(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire887a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire887a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("5sB0y", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hYZB9")).then(()=>parcelRequire("ajgRO"));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case "preload":
            return $1c132cac09cd18d9$var$cachedPreloads;
        case "prefetch":
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("fzv2W", function(module, exports) {
$parcel$export(module.exports, "convertEvmBlockchainMetaToEvmChainInfo", function () { return (parcelRequire("7aYgM")).convertEvmBlockchainMetaToEvmChainInfo; });
$parcel$export(module.exports, "detectInstallLink", function () { return (parcelRequire("7aYgM")).detectInstallLink; });
$parcel$export(module.exports, "detectMobileScreens", function () { return (parcelRequire("7aYgM")).detectMobileScreens; });
$parcel$export(module.exports, "getSolanaAccounts", function () { return (parcelRequire("7aYgM")).getSolanaAccounts; });
$parcel$export(module.exports, "isEvmAddress", function () { return (parcelRequire("B8faE")).isAddress; });
$parcel$export(module.exports, "splitWalletNetwork", function () { return (parcelRequire("7aYgM")).splitWalletNetwork; });
$parcel$export(module.exports, "timeout", function () { return (parcelRequire("7aYgM")).timeout; });
$parcel$export(module.exports, "canEagerlyConnectToEvm", function () { return (parcelRequire("bHRZL")).canEagerlyConnectToEvm; });
$parcel$export(module.exports, "canSwitchNetworkToEvm", function () { return (parcelRequire("bHRZL")).canSwitchNetworkToEvm; });
$parcel$export(module.exports, "chooseInstance", function () { return (parcelRequire("bHRZL")).chooseInstance; });
$parcel$export(module.exports, "getEvmAccounts", function () { return (parcelRequire("bHRZL")).getEvmAccounts; });
$parcel$export(module.exports, "getEvmProvider", function () { return (parcelRequire("bHRZL")).getEvmProvider; });
$parcel$export(module.exports, "getNetworkInstance", function () { return (parcelRequire("bHRZL")).getNetworkInstance; });
$parcel$export(module.exports, "subscribeToEvm", function () { return (parcelRequire("bHRZL")).subscribeToEvm; });
$parcel$export(module.exports, "switchNetworkForEvm", function () { return (parcelRequire("bHRZL")).switchNetworkForEvm; });
$parcel$export(module.exports, "DEFAULT_COSMOS_RPC_URL", function () { return (parcelRequire("yEwlv")).DEFAULT_COSMOS_RPC_URL; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_RPC_URL", function () { return (parcelRequire("yEwlv")).DEFAULT_ETHEREUM_RPC_URL; });
$parcel$export(module.exports, "ETHEREUM_CHAIN_ID", function () { return (parcelRequire("yEwlv")).ETHEREUM_CHAIN_ID; });
$parcel$export(module.exports, "getBlockChainNameFromId", function () { return (parcelRequire("8aS14")).legacyGetBlockChainNameFromId; });
$parcel$export(module.exports, "KEPLR_COMPATIBLE_WALLETS", function () { return (parcelRequire("yEwlv")).KEPLR_COMPATIBLE_WALLETS; });
$parcel$export(module.exports, "Namespace", function () { return (parcelRequire("8aS14")).LegacyNamespace; });
$parcel$export(module.exports, "namespaces", function () { return (parcelRequire("yEwlv")).namespaces; });
$parcel$export(module.exports, "Networks", function () { return (parcelRequire("8aS14")).LegacyNetworks; });
$parcel$export(module.exports, "uint8ArrayToHex", function () { return (parcelRequire("yEwlv")).uint8ArrayToHex; });
$parcel$export(module.exports, "WalletTypes", function () { return (parcelRequire("yEwlv")).WalletTypes; });
$parcel$export(module.exports, "XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS", function () { return (parcelRequire("yEwlv")).XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS; });
$parcel$export(module.exports, "getCosmosAccounts", function () { return (parcelRequire("jN5Ze")).getCosmosAccounts; });
$parcel$export(module.exports, "getCosmosExperimentalChainInfo", function () { return (parcelRequire("jN5Ze")).getCosmosExperimentalChainInfo; });
$parcel$export(module.exports, "suggestCosmosChain", function () { return (parcelRequire("jN5Ze")).suggestCosmosChain; });
parcelRequire("7aYgM");
parcelRequire("bHRZL");
parcelRequire("yEwlv");
parcelRequire("jN5Ze");

});
parcelRegister("7aYgM", function(module, exports) {

$parcel$export(module.exports, "deepCopy", function () { return $b62086b61f20b9f1$export$6c40052bed430212; });
$parcel$export(module.exports, "switchOrAddNetworkForMetamaskCompatibleWallets", function () { return $b62086b61f20b9f1$export$56ce9af15430dcbb; });
$parcel$export(module.exports, "timeout", function () { return $b62086b61f20b9f1$export$83e74882c5df8fe1; });
$parcel$export(module.exports, "convertEvmBlockchainMetaToEvmChainInfo", function () { return $b62086b61f20b9f1$export$f0e13d51b5c692b6; });
$parcel$export(module.exports, "getSolanaAccounts", function () { return $b62086b61f20b9f1$export$a009f0f0c363aa6c; });
$parcel$export(module.exports, "detectInstallLink", function () { return $b62086b61f20b9f1$export$fd0008baca2bf83d; });
$parcel$export(module.exports, "detectMobileScreens", function () { return $b62086b61f20b9f1$export$486f06d416851c61; });
$parcel$export(module.exports, "splitWalletNetwork", function () { return $b62086b61f20b9f1$export$7925cdcd51d3102; });
$parcel$export(module.exports, "isEvmAddress", function () { return (parcelRequire("B8faE")).isAddress; });
parcelRequire("yEwlv");
var $8aS14 = parcelRequire("8aS14");

var $B8faE = parcelRequire("B8faE");
function $b62086b61f20b9f1$export$6c40052bed430212(obj) {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for(let i = 0, len = obj.length; i < len; i++)copy[i] = $b62086b61f20b9f1$export$6c40052bed430212(obj[i]);
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for(const attr in obj)if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = $b62086b61f20b9f1$export$6c40052bed430212(obj[attr]);
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
async function $b62086b61f20b9f1$export$56ce9af15430dcbb(instance, network, evmNetworksChainInfo) {
    const targetChain = evmNetworksChainInfo[network];
    try {
        await instance.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: targetChain?.chainId
                }
            ]
        });
    } catch (switchError) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /*
     * @ts-ignore
     * To resolve this error: Catch clause variable type annotation must be any or unknown if specified
     */ const error = switchError;
        if (!targetChain) throw new Error(`It seems you don't have ${network} network on your wallet. Please add it manually.`);
        else if (error.code === 4902 || !error.code) /*
       * Note: on WalletConnect `code` is undefined so we have to use !switchError.code as fallback.
       * This error code indicates that the chain has not been added to wallet.
       */ await instance.request({
            method: "wallet_addEthereumChain",
            params: [
                targetChain
            ]
        });
        throw switchError;
    }
}
async function $b62086b61f20b9f1$export$83e74882c5df8fe1(forPromise, time) {
    const timeoutPromise = new Promise((_, reject)=>{
        setTimeout(()=>{
            reject("Timeout!");
        }, time);
    });
    return Promise.race([
        forPromise,
        timeoutPromise
    ]);
}
const $b62086b61f20b9f1$export$f0e13d51b5c692b6 = (evmBlockchains)=>evmBlockchains.reduce((evmNetWorksChainInfo, blockchainMeta)=>(evmNetWorksChainInfo[blockchainMeta.name] = {
            chainName: blockchainMeta.info.chainName,
            chainId: blockchainMeta.chainId,
            nativeCurrency: blockchainMeta.info.nativeCurrency,
            rpcUrls: blockchainMeta.info.rpcUrls,
            blockExplorerUrls: blockchainMeta.info.blockExplorerUrls
        }, evmNetWorksChainInfo), {});
const $b62086b61f20b9f1$export$6965bcf5cb20b5b5 = (evmNetworkChainInfo)=>{
    return Object.fromEntries(new Map(Object.keys(evmNetworkChainInfo).map((chainName)=>{
        const info = evmNetworkChainInfo[chainName];
        /*
         * This `if` is only used for satisfying typescript,
         * Because we iterating over Object.keys(EVM_NETWORKS_CHAIN_INFO)
         * And obviously it cannot be `undefined` and always has a value.
         */ if (info) return [
            parseInt(info.chainId),
            info.rpcUrls[0]
        ];
        return [
            0,
            ""
        ];
    })));
};
const $b62086b61f20b9f1$export$a009f0f0c363aa6c = async ({ instance: instance })=>{
    // Asking for account from wallet.
    const solanaResponse = await instance.connect();
    const account = solanaResponse.publicKey.toString();
    return {
        accounts: [
            account
        ],
        chainId: (0, $8aS14.LegacyNetworks).SOLANA
    };
};
function $b62086b61f20b9f1$export$83c5a315dd1cff42(wallets) {
    return wallets.sort((a, b)=>Number(b.connected) - Number(a.connected) || Number(b.extensionAvailable) - Number(a.extensionAvailable));
}
function $b62086b61f20b9f1$var$isBrave() {
    let isBrave = false;
    const nav = navigator;
    if (nav.brave && nav.brave.isBrave) nav.brave.isBrave().then((res)=>{
        if (res) isBrave = true;
    });
    return isBrave;
}
function $b62086b61f20b9f1$export$fd0008baca2bf83d(install) {
    if (typeof install !== "object") return install;
    let link;
    if ($b62086b61f20b9f1$var$isBrave()) link = install.BRAVE;
    else if (navigator.userAgent?.toLowerCase().indexOf("chrome") !== -1) link = install.CHROME;
    else if (navigator.userAgent?.toLowerCase().indexOf("firefox") !== -1) link = install.FIREFOX;
    else if (navigator.userAgent?.toLowerCase().indexOf("edge") !== -1) link = install.EDGE;
    return link || install.DEFAULT;
}
function $b62086b61f20b9f1$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function $b62086b61f20b9f1$export$7925cdcd51d3102(input) {
    const removedAddressInput = input?.split(":")[0] || "";
    const splittedInput = removedAddressInput.split("-");
    const network = splittedInput[splittedInput.length - 1];
    const walletNetwork = splittedInput.slice(0, -1);
    if (walletNetwork[walletNetwork.length - 1] === network) walletNetwork.pop();
    const wallet = walletNetwork.join("-");
    return [
        wallet,
        network
    ];
}

});
parcelRegister("yEwlv", function(module, exports) {

$parcel$export(module.exports, "uint8ArrayToHex", function () { return $81512b094f3904fa$export$c44b02fb03dbac82; });
$parcel$export(module.exports, "WalletTypes", function () { return $81512b094f3904fa$export$b80cfa133c9c182d; });
$parcel$export(module.exports, "namespaces", function () { return $81512b094f3904fa$export$41fc20bb625e8618; });
$parcel$export(module.exports, "XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS", function () { return $81512b094f3904fa$export$7289d9aba3deaf99; });
$parcel$export(module.exports, "KEPLR_COMPATIBLE_WALLETS", function () { return $81512b094f3904fa$export$12e8aeb69ff35d9; });
$parcel$export(module.exports, "DEFAULT_COSMOS_RPC_URL", function () { return $81512b094f3904fa$export$832fb1b437e459ec; });
$parcel$export(module.exports, "ETHEREUM_CHAIN_ID", function () { return $81512b094f3904fa$export$814907fc0b5ea6f0; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_RPC_URL", function () { return $81512b094f3904fa$export$4ee19c176513503a; });
$parcel$export(module.exports, "Networks", function () { return (parcelRequire("8aS14")).LegacyNetworks; });
$parcel$export(module.exports, "Namespace", function () { return (parcelRequire("8aS14")).LegacyNamespace; });
$parcel$export(module.exports, "getBlockChainNameFromId", function () { return (parcelRequire("8aS14")).legacyGetBlockChainNameFromId; });

var $8aS14 = parcelRequire("8aS14");

var $3aNd6 = parcelRequire("3aNd6");
var $81512b094f3904fa$require$Buffer = $3aNd6.Buffer;
const $81512b094f3904fa$export$3fce19fdf0c5de73 = false;
const $81512b094f3904fa$export$c44b02fb03dbac82 = (buffer)=>{
    return $81512b094f3904fa$require$Buffer.from(buffer).toString("hex");
};
var $81512b094f3904fa$export$b80cfa133c9c182d;
(function(WalletTypes) {
    WalletTypes["DEFAULT"] = "default";
    WalletTypes["META_MASK"] = "metamask";
    WalletTypes["WALLET_CONNECT_2"] = "wallet-connect-2";
    WalletTypes["TRUST_WALLET"] = "trust-wallet";
    WalletTypes["KEPLR"] = "keplr";
    WalletTypes["PHANTOM"] = "phantom";
    WalletTypes["BITGET"] = "bitget";
    WalletTypes["TRON_LINK"] = "tron-link";
    WalletTypes["COINBASE"] = "coinbase";
    WalletTypes["XDEFI"] = "xdefi";
    WalletTypes["CLOVER"] = "clover";
    WalletTypes["ARGENTX"] = "argentx";
    WalletTypes["FRONTIER"] = "frontier";
    WalletTypes["COSMOSTATION"] = "cosmostation";
    WalletTypes["COIN98"] = "coin98";
    WalletTypes["SAFEPAL"] = "safepal";
    WalletTypes["SAFE"] = "safe";
    WalletTypes["TOKEN_POCKET"] = "token-pocket";
    WalletTypes["BRAVE"] = "brave";
    WalletTypes["BRAAVOS"] = "braavos";
    WalletTypes["MATH"] = "math";
    WalletTypes["EXODUS"] = "exodus";
    WalletTypes["OKX"] = "okx";
    WalletTypes["HALO"] = "halo";
    WalletTypes["LEAP"] = "leap";
    WalletTypes["LEAP_COSMOS"] = "leap-cosmos";
    WalletTypes["STATION"] = "station";
    WalletTypes["ENKRYPT"] = "enkrypt";
    WalletTypes["TAHO"] = "taho";
    WalletTypes["MY_TON_WALLET"] = "mytonwallet";
    WalletTypes["SOLFLARE_SNAP"] = "solflare-snap";
    WalletTypes["LEDGER"] = "ledger";
    WalletTypes["Rabby"] = "rabby";
    WalletTypes["TOMO"] = "tomo";
    WalletTypes["TREZOR"] = "trezor";
    WalletTypes["SOLFLARE"] = "solflare";
})($81512b094f3904fa$export$b80cfa133c9c182d || ($81512b094f3904fa$export$b80cfa133c9c182d = {}));
const $81512b094f3904fa$export$41fc20bb625e8618 = {
    [(0, $8aS14.LegacyNamespace).Evm]: {
        mainBlockchain: "ETH",
        title: "Ethereum",
        derivationPaths: [
            {
                id: "metamask",
                label: `Metamask (m/44'/60'/0'/0/index)`,
                generateDerivationPath: (index)=>`44'/60'/0'/0/${index}`
            },
            {
                id: "ledgerLive",
                label: `LedgerLive (m/44'/60'/index'/0/0)`,
                generateDerivationPath: (index)=>`44'/60'/${index}'/0/0`
            },
            {
                id: "legacy",
                label: `Legacy (m/44'/60'/0'/index)`,
                generateDerivationPath: (index)=>`44'/60'/0'/${index}`
            }
        ]
    },
    [(0, $8aS14.LegacyNamespace).Solana]: {
        mainBlockchain: "SOLANA",
        title: "Solana",
        derivationPaths: [
            {
                id: `(m/44'/501'/index')`,
                label: `(m/44'/501'/index')`,
                generateDerivationPath: (index)=>`44'/501'/${index}'`
            },
            {
                id: `(m/44'/501'/0'/index)`,
                label: `(m/44'/501'/0'/index)`,
                generateDerivationPath: (index)=>`44'/501'/0'/${index}`
            }
        ]
    },
    [(0, $8aS14.LegacyNamespace).Cosmos]: {
        mainBlockchain: "COSMOS",
        title: "Cosmos"
    },
    [(0, $8aS14.LegacyNamespace).Utxo]: {
        mainBlockchain: "BTC",
        title: "Utxo"
    },
    [(0, $8aS14.LegacyNamespace).Starknet]: {
        title: "Starknet",
        mainBlockchain: "STARKNET"
    },
    [(0, $8aS14.LegacyNamespace).Tron]: {
        title: "Tron",
        mainBlockchain: "TRON"
    }
};
const $81512b094f3904fa$export$7289d9aba3deaf99 = [
    (0, $8aS14.LegacyNetworks).BTC,
    (0, $8aS14.LegacyNetworks).LTC,
    (0, $8aS14.LegacyNetworks).THORCHAIN,
    (0, $8aS14.LegacyNetworks).BCH,
    (0, $8aS14.LegacyNetworks).MAYA,
    (0, $8aS14.LegacyNetworks).DOGE
];
const $81512b094f3904fa$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos",
    "xdefi"
];
const $81512b094f3904fa$export$832fb1b437e459ec = "https://cosmos-rpc.polkachu.com";
const $81512b094f3904fa$export$814907fc0b5ea6f0 = "0x1";
const $81512b094f3904fa$export$4ee19c176513503a = "https://rpc.ankr.com/eth";

});
parcelRegister("8aS14", function(module, exports) {

$parcel$export(module.exports, "LegacyNetworks", function () { return $5f3928697c9bcc7d$export$81ee6de5033cd1db; });
$parcel$export(module.exports, "LegacyNamespace", function () { return $5f3928697c9bcc7d$export$259ca55fffa8e15; });
$parcel$export(module.exports, "Persistor", function () { return $5f3928697c9bcc7d$export$e01a546649d7a495; });
$parcel$export(module.exports, "legacyReadAccountAddress", function () { return $5f3928697c9bcc7d$export$a03d8c9a97cb17f0; });
$parcel$export(module.exports, "legacyGetBlockChainNameFromId", function () { return $5f3928697c9bcc7d$export$2f76b7ab62da017c; });
$parcel$export(module.exports, "LegacyWallet", function () { return $5f3928697c9bcc7d$export$aff9e20972034897; });
var $5f3928697c9bcc7d$var$w = Object.defineProperty;
var $5f3928697c9bcc7d$var$r = (a, t)=>$5f3928697c9bcc7d$var$w(a, "name", {
        value: t,
        configurable: !0
    });
var $5f3928697c9bcc7d$export$81ee6de5033cd1db = ((e)=>(e.BTC = "BTC", e.BSC = "BSC", e.LTC = "LTC", e.THORCHAIN = "THOR", e.BCH = "BCH", e.BINANCE = "BNB", e.ETHEREUM = "ETH", e.POLYGON = "POLYGON", e.TERRA = "TERRA", e.POLKADOT = "", e.TRON = "TRON", e.DOGE = "DOGE", e.HARMONY = "HARMONY", e.AVAX_CCHAIN = "AVAX_CCHAIN", e.FANTOM = "FANTOM", e.MOONBEAM = "MOONBEAM", e.ARBITRUM = "ARBITRUM", e.BOBA = "BOBA", e.OPTIMISM = "OPTIMISM", e.FUSE = "FUSE", e.CRONOS = "CRONOS", e.SOLANA = "SOLANA", e.MOONRIVER = "MOONRIVER", e.GNOSIS = "GNOSIS", e.COSMOS = "COSMOS", e.OSMOSIS = "OSMOSIS", e.AXELAR = "AXELAR", e.MARS = "MARS", e.STRIDE = "STRIDE", e.MAYA = "MAYA", e.AKASH = "AKASH", e.IRIS = "IRIS", e.PERSISTENCE = "PERSISTENCE", e.SENTINEL = "SENTINEL", e.REGEN = "REGEN", e.CRYPTO_ORG = "CRYPTO_ORG", e.SIF = "SIF", e.CHIHUAHUA = "CHIHUAHUA", e.JUNO = "JUNO", e.KUJIRA = "KUJIRA", e.STARNAME = "STARNAME", e.COMDEX = "COMDEX", e.STARGAZE = "STARGAZE", e.DESMOS = "DESMOS", e.BITCANNA = "BITCANNA", e.SECRET = "SECRET", e.INJECTIVE = "INJECTIVE", e.LUMNETWORK = "LUMNETWORK", e.BANDCHAIN = "BANDCHAIN", e.EMONEY = "EMONEY", e.BITSONG = "BITSONG", e.KI = "KI", e.MEDIBLOC = "MEDIBLOC", e.KONSTELLATION = "KONSTELLATION", e.UMEE = "UMEE", e.STARKNET = "STARKNET", e.TON = "TON", e.Unknown = "Unkown", e))($5f3928697c9bcc7d$export$81ee6de5033cd1db || {}), $5f3928697c9bcc7d$export$259ca55fffa8e15 = ((i)=>(i.Solana = "Solana", i.Evm = "EVM", i.Cosmos = "Cosmos", i.Utxo = "UTXO", i.Starknet = "Starknet", i.Tron = "Tron", i))($5f3928697c9bcc7d$export$259ca55fffa8e15 || {}), $5f3928697c9bcc7d$export$183808fb4a9082e9 = ((i)=>(i.CONNECTED = "connected", i.CONNECTING = "connecting", i.REACHABLE = "reachable", i.INSTALLED = "installed", i.ACCOUNTS = "accounts", i.NETWORK = "network", i))($5f3928697c9bcc7d$export$183808fb4a9082e9 || {});
var $5f3928697c9bcc7d$export$e01a546649d7a495 = class {
    static #_ = $5f3928697c9bcc7d$var$r(this, "Persistor");
    getItem(t) {
        let n = localStorage.getItem(t);
        return n ? JSON.parse(n) : null;
    }
    setItem(t, n) {
        localStorage.setItem(t, JSON.stringify(n));
    }
    removeItem(t) {
        localStorage.removeItem(t);
    }
};
function $5f3928697c9bcc7d$var$N(a, t) {
    return `${t || ""}:${a}`;
}
$5f3928697c9bcc7d$var$r($5f3928697c9bcc7d$var$N, "formatAddressWithNetwork");
function $5f3928697c9bcc7d$var$I(a, t) {
    return a ? a.map((n)=>$5f3928697c9bcc7d$var$N(n, t)) : [];
}
$5f3928697c9bcc7d$var$r($5f3928697c9bcc7d$var$I, "accountAddressesWithNetwork");
function $5f3928697c9bcc7d$export$a03d8c9a97cb17f0(a) {
    let [t, n] = a.split(":");
    return {
        network: t,
        address: n
    };
}
$5f3928697c9bcc7d$var$r($5f3928697c9bcc7d$export$a03d8c9a97cb17f0, "readAccountAddress");
function $5f3928697c9bcc7d$var$S(a) {
    let { checkInstallation: t = !0 } = a.config;
    return t;
}
$5f3928697c9bcc7d$var$r($5f3928697c9bcc7d$var$S, "needsCheckInstallation");
var $5f3928697c9bcc7d$export$2f76b7ab62da017c = $5f3928697c9bcc7d$var$r((a, t)=>(a = typeof a == "string" && a.startsWith("0x") ? parseInt(a) : a, Object.values($5f3928697c9bcc7d$export$81ee6de5033cd1db).includes(String(a)) ? a : a === "Binance-Chain-Tigris" ? "BNB" : t.filter((o)=>!!o.chainId).find((o)=>(o.chainId?.startsWith("0x") ? parseInt(o.chainId) : o.chainId) == a)?.name || null), "getBlockChainNameFromId");
var $5f3928697c9bcc7d$var$m = class {
    static #_ = $5f3928697c9bcc7d$var$r(this, "Wallet");
    provider;
    actions;
    state;
    options;
    info;
    cleanupSubscribe;
    constructor(t, n){
        this.actions = n, this.options = t, this.provider = null, this.info = {
            supportedBlockchains: [],
            isContractWallet: !1
        }, this.state = {
            connected: !1,
            connecting: !1,
            reachable: !1,
            installed: !1,
            accounts: null,
            network: null
        }, $5f3928697c9bcc7d$var$S(t) || this.setInstalledAs(!0);
    }
    async suggestAndConnect(t) {
        return this.actions.suggest && await this.actions.suggest({
            instance: this.provider,
            meta: this.info.supportedBlockchains,
            network: t
        }), await this.connect(t);
    }
    async connect(t, n) {
        if (this.state.connecting) throw new Error("Connecting...");
        let o = await this.getConnectionFromState(), s = this.state.network, c = t || s || this.options.config.defaultNetwork;
        if (o) {
            let l = s !== c && !!c;
            if (s === c) return o;
            let p = !0;
            if (this.actions.canSwitchNetworkTo && (p = this.actions.canSwitchNetworkTo({
                provider: this.provider,
                meta: this.info.supportedBlockchains,
                network: c || ""
            })), l && p && this.actions.switchNetwork) return await this.actions.switchNetwork({
                instance: this.provider,
                meta: this.info.supportedBlockchains,
                network: c,
                newInstance: this.tryGetInstance.bind(this),
                getState: this.getState.bind(this),
                updateChainId: this.updateChainId.bind(this)
            }), c !== this.state.network && !this.options.config.isAsyncSwitchNetwork && this.updateState({
                network: t
            }), {
                accounts: o.accounts,
                network: c,
                provider: this.provider
            };
        }
        let i = await this.tryGetInstance({
            network: t
        });
        this.updateState({
            connecting: !0
        }), this.setInstalledAs(!0);
        try {
            var u = await this.actions.connect({
                instance: i,
                network: c || void 0,
                meta: this.info.supportedBlockchains || [],
                namespaces: n
            });
        } catch (l) {
            throw this.resetState(), l;
        }
        this.updateState({
            connected: !0,
            reachable: !0,
            connecting: !1
        });
        let f = [], y = null;
        if (Array.isArray(u)) {
            let l = null;
            f = u.flatMap((A)=>{
                let k = A.chainId || "Unkown", g = $5f3928697c9bcc7d$export$2f76b7ab62da017c(k, this.info.supportedBlockchains) || "Unkown";
                return !l && g !== "Unkown" && this.info.supportedBlockchains.find((T)=>T.name === g)?.info?.infoType === "EvmMetaInfo" && (l = g), $5f3928697c9bcc7d$var$I(A.accounts, g);
            }).filter(Boolean), y = l || c || this.options.config.defaultNetwork;
        } else {
            let l = u.chainId || "Unkown", p = $5f3928697c9bcc7d$export$2f76b7ab62da017c(l, this.info.supportedBlockchains) || "Unkown";
            f = $5f3928697c9bcc7d$var$I(u.accounts, p), y = p;
        }
        return f.length > 0 && this.updateState({
            accounts: f,
            network: y
        }), {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        };
    }
    async disconnect() {
        this.resetState(), this.actions.disconnect && this.actions.disconnect({
            instance: this.provider,
            destroyInstance: ()=>{
                this.setProvider(null);
            }
        });
    }
    async eagerConnect() {
        let t = await this.tryGetInstance({
            network: void 0
        }), { canEagerConnect: n } = this.actions, o = `can't restore connection for ${this.options.config.type} .`;
        if (n) {
            if (await n({
                instance: t,
                meta: this.info.supportedBlockchains
            })) return this.connect();
            throw new Error(o);
        } else throw new Error(o);
    }
    async getSigners(t) {
        return await this.actions.getSigners(t);
    }
    getWalletInfo(t) {
        return this.actions.getWalletInfo(t);
    }
    canSwitchNetworkTo(t, n) {
        let o = this.actions.canSwitchNetworkTo;
        return o ? o({
            network: t,
            meta: this.info.supportedBlockchains,
            provider: n
        }) : !1;
    }
    onInit() {
        this.options.config.isAsyncInstance ? $5f3928697c9bcc7d$var$S(this.options) && this.actions.getInstance().then((t)=>{
            t && this.setInstalledAs(!0);
        }) : this.actions.getInstance() && !this.state.installed && this.setInstalledAs(!0);
    }
    setProvider(t) {
        if (this.provider = t, t && this.actions.subscribe) {
            let n = this.actions.subscribe({
                instance: t,
                state: this.state,
                meta: this.info.supportedBlockchains,
                connect: this.connect.bind(this),
                disconnect: this.disconnect.bind(this),
                updateAccounts: (o, s)=>{
                    let c = this.state.network;
                    s && (c = $5f3928697c9bcc7d$export$2f76b7ab62da017c(s, this.info.supportedBlockchains) || "Unkown");
                    let i = $5f3928697c9bcc7d$var$I(o, c);
                    i.length > 0 && this.updateState({
                        accounts: i
                    });
                },
                updateChainId: this.updateChainId.bind(this)
            });
            this.cleanupSubscribe = n;
        } else !t && this.cleanupSubscribe && this.cleanupSubscribe();
    }
    setInfo(t) {
        typeof t.supportedBlockchains < "u" && (this.info.supportedBlockchains = t.supportedBlockchains), typeof t.isContractWallet < "u" && (this.info.isContractWallet = t.isContractWallet);
    }
    setHandler(t) {
        this.options.handler = t;
    }
    getState() {
        return this.state;
    }
    updateState(t) {
        let n = [];
        typeof t.connected < "u" && (this.state.connected = t.connected, n.push([
            "connected",
            t.connected
        ])), typeof t.connecting < "u" && (this.state.connecting = t.connecting, n.push([
            "connecting",
            t.connecting
        ])), typeof t.reachable < "u" && (this.state.reachable = t.reachable, n.push([
            "reachable",
            t.reachable
        ])), typeof t.installed < "u" && (this.state.installed = t.installed, n.push([
            "installed",
            t.installed
        ])), typeof t.accounts < "u" && (this.state.accounts = t.accounts, n.push([
            "accounts",
            t.accounts
        ])), typeof t.network < "u" && (this.state.network = t.network, n.push([
            "network",
            t.network
        ]));
        let o = this.getState();
        n.forEach(([s, c])=>{
            let i = {
                supportedBlockchains: this.info.supportedBlockchains,
                isContractWallet: this.info.isContractWallet
            };
            this.options.handler(this.options.config.type, s, c, o, i);
        });
    }
    resetState() {
        this.updateState({
            connected: !1,
            connecting: !1,
            reachable: !1,
            accounts: null,
            network: null
        });
    }
    async getConnectionFromState() {
        return this.state.connected && this.provider ? {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        } : null;
    }
    updateChainId(t) {
        let n = t ? $5f3928697c9bcc7d$export$2f76b7ab62da017c(t, this.info.supportedBlockchains) : "Unkown";
        this.updateState({
            network: n
        });
    }
    setInstalledAs(t) {
        !$5f3928697c9bcc7d$var$S(this.options) && t === !1 || this.updateState({
            installed: t
        });
    }
    async tryGetInstance({ network: t, force: n }) {
        let o = null;
        if (this.setProvider(null), this.options.config.isAsyncInstance) {
            let s = {
                currentProvider: this.provider,
                meta: this.info.supportedBlockchains,
                force: n || !1,
                updateChainId: this.updateChainId.bind(this),
                getState: this.getState.bind(this)
            };
            t && (s.network = t), o = await this.actions.getInstance(s);
        } else o = this.actions.getInstance();
        if (!o) {
            this.setInstalledAs(!1), this.resetState();
            let s = `It seems your selected wallet (${this.options.config.type}) isn't installed.`;
            throw new Error(s);
        }
        return this.setProvider(o), o;
    }
}, $5f3928697c9bcc7d$export$aff9e20972034897 = $5f3928697c9bcc7d$var$m;

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a; }, function (v) { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $24f87a6f86a8996f$export$599f31c3813fae4d; }, function (v) { return $24f87a6f86a8996f$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
var $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
var $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    var buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        var len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        var buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $24f87a6f86a8996f$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $3caef5c332c7293f$export$a48f0734ac7c2329; }, function (v) { return $3caef5c332c7293f$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("B8faE", function(module, exports) {

$parcel$export(module.exports, "isAddressable", function () { return $06f9d9d760226a67$export$6a88e03bca5eb759; });
$parcel$export(module.exports, "isAddress", function () { return $06f9d9d760226a67$export$977e255126d763d6; });
$parcel$export(module.exports, "resolveAddress", function () { return $06f9d9d760226a67$export$687eed6b344123c9; });

var $g6m4b = parcelRequire("g6m4b");

var $1MMj0 = parcelRequire("1MMj0");
function $06f9d9d760226a67$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $06f9d9d760226a67$export$977e255126d763d6(value) {
    try {
        (0, $1MMj0.getAddress)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $06f9d9d760226a67$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $g6m4b.assert)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $g6m4b.assertArgument)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $1MMj0.getAddress)(result);
}
function $06f9d9d760226a67$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $1MMj0.getAddress)(target);
        (0, $g6m4b.assert)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $06f9d9d760226a67$var$checkAddress(target, resolver.resolveName(target));
    } else if ($06f9d9d760226a67$export$6a88e03bca5eb759(target)) return $06f9d9d760226a67$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $06f9d9d760226a67$var$checkAddress(target, target);
    (0, $g6m4b.assertArgument)(false, "unsupported addressable value", "target", target);
}

});
parcelRegister("g6m4b", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $bb8e52d338877b37$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isCallException", function () { return $bb8e52d338877b37$export$748c4fa78f31ff35; });
$parcel$export(module.exports, "makeError", function () { return $bb8e52d338877b37$export$5a4bb2b1c89bdce7; });
$parcel$export(module.exports, "assert", function () { return $bb8e52d338877b37$export$a7a9523472993e97; });
$parcel$export(module.exports, "assertArgument", function () { return $bb8e52d338877b37$export$c3d31707e5030f5e; });
$parcel$export(module.exports, "assertArgumentCount", function () { return $bb8e52d338877b37$export$d228410a8a77e4fa; });
$parcel$export(module.exports, "assertNormalize", function () { return $bb8e52d338877b37$export$d993e67fefdfecda; });
$parcel$export(module.exports, "assertPrivate", function () { return $bb8e52d338877b37$export$ac1a938d48ec8c7b; });
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ 
var $hSKFx = parcelRequire("hSKFx");

var $lH7cM = parcelRequire("lH7cM");
function $bb8e52d338877b37$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($bb8e52d338877b37$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $bb8e52d338877b37$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$bb8e52d338877b37$var$stringify(k)}: ${$bb8e52d338877b37$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $bb8e52d338877b37$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $bb8e52d338877b37$export$748c4fa78f31ff35(error) {
    return $bb8e52d338877b37$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $bb8e52d338877b37$export$5a4bb2b1c89bdce7(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$bb8e52d338877b37$var$stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + $bb8e52d338877b37$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $hSKFx.version)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $lH7cM.defineProperties)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, $lH7cM.defineProperties)(error, {
        shortMessage: shortMessage
    });
    return error;
}
function $bb8e52d338877b37$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $bb8e52d338877b37$export$5a4bb2b1c89bdce7(message, code, info);
}
function $bb8e52d338877b37$export$c3d31707e5030f5e(check, message, name, value) {
    $bb8e52d338877b37$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $bb8e52d338877b37$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $bb8e52d338877b37$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $bb8e52d338877b37$export$a7a9523472993e97(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $bb8e52d338877b37$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $bb8e52d338877b37$export$d993e67fefdfecda(form) {
    $bb8e52d338877b37$export$a7a9523472993e97($bb8e52d338877b37$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $bb8e52d338877b37$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $bb8e52d338877b37$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}

});
parcelRegister("hSKFx", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d04bae4fc4e24d48$export$83d89fbfd8236492; });
/* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $d04bae4fc4e24d48$export$83d89fbfd8236492 = "6.13.2";

});

parcelRegister("lH7cM", function(module, exports) {

$parcel$export(module.exports, "resolveProperties", function () { return $fcb333efda27d9d7$export$d503dd157d963b60; });
$parcel$export(module.exports, "defineProperties", function () { return $fcb333efda27d9d7$export$b61bda4fbca264f2; });
/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $fcb333efda27d9d7$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $fcb333efda27d9d7$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $fcb333efda27d9d7$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $fcb333efda27d9d7$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}

});


parcelRegister("1MMj0", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $14cfbe985a29575c$export$88411125f012957a; });
parcelRequire("iiTEi");
var $kdR5O = parcelRequire("kdR5O");

var $g6m4b = parcelRequire("g6m4b");
var $8Cy13 = parcelRequire("8Cy13");
const $14cfbe985a29575c$var$BN_0 = BigInt(0);
const $14cfbe985a29575c$var$BN_36 = BigInt(36);
function $14cfbe985a29575c$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $8Cy13.getBytes)((0, $kdR5O.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $14cfbe985a29575c$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$14cfbe985a29575c$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$14cfbe985a29575c$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $14cfbe985a29575c$var$safeDigits = 15;
function $14cfbe985a29575c$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $14cfbe985a29575c$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $14cfbe985a29575c$var$safeDigits){
        let block = expanded.substring(0, $14cfbe985a29575c$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $14cfbe985a29575c$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $14cfbe985a29575c$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $14cfbe985a29575c$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $14cfbe985a29575c$var$BN_36 + $14cfbe985a29575c$var$Base36[value[i]];
    return result;
}
function $14cfbe985a29575c$export$88411125f012957a(address) {
    (0, $g6m4b.assertArgument)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $14cfbe985a29575c$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $g6m4b.assertArgument)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $g6m4b.assertArgument)(address.substring(2, 4) === $14cfbe985a29575c$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $14cfbe985a29575c$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $14cfbe985a29575c$var$getChecksumAddress("0x" + result);
    }
    (0, $g6m4b.assertArgument)(false, "invalid address", "address", address);
}
function $14cfbe985a29575c$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($14cfbe985a29575c$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $14cfbe985a29575c$var$ibanChecksum("XE00" + base36) + base36;
}

});
parcelRegister("iiTEi", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("kdR5O")).keccak256; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("i7EHi")).sha256; });
/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ 
var $jAnOe = parcelRequire("jAnOe");

var $kdR5O = parcelRequire("kdR5O");

var $h5f4O = parcelRequire("h5f4O");

var $f9KYV = parcelRequire("f9KYV");

var $jrQTq = parcelRequire("jrQTq");

var $hSwrm = parcelRequire("hSwrm");

var $i7EHi = parcelRequire("i7EHi");

var $a8s1f = parcelRequire("a8s1f");

var $fWvq9 = parcelRequire("fWvq9");
/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $d5351326e726e227$export$6a9f04c98a658ecb() {
    (0, $jAnOe.computeHmac).lock();
    (0, $kdR5O.keccak256).lock();
    (0, $f9KYV.pbkdf2).lock();
    (0, $jrQTq.randomBytes).lock();
    (0, $h5f4O.ripemd160).lock();
    (0, $hSwrm.scrypt).lock();
    (0, $hSwrm.scryptSync).lock();
    (0, $i7EHi.sha256).lock();
    (0, $i7EHi.sha512).lock();
    (0, $jrQTq.randomBytes).lock();
}

});
parcelRegister("jAnOe", function(module, exports) {

$parcel$export(module.exports, "computeHmac", function () { return $e423d9237c6b8e93$export$967075d2f3b8e7ff; });
/**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ 
var $8L1lW = parcelRequire("8L1lW");

var $8Cy13 = parcelRequire("8Cy13");
let $e423d9237c6b8e93$var$locked = false;
const $e423d9237c6b8e93$var$_computeHmac = function(algorithm, key, data) {
    return (0, $8L1lW.createHmac)(algorithm, key).update(data).digest();
};
let $e423d9237c6b8e93$var$__computeHmac = $e423d9237c6b8e93$var$_computeHmac;
function $e423d9237c6b8e93$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $8Cy13.getBytes)(_key, "key");
    const data = (0, $8Cy13.getBytes)(_data, "data");
    return (0, $8Cy13.hexlify)($e423d9237c6b8e93$var$__computeHmac(algorithm, key, data));
}
$e423d9237c6b8e93$export$967075d2f3b8e7ff._ = $e423d9237c6b8e93$var$_computeHmac;
$e423d9237c6b8e93$export$967075d2f3b8e7ff.lock = function() {
    $e423d9237c6b8e93$var$locked = true;
};
$e423d9237c6b8e93$export$967075d2f3b8e7ff.register = function(func) {
    if ($e423d9237c6b8e93$var$locked) throw new Error("computeHmac is locked");
    $e423d9237c6b8e93$var$__computeHmac = func;
};
Object.freeze($e423d9237c6b8e93$export$967075d2f3b8e7ff);

});
parcelRegister("8L1lW", function(module, exports) {

$parcel$export(module.exports, "createHash", function () { return $6603c32e88d7675b$export$2fb37efbf6ae0c0e; });
$parcel$export(module.exports, "createHmac", function () { return $6603c32e88d7675b$export$da39cf97e1eb7c91; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $6603c32e88d7675b$export$b80c7ba289c8fa56; });
$parcel$export(module.exports, "randomBytes", function () { return $6603c32e88d7675b$export$5f828d93ff035aa8; });
/* Browser Crypto Shims */ 
var $9KVQy = parcelRequire("9KVQy");

var $8lTS6 = parcelRequire("8lTS6");

var $kHnZL = parcelRequire("kHnZL");

var $22bNf = parcelRequire("22bNf");

var $g6m4b = parcelRequire("g6m4b");
function $6603c32e88d7675b$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $6603c32e88d7675b$var$anyGlobal = $6603c32e88d7675b$var$getGlobal();
const $6603c32e88d7675b$var$crypto = $6603c32e88d7675b$var$anyGlobal.crypto || $6603c32e88d7675b$var$anyGlobal.msCrypto;
function $6603c32e88d7675b$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $kHnZL.sha256).create();
        case "sha512":
            return (0, $22bNf.sha512).create();
    }
    (0, $g6m4b.assertArgument)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $6603c32e88d7675b$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $kHnZL.sha256,
        sha512: $22bNf.sha512
    }[_algo];
    (0, $g6m4b.assertArgument)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $9KVQy.hmac).create(algo, key);
}
function $6603c32e88d7675b$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $kHnZL.sha256,
        sha512: $22bNf.sha512
    }[_algo];
    (0, $g6m4b.assertArgument)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $8lTS6.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $6603c32e88d7675b$export$5f828d93ff035aa8(length) {
    (0, $g6m4b.assert)($6603c32e88d7675b$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $g6m4b.assertArgument)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $6603c32e88d7675b$var$crypto.getRandomValues(result);
    return result;
}

});
parcelRegister("9KVQy", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $71a54815d4b0fbfc$export$355af40f8ab02f34; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");
class $71a54815d4b0fbfc$export$7b9cf41ebec74f45 extends (0, $9mdbq.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $kW2j6.hash)(hash);
        const key = (0, $9mdbq.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $kW2j6.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $kW2j6.exists)(this);
        (0, $kW2j6.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $71a54815d4b0fbfc$export$355af40f8ab02f34 = (hash, key, message)=>new $71a54815d4b0fbfc$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$71a54815d4b0fbfc$export$355af40f8ab02f34.create = (hash, key)=>new $71a54815d4b0fbfc$export$7b9cf41ebec74f45(hash, key);

});
parcelRegister("kW2j6", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $f3db038be156b7eb$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $f3db038be156b7eb$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $f3db038be156b7eb$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $f3db038be156b7eb$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $f3db038be156b7eb$export$c789db2c85949867; });
function $f3db038be156b7eb$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $f3db038be156b7eb$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $f3db038be156b7eb$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $f3db038be156b7eb$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $f3db038be156b7eb$export$98e628dec113755e(hash.outputLen);
    $f3db038be156b7eb$export$98e628dec113755e(hash.blockLen);
}
function $f3db038be156b7eb$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $f3db038be156b7eb$export$c789db2c85949867(out, instance) {
    $f3db038be156b7eb$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $f3db038be156b7eb$var$assert = {
    number: $f3db038be156b7eb$export$98e628dec113755e,
    bool: $f3db038be156b7eb$export$87b259aa03e3d267,
    bytes: $f3db038be156b7eb$export$b3317979f9250576,
    hash: $f3db038be156b7eb$export$d6af199866bfb566,
    exists: $f3db038be156b7eb$export$f7e9f41ea797a17,
    output: $f3db038be156b7eb$export$c789db2c85949867
};
var $f3db038be156b7eb$export$2e2bcd8739ae039 = $f3db038be156b7eb$var$assert;

});

parcelRegister("9mdbq", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $6d0065097d5215bf$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $6d0065097d5215bf$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $6d0065097d5215bf$export$466993d7d0d272aa; });
$parcel$export(module.exports, "asyncLoop", function () { return $6d0065097d5215bf$export$57207d71b8c929c8; });
$parcel$export(module.exports, "toBytes", function () { return $6d0065097d5215bf$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $6d0065097d5215bf$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $6d0065097d5215bf$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "checkOpts", function () { return $6d0065097d5215bf$export$6fcee72895eceb1e; });
$parcel$export(module.exports, "wrapConstructor", function () { return $6d0065097d5215bf$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $6d0065097d5215bf$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $6d0065097d5215bf$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $9hV6m = parcelRequire("9hV6m");
const $6d0065097d5215bf$var$u8a = (a)=>a instanceof Uint8Array;
const $6d0065097d5215bf$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $6d0065097d5215bf$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $6d0065097d5215bf$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$6d0065097d5215bf$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $6d0065097d5215bf$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $6d0065097d5215bf$export$58b867e287a802c8(bytes) {
    if (!$6d0065097d5215bf$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6d0065097d5215bf$var$hexes[bytes[i]];
    return hex;
}
function $6d0065097d5215bf$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $6d0065097d5215bf$export$bdd553fddd433dcb = async ()=>{};
async function $6d0065097d5215bf$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $6d0065097d5215bf$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $6d0065097d5215bf$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $6d0065097d5215bf$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $6d0065097d5215bf$export$3df70a15530b5e81(data);
    if (!$6d0065097d5215bf$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $6d0065097d5215bf$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6d0065097d5215bf$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $6d0065097d5215bf$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $6d0065097d5215bf$var$toStr = {}.toString;
function $6d0065097d5215bf$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $6d0065097d5215bf$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $6d0065097d5215bf$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $6d0065097d5215bf$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $9hV6m.crypto) && typeof (0, $9hV6m.crypto).getRandomValues === "function") return (0, $9hV6m.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("9hV6m", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $6c31fecb2de06915$export$7effb53edfc7fa2d; });
const $6c31fecb2de06915$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("8lTS6", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $614b9fd308b6bd03$export$448fa22aedc9dbca; });

var $kW2j6 = parcelRequire("kW2j6");

var $9KVQy = parcelRequire("9KVQy");

var $9mdbq = parcelRequire("9mdbq");
// Common prologue and epilogue for sync/async functions
function $614b9fd308b6bd03$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $kW2j6.hash)(hash);
    const opts = (0, $9mdbq.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $kW2j6.number)(c);
    (0, $kW2j6.number)(dkLen);
    (0, $kW2j6.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $9mdbq.toBytes)(_password);
    const salt = (0, $9mdbq.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = (0, $9KVQy.hmac).create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $614b9fd308b6bd03$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
function $614b9fd308b6bd03$export$448fa22aedc9dbca(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $614b9fd308b6bd03$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $9mdbq.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $614b9fd308b6bd03$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
async function $614b9fd308b6bd03$export$fda056adff0996c3(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $614b9fd308b6bd03$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $9mdbq.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $9mdbq.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $614b9fd308b6bd03$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}

});

parcelRegister("kHnZL", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $f11a6fbc065abd4a$export$bced8d2aada2d1c9; });

var $GWdd1 = parcelRequire("GWdd1");

var $9mdbq = parcelRequire("9mdbq");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $f11a6fbc065abd4a$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f11a6fbc065abd4a$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f11a6fbc065abd4a$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f11a6fbc065abd4a$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f11a6fbc065abd4a$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $f11a6fbc065abd4a$var$SHA256 extends (0, $GWdd1.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f11a6fbc065abd4a$var$IV[0] | 0;
        this.B = $f11a6fbc065abd4a$var$IV[1] | 0;
        this.C = $f11a6fbc065abd4a$var$IV[2] | 0;
        this.D = $f11a6fbc065abd4a$var$IV[3] | 0;
        this.E = $f11a6fbc065abd4a$var$IV[4] | 0;
        this.F = $f11a6fbc065abd4a$var$IV[5] | 0;
        this.G = $f11a6fbc065abd4a$var$IV[6] | 0;
        this.H = $f11a6fbc065abd4a$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f11a6fbc065abd4a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f11a6fbc065abd4a$var$SHA256_W[i - 15];
            const W2 = $f11a6fbc065abd4a$var$SHA256_W[i - 2];
            const s0 = (0, $9mdbq.rotr)(W15, 7) ^ (0, $9mdbq.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9mdbq.rotr)(W2, 17) ^ (0, $9mdbq.rotr)(W2, 19) ^ W2 >>> 10;
            $f11a6fbc065abd4a$var$SHA256_W[i] = s1 + $f11a6fbc065abd4a$var$SHA256_W[i - 7] + s0 + $f11a6fbc065abd4a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9mdbq.rotr)(E, 6) ^ (0, $9mdbq.rotr)(E, 11) ^ (0, $9mdbq.rotr)(E, 25);
            const T1 = H + sigma1 + $f11a6fbc065abd4a$var$Chi(E, F, G) + $f11a6fbc065abd4a$var$SHA256_K[i] + $f11a6fbc065abd4a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9mdbq.rotr)(A, 2) ^ (0, $9mdbq.rotr)(A, 13) ^ (0, $9mdbq.rotr)(A, 22);
            const T2 = sigma0 + $f11a6fbc065abd4a$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f11a6fbc065abd4a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f11a6fbc065abd4a$var$SHA224 extends $f11a6fbc065abd4a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $f11a6fbc065abd4a$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA256());
const $f11a6fbc065abd4a$export$97b70509d4e397ea = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA224());

});
parcelRegister("GWdd1", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $0811140f03d50e93$export$ebbe38f24b9a0856; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");
// Polyfill for Safari 14
function $0811140f03d50e93$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $0811140f03d50e93$export$ebbe38f24b9a0856 extends (0, $9mdbq.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9mdbq.createView)(this.buffer);
    }
    update(data) {
        (0, $kW2j6.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9mdbq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9mdbq.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kW2j6.exists)(this);
        (0, $kW2j6.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $0811140f03d50e93$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9mdbq.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});


parcelRegister("22bNf", function(module, exports) {

$parcel$export(module.exports, "sha512", function () { return $17b4ea9374b33102$export$a888d2532e6dc7bb; });

var $GWdd1 = parcelRequire("GWdd1");

var $ePVjL = parcelRequire("ePVjL");

var $9mdbq = parcelRequire("9mdbq");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$17b4ea9374b33102$var$SHA512_Kh, $17b4ea9374b33102$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $ePVjL.default).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $17b4ea9374b33102$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $17b4ea9374b33102$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $17b4ea9374b33102$export$d655fdb8a1cad5df extends (0, $GWdd1.SHA2) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $17b4ea9374b33102$var$SHA512_W_H[i] = view.getUint32(offset);
            $17b4ea9374b33102$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $17b4ea9374b33102$var$SHA512_W_H[i - 15] | 0;
            const W15l = $17b4ea9374b33102$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $ePVjL.default).rotrSH(W15h, W15l, 1) ^ (0, $ePVjL.default).rotrSH(W15h, W15l, 8) ^ (0, $ePVjL.default).shrSH(W15h, W15l, 7);
            const s0l = (0, $ePVjL.default).rotrSL(W15h, W15l, 1) ^ (0, $ePVjL.default).rotrSL(W15h, W15l, 8) ^ (0, $ePVjL.default).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $17b4ea9374b33102$var$SHA512_W_H[i - 2] | 0;
            const W2l = $17b4ea9374b33102$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $ePVjL.default).rotrSH(W2h, W2l, 19) ^ (0, $ePVjL.default).rotrBH(W2h, W2l, 61) ^ (0, $ePVjL.default).shrSH(W2h, W2l, 6);
            const s1l = (0, $ePVjL.default).rotrSL(W2h, W2l, 19) ^ (0, $ePVjL.default).rotrBL(W2h, W2l, 61) ^ (0, $ePVjL.default).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $ePVjL.default).add4L(s0l, s1l, $17b4ea9374b33102$var$SHA512_W_L[i - 7], $17b4ea9374b33102$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $ePVjL.default).add4H(SUMl, s0h, s1h, $17b4ea9374b33102$var$SHA512_W_H[i - 7], $17b4ea9374b33102$var$SHA512_W_H[i - 16]);
            $17b4ea9374b33102$var$SHA512_W_H[i] = SUMh | 0;
            $17b4ea9374b33102$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $ePVjL.default).rotrSH(Eh, El, 14) ^ (0, $ePVjL.default).rotrSH(Eh, El, 18) ^ (0, $ePVjL.default).rotrBH(Eh, El, 41);
            const sigma1l = (0, $ePVjL.default).rotrSL(Eh, El, 14) ^ (0, $ePVjL.default).rotrSL(Eh, El, 18) ^ (0, $ePVjL.default).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $ePVjL.default).add5L(Hl, sigma1l, CHIl, $17b4ea9374b33102$var$SHA512_Kl[i], $17b4ea9374b33102$var$SHA512_W_L[i]);
            const T1h = (0, $ePVjL.default).add5H(T1ll, Hh, sigma1h, CHIh, $17b4ea9374b33102$var$SHA512_Kh[i], $17b4ea9374b33102$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $ePVjL.default).rotrSH(Ah, Al, 28) ^ (0, $ePVjL.default).rotrBH(Ah, Al, 34) ^ (0, $ePVjL.default).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $ePVjL.default).rotrSL(Ah, Al, 28) ^ (0, $ePVjL.default).rotrBL(Ah, Al, 34) ^ (0, $ePVjL.default).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $ePVjL.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $ePVjL.default).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $ePVjL.default).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $ePVjL.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $ePVjL.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $ePVjL.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $ePVjL.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $ePVjL.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $ePVjL.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $ePVjL.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $ePVjL.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $17b4ea9374b33102$var$SHA512_W_H.fill(0);
        $17b4ea9374b33102$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $17b4ea9374b33102$var$SHA512_224 extends $17b4ea9374b33102$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $17b4ea9374b33102$var$SHA512_256 extends $17b4ea9374b33102$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $17b4ea9374b33102$var$SHA384 extends $17b4ea9374b33102$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $17b4ea9374b33102$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $17b4ea9374b33102$export$d655fdb8a1cad5df());
const $17b4ea9374b33102$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $17b4ea9374b33102$var$SHA512_224());
const $17b4ea9374b33102$export$c78786b6da86db2a = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $17b4ea9374b33102$var$SHA512_256());
const $17b4ea9374b33102$export$612d47d55dedde45 = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $17b4ea9374b33102$var$SHA384());

});
parcelRegister("ePVjL", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $acd24a3cab1630f3$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $acd24a3cab1630f3$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $acd24a3cab1630f3$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $acd24a3cab1630f3$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $acd24a3cab1630f3$export$5d12cc1da441323f; });
$parcel$export(module.exports, "default", function () { return $acd24a3cab1630f3$export$2e2bcd8739ae039; });
const $acd24a3cab1630f3$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $acd24a3cab1630f3$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $acd24a3cab1630f3$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $acd24a3cab1630f3$var$U32_MASK64),
        l: Number(n >> $acd24a3cab1630f3$var$_32n & $acd24a3cab1630f3$var$U32_MASK64)
    };
    return {
        h: Number(n >> $acd24a3cab1630f3$var$_32n & $acd24a3cab1630f3$var$U32_MASK64) | 0,
        l: Number(n & $acd24a3cab1630f3$var$U32_MASK64) | 0
    };
}
function $acd24a3cab1630f3$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $acd24a3cab1630f3$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $acd24a3cab1630f3$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $acd24a3cab1630f3$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $acd24a3cab1630f3$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $acd24a3cab1630f3$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $acd24a3cab1630f3$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $acd24a3cab1630f3$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $acd24a3cab1630f3$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $acd24a3cab1630f3$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $acd24a3cab1630f3$export$a088d44bd387d2a3 = (_h, l)=>l;
const $acd24a3cab1630f3$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $acd24a3cab1630f3$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $acd24a3cab1630f3$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $acd24a3cab1630f3$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $acd24a3cab1630f3$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $acd24a3cab1630f3$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $acd24a3cab1630f3$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $acd24a3cab1630f3$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $acd24a3cab1630f3$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $acd24a3cab1630f3$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $acd24a3cab1630f3$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $acd24a3cab1630f3$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $acd24a3cab1630f3$var$u64 = {
    fromBig: $acd24a3cab1630f3$export$9625d4333cb56c3f,
    split: $acd24a3cab1630f3$export$65980d18b75784e2,
    toBig: $acd24a3cab1630f3$export$30f78adcaaa2eb7,
    shrSH: $acd24a3cab1630f3$export$75aa78dc5bd52853,
    shrSL: $acd24a3cab1630f3$export$a0225ff0aee14e25,
    rotrSH: $acd24a3cab1630f3$export$97f812dfd830ca87,
    rotrSL: $acd24a3cab1630f3$export$60987e30e2c9d9d,
    rotrBH: $acd24a3cab1630f3$export$af9c7fbac44dcb76,
    rotrBL: $acd24a3cab1630f3$export$f619171d6d5ac414,
    rotr32H: $acd24a3cab1630f3$export$a088d44bd387d2a3,
    rotr32L: $acd24a3cab1630f3$export$8415aae4d1f69577,
    rotlSH: $acd24a3cab1630f3$export$4b80a2917447870e,
    rotlSL: $acd24a3cab1630f3$export$20652918a7b63b3,
    rotlBH: $acd24a3cab1630f3$export$a52f14bf902f9977,
    rotlBL: $acd24a3cab1630f3$export$5d12cc1da441323f,
    add: $acd24a3cab1630f3$export$e16d8520af44a096,
    add3L: $acd24a3cab1630f3$export$c0c22b91f08911f,
    add3H: $acd24a3cab1630f3$export$ef7b26044977a8ec,
    add4L: $acd24a3cab1630f3$export$2f4e199c560f545d,
    add4H: $acd24a3cab1630f3$export$e909220d675a7741,
    add5H: $acd24a3cab1630f3$export$b45ee8d78c965098,
    add5L: $acd24a3cab1630f3$export$d732b061fe9c9ae4
};
var $acd24a3cab1630f3$export$2e2bcd8739ae039 = $acd24a3cab1630f3$var$u64;

});



parcelRegister("8Cy13", function(module, exports) {

$parcel$export(module.exports, "getBytes", function () { return $646c422fbb8bae38$export$a3521add2594f3c8; });
$parcel$export(module.exports, "getBytesCopy", function () { return $646c422fbb8bae38$export$37110e7fee0af4ad; });
$parcel$export(module.exports, "isHexString", function () { return $646c422fbb8bae38$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytesLike", function () { return $646c422fbb8bae38$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "hexlify", function () { return $646c422fbb8bae38$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "concat", function () { return $646c422fbb8bae38$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "dataLength", function () { return $646c422fbb8bae38$export$2321cd91b99770ff; });
$parcel$export(module.exports, "dataSlice", function () { return $646c422fbb8bae38$export$f6d845ffb449edc9; });
$parcel$export(module.exports, "zeroPadValue", function () { return $646c422fbb8bae38$export$4473860254365feb; });
$parcel$export(module.exports, "zeroPadBytes", function () { return $646c422fbb8bae38$export$1dc7fbe1b8738fe7; });
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
var $g6m4b = parcelRequire("g6m4b");
function $646c422fbb8bae38$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $g6m4b.assertArgument)(false, "invalid BytesLike value", name || "value", value);
}
function $646c422fbb8bae38$export$a3521add2594f3c8(value, name) {
    return $646c422fbb8bae38$var$_getBytes(value, name, false);
}
function $646c422fbb8bae38$export$37110e7fee0af4ad(value, name) {
    return $646c422fbb8bae38$var$_getBytes(value, name, true);
}
function $646c422fbb8bae38$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $646c422fbb8bae38$export$9a14abb1a440cd5e(value) {
    return $646c422fbb8bae38$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $646c422fbb8bae38$var$HexCharacters = "0123456789abcdef";
function $646c422fbb8bae38$export$2b0d6b5fbe698c70(data) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $646c422fbb8bae38$var$HexCharacters[(v & 0xf0) >> 4] + $646c422fbb8bae38$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $646c422fbb8bae38$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$646c422fbb8bae38$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $646c422fbb8bae38$export$2321cd91b99770ff(data) {
    if ($646c422fbb8bae38$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $646c422fbb8bae38$export$a3521add2594f3c8(data).length;
}
function $646c422fbb8bae38$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $g6m4b.assert)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $646c422fbb8bae38$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $646c422fbb8bae38$export$9c854001a22ebaa2(data) {
    let bytes = $646c422fbb8bae38$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $646c422fbb8bae38$var$zeroPad(data, length, left) {
    const bytes = $646c422fbb8bae38$export$a3521add2594f3c8(data);
    (0, $g6m4b.assert)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $646c422fbb8bae38$export$2b0d6b5fbe698c70(result);
}
function $646c422fbb8bae38$export$4473860254365feb(data, length) {
    return $646c422fbb8bae38$var$zeroPad(data, length, true);
}
function $646c422fbb8bae38$export$1dc7fbe1b8738fe7(data, length) {
    return $646c422fbb8bae38$var$zeroPad(data, length, false);
}

});


parcelRegister("kdR5O", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $eb8e34a59f49e216$export$f8151fce47ad1c35; });
/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ 
var $1gh8R = parcelRequire("1gh8R");

var $8Cy13 = parcelRequire("8Cy13");
let $eb8e34a59f49e216$var$locked = false;
const $eb8e34a59f49e216$var$_keccak256 = function(data) {
    return (0, $1gh8R.keccak_256)(data);
};
let $eb8e34a59f49e216$var$__keccak256 = $eb8e34a59f49e216$var$_keccak256;
function $eb8e34a59f49e216$export$f8151fce47ad1c35(_data) {
    const data = (0, $8Cy13.getBytes)(_data, "data");
    return (0, $8Cy13.hexlify)($eb8e34a59f49e216$var$__keccak256(data));
}
$eb8e34a59f49e216$export$f8151fce47ad1c35._ = $eb8e34a59f49e216$var$_keccak256;
$eb8e34a59f49e216$export$f8151fce47ad1c35.lock = function() {
    $eb8e34a59f49e216$var$locked = true;
};
$eb8e34a59f49e216$export$f8151fce47ad1c35.register = function(func) {
    if ($eb8e34a59f49e216$var$locked) throw new TypeError("keccak256 is locked");
    $eb8e34a59f49e216$var$__keccak256 = func;
};
Object.freeze($eb8e34a59f49e216$export$f8151fce47ad1c35);

});
parcelRegister("1gh8R", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $0eb4951ed1531698$export$860ddaa9ca84a66d; });

var $kW2j6 = parcelRequire("kW2j6");

var $ePVjL = parcelRequire("ePVjL");

var $9mdbq = parcelRequire("9mdbq");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$0eb4951ed1531698$var$SHA3_PI, $0eb4951ed1531698$var$SHA3_ROTL, $0eb4951ed1531698$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $0eb4951ed1531698$var$_0n = /* @__PURE__ */ BigInt(0);
const $0eb4951ed1531698$var$_1n = /* @__PURE__ */ BigInt(1);
const $0eb4951ed1531698$var$_2n = /* @__PURE__ */ BigInt(2);
const $0eb4951ed1531698$var$_7n = /* @__PURE__ */ BigInt(7);
const $0eb4951ed1531698$var$_256n = /* @__PURE__ */ BigInt(256);
const $0eb4951ed1531698$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $0eb4951ed1531698$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $0eb4951ed1531698$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $0eb4951ed1531698$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $0eb4951ed1531698$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $0eb4951ed1531698$var$_1n ^ (R >> $0eb4951ed1531698$var$_7n) * $0eb4951ed1531698$var$_0x71n) % $0eb4951ed1531698$var$_256n;
        if (R & $0eb4951ed1531698$var$_2n) t ^= $0eb4951ed1531698$var$_1n << ($0eb4951ed1531698$var$_1n << /* @__PURE__ */ BigInt(j)) - $0eb4951ed1531698$var$_1n;
    }
    $0eb4951ed1531698$var$_SHA3_IOTA.push(t);
}
const [$0eb4951ed1531698$var$SHA3_IOTA_H, $0eb4951ed1531698$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $ePVjL.split)($0eb4951ed1531698$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $0eb4951ed1531698$var$rotlH = (h, l, s)=>s > 32 ? (0, $ePVjL.rotlBH)(h, l, s) : (0, $ePVjL.rotlSH)(h, l, s);
const $0eb4951ed1531698$var$rotlL = (h, l, s)=>s > 32 ? (0, $ePVjL.rotlBL)(h, l, s) : (0, $ePVjL.rotlSL)(h, l, s);
function $0eb4951ed1531698$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $0eb4951ed1531698$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $0eb4951ed1531698$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $0eb4951ed1531698$var$SHA3_ROTL[t];
            const Th = $0eb4951ed1531698$var$rotlH(curH, curL, shift);
            const Tl = $0eb4951ed1531698$var$rotlL(curH, curL, shift);
            const PI = $0eb4951ed1531698$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $0eb4951ed1531698$var$SHA3_IOTA_H[round];
        s[1] ^= $0eb4951ed1531698$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $0eb4951ed1531698$export$f7374b8b4498bc2e extends (0, $9mdbq.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $kW2j6.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $9mdbq.u32)(this.state);
    }
    keccak() {
        $0eb4951ed1531698$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $kW2j6.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $9mdbq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $kW2j6.exists)(this, false);
        (0, $kW2j6.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $kW2j6.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $kW2j6.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $0eb4951ed1531698$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $0eb4951ed1531698$var$gen = (suffix, blockLen, outputLen)=>(0, $9mdbq.wrapConstructor)(()=>new $0eb4951ed1531698$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $0eb4951ed1531698$export$fe6c2b96a79338e9 = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x06, 144, 28);
const $0eb4951ed1531698$export$76e19b6966813b14 = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x06, 136, 32);
const $0eb4951ed1531698$export$a58509fa80f30d15 = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x06, 104, 48);
const $0eb4951ed1531698$export$20ed324dbdf09b7c = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x06, 72, 64);
const $0eb4951ed1531698$export$2f7fb3c6fac246bc = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x01, 144, 28);
const $0eb4951ed1531698$export$860ddaa9ca84a66d = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x01, 136, 32);
const $0eb4951ed1531698$export$46fcdeb4c5686552 = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x01, 104, 48);
const $0eb4951ed1531698$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $0eb4951ed1531698$var$gen(0x01, 72, 64);
const $0eb4951ed1531698$var$genShake = (suffix, blockLen, outputLen)=>(0, $9mdbq.wrapXOFConstructorWithOpts)((opts = {})=>new $0eb4951ed1531698$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $0eb4951ed1531698$export$f43dc3bb86efbba2 = /* @__PURE__ */ $0eb4951ed1531698$var$genShake(0x1f, 168, 16);
const $0eb4951ed1531698$export$c240d011f1520440 = /* @__PURE__ */ $0eb4951ed1531698$var$genShake(0x1f, 136, 32);

});


parcelRegister("h5f4O", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $c6fe99323c2965cd$export$d1cea0ee4e3f0d3e; });

var $bVNbP = parcelRequire("bVNbP");

var $8Cy13 = parcelRequire("8Cy13");
let $c6fe99323c2965cd$var$locked = false;
const $c6fe99323c2965cd$var$_ripemd160 = function(data) {
    return (0, $bVNbP.ripemd160)(data);
};
let $c6fe99323c2965cd$var$__ripemd160 = $c6fe99323c2965cd$var$_ripemd160;
function $c6fe99323c2965cd$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $8Cy13.getBytes)(_data, "data");
    return (0, $8Cy13.hexlify)($c6fe99323c2965cd$var$__ripemd160(data));
}
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e._ = $c6fe99323c2965cd$var$_ripemd160;
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e.lock = function() {
    $c6fe99323c2965cd$var$locked = true;
};
$c6fe99323c2965cd$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($c6fe99323c2965cd$var$locked) throw new TypeError("ripemd160 is locked");
    $c6fe99323c2965cd$var$__ripemd160 = func;
};
Object.freeze($c6fe99323c2965cd$export$d1cea0ee4e3f0d3e);

});
parcelRegister("bVNbP", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $8afb2ca53f256d31$export$d1cea0ee4e3f0d3e; });

var $GWdd1 = parcelRequire("GWdd1");

var $9mdbq = parcelRequire("9mdbq");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $8afb2ca53f256d31$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $8afb2ca53f256d31$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $8afb2ca53f256d31$var$Pi = /* @__PURE__ */ $8afb2ca53f256d31$var$Id.map((i)=>(9 * i + 5) % 16);
let $8afb2ca53f256d31$var$idxL = [
    $8afb2ca53f256d31$var$Id
];
let $8afb2ca53f256d31$var$idxR = [
    $8afb2ca53f256d31$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $8afb2ca53f256d31$var$idxL,
    $8afb2ca53f256d31$var$idxR
])j.push(j[i].map((k)=>$8afb2ca53f256d31$var$Rho[k]));
const $8afb2ca53f256d31$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $8afb2ca53f256d31$var$shiftsL = /* @__PURE__ */ $8afb2ca53f256d31$var$idxL.map((idx, i)=>idx.map((j)=>$8afb2ca53f256d31$var$shifts[i][j]));
const $8afb2ca53f256d31$var$shiftsR = /* @__PURE__ */ $8afb2ca53f256d31$var$idxR.map((idx, i)=>idx.map((j)=>$8afb2ca53f256d31$var$shifts[i][j]));
const $8afb2ca53f256d31$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $8afb2ca53f256d31$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $8afb2ca53f256d31$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $8afb2ca53f256d31$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $8afb2ca53f256d31$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $8afb2ca53f256d31$export$7b0ccd21718381c9 extends (0, $GWdd1.SHA2) {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$8afb2ca53f256d31$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $8afb2ca53f256d31$var$Kl[group], hbr = $8afb2ca53f256d31$var$Kr[group]; // prettier-ignore
            const rl = $8afb2ca53f256d31$var$idxL[group], rr = $8afb2ca53f256d31$var$idxR[group]; // prettier-ignore
            const sl = $8afb2ca53f256d31$var$shiftsL[group], sr = $8afb2ca53f256d31$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $8afb2ca53f256d31$var$rotl(al + $8afb2ca53f256d31$var$f(group, bl, cl, dl) + $8afb2ca53f256d31$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $8afb2ca53f256d31$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $8afb2ca53f256d31$var$rotl(ar + $8afb2ca53f256d31$var$f(rGroup, br, cr, dr) + $8afb2ca53f256d31$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $8afb2ca53f256d31$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $8afb2ca53f256d31$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
const $8afb2ca53f256d31$export$d1cea0ee4e3f0d3e = /* @__PURE__ */ (0, $9mdbq.wrapConstructor)(()=>new $8afb2ca53f256d31$export$7b0ccd21718381c9());

});


parcelRegister("f9KYV", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $b08c23dad829fb20$export$448fa22aedc9dbca; });
/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 
var $8L1lW = parcelRequire("8L1lW");

var $8Cy13 = parcelRequire("8Cy13");
let $b08c23dad829fb20$var$locked = false;
const $b08c23dad829fb20$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $8L1lW.pbkdf2Sync)(password, salt, iterations, keylen, algo);
};
let $b08c23dad829fb20$var$__pbkdf2 = $b08c23dad829fb20$var$_pbkdf2;
function $b08c23dad829fb20$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $8Cy13.getBytes)(_password, "password");
    const salt = (0, $8Cy13.getBytes)(_salt, "salt");
    return (0, $8Cy13.hexlify)($b08c23dad829fb20$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$b08c23dad829fb20$export$448fa22aedc9dbca._ = $b08c23dad829fb20$var$_pbkdf2;
$b08c23dad829fb20$export$448fa22aedc9dbca.lock = function() {
    $b08c23dad829fb20$var$locked = true;
};
$b08c23dad829fb20$export$448fa22aedc9dbca.register = function(func) {
    if ($b08c23dad829fb20$var$locked) throw new Error("pbkdf2 is locked");
    $b08c23dad829fb20$var$__pbkdf2 = func;
};
Object.freeze($b08c23dad829fb20$export$448fa22aedc9dbca);

});

parcelRegister("jrQTq", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $e2899165f684d722$export$5f828d93ff035aa8; });
/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
var $8L1lW = parcelRequire("8L1lW");
let $e2899165f684d722$var$locked = false;
const $e2899165f684d722$var$_randomBytes = function(length) {
    return new Uint8Array((0, $8L1lW.randomBytes)(length));
};
let $e2899165f684d722$var$__randomBytes = $e2899165f684d722$var$_randomBytes;
function $e2899165f684d722$export$5f828d93ff035aa8(length) {
    return $e2899165f684d722$var$__randomBytes(length);
}
$e2899165f684d722$export$5f828d93ff035aa8._ = $e2899165f684d722$var$_randomBytes;
$e2899165f684d722$export$5f828d93ff035aa8.lock = function() {
    $e2899165f684d722$var$locked = true;
};
$e2899165f684d722$export$5f828d93ff035aa8.register = function(func) {
    if ($e2899165f684d722$var$locked) throw new Error("randomBytes is locked");
    $e2899165f684d722$var$__randomBytes = func;
};
Object.freeze($e2899165f684d722$export$5f828d93ff035aa8);

});

parcelRegister("hSwrm", function(module, exports) {

$parcel$export(module.exports, "scrypt", function () { return $d040a4c743127b7f$export$7cf7c2f1ec457bf3; });
$parcel$export(module.exports, "scryptSync", function () { return $d040a4c743127b7f$export$86c79e0734c26a76; });

var $bEPDm = parcelRequire("bEPDm");

var $8Cy13 = parcelRequire("8Cy13");
let $d040a4c743127b7f$var$lockedSync = false, $d040a4c743127b7f$var$lockedAsync = false;
const $d040a4c743127b7f$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $bEPDm.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $d040a4c743127b7f$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $bEPDm.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $d040a4c743127b7f$var$__scryptAsync = $d040a4c743127b7f$var$_scryptAsync;
let $d040a4c743127b7f$var$__scryptSync = $d040a4c743127b7f$var$_scryptSync;
async function $d040a4c743127b7f$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $8Cy13.getBytes)(_passwd, "passwd");
    const salt = (0, $8Cy13.getBytes)(_salt, "salt");
    return (0, $8Cy13.hexlify)(await $d040a4c743127b7f$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$d040a4c743127b7f$export$7cf7c2f1ec457bf3._ = $d040a4c743127b7f$var$_scryptAsync;
$d040a4c743127b7f$export$7cf7c2f1ec457bf3.lock = function() {
    $d040a4c743127b7f$var$lockedAsync = true;
};
$d040a4c743127b7f$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($d040a4c743127b7f$var$lockedAsync) throw new Error("scrypt is locked");
    $d040a4c743127b7f$var$__scryptAsync = func;
};
Object.freeze($d040a4c743127b7f$export$7cf7c2f1ec457bf3);
function $d040a4c743127b7f$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $8Cy13.getBytes)(_passwd, "passwd");
    const salt = (0, $8Cy13.getBytes)(_salt, "salt");
    return (0, $8Cy13.hexlify)($d040a4c743127b7f$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$d040a4c743127b7f$export$86c79e0734c26a76._ = $d040a4c743127b7f$var$_scryptSync;
$d040a4c743127b7f$export$86c79e0734c26a76.lock = function() {
    $d040a4c743127b7f$var$lockedSync = true;
};
$d040a4c743127b7f$export$86c79e0734c26a76.register = function(func) {
    if ($d040a4c743127b7f$var$lockedSync) throw new Error("scryptSync is locked");
    $d040a4c743127b7f$var$__scryptSync = func;
};
Object.freeze($d040a4c743127b7f$export$86c79e0734c26a76);

});
parcelRegister("bEPDm", function(module, exports) {

$parcel$export(module.exports, "scrypt", function () { return $87cb7b8907f68a78$export$7cf7c2f1ec457bf3; });
$parcel$export(module.exports, "scryptAsync", function () { return $87cb7b8907f68a78$export$aaeeb1df7f0390e8; });

var $kW2j6 = parcelRequire("kW2j6");

var $kHnZL = parcelRequire("kHnZL");

var $8lTS6 = parcelRequire("8lTS6");

var $9mdbq = parcelRequire("9mdbq");
// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $87cb7b8907f68a78$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $87cb7b8907f68a78$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $87cb7b8907f68a78$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $87cb7b8907f68a78$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $87cb7b8907f68a78$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $87cb7b8907f68a78$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $87cb7b8907f68a78$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $87cb7b8907f68a78$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $87cb7b8907f68a78$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $87cb7b8907f68a78$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $87cb7b8907f68a78$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $87cb7b8907f68a78$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $87cb7b8907f68a78$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $87cb7b8907f68a78$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $87cb7b8907f68a78$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $87cb7b8907f68a78$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $87cb7b8907f68a78$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $87cb7b8907f68a78$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $87cb7b8907f68a78$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $87cb7b8907f68a78$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $87cb7b8907f68a78$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $87cb7b8907f68a78$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $87cb7b8907f68a78$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $87cb7b8907f68a78$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $87cb7b8907f68a78$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $87cb7b8907f68a78$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $87cb7b8907f68a78$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $87cb7b8907f68a78$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $87cb7b8907f68a78$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $87cb7b8907f68a78$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $87cb7b8907f68a78$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $87cb7b8907f68a78$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $87cb7b8907f68a78$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $87cb7b8907f68a78$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $87cb7b8907f68a78$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $87cb7b8907f68a78$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $87cb7b8907f68a78$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $87cb7b8907f68a78$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $9mdbq.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    (0, $kW2j6.number)(N);
    (0, $kW2j6.number)(r);
    (0, $kW2j6.number)(p);
    (0, $kW2j6.number)(dkLen);
    (0, $kW2j6.number)(asyncTick);
    (0, $kW2j6.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $8lTS6.pbkdf2)((0, $kHnZL.sha256), password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $9mdbq.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $9mdbq.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $9mdbq.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $87cb7b8907f68a78$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $8lTS6.pbkdf2)((0, $kHnZL.sha256), password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
function $87cb7b8907f68a78$export$7cf7c2f1ec457bf3(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $87cb7b8907f68a78$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $87cb7b8907f68a78$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $87cb7b8907f68a78$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $87cb7b8907f68a78$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $87cb7b8907f68a78$var$scryptOutput(password, dkLen, B, V, tmp);
}
async function $87cb7b8907f68a78$export$aaeeb1df7f0390e8(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $87cb7b8907f68a78$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $9mdbq.asyncLoop)(N - 1, asyncTick, ()=>{
            $87cb7b8907f68a78$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $87cb7b8907f68a78$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $9mdbq.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $87cb7b8907f68a78$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $87cb7b8907f68a78$var$scryptOutput(password, dkLen, B, V, tmp);
}

});


parcelRegister("i7EHi", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $d318730f8de39247$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $d318730f8de39247$export$a888d2532e6dc7bb; });

var $8L1lW = parcelRequire("8L1lW");

var $8Cy13 = parcelRequire("8Cy13");
const $d318730f8de39247$var$_sha256 = function(data) {
    return (0, $8L1lW.createHash)("sha256").update(data).digest();
};
const $d318730f8de39247$var$_sha512 = function(data) {
    return (0, $8L1lW.createHash)("sha512").update(data).digest();
};
let $d318730f8de39247$var$__sha256 = $d318730f8de39247$var$_sha256;
let $d318730f8de39247$var$__sha512 = $d318730f8de39247$var$_sha512;
let $d318730f8de39247$var$locked256 = false, $d318730f8de39247$var$locked512 = false;
function $d318730f8de39247$export$bced8d2aada2d1c9(_data) {
    const data = (0, $8Cy13.getBytes)(_data, "data");
    return (0, $8Cy13.hexlify)($d318730f8de39247$var$__sha256(data));
}
$d318730f8de39247$export$bced8d2aada2d1c9._ = $d318730f8de39247$var$_sha256;
$d318730f8de39247$export$bced8d2aada2d1c9.lock = function() {
    $d318730f8de39247$var$locked256 = true;
};
$d318730f8de39247$export$bced8d2aada2d1c9.register = function(func) {
    if ($d318730f8de39247$var$locked256) throw new Error("sha256 is locked");
    $d318730f8de39247$var$__sha256 = func;
};
Object.freeze($d318730f8de39247$export$bced8d2aada2d1c9);
function $d318730f8de39247$export$a888d2532e6dc7bb(_data) {
    const data = (0, $8Cy13.getBytes)(_data, "data");
    return (0, $8Cy13.hexlify)($d318730f8de39247$var$__sha512(data));
}
$d318730f8de39247$export$a888d2532e6dc7bb._ = $d318730f8de39247$var$_sha512;
$d318730f8de39247$export$a888d2532e6dc7bb.lock = function() {
    $d318730f8de39247$var$locked512 = true;
};
$d318730f8de39247$export$a888d2532e6dc7bb.register = function(func) {
    if ($d318730f8de39247$var$locked512) throw new Error("sha512 is locked");
    $d318730f8de39247$var$__sha512 = func;
};
Object.freeze($d318730f8de39247$export$bced8d2aada2d1c9);

});

parcelRegister("a8s1f", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $761062c457f5b164$export$21643ca94aed3e83; });
/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ 
var $e9jdX = parcelRequire("e9jdX");

var $g6m4b = parcelRequire("g6m4b");
var $8Cy13 = parcelRequire("8Cy13");
var $b1Qj1 = parcelRequire("b1Qj1");

var $fWvq9 = parcelRequire("fWvq9");
class $761062c457f5b164$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $g6m4b.assertArgument)((0, $8Cy13.dataLength)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $8Cy13.hexlify)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $g6m4b.assertArgument)((0, $8Cy13.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $e9jdX.secp256k1).sign((0, $8Cy13.getBytesCopy)(digest), (0, $8Cy13.getBytesCopy)(this.#privateKey), {
            lowS: true
        });
        return (0, $fWvq9.Signature).from({
            r: (0, $b1Qj1.toBeHex)(sig.r, 32),
            s: (0, $b1Qj1.toBeHex)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $761062c457f5b164$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $8Cy13.hexlify)((0, $e9jdX.secp256k1).getSharedSecret((0, $8Cy13.getBytesCopy)(this.#privateKey), (0, $8Cy13.getBytes)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $8Cy13.getBytes)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, $e9jdX.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, $8Cy13.hexlify)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, $e9jdX.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, $8Cy13.hexlify)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $g6m4b.assertArgument)((0, $8Cy13.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $fWvq9.Signature).from(signature);
        let secpSig = (0, $e9jdX.secp256k1).Signature.fromCompact((0, $8Cy13.getBytesCopy)((0, $8Cy13.concat)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, $8Cy13.getBytesCopy)(digest));
        (0, $g6m4b.assertArgument)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, $e9jdX.secp256k1).ProjectivePoint.fromHex($761062c457f5b164$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = (0, $e9jdX.secp256k1).ProjectivePoint.fromHex($761062c457f5b164$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}

});
parcelRegister("e9jdX", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $a4d0d17353f73836$export$529e6123e9353a90; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $kHnZL = parcelRequire("kHnZL");

var $9mdbq = parcelRequire("9mdbq");

var $2EDIM = parcelRequire("2EDIM");

var $f6yZP = parcelRequire("f6yZP");

var $eCCek = parcelRequire("eCCek");

var $fl4xx = parcelRequire("fl4xx");

var $47y4K = parcelRequire("47y4K");
const $a4d0d17353f73836$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $a4d0d17353f73836$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $a4d0d17353f73836$var$_1n = BigInt(1);
const $a4d0d17353f73836$var$_2n = BigInt(2);
const $a4d0d17353f73836$var$divNearest = (a, b)=>(a + b / $a4d0d17353f73836$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $a4d0d17353f73836$var$sqrtMod(y) {
    const P = $a4d0d17353f73836$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2EDIM.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2EDIM.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2EDIM.pow2)(b9, $a4d0d17353f73836$var$_2n, P) * b2 % P;
    const b22 = (0, $2EDIM.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2EDIM.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2EDIM.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2EDIM.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2EDIM.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2EDIM.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2EDIM.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2EDIM.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2EDIM.pow2)(t2, $a4d0d17353f73836$var$_2n, P);
    if (!$a4d0d17353f73836$var$Fp.eql($a4d0d17353f73836$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $a4d0d17353f73836$var$Fp = (0, $2EDIM.Field)($a4d0d17353f73836$var$secp256k1P, undefined, undefined, {
    sqrt: $a4d0d17353f73836$var$sqrtMod
});
const $a4d0d17353f73836$export$529e6123e9353a90 = (0, $47y4K.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $a4d0d17353f73836$var$Fp,
    n: $a4d0d17353f73836$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $a4d0d17353f73836$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$a4d0d17353f73836$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $a4d0d17353f73836$var$divNearest(b2 * k, n);
            const c2 = $a4d0d17353f73836$var$divNearest(-b1 * k, n);
            let k1 = (0, $2EDIM.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2EDIM.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $kHnZL.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $a4d0d17353f73836$var$_0n = BigInt(0);
const $a4d0d17353f73836$var$fe = (x)=>typeof x === "bigint" && $a4d0d17353f73836$var$_0n < x && x < $a4d0d17353f73836$var$secp256k1P;
const $a4d0d17353f73836$var$ge = (x)=>typeof x === "bigint" && $a4d0d17353f73836$var$_0n < x && x < $a4d0d17353f73836$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $a4d0d17353f73836$var$TAGGED_HASH_PREFIXES = {};
function $a4d0d17353f73836$var$taggedHash(tag, ...messages) {
    let tagP = $a4d0d17353f73836$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $kHnZL.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $eCCek.concatBytes)(tagH, tagH);
        $a4d0d17353f73836$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $kHnZL.sha256)((0, $eCCek.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $a4d0d17353f73836$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $a4d0d17353f73836$var$numTo32b = (n)=>(0, $eCCek.numberToBytesBE)(n, 32);
const $a4d0d17353f73836$var$modP = (x)=>(0, $2EDIM.mod)(x, $a4d0d17353f73836$var$secp256k1P);
const $a4d0d17353f73836$var$modN = (x)=>(0, $2EDIM.mod)(x, $a4d0d17353f73836$var$secp256k1N);
const $a4d0d17353f73836$var$Point = $a4d0d17353f73836$export$529e6123e9353a90.ProjectivePoint;
const $a4d0d17353f73836$var$GmulAdd = (Q, a, b)=>$a4d0d17353f73836$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $a4d0d17353f73836$var$schnorrGetExtPubKey(priv) {
    let d_ = $a4d0d17353f73836$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $a4d0d17353f73836$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $a4d0d17353f73836$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $a4d0d17353f73836$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $a4d0d17353f73836$var$lift_x(x) {
    if (!$a4d0d17353f73836$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $a4d0d17353f73836$var$modP(x * x);
    const c = $a4d0d17353f73836$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $a4d0d17353f73836$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $a4d0d17353f73836$var$_2n !== $a4d0d17353f73836$var$_0n) y = $a4d0d17353f73836$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $a4d0d17353f73836$var$Point(x, y, $a4d0d17353f73836$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $a4d0d17353f73836$var$challenge(...args) {
    return $a4d0d17353f73836$var$modN((0, $eCCek.bytesToNumberBE)($a4d0d17353f73836$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $a4d0d17353f73836$var$schnorrGetPublicKey(privateKey) {
    return $a4d0d17353f73836$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $a4d0d17353f73836$var$schnorrSign(message, privateKey, auxRand = (0, $9mdbq.randomBytes)(32)) {
    const m = (0, $eCCek.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $a4d0d17353f73836$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $eCCek.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $a4d0d17353f73836$var$numTo32b(d ^ (0, $eCCek.bytesToNumberBE)($a4d0d17353f73836$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $a4d0d17353f73836$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $a4d0d17353f73836$var$modN((0, $eCCek.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $a4d0d17353f73836$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $a4d0d17353f73836$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $a4d0d17353f73836$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($a4d0d17353f73836$var$numTo32b($a4d0d17353f73836$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$a4d0d17353f73836$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $a4d0d17353f73836$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $eCCek.ensureBytes)("signature", signature, 64);
    const m = (0, $eCCek.ensureBytes)("message", message);
    const pub = (0, $eCCek.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $a4d0d17353f73836$var$lift_x((0, $eCCek.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $eCCek.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$a4d0d17353f73836$var$fe(r)) return false;
        const s = (0, $eCCek.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$a4d0d17353f73836$var$ge(s)) return false;
        const e = $a4d0d17353f73836$var$challenge($a4d0d17353f73836$var$numTo32b(r), $a4d0d17353f73836$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $a4d0d17353f73836$var$GmulAdd(P, s, $a4d0d17353f73836$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $a4d0d17353f73836$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $a4d0d17353f73836$var$schnorrGetPublicKey,
        sign: $a4d0d17353f73836$var$schnorrSign,
        verify: $a4d0d17353f73836$var$schnorrVerify,
        utils: {
            randomPrivateKey: $a4d0d17353f73836$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $a4d0d17353f73836$var$lift_x,
            pointToBytes: $a4d0d17353f73836$var$pointToBytes,
            numberToBytesBE: $eCCek.numberToBytesBE,
            bytesToNumberBE: $eCCek.bytesToNumberBE,
            taggedHash: $a4d0d17353f73836$var$taggedHash,
            mod: $2EDIM.mod
        }
    }))();
const $a4d0d17353f73836$var$isoMap = /* @__PURE__ */ (()=>(0, $fl4xx.isogenyMap)($a4d0d17353f73836$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $a4d0d17353f73836$var$mapSWU = /* @__PURE__ */ (()=>(0, $f6yZP.mapToCurveSimpleSWU)($a4d0d17353f73836$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $a4d0d17353f73836$var$Fp.create(BigInt("-11"))
    }))();
const $a4d0d17353f73836$var$htf = /* @__PURE__ */ (()=>(0, $fl4xx.createHasher)($a4d0d17353f73836$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $a4d0d17353f73836$var$mapSWU($a4d0d17353f73836$var$Fp.create(scalars[0]));
        return $a4d0d17353f73836$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $a4d0d17353f73836$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $kHnZL.sha256)
    }))();
const $a4d0d17353f73836$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$a4d0d17353f73836$var$htf.hashToCurve)();
const $a4d0d17353f73836$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$a4d0d17353f73836$var$htf.encodeToCurve)();

});
parcelRegister("2EDIM", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $1eee20fe136dd081$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow2", function () { return $1eee20fe136dd081$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $1eee20fe136dd081$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "validateField", function () { return $1eee20fe136dd081$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $1eee20fe136dd081$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $1eee20fe136dd081$export$a455218a85c89869; });
$parcel$export(module.exports, "getMinHashLength", function () { return $1eee20fe136dd081$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $1eee20fe136dd081$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $eCCek = parcelRequire("eCCek");
// prettier-ignore
const $1eee20fe136dd081$var$_0n = BigInt(0), $1eee20fe136dd081$var$_1n = BigInt(1), $1eee20fe136dd081$var$_2n = BigInt(2), $1eee20fe136dd081$var$_3n = BigInt(3);
// prettier-ignore
const $1eee20fe136dd081$var$_4n = BigInt(4), $1eee20fe136dd081$var$_5n = BigInt(5), $1eee20fe136dd081$var$_8n = BigInt(8);
// prettier-ignore
const $1eee20fe136dd081$var$_9n = BigInt(9), $1eee20fe136dd081$var$_16n = BigInt(16);
function $1eee20fe136dd081$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $1eee20fe136dd081$var$_0n ? result : b + result;
}
function $1eee20fe136dd081$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $1eee20fe136dd081$var$_0n || power < $1eee20fe136dd081$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1eee20fe136dd081$var$_1n) return $1eee20fe136dd081$var$_0n;
    let res = $1eee20fe136dd081$var$_1n;
    while(power > $1eee20fe136dd081$var$_0n){
        if (power & $1eee20fe136dd081$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1eee20fe136dd081$var$_1n;
    }
    return res;
}
function $1eee20fe136dd081$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $1eee20fe136dd081$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $1eee20fe136dd081$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $1eee20fe136dd081$var$_0n || modulo <= $1eee20fe136dd081$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1eee20fe136dd081$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1eee20fe136dd081$var$_0n, y = $1eee20fe136dd081$var$_1n, u = $1eee20fe136dd081$var$_1n, v = $1eee20fe136dd081$var$_0n;
    while(a !== $1eee20fe136dd081$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1eee20fe136dd081$var$_1n) throw new Error("invert: does not exist");
    return $1eee20fe136dd081$export$842a2cf37af977e1(x, modulo);
}
function $1eee20fe136dd081$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1eee20fe136dd081$var$_1n) / $1eee20fe136dd081$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1eee20fe136dd081$var$_1n, S = 0; Q % $1eee20fe136dd081$var$_2n === $1eee20fe136dd081$var$_0n; Q /= $1eee20fe136dd081$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1eee20fe136dd081$var$_2n; Z < P && $1eee20fe136dd081$export$9c297f60e22e3389(Z, legendreC, P) !== P - $1eee20fe136dd081$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1eee20fe136dd081$var$_1n) / $1eee20fe136dd081$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1eee20fe136dd081$var$_1n) / $1eee20fe136dd081$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1eee20fe136dd081$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $1eee20fe136dd081$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1eee20fe136dd081$var$_4n === $1eee20fe136dd081$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1eee20fe136dd081$var$_1n) / $1eee20fe136dd081$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1eee20fe136dd081$var$_8n === $1eee20fe136dd081$var$_5n) {
        const c1 = (P - $1eee20fe136dd081$var$_5n) / $1eee20fe136dd081$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1eee20fe136dd081$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1eee20fe136dd081$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1eee20fe136dd081$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1eee20fe136dd081$export$69f29ab1f3e9a234(P);
}
const $1eee20fe136dd081$export$7806f13ad5078b2f = (num, modulo)=>($1eee20fe136dd081$export$842a2cf37af977e1(num, modulo) & $1eee20fe136dd081$var$_1n) === $1eee20fe136dd081$var$_1n;
// prettier-ignore
const $1eee20fe136dd081$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1eee20fe136dd081$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1eee20fe136dd081$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $eCCek.validateObject)(field, opts);
}
function $1eee20fe136dd081$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1eee20fe136dd081$var$_0n) throw new Error("Expected power > 0");
    if (power === $1eee20fe136dd081$var$_0n) return f.ONE;
    if (power === $1eee20fe136dd081$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1eee20fe136dd081$var$_0n){
        if (power & $1eee20fe136dd081$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1eee20fe136dd081$var$_1n;
    }
    return p;
}
function $1eee20fe136dd081$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $1eee20fe136dd081$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1eee20fe136dd081$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $1eee20fe136dd081$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $1eee20fe136dd081$var$_1n) / $1eee20fe136dd081$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $1eee20fe136dd081$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $1eee20fe136dd081$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1eee20fe136dd081$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1eee20fe136dd081$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1eee20fe136dd081$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $eCCek.bitMask)(BITS),
        ZERO: $1eee20fe136dd081$var$_0n,
        ONE: $1eee20fe136dd081$var$_1n,
        create: (num)=>$1eee20fe136dd081$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1eee20fe136dd081$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1eee20fe136dd081$var$_0n,
        isOdd: (num)=>(num & $1eee20fe136dd081$var$_1n) === $1eee20fe136dd081$var$_1n,
        neg: (num)=>$1eee20fe136dd081$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1eee20fe136dd081$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$1eee20fe136dd081$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1eee20fe136dd081$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1eee20fe136dd081$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$1eee20fe136dd081$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$1eee20fe136dd081$export$842a2cf37af977e1(lhs * $1eee20fe136dd081$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1eee20fe136dd081$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1eee20fe136dd081$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $eCCek.numberToBytesLE)(num, BYTES) : (0, $eCCek.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $eCCek.bytesToNumberLE)(bytes) : (0, $eCCek.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $1eee20fe136dd081$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $1eee20fe136dd081$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $1eee20fe136dd081$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $eCCek.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1eee20fe136dd081$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $eCCek.bytesToNumberLE)(hash) : (0, $eCCek.bytesToNumberBE)(hash);
    return $1eee20fe136dd081$export$842a2cf37af977e1(num, groupOrder - $1eee20fe136dd081$var$_1n) + $1eee20fe136dd081$var$_1n;
}
function $1eee20fe136dd081$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $1eee20fe136dd081$export$d058763b563056af(fieldOrder) {
    const length = $1eee20fe136dd081$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $1eee20fe136dd081$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1eee20fe136dd081$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $1eee20fe136dd081$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $eCCek.bytesToNumberBE)(key) : (0, $eCCek.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1eee20fe136dd081$export$842a2cf37af977e1(num, fieldOrder - $1eee20fe136dd081$var$_1n) + $1eee20fe136dd081$var$_1n;
    return isLE ? (0, $eCCek.numberToBytesLE)(reduced, fieldLen) : (0, $eCCek.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("eCCek", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $aa52450698464a9a$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $aa52450698464a9a$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $aa52450698464a9a$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $aa52450698464a9a$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $aa52450698464a9a$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $aa52450698464a9a$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $aa52450698464a9a$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $aa52450698464a9a$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $aa52450698464a9a$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $aa52450698464a9a$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $aa52450698464a9a$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $aa52450698464a9a$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $aa52450698464a9a$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $aa52450698464a9a$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $aa52450698464a9a$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $aa52450698464a9a$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $aa52450698464a9a$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $aa52450698464a9a$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $aa52450698464a9a$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $aa52450698464a9a$var$_0n = BigInt(0);
const $aa52450698464a9a$var$_1n = BigInt(1);
const $aa52450698464a9a$var$_2n = BigInt(2);
const $aa52450698464a9a$var$u8a = (a)=>a instanceof Uint8Array;
const $aa52450698464a9a$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $aa52450698464a9a$export$58b867e287a802c8(bytes) {
    if (!$aa52450698464a9a$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $aa52450698464a9a$var$hexes[bytes[i]];
    return hex;
}
function $aa52450698464a9a$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $aa52450698464a9a$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $aa52450698464a9a$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $aa52450698464a9a$export$d609354794974f8(bytes) {
    return $aa52450698464a9a$export$d57f2bacc26b4249($aa52450698464a9a$export$58b867e287a802c8(bytes));
}
function $aa52450698464a9a$export$d67b1d03392107e7(bytes) {
    if (!$aa52450698464a9a$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $aa52450698464a9a$export$d57f2bacc26b4249($aa52450698464a9a$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $aa52450698464a9a$export$1459dafd057611cb(n, len) {
    return $aa52450698464a9a$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $aa52450698464a9a$export$ba2172e58d139f6d(n, len) {
    return $aa52450698464a9a$export$1459dafd057611cb(n, len).reverse();
}
function $aa52450698464a9a$export$80ee8c1914de6dde(n) {
    return $aa52450698464a9a$export$31c96b9df38bc8d4($aa52450698464a9a$export$4ed2545b622827c1(n));
}
function $aa52450698464a9a$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $aa52450698464a9a$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($aa52450698464a9a$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $aa52450698464a9a$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$aa52450698464a9a$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $aa52450698464a9a$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $aa52450698464a9a$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $aa52450698464a9a$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $aa52450698464a9a$var$_0n; n >>= $aa52450698464a9a$var$_1n, len += 1);
    return len;
}
function $aa52450698464a9a$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $aa52450698464a9a$var$_1n;
}
const $aa52450698464a9a$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $aa52450698464a9a$var$_1n : $aa52450698464a9a$var$_0n) << BigInt(pos);
};
const $aa52450698464a9a$export$803efa2fa1c7279 = (n)=>($aa52450698464a9a$var$_2n << BigInt(n - 1)) - $aa52450698464a9a$var$_1n;
// DRBG
const $aa52450698464a9a$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $aa52450698464a9a$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $aa52450698464a9a$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $aa52450698464a9a$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $aa52450698464a9a$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $aa52450698464a9a$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($aa52450698464a9a$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($aa52450698464a9a$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $aa52450698464a9a$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $aa52450698464a9a$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $aa52450698464a9a$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $aa52450698464a9a$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("f6yZP", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $aff2900e63573b35$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $aff2900e63573b35$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $2EDIM = parcelRequire("2EDIM");

var $eCCek = parcelRequire("eCCek");

var $tEskq = parcelRequire("tEskq");
function $aff2900e63573b35$var$validatePointOpts(curve) {
    const opts = (0, $tEskq.validateBasic)(curve);
    $eCCek.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $aff2900e63573b35$var$b2n, hexToBytes: $aff2900e63573b35$var$h2b } = $eCCek;
const $aff2900e63573b35$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $aff2900e63573b35$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $aff2900e63573b35$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $aff2900e63573b35$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $aff2900e63573b35$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $aff2900e63573b35$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $aff2900e63573b35$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $aff2900e63573b35$var$_0n = BigInt(0), $aff2900e63573b35$var$_1n = BigInt(1), $aff2900e63573b35$var$_2n = BigInt(2), $aff2900e63573b35$var$_3n = BigInt(3), $aff2900e63573b35$var$_4n = BigInt(4);
function $aff2900e63573b35$export$fa783af82e4fe0fc(opts) {
    const CURVE = $aff2900e63573b35$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $eCCek.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $aff2900e63573b35$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $eCCek.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $eCCek.bytesToNumberBE((0, $eCCek.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $2EDIM.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $eCCek.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $aff2900e63573b35$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $aff2900e63573b35$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $aff2900e63573b35$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $aff2900e63573b35$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $aff2900e63573b35$var$_0n || k2 > $aff2900e63573b35$var$_0n){
                if (k1 & $aff2900e63573b35$var$_1n) k1p = k1p.add(d);
                if (k2 & $aff2900e63573b35$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $aff2900e63573b35$var$_1n;
                k2 >>= $aff2900e63573b35$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $aff2900e63573b35$var$_0n || a === $aff2900e63573b35$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $aff2900e63573b35$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $aff2900e63573b35$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $eCCek.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $tEskq.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $aff2900e63573b35$var$validateOpts(curve) {
    const opts = (0, $tEskq.validateBasic)(curve);
    $eCCek.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $aff2900e63573b35$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $aff2900e63573b35$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $aff2900e63573b35$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $2EDIM.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $2EDIM.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $aff2900e63573b35$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $eCCek.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $eCCek.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $aff2900e63573b35$var$_1n) === $aff2900e63573b35$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$eCCek.bytesToHex($eCCek.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $aff2900e63573b35$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$eCCek.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $eCCek.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $aff2900e63573b35$export$56ac33195d7076db.toSig((0, $eCCek.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $eCCek.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $eCCek.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $aff2900e63573b35$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $eCCek.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $2EDIM.getMinHashLength(CURVE.n);
            return $2EDIM.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $eCCek.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $eCCek.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($aff2900e63573b35$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $eCCek.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $eCCek.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $eCCek.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $eCCek.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $eCCek.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $aff2900e63573b35$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $aff2900e63573b35$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $aff2900e63573b35$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $eCCek.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $eCCek.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $eCCek.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $aff2900e63573b35$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $aff2900e63573b35$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $aff2900e63573b35$var$_0n;
    for(let o = q - $aff2900e63573b35$var$_1n; o % $aff2900e63573b35$var$_2n === $aff2900e63573b35$var$_0n; o /= $aff2900e63573b35$var$_2n)l += $aff2900e63573b35$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $aff2900e63573b35$var$_2n << c1 - $aff2900e63573b35$var$_1n - $aff2900e63573b35$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $aff2900e63573b35$var$_2n;
    const c2 = (q - $aff2900e63573b35$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $aff2900e63573b35$var$_1n) / $aff2900e63573b35$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $aff2900e63573b35$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $aff2900e63573b35$var$_1n) / $aff2900e63573b35$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $aff2900e63573b35$var$_1n; i--){
            let tv5 = i - $aff2900e63573b35$var$_2n; // 18.    tv5 = i - 2
            tv5 = $aff2900e63573b35$var$_2n << tv5 - $aff2900e63573b35$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $aff2900e63573b35$var$_4n === $aff2900e63573b35$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $aff2900e63573b35$var$_3n) / $aff2900e63573b35$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $aff2900e63573b35$export$cc7fea9756a17416(Fp, opts) {
    $2EDIM.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $aff2900e63573b35$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("tEskq", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $2EDIM = parcelRequire("2EDIM");

var $eCCek = parcelRequire("eCCek");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $2EDIM.validateField)(curve.Fp);
    (0, $eCCek.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2EDIM.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("fl4xx", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", function () { return $b2ac56b605f23610$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $b2ac56b605f23610$export$14b114effbc08b6b; });

var $2EDIM = parcelRequire("2EDIM");

var $eCCek = parcelRequire("eCCek");
function $b2ac56b605f23610$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $eCCek.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $b2ac56b605f23610$var$os2ip = (0, $eCCek.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $b2ac56b605f23610$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $b2ac56b605f23610$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $b2ac56b605f23610$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $b2ac56b605f23610$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $b2ac56b605f23610$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $b2ac56b605f23610$var$isBytes(msg);
    $b2ac56b605f23610$var$isBytes(DST);
    $b2ac56b605f23610$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $eCCek.concatBytes)((0, $eCCek.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $eCCek.concatBytes)(DST, $b2ac56b605f23610$var$i2osp(DST.length, 1));
    const Z_pad = $b2ac56b605f23610$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $b2ac56b605f23610$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $eCCek.concatBytes)(Z_pad, msg, l_i_b_str, $b2ac56b605f23610$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $eCCek.concatBytes)(b_0, $b2ac56b605f23610$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $b2ac56b605f23610$var$strxor(b_0, b[i - 1]),
            $b2ac56b605f23610$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $eCCek.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $eCCek.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $b2ac56b605f23610$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $b2ac56b605f23610$var$isBytes(msg);
    $b2ac56b605f23610$var$isBytes(DST);
    $b2ac56b605f23610$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $eCCek.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($b2ac56b605f23610$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($b2ac56b605f23610$var$i2osp(DST.length, 1)).digest();
}
function $b2ac56b605f23610$export$97cdd5ee18de8172(msg, count, options) {
    (0, $eCCek.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $b2ac56b605f23610$var$isBytes(msg);
    $b2ac56b605f23610$var$isNum(count);
    const DST = $b2ac56b605f23610$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $b2ac56b605f23610$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $b2ac56b605f23610$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2EDIM.mod)($b2ac56b605f23610$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $b2ac56b605f23610$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $b2ac56b605f23610$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $b2ac56b605f23610$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $b2ac56b605f23610$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("47y4K", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $30023f8e8645eec6$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $9KVQy = parcelRequire("9KVQy");

var $9mdbq = parcelRequire("9mdbq");

var $f6yZP = parcelRequire("f6yZP");
function $30023f8e8645eec6$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $9KVQy.hmac)(hash, key, (0, $9mdbq.concatBytes)(...msgs)),
        randomBytes: $9mdbq.randomBytes
    };
}
function $30023f8e8645eec6$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $f6yZP.weierstrass)({
            ...curveDef,
            ...$30023f8e8645eec6$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});


parcelRegister("b1Qj1", function(module, exports) {

$parcel$export(module.exports, "fromTwos", function () { return $80785c90802caadd$export$92182edcfa20e5bc; });
$parcel$export(module.exports, "getNumber", function () { return $80785c90802caadd$export$b14f2714108df84; });
$parcel$export(module.exports, "toTwos", function () { return $80785c90802caadd$export$7101cd4e6275351c; });
$parcel$export(module.exports, "getBigInt", function () { return $80785c90802caadd$export$61fe455e2b1e28a4; });
$parcel$export(module.exports, "mask", function () { return $80785c90802caadd$export$d99f0801a68bbcf1; });
$parcel$export(module.exports, "toBigInt", function () { return $80785c90802caadd$export$c221a145703ab783; });
$parcel$export(module.exports, "toNumber", function () { return $80785c90802caadd$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "toBeHex", function () { return $80785c90802caadd$export$c6ebe05badb16181; });
$parcel$export(module.exports, "toBeArray", function () { return $80785c90802caadd$export$b627fcfb5ea68cb0; });
$parcel$export(module.exports, "toQuantity", function () { return $80785c90802caadd$export$d9c067986dbc68dd; });
/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 
var $8Cy13 = parcelRequire("8Cy13");

var $g6m4b = parcelRequire("g6m4b");
const $80785c90802caadd$var$BN_0 = BigInt(0);
const $80785c90802caadd$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $80785c90802caadd$var$maxValue = 0x1fffffffffffff;
function $80785c90802caadd$export$92182edcfa20e5bc(_value, _width) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($80785c90802caadd$export$b14f2714108df84(_width, "width"));
    (0, $g6m4b.assert)(value >> width === $80785c90802caadd$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $80785c90802caadd$var$BN_1) {
        const mask = ($80785c90802caadd$var$BN_1 << width) - $80785c90802caadd$var$BN_1;
        return -((~value & mask) + $80785c90802caadd$var$BN_1);
    }
    return value;
}
function $80785c90802caadd$export$7101cd4e6275351c(_value, _width) {
    let value = $80785c90802caadd$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($80785c90802caadd$export$b14f2714108df84(_width, "width"));
    const limit = $80785c90802caadd$var$BN_1 << width - $80785c90802caadd$var$BN_1;
    if (value < $80785c90802caadd$var$BN_0) {
        value = -value;
        (0, $g6m4b.assert)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($80785c90802caadd$var$BN_1 << width) - $80785c90802caadd$var$BN_1;
        return (~value & mask) + $80785c90802caadd$var$BN_1;
    } else (0, $g6m4b.assert)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $80785c90802caadd$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($80785c90802caadd$export$b14f2714108df84(_bits, "bits"));
    return value & ($80785c90802caadd$var$BN_1 << bits) - $80785c90802caadd$var$BN_1;
}
function $80785c90802caadd$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $g6m4b.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $g6m4b.assertArgument)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $g6m4b.assertArgument)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $g6m4b.assertArgument)(false, "invalid BigNumberish value", name || "value", value);
}
function $80785c90802caadd$export$8677d6ca9282a154(value, name) {
    const result = $80785c90802caadd$export$61fe455e2b1e28a4(value, name);
    (0, $g6m4b.assert)(result >= $80785c90802caadd$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $80785c90802caadd$var$Nibbles = "0123456789abcdef";
function $80785c90802caadd$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $80785c90802caadd$var$Nibbles[v >> 4];
            result += $80785c90802caadd$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $80785c90802caadd$export$61fe455e2b1e28a4(value);
}
function $80785c90802caadd$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $g6m4b.assertArgument)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $g6m4b.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $g6m4b.assertArgument)(value >= -$80785c90802caadd$var$maxValue && value <= $80785c90802caadd$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $80785c90802caadd$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $g6m4b.assertArgument)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $g6m4b.assertArgument)(false, "invalid numeric value", name || "value", value);
}
function $80785c90802caadd$export$a0a81dc3380ce7d3(value) {
    return $80785c90802caadd$export$b14f2714108df84($80785c90802caadd$export$c221a145703ab783(value));
}
function $80785c90802caadd$export$c6ebe05badb16181(_value, _width) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $80785c90802caadd$export$b14f2714108df84(_width, "width");
        (0, $g6m4b.assert)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $80785c90802caadd$export$b627fcfb5ea68cb0(_value) {
    const value = $80785c90802caadd$export$8677d6ca9282a154(_value, "value");
    if (value === $80785c90802caadd$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $80785c90802caadd$export$d9c067986dbc68dd(value) {
    let result = (0, $8Cy13.hexlify)((0, $8Cy13.isBytesLike)(value) ? value : $80785c90802caadd$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}

});

parcelRegister("fWvq9", function(module, exports) {

$parcel$export(module.exports, "Signature", function () { return $b9b4a54a1598ff6f$export$848620f5f2f26e86; });

var $jnex2 = parcelRequire("jnex2");

var $g6m4b = parcelRequire("g6m4b");
var $8Cy13 = parcelRequire("8Cy13");
var $b1Qj1 = parcelRequire("b1Qj1");
// Constants
const $b9b4a54a1598ff6f$var$BN_0 = BigInt(0);
const $b9b4a54a1598ff6f$var$BN_1 = BigInt(1);
const $b9b4a54a1598ff6f$var$BN_2 = BigInt(2);
const $b9b4a54a1598ff6f$var$BN_27 = BigInt(27);
const $b9b4a54a1598ff6f$var$BN_28 = BigInt(28);
const $b9b4a54a1598ff6f$var$BN_35 = BigInt(35);
const $b9b4a54a1598ff6f$var$_guard = {};
function $b9b4a54a1598ff6f$var$toUint256(value) {
    return (0, $8Cy13.zeroPadValue)((0, $b1Qj1.toBeArray)(value), 32);
}
class $b9b4a54a1598ff6f$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $g6m4b.assertArgument)((0, $8Cy13.dataLength)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $8Cy13.hexlify)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $g6m4b.assertArgument)((0, $8Cy13.dataLength)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $8Cy13.hexlify)(_value);
        (0, $g6m4b.assertArgument)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $b1Qj1.getNumber)(value, "value");
        (0, $g6m4b.assertArgument)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $b9b4a54a1598ff6f$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $8Cy13.getBytes)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $8Cy13.hexlify)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $8Cy13.concat)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $8Cy13.concat)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $g6m4b.assertPrivate)(guard, $b9b4a54a1598ff6f$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $b1Qj1.getBigInt)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $b9b4a54a1598ff6f$var$BN_27 || bv == $b9b4a54a1598ff6f$var$BN_28) return $b9b4a54a1598ff6f$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $g6m4b.assertArgument)(bv >= $b9b4a54a1598ff6f$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $b9b4a54a1598ff6f$var$BN_35) / $b9b4a54a1598ff6f$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $b1Qj1.getBigInt)(chainId) * $b9b4a54a1598ff6f$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $b1Qj1.getBigInt)(v);
        if (bv === $b9b4a54a1598ff6f$var$BN_0 || bv === $b9b4a54a1598ff6f$var$BN_27) return 27;
        if (bv === $b9b4a54a1598ff6f$var$BN_1 || bv === $b9b4a54a1598ff6f$var$BN_28) return 28;
        (0, $g6m4b.assertArgument)(bv >= $b9b4a54a1598ff6f$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $b9b4a54a1598ff6f$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $g6m4b.assertArgument)(check, message, "signature", sig);
        }
        if (sig == null) return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, (0, $jnex2.ZeroHash), (0, $jnex2.ZeroHash), 27);
        if (typeof sig === "string") {
            const bytes = (0, $8Cy13.getBytes)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $8Cy13.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, (0, $8Cy13.hexlify)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $8Cy13.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $b9b4a54a1598ff6f$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, (0, $8Cy13.hexlify)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $b9b4a54a1598ff6f$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $b9b4a54a1598ff6f$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $b9b4a54a1598ff6f$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $8Cy13.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $8Cy13.getBytes)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $8Cy13.hexlify)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $8Cy13.getBytes)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $b1Qj1.getBigInt)(_v);
                return {
                    networkV: v >= $b9b4a54a1598ff6f$var$BN_35 ? v : undefined,
                    v: $b9b4a54a1598ff6f$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $8Cy13.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $8Cy13.getBytes)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $b1Qj1.getNumber)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $b9b4a54a1598ff6f$export$848620f5f2f26e86($b9b4a54a1598ff6f$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $b1Qj1.getNumber)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}

});
parcelRegister("jnex2", function(module, exports) {

$parcel$export(module.exports, "ZeroHash", function () { return $e1ab700abe0d106c$export$89c2533b29c23a61; });
/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $e1ab700abe0d106c$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});







parcelRegister("bHRZL", function(module, exports) {

$parcel$export(module.exports, "getEvmAccounts", function () { return $8958deb27a2a2097$export$785cd5e95d0717c1; });
$parcel$export(module.exports, "subscribeToEvm", function () { return $8958deb27a2a2097$export$dae4ecb17c5c4020; });
$parcel$export(module.exports, "canEagerlyConnectToEvm", function () { return $8958deb27a2a2097$export$4e65aae37dd4fc2c; });
$parcel$export(module.exports, "switchNetworkForEvm", function () { return $8958deb27a2a2097$export$394219efce660c44; });
$parcel$export(module.exports, "getNetworkInstance", function () { return $8958deb27a2a2097$export$2029b78bc980a576; });
$parcel$export(module.exports, "canSwitchNetworkToEvm", function () { return $8958deb27a2a2097$export$86abff8ce014c125; });
$parcel$export(module.exports, "chooseInstance", function () { return $8958deb27a2a2097$export$b1eab42bc9b6c7a3; });
$parcel$export(module.exports, "getEvmProvider", function () { return $8958deb27a2a2097$export$2515b173249f2353; });
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $7aYgM = parcelRequire("7aYgM");
parcelRequire("yEwlv");
var $8aS14 = parcelRequire("8aS14");
async function $8958deb27a2a2097$export$785cd5e95d0717c1(instance) {
    const [accounts, chainId] = await Promise.all([
        instance.request({
            method: "eth_requestAccounts"
        }),
        instance.request({
            method: "eth_chainId"
        })
    ]);
    return {
        accounts: accounts,
        chainId: chainId
    };
}
const $8958deb27a2a2097$export$dae4ecb17c5c4020 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (addresses)=>{
        /*
     * TODO: after enabling autoconnect, we can consider this condition
     * to be removed.
     * The problem was if a user already connected its wallet,
     * Metamask is triggering this event on first load, so when autoconnect is disabled,
     * it's automaticlally change the state of wallet to `connected`.
     */ if (state.connected) updateAccounts(addresses);
    };
    const handleChainChanged = (chainId)=>{
        updateChainId(chainId);
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    instance?.on?.("chainChanged", handleChainChanged);
    const cleanup = ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
        instance?.off?.("chainChanged", handleChainChanged);
    };
    return cleanup;
};
const $8958deb27a2a2097$export$4e65aae37dd4fc2c = async ({ instance: instance })=>{
    try {
        const accounts = await instance.request({
            method: "eth_accounts"
        });
        if (accounts.length) return true;
        return false;
    } catch (error) {
        return false;
    }
};
const $8958deb27a2a2097$export$394219efce660c44 = async ({ instance: instance, network: network, meta: meta })=>{
    const evmBlockchains = meta.filter((0, $21GQj.isEvmBlockchain));
    const evmInstance = $8958deb27a2a2097$export$2029b78bc980a576(instance, (0, $8aS14.LegacyNetworks).ETHEREUM);
    await (0, $7aYgM.switchOrAddNetworkForMetamaskCompatibleWallets)(evmInstance, network, (0, $7aYgM.convertEvmBlockchainMetaToEvmChainInfo)(evmBlockchains));
};
const $8958deb27a2a2097$export$86abff8ce014c125 = ({ network: network, meta: meta })=>{
    return $8958deb27a2a2097$export$9c76cdd331bb450e(meta).includes(network);
};
function $8958deb27a2a2097$export$9c76cdd331bb450e(meta) {
    return meta.filter((0, $21GQj.isEvmBlockchain)).map((blockchain)=>blockchain.name);
}
function $8958deb27a2a2097$export$d1cfcb1ce8ae2e4e(network, meta) {
    if (!network) return null;
    const evmBlockchains = $8958deb27a2a2097$export$9c76cdd331bb450e(meta);
    return evmBlockchains.includes(network) ? (0, $8aS14.LegacyNetworks).ETHEREUM : null;
}
function $8958deb27a2a2097$var$isEvmNetwork(network, meta) {
    if (!network) return false;
    return $8958deb27a2a2097$export$9c76cdd331bb450e(meta).includes(network);
}
function $8958deb27a2a2097$export$b1eab42bc9b6c7a3(instances, meta, network) {
    // If there is no `network` we fallback to default network.
    network = network || (0, $8aS14.LegacyNetworks).ETHEREUM;
    const instance_network_name = $8958deb27a2a2097$var$isEvmNetwork(network, meta) ? $8958deb27a2a2097$export$d1cfcb1ce8ae2e4e(network, meta) : network;
    const instance = !!instances && !!instance_network_name ? instances.get(instance_network_name) : null;
    return instance;
}
function $8958deb27a2a2097$export$2029b78bc980a576(provider, network) {
    return provider.size ? provider.get(network) : provider;
}
function $8958deb27a2a2097$export$2515b173249f2353(providers, type) {
    if (type && providers[type]) {
        // we need this because provider can return an instance or a map of instances, so what you are doing here is try to detect that.
        if (providers[type].size) return providers[type].get((0, $8aS14.LegacyNetworks).ETHEREUM);
        return providers[type];
    }
    return null;
}

});
parcelRegister("14sfz", function(module, exports) {
$parcel$export(module.exports, "cosmosBlockchains", function () { return (parcelRequire("21GQj")).cosmosBlockchains; });
$parcel$export(module.exports, "evmBlockchains", function () { return (parcelRequire("21GQj")).evmBlockchains; });
$parcel$export(module.exports, "isAPIErrorCode", function () { return (parcelRequire("liigz")).isAPIErrorCode; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return (parcelRequire("21GQj")).isCosmosBlockchain; });
$parcel$export(module.exports, "isEvmBlockchain", function () { return (parcelRequire("21GQj")).isEvmBlockchain; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return (parcelRequire("21GQj")).isSolanaBlockchain; });
$parcel$export(module.exports, "solanaBlockchain", function () { return (parcelRequire("21GQj")).solanaBlockchain; });
$parcel$export(module.exports, "starknetBlockchain", function () { return (parcelRequire("21GQj")).starknetBlockchain; });
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("liigz")).TransactionStatus; });
$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("liigz")).TransactionType; });
$parcel$export(module.exports, "tronBlockchain", function () { return (parcelRequire("21GQj")).tronBlockchain; });
$parcel$export(module.exports, "DefaultSignerFactory", function () { return (parcelRequire("5QE4B")).DefaultSignerFactory; });
$parcel$export(module.exports, "isSignerErrorCode", function () { return (parcelRequire("bfeGn")).isSignerErrorCode; });
$parcel$export(module.exports, "RPCErrorCode", function () { return (parcelRequire("bfeGn")).RPCErrorCode; });
$parcel$export(module.exports, "SignerError", function () { return (parcelRequire("bfeGn")).SignerError; });
$parcel$export(module.exports, "SignerErrorCode", function () { return (parcelRequire("bfeGn")).SignerErrorCode; });
$parcel$export(module.exports, "PendingSwapNetworkStatus", function () { return (parcelRequire("aQzGx")).PendingSwapNetworkStatus; });

var $7hCBE = parcelRequire("7hCBE");

var $kVWX9 = parcelRequire("kVWX9");
parcelRequire("gnlTV");
parcelRequire("3fJQS");
parcelRequire("aQzGx");
parcelRequire("2Ob00");

});
parcelRegister("7hCBE", function(module, exports) {
parcelRequire("2VA6f");
parcelRequire("kSEJI");
parcelRequire("dqenc");
parcelRequire("hI2ZG");
parcelRequire("jjKYb");
parcelRequire("jfbiN");

});
parcelRegister("2VA6f", function(module, exports) {

});

parcelRegister("kSEJI", function(module, exports) {

});

parcelRegister("dqenc", function(module, exports) {

});

parcelRegister("hI2ZG", function(module, exports) {
parcelRequire("gnlTV");
var $5napq = parcelRequire("5napq");

});
parcelRegister("gnlTV", function(module, exports) {
$parcel$export(module.exports, "isAPIErrorCode", function () { return (parcelRequire("liigz")).isAPIErrorCode; });
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("liigz")).TransactionStatus; });
$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("liigz")).TransactionType; });
$parcel$export(module.exports, "cosmosBlockchains", function () { return (parcelRequire("21GQj")).cosmosBlockchains; });
$parcel$export(module.exports, "evmBlockchains", function () { return (parcelRequire("21GQj")).evmBlockchains; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return (parcelRequire("21GQj")).isCosmosBlockchain; });
$parcel$export(module.exports, "isEvmBlockchain", function () { return (parcelRequire("21GQj")).isEvmBlockchain; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return (parcelRequire("21GQj")).isSolanaBlockchain; });
$parcel$export(module.exports, "solanaBlockchain", function () { return (parcelRequire("21GQj")).solanaBlockchain; });
$parcel$export(module.exports, "starknetBlockchain", function () { return (parcelRequire("21GQj")).starknetBlockchain; });
$parcel$export(module.exports, "tronBlockchain", function () { return (parcelRequire("21GQj")).tronBlockchain; });
parcelRequire("hNR5p");
parcelRequire("4OcQc");
parcelRequire("ezs4v");
parcelRequire("5napq");
parcelRequire("liigz");
parcelRequire("4qGwj");
parcelRequire("21GQj");

});
parcelRegister("hNR5p", function(module, exports) {

});

parcelRegister("4OcQc", function(module, exports) {

});

parcelRegister("ezs4v", function(module, exports) {

});

parcelRegister("5napq", function(module, exports) {
/**
 * Routing Result Type
 *
 */ var $3e972cc6b9abb0af$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
    RoutingResultType["HIGH_IMPACT_FOR_CREATE_TX"] = "HIGH_IMPACT_FOR_CREATE_TX";
})($3e972cc6b9abb0af$export$9244fb3192b4c649 || ($3e972cc6b9abb0af$export$9244fb3192b4c649 = {}));

});

parcelRegister("liigz", function(module, exports) {

$parcel$export(module.exports, "TransactionType", function () { return $f80972bafa11a845$export$d513b00599f845d4; });
$parcel$export(module.exports, "isAPIErrorCode", function () { return $f80972bafa11a845$export$882b4f79e45cc211; });
$parcel$export(module.exports, "TransactionStatus", function () { return $f80972bafa11a845$export$7c391bd3b61d2374; });
/**
 * The type of transaction
 */ var $f80972bafa11a845$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($f80972bafa11a845$export$d513b00599f845d4 || ($f80972bafa11a845$export$d513b00599f845d4 = {}));
var $f80972bafa11a845$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($f80972bafa11a845$export$d5c0ec10a1bea971 || ($f80972bafa11a845$export$d5c0ec10a1bea971 = {}));
function $f80972bafa11a845$export$882b4f79e45cc211(value) {
    return [
        "TX_FAIL",
        "TX_EXPIRED",
        "FETCH_TX_FAILED",
        "USER_REJECT",
        "USER_CANCEL",
        "USER_CANCELED_TX",
        "CALL_WALLET_FAILED",
        "SEND_TX_FAILED",
        "CALL_OR_SEND_FAILED",
        "TX_FAILED_IN_BLOCKCHAIN",
        "CLIENT_UNEXPECTED_BEHAVIOUR",
        "INSUFFICIENT_APPROVE"
    ].includes(value);
}
var $f80972bafa11a845$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($f80972bafa11a845$export$7c391bd3b61d2374 || ($f80972bafa11a845$export$7c391bd3b61d2374 = {}));

});

parcelRegister("4qGwj", function(module, exports) {
parcelRequire("1n7KP");
parcelRequire("43yY9");
parcelRequire("aBVr7");
parcelRequire("IHTTe");
parcelRequire("ccXVf");
parcelRequire("kw8f7");
parcelRequire("fbV9H");

});
parcelRegister("1n7KP", function(module, exports) {

});

parcelRegister("43yY9", function(module, exports) {

var $liigz = parcelRequire("liigz");
var $2f42915ed3b151ff$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).COSMOS;
};

});

parcelRegister("aBVr7", function(module, exports) {

var $liigz = parcelRequire("liigz");
var $7b99e9c7c2591649$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).SOLANA;
};

});

parcelRegister("IHTTe", function(module, exports) {

var $liigz = parcelRequire("liigz");
var $086629e3d7fee2fb$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).TRANSFER;
};

});

parcelRegister("ccXVf", function(module, exports) {

});

parcelRegister("kw8f7", function(module, exports) {

var $liigz = parcelRequire("liigz");
var $eefd30ac7339caa4$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).TRON;
};

});

parcelRegister("fbV9H", function(module, exports) {

var $liigz = parcelRequire("liigz");
var $b0f437fa9bf391e1$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($b0f437fa9bf391e1$export$6ef804aee1395a14 || ($b0f437fa9bf391e1$export$6ef804aee1395a14 = {}));
var $b0f437fa9bf391e1$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).TON;
};

});


parcelRegister("21GQj", function(module, exports) {

$parcel$export(module.exports, "isEvmBlockchain", function () { return $179ce86ce5df134d$export$9d749b8b357dfab2; });
$parcel$export(module.exports, "isCosmosBlockchain", function () { return $179ce86ce5df134d$export$d917e9e8a70036a6; });
$parcel$export(module.exports, "isSolanaBlockchain", function () { return $179ce86ce5df134d$export$ff5a0a65a8982bf2; });
$parcel$export(module.exports, "evmBlockchains", function () { return $179ce86ce5df134d$export$e2a694e57950e88e; });
$parcel$export(module.exports, "solanaBlockchain", function () { return $179ce86ce5df134d$export$11a35c42f4dd4832; });
$parcel$export(module.exports, "starknetBlockchain", function () { return $179ce86ce5df134d$export$e1f5443c7a926d0f; });
$parcel$export(module.exports, "tronBlockchain", function () { return $179ce86ce5df134d$export$61a2144ef91f3622; });
$parcel$export(module.exports, "cosmosBlockchains", function () { return $179ce86ce5df134d$export$7a136f0d6bb0d722; });
var $179ce86ce5df134d$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $179ce86ce5df134d$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $179ce86ce5df134d$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $179ce86ce5df134d$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $179ce86ce5df134d$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $179ce86ce5df134d$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $179ce86ce5df134d$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $179ce86ce5df134d$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$9d749b8b357dfab2);
};
var $179ce86ce5df134d$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$ff5a0a65a8982bf2);
};
var $179ce86ce5df134d$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$80db8fd9e7a31db2);
};
var $179ce86ce5df134d$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$744fa0907a94ca40);
};
var $179ce86ce5df134d$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$d917e9e8a70036a6);
};
var $179ce86ce5df134d$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$83b5ebc3a9031095);
};
var $179ce86ce5df134d$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($179ce86ce5df134d$export$9500a92ad5d775aa);
};

});



parcelRegister("jjKYb", function(module, exports) {
parcelRequire("gnlTV");
var $liigz = parcelRequire("liigz");

});

parcelRegister("jfbiN", function(module, exports) {
parcelRequire("jhGZ6");
parcelRequire("5SXi4");
parcelRequire("5XTWT");
parcelRequire("8mKWF");
parcelRequire("iARYc");
parcelRequire("7wT6b");
parcelRequire("gH40X");

});
parcelRegister("jhGZ6", function(module, exports) {
parcelRequire("gnlTV");
var $liigz = parcelRequire("liigz");
var $e0a0f2b3f3bdf52b$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).EVM;
};

});

parcelRegister("5SXi4", function(module, exports) {
parcelRequire("gnlTV");
var $43yY9 = parcelRequire("43yY9");

});

parcelRegister("5XTWT", function(module, exports) {
parcelRequire("gnlTV");
var $IHTTe = parcelRequire("IHTTe");

});

parcelRegister("8mKWF", function(module, exports) {
parcelRequire("gnlTV");
var $aBVr7 = parcelRequire("aBVr7");

});

parcelRegister("iARYc", function(module, exports) {
parcelRequire("gnlTV");
var $kw8f7 = parcelRequire("kw8f7");

});

parcelRegister("7wT6b", function(module, exports) {
parcelRequire("gnlTV");
var $liigz = parcelRequire("liigz");
var $57b64308fc726218$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).STARKNET;
};

});

parcelRegister("gH40X", function(module, exports) {

var $fbV9H = parcelRequire("fbV9H");

});



parcelRegister("kVWX9", function(module, exports) {
parcelRequire("4WqqN");
parcelRequire("1LZ5b");
parcelRequire("cAWP4");
parcelRequire("lekdx");
parcelRequire("JWMoW");
parcelRequire("25g4s");

});
parcelRegister("4WqqN", function(module, exports) {

});

parcelRegister("1LZ5b", function(module, exports) {

});

parcelRegister("cAWP4", function(module, exports) {

});

parcelRegister("lekdx", function(module, exports) {
parcelRequire("gnlTV");
var $5napq = parcelRequire("5napq");

});

parcelRegister("JWMoW", function(module, exports) {

$parcel$export(module.exports, "TransactionType", function () { return (parcelRequire("liigz")).TransactionType; });
parcelRequire("gnlTV");
var $liigz = parcelRequire("liigz");

});

parcelRegister("25g4s", function(module, exports) {
parcelRequire("2NitP");
parcelRequire("htj7m");
parcelRequire("d45uZ");
parcelRequire("ekR0p");
parcelRequire("hsEp7");

});
parcelRegister("2NitP", function(module, exports) {
parcelRequire("JWMoW");
var $liigz = parcelRequire("liigz");
var $208e7e27febabed8$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).EVM;
};

});

parcelRegister("htj7m", function(module, exports) {
parcelRequire("gnlTV");
var $43yY9 = parcelRequire("43yY9");

});

parcelRegister("d45uZ", function(module, exports) {
parcelRequire("gnlTV");
var $IHTTe = parcelRequire("IHTTe");

});

parcelRegister("ekR0p", function(module, exports) {
parcelRequire("gnlTV");
var $aBVr7 = parcelRequire("aBVr7");

});

parcelRegister("hsEp7", function(module, exports) {
parcelRequire("JWMoW");
var $liigz = parcelRequire("liigz");
var $cb6464a2d8c17f55$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $liigz.TransactionType).STARKNET;
};

});



parcelRegister("3fJQS", function(module, exports) {
$parcel$export(module.exports, "isSignerErrorCode", function () { return (parcelRequire("bfeGn")).isSignerErrorCode; });
$parcel$export(module.exports, "RPCErrorCode", function () { return (parcelRequire("bfeGn")).RPCErrorCode; });
$parcel$export(module.exports, "SignerError", function () { return (parcelRequire("bfeGn")).SignerError; });
$parcel$export(module.exports, "SignerErrorCode", function () { return (parcelRequire("bfeGn")).SignerErrorCode; });
$parcel$export(module.exports, "DefaultSignerFactory", function () { return (parcelRequire("5QE4B")).DefaultSignerFactory; });
parcelRequire("bfeGn");
parcelRequire("5QE4B");

});
parcelRegister("bfeGn", function(module, exports) {

$parcel$export(module.exports, "SignerErrorCode", function () { return $82fc7c15948e5c79$export$1105a941ceaa4b25; });
$parcel$export(module.exports, "RPCErrorCode", function () { return $82fc7c15948e5c79$export$618932a85b762ea3; });
$parcel$export(module.exports, "isSignerErrorCode", function () { return $82fc7c15948e5c79$export$be10b575629ad8f; });
$parcel$export(module.exports, "SignerError", function () { return $82fc7c15948e5c79$export$7cc7da8fa05ccee8; });
var $82fc7c15948e5c79$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $82fc7c15948e5c79$var$__assign = undefined && undefined.__assign || function() {
    $82fc7c15948e5c79$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82fc7c15948e5c79$var$__assign.apply(this, arguments);
};
var $82fc7c15948e5c79$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($82fc7c15948e5c79$export$1105a941ceaa4b25 || ($82fc7c15948e5c79$export$1105a941ceaa4b25 = {}));
var $82fc7c15948e5c79$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($82fc7c15948e5c79$export$618932a85b762ea3 || ($82fc7c15948e5c79$export$618932a85b762ea3 = {}));
function $82fc7c15948e5c79$export$be10b575629ad8f(value) {
    return Object.keys($82fc7c15948e5c79$export$1105a941ceaa4b25).includes(value);
}
function $82fc7c15948e5c79$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.REJECTED_BY_USER] = "User rejected the transaction", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.SIGN_TX_ERROR] = "Error signing the transaction", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.SEND_TX_ERROR] = "Error sending the transaction", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = "Operation not implemented", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = "Unsupported operation", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = "Transaction failed in blockchain", _a[$82fc7c15948e5c79$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = "Unexpected error", _a);
    return errorMap[code];
}
var $82fc7c15948e5c79$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $82fc7c15948e5c79$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, cause, context) {
        var _this = _super.call(this, m || $82fc7c15948e5c79$export$714f3eb4b9ca37c5(code), {
            cause: cause
        }) || this;
        _this.name = "SignerError";
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.context = context;
        if (_this.code === $82fc7c15948e5c79$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $82fc7c15948e5c79$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = "User rejected the transaction";
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, "_isSignerError");
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            "rejected by user",
            "rejected by the user",
            "user canceled",
            "user rejected",
            "user denied",
            "request rejected",
            "user abort",
            "disapproved",
            "declined by user"
        ];
        if (!!error && typeof error === "string") for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === "object") {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || "").toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($82fc7c15948e5c79$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($82fc7c15948e5c79$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($82fc7c15948e5c79$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, "Assertion failed: " + m);
    };
    SignerError.prototype.getErrorContext = function() {
        return $82fc7c15948e5c79$var$__assign({
            code: this.code,
            rpcCode: this.rpcCode,
            message: this.message
        }, this.context || {});
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $82fc7c15948e5c79$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || "User rejected the transaction"
        };
        var rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);

});

parcelRegister("5QE4B", function(module, exports) {

$parcel$export(module.exports, "DefaultSignerFactory", function () { return $4420e4c6f33fd05e$export$2006fb7614e99307; });
var $4420e4c6f33fd05e$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error("Signer not found for " + txType);
    };
    return DefaultSignerFactory;
}();

});


parcelRegister("aQzGx", function(module, exports) {

$parcel$export(module.exports, "PendingSwapNetworkStatus", function () { return $7e5a710dc3788f04$export$b1569e7f9d4064a9; });
var $7e5a710dc3788f04$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})($7e5a710dc3788f04$export$b1569e7f9d4064a9 || ($7e5a710dc3788f04$export$b1569e7f9d4064a9 = {}));
var $7e5a710dc3788f04$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($7e5a710dc3788f04$export$bb45678bd9ad9127 || ($7e5a710dc3788f04$export$bb45678bd9ad9127 = {}));

});

parcelRegister("2Ob00", function(module, exports) {
parcelRequire("6iWbz");
parcelRequire("3VYKw");

});
parcelRegister("6iWbz", function(module, exports) {

});

parcelRegister("3VYKw", function(module, exports) {

});




parcelRegister("jN5Ze", function(module, exports) {

$parcel$export(module.exports, "getCosmosExperimentalChainInfo", function () { return $4c04d9d14ae8be7a$export$9a5d8b9457d52deb; });
$parcel$export(module.exports, "getCosmosAccounts", function () { return $4c04d9d14ae8be7a$export$d4d8333f992ebe8c; });
$parcel$export(module.exports, "suggestCosmosChain", function () { return $4c04d9d14ae8be7a$export$d873bd134feb393; });

var $7aYgM = parcelRequire("7aYgM");
const $4c04d9d14ae8be7a$var$getCosmosMainChainsIds = (blockchains)=>blockchains.filter((blockchain)=>blockchain.info && !blockchain.info.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $4c04d9d14ae8be7a$var$getCosmosMiscChainsIds = (blockchains)=>blockchains.filter((blockchain)=>blockchain.info?.experimental).map((blockchain)=>blockchain.chainId).filter((chainId)=>!!chainId);
const $4c04d9d14ae8be7a$export$9a5d8b9457d52deb = (blockchains)=>blockchains.filter((blockchain)=>!!blockchain.info).filter((blockchain)=>!!blockchain.chainId).reduce((cosmosExperimentalChainsInfo, blockchain)=>{
        const info = (0, $7aYgM.deepCopy)(blockchain.info);
        info.stakeCurrency.coinImageUrl = window.location.origin + info.stakeCurrency.coinImageUrl;
        info.currencies = info.currencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        info.feeCurrencies = info.feeCurrencies.map((currency)=>({
                ...currency,
                coinImageUrl: window.location.origin + currency.coinImageUrl
            }));
        if (!info.gasPriceStep) delete info.gasPriceStep;
        const { experimental: experimental, ...otherProperties } = info;
        return cosmosExperimentalChainsInfo[blockchain.name] = {
            id: blockchain.chainId,
            info: {
                ...otherProperties,
                chainId: blockchain.chainId
            },
            experimental: experimental
        }, cosmosExperimentalChainsInfo;
    }, {});
async function $4c04d9d14ae8be7a$var$getMainAccounts({ desiredChainIds: desiredChainIds, instance: instance }) {
    // Trying to get accounts from all chains
    const offlineSigners = desiredChainIds.map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    }).filter(Boolean);
    const accountsPromises = offlineSigners.map(({ signer: signer })=>signer.getAccounts());
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== "fulfilled") return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
async function $4c04d9d14ae8be7a$var$tryRequestMiscAccounts({ excludedChain: excludedChain, instance: instance, meta: meta }) {
    const offlineSigners = $4c04d9d14ae8be7a$var$getCosmosMiscChainsIds(meta).filter((id)=>id !== excludedChain).map((chainId)=>{
        const signer = instance.getOfflineSigner(chainId);
        return {
            signer: signer,
            chainId: chainId
        };
    });
    const accountsPromises = offlineSigners.map(async ({ signer: signer })=>signer.getAccounts());
    const availableAccountForChains = await Promise.allSettled(accountsPromises);
    const resolvedAccounts = [];
    availableAccountForChains.forEach((result, index)=>{
        if (result.status !== "fulfilled") return;
        const accounts = result.value;
        const { chainId: chainId } = offlineSigners[index];
        const addresses = accounts.map((account)=>account.address);
        resolvedAccounts.push({
            accounts: addresses,
            chainId: chainId
        });
    });
    return resolvedAccounts;
}
const $4c04d9d14ae8be7a$export$d4d8333f992ebe8c = async ({ instance: instance, network: network, meta: meta })=>{
    const chainInfo = network ? $4c04d9d14ae8be7a$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!!network && !chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for connect to wallet.
    if (!!chainInfo) await instance.experimentalSuggestChain(chainInfo.info);
    // Getting main chains + target network
    let desiredChainIds = $4c04d9d14ae8be7a$var$getCosmosMainChainsIds(meta);
    if (!!chainInfo) desiredChainIds.push(chainInfo.id);
    desiredChainIds = Array.from(new Set(desiredChainIds)).filter(Boolean);
    await instance.enable(desiredChainIds);
    const mainAccounts = await $4c04d9d14ae8be7a$var$getMainAccounts({
        desiredChainIds: desiredChainIds,
        instance: instance
    });
    const exclude = !!chainInfo ? chainInfo.id : undefined;
    const miscAccounts = exclude ? await $4c04d9d14ae8be7a$var$tryRequestMiscAccounts({
        instance: instance,
        meta: meta,
        excludedChain: exclude
    }) : [];
    const results = [
        ...mainAccounts,
        ...miscAccounts
    ];
    return results;
};
const $4c04d9d14ae8be7a$export$d873bd134feb393 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const chainInfo = network ? $4c04d9d14ae8be7a$export$9a5d8b9457d52deb(meta)[network] : null;
    if (!chainInfo) throw new Error(`You need to add ${network} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    // Asking for add experimental chain to wallet.
    await instance.experimentalSuggestChain(chainInfo.info);
};

});


parcelRegister("1wVs5", function(module, exports) {
"use strict";

});

parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("76r4H", function(module, exports) {

$parcel$export(module.exports, "BigNumber", function () { return $bbbae96a0813d414$export$d97aa349ed20696; });
$parcel$export(module.exports, "default", function () { return $bbbae96a0813d414$export$2e2bcd8739ae039; });
/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $bbbae96a0813d414$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $bbbae96a0813d414$var$mathceil = Math.ceil, $bbbae96a0813d414$var$mathfloor = Math.floor, $bbbae96a0813d414$var$bignumberError = "[BigNumber Error] ", $bbbae96a0813d414$var$tooManyDigits = $bbbae96a0813d414$var$bignumberError + "Number primitive has more than 15 significant digits: ", $bbbae96a0813d414$var$BASE = 1e14, $bbbae96a0813d414$var$LOG_BASE = 14, $bbbae96a0813d414$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$bbbae96a0813d414$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $bbbae96a0813d414$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$bbbae96a0813d414$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $bbbae96a0813d414$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$bbbae96a0813d414$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $bbbae96a0813d414$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($bbbae96a0813d414$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $bbbae96a0813d414$var$MAX_SAFE_INTEGER || v !== $bbbae96a0813d414$var$mathfloor(v))) throw Error($bbbae96a0813d414$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $bbbae96a0813d414$var$LOG_BASE;
                if (e < 0) i += $bbbae96a0813d414$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $bbbae96a0813d414$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $bbbae96a0813d414$var$LOG_BASE));
                    i = $bbbae96a0813d414$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $bbbae96a0813d414$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $bbbae96a0813d414$var$intCheck(v, 0, $bbbae96a0813d414$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $bbbae96a0813d414$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $bbbae96a0813d414$var$intCheck(v[0], -$bbbae96a0813d414$var$MAX, 0, p);
                        $bbbae96a0813d414$var$intCheck(v[1], 0, $bbbae96a0813d414$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $bbbae96a0813d414$var$intCheck(v, -$bbbae96a0813d414$var$MAX, $bbbae96a0813d414$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $bbbae96a0813d414$var$intCheck(v[0], -$bbbae96a0813d414$var$MAX, -1, p);
                        $bbbae96a0813d414$var$intCheck(v[1], 1, $bbbae96a0813d414$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $bbbae96a0813d414$var$intCheck(v, -$bbbae96a0813d414$var$MAX, $bbbae96a0813d414$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($bbbae96a0813d414$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($bbbae96a0813d414$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($bbbae96a0813d414$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $bbbae96a0813d414$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $bbbae96a0813d414$var$intCheck(v, 0, $bbbae96a0813d414$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($bbbae96a0813d414$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($bbbae96a0813d414$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($bbbae96a0813d414$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$bbbae96a0813d414$var$MAX && e <= $bbbae96a0813d414$var$MAX && e === $bbbae96a0813d414$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $bbbae96a0813d414$var$LOG_BASE;
                if (i < 1) i += $bbbae96a0813d414$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $bbbae96a0813d414$var$BASE || n !== $bbbae96a0813d414$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($bbbae96a0813d414$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $bbbae96a0813d414$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $bbbae96a0813d414$var$intCheck(dp, 0, $bbbae96a0813d414$var$MAX);
            k = $bbbae96a0813d414$var$mathceil(dp / $bbbae96a0813d414$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($bbbae96a0813d414$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $bbbae96a0813d414$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $bbbae96a0813d414$var$POWS_TEN[$bbbae96a0813d414$var$LOG_BASE - dp];
                c[i] = $bbbae96a0813d414$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $bbbae96a0813d414$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $bbbae96a0813d414$var$LOG_BASE) e -= $bbbae96a0813d414$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($bbbae96a0813d414$var$toFixedPoint($bbbae96a0813d414$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $bbbae96a0813d414$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $bbbae96a0813d414$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $bbbae96a0813d414$var$SQRT_BASE, khi = k / $bbbae96a0813d414$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $bbbae96a0813d414$var$SQRT_BASE;
                xhi = x[i] / $bbbae96a0813d414$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $bbbae96a0813d414$var$SQRT_BASE * $bbbae96a0813d414$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $bbbae96a0813d414$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $bbbae96a0813d414$var$BASE;
                e = $bbbae96a0813d414$var$bitFloor(x.e / $bbbae96a0813d414$var$LOG_BASE) - $bbbae96a0813d414$var$bitFloor(y.e / $bbbae96a0813d414$var$LOG_BASE);
                s = s / $bbbae96a0813d414$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $bbbae96a0813d414$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $bbbae96a0813d414$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $bbbae96a0813d414$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $bbbae96a0813d414$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $bbbae96a0813d414$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $bbbae96a0813d414$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $bbbae96a0813d414$var$toExponential(str, ne) : $bbbae96a0813d414$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $bbbae96a0813d414$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $bbbae96a0813d414$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $bbbae96a0813d414$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $bbbae96a0813d414$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $bbbae96a0813d414$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($bbbae96a0813d414$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $bbbae96a0813d414$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $bbbae96a0813d414$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $bbbae96a0813d414$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $bbbae96a0813d414$var$mathceil((i + 1) / $bbbae96a0813d414$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $bbbae96a0813d414$var$LOG_BASE;
                            j = i - $bbbae96a0813d414$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $bbbae96a0813d414$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $bbbae96a0813d414$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $bbbae96a0813d414$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($bbbae96a0813d414$var$LOG_BASE - sd % $bbbae96a0813d414$var$LOG_BASE) % $bbbae96a0813d414$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$bbbae96a0813d414$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $bbbae96a0813d414$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $bbbae96a0813d414$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $bbbae96a0813d414$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $bbbae96a0813d414$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $bbbae96a0813d414$var$toExponential(str, e) : $bbbae96a0813d414$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $bbbae96a0813d414$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $bbbae96a0813d414$var$intCheck(dp, 0, $bbbae96a0813d414$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $bbbae96a0813d414$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $bbbae96a0813d414$var$bitFloor(this.e / $bbbae96a0813d414$var$LOG_BASE)) * $bbbae96a0813d414$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($bbbae96a0813d414$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $bbbae96a0813d414$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $bbbae96a0813d414$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $bbbae96a0813d414$var$mathceil(POW_PRECISION / $bbbae96a0813d414$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $bbbae96a0813d414$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $bbbae96a0813d414$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $bbbae96a0813d414$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $bbbae96a0813d414$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $bbbae96a0813d414$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $bbbae96a0813d414$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $bbbae96a0813d414$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $bbbae96a0813d414$var$bitFloor(this.e / $bbbae96a0813d414$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $bbbae96a0813d414$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $bbbae96a0813d414$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $bbbae96a0813d414$var$LOG_BASE, ye = y.e / $bbbae96a0813d414$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $bbbae96a0813d414$var$bitFloor(xe);
        ye = $bbbae96a0813d414$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $bbbae96a0813d414$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $bbbae96a0813d414$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $bbbae96a0813d414$var$bitFloor(x.e / $bbbae96a0813d414$var$LOG_BASE) + $bbbae96a0813d414$var$bitFloor(y.e / $bbbae96a0813d414$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $bbbae96a0813d414$var$BASE;
        sqrtBase = $bbbae96a0813d414$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $bbbae96a0813d414$var$LOG_BASE, ye = y.e / $bbbae96a0813d414$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $bbbae96a0813d414$var$bitFloor(xe);
        ye = $bbbae96a0813d414$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $bbbae96a0813d414$var$BASE | 0;
            xc[b] = $bbbae96a0813d414$var$BASE === xc[b] ? 0 : xc[b] % $bbbae96a0813d414$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $bbbae96a0813d414$var$intCheck(sd, 1, $bbbae96a0813d414$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $bbbae96a0813d414$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $bbbae96a0813d414$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $bbbae96a0813d414$var$intCheck(k, -$bbbae96a0813d414$var$MAX_SAFE_INTEGER, $bbbae96a0813d414$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $bbbae96a0813d414$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $bbbae96a0813d414$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($bbbae96a0813d414$var$coeffToString(t.c).slice(0, s) === (n = $bbbae96a0813d414$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $bbbae96a0813d414$var$intCheck(dp, 0, $bbbae96a0813d414$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $bbbae96a0813d414$var$intCheck(dp, 0, $bbbae96a0813d414$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($bbbae96a0813d414$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($bbbae96a0813d414$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $bbbae96a0813d414$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $bbbae96a0813d414$var$POWS_TEN[(exp = e % $bbbae96a0813d414$var$LOG_BASE) < 0 ? $bbbae96a0813d414$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $bbbae96a0813d414$var$intCheck(sd, 1, $bbbae96a0813d414$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $bbbae96a0813d414$var$toExponential($bbbae96a0813d414$var$coeffToString(n.c), e) : $bbbae96a0813d414$var$toFixedPoint($bbbae96a0813d414$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $bbbae96a0813d414$var$toFixedPoint($bbbae96a0813d414$var$coeffToString(n.c), n.e, "0");
            } else {
                $bbbae96a0813d414$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($bbbae96a0813d414$var$toFixedPoint($bbbae96a0813d414$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $bbbae96a0813d414$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $bbbae96a0813d414$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $bbbae96a0813d414$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $bbbae96a0813d414$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $bbbae96a0813d414$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $bbbae96a0813d414$var$mathfloor(n)) throw Error($bbbae96a0813d414$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $bbbae96a0813d414$var$isOdd(n) {
    var k = n.c.length - 1;
    return $bbbae96a0813d414$var$bitFloor(n.e / $bbbae96a0813d414$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $bbbae96a0813d414$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $bbbae96a0813d414$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $bbbae96a0813d414$export$d97aa349ed20696 = $bbbae96a0813d414$var$clone();
var $bbbae96a0813d414$export$2e2bcd8739ae039 = $bbbae96a0813d414$export$d97aa349ed20696;

});

parcelRegister("1aMHK", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $e72f5d256607c8b0$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $e72f5d256607c8b0$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $e72f5d256607c8b0$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $e72f5d256607c8b0$export$1050f835b63b671e; });
$parcel$export(module.exports, "__exportStar", function () { return $e72f5d256607c8b0$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $e72f5d256607c8b0$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $e72f5d256607c8b0$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $e72f5d256607c8b0$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importStar", function () { return $e72f5d256607c8b0$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $e72f5d256607c8b0$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e72f5d256607c8b0$var$extendStatics = function(d, b) {
    $e72f5d256607c8b0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e72f5d256607c8b0$var$extendStatics(d, b);
};
function $e72f5d256607c8b0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e72f5d256607c8b0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e72f5d256607c8b0$export$18ce0697a983be9b = function() {
    $e72f5d256607c8b0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e72f5d256607c8b0$export$18ce0697a983be9b.apply(this, arguments);
};
function $e72f5d256607c8b0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e72f5d256607c8b0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e72f5d256607c8b0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e72f5d256607c8b0$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e72f5d256607c8b0$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e72f5d256607c8b0$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e72f5d256607c8b0$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e72f5d256607c8b0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e72f5d256607c8b0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e72f5d256607c8b0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e72f5d256607c8b0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e72f5d256607c8b0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e72f5d256607c8b0$export$45d3717a4c69092e(o, m, p);
}
function $e72f5d256607c8b0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e72f5d256607c8b0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e72f5d256607c8b0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e72f5d256607c8b0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e72f5d256607c8b0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e72f5d256607c8b0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e72f5d256607c8b0$export$10c90e4f7922046c(v) {
    return this instanceof $e72f5d256607c8b0$export$10c90e4f7922046c ? (this.v = v, this) : new $e72f5d256607c8b0$export$10c90e4f7922046c(v);
}
function $e72f5d256607c8b0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e72f5d256607c8b0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e72f5d256607c8b0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e72f5d256607c8b0$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e72f5d256607c8b0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e72f5d256607c8b0$export$19a8beecd37a4c45 === "function" ? $e72f5d256607c8b0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e72f5d256607c8b0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e72f5d256607c8b0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e72f5d256607c8b0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e72f5d256607c8b0$export$45d3717a4c69092e(result, mod, k);
    }
    $e72f5d256607c8b0$var$__setModuleDefault(result, mod);
    return result;
}
function $e72f5d256607c8b0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e72f5d256607c8b0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e72f5d256607c8b0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e72f5d256607c8b0$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e72f5d256607c8b0$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e72f5d256607c8b0$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e72f5d256607c8b0$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e72f5d256607c8b0$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e72f5d256607c8b0$export$2e2bcd8739ae039 = {
    __extends: $e72f5d256607c8b0$export$a8ba968b8961cb8a,
    __assign: $e72f5d256607c8b0$export$18ce0697a983be9b,
    __rest: $e72f5d256607c8b0$export$3c9a16f847548506,
    __decorate: $e72f5d256607c8b0$export$29e00dfd3077644b,
    __param: $e72f5d256607c8b0$export$d5ad3fd78186038f,
    __metadata: $e72f5d256607c8b0$export$f1db080c865becb9,
    __awaiter: $e72f5d256607c8b0$export$1050f835b63b671e,
    __generator: $e72f5d256607c8b0$export$67ebef60e6f28a6,
    __createBinding: $e72f5d256607c8b0$export$45d3717a4c69092e,
    __exportStar: $e72f5d256607c8b0$export$f33643c0debef087,
    __values: $e72f5d256607c8b0$export$19a8beecd37a4c45,
    __read: $e72f5d256607c8b0$export$8d051b38c9118094,
    __spread: $e72f5d256607c8b0$export$afc72e2116322959,
    __spreadArrays: $e72f5d256607c8b0$export$6388937ca91ccae8,
    __spreadArray: $e72f5d256607c8b0$export$1216008129fb82ed,
    __await: $e72f5d256607c8b0$export$10c90e4f7922046c,
    __asyncGenerator: $e72f5d256607c8b0$export$e427f37a30a4de9b,
    __asyncDelegator: $e72f5d256607c8b0$export$bbd80228419bb833,
    __asyncValues: $e72f5d256607c8b0$export$e3b29a3d6162315f,
    __makeTemplateObject: $e72f5d256607c8b0$export$4fb47efe1390b86f,
    __importStar: $e72f5d256607c8b0$export$c21735bcef00d192,
    __importDefault: $e72f5d256607c8b0$export$da59b14a69baef04,
    __classPrivateFieldGet: $e72f5d256607c8b0$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e72f5d256607c8b0$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e72f5d256607c8b0$export$81fdc39f203e4e04,
    __addDisposableResource: $e72f5d256607c8b0$export$88ac25d8e944e405,
    __disposeResources: $e72f5d256607c8b0$export$8f076105dc360e92
};

});

parcelRegister("eXtb5", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $ae3d3578c845e26a$export$bf730a2d8bf68b42; }, function (v) { return $ae3d3578c845e26a$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ae3d3578c845e26a$export$bf730a2d8bf68b42;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ePGDo = parcelRequire("ePGDo");
function $ae3d3578c845e26a$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ae3d3578c845e26a$var$q = "function" === typeof Object.is ? Object.is : $ae3d3578c845e26a$var$p, $ae3d3578c845e26a$var$r = $ePGDo.useSyncExternalStore, $ae3d3578c845e26a$var$t = $exYeM.useRef, $ae3d3578c845e26a$var$u = $exYeM.useEffect, $ae3d3578c845e26a$var$v = $exYeM.useMemo, $ae3d3578c845e26a$var$w = $exYeM.useDebugValue;
$ae3d3578c845e26a$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $ae3d3578c845e26a$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $ae3d3578c845e26a$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($ae3d3578c845e26a$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $ae3d3578c845e26a$var$r(a, c[0], c[1]);
    $ae3d3578c845e26a$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $ae3d3578c845e26a$var$w(d);
    return d;
};

});
parcelRegister("ePGDo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kvD72"));

});
parcelRegister("kvD72", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16; }, function (v) { return $eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eee50ad7e4fe08dc$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $eee50ad7e4fe08dc$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $eee50ad7e4fe08dc$var$k = "function" === typeof Object.is ? Object.is : $eee50ad7e4fe08dc$var$h, $eee50ad7e4fe08dc$var$l = $exYeM.useState, $eee50ad7e4fe08dc$var$m = $exYeM.useEffect, $eee50ad7e4fe08dc$var$n = $exYeM.useLayoutEffect, $eee50ad7e4fe08dc$var$p = $exYeM.useDebugValue;
function $eee50ad7e4fe08dc$var$q(a, b) {
    var d = b(), f = $eee50ad7e4fe08dc$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $eee50ad7e4fe08dc$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $eee50ad7e4fe08dc$var$m(function() {
        $eee50ad7e4fe08dc$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $eee50ad7e4fe08dc$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $eee50ad7e4fe08dc$var$p(d);
    return d;
}
function $eee50ad7e4fe08dc$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$eee50ad7e4fe08dc$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $eee50ad7e4fe08dc$var$t(a, b) {
    return b();
}
var $eee50ad7e4fe08dc$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $eee50ad7e4fe08dc$var$t : $eee50ad7e4fe08dc$var$q;
$eee50ad7e4fe08dc$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $eee50ad7e4fe08dc$var$u;

});



parcelRegister("6xcFR", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7d6WJ")).then(()=>parcelRequire("jXPdh"));

});

parcelRegister("bWPjV", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3g3t4")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c9Tx3"))
]).then(()=>parcelRequire("e4Mbg"));

});

parcelRegister("fqCpP", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4ioaA")).then(()=>parcelRequire("haHea"));

});

parcelRegister("4DYZp", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("eOYHt")).then(()=>parcelRequire("6MroZ"));

});

parcelRegister("614yl", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3Gcrf")).then(()=>parcelRequire("5ZadZ"));

});

parcelRegister("anyT5", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dKyw0")).then(()=>parcelRequire("7j4Qc"));

});

parcelRegister("lcEHA", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("hysJJ")).then(()=>parcelRequire("jalvW"));

});

parcelRegister("fRq6b", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("iWI08")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cNGjO")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3VV1N")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c2aEk")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lJQ3X"))
]).then(()=>parcelRequire("ajMQH"));

});

parcelRegister("fs5wa", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("9zBER")).then(()=>parcelRequire("gj8xT"));

});

parcelRegister("9IKPT", function(module, exports) {

$parcel$export(module.exports, "getLedgerError", function () { return $1e96ed7df6ab25aa$export$36edca307d1b62d1; });
$parcel$export(module.exports, "getLedgerInstance", function () { return $1e96ed7df6ab25aa$export$6c112385a05acdaf; });
$parcel$export(module.exports, "getEthereumAccounts", function () { return $1e96ed7df6ab25aa$export$d5de980bfde9e56b; });
$parcel$export(module.exports, "transportConnect", function () { return $1e96ed7df6ab25aa$export$ea1f07d757001497; });
$parcel$export(module.exports, "transportDisconnect", function () { return $1e96ed7df6ab25aa$export$a84ecb994933e890; });
$parcel$export(module.exports, "getSolanaAccounts", function () { return $1e96ed7df6ab25aa$export$a009f0f0c363aa6c; });

var $1Uqgk = parcelRequire("1Uqgk");
parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");
var $8aS14 = parcelRequire("8aS14");

var $4evmt = parcelRequire("4evmt");

var $53JAW = parcelRequire("53JAW");
const $1e96ed7df6ab25aa$export$7dd621d8a174fee6 = 16;
const $1e96ed7df6ab25aa$var$ledgerFrequentErrorMessages = {
    0x5515: "The device is locked",
    0x650f: "Related application is not ready on your device",
    0x6985: "Action denied by user"
};
function $1e96ed7df6ab25aa$var$getLedgerErrorMessage(statusCode) {
    if ($1e96ed7df6ab25aa$var$ledgerFrequentErrorMessages[statusCode]) return $1e96ed7df6ab25aa$var$ledgerFrequentErrorMessages[statusCode];
    else if ((0, $1Uqgk.getAltStatusMessage)(statusCode)) return (0, $1Uqgk.getAltStatusMessage)(statusCode);
    return `Ledger device unknown error 0x${statusCode.toString($1e96ed7df6ab25aa$export$7dd621d8a174fee6)}`; // Hexadecimal numbers are more commonly recognized and utilized for representing ledger error codes
}
function $1e96ed7df6ab25aa$export$36edca307d1b62d1(error) {
    if (error?.statusCode) return new Error($1e96ed7df6ab25aa$var$getLedgerErrorMessage(error.statusCode));
    if (error?.code === "INSUFFICIENT_FUNDS") return new Error("Insufficient funds for transaction");
    return error;
}
function $1e96ed7df6ab25aa$export$6c112385a05acdaf() {
    /*
   * Instances have a required property which is `chainId` and is using in swap execution.
   * Here we are setting it as Ethereum always since we are supporting only eth for now.
   */ const instances = new Map();
    instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, {
        chainId: (0, $yEwlv.ETHEREUM_CHAIN_ID)
    });
    instances.set((0, $8aS14.LegacyNetworks).SOLANA, {
        chainId: (0, $8aS14.LegacyNetworks).SOLANA
    });
    return instances;
}

async function $1e96ed7df6ab25aa$export$d5de980bfde9e56b() {
    try {
        const transport = await $1e96ed7df6ab25aa$export$ea1f07d757001497();
        const eth = new (await (parcelRequire("1yayi"))).default(transport);
        const accounts = [];
        const result = await eth.getAddress((0, $53JAW.getDerivationPath)(), false, true);
        accounts.push(result.address);
        return {
            accounts: accounts,
            chainId: (0, $yEwlv.ETHEREUM_CHAIN_ID)
        };
    } catch (error) {
        throw $1e96ed7df6ab25aa$export$36edca307d1b62d1(error);
    } finally{
        await $1e96ed7df6ab25aa$export$a84ecb994933e890();
    }
}

async function $1e96ed7df6ab25aa$export$a009f0f0c363aa6c() {
    try {
        const transport = await $1e96ed7df6ab25aa$export$ea1f07d757001497();
        const solana = new (await (parcelRequire("fNyS2"))).default(transport);
        const accounts = [];
        const result = await solana.getAddress((0, $53JAW.getDerivationPath)());
        accounts.push((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(result.address));
        return {
            accounts: accounts,
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        };
    } catch (error) {
        throw $1e96ed7df6ab25aa$export$36edca307d1b62d1(error);
    } finally{
        await $1e96ed7df6ab25aa$export$a84ecb994933e890();
    }
}
let $1e96ed7df6ab25aa$var$transportConnection = null;

async function $1e96ed7df6ab25aa$export$ea1f07d757001497() {
    $1e96ed7df6ab25aa$var$transportConnection = await (await (parcelRequire("c9uSC"))).default.create();
    return $1e96ed7df6ab25aa$var$transportConnection;
}
async function $1e96ed7df6ab25aa$export$a84ecb994933e890() {
    if ($1e96ed7df6ab25aa$var$transportConnection) {
        await $1e96ed7df6ab25aa$var$transportConnection.close();
        $1e96ed7df6ab25aa$var$transportConnection = null;
    }
}

});
parcelRegister("1Uqgk", function(module, exports) {

$parcel$export(module.exports, "DisconnectedDevice", function () { return $163f648bbb913755$export$1e42f3936938e063; });
$parcel$export(module.exports, "DisconnectedDeviceDuringOperation", function () { return $163f648bbb913755$export$2a60f41a2ed2742; });
$parcel$export(module.exports, "TransportOpenUserCancelled", function () { return $163f648bbb913755$export$9642f061c2494239; });
$parcel$export(module.exports, "TransportPendingOperation", function () { return $163f648bbb913755$export$a02f8f98115efd5d; });
$parcel$export(module.exports, "TransportError", function () { return $163f648bbb913755$export$8e68de6fb26f2236; });
$parcel$export(module.exports, "StatusCodes", function () { return $163f648bbb913755$export$efd5569f873811b1; });
$parcel$export(module.exports, "getAltStatusMessage", function () { return $163f648bbb913755$export$799566c03457ebd5; });
$parcel$export(module.exports, "TransportStatusError", function () { return $163f648bbb913755$export$78917f4716d96cfe; });
$parcel$export(module.exports, "createCustomErrorClass", function () { return (parcelRequire("jz8kv")).createCustomErrorClass; });

var $jz8kv = parcelRequire("jz8kv");
const $163f648bbb913755$export$d7dd32b41fc9c3a0 = (0, $jz8kv.createCustomErrorClass)("AccountNameRequired");
const $163f648bbb913755$export$fb9db505804530ec = (0, $jz8kv.createCustomErrorClass)("AccountNotSupported");
const $163f648bbb913755$export$c9d6bf2b06944665 = (0, $jz8kv.createCustomErrorClass)("AmountRequired");
const $163f648bbb913755$export$2628fce2396c23c2 = (0, $jz8kv.createCustomErrorClass)("BluetoothRequired");
const $163f648bbb913755$export$75f8b0767ef406f1 = (0, $jz8kv.createCustomErrorClass)("BtcUnmatchedApp");
const $163f648bbb913755$export$f60aa84fd00bc3ee = (0, $jz8kv.createCustomErrorClass)("CantOpenDevice");
const $163f648bbb913755$export$fc0260506e4022ab = (0, $jz8kv.createCustomErrorClass)("CashAddrNotSupported");
const $163f648bbb913755$export$1e9e90415b859c28 = (0, $jz8kv.createCustomErrorClass)("ClaimRewardsFeesWarning");
const $163f648bbb913755$export$e0b1ec53ba36e221 = (0, $jz8kv.createCustomErrorClass)("CurrencyNotSupported");
const $163f648bbb913755$export$fa9aacd48d3a45c2 = (0, $jz8kv.createCustomErrorClass)("DeviceAppVerifyNotSupported");
const $163f648bbb913755$export$f21ce806524ab8d4 = (0, $jz8kv.createCustomErrorClass)("DeviceGenuineSocketEarlyClose");
const $163f648bbb913755$export$9c30dc6872fcd74c = (0, $jz8kv.createCustomErrorClass)("DeviceNotGenuine");
const $163f648bbb913755$export$1d5ae41b109edf1f = (0, $jz8kv.createCustomErrorClass)("DeviceOnDashboardExpected");
const $163f648bbb913755$export$8eecf64ec9a8cfd7 = (0, $jz8kv.createCustomErrorClass)("DeviceOnDashboardUnexpected");
const $163f648bbb913755$export$a5e2071f1ac48fdd = (0, $jz8kv.createCustomErrorClass)("DeviceInOSUExpected");
const $163f648bbb913755$export$3be6e7231165f4ac = (0, $jz8kv.createCustomErrorClass)("DeviceHalted");
const $163f648bbb913755$export$fa7bfae6dce03474 = (0, $jz8kv.createCustomErrorClass)("DeviceNameInvalid");
const $163f648bbb913755$export$bcce4e5aded80ca0 = (0, $jz8kv.createCustomErrorClass)("DeviceSocketFail");
const $163f648bbb913755$export$944a0f9a7cc1e03a = (0, $jz8kv.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const $163f648bbb913755$export$612d1f6d08d4cfb = (0, $jz8kv.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const $163f648bbb913755$export$5f6bf7cdd5818529 = (0, $jz8kv.createCustomErrorClass)("UnresponsiveDeviceError");
const $163f648bbb913755$export$1e42f3936938e063 = (0, $jz8kv.createCustomErrorClass)("DisconnectedDevice");
const $163f648bbb913755$export$2a60f41a2ed2742 = (0, $jz8kv.createCustomErrorClass)("DisconnectedDeviceDuringOperation");
const $163f648bbb913755$export$93e2040d8e24d646 = (0, $jz8kv.createCustomErrorClass)("DeviceExtractOnboardingStateError");
const $163f648bbb913755$export$e6aaf90bcb4b2013 = (0, $jz8kv.createCustomErrorClass)("DeviceOnboardingStatePollingError");
const $163f648bbb913755$export$cfbd0adf8f9fdaf9 = (0, $jz8kv.createCustomErrorClass)("EnpointConfig");
const $163f648bbb913755$export$96d8d3c501f1625 = (0, $jz8kv.createCustomErrorClass)("EthAppPleaseEnableContractData");
const $163f648bbb913755$export$37b49553b7172cb1 = (0, $jz8kv.createCustomErrorClass)("FeeEstimationFailed");
const $163f648bbb913755$export$d00fd6c398a70fd9 = (0, $jz8kv.createCustomErrorClass)("FirmwareNotRecognized");
const $163f648bbb913755$export$3dc3bbf8c134219c = (0, $jz8kv.createCustomErrorClass)("HardResetFail");
const $163f648bbb913755$export$5e8f7ae1054a2777 = (0, $jz8kv.createCustomErrorClass)("InvalidXRPTag");
const $163f648bbb913755$export$953b602d2269ceba = (0, $jz8kv.createCustomErrorClass)("InvalidAddress");
const $163f648bbb913755$export$61e75f453df94067 = (0, $jz8kv.createCustomErrorClass)("InvalidNonce");
const $163f648bbb913755$export$bbdaf7c77a7508eb = (0, $jz8kv.createCustomErrorClass)("InvalidAddressBecauseDestinationIsAlsoSource");
const $163f648bbb913755$export$882967e2980534f9 = (0, $jz8kv.createCustomErrorClass)("LatestMCUInstalledError");
const $163f648bbb913755$export$59772a13ac97df0e = (0, $jz8kv.createCustomErrorClass)("UnknownMCU");
const $163f648bbb913755$export$26bf4f7c63d50901 = (0, $jz8kv.createCustomErrorClass)("LedgerAPIError");
const $163f648bbb913755$export$fdab6afd1b1820af = (0, $jz8kv.createCustomErrorClass)("LedgerAPIErrorWithMessage");
const $163f648bbb913755$export$c2996b38942cf758 = (0, $jz8kv.createCustomErrorClass)("LedgerAPINotAvailable");
const $163f648bbb913755$export$3d81abcc61613a27 = (0, $jz8kv.createCustomErrorClass)("ManagerAppAlreadyInstalled");
const $163f648bbb913755$export$87a9bff9fff141e2 = (0, $jz8kv.createCustomErrorClass)("ManagerAppRelyOnBTC");
const $163f648bbb913755$export$86581a722c4238c0 = (0, $jz8kv.createCustomErrorClass)("ManagerAppDepInstallRequired");
const $163f648bbb913755$export$267a8476044885dd = (0, $jz8kv.createCustomErrorClass)("ManagerAppDepUninstallRequired");
const $163f648bbb913755$export$bb771ca417eca344 = (0, $jz8kv.createCustomErrorClass)("ManagerDeviceLocked");
const $163f648bbb913755$export$b634ce25e3ff5229 = (0, $jz8kv.createCustomErrorClass)("ManagerFirmwareNotEnoughSpace");
const $163f648bbb913755$export$2d26f4eadfe37285 = (0, $jz8kv.createCustomErrorClass)("ManagerNotEnoughSpace");
const $163f648bbb913755$export$ceb7f9bef5a1e481 = (0, $jz8kv.createCustomErrorClass)("ManagerUninstallBTCDep");
const $163f648bbb913755$export$baadb6886fde1621 = (0, $jz8kv.createCustomErrorClass)("NetworkDown");
const $163f648bbb913755$export$bae979e68e4dc802 = (0, $jz8kv.createCustomErrorClass)("NetworkError");
const $163f648bbb913755$export$5cbfa0659f97216a = (0, $jz8kv.createCustomErrorClass)("NoAddressesFound");
const $163f648bbb913755$export$9e00aead3515e5c9 = (0, $jz8kv.createCustomErrorClass)("NotEnoughBalance");
const $163f648bbb913755$export$5ed90e0e011f4857 = (0, $jz8kv.createCustomErrorClass)("NotEnoughBalanceToDelegate");
const $163f648bbb913755$export$75178c95e66d9630 = (0, $jz8kv.createCustomErrorClass)("NotEnoughBalanceInParentAccount");
const $163f648bbb913755$export$e3e2865b29f7e0b0 = (0, $jz8kv.createCustomErrorClass)("NotEnoughSpendableBalance");
const $163f648bbb913755$export$a84b3634866707ea = (0, $jz8kv.createCustomErrorClass)("NotEnoughBalanceBecauseDestinationNotCreated");
const $163f648bbb913755$export$a282f858b69a7326 = (0, $jz8kv.createCustomErrorClass)("NoAccessToCamera");
const $163f648bbb913755$export$5111c405c5cacc97 = (0, $jz8kv.createCustomErrorClass)("NotEnoughGas");
const $163f648bbb913755$export$1cb5c4489aaca4d6 = (0, $jz8kv.createCustomErrorClass)("NotEnoughGasSwap");
const $163f648bbb913755$export$626e1fd20d22139c = (0, $jz8kv.createCustomErrorClass)("NotSupportedLegacyAddress");
const $163f648bbb913755$export$f919e2c9c746346b = (0, $jz8kv.createCustomErrorClass)("GasLessThanEstimate");
const $163f648bbb913755$export$cc562f3706902d22 = (0, $jz8kv.createCustomErrorClass)("PriorityFeeTooLow");
const $163f648bbb913755$export$ee14d05cd43eb762 = (0, $jz8kv.createCustomErrorClass)("PriorityFeeTooHigh");
const $163f648bbb913755$export$931458f4b7d53154 = (0, $jz8kv.createCustomErrorClass)("PriorityFeeHigherThanMaxFee");
const $163f648bbb913755$export$c0ce9cadb94c6b86 = (0, $jz8kv.createCustomErrorClass)("MaxFeeTooLow");
const $163f648bbb913755$export$22c5aa8937c5b423 = (0, $jz8kv.createCustomErrorClass)("PasswordsDontMatch");
const $163f648bbb913755$export$f57670cd1aaf386 = (0, $jz8kv.createCustomErrorClass)("PasswordIncorrect");
const $163f648bbb913755$export$3ba22bf10deb1448 = (0, $jz8kv.createCustomErrorClass)("RecommendSubAccountsToEmpty");
const $163f648bbb913755$export$33f73085e1b7871b = (0, $jz8kv.createCustomErrorClass)("RecommendUndelegation");
const $163f648bbb913755$export$cd4d967a66d81060 = (0, $jz8kv.createCustomErrorClass)("TimeoutTagged");
const $163f648bbb913755$export$9375635756d6156e = (0, $jz8kv.createCustomErrorClass)("UnexpectedBootloader");
const $163f648bbb913755$export$90478a5d08d6c2d7 = (0, $jz8kv.createCustomErrorClass)("MCUNotGenuineToDashboard");
const $163f648bbb913755$export$132f0197eaa65535 = (0, $jz8kv.createCustomErrorClass)("RecipientRequired");
const $163f648bbb913755$export$7aee729193ab77ba = (0, $jz8kv.createCustomErrorClass)("UnavailableTezosOriginatedAccountReceive");
const $163f648bbb913755$export$4ec11dc947a3c9d6 = (0, $jz8kv.createCustomErrorClass)("UnavailableTezosOriginatedAccountSend");
const $163f648bbb913755$export$5e3ed85b946872a1 = (0, $jz8kv.createCustomErrorClass)("UpdateFetchFileFail");
const $163f648bbb913755$export$5db6383ad081f01e = (0, $jz8kv.createCustomErrorClass)("UpdateIncorrectHash");
const $163f648bbb913755$export$92c199eb837d8df8 = (0, $jz8kv.createCustomErrorClass)("UpdateIncorrectSig");
const $163f648bbb913755$export$85e0c017833c894c = (0, $jz8kv.createCustomErrorClass)("UpdateYourApp");
const $163f648bbb913755$export$84115f1b54c874b3 = (0, $jz8kv.createCustomErrorClass)("UserRefusedDeviceNameChange");
const $163f648bbb913755$export$3f4864efb1638333 = (0, $jz8kv.createCustomErrorClass)("UserRefusedAddress");
const $163f648bbb913755$export$d777e0ef77faca34 = (0, $jz8kv.createCustomErrorClass)("UserRefusedFirmwareUpdate");
const $163f648bbb913755$export$3d8a4f08cd3eb133 = (0, $jz8kv.createCustomErrorClass)("UserRefusedAllowManager");
const $163f648bbb913755$export$db9b724c3524b5d6 = (0, $jz8kv.createCustomErrorClass)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $163f648bbb913755$export$65df6bdf4eb29653 = (0, $jz8kv.createCustomErrorClass)("ExpertModeRequired");
const $163f648bbb913755$export$9642f061c2494239 = (0, $jz8kv.createCustomErrorClass)("TransportOpenUserCancelled");
const $163f648bbb913755$export$fd71e3a51c4bf0ae = (0, $jz8kv.createCustomErrorClass)("TransportInterfaceNotAvailable");
const $163f648bbb913755$export$a02f8f98115efd5d = (0, $jz8kv.createCustomErrorClass)("TransportPendingOperation");
const $163f648bbb913755$export$c0ffbdd94649bd06 = (0, $jz8kv.createCustomErrorClass)("TransportWebUSBGestureRequired");
const $163f648bbb913755$export$28149f687a2e30c9 = (0, $jz8kv.createCustomErrorClass)("TransactionHasBeenValidatedError");
const $163f648bbb913755$export$448663d307bde953 = (0, $jz8kv.createCustomErrorClass)("TransportExchangeTimeoutError");
const $163f648bbb913755$export$4800af3cc6204928 = (0, $jz8kv.createCustomErrorClass)("DeviceShouldStayInApp");
const $163f648bbb913755$export$101490ec073327e1 = (0, $jz8kv.createCustomErrorClass)("WebsocketConnectionError");
const $163f648bbb913755$export$219228963d86b069 = (0, $jz8kv.createCustomErrorClass)("WebsocketConnectionFailed");
const $163f648bbb913755$export$25b49ca0efdfe5d1 = (0, $jz8kv.createCustomErrorClass)("WrongDeviceForAccount");
const $163f648bbb913755$export$4de3709f8e2844ca = (0, $jz8kv.createCustomErrorClass)("WrongDeviceForAccountPayout");
const $163f648bbb913755$export$b7651c38a977157 = (0, $jz8kv.createCustomErrorClass)("WrongDeviceForAccountRefund");
const $163f648bbb913755$export$63498b46122d8a23 = (0, $jz8kv.createCustomErrorClass)("WrongAppForCurrency");
const $163f648bbb913755$export$707f317a4761c46d = (0, $jz8kv.createCustomErrorClass)("ETHAddressNonEIP");
const $163f648bbb913755$export$a5d8da2f27618c16 = (0, $jz8kv.createCustomErrorClass)("CantScanQRCode");
const $163f648bbb913755$export$3f2d8a7775aab6cc = (0, $jz8kv.createCustomErrorClass)("FeeNotLoaded");
const $163f648bbb913755$export$3ae46f8c8f45dbe7 = (0, $jz8kv.createCustomErrorClass)("FeeNotLoadedSwap");
const $163f648bbb913755$export$ffbf6641e9ab88d3 = (0, $jz8kv.createCustomErrorClass)("FeeRequired");
const $163f648bbb913755$export$53e797c2fa09aff3 = (0, $jz8kv.createCustomErrorClass)("FeeTooHigh");
const $163f648bbb913755$export$cb0b645e3d7170ab = (0, $jz8kv.createCustomErrorClass)("PendingOperation");
const $163f648bbb913755$export$2aca4567d80fd933 = (0, $jz8kv.createCustomErrorClass)("SyncError");
const $163f648bbb913755$export$a2d6658d365c43df = (0, $jz8kv.createCustomErrorClass)("PairingFailed");
const $163f648bbb913755$export$4400fa093e7d20ad = (0, $jz8kv.createCustomErrorClass)("PeerRemovedPairing");
const $163f648bbb913755$export$3f7ba18f3c84cced = (0, $jz8kv.createCustomErrorClass)("GenuineCheckFailed");
const $163f648bbb913755$export$437e6aac14cab3d9 = (0, $jz8kv.createCustomErrorClass)("LedgerAPI4xx");
const $163f648bbb913755$export$309835543e52bf92 = (0, $jz8kv.createCustomErrorClass)("LedgerAPI5xx");
const $163f648bbb913755$export$c282cdb2f7fdc27a = (0, $jz8kv.createCustomErrorClass)("FirmwareOrAppUpdateRequired");
const $163f648bbb913755$export$aba9024c0d586a15 = (0, $jz8kv.createCustomErrorClass)("ReplacementTransactionUnderpriced");
const $163f648bbb913755$export$51a1e1b4f21df9f4 = (0, $jz8kv.createCustomErrorClass)("OpReturnSizeLimit");
const $163f648bbb913755$export$1d49177380419e3d = (0, $jz8kv.createCustomErrorClass)("DustLimit");
const $163f648bbb913755$export$28f62a162580c9c2 = (0, $jz8kv.createCustomErrorClass)("LanguageNotFound");
const $163f648bbb913755$export$d3cadb9f4e1fa40d = (0, $jz8kv.createCustomErrorClass)("NoDBPathGiven");
const $163f648bbb913755$export$de46c919e379f03f = (0, $jz8kv.createCustomErrorClass)("DBWrongPassword");
const $163f648bbb913755$export$e1c94c135b0a553e = (0, $jz8kv.createCustomErrorClass)("DBNotReset");
const $163f648bbb913755$export$35de8a1f557fb8bb = (0, $jz8kv.createCustomErrorClass)("SequenceNumberError");
const $163f648bbb913755$export$df2168717eaf23c6 = (0, $jz8kv.createCustomErrorClass)("DisabledTransactionBroadcastError");
var $163f648bbb913755$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($163f648bbb913755$export$62e86095f76df800 || ($163f648bbb913755$export$62e86095f76df800 = {}));
class $163f648bbb913755$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $163f648bbb913755$export$ef5ffbe444ecd147.prototype);
    }
}
class $163f648bbb913755$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $jz8kv.addCustomErrorDeserializer)("TransportError", (e)=>new $163f648bbb913755$export$8e68de6fb26f2236(e.message, e.id));
const $163f648bbb913755$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CUSTOM_IMAGE_BOOTLOADER: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102
};
function $163f648bbb913755$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $163f648bbb913755$export$78917f4716d96cfe extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($163f648bbb913755$export$efd5569f873811b1).find((k)=>$163f648bbb913755$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $163f648bbb913755$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $163f648bbb913755$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $163f648bbb913755$export$efd5569f873811b1.LOCKED_DEVICE) return new $163f648bbb913755$export$1fb6667702a70644(message);
    }
}
class $163f648bbb913755$export$1fb6667702a70644 extends $163f648bbb913755$export$78917f4716d96cfe {
    constructor(message){
        super($163f648bbb913755$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $163f648bbb913755$export$1fb6667702a70644.prototype);
    }
}
(0, $jz8kv.addCustomErrorDeserializer)("TransportStatusError", (e)=>new $163f648bbb913755$export$78917f4716d96cfe(e.statusCode));

});
parcelRegister("jz8kv", function(module, exports) {

$parcel$export(module.exports, "addCustomErrorDeserializer", function () { return $e3e7bf4c31cc3f61$export$ff6248acd0c27a3f; });
$parcel$export(module.exports, "createCustomErrorClass", function () { return $e3e7bf4c31cc3f61$export$94baff7bf5134824; });
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $e3e7bf4c31cc3f61$var$errorClasses = {};
const $e3e7bf4c31cc3f61$var$deserializers = {};
const $e3e7bf4c31cc3f61$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $e3e7bf4c31cc3f61$var$deserializers[name] = deserializer;
};
const $e3e7bf4c31cc3f61$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $e3e7bf4c31cc3f61$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $e3e7bf4c31cc3f61$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $e3e7bf4c31cc3f61$var$isObject(value) {
    return typeof value === "object";
}
const $e3e7bf4c31cc3f61$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $e3e7bf4c31cc3f61$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $e3e7bf4c31cc3f61$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $e3e7bf4c31cc3f61$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $e3e7bf4c31cc3f61$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $e3e7bf4c31cc3f61$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $e3e7bf4c31cc3f61$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $e3e7bf4c31cc3f61$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $e3e7bf4c31cc3f61$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}

});


parcelRegister("4evmt", function(module, exports) {

var $fEvIe = parcelRequire("fEvIe");
const $3150cbf657b6d7fc$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $fEvIe($3150cbf657b6d7fc$var$ALPHABET);

});
parcelRegister("fEvIe", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $b65330d93c719c85$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $b65330d93c719c85$var$base;

});


parcelRegister("53JAW", function(module, exports) {

$parcel$export(module.exports, "setDerivationPath", function () { return $bad5e5da7646a3f8$export$7700d582a5b9e8d0; });
$parcel$export(module.exports, "getDerivationPath", function () { return $bad5e5da7646a3f8$export$11792f2e0d4d6623; });
// We keep derivationPath here because we need to maintain it for signing transactions after it is set in connect method
let $bad5e5da7646a3f8$var$derivationPath = "";
function $bad5e5da7646a3f8$export$7700d582a5b9e8d0(path) {
    $bad5e5da7646a3f8$var$derivationPath = path;
}
function $bad5e5da7646a3f8$export$11792f2e0d4d6623() {
    return $bad5e5da7646a3f8$var$derivationPath;
}

});

parcelRegister("1yayi", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cNGjO")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c2aEk")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("990pc"))
]).then(()=>parcelRequire("aqcUy"));

});

parcelRegister("fNyS2", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cyrUg")).then(()=>parcelRequire("khUal"));

});

parcelRegister("c9uSC", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("fCvz3")).then(()=>parcelRequire("gMeIB"));

});


parcelRegister("cfbE8", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3g3t4")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("irg01"))
]).then(()=>parcelRequire("8vYbP"));

});

parcelRegister("9taAx", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dih4Q")).then(()=>parcelRequire("b1DnQ"));

});

parcelRegister("3CkBL", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("iWI08")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3VV1N")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c2aEk")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("dUTsy"))
]).then(()=>parcelRequire("1cPKh"));

});

parcelRegister("2HZPr", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("e1FmX")).then(()=>parcelRequire("9XSba"));

});

parcelRegister("aSKsu", function(module, exports) {

$parcel$export(module.exports, "sdk", function () { return $7116aae41060c232$export$2bd721eefbd23f7b; });
$parcel$export(module.exports, "getSafeInstance", function () { return $7116aae41060c232$export$1dfff23d73f0d87c; });

var $icYd7 = parcelRequire("icYd7");

var $a2xSs = parcelRequire("a2xSs");
const $7116aae41060c232$var$options = {
    debug: false
};
/*
 * similar to:
 * https://github.com/wagmi-dev/references/pull/114
 */ let $7116aae41060c232$var$SDK = (0, $a2xSs.default);
if (typeof (0, $a2xSs.default) !== "function" && // @ts-expect-error This import error is not visible to TypeScript
typeof (0, $a2xSs.default).default === "function") $7116aae41060c232$var$SDK = (0, $a2xSs.default).default;
const $7116aae41060c232$export$2bd721eefbd23f7b = new $7116aae41060c232$var$SDK($7116aae41060c232$var$options);
async function $7116aae41060c232$export$1dfff23d73f0d87c() {
    const timeout = 200;
    const accountInfo = await Promise.race([
        $7116aae41060c232$export$2bd721eefbd23f7b.safe.getInfo(),
        new Promise((resolve)=>setTimeout(resolve, timeout))
    ]);
    return accountInfo ? new (0, $icYd7.SafeAppProvider)(accountInfo, $7116aae41060c232$export$2bd721eefbd23f7b) : null;
}

});
parcelRegister("icYd7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppProvider = void 0;

var $lmZJb = parcelRequire("lmZJb");
Object.defineProperty(module.exports, "SafeAppProvider", {
    enumerable: true,
    get: function() {
        return $lmZJb.SafeAppProvider;
    }
});

});
parcelRegister("lmZJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppProvider = void 0;

var $dG33B = parcelRequire("dG33B");

var $2zCQC = parcelRequire("2zCQC");
// The API is based on Ethereum JavaScript API Provider Standard. Link: https://eips.ethereum.org/EIPS/eip-1193
class $f8eb88e9f6f1a4f4$var$SafeAppProvider extends $dG33B.EventEmitter {
    constructor(safe, sdk){
        super();
        this.submittedTxs = new Map();
        this.safe = safe;
        this.sdk = sdk;
    }
    async connect() {
        this.emit("connect", {
            chainId: this.chainId
        });
        return;
    }
    async disconnect() {
        return;
    }
    get chainId() {
        return this.safe.chainId;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async request(request) {
        const { method: method, params: params = [] } = request;
        switch(method){
            case "eth_accounts":
                return [
                    this.safe.safeAddress
                ];
            case "net_version":
            case "eth_chainId":
                return `0x${this.chainId.toString(16)}`;
            case "personal_sign":
                {
                    const [message, address] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(message);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sign":
                {
                    const [address, messageHash] = params;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase() || !messageHash.startsWith("0x")) throw new Error("The address or message hash is invalid");
                    const response = await this.sdk.txs.signMessage(messageHash);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_signTypedData":
            case "eth_signTypedData_v4":
                {
                    const [address, typedData] = params;
                    const parsedTypedData = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
                    if (this.safe.safeAddress.toLowerCase() !== address.toLowerCase()) throw new Error("The address is invalid");
                    const response = await this.sdk.txs.signTypedMessage(parsedTypedData);
                    const signature = "signature" in response ? response.signature : undefined;
                    return signature || "0x";
                }
            case "eth_sendTransaction":
                const tx = Object.assign({
                    value: "0",
                    data: "0x"
                }, params[0]);
                // Some ethereum libraries might pass the gas as a hex-encoded string
                // We need to convert it to a number because the SDK expects a number and our backend only supports
                // Decimal numbers
                if (typeof tx.gas === "string" && tx.gas.startsWith("0x")) tx.gas = parseInt(tx.gas, 16);
                const resp = await this.sdk.txs.send({
                    txs: [
                        tx
                    ],
                    params: {
                        safeTxGas: tx.gas
                    }
                });
                // Store fake transaction
                this.submittedTxs.set(resp.safeTxHash, {
                    from: this.safe.safeAddress,
                    hash: resp.safeTxHash,
                    gas: 0,
                    gasPrice: "0x00",
                    nonce: 0,
                    input: tx.data,
                    value: tx.value,
                    to: tx.to,
                    blockHash: null,
                    blockNumber: null,
                    transactionIndex: null
                });
                return resp.safeTxHash;
            case "eth_blockNumber":
                const block = await this.sdk.eth.getBlockByNumber([
                    "latest"
                ]);
                return block.number;
            case "eth_getBalance":
                return this.sdk.eth.getBalance([
                    (0, $2zCQC.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getCode":
                return this.sdk.eth.getCode([
                    (0, $2zCQC.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getTransactionCount":
                return this.sdk.eth.getTransactionCount([
                    (0, $2zCQC.getLowerCase)(params[0]),
                    params[1]
                ]);
            case "eth_getStorageAt":
                return this.sdk.eth.getStorageAt([
                    (0, $2zCQC.getLowerCase)(params[0]),
                    params[1],
                    params[2]
                ]);
            case "eth_getBlockByNumber":
                return this.sdk.eth.getBlockByNumber([
                    params[0],
                    params[1]
                ]);
            case "eth_getBlockByHash":
                return this.sdk.eth.getBlockByHash([
                    params[0],
                    params[1]
                ]);
            case "eth_getTransactionByHash":
                let txHash = params[0];
                try {
                    const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                    txHash = resp.txHash || txHash;
                } catch (e) {}
                // Use fake transaction if we don't have a real tx hash
                if (this.submittedTxs.has(txHash)) return this.submittedTxs.get(txHash);
                return this.sdk.eth.getTransactionByHash([
                    txHash
                ]).then((tx)=>{
                    // We set the tx hash to the one requested, as some provider assert this
                    if (tx) tx.hash = params[0];
                    return tx;
                });
            case "eth_getTransactionReceipt":
                {
                    let txHash = params[0];
                    try {
                        const resp = await this.sdk.txs.getBySafeTxHash(txHash);
                        txHash = resp.txHash || txHash;
                    } catch (e) {}
                    return this.sdk.eth.getTransactionReceipt([
                        txHash
                    ]).then((tx)=>{
                        // We set the tx hash to the one requested, as some provider assert this
                        if (tx) tx.transactionHash = params[0];
                        return tx;
                    });
                }
            case "eth_estimateGas":
                return this.sdk.eth.getEstimateGas(params[0]);
            case "eth_call":
                return this.sdk.eth.call([
                    params[0],
                    params[1]
                ]);
            case "eth_getLogs":
                return this.sdk.eth.getPastLogs([
                    params[0]
                ]);
            case "eth_gasPrice":
                return this.sdk.eth.getGasPrice();
            case "wallet_getPermissions":
                return this.sdk.wallet.getPermissions();
            case "wallet_requestPermissions":
                return this.sdk.wallet.requestPermissions(params[0]);
            case "safe_setSettings":
                return this.sdk.eth.setSafeSettings([
                    params[0]
                ]);
            default:
                throw Error(`"${request.method}" not implemented`);
        }
    }
    // this method is needed for ethers v4
    // https://github.com/ethers-io/ethers.js/blob/427e16826eb15d52d25c4f01027f8db22b74b76c/src.ts/providers/web3-provider.ts#L41-L55
    send(request, callback) {
        if (!request) callback("Undefined request");
        this.request(request).then((result)=>callback(null, {
                jsonrpc: "2.0",
                id: request.id,
                result: result
            })).catch((error)=>callback(error, null));
    }
}
module.exports.SafeAppProvider = $f8eb88e9f6f1a4f4$var$SafeAppProvider;

});
parcelRegister("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9f5191ad6e142a03$var$R = typeof Reflect === "object" ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === "function" ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === "function") $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("2zCQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLowerCase = void 0;
function $1dfcfbff167cb97a$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
module.exports.getLowerCase = $1dfcfbff167cb97a$var$getLowerCase;

});



parcelRegister("a2xSs", function(module, exports) {
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("3IwI3")).TransactionStatus; });

$parcel$export(module.exports, "default", function () { return $74f45ea42662c1f5$export$2e2bcd8739ae039; });

var $7om7r = parcelRequire("7om7r");
parcelRequire("5rhNo");
parcelRequire("5NJYn");
parcelRequire("7hiqm");

var $1CgRe = parcelRequire("1CgRe");
parcelRequire("ezDEC");
var $74f45ea42662c1f5$export$2e2bcd8739ae039 = (0, $7om7r.default);

});
parcelRegister("7om7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561beea7e1aa02b9$export$2e2bcd8739ae039; });

var $4f2OK = parcelRequire("4f2OK");

var $gyCfU = parcelRequire("gyCfU");

var $3eAp2 = parcelRequire("3eAp2");

var $fdRBL = parcelRequire("fdRBL");

var $1JiNB = parcelRequire("1JiNB");
class $561beea7e1aa02b9$var$SafeAppsSDK {
    constructor(opts = {}){
        const { allowedDomains: allowedDomains = null, debug: debug = false } = opts;
        this.communicator = new (0, $4f2OK.default)(allowedDomains, debug);
        this.eth = new (0, $3eAp2.Eth)(this.communicator);
        this.txs = new (0, $gyCfU.TXs)(this.communicator);
        this.safe = new (0, $fdRBL.Safe)(this.communicator);
        this.wallet = new (0, $1JiNB.Wallet)(this.communicator);
    }
}
var $561beea7e1aa02b9$export$2e2bcd8739ae039 = $561beea7e1aa02b9$var$SafeAppsSDK;

});
parcelRegister("4f2OK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $316abf9d7db2d0be$export$2e2bcd8739ae039; });

var $7hiqm = parcelRequire("7hiqm");
parcelRequire("5NJYn");
class $316abf9d7db2d0be$var$PostMessageCommunicator {
    constructor(allowedOrigins = null, debugMode = false){
        this.allowedOrigins = null;
        this.callbacks = new Map();
        this.debugMode = false;
        this.isServer = typeof window === "undefined";
        this.isValidMessage = ({ origin: origin, data: data, source: source })=>{
            const emptyOrMalformed = !data;
            const sentFromParentEl = !this.isServer && source === window.parent;
            const majorVersionNumber = typeof data.version !== "undefined" && parseInt(data.version.split(".")[0]);
            const allowedSDKVersion = typeof majorVersionNumber === "number" && majorVersionNumber >= 1;
            let validOrigin = true;
            if (Array.isArray(this.allowedOrigins)) validOrigin = this.allowedOrigins.find((regExp)=>regExp.test(origin)) !== undefined;
            return !emptyOrMalformed && sentFromParentEl && allowedSDKVersion && validOrigin;
        };
        this.logIncomingMessage = (msg)=>{
            console.info(`Safe Apps SDK v1: A message was received from origin ${msg.origin}. `, msg.data);
        };
        this.onParentMessage = (msg)=>{
            if (this.isValidMessage(msg)) {
                this.debugMode && this.logIncomingMessage(msg);
                this.handleIncomingMessage(msg.data);
            }
        };
        this.handleIncomingMessage = (payload)=>{
            const { id: id } = payload;
            const cb = this.callbacks.get(id);
            if (cb) {
                cb(payload);
                this.callbacks.delete(id);
            }
        };
        this.send = (method, params)=>{
            const request = (0, $7hiqm.MessageFormatter).makeRequest(method, params);
            if (this.isServer) throw new Error("Window doesn't exist");
            window.parent.postMessage(request, "*");
            return new Promise((resolve, reject)=>{
                this.callbacks.set(request.id, (response)=>{
                    if (!response.success) {
                        reject(new Error(response.error));
                        return;
                    }
                    resolve(response);
                });
            });
        };
        this.allowedOrigins = allowedOrigins;
        this.debugMode = debugMode;
        if (!this.isServer) window.addEventListener("message", this.onParentMessage);
    }
}
var $316abf9d7db2d0be$export$2e2bcd8739ae039 = $316abf9d7db2d0be$var$PostMessageCommunicator;

});
parcelRegister("7hiqm", function(module, exports) {

$parcel$export(module.exports, "MessageFormatter", function () { return $54c86992bf2d112d$export$526ebc05ff964723; });

var $1CgRe = parcelRequire("1CgRe");

var $juioh = parcelRequire("juioh");
class $54c86992bf2d112d$export$526ebc05ff964723 {
}
$54c86992bf2d112d$export$526ebc05ff964723.makeRequest = (method, params)=>{
    const id = (0, $juioh.generateRequestId)();
    return {
        id: id,
        method: method,
        params: params,
        env: {
            sdkVersion: (0, $1CgRe.getSDKVersion)()
        }
    };
};
$54c86992bf2d112d$export$526ebc05ff964723.makeResponse = (id, data, version)=>({
        id: id,
        success: true,
        version: version,
        data: data
    });
$54c86992bf2d112d$export$526ebc05ff964723.makeErrorResponse = (id, error, version)=>({
        id: id,
        success: false,
        error: error,
        version: version
    });

});
parcelRegister("1CgRe", function(module, exports) {

$parcel$export(module.exports, "getSDKVersion", function () { return $12d66aa247f69f5f$export$31f5a83d65f30cbf; });
const $12d66aa247f69f5f$export$31f5a83d65f30cbf = ()=>"9.1.0";

});

parcelRegister("juioh", function(module, exports) {

$parcel$export(module.exports, "generateRequestId", function () { return $e2ff15ad69431b27$export$adb840ec535541d1; });
// i.e. 0-255 -> '00'-'ff'
const $e2ff15ad69431b27$var$dec2hex = (dec)=>dec.toString(16).padStart(2, "0");
const $e2ff15ad69431b27$var$generateId = (len)=>{
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, $e2ff15ad69431b27$var$dec2hex).join("");
};
const $e2ff15ad69431b27$export$adb840ec535541d1 = ()=>{
    if (typeof window !== "undefined") return $e2ff15ad69431b27$var$generateId(10);
    return new Date().getTime().toString(36);
};

});


parcelRegister("5NJYn", function(module, exports) {

$parcel$export(module.exports, "Methods", function () { return $43953097941d61cb$export$abe5cd09e951a89a; });
$parcel$export(module.exports, "RestrictedMethods", function () { return $43953097941d61cb$export$4ac6b1b5d280d305; });
var $43953097941d61cb$export$abe5cd09e951a89a;
(function(Methods) {
    Methods["sendTransactions"] = "sendTransactions";
    Methods["rpcCall"] = "rpcCall";
    Methods["getChainInfo"] = "getChainInfo";
    Methods["getSafeInfo"] = "getSafeInfo";
    Methods["getTxBySafeTxHash"] = "getTxBySafeTxHash";
    Methods["getSafeBalances"] = "getSafeBalances";
    Methods["signMessage"] = "signMessage";
    Methods["signTypedMessage"] = "signTypedMessage";
    Methods["getEnvironmentInfo"] = "getEnvironmentInfo";
    Methods["getOffChainSignature"] = "getOffChainSignature";
    Methods["requestAddressBook"] = "requestAddressBook";
    Methods["wallet_getPermissions"] = "wallet_getPermissions";
    Methods["wallet_requestPermissions"] = "wallet_requestPermissions";
})($43953097941d61cb$export$abe5cd09e951a89a || ($43953097941d61cb$export$abe5cd09e951a89a = {}));
var $43953097941d61cb$export$4ac6b1b5d280d305;
(function(RestrictedMethods) {
    RestrictedMethods["requestAddressBook"] = "requestAddressBook";
})($43953097941d61cb$export$4ac6b1b5d280d305 || ($43953097941d61cb$export$4ac6b1b5d280d305 = {}));

});


parcelRegister("gyCfU", function(module, exports) {

$parcel$export(module.exports, "TXs", function () { return $c0dd7f13b21cbf04$export$fb5246409507224d; });

var $5NJYn = parcelRequire("5NJYn");
parcelRequire("5rhNo");
var $l1Ioo = parcelRequire("l1Ioo");
class $c0dd7f13b21cbf04$export$fb5246409507224d {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getBySafeTxHash(safeTxHash) {
        if (!safeTxHash) throw new Error("Invalid safeTxHash");
        const response = await this.communicator.send((0, $5NJYn.Methods).getTxBySafeTxHash, {
            safeTxHash: safeTxHash
        });
        return response.data;
    }
    async signMessage(message) {
        const messagePayload = {
            message: message
        };
        const response = await this.communicator.send((0, $5NJYn.Methods).signMessage, messagePayload);
        return response.data;
    }
    async signTypedMessage(typedData) {
        if (!(0, $l1Ioo.isObjectEIP712TypedData)(typedData)) throw new Error("Invalid typed data");
        const response = await this.communicator.send((0, $5NJYn.Methods).signTypedMessage, {
            typedData: typedData
        });
        return response.data;
    }
    async send({ txs: txs, params: params }) {
        if (!txs || !txs.length) throw new Error("No transactions were passed");
        const messagePayload = {
            txs: txs,
            params: params
        };
        const response = await this.communicator.send((0, $5NJYn.Methods).sendTransactions, messagePayload);
        return response.data;
    }
}

});
parcelRegister("5rhNo", function(module, exports) {
$parcel$export(module.exports, "isObjectEIP712TypedData", function () { return (parcelRequire("l1Ioo")).isObjectEIP712TypedData; });
$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("3IwI3")).TransactionStatus; });
parcelRequire("l1Ioo");
parcelRequire("7BVsJ");
parcelRequire("fQw9n");
parcelRequire("123rG");

});
parcelRegister("l1Ioo", function(module, exports) {

$parcel$export(module.exports, "isObjectEIP712TypedData", function () { return $f4ec205b76401921$export$a3ca91f403a95d3a; });
const $f4ec205b76401921$export$a3ca91f403a95d3a = (obj)=>{
    return typeof obj === "object" && obj != null && "domain" in obj && "types" in obj && "message" in obj;
};

});

parcelRegister("7BVsJ", function(module, exports) {

});

parcelRegister("fQw9n", function(module, exports) {

$parcel$export(module.exports, "TransactionStatus", function () { return (parcelRequire("3IwI3")).TransactionStatus; });

var $3IwI3 = parcelRequire("3IwI3");

});
parcelRegister("3IwI3", function(module, exports) {
"use strict";
var $2b4eda9d98a44179$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b4eda9d98a44179$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b4eda9d98a44179$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unregisterDevice = module.exports.unregisterSafe = module.exports.registerDevice = module.exports.getDelegates = module.exports.confirmSafeMessage = module.exports.proposeSafeMessage = module.exports.getSafeMessage = module.exports.getSafeMessages = module.exports.getDecodedData = module.exports.getMasterCopies = module.exports.getSafeApps = module.exports.getChainConfig = module.exports.getChainsConfig = module.exports.proposeTransaction = module.exports.getNonces = module.exports.postSafeGasEstimation = module.exports.getTransactionDetails = module.exports.getTransactionQueue = module.exports.getTransactionHistory = module.exports.getCollectiblesPage = module.exports.getCollectibles = module.exports.getOwnedSafes = module.exports.getFiatCurrencies = module.exports.getBalances = module.exports.getMultisigTransactions = module.exports.getModuleTransactions = module.exports.getIncomingTransfers = module.exports.getSafeInfo = module.exports.setBaseUrl = void 0;

var $fNiMH = parcelRequire("fNiMH");

var $fmidM = parcelRequire("fmidM");

$2b4eda9d98a44179$var$__exportStar((parcelRequire("etqbL")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("7v5VD")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("1EjaA")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("cBYe0")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("3sBiO")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("inOe3")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("5WrS5")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("2Nzrp")), module.exports);

$2b4eda9d98a44179$var$__exportStar((parcelRequire("l8BzW")), module.exports);
// Can be set externally to a different CGW host
let $2b4eda9d98a44179$var$baseUrl = $fmidM.DEFAULT_BASE_URL;
/**
 * Set the base CGW URL
 */ const $2b4eda9d98a44179$var$setBaseUrl = (url)=>{
    $2b4eda9d98a44179$var$baseUrl = url;
};
module.exports.setBaseUrl = $2b4eda9d98a44179$var$setBaseUrl;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Get basic information about a Safe. E.g. owners, modules, version etc
 */ function $2b4eda9d98a44179$var$getSafeInfo(chainId, address) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getSafeInfo = $2b4eda9d98a44179$var$getSafeInfo;
/**
 * Get filterable list of incoming transactions
 */ function $2b4eda9d98a44179$var$getIncomingTransfers(chainId, address, query, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/incoming-transfers/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getIncomingTransfers = $2b4eda9d98a44179$var$getIncomingTransfers;
/**
 * Get filterable list of module transactions
 */ function $2b4eda9d98a44179$var$getModuleTransactions(chainId, address, query, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/module-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getModuleTransactions = $2b4eda9d98a44179$var$getModuleTransactions;
/**
 * Get filterable list of multisig transactions
 */ function $2b4eda9d98a44179$var$getMultisigTransactions(chainId, address, query, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/multisig-transactions/", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getMultisigTransactions = $2b4eda9d98a44179$var$getMultisigTransactions;
/**
 * Get the total balance and all assets stored in a Safe
 */ function $2b4eda9d98a44179$var$getBalances(chainId, address, currency = "usd", query = {}) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/balances/{currency}", {
        path: {
            chainId: chainId,
            address: address,
            currency: currency
        },
        query: query
    });
}
module.exports.getBalances = $2b4eda9d98a44179$var$getBalances;
/**
 * Get a list of supported fiat currencies (e.g. USD, EUR etc)
 */ function $2b4eda9d98a44179$var$getFiatCurrencies() {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/balances/supported-fiat-codes");
}
module.exports.getFiatCurrencies = $2b4eda9d98a44179$var$getFiatCurrencies;
/**
 * Get the addresses of all Safes belonging to an owner
 */ function $2b4eda9d98a44179$var$getOwnedSafes(chainId, address) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/owners/{address}/safes", {
        path: {
            chainId: chainId,
            address: address
        }
    });
}
module.exports.getOwnedSafes = $2b4eda9d98a44179$var$getOwnedSafes;
/**
 * Get NFTs stored in a Safe
 */ function $2b4eda9d98a44179$var$getCollectibles(chainId, address, query = {}) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    });
}
module.exports.getCollectibles = $2b4eda9d98a44179$var$getCollectibles;
/**
 * Get NFTs stored in a Safe
 */ function $2b4eda9d98a44179$var$getCollectiblesPage(chainId, address, query = {}, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v2/chains/{chainId}/safes/{address}/collectibles", {
        path: {
            chainId: chainId,
            address: address
        },
        query: query
    }, pageUrl);
}
module.exports.getCollectiblesPage = $2b4eda9d98a44179$var$getCollectiblesPage;
/**
 * Get a list of past Safe transactions
 */ function $2b4eda9d98a44179$var$getTransactionHistory(chainId, address, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/history", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getTransactionHistory = $2b4eda9d98a44179$var$getTransactionHistory;
/**
 * Get the list of pending transactions
 */ function $2b4eda9d98a44179$var$getTransactionQueue(chainId, address, pageUrl, trusted) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/transactions/queued", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {
            trusted: trusted
        }
    }, pageUrl);
}
module.exports.getTransactionQueue = $2b4eda9d98a44179$var$getTransactionQueue;
/**
 * Get the details of an individual transaction by its id
 */ function $2b4eda9d98a44179$var$getTransactionDetails(chainId, transactionId) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/transactions/{transactionId}", {
        path: {
            chainId: chainId,
            transactionId: transactionId
        }
    });
}
module.exports.getTransactionDetails = $2b4eda9d98a44179$var$getTransactionDetails;
/**
 * Request a gas estimate & recommmended tx nonce for a created transaction
 */ function $2b4eda9d98a44179$var$postSafeGasEstimation(chainId, address, body) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v2/chains/{chainId}/safes/{safe_address}/multisig-transactions/estimations", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.postSafeGasEstimation = $2b4eda9d98a44179$var$postSafeGasEstimation;
function $2b4eda9d98a44179$var$getNonces(chainId, address) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/nonces", {
        path: {
            chainId: chainId,
            safe_address: address
        }
    });
}
module.exports.getNonces = $2b4eda9d98a44179$var$getNonces;
/**
 * Propose a new transaction for other owners to sign/execute
 */ function $2b4eda9d98a44179$var$proposeTransaction(chainId, address, body) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/transactions/{safe_address}/propose", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeTransaction = $2b4eda9d98a44179$var$proposeTransaction;
/**
 * Returns all defined chain configs
 */ function $2b4eda9d98a44179$var$getChainsConfig(query) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains", {
        query: query
    });
}
module.exports.getChainsConfig = $2b4eda9d98a44179$var$getChainsConfig;
/**
 * Returns a chain config
 */ function $2b4eda9d98a44179$var$getChainConfig(chainId) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getChainConfig = $2b4eda9d98a44179$var$getChainConfig;
/**
 * Returns Safe Apps List
 */ function $2b4eda9d98a44179$var$getSafeApps(chainId, query = {}) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safe-apps", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getSafeApps = $2b4eda9d98a44179$var$getSafeApps;
/**
 * Returns list of Master Copies
 */ function $2b4eda9d98a44179$var$getMasterCopies(chainId) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/about/master-copies", {
        path: {
            chainId: chainId
        }
    });
}
module.exports.getMasterCopies = $2b4eda9d98a44179$var$getMasterCopies;
/**
 * Returns decoded data
 */ function $2b4eda9d98a44179$var$getDecodedData(chainId, encodedData, to) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/data-decoder", {
        path: {
            chainId: chainId
        },
        body: {
            data: encodedData,
            to: to
        }
    });
}
module.exports.getDecodedData = $2b4eda9d98a44179$var$getDecodedData;
/**
 * Returns list of `SafeMessage`s
 */ function $2b4eda9d98a44179$var$getSafeMessages(chainId, address, pageUrl) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        query: {}
    }, pageUrl);
}
module.exports.getSafeMessages = $2b4eda9d98a44179$var$getSafeMessages;
/**
 * Returns a `SafeMessage`
 */ function $2b4eda9d98a44179$var$getSafeMessage(chainId, messageHash) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        }
    });
}
module.exports.getSafeMessage = $2b4eda9d98a44179$var$getSafeMessage;
/**
 * Propose a new `SafeMessage` for other owners to sign
 */ function $2b4eda9d98a44179$var$proposeSafeMessage(chainId, address, body) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/safes/{safe_address}/messages", {
        path: {
            chainId: chainId,
            safe_address: address
        },
        body: body
    });
}
module.exports.proposeSafeMessage = $2b4eda9d98a44179$var$proposeSafeMessage;
/**
 * Add a confirmation to a `SafeMessage`
 */ function $2b4eda9d98a44179$var$confirmSafeMessage(chainId, messageHash, body) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/messages/{message_hash}/signatures", {
        path: {
            chainId: chainId,
            message_hash: messageHash
        },
        body: body
    });
}
module.exports.confirmSafeMessage = $2b4eda9d98a44179$var$confirmSafeMessage;
/**
 * Returns a list of delegates
 */ function $2b4eda9d98a44179$var$getDelegates(chainId, query = {}) {
    return (0, $fNiMH.getEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/delegates", {
        path: {
            chainId: chainId
        },
        query: query
    });
}
module.exports.getDelegates = $2b4eda9d98a44179$var$getDelegates;
/**
 * Registers a device/Safe for notifications
 */ function $2b4eda9d98a44179$var$registerDevice(body) {
    return (0, $fNiMH.postEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/register/notifications", {
        body: body
    });
}
module.exports.registerDevice = $2b4eda9d98a44179$var$registerDevice;
/**
 * Unregisters a Safe from notifications
 */ function $2b4eda9d98a44179$var$unregisterSafe(chainId, address, uuid) {
    return (0, $fNiMH.deleteEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}/safes/{safe_address}", {
        path: {
            chainId: chainId,
            safe_address: address,
            uuid: uuid
        }
    });
}
module.exports.unregisterSafe = $2b4eda9d98a44179$var$unregisterSafe;
/**
 * Unregisters a device from notifications
 */ function $2b4eda9d98a44179$var$unregisterDevice(chainId, uuid) {
    return (0, $fNiMH.deleteEndpoint)($2b4eda9d98a44179$var$baseUrl, "/v1/chains/{chainId}/notifications/devices/{uuid}", {
        path: {
            chainId: chainId,
            uuid: uuid
        }
    });
}
module.exports.unregisterDevice = $2b4eda9d98a44179$var$unregisterDevice; /* eslint-enable @typescript-eslint/explicit-module-boundary-types */ 

});
parcelRegister("fNiMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteEndpoint = module.exports.getEndpoint = module.exports.postEndpoint = void 0;

var $5x6om = parcelRequire("5x6om");
function $b7fa00cd09a40658$var$makeUrl(baseUrl, path, pathParams, query) {
    const pathname = (0, $5x6om.insertParams)(path, pathParams);
    const search = (0, $5x6om.stringifyQuery)(query);
    return `${baseUrl}${pathname}${search}`;
}
function $b7fa00cd09a40658$var$postEndpoint(baseUrl, path, params) {
    const url = $b7fa00cd09a40658$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $5x6om.fetchData)(url, params === null || params === void 0 ? void 0 : params.body);
}
module.exports.postEndpoint = $b7fa00cd09a40658$var$postEndpoint;
function $b7fa00cd09a40658$var$getEndpoint(baseUrl, path, params, rawUrl) {
    if (rawUrl) return (0, $5x6om.fetchData)(rawUrl);
    const url = $b7fa00cd09a40658$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path, params === null || params === void 0 ? void 0 : params.query);
    return (0, $5x6om.fetchData)(url);
}
module.exports.getEndpoint = $b7fa00cd09a40658$var$getEndpoint;
function $b7fa00cd09a40658$var$deleteEndpoint(baseUrl, path, params) {
    const url = $b7fa00cd09a40658$var$makeUrl(baseUrl, path, params === null || params === void 0 ? void 0 : params.path);
    return (0, $5x6om.deleteData)(url);
}
module.exports.deleteEndpoint = $b7fa00cd09a40658$var$deleteEndpoint;

});
parcelRegister("5x6om", function(module, exports) {
"use strict";
var $4074fe228119ed78$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deleteData = module.exports.fetchData = module.exports.stringifyQuery = module.exports.insertParams = void 0;
const $4074fe228119ed78$var$isErrorResponse = (data)=>{
    const isObject = typeof data === "object" && data !== null;
    return isObject && "code" in data && "message" in data;
};
function $4074fe228119ed78$var$replaceParam(str, key, value) {
    return str.replace(new RegExp(`\\{${key}\\}`, "g"), value);
}
function $4074fe228119ed78$var$insertParams(template, params) {
    return params ? Object.keys(params).reduce((result, key)=>{
        return $4074fe228119ed78$var$replaceParam(result, key, String(params[key]));
    }, template) : template;
}
module.exports.insertParams = $4074fe228119ed78$var$insertParams;
function $4074fe228119ed78$var$stringifyQuery(query) {
    if (!query) return "";
    const searchParams = new URLSearchParams();
    Object.keys(query).forEach((key)=>{
        if (query[key] != null) searchParams.append(key, String(query[key]));
    });
    const searchString = searchParams.toString();
    return searchString ? `?${searchString}` : "";
}
module.exports.stringifyQuery = $4074fe228119ed78$var$stringifyQuery;
function $4074fe228119ed78$var$parseResponse(resp) {
    return $4074fe228119ed78$var$__awaiter(this, void 0, void 0, function*() {
        let json;
        try {
            json = yield resp.json();
        } catch (_a) {
            if (resp.headers && resp.headers.get("content-length") !== "0") throw new Error(`Invalid response content: ${resp.statusText}`);
        }
        if (!resp.ok) {
            const errTxt = $4074fe228119ed78$var$isErrorResponse(json) ? `${json.code}: ${json.message}` : resp.statusText;
            throw new Error(errTxt);
        }
        return json;
    });
}
function $4074fe228119ed78$var$fetchData(url, body) {
    return $4074fe228119ed78$var$__awaiter(this, void 0, void 0, function*() {
        let options;
        if (body != null) options = {
            method: "POST",
            body: typeof body === "string" ? body : JSON.stringify(body),
            headers: {
                "Content-Type": "application/json"
            }
        };
        const resp = yield fetch(url, options);
        return $4074fe228119ed78$var$parseResponse(resp);
    });
}
module.exports.fetchData = $4074fe228119ed78$var$fetchData;
function $4074fe228119ed78$var$deleteData(url) {
    return $4074fe228119ed78$var$__awaiter(this, void 0, void 0, function*() {
        const options = {
            method: "DELETE"
        };
        const resp = yield fetch(url, options);
        return $4074fe228119ed78$var$parseResponse(resp);
    });
}
module.exports.deleteData = $4074fe228119ed78$var$deleteData;

});


parcelRegister("fmidM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BASE_URL = void 0;
module.exports.DEFAULT_BASE_URL = "https://safe-client.safe.global";

});

parcelRegister("etqbL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImplementationVersionState = void 0;
var $a89816a5d7000f35$var$ImplementationVersionState;
(function(ImplementationVersionState) {
    ImplementationVersionState["UP_TO_DATE"] = "UP_TO_DATE";
    ImplementationVersionState["OUTDATED"] = "OUTDATED";
    ImplementationVersionState["UNKNOWN"] = "UNKNOWN";
})($a89816a5d7000f35$var$ImplementationVersionState = module.exports.ImplementationVersionState || (module.exports.ImplementationVersionState = {}));

});

parcelRegister("7v5VD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeAppSocialPlatforms = module.exports.SafeAppFeatures = module.exports.SafeAppAccessPolicyTypes = void 0;
var $576006f07f0e35e6$var$SafeAppAccessPolicyTypes;
(function(SafeAppAccessPolicyTypes) {
    SafeAppAccessPolicyTypes["NoRestrictions"] = "NO_RESTRICTIONS";
    SafeAppAccessPolicyTypes["DomainAllowlist"] = "DOMAIN_ALLOWLIST";
})($576006f07f0e35e6$var$SafeAppAccessPolicyTypes = module.exports.SafeAppAccessPolicyTypes || (module.exports.SafeAppAccessPolicyTypes = {}));
var $576006f07f0e35e6$var$SafeAppFeatures;
(function(SafeAppFeatures) {
    SafeAppFeatures["BATCHED_TRANSACTIONS"] = "BATCHED_TRANSACTIONS";
})($576006f07f0e35e6$var$SafeAppFeatures = module.exports.SafeAppFeatures || (module.exports.SafeAppFeatures = {}));
var $576006f07f0e35e6$var$SafeAppSocialPlatforms;
(function(SafeAppSocialPlatforms) {
    SafeAppSocialPlatforms["TWITTER"] = "TWITTER";
    SafeAppSocialPlatforms["GITHUB"] = "GITHUB";
    SafeAppSocialPlatforms["DISCORD"] = "DISCORD";
})($576006f07f0e35e6$var$SafeAppSocialPlatforms = module.exports.SafeAppSocialPlatforms || (module.exports.SafeAppSocialPlatforms = {}));

});

parcelRegister("1EjaA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LabelValue = module.exports.DetailedExecutionInfoType = module.exports.TransactionListItemType = module.exports.ConflictType = module.exports.TransactionInfoType = module.exports.SettingsInfoType = module.exports.TransactionTokenType = module.exports.TransferDirection = module.exports.TransactionStatus = module.exports.Operation = void 0;
var $13386590fbbd8766$var$Operation;
(function(Operation) {
    Operation[Operation["CALL"] = 0] = "CALL";
    Operation[Operation["DELEGATE"] = 1] = "DELEGATE";
})($13386590fbbd8766$var$Operation = module.exports.Operation || (module.exports.Operation = {}));
var $13386590fbbd8766$var$TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus["AWAITING_CONFIRMATIONS"] = "AWAITING_CONFIRMATIONS";
    TransactionStatus["AWAITING_EXECUTION"] = "AWAITING_EXECUTION";
    TransactionStatus["CANCELLED"] = "CANCELLED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["SUCCESS"] = "SUCCESS";
})($13386590fbbd8766$var$TransactionStatus = module.exports.TransactionStatus || (module.exports.TransactionStatus = {}));
var $13386590fbbd8766$var$TransferDirection;
(function(TransferDirection) {
    TransferDirection["INCOMING"] = "INCOMING";
    TransferDirection["OUTGOING"] = "OUTGOING";
    TransferDirection["UNKNOWN"] = "UNKNOWN";
})($13386590fbbd8766$var$TransferDirection = module.exports.TransferDirection || (module.exports.TransferDirection = {}));
var $13386590fbbd8766$var$TransactionTokenType;
(function(TransactionTokenType) {
    TransactionTokenType["ERC20"] = "ERC20";
    TransactionTokenType["ERC721"] = "ERC721";
    TransactionTokenType["NATIVE_COIN"] = "NATIVE_COIN";
})($13386590fbbd8766$var$TransactionTokenType = module.exports.TransactionTokenType || (module.exports.TransactionTokenType = {}));
var $13386590fbbd8766$var$SettingsInfoType;
(function(SettingsInfoType) {
    SettingsInfoType["SET_FALLBACK_HANDLER"] = "SET_FALLBACK_HANDLER";
    SettingsInfoType["ADD_OWNER"] = "ADD_OWNER";
    SettingsInfoType["REMOVE_OWNER"] = "REMOVE_OWNER";
    SettingsInfoType["SWAP_OWNER"] = "SWAP_OWNER";
    SettingsInfoType["CHANGE_THRESHOLD"] = "CHANGE_THRESHOLD";
    SettingsInfoType["CHANGE_IMPLEMENTATION"] = "CHANGE_IMPLEMENTATION";
    SettingsInfoType["ENABLE_MODULE"] = "ENABLE_MODULE";
    SettingsInfoType["DISABLE_MODULE"] = "DISABLE_MODULE";
    SettingsInfoType["SET_GUARD"] = "SET_GUARD";
    SettingsInfoType["DELETE_GUARD"] = "DELETE_GUARD";
})($13386590fbbd8766$var$SettingsInfoType = module.exports.SettingsInfoType || (module.exports.SettingsInfoType = {}));
var $13386590fbbd8766$var$TransactionInfoType;
(function(TransactionInfoType) {
    TransactionInfoType["TRANSFER"] = "Transfer";
    TransactionInfoType["SETTINGS_CHANGE"] = "SettingsChange";
    TransactionInfoType["CUSTOM"] = "Custom";
    TransactionInfoType["CREATION"] = "Creation";
})($13386590fbbd8766$var$TransactionInfoType = module.exports.TransactionInfoType || (module.exports.TransactionInfoType = {}));
var $13386590fbbd8766$var$ConflictType;
(function(ConflictType) {
    ConflictType["NONE"] = "None";
    ConflictType["HAS_NEXT"] = "HasNext";
    ConflictType["END"] = "End";
})($13386590fbbd8766$var$ConflictType = module.exports.ConflictType || (module.exports.ConflictType = {}));
var $13386590fbbd8766$var$TransactionListItemType;
(function(TransactionListItemType) {
    TransactionListItemType["TRANSACTION"] = "TRANSACTION";
    TransactionListItemType["LABEL"] = "LABEL";
    TransactionListItemType["CONFLICT_HEADER"] = "CONFLICT_HEADER";
    TransactionListItemType["DATE_LABEL"] = "DATE_LABEL";
})($13386590fbbd8766$var$TransactionListItemType = module.exports.TransactionListItemType || (module.exports.TransactionListItemType = {}));
var $13386590fbbd8766$var$DetailedExecutionInfoType;
(function(DetailedExecutionInfoType) {
    DetailedExecutionInfoType["MULTISIG"] = "MULTISIG";
    DetailedExecutionInfoType["MODULE"] = "MODULE";
})($13386590fbbd8766$var$DetailedExecutionInfoType = module.exports.DetailedExecutionInfoType || (module.exports.DetailedExecutionInfoType = {}));
var $13386590fbbd8766$var$LabelValue;
(function(LabelValue) {
    LabelValue["Queued"] = "Queued";
    LabelValue["Next"] = "Next";
})($13386590fbbd8766$var$LabelValue = module.exports.LabelValue || (module.exports.LabelValue = {}));

});

parcelRegister("cBYe0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FEATURES = module.exports.GAS_PRICE_TYPE = module.exports.RPC_AUTHENTICATION = void 0;
var $92e7a81f699a0658$var$RPC_AUTHENTICATION;
(function(RPC_AUTHENTICATION) {
    RPC_AUTHENTICATION["API_KEY_PATH"] = "API_KEY_PATH";
    RPC_AUTHENTICATION["NO_AUTHENTICATION"] = "NO_AUTHENTICATION";
    RPC_AUTHENTICATION["UNKNOWN"] = "UNKNOWN";
})($92e7a81f699a0658$var$RPC_AUTHENTICATION = module.exports.RPC_AUTHENTICATION || (module.exports.RPC_AUTHENTICATION = {}));
var $92e7a81f699a0658$var$GAS_PRICE_TYPE;
(function(GAS_PRICE_TYPE) {
    GAS_PRICE_TYPE["ORACLE"] = "ORACLE";
    GAS_PRICE_TYPE["FIXED"] = "FIXED";
    GAS_PRICE_TYPE["FIXED_1559"] = "FIXED1559";
    GAS_PRICE_TYPE["UNKNOWN"] = "UNKNOWN";
})($92e7a81f699a0658$var$GAS_PRICE_TYPE = module.exports.GAS_PRICE_TYPE || (module.exports.GAS_PRICE_TYPE = {}));
var $92e7a81f699a0658$var$FEATURES;
(function(FEATURES) {
    FEATURES["ERC721"] = "ERC721";
    FEATURES["SAFE_APPS"] = "SAFE_APPS";
    FEATURES["CONTRACT_INTERACTION"] = "CONTRACT_INTERACTION";
    FEATURES["DOMAIN_LOOKUP"] = "DOMAIN_LOOKUP";
    FEATURES["SPENDING_LIMIT"] = "SPENDING_LIMIT";
    FEATURES["EIP1559"] = "EIP1559";
    FEATURES["SAFE_TX_GAS_OPTIONAL"] = "SAFE_TX_GAS_OPTIONAL";
    FEATURES["TX_SIMULATION"] = "TX_SIMULATION";
    FEATURES["EIP1271"] = "EIP1271";
})($92e7a81f699a0658$var$FEATURES = module.exports.FEATURES || (module.exports.FEATURES = {}));

});

parcelRegister("3sBiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenType = void 0;
var $2850ec1f9a508d22$var$TokenType;
(function(TokenType) {
    TokenType["ERC20"] = "ERC20";
    TokenType["ERC721"] = "ERC721";
    TokenType["NATIVE_TOKEN"] = "NATIVE_TOKEN";
})($2850ec1f9a508d22$var$TokenType = module.exports.TokenType || (module.exports.TokenType = {}));

});

parcelRegister("inOe3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5WrS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2Nzrp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeMessageStatus = module.exports.SafeMessageListItemType = void 0;
var $209ba63f855e1ff2$var$SafeMessageListItemType;
(function(SafeMessageListItemType) {
    SafeMessageListItemType["DATE_LABEL"] = "DATE_LABEL";
    SafeMessageListItemType["MESSAGE"] = "MESSAGE";
})($209ba63f855e1ff2$var$SafeMessageListItemType = module.exports.SafeMessageListItemType || (module.exports.SafeMessageListItemType = {}));
var $209ba63f855e1ff2$var$SafeMessageStatus;
(function(SafeMessageStatus) {
    SafeMessageStatus["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    SafeMessageStatus["CONFIRMED"] = "CONFIRMED";
})($209ba63f855e1ff2$var$SafeMessageStatus = module.exports.SafeMessageStatus || (module.exports.SafeMessageStatus = {}));

});

parcelRegister("l8BzW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeviceType = void 0;
var $f6377ea825182b30$var$DeviceType;
(function(DeviceType) {
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["IOS"] = "IOS";
    DeviceType["WEB"] = "WEB";
})($f6377ea825182b30$var$DeviceType = module.exports.DeviceType || (module.exports.DeviceType = {}));

});



parcelRegister("123rG", function(module, exports) {
parcelRequire("5NJYn");

});



parcelRegister("3eAp2", function(module, exports) {

$parcel$export(module.exports, "Eth", function () { return $25aeeac3f7c5c55e$export$4a8fe6f3e78a368a; });

var $ezDEC = parcelRequire("ezDEC");

var $5NJYn = parcelRequire("5NJYn");
const $25aeeac3f7c5c55e$var$inputFormatters = {
    defaultBlockParam: (arg = "latest")=>arg,
    returnFullTxObjectParam: (arg = false)=>arg,
    blockNumberToHex: (arg)=>Number.isInteger(arg) ? `0x${arg.toString(16)}` : arg
};
class $25aeeac3f7c5c55e$export$4a8fe6f3e78a368a {
    constructor(communicator){
        this.communicator = communicator;
        this.call = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_call,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getBalance = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getBalance,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getCode = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getCode,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getStorageAt = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getStorageAt,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.blockNumberToHex,
                $25aeeac3f7c5c55e$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getPastLogs = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getLogs
        });
        this.getBlockByHash = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getBlockByHash,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getBlockByNumber = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getBlockByNumber,
            formatters: [
                $25aeeac3f7c5c55e$var$inputFormatters.blockNumberToHex,
                $25aeeac3f7c5c55e$var$inputFormatters.returnFullTxObjectParam
            ]
        });
        this.getTransactionByHash = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getTransactionByHash
        });
        this.getTransactionReceipt = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getTransactionReceipt
        });
        this.getTransactionCount = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_getTransactionCount,
            formatters: [
                null,
                $25aeeac3f7c5c55e$var$inputFormatters.defaultBlockParam
            ]
        });
        this.getGasPrice = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).eth_gasPrice
        });
        this.getEstimateGas = (transaction)=>this.buildRequest({
                call: (0, $ezDEC.RPC_CALLS).eth_estimateGas
            })([
                transaction
            ]);
        this.setSafeSettings = this.buildRequest({
            call: (0, $ezDEC.RPC_CALLS).safe_setSettings
        });
    }
    buildRequest(args) {
        const { call: call, formatters: formatters } = args;
        return async (params)=>{
            if (formatters && Array.isArray(params)) formatters.forEach((formatter, i)=>{
                if (formatter) params[i] = formatter(params[i]);
            });
            const payload = {
                call: call,
                params: params || []
            };
            const response = await this.communicator.send((0, $5NJYn.Methods).rpcCall, payload);
            return response.data;
        };
    }
}

});
parcelRegister("ezDEC", function(module, exports) {

$parcel$export(module.exports, "RPC_CALLS", function () { return $a9c3180ecd8335b1$export$342bf17e2a7081dd; });
const $a9c3180ecd8335b1$export$342bf17e2a7081dd = {
    eth_call: "eth_call",
    eth_gasPrice: "eth_gasPrice",
    eth_getLogs: "eth_getLogs",
    eth_getBalance: "eth_getBalance",
    eth_getCode: "eth_getCode",
    eth_getBlockByHash: "eth_getBlockByHash",
    eth_getBlockByNumber: "eth_getBlockByNumber",
    eth_getStorageAt: "eth_getStorageAt",
    eth_getTransactionByHash: "eth_getTransactionByHash",
    eth_getTransactionReceipt: "eth_getTransactionReceipt",
    eth_getTransactionCount: "eth_getTransactionCount",
    eth_estimateGas: "eth_estimateGas",
    safe_setSettings: "safe_setSettings"
};

});


parcelRegister("fdRBL", function(module, exports) {

$parcel$export(module.exports, "Safe", function () { return $b151a75dfd83c52c$export$608e5f71f295e7a1; });

var $5gmNj = parcelRequire("5gmNj");
var $gdlQS = parcelRequire("gdlQS");
var $2znuB = parcelRequire("2znuB");

var $c8AwN = parcelRequire("c8AwN");

var $5NJYn = parcelRequire("5NJYn");

var $ezDEC = parcelRequire("ezDEC");
parcelRequire("5rhNo");
var $l1Ioo = parcelRequire("l1Ioo");

var $cU2ef = parcelRequire("cU2ef");
var $b151a75dfd83c52c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $b151a75dfd83c52c$export$608e5f71f295e7a1 {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getChainInfo() {
        const response = await this.communicator.send((0, $5NJYn.Methods).getChainInfo, undefined);
        return response.data;
    }
    async getInfo() {
        const response = await this.communicator.send((0, $5NJYn.Methods).getSafeInfo, undefined);
        return response.data;
    }
    // There is a possibility that this method will change because we may add pagination to the endpoint
    async experimental_getBalances({ currency: currency = "usd" } = {}) {
        const response = await this.communicator.send((0, $5NJYn.Methods).getSafeBalances, {
            currency: currency
        });
        return response.data;
    }
    async check1271Signature(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $5gmNj.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: "_dataHash",
                            type: "bytes32"
                        },
                        {
                            name: "_signature",
                            type: "bytes"
                        }
                    ],
                    name: "isValidSignature",
                    outputs: [
                        {
                            name: "",
                            type: "bytes4"
                        }
                    ],
                    payable: false,
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ],
            functionName: "isValidSignature",
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: (0, $ezDEC.RPC_CALLS).eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send((0, $5NJYn.Methods).rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === (0, $c8AwN.MAGIC_VALUE);
        } catch (err) {
            return false;
        }
    }
    async check1271SignatureBytes(messageHash, signature = "0x") {
        const safeInfo = await this.getInfo();
        const encodedIsValidSignatureCall = (0, $5gmNj.encodeFunctionData)({
            abi: [
                {
                    constant: false,
                    inputs: [
                        {
                            name: "_data",
                            type: "bytes"
                        },
                        {
                            name: "_signature",
                            type: "bytes"
                        }
                    ],
                    name: "isValidSignature",
                    outputs: [
                        {
                            name: "",
                            type: "bytes4"
                        }
                    ],
                    payable: false,
                    stateMutability: "nonpayable",
                    type: "function"
                }
            ],
            functionName: "isValidSignature",
            args: [
                messageHash,
                signature
            ]
        });
        const payload = {
            call: (0, $ezDEC.RPC_CALLS).eth_call,
            params: [
                {
                    to: safeInfo.safeAddress,
                    data: encodedIsValidSignatureCall
                },
                "latest"
            ]
        };
        try {
            const response = await this.communicator.send((0, $5NJYn.Methods).rpcCall, payload);
            return response.data.slice(0, 10).toLowerCase() === (0, $c8AwN.MAGIC_VALUE_BYTES);
        } catch (err) {
            return false;
        }
    }
    calculateMessageHash(message) {
        return (0, $gdlQS.hashMessage)(message);
    }
    calculateTypedMessageHash(typedMessage) {
        const chainId = typeof typedMessage.domain.chainId === "object" ? typedMessage.domain.chainId.toNumber() : Number(typedMessage.domain.chainId);
        let primaryType = typedMessage.primaryType;
        if (!primaryType) {
            const fields = Object.values(typedMessage.types);
            // We try to infer primaryType (simplified ether's version)
            const primaryTypes = Object.keys(typedMessage.types).filter((typeName)=>fields.every((dataTypes)=>dataTypes.every(({ type: type })=>type.replace("[", "").replace("]", "") !== typeName)));
            if (primaryTypes.length === 0 || primaryTypes.length > 1) throw new Error("Please specify primaryType");
            primaryType = primaryTypes[0];
        }
        return (0, $2znuB.hashTypedData)({
            message: typedMessage.message,
            domain: {
                ...typedMessage.domain,
                chainId: chainId,
                verifyingContract: typedMessage.domain.verifyingContract,
                salt: typedMessage.domain.salt
            },
            types: typedMessage.types,
            primaryType: primaryType
        });
    }
    async getOffChainSignature(messageHash) {
        const response = await this.communicator.send((0, $5NJYn.Methods).getOffChainSignature, messageHash);
        return response.data;
    }
    async isMessageSigned(message, signature = "0x") {
        let check;
        if (typeof message === "string") check = async ()=>{
            const messageHash = this.calculateMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if ((0, $l1Ioo.isObjectEIP712TypedData)(message)) check = async ()=>{
            const messageHash = this.calculateTypedMessageHash(message);
            const messageHashSigned = await this.isMessageHashSigned(messageHash, signature);
            return messageHashSigned;
        };
        if (check) {
            const isValid = await check();
            return isValid;
        }
        throw new Error("Invalid message type");
    }
    async isMessageHashSigned(messageHash, signature = "0x") {
        const checks = [
            this.check1271Signature.bind(this),
            this.check1271SignatureBytes.bind(this)
        ];
        for (const check of checks){
            const isValid = await check(messageHash, signature);
            if (isValid) return true;
        }
        return false;
    }
    async getEnvironmentInfo() {
        const response = await this.communicator.send((0, $5NJYn.Methods).getEnvironmentInfo, undefined);
        return response.data;
    }
    async requestAddressBook() {
        const response = await this.communicator.send((0, $5NJYn.Methods).requestAddressBook, undefined);
        return response.data;
    }
}
$b151a75dfd83c52c$var$__decorate([
    (0, $cU2ef.default)()
], $b151a75dfd83c52c$export$608e5f71f295e7a1.prototype, "requestAddressBook", null);

});
parcelRegister("5gmNj", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $3d5020db126ba84d$export$f4ee15df45da9f03; });

var $5mdyK = parcelRequire("5mdyK");

var $7ITwU = parcelRequire("7ITwU");

var $h6Lln = parcelRequire("h6Lln");
function $3d5020db126ba84d$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $h6Lln.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $7ITwU.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $5mdyK.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("5mdyK", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $3e698676fccd78ed$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $3e698676fccd78ed$export$f6cc0b64b5a999af; });
function $3e698676fccd78ed$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $3e698676fccd78ed$export$f6cc0b64b5a999af(values);
    return $3e698676fccd78ed$export$287dd7971339c972(values);
}
function $3e698676fccd78ed$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $3e698676fccd78ed$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("7ITwU", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $59f7b788597f5360$export$448ea0950d6dd7d7; });

var $hJ4aq = parcelRequire("hJ4aq");

var $gZZzN = parcelRequire("gZZzN");

var $3gTyY = parcelRequire("3gTyY");

var $71qyi = parcelRequire("71qyi");

var $5mdyK = parcelRequire("5mdyK");

var $j0E9O = parcelRequire("j0E9O");

var $3sEGT = parcelRequire("3sEGT");

var $eT7uQ = parcelRequire("eT7uQ");

var $TYK4e = parcelRequire("TYK4e");
function $59f7b788597f5360$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $hJ4aq.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $59f7b788597f5360$var$prepareParams({
        params: params,
        values: values
    });
    const data = $59f7b788597f5360$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $59f7b788597f5360$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($59f7b788597f5360$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $59f7b788597f5360$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $59f7b788597f5360$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $59f7b788597f5360$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $59f7b788597f5360$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $59f7b788597f5360$var$encodeAddress(value);
    if (param.type === "bool") return $59f7b788597f5360$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $59f7b788597f5360$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $59f7b788597f5360$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $59f7b788597f5360$var$encodeString(value);
    throw new (0, $hJ4aq.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $59f7b788597f5360$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $3sEGT.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $TYK4e.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $3sEGT.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $5mdyK.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $59f7b788597f5360$var$encodeAddress(value) {
    if (!(0, $71qyi.isAddress)(value)) throw new (0, $gZZzN.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $j0E9O.padHex)(value.toLowerCase())
    };
}
function $59f7b788597f5360$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $hJ4aq.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $hJ4aq.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $59f7b788597f5360$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $59f7b788597f5360$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $TYK4e.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $5mdyK.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $5mdyK.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $59f7b788597f5360$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $3sEGT.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $j0E9O.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $5mdyK.concat)([
                (0, $j0E9O.padHex)((0, $TYK4e.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $hJ4aq.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $j0E9O.padHex)(value, {
            dir: "right"
        })
    };
}
function $59f7b788597f5360$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $3gTyY.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $j0E9O.padHex)((0, $TYK4e.boolToHex)(value))
    };
}
function $59f7b788597f5360$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $TYK4e.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $59f7b788597f5360$var$encodeString(value) {
    const hexValue = (0, $TYK4e.stringToHex)(value);
    const partsLength = Math.ceil((0, $3sEGT.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $j0E9O.padHex)((0, $eT7uQ.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $5mdyK.concat)([
            (0, $j0E9O.padHex)((0, $TYK4e.numberToHex)((0, $3sEGT.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $59f7b788597f5360$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $59f7b788597f5360$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $59f7b788597f5360$var$encodeParams(preparedParams) : (0, $5mdyK.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $59f7b788597f5360$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("hJ4aq", function(module, exports) {

$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $ce79df266eec8ea6$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $ce79df266eec8ea6$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $ce79df266eec8ea6$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $ce79df266eec8ea6$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $ce79df266eec8ea6$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "BytesSizeMismatchError", function () { return $ce79df266eec8ea6$export$a0eb884ede5c87eb; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $ce79df266eec8ea6$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $ce79df266eec8ea6$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $ce79df266eec8ea6$export$81781a0fcfb9ed95; });

var $4skRo = parcelRequire("4skRo");

var $3sEGT = parcelRequire("3sEGT");

var $3gTyY = parcelRequire("3gTyY");
class $ce79df266eec8ea6$export$efa723f306cf6168 extends (0, $3gTyY.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$4faec14323ef9c47 extends (0, $3gTyY.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$68a7b570091cba69 extends (0, $3gTyY.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $ce79df266eec8ea6$export$7a409e433c5f3a8c extends (0, $3gTyY.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $4skRo.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $ce79df266eec8ea6$export$a063cde4013f1935 extends (0, $3gTyY.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $ce79df266eec8ea6$export$a851da9bf50b557 extends (0, $3gTyY.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $ce79df266eec8ea6$export$19c281dc8e23a2ea extends (0, $3gTyY.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $3sEGT.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $ce79df266eec8ea6$export$20737d495bb13c2d extends (0, $3gTyY.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $ce79df266eec8ea6$export$d47cf5ef47eda817 extends (0, $3gTyY.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$86b719574b683f04 extends (0, $3gTyY.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$8959cb729fefe1ea extends (0, $3gTyY.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $ce79df266eec8ea6$export$f83210ce5f9b901f extends (0, $3gTyY.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $ce79df266eec8ea6$export$3b44baeac92e4d3a extends (0, $3gTyY.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$c7be62baad13b157 extends (0, $3gTyY.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$c4faa308ea7f9b2 extends (0, $3gTyY.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$26f2edb605108b34 extends (0, $3gTyY.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$14373147a0e60810 extends (0, $3gTyY.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $ce79df266eec8ea6$export$fdbba54ba15f2c2d extends (0, $3gTyY.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $4skRo.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $4skRo.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $ce79df266eec8ea6$export$a0eb884ede5c87eb extends (0, $3gTyY.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $ce79df266eec8ea6$export$3978f86c08fc8c25 extends (0, $3gTyY.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $4skRo.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $ce79df266eec8ea6$export$6d7c6f419cf52377 extends (0, $3gTyY.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $4skRo.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $ce79df266eec8ea6$export$53ed98b886965f49 extends (0, $3gTyY.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $ce79df266eec8ea6$export$cf94ccff0ff97c65 extends (0, $3gTyY.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $ce79df266eec8ea6$export$710dd6d4f78cc47e extends (0, $3gTyY.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $ce79df266eec8ea6$export$81781a0fcfb9ed95 extends (0, $3gTyY.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $ce79df266eec8ea6$export$a16541e2fe420ef1 extends (0, $3gTyY.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("4skRo", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $33e9f55717ad766e$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $33e9f55717ad766e$export$849e499971de75b3; });

var $hJ4aq = parcelRequire("hJ4aq");
function $33e9f55717ad766e$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $hJ4aq.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$33e9f55717ad766e$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $33e9f55717ad766e$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$33e9f55717ad766e$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $33e9f55717ad766e$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$33e9f55717ad766e$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});

parcelRegister("3sEGT", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $28538cf3dca4036d$export$346677f925de839c; });

var $52QU2 = parcelRequire("52QU2");
function $28538cf3dca4036d$export$346677f925de839c(value) {
    if ((0, $52QU2.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("52QU2", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $3ac62d1397eb07c2$export$8a9b6341a7c96bc; });
function $3ac62d1397eb07c2$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});


parcelRegister("3gTyY", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $261df76926def616$export$a490eb03cb7a0a5e; });

var $fMBWA = parcelRequire("fMBWA");
let $261df76926def616$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: $fMBWA.version
};
function $261df76926def616$export$4ac109df0c5244e9(config) {
    $261df76926def616$var$errorConfig = config;
}
class $261df76926def616$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $261df76926def616$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $261df76926def616$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $261df76926def616$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$261df76926def616$var$errorConfig.version ? [
                `Version: ${$261df76926def616$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $fMBWA.version);
    }
    walk(fn) {
        return $261df76926def616$var$walk(this, fn);
    }
}
function $261df76926def616$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $261df76926def616$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("fMBWA", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b7d8c58fe10a013e$export$83d89fbfd8236492; });
const $b7d8c58fe10a013e$export$83d89fbfd8236492 = "2.21.9";

});



parcelRegister("gZZzN", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $c6021ba38a50ce54$export$66c44d927ffead98; });

var $3gTyY = parcelRequire("3gTyY");
class $c6021ba38a50ce54$export$66c44d927ffead98 extends (0, $3gTyY.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});

parcelRegister("71qyi", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $51cd3918bbe01de6$export$977e255126d763d6; });

var $eCcCf = parcelRequire("eCcCf");

var $85sBM = parcelRequire("85sBM");
const $51cd3918bbe01de6$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $51cd3918bbe01de6$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $eCcCf.LruMap)(8192);
function $51cd3918bbe01de6$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($51cd3918bbe01de6$export$ef83598cc5072ce.has(cacheKey)) return $51cd3918bbe01de6$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$51cd3918bbe01de6$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $85sBM.checksumAddress)(address) === address;
        return true;
    })();
    $51cd3918bbe01de6$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});
parcelRegister("eCcCf", function(module, exports) {

$parcel$export(module.exports, "LruMap", function () { return $aa3e668743821e3a$export$fcb3b6cad79d7e3a; });
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $aa3e668743821e3a$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("85sBM", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $5e34fb641774d4cb$export$9ff46e8f6df13548; });

var $gZZzN = parcelRequire("gZZzN");

var $62edD = parcelRequire("62edD");

var $2J7yR = parcelRequire("2J7yR");

var $eCcCf = parcelRequire("eCcCf");

var $71qyi = parcelRequire("71qyi");
const $5e34fb641774d4cb$var$checksumAddressCache = /*#__PURE__*/ new (0, $eCcCf.LruMap)(8192);
function $5e34fb641774d4cb$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($5e34fb641774d4cb$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $5e34fb641774d4cb$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $2J7yR.keccak256)((0, $62edD.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $5e34fb641774d4cb$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $5e34fb641774d4cb$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $71qyi.isAddress)(address, {
        strict: false
    })) throw new (0, $gZZzN.InvalidAddressError)({
        address: address
    });
    return $5e34fb641774d4cb$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("62edD", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $464df58b663004ca$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $464df58b663004ca$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $464df58b663004ca$export$c8dd6bc66a63753c; });

var $3gTyY = parcelRequire("3gTyY");

var $52QU2 = parcelRequire("52QU2");

var $j0E9O = parcelRequire("j0E9O");

var $hFSAP = parcelRequire("hFSAP");

var $TYK4e = parcelRequire("TYK4e");
const $464df58b663004ca$var$encoder = /*#__PURE__*/ new TextEncoder();
function $464df58b663004ca$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $464df58b663004ca$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $464df58b663004ca$export$771517697a68241(value, opts);
    if ((0, $52QU2.isHex)(value)) return $464df58b663004ca$export$31c96b9df38bc8d4(value, opts);
    return $464df58b663004ca$export$c8dd6bc66a63753c(value, opts);
}
function $464df58b663004ca$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $hFSAP.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $j0E9O.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $464df58b663004ca$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $464df58b663004ca$var$charCodeToBase16(char) {
    if (char >= $464df58b663004ca$var$charCodeMap.zero && char <= $464df58b663004ca$var$charCodeMap.nine) return char - $464df58b663004ca$var$charCodeMap.zero;
    if (char >= $464df58b663004ca$var$charCodeMap.A && char <= $464df58b663004ca$var$charCodeMap.F) return char - ($464df58b663004ca$var$charCodeMap.A - 10);
    if (char >= $464df58b663004ca$var$charCodeMap.a && char <= $464df58b663004ca$var$charCodeMap.f) return char - ($464df58b663004ca$var$charCodeMap.a - 10);
    return undefined;
}
function $464df58b663004ca$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $hFSAP.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $j0E9O.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $464df58b663004ca$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $464df58b663004ca$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $3gTyY.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $464df58b663004ca$export$49ad9be85c347998(value, opts) {
    const hex = (0, $TYK4e.numberToHex)(value, opts);
    return $464df58b663004ca$export$31c96b9df38bc8d4(hex);
}
function $464df58b663004ca$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $464df58b663004ca$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $hFSAP.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $j0E9O.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("j0E9O", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $dd6d2ad366739645$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $dd6d2ad366739645$export$1bcd51c0fce8ee55; });

var $cx9aq = parcelRequire("cx9aq");
function $dd6d2ad366739645$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $dd6d2ad366739645$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $dd6d2ad366739645$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $dd6d2ad366739645$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $cx9aq.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $dd6d2ad366739645$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $cx9aq.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("cx9aq", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $91ffad820a4dbbb3$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $91ffad820a4dbbb3$export$70445dc308a7f3d5; });

var $3gTyY = parcelRequire("3gTyY");
class $91ffad820a4dbbb3$export$cfcd41bba8b36dbd extends (0, $3gTyY.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $91ffad820a4dbbb3$export$70445dc308a7f3d5 extends (0, $3gTyY.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $91ffad820a4dbbb3$export$8a5469becf223114 extends (0, $3gTyY.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("hFSAP", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $cde09d0997bb636a$export$2af489edb7fa35fe; });

var $ePI1u = parcelRequire("ePI1u");

var $3sEGT = parcelRequire("3sEGT");

var $58gqU = parcelRequire("58gqU");

var $62edD = parcelRequire("62edD");
function $cde09d0997bb636a$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $3sEGT.size)(hexOrBytes) > size) throw new (0, $ePI1u.SizeOverflowError)({
        givenSize: (0, $3sEGT.size)(hexOrBytes),
        maxSize: size
    });
}
function $cde09d0997bb636a$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $cde09d0997bb636a$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $cde09d0997bb636a$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $cde09d0997bb636a$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $cde09d0997bb636a$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $62edD.hexToBytes)(hex, opts);
}
function $cde09d0997bb636a$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $cde09d0997bb636a$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $cde09d0997bb636a$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $cde09d0997bb636a$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $58gqU.trim)(hex);
    }
    if ((0, $58gqU.trim)(hex) === "0x00") return false;
    if ((0, $58gqU.trim)(hex) === "0x01") return true;
    throw new (0, $ePI1u.InvalidHexBooleanError)(hex);
}
function $cde09d0997bb636a$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($cde09d0997bb636a$export$92a44656ec81b584(hex, opts));
}
function $cde09d0997bb636a$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $62edD.hexToBytes)(hex);
    if (opts.size) {
        $cde09d0997bb636a$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $58gqU.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("ePI1u", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $02c96b42b3284d74$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $02c96b42b3284d74$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $02c96b42b3284d74$export$beb44ed4f8747d0e; });

var $3gTyY = parcelRequire("3gTyY");
class $02c96b42b3284d74$export$47d164a8071229a9 extends (0, $3gTyY.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $02c96b42b3284d74$export$52fc62e5266c8838 extends (0, $3gTyY.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $02c96b42b3284d74$export$f574ac54e35514c extends (0, $3gTyY.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $02c96b42b3284d74$export$ef05eafd11dd4a83 extends (0, $3gTyY.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $02c96b42b3284d74$export$beb44ed4f8747d0e extends (0, $3gTyY.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("58gqU", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $3bca725a27400e64$export$87c2784dc9fc4ab; });
function $3bca725a27400e64$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("TYK4e", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $0a844144bf1cba84$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $0a844144bf1cba84$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $0a844144bf1cba84$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $0a844144bf1cba84$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $0a844144bf1cba84$export$58b867e287a802c8; });

var $ePI1u = parcelRequire("ePI1u");

var $j0E9O = parcelRequire("j0E9O");

var $hFSAP = parcelRequire("hFSAP");
const $0a844144bf1cba84$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $0a844144bf1cba84$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $0a844144bf1cba84$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $0a844144bf1cba84$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $0a844144bf1cba84$export$b5c95dec4f62ef7a(value, opts);
    return $0a844144bf1cba84$export$58b867e287a802c8(value, opts);
}
function $0a844144bf1cba84$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $hFSAP.assertSize)(hex, {
            size: opts.size
        });
        return (0, $j0E9O.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $0a844144bf1cba84$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $0a844144bf1cba84$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $hFSAP.assertSize)(hex, {
            size: opts.size
        });
        return (0, $j0E9O.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $0a844144bf1cba84$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $ePI1u.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $j0E9O.pad)(hex, {
        size: size
    });
    return hex;
}
const $0a844144bf1cba84$var$encoder = /*#__PURE__*/ new TextEncoder();
function $0a844144bf1cba84$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $0a844144bf1cba84$var$encoder.encode(value_);
    return $0a844144bf1cba84$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("2J7yR", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $1fc5a63e76f90906$export$f8151fce47ad1c35; });

var $7MqpV = parcelRequire("7MqpV");

var $52QU2 = parcelRequire("52QU2");

var $62edD = parcelRequire("62edD");

var $TYK4e = parcelRequire("TYK4e");
function $1fc5a63e76f90906$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $7MqpV.keccak_256)((0, $52QU2.isHex)(value, {
        strict: false
    }) ? (0, $62edD.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $TYK4e.toHex)(bytes);
}

});
parcelRegister("7MqpV", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $5aa181f8aafa9c77$export$860ddaa9ca84a66d; });

var $9OXOk = parcelRequire("9OXOk");

var $gS1tg = parcelRequire("gS1tg");

var $a16Bd = parcelRequire("a16Bd");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $5aa181f8aafa9c77$var$SHA3_PI = [];
const $5aa181f8aafa9c77$var$SHA3_ROTL = [];
const $5aa181f8aafa9c77$var$_SHA3_IOTA = [];
const $5aa181f8aafa9c77$var$_0n = /* @__PURE__ */ BigInt(0);
const $5aa181f8aafa9c77$var$_1n = /* @__PURE__ */ BigInt(1);
const $5aa181f8aafa9c77$var$_2n = /* @__PURE__ */ BigInt(2);
const $5aa181f8aafa9c77$var$_7n = /* @__PURE__ */ BigInt(7);
const $5aa181f8aafa9c77$var$_256n = /* @__PURE__ */ BigInt(256);
const $5aa181f8aafa9c77$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $5aa181f8aafa9c77$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $5aa181f8aafa9c77$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $5aa181f8aafa9c77$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $5aa181f8aafa9c77$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $5aa181f8aafa9c77$var$_1n ^ (R >> $5aa181f8aafa9c77$var$_7n) * $5aa181f8aafa9c77$var$_0x71n) % $5aa181f8aafa9c77$var$_256n;
        if (R & $5aa181f8aafa9c77$var$_2n) t ^= $5aa181f8aafa9c77$var$_1n << ($5aa181f8aafa9c77$var$_1n << /* @__PURE__ */ BigInt(j)) - $5aa181f8aafa9c77$var$_1n;
    }
    $5aa181f8aafa9c77$var$_SHA3_IOTA.push(t);
}
const [$5aa181f8aafa9c77$var$SHA3_IOTA_H, $5aa181f8aafa9c77$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $gS1tg.split)($5aa181f8aafa9c77$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $5aa181f8aafa9c77$var$rotlH = (h, l, s)=>s > 32 ? (0, $gS1tg.rotlBH)(h, l, s) : (0, $gS1tg.rotlSH)(h, l, s);
const $5aa181f8aafa9c77$var$rotlL = (h, l, s)=>s > 32 ? (0, $gS1tg.rotlBL)(h, l, s) : (0, $gS1tg.rotlSL)(h, l, s);
function $5aa181f8aafa9c77$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $5aa181f8aafa9c77$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $5aa181f8aafa9c77$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $5aa181f8aafa9c77$var$SHA3_ROTL[t];
            const Th = $5aa181f8aafa9c77$var$rotlH(curH, curL, shift);
            const Tl = $5aa181f8aafa9c77$var$rotlL(curH, curL, shift);
            const PI = $5aa181f8aafa9c77$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $5aa181f8aafa9c77$var$SHA3_IOTA_H[round];
        s[1] ^= $5aa181f8aafa9c77$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $5aa181f8aafa9c77$export$f7374b8b4498bc2e extends (0, $a16Bd.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $9OXOk.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $a16Bd.u32)(this.state);
    }
    keccak() {
        if (!(0, $a16Bd.isLE)) (0, $a16Bd.byteSwap32)(this.state32);
        $5aa181f8aafa9c77$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $a16Bd.isLE)) (0, $a16Bd.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $9OXOk.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $a16Bd.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $9OXOk.exists)(this, false);
        (0, $9OXOk.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $9OXOk.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $9OXOk.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $5aa181f8aafa9c77$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $5aa181f8aafa9c77$var$gen = (suffix, blockLen, outputLen)=>(0, $a16Bd.wrapConstructor)(()=>new $5aa181f8aafa9c77$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $5aa181f8aafa9c77$export$fe6c2b96a79338e9 = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x06, 144, 28);
const $5aa181f8aafa9c77$export$76e19b6966813b14 = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x06, 136, 32);
const $5aa181f8aafa9c77$export$a58509fa80f30d15 = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x06, 104, 48);
const $5aa181f8aafa9c77$export$20ed324dbdf09b7c = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x06, 72, 64);
const $5aa181f8aafa9c77$export$2f7fb3c6fac246bc = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x01, 144, 28);
const $5aa181f8aafa9c77$export$860ddaa9ca84a66d = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x01, 136, 32);
const $5aa181f8aafa9c77$export$46fcdeb4c5686552 = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x01, 104, 48);
const $5aa181f8aafa9c77$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $5aa181f8aafa9c77$var$gen(0x01, 72, 64);
const $5aa181f8aafa9c77$var$genShake = (suffix, blockLen, outputLen)=>(0, $a16Bd.wrapXOFConstructorWithOpts)((opts = {})=>new $5aa181f8aafa9c77$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $5aa181f8aafa9c77$export$f43dc3bb86efbba2 = /* @__PURE__ */ $5aa181f8aafa9c77$var$genShake(0x1f, 168, 16);
const $5aa181f8aafa9c77$export$c240d011f1520440 = /* @__PURE__ */ $5aa181f8aafa9c77$var$genShake(0x1f, 136, 32);

});
parcelRegister("9OXOk", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $72672db6892b6c6d$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $72672db6892b6c6d$export$b3317979f9250576; });
$parcel$export(module.exports, "exists", function () { return $72672db6892b6c6d$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $72672db6892b6c6d$export$c789db2c85949867; });
function $72672db6892b6c6d$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $72672db6892b6c6d$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $72672db6892b6c6d$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $72672db6892b6c6d$export$b3317979f9250576(b, ...lengths) {
    if (!$72672db6892b6c6d$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $72672db6892b6c6d$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $72672db6892b6c6d$export$98e628dec113755e(h.outputLen);
    $72672db6892b6c6d$export$98e628dec113755e(h.blockLen);
}
function $72672db6892b6c6d$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $72672db6892b6c6d$export$c789db2c85949867(out, instance) {
    $72672db6892b6c6d$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $72672db6892b6c6d$var$assert = {
    number: $72672db6892b6c6d$export$98e628dec113755e,
    bool: $72672db6892b6c6d$export$87b259aa03e3d267,
    bytes: $72672db6892b6c6d$export$b3317979f9250576,
    hash: $72672db6892b6c6d$export$d6af199866bfb566,
    exists: $72672db6892b6c6d$export$f7e9f41ea797a17,
    output: $72672db6892b6c6d$export$c789db2c85949867
};
var $72672db6892b6c6d$export$2e2bcd8739ae039 = $72672db6892b6c6d$var$assert;

});

parcelRegister("gS1tg", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $c482d4924f5254c9$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $c482d4924f5254c9$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $c482d4924f5254c9$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $c482d4924f5254c9$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $c482d4924f5254c9$export$5d12cc1da441323f; });
const $c482d4924f5254c9$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c482d4924f5254c9$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c482d4924f5254c9$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $c482d4924f5254c9$var$U32_MASK64),
        l: Number(n >> $c482d4924f5254c9$var$_32n & $c482d4924f5254c9$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c482d4924f5254c9$var$_32n & $c482d4924f5254c9$var$U32_MASK64) | 0,
        l: Number(n & $c482d4924f5254c9$var$U32_MASK64) | 0
    };
}
function $c482d4924f5254c9$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c482d4924f5254c9$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $c482d4924f5254c9$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $c482d4924f5254c9$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $c482d4924f5254c9$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $c482d4924f5254c9$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $c482d4924f5254c9$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $c482d4924f5254c9$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c482d4924f5254c9$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $c482d4924f5254c9$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $c482d4924f5254c9$export$a088d44bd387d2a3 = (_h, l)=>l;
const $c482d4924f5254c9$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $c482d4924f5254c9$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $c482d4924f5254c9$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c482d4924f5254c9$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $c482d4924f5254c9$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c482d4924f5254c9$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $c482d4924f5254c9$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $c482d4924f5254c9$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $c482d4924f5254c9$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $c482d4924f5254c9$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $c482d4924f5254c9$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $c482d4924f5254c9$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $c482d4924f5254c9$var$u64 = {
    fromBig: $c482d4924f5254c9$export$9625d4333cb56c3f,
    split: $c482d4924f5254c9$export$65980d18b75784e2,
    toBig: $c482d4924f5254c9$export$30f78adcaaa2eb7,
    shrSH: $c482d4924f5254c9$export$75aa78dc5bd52853,
    shrSL: $c482d4924f5254c9$export$a0225ff0aee14e25,
    rotrSH: $c482d4924f5254c9$export$97f812dfd830ca87,
    rotrSL: $c482d4924f5254c9$export$60987e30e2c9d9d,
    rotrBH: $c482d4924f5254c9$export$af9c7fbac44dcb76,
    rotrBL: $c482d4924f5254c9$export$f619171d6d5ac414,
    rotr32H: $c482d4924f5254c9$export$a088d44bd387d2a3,
    rotr32L: $c482d4924f5254c9$export$8415aae4d1f69577,
    rotlSH: $c482d4924f5254c9$export$4b80a2917447870e,
    rotlSL: $c482d4924f5254c9$export$20652918a7b63b3,
    rotlBH: $c482d4924f5254c9$export$a52f14bf902f9977,
    rotlBL: $c482d4924f5254c9$export$5d12cc1da441323f,
    add: $c482d4924f5254c9$export$e16d8520af44a096,
    add3L: $c482d4924f5254c9$export$c0c22b91f08911f,
    add3H: $c482d4924f5254c9$export$ef7b26044977a8ec,
    add4L: $c482d4924f5254c9$export$2f4e199c560f545d,
    add4H: $c482d4924f5254c9$export$e909220d675a7741,
    add5H: $c482d4924f5254c9$export$b45ee8d78c965098,
    add5L: $c482d4924f5254c9$export$d732b061fe9c9ae4
};
var $c482d4924f5254c9$export$2e2bcd8739ae039 = $c482d4924f5254c9$var$u64;

});

parcelRegister("a16Bd", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $74af1dd8004ba9bf$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "isLE", function () { return $74af1dd8004ba9bf$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $74af1dd8004ba9bf$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $74af1dd8004ba9bf$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "Hash", function () { return $74af1dd8004ba9bf$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $74af1dd8004ba9bf$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $74af1dd8004ba9bf$export$e18964dbd6e083c1; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $fxHtv = parcelRequire("fxHtv");

var $9OXOk = parcelRequire("9OXOk");
function $74af1dd8004ba9bf$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $74af1dd8004ba9bf$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $74af1dd8004ba9bf$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $74af1dd8004ba9bf$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $74af1dd8004ba9bf$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $74af1dd8004ba9bf$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $74af1dd8004ba9bf$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $74af1dd8004ba9bf$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $74af1dd8004ba9bf$export$4a0a88cc2d284e7f = $74af1dd8004ba9bf$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$74af1dd8004ba9bf$export$a4170f7f8be47425(n);
function $74af1dd8004ba9bf$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $74af1dd8004ba9bf$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $74af1dd8004ba9bf$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $74af1dd8004ba9bf$export$58b867e287a802c8(bytes) {
    (0, $9OXOk.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $74af1dd8004ba9bf$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $74af1dd8004ba9bf$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $74af1dd8004ba9bf$var$asciiToBase16(char) {
    if (char >= $74af1dd8004ba9bf$var$asciis._0 && char <= $74af1dd8004ba9bf$var$asciis._9) return char - $74af1dd8004ba9bf$var$asciis._0;
    if (char >= $74af1dd8004ba9bf$var$asciis._A && char <= $74af1dd8004ba9bf$var$asciis._F) return char - ($74af1dd8004ba9bf$var$asciis._A - 10);
    if (char >= $74af1dd8004ba9bf$var$asciis._a && char <= $74af1dd8004ba9bf$var$asciis._f) return char - ($74af1dd8004ba9bf$var$asciis._a - 10);
    return;
}
function $74af1dd8004ba9bf$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $74af1dd8004ba9bf$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $74af1dd8004ba9bf$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $74af1dd8004ba9bf$export$bdd553fddd433dcb = async ()=>{};
async function $74af1dd8004ba9bf$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $74af1dd8004ba9bf$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $74af1dd8004ba9bf$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $74af1dd8004ba9bf$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $74af1dd8004ba9bf$export$3df70a15530b5e81(data);
    (0, $9OXOk.bytes)(data);
    return data;
}
function $74af1dd8004ba9bf$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $9OXOk.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $74af1dd8004ba9bf$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $74af1dd8004ba9bf$var$toStr = {}.toString;
function $74af1dd8004ba9bf$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $74af1dd8004ba9bf$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $74af1dd8004ba9bf$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($74af1dd8004ba9bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $74af1dd8004ba9bf$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($74af1dd8004ba9bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $74af1dd8004ba9bf$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($74af1dd8004ba9bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $74af1dd8004ba9bf$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $fxHtv.crypto) && typeof (0, $fxHtv.crypto).getRandomValues === "function") return (0, $fxHtv.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("fxHtv", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $b50ba94c2ff2ca83$export$7effb53edfc7fa2d; });
const $b50ba94c2ff2ca83$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("eT7uQ", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $ad6c04636bd4f72d$export$58adb3bec8346d0f; });

var $cx9aq = parcelRequire("cx9aq");

var $52QU2 = parcelRequire("52QU2");

var $3sEGT = parcelRequire("3sEGT");
function $ad6c04636bd4f72d$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $52QU2.isHex)(value, {
        strict: false
    })) return $ad6c04636bd4f72d$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $ad6c04636bd4f72d$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $ad6c04636bd4f72d$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $3sEGT.size)(value) - 1) throw new (0, $cx9aq.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $3sEGT.size)(value)
    });
}
function $ad6c04636bd4f72d$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $3sEGT.size)(value) !== end - start) throw new (0, $cx9aq.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $3sEGT.size)(value)
    });
}
function $ad6c04636bd4f72d$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $ad6c04636bd4f72d$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $ad6c04636bd4f72d$var$assertEndOffset(value, start, end);
    return value;
}
function $ad6c04636bd4f72d$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $ad6c04636bd4f72d$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $ad6c04636bd4f72d$var$assertEndOffset(value, start, end);
    return value;
}

});


parcelRegister("h6Lln", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", function () { return $c747b8b747068389$export$bb3e0a434581ff8; });

var $hJ4aq = parcelRequire("hJ4aq");

var $3E8dc = parcelRequire("3E8dc");

var $4skRo = parcelRequire("4skRo");

var $lLgwN = parcelRequire("lLgwN");
const $c747b8b747068389$var$docsPath = "/docs/contract/encodeFunctionData";
function $c747b8b747068389$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $lLgwN.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $hJ4aq.AbiFunctionNotFoundError)(functionName, {
            docsPath: $c747b8b747068389$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $hJ4aq.AbiFunctionNotFoundError)(undefined, {
        docsPath: $c747b8b747068389$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $3E8dc.toFunctionSelector)((0, $4skRo.formatAbiItem)(abiItem))
    };
}

});
parcelRegister("3E8dc", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", function () { return $2a7b7a3c78cf65f1$export$e2442488533809cb; });

var $eT7uQ = parcelRequire("eT7uQ");

var $7nP6Z = parcelRequire("7nP6Z");
const $2a7b7a3c78cf65f1$export$e2442488533809cb = (fn)=>(0, $eT7uQ.slice)((0, $7nP6Z.toSignatureHash)(fn), 0, 4);

});
parcelRegister("7nP6Z", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", function () { return $56025416b2d12fe6$export$d809beebc9c913db; });

var $hc0sI = parcelRequire("hc0sI");

var $9tbxq = parcelRequire("9tbxq");
function $56025416b2d12fe6$export$d809beebc9c913db(fn) {
    return (0, $hc0sI.hashSignature)((0, $9tbxq.toSignature)(fn));
}

});
parcelRegister("hc0sI", function(module, exports) {

$parcel$export(module.exports, "hashSignature", function () { return $c843ea691bce0d67$export$77bbcd7aaec17976; });

var $62edD = parcelRequire("62edD");

var $2J7yR = parcelRequire("2J7yR");
const $c843ea691bce0d67$var$hash = (value)=>(0, $2J7yR.keccak256)((0, $62edD.toBytes)(value));
function $c843ea691bce0d67$export$77bbcd7aaec17976(sig) {
    return $c843ea691bce0d67$var$hash(sig);
}

});

parcelRegister("9tbxq", function(module, exports) {

$parcel$export(module.exports, "toSignature", function () { return $6e4fc5b90c3bea9a$export$d075a2fd83e0ecb; });

var $jieZl = parcelRequire("jieZl");

var $3MWKF = parcelRequire("3MWKF");
const $6e4fc5b90c3bea9a$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $jieZl.formatAbiItem)(def);
    })();
    return (0, $3MWKF.normalizeSignature)(def_);
};

});
parcelRegister("jieZl", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $e0bb532870bd043c$export$dc5d0ff4fc2fdee1; });

var $eyNk0 = parcelRequire("eyNk0");
function $e0bb532870bd043c$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $eyNk0.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $eyNk0.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $eyNk0.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $eyNk0.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $eyNk0.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("eyNk0", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $a99a7feb2d64c14d$export$c55dbda1a081631e; });

var $9V9Jz = parcelRequire("9V9Jz");
function $a99a7feb2d64c14d$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $9V9Jz.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("9V9Jz", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $7390fcea91ee8c8f$export$c75e01ebc733dc6b; });

var $cvUzq = parcelRequire("cvUzq");
// https://regexr.com/7f7rv
const $7390fcea91ee8c8f$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $7390fcea91ee8c8f$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($7390fcea91ee8c8f$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $7390fcea91ee8c8f$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $cvUzq.execTyped)($7390fcea91ee8c8f$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $7390fcea91ee8c8f$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("cvUzq", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $91c442fd5ade4335$export$1cca4755fb17f5bd; });
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $91c442fd5ade4335$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $91c442fd5ade4335$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $91c442fd5ade4335$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $91c442fd5ade4335$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("3MWKF", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $2c236da351b13eee$export$5cba87ebe4d0307a; });

var $3gTyY = parcelRequire("3gTyY");
function $2c236da351b13eee$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $3gTyY.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("lLgwN", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $fd7acee00967b4dc$export$99b134cd177e9574; });

var $hJ4aq = parcelRequire("hJ4aq");

var $52QU2 = parcelRequire("52QU2");

var $71qyi = parcelRequire("71qyi");

var $2CU7J = parcelRequire("2CU7J");

var $3E8dc = parcelRequire("3E8dc");
function $fd7acee00967b4dc$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $52QU2.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $3E8dc.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $2CU7J.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $fd7acee00967b4dc$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $fd7acee00967b4dc$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $hJ4aq.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $fd7acee00967b4dc$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $71qyi.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $fd7acee00967b4dc$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$fd7acee00967b4dc$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $fd7acee00967b4dc$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $fd7acee00967b4dc$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $71qyi.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $71qyi.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("2CU7J", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", function () { return $1e9aaa669d644d43$export$351f40ec61b2972; });

var $7nP6Z = parcelRequire("7nP6Z");
const $1e9aaa669d644d43$export$351f40ec61b2972 = (0, $7nP6Z.toSignatureHash);

});




parcelRegister("gdlQS", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $bcdecf8969ccde46$export$d4c241cec96564c1; });

var $2J7yR = parcelRequire("2J7yR");

var $8iWfS = parcelRequire("8iWfS");
function $bcdecf8969ccde46$export$d4c241cec96564c1(message, to_) {
    return (0, $2J7yR.keccak256)((0, $8iWfS.toPrefixedMessage)(message), to_);
}

});
parcelRegister("8iWfS", function(module, exports) {

$parcel$export(module.exports, "toPrefixedMessage", function () { return $60bd31698d3b4be9$export$6c55de89b570d8ea; });

var $cC0to = parcelRequire("cC0to");

var $5mdyK = parcelRequire("5mdyK");

var $3sEGT = parcelRequire("3sEGT");

var $TYK4e = parcelRequire("TYK4e");
function $60bd31698d3b4be9$export$6c55de89b570d8ea(message_) {
    const message = (()=>{
        if (typeof message_ === "string") return (0, $TYK4e.stringToHex)(message_);
        if (typeof message_.raw === "string") return message_.raw;
        return (0, $TYK4e.bytesToHex)(message_.raw);
    })();
    const prefix = (0, $TYK4e.stringToHex)(`${(0, $cC0to.presignMessagePrefix)}${(0, $3sEGT.size)(message)}`);
    return (0, $5mdyK.concat)([
        prefix,
        message
    ]);
}

});
parcelRegister("cC0to", function(module, exports) {

$parcel$export(module.exports, "presignMessagePrefix", function () { return $92e9669c1d57e0c5$export$39d5d904b514ff63; });
const $92e9669c1d57e0c5$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";

});



parcelRegister("2znuB", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", function () { return $1df112c5bb4f77da$export$9e2bd399d9aaab56; });
$parcel$export(module.exports, "hashDomain", function () { return $1df112c5bb4f77da$export$d4e887b08c47faea; });
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $7ITwU = parcelRequire("7ITwU");

var $5mdyK = parcelRequire("5mdyK");

var $TYK4e = parcelRequire("TYK4e");

var $2J7yR = parcelRequire("2J7yR");

var $lGhIb = parcelRequire("lGhIb");
function $1df112c5bb4f77da$export$9e2bd399d9aaab56(parameters) {
    const { domain: domain = {}, message: message, primaryType: primaryType } = parameters;
    const types = {
        EIP712Domain: (0, $lGhIb.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $lGhIb.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($1df112c5bb4f77da$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($1df112c5bb4f77da$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $2J7yR.keccak256)((0, $5mdyK.concat)(parts));
}
function $1df112c5bb4f77da$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $1df112c5bb4f77da$export$4b8f67c208624fdf({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $1df112c5bb4f77da$export$4b8f67c208624fdf({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $1df112c5bb4f77da$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $2J7yR.keccak256)(encoded);
}
function $1df112c5bb4f77da$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $1df112c5bb4f77da$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $1df112c5bb4f77da$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $7ITwU.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $1df112c5bb4f77da$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $TYK4e.toHex)($1df112c5bb4f77da$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $2J7yR.keccak256)(encodedHashType);
}
function $1df112c5bb4f77da$export$432cbecf661dce2b({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $1df112c5bb4f77da$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $1df112c5bb4f77da$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$1df112c5bb4f77da$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $1df112c5bb4f77da$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $2J7yR.keccak256)($1df112c5bb4f77da$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $2J7yR.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $2J7yR.keccak256)((0, $TYK4e.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$1df112c5bb4f77da$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $2J7yR.keccak256)((0, $7ITwU.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});
parcelRegister("lGhIb", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", function () { return $fc8b426077588e7e$export$fac174f558903e26; });
$parcel$export(module.exports, "getTypesForEIP712Domain", function () { return $fc8b426077588e7e$export$6a292159484ee032; });

var $hJ4aq = parcelRequire("hJ4aq");

var $gZZzN = parcelRequire("gZZzN");

var $71qyi = parcelRequire("71qyi");

var $3sEGT = parcelRequire("3sEGT");

var $TYK4e = parcelRequire("TYK4e");

var $eZ388 = parcelRequire("eZ388");

var $2znuB = parcelRequire("2znuB");

var $19VY5 = parcelRequire("19VY5");
function $fc8b426077588e7e$export$ce8e1cf733064451(parameters) {
    const { domain: domain_, message: message_, primaryType: primaryType, types: types } = parameters;
    const normalizeData = (struct, data_)=>{
        const data = {
            ...data_
        };
        for (const param of struct){
            const { name: name, type: type } = param;
            if (type === "address") data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (()=>{
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (()=>{
        if (primaryType === "EIP712Domain") return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return (0, $19VY5.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $fc8b426077588e7e$export$fac174f558903e26(parameters) {
    const { domain: domain, message: message, primaryType: primaryType, types: types } = parameters;
    const validateData = (struct, data)=>{
        for (const param of struct){
            const { name: name, type: type } = param;
            const value = data[name];
            const integerMatch = type.match((0, $eZ388.integerRegex));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $TYK4e.numberToHex)(value, {
                    signed: base === "int",
                    size: Number.parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $71qyi.isAddress)(value)) throw new (0, $gZZzN.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $eZ388.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $3sEGT.size)(value) !== Number.parseInt(size_)) throw new (0, $hJ4aq.BytesSizeMismatchError)({
                    expectedSize: Number.parseInt(size_),
                    givenSize: (0, $3sEGT.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    // Validate message types.
    if (primaryType !== "EIP712Domain") validateData(types[primaryType], message);
}
function $fc8b426077588e7e$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        typeof domain?.chainId === "number" && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $fc8b426077588e7e$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $2znuB.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $fc8b426077588e7e$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}

});
parcelRegister("eZ388", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", function () { return $ae8930c4bdfedd01$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $ae8930c4bdfedd01$export$45902cc189596eef; });
const $ae8930c4bdfedd01$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $ae8930c4bdfedd01$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $ae8930c4bdfedd01$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});

parcelRegister("19VY5", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $0d8398fbbe8d24a5$export$fac44ee5b035f737; });
const $0d8398fbbe8d24a5$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});



parcelRegister("c8AwN", function(module, exports) {

$parcel$export(module.exports, "MAGIC_VALUE", function () { return $8d62911093b20a48$export$86f35aaf3a84cb8c; });
$parcel$export(module.exports, "MAGIC_VALUE_BYTES", function () { return $8d62911093b20a48$export$9306a0ebeb4e08a8; });
const $8d62911093b20a48$export$86f35aaf3a84cb8c = "0x1626ba7e";
const $8d62911093b20a48$export$9306a0ebeb4e08a8 = "0x20c13b0b";

});

parcelRegister("cU2ef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $964c7195bee5667a$export$2e2bcd8739ae039; });

var $1JiNB = parcelRequire("1JiNB");

var $1dLBo = parcelRequire("1dLBo");
const $964c7195bee5667a$var$hasPermission = (required, permissions)=>permissions.some((permission)=>permission.parentCapability === required);
const $964c7195bee5667a$var$requirePermission = ()=>(_, propertyKey, descriptor)=>{
        const originalMethod = descriptor.value;
        descriptor.value = async function() {
            // @ts-expect-error accessing private property from decorator. 'this' context is the class instance
            const wallet = new (0, $1JiNB.Wallet)(this.communicator);
            let currentPermissions = await wallet.getPermissions();
            if (!$964c7195bee5667a$var$hasPermission(propertyKey, currentPermissions)) currentPermissions = await wallet.requestPermissions([
                {
                    [propertyKey]: {}
                }
            ]);
            if (!$964c7195bee5667a$var$hasPermission(propertyKey, currentPermissions)) throw new (0, $1dLBo.PermissionsError)("Permissions rejected", (0, $1dLBo.PERMISSIONS_REQUEST_REJECTED));
            return originalMethod.apply(this);
        };
        return descriptor;
    };
var $964c7195bee5667a$export$2e2bcd8739ae039 = $964c7195bee5667a$var$requirePermission;

});
parcelRegister("1JiNB", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $1428937f929fa2b0$export$bcca3ea514774656; });

var $5NJYn = parcelRequire("5NJYn");

var $1dLBo = parcelRequire("1dLBo");
class $1428937f929fa2b0$export$bcca3ea514774656 {
    constructor(communicator){
        this.communicator = communicator;
    }
    async getPermissions() {
        const response = await this.communicator.send((0, $5NJYn.Methods).wallet_getPermissions, undefined);
        return response.data;
    }
    async requestPermissions(permissions) {
        if (!this.isPermissionRequestValid(permissions)) throw new (0, $1dLBo.PermissionsError)("Permissions request is invalid", (0, $1dLBo.PERMISSIONS_REQUEST_REJECTED));
        try {
            const response = await this.communicator.send((0, $5NJYn.Methods).wallet_requestPermissions, permissions);
            return response.data;
        } catch  {
            throw new (0, $1dLBo.PermissionsError)("Permissions rejected", (0, $1dLBo.PERMISSIONS_REQUEST_REJECTED));
        }
    }
    isPermissionRequestValid(permissions) {
        return permissions.every((pr)=>{
            if (typeof pr === "object") return Object.keys(pr).every((method)=>{
                if (Object.values((0, $5NJYn.RestrictedMethods)).includes(method)) return true;
                return false;
            });
            return false;
        });
    }
}

});
parcelRegister("1dLBo", function(module, exports) {

$parcel$export(module.exports, "PERMISSIONS_REQUEST_REJECTED", function () { return $0e3bee26a66142f5$export$7d5ee3f5e13b90d; });
$parcel$export(module.exports, "PermissionsError", function () { return $0e3bee26a66142f5$export$8bc636af3de07ca1; });
const $0e3bee26a66142f5$export$7d5ee3f5e13b90d = 4001;
class $0e3bee26a66142f5$export$8bc636af3de07ca1 extends Error {
    constructor(message, code, data){
        super(message);
        this.code = code;
        this.data = data;
        // Should adjust prototype manually because how TS handles the type extension compilation
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0e3bee26a66142f5$export$8bc636af3de07ca1.prototype);
    }
}

});







parcelRegister("7qW2M", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3g3t4")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c9Tx3")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3YTHB"))
]).then(()=>parcelRequire("7U3eO"));

});

parcelRegister("4Ya7C", function(module, exports) {

$parcel$export(module.exports, "PublicKey", function () { return $39e49e08d4376623$export$ca8b6604d6ce14de; });
$parcel$export(module.exports, "TransactionExpiredBlockheightExceededError", function () { return $39e49e08d4376623$export$718fcd78527f88ed; });
$parcel$export(module.exports, "TransactionInstruction", function () { return $39e49e08d4376623$export$a7a3aa8360ac9f59; });
$parcel$export(module.exports, "Transaction", function () { return $39e49e08d4376623$export$febc5573c75cefb0; });
$parcel$export(module.exports, "VersionedTransaction", function () { return $39e49e08d4376623$export$232cc3f078dcc284; });
$parcel$export(module.exports, "Connection", function () { return $39e49e08d4376623$export$98b66c25bb38499d; });

var $7aSCJ = parcelRequire("7aSCJ");

var $I9mxh = parcelRequire("I9mxh");

var $enBgw = parcelRequire("enBgw");

var $4TRC3 = parcelRequire("4TRC3");

var $czdZ3 = parcelRequire("czdZ3");

var $f5x94 = parcelRequire("f5x94");

var $hGf21 = parcelRequire("hGf21");

var $2HiMo = parcelRequire("2HiMo");

var $jDCP1 = parcelRequire("jDCP1");

var $jjnoJ = parcelRequire("jjnoJ");

var $bQupP = parcelRequire("bQupP");

var $9Zzo3 = parcelRequire("9Zzo3");

var $bj4AF = parcelRequire("bj4AF");

var $iI8rD = parcelRequire("iI8rD");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $39e49e08d4376623$var$generatePrivateKey = (0, $I9mxh.ed25519).utils.randomPrivateKey;
const $39e49e08d4376623$var$generateKeypair = ()=>{
    const privateScalar = (0, $I9mxh.ed25519).utils.randomPrivateKey();
    const publicKey = $39e49e08d4376623$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $39e49e08d4376623$var$getPublicKey = (0, $I9mxh.ed25519).getPublicKey;
function $39e49e08d4376623$var$isOnCurve(publicKey) {
    try {
        (0, $I9mxh.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $39e49e08d4376623$var$sign = (message, secretKey)=>(0, $I9mxh.ed25519).sign(message, secretKey.slice(0, 32));
const $39e49e08d4376623$var$verify = (0, $I9mxh.ed25519).verify;
const $39e49e08d4376623$var$toBuffer = (arr)=>{
    if ((0, $7aSCJ.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $7aSCJ.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $7aSCJ.Buffer).from(arr);
};
// Class wrapping a plain object
class $39e49e08d4376623$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $7aSCJ.Buffer).from((0, $f5x94.serialize)($39e49e08d4376623$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $f5x94.deserialize)($39e49e08d4376623$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $f5x94.deserializeUnchecked)($39e49e08d4376623$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $39e49e08d4376623$export$deb82508dd66d288 extends $39e49e08d4376623$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $39e49e08d4376623$export$68d13ce9b4cc48f3 = new Map();
var $39e49e08d4376623$var$_class;
let $39e49e08d4376623$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $39e49e08d4376623$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $39e49e08d4376623$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $39e49e08d4376623$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $39e49e08d4376623$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $39e49e08d4376623$var$_Symbol$toStringTag = Symbol.toStringTag;
class $39e49e08d4376623$export$ca8b6604d6ce14de extends $39e49e08d4376623$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($39e49e08d4376623$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(value);
                if (decoded.length != $39e49e08d4376623$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($enBgw)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($enBgw)))(value);
            if (this._bn.byteLength() > $39e49e08d4376623$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $39e49e08d4376623$export$ca8b6604d6ce14de($39e49e08d4376623$var$uniquePublicKeyCounter);
        $39e49e08d4376623$var$uniquePublicKeyCounter += 1;
        return new $39e49e08d4376623$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $7aSCJ.Buffer));
        if (b.length === $39e49e08d4376623$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $7aSCJ.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$39e49e08d4376623$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $7aSCJ.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $7aSCJ.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $czdZ3.sha256)(buffer);
        return new $39e49e08d4376623$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $7aSCJ.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $39e49e08d4376623$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $7aSCJ.Buffer).concat([
                buffer,
                $39e49e08d4376623$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $7aSCJ.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $7aSCJ.Buffer).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $czdZ3.sha256)(buffer);
        if ($39e49e08d4376623$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $39e49e08d4376623$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $7aSCJ.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $39e49e08d4376623$export$ca8b6604d6ce14de(pubkeyData);
        return $39e49e08d4376623$var$isOnCurve(pubkey.toBytes());
    }
}
$39e49e08d4376623$var$_class = $39e49e08d4376623$export$ca8b6604d6ce14de;
$39e49e08d4376623$export$ca8b6604d6ce14de.default = new $39e49e08d4376623$var$_class("11111111111111111111111111111111");
$39e49e08d4376623$export$68d13ce9b4cc48f3.set($39e49e08d4376623$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $39e49e08d4376623$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $39e49e08d4376623$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $39e49e08d4376623$var$toBuffer($39e49e08d4376623$var$generatePrivateKey());
            this._publicKey = $39e49e08d4376623$var$toBuffer($39e49e08d4376623$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $39e49e08d4376623$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $7aSCJ.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $39e49e08d4376623$export$42bd37c1c64962b6 = new $39e49e08d4376623$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $39e49e08d4376623$export$4c6d5b89e1596f26 = 1232;
const $39e49e08d4376623$export$3c3793d809f8b858 = 0x7f;
const $39e49e08d4376623$export$14aee086fde78fa6 = 64;
class $39e49e08d4376623$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($39e49e08d4376623$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $39e49e08d4376623$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($39e49e08d4376623$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $39e49e08d4376623$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($39e49e08d4376623$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $39e49e08d4376623$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $39e49e08d4376623$var$publicKey = (property = "publicKey")=>{
    return $hGf21.blob(32, property);
};
/**
 * Layout for a signature
 */ const $39e49e08d4376623$var$signature = (property = "signature")=>{
    return $hGf21.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $39e49e08d4376623$var$rustString = (property = "string")=>{
    const rsl = $hGf21.struct([
        $hGf21.u32("length"),
        $hGf21.u32("lengthPadding"),
        $hGf21.blob($hGf21.offset($hGf21.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $7aSCJ.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $hGf21.u32().span + $hGf21.u32().span + (0, $7aSCJ.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $39e49e08d4376623$var$authorized = (property = "authorized")=>{
    return $hGf21.struct([
        $39e49e08d4376623$var$publicKey("staker"),
        $39e49e08d4376623$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $39e49e08d4376623$var$lockup = (property = "lockup")=>{
    return $hGf21.struct([
        $hGf21.ns64("unixTimestamp"),
        $hGf21.ns64("epoch"),
        $39e49e08d4376623$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $39e49e08d4376623$var$voteInit = (property = "voteInit")=>{
    return $hGf21.struct([
        $39e49e08d4376623$var$publicKey("nodePubkey"),
        $39e49e08d4376623$var$publicKey("authorizedVoter"),
        $39e49e08d4376623$var$publicKey("authorizedWithdrawer"),
        $hGf21.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $39e49e08d4376623$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $hGf21.struct([
        $hGf21.u32("voteAuthorizationType"),
        $39e49e08d4376623$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $39e49e08d4376623$var$rustString("currentAuthorityDerivedKeySeed"),
        $39e49e08d4376623$var$publicKey("newAuthorized")
    ], property);
};
function $39e49e08d4376623$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $39e49e08d4376623$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $39e49e08d4376623$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $39e49e08d4376623$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $39e49e08d4376623$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $39e49e08d4376623$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $39e49e08d4376623$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $39e49e08d4376623$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $39e49e08d4376623$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $39e49e08d4376623$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $39e49e08d4376623$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $39e49e08d4376623$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $39e49e08d4376623$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $39e49e08d4376623$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $39e49e08d4376623$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $39e49e08d4376623$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $39e49e08d4376623$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $39e49e08d4376623$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($39e49e08d4376623$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $39e49e08d4376623$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($39e49e08d4376623$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $39e49e08d4376623$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $39e49e08d4376623$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $39e49e08d4376623$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $39e49e08d4376623$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $39e49e08d4376623$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode(ix.data)
            }));
        return new $39e49e08d4376623$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $39e49e08d4376623$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(instruction.data));
            let keyIndicesCount = [];
            $39e49e08d4376623$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $39e49e08d4376623$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $7aSCJ.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $7aSCJ.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $39e49e08d4376623$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $7aSCJ.Buffer).alloc($39e49e08d4376623$export$4c6d5b89e1596f26);
        (0, $7aSCJ.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $hGf21.struct([
                $hGf21.u8("programIdIndex"),
                $hGf21.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $hGf21.seq($hGf21.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $hGf21.blob(instruction.dataLength.length, "dataLength"),
                $hGf21.seq($hGf21.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $hGf21.struct([
            $hGf21.blob(1, "numRequiredSignatures"),
            $hGf21.blob(1, "numReadonlySignedAccounts"),
            $hGf21.blob(1, "numReadonlyUnsignedAccounts"),
            $hGf21.blob(keyCount.length, "keyCount"),
            $hGf21.seq($39e49e08d4376623$var$publicKey("key"), numKeys, "keys"),
            $39e49e08d4376623$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $7aSCJ.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $7aSCJ.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $7aSCJ.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $7aSCJ.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$39e49e08d4376623$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(this.recentBlockhash)
        };
        let signData = (0, $7aSCJ.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $39e49e08d4376623$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $39e49e08d4376623$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = $39e49e08d4376623$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $39e49e08d4376623$var$guardedShift(byteArray);
        const accountCount = $39e49e08d4376623$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343);
            accountKeys.push(new $39e49e08d4376623$export$ca8b6604d6ce14de((0, $7aSCJ.Buffer).from(account)));
        }
        const recentBlockhash = $39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343);
        const instructionCount = $39e49e08d4376623$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $39e49e08d4376623$var$guardedShift(byteArray);
            const accountCount = $39e49e08d4376623$var$decodeLength(byteArray);
            const accounts = $39e49e08d4376623$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $39e49e08d4376623$var$decodeLength(byteArray);
            const dataSlice = $39e49e08d4376623$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode((0, $7aSCJ.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode((0, $7aSCJ.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $39e49e08d4376623$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $39e49e08d4376623$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $39e49e08d4376623$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $39e49e08d4376623$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $39e49e08d4376623$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $39e49e08d4376623$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $39e49e08d4376623$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $39e49e08d4376623$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $39e49e08d4376623$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $hGf21.struct([
            $hGf21.u8("prefix"),
            $hGf21.struct([
                $hGf21.u8("numRequiredSignatures"),
                $hGf21.u8("numReadonlySignedAccounts"),
                $hGf21.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $hGf21.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $hGf21.seq($39e49e08d4376623$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $39e49e08d4376623$var$publicKey("recentBlockhash"),
            $hGf21.blob(encodedInstructionsLength.length, "instructionsLength"),
            $hGf21.blob(serializedInstructions.length, "serializedInstructions"),
            $hGf21.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $hGf21.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($39e49e08d4376623$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($39e49e08d4376623$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $39e49e08d4376623$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $39e49e08d4376623$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $hGf21.struct([
                $hGf21.u8("programIdIndex"),
                $hGf21.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $hGf21.seq($hGf21.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $hGf21.blob(encodedDataLength.length, "encodedDataLength"),
                $hGf21.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($39e49e08d4376623$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $39e49e08d4376623$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $39e49e08d4376623$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $hGf21.struct([
                $39e49e08d4376623$var$publicKey("accountKey"),
                $hGf21.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $hGf21.seq($hGf21.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $hGf21.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $hGf21.seq($hGf21.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $39e49e08d4376623$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $39e49e08d4376623$export$3c3793d809f8b858;
        $39e49e08d4376623$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $39e49e08d4376623$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $39e49e08d4376623$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $39e49e08d4376623$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $39e49e08d4376623$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $39e49e08d4376623$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $39e49e08d4376623$export$ca8b6604d6ce14de($39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode($39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343));
        const instructionCount = $39e49e08d4376623$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $39e49e08d4376623$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $39e49e08d4376623$var$decodeLength(byteArray);
            const accountKeyIndexes = $39e49e08d4376623$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $39e49e08d4376623$var$decodeLength(byteArray);
            const data = new Uint8Array($39e49e08d4376623$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $39e49e08d4376623$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $39e49e08d4376623$export$ca8b6604d6ce14de($39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343));
            const writableIndexesLength = $39e49e08d4376623$var$decodeLength(byteArray);
            const writableIndexes = $39e49e08d4376623$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $39e49e08d4376623$var$decodeLength(byteArray);
            const readonlyIndexes = $39e49e08d4376623$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $39e49e08d4376623$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $39e49e08d4376623$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $39e49e08d4376623$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $39e49e08d4376623$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $39e49e08d4376623$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $39e49e08d4376623$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $39e49e08d4376623$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $39e49e08d4376623$var$DEFAULT_SIGNATURE = (0, $7aSCJ.Buffer).alloc($39e49e08d4376623$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $39e49e08d4376623$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $7aSCJ.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $39e49e08d4376623$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $39e49e08d4376623$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $39e49e08d4376623$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$39e49e08d4376623$var$assert(keyIndex >= 0));
        });
        return new $39e49e08d4376623$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $39e49e08d4376623$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $39e49e08d4376623$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $39e49e08d4376623$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $7aSCJ.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$39e49e08d4376623$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $39e49e08d4376623$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $7aSCJ.Buffer).alloc(transactionLength);
        $39e49e08d4376623$var$assert(signatures.length < 256);
        (0, $7aSCJ.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $39e49e08d4376623$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $7aSCJ.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $39e49e08d4376623$var$assert(wireTransaction.length <= $39e49e08d4376623$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$39e49e08d4376623$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $39e49e08d4376623$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $39e49e08d4376623$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $39e49e08d4376623$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $39e49e08d4376623$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode((0, $7aSCJ.Buffer).from(signature)));
        }
        return $39e49e08d4376623$export$febc5573c75cefb0.populate($39e49e08d4376623$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).encode($39e49e08d4376623$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $39e49e08d4376623$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $39e49e08d4376623$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $39e49e08d4376623$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $39e49e08d4376623$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $39e49e08d4376623$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $39e49e08d4376623$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $39e49e08d4376623$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $39e49e08d4376623$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $39e49e08d4376623$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $39e49e08d4376623$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $39e49e08d4376623$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($39e49e08d4376623$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $39e49e08d4376623$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $hGf21.struct([
            $hGf21.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $hGf21.seq($39e49e08d4376623$var$signature(), this.signatures.length, "signatures"),
            $hGf21.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $39e49e08d4376623$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$14aee086fde78fa6)));
        const message = $39e49e08d4376623$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $39e49e08d4376623$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $39e49e08d4376623$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $39e49e08d4376623$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $39e49e08d4376623$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $39e49e08d4376623$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $39e49e08d4376623$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $39e49e08d4376623$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $39e49e08d4376623$var$NUM_SLOTS_PER_SECOND = $39e49e08d4376623$var$NUM_TICKS_PER_SECOND / $39e49e08d4376623$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $39e49e08d4376623$var$MS_PER_SLOT = 1000 / $39e49e08d4376623$var$NUM_SLOTS_PER_SECOND;
const $39e49e08d4376623$export$393aa1412d47050e = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $39e49e08d4376623$export$2b71d479444d2f4 = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $39e49e08d4376623$export$54419cc1a3ece8d6 = new $39e49e08d4376623$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $39e49e08d4376623$export$e74201139e9833db = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $39e49e08d4376623$export$970d0190cdb3a8e9 = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $39e49e08d4376623$export$da3b38d796bc1af1 = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $39e49e08d4376623$export$7b3a057916a4a7ae = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $39e49e08d4376623$export$3272815bf0633907 = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $39e49e08d4376623$export$ca994171317280ea = new $39e49e08d4376623$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $39e49e08d4376623$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $39e49e08d4376623$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $39e49e08d4376623$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $39e49e08d4376623$var$getAlloc(type, fields);
    const data = (0, $7aSCJ.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $39e49e08d4376623$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $39e49e08d4376623$export$d1cc579b1c48f515 = $hGf21.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $39e49e08d4376623$var$NonceAccountLayout = $hGf21.struct([
    $hGf21.u32("version"),
    $hGf21.u32("state"),
    $39e49e08d4376623$var$publicKey("authorizedPubkey"),
    $39e49e08d4376623$var$publicKey("nonce"),
    $hGf21.struct([
        $39e49e08d4376623$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $39e49e08d4376623$export$7126250b6d8bd94a = $39e49e08d4376623$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $39e49e08d4376623$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $39e49e08d4376623$var$NonceAccountLayout.decode($39e49e08d4376623$var$toBuffer(buffer), 0);
        return new $39e49e08d4376623$export$ed1c2356ce604759({
            authorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $39e49e08d4376623$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $39e49e08d4376623$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $39e49e08d4376623$var$bigInt = (length)=>(property)=>{
        const layout = (0, $hGf21.blob)(length, property);
        const { encode: encode, decode: decode } = $39e49e08d4376623$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $2HiMo.toBigIntLE)((0, $7aSCJ.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $2HiMo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $39e49e08d4376623$var$u64 = $39e49e08d4376623$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $39e49e08d4376623$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $hGf21.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($39e49e08d4376623$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $39e49e08d4376623$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($39e49e08d4376623$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $39e49e08d4376623$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("lamports"),
            $hGf21.ns64("space"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("base"),
            $39e49e08d4376623$var$rustString("seed"),
            $hGf21.ns64("lamports"),
            $hGf21.ns64("space"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("base"),
            $39e49e08d4376623$var$rustString("seed"),
            $hGf21.ns64("space"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("base"),
            $39e49e08d4376623$var$rustString("seed"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$u64("lamports"),
            $39e49e08d4376623$var$rustString("seed"),
            $39e49e08d4376623$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $39e49e08d4376623$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.Create;
        const data = $39e49e08d4376623$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $39e49e08d4376623$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.Transfer;
            data = $39e49e08d4376623$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $39e49e08d4376623$var$encodeData(type, {
                base: $39e49e08d4376623$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.Assign;
            data = $39e49e08d4376623$var$encodeData(type, {
                programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $39e49e08d4376623$var$encodeData(type, {
            base: $39e49e08d4376623$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $39e49e08d4376623$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $39e49e08d4376623$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $39e49e08d4376623$var$encodeData(type, {
            authorized: $39e49e08d4376623$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $39e49e08d4376623$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $39e49e08d4376623$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $39e49e08d4376623$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $39e49e08d4376623$var$encodeData(type, {
            authorized: $39e49e08d4376623$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $39e49e08d4376623$var$encodeData(type, {
                base: $39e49e08d4376623$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $39e49e08d4376623$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $39e49e08d4376623$export$74bdf41d8d1e7108.Allocate;
            data = $39e49e08d4376623$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$39e49e08d4376623$export$d8c4e17726848113.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $39e49e08d4376623$var$CHUNK_SIZE = $39e49e08d4376623$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $39e49e08d4376623$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $39e49e08d4376623$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $39e49e08d4376623$export$febc5573c75cefb0();
                    transaction.add($39e49e08d4376623$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $39e49e08d4376623$export$febc5573c75cefb0();
                    transaction.add($39e49e08d4376623$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $39e49e08d4376623$export$febc5573c75cefb0();
                    transaction.add($39e49e08d4376623$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $39e49e08d4376623$export$febc5573c75cefb0().add($39e49e08d4376623$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $39e49e08d4376623$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.u32("offset"),
            $hGf21.u32("bytesLength"),
            $hGf21.u32("bytesLengthPadding"),
            $hGf21.seq($hGf21.u8("byte"), $hGf21.offset($hGf21.u32(), -8), "bytes")
        ]);
        const chunkSize = $39e49e08d4376623$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $7aSCJ.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $39e49e08d4376623$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($39e49e08d4376623$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $39e49e08d4376623$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $hGf21.struct([
                $hGf21.u32("instruction")
            ]);
            const data = (0, $7aSCJ.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $39e49e08d4376623$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $39e49e08d4376623$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($39e49e08d4376623$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$39e49e08d4376623$export$3b0d6d7590275603.chunkSize = $39e49e08d4376623$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $39e49e08d4376623$export$59833422f998b937 = new $39e49e08d4376623$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $39e49e08d4376623$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $39e49e08d4376623$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $39e49e08d4376623$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $39e49e08d4376623$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $39e49e08d4376623$var$objToString = Object.prototype.toString;
var $39e49e08d4376623$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $39e49e08d4376623$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $39e49e08d4376623$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $39e49e08d4376623$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $39e49e08d4376623$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $39e49e08d4376623$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $39e49e08d4376623$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $39e49e08d4376623$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $39e49e08d4376623$var$fastStableStringify = function(val) {
    var returnVal = $39e49e08d4376623$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $39e49e08d4376623$var$fastStableStringify$1 = /*@__PURE__*/ $39e49e08d4376623$var$getDefaultExportFromCjs($39e49e08d4376623$var$fastStableStringify);
const $39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $39e49e08d4376623$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $39e49e08d4376623$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $39e49e08d4376623$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $39e49e08d4376623$var$trailingZeros($39e49e08d4376623$var$nextPowerOfTwo(slot + $39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $39e49e08d4376623$var$trailingZeros($39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $39e49e08d4376623$var$trailingZeros($39e49e08d4376623$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $39e49e08d4376623$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $39e49e08d4376623$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $39e49e08d4376623$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
var $39e49e08d4376623$var$fetchImpl = globalThis.fetch;
class $39e49e08d4376623$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($bQupP))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($9Zzo3)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $39e49e08d4376623$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $39e49e08d4376623$var$LOOKUP_TABLE_META_SIZE = 56;
class $39e49e08d4376623$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $39e49e08d4376623$var$decodeData($39e49e08d4376623$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $39e49e08d4376623$var$LOOKUP_TABLE_META_SIZE;
        $39e49e08d4376623$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $39e49e08d4376623$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $hGf21.struct([
            $hGf21.seq($39e49e08d4376623$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($39e49e08d4376623$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $39e49e08d4376623$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $39e49e08d4376623$export$ca8b6604d6ce14de(address))
        };
    }
}
const $39e49e08d4376623$var$LookupTableMetaLayout = {
    index: 1,
    layout: $hGf21.struct([
        $hGf21.u32("typeIndex"),
        $39e49e08d4376623$var$u64("deactivationSlot"),
        $hGf21.nu64("lastExtendedSlot"),
        $hGf21.u8("lastExtendedStartIndex"),
        $hGf21.u8(),
        // option
        $hGf21.seq($39e49e08d4376623$var$publicKey(), $hGf21.offset($hGf21.u8(), -1), "authority")
    ])
};
const $39e49e08d4376623$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $39e49e08d4376623$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($39e49e08d4376623$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $39e49e08d4376623$var$PublicKeyFromString = (0, $jDCP1.coerce)((0, $jDCP1.instance)($39e49e08d4376623$export$ca8b6604d6ce14de), (0, $jDCP1.string)(), (value)=>new $39e49e08d4376623$export$ca8b6604d6ce14de(value));
const $39e49e08d4376623$var$RawAccountDataResult = (0, $jDCP1.tuple)([
    (0, $jDCP1.string)(),
    (0, $jDCP1.literal)("base64")
]);
const $39e49e08d4376623$var$BufferFromRawAccountData = (0, $jDCP1.coerce)((0, $jDCP1.instance)((0, $7aSCJ.Buffer)), $39e49e08d4376623$var$RawAccountDataResult, (value)=>(0, $7aSCJ.Buffer).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $39e49e08d4376623$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $39e49e08d4376623$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $39e49e08d4376623$var$createRpcResult(result) {
    return (0, $jDCP1.union)([
        (0, $jDCP1.type)({
            jsonrpc: (0, $jDCP1.literal)("2.0"),
            id: (0, $jDCP1.string)(),
            result: result
        }),
        (0, $jDCP1.type)({
            jsonrpc: (0, $jDCP1.literal)("2.0"),
            id: (0, $jDCP1.string)(),
            error: (0, $jDCP1.type)({
                code: (0, $jDCP1.unknown)(),
                message: (0, $jDCP1.string)(),
                data: (0, $jDCP1.optional)((0, $jDCP1.any)())
            })
        })
    ]);
}
const $39e49e08d4376623$var$UnknownRpcResult = $39e49e08d4376623$var$createRpcResult((0, $jDCP1.unknown)());
/**
 * @internal
 */ function $39e49e08d4376623$var$jsonRpcResult(schema) {
    return (0, $jDCP1.coerce)($39e49e08d4376623$var$createRpcResult(schema), $39e49e08d4376623$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $jDCP1.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $39e49e08d4376623$var$jsonRpcResultAndContext(value) {
    return $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.type)({
        context: (0, $jDCP1.type)({
            slot: (0, $jDCP1.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $39e49e08d4376623$var$notificationResultAndContext(value) {
    return (0, $jDCP1.type)({
        context: (0, $jDCP1.type)({
            slot: (0, $jDCP1.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $39e49e08d4376623$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $39e49e08d4376623$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $39e49e08d4376623$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $39e49e08d4376623$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $39e49e08d4376623$var$GetInflationGovernorResult = (0, $jDCP1.type)({
    foundation: (0, $jDCP1.number)(),
    foundationTerm: (0, $jDCP1.number)(),
    initial: (0, $jDCP1.number)(),
    taper: (0, $jDCP1.number)(),
    terminal: (0, $jDCP1.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $39e49e08d4376623$var$GetInflationRewardResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)((0, $jDCP1.nullable)((0, $jDCP1.type)({
    epoch: (0, $jDCP1.number)(),
    effectiveSlot: (0, $jDCP1.number)(),
    amount: (0, $jDCP1.number)(),
    postBalance: (0, $jDCP1.number)(),
    commission: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $39e49e08d4376623$var$GetRecentPrioritizationFeesResult = (0, $jDCP1.array)((0, $jDCP1.type)({
    slot: (0, $jDCP1.number)(),
    prioritizationFee: (0, $jDCP1.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $39e49e08d4376623$var$GetInflationRateResult = (0, $jDCP1.type)({
    total: (0, $jDCP1.number)(),
    validator: (0, $jDCP1.number)(),
    foundation: (0, $jDCP1.number)(),
    epoch: (0, $jDCP1.number)()
});
/**
 * Information about the current epoch
 */ const $39e49e08d4376623$var$GetEpochInfoResult = (0, $jDCP1.type)({
    epoch: (0, $jDCP1.number)(),
    slotIndex: (0, $jDCP1.number)(),
    slotsInEpoch: (0, $jDCP1.number)(),
    absoluteSlot: (0, $jDCP1.number)(),
    blockHeight: (0, $jDCP1.optional)((0, $jDCP1.number)()),
    transactionCount: (0, $jDCP1.optional)((0, $jDCP1.number)())
});
const $39e49e08d4376623$var$GetEpochScheduleResult = (0, $jDCP1.type)({
    slotsPerEpoch: (0, $jDCP1.number)(),
    leaderScheduleSlotOffset: (0, $jDCP1.number)(),
    warmup: (0, $jDCP1.boolean)(),
    firstNormalEpoch: (0, $jDCP1.number)(),
    firstNormalSlot: (0, $jDCP1.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $39e49e08d4376623$var$GetLeaderScheduleResult = (0, $jDCP1.record)((0, $jDCP1.string)(), (0, $jDCP1.array)((0, $jDCP1.number)()));
/**
 * Transaction error or null
 */ const $39e49e08d4376623$var$TransactionErrorResult = (0, $jDCP1.nullable)((0, $jDCP1.union)([
    (0, $jDCP1.type)({}),
    (0, $jDCP1.string)()
]));
/**
 * Signature status for a transaction
 */ const $39e49e08d4376623$var$SignatureStatusResult = (0, $jDCP1.type)({
    err: $39e49e08d4376623$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $39e49e08d4376623$var$SignatureReceivedResult = (0, $jDCP1.literal)("receivedSignature");
/**
 * Version info for a node
 */ const $39e49e08d4376623$var$VersionResult = (0, $jDCP1.type)({
    "solana-core": (0, $jDCP1.string)(),
    "feature-set": (0, $jDCP1.optional)((0, $jDCP1.number)())
});
const $39e49e08d4376623$var$SimulatedTransactionResponseStruct = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.type)({
    err: (0, $jDCP1.nullable)((0, $jDCP1.union)([
        (0, $jDCP1.type)({}),
        (0, $jDCP1.string)()
    ])),
    logs: (0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.string)())),
    accounts: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.nullable)((0, $jDCP1.type)({
        executable: (0, $jDCP1.boolean)(),
        owner: (0, $jDCP1.string)(),
        lamports: (0, $jDCP1.number)(),
        data: (0, $jDCP1.array)((0, $jDCP1.string)()),
        rentEpoch: (0, $jDCP1.optional)((0, $jDCP1.number)())
    }))))),
    unitsConsumed: (0, $jDCP1.optional)((0, $jDCP1.number)()),
    returnData: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.type)({
        programId: (0, $jDCP1.string)(),
        data: (0, $jDCP1.tuple)([
            (0, $jDCP1.string)(),
            (0, $jDCP1.literal)("base64")
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $39e49e08d4376623$var$BlockProductionResponseStruct = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.type)({
    byIdentity: (0, $jDCP1.record)((0, $jDCP1.string)(), (0, $jDCP1.array)((0, $jDCP1.number)())),
    range: (0, $jDCP1.type)({
        firstSlot: (0, $jDCP1.number)(),
        lastSlot: (0, $jDCP1.number)()
    })
}));
/**
 * A performance sample
 */ function $39e49e08d4376623$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $39e49e08d4376623$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($jjnoJ)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $39e49e08d4376623$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $39e49e08d4376623$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $39e49e08d4376623$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $39e49e08d4376623$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $39e49e08d4376623$var$GetInflationGovernorRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $39e49e08d4376623$var$GetInflationRateRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $39e49e08d4376623$var$GetRecentPrioritizationFeesRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $39e49e08d4376623$var$GetEpochInfoRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $39e49e08d4376623$var$GetEpochScheduleRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $39e49e08d4376623$var$GetLeaderScheduleRpcResult = $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $39e49e08d4376623$var$SlotRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $39e49e08d4376623$var$GetSupplyRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.type)({
    total: (0, $jDCP1.number)(),
    circulating: (0, $jDCP1.number)(),
    nonCirculating: (0, $jDCP1.number)(),
    nonCirculatingAccounts: (0, $jDCP1.array)($39e49e08d4376623$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $39e49e08d4376623$var$TokenAmountResult = (0, $jDCP1.type)({
    amount: (0, $jDCP1.string)(),
    uiAmount: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    decimals: (0, $jDCP1.number)(),
    uiAmountString: (0, $jDCP1.optional)((0, $jDCP1.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $39e49e08d4376623$var$GetTokenLargestAccountsResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.type)({
    address: $39e49e08d4376623$var$PublicKeyFromString,
    amount: (0, $jDCP1.string)(),
    uiAmount: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    decimals: (0, $jDCP1.number)(),
    uiAmountString: (0, $jDCP1.optional)((0, $jDCP1.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $39e49e08d4376623$var$GetTokenAccountsByOwner = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    account: (0, $jDCP1.type)({
        executable: (0, $jDCP1.boolean)(),
        owner: $39e49e08d4376623$var$PublicKeyFromString,
        lamports: (0, $jDCP1.number)(),
        data: $39e49e08d4376623$var$BufferFromRawAccountData,
        rentEpoch: (0, $jDCP1.number)()
    })
})));
const $39e49e08d4376623$var$ParsedAccountDataResult = (0, $jDCP1.type)({
    program: (0, $jDCP1.string)(),
    parsed: (0, $jDCP1.unknown)(),
    space: (0, $jDCP1.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $39e49e08d4376623$var$GetParsedTokenAccountsByOwner = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    account: (0, $jDCP1.type)({
        executable: (0, $jDCP1.boolean)(),
        owner: $39e49e08d4376623$var$PublicKeyFromString,
        lamports: (0, $jDCP1.number)(),
        data: $39e49e08d4376623$var$ParsedAccountDataResult,
        rentEpoch: (0, $jDCP1.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $39e49e08d4376623$var$GetLargestAccountsRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.type)({
    lamports: (0, $jDCP1.number)(),
    address: $39e49e08d4376623$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $39e49e08d4376623$var$AccountInfoResult = (0, $jDCP1.type)({
    executable: (0, $jDCP1.boolean)(),
    owner: $39e49e08d4376623$var$PublicKeyFromString,
    lamports: (0, $jDCP1.number)(),
    data: $39e49e08d4376623$var$BufferFromRawAccountData,
    rentEpoch: (0, $jDCP1.number)()
});
/**
 * @internal
 */ const $39e49e08d4376623$var$KeyedAccountInfoResult = (0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    account: $39e49e08d4376623$var$AccountInfoResult
});
const $39e49e08d4376623$var$ParsedOrRawAccountData = (0, $jDCP1.coerce)((0, $jDCP1.union)([
    (0, $jDCP1.instance)((0, $7aSCJ.Buffer)),
    $39e49e08d4376623$var$ParsedAccountDataResult
]), (0, $jDCP1.union)([
    $39e49e08d4376623$var$RawAccountDataResult,
    $39e49e08d4376623$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $jDCP1.create)(value, $39e49e08d4376623$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $39e49e08d4376623$var$ParsedAccountInfoResult = (0, $jDCP1.type)({
    executable: (0, $jDCP1.boolean)(),
    owner: $39e49e08d4376623$var$PublicKeyFromString,
    lamports: (0, $jDCP1.number)(),
    data: $39e49e08d4376623$var$ParsedOrRawAccountData,
    rentEpoch: (0, $jDCP1.number)()
});
const $39e49e08d4376623$var$KeyedParsedAccountInfoResult = (0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    account: $39e49e08d4376623$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $39e49e08d4376623$var$StakeActivationResult = (0, $jDCP1.type)({
    state: (0, $jDCP1.union)([
        (0, $jDCP1.literal)("active"),
        (0, $jDCP1.literal)("inactive"),
        (0, $jDCP1.literal)("activating"),
        (0, $jDCP1.literal)("deactivating")
    ]),
    active: (0, $jDCP1.number)(),
    inactive: (0, $jDCP1.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $39e49e08d4376623$var$GetConfirmedSignaturesForAddress2RpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)((0, $jDCP1.type)({
    signature: (0, $jDCP1.string)(),
    slot: (0, $jDCP1.number)(),
    err: $39e49e08d4376623$var$TransactionErrorResult,
    memo: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    blockTime: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $39e49e08d4376623$var$GetSignaturesForAddressRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)((0, $jDCP1.type)({
    signature: (0, $jDCP1.string)(),
    slot: (0, $jDCP1.number)(),
    err: $39e49e08d4376623$var$TransactionErrorResult,
    memo: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    blockTime: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $39e49e08d4376623$var$AccountNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: $39e49e08d4376623$var$notificationResultAndContext($39e49e08d4376623$var$AccountInfoResult)
});
/**
 * @internal
 */ const $39e49e08d4376623$var$ProgramAccountInfoResult = (0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    account: $39e49e08d4376623$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $39e49e08d4376623$var$ProgramAccountNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: $39e49e08d4376623$var$notificationResultAndContext($39e49e08d4376623$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $39e49e08d4376623$var$SlotInfoResult = (0, $jDCP1.type)({
    parent: (0, $jDCP1.number)(),
    slot: (0, $jDCP1.number)(),
    root: (0, $jDCP1.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $39e49e08d4376623$var$SlotNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: $39e49e08d4376623$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $39e49e08d4376623$var$SlotUpdateResult = (0, $jDCP1.union)([
    (0, $jDCP1.type)({
        type: (0, $jDCP1.union)([
            (0, $jDCP1.literal)("firstShredReceived"),
            (0, $jDCP1.literal)("completed"),
            (0, $jDCP1.literal)("optimisticConfirmation"),
            (0, $jDCP1.literal)("root")
        ]),
        slot: (0, $jDCP1.number)(),
        timestamp: (0, $jDCP1.number)()
    }),
    (0, $jDCP1.type)({
        type: (0, $jDCP1.literal)("createdBank"),
        parent: (0, $jDCP1.number)(),
        slot: (0, $jDCP1.number)(),
        timestamp: (0, $jDCP1.number)()
    }),
    (0, $jDCP1.type)({
        type: (0, $jDCP1.literal)("frozen"),
        slot: (0, $jDCP1.number)(),
        timestamp: (0, $jDCP1.number)(),
        stats: (0, $jDCP1.type)({
            numTransactionEntries: (0, $jDCP1.number)(),
            numSuccessfulTransactions: (0, $jDCP1.number)(),
            numFailedTransactions: (0, $jDCP1.number)(),
            maxTransactionsPerEntry: (0, $jDCP1.number)()
        })
    }),
    (0, $jDCP1.type)({
        type: (0, $jDCP1.literal)("dead"),
        slot: (0, $jDCP1.number)(),
        timestamp: (0, $jDCP1.number)(),
        err: (0, $jDCP1.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $39e49e08d4376623$var$SlotUpdateNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: $39e49e08d4376623$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $39e49e08d4376623$var$SignatureNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: $39e49e08d4376623$var$notificationResultAndContext((0, $jDCP1.union)([
        $39e49e08d4376623$var$SignatureStatusResult,
        $39e49e08d4376623$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $39e49e08d4376623$var$RootNotificationResult = (0, $jDCP1.type)({
    subscription: (0, $jDCP1.number)(),
    result: (0, $jDCP1.number)()
});
const $39e49e08d4376623$var$ContactInfoResult = (0, $jDCP1.type)({
    pubkey: (0, $jDCP1.string)(),
    gossip: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    tpu: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    rpc: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    version: (0, $jDCP1.nullable)((0, $jDCP1.string)())
});
const $39e49e08d4376623$var$VoteAccountInfoResult = (0, $jDCP1.type)({
    votePubkey: (0, $jDCP1.string)(),
    nodePubkey: (0, $jDCP1.string)(),
    activatedStake: (0, $jDCP1.number)(),
    epochVoteAccount: (0, $jDCP1.boolean)(),
    epochCredits: (0, $jDCP1.array)((0, $jDCP1.tuple)([
        (0, $jDCP1.number)(),
        (0, $jDCP1.number)(),
        (0, $jDCP1.number)()
    ])),
    commission: (0, $jDCP1.number)(),
    lastVote: (0, $jDCP1.number)(),
    rootSlot: (0, $jDCP1.nullable)((0, $jDCP1.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $39e49e08d4376623$var$GetVoteAccounts = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.type)({
    current: (0, $jDCP1.array)($39e49e08d4376623$var$VoteAccountInfoResult),
    delinquent: (0, $jDCP1.array)($39e49e08d4376623$var$VoteAccountInfoResult)
}));
const $39e49e08d4376623$var$ConfirmationStatus = (0, $jDCP1.union)([
    (0, $jDCP1.literal)("processed"),
    (0, $jDCP1.literal)("confirmed"),
    (0, $jDCP1.literal)("finalized")
]);
const $39e49e08d4376623$var$SignatureStatusResponse = (0, $jDCP1.type)({
    slot: (0, $jDCP1.number)(),
    confirmations: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    err: $39e49e08d4376623$var$TransactionErrorResult,
    confirmationStatus: (0, $jDCP1.optional)($39e49e08d4376623$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $39e49e08d4376623$var$GetSignatureStatusesRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.nullable)($39e49e08d4376623$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $39e49e08d4376623$var$GetMinimumBalanceForRentExemptionRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)());
const $39e49e08d4376623$var$AddressTableLookupStruct = (0, $jDCP1.type)({
    accountKey: $39e49e08d4376623$var$PublicKeyFromString,
    writableIndexes: (0, $jDCP1.array)((0, $jDCP1.number)()),
    readonlyIndexes: (0, $jDCP1.array)((0, $jDCP1.number)())
});
const $39e49e08d4376623$var$ConfirmedTransactionResult = (0, $jDCP1.type)({
    signatures: (0, $jDCP1.array)((0, $jDCP1.string)()),
    message: (0, $jDCP1.type)({
        accountKeys: (0, $jDCP1.array)((0, $jDCP1.string)()),
        header: (0, $jDCP1.type)({
            numRequiredSignatures: (0, $jDCP1.number)(),
            numReadonlySignedAccounts: (0, $jDCP1.number)(),
            numReadonlyUnsignedAccounts: (0, $jDCP1.number)()
        }),
        instructions: (0, $jDCP1.array)((0, $jDCP1.type)({
            accounts: (0, $jDCP1.array)((0, $jDCP1.number)()),
            data: (0, $jDCP1.string)(),
            programIdIndex: (0, $jDCP1.number)()
        })),
        recentBlockhash: (0, $jDCP1.string)(),
        addressTableLookups: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$AddressTableLookupStruct))
    })
});
const $39e49e08d4376623$var$AnnotatedAccountKey = (0, $jDCP1.type)({
    pubkey: $39e49e08d4376623$var$PublicKeyFromString,
    signer: (0, $jDCP1.boolean)(),
    writable: (0, $jDCP1.boolean)(),
    source: (0, $jDCP1.optional)((0, $jDCP1.union)([
        (0, $jDCP1.literal)("transaction"),
        (0, $jDCP1.literal)("lookupTable")
    ]))
});
const $39e49e08d4376623$var$ConfirmedTransactionAccountsModeResult = (0, $jDCP1.type)({
    accountKeys: (0, $jDCP1.array)($39e49e08d4376623$var$AnnotatedAccountKey),
    signatures: (0, $jDCP1.array)((0, $jDCP1.string)())
});
const $39e49e08d4376623$var$ParsedInstructionResult = (0, $jDCP1.type)({
    parsed: (0, $jDCP1.unknown)(),
    program: (0, $jDCP1.string)(),
    programId: $39e49e08d4376623$var$PublicKeyFromString
});
const $39e49e08d4376623$var$RawInstructionResult = (0, $jDCP1.type)({
    accounts: (0, $jDCP1.array)($39e49e08d4376623$var$PublicKeyFromString),
    data: (0, $jDCP1.string)(),
    programId: $39e49e08d4376623$var$PublicKeyFromString
});
const $39e49e08d4376623$var$InstructionResult = (0, $jDCP1.union)([
    $39e49e08d4376623$var$RawInstructionResult,
    $39e49e08d4376623$var$ParsedInstructionResult
]);
const $39e49e08d4376623$var$UnknownInstructionResult = (0, $jDCP1.union)([
    (0, $jDCP1.type)({
        parsed: (0, $jDCP1.unknown)(),
        program: (0, $jDCP1.string)(),
        programId: (0, $jDCP1.string)()
    }),
    (0, $jDCP1.type)({
        accounts: (0, $jDCP1.array)((0, $jDCP1.string)()),
        data: (0, $jDCP1.string)(),
        programId: (0, $jDCP1.string)()
    })
]);
const $39e49e08d4376623$var$ParsedOrRawInstruction = (0, $jDCP1.coerce)($39e49e08d4376623$var$InstructionResult, $39e49e08d4376623$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $jDCP1.create)(value, $39e49e08d4376623$var$RawInstructionResult);
    else return (0, $jDCP1.create)(value, $39e49e08d4376623$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $39e49e08d4376623$var$ParsedConfirmedTransactionResult = (0, $jDCP1.type)({
    signatures: (0, $jDCP1.array)((0, $jDCP1.string)()),
    message: (0, $jDCP1.type)({
        accountKeys: (0, $jDCP1.array)($39e49e08d4376623$var$AnnotatedAccountKey),
        instructions: (0, $jDCP1.array)($39e49e08d4376623$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $jDCP1.string)(),
        addressTableLookups: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)($39e49e08d4376623$var$AddressTableLookupStruct)))
    })
});
const $39e49e08d4376623$var$TokenBalanceResult = (0, $jDCP1.type)({
    accountIndex: (0, $jDCP1.number)(),
    mint: (0, $jDCP1.string)(),
    owner: (0, $jDCP1.optional)((0, $jDCP1.string)()),
    uiTokenAmount: $39e49e08d4376623$var$TokenAmountResult
});
const $39e49e08d4376623$var$LoadedAddressesResult = (0, $jDCP1.type)({
    writable: (0, $jDCP1.array)($39e49e08d4376623$var$PublicKeyFromString),
    readonly: (0, $jDCP1.array)($39e49e08d4376623$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $39e49e08d4376623$var$ConfirmedTransactionMetaResult = (0, $jDCP1.type)({
    err: $39e49e08d4376623$var$TransactionErrorResult,
    fee: (0, $jDCP1.number)(),
    innerInstructions: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.type)({
        index: (0, $jDCP1.number)(),
        instructions: (0, $jDCP1.array)((0, $jDCP1.type)({
            accounts: (0, $jDCP1.array)((0, $jDCP1.number)()),
            data: (0, $jDCP1.string)(),
            programIdIndex: (0, $jDCP1.number)()
        }))
    })))),
    preBalances: (0, $jDCP1.array)((0, $jDCP1.number)()),
    postBalances: (0, $jDCP1.array)((0, $jDCP1.number)()),
    logMessages: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.string)()))),
    preTokenBalances: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)($39e49e08d4376623$var$TokenBalanceResult))),
    postTokenBalances: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)($39e49e08d4376623$var$TokenBalanceResult))),
    loadedAddresses: (0, $jDCP1.optional)($39e49e08d4376623$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $jDCP1.optional)((0, $jDCP1.number)())
});
/**
 * @internal
 */ const $39e49e08d4376623$var$ParsedConfirmedTransactionMetaResult = (0, $jDCP1.type)({
    err: $39e49e08d4376623$var$TransactionErrorResult,
    fee: (0, $jDCP1.number)(),
    innerInstructions: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.type)({
        index: (0, $jDCP1.number)(),
        instructions: (0, $jDCP1.array)($39e49e08d4376623$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $jDCP1.array)((0, $jDCP1.number)()),
    postBalances: (0, $jDCP1.array)((0, $jDCP1.number)()),
    logMessages: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)((0, $jDCP1.string)()))),
    preTokenBalances: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)($39e49e08d4376623$var$TokenBalanceResult))),
    postTokenBalances: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.array)($39e49e08d4376623$var$TokenBalanceResult))),
    loadedAddresses: (0, $jDCP1.optional)($39e49e08d4376623$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $jDCP1.optional)((0, $jDCP1.number)())
});
const $39e49e08d4376623$var$TransactionVersionStruct = (0, $jDCP1.union)([
    (0, $jDCP1.literal)(0),
    (0, $jDCP1.literal)("legacy")
]);
/** @internal */ const $39e49e08d4376623$var$RewardsResult = (0, $jDCP1.type)({
    pubkey: (0, $jDCP1.string)(),
    lamports: (0, $jDCP1.number)(),
    postBalance: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    rewardType: (0, $jDCP1.nullable)((0, $jDCP1.string)()),
    commission: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $39e49e08d4376623$var$GetBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    transactions: (0, $jDCP1.array)((0, $jDCP1.type)({
        transaction: $39e49e08d4376623$var$ConfirmedTransactionResult,
        meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ConfirmedTransactionMetaResult),
        version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
    })),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $39e49e08d4376623$var$GetNoneModeBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $39e49e08d4376623$var$GetAccountsModeBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    transactions: (0, $jDCP1.array)((0, $jDCP1.type)({
        transaction: $39e49e08d4376623$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ConfirmedTransactionMetaResult),
        version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
    })),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $39e49e08d4376623$var$GetParsedBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    transactions: (0, $jDCP1.array)((0, $jDCP1.type)({
        transaction: $39e49e08d4376623$var$ParsedConfirmedTransactionResult,
        meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
    })),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $39e49e08d4376623$var$GetParsedAccountsModeBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    transactions: (0, $jDCP1.array)((0, $jDCP1.type)({
        transaction: $39e49e08d4376623$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
    })),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $39e49e08d4376623$var$GetParsedNoneModeBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)()),
    blockHeight: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $39e49e08d4376623$var$GetConfirmedBlockRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    transactions: (0, $jDCP1.array)((0, $jDCP1.type)({
        transaction: $39e49e08d4376623$var$ConfirmedTransactionResult,
        meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $jDCP1.optional)((0, $jDCP1.array)($39e49e08d4376623$var$RewardsResult)),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $39e49e08d4376623$var$GetBlockSignaturesRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    previousBlockhash: (0, $jDCP1.string)(),
    parentSlot: (0, $jDCP1.number)(),
    signatures: (0, $jDCP1.array)((0, $jDCP1.string)()),
    blockTime: (0, $jDCP1.nullable)((0, $jDCP1.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $39e49e08d4376623$var$GetTransactionRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    slot: (0, $jDCP1.number)(),
    meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)())),
    transaction: $39e49e08d4376623$var$ConfirmedTransactionResult,
    version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $39e49e08d4376623$var$GetParsedTransactionRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.type)({
    slot: (0, $jDCP1.number)(),
    transaction: $39e49e08d4376623$var$ParsedConfirmedTransactionResult,
    meta: (0, $jDCP1.nullable)($39e49e08d4376623$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $jDCP1.optional)((0, $jDCP1.nullable)((0, $jDCP1.number)())),
    version: (0, $jDCP1.optional)($39e49e08d4376623$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $39e49e08d4376623$var$GetRecentBlockhashAndContextRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    feeCalculator: (0, $jDCP1.type)({
        lamportsPerSignature: (0, $jDCP1.number)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $39e49e08d4376623$var$GetLatestBlockhashRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.type)({
    blockhash: (0, $jDCP1.string)(),
    lastValidBlockHeight: (0, $jDCP1.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $39e49e08d4376623$var$IsBlockhashValidRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.boolean)());
const $39e49e08d4376623$var$PerfSampleResult = (0, $jDCP1.type)({
    slot: (0, $jDCP1.number)(),
    numTransactions: (0, $jDCP1.number)(),
    numSlots: (0, $jDCP1.number)(),
    samplePeriodSecs: (0, $jDCP1.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $39e49e08d4376623$var$GetRecentPerformanceSamplesRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)($39e49e08d4376623$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $39e49e08d4376623$var$GetFeeCalculatorRpcResult = $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.nullable)((0, $jDCP1.type)({
    feeCalculator: (0, $jDCP1.type)({
        lamportsPerSignature: (0, $jDCP1.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $39e49e08d4376623$var$RequestAirdropRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $39e49e08d4376623$var$SendTransactionRpcResult = $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $39e49e08d4376623$var$LogsResult = (0, $jDCP1.type)({
    err: $39e49e08d4376623$var$TransactionErrorResult,
    logs: (0, $jDCP1.array)((0, $jDCP1.string)()),
    signature: (0, $jDCP1.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $39e49e08d4376623$var$LogsNotificationResult = (0, $jDCP1.type)({
    result: $39e49e08d4376623$var$notificationResultAndContext($39e49e08d4376623$var$LogsResult),
    subscription: (0, $jDCP1.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $39e49e08d4376623$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $39e49e08d4376623$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $39e49e08d4376623$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)()));
                        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $39e49e08d4376623$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $39e49e08d4376623$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $39e49e08d4376623$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $39e49e08d4376623$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $39e49e08d4376623$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $39e49e08d4376623$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.number)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.nullable)((0, $jDCP1.number)())));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$SlotRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetSupplyRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext($39e49e08d4376623$var$TokenAmountResult));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext($39e49e08d4376623$var$TokenAmountResult));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.nullable)($39e49e08d4376623$var$AccountInfoResult)));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.nullable)($39e49e08d4376623$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.nullable)($39e49e08d4376623$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.array)((0, $jDCP1.nullable)($39e49e08d4376623$var$AccountInfoResult))));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$StakeActivationResult));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", configWithoutEncoding);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $jDCP1.array)($39e49e08d4376623$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext(baseSchema)) : (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)($39e49e08d4376623$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($4TRC3))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $39e49e08d4376623$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $39e49e08d4376623$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $39e49e08d4376623$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $39e49e08d4376623$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $39e49e08d4376623$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $39e49e08d4376623$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $39e49e08d4376623$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $39e49e08d4376623$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $39e49e08d4376623$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $39e49e08d4376623$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $39e49e08d4376623$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $39e49e08d4376623$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $39e49e08d4376623$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $39e49e08d4376623$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $39e49e08d4376623$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $39e49e08d4376623$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $39e49e08d4376623$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $39e49e08d4376623$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)($39e49e08d4376623$var$ContactInfoResult)));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetVoteAccounts);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.string)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)($39e49e08d4376623$var$PublicKeyFromString)));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $39e49e08d4376623$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.number)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetInflationRewardResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $39e49e08d4376623$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $39e49e08d4376623$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.nullable)((0, $jDCP1.number)())));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult($39e49e08d4376623$var$VersionResult));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.string)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $39e49e08d4376623$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetTransactionRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $39e49e08d4376623$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $39e49e08d4376623$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetTransactionRpcResult);
            if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $39e49e08d4376623$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $39e49e08d4376623$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $39e49e08d4376623$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResult((0, $jDCP1.array)((0, $jDCP1.number)())));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetTransactionRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $39e49e08d4376623$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $39e49e08d4376623$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $39e49e08d4376623$export$5b2310da10e607da({
            key: accountKey,
            state: $39e49e08d4376623$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $39e49e08d4376623$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $39e49e08d4376623$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $39e49e08d4376623$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $39e49e08d4376623$var$sleep($39e49e08d4376623$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $39e49e08d4376623$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$jsonRpcResultAndContext((0, $jDCP1.number)()));
        if ("error" in res) throw new $39e49e08d4376623$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $7aSCJ.Buffer).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $39e49e08d4376623$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $39e49e08d4376623$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $39e49e08d4376623$export$121e803f723b3045("failed to simulate transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $39e49e08d4376623$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $jDCP1.create)(unsafeRes, $39e49e08d4376623$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $39e49e08d4376623$export$121e803f723b3045("failed to send transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $39e49e08d4376623$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $39e49e08d4376623$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64");
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $jDCP1.create)(notification, $39e49e08d4376623$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $39e49e08d4376623$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $39e49e08d4376623$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $39e49e08d4376623$export$c53bca448cf33676($39e49e08d4376623$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $39e49e08d4376623$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $39e49e08d4376623$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $39e49e08d4376623$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $39e49e08d4376623$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $39e49e08d4376623$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $39e49e08d4376623$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$u64("recentSlot"),
            $hGf21.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$u64(),
            $hGf21.seq($39e49e08d4376623$var$publicKey(), $hGf21.offset($hGf21.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    }
});
class $39e49e08d4376623$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $hGf21.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($39e49e08d4376623$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $39e49e08d4376623$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($39e49e08d4376623$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $39e49e08d4376623$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $39e49e08d4376623$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $2HiMo.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $39e49e08d4376623$export$7d102200c3a357d6.CreateLookupTable;
        const data = $39e49e08d4376623$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $39e49e08d4376623$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $39e49e08d4376623$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $39e49e08d4376623$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $39e49e08d4376623$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $39e49e08d4376623$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $39e49e08d4376623$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $39e49e08d4376623$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $39e49e08d4376623$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $39e49e08d4376623$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $39e49e08d4376623$export$7d102200c3a357d6.CloseLookupTable;
        const data = $39e49e08d4376623$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$39e49e08d4376623$export$5147a345798de168.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $39e49e08d4376623$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $hGf21.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($39e49e08d4376623$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($39e49e08d4376623$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $39e49e08d4376623$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $hGf21.struct([
            $hGf21.u8("instruction"),
            $hGf21.u32("units"),
            $hGf21.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $hGf21.struct([
            $hGf21.u8("instruction"),
            $hGf21.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $hGf21.struct([
            $hGf21.u8("instruction"),
            $hGf21.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $hGf21.struct([
            $hGf21.u8("instruction"),
            $39e49e08d4376623$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $39e49e08d4376623$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $39e49e08d4376623$export$b7c79c50764da3d6.RequestUnits;
        const data = $39e49e08d4376623$var$encodeData(type, params);
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $39e49e08d4376623$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $39e49e08d4376623$var$encodeData(type, params);
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $39e49e08d4376623$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $39e49e08d4376623$var$encodeData(type, params);
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $39e49e08d4376623$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $39e49e08d4376623$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$39e49e08d4376623$export$11585db5942bcdb7.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $39e49e08d4376623$var$PRIVATE_KEY_BYTES$1 = 64;
const $39e49e08d4376623$var$PUBLIC_KEY_BYTES$1 = 32;
const $39e49e08d4376623$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $39e49e08d4376623$var$ED25519_INSTRUCTION_LAYOUT = $hGf21.struct([
    $hGf21.u8("numSignatures"),
    $hGf21.u8("padding"),
    $hGf21.u16("signatureOffset"),
    $hGf21.u16("signatureInstructionIndex"),
    $hGf21.u16("publicKeyOffset"),
    $hGf21.u16("publicKeyInstructionIndex"),
    $hGf21.u16("messageDataOffset"),
    $hGf21.u16("messageDataSize"),
    $hGf21.u16("messageInstructionIndex")
]);
class $39e49e08d4376623$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $39e49e08d4376623$var$assert(publicKey.length === $39e49e08d4376623$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$39e49e08d4376623$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $39e49e08d4376623$var$assert(signature.length === $39e49e08d4376623$var$SIGNATURE_BYTES, `Signature must be ${$39e49e08d4376623$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $39e49e08d4376623$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $7aSCJ.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $39e49e08d4376623$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $39e49e08d4376623$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $39e49e08d4376623$var$assert(privateKey.length === $39e49e08d4376623$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$39e49e08d4376623$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $39e49e08d4376623$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $39e49e08d4376623$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$39e49e08d4376623$export$e5087aea02631e.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $39e49e08d4376623$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $iI8rD.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $iI8rD.secp256k1).utils.isValidPrivateKey;
const $39e49e08d4376623$var$publicKeyCreate = (0, $iI8rD.secp256k1).getPublicKey;
const $39e49e08d4376623$var$PRIVATE_KEY_BYTES = 32;
const $39e49e08d4376623$var$ETHEREUM_ADDRESS_BYTES = 20;
const $39e49e08d4376623$var$PUBLIC_KEY_BYTES = 64;
const $39e49e08d4376623$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $39e49e08d4376623$var$SECP256K1_INSTRUCTION_LAYOUT = $hGf21.struct([
    $hGf21.u8("numSignatures"),
    $hGf21.u16("signatureOffset"),
    $hGf21.u8("signatureInstructionIndex"),
    $hGf21.u16("ethAddressOffset"),
    $hGf21.u8("ethAddressInstructionIndex"),
    $hGf21.u16("messageDataOffset"),
    $hGf21.u16("messageDataSize"),
    $hGf21.u8("messageInstructionIndex"),
    $hGf21.blob(20, "ethAddress"),
    $hGf21.blob(64, "signature"),
    $hGf21.u8("recoveryId")
]);
class $39e49e08d4376623$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $39e49e08d4376623$var$assert(publicKey.length === $39e49e08d4376623$var$PUBLIC_KEY_BYTES, `Public key must be ${$39e49e08d4376623$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $7aSCJ.Buffer).from((0, $bj4AF.keccak_256)($39e49e08d4376623$var$toBuffer(publicKey))).slice(-$39e49e08d4376623$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $39e49e08d4376623$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $39e49e08d4376623$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $7aSCJ.Buffer).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $7aSCJ.Buffer).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $39e49e08d4376623$var$assert(ethAddress.length === $39e49e08d4376623$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$39e49e08d4376623$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $39e49e08d4376623$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $7aSCJ.Buffer).alloc($39e49e08d4376623$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $39e49e08d4376623$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $39e49e08d4376623$var$toBuffer(signature),
            ethAddress: $39e49e08d4376623$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($39e49e08d4376623$var$toBuffer(message), $39e49e08d4376623$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $39e49e08d4376623$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $39e49e08d4376623$var$assert(pkey.length === $39e49e08d4376623$var$PRIVATE_KEY_BYTES, `Private key must be ${$39e49e08d4376623$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $39e49e08d4376623$var$toBuffer(pkey);
            const publicKey = $39e49e08d4376623$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $7aSCJ.Buffer).from((0, $bj4AF.keccak_256)($39e49e08d4376623$var$toBuffer(message)));
            const [signature, recoveryId] = $39e49e08d4376623$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$39e49e08d4376623$export$d85dd4c1161d13c9.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $39e49e08d4376623$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $39e49e08d4376623$export$18aac71979bdd08f = new $39e49e08d4376623$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $39e49e08d4376623$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $39e49e08d4376623$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$39e49e08d4376623$var$_class2 = $39e49e08d4376623$export$e7f3941ade35598c;
$39e49e08d4376623$export$e7f3941ade35598c.default = new $39e49e08d4376623$var$_class2(0, 0, $39e49e08d4376623$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $39e49e08d4376623$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $hGf21.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($39e49e08d4376623$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $39e49e08d4376623$export$9ac74ae66932a145(new $39e49e08d4376623$export$ca8b6604d6ce14de(authorized.staker), new $39e49e08d4376623$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $39e49e08d4376623$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $39e49e08d4376623$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $39e49e08d4376623$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($39e49e08d4376623$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $39e49e08d4376623$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$authorized(),
            $39e49e08d4376623$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("newAuthorized"),
            $hGf21.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("newAuthorized"),
            $hGf21.u32("stakeAuthorizationType"),
            $39e49e08d4376623$var$rustString("authoritySeed"),
            $39e49e08d4376623$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $39e49e08d4376623$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $39e49e08d4376623$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $39e49e08d4376623$export$e7f3941ade35598c.default;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Initialize;
        const data = $39e49e08d4376623$var$encodeData(type, {
            authorized: {
                staker: $39e49e08d4376623$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $39e49e08d4376623$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $39e49e08d4376623$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Delegate;
        const data = $39e49e08d4376623$var$encodeData(type);
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Authorize;
        const data = $39e49e08d4376623$var$encodeData(type, {
            newAuthorized: $39e49e08d4376623$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $39e49e08d4376623$var$encodeData(type, {
            newAuthorized: $39e49e08d4376623$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $39e49e08d4376623$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Split;
        const data = $39e49e08d4376623$var$encodeData(type, {
            lamports: lamports
        });
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.add($39e49e08d4376623$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($39e49e08d4376623$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Merge;
        const data = $39e49e08d4376623$var$encodeData(type);
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Withdraw;
        const data = $39e49e08d4376623$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $39e49e08d4376623$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $39e49e08d4376623$export$c89793bd2bba8b2e.Deactivate;
        const data = $39e49e08d4376623$var$encodeData(type);
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$39e49e08d4376623$export$df86f933e9f8fb15.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $39e49e08d4376623$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $39e49e08d4376623$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $39e49e08d4376623$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $hGf21.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $39e49e08d4376623$export$3f9d1b16ff840d7(new $39e49e08d4376623$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $39e49e08d4376623$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $39e49e08d4376623$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $39e49e08d4376623$var$decodeData$1($39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($39e49e08d4376623$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$publicKey("newAuthorized"),
            $hGf21.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $hGf21.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $hGf21.struct([
            $hGf21.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $hGf21.struct([
            $hGf21.u32("instruction"),
            $39e49e08d4376623$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $39e49e08d4376623$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $39e49e08d4376623$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $39e49e08d4376623$var$encodeData(type, {
            voteInit: {
                nodePubkey: $39e49e08d4376623$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $39e49e08d4376623$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $39e49e08d4376623$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $39e49e08d4376623$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $39e49e08d4376623$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $39e49e08d4376623$export$febc5573c75cefb0();
        transaction.add($39e49e08d4376623$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $39e49e08d4376623$var$encodeData(type, {
            newAuthorized: $39e49e08d4376623$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $39e49e08d4376623$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $39e49e08d4376623$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $39e49e08d4376623$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $39e49e08d4376623$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $39e49e08d4376623$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
        return $39e49e08d4376623$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $39e49e08d4376623$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $39e49e08d4376623$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $39e49e08d4376623$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$39e49e08d4376623$export$83db2bc702bee1eb.programId = new $39e49e08d4376623$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $39e49e08d4376623$export$83db2bc702bee1eb.space = 3762;
const $39e49e08d4376623$export$afdb09d3afdde87c = new $39e49e08d4376623$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $39e49e08d4376623$var$InfoString = (0, $jDCP1.type)({
    name: (0, $jDCP1.string)(),
    website: (0, $jDCP1.optional)((0, $jDCP1.string)()),
    details: (0, $jDCP1.optional)((0, $jDCP1.string)()),
    keybaseUsername: (0, $jDCP1.optional)((0, $jDCP1.string)())
});
/**
 * ValidatorInfo class
 */ class $39e49e08d4376623$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $39e49e08d4376623$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $39e49e08d4376623$export$ca8b6604d6ce14de($39e49e08d4376623$var$guardedSplice(byteArray, 0, $39e49e08d4376623$export$84fc0a248cc54343));
            const isSigner = $39e49e08d4376623$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($39e49e08d4376623$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $39e49e08d4376623$var$rustString().decode((0, $7aSCJ.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $jDCP1.assert)(info, $39e49e08d4376623$var$InfoString);
                return new $39e49e08d4376623$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $39e49e08d4376623$export$90bca02a3aea0768 = new $39e49e08d4376623$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $39e49e08d4376623$var$VoteAccountLayout = $hGf21.struct([
    $39e49e08d4376623$var$publicKey("nodePubkey"),
    $39e49e08d4376623$var$publicKey("authorizedWithdrawer"),
    $hGf21.u8("commission"),
    $hGf21.nu64(),
    // votes.length
    $hGf21.seq($hGf21.struct([
        $hGf21.nu64("slot"),
        $hGf21.u32("confirmationCount")
    ]), $hGf21.offset($hGf21.u32(), -8), "votes"),
    $hGf21.u8("rootSlotValid"),
    $hGf21.nu64("rootSlot"),
    $hGf21.nu64(),
    // authorizedVoters.length
    $hGf21.seq($hGf21.struct([
        $hGf21.nu64("epoch"),
        $39e49e08d4376623$var$publicKey("authorizedVoter")
    ]), $hGf21.offset($hGf21.u32(), -8), "authorizedVoters"),
    $hGf21.struct([
        $hGf21.seq($hGf21.struct([
            $39e49e08d4376623$var$publicKey("authorizedPubkey"),
            $hGf21.nu64("epochOfLastAuthorizedSwitch"),
            $hGf21.nu64("targetEpoch")
        ]), 32, "buf"),
        $hGf21.nu64("idx"),
        $hGf21.u8("isEmpty")
    ], "priorVoters"),
    $hGf21.nu64(),
    // epochCredits.length
    $hGf21.seq($hGf21.struct([
        $hGf21.nu64("epoch"),
        $hGf21.nu64("credits"),
        $hGf21.nu64("prevCredits")
    ]), $hGf21.offset($hGf21.u32(), -8), "epochCredits"),
    $hGf21.struct([
        $hGf21.nu64("slot"),
        $hGf21.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $39e49e08d4376623$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $39e49e08d4376623$var$VoteAccountLayout.decode($39e49e08d4376623$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $39e49e08d4376623$export$89ef186f708d638b({
            nodePubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $39e49e08d4376623$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($39e49e08d4376623$var$parseAuthorizedVoter),
            priorVoters: $39e49e08d4376623$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $39e49e08d4376623$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $39e49e08d4376623$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $39e49e08d4376623$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $39e49e08d4376623$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $39e49e08d4376623$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($39e49e08d4376623$var$parsePriorVoters),
        ...buf.slice(0, idx).map($39e49e08d4376623$var$parsePriorVoters)
    ];
}
const $39e49e08d4376623$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $39e49e08d4376623$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $39e49e08d4376623$var$endpoint[key]["devnet"];
    const url = $39e49e08d4376623$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $39e49e08d4376623$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $39e49e08d4376623$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("7aSCJ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5393d6b91c293c78$export$a143d493d941bafc; }, function (v) { return $5393d6b91c293c78$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5393d6b91c293c78$export$f99ded8fe4b79145; }, function (v) { return $5393d6b91c293c78$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5393d6b91c293c78$export$a143d493d941bafc;
var $5393d6b91c293c78$export$e4cf37d7f6fb9e0a;
var $5393d6b91c293c78$export$f99ded8fe4b79145;
var $5393d6b91c293c78$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $5393d6b91c293c78$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5393d6b91c293c78$export$a143d493d941bafc = $5393d6b91c293c78$var$Buffer;
$5393d6b91c293c78$export$e4cf37d7f6fb9e0a = $5393d6b91c293c78$var$SlowBuffer;
$5393d6b91c293c78$export$f99ded8fe4b79145 = 50;
const $5393d6b91c293c78$var$K_MAX_LENGTH = 0x7fffffff;
$5393d6b91c293c78$export$599f31c3813fae4d = $5393d6b91c293c78$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5393d6b91c293c78$var$Buffer.TYPED_ARRAY_SUPPORT = $5393d6b91c293c78$var$typedArraySupport();
if (!$5393d6b91c293c78$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5393d6b91c293c78$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5393d6b91c293c78$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5393d6b91c293c78$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5393d6b91c293c78$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5393d6b91c293c78$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5393d6b91c293c78$var$createBuffer(length) {
    if (length > $5393d6b91c293c78$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5393d6b91c293c78$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5393d6b91c293c78$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5393d6b91c293c78$var$allocUnsafe(arg);
    }
    return $5393d6b91c293c78$var$from(arg, encodingOrOffset, length);
}
$5393d6b91c293c78$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5393d6b91c293c78$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5393d6b91c293c78$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5393d6b91c293c78$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5393d6b91c293c78$var$isInstance(value, ArrayBuffer) || value && $5393d6b91c293c78$var$isInstance(value.buffer, ArrayBuffer)) return $5393d6b91c293c78$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5393d6b91c293c78$var$isInstance(value, SharedArrayBuffer) || value && $5393d6b91c293c78$var$isInstance(value.buffer, SharedArrayBuffer))) return $5393d6b91c293c78$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5393d6b91c293c78$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5393d6b91c293c78$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5393d6b91c293c78$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5393d6b91c293c78$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5393d6b91c293c78$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5393d6b91c293c78$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5393d6b91c293c78$var$Buffer, Uint8Array);
function $5393d6b91c293c78$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5393d6b91c293c78$var$alloc(size, fill, encoding) {
    $5393d6b91c293c78$var$assertSize(size);
    if (size <= 0) return $5393d6b91c293c78$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5393d6b91c293c78$var$createBuffer(size).fill(fill, encoding) : $5393d6b91c293c78$var$createBuffer(size).fill(fill);
    return $5393d6b91c293c78$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5393d6b91c293c78$var$Buffer.alloc = function(size, fill, encoding) {
    return $5393d6b91c293c78$var$alloc(size, fill, encoding);
};
function $5393d6b91c293c78$var$allocUnsafe(size) {
    $5393d6b91c293c78$var$assertSize(size);
    return $5393d6b91c293c78$var$createBuffer(size < 0 ? 0 : $5393d6b91c293c78$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5393d6b91c293c78$var$Buffer.allocUnsafe = function(size) {
    return $5393d6b91c293c78$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5393d6b91c293c78$var$Buffer.allocUnsafeSlow = function(size) {
    return $5393d6b91c293c78$var$allocUnsafe(size);
};
function $5393d6b91c293c78$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5393d6b91c293c78$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5393d6b91c293c78$var$byteLength(string, encoding) | 0;
    let buf = $5393d6b91c293c78$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5393d6b91c293c78$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5393d6b91c293c78$var$checked(array.length) | 0;
    const buf = $5393d6b91c293c78$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5393d6b91c293c78$var$fromArrayView(arrayView) {
    if ($5393d6b91c293c78$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5393d6b91c293c78$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5393d6b91c293c78$var$fromArrayLike(arrayView);
}
function $5393d6b91c293c78$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5393d6b91c293c78$var$Buffer.prototype);
    return buf;
}
function $5393d6b91c293c78$var$fromObject(obj) {
    if ($5393d6b91c293c78$var$Buffer.isBuffer(obj)) {
        const len = $5393d6b91c293c78$var$checked(obj.length) | 0;
        const buf = $5393d6b91c293c78$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5393d6b91c293c78$var$numberIsNaN(obj.length)) return $5393d6b91c293c78$var$createBuffer(0);
        return $5393d6b91c293c78$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5393d6b91c293c78$var$fromArrayLike(obj.data);
}
function $5393d6b91c293c78$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5393d6b91c293c78$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5393d6b91c293c78$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5393d6b91c293c78$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5393d6b91c293c78$var$Buffer.alloc(+length);
}
$5393d6b91c293c78$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5393d6b91c293c78$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5393d6b91c293c78$var$Buffer.compare = function compare(a, b) {
    if ($5393d6b91c293c78$var$isInstance(a, Uint8Array)) a = $5393d6b91c293c78$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5393d6b91c293c78$var$isInstance(b, Uint8Array)) b = $5393d6b91c293c78$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5393d6b91c293c78$var$Buffer.isBuffer(a) || !$5393d6b91c293c78$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5393d6b91c293c78$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5393d6b91c293c78$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5393d6b91c293c78$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5393d6b91c293c78$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5393d6b91c293c78$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5393d6b91c293c78$var$Buffer.isBuffer(buf)) buf = $5393d6b91c293c78$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5393d6b91c293c78$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5393d6b91c293c78$var$byteLength(string, encoding) {
    if ($5393d6b91c293c78$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5393d6b91c293c78$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5393d6b91c293c78$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5393d6b91c293c78$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5393d6b91c293c78$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5393d6b91c293c78$var$Buffer.byteLength = $5393d6b91c293c78$var$byteLength;
function $5393d6b91c293c78$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5393d6b91c293c78$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5393d6b91c293c78$var$utf8Slice(this, start, end);
        case "ascii":
            return $5393d6b91c293c78$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5393d6b91c293c78$var$latin1Slice(this, start, end);
        case "base64":
            return $5393d6b91c293c78$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5393d6b91c293c78$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5393d6b91c293c78$var$Buffer.prototype._isBuffer = true;
function $5393d6b91c293c78$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5393d6b91c293c78$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5393d6b91c293c78$var$swap(this, i, i + 1);
    return this;
};
$5393d6b91c293c78$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5393d6b91c293c78$var$swap(this, i, i + 3);
        $5393d6b91c293c78$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5393d6b91c293c78$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5393d6b91c293c78$var$swap(this, i, i + 7);
        $5393d6b91c293c78$var$swap(this, i + 1, i + 6);
        $5393d6b91c293c78$var$swap(this, i + 2, i + 5);
        $5393d6b91c293c78$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5393d6b91c293c78$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5393d6b91c293c78$var$utf8Slice(this, 0, length);
    return $5393d6b91c293c78$var$slowToString.apply(this, arguments);
};
$5393d6b91c293c78$var$Buffer.prototype.toLocaleString = $5393d6b91c293c78$var$Buffer.prototype.toString;
$5393d6b91c293c78$var$Buffer.prototype.equals = function equals(b) {
    if (!$5393d6b91c293c78$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5393d6b91c293c78$var$Buffer.compare(this, b) === 0;
};
$5393d6b91c293c78$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5393d6b91c293c78$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5393d6b91c293c78$var$customInspectSymbol) $5393d6b91c293c78$var$Buffer.prototype[$5393d6b91c293c78$var$customInspectSymbol] = $5393d6b91c293c78$var$Buffer.prototype.inspect;
$5393d6b91c293c78$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5393d6b91c293c78$var$isInstance(target, Uint8Array)) target = $5393d6b91c293c78$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5393d6b91c293c78$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5393d6b91c293c78$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5393d6b91c293c78$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5393d6b91c293c78$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5393d6b91c293c78$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5393d6b91c293c78$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5393d6b91c293c78$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5393d6b91c293c78$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5393d6b91c293c78$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5393d6b91c293c78$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5393d6b91c293c78$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5393d6b91c293c78$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5393d6b91c293c78$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5393d6b91c293c78$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5393d6b91c293c78$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5393d6b91c293c78$var$utf8Write(buf, string, offset, length) {
    return $5393d6b91c293c78$var$blitBuffer($5393d6b91c293c78$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5393d6b91c293c78$var$asciiWrite(buf, string, offset, length) {
    return $5393d6b91c293c78$var$blitBuffer($5393d6b91c293c78$var$asciiToBytes(string), buf, offset, length);
}
function $5393d6b91c293c78$var$base64Write(buf, string, offset, length) {
    return $5393d6b91c293c78$var$blitBuffer($5393d6b91c293c78$var$base64ToBytes(string), buf, offset, length);
}
function $5393d6b91c293c78$var$ucs2Write(buf, string, offset, length) {
    return $5393d6b91c293c78$var$blitBuffer($5393d6b91c293c78$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5393d6b91c293c78$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5393d6b91c293c78$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5393d6b91c293c78$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5393d6b91c293c78$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5393d6b91c293c78$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5393d6b91c293c78$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5393d6b91c293c78$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5393d6b91c293c78$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $5393d6b91c293c78$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5393d6b91c293c78$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5393d6b91c293c78$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5393d6b91c293c78$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5393d6b91c293c78$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5393d6b91c293c78$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5393d6b91c293c78$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5393d6b91c293c78$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5393d6b91c293c78$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5393d6b91c293c78$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5393d6b91c293c78$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5393d6b91c293c78$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5393d6b91c293c78$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5393d6b91c293c78$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5393d6b91c293c78$var$Buffer.prototype.readUintLE = $5393d6b91c293c78$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5393d6b91c293c78$var$Buffer.prototype.readUintBE = $5393d6b91c293c78$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5393d6b91c293c78$var$Buffer.prototype.readUint8 = $5393d6b91c293c78$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5393d6b91c293c78$var$Buffer.prototype.readUint16LE = $5393d6b91c293c78$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5393d6b91c293c78$var$Buffer.prototype.readUint16BE = $5393d6b91c293c78$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5393d6b91c293c78$var$Buffer.prototype.readUint32LE = $5393d6b91c293c78$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5393d6b91c293c78$var$Buffer.prototype.readUint32BE = $5393d6b91c293c78$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5393d6b91c293c78$var$Buffer.prototype.readBigUInt64LE = $5393d6b91c293c78$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5393d6b91c293c78$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5393d6b91c293c78$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5393d6b91c293c78$var$Buffer.prototype.readBigUInt64BE = $5393d6b91c293c78$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5393d6b91c293c78$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5393d6b91c293c78$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5393d6b91c293c78$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5393d6b91c293c78$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5393d6b91c293c78$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5393d6b91c293c78$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5393d6b91c293c78$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5393d6b91c293c78$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5393d6b91c293c78$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5393d6b91c293c78$var$Buffer.prototype.readBigInt64LE = $5393d6b91c293c78$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5393d6b91c293c78$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5393d6b91c293c78$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5393d6b91c293c78$var$Buffer.prototype.readBigInt64BE = $5393d6b91c293c78$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5393d6b91c293c78$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5393d6b91c293c78$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5393d6b91c293c78$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$5393d6b91c293c78$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$5393d6b91c293c78$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$5393d6b91c293c78$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $5393d6b91c293c78$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5393d6b91c293c78$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5393d6b91c293c78$var$Buffer.prototype.writeUintLE = $5393d6b91c293c78$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5393d6b91c293c78$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUintBE = $5393d6b91c293c78$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5393d6b91c293c78$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUint8 = $5393d6b91c293c78$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUint16LE = $5393d6b91c293c78$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUint16BE = $5393d6b91c293c78$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUint32LE = $5393d6b91c293c78$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5393d6b91c293c78$var$Buffer.prototype.writeUint32BE = $5393d6b91c293c78$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5393d6b91c293c78$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5393d6b91c293c78$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5393d6b91c293c78$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5393d6b91c293c78$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5393d6b91c293c78$var$Buffer.prototype.writeBigUInt64LE = $5393d6b91c293c78$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5393d6b91c293c78$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5393d6b91c293c78$var$Buffer.prototype.writeBigUInt64BE = $5393d6b91c293c78$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5393d6b91c293c78$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5393d6b91c293c78$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5393d6b91c293c78$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5393d6b91c293c78$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5393d6b91c293c78$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5393d6b91c293c78$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5393d6b91c293c78$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5393d6b91c293c78$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5393d6b91c293c78$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5393d6b91c293c78$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5393d6b91c293c78$var$Buffer.prototype.writeBigInt64LE = $5393d6b91c293c78$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5393d6b91c293c78$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5393d6b91c293c78$var$Buffer.prototype.writeBigInt64BE = $5393d6b91c293c78$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5393d6b91c293c78$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5393d6b91c293c78$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5393d6b91c293c78$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5393d6b91c293c78$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5393d6b91c293c78$var$writeFloat(this, value, offset, true, noAssert);
};
$5393d6b91c293c78$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5393d6b91c293c78$var$writeFloat(this, value, offset, false, noAssert);
};
function $5393d6b91c293c78$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5393d6b91c293c78$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5393d6b91c293c78$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5393d6b91c293c78$var$writeDouble(this, value, offset, true, noAssert);
};
$5393d6b91c293c78$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5393d6b91c293c78$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5393d6b91c293c78$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5393d6b91c293c78$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5393d6b91c293c78$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5393d6b91c293c78$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5393d6b91c293c78$var$Buffer.isBuffer(val) ? val : $5393d6b91c293c78$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5393d6b91c293c78$var$errors = {};
function $5393d6b91c293c78$var$E(sym, getMessage, Base) {
    $5393d6b91c293c78$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5393d6b91c293c78$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5393d6b91c293c78$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5393d6b91c293c78$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5393d6b91c293c78$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5393d6b91c293c78$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5393d6b91c293c78$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5393d6b91c293c78$var$checkBounds(buf, offset, byteLength) {
    $5393d6b91c293c78$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5393d6b91c293c78$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5393d6b91c293c78$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5393d6b91c293c78$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5393d6b91c293c78$var$checkBounds(buf, offset, byteLength);
}
function $5393d6b91c293c78$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5393d6b91c293c78$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5393d6b91c293c78$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5393d6b91c293c78$var$validateNumber(value, type);
        throw new $5393d6b91c293c78$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5393d6b91c293c78$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5393d6b91c293c78$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5393d6b91c293c78$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5393d6b91c293c78$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5393d6b91c293c78$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5393d6b91c293c78$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5393d6b91c293c78$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5393d6b91c293c78$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5393d6b91c293c78$var$base64ToBytes(str) {
    return $5d11t.toByteArray($5393d6b91c293c78$var$base64clean(str));
}
function $5393d6b91c293c78$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5393d6b91c293c78$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5393d6b91c293c78$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5393d6b91c293c78$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5393d6b91c293c78$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5393d6b91c293c78$var$BufferBigIntNotDefined : fn;
}
function $5393d6b91c293c78$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});

parcelRegister("I9mxh", function(module, exports) {

$parcel$export(module.exports, "ed25519", function () { return $084b5f5e6cc8ec0d$export$f63794f4a09a19c1; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $1E6JR = parcelRequire("1E6JR");

var $3yPLd = parcelRequire("3yPLd");

var $kxvvu = parcelRequire("kxvvu");

var $kl9zG = parcelRequire("kl9zG");

var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");

var $bhzWT = parcelRequire("bhzWT");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $084b5f5e6cc8ec0d$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $084b5f5e6cc8ec0d$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $084b5f5e6cc8ec0d$var$_0n = BigInt(0), $084b5f5e6cc8ec0d$var$_1n = BigInt(1), $084b5f5e6cc8ec0d$var$_2n = BigInt(2), $084b5f5e6cc8ec0d$var$_5n = BigInt(5);
// prettier-ignore
const $084b5f5e6cc8ec0d$var$_10n = BigInt(10), $084b5f5e6cc8ec0d$var$_20n = BigInt(20), $084b5f5e6cc8ec0d$var$_40n = BigInt(40), $084b5f5e6cc8ec0d$var$_80n = BigInt(80);
function $084b5f5e6cc8ec0d$var$ed25519_pow_2_252_3(x) {
    const P = $084b5f5e6cc8ec0d$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $fY0nS.pow2)(b2, $084b5f5e6cc8ec0d$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $fY0nS.pow2)(b4, $084b5f5e6cc8ec0d$var$_1n, P) * x % P; // x^31
    const b10 = (0, $fY0nS.pow2)(b5, $084b5f5e6cc8ec0d$var$_5n, P) * b5 % P;
    const b20 = (0, $fY0nS.pow2)(b10, $084b5f5e6cc8ec0d$var$_10n, P) * b10 % P;
    const b40 = (0, $fY0nS.pow2)(b20, $084b5f5e6cc8ec0d$var$_20n, P) * b20 % P;
    const b80 = (0, $fY0nS.pow2)(b40, $084b5f5e6cc8ec0d$var$_40n, P) * b40 % P;
    const b160 = (0, $fY0nS.pow2)(b80, $084b5f5e6cc8ec0d$var$_80n, P) * b80 % P;
    const b240 = (0, $fY0nS.pow2)(b160, $084b5f5e6cc8ec0d$var$_80n, P) * b80 % P;
    const b250 = (0, $fY0nS.pow2)(b240, $084b5f5e6cc8ec0d$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $fY0nS.pow2)(b250, $084b5f5e6cc8ec0d$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $084b5f5e6cc8ec0d$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $084b5f5e6cc8ec0d$var$uvRatio(u, v) {
    const P = $084b5f5e6cc8ec0d$var$ED25519_P;
    const v3 = (0, $fY0nS.mod)(v * v * v, P); // v³
    const v7 = (0, $fY0nS.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $084b5f5e6cc8ec0d$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $fY0nS.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $fY0nS.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $fY0nS.mod)(x * $084b5f5e6cc8ec0d$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $fY0nS.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $fY0nS.mod)(-u * $084b5f5e6cc8ec0d$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $fY0nS.isNegativeLE)(x, P)) x = (0, $fY0nS.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $084b5f5e6cc8ec0d$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $084b5f5e6cc8ec0d$var$Fp = (0, $fY0nS.Field)($084b5f5e6cc8ec0d$var$ED25519_P, undefined, true);
const $084b5f5e6cc8ec0d$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $084b5f5e6cc8ec0d$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: (0, $1E6JR.sha512),
    randomBytes: $3yPLd.randomBytes,
    adjustScalarBytes: $084b5f5e6cc8ec0d$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $084b5f5e6cc8ec0d$var$uvRatio
};
const $084b5f5e6cc8ec0d$export$f63794f4a09a19c1 = /* @__PURE__ */ (0, $kxvvu.twistedEdwards)($084b5f5e6cc8ec0d$var$ed25519Defaults);
function $084b5f5e6cc8ec0d$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $3yPLd.concatBytes)((0, $3yPLd.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $084b5f5e6cc8ec0d$export$1bc11da7986b0196 = /* @__PURE__ */ (0, $kxvvu.twistedEdwards)({
    ...$084b5f5e6cc8ec0d$var$ed25519Defaults,
    domain: $084b5f5e6cc8ec0d$var$ed25519_domain
});
const $084b5f5e6cc8ec0d$export$473acbb6f701cbb6 = /* @__PURE__ */ (0, $kxvvu.twistedEdwards)({
    ...$084b5f5e6cc8ec0d$var$ed25519Defaults,
    domain: $084b5f5e6cc8ec0d$var$ed25519_domain,
    prehash: (0, $1E6JR.sha512)
});
const $084b5f5e6cc8ec0d$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $kl9zG.montgomery)({
        P: $084b5f5e6cc8ec0d$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $084b5f5e6cc8ec0d$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $084b5f5e6cc8ec0d$var$ed25519_pow_2_252_3(x);
            return (0, $fY0nS.mod)((0, $fY0nS.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $084b5f5e6cc8ec0d$var$adjustScalarBytes,
        randomBytes: $3yPLd.randomBytes
    }))();
function $084b5f5e6cc8ec0d$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $084b5f5e6cc8ec0d$var$Fp.toBytes($084b5f5e6cc8ec0d$var$Fp.create((_1n + y) * $084b5f5e6cc8ec0d$var$Fp.inv(_1n - y)));
}
const $084b5f5e6cc8ec0d$export$84bc39a6e4664b07 = $084b5f5e6cc8ec0d$export$78609ae56f1edf04; // deprecated
function $084b5f5e6cc8ec0d$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $084b5f5e6cc8ec0d$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $084b5f5e6cc8ec0d$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $084b5f5e6cc8ec0d$var$ELL2_C1 = ($084b5f5e6cc8ec0d$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $084b5f5e6cc8ec0d$var$ELL2_C2 = $084b5f5e6cc8ec0d$var$Fp.pow($084b5f5e6cc8ec0d$var$_2n, $084b5f5e6cc8ec0d$var$ELL2_C1); // 2. c2 = 2^c1
const $084b5f5e6cc8ec0d$var$ELL2_C3 = $084b5f5e6cc8ec0d$var$Fp.sqrt($084b5f5e6cc8ec0d$var$Fp.neg($084b5f5e6cc8ec0d$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $084b5f5e6cc8ec0d$var$ELL2_C4 = ($084b5f5e6cc8ec0d$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $084b5f5e6cc8ec0d$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $084b5f5e6cc8ec0d$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $084b5f5e6cc8ec0d$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $084b5f5e6cc8ec0d$var$Fp.mul(tv1, $084b5f5e6cc8ec0d$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $084b5f5e6cc8ec0d$var$Fp.add(tv1, $084b5f5e6cc8ec0d$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $084b5f5e6cc8ec0d$var$Fp.neg($084b5f5e6cc8ec0d$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $084b5f5e6cc8ec0d$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $084b5f5e6cc8ec0d$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $084b5f5e6cc8ec0d$var$Fp.mul(tv1, $084b5f5e6cc8ec0d$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $084b5f5e6cc8ec0d$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $084b5f5e6cc8ec0d$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $084b5f5e6cc8ec0d$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $084b5f5e6cc8ec0d$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $084b5f5e6cc8ec0d$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $084b5f5e6cc8ec0d$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $084b5f5e6cc8ec0d$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $084b5f5e6cc8ec0d$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $084b5f5e6cc8ec0d$var$Fp.pow(tv2, $084b5f5e6cc8ec0d$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $084b5f5e6cc8ec0d$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $084b5f5e6cc8ec0d$var$Fp.mul(y11, $084b5f5e6cc8ec0d$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $084b5f5e6cc8ec0d$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $084b5f5e6cc8ec0d$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $084b5f5e6cc8ec0d$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $084b5f5e6cc8ec0d$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $084b5f5e6cc8ec0d$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $084b5f5e6cc8ec0d$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $084b5f5e6cc8ec0d$var$Fp.mul(y21, $084b5f5e6cc8ec0d$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $084b5f5e6cc8ec0d$var$Fp.mul(y21, $084b5f5e6cc8ec0d$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $084b5f5e6cc8ec0d$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $084b5f5e6cc8ec0d$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $084b5f5e6cc8ec0d$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $084b5f5e6cc8ec0d$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $084b5f5e6cc8ec0d$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $084b5f5e6cc8ec0d$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $084b5f5e6cc8ec0d$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $084b5f5e6cc8ec0d$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $084b5f5e6cc8ec0d$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $084b5f5e6cc8ec0d$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $084b5f5e6cc8ec0d$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $084b5f5e6cc8ec0d$var$Fp.cmov(y, $084b5f5e6cc8ec0d$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $084b5f5e6cc8ec0d$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $084b5f5e6cc8ec0d$var$ELL2_C1_EDWARDS = (0, $fY0nS.FpSqrtEven)($084b5f5e6cc8ec0d$var$Fp, $084b5f5e6cc8ec0d$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $084b5f5e6cc8ec0d$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $084b5f5e6cc8ec0d$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $084b5f5e6cc8ec0d$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $084b5f5e6cc8ec0d$var$Fp.mul(xn, $084b5f5e6cc8ec0d$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $084b5f5e6cc8ec0d$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $084b5f5e6cc8ec0d$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $084b5f5e6cc8ec0d$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $084b5f5e6cc8ec0d$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $084b5f5e6cc8ec0d$var$Fp.eql(tv1, $084b5f5e6cc8ec0d$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $084b5f5e6cc8ec0d$var$Fp.cmov(xn, $084b5f5e6cc8ec0d$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $084b5f5e6cc8ec0d$var$Fp.cmov(xd, $084b5f5e6cc8ec0d$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $084b5f5e6cc8ec0d$var$Fp.cmov(yn, $084b5f5e6cc8ec0d$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $084b5f5e6cc8ec0d$var$Fp.cmov(yd, $084b5f5e6cc8ec0d$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $084b5f5e6cc8ec0d$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $084b5f5e6cc8ec0d$var$Fp.mul(xn, inv[0]),
        y: $084b5f5e6cc8ec0d$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $084b5f5e6cc8ec0d$var$htf = /* @__PURE__ */ (()=>(0, $bhzWT.createHasher)($084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$084b5f5e6cc8ec0d$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $084b5f5e6cc8ec0d$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $1E6JR.sha512)
    }))();
const $084b5f5e6cc8ec0d$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$084b5f5e6cc8ec0d$var$htf.hashToCurve)();
const $084b5f5e6cc8ec0d$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$084b5f5e6cc8ec0d$var$htf.encodeToCurve)();
function $084b5f5e6cc8ec0d$var$assertRstPoint(other) {
    if (!(other instanceof $084b5f5e6cc8ec0d$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $084b5f5e6cc8ec0d$var$SQRT_M1 = $084b5f5e6cc8ec0d$var$ED25519_SQRT_M1;
// √(ad - 1)
const $084b5f5e6cc8ec0d$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $084b5f5e6cc8ec0d$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $084b5f5e6cc8ec0d$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $084b5f5e6cc8ec0d$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $084b5f5e6cc8ec0d$var$invertSqrt = (number)=>$084b5f5e6cc8ec0d$var$uvRatio($084b5f5e6cc8ec0d$var$_1n, number);
const $084b5f5e6cc8ec0d$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $084b5f5e6cc8ec0d$var$bytes255ToNumberLE = (bytes)=>$084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.create((0, $7kYSC.bytesToNumberLE)(bytes) & $084b5f5e6cc8ec0d$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $084b5f5e6cc8ec0d$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE;
    const P = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($084b5f5e6cc8ec0d$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $084b5f5e6cc8ec0d$var$_1n) * $084b5f5e6cc8ec0d$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $084b5f5e6cc8ec0d$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $fY0nS.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $084b5f5e6cc8ec0d$var$_1n) * $084b5f5e6cc8ec0d$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $084b5f5e6cc8ec0d$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($084b5f5e6cc8ec0d$var$_1n - s2); // 12
    const W3 = mod($084b5f5e6cc8ec0d$var$_1n + s2); // 13
    return new $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $084b5f5e6cc8ec0d$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $084b5f5e6cc8ec0d$var$RistPoint($084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $7kYSC.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $084b5f5e6cc8ec0d$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $084b5f5e6cc8ec0d$var$calcElligatorRistrettoMap(r1);
        const r2 = $084b5f5e6cc8ec0d$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $084b5f5e6cc8ec0d$var$calcElligatorRistrettoMap(r2);
        return new $084b5f5e6cc8ec0d$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $7kYSC.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE;
        const P = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $084b5f5e6cc8ec0d$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $7kYSC.equalBytes)((0, $7kYSC.numberToBytesLE)(s, 32), hex) || (0, $fY0nS.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($084b5f5e6cc8ec0d$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($084b5f5e6cc8ec0d$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $084b5f5e6cc8ec0d$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $fY0nS.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $fY0nS.isNegativeLE)(t, P) || y === $084b5f5e6cc8ec0d$var$_0n) throw new Error(emsg);
        return new $084b5f5e6cc8ec0d$var$RistPoint(new $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint(x, y, $084b5f5e6cc8ec0d$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $084b5f5e6cc8ec0d$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $fY0nS.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $084b5f5e6cc8ec0d$var$SQRT_M1);
            let _y = mod(x * $084b5f5e6cc8ec0d$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $084b5f5e6cc8ec0d$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $fY0nS.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $fY0nS.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $7kYSC.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $7kYSC.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $084b5f5e6cc8ec0d$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $084b5f5e6cc8ec0d$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $084b5f5e6cc8ec0d$var$assertRstPoint(other);
        return new $084b5f5e6cc8ec0d$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $084b5f5e6cc8ec0d$var$assertRstPoint(other);
        return new $084b5f5e6cc8ec0d$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $084b5f5e6cc8ec0d$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $084b5f5e6cc8ec0d$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
}
const $084b5f5e6cc8ec0d$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$084b5f5e6cc8ec0d$var$RistPoint.BASE) $084b5f5e6cc8ec0d$var$RistPoint.BASE = new $084b5f5e6cc8ec0d$var$RistPoint($084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$084b5f5e6cc8ec0d$var$RistPoint.ZERO) $084b5f5e6cc8ec0d$var$RistPoint.ZERO = new $084b5f5e6cc8ec0d$var$RistPoint($084b5f5e6cc8ec0d$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $084b5f5e6cc8ec0d$var$RistPoint;
})();
const $084b5f5e6cc8ec0d$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $3yPLd.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $bhzWT.expand_message_xmd)(msg, DST, 64, (0, $1E6JR.sha512));
    const P = $084b5f5e6cc8ec0d$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $084b5f5e6cc8ec0d$export$667ef88de7a83a7f = $084b5f5e6cc8ec0d$export$c9ad4c0d917ad3; // legacy

});
parcelRegister("1E6JR", function(module, exports) {

$parcel$export(module.exports, "sha512", function () { return $132ec10504e2e23b$export$a888d2532e6dc7bb; });

var $hX45y = parcelRequire("hX45y");

var $24AYt = parcelRequire("24AYt");

var $3yPLd = parcelRequire("3yPLd");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$132ec10504e2e23b$var$SHA512_Kh, $132ec10504e2e23b$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $24AYt.default).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $132ec10504e2e23b$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $132ec10504e2e23b$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $132ec10504e2e23b$export$d655fdb8a1cad5df extends (0, $hX45y.SHA2) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $132ec10504e2e23b$var$SHA512_W_H[i] = view.getUint32(offset);
            $132ec10504e2e23b$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $132ec10504e2e23b$var$SHA512_W_H[i - 15] | 0;
            const W15l = $132ec10504e2e23b$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $24AYt.default).rotrSH(W15h, W15l, 1) ^ (0, $24AYt.default).rotrSH(W15h, W15l, 8) ^ (0, $24AYt.default).shrSH(W15h, W15l, 7);
            const s0l = (0, $24AYt.default).rotrSL(W15h, W15l, 1) ^ (0, $24AYt.default).rotrSL(W15h, W15l, 8) ^ (0, $24AYt.default).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $132ec10504e2e23b$var$SHA512_W_H[i - 2] | 0;
            const W2l = $132ec10504e2e23b$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $24AYt.default).rotrSH(W2h, W2l, 19) ^ (0, $24AYt.default).rotrBH(W2h, W2l, 61) ^ (0, $24AYt.default).shrSH(W2h, W2l, 6);
            const s1l = (0, $24AYt.default).rotrSL(W2h, W2l, 19) ^ (0, $24AYt.default).rotrBL(W2h, W2l, 61) ^ (0, $24AYt.default).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $24AYt.default).add4L(s0l, s1l, $132ec10504e2e23b$var$SHA512_W_L[i - 7], $132ec10504e2e23b$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $24AYt.default).add4H(SUMl, s0h, s1h, $132ec10504e2e23b$var$SHA512_W_H[i - 7], $132ec10504e2e23b$var$SHA512_W_H[i - 16]);
            $132ec10504e2e23b$var$SHA512_W_H[i] = SUMh | 0;
            $132ec10504e2e23b$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $24AYt.default).rotrSH(Eh, El, 14) ^ (0, $24AYt.default).rotrSH(Eh, El, 18) ^ (0, $24AYt.default).rotrBH(Eh, El, 41);
            const sigma1l = (0, $24AYt.default).rotrSL(Eh, El, 14) ^ (0, $24AYt.default).rotrSL(Eh, El, 18) ^ (0, $24AYt.default).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $24AYt.default).add5L(Hl, sigma1l, CHIl, $132ec10504e2e23b$var$SHA512_Kl[i], $132ec10504e2e23b$var$SHA512_W_L[i]);
            const T1h = (0, $24AYt.default).add5H(T1ll, Hh, sigma1h, CHIh, $132ec10504e2e23b$var$SHA512_Kh[i], $132ec10504e2e23b$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $24AYt.default).rotrSH(Ah, Al, 28) ^ (0, $24AYt.default).rotrBH(Ah, Al, 34) ^ (0, $24AYt.default).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $24AYt.default).rotrSL(Ah, Al, 28) ^ (0, $24AYt.default).rotrBL(Ah, Al, 34) ^ (0, $24AYt.default).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $24AYt.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $24AYt.default).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $24AYt.default).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $24AYt.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $24AYt.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $24AYt.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $24AYt.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $24AYt.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $24AYt.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $24AYt.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $24AYt.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $132ec10504e2e23b$var$SHA512_W_H.fill(0);
        $132ec10504e2e23b$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $132ec10504e2e23b$var$SHA512_224 extends $132ec10504e2e23b$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $132ec10504e2e23b$var$SHA512_256 extends $132ec10504e2e23b$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $132ec10504e2e23b$var$SHA384 extends $132ec10504e2e23b$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $132ec10504e2e23b$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $132ec10504e2e23b$export$d655fdb8a1cad5df());
const $132ec10504e2e23b$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $132ec10504e2e23b$var$SHA512_224());
const $132ec10504e2e23b$export$c78786b6da86db2a = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $132ec10504e2e23b$var$SHA512_256());
const $132ec10504e2e23b$export$612d47d55dedde45 = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $132ec10504e2e23b$var$SHA384());

});
parcelRegister("hX45y", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $d11b1e427af1d9f4$export$ebbe38f24b9a0856; });

var $4JTCm = parcelRequire("4JTCm");

var $3yPLd = parcelRequire("3yPLd");
// Polyfill for Safari 14
function $d11b1e427af1d9f4$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $d11b1e427af1d9f4$export$ebbe38f24b9a0856 extends (0, $3yPLd.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3yPLd.createView)(this.buffer);
    }
    update(data) {
        (0, $4JTCm.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3yPLd.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3yPLd.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $4JTCm.exists)(this);
        (0, $4JTCm.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $d11b1e427af1d9f4$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3yPLd.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("4JTCm", function(module, exports) {

$parcel$export(module.exports, "bytes", function () { return $373681ed054707c0$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $373681ed054707c0$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $373681ed054707c0$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $373681ed054707c0$export$c789db2c85949867; });
function $373681ed054707c0$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $373681ed054707c0$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $373681ed054707c0$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $373681ed054707c0$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $373681ed054707c0$export$98e628dec113755e(hash.outputLen);
    $373681ed054707c0$export$98e628dec113755e(hash.blockLen);
}
function $373681ed054707c0$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $373681ed054707c0$export$c789db2c85949867(out, instance) {
    $373681ed054707c0$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $373681ed054707c0$var$assert = {
    number: $373681ed054707c0$export$98e628dec113755e,
    bool: $373681ed054707c0$export$87b259aa03e3d267,
    bytes: $373681ed054707c0$export$b3317979f9250576,
    hash: $373681ed054707c0$export$d6af199866bfb566,
    exists: $373681ed054707c0$export$f7e9f41ea797a17,
    output: $373681ed054707c0$export$c789db2c85949867
};
var $373681ed054707c0$export$2e2bcd8739ae039 = $373681ed054707c0$var$assert;

});

parcelRegister("3yPLd", function(module, exports) {

$parcel$export(module.exports, "createView", function () { return $297cb2a9495f64de$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $297cb2a9495f64de$export$466993d7d0d272aa; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $297cb2a9495f64de$export$3df70a15530b5e81; });
$parcel$export(module.exports, "toBytes", function () { return $297cb2a9495f64de$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $297cb2a9495f64de$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $297cb2a9495f64de$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $297cb2a9495f64de$export$f081816339df1972; });
$parcel$export(module.exports, "randomBytes", function () { return $297cb2a9495f64de$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $bRQ15 = parcelRequire("bRQ15");
const $297cb2a9495f64de$var$u8a = (a)=>a instanceof Uint8Array;
const $297cb2a9495f64de$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $297cb2a9495f64de$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $297cb2a9495f64de$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $297cb2a9495f64de$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $297cb2a9495f64de$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$297cb2a9495f64de$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $297cb2a9495f64de$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $297cb2a9495f64de$export$58b867e287a802c8(bytes) {
    if (!$297cb2a9495f64de$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $297cb2a9495f64de$var$hexes[bytes[i]];
    return hex;
}
function $297cb2a9495f64de$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $297cb2a9495f64de$export$bdd553fddd433dcb = async ()=>{};
async function $297cb2a9495f64de$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $297cb2a9495f64de$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $297cb2a9495f64de$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $297cb2a9495f64de$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $297cb2a9495f64de$export$3df70a15530b5e81(data);
    if (!$297cb2a9495f64de$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $297cb2a9495f64de$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$297cb2a9495f64de$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $297cb2a9495f64de$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $297cb2a9495f64de$var$toStr = {}.toString;
function $297cb2a9495f64de$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $297cb2a9495f64de$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $297cb2a9495f64de$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($297cb2a9495f64de$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $297cb2a9495f64de$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($297cb2a9495f64de$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $297cb2a9495f64de$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($297cb2a9495f64de$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $297cb2a9495f64de$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $bRQ15.crypto) && typeof (0, $bRQ15.crypto).getRandomValues === "function") return (0, $bRQ15.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("bRQ15", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $8a3cfe592e77d3e3$export$7effb53edfc7fa2d; });
const $8a3cfe592e77d3e3$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("24AYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1828a2da827770c5$export$2e2bcd8739ae039; });
const $1828a2da827770c5$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $1828a2da827770c5$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $1828a2da827770c5$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $1828a2da827770c5$var$U32_MASK64),
        l: Number(n >> $1828a2da827770c5$var$_32n & $1828a2da827770c5$var$U32_MASK64)
    };
    return {
        h: Number(n >> $1828a2da827770c5$var$_32n & $1828a2da827770c5$var$U32_MASK64) | 0,
        l: Number(n & $1828a2da827770c5$var$U32_MASK64) | 0
    };
}
function $1828a2da827770c5$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $1828a2da827770c5$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $1828a2da827770c5$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $1828a2da827770c5$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $1828a2da827770c5$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $1828a2da827770c5$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $1828a2da827770c5$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $1828a2da827770c5$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $1828a2da827770c5$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $1828a2da827770c5$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $1828a2da827770c5$export$a088d44bd387d2a3 = (_h, l)=>l;
const $1828a2da827770c5$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $1828a2da827770c5$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $1828a2da827770c5$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $1828a2da827770c5$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $1828a2da827770c5$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $1828a2da827770c5$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $1828a2da827770c5$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $1828a2da827770c5$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $1828a2da827770c5$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $1828a2da827770c5$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $1828a2da827770c5$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $1828a2da827770c5$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $1828a2da827770c5$var$u64 = {
    fromBig: $1828a2da827770c5$export$9625d4333cb56c3f,
    split: $1828a2da827770c5$export$65980d18b75784e2,
    toBig: $1828a2da827770c5$export$30f78adcaaa2eb7,
    shrSH: $1828a2da827770c5$export$75aa78dc5bd52853,
    shrSL: $1828a2da827770c5$export$a0225ff0aee14e25,
    rotrSH: $1828a2da827770c5$export$97f812dfd830ca87,
    rotrSL: $1828a2da827770c5$export$60987e30e2c9d9d,
    rotrBH: $1828a2da827770c5$export$af9c7fbac44dcb76,
    rotrBL: $1828a2da827770c5$export$f619171d6d5ac414,
    rotr32H: $1828a2da827770c5$export$a088d44bd387d2a3,
    rotr32L: $1828a2da827770c5$export$8415aae4d1f69577,
    rotlSH: $1828a2da827770c5$export$4b80a2917447870e,
    rotlSL: $1828a2da827770c5$export$20652918a7b63b3,
    rotlBH: $1828a2da827770c5$export$a52f14bf902f9977,
    rotlBL: $1828a2da827770c5$export$5d12cc1da441323f,
    add: $1828a2da827770c5$export$e16d8520af44a096,
    add3L: $1828a2da827770c5$export$c0c22b91f08911f,
    add3H: $1828a2da827770c5$export$ef7b26044977a8ec,
    add4L: $1828a2da827770c5$export$2f4e199c560f545d,
    add4H: $1828a2da827770c5$export$e909220d675a7741,
    add5H: $1828a2da827770c5$export$b45ee8d78c965098,
    add5L: $1828a2da827770c5$export$d732b061fe9c9ae4
};
var $1828a2da827770c5$export$2e2bcd8739ae039 = $1828a2da827770c5$var$u64;

});


parcelRegister("kxvvu", function(module, exports) {

$parcel$export(module.exports, "twistedEdwards", function () { return $ef3f54570c4cc0eb$export$f0c1eee63ea541eb; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");

var $h8jIb = parcelRequire("h8jIb");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $ef3f54570c4cc0eb$var$_0n = BigInt(0), $ef3f54570c4cc0eb$var$_1n = BigInt(1), $ef3f54570c4cc0eb$var$_2n = BigInt(2), $ef3f54570c4cc0eb$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $ef3f54570c4cc0eb$var$VERIFY_DEFAULT = {
    zip215: true
};
function $ef3f54570c4cc0eb$var$validateOpts(curve) {
    const opts = (0, $h8jIb.validateBasic)(curve);
    $7kYSC.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $ef3f54570c4cc0eb$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $ef3f54570c4cc0eb$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $ef3f54570c4cc0eb$var$_2n << BigInt(nByteLength * 8) - $ef3f54570c4cc0eb$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $ef3f54570c4cc0eb$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $ef3f54570c4cc0eb$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $ef3f54570c4cc0eb$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $ef3f54570c4cc0eb$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $ef3f54570c4cc0eb$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($ef3f54570c4cc0eb$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $ef3f54570c4cc0eb$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $ef3f54570c4cc0eb$var$_2n * T2);
                const D = modP(T1 * $ef3f54570c4cc0eb$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $ef3f54570c4cc0eb$var$_0n) return I;
            if (this.equals(I) || n === $ef3f54570c4cc0eb$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $ef3f54570c4cc0eb$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $ef3f54570c4cc0eb$var$_0n,
                y: $ef3f54570c4cc0eb$var$_1n
            };
            if (zz !== $ef3f54570c4cc0eb$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $ef3f54570c4cc0eb$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $7kYSC.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $7kYSC.bytesToNumberLE(normed);
            if (y === $ef3f54570c4cc0eb$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $ef3f54570c4cc0eb$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $ef3f54570c4cc0eb$var$_1n) === $ef3f54570c4cc0eb$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $ef3f54570c4cc0eb$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $7kYSC.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $ef3f54570c4cc0eb$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $7kYSC.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $ef3f54570c4cc0eb$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($ef3f54570c4cc0eb$var$_0n, $ef3f54570c4cc0eb$var$_1n, $ef3f54570c4cc0eb$var$_1n, $ef3f54570c4cc0eb$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $h8jIb.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $fY0nS.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($7kYSC.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $7kYSC.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $7kYSC.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $7kYSC.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $7kYSC.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $7kYSC.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $7kYSC.concatBytes(R, $7kYSC.numberToBytesLE(s, Fp.BYTES));
        return (0, $7kYSC.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $ef3f54570c4cc0eb$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $7kYSC.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $7kYSC.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $7kYSC.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}

});
parcelRegister("fY0nS", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $b9fcc1e3680c3d45$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $b9fcc1e3680c3d45$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $b9fcc1e3680c3d45$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $b9fcc1e3680c3d45$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "isNegativeLE", function () { return $b9fcc1e3680c3d45$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $b9fcc1e3680c3d45$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $b9fcc1e3680c3d45$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $b9fcc1e3680c3d45$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $b9fcc1e3680c3d45$export$1d7b691df0888e02; });
$parcel$export(module.exports, "getMinHashLength", function () { return $b9fcc1e3680c3d45$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $b9fcc1e3680c3d45$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $7kYSC = parcelRequire("7kYSC");
// prettier-ignore
const $b9fcc1e3680c3d45$var$_0n = BigInt(0), $b9fcc1e3680c3d45$var$_1n = BigInt(1), $b9fcc1e3680c3d45$var$_2n = BigInt(2), $b9fcc1e3680c3d45$var$_3n = BigInt(3);
// prettier-ignore
const $b9fcc1e3680c3d45$var$_4n = BigInt(4), $b9fcc1e3680c3d45$var$_5n = BigInt(5), $b9fcc1e3680c3d45$var$_8n = BigInt(8);
// prettier-ignore
const $b9fcc1e3680c3d45$var$_9n = BigInt(9), $b9fcc1e3680c3d45$var$_16n = BigInt(16);
function $b9fcc1e3680c3d45$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $b9fcc1e3680c3d45$var$_0n ? result : b + result;
}
function $b9fcc1e3680c3d45$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $b9fcc1e3680c3d45$var$_0n || power < $b9fcc1e3680c3d45$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $b9fcc1e3680c3d45$var$_1n) return $b9fcc1e3680c3d45$var$_0n;
    let res = $b9fcc1e3680c3d45$var$_1n;
    while(power > $b9fcc1e3680c3d45$var$_0n){
        if (power & $b9fcc1e3680c3d45$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $b9fcc1e3680c3d45$var$_1n;
    }
    return res;
}
function $b9fcc1e3680c3d45$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $b9fcc1e3680c3d45$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $b9fcc1e3680c3d45$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $b9fcc1e3680c3d45$var$_0n || modulo <= $b9fcc1e3680c3d45$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $b9fcc1e3680c3d45$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $b9fcc1e3680c3d45$var$_0n, y = $b9fcc1e3680c3d45$var$_1n, u = $b9fcc1e3680c3d45$var$_1n, v = $b9fcc1e3680c3d45$var$_0n;
    while(a !== $b9fcc1e3680c3d45$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $b9fcc1e3680c3d45$var$_1n) throw new Error("invert: does not exist");
    return $b9fcc1e3680c3d45$export$842a2cf37af977e1(x, modulo);
}
function $b9fcc1e3680c3d45$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $b9fcc1e3680c3d45$var$_1n) / $b9fcc1e3680c3d45$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $b9fcc1e3680c3d45$var$_1n, S = 0; Q % $b9fcc1e3680c3d45$var$_2n === $b9fcc1e3680c3d45$var$_0n; Q /= $b9fcc1e3680c3d45$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $b9fcc1e3680c3d45$var$_2n; Z < P && $b9fcc1e3680c3d45$export$9c297f60e22e3389(Z, legendreC, P) !== P - $b9fcc1e3680c3d45$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $b9fcc1e3680c3d45$var$_1n) / $b9fcc1e3680c3d45$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $b9fcc1e3680c3d45$var$_1n) / $b9fcc1e3680c3d45$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $b9fcc1e3680c3d45$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $b9fcc1e3680c3d45$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $b9fcc1e3680c3d45$var$_4n === $b9fcc1e3680c3d45$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $b9fcc1e3680c3d45$var$_1n) / $b9fcc1e3680c3d45$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $b9fcc1e3680c3d45$var$_8n === $b9fcc1e3680c3d45$var$_5n) {
        const c1 = (P - $b9fcc1e3680c3d45$var$_5n) / $b9fcc1e3680c3d45$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $b9fcc1e3680c3d45$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $b9fcc1e3680c3d45$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $b9fcc1e3680c3d45$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $b9fcc1e3680c3d45$export$69f29ab1f3e9a234(P);
}
const $b9fcc1e3680c3d45$export$7806f13ad5078b2f = (num, modulo)=>($b9fcc1e3680c3d45$export$842a2cf37af977e1(num, modulo) & $b9fcc1e3680c3d45$var$_1n) === $b9fcc1e3680c3d45$var$_1n;
// prettier-ignore
const $b9fcc1e3680c3d45$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $b9fcc1e3680c3d45$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $b9fcc1e3680c3d45$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $7kYSC.validateObject)(field, opts);
}
function $b9fcc1e3680c3d45$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $b9fcc1e3680c3d45$var$_0n) throw new Error("Expected power > 0");
    if (power === $b9fcc1e3680c3d45$var$_0n) return f.ONE;
    if (power === $b9fcc1e3680c3d45$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $b9fcc1e3680c3d45$var$_0n){
        if (power & $b9fcc1e3680c3d45$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $b9fcc1e3680c3d45$var$_1n;
    }
    return p;
}
function $b9fcc1e3680c3d45$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $b9fcc1e3680c3d45$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $b9fcc1e3680c3d45$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $b9fcc1e3680c3d45$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $b9fcc1e3680c3d45$var$_1n) / $b9fcc1e3680c3d45$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $b9fcc1e3680c3d45$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $b9fcc1e3680c3d45$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $b9fcc1e3680c3d45$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $b9fcc1e3680c3d45$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $b9fcc1e3680c3d45$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $7kYSC.bitMask)(BITS),
        ZERO: $b9fcc1e3680c3d45$var$_0n,
        ONE: $b9fcc1e3680c3d45$var$_1n,
        create: (num)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $b9fcc1e3680c3d45$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $b9fcc1e3680c3d45$var$_0n,
        isOdd: (num)=>(num & $b9fcc1e3680c3d45$var$_1n) === $b9fcc1e3680c3d45$var$_1n,
        neg: (num)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$b9fcc1e3680c3d45$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$b9fcc1e3680c3d45$export$842a2cf37af977e1(lhs * $b9fcc1e3680c3d45$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$b9fcc1e3680c3d45$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$b9fcc1e3680c3d45$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $7kYSC.numberToBytesLE)(num, BYTES) : (0, $7kYSC.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $7kYSC.bytesToNumberLE)(bytes) : (0, $7kYSC.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $b9fcc1e3680c3d45$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $b9fcc1e3680c3d45$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $b9fcc1e3680c3d45$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $7kYSC.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $b9fcc1e3680c3d45$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $7kYSC.bytesToNumberLE)(hash) : (0, $7kYSC.bytesToNumberBE)(hash);
    return $b9fcc1e3680c3d45$export$842a2cf37af977e1(num, groupOrder - $b9fcc1e3680c3d45$var$_1n) + $b9fcc1e3680c3d45$var$_1n;
}
function $b9fcc1e3680c3d45$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $b9fcc1e3680c3d45$export$d058763b563056af(fieldOrder) {
    const length = $b9fcc1e3680c3d45$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $b9fcc1e3680c3d45$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $b9fcc1e3680c3d45$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $b9fcc1e3680c3d45$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $7kYSC.bytesToNumberBE)(key) : (0, $7kYSC.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $b9fcc1e3680c3d45$export$842a2cf37af977e1(num, fieldOrder - $b9fcc1e3680c3d45$var$_1n) + $b9fcc1e3680c3d45$var$_1n;
    return isLE ? (0, $7kYSC.numberToBytesLE)(reduced, fieldLen) : (0, $7kYSC.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("7kYSC", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $5579a02a40df8123$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $5579a02a40df8123$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $5579a02a40df8123$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $5579a02a40df8123$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $5579a02a40df8123$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $5579a02a40df8123$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $5579a02a40df8123$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $5579a02a40df8123$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $5579a02a40df8123$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $5579a02a40df8123$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $5579a02a40df8123$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $5579a02a40df8123$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $5579a02a40df8123$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $5579a02a40df8123$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $5579a02a40df8123$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $5579a02a40df8123$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $5579a02a40df8123$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $5579a02a40df8123$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $5579a02a40df8123$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $5579a02a40df8123$var$_0n = BigInt(0);
const $5579a02a40df8123$var$_1n = BigInt(1);
const $5579a02a40df8123$var$_2n = BigInt(2);
const $5579a02a40df8123$var$u8a = (a)=>a instanceof Uint8Array;
const $5579a02a40df8123$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $5579a02a40df8123$export$58b867e287a802c8(bytes) {
    if (!$5579a02a40df8123$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $5579a02a40df8123$var$hexes[bytes[i]];
    return hex;
}
function $5579a02a40df8123$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $5579a02a40df8123$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $5579a02a40df8123$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $5579a02a40df8123$export$d609354794974f8(bytes) {
    return $5579a02a40df8123$export$d57f2bacc26b4249($5579a02a40df8123$export$58b867e287a802c8(bytes));
}
function $5579a02a40df8123$export$d67b1d03392107e7(bytes) {
    if (!$5579a02a40df8123$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $5579a02a40df8123$export$d57f2bacc26b4249($5579a02a40df8123$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $5579a02a40df8123$export$1459dafd057611cb(n, len) {
    return $5579a02a40df8123$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $5579a02a40df8123$export$ba2172e58d139f6d(n, len) {
    return $5579a02a40df8123$export$1459dafd057611cb(n, len).reverse();
}
function $5579a02a40df8123$export$80ee8c1914de6dde(n) {
    return $5579a02a40df8123$export$31c96b9df38bc8d4($5579a02a40df8123$export$4ed2545b622827c1(n));
}
function $5579a02a40df8123$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $5579a02a40df8123$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($5579a02a40df8123$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $5579a02a40df8123$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$5579a02a40df8123$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $5579a02a40df8123$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $5579a02a40df8123$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $5579a02a40df8123$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $5579a02a40df8123$var$_0n; n >>= $5579a02a40df8123$var$_1n, len += 1);
    return len;
}
function $5579a02a40df8123$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $5579a02a40df8123$var$_1n;
}
const $5579a02a40df8123$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $5579a02a40df8123$var$_1n : $5579a02a40df8123$var$_0n) << BigInt(pos);
};
const $5579a02a40df8123$export$803efa2fa1c7279 = (n)=>($5579a02a40df8123$var$_2n << BigInt(n - 1)) - $5579a02a40df8123$var$_1n;
// DRBG
const $5579a02a40df8123$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $5579a02a40df8123$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $5579a02a40df8123$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $5579a02a40df8123$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $5579a02a40df8123$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $5579a02a40df8123$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($5579a02a40df8123$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($5579a02a40df8123$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $5579a02a40df8123$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $5579a02a40df8123$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $5579a02a40df8123$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $5579a02a40df8123$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("h8jIb", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $fY0nS.validateField)(curve.Fp);
    (0, $7kYSC.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $fY0nS.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("kl9zG", function(module, exports) {

$parcel$export(module.exports, "montgomery", function () { return $eced321eee2d5c04$export$bdbee0d01bf914a7; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");
const $eced321eee2d5c04$var$_0n = BigInt(0);
const $eced321eee2d5c04$var$_1n = BigInt(1);
function $eced321eee2d5c04$var$validateOpts(curve) {
    (0, $7kYSC.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $eced321eee2d5c04$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $eced321eee2d5c04$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $fY0nS.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $fY0nS.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $eced321eee2d5c04$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $eced321eee2d5c04$var$_1n;
        let z_2 = $eced321eee2d5c04$var$_0n;
        let x_3 = u;
        let z_3 = $eced321eee2d5c04$var$_1n;
        let swap = $eced321eee2d5c04$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $eced321eee2d5c04$var$_0n; t--){
            const k_t = k >> t & $eced321eee2d5c04$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $7kYSC.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        // This is very ugly way, but it works because fieldLen-1 is outside of bounds for X448, so this becomes NOOP
        // fieldLen - scalaryBytes = 1 for X448 and = 0 for X25519
        const u = (0, $7kYSC.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        // u[fieldLen-1] crashes QuickJS (TypeError: out-of-bound numeric index)
        if (fieldLen === montgomeryBytes) u[fieldLen - 1] &= 127; // 0b0111_1111
        return (0, $7kYSC.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $7kYSC.ensureBytes)("scalar", n);
        if (bytes.length !== montgomeryBytes && bytes.length !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${bytes.length}`);
        return (0, $7kYSC.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $eced321eee2d5c04$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}

});

parcelRegister("bhzWT", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", function () { return $836d2af0cfedb437$export$3df78c69af9fc85d; });
$parcel$export(module.exports, "isogenyMap", function () { return $836d2af0cfedb437$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $836d2af0cfedb437$export$14b114effbc08b6b; });

var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");
function $836d2af0cfedb437$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $7kYSC.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $836d2af0cfedb437$var$os2ip = (0, $7kYSC.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $836d2af0cfedb437$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $836d2af0cfedb437$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $836d2af0cfedb437$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $836d2af0cfedb437$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $836d2af0cfedb437$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $836d2af0cfedb437$var$isBytes(msg);
    $836d2af0cfedb437$var$isBytes(DST);
    $836d2af0cfedb437$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $7kYSC.concatBytes)((0, $7kYSC.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $7kYSC.concatBytes)(DST, $836d2af0cfedb437$var$i2osp(DST.length, 1));
    const Z_pad = $836d2af0cfedb437$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $836d2af0cfedb437$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $7kYSC.concatBytes)(Z_pad, msg, l_i_b_str, $836d2af0cfedb437$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $7kYSC.concatBytes)(b_0, $836d2af0cfedb437$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $836d2af0cfedb437$var$strxor(b_0, b[i - 1]),
            $836d2af0cfedb437$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $7kYSC.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $7kYSC.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $836d2af0cfedb437$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $836d2af0cfedb437$var$isBytes(msg);
    $836d2af0cfedb437$var$isBytes(DST);
    $836d2af0cfedb437$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $7kYSC.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($836d2af0cfedb437$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($836d2af0cfedb437$var$i2osp(DST.length, 1)).digest();
}
function $836d2af0cfedb437$export$97cdd5ee18de8172(msg, count, options) {
    (0, $7kYSC.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $836d2af0cfedb437$var$isBytes(msg);
    $836d2af0cfedb437$var$isNum(count);
    const DST = $836d2af0cfedb437$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $836d2af0cfedb437$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $836d2af0cfedb437$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $fY0nS.mod)($836d2af0cfedb437$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $836d2af0cfedb437$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $836d2af0cfedb437$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $836d2af0cfedb437$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $836d2af0cfedb437$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});


parcelRegister("enBgw", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4TRC3", function(module, exports) {

var $bQBSB = parcelRequire("bQBSB");
var $3915e2d5b1bf1a7c$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $bQBSB($3915e2d5b1bf1a7c$var$ALPHABET);

});
parcelRegister("bQBSB", function(module, exports) {
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $8a01ef21a4b360f6$require$_Buffer = $2iVwY.Buffer;
function $8a01ef21a4b360f6$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $8a01ef21a4b360f6$require$_Buffer.from(source);
        if (!$8a01ef21a4b360f6$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $8a01ef21a4b360f6$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $8a01ef21a4b360f6$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $8a01ef21a4b360f6$var$base;

});
parcelRegister("2iVwY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $3aNd6 = parcelRequire("3aNd6");
var $1ad9e3a3bba0ff2c$var$Buffer = $3aNd6.Buffer;
// alternative to using Object.keys for old browsers
function $1ad9e3a3bba0ff2c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1ad9e3a3bba0ff2c$var$Buffer.from && $1ad9e3a3bba0ff2c$var$Buffer.alloc && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafe && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafeSlow) module.exports = $3aNd6;
else {
    // Copy properties from require('buffer')
    $1ad9e3a3bba0ff2c$var$copyProps($3aNd6, module.exports);
    module.exports.Buffer = $1ad9e3a3bba0ff2c$var$SafeBuffer;
}
function $1ad9e3a3bba0ff2c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
}
$1ad9e3a3bba0ff2c$var$SafeBuffer.prototype = Object.create($1ad9e3a3bba0ff2c$var$Buffer.prototype);
// Copy static methods from Buffer
$1ad9e3a3bba0ff2c$var$copyProps($1ad9e3a3bba0ff2c$var$Buffer, $1ad9e3a3bba0ff2c$var$SafeBuffer);
$1ad9e3a3bba0ff2c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1ad9e3a3bba0ff2c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(size);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $3aNd6.SlowBuffer(size);
};

});



parcelRegister("czdZ3", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $926399caa995c6e3$export$bced8d2aada2d1c9; });

var $dwERR = parcelRequire("dwERR");

var $75wGM = parcelRequire("75wGM");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $926399caa995c6e3$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $926399caa995c6e3$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $926399caa995c6e3$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $926399caa995c6e3$var$SHA256 extends (0, $dwERR.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $926399caa995c6e3$var$SHA256_IV[0] | 0;
        this.B = $926399caa995c6e3$var$SHA256_IV[1] | 0;
        this.C = $926399caa995c6e3$var$SHA256_IV[2] | 0;
        this.D = $926399caa995c6e3$var$SHA256_IV[3] | 0;
        this.E = $926399caa995c6e3$var$SHA256_IV[4] | 0;
        this.F = $926399caa995c6e3$var$SHA256_IV[5] | 0;
        this.G = $926399caa995c6e3$var$SHA256_IV[6] | 0;
        this.H = $926399caa995c6e3$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$926399caa995c6e3$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $926399caa995c6e3$var$SHA256_W[i - 15];
            const W2 = $926399caa995c6e3$var$SHA256_W[i - 2];
            const s0 = (0, $75wGM.rotr)(W15, 7) ^ (0, $75wGM.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $75wGM.rotr)(W2, 17) ^ (0, $75wGM.rotr)(W2, 19) ^ W2 >>> 10;
            $926399caa995c6e3$var$SHA256_W[i] = s1 + $926399caa995c6e3$var$SHA256_W[i - 7] + s0 + $926399caa995c6e3$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $75wGM.rotr)(E, 6) ^ (0, $75wGM.rotr)(E, 11) ^ (0, $75wGM.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $dwERR.Chi)(E, F, G) + $926399caa995c6e3$var$SHA256_K[i] + $926399caa995c6e3$var$SHA256_W[i] | 0;
            const sigma0 = (0, $75wGM.rotr)(A, 2) ^ (0, $75wGM.rotr)(A, 13) ^ (0, $75wGM.rotr)(A, 22);
            const T2 = sigma0 + (0, $dwERR.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $926399caa995c6e3$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $926399caa995c6e3$var$SHA224 extends $926399caa995c6e3$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $926399caa995c6e3$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $75wGM.wrapConstructor)(()=>new $926399caa995c6e3$var$SHA256());
const $926399caa995c6e3$export$97b70509d4e397ea = /* @__PURE__ */ (0, $75wGM.wrapConstructor)(()=>new $926399caa995c6e3$var$SHA224());

});
parcelRegister("dwERR", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $9d8df6fc4d013976$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $9d8df6fc4d013976$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $9d8df6fc4d013976$export$f9f830659f932cb2; });

var $hHe7I = parcelRequire("hHe7I");

var $75wGM = parcelRequire("75wGM");
// Polyfill for Safari 14
function $9d8df6fc4d013976$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $9d8df6fc4d013976$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $9d8df6fc4d013976$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $9d8df6fc4d013976$export$f9f830659f932cb2 extends (0, $75wGM.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $75wGM.createView)(this.buffer);
    }
    update(data) {
        (0, $hHe7I.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $75wGM.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $75wGM.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $hHe7I.exists)(this);
        (0, $hHe7I.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $9d8df6fc4d013976$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $75wGM.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("hHe7I", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $ce216874fe9b818f$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $ce216874fe9b818f$export$b3317979f9250576; });
$parcel$export(module.exports, "exists", function () { return $ce216874fe9b818f$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $ce216874fe9b818f$export$c789db2c85949867; });
function $ce216874fe9b818f$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $ce216874fe9b818f$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $ce216874fe9b818f$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $ce216874fe9b818f$export$b3317979f9250576(b, ...lengths) {
    if (!$ce216874fe9b818f$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $ce216874fe9b818f$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $ce216874fe9b818f$export$98e628dec113755e(h.outputLen);
    $ce216874fe9b818f$export$98e628dec113755e(h.blockLen);
}
function $ce216874fe9b818f$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $ce216874fe9b818f$export$c789db2c85949867(out, instance) {
    $ce216874fe9b818f$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $ce216874fe9b818f$var$assert = {
    number: $ce216874fe9b818f$export$98e628dec113755e,
    bool: $ce216874fe9b818f$export$87b259aa03e3d267,
    bytes: $ce216874fe9b818f$export$b3317979f9250576,
    hash: $ce216874fe9b818f$export$d6af199866bfb566,
    exists: $ce216874fe9b818f$export$f7e9f41ea797a17,
    output: $ce216874fe9b818f$export$c789db2c85949867
};
var $ce216874fe9b818f$export$2e2bcd8739ae039 = $ce216874fe9b818f$var$assert;

});

parcelRegister("75wGM", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $52925b6784d75c30$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $52925b6784d75c30$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $52925b6784d75c30$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $52925b6784d75c30$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $52925b6784d75c30$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $52925b6784d75c30$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "Hash", function () { return $52925b6784d75c30$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $52925b6784d75c30$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $52925b6784d75c30$export$e18964dbd6e083c1; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $6qC10 = parcelRequire("6qC10");

var $hHe7I = parcelRequire("hHe7I");
function $52925b6784d75c30$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $52925b6784d75c30$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $52925b6784d75c30$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $52925b6784d75c30$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $52925b6784d75c30$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $52925b6784d75c30$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $52925b6784d75c30$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $52925b6784d75c30$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $52925b6784d75c30$export$4a0a88cc2d284e7f = $52925b6784d75c30$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$52925b6784d75c30$export$a4170f7f8be47425(n);
function $52925b6784d75c30$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $52925b6784d75c30$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $52925b6784d75c30$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $52925b6784d75c30$export$58b867e287a802c8(bytes) {
    (0, $hHe7I.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $52925b6784d75c30$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $52925b6784d75c30$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $52925b6784d75c30$var$asciiToBase16(char) {
    if (char >= $52925b6784d75c30$var$asciis._0 && char <= $52925b6784d75c30$var$asciis._9) return char - $52925b6784d75c30$var$asciis._0;
    if (char >= $52925b6784d75c30$var$asciis._A && char <= $52925b6784d75c30$var$asciis._F) return char - ($52925b6784d75c30$var$asciis._A - 10);
    if (char >= $52925b6784d75c30$var$asciis._a && char <= $52925b6784d75c30$var$asciis._f) return char - ($52925b6784d75c30$var$asciis._a - 10);
    return;
}
function $52925b6784d75c30$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $52925b6784d75c30$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $52925b6784d75c30$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $52925b6784d75c30$export$bdd553fddd433dcb = async ()=>{};
async function $52925b6784d75c30$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $52925b6784d75c30$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $52925b6784d75c30$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $52925b6784d75c30$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $52925b6784d75c30$export$3df70a15530b5e81(data);
    (0, $hHe7I.bytes)(data);
    return data;
}
function $52925b6784d75c30$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $hHe7I.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $52925b6784d75c30$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $52925b6784d75c30$var$toStr = {}.toString;
function $52925b6784d75c30$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $52925b6784d75c30$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $52925b6784d75c30$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($52925b6784d75c30$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $52925b6784d75c30$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($52925b6784d75c30$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $52925b6784d75c30$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($52925b6784d75c30$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $52925b6784d75c30$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $6qC10.crypto) && typeof (0, $6qC10.crypto).getRandomValues === "function") return (0, $6qC10.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("6qC10", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $4ae2a8d755fc7488$export$7effb53edfc7fa2d; });
const $4ae2a8d755fc7488$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("f5x94", function(module, exports) {

var $3aNd6 = parcelRequire("3aNd6");
var $afc1089b46168589$require$Buffer = $3aNd6.Buffer;
"use strict";
var $afc1089b46168589$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $afc1089b46168589$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $afc1089b46168589$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $afc1089b46168589$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $afc1089b46168589$var$__createBinding(result, mod, k);
    }
    $afc1089b46168589$var$__setModuleDefault(result, mod);
    return result;
};
var $afc1089b46168589$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $afc1089b46168589$var$bn_js_1 = $afc1089b46168589$var$__importDefault((parcelRequire("1xP4V")));

const $afc1089b46168589$var$bs58_1 = $afc1089b46168589$var$__importDefault((parcelRequire("l0tOW")));

// TODO: Make sure this polyfill not included when not required
const $afc1089b46168589$var$encoding = $afc1089b46168589$var$__importStar((parcelRequire("lmta0")));
const $afc1089b46168589$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $afc1089b46168589$var$encoding.TextDecoder : TextDecoder;
const $afc1089b46168589$var$textDecoder = new $afc1089b46168589$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $afc1089b46168589$var$baseEncode(value) {
    if (typeof value === "string") value = $afc1089b46168589$require$Buffer.from(value, "utf8");
    return $afc1089b46168589$var$bs58_1.default.encode($afc1089b46168589$require$Buffer.from(value));
}
module.exports.baseEncode = $afc1089b46168589$var$baseEncode;
function $afc1089b46168589$var$baseDecode(value) {
    return $afc1089b46168589$require$Buffer.from($afc1089b46168589$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $afc1089b46168589$var$baseDecode;
const $afc1089b46168589$var$INITIAL_LENGTH = 1024;
class $afc1089b46168589$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $afc1089b46168589$var$BorshError;
/// Binary encoder.
class $afc1089b46168589$var$BinaryWriter {
    constructor(){
        this.buf = $afc1089b46168589$require$Buffer.alloc($afc1089b46168589$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $afc1089b46168589$require$Buffer.concat([
            this.buf,
            $afc1089b46168589$require$Buffer.alloc($afc1089b46168589$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($afc1089b46168589$require$Buffer.from(new $afc1089b46168589$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($afc1089b46168589$require$Buffer.from(new $afc1089b46168589$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($afc1089b46168589$require$Buffer.from(new $afc1089b46168589$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($afc1089b46168589$require$Buffer.from(new $afc1089b46168589$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $afc1089b46168589$require$Buffer.concat([
            $afc1089b46168589$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $afc1089b46168589$require$Buffer.alloc($afc1089b46168589$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $afc1089b46168589$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($afc1089b46168589$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $afc1089b46168589$var$BinaryWriter;
function $afc1089b46168589$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $afc1089b46168589$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $afc1089b46168589$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $afc1089b46168589$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $afc1089b46168589$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $afc1089b46168589$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $afc1089b46168589$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $afc1089b46168589$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $afc1089b46168589$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $afc1089b46168589$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU8", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU16", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU32", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU64", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU128", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU256", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readU512", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readString", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readFixedArray", null);
$afc1089b46168589$var$__decorate([
    $afc1089b46168589$var$handlingRangeError
], $afc1089b46168589$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $afc1089b46168589$var$BinaryReader;
function $afc1089b46168589$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $afc1089b46168589$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$afc1089b46168589$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $afc1089b46168589$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $afc1089b46168589$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$afc1089b46168589$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $afc1089b46168589$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $afc1089b46168589$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $afc1089b46168589$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $afc1089b46168589$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $afc1089b46168589$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $afc1089b46168589$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $afc1089b46168589$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $afc1089b46168589$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $afc1089b46168589$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $afc1089b46168589$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $afc1089b46168589$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $afc1089b46168589$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $afc1089b46168589$var$serialize(schema, obj, Writer = $afc1089b46168589$var$BinaryWriter) {
    const writer = new Writer();
    $afc1089b46168589$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $afc1089b46168589$var$serialize;
function $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$afc1089b46168589$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($afc1089b46168589$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$afc1089b46168589$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $afc1089b46168589$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $afc1089b46168589$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $afc1089b46168589$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $afc1089b46168589$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $afc1089b46168589$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $afc1089b46168589$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $afc1089b46168589$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $afc1089b46168589$var$deserialize(schema, classType, buffer, Reader = $afc1089b46168589$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $afc1089b46168589$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $afc1089b46168589$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $afc1089b46168589$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $afc1089b46168589$var$deserializeUnchecked(schema, classType, buffer, Reader = $afc1089b46168589$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $afc1089b46168589$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $afc1089b46168589$var$deserializeUnchecked;

});
parcelRegister("1xP4V", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1wVs5")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("l0tOW", function(module, exports) {

var $bQBSB = parcelRequire("bQBSB");
var $f4b0bacb41712c3f$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $bQBSB($f4b0bacb41712c3f$var$ALPHABET);

});

parcelRegister("lmta0", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $f8d245b453279ae6$export$88fb0cfd153261a7; }, function (v) { return $f8d245b453279ae6$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $f8d245b453279ae6$export$9c6b53e35bc51b5c; }, function (v) { return $f8d245b453279ae6$export$9c6b53e35bc51b5c = v; });
var $f8d245b453279ae6$export$88fb0cfd153261a7;
var $f8d245b453279ae6$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $f8d245b453279ae6$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $f8d245b453279ae6$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $f8d245b453279ae6$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $f8d245b453279ae6$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $f8d245b453279ae6$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $f8d245b453279ae6$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$f8d245b453279ae6$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $f8d245b453279ae6$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $f8d245b453279ae6$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $f8d245b453279ae6$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $f8d245b453279ae6$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f8d245b453279ae6$var$TextDecoder(encoding, options) {
    if (!(this instanceof $f8d245b453279ae6$var$TextDecoder)) return new $f8d245b453279ae6$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f8d245b453279ae6$var$DEFAULT_ENCODING;
    if (encoding !== $f8d245b453279ae6$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f8d245b453279ae6$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$f8d245b453279ae6$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $f8d245b453279ae6$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $f8d245b453279ae6$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $f8d245b453279ae6$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $f8d245b453279ae6$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $f8d245b453279ae6$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $f8d245b453279ae6$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f8d245b453279ae6$var$TextEncoder(encoding, options) {
    if (!(this instanceof $f8d245b453279ae6$var$TextEncoder)) return new $f8d245b453279ae6$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f8d245b453279ae6$var$DEFAULT_ENCODING;
    if (encoding !== $f8d245b453279ae6$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f8d245b453279ae6$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$f8d245b453279ae6$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $f8d245b453279ae6$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $f8d245b453279ae6$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $f8d245b453279ae6$var$Stream($f8d245b453279ae6$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $f8d245b453279ae6$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $f8d245b453279ae6$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $f8d245b453279ae6$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $f8d245b453279ae6$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $f8d245b453279ae6$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $f8d245b453279ae6$var$end_of_stream) return $f8d245b453279ae6$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($f8d245b453279ae6$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($f8d245b453279ae6$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($f8d245b453279ae6$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($f8d245b453279ae6$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $f8d245b453279ae6$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$f8d245b453279ae6$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $f8d245b453279ae6$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $f8d245b453279ae6$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $f8d245b453279ae6$var$end_of_stream) return $f8d245b453279ae6$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($f8d245b453279ae6$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($f8d245b453279ae6$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($f8d245b453279ae6$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($f8d245b453279ae6$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$f8d245b453279ae6$export$88fb0cfd153261a7 = $f8d245b453279ae6$var$TextEncoder;
$f8d245b453279ae6$export$9c6b53e35bc51b5c = $f8d245b453279ae6$var$TextDecoder;

});


parcelRegister("hGf21", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $ejJh3 = parcelRequire("ejJh3");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $cdf204e1a5baf5c4$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
module.exports.checkUint8Array = $cdf204e1a5baf5c4$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b) {
    $cdf204e1a5baf5c4$var$checkUint8Array(b);
    return $ejJh3.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $cdf204e1a5baf5c4$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $cdf204e1a5baf5c4$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $cdf204e1a5baf5c4$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
module.exports.nameWithProperty = $cdf204e1a5baf5c4$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $cdf204e1a5baf5c4$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $cdf204e1a5baf5c4$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $cdf204e1a5baf5c4$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$ExternalLayout extends $cdf204e1a5baf5c4$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
module.exports.ExternalLayout = $cdf204e1a5baf5c4$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $cdf204e1a5baf5c4$var$GreedyCount extends $cdf204e1a5baf5c4$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $cdf204e1a5baf5c4$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $cdf204e1a5baf5c4$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$OffsetLayout extends $cdf204e1a5baf5c4$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $cdf204e1a5baf5c4$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $cdf204e1a5baf5c4$var$UInt || this.layout instanceof $cdf204e1a5baf5c4$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $cdf204e1a5baf5c4$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$UInt extends $cdf204e1a5baf5c4$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $cdf204e1a5baf5c4$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$UIntBE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $cdf204e1a5baf5c4$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Int extends $cdf204e1a5baf5c4$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $cdf204e1a5baf5c4$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$IntBE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $cdf204e1a5baf5c4$var$IntBE;
const $cdf204e1a5baf5c4$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $cdf204e1a5baf5c4$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $cdf204e1a5baf5c4$var$V2E32);
    const lo32 = src - hi32 * $cdf204e1a5baf5c4$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $cdf204e1a5baf5c4$var$roundedInt64(hi32, lo32) {
    return hi32 * $cdf204e1a5baf5c4$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$NearUInt64 extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $cdf204e1a5baf5c4$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $cdf204e1a5baf5c4$var$divmodInt64(src);
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $cdf204e1a5baf5c4$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$NearUInt64BE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $cdf204e1a5baf5c4$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $cdf204e1a5baf5c4$var$divmodInt64(src);
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $cdf204e1a5baf5c4$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$NearInt64 extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $cdf204e1a5baf5c4$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $cdf204e1a5baf5c4$var$divmodInt64(src);
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $cdf204e1a5baf5c4$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$NearInt64BE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $cdf204e1a5baf5c4$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $cdf204e1a5baf5c4$var$divmodInt64(src);
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $cdf204e1a5baf5c4$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Float extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $cdf204e1a5baf5c4$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$FloatBE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $cdf204e1a5baf5c4$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Double extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $cdf204e1a5baf5c4$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$DoubleBE extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $cdf204e1a5baf5c4$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Sequence extends $cdf204e1a5baf5c4$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $cdf204e1a5baf5c4$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $cdf204e1a5baf5c4$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $cdf204e1a5baf5c4$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $cdf204e1a5baf5c4$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $cdf204e1a5baf5c4$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $cdf204e1a5baf5c4$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $cdf204e1a5baf5c4$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Structure extends $cdf204e1a5baf5c4$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $cdf204e1a5baf5c4$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $cdf204e1a5baf5c4$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $cdf204e1a5baf5c4$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $cdf204e1a5baf5c4$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
module.exports.UnionDiscriminator = $cdf204e1a5baf5c4$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $cdf204e1a5baf5c4$var$UnionLayoutDiscriminator extends $cdf204e1a5baf5c4$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $cdf204e1a5baf5c4$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $cdf204e1a5baf5c4$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Union extends $cdf204e1a5baf5c4$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $cdf204e1a5baf5c4$var$UInt || discr instanceof $cdf204e1a5baf5c4$var$UIntBE) discriminator = new $cdf204e1a5baf5c4$var$UnionLayoutDiscriminator(new $cdf204e1a5baf5c4$var$OffsetLayout(discr));
        else if (discr instanceof $cdf204e1a5baf5c4$var$ExternalLayout && discr.isCount()) discriminator = new $cdf204e1a5baf5c4$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $cdf204e1a5baf5c4$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $cdf204e1a5baf5c4$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $cdf204e1a5baf5c4$var$UInt || discr instanceof $cdf204e1a5baf5c4$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $cdf204e1a5baf5c4$var$UInt || discr instanceof $cdf204e1a5baf5c4$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $cdf204e1a5baf5c4$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $cdf204e1a5baf5c4$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$VariantLayout extends $cdf204e1a5baf5c4$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $cdf204e1a5baf5c4$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $cdf204e1a5baf5c4$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $cdf204e1a5baf5c4$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $cdf204e1a5baf5c4$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$BitStructure extends $cdf204e1a5baf5c4$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $cdf204e1a5baf5c4$var$UInt || word instanceof $cdf204e1a5baf5c4$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $cdf204e1a5baf5c4$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $cdf204e1a5baf5c4$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $cdf204e1a5baf5c4$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $cdf204e1a5baf5c4$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $cdf204e1a5baf5c4$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $cdf204e1a5baf5c4$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $cdf204e1a5baf5c4$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $cdf204e1a5baf5c4$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $cdf204e1a5baf5c4$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($cdf204e1a5baf5c4$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $cdf204e1a5baf5c4$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($cdf204e1a5baf5c4$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $cdf204e1a5baf5c4$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $cdf204e1a5baf5c4$var$Boolean extends $cdf204e1a5baf5c4$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $cdf204e1a5baf5c4$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Blob extends $cdf204e1a5baf5c4$var$Layout {
    constructor(length, property){
        if (!(length instanceof $cdf204e1a5baf5c4$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $cdf204e1a5baf5c4$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $cdf204e1a5baf5c4$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($cdf204e1a5baf5c4$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(src);
        $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $cdf204e1a5baf5c4$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $cdf204e1a5baf5c4$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$CString extends $cdf204e1a5baf5c4$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $cdf204e1a5baf5c4$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $ejJh3.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $cdf204e1a5baf5c4$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$UTF8 extends $cdf204e1a5baf5c4$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $cdf204e1a5baf5c4$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $ejJh3.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($cdf204e1a5baf5c4$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $cdf204e1a5baf5c4$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $cdf204e1a5baf5c4$var$Constant extends $cdf204e1a5baf5c4$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $cdf204e1a5baf5c4$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $cdf204e1a5baf5c4$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $cdf204e1a5baf5c4$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $cdf204e1a5baf5c4$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $cdf204e1a5baf5c4$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $cdf204e1a5baf5c4$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $cdf204e1a5baf5c4$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $cdf204e1a5baf5c4$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $cdf204e1a5baf5c4$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $cdf204e1a5baf5c4$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $cdf204e1a5baf5c4$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $cdf204e1a5baf5c4$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $cdf204e1a5baf5c4$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $cdf204e1a5baf5c4$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $cdf204e1a5baf5c4$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $cdf204e1a5baf5c4$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $cdf204e1a5baf5c4$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $cdf204e1a5baf5c4$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $cdf204e1a5baf5c4$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $cdf204e1a5baf5c4$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $cdf204e1a5baf5c4$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $cdf204e1a5baf5c4$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $cdf204e1a5baf5c4$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $cdf204e1a5baf5c4$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $cdf204e1a5baf5c4$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $cdf204e1a5baf5c4$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $cdf204e1a5baf5c4$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $cdf204e1a5baf5c4$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $cdf204e1a5baf5c4$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $cdf204e1a5baf5c4$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $cdf204e1a5baf5c4$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $cdf204e1a5baf5c4$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $cdf204e1a5baf5c4$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $cdf204e1a5baf5c4$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $cdf204e1a5baf5c4$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $cdf204e1a5baf5c4$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $cdf204e1a5baf5c4$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $cdf204e1a5baf5c4$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $cdf204e1a5baf5c4$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $cdf204e1a5baf5c4$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $cdf204e1a5baf5c4$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $cdf204e1a5baf5c4$var$Constant(value, property);

});
parcelRegister("ejJh3", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a6c5f585ab2aa95c$export$a143d493d941bafc; }, function (v) { return $a6c5f585ab2aa95c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a6c5f585ab2aa95c$export$f99ded8fe4b79145; }, function (v) { return $a6c5f585ab2aa95c$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a6c5f585ab2aa95c$export$a143d493d941bafc;
var $a6c5f585ab2aa95c$export$e4cf37d7f6fb9e0a;
var $a6c5f585ab2aa95c$export$f99ded8fe4b79145;
var $a6c5f585ab2aa95c$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $a6c5f585ab2aa95c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$a6c5f585ab2aa95c$export$a143d493d941bafc = $a6c5f585ab2aa95c$var$Buffer;
$a6c5f585ab2aa95c$export$e4cf37d7f6fb9e0a = $a6c5f585ab2aa95c$var$SlowBuffer;
$a6c5f585ab2aa95c$export$f99ded8fe4b79145 = 50;
const $a6c5f585ab2aa95c$var$K_MAX_LENGTH = 0x7fffffff;
$a6c5f585ab2aa95c$export$599f31c3813fae4d = $a6c5f585ab2aa95c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a6c5f585ab2aa95c$var$Buffer.TYPED_ARRAY_SUPPORT = $a6c5f585ab2aa95c$var$typedArraySupport();
if (!$a6c5f585ab2aa95c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a6c5f585ab2aa95c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a6c5f585ab2aa95c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a6c5f585ab2aa95c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a6c5f585ab2aa95c$var$createBuffer(length) {
    if (length > $a6c5f585ab2aa95c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a6c5f585ab2aa95c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a6c5f585ab2aa95c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a6c5f585ab2aa95c$var$allocUnsafe(arg);
    }
    return $a6c5f585ab2aa95c$var$from(arg, encodingOrOffset, length);
}
$a6c5f585ab2aa95c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a6c5f585ab2aa95c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $a6c5f585ab2aa95c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a6c5f585ab2aa95c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a6c5f585ab2aa95c$var$isInstance(value, ArrayBuffer) || value && $a6c5f585ab2aa95c$var$isInstance(value.buffer, ArrayBuffer)) return $a6c5f585ab2aa95c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($a6c5f585ab2aa95c$var$isInstance(value, SharedArrayBuffer) || value && $a6c5f585ab2aa95c$var$isInstance(value.buffer, SharedArrayBuffer))) return $a6c5f585ab2aa95c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a6c5f585ab2aa95c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a6c5f585ab2aa95c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $a6c5f585ab2aa95c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a6c5f585ab2aa95c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a6c5f585ab2aa95c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a6c5f585ab2aa95c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a6c5f585ab2aa95c$var$Buffer, Uint8Array);
function $a6c5f585ab2aa95c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a6c5f585ab2aa95c$var$alloc(size, fill, encoding) {
    $a6c5f585ab2aa95c$var$assertSize(size);
    if (size <= 0) return $a6c5f585ab2aa95c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $a6c5f585ab2aa95c$var$createBuffer(size).fill(fill, encoding) : $a6c5f585ab2aa95c$var$createBuffer(size).fill(fill);
    return $a6c5f585ab2aa95c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a6c5f585ab2aa95c$var$Buffer.alloc = function(size, fill, encoding) {
    return $a6c5f585ab2aa95c$var$alloc(size, fill, encoding);
};
function $a6c5f585ab2aa95c$var$allocUnsafe(size) {
    $a6c5f585ab2aa95c$var$assertSize(size);
    return $a6c5f585ab2aa95c$var$createBuffer(size < 0 ? 0 : $a6c5f585ab2aa95c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a6c5f585ab2aa95c$var$Buffer.allocUnsafe = function(size) {
    return $a6c5f585ab2aa95c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a6c5f585ab2aa95c$var$Buffer.allocUnsafeSlow = function(size) {
    return $a6c5f585ab2aa95c$var$allocUnsafe(size);
};
function $a6c5f585ab2aa95c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$a6c5f585ab2aa95c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $a6c5f585ab2aa95c$var$byteLength(string, encoding) | 0;
    let buf = $a6c5f585ab2aa95c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a6c5f585ab2aa95c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a6c5f585ab2aa95c$var$checked(array.length) | 0;
    const buf = $a6c5f585ab2aa95c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a6c5f585ab2aa95c$var$fromArrayView(arrayView) {
    if ($a6c5f585ab2aa95c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a6c5f585ab2aa95c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a6c5f585ab2aa95c$var$fromArrayLike(arrayView);
}
function $a6c5f585ab2aa95c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a6c5f585ab2aa95c$var$Buffer.prototype);
    return buf;
}
function $a6c5f585ab2aa95c$var$fromObject(obj) {
    if ($a6c5f585ab2aa95c$var$Buffer.isBuffer(obj)) {
        const len = $a6c5f585ab2aa95c$var$checked(obj.length) | 0;
        const buf = $a6c5f585ab2aa95c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $a6c5f585ab2aa95c$var$numberIsNaN(obj.length)) return $a6c5f585ab2aa95c$var$createBuffer(0);
        return $a6c5f585ab2aa95c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $a6c5f585ab2aa95c$var$fromArrayLike(obj.data);
}
function $a6c5f585ab2aa95c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a6c5f585ab2aa95c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a6c5f585ab2aa95c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $a6c5f585ab2aa95c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a6c5f585ab2aa95c$var$Buffer.alloc(+length);
}
$a6c5f585ab2aa95c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a6c5f585ab2aa95c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a6c5f585ab2aa95c$var$Buffer.compare = function compare(a, b) {
    if ($a6c5f585ab2aa95c$var$isInstance(a, Uint8Array)) a = $a6c5f585ab2aa95c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a6c5f585ab2aa95c$var$isInstance(b, Uint8Array)) b = $a6c5f585ab2aa95c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(a) || !$a6c5f585ab2aa95c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a6c5f585ab2aa95c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$a6c5f585ab2aa95c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a6c5f585ab2aa95c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a6c5f585ab2aa95c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a6c5f585ab2aa95c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(buf)) buf = $a6c5f585ab2aa95c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a6c5f585ab2aa95c$var$byteLength(string, encoding) {
    if ($a6c5f585ab2aa95c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a6c5f585ab2aa95c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $a6c5f585ab2aa95c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $a6c5f585ab2aa95c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a6c5f585ab2aa95c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a6c5f585ab2aa95c$var$Buffer.byteLength = $a6c5f585ab2aa95c$var$byteLength;
function $a6c5f585ab2aa95c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $a6c5f585ab2aa95c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $a6c5f585ab2aa95c$var$utf8Slice(this, start, end);
        case "ascii":
            return $a6c5f585ab2aa95c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $a6c5f585ab2aa95c$var$latin1Slice(this, start, end);
        case "base64":
            return $a6c5f585ab2aa95c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a6c5f585ab2aa95c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a6c5f585ab2aa95c$var$Buffer.prototype._isBuffer = true;
function $a6c5f585ab2aa95c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$a6c5f585ab2aa95c$var$swap(this, i, i + 1);
    return this;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $a6c5f585ab2aa95c$var$swap(this, i, i + 3);
        $a6c5f585ab2aa95c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $a6c5f585ab2aa95c$var$swap(this, i, i + 7);
        $a6c5f585ab2aa95c$var$swap(this, i + 1, i + 6);
        $a6c5f585ab2aa95c$var$swap(this, i + 2, i + 5);
        $a6c5f585ab2aa95c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $a6c5f585ab2aa95c$var$utf8Slice(this, 0, length);
    return $a6c5f585ab2aa95c$var$slowToString.apply(this, arguments);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.toLocaleString = $a6c5f585ab2aa95c$var$Buffer.prototype.toString;
$a6c5f585ab2aa95c$var$Buffer.prototype.equals = function equals(b) {
    if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $a6c5f585ab2aa95c$var$Buffer.compare(this, b) === 0;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $a6c5f585ab2aa95c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($a6c5f585ab2aa95c$var$customInspectSymbol) $a6c5f585ab2aa95c$var$Buffer.prototype[$a6c5f585ab2aa95c$var$customInspectSymbol] = $a6c5f585ab2aa95c$var$Buffer.prototype.inspect;
$a6c5f585ab2aa95c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a6c5f585ab2aa95c$var$isInstance(target, Uint8Array)) target = $a6c5f585ab2aa95c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a6c5f585ab2aa95c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a6c5f585ab2aa95c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $a6c5f585ab2aa95c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a6c5f585ab2aa95c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a6c5f585ab2aa95c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a6c5f585ab2aa95c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $a6c5f585ab2aa95c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a6c5f585ab2aa95c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a6c5f585ab2aa95c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a6c5f585ab2aa95c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a6c5f585ab2aa95c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a6c5f585ab2aa95c$var$utf8Write(buf, string, offset, length) {
    return $a6c5f585ab2aa95c$var$blitBuffer($a6c5f585ab2aa95c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a6c5f585ab2aa95c$var$asciiWrite(buf, string, offset, length) {
    return $a6c5f585ab2aa95c$var$blitBuffer($a6c5f585ab2aa95c$var$asciiToBytes(string), buf, offset, length);
}
function $a6c5f585ab2aa95c$var$base64Write(buf, string, offset, length) {
    return $a6c5f585ab2aa95c$var$blitBuffer($a6c5f585ab2aa95c$var$base64ToBytes(string), buf, offset, length);
}
function $a6c5f585ab2aa95c$var$ucs2Write(buf, string, offset, length) {
    return $a6c5f585ab2aa95c$var$blitBuffer($a6c5f585ab2aa95c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a6c5f585ab2aa95c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $a6c5f585ab2aa95c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $a6c5f585ab2aa95c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $a6c5f585ab2aa95c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $a6c5f585ab2aa95c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a6c5f585ab2aa95c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a6c5f585ab2aa95c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a6c5f585ab2aa95c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $a6c5f585ab2aa95c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a6c5f585ab2aa95c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a6c5f585ab2aa95c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a6c5f585ab2aa95c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a6c5f585ab2aa95c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a6c5f585ab2aa95c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a6c5f585ab2aa95c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a6c5f585ab2aa95c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a6c5f585ab2aa95c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $a6c5f585ab2aa95c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a6c5f585ab2aa95c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a6c5f585ab2aa95c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a6c5f585ab2aa95c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$a6c5f585ab2aa95c$var$Buffer.prototype.readUintLE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUintBE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUint8 = $a6c5f585ab2aa95c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUint16LE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUint16BE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUint32LE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readUint32BE = $a6c5f585ab2aa95c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readBigUInt64LE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a6c5f585ab2aa95c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6c5f585ab2aa95c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a6c5f585ab2aa95c$var$Buffer.prototype.readBigUInt64BE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a6c5f585ab2aa95c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6c5f585ab2aa95c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a6c5f585ab2aa95c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readBigInt64LE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a6c5f585ab2aa95c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6c5f585ab2aa95c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a6c5f585ab2aa95c$var$Buffer.prototype.readBigInt64BE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a6c5f585ab2aa95c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6c5f585ab2aa95c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a6c5f585ab2aa95c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $a6c5f585ab2aa95c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUintLE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6c5f585ab2aa95c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUintBE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6c5f585ab2aa95c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUint8 = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUint16LE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUint16BE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUint32LE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeUint32BE = $a6c5f585ab2aa95c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a6c5f585ab2aa95c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a6c5f585ab2aa95c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a6c5f585ab2aa95c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a6c5f585ab2aa95c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.writeBigUInt64LE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a6c5f585ab2aa95c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a6c5f585ab2aa95c$var$Buffer.prototype.writeBigUInt64BE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a6c5f585ab2aa95c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a6c5f585ab2aa95c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a6c5f585ab2aa95c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a6c5f585ab2aa95c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeBigInt64LE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a6c5f585ab2aa95c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$a6c5f585ab2aa95c$var$Buffer.prototype.writeBigInt64BE = $a6c5f585ab2aa95c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a6c5f585ab2aa95c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $a6c5f585ab2aa95c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $a6c5f585ab2aa95c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a6c5f585ab2aa95c$var$writeFloat(this, value, offset, true, noAssert);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a6c5f585ab2aa95c$var$writeFloat(this, value, offset, false, noAssert);
};
function $a6c5f585ab2aa95c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6c5f585ab2aa95c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a6c5f585ab2aa95c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a6c5f585ab2aa95c$var$writeDouble(this, value, offset, true, noAssert);
};
$a6c5f585ab2aa95c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a6c5f585ab2aa95c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a6c5f585ab2aa95c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a6c5f585ab2aa95c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a6c5f585ab2aa95c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$a6c5f585ab2aa95c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a6c5f585ab2aa95c$var$Buffer.isBuffer(val) ? val : $a6c5f585ab2aa95c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a6c5f585ab2aa95c$var$errors = {};
function $a6c5f585ab2aa95c$var$E(sym, getMessage, Base) {
    $a6c5f585ab2aa95c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$a6c5f585ab2aa95c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$a6c5f585ab2aa95c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a6c5f585ab2aa95c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a6c5f585ab2aa95c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a6c5f585ab2aa95c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a6c5f585ab2aa95c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a6c5f585ab2aa95c$var$checkBounds(buf, offset, byteLength) {
    $a6c5f585ab2aa95c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a6c5f585ab2aa95c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a6c5f585ab2aa95c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a6c5f585ab2aa95c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $a6c5f585ab2aa95c$var$checkBounds(buf, offset, byteLength);
}
function $a6c5f585ab2aa95c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $a6c5f585ab2aa95c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $a6c5f585ab2aa95c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a6c5f585ab2aa95c$var$validateNumber(value, type);
        throw new $a6c5f585ab2aa95c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $a6c5f585ab2aa95c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a6c5f585ab2aa95c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a6c5f585ab2aa95c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a6c5f585ab2aa95c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a6c5f585ab2aa95c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $a6c5f585ab2aa95c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $a6c5f585ab2aa95c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a6c5f585ab2aa95c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a6c5f585ab2aa95c$var$base64ToBytes(str) {
    return $5d11t.toByteArray($a6c5f585ab2aa95c$var$base64clean(str));
}
function $a6c5f585ab2aa95c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a6c5f585ab2aa95c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a6c5f585ab2aa95c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a6c5f585ab2aa95c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a6c5f585ab2aa95c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $a6c5f585ab2aa95c$var$BufferBigIntNotDefined : fn;
}
function $a6c5f585ab2aa95c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRegister("2HiMo", function(module, exports) {

var $3aNd6 = parcelRequire("3aNd6");
var $1f6e2a26776de5c2$require$Buffer = $3aNd6.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $1f6e2a26776de5c2$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $1f6e2a26776de5c2$var$toBigIntLE(buf) {
    {
        const reversed = $1f6e2a26776de5c2$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $1f6e2a26776de5c2$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $1f6e2a26776de5c2$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $1f6e2a26776de5c2$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $1f6e2a26776de5c2$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $1f6e2a26776de5c2$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $1f6e2a26776de5c2$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $1f6e2a26776de5c2$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $1f6e2a26776de5c2$var$converter.fromBigInt(num, $1f6e2a26776de5c2$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $1f6e2a26776de5c2$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $1f6e2a26776de5c2$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $1f6e2a26776de5c2$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $1f6e2a26776de5c2$var$converter.fromBigInt(num, $1f6e2a26776de5c2$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $1f6e2a26776de5c2$var$toBufferBE;

});

parcelRegister("jDCP1", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $e4bfc60db6816cb4$export$a7a9523472993e97; });
$parcel$export(module.exports, "create", function () { return $e4bfc60db6816cb4$export$185802fd694ee1f5; });
$parcel$export(module.exports, "optional", function () { return $e4bfc60db6816cb4$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "any", function () { return $e4bfc60db6816cb4$export$4154a199d7d90455; });
$parcel$export(module.exports, "array", function () { return $e4bfc60db6816cb4$export$2f23118c22fb2630; });
$parcel$export(module.exports, "boolean", function () { return $e4bfc60db6816cb4$export$4a21f16c33752377; });
$parcel$export(module.exports, "instance", function () { return $e4bfc60db6816cb4$export$9544d5bb712b01ea; });
$parcel$export(module.exports, "literal", function () { return $e4bfc60db6816cb4$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "nullable", function () { return $e4bfc60db6816cb4$export$133fc36489ac9add; });
$parcel$export(module.exports, "number", function () { return $e4bfc60db6816cb4$export$98e628dec113755e; });
$parcel$export(module.exports, "record", function () { return $e4bfc60db6816cb4$export$e5185e241753e543; });
$parcel$export(module.exports, "string", function () { return $e4bfc60db6816cb4$export$22b082955e083ec3; });
$parcel$export(module.exports, "tuple", function () { return $e4bfc60db6816cb4$export$65e3907585753458; });
$parcel$export(module.exports, "type", function () { return $e4bfc60db6816cb4$export$bf9fb029d174d554; });
$parcel$export(module.exports, "union", function () { return $e4bfc60db6816cb4$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "unknown", function () { return $e4bfc60db6816cb4$export$19282c40b967aec6; });
$parcel$export(module.exports, "coerce", function () { return $e4bfc60db6816cb4$export$8c14e57e778d3873; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $e4bfc60db6816cb4$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $e4bfc60db6816cb4$var$isIterable(x) {
    return $e4bfc60db6816cb4$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $e4bfc60db6816cb4$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $e4bfc60db6816cb4$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $e4bfc60db6816cb4$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $e4bfc60db6816cb4$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $e4bfc60db6816cb4$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $e4bfc60db6816cb4$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $e4bfc60db6816cb4$var$toFailures(result, context, struct, value) {
    if (!$e4bfc60db6816cb4$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $e4bfc60db6816cb4$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $e4bfc60db6816cb4$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $e4bfc60db6816cb4$var$isObject(struct.schema) && $e4bfc60db6816cb4$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $e4bfc60db6816cb4$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($e4bfc60db6816cb4$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $e4bfc60db6816cb4$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $e4bfc60db6816cb4$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $e4bfc60db6816cb4$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $e4bfc60db6816cb4$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $e4bfc60db6816cb4$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $e4bfc60db6816cb4$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $e4bfc60db6816cb4$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $e4bfc60db6816cb4$export$a7a9523472993e97(value, struct) {
    const result = $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $e4bfc60db6816cb4$export$185802fd694ee1f5(value, struct) {
    const result = $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $e4bfc60db6816cb4$export$d99f0801a68bbcf1(value, struct) {
    const result = $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $e4bfc60db6816cb4$export$226b3eccf92c9ed9(value, struct) {
    const result = $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $e4bfc60db6816cb4$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $e4bfc60db6816cb4$var$run(value, struct, options);
    const tuple = $e4bfc60db6816cb4$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $e4bfc60db6816cb4$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $e4bfc60db6816cb4$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $e4bfc60db6816cb4$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $e4bfc60db6816cb4$export$f36d6a7a5c09a23e(name, validator) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $e4bfc60db6816cb4$export$cdd73fc4100a6ef4(struct, log) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $e4bfc60db6816cb4$export$7077912c31975674(fn) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $e4bfc60db6816cb4$export$488013bae63b21da(fn) {
    let struct;
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $e4bfc60db6816cb4$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $e4bfc60db6816cb4$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $e4bfc60db6816cb4$export$e45945969df8035a(struct) {
    const schema = struct instanceof $e4bfc60db6816cb4$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $e4bfc60db6816cb4$export$516e28dec6a4b6d4(schema[key]);
    return $e4bfc60db6816cb4$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $e4bfc60db6816cb4$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $e4bfc60db6816cb4$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $e4bfc60db6816cb4$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $e4bfc60db6816cb4$export$4154a199d7d90455() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $e4bfc60db6816cb4$export$2f23118c22fb2630(Element) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $e4bfc60db6816cb4$export$4a21f16c33752377() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $e4bfc60db6816cb4$export$324d90190a8b822a() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
function $e4bfc60db6816cb4$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$e4bfc60db6816cb4$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $e4bfc60db6816cb4$export$86951950244e2001() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $e4bfc60db6816cb4$export$9544d5bb712b01ea(Class) {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $e4bfc60db6816cb4$export$32744b5b3bba4764() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
function $e4bfc60db6816cb4$export$bc86dfbf7795668c(Structs) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $e4bfc60db6816cb4$export$c8ec6e1ec9fefcb0(constant) {
    const description = $e4bfc60db6816cb4$var$print(constant);
    const t = typeof constant;
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
function $e4bfc60db6816cb4$export$871de8747c9eaa88(Key, Value) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $e4bfc60db6816cb4$export$b3e22bcfd64c1022() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $e4bfc60db6816cb4$export$133fc36489ac9add(struct) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $e4bfc60db6816cb4$export$98e628dec113755e() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
function $e4bfc60db6816cb4$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $e4bfc60db6816cb4$export$b3e22bcfd64c1022();
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $e4bfc60db6816cb4$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $e4bfc60db6816cb4$var$isObject(value) || "Expected an object, but received: " + $e4bfc60db6816cb4$var$print(value);
        },
        coercer (value) {
            return $e4bfc60db6816cb4$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $e4bfc60db6816cb4$export$516e28dec6a4b6d4(struct) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $e4bfc60db6816cb4$export$e5185e241753e543(Key, Value) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($e4bfc60db6816cb4$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $e4bfc60db6816cb4$var$isObject(value) || "Expected an object, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $e4bfc60db6816cb4$export$efdc1e5bdb609bb() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $e4bfc60db6816cb4$export$adaa4cf7ef1b65be(Element) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $e4bfc60db6816cb4$export$22b082955e083ec3() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $e4bfc60db6816cb4$var$print(value);
    });
}
function $e4bfc60db6816cb4$export$65e3907585753458(Elements) {
    const Never = $e4bfc60db6816cb4$export$b3e22bcfd64c1022();
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $e4bfc60db6816cb4$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($e4bfc60db6816cb4$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $e4bfc60db6816cb4$var$isObject(value) || "Expected an object, but received: " + $e4bfc60db6816cb4$var$print(value);
        }
    });
}
function $e4bfc60db6816cb4$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        type: "union",
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $e4bfc60db6816cb4$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $e4bfc60db6816cb4$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $e4bfc60db6816cb4$export$19282c40b967aec6() {
    return $e4bfc60db6816cb4$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e4bfc60db6816cb4$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $e4bfc60db6816cb4$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e4bfc60db6816cb4$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $e4bfc60db6816cb4$export$8c14e57e778d3873(struct, $e4bfc60db6816cb4$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $e4bfc60db6816cb4$var$isPlainObject(x) && $e4bfc60db6816cb4$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $e4bfc60db6816cb4$export$41f369984ed28930(struct) {
    return $e4bfc60db6816cb4$export$8c14e57e778d3873(struct, $e4bfc60db6816cb4$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $e4bfc60db6816cb4$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $e4bfc60db6816cb4$export$edc9d475108b3212(struct, "empty", (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $e4bfc60db6816cb4$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $e4bfc60db6816cb4$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $e4bfc60db6816cb4$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $e4bfc60db6816cb4$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $e4bfc60db6816cb4$export$24f82734ea047e6f(struct, regexp) {
    return $e4bfc60db6816cb4$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $e4bfc60db6816cb4$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $e4bfc60db6816cb4$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $e4bfc60db6816cb4$export$edc9d475108b3212(struct, name, refiner) {
    return new $e4bfc60db6816cb4$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $e4bfc60db6816cb4$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("jjnoJ", function(module, exports) {
"use strict";

var $l0U3J = parcelRequire("l0U3J");
var $e0f1f0fe6d8e5ace$require$uuid = $l0U3J.default;

var $2vOjf = parcelRequire("2vOjf");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $e0f1f0fe6d8e5ace$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $e0f1f0fe6d8e5ace$var$ClientBrowser)) return new $e0f1f0fe6d8e5ace$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $e0f1f0fe6d8e5ace$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $e0f1f0fe6d8e5ace$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $e0f1f0fe6d8e5ace$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $2vOjf(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $e0f1f0fe6d8e5ace$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("l0U3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4c5153ea2ab51a2$export$2e2bcd8739ae039; });

var $hJ2nO = parcelRequire("hJ2nO");

var $bjicL = parcelRequire("bjicL");
function $f4c5153ea2ab51a2$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $hJ2nO.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $bjicL.default)(rnds);
}
var $f4c5153ea2ab51a2$export$2e2bcd8739ae039 = $f4c5153ea2ab51a2$var$v4;

});
parcelRegister("hJ2nO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce787ce0e18445be$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ce787ce0e18445be$var$getRandomValues;
var $ce787ce0e18445be$var$rnds8 = new Uint8Array(16);
function $ce787ce0e18445be$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ce787ce0e18445be$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ce787ce0e18445be$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ce787ce0e18445be$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ce787ce0e18445be$var$getRandomValues($ce787ce0e18445be$var$rnds8);
}

});

parcelRegister("bjicL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83bf972925bb4f9f$export$2e2bcd8739ae039; });

var $c9Kxf = parcelRequire("c9Kxf");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $83bf972925bb4f9f$var$byteToHex = [];
for(var $83bf972925bb4f9f$var$i = 0; $83bf972925bb4f9f$var$i < 256; ++$83bf972925bb4f9f$var$i)$83bf972925bb4f9f$var$byteToHex.push(($83bf972925bb4f9f$var$i + 0x100).toString(16).substr(1));
function $83bf972925bb4f9f$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($83bf972925bb4f9f$var$byteToHex[arr[offset + 0]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 1]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 2]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 3]] + "-" + $83bf972925bb4f9f$var$byteToHex[arr[offset + 4]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 5]] + "-" + $83bf972925bb4f9f$var$byteToHex[arr[offset + 6]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 7]] + "-" + $83bf972925bb4f9f$var$byteToHex[arr[offset + 8]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 9]] + "-" + $83bf972925bb4f9f$var$byteToHex[arr[offset + 10]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 11]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 12]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 13]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 14]] + $83bf972925bb4f9f$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $c9Kxf.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $83bf972925bb4f9f$export$2e2bcd8739ae039 = $83bf972925bb4f9f$var$stringify;

});
parcelRegister("c9Kxf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9a6c37a6d826a6$export$2e2bcd8739ae039; });

var $16H1f = parcelRequire("16H1f");
function $8d9a6c37a6d826a6$var$validate(uuid) {
    return typeof uuid === "string" && (0, $16H1f.default).test(uuid);
}
var $8d9a6c37a6d826a6$export$2e2bcd8739ae039 = $8d9a6c37a6d826a6$var$validate;

});
parcelRegister("16H1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ce7b8ab3fa83afc$export$2e2bcd8739ae039; });
var $0ce7b8ab3fa83afc$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("2vOjf", function(module, exports) {
"use strict";

var $l0U3J = parcelRequire("l0U3J");
var $1d45806fbfd7daa0$require$uuid = $l0U3J.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $1d45806fbfd7daa0$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $1d45806fbfd7daa0$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $1d45806fbfd7daa0$var$generateRequest;

});


parcelRegister("bQupP", function(module, exports) {
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $3aNd6 = parcelRequire("3aNd6");
var $89fc24f0904a5014$require$Buffer = $3aNd6.Buffer;
"use strict";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $89fc24f0904a5014$var$_regenerator = $iQtbn((parcelRequire("joUYv")));

var $89fc24f0904a5014$var$_asyncToGenerator2 = $iQtbn((parcelRequire("du1EA")));

var $89fc24f0904a5014$var$_typeof2 = $iQtbn((parcelRequire("5OoXb")));

var $89fc24f0904a5014$var$_classCallCheck2 = $iQtbn((parcelRequire("clMMr")));

var $89fc24f0904a5014$var$_createClass2 = $iQtbn((parcelRequire("drNVG")));

var $89fc24f0904a5014$var$_inherits2 = $iQtbn((parcelRequire("kLJEy")));

var $89fc24f0904a5014$var$_possibleConstructorReturn2 = $iQtbn((parcelRequire("i3X6a")));

var $89fc24f0904a5014$var$_getPrototypeOf2 = $iQtbn((parcelRequire("7vAxn")));

var $3jmf4 = parcelRequire("3jmf4");

var $98G46 = parcelRequire("98G46");
function $89fc24f0904a5014$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $89fc24f0904a5014$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $89fc24f0904a5014$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $89fc24f0904a5014$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $89fc24f0904a5014$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $89fc24f0904a5014$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $89fc24f0904a5014$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $89fc24f0904a5014$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $89fc24f0904a5014$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $89fc24f0904a5014$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        var dataPack = arguments.length > 4 ? arguments[4] : undefined;
        (0, $89fc24f0904a5014$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $89fc24f0904a5014$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $98G46.DefaultDataPack();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $89fc24f0904a5014$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $89fc24f0904a5014$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || undefined,
                        id: rpc_id
                    };
                    _this2.socket.send(_this2.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $89fc24f0904a5014$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $89fc24f0904a5014$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $89fc24f0904a5014$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $89fc24f0904a5014$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $89fc24f0904a5014$var$_regenerator["default"].mark(function _callee2() {
                    return $89fc24f0904a5014$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this3.socket.send(_this3.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $89fc24f0904a5014$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $89fc24f0904a5014$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $89fc24f0904a5014$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $89fc24f0904a5014$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $89fc24f0904a5014$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $89fc24f0904a5014$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $89fc24f0904a5014$require$Buffer.from(message).toString();
                    try {
                        message = _this4.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method && message.params) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($3jmf4.EventEmitter);
module.exports["default"] = $89fc24f0904a5014$var$CommonClient;

});
parcelRegister("iQtbn", function(module, exports) {
function $db83b85f8546cca5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $db83b85f8546cca5$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("joUYv", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $e1fc74389179ae7b$var$runtime = (parcelRequire("hWp4C"))();
module.exports = $e1fc74389179ae7b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $e1fc74389179ae7b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $e1fc74389179ae7b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e1fc74389179ae7b$var$runtime);
}

});
parcelRegister("hWp4C", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $d0fb4d88eb41fb5f$var$_typeof = $5OoXb.default;
function $d0fb4d88eb41fb5f$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $d0fb4d88eb41fb5f$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $d0fb4d88eb41fb5f$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($d0fb4d88eb41fb5f$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $d0fb4d88eb41fb5f$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5OoXb", function(module, exports) {
function $43b4fa80efde8fb9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $43b4fa80efde8fb9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $43b4fa80efde8fb9$var$_typeof(o);
}
module.exports = $43b4fa80efde8fb9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("du1EA", function(module, exports) {
function $9d0f5c15e8941c0b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9d0f5c15e8941c0b$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9d0f5c15e8941c0b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9d0f5c15e8941c0b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $9d0f5c15e8941c0b$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("clMMr", function(module, exports) {
function $8fdd48f05e7c9e18$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8fdd48f05e7c9e18$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("drNVG", function(module, exports) {

var $sa3Cx = parcelRequire("sa3Cx");
function $9ca486e3f798cd16$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $sa3Cx(descriptor.key), descriptor);
    }
}
function $9ca486e3f798cd16$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ca486e3f798cd16$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ca486e3f798cd16$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $9ca486e3f798cd16$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("sa3Cx", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $054a6ad4520a649f$var$_typeof = $5OoXb.default;

var $1wGoe = parcelRequire("1wGoe");
function $054a6ad4520a649f$var$_toPropertyKey(arg) {
    var key = $1wGoe(arg, "string");
    return $054a6ad4520a649f$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $054a6ad4520a649f$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1wGoe", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $11c9a95bb7de7697$var$_typeof = $5OoXb.default;
function $11c9a95bb7de7697$var$_toPrimitive(input, hint) {
    if ($11c9a95bb7de7697$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($11c9a95bb7de7697$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $11c9a95bb7de7697$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kLJEy", function(module, exports) {

var $2yX5r = parcelRequire("2yX5r");
function $f1eb9c2a56c06cb0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2yX5r(subClass, superClass);
}
module.exports = $f1eb9c2a56c06cb0$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2yX5r", function(module, exports) {
function $1ddc972472ee1694$var$_setPrototypeOf(o, p) {
    module.exports = $1ddc972472ee1694$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $1ddc972472ee1694$var$_setPrototypeOf(o, p);
}
module.exports = $1ddc972472ee1694$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("i3X6a", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $d2665983ba6f0935$var$_typeof = $5OoXb.default;

var $9Lt1F = parcelRequire("9Lt1F");
function $d2665983ba6f0935$var$_possibleConstructorReturn(self, call) {
    if (call && ($d2665983ba6f0935$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9Lt1F(self);
}
module.exports = $d2665983ba6f0935$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9Lt1F", function(module, exports) {
function $71bf04cd41e006f0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $71bf04cd41e006f0$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7vAxn", function(module, exports) {
function $5777c5340528614f$var$_getPrototypeOf(o) {
    module.exports = $5777c5340528614f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $5777c5340528614f$var$_getPrototypeOf(o);
}
module.exports = $5777c5340528614f$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3jmf4", function(module, exports) {
"use strict";
var $26946641ffe5315a$var$has = Object.prototype.hasOwnProperty, $26946641ffe5315a$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $26946641ffe5315a$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $26946641ffe5315a$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $26946641ffe5315a$var$Events().__proto__) $26946641ffe5315a$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $26946641ffe5315a$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $26946641ffe5315a$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $26946641ffe5315a$var$EE(fn, context || emitter, once), evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $26946641ffe5315a$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $26946641ffe5315a$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $26946641ffe5315a$var$EventEmitter() {
    this._events = new $26946641ffe5315a$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($26946641ffe5315a$var$has.call(events, name)) names.push($26946641ffe5315a$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $26946641ffe5315a$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $26946641ffe5315a$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $26946641ffe5315a$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $26946641ffe5315a$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $26946641ffe5315a$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $26946641ffe5315a$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $26946641ffe5315a$var$prefix ? $26946641ffe5315a$var$prefix + event : event;
        if (this._events[evt]) $26946641ffe5315a$var$clearEvent(this, evt);
    } else {
        this._events = new $26946641ffe5315a$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$26946641ffe5315a$var$EventEmitter.prototype.off = $26946641ffe5315a$var$EventEmitter.prototype.removeListener;
$26946641ffe5315a$var$EventEmitter.prototype.addListener = $26946641ffe5315a$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$26946641ffe5315a$var$EventEmitter.prefixed = $26946641ffe5315a$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$26946641ffe5315a$var$EventEmitter.EventEmitter = $26946641ffe5315a$var$EventEmitter;
module.exports = $26946641ffe5315a$var$EventEmitter;

});

parcelRegister("98G46", function(module, exports) {
"use strict";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultDataPack = void 0;
module.exports.createError = $6a757db27fb14e87$var$createError;

var $6a757db27fb14e87$var$_classCallCheck2 = $iQtbn((parcelRequire("clMMr")));

var $6a757db27fb14e87$var$_createClass2 = $iQtbn((parcelRequire("drNVG")));
var $6a757db27fb14e87$var$errors = new Map([
    [
        -32000,
        "Event not provided"
    ],
    [
        -32600,
        "Invalid Request"
    ],
    [
        -32601,
        "Method not found"
    ],
    [
        -32602,
        "Invalid params"
    ],
    [
        -32603,
        "Internal error"
    ],
    [
        -32604,
        "Params not found"
    ],
    [
        -32605,
        "Method forbidden"
    ],
    [
        -32606,
        "Event forbidden"
    ],
    [
        -32700,
        "Parse error"
    ]
]);
var $6a757db27fb14e87$var$DefaultDataPack = /*#__PURE__*/ function() {
    function DefaultDataPack() {
        (0, $6a757db27fb14e87$var$_classCallCheck2["default"])(this, DefaultDataPack);
    }
    (0, $6a757db27fb14e87$var$_createClass2["default"])(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
/**
 * Creates a JSON-RPC 2.0-compliant error.
 * @param {Number} code - error code
 * @param {String} details - error details
 * @return {Object}
 */ module.exports.DefaultDataPack = $6a757db27fb14e87$var$DefaultDataPack;
function $6a757db27fb14e87$var$createError(code, details) {
    var error = {
        code: code,
        message: $6a757db27fb14e87$var$errors.get(code) || "Internal Server Error"
    };
    if (details) error["data"] = details;
    return error;
}

});


parcelRegister("9Zzo3", function(module, exports) {
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $746542aa3313ba0c$var$_default;

var $746542aa3313ba0c$var$_classCallCheck2 = $iQtbn((parcelRequire("clMMr")));

var $746542aa3313ba0c$var$_createClass2 = $iQtbn((parcelRequire("drNVG")));

var $746542aa3313ba0c$var$_inherits2 = $iQtbn((parcelRequire("kLJEy")));

var $746542aa3313ba0c$var$_possibleConstructorReturn2 = $iQtbn((parcelRequire("i3X6a")));

var $746542aa3313ba0c$var$_getPrototypeOf2 = $iQtbn((parcelRequire("7vAxn")));

var $3jmf4 = parcelRequire("3jmf4");
function $746542aa3313ba0c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $746542aa3313ba0c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $746542aa3313ba0c$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $746542aa3313ba0c$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $746542aa3313ba0c$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $746542aa3313ba0c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $746542aa3313ba0c$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $746542aa3313ba0c$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $746542aa3313ba0c$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $746542aa3313ba0c$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $746542aa3313ba0c$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($3jmf4.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $746542aa3313ba0c$var$_default(address, options) {
    return new $746542aa3313ba0c$var$WebSocketBrowserImpl(address, options);
}

});

parcelRegister("bj4AF", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $021fd2b415770c9b$export$860ddaa9ca84a66d; });

var $hHe7I = parcelRequire("hHe7I");

var $y6b0j = parcelRequire("y6b0j");

var $75wGM = parcelRequire("75wGM");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $021fd2b415770c9b$var$SHA3_PI = [];
const $021fd2b415770c9b$var$SHA3_ROTL = [];
const $021fd2b415770c9b$var$_SHA3_IOTA = [];
const $021fd2b415770c9b$var$_0n = /* @__PURE__ */ BigInt(0);
const $021fd2b415770c9b$var$_1n = /* @__PURE__ */ BigInt(1);
const $021fd2b415770c9b$var$_2n = /* @__PURE__ */ BigInt(2);
const $021fd2b415770c9b$var$_7n = /* @__PURE__ */ BigInt(7);
const $021fd2b415770c9b$var$_256n = /* @__PURE__ */ BigInt(256);
const $021fd2b415770c9b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $021fd2b415770c9b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $021fd2b415770c9b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $021fd2b415770c9b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $021fd2b415770c9b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $021fd2b415770c9b$var$_1n ^ (R >> $021fd2b415770c9b$var$_7n) * $021fd2b415770c9b$var$_0x71n) % $021fd2b415770c9b$var$_256n;
        if (R & $021fd2b415770c9b$var$_2n) t ^= $021fd2b415770c9b$var$_1n << ($021fd2b415770c9b$var$_1n << /* @__PURE__ */ BigInt(j)) - $021fd2b415770c9b$var$_1n;
    }
    $021fd2b415770c9b$var$_SHA3_IOTA.push(t);
}
const [$021fd2b415770c9b$var$SHA3_IOTA_H, $021fd2b415770c9b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $y6b0j.split)($021fd2b415770c9b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $021fd2b415770c9b$var$rotlH = (h, l, s)=>s > 32 ? (0, $y6b0j.rotlBH)(h, l, s) : (0, $y6b0j.rotlSH)(h, l, s);
const $021fd2b415770c9b$var$rotlL = (h, l, s)=>s > 32 ? (0, $y6b0j.rotlBL)(h, l, s) : (0, $y6b0j.rotlSL)(h, l, s);
function $021fd2b415770c9b$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $021fd2b415770c9b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $021fd2b415770c9b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $021fd2b415770c9b$var$SHA3_ROTL[t];
            const Th = $021fd2b415770c9b$var$rotlH(curH, curL, shift);
            const Tl = $021fd2b415770c9b$var$rotlL(curH, curL, shift);
            const PI = $021fd2b415770c9b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $021fd2b415770c9b$var$SHA3_IOTA_H[round];
        s[1] ^= $021fd2b415770c9b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $021fd2b415770c9b$export$f7374b8b4498bc2e extends (0, $75wGM.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $hHe7I.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $75wGM.u32)(this.state);
    }
    keccak() {
        if (!(0, $75wGM.isLE)) (0, $75wGM.byteSwap32)(this.state32);
        $021fd2b415770c9b$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $75wGM.isLE)) (0, $75wGM.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $hHe7I.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $75wGM.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $hHe7I.exists)(this, false);
        (0, $hHe7I.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $hHe7I.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $hHe7I.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $021fd2b415770c9b$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $021fd2b415770c9b$var$gen = (suffix, blockLen, outputLen)=>(0, $75wGM.wrapConstructor)(()=>new $021fd2b415770c9b$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $021fd2b415770c9b$export$fe6c2b96a79338e9 = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x06, 144, 28);
const $021fd2b415770c9b$export$76e19b6966813b14 = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x06, 136, 32);
const $021fd2b415770c9b$export$a58509fa80f30d15 = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x06, 104, 48);
const $021fd2b415770c9b$export$20ed324dbdf09b7c = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x06, 72, 64);
const $021fd2b415770c9b$export$2f7fb3c6fac246bc = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x01, 144, 28);
const $021fd2b415770c9b$export$860ddaa9ca84a66d = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x01, 136, 32);
const $021fd2b415770c9b$export$46fcdeb4c5686552 = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x01, 104, 48);
const $021fd2b415770c9b$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $021fd2b415770c9b$var$gen(0x01, 72, 64);
const $021fd2b415770c9b$var$genShake = (suffix, blockLen, outputLen)=>(0, $75wGM.wrapXOFConstructorWithOpts)((opts = {})=>new $021fd2b415770c9b$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $021fd2b415770c9b$export$f43dc3bb86efbba2 = /* @__PURE__ */ $021fd2b415770c9b$var$genShake(0x1f, 168, 16);
const $021fd2b415770c9b$export$c240d011f1520440 = /* @__PURE__ */ $021fd2b415770c9b$var$genShake(0x1f, 136, 32);

});
parcelRegister("y6b0j", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $0667f79cae2450a7$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $0667f79cae2450a7$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $0667f79cae2450a7$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $0667f79cae2450a7$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $0667f79cae2450a7$export$5d12cc1da441323f; });
const $0667f79cae2450a7$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $0667f79cae2450a7$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $0667f79cae2450a7$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $0667f79cae2450a7$var$U32_MASK64),
        l: Number(n >> $0667f79cae2450a7$var$_32n & $0667f79cae2450a7$var$U32_MASK64)
    };
    return {
        h: Number(n >> $0667f79cae2450a7$var$_32n & $0667f79cae2450a7$var$U32_MASK64) | 0,
        l: Number(n & $0667f79cae2450a7$var$U32_MASK64) | 0
    };
}
function $0667f79cae2450a7$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $0667f79cae2450a7$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $0667f79cae2450a7$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $0667f79cae2450a7$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $0667f79cae2450a7$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $0667f79cae2450a7$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $0667f79cae2450a7$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $0667f79cae2450a7$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $0667f79cae2450a7$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $0667f79cae2450a7$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $0667f79cae2450a7$export$a088d44bd387d2a3 = (_h, l)=>l;
const $0667f79cae2450a7$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $0667f79cae2450a7$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $0667f79cae2450a7$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $0667f79cae2450a7$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $0667f79cae2450a7$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $0667f79cae2450a7$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $0667f79cae2450a7$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $0667f79cae2450a7$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $0667f79cae2450a7$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $0667f79cae2450a7$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $0667f79cae2450a7$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $0667f79cae2450a7$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $0667f79cae2450a7$var$u64 = {
    fromBig: $0667f79cae2450a7$export$9625d4333cb56c3f,
    split: $0667f79cae2450a7$export$65980d18b75784e2,
    toBig: $0667f79cae2450a7$export$30f78adcaaa2eb7,
    shrSH: $0667f79cae2450a7$export$75aa78dc5bd52853,
    shrSL: $0667f79cae2450a7$export$a0225ff0aee14e25,
    rotrSH: $0667f79cae2450a7$export$97f812dfd830ca87,
    rotrSL: $0667f79cae2450a7$export$60987e30e2c9d9d,
    rotrBH: $0667f79cae2450a7$export$af9c7fbac44dcb76,
    rotrBL: $0667f79cae2450a7$export$f619171d6d5ac414,
    rotr32H: $0667f79cae2450a7$export$a088d44bd387d2a3,
    rotr32L: $0667f79cae2450a7$export$8415aae4d1f69577,
    rotlSH: $0667f79cae2450a7$export$4b80a2917447870e,
    rotlSL: $0667f79cae2450a7$export$20652918a7b63b3,
    rotlBH: $0667f79cae2450a7$export$a52f14bf902f9977,
    rotlBL: $0667f79cae2450a7$export$5d12cc1da441323f,
    add: $0667f79cae2450a7$export$e16d8520af44a096,
    add3L: $0667f79cae2450a7$export$c0c22b91f08911f,
    add3H: $0667f79cae2450a7$export$ef7b26044977a8ec,
    add4L: $0667f79cae2450a7$export$2f4e199c560f545d,
    add4H: $0667f79cae2450a7$export$e909220d675a7741,
    add5H: $0667f79cae2450a7$export$b45ee8d78c965098,
    add5L: $0667f79cae2450a7$export$d732b061fe9c9ae4
};
var $0667f79cae2450a7$export$2e2bcd8739ae039 = $0667f79cae2450a7$var$u64;

});


parcelRegister("iI8rD", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $d9f2e301ef333a8f$export$529e6123e9353a90; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $33Sfc = parcelRequire("33Sfc");

var $3yPLd = parcelRequire("3yPLd");

var $fY0nS = parcelRequire("fY0nS");

var $2H7VI = parcelRequire("2H7VI");

var $7kYSC = parcelRequire("7kYSC");

var $bhzWT = parcelRequire("bhzWT");

var $7y3Ay = parcelRequire("7y3Ay");
const $d9f2e301ef333a8f$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $d9f2e301ef333a8f$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $d9f2e301ef333a8f$var$_1n = BigInt(1);
const $d9f2e301ef333a8f$var$_2n = BigInt(2);
const $d9f2e301ef333a8f$var$divNearest = (a, b)=>(a + b / $d9f2e301ef333a8f$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $d9f2e301ef333a8f$var$sqrtMod(y) {
    const P = $d9f2e301ef333a8f$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $fY0nS.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $fY0nS.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $fY0nS.pow2)(b9, $d9f2e301ef333a8f$var$_2n, P) * b2 % P;
    const b22 = (0, $fY0nS.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $fY0nS.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $fY0nS.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $fY0nS.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $fY0nS.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $fY0nS.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $fY0nS.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $fY0nS.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $fY0nS.pow2)(t2, $d9f2e301ef333a8f$var$_2n, P);
    if (!$d9f2e301ef333a8f$var$Fp.eql($d9f2e301ef333a8f$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $d9f2e301ef333a8f$var$Fp = (0, $fY0nS.Field)($d9f2e301ef333a8f$var$secp256k1P, undefined, undefined, {
    sqrt: $d9f2e301ef333a8f$var$sqrtMod
});
const $d9f2e301ef333a8f$export$529e6123e9353a90 = (0, $7y3Ay.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $d9f2e301ef333a8f$var$Fp,
    n: $d9f2e301ef333a8f$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $d9f2e301ef333a8f$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$d9f2e301ef333a8f$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $d9f2e301ef333a8f$var$divNearest(b2 * k, n);
            const c2 = $d9f2e301ef333a8f$var$divNearest(-b1 * k, n);
            let k1 = (0, $fY0nS.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $fY0nS.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $33Sfc.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $d9f2e301ef333a8f$var$_0n = BigInt(0);
const $d9f2e301ef333a8f$var$fe = (x)=>typeof x === "bigint" && $d9f2e301ef333a8f$var$_0n < x && x < $d9f2e301ef333a8f$var$secp256k1P;
const $d9f2e301ef333a8f$var$ge = (x)=>typeof x === "bigint" && $d9f2e301ef333a8f$var$_0n < x && x < $d9f2e301ef333a8f$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $d9f2e301ef333a8f$var$TAGGED_HASH_PREFIXES = {};
function $d9f2e301ef333a8f$var$taggedHash(tag, ...messages) {
    let tagP = $d9f2e301ef333a8f$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $33Sfc.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $7kYSC.concatBytes)(tagH, tagH);
        $d9f2e301ef333a8f$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $33Sfc.sha256)((0, $7kYSC.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $d9f2e301ef333a8f$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $d9f2e301ef333a8f$var$numTo32b = (n)=>(0, $7kYSC.numberToBytesBE)(n, 32);
const $d9f2e301ef333a8f$var$modP = (x)=>(0, $fY0nS.mod)(x, $d9f2e301ef333a8f$var$secp256k1P);
const $d9f2e301ef333a8f$var$modN = (x)=>(0, $fY0nS.mod)(x, $d9f2e301ef333a8f$var$secp256k1N);
const $d9f2e301ef333a8f$var$Point = $d9f2e301ef333a8f$export$529e6123e9353a90.ProjectivePoint;
const $d9f2e301ef333a8f$var$GmulAdd = (Q, a, b)=>$d9f2e301ef333a8f$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $d9f2e301ef333a8f$var$schnorrGetExtPubKey(priv) {
    let d_ = $d9f2e301ef333a8f$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $d9f2e301ef333a8f$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $d9f2e301ef333a8f$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $d9f2e301ef333a8f$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $d9f2e301ef333a8f$var$lift_x(x) {
    if (!$d9f2e301ef333a8f$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $d9f2e301ef333a8f$var$modP(x * x);
    const c = $d9f2e301ef333a8f$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $d9f2e301ef333a8f$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $d9f2e301ef333a8f$var$_2n !== $d9f2e301ef333a8f$var$_0n) y = $d9f2e301ef333a8f$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $d9f2e301ef333a8f$var$Point(x, y, $d9f2e301ef333a8f$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $d9f2e301ef333a8f$var$challenge(...args) {
    return $d9f2e301ef333a8f$var$modN((0, $7kYSC.bytesToNumberBE)($d9f2e301ef333a8f$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $d9f2e301ef333a8f$var$schnorrGetPublicKey(privateKey) {
    return $d9f2e301ef333a8f$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $d9f2e301ef333a8f$var$schnorrSign(message, privateKey, auxRand = (0, $3yPLd.randomBytes)(32)) {
    const m = (0, $7kYSC.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $d9f2e301ef333a8f$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $7kYSC.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $d9f2e301ef333a8f$var$numTo32b(d ^ (0, $7kYSC.bytesToNumberBE)($d9f2e301ef333a8f$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $d9f2e301ef333a8f$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $d9f2e301ef333a8f$var$modN((0, $7kYSC.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $d9f2e301ef333a8f$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $d9f2e301ef333a8f$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $d9f2e301ef333a8f$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($d9f2e301ef333a8f$var$numTo32b($d9f2e301ef333a8f$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$d9f2e301ef333a8f$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $d9f2e301ef333a8f$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $7kYSC.ensureBytes)("signature", signature, 64);
    const m = (0, $7kYSC.ensureBytes)("message", message);
    const pub = (0, $7kYSC.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $d9f2e301ef333a8f$var$lift_x((0, $7kYSC.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $7kYSC.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$d9f2e301ef333a8f$var$fe(r)) return false;
        const s = (0, $7kYSC.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$d9f2e301ef333a8f$var$ge(s)) return false;
        const e = $d9f2e301ef333a8f$var$challenge($d9f2e301ef333a8f$var$numTo32b(r), $d9f2e301ef333a8f$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $d9f2e301ef333a8f$var$GmulAdd(P, s, $d9f2e301ef333a8f$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $d9f2e301ef333a8f$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $d9f2e301ef333a8f$var$schnorrGetPublicKey,
        sign: $d9f2e301ef333a8f$var$schnorrSign,
        verify: $d9f2e301ef333a8f$var$schnorrVerify,
        utils: {
            randomPrivateKey: $d9f2e301ef333a8f$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $d9f2e301ef333a8f$var$lift_x,
            pointToBytes: $d9f2e301ef333a8f$var$pointToBytes,
            numberToBytesBE: $7kYSC.numberToBytesBE,
            bytesToNumberBE: $7kYSC.bytesToNumberBE,
            taggedHash: $d9f2e301ef333a8f$var$taggedHash,
            mod: $fY0nS.mod
        }
    }))();
const $d9f2e301ef333a8f$var$isoMap = /* @__PURE__ */ (()=>(0, $bhzWT.isogenyMap)($d9f2e301ef333a8f$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $d9f2e301ef333a8f$var$mapSWU = /* @__PURE__ */ (()=>(0, $2H7VI.mapToCurveSimpleSWU)($d9f2e301ef333a8f$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $d9f2e301ef333a8f$var$Fp.create(BigInt("-11"))
    }))();
const $d9f2e301ef333a8f$var$htf = /* @__PURE__ */ (()=>(0, $bhzWT.createHasher)($d9f2e301ef333a8f$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $d9f2e301ef333a8f$var$mapSWU($d9f2e301ef333a8f$var$Fp.create(scalars[0]));
        return $d9f2e301ef333a8f$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $d9f2e301ef333a8f$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $33Sfc.sha256)
    }))();
const $d9f2e301ef333a8f$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$d9f2e301ef333a8f$var$htf.hashToCurve)();
const $d9f2e301ef333a8f$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$d9f2e301ef333a8f$var$htf.encodeToCurve)();

});
parcelRegister("33Sfc", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $23abbaa8e6c6d6cc$export$bced8d2aada2d1c9; });

var $hX45y = parcelRequire("hX45y");

var $3yPLd = parcelRequire("3yPLd");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $23abbaa8e6c6d6cc$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $23abbaa8e6c6d6cc$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $23abbaa8e6c6d6cc$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $23abbaa8e6c6d6cc$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $23abbaa8e6c6d6cc$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $23abbaa8e6c6d6cc$var$SHA256 extends (0, $hX45y.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $23abbaa8e6c6d6cc$var$IV[0] | 0;
        this.B = $23abbaa8e6c6d6cc$var$IV[1] | 0;
        this.C = $23abbaa8e6c6d6cc$var$IV[2] | 0;
        this.D = $23abbaa8e6c6d6cc$var$IV[3] | 0;
        this.E = $23abbaa8e6c6d6cc$var$IV[4] | 0;
        this.F = $23abbaa8e6c6d6cc$var$IV[5] | 0;
        this.G = $23abbaa8e6c6d6cc$var$IV[6] | 0;
        this.H = $23abbaa8e6c6d6cc$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$23abbaa8e6c6d6cc$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $23abbaa8e6c6d6cc$var$SHA256_W[i - 15];
            const W2 = $23abbaa8e6c6d6cc$var$SHA256_W[i - 2];
            const s0 = (0, $3yPLd.rotr)(W15, 7) ^ (0, $3yPLd.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3yPLd.rotr)(W2, 17) ^ (0, $3yPLd.rotr)(W2, 19) ^ W2 >>> 10;
            $23abbaa8e6c6d6cc$var$SHA256_W[i] = s1 + $23abbaa8e6c6d6cc$var$SHA256_W[i - 7] + s0 + $23abbaa8e6c6d6cc$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3yPLd.rotr)(E, 6) ^ (0, $3yPLd.rotr)(E, 11) ^ (0, $3yPLd.rotr)(E, 25);
            const T1 = H + sigma1 + $23abbaa8e6c6d6cc$var$Chi(E, F, G) + $23abbaa8e6c6d6cc$var$SHA256_K[i] + $23abbaa8e6c6d6cc$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3yPLd.rotr)(A, 2) ^ (0, $3yPLd.rotr)(A, 13) ^ (0, $3yPLd.rotr)(A, 22);
            const T2 = sigma0 + $23abbaa8e6c6d6cc$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $23abbaa8e6c6d6cc$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $23abbaa8e6c6d6cc$var$SHA224 extends $23abbaa8e6c6d6cc$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $23abbaa8e6c6d6cc$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $23abbaa8e6c6d6cc$var$SHA256());
const $23abbaa8e6c6d6cc$export$97b70509d4e397ea = /* @__PURE__ */ (0, $3yPLd.wrapConstructor)(()=>new $23abbaa8e6c6d6cc$var$SHA224());

});

parcelRegister("2H7VI", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $1f65bfa345002f04$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $1f65bfa345002f04$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $fY0nS = parcelRequire("fY0nS");

var $7kYSC = parcelRequire("7kYSC");

var $h8jIb = parcelRequire("h8jIb");
function $1f65bfa345002f04$var$validatePointOpts(curve) {
    const opts = (0, $h8jIb.validateBasic)(curve);
    $7kYSC.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $1f65bfa345002f04$var$b2n, hexToBytes: $1f65bfa345002f04$var$h2b } = $7kYSC;
const $1f65bfa345002f04$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $1f65bfa345002f04$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $1f65bfa345002f04$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $1f65bfa345002f04$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $1f65bfa345002f04$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $1f65bfa345002f04$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $1f65bfa345002f04$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $1f65bfa345002f04$var$_0n = BigInt(0), $1f65bfa345002f04$var$_1n = BigInt(1), $1f65bfa345002f04$var$_2n = BigInt(2), $1f65bfa345002f04$var$_3n = BigInt(3), $1f65bfa345002f04$var$_4n = BigInt(4);
function $1f65bfa345002f04$export$fa783af82e4fe0fc(opts) {
    const CURVE = $1f65bfa345002f04$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $7kYSC.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $1f65bfa345002f04$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $7kYSC.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $7kYSC.bytesToNumberBE((0, $7kYSC.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $fY0nS.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $7kYSC.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $1f65bfa345002f04$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $1f65bfa345002f04$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $1f65bfa345002f04$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $1f65bfa345002f04$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $1f65bfa345002f04$var$_0n || k2 > $1f65bfa345002f04$var$_0n){
                if (k1 & $1f65bfa345002f04$var$_1n) k1p = k1p.add(d);
                if (k2 & $1f65bfa345002f04$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $1f65bfa345002f04$var$_1n;
                k2 >>= $1f65bfa345002f04$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $1f65bfa345002f04$var$_0n || a === $1f65bfa345002f04$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $1f65bfa345002f04$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $1f65bfa345002f04$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $7kYSC.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $h8jIb.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $1f65bfa345002f04$var$validateOpts(curve) {
    const opts = (0, $h8jIb.validateBasic)(curve);
    $7kYSC.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $1f65bfa345002f04$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $1f65bfa345002f04$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $1f65bfa345002f04$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $fY0nS.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $fY0nS.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $1f65bfa345002f04$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $7kYSC.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $7kYSC.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $1f65bfa345002f04$var$_1n) === $1f65bfa345002f04$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$7kYSC.bytesToHex($7kYSC.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $1f65bfa345002f04$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$7kYSC.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $7kYSC.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $1f65bfa345002f04$export$56ac33195d7076db.toSig((0, $7kYSC.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $7kYSC.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $7kYSC.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $1f65bfa345002f04$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $7kYSC.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $fY0nS.getMinHashLength(CURVE.n);
            return $fY0nS.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $7kYSC.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $7kYSC.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($1f65bfa345002f04$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $7kYSC.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $7kYSC.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $7kYSC.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $7kYSC.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $7kYSC.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $1f65bfa345002f04$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $1f65bfa345002f04$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $1f65bfa345002f04$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $7kYSC.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $7kYSC.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $7kYSC.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $1f65bfa345002f04$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $1f65bfa345002f04$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $1f65bfa345002f04$var$_0n;
    for(let o = q - $1f65bfa345002f04$var$_1n; o % $1f65bfa345002f04$var$_2n === $1f65bfa345002f04$var$_0n; o /= $1f65bfa345002f04$var$_2n)l += $1f65bfa345002f04$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $1f65bfa345002f04$var$_2n << c1 - $1f65bfa345002f04$var$_1n - $1f65bfa345002f04$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $1f65bfa345002f04$var$_2n;
    const c2 = (q - $1f65bfa345002f04$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $1f65bfa345002f04$var$_1n) / $1f65bfa345002f04$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $1f65bfa345002f04$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $1f65bfa345002f04$var$_1n) / $1f65bfa345002f04$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $1f65bfa345002f04$var$_1n; i--){
            let tv5 = i - $1f65bfa345002f04$var$_2n; // 18.    tv5 = i - 2
            tv5 = $1f65bfa345002f04$var$_2n << tv5 - $1f65bfa345002f04$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $1f65bfa345002f04$var$_4n === $1f65bfa345002f04$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $1f65bfa345002f04$var$_3n) / $1f65bfa345002f04$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $1f65bfa345002f04$export$cc7fea9756a17416(Fp, opts) {
    $fY0nS.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $1f65bfa345002f04$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});

parcelRegister("7y3Ay", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $57ee7e0459cce32a$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $ihMBq = parcelRequire("ihMBq");

var $3yPLd = parcelRequire("3yPLd");

var $2H7VI = parcelRequire("2H7VI");
function $57ee7e0459cce32a$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $ihMBq.hmac)(hash, key, (0, $3yPLd.concatBytes)(...msgs)),
        randomBytes: $3yPLd.randomBytes
    };
}
function $57ee7e0459cce32a$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $2H7VI.weierstrass)({
            ...curveDef,
            ...$57ee7e0459cce32a$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});
parcelRegister("ihMBq", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $d4ff8401381e2ff0$export$355af40f8ab02f34; });

var $4JTCm = parcelRequire("4JTCm");

var $3yPLd = parcelRequire("3yPLd");
class $d4ff8401381e2ff0$export$7b9cf41ebec74f45 extends (0, $3yPLd.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $4JTCm.hash)(hash);
        const key = (0, $3yPLd.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $4JTCm.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $4JTCm.exists)(this);
        (0, $4JTCm.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $d4ff8401381e2ff0$export$355af40f8ab02f34 = (hash, key, message)=>new $d4ff8401381e2ff0$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$d4ff8401381e2ff0$export$355af40f8ab02f34.create = (hash, key)=>new $d4ff8401381e2ff0$export$7b9cf41ebec74f45(hash, key);

});




parcelRegister("fk6Pk", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("eVbhT")).then(()=>parcelRequire("dVGqD"));

});

parcelRegister("i2utu", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cyeKU")).then(()=>parcelRequire("bN0RB"));

});

parcelRegister("6peVL", function(module, exports) {

$parcel$export(module.exports, "trezorErrorMessages", function () { return $e852ce8a958ce2b9$export$f34724b4e81a10e4; });
$parcel$export(module.exports, "getTrezorModule", function () { return $e852ce8a958ce2b9$export$7877c760b08e516b; });
$parcel$export(module.exports, "getTrezorInstance", function () { return $e852ce8a958ce2b9$export$22b246ed377359ea; });
$parcel$export(module.exports, "getEthereumAccounts", function () { return $e852ce8a958ce2b9$export$d5de980bfde9e56b; });
$parcel$export(module.exports, "valueToHex", function () { return $e852ce8a958ce2b9$export$7fd95ad4782e58f1; });
$parcel$export(module.exports, "getTrezorNormalizedDerivationPath", function () { return $e852ce8a958ce2b9$export$1e53c0113c559e93; });
parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");
var $8aS14 = parcelRequire("8aS14");

var $3HnEP = parcelRequire("3HnEP");
const $e852ce8a958ce2b9$export$f34724b4e81a10e4 = {
    Failure_ActionCancelled: "User rejected the transaction."
};

async function $e852ce8a958ce2b9$export$7877c760b08e516b() {
    const mod = await (parcelRequire("bcJjT"));
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (mod.default.default) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return mod.default.default;
    return mod.default;
}
function $e852ce8a958ce2b9$export$22b246ed377359ea() {
    /*
   * Instances have a required property which is `chainId` and is using in swap execution.
   * Here we are setting it as Ethereum always since we are supporting only eth for now.
   */ const instances = new Map();
    instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, {
        chainId: (0, $yEwlv.ETHEREUM_CHAIN_ID)
    });
    return instances;
}
async function $e852ce8a958ce2b9$export$d5de980bfde9e56b() {
    const TrezorConnect = await $e852ce8a958ce2b9$export$7877c760b08e516b();
    const result = await TrezorConnect.ethereumGetAddress({
        path: (0, $3HnEP.getDerivationPath)()
    });
    if (!result.success) throw new Error(result.payload.error);
    return {
        accounts: [
            result.payload.address
        ],
        chainId: (0, $yEwlv.ETHEREUM_CHAIN_ID)
    };
}
const $e852ce8a958ce2b9$export$7fd95ad4782e58f1 = (value)=>{
    const ZERO_BIGINT = BigInt(0);
    const HEX_BASE = 16;
    return BigInt(value) > ZERO_BIGINT ? `0x${BigInt(value).toString(HEX_BASE)}` : "0x0";
};
const $e852ce8a958ce2b9$export$1e53c0113c559e93 = (path // TrezorConnect needs master node to be added to derivation path
)=>path && !path.startsWith("m/") ? "m/" + path : path;

});
parcelRegister("3HnEP", function(module, exports) {

$parcel$export(module.exports, "setDerivationPath", function () { return $7d3114d51a204b3b$export$7700d582a5b9e8d0; });
$parcel$export(module.exports, "getDerivationPath", function () { return $7d3114d51a204b3b$export$11792f2e0d4d6623; });
// We keep derivationPath here because we need to maintain it for signing transactions after it is set in connect method
let $7d3114d51a204b3b$var$derivationPath = "";
function $7d3114d51a204b3b$export$7700d582a5b9e8d0(path) {
    $7d3114d51a204b3b$var$derivationPath = path;
}
function $7d3114d51a204b3b$export$11792f2e0d4d6623() {
    return $7d3114d51a204b3b$var$derivationPath;
}

});

parcelRegister("bcJjT", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("iWI08")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("flfS1"))
]).then(()=>parcelRequire("d6f5n"));

});


parcelRegister("iB1e7", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3g3t4")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c9Tx3")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3CRxA"))
]).then(()=>parcelRequire("iGIIL"));

});

parcelRegister("6sf4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $1WATb = parcelRequire("1WATb");

var $dG33B = parcelRequire("dG33B");

var $j5HK8 = parcelRequire("j5HK8");

var $a8KUy = parcelRequire("a8KUy");

var $lJxs2 = parcelRequire("lJxs2");
class $4b310c20dfa760fa$var$HeartBeat extends $a8KUy.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $dG33B.EventEmitter();
        this.interval = $lJxs2.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $lJxs2.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $1WATb.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $4b310c20dfa760fa$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $1WATb.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $1WATb.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $j5HK8.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($lJxs2.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $4b310c20dfa760fa$var$HeartBeat;

});
parcelRegister("1WATb", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $16a7d29ca58846ec$export$1050f835b63b671e; });
$parcel$export(module.exports, "__exportStar", function () { return $16a7d29ca58846ec$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $16a7d29ca58846ec$var$extendStatics = function(d, b) {
    $16a7d29ca58846ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $16a7d29ca58846ec$var$extendStatics(d, b);
};
function $16a7d29ca58846ec$export$a8ba968b8961cb8a(d, b) {
    $16a7d29ca58846ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $16a7d29ca58846ec$export$18ce0697a983be9b = function() {
    $16a7d29ca58846ec$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16a7d29ca58846ec$export$18ce0697a983be9b.apply(this, arguments);
};
function $16a7d29ca58846ec$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $16a7d29ca58846ec$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $16a7d29ca58846ec$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $16a7d29ca58846ec$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $16a7d29ca58846ec$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $16a7d29ca58846ec$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $16a7d29ca58846ec$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $16a7d29ca58846ec$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $16a7d29ca58846ec$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $16a7d29ca58846ec$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $16a7d29ca58846ec$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($16a7d29ca58846ec$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $16a7d29ca58846ec$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $16a7d29ca58846ec$export$10c90e4f7922046c(v) {
    return this instanceof $16a7d29ca58846ec$export$10c90e4f7922046c ? (this.v = v, this) : new $16a7d29ca58846ec$export$10c90e4f7922046c(v);
}
function $16a7d29ca58846ec$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $16a7d29ca58846ec$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $16a7d29ca58846ec$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $16a7d29ca58846ec$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $16a7d29ca58846ec$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $16a7d29ca58846ec$export$19a8beecd37a4c45 === "function" ? $16a7d29ca58846ec$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $16a7d29ca58846ec$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $16a7d29ca58846ec$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $16a7d29ca58846ec$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $16a7d29ca58846ec$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $16a7d29ca58846ec$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("j5HK8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e5SDf = parcelRequire("e5SDf");

$e5SDf.__exportStar((parcelRequire("c3KcY")), module.exports);

$e5SDf.__exportStar((parcelRequire("c7uqJ")), module.exports);

$e5SDf.__exportStar((parcelRequire("7SKWX")), module.exports);

$e5SDf.__exportStar((parcelRequire("a4kwH")), module.exports);

});
parcelRegister("e5SDf", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $a42be91e310212ef$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a42be91e310212ef$var$extendStatics = function(d, b) {
    $a42be91e310212ef$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a42be91e310212ef$var$extendStatics(d, b);
};
function $a42be91e310212ef$export$a8ba968b8961cb8a(d, b) {
    $a42be91e310212ef$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a42be91e310212ef$export$18ce0697a983be9b = function() {
    $a42be91e310212ef$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a42be91e310212ef$export$18ce0697a983be9b.apply(this, arguments);
};
function $a42be91e310212ef$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a42be91e310212ef$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a42be91e310212ef$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a42be91e310212ef$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a42be91e310212ef$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a42be91e310212ef$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $a42be91e310212ef$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $a42be91e310212ef$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $a42be91e310212ef$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a42be91e310212ef$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a42be91e310212ef$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a42be91e310212ef$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a42be91e310212ef$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a42be91e310212ef$export$10c90e4f7922046c(v) {
    return this instanceof $a42be91e310212ef$export$10c90e4f7922046c ? (this.v = v, this) : new $a42be91e310212ef$export$10c90e4f7922046c(v);
}
function $a42be91e310212ef$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a42be91e310212ef$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a42be91e310212ef$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a42be91e310212ef$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a42be91e310212ef$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a42be91e310212ef$export$19a8beecd37a4c45 === "function" ? $a42be91e310212ef$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a42be91e310212ef$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $a42be91e310212ef$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $a42be91e310212ef$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a42be91e310212ef$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $a42be91e310212ef$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("c3KcY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e5SDf = parcelRequire("e5SDf");

$e5SDf.__exportStar((parcelRequire("3vUYd")), module.exports);

$e5SDf.__exportStar((parcelRequire("em6v1")), module.exports);

});
parcelRegister("3vUYd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $28f07570d0a93e4c$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $28f07570d0a93e4c$var$delay;

});

parcelRegister("em6v1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $a4kwH = parcelRequire("a4kwH");
function $a738296c5b056da7$var$toMiliseconds(seconds) {
    return seconds * $a4kwH.ONE_THOUSAND;
}
module.exports.toMiliseconds = $a738296c5b056da7$var$toMiliseconds;
function $a738296c5b056da7$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $a4kwH.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $a738296c5b056da7$var$fromMiliseconds;

});
parcelRegister("a4kwH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e5SDf = parcelRequire("e5SDf");

$e5SDf.__exportStar((parcelRequire("7scIC")), module.exports);

$e5SDf.__exportStar((parcelRequire("kIMu4")), module.exports);

});
parcelRegister("7scIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("kIMu4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("c7uqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $8d2dbe4b821dbeb6$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $8d2dbe4b821dbeb6$var$Watch;
module.exports.default = $8d2dbe4b821dbeb6$var$Watch;

});

parcelRegister("7SKWX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e5SDf = parcelRequire("e5SDf");

$e5SDf.__exportStar((parcelRequire("f1hwF")), module.exports);

});
parcelRegister("f1hwF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $aef48b4fd1783da9$var$IWatch {
}
module.exports.IWatch = $aef48b4fd1783da9$var$IWatch;

});



parcelRegister("a8KUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1WATb = parcelRequire("1WATb");

$1WATb.__exportStar((parcelRequire("3uPKg")), module.exports);

});
parcelRegister("3uPKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("d55yj");
var $1lOcn = parcelRequire("1lOcn");
class $28bc4ff5e3b5c7f7$var$IHeartBeat extends $1lOcn.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $28bc4ff5e3b5c7f7$var$IHeartBeat;

});
parcelRegister("d55yj", function(module, exports) {
$parcel$export(module.exports, "IEvents", function () { return (parcelRequire("1lOcn")).IEvents; });
parcelRequire("1lOcn");

});
parcelRegister("1lOcn", function(module, exports) {

$parcel$export(module.exports, "IEvents", function () { return $0fbeb1089f041636$export$ab429ec7e240e546; });
class $0fbeb1089f041636$export$ab429ec7e240e546 {
}

});




parcelRegister("lJxs2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1WATb = parcelRequire("1WATb");

$1WATb.__exportStar((parcelRequire("KUPmw")), module.exports);

});
parcelRegister("KUPmw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $j5HK8 = parcelRequire("j5HK8");
module.exports.HEARTBEAT_INTERVAL = $j5HK8.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRegister("2gtzz", function(module, exports) {
"use strict";

var $aXIzn = parcelRequire("aXIzn");
module.exports = $1a6403f05d7b1029$var$pino;
const $1a6403f05d7b1029$var$_console = $1a6403f05d7b1029$var$pfGlobalThisOrFallback().console || {};
const $1a6403f05d7b1029$var$stdSerializers = {
    mapHttpRequest: $1a6403f05d7b1029$var$mock,
    mapHttpResponse: $1a6403f05d7b1029$var$mock,
    wrapRequestSerializer: $1a6403f05d7b1029$var$passthrough,
    wrapResponseSerializer: $1a6403f05d7b1029$var$passthrough,
    wrapErrorSerializer: $1a6403f05d7b1029$var$passthrough,
    req: $1a6403f05d7b1029$var$mock,
    res: $1a6403f05d7b1029$var$mock,
    err: $1a6403f05d7b1029$var$asErrValue
};
function $1a6403f05d7b1029$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $1a6403f05d7b1029$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $1a6403f05d7b1029$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $1a6403f05d7b1029$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $1a6403f05d7b1029$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $1a6403f05d7b1029$var$getTimeFunction(opts)
    };
    logger.levels = $1a6403f05d7b1029$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $1a6403f05d7b1029$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $1a6403f05d7b1029$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $1a6403f05d7b1029$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $1a6403f05d7b1029$var$set(setOpts, logger, "fatal", "error");
        $1a6403f05d7b1029$var$set(setOpts, logger, "warn", "error");
        $1a6403f05d7b1029$var$set(setOpts, logger, "info", "log");
        $1a6403f05d7b1029$var$set(setOpts, logger, "debug", "log");
        $1a6403f05d7b1029$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $1a6403f05d7b1029$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $1a6403f05d7b1029$var$bind(parent, bindings, "error");
            this.fatal = $1a6403f05d7b1029$var$bind(parent, bindings, "fatal");
            this.warn = $1a6403f05d7b1029$var$bind(parent, bindings, "warn");
            this.info = $1a6403f05d7b1029$var$bind(parent, bindings, "info");
            this.debug = $1a6403f05d7b1029$var$bind(parent, bindings, "debug");
            this.trace = $1a6403f05d7b1029$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $1a6403f05d7b1029$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$1a6403f05d7b1029$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$1a6403f05d7b1029$var$pino.stdSerializers = $1a6403f05d7b1029$var$stdSerializers;
$1a6403f05d7b1029$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $1a6403f05d7b1029$var$nullTime,
    epochTime: $1a6403f05d7b1029$var$epochTime,
    unixTime: $1a6403f05d7b1029$var$unixTime,
    isoTime: $1a6403f05d7b1029$var$isoTime
});
function $1a6403f05d7b1029$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $1a6403f05d7b1029$var$noop : proto[level] ? proto[level] : $1a6403f05d7b1029$var$_console[level] || $1a6403f05d7b1029$var$_console[fallback] || $1a6403f05d7b1029$var$noop;
    $1a6403f05d7b1029$var$wrap(opts, logger, level);
}
function $1a6403f05d7b1029$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $1a6403f05d7b1029$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $1a6403f05d7b1029$var$_console ? $1a6403f05d7b1029$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $1a6403f05d7b1029$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $1a6403f05d7b1029$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $1a6403f05d7b1029$var$pino.levels.values[transmitLevel];
                const methodValue = $1a6403f05d7b1029$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $1a6403f05d7b1029$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $1a6403f05d7b1029$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $1a6403f05d7b1029$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $1a6403f05d7b1029$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $1a6403f05d7b1029$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $aXIzn(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $aXIzn(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $1a6403f05d7b1029$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $1a6403f05d7b1029$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $1a6403f05d7b1029$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $1a6403f05d7b1029$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $1a6403f05d7b1029$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $1a6403f05d7b1029$var$createLogEventShape(bindings);
}
function $1a6403f05d7b1029$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $1a6403f05d7b1029$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $1a6403f05d7b1029$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $1a6403f05d7b1029$var$nullTime;
    return $1a6403f05d7b1029$var$epochTime;
}
function $1a6403f05d7b1029$var$mock() {
    return {};
}
function $1a6403f05d7b1029$var$passthrough(a) {
    return a;
}
function $1a6403f05d7b1029$var$noop() {}
function $1a6403f05d7b1029$var$nullTime() {
    return false;
}
function $1a6403f05d7b1029$var$epochTime() {
    return Date.now();
}
function $1a6403f05d7b1029$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $1a6403f05d7b1029$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $1a6403f05d7b1029$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRegister("aXIzn", function(module, exports) {
"use strict";
function $7fb1fcae15d04b5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $7fb1fcae15d04b5e$var$format;
function $7fb1fcae15d04b5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $7fb1fcae15d04b5e$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRegister("dlIIs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRegister("dQeds", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $dlIIs = parcelRequire("dlIIs");
function $a13b28b4cfc177d0$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $dlIIs.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $a13b28b4cfc177d0$var$getDefaultLoggerOptions;
function $a13b28b4cfc177d0$var$getBrowserLoggerContext(logger, customContextKey = $dlIIs.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $a13b28b4cfc177d0$var$getBrowserLoggerContext;
function $a13b28b4cfc177d0$var$setBrowserLoggerContext(logger, context, customContextKey = $dlIIs.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $a13b28b4cfc177d0$var$setBrowserLoggerContext;
function $a13b28b4cfc177d0$var$getLoggerContext(logger, customContextKey = $dlIIs.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $a13b28b4cfc177d0$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $a13b28b4cfc177d0$var$getLoggerContext;
function $a13b28b4cfc177d0$var$formatChildLoggerContext(logger, childContext, customContextKey = $dlIIs.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $a13b28b4cfc177d0$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $a13b28b4cfc177d0$var$formatChildLoggerContext;
function $a13b28b4cfc177d0$var$generateChildLogger(logger, childContext, customContextKey = $dlIIs.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $a13b28b4cfc177d0$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $a13b28b4cfc177d0$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $a13b28b4cfc177d0$var$generateChildLogger;

});

parcelRegister("k6hbu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $ea21b29ee87d0954$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $ea21b29ee87d0954$var$getBrowerCrypto;
function $ea21b29ee87d0954$var$getSubtleCrypto() {
    const browserCrypto = $ea21b29ee87d0954$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $ea21b29ee87d0954$var$getSubtleCrypto;
function $ea21b29ee87d0954$var$isBrowserCryptoAvailable() {
    return !!$ea21b29ee87d0954$var$getBrowerCrypto() && !!$ea21b29ee87d0954$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $ea21b29ee87d0954$var$isBrowserCryptoAvailable;

});

parcelRegister("dRcwz", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $a169f0b22d358438$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $a169f0b22d358438$var$isReactNative;
function $a169f0b22d358438$var$isNode() {
    return typeof $6qd2L !== "undefined" && typeof $6qd2L.versions !== "undefined" && typeof $6qd2L.versions.node !== "undefined";
}
module.exports.isNode = $a169f0b22d358438$var$isNode;
function $a169f0b22d358438$var$isBrowser() {
    return !$a169f0b22d358438$var$isReactNative() && !$a169f0b22d358438$var$isNode();
}
module.exports.isBrowser = $a169f0b22d358438$var$isBrowser;

});

parcelRegister("gO9pH", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("1ABol", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("bAcE3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $86ecdd8ffc58ba4b$export$2e2bcd8739ae039; });
function $86ecdd8ffc58ba4b$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("67phy", function(module, exports) {

$parcel$export(module.exports, "ChainId", function () { return $92c0425c8f4fc30c$export$c06e1e7429de6283; });
$parcel$export(module.exports, "AccountId", function () { return $92c0425c8f4fc30c$export$ef7439494a23f06e; });
function $92c0425c8f4fc30c$var$_extends() {
    $92c0425c8f4fc30c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $92c0425c8f4fc30c$var$_extends.apply(this, arguments);
}
var $92c0425c8f4fc30c$var$CAIP2 = {
    name: "chainId",
    regex: "[-:a-zA-Z0-9]{5,41}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $92c0425c8f4fc30c$var$CAIP10 = {
    name: "accountId",
    regex: "[-:a-zA-Z0-9]{7,106}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,32}"
            },
            2: {
                name: "address",
                regex: "[a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $92c0425c8f4fc30c$var$AssetName$1 = {
    name: "assetName",
    regex: "[-:a-zA-Z0-9]{5,73}",
    parameters: {
        delimiter: ":",
        values: {
            0: {
                name: "namespace",
                regex: "[-a-z0-9]{3,8}"
            },
            1: {
                name: "reference",
                regex: "[-a-zA-Z0-9]{1,64}"
            }
        }
    }
};
var $92c0425c8f4fc30c$var$CAIP19AssetType = {
    name: "assetType",
    regex: "[-:a-zA-Z0-9]{11,115}",
    parameters: {
        delimiter: "/",
        values: {
            0: $92c0425c8f4fc30c$var$CAIP2,
            1: $92c0425c8f4fc30c$var$AssetName$1
        }
    }
};
var $92c0425c8f4fc30c$var$CAIP19AssetId = {
    name: "assetId",
    regex: "[-:a-zA-Z0-9]{13,148}",
    parameters: {
        delimiter: "/",
        values: {
            0: $92c0425c8f4fc30c$var$CAIP2,
            1: $92c0425c8f4fc30c$var$AssetName$1,
            2: {
                name: "tokenId",
                regex: "[-a-zA-Z0-9]{1,32}"
            }
        }
    }
};
var $92c0425c8f4fc30c$var$CAIP = {
    "2": $92c0425c8f4fc30c$var$CAIP2,
    "10": $92c0425c8f4fc30c$var$CAIP10,
    "19": {
        assetName: $92c0425c8f4fc30c$var$AssetName$1,
        assetType: $92c0425c8f4fc30c$var$CAIP19AssetType,
        assetId: $92c0425c8f4fc30c$var$CAIP19AssetId
    }
};
function $92c0425c8f4fc30c$var$splitParams(id, spec) {
    return id.split(spec.parameters.delimiter);
}
function $92c0425c8f4fc30c$var$getParams(id, spec) {
    var arr = $92c0425c8f4fc30c$var$splitParams(id, spec);
    var params = {};
    arr.forEach(function(value, index) {
        params[spec.parameters.values[index].name] = value;
    });
    return params;
}
function $92c0425c8f4fc30c$var$joinParams(params, spec) {
    return Object.values(spec.parameters.values).map(function(parameter) {
        var param = params[parameter.name];
        return typeof param === "string" ? param : $92c0425c8f4fc30c$var$joinParams(param, parameter);
    }).join(spec.parameters.delimiter);
}
function $92c0425c8f4fc30c$var$isValidId(id, spec) {
    if (!new RegExp(spec.regex).test(id)) return false;
    var params = $92c0425c8f4fc30c$var$splitParams(id, spec);
    if (params.length !== Object.keys(spec.parameters.values).length) return false;
    var matches = params.map(function(param, index) {
        return new RegExp(spec.parameters.values[index].regex).test(param);
    }).filter(function(x) {
        return !!x;
    });
    if (matches.length !== params.length) return false;
    return true;
}
var $92c0425c8f4fc30c$export$c06e1e7429de6283 = /*#__PURE__*/ function() {
    function ChainId(params) {
        if (typeof params === "string") params = ChainId.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    ChainId.parse = function parse(id) {
        if (!$92c0425c8f4fc30c$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new ChainId($92c0425c8f4fc30c$var$getParams(id, this.spec)).toJSON();
    };
    ChainId.format = function format(params) {
        return $92c0425c8f4fc30c$var$joinParams(params, this.spec);
    };
    var _proto = ChainId.prototype;
    _proto.toString = function toString() {
        return ChainId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return ChainId;
}();
$92c0425c8f4fc30c$export$c06e1e7429de6283.spec = $92c0425c8f4fc30c$var$CAIP["2"];
var $92c0425c8f4fc30c$export$ef7439494a23f06e = /*#__PURE__*/ function() {
    function AccountId(params) {
        if (typeof params === "string") params = AccountId.parse(params);
        this.chainId = new $92c0425c8f4fc30c$export$c06e1e7429de6283(params.chainId);
        this.address = params.address;
    }
    AccountId.parse = function parse(id) {
        if (!$92c0425c8f4fc30c$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        var _getParams = $92c0425c8f4fc30c$var$getParams(id, this.spec), namespace = _getParams.namespace, reference = _getParams.reference, address = _getParams.address;
        var chainId = new $92c0425c8f4fc30c$export$c06e1e7429de6283({
            namespace: namespace,
            reference: reference
        });
        return new AccountId({
            chainId: chainId,
            address: address
        }).toJSON();
    };
    AccountId.format = function format(params) {
        var chainId = new $92c0425c8f4fc30c$export$c06e1e7429de6283(params.chainId);
        var splitParams = $92c0425c8f4fc30c$var$_extends({}, chainId.toJSON(), {
            address: params.address
        });
        return $92c0425c8f4fc30c$var$joinParams(splitParams, this.spec);
    };
    var _proto = AccountId.prototype;
    _proto.toString = function toString() {
        return AccountId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            address: this.address
        };
    };
    return AccountId;
}();
$92c0425c8f4fc30c$export$ef7439494a23f06e.spec = $92c0425c8f4fc30c$var$CAIP["10"];
var $92c0425c8f4fc30c$var$AssetName = /*#__PURE__*/ function() {
    function AssetName(params) {
        if (typeof params === "string") params = AssetName.parse(params);
        this.namespace = params.namespace;
        this.reference = params.reference;
    }
    AssetName.parse = function parse(id) {
        if (!$92c0425c8f4fc30c$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetName($92c0425c8f4fc30c$var$getParams(id, this.spec)).toJSON();
    };
    AssetName.format = function format(params) {
        return $92c0425c8f4fc30c$var$joinParams(params, this.spec);
    };
    var _proto = AssetName.prototype;
    _proto.toString = function toString() {
        return AssetName.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            namespace: this.namespace,
            reference: this.reference
        };
    };
    return AssetName;
}();
$92c0425c8f4fc30c$var$AssetName.spec = $92c0425c8f4fc30c$var$CAIP["19"].assetName;
var $92c0425c8f4fc30c$export$e57062a38354425e = /*#__PURE__*/ function() {
    function AssetType(params) {
        if (typeof params === "string") params = AssetType.parse(params);
        this.chainId = new $92c0425c8f4fc30c$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $92c0425c8f4fc30c$var$AssetName(params.assetName);
    }
    AssetType.parse = function parse(id) {
        if (!$92c0425c8f4fc30c$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetType($92c0425c8f4fc30c$var$getParams(id, this.spec)).toJSON();
    };
    AssetType.format = function format(params) {
        return $92c0425c8f4fc30c$var$joinParams(params, this.spec);
    };
    var _proto = AssetType.prototype;
    _proto.toString = function toString() {
        return AssetType.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName
        };
    };
    return AssetType;
}();
$92c0425c8f4fc30c$export$e57062a38354425e.spec = $92c0425c8f4fc30c$var$CAIP["19"].assetType;
var $92c0425c8f4fc30c$export$7591af3d8814cc71 = /*#__PURE__*/ function() {
    function AssetId(params) {
        if (typeof params === "string") params = AssetId.parse(params);
        this.chainId = new $92c0425c8f4fc30c$export$c06e1e7429de6283(params.chainId);
        this.assetName = new $92c0425c8f4fc30c$var$AssetName(params.assetName);
        this.tokenId = params.tokenId;
    }
    AssetId.parse = function parse(id) {
        if (!$92c0425c8f4fc30c$var$isValidId(id, this.spec)) throw new Error("Invalid " + this.spec.name + " provided: " + id);
        return new AssetId($92c0425c8f4fc30c$var$getParams(id, this.spec)).toJSON();
    };
    AssetId.format = function format(params) {
        return $92c0425c8f4fc30c$var$joinParams(params, this.spec);
    };
    var _proto = AssetId.prototype;
    _proto.toString = function toString() {
        return AssetId.format(this.toJSON());
    };
    _proto.toJSON = function toJSON() {
        return {
            chainId: this.chainId.toJSON(),
            assetName: this.assetName.toJSON(),
            tokenId: this.tokenId
        };
    };
    return AssetId;
}();
$92c0425c8f4fc30c$export$7591af3d8814cc71.spec = $92c0425c8f4fc30c$var$CAIP["19"].assetId;

});

parcelRegister("ckJhP", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NETWORK", function () { return $b98932fe9fc88702$export$6818d7655dbeaa11; });
$parcel$export(module.exports, "PING_TIMEOUT", function () { return $b98932fe9fc88702$export$8e04482e451f7f3d; });
$parcel$export(module.exports, "NAMESPACES", function () { return $b98932fe9fc88702$export$4d2fb7344096e022; });
$parcel$export(module.exports, "CHAIN_ID_STORAGE", function () { return $b98932fe9fc88702$export$4719bc910dce5624; });
$parcel$export(module.exports, "SolanaRPCMethods", function () { return $b98932fe9fc88702$export$3356036d1cf2007a; });
$parcel$export(module.exports, "CosmosRPCMethods", function () { return $b98932fe9fc88702$export$3ff55fb95ffc0bde; });
$parcel$export(module.exports, "EthereumRPCMethods", function () { return $b98932fe9fc88702$export$7975683052f7ad27; });
$parcel$export(module.exports, "EthereumEvents", function () { return $b98932fe9fc88702$export$3887db1ef7860390; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_EVENTS", function () { return $b98932fe9fc88702$export$e0379e0639ead25b; });
$parcel$export(module.exports, "DEFAULT_ETHEREUM_METHODS", function () { return $b98932fe9fc88702$export$469dd5b8e272d548; });
$parcel$export(module.exports, "DEFAULT_SOLANA_CHAIN_ID", function () { return $b98932fe9fc88702$export$c3c3260cf26e915d; });
$parcel$export(module.exports, "DEFAULT_APP_METADATA", function () { return $b98932fe9fc88702$export$b4cc18c8d87b93d3; });
$parcel$export(module.exports, "RELAY_URL", function () { return $b98932fe9fc88702$export$5d8b1f887d985f47; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
const $b98932fe9fc88702$export$6818d7655dbeaa11 = (0, $8aS14.LegacyNetworks).ETHEREUM;
const $b98932fe9fc88702$export$8e04482e451f7f3d = 10000;
var $b98932fe9fc88702$export$4d2fb7344096e022;
(function(NAMESPACES) {
    NAMESPACES["ETHEREUM"] = "eip155";
    NAMESPACES["SOLANA"] = "solana";
    NAMESPACES["COSMOS"] = "cosmos";
    NAMESPACES["POLKADOT"] = "polkadot";
    NAMESPACES["CARDANO"] = "cip34";
    NAMESPACES["ERLOND"] = "elrond";
    NAMESPACES["MULTIVERSX"] = "multiversx";
})($b98932fe9fc88702$export$4d2fb7344096e022 || ($b98932fe9fc88702$export$4d2fb7344096e022 = {}));
const $b98932fe9fc88702$export$4719bc910dce5624 = "wc@2:client//namespaces";
var $b98932fe9fc88702$export$3356036d1cf2007a;
(function(SolanaRPCMethods) {
    SolanaRPCMethods["GET_ACCOUNTS"] = "solana_getAccounts";
    SolanaRPCMethods["REQUEST_ACCOUNTS"] = "solana_requestAccounts";
    SolanaRPCMethods["SIGN_TRANSACTION"] = "solana_signTransaction";
    SolanaRPCMethods["SIGN_MESSAGE"] = "solana_signMessage";
})($b98932fe9fc88702$export$3356036d1cf2007a || ($b98932fe9fc88702$export$3356036d1cf2007a = {}));
var $b98932fe9fc88702$export$3ff55fb95ffc0bde;
(function(CosmosRPCMethods) {
    CosmosRPCMethods["GET_ACCOUNTS"] = "cosmos_getAccounts";
    CosmosRPCMethods["SIGN_DIRECT"] = "cosmos_signDirect";
    CosmosRPCMethods["SIGN_AMINO"] = "cosmos_signAmino";
})($b98932fe9fc88702$export$3ff55fb95ffc0bde || ($b98932fe9fc88702$export$3ff55fb95ffc0bde = {}));
var $b98932fe9fc88702$export$7975683052f7ad27;
(function(EthereumRPCMethods) {
    EthereumRPCMethods["PERSONAL_SIGN"] = "personal_sign";
    EthereumRPCMethods["SIGN"] = "eth_sign";
    EthereumRPCMethods["SIGN_TYPED_DATA"] = "eth_signTypedData";
    EthereumRPCMethods["SIGN_TRANSACTION"] = "eth_signTransaction";
    EthereumRPCMethods["SEND_TRANSACTION"] = "eth_sendTransaction";
    EthereumRPCMethods["SEND_RAW_TRANSACTION"] = "eth_sendRawTransaction";
    EthereumRPCMethods["SWITCH_CHAIN"] = "wallet_switchEthereumChain";
    EthereumRPCMethods["ADD_CHAIN"] = "wallet_addEthereumChain";
    EthereumRPCMethods["GET_CHAIN"] = "eth_chainId";
})($b98932fe9fc88702$export$7975683052f7ad27 || ($b98932fe9fc88702$export$7975683052f7ad27 = {}));
var $b98932fe9fc88702$export$6693fea3a81074a1;
(function(StarknetRPCMethods) {
    StarknetRPCMethods["REQUEST_ADD_INVOKE_TRANSACTION"] = "starknet_requestAddInvokeTransaction";
    StarknetRPCMethods["SIGN_TYPED_DATA"] = "starknet_signTypedData";
})($b98932fe9fc88702$export$6693fea3a81074a1 || ($b98932fe9fc88702$export$6693fea3a81074a1 = {}));
var $b98932fe9fc88702$export$3887db1ef7860390;
(function(EthereumEvents) {
    EthereumEvents["CHAIN_CHANGED"] = "chainChanged";
    EthereumEvents["ACCOUNTS_CHANGED"] = "accountsChanged";
})($b98932fe9fc88702$export$3887db1ef7860390 || ($b98932fe9fc88702$export$3887db1ef7860390 = {}));
const $b98932fe9fc88702$export$e0379e0639ead25b = [
    "chainChanged",
    "accountsChanged"
];
const $b98932fe9fc88702$export$469dd5b8e272d548 = [
    "personal_sign",
    "eth_sendTransaction",
    "eth_signTransaction",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "eth_chainId"
];
const $b98932fe9fc88702$export$ed05091276d4db2b = [
    "solana_signTransaction",
    "solana_signMessage"
];
const $b98932fe9fc88702$export$3c349725a6f26236 = [
    "cosmos_getAccounts",
    "cosmos_signAmino",
    "cosmos_signDirect"
];
const $b98932fe9fc88702$export$c3c3260cf26e915d = "4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ";
const $b98932fe9fc88702$export$b4cc18c8d87b93d3 = {
    name: "Rango Exchange",
    description: "The Ultimate Cross-Chain Solution",
    url: "https://app.rango.exchange/",
    icons: [
        "https://app.rango.exchange/logo-rounded.png"
    ]
};
const $b98932fe9fc88702$export$5d8b1f887d985f47 = "wss://relay.walletconnect.com";

});

parcelRegister("d276p", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", function () { return $97d0f8aa3f9623f0$export$2dd8023fb2cd44c; });
$parcel$export(module.exports, "CoreUtil", function () { return $97d0f8aa3f9623f0$export$2ff3ceb398d6f444; });
$parcel$export(module.exports, "EventsCtrl", function () { return $97d0f8aa3f9623f0$export$59a837b99037295; });
$parcel$export(module.exports, "OptionsCtrl", function () { return $97d0f8aa3f9623f0$export$5f7b08e38aeeee56; });
$parcel$export(module.exports, "ConfigCtrl", function () { return $97d0f8aa3f9623f0$export$5239b2e4de4e2646; });
$parcel$export(module.exports, "ExplorerCtrl", function () { return $97d0f8aa3f9623f0$export$8a0e3ad54b37ee57; });
$parcel$export(module.exports, "ModalCtrl", function () { return $97d0f8aa3f9623f0$export$f6ef1648e6110c37; });
$parcel$export(module.exports, "ThemeCtrl", function () { return $97d0f8aa3f9623f0$export$fed0363cf09933ba; });
$parcel$export(module.exports, "ToastCtrl", function () { return $97d0f8aa3f9623f0$export$49bec3d5b199c07; });

var $hBejl = parcelRequire("hBejl");
const $97d0f8aa3f9623f0$var$o = (0, $hBejl.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $97d0f8aa3f9623f0$export$2dd8023fb2cd44c = {
    state: $97d0f8aa3f9623f0$var$o,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$o, ()=>e($97d0f8aa3f9623f0$var$o));
    },
    push (e, t) {
        e !== $97d0f8aa3f9623f0$var$o.view && ($97d0f8aa3f9623f0$var$o.view = e, t && ($97d0f8aa3f9623f0$var$o.data = t), $97d0f8aa3f9623f0$var$o.history.push(e));
    },
    reset (e) {
        $97d0f8aa3f9623f0$var$o.view = e, $97d0f8aa3f9623f0$var$o.history = [
            e
        ];
    },
    replace (e) {
        $97d0f8aa3f9623f0$var$o.history.length > 1 && ($97d0f8aa3f9623f0$var$o.history[$97d0f8aa3f9623f0$var$o.history.length - 1] = e, $97d0f8aa3f9623f0$var$o.view = e);
    },
    goBack () {
        if ($97d0f8aa3f9623f0$var$o.history.length > 1) {
            $97d0f8aa3f9623f0$var$o.history.pop();
            const [e] = $97d0f8aa3f9623f0$var$o.history.slice(-1);
            $97d0f8aa3f9623f0$var$o.view = e;
        }
    },
    setData (e) {
        $97d0f8aa3f9623f0$var$o.data = e;
    }
}, $97d0f8aa3f9623f0$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if ($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!$97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $97d0f8aa3f9623f0$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, $97d0f8aa3f9623f0$var$_ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $97d0f8aa3f9623f0$var$r = (0, $hBejl.proxy)({
    enabled: $97d0f8aa3f9623f0$var$_,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $97d0f8aa3f9623f0$export$59a837b99037295 = {
    state: $97d0f8aa3f9623f0$var$r,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$r.events, ()=>e((0, $hBejl.snapshot)($97d0f8aa3f9623f0$var$r.events[$97d0f8aa3f9623f0$var$r.events.length - 1])));
    },
    initialize () {
        $97d0f8aa3f9623f0$var$r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($97d0f8aa3f9623f0$var$r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $97d0f8aa3f9623f0$var$r.connectedWalletId = e;
    },
    click (e) {
        if ($97d0f8aa3f9623f0$var$r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $97d0f8aa3f9623f0$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $97d0f8aa3f9623f0$var$r.events.push(t);
        }
    },
    track (e) {
        if ($97d0f8aa3f9623f0$var$r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $97d0f8aa3f9623f0$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $97d0f8aa3f9623f0$var$r.events.push(t);
        }
    },
    view (e) {
        if ($97d0f8aa3f9623f0$var$r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $97d0f8aa3f9623f0$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $97d0f8aa3f9623f0$var$r.events.push(t);
        }
    }
}, $97d0f8aa3f9623f0$var$c = (0, $hBejl.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56 = {
    state: $97d0f8aa3f9623f0$var$c,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$c, ()=>e($97d0f8aa3f9623f0$var$c));
    },
    setChains (e) {
        $97d0f8aa3f9623f0$var$c.chains = e;
    },
    setWalletConnectUri (e) {
        $97d0f8aa3f9623f0$var$c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        $97d0f8aa3f9623f0$var$c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $97d0f8aa3f9623f0$var$c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $97d0f8aa3f9623f0$var$c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $97d0f8aa3f9623f0$var$c.isUiLoaded = e;
    },
    setIsAuth (e) {
        $97d0f8aa3f9623f0$var$c.isAuth = e;
    }
}, $97d0f8aa3f9623f0$var$W = (0, $hBejl.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $97d0f8aa3f9623f0$export$5239b2e4de4e2646 = {
    state: $97d0f8aa3f9623f0$var$W,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$W, ()=>e($97d0f8aa3f9623f0$var$W));
    },
    setConfig (e) {
        var t, s;
        $97d0f8aa3f9623f0$export$59a837b99037295.initialize(), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setChains(e.chains), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setIsAuth(Boolean(e.enableAuthMode)), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.setModalVersionInStorage(), Object.assign($97d0f8aa3f9623f0$var$W, e);
    }
};
var $97d0f8aa3f9623f0$var$V = Object.defineProperty, $97d0f8aa3f9623f0$var$D = Object.getOwnPropertySymbols, $97d0f8aa3f9623f0$var$H = Object.prototype.hasOwnProperty, $97d0f8aa3f9623f0$var$B = Object.prototype.propertyIsEnumerable, $97d0f8aa3f9623f0$var$M = (e, t, s)=>t in e ? $97d0f8aa3f9623f0$var$V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $97d0f8aa3f9623f0$var$K = (e, t)=>{
    for(var s in t || (t = {}))$97d0f8aa3f9623f0$var$H.call(t, s) && $97d0f8aa3f9623f0$var$M(e, s, t[s]);
    if ($97d0f8aa3f9623f0$var$D) for (var s of $97d0f8aa3f9623f0$var$D(t))$97d0f8aa3f9623f0$var$B.call(t, s) && $97d0f8aa3f9623f0$var$M(e, s, t[s]);
    return e;
};
const $97d0f8aa3f9623f0$var$L = "https://explorer-api.walletconnect.com", $97d0f8aa3f9623f0$var$E = "wcm", $97d0f8aa3f9623f0$var$O = "js-2.6.2";
async function $97d0f8aa3f9623f0$var$w(e, t) {
    const s = $97d0f8aa3f9623f0$var$K({
        sdkType: $97d0f8aa3f9623f0$var$E,
        sdkVersion: $97d0f8aa3f9623f0$var$O
    }, t), n = new URL(e, $97d0f8aa3f9623f0$var$L);
    return n.searchParams.append("projectId", $97d0f8aa3f9623f0$export$5239b2e4de4e2646.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const $97d0f8aa3f9623f0$var$m = {
    async getDesktopListings (e) {
        return $97d0f8aa3f9623f0$var$w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $97d0f8aa3f9623f0$var$w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $97d0f8aa3f9623f0$var$w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $97d0f8aa3f9623f0$var$w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$97d0f8aa3f9623f0$var$L}/w3m/v1/getWalletImage/${e}?projectId=${$97d0f8aa3f9623f0$export$5239b2e4de4e2646.state.projectId}&sdkType=${$97d0f8aa3f9623f0$var$E}&sdkVersion=${$97d0f8aa3f9623f0$var$O}`;
    },
    getAssetImageUrl (e) {
        return `${$97d0f8aa3f9623f0$var$L}/w3m/v1/getAssetImage/${e}?projectId=${$97d0f8aa3f9623f0$export$5239b2e4de4e2646.state.projectId}&sdkType=${$97d0f8aa3f9623f0$var$E}&sdkVersion=${$97d0f8aa3f9623f0$var$O}`;
    }
};
var $97d0f8aa3f9623f0$var$z = Object.defineProperty, $97d0f8aa3f9623f0$var$j = Object.getOwnPropertySymbols, $97d0f8aa3f9623f0$var$J = Object.prototype.hasOwnProperty, $97d0f8aa3f9623f0$var$q = Object.prototype.propertyIsEnumerable, $97d0f8aa3f9623f0$var$k = (e, t, s)=>t in e ? $97d0f8aa3f9623f0$var$z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $97d0f8aa3f9623f0$var$F = (e, t)=>{
    for(var s in t || (t = {}))$97d0f8aa3f9623f0$var$J.call(t, s) && $97d0f8aa3f9623f0$var$k(e, s, t[s]);
    if ($97d0f8aa3f9623f0$var$j) for (var s of $97d0f8aa3f9623f0$var$j(t))$97d0f8aa3f9623f0$var$q.call(t, s) && $97d0f8aa3f9623f0$var$k(e, s, t[s]);
    return e;
};
const $97d0f8aa3f9623f0$var$N = $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isMobile(), $97d0f8aa3f9623f0$var$d = (0, $hBejl.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $97d0f8aa3f9623f0$export$8a0e3ad54b37ee57 = {
    state: $97d0f8aa3f9623f0$var$d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $97d0f8aa3f9623f0$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $97d0f8aa3f9623f0$var$d.recomendedWallets;
        if ($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await $97d0f8aa3f9623f0$var$m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), $97d0f8aa3f9623f0$var$d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.state, i = s?.join(","), l = $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = $97d0f8aa3f9623f0$var$N ? await $97d0f8aa3f9623f0$var$m.getMobileListings(v) : await $97d0f8aa3f9623f0$var$m.getDesktopListings(v);
            $97d0f8aa3f9623f0$var$d.recomendedWallets = Object.values(b);
        }
        return $97d0f8aa3f9623f0$var$d.recomendedWallets;
    },
    async getWallets (e) {
        const t = $97d0f8aa3f9623f0$var$F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = $97d0f8aa3f9623f0$export$5239b2e4de4e2646.state, { recomendedWallets: i } = $97d0f8aa3f9623f0$var$d;
        if (n === "ALL") return $97d0f8aa3f9623f0$var$d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = s.join(",")), $97d0f8aa3f9623f0$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = $97d0f8aa3f9623f0$var$N ? await $97d0f8aa3f9623f0$var$m.getMobileListings(t) : await $97d0f8aa3f9623f0$var$m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return $97d0f8aa3f9623f0$var$d[U] = {
            listings: [
                ...$97d0f8aa3f9623f0$var$d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return $97d0f8aa3f9623f0$var$m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $97d0f8aa3f9623f0$var$m.getAssetImageUrl(e);
    },
    resetSearch () {
        $97d0f8aa3f9623f0$var$d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $97d0f8aa3f9623f0$var$I = (0, $hBejl.proxy)({
    open: !1
}), $97d0f8aa3f9623f0$export$f6ef1648e6110c37 = {
    state: $97d0f8aa3f9623f0$var$I,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$I, ()=>e($97d0f8aa3f9623f0$var$I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.state;
            if ($97d0f8aa3f9623f0$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setWalletConnectUri(e?.uri), $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.setChains(e?.chains), $97d0f8aa3f9623f0$export$2dd8023fb2cd44c.reset("ConnectWallet"), s && n) $97d0f8aa3f9623f0$var$I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = $97d0f8aa3f9623f0$export$5f7b08e38aeeee56.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), $97d0f8aa3f9623f0$var$I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $97d0f8aa3f9623f0$var$I.open = !1;
    }
};
var $97d0f8aa3f9623f0$var$G = Object.defineProperty, $97d0f8aa3f9623f0$var$$ = Object.getOwnPropertySymbols, $97d0f8aa3f9623f0$var$Q = Object.prototype.hasOwnProperty, $97d0f8aa3f9623f0$var$X = Object.prototype.propertyIsEnumerable, $97d0f8aa3f9623f0$var$S = (e, t, s)=>t in e ? $97d0f8aa3f9623f0$var$G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $97d0f8aa3f9623f0$var$Y = (e, t)=>{
    for(var s in t || (t = {}))$97d0f8aa3f9623f0$var$Q.call(t, s) && $97d0f8aa3f9623f0$var$S(e, s, t[s]);
    if ($97d0f8aa3f9623f0$var$$) for (var s of $97d0f8aa3f9623f0$var$$(t))$97d0f8aa3f9623f0$var$X.call(t, s) && $97d0f8aa3f9623f0$var$S(e, s, t[s]);
    return e;
};
function $97d0f8aa3f9623f0$var$Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $97d0f8aa3f9623f0$var$C = (0, $hBejl.proxy)({
    themeMode: $97d0f8aa3f9623f0$var$Z() ? "dark" : "light"
}), $97d0f8aa3f9623f0$export$fed0363cf09933ba = {
    state: $97d0f8aa3f9623f0$var$C,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$C, ()=>e($97d0f8aa3f9623f0$var$C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && ($97d0f8aa3f9623f0$var$C.themeMode = t), s && ($97d0f8aa3f9623f0$var$C.themeVariables = $97d0f8aa3f9623f0$var$Y({}, s));
    }
}, $97d0f8aa3f9623f0$var$g = (0, $hBejl.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $97d0f8aa3f9623f0$export$49bec3d5b199c07 = {
    state: $97d0f8aa3f9623f0$var$g,
    subscribe (e) {
        return (0, $hBejl.subscribe)($97d0f8aa3f9623f0$var$g, ()=>e($97d0f8aa3f9623f0$var$g));
    },
    openToast (e, t) {
        $97d0f8aa3f9623f0$var$g.open = !0, $97d0f8aa3f9623f0$var$g.message = e, $97d0f8aa3f9623f0$var$g.variant = t;
    },
    closeToast () {
        $97d0f8aa3f9623f0$var$g.open = !1;
    }
};

});
parcelRegister("hBejl", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $d2278a5dbb886616$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "subscribe", function () { return $d2278a5dbb886616$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $d2278a5dbb886616$export$b8801ea43165ed7d; });

var $bTszt = parcelRequire("bTszt");
var $d2278a5dbb886616$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $d2278a5dbb886616$var$isObject = (x)=>typeof x === "object" && x !== null;
const $d2278a5dbb886616$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $d2278a5dbb886616$var$refSet = /* @__PURE__ */ new WeakSet();
const $d2278a5dbb886616$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$d2278a5dbb886616$var$isObject(x) && !$d2278a5dbb886616$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $bTszt.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($d2278a5dbb886616$var$refSet.has(value)) (0, $bTszt.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($d2278a5dbb886616$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $d2278a5dbb886616$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$d2278a5dbb886616$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($d2278a5dbb886616$import_meta.env ? $d2278a5dbb886616$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($d2278a5dbb886616$import_meta.env ? $d2278a5dbb886616$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($d2278a5dbb886616$var$isObject(value)) value = (0, $bTszt.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$d2278a5dbb886616$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$d2278a5dbb886616$var$refSet.has(nextValue) && $d2278a5dbb886616$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $d2278a5dbb886616$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $d2278a5dbb886616$var$proxyStateMap,
        $d2278a5dbb886616$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$d2278a5dbb886616$var$defaultProxyFunction] = $d2278a5dbb886616$var$buildProxyFunction();
function $d2278a5dbb886616$export$923f96dd5afa9ce6(initialObject = {}) {
    return $d2278a5dbb886616$var$defaultProxyFunction(initialObject);
}
function $d2278a5dbb886616$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $d2278a5dbb886616$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $d2278a5dbb886616$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $d2278a5dbb886616$var$proxyStateMap.get(proxyObject);
    if (($d2278a5dbb886616$import_meta.env ? $d2278a5dbb886616$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $d2278a5dbb886616$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $d2278a5dbb886616$var$proxyStateMap.get(proxyObject);
    if (($d2278a5dbb886616$import_meta.env ? $d2278a5dbb886616$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $d2278a5dbb886616$export$eff4d24c3ff7876e(obj) {
    $d2278a5dbb886616$var$refSet.add(obj);
    return obj;
}
const $d2278a5dbb886616$export$e7b04d37d9502758 = $d2278a5dbb886616$var$buildProxyFunction;

});
parcelRegister("bTszt", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $8a8afe60fcd42296$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $8a8afe60fcd42296$export$2c8383c890e26a1c; });
const $8a8afe60fcd42296$var$e = Symbol(), $8a8afe60fcd42296$var$t = Symbol(), $8a8afe60fcd42296$var$r = "a", $8a8afe60fcd42296$var$n = "w";
let $8a8afe60fcd42296$var$o = (e, t)=>new Proxy(e, t);
const $8a8afe60fcd42296$var$s = Object.getPrototypeOf, $8a8afe60fcd42296$var$c = new WeakMap, $8a8afe60fcd42296$var$l = (e)=>e && ($8a8afe60fcd42296$var$c.has(e) ? $8a8afe60fcd42296$var$c.get(e) : $8a8afe60fcd42296$var$s(e) === Object.prototype || $8a8afe60fcd42296$var$s(e) === Array.prototype), $8a8afe60fcd42296$var$f = (e)=>"object" == typeof e && null !== e, $8a8afe60fcd42296$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($8a8afe60fcd42296$var$s(e), t);
}, $8a8afe60fcd42296$var$u = (e)=>e[$8a8afe60fcd42296$var$t] || e, $8a8afe60fcd42296$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$8a8afe60fcd42296$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $8a8afe60fcd42296$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $8a8afe60fcd42296$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$8a8afe60fcd42296$var$r].get(o);
                if (s || (s = {}, c[$8a8afe60fcd42296$var$r].set(o, s)), e === $8a8afe60fcd42296$var$n) s[$8a8afe60fcd42296$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $8a8afe60fcd42296$var$t ? o : (f("k", n), $8a8afe60fcd42296$export$7865d0c7f908de6b(Reflect.get(e, n), c[$8a8afe60fcd42296$var$r], c.c, c.t)),
            has: (t, n)=>n === $8a8afe60fcd42296$var$e ? (l = !0, c[$8a8afe60fcd42296$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($8a8afe60fcd42296$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $8a8afe60fcd42296$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$8a8afe60fcd42296$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $8a8afe60fcd42296$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$8a8afe60fcd42296$var$f(e) || !$8a8afe60fcd42296$var$f(t)) return !0;
    const s = r.get($8a8afe60fcd42296$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$8a8afe60fcd42296$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $8a8afe60fcd42296$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $8a8afe60fcd42296$export$badc26589cf7bb38 = (t)=>!!$8a8afe60fcd42296$var$l(t) && $8a8afe60fcd42296$var$e in t, $8a8afe60fcd42296$export$80d2cee7ee556e99 = (e)=>$8a8afe60fcd42296$var$l(e) && e[$8a8afe60fcd42296$var$t] || null, $8a8afe60fcd42296$export$2c8383c890e26a1c = (e, t = !0)=>{
    $8a8afe60fcd42296$var$c.set(e, t);
}, $8a8afe60fcd42296$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $8a8afe60fcd42296$var$f(e) && s.add(e);
        const i = $8a8afe60fcd42296$var$f(e) && t.get($8a8afe60fcd42296$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$8a8afe60fcd42296$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $8a8afe60fcd42296$export$9b4d5450dbd8e67e = (e)=>{
    $8a8afe60fcd42296$var$o = e;
};

});



parcelRegister("l2m1H", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("a2ycA")).then(()=>parcelRequire("aGROC"));

});

parcelRegister("3tGm7", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3g3t4")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c9Tx3")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7sBIG"))
]).then(()=>parcelRequire("16wOa"));

});

parcelRegister("1agdN", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("iWI08")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cNGjO")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3VV1N")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c2aEk")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lJQ3X")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("f5KjH"))
]).then(()=>parcelRequire("eyRNK"));

});

parcelRegister("5Ocfb", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("duob7")).then(()=>parcelRequire("ipjtJ"));

});

parcelRegister("bUtcz", function(module, exports) {

$parcel$export(module.exports, "xdefi", function () { return $d449d2acb935524a$export$addfd73ac5984873; });
$parcel$export(module.exports, "getNonEvmAccounts", function () { return $d449d2acb935524a$export$78e7a9381dd8e059; });
$parcel$export(module.exports, "xdefiTransfer", function () { return $d449d2acb935524a$export$b137d6c170e38e8e; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $bfeGn = parcelRequire("bfeGn");

var $7TfHp = parcelRequire("7TfHp");
function $d449d2acb935524a$export$addfd73ac5984873() {
    const { xfi: xfi } = window;
    if (!xfi) return null;
    const instances = new Map();
    if (xfi.bitcoin) instances.set((0, $8aS14.LegacyNetworks).BTC, xfi.bitcoin);
    if (xfi.litecoin) instances.set((0, $8aS14.LegacyNetworks).LTC, xfi.litecoin);
    if (xfi.thorchain) instances.set((0, $8aS14.LegacyNetworks).THORCHAIN, xfi.thorchain);
    if (xfi.bitcoincash) instances.set((0, $8aS14.LegacyNetworks).BCH, xfi.bitcoincash);
    if (xfi.ethereum) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, xfi.ethereum);
    if (xfi.dogecoin) instances.set((0, $8aS14.LegacyNetworks).DOGE, xfi.dogecoin);
    if (xfi.solana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, xfi.solana);
    if (xfi.mayachain) instances.set((0, $8aS14.LegacyNetworks).MAYA, xfi.mayachain);
    if (xfi.keplr) instances.set((0, $8aS14.LegacyNetworks).COSMOS, xfi.keplr);
    return instances;
}
function $d449d2acb935524a$export$d1cfcb1ce8ae2e4e(netowrk) {
    if (!netowrk) return null;
    return (0, $7TfHp.SUPPORTED_ETH_CHAINS).includes(netowrk) ? (0, $8aS14.LegacyNetworks).ETHEREUM : null;
}
async function $d449d2acb935524a$export$78e7a9381dd8e059(instances) {
    const nonEvmNetworks = (0, $7TfHp.SUPPORTED_NETWORKS).filter((net)=>net !== (0, $8aS14.LegacyNetworks).ETHEREUM);
    const promises = nonEvmNetworks.filter((network)=>// Ensure the instance is defined
        instances.get(network) !== undefined).map(async (network)=>{
        return new Promise((resolve, reject)=>{
            const instance = instances.get(network);
            instance.request({
                method: "request_accounts",
                params: []
            }, (error, accounts)=>{
                if (error) {
                    reject(error);
                    return error;
                }
                const result = {
                    accounts: accounts,
                    chainId: network
                };
                resolve(result);
            });
        });
    });
    const results = await Promise.all(promises);
    return results;
}
async function $d449d2acb935524a$export$b137d6c170e38e8e(blockchain, ticker, from, amount, decimals, recipientAddress, provider, method, memo) {
    return new Promise(function(resolve, reject) {
        const params = {
            asset: {
                chain: blockchain,
                symbol: ticker,
                ticker: ticker
            },
            from: from,
            amount: {
                amount: amount,
                decimals: decimals
            },
            memo: memo
        };
        if (recipientAddress) params.recipient = recipientAddress;
        provider.request({
            method: method,
            params: [
                params
            ]
        }, (error, result)=>{
            if (error) reject(new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SEND_TX_ERROR, undefined, error));
            else resolve(result);
        });
    });
}

});
parcelRegister("7TfHp", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_NETWORKS", function () { return $e05cf282f7ec8384$export$1ab337da26caa141; });
$parcel$export(module.exports, "SUPPORTED_ETH_CHAINS", function () { return $e05cf282f7ec8384$export$2f1ee95fdafdbc6f; });
$parcel$export(module.exports, "SUPPORTED_COSMOS_CHAINS", function () { return $e05cf282f7ec8384$export$35f3dd08d92fdef4; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
const $e05cf282f7ec8384$export$1ab337da26caa141 = (0, $yEwlv.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS);
const $e05cf282f7ec8384$export$2f1ee95fdafdbc6f = [
    (0, $8aS14.LegacyNetworks).POLYGON,
    (0, $8aS14.LegacyNetworks).ETHEREUM,
    (0, $8aS14.LegacyNetworks).BSC,
    (0, $8aS14.LegacyNetworks).AVAX_CCHAIN,
    (0, $8aS14.LegacyNetworks).FANTOM,
    (0, $8aS14.LegacyNetworks).ARBITRUM
];
const $e05cf282f7ec8384$export$35f3dd08d92fdef4 = [
    (0, $8aS14.LegacyNetworks).COSMOS,
    (0, $8aS14.LegacyNetworks).AKASH,
    (0, $8aS14.LegacyNetworks).AXELAR,
    (0, $8aS14.LegacyNetworks).CRYPTO_ORG,
    (0, $8aS14.LegacyNetworks).JUNO,
    (0, $8aS14.LegacyNetworks).KUJIRA,
    (0, $8aS14.LegacyNetworks).MARS,
    (0, $8aS14.LegacyNetworks).OSMOSIS,
    (0, $8aS14.LegacyNetworks).STARGAZE,
    (0, $8aS14.LegacyNetworks).STRIDE
];

});


parcelRegister("c9no2", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("5G4j5")).then(()=>parcelRequire("8lH5x"));

});

parcelRegister("9j7Xd", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("iWI08")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("cNGjO")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3VV1N")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("c2aEk")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("lJQ3X")),
    (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("brrap"))
]).then(()=>parcelRequire("kAP9A"));

});

parcelRegister("7IVgN", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("4SbcL")).then(()=>parcelRequire("5keZe"));

});

parcelRegister("jMEJx", function(module, exports) {

$parcel$export(module.exports, "DefaultSolanaSigner", function () { return (parcelRequire("2GnNx")).DefaultSolanaSigner; });
$parcel$export(module.exports, "executeSolanaTransaction", function () { return (parcelRequire("gc2oH")).executeSolanaTransaction; });
$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return (parcelRequire("gc2oH")).generalSolanaTransactionExecutor; });
$parcel$export(module.exports, "prepareTransaction", function () { return (parcelRequire("l9jWQ")).prepareTransaction; });
$parcel$export(module.exports, "getSolanaConnection", function () { return (parcelRequire("hCUH8")).getSolanaConnection; });
$parcel$export(module.exports, "simulateTransaction", function () { return (parcelRequire("ejCiR")).simulateTransaction; });
$parcel$export(module.exports, "setSolanaSignerConfig", function () { return (parcelRequire("4HuAm")).setSolanaSignerConfig; });

var $2GnNx = parcelRequire("2GnNx");
parcelRequire("lkfP3");
var $gc2oH = parcelRequire("gc2oH");
var $hCUH8 = parcelRequire("hCUH8");
var $l9jWQ = parcelRequire("l9jWQ");
var $ejCiR = parcelRequire("ejCiR");

var $4HuAm = parcelRequire("4HuAm");

});
parcelRegister("2GnNx", function(module, exports) {

$parcel$export(module.exports, "DefaultSolanaSigner", function () { return $40226c84ac52dc7d$export$38f28568c8f589a4; });

var $4evmt = parcelRequire("4evmt");
parcelRequire("14sfz");
var $bfeGn = parcelRequire("bfeGn");

var $gc2oH = parcelRequire("gc2oH");
class $40226c84ac52dc7d$export$38f28568c8f589a4 {
    constructor(provider){
        this._provider = provider;
    }
    get provider() {
        return this._provider;
    }
    async signMessage(msg) {
        try {
            const encodedMessage = new TextEncoder().encode(msg);
            const { signature: signature } = await this._provider.request({
                method: "signMessage",
                params: {
                    message: encodedMessage
                }
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(signature);
        } catch (error) {
            throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SIGN_TX_ERROR, undefined, error);
        }
    }
    async signAndSendTx(tx) {
        const hash = await (0, $gc2oH.executeSolanaTransaction)(tx, this._provider);
        return {
            hash: hash
        };
    }
}

});
parcelRegister("gc2oH", function(module, exports) {

$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return $858c5332e34fae5c$export$2c46e2eb81692c02; });
$parcel$export(module.exports, "executeSolanaTransaction", function () { return $858c5332e34fae5c$export$478d53c60663f0a6; });
parcelRequire("14sfz");
var $bfeGn = parcelRequire("bfeGn");

var $hCUH8 = parcelRequire("hCUH8");

var $l9jWQ = parcelRequire("l9jWQ");

var $b5KHv = parcelRequire("b5KHv");

var $ejCiR = parcelRequire("ejCiR");
const $858c5332e34fae5c$export$2c46e2eb81692c02 = async (tx, DefaultSolanaSigner)=>{
    const connection = (0, $hCUH8.getSolanaConnection)();
    const latestBlock = await connection.getLatestBlockhash("confirmed");
    const finalTx = (0, $l9jWQ.prepareTransaction)(tx, latestBlock.blockhash);
    const serializedTransaction = await DefaultSolanaSigner(finalTx);
    // We first simulate whether the transaction would be successful
    await (0, $ejCiR.simulateTransaction)(finalTx, tx.txType);
    const { txId: txId, txResponse: txResponse } = await (0, $b5KHv.transactionSenderAndConfirmationWaiter)({
        connection: connection,
        serializedTransaction: serializedTransaction
    });
    if (!txId || !txResponse) throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SEND_TX_ERROR, undefined, "Error confirming the transaction");
    return txId;
};
async function $858c5332e34fae5c$export$478d53c60663f0a6(tx, solanaProvider) {
    const DefaultSolanaSigner = async (solanaWeb3Transaction)=>{
        if (!solanaProvider.publicKey) throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SIGN_TX_ERROR, "Please make sure the required account is connected properly.");
        if (tx.from !== solanaProvider.publicKey?.toString()) throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SIGN_TX_ERROR, `Your connected account doesn't match with the required account. Please ensure that you are connected with the correct account and try again.`);
        try {
            const signedTransaction = await solanaProvider.signTransaction(solanaWeb3Transaction);
            return signedTransaction.serialize();
        } catch (e) {
            const REJECTION_CODE = 4001;
            if (e && Object.hasOwn(e, "code") && e.code === REJECTION_CODE) throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).REJECTED_BY_USER, undefined, e);
            throw new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SIGN_TX_ERROR, undefined, e);
        }
    };
    return await $858c5332e34fae5c$export$2c46e2eb81692c02(tx, DefaultSolanaSigner);
}

});
parcelRegister("hCUH8", function(module, exports) {

$parcel$export(module.exports, "getSolanaConnection", function () { return $7a0327412a9ccc52$export$4b8aa67d974d7528; });
$parcel$export(module.exports, "wait", function () { return $7a0327412a9ccc52$export$5c069c93d2b7493f; });

var $4Ya7C = parcelRequire("4Ya7C");

var $4HuAm = parcelRequire("4HuAm");
const $7a0327412a9ccc52$var$IS_DEV = false;
const $7a0327412a9ccc52$var$SOLANA_RPC_URL = !$7a0327412a9ccc52$var$IS_DEV ? "https://purple-practical-friday.solana-mainnet.quiknode.pro/d94ab067f793d48c81354c78c86ae908d9fc1582/" : "https://fluent-still-scion.solana-mainnet.discover.quiknode.pro/fc8be9b8ac7aea382ec591359628e16d8c52ef6a/";
function $7a0327412a9ccc52$export$4b8aa67d974d7528() {
    const customRPC = (0, $4HuAm.getSolanaSignerConfig)("customRPC");
    return new (0, $4Ya7C.Connection)(customRPC || $7a0327412a9ccc52$var$SOLANA_RPC_URL, {
        commitment: "confirmed",
        disableRetryOnRateLimit: false
    });
}
const $7a0327412a9ccc52$export$5c069c93d2b7493f = async (time)=>new Promise((resolve)=>setTimeout(resolve, time));

});
parcelRegister("4HuAm", function(module, exports) {

$parcel$export(module.exports, "setSolanaSignerConfig", function () { return $ad848165b89f5ec3$export$e36eb7a2b6b6c75c; });
$parcel$export(module.exports, "getSolanaSignerConfig", function () { return $ad848165b89f5ec3$export$9b3036b45850ff6; });
const $ad848165b89f5ec3$var$solanaSignerConfig = {};
function $ad848165b89f5ec3$export$e36eb7a2b6b6c75c(key, value) {
    $ad848165b89f5ec3$var$solanaSignerConfig[key] = value;
    return value;
}
function $ad848165b89f5ec3$export$9b3036b45850ff6(key) {
    return $ad848165b89f5ec3$var$solanaSignerConfig[key];
}

});


parcelRegister("l9jWQ", function(module, exports) {

$parcel$export(module.exports, "prepareTransaction", function () { return $44b5dc356dbd6d0c$export$7e0572dffdc923a3; });

var $4Ya7C = parcelRequire("4Ya7C");

var $3aNd6 = parcelRequire("3aNd6");
var $44b5dc356dbd6d0c$require$Buffer = $3aNd6.Buffer;
const $44b5dc356dbd6d0c$export$7e0572dffdc923a3 = (tx, recentBlockhash)=>{
    if (tx.txType === "VERSIONED") return $44b5dc356dbd6d0c$export$e3627c823b2d0e16(tx, recentBlockhash);
    return $44b5dc356dbd6d0c$export$6746e97ddad7e458(tx, recentBlockhash);
};
function $44b5dc356dbd6d0c$export$e3627c823b2d0e16(tx, recentBlockhash) {
    const versionedTransaction = (0, $4Ya7C.VersionedTransaction).deserialize(new Uint8Array(tx.serializedMessage || []));
    /*
   * We shouldn't override the recent blockhash provided by the API
   * Otherwise, the transaction will become invalid if partially signed by the API
   */ versionedTransaction.message.recentBlockhash = tx.recentBlockhash || recentBlockhash;
    tx.signatures.forEach(({ publicKey: publicKey, signature: signature })=>{
        versionedTransaction.addSignature(new (0, $4Ya7C.PublicKey)(publicKey), new Uint8Array(signature));
    });
    return versionedTransaction;
}
function $44b5dc356dbd6d0c$export$6746e97ddad7e458(tx, recentBlockhash) {
    const transaction = new (0, $4Ya7C.Transaction)({
        feePayer: new (0, $4Ya7C.PublicKey)(tx.from),
        recentBlockhash: tx.recentBlockhash || recentBlockhash
    });
    tx.instructions.forEach(({ keys: keys, programId: programId, data: data })=>{
        const instruction = new (0, $4Ya7C.TransactionInstruction)({
            keys: keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: new (0, $4Ya7C.PublicKey)(pubkey),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: new (0, $4Ya7C.PublicKey)(programId),
            data: $44b5dc356dbd6d0c$require$Buffer.from(data)
        });
        transaction.add(instruction);
    });
    tx.signatures.forEach(({ publicKey: publicKey, signature: signature })=>{
        transaction.addSignature(new (0, $4Ya7C.PublicKey)(publicKey), $44b5dc356dbd6d0c$require$Buffer.from(new Uint8Array(signature)));
    });
    return transaction;
}

});

parcelRegister("b5KHv", function(module, exports) {

$parcel$export(module.exports, "transactionSenderAndConfirmationWaiter", function () { return $a9c751a551dffbf6$export$c6a44f9085145c9f; });

var $4Ya7C = parcelRequire("4Ya7C");

var $cUFBz = parcelRequire("cUFBz");
parcelRequire("14sfz");
var $bfeGn = parcelRequire("bfeGn");

var $hCUH8 = parcelRequire("hCUH8");
const $a9c751a551dffbf6$var$SEND_OPTIONS = {
    skipPreflight: true
};
const $a9c751a551dffbf6$var$TIME_OUT = 2000;
const $a9c751a551dffbf6$var$CONFIRMATION_TIME_OUT = 30000;
async function $a9c751a551dffbf6$export$c6a44f9085145c9f({ connection: connection, serializedTransaction: serializedTransaction }) {
    const txId = await connection.sendRawTransaction(serializedTransaction, $a9c751a551dffbf6$var$SEND_OPTIONS);
    const controller = new AbortController();
    const abortSignal = controller.signal;
    const abortableResender = async ()=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            await (0, $hCUH8.wait)($a9c751a551dffbf6$var$TIME_OUT);
            if (abortSignal.aborted) return;
            try {
                await connection.sendRawTransaction(serializedTransaction, $a9c751a551dffbf6$var$SEND_OPTIONS);
            } catch (e) {
                console.warn(`Failed to resend transaction: ${e}`);
            }
        }
    };
    try {
        abortableResender();
        // this would throw TransactionExpiredBlockheightExceededError
        await Promise.race([
            new Promise((_, reject)=>setTimeout(()=>{
                    if (!abortSignal.aborted) reject(new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SEND_TX_ERROR, undefined, `Error confirming transaction (timeout)`));
                }, $a9c751a551dffbf6$var$CONFIRMATION_TIME_OUT)),
            // eslint-disable-next-line no-async-promise-executor
            new Promise(async (resolve, reject)=>{
                // in case ws socket died
                while(!abortSignal.aborted){
                    await (0, $hCUH8.wait)($a9c751a551dffbf6$var$TIME_OUT);
                    const { value: statuses } = await connection.getSignatureStatuses([
                        txId
                    ], {
                        searchTransactionHistory: false
                    });
                    if (statuses?.length > 0) {
                        const status = statuses[0];
                        if (status) {
                            if (status.err) reject(new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SEND_TX_ERROR, undefined, `Transaction failed: ${JSON.stringify(status.err)}`));
                            if (status.confirmationStatus && [
                                "confirmed",
                                "finalized"
                            ].includes(status.confirmationStatus)) resolve(true);
                        }
                    }
                }
            })
        ]);
    } catch (e) {
        if (e instanceof (0, $4Ya7C.TransactionExpiredBlockheightExceededError)) // we consume this error and getTransaction would return null
        return {
            txId: txId,
            txResponse: null
        };
        throw e;
    } finally{
        controller.abort();
    }
    // in case rpc is not synced yet, we add some retries
    const txResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($cUFBz)))(async (retry)=>{
        const response = await connection.getTransaction(txId, {
            commitment: "confirmed",
            maxSupportedTransactionVersion: 0
        });
        if (!response) retry(response);
        return response;
    }, {
        retries: 5,
        minTimeout: 1e3
    });
    return {
        txId: txId,
        txResponse: txResponse
    };
}

});
parcelRegister("cUFBz", function(module, exports) {
"use strict";

var $6mAaY = parcelRequire("6mAaY");

var $hKX9M = parcelRequire("hKX9M");
var $966afce6b7cf1450$var$hasOwn = Object.prototype.hasOwnProperty;
function $966afce6b7cf1450$var$isRetryError(err) {
    return err && err.code === "EPROMISERETRY" && $966afce6b7cf1450$var$hasOwn.call(err, "retried");
}
function $966afce6b7cf1450$var$promiseRetry(fn, options) {
    var temp;
    var operation;
    if (typeof fn === "object" && typeof options === "function") {
        // Swap options and fn when using alternate signature (options, fn)
        temp = options;
        options = fn;
        fn = temp;
    }
    operation = $hKX9M.operation(options);
    return new Promise(function(resolve, reject) {
        operation.attempt(function(number) {
            Promise.resolve().then(function() {
                return fn(function(err) {
                    if ($966afce6b7cf1450$var$isRetryError(err)) err = err.retried;
                    throw $6mAaY(new Error("Retrying"), "EPROMISERETRY", {
                        retried: err
                    });
                }, number);
            }).then(resolve, function(err) {
                if ($966afce6b7cf1450$var$isRetryError(err)) {
                    err = err.retried;
                    if (operation.retry(err || new Error())) return;
                }
                reject(err);
            });
        });
    });
}
module.exports = $966afce6b7cf1450$var$promiseRetry;

});
parcelRegister("6mAaY", function(module, exports) {
"use strict";
function $4a20dbf5fa201e08$var$assign(obj, props) {
    for(const key in props)Object.defineProperty(obj, key, {
        value: props[key],
        enumerable: true,
        configurable: true
    });
    return obj;
}
function $4a20dbf5fa201e08$var$createError(err, code, props) {
    if (!err || typeof err === "string") throw new TypeError("Please pass an Error to err-code");
    if (!props) props = {};
    if (typeof code === "object") {
        props = code;
        code = undefined;
    }
    if (code != null) props.code = code;
    try {
        return $4a20dbf5fa201e08$var$assign(err, props);
    } catch (_) {
        props.message = err.message;
        props.stack = err.stack;
        const ErrClass = function() {};
        ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
        return $4a20dbf5fa201e08$var$assign(new ErrClass(), props);
    }
}
module.exports = $4a20dbf5fa201e08$var$createError;

});

parcelRegister("hKX9M", function(module, exports) {

module.exports = (parcelRequire("7xLKl"));

});
parcelRegister("7xLKl", function(module, exports) {

var $dHj4a = parcelRequire("dHj4a");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $dHj4a(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("dHj4a", function(module, exports) {
function $9f8e14add9c95779$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $9f8e14add9c95779$var$RetryOperation;
$9f8e14add9c95779$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$9f8e14add9c95779$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$9f8e14add9c95779$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$9f8e14add9c95779$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$9f8e14add9c95779$var$RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
$9f8e14add9c95779$var$RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
$9f8e14add9c95779$var$RetryOperation.prototype.start = $9f8e14add9c95779$var$RetryOperation.prototype.try;
$9f8e14add9c95779$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$9f8e14add9c95779$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$9f8e14add9c95779$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});





parcelRegister("ejCiR", function(module, exports) {

$parcel$export(module.exports, "simulateTransaction", function () { return $f9247b1ab0c16276$export$d7412238dc36647a; });
parcelRequire("14sfz");
var $bfeGn = parcelRequire("bfeGn");

var $hCUH8 = parcelRequire("hCUH8");
const $f9247b1ab0c16276$var$INSUFFICIENT_FUNDS_ERROR_CODE = 1;
const $f9247b1ab0c16276$var$SLIPPAGE_ERROR_CODE = 6001;
const $f9247b1ab0c16276$var$PROGRAM_FAILED_TO_COMPLETE_ERROR = "ProgramFailedToComplete";
const $f9247b1ab0c16276$var$ACCOUNT_NOT_FOUND_ERROR = "AccountNotFound";
async function $f9247b1ab0c16276$export$d7412238dc36647a(tx, type) {
    if (type === "VERSIONED") {
        const connection = (0, $hCUH8.getSolanaConnection)();
        // We first simulate whether the transaction would be successful
        const { value: simulatedTransactionResponse } = await connection.simulateTransaction(tx, {
            replaceRecentBlockhash: true,
            commitment: "processed"
        });
        const { err: err, logs: logs } = simulatedTransactionResponse;
        if (err) {
            /*
       * Simulation error, we can check the logs for more details
       * If you are getting an invalid account error, make sure that you have the input mint account to actually swap from.
       */ console.error("Simulation Error:", {
                err: err,
                logs: logs
            });
            throw $f9247b1ab0c16276$var$getSimulationError(err, logs);
        }
    }
}
function $f9247b1ab0c16276$var$getInsufficientFundsErrorMessage(logs) {
    const insufficientLamportErrorMessage = logs?.find((log)=>log.toLowerCase()?.includes("insufficient lamports"));
    return insufficientLamportErrorMessage || "Insufficient funds";
}
function $f9247b1ab0c16276$var$getSimulationError(error, logs) {
    let message = (logs?.length || 0) > 0 ? logs?.[logs?.length - 1] : JSON.stringify(error);
    /*
   * trying to detect common errors (e.g. insufficient fund or slippage error)
   * We could probably remove this code after upgrading solana/web3 lib to v2
   */ if (typeof error === "string") message = error === $f9247b1ab0c16276$var$ACCOUNT_NOT_FOUND_ERROR ? "Attempt to debit an account but found no record of a prior credit." : error;
    else {
        if (Array.isArray(error?.InstructionError) && error.InstructionError.length > 1) {
            const instructionError = error.InstructionError[1];
            if (typeof instructionError === "object") switch(instructionError.Custom){
                case $f9247b1ab0c16276$var$INSUFFICIENT_FUNDS_ERROR_CODE:
                    message = $f9247b1ab0c16276$var$getInsufficientFundsErrorMessage(logs);
                    break;
                case $f9247b1ab0c16276$var$SLIPPAGE_ERROR_CODE:
                    message = "Slippage error";
                    break;
                default:
                    break;
            }
            else if (instructionError === $f9247b1ab0c16276$var$PROGRAM_FAILED_TO_COMPLETE_ERROR) message = "Program failed to complete";
        } else if (error?.InsufficientFundsForRent) message = "Transaction results in an account with insufficient funds for rent.";
    }
    return new (0, $bfeGn.SignerError)((0, $bfeGn.SignerErrorCode).SEND_TX_ERROR, undefined, `Simulation failed: ${message}`);
}

});



parcelRegister("lkfP3", function(module, exports) {

$parcel$export(module.exports, "executeSolanaTransaction", function () { return (parcelRequire("gc2oH")).executeSolanaTransaction; });
$parcel$export(module.exports, "generalSolanaTransactionExecutor", function () { return (parcelRequire("gc2oH")).generalSolanaTransactionExecutor; });
$parcel$export(module.exports, "prepareTransaction", function () { return (parcelRequire("l9jWQ")).prepareTransaction; });
$parcel$export(module.exports, "getSolanaConnection", function () { return (parcelRequire("hCUH8")).getSolanaConnection; });
$parcel$export(module.exports, "simulateTransaction", function () { return (parcelRequire("ejCiR")).simulateTransaction; });

var $gc2oH = parcelRequire("gc2oH");

var $l9jWQ = parcelRequire("l9jWQ");

var $hCUH8 = parcelRequire("hCUH8");

var $ejCiR = parcelRequire("ejCiR");

});


var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


/* eslint-disable @typescript-eslint/no-magic-numbers */ var $9816b5f28105e113$export$ca664994d1d54bff;
(function(Level) {
    Level[Level["Off"] = 99] = "Off";
    Level[Level["Trace"] = 0] = "Trace";
    Level[Level["Debug"] = 1] = "Debug";
    Level[Level["Info"] = 2] = "Info";
    Level[Level["Warn"] = 3] = "Warn";
    Level[Level["Error"] = 4] = "Error";
})($9816b5f28105e113$export$ca664994d1d54bff || ($9816b5f28105e113$export$ca664994d1d54bff = {}));
const $9816b5f28105e113$export$3d7865934588d77e = "logger-message-event";



function $babb9842987a2c28$export$2537104fcecd895b(level) {
    switch(level){
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Trace:
            return "trace";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Debug:
            return "debug";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Info:
            return "info";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Warn:
            return "warn";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Error:
            return "error";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Off:
            return "off";
        default:
            return `unknown level (${level})`;
    }
}
function $babb9842987a2c28$export$f0c152d1c8a40895(level) {
    switch(level){
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Trace:
            return "background-color: #87d9ff; color: #000000;";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Debug:
            return "background-color: #4fff00; color: #000000;";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Info:
            return "background-color: #ffd800; color: #000000;";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Warn:
            return "background-color: #0034ff; color: #000000;";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Error:
            return "background-color: #ff0000;";
        case (0, $9816b5f28105e113$export$ca664994d1d54bff).Off:
            return "background-color: #000000;";
        default:
            return "background-color: #cccccc;";
    }
}
function $babb9842987a2c28$export$25868d1e8e76735f(payload) {
    return [
        `%c[%s] %O %O`,
        $babb9842987a2c28$export$f0c152d1c8a40895(payload.level),
        $babb9842987a2c28$export$2537104fcecd895b(payload.level),
        payload.message,
        payload.data
    ];
}


function $78c976e59c6611c9$export$50a222d9023da98b() {
    return {
        handler (payload) {
            const message = (0, $babb9842987a2c28$export$25868d1e8e76735f)(payload);
            switch(payload.level){
                case (0, $9816b5f28105e113$export$ca664994d1d54bff).Trace:
                    console.debug(...message);
                    break;
                case (0, $9816b5f28105e113$export$ca664994d1d54bff).Debug:
                    console.debug(...message);
                    break;
                case (0, $9816b5f28105e113$export$ca664994d1d54bff).Info:
                    console.log(...message);
                    break;
                case (0, $9816b5f28105e113$export$ca664994d1d54bff).Warn:
                    console.warn(...message);
                    break;
                case (0, $9816b5f28105e113$export$ca664994d1d54bff).Error:
                    console.error(...message);
                    break;
                default:
                    console.log(...message);
                    break;
            }
        }
    };
}





function $b6fd00af8aaea273$export$3b029eb57ac4d562(baseLevel, level) {
    return level >= baseLevel;
}
function $b6fd00af8aaea273$export$cbe4cdc5960cfa11(payload) {
    if (!payload.level || !payload.message) return false;
    return true;
}


function $915fd65f920a3eb7$export$2cd8252107eb640b(layers, options) {
    const { baseLevel: baseLevel } = options;
    document.addEventListener((0, $9816b5f28105e113$export$3d7865934588d77e), function handler(e) {
        // Typescript issue: https://github.com/microsoft/TypeScript/issues/28357
        const event = e;
        // Runtime check for making sure event has a valid structure.
        if (!(0, $b6fd00af8aaea273$export$cbe4cdc5960cfa11)(event.detail)) return;
        const level = event.detail.level;
        if (!(0, $b6fd00af8aaea273$export$3b029eb57ac4d562)(baseLevel, level)) // Skipping event.
        return;
        for (const layer of layers)try {
            layer.handler(event.detail);
        } catch  {
            break;
        }
    });
}





parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;


/**
 * React Router DOM v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

/**
 * @remix-run/router v1.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d09e32d367368ff7$var$_extends() {
    $d09e32d367368ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09e32d367368ff7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d09e32d367368ff7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d09e32d367368ff7$export$e19cd5f9376f8cee || ($d09e32d367368ff7$export$e19cd5f9376f8cee = {}));
const $d09e32d367368ff7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d09e32d367368ff7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d09e32d367368ff7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d09e32d367368ff7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d09e32d367368ff7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d09e32d367368ff7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d09e32d367368ff7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d09e32d367368ff7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d09e32d367368ff7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d09e32d367368ff7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d09e32d367368ff7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d09e32d367368ff7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d09e32d367368ff7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d09e32d367368ff7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d09e32d367368ff7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
        $d09e32d367368ff7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d09e32d367368ff7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d09e32d367368ff7$var$ResultType || ($d09e32d367368ff7$var$ResultType = {}));
const $d09e32d367368ff7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d09e32d367368ff7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d09e32d367368ff7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d09e32d367368ff7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d09e32d367368ff7$var$isIndexRoute(route)) {
            let indexRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d09e32d367368ff7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d09e32d367368ff7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d09e32d367368ff7$var$flattenRoutes(routes);
    $d09e32d367368ff7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d09e32d367368ff7$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d09e32d367368ff7$var$safelyDecodeURI(pathname));
    return matches;
}
function $d09e32d367368ff7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d09e32d367368ff7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d09e32d367368ff7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d09e32d367368ff7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d09e32d367368ff7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d09e32d367368ff7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d09e32d367368ff7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d09e32d367368ff7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d09e32d367368ff7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d09e32d367368ff7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d09e32d367368ff7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d09e32d367368ff7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d09e32d367368ff7$var$paramRe = /^:\w+$/;
const $d09e32d367368ff7$var$dynamicSegmentValue = 3;
const $d09e32d367368ff7$var$indexRouteValue = 2;
const $d09e32d367368ff7$var$emptySegmentValue = 1;
const $d09e32d367368ff7$var$staticSegmentValue = 10;
const $d09e32d367368ff7$var$splatPenalty = -2;
const $d09e32d367368ff7$var$isSplat = (s)=>s === "*";
function $d09e32d367368ff7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d09e32d367368ff7$var$isSplat)) initialScore += $d09e32d367368ff7$var$splatPenalty;
    if (index) initialScore += $d09e32d367368ff7$var$indexRouteValue;
    return segments.filter((s)=>!$d09e32d367368ff7$var$isSplat(s)).reduce((score, segment)=>score + ($d09e32d367368ff7$var$paramRe.test(segment) ? $d09e32d367368ff7$var$dynamicSegmentValue : segment === "" ? $d09e32d367368ff7$var$emptySegmentValue : $d09e32d367368ff7$var$staticSegmentValue), initialScore);
}
function $d09e32d367368ff7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d09e32d367368ff7$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d09e32d367368ff7$export$a5c6d149b50c1d86($d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d09e32d367368ff7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d09e32d367368ff7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d09e32d367368ff7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d09e32d367368ff7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d09e32d367368ff7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $d09e32d367368ff7$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d09e32d367368ff7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d09e32d367368ff7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d09e32d367368ff7$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d09e32d367368ff7$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d09e32d367368ff7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d09e32d367368ff7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d09e32d367368ff7$var$normalizeSearch(search),
        hash: $d09e32d367368ff7$var$normalizeHash(hash)
    };
}
function $d09e32d367368ff7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d09e32d367368ff7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d09e32d367368ff7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d09e32d367368ff7$export$a5784978eca585fa(matches) {
    // Use the full pathname for the leaf match so we include splat values for "." links
    return $d09e32d367368ff7$var$getPathContributingMatches(matches).map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
}
/**
 * @private
 */ function $d09e32d367368ff7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d09e32d367368ff7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d09e32d367368ff7$var$_extends({}, toArg);
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d09e32d367368ff7$var$getInvalidPathError("?", "pathname", "search", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "pathname", "hash", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d09e32d367368ff7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d09e32d367368ff7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d09e32d367368ff7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d09e32d367368ff7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d09e32d367368ff7$export$42a99a7a4bc0e76a extends Error {
}
class $d09e32d367368ff7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d09e32d367368ff7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d09e32d367368ff7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d09e32d367368ff7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d09e32d367368ff7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d09e32d367368ff7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d09e32d367368ff7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d09e32d367368ff7$var$unwrapTrackedPromise(value) {
    if (!$d09e32d367368ff7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d09e32d367368ff7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d09e32d367368ff7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d09e32d367368ff7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d09e32d367368ff7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d09e32d367368ff7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d09e32d367368ff7$var$validMutationMethods = new Set($d09e32d367368ff7$var$validMutationMethodsArr);
const $d09e32d367368ff7$var$validRequestMethodsArr = [
    "get",
    ...$d09e32d367368ff7$var$validMutationMethodsArr
];
const $d09e32d367368ff7$var$validRequestMethods = new Set($d09e32d367368ff7$var$validRequestMethodsArr);
const $d09e32d367368ff7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d09e32d367368ff7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d09e32d367368ff7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d09e32d367368ff7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d09e32d367368ff7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d09e32d367368ff7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d09e32d367368ff7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d09e32d367368ff7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d09e32d367368ff7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d09e32d367368ff7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d09e32d367368ff7$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d09e32d367368ff7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d09e32d367368ff7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d09e32d367368ff7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d09e32d367368ff7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d09e32d367368ff7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d09e32d367368ff7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d09e32d367368ff7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d09e32d367368ff7$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d09e32d367368ff7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d09e32d367368ff7$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d09e32d367368ff7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d09e32d367368ff7$var$isDeferredResult(result)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d09e32d367368ff7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d09e32d367368ff7$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d09e32d367368ff7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d09e32d367368ff7$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d09e32d367368ff7$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $d09e32d367368ff7$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
            return;
        }
        if ($d09e32d367368ff7$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d09e32d367368ff7$var$isDeferredResult(actionResult)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d09e32d367368ff7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d09e32d367368ff7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $d09e32d367368ff7$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d09e32d367368ff7$var$isDeferredResult(result)) result = await $d09e32d367368ff7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d09e32d367368ff7$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $d09e32d367368ff7$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace : $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d09e32d367368ff7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d09e32d367368ff7$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d09e32d367368ff7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d09e32d367368ff7$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d09e32d367368ff7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d09e32d367368ff7$var$callLoaderOrAction("loader", $d09e32d367368ff7$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $d09e32d367368ff7$var$ResultType.error,
                        error: $d09e32d367368ff7$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $d09e32d367368ff7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d09e32d367368ff7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d09e32d367368ff7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d09e32d367368ff7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d09e32d367368ff7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d09e32d367368ff7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d09e32d367368ff7$export$4d0306f8f6a4585b = Symbol("deferred");
function $d09e32d367368ff7$export$3336b097a6fbc59a(routes, opts) {
    $d09e32d367368ff7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d09e32d367368ff7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d09e32d367368ff7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d09e32d367368ff7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d09e32d367368ff7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d09e32d367368ff7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d09e32d367368ff7$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d09e32d367368ff7$var$isResponse(result) ? result : $d09e32d367368ff7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d09e32d367368ff7$var$isQueryRouteResponse(e)) {
                if (e.type === $d09e32d367368ff7$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d09e32d367368ff7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d09e32d367368ff7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d09e32d367368ff7$var$_extends({}, context, {
                statusCode: $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d09e32d367368ff7$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d09e32d367368ff7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d09e32d367368ff7$export$fec11da027c70692(routes, context, error) {
    let newContext = $d09e32d367368ff7$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d09e32d367368ff7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d09e32d367368ff7$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d09e32d367368ff7$export$cae722b0cc860f13(to ? to : ".", $d09e32d367368ff7$export$a5784978eca585fa(contextualMatches), $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d09e32d367368ff7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d09e32d367368ff7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d09e32d367368ff7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d09e32d367368ff7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d09e32d367368ff7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d09e32d367368ff7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d09e32d367368ff7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d09e32d367368ff7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d09e32d367368ff7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d09e32d367368ff7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d09e32d367368ff7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d09e32d367368ff7$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($d09e32d367368ff7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d09e32d367368ff7$var$shouldRevalidateLoader(match, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d09e32d367368ff7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d09e32d367368ff7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d09e32d367368ff7$var$shouldRevalidateLoader(fetcherMatch, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d09e32d367368ff7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d09e32d367368ff7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d09e32d367368ff7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d09e32d367368ff7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d09e32d367368ff7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d09e32d367368ff7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d09e32d367368ff7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d09e32d367368ff7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d09e32d367368ff7$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d09e32d367368ff7$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d09e32d367368ff7$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d09e32d367368ff7$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d09e32d367368ff7$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d09e32d367368ff7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) location = $d09e32d367368ff7$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d09e32d367368ff7$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $d09e32d367368ff7$var$ResultType.error ? $d09e32d367368ff7$var$ResultType.error : $d09e32d367368ff7$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
            type: resultType,
            error: new $d09e32d367368ff7$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d09e32d367368ff7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d09e32d367368ff7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d09e32d367368ff7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d09e32d367368ff7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d09e32d367368ff7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d09e32d367368ff7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d09e32d367368ff7$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d09e32d367368ff7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d09e32d367368ff7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d09e32d367368ff7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d09e32d367368ff7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d09e32d367368ff7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d09e32d367368ff7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d09e32d367368ff7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d09e32d367368ff7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d09e32d367368ff7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d09e32d367368ff7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d09e32d367368ff7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d09e32d367368ff7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d09e32d367368ff7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(path) : path;
    return $d09e32d367368ff7$export$fe53371bee54353d($d09e32d367368ff7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d09e32d367368ff7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d09e32d367368ff7$var$isDeferredResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.deferred;
}
function $d09e32d367368ff7$var$isErrorResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.error;
}
function $d09e32d367368ff7$var$isRedirectResult(result) {
    return (result && result.type) === $d09e32d367368ff7$var$ResultType.redirect;
}
function $d09e32d367368ff7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d09e32d367368ff7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d09e32d367368ff7$var$isRedirectResponse(result) {
    if (!$d09e32d367368ff7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d09e32d367368ff7$var$isQueryRouteResponse(obj) {
    return obj && $d09e32d367368ff7$var$isResponse(obj.response) && (obj.type === $d09e32d367368ff7$var$ResultType.data || obj.type === $d09e32d367368ff7$var$ResultType.error);
}
function $d09e32d367368ff7$var$isValidMethod(method) {
    return $d09e32d367368ff7$var$validRequestMethods.has(method.toLowerCase());
}
function $d09e32d367368ff7$var$isMutationMethod(method) {
    return $d09e32d367368ff7$var$validMutationMethods.has(method.toLowerCase());
}
async function $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d09e32d367368ff7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d09e32d367368ff7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d09e32d367368ff7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d09e32d367368ff7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d09e32d367368ff7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d09e32d367368ff7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d09e32d367368ff7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d09e32d367368ff7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d09e32d367368ff7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d09e32d367368ff7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d09e32d367368ff7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d09e32d367368ff7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d09e32d367368ff7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d09e32d367368ff7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d09e32d367368ff7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d09e32d367368ff7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

function $b0e6fcd50b7ef685$var$_extends() {
    $b0e6fcd50b7ef685$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0e6fcd50b7ef685$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b0e6fcd50b7ef685$export$3add0d5dce533e2e = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$145dfa71566a64dc = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$var$AwaitContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b0e6fcd50b7ef685$export$26749e8557646306 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$c7914228fb69b0f5 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$9072aa6dd1f93057 = /*#__PURE__*/ $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b0e6fcd50b7ef685$var$RouteErrorContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b0e6fcd50b7ef685$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b0e6fcd50b7ef685$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b0e6fcd50b7ef685$export$45d76561a5302f2b() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b0e6fcd50b7ef685$export$1b3f31771c5d07c() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b0e6fcd50b7ef685$export$6c330e8992e8a295(pattern) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b0e6fcd50b7ef685$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $exYeM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b0e6fcd50b7ef685$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b0e6fcd50b7ef685$var$useNavigateStable() : $b0e6fcd50b7ef685$var$useNavigateUnstable();
}
function $b0e6fcd50b7ef685$var$useNavigateUnstable() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$a5784978eca585fa)(matches));
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$OutletContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b0e6fcd50b7ef685$export$4138103a3ae699cc() {
    return $exYeM.useContext($b0e6fcd50b7ef685$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$a5784978eca585fa)(matches));
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b0e6fcd50b7ef685$export$5d3fca4a98652595(routes, locationArg) {
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: parentMatches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d09e32d367368ff7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b0e6fcd50b7ef685$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b0e6fcd50b7ef685$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b0e6fcd50b7ef685$var$DefaultErrorComponent() {
    let error = $b0e6fcd50b7ef685$export$ed527bf60f6e05f2();
    let message = (0, $d09e32d367368ff7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b0e6fcd50b7ef685$var$defaultErrorElement = /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DefaultErrorComponent, null);
class $b0e6fcd50b7ef685$var$RenderErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $b0e6fcd50b7ef685$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b0e6fcd50b7ef685$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $b0e6fcd50b7ef685$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b0e6fcd50b7ef685$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b0e6fcd50b7ef685$var$DataRouterHook || {});
var $b0e6fcd50b7ef685$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b0e6fcd50b7ef685$var$DataRouterStateHook || {});
function $b0e6fcd50b7ef685$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b0e6fcd50b7ef685$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b0e6fcd50b7ef685$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($b0e6fcd50b7ef685$export$145dfa71566a64dc);
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
function $b0e6fcd50b7ef685$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b0e6fcd50b7ef685$var$useCurrentRouteId(hookName) {
    let route = $b0e6fcd50b7ef685$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b0e6fcd50b7ef685$export$5fc8298006ad9e58() {
    return $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b0e6fcd50b7ef685$export$d0fd4b7106de2769() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b0e6fcd50b7ef685$export$600dc272ed516c15() {
    let dataRouterContext = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseRevalidator);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRevalidator);
    return $exYeM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b0e6fcd50b7ef685$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseMatches);
    return $exYeM.useMemo(()=>matches.map((m)=>(0, $d09e32d367368ff7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b0e6fcd50b7ef685$export$1448a5050d252c4d() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b0e6fcd50b7ef685$export$fd5d37484eab868d(routeId) {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b0e6fcd50b7ef685$export$fdc00f3f26066d5e() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseActionData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b0e6fcd50b7ef685$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $exYeM.useContext($b0e6fcd50b7ef685$var$RouteErrorContext);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$17f53340677d5831() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b0e6fcd50b7ef685$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b0e6fcd50b7ef685$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseBlocker);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b0e6fcd50b7ef685$var$_extends({}, currentLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b0e6fcd50b7ef685$var$_extends({}, nextLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $exYeM.useEffect(()=>{
        let key = String(++$b0e6fcd50b7ef685$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d09e32d367368ff7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b0e6fcd50b7ef685$var$useNavigateStable() {
    let { router: router } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseNavigateStable);
    let id = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b0e6fcd50b7ef685$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$alreadyWarned = {};
function $b0e6fcd50b7ef685$var$warningOnce(key, cond, message) {
    if (!cond && !$b0e6fcd50b7ef685$var$alreadyWarned[key]) $b0e6fcd50b7ef685$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b0e6fcd50b7ef685$var$START_TRANSITION = "startTransition";
const $b0e6fcd50b7ef685$var$startTransitionImpl = $exYeM[$b0e6fcd50b7ef685$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b0e6fcd50b7ef685$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        if (v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl) $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $b0e6fcd50b7ef685$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b0e6fcd50b7ef685$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b0e6fcd50b7ef685$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let navigate = $b0e6fcd50b7ef685$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, (0, $d09e32d367368ff7$export$a5784978eca585fa)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b0e6fcd50b7ef685$export$910ae8079b2c2852(props) {
    return $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b0e6fcd50b7ef685$export$e7b0ac011bb776c6(_props) {
    (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b0e6fcd50b7ef685$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b0e6fcd50b7ef685$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b0e6fcd50b7ef685$export$5d3fca4a98652595($b0e6fcd50b7ef685$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b0e6fcd50b7ef685$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$ResolveAwait, null, children));
}
var $b0e6fcd50b7ef685$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b0e6fcd50b7ef685$var$AwaitRenderStatus || {});
const $b0e6fcd50b7ef685$var$neverSettledPromise = new Promise(()=>{});
class $b0e6fcd50b7ef685$var$AwaitErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.error : promise._data !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.success : $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && promise._error instanceof (0, $d09e32d367368ff7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $b0e6fcd50b7ef685$var$neverSettledPromise;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b0e6fcd50b7ef685$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b0e6fcd50b7ef685$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b0e6fcd50b7ef685$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b0e6fcd50b7ef685$export$e7b0ac011bb776c6) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b0e6fcd50b7ef685$export$daf73786167a7f72(matches) {
    return $b0e6fcd50b7ef685$var$_renderMatches(matches);
}
function $b0e6fcd50b7ef685$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $exYeM.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $exYeM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b0e6fcd50b7ef685$export$f30f7e456d254e83(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b0e6fcd50b7ef685$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b0e6fcd50b7ef685$export$52b333d321859367
    }).initialize();
}



function $2cc1d3688dd37f6f$var$_extends() {
    $2cc1d3688dd37f6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cc1d3688dd37f6f$var$_extends.apply(this, arguments);
}
function $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2cc1d3688dd37f6f$var$defaultMethod = "get";
const $2cc1d3688dd37f6f$var$defaultEncType = "application/x-www-form-urlencoded";
function $2cc1d3688dd37f6f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2cc1d3688dd37f6f$var$isButtonElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2cc1d3688dd37f6f$var$isFormElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2cc1d3688dd37f6f$var$isInputElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2cc1d3688dd37f6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2cc1d3688dd37f6f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2cc1d3688dd37f6f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = null;
function $2cc1d3688dd37f6f$var$isFormDataSubmitterSupported() {
    if ($2cc1d3688dd37f6f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = true;
    }
    return $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter;
}
const $2cc1d3688dd37f6f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2cc1d3688dd37f6f$var$getFormEncType(encType) {
    if (encType != null && !$2cc1d3688dd37f6f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2cc1d3688dd37f6f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2cc1d3688dd37f6f$var$isButtonElement(target) || $2cc1d3688dd37f6f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("formenctype")) || $2cc1d3688dd37f6f$var$getFormEncType(form.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2cc1d3688dd37f6f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2cc1d3688dd37f6f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2cc1d3688dd37f6f$var$defaultMethod;
        action = null;
        encType = $2cc1d3688dd37f6f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2cc1d3688dd37f6f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $2cc1d3688dd37f6f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $2cc1d3688dd37f6f$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $2cc1d3688dd37f6f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2cc1d3688dd37f6f$var$_extends({}, state, {
        errors: $2cc1d3688dd37f6f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2cc1d3688dd37f6f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d09e32d367368ff7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $2cc1d3688dd37f6f$export$7ad602f0e94e62d1 = /*#__PURE__*/ $exYeM.createContext({
    isTransitioning: false
});
const $2cc1d3688dd37f6f$export$148fd98d095596d4 = /*#__PURE__*/ $exYeM.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2cc1d3688dd37f6f$var$START_TRANSITION = "startTransition";
const $2cc1d3688dd37f6f$var$startTransitionImpl = $exYeM[$2cc1d3688dd37f6f$var$START_TRANSITION];
const $2cc1d3688dd37f6f$var$FLUSH_SYNC = "flushSync";
const $2cc1d3688dd37f6f$var$flushSyncImpl = $97dc602bd7e23afa$exports[$2cc1d3688dd37f6f$var$FLUSH_SYNC];
function $2cc1d3688dd37f6f$var$startTransitionSafe(cb) {
    if ($2cc1d3688dd37f6f$var$startTransitionImpl) $2cc1d3688dd37f6f$var$startTransitionImpl(cb);
    else cb();
}
function $2cc1d3688dd37f6f$var$flushSyncSafe(cb) {
    if ($2cc1d3688dd37f6f$var$flushSyncImpl) $2cc1d3688dd37f6f$var$flushSyncImpl(cb);
    else cb();
}
class $2cc1d3688dd37f6f$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2cc1d3688dd37f6f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let [pendingState, setPendingState] = $exYeM.useState();
    let [vtContext, setVtContext] = $exYeM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $exYeM.useState();
    let [transition, setTransition] = $exYeM.useState();
    let [interruption, setInterruption] = $exYeM.useState();
    let fetcherData = $exYeM.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $exYeM.useCallback((cb)=>{
        if (v7_startTransition) $2cc1d3688dd37f6f$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $exYeM.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $exYeM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $2cc1d3688dd37f6f$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $exYeM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $2cc1d3688dd37f6f$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $b0e6fcd50b7ef685$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2cc1d3688dd37f6f$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2cc1d3688dd37f6f$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $2cc1d3688dd37f6f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $exYeM.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref7, $2cc1d3688dd37f6f$var$_excluded);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2cc1d3688dd37f6f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $b0e6fcd50b7ef685$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $2cc1d3688dd37f6f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $exYeM.createElement("a", $2cc1d3688dd37f6f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $exYeM.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref8, $2cc1d3688dd37f6f$var$_excluded2);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let routerState = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    let { navigator: navigator } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2cc1d3688dd37f6f$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a6c7ac8248d6e38a, $2cc1d3688dd37f6f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2cc1d3688dd37f6f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $exYeM.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2cc1d3688dd37f6f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref9, $2cc1d3688dd37f6f$var$_excluded3);
    let submit = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let formAction = $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $exYeM.createElement("form", $2cc1d3688dd37f6f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2cc1d3688dd37f6f$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $2cc1d3688dd37f6f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2cc1d3688dd37f6f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($2cc1d3688dd37f6f$var$DataRouterHook || ($2cc1d3688dd37f6f$var$DataRouterHook = {}));
var $2cc1d3688dd37f6f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2cc1d3688dd37f6f$var$DataRouterStateHook || ($2cc1d3688dd37f6f$var$DataRouterStateHook = {}));
// Internal hooks
function $2cc1d3688dd37f6f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2cc1d3688dd37f6f$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e));
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2cc1d3688dd37f6f$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2cc1d3688dd37f6f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d09e32d367368ff7$export$fe53371bee54353d)(location) === (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2cc1d3688dd37f6f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $exYeM.useRef($2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2cc1d3688dd37f6f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2cc1d3688dd37f6f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $2cc1d3688dd37f6f$var$fetcherId = 0;
let $2cc1d3688dd37f6f$var$getUniqueFetcherId = ()=>"__" + String(++$2cc1d3688dd37f6f$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2cc1d3688dd37f6f$export$47c85c6e3a081d3() {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let currentRouteId = (0, $b0e6fcd50b7ef685$export$5fc8298006ad9e58)();
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $2cc1d3688dd37f6f$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let routeContext = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !routeContext && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2cc1d3688dd37f6f$var$_extends({}, (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2cc1d3688dd37f6f$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseFetcher);
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $exYeM.useContext($2cc1d3688dd37f6f$export$148fd98d095596d4);
    let route = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $exYeM.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($2cc1d3688dd37f6f$var$getUniqueFetcherId());
    // Registration/cleanup
    $exYeM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $exYeM.useCallback((href, opts)=>{
        !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let submit = $exYeM.useCallback((target, opts)=>{
        submitImpl(target, $2cc1d3688dd37f6f$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $exYeM.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a7fed597f4b8afd8, $2cc1d3688dd37f6f$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $d09e32d367368ff7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>$2cc1d3688dd37f6f$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2cc1d3688dd37f6f$export$fa996778a3a31087() {
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $2cc1d3688dd37f6f$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2cc1d3688dd37f6f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2cc1d3688dd37f6f$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let matches = (0, $b0e6fcd50b7ef685$export$2378eb7f5ff86053)();
    let navigation = (0, $b0e6fcd50b7ef685$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2cc1d3688dd37f6f$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2cc1d3688dd37f6f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2cc1d3688dd37f6f$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2cc1d3688dd37f6f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2cc1d3688dd37f6f$var$_extends({}, location, {
                    pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2cc1d3688dd37f6f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2cc1d3688dd37f6f$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $b0e6fcd50b7ef685$export$b273b3273281a049)(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $2cc1d3688dd37f6f$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $exYeM.useContext($2cc1d3688dd37f6f$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.useViewTransitionState);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $d09e32d367368ff7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $d09e32d367368ff7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



/*
 * this API key is limited and
 * it is only for test purpose
 */ const $e3869297c16ce984$var$RANGO_PUBLIC_API_KEY = "c6381a79-2817-4602-83bf-6a641a409e32";
let $e3869297c16ce984$var$configs = {
    API_KEY: $e3869297c16ce984$var$RANGO_PUBLIC_API_KEY,
    BASE_URL: ""
};
function $e3869297c16ce984$export$44487a86467333c3(name) {
    return $e3869297c16ce984$var$configs[name];
}
function $e3869297c16ce984$export$940a7873bb071df8(name, value) {
    $e3869297c16ce984$var$configs[name] = value;
    return value;
}
function $e3869297c16ce984$export$b9b9cdb96b829919(nextConfigs) {
    $e3869297c16ce984$var$configs = nextConfigs;
    return $e3869297c16ce984$var$configs;
}


var $ab26e0b6754d430c$export$f01edf6b00a44c8a;
(function(SwapActionTypes) {
    SwapActionTypes["START"] = "START";
    SwapActionTypes["SCHEDULE_NEXT_STEP"] = "SCHEDULE_NEXT_STEP";
    SwapActionTypes["CREATE_TRANSACTION"] = "CREATE_TRANSACTION";
    SwapActionTypes["EXECUTE_TRANSACTION"] = "EXECUTE_TRANSACTION";
    SwapActionTypes["CHECK_TRANSACTION_STATUS"] = "CHECK_TRANSACTION_STATUS";
})($ab26e0b6754d430c$export$f01edf6b00a44c8a || ($ab26e0b6754d430c$export$f01edf6b00a44c8a = {}));
var $ab26e0b6754d430c$export$b022a9988c1688ba;
(function(BlockReason) {
    BlockReason["WAIT_FOR_CONNECT_WALLET"] = "waiting_for_connecting_wallet";
    BlockReason["WAIT_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    BlockReason["DEPENDS_ON_OTHER_QUEUES"] = "depends_on_other_queues";
})($ab26e0b6754d430c$export$b022a9988c1688ba || ($ab26e0b6754d430c$export$b022a9988c1688ba = {}));
var $ab26e0b6754d430c$export$54f5f69c1651567f;
(function(WidgetEvents) {
    WidgetEvents["RouteEvent"] = "routeEvent";
    WidgetEvents["StepEvent"] = "stepEvent";
})($ab26e0b6754d430c$export$54f5f69c1651567f || ($ab26e0b6754d430c$export$54f5f69c1651567f = {}));
var $ab26e0b6754d430c$export$543d0a6c7f452841;
(function(RouteEventType) {
    RouteEventType["STARTED"] = "started";
    RouteEventType["FAILED"] = "failed";
    RouteEventType["SUCCEEDED"] = "succeeded";
})($ab26e0b6754d430c$export$543d0a6c7f452841 || ($ab26e0b6754d430c$export$543d0a6c7f452841 = {}));
var $ab26e0b6754d430c$export$4a1a2e5c997cdbb1;
(function(StepExecutionEventStatus) {
    StepExecutionEventStatus["CREATE_TX"] = "create_tx";
    StepExecutionEventStatus["SEND_TX"] = "send_tx";
    StepExecutionEventStatus["TX_SENT"] = "tx_sent";
})($ab26e0b6754d430c$export$4a1a2e5c997cdbb1 || ($ab26e0b6754d430c$export$4a1a2e5c997cdbb1 = {}));
var $ab26e0b6754d430c$export$ee459e29d25d53b0;
(function(StepExecutionBlockedEventStatus) {
    StepExecutionBlockedEventStatus["WAITING_FOR_QUEUE"] = "waiting_for_queue";
    StepExecutionBlockedEventStatus["WAITING_FOR_WALLET_CONNECT"] = "waiting_for_wallet_connect";
    StepExecutionBlockedEventStatus["WAITING_FOR_NETWORK_CHANGE"] = "waiting_for_network_change";
    StepExecutionBlockedEventStatus["WAITING_FOR_CHANGE_WALLET_ACCOUNT"] = "waiting_for_change_wallet_account";
})($ab26e0b6754d430c$export$ee459e29d25d53b0 || ($ab26e0b6754d430c$export$ee459e29d25d53b0 = {}));
var $ab26e0b6754d430c$export$19ce097d7421ac9a;
(function(StepEventType) {
    StepEventType["STARTED"] = "started";
    StepEventType["FAILED"] = "failed";
    StepEventType["SUCCEEDED"] = "succeeded";
    StepEventType["TX_EXECUTION"] = "tx_execution";
    StepEventType["TX_EXECUTION_BLOCKED"] = "tx_execution_blocked";
    StepEventType["APPROVAL_TX_SUCCEEDED"] = "approval_tx_succeeded";
    StepEventType["CHECK_STATUS"] = "check_status";
    StepEventType["OUTPUT_REVEALED"] = "output_revealed";
})($ab26e0b6754d430c$export$19ce097d7421ac9a || ($ab26e0b6754d430c$export$19ce097d7421ac9a = {}));
var $ab26e0b6754d430c$export$ac89cc7182ae1ed0;
(function(EventSeverity) {
    EventSeverity["ERROR"] = "error";
    EventSeverity["SUCCESS"] = "success";
    EventSeverity["WARNING"] = "warning";
    EventSeverity["INFO"] = "info";
})($ab26e0b6754d430c$export$ac89cc7182ae1ed0 || ($ab26e0b6754d430c$export$ac89cc7182ae1ed0 = {}));


const $a9f720414a973cf5$export$bbfd8242d61c310 = "Waiting for other swaps to complete";
const $a9f720414a973cf5$export$d6102d677d637a6d = "Waiting for connecting wallet";
const $a9f720414a973cf5$export$f2aac43aeaf7ba5a = (type, address)=>`Please change your ${type || "wallet"} account to ${address || "proper address"}`;
const $a9f720414a973cf5$export$2f02fd340a90fed8 = (type)=>`Please connect your ${type ?? ""} wallet.`;
const $a9f720414a973cf5$export$721abf6846856403 = (network)=>`Please change your network to ${network}.`;
const $a9f720414a973cf5$export$c93d4c74989d686f = "CLIENT_UNEXPECTED_BEHAVIOUR";


/* eslint-disable destructuring/in-params */ /* eslint-disable @typescript-eslint/no-magic-numbers */ /* eslint-disable @typescript-eslint/no-floating-promises */ 
function $fb3be70fdf9902bf$export$2f9235b8134cbdd4(error) {
    return error instanceof Error;
}


function $2d0ef42914e3f734$export$9f30d106dee2fb21(level, message, data) {
    if (!(0, $fb3be70fdf9902bf$export$2f9235b8134cbdd4)(message)) throw new Error("Your error input should be an instance of Error.");
    const event = new CustomEvent((0, $9816b5f28105e113$export$3d7865934588d77e), {
        detail: {
            level: level,
            message: message,
            data: data
        }
    });
    if (!document) console.warn("document isn't available.");
    else document.dispatchEvent(event);
}
function $2d0ef42914e3f734$export$a3bc9b8ed74fc(message, data) {
    $2d0ef42914e3f734$export$9f30d106dee2fb21((0, $9816b5f28105e113$export$ca664994d1d54bff).Error, message, data);
}
function $2d0ef42914e3f734$export$c106dd0671a0fc2d(message, data) {
    $2d0ef42914e3f734$export$9f30d106dee2fb21((0, $9816b5f28105e113$export$ca664994d1d54bff).Warn, message, data);
}
function $2d0ef42914e3f734$export$a80b3bd66acc52ff(message, data) {
    $2d0ef42914e3f734$export$9f30d106dee2fb21((0, $9816b5f28105e113$export$ca664994d1d54bff).Info, message, data);
}
function $2d0ef42914e3f734$export$1c9f709888824e05(message, data) {
    $2d0ef42914e3f734$export$9f30d106dee2fb21((0, $9816b5f28105e113$export$ca664994d1d54bff).Debug, message, data);
}
function $2d0ef42914e3f734$export$357889f174732d38(message, data) {
    $2d0ef42914e3f734$export$9f30d106dee2fb21((0, $9816b5f28105e113$export$ca664994d1d54bff).Trace, message, data);
}




const $cb482a25fa64fd81$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cb482a25fa64fd81$export$2e2bcd8739ae039 = {
    randomUUID: $cb482a25fa64fd81$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a4faffbfed8ce8b6$var$getRandomValues;
const $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a4faffbfed8ce8b6$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a4faffbfed8ce8b6$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}


var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === "string" && (0, $f53d8abb4c91ec67$export$2e2bcd8739ae039).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $489cbfc69d38cb8e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$489cbfc69d38cb8e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + "-" + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]];
}
function $489cbfc69d38cb8e$var$stringify(arr, offset = 0) {
    const uuid = $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8e32bacb71dd477f$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;


function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    if ((0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $a4faffbfed8ce8b6$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $489cbfc69d38cb8e$export$8fb373d660548968)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;


const $04400e89df3d70a0$export$3c22ff8b64b8f565 = "queues-manager";
const $04400e89df3d70a0$var$OBJECT_STORE_NAME = "queues";
const $04400e89df3d70a0$var$VERSION = 1;

class $04400e89df3d70a0$var$Persistor {
    constructor(){
        this.db = (parcelRequire("5sB0y")).then(async (idb)=>{
            return idb.openDB($04400e89df3d70a0$export$3c22ff8b64b8f565, $04400e89df3d70a0$var$VERSION, {
                upgrade (db) {
                    db.createObjectStore($04400e89df3d70a0$var$OBJECT_STORE_NAME, {
                        keyPath: "id"
                    });
                }
            });
        }).catch(()=>{
            throw new Error("Couldn't load idb.");
        });
    }
    async insertQueue(queue) {
        const db = await this.db;
        const queueRecord = await db.get($04400e89df3d70a0$var$OBJECT_STORE_NAME, queue.id);
        if (queueRecord) ;
        else await db.add($04400e89df3d70a0$var$OBJECT_STORE_NAME, queue);
    }
    async updateQueue(id, queue) {
        const db = await this.db;
        const currentRecord = await db.get($04400e89df3d70a0$var$OBJECT_STORE_NAME, id);
        if (!currentRecord) return;
        const updatedRecord = {
            ...currentRecord,
            ...queue
        };
        await db.put($04400e89df3d70a0$var$OBJECT_STORE_NAME, updatedRecord);
    }
    async getAll() {
        const db = await this.db;
        const results = await db.getAll($04400e89df3d70a0$var$OBJECT_STORE_NAME);
        return results;
    }
    async deleteQueue(id) {
        const db = await this.db;
        const currentRecord = await db.get($04400e89df3d70a0$var$OBJECT_STORE_NAME, id);
        if (currentRecord) await db.delete($04400e89df3d70a0$var$OBJECT_STORE_NAME, id);
    }
}
var $04400e89df3d70a0$export$2e2bcd8739ae039 = $04400e89df3d70a0$var$Persistor;



var $099e91276c36ee90$export$96e9906d6d93a972;
(function(Status) {
    Status["PENDING"] = "PENDING";
    Status["RUNNING"] = "RUNNING";
    Status["FAILED"] = "FAILED";
    Status["SUCCESS"] = "SUCCESS";
    Status["CANCELED"] = "CANCELED";
    Status["BLOCKED"] = "BLOCKED";
})($099e91276c36ee90$export$96e9906d6d93a972 || ($099e91276c36ee90$export$96e9906d6d93a972 = {}));
const $099e91276c36ee90$export$638f14178e6e0c43 = 5000;


/**
 *
 * Notes on statuses:
 *  - Success: last task has success status
 *  - Failed: any of task has been failed
 *  - Running: first task is not on pending
 *  - Pending: default state. not started
 *
 */ class $4be5773fae5d2979$var$Queue {
    constructor(options){
        this.state = {
            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING,
            activeTaskIndex: 0,
            tasks: {}
        };
        this.tasks = [];
        this.storage = {};
        this.id = options.id;
        this.events = options.events;
        this.actions = options.actions;
    }
    /**
   * Update queue status and trigger an event
   *
   */ updateQueueStatus(status) {
        this.state.status = status;
        this.events.onUpdateListStatus(status);
    }
    updateActiveTaskIndex(index) {
        this.state.activeTaskIndex = index;
    }
    /**
   *
   * Update task state (`status`, `blockedFor`) and trigger an event.
   * @param id
   * @param nextState
   */ updateTaskState(id, nextState) {
        if (nextState.status) this.state.tasks[id].status = nextState.status;
        if (nextState.blockedFor) this.state.tasks[id].blockedFor = nextState.blockedFor;
        const updatedTaskEvent = {
            id: id,
            task: this.get(id),
            action: this.tasks.find((task)=>task.id === id).action
        };
        this.events.onUpdate(updatedTaskEvent);
    }
    /**
   * Create a task by providing an `action` name.
   *
   * this method creating the task, push it to the queue's tasks and trigger an event.
   * @param action
   */ createTask(action) {
        const id = (0, $d0666643e2ee88b4$export$2e2bcd8739ae039)();
        this.tasks.push({
            action: action,
            id: id
        });
        this.state.tasks[id] = {
            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING,
            blockedFor: null
        };
        const createdTask = this.get(id);
        this.events.onCreate({
            id: id,
            task: createdTask,
            action: action
        });
    }
    /**
   * Initilize a queue with some tasks, instead of an empty queue.
   *
   * Using it for recover the queue state from persistor.
   *
   */ initTasks(info) {
        this.state = info.state;
        this.storage = info.storage;
        info.tasks.forEach((task)=>{
            this.tasks.push(task);
            const action = this.tasks.find((t)=>t.id === task.id).action;
            this.events.onCreate({
                id: task.id,
                task: this.get(task.id),
                action: action
            });
        });
    }
    checkBlock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { task: task, state: state } = currentActiveTask;
        if (state.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) this.events.onBlock({
            action: task.action,
            id: task.id,
            reason: state.blockedFor
        });
    }
    /**
   * Getting task state by ID
   */ get(id) {
        const task = this.state.tasks[id];
        if (!task) return null;
        return task;
    }
    /**
   *
   * Checking if status of the last is `SUCCESS` or not
   *
   */ lastTaskIsSuccessful() {
        const lastTask = this.tasks[this.tasks.length - 1];
        // checking for empty lists.
        if (lastTask) {
            const lastTaskState = this.state.tasks[lastTask.id];
            // Maybe we didn't create the state yet. It should has success status as well.
            if (!!lastTaskState && lastTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS) return true;
        }
        return false;
    }
    /**
   * If the first task started (it's not PENDING),
   * it means the queue has been ran.
   *
   * @returns
   */ firstTaskIsStarted() {
        const firstTask = this.tasks[0];
        // checking for empty lists.
        if (firstTask) {
            const firstTaskState = this.state.tasks[firstTask.id];
            // Maybe we didn't create the state yet.
            if (!!firstTaskState) {
                if (firstTaskState.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING) return true;
            }
        }
        return false;
    }
    /**
   * Getting active task index from state and
   * returns the task and its state.
   *
   */ getActiveTask() {
        // First try to get task with `activeTask`
        const index = this.state.activeTaskIndex;
        const task = this.tasks[index];
        // Consider all the tasks has been executed.
        if (!task) return null;
        const state = this.state.tasks[task.id];
        return {
            task: task,
            state: state,
            index: index
        };
    }
    /**
   * Update and find the queue status by checking state of each tasks in the queue.
   */ check() {
        const currentListStatus = this.state.status;
        let nextListStatus = this.firstTaskIsStarted() ? (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING : (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING;
        if (this.lastTaskIsSuccessful()) nextListStatus = (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS;
        else // Is there any failed task?
        for (const task of this.tasks){
            const state = this.state.tasks[task.id];
            // If one item fails, we stop to work on the list.
            if (state.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED) {
                nextListStatus = (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED;
                break;
            }
        }
        // We only update and trigger an event when there is a new value
        if (nextListStatus !== currentListStatus) this.updateQueueStatus(nextListStatus);
    }
    /**
   * Execute active task.
   * Based on the state of active task, the behaviour is different. If status is:
   *  - Success -> we need to go to next task by updating the active index and try `next` on more time.
   *  - Failed, Running, or no active task -> doesn't do anything.
   *  - Pending or Blocked -> update the task and queue status to running, and execute the provided `action` for the task.
   *
   * The queue is a linked list somehow, active task means the pointer to where we are in the queue right now.
   *
   */ next(params) {
        this.check();
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) return;
        const { index: activeTaskIndex, task: activeTask, state: activeTaskState } = currentActiveTask;
        // if `activeTask` is already done, we will go for next one.
        if (activeTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS) {
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            this.next(params);
            return;
        }
        if ([
            (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED,
            (0, $099e91276c36ee90$export$96e9906d6d93a972).CANCELED,
            (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING
        ].includes(activeTaskState.status)) return;
        if (activeTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING || activeTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) {
            // Update task status to `running`
            this.updateTaskState(activeTask.id, {
                status: (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING
            });
            this.updateQueueStatus((0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING);
            // Try to execute task.
            const execute = this.actions[activeTask.action];
            execute({
                context: this.getContext(params),
                next: ()=>{
                    this.markCurrentTaskAsFinished(params);
                },
                retry: ()=>{
                    this.resume(params);
                },
                failed: ()=>{
                    this.updateTaskState(activeTask.id, {
                        status: (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED
                    });
                    this.check();
                },
                schedule: (action)=>{
                    this.createTask(action);
                    this.check();
                },
                getStorage: this.getStorage.bind(this),
                setStorage: this.setStorage.bind(this),
                block: (reason)=>{
                    this.block({
                        reason: reason
                    });
                },
                unblock: ()=>{
                    this.unblock();
                }
            });
        }
    }
    /**
   * Change the `status` of active task and queue to BLOCKED, then trigger an event.
   */ block({ reason: reason, silent: silent = false }) {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask) throw new Error("Task isn't exist.");
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED,
            blockedFor: reason
        });
        this.updateQueueStatus((0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED);
        if (!silent) this.events.onBlock({
            action: currentActiveTask.task.action,
            id: currentActiveTask.task.id,
            reason: reason
        });
    }
    /**
   * If the active task is `BLOCKED`, update the task status to `PENDING`, queue status to `RUNNING`
   * then trigger an event.
   */ unblock() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || currentActiveTask.state.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) throw new Error("Task is not blocked.");
        this.updateTaskState(currentActiveTask.task.id, {
            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING
        });
        this.updateQueueStatus((0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING);
        this.events.onUnblock({
            id: currentActiveTask.task.id
        });
    }
    /**
   * If the active task is `BLOCKED` then execute the `action` for the task.
   *
   * It is useful for when we need to run a blocked task without changing the status of task at the first place.
   * For scenarios like we have some conditions in `action` and needs to run the `action` again
   * to check the conditions are met or not, if yes, so we can proceed the `action`.
   *
   */ forceRun(params) {
        const currentTask = this.getActiveTask();
        if (!currentTask || currentTask.state.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) throw new Error("Task is not blocked.");
        // Try to execute task.
        const execute = this.actions[currentTask.task.action];
        execute({
            context: this.getContext(params),
            next: ()=>{
                /*
          NOTE:
            When running `forceRun`, the status of task can be `BLOCKED`
            So we need to change to `Running` first. 
        */ // Update task status to `running`
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING
                });
                this.updateQueueStatus((0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING);
                this.markCurrentTaskAsFinished(params);
            },
            retry: ()=>{
                this.resume(params);
            },
            failed: ()=>{
                this.updateTaskState(currentTask.task.id, {
                    status: (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED
                });
                this.check();
            },
            schedule: (action)=>{
                this.createTask(action);
                this.check();
            },
            getStorage: this.getStorage.bind(this),
            setStorage: this.setStorage.bind(this),
            block: (reason)=>{
                this.block({
                    reason: reason
                });
            },
            unblock: ()=>{
                this.unblock();
            }
        });
    }
    markCurrentTaskAsFinished(params) {
        this.check();
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS
            });
            this.updateActiveTaskIndex(activeTaskIndex + 1);
            const updatedTaskEvent = {
                id: activeTask.id,
                task: this.get(activeTask.id),
                action: this.tasks.find((task)=>task.id === activeTask.id).action
            };
            this.events.onUpdate(updatedTaskEvent);
            this.next(params);
        }
    }
    /**
   * If the active task is `RUNNING`, change it to `PENING` the try to run the task by calling `next`.
   * If it's other than `RUNNING` we reset the queue state and run the queue from the beggining.
   *
   * @param params
   * @returns
   */ resume(params) {
        const activeTaskIndex = this.state.activeTaskIndex;
        const activeTask = this.tasks[activeTaskIndex];
        if (!activeTask) return;
        const activeTaskState = this.state.tasks[activeTask.id];
        if (activeTaskState.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING) {
            this.updateTaskState(activeTask.id, {
                status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING
            });
            this.next(params);
        } else {
            this.resetState();
            this.next(params);
        }
    }
    /**
   *
   * Cancel the queue by changing active task and queue status to `CANCELED`.
   *
   */ cancel() {
        const currentActiveTask = this.getActiveTask();
        if (!currentActiveTask || [
            (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED,
            (0, $099e91276c36ee90$export$96e9906d6d93a972).CANCELED,
            (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS
        ].includes(currentActiveTask.state.status)) return;
        const { task: task } = currentActiveTask;
        // Update task status to `canceled`
        this.updateTaskState(task.id, {
            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).CANCELED
        });
        const updatedTaskEvent = {
            id: task.id,
            task: this.get(task.id),
            action: this.tasks.find((t)=>t.id === task.id).action
        };
        this.events.onUpdate(updatedTaskEvent);
        // Update queue status to `canceled`
        this.updateQueueStatus((0, $099e91276c36ee90$export$96e9906d6d93a972).CANCELED);
    }
    /**
   * Update queue status, and all the tasks inside queue to `PENDING`.
   */ resetState() {
        this.state.activeTaskIndex = 0;
        this.state.status = (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING;
        Object.keys(this.state.tasks).forEach((id)=>{
            this.state.tasks[id].status = (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING;
        });
    }
    getStorage() {
        return this.storage;
    }
    setStorage(data) {
        this.storage = data;
        this.events.onStorageUpdate(data);
        return this.storage;
    }
    getContext(params) {
        return {
            ...params.context,
            _queue: {
                id: this.id
            }
        };
    }
}
var $4be5773fae5d2979$export$2e2bcd8739ae039 = $4be5773fae5d2979$var$Queue;



class $5657a7d59f5376af$export$d0d38e7dec7a1a61 {
    /**
   *
   * Making an instance, initilize events, setup a persistor and try to recover the last state of the manager.
   *
   *
   */ constructor(options){
        this.queuesDefs = new Map();
        this.queues = new Map();
        this.isPaused = false;
        // The client won't get any update on pause, We are using a polling mode to fix this issue for now.
        this.syncInterval = null;
        const defaultEventHandlers = {
            onCreateQueue: ()=>{
            // ...
            },
            onCreateTask: ()=>{
            // ...
            },
            onUpdateQueue: ()=>{
            // ...
            },
            onUpdateTask: ()=>{
            // ...
            },
            onStorageUpdate: ()=>{
            // ...
            },
            onTaskBlock: ()=>{
            // ...
            },
            onPersistedDataLoaded: ()=>{
            // ..
            },
            onDeleteQueue: ()=>{
            // ...
            }
        };
        if (options.events) this.events = {
            ...defaultEventHandlers,
            ...options.events
        };
        else this.events = defaultEventHandlers;
        options.queuesDefs.map((qDef)=>{
            this.queuesDefs.set(qDef.name, qDef);
        });
        this.context = options.context || {};
        this.persistor = new (0, $04400e89df3d70a0$export$2e2bcd8739ae039)();
        this.sync();
        if (options.isPaused) this.pause();
    }
    // Create a new queue
    /**
   *
   * Create a new queue by client.
   *
   * It will do the internal things to make a queue from definitions, and running using Manager.
   *
   * Notes:
   *  - After creating the queue, it will be run automatically.
   *
   * @returns an ID for queue so it can be used to get the created queue later by client.
   *
   */ async create(name, storage, options) {
        if (!this.queuesDefs.has(name)) throw new Error("You need to add a queue definition first.");
        try {
            const def = this.queuesDefs.get(name);
            const queue_id = options?.id || (0, $d0666643e2ee88b4$export$2e2bcd8739ae039)();
            const createdAt = Date.now();
            const list = this.createQueue({
                queue_id: queue_id,
                queue_name: name
            });
            list.setStorage(storage);
            const createdQueue = this.add(queue_id, {
                list: list,
                createdAt: createdAt,
                name: name,
                status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING,
                actions: {
                    run: ()=>{
                        list.next({
                            context: this.getContext()
                        });
                    },
                    cancel: ()=>{
                        list.cancel();
                    },
                    setStorage: (...args)=>{
                        list.setStorage(...args);
                    },
                    getStorage: ()=>{
                        return list.getStorage();
                    }
                }
            });
            /*
       * Persist initial queue
       * Note: we need to first insert the queue, and then it can be updated by internal events.
       */ await this.persistor.insertQueue({
                id: queue_id,
                createdAt: createdAt,
                name: createdQueue.name,
                status: createdQueue.status,
                tasks: list.tasks,
                state: list.state,
                storage: list.getStorage()
            });
            // adding initial tasks
            def.run.forEach((action)=>{
                list.createTask(action);
            });
            // After creating a new queue, try to run.
            this.execute();
            return queue_id;
        } catch (e) {
            throw new Error(e?.message);
        }
    }
    /**
   *
   * Reading persisted data from storage then brings into memory.
   *
   * Notes:
   *  - Reset the memory, so we can call this method whenever we want and not only on the initialize process.
   *  - All the events will be tirggered (like onCreateQueue, onCreateTask, onBlock, ....)
   *  - Try to `resume` if the status is `running`.
   *  - Trigger `onPersistedDataLoaded` event when queues recovered from storage.
   *
   */ /**
   * Get a queue by its ID.
   *
   * @returns An object includes queue and its state in `Manager`.
   */ get(queue_id) {
        return this.queues.get(queue_id);
    }
    /**
   * Get all queues from `Manager`
   *
   * @returns a list of queues includes all the queues and their states.
   */ getAll() {
        return this.queues;
    }
    deleteQueue(queue_id) {
        this.queues.delete(queue_id);
        this.persistor.deleteQueue(queue_id);
    }
    async clearQueue() {
        // Identify queues that are not running
        this.queues.forEach((queue, queue_id)=>{
            if (queue.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING && queue.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING && queue.status !== (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) this.deleteQueue(queue_id);
        });
    }
    /**
   *
   * Ask from manager to run pending queues.
   *
   * It only try to run queues with `PENDING` status and ignore all the other statuses.
   *
   */ execute() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING) q.actions.run();
    }
    /**
   *
   * Try to find queues with `RUNNING` status to run them again.
   *
   * It's useful for recovering the queue at some certain points
   * like running a currepted task (reloaded when it was running) or needs manual trigger from UI.
   *
   * @returns
   */ resume() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING) {
            q.list.resume({
                context: this.getContext()
            });
            return;
        }
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run all `BLOCKED` queues once again.
   *
   * If a queue has `BLOCKED` status and the last task is `BLOCKED` as well,
   * The task will be run one more time.
   *
   * Useful for scenarios like we are blocking the queue under some conditions in task,
   * We can use this method to ask the queue to run the blocked task one more time and
   * maybe this time condtions are met and the queue can be proceed.
   *
   * @returns
   */ retry() {
        if (!this.shouldExecute()) return;
        for (const [, q] of Array.from(this.queues))if (q.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) q.list.checkBlock();
        // If there is no running queue, try to run a new queue.
        this.execute();
    }
    /**
   *
   * Run a blocked task on a specific queue with the ability to pass more data.
   *
   * Useful when we have a custom logic for running queue and needs to pass some specific data
   * to the task and try to run it manually with the provided data.
   *
   */ forceExecute(queue_id, data) {
        const queue = this.get(queue_id);
        let context = this.getContext();
        if (data) context = {
            ...context,
            ...data
        };
        queue?.list.forceRun({
            context: context
        });
    }
    /**
   * Active readonly mode for manager, it means it doesn't run anythin,
   * And only can be used to read the data.
   */ pause() {
        if (this.isPaused) return;
        this.isPaused = true;
        this.syncInterval = window.setInterval(()=>{
            this.sync();
        }, (0, $099e91276c36ee90$export$638f14178e6e0c43));
    }
    /**
   * Activate normal mode which means it will be able to run the queuese as well.
   */ run() {
        // If call this method multiple times, it should be run for once.
        if (this.isPaused) {
            this.isPaused = false;
            if (!!this.syncInterval) {
                clearInterval(this.syncInterval);
                this.syncInterval = null;
            }
            this.sync();
        }
    }
    async sync() {
        try {
            // Reading queues from storage
            const queues = await this.persistor.getAll();
            // Reset queues, if anything is exist in memory.
            this.queues = new Map();
            // Brings them into memory
            queues.forEach((q)=>{
                const list = this.createQueue({
                    queue_id: q.id,
                    queue_name: q.name
                });
                this.add(q.id, {
                    list: list,
                    createdAt: q.createdAt,
                    name: q.name,
                    status: q.status,
                    actions: {
                        run: ()=>{
                            list.next({
                                context: this.getContext()
                            });
                        },
                        cancel: ()=>{
                            list.cancel();
                        },
                        setStorage: (...args)=>{
                            list.setStorage(...args);
                        },
                        getStorage: ()=>{
                            return list.getStorage();
                        }
                    }
                });
                list.initTasks({
                    state: q.state,
                    tasks: q.tasks,
                    storage: q.storage || {}
                });
                if (q.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING && this.shouldExecute()) list.resume({
                    context: this.getContext()
                });
            });
        } catch (e) {
            console.log(`IndexDB Error: ${e}`);
        }
        // Trigger an event to let the subscribers we are done here.
        this.events.onPersistedDataLoaded(this);
    }
    /**
   *
   * Making a new instance from `Queue` and adds Manager's event handlers to it.
   *
   * @returns An instance of `Queue` with wrapped event handlers from Manager.
   *
   */ createQueue(info) {
        const { queue_id: queue_id, queue_name: queue_name } = info;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const def = this.queuesDefs.get(queue_name);
        const list = new (0, $4be5773fae5d2979$export$2e2bcd8739ae039)({
            id: queue_id,
            events: {
                onCreate: (task)=>{
                    this.events.onCreateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onCreate) def.events.onCreate(task);
                },
                onUpdate: (task)=>{
                    this.events.onUpdateTask(queue_id, task);
                    this.handleUpdate(queue_id);
                    if (def.events?.onUpdate) def.events.onUpdate(task);
                },
                onUpdateListStatus: (status)=>{
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: status
                    });
                    this.events.onUpdateQueue(queue_id, this.get(queue_id));
                    this.handleUpdate(queue_id);
                    // After finishing a queue, try to run other queues.
                    this.execute();
                    if (def.events?.onUpdateListStatus) def.events.onUpdateListStatus(status);
                },
                onStorageUpdate: (data)=>{
                    this.events.onStorageUpdate(queue_id, data);
                    if (def.events?.onStorageUpdate) def.events.onStorageUpdate(data);
                    this.handleUpdate(queue_id);
                },
                onBlock: (event)=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED
                    });
                    // Trigger event
                    this.events.onTaskBlock(queue_id);
                    if (def.whenTaskBlocked) def.whenTaskBlocked(event, {
                        queue_id: queue_id,
                        queue: list,
                        context: this.getContext(),
                        getBlockedTasks: this.getBlockedTasks.bind(this),
                        forceExecute: this.forceExecute.bind(this),
                        retry: this.retry.bind(this),
                        manager: manager
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                },
                onUnblock: ()=>{
                    // Update queue status
                    this.queues.set(queue_id, {
                        ...this.get(queue_id),
                        status: (0, $099e91276c36ee90$export$96e9906d6d93a972).PENDING
                    });
                    // Sync
                    this.handleUpdate(queue_id);
                    this.execute();
                }
            },
            actions: def.actions
        });
        return list;
    }
    /**
   * Go through all tasks (from all queues) and return a list of blocked tasks
   *
   * @returns a list of blocked tasks including enough information to get the queue and mutate the storage.
   *
   */ getBlockedTasks() {
        const queues = this.getAll();
        const blockedTasks = [];
        queues.forEach((q, queue_id)=>{
            q.list.tasks.forEach((task)=>{
                const state = q.list.state.tasks[task.id];
                if (state.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) blockedTasks.push({
                    task_id: task.id,
                    queue_id: queue_id,
                    action: task.action,
                    reason: state.blockedFor,
                    storage: {
                        get: ()=>{
                            return q.list.getStorage();
                        },
                        set: (data)=>{
                            return q.list.setStorage(data);
                        }
                    }
                });
            });
        });
        return blockedTasks;
    }
    /**
   *
   * Add a queue to the manager to keep track of the queue and its state.
   *
   * @param id
   * @param queue
   * @returns
   */ add(id, queue) {
        this.queues.set(id, queue);
        const createdQueue = this.get(id);
        this.events.onCreateQueue({
            ...createdQueue,
            id: id
        });
        return createdQueue;
    }
    /**
   *
   * Sync in-memory state (of `Manager`) with storage (persist).
   *
   * Usually we call this method after a change detected in the state of manager.
   *
   */ handleUpdate(queue_id) {
        const queue = this.get(queue_id);
        if (queue) {
            const status = queue.status;
            const state = queue.list.state;
            const tasks = queue.list.tasks;
            this.persistor.updateQueue(queue_id, {
                status: status,
                state: state,
                tasks: tasks,
                storage: queue.list.getStorage()
            });
        }
    }
    getContext() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return this.context?.current || {};
    }
    shouldExecute() {
        return !this.isPaused;
    }
}







var $8aS14 = parcelRequire("8aS14");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $bHRZL = parcelRequire("bHRZL");
var $7aYgM = parcelRequire("7aYgM");
var $bdf97a5d33000067$exports = {};
"use strict";

(function() {
    var buf, bufIdx = 0, hexBytes = [], i;
    // Pre-calculate toString(16) for speed
    for(i = 0; i < 256; i++)hexBytes[i] = (i + 0x100).toString(16).substr(1);
    // Buffer random numbers for speed
    // Reduce memory usage by decreasing this number (min 16)
    // or improve speed by increasing this number (try 16384)
    uuid.BUFFER_SIZE = 4096;
    // Binary uuids
    uuid.bin = uuidBin;
    // Clear buffer
    uuid.clearBuffer = function() {
        buf = null;
        bufIdx = 0;
    };
    // Test for uuid
    uuid.test = function(uuid) {
        if (typeof uuid === "string") return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
        return false;
    };
    // Node & Browser support
    var crypt0;
    if (typeof crypto !== "undefined") crypt0 = crypto;
    else if (typeof window !== "undefined" && typeof window.msCrypto !== "undefined") crypt0 = window.msCrypto; // IE11
    crypt0 = crypt0 || (parcelRequire("1wVs5"));
    $bdf97a5d33000067$exports = uuid;
    // Use best available PRNG
    // Also expose this so you can override it.
    uuid.randomBytes = function() {
        if (crypt0) {
            if (crypt0.randomBytes) return crypt0.randomBytes;
            if (crypt0.getRandomValues) {
                if (typeof Uint8Array.prototype.slice !== "function") return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return Array.from(bytes);
                };
                return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return bytes;
                };
            }
        }
        return function(n) {
            var i, r = [];
            for(i = 0; i < n; i++)r.push(Math.floor(Math.random() * 256));
            return r;
        };
    }();
    // Buffer some random bytes for speed
    function randomBytesBuffered(n) {
        if (!buf || bufIdx + n > uuid.BUFFER_SIZE) {
            bufIdx = 0;
            buf = uuid.randomBytes(uuid.BUFFER_SIZE);
        }
        return buf.slice(bufIdx, bufIdx += n);
    }
    // uuid.bin
    function uuidBin() {
        var b = randomBytesBuffered(16);
        b[6] = b[6] & 0x0f | 0x40;
        b[8] = b[8] & 0x3f | 0x80;
        return b;
    }
    // String UUIDv4 (Random)
    function uuid() {
        var b = uuidBin();
        return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + "-" + hexBytes[b[4]] + hexBytes[b[5]] + "-" + hexBytes[b[6]] + hexBytes[b[7]] + "-" + hexBytes[b[8]] + hexBytes[b[9]] + "-" + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
    }
})();


"use strict";
function $7f256a58ba1b04d5$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $6qd2L = parcelRequire("6qd2L");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $afbe88f4a41f80c6$var$toString } = Object.prototype;
const { getPrototypeOf: $afbe88f4a41f80c6$var$getPrototypeOf } = Object;
const $afbe88f4a41f80c6$var$kindOf = ((cache)=>(thing)=>{
        const str = $afbe88f4a41f80c6$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $afbe88f4a41f80c6$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$afbe88f4a41f80c6$var$kindOf(thing) === type;
};
const $afbe88f4a41f80c6$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $afbe88f4a41f80c6$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $afbe88f4a41f80c6$var$isUndefined = $afbe88f4a41f80c6$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $afbe88f4a41f80c6$var$isBuffer(val) {
    return val !== null && !$afbe88f4a41f80c6$var$isUndefined(val) && val.constructor !== null && !$afbe88f4a41f80c6$var$isUndefined(val.constructor) && $afbe88f4a41f80c6$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $afbe88f4a41f80c6$var$isArrayBuffer = $afbe88f4a41f80c6$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $afbe88f4a41f80c6$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $afbe88f4a41f80c6$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $afbe88f4a41f80c6$var$isString = $afbe88f4a41f80c6$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $afbe88f4a41f80c6$var$isFunction = $afbe88f4a41f80c6$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $afbe88f4a41f80c6$var$isNumber = $afbe88f4a41f80c6$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $afbe88f4a41f80c6$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $afbe88f4a41f80c6$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $afbe88f4a41f80c6$var$isPlainObject = (val)=>{
    if ($afbe88f4a41f80c6$var$kindOf(val) !== "object") return false;
    const prototype = $afbe88f4a41f80c6$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $afbe88f4a41f80c6$var$isDate = $afbe88f4a41f80c6$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $afbe88f4a41f80c6$var$isFile = $afbe88f4a41f80c6$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $afbe88f4a41f80c6$var$isBlob = $afbe88f4a41f80c6$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $afbe88f4a41f80c6$var$isFileList = $afbe88f4a41f80c6$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $afbe88f4a41f80c6$var$isStream = (val)=>$afbe88f4a41f80c6$var$isObject(val) && $afbe88f4a41f80c6$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $afbe88f4a41f80c6$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $afbe88f4a41f80c6$var$isFunction(thing.append) && ((kind = $afbe88f4a41f80c6$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $afbe88f4a41f80c6$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $afbe88f4a41f80c6$var$isURLSearchParams = $afbe88f4a41f80c6$var$kindOfTest("URLSearchParams");
const [$afbe88f4a41f80c6$var$isReadableStream, $afbe88f4a41f80c6$var$isRequest, $afbe88f4a41f80c6$var$isResponse, $afbe88f4a41f80c6$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($afbe88f4a41f80c6$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $afbe88f4a41f80c6$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $afbe88f4a41f80c6$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($afbe88f4a41f80c6$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $afbe88f4a41f80c6$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $afbe88f4a41f80c6$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $afbe88f4a41f80c6$var$isContextDefined = (context)=>!$afbe88f4a41f80c6$var$isUndefined(context) && context !== $afbe88f4a41f80c6$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $afbe88f4a41f80c6$var$merge() {
    const { caseless: caseless } = $afbe88f4a41f80c6$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $afbe88f4a41f80c6$var$findKey(result, key) || key;
        if ($afbe88f4a41f80c6$var$isPlainObject(result[targetKey]) && $afbe88f4a41f80c6$var$isPlainObject(val)) result[targetKey] = $afbe88f4a41f80c6$var$merge(result[targetKey], val);
        else if ($afbe88f4a41f80c6$var$isPlainObject(val)) result[targetKey] = $afbe88f4a41f80c6$var$merge({}, val);
        else if ($afbe88f4a41f80c6$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $afbe88f4a41f80c6$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $afbe88f4a41f80c6$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $afbe88f4a41f80c6$var$forEach(b, (val, key)=>{
        if (thisArg && $afbe88f4a41f80c6$var$isFunction(val)) a[key] = (0, $7f256a58ba1b04d5$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $afbe88f4a41f80c6$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $afbe88f4a41f80c6$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $afbe88f4a41f80c6$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $afbe88f4a41f80c6$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $afbe88f4a41f80c6$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $afbe88f4a41f80c6$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($afbe88f4a41f80c6$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$afbe88f4a41f80c6$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $afbe88f4a41f80c6$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $afbe88f4a41f80c6$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $afbe88f4a41f80c6$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $afbe88f4a41f80c6$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $afbe88f4a41f80c6$var$isHTMLForm = $afbe88f4a41f80c6$var$kindOfTest("HTMLFormElement");
const $afbe88f4a41f80c6$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $afbe88f4a41f80c6$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $afbe88f4a41f80c6$var$isRegExp = $afbe88f4a41f80c6$var$kindOfTest("RegExp");
const $afbe88f4a41f80c6$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $afbe88f4a41f80c6$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $afbe88f4a41f80c6$var$freezeMethods = (obj)=>{
    $afbe88f4a41f80c6$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($afbe88f4a41f80c6$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$afbe88f4a41f80c6$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $afbe88f4a41f80c6$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $afbe88f4a41f80c6$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $afbe88f4a41f80c6$var$noop = ()=>{};
const $afbe88f4a41f80c6$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $afbe88f4a41f80c6$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $afbe88f4a41f80c6$var$DIGIT = "0123456789";
const $afbe88f4a41f80c6$var$ALPHABET = {
    DIGIT: $afbe88f4a41f80c6$var$DIGIT,
    ALPHA: $afbe88f4a41f80c6$var$ALPHA,
    ALPHA_DIGIT: $afbe88f4a41f80c6$var$ALPHA + $afbe88f4a41f80c6$var$ALPHA.toUpperCase() + $afbe88f4a41f80c6$var$DIGIT
};
const $afbe88f4a41f80c6$var$generateString = (size = 16, alphabet = $afbe88f4a41f80c6$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $afbe88f4a41f80c6$var$isSpecCompliantForm(thing) {
    return !!(thing && $afbe88f4a41f80c6$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $afbe88f4a41f80c6$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($afbe88f4a41f80c6$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $afbe88f4a41f80c6$var$isArray(source) ? [] : {};
                $afbe88f4a41f80c6$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$afbe88f4a41f80c6$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $afbe88f4a41f80c6$var$isAsyncFn = $afbe88f4a41f80c6$var$kindOfTest("AsyncFunction");
const $afbe88f4a41f80c6$var$isThenable = (thing)=>thing && ($afbe88f4a41f80c6$var$isObject(thing) || $afbe88f4a41f80c6$var$isFunction(thing)) && $afbe88f4a41f80c6$var$isFunction(thing.then) && $afbe88f4a41f80c6$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $afbe88f4a41f80c6$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $afbe88f4a41f80c6$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $afbe88f4a41f80c6$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $afbe88f4a41f80c6$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $afbe88f4a41f80c6$var$isFunction($afbe88f4a41f80c6$var$_global.postMessage));
const $afbe88f4a41f80c6$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($afbe88f4a41f80c6$var$_global) : typeof $6qd2L !== "undefined" && $6qd2L.nextTick || $afbe88f4a41f80c6$var$_setImmediate;
var // *********************
$afbe88f4a41f80c6$export$2e2bcd8739ae039 = {
    isArray: $afbe88f4a41f80c6$var$isArray,
    isArrayBuffer: $afbe88f4a41f80c6$var$isArrayBuffer,
    isBuffer: $afbe88f4a41f80c6$var$isBuffer,
    isFormData: $afbe88f4a41f80c6$var$isFormData,
    isArrayBufferView: $afbe88f4a41f80c6$var$isArrayBufferView,
    isString: $afbe88f4a41f80c6$var$isString,
    isNumber: $afbe88f4a41f80c6$var$isNumber,
    isBoolean: $afbe88f4a41f80c6$var$isBoolean,
    isObject: $afbe88f4a41f80c6$var$isObject,
    isPlainObject: $afbe88f4a41f80c6$var$isPlainObject,
    isReadableStream: $afbe88f4a41f80c6$var$isReadableStream,
    isRequest: $afbe88f4a41f80c6$var$isRequest,
    isResponse: $afbe88f4a41f80c6$var$isResponse,
    isHeaders: $afbe88f4a41f80c6$var$isHeaders,
    isUndefined: $afbe88f4a41f80c6$var$isUndefined,
    isDate: $afbe88f4a41f80c6$var$isDate,
    isFile: $afbe88f4a41f80c6$var$isFile,
    isBlob: $afbe88f4a41f80c6$var$isBlob,
    isRegExp: $afbe88f4a41f80c6$var$isRegExp,
    isFunction: $afbe88f4a41f80c6$var$isFunction,
    isStream: $afbe88f4a41f80c6$var$isStream,
    isURLSearchParams: $afbe88f4a41f80c6$var$isURLSearchParams,
    isTypedArray: $afbe88f4a41f80c6$var$isTypedArray,
    isFileList: $afbe88f4a41f80c6$var$isFileList,
    forEach: $afbe88f4a41f80c6$var$forEach,
    merge: $afbe88f4a41f80c6$var$merge,
    extend: $afbe88f4a41f80c6$var$extend,
    trim: $afbe88f4a41f80c6$var$trim,
    stripBOM: $afbe88f4a41f80c6$var$stripBOM,
    inherits: $afbe88f4a41f80c6$var$inherits,
    toFlatObject: $afbe88f4a41f80c6$var$toFlatObject,
    kindOf: $afbe88f4a41f80c6$var$kindOf,
    kindOfTest: $afbe88f4a41f80c6$var$kindOfTest,
    endsWith: $afbe88f4a41f80c6$var$endsWith,
    toArray: $afbe88f4a41f80c6$var$toArray,
    forEachEntry: $afbe88f4a41f80c6$var$forEachEntry,
    matchAll: $afbe88f4a41f80c6$var$matchAll,
    isHTMLForm: $afbe88f4a41f80c6$var$isHTMLForm,
    hasOwnProperty: $afbe88f4a41f80c6$var$hasOwnProperty,
    hasOwnProp: $afbe88f4a41f80c6$var$hasOwnProperty,
    reduceDescriptors: $afbe88f4a41f80c6$var$reduceDescriptors,
    freezeMethods: $afbe88f4a41f80c6$var$freezeMethods,
    toObjectSet: $afbe88f4a41f80c6$var$toObjectSet,
    toCamelCase: $afbe88f4a41f80c6$var$toCamelCase,
    noop: $afbe88f4a41f80c6$var$noop,
    toFiniteNumber: $afbe88f4a41f80c6$var$toFiniteNumber,
    findKey: $afbe88f4a41f80c6$var$findKey,
    global: $afbe88f4a41f80c6$var$_global,
    isContextDefined: $afbe88f4a41f80c6$var$isContextDefined,
    ALPHABET: $afbe88f4a41f80c6$var$ALPHABET,
    generateString: $afbe88f4a41f80c6$var$generateString,
    isSpecCompliantForm: $afbe88f4a41f80c6$var$isSpecCompliantForm,
    toJSONObject: $afbe88f4a41f80c6$var$toJSONObject,
    isAsyncFn: $afbe88f4a41f80c6$var$isAsyncFn,
    isThenable: $afbe88f4a41f80c6$var$isThenable,
    setImmediate: $afbe88f4a41f80c6$var$_setImmediate,
    asap: $afbe88f4a41f80c6$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $cff8687cfa13e748$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).inherits($cff8687cfa13e748$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $cff8687cfa13e748$var$prototype = $cff8687cfa13e748$var$AxiosError.prototype;
const $cff8687cfa13e748$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $cff8687cfa13e748$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($cff8687cfa13e748$var$AxiosError, $cff8687cfa13e748$var$descriptors);
Object.defineProperty($cff8687cfa13e748$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$cff8687cfa13e748$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($cff8687cfa13e748$var$prototype);
    (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $cff8687cfa13e748$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $cff8687cfa13e748$export$2e2bcd8739ae039 = $cff8687cfa13e748$var$AxiosError;


// eslint-disable-next-line strict
var $b35c572f22f11229$export$2e2bcd8739ae039 = null;



var $3aNd6 = parcelRequire("3aNd6");
var $fb6666fbd2dfc1b9$require$Buffer = $3aNd6.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fb6666fbd2dfc1b9$var$isVisitable(thing) {
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fb6666fbd2dfc1b9$var$removeBrackets(key) {
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fb6666fbd2dfc1b9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fb6666fbd2dfc1b9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fb6666fbd2dfc1b9$var$isFlatArray(arr) {
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fb6666fbd2dfc1b9$var$isVisitable);
}
const $fb6666fbd2dfc1b9$var$predicates = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toFlatObject((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fb6666fbd2dfc1b9$var$toFormData(obj, formData, options) {
    if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $b35c572f22f11229$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fb6666fbd2dfc1b9$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(value) && $fb6666fbd2dfc1b9$var$isFlatArray(value) || ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFileList(value) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fb6666fbd2dfc1b9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fb6666fbd2dfc1b9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fb6666fbd2dfc1b9$var$isVisitable(value)) return true;
        formData.append($fb6666fbd2dfc1b9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fb6666fbd2dfc1b9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fb6666fbd2dfc1b9$var$isVisitable
    });
    function build(value, path) {
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fb6666fbd2dfc1b9$export$2e2bcd8739ae039 = $fb6666fbd2dfc1b9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $539a9a4fdf246321$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $539a9a4fdf246321$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fb6666fbd2dfc1b9$export$2e2bcd8739ae039)(params, this, options);
}
const $539a9a4fdf246321$var$prototype = $539a9a4fdf246321$var$AxiosURLSearchParams.prototype;
$539a9a4fdf246321$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$539a9a4fdf246321$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $539a9a4fdf246321$var$encode);
    } : $539a9a4fdf246321$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $539a9a4fdf246321$export$2e2bcd8739ae039 = $539a9a4fdf246321$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db3d06bca11cd690$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db3d06bca11cd690$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db3d06bca11cd690$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $539a9a4fdf246321$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $1c6a045d750b6f68$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $1c6a045d750b6f68$export$2e2bcd8739ae039 = $1c6a045d750b6f68$var$InterceptorManager;





"use strict";
var $505f21a8a1bce65d$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $24e38bb64c77a457$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $539a9a4fdf246321$export$2e2bcd8739ae039);


"use strict";
var $3820018d0525645a$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e29767404bfce47$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $8a5ba0ec0ddcb6ee$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $24e38bb64c77a457$export$2e2bcd8739ae039,
        FormData: $3820018d0525645a$export$2e2bcd8739ae039,
        Blob: $2e29767404bfce47$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $c6e8c07ba4ccfb9d$exports = {};

$parcel$export($c6e8c07ba4ccfb9d$exports, "hasBrowserEnv", function () { return $c6e8c07ba4ccfb9d$export$c4996c4b7b93b0bf; });
$parcel$export($c6e8c07ba4ccfb9d$exports, "navigator", function () { return $c6e8c07ba4ccfb9d$export$ec7c8efa7f5790ae; });
$parcel$export($c6e8c07ba4ccfb9d$exports, "hasStandardBrowserEnv", function () { return $c6e8c07ba4ccfb9d$export$c0bcc9250309d66; });
$parcel$export($c6e8c07ba4ccfb9d$exports, "hasStandardBrowserWebWorkerEnv", function () { return $c6e8c07ba4ccfb9d$export$c81692cf5af97dac; });
$parcel$export($c6e8c07ba4ccfb9d$exports, "origin", function () { return $c6e8c07ba4ccfb9d$export$f710a83a91838a36; });
const $c6e8c07ba4ccfb9d$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $c6e8c07ba4ccfb9d$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $c6e8c07ba4ccfb9d$export$c0bcc9250309d66 = $c6e8c07ba4ccfb9d$export$c4996c4b7b93b0bf && (!$c6e8c07ba4ccfb9d$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($c6e8c07ba4ccfb9d$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $c6e8c07ba4ccfb9d$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $c6e8c07ba4ccfb9d$export$f710a83a91838a36 = $c6e8c07ba4ccfb9d$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $a0f5f22b68ca9d6d$export$2e2bcd8739ae039 = {
    ...$c6e8c07ba4ccfb9d$exports,
    ...(0, $8a5ba0ec0ddcb6ee$export$2e2bcd8739ae039)
};


"use strict";
function $84faa18a26337de0$export$2e2bcd8739ae039(data, options) {
    return (0, $fb6666fbd2dfc1b9$export$2e2bcd8739ae039)(data, new (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).isNode && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $96f20c20e1e284bd$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $96f20c20e1e284bd$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $96f20c20e1e284bd$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $96f20c20e1e284bd$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFormData(formData) && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($96f20c20e1e284bd$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $96f20c20e1e284bd$export$2e2bcd8739ae039 = $96f20c20e1e284bd$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $979b7b1af9746a71$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $979b7b1af9746a71$var$defaults = {
    transitional: (0, $505f21a8a1bce65d$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $96f20c20e1e284bd$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isBuffer(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isStream(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFile(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isBlob(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $84faa18a26337de0$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fb6666fbd2dfc1b9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $979b7b1af9746a71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $979b7b1af9746a71$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isResponse(data) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $cff8687cfa13e748$export$2e2bcd8739ae039).from(e, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $979b7b1af9746a71$var$defaults.headers[method] = {};
});
var $979b7b1af9746a71$export$2e2bcd8739ae039 = $979b7b1af9746a71$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b78c10e7f2bd65ee$var$ignoreDuplicateOf = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b78c10e7f2bd65ee$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b78c10e7f2bd65ee$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $02461c6569ba1414$var$$internals = Symbol("internals");
function $02461c6569ba1414$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $02461c6569ba1414$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(value) ? value.map($02461c6569ba1414$var$normalizeValue) : String(value);
}
function $02461c6569ba1414$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $02461c6569ba1414$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $02461c6569ba1414$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $02461c6569ba1414$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $02461c6569ba1414$var$buildAccessors(obj, header) {
    const accessorName = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $02461c6569ba1414$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $02461c6569ba1414$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $02461c6569ba1414$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$02461c6569ba1414$var$isValidHeaderName(header)) setHeaders((0, $b78c10e7f2bd65ee$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $02461c6569ba1414$var$normalizeHeader(header);
        if (header) {
            const key = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $02461c6569ba1414$var$parseTokens(value);
                if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $02461c6569ba1414$var$normalizeHeader(header);
        if (header) {
            const key = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $02461c6569ba1414$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $02461c6569ba1414$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $02461c6569ba1414$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $02461c6569ba1414$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $02461c6569ba1414$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $02461c6569ba1414$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $02461c6569ba1414$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$02461c6569ba1414$var$$internals] = this[$02461c6569ba1414$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $02461c6569ba1414$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $02461c6569ba1414$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$02461c6569ba1414$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).reduceDescriptors($02461c6569ba1414$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).freezeMethods($02461c6569ba1414$var$AxiosHeaders);
var $02461c6569ba1414$export$2e2bcd8739ae039 = $02461c6569ba1414$var$AxiosHeaders;


"use strict";
function $c9b39f20de814beb$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $979b7b1af9746a71$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $7658f31487095a40$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $c76f0e7c9706d078$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $cff8687cfa13e748$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).inherits($c76f0e7c9706d078$var$CanceledError, (0, $cff8687cfa13e748$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $c76f0e7c9706d078$export$2e2bcd8739ae039 = $c76f0e7c9706d078$var$CanceledError;







"use strict";
function $5670288a91068c60$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $3f906e4b5ec3c504$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a6e20fbe74d0d458$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a6e20fbe74d0d458$export$2e2bcd8739ae039 = $a6e20fbe74d0d458$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2d794f8debaba053$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2d794f8debaba053$export$2e2bcd8739ae039 = $2d794f8debaba053$var$throttle;



const $cd1b9c5bced6dff3$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $a6e20fbe74d0d458$export$2e2bcd8739ae039)(50, 250);
    return (0, $2d794f8debaba053$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $cd1b9c5bced6dff3$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $cd1b9c5bced6dff3$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).asap(()=>fn(...args));






"use strict";
var $9d5f45416b7485c9$export$2e2bcd8739ae039 = (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $ac01a933b32bd725$export$2e2bcd8739ae039 = (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $ae23f8510c95b4f1$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $dc5d448ba41d0b01$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $234daf6b836e0927$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ae23f8510c95b4f1$export$2e2bcd8739ae039)(requestedURL)) return (0, $dc5d448ba41d0b01$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $825eeb8bb2b82d0b$var$headersToObject = (thing)=>thing instanceof (0, $02461c6569ba1414$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $825eeb8bb2b82d0b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isPlainObject(target) && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($825eeb8bb2b82d0b$var$headersToObject(a), $825eeb8bb2b82d0b$var$headersToObject(b), true)
    };
    (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $3a14d64778cec0af$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db3d06bca11cd690$export$2e2bcd8739ae039)((0, $234daf6b836e0927$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $9d5f45416b7485c9$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $ac01a933b32bd725$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $0b5e0e40c8a534ad$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $0b5e0e40c8a534ad$export$2e2bcd8739ae039 = $0b5e0e40c8a534ad$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $3a14d64778cec0af$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5670288a91068c60$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Request aborted", (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Network Error", (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $505f21a8a1bce65d$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ETIMEDOUT : (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $cd1b9c5bced6dff3$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $cd1b9c5bced6dff3$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c76f0e7c9706d078$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $3f906e4b5ec3c504$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $17343b57ecaef8d5$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $cff8687cfa13e748$export$2e2bcd8739ae039) ? err : new (0, $c76f0e7c9706d078$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $17343b57ecaef8d5$export$2e2bcd8739ae039 = $17343b57ecaef8d5$var$composeSignals;


const $f0fd4c68fd33dde1$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $f0fd4c68fd33dde1$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $f0fd4c68fd33dde1$var$readStream(iterable))yield* $f0fd4c68fd33dde1$export$71b051935044bd5d(chunk, chunkSize);
};
const $f0fd4c68fd33dde1$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $f0fd4c68fd33dde1$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $f0fd4c68fd33dde1$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $04e40c92c2a05612$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $04e40c92c2a05612$var$isReadableStreamSupported = $04e40c92c2a05612$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $04e40c92c2a05612$var$encodeText = $04e40c92c2a05612$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $04e40c92c2a05612$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $04e40c92c2a05612$var$supportsRequestStream = $04e40c92c2a05612$var$isReadableStreamSupported && $04e40c92c2a05612$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $04e40c92c2a05612$var$DEFAULT_CHUNK_SIZE = 65536;
const $04e40c92c2a05612$var$supportsResponseStream = $04e40c92c2a05612$var$isReadableStreamSupported && $04e40c92c2a05612$var$test(()=>(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $04e40c92c2a05612$var$resolvers = {
    stream: $04e40c92c2a05612$var$supportsResponseStream && ((res)=>res.body)
};
$04e40c92c2a05612$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$04e40c92c2a05612$var$resolvers[type] && ($04e40c92c2a05612$var$resolvers[type] = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $04e40c92c2a05612$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $a0f5f22b68ca9d6d$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(body)) return (await $04e40c92c2a05612$var$encodeText(body)).byteLength;
};
const $04e40c92c2a05612$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $04e40c92c2a05612$var$getBodyLength(body) : length;
};
var $04e40c92c2a05612$export$2e2bcd8739ae039 = $04e40c92c2a05612$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $3a14d64778cec0af$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $17343b57ecaef8d5$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $04e40c92c2a05612$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $04e40c92c2a05612$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $cd1b9c5bced6dff3$export$d9fadd12586c18d6)(requestContentLength, (0, $cd1b9c5bced6dff3$export$c1b28109d46c3592)((0, $cd1b9c5bced6dff3$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $f0fd4c68fd33dde1$export$b0119225647bd83)(_request.body, $04e40c92c2a05612$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $04e40c92c2a05612$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($04e40c92c2a05612$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $cd1b9c5bced6dff3$export$d9fadd12586c18d6)(responseContentLength, (0, $cd1b9c5bced6dff3$export$c1b28109d46c3592)((0, $cd1b9c5bced6dff3$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $f0fd4c68fd33dde1$export$b0119225647bd83)(response.body, $04e40c92c2a05612$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $04e40c92c2a05612$var$resolvers[(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).findKey($04e40c92c2a05612$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $5670288a91068c60$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Network Error", (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $cff8687cfa13e748$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $33360ce181df52db$var$knownAdapters = {
    http: (0, $b35c572f22f11229$export$2e2bcd8739ae039),
    xhr: (0, $0b5e0e40c8a534ad$export$2e2bcd8739ae039),
    fetch: (0, $04e40c92c2a05612$export$2e2bcd8739ae039)
};
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach($33360ce181df52db$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $33360ce181df52db$var$renderReason = (reason)=>`- ${reason}`;
const $33360ce181df52db$var$isResolvedHandle = (adapter)=>(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $33360ce181df52db$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$33360ce181df52db$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $33360ce181df52db$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($33360ce181df52db$var$renderReason).join("\n") : " " + $33360ce181df52db$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $33360ce181df52db$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $e8e5a1cf0540d05d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c76f0e7c9706d078$export$2e2bcd8739ae039)(null, config);
}
function $e8e5a1cf0540d05d$export$2e2bcd8739ae039(config) {
    $e8e5a1cf0540d05d$var$throwIfCancellationRequested(config);
    config.headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $c9b39f20de814beb$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $33360ce181df52db$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $979b7b1af9746a71$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $e8e5a1cf0540d05d$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $c9b39f20de814beb$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7658f31487095a40$export$2e2bcd8739ae039)(reason)) {
            $e8e5a1cf0540d05d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $c9b39f20de814beb$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $79e58d7062b8d21e$export$a4ad2735b021c132 = "1.7.7";



"use strict";
const $137eb5e53f562cab$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $137eb5e53f562cab$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $137eb5e53f562cab$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $137eb5e53f562cab$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $79e58d7062b8d21e$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$137eb5e53f562cab$var$deprecatedWarnings[opt]) {
            $137eb5e53f562cab$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $137eb5e53f562cab$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("options must be an object", (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $cff8687cfa13e748$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $cff8687cfa13e748$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $137eb5e53f562cab$export$2e2bcd8739ae039 = {
    assertOptions: $137eb5e53f562cab$var$assertOptions,
    validators: $137eb5e53f562cab$var$validators
};



"use strict";
const $c5f39b220e6bab5e$var$validators = (0, $137eb5e53f562cab$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $c5f39b220e6bab5e$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $1c6a045d750b6f68$export$2e2bcd8739ae039)(),
            response: new (0, $1c6a045d750b6f68$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $137eb5e53f562cab$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $c5f39b220e6bab5e$var$validators.transitional($c5f39b220e6bab5e$var$validators.boolean),
            forcedJSONParsing: $c5f39b220e6bab5e$var$validators.transitional($c5f39b220e6bab5e$var$validators.boolean),
            clarifyTimeoutError: $c5f39b220e6bab5e$var$validators.transitional($c5f39b220e6bab5e$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $137eb5e53f562cab$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $c5f39b220e6bab5e$var$validators.function,
                serialize: $c5f39b220e6bab5e$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $02461c6569ba1414$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $e8e5a1cf0540d05d$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $e8e5a1cf0540d05d$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $234daf6b836e0927$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $db3d06bca11cd690$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $c5f39b220e6bab5e$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $c5f39b220e6bab5e$var$Axios.prototype[method] = generateHTTPMethod();
    $c5f39b220e6bab5e$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $c5f39b220e6bab5e$export$2e2bcd8739ae039 = $c5f39b220e6bab5e$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fdaa16ceaf49b7b6$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c76f0e7c9706d078$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fdaa16ceaf49b7b6$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fdaa16ceaf49b7b6$export$2e2bcd8739ae039 = $fdaa16ceaf49b7b6$var$CancelToken;






"use strict";
function $c3082149235d5853$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $f16e4b60ed97f2ad$export$2e2bcd8739ae039(payload) {
    return (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $55769d0049793057$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($55769d0049793057$var$HttpStatusCode).forEach(([key, value])=>{
    $55769d0049793057$var$HttpStatusCode[value] = key;
});
var $55769d0049793057$export$2e2bcd8739ae039 = $55769d0049793057$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $648a84af85b616e7$var$createInstance(defaultConfig) {
    const context = new (0, $c5f39b220e6bab5e$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $7f256a58ba1b04d5$export$2e2bcd8739ae039)((0, $c5f39b220e6bab5e$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).extend(instance, (0, $c5f39b220e6bab5e$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $648a84af85b616e7$var$createInstance((0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $648a84af85b616e7$var$axios = $648a84af85b616e7$var$createInstance((0, $979b7b1af9746a71$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$648a84af85b616e7$var$axios.Axios = (0, $c5f39b220e6bab5e$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$648a84af85b616e7$var$axios.CanceledError = (0, $c76f0e7c9706d078$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.CancelToken = (0, $fdaa16ceaf49b7b6$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.isCancel = (0, $7658f31487095a40$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.VERSION = (0, $79e58d7062b8d21e$export$a4ad2735b021c132);
$648a84af85b616e7$var$axios.toFormData = (0, $fb6666fbd2dfc1b9$export$2e2bcd8739ae039);
// Expose AxiosError class
$648a84af85b616e7$var$axios.AxiosError = (0, $cff8687cfa13e748$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$648a84af85b616e7$var$axios.Cancel = $648a84af85b616e7$var$axios.CanceledError;
// Expose all/spread
$648a84af85b616e7$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$648a84af85b616e7$var$axios.spread = (0, $c3082149235d5853$export$2e2bcd8739ae039);
// Expose isAxiosError
$648a84af85b616e7$var$axios.isAxiosError = (0, $f16e4b60ed97f2ad$export$2e2bcd8739ae039);
// Expose mergeConfig
$648a84af85b616e7$var$axios.mergeConfig = (0, $825eeb8bb2b82d0b$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.AxiosHeaders = (0, $02461c6569ba1414$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.formToJSON = (thing)=>(0, $96f20c20e1e284bd$export$2e2bcd8739ae039)((0, $afbe88f4a41f80c6$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$648a84af85b616e7$var$axios.getAdapter = (0, $33360ce181df52db$export$2e2bcd8739ae039).getAdapter;
$648a84af85b616e7$var$axios.HttpStatusCode = (0, $55769d0049793057$export$2e2bcd8739ae039);
$648a84af85b616e7$var$axios.default = $648a84af85b616e7$var$axios;
var // this module should only have a default export
$648a84af85b616e7$export$2e2bcd8739ae039 = $648a84af85b616e7$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c329a6aeb7a206f0$export$1c00760e9e5a4e95, AxiosError: $c329a6aeb7a206f0$export$c1fbed17c2f6a328, CanceledError: $c329a6aeb7a206f0$export$1ab0c6b20d94fa14, isCancel: $c329a6aeb7a206f0$export$3b22524397b493c6, CancelToken: $c329a6aeb7a206f0$export$fd08e3cb425f0d61, VERSION: $c329a6aeb7a206f0$export$a4ad2735b021c132, all: $c329a6aeb7a206f0$export$84bf76cd7afc7469, Cancel: $c329a6aeb7a206f0$export$848c9b7ead0df967, isAxiosError: $c329a6aeb7a206f0$export$fbafdbe06a5b5a9a, spread: $c329a6aeb7a206f0$export$3ae0fd4797ed47c8, toFormData: $c329a6aeb7a206f0$export$10ae0d317ea97f8b, AxiosHeaders: $c329a6aeb7a206f0$export$4e7d6ff0f3e6520, HttpStatusCode: $c329a6aeb7a206f0$export$a972f69c851492b3, formToJSON: $c329a6aeb7a206f0$export$86d7c59254d6a2c9, getAdapter: $c329a6aeb7a206f0$export$17ddc20a97d669e2, mergeConfig: $c329a6aeb7a206f0$export$7ec1ebcfa9d8bd6a } = (0, $648a84af85b616e7$export$2e2bcd8739ae039);


function $e0809f1f0dfba620$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $e0809f1f0dfba620$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $e0809f1f0dfba620$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $e0809f1f0dfba620$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function $e0809f1f0dfba620$var$_extends() {
    return $e0809f1f0dfba620$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e0809f1f0dfba620$var$_extends.apply(null, arguments);
}
function $e0809f1f0dfba620$var$_regeneratorRuntime() {
    $e0809f1f0dfba620$var$_regeneratorRuntime = function() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(typeof e + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
var $e0809f1f0dfba620$export$2eb9c0bd2d5b9cf8 = /*#__PURE__*/ function() {
    function RangoClient(apiKey, apiUrl) {
        this.apiUrl = apiUrl || "https://api.rango.exchange";
        this.apiKey = apiKey;
        try {
            if (typeof window !== "undefined") {
                var deviceId = localStorage.getItem("deviceId");
                if (deviceId) this.deviceId = deviceId;
                else {
                    var generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($bdf97a5d33000067$exports)))();
                    localStorage.setItem("deviceId", generatedId);
                    this.deviceId = generatedId;
                }
            } else this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($bdf97a5d33000067$exports)))();
        } catch (e) {
            this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($bdf97a5d33000067$exports)))();
        }
        this.httpService = (0, $648a84af85b616e7$export$2e2bcd8739ae039).create({
            baseURL: this.apiUrl
        });
    }
    var _proto = RangoClient.prototype;
    _proto.getAllMetadata = /*#__PURE__*/ function() {
        var _getAllMetadata = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee(metaRequest, options) {
            var _metaRequest$blockcha, _metaRequest$swappers, _metaRequest$swappers2, _metaRequest$transact;
            var params, axiosResponse, reformatTokens, tokens, popularTokens;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        params = $e0809f1f0dfba620$var$_extends({}, metaRequest, {
                            blockchains: metaRequest == null || (_metaRequest$blockcha = metaRequest.blockchains) == null ? void 0 : _metaRequest$blockcha.join(),
                            swappers: metaRequest == null || (_metaRequest$swappers = metaRequest.swappers) == null ? void 0 : _metaRequest$swappers.join(),
                            swappersGroups: metaRequest == null || (_metaRequest$swappers2 = metaRequest.swappersGroups) == null ? void 0 : _metaRequest$swappers2.join(),
                            transactionTypes: metaRequest == null || (_metaRequest$transact = metaRequest.transactionTypes) == null ? void 0 : _metaRequest$transact.join()
                        });
                        _context.next = 3;
                        return this.httpService.get("/meta/compact?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({
                            params: params
                        }, options));
                    case 3:
                        axiosResponse = _context.sent;
                        reformatTokens = function reformatTokens(tokens) {
                            return tokens.map(function(tm) {
                                return {
                                    blockchain: tm.b,
                                    symbol: tm.s,
                                    image: tm.i,
                                    address: tm.a || null,
                                    usdPrice: tm.p || null,
                                    isSecondaryCoin: tm.is || false,
                                    coinSource: tm.c || null,
                                    coinSourceUrl: tm.cu || null,
                                    name: tm.n || null,
                                    decimals: tm.d,
                                    isPopular: tm.ip || false,
                                    supportedSwappers: tm.ss || []
                                };
                            });
                        };
                        tokens = reformatTokens(axiosResponse.data.tokens);
                        popularTokens = reformatTokens(axiosResponse.data.popularTokens);
                        return _context.abrupt("return", $e0809f1f0dfba620$var$_extends({}, axiosResponse.data, {
                            tokens: tokens,
                            popularTokens: popularTokens
                        }));
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function getAllMetadata(_x, _x2) {
            return _getAllMetadata.apply(this, arguments);
        }
        return getAllMetadata;
    }();
    _proto.getBlockchains = /*#__PURE__*/ function() {
        var _getBlockchains = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee2(options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return this.httpService.get("/meta/blockchains?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context2.sent;
                        return _context2.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function getBlockchains(_x3) {
            return _getBlockchains.apply(this, arguments);
        }
        return getBlockchains;
    }();
    _proto.getSwappers = /*#__PURE__*/ function() {
        var _getSwappers = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee3(options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return this.httpService.get("/meta/swappers?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context3.sent;
                        return _context3.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function getSwappers(_x4) {
            return _getSwappers.apply(this, arguments);
        }
        return getSwappers;
    }();
    _proto.getCustomToken = /*#__PURE__*/ function() {
        var _getCustomToken = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee4(customTokenRequest, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return this.httpService.get("/meta/custom-token?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({
                            params: customTokenRequest
                        }, options));
                    case 2:
                        axiosResponse = _context4.sent;
                        return _context4.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function getCustomToken(_x5, _x6) {
            return _getCustomToken.apply(this, arguments);
        }
        return getCustomToken;
    }();
    _proto.getBestRoute = /*#__PURE__*/ function() {
        var _getBestRoute = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee5(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return this.httpService.post("/routing/best?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context5.sent;
                        return _context5.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5, this);
        }));
        function getBestRoute(_x7, _x8) {
            return _getBestRoute.apply(this, arguments);
        }
        return getBestRoute;
    }();
    _proto.getAllRoutes = /*#__PURE__*/ function() {
        var _getAllRoutes = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee6(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return this.httpService.post("/routing/bests?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context6.sent;
                        return _context6.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, this);
        }));
        function getAllRoutes(_x9, _x10) {
            return _getAllRoutes.apply(this, arguments);
        }
        return getAllRoutes;
    }();
    _proto.confirmRoute = /*#__PURE__*/ function() {
        var _confirmRoute = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee7(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return this.httpService.post("/routing/confirm?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context7.sent;
                        return _context7.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }, _callee7, this);
        }));
        function confirmRoute(_x11, _x12) {
            return _confirmRoute.apply(this, arguments);
        }
        return confirmRoute;
    }() // @deprecated use confirmRoute instead
    ;
    _proto.confirmRouteRequest = /*#__PURE__*/ function() {
        var _confirmRouteRequest = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee8(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        _context8.next = 2;
                        return this.httpService.post("/routing/confirm?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context8.sent;
                        return _context8.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8, this);
        }));
        function confirmRouteRequest(_x13, _x14) {
            return _confirmRouteRequest.apply(this, arguments);
        }
        return confirmRouteRequest;
    }();
    _proto.checkApproval = /*#__PURE__*/ function() {
        var _checkApproval = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee9(requestId, txId, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee9$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        _context9.next = 2;
                        return this.httpService.get("/tx/" + requestId + "/check-approval?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({
                            params: {
                                txId: txId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context9.sent;
                        return _context9.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context9.stop();
                }
            }, _callee9, this);
        }));
        function checkApproval(_x15, _x16, _x17) {
            return _checkApproval.apply(this, arguments);
        }
        return checkApproval;
    }();
    _proto.checkStatus = /*#__PURE__*/ function() {
        var _checkStatus = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee10(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee10$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        _context10.next = 2;
                        return this.httpService.post("/tx/check-status?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context10.sent;
                        return _context10.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context10.stop();
                }
            }, _callee10, this);
        }));
        function checkStatus(_x18, _x19) {
            return _checkStatus.apply(this, arguments);
        }
        return checkStatus;
    }();
    _proto.createTransaction = /*#__PURE__*/ function() {
        var _createTransaction = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee11(requestBody, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee11$(_context11) {
                while(true)switch(_context11.prev = _context11.next){
                    case 0:
                        _context11.next = 2;
                        return this.httpService.post("/tx/create?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context11.sent;
                        return _context11.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context11.stop();
                }
            }, _callee11, this);
        }));
        function createTransaction(_x20, _x21) {
            return _createTransaction.apply(this, arguments);
        }
        return createTransaction;
    }();
    _proto.reportFailure = /*#__PURE__*/ function() {
        var _reportFailure = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee12(requestBody, options) {
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee12$(_context12) {
                while(true)switch(_context12.prev = _context12.next){
                    case 0:
                        _context12.next = 2;
                        return this.httpService.post("/tx/report-tx?apiKey=" + this.apiKey, requestBody, $e0809f1f0dfba620$var$_extends({}, options));
                    case 2:
                    case "end":
                        return _context12.stop();
                }
            }, _callee12, this);
        }));
        function reportFailure(_x22, _x23) {
            return _reportFailure.apply(this, arguments);
        }
        return reportFailure;
    }();
    _proto.getWalletsDetails = /*#__PURE__*/ function() {
        var _getWalletsDetails = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee13(walletAddresses, options) {
            var walletAddressesQueryParams, i, walletAddress, axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee13$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        walletAddressesQueryParams = "";
                        for(i = 0; i < walletAddresses.length; i++){
                            walletAddress = walletAddresses[i];
                            walletAddressesQueryParams += "&address=" + walletAddress.blockchain + "." + walletAddress.address;
                        }
                        _context13.next = 4;
                        return this.httpService.get("/wallets/details?apiKey=" + this.apiKey + walletAddressesQueryParams, $e0809f1f0dfba620$var$_extends({}, options));
                    case 4:
                        axiosResponse = _context13.sent;
                        return _context13.abrupt("return", axiosResponse.data);
                    case 6:
                    case "end":
                        return _context13.stop();
                }
            }, _callee13, this);
        }));
        function getWalletsDetails(_x24, _x25) {
            return _getWalletsDetails.apply(this, arguments);
        }
        return getWalletsDetails;
    }();
    _proto.getTokenBalance = /*#__PURE__*/ function() {
        var _getTokenBalance = /*#__PURE__*/ $e0809f1f0dfba620$var$_asyncToGenerator(/*#__PURE__*/ $e0809f1f0dfba620$var$_regeneratorRuntime().mark(function _callee14(tokenBalanceRequest, options) {
            var axiosResponse;
            return $e0809f1f0dfba620$var$_regeneratorRuntime().wrap(function _callee14$(_context14) {
                while(true)switch(_context14.prev = _context14.next){
                    case 0:
                        _context14.next = 2;
                        return this.httpService.get("/wallets/token-balance?apiKey=" + this.apiKey, $e0809f1f0dfba620$var$_extends({
                            params: tokenBalanceRequest
                        }, options));
                    case 2:
                        axiosResponse = _context14.sent;
                        return _context14.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context14.stop();
                }
            }, _callee14, this);
        }));
        function getTokenBalance(_x26, _x27) {
            return _getTokenBalance.apply(this, arguments);
        }
        return getTokenBalance;
    }();
    return RangoClient;
}();
var $e0809f1f0dfba620$export$9d749b8b357dfab2 = function isEvmBlockchain(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $e0809f1f0dfba620$export$d917e9e8a70036a6 = function isCosmosBlockchain(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $e0809f1f0dfba620$export$ff5a0a65a8982bf2 = function isSolanaBlockchain(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $e0809f1f0dfba620$export$744fa0907a94ca40 = function isTronBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $e0809f1f0dfba620$export$83b5ebc3a9031095 = function isTransferBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $e0809f1f0dfba620$export$80db8fd9e7a31db2 = function isStarknetBlockchain(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $e0809f1f0dfba620$export$9500a92ad5d775aa = function isTonBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $e0809f1f0dfba620$export$e2a694e57950e88e = function evmBlockchains(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$9d749b8b357dfab2);
};
var $e0809f1f0dfba620$export$11a35c42f4dd4832 = function solanaBlockchain(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$ff5a0a65a8982bf2);
};
var $e0809f1f0dfba620$export$e1f5443c7a926d0f = function starknetBlockchain(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$80db8fd9e7a31db2);
};
var $e0809f1f0dfba620$export$61a2144ef91f3622 = function tronBlockchain(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$744fa0907a94ca40);
};
var $e0809f1f0dfba620$export$7a136f0d6bb0d722 = function cosmosBlockchains(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$d917e9e8a70036a6);
};
var $e0809f1f0dfba620$export$80dff8c560b1e7ce = function transferBlockchains(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$83b5ebc3a9031095);
};
var $e0809f1f0dfba620$export$e38bf62be0c23ec5 = function tonBlockchain(blockchains) {
    return blockchains.filter($e0809f1f0dfba620$export$9500a92ad5d775aa);
};
/**
 * Routing Result Type
 *
 */ var $e0809f1f0dfba620$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
    RoutingResultType["HIGH_IMPACT_FOR_CREATE_TX"] = "HIGH_IMPACT_FOR_CREATE_TX";
})($e0809f1f0dfba620$export$9244fb3192b4c649 || ($e0809f1f0dfba620$export$9244fb3192b4c649 = {}));
/**
 * The type of transaction
 */ var $e0809f1f0dfba620$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($e0809f1f0dfba620$export$d513b00599f845d4 || ($e0809f1f0dfba620$export$d513b00599f845d4 = {}));
/**
 * The type of transaction
 * @deprecated use TransactionType instead
 */ var $e0809f1f0dfba620$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($e0809f1f0dfba620$export$d5c0ec10a1bea971 || ($e0809f1f0dfba620$export$d5c0ec10a1bea971 = {}));
/**
 * The status of transaction in tracking
 */ var $e0809f1f0dfba620$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($e0809f1f0dfba620$export$7c391bd3b61d2374 || ($e0809f1f0dfba620$export$7c391bd3b61d2374 = {}));
var $e0809f1f0dfba620$export$16073528a91c8d2a = function isCosmosTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.COSMOS;
};
var $e0809f1f0dfba620$export$b1818bc93202fd47 = function isSolanaTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.SOLANA;
};
var $e0809f1f0dfba620$export$a6e014f972e5c64c = function isTransferTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.TRANSFER;
};
var $e0809f1f0dfba620$export$9fd5291d9179852a = function isTronTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.TRON;
};
var $e0809f1f0dfba620$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($e0809f1f0dfba620$export$6ef804aee1395a14 || ($e0809f1f0dfba620$export$6ef804aee1395a14 = {}));
var $e0809f1f0dfba620$export$232916af2d90d322 = function isTonTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.TON;
};
var $e0809f1f0dfba620$export$b9109202fe95a066 = function isEvmTransaction(transaction) {
    return transaction.type === $e0809f1f0dfba620$export$d513b00599f845d4.EVM;
};


parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");
var $bfeGn = parcelRequire("bfeGn");



let $33a294d743a65dae$var$rango = undefined;
const $33a294d743a65dae$export$c1b2b945bea31d71 = ()=>{
    if ($33a294d743a65dae$var$rango) return $33a294d743a65dae$var$rango;
    $33a294d743a65dae$var$rango = new (0, $e0809f1f0dfba620$export$2eb9c0bd2d5b9cf8)((0, $e3869297c16ce984$export$44487a86467333c3)("API_KEY"), (0, $e3869297c16ce984$export$44487a86467333c3)("BASE_URL"));
    return $33a294d743a65dae$var$rango;
};







var $76r4H = parcelRequire("76r4H");

var $76r4H = parcelRequire("76r4H");
const $edfaa0206604e5d0$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null) return "";
    if (number === "") return "";
    const n = new (0, $76r4H.default)(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, $76r4H.default)(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++)if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    if (n.isEqualTo(0)) return "0";
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};


parcelRequire("14sfz");
var $liigz = parcelRequire("liigz");
var $bfeGn = parcelRequire("bfeGn");

const $a4bfc3a31209948b$var$ERROR_ASSERTION_FAILED = "Assertion failed (Unexpected behaviour)";
const $a4bfc3a31209948b$var$ERROR_CREATE_TRANSACTION = "Create transaction failed in Rango Server";
const $a4bfc3a31209948b$var$ERROR_INPUT_WALLET_NOT_FOUND = "Input wallet not found";
class $a4bfc3a31209948b$export$89427b94e5b39218 extends Error {
    constructor(code, m, root, detail){
        super(m);
        this._isPrettyError = true;
        Object.setPrototypeOf(this, $a4bfc3a31209948b$export$89427b94e5b39218.prototype);
        $a4bfc3a31209948b$export$89427b94e5b39218.prototype._isPrettyError = true;
        this.code = code;
        this.detail = detail;
        this.root = root;
    }
    static isPrettyError(obj) {
        return obj instanceof $a4bfc3a31209948b$export$89427b94e5b39218 || Object.prototype.hasOwnProperty.call(obj, "_isPrettyError");
    }
    getErrorDetail() {
        const rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        const rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            extraMessage: this.message,
            extraMessageDetail: this.detail || rootStr,
            extraMessageErrorCode: this.code || null
        };
    }
    static AssertionFailed(m) {
        return new $a4bfc3a31209948b$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $a4bfc3a31209948b$var$ERROR_ASSERTION_FAILED, null, m);
    }
    static BadStatusCode(message, statusCode) {
        return new $a4bfc3a31209948b$export$89427b94e5b39218("TX_FAIL", message, null, `status code = ${statusCode}`);
    }
    static CreateTransaction(detail) {
        return new $a4bfc3a31209948b$export$89427b94e5b39218("FETCH_TX_FAILED", $a4bfc3a31209948b$var$ERROR_CREATE_TRANSACTION, null, detail);
    }
    static WalletMissing() {
        return new $a4bfc3a31209948b$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $a4bfc3a31209948b$var$ERROR_INPUT_WALLET_NOT_FOUND, null, "Server requested for a blockchain or address not selected by user");
    }
    static BlockchainMissing() {
        return new $a4bfc3a31209948b$export$89427b94e5b39218("CLIENT_UNEXPECTED_BEHAVIOUR", $a4bfc3a31209948b$var$ERROR_INPUT_WALLET_NOT_FOUND, null, "Server requested for a blockchain or address not selected by user");
    }
}
function $a4bfc3a31209948b$export$6de13c9ec5bf007b(errorCode) {
    try {
        if (!errorCode) return 0, $a9f720414a973cf5$export$c93d4c74989d686f;
        if ((0, $liigz.isAPIErrorCode)(errorCode)) return errorCode;
        if ((0, $bfeGn.isSignerErrorCode)(errorCode)) {
            const t = {
                [(0, $bfeGn.SignerErrorCode).REJECTED_BY_USER]: "USER_REJECT",
                [(0, $bfeGn.SignerErrorCode).SIGN_TX_ERROR]: "CALL_WALLET_FAILED",
                [(0, $bfeGn.SignerErrorCode).SEND_TX_ERROR]: "SEND_TX_FAILED",
                [(0, $bfeGn.SignerErrorCode).TX_FAILED_IN_BLOCKCHAIN]: "TX_FAILED_IN_BLOCKCHAIN",
                [(0, $bfeGn.SignerErrorCode).NOT_IMPLEMENTED]: (0, $a9f720414a973cf5$export$c93d4c74989d686f),
                [(0, $bfeGn.SignerErrorCode).OPERATION_UNSUPPORTED]: (0, $a9f720414a973cf5$export$c93d4c74989d686f),
                [(0, $bfeGn.SignerErrorCode).UNEXPECTED_BEHAVIOUR]: (0, $a9f720414a973cf5$export$c93d4c74989d686f)
            };
            return t[errorCode];
        }
        return 0, $a9f720414a973cf5$export$c93d4c74989d686f;
    } catch (err) {
        return 0, $a9f720414a973cf5$export$c93d4c74989d686f;
    }
}
const $a4bfc3a31209948b$export$8a2553b801670ae3 = (obj)=>{
    if (!obj) return {
        extraMessage: "",
        extraMessageErrorCode: null
    };
    if ($a4bfc3a31209948b$export$89427b94e5b39218.isPrettyError(obj)) return obj.getErrorDetail();
    if ((0, $bfeGn.SignerError).isSignerError(obj)) {
        const t = obj.getErrorDetail();
        return {
            extraMessage: t.message,
            extraMessageDetail: t.detail,
            extraMessageErrorCode: t.code
        };
    }
    if (obj instanceof Error) return {
        extraMessage: obj.toString(),
        extraMessageErrorCode: null
    };
    if (typeof obj !== "string") return {
        extraMessage: JSON.stringify(obj),
        extraMessageErrorCode: null
    };
    return {
        extraMessage: obj,
        extraMessageErrorCode: null
    };
};


var $f3ce3db9d10c7efd$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($f3ce3db9d10c7efd$export$bb45678bd9ad9127 || ($f3ce3db9d10c7efd$export$bb45678bd9ad9127 = {}));
const $f3ce3db9d10c7efd$export$e07f0a7a416c5e36 = (swap, step)=>{
    try {
        return $f3ce3db9d10c7efd$export$e314a0b0b5946154(swap, step);
    } catch (e) {
        return null;
    }
};
const $f3ce3db9d10c7efd$export$e314a0b0b5946154 = (swap, step)=>{
    const b1 = step.evmTransaction?.blockChain || step.evmApprovalTransaction?.blockChain || step.starknetTransaction?.blockChain || step.starknetApprovalTransaction?.blockChain || step.tronTransaction?.blockChain || step.tronApprovalTransaction?.blockChain || step.cosmosTransaction?.blockChain || step.solanaTransaction?.blockChain || step.tonTransaction?.blockChain;
    if (b1) return b1;
    const transferAddress = step.transferTransaction?.fromWalletAddress;
    if (!transferAddress) throw (0, $a4bfc3a31209948b$export$89427b94e5b39218).BlockchainMissing();
    const blockchain = Object.keys(swap.wallets).find((b)=>swap.wallets[b]?.address === transferAddress) || null;
    if (blockchain == null) throw (0, $a4bfc3a31209948b$export$89427b94e5b39218).BlockchainMissing();
    return blockchain;
};
const $f3ce3db9d10c7efd$export$1dc40019f7ea36bf = (txHash, network, blockchainMetaMap)=>{
    const blockchainMeta = blockchainMetaMap[network];
    const baseUrl = blockchainMeta.info?.transactionUrl;
    if (!baseUrl) return;
    if (baseUrl.indexOf("/{txHash}") !== -1) return baseUrl.replace("{txHash}", txHash);
    return `${baseUrl}/${txHash}`;
};
function $f3ce3db9d10c7efd$export$b6b54d9bbb742a92(swap, currentStep) {
    return swap.steps.find((step)=>step.status !== "failed" && step.status !== "success" && step.id !== currentStep.id) || null;
}
const $f3ce3db9d10c7efd$export$336d89edaa0d6235 = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ""] || swap.wallets[step.evmApprovalTransaction?.blockChain || ""] || swap.wallets[step.tronTransaction?.blockChain || ""] || swap.wallets[step.tronApprovalTransaction?.blockChain || ""] || swap.wallets[step.starknetTransaction?.blockChain || ""] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ""] || swap.wallets[step.cosmosTransaction?.blockChain || ""] || swap.wallets[step.solanaTransaction?.blockChain || ""] || swap.wallets[step.tonTransaction?.blockChain || ""] || (step.transferTransaction?.fromWalletAddress ? {
        address: step.transferTransaction?.fromWalletAddress
    } : null) || null;
    if (result == null) throw (0, $a4bfc3a31209948b$export$89427b94e5b39218).WalletMissing();
    return result.address;
};
function $f3ce3db9d10c7efd$export$f9842af9f6c21d6d(swap, currentStep) {
    const walletAddress = $f3ce3db9d10c7efd$export$336d89edaa0d6235(swap, currentStep);
    const walletKV = Object.keys(swap.wallets).map((k)=>({
            k: k,
            v: swap.wallets[k]
        })).find(({ v: v })=>v.address === walletAddress) || null;
    const blockchain = walletKV?.k || null;
    const wallet = walletKV?.v || null;
    const walletType = wallet?.walletType;
    if (wallet === null) throw (0, $a4bfc3a31209948b$export$89427b94e5b39218).AssertionFailed(`Wallet for source ${blockchain} not passed: walletType: ${walletType}`);
    return wallet;
}
function $f3ce3db9d10c7efd$export$5be79e3cb2436f0b(swap, currentStep) {
    if (!currentStep) return null;
    try {
        return $f3ce3db9d10c7efd$export$f9842af9f6c21d6d(swap, currentStep);
    } catch (e) {
        return null;
    }
}
const $f3ce3db9d10c7efd$export$6d86cb5a06ea37cc = (blockchain, symbol, address, allTokens)=>{
    const token = allTokens?.find((t)=>t.blockchain === blockchain && t.symbol?.toUpperCase() === symbol?.toUpperCase() && t.address === address);
    return token?.usdPrice || null;
};
function $f3ce3db9d10c7efd$export$acbec34e083696b5(step, allTokens) {
    let totalFeeInUsd = new (0, $76r4H.default)(0);
    for(let i = 0; i < step.fee.length; i++){
        const fee = step.fee[i];
        if (fee.expenseType === "DECREASE_FROM_OUTPUT") continue;
        const unitPrice = $f3ce3db9d10c7efd$export$6d86cb5a06ea37cc(fee.asset.blockchain, fee.asset.symbol, fee.asset.address, allTokens);
        totalFeeInUsd = totalFeeInUsd.plus(new (0, $76r4H.default)(fee.amount).multipliedBy(unitPrice || 0));
    }
    return totalFeeInUsd;
}
function $f3ce3db9d10c7efd$var$mapSwapStepToPendingSwapStep(swap, meta) {
    return {
        // from
        fromBlockchain: swap.from.blockchain,
        fromBlockchainLogo: swap.from.blockchainLogo,
        fromLogo: swap.from.logo,
        fromSymbol: swap.from.symbol,
        fromSymbolAddress: swap.from.address,
        fromDecimals: swap.from.decimals,
        fromAmountPrecision: swap.fromAmountPrecision,
        fromAmountMinValue: swap.fromAmountMinValue,
        fromAmountMaxValue: swap.fromAmountMaxValue,
        fromAmountRestrictionType: swap.fromAmountRestrictionType,
        fromUsdPrice: swap.from.usdPrice,
        // to
        toBlockchain: swap.to.blockchain,
        toBlockchainLogo: swap.to.blockchainLogo,
        toSymbol: swap.to.symbol,
        toSymbolAddress: swap.to.address,
        toDecimals: swap.to.decimals,
        toLogo: swap.to.logo,
        toUsdPrice: swap.to.usdPrice,
        // swapper
        swapperId: swap.swapperId,
        swapperLogo: swap.swapperLogo,
        swapperType: swap.swapperType,
        // route
        expectedOutputAmountHumanReadable: swap.toAmount,
        feeInUsd: meta ? (0, $edfaa0206604e5d0$export$f67be9d9b0e25d7b)($f3ce3db9d10c7efd$export$acbec34e083696b5(swap, meta?.tokens), null, 8) : null,
        estimatedTimeInSeconds: swap.estimatedTimeInSeconds || null,
        internalSteps: null
    };
}
function $f3ce3db9d10c7efd$export$dc09743a86365433(inputAmount, bestRoute, wallets, settings, validateBalanceOrFee, meta) {
    const simulationResult = bestRoute.result;
    if (!simulationResult) throw Error("Simulation result should not be null");
    return {
        creationTime: new Date().getTime().toString(),
        finishTime: null,
        requestId: bestRoute.requestId || "",
        inputAmount: inputAmount,
        wallets: wallets,
        status: "running",
        isPaused: false,
        extraMessage: null,
        extraMessageSeverity: null,
        extraMessageDetail: null,
        extraMessageErrorCode: null,
        networkStatusExtraMessage: null,
        networkStatusExtraMessageDetail: null,
        lastNotificationTime: null,
        settings: settings,
        simulationResult: simulationResult,
        validateBalanceOrFee: validateBalanceOrFee,
        steps: bestRoute.result?.swaps?.map((swap, index)=>{
            const stepRoute = $f3ce3db9d10c7efd$var$mapSwapStepToPendingSwapStep(swap, meta);
            return {
                id: index + 1,
                // route
                ...stepRoute,
                internalSwaps: swap?.internalSwaps?.map((internalSwap)=>{
                    const stepRoute = $f3ce3db9d10c7efd$var$mapSwapStepToPendingSwapStep(internalSwap, meta);
                    return stepRoute;
                }) || null,
                // status, tracking
                outputAmount: "",
                status: "created",
                networkStatus: null,
                startTransactionTime: new Date().getTime(),
                externalTransactionId: null,
                executedTransactionId: null,
                executedTransactionTime: null,
                explorerUrl: null,
                diagnosisUrl: null,
                trackingCode: null,
                internalSteps: null,
                // transactions
                evmTransaction: null,
                evmApprovalTransaction: null,
                starknetTransaction: null,
                starknetApprovalTransaction: null,
                tronTransaction: null,
                tronApprovalTransaction: null,
                cosmosTransaction: null,
                solanaTransaction: null,
                transferTransaction: null,
                tonTransaction: null,
                // front fields
                hasAlreadyProceededToSign: false
            };
        }) || []
    };
}



function $42ad3905e5eb98b9$var$createSteps(swapSteps) {
    return swapSteps.map((swapStep)=>{
        const { diagnosisUrl: diagnosisUrl, estimatedTimeInSeconds: estimatedTimeInSeconds, explorerUrl: explorerUrl, feeInUsd: feeInUsd, executedTransactionId: executedTransactionId, executedTransactionTime: executedTransactionTime, expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable, fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromSymbol: fromSymbol, toSymbol: toSymbol, fromSymbolAddress: fromSymbolAddress, toSymbolAddress: toSymbolAddress, swapperType: swapperType, swapperId: swapperId, outputAmount: outputAmount, fromAmountMaxValue: fromAmountMaxValue, fromAmountMinValue: fromAmountMinValue, fromAmountPrecision: fromAmountPrecision, fromAmountRestrictionType: fromAmountRestrictionType, fromDecimals: fromDecimals, status: stepStatus } = swapStep;
        const step = {
            diagnosisUrl: diagnosisUrl,
            estimatedTimeInSeconds: estimatedTimeInSeconds,
            explorerUrl: explorerUrl,
            feeInUsd: feeInUsd,
            executedTransactionId: executedTransactionId,
            executedTransactionTime: executedTransactionTime,
            expectedOutputAmountHumanReadable: expectedOutputAmountHumanReadable,
            fromBlockchain: fromBlockchain,
            toBlockchain: toBlockchain,
            fromSymbol: fromSymbol,
            toSymbol: toSymbol,
            fromSymbolAddress: fromSymbolAddress,
            toSymbolAddress: toSymbolAddress,
            swapperName: swapperId,
            swapperType: swapperType,
            outputAmount: outputAmount,
            fromAmountMaxValue: fromAmountMaxValue,
            fromAmountMinValue: fromAmountMinValue,
            fromAmountPrecision: fromAmountPrecision,
            fromAmountRestrictionType: fromAmountRestrictionType,
            fromDecimals: fromDecimals,
            status: stepStatus,
            transaction: (0, $45075b780ed6e88c$export$e0828339165e66a2)(swapStep)
        };
        return step;
    });
}
function $42ad3905e5eb98b9$var$getEventPayload(swap, type, swapStep) {
    const { creationTime: creationTime, finishTime: finishTime, requestId: requestId, inputAmount: inputAmount, status: status, wallets: wallets, steps: steps, settings: settings } = swap;
    const routeSteps = $42ad3905e5eb98b9$var$createSteps(steps);
    const route = {
        creationTime: creationTime,
        finishTime: finishTime,
        requestId: requestId,
        inputAmount: inputAmount,
        status: status,
        wallets: wallets,
        steps: routeSteps,
        slippage: settings.slippage,
        infiniteApproval: settings.infiniteApprove
    };
    const result = {
        route: route,
        step: routeSteps[routeSteps.length - 1]
    };
    if (swapStep) result.step = $42ad3905e5eb98b9$var$createSteps([
        swapStep
    ])[0];
    else if (type === "failed") {
        const failedStep = (0, $45075b780ed6e88c$export$2574a36ee57e8565)(routeSteps);
        if (failedStep) result.step = failedStep;
    } else {
        const lastSuccessfulStep = (0, $45075b780ed6e88c$export$ce182e0a92d996da)(routeSteps);
        if (lastSuccessfulStep) result.step = lastSuccessfulStep;
    }
    return result;
}
function $42ad3905e5eb98b9$var$emitRouteEvent(stepEvent, route) {
    let routeEvent;
    const { type: type } = stepEvent;
    switch(type){
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).STARTED:
            routeEvent = {
                ...stepEvent,
                type: (0, $ab26e0b6754d430c$export$543d0a6c7f452841).STARTED
            };
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED:
            routeEvent = {
                ...stepEvent,
                type: (0, $ab26e0b6754d430c$export$543d0a6c7f452841).FAILED
            };
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).SUCCEEDED:
            routeEvent = {
                ...stepEvent,
                type: (0, $ab26e0b6754d430c$export$543d0a6c7f452841).SUCCEEDED
            };
            break;
        default:
            break;
    }
    if (routeEvent) {
        const eventEmitter = (0, $e3869297c16ce984$export$44487a86467333c3)("emitter");
        eventEmitter?.emit((0, $ab26e0b6754d430c$export$54f5f69c1651567f).RouteEvent, {
            event: routeEvent,
            route: route
        });
    }
}
function $42ad3905e5eb98b9$var$emitStepEvent(stepEvent, route, step) {
    const eventEmitter = (0, $e3869297c16ce984$export$44487a86467333c3)("emitter");
    eventEmitter?.emit((0, $ab26e0b6754d430c$export$54f5f69c1651567f).StepEvent, {
        event: stepEvent,
        route: route,
        step: step
    });
}
function $42ad3905e5eb98b9$export$95858563cfce6cd6(params) {
    const { event: event } = params;
    const { type: type } = event;
    const { route: route, step: step } = $42ad3905e5eb98b9$var$getEventPayload(params.swap, type, params.step ?? undefined);
    const fromAsset = `${step.fromBlockchain}.${step.fromSymbol}`;
    const toAsset = `${step.toBlockchain}.${step.toSymbol}`;
    const outputAmount = step.outputAmount ?? "";
    const currentFromBlockchain = !!params.step ? (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(params.swap, params.step) : null;
    let message = "";
    let messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).INFO;
    switch(type){
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).STARTED:
            message = "Swap process started";
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).SUCCEEDED:
            message = `You received ${outputAmount} ${toAsset}, hooray!`;
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED:
            message = `Swap failed: ${params.swap?.extraMessage ?? "Reason is unknown"}`;
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).ERROR;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION:
            if (event.status === (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).CREATE_TX) {
                message = "Please wait while the transaction is created ...";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).INFO;
            } else if (event.status === (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).SEND_TX) {
                if (params.step && (0, $45075b780ed6e88c$export$b9926026bbb60802)(params.step)) message = `Please confirm '${step.swapperName}' smart contract access to ${fromAsset}`;
                else message = "Please confirm transaction request in your wallet";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).TX_SENT) {
                message = "Transaction sent successfully";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).INFO;
            }
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).CHECK_STATUS:
            if (params.step && (0, $45075b780ed6e88c$export$b9926026bbb60802)(params.step)) message = "Checking approve transaction status ...";
            else message = "Checking transaction status ...";
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).INFO;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED:
            message = "Smart contract called successfully";
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).OUTPUT_REVEALED:
            message = "Transaction output amount revealed";
            messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).SUCCESS;
            break;
        case (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED:
            if (event.status === (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT) {
                message = "Please connect your wallet.";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_QUEUE) {
                message = "Waiting for other swaps to complete";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT) {
                message = "Please change your wallet account.";
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING;
            } else if (event.status === (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE) {
                message = `Please change your wallet network to ${currentFromBlockchain}.`;
                messageSeverity = (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING;
            }
            break;
        default:
            break;
    }
    if (params.step) $42ad3905e5eb98b9$var$emitStepEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route, step);
    if (params.event.type === (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED || !params.step) $42ad3905e5eb98b9$var$emitRouteEvent({
        ...event,
        message: message,
        messageSeverity: messageSeverity
    }, route);
}





let $45075b780ed6e88c$var$swapClaimedBy = null;
function $45075b780ed6e88c$export$269a5aa1e1356b04() {
    return {
        claimedBy: ()=>$45075b780ed6e88c$var$swapClaimedBy?.id,
        setClaimer: (queue_id)=>{
            $45075b780ed6e88c$var$swapClaimedBy = {
                id: queue_id
            };
        },
        reset: ()=>{
            $45075b780ed6e88c$var$swapClaimedBy = null;
        }
    };
}
const $45075b780ed6e88c$var$swapTransactionToDataMap = {};
function $45075b780ed6e88c$export$156145f76a656206() {
    return {
        getTransactionDataByHash: (hash)=>$45075b780ed6e88c$var$swapTransactionToDataMap[hash] || {},
        setTransactionDataByHash: (hash, data)=>{
            const r = $45075b780ed6e88c$var$swapTransactionToDataMap[hash];
            if (!r) $45075b780ed6e88c$var$swapTransactionToDataMap[hash] = {};
            $45075b780ed6e88c$var$swapTransactionToDataMap[hash].response = data.response || $45075b780ed6e88c$var$swapTransactionToDataMap[hash].response;
            $45075b780ed6e88c$var$swapTransactionToDataMap[hash].receiptReceived = data.receiptReceived || $45075b780ed6e88c$var$swapTransactionToDataMap[hash].receiptReceived || false;
        }
    };
}
const $45075b780ed6e88c$export$613fded3c60df0c1 = (swap)=>{
    return swap.steps.find((step)=>step.status !== "failed" && step.status !== "success") || null;
};
const $45075b780ed6e88c$export$e0828339165e66a2 = (currentStep)=>{
    const { evmTransaction: evmTransaction, evmApprovalTransaction: evmApprovalTransaction, cosmosTransaction: cosmosTransaction, solanaTransaction: solanaTransaction, transferTransaction: transferTransaction, starknetApprovalTransaction: starknetApprovalTransaction, starknetTransaction: starknetTransaction, tronApprovalTransaction: tronApprovalTransaction, tronTransaction: tronTransaction, tonTransaction: tonTransaction } = currentStep;
    return evmTransaction || evmApprovalTransaction || cosmosTransaction || solanaTransaction || transferTransaction || starknetApprovalTransaction || starknetTransaction || tronApprovalTransaction || tronTransaction || tonTransaction;
};
const $45075b780ed6e88c$export$6b6ed2f9ae969f2d = (currentStep, transaction)=>{
    currentStep.transferTransaction = null;
    currentStep.cosmosTransaction = null;
    currentStep.evmTransaction = null;
    currentStep.solanaTransaction = null;
    currentStep.evmApprovalTransaction = null;
    currentStep.starknetApprovalTransaction = null;
    currentStep.starknetTransaction = null;
    currentStep.tronApprovalTransaction = null;
    currentStep.tronTransaction = null;
    currentStep.tonTransaction = null;
    const txType = transaction.type;
    switch(txType){
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).EVM:
            if (transaction.isApprovalTx) currentStep.evmApprovalTransaction = transaction;
            else currentStep.evmTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).TRON:
            if (transaction.isApprovalTx) currentStep.tronApprovalTransaction = transaction;
            else currentStep.tronTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).STARKNET:
            if (transaction.isApprovalTx) currentStep.starknetApprovalTransaction = transaction;
            else currentStep.starknetTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).COSMOS:
            currentStep.cosmosTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).SOLANA:
            currentStep.solanaTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).TRANSFER:
            currentStep.transferTransaction = transaction;
            break;
        case (0, $e0809f1f0dfba620$export$d513b00599f845d4).TON:
            currentStep.tonTransaction = transaction;
            break;
        default:
            ((x)=>{
                throw new Error(`${x} was unhandled!`);
            })(txType);
    }
    return currentStep;
};
const $45075b780ed6e88c$export$e959b2e816f5278e = (currentStep)=>{
    return $45075b780ed6e88c$export$e0828339165e66a2(currentStep)?.type;
};
const $45075b780ed6e88c$export$b9926026bbb60802 = (currentStep)=>{
    const { evmApprovalTransaction: evmApprovalTransaction, starknetApprovalTransaction: starknetApprovalTransaction, tronApprovalTransaction: tronApprovalTransaction } = currentStep;
    return !!(evmApprovalTransaction || starknetApprovalTransaction || tronApprovalTransaction);
};
function $45075b780ed6e88c$export$4ed458d278ce509a({ getStorage: getStorage, setStorage: setStorage, nextStatus: nextStatus, nextStepStatus: nextStepStatus, message: message, details: details, errorCode: errorCode = null, hasAlreadyProceededToSign: hasAlreadyProceededToSign, trace: trace = null }) {
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    const updatedResult = {
        swap: swap,
        step: currentStep
    };
    if (!!nextStepStatus && !!currentStep) currentStep.status = nextStepStatus;
    if (nextStatus) swap.status = nextStatus;
    swap.hasAlreadyProceededToSign = hasAlreadyProceededToSign;
    if (!!nextStatus && [
        "failed",
        "success"
    ].includes(nextStatus)) swap.finishTime = new Date().getTime().toString();
    if (!!message || !!details) {
        swap.extraMessage = message || "";
        swap.extraMessageDetail = details || "";
    }
    if (!!nextStepStatus && [
        "failed"
    ].includes(nextStepStatus)) {
        //if user cancel the swap, we should pass relevant reason to the server.
        const errorReason = details && details.includes("Warning") ? "Swap canceled by user." : details;
        const walletType = (0, $f3ce3db9d10c7efd$export$5be79e3cb2436f0b)(swap, currentStep)?.walletType;
        swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).error;
        const failureType = (0, $a4bfc3a31209948b$export$6de13c9ec5bf007b)(errorCode);
        updatedResult.failureType = failureType;
        // If trace of error was available, we will send it to the api (except user rejection)
        const errorReasonForAPI = errorCode !== "REJECTED_BY_USER" && trace?.message && typeof trace.message === "string" ? trace.message : errorReason || "";
        (0, $33a294d743a65dae$export$c1b2b945bea31d71)().reportFailure({
            requestId: swap.requestId,
            step: currentStep?.id || 1,
            eventType: failureType,
            reason: errorReasonForAPI,
            tags: walletType ? {
                wallet: walletType
            } : undefined
        }).then().catch();
    } else if (!!nextStepStatus && [
        "running"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).info;
    else if (!!nextStepStatus && [
        "success",
        "approved"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).success;
    else if (nextStepStatus && [
        "waitingForApproval"
    ].includes(nextStepStatus)) swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).warning;
    if (nextStepStatus === "running" && currentStep) currentStep.startTransactionTime = new Date().getTime();
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return updatedResult;
}
function $45075b780ed6e88c$export$d2255bf7fdde61bf({ getStorage: getStorage, setStorage: setStorage }, txId, explorerUrl) {
    const swap = getStorage().swapDetails;
    swap.hasAlreadyProceededToSign = null;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    currentStep.executedTransactionId = txId;
    currentStep.executedTransactionTime = new Date().getTime().toString();
    if (explorerUrl?.url) currentStep.explorerUrl = [
        ...currentStep.explorerUrl || [],
        {
            url: explorerUrl.url,
            description: explorerUrl.description || null
        }
    ];
    const isApproval = $45075b780ed6e88c$export$b9926026bbb60802(currentStep);
    if (isApproval) swap.extraMessage = "Checking approve transaction status ...";
    else swap.extraMessage = "Checking transaction status ...";
    swap.extraMessageDetail = "";
    swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).info;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION,
            status: (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).TX_SENT
        },
        swap: swap,
        step: currentStep
    });
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
}
function $45075b780ed6e88c$export$79aac2cf09acb365({ getStorage: getStorage, setStorage: setStorage }, reason, reasonDetail) {
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    const isAlreadyMarked = currentStep.networkStatus === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet && swap.networkStatusExtraMessage === reason && swap.networkStatusExtraMessageDetail === reasonDetail;
    if (isAlreadyMarked) return;
    currentStep.networkStatus = (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
}
function $45075b780ed6e88c$export$ef6de5a7a1eb84b5({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    // Generate message
    const { type: type } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
    const fromBlockchain = (0, $f3ce3db9d10c7efd$export$e314a0b0b5946154)(swap, currentStep);
    const reason = `Change ${type} wallet network to ${fromBlockchain}`;
    const reasonDetail = `Please change your ${type} wallet network to ${fromBlockchain}.`;
    const currentTime = new Date();
    swap.lastNotificationTime = currentTime.getTime().toString();
    currentStep.networkStatus = (0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange;
    swap.networkStatusExtraMessage = reason;
    swap.networkStatusExtraMessageDetail = reasonDetail;
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
function $45075b780ed6e88c$export$13dec43429df168f({ getStorage: getStorage, setStorage: setStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (!currentStep) return;
    swap.networkStatusExtraMessage = "";
    swap.networkStatusExtraMessageDetail = "";
    currentStep.networkStatus = (0, $aQzGx.PendingSwapNetworkStatus).WaitingForQueue;
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
        },
        swap: swap,
        step: currentStep
    });
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    return {
        swap: swap,
        step: currentStep
    };
}
async function $45075b780ed6e88c$export$1391212d75b2ee65(ms) {
    return new Promise((res)=>setTimeout(res, ms));
}
const $45075b780ed6e88c$export$bb807b0a6bc347f5 = (swap, network)=>{
    return swap.wallets[network]?.walletType;
};
function $45075b780ed6e88c$export$a07d9470285db41(wallet) {
    return wallet === null || wallet?.blockchains === null || wallet?.blockchains.length === 0;
}
function $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const step = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    const bcName = (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, step);
    if (!bcName) return {
        type: null,
        network: null,
        address: null
    };
    const walletType = $45075b780ed6e88c$export$bb807b0a6bc347f5(swap, bcName);
    const sourceWallet = swap.wallets[bcName];
    return {
        type: walletType || null,
        network: bcName,
        address: sourceWallet ? sourceWallet.address : null
    };
}
/**
 * On EVM compatible wallets, There is one instance with different chains (like Polygon)
 * To get the chain from instance we will use this function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
async function $45075b780ed6e88c$var$getChainId(provider) {
    try {
        const chainId = await provider.request({
            method: "eth_chainId"
        }) || provider?.chainId;
        return chainId;
    } catch  {
        return provider?.chainId;
    }
}
async function $45075b780ed6e88c$export$e51ad0ccc6210c75(swap, step, wallet, meta, providers) {
    if ($45075b780ed6e88c$export$a07d9470285db41(wallet)) return false;
    const fromBlockChain = (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, step);
    if (!fromBlockChain) return false;
    if (meta.evmBasedChains.find((evmBlochain)=>evmBlochain.name === fromBlockChain)) {
        try {
            const sourceWallet = swap.wallets[fromBlockChain];
            if (sourceWallet) {
                const provider = (0, $bHRZL.getEvmProvider)(providers, sourceWallet.walletType);
                const chainId = await $45075b780ed6e88c$var$getChainId(provider);
                if (chainId) {
                    const blockChain = (0, $8aS14.legacyGetBlockChainNameFromId)(chainId, Object.entries(meta.blockchains).map(([, blockchainMeta])=>blockchainMeta));
                    if (blockChain && blockChain.toLowerCase() === fromBlockChain.toLowerCase()) return true;
                    if (blockChain && blockChain.toLowerCase() !== fromBlockChain.toLowerCase()) return false;
                }
            }
        } catch (e) {
            console.log(e);
        }
        return false;
    }
    return true;
}
const $45075b780ed6e88c$export$9f101a08b811faba = (swap, step)=>{
    const result = swap.wallets[step.evmTransaction?.blockChain || ""] || swap.wallets[step.evmApprovalTransaction?.blockChain || ""] || swap.wallets[step.tronTransaction?.blockChain || ""] || swap.wallets[step.tronApprovalTransaction?.blockChain || ""] || swap.wallets[step.starknetTransaction?.blockChain || ""] || swap.wallets[step.starknetApprovalTransaction?.blockChain || ""] || swap.wallets[step.cosmosTransaction?.blockChain || ""] || swap.wallets[step.solanaTransaction?.blockChain || ""] || swap.wallets[step.tonTransaction?.blockChain || ""] || step.transferTransaction?.fromWalletAddress || null;
    return result !== null;
};
function $45075b780ed6e88c$export$84ffc71d1c4cf1c1(actions) {
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        currentStep.networkStatus = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $45075b780ed6e88c$export$92b8d849bafb537c(actions, data = {
    message: "",
    details: "",
    status: null
}) {
    const { message: message, details: details, status: status } = data;
    const { getStorage: getStorage, setStorage: setStorage } = actions;
    const swap = getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (currentStep?.networkStatus) {
        swap.networkStatusExtraMessage = message;
        swap.networkStatusExtraMessageDetail = details;
        currentStep.networkStatus = status;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
    }
}
function $45075b780ed6e88c$export$c29c9a248811e0a7(event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const { ok: ok, reason: reason } = $45075b780ed6e88c$export$ba15f3931e3e12e6(swap, context.state);
    if (!ok) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
        const { type: walletType, address: address } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                ...reason === "account_miss_match" ? {
                    status: (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_CHANGE_WALLET_ACCOUNT,
                    requiredAccount: address ?? undefined
                } : {
                    status: (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT,
                    requiredWallet: walletType ?? undefined,
                    requiredAccount: address ?? undefined
                }
            },
            swap: swap,
            step: currentStep
        });
        $45075b780ed6e88c$export$79aac2cf09acb365({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        }, (0, $a9f720414a973cf5$export$d6102d677d637a6d), event.reason.description);
        return;
    }
    queue.unblock();
}
function $45075b780ed6e88c$export$15bd368e2f15ea8b(_event, meta) {
    const { context: context, queue: queue } = meta;
    const swap = queue.getStorage().swapDetails;
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    if (!currentStep || swap.status !== "running") return;
    const result = $45075b780ed6e88c$export$ef6de5a7a1eb84b5({
        getStorage: queue.getStorage.bind(queue),
        setStorage: queue.setStorage.bind(queue)
    });
    const requiredNetwork = (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, currentStep);
    const requiredWallet = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap).type;
    const currentNetwork = requiredWallet ? context.state(requiredWallet).network : undefined;
    if (result) (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
            status: (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
            requiredNetwork: requiredNetwork ?? undefined,
            currentNetwork: currentNetwork ?? undefined
        },
        swap: result.swap,
        step: result.step
    });
    // Try to auto switch
    const { type: type, network: network } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
    if (!!type && !!network) {
        if (context.canSwitchNetworkTo(type, network)) {
            const result = context.switchNetwork(type, network);
            if (result) result.then(()=>{
                queue.unblock();
            }).catch((error)=>{
                // ignore switch network errors
                console.log({
                    error: error
                });
            });
        }
    }
}
function $45075b780ed6e88c$export$63f1cfbd06c1a0f9(_event, meta) {
    const { getBlockedTasks: getBlockedTasks, forceExecute: forceExecute, queue: queue, manager: manager, context: context } = meta;
    const { setClaimer: setClaimer, claimedBy: claimedBy, reset: reset } = $45075b780ed6e88c$export$269a5aa1e1356b04();
    // We only needs those blocked tasks that have DEPENDS_ON_OTHER_QUEUES reason.
    const blockedTasks = getBlockedTasks().filter((task)=>task.reason.reason === (0, $ab26e0b6754d430c$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES);
    if (blockedTasks.length === 0) return;
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId;
    if (claimerId === queue.id) return;
    // Check if any queue `claimed` before, if yes, we don't should do anything.
    if (isClaimedByAnyQueue) {
        // We need to keep the latest swap messages
        $45075b780ed6e88c$export$13dec43429df168f({
            getStorage: queue.getStorage.bind(queue),
            setStorage: queue.setStorage.bind(queue)
        });
        return;
    }
    // Prioritize current queue to be run first.
    let task = blockedTasks.find((task)=>{
        return task.queue_id === meta.queue_id;
    });
    // If current task isn't available anymore, fallback to first blocked task.
    if (!task) {
        const firstBlockedTask = blockedTasks[0];
        task = firstBlockedTask;
    }
    setClaimer(task.queue_id);
    const claimedStorage = task.storage.get();
    const { type: type, network: network, address: address } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(claimedStorage.swapDetails);
    // Run
    forceExecute(task.queue_id, {
        claimedBy: claimedBy(),
        resetClaimedBy: ()=>{
            reset();
            // TODO: Use key generator
            $45075b780ed6e88c$export$4ca8cf19c61b3860(`${type}-${network}:${address}`, manager, context.canSwitchNetworkTo);
        }
    });
}
function $45075b780ed6e88c$export$ba15f3931e3e12e6(swap, getState) {
    const { type: type, address: address } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
    if (!type || !address) return {
        ok: false,
        reason: "not_connected"
    };
    const walletState = getState(type);
    const { accounts: accounts, connected: connected } = walletState;
    const connectedAccounts = accounts || [];
    if (!connected) return {
        ok: false,
        reason: "not_connected"
    };
    const matched = connectedAccounts.some((account)=>{
        const { address: accountAddress } = (0, $8aS14.legacyReadAccountAddress)(account);
        return address.toLocaleLowerCase() === accountAddress.toLocaleLowerCase();
    });
    return {
        ok: matched,
        reason: "account_miss_match"
    };
}
async function $45075b780ed6e88c$export$6ad02cc4966b42ab(actions) {
    const { setTransactionDataByHash: setTransactionDataByHash } = $45075b780ed6e88c$export$156145f76a656206();
    const { getStorage: getStorage, setStorage: setStorage, failed: failed, next: next, schedule: schedule, context: context } = actions;
    const { meta: meta, getSigners: getSigners, isMobileWallet: isMobileWallet } = context;
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
    const sourceWallet = (0, $f3ce3db9d10c7efd$export$f9842af9f6c21d6d)(swap, currentStep);
    const mobileWallet = isMobileWallet(sourceWallet?.walletType);
    const walletAddress = (0, $f3ce3db9d10c7efd$export$336d89edaa0d6235)(swap, currentStep);
    const currentStepBlockchain = (0, $f3ce3db9d10c7efd$export$e314a0b0b5946154)(swap, currentStep);
    const onFinish = ()=>{
        // TODO resetClaimedBy is undefined here
        if (actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const tx = $45075b780ed6e88c$export$e0828339165e66a2(currentStep);
    const txType = tx?.type;
    const isApproval = $45075b780ed6e88c$export$b9926026bbb60802(currentStep);
    if (!tx || !txType) {
        const extraMessage = "Unexpected Error: tx is null!";
        const updateResult = $45075b780ed6e88c$export$4ed458d278ce509a({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: undefined,
            errorCode: "CLIENT_UNEXPECTED_BEHAVIOUR"
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: "CLIENT_UNEXPECTED_BEHAVIOUR"
            },
            ...updateResult
        });
        failed();
        return onFinish();
    }
    const chainId = meta.blockchains?.[tx.blockChain]?.chainId;
    const hasAlreadyProceededToSign = typeof swap.hasAlreadyProceededToSign === "boolean";
    let nextStatus, nextStepStatus, message, details, eventType;
    if (isApproval) {
        message = `Waiting for approval of ${currentStep?.fromSymbol} coin ${mobileWallet ? "on your mobile phone!" : ""}`;
        details = "Waiting for approve transaction to be mined and confirmed successfully";
        nextStepStatus = "waitingForApproval";
        nextStatus = undefined;
        eventType = (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION;
    } else if (hasAlreadyProceededToSign) {
        message = "Transaction is expired. Please try again.";
        nextStepStatus = "failed";
        nextStatus = "failed";
        details = "";
        eventType = (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED;
    } else {
        message = "Executing transaction ...";
        nextStepStatus = "running";
        nextStatus = "running";
        details = `${mobileWallet ? "Check your mobile phone!" : ""}`;
        eventType = (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION;
    }
    const updateResult = $45075b780ed6e88c$export$4ed458d278ce509a({
        getStorage: getStorage,
        setStorage: setStorage,
        nextStepStatus: nextStepStatus,
        nextStatus: nextStatus,
        message: message,
        details: details,
        hasAlreadyProceededToSign: isApproval ? undefined : hasAlreadyProceededToSign,
        errorCode: hasAlreadyProceededToSign ? "TX_EXPIRED" : undefined
    });
    if (eventType === (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED) (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: eventType,
            reason: message,
            reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
        },
        ...updateResult
    });
    else (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: eventType,
            status: (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).SEND_TX
        },
        ...updateResult
    });
    if (hasAlreadyProceededToSign) {
        failed();
        onFinish();
        return;
    }
    const walletSigners = await getSigners(sourceWallet.walletType);
    const signer = walletSigners.getSigner(txType);
    signer.signAndSendTx(tx, walletAddress, chainId).then(({ hash: hash, response: response })=>{
        const explorerUrl = (0, $f3ce3db9d10c7efd$export$1dc40019f7ea36bf)(hash, currentStepBlockchain, meta.blockchains);
        $45075b780ed6e88c$export$d2255bf7fdde61bf(actions, hash, explorerUrl && (!response || response && !response.hashRequiringUpdate) ? {
            url: explorerUrl,
            description: isApproval ? "Approve" : "Swap"
        } : undefined);
        // response used for evm transactions to get receipt and track replaced
        response && setTransactionDataByHash(hash, {
            response: response
        });
        schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
        next();
        onFinish();
    }, (error)=>{
        if (swap.status === "failed") return;
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $a4bfc3a31209948b$export$8a2553b801670ae3)(error);
        (0, $2d0ef42914e3f734$export$c106dd0671a0fc2d)(error, {
            tags: {
                requestId: swap.requestId,
                rpc: true,
                swapper: currentStep?.swapperId || "",
                walletType: sourceWallet?.walletType || ""
            },
            context: (0, $bfeGn.SignerError).isSignerError(error) ? error.getErrorContext() : {}
        });
        const updateResult = $45075b780ed6e88c$export$4ed458d278ce509a({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode,
            trace: error?.cause
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        failed();
        onFinish();
    });
}
function $45075b780ed6e88c$export$4855f2a4839078ef(params) {
    const { wallet_network: wallet_network, evmChains: evmChains, manager: manager } = params;
    const [wallet, network] = (0, $7aYgM.splitWalletNetwork)(wallet_network);
    // We only need change network for EVM chains.
    if (!evmChains.some((chain)=>chain.name == network)) return;
    manager?.getAll().forEach((q)=>{
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (swap && swap.status === "running") {
            const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
            if (currentStep) {
                const currentStepRequiredWallet = queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType;
                const hasWaitingForConnect = Object.keys(q.list.state.tasks).some((taskId)=>{
                    const task = q.list.state.tasks[taskId];
                    return task.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED && // TODO double check later
                    [
                        (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET
                    ].includes(task.blockedFor?.reason);
                });
                const requiredNetwork = (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, currentStep);
                if (currentStepRequiredWallet === wallet && hasWaitingForConnect && requiredNetwork != network) {
                    const queueInstance = q.list;
                    const { type: type } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
                    const description = (0, $a9f720414a973cf5$export$721abf6846856403)(type);
                    q.list.block({
                        reason: {
                            reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                            description: description
                        },
                        silent: true
                    });
                    const result = $45075b780ed6e88c$export$ef6de5a7a1eb84b5({
                        getStorage: queueInstance.getStorage.bind(queueInstance),
                        setStorage: queueInstance.setStorage.bind(queueInstance)
                    });
                    if (result) (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
                        event: {
                            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED,
                            status: (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_NETWORK_CHANGE,
                            currentNetwork: network,
                            requiredNetwork: requiredNetwork ?? undefined
                        },
                        swap: result.swap,
                        step: result.step
                    });
                }
            }
        }
    });
}
function $45075b780ed6e88c$export$d9db0ccdbfe08fc3(manager) {
    manager?.getAll().forEach((q)=>{
        const hasWaitingForNetwork = Object.keys(q.list.state.tasks).some((taskId)=>{
            const task = q.list.state.tasks[taskId];
            return task.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED && [
                (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
                (0, $ab26e0b6754d430c$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES
            ].includes(task.blockedFor?.reason);
        });
        if (hasWaitingForNetwork) {
            const swap = q.list.getStorage()?.swapDetails;
            if (swap.status === "running") {
                const { type: type } = $45075b780ed6e88c$export$a1ae03e1f1eb7b55(swap);
                const description = (0, $a9f720414a973cf5$export$2f02fd340a90fed8)(type);
                // Change the block reason to waiting for connecting wallet
                q.list.block({
                    reason: {
                        reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
                        description: description
                    }
                });
            }
        }
    });
}
function $45075b780ed6e88c$export$fbf0d9b8906779ef(manager) {
    const queues = manager?.getAll() || new Map();
    const result = [];
    queues.forEach((q)=>{
        // retry only on affected queues
        const queueStorage = q.list.getStorage();
        const swap = queueStorage?.swapDetails;
        if (!swap || swap.status !== "running") return;
        result.push(swap);
    });
    return result;
}
function $45075b780ed6e88c$export$31570cddaa6e4311(runningSwaps) {
    runningSwaps.forEach((swap)=>{
        const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
        const eventType = (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION_BLOCKED;
        let eventSubtype;
        if (currentStep?.networkStatus === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForQueue) eventSubtype = (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_QUEUE;
        else if (swap?.status === "running") eventSubtype = (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_WALLET_CONNECT;
        if (!!eventType && !!(0, $42ad3905e5eb98b9$export$95858563cfce6cd6)) (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: eventType,
                status: eventSubtype ?? (0, $ab26e0b6754d430c$export$ee459e29d25d53b0).WAITING_FOR_QUEUE
            },
            swap: swap,
            step: currentStep
        });
    });
}
function $45075b780ed6e88c$export$4ca8cf19c61b3860(wallet_network, manager, canSwitchNetworkTo, options = {
    fallbackToOnlyWallet: true
}) {
    const [wallet, network] = (0, $7aYgM.splitWalletNetwork)(wallet_network);
    if (!wallet || !network) return;
    const walletAndNetworkMatched = [];
    const onlyWalletMatched = [];
    manager?.getAll().forEach((q)=>{
        // retry only on affected queues
        if (q.status === (0, $099e91276c36ee90$export$96e9906d6d93a972).BLOCKED) {
            const queueStorage = q.list.getStorage();
            const swap = queueStorage?.swapDetails;
            if (swap && swap.status === "running") {
                const currentStep = $45075b780ed6e88c$export$613fded3c60df0c1(swap);
                if (currentStep) {
                    if ((0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, currentStep) == network && queueStorage?.swapDetails.wallets[network]?.walletType === wallet) walletAndNetworkMatched.push(q.list);
                    else if (queueStorage?.swapDetails.wallets[currentStep.fromBlockchain]?.walletType === wallet) onlyWalletMatched.push(q.list);
                }
            }
        }
    });
    let finalQueueToBeRun = undefined;
    if (walletAndNetworkMatched.length > 0) {
        finalQueueToBeRun = walletAndNetworkMatched[0];
        if (walletAndNetworkMatched.length > 1) for(let i = 1; i < walletAndNetworkMatched.length; i++){
            const currentQueue = walletAndNetworkMatched[i];
            $45075b780ed6e88c$export$13dec43429df168f({
                getStorage: currentQueue.getStorage.bind(currentQueue),
                setStorage: currentQueue.setStorage.bind(currentQueue)
            });
        }
    } else if (onlyWalletMatched.length > 0 && options.fallbackToOnlyWallet) finalQueueToBeRun = onlyWalletMatched[0];
    if (!canSwitchNetworkTo?.(wallet, network)) finalQueueToBeRun?.unblock();
    else finalQueueToBeRun?.checkBlock();
}
function $45075b780ed6e88c$export$d31e98f8646bca08(step) {
    return !!step.evmTransaction || !!step.evmApprovalTransaction;
}
async function $45075b780ed6e88c$export$495b8adaeb8ab9b9(rawResponse) {
    const responseBody = await rawResponse;
    if (!responseBody.ok || !responseBody.transaction) throw (0, $a4bfc3a31209948b$export$89427b94e5b39218).CreateTransaction(responseBody.error || "bad response from create tx endpoint");
    return responseBody;
}
function $45075b780ed6e88c$export$c778f9ff5514f6d7(swap, manager) {
    const { reset: reset } = $45075b780ed6e88c$export$269a5aa1e1356b04();
    swap.actions.cancel();
    const updateResult = $45075b780ed6e88c$export$4ed458d278ce509a({
        getStorage: swap.actions.getStorage,
        setStorage: swap.actions.setStorage,
        message: "Swap canceled by user.",
        details: "Warning: If you've already signed and sent a transaction, it won't be affected, but next swap steps will not be executed.",
        nextStatus: "failed",
        nextStepStatus: "failed",
        errorCode: "USER_CANCEL"
    });
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
            reasonCode: "USER_CANCEL",
            reason: updateResult.swap.extraMessage ?? undefined
        },
        swap: updateResult.swap,
        step: updateResult.step
    });
    reset();
    if (manager) manager?.retry();
    return updateResult;
}
function $45075b780ed6e88c$export$ce182e0a92d996da(steps) {
    return steps.slice().reverse().find((step)=>step.status === "success");
}
function $45075b780ed6e88c$export$2574a36ee57e8565(steps) {
    return steps.slice().reverse().find((step)=>step.status === "failed");
}
function $45075b780ed6e88c$export$5265eafbefe28577(step) {
    const { transaction: transaction } = step;
    const approvalTx = transaction?.type === (0, $e0809f1f0dfba620$export$d513b00599f845d4).EVM && transaction.isApprovalTx || transaction?.type === (0, $e0809f1f0dfba620$export$d513b00599f845d4).STARKNET && transaction.isApprovalTx || transaction?.type === (0, $e0809f1f0dfba620$export$d513b00599f845d4).TRON && transaction.isApprovalTx;
    return approvalTx;
}







const $f6d1753a5da7a403$var$INTERVAL_FOR_CHECK_STATUS = 5000;
const $f6d1753a5da7a403$var$INTERVAL_FOR_CHECK_APPROVAL = 5000;
/**
 * Subscribe to status of swap transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $f6d1753a5da7a403$var$checkTransactionStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    if (!currentStep?.executedTransactionId) return;
    const tx = (0, $45075b780ed6e88c$export$e0828339165e66a2)(currentStep);
    let txId = currentStep.executedTransactionId;
    let getTxReceiptFailed = false;
    let status = null;
    let signer = null;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $45075b780ed6e88c$export$156145f76a656206)();
    try {
        const txType = (0, $45075b780ed6e88c$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $f3ce3db9d10c7efd$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) signer = (await context.getSigners(sourceWallet.walletType)).getSigner(txType);
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        // if wallet is connected, try to get transaction reciept
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepBlockchain = (0, $f3ce3db9d10c7efd$export$e314a0b0b5946154)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $f3ce3db9d10c7efd$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepBlockchain, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: "Replaced Swap"
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $a4bfc3a31209948b$export$8a2553b801670ae3)(error);
        const updateResult = (0, $45075b780ed6e88c$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        getTxReceiptFailed = true;
    /*
     * We shouldn't return here, because we need to trigger check status job in backend.
     * This is not a ui requirement but the backend one.
     */ }
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        status = await (0, $33a294d743a65dae$export$c1b2b945bea31d71)().checkStatus({
            requestId: swap.requestId,
            txId: txId,
            step: currentStep.id
        });
    } catch (e) {
        await (0, $45075b780ed6e88c$export$1391212d75b2ee65)($f6d1753a5da7a403$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
        return;
    }
    /*
   * If user cancel swap during check status api call,
   * or getting transaction receipt failed,
   * we should ignore check status response and return
   */ if (getTxReceiptFailed) return failed();
    if (currentStep?.status === "failed") return;
    const outputAmount = status?.outputAmount || (currentStep.outputAmount ? currentStep.outputAmount : null);
    const prevOutputAmount = currentStep.outputAmount || null;
    swap.extraMessage = status?.extraMessage || swap.extraMessage;
    swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).info;
    swap.extraMessageDetail = "";
    currentStep.status = status?.status || currentStep.status;
    currentStep.diagnosisUrl = status?.diagnosisUrl || currentStep.diagnosisUrl || null;
    currentStep.outputAmount = outputAmount || currentStep.outputAmount;
    currentStep.explorerUrl = status?.explorerUrl || currentStep.explorerUrl;
    currentStep.internalSteps = status?.steps || null;
    const newTransaction = status?.newTx;
    if (newTransaction) {
        currentStep.status = "created";
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        (0, $45075b780ed6e88c$export$6b6ed2f9ae969f2d)(currentStep, newTransaction);
    }
    if (prevOutputAmount === null && outputAmount !== null) (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).OUTPUT_REVEALED,
            outputAmount: outputAmount
        },
        swap: swap,
        step: currentStep
    });
    else if (prevOutputAmount === null && outputAmount === null) // it is needed to set notification after reloading the page
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).CHECK_STATUS
        },
        swap: swap,
        step: currentStep
    });
    if (currentStep.status === "success") {
        const nextStep = (0, $f3ce3db9d10c7efd$export$b6b54d9bbb742a92)(swap, currentStep);
        swap.extraMessageDetail = "";
        swap.extraMessage = nextStep ? `starting next step: ${nextStep.swapperId}: ${nextStep.fromBlockchain} -> ${nextStep.toBlockchain}` : "";
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).SUCCEEDED,
                outputAmount: currentStep.outputAmount ?? ""
            },
            swap: swap,
            step: currentStep
        });
    } else if (currentStep.status === "failed") {
        swap.extraMessage = "Transaction failed in blockchain";
        swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).error;
        swap.extraMessageDetail = status?.extraMessage || "";
        swap.status = "failed";
        swap.finishTime = new Date().getTime().toString();
    }
    // Sync data with storage
    setStorage({
        ...getStorage(),
        swapDetails: swap
    });
    if (status?.status === "failed") failed();
    else if (status?.status === "success" || status?.status === "running" && !!status.newTx) {
        schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $45075b780ed6e88c$export$1391212d75b2ee65)($f6d1753a5da7a403$var$INTERVAL_FOR_CHECK_STATUS);
        retry();
    }
}
/**
 * Subscribe to status of approval transaction by checking from server periodically.
 * After getting the status, notify the user and schedule `SCHEDULE_NEXT_STEP`.
 */ async function $f6d1753a5da7a403$var$checkApprovalStatus({ getStorage: getStorage, setStorage: setStorage, next: next, schedule: schedule, retry: retry, failed: failed, context: context }) {
    const swap = getStorage().swapDetails;
    const { meta: meta } = context;
    const { getTransactionDataByHash: getTransactionDataByHash, setTransactionDataByHash: setTransactionDataByHash } = (0, $45075b780ed6e88c$export$156145f76a656206)();
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log("ignore check status, current step is null");
        return;
    }
    const tx = (0, $45075b780ed6e88c$export$e0828339165e66a2)(currentStep);
    if (!currentStep?.executedTransactionId) return;
    let txId = currentStep.executedTransactionId;
    let signer = null;
    try {
        const txType = (0, $45075b780ed6e88c$export$e959b2e816f5278e)(currentStep);
        const sourceWallet = (0, $f3ce3db9d10c7efd$export$f9842af9f6c21d6d)(swap, currentStep);
        if (txType && sourceWallet) {
            const walletSigners = await context.getSigners(sourceWallet.walletType);
            signer = walletSigners.getSigner(txType);
        }
    } catch (error) {
    /*
     * wallet is not connected yet
     * no need to do anything
     */ }
    try {
        const { response: txResponse, receiptReceived: receiptReceived } = getTransactionDataByHash(txId);
        // if wallet is connected, try to get transaction reciept
        if (signer?.wait && !receiptReceived) {
            const chainId = tx?.blockChain && meta.blockchains?.[tx?.blockChain]?.chainId || undefined;
            const { hash: updatedTxHash, response: updatedTxResponse } = await signer.wait(txId, chainId, txResponse);
            if (updatedTxHash !== txId) {
                currentStep.executedTransactionId = updatedTxHash || currentStep.executedTransactionId;
                const currentStepBlockchain = (0, $f3ce3db9d10c7efd$export$e314a0b0b5946154)(swap, currentStep);
                let explorerUrl;
                const blockchainsMetaNotEmpty = !!Object.keys(meta.blockchains).length;
                if (blockchainsMetaNotEmpty) explorerUrl = (0, $f3ce3db9d10c7efd$export$1dc40019f7ea36bf)(currentStep.executedTransactionId, currentStepBlockchain, meta.blockchains);
                if (explorerUrl) {
                    if (currentStep.explorerUrl && currentStep.explorerUrl?.length >= 1) currentStep.explorerUrl[currentStep.explorerUrl.length - 1] = {
                        url: explorerUrl,
                        description: "Replaced Approve"
                    };
                }
                txId = currentStep.executedTransactionId;
                if (updatedTxHash && updatedTxResponse) setTransactionDataByHash(updatedTxHash, {
                    response: updatedTxResponse
                });
            } else setTransactionDataByHash(updatedTxHash, {
                receiptReceived: true
            });
        }
    } catch (error) {
        const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail, extraMessageErrorCode: extraMessageErrorCode } = (0, $a4bfc3a31209948b$export$8a2553b801670ae3)(error);
        const updateResult = (0, $45075b780ed6e88c$export$4ed458d278ce509a)({
            getStorage: getStorage,
            setStorage: setStorage,
            nextStatus: "failed",
            nextStepStatus: "failed",
            message: extraMessage,
            details: extraMessageDetail,
            errorCode: extraMessageErrorCode
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                reason: extraMessage,
                reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
            },
            ...updateResult
        });
        return failed();
    }
    let isApproved = false;
    try {
        const response = await (0, $33a294d743a65dae$export$c1b2b945bea31d71)().checkApproval(swap.requestId, currentStep.executedTransactionId);
        // If user cancel swap during check status api call, we should ignore check approval response
        if (currentStep?.status === "failed") return;
        isApproved = response.isApproved;
        if (!isApproved && (response.txStatus === "failed" || response.txStatus === "success")) {
            let message, details;
            if (response.txStatus === "failed") {
                message = "Approve transaction failed";
                details = "Smart contract approval tx failed in blockchain.";
            } else {
                message = "Not enough approval";
                if (response.requiredApprovedAmount && response.currentApprovedAmount) details = `Required approval: ${response.requiredApprovedAmount}, current approval: ${response.currentApprovedAmount}`;
                else details = `You still don't have enough approval for this swap.`;
            }
            /*
       * approve transaction failed on
       * we should fail the whole swap
       */ const updateResult = (0, $45075b780ed6e88c$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: "failed",
                nextStepStatus: "failed",
                errorCode: "INSUFFICIENT_APPROVE",
                message: message,
                details: details
            });
            (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
                event: {
                    type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                    reason: message,
                    reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
                },
                ...updateResult
            });
            failed();
        } else if (!isApproved) // it is needed to set notification after reloading the page
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).CHECK_STATUS
            },
            swap: swap,
            step: currentStep
        });
    } catch (e) {
        isApproved = false;
    }
    if (isApproved) {
        currentStep.status = "approved";
        swap.extraMessage = `Spending ${currentStep.fromSymbol} approved successfully.`;
        swap.extraMessageDetail = null;
        swap.extraMessageSeverity = (0, $f3ce3db9d10c7efd$export$bb45678bd9ad9127).success;
        currentStep.evmApprovalTransaction = null;
        currentStep.executedTransactionId = null;
        currentStep.executedTransactionTime = null;
        currentStep.starknetApprovalTransaction = null;
        currentStep.tronApprovalTransaction = null;
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).APPROVAL_TX_SUCCEEDED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
        next();
    } else {
        await (0, $45075b780ed6e88c$export$1391212d75b2ee65)($f6d1753a5da7a403$var$INTERVAL_FOR_CHECK_APPROVAL);
        retry();
    }
}
async function $f6d1753a5da7a403$export$1c8f61c1db5300d2(actions) {
    const swap = actions.getStorage().swapDetails;
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    if (!currentStep) {
        console.log("ignore check status, current step is null", swap.requestId);
        return;
    }
    /*
   * Reset network status
   * Because when check status is on `loading` or `failed` status, it shows previous message that isn't related to current state.
   */ (0, $45075b780ed6e88c$export$84ffc71d1c4cf1c1)(actions);
    if (currentStep.status === "running") await $f6d1753a5da7a403$var$checkTransactionStatus(actions);
    else if (currentStep.status === "waitingForApproval") await $f6d1753a5da7a403$var$checkApprovalStatus(actions);
}








async function $a069a7fbfcfbf437$export$714aebfec8ead7f0(actions) {
    const { setStorage: setStorage, getStorage: getStorage, next: next, schedule: schedule } = actions;
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    const transaction = (0, $45075b780ed6e88c$export$e0828339165e66a2)(currentStep);
    if (!transaction) {
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION,
                status: (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).CREATE_TX
            },
            swap: swap,
            step: currentStep
        });
        const request = {
            requestId: swap.requestId,
            step: currentStep.id,
            userSettings: {
                slippage: swap.settings.slippage,
                infiniteApprove: swap.settings.infiniteApprove
            },
            validations: {
                balance: swap.validateBalanceOrFee,
                fee: swap.validateBalanceOrFee,
                approve: true
            }
        };
        try {
            // Getting transcation from server.
            const { transaction: transaction } = await (0, $45075b780ed6e88c$export$495b8adaeb8ab9b9)((0, $33a294d743a65dae$export$c1b2b945bea31d71)().createTransaction(request));
            if (transaction) (0, $45075b780ed6e88c$export$6b6ed2f9ae969f2d)(currentStep, transaction);
            setStorage({
                ...getStorage(),
                swapDetails: swap
            });
            schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION);
            next();
        } catch (error) {
            swap.status = "failed";
            swap.finishTime = new Date().getTime().toString();
            const { extraMessage: extraMessage, extraMessageDetail: extraMessageDetail } = (0, $a4bfc3a31209948b$export$8a2553b801670ae3)(error);
            const updateResult = (0, $45075b780ed6e88c$export$4ed458d278ce509a)({
                getStorage: getStorage,
                setStorage: setStorage,
                nextStatus: "failed",
                nextStepStatus: "failed",
                message: extraMessage,
                details: extraMessageDetail,
                errorCode: "FETCH_TX_FAILED"
            });
            (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
                event: {
                    type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                    reason: extraMessage,
                    reasonCode: updateResult.failureType ?? (0, $a9f720414a973cf5$export$c93d4c74989d686f)
                },
                ...updateResult
            });
            actions.failed();
        }
    }
}


parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");




async function $00c7d03f3a2e8c28$export$794e1f6267917bde(actions) {
    const { getStorage: getStorage, context: context } = actions;
    const { meta: meta, wallets: wallets, providers: providers } = context;
    const { claimedBy: claimedBy } = (0, $45075b780ed6e88c$export$269a5aa1e1356b04)();
    const isClaimed = context.claimedBy === context._queue?.id;
    const requestBlock = (blockedFor)=>{
        actions.block(blockedFor);
        if (isClaimed && actions.context.resetClaimedBy) actions.context.resetClaimedBy();
    };
    const swap = getStorage().swapDetails;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    // Resetting network status, so we will set it again during the running of this task.
    (0, $45075b780ed6e88c$export$84ffc71d1c4cf1c1)(actions);
    /* Make sure wallet is connected and also the connected wallet is matched with tx by checking address. */ const isWrongAddress = !(0, $45075b780ed6e88c$export$ba15f3931e3e12e6)(swap, context.state).ok;
    if (isWrongAddress) {
        const { type: type, address: address } = (0, $45075b780ed6e88c$export$a1ae03e1f1eb7b55)(swap);
        const isWalletInCompatible = wallets?.blockchains?.find((w)=>!w.accounts?.find((account)=>account.walletType === type));
        const description = (0, $45075b780ed6e88c$export$a07d9470285db41)(wallets) || isWalletInCompatible ? (0, $a9f720414a973cf5$export$2f02fd340a90fed8)(type) : (0, $a9f720414a973cf5$export$f2aac43aeaf7ba5a)(type, address);
        const blockedFor = {
            reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET,
            description: description
        };
        requestBlock(blockedFor);
        return;
    }
    /* Wallet should be on correct network */ const networkMatched = await (0, $45075b780ed6e88c$export$e51ad0ccc6210c75)(swap, currentStep, wallets, meta, providers);
    const claimerId = claimedBy();
    const isClaimedByAnyQueue = !!claimerId && !isClaimed;
    if (isClaimedByAnyQueue && !networkMatched) {
        const details = (0, $a9f720414a973cf5$export$bbfd8242d61c310);
        const blockedFor = {
            reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            details: details
        };
        requestBlock(blockedFor);
        return;
    } else if (!networkMatched) {
        const fromBlockchain = (0, $f3ce3db9d10c7efd$export$e314a0b0b5946154)(swap, currentStep);
        const details = (0, $a9f720414a973cf5$export$721abf6846856403)(fromBlockchain);
        const blockedFor = {
            reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE,
            details: details
        };
        requestBlock(blockedFor);
        return;
    }
    // Update network to mark it as network changed successfully.
    (0, $45075b780ed6e88c$export$92b8d849bafb537c)(actions, {
        message: "",
        details: "Wallet network changed successfully",
        status: (0, $aQzGx.PendingSwapNetworkStatus).NetworkChanged
    });
    /*
   *For avoiding conflict by making too many requests to wallet, we need to make sure
   *We only run one request at a time (In parallel mode).
   */ const needsToBlockQueue = (0, $45075b780ed6e88c$export$d31e98f8646bca08)(currentStep);
    if (needsToBlockQueue && !isClaimed) {
        const blockedFor = {
            reason: (0, $ab26e0b6754d430c$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES,
            description: (0, $a9f720414a973cf5$export$bbfd8242d61c310),
            details: {}
        };
        requestBlock(blockedFor);
        return;
    }
    // All the conditions are met. We can safely send the tx to wallet for sign.
    await (0, $45075b780ed6e88c$export$6ad02cc4966b42ab)(actions);
}





function $b254294b36230f6c$export$a4cc6fa6e89e741e({ schedule: schedule, next: next, failed: failed, setStorage: setStorage, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    const isFailed = swap.steps.find((step)=>step.status === "failed");
    if (!!currentStep && !isFailed) {
        if ((0, $45075b780ed6e88c$export$9f101a08b811faba)(swap, currentStep)) {
            schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION);
            return next();
        }
        if (currentStep?.executedTransactionId) {
            schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS);
            return next();
        }
        swap.status = "running";
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            event: {
                type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).STARTED
            },
            swap: swap,
            step: currentStep
        });
        schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).CREATE_TRANSACTION);
        next();
    } else {
        swap.status = isFailed ? "failed" : "success";
        swap.finishTime = new Date().getTime().toString();
        setStorage({
            ...getStorage(),
            swapDetails: swap
        });
        (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
            ...isFailed ? {
                event: {
                    type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).FAILED,
                    reason: swap.extraMessage ?? undefined,
                    reasonCode: "CALL_OR_SEND_FAILED"
                }
            } : {
                event: {
                    type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).SUCCEEDED,
                    outputAmount: (0, $45075b780ed6e88c$export$ce182e0a92d996da)(swap.steps)?.outputAmount ?? ""
                }
            },
            swap: swap,
            step: null
        });
        if (isFailed) failed();
        else next();
    }
}




function $0fb4aa7eb1b1984c$export$b3571188c770cc5a({ schedule: schedule, next: next, getStorage: getStorage }) {
    const swap = getStorage().swapDetails;
    (0, $42ad3905e5eb98b9$export$95858563cfce6cd6)({
        event: {
            type: (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).STARTED
        },
        swap: swap,
        step: null
    });
    schedule((0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP);
    next();
}



const $dd9eb4bab736d42a$export$5b43de9847fa5c2b = {
    name: "swap",
    actions: {
        [(0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).START]: (0, $0fb4aa7eb1b1984c$export$b3571188c770cc5a),
        [(0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP]: (0, $b254294b36230f6c$export$a4cc6fa6e89e741e),
        [(0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).CREATE_TRANSACTION]: (0, $a069a7fbfcfbf437$export$714aebfec8ead7f0),
        [(0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).EXECUTE_TRANSACTION]: (0, $00c7d03f3a2e8c28$export$794e1f6267917bde),
        [(0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).CHECK_TRANSACTION_STATUS]: (0, $f6d1753a5da7a403$export$1c8f61c1db5300d2)
    },
    run: [
        (0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).START
    ],
    whenTaskBlocked: (event, meta)=>{
        if (event.reason.reason === (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_CONNECT_WALLET) (0, $45075b780ed6e88c$export$c29c9a248811e0a7)(event, meta);
        else if (event.reason.reason === (0, $ab26e0b6754d430c$export$b022a9988c1688ba).WAIT_FOR_NETWORK_CHANGE) (0, $45075b780ed6e88c$export$15bd368e2f15ea8b)(event, meta);
        else if (event.reason.reason === (0, $ab26e0b6754d430c$export$b022a9988c1688ba).DEPENDS_ON_OTHER_QUEUES) (0, $45075b780ed6e88c$export$63f1cfbd06c1a0f9)(event, meta);
    }
};









var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $0d231845f094a77d$export$f6196a6c6bb539b4 = {
    loadedFromPersistor: false
};
function $0d231845f094a77d$var$reducer(state, action) {
    switch(action.type){
        case "UPDATE":
            return {
                ...state,
                [action.name]: action.value
            };
        default:
            return state;
    }
}
function $0d231845f094a77d$export$78aa9f240301775c() {
    const [state, dispatch] = (0, $exYeM.useReducer)($0d231845f094a77d$var$reducer, $0d231845f094a77d$export$f6196a6c6bb539b4);
    return {
        state: state,
        update: (name, value)=>{
            dispatch({
                type: "UPDATE",
                name: name,
                value: value
            });
        }
    };
}


const $5008c46af694b4d0$var$ManagerCtx = /*#__PURE__*/ (0, $exYeM.createContext)({
    manager: undefined,
    state: (0, $0d231845f094a77d$export$f6196a6c6bb539b4)
});
function $5008c46af694b4d0$var$Provider(props) {
    // TODO: this is not a proper way but i don't want to change the context interface atm.
    const [, forceRender] = (0, $exYeM.useState)({});
    const { state: state, update: update } = (0, $0d231845f094a77d$export$78aa9f240301775c)();
    const context = (0, $exYeM.useRef)(props.context);
    const manager = (0, $exYeM.useMemo)(()=>{
        return new (0, $5657a7d59f5376af$export$d0d38e7dec7a1a61)({
            queuesDefs: props.queuesDefs,
            events: {
                onStorageUpdate: ()=>{
                    forceRender({});
                },
                onCreateQueue: ()=>{
                    forceRender({});
                },
                onCreateTask: ()=>{
                    forceRender({});
                },
                onUpdateQueue: ()=>{
                    forceRender({});
                },
                onUpdateTask: ()=>{
                    forceRender({});
                },
                onPersistedDataLoaded: (manager)=>{
                    forceRender({});
                    if (props.onPersistedDataLoaded) props.onPersistedDataLoaded(manager);
                    /*
           * This condition will make sure, we only update the `loadedFromPersistor`.
           * But be aware `onPersistedDataLoaded` is calling after each `sync` which means can be called multiple times.
           */ if (!state.loadedFromPersistor) update("loadedFromPersistor", true);
                },
                onTaskBlock: ()=>{
                    forceRender({});
                },
                onDeleteQueue: ()=>{
                    forceRender({});
                }
            },
            context: context || {},
            isPaused: props.isPaused
        });
    }, []);
    (0, $exYeM.useLayoutEffect)(()=>{
        context.current = props.context;
    }, [
        props.context
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (typeof props.isPaused !== "undefined") {
            if (props.isPaused) manager.pause();
            else manager.run();
            forceRender({});
        }
    }, [
        props.isPaused
    ]);
    return(// eslint-disable-next-line react/jsx-no-constructed-context-values
    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($5008c46af694b4d0$var$ManagerCtx.Provider, {
        value: {
            manager: manager,
            state: state
        },
        children: props.children
    }));
}
function $5008c46af694b4d0$export$ddf53f26a9d1c984() {
    const context = (0, $exYeM.useContext)($5008c46af694b4d0$var$ManagerCtx);
    if (!context) throw Error("useManager can only be used within the Provider component");
    return context;
}
var $5008c46af694b4d0$export$2e2bcd8739ae039 = $5008c46af694b4d0$var$Provider;





var $exYeM = parcelRequire("exYeM");




const $6cde48b83c738236$var$MIGRATED_KEY = "migratedToQueueManager";
/**
 *
 * If `MIGRATED_KEY` is set, it means we already migrated data from localstorage.
 *
 */ function $6cde48b83c738236$export$993f7575d6ad7c5b() {
    return !!window.localStorage.getItem($6cde48b83c738236$var$MIGRATED_KEY);
}
async function $6cde48b83c738236$var$hasQueueManagerOnIDB() {
    try {
        return (await window.indexedDB.databases()).map((db)=>db.name).includes((0, $04400e89df3d70a0$export$3c22ff8b64b8f565));
    } catch  {
        return false;
    }
}
/**
 *
 * By calling this function, we first check if the data already migrated or not,
 * If not, starting to migrating to IndexedDb with proper format that queue manager is understand.
 *
 */ async function $6cde48b83c738236$export$f07d3c018abd1a6b() {
    const swapsFromStorage = window.localStorage.getItem("pendingSwaps");
    const hasIndexDB = await $6cde48b83c738236$var$hasQueueManagerOnIDB();
    // For new users or already migrated.
    if (!swapsFromStorage || $6cde48b83c738236$export$993f7575d6ad7c5b() || hasIndexDB) return true;
    // For old users, but they didn't do any swaps yet.
    const swaps = JSON.parse(swapsFromStorage);
    const convertedSwaps = [];
    swaps.forEach((swap)=>{
        /*
     *For running task we need to add some more work
     *We need to create a queue task to be run and resume the running task from queue manager.
     */ if (swap.status === "running") {
            const taskId = (0, $d0666643e2ee88b4$export$2e2bcd8739ae039)();
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: "swap",
                status: (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING,
                    activeTaskIndex: 0,
                    tasks: {
                        [taskId]: {
                            blockedFor: null,
                            status: (0, $099e91276c36ee90$export$96e9906d6d93a972).RUNNING
                        }
                    }
                },
                tasks: [
                    {
                        id: taskId,
                        action: (0, $ab26e0b6754d430c$export$f01edf6b00a44c8a).SCHEDULE_NEXT_STEP
                    }
                ]
            };
            convertedSwaps.push(convertedSwap);
        } else {
            /*
       * For failed or successful swaps, we only move it to IndexedDB,
       * And there is no need to consider them to be run.
       */ const status = swap.status === "success" ? (0, $099e91276c36ee90$export$96e9906d6d93a972).SUCCESS : (0, $099e91276c36ee90$export$96e9906d6d93a972).FAILED;
            const convertedSwap = {
                id: swap.requestId,
                createdAt: Number(swap.creationTime),
                name: "swap",
                status: status,
                storage: {
                    swapDetails: swap
                },
                state: {
                    status: status,
                    activeTaskIndex: 0,
                    tasks: {}
                },
                tasks: []
            };
            convertedSwaps.push(convertedSwap);
        }
    });
    // Getting an instance from persistor, so we can directly put our data inside it.
    const persistor = new (0, $04400e89df3d70a0$export$2e2bcd8739ae039)();
    const promises = convertedSwaps.map(async (queue)=>persistor.insertQueue(queue));
    await Promise.all(promises);
    // Mark as the data has been successfully migrated.
    window.localStorage.setItem($6cde48b83c738236$var$MIGRATED_KEY, "1");
    return true;
}


let $64034aac48a9a7d7$var$isCalled = 0;
/**
 *
 * Runs a migration (old swaps from localstorage to queue manager's IndexedDB)
 * It will be run only once on page load.
 *
 */ function $64034aac48a9a7d7$export$62d22dd62ac1f1b() {
    const isMigrated = (0, $6cde48b83c738236$export$993f7575d6ad7c5b)();
    const [status, setStatus] = (0, $exYeM.useState)(isMigrated);
    (0, $exYeM.useEffect)(()=>{
        (async ()=>{
            // Preventing react to be called twice on Strict Mode (development)
            if ($64034aac48a9a7d7$var$isCalled) return;
            $64034aac48a9a7d7$var$isCalled = 1;
            (0, $6cde48b83c738236$export$f07d3c018abd1a6b)().finally(()=>{
                setStatus(true);
            });
        })();
    }, []);
    return {
        status: status
    };
}
/**
 *
 * On initial load and also connect/disconnect we may need to update swap's notified message.
 * And also if a new wallet is connected we will retry the queue to see we can resume it or not.
 *
 */ function $64034aac48a9a7d7$export$1fbfa58ad4d80d3a(params) {
    const { manager: manager } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    (0, $exYeM.useEffect)(()=>{
        if (params.lastConnectedWallet) {
            (0, $45075b780ed6e88c$export$4855f2a4839078ef)({
                evmChains: params.evmChains,
                wallet_network: params.lastConnectedWallet,
                manager: manager
            });
            (0, $45075b780ed6e88c$export$4ca8cf19c61b3860)(params.lastConnectedWallet, manager, params.canSwitchNetworkTo);
        }
    }, [
        params.lastConnectedWallet
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (params.disconnectedWallet) {
            (0, $45075b780ed6e88c$export$d9db0ccdbfe08fc3)(manager);
            /*
       *We need to reset the state value, so if a wallet disconnected twice (after reconnect),
       *this effect will be run properly.
       */ params.clearDisconnectedWallet();
        }
    }, [
        params.disconnectedWallet
    ]);
}


function $438d15dd568686cf$export$e5055f26eedfa461(configs) {
    (0, $e3869297c16ce984$export$b9b9cdb96b829919)(configs);
    return 0, $dd9eb4bab736d42a$export$5b43de9847fa5c2b;
}



var $8aS14 = parcelRequire("8aS14");

var $8aS14 = parcelRequire("8aS14");
const $9767eb4ee16f8000$export$8c649a701cb55656 = "last-connected-wallets";


function $2beaad4c97d35327$export$7877a478dd30fd3d(wallets, type) {
    return wallets.find((wallet)=>wallet.type === type) || null;
}
const $2beaad4c97d35327$export$583dd06ffb7665f8 = {
    connected: false,
    connecting: false,
    reachable: false,
    installed: false,
    accounts: null,
    network: null
};
function $2beaad4c97d35327$export$ca8ebd435faad836(state, action) {
    if (action.type === "new_state") {
        // TODO fix problem and remove ts-ignore
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const target_wallet = state[action.wallet];
        if (!target_wallet) return {
            ...state,
            [action.wallet]: {
                ...$2beaad4c97d35327$export$583dd06ffb7665f8,
                [action.name]: action.value
            }
        };
        return {
            ...state,
            [action.wallet]: {
                ...target_wallet,
                [action.name]: action.value
            }
        };
    }
    return state;
}
function $2beaad4c97d35327$export$5ae027e423e49e34(providersState) {
    return Object.entries(providersState).filter(([, wallet_state])=>{
        return wallet_state?.connected;
    }).map(([type])=>{
        return type;
    });
}
function $2beaad4c97d35327$export$fa8b8bfe0657110e(providersState) {
    return Object.entries(providersState).map(([type])=>{
        return type;
    });
}
function $2beaad4c97d35327$export$927cec00467ddd76(list) {
    const wallets = new Map();
    list.forEach((provider)=>{
        const { config: config, ...actions } = provider;
        wallets.set(config.type, {
            actions: actions,
            config: config
        });
    });
    return wallets;
}
function $2beaad4c97d35327$export$aefee5ebe1dcfd9e(fn) {
    return fn?.constructor?.name === "AsyncFunction";
}
function $2beaad4c97d35327$export$bfabd3ae82f8899f(options) {
    const { checkInstallation: checkInstallation = true } = options.config;
    return checkInstallation;
}
async function $2beaad4c97d35327$export$567be3f12e4409f4({ type: type, walletActions: walletActions, getState: getState }) {
    if (walletActions.canEagerConnect) {
        const persistor = new (0, $8aS14.Persistor)();
        const wallets = persistor.getItem((0, $9767eb4ee16f8000$export$8c649a701cb55656));
        /*
     *If on the last attempt we are unable to eagerly connect to any wallet and the user connects any wallet manualy,
     *persistance will be outdated and will need to be removed.
     */ const shouldClearPersistance = wallets?.find((walletType)=>!getState(walletType).connected);
        if (shouldClearPersistance) $2beaad4c97d35327$export$68f445eb81c96373();
        const walletAlreadyPersisted = !!wallets?.find((wallet)=>wallet === type);
        if (wallets && !walletAlreadyPersisted) persistor.setItem((0, $9767eb4ee16f8000$export$8c649a701cb55656), wallets.concat(type));
        else persistor.setItem((0, $9767eb4ee16f8000$export$8c649a701cb55656), [
            type
        ]);
    }
}
function $2beaad4c97d35327$export$967c813e2e19faa4({ type: type, walletActions: walletActions }) {
    if (walletActions.canEagerConnect) {
        const persistor = new (0, $8aS14.Persistor)();
        const wallets = persistor.getItem((0, $9767eb4ee16f8000$export$8c649a701cb55656));
        if (wallets) persistor.setItem((0, $9767eb4ee16f8000$export$8c649a701cb55656), wallets.filter((wallet)=>wallet !== type));
    }
}
function $2beaad4c97d35327$export$68f445eb81c96373() {
    const persistor = new (0, $8aS14.Persistor)();
    const wallets = persistor.getItem((0, $9767eb4ee16f8000$export$8c649a701cb55656));
    if (wallets) persistor.removeItem((0, $9767eb4ee16f8000$export$8c649a701cb55656));
}
async function $2beaad4c97d35327$export$392c2457b7907874(wallets, getWalletInstance) {
    const persistor = new (0, $8aS14.Persistor)();
    const lastConnectedWallets = persistor.getItem((0, $9767eb4ee16f8000$export$8c649a701cb55656));
    if (lastConnectedWallets && lastConnectedWallets.length) {
        const connect_promises = [];
        lastConnectedWallets.forEach((walletType)=>{
            const wallet = wallets.get(walletType);
            if (!!wallet) {
                const walletInstance = getWalletInstance(wallet);
                connect_promises.push({
                    walletType: walletType,
                    eagerConnect: walletInstance.eagerConnect.bind(walletInstance)
                });
            }
        });
        const result = await Promise.allSettled(connect_promises.map(async ({ eagerConnect: eagerConnect })=>eagerConnect()));
        const canRestoreAnyConnection = !!result.find(({ status: status })=>status === "fulfilled");
        /*
     *After successfully connecting to at least one wallet,
     *we will removing the other wallets from persistence.
     *If we are unable to connect to any wallet,
     *the persistence will not be removed and the eager connection will be retried with another page load.
     */ if (canRestoreAnyConnection) {
            const walletsToRemoveFromPersistance = [];
            result.forEach((settleResult, index)=>{
                const { status: status } = settleResult;
                if (status === "rejected") walletsToRemoveFromPersistance.push(connect_promises[index].walletType);
            });
            if (walletsToRemoveFromPersistance.length) persistor.setItem((0, $9767eb4ee16f8000$export$8c649a701cb55656), lastConnectedWallets.filter((walletType)=>!walletsToRemoveFromPersistance.includes(walletType)));
        }
    }
}
function $2beaad4c97d35327$export$a94115b6ef8724e(dispatcher, onUpdateState) {
    const handler = (type, name, value, coreState, supportedChains)=>{
        const action = {
            type: "new_state",
            wallet: type,
            name: name,
            value: value
        };
        // Update state
        dispatcher(action);
        // Giving the event to the outside listener
        if (onUpdateState) onUpdateState(type, name, value, coreState, supportedChains);
    };
    return handler;
}



parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $63b3b140a1f1bba1$var$defaultErrorMesssage = "Context hasn't been initialized yet.";
const $63b3b140a1f1bba1$var$defaultContext = {
    async connect () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    async disconnect () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    async disconnectAll () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    async suggestAndConnect () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    state () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    canSwitchNetworkTo () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    providers () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    getWalletInfo () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    },
    getSigners () {
        throw new Error($63b3b140a1f1bba1$var$defaultErrorMesssage);
    }
};
const $63b3b140a1f1bba1$export$19648c908dc8d0bf = (0, $exYeM.createContext)($63b3b140a1f1bba1$var$defaultContext);



var $exYeM = parcelRequire("exYeM");


var $8aS14 = parcelRequire("8aS14");

var $exYeM = parcelRequire("exYeM");

function $3fc2765fe288a6f8$export$ff0ad642b4872edc(onChangeState) {
    const availableWallets = (0, $exYeM.useRef)({});
    /*
   * If `wallet` hasn't been added to `availableWallets`,
   * Get a instance of `Wallet` and save the refrence in `availableWallets`.
   * Otherwise, return the already created instance.
   */ function updater(wallet) {
        const type = wallet.config.type;
        // We only update, if there is no instance available.
        if (typeof availableWallets.current[type] === "undefined") availableWallets.current[type] = new (0, $8aS14.LegacyWallet)({
            config: wallet.config,
            handler: onChangeState
        }, wallet.actions);
        return availableWallets.current[type];
    }
    return updater;
}
function $3fc2765fe288a6f8$export$934951b5ed2ebf82() {
    const context = (0, $exYeM.useContext)((0, $63b3b140a1f1bba1$export$19648c908dc8d0bf));
    if (!context) throw Error("useWallet can only be used within the Provider component");
    return context;
}



var $exYeM = parcelRequire("exYeM");

function $00ad5059f80d2887$export$6c56af1685106432(props) {
    const autoConnectInitiated = (0, $exYeM.useRef)(false);
    // Running auto connect on instances
    (0, $exYeM.useEffect)(()=>{
        const shouldTryAutoConnect = props.allBlockChains && props.allBlockChains.length && props.autoConnect && !autoConnectInitiated.current;
        if (shouldTryAutoConnect) {
            autoConnectInitiated.current = true;
            (async ()=>{
                await (0, $2beaad4c97d35327$export$392c2457b7907874)(props.wallets, props.getWalletInstanceFromLegacy);
            })();
        }
    }, [
        props.autoConnect,
        props.allBlockChains
    ]);
}


function $d1c0d1b4e9ab308f$export$fefdcf5a1fbabdc6(props) {
    const [providersState, dispatch] = (0, $exYeM.useReducer)((0, $2beaad4c97d35327$export$ca8ebd435faad836), {});
    // Get (or add) wallet instance (`provider`s will be wrapped in a `Wallet`)
    const getWalletInstance = (0, $3fc2765fe288a6f8$export$ff0ad642b4872edc)((0, $2beaad4c97d35327$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
    // Getting providers from props and put all of them in a `Map` with an appropriate interface.
    const listOfProviders = props.providers;
    const wallets = (0, $2beaad4c97d35327$export$927cec00467ddd76)(listOfProviders);
    (0, $00ad5059f80d2887$export$6c56af1685106432)({
        wallets: wallets,
        allBlockChains: props.allBlockChains,
        autoConnect: props.autoConnect,
        getWalletInstanceFromLegacy: getWalletInstance
    });
    // Final API we put in context and it will be available to use for users.
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const api = {
        async connect (type, network, namespaces) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const result = await walletInstance.connect(network, namespaces);
            if (props.autoConnect) (0, $2beaad4c97d35327$export$567be3f12e4409f4)({
                type: type,
                walletActions: wallet.actions,
                getState: api.state
            });
            return result;
        },
        async disconnect (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            await walletInstance.disconnect();
            if (props.autoConnect) (0, $2beaad4c97d35327$export$967c813e2e19faa4)({
                type: type,
                walletActions: wallet.actions
            });
        },
        async disconnectAll () {
            const disconnect_promises = [];
            /*
       * When a wallet is initializing, a record will be added to `providersState`
       * So we use them to know what wallet has been initialized then we need to
       * filter connected wallets only.
       */ (0, $2beaad4c97d35327$export$5ae027e423e49e34)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    disconnect_promises.push(walletInstance.disconnect());
                }
            });
            if (props.autoConnect) (0, $2beaad4c97d35327$export$68f445eb81c96373)();
            return await Promise.allSettled(disconnect_promises);
        },
        async suggestAndConnect (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const result = await walletInstance.suggestAndConnect(network);
            return result;
        },
        state (type) {
            return providersState[type] || (0, $2beaad4c97d35327$export$583dd06ffb7665f8);
        },
        canSwitchNetworkTo (type, network) {
            const wallet = wallets.get(type);
            if (!wallet) return false;
            const walletInstance = getWalletInstance(wallet);
            return walletInstance.canSwitchNetworkTo ? walletInstance.canSwitchNetworkTo(network, walletInstance.provider) : false;
        },
        providers () {
            const providers = {};
            (0, $2beaad4c97d35327$export$fa8b8bfe0657110e)(providersState).forEach((type)=>{
                const wallet = wallets.get(type);
                if (wallet) {
                    const walletInstance = getWalletInstance(wallet);
                    providers[type] = walletInstance.provider;
                }
            });
            return providers;
        },
        getWalletInfo (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            /*
       * Get wallet info could be used in render methods to show wallets data
       * So, addWalletRef method shouldn't be called in this method
       */ return wallet.actions.getWalletInfo(props.allBlockChains || []);
        },
        async getSigners (type) {
            const wallet = wallets.get(type);
            if (!wallet) throw new Error(`You should add ${type} to provider first.`);
            const walletInstance = getWalletInstance(wallet);
            const provider = walletInstance.provider;
            const result = walletInstance.getSigners(provider);
            return result;
        }
    };
    // Initialize instances
    (0, $exYeM.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const runOnInit = ()=>{
                if (walletInstance.onInit) walletInstance.onInit();
            };
            const initWhenPageIsReady = (event)=>{
                if (event.target && event.target.readyState === "complete") {
                    runOnInit();
                    document.removeEventListener("readystatechange", initWhenPageIsReady);
                }
            };
            // Try to run, maybe it's ready.
            runOnInit();
            /*
       * Try again when the page has been completely loaded.
       * Some of wallets, take some time to be fully injected and loaded.
       */ document.addEventListener("readystatechange", initWhenPageIsReady);
        });
    }, []);
    // Setting supported blockchains on instances
    (0, $exYeM.useEffect)(()=>{
        const allBlockChains = props.allBlockChains;
        if (allBlockChains) wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            const walletInfo = walletInstance.getWalletInfo(props.allBlockChains || []);
            walletInstance.setInfo({
                supportedBlockchains: walletInfo.supportedChains,
                isContractWallet: !!walletInfo.isContractWallet
            });
        });
    }, [
        props.allBlockChains
    ]);
    // Setting event handler on instances
    (0, $exYeM.useEffect)(()=>{
        wallets.forEach((wallet)=>{
            const walletInstance = getWalletInstance(wallet);
            walletInstance.setHandler((0, $2beaad4c97d35327$export$a94115b6ef8724e)(dispatch, props.onUpdateState));
        });
    }, [
        props.onUpdateState
    ]);
    return api;
}


function $e812922bcaff6f9f$var$Provider(props) {
    const legacyApi = (0, $d1c0d1b4e9ab308f$export$fefdcf5a1fbabdc6)(props);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $63b3b140a1f1bba1$export$19648c908dc8d0bf).Provider, {
        value: legacyApi,
        children: props.children
    });
}
var $e812922bcaff6f9f$export$2e2bcd8739ae039 = $e812922bcaff6f9f$var$Provider;



var $b5172e8f52f8965a$export$ada873a34909da65;
(function(Events) {
    Events["CONNECTED"] = "connected";
    Events["CONNECTING"] = "connecting";
    Events["REACHABLE"] = "reachable";
    Events["INSTALLED"] = "installed";
    Events["ACCOUNTS"] = "accounts";
    Events["NETWORK"] = "network";
})($b5172e8f52f8965a$export$ada873a34909da65 || ($b5172e8f52f8965a$export$ada873a34909da65 = {}));




parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");

var $b25800e7eec8f6bb$exports = {};
"use strict";
/**
 * @file **unraw** | Convert raw escape sequences to their respective characters
 * (undo `String.raw`).
 * @author Ian Sanders
 * @copyright 2019 Ian Sanders
 * @license MIT
 */ Object.defineProperty($b25800e7eec8f6bb$exports, "__esModule", {
    value: true
});
var $bd21120657055abb$exports = {};
"use strict";
/**
 * @file **unraw - errors.ts** | Error messages used by `unraw`.
 * @author Ian Sanders
 * @copyright 2019 Ian Sanders
 * @license MIT
 */ Object.defineProperty($bd21120657055abb$exports, "__esModule", {
    value: true
});
// NOTE: don't construct errors here or they'll have the wrong stack trace.
// NOTE: don't make custom error class; the JS engines use `SyntaxError`
/**
 * Keys for possible error messages used by `unraw`.
 * Note: These do _not_ map to actual error object types. All errors thrown
 * are `SyntaxError`.
 */ // Don't use const enum or JS users won't be able to access the enum values
var $bd21120657055abb$var$ErrorType;
(function(ErrorType) {
    /**
     * Thrown when a badly formed Unicode escape sequence is found. Possible
     * reasons include the code being too short (`"\u25"`) or having invalid
     * characters (`"\u2$A5"`).
     */ ErrorType["MalformedUnicode"] = "MALFORMED_UNICODE";
    /**
     * Thrown when a badly formed hexadecimal escape sequence is found. Possible
     * reasons include the code being too short (`"\x2"`) or having invalid
     * characters (`"\x2$"`).
     */ ErrorType["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
    /**
     * Thrown when a Unicode code point escape sequence has too high of a code
     * point. The maximum code point allowed is `\u{10FFFF}`, so `\u{110000}` and
     * higher will throw this error.
     */ ErrorType["CodePointLimit"] = "CODE_POINT_LIMIT";
    /**
     * Thrown when an octal escape sequences is encountered and `allowOctals` is
     * `false`. For example, `unraw("\234", false)`.
     */ ErrorType["OctalDeprecation"] = "OCTAL_DEPRECATION";
    /**
     * Thrown only when a single backslash is found at the end of a string. For
     * example, `"\\"` or `"test\\x24\\"`.
     */ ErrorType["EndOfString"] = "END_OF_STRING";
})($bd21120657055abb$var$ErrorType = $bd21120657055abb$exports.ErrorType || ($bd21120657055abb$exports.ErrorType = {}));
/** Map of error message names to the full text of the message. */ $bd21120657055abb$exports.errorMessages = new Map([
    [
        $bd21120657055abb$var$ErrorType.MalformedUnicode,
        "malformed Unicode character escape sequence"
    ],
    [
        $bd21120657055abb$var$ErrorType.MalformedHexadecimal,
        "malformed hexadecimal character escape sequence"
    ],
    [
        $bd21120657055abb$var$ErrorType.CodePointLimit,
        "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
        $bd21120657055abb$var$ErrorType.OctalDeprecation,
        '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [
        $bd21120657055abb$var$ErrorType.EndOfString,
        "malformed escape sequence at end of string"
    ]
]);


$b25800e7eec8f6bb$exports.ErrorType = $bd21120657055abb$exports.ErrorType;
$b25800e7eec8f6bb$exports.errorMessages = $bd21120657055abb$exports.errorMessages;
/**
 * Parse a string as a base-16 number. This is more strict than `parseInt` as it
 * will not allow any other characters, including (for example) "+", "-", and
 * ".".
 * @param hex A string containing a hexadecimal number.
 * @returns The parsed integer, or `NaN` if the string is not a valid hex
 * number.
 */ function $b25800e7eec8f6bb$var$parseHexToInt(hex) {
    const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
    return isOnlyHexChars ? parseInt(hex, 16) : NaN;
}
/**
 * Check the validity and length of a hexadecimal code and optionally enforces
 * a specific number of hex digits.
 * @param hex The string to validate and parse.
 * @param errorName The name of the error message to throw a `SyntaxError` with
 * if `hex` is invalid. This is used to index `errorMessages`.
 * @param enforcedLength If provided, will throw an error if `hex` is not
 * exactly this many characters.
 * @returns The parsed hex number as a normal number.
 * @throws {SyntaxError} If the code is not valid.
 */ function $b25800e7eec8f6bb$var$validateAndParseHex(hex, errorName, enforcedLength) {
    const parsedHex = $b25800e7eec8f6bb$var$parseHexToInt(hex);
    if (Number.isNaN(parsedHex) || enforcedLength !== undefined && enforcedLength !== hex.length) throw new SyntaxError($bd21120657055abb$exports.errorMessages.get(errorName));
    return parsedHex;
}
/**
 * Parse a two-digit hexadecimal character escape code.
 * @param code The two-digit hexadecimal number that represents the character to
 * output.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the code is not valid hex or is not the right
 * length.
 */ function $b25800e7eec8f6bb$var$parseHexadecimalCode(code) {
    const parsedCode = $b25800e7eec8f6bb$var$validateAndParseHex(code, $bd21120657055abb$exports.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(parsedCode);
}
/**
 * Parse a four-digit Unicode character escape code.
 * @param code The four-digit unicode number that represents the character to
 * output.
 * @param surrogateCode Optional four-digit unicode surrogate that represents
 * the other half of the character to output.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the codes are not valid hex or are not the right
 * length.
 */ function $b25800e7eec8f6bb$var$parseUnicodeCode(code, surrogateCode) {
    const parsedCode = $b25800e7eec8f6bb$var$validateAndParseHex(code, $bd21120657055abb$exports.ErrorType.MalformedUnicode, 4);
    if (surrogateCode !== undefined) {
        const parsedSurrogateCode = $b25800e7eec8f6bb$var$validateAndParseHex(surrogateCode, $bd21120657055abb$exports.ErrorType.MalformedUnicode, 4);
        return String.fromCharCode(parsedCode, parsedSurrogateCode);
    }
    return String.fromCharCode(parsedCode);
}
/**
 * Test if the text is surrounded by curly braces (`{}`).
 * @param text Text to check.
 * @returns `true` if the text is in the form `{*}`.
 */ function $b25800e7eec8f6bb$var$isCurlyBraced(text) {
    return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
}
/**
 * Parse a Unicode code point character escape code.
 * @param codePoint A unicode escape code point, including the surrounding curly
 * braces.
 * @returns The single character represented by the code.
 * @throws {SyntaxError} If the code is not valid hex or does not have the
 * surrounding curly braces.
 */ function $b25800e7eec8f6bb$var$parseUnicodeCodePointCode(codePoint) {
    if (!$b25800e7eec8f6bb$var$isCurlyBraced(codePoint)) throw new SyntaxError($bd21120657055abb$exports.errorMessages.get($bd21120657055abb$exports.ErrorType.MalformedUnicode));
    const withoutBraces = codePoint.slice(1, -1);
    const parsedCode = $b25800e7eec8f6bb$var$validateAndParseHex(withoutBraces, $bd21120657055abb$exports.ErrorType.MalformedUnicode);
    try {
        return String.fromCodePoint(parsedCode);
    } catch (err) {
        throw err instanceof RangeError ? new SyntaxError($bd21120657055abb$exports.errorMessages.get($bd21120657055abb$exports.ErrorType.CodePointLimit)) : err;
    }
}
// Have to give overload that takes boolean for when compiler doesn't know if
// true or false
function $b25800e7eec8f6bb$var$parseOctalCode(code, error = false) {
    if (error) throw new SyntaxError($bd21120657055abb$exports.errorMessages.get($bd21120657055abb$exports.ErrorType.OctalDeprecation));
    // The original regex only allows digits so we don't need to have a strict
    // octal parser like hexToInt. Length is not enforced for octals.
    const parsedCode = parseInt(code, 8);
    return String.fromCharCode(parsedCode);
}
/**
 * Map of unescaped letters to their corresponding special JS escape characters.
 * Intentionally does not include characters that map to themselves like "\'".
 */ const $b25800e7eec8f6bb$var$singleCharacterEscapes = new Map([
    [
        "b",
        "\b"
    ],
    [
        "f",
        "\f"
    ],
    [
        "n",
        "\n"
    ],
    [
        "r",
        "\r"
    ],
    [
        "t",
        "	"
    ],
    [
        "v",
        "\v"
    ],
    [
        "0",
        "\0"
    ]
]);
/**
 * Parse a single character escape sequence and return the matching character.
 * If none is matched, defaults to `code`.
 * @param code A single character code.
 */ function $b25800e7eec8f6bb$var$parseSingleCharacterCode(code) {
    return $b25800e7eec8f6bb$var$singleCharacterEscapes.get(code) || code;
}
/**
 * Matches every escape sequence possible, including invalid ones.
 *
 * All capture groups (described below) are unique (only one will match), except
 * for 4, which can only potentially match if 3 does.
 *
 * **Capture Groups:**
 * 0. A single backslash
 * 1. Hexadecimal code
 * 2. Unicode code point code with surrounding curly braces
 * 3. Unicode escape code with surrogate
 * 4. Surrogate code
 * 5. Unicode escape code without surrogate
 * 6. Octal code _NOTE: includes "0"._
 * 7. A single character (will never be \, x, u, or 0-3)
 */ const $b25800e7eec8f6bb$var$escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
/**
 * Replace raw escape character strings with their escape characters.
 * @param raw A string where escape characters are represented as raw string
 * values like `\'` rather than `'`.
 * @param allowOctals If `true`, will process the now-deprecated octal escape
 * sequences (ie, `\111`).
 * @returns The processed string, with escape characters replaced by their
 * respective actual Unicode characters.
 */ function $b25800e7eec8f6bb$var$unraw(raw, allowOctals = false) {
    return raw.replace($b25800e7eec8f6bb$var$escapeMatch, function(_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
        // Compare groups to undefined because empty strings mean different errors
        // Otherwise, `\u` would fail the same as `\` which is wrong.
        if (backslash !== undefined) return "\\";
        if (hex !== undefined) return $b25800e7eec8f6bb$var$parseHexadecimalCode(hex);
        if (codePoint !== undefined) return $b25800e7eec8f6bb$var$parseUnicodeCodePointCode(codePoint);
        if (unicodeWithSurrogate !== undefined) return $b25800e7eec8f6bb$var$parseUnicodeCode(unicodeWithSurrogate, surrogate);
        if (unicode !== undefined) return $b25800e7eec8f6bb$var$parseUnicodeCode(unicode);
        if (octal === "0") return "\0";
        if (octal !== undefined) return $b25800e7eec8f6bb$var$parseOctalCode(octal, !allowOctals);
        if (singleCharacter !== undefined) return $b25800e7eec8f6bb$var$parseSingleCharacterCode(singleCharacter);
        throw new SyntaxError($bd21120657055abb$exports.errorMessages.get($bd21120657055abb$exports.ErrorType.EndOfString));
    });
}
$b25800e7eec8f6bb$exports.unraw = $b25800e7eec8f6bb$var$unraw;
$b25800e7eec8f6bb$exports.default = $b25800e7eec8f6bb$var$unraw;



const $e58de2ce5f95dde9$var$isString = (s)=>typeof s === "string";
const $e58de2ce5f95dde9$var$isFunction = (f)=>typeof f === "function";
const $e58de2ce5f95dde9$var$cache = /* @__PURE__ */ new Map();
function $e58de2ce5f95dde9$var$normalizeLocales(locales) {
    const out = Array.isArray(locales) ? locales : [
        locales
    ];
    return [
        ...out,
        "en"
    ];
}
function $e58de2ce5f95dde9$var$date(locales, value, format) {
    const _locales = $e58de2ce5f95dde9$var$normalizeLocales(locales);
    const formatter = $e58de2ce5f95dde9$var$getMemoized(()=>$e58de2ce5f95dde9$var$cacheKey("date", _locales, format), ()=>new Intl.DateTimeFormat(_locales, format));
    return formatter.format($e58de2ce5f95dde9$var$isString(value) ? new Date(value) : value);
}
function $e58de2ce5f95dde9$var$number(locales, value, format) {
    const _locales = $e58de2ce5f95dde9$var$normalizeLocales(locales);
    const formatter = $e58de2ce5f95dde9$var$getMemoized(()=>$e58de2ce5f95dde9$var$cacheKey("number", _locales, format), ()=>new Intl.NumberFormat(_locales, format));
    return formatter.format(value);
}
function $e58de2ce5f95dde9$var$plural(locales, ordinal, value, { offset: offset = 0, ...rules }) {
    const _locales = $e58de2ce5f95dde9$var$normalizeLocales(locales);
    const plurals = ordinal ? $e58de2ce5f95dde9$var$getMemoized(()=>$e58de2ce5f95dde9$var$cacheKey("plural-ordinal", _locales), ()=>new Intl.PluralRules(_locales, {
            type: "ordinal"
        })) : $e58de2ce5f95dde9$var$getMemoized(()=>$e58de2ce5f95dde9$var$cacheKey("plural-cardinal", _locales), ()=>new Intl.PluralRules(_locales, {
            type: "cardinal"
        }));
    return rules[value] ?? rules[plurals.select(value - offset)] ?? rules.other;
}
function $e58de2ce5f95dde9$var$getMemoized(getKey, construct) {
    const key = getKey();
    let formatter = $e58de2ce5f95dde9$var$cache.get(key);
    if (!formatter) {
        formatter = construct();
        $e58de2ce5f95dde9$var$cache.set(key, formatter);
    }
    return formatter;
}
function $e58de2ce5f95dde9$var$cacheKey(type, locales, options) {
    const localeKey = locales.join("-");
    return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
const $e58de2ce5f95dde9$export$55069460464ca7a9 = {
    __proto__: null,
    date: $e58de2ce5f95dde9$var$date,
    number: $e58de2ce5f95dde9$var$number,
    plural: $e58de2ce5f95dde9$var$plural
};
const $e58de2ce5f95dde9$var$UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
const $e58de2ce5f95dde9$var$getDefaultFormats = (locale, locales, formats = {})=>{
    locales = locales || locale;
    const style = (format)=>$e58de2ce5f95dde9$var$isString(format) ? formats[format] || {
            style: format
        } : format;
    const replaceOctothorpe = (value, message)=>{
        const numberFormat = Object.keys(formats).length ? style("number") : {};
        const valueStr = $e58de2ce5f95dde9$var$number(locales, value, numberFormat);
        return message.replace("#", valueStr);
    };
    return {
        plural: (value, cases)=>{
            const { offset: offset = 0 } = cases;
            const message = $e58de2ce5f95dde9$var$plural(locales, false, value, cases);
            return replaceOctothorpe(value - offset, message);
        },
        selectordinal: (value, cases)=>{
            const { offset: offset = 0 } = cases;
            const message = $e58de2ce5f95dde9$var$plural(locales, true, value, cases);
            return replaceOctothorpe(value - offset, message);
        },
        select: (value, rules)=>rules[value] ?? rules.other,
        number: (value, format)=>$e58de2ce5f95dde9$var$number(locales, value, style(format)),
        date: (value, format)=>$e58de2ce5f95dde9$var$date(locales, value, style(format)),
        undefined: (value)=>value
    };
};
function $e58de2ce5f95dde9$var$interpolate(translation, locale, locales) {
    return (values, formats = {})=>{
        const formatters = $e58de2ce5f95dde9$var$getDefaultFormats(locale, locales, formats);
        const formatMessage = (message)=>{
            if (!Array.isArray(message)) return message;
            return message.reduce((message2, token)=>{
                if ($e58de2ce5f95dde9$var$isString(token)) return message2 + token;
                const [name, type, format] = token;
                let interpolatedFormat = {};
                if (format != null && !$e58de2ce5f95dde9$var$isString(format)) Object.keys(format).forEach((key)=>{
                    interpolatedFormat[key] = formatMessage(format[key]);
                });
                else interpolatedFormat = format;
                const value = formatters[type](values[name], interpolatedFormat);
                if (value == null) return message2;
                return message2 + value;
            }, "");
        };
        const result = formatMessage(translation);
        if ($e58de2ce5f95dde9$var$isString(result) && $e58de2ce5f95dde9$var$UNICODE_REGEX.test(result)) return (0, (/*@__PURE__*/$parcel$interopDefault($b25800e7eec8f6bb$exports)))(result.trim());
        if ($e58de2ce5f95dde9$var$isString(result)) return result.trim();
        return result;
    };
}
class $e58de2ce5f95dde9$var$EventEmitter {
    constructor(){
        this._events = {};
    }
    on(event, listener) {
        if (!this._hasEvent(event)) this._events[event] = [];
        this._events[event].push(listener);
        return ()=>this.removeListener(event, listener);
    }
    removeListener(event, listener) {
        if (!this._hasEvent(event)) return;
        const index = this._events[event].indexOf(listener);
        if (~index) this._events[event].splice(index, 1);
    }
    emit(event, ...args) {
        if (!this._hasEvent(event)) return;
        this._events[event].map((listener)=>listener.apply(this, args));
    }
    _hasEvent(event) {
        return Array.isArray(this._events[event]);
    }
}
class $e58de2ce5f95dde9$export$dbe3113d60765c1a extends $e58de2ce5f95dde9$var$EventEmitter {
    constructor(params){
        super();
        /**
     * Alias for {@see I18n._}
     */ this.t = this._.bind(this);
        this._messages = {};
        this._localeData = {};
        if (params.missing != null) this._missing = params.missing;
        if (params.messages != null) this.load(params.messages);
        if (params.localeData != null) this.loadLocaleData(params.localeData);
        if (params.locale != null || params.locales != null) this.activate(params.locale, params.locales);
    }
    get locale() {
        return this._locale;
    }
    get locales() {
        return this._locales;
    }
    get messages() {
        return this._messages[this._locale] ?? {};
    }
    /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */ get localeData() {
        return this._localeData[this._locale] ?? {};
    }
    _loadLocaleData(locale, localeData) {
        if (this._localeData[locale] == null) this._localeData[locale] = localeData;
        else Object.assign(this._localeData[locale], localeData);
    }
    /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */ loadLocaleData(localeOrAllData, localeData) {
        if (localeData != null) this._loadLocaleData(localeOrAllData, localeData);
        else Object.keys(localeOrAllData).forEach((locale)=>this._loadLocaleData(locale, localeOrAllData[locale]));
        this.emit("change");
    }
    _load(locale, messages) {
        if (this._messages[locale] == null) this._messages[locale] = messages;
        else Object.assign(this._messages[locale], messages);
    }
    load(localeOrMessages, messages) {
        if (messages != null) this._load(localeOrMessages, messages);
        else Object.keys(localeOrMessages).forEach((locale)=>this._load(locale, localeOrMessages[locale]));
        this.emit("change");
    }
    /**
   * @param options {@link LoadAndActivateOptions}
   */ loadAndActivate({ locale: locale, locales: locales, messages: messages }) {
        this._locale = locale;
        this._locales = locales || void 0;
        this._messages[this._locale] = messages;
        this.emit("change");
    }
    activate(locale, locales) {
        this._locale = locale;
        this._locales = locales;
        this.emit("change");
    }
    _(id, values = {}, { message: message, formats: formats } = {}) {
        if (!$e58de2ce5f95dde9$var$isString(id)) {
            values = id.values || values;
            message = id.message;
            id = id.id;
        }
        const messageMissing = !this.messages[id];
        const missing = this._missing;
        if (missing && messageMissing) return $e58de2ce5f95dde9$var$isFunction(missing) ? missing(this._locale, id) : missing;
        if (messageMissing) this.emit("missing", {
            id: id,
            locale: this._locale
        });
        let translation = this.messages[id] || message || id;
        if ($e58de2ce5f95dde9$var$isString(translation) && $e58de2ce5f95dde9$var$UNICODE_REGEX.test(translation)) return JSON.parse(`"${translation}"`);
        if ($e58de2ce5f95dde9$var$isString(translation)) return translation;
        return $e58de2ce5f95dde9$var$interpolate(translation, this._locale, this._locales)(values, formats);
    }
    date(value, format) {
        return $e58de2ce5f95dde9$var$date(this._locales || this._locale, value, format);
    }
    number(value, format) {
        return $e58de2ce5f95dde9$var$number(this._locales || this._locale, value, format);
    }
}
function $e58de2ce5f95dde9$export$ac011f04c7aa94a(params = {}) {
    return new $e58de2ce5f95dde9$export$dbe3113d60765c1a(params);
}
const $e58de2ce5f95dde9$export$a7357cdd1f0b0168 = $e58de2ce5f95dde9$export$ac011f04c7aa94a();



var $exYeM = parcelRequire("exYeM");
const $bc776e50cb44f318$export$4f3acf62dc72ccc7 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $bc776e50cb44f318$export$7cf632b40df9abf8() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($bc776e50cb44f318$export$4f3acf62dc72ccc7);
    return context;
}
const $bc776e50cb44f318$export$a54013f0d02a8f82 = ({ i18n: i18n, defaultComponent: defaultComponent, children: children })=>{
    const latestKnownLocale = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(i18n.locale);
    const makeContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>({
            i18n: i18n,
            defaultComponent: defaultComponent
        }), [
        i18n,
        defaultComponent
    ]);
    const [context, setContext] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(makeContext());
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const updateContext = ()=>{
            latestKnownLocale.current = i18n.locale;
            setContext(makeContext());
        };
        const unsubscribe = i18n.on("change", updateContext);
        if (latestKnownLocale.current !== i18n.locale) updateContext();
        return unsubscribe;
    }, [
        i18n,
        makeContext
    ]);
    if (!latestKnownLocale.current) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($bc776e50cb44f318$export$4f3acf62dc72ccc7.Provider, {
        value: context
    }, children);
};
const $bc776e50cb44f318$var$tagRe = /<([a-zA-Z0-9]+)>(.*?)<\/\1>|<([a-zA-Z0-9]+)\/>/;
const $bc776e50cb44f318$var$nlRe = /(?:\r\n|\r|\n)/g;
const $bc776e50cb44f318$var$voidElementTags = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
function $bc776e50cb44f318$var$formatElements(value, elements = {}) {
    const uniqueId = $bc776e50cb44f318$var$makeCounter(0, "$lingui$");
    const parts = value.replace($bc776e50cb44f318$var$nlRe, "").split($bc776e50cb44f318$var$tagRe);
    if (parts.length === 1) return value;
    const tree = [];
    const before = parts.shift();
    if (before) tree.push(before);
    for (const [index, children, after] of $bc776e50cb44f318$var$getElements(parts)){
        let element = elements[index];
        if (!element || $bc776e50cb44f318$var$voidElementTags[element.type] && children) {
            if (!element) console.error(`Can't use element at index '${index}' as it is not declared in the original translation`);
            else console.error(`${element.type} is a void element tag therefore it must have no children`);
            element = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment);
        }
        if (Array.isArray(element)) element = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {}, element);
        tree.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(element, {
            key: uniqueId()
        }, // format children for pair tags
        // unpaired tags might have children if it's a component passed as a variable
        children ? $bc776e50cb44f318$var$formatElements(children, elements) : element.props.children));
        if (after) tree.push(after);
    }
    return tree;
}
function $bc776e50cb44f318$var$getElements(parts) {
    if (!parts.length) return [];
    const [paired, children, unpaired, after] = parts.slice(0, 4);
    return [
        [
            paired || unpaired,
            children || "",
            after
        ]
    ].concat($bc776e50cb44f318$var$getElements(parts.slice(4, parts.length)));
}
const $bc776e50cb44f318$var$makeCounter = (count = 0, prefix = "")=>()=>`${prefix}_${count++}`;
function $bc776e50cb44f318$export$8d6a9236f2e3f2ce(props) {
    const { i18n: i18n, defaultComponent: defaultComponent } = $bc776e50cb44f318$export$7cf632b40df9abf8();
    const { render: render, component: component, id: id, message: message, formats: formats } = props;
    const values = {
        ...props.values
    };
    const components = {
        ...props.components
    };
    if (values) Object.keys(values).forEach((key)=>{
        const value = values[key];
        const valueIsReactEl = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).isValidElement(value) || Array.isArray(value) && value.every((el)=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).isValidElement(el));
        if (!valueIsReactEl) return;
        const index = Object.keys(components).length;
        components[index] = value;
        values[key] = `<${index}/>`;
    });
    const _translation = i18n && typeof i18n._ === "function" ? i18n._(id, values, {
        message: message,
        formats: formats
    }) : id;
    const translation = _translation ? $bc776e50cb44f318$var$formatElements(_translation, components) : null;
    if (render === null || component === null) return translation;
    const FallbackComponent = defaultComponent || $bc776e50cb44f318$var$RenderFragment;
    const i18nProps = {
        id: id,
        message: message,
        translation: translation,
        isTranslated: id !== translation && message !== translation,
        children: translation
    };
    if (render && component) console.error("You can't use both `component` and `render` prop at the same time. `component` is ignored.");
    else if (render && typeof render !== "function") console.error(`Invalid value supplied to prop \`render\`. It must be a function, provided ${render}`);
    else if (component && typeof component !== "function") {
        console.error(`Invalid value supplied to prop \`component\`. It must be a React component, provided ${component}`);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(FallbackComponent, i18nProps, translation);
    }
    if (typeof render === "function") return render(i18nProps);
    const Component = component || FallbackComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, i18nProps, translation);
}
const $bc776e50cb44f318$var$RenderFragment = ({ children: children })=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, children);
};



var $exYeM = parcelRequire("exYeM");
/*eslint-disable*/ const $9eb8ba525c3d6ebc$export$defe85febe8b728c = JSON.parse('{"No results found":"Geen resultate gevind nie","Try using different keywords":"Probeer om verskillende sleutelwoorde te gebruik","Select Chain":"Kies Ketting","All":"Almal","More +{count}":["Meer +",["count"]],"Activate this tab":"Aktiveer hierdie oortjie","Another tab is open and handles transactions.":"Nog \'n oortjie is oop en hanteer transaksies.","Activate current tab":"Aktiveer huidige oortjie","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Tans loop sommige transaksies en word dit deur \'n ander blaaieroortjie hanteer. As jy hierdie oortjie aktiveer, sal alle transaksies wat reeds in die transaksietekenstap is, verval.","Confirm":"Bevestig","Your {blockchainName} wallets":["Jou ",["blockchainName"]," beursies"],"Insufficient account balance":"Onvoldoende rekeningsaldo","Proceed anyway":"Gaan in elk geval voort","You need to connect a {blockchainName} wallet.":["Jy moet \'n ",["blockchainName"]," beursie koppel."],"Add {chain} chain":["Voeg ",["chain"]," ketting by"],"Show more wallets":"Wys meer beursies","Send to a different address":"Stuur na \'n ander adres","Enter {blockchainName} address":["Voer ",["blockchainName"]," adres in"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adres ",["destination"]," pas nie by die blokkettingadrespatroon nie."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Hierdie token verskyn nie op die aktiewe tokenlys(e nie). Maak seker dit is die teken wat jy wil verhandel.","Import":"Invoer","Status":"Status","Reset":"Stel terug","Cancel":"Kanselleer","Refresh":"Verfris","Notifications":"Kennisgewings","Settings":"Instellings","History":"Geskiedenis","Connect Wallet":"Koppel Wallet","Today":"Vandag","Swaps steps":"Ruil trappe om","Retry":"Probeer weer","Slippage Error":"Glipfout","Slippage Warning":"Glipwaarskuwing","Bridge Limit Error":"Bruglimietfout","Yours: {amount} {symbol}":["Die uwe: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum vereiste glip: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Die uwe: ",["userSlippage"]],"See All Routes":"Sien Alle Roetes","View more info":"Bekyk meer inligting","Gas & Fee Explanation":"Gas & Fooi Verduideliking","Details":"Besonderhede","Total Payable Fee":"Totale betaalbare fooi","Hide non-payable fees":"Versteek nie-betaalbare fooie","Show non-payable fees":"Toon nie-betaalbare fooie","Description":"Beskrywing","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Die volgende fooie word in die transaksie-uitset in ag geneem en\\n                sal jy nie ekstra gas daarvoor hoef te betaal nie.","Swap input":"Wissel invoer","Estimated output":"Geskatte uitset","Via:":"Via:","Chains:":"Kettings:","Sort by":"Sorteer volgens","Smart Routing":"Slim roetering","Lowest Fee":"Laagste fooi","Fastest Transfer":"Vinnigste oordrag","Maximum Return":"Maksimum opbrengs","Maximum Output":"Maksimum uitset","Swapping":"Omruil","Gas cost":"Gas koste","Receiving":"Ontvangs","Price impact":"Prys impak","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Jy moet glip verhoog tot minstens ",["minRequiredSlippage"]," vir hierdie roete."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Ons beveel aan dat jy glip verhoog tot minstens ",["minRequiredSlippage"]," vir hierdie roete."],"Caution, your slippage is high.":"Wees versigtig, jou glip is hoog.","Change":"Verander","Change settings":"Verander instellings","High slippage":"Ho\xeb gly","Low slippage":"Lae gly"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Wees versigtig, jou glip is hoog (=",["userSlippage"],"). Jou handel kan voorloper wees."],"Confirm anyway":"Bevestig in elk geval","Something went wrong":"Iets het verkeerd geloop","Something went wrong. Please refresh the app.":"Iets het verkeerd geloop. Herlaai asseblief die toepassing.","Slippage tolerance per swap":"Gliptoleransie per ruil","Custom":"Pasgemaak","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Jou transaksie sal teruggedraai word as die prys ongunstig verander met meer as hierdie persentasie.","Warning":"Waarskuwing","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Hierdie instelling word op elke stap toegepas (bv. 1Inch, Thorchain, ens.), wat beteken dat slegs daardie spesifieke stap teruggekeer sal word, nie die hele roete nie.","Swap Details":"Ruil Besonderhede","Request ID":"Versoek ID","Not found":"Nie gevind nie","Swap with request ID = {requestId} not found.":["Ruil met versoek-ID = ",["requestId"]," nie gevind nie."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Jy het ",["amount"]," ",["token"]," in ",["conciseAddress"]," beursie op ",["chain"]," ketting ontvang."],"Transaction was not sent.":"Transaksie is nie gestuur nie.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," op ",["blockchain"]," bly in jou beursie."],"Delete":"Vee uit","Try again":"Probeer weer","Copied To Clipboard":"Gekopieer na knipbord","Copy Request ID":"Kopieer versoek-ID","View on Rango Explorer":"Kyk op Rango Explorer","Finished at":"Klaar om","Created at":"Geskep by","View transaction":"Bekyk transaksie","Connect":"Koppel","Swap Successful":"Ruil Suksesvol","Transaction Failed":"Transaksie het misluk","Done":"Klaar","Diagnosis":"Diagnose","See Details":"Sien Besonderhede","Cancel Swap":"Kanselleer Ruil","Are you sure you want to cancel this swap?":"Is jy seker jy wil hierdie ruil kanselleer?","Yes, Cancel it":"Ja, kanselleer dit","No, Continue":"Nee, gaan voort","Delete Transaction":"Vee transaksie uit","Are you sure you want to delete this swap?":"Is jy seker jy wil hierdie ruil uitvee?","Yes, Delete it":"Ja, verwyder dit","No, Cancel":"Nee, kanselleer","Change Network":"Verander netwerk","Network Changed":"Netwerk verander","Select Token":"Kies Token","Wallet Connected":"Beursie gekoppel","Your wallet is connected, you can use it to swap.":"Jou beursie is gekoppel, jy kan dit gebruik om te ruil.","Failed to Connect":"Kon nie koppel nie","Your wallet is not connected. Please try again.":"Jou beursie is nie gekoppel nie. Probeer asseblief weer.","Connecting to your wallet":"Koppel aan jou beursie","Click connect in your wallet popup.":"Klik koppel in jou beursie-opspringer.","Select Derivation Path":"Kies Afleidingspad","In order to connect to {type}, you must first select a Derivation Path":["Om aan ",["type"],"te koppel, moet jy eers \'n Afleidingspad kies"],"Choose Derivation Path Template":"Kies Afleidingspadsjabloon","Enter Path":"Voer Pad in","Enter Index":"Voer indeks in","Add {blockchainDisplayName} Chain":["Voeg ",["blockchainDisplayName"]," Ketting by"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Wil jy die ",["blockchainDisplayName"]," eksperimentele ketting by jou beursie voeg?"],"Please approve the experimental chain pop-up in your wallet.":"Keur asseblief die eksperimentele ketting-opspringer in jou beursie goed.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Ketting bygevoeg"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Die ",["blockchainDisplayName"]," -ketting is suksesvol by jou beursie gevoeg."],"Request Rejected":"Versoek afgekeur","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Jy het geweier om ",["blockchainDisplayName"]," -ketting by jou beursie te voeg."],"Select chain types":"Kies tipes ketting","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Hierdie beursie ondersteun verskeie kettings. Kies aan watter ketting jy wil koppel.","Failed Network, Please retry your swap.":"Mislukte netwerk, probeer asseblief weer jou ruil.","Please reset your liquidity sources.":"Stel asseblief jou likiditeitsbronne terug.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Jy het die likiditeitsbronne beperk en dit kan daartoe lei dat Rango geen roetes vind nie. Oorweeg asseblief om jou likiditeitsbronne terug te stel.","No Routes Found.":"Geen roetes gevind nie.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Redes waarom Rango nie \'n roete kon vind nie: lae likiditeit op token, baie lae insetbedrag of geen roetes beskikbaar vir die geselekteerde inset/afvoertokenkombinasie nie.","Bridge Limit Error: Please increase your amount.":"Bruglimietfout: Verhoog asseblief jou bedrag.","Bridge Limit Error: Please decrease your amount.":"Bruglimietfout: verminder asseblief jou bedrag.","High Price Impact":"Ho\xeb prys impak","Price impact is too high!":"Prys impak is te hoog!","The price impact is significantly higher than the allowed amount.":"Die prysimpak is aansienlik ho\xebr as die toegelate bedrag.","Confirm high price impact":"Bevestig ho\xeb prys impak","Route updated and price impact is too high, try again later!":"Roete is opgedateer en prysimpak is te hoog, probeer later weer!","USD Price Unknown":"USD-prys onbekend","USD Price Unknown, Cannot calculate Price Impact.":"USD-prys onbekend, kan nie prysimpak bereken nie.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD-prys onbekend, kan nie prysimpak bereken nie. Die prysimpak kan ho\xebr as gewoonlik wees. Is jy seker om voort te gaan met die ruil?","Confirm USD Price Unknown":"Bevestig USD-prys onbekend","Swap":"Ruil","Swap anyway":"Ruil in elk geval","The route goes through Ethereum. Continue?":"Die roete gaan deur Ethereum. Gaan voort?","Route has been updated.":"Roete is opgedateer.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Uitsetbedrag verander na ",["newOutputAmount"]," (",["percentageChange"],"% verandering)."],"Route swappers has been updated.":"Roete-ruilers is opgedateer.","Route internal coins has been updated.":"Roete interne munte is opgedateer.","Routes":"Roetes","From":"Van","To":"Om","Light":"Lig","Dark":"Donker","Auto":"Outo","Loading failed":"Kon nie laai nie","Bridges":"Br\xfbe","Exchanges":"Uitruilings","Custom Tokens":"Pasgemaakte tekens","Language":"Taal","Infinite approval":"Oneindige goedkeuring","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Deur die \'Oneindige goedkeuring\'-modus te aktiveer, verleen onbeperkte toegang tot onderliggende slimkontrakte, wat hulle in staat stel om die goedgekeurde tokenbedrag sonder beperkings te gebruik.","Theme":"Tema","Duplicate Token":"Duplikaatteken","The address you entered is duplicate, please enter a new address.":"Die adres wat jy ingevoer het is duplikaat, voer asseblief \'n nuwe adres in.","Token Already Exists":"Teken bestaan reeds","There\'s no need to add this token again because it already exists and is supported by us.":"Dit is nie nodig om hierdie teken weer by te voeg nie, want dit bestaan reeds en word deur ons ondersteun.","Token Not Found":"Teken nie gevind nie","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Jammer, geen teken is op ",["blockchain"]," -ketting met die verskafde adres gevind nie. maak asseblief seker dat jy die regte tokenadres ingevoer het."],"Network Error":"Netwerkfout","Add Custom Token":"Voeg pasgemaakte teken by","Select chain":"Kies ketting","Enter Address":"Voer adres in","Enter token address":"Voer tokenadres in","Failed Network, Please retry.":"Mislukte netwerk, probeer asseblief weer.","Add another custom token":"Voeg nog \'n pasgemaakte teken by","Confirm Swap":"Bevestig omruiling","Start Swap":"Begin Swap","You get":"Jy kry","Search Token":"Soek Token","No custom tokens":"Geen pasgemaakte tekens nie","press the button to add your custom token":"druk die knoppie om jou pasgemaakte teken by te voeg","Delete Custom Token":"Vee gepasmaakte teken uit","Are you sure you want to Delete this Token?":"Is jy seker jy wil hierdie teken uitvee?","Complete":"Voltooi","Running":"Hardloop","Failed":"Misluk","Clear":"Duidelik","Search Transaction":"Soek transaksie","No transactions":"Geen transaksies nie","Your transaction history is stored locally and will appear here after you start a swap":"Jou transaksiegeskiedenis word plaaslik gestoor en sal hier verskyn nadat jy \'n ruil begin het","Clear Transaction History":"Vee transaksiegeskiedenis uit","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"As u voortgaan, sal alle suksesvolle en mislukte transaksies van die legstuk verwyder word. Wil jy voortgaan?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Let wel: Dit vee nie jou transaksiegeskiedenis op die ketting uit nie; dit verwyder hulle net hier.","Yes, Clear the history":"Ja, maak die geskiedenis skoon","language":"taal","Deselect all":"Ontkies almal","Select all":"Kies alles","Search {sourceType}":["Soek ",["sourceType"]],"Search Chain":"Soekketting","Source":"Bron","Destination":"Bestemming","Swap {type}":["Ruil ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Tans is jy in veldtogmodus met beperkings op likiditeitsbronne. Wil jy uit hierdie modus skakel en van alle beskikbare likiditeitsbronne gebruik maak?","The request ID is necessary to display the swap details.":"Die versoek-ID is nodig om die ruilbesonderhede te vertoon.","Connect Wallets":"Koppel beursies","Choose a wallet to connect.":"Kies \'n beursie om aan te sluit.","This week":"Hierdie week","This month":"Hierdie maand","This year":"Hierdie jaar","Required: >= {min} {symbol}":["Vereis: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Vereis: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Vereis: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Vereis: < ",["max"]," ",["symbol"]]," for network fee":" vir netwerkfooi"," for swap":" vir ruil"," for input and network fee":" vir insette en netwerkfooi","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Benodig \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", maar jy het ",["currentAmount"]," ",["symbol"]," in jou ",["blockchain"]," beursie."],"Waiting for connecting wallet":"Wag vir koppel beursie","Waiting for other running tasks to be finished":"Wag vir ander lopende take om klaar te wees","Waiting for changing wallet network":"Wag vir verandering van beursienetwerk","Sunday":"Sondag","Monday":"Maandag","Tuesday":"Dinsdag","Wednesday":"Woensdag","Thursday":"Donderdag","Friday":"Vrydag","Saturday":"Saterdag","Powered By":"Aangedryf deur","Aggregated Transaction":"Geaggregeerde transaksie","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Ruil op ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Brug na ",["toChain"]," via ",["swapper"]],"Completed":"Voltooi","In progress":"Aan die gang","Waiting for bridge transaction":"Wag vir brugtransaksie","Connected":"Gekoppel","Disconnect":"Ontkoppel","Install":"Installeer","Connecting ...":"Koppel tans \u2026","Connecting":"Verbind","Disconnected":"Ontkoppel","you need to pass a correct state to Wallet.":"jy moet \'n korrekte toestand aan Wallet deurgee.","There are no notifications.":"Daar is geen kennisgewings nie.","Clear all":"Vee alles uit","Balance":"Balans","Max":"Maks"}');


/*eslint-disable*/ const $70d3a57bbc5cc5ee$export$defe85febe8b728c = JSON.parse('{"No results found":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0646\u062A\u0627\u0626\u062C","Try using different keywords":"\u062D\u0627\u0648\u0644 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0643\u0644\u0645\u0627\u062A \u0631\u0626\u064A\u0633\u064A\u0629 \u0645\u062E\u062A\u0644\u0641\u0629","Select Chain":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0644\u0633\u0644\u0629","All":"\u0627\u0644\u062C\u0645\u064A\u0639","More +{count}":["\u0627\u0644\u0645\u0632\u064A\u062F +",["count"]],"Activate this tab":"\u062A\u0641\u0639\u064A\u0644 \u0647\u0630\u0647 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628","Another tab is open and handles transactions.":"\u0647\u0646\u0627\u0643 \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u0623\u062E\u0631\u0649 \u0645\u0641\u062A\u0648\u062D\u0629 \u0648\u062A\u062A\u0639\u0627\u0645\u0644 \u0645\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A.","Activate current tab":"\u062A\u0641\u0639\u064A\u0644 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0627\u0644\u062D\u0627\u0644\u064A\u0629","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u062D\u0627\u0644\u064A\u064B\u0627\u060C \u064A\u062A\u0645 \u062A\u0634\u063A\u064A\u0644 \u0628\u0639\u0636 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0648\u0645\u0639\u0627\u0644\u062C\u062A\u0647\u0627 \u0628\u0648\u0627\u0633\u0637\u0629 \u0639\u0644\u0627\u0645\u0629 \u062A\u0628\u0648\u064A\u0628 \u0623\u062E\u0631\u0649 \u0628\u0627\u0644\u0645\u062A\u0635\u0641\u062D. \u0625\u0630\u0627 \u0642\u0645\u062A \u0628\u062A\u0646\u0634\u064A\u0637 \u0639\u0644\u0627\u0645\u0629 \u0627\u0644\u062A\u0628\u0648\u064A\u0628 \u0647\u0630\u0647\u060C \u0641\u0633\u062A\u0646\u062A\u0647\u064A \u0635\u0644\u0627\u062D\u064A\u0629 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644 \u0641\u064A \u062E\u0637\u0648\u0629 \u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629.","Confirm":"\u064A\u062A\u0623\u0643\u062F","Your {blockchainName} wallets":["\u0645\u062D\u0641\u0638\u062A\u0643 ",["blockchainName"]],"Insufficient account balance":"\u0631\u0635\u064A\u062F \u0627\u0644\u062D\u0633\u0627\u0628 \u063A\u064A\u0631 \u0643\u0627\u0641","Proceed anyway":"\u0627\u0644\u0645\u0636\u064A \u0642\u062F\u0645\u0627 \u0639\u0644\u0649 \u0623\u064A\u0629 \u062D\u0627\u0644","You need to connect a {blockchainName} wallet.":["\u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u0629 ",["blockchainName"]," ."],"Add {chain} chain":["\u0623\u0636\u0641 \u0633\u0644\u0633\u0644\u0629 ",["chain"]],"Show more wallets":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u062D\u0627\u0641\u0638","Send to a different address":"\u0625\u0631\u0633\u0627\u0644 \u0625\u0644\u0649 \u0639\u0646\u0648\u0627\u0646 \u0645\u062E\u062A\u0644\u0641","Enter {blockchainName} address":["\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0627\u0644\u0639\u0646\u0648\u0627\u0646 ",["destination"]," \u0644\u0627 \u064A\u062A\u0637\u0627\u0628\u0642 \u0645\u0639 \u0646\u0645\u0637 \u0639\u0646\u0648\u0627\u0646 blockchain."],"via":"\u0639\u0628\u0631","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u0644\u0627 \u064A\u0638\u0647\u0631 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0641\u064A \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0646\u0634\u0637\u0629. \u062A\u0623\u0643\u062F \u0645\u0646 \u0623\u0646 \u0647\u0630\u0627 \u0647\u0648 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0630\u064A \u062A\u0631\u064A\u062F \u062A\u062F\u0627\u0648\u0644\u0647.","Import":"\u064A\u0633\u062A\u0648\u0631\u062F","Status":"\u062D\u0627\u0644\u0629","Reset":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637","Cancel":"\u064A\u0644\u063A\u064A","Refresh":"\u064A\u0646\u0639\u0634","Notifications":"\u0625\u0634\u0639\u0627\u0631\u0627\u062A","Settings":"\u0625\u0639\u062F\u0627\u062F\u0627\u062A","History":"\u062A\u0627\u0631\u064A\u062E","Connect Wallet":"\u0631\u0628\u0637 \u0627\u0644\u0645\u062D\u0641\u0638\u0629","Today":"\u0627\u0644\u064A\u0648\u0645","Swaps steps":"\u062E\u0637\u0648\u0627\u062A \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","Retry":"\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629","Slippage Error":"\u062E\u0637\u0623 \u0627\u0644\u0627\u0646\u0632\u0644\u0627\u0642","Slippage Warning":"\u062A\u062D\u0630\u064A\u0631 \u0645\u0646 \u0627\u0644\u0627\u0646\u0632\u0644\u0627\u0642","Bridge Limit Error":"\u062E\u0637\u0623 \u062D\u062F \u0627\u0644\u062C\u0633\u0631","Yours: {amount} {symbol}":["\u062E\u0627\u0635\u062A\u0643: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0644\u0644\u0627\u0646\u0632\u0644\u0627\u0642: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u062E\u0627\u0635\u062A\u0643: ",["userSlippage"]],"See All Routes":"\u0634\u0627\u0647\u062F \u062C\u0645\u064A\u0639 \u0627\u0644\u0637\u0631\u0642","View more info":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A","Gas & Fee Explanation":"\u0634\u0631\u062D \u0627\u0644\u063A\u0627\u0632 \u0648\u0627\u0644\u0631\u0633\u0648\u0645","Details":"\u062A\u0641\u0627\u0635\u064A\u0644","Total Payable Fee":"\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0645\u0633\u062A\u062D\u0642\u0629","Hide non-payable fees":"\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0631\u0633\u0648\u0645 \u063A\u064A\u0631 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062F\u0641\u0639","Show non-payable fees":"\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0631\u0633\u0648\u0645 \u063A\u064A\u0631 \u0627\u0644\u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u062F\u0641\u0639","Description":"\u0648\u0635\u0641","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u064A\u062A\u0645 \u0623\u062E\u0630 \u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u062A\u0627\u0644\u064A\u0629 \u0641\u064A \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631 \u0641\u064A \u0646\u0627\u062A\u062C \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0648\\n                \u0644\u0646 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u062F\u0641\u0639 \u0631\u0633\u0648\u0645 \u063A\u0627\u0632 \u0625\u0636\u0627\u0641\u064A\u0629 \u0645\u0642\u0627\u0628\u0644\u0647\u0627.","Swap input":"\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0645\u062F\u062E\u0644\u0627\u062A","Estimated output":"\u0627\u0644\u0646\u0627\u062A\u062C \u0627\u0644\u0645\u0642\u062F\u0631","Via:":"\u0639\u0628\u0631:","Chains:":"\u0627\u0644\u0633\u0644\u0627\u0633\u0644:","Sort by":"\u0641\u0631\u0632 \u062D\u0633\u0628","Smart Routing":"\u0627\u0644\u062A\u0648\u062C\u064A\u0647 \u0627\u0644\u0630\u0643\u064A","Lowest Fee":"\u0623\u0642\u0644 \u0631\u0633\u0648\u0645","Fastest Transfer":"\u0623\u0633\u0631\u0639 \u0646\u0642\u0644","Maximum Return":"\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u0639\u0627\u0626\u062F","Maximum Output":"\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u0625\u062E\u0631\u0627\u062C","Swapping":"\u062A\u0628\u0627\u062F\u0644","Gas cost":"\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u063A\u0627\u0632","Receiving":"\u0625\u0633\u062A\u0644\u0627\u0645","Price impact":"\u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0627\u0646\u0632\u0644\u0627\u0642 \u0625\u0644\u0649 ",["minRequiredSlippage"]," \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0647\u0630\u0627 \u0627\u0644\u0637\u0631\u064A\u0642."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u0646\u0646\u0635\u062D\u0643 \u0628\u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0627\u0646\u0632\u0644\u0627\u0642 \u0625\u0644\u0649 ",["minRequiredSlippage"]," \u0639\u0644\u0649 \u0627\u0644\u0623\u0642\u0644 \u0644\u0647\u0630\u0627 \u0627\u0644\u0637\u0631\u064A\u0642."],"Caution, your slippage is high.":"\u0627\u0646\u062A\u0628\u0647\u060C \u0627\u0646\u0632\u0644\u0627\u0642\u0643 \u0645\u0631\u062A\u0641\u0639.","Change":"\u064A\u062A\u063A\u064A\u0631","Change settings":"\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A","High slippage":"\u0627\u0646\u0632\u0644\u0627\u0642 \u0639\u0627\u0644\u064A","Low slippage":"\u0627\u0646\u0632\u0644\u0627\u0642 \u0645\u0646\u062E\u0641\u0636"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0627\u0646\u062A\u0628\u0647\u060C \u0627\u0646\u0632\u0644\u0627\u0642\u0643 \u0645\u0631\u062A\u0641\u0639 (=",["userSlippage"],"). \u0642\u062F \u062A\u0643\u0648\u0646 \u062A\u062C\u0627\u0631\u062A\u0643 \u0641\u064A \u0627\u0644\u0645\u0642\u062F\u0645\u0629."],"Confirm anyway":"\u062A\u0623\u0643\u064A\u062F \u0639\u0644\u0649 \u0623\u064A\u0629 \u062D\u0627\u0644","Something went wrong":"\u0644\u0642\u062F \u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627","Something went wrong. Please refresh the app.":"\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627. \u064A\u0631\u062C\u0649 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062A\u0637\u0628\u064A\u0642.","Slippage tolerance per swap":"\u062A\u062D\u0645\u0644 \u0627\u0644\u0627\u0646\u0632\u0644\u0627\u0642 \u0644\u0643\u0644 \u0645\u0628\u0627\u062F\u0644\u0629","Custom":"\u0645\u062E\u0635\u0635","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0633\u064A\u062A\u0645 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0645\u0639\u0627\u0645\u0644\u062A\u0643 \u0625\u0630\u0627 \u062A\u063A\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0628\u0634\u0643\u0644 \u063A\u064A\u0631 \u0645\u0648\u0627\u062A\u064D \u0628\u0646\u0633\u0628\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 \u0647\u0630\u0647 \u0627\u0644\u0646\u0633\u0628\u0629.","Warning":"\u062A\u062D\u0630\u064A\u0631","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u064A\u062A\u0645 \u062A\u0637\u0628\u064A\u0642 \u0647\u0630\u0627 \u0627\u0644\u0625\u0639\u062F\u0627\u062F \u0639\u0644\u0649 \u0643\u0644 \u062E\u0637\u0648\u0629 (\u0639\u0644\u0649 \u0633\u0628\u064A\u0644 \u0627\u0644\u0645\u062B\u0627\u0644 1Inch\u060C Thorchain\u060C \u0648\u0645\u0627 \u0625\u0644\u0649 \u0630\u0644\u0643)\u060C \u0645\u0645\u0627 \u064A\u0639\u0646\u064A \u0623\u0646\u0647 \u0633\u064A\u062A\u0645 \u0627\u0644\u062A\u0631\u0627\u062C\u0639 \u0639\u0646 \u0647\u0630\u0647 \u0627\u0644\u062E\u0637\u0648\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0641\u0642\u0637\u060C \u0648\u0644\u064A\u0633 \u0627\u0644\u0645\u0633\u0627\u0631 \u0628\u0627\u0644\u0643\u0627\u0645\u0644.","Swap Details":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","Request ID":"\u0645\u0639\u0631\u0641 \u0627\u0644\u0637\u0644\u0628","Not found":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u064A\u0647","Swap with request ID = {requestId} not found.":["\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u062A\u0628\u0627\u062F\u0644 \u0645\u0639 \u0645\u0639\u0631\u0641 \u0627\u0644\u0637\u0644\u0628 = ",["requestId"]," ."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0644\u0642\u062F \u062A\u0644\u0642\u064A\u062A ",["amount"]," ",["token"]," \u0641\u064A \u0645\u062D\u0641\u0638\u0629 ",["conciseAddress"]," \u0639\u0644\u0649 \u0633\u0644\u0633\u0644\u0629 ",["chain"]," ."],"Transaction was not sent.":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0631\u0633\u0627\u0644 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u0639\u0644\u0649 ",["blockchain"]," \u064A\u0628\u0642\u0649 \u0641\u064A \u0645\u062D\u0641\u0638\u062A\u0643."],"Delete":"\u064A\u0645\u0633\u062D","Try again":"\u062D\u0627\u0648\u0644 \u062B\u0627\u0646\u064A\u0629","Copied To Clipboard":"\u062A\u0645 \u0646\u0633\u062E\u0647\u0627 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629","Copy Request ID":"\u0646\u0633\u062E\u0629 \u0645\u0646 \u0645\u0639\u0631\u0641 \u0627\u0644\u0637\u0644\u0628","View on Rango Explorer":"\u0639\u0631\u0636 \u0639\u0644\u0649 \u0631\u0627\u0646\u062C\u0648 \u0625\u0643\u0633\u0628\u0644\u0648\u0631\u0631","Finished at":"\u0627\u0646\u062A\u0647\u062A \u0641\u064A","Created at":"\u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647 \u0641\u064A","View transaction":"\u0639\u0631\u0636 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","Connect":"\u064A\u062A\u0635\u0644","Swap Successful":"\u062A\u0645 \u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0628\u0646\u062C\u0627\u062D","Transaction Failed":"\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","Done":"\u0645\u0646\u062A\u0647\u064A","Diagnosis":"\u062A\u0634\u062E\u0628\u0635","See Details":"\u0634\u0627\u0647\u062F \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644","Cancel Swap":"\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","Are you sure you want to cancel this swap?":"\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u0625\u0644\u063A\u0627\u0621 \u0647\u0630\u0627 \u0627\u0644\u062A\u0628\u0627\u062F\u0644\u061F","Yes, Cancel it":"\u0646\u0639\u0645\u060C \u0642\u0645 \u0628\u0625\u0644\u063A\u0627\u0626\u0647","No, Continue":"\u0644\u0627\u060C \u0627\u0633\u062A\u0645\u0631","Delete Transaction":"\u062D\u0630\u0641 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","Are you sure you want to delete this swap?":"\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0647\u0630\u0647 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629\u061F","Yes, Delete it":"\u0646\u0639\u0645\u060C \u0627\u062D\u0630\u0641\u0647","No, Cancel":"\u0644\u0627\u060C \u0625\u0644\u063A\u0627\u0621","Change Network":"\u0634\u0628\u0643\u0629 \u0627\u0644\u062A\u063A\u064A\u064A\u0631","Network Changed":"\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0634\u0628\u0643\u0629","Select Token":"\u062D\u062F\u062F \u0627\u0644\u0631\u0645\u0632","Wallet Connected":"\u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0645\u062A\u0635\u0644\u0629","Your wallet is connected, you can use it to swap.":"\u0645\u062D\u0641\u0638\u062A\u0643 \u0645\u062A\u0635\u0644\u0629\u060C \u0648\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0647\u0627 \u0644\u0644\u062A\u0628\u062F\u064A\u0644.","Failed to Connect":"\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644","Your wallet is not connected. Please try again.":"\u0645\u062D\u0641\u0638\u062A\u0643 \u063A\u064A\u0631 \u0645\u062A\u0635\u0644\u0629. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","Connecting to your wallet":"\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0645\u062D\u0641\u0638\u062A\u0643","Click connect in your wallet popup.":"\u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0645\u0646\u0628\u062B\u0642\u0629 \u0644\u0645\u062D\u0641\u0638\u062A\u0643.","Select Derivation Path":"\u062D\u062F\u062F \u0645\u0633\u0627\u0631 \u0627\u0644\u0627\u0634\u062A\u0642\u0627\u0642","In order to connect to {type}, you must first select a Derivation Path":["\u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0640 ",["type"],"\u060C \u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u0623\u0648\u0644\u0627\u064B \u062A\u062D\u062F\u064A\u062F \u0645\u0633\u0627\u0631 \u0627\u0644\u0627\u0634\u062A\u0642\u0627\u0642"],"Choose Derivation Path Template":"\u0627\u062E\u062A\u0631 \u0642\u0627\u0644\u0628 \u0645\u0633\u0627\u0631 \u0627\u0644\u0627\u0634\u062A\u0642\u0627\u0642","Enter Path":"\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0633\u0627\u0631","Enter Index":"\u0623\u062F\u062E\u0644 \u0627\u0644\u0641\u0647\u0631\u0633","Add {blockchainDisplayName} Chain":["\u0623\u0636\u0641 \u0633\u0644\u0633\u0644\u0629 ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0647\u0644 \u062A\u0631\u063A\u0628 \u0641\u064A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 ",["blockchainDisplayName"]," \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643\u061F"],"Please approve the experimental chain pop-up in your wallet.":"\u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A\u0629 \u0627\u0644\u0645\u0646\u0628\u062B\u0642\u0629 \u0641\u064A \u0645\u062D\u0641\u0638\u062A\u0643.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0633\u0644\u0633\u0644\u0629"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0633\u0644\u0633\u0644\u0629 ",["blockchainDisplayName"]," \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0646\u062C\u0627\u062D."],"Request Rejected":"\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0637\u0644\u0628","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0644\u0642\u062F \u0631\u0641\u0636\u062A \u0625\u0636\u0627\u0641\u0629 \u0633\u0644\u0633\u0644\u0629 ",["blockchainDisplayName"]," \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."],"Select chain types":"\u0627\u062E\u062A\u0631 \u0623\u0646\u0648\u0627\u0639 \u0627\u0644\u0633\u0644\u0633\u0644\u0629","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u062A\u062F\u0639\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0633\u0644\u0627\u0633\u0644 \u0645\u062A\u0639\u062F\u062F\u0629. \u062D\u062F\u062F \u0627\u0644\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u063A\u0628 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0647\u0627.","Failed Network, Please retry your swap.":"\u0641\u0634\u0644\u062A \u0627\u0644\u0634\u0628\u0643\u0629\u060C \u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u0644\u062A\u0628\u062F\u064A\u0644.","Please reset your liquidity sources.":"\u064A\u0631\u062C\u0649 \u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u0633\u064A\u0648\u0644\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0644\u0642\u062F \u0642\u0645\u062A \u0628\u062A\u0642\u064A\u064A\u062F \u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u0633\u064A\u0648\u0644\u0629 \u0648\u0642\u062F \u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0625\u0644\u0649 \u0639\u062F\u0645 \u062A\u0645\u0643\u0646 Rango \u0645\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u0645\u0633\u0627\u0631\u0627\u062A. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0641\u0643\u064A\u0631 \u0641\u064A \u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u0633\u064A\u0648\u0644\u0629 \u0644\u062F\u064A\u0643.","No Routes Found.":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u0637\u0631\u0642.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u0623\u0633\u0628\u0627\u0628 \u0639\u062F\u0645 \u062A\u0645\u0643\u0646 Rango \u0645\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0633\u0627\u0631: \u0627\u0646\u062E\u0641\u0627\u0636 \u0627\u0644\u0633\u064A\u0648\u0644\u0629 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632\u060C \u0623\u0648 \u0627\u0646\u062E\u0641\u0627\u0636 \u0643\u0645\u064A\u0629 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0628\u0634\u0643\u0644 \u0643\u0628\u064A\u0631 \u0623\u0648 \u0639\u062F\u0645 \u062A\u0648\u0641\u0631 \u0645\u0633\u0627\u0631\u0627\u062A \u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u0644\u0644\u0625\u062F\u062E\u0627\u0644/\u0627\u0644\u0625\u062E\u0631\u0627\u062C.","Bridge Limit Error: Please increase your amount.":"\u062E\u0637\u0623 \u0641\u064A \u062D\u062F \u0627\u0644\u062C\u0633\u0631: \u064A\u0631\u062C\u0649 \u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643.","Bridge Limit Error: Please decrease your amount.":"\u062E\u0637\u0623 \u0641\u064A \u062D\u062F \u0627\u0644\u062C\u0633\u0631: \u064A\u0631\u062C\u0649 \u062A\u0642\u0644\u064A\u0644 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643.","High Price Impact":"\u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0645\u0631\u062A\u0641\u0639","Price impact is too high!":"\u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0645\u0631\u062A\u0641\u0639 \u062C\u062F\u064B\u0627!","The price impact is significantly higher than the allowed amount.":"\u0625\u0646 \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0623\u0639\u0644\u0649 \u0628\u0643\u062B\u064A\u0631 \u0645\u0646 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0628\u0647.","Confirm high price impact":"\u062A\u0623\u0643\u064A\u062F \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0645\u0631\u062A\u0641\u0639","Route updated and price impact is too high, try again later!":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0633\u0627\u0631 \u0648\u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0645\u0631\u062A\u0641\u0639 \u0644\u0644\u063A\u0627\u064A\u0629\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627!","USD Price Unknown":"\u0633\u0639\u0631 \u0627\u0644\u062F\u0648\u0644\u0627\u0631 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641","USD Price Unknown, Cannot calculate Price Impact.":"\u0633\u0639\u0631 \u0627\u0644\u062F\u0648\u0644\u0627\u0631 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0633\u0627\u0628 \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u0633\u0639\u0631 \u0627\u0644\u062F\u0648\u0644\u0627\u0631 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641\u060C \u0644\u0627 \u064A\u0645\u0643\u0646 \u062D\u0633\u0627\u0628 \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631. \u0642\u062F \u064A\u0643\u0648\u0646 \u062A\u0623\u062B\u064A\u0631 \u0627\u0644\u0633\u0639\u0631 \u0623\u0639\u0644\u0649 \u0645\u0646 \u0627\u0644\u0645\u0639\u062A\u0627\u062F. \u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0641\u064A \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629\u061F","Confirm USD Price Unknown":"\u062A\u0623\u0643\u064A\u062F \u0633\u0639\u0631 \u0627\u0644\u062F\u0648\u0644\u0627\u0631 \u0627\u0644\u0623\u0645\u0631\u064A\u0643\u064A \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641","Swap":"\u062A\u0628\u062F\u064A\u0644","Swap anyway":"\u062A\u0628\u0627\u062F\u0644 \u0639\u0644\u0649 \u0623\u064A\u0629 \u062D\u0627\u0644","The route goes through Ethereum. Continue?":"\u0627\u0644\u0645\u0633\u0627\u0631 \u064A\u0645\u0631 \u0639\u0628\u0631 \u0627\u0644\u0625\u064A\u062B\u0631\u064A\u0648\u0645. \u0647\u0644 \u062A\u0631\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631\u061F","Route has been updated.":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0633\u0627\u0631.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u0643\u0645\u064A\u0629 \u0627\u0644\u0625\u062E\u0631\u0627\u062C \u0625\u0644\u0649 ",["newOutputAmount"]," (",["percentageChange"],"% \u0627\u0644\u062A\u063A\u064A\u064A\u0631)."],"Route swappers has been updated.":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0645\u0628\u0627\u062F\u0644\u0627\u062A \u0627\u0644\u0645\u0633\u0627\u0631.","Route internal coins has been updated.":"\u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0639\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u0639\u062F\u0646\u064A\u0629 \u0627\u0644\u062F\u0627\u062E\u0644\u064A\u0629 \u0644\u0644\u0645\u0633\u0627\u0631.","Routes":"\u0627\u0644\u0637\u0631\u0642","From":"\u0645\u0646","To":"\u0644","Light":"\u0636\u0648\u0621","Dark":"\u0645\u0638\u0644\u0645","Auto":"\u0622\u0644\u064A","Loading failed":"\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0645\u064A\u0644","Bridges":"\u0627\u0644\u062C\u0633\u0648\u0631","Exchanges":"\u0627\u0644\u062A\u0628\u0627\u062F\u0644\u0627\u062A","Custom Tokens":"\u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u0645\u062E\u0635\u0635\u0629","Language":"\u0644\u063A\u0629","Infinite approval":"\u0645\u0648\u0627\u0641\u0642\u0629 \u0644\u0627 \u0646\u0647\u0627\u0626\u064A\u0629","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u064A\u062A\u064A\u062D \u062A\u0645\u0643\u064A\u0646 \u0648\u0636\u0639 \\"\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0627\u0644\u0644\u0627\u0646\u0647\u0627\u0626\u064A\u0629\\" \u0627\u0644\u0648\u0635\u0648\u0644 \u063A\u064A\u0631 \u0627\u0644\u0645\u0642\u064A\u062F \u0625\u0644\u0649 \u0627\u0644\u0639\u0642\u0648\u062F \u0627\u0644\u0630\u0643\u064A\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629\u060C \u0645\u0645\u0627 \u064A\u0633\u0645\u062D \u0644\u0647\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0628\u0644\u063A \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0639\u062A\u0645\u062F \u062F\u0648\u0646 \u0642\u064A\u0648\u062F.","Theme":"\u0633\u0645\u0629","Duplicate Token":"\u0631\u0645\u0632 \u0645\u0643\u0631\u0631","The address you entered is duplicate, please enter a new address.":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0630\u064A \u0623\u062F\u062E\u0644\u062A\u0647 \u0645\u0643\u0631\u0631\u060C \u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u062C\u062F\u064A\u062F.","Token Already Exists":"\u0627\u0644\u0631\u0645\u0632 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644","There\'s no need to add this token again because it already exists and is supported by us.":"\u0644\u064A\u0633\u062A \u0647\u0646\u0627\u0643 \u062D\u0627\u062C\u0629 \u0644\u0625\u0636\u0627\u0641\u0629 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0623\u0646\u0647 \u0645\u0648\u062C\u0648\u062F \u0628\u0627\u0644\u0641\u0639\u0644 \u0648\u064A\u062F\u0639\u0645\u0647 \u0641\u0631\u064A\u0642\u0646\u0627.","Token Not Found":"\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u0639\u0630\u0631\u0627\u064B\u060C \u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0631\u0645\u0632 \u0645\u0645\u064A\u0632 \u0639\u0644\u0649 \u0633\u0644\u0633\u0644\u0629 ",["blockchain"]," \u0628\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u062F\u0645. \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0623\u0643\u062F \u0645\u0646 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u0645\u064A\u0632 \u0627\u0644\u0635\u062D\u064A\u062D."],"Network Error":"\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0634\u0628\u0643\u0629","Add Custom Token":"\u0625\u0636\u0627\u0641\u0629 \u0631\u0645\u0632 \u0645\u062E\u0635\u0635","Select chain":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0644\u0633\u0644\u0629","Enter Address":"\u0623\u062F\u062E\u0644 \u0627\u0644\u0639\u0646\u0648\u0627\u0646","Enter token address":"\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0645\u0632","Failed Network, Please retry.":"\u0641\u0634\u0644\u062A \u0627\u0644\u0634\u0628\u0643\u0629\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.","Add another custom token":"\u0625\u0636\u0627\u0641\u0629 \u0631\u0645\u0632 \u0645\u062E\u0635\u0635 \u0622\u062E\u0631","Confirm Swap":"\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","Start Swap":"\u0627\u0628\u062F\u0623 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","You get":"\u0644\u0642\u062F \u062D\u0635\u0644\u062A","Search Token":"\u0631\u0645\u0632 \u0627\u0644\u0628\u062D\u062B","No custom tokens":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0631\u0645\u0648\u0632 \u0645\u062E\u0635\u0635\u0629","press the button to add your custom token":"\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0632\u0631 \u0644\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062E\u0635\u0635 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643","Delete Custom Token":"\u062D\u0630\u0641 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0645\u062E\u0635\u0635","Are you sure you want to Delete this Token?":"\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0623\u0646\u0643 \u062A\u0631\u064A\u062F \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0631\u0645\u0632\u061F","Complete":"\u0645\u0643\u062A\u0645\u0644","Running":"\u062C\u0631\u064A","Failed":"\u0641\u0634\u0644","Clear":"\u0648\u0627\u0636\u062D","Search Transaction":"\u0628\u062D\u062B \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","No transactions":"\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0639\u0627\u0645\u0644\u0627\u062A","Your transaction history is stored locally and will appear here after you start a swap":"\u064A\u062A\u0645 \u062A\u062E\u0632\u064A\u0646 \u0633\u062C\u0644 \u0645\u0639\u0627\u0645\u0644\u0627\u062A\u0643 \u0645\u062D\u0644\u064A\u064B\u0627 \u0648\u0633\u064A\u0638\u0647\u0631 \u0647\u0646\u0627 \u0628\u0639\u062F \u0628\u062F\u0621 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629","Clear Transaction History":"\u0645\u0633\u062D \u0633\u062C\u0644 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0633\u064A\u0624\u062F\u064A \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0625\u0644\u0649 \u0625\u0632\u0627\u0644\u0629 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0646\u0627\u062C\u062D\u0629 \u0648\u0627\u0644\u0641\u0627\u0634\u0644\u0629 \u0645\u0646 \u0627\u0644\u0623\u062F\u0627\u0629. \u0647\u0644 \u062A\u0631\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0645\u0631\u0627\u0631\u061F","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u0645\u0644\u0627\u062D\u0638\u0629: \u0644\u0646 \u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0625\u0644\u0649 \u0645\u0633\u062D \u0633\u062C\u0644 \u0645\u0639\u0627\u0645\u0644\u0627\u062A\u0643 \u0639\u0644\u0649 \u0627\u0644\u0633\u0644\u0633\u0644\u0629\u061B \u0628\u0644 \u064A\u0632\u064A\u0644\u0647\u0627 \u0647\u0646\u0627 \u0641\u0642\u0637.","Yes, Clear the history":"\u0646\u0639\u0645\u060C \u0645\u0633\u062D \u0627\u0644\u062A\u0627\u0631\u064A\u062E","language":"\u0644\u063A\u0629","Deselect all":"\u0625\u0644\u063A\u0627\u0621 \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644","Select all":"\u062D\u062F\u062F \u0627\u0644\u0643\u0644","Search {sourceType}":["\u0628\u062D\u062B ",["sourceType"]],"Search Chain":"\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u0628\u062D\u062B","Source":"\u0645\u0635\u062F\u0631","Destination":"\u0648\u062C\u0647\u0629","Swap {type}":["\u0645\u0628\u0627\u062F\u0644\u0629 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0623\u0646\u062A \u062D\u0627\u0644\u064A\u064B\u0627 \u0641\u064A \u0648\u0636\u0639 \u0627\u0644\u062D\u0645\u0644\u0629 \u0645\u0639 \u0641\u0631\u0636 \u0642\u064A\u0648\u062F \u0639\u0644\u0649 \u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u0633\u064A\u0648\u0644\u0629. \u0647\u0644 \u062A\u0631\u063A\u0628 \u0641\u064A \u0627\u0644\u062E\u0631\u0648\u062C \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u0648\u0636\u0639 \u0648\u0627\u0644\u0627\u0633\u062A\u0641\u0627\u062F\u0629 \u0645\u0646 \u062C\u0645\u064A\u0639 \u0645\u0635\u0627\u062F\u0631 \u0627\u0644\u0633\u064A\u0648\u0644\u0629 \u0627\u0644\u0645\u062A\u0627\u062D\u0629\u061F","The request ID is necessary to display the swap details.":"\u0645\u0639\u0631\u0641 \u0627\u0644\u0637\u0644\u0628 \u0636\u0631\u0648\u0631\u064A \u0644\u0639\u0631\u0636 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0628\u0627\u062F\u0644\u0629.","Connect Wallets":"\u0631\u0628\u0637 \u0627\u0644\u0645\u062D\u0627\u0641\u0638","Choose a wallet to connect.":"\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u062A\u064A \u062A\u0631\u064A\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0647\u0627.","This week":"\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0628\u0648\u0639","This month":"\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631","This year":"\u0647\u0630\u0627 \u0627\u0644\u0639\u0627\u0645","Required: >= {min} {symbol}":["\u0627\u0644\u0645\u0637\u0644\u0648\u0628: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u0627\u0644\u0645\u0637\u0644\u0648\u0628: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0627\u0644\u0645\u0637\u0644\u0648\u0628: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0627\u0644\u0645\u0637\u0644\u0648\u0628: < ",["max"]," ",["symbol"]]," for network fee":" \u0645\u0642\u0627\u0628\u0644 \u0631\u0633\u0648\u0645 \u0627\u0644\u0634\u0628\u0643\u0629"," for swap":" \u0644\u0644\u062A\u0628\u0627\u062F\u0644"," for input and network fee":" \u0645\u0642\u0627\u0628\u0644 \u0631\u0633\u0648\u0645 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0648\u0627\u0644\u0634\u0628\u0643\u0629","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u064A\u062D\u062A\u0627\u062C \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\u060C \u0648\u0644\u0643\u0646 \u0644\u062F\u064A\u0643 ",["currentAmount"]," ",["symbol"]," \u0641\u064A \u0645\u062D\u0641\u0638\u062A\u0643 ",["blockchain"]," ."],"Waiting for connecting wallet":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0631\u0628\u0637 \u0627\u0644\u0645\u062D\u0641\u0638\u0629","Waiting for other running tasks to be finished":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0623\u062E\u0631\u0649 \u0627\u0644\u062C\u0627\u0631\u064A\u0629","Waiting for changing wallet network":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u063A\u064A\u064A\u0631 \u0634\u0628\u0643\u0629 \u0627\u0644\u0645\u062D\u0641\u0638\u0629","Sunday":"\u0627\u0644\u0623\u062D\u062F","Monday":"\u0627\u0644\u0627\u062B\u0646\u064A\u0646","Tuesday":"\u064A\u0648\u0645 \u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621","Wednesday":"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621","Thursday":"\u064A\u0648\u0645 \u0627\u0644\u062E\u0645\u064A\u0633","Friday":"\u062C\u0645\u0639\u0629","Saturday":"\u0627\u0644\u0633\u0628\u062A","Powered By":"\u0645\u062F\u0639\u0648\u0645 \u0628\u0648\u0627\u0633\u0637\u0629","Aggregated Transaction":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u062C\u0645\u0639\u0629","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0642\u0645 \u0628\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0639\u0644\u0649 ",["fromChain"]," \u0639\u0628\u0631 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u062C\u0633\u0631 \u0625\u0644\u0649 ",["toChain"]," \u0639\u0628\u0631 ",["swapper"]],"Completed":"\u0645\u0643\u062A\u0645\u0644","In progress":"\u0641\u064A \u062A\u064E\u0642\u064E\u062F\u0645","Waiting for bridge transaction":"\u0641\u064A \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u062C\u0633\u0631","Connected":"\u0645\u062A\u0635\u0644","Disconnect":"\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644","Install":"\u062B\u064E\u0628\u064E\u0651\u062A\u064E","Connecting ...":"\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 ...","Connecting":"\u0627\u0644\u0627\u062A\u0635\u0627\u0644","Disconnected":"\u0645\u0646\u0642\u0637\u0639","you need to pass a correct state to Wallet.":"\u064A\u062C\u0628 \u0639\u0644\u064A\u0643 \u062A\u0645\u0631\u064A\u0631 \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0635\u062D\u064A\u062D\u0629 \u0625\u0644\u0649 Wallet.","There are no notifications.":"\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u0634\u0639\u0627\u0631\u0627\u062A.","Clear all":"\u0645\u0633\u062D \u0627\u0644\u0643\u0644","Balance":"\u062A\u0648\u0627\u0632\u0646","Max":"\u0627\u0644\u0623\u0639\u0644\u0649"}');


/*eslint-disable*/ const $d9456b7cb7e535ea$export$defe85febe8b728c = JSON.parse('{"No results found":"\u0995\u09CB\u09A8 \u09AB\u09B2\u09BE\u09AB\u09B2 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF","Try using different keywords":"\u09AC\u09BF\u09AD\u09BF\u09A8\u09CD\u09A8 \u0995\u09C0\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u09A1 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C7 \u09A6\u09C7\u0996\u09C1\u09A8","Select Chain":"\u099A\u09C7\u0987\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","All":"\u09B8\u09AC","More +{count}":["\u0986\u09B0\u0993 +",["count"]],"Activate this tab":"\u098F\u0987 \u099F\u09CD\u09AF\u09BE\u09AC \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u0995\u09B0\u09C1\u09A8","Another tab is open and handles transactions.":"\u0986\u09B0\u09C7\u0995\u099F\u09BF \u099F\u09CD\u09AF\u09BE\u09AC \u0996\u09CB\u09B2\u09BE \u098F\u09AC\u0982 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u09A8\u09BE \u0995\u09B0\u09C7\u0964","Activate current tab":"\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8 \u099F\u09CD\u09AF\u09BE\u09AC \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u0995\u09B0\u09C1\u09A8","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8\u09C7, \u0995\u09BF\u099B\u09C1 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u099A\u09B2\u099B\u09C7 \u098F\u09AC\u0982 \u0985\u09A8\u09CD\u09AF \u09AC\u09CD\u09B0\u09BE\u0989\u099C\u09BE\u09B0 \u099F\u09CD\u09AF\u09BE\u09AC \u09A6\u09CD\u09AC\u09BE\u09B0\u09BE \u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u09BF\u09A4 \u09B9\u099A\u09CD\u099B\u09C7\u09F7 \u0986\u09AA\u09A8\u09BF \u09AF\u09A6\u09BF \u098F\u0987 \u099F\u09CD\u09AF\u09BE\u09AC\u099F\u09BF \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u0995\u09B0\u09C7\u09A8, \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09B8\u09BE\u0987\u09A8 \u09A7\u09BE\u09AA\u09C7 \u09A5\u09BE\u0995\u09BE \u09B8\u09AE\u09B8\u09CD\u09A4 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u09AE\u09C7\u09AF\u09BC\u09BE\u09A6 \u09B6\u09C7\u09B7 \u09B9\u09AF\u09BC\u09C7 \u09AF\u09BE\u09AC\u09C7\u0964","Confirm":"\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8","Your {blockchainName} wallets":["\u0986\u09AA\u09A8\u09BE\u09B0 ",["blockchainName"]," \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F"],"Insufficient account balance":"\u0985\u09AA\u09B0\u09CD\u09AF\u09BE\u09AA\u09CD\u09A4 \u0985\u09CD\u09AF\u09BE\u0995\u09BE\u0989\u09A8\u09CD\u099F \u09AC\u09CD\u09AF\u09BE\u09B2\u09C7\u09A8\u09CD\u09B8","Proceed anyway":"\u09AF\u09BE\u0987\u09B9\u09CB\u0995 \u098F\u0997\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u09A8","You need to connect a {blockchainName} wallet.":["\u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u098F\u0995\u099F\u09BF ",["blockchainName"]," \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u09F7"],"Add {chain} chain":[["chain"]," \u099A\u09C7\u0987\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8"],"Show more wallets":"\u0986\u09B0\u0993 \u09AE\u09BE\u09A8\u09BF\u09AC\u09CD\u09AF\u09BE\u0997 \u09A6\u09C7\u0996\u09BE\u09A8","Send to a different address":"\u0985\u09A8\u09CD\u09AF \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u09AF\u09BC \u09AA\u09BE\u09A0\u09BE\u09A8","Enter {blockchainName} address":[["blockchainName"]," \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09B2\u09BF\u0996\u09C1\u09A8"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u09A0\u09BF\u0995\u09BE\u09A8\u09BE ",["destination"]," \u09AC\u09CD\u09B2\u0995\u099A\u09C7\u0987\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09AA\u09CD\u09AF\u09BE\u099F\u09BE\u09B0\u09CD\u09A8\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09AE\u09C7\u09B2\u09C7 \u09A8\u09BE\u0964"],"via":"\u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u098F\u0987 \u099F\u09CB\u0995\u09C7\u09A8\u099F\u09BF \u09B8\u0995\u09CD\u09B0\u09BF\u09AF\u09BC \u099F\u09CB\u0995\u09C7\u09A8 \u09A4\u09BE\u09B2\u09BF\u0995\u09BE\u09AF\u09BC \u0989\u09AA\u09B8\u09CD\u09A5\u09BF\u09A4 \u09B9\u09AF\u09BC \u09A8\u09BE\u09F7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8 \u09AF\u09C7 \u098F\u099F\u09BF \u09B8\u09C7\u0987 \u099F\u09CB\u0995\u09C7\u09A8 \u09AF\u09BE \u0986\u09AA\u09A8\u09BF \u099F\u09CD\u09B0\u09C7\u09A1 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u09A8\u0964","Import":"\u0986\u09AE\u09A6\u09BE\u09A8\u09BF","Status":"\u09B8\u09CD\u099F\u09CD\u09AF\u09BE\u099F\u09BE\u09B8","Reset":"\u09B0\u09BF\u09B8\u09C7\u099F \u0995\u09B0\u09C1\u09A8","Cancel":"\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8","Refresh":"\u09B0\u09BF\u09AB\u09CD\u09B0\u09C7\u09B6","Notifications":"\u09AC\u09BF\u099C\u09CD\u099E\u09AA\u09CD\u09A4\u09BF","Settings":"\u09B8\u09C7\u099F\u09BF\u0982\u09B8","History":"\u0987\u09A4\u09BF\u09B9\u09BE\u09B8","Connect Wallet":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09C1\u09A8","Today":"\u0986\u099C","Swaps steps":"\u09A7\u09BE\u09AA\u0997\u09C1\u09B2\u09BF \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0995\u09B0\u09C7","Retry":"\u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8","Slippage Error":"\u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09A4\u09CD\u09B0\u09C1\u099F\u09BF","Slippage Warning":"\u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09B8\u09A4\u09B0\u09CD\u0995\u09A4\u09BE","Bridge Limit Error":"\u09B8\u09C7\u09A4\u09C1 \u09B8\u09C0\u09AE\u09BE \u09A4\u09CD\u09B0\u09C1\u099F\u09BF","Yours: {amount} {symbol}":["\u0986\u09AA\u09A8\u09BE\u09B0: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u09A8\u09CD\u09AF\u09C2\u09A8\u09A4\u09AE \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C: ",["minRequiredSlippage"],"\u09F7"],"Yours: {userSlippage}":["\u0986\u09AA\u09A8\u09BE\u09B0: ",["userSlippage"]],"See All Routes":"\u09B8\u09AE\u09B8\u09CD\u09A4 \u09B0\u09C1\u099F \u09A6\u09C7\u0996\u09C1\u09A8","View more info":"\u0986\u09B0\u09CB \u09A4\u09A5\u09CD\u09AF \u09A6\u09C7\u0996\u09C1\u09A8","Gas & Fee Explanation":"\u0997\u09CD\u09AF\u09BE\u09B8 \u0993 \u09AB\u09BF \u09AC\u09CD\u09AF\u09BE\u0996\u09CD\u09AF\u09BE","Details":"\u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4","Total Payable Fee":"\u09AE\u09CB\u099F \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u09AB\u09BF","Hide non-payable fees":"\u0985\u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u09AB\u09BF \u09B2\u09C1\u0995\u09BE\u09A8","Show non-payable fees":"\u0985\u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u09AB\u09BF \u09A6\u09C7\u0996\u09BE\u09A8","Description":"\u09AC\u09B0\u09CD\u09A3\u09A8\u09BE","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u09A8\u09BF\u09AE\u09CD\u09A8\u09B2\u09BF\u0996\u09BF\u09A4 \u09AB\u09BF\u0997\u09C1\u09B2\u09BF \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u0986\u0989\u099F\u09AA\u09C1\u099F\u09C7 \u09AC\u09BF\u09AC\u09C7\u099A\u09A8\u09BE \u0995\u09B0\u09BE \u09B9\u09AF\u09BC \u098F\u09AC\u0982\\n                \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u09A4\u09BE\u09A6\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09A4\u09BF\u09B0\u09BF\u0995\u09CD\u09A4 \u0997\u09CD\u09AF\u09BE\u09B8 \u09A6\u09BF\u09A4\u09C7 \u09B9\u09AC\u09C7 \u09A8\u09BE\u09F7","Swap input":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0987\u09A8\u09AA\u09C1\u099F","Estimated output":"\u0986\u09A8\u09C1\u09AE\u09BE\u09A8\u09BF\u0995 \u0986\u0989\u099F\u09AA\u09C1\u099F","Via:":"\u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7:","Chains:":"\u099A\u09C7\u0987\u09A8:","Sort by":"\u0985\u09A8\u09C1\u09B8\u09BE\u09B0\u09C7 \u09B8\u09BE\u099C\u09BE\u09A8","Smart Routing":"\u09B8\u09CD\u09AE\u09BE\u09B0\u09CD\u099F \u09B0\u09BE\u0989\u099F\u09BF\u0982","Lowest Fee":"\u09B8\u09B0\u09CD\u09AC\u09A8\u09BF\u09AE\u09CD\u09A8 \u09AB\u09BF","Fastest Transfer":"\u09A6\u09CD\u09B0\u09C1\u09A4\u09A4\u09AE \u09B8\u09CD\u09A5\u09BE\u09A8\u09BE\u09A8\u09CD\u09A4\u09B0","Maximum Return":"\u09B8\u09B0\u09CD\u09AC\u09CB\u099A\u09CD\u099A \u09B0\u09BF\u099F\u09BE\u09B0\u09CD\u09A8","Maximum Output":"\u09B8\u09B0\u09CD\u09AC\u09CB\u099A\u09CD\u099A \u0986\u0989\u099F\u09AA\u09C1\u099F","Swapping":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2","Gas cost":"\u0997\u09CD\u09AF\u09BE\u09B8 \u0996\u09B0\u099A","Receiving":"\u09B0\u09BF\u09B8\u09BF\u09AD\u09BF\u0982","Price impact":"\u09A6\u09BE\u09AE\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u098F\u0987 \u09B0\u09C1\u099F\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u0985\u09A8\u09CD\u09A4\u09A4 ",["minRequiredSlippage"]," \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09AC\u09BE\u09A1\u09BC\u09BE\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u0986\u09AE\u09B0\u09BE \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u098F\u0987 \u09B0\u09C1\u099F\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0995\u09AE\u09AA\u0995\u09CD\u09B7\u09C7 ",["minRequiredSlippage"]," \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09AC\u09BE\u09A1\u09BC\u09BE\u09A4\u09C7 \u09B8\u09C1\u09AA\u09BE\u09B0\u09BF\u09B6 \u0995\u09B0\u099B\u09BF\u09F7"],"Caution, your slippage is high.":"\u09B8\u09BE\u09AC\u09A7\u09BE\u09A8, \u0986\u09AA\u09A8\u09BE\u09B0 \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09AC\u09C7\u09B6\u09BF\u0964","Change":"\u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8","Change settings":"\u09B8\u09C7\u099F\u09BF\u0982\u09B8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8","High slippage":"\u0989\u099A\u09CD\u099A \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C","Low slippage":"\u0995\u09AE \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u09B8\u09BE\u09AC\u09A7\u09BE\u09A8, \u0986\u09AA\u09A8\u09BE\u09B0 \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09AC\u09C7\u09B6\u09BF (=",["userSlippage"],")\u0964 \u0986\u09AA\u09A8\u09BE\u09B0 \u099F\u09CD\u09B0\u09C7\u09A1 \u09AB\u09CD\u09B0\u09A8\u09CD\u099F \u09B0\u09BE\u09A8 \u09B9\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7."],"Confirm anyway":"\u09AF\u09BE\u0987\u09B9\u09CB\u0995 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8","Something went wrong":"\u0995\u09BF\u099B\u09C1 \u09AD\u09C1\u09B2 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Something went wrong. Please refresh the app.":"\u0995\u09BF\u099B\u09C1 \u09AD\u09C1\u09B2 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7 \u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0985\u09CD\u09AF\u09BE\u09AA\u099F\u09BF \u09B0\u09BF\u09AB\u09CD\u09B0\u09C7\u09B6 \u0995\u09B0\u09C1\u09A8\u0964","Slippage tolerance per swap":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AA\u09CD\u09B0\u09A4\u09BF \u09B8\u09CD\u09B2\u09BF\u09AA\u09C7\u099C \u09B8\u09B9\u09A8\u09B6\u09C0\u09B2\u09A4\u09BE","Custom":"\u0995\u09BE\u09B8\u09CD\u099F\u09AE","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u098F\u0987 \u09B6\u09A4\u09BE\u0982\u09B6\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF \u09AE\u09C2\u09B2\u09CD\u09AF \u09AA\u09CD\u09B0\u09A4\u09BF\u0995\u09C2\u09B2\u09AD\u09BE\u09AC\u09C7 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4 \u09B9\u09B2\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AB\u09BF\u09B0\u09BF\u09AF\u09BC\u09C7 \u09A6\u09C7\u0993\u09AF\u09BC\u09BE \u09B9\u09AC\u09C7\u0964","Warning":"\u09B8\u09A4\u09B0\u09CD\u0995\u09A4\u09BE","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u098F\u0987 \u09B8\u09C7\u099F\u09BF\u0982\u099F\u09BF \u09AA\u09CD\u09B0\u09A4\u09BF\u099F\u09BF \u09A7\u09BE\u09AA\u09C7 \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC (\u09AF\u09C7\u09AE\u09A8 1 \u0987\u099E\u09CD\u099A\u09BF, \u09A5\u09B0\u099A\u09C7\u0987\u09A8, \u0987\u09A4\u09CD\u09AF\u09BE\u09A6\u09BF), \u09AF\u09BE\u09B0 \u0985\u09B0\u09CD\u09A5 \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 \u09B8\u09C7\u0987 \u09A8\u09BF\u09B0\u09CD\u09A6\u09BF\u09B7\u09CD\u099F \u09A7\u09BE\u09AA\u099F\u09BF \u09AA\u09CD\u09B0\u09A4\u09CD\u09AF\u09BE\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7, \u09AA\u09C1\u09B0\u09CB \u09B0\u09C1\u099F \u09A8\u09AF\u09BC\u0964","Swap Details":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AC\u09BF\u09AC\u09B0\u09A3","Request ID":"\u0986\u0987\u09A1\u09BF \u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u0995\u09B0\u09C1\u09A8","Not found":"\u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF","Swap with request ID = {requestId} not found.":["\u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u0986\u0987\u09A1\u09BF \u09A6\u09BF\u09AF\u09BC\u09C7 \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0995\u09B0\u09C1\u09A8 = ",["requestId"]," \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0986\u09AA\u09A8\u09BF ",["chain"]," \u099A\u09C7\u0987\u09A8\u09C7 ",["conciseAddress"]," \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 ",["amount"]," ",["token"]," \u09AA\u09C7\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u09F7"],"Transaction was not sent.":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AA\u09BE\u09A0\u09BE\u09A8\u09CB \u09B9\u09AF\u09BC\u09A8\u09BF.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," ",["blockchain"]," -\u098F \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 \u09A5\u09C7\u0995\u09C7 \u09AF\u09BE\u09AF\u09BC\u09F7"],"Delete":"\u09AE\u09C1\u099B\u09C7 \u09A6\u09BF\u09A8","Try again":"\u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8","Copied To Clipboard":"\u0995\u09CD\u09B2\u09BF\u09AA\u09AC\u09CB\u09B0\u09CD\u09A1\u09C7 \u0995\u09AA\u09BF \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Copy Request ID":"\u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u0986\u0987\u09A1\u09BF \u0995\u09AA\u09BF \u0995\u09B0\u09C1\u09A8","View on Rango Explorer":"Rango Explorer \u098F \u09A6\u09C7\u0996\u09C1\u09A8","Finished at":"\u098F \u09B6\u09C7\u09B7 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Created at":"\u098F \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","View transaction":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09A6\u09C7\u0996\u09C1\u09A8","Connect":"\u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8","Swap Successful":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09B8\u09AB\u09B2","Transaction Failed":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09F7","Done":"\u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8","Diagnosis":"\u09B0\u09CB\u0997 \u09A8\u09BF\u09B0\u09CD\u09A3\u09AF\u09BC","See Details":"\u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4 \u09A6\u09C7\u0996\u09C1\u09A8","Cancel Swap":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8","Are you sure you want to cancel this swap?":"\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u098F\u0987 \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09BE\u09B0 \u09AC\u09BF\u09B7\u09AF\u09BC\u09C7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4?","Yes, Cancel it":"\u09B9\u09CD\u09AF\u09BE\u0981, \u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8","No, Continue":"\u09A8\u09BE, \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u09A8","Delete Transaction":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AE\u09C1\u099B\u09C1\u09A8","Are you sure you want to delete this swap?":"\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u098F\u0987 \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09BE\u09B0 \u09AC\u09BF\u09B7\u09AF\u09BC\u09C7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4?","Yes, Delete it":"\u09B9\u09CD\u09AF\u09BE\u0981, \u09AE\u09C1\u099B\u09C1\u09A8","No, Cancel":"\u09A8\u09BE, \u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8","Change Network":"\u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8","Network Changed":"\u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Select Token":"\u099F\u09CB\u0995\u09C7\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","Wallet Connected":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4","Your wallet is connected, you can use it to swap.":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0986\u099B\u09C7, \u0986\u09AA\u09A8\u09BF \u098F\u099F\u09BF \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0995\u09B0\u09A4\u09C7 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u09A8\u0964","Failed to Connect":"\u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Your wallet is not connected. Please try again.":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09C7\u0987. \u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8.","Connecting to your wallet":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 \u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","Click connect in your wallet popup.":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09AA\u09AA\u0986\u09AA\u09C7 \u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09CD\u09B2\u09BF\u0995 \u0995\u09B0\u09C1\u09A8\u0964","Select Derivation Path":"\u09A1\u09C7\u09B0\u09BF\u09AD\u09C7\u09B6\u09A8 \u09AA\u09BE\u09A5 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\u098F\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF, \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u09AA\u09CD\u09B0\u09A5\u09AE\u09C7 \u098F\u0995\u099F\u09BF \u09A1\u09C7\u09B0\u09BF\u09AD\u09C7\u09B6\u09A8 \u09AA\u09BE\u09A5 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7"],"Choose Derivation Path Template":"\u09A1\u09C7\u09B0\u09BF\u09AD\u09C7\u09B6\u09A8 \u09AA\u09BE\u09A5 \u099F\u09C7\u09AE\u09AA\u09CD\u09B2\u09C7\u099F \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","Enter Path":"\u09AA\u09BE\u09A5 \u09B2\u09BF\u0996\u09C1\u09A8","Enter Index":"\u0987\u09A8\u09A1\u09C7\u0995\u09CD\u09B8 \u09B2\u09BF\u0996\u09C1\u09A8","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \u099A\u09C7\u0987\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 ",["blockchainDisplayName"]," \u09AA\u09B0\u09C0\u0995\u09CD\u09B7\u09BE\u09AE\u09C2\u09B2\u0995 \u099A\u09C7\u0987\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u09A8?"],"Please approve the experimental chain pop-up in your wallet.":"\u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 \u09AA\u09B0\u09C0\u0995\u09CD\u09B7\u09BE\u09AE\u09C2\u09B2\u0995 \u099A\u09C7\u0987\u09A8 \u09AA\u09AA-\u0986\u09AA \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09A8 \u0995\u09B0\u09C1\u09A8\u0964","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u099A\u09C7\u0987\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u099A\u09C7\u0987\u09A8 \u09B8\u09AB\u09B2\u09AD\u09BE\u09AC\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 \u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09F7"],"Request Rejected":"\u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u09AA\u09CD\u09B0\u09A4\u09CD\u09AF\u09BE\u0996\u09CD\u09AF\u09BE\u09A4","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0986\u09AA\u09A8\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 ",["blockchainDisplayName"]," \u099A\u09C7\u0987\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09AA\u09CD\u09B0\u09A4\u09CD\u09AF\u09BE\u0996\u09CD\u09AF\u09BE\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8\u09F7"],"Select chain types":"\u099A\u09C7\u0987\u09A8 \u09AA\u09CD\u09B0\u0995\u09BE\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u098F\u0987 \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u098F\u0995\u09BE\u09A7\u09BF\u0995 \u099A\u09C7\u0987\u09A8 \u09B8\u09AE\u09B0\u09CD\u09A5\u09A8 \u0995\u09B0\u09C7\u0964 \u0986\u09AA\u09A8\u09BF \u0995\u09CB\u09A8 \u099A\u09C7\u0987\u09A8\u099F\u09BF\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u09A8 \u09A4\u09BE \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8\u09F7","Failed Network, Please retry your swap.":"\u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995, \u0986\u09AA\u09A8\u09BE\u09B0 \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8.","Please reset your liquidity sources.":"\u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF \u0989\u09A4\u09CD\u09B8 \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u09B8\u09C7\u099F \u0995\u09B0\u09C1\u09A8\u0964","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0986\u09AA\u09A8\u09BF \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF\u09C7\u09B0 \u0989\u09A4\u09CD\u09B8 \u09B8\u09C0\u09AE\u09BF\u09A4 \u0995\u09B0\u09C7\u099B\u09C7\u09A8 \u098F\u09AC\u0982 \u098F\u09B0 \u09AB\u09B2\u09C7 Rango \u0995\u09CB\u09A8\u09CB \u09B0\u09C1\u099F \u0996\u09C1\u0981\u099C\u09C7 \u09A8\u09BE \u09AA\u09C7\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964 \u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF \u0989\u09A4\u09CD\u09B8 \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u09B8\u09C7\u099F \u0995\u09B0\u09BE\u09B0 \u0995\u09A5\u09BE \u09AC\u09BF\u09AC\u09C7\u099A\u09A8\u09BE \u0995\u09B0\u09C1\u09A8\u0964","No Routes Found.":"\u0995\u09CB\u09A8 \u09B0\u09C1\u099F \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u09B0\u09C7\u0999\u09CD\u0997\u09CB \u0995\u09C7\u09A8 \u098F\u0995\u099F\u09BF \u09B0\u09C1\u099F \u0996\u09C1\u0981\u099C\u09C7 \u09AA\u09BE\u09AF\u09BC\u09A8\u09BF \u09A4\u09BE\u09B0 \u0995\u09BE\u09B0\u09A3: \u099F\u09CB\u0995\u09C7\u09A8\u09C7 \u0995\u09AE \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF, \u0996\u09C1\u09AC \u0995\u09AE \u0987\u09A8\u09AA\u09C1\u099F \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3 \u09AC\u09BE \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09BF\u09A4 \u0987\u09A8\u09AA\u09C1\u099F/\u0986\u0989\u099F\u09AA\u09C1\u099F \u099F\u09CB\u0995\u09C7\u09A8 \u09B8\u0982\u09AE\u09BF\u09B6\u09CD\u09B0\u09A3\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0995\u09CB\u09A8\u0993 \u09B0\u09C1\u099F \u0989\u09AA\u09B2\u09AC\u09CD\u09A7 \u09A8\u09C7\u0987\u0964","Bridge Limit Error: Please increase your amount.":"\u09B8\u09C7\u09A4\u09C1 \u09B8\u09C0\u09AE\u09BE \u09A4\u09CD\u09B0\u09C1\u099F\u09BF: \u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3 \u09AC\u09C3\u09A6\u09CD\u09A7\u09BF \u0995\u09B0\u09C1\u09A8.","Bridge Limit Error: Please decrease your amount.":"\u09B8\u09C7\u09A4\u09C1 \u09B8\u09C0\u09AE\u09BE \u09A4\u09CD\u09B0\u09C1\u099F\u09BF: \u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3 \u09B9\u09CD\u09B0\u09BE\u09B8 \u0995\u09B0\u09C1\u09A8.","High Price Impact":"\u0989\u099A\u09CD\u099A \u09AE\u09C2\u09B2\u09CD\u09AF\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC","Price impact is too high!":"\u09A6\u09BE\u09AE\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u0996\u09C1\u09AC \u09AC\u09C7\u09B6\u09BF!","The price impact is significantly higher than the allowed amount.":"\u09AE\u09C2\u09B2\u09CD\u09AF\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09BF\u09A4 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3\u09C7\u09B0 \u09A4\u09C1\u09B2\u09A8\u09BE\u09AF\u09BC \u0989\u09B2\u09CD\u09B2\u09C7\u0996\u09AF\u09CB\u0997\u09CD\u09AF\u09AD\u09BE\u09AC\u09C7 \u09AC\u09C7\u09B6\u09BF\u0964","Confirm high price impact":"\u0989\u099A\u09CD\u099A \u09AE\u09C2\u09B2\u09CD\u09AF \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8","Route updated and price impact is too high, try again later!":"\u09B0\u09C1\u099F \u0986\u09AA\u09A1\u09C7\u099F \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7 \u098F\u09AC\u0982 \u09A6\u09BE\u09AE\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u0996\u09C1\u09AC \u09AC\u09C7\u09B6\u09BF, \u09AA\u09B0\u09C7 \u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8!","USD Price Unknown":"USD \u09AE\u09C2\u09B2\u09CD\u09AF \u0985\u099C\u09BE\u09A8\u09BE","USD Price Unknown, Cannot calculate Price Impact.":"USD \u09AE\u09C2\u09B2\u09CD\u09AF \u0985\u099C\u09BE\u09A8\u09BE, \u09AE\u09C2\u09B2\u09CD\u09AF\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u0997\u09A3\u09A8\u09BE \u0995\u09B0\u09BE \u09AF\u09BE\u099A\u09CD\u099B\u09C7 \u09A8\u09BE\u0964","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \u09AE\u09C2\u09B2\u09CD\u09AF \u0985\u099C\u09BE\u09A8\u09BE, \u09AE\u09C2\u09B2\u09CD\u09AF\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u0997\u09A3\u09A8\u09BE \u0995\u09B0\u09BE \u09AF\u09BE\u099A\u09CD\u099B\u09C7 \u09A8\u09BE\u0964 \u09A6\u09BE\u09AE\u09C7\u09B0 \u09AA\u09CD\u09B0\u09AD\u09BE\u09AC \u09B8\u09CD\u09AC\u09BE\u09AD\u09BE\u09AC\u09BF\u0995\u09C7\u09B0 \u099A\u09C7\u09AF\u09BC\u09C7 \u09AC\u09C7\u09B6\u09BF \u09B9\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964 \u0986\u09AA\u09A8\u09BF \u0995\u09BF \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u0993\u09AF\u09BC\u09BE\u09B0 \u09AC\u09BF\u09B7\u09AF\u09BC\u09C7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4?","Confirm USD Price Unknown":"\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8 USD \u09AE\u09C2\u09B2\u09CD\u09AF \u0985\u099C\u09BE\u09A8\u09BE","Swap":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2","Swap anyway":"\u09AF\u09C7\u09AD\u09BE\u09AC\u09C7\u0987 \u09B9\u09CB\u0995 \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0995\u09B0\u09C1\u09A8","The route goes through Ethereum. Continue?":"\u09B0\u09C1\u099F Ethereum \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 \u09AF\u09BE\u09AF\u09BC. \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09BE\u09A8?","Route has been updated.":"\u09B0\u09C1\u099F \u0986\u09AA\u09A1\u09C7\u099F \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u0964","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0986\u0989\u099F\u09AA\u09C1\u099F \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3 ",["newOutputAmount"]," \u098F \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09BF\u09A4 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7 (",["percentageChange"],"% \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8)\u0964"],"Route swappers has been updated.":"\u09B0\u09C1\u099F \u09B8\u09CB\u09AF\u09BC\u09BE\u09AA\u09BE\u09B0 \u0986\u09AA\u09A1\u09C7\u099F \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u0964","Route internal coins has been updated.":"\u09B0\u09C1\u099F \u0985\u09AD\u09CD\u09AF\u09A8\u09CD\u09A4\u09B0\u09C0\u09A3 \u09AE\u09C1\u09A6\u09CD\u09B0\u09BE \u0986\u09AA\u09A1\u09C7\u099F \u0995\u09B0\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7.","Routes":"\u09B0\u09C1\u099F","From":"\u09A5\u09C7\u0995\u09C7","To":"\u09AA\u09CD\u09B0\u09A4\u09BF","Light":"\u0986\u09B2\u09CB","Dark":"\u0985\u09A8\u09CD\u09A7\u0995\u09BE\u09B0","Auto":"\u0985\u099F\u09CB","Loading failed":"\u09B2\u09CB\u09A1\u09BF\u0982 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09F7","Bridges":"\u09AC\u09CD\u09B0\u09BF\u099C","Exchanges":"\u09AC\u09BF\u09A8\u09BF\u09AE\u09AF\u09BC","Custom Tokens":"\u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8","Language":"\u09AD\u09BE\u09B7\u09BE","Infinite approval":"\u0985\u09B8\u09C0\u09AE \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09A8","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\'\u0985\u09B8\u09C0\u09AE \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09A8\' \u09AE\u09CB\u09A1 \u09B8\u0995\u09CD\u09B7\u09AE \u0995\u09B0\u09BE \u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09A8\u09BF\u09B9\u09BF\u09A4 \u09B8\u09CD\u09AE\u09BE\u09B0\u09CD\u099F \u099A\u09C1\u0995\u09CD\u09A4\u09BF\u0997\u09C1\u09B2\u09BF\u09A4\u09C7 \u09B8\u09C0\u09AE\u09BE\u09B9\u09C0\u09A8 \u0985\u09CD\u09AF\u09BE\u0995\u09CD\u09B8\u09C7\u09B8 \u09AE\u099E\u09CD\u099C\u09C1\u09B0 \u0995\u09B0\u09C7, \u09A4\u09BE\u09A6\u09C7\u09B0 \u09B8\u09C0\u09AE\u09BE\u09AC\u09A6\u09CD\u09A7\u09A4\u09BE \u099B\u09BE\u09A1\u09BC\u09BE\u0987 \u0985\u09A8\u09C1\u09AE\u09CB\u09A6\u09BF\u09A4 \u099F\u09CB\u0995\u09C7\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09BE\u09B0 \u0985\u09A8\u09C1\u09AE\u09A4\u09BF \u09A6\u09C7\u09AF\u09BC\u0964","Theme":"\u09A5\u09BF\u09AE","Duplicate Token":"\u09A1\u09C1\u09AA\u09CD\u09B2\u09BF\u0995\u09C7\u099F \u099F\u09CB\u0995\u09C7\u09A8","The address you entered is duplicate, please enter a new address.":"\u0986\u09AA\u09A8\u09BF \u09AF\u09C7 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u099F\u09BF \u09B2\u09BF\u0996\u09C7\u099B\u09C7\u09A8 \u09A4\u09BE \u09B8\u09A6\u09C3\u09B6, \u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u098F\u0995\u099F\u09BF \u09A8\u09A4\u09C1\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09B2\u09BF\u0996\u09C1\u09A8\u09F7","Token Already Exists":"\u099F\u09CB\u0995\u09C7\u09A8 \u0987\u09A4\u09BF\u09AE\u09A7\u09CD\u09AF\u09C7\u0987 \u09AC\u09BF\u09A6\u09CD\u09AF\u09AE\u09BE\u09A8\u09F7","There\'s no need to add this token again because it already exists and is supported by us.":"\u098F\u0987 \u099F\u09CB\u0995\u09C7\u09A8\u099F\u09BF \u0986\u09AC\u09BE\u09B0 \u09AF\u09CB\u0997 \u0995\u09B0\u09BE\u09B0 \u09A6\u09B0\u0995\u09BE\u09B0 \u09A8\u09C7\u0987 \u0995\u09BE\u09B0\u09A3 \u098F\u099F\u09BF \u0987\u09A4\u09BF\u09AE\u09A7\u09CD\u09AF\u09C7\u0987 \u09AC\u09BF\u09A6\u09CD\u09AF\u09AE\u09BE\u09A8 \u098F\u09AC\u0982 \u0986\u09AE\u09BE\u09A6\u09C7\u09B0 \u09A6\u09CD\u09AC\u09BE\u09B0\u09BE \u09B8\u09AE\u09B0\u09CD\u09A5\u09BF\u09A4\u0964","Token Not Found":"\u099F\u09CB\u0995\u09C7\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u09A6\u09C1\u0983\u0996\u09BF\u09A4, \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09B8\u09B9 ",["blockchain"]," \u099A\u09C7\u0987\u09A8\u09C7 \u0995\u09CB\u09A8\u09CB \u099F\u09CB\u0995\u09C7\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u09F7 \u09A6\u09AF\u09BC\u09BE \u0995\u09B0\u09C7 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8 \u09AF\u09C7 \u0986\u09AA\u09A8\u09BF \u09B8\u09A0\u09BF\u0995 \u099F\u09CB\u0995\u09C7\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u099F\u09BF \u09AA\u09CD\u09B0\u09AC\u09C7\u09B6 \u0995\u09B0\u09C7\u099B\u09C7\u09A8\u0964"],"Network Error":"\u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09A4\u09CD\u09B0\u09C1\u099F\u09BF\u09F7","Add Custom Token":"\u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8","Select chain":"\u099A\u09C7\u0987\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","Enter Address":"\u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09B2\u09BF\u0996\u09C1\u09A8","Enter token address":"\u099F\u09CB\u0995\u09C7\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE \u09B2\u09BF\u0996\u09C1\u09A8","Failed Network, Please retry.":"\u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7, \u0985\u09A8\u09C1\u0997\u09CD\u09B0\u09B9 \u0995\u09B0\u09C7 \u0986\u09AC\u09BE\u09B0 \u099A\u09C7\u09B7\u09CD\u099F\u09BE \u0995\u09B0\u09C1\u09A8\u0964","Add another custom token":"\u0986\u09B0\u09C7\u0995\u099F\u09BF \u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09C1\u09A8","Confirm Swap":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8","Start Swap":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09B6\u09C1\u09B0\u09C1 \u0995\u09B0\u09C1\u09A8","You get":"\u0986\u09AA\u09A8\u09BF \u09AA\u09BE\u09AC\u09C7\u09A8","Search Token":"\u099F\u09CB\u0995\u09C7\u09A8 \u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8","No custom tokens":"\u0995\u09CB\u09A8\u09CB \u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8 \u09A8\u09C7\u0987","press the button to add your custom token":"\u0986\u09AA\u09A8\u09BE\u09B0 \u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8 \u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u09AC\u09CB\u09A4\u09BE\u09AE \u099F\u09BF\u09AA\u09C1\u09A8","Delete Custom Token":"\u0995\u09BE\u09B8\u09CD\u099F\u09AE \u099F\u09CB\u0995\u09C7\u09A8 \u09AE\u09C1\u099B\u09C1\u09A8","Are you sure you want to Delete this Token?":"\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0986\u09AA\u09A8\u09BF \u098F\u0987 \u099F\u09CB\u0995\u09C7\u09A8 \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09A4\u09C7 \u099A\u09BE\u09A8?","Complete":"\u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3","Running":"\u099A\u09B2\u099B\u09C7","Failed":"\u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7","Clear":"\u09AA\u09B0\u09BF\u09B7\u09CD\u0995\u09BE\u09B0","Search Transaction":"\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8","No transactions":"\u0995\u09CB\u09A8\u09CB \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09A8\u09C7\u0987","Your transaction history is stored locally and will appear here after you start a swap":"\u0986\u09AA\u09A8\u09BE\u09B0 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09B8\u09CD\u09A5\u09BE\u09A8\u09C0\u09AF\u09BC\u09AD\u09BE\u09AC\u09C7 \u09B8\u0982\u09B0\u0995\u09CD\u09B7\u09A3 \u0995\u09B0\u09BE \u09B9\u09AF\u09BC \u098F\u09AC\u0982 \u0986\u09AA\u09A8\u09BF \u098F\u0995\u099F\u09BF \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09B6\u09C1\u09B0\u09C1 \u0995\u09B0\u09BE\u09B0 \u09AA\u09B0\u09C7 \u098F\u0996\u09BE\u09A8\u09C7 \u0989\u09AA\u09B8\u09CD\u09A5\u09BF\u09A4 \u09B9\u09AC\u09C7\u09F7","Clear Transaction History":"\u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09B8\u09BE\u09AB \u0995\u09B0\u09C1\u09A8","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0985\u0997\u09CD\u09B0\u09B8\u09B0 \u09B9\u09B2\u09C7 \u0989\u0987\u099C\u09C7\u099F \u09A5\u09C7\u0995\u09C7 \u09B8\u09AE\u09B8\u09CD\u09A4 \u09B8\u09AB\u09B2 \u098F\u09AC\u0982 \u09AC\u09CD\u09AF\u09B0\u09CD\u09A5 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8 \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09BE \u09B9\u09AC\u09C7\u0964 \u0986\u09AA\u09A8\u09BF \u0995\u09BF \u099A\u09BE\u09B2\u09BF\u09AF\u09BC\u09C7 \u09AF\u09C7\u09A4\u09C7 \u099A\u09BE\u09A8?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u09A6\u09CD\u09B0\u09B7\u09CD\u099F\u09AC\u09CD\u09AF: \u098F\u099F\u09BF \u099A\u09C7\u0987\u09A8\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09AE\u09C1\u099B\u09C7 \u09AB\u09C7\u09B2\u09AC\u09C7 \u09A8\u09BE; \u098F\u099F\u09BF \u09B6\u09C1\u09A7\u09C1\u09AE\u09BE\u09A4\u09CD\u09B0 \u09A4\u09BE\u09A6\u09C7\u09B0 \u098F\u0996\u09BE\u09A8\u09C7 \u09B8\u09B0\u09BF\u09AF\u09BC\u09C7 \u09A6\u09C7\u09AF\u09BC\u0964","Yes, Clear the history":"\u09B9\u09CD\u09AF\u09BE\u0981, \u0987\u09A4\u09BF\u09B9\u09BE\u09B8 \u09B8\u09BE\u09AB \u0995\u09B0\u09C1\u09A8","language":"\u09AD\u09BE\u09B7\u09BE","Deselect all":"\u09B8\u09AC \u09AC\u09BE\u09A6 \u09A6\u09BF\u09A8","Select all":"\u09B8\u09AC \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8","Search {sourceType}":[["sourceType"],"\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u0995\u09B0\u09C1\u09A8\u09F7"],"Search Chain":"\u0985\u09A8\u09C1\u09B8\u09A8\u09CD\u09A7\u09BE\u09A8 \u099A\u09C7\u0987\u09A8","Source":"\u0989\u09CE\u09B8","Destination":"\u0997\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF","Swap {type}":["\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 ",["type"],"\u09F7"],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8\u09C7, \u0986\u09AA\u09A8\u09BF \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF \u0989\u09A4\u09CD\u09B8\u09C7\u09B0 \u0989\u09AA\u09B0 \u09AC\u09BF\u09A7\u09BF\u09A8\u09BF\u09B7\u09C7\u09A7 \u09B8\u09B9 \u09AA\u09CD\u09B0\u099A\u09BE\u09B0\u09BE\u09AD\u09BF\u09AF\u09BE\u09A8 \u09AE\u09CB\u09A1\u09C7 \u0986\u099B\u09C7\u09A8\u0964 \u0986\u09AA\u09A8\u09BF \u0995\u09BF \u098F\u0987 \u09AE\u09CB\u09A1 \u09A5\u09C7\u0995\u09C7 \u09B8\u09CD\u09AF\u09C1\u0987\u099A \u0986\u0989\u099F \u0995\u09B0\u09A4\u09C7 \u098F\u09AC\u0982 \u09B8\u09AE\u09B8\u09CD\u09A4 \u0989\u09AA\u09B2\u09AC\u09CD\u09A7 \u09A4\u09BE\u09B0\u09B2\u09CD\u09AF \u0989\u09A4\u09CD\u09B8 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u09A8?","The request ID is necessary to display the swap details.":"\u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u09AC\u09BF\u09AC\u09B0\u09A3 \u09AA\u09CD\u09B0\u09A6\u09B0\u09CD\u09B6\u09A8 \u0995\u09B0\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09A8\u09C1\u09B0\u09CB\u09A7 \u0986\u0987\u09A1\u09BF \u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC\u0964","Connect Wallets":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09C1\u09A8","Choose a wallet to connect.":"\u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09A4\u09C7 \u098F\u0995\u099F\u09BF \u09AE\u09BE\u09A8\u09BF\u09AC\u09CD\u09AF\u09BE\u0997 \u099A\u09AF\u09BC\u09A8 \u0995\u09B0\u09C1\u09A8.","This week":"\u098F\u0987 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9\u09C7","This month":"\u098F\u0987 \u09AE\u09BE\u09B8\u09C7","This year":"\u098F\u0987 \u09AC\u099B\u09B0","Required: >= {min} {symbol}":["\u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8\u09C0\u09AF\u09BC: < ",["max"]," ",["symbol"]]," for network fee":" \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AB\u09BF \u099C\u09A8\u09CD\u09AF"," for swap":" \u0985\u09A6\u09B2\u09AC\u09A6\u09B2\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF"," for input and network fee":" \u0987\u09A8\u09AA\u09C1\u099F \u098F\u09AC\u0982 \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AB\u09BF \u099C\u09A8\u09CD\u09AF","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u09AA\u09CD\u09B0\u09AF\u09BC\u09CB\u099C\u09A8 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", \u0995\u09BF\u09A8\u09CD\u09A4\u09C1 \u0986\u09AA\u09A8\u09BE\u09B0 ",["blockchain"]," \u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F\u09C7 ",["currentAmount"]," ",["symbol"]," \u0986\u099B\u09C7\u09F7"],"Waiting for connecting wallet":"\u09AE\u09BE\u09A8\u09BF\u09AC\u09CD\u09AF\u09BE\u0997 \u09B8\u0982\u09AF\u09CB\u0997\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","Waiting for other running tasks to be finished":"\u0985\u09A8\u09CD\u09AF\u09BE\u09A8\u09CD\u09AF \u099A\u09B2\u09AE\u09BE\u09A8 \u0995\u09BE\u099C \u09B8\u09AE\u09BE\u09AA\u09CD\u09A4 \u09B9\u0993\u09AF\u09BC\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","Waiting for changing wallet network":"\u0993\u09AF\u09BC\u09BE\u09B2\u09C7\u099F \u09A8\u09C7\u099F\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u0995 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","Sunday":"\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0","Monday":"\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0","Tuesday":"\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0","Wednesday":"\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0","Thursday":"\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0","Friday":"\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0","Saturday":"\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0","Powered By":"\u09A6\u09CD\u09AC\u09BE\u09B0\u09BE \u099A\u09BE\u09B2\u09BF\u09A4","Aggregated Transaction":"\u09B8\u09AE\u09B7\u09CD\u099F\u09BF\u0997\u09A4 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["swapper"],"\u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 ",["fromChain"]," \u098F \u0985\u09A6\u09B2\u09AC\u09A6\u09B2 \u0995\u09B0\u09C1\u09A8\u09F7"],"Bridge to {toChain} via {swapper}":[["swapper"],"\u09B9\u09AF\u09BC\u09C7 ",["toChain"]," \u098F \u09B8\u09C7\u09A4\u09C1"],"Completed":"\u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8","In progress":"\u099A\u09B2\u099B\u09C7","Waiting for bridge transaction":"\u09B8\u09C7\u09A4\u09C1 \u09B2\u09C7\u09A8\u09A6\u09C7\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u099B\u09C7","Connected":"\u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4","Disconnect":"\u09B8\u0982\u09AF\u09CB\u0997 \u09AC\u09BF\u099A\u09CD\u099B\u09BF\u09A8\u09CD\u09A8 \u0995\u09B0\u09C1\u09A8","Install":"\u0987\u09A8\u09B8\u09CD\u099F\u09B2 \u0995\u09B0\u09C1\u09A8","Connecting ...":"\u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7...","Connecting":"\u09B8\u0982\u09AF\u09CB\u0997 \u0995\u09B0\u09BE \u09B9\u099A\u09CD\u099B\u09C7","Disconnected":"\u09B8\u0982\u09AF\u09CB\u0997 \u09AC\u09BF\u099A\u09CD\u099B\u09BF\u09A8\u09CD\u09A8","you need to pass a correct state to Wallet.":"\u0986\u09AA\u09A8\u09BE\u0995\u09C7 Wallet \u098F \u098F\u0995\u099F\u09BF \u09B8\u09A0\u09BF\u0995 \u0985\u09AC\u09B8\u09CD\u09A5\u09BE \u09A6\u09BF\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964","There are no notifications.":"\u0995\u09CB\u09A8 \u09AC\u09BF\u099C\u09CD\u099E\u09AA\u09CD\u09A4\u09BF \u09A8\u09C7\u0987.","Clear all":"\u09B8\u09AC \u09B8\u09BE\u09AB \u0995\u09B0\u09C1\u09A8","Balance":"\u09AD\u09BE\u09B0\u09B8\u09BE\u09AE\u09CD\u09AF","Max":"\u09B8\u09B0\u09CD\u09AC\u09CB\u099A\u09CD\u099A"}');


/*eslint-disable*/ const $4897c42ac4abf87c$export$defe85febe8b728c = JSON.parse('{"No results found":"No s\'han trobat resultats","Try using different keywords":"Proveu d\'utilitzar paraules clau diferents","Select Chain":"Seleccioneu Cadena","All":"Tots","More +{count}":["M\xe9s +",["count"]],"Activate this tab":"Activa aquesta pestanya","Another tab is open and handles transactions.":"Una altra pestanya est\xe0 oberta i gestiona les transaccions.","Activate current tab":"Activa la pestanya actual","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Actualment, algunes transaccions s\'estan executant i gestionades per una altra pestanya del navegador. Si activeu aquesta pestanya, caducaran totes les transaccions que ja estiguin al pas de signatura de la transacci\xf3.","Confirm":"Confirmeu","Your {blockchainName} wallets":["Les vostres carteres ",["blockchainName"]],"Insufficient account balance":"Saldo del compte insuficient","Proceed anyway":"Continueu igualment","You need to connect a {blockchainName} wallet.":["Heu de connectar una cartera ",["blockchainName"]," ."],"Add {chain} chain":["Afegeix ",["chain"]," cadena"],"Show more wallets":"Mostra m\xe9s carteres","Send to a different address":"Enviar a una adre\xe7a diferent","Enter {blockchainName} address":["Introdu\xefu l\'adre\xe7a ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["L\'adre\xe7a ",["destination"]," no coincideix amb el patr\xf3 d\'adreces blockchain."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Aquest testimoni no apareix a les llistes de fitxes actives. Assegureu-vos que aquest \xe9s el testimoni que voleu negociar.","Import":"Importar","Status":"Estat","Reset":"Restableix","Cancel":"Cancel\xb7la","Refresh":"Actualitza","Notifications":"Notificacions","Settings":"Configuraci\xf3","History":"Hist\xf2ria","Connect Wallet":"Connecta Wallet","Today":"Avui","Swaps steps":"Canvia passos","Retry":"Torna-ho a provar","Slippage Error":"Error de lliscament","Slippage Warning":"Av\xeds de lliscament","Bridge Limit Error":"Error de l\xedmit del pont","Yours: {amount} {symbol}":["El teu: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Lliscament m\xednim requerit: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["El teu: ",["userSlippage"]],"See All Routes":"Veure totes les rutes","View more info":"Veure m\xe9s informaci\xf3","Gas & Fee Explanation":"Explicaci\xf3 de la tarifa i el gas","Details":"Detalls","Total Payable Fee":"Quota total a pagar","Hide non-payable fees":"Amaga les taxes no pagables","Show non-payable fees":"Mostra les taxes no pagables","Description":"Descripci\xf3","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Les tarifes seg\xfcents es tenen en compte a la sortida de la transacci\xf3 i\\n                no haureu de pagar gas addicional per elles.","Swap input":"Canvia l\'entrada","Estimated output":"Sortida estimada","Via:":"Via:","Chains:":"Cadenes:","Sort by":"Ordena per","Smart Routing":"Enrutament intel\xb7ligent","Lowest Fee":"Tarifa m\xe9s baixa","Fastest Transfer":"La transfer\xe8ncia m\xe9s r\xe0pida","Maximum Return":"Rendiment m\xe0xim","Maximum Output":"Sortida m\xe0xima","Swapping":"Canvi","Gas cost":"Cost del gas","Receiving":"Recepci\xf3","Price impact":"Impacte en el preu","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Heu d\'augmentar el lliscament com a m\xednim a ",["minRequiredSlippage"]," per a aquesta ruta."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Us recomanem que augmenteu el lliscament com a m\xednim a ",["minRequiredSlippage"]," per a aquesta ruta."],"Caution, your slippage is high.":"Atenci\xf3, el vostre lliscament \xe9s alt.","Change":"Canviar","Change settings":"Canvia la configuraci\xf3","High slippage":"Alt lliscament","Low slippage":"Baix lliscament"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Atenci\xf3, el vostre lliscament \xe9s alt (=",["userSlippage"],"). El vostre comer\xe7 pot ser al capdavant."],"Confirm anyway":"Confirmeu igualment","Something went wrong":"Alguna cosa va fallar","Something went wrong. Please refresh the app.":"Alguna cosa va fallar. Actualitzeu l\'aplicaci\xf3.","Slippage tolerance per swap":"Toler\xe0ncia de lliscament per canvi","Custom":"Personalitzat","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"La vostra transacci\xf3 es revertir\xe0 si el preu canvia desfavorablement en m\xe9s d\'aquest percentatge.","Warning":"Av\xeds","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Aquesta configuraci\xf3 s\'aplica a cada pas (per exemple, 1 polzada, Thorchain, etc.), el que significa que nom\xe9s es revertir\xe0 aquest pas espec\xedfic, no tota la ruta.","Swap Details":"Detalls de l\'intercanvi","Request ID":"Sol\xb7licitud d\'identificaci\xf3","Not found":"No s\'ha trobat","Swap with request ID = {requestId} not found.":["Canvia amb l\'ID de sol\xb7licitud = ",["requestId"]," no s\'ha trobat."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Heu rebut ",["amount"]," ",["token"]," a la cartera ",["conciseAddress"]," de la cadena ",["chain"]," ."],"Transaction was not sent.":"La transacci\xf3 no s\'ha enviat.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," el ",["blockchain"]," roman a la cartera."],"Delete":"Suprimeix","Try again":"Torna-ho a provar","Copied To Clipboard":"S\'ha copiat al porta-retalls","Copy Request ID":"Copia l\'identificador de sol\xb7licitud","View on Rango Explorer":"Veure a Rango Explorer","Finished at":"Acabat a les","Created at":"Creat a","View transaction":"Veure transacci\xf3","Connect":"Connecta\'t","Swap Successful":"Canvi amb \xe8xit","Transaction Failed":"La transacci\xf3 ha fallat","Done":"Fet","Diagnosis":"Diagn\xf2stic","See Details":"Veure Detalls","Cancel Swap":"Cancel\xb7la l\'intercanvi","Are you sure you want to cancel this swap?":"Esteu segur que voleu cancel\xb7lar aquest intercanvi?","Yes, Cancel it":"S\xed, cancel\xb7la-ho","No, Continue":"No, continua","Delete Transaction":"Suprimeix la transacci\xf3","Are you sure you want to delete this swap?":"Esteu segur que voleu suprimir aquest intercanvi?","Yes, Delete it":"S\xed, esborra-ho","No, Cancel":"No, cancel\xb7la","Change Network":"Canviar Xarxa","Network Changed":"La xarxa ha canviat","Select Token":"Seleccioneu Token","Wallet Connected":"Wallet connectat","Your wallet is connected, you can use it to swap.":"La vostra cartera est\xe0 connectada, podeu utilitzar-la per intercanviar.","Failed to Connect":"No s\'ha pogut connectar","Your wallet is not connected. Please try again.":"La teva cartera no est\xe0 connectada. Si us plau, torna-ho a provar.","Connecting to your wallet":"Connectant a la teva cartera","Click connect in your wallet popup.":"Feu clic a connectar a la finestra emergent de la cartera.","Select Derivation Path":"Seleccioneu Cam\xed de derivaci\xf3","In order to connect to {type}, you must first select a Derivation Path":["Per connectar-vos a ",["type"],", primer heu de seleccionar un cam\xed de derivaci\xf3"],"Choose Derivation Path Template":"Trieu Plantilla de cam\xed de derivaci\xf3","Enter Path":"Introdu\xefu el cam\xed","Enter Index":"Introdu\xefu l\'\xedndex","Add {blockchainDisplayName} Chain":["Afegeix ",["blockchainDisplayName"]," cadena"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Vols afegir la cadena experimental ",["blockchainDisplayName"]," a la teva cartera?"],"Please approve the experimental chain pop-up in your wallet.":"Aproveu la finestra emergent de la cadena experimental a la vostra cartera.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Cadena afegida"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["La cadena ",["blockchainDisplayName"]," s\'ha afegit correctament a la vostra cartera."],"Request Rejected":"Sol\xb7licitud rebutjada","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Has rebutjat afegir la cadena ",["blockchainDisplayName"]," a la teva cartera."],"Select chain types":"Seleccioneu els tipus de cadena","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Aquesta cartera admet m\xfaltiples cadenes. Seleccioneu a quina cadena us voleu connectar.","Failed Network, Please retry your swap.":"La xarxa ha fallat. Torneu a provar l\'intercanvi.","Please reset your liquidity sources.":"Reinicieu les fonts de liquiditat.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Heu limitat les fonts de liquiditat i aix\xf2 pot fer que Rango no trobi cap ruta. Considereu la possibilitat de restablir les vostres fonts de liquiditat.","No Routes Found.":"No s\'han trobat rutes.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Motius pels quals Rango no ha pogut trobar una ruta: poca liquiditat al testimoni, quantitat d\'entrada molt baixa o no hi ha rutes disponibles per a la combinaci\xf3 de testimoni d\'entrada/sortida seleccionada.","Bridge Limit Error: Please increase your amount.":"Error de l\xedmit de pont: augmenta l\'import.","Bridge Limit Error: Please decrease your amount.":"Error de l\xedmit de pont: redu\xefu l\'import.","High Price Impact":"Alt impacte dels preus","Price impact is too high!":"L\'impacte del preu \xe9s massa alt!","The price impact is significantly higher than the allowed amount.":"L\'impacte del preu \xe9s significativament superior a la quantitat permesa.","Confirm high price impact":"Confirmeu l\'alt impacte dels preus","Route updated and price impact is too high, try again later!":"La ruta s\'ha actualitzat i l\'impacte en el preu \xe9s massa alt, torna-ho a provar m\xe9s tard!","USD Price Unknown":"Preu en USD desconegut","USD Price Unknown, Cannot calculate Price Impact.":"Preu en USD desconegut, no es pot calcular l\'impacte del preu.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Preu en USD desconegut, no es pot calcular l\'impacte del preu. L\'impacte en el preu pot ser m\xe9s gran de l\'habitual. Esteu segur de continuar l\'intercanvi?","Confirm USD Price Unknown":"Confirmeu el preu en USD desconegut","Swap":"Canviar","Swap anyway":"Canvia de totes maneres","The route goes through Ethereum. Continue?":"La ruta passa per Ethereum. Continuar?","Route has been updated.":"La ruta s\'ha actualitzat.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["La quantitat de sortida ha canviat a ",["newOutputAmount"]," (",["percentageChange"],"% de canvi)."],"Route swappers has been updated.":"Els intercanviadors de rutes s\'han actualitzat.","Route internal coins has been updated.":"Les monedes internes de la ruta s\'han actualitzat.","Routes":"Rutes","From":"Des de","To":"A","Light":"Llum","Dark":"Fosc","Auto":"Autom\xe0tic","Loading failed":"S\'ha produ\xeft un error en carregar","Bridges":"Ponts","Exchanges":"Intercanvis","Custom Tokens":"Fitxes personalitzades","Language":"Llengua","Infinite approval":"Aprovaci\xf3 infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"L\'habilitaci\xf3 del mode \\"Aprovaci\xf3 infinita\\" concedeix acc\xe9s sense restriccions als contractes intel\xb7ligents subjacents, cosa que els permet utilitzar la quantitat de testimoni aprovada sense limitacions.","Theme":"Tema","Duplicate Token":"Token duplicat","The address you entered is duplicate, please enter a new address.":"L\'adre\xe7a que heu introdu\xeft \xe9s duplicada, introdu\xefu una adre\xe7a nova.","Token Already Exists":"El testimoni ja existeix","There\'s no need to add this token again because it already exists and is supported by us.":"No cal tornar a afegir aquest testimoni perqu\xe8 ja existeix i el donem suport.","Token Not Found":"No s\'ha trobat el testimoni","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Ho sentim, no s\'ha trobat cap testimoni a la cadena ",["blockchain"]," amb l\'adre\xe7a proporcionada. si us plau, assegureu-vos que heu introdu\xeft l\'adre\xe7a de testimoni correcta."],"Network Error":"Error de xarxa","Add Custom Token":"Afegeix un testimoni personalitzat","Select chain":"Seleccioneu la cadena","Enter Address":"Introdu\xefu l\'adre\xe7a","Enter token address":"Introdu\xefu l\'adre\xe7a del testimoni","Failed Network, Please retry.":"La xarxa ha fallat, torneu-ho a provar.","Add another custom token":"Afegiu un altre testimoni personalitzat","Confirm Swap":"Confirmeu l\'intercanvi","Start Swap":"Inicia l\'intercanvi","You get":"Ho aconsegueixes","Search Token":"Token de cerca","No custom tokens":"Sense fitxes personalitzades","press the button to add your custom token":"premeu el bot\xf3 per afegir el vostre testimoni personalitzat","Delete Custom Token":"Suprimeix el testimoni personalitzat","Are you sure you want to Delete this Token?":"Esteu segur que voleu suprimir aquest testimoni?","Complete":"Completa","Running":"C\xf3rrer","Failed":"Ha fallat","Clear":"Clar","Search Transaction":"Cerca transacci\xf3","No transactions":"No hi ha transaccions","Your transaction history is stored locally and will appear here after you start a swap":"El vostre historial de transaccions s\'emmagatzema localment i apareixer\xe0 aqu\xed despr\xe9s d\'iniciar un intercanvi","Clear Transaction History":"Esborra l\'historial de transaccions","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Si continueu, s\'eliminaran del widget totes les transaccions reeixides i fallides. Vols continuar?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Nota: Aix\xf2 no esborra el vostre historial de transaccions a la cadena; aqu\xed nom\xe9s els elimina.","Yes, Clear the history":"S\xed, esborra l\'historial","language":"llengua","Deselect all":"Desseleccioneu-ho tot","Select all":"Seleccioneu-ho tot","Search {sourceType}":["Cerca ",["sourceType"]],"Search Chain":"Cadena de cerca","Source":"Font","Destination":"Destinaci\xf3","Swap {type}":["Canvia ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Actualment, esteu en mode campanya amb restriccions a les fonts de liquiditat. Voleu sortir d\'aquest mode i fer \xfas de totes les fonts de liquiditat disponibles?","The request ID is necessary to display the swap details.":"L\'identificador de sol\xb7licitud \xe9s necessari per mostrar els detalls de l\'intercanvi.","Connect Wallets":"Connecta Wallets","Choose a wallet to connect.":"Trieu una cartera per connectar-vos.","This week":"Aquesta setmana","This month":"Aquest mes","This year":"Aquest any","Required: >= {min} {symbol}":["Necessari: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Necessari: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Obligatori: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Necessari: < ",["max"]," ",["symbol"]]," for network fee":" per tarifa de xarxa"," for swap":" per intercanvi"," for input and network fee":" per entrada i tarifa de xarxa","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Necessita \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", per\xf2 tens ",["currentAmount"]," ",["symbol"]," a la teva cartera ",["blockchain"]," ."],"Waiting for connecting wallet":"S\'est\xe0 esperant la connexi\xf3 de la cartera","Waiting for other running tasks to be finished":"Esperant que s\'acabin altres tasques en execuci\xf3","Waiting for changing wallet network":"S\'est\xe0 esperant el canvi de xarxa de cartera","Sunday":"diumenge","Monday":"dilluns","Tuesday":"dimarts","Wednesday":"dimecres","Thursday":"dijous","Friday":"divendres","Saturday":"dissabte","Powered By":"Desenvolupat per","Aggregated Transaction":"Transacci\xf3 agregada","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Canvia a ",["fromChain"]," mitjan\xe7ant ",["swapper"]],"Bridge to {toChain} via {swapper}":["Pont cap a ",["toChain"]," via ",["swapper"]],"Completed":"Completat","In progress":"En curs","Waiting for bridge transaction":"S\'est\xe0 esperant la transacci\xf3 pont","Connected":"Connectat","Disconnect":"Desconnecta","Install":"Instal\xb7lar","Connecting ...":"S\'est\xe0 connectant...","Connecting":"Connectant","Disconnected":"Desconnectat","you need to pass a correct state to Wallet.":"heu de passar un estat correcte a Wallet.","There are no notifications.":"No hi ha notificacions.","Clear all":"Esborra-ho tot","Balance":"Balan\xe7","Max":"M\xe0x"}');


/*eslint-disable*/ const $cbcb323baab5f3ac$export$defe85febe8b728c = JSON.parse('{"No results found":"Ingen resultater fundet","Try using different keywords":"Pr\xf8v at bruge forskellige s\xf8geord","Select Chain":"V\xe6lg K\xe6de","All":"Alle","More +{count}":["Mere +",["count"]],"Activate this tab":"Aktiver denne fane","Another tab is open and handles transactions.":"En anden fane er \xe5ben og h\xe5ndterer transaktioner.","Activate current tab":"Aktiver den aktuelle fane","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"I \xf8jeblikket k\xf8rer nogle transaktioner og h\xe5ndteres af en anden browserfane. Hvis du aktiverer denne fane, vil alle transaktioner, der allerede er i transaktionstegntrinnet, udl\xf8be.","Confirm":"Bekr\xe6fte","Your {blockchainName} wallets":["Dine ",["blockchainName"]," tegneb\xf8ger"],"Insufficient account balance":"Utilstr\xe6kkelig kontosaldo","Proceed anyway":"Forts\xe6t alligevel","You need to connect a {blockchainName} wallet.":["Du skal tilslutte en ",["blockchainName"]," tegnebog."],"Add {chain} chain":["Tilf\xf8j ",["chain"]," k\xe6de"],"Show more wallets":"Vis flere tegneb\xf8ger","Send to a different address":"Send til en anden adresse","Enter {blockchainName} address":["Indtast ",["blockchainName"]," adresse"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adressen ",["destination"]," matcher ikke blockchain-adressem\xf8nsteret."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Dette token vises ikke p\xe5 den eller de aktive token-lister. S\xf8rg for, at dette er det token, du vil handle.","Import":"Importere","Status":"Status","Reset":"Nulstil","Cancel":"Oph\xe6ve","Refresh":"Opfriske","Notifications":"Meddelelser","Settings":"Indstillinger","History":"Historie","Connect Wallet":"Tilslut tegnebog","Today":"I dag","Swaps steps":"Bytter trin","Retry":"Pr\xf8v igen","Slippage Error":"Skridningsfejl","Slippage Warning":"Advarsel om glidning","Bridge Limit Error":"Brogr\xe6nsefejl","Yours: {amount} {symbol}":["Dine: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum p\xe5kr\xe6vet glidning: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Dine: ",["userSlippage"]],"See All Routes":"Se alle ruter","View more info":"Se mere info","Gas & Fee Explanation":"Gas & gebyrforklaring","Details":"Detaljer","Total Payable Fee":"Samlet betalbar gebyr","Hide non-payable fees":"Skjul ikke-betalbare gebyrer","Show non-payable fees":"Vis ikke-betalbare gebyrer","Description":"Beskrivelse","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"F\xf8lgende gebyrer tages i betragtning i transaktionens output, og\\n                beh\xf8ver du ikke betale ekstra gas for dem.","Swap input":"Skift input","Estimated output":"Estimeret output","Via:":"Via:","Chains:":"K\xe6der:","Sort by":"Sorter efter","Smart Routing":"Smart Routing","Lowest Fee":"Laveste gebyr","Fastest Transfer":"Hurtigste overf\xf8rsel","Maximum Return":"Maksimal afkast","Maximum Output":"Maksimal output","Swapping":"Bytte","Gas cost":"Gas omkostninger","Receiving":"Modtager","Price impact":"Prisp\xe5virkning","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Du skal \xf8ge glidningen til mindst ",["minRequiredSlippage"]," for denne rute."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Vi anbefaler, at du \xf8ger glidningen til mindst ",["minRequiredSlippage"]," for denne rute."],"Caution, your slippage is high.":"Forsigtig, din glidning er h\xf8j.","Change":"Forandring","Change settings":"Skift indstillinger","High slippage":"H\xf8j glidning","Low slippage":"Lav glidning"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Forsigtig, din glidning er h\xf8j (=",["userSlippage"],"). Din handel kan v\xe6re frontl\xf8b."],"Confirm anyway":"Bekr\xe6ft alligevel","Something went wrong":"Noget gik galt","Something went wrong. Please refresh the app.":"Noget gik galt. Opdater venligst appen.","Slippage tolerance per swap":"Skridtolerance pr. swap","Custom":"Skik","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Din transaktion vil blive tilbagef\xf8rt, hvis prisen \xe6ndres ugunstigt med mere end denne procentdel.","Warning":"Advarsel","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Denne indstilling anvendes p\xe5 hvert trin (f.eks. 1 tomme, Thorchain osv.), hvilket betyder, at kun det specifikke trin vil blive vendt tilbage, ikke hele ruten.","Swap Details":"Byt detaljer","Request ID":"Anmod om ID","Not found":"Ikke fundet","Swap with request ID = {requestId} not found.":["Byt med anmodnings-id = ",["requestId"]," ikke fundet."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Du har modtaget ",["amount"]," ",["token"]," i ",["conciseAddress"]," tegnebog p\xe5 ",["chain"]," k\xe6den."],"Transaction was not sent.":"Transaktionen blev ikke sendt.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," p\xe5 ",["blockchain"]," forbliver i din tegnebog."],"Delete":"Slet","Try again":"Pr\xf8v igen","Copied To Clipboard":"Kopieret til udklipsholder","Copy Request ID":"Kopi\xe9r anmodnings-id","View on Rango Explorer":"Se p\xe5 Rango Explorer","Finished at":"Afsluttet kl","Created at":"Oprettet kl","View transaction":"Se transaktion","Connect":"Forbinde","Swap Successful":"Swap vellykket","Transaction Failed":"Transaktion mislykkedes","Done":"F\xe6rdig","Diagnosis":"Diagnose","See Details":"Se detaljer","Cancel Swap":"Annuller Swap","Are you sure you want to cancel this swap?":"Er du sikker p\xe5, at du vil annullere dette bytte?","Yes, Cancel it":"Ja, annuller det","No, Continue":"Nej, forts\xe6t","Delete Transaction":"Slet transaktion","Are you sure you want to delete this swap?":"Er du sikker p\xe5, at du vil slette denne swap?","Yes, Delete it":"Ja, slet det","No, Cancel":"Nej, annuller","Change Network":"Skift netv\xe6rk","Network Changed":"Netv\xe6rk \xe6ndret","Select Token":"V\xe6lg Token","Wallet Connected":"Tegnebog tilsluttet","Your wallet is connected, you can use it to swap.":"Din tegnebog er tilsluttet, du kan bruge den til at bytte.","Failed to Connect":"Kunne ikke oprette forbindelse","Your wallet is not connected. Please try again.":"Din tegnebog er ikke tilsluttet. Pr\xf8v venligst igen.","Connecting to your wallet":"Tilslutning til din tegnebog","Click connect in your wallet popup.":"Klik p\xe5 tilslut i din tegnebogs popup.","Select Derivation Path":"V\xe6lg Afledningssti","In order to connect to {type}, you must first select a Derivation Path":["For at oprette forbindelse til ",["type"],"skal du f\xf8rst v\xe6lge en afledningssti"],"Choose Derivation Path Template":"V\xe6lg Afledningsstiskabelon","Enter Path":"Indtast sti","Enter Index":"Indtast indeks","Add {blockchainDisplayName} Chain":["Tilf\xf8j ",["blockchainDisplayName"]," k\xe6de"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Kunne du t\xe6nke dig at tilf\xf8je ",["blockchainDisplayName"]," eksperimentelle k\xe6de til din tegnebog?"],"Please approve the experimental chain pop-up in your wallet.":"Godkend venligst den eksperimentelle k\xe6de-pop-up i din tegnebog.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," K\xe6de tilf\xf8jet"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," -k\xe6den er blevet tilf\xf8jet til din tegnebog."],"Request Rejected":"Anmodning afvist","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Du har afvist at tilf\xf8je ",["blockchainDisplayName"]," -k\xe6den til din tegnebog."],"Select chain types":"V\xe6lg k\xe6detyper","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Denne pung underst\xf8tter flere k\xe6der. V\xe6lg hvilken k\xe6de du vil oprette forbindelse til.","Failed Network, Please retry your swap.":"Mislykket netv\xe6rk. Pr\xf8v venligst at bytte igen.","Please reset your liquidity sources.":"Nulstil venligst dine likviditetskilder.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Du har begr\xe6nset likviditetskilderne, og det kan resultere i, at Rango ikke finder nogen ruter. Overvej venligst at nulstille dine likviditetskilder.","No Routes Found.":"Ingen ruter fundet.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\xc5rsager til, at Rango ikke kunne finde en rute: lav likviditet p\xe5 token, meget lavt inputbel\xf8b eller ingen tilg\xe6ngelige ruter for den valgte input/output token-kombination.","Bridge Limit Error: Please increase your amount.":"Bridge Limit Error: For\xf8g venligst dit bel\xf8b.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit Error: Reducer venligst dit bel\xf8b.","High Price Impact":"H\xf8j prisp\xe5virkning","Price impact is too high!":"Prisp\xe5virkningen er for h\xf8j!","The price impact is significantly higher than the allowed amount.":"Prisp\xe5virkningen er v\xe6sentligt h\xf8jere end det tilladte bel\xf8b.","Confirm high price impact":"Bekr\xe6ft h\xf8j prisp\xe5virkning","Route updated and price impact is too high, try again later!":"Ruten er opdateret, og prisp\xe5virkningen er for h\xf8j. Pr\xf8v igen senere!","USD Price Unknown":"USD Pris ukendt","USD Price Unknown, Cannot calculate Price Impact.":"USD-pris ukendt, kan ikke beregne prisp\xe5virkning.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD-pris ukendt, kan ikke beregne prisp\xe5virkning. Prisp\xe5virkningen kan v\xe6re h\xf8jere end normalt. Er du sikker p\xe5 at du vil forts\xe6tte byttet?","Confirm USD Price Unknown":"Bekr\xe6ft USD-pris ukendt","Swap":"Byt","Swap anyway":"Byt alligevel","The route goes through Ethereum. Continue?":"Ruten g\xe5r gennem Ethereum. Forts\xe6tte?","Route has been updated.":"Ruten er blevet opdateret.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Outputm\xe6ngde \xe6ndret til ",["newOutputAmount"]," (",["percentageChange"],"% \xe6ndring)."],"Route swappers has been updated.":"Rutebyttere er blevet opdateret.","Route internal coins has been updated.":"Rutens interne m\xf8nter er blevet opdateret.","Routes":"Ruter","From":"Fra","To":"Til","Light":"Lys","Dark":"M\xf8rk","Auto":"Auto","Loading failed":"Indl\xe6sning mislykkedes","Bridges":"Broer","Exchanges":"Udvekslinger","Custom Tokens":"Brugerdefinerede tokens","Language":"Sprog","Infinite approval":"Uendelig godkendelse","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Aktivering af tilstanden \'Uendelig godkendelse\' giver ubegr\xe6nset adgang til underliggende smarte kontrakter, hvilket giver dem mulighed for at bruge det godkendte tokenbel\xf8b uden begr\xe6nsninger.","Theme":"Tema","Duplicate Token":"Dublet token","The address you entered is duplicate, please enter a new address.":"Den adresse du indtastede er dublet, indtast venligst en ny adresse.","Token Already Exists":"Token findes allerede","There\'s no need to add this token again because it already exists and is supported by us.":"Der er ingen grund til at tilf\xf8je dette token igen, fordi det allerede eksisterer og underst\xf8ttes af os.","Token Not Found":"Token ikke fundet","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Beklager, der blev ikke fundet noget token p\xe5 ",["blockchain"]," -k\xe6den med den angivne adresse. S\xf8rg for, at du har indtastet den rigtige token-adresse."],"Network Error":"Netv\xe6rksfejl","Add Custom Token":"Tilf\xf8j tilpasset token","Select chain":"V\xe6lg k\xe6de","Enter Address":"Indtast adresse","Enter token address":"Indtast token-adresse","Failed Network, Please retry.":"Mislykket netv\xe6rk. Pr\xf8v venligst igen.","Add another custom token":"Tilf\xf8j endnu et brugerdefineret token","Confirm Swap":"Bekr\xe6ft Swap","Start Swap":"Start Swap","You get":"Du f\xe5r","Search Token":"S\xf8g token","No custom tokens":"Ingen brugerdefinerede tokens","press the button to add your custom token":"tryk p\xe5 knappen for at tilf\xf8je dit brugerdefinerede token","Delete Custom Token":"Slet brugerdefineret token","Are you sure you want to Delete this Token?":"Er du sikker p\xe5, at du vil slette dette token?","Complete":"Komplet","Running":"L\xf8b","Failed":"Mislykkedes","Clear":"Klar","Search Transaction":"S\xf8g transaktion","No transactions":"Ingen transaktioner","Your transaction history is stored locally and will appear here after you start a swap":"Din transaktionshistorik gemmes lokalt og vises her, n\xe5r du har startet en swap","Clear Transaction History":"Ryd transaktionshistorik","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Hvis du forts\xe6tter, fjernes alle vellykkede og mislykkede transaktioner fra widgetten. Vil du forts\xe6tte?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Bem\xe6rk: Dette sletter ikke din transaktionshistorik p\xe5 k\xe6den; det fjerner dem kun her.","Yes, Clear the history":"Ja, Ryd historikken","language":"sprog","Deselect all":"Frav\xe6lg alle","Select all":"V\xe6lg alle","Search {sourceType}":["S\xf8g ",["sourceType"]],"Search Chain":"S\xf8gek\xe6de","Source":"Kilde","Destination":"Bestemmelsessted","Swap {type}":["Byt ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"I \xf8jeblikket er du i kampagnetilstand med begr\xe6nsninger p\xe5 likviditetskilder. Vil du skifte ud af denne tilstand og g\xf8re brug af alle tilg\xe6ngelige likviditetskilder?","The request ID is necessary to display the swap details.":"Anmodnings-id\'et er n\xf8dvendigt for at vise bytteoplysningerne.","Connect Wallets":"Tilslut tegneb\xf8ger","Choose a wallet to connect.":"V\xe6lg en tegnebog at forbinde.","This week":"Denne uge","This month":"Denne m\xe5ned","This year":"I \xe5r","Required: >= {min} {symbol}":["P\xe5kr\xe6vet: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["P\xe5kr\xe6vet: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["P\xe5kr\xe6vet: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["P\xe5kr\xe6vet: < ",["max"]," ",["symbol"]]," for network fee":" mod netv\xe6rksafgift"," for swap":" til bytte"," for input and network fee":" for input og netv\xe6rksgebyr","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Har brug for \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", men du har ",["currentAmount"]," ",["symbol"]," i din ",["blockchain"]," tegnebog."],"Waiting for connecting wallet":"Venter p\xe5 tilslutning af tegnebog","Waiting for other running tasks to be finished":"Venter p\xe5, at andre k\xf8rende opgaver er f\xe6rdige","Waiting for changing wallet network":"Venter p\xe5 at skifte tegnebogsnetv\xe6rk","Sunday":"s\xf8ndag","Monday":"mandag","Tuesday":"tirsdag","Wednesday":"onsdag","Thursday":"torsdag","Friday":"fredag","Saturday":"l\xf8rdag","Powered By":"Drevet af","Aggregated Transaction":"Aggregeret transaktion","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Byt p\xe5 ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bro til ",["toChain"]," via ",["swapper"]],"Completed":"F\xe6rdiggjort","In progress":"I gang","Waiting for bridge transaction":"Venter p\xe5 brotransaktion","Connected":"Forbundet","Disconnect":"Afbryde","Install":"Installere","Connecting ...":"Opretter forbindelse...","Connecting":"Forbinder","Disconnected":"Afbrudt","you need to pass a correct state to Wallet.":"du skal sende en korrekt tilstand til Wallet.","There are no notifications.":"Der er ingen meddelelser.","Clear all":"Ryd alle","Balance":"Balance","Max":"Maks"}');


/*eslint-disable*/ const $f4a2abe442b680eb$export$defe85febe8b728c = JSON.parse('{"No results found":"Keine Ergebnisse gefunden","Try using different keywords":"Versuchen Sie, andere Stichw\xf6rter zu verwenden","Select Chain":"Kette ausw\xe4hlen","All":"Alle","More +{count}":["Mehr +",["count"]],"Activate this tab":"Diesen Tab aktivieren","Another tab is open and handles transactions.":"Ein weiterer Tab ist ge\xf6ffnet und bearbeitet Transaktionen.","Activate current tab":"Aktuellen Tab aktivieren","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Derzeit laufen einige Transaktionen und werden von einem anderen Browser-Tab abgewickelt. Wenn Sie diesen Tab aktivieren, werden alle Transaktionen, die sich bereits im Schritt zum Transaktionszeichen befinden, ablaufen.","Confirm":"Best\xe4tigen","Your {blockchainName} wallets":["Ihre ",["blockchainName"]," Wallets"],"Insufficient account balance":"Unzureichender Kontostand","Proceed anyway":"Trotzdem fortfahren","You need to connect a {blockchainName} wallet.":["Sie m\xfcssen eine ",["blockchainName"]," Wallet verbinden."],"Add {chain} chain":[["chain"]," Kette hinzuf\xfcgen"],"Show more wallets":"Mehr Brieftaschen anzeigen","Send to a different address":"An eine andere Adresse senden","Enter {blockchainName} address":[["blockchainName"]," Adresse eingeben"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adresse ",["destination"]," stimmt nicht mit dem Blockchain-Adressmuster \xfcberein."],"via":"\xfcber","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Dieses Token erscheint nicht in der aktiven Tokenliste(n). Stellen Sie sicher, dass dies das Token ist, das Sie handeln m\xf6chten.","Import":"Importieren","Status":"Status","Reset":"Reset","Cancel":"Abbrechen","Refresh":"Aktualisieren","Notifications":"Benachrichtigungen","Settings":"Einstellungen","History":"Verlauf","Connect Wallet":"Wallet verbinden","Today":"Heute","Swaps steps":"Swaps Schritte","Retry":"Wiederholen","Slippage Error":"Slippage Fehler","Slippage Warning":"Slippage Warnung","Bridge Limit Error":"Br\xfcckenbegrenzungsfehler","Yours: {amount} {symbol}":["Ihre: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimal ben\xf6tigte Slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Ihre: ",["userSlippage"]],"See All Routes":"Alle Routen anzeigen","View more info":"Mehr Infos anzeigen","Gas & Fee Explanation":"Gas- & Geb\xfchrenerkl\xe4rung","Details":"Details","Total Payable Fee":"Gesamtgeb\xfchr","Hide non-payable fees":"Nicht zu zahlende Geb\xfchren ausblenden","Show non-payable fees":"Nicht zahlbare Geb\xfchren anzeigen","Description":"Beschreibung","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Die folgenden Geb\xfchren werden in der Transaktionsleistung ber\xfccksichtigt und\\n                Sie brauchen kein zus\xe4tzliches Gas daf\xfcr zu bezahlen.","Swap input":"Swap input","Estimated output":"Gesch\xe4tzte Ausgabe","Via:":"Via:","Chains:":"Ketten:","Sort by":"Sortieren nach","Smart Routing":"Intelligente Routing","Lowest Fee":"Niedrigste Geb\xfchr","Fastest Transfer":"Schnellste \xdcbertragung","Maximum Return":"Maximale Retoure","Maximum Output":"Maximale Ausgabe","Swapping":"Swapping","Gas cost":"Gaskosten","Receiving":"Empfangen","Price impact":"Preisauswirkung","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Sie m\xfcssen den Slippage f\xfcr diese Route auf mindestens ",["minRequiredSlippage"]," erh\xf6hen."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Wir empfehlen Ihnen, den Slippage auf mindestens ",["minRequiredSlippage"]," f\xfcr diese Route zu erh\xf6hen."],"Caution, your slippage is high.":"Vorsicht, Ihre Slippage ist hoch.","Change":"\xc4ndern","Change settings":"Einstellungen \xe4ndern","High slippage":"Hoher Slippage","Low slippage":"Niedrige Slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Achtung, Ihr Slippage ist hoch (=",["userSlippage"],"). Ihr Handel k\xf6nnte vorderhand laufen."],"Confirm anyway":"Trotzdem best\xe4tigen","Something went wrong":"Etwas ist schief gelaufen","Something went wrong. Please refresh the app.":"Etwas ist schief gelaufen. Bitte aktualisieren Sie die App.","Slippage tolerance per swap":"Slippage Toleranz pro Tausch","Custom":"Eigene","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Ihre Transaktion wird r\xfcckg\xe4ngig gemacht, wenn sich der Preis ung\xfcnstig um mehr als diesen Prozentsatz \xe4ndert.","Warning":"Warnung","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Diese Einstellung wird auf jeden Schritt angewendet (z.B. 1Inch, Thorchain, etc.), was bedeutet, dass nur ein bestimmter Schritt r\xfcckg\xe4ngig gemacht wird, nicht die gesamte Route.","Swap Details":"Swap-Details","Request ID":"Anfrage-ID","Not found":"Nicht gefunden","Swap with request ID = {requestId} not found.":["Swap mit Request ID = ",["requestId"]," nicht gefunden."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Sie haben ",["amount"]," ",["token"]," in ",["conciseAddress"]," Wallet auf ",["chain"]," Kette erhalten."],"Transaction was not sent.":"Transaktion wurde nicht versendet.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," auf ",["blockchain"]," verbleibt in Ihrer Brieftasche."],"Delete":"L\xf6schen","Try again":"Erneut versuchen","Copied To Clipboard":"In Zwischenablage kopiert","Copy Request ID":"Anfrage-ID kopieren","View on Rango Explorer":"Auf Rango Explorer anzeigen","Finished at":"Beendet am","Created at":"Erstellt am","View transaction":"Transaktion anzeigen","Connect":"Verbinden","Swap Successful":"Tausch erfolgreich","Transaction Failed":"Transaktion fehlgeschlagen","Done":"Fertig","Diagnosis":"Diagnose","See Details":"Details ansehen","Cancel Swap":"Tausch abbrechen","Are you sure you want to cancel this swap?":"Sind Sie sicher, dass Sie diesen Swap abbrechen m\xf6chten?","Yes, Cancel it":"Ja, abbrechen","No, Continue":"Nein, Fortfahren","Delete Transaction":"Transaktion l\xf6schen","Are you sure you want to delete this swap?":"Sind Sie sicher, dass Sie diesen Swap l\xf6schen m\xf6chten?","Yes, Delete it":"Ja, l\xf6schen","No, Cancel":"Nein, abbrechen","Change Network":"Netzwerk \xe4ndern","Network Changed":"Netzwerk ge\xe4ndert","Select Token":"Token ausw\xe4hlen","Wallet Connected":"Wallet verbunden","Your wallet is connected, you can use it to swap.":"Ihre Brieftasche ist verbunden, Sie k\xf6nnen sie zum Tausch verwenden.","Failed to Connect":"Verbindung fehlgeschlagen","Your wallet is not connected. Please try again.":"Ihre Brieftasche ist nicht verbunden. Bitte versuchen Sie es erneut.","Connecting to your wallet":"Verbinde mit Ihrer Brieftasche","Click connect in your wallet popup.":"Klicken Sie in Ihrem Wallet-Popup auf Verbinden.","Select Derivation Path":"Ableitungspfad ausw\xe4hlen","In order to connect to {type}, you must first select a Derivation Path":["Um eine Verbindung zu ",["type"],"herzustellen, m\xfcssen Sie zuerst einen Derivationspfad ausw\xe4hlen"],"Choose Derivation Path Template":"W\xe4hlen Sie Derivationspfad Vorlage","Enter Path":"Pfad eingeben","Enter Index":"Index eingeben","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," Kette hinzuf\xfcgen"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["M\xf6chten Sie die experimentelle Kette ",["blockchainDisplayName"]," zu Ihrer Wallet hinzuf\xfcgen?"],"Please approve the experimental chain pop-up in your wallet.":"Bitte genehmigen Sie das experimentelle Kettenpopup in Ihrer Brieftasche.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Kette hinzugef\xfcgt"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Die ",["blockchainDisplayName"]," Kette wurde erfolgreich zur Brieftasche hinzugef\xfcgt."],"Request Rejected":"Anfrage abgelehnt","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Sie haben das Hinzuf\xfcgen von ",["blockchainDisplayName"]," Kette zu Ihrer Brieftasche abgelehnt."],"Select chain types":"Kettentypen ausw\xe4hlen","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Diese Brieftasche unterst\xfctzt mehrere Ketten. W\xe4hlen Sie aus, zu welcher Kette Sie sich verbinden m\xf6chten.","Failed Network, Please retry your swap.":"Netzwerk fehlgeschlagen, bitte versuche deinen Swap.","Please reset your liquidity sources.":"Bitte setzen Sie Ihre Liquidit\xe4tsquellen zur\xfcck.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Sie haben die Liquidit\xe4tsquellen begrenzt und dies k\xf6nnte dazu f\xfchren, dass Rango keine Routen findet. Bitte \xfcberlegen Sie Ihre Liquidit\xe4tsquellen zur\xfcckzusetzen.","No Routes Found.":"Keine Routen gefunden.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Gr\xfcnde warum Rango keine Route finden konnte: geringe Liquidit\xe4t beim Token, sehr geringe Eingabeaufforderung oder keine Routen f\xfcr die gew\xe4hlte Kombination aus Ein-/Ausgabe-Token.","Bridge Limit Error: Please increase your amount.":"Bridge-Limit-Fehler: Bitte erh\xf6hen Sie Ihren Betrag.","Bridge Limit Error: Please decrease your amount.":"Br\xfcckenbegrenzung Fehler: Bitte verringern Sie Ihren Betrag.","High Price Impact":"Hohe Preisbelastung","Price impact is too high!":"Preisauswirkungen sind zu hoch!","The price impact is significantly higher than the allowed amount.":"Die Preisauswirkungen sind deutlich h\xf6her als der zul\xe4ssige Betrag.","Confirm high price impact":"Best\xe4tigen Sie den hohen Preisaussto\xdf","Route updated and price impact is too high, try again later!":"Route aktualisiert und Preis Auswirkungen ist zu hoch, versuchen Sie es sp\xe4ter noch einmal!","USD Price Unknown":"USD Preis unbekannt","USD Price Unknown, Cannot calculate Price Impact.":"USD-Preis unbekannt, Preisauswirkungen k\xf6nnen nicht berechnet werden.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD-Preis unbekannt, Preisauswirkungen k\xf6nnen nicht berechnet werden. Der Preisaussto\xdf kann h\xf6her sein als \xfcblich. M\xf6chten Sie den Swap wirklich fortsetzen?","Confirm USD Price Unknown":"USD-Preis unbekannt best\xe4tigen","Swap":"Tausch","Swap anyway":"Trotzdem tauschen","The route goes through Ethereum. Continue?":"Die Route geht durch Ethereum. Weiter?","Route has been updated.":"Route wurde aktualisiert.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Ausgabebetrag wurde auf ",["newOutputAmount"]," ge\xe4ndert (",["percentageChange"],"% \xc4nderung)."],"Route swappers has been updated.":"Route Swappers wurde aktualisiert.","Route internal coins has been updated.":"Interne Routenm\xfcnzen wurden aktualisiert.","Routes":"Routen","From":"Von","To":"An","Light":"Hell","Dark":"Dunkel","Auto":"Auto","Loading failed":"Laden fehlgeschlagen","Bridges":"Br\xfccken","Exchanges":"Austausche","Custom Tokens":"Eigene Token","Language":"Sprache","Infinite approval":"Unendliche Genehmigung","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Das Aktivieren des \\"Infinite Advisval\\"-Modus gew\xe4hrt uneingeschr\xe4nkten Zugriff auf zugrunde liegende Smart-Vertr\xe4ge, was es ihnen erlaubt, den genehmigten Tokenbetrag uneingeschr\xe4nkt zu nutzen.","Theme":"Thema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"Die eingegebene Adresse ist doppelt, bitte geben Sie eine neue Adresse ein.","Token Already Exists":"Token existiert bereits","There\'s no need to add this token again because it already exists and is supported by us.":"Es ist nicht n\xf6tig, dieses Token erneut hinzuzuf\xfcgen, da es bereits existiert und von uns unterst\xfctzt wird.","Token Not Found":"Token nicht gefunden","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Leider wurde kein Token in der ",["blockchain"]," Kette mit der angegebenen Adresse gefunden. Bitte stellen Sie sicher, dass Sie die richtige Token-Adresse eingegeben haben."],"Network Error":"Netzwerkfehler","Add Custom Token":"Token hinzuf\xfcgen","Select chain":"Kette ausw\xe4hlen","Enter Address":"Adresse eingeben","Enter token address":"Token Adresse eingeben","Failed Network, Please retry.":"Fehlgeschlagenes Netzwerk, bitte erneut versuchen.","Add another custom token":"Neues benutzerdefiniertes Token hinzuf\xfcgen","Confirm Swap":"Swap best\xe4tigen","Start Swap":"Swap starten","You get":"Du bekommst","Search Token":"Such-Token","No custom tokens":"Keine benutzerdefinierten Token","press the button to add your custom token":"dr\xfccken Sie die Schaltfl\xe4che, um Ihr benutzerdefiniertes Token hinzuzuf\xfcgen","Delete Custom Token":"Benutzerdefiniertes Token l\xf6schen","Are you sure you want to Delete this Token?":"Sind Sie sicher, dass Sie dieses Token l\xf6schen m\xf6chten?","Complete":"Complete","Running":"Laufend","Failed":"Fehler","Clear":"Leeren","Search Transaction":"Transaktion durchsuchen","No transactions":"Keine Transaktionen","Your transaction history is stored locally and will appear here after you start a swap":"Ihr Transaktionsverlauf wird lokal gespeichert und erscheint hier, nachdem Sie einen Swap gestartet haben","Clear Transaction History":"Transaktionsverlauf l\xf6schen","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Fortfahren wird alle erfolgreichen und fehlgeschlagenen Transaktionen vom Widget entfernen. M\xf6chten Sie fortfahren?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Hinweis: Dies l\xf6scht nicht Ihren Transaktionsverlauf auf der Kette, sondern entfernt ihn nur hier.","Yes, Clear the history":"Ja, den Verlauf l\xf6schen","language":"sprache","Deselect all":"Alle abw\xe4hlen","Select all":"Alles ausw\xe4hlen","Search {sourceType}":["Suche ",["sourceType"]],"Search Chain":"Suchkette","Source":"Quelle","Destination":"Ziel","Swap {type}":[["type"]," tauschen"],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Derzeit sind Sie im Kampagnenmodus mit Beschr\xe4nkungen f\xfcr Liquidit\xe4tsquellen. M\xf6chten Sie aus diesem Modus ausschalten und alle verf\xfcgbaren Liquidit\xe4tsquellen nutzen?","The request ID is necessary to display the swap details.":"Die Request-ID ist notwendig, um die Swap-Details anzuzeigen.","Connect Wallets":"Wallets verbinden","Choose a wallet to connect.":"Wallet zum Verbinden ausw\xe4hlen.","This week":"Diese Woche","This month":"Diesen Monat","This year":"Dieses Jahr","Required: >= {min} {symbol}":["Erforderlich: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Erforderlich: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Erforderlich: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Erforderlich: < ",["max"]," ",["symbol"]]," for network fee":" f\xfcr Netzwerkgeb\xfchr"," for swap":" f\xfcr Tausch"," for input and network fee":" f\xfcr Eingabe und Netzwerkgeb\xfchr","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Ben\xf6tigt <unk> ",["requiredAmount"]," ",["symbol"],["reason"],", aber Sie haben ",["currentAmount"]," ",["symbol"]," in Ihrem ",["blockchain"]," Wallet."],"Waiting for connecting wallet":"Warte auf Verbindung der Brieftasche","Waiting for other running tasks to be finished":"Warte auf Beendigung anderer laufender Aufgaben","Waiting for changing wallet network":"Warte auf \xc4nderung des Wallet-Netzwerks","Sunday":"Sonntag","Monday":"Montag","Tuesday":"Dienstag","Wednesday":"Mittwoch","Thursday":"Donnerstag","Friday":"Freitag","Saturday":"Samstag","Powered By":"Powered by","Aggregated Transaction":"Gesamte Transaktion","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Tausch auf ",["fromChain"]," \xfcber ",["swapper"]],"Bridge to {toChain} via {swapper}":["Br\xfccke zu ",["toChain"]," \xfcber ",["swapper"]],"Completed":"Abgeschlossen","In progress":"In Bearbeitung","Waiting for bridge transaction":"Warte auf Bridge-Transaktion","Connected":"Verbunden","Disconnect":"Verbindung trennen","Install":"Installieren","Connecting ...":"Verbinde ...","Connecting":"Verbinden","Disconnected":"Verbindung getrennt","you need to pass a correct state to Wallet.":"Sie m\xfcssen einen korrekten Zustand an Wallet \xfcbergeben.","There are no notifications.":"Keine Benachrichtigungen vorhanden.","Clear all":"Alles l\xf6schen","Balance":"Saldo","Max":"Max."}');


/*eslint-disable*/ const $3e9330b072e528d1$export$defe85febe8b728c = JSON.parse('{"No results found":"\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1","Try using different keywords":"\u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AD\u03C2 \u03BB\u03AD\u03BE\u03B5\u03B9\u03C2-\u03BA\u03BB\u03B5\u03B9\u03B4\u03B9\u03AC","Select Chain":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2","All":"\u038C\u03BB\u03B1","More +{count}":["\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 +",["count"]],"Activate this tab":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1\u03C2","Another tab is open and handles transactions.":"\u039C\u03B9\u03B1 \u03AC\u03BB\u03BB\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AE \u03BA\u03B1\u03B9 \u03C7\u03B5\u03B9\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2.","Activate current tab":"\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1\u03C2 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1\u03C2","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0395\u03C0\u03AF \u03C4\u03BF\u03C5 \u03C0\u03B1\u03C1\u03CC\u03BD\u03C4\u03BF\u03C2, \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B5\u03BA\u03C4\u03B5\u03BB\u03BF\u03CD\u03BD\u03C4\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03B1\u03BD\u03C4\u03B9\u03BC\u03B5\u03C4\u03C9\u03C0\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03AC\u03BB\u03BB\u03B7 \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1 \u03C0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03C4\u03AE. \u0395\u03AC\u03BD \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03BA\u03B1\u03C1\u03C4\u03AD\u03BB\u03B1, \u03CC\u03BB\u03B5\u03C2 \u03BF\u03B9 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03B2\u03C1\u03AF\u03C3\u03BA\u03BF\u03BD\u03C4\u03B1\u03B9 \u03AE\u03B4\u03B7 \u03C3\u03C4\u03BF \u03B2\u03AE\u03BC\u03B1 \u03C4\u03BF\u03C5 \u03C3\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03B8\u03B1 \u03BB\u03AE\u03BE\u03BF\u03C5\u03BD.","Confirm":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7","Your {blockchainName} wallets":["\u03A4\u03B1 ",["blockchainName"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9\u03B1 \u03C3\u03B1\u03C2"],"Insufficient account balance":"\u0391\u03BD\u03B5\u03C0\u03B1\u03C1\u03BA\u03AD\u03C2 \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD","Proceed anyway":"\u03A3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03C4\u03B5 \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","You need to connect a {blockchainName} wallet.":["\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 ",["blockchainName"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9."],"Add {chain} chain":["\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 ",["chain"]," \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2"],"Show more wallets":"\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03CE\u03BD","Send to a different address":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C3\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7","Enter {blockchainName} address":["\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 ",["blockchainName"]," \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 ",["destination"]," \u03B4\u03B5\u03BD \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03B5\u03B9 \u03BC\u03B5 \u03C4\u03BF \u03BC\u03BF\u03C4\u03AF\u03B2\u03BF \u03B4\u03B9\u03B5\u03C5\u03B8\u03CD\u03BD\u03C3\u03B5\u03C9\u03BD blockchain."],"via":"\u03BC\u03AD\u03C3\u03C9","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03B4\u03B5\u03BD \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03B5\u03BD\u03B5\u03C1\u03B3\u03CE\u03BD \u03C3\u03C5\u03BC\u03B2\u03CC\u03BB\u03C9\u03BD. \u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B1\u03C5\u03C4\u03CC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5.","Import":"\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE","Status":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","Reset":"Reset","Cancel":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","Refresh":"\u0391\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7","Notifications":"\u0395\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2","Settings":"\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2","History":"\u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC","Connect Wallet":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD","Today":"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1","Swaps steps":"\u0392\u03AE\u03BC\u03B1\u03C4\u03B1 swaps","Retry":"\u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7","Slippage Error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u039F\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2","Slippage Warning":"\u03A0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u039F\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2","Bridge Limit Error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u039F\u03C1\u03AF\u03BF\u03C5 \u0393\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2","Yours: {amount} {symbol}":["\u0394\u03B9\u03BA\u03AC \u03C3\u03B1\u03C2: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u0395\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03B7 \u03B1\u03C0\u03B1\u03B9\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0394\u03B9\u03BA\u03AC \u03C3\u03B1\u03C2: ",["userSlippage"]],"See All Routes":"\u0394\u03B5\u03AF\u03C4\u03B5 \u038C\u03BB\u03B5\u03C2 \u03A4\u03B9\u03C2 \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2","View more info":"\u0394\u03B5\u03AF\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","Gas & Fee Explanation":"\u0395\u03BE\u03AE\u03B3\u03B7\u03C3\u03B7 \u0391\u03B5\u03C1\u03AF\u03BF\u03C5 & \u03A7\u03C1\u03AD\u03BF\u03C5\u03C2","Details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","Total Payable Fee":"\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03A0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03B1 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","Hide non-payable fees":"\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03BC\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03C9\u03BD \u03C4\u03B5\u03BB\u03CE\u03BD","Show non-payable fees":"\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03BC\u03B7 \u03C0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03C9\u03BD \u03C4\u03B5\u03BB\u03CE\u03BD","Description":"\u03A0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u039F\u03B9 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03B9\u03C2 \u03BB\u03B1\u03BC\u03B2\u03AC\u03BD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C5\u03C0\u03CC\u03C8\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BA\u03B1\u03B9\\n                \u03B4\u03B5\u03BD \u03B8\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03BD\u03B1 \u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B9\u03C0\u03BB\u03AD\u03BF\u03BD \u03C6\u03C5\u03C3\u03B9\u03BA\u03CC \u03B1\u03AD\u03C1\u03B9\u03BF \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03BF\u03CD\u03C2.","Swap input":"Swap input","Estimated output":"\u0395\u03BA\u03C4\u03B9\u03BC\u03CE\u03BC\u03B5\u03BD\u03B7 \u03AD\u03BE\u03BF\u03B4\u03BF\u03C2","Via:":"\u0392\u03B9\u03AD\u03BD\u03BD\u03B7:","Chains:":"\u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B5\u03C2:","Sort by":"\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7 \u03BA\u03B1\u03C4\u03AC","Smart Routing":"\u0388\u03BE\u03C5\u03C0\u03BD\u03B7 \u0394\u03C1\u03BF\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7","Lowest Fee":"\u03A7\u03B1\u03BC\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","Fastest Transfer":"\u03A4\u03B1\u03C7\u03CD\u03C4\u03B5\u03C1\u03B7 \u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","Maximum Return":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE","Maximum Output":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u0388\u03BE\u03BF\u03B4\u03BF\u03C2","Swapping":"Swapping","Gas cost":"\u039A\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03B5\u03C1\u03AF\u03BF\u03C5","Receiving":"\u039B\u03AE\u03C8\u03B7","Price impact":"\u0391\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u03A0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C5\u03BE\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD ",["minRequiredSlippage"]," \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BD\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03BD\u03B1 \u03B1\u03C5\u03BE\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD ",["minRequiredSlippage"]," \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE."],"Caution, your slippage is high.":"\u03A0\u03C1\u03BF\u03C3\u03BF\u03C7\u03AE, \u03B7 \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C8\u03B7\u03BB\u03AE.","Change":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE","Change settings":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03C9\u03BD","High slippage":"\u03A5\u03C8\u03B7\u03BB\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7","Low slippage":"\u03A7\u03B1\u03BC\u03B7\u03BB\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u03A0\u03C1\u03BF\u03C3\u03BF\u03C7\u03AE, \u03B7 \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03AE \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C8\u03B7\u03BB\u03AE (=",["userSlippage"],"). \u0397 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B1\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03C0\u03C1\u03BF\u03C3\u03C4\u03B9\u03BD\u03AE."],"Confirm anyway":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","Something went wrong":"\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03C3\u03C4\u03C1\u03B1\u03B2\u03AC","Something went wrong. Please refresh the app.":"\u039A\u03AC\u03C4\u03B9 \u03C0\u03AE\u03B3\u03B5 \u03C3\u03C4\u03C1\u03B1\u03B2\u03AC. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B1\u03BD\u03B5\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE.","Slippage tolerance per swap":"\u0391\u03BD\u03BF\u03C7\u03AE \u03BF\u03BB\u03AF\u03C3\u03B8\u03B7\u03C3\u03B7\u03C2 \u03B1\u03BD\u03AC \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","Custom":"\u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0397 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B1\u03C2 \u03B8\u03B1 \u03B5\u03C0\u03B1\u03BD\u03AD\u03BB\u03B8\u03B5\u03B9 \u03B1\u03BD \u03B7 \u03C4\u03B9\u03BC\u03AE \u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03B9 \u03B4\u03C5\u03C3\u03BC\u03B5\u03BD\u03CE\u03C2 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03BF\u03C3\u03BF\u03C3\u03C4\u03CC.","Warning":"\u03A0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u0391\u03C5\u03C4\u03AE \u03B7 \u03C1\u03CD\u03B8\u03BC\u03B9\u03C3\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03CC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03B5 \u03BA\u03AC\u03B8\u03B5 \u03B2\u03AE\u03BC\u03B1 (\u03C0.\u03C7. 1Inch, Thorchain, \u03BA\u03BB\u03C0.), \u03C0\u03BF\u03C5 \u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03BC\u03CC\u03BD\u03BF \u03C4\u03BF \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03BF \u03B2\u03AE\u03BC\u03B1 \u03B8\u03B1 \u03B5\u03C0\u03B1\u03BD\u03AD\u03BB\u03B8\u03B5\u03B9, \u03CC\u03C7\u03B9 \u03BF\u03BB\u03CC\u03BA\u03BB\u03B7\u03C1\u03B7 \u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE.","Swap Details":"\u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Request ID":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u0391\u03AF\u03C4\u03B7\u03C3\u03B7\u03C2","Not found":"\u0394\u03B5 \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","Swap with request ID = {requestId} not found.":["\u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03BC\u03B5 \u03C4\u03BF \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 = ",["requestId"]," \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0388\u03C7\u03B5\u03C4\u03B5 \u03BB\u03AC\u03B2\u03B5\u03B9 ",["amount"]," ",["token"]," \u03C3\u03C4\u03BF ",["conciseAddress"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03C4\u03BF ",["chain"]," chain."],"Transaction was not sent.":"\u0397 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B5\u03BD \u03C3\u03C4\u03AC\u03BB\u03B8\u03B7\u03BA\u03B5.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u03C3\u03C4\u03BF ",["blockchain"]," \u03C0\u03B1\u03C1\u03B1\u03BC\u03AD\u03BD\u03B5\u03B9 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2."],"Delete":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","Try again":"\u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC","Copied To Clipboard":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5 \u03A3\u03C4\u03BF \u03A0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF","Copy Request ID":"\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03BF\u03CD \u0391\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","View on Rango Explorer":"\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C4\u03BF\u03BD \u0395\u03BE\u03B5\u03C1\u03B5\u03C5\u03BD\u03B7\u03C4\u03AE \u03C4\u03BF\u03C5 Rango","Finished at":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03B9\u03C2","Created at":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C4\u03B9\u03C2","View transaction":"\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Connect":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Swap Successful":"Swap \u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2","Transaction Failed":"\u0397 \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u0391\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5","Done":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","Diagnosis":"\u0394\u03B9\u03AC\u03B3\u03BD\u03C9\u03C3\u03B7","See Details":"\u0394\u03B5\u03AF\u03C4\u03B5 \u039B\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","Cancel Swap":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Are you sure you want to cancel this swap?":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BA\u03C5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF swap?","Yes, Cancel it":"\u039D\u03B1\u03B9, \u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","No, Continue":"\u038C\u03C7\u03B9, \u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","Delete Transaction":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Are you sure you want to delete this swap?":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF swap?","Yes, Delete it":"\u039D\u03B1\u03B9, \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03BF\u03CD\u03BD","No, Cancel":"\u038C\u03C7\u03B9, \u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","Change Network":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u0394\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Network Changed":"\u03A4\u03BF \u0394\u03AF\u03BA\u03C4\u03C5\u03BF \u0386\u03BB\u03BB\u03B1\u03BE\u03B5","Select Token":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD","Wallet Connected":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9","Your wallet is connected, you can use it to swap.":"\u03A4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE.","Failed to Connect":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2","Your wallet is not connected. Please try again.":"\u03A4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","Connecting to your wallet":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2","Click connect in your wallet popup.":"\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF \u03B1\u03BD\u03B1\u03B4\u03C5\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03B1\u03C1\u03AC\u03B8\u03C5\u03C1\u03BF \u03C4\u03BF\u03C5 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD.","Select Derivation Path":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03A0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2","In order to connect to {type}, you must first select a Derivation Path":["\u0393\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF ",["type"],", \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03C0\u03C1\u03CE\u03C4\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03A0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2"],"Choose Derivation Path Template":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03A0\u03C1\u03CC\u03C4\u03C5\u03C0\u03BF \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2 \u03A0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2","Enter Path":"\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2","Enter Index":"\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u0395\u03C5\u03C1\u03B5\u03C4\u03B7\u03C1\u03AF\u03BF\u03C5","Add {blockchainDisplayName} Chain":["\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 ",["blockchainDisplayName"]," \u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF ",["blockchainDisplayName"]," \u03C0\u03B5\u03B9\u03C1\u03B1\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2?"],"Please approve the experimental chain pop-up in your wallet.":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03BD\u03B1 \u03B5\u03B3\u03BA\u03C1\u03AF\u03BD\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B1\u03BD\u03B1\u03B4\u03C5\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03B1\u03C1\u03AC\u03B8\u03C5\u03C1\u03BF \u03C4\u03B7\u03C2 \u03C0\u03B5\u03B9\u03C1\u03B1\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE\u03C2 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2.","{blockchainDisplayName} Chain Added":["\u03A0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 ",["blockchainDisplayName"]," \u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u0397 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1 ",["blockchainDisplayName"]," \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2."],"Request Rejected":"\u0391\u03AF\u03C4\u03B7\u03C3\u03B7 \u0391\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0391\u03C0\u03BF\u03C1\u03C1\u03AF\u03C8\u03B1\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2 ",["blockchainDisplayName"]," \u03C3\u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2."],"Select chain types":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03CD\u03C0\u03BF\u03C5\u03C2 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03B9 \u03C0\u03BF\u03BB\u03BB\u03B1\u03C0\u03BB\u03AD\u03C2 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B5\u03C2. \u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C3\u03B5 \u03C0\u03BF\u03B9\u03B1 \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1 \u03B8\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5.","Failed Network, Please retry your swap.":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5, \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C4\u03BF swap.","Please reset your liquidity sources.":"\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0388\u03C7\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03C5\u03C4\u03CC \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03BF\u03B4\u03B7\u03B3\u03AE\u03C3\u03B5\u03B9 \u03C3\u03B5 Rango \u03B5\u03CD\u03C1\u03B5\u03C3\u03B7 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C3\u03BA\u03B5\u03C6\u03C4\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2.","No Routes Found.":"\u0394\u03B5\u03BD \u0392\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u039B\u03CC\u03B3\u03BF\u03B9 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03BF\u03C0\u03BF\u03AF\u03BF\u03C5\u03C2 \u03C4\u03BF Rango \u03B4\u03B5\u03BD \u03BC\u03C0\u03CC\u03C1\u03B5\u03C3\u03B5 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03B9 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE: \u03C7\u03B1\u03BC\u03B7\u03BB\u03AE \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C3\u03C4\u03BF token, \u03C0\u03BF\u03BB\u03CD \u03C7\u03B1\u03BC\u03B7\u03BB\u03CC \u03C0\u03BF\u03C3\u03CC \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2 \u03AE \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C5\u03BD\u03B4\u03C5\u03B1\u03C3\u03BC\u03CC \u03B5\u03B9\u03C3\u03CC\u03B4\u03BF\u03C5/\u03B5\u03BE\u03CC\u03B4\u03BF\u03C5 token.","Bridge Limit Error: Please increase your amount.":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BF\u03C1\u03AF\u03BF\u03C5 \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2: \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03C5\u03BE\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C3\u03CC \u03C3\u03B1\u03C2.","Bridge Limit Error: Please decrease your amount.":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BF\u03C1\u03AF\u03BF\u03C5 \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2: \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03BC\u03B5\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BF\u03C3\u03CC \u03C3\u03B1\u03C2.","High Price Impact":"\u0395\u03C0\u03B9\u03C0\u03C4\u03CE\u03C3\u03B5\u03B9\u03C2 \u03A5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03A4\u03B9\u03BC\u03AE\u03C2","Price impact is too high!":"\u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B9\u03BC\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C5\u03C8\u03B7\u03BB\u03CC\u03C2!","The price impact is significantly higher than the allowed amount.":"\u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B9\u03BC\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03B7\u03BC\u03B1\u03BD\u03C4\u03B9\u03BA\u03AC \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF \u03B5\u03C0\u03B9\u03C4\u03C1\u03B5\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC.","Confirm high price impact":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03C3\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03B4\u03C1\u03B1\u03C3\u03B7 \u03C5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","Route updated and price impact is too high, try again later!":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03BA\u03B1\u03B9 \u03BF \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03C5\u03C8\u03B7\u03BB\u03CC\u03C2, \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1!","USD Price Unknown":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03B7","USD Price Unknown, Cannot calculate Price Impact.":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF, \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u03A4\u03B9\u03BC\u03AE USD \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF, \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03C0\u03AF\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2. \u039F \u03B1\u03BD\u03C4\u03AF\u03BA\u03C4\u03C5\u03C0\u03BF\u03C2 \u03C4\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7 \u03B1\u03C0\u03CC \u03C4\u03BF \u03C3\u03C5\u03BD\u03B7\u03B8\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF. \u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD Swap?","Confirm USD Price Unknown":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03A4\u03B9\u03BC\u03AE\u03C2 Usd \u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF","Swap":"\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","Swap anyway":"\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03BF\u03CD\u03C4\u03C9\u03C2 \u03AE \u03AC\u03BB\u03BB\u03C9\u03C2","The route goes through Ethereum. Continue?":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03C0\u03B5\u03C1\u03BD\u03AC\u03B5\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF Ethereum. \u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1?","Route has been updated.":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE \u03AD\u03C7\u03B5\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u03A4\u03BF \u03C0\u03BF\u03C3\u03CC \u03B5\u03BE\u03CC\u03B4\u03BF\u03C5 \u03AC\u03BB\u03BB\u03B1\u03BE\u03B5 \u03C3\u03B5 ",["newOutputAmount"]," (",["percentageChange"],"% \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE)."],"Route swappers has been updated.":"\u03A4\u03B1 swappers \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03CE\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Route internal coins has been updated.":"\u03A4\u03B1 \u03B5\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03AC \u03BD\u03BF\u03BC\u03AF\u03C3\u03BC\u03B1\u03C4\u03B1 \u03B4\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2 \u03AD\u03C7\u03BF\u03C5\u03BD \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03B8\u03B5\u03AF.","Routes":"\u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AD\u03C2","From":"\u0391\u03C0\u03CC","To":"\u03A0\u03C1\u03BF\u03C2","Light":"\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC","Dark":"\u03A3\u03BA\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC","Auto":"\u0391\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF","Loading failed":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2","Bridges":"\u0393\u03AD\u03C6\u03C5\u03C1\u03B5\u03C2","Exchanges":"\u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2","Custom Tokens":"\u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03B1 Tokens","Language":"\u0393\u03BB\u03CE\u03C3\u03C3\u03B1","Infinite approval":"\u0386\u03C0\u03B5\u03B9\u03C1\u03B7 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u0397 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 \'\u0386\u03C0\u03B5\u03B9\u03C1\u03B7 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\' \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03B9 \u03B1\u03C0\u03B5\u03C1\u03B9\u03CC\u03C1\u03B9\u03C3\u03C4\u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C5\u03C0\u03BF\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B5\u03C2 \u03AD\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03C3\u03C5\u03BC\u03B2\u03AC\u03C3\u03B5\u03B9\u03C2, \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03BF\u03BD\u03C4\u03AC\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BD \u03C4\u03BF \u03B5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03BF \u03C0\u03BF\u03C3\u03CC \u03C3\u03C5\u03BC\u03B2\u03BF\u03BB\u03B1\u03AF\u03C9\u03BD \u03C7\u03C9\u03C1\u03AF\u03C2 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2.","Theme":"\u0398\u03AD\u03BC\u03B1","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03BF\u03C5 \u03B5\u03B9\u03C3\u03AC\u03B3\u03B1\u03C4\u03B5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03C0\u03BB\u03CC\u03C4\u03C5\u03C0\u03B7, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03BD\u03AD\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7.","Token Already Exists":"\u03A4\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03A5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u0389\u03B4\u03B7","There\'s no need to add this token again because it already exists and is supported by us.":"\u0394\u03B5\u03BD \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03BE\u03B1\u03BD\u03AC \u03B5\u03C0\u03B5\u03B9\u03B4\u03AE \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03BA\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03B5\u03BC\u03AC\u03C2.","Token Not Found":"\u03A4\u03BF \u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u0394\u03B5\u03BD \u0392\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u039B\u03C5\u03C0\u03BF\u03CD\u03BC\u03B1\u03C3\u03C4\u03B5, \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03C3\u03C4\u03B7\u03BD \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1 ",["blockchain"]," \u03BC\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B5\u03C7\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B5\u03B9\u03C3\u03AD\u03BB\u03B8\u03B5\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C9\u03C3\u03C4\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD."],"Network Error":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u0394\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Add Custom Token":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF\u03C5 \u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD","Select chain":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1\u03C2","Enter Address":"\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2","Enter token address":"\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD","Failed Network, Please retry.":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03B7\u03BC\u03AD\u03BD\u03BF \u0394\u03AF\u03BA\u03C4\u03C5\u03BF, \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","Add another custom token":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03AC\u03BB\u03BB\u03BF \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC","Confirm Swap":"\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Start Swap":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 \u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","You get":"\u03A0\u03B1\u03AF\u03C1\u03BD\u03B5\u03C4\u03B5","Search Token":"\u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2","No custom tokens":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03B1 \u03C3\u03B7\u03BC\u03B5\u03AF\u03B1","press the button to add your custom token":"\u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF \u03B4\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03CC \u03C3\u03B1\u03C2","Delete Custom Token":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03A0\u03C1\u03BF\u03C3\u03B1\u03C1\u03BC\u03BF\u03C3\u03BC\u03AD\u03BD\u03BF\u03C5 \u0394\u03B9\u03B1\u03BA\u03C1\u03B9\u03C4\u03B9\u03BA\u03BF\u03CD","Are you sure you want to Delete this Token?":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF Token?","Complete":"Complete","Running":"\u0395\u03BA\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9","Failed":"\u0391\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5","Clear":"\u0395\u03BA\u03BA\u03B1\u03B8\u03AC\u03C1\u03B9\u03C3\u03B7","Search Transaction":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","No transactions":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2","Your transaction history is stored locally and will appear here after you start a swap":"\u03A4\u03BF \u03B9\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2 \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03B5\u03C4\u03B1\u03B9 \u03C4\u03BF\u03C0\u03B9\u03BA\u03AC \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03C3\u03C4\u03B5\u03AF \u03B5\u03B4\u03CE \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","Clear Transaction History":"\u0395\u03BA\u03BA\u03B1\u03B8\u03AC\u03C1\u03B9\u03C3\u03B7 \u0399\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03BF\u03CD \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0397 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1 \u03B8\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03B9 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03B1\u03C0\u03BF\u03C4\u03C5\u03C7\u03B7\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF widget. \u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u03A3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7: \u0391\u03C5\u03C4\u03CC \u03B4\u03B5\u03BD \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B5\u03B9 \u03C4\u03BF \u03B9\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03CC \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1, \u03B1\u03BB\u03BB\u03AC \u03C4\u03B9\u03C2 \u03B1\u03C6\u03B1\u03B9\u03C1\u03B5\u03AF \u03BC\u03CC\u03BD\u03BF \u03B5\u03B4\u03CE.","Yes, Clear the history":"\u039D\u03B1\u03B9, \u039A\u03B1\u03B8\u03B1\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03B9\u03C3\u03C4\u03BF\u03C1\u03B9\u03BA\u03BF\u03CD","language":"\u03B3\u03BB\u03CE\u03C3\u03C3\u03B1","Deselect all":"\u0391\u03C0\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD","Select all":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD","Search {sourceType}":["\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 ",["sourceType"]],"Search Chain":"\u0391\u03BB\u03C5\u03C3\u03AF\u03B4\u03B1 \u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2","Source":"\u03A0\u03B7\u03B3\u03AE","Destination":"\u03A0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2","Swap {type}":["\u0391\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0395\u03C0\u03AF \u03C4\u03BF\u03C5 \u03C0\u03B1\u03C1\u03CC\u03BD\u03C4\u03BF\u03C2, \u03B5\u03AF\u03C3\u03C4\u03B5 \u03C3\u03B5 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03B1\u03BC\u03C0\u03AC\u03BD\u03B9\u03B1\u03C2 \u03BC\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2 \u03C3\u03C4\u03B9\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2. \u0398\u03B1 \u03B8\u03AD\u03BB\u03B1\u03C4\u03B5 \u03BD\u03B1 \u03B2\u03B3\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03C0\u03B7\u03B3\u03AD\u03C2 \u03C1\u03B5\u03C5\u03C3\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2?","The request ID is necessary to display the swap details.":"\u03A4\u03BF \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03B5\u03C1\u03B5\u03B9\u03CE\u03BD \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2.","Connect Wallets":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03CE\u03BD","Choose a wallet to connect.":"\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03B3\u03B9\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7.","This week":"\u0391\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1","This month":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03BC\u03AE\u03BD\u03B1","This year":"\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03AD\u03C4\u03BF\u03C2","Required: >= {min} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9: < ",["max"]," ",["symbol"]]," for network fee":" \u03B3\u03B9\u03B1 \u03C4\u03AD\u03BB\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5"," for swap":" \u03B3\u03B9\u03B1 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE"," for input and network fee":" \u03B3\u03B9\u03B1 \u03B5\u03B9\u03C3\u03C1\u03BF\u03AE \u03BA\u03B1\u03B9 \u03C4\u03AD\u03BB\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u03A7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", \u03B1\u03BB\u03BB\u03AC \u03AD\u03C7\u03B5\u03C4\u03B5 ",["currentAmount"]," ",["symbol"]," \u03C3\u03C4\u03BF ",["blockchain"]," \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9 \u03C3\u03B1\u03C2."],"Waiting for connecting wallet":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9","Waiting for other running tasks to be finished":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03B8\u03BF\u03CD\u03BD \u03AC\u03BB\u03BB\u03B5\u03C2 \u03B5\u03BA\u03C4\u03B5\u03BB\u03BF\u03CD\u03BC\u03B5\u03BD\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2","Waiting for changing wallet network":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03C0\u03BF\u03C1\u03C4\u03BF\u03C6\u03BF\u03BB\u03B9\u03BF\u03CD","Sunday":"\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE","Monday":"\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1","Tuesday":"\u03A4\u03C1\u03AF\u03C4\u03B7","Wednesday":"\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7","Thursday":"\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7","Friday":"\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE","Saturday":"\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF","Powered By":"\u03A4\u03C1\u03BF\u03C6\u03BF\u03B4\u03BF\u03C4\u03B5\u03AF\u03C4\u03B1\u03B9 \u0391\u03C0\u03CC","Aggregated Transaction":"\u03A3\u03C5\u03B3\u03BA\u03B5\u03BD\u03C4\u03C1\u03C9\u03C4\u03B9\u03BA\u03AE \u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03C4\u03BF ",["fromChain"]," \u03BC\u03AD\u03C3\u03C9 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u0393\u03AD\u03C6\u03C5\u03C1\u03B1 \u03C3\u03C4\u03BF ",["toChain"]," \u03BC\u03AD\u03C3\u03C9 ",["swapper"]],"Completed":"\u039F\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5","In progress":"\u03A3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7","Waiting for bridge transaction":"\u0391\u03BD\u03B1\u03BC\u03BF\u03BD\u03AE \u03B3\u03B9\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03B3\u03AD\u03C6\u03C5\u03C1\u03B1\u03C2","Connected":"\u03A3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF","Disconnect":"\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Install":"\u0395\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","Connecting ...":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7...","Connecting":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","Disconnected":"\u0391\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03AD\u03B8\u03B7\u03BA\u03B5","you need to pass a correct state to Wallet.":"\u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C9\u03C3\u03C4\u03AE \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \u03A0\u03BF\u03C1\u03C4\u03BF\u03C6\u03CC\u03BB\u03B9.","There are no notifications.":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9\u03C2.","Clear all":"\u0395\u03BA\u03BA\u03B1\u03B8\u03AC\u03C1\u03B9\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD","Balance":"\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF","Max":"\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF"}');


/*eslint-disable*/ const $b41d5a2e355d559e$export$defe85febe8b728c = JSON.parse('{"No results found":"No results found","Try using different keywords":"Try using different keywords","Select Chain":"Select Chain","All":"All","More +{count}":["More +",["count"]],"Activate this tab":"Activate this tab","Another tab is open and handles transactions.":"Another tab is open and handles transactions.","Activate current tab":"Activate current tab","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.","Confirm":"Confirm","Your {blockchainName} wallets":["Your ",["blockchainName"]," wallets"],"Insufficient account balance":"Insufficient account balance","Proceed anyway":"Proceed anyway","You need to connect a {blockchainName} wallet.":["You need to connect a ",["blockchainName"]," wallet."],"Add {chain} chain":["Add ",["chain"]," chain"],"Show more wallets":"Show more wallets","Send to a different address":"Send to a different address","Enter {blockchainName} address":["Enter ",["blockchainName"]," address"],"Address {destination} doesn\'t match the blockchain address pattern.":["Address ",["destination"]," doesn\'t match the blockchain address pattern."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.","Import":"Import","Status":"Status","Reset":"Reset","Cancel":"Cancel","Refresh":"Refresh","Notifications":"Notifications","Settings":"Settings","History":"History","Connect Wallet":"Connect Wallet","Today":"Today","Swaps steps":"Swaps steps","Retry":"Retry","Slippage Error":"Slippage Error","Slippage Warning":"Slippage Warning","Bridge Limit Error":"Bridge Limit Error","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum required slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Yours: ",["userSlippage"]],"See All Routes":"See All Routes","View more info":"View more info","Gas & Fee Explanation":"Gas & Fee Explanation","Details":"Details","Total Payable Fee":"Total Payable Fee","Hide non-payable fees":"Hide non-payable fees","Show non-payable fees":"Show non-payable fees","Description":"Description","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.","Swap input":"Swap input","Estimated output":"Estimated output","Via:":"Via:","Chains:":"Chains:","Sort by":"Sort by","Smart Routing":"Smart Routing","Lowest Fee":"Lowest Fee","Fastest Transfer":"Fastest Transfer","Maximum Return":"Maximum Return","Maximum Output":"Maximum Output","Swapping":"Swapping","Gas cost":"Gas cost","Receiving":"Receiving","Price impact":"Price impact","You need to increase slippage to at least {minRequiredSlippage} for this route.":["You need to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["We recommend you to increase slippage to at least ",["minRequiredSlippage"]," for this route."],"Caution, your slippage is high.":"Caution, your slippage is high.","Change":"Change","Change settings":"Change settings","High slippage":"High slippage","Low slippage":"Low slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Caution, your slippage is high (=",["userSlippage"],"). Your trade may be front run."],"Confirm anyway":"Confirm anyway","Something went wrong":"Something went wrong","Something went wrong. Please refresh the app.":"Something went wrong. Please refresh the app.","Slippage tolerance per swap":"Slippage tolerance per swap","Custom":"Custom","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Your transaction will be reverted if the price changes unfavorably by more than this percentage.","Warning":"Warning","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.","Swap Details":"Swap Details","Request ID":"Request ID","Not found":"Not found","Swap with request ID = {requestId} not found.":["Swap with request ID = ",["requestId"]," not found."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["You have received ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet on ",["chain"]," chain."],"Transaction was not sent.":"Transaction was not sent.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," on ",["blockchain"]," remains in your wallet."],"Delete":"Delete","Try again":"Try again","Copied To Clipboard":"Copied To Clipboard","Copy Request ID":"Copy Request ID","View on Rango Explorer":"View on Rango Explorer","Finished at":"Finished at","Created at":"Created at","View transaction":"View transaction","Connect":"Connect","Swap Successful":"Swap Successful","Transaction Failed":"Transaction Failed","Done":"Done","Diagnosis":"Diagnosis","See Details":"See Details","Cancel Swap":"Cancel Swap","Are you sure you want to cancel this swap?":"Are you sure you want to cancel this swap?","Yes, Cancel it":"Yes, Cancel it","No, Continue":"No, Continue","Delete Transaction":"Delete Transaction","Are you sure you want to delete this swap?":"Are you sure you want to delete this swap?","Yes, Delete it":"Yes, Delete it","No, Cancel":"No, Cancel","Change Network":"Change Network","Network Changed":"Network Changed","Select Token":"Select Token","Wallet Connected":"Wallet Connected","Your wallet is connected, you can use it to swap.":"Your wallet is connected, you can use it to swap.","Failed to Connect":"Failed to Connect","Your wallet is not connected. Please try again.":"Your wallet is not connected. Please try again.","Connecting to your wallet":"Connecting to your wallet","Click connect in your wallet popup.":"Click connect in your wallet popup.","Select Derivation Path":"Select Derivation Path","In order to connect to {type}, you must first select a Derivation Path":["In order to connect to ",["type"],", you must first select a Derivation Path"],"Choose Derivation Path Template":"Choose Derivation Path Template","Enter Path":"Enter Path","Enter Index":"Enter Index","Add {blockchainDisplayName} Chain":["Add ",["blockchainDisplayName"]," Chain"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Would you like to add the ",["blockchainDisplayName"]," experimental chain to your wallet?"],"Please approve the experimental chain pop-up in your wallet.":"Please approve the experimental chain pop-up in your wallet.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Chain Added"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["The ",["blockchainDisplayName"]," chain has been successfully added to your wallet."],"Request Rejected":"Request Rejected","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["You\'ve rejected adding ",["blockchainDisplayName"]," chain to your wallet."],"Select chain types":"Select chain types","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"This wallet supports multiple chains. Select which chain you\'d like to connect to.","Failed Network, Please retry your swap.":"Failed Network, Please retry your swap.","Please reset your liquidity sources.":"Please reset your liquidity sources.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.","No Routes Found.":"No Routes Found.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.","Bridge Limit Error: Please increase your amount.":"Bridge Limit Error: Please increase your amount.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit Error: Please decrease your amount.","High Price Impact":"High Price Impact","Price impact is too high!":"Price impact is too high!","The price impact is significantly higher than the allowed amount.":"The price impact is significantly higher than the allowed amount.","Confirm high price impact":"Confirm high price impact","Route updated and price impact is too high, try again later!":"Route updated and price impact is too high, try again later!","USD Price Unknown":"USD Price Unknown","USD Price Unknown, Cannot calculate Price Impact.":"USD Price Unknown, Cannot calculate Price Impact.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?","Confirm USD Price Unknown":"Confirm USD Price Unknown","Swap":"Swap","Swap anyway":"Swap anyway","The route goes through Ethereum. Continue?":"The route goes through Ethereum. Continue?","Route has been updated.":"Route has been updated.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Output amount changed to ",["newOutputAmount"]," (",["percentageChange"],"% change)."],"Route swappers has been updated.":"Route swappers has been updated.","Route internal coins has been updated.":"Route internal coins has been updated.","Routes":"Routes","From":"From","To":"To","Light":"Light","Dark":"Dark","Auto":"Auto","Loading failed":"Loading failed","Bridges":"Bridges","Exchanges":"Exchanges","Custom Tokens":"Custom Tokens","Language":"Language","Infinite approval":"Infinite approval","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.","Theme":"Theme","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"The address you entered is duplicate, please enter a new address.","Token Already Exists":"Token Already Exists","There\'s no need to add this token again because it already exists and is supported by us.":"There\'s no need to add this token again because it already exists and is supported by us.","Token Not Found":"Token Not Found","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Sorry, no token was found on ",["blockchain"]," chain with the provided address. please make sure you have entered the right token address."],"Network Error":"Network Error","Add Custom Token":"Add Custom Token","Select chain":"Select chain","Enter Address":"Enter Address","Enter token address":"Enter token address","Failed Network, Please retry.":"Failed Network, Please retry.","Add another custom token":"Add another custom token","Confirm Swap":"Confirm Swap","Start Swap":"Start Swap","You get":"You get","Search Token":"Search Token","No custom tokens":"No custom tokens","press the button to add your custom token":"press the button to add your custom token","Delete Custom Token":"Delete Custom Token","Are you sure you want to Delete this Token?":"Are you sure you want to Delete this Token?","Complete":"Complete","Running":"Running","Failed":"Failed","Clear":"Clear","Search Transaction":"Search Transaction","No transactions":"No transactions","Your transaction history is stored locally and will appear here after you start a swap":"Your transaction history is stored locally and will appear here after you start a swap","Clear Transaction History":"Clear Transaction History","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Note: This does not erase your transaction history on the chain; it only removes them here.","Yes, Clear the history":"Yes, Clear the history","language":"language","Deselect all":"Deselect all","Select all":"Select all","Search {sourceType}":["Search ",["sourceType"]],"Search Chain":"Search Chain","Source":"Source","Destination":"Destination","Swap {type}":["Swap ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?","The request ID is necessary to display the swap details.":"The request ID is necessary to display the swap details.","Connect Wallets":"Connect Wallets","Choose a wallet to connect.":"Choose a wallet to connect.","This week":"This week","This month":"This month","This year":"This year","Required: >= {min} {symbol}":["Required: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Required: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Required: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Required: < ",["max"]," ",["symbol"]]," for network fee":" for network fee"," for swap":" for swap"," for input and network fee":" for input and network fee","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Needs \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", but you have ",["currentAmount"]," ",["symbol"]," in your ",["blockchain"]," wallet."],"Waiting for connecting wallet":"Waiting for connecting wallet","Waiting for other running tasks to be finished":"Waiting for other running tasks to be finished","Waiting for changing wallet network":"Waiting for changing wallet network","Sunday":"Sunday","Monday":"Monday","Tuesday":"Tuesday","Wednesday":"Wednesday","Thursday":"Thursday","Friday":"Friday","Saturday":"Saturday","Powered By":"Powered By","Aggregated Transaction":"Aggregated Transaction","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Swap on ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Completed":"Completed","In progress":"In progress","Waiting for bridge transaction":"Waiting for bridge transaction","Connected":"Connected","Disconnect":"Disconnect","Install":"Install","Connecting ...":"Connecting ...","Connecting":"Connecting","Disconnected":"Disconnected","you need to pass a correct state to Wallet.":"you need to pass a correct state to Wallet.","There are no notifications.":"There are no notifications.","Clear all":"Clear all","Balance":"Balance","Max":"Max"}');


/*eslint-disable*/ const $120ac1159ebd9e5b$export$defe85febe8b728c = JSON.parse('{"No results found":"No hay resultados","Try using different keywords":"Intenta usar diferentes palabras clave","Select Chain":"Seleccionar cadena","All":"Todos","More +{count}":["M\xe1s +",["count"]],"Activate this tab":"Activar esta pesta\xf1a","Another tab is open and handles transactions.":"Otra pesta\xf1a es abierta y maneja transacciones.","Activate current tab":"Activar pesta\xf1a actual","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Actualmente, algunas transacciones se est\xe1n ejecutando y siendo manejadas por otra pesta\xf1a del navegador. Si activa esta pesta\xf1a, todas las transacciones que ya est\xe1n en el paso del signo de transacci\xf3n caducar\xe1n.","Confirm":"Confirmar","Your {blockchainName} wallets":["Tus billeteras ",["blockchainName"]],"Insufficient account balance":"Saldo insuficiente de la cuenta","Proceed anyway":"Proceda de todos modos","You need to connect a {blockchainName} wallet.":["Necesitas conectar un monedero ",["blockchainName"],"."],"Add {chain} chain":["A\xf1adir cadena ",["chain"]],"Show more wallets":"Mostrar m\xe1s carteras","Send to a different address":"Enviar a una direcci\xf3n diferente","Enter {blockchainName} address":["Introduzca la direcci\xf3n ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["La direcci\xf3n ",["destination"]," no coincide con el patr\xf3n de direcci\xf3n de la cadena de bloques."],"via":"v\xeda","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Este token no aparece en la lista de tokens activa. Aseg\xfarese de que es el token que desea intercambiar.","Import":"Importar","Status":"Estado","Reset":"Reset","Cancel":"Cancelar","Refresh":"Refrescar","Notifications":"Notificaciones","Settings":"Ajustes","History":"Historial","Connect Wallet":"Conectar cartera","Today":"Hoy","Swaps steps":"Intercambiar pasos","Retry":"Reintentar","Slippage Error":"Error de deslizamiento","Slippage Warning":"Advertencia de deslizamiento","Bridge Limit Error":"Error de l\xedmite del puente","Yours: {amount} {symbol}":["Tu: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["M\xednimo deslizamiento requerido: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Tu: ",["userSlippage"]],"See All Routes":"Ver todas las rutas","View more info":"Ver m\xe1s informaci\xf3n","Gas & Fee Explanation":"Explicaci\xf3n de gas y comisi\xf3n","Details":"Detalles","Total Payable Fee":"Tarifa total a pagar","Hide non-payable fees":"Ocultar tarifas no pagables","Show non-payable fees":"Mostrar tarifas no pagables","Description":"Descripci\xf3n","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Las siguientes comisiones se consideran en la salida de la transacci\xf3n y\\n                no necesitar\xe1s pagar gas adicional por ellas.","Swap input":"Swap input","Estimated output":"Salida estimada","Via:":"V\xeda:","Chains:":"Cadenas:","Sort by":"Ordenar por","Smart Routing":"Ruta inteligente","Lowest Fee":"Tarifa m\xe1s baja","Fastest Transfer":"Transferencia m\xe1s r\xe1pida","Maximum Return":"Devoluci\xf3n m\xe1xima","Maximum Output":"Salida m\xe1xima","Swapping":"Swapping","Gas cost":"Coste de gas","Receiving":"Recibiendo","Price impact":"Impacto del precio","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Necesitas aumentar el deslizamiento a al menos ",["minRequiredSlippage"]," para esta ruta."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Te recomendamos que aumentes el deslizamiento a al menos ",["minRequiredSlippage"]," para esta ruta."],"Caution, your slippage is high.":"Precauci\xf3n, tu deslizamiento es alto.","Change":"Cambiar","Change settings":"Cambiar configuraci\xf3n","High slippage":"Deslizar alto","Low slippage":"Deslizamiento bajo"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Precauci\xf3n, su deslizamiento es alto (=",["userSlippage"],"). Su operaci\xf3n puede ser inicial."],"Confirm anyway":"Confirmar de todos modos","Something went wrong":"Algo sali\xf3 mal","Something went wrong. Please refresh the app.":"Algo sali\xf3 mal. Por favor, actualiza la aplicaci\xf3n.","Slippage tolerance per swap":"Tolerancia de deslizamiento por intercambio","Custom":"Personalizado","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Su transacci\xf3n ser\xe1 revertida si el precio cambia desfavorablemente m\xe1s de este porcentaje.","Warning":"Advertencia","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Este ajuste se aplica a cada paso (por ejemplo, 1Inch, Thorchain, etc.), lo que significa que s\xf3lo se revertir\xe1 un paso espec\xedfico, no toda la ruta.","Swap Details":"Detalles de intercambio","Request ID":"ID de Solicitud","Not found":"No encontrado","Swap with request ID = {requestId} not found.":["Intercambio con ID de solicitud = ",["requestId"]," no encontrado."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Ha recibido ",["amount"]," ",["token"]," en el monedero ",["conciseAddress"]," de la cadena ",["chain"],"."],"Transaction was not sent.":"La transacci\xf3n no fue enviada.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," en ",["blockchain"]," permanece en tu cartera."],"Delete":"Eliminar","Try again":"Int\xe9ntalo de nuevo","Copied To Clipboard":"Copiado al portapapeles","Copy Request ID":"Copiar ID de Solicitud","View on Rango Explorer":"Ver en Rango Explorer","Finished at":"Terminado el","Created at":"Creado el","View transaction":"Ver transacci\xf3n","Connect":"Conectar","Swap Successful":"Intercambio exitoso","Transaction Failed":"Transacci\xf3n fallida","Done":"Hecho","Diagnosis":"Diagn\xf3stico","See Details":"Ver detalles","Cancel Swap":"Cancelar intercambio","Are you sure you want to cancel this swap?":"\xbfEst\xe1 seguro de que desea cancelar este intercambio?","Yes, Cancel it":"S\xed, cancelarlo","No, Continue":"No, continuar","Delete Transaction":"Eliminar transacci\xf3n","Are you sure you want to delete this swap?":"\xbfEst\xe1 seguro de que desea eliminar este intercambio?","Yes, Delete it":"S\xed, eliminarlo","No, Cancel":"No, cancelar","Change Network":"Cambiar red","Network Changed":"Red cambiada","Select Token":"Seleccionar token","Wallet Connected":"Cartera conectada","Your wallet is connected, you can use it to swap.":"Su cartera est\xe1 conectada, puede usarla para intercambiar.","Failed to Connect":"Error al conectar","Your wallet is not connected. Please try again.":"Su cartera no est\xe1 conectada. Por favor, int\xe9ntelo de nuevo.","Connecting to your wallet":"Conectando a su cartera","Click connect in your wallet popup.":"Haga clic en conectar en su ventana emergente.","Select Derivation Path":"Seleccionar ruta de derivaci\xf3n","In order to connect to {type}, you must first select a Derivation Path":["Para conectarse a ",["type"],", primero debe seleccionar una Ruta de Derivaci\xf3n"],"Choose Derivation Path Template":"Elegir plantilla de ruta de derivaci\xf3n","Enter Path":"Introducir ruta","Enter Index":"Introducir \xedndice","Add {blockchainDisplayName} Chain":["A\xf1adir cadena ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\xbfQuieres a\xf1adir la cadena experimental ",["blockchainDisplayName"]," a tu cartera?"],"Please approve the experimental chain pop-up in your wallet.":"Por favor, apruebe la cadena experimental emergente en su cartera.","{blockchainDisplayName} Chain Added":["Cadena ",["blockchainDisplayName"]," a\xf1adida"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["La cadena ",["blockchainDisplayName"]," se ha a\xf1adido correctamente a tu cartera."],"Request Rejected":"Solicitud rechazada","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Has rechazado a\xf1adir la cadena ",["blockchainDisplayName"]," a tu cartera."],"Select chain types":"Seleccionar tipos de cadena","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Esta cartera soporta m\xfaltiples cadenas. Selecciona a qu\xe9 cadena quieres conectar.","Failed Network, Please retry your swap.":"Red fallida, vuelva a intentar su intercambio.","Please reset your liquidity sources.":"Por favor, reinicie sus fuentes de liquidez.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Usted ha limitado las fuentes de liquidez y esto puede resultar en que Rango no encuentre rutas. Por favor considere restablecer sus fuentes de liquidez.","No Routes Found.":"No se encontraron Rutas.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Razones por las que Rango no pudo encontrar una ruta: baja liquidez en el token, muy baja cantidad de entrada o ninguna ruta disponible para la combinaci\xf3n de entrada/salida seleccionada.","Bridge Limit Error: Please increase your amount.":"Error en el l\xedmite del puente. Por favor, aumente su cantidad.","Bridge Limit Error: Please decrease your amount.":"Error en el l\xedmite del puente. Por favor disminuya su cantidad.","High Price Impact":"Impacto de precios altos","Price impact is too high!":"\xa1El impacto de los precios es demasiado alto!","The price impact is significantly higher than the allowed amount.":"El impacto de los precios es significativamente m\xe1s alto que la cantidad permitida.","Confirm high price impact":"Confirmar alto impacto de precio","Route updated and price impact is too high, try again later!":"Ruta actualizada y el impacto de los precios es demasiado alto, int\xe9ntalo de nuevo m\xe1s tarde!","USD Price Unknown":"Precio desconocido USD","USD Price Unknown, Cannot calculate Price Impact.":"Precio USD Desconocido, no se puede calcular el impacto del precio.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Precio USD Desconocido, no se puede calcular el impacto del precio. El impacto del precio puede ser mayor de lo habitual. \xbfEst\xe1 seguro de continuar el swap?","Confirm USD Price Unknown":"Confirmar el precio de USD desconocido","Swap":"Intercambiar","Swap anyway":"Intercambiar de todos modos","The route goes through Ethereum. Continue?":"La ruta pasa por Ethereum. \xbfContinuar?","Route has been updated.":"La ruta ha sido actualizada.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Cantidad de salida cambiada a ",["newOutputAmount"]," ( cambio",["percentageChange"],"%)."],"Route swappers has been updated.":"Los swappers de rutas han sido actualizados.","Route internal coins has been updated.":"Se han actualizado las monedas internas de la ruta.","Routes":"Rutas","From":"De","To":"A","Light":"Claro","Dark":"Oscuro","Auto":"Auto","Loading failed":"Error al cargar","Bridges":"Puentes","Exchanges":"Intercambios","Custom Tokens":"Tokens personalizados","Language":"Idioma","Infinite approval":"Aprobaci\xf3n infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Habilitar el modo \'Aprobaci\xf3n infinita\' otorga acceso sin restricciones a los contratos inteligentes subyacentes, permiti\xe9ndoles utilizar la cantidad de token aprobada sin limitaciones.","Theme":"Tema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"La direcci\xf3n introducida es duplicada, por favor ingrese una nueva direcci\xf3n.","Token Already Exists":"El token ya existe","There\'s no need to add this token again because it already exists and is supported by us.":"No hay necesidad de a\xf1adir este token de nuevo porque ya existe y est\xe1 soportado por nosotros.","Token Not Found":"Token no encontrado","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Lo sentimos, no se ha encontrado ning\xfan token en la cadena ",["blockchain"]," con la direcci\xf3n proporcionada. Por favor, aseg\xfarese de que ha introducido la direcci\xf3n correcta del token."],"Network Error":"Error de red","Add Custom Token":"A\xf1adir token personalizado","Select chain":"Seleccionar cadena","Enter Address":"Introducir direcci\xf3n","Enter token address":"Introducir direcci\xf3n de token","Failed Network, Please retry.":"Red fallida, vuelva a intentarlo.","Add another custom token":"A\xf1adir otro token personalizado","Confirm Swap":"Confirmar intercambio","Start Swap":"Iniciar intercambio","You get":"Obtienes","Search Token":"Buscar token","No custom tokens":"No hay tokens personalizados","press the button to add your custom token":"pulsa el bot\xf3n para a\xf1adir tu token personalizado","Delete Custom Token":"Eliminar token personalizado","Are you sure you want to Delete this Token?":"\xbfEst\xe1 seguro de que desea eliminar este token?","Complete":"Complete","Running":"Ejecutando","Failed":"Fallo","Clear":"Claro","Search Transaction":"Buscar transacci\xf3n","No transactions":"No hay transacciones","Your transaction history is stored locally and will appear here after you start a swap":"Su historial de transacciones se almacena localmente y aparecer\xe1 aqu\xed despu\xe9s de iniciar un intercambio","Clear Transaction History":"Borrar historial de transacciones","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Continuar eliminar\xe1 todas las transacciones exitosas y fallidas del widget. \xbfDesea continuar?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Nota: Esto no borra tu historial de transacciones en la cadena; s\xf3lo los elimina aqu\xed.","Yes, Clear the history":"S\xed, borrar el historial","language":"idioma","Deselect all":"Deseleccionar todo","Select all":"Seleccionar todo","Search {sourceType}":["Buscar ",["sourceType"]],"Search Chain":"Buscar Cadena","Source":"Fuente","Destination":"Destino","Swap {type}":["Intercambiar ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Actualmente est\xe1s en modo campa\xf1a con restricciones sobre las fuentes de liquidez. \xbfLe gustar\xeda desconectar de este modo y hacer uso de todas las fuentes de liquidez disponibles?","The request ID is necessary to display the swap details.":"El ID de solicitud es necesario para mostrar los detalles del intercambio.","Connect Wallets":"Conectar billeteras","Choose a wallet to connect.":"Elija una cartera para conectar.","This week":"Esta semana","This month":"Este mes","This year":"Este a\xf1o","Required: >= {min} {symbol}":["Requerido: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Requerido: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Requerido: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Requerido: < ",["max"]," ",["symbol"]]," for network fee":" por comisi\xf3n de red"," for swap":" para intercambio"," for input and network fee":" por entrada y tarifa de red","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Necesitas ",["requiredAmount"]," ",["symbol"],["reason"],", pero tienes ",["currentAmount"]," ",["symbol"]," en tu monedero ",["blockchain"],"."],"Waiting for connecting wallet":"Esperando por conectar cartera","Waiting for other running tasks to be finished":"Esperando a que finalicen otras tareas en ejecuci\xf3n","Waiting for changing wallet network":"Esperando a cambiar la red del monedero","Sunday":"Domingo","Monday":"Lunes","Tuesday":"Martes","Wednesday":"Mi\xe9rcoles","Thursday":"Jueves","Friday":"Viernes","Saturday":"S\xe1bado","Powered By":"Desarrollado por","Aggregated Transaction":"Transacci\xf3n agregada","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Intercambiar por ",["fromChain"]," v\xeda ",["swapper"]],"Bridge to {toChain} via {swapper}":["Puente a ",["toChain"]," a trav\xe9s de ",["swapper"]],"Completed":"Completado","In progress":"En progreso","Waiting for bridge transaction":"Esperando una transacci\xf3n de puente","Connected":"Conectado","Disconnect":"Desconectar","Install":"Instalar","Connecting ...":"Conectando...","Connecting":"Conectando","Disconnected":"Desconectado","you need to pass a correct state to Wallet.":"necesita pasar un estado correcto a Wallet.","There are no notifications.":"No hay notificaciones.","Clear all":"Limpiar todo","Balance":"Saldo","Max":"M\xe1x"}');


/*eslint-disable*/ const $902cca6be1bf7145$export$defe85febe8b728c = JSON.parse('{"No results found":"Tuloksia ei l\xf6ytynyt","Try using different keywords":"Kokeile k\xe4ytt\xe4\xe4 eri avainsanoja","Select Chain":"Valitse Ketju","All":"Kaikki","More +{count}":["Enemm\xe4n +",["count"]],"Activate this tab":"Aktivoi t\xe4m\xe4 v\xe4lilehti","Another tab is open and handles transactions.":"Toinen v\xe4lilehti on avoin ja k\xe4sittelee tapahtumia.","Activate current tab":"Aktivoi nykyinen v\xe4lilehti","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"T\xe4ll\xe4 hetkell\xe4 jotkin tapahtumat ovat k\xe4ynniss\xe4 ja niit\xe4 k\xe4sitell\xe4\xe4n muilla selainv\xe4lilehdill\xe4. Jos aktivoit t\xe4m\xe4n v\xe4lilehden, kaikki tapahtumat, jotka ovat jo tapahtumakirjautumisvaiheessa, vanhenevat.","Confirm":"Vahvista","Your {blockchainName} wallets":[["blockchainName"]," lompakkoasi"],"Insufficient account balance":"Tilin saldo ei riit\xe4","Proceed anyway":"Jatka joka tapauksessa","You need to connect a {blockchainName} wallet.":["Sinun on yhdistett\xe4v\xe4 ",["blockchainName"]," lompakko."],"Add {chain} chain":["Lis\xe4\xe4 ",["chain"]," ketju"],"Show more wallets":"N\xe4yt\xe4 lis\xe4\xe4 lompakkoja","Send to a different address":"L\xe4het\xe4 toiseen osoitteeseen","Enter {blockchainName} address":["Sy\xf6t\xe4 ",["blockchainName"]," osoite"],"Address {destination} doesn\'t match the blockchain address pattern.":["Osoite ",["destination"]," ei vastaa lohkoketjun osoitekuviota."],"via":"kautta","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"T\xe4m\xe4 tunnus ei n\xe4y aktiivisessa token listassa. Varmista, ett\xe4 t\xe4m\xe4 on token jonka haluat vaihtaa.","Import":"Tuo","Status":"Tila","Reset":"Reset","Cancel":"Peruuta","Refresh":"P\xe4ivit\xe4","Notifications":"Ilmoitukset","Settings":"Asetukset","History":"Historia","Connect Wallet":"Yhdist\xe4 Lompakko","Today":"T\xe4n\xe4\xe4n","Swaps steps":"Swapin vaiheet","Retry":"Yrit\xe4 Uudelleen","Slippage Error":"Virhe lipasivulla","Slippage Warning":"lipasivun Varoitus","Bridge Limit Error":"Sillan Rajoitus Virhe","Yours: {amount} {symbol}":["Sinun: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Pienin vaadittu slippa: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Sinut: ",["userSlippage"]],"See All Routes":"Katso Kaikki Reitit","View more info":"N\xe4yt\xe4 lis\xe4tiedot","Gas & Fee Explanation":"Kaasun Ja Maksun Selitys","Details":"Yksityiskohdat","Total Payable Fee":"Maksettu Maksu Yhteens\xe4","Hide non-payable fees":"Piilota muut kuin maksetut maksut","Show non-payable fees":"N\xe4yt\xe4 maksamattomat maksut","Description":"Kuvaus","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Seuraavat maksut otetaan huomioon liiketoimen tuotos, ja\\n                sinun ei tarvitse maksaa ylim\xe4\xe4r\xe4ist\xe4 kaasua niist\xe4.","Swap input":"Swap input","Estimated output":"Arvioitu tuotos","Via:":"Via:","Chains:":"Ketjut:","Sort by":"J\xe4rjest\xe4","Smart Routing":"\xc4lyk\xe4s Reititys","Lowest Fee":"Alin Maksu","Fastest Transfer":"Nopein Siirto","Maximum Return":"Suurin Palautus","Maximum Output":"Suurin Ulostulo","Swapping":"Swapping","Gas cost":"Kaasun hinta","Receiving":"Vastaanotetaan","Price impact":"Hinnan vaikutus","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Sinun t\xe4ytyy lis\xe4t\xe4 lipsumissivua v\xe4hint\xe4\xe4n ",["minRequiredSlippage"]," t\xe4lle reitille."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Suosittelemme, ett\xe4 nostat lipsumisen v\xe4hint\xe4\xe4n ",["minRequiredSlippage"]," t\xe4lle reitille."],"Caution, your slippage is high.":"Varoitus, lipsumisesi on korkea.","Change":"Muuta","Change settings":"Muuta asetuksia","High slippage":"Korkea lipsahdus","Low slippage":"Alhainen lipsahdus"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Varoitus, lipsumisesi on korkea (=",["userSlippage"],"). Kaupasi voi olla etu."],"Confirm anyway":"Vahvista joka tapauksessa","Something went wrong":"Jokin meni pieleen","Something went wrong. Please refresh the app.":"Jokin meni pieleen. P\xe4ivit\xe4 sovellus.","Slippage tolerance per swap":"Liu\'utuksen toleranssi swapia kohti","Custom":"Mukautettu","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Tapahtumasi palautetaan, jos hinta muuttuu ep\xe4suotuisasti enemm\xe4n kuin t\xe4m\xe4 prosenttiosuus.","Warning":"Varoitus","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"T\xe4t\xe4 asetusta sovelletaan jokaiseen vaiheeseen (esim. 1Inch, Thorchain, jne.), mik\xe4 tarkoittaa vain sit\xe4, ett\xe4 tietty vaihe peruutetaan, ei koko reitti\xe4.","Swap Details":"Vaihda Tiedot","Request ID":"Pyyd\xe4 ID","Not found":"Ei l\xf6ydy","Swap with request ID = {requestId} not found.":["Vaihda pyynn\xf6n ID = ",["requestId"]," ei l\xf6ytynyt."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Olet saanut ",["amount"]," ",["token"]," ",["conciseAddress"]," -lompakossa ",["chain"]," -ketjussa."],"Transaction was not sent.":"Tapahtumaa ei l\xe4hetetty.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," ",["blockchain"]," j\xe4\xe4 lompakkoosi."],"Delete":"Poista","Try again":"Yrit\xe4 uudelleen","Copied To Clipboard":"Kopioitu Leikep\xf6yd\xe4lle","Copy Request ID":"Kopioi Pyynt\xf6 ID","View on Rango Explorer":"N\xe4yt\xe4 Rango Explorerissa","Finished at":"Valmis klo","Created at":"Luotu klo","View transaction":"N\xe4yt\xe4 tapahtuma","Connect":"Yhdist\xe4","Swap Successful":"Vaihto Onnistui","Transaction Failed":"Tapahtuma Ep\xe4onnistui","Done":"Valmis","Diagnosis":"Diagnoosi","See Details":"N\xe4yt\xe4 Yksityiskohdat","Cancel Swap":"Peruuta Vaihda","Are you sure you want to cancel this swap?":"Oletko varma, ett\xe4 haluat peruuttaa t\xe4m\xe4n swapin?","Yes, Cancel it":"Kyll\xe4, peruuta se","No, Continue":"Ei, Jatka","Delete Transaction":"Poista Tapahtuma","Are you sure you want to delete this swap?":"Oletko varma, ett\xe4 haluat poistaa t\xe4m\xe4n swapin?","Yes, Delete it":"Kyll\xe4, poista se","No, Cancel":"Ei, Peruuta","Change Network":"Vaihda Verkkoa","Network Changed":"Verkko Muutettu","Select Token":"Valitse Tunnus","Wallet Connected":"Lompakko Yhdistetty","Your wallet is connected, you can use it to swap.":"Lompakkosi on yhdistetty, voit k\xe4ytt\xe4\xe4 sit\xe4 vaihtaaksesi.","Failed to Connect":"Yhteyden muodostaminen ep\xe4onnistui","Your wallet is not connected. Please try again.":"Lompakkosi ei ole yhdistetty. Yrit\xe4 uudelleen.","Connecting to your wallet":"Yhdistet\xe4\xe4n lompakkoon","Click connect in your wallet popup.":"Valitse yhdist\xe4 lompakon ponnahdusikkuna.","Select Derivation Path":"Valitse Derivation Polku","In order to connect to {type}, you must first select a Derivation Path":["Jotta voit muodostaa yhteyden ",["type"],", sinun t\xe4ytyy ensin valita Derivation Path"],"Choose Derivation Path Template":"Valitse Derivation Polku Malli","Enter Path":"Sy\xf6t\xe4 Polku","Enter Index":"Sy\xf6t\xe4 Hakemisto","Add {blockchainDisplayName} Chain":["Lis\xe4\xe4 ",["blockchainDisplayName"]," Ketju"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Haluatko lis\xe4t\xe4 lompakkoon ",["blockchainDisplayName"]," kokeellinen ketju?"],"Please approve the experimental chain pop-up in your wallet.":"Ole hyv\xe4 ja hyv\xe4ksy kokeellinen ketju ponnahdusikkuna lompakossa.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Ketju Lis\xe4tty"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," ketju on onnistuneesti lis\xe4tty lompakkoon."],"Request Rejected":"Pyynt\xf6 Hyl\xe4tty","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Olet hyl\xe4nnyt ",["blockchainDisplayName"]," ketjun lis\xe4\xe4misen lompakkoon."],"Select chain types":"Valitse ketjutyypit","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"T\xe4m\xe4 lompakko tukee useita ketjuja. Valitse mihin ketjuun, johon haluat yhdist\xe4\xe4.","Failed Network, Please retry your swap.":"Ep\xe4onnistunut verkko, yrit\xe4 swapisi uudelleen.","Please reset your liquidity sources.":"Ole hyv\xe4 ja nollaa likviditeetin l\xe4hteet.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Olet rajoittanut likviditeettil\xe4hteit\xe4 ja t\xe4m\xe4 saattaa johtaa Rangon l\xf6yt\xe4miseen ilman reittej\xe4. Harkitse likviditeetin l\xe4hteiden uudelleenasettamista.","No Routes Found.":"Reittej\xe4 Ei L\xf6ytynyt.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Syyt miksi Rango ei l\xf6yt\xe4nyt reitti\xe4: alhainen likviditeetti token, hyvin alhainen sy\xf6te m\xe4\xe4r\xe4 tai ei reittej\xe4 k\xe4ytett\xe4viss\xe4 valitun sis\xe4\xe4n- / ulostulo token yhdistelm\xe4.","Bridge Limit Error: Please increase your amount.":"Bridge Limit virhe: Ole hyv\xe4 ja lis\xe4\xe4 summaasi.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit virhe: pienenn\xe4 summaasi.","High Price Impact":"Korkean Hinnan Vaikutus","Price impact is too high!":"Hintavaikutus on liian suuri!","The price impact is significantly higher than the allowed amount.":"Hintavaikutus on huomattavasti suurempi kuin sallittu m\xe4\xe4r\xe4.","Confirm high price impact":"Vahvista hintavaikutus","Route updated and price impact is too high, try again later!":"Reitti p\xe4ivitetty ja hintavaikutus on liian korkea, yrit\xe4 my\xf6hemmin uudelleen!","USD Price Unknown":"Yhdysvaltain Hinta Tuntematon","USD Price Unknown, Cannot calculate Price Impact.":"USD Hinta tuntematon, Ei voida laskea Hintavaikutusta.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Hinta tuntematon, Ei voida laskea hintavaikutusta. Hintavaikutus voi olla tavallista suurempi. Oletko varma jatkamaan swap?","Confirm USD Price Unknown":"Vahvista USD Hinta Tuntematon","Swap":"Vaihda","Swap anyway":"Vaihda joka tapauksessa","The route goes through Ethereum. Continue?":"Reitti kulkee Ethereumin kautta. Jatketaanko?","Route has been updated.":"Reitti on p\xe4ivitetty.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["L\xe4ht\xf6m\xe4\xe4r\xe4ksi muutettiin ",["newOutputAmount"]," (",["percentageChange"],"% muutos)."],"Route swappers has been updated.":"Reitin vaihtajat on p\xe4ivitetty.","Route internal coins has been updated.":"Reitin sis\xe4iset kolikot on p\xe4ivitetty.","Routes":"Reitit","From":"Alkaen","To":"Vastaanottaja","Light":"Vaalea","Dark":"Tumma","Auto":"Automaattinen","Loading failed":"Lataus ep\xe4onnistui","Bridges":"Sillat","Exchanges":"P\xf6rssit","Custom Tokens":"Mukautetut Tokenit","Language":"Kieli","Infinite approval":"Loputon hyv\xe4ksynt\xe4","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"P\xe4\xe4llekk\xe4isen hyv\xe4ksynn\xe4n k\xe4ytt\xf6\xf6notto mahdollistaa rajoittamattoman p\xe4\xe4syn taustalla oleviin \xe4lykk\xe4isiin sopimuksiin, jolloin ne voivat k\xe4ytt\xe4\xe4 hyv\xe4ksytty\xe4 symbolin m\xe4\xe4r\xe4\xe4 rajoituksetta.","Theme":"Teema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"Antamasi osoite on kaksoiskappale, kirjoita uusi osoite.","Token Already Exists":"Token Jo Olemassa","There\'s no need to add this token again because it already exists and is supported by us.":"T\xe4m\xe4n tunnuksen lis\xe4\xe4minen uudelleen ei ole tarpeen, koska se on jo olemassa ja sit\xe4 tukee meid\xe4t.","Token Not Found":"Tunnistetta Ei L\xf6ytynyt","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Anteeksi, tunnus ei l\xf6ytynyt ",["blockchain"]," ketjusta annetun osoitteen kanssa. Varmista, ett\xe4 olet sy\xf6tt\xe4nyt oikeanlaisen token osoitteen."],"Network Error":"Verkon Virhe","Add Custom Token":"Lis\xe4\xe4 Mukautettu Tunnus","Select chain":"Valitse ketju","Enter Address":"Sy\xf6t\xe4 Osoite","Enter token address":"Sy\xf6t\xe4 tunnisteen osoite","Failed Network, Please retry.":"Ep\xe4onnistunut verkko, yrit\xe4 uudelleen.","Add another custom token":"Lis\xe4\xe4 toinen mukautettu tunnus","Confirm Swap":"Vahvista Vaihda","Start Swap":"K\xe4ynnist\xe4 Vaihda","You get":"Sin\xe4 saat","Search Token":"Etsi P\xe4\xe4symerkki","No custom tokens":"Ei omia tunnuksia","press the button to add your custom token":"paina painiketta lis\xe4t\xe4ksesi mukautetun tunnuksen","Delete Custom Token":"Poista Mukautettu Tunnus","Are you sure you want to Delete this Token?":"Oletko varma, ett\xe4 haluat poistaa t\xe4m\xe4n polkun?","Complete":"Complete","Running":"K\xe4ynniss\xe4","Failed":"Ep\xe4onnistui","Clear":"Tyhjenn\xe4","Search Transaction":"Etsi Tapahtuma","No transactions":"Ei tapahtumia","Your transaction history is stored locally and will appear here after you start a swap":"Tapahtumahistoriasi on tallennettu paikallisesti ja se tulee n\xe4kym\xe4\xe4n t\xe4\xe4ll\xe4 swapin k\xe4ynnistymisen j\xe4lkeen","Clear Transaction History":"Tyhjenn\xe4 Tapahtuman Historia","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Jatkaminen poistaa kaikki onnistuneet ja ep\xe4onnistuneet tapahtumat widgetist\xe4. Haluatko jatkaa?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Huom: T\xe4m\xe4 ei poista tapahtumahistoriaasi ketjussa, vaan se poistaa ne vain t\xe4\xe4lt\xe4.","Yes, Clear the history":"Kyll\xe4, Tyhjenn\xe4 historia","language":"kieli","Deselect all":"Poista kaikki valinnat","Select all":"Valitse kaikki","Search {sourceType}":["Hae ",["sourceType"]],"Search Chain":"Etsi Ketju","Source":"L\xe4hde","Destination":"Kohde","Swap {type}":["Vaihda ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"T\xe4ll\xe4 hetkell\xe4 olet kampanjatilassa, jossa on rajoituksia likviditeetin l\xe4hteit\xe4. Haluatko vaihtaa pois t\xe4st\xe4 tilasta ja hy\xf6dynt\xe4\xe4 kaikkia k\xe4ytett\xe4viss\xe4 olevia likviditeetin l\xe4hteit\xe4?","The request ID is necessary to display the swap details.":"Pyynt\xf6 ID on tarpeen n\xe4ytt\xe4\xe4 swapin tiedot.","Connect Wallets":"Yhdist\xe4 Lompakot","Choose a wallet to connect.":"Valitse yhdist\xe4v\xe4 lompakko","This week":"T\xe4ll\xe4 viikolla","This month":"T\xe4ss\xe4 kuussa","This year":"T\xe4n\xe4 vuonna","Required: >= {min} {symbol}":["Pakollinen: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Pakollinen: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Pakollinen: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Pakollinen: < ",["max"]," ",["symbol"]]," for network fee":" verkkomaksua varten"," for swap":" vaihtamista varten"," for input and network fee":" sy\xf6tt\xf6- ja verkkomaksu","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Tarvitsee \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", mutta sinulla on ",["currentAmount"]," ",["symbol"]," lompakossasi ",["blockchain"]," ."],"Waiting for connecting wallet":"Odotetaan lompakon yhdist\xe4mist\xe4","Waiting for other running tasks to be finished":"Odotetaan, ett\xe4 muut k\xe4ynniss\xe4 olevat teht\xe4v\xe4t valmistuvat","Waiting for changing wallet network":"Odotetaan lompakon verkon vaihtamista","Sunday":"Sunnuntai","Monday":"Maanantai","Tuesday":"Tiistai","Wednesday":"Keskiviikko","Thursday":"Torstai","Friday":"Perjantai","Saturday":"Lauantai","Powered By":"Palvelun Toimittaja","Aggregated Transaction":"Yhdistetty Tapahtuma","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Vaihda kohtaan ",["fromChain"]," kautta ",["swapper"]],"Bridge to {toChain} via {swapper}":["Silta ",["toChain"]," :n kautta ",["swapper"]],"Completed":"Valmis","In progress":"Toiminto k\xe4ynniss\xe4","Waiting for bridge transaction":"Odotetaan siltatapahtumaa","Connected":"Yhdistetty","Disconnect":"Katkaise","Install":"Asenna","Connecting ...":"Yhdistet\xe4\xe4n ...","Connecting":"Yhdistet\xe4\xe4n","Disconnected":"Yhteys Katkaistu","you need to pass a correct state to Wallet.":"sinun t\xe4ytyy siirt\xe4\xe4 oikea tila Walletiin.","There are no notifications.":"Ilmoituksia ei ole.","Clear all":"Tyhjenn\xe4 kaikki","Balance":"Saldo","Max":"Maksimi"}');


/*eslint-disable*/ const $92308cb0459afc04$export$defe85febe8b728c = JSON.parse('{"No results found":"Walang nakitang resulta","Try using different keywords":"Subukang gumamit ng iba\'t ibang mga keyword","Select Chain":"Piliin ang Chain","All":"Lahat","More +{count}":["Higit pa +",["count"]],"Activate this tab":"I-activate ang tab na ito","Another tab is open and handles transactions.":"Ang isa pang tab ay bukas at pinangangasiwaan ang mga transaksyon.","Activate current tab":"I-activate ang kasalukuyang tab","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Sa kasalukuyan, ang ilang mga transaksyon ay tumatakbo at pinangangasiwaan ng ibang tab ng browser. Kung i-activate mo ang tab na ito, mag-e-expire ang lahat ng transaksyon na nasa hakbang sa pag-sign ng transaksyon.","Confirm":"Kumpirmahin","Your {blockchainName} wallets":["Ang iyong ",["blockchainName"]," wallet"],"Insufficient account balance":"Hindi sapat na balanse sa account","Proceed anyway":"Magpatuloy pa rin","You need to connect a {blockchainName} wallet.":["Kailangan mong magkonekta ng ",["blockchainName"]," wallet."],"Add {chain} chain":["Magdagdag ng ",["chain"]," chain"],"Show more wallets":"Magpakita ng higit pang mga wallet","Send to a different address":"Ipadala sa ibang address","Enter {blockchainName} address":["Ilagay ang ",["blockchainName"]," address"],"Address {destination} doesn\'t match the blockchain address pattern.":["Ang address ",["destination"]," ay hindi tumutugma sa pattern ng address ng blockchain."],"via":"sa pamamagitan ng","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Hindi lumalabas ang token na ito sa (mga) aktibong listahan ng token. Tiyaking ito ang token na gusto mong i-trade.","Import":"Mag-import","Status":"Katayuan","Reset":"I-reset","Cancel":"Kanselahin","Refresh":"I-refresh","Notifications":"Mga abiso","Settings":"Mga setting","History":"Kasaysayan","Connect Wallet":"Ikonekta ang Wallet","Today":"Ngayong araw","Swaps steps":"Nagpapalitan ng mga hakbang","Retry":"Subukan muli","Slippage Error":"Slippage Error","Slippage Warning":"Babala ng slippage","Bridge Limit Error":"Error sa Limitasyon ng Tulay","Yours: {amount} {symbol}":["Sa iyo: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum na kinakailangang slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Sa iyo: ",["userSlippage"]],"See All Routes":"Tingnan ang Lahat ng Ruta","View more info":"Tingnan ang higit pang impormasyon","Gas & Fee Explanation":"Paliwanag ng Gas at Bayad","Details":"Mga Detalye","Total Payable Fee":"Kabuuang Bayad na Bayad","Hide non-payable fees":"Itago ang mga hindi mababayarang bayarin","Show non-payable fees":"Ipakita ang mga hindi nababayarang bayarin","Description":"Paglalarawan","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Ang mga sumusunod na bayarin ay isinasaalang-alang sa output ng transaksyon at\\n                hindi mo na kailangang magbayad ng dagdag na gas para sa kanila.","Swap input":"Magpalit ng input","Estimated output":"Tinantyang output","Via:":"sa pamamagitan ng:","Chains:":"Mga tanikala:","Sort by":"Pagbukud-bukurin ayon sa","Smart Routing":"Smart Routing","Lowest Fee":"Pinakamababang Bayad","Fastest Transfer":"Pinakamabilis na Paglipat","Maximum Return":"Pinakamataas na Pagbabalik","Maximum Output":"Pinakamataas na Output","Swapping":"Pagpapalit","Gas cost":"Gastos sa gas","Receiving":"Pagtanggap","Price impact":"Epekto sa presyo","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Kailangan mong pataasin ang pagdulas sa hindi bababa sa ",["minRequiredSlippage"]," para sa rutang ito."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Inirerekomenda namin sa iyo na taasan ang pagdulas sa hindi bababa sa ",["minRequiredSlippage"]," para sa rutang ito."],"Caution, your slippage is high.":"Mag-ingat, mataas ang iyong pagkadulas.","Change":"Baguhin","Change settings":"Baguhin ang mga setting","High slippage":"Mataas na pagdulas","Low slippage":"Mababang slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Mag-ingat, mataas ang iyong pagkadulas (=",["userSlippage"],"). Maaaring front run ang iyong trade."],"Confirm anyway":"Kumpirmahin pa rin","Something went wrong":"Nagkaproblema","Something went wrong. Please refresh the app.":"Nagkaproblema. Paki-refresh ang app.","Slippage tolerance per swap":"Pagpapahintulot sa slippage bawat swap","Custom":"Custom","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Ibabalik ang iyong transaksyon kung hindi maganda ang pagbabago sa presyo ng higit sa porsyentong ito.","Warning":"Babala","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Inilapat ang setting na ito sa bawat hakbang (hal. 1Inch, Thorchain, atbp.), ibig sabihin, ang partikular na hakbang lang ang ibabalik, hindi ang buong ruta.","Swap Details":"Pagpalitin ang mga Detalye","Request ID":"Humiling ng ID","Not found":"Hindi nahanap","Swap with request ID = {requestId} not found.":["Magpalit gamit ang request ID = ",["requestId"]," hindi nahanap."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Nakatanggap ka ng ",["amount"]," ",["token"]," sa ",["conciseAddress"]," wallet sa ",["chain"]," chain."],"Transaction was not sent.":"Hindi naipadala ang transaksyon.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," sa ",["blockchain"]," nananatili sa iyong wallet."],"Delete":"Tanggalin","Try again":"Subukan muli","Copied To Clipboard":"Kinopya Sa Clipboard","Copy Request ID":"Kopyahin ang Request ID","View on Rango Explorer":"Tingnan sa Rango Explorer","Finished at":"Natapos sa","Created at":"Nilikha sa","View transaction":"Tingnan ang transaksyon","Connect":"Kumonekta","Swap Successful":"Matagumpay na Pagpalit","Transaction Failed":"Nabigo ang Transaksyon","Done":"Tapos na","Diagnosis":"Diagnosis","See Details":"Tingnan ang Mga Detalye","Cancel Swap":"Kanselahin ang Pagpalit","Are you sure you want to cancel this swap?":"Sigurado ka bang gusto mong kanselahin ang swap na ito?","Yes, Cancel it":"Oo, Kanselahin ito","No, Continue":"Hindi, Magpatuloy","Delete Transaction":"Tanggalin ang Transaksyon","Are you sure you want to delete this swap?":"Sigurado ka bang gusto mong tanggalin ang swap na ito?","Yes, Delete it":"Oo, Tanggalin ito","No, Cancel":"Hindi, Kanselahin","Change Network":"Baguhin ang Network","Network Changed":"Binago ang Network","Select Token":"Piliin ang Token","Wallet Connected":"Nakakonekta ang Wallet","Your wallet is connected, you can use it to swap.":"Ang iyong wallet ay konektado, maaari mo itong gamitin upang makipagpalitan.","Failed to Connect":"Nabigong Kumonekta","Your wallet is not connected. Please try again.":"Hindi konektado ang iyong wallet. Pakisubukang muli.","Connecting to your wallet":"Kumokonekta sa iyong wallet","Click connect in your wallet popup.":"I-click ang kumonekta sa popup ng iyong wallet.","Select Derivation Path":"Piliin ang Derivation Path","In order to connect to {type}, you must first select a Derivation Path":["Para makakonekta sa ",["type"],", kailangan mo munang pumili ng Derivation Path"],"Choose Derivation Path Template":"Piliin ang Template ng Derivation Path","Enter Path":"Ipasok ang Path","Enter Index":"Ipasok ang Index","Add {blockchainDisplayName} Chain":["Magdagdag ng ",["blockchainDisplayName"]," Chain"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Gusto mo bang idagdag ang ",["blockchainDisplayName"]," pang-eksperimentong chain sa iyong wallet?"],"Please approve the experimental chain pop-up in your wallet.":"Mangyaring aprubahan ang pang-eksperimentong chain pop-up sa iyong wallet.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Naidagdag ang Chain"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Ang ",["blockchainDisplayName"]," chain ay matagumpay na naidagdag sa iyong wallet."],"Request Rejected":"Tinanggihan ang Kahilingan","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Tinanggihan mo ang pagdaragdag ng ",["blockchainDisplayName"]," chain sa iyong wallet."],"Select chain types":"Pumili ng mga uri ng chain","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Sinusuportahan ng wallet na ito ang maraming chain. Piliin kung saang chain mo gustong kumonekta.","Failed Network, Please retry your swap.":"Nabigong Network, Pakisubukang muli ang iyong swap.","Please reset your liquidity sources.":"Paki-reset ang iyong mga mapagkukunan ng pagkatubig.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Nilimitahan mo ang mga mapagkukunan ng pagkatubig at maaaring magresulta ito sa Rango na walang mahanap na mga ruta. Mangyaring isaalang-alang ang pag-reset ng iyong mga mapagkukunan ng pagkatubig.","No Routes Found.":"Walang Nahanap na Ruta.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Mga dahilan kung bakit hindi makahanap ng ruta ang Rango: mababang liquidity sa token, napakababang halaga ng input o walang available na ruta para sa napiling kumbinasyon ng input/output token.","Bridge Limit Error: Please increase your amount.":"Bridge Limit Error: Pakidagdagan ang iyong halaga.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit Error: Mangyaring bawasan ang iyong halaga.","High Price Impact":"Mataas na Epekto sa Presyo","Price impact is too high!":"Masyadong mataas ang epekto sa presyo!","The price impact is significantly higher than the allowed amount.":"Ang epekto sa presyo ay makabuluhang mas mataas kaysa sa pinapayagang halaga.","Confirm high price impact":"Kumpirmahin ang epekto ng mataas na presyo","Route updated and price impact is too high, try again later!":"Na-update ang ruta at masyadong mataas ang epekto sa presyo, subukang muli sa ibang pagkakataon!","USD Price Unknown":"Hindi Alam ang Presyo ng USD","USD Price Unknown, Cannot calculate Price Impact.":"Hindi Alam ang Presyo ng USD, Hindi makalkula ang Epekto sa Presyo.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Hindi Alam ang Presyo ng USD, Hindi makalkula ang Epekto sa Presyo. Maaaring mas mataas ang epekto sa presyo kaysa karaniwan. Sigurado ka bang ipagpapatuloy ang Swap?","Confirm USD Price Unknown":"Kumpirmahin ang Presyong USD Hindi Alam","Swap":"Magpalit","Swap anyway":"Magpalit pa rin","The route goes through Ethereum. Continue?":"Ang ruta ay dumadaan sa Ethereum. Magpatuloy?","Route has been updated.":"Na-update ang ruta.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Ang halaga ng output ay ginawang ",["newOutputAmount"]," (",["percentageChange"],"% pagbabago)."],"Route swappers has been updated.":"Ang mga nagpapalit ng ruta ay na-update.","Route internal coins has been updated.":"Ang mga panloob na barya ng ruta ay na-update.","Routes":"Mga Ruta","From":"Mula sa","To":"Upang","Light":"Liwanag","Dark":"Madilim","Auto":"Auto","Loading failed":"Nabigo ang paglo-load","Bridges":"Mga tulay","Exchanges":"Mga palitan","Custom Tokens":"Mga Custom na Token","Language":"Wika","Infinite approval":"Walang katapusang pag-apruba","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Ang pag-enable sa \'Infinite approval\' na mode ay nagbibigay ng hindi pinaghihigpitang access sa mga pinagbabatayan na smart contract, na nagpapahintulot sa kanila na gamitin ang naaprubahang halaga ng token nang walang limitasyon.","Theme":"Tema","Duplicate Token":"Duplicate na Token","The address you entered is duplicate, please enter a new address.":"Ang address na iyong inilagay ay duplicate, mangyaring magpasok ng bagong address.","Token Already Exists":"Umiiral na ang Token","There\'s no need to add this token again because it already exists and is supported by us.":"Hindi na kailangang idagdag muli ang token na ito dahil mayroon na ito at sinusuportahan namin.","Token Not Found":"Hindi Natagpuan ang Token","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Paumanhin, walang nakitang token sa ",["blockchain"]," chain na may ibinigay na address. pakitiyak na naipasok mo ang tamang token address."],"Network Error":"Error sa Network","Add Custom Token":"Magdagdag ng Custom Token","Select chain":"Pumili ng chain","Enter Address":"Ilagay ang Address","Enter token address":"Ilagay ang token address","Failed Network, Please retry.":"Nabigong Network, Pakisubukang muli.","Add another custom token":"Magdagdag ng isa pang custom na token","Confirm Swap":"Kumpirmahin ang Swap","Start Swap":"Simulan ang Swap","You get":"Nakukuha mo","Search Token":"Maghanap ng Token","No custom tokens":"Walang custom na token","press the button to add your custom token":"pindutin ang button para idagdag ang iyong custom na token","Delete Custom Token":"Tanggalin ang Custom Token","Are you sure you want to Delete this Token?":"Sigurado ka bang gusto mong Tanggalin ang Token na ito?","Complete":"Kumpleto","Running":"Tumatakbo","Failed":"Nabigo","Clear":"Maaliwalas","Search Transaction":"Transaksyon sa Paghahanap","No transactions":"Walang transaksyon","Your transaction history is stored locally and will appear here after you start a swap":"Ang iyong kasaysayan ng transaksyon ay lokal na naka-imbak at lalabas dito pagkatapos mong simulan ang isang swap","Clear Transaction History":"I-clear ang History ng Transaksyon","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Aalisin ng pagpapatuloy ang lahat ng matagumpay at nabigong transaksyon mula sa widget. Gusto mo bang magpatuloy?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Tandaan: Hindi nito binubura ang iyong history ng transaksyon sa chain; inaalis lang sila dito.","Yes, Clear the history":"Oo, I-clear ang kasaysayan","language":"wika","Deselect all":"Alisin sa pagkakapili ang lahat","Select all":"Piliin lahat","Search {sourceType}":["Maghanap ",["sourceType"]],"Search Chain":"Chain ng Paghahanap","Source":"Pinagmulan","Destination":"Patutunguhan","Swap {type}":["Magpalit ng ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Sa kasalukuyan, nasa campaign mode ka na may mga paghihigpit sa mga source ng liquidity. Gusto mo bang umalis sa mode na ito at gamitin ang lahat ng available na mapagkukunan ng pagkatubig?","The request ID is necessary to display the swap details.":"Kinakailangan ang request ID para ipakita ang mga detalye ng swap.","Connect Wallets":"Ikonekta ang mga Wallets","Choose a wallet to connect.":"Pumili ng wallet upang kumonekta.","This week":"Ngayong linggo","This month":"Ngayong buwan","This year":"Ngayong taon","Required: >= {min} {symbol}":["Kinakailangan: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Kinakailangan: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Kinakailangan: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Kinakailangan: < ",["max"]," ",["symbol"]]," for network fee":" para sa bayad sa network"," for swap":" para sa swap"," for input and network fee":" para sa input at bayad sa network","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Kailangan ng \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", ngunit mayroon kang ",["currentAmount"]," ",["symbol"]," sa iyong ",["blockchain"]," wallet."],"Waiting for connecting wallet":"Naghihintay para sa pagkonekta ng wallet","Waiting for other running tasks to be finished":"Naghihintay na matapos ang iba pang tumatakbong gawain","Waiting for changing wallet network":"Naghihintay para sa pagpapalit ng network ng wallet","Sunday":"Linggo","Monday":"Lunes","Tuesday":"Martes","Wednesday":"Miyerkules","Thursday":"Huwebes","Friday":"Biyernes","Saturday":"Sabado","Powered By":"Pinapatakbo ng","Aggregated Transaction":"Pinagsama-samang Transaksyon","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Magpalit sa ",["fromChain"]," sa pamamagitan ng ",["swapper"]],"Bridge to {toChain} via {swapper}":["Tulay sa ",["toChain"]," sa pamamagitan ng ",["swapper"]],"Completed":"Nakumpleto","In progress":"Isinasagawa","Waiting for bridge transaction":"Naghihintay ng bridge transaction","Connected":"Nakakonekta","Disconnect":"Idiskonekta","Install":"I-install","Connecting ...":"Kumokonekta...","Connecting":"Kumokonekta","Disconnected":"Nadiskonekta","you need to pass a correct state to Wallet.":"kailangan mong ipasa ang tamang estado sa Wallet.","There are no notifications.":"Walang mga notification.","Clear all":"I-clear lahat","Balance":"Balanse","Max":"Max"}');


/*eslint-disable*/ const $1ffe798a265e8e17$export$defe85febe8b728c = JSON.parse('{"No results found":"Aucun r\xe9sultat trouv\xe9","Try using different keywords":"Essayez d\'utiliser diff\xe9rents mots-cl\xe9s","Select Chain":"S\xe9lectionner une cha\xeene","All":"Tous","More +{count}":["Plus +",["count"]],"Activate this tab":"Activer cet onglet","Another tab is open and handles transactions.":"Un autre onglet est ouvert et g\xe8re les transactions.","Activate current tab":"Activer l\'onglet actuel","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Actuellement, certaines transactions sont en cours d\'ex\xe9cution et sont g\xe9r\xe9es par un autre onglet du navigateur. Si vous activez cet onglet, toutes les transactions qui sont d\xe9j\xe0 dans l\'\xe9tape de signature de la transaction expireront.","Confirm":"Valider","Your {blockchainName} wallets":["Vos portefeuilles ",["blockchainName"]],"Insufficient account balance":"Solde du compte insuffisant","Proceed anyway":"Continuer quand m\xeame","You need to connect a {blockchainName} wallet.":["Vous devez connecter un portefeuille ",["blockchainName"],"."],"Add {chain} chain":["Ajouter une cha\xeene ",["chain"]],"Show more wallets":"Afficher plus de portefeuilles","Send to a different address":"Envoyer \xe0 une autre adresse","Enter {blockchainName} address":["Entrez l\'adresse ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["L\'adresse ",["destination"]," ne correspond pas au mod\xe8le d\'adresse blockchain."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Ce jeton n\'appara\xeet pas dans la liste de jetons actifs. Assurez-vous qu\'il s\'agit du jeton que vous voulez \xe9changer.","Import":"Importation","Status":"Statut","Reset":"Reset","Cancel":"Abandonner","Refresh":"Rafra\xeechir","Notifications":"Notifications","Settings":"R\xe9glages","History":"Historique","Connect Wallet":"Connecter le portefeuille","Today":"Aujourd\'hui","Swaps steps":"\xc9tapes d\'\xe9change","Retry":"R\xe9essayer","Slippage Error":"Erreur de Slippage","Slippage Warning":"Avertissement de Slippage","Bridge Limit Error":"Erreur de limite de pont","Yours: {amount} {symbol}":["Vous: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Slippage minimum requis : ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Votre: ",["userSlippage"]],"See All Routes":"Voir toutes les routes","View more info":"Voir plus d\'infos","Gas & Fee Explanation":"Explication du gaz et des frais","Details":"D\xe9tails du produit","Total Payable Fee":"Total des frais payables","Hide non-payable fees":"Masquer les frais non payables","Show non-payable fees":"Afficher les frais non payants","Description":"Libell\xe9","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Les frais suivants sont pris en compte dans la production de la transaction et\\n                vous n\'aurez pas besoin de payer du gaz suppl\xe9mentaire pour eux.","Swap input":"Swap input","Estimated output":"Sortie estim\xe9e","Via:":"Via:","Chains:":"Cha\xeenes :","Sort by":"Trier par","Smart Routing":"Routage intelligent","Lowest Fee":"Frais les plus bas","Fastest Transfer":"Transfert le plus rapide","Maximum Return":"Retour maximum","Maximum Output":"Sortie maximale","Swapping":"Swapping","Gas cost":"Co\xfbt du gaz","Receiving":"R\xe9ception en cours","Price impact":"Impact des prix","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Vous devez augmenter le slippage \xe0 au moins ",["minRequiredSlippage"]," pour cette route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Nous vous recommandons d\'augmenter le slippage \xe0 au moins ",["minRequiredSlippage"]," pour cette route."],"Caution, your slippage is high.":"Attention, votre slippage est \xe9lev\xe9.","Change":"Changement","Change settings":"Modifier les param\xe8tres","High slippage":"Haut slippage","Low slippage":"Slippage bas"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Attention, votre slippage est \xe9lev\xe9 (=",["userSlippage"],"). Votre \xe9change peut \xeatre frontal."],"Confirm anyway":"Confirmer quand m\xeame","Something went wrong":"Quelque chose s\'est mal pass\xe9","Something went wrong. Please refresh the app.":"Une erreur s\'est produite. Veuillez actualiser l\'application.","Slippage tolerance per swap":"Tol\xe9rance avec glissement par swap","Custom":"Personnalis\xe9","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Votre transaction sera annul\xe9e si le prix change d\xe9favorablement de plus de ce pourcentage.","Warning":"Avertissement","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Ce param\xe8tre est appliqu\xe9 \xe0 chaque \xe9tape (par exemple, 1Inch, Thorchain, etc.), ce qui signifie que seule cette \xe9tape sp\xe9cifique sera annul\xe9e, pas la route enti\xe8re.","Swap Details":"Permuter les d\xe9tails","Request ID":"ID de la requ\xeate","Not found":"Non trouv\xe9","Swap with request ID = {requestId} not found.":["L\'\xe9change avec la requ\xeate ID = ",["requestId"]," est introuvable."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Vous avez re\xe7u ",["amount"]," ",["token"]," dans un portefeuille ",["conciseAddress"]," sur la cha\xeene ",["chain"],"."],"Transaction was not sent.":"La transaction n\'a pas \xe9t\xe9 envoy\xe9e.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," sur ",["blockchain"]," reste dans votre portefeuille."],"Delete":"Supprimez","Try again":"R\xe9essayez","Copied To Clipboard":"Copi\xe9 dans le presse-papiers","Copy Request ID":"Copier l\'ID de la requ\xeate","View on Rango Explorer":"Voir sur Rango Explorer","Finished at":"Termin\xe9 \xe0","Created at":"Cr\xe9\xe9 le","View transaction":"Voir la transaction","Connect":"Connecter","Swap Successful":"Echange R\xe9ussi","Transaction Failed":"La transaction a \xe9chou\xe9","Done":"Fait","Diagnosis":"Diagnostic","See Details":"Voir les d\xe9tails","Cancel Swap":"Annuler l\'\xe9change","Are you sure you want to cancel this swap?":"\xcates-vous s\xfbr de vouloir annuler cet \xe9change ?","Yes, Cancel it":"Oui, annuler","No, Continue":"Non, continuer","Delete Transaction":"Supprimer la transaction","Are you sure you want to delete this swap?":"\xcates-vous s\xfbr de vouloir supprimer cet \xe9change ?","Yes, Delete it":"Oui, supprimer","No, Cancel":"Non, Annuler","Change Network":"Changer de r\xe9seau","Network Changed":"R\xe9seau modifi\xe9","Select Token":"S\xe9lectionner un jeton","Wallet Connected":"Portefeuille connect\xe9","Your wallet is connected, you can use it to swap.":"Votre portefeuille est connect\xe9, vous pouvez l\'utiliser pour \xe9changer.","Failed to Connect":"\xc9chec de la connexion","Your wallet is not connected. Please try again.":"Votre portefeuille n\'est pas connect\xe9. Veuillez r\xe9essayer.","Connecting to your wallet":"Connexion \xe0 votre portefeuille","Click connect in your wallet popup.":"Cliquez sur se connecter dans la fen\xeatre pop-up de votre portefeuille.","Select Derivation Path":"S\xe9lectionner le chemin de d\xe9rivation","In order to connect to {type}, you must first select a Derivation Path":["Pour vous connecter \xe0 ",["type"],", vous devez d\'abord s\xe9lectionner un chemin de d\xe9rivation"],"Choose Derivation Path Template":"Choisir le mod\xe8le de chemin de d\xe9rivation","Enter Path":"Entrez le chemin d\'acc\xe8s","Enter Index":"Entrer l\'index","Add {blockchainDisplayName} Chain":["Ajouter une cha\xeene ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Voulez-vous ajouter la cha\xeene exp\xe9rimentale ",["blockchainDisplayName"]," \xe0 votre portefeuille?"],"Please approve the experimental chain pop-up in your wallet.":"Veuillez approuver la popup de la cha\xeene exp\xe9rimentale dans votre portefeuille.","{blockchainDisplayName} Chain Added":["Cha\xeene ",["blockchainDisplayName"]," ajout\xe9e"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["La cha\xeene ",["blockchainDisplayName"]," a \xe9t\xe9 ajout\xe9e avec succ\xe8s \xe0 votre portefeuille."],"Request Rejected":"Demande rejet\xe9e","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Vous avez rejet\xe9 l\'ajout de la cha\xeene ",["blockchainDisplayName"]," \xe0 votre portefeuille."],"Select chain types":"S\xe9lectionnez les types de cha\xeenes","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Ce portefeuille prend en charge plusieurs cha\xeenes. S\xe9lectionnez la cha\xeene \xe0 laquelle vous souhaitez vous connecter.","Failed Network, Please retry your swap.":"R\xe9seau \xe9chou\xe9, veuillez r\xe9essayer votre swap.","Please reset your liquidity sources.":"Veuillez r\xe9initialiser vos sources de liquidit\xe9s.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Vous avez limit\xe9 les sources de liquidit\xe9s et cela pourrait conduire \xe0 ce que Rango ne trouve aucune voie. Veuillez envisager de r\xe9initialiser vos sources de liquidit\xe9.","No Routes Found.":"Aucune route trouv\xe9e.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Raison pour laquelle Rango n\'a pas pu trouver de route : faible liquidit\xe9 sur jeton, tr\xe8s faible quantit\xe9 d\'entr\xe9e ou aucune route disponible pour la combinaison de jeton d\'entr\xe9e/sortie s\xe9lectionn\xe9e.","Bridge Limit Error: Please increase your amount.":"Erreur de limite de pont : veuillez augmenter votre montant.","Bridge Limit Error: Please decrease your amount.":"Erreur de limite de pont : veuillez r\xe9duire votre montant.","High Price Impact":"Impact sur les prix \xe9lev\xe9s","Price impact is too high!":"L\'impact sur les prix est trop \xe9lev\xe9!","The price impact is significantly higher than the allowed amount.":"L\'impact sur les prix est nettement plus \xe9lev\xe9 que le montant autoris\xe9.","Confirm high price impact":"Confirmer l\'impact \xe9lev\xe9 du prix","Route updated and price impact is too high, try again later!":"La mise \xe0 jour de la route et l\'impact des prix est trop \xe9lev\xe9, r\xe9essayez plus tard!","USD Price Unknown":"Prix USD inconnu","USD Price Unknown, Cannot calculate Price Impact.":"Prix USD inconnu, impossible de calculer l\'impact des prix.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Prix USD inconnu, impossible de calculer l\'impact des prix. L\'impact sur le prix peut \xeatre plus \xe9lev\xe9 que d\'habitude. \xcates-vous s\xfbr de vouloir continuer le swap?","Confirm USD Price Unknown":"Confirmer le prix en USD inconnu","Swap":"Permuter","Swap anyway":"Permuter quand m\xeame","The route goes through Ethereum. Continue?":"L\'itin\xe9raire passe par Ethereum. Continuer ?","Route has been updated.":"La route a \xe9t\xe9 mise \xe0 jour.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["La quantit\xe9 de sortie a \xe9t\xe9 modifi\xe9e \xe0 ",["newOutputAmount"]," (",["percentageChange"],"%)."],"Route swappers has been updated.":"Les swappers de route ont \xe9t\xe9 mis \xe0 jour.","Route internal coins has been updated.":"Les pi\xe8ces internes de la route ont \xe9t\xe9 mises \xe0 jour.","Routes":"Routes","From":"A partir de","To":"\xc0","Light":"Lumi\xe8re","Dark":"Sombre","Auto":"Automatique","Loading failed":"\xc9chec du chargement","Bridges":"Ponts de connexion","Exchanges":"\xc9changes","Custom Tokens":"Jetons personnalis\xe9s","Language":"Langue","Infinite approval":"Approbation infinie","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"L\'activation du mode \\"Approbation infinie\\" donne un acc\xe8s illimit\xe9 aux contrats intelligents sous-jacents, leur permettant d\'utiliser le montant de jeton approuv\xe9 sans restrictions.","Theme":"Th\xe8me","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"L\'adresse que vous avez saisie est dupliqu\xe9e, veuillez entrer une nouvelle adresse.","Token Already Exists":"Le jeton existe d\xe9j\xe0","There\'s no need to add this token again because it already exists and is supported by us.":"Il n\'y a pas besoin d\'ajouter ce jeton \xe0 nouveau car il existe d\xe9j\xe0 et est support\xe9 par nous.","Token Not Found":"Jeton introuvable","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["D\xe9sol\xe9, aucun jeton n\'a \xe9t\xe9 trouv\xe9 sur la cha\xeene ",["blockchain"]," avec l\'adresse fournie. Veuillez vous assurer que vous avez entr\xe9 la bonne adresse de jeton."],"Network Error":"Erreur r\xe9seau","Add Custom Token":"Ajouter un jeton personnalis\xe9","Select chain":"S\xe9lectionner une cha\xeene","Enter Address":"Entrer une adresse","Enter token address":"Entrez l\'adresse du jeton","Failed Network, Please retry.":"R\xe9seau \xe9chou\xe9, veuillez r\xe9essayer.","Add another custom token":"Ajouter un autre jeton personnalis\xe9","Confirm Swap":"Confirmer l\'\xe9change","Start Swap":"D\xe9but de l\'\xe9change","You get":"Vous obtenez","Search Token":"Jeton de recherche","No custom tokens":"Aucun jeton personnalis\xe9","press the button to add your custom token":"appuyez sur le bouton pour ajouter votre jeton personnalis\xe9","Delete Custom Token":"Supprimer le jeton personnalis\xe9","Are you sure you want to Delete this Token?":"\xcates-vous s\xfbr de vouloir supprimer ce jeton ?","Complete":"Complete","Running":"En cours d\'ex\xe9cution","Failed":"Echou\xe9","Clear":"Nettoyer","Search Transaction":"Rechercher une transaction","No transactions":"Aucune transaction","Your transaction history is stored locally and will appear here after you start a swap":"Votre historique de transaction est stock\xe9 localement et appara\xeetra ici apr\xe8s avoir d\xe9marr\xe9 un swap","Clear Transaction History":"Effacer l\'historique des transactions","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Continuer supprimera toutes les transactions r\xe9ussies et \xe9chou\xe9es du widget. Voulez-vous continuer ?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Note: Cela n\'efface pas votre historique de transactions dans la cha\xeene; cela ne les supprime que ici.","Yes, Clear the history":"Oui, effacer l\'historique","language":"Langue","Deselect all":"D\xe9s\xe9lectionner tout","Select all":"Tout s\xe9lectionner","Search {sourceType}":["Rechercher dans ",["sourceType"]],"Search Chain":"Cha\xeene de recherche","Source":"Source","Destination":"Destination","Swap {type}":["\xc9changer ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Actuellement, vous \xeates en mode campagne avec des restrictions sur les sources de liquidit\xe9s. Voulez-vous sortir de ce mode et utiliser toutes les sources de liquidit\xe9s disponibles ?","The request ID is necessary to display the swap details.":"L\'identifiant de la requ\xeate est n\xe9cessaire pour afficher les d\xe9tails du swap.","Connect Wallets":"Connecter les portefeuilles","Choose a wallet to connect.":"Choisissez un portefeuille \xe0 connecter.","This week":"Cette semaine","This month":"Ce mois-ci","This year":"Cette ann\xe9e","Required: >= {min} {symbol}":["Requis: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Requis: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Requis: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Requis: < ",["max"]," ",["symbol"]]," for network fee":" pour frais de r\xe9seau"," for swap":" pour swap"," for input and network fee":" pour les frais d\'entr\xe9e et de r\xe9seau","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["N\xe9cessite \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", mais vous avez ",["currentAmount"]," ",["symbol"]," dans votre portefeuille ",["blockchain"]," ."],"Waiting for connecting wallet":"En attente de connexion au portefeuille","Waiting for other running tasks to be finished":"En attente de la fin des autres t\xe2ches en cours","Waiting for changing wallet network":"En attente de changement de r\xe9seau du portefeuille","Sunday":"Dimanche","Monday":"Lundi","Tuesday":"Mardi","Wednesday":"Mercredi","Thursday":"Jeudi","Friday":"Vendredi","Saturday":"Samedi","Powered By":"Propuls\xe9 par","Aggregated Transaction":"Transaction agr\xe9g\xe9e","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\xc9changer sur ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Pont vers ",["toChain"]," via ",["swapper"]],"Completed":"Termin\xe9","In progress":"En cours","Waiting for bridge transaction":"En attente de la transaction de pont","Connected":"Connect\xe9","Disconnect":"D\xe9connecter","Install":"Installer","Connecting ...":"Connexion en cours...","Connecting":"Connexion en cours","Disconnected":"D\xe9connect\xe9","you need to pass a correct state to Wallet.":"vous devez passer un \xe9tat correct \xe0 Wallet.","There are no notifications.":"Il n\'y a pas de notifications.","Clear all":"Effacer tout","Balance":"Solde","Max":"Max."}');


/*eslint-disable*/ const $08b4924e0a1d36ad$export$defe85febe8b728c = JSON.parse('{"No results found":"\u0915\u094B\u0908 \u092A\u0930\u093F\u0923\u093E\u092E \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E","Try using different keywords":"\u0905\u0932\u0917-\u0905\u0932\u0917 \u0915\u0940\u0935\u0930\u094D\u0921 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0926\u0947\u0916\u0947\u0902","Select Chain":"\u091A\u0947\u0928 \u091A\u0941\u0928\u0947\u0902","All":"\u0938\u092D\u0940","More +{count}":["\u0905\u0927\u093F\u0915 +",["count"]],"Activate this tab":"\u0907\u0938 \u091F\u0948\u092C \u0915\u094B \u0938\u0915\u094D\u0930\u093F\u092F \u0915\u0930\u0947\u0902","Another tab is open and handles transactions.":"\u090F\u0915 \u0905\u0928\u094D\u092F \u091F\u0948\u092C \u0916\u0941\u0932\u093E \u0939\u0948 \u091C\u094B \u0932\u0947\u0928\u0926\u0947\u0928 \u0915\u094B \u0938\u0902\u092D\u093E\u0932\u0924\u093E \u0939\u0948\u0964","Activate current tab":"\u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u091F\u0948\u092C \u0938\u0915\u094D\u0930\u093F\u092F \u0915\u0930\u0947\u0902","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902, \u0915\u0941\u091B \u0932\u0947\u0928\u0926\u0947\u0928 \u091A\u0932 \u0930\u0939\u0947 \u0939\u0948\u0902 \u0914\u0930 \u0905\u0928\u094D\u092F \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u091F\u0948\u092C \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u092D\u093E\u0932\u0947 \u091C\u093E \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u092F\u0926\u093F \u0906\u092A \u0907\u0938 \u091F\u0948\u092C \u0915\u094B \u0938\u0915\u094D\u0930\u093F\u092F \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0932\u0947\u0928\u0926\u0947\u0928 \u0938\u093E\u0907\u0928 \u091A\u0930\u0923 \u092E\u0947\u0902 \u092A\u0939\u0932\u0947 \u0938\u0947 \u092E\u094C\u091C\u0942\u0926 \u0938\u092D\u0940 \u0932\u0947\u0928\u0926\u0947\u0928 \u0938\u092E\u093E\u092A\u094D\u0924 \u0939\u094B \u091C\u093E\u090F\u0902\u0917\u0947\u0964","Confirm":"\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0928\u093E","Your {blockchainName} wallets":["\u0906\u092A\u0915\u0947 ",["blockchainName"]," \u0935\u0949\u0932\u0947\u091F"],"Insufficient account balance":"\u0916\u093E\u0924\u093E \u0936\u0947\u0937 \u0905\u092A\u0930\u094D\u092F\u093E\u092A\u094D\u0924 \u0939\u0948","Proceed anyway":"\u0935\u0948\u0938\u0947 \u092D\u0940 \u0906\u0917\u0947 \u092C\u0922\u093C\u0947","You need to connect a {blockchainName} wallet.":["\u0906\u092A\u0915\u094B ",["blockchainName"]," \u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u093E \u0939\u094B\u0917\u093E\u0964"],"Add {chain} chain":[["chain"]," \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u091C\u094B\u0921\u093C\u0947\u0902"],"Show more wallets":"\u0905\u0927\u093F\u0915 \u0935\u0949\u0932\u0947\u091F \u0926\u093F\u0916\u093E\u090F\u0902","Send to a different address":"\u0915\u093F\u0938\u0940 \u0926\u0942\u0938\u0930\u0947 \u092A\u0924\u0947 \u092A\u0930 \u092D\u0947\u091C\u0947\u0902","Enter {blockchainName} address":[["blockchainName"]," \u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u092A\u0924\u093E ",["destination"]," \u092C\u094D\u0932\u0949\u0915\u091A\u0947\u0928 \u092A\u0924\u093E \u092A\u0948\u091F\u0930\u094D\u0928 \u0938\u0947 \u092E\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093E\u0924\u093E\u0964"],"via":"\u0915\u0947 \u091C\u0930\u093F\u090F","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u092F\u0939 \u091F\u094B\u0915\u0928 \u0938\u0915\u094D\u0930\u093F\u092F \u091F\u094B\u0915\u0928 \u0938\u0942\u091A\u0940(\u0913\u0902) \u092E\u0947\u0902 \u0926\u093F\u0916\u093E\u0908 \u0928\u0939\u0940\u0902 \u0926\u0947\u0924\u093E \u0939\u0948\u0964 \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u092F\u0939 \u0935\u0939\u0940 \u091F\u094B\u0915\u0928 \u0939\u0948 \u091C\u093F\u0938\u0915\u093E \u0906\u092A \u0935\u094D\u092F\u093E\u092A\u093E\u0930 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902\u0964","Import":"\u0906\u092F\u093E\u0924","Status":"\u0938\u094D\u0925\u093F\u0924\u093F","Reset":"\u0930\u0940\u0938\u0947\u091F \u0915\u0930\u0947\u0902","Cancel":"\u0930\u0926\u094D\u0926 \u0915\u0930\u0928\u093E","Refresh":"\u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u093E","Notifications":"\u0938\u0942\u091A\u0928\u093E\u090F\u0902","Settings":"\u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938","History":"\u0907\u0924\u093F\u0939\u093E\u0938","Connect Wallet":"\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902","Today":"\u0906\u091C","Swaps steps":"\u0915\u0926\u092E \u092C\u0926\u0932\u0924\u093E \u0939\u0948","Retry":"\u092A\u0941\u0928: \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902","Slippage Error":"\u092B\u093F\u0938\u0932\u0928 \u0924\u094D\u0930\u0941\u091F\u093F","Slippage Warning":"\u092B\u093F\u0938\u0932\u0928 \u091A\u0947\u0924\u093E\u0935\u0928\u0940","Bridge Limit Error":"\u092C\u094D\u0930\u093F\u091C \u0938\u0940\u092E\u093E \u0924\u094D\u0930\u0941\u091F\u093F","Yours: {amount} {symbol}":["\u0906\u092A\u0915\u093E: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u0928\u094D\u092F\u0942\u0928\u0924\u092E \u0906\u0935\u0936\u094D\u092F\u0915 \u0938\u094D\u0932\u093F\u092A\u0947\u091C: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0906\u092A\u0915\u093E: ",["userSlippage"]],"See All Routes":"\u0938\u092D\u0940 \u0930\u0942\u091F \u0926\u0947\u0916\u0947\u0902","View more info":"\u0905\u0927\u093F\u0915 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0926\u0947\u0916\u0947\u0902","Gas & Fee Explanation":"\u0917\u0948\u0938 \u090F\u0935\u0902 \u0936\u0941\u0932\u094D\u0915 \u0938\u094D\u092A\u0937\u094D\u091F\u0940\u0915\u0930\u0923","Details":"\u0935\u093F\u0935\u0930\u0923","Total Payable Fee":"\u0915\u0941\u0932 \u0926\u0947\u092F \u0936\u0941\u0932\u094D\u0915","Hide non-payable fees":"\u0917\u0948\u0930-\u092D\u0941\u0917\u0924\u093E\u0928 \u092F\u094B\u0917\u094D\u092F \u0936\u0941\u0932\u094D\u0915 \u091B\u093F\u092A\u093E\u090F\u0901","Show non-payable fees":"\u0917\u0948\u0930-\u0926\u0947\u092F \u0936\u0941\u0932\u094D\u0915 \u0926\u093F\u0916\u093E\u090F\u0902","Description":"\u0935\u093F\u0935\u0930\u0923","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0932\u0947\u0928\u0926\u0947\u0928 \u0906\u0909\u091F\u092A\u0941\u091F \u092E\u0947\u0902 \u0928\u093F\u092E\u094D\u0928\u0932\u093F\u0916\u093F\u0924 \u0936\u0941\u0932\u094D\u0915\u094B\u0902 \u092A\u0930 \u0935\u093F\u091A\u093E\u0930 \u0915\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948 \u0914\u0930\\n                \u0906\u092A\u0915\u094B \u0909\u0928\u0915\u0947 \u0932\u093F\u090F \u0905\u0924\u093F\u0930\u093F\u0915\u094D\u0924 \u0917\u0948\u0938 \u0915\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u094B\u0917\u0940\u0964","Swap input":"\u0907\u0928\u092A\u0941\u091F \u0938\u094D\u0935\u0948\u092A \u0915\u0930\u0947\u0902","Estimated output":"\u0905\u0928\u0941\u092E\u093E\u0928\u093F\u0924 \u0909\u0924\u094D\u092A\u093E\u0926\u0928","Via:":"\u0915\u0947 \u091C\u0930\u093F\u090F:","Chains:":"\u091C\u0902\u091C\u0940\u0930\u0947\u0902:","Sort by":"\u0907\u0938\u0915\u0947 \u0905\u0928\u0941\u0938\u093E\u0930 \u0915\u094D\u0930\u092E\u092C\u0926\u094D\u0927 \u0915\u0930\u0947\u0902","Smart Routing":"\u0938\u094D\u092E\u093E\u0930\u094D\u091F \u0930\u0942\u091F\u093F\u0902\u0917","Lowest Fee":"\u0938\u092C\u0938\u0947 \u0915\u092E \u0936\u0941\u0932\u094D\u0915","Fastest Transfer":"\u0938\u092C\u0938\u0947 \u0924\u0947\u091C\u093C \u0938\u094D\u0925\u093E\u0928\u093E\u0902\u0924\u0930\u0923","Maximum Return":"\u0905\u0927\u093F\u0915\u0924\u092E \u0930\u093F\u091F\u0930\u094D\u0928","Maximum Output":"\u0905\u0927\u093F\u0915\u0924\u092E \u0906\u0909\u091F\u092A\u0941\u091F","Swapping":"\u0905\u0926\u0932\u093E-\u092C\u0926\u0932\u0940","Gas cost":"\u0917\u0948\u0938 \u0915\u0940 \u0932\u093E\u0917\u0924","Receiving":"\u092A\u094D\u0930\u093E\u092A\u094D\u0924","Price impact":"\u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0906\u092A\u0915\u094B \u0907\u0938 \u092E\u093E\u0930\u094D\u0917 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0932\u093F\u092A\u0947\u091C \u0915\u094B \u0915\u092E \u0938\u0947 \u0915\u092E ",["minRequiredSlippage"]," \u0924\u0915 \u092C\u0922\u093C\u093E\u0928\u0947 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948\u0964"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u0939\u092E \u0906\u092A\u0915\u094B \u0907\u0938 \u092E\u093E\u0930\u094D\u0917 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0932\u093F\u092A\u0947\u091C \u0915\u094B \u0915\u092E \u0938\u0947 \u0915\u092E ",["minRequiredSlippage"]," \u0924\u0915 \u092C\u0922\u093C\u093E\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"],"Caution, your slippage is high.":"\u0938\u093E\u0935\u0927\u093E\u0928, \u0906\u092A\u0915\u0940 \u092B\u093F\u0938\u0932\u0928 \u0905\u0927\u093F\u0915 \u0939\u0948\u0964","Change":"\u092A\u0930\u093F\u0935\u0930\u094D\u0924\u0928","Change settings":"\u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938 \u092A\u0930\u093F\u0935\u0930\u094D\u0924\u093F\u0924 \u0915\u0930\u0928\u093E","High slippage":"\u0909\u091A\u094D\u091A \u092B\u093F\u0938\u0932\u0928","Low slippage":"\u0915\u092E \u092B\u093F\u0938\u0932\u0928"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0938\u093E\u0935\u0927\u093E\u0928, \u0906\u092A\u0915\u0940 \u0938\u094D\u0932\u093F\u092A\u0947\u091C \u0905\u0927\u093F\u0915 \u0939\u0948 (=",["userSlippage"],")\u0964 \u0906\u092A\u0915\u093E \u091F\u094D\u0930\u0947\u0921 \u092B\u094D\u0930\u0902\u091F \u0930\u0928 \u0939\u094B \u0938\u0915\u0924\u093E \u0939\u0948\u0964"],"Confirm anyway":"\u092B\u093F\u0930 \u092D\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902","Something went wrong":"\u0915\u0941\u091B \u0917\u0932\u0924 \u0939\u094B \u0917\u092F\u093E","Something went wrong. Please refresh the app.":"\u0915\u0941\u091B \u0917\u0921\u093C\u092C\u0921\u093C \u0939\u094B \u0917\u0908 \u0939\u0948\u0964 \u0915\u0943\u092A\u092F\u093E \u0910\u092A \u0915\u094B \u0930\u0940\u092B\u093C\u094D\u0930\u0947\u0936 \u0915\u0930\u0947\u0902\u0964","Slippage tolerance per swap":"\u092A\u094D\u0930\u0924\u093F \u0938\u094D\u0935\u0948\u092A \u0938\u094D\u0932\u093F\u092A\u0947\u091C \u0938\u0939\u0928\u0936\u0940\u0932\u0924\u093E","Custom":"\u0930\u093F\u0935\u093E\u091C\u093C","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u092F\u0926\u093F \u092E\u0942\u0932\u094D\u092F \u092E\u0947\u0902 \u0907\u0938 \u092A\u094D\u0930\u0924\u093F\u0936\u0924 \u0938\u0947 \u0905\u0927\u093F\u0915 \u092A\u094D\u0930\u0924\u093F\u0915\u0942\u0932 \u092A\u0930\u093F\u0935\u0930\u094D\u0924\u0928 \u0939\u094B\u0924\u093E \u0939\u0948 \u0924\u094B \u0906\u092A\u0915\u093E \u0932\u0947\u0928\u0926\u0947\u0928 \u0935\u093E\u092A\u0938 \u0915\u0930 \u0926\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E\u0964","Warning":"\u091A\u0947\u0924\u093E\u0935\u0928\u0940","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u092F\u0939 \u0938\u0947\u091F\u093F\u0902\u0917 \u092A\u094D\u0930\u0924\u094D\u092F\u0947\u0915 \u091A\u0930\u0923 \u092A\u0930 \u0932\u093E\u0917\u0942 \u0939\u094B\u0924\u0940 \u0939\u0948 (\u091C\u0948\u0938\u0947 1\u0907\u0902\u091A, \u0925\u094B\u0930\u091A\u0947\u0928, \u0906\u0926\u093F), \u091C\u093F\u0938\u0915\u093E \u0905\u0930\u094D\u0925 \u0939\u0948 \u0915\u093F \u0915\u0947\u0935\u0932 \u0935\u093F\u0936\u093F\u0937\u094D\u091F \u091A\u0930\u0923 \u0939\u0940 \u092A\u0942\u0930\u094D\u0935\u0935\u0924 \u0915\u093F\u092F\u093E \u091C\u093E\u090F\u0917\u093E, \u0938\u0902\u092A\u0942\u0930\u094D\u0923 \u092E\u093E\u0930\u094D\u0917 \u0928\u0939\u0940\u0902\u0964","Swap Details":"\u0938\u094D\u0935\u0948\u092A \u0935\u093F\u0935\u0930\u0923","Request ID":"\u0905\u0928\u0941\u0930\u094B\u0927 \u0906\u0908\u0921\u0940","Not found":"\u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E","Swap with request ID = {requestId} not found.":["\u0905\u0928\u0941\u0930\u094B\u0927 \u0906\u0908\u0921\u0940 = ",["requestId"]," \u0915\u0947 \u0938\u093E\u0925 \u0938\u094D\u0935\u0948\u092A \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0906\u092A\u0915\u094B ",["chain"]," \u091A\u0947\u0928 \u092A\u0930 ",["conciseAddress"]," \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 ",["amount"]," ",["token"]," \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0939\u0941\u0906 \u0939\u0948\u0964"],"Transaction was not sent.":"\u0932\u0947\u0928-\u0926\u0947\u0928 \u0928\u0939\u0940\u0902 \u092D\u0947\u091C\u093E \u0917\u092F\u093E.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u092A\u0930 ",["blockchain"]," \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u0930\u0939\u0924\u093E \u0939\u0948\u0964"],"Delete":"\u092E\u093F\u091F\u093E\u0928\u093E","Try again":"\u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902","Copied To Clipboard":"\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u093F\u092F\u093E \u0917\u092F\u093E","Copy Request ID":"\u0905\u0928\u0941\u0930\u094B\u0927 \u0906\u0908\u0921\u0940 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902","View on Rango Explorer":"\u0930\u0948\u0902\u0917\u094B \u090F\u0915\u094D\u0938\u092A\u094D\u0932\u094B\u0930\u0930 \u092A\u0930 \u0926\u0947\u0916\u0947\u0902","Finished at":"\u092A\u0930 \u0938\u092E\u093E\u092A\u094D\u0924","Created at":"\u092A\u0930 \u092C\u0928\u093E\u092F\u093E \u0917\u092F\u093E","View transaction":"\u0932\u0947\u0928-\u0926\u0947\u0928 \u0926\u0947\u0916\u0947\u0902","Connect":"\u091C\u094B\u0921\u093C\u0928\u093E","Swap Successful":"\u0938\u094D\u0935\u0948\u092A \u0938\u092B\u0932","Transaction Failed":"\u0932\u0947\u0928 - \u0926\u0947\u0928 \u0935\u093F\u092B\u0932","Done":"\u0939\u094B \u0917\u092F\u093E","Diagnosis":"\u0928\u093F\u0926\u093E\u0928","See Details":"\u0935\u093F\u0938\u094D\u0924\u0943\u0924 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0926\u0947\u0916\u0947\u0902","Cancel Swap":"\u0938\u094D\u0935\u0948\u092A \u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902","Are you sure you want to cancel this swap?":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u0915\u0908 \u0907\u0938 \u0938\u094D\u0935\u0948\u092A \u0915\u094B \u0930\u0926\u094D\u0926 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?","Yes, Cancel it":"\u0939\u093E\u0902, \u0907\u0938\u0947 \u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902","No, Continue":"\u0928\u0939\u0940\u0902, \u091C\u093E\u0930\u0940 \u0930\u0916\u0947\u0902","Delete Transaction":"\u0932\u0947\u0928\u0926\u0947\u0928 \u0939\u091F\u093E\u090F\u0902","Are you sure you want to delete this swap?":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u0915\u0908 \u0907\u0938 \u0938\u094D\u0935\u0948\u092A \u0915\u094B \u0939\u091F\u093E\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?","Yes, Delete it":"\u0939\u093E\u0902, \u0907\u0938\u0947 \u0939\u091F\u093E \u0926\u0947\u0902","No, Cancel":"\u0928\u0939\u0940\u0902, \u0930\u0926\u094D\u0926 \u0915\u0930\u0947\u0902","Change Network":"\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u092C\u0926\u0932\u0947\u0902","Network Changed":"\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u092A\u0930\u093F\u0935\u0930\u094D\u0924\u093F\u0924","Select Token":"\u091F\u094B\u0915\u0928 \u091A\u0941\u0928\u0947\u0902","Wallet Connected":"\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F\u0947\u0921","Your wallet is connected, you can use it to swap.":"\u0906\u092A\u0915\u093E \u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0939\u094B \u0917\u092F\u093E \u0939\u0948, \u0906\u092A \u0907\u0938\u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0938\u094D\u0935\u0948\u092A \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964","Failed to Connect":"\u091C\u094B\u0921\u0928\u0947 \u092E\u0947\u0902 \u0935\u093F\u092B\u0932","Your wallet is not connected. Please try again.":"\u0906\u092A\u0915\u093E \u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0928\u0939\u0940\u0902 \u0939\u0948\u0964 \u0915\u0943\u092A\u092F\u093E \u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902\u0964","Connecting to your wallet":"\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u093E","Click connect in your wallet popup.":"\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u092A\u0949\u092A\u0905\u092A \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u091F \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964","Select Derivation Path":"\u0935\u094D\u092F\u0941\u0924\u094D\u092A\u0924\u094D\u0924\u093F \u092A\u0925 \u091A\u0941\u0928\u0947\u0902","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F, \u0906\u092A\u0915\u094B \u092A\u0939\u0932\u0947 \u090F\u0915 \u0935\u094D\u092F\u0941\u0924\u094D\u092A\u0928\u094D\u0928 \u092A\u0925 \u091A\u0941\u0928\u0928\u093E \u0939\u094B\u0917\u093E"],"Choose Derivation Path Template":"\u0935\u094D\u092F\u0941\u0924\u094D\u092A\u0924\u094D\u0924\u093F \u092A\u0925 \u091F\u0947\u092E\u094D\u092A\u0932\u0947\u091F \u091A\u0941\u0928\u0947\u0902","Enter Path":"\u092A\u0925 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","Enter Index":"\u0938\u0942\u091A\u0915\u093E\u0902\u0915 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \u091A\u0947\u0928 \u091C\u094B\u0921\u093C\u0947\u0902"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0915\u094D\u092F\u093E \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 ",["blockchainDisplayName"]," \u092A\u094D\u0930\u093E\u092F\u094B\u0917\u093F\u0915 \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u091C\u094B\u0921\u093C\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947?"],"Please approve the experimental chain pop-up in your wallet.":"\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u092A\u094D\u0930\u093E\u092F\u094B\u0917\u093F\u0915 \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u092A\u0949\u092A-\u0905\u092A \u0915\u094B \u0905\u0928\u0941\u092E\u094B\u0926\u093F\u0924 \u0915\u0930\u0947\u0902\u0964","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u091C\u094B\u0921\u093C\u0940 \u0917\u0908"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u0938\u092B\u0932\u0924\u093E\u092A\u0942\u0930\u094D\u0935\u0915 \u091C\u094B\u0921\u093C \u0926\u0940 \u0917\u0908 \u0939\u0948\u0964"],"Request Rejected":"\u0905\u0928\u0941\u0930\u094B\u0927 \u0905\u0938\u094D\u0935\u0940\u0915\u0943\u0924","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0906\u092A\u0928\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 ",["blockchainDisplayName"]," \u091A\u0947\u0928 \u091C\u094B\u0921\u093C\u0928\u0947 \u0915\u094B \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948\u0964"],"Select chain types":"\u091A\u0947\u0928 \u092A\u094D\u0930\u0915\u093E\u0930 \u091A\u0941\u0928\u0947\u0902","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u092F\u0939 \u0935\u0949\u0932\u0947\u091F \u0915\u0908 \u091A\u0947\u0928 \u0915\u094B \u0938\u092A\u094B\u0930\u094D\u091F \u0915\u0930\u0924\u093E \u0939\u0948\u0964 \u091A\u0941\u0928\u0947\u0902 \u0915\u093F \u0906\u092A \u0915\u093F\u0938 \u091A\u0947\u0928 \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902\u0964","Failed Network, Please retry your swap.":"\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0935\u093F\u092B\u0932, \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u093E \u0938\u094D\u0935\u0948\u092A \u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902.","Please reset your liquidity sources.":"\u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u0924\u0930\u0932\u0924\u093E \u0938\u094D\u0930\u094B\u0924\u094B\u0902 \u0915\u094B \u0930\u0940\u0938\u0947\u091F \u0915\u0930\u0947\u0902\u0964","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0906\u092A\u0928\u0947 \u0932\u093F\u0915\u094D\u0935\u093F\u0921\u093F\u091F\u0940 \u0938\u094D\u0930\u094B\u0924\u094B\u0902 \u0915\u094B \u0938\u0940\u092E\u093F\u0924 \u0915\u0930 \u0926\u093F\u092F\u093E \u0939\u0948 \u0914\u0930 \u0907\u0938\u0915\u0947 \u092A\u0930\u093F\u0923\u093E\u092E\u0938\u094D\u0935\u0930\u0942\u092A Rango \u0915\u094B \u0915\u094B\u0908 \u092E\u093E\u0930\u094D\u0917 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932 \u0938\u0915\u0924\u093E \u0939\u0948\u0964 \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0947 \u0932\u093F\u0915\u094D\u0935\u093F\u0921\u093F\u091F\u0940 \u0938\u094D\u0930\u094B\u0924\u094B\u0902 \u0915\u094B \u0930\u0940\u0938\u0947\u091F \u0915\u0930\u0928\u0947 \u092A\u0930 \u0935\u093F\u091A\u093E\u0930 \u0915\u0930\u0947\u0902\u0964","No Routes Found.":"\u0915\u094B\u0908 \u092E\u093E\u0930\u094D\u0917 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u0930\u0948\u0902\u0917\u094B \u0915\u094B \u092E\u093E\u0930\u094D\u0917 \u0928 \u092E\u093F\u0932 \u092A\u093E\u0928\u0947 \u0915\u0947 \u0915\u093E\u0930\u0923: \u091F\u094B\u0915\u0928 \u092A\u0930 \u0915\u092E \u0924\u0930\u0932\u0924\u093E, \u092C\u0939\u0941\u0924 \u0915\u092E \u0907\u0928\u092A\u0941\u091F \u0930\u093E\u0936\u093F \u092F\u093E \u091A\u092F\u0928\u093F\u0924 \u0907\u0928\u092A\u0941\u091F/\u0906\u0909\u091F\u092A\u0941\u091F \u091F\u094B\u0915\u0928 \u0938\u0902\u092F\u094B\u091C\u0928 \u0915\u0947 \u0932\u093F\u090F \u0915\u094B\u0908 \u092E\u093E\u0930\u094D\u0917 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u094B\u0928\u093E\u0964","Bridge Limit Error: Please increase your amount.":"\u092C\u094D\u0930\u093F\u091C \u0932\u093F\u092E\u093F\u091F \u0924\u094D\u0930\u0941\u091F\u093F: \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0940 \u0930\u093E\u0936\u093F \u092C\u0922\u093C\u093E\u090F\u0901\u0964","Bridge Limit Error: Please decrease your amount.":"\u092C\u094D\u0930\u093F\u091C \u0932\u093F\u092E\u093F\u091F \u0924\u094D\u0930\u0941\u091F\u093F: \u0915\u0943\u092A\u092F\u093E \u0905\u092A\u0928\u0940 \u0930\u093E\u0936\u093F \u0915\u092E \u0915\u0930\u0947\u0902\u0964","High Price Impact":"\u0909\u091A\u094D\u091A \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935","Price impact is too high!":"\u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u092C\u0939\u0941\u0924 \u0905\u0927\u093F\u0915 \u0939\u0948!","The price impact is significantly higher than the allowed amount.":"\u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u0905\u0928\u0941\u092E\u0924 \u0930\u093E\u0936\u093F \u0938\u0947 \u0915\u093E\u092B\u0940 \u0905\u0927\u093F\u0915 \u0939\u0948\u0964","Confirm high price impact":"\u0909\u091A\u094D\u091A \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902","Route updated and price impact is too high, try again later!":"\u092E\u093E\u0930\u094D\u0917 \u0905\u092A\u0921\u0947\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0914\u0930 \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u092C\u0939\u0941\u0924 \u0905\u0927\u093F\u0915 \u0939\u0948, \u092C\u093E\u0926 \u092E\u0947\u0902 \u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902!","USD Price Unknown":"USD \u092E\u0942\u0932\u094D\u092F \u0905\u091C\u094D\u091E\u093E\u0924","USD Price Unknown, Cannot calculate Price Impact.":"USD \u092E\u0942\u0932\u094D\u092F \u0905\u091C\u094D\u091E\u093E\u0924, \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u0915\u0940 \u0917\u0923\u0928\u093E \u0928\u0939\u0940\u0902 \u0915\u0940 \u091C\u093E \u0938\u0915\u0924\u0940.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \u092E\u0942\u0932\u094D\u092F \u0905\u091C\u094D\u091E\u093E\u0924 \u0939\u0948, \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u0915\u0940 \u0917\u0923\u0928\u093E \u0928\u0939\u0940\u0902 \u0915\u0940 \u091C\u093E \u0938\u0915\u0924\u0940\u0964 \u092E\u0942\u0932\u094D\u092F \u092A\u094D\u0930\u092D\u093E\u0935 \u0938\u093E\u092E\u093E\u0928\u094D\u092F \u0938\u0947 \u0905\u0927\u093F\u0915 \u0939\u094B \u0938\u0915\u0924\u093E \u0939\u0948\u0964 \u0915\u094D\u092F\u093E \u0906\u092A \u0938\u094D\u0935\u0948\u092A \u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?","Confirm USD Price Unknown":"USD \u092E\u0942\u0932\u094D\u092F \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902 \u0905\u091C\u094D\u091E\u093E\u0924","Swap":"\u092C\u0926\u0932\u0928\u093E","Swap anyway":"\u0935\u0948\u0938\u0947 \u092D\u0940 \u0938\u094D\u0935\u0948\u092A \u0915\u0930\u0947\u0902","The route goes through Ethereum. Continue?":"\u092F\u0939 \u092E\u093E\u0930\u094D\u0917 \u090F\u0925\u0947\u0930\u093F\u092F\u092E \u0938\u0947 \u0939\u094B\u0915\u0930 \u091C\u093E\u0924\u093E \u0939\u0948\u0964 \u0906\u0917\u0947 \u092C\u0922\u093C\u0947\u0902?","Route has been updated.":"\u092E\u093E\u0930\u094D\u0917 \u0905\u0926\u094D\u092F\u0924\u0928 \u0915\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0906\u0909\u091F\u092A\u0941\u091F \u0930\u093E\u0936\u093F ",["newOutputAmount"]," (",["percentageChange"],"% \u092A\u0930\u093F\u0935\u0930\u094D\u0924\u0928) \u092E\u0947\u0902 \u092A\u0930\u093F\u0935\u0930\u094D\u0924\u093F\u0924 \u0939\u0941\u0908\u0964"],"Route swappers has been updated.":"\u0930\u0942\u091F \u0938\u094D\u0935\u0948\u092A\u0930\u094D\u0938 \u0915\u094B \u0905\u0926\u094D\u092F\u0924\u0928 \u0915\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948\u0964","Route internal coins has been updated.":"\u0930\u0942\u091F \u0906\u0902\u0924\u0930\u093F\u0915 \u0938\u093F\u0915\u094D\u0915\u094B\u0902 \u0915\u094B \u0905\u0926\u094D\u092F\u0924\u0928 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948\u0964","Routes":"\u092E\u093E\u0930\u094D\u0917\u094B\u0902","From":"\u0938\u0947","To":"\u0915\u094B","Light":"\u0930\u094B\u0936\u0928\u0940","Dark":"\u0905\u0901\u0927\u0947\u0930\u093E","Auto":"\u0911\u091F\u094B","Loading failed":"\u0932\u094B\u0921\u093F\u0902\u0917 \u0935\u093F\u092B\u0932","Bridges":"\u092A\u0941\u0932\u094B\u0902","Exchanges":"\u090F\u0915\u094D\u0938\u091A\u0947\u0902\u091C\u094B\u0902","Custom Tokens":"\u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928","Language":"\u092D\u093E\u0937\u093E","Infinite approval":"\u0905\u0928\u0902\u0924 \u0938\u094D\u0935\u0940\u0915\u0943\u0924\u093F","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\'\u0905\u0928\u0902\u0924 \u0905\u0928\u0941\u092E\u094B\u0926\u0928\' \u092E\u094B\u0921 \u0915\u094B \u0938\u0915\u094D\u0937\u092E \u0915\u0930\u0928\u0947 \u0938\u0947 \u0905\u0902\u0924\u0930\u094D\u0928\u093F\u0939\u093F\u0924 \u0938\u094D\u092E\u093E\u0930\u094D\u091F \u0905\u0928\u0941\u092C\u0902\u0927\u094B\u0902 \u0924\u0915 \u0905\u092A\u094D\u0930\u0924\u093F\u092C\u0902\u0927\u093F\u0924 \u092A\u0939\u0941\u0902\u091A \u092E\u093F\u0932\u0924\u0940 \u0939\u0948, \u091C\u093F\u0938\u0938\u0947 \u0909\u0928\u094D\u0939\u0947\u0902 \u092C\u093F\u0928\u093E \u0915\u093F\u0938\u0940 \u0938\u0940\u092E\u093E \u0915\u0947 \u0905\u0928\u0941\u092E\u094B\u0926\u093F\u0924 \u091F\u094B\u0915\u0928 \u0930\u093E\u0936\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0905\u0928\u0941\u092E\u0924\u093F \u092E\u093F\u0932\u0924\u0940 \u0939\u0948\u0964","Theme":"\u0935\u093F\u0937\u092F","Duplicate Token":"\u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F \u091F\u094B\u0915\u0928","The address you entered is duplicate, please enter a new address.":"\u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u092A\u0924\u093E \u0921\u0941\u092A\u094D\u0932\u093F\u0915\u0947\u091F \u0939\u0948, \u0915\u0943\u092A\u092F\u093E \u0928\u092F\u093E \u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902\u0964","Token Already Exists":"\u091F\u094B\u0915\u0928 \u092A\u0939\u0932\u0947 \u0938\u0947 \u092E\u094C\u091C\u0942\u0926 \u0939\u0948","There\'s no need to add this token again because it already exists and is supported by us.":"\u0907\u0938 \u091F\u094B\u0915\u0928 \u0915\u094B \u0926\u094B\u092C\u093E\u0930\u093E \u091C\u094B\u0921\u093C\u0928\u0947 \u0915\u0940 \u0915\u094B\u0908 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u0948 \u0915\u094D\u092F\u094B\u0902\u0915\u093F \u092F\u0939 \u092A\u0939\u0932\u0947 \u0938\u0947 \u092E\u094C\u091C\u0942\u0926 \u0939\u0948 \u0914\u0930 \u0939\u092E\u093E\u0930\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u092E\u0930\u094D\u0925\u093F\u0924 \u0939\u0948\u0964","Token Not Found":"\u091F\u094B\u0915\u0928 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u0915\u094D\u0937\u092E\u093E \u0915\u0930\u0947\u0902, \u0926\u093F\u090F \u0917\u090F \u092A\u0924\u0947 \u0915\u0947 \u0938\u093E\u0925 ",["blockchain"]," \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E \u092A\u0930 \u0915\u094B\u0908 \u091F\u094B\u0915\u0928 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E\u0964 \u0915\u0943\u092A\u092F\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A\u0928\u0947 \u0938\u0939\u0940 \u091F\u094B\u0915\u0928 \u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u093F\u092F\u093E \u0939\u0948\u0964"],"Network Error":"\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0924\u094D\u0930\u0941\u091F\u093F","Add Custom Token":"\u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928 \u091C\u094B\u0921\u093C\u0947\u0902","Select chain":"\u091A\u0947\u0928 \u091A\u0941\u0928\u0947\u0902","Enter Address":"\u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","Enter token address":"\u091F\u094B\u0915\u0928 \u092A\u0924\u093E \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902","Failed Network, Please retry.":"\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0935\u093F\u092B\u0932, \u0915\u0943\u092A\u092F\u093E \u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902.","Add another custom token":"\u090F\u0915 \u0914\u0930 \u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928 \u091C\u094B\u0921\u093C\u0947\u0902","Confirm Swap":"\u0938\u094D\u0935\u0948\u092A \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902","Start Swap":"\u0938\u094D\u0935\u0948\u092A \u092A\u094D\u0930\u093E\u0930\u0902\u092D \u0915\u0930\u0947\u0902","You get":"\u0906\u092A\u0915\u094B \u092E\u093F\u0932\u093E","Search Token":"\u0916\u094B\u091C \u091F\u094B\u0915\u0928","No custom tokens":"\u0915\u094B\u0908 \u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928 \u0928\u0939\u0940\u0902","press the button to add your custom token":"\u0905\u092A\u0928\u093E \u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928 \u091C\u094B\u0921\u093C\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092C\u091F\u0928 \u0926\u092C\u093E\u090F\u0901","Delete Custom Token":"\u0915\u0938\u094D\u091F\u092E \u091F\u094B\u0915\u0928 \u0939\u091F\u093E\u090F\u0902","Are you sure you want to Delete this Token?":"\u0915\u094D\u092F\u093E \u0906\u092A \u0935\u093E\u0915\u0908 \u0907\u0938 \u091F\u094B\u0915\u0928 \u0915\u094B \u0939\u091F\u093E\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?","Complete":"\u092A\u0942\u0930\u093E","Running":"\u0926\u094C\u0921\u093C\u0928\u093E","Failed":"\u0905\u0938\u092B\u0932","Clear":"\u0938\u094D\u092A\u0937\u094D\u091F","Search Transaction":"\u0932\u0947\u0928\u0926\u0947\u0928 \u0916\u094B\u091C\u0947\u0902","No transactions":"\u0915\u094B\u0908 \u0932\u0947\u0928\u0926\u0947\u0928 \u0928\u0939\u0940\u0902","Your transaction history is stored locally and will appear here after you start a swap":"\u0906\u092A\u0915\u093E \u0932\u0947\u0928-\u0926\u0947\u0928 \u0907\u0924\u093F\u0939\u093E\u0938 \u0938\u094D\u0925\u093E\u0928\u0940\u092F \u0930\u0942\u092A \u0938\u0947 \u0938\u0902\u0917\u094D\u0930\u0939\u0940\u0924 \u0939\u0948 \u0914\u0930 \u0906\u092A\u0915\u0947 \u0926\u094D\u0935\u093E\u0930\u093E \u0938\u094D\u0935\u0948\u092A \u0936\u0941\u0930\u0942 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926 \u092F\u0939\u093E\u0902 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E","Clear Transaction History":"\u0932\u0947\u0928-\u0926\u0947\u0928 \u0907\u0924\u093F\u0939\u093E\u0938 \u0938\u093E\u092B\u093C \u0915\u0930\u0947\u0902","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0906\u0917\u0947 \u092C\u0922\u093C\u0928\u0947 \u0938\u0947 \u0935\u093F\u091C\u0947\u091F \u0938\u0947 \u0938\u092D\u0940 \u0938\u092B\u0932 \u0914\u0930 \u0905\u0938\u092B\u0932 \u0932\u0947\u0928\u0926\u0947\u0928 \u0939\u091F\u093E \u0926\u093F\u090F \u091C\u093E\u090F\u0902\u0917\u0947\u0964 \u0915\u094D\u092F\u093E \u0906\u092A \u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u093E \u091A\u093E\u0939\u0924\u0947 \u0939\u0948\u0902?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u0927\u094D\u092F\u093E\u0928 \u0926\u0947\u0902: \u0907\u0938\u0938\u0947 \u091A\u0947\u0928 \u092A\u0930 \u0906\u092A\u0915\u0947 \u0932\u0947\u0928-\u0926\u0947\u0928 \u0915\u093E \u0907\u0924\u093F\u0939\u093E\u0938 \u0928\u0939\u0940\u0902 \u092E\u093F\u091F\u0924\u093E; \u092F\u0939 \u0915\u0947\u0935\u0932 \u0909\u0928\u094D\u0939\u0947\u0902 \u092F\u0939\u093E\u0902 \u0938\u0947 \u0939\u091F\u093E\u0924\u093E \u0939\u0948\u0964","Yes, Clear the history":"\u0939\u093E\u0902, \u0907\u0924\u093F\u0939\u093E\u0938 \u0938\u093E\u092B\u093C \u0915\u0930\u0947\u0902","language":"\u092D\u093E\u0937\u093E","Deselect all":"\u0938\u092C\u0915\u094B \u0905\u091A\u092F\u0928\u093F\u0924 \u0915\u0930\u094B","Select all":"\u0938\u092C\u0915\u093E \u091A\u092F\u0928 \u0915\u0930\u0947\u0902","Search {sourceType}":["\u0916\u094B\u091C ",["sourceType"]],"Search Chain":"\u0916\u094B\u091C \u0936\u094D\u0930\u0943\u0902\u0916\u0932\u093E","Source":"\u0938\u094D\u0930\u094B\u0924","Destination":"\u0917\u0902\u0924\u0935\u094D\u092F","Swap {type}":["\u0938\u094D\u0935\u0948\u092A ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0935\u0930\u094D\u0924\u092E\u093E\u0928 \u092E\u0947\u0902, \u0906\u092A \u0928\u0915\u0926\u0940 \u0938\u094D\u0930\u094B\u0924\u094B\u0902 \u092A\u0930 \u092A\u094D\u0930\u0924\u093F\u092C\u0902\u0927\u094B\u0902 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092D\u093F\u092F\u093E\u0928 \u092E\u094B\u0921 \u092E\u0947\u0902 \u0939\u0948\u0902\u0964 \u0915\u094D\u092F\u093E \u0906\u092A \u0907\u0938 \u092E\u094B\u0921 \u0938\u0947 \u092C\u093E\u0939\u0930 \u0928\u093F\u0915\u0932\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947 \u0914\u0930 \u0938\u092D\u0940 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0915\u0926\u0940 \u0938\u094D\u0930\u094B\u0924\u094B\u0902 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947?","The request ID is necessary to display the swap details.":"\u0938\u094D\u0935\u0948\u092A \u0935\u093F\u0935\u0930\u0923 \u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u0928\u0941\u0930\u094B\u0927 \u0906\u0908\u0921\u0940 \u0906\u0935\u0936\u094D\u092F\u0915 \u0939\u0948\u0964","Connect Wallets":"\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902","Choose a wallet to connect.":"\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u091A\u0941\u0928\u0947\u0902.","This week":"\u0907\u0938 \u0938\u092A\u094D\u0924\u093E\u0939","This month":"\u0907\u0938 \u092E\u0939\u0940\u0928\u0947","This year":"\u0907\u0938 \u0938\u093E\u0932","Required: >= {min} {symbol}":["\u0906\u0935\u0936\u094D\u092F\u0915: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u0906\u0935\u0936\u094D\u092F\u0915: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0906\u0935\u0936\u094D\u092F\u0915: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0906\u0935\u0936\u094D\u092F\u0915: < ",["max"]," ",["symbol"]]," for network fee":" \u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0936\u0941\u0932\u094D\u0915 \u0915\u0947 \u0932\u093F\u090F"," for swap":" \u0905\u0926\u0932\u093E-\u092C\u0926\u0932\u0940 \u0915\u0947 \u0932\u093F\u090F"," for input and network fee":" \u0907\u0928\u092A\u0941\u091F \u0914\u0930 \u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0936\u0941\u0932\u094D\u0915 \u0915\u0947 \u0932\u093F\u090F","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948, \u0932\u0947\u0915\u093F\u0928 \u0906\u092A\u0915\u0947 ",["blockchain"]," \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 ",["currentAmount"]," ",["symbol"]," \u0939\u0948\u0964"],"Waiting for connecting wallet":"\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0939\u094B\u0928\u0947 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0915\u0940 \u091C\u093E \u0930\u0939\u0940 \u0939\u0948","Waiting for other running tasks to be finished":"\u0905\u0928\u094D\u092F \u091A\u0932 \u0930\u0939\u0947 \u0915\u093E\u0930\u094D\u092F\u094B\u0902 \u0915\u0947 \u0938\u092E\u093E\u092A\u094D\u0924 \u0939\u094B\u0928\u0947 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u0915\u0930 \u0930\u0939\u093E \u0939\u0942\u0901","Waiting for changing wallet network":"\u0935\u0949\u0932\u0947\u091F \u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u092C\u0926\u0932\u0928\u0947 \u0915\u093E \u0907\u0902\u0924\u091C\u093E\u0930","Sunday":"\u0930\u0935\u093F\u0935\u093E\u0930","Monday":"\u0938\u094B\u092E\u0935\u093E\u0930","Tuesday":"\u092E\u0902\u0917\u0932\u0935\u093E\u0930","Wednesday":"\u092C\u0941\u0927\u0935\u093E\u0930","Thursday":"\u0917\u0941\u0930\u0941\u0935\u093E\u0930","Friday":"\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930","Saturday":"\u0936\u0928\u093F\u0935\u093E\u0930","Powered By":"\u0926\u094D\u0935\u093E\u0930\u093E \u0938\u0902\u091A\u093E\u0932\u093F\u0924","Aggregated Transaction":"\u0938\u092E\u0947\u0915\u093F\u0924 \u0932\u0947\u0928\u0926\u0947\u0928","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["fromChain"]," \u0938\u0947 ",["swapper"],"\u092A\u0930 \u0938\u094D\u0935\u0948\u092A \u0915\u0930\u0947\u0902"],"Bridge to {toChain} via {swapper}":[["swapper"],"\u0938\u0947 \u0939\u094B\u0915\u0930 ",["toChain"]," \u0924\u0915 \u0915\u093E \u092A\u0941\u0932"],"Completed":"\u092A\u0941\u0930\u093E \u0939\u094B\u0928\u093E\u0964","In progress":"\u092A\u094D\u0930\u0917\u0924\u093F \u092A\u0930 \u0939\u0948","Waiting for bridge transaction":"\u092C\u094D\u0930\u093F\u091C \u0932\u0947\u0928\u0926\u0947\u0928 \u0915\u0940 \u092A\u094D\u0930\u0924\u0940\u0915\u094D\u0937\u093E \u092E\u0947\u0902","Connected":"\u091C\u0941\u0921\u093C\u0947 \u0939\u0941\u090F","Disconnect":"\u0921\u093F\u0938\u094D\u0915\u0928\u0947\u0915\u094D\u091F","Install":"\u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0928\u093E","Connecting ...":"\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930 \u0930\u0939\u093E \u0939\u0942\u0901...","Connecting":"\u0915\u0928\u0947\u0915\u094D\u091F","Disconnected":"\u0921\u093F\u0938\u094D\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E","you need to pass a correct state to Wallet.":"\u0906\u092A\u0915\u094B \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0938\u0939\u0940 \u0938\u094D\u0925\u093F\u0924\u093F \u092A\u093E\u0938 \u0915\u0930\u0928\u0940 \u0939\u094B\u0917\u0940\u0964","There are no notifications.":"\u0915\u094B\u0908 \u0938\u0942\u091A\u0928\u093E \u0928\u0939\u0940\u0902 \u0939\u0948.","Clear all":"\u0938\u092D\u0940 \u0938\u093E\u092B \u0915\u0930\u0947\u0902","Balance":"\u0938\u0902\u0924\u0941\u0932\u0928","Max":"\u0905\u0927\u093F\u0915\u0924\u092E"}');


/*eslint-disable*/ const $c9a017bc79de91a8$export$defe85febe8b728c = JSON.parse('{"No results found":"Nincs tal\xe1lat","Try using different keywords":"Pr\xf3b\xe1ljon meg m\xe1s kulcsszavakat haszn\xe1lni","Select Chain":"V\xe1lassza a L\xe1nc lehet\u0151s\xe9get","All":"Minden","More +{count}":["Tov\xe1bbiak +",["count"]],"Activate this tab":"Aktiv\xe1lja ezt a lapot","Another tab is open and handles transactions.":"Egy m\xe1sik lap nyitva van, \xe9s a tranzakci\xf3kat kezeli.","Activate current tab":"Az aktu\xe1lis lap aktiv\xe1l\xe1sa","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Jelenleg n\xe9h\xe1ny tranzakci\xf3 fut, \xe9s m\xe1s b\xf6ng\xe9sz\u0151lap kezeli \u0151ket. Ha aktiv\xe1lja ezt a lapot, minden olyan tranzakci\xf3 lej\xe1r, amely m\xe1r benne van a tranzakci\xf3 al\xe1\xedr\xe1si l\xe9p\xe9s\xe9ben.","Confirm":"Er\u0151s\xedtse meg","Your {blockchainName} wallets":["Az \xd6n ",["blockchainName"]," p\xe9nzt\xe1rc\xe1ja"],"Insufficient account balance":"El\xe9gtelen sz\xe1mlaegyenleg","Proceed anyway":"Mindenk\xe9ppen folytassa","You need to connect a {blockchainName} wallet.":["Egy ",["blockchainName"]," p\xe9nzt\xe1rc\xe1t kell csatlakoztatnia."],"Add {chain} chain":["Add hozz\xe1 a ",["chain"]," l\xe1ncot"],"Show more wallets":"Tov\xe1bbi p\xe9nzt\xe1rc\xe1k megjelen\xedt\xe9se","Send to a different address":"K\xfcldje el egy m\xe1sik c\xedmre","Enter {blockchainName} address":["\xcdrja be a ",["blockchainName"]," c\xedmet"],"Address {destination} doesn\'t match the blockchain address pattern.":["A ",["destination"]," c\xedm nem egyezik a blokkl\xe1nc c\xedmmint\xe1j\xe1val."],"via":"kereszt\xfcl","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Ez a token nem jelenik meg az akt\xedv token list\xe1kon. Gy\u0151z\u0151dj\xf6n meg arr\xf3l, hogy ez az a token, amellyel kereskedni szeretne.","Import":"Import\xe1l\xe1s","Status":"\xc1llapot","Reset":"Reset","Cancel":"M\xe9gsem","Refresh":"Friss\xedt\xe9s","Notifications":"\xc9rtes\xedt\xe9sek","Settings":"Be\xe1ll\xedt\xe1sok elemre","History":"T\xf6rt\xe9nelem","Connect Wallet":"Wallet csatlakoztat\xe1sa","Today":"Ma","Swaps steps":"Felcser\xe9li a l\xe9p\xe9seket","Retry":"Pr\xf3b\xe1lja \xfajra","Slippage Error":"Cs\xfasz\xe1si hiba","Slippage Warning":"Cs\xfasz\xe1sra figyelmeztet\xe9s","Bridge Limit Error":"Bridge Limit hiba","Yours: {amount} {symbol}":["A ti\xe9d: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minim\xe1lis sz\xfcks\xe9ges cs\xfasz\xe1s: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["A ti\xe9d: ",["userSlippage"]],"See All Routes":"L\xe1sd: \xd6sszes \xfatvonal","View more info":"Tov\xe1bbi inform\xe1ci\xf3k megtekint\xe9se","Gas & Fee Explanation":"G\xe1z \xe9s d\xedj magyar\xe1zata","Details":"R\xe9szletek","Total Payable Fee":"Teljes fizetend\u0151 d\xedj","Hide non-payable fees":"A nem fizetend\u0151 d\xedjak elrejt\xe9se","Show non-payable fees":"Mutassa meg a nem fizetend\u0151 d\xedjakat","Description":"Le\xedr\xe1s","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Az al\xe1bbi d\xedjak figyelembe v\xe9telre ker\xfclnek a tranzakci\xf3 kimenet\xe9n\xe9l, \xe9s\\n                ezek\xe9rt nem kell k\xfcl\xf6n g\xe1zt fizetni.","Swap input":"Cser\xe9lje ki a bemenetet","Estimated output":"Becs\xfclt teljes\xedtm\xe9ny","Via:":"Kereszt\xfcl:","Chains:":"L\xe1ncok:","Sort by":"Rendez\xe9s","Smart Routing":"Intelligens \xfatv\xe1laszt\xe1s","Lowest Fee":"Legalacsonyabb d\xedj","Fastest Transfer":"Leggyorsabb \xe1tvitel","Maximum Return":"Maxim\xe1lis megt\xe9r\xfcl\xe9s","Maximum Output":"Maxim\xe1lis kimenet","Swapping":"Csere","Gas cost":"G\xe1z k\xf6lts\xe9g","Receiving":"Fogad\xe1s","Price impact":"\xc1rhat\xe1s","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Ehhez az \xfatvonalhoz legal\xe1bb ",["minRequiredSlippage"]," -ra kell n\xf6velnie a cs\xfasz\xe1st."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Javasoljuk, hogy ezen az \xfatvonalon n\xf6velje a cs\xfasz\xe1st legal\xe1bb ",["minRequiredSlippage"]," -ra."],"Caution, your slippage is high.":"Vigy\xe1zat, nagy a cs\xfasz\xe1sod.","Change":"V\xe1ltoz\xe1s","Change settings":"M\xf3dos\xedtsa a be\xe1ll\xedt\xe1sokat","High slippage":"Magas cs\xfasz\xe1s","Low slippage":"Alacsony cs\xfasz\xe1s"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Vigy\xe1zat, a cs\xfasz\xe1sa nagy (=",["userSlippage"],"). El\u0151fordulhat, hogy a kereskedelme el\u0151fut."],"Confirm anyway":"Mindenk\xe9ppen er\u0151s\xedtsd meg","Something went wrong":"Valami elromlott","Something went wrong. Please refresh the app.":"Valami elromlott. K\xe9rj\xfck, friss\xedtse az alkalmaz\xe1st.","Slippage tolerance per swap":"Cs\xfasz\xe1si t\u0171r\xe9s cser\xe9nk\xe9nt","Custom":"Szok\xe1s","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Tranzakci\xf3ja vissza\xe1ll, ha az \xe1r enn\xe9l a sz\xe1zal\xe9kn\xe1l nagyobb m\xe9rt\xe9kben v\xe1ltozik kedvez\u0151tlen\xfcl.","Warning":"Figyelmeztet\xe9s","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Ez a be\xe1ll\xedt\xe1s minden l\xe9p\xe9sre vonatkozik (pl. 1 h\xfcvelyk, Thorchain stb.), ami azt jelenti, hogy csak az adott l\xe9p\xe9s ker\xfcl vissza\xe1ll\xedt\xe1sra, nem a teljes \xfatvonal.","Swap Details":"Csere r\xe9szletei","Request ID":"K\xe9rjen azonos\xedt\xf3t","Not found":"Nem tal\xe1lhat\xf3","Swap with request ID = {requestId} not found.":["Csere k\xe9r\xe9sazonos\xedt\xf3val = ",["requestId"]," nem tal\xe1lhat\xf3."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":[["amount"]," ",["token"]," kapott ",["conciseAddress"]," p\xe9nzt\xe1rc\xe1ban a ",["chain"]," l\xe1ncon."],"Transaction was not sent.":"A tranzakci\xf3 nem lett elk\xfcldve.","{amount} {symbol} on {blockchain} remains in your wallet.":["A ",["amount"]," ",["symbol"]," ",["blockchain"]," a p\xe9nzt\xe1rc\xe1j\xe1ban marad."],"Delete":"T\xf6r\xf6l","Try again":"Pr\xf3b\xe1ld \xfajra","Copied To Clipboard":"V\xe1g\xf3lapra m\xe1solva","Copy Request ID":"K\xe9r\xe9sazonos\xedt\xf3 m\xe1sol\xe1sa","View on Rango Explorer":"Megtekint\xe9s a Rango Exploreren","Finished at":"K\xe9sz\xfclt:","Created at":"L\xe9trehozva:","View transaction":"Tranzakci\xf3 megtekint\xe9se","Connect":"Csatlakoz\xe1s","Swap Successful":"A csere sikeres","Transaction Failed":"A tranzakci\xf3 sikertelen","Done":"K\xe9sz","Diagnosis":"Diagn\xf3zis","See Details":"L\xe1sd R\xe9szletek","Cancel Swap":"Csere lemond\xe1sa","Are you sure you want to cancel this swap?":"Biztosan megszak\xedtja ezt a cser\xe9t?","Yes, Cancel it":"Igen, m\xe9gse","No, Continue":"Nem, folytasd","Delete Transaction":"Tranzakci\xf3 t\xf6rl\xe9se","Are you sure you want to delete this swap?":"Biztosan t\xf6rli ezt a cser\xe9t?","Yes, Delete it":"Igen, t\xf6r\xf6lje","No, Cancel":"Nem, M\xe9gsem","Change Network":"H\xe1l\xf3zat m\xf3dos\xedt\xe1sa","Network Changed":"H\xe1l\xf3zat megv\xe1ltozott","Select Token":"V\xe1lassza a Token lehet\u0151s\xe9get","Wallet Connected":"Wallet csatlakoztatva","Your wallet is connected, you can use it to swap.":"A p\xe9nzt\xe1rc\xe1ja csatlakoztatva van, haszn\xe1lhatja cser\xe9re.","Failed to Connect":"Nem siker\xfclt csatlakozni","Your wallet is not connected. Please try again.":"A p\xe9nzt\xe1rca nincs csatlakoztatva. K\xe9rj\xfck, pr\xf3b\xe1lja \xfajra.","Connecting to your wallet":"Csatlakoz\xe1s a p\xe9nzt\xe1rc\xe1hoz","Click connect in your wallet popup.":"Kattintson a Connect gombra a p\xe9nzt\xe1rca el\u0151ugr\xf3 ablak\xe1ban.","Select Derivation Path":"V\xe1lassza ki a sz\xe1rmaztat\xe1si \xfatvonalat","In order to connect to {type}, you must first select a Derivation Path":["A ",["type"],"-hoz val\xf3 csatlakoz\xe1shoz el\u0151sz\xf6r ki kell v\xe1lasztania egy sz\xe1rmaz\xe1si \xfatvonalat"],"Choose Derivation Path Template":"V\xe1lassza a sz\xe1rmaztat\xe1si \xfatvonal sablont","Enter Path":"\xcdrja be az \xfatvonalat","Enter Index":"\xcdrja be az indexet","Add {blockchainDisplayName} Chain":["Add hozz\xe1 a ",["blockchainDisplayName"]," l\xe1ncot"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Szeretn\xe9 hozz\xe1adni a ",["blockchainDisplayName"]," k\xeds\xe9rleti l\xe1ncot a p\xe9nzt\xe1rc\xe1j\xe1hoz?"],"Please approve the experimental chain pop-up in your wallet.":"K\xe9rj\xfck, hagyja j\xf3v\xe1 a k\xeds\xe9rleti l\xe1nc el\u0151ugr\xf3 ablak\xe1t a p\xe9nzt\xe1rc\xe1j\xe1ban.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," L\xe1nc hozz\xe1adva"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["A ",["blockchainDisplayName"]," l\xe1ncot sikeresen hozz\xe1adtuk p\xe9nzt\xe1rc\xe1j\xe1hoz."],"Request Rejected":"K\xe9relem elutas\xedtva","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\xd6n elutas\xedtotta a ",["blockchainDisplayName"]," l\xe1nc hozz\xe1ad\xe1s\xe1t p\xe9nzt\xe1rc\xe1j\xe1hoz."],"Select chain types":"V\xe1lasszon l\xe1nct\xedpusokat","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Ez a p\xe9nzt\xe1rca t\xf6bb l\xe1ncot is t\xe1mogat. V\xe1lassza ki, melyik l\xe1nchoz szeretne csatlakozni.","Failed Network, Please retry your swap.":"Sikertelen h\xe1l\xf3zat. K\xe9rj\xfck, pr\xf3b\xe1lja \xfajra a cser\xe9t.","Please reset your liquidity sources.":"K\xe9rj\xfck, \xe1ll\xedtsa vissza likvidit\xe1si forr\xe1sait.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Korl\xe1tozta a likvidit\xe1si forr\xe1sokat, \xe9s ez azt eredm\xe9nyezheti, hogy Rango nem tal\xe1l \xfatvonalat. K\xe9rj\xfck, fontolja meg likvidit\xe1si forr\xe1sai vissza\xe1ll\xedt\xe1s\xe1t.","No Routes Found.":"Nem tal\xe1lhat\xf3 \xfatvonal.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Okok, amelyek miatt a Rango nem tal\xe1lt \xfatvonalat: alacsony a token likvidit\xe1sa, nagyon alacsony a bemeneti mennyis\xe9g, vagy nincsenek el\xe9rhet\u0151 \xfatvonalak a kiv\xe1lasztott bemeneti/kimeneti token kombin\xe1ci\xf3hoz.","Bridge Limit Error: Please increase your amount.":"Bridge Limit hiba: K\xe9rj\xfck, n\xf6velje az \xf6sszeget.","Bridge Limit Error: Please decrease your amount.":"Bridge Limit Error: K\xe9rj\xfck, cs\xf6kkentse az \xf6sszeget.","High Price Impact":"Magas \xe1rhat\xe1s","Price impact is too high!":"Az \xe1rhat\xe1s t\xfal nagy!","The price impact is significantly higher than the allowed amount.":"Az \xe1rhat\xe1s l\xe9nyegesen nagyobb a megengedettn\xe9l.","Confirm high price impact":"Er\u0151s\xedtse meg a magas \xe1rhat\xe1st","Route updated and price impact is too high, try again later!":"Az \xfatvonal friss\xedtve, \xe9s az \xe1rhat\xe1s t\xfal nagy, pr\xf3b\xe1lkozzon \xfajra k\xe9s\u0151bb!","USD Price Unknown":"USD \xc1r Ismeretlen","USD Price Unknown, Cannot calculate Price Impact.":"USD \xc1r Ismeretlen, Nem lehet kisz\xe1m\xedtani az \xe1rhat\xe1st.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \xc1r Ismeretlen, Nem lehet kisz\xe1m\xedtani az \xe1rhat\xe1st. Az \xe1rhat\xe1s a szok\xe1sosn\xe1l nagyobb lehet. Biztos, hogy folytatja a cser\xe9t?","Confirm USD Price Unknown":"Er\u0151s\xedtse USD \xc1r Ismeretlen","Swap":"Csere","Swap anyway":"Cser\xe9lj am\xfagy","The route goes through Ethereum. Continue?":"Az \xfat az Ethereumon kereszt\xfcl vezet. Folytatja?","Route has been updated.":"Az \xfatvonal friss\xedtve.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["A kimeneti mennyis\xe9g ",["newOutputAmount"]," \xe9rt\xe9kre m\xf3dosult (",["percentageChange"],"% v\xe1ltoz\xe1s)."],"Route swappers has been updated.":"Az \xfatvonalcser\xe9l\u0151k friss\xedtve.","Route internal coins has been updated.":"Az \xfatvonal bels\u0151 \xe9rm\xe9i friss\xedtve lettek.","Routes":"\xdatvonalak","From":"T\xf3l","To":"To","Light":"F\xe9ny","Dark":"S\xf6t\xe9t","Auto":"Auto","Loading failed":"A bet\xf6lt\xe9s nem siker\xfclt","Bridges":"Hidak","Exchanges":"Cser\xe9k","Custom Tokens":"Egyedi tokenek","Language":"Nyelv","Infinite approval":"V\xe9gtelen j\xf3v\xe1hagy\xe1s","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"A \u201EV\xe9gtelen j\xf3v\xe1hagy\xe1s\u201D m\xf3d enged\xe9lyez\xe9se korl\xe1tlan hozz\xe1f\xe9r\xe9st biztos\xedt az alapul szolg\xe1l\xf3 intelligens szerz\u0151d\xe9sekhez, lehet\u0151v\xe9 t\xe9ve sz\xe1mukra a j\xf3v\xe1hagyott token mennyis\xe9g\xe9nek korl\xe1toz\xe1sok n\xe9lk\xfcli felhaszn\xe1l\xe1s\xe1t.","Theme":"T\xe9ma","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"A megadott c\xedm ism\xe9tl\u0151d\u0151, k\xe9rj\xfck, adjon meg egy \xfaj c\xedmet.","Token Already Exists":"A token m\xe1r l\xe9tezik","There\'s no need to add this token again because it already exists and is supported by us.":"Nem sz\xfcks\xe9ges \xfajra hozz\xe1adni ezt a tokent, mert m\xe1r l\xe9tezik, \xe9s mi is t\xe1mogatjuk.","Token Not Found":"Token nem tal\xe1lhat\xf3","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Sajn\xe1ljuk, nem tal\xe1lhat\xf3 token a ",["blockchain"]," l\xe1ncon a megadott c\xedmmel. k\xe9rj\xfck, ellen\u0151rizze, hogy a megfelel\u0151 token c\xedmet adta-e meg."],"Network Error":"H\xe1l\xf3zati hiba","Add Custom Token":"Adjon hozz\xe1 egy\xe9ni tokent","Select chain":"V\xe1lassza ki a l\xe1ncot","Enter Address":"Adja meg a c\xedmet","Enter token address":"\xcdrja be a token c\xedm\xe9t","Failed Network, Please retry.":"Sikertelen h\xe1l\xf3zat, pr\xf3b\xe1lkozzon \xfajra.","Add another custom token":"Adjon hozz\xe1 egy m\xe1sik egy\xe9ni tokent","Confirm Swap":"Er\u0151s\xedtse meg a cser\xe9t","Start Swap":"Ind\xedtsa el a Swapot","You get":"Megkapod","Search Token":"Token keres\xe9se","No custom tokens":"Nincsenek egy\xe9ni tokenek","press the button to add your custom token":"nyomja meg a gombot az egy\xe9ni token hozz\xe1ad\xe1s\xe1hoz","Delete Custom Token":"Egy\xe9ni token t\xf6rl\xe9se","Are you sure you want to Delete this Token?":"Biztosan t\xf6rli ezt a tokent?","Complete":"Teljes","Running":"Fut\xe1s","Failed":"Sikertelen","Clear":"Vil\xe1gos","Search Transaction":"Tranzakci\xf3 keres\xe9se","No transactions":"Nincsenek tranzakci\xf3k","Your transaction history is stored locally and will appear here after you start a swap":"A tranzakci\xf3s el\u0151zm\xe9nyeket helyben t\xe1roljuk, \xe9s a csere elind\xedt\xe1sa ut\xe1n itt jelennek meg","Clear Transaction History":"Tranzakci\xf3s el\u0151zm\xe9nyek t\xf6rl\xe9se","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"A folytat\xe1s elt\xe1vol\xedtja az \xf6sszes sikeres \xe9s sikertelen tranzakci\xf3t a widgetb\u0151l. Folytatja?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Megjegyz\xe9s: Ez nem t\xf6rli a tranzakci\xf3s el\u0151zm\xe9nyeket a l\xe1ncon; csak itt t\xe1vol\xedtja el \u0151ket.","Yes, Clear the history":"Igen, t\xf6r\xf6lje az el\u0151zm\xe9nyeket","language":"nyelv","Deselect all":"T\xf6r\xf6lje az \xf6sszes kijel\xf6l\xe9s\xe9t","Select all":"V\xe1lassza ki az \xf6sszeset","Search {sourceType}":["Keres\xe9s ",["sourceType"]],"Search Chain":"Keres\u0151l\xe1nc","Source":"Forr\xe1s","Destination":"Rendeltet\xe9si hely","Swap {type}":["Csere ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Jelenleg kamp\xe1nym\xf3dban van, a likvidit\xe1si forr\xe1sokra vonatkoz\xf3 korl\xe1toz\xe1sokkal. Szeretne kil\xe9pni ebb\u0151l a m\xf3db\xf3l, \xe9s kihaszn\xe1lni az \xf6sszes rendelkez\xe9sre \xe1ll\xf3 likvidit\xe1si forr\xe1st?","The request ID is necessary to display the swap details.":"A k\xe9relem azonos\xedt\xf3ja sz\xfcks\xe9ges a csere r\xe9szleteinek megjelen\xedt\xe9s\xe9hez.","Connect Wallets":"Csatlakoztassa a p\xe9nzt\xe1rc\xe1kat","Choose a wallet to connect.":"V\xe1lasszon egy p\xe9nzt\xe1rc\xe1t a csatlakoztat\xe1shoz.","This week":"Ezen a h\xe9ten","This month":"Ebben a h\xf3napban","This year":"Id\xe9n","Required: >= {min} {symbol}":["K\xf6telez\u0151: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["K\xf6telez\u0151: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["K\xf6telez\u0151: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["K\xf6telez\u0151: < ",["max"]," ",["symbol"]]," for network fee":" h\xe1l\xf3zati d\xedj ellen\xe9ben"," for swap":" cser\xe9re"," for input and network fee":" bemeneti \xe9s h\xe1l\xf3zati d\xedj\xe9rt","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"kell, de ",["currentAmount"]," ",["symbol"]," van a ",["blockchain"]," p\xe9nzt\xe1rc\xe1j\xe1ban."],"Waiting for connecting wallet":"V\xe1rakoz\xe1s a p\xe9nzt\xe1rca csatlakoztat\xe1s\xe1ra","Waiting for other running tasks to be finished":"V\xe1rakoz\xe1s a t\xf6bbi fut\xf3 feladat befejez\xe9s\xe9re","Waiting for changing wallet network":"V\xe1rakoz\xe1s a p\xe9nzt\xe1rcah\xe1l\xf3zat megv\xe1ltoztat\xe1s\xe1ra","Sunday":"vas\xe1rnap","Monday":"h\xe9tf\u0151","Tuesday":"kedd","Wednesday":"szerda","Thursday":"cs\xfct\xf6rt\xf6k","Friday":"p\xe9ntek","Saturday":"szombat","Powered By":"Powered by","Aggregated Transaction":"\xd6sszes\xedtett Tranzakci\xf3","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Csere a ",["fromChain"]," -ra ",["swapper"],"-n kereszt\xfcl"],"Bridge to {toChain} via {swapper}":["H\xedd a ",["toChain"]," fel\xe9 a ",["swapper"],"-n kereszt\xfcl"],"Completed":"Befejezve","In progress":"Folyamatban van","Waiting for bridge transaction":"V\xe1rakoz\xe1s a h\xedd tranzakci\xf3ra","Connected":"Csatlakozva","Disconnect":"Lev\xe1laszt\xe1s","Install":"Telep\xedt\xe9s","Connecting ...":"Csatlakoz\xe1s...","Connecting":"Csatlakoz\xe1s","Disconnected":"Sz\xe9tkapcsolt","you need to pass a correct state to Wallet.":"helyes \xe1llapotot kell \xe1tadnia a Walletnek.","There are no notifications.":"Nincsenek \xe9rtes\xedt\xe9sek.","Clear all":"Minden t\xf6rl\xe9se","Balance":"Egyens\xfaly","Max":"Max"}');


/*eslint-disable*/ const $6d2a809d3b820113$export$defe85febe8b728c = JSON.parse('{"No results found":"Tidak ada hasil ditemukan","Try using different keywords":"Coba gunakan kata kunci yang berbeda","Select Chain":"Pilih Rantai","All":"Semua","More +{count}":["Lebih lanjut +",["count"]],"Activate this tab":"Aktifkan tab ini","Another tab is open and handles transactions.":"Tab lain terbuka dan menangani transaksi.","Activate current tab":"Aktifkan tab saat ini","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Saat ini, beberapa transaksi sedang berjalan dan ditangani oleh tab browser lain. Jika Anda mengaktifkan tab ini, semua transaksi yang sudah ada dalam langkah tanda tangan transaksi akan kedaluwarsa.","Confirm":"Mengonfirmasi","Your {blockchainName} wallets":["Dompet ",["blockchainName"]," Anda"],"Insufficient account balance":"Saldo akun tidak mencukupi","Proceed anyway":"Tetap lanjutkan saja","You need to connect a {blockchainName} wallet.":["Anda perlu menghubungkan dompet ",["blockchainName"]," ."],"Add {chain} chain":["Tambahkan rantai ",["chain"]],"Show more wallets":"Tampilkan lebih banyak dompet","Send to a different address":"Kirim ke alamat lain","Enter {blockchainName} address":["Masukkan alamat ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["Alamat ",["destination"]," tidak cocok dengan pola alamat blockchain."],"via":"melalui","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Token ini tidak muncul pada daftar token aktif. Pastikan ini adalah token yang ingin Anda perdagangkan.","Import":"Impor","Status":"Status","Reset":"Mengatur ulang","Cancel":"Membatalkan","Refresh":"Menyegarkan","Notifications":"Pemberitahuan","Settings":"Pengaturan","History":"Sejarah","Connect Wallet":"Hubungkan Dompet","Today":"Hari ini","Swaps steps":"Langkah-langkah pertukaran","Retry":"Mencoba kembali","Slippage Error":"Kesalahan Tergelincir","Slippage Warning":"Peringatan Tergelincir","Bridge Limit Error":"Kesalahan Batas Jembatan","Yours: {amount} {symbol}":["Milik Anda: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Slippage minimum yang dibutuhkan: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Milik Anda: ",["userSlippage"]],"See All Routes":"Lihat Semua Rute","View more info":"Lihat info lebih lanjut","Gas & Fee Explanation":"Penjelasan Gas & Biaya","Details":"Rincian","Total Payable Fee":"Total Biaya yang Harus Dibayar","Hide non-payable fees":"Sembunyikan biaya yang tidak dibayarkan","Show non-payable fees":"Tampilkan biaya yang tidak dibayarkan","Description":"Keterangan","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Biaya-biaya berikut dipertimbangkan dalam hasil transaksi dan\\n                Anda tidak perlu membayar biaya gas tambahan untuk biaya-biaya tersebut.","Swap input":"Tukar masukan","Estimated output":"Perkiraan keluaran","Via:":"Melalui:","Chains:":"Rantai:","Sort by":"Urutkan berdasarkan","Smart Routing":"Rute Cerdas","Lowest Fee":"Biaya Terendah","Fastest Transfer":"Transfer Tercepat","Maximum Return":"Hasil Maksimal","Maximum Output":"Output Maksimum","Swapping":"Pertukaran","Gas cost":"Biaya gas","Receiving":"Menerima","Price impact":"Dampak harga","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Anda perlu meningkatkan slippage setidaknya hingga ",["minRequiredSlippage"]," untuk rute ini."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Kami sarankan Anda meningkatkan slippage minimal hingga ",["minRequiredSlippage"]," untuk rute ini."],"Caution, your slippage is high.":"Perhatian, slip Anda tinggi.","Change":"Mengubah","Change settings":"Ubah pengaturan","High slippage":"Slip yang tinggi","Low slippage":"Selip rendah"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Perhatian, slippage Anda tinggi (=",["userSlippage"],"). Perdagangan Anda mungkin akan mengalami front run."],"Confirm anyway":"Konfirmasi saja","Something went wrong":"Ada yang salah","Something went wrong. Please refresh the app.":"Terjadi kesalahan. Harap segarkan aplikasi.","Slippage tolerance per swap":"Toleransi selip per swap","Custom":"Kebiasaan","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Transaksi Anda akan dibatalkan jika harga berubah tidak menguntungkan lebih dari persentase ini.","Warning":"Peringatan","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Pengaturan ini diterapkan pada setiap langkah (misalnya 1Inch, Thorchain, dll.), artinya hanya langkah spesifik tersebut yang akan dikembalikan, bukan keseluruhan rute.","Swap Details":"Rincian Tukar","Request ID":"ID Permintaan","Not found":"Tidak ditemukan","Swap with request ID = {requestId} not found.":["Penukaran dengan ID permintaan = ",["requestId"]," tidak ditemukan."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Anda telah menerima ",["amount"]," ",["token"]," di dompet ",["conciseAddress"]," di rantai ",["chain"]," ."],"Transaction was not sent.":"Transaksi tidak terkirim.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," pada ",["blockchain"]," tetap ada di dompet Anda."],"Delete":"Menghapus","Try again":"Coba lagi","Copied To Clipboard":"Disalin ke Papan Klip","Copy Request ID":"Salin ID Permintaan","View on Rango Explorer":"Lihat di Rango Explorer","Finished at":"Selesai di","Created at":"Dibuat di","View transaction":"Lihat transaksi","Connect":"Menghubungkan","Swap Successful":"Pertukaran Berhasil","Transaction Failed":"Transaksi Gagal","Done":"Selesai","Diagnosis":"Diagnosa","See Details":"Lihat Detail","Cancel Swap":"Batalkan Tukar","Are you sure you want to cancel this swap?":"Apakah Anda yakin ingin membatalkan pertukaran ini?","Yes, Cancel it":"Ya, Batalkan","No, Continue":"Tidak, Lanjutkan","Delete Transaction":"Hapus Transaksi","Are you sure you want to delete this swap?":"Apakah Anda yakin ingin menghapus pertukaran ini?","Yes, Delete it":"Ya, Hapus itu","No, Cancel":"Tidak, Batal","Change Network":"Ubah Jaringan","Network Changed":"Jaringan Berubah","Select Token":"Pilih Token","Wallet Connected":"Dompet Terhubung","Your wallet is connected, you can use it to swap.":"Dompet Anda terhubung, Anda dapat menggunakannya untuk bertukar.","Failed to Connect":"Gagal Terhubung","Your wallet is not connected. Please try again.":"Dompet Anda tidak terhubung. Silakan coba lagi.","Connecting to your wallet":"Menghubungkan ke dompet Anda","Click connect in your wallet popup.":"Klik sambungkan pada popup dompet Anda.","Select Derivation Path":"Pilih Jalur Derivasi","In order to connect to {type}, you must first select a Derivation Path":["Untuk terhubung ke ",["type"],", Anda harus terlebih dahulu memilih Jalur Derivasi"],"Choose Derivation Path Template":"Pilih Template Jalur Derivasi","Enter Path":"Masukkan Jalur","Enter Index":"Masukkan Indeks","Add {blockchainDisplayName} Chain":["Tambahkan ",["blockchainDisplayName"]," Rantai"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Apakah Anda ingin menambahkan rantai eksperimental ",["blockchainDisplayName"]," ke dompet Anda?"],"Please approve the experimental chain pop-up in your wallet.":"Harap setujui pop-up rantai eksperimental di dompet Anda.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Rantai Ditambahkan"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Rantai ",["blockchainDisplayName"]," telah berhasil ditambahkan ke dompet Anda."],"Request Rejected":"Permintaan Ditolak","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Anda telah menolak penambahan rantai ",["blockchainDisplayName"]," ke dompet Anda."],"Select chain types":"Pilih jenis rantai","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Dompet ini mendukung beberapa rantai. Pilih rantai yang ingin Anda sambungkan.","Failed Network, Please retry your swap.":"Jaringan Gagal, Silakan coba lagi pertukaran Anda.","Please reset your liquidity sources.":"Harap atur ulang sumber likuiditas Anda.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Anda telah membatasi sumber likuiditas dan ini dapat mengakibatkan Rango tidak menemukan rute. Harap pertimbangkan untuk mengatur ulang sumber likuiditas Anda.","No Routes Found.":"Tidak Ada Rute Ditemukan.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Alasan mengapa Rango tidak dapat menemukan rute: likuiditas rendah pada token, jumlah input sangat rendah atau tidak ada rute yang tersedia untuk kombinasi token input/output yang dipilih.","Bridge Limit Error: Please increase your amount.":"Kesalahan Batas Jembatan: Harap tingkatkan jumlah Anda.","Bridge Limit Error: Please decrease your amount.":"Kesalahan Batas Jembatan: Harap kurangi jumlah Anda.","High Price Impact":"Dampak Harga Tinggi","Price impact is too high!":"Dampak harga terlalu tinggi!","The price impact is significantly higher than the allowed amount.":"Dampak harga secara signifikan lebih tinggi daripada jumlah yang diizinkan.","Confirm high price impact":"Konfirmasi dampak harga tinggi","Route updated and price impact is too high, try again later!":"Rute diperbarui dan dampak harga terlalu tinggi, coba lagi nanti!","USD Price Unknown":"Harga USD Tidak Diketahui","USD Price Unknown, Cannot calculate Price Impact.":"Harga USD Tidak Diketahui, Tidak dapat menghitung Dampak Harga.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Harga USD Tidak Diketahui, Dampak Harga Tidak Dapat Dihitung. Dampak harga mungkin lebih tinggi dari biasanya. Apakah Anda yakin untuk melanjutkan Swap?","Confirm USD Price Unknown":"Konfirmasi Harga USD Tidak Diketahui","Swap":"Menukar","Swap anyway":"Tukar saja","The route goes through Ethereum. Continue?":"Rutenya melewati Ethereum. Lanjutkan?","Route has been updated.":"Rute telah diperbarui.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Jumlah keluaran berubah menjadi ",["newOutputAmount"]," (",["percentageChange"],"% perubahan)."],"Route swappers has been updated.":"Penukar rute telah diperbarui.","Route internal coins has been updated.":"Koin internal rute telah diperbarui.","Routes":"Rute","From":"Dari","To":"Ke","Light":"Lampu","Dark":"Gelap","Auto":"Mobil","Loading failed":"Pemuatan gagal","Bridges":"Jembatan","Exchanges":"Pertukaran","Custom Tokens":"Token Kustom","Language":"Bahasa","Infinite approval":"Persetujuan tak terbatas","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Mengaktifkan mode \'Persetujuan Tak Terbatas\' memberikan akses tak terbatas ke kontrak pintar yang mendasarinya, yang memungkinkan mereka memanfaatkan jumlah token yang disetujui tanpa batasan.","Theme":"Tema","Duplicate Token":"Token Duplikat","The address you entered is duplicate, please enter a new address.":"Alamat yang Anda masukkan duplikat, silakan masukkan alamat baru.","Token Already Exists":"Token Sudah Ada","There\'s no need to add this token again because it already exists and is supported by us.":"Tidak perlu menambahkan token ini lagi karena sudah ada dan didukung oleh kami.","Token Not Found":"Token Tidak Ditemukan","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Maaf, tidak ada token yang ditemukan pada rantai ",["blockchain"]," dengan alamat yang diberikan. Pastikan Anda telah memasukkan alamat token yang benar."],"Network Error":"Kesalahan Jaringan","Add Custom Token":"Tambahkan Token Kustom","Select chain":"Pilih rantai","Enter Address":"Masukkan Alamat","Enter token address":"Masukkan alamat token","Failed Network, Please retry.":"Jaringan Gagal, Silakan coba lagi.","Add another custom token":"Tambahkan token kustom lainnya","Confirm Swap":"Konfirmasi Penukaran","Start Swap":"Mulai Tukar","You get":"Kamu mendapatkan","Search Token":"Pencarian Token","No custom tokens":"Tidak ada token khusus","press the button to add your custom token":"tekan tombol untuk menambahkan token khusus Anda","Delete Custom Token":"Hapus Token Kustom","Are you sure you want to Delete this Token?":"Apakah Anda yakin ingin Menghapus Token ini?","Complete":"Menyelesaikan","Running":"Berlari","Failed":"Gagal","Clear":"Jernih","Search Transaction":"Pencarian Transaksi","No transactions":"Tidak ada transaksi","Your transaction history is stored locally and will appear here after you start a swap":"Riwayat transaksi Anda disimpan secara lokal dan akan muncul di sini setelah Anda memulai swap","Clear Transaction History":"Hapus Riwayat Transaksi","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Proses ini akan menghapus semua transaksi yang berhasil dan gagal dari widget. Apakah Anda ingin melanjutkan?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Catatan: Ini tidak menghapus riwayat transaksi Anda di rantai; tetapi hanya menghapusnya di sini.","Yes, Clear the history":"Ya, Hapus riwayat","language":"bahasa","Deselect all":"Batalkan pilihan semua","Select all":"Pilih semua","Search {sourceType}":["Pencarian ",["sourceType"]],"Search Chain":"Rantai Pencarian","Source":"Sumber","Destination":"Tujuan","Swap {type}":["Tukar ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Saat ini, Anda sedang dalam mode kampanye dengan pembatasan sumber likuiditas. Apakah Anda ingin keluar dari mode ini dan memanfaatkan semua sumber likuiditas yang tersedia?","The request ID is necessary to display the swap details.":"ID permintaan diperlukan untuk menampilkan rincian pertukaran.","Connect Wallets":"Hubungkan Dompet","Choose a wallet to connect.":"Pilih dompet untuk dihubungkan.","This week":"Minggu ini","This month":"Bulan ini","This year":"tahun ini","Required: >= {min} {symbol}":["Diperlukan: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Diperlukan: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Diperlukan: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Diperlukan: < ",["max"]," ",["symbol"]]," for network fee":" untuk biaya jaringan"," for swap":" untuk tukar"," for input and network fee":" untuk biaya input dan jaringan","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Membutuhkan \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", tetapi Anda memiliki ",["currentAmount"]," ",["symbol"]," di dompet ",["blockchain"]," Anda."],"Waiting for connecting wallet":"Menunggu dompet penghubung","Waiting for other running tasks to be finished":"Menunggu tugas lain yang sedang berjalan untuk diselesaikan","Waiting for changing wallet network":"Menunggu perubahan jaringan dompet","Sunday":"Minggu","Monday":"Senin","Tuesday":"Selasa","Wednesday":"Rabu","Thursday":"Kamis","Friday":"Jumat","Saturday":"Sabtu","Powered By":"Didukung Oleh","Aggregated Transaction":"Transaksi Agregat","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Tukar pada ",["fromChain"]," melalui ",["swapper"]],"Bridge to {toChain} via {swapper}":["Jembatan menuju ",["toChain"]," melalui ",["swapper"]],"Completed":"Selesai","In progress":"Sedang berlangsung","Waiting for bridge transaction":"Menunggu transaksi jembatan","Connected":"Terhubung","Disconnect":"Memutuskan","Install":"Memasang","Connecting ...":"Menghubungkan ...","Connecting":"Menghubungkan","Disconnected":"Terputus","you need to pass a correct state to Wallet.":"Anda perlu memberikan status yang benar ke Wallet.","There are no notifications.":"Tidak ada pemberitahuan.","Clear all":"Hapus semuanya","Balance":"Keseimbangan","Max":"Maksimal"}');


/*eslint-disable*/ const $85993aef506dc223$export$defe85febe8b728c = JSON.parse('{"No results found":"Nessun risultato trovato","Try using different keywords":"Prova a usare parole chiave diverse","Select Chain":"Seleziona Catena","All":"Tutti","More +{count}":["Altro +",["count"]],"Activate this tab":"Attiva questa scheda","Another tab is open and handles transactions.":"Un\'altra scheda \xe8 aperta e gestisce le transazioni.","Activate current tab":"Attiva la scheda corrente","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Attualmente, alcune transazioni sono in esecuzione e vengono gestite da un\'altra scheda del browser. Se attivi questa scheda, tutte le transazioni che sono gi\xe0 nella fase del segno di transazione scadranno.","Confirm":"Conferma","Your {blockchainName} wallets":["I tuoi portafogli ",["blockchainName"]],"Insufficient account balance":"Saldo del conto insufficiente","Proceed anyway":"Procedere comunque","You need to connect a {blockchainName} wallet.":["Devi collegare un portafoglio ",["blockchainName"],"."],"Add {chain} chain":["Aggiungi catena ",["chain"]],"Show more wallets":"Mostra altri portafogli","Send to a different address":"Invia a un indirizzo diverso","Enter {blockchainName} address":["Inserisci l\'indirizzo ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["L\'indirizzo ",["destination"]," non corrisponde al modello di indirizzo blockchain."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Questo token non appare nella lista dei token attivi. Assicurati che questo sia il token che vuoi scambiare.","Import":"Importa","Status":"Stato","Reset":"Reset","Cancel":"Annulla","Refresh":"Aggiorna","Notifications":"Notifiche","Settings":"Impostazioni","History":"Storico","Connect Wallet":"Connetti Portafoglio","Today":"Oggi","Swaps steps":"Passaggi degli swap","Retry":"Riprova","Slippage Error":"Errore Slippage","Slippage Warning":"Avviso Slippage","Bridge Limit Error":"Errore Limite Ponte","Yours: {amount} {symbol}":["Tuo: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Scivolo minimo richiesto: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Tuo: ",["userSlippage"]],"See All Routes":"Vedi Tutte Le Itinerari","View more info":"Vedi maggiori informazioni","Gas & Fee Explanation":"Spiegazione Di Gas E Commissioni","Details":"Dettagli","Total Payable Fee":"Commissioni Pagabili Totali","Hide non-payable fees":"Nascondi commissioni non pagabili","Show non-payable fees":"Mostra commissioni non pagabili","Description":"Descrizione","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Le seguenti commissioni sono prese in considerazione nell\'output della transazione e\\n                non sar\xe0 necessario pagare gas extra per loro.","Swap input":"Swap input","Estimated output":"Risultato stimato","Via:":"Via:","Chains:":"Catene:","Sort by":"Ordina per","Smart Routing":"Routing Intelligente","Lowest Fee":"Tariffa Pi\xf9 Bassa","Fastest Transfer":"Trasferimento Pi\xf9 Veloce","Maximum Return":"Ritorno Massimo","Maximum Output":"Output Massimo","Swapping":"Swapping","Gas cost":"Costo del gas","Receiving":"Ricezione","Price impact":"Impatto sui prezzi","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\xc8 necessario aumentare lo slittamento ad almeno ",["minRequiredSlippage"]," per questo percorso."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Ti consigliamo di aumentare lo slittamento ad almeno ",["minRequiredSlippage"]," per questo percorso."],"Caution, your slippage is high.":"Attenzione, il tuo slittamento \xe8 alto.","Change":"Cambia","Change settings":"Cambia impostazioni","High slippage":"Scivolo alto","Low slippage":"Scivolo basso"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Attenzione, il tuo slippage \xe8 alto (=",["userSlippage"],"). Il tuo trade pu\xf2 essere eseguito in anticipo."],"Confirm anyway":"Conferma comunque","Something went wrong":"Qualcosa \xe8 andato storto","Something went wrong. Please refresh the app.":"Qualcosa \xe8 andato storto. Si prega di aggiornare l\'app.","Slippage tolerance per swap":"Tolleranza slippage per swap","Custom":"Personalizzato","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"La tua transazione verr\xe0 ripristinata se il prezzo cambia sfavorevolmente di pi\xf9 di questa percentuale.","Warning":"Attenzione","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Questa impostazione viene applicata ad ogni passo (ad esempio 1Inch, Thorchain, ecc.), il che significa solo che il passaggio specifico sar\xe0 invertito, non l\'intero percorso.","Swap Details":"Scambia Dettagli","Request ID":"Richiedi Id","Not found":"Non trovato","Swap with request ID = {requestId} not found.":["Scambia con ID richiesta = ",["requestId"]," non trovato."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Hai ricevuto ",["amount"]," ",["token"]," in ",["conciseAddress"]," portafoglio nella catena ",["chain"],"."],"Transaction was not sent.":"La transazione non \xe8 stata inviata.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," su ",["blockchain"]," rimane nel tuo portafoglio."],"Delete":"Elimina","Try again":"Riprova","Copied To Clipboard":"Copiato Negli Appunti","Copy Request ID":"Copia Id Richiesta","View on Rango Explorer":"Visualizza su Rango Explorer","Finished at":"Terminato il","Created at":"Creato il","View transaction":"Visualizza transazione","Connect":"Connetti","Swap Successful":"Scambia Riuscito","Transaction Failed":"Transazione Non Riuscita","Done":"Fatto","Diagnosis":"Diagnosi","See Details":"Vedi Dettagli","Cancel Swap":"Annulla Scambia","Are you sure you want to cancel this swap?":"Sei sicuro di voler annullare questo swap?","Yes, Cancel it":"S\xec, annullalo","No, Continue":"No, Continua","Delete Transaction":"Elimina Transazione","Are you sure you want to delete this swap?":"Sei sicuro di voler eliminare questo swap?","Yes, Delete it":"S\xec, eliminalo","No, Cancel":"No, Annulla","Change Network":"Cambia Rete","Network Changed":"Rete Modificata","Select Token":"Seleziona Token","Wallet Connected":"Portafoglio Connesso","Your wallet is connected, you can use it to swap.":"Il tuo portafoglio \xe8 connesso, puoi usarlo per scambiare.","Failed to Connect":"Impossibile connettersi","Your wallet is not connected. Please try again.":"Il tuo portafoglio non \xe8 connesso. Riprova.","Connecting to your wallet":"Connessione al tuo portafoglio","Click connect in your wallet popup.":"Fare clic su Connetti nel tuo portafoglio popup.","Select Derivation Path":"Seleziona Percorso Di Derivazione","In order to connect to {type}, you must first select a Derivation Path":["Per connetterti a ",["type"],", devi prima selezionare un percorso di derivazione"],"Choose Derivation Path Template":"Scegli Modello Percorso Derivazione","Enter Path":"Inserisci Percorso","Enter Index":"Inserisci Indice","Add {blockchainDisplayName} Chain":["Aggiungi Catena ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Vuoi aggiungere la catena sperimentale ",["blockchainDisplayName"]," al tuo portafoglio?"],"Please approve the experimental chain pop-up in your wallet.":"Si prega di approvare il pop-up della catena sperimentale nel portafoglio.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Catena Aggiunta"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["La catena ",["blockchainDisplayName"]," \xe8 stata aggiunta con successo al tuo portafoglio."],"Request Rejected":"Richiesta Rifiutata","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Hai rifiutato l\'aggiunta di una catena ",["blockchainDisplayName"]," al tuo portafoglio."],"Select chain types":"Seleziona tipi di catena","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Questo portafoglio supporta pi\xf9 catene. Seleziona a quale catena vuoi connetterti.","Failed Network, Please retry your swap.":"Rete fallita, riprova il tuo swap.","Please reset your liquidity sources.":"Reimposta le tue fonti di liquidit\xe0.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Hai limitato le fonti di liquidit\xe0 e questo potrebbe portare a Rango a non trovare nessuna rotta. Si prega di considerare la possibilit\xe0 di ripristinare le fonti di liquidit\xe0.","No Routes Found.":"Nessuna Rotta Trovata.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Motivi per cui Rango non ha trovato un percorso: bassa liquidit\xe0 sul token, quantit\xe0 di input molto bassa o nessun percorso disponibile per la combinazione di token input/output selezionata.","Bridge Limit Error: Please increase your amount.":"Errore limite ponte: aumenta il tuo importo.","Bridge Limit Error: Please decrease your amount.":"Errore limite ponte: si prega di diminuire l\'importo.","High Price Impact":"Impatto Ad Alto Prezzo","Price impact is too high!":"L\'impatto sui prezzi \xe8 troppo alto!","The price impact is significantly higher than the allowed amount.":"L\u2019impatto sui prezzi \xe8 significativamente superiore all\u2019importo consentito.","Confirm high price impact":"Conferma un impatto sui prezzi elevato","Route updated and price impact is too high, try again later!":"Percorso aggiornato e impatto prezzo \xe8 troppo alto, riprova pi\xf9 tardi!","USD Price Unknown":"Prezzo USD Sconosciuto","USD Price Unknown, Cannot calculate Price Impact.":"USD Prezzo Sconosciuto, non \xe8 possibile calcolare il prezzo impatto.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?","Confirm USD Price Unknown":"Conferma Il Prezzo Usd Sconosciuto","Swap":"Scambia","Swap anyway":"Scambia comunque","The route goes through Ethereum. Continue?":"Il percorso passa attraverso Ethereum. Continuare?","Route has been updated.":"Il percorso \xe8 stato aggiornato.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Importo output cambiato in ",["newOutputAmount"]," (",["percentageChange"],"% cambio)."],"Route swappers has been updated.":"Gli swappers del percorso sono stati aggiornati.","Route internal coins has been updated.":"Il percorso delle monete interne \xe8 stato aggiornato.","Routes":"Itinerari","From":"Da","To":"A","Light":"Chiaro","Dark":"Scuro","Auto":"Automatico","Loading failed":"Caricamento fallito","Bridges":"Ponti","Exchanges":"Scambi","Custom Tokens":"Token Personalizzati","Language":"Lingua","Infinite approval":"Approvazione infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Abilitando la modalit\xe0 \'Approvazione infinita\' si concede l\'accesso illimitato agli smart contract sottostanti, consentendo loro di utilizzare l\'importo del token approvato senza limitazioni.","Theme":"Tema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"L\'indirizzo inserito \xe8 duplicato, inserisci un nuovo indirizzo.","Token Already Exists":"Token Esiste Gi\xe0","There\'s no need to add this token again because it already exists and is supported by us.":"Non c\'\xe8 bisogno di aggiungere questo token di nuovo perch\xe9 esiste gi\xe0 ed \xe8 supportato da noi.","Token Not Found":"Token Non Trovato","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Siamo spiacenti, nessun token \xe8 stato trovato sulla catena ",["blockchain"]," con l\'indirizzo fornito. Assicurati di aver inserito l\'indirizzo del token giusto."],"Network Error":"Errore Di Rete","Add Custom Token":"Aggiungi Token Personalizzato","Select chain":"Seleziona catena","Enter Address":"Inserisci Indirizzo","Enter token address":"Inserisci indirizzo token","Failed Network, Please retry.":"Rete non riuscita, riprova.","Add another custom token":"Aggiungi un altro token personalizzato","Confirm Swap":"Conferma Scambio","Start Swap":"Inizia Scambia","You get":"Si ottiene","Search Token":"Token Di Ricerca","No custom tokens":"Nessun token personalizzato","press the button to add your custom token":"premi il pulsante per aggiungere il tuo token personalizzato","Delete Custom Token":"Elimina Token Personalizzato","Are you sure you want to Delete this Token?":"Sei sicuro di voler eliminare questo Token?","Complete":"Complete","Running":"Esecuzione","Failed":"Fallito","Clear":"Pulisci","Search Transaction":"Ricerca Transazione","No transactions":"Nessuna transazione","Your transaction history is stored locally and will appear here after you start a swap":"La cronologia delle transazioni \xe8 memorizzata localmente e apparir\xe0 qui dopo aver avviato uno swap","Clear Transaction History":"Cancella Cronologia Transazioni","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Procedere rimuover\xe0 dal widget tutte le transazioni fallite e non riuscite. Vuoi continuare?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Nota: Questo non cancella la cronologia delle transazioni nella catena; le rimuove solo qui.","Yes, Clear the history":"S\xec, Cancella la cronologia","language":"lingua","Deselect all":"Deseleziona tutto","Select all":"Seleziona tutto","Search {sourceType}":["Cerca ",["sourceType"]],"Search Chain":"Catena Di Ricerca","Source":"Fonte","Destination":"Destinazione","Swap {type}":["Scambia ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Attualmente, sei in modalit\xe0 campagna con restrizioni sulle fonti di liquidit\xe0. Vuoi disattivare questa modalit\xe0 e utilizzare tutte le fonti di liquidit\xe0 disponibili?","The request ID is necessary to display the swap details.":"L\'ID della richiesta \xe8 necessario per visualizzare i dettagli dello swap.","Connect Wallets":"Collega Portafogli","Choose a wallet to connect.":"Scegli un portafoglio da collegare.","This week":"Questa settimana","This month":"Questo mese","This year":"Quest\'anno","Required: >= {min} {symbol}":["Richiesto: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Richiesto: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Richiesto: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Richiesto: < ",["max"]," ",["symbol"]]," for network fee":" per commissione di rete"," for swap":" per swap"," for input and network fee":" per input e canone di rete","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Servono \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", ma hai ",["currentAmount"]," ",["symbol"]," nel tuo portafoglio ",["blockchain"]," ."],"Waiting for connecting wallet":"In attesa della connessione del portafoglio","Waiting for other running tasks to be finished":"In attesa che altre attivit\xe0 in esecuzione siano terminate","Waiting for changing wallet network":"In attesa di cambiare la rete del portafoglio","Sunday":"Domenica","Monday":"Luned\xec","Tuesday":"Marted\xec","Wednesday":"Mercoled\xec","Thursday":"Gioved\xec","Friday":"Venerd\xec","Saturday":"Sabato","Powered By":"Powered By","Aggregated Transaction":"Transazione Aggregata","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Scambia su ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bridge to ",["toChain"]," via ",["swapper"]],"Completed":"Completato","In progress":"In corso","Waiting for bridge transaction":"In attesa di transazione bridge","Connected":"Connesso","Disconnect":"Disconnetti","Install":"Installa","Connecting ...":"Connessione...","Connecting":"Connessione","Disconnected":"Disconnesso","you need to pass a correct state to Wallet.":"devi passare uno stato corretto a Wallet.","There are no notifications.":"Non ci sono notifiche.","Clear all":"Cancella tutto","Balance":"Saldo","Max":"Max"}');


/*eslint-disable*/ const $d478e065bd8fe83e$export$defe85febe8b728c = JSON.parse('{"No results found":"\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","Try using different keywords":"\u5225\u306E\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044","Select Chain":"\u30C1\u30A7\u30FC\u30F3\u3092\u9078\u629E","All":"\u3059\u3079\u3066","More +{count}":["\u305D\u306E\u4ED6 +",["count"]],"Activate this tab":"\u3053\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B","Another tab is open and handles transactions.":"\u5225\u306E\u30BF\u30D6\u306F\u30AA\u30FC\u30D7\u30F3\u3067\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u51E6\u7406\u3057\u307E\u3059\u3002","Activate current tab":"\u73FE\u5728\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u73FE\u5728\u3001\u4E00\u90E8\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u5B9F\u884C\u3055\u308C\u3001\u4ED6\u306E\u30D6\u30E9\u30A6\u30B6\u30BF\u30D6\u3067\u51E6\u7406\u3055\u308C\u3066\u3044\u307E\u3059\u3002 \u3053\u306E\u30BF\u30D6\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u3059\u3067\u306B\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u8A18\u53F7\u306E\u30B9\u30C6\u30C3\u30D7\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3059\u3002","Confirm":"\u78BA\u8A8D\u3059\u308B","Your {blockchainName} wallets":["\u3042\u306A\u305F\u306E ",["blockchainName"]," \u30A6\u30A9\u30EC\u30C3\u30C8"],"Insufficient account balance":"\u30A2\u30AB\u30A6\u30F3\u30C8\u6B8B\u9AD8\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059","Proceed anyway":"\u3068\u306B\u304B\u304F\u7D9A\u884C\u3059\u308B","You need to connect a {blockchainName} wallet.":[["blockchainName"]," \u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"],"Add {chain} chain":[["chain"]," \u30C1\u30A7\u30FC\u30F3\u3092\u8FFD\u52A0"],"Show more wallets":"\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u3082\u3063\u3068\u8868\u793A","Send to a different address":"\u5225\u306E\u30A2\u30C9\u30EC\u30B9\u306B\u9001\u308B","Enter {blockchainName} address":[["blockchainName"]," \u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u30A2\u30C9\u30EC\u30B9 ",["destination"]," \u306F\u30D6\u30ED\u30C3\u30AF\u30C1\u30A7\u30FC\u30F3\u30A2\u30C9\u30EC\u30B9\u30D1\u30BF\u30FC\u30F3\u3068\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002"],"via":"\u7D4C\u7531:","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30C8\u30FC\u30AF\u30F3\u30EA\u30B9\u30C8\u306B\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002\u3053\u308C\u304C\u53D6\u5F15\u3057\u305F\u3044\u30C8\u30FC\u30AF\u30F3\u3067\u3042\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Import":"\u30A4\u30F3\u30DD\u30FC\u30C8","Status":"\u30B9\u30C6\u30FC\u30BF\u30B9","Reset":"Reset","Cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","Refresh":"\u66F4\u65B0","Notifications":"\u901A\u77E5","Settings":"\u8A2D\u5B9A","History":"\u6CBF\u9769","Connect Wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A","Today":"\u4ECA\u65E5","Swaps steps":"\u30B9\u30C6\u30C3\u30D7\u3092\u5165\u308C\u66FF\u3048\u307E\u3059","Retry":"\u518D\u8A66\u884C\u3059\u308B","Slippage Error":"\u30B9\u30E9\u30A4\u30C9\u30DA\u30FC\u30B8\u30A8\u30E9\u30FC","Slippage Warning":"\u6ED1\u308A\u6B62\u3081\u306E\u8B66\u544A","Bridge Limit Error":"\u30D6\u30EA\u30C3\u30B8\u5236\u9650\u30A8\u30E9\u30FC","Yours: {amount} {symbol}":["\u3042\u306A\u305F\u306E: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u6700\u5C0F\u5FC5\u8981\u306A\u30B9\u30EA\u30C3\u30D7: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u3042\u306A\u305F\u306E: ",["userSlippage"]],"See All Routes":"\u3059\u3079\u3066\u306E\u30EB\u30FC\u30C8\u3092\u898B\u308B","View more info":"\u8A73\u7D30\u60C5\u5831\u3092\u8868\u793A","Gas & Fee Explanation":"\u30AC\u30B9&\u6599\u91D1\u306E\u8AAC\u660E","Details":"\u8A73\u7D30","Total Payable Fee":"\u5408\u8A08\u652F\u6255\u624B\u6570\u6599","Hide non-payable fees":"\u652F\u6255\u3044\u4E0D\u53EF\u80FD\u306A\u624B\u6570\u6599\u3092\u975E\u8868\u793A","Show non-payable fees":"\u672A\u6255\u3044\u624B\u6570\u6599\u3092\u8868\u793A","Description":"\u8AAC\u660E","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u4EE5\u4E0B\u306E\u624B\u6570\u6599\u306F\u53D6\u5F15\u306E\u51FA\u529B\u3067\u8003\u616E\u3055\u308C\u3001\\n                \u4F59\u5206\u306A\u30AC\u30B9\u3092\u652F\u6255\u3046\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Swap input":"Swap input","Estimated output":"\u63A8\u5B9A\u3055\u308C\u305F\u51FA\u529B","Via:":"\u30D3\u30A2:","Chains:":"\u30C1\u30A7\u30FC\u30F3:","Sort by":"\u4E26\u3073\u66FF\u3048","Smart Routing":"\u30B9\u30DE\u30FC\u30C8\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0","Lowest Fee":"\u6700\u4F4E\u624B\u6570\u6599","Fastest Transfer":"\u6700\u901F\u9001\u91D1","Maximum Return":"\u6700\u5927\u8FD4\u54C1\u6570","Maximum Output":"\u6700\u5927\u51FA\u529B","Swapping":"Swapping","Gas cost":"\u30AC\u30B9\u30B3\u30B9\u30C8","Receiving":"\u53D7\u4FE1\u4E2D","Price impact":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u3053\u306E\u30EB\u30FC\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u5C11\u306A\u304F\u3068\u3082 ",["minRequiredSlippage"]," \u307E\u3067\u6ED1\u308A\u3084\u3059\u304F\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u3053\u306E\u30EB\u30FC\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u5C11\u306A\u304F\u3068\u3082 ",["minRequiredSlippage"]," \u3078\u306E\u6ED1\u308A\u3092\u5897\u3084\u3059\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"],"Caution, your slippage is high.":"\u6CE8\u610F\u3001\u3042\u306A\u305F\u306E\u6ED1\u308A\u306F\u9AD8\u3044\u3067\u3059\u3002","Change":"\u5909\u66F4","Change settings":"\u8A2D\u5B9A\u306E\u5909\u66F4","High slippage":"\u30CF\u30A4\u30B9\u30EA\u30C3\u30D7\u30DA\u30FC\u30B8","Low slippage":"\u3059\u3079\u308A\u4F4E\u3044\u9806"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u6CE8\u610F\u3001\u3042\u306A\u305F\u306E\u6ED1\u308A\u304C\u9AD8\u3044\u3067\u3059 (=",["userSlippage"],"). \u3042\u306A\u305F\u306E\u53D6\u5F15\u306F\u3001\u524D\u6255\u3044\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"],"Confirm anyway":"\u78BA\u8A8D\u3059\u308B","Something went wrong":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F","Something went wrong. Please refresh the app.":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30A2\u30D7\u30EA\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Slippage tolerance per swap":"\u30B9\u30EF\u30C3\u30D7\u3054\u3068\u306E\u6ED1\u308A\u6B62\u3081\u8A31\u5BB9\u5DEE","Custom":"\u30AB\u30B9\u30BF\u30E0","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u4FA1\u683C\u304C\u3053\u306E\u30D1\u30FC\u30BB\u30F3\u30C6\u30FC\u30B8\u3088\u308A\u3082\u4E0D\u5229\u306B\u5909\u66F4\u3055\u308C\u305F\u5834\u5408\u3001\u53D6\u5F15\u306F\u5143\u306B\u623B\u3055\u308C\u307E\u3059\u3002","Warning":"\u8B66\u544A","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u3053\u306E\u8A2D\u5B9A\u306F\u5404\u30B9\u30C6\u30C3\u30D7\u306B\u9069\u7528\u3055\u308C\u307E\u3059 (\u4F8B: 1Inch\u3001Thorchain\u306A\u3069)\u3002 \u3053\u308C\u306F\u3001\u7279\u5B9A\u306E\u30B9\u30C6\u30C3\u30D7\u304C\u30EB\u30FC\u30C8\u5168\u4F53\u3067\u306F\u306A\u304F\u3001\u5143\u306B\u623B\u3055\u308C\u308B\u3053\u3068\u3092\u610F\u5473\u3057\u307E\u3059\u3002","Swap Details":"\u30B9\u30EF\u30C3\u30D7\u306E\u8A73\u7D30","Request ID":"\u8981\u6C42ID","Not found":"\u898B\u3064\u304B\u308A\u307E\u305B\u3093","Swap with request ID = {requestId} not found.":["\u30EA\u30AF\u30A8\u30B9\u30C8 ID = ",["requestId"]," \u3067\u30B9\u30EF\u30C3\u30D7\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":[["amount"]," \u30C1\u30A7\u30FC\u30F3\u306E ",["token"]," \u30A6\u30A9\u30EC\u30C3\u30C8\u3067 ",["conciseAddress"]," ",["chain"]," Anamed@@4 \u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u305F\u3002"],"Transaction was not sent.":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u306F\u9001\u4FE1\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F\u3002","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," \u306E ",["symbol"]," ",["blockchain"]," \u306F\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u6B8B\u308A\u307E\u3059\u3002"],"Delete":"\u524A\u9664","Try again":"\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044","Copied To Clipboard":"\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F","Copy Request ID":"\u30EA\u30AF\u30A8\u30B9\u30C8ID\u3092\u30B3\u30D4\u30FC","View on Rango Explorer":"Rango\u30A8\u30AF\u30B9\u30D7\u30ED\u30FC\u30E9\u30FC\u3067\u8868\u793A","Finished at":"\u7D42\u4E86\u65E5\u6642","Created at":"\u4F5C\u6210\u65E5\u6642","View transaction":"\u53D6\u5F15\u3092\u8868\u793A","Connect":"\u63A5\u7D9A\u3059\u308B","Swap Successful":"\u4EA4\u4EE3\u6210\u529F","Transaction Failed":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u5931\u6557","Done":"\u5B8C\u4E86","Diagnosis":"\u8A3A\u65AD","See Details":"\u8A73\u7D30\u3092\u898B\u308B","Cancel Swap":"\u4EA4\u63DB\u3092\u30AD\u30E3\u30F3\u30BB\u30EB","Are you sure you want to cancel this swap?":"\u3053\u306E\u30B9\u30EF\u30C3\u30D7\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Yes, Cancel it":"\u306F\u3044\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059","No, Continue":"\u3044\u3044\u3048\u3001\u7D9A\u884C\u3057\u307E\u3059","Delete Transaction":"\u53D6\u5F15\u3092\u524A\u9664","Are you sure you want to delete this swap?":"\u3053\u306E\u30B9\u30EF\u30C3\u30D7\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Yes, Delete it":"\u306F\u3044\u3001\u524A\u9664\u3057\u307E\u3059","No, Cancel":"\u3044\u3044\u3048\u3001\u30AD\u30E3\u30F3\u30BB\u30EB","Change Network":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5909\u66F4","Network Changed":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5909\u66F4\u3057\u307E\u3057\u305F","Select Token":"\u30C8\u30FC\u30AF\u30F3\u3092\u9078\u629E","Wallet Connected":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F","Your wallet is connected, you can use it to swap.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u4EA4\u63DB\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002","Failed to Connect":"\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F","Your wallet is not connected. Please try again.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3082\u3046\u4E00\u5EA6\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Connecting to your wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u4E2D","Click connect in your wallet popup.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u3067format@@0\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002","Select Derivation Path":"\u6D3E\u751F\u30D1\u30B9\u306E\u9078\u629E","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\u306B\u63A5\u7D9A\u3059\u308B\u306B\u306F\u3001\u5148\u306B\u6D3E\u751F\u30D1\u30B9\u3092\u9078\u629E\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059"],"Choose Derivation Path Template":"\u6D3E\u751F\u30D1\u30B9\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u9078\u629E","Enter Path":"\u30D1\u30B9\u3092\u5165\u529B","Enter Index":"\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9\u3092\u5165\u529B","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u3092\u8FFD\u52A0"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":[["blockchainDisplayName"]," \u5B9F\u9A13\u30C1\u30A7\u30FC\u30F3\u3092\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8FFD\u52A0\u3057\u307E\u3059\u304B\uFF1F"],"Please approve the experimental chain pop-up in your wallet.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u5B9F\u9A13\u7684\u306A\u9023\u9396\u30DD\u30C3\u30D7\u30A2\u30C3\u30D7\u3092\u627F\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u304C\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002"],"Request Rejected":"\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":[["blockchainDisplayName"]," \u30C1\u30A7\u30FC\u30F3\u3092\u3042\u306A\u305F\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u8FFD\u52A0\u3059\u308B\u3053\u3068\u3092\u62D2\u5426\u3057\u307E\u3057\u305F\u3002"],"Select chain types":"\u30C1\u30A7\u30FC\u30F3\u30BF\u30A4\u30D7\u3092\u9078\u629E","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u3053\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u8907\u6570\u306E\u30C1\u30A7\u30FC\u30F3\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002\u63A5\u7D9A\u3057\u305F\u3044\u30C1\u30A7\u30FC\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Failed Network, Please retry your swap.":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30B9\u30EF\u30C3\u30D7\u3092\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Please reset your liquidity sources.":"\u6D41\u52D5\u6027\u60C5\u5831\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u6D41\u52D5\u6027\u6E90\u304C\u5236\u9650\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001Rango\u306B\u30EB\u30FC\u30C8\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u6D41\u52D5\u6027\u6E90\u306E\u30EA\u30BB\u30C3\u30C8\u3092\u691C\u8A0E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","No Routes Found.":"\u30EB\u30FC\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango\u304C\u30EB\u30FC\u30C8\u3092\u898B\u3064\u3051\u3089\u308C\u306A\u304B\u3063\u305F\u7406\u7531: \u30C8\u30FC\u30AF\u30F3\u306E\u6D41\u52D5\u6027\u304C\u4F4E\u304F\u3001\u975E\u5E38\u306B\u4F4E\u3044\u5165\u529B\u91CF\u3001\u307E\u305F\u306F\u9078\u629E\u3055\u308C\u305F\u5165\u529B/\u51FA\u529B\u30C8\u30FC\u30AF\u30F3\u306E\u7D44\u307F\u5408\u308F\u305B\u3067\u5229\u7528\u53EF\u80FD\u306A\u30EB\u30FC\u30C8\u304C\u3042\u308A\u307E\u305B\u3093\u3002","Bridge Limit Error: Please increase your amount.":"\u30D6\u30EA\u30C3\u30B8\u5236\u9650\u30A8\u30E9\u30FC: \u91D1\u984D\u3092\u5897\u3084\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Bridge Limit Error: Please decrease your amount.":"\u30D6\u30EA\u30C3\u30B8\u5236\u9650\u30A8\u30E9\u30FC: \u91D1\u984D\u3092\u6E1B\u3089\u3057\u3066\u304F\u3060\u3055\u3044\u3002","High Price Impact":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF","Price impact is too high!":"\u4FA1\u683C\u306E\u5F71\u97FF\u304C\u9AD8\u3059\u304E\u307E\u3059!","The price impact is significantly higher than the allowed amount.":"\u4FA1\u683C\u3078\u306E\u5F71\u97FF\u306F\u3001\u8A31\u5BB9\u984D\u3088\u308A\u3082\u5927\u5E45\u306B\u9AD8\u304F\u306A\u308A\u307E\u3059\u3002","Confirm high price impact":"\u9AD8\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u78BA\u8A8D\u3059\u308B","Route updated and price impact is too high, try again later!":"\u30EB\u30FC\u30C8\u306E\u66F4\u65B0\u3068\u4FA1\u683C\u3078\u306E\u5F71\u97FF\u304C\u9AD8\u3059\u304E\u307E\u3059\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01","USD Price Unknown":"USD\u4FA1\u683C\u4E0D\u660E","USD Price Unknown, Cannot calculate Price Impact.":"USD\u4FA1\u683C\u304C\u4E0D\u660E\u3067\u3059\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u8A08\u7B97\u3067\u304D\u307E\u305B\u3093\u3002","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD\u4FA1\u683C\u304C\u4E0D\u660E\u3067\u3059\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u3092\u8A08\u7B97\u3067\u304D\u307E\u305B\u3093\u3002\u4FA1\u683C\u306E\u5F71\u97FF\u306F\u901A\u5E38\u3088\u308A\u3082\u9AD8\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u30B9\u30EF\u30C3\u30D7\u3092\u7D9A\u884C\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Confirm USD Price Unknown":"\u4E0D\u660E\u306AUSD\u4FA1\u683C\u3092\u78BA\u8A8D","Swap":"\u5165\u308C\u66FF\u3048","Swap anyway":"\u3068\u306B\u304B\u304F\u5165\u308C\u66FF\u3048","The route goes through Ethereum. Continue?":"\u30EB\u30FC\u30C8\u306FEthereum\u3092\u901A\u904E\u3057\u307E\u3059\u3002\u7D9A\u884C\u3057\u307E\u3059\u304B\uFF1F","Route has been updated.":"\u30EB\u30FC\u30C8\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u51FA\u529B\u91CF\u304C ",["newOutputAmount"]," \u306B\u5909\u66F4\u3055\u308C\u307E\u3057\u305F(",["percentageChange"],"%\u5909\u66F4)\u3002"],"Route swappers has been updated.":"\u30EB\u30FC\u30C8\u30B9\u30EF\u30C3\u30D1\u30FC\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F\u3002","Route internal coins has been updated.":"\u30EB\u30FC\u30C8\u5185\u90E8\u30B3\u30A4\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","Routes":"\u30EB\u30FC\u30C8","From":"\u5DEE\u51FA\u4EBA:","To":"\u7D42\u4E86\u65E5","Light":"\u30E9\u30A4\u30C8","Dark":"\u30C0\u30FC\u30AF","Auto":"\u81EA\u52D5","Loading failed":"\u8AAD\u307F\u8FBC\u307F\u306B\u5931\u6557\u3057\u307E\u3057\u305F","Bridges":"\u30D6\u30EA\u30C3\u30B8","Exchanges":"\u4EA4\u63DB","Custom Tokens":"\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3","Language":"\u8A00\u8A9E","Infinite approval":"\u6C38\u4E45\u627F\u8A8D","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u300C\u7121\u9650\u627F\u8A8D\u300D\u30E2\u30FC\u30C9\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u57FA\u76E4\u3068\u306A\u308B\u30B9\u30DE\u30FC\u30C8\u30B3\u30F3\u30C8\u30E9\u30AF\u30C8\u3078\u306E\u7121\u5236\u9650\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u8A31\u53EF\u3055\u308C\u3001\u627F\u8A8D\u3055\u308C\u305F\u30C8\u30FC\u30AF\u30F3\u306E\u91CF\u3092\u5236\u9650\u306A\u304F\u5229\u7528\u3067\u304D\u307E\u3059\u3002","Theme":"\u30C6\u30FC\u30DE","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"\u5165\u529B\u3057\u305F\u30A2\u30C9\u30EC\u30B9\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059\u3002\u65B0\u3057\u3044\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Token Already Exists":"\u30C8\u30FC\u30AF\u30F3\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059","There\'s no need to add this token again because it already exists and is supported by us.":"\u3059\u3067\u306B\u5B58\u5728\u3057\u3001\u79C1\u305F\u3061\u304C\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u3082\u3046\u4E00\u5EA6\u8FFD\u52A0\u3059\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Token Not Found":"\u30C8\u30FC\u30AF\u30F3\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u304C\u3001\u6307\u5B9A\u3055\u308C\u305F\u30A2\u30C9\u30EC\u30B9\u306E ",["blockchain"]," \u30C1\u30A7\u30FC\u30F3\u3067\u30C8\u30FC\u30AF\u30F3\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u6B63\u3057\u3044\u30C8\u30FC\u30AF\u30F3\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002"],"Network Error":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30A8\u30E9\u30FC","Add Custom Token":"\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3\u3092\u8FFD\u52A0","Select chain":"\u30C1\u30A7\u30FC\u30F3\u3092\u9078\u629E","Enter Address":"\u4F4F\u6240\u3092\u5165\u529B","Enter token address":"\u30C8\u30FC\u30AF\u30F3\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","Failed Network, Please retry.":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","Add another custom token":"\u5225\u306E\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3\u3092\u8FFD\u52A0","Confirm Swap":"\u30B9\u30EF\u30C3\u30D7\u306E\u78BA\u8A8D","Start Swap":"\u30B9\u30EF\u30C3\u30D7\u3092\u958B\u59CB","You get":"\u3042\u306A\u305F\u306F","Search Token":"\u30C8\u30FC\u30AF\u30F3\u3092\u691C\u7D22","No custom tokens":"\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3\u306F\u3042\u308A\u307E\u305B\u3093","press the button to add your custom token":"\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3\u3092\u8FFD\u52A0\u3059\u308B\u306B\u306F\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044","Delete Custom Token":"\u30AB\u30B9\u30BF\u30E0\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664","Are you sure you want to Delete this Token?":"\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","Complete":"Complete","Running":"\u5B9F\u884C\u4E2D","Failed":"\u5931\u6557\u3057\u307E\u3057\u305F","Clear":"\u30AF\u30EA\u30A2","Search Transaction":"\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u691C\u7D22","No transactions":"\u53D6\u5F15\u304C\u3042\u308A\u307E\u305B\u3093","Your transaction history is stored locally and will appear here after you start a swap":"\u53D6\u5F15\u5C65\u6B74\u306F\u30ED\u30FC\u30AB\u30EB\u306B\u4FDD\u5B58\u3055\u308C\u3001\u30B9\u30EF\u30C3\u30D7\u3092\u958B\u59CB\u3059\u308B\u3068\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059","Clear Transaction History":"\u53D6\u5F15\u5C65\u6B74\u3092\u6D88\u53BB","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u7D9A\u884C\u3059\u308B\u3068\u3001\u6210\u529F\u3057\u305F\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3068\u5931\u6557\u3057\u305F\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002\u7D9A\u884C\u3057\u307E\u3059\u304B\uFF1F","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u6CE8:\u30C1\u30A7\u30FC\u30F3\u4E0A\u306E\u53D6\u5F15\u5C65\u6B74\u306F\u6D88\u53BB\u3055\u308C\u307E\u305B\u3093\u3002\u3053\u3053\u3067\u306E\u307F\u524A\u9664\u3055\u308C\u307E\u3059\u3002","Yes, Clear the history":"\u306F\u3044\u3001\u5C65\u6B74\u3092\u6D88\u53BB\u3057\u307E\u3059","language":"\u8A00\u8A9E","Deselect all":"\u3059\u3079\u3066\u306E\u9078\u629E\u3092\u89E3\u9664","Select all":"\u3059\u3079\u3066\u9078\u629E","Search {sourceType}":[["sourceType"]," \u3092\u691C\u7D22"],"Search Chain":"\u691C\u7D22\u30C1\u30A7\u30FC\u30F3","Source":"\u30BD\u30FC\u30B9","Destination":"\u4FDD\u5B58\u5148","Swap {type}":[["type"]," \u3092\u5165\u308C\u66FF\u3048"],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u73FE\u5728\u3001\u6D41\u52D5\u6027\u60C5\u5831\u6E90\u306B\u5236\u9650\u304C\u3042\u308B\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u30E2\u30FC\u30C9\u3067\u3059\u3002 \u3053\u306E\u30E2\u30FC\u30C9\u3092\u5207\u308A\u66FF\u3048\u3066\u3001\u5229\u7528\u53EF\u80FD\u306A\u3059\u3079\u3066\u306E\u6D41\u52D5\u6027\u6E90\u3092\u4F7F\u7528\u3057\u307E\u3059\u304B\uFF1F","The request ID is necessary to display the swap details.":"\u30B9\u30EF\u30C3\u30D7\u306E\u8A73\u7D30\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u30EA\u30AF\u30A8\u30B9\u30C8 ID \u304C\u5FC5\u8981\u3067\u3059\u3002","Connect Wallets":"\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A","Choose a wallet to connect.":"\u63A5\u7D9A\u3059\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002","This week":"\u4ECA\u9031\u4E2D","This month":"\u4ECA\u6708\u306E","This year":"\u5E74","Required: >= {min} {symbol}":["\u5FC5\u9808\uFF1A>= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u5FC5\u9808: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u5FC5\u9808: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u5FC5\u9808: < ",["max"]," ",["symbol"]]," for network fee":" \u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u6599\u91D1\u3067"," for swap":" \u30B9\u30EF\u30C3\u30D7\u7528"," for input and network fee":" \u5165\u529B\u3068\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u6599\u91D1\u306B\u3064\u3044\u3066","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u5FC5\u8981\u984D\u306F \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\u3067\u3059\u304C\u3001\u3042\u306A\u305F\u306E ",["blockchain"]," \u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u306F ",["currentAmount"]," ",["symbol"]," \u304C\u3042\u308A\u307E\u3059\u3002"],"Waiting for connecting wallet":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u63A5\u7D9A\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Waiting for other running tasks to be finished":"\u4ED6\u306E\u5B9F\u884C\u4E2D\u306E\u30BF\u30B9\u30AF\u304C\u5B8C\u4E86\u3059\u308B\u306E\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Waiting for changing wallet network":"\u30A6\u30A9\u30EC\u30C3\u30C8\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306E\u5909\u66F4\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Sunday":"\u65E5\u66DC\u65E5","Monday":"\u6708\u66DC\u65E5","Tuesday":"\u706B\u66DC\u65E5","Wednesday":"\u6C34\u66DC\u65E5","Thursday":"\u6728\u66DC\u65E5","Friday":"\u91D1\u66DC\u65E5","Saturday":"\u571F\u66DC\u65E5","Powered By":"Powered By","Aggregated Transaction":"\u96C6\u8A08\u53D6\u5F15","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["fromChain"]," \u3067 ",["swapper"],"\u3092\u5165\u308C\u66FF\u3048"],"Bridge to {toChain} via {swapper}":[["toChain"]," \u7D4C\u7531\u3067 ",["swapper"],"\u306B\u6A4B"],"Completed":"\u5B8C\u4E86","In progress":"\u9032\u884C\u4E2D","Waiting for bridge transaction":"\u30D6\u30EA\u30C3\u30B8\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u3092\u5F85\u3063\u3066\u3044\u307E\u3059","Connected":"\u63A5\u7D9A\u3057\u307E\u3057\u305F","Disconnect":"\u63A5\u7D9A\u3092\u89E3\u9664","Install":"\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB","Connecting ...":"\u63A5\u7D9A\u4E2D...","Connecting":"\u63A5\u7D9A\u4E2D","Disconnected":"\u5207\u65AD\u3055\u308C\u307E\u3057\u305F","you need to pass a correct state to Wallet.":"\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u6B63\u3057\u3044\u72B6\u614B\u3092\u6E21\u3059\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","There are no notifications.":"\u901A\u77E5\u306F\u3042\u308A\u307E\u305B\u3093\u3002","Clear all":"\u3059\u3079\u3066\u30AF\u30EA\u30A2","Balance":"\u6B8B\u9AD8","Max":"\u6700\u5927\u5024"}');


/*eslint-disable*/ const $f9c8288eb64e0cad$export$defe85febe8b728c = JSON.parse('{"No results found":"\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4","Try using different keywords":"\uB2E4\uB978 \uD0A4\uC6CC\uB4DC\uB97C \uC0AC\uC6A9\uD574 \uBCF4\uC138\uC694","Select Chain":"\uCCB4\uC778 \uC120\uD0DD","All":"\uBAA8\uB450","More +{count}":["\uB354 \uBCF4\uAE30 +",["count"]],"Activate this tab":"\uC774 \uD0ED\uC744 \uD65C\uC131\uD654\uD558\uC138\uC694","Another tab is open and handles transactions.":"\uB610 \uB2E4\uB978 \uD0ED\uC774 \uC5F4\uB824 \uAC70\uB798\uB97C \uCC98\uB9AC\uD569\uB2C8\uB2E4.","Activate current tab":"\uD604\uC7AC \uD0ED \uD65C\uC131\uD654","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\uD604\uC7AC \uC77C\uBD80 \uAC70\uB798\uAC00 \uC2E4\uD589 \uC911\uC774\uBA70 \uB2E4\uB978 \uBE0C\uB77C\uC6B0\uC800 \uD0ED\uC5D0\uC11C \uCC98\uB9AC\uB418\uACE0 \uC788\uC2B5\uB2C8\uB2E4. \uC774 \uD0ED\uC744 \uD65C\uC131\uD654\uD558\uBA74 \uC774\uBBF8 \uAC70\uB798 \uC11C\uBA85 \uB2E8\uACC4\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uAC70\uB798\uAC00 \uB9CC\uB8CC\uB429\uB2C8\uB2E4.","Confirm":"\uD655\uC778\uD558\uB2E4","Your {blockchainName} wallets":["\uADC0\uD558\uC758 ",["blockchainName"]," \uC9C0\uAC11"],"Insufficient account balance":"\uACC4\uC88C\uC794\uC561\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4","Proceed anyway":"\uC5B4\uCA0C\uB4E0 \uC9C4\uD589\uD558\uC138\uC694","You need to connect a {blockchainName} wallet.":[["blockchainName"]," \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD574\uC57C \uD569\uB2C8\uB2E4."],"Add {chain} chain":[["chain"]," \uCCB4\uC778 \uCD94\uAC00"],"Show more wallets":"\uB354 \uB9CE\uC740 \uC9C0\uAC11 \uBCF4\uAE30","Send to a different address":"\uB2E4\uB978 \uC8FC\uC18C\uB85C \uBCF4\uB0B4\uAE30","Enter {blockchainName} address":[["blockchainName"]," \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694"],"Address {destination} doesn\'t match the blockchain address pattern.":["\uC8FC\uC18C ",["destination"]," \uAC00 \uBE14\uB85D\uCCB4\uC778 \uC8FC\uC18C \uD328\uD134\uACFC \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."],"via":"~\uC744 \uD1B5\uD574","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\uC774 \uD1A0\uD070\uC740 \uD65C\uC131 \uD1A0\uD070 \uBAA9\uB85D\uC5D0 \uB098\uD0C0\uB098\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC774\uAC83\uC774 \uAC70\uB798\uD558\uB824\uB294 \uD1A0\uD070\uC778\uC9C0 \uD655\uC778\uD558\uC138\uC694.","Import":"\uC218\uC785","Status":"\uC0C1\uD0DC","Reset":"\uB2E4\uC2DC \uB193\uAE30","Cancel":"\uCDE8\uC18C","Refresh":"\uC0C8\uB85C \uACE0\uCE58\uB2E4","Notifications":"\uC54C\uB9BC","Settings":"\uC124\uC815","History":"\uC5ED\uC0AC","Connect Wallet":"\uC9C0\uAC11 \uC5F0\uACB0","Today":"\uC624\uB298","Swaps steps":"\uB2E8\uACC4\uB97C \uBC14\uAFC9\uB2C8\uB2E4","Retry":"\uB2E4\uC2DC \uD574 \uBCF4\uB2E4","Slippage Error":"\uBBF8\uB044\uB7EC\uC9D0 \uC624\uB958","Slippage Warning":"\uBBF8\uB044\uB7EC\uC9D0 \uACBD\uACE0","Bridge Limit Error":"\uBE0C\uB9AC\uC9C0 \uD55C\uACC4 \uC624\uB958","Yours: {amount} {symbol}":["\uB2F9\uC2E0\uC758: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\uCD5C\uC18C \uD544\uC694 \uBBF8\uB044\uB7EC\uC9D0: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\uB2F9\uC2E0\uC758: ",["userSlippage"]],"See All Routes":"\uBAA8\uB4E0 \uACBD\uB85C \uBCF4\uAE30","View more info":"\uB354 \uB9CE\uC740 \uC815\uBCF4 \uBCF4\uAE30","Gas & Fee Explanation":"\uAC00\uC2A4 \uBC0F \uC218\uC218\uB8CC \uC124\uBA85","Details":"\uC138\uBD80","Total Payable Fee":"\uCD1D \uC9C0\uBD88 \uC218\uC218\uB8CC","Hide non-payable fees":"\uC9C0\uBD88 \uBD88\uAC00\uB2A5\uD55C \uC218\uC218\uB8CC \uC228\uAE30\uAE30","Show non-payable fees":"\uC9C0\uBD88 \uBD88\uAC00\uB2A5\uD55C \uC218\uC218\uB8CC \uD45C\uC2DC","Description":"\uC124\uBA85","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\uB2E4\uC74C \uC218\uC218\uB8CC\uB294 \uAC70\uB798 \uCD9C\uB825\uC5D0 \uACE0\uB824\uB418\uBA70\\n                \uC774\uC5D0 \uB300\uD574 \uCD94\uAC00 \uAC00\uC2A4\uB97C \uC9C0\uBD88\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","Swap input":"\uC785\uB825 \uBC14\uAFB8\uAE30","Estimated output":"\uC608\uC0C1 \uCD9C\uB825","Via:":"\uC744 \uD1B5\uD574:","Chains:":"\uC1E0\uC0AC\uC2AC:","Sort by":"\uC815\uB82C \uAE30\uC900","Smart Routing":"\uC2A4\uB9C8\uD2B8 \uB77C\uC6B0\uD305","Lowest Fee":"\uAC00\uC7A5 \uB0AE\uC740 \uC218\uC218\uB8CC","Fastest Transfer":"\uAC00\uC7A5 \uBE60\uB978 \uC804\uC1A1","Maximum Return":"\uCD5C\uB300 \uC218\uC775","Maximum Output":"\uCD5C\uB300 \uCD9C\uB825","Swapping":"\uC2A4\uC640\uD551","Gas cost":"\uAC00\uC2A4 \uBE44\uC6A9","Receiving":"\uC804\uC218","Price impact":"\uAC00\uACA9 \uC601\uD5A5","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\uC774 \uACBD\uB85C\uC758 \uACBD\uC6B0 \uBBF8\uB044\uB7EC\uC9D0\uC744 \uCD5C\uC18C\uD55C ",["minRequiredSlippage"]," \uAE4C\uC9C0 \uB192\uC5EC\uC57C \uD569\uB2C8\uB2E4."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\uC774 \uACBD\uB85C\uC758 \uACBD\uC6B0 \uBBF8\uB044\uB7EC\uC9D0\uC744 \uCD5C\uC18C\uD55C ",["minRequiredSlippage"]," \uAE4C\uC9C0 \uB192\uC774\uB294 \uAC83\uC774 \uC88B\uC2B5\uB2C8\uB2E4."],"Caution, your slippage is high.":"\uC870\uC2EC\uD558\uC138\uC694, \uBBF8\uB044\uB7EC\uC9D0\uC774 \uC2EC\uD569\uB2C8\uB2E4.","Change":"\uBCC0\uD654","Change settings":"\uC124\uC815 \uBCC0\uACBD","High slippage":"\uB192\uC740 \uBBF8\uB044\uB7EC\uC9D0","Low slippage":"\uB0AE\uC740 \uBBF8\uB044\uB7EC\uC9D0"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \uC8FC\uC758\uD558\uC138\uC694, \uB2F9\uC2E0\uC758 \uC2AC\uB9AC\uD53C\uC9C0\uB294 \uB192\uC2B5\uB2C8\uB2E4(=",["userSlippage"],"). \uB2F9\uC2E0\uC758 \uAC70\uB798\uB294 \uC120\uB450\uC77C \uC218 \uC788\uC2B5\uB2C8\uB2E4."],"Confirm anyway":"\uC5B4\uCA0C\uB4E0 \uD655\uC778","Something went wrong":"\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","Something went wrong. Please refresh the app.":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC571\uC744 \uC0C8\uB85C \uACE0\uCE68\uD558\uC138\uC694.","Slippage tolerance per swap":"\uC2A4\uC651\uB2F9 \uBBF8\uB044\uB7EC\uC9D0 \uD5C8\uC6A9 \uBC94\uC704","Custom":"\uAD00\uC2B5","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\uAC00\uACA9\uC774 \uC774 \uBE44\uC728 \uC774\uC0C1 \uBD88\uB9AC\uD558\uAC8C \uBCC0\uB3D9\uB420 \uACBD\uC6B0, \uADC0\uD558\uC758 \uAC70\uB798\uB294 \uCDE8\uC18C\uB429\uB2C8\uB2E4.","Warning":"\uACBD\uACE0","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\uC774 \uC124\uC815\uC740 \uAC01 \uB2E8\uACC4(\uC608: 1\uC778\uCE58, \uD1A0\uB974\uCCB4\uC778 \uB4F1)\uC5D0 \uC801\uC6A9\uB429\uB2C8\uB2E4. \uC989, \uC804\uCCB4 \uACBD\uB85C\uAC00 \uC544\uB2CC \uD574\uB2F9 \uB2E8\uACC4\uB9CC \uB418\uB3CC\uB824\uC9D1\uB2C8\uB2E4.","Swap Details":"\uC2A4\uC651 \uC138\uBD80 \uC815\uBCF4","Request ID":"\uC694\uCCAD ID","Not found":"\uCC3E\uC744 \uC218 \uC5C6\uC74C","Swap with request ID = {requestId} not found.":["\uC694\uCCAD ID = ",["requestId"]," \uC778 \uC2A4\uC651\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":[["chain"]," \uCCB4\uC778\uC758 ",["conciseAddress"]," \uC9C0\uAC11\uC5D0\uC11C ",["amount"]," ",["token"]," \uC744 \uBC1B\uC558\uC2B5\uB2C8\uB2E4."],"Transaction was not sent.":"\uAC70\uB798\uAC00 \uC804\uC1A1\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \uC758 ",["blockchain"]," \uC774(\uAC00) \uC9C0\uAC11\uC5D0 \uB0A8\uC544 \uC788\uC2B5\uB2C8\uB2E4."],"Delete":"\uC0AD\uC81C","Try again":"\uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694","Copied To Clipboard":"\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB428","Copy Request ID":"\uBCF5\uC0AC \uC694\uCCAD ID","View on Rango Explorer":"Rango Explorer\uC5D0\uC11C \uBCF4\uAE30","Finished at":"\uC644\uB8CC\uB428","Created at":"\uC0DD\uC131\uB428","View transaction":"\uAC70\uB798 \uBCF4\uAE30","Connect":"\uC5F0\uACB0\uD558\uB2E4","Swap Successful":"\uC2A4\uC651 \uC131\uACF5","Transaction Failed":"\uAC70\uB798 \uC2E4\uD328","Done":"\uC644\uB8CC","Diagnosis":"\uC9C4\uB2E8","See Details":"\uC790\uC138\uD55C \uB0B4\uC6A9 \uBCF4\uAE30","Cancel Swap":"\uC2A4\uC651 \uCDE8\uC18C","Are you sure you want to cancel this swap?":"\uC774 \uAD50\uD658\uC744 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Yes, Cancel it":"\uB124, \uCDE8\uC18C\uD569\uB2C8\uB2E4","No, Continue":"\uC544\uB2C8\uC694, \uACC4\uC18D\uD558\uC138\uC694","Delete Transaction":"\uAC70\uB798 \uC0AD\uC81C","Are you sure you want to delete this swap?":"\uC774 \uC2A4\uC651\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Yes, Delete it":"\uB124, \uC0AD\uC81C\uD569\uB2C8\uB2E4","No, Cancel":"\uC544\uB2C8\uC694, \uCDE8\uC18C","Change Network":"\uB124\uD2B8\uC6CC\uD06C \uBCC0\uACBD","Network Changed":"\uB124\uD2B8\uC6CC\uD06C\uAC00 \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4","Select Token":"\uD1A0\uD070 \uC120\uD0DD","Wallet Connected":"\uC9C0\uAC11 \uC5F0\uACB0\uB428","Your wallet is connected, you can use it to swap.":"\uADC0\uD558\uC758 \uC9C0\uAC11\uC774 \uC5F0\uACB0\uB418\uC5C8\uC73C\uBBC0\uB85C \uC774\uB97C \uC0AC\uC6A9\uD574 \uC2A4\uC651\uC744 \uC9C4\uD589\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","Failed to Connect":"\uC5F0\uACB0\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4","Your wallet is not connected. Please try again.":"\uC9C0\uAC11\uC774 \uC5F0\uACB0\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","Connecting to your wallet":"\uC9C0\uAC11\uC5D0 \uC5F0\uACB0\uD558\uAE30","Click connect in your wallet popup.":"\uC9C0\uAC11 \uD31D\uC5C5\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD074\uB9AD\uD558\uC138\uC694.","Select Derivation Path":"\uD30C\uC0DD \uACBD\uB85C \uC120\uD0DD","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\uC5D0 \uC5F0\uACB0\uD558\uB824\uBA74 \uBA3C\uC800 \uD30C\uC0DD \uACBD\uB85C\uB97C \uC120\uD0DD\uD574\uC57C \uD569\uB2C8\uB2E4."],"Choose Derivation Path Template":"\uD30C\uC0DD \uACBD\uB85C \uD15C\uD50C\uB9BF \uC120\uD0DD","Enter Path":"\uACBD\uB85C \uC785\uB825","Enter Index":"\uC778\uB371\uC2A4\uB97C \uC785\uB825\uD558\uC138\uC694","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \uCCB4\uC778 \uCD94\uAC00"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":[["blockchainDisplayName"]," \uC2E4\uD5D8\uC801 \uCCB4\uC778\uC744 \uC9C0\uAC11\uC5D0 \uCD94\uAC00\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"],"Please approve the experimental chain pop-up in your wallet.":"\uC9C0\uAC11\uC5D0\uC11C \uC2E4\uD5D8\uC801 \uCCB4\uC778 \uD31D\uC5C5\uC744 \uC2B9\uC778\uD574 \uC8FC\uC138\uC694.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \uCCB4\uC778 \uCD94\uAC00\uB428"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \uCCB4\uC778\uC774 \uC9C0\uAC11\uC5D0 \uC131\uACF5\uC801\uC73C\uB85C \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4."],"Request Rejected":"\uC694\uCCAD \uAC70\uBD80\uB428","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\uC9C0\uAC11\uC5D0 ",["blockchainDisplayName"]," \uCCB4\uC778\uC744 \uCD94\uAC00\uD558\uB294 \uAC83\uC744 \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4."],"Select chain types":"\uCCB4\uC778 \uC720\uD615 \uC120\uD0DD","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\uC774 \uC9C0\uAC11\uC740 \uC5EC\uB7EC \uCCB4\uC778\uC744 \uC9C0\uC6D0\uD569\uB2C8\uB2E4. \uC5F0\uACB0\uD558\uB824\uB294 \uCCB4\uC778\uC744 \uC120\uD0DD\uD558\uC138\uC694.","Failed Network, Please retry your swap.":"\uB124\uD2B8\uC6CC\uD06C \uC624\uB958\uC785\uB2C8\uB2E4. \uC2A4\uC651\uC744 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.","Please reset your liquidity sources.":"\uC720\uB3D9\uC131 \uC18C\uC2A4\uB97C \uC7AC\uC124\uC815\uD574 \uC8FC\uC138\uC694.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\uC720\uB3D9\uC131 \uC18C\uC2A4\uB97C \uC81C\uD55C\uD588\uAE30 \uB54C\uBB38\uC5D0 Rango\uAC00 \uACBD\uB85C\uB97C \uCC3E\uC9C0 \uBABB\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC720\uB3D9\uC131 \uC18C\uC2A4\uB97C \uC7AC\uC124\uC815\uD558\uB294 \uAC83\uC744 \uACE0\uB824\uD574 \uBCF4\uC138\uC694.","No Routes Found.":"\uACBD\uB85C\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango\uAC00 \uACBD\uB85C\uB97C \uCC3E\uC744 \uC218 \uC5C6\uB294 \uC774\uC720\uB294 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4: \uD1A0\uD070\uC758 \uC720\uB3D9\uC131\uC774 \uB0AE\uC74C, \uC785\uB825 \uAE08\uC561\uC774 \uB9E4\uC6B0 \uB0AE\uC74C, \uC120\uD0DD\uD55C \uC785\uB825/\uCD9C\uB825 \uD1A0\uD070 \uC870\uD569\uC5D0 \uC0AC\uC6A9\uD560 \uC218 \uC788\uB294 \uACBD\uB85C\uAC00 \uC5C6\uC74C.","Bridge Limit Error: Please increase your amount.":"\uBE0C\uB9AC\uC9C0 \uD55C\uB3C4 \uC624\uB958: \uAE08\uC561\uC744 \uB298\uB824\uC8FC\uC138\uC694.","Bridge Limit Error: Please decrease your amount.":"\uBE0C\uB9AC\uC9C0 \uD55C\uB3C4 \uC624\uB958: \uAE08\uC561\uC744 \uC904\uC5EC \uC8FC\uC138\uC694.","High Price Impact":"\uB192\uC740 \uAC00\uACA9\uC758 \uC601\uD5A5","Price impact is too high!":"\uAC00\uACA9 \uC601\uD5A5\uC774 \uB108\uBB34 \uD07D\uB2C8\uB2E4!","The price impact is significantly higher than the allowed amount.":"\uAC00\uACA9\uC5D0 \uBBF8\uCE58\uB294 \uC601\uD5A5\uC774 \uD5C8\uC6A9 \uAE08\uC561\uBCF4\uB2E4 \uD6E8\uC52C \uB192\uC2B5\uB2C8\uB2E4.","Confirm high price impact":"\uB192\uC740 \uAC00\uACA9 \uC601\uD5A5 \uD655\uC778","Route updated and price impact is too high, try again later!":"\uACBD\uB85C\uAC00 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uACE0 \uAC00\uACA9 \uC601\uD5A5\uC774 \uB108\uBB34 \uD07D\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694!","USD Price Unknown":"USD \uAC00\uACA9 \uBBF8\uC0C1","USD Price Unknown, Cannot calculate Price Impact.":"USD \uAC00\uACA9\uC744 \uC54C \uC218 \uC5C6\uC73C\uBBC0\uB85C \uAC00\uACA9 \uC601\uD5A5\uC744 \uACC4\uC0B0\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \uAC00\uACA9 \uC54C \uC218 \uC5C6\uC74C, \uAC00\uACA9 \uC601\uD5A5\uC744 \uACC4\uC0B0\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uAC00\uACA9 \uC601\uD5A5\uC774 \uD3C9\uC18C\uBCF4\uB2E4 \uB354 \uB192\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC2A4\uC651\uC744 \uACC4\uC18D\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Confirm USD Price Unknown":"USD \uAC00\uACA9 \uD655\uC778 \uBD88\uBA85","Swap":"\uAD50\uD658","Swap anyway":"\uC5B4\uCA0C\uB4E0 \uBC14\uAFD4\uB77C","The route goes through Ethereum. Continue?":"\uC774 \uACBD\uB85C\uB294 Ethereum\uC744 \uD1B5\uACFC\uD569\uB2C8\uB2E4. \uACC4\uC18D\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Route has been updated.":"\uACBD\uB85C\uAC00 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\uCD9C\uB825\uB7C9\uC774 ",["newOutputAmount"]," (",["percentageChange"],"% \uBCC0\uACBD)\uC73C\uB85C \uBCC0\uACBD\uB418\uC5C8\uC2B5\uB2C8\uB2E4."],"Route swappers has been updated.":"\uACBD\uB85C \uBCC0\uACBD \uAE30\uB2A5\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","Route internal coins has been updated.":"\uACBD\uB85C \uB0B4\uBD80 \uCF54\uC778\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","Routes":"\uACBD\uB85C","From":"\uC5D0\uC11C","To":"\uC5D0\uAC8C","Light":"\uBE5B","Dark":"\uC5B4\uB450\uC6B4","Auto":"\uC790\uB3D9\uCC28","Loading failed":"\uB85C\uB529 \uC2E4\uD328","Bridges":"\uB2E4\uB9AC","Exchanges":"\uAD50\uD658","Custom Tokens":"\uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070","Language":"\uC5B8\uC5B4","Infinite approval":"\uBB34\uD55C\uD55C \uC2B9\uC778","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\'\uBB34\uD55C \uC2B9\uC778\' \uBAA8\uB4DC\uB97C \uD65C\uC131\uD654\uD558\uBA74 \uAE30\uBCF8 \uC2A4\uB9C8\uD2B8 \uACC4\uC57D\uC5D0 \uC81C\uD55C \uC5C6\uC774 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uC73C\uBBC0\uB85C \uC2B9\uC778\uB41C \uD1A0\uD070 \uAE08\uC561\uC744 \uC81C\uD55C \uC5C6\uC774 \uD65C\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","Theme":"\uC8FC\uC81C","Duplicate Token":"\uC911\uBCF5 \uD1A0\uD070","The address you entered is duplicate, please enter a new address.":"\uC785\uB825\uD558\uC2E0 \uC8FC\uC18C\uAC00 \uC911\uBCF5\uB429\uB2C8\uB2E4. \uC0C8 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694.","Token Already Exists":"\uD1A0\uD070\uC774 \uC774\uBBF8 \uC874\uC7AC\uD569\uB2C8\uB2E4","There\'s no need to add this token again because it already exists and is supported by us.":"\uC774 \uD1A0\uD070\uC740 \uC774\uBBF8 \uC874\uC7AC\uD558\uACE0 \uB2F9\uC0AC\uC5D0\uC11C \uC9C0\uC6D0\uD558\uBBC0\uB85C \uB2E4\uC2DC \uCD94\uAC00\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","Token Not Found":"\uD1A0\uD070\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uC81C\uACF5\uB41C \uC8FC\uC18C\uB85C ",["blockchain"]," \uCCB4\uC778\uC5D0\uC11C \uD1A0\uD070\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC62C\uBC14\uB978 \uD1A0\uD070 \uC8FC\uC18C\uB97C \uC785\uB825\uD588\uB294\uC9C0 \uD655\uC778\uD558\uC138\uC694."],"Network Error":"\uB124\uD2B8\uC6CC\uD06C \uC624\uB958","Add Custom Token":"\uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070 \uCD94\uAC00","Select chain":"\uCCB4\uC778 \uC120\uD0DD","Enter Address":"\uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694","Enter token address":"\uD1A0\uD070 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694","Failed Network, Please retry.":"\uB124\uD2B8\uC6CC\uD06C\uC5D0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","Add another custom token":"\uB2E4\uB978 \uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070 \uCD94\uAC00","Confirm Swap":"\uC2A4\uC651 \uD655\uC778","Start Swap":"\uC2A4\uC651 \uC2DC\uC791","You get":"\uB2F9\uC2E0\uC740 \uC5BB\uC744","Search Token":"\uAC80\uC0C9 \uD1A0\uD070","No custom tokens":"\uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070 \uC5C6\uC74C","press the button to add your custom token":"\uBC84\uD2BC\uC744 \uB20C\uB7EC \uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070\uC744 \uCD94\uAC00\uD558\uC138\uC694","Delete Custom Token":"\uC0AC\uC6A9\uC790 \uC815\uC758 \uD1A0\uD070 \uC0AD\uC81C","Are you sure you want to Delete this Token?":"\uC774 \uD1A0\uD070\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Complete":"\uC644\uBCBD\uD55C","Running":"\uB2EC\uB9AC\uAE30","Failed":"\uC2E4\uD328\uD55C","Clear":"\uBD84\uBA85\uD55C","Search Transaction":"\uAC70\uB798 \uAC80\uC0C9","No transactions":"\uAC70\uB798 \uC5C6\uC74C","Your transaction history is stored locally and will appear here after you start a swap":"\uAC70\uB798 \uB0B4\uC5ED\uC740 \uB85C\uCEEC\uC5D0 \uC800\uC7A5\uB418\uBA70 \uC2A4\uC651\uC744 \uC2DC\uC791\uD558\uBA74 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4.","Clear Transaction History":"\uAC70\uB798 \uB0B4\uC5ED \uC9C0\uC6B0\uAE30","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\uC9C4\uD589\uD558\uBA74 \uC704\uC82F\uC5D0\uC11C \uBAA8\uB4E0 \uC131\uACF5 \uBC0F \uC2E4\uD328\uD55C \uAC70\uB798\uAC00 \uC81C\uAC70\uB429\uB2C8\uB2E4. \uACC4\uC18D\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\uCC38\uACE0: \uC774\uB807\uAC8C \uD574\uB3C4 \uCCB4\uC778\uC758 \uAC70\uB798 \uB0B4\uC5ED\uC740 \uC9C0\uC6CC\uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E8\uC9C0 \uC5EC\uAE30\uC11C\uB9CC \uC0AD\uC81C\uB429\uB2C8\uB2E4.","Yes, Clear the history":"\uB124, \uAE30\uB85D\uC744 \uC9C0\uC6C1\uB2C8\uB2E4.","language":"\uC5B8\uC5B4","Deselect all":"\uBAA8\uB450 \uC120\uD0DD \uD574\uC81C","Select all":"\uBAA8\uB450 \uC120\uD0DD","Search {sourceType}":["\uAC80\uC0C9 ",["sourceType"]],"Search Chain":"\uAC80\uC0C9 \uCCB4\uC778","Source":"\uC6D0\uCC9C","Destination":"\uBAA9\uC801\uC9C0","Swap {type}":["\uC2A4\uC651 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\uD604\uC7AC \uC720\uB3D9\uC131 \uC18C\uC2A4\uC5D0 \uC81C\uD55C\uC774 \uC788\uB294 \uCEA0\uD398\uC778 \uBAA8\uB4DC\uC5D0 \uC788\uC2B5\uB2C8\uB2E4. \uC774 \uBAA8\uB4DC\uC5D0\uC11C \uC804\uD658\uD558\uC5EC \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uBAA8\uB4E0 \uC720\uB3D9\uC131 \uC18C\uC2A4\uB97C \uD65C\uC6A9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","The request ID is necessary to display the swap details.":"\uC2A4\uC651 \uC138\uBD80 \uC815\uBCF4\uB97C \uD45C\uC2DC\uD558\uB824\uBA74 \uC694\uCCAD ID\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.","Connect Wallets":"\uC9C0\uAC11 \uC5F0\uACB0","Choose a wallet to connect.":"\uC5F0\uACB0\uD560 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC138\uC694.","This week":"\uC774\uBC88 \uC8FC","This month":"\uC774\uBC88 \uB2EC","This year":"\uC62C\uD574","Required: >= {min} {symbol}":["\uD544\uC218: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\uD544\uC218: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\uD544\uC218: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\uD544\uC218: < ",["max"]," ",["symbol"]]," for network fee":" \uB124\uD2B8\uC6CC\uD06C \uC218\uC218\uB8CC"," for swap":" \uC2A4\uC651\uC744 \uC704\uD574"," for input and network fee":" \uC785\uB825 \uBC0F \uB124\uD2B8\uC6CC\uD06C \uC694\uAE08","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\uAC00 \uD544\uC694\uD55C\uB370, ",["currentAmount"]," ",["symbol"]," \uAC00 ",["blockchain"]," \uC9C0\uAC11\uC5D0 \uC788\uC2B5\uB2C8\uB2E4."],"Waiting for connecting wallet":"\uC9C0\uAC11 \uC5F0\uACB0\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC911","Waiting for other running tasks to be finished":"\uB2E4\uB978 \uC2E4\uD589 \uC911\uC778 \uC791\uC5C5\uC774 \uC644\uB8CC\uB420 \uB54C\uAE4C\uC9C0 \uAE30\uB2E4\uB9AC\uAE30","Waiting for changing wallet network":"\uC9C0\uAC11 \uB124\uD2B8\uC6CC\uD06C \uBCC0\uACBD\uC744 \uAE30\uB2E4\uB9AC\uB294 \uC911","Sunday":"\uC77C\uC694\uC77C","Monday":"\uC6D4\uC694\uC77C","Tuesday":"\uD654\uC694\uC77C","Wednesday":"\uC218\uC694\uC77C","Thursday":"\uBAA9\uC694\uC77C","Friday":"\uAE08\uC694\uC77C","Saturday":"\uD1A0\uC694\uC77C","Powered By":"\uC81C\uACF5\uC790:","Aggregated Transaction":"\uC9D1\uACC4\uB41C \uAC70\uB798","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["fromChain"]," \uC744 ",["swapper"],"\uC744 \uD1B5\uD574 \uBC14\uAFD4\uC8FC\uC138\uC694"],"Bridge to {toChain} via {swapper}":[["swapper"],"\uB97C \uACBD\uC720\uD558\uC5EC ",["toChain"]," \uB85C \uC5F0\uACB0"],"Completed":"\uC644\uC804\uD55C","In progress":"\uC9C4\uD589\uC911","Waiting for bridge transaction":"\uBE0C\uB9BF\uC9C0 \uAC70\uB798\uB97C \uAE30\uB2E4\uB9AC\uB294 \uC911","Connected":"\uC5F0\uACB0\uB428","Disconnect":"\uC5F0\uACB0 \uD574\uC81C","Install":"\uC124\uCE58\uD558\uB2E4","Connecting ...":"\uC5F0\uACB0 \uC911...","Connecting":"\uC5F0\uACB0 \uC911","Disconnected":"\uC5F0\uACB0 \uB04A\uAE40","you need to pass a correct state to Wallet.":"Wallet\uC5D0 \uC62C\uBC14\uB978 \uC0C1\uD0DC\uB97C \uC804\uB2EC\uD574\uC57C \uD569\uB2C8\uB2E4.","There are no notifications.":"\uC54C\uB9BC\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.","Clear all":"\uBAA8\uB450 \uC9C0\uC6B0\uAE30","Balance":"\uADE0\uD615","Max":"\uB9E5\uC2A4"}');


/*eslint-disable*/ const $635408662cd9c3d7$export$defe85febe8b728c = JSON.parse('{"No results found":"Rezultat\u0173 nerasta","Try using different keywords":"Pabandykite naudoti skirtingus raktinius \u017Eod\u017Eius","Select Chain":"Pasirinkite Grandin\u0117","All":"Visi","More +{count}":["Daugiau +",["count"]],"Activate this tab":"Suaktyvinkite \u0161\u012F skirtuk\u0105","Another tab is open and handles transactions.":"Kitas skirtukas atidarytas ir tvarko operacijas.","Activate current tab":"Suaktyvinti dabartin\u012F skirtuk\u0105","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0160iuo metu kai kurios operacijos vykdomos ir tvarkomos kitame nar\u0161ykl\u0117s skirtuke. Jei suaktyvinsite \u0161\u012F skirtuk\u0105, visos operacijos, kurios jau yra operacijos pasira\u0161ymo \u017Eingsnyje, baigs galioti.","Confirm":"Patvirtinti","Your {blockchainName} wallets":["J\u016Bs\u0173 ",["blockchainName"]," pinigin\u0117s"],"Insufficient account balance":"Nepakankamas s\u0105skaitos likutis","Proceed anyway":"Vis tiek t\u0119skite","You need to connect a {blockchainName} wallet.":["Turite prijungti ",["blockchainName"]," pinigin\u0119."],"Add {chain} chain":["Prid\u0117kite ",["chain"]," grandin\u0119"],"Show more wallets":"Rodyti daugiau pinigini\u0173","Send to a different address":"Si\u0173sti kitu adresu","Enter {blockchainName} address":["\u012Eveskite ",["blockchainName"]," adres\u0105"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adresas ",["destination"]," neatitinka blockchain adreso \u0161ablono."],"via":"per","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u0160is prieigos raktas nerodomas aktyvi\u0173 \u017Eeton\u0173 s\u0105ra\u0161e (-uose). \u012Esitikinkite, kad tai yra \u017Eenklas, kuriuo norite prekiauti.","Import":"Importuoti","Status":"B\u016Bsena","Reset":"Nustatyti i\u0161 naujo","Cancel":"At\u0161aukti","Refresh":"Atnaujinti","Notifications":"Prane\u0161imai","Settings":"Nustatymai","History":"Istorija","Connect Wallet":"Prijunkite Pinigin\u0119","Today":"\u0160iandien","Swaps steps":"Sukei\u010Dia \u017Eingsnius","Retry":"Bandykite dar kart\u0105","Slippage Error":"Paslydimo klaida","Slippage Warning":"Paslydimo \u012Fsp\u0117jimas","Bridge Limit Error":"Tilto ribos klaida","Yours: {amount} {symbol}":["J\u016Bs\u0173: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimalus reikalingas slydimas: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["J\u016Bs\u0173: ",["userSlippage"]],"See All Routes":"\u017Di\u016Br\u0117ti visus mar\u0161rutus","View more info":"\u017Di\u016Br\u0117ti daugiau informacijos","Gas & Fee Explanation":"Duj\u0173 ir mokes\u010Di\u0173 paai\u0161kinimas","Details":"Detal\u0117s","Total Payable Fee":"Visas mok\u0117tinas mokestis","Hide non-payable fees":"Sl\u0117pti nemokamus mokes\u010Dius","Show non-payable fees":"Rodyti nemokamus mokes\u010Dius","Description":"Apra\u0161ymas","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Toliau nurodyti mokes\u010Diai atsi\u017Evelgiama \u012F operacijos i\u0161vest\u012F ir\\n                u\u017E juos nereik\u0117s mok\u0117ti papildom\u0173 duj\u0173.","Swap input":"Sukeisti \u012Fvest\u012F","Estimated output":"Numatoma produkcija","Via:":"Per:","Chains:":"Grandin\u0117s:","Sort by":"R\u016B\u0161iuoti pagal","Smart Routing":"I\u0161manusis mar\u0161ruto parinkimas","Lowest Fee":"Ma\u017Eiausias mokestis","Fastest Transfer":"Grei\u010Diausias perk\u0117limas","Maximum Return":"Did\u017Eiausia gr\u0105\u017Ea","Maximum Output":"Maksimali i\u0161vestis","Swapping":"Keitimas","Gas cost":"Duj\u0173 kaina","Receiving":"Pri\u0117mimas","Price impact":"Kainos poveikis","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0160iam mar\u0161rutui reikia padidinti slydim\u0105 bent iki ",["minRequiredSlippage"]," ."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Rekomenduojame padidinti \u0161io mar\u0161ruto slydim\u0105 bent iki ",["minRequiredSlippage"]," ."],"Caution, your slippage is high.":"Atsargiai, j\u016Bs\u0173 paslydimas didelis.","Change":"Keisti","Change settings":"Pakeiskite nustatymus","High slippage":"Didelis slydimas","Low slippage":"Ma\u017Eas slydimas"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Atsargiai, j\u016Bs\u0173 slydimas didelis (=",["userSlippage"],"). J\u016Bs\u0173 prekyba gali b\u016Bti vykdoma i\u0161 anksto."],"Confirm anyway":"Vis tiek patvirtinkite","Something went wrong":"Ka\u017Ekas nutiko","Something went wrong. Please refresh the app.":"Ka\u017Ekas nutiko. Atnaujinkite program\u0105.","Slippage tolerance per swap":"Slydimo tolerancija vienam apsikeitimui","Custom":"Pasirinktinis","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"J\u016Bs\u0173 sandoris bus gr\u0105\u017Eintas, jei kaina nepalankiai pasikeis daugiau nei \u0161is procentas.","Warning":"\u012Esp\u0117jimas","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u0160is nustatymas taikomas kiekvienam \u017Eingsniui (pvz., 1 colis, Thorchain ir kt.), o tai rei\u0161kia, kad bus gr\u0105\u017Eintas tik konkretus \u017Eingsnis, o ne visas mar\u0161rutas.","Swap Details":"Keitimo detal\u0117s","Request ID":"Pra\u0161yti ID","Not found":"Nerasta","Swap with request ID = {requestId} not found.":["Sukeisti su u\u017Eklausos ID = ",["requestId"]," nerasta."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Gavote ",["amount"]," ",["token"]," ",["conciseAddress"]," pinigin\u0117je grandin\u0117je ",["chain"]," ."],"Transaction was not sent.":"Sandoris nebuvo i\u0161si\u0173stas.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," ",["blockchain"]," lieka j\u016Bs\u0173 pinigin\u0117je."],"Delete":"I\u0161trinti","Try again":"Bandykite dar kart\u0105","Copied To Clipboard":"Nukopijuota \u012F main\u0173 srit\u012F","Copy Request ID":"Nukopijuokite u\u017Eklausos ID","View on Rango Explorer":"\u017Di\u016Br\u0117ti Rango Explorer","Finished at":"Baigta val","Created at":"Sukurta","View transaction":"Per\u017Ei\u016Br\u0117ti operacij\u0105","Connect":"Prisijunkite","Swap Successful":"Swap s\u0117kmingas","Transaction Failed":"Sandoris nepavyko","Done":"Atlikta","Diagnosis":"Diagnoz\u0117","See Details":"\u017Dr. I\u0161sami\u0105 informacij\u0105","Cancel Swap":"At\u0161aukti apsikeitim\u0105","Are you sure you want to cancel this swap?":"Ar tikrai norite at\u0161aukti \u0161\u012F apsikeitim\u0105?","Yes, Cancel it":"Taip, at\u0161aukti","No, Continue":"Ne, T\u0119sti","Delete Transaction":"I\u0161trinti operacij\u0105","Are you sure you want to delete this swap?":"Ar tikrai norite i\u0161trinti \u0161\u012F apsikeitim\u0105?","Yes, Delete it":"Taip, i\u0161trinkite","No, Cancel":"Ne, at\u0161aukti","Change Network":"Keisti tinkl\u0105","Network Changed":"Pakeistas tinklas","Select Token":"Pasirinkite \u017Detonas","Wallet Connected":"Pinigin\u0117 prijungta","Your wallet is connected, you can use it to swap.":"J\u016Bs\u0173 pinigin\u0117 prijungta, galite j\u0105 naudoti apsikeitimui.","Failed to Connect":"Nepavyko prisijungti","Your wallet is not connected. Please try again.":"J\u016Bs\u0173 pinigin\u0117 neprijungta. Bandykite dar kart\u0105.","Connecting to your wallet":"Prisijungimas prie pinigin\u0117s","Click connect in your wallet popup.":"I\u0161\u0161okan\u010Diajame pinigin\u0117s lange spustel\u0117kite prisijungti.","Select Derivation Path":"Pasirinkite i\u0161vedimo keli\u0105","In order to connect to {type}, you must first select a Derivation Path":["Nor\u0117dami prisijungti prie ",["type"],", pirmiausia turite pasirinkti i\u0161vedimo keli\u0105"],"Choose Derivation Path Template":"Pasirinkite i\u0161vedimo kelio \u0161ablon\u0105","Enter Path":"\u012Eveskite keli\u0105","Enter Index":"\u012Eveskite indeks\u0105","Add {blockchainDisplayName} Chain":["Prid\u0117ti ",["blockchainDisplayName"]," grandin\u0119"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Ar nor\u0117tum\u0117te prid\u0117ti ",["blockchainDisplayName"]," eksperimentin\u0119 grandin\u0119 prie savo pinigin\u0117s?"],"Please approve the experimental chain pop-up in your wallet.":"Patvirtinkite eksperimentin\u0117s grandin\u0117s i\u0161\u0161okant\u012Fj\u012F lang\u0105 savo pinigin\u0117je.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Prid\u0117ta grandin\u0117"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Grandin\u0117 ",["blockchainDisplayName"]," s\u0117kmingai prid\u0117ta prie j\u016Bs\u0173 pinigin\u0117s."],"Request Rejected":"U\u017Eklausa atmesta","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["J\u016Bs atsisak\u0117te prid\u0117ti ",["blockchainDisplayName"]," grandin\u0119 prie savo pinigin\u0117s."],"Select chain types":"Pasirinkite grandin\u0117s tipus","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u0160i pinigin\u0117 palaiko kelias grandines. Pasirinkite, prie kurios grandin\u0117s norite prisijungti.","Failed Network, Please retry your swap.":"Nepavyko pakeisti tinklo. Bandykite dar kart\u0105 pakeisti.","Please reset your liquidity sources.":"I\u0161 naujo nustatykite savo likvidumo \u0161altinius.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Apribojote likvidumo \u0161altinius, tod\u0117l Rango gali nerasti mar\u0161rut\u0173. Apsvarstykite galimyb\u0119 i\u0161 naujo nustatyti savo likvidumo \u0161altinius.","No Routes Found.":"Mar\u0161rut\u0173 nerasta.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Prie\u017Eastys, kod\u0117l Rango negal\u0117jo rasti mar\u0161ruto: ma\u017Eas prieigos rakto likvidumas, labai ma\u017Eas \u012Fvesties kiekis arba n\u0117ra mar\u0161rut\u0173 pasirinktam \u012Fvesties / i\u0161vesties prieigos rakto deriniui.","Bridge Limit Error: Please increase your amount.":"Tilto limito klaida: padidinkite sum\u0105.","Bridge Limit Error: Please decrease your amount.":"Tilto limito klaida: suma\u017Einkite sum\u0105.","High Price Impact":"Didel\u0117s kainos poveikis","Price impact is too high!":"Kainos poveikis per didelis!","The price impact is significantly higher than the allowed amount.":"\u012Etaka kainai yra \u017Eymiai didesn\u0117 nei leistina suma.","Confirm high price impact":"Patvirtinkite didel\u0117s kainos poveik\u012F","Route updated and price impact is too high, try again later!":"Mar\u0161rutas atnaujintas ir kainos poveikis per didelis, bandykite dar kart\u0105 v\u0117liau!","USD Price Unknown":"USD Kaina Ne\u017Einoma","USD Price Unknown, Cannot calculate Price Impact.":"USD Kaina ne\u017Einoma, negalima apskai\u010Diuoti kainos poveikio.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Kaina ne\u017Einoma, negalima apskai\u010Diuoti kainos poveikio. Kainos poveikis gali b\u016Bti didesnis nei \u012Fprastai. Ar tikrai t\u0119site apsikeitim\u0105?","Confirm USD Price Unknown":"Patvirtinti USD Kaina ne\u017Einoma","Swap":"Sukeisti","Swap anyway":"Vistiek sukeisk","The route goes through Ethereum. Continue?":"Mar\u0161rutas eina per Ethereum. T\u0119sti?","Route has been updated.":"Mar\u0161rutas atnaujintas.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["I\u0161vesties kiekis pakeistas \u012F ",["newOutputAmount"]," (",["percentageChange"],"% pokytis)."],"Route swappers has been updated.":"Atnaujinti mar\u0161rut\u0173 keitikliai.","Route internal coins has been updated.":"Mar\u0161ruto vidin\u0117s monetos buvo atnaujintos.","Routes":"Mar\u0161rutai","From":"I\u0161","To":"\u012E","Light":"\u0160viesa","Dark":"Tamsus","Auto":"Auto","Loading failed":"\u012Ekelti nepavyko","Bridges":"Tiltai","Exchanges":"Mainai","Custom Tokens":"Pasirinktiniai \u017Eetonai","Language":"Kalba","Infinite approval":"Begalinis pritarimas","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u012Ejungus \u201EBegalinio patvirtinimo\u201C re\u017Eim\u0105, suteikiama neribota prieiga prie pagrindini\u0173 i\u0161mani\u0173j\u0173 sutar\u010Di\u0173, leid\u017Eianti joms be apribojim\u0173 naudoti patvirtint\u0105 prieigos rakto sum\u0105.","Theme":"tema","Duplicate Token":"Tokeno kopija","The address you entered is duplicate, please enter a new address.":"\u012Evestas adresas pasikartoja, \u012Fveskite nauj\u0105 adres\u0105.","Token Already Exists":"\u017Detonas jau egzistuoja","There\'s no need to add this token again because it already exists and is supported by us.":"Nereikia dar kart\u0105 prid\u0117ti \u0161io prieigos rakto, nes jis jau yra ir yra m\u016Bs\u0173 palaikomas.","Token Not Found":"\u017Detonas nerastas","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Atsipra\u0161ome, grandin\u0117je ",["blockchain"]," su nurodytu adresu \u017Eetonas nerastas. \u012Fsitikinkite, kad \u012Fved\u0117te tinkam\u0105 prieigos rakto adres\u0105."],"Network Error":"Tinklo klaida","Add Custom Token":"Prid\u0117ti pasirinktin\u012F prieigos rakt\u0105","Select chain":"Pasirinkite grandin\u0119","Enter Address":"\u012Eveskite adres\u0105","Enter token address":"\u012Eveskite \u017Eetono adres\u0105","Failed Network, Please retry.":"Nepavyko prisijungti prie tinklo, bandykite dar kart\u0105.","Add another custom token":"Prid\u0117kite kit\u0105 tinkint\u0105 prieigos rakt\u0105","Confirm Swap":"Patvirtinkite apsikeitim\u0105","Start Swap":"Prad\u0117ti Swap","You get":"J\u016Bs gaunate","Search Token":"Paie\u0161kos \u017Eenklas","No custom tokens":"N\u0117ra tinkint\u0173 \u017Eeton\u0173","press the button to add your custom token":"paspauskite mygtuk\u0105, kad prid\u0117tum\u0117te pasirinktin\u012F prieigos rakt\u0105","Delete Custom Token":"I\u0161trinkite tinkint\u0105 prieigos rakt\u0105","Are you sure you want to Delete this Token?":"Ar tikrai norite i\u0161trinti \u0161\u012F prieigos rakt\u0105?","Complete":"U\u017Ebaigti","Running":"B\u0117gimas","Failed":"Nepavyko","Clear":"Ai\u0161ku","Search Transaction":"Paie\u0161kos sandoris","No transactions":"Joki\u0173 sandori\u0173","Your transaction history is stored locally and will appear here after you start a swap":"J\u016Bs\u0173 operacij\u0173 istorija saugoma vietoje ir bus rodoma \u010Dia, kai prad\u0117site apsikeitim\u0105","Clear Transaction History":"I\u0161valyti operacij\u0173 istorij\u0105","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"T\u0119siant bus pa\u0161alintos visos s\u0117kmingos ir nepavykusios operacijos i\u0161 valdiklio. Ar norite t\u0119sti?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Pastaba: tai nei\u0161trina j\u016Bs\u0173 operacij\u0173 istorijos grandin\u0117je; tai tik pa\u0161alina juos \u010Dia.","Yes, Clear the history":"Taip, i\u0161valykite istorij\u0105","language":"kalba","Deselect all":"Panaikinkite vis\u0173 pasirinkim\u0105","Select all":"Pasirinkite visk\u0105","Search {sourceType}":["Ie\u0161koti ",["sourceType"]],"Search Chain":"Paie\u0161kos grandin\u0117","Source":"\u0160altinis","Destination":"Paskirties vieta","Swap {type}":["Sukeisti ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0160iuo metu veikiate kampanijos re\u017Eimu su apribojimais likvidumo \u0161altiniams. Ar nor\u0117tum\u0117te i\u0161jungti \u0161\u012F re\u017Eim\u0105 ir pasinaudoti visais turimais likvidumo \u0161altiniais?","The request ID is necessary to display the swap details.":"U\u017Eklausos ID b\u016Btinas norint parodyti apsikeitimo informacij\u0105.","Connect Wallets":"Prijunkite pinigines","Choose a wallet to connect.":"Pasirinkite pinigin\u0119, kuri\u0105 norite prijungti.","This week":"\u0160i\u0105 savait\u0119","This month":"\u0160\u012F m\u0117nes\u012F","This year":"\u0160iemet","Required: >= {min} {symbol}":["B\u016Btina: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["B\u016Btina: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["B\u016Btina: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["B\u016Btina: < ",["max"]," ",["symbol"]]," for network fee":" u\u017E tinklo mokest\u012F"," for swap":" u\u017E mainus"," for input and network fee":" u\u017E \u012Fvesties ir tinklo mokest\u012F","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Reikia \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", bet j\u016Bs\u0173 ",["blockchain"]," pinigin\u0117je yra ",["currentAmount"]," ",["symbol"]," ."],"Waiting for connecting wallet":"Laukiama prijungiant pinigin\u0119","Waiting for other running tasks to be finished":"Laukiama, kol bus baigtos kitos b\u0117gimo u\u017Eduotys","Waiting for changing wallet network":"Laukiama, kol bus pakeistas pinigin\u0117s tinklas","Sunday":"sekmadienis","Monday":"pirmadienis","Tuesday":"antradienis","Wednesday":"tre\u010Diadien\u012F","Thursday":"ketvirtadienis","Friday":"penktadienis","Saturday":"\u0161e\u0161tadienis","Powered By":"Maitinamas","Aggregated Transaction":"Suvestin\u0117 operacija","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Pakeiskite \u012F ",["fromChain"]," per ",["swapper"]],"Bridge to {toChain} via {swapper}":["Tiltas \u012F ",["toChain"]," per ",["swapper"]],"Completed":"U\u017Ebaigta","In progress":"Vykdoma","Waiting for bridge transaction":"Laukiama tilto sandorio","Connected":"Prisijungta","Disconnect":"Atsijungti","Install":"\u012Ediegti","Connecting ...":"Jungiamasi...","Connecting":"Prisijungimas","Disconnected":"Atjungtas","you need to pass a correct state to Wallet.":"Pinigin\u0117je turite perduoti teising\u0105 b\u016Bsen\u0105.","There are no notifications.":"Prane\u0161im\u0173 n\u0117ra.","Clear all":"I\u0161valyti visk\u0105","Balance":"Balansas","Max":"Maks"}');


/*eslint-disable*/ const $833a28f7a46ae305$export$defe85febe8b728c = JSON.parse('{"No results found":"Tiada hasil ditemui","Try using different keywords":"Cuba gunakan kata kunci yang berbeza","Select Chain":"Pilih Rantaian","All":"Semua","More +{count}":["Lagi +",["count"]],"Activate this tab":"Aktifkan tab ini","Another tab is open and handles transactions.":"Tab lain dibuka dan mengendalikan transaksi.","Activate current tab":"Aktifkan tab semasa","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Pada masa ini, beberapa transaksi sedang berjalan dan dikendalikan oleh tab penyemak imbas lain. Jika anda mengaktifkan tab ini, semua transaksi yang sudah berada dalam langkah tanda transaksi akan tamat tempoh.","Confirm":"sahkan","Your {blockchainName} wallets":["Dompet ",["blockchainName"]," anda"],"Insufficient account balance":"Baki akaun tidak mencukupi","Proceed anyway":"Teruskan juga","You need to connect a {blockchainName} wallet.":["Anda perlu menyambung dompet ",["blockchainName"]," ."],"Add {chain} chain":["Tambahkan rantai ",["chain"]],"Show more wallets":"Tunjukkan lebih banyak dompet","Send to a different address":"Hantar ke alamat lain","Enter {blockchainName} address":["Masukkan ",["blockchainName"]," alamat"],"Address {destination} doesn\'t match the blockchain address pattern.":["Alamat ",["destination"]," tidak sepadan dengan corak alamat blockchain."],"via":"melalui","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Token ini tidak muncul pada senarai token aktif. Pastikan ini adalah token yang anda ingin berdagang.","Import":"Import","Status":"Status","Reset":"Tetapkan semula","Cancel":"Batal","Refresh":"Segarkan semula","Notifications":"Pemberitahuan","Settings":"tetapan","History":"Sejarah","Connect Wallet":"Sambung Wallet","Today":"Hari ini","Swaps steps":"Bertukar langkah","Retry":"Cuba semula","Slippage Error":"Ralat Gelinciran","Slippage Warning":"Amaran Gelinciran","Bridge Limit Error":"Ralat Had Jambatan","Yours: {amount} {symbol}":["Milik anda: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Kegelinciran minimum yang diperlukan: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Milik anda: ",["userSlippage"]],"See All Routes":"Lihat Semua Laluan","View more info":"Lihat maklumat lanjut","Gas & Fee Explanation":"Penjelasan Gas & Yuran","Details":"Butiran","Total Payable Fee":"Jumlah Yuran Yang Perlu Dibayar","Hide non-payable fees":"Sembunyikan yuran yang tidak perlu dibayar","Show non-payable fees":"Tunjukkan yuran yang tidak perlu dibayar","Description":"Penerangan","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Yuran berikut dipertimbangkan dalam output transaksi dan\\n                anda tidak perlu membayar gas tambahan untuknya.","Swap input":"Tukar input","Estimated output":"Anggaran keluaran","Via:":"Melalui:","Chains:":"rantai:","Sort by":"Isih mengikut","Smart Routing":"Penghalaan Pintar","Lowest Fee":"Yuran Terendah","Fastest Transfer":"Pemindahan Terpantas","Maximum Return":"Pulangan Maksimum","Maximum Output":"Output Maksimum","Swapping":"Bertukar-tukar","Gas cost":"Kos gas","Receiving":"Menerima","Price impact":"Kesan harga","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Anda perlu meningkatkan gelinciran kepada sekurang-kurangnya ",["minRequiredSlippage"]," untuk laluan ini."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Kami mengesyorkan anda meningkatkan gelinciran kepada sekurang-kurangnya ",["minRequiredSlippage"]," untuk laluan ini."],"Caution, your slippage is high.":"Awas, gelinciran anda tinggi.","Change":"Berubah","Change settings":"Tukar tetapan","High slippage":"gelinciran tinggi","Low slippage":"gelinciran rendah"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Awas, gelinciran anda tinggi (=",["userSlippage"],"). Dagangan anda mungkin dijalankan di hadapan."],"Confirm anyway":"Confirm pula","Something went wrong":"Sesuatu telah berlaku","Something went wrong. Please refresh the app.":"Sesuatu telah berlaku. Sila muat semula apl.","Slippage tolerance per swap":"Toleransi gelinciran setiap pertukaran","Custom":"Adat","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Urus niaga anda akan dikembalikan jika harga berubah secara tidak menguntungkan lebih daripada peratusan ini.","Warning":"Amaran","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Tetapan ini digunakan pada setiap langkah (cth. 1Inch, Thorchain, dsb.), bermakna hanya langkah tertentu itu akan dibalikkan, bukan keseluruhan laluan.","Swap Details":"Swap Butiran","Request ID":"Minta ID","Not found":"Tidak dijumpai","Swap with request ID = {requestId} not found.":["Tukar dengan ID permintaan = ",["requestId"]," tidak ditemui."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Anda telah menerima ",["amount"]," ",["token"]," dalam dompet ",["conciseAddress"]," pada rantai ",["chain"]," ."],"Transaction was not sent.":"Urus niaga tidak dihantar.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," pada ",["blockchain"]," kekal dalam dompet anda."],"Delete":"Padam","Try again":"Cuba lagi","Copied To Clipboard":"Disalin Ke Papan Klip","Copy Request ID":"Salin ID Permintaan","View on Rango Explorer":"Lihat pada Rango Explorer","Finished at":"Selesai pada","Created at":"Dicipta pada","View transaction":"Lihat transaksi","Connect":"Sambung","Swap Successful":"Tukar Berjaya","Transaction Failed":"Transaksi Gagal","Done":"Selesai","Diagnosis":"Diagnosis","See Details":"Lihat Butiran","Cancel Swap":"Batalkan Swap","Are you sure you want to cancel this swap?":"Adakah anda pasti mahu membatalkan pertukaran ini?","Yes, Cancel it":"Ya, Batalkan","No, Continue":"Tidak, Teruskan","Delete Transaction":"Padamkan Transaksi","Are you sure you want to delete this swap?":"Adakah anda pasti mahu memadamkan pertukaran ini?","Yes, Delete it":"Ya, Padamkannya","No, Cancel":"Tidak, Batal","Change Network":"Tukar Rangkaian","Network Changed":"Rangkaian Berubah","Select Token":"Pilih Token","Wallet Connected":"Dompet Disambungkan","Your wallet is connected, you can use it to swap.":"Dompet anda disambungkan, anda boleh menggunakannya untuk menukar.","Failed to Connect":"Gagal Bersambung","Your wallet is not connected. Please try again.":"Dompet anda tidak disambungkan. Sila cuba lagi.","Connecting to your wallet":"Menyambung ke dompet anda","Click connect in your wallet popup.":"Klik sambung dalam pop timbul dompet anda.","Select Derivation Path":"Pilih Laluan Derivasi","In order to connect to {type}, you must first select a Derivation Path":["Untuk menyambung ke ",["type"],", anda mesti memilih Laluan Derivasi dahulu"],"Choose Derivation Path Template":"Pilih Templat Laluan Derivasi","Enter Path":"Masukkan Laluan","Enter Index":"Masukkan Indeks","Add {blockchainDisplayName} Chain":["Tambah ",["blockchainDisplayName"]," Rantaian"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Adakah anda ingin menambahkan rantaian percubaan ",["blockchainDisplayName"]," pada dompet anda?"],"Please approve the experimental chain pop-up in your wallet.":"Sila luluskan tetingkap timbul rangkaian percubaan dalam dompet anda.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Rantaian Ditambah"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Rantaian ",["blockchainDisplayName"]," telah berjaya ditambahkan pada dompet anda."],"Request Rejected":"Permintaan Ditolak","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Anda telah menolak menambah rantai ",["blockchainDisplayName"]," pada dompet anda."],"Select chain types":"Pilih jenis rantai","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Dompet ini menyokong berbilang rantai. Pilih rangkaian yang anda ingin sambungkan.","Failed Network, Please retry your swap.":"Rangkaian Gagal, Sila cuba semula pertukaran anda.","Please reset your liquidity sources.":"Sila tetapkan semula sumber kecairan anda.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Anda telah mengehadkan sumber kecairan dan ini mungkin menyebabkan Rango tidak menemui laluan. Sila pertimbangkan untuk menetapkan semula sumber kecairan anda.","No Routes Found.":"Tiada Laluan Ditemui.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Sebab Rango tidak menemui laluan: kecairan yang rendah pada token, jumlah input yang sangat rendah atau tiada laluan tersedia untuk gabungan token input/output yang dipilih.","Bridge Limit Error: Please increase your amount.":"Ralat Had Jambatan: Sila tingkatkan jumlah anda.","Bridge Limit Error: Please decrease your amount.":"Ralat Had Jambatan: Sila kurangkan jumlah anda.","High Price Impact":"Kesan Harga Tinggi","Price impact is too high!":"Kesan harga terlalu tinggi!","The price impact is significantly higher than the allowed amount.":"Kesan harga adalah jauh lebih tinggi daripada jumlah yang dibenarkan.","Confirm high price impact":"Sahkan kesan harga yang tinggi","Route updated and price impact is too high, try again later!":"Laluan dikemas kini dan impak harga terlalu tinggi, cuba sebentar lagi!","USD Price Unknown":"Harga USD Tidak Diketahui","USD Price Unknown, Cannot calculate Price Impact.":"Harga USD Tidak Diketahui, Tidak Dapat Mengira Kesan Harga.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Harga USD Tidak Diketahui, Tidak Dapat Mengira Kesan Harga. Kesan harga mungkin lebih tinggi daripada biasa. Adakah anda pasti untuk meneruskan Swap?","Confirm USD Price Unknown":"Sahkan Harga USD Tidak Diketahui","Swap":"Tukar","Swap anyway":"Tukar pula","The route goes through Ethereum. Continue?":"Laluan itu melalui Ethereum. teruskan?","Route has been updated.":"Laluan telah dikemas kini.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Amaun output ditukar kepada ",["newOutputAmount"]," (",["percentageChange"],"% perubahan)."],"Route swappers has been updated.":"Penukar laluan telah dikemas kini.","Route internal coins has been updated.":"Syiling dalaman laluan telah dikemas kini.","Routes":"Laluan","From":"daripada","To":"Kepada","Light":"Cahaya","Dark":"Gelap","Auto":"Auto","Loading failed":"Gagal memuatkan","Bridges":"Jambatan","Exchanges":"Pertukaran","Custom Tokens":"Token Tersuai","Language":"Bahasa","Infinite approval":"Kelulusan yang tidak terhingga","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Mendayakan mod \'Kelulusan tidak terhingga\' memberikan akses tanpa had kepada kontrak pintar asas, membolehkan mereka menggunakan jumlah token yang diluluskan tanpa had.","Theme":"Tema","Duplicate Token":"Token Pendua","The address you entered is duplicate, please enter a new address.":"Alamat yang anda masukkan adalah pendua, sila masukkan alamat baharu.","Token Already Exists":"Token Sudah Wujud","There\'s no need to add this token again because it already exists and is supported by us.":"Tidak perlu menambah token ini lagi kerana ia sudah wujud dan disokong oleh kami.","Token Not Found":"Token Tidak Ditemui","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Maaf, tiada token ditemui pada rantai ",["blockchain"]," dengan alamat yang diberikan. sila pastikan anda telah memasukkan alamat token yang betul."],"Network Error":"Ralat Rangkaian","Add Custom Token":"Tambah Token Tersuai","Select chain":"Pilih rantai","Enter Address":"Masukkan Alamat","Enter token address":"Masukkan alamat token","Failed Network, Please retry.":"Rangkaian Gagal, Sila cuba semula.","Add another custom token":"Tambahkan satu lagi token tersuai","Confirm Swap":"Sahkan Tukar","Start Swap":"Mulakan Tukar","You get":"awak dapat","Search Token":"Token Carian","No custom tokens":"Tiada token tersuai","press the button to add your custom token":"tekan butang untuk menambah token tersuai anda","Delete Custom Token":"Padamkan Token Tersuai","Are you sure you want to Delete this Token?":"Adakah anda pasti mahu Memadam Token ini?","Complete":"lengkap","Running":"Berlari","Failed":"gagal","Clear":"Jelas","Search Transaction":"Transaksi Carian","No transactions":"Tiada transaksi","Your transaction history is stored locally and will appear here after you start a swap":"Sejarah transaksi anda disimpan secara setempat dan akan dipaparkan di sini selepas anda memulakan pertukaran","Clear Transaction History":"Kosongkan Sejarah Transaksi","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Prosiding akan mengalih keluar semua transaksi yang berjaya dan gagal daripada widget. Adakah anda mahu meneruskan?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Nota: Ini tidak memadamkan sejarah transaksi anda pada rantaian; ia hanya membuang mereka di sini.","Yes, Clear the history":"Ya, Kosongkan sejarah","language":"bahasa","Deselect all":"Nyahpilih semua","Select all":"Pilih semua","Search {sourceType}":["Cari ",["sourceType"]],"Search Chain":"Rantaian Carian","Source":"Sumber","Destination":"Destinasi","Swap {type}":["Tukar ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Pada masa ini, anda berada dalam mod kempen dengan sekatan pada sumber kecairan. Adakah anda ingin keluar daripada mod ini dan menggunakan semua sumber kecairan yang tersedia?","The request ID is necessary to display the swap details.":"ID permintaan diperlukan untuk memaparkan butiran swap.","Connect Wallets":"Sambungkan Dompet","Choose a wallet to connect.":"Pilih dompet untuk disambungkan.","This week":"minggu ini","This month":"bulan ini","This year":"tahun ini","Required: >= {min} {symbol}":["Diperlukan: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Diperlukan: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Diperlukan: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Diperlukan: < ",["max"]," ",["symbol"]]," for network fee":" untuk bayaran rangkaian"," for swap":" untuk pertukaran"," for input and network fee":" untuk input dan bayaran rangkaian","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Memerlukan \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", tetapi anda mempunyai ",["currentAmount"]," ",["symbol"]," dalam dompet ",["blockchain"]," anda."],"Waiting for connecting wallet":"Menunggu untuk menyambung dompet","Waiting for other running tasks to be finished":"Menunggu tugasan lain yang sedang dijalankan selesai","Waiting for changing wallet network":"Menunggu untuk menukar rangkaian dompet","Sunday":"Ahad","Monday":"Isnin","Tuesday":"Selasa","Wednesday":"Rabu","Thursday":"Khamis","Friday":"Jumaat","Saturday":"Sabtu","Powered By":"Dikuasakan Oleh","Aggregated Transaction":"Transaksi Agregat","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Tukar pada ",["fromChain"]," melalui ",["swapper"]],"Bridge to {toChain} via {swapper}":["Jambatan ke ",["toChain"]," melalui ",["swapper"]],"Completed":"Selesai","In progress":"Sedang berlangsung","Waiting for bridge transaction":"Menunggu transaksi jambatan","Connected":"Bersambung","Disconnect":"Putuskan sambungan","Install":"Pasang","Connecting ...":"Menyambung...","Connecting":"Menyambung","Disconnected":"Terputus sambungan","you need to pass a correct state to Wallet.":"anda perlu menghantar keadaan yang betul kepada Wallet.","There are no notifications.":"Tiada pemberitahuan.","Clear all":"Kosongkan semua","Balance":"Baki","Max":"Maks"}');


/*eslint-disable*/ const $8558407c79bcbcba$export$defe85febe8b728c = JSON.parse('{"No results found":"Geen resultaten gevonden","Try using different keywords":"Probeer andere trefwoorden te gebruiken","Select Chain":"Selecteer Ketting","All":"Allemaal","More +{count}":["Meer +",["count"]],"Activate this tab":"Dit tabblad activeren","Another tab is open and handles transactions.":"Een ander tabblad is open en behandelt transacties.","Activate current tab":"Actief tabblad","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Op dit moment worden sommige transacties uitgevoerd en behandeld door een ander browsertabblad. Als u dit tabblad activeert, zullen alle transacties die al in de transactie tekenen staan verlopen.","Confirm":"Bevestigen","Your {blockchainName} wallets":["Uw ",["blockchainName"]," portemonnees"],"Insufficient account balance":"Onvoldoende saldo","Proceed anyway":"Toch doorgaan","You need to connect a {blockchainName} wallet.":["Je moet een ",["blockchainName"]," portemonnee verbinden."],"Add {chain} chain":["Voeg ",["chain"]," keten toe"],"Show more wallets":"Toon meer portefeuilles","Send to a different address":"Stuur naar een ander adres","Enter {blockchainName} address":["Voer ",["blockchainName"]," adres in"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adres ",["destination"]," komt niet overeen met het blockchainadrespatroon."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Dit token verschijnt niet op de actieve tokenlijsten. Zorg ervoor dat dit het token is dat je wilt verhandelen.","Import":"Importeren","Status":"status","Reset":"Reset","Cancel":"annuleren","Refresh":"Vernieuwen","Notifications":"Notificaties","Settings":"Instellingen","History":"Geschiedenis","Connect Wallet":"Verbind Portemonnee","Today":"vandaag","Swaps steps":"Swaps stappen","Retry":"Opnieuw","Slippage Error":"Slippage Fout","Slippage Warning":"Slippage Waarschuwing","Bridge Limit Error":"Brug limiet fout","Yours: {amount} {symbol}":["Jours: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum vereiste slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Jouw: ",["userSlippage"]],"See All Routes":"Alle routes bekijken","View more info":"Bekijk meer informatie","Gas & Fee Explanation":"Gas & Fee Uitleg","Details":"Beschrijving","Total Payable Fee":"Totale te betalen vergoeding","Hide non-payable fees":"Verberg onbetaalbare vergoedingen","Show non-payable fees":"Toon onbetaalbare kosten","Description":"Beschrijving","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"De volgende kosten worden in rekening gebracht in de transactieuitvoer en\\n                je hoeft er geen extra gas voor te betalen.","Swap input":"Swap input","Estimated output":"Geschatte uitvoer","Via:":"Via:","Chains:":"Kettingen:","Sort by":"Sorteren op","Smart Routing":"Slimme routering","Lowest Fee":"Laagste kosten","Fastest Transfer":"Snelste overdracht","Maximum Return":"Maximale retour","Maximum Output":"Maximale uitvoer","Swapping":"Swapping","Gas cost":"Gas kosten","Receiving":"Ontvangen","Price impact":"Prijs impact","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Je moet slippage verhogen naar tenminste ",["minRequiredSlippage"]," voor deze route."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["We raden je aan om slippage ten minste ",["minRequiredSlippage"]," voor deze route te verhogen."],"Caution, your slippage is high.":"Let op, je slippage is hoog.","Change":"Veranderen","Change settings":"Instellingen wijzigen","High slippage":"Hoge slippage","Low slippage":"Lage slippage"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Let op, uw slippage is hoog (=",["userSlippage"],"). Uw transactie kan vooraf worden uitgevoerd."],"Confirm anyway":"Toch bevestigen","Something went wrong":"Er ging iets mis","Something went wrong. Please refresh the app.":"Er is iets fout gegaan. Vernieuw de app.","Slippage tolerance per swap":"Slippage tolerantie per swap","Custom":"Aangepaste","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Uw transactie zal worden teruggedraaid als de prijs onvoordelig verandert met meer dan dit percentage.","Warning":"Waarschuwing","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Deze instelling wordt toegepast op elke stap (bijvoorbeeld 1Inch, Thorchain, etc.), wat betekent dat alleen de specifieke stap wordt teruggedraaid, niet de hele route.","Swap Details":"Details omwisselen","Request ID":"ID aanvragen","Not found":"Niet gevonden","Swap with request ID = {requestId} not found.":["Wissel met verzoek-ID = ",["requestId"]," niet gevonden."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Je hebt ",["amount"]," ",["token"]," ontvangen in de ",["conciseAddress"]," portemonnee in ",["chain"]," keten."],"Transaction was not sent.":"Transactie is niet verzonden.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," op ",["blockchain"]," blijft in jouw portemonnee."],"Delete":"Verwijderen","Try again":"Opnieuw proberen","Copied To Clipboard":"Gekopieerd naar klembord","Copy Request ID":"Aanvraag-ID kopi\xebren","View on Rango Explorer":"Bekijk op Rango Explorer","Finished at":"Afgerond op","Created at":"Aangemaakt op","View transaction":"Transactie weergeven","Connect":"Verbinden","Swap Successful":"Wissel succesvol","Transaction Failed":"Transactie mislukt","Done":"Voltooid","Diagnosis":"Diagnose","See Details":"Details bekijken","Cancel Swap":"Verwissel annuleren","Are you sure you want to cancel this swap?":"Weet u zeker dat u deze swap wilt annuleren?","Yes, Cancel it":"Ja, annuleren","No, Continue":"Nee, ga verder","Delete Transaction":"Verwijder transactie","Are you sure you want to delete this swap?":"Weet u zeker dat u deze swap wilt verwijderen?","Yes, Delete it":"Ja, verwijder het","No, Cancel":"Nee, annuleer","Change Network":"Netwerk wijzigen","Network Changed":"Netwerk gewijzigd","Select Token":"Selecteer Token","Wallet Connected":"Portemonnee verbonden","Your wallet is connected, you can use it to swap.":"Uw portemonnee is verbonden, u kunt deze omwisselen.","Failed to Connect":"Verbinden mislukt","Your wallet is not connected. Please try again.":"Uw portemonnee is niet verbonden. Probeer het opnieuw.","Connecting to your wallet":"Verbinding maken met uw portemonnee","Click connect in your wallet popup.":"Klik op verbinden met uw portemonnee popup.","Select Derivation Path":"Selecteer Afgeleidespad","In order to connect to {type}, you must first select a Derivation Path":["Om verbinding te maken met ",["type"],"moet u eerst een afleidingspad selecteren"],"Choose Derivation Path Template":"Kies Derivatie Pad sjabloon","Enter Path":"Pad invoeren","Enter Index":"Index invoeren","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," Ketting toevoegen"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Wilt u de ",["blockchainDisplayName"]," experimentele keten aan uw portemonnee toevoegen?"],"Please approve the experimental chain pop-up in your wallet.":"Gelieve de experimentele keten pop-up in uw portemonnee goed te keuren.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Ketting toegevoegd"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["De ",["blockchainDisplayName"]," keten is met succes aan uw portemonnee toegevoegd."],"Request Rejected":"Verzoek afgewezen","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Je hebt geweigerd om ",["blockchainDisplayName"]," -keten toe te voegen aan je portemonnee."],"Select chain types":"Selecteer chain types","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Deze portemonnee ondersteunt meerdere chains. Selecteer met welke keten u verbinding wilt maken.","Failed Network, Please retry your swap.":"Mislukt netwerk. Probeer het opnieuw.","Please reset your liquidity sources.":"Gelieve uw liquiditeitsbronnen te resetten.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"U hebt de liquiditeitsbronnen beperkt en dit kan ertoe leiden dat Rango geen routes vindt. Overweeg om uw liquiditeitsbronnen opnieuw in te stellen.","No Routes Found.":"Geen routes gevonden.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Redenen waarom Rango geen route kon vinden: lage liquiditeit op token, zeer lage invoerhoeveelheid of geen routes beschikbaar voor de geselecteerde combinatie van invoer/output token.","Bridge Limit Error: Please increase your amount.":"Bridge Limiet Fout: Verhoog uw bedrag.","Bridge Limit Error: Please decrease your amount.":"Bridge Limiet Fout: Verminder je bedrag.","High Price Impact":"Hoge prijs impact","Price impact is too high!":"De prijsimpact is te hoog!","The price impact is significantly higher than the allowed amount.":"Het prijseffect is beduidend hoger dan het toegestane bedrag.","Confirm high price impact":"hoge prijsimpact bevestigen","Route updated and price impact is too high, try again later!":"Route bijgewerkt en prijseffect is te hoog, probeer het later opnieuw!","USD Price Unknown":"USD prijs onbekend","USD Price Unknown, Cannot calculate Price Impact.":"USD prijs onbekend, kan de Impact niet berekenen.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD prijs onbekend, kan de Impact niet berekenen. Mogelijk is de prijs hoger dan normaal. Weet u zeker dat u door wilt gaan met de Swap?","Confirm USD Price Unknown":"Onbekende USD prijs bevestigen","Swap":"Wisselen","Swap anyway":"Wissel toch","The route goes through Ethereum. Continue?":"De route loopt door Ethereum. Doorgaan?","Route has been updated.":"De route is bijgewerkt.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Uitgangsbedrag gewijzigd naar ",["newOutputAmount"]," (",["percentageChange"],"% wijziging)."],"Route swappers has been updated.":"Route swappers zijn bijgewerkt.","Route internal coins has been updated.":"Route interne munten zijn bijgewerkt.","Routes":"Routes","From":"van","To":"tot","Light":"Licht","Dark":"Donker","Auto":"Automatisch","Loading failed":"Laden mislukt","Bridges":"Bruggen","Exchanges":"Uitwisselingen","Custom Tokens":"Aangepaste Tokens","Language":"Taal","Infinite approval":"Oneindige goedkeuring","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Het inschakelen van de \'Oneindige goedkeuring\' modus verleent onbeperkte toegang tot onderliggende slimme contracten, waardoor ze het goedgekeurde token bedrag zonder beperkingen kunnen gebruiken.","Theme":"Thema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"Het opgegeven adres is dubbel, voer een nieuw adres in.","Token Already Exists":"Token bestaat al","There\'s no need to add this token again because it already exists and is supported by us.":"Het is niet nodig om dit token opnieuw toe te voegen omdat het al bestaat en door ons wordt ondersteund.","Token Not Found":"Token niet gevonden","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Sorry, er is geen token gevonden op ",["blockchain"]," keten met het opgegeven adres. Zorg ervoor dat u het juiste token adres hebt ingevoerd."],"Network Error":"Netwerk fout","Add Custom Token":"Aangepaste Token toevoegen","Select chain":"Selecteer keten","Enter Address":"Voer adres in","Enter token address":"Voer token adres in","Failed Network, Please retry.":"Mislukt netwerk, probeer het opnieuw.","Add another custom token":"Nog een aangepast token toevoegen","Confirm Swap":"Bevestig verwisselen","Start Swap":"Start omwisselen","You get":"Je krijgt","Search Token":"Zoek Token","No custom tokens":"Geen aangepaste tokens","press the button to add your custom token":"druk op de knop om je eigen token toe te voegen","Delete Custom Token":"Aangepaste token verwijderen","Are you sure you want to Delete this Token?":"Weet u zeker dat u deze token wilt verwijderen?","Complete":"Complete","Running":"Lopend","Failed":"Mislukt","Clear":"Verwijderen","Search Transaction":"Zoek transactie","No transactions":"Geen transacties","Your transaction history is stored locally and will appear here after you start a swap":"Uw transactiegeschiedenis is lokaal opgeslagen en zal hier verschijnen nadat u een swap heeft gestart","Clear Transaction History":"Wis transactiegeschiedenis","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Doorgaan zal alle succesvolle en mislukte transacties van de widget verwijderen. Wilt u doorgaan?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Opmerking: Dit wist uw transactiegeschiedenis op de keten niet; het verwijdert ze alleen hier.","Yes, Clear the history":"Ja, de geschiedenis wissen","language":"Taal","Deselect all":"Deselecteer alles","Select all":"Alles selecteren","Search {sourceType}":["Zoek ",["sourceType"]],"Search Chain":"Zoek ketting","Source":"Bron","Destination":"Doelstelling","Swap {type}":["Wissel ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Momenteel bent u in campagnemodus met beperkingen op liquiditeitsbronnen. Wilt u uit deze modus schakelen en gebruik maken van alle beschikbare liquiditeitsbronnen?","The request ID is necessary to display the swap details.":"Het verzoek-ID is nodig om de swap-gegevens weer te geven.","Connect Wallets":"Verbind Portemonnees","Choose a wallet to connect.":"Kies een portemonnee om te verbinden.","This week":"Deze week","This month":"Deze maand","This year":"Dit jaar","Required: >= {min} {symbol}":["Vereist: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Vereist: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Vereist: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Vereist: < ",["max"]," ",["symbol"]]," for network fee":" voor netwerkheffing"," for swap":" voor swap"," for input and network fee":" voor invoer en netwerk vergoeding","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Moet ",["requiredAmount"]," ",["symbol"],["reason"],", maar je hebt ",["currentAmount"]," ",["symbol"]," in je ",["blockchain"]," portemonnee nodig."],"Waiting for connecting wallet":"Wachten op verbinding met portemonnee","Waiting for other running tasks to be finished":"Wachten tot andere lopende taken zijn voltooid","Waiting for changing wallet network":"Wachten op het wijzigen van wallet netwerk","Sunday":"zondag","Monday":"maandag","Tuesday":"dinsdag","Wednesday":"woensdag","Thursday":"donderdag","Friday":"vrijdag","Saturday":"zaterdag","Powered By":"Mogelijk gemaakt door","Aggregated Transaction":"Geaggregeerde transactie","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Wissel op ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Brug naar ",["toChain"]," via ",["swapper"]],"Completed":"Voltooid","In progress":"In behandeling","Waiting for bridge transaction":"Wachten op bridge transactie","Connected":"Verbonden","Disconnect":"Verbreek","Install":"Installeren","Connecting ...":"Verbinden ...","Connecting":"Verbinden","Disconnected":"Losgekoppeld","you need to pass a correct state to Wallet.":"u moet een juiste status doorgeven aan Wallet.","There are no notifications.":"Er zijn geen meldingen.","Clear all":"Alles wissen","Balance":"Saldo","Max":"Max."}');


/*eslint-disable*/ const $11d62329a6924e92$export$defe85febe8b728c = JSON.parse('{"No results found":"Nie znaleziono wynik\xf3w","Try using different keywords":"Spr\xf3buj u\u017Cy\u0107 r\xf3\u017Cnych s\u0142\xf3w kluczowych","Select Chain":"Wybierz \u0142a\u0144cuch","All":"Wszystkie","More +{count}":["Wi\u0119cej +",["count"]],"Activate this tab":"Aktywuj t\u0119 kart\u0119","Another tab is open and handles transactions.":"Inna karta jest otwarta i obs\u0142uguje transakcje.","Activate current tab":"Aktywuj bie\u017C\u0105c\u0105 kart\u0119","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Obecnie niekt\xf3re transakcje s\u0105 uruchomione i s\u0105 obs\u0142ugiwane przez inn\u0105 kart\u0119 przegl\u0105darki. Je\u015Bli aktywujesz t\u0119 kart\u0119, wszystkie transakcje, kt\xf3re s\u0105 ju\u017C w kroku podpisu transakcji, wygasn\u0105.","Confirm":"Potwierd\u017A","Your {blockchainName} wallets":["Twoje portfele ",["blockchainName"]],"Insufficient account balance":"Niewystarczaj\u0105ce saldo konta","Proceed anyway":"Kontynuuj mimo to","You need to connect a {blockchainName} wallet.":["Musisz po\u0142\u0105czy\u0107 portfel ",["blockchainName"],"."],"Add {chain} chain":["Dodaj \u0142a\u0144cuch ",["chain"]],"Show more wallets":"Poka\u017C wi\u0119cej portfeli","Send to a different address":"Wy\u015Blij na inny adres","Enter {blockchainName} address":["Wprowad\u017A adres ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["Adres ",["destination"]," nie pasuje do wzoru adresu blockchain."],"via":"przez","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Ten token nie pojawia si\u0119 na listach aktywnych token\xf3w. Upewnij si\u0119, \u017Ce to jest token, kt\xf3ry chcesz wymieni\u0107.","Import":"Importuj","Status":"Status","Reset":"Reset","Cancel":"Anuluj","Refresh":"Od\u015Bwie\u017C","Notifications":"Powiadomienia","Settings":"Ustawienia","History":"Historia","Connect Wallet":"Po\u0142\u0105cz portfel","Today":"Dzi\u015B","Swaps steps":"Etapy swap\xf3w","Retry":"Pon\xf3w pr\xf3b\u0119","Slippage Error":"B\u0142\u0105d po\u015Blizgu","Slippage Warning":"Ostrze\u017Cenie po\u015Blizgu","Bridge Limit Error":"B\u0142\u0105d limitu mostu","Yours: {amount} {symbol}":["Nasz: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimalny wymagany po\u015Blizg: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Yours: ",["userSlippage"]],"See All Routes":"Zobacz wszystkie trasy","View more info":"Zobacz wi\u0119cej informacji","Gas & Fee Explanation":"Wyja\u015Bnienie dotycz\u0105ce gazu i op\u0142at","Details":"Szczeg\xf3\u0142y","Total Payable Fee":"Ca\u0142kowita nale\u017Cna op\u0142ata","Hide non-payable fees":"Ukryj op\u0142aty niep\u0142atne","Show non-payable fees":"Poka\u017C op\u0142aty bezp\u0142atne","Description":"Opis","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Nast\u0119puj\u0105ce op\u0142aty s\u0105 brane pod uwag\u0119 w wyj\u015Bciu transakcji i\\n                nie musisz za nie p\u0142aci\u0107 dodatkowego gazu.","Swap input":"Swap input","Estimated output":"Szacowane wyj\u015Bcie","Via:":"Przelotka:","Chains:":"\u0141a\u0144cuchy","Sort by":"Sortuj wed\u0142ug","Smart Routing":"Inteligentne Trasowanie","Lowest Fee":"Najni\u017Csza op\u0142ata","Fastest Transfer":"Najszybszy transfer","Maximum Return":"Maksymalny zwrot","Maximum Output":"Maksymalna warto\u015B\u0107 wyj\u015Bciowa","Swapping":"Swapping","Gas cost":"Koszt gazu","Receiving":"Odbieranie","Price impact":"Wp\u0142yw cen","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Musisz zwi\u0119kszy\u0107 po\u015Blizg do co najmniej ",["minRequiredSlippage"]," dla tej trasy."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Zalecamy zwi\u0119kszenie po\u015Blizgu do co najmniej ",["minRequiredSlippage"]," dla tej trasy."],"Caution, your slippage is high.":"Zachowaj ostro\u017Cno\u015B\u0107, tw\xf3j po\u015Blizg jest wysoki.","Change":"Zmiana","Change settings":"Zmie\u0144 ustawienia","High slippage":"Wysoki po\u015Blizg","Low slippage":"Niski po\u015Blizg"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Uwaga, Tw\xf3j po\u015Blizg jest wysoki (=",["userSlippage"],"). Twoja transakcja mo\u017Ce by\u0107 aktywna."],"Confirm anyway":"Potwierd\u017A mimo wszystko","Something went wrong":"Co\u015B posz\u0142o nie tak","Something went wrong. Please refresh the app.":"Co\u015B posz\u0142o nie tak. Prosz\u0119 od\u015Bwie\u017Cy\u0107 aplikacj\u0119.","Slippage tolerance per swap":"Tolerancja po\u015Blizgu na swap","Custom":"W\u0142asny","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Twoja transakcja zostanie przywr\xf3cona, je\u015Bli cena zmieni si\u0119 niekorzystnie o wi\u0119cej ni\u017C ten procent.","Warning":"Ostrze\u017Cenie","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"To ustawienie jest stosowane na ka\u017Cdym etapie (np. 1Inch, Thorchain itp.), co oznacza, \u017Ce konkretny krok zostanie odwr\xf3cony, a nie na ca\u0142ej drodze.","Swap Details":"Zamie\u0144 szczeg\xf3\u0142y","Request ID":"\u017B\u0105danie ID","Not found":"Nie znaleziono","Swap with request ID = {requestId} not found.":["Zamie\u0144 z ID \u017C\u0105dania = ",["requestId"]," nie znaleziono."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Otrzyma\u0142e\u015B ",["amount"]," ",["token"]," w portfelu ",["conciseAddress"]," w \u0142a\u0144cuchu ",["chain"],"."],"Transaction was not sent.":"Transakcja nie zosta\u0142a wys\u0142ana.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," na ",["blockchain"]," pozostaje w Twoim portfelu."],"Delete":"Usu\u0144","Try again":"Spr\xf3buj ponownie","Copied To Clipboard":"Skopiowano do schowka","Copy Request ID":"Kopiuj ID \u017C\u0105dania","View on Rango Explorer":"Zobacz w Eksploratorze Rango","Finished at":"Zako\u0144czono o","Created at":"Utworzono w","View transaction":"Zobacz transakcj\u0119","Connect":"Po\u0142\u0105cz","Swap Successful":"Zamiana zako\u0144czona","Transaction Failed":"Transakcja nie powiod\u0142a si\u0119","Done":"Gotowe","Diagnosis":"Diagnoza","See Details":"Zobacz szczeg\xf3\u0142y","Cancel Swap":"Anuluj zamian\u0119","Are you sure you want to cancel this swap?":"Czy na pewno chcesz anulowa\u0107 t\u0119 swap?","Yes, Cancel it":"Tak, anuluj","No, Continue":"Nie, Kontynuuj","Delete Transaction":"Usu\u0144 transakcj\u0119","Are you sure you want to delete this swap?":"Czy na pewno chcesz usun\u0105\u0107 t\u0119 swap?","Yes, Delete it":"Tak, usu\u0144","No, Cancel":"Nie, Anuluj","Change Network":"Zmie\u0144 sie\u0107","Network Changed":"Sie\u0107 zmieniona","Select Token":"Wybierz token","Wallet Connected":"Portfel po\u0142\u0105czony","Your wallet is connected, you can use it to swap.":"Tw\xf3j portfel jest po\u0142\u0105czony, mo\u017Cesz go u\u017Cy\u0107 do zamiany.","Failed to Connect":"Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107","Your wallet is not connected. Please try again.":"Tw\xf3j portfel nie jest po\u0142\u0105czony. Spr\xf3buj ponownie.","Connecting to your wallet":"\u0141\u0105czenie z portfelem","Click connect in your wallet popup.":"Kliknij po\u0142\u0105czenie w wyskakuj\u0105cym oknie portfela.","Select Derivation Path":"Wybierz \u015Acie\u017Ck\u0119 Pochodn\u0105","In order to connect to {type}, you must first select a Derivation Path":["Aby po\u0142\u0105czy\u0107 si\u0119 z ",["type"],"musisz najpierw wybra\u0107 \u015Acie\u017Ck\u0119 Pochodn\u0105"],"Choose Derivation Path Template":"Wybierz szablon \u015Bcie\u017Cki pochodnej","Enter Path":"Wprowad\u017A \u015Bcie\u017Ck\u0119","Enter Index":"Wprowad\u017A indeks","Add {blockchainDisplayName} Chain":["Dodaj \u0142a\u0144cuch ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Czy chcesz doda\u0107 eksperymentalny \u0142a\u0144cuch ",["blockchainDisplayName"]," do swojego portfela?"],"Please approve the experimental chain pop-up in your wallet.":"Prosz\u0119 zatwierdzi\u0107 eksperymentalne wyskakuj\u0105ce okienko \u0142a\u0144cucha w portfelu.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0141a\u0144cuch dodany"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u0141a\u0144cuch ",["blockchainDisplayName"]," zosta\u0142 pomy\u015Blnie dodany do Twojego portfela."],"Request Rejected":"\u017B\u0105danie odrzucone","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Odrzuci\u0142e\u015B dodanie \u0142a\u0144cucha ",["blockchainDisplayName"]," do swojego portfela."],"Select chain types":"Wybierz typy \u0142a\u0144cuch\xf3w","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Ten portfel obs\u0142uguje wiele \u0142a\u0144cuch\xf3w. Wybierz \u0142a\u0144cuch, z kt\xf3rym chcesz si\u0119 po\u0142\u0105czy\u0107.","Failed Network, Please retry your swap.":"Nieudana sie\u0107, pon\xf3w pr\xf3b\u0119 wymiany.","Please reset your liquidity sources.":"Prosz\u0119 zresetowa\u0107 \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Ograniczy\u0142e\u015B \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci, co mo\u017Ce skutkowa\u0107 znalezieniem przez Rango \u017Cadnych tras. Rozwa\u017C zresetowanie \u017Ar\xf3de\u0142 p\u0142ynno\u015Bci.","No Routes Found.":"Nie znaleziono trasy.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Powody, dla kt\xf3rych Rango nie m\xf3g\u0142 znale\u017A\u0107 trasy: niska p\u0142ynno\u015B\u0107 w tokenu, bardzo niska ilo\u015B\u0107 wej\u015Bciowa lub brak dost\u0119pnych tras dla wybranej kombinacji tokenu wej\u015Bciowego/wyj\u015Bciowego.","Bridge Limit Error: Please increase your amount.":"B\u0142\u0105d limitu mostka: Prosz\u0119 zwi\u0119kszy\u0107 swoj\u0105 kwot\u0119.","Bridge Limit Error: Please decrease your amount.":"B\u0142\u0105d limitu mostka: Prosz\u0119 zmniejszy\u0107 swoj\u0105 kwot\u0119.","High Price Impact":"Wp\u0142yw Wysokiej Ceny","Price impact is too high!":"Wp\u0142yw ceny jest zbyt wysoki!","The price impact is significantly higher than the allowed amount.":"Wp\u0142yw na cen\u0119 jest znacznie wy\u017Cszy ni\u017C dozwolona kwota.","Confirm high price impact":"Potwierd\u017A wysoki wp\u0142yw cen","Route updated and price impact is too high, try again later!":"Zaktualizowano tras\u0119 i wp\u0142yw ceny jest zbyt wysoki, spr\xf3buj ponownie p\xf3\u017Aniej!","USD Price Unknown":"Cena USD nieznana","USD Price Unknown, Cannot calculate Price Impact.":"Cena USD Nieznana, nie mo\u017Cna obliczy\u0107 wp\u0142ywu na cen\u0119.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Cena USD Nieznana, nie mo\u017Cna obliczy\u0107 wp\u0142ywu na cen\u0119. Wp\u0142yw ceny mo\u017Ce by\u0107 wy\u017Cszy ni\u017C zwykle. Czy na pewno chcesz kontynuowa\u0107 transakcj\u0119?","Confirm USD Price Unknown":"Potwierd\u017A cen\u0119 USD nieznan\u0105","Swap":"Zamie\u0144","Swap anyway":"Zamie\u0144 mimo to","The route goes through Ethereum. Continue?":"Trasa przebiega przez Ethereum. Kontynuowa\u0107?","Route has been updated.":"Trasa zosta\u0142a zaktualizowana.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Kwota wyj\u015Bciowa zmieniona na ",["newOutputAmount"]," (zmiana",["percentageChange"],"%)."],"Route swappers has been updated.":"Zaktualizowano zamienniki tras.","Route internal coins has been updated.":"Trasa monet wewn\u0119trznych zosta\u0142a zaktualizowana.","Routes":"Trasy","From":"Od","To":"Do","Light":"\u015Awiat\u0142o","Dark":"Ciemny","Auto":"Auto","Loading failed":"\u0141adowanie nie powiod\u0142o si\u0119","Bridges":"Mosty","Exchanges":"Wymiana","Custom Tokens":"Niestandardowe tokeny","Language":"J\u0119zyk","Infinite approval":"Niesko\u0144czone zatwierdzenie","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"W\u0142\u0105czenie trybu \'Niesko\u0144czone zatwierdzenie\' zapewnia nieograniczony dost\u0119p do podstawowych inteligentnych um\xf3w, umo\u017Cliwiaj\u0105c im wykorzystanie zatwierdzonej ilo\u015Bci token\xf3w bez ogranicze\u0144.","Theme":"Motyw","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"Podany adres jest zduplikowany, wprowad\u017A nowy adres.","Token Already Exists":"Token ju\u017C istnieje","There\'s no need to add this token again because it already exists and is supported by us.":"Nie ma potrzeby dodawania tego tokenu ponownie, poniewa\u017C ju\u017C istnieje i jest obs\u0142ugiwany przez nas.","Token Not Found":"Token nie znaleziony","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Przepraszamy, nie znaleziono tokenu w \u0142a\u0144cuchu ",["blockchain"]," z podanym adrem. Upewnij si\u0119, \u017Ce wprowadzi\u0142e\u015B odpowiedni adres tokena."],"Network Error":"B\u0142\u0105d sieci","Add Custom Token":"Dodaj w\u0142asny token","Select chain":"Wybierz \u0142a\u0144cuch","Enter Address":"Wprowad\u017A adres","Enter token address":"Wprowad\u017A adres tokenu","Failed Network, Please retry.":"Nieudana sie\u0107, spr\xf3buj ponownie.","Add another custom token":"Dodaj kolejny niestandardowy token","Confirm Swap":"Potwierd\u017A wymian\u0119","Start Swap":"Rozpocznij wymian\u0119","You get":"Otrzymujesz","Search Token":"Token wyszukiwania","No custom tokens":"Brak niestandardowych token\xf3w","press the button to add your custom token":"naci\u015Bnij przycisk, aby doda\u0107 w\u0142asny token","Delete Custom Token":"Usu\u0144 w\u0142asny token","Are you sure you want to Delete this Token?":"Czy na pewno chcesz usun\u0105\u0107 ten token?","Complete":"Complete","Running":"Uruchamianie","Failed":"Niepowodzenie","Clear":"Wyczy\u015B\u0107","Search Transaction":"Szukaj transakcji","No transactions":"Brak transakcji","Your transaction history is stored locally and will appear here after you start a swap":"Twoja historia transakcji jest przechowywana lokalnie i pojawi si\u0119 tutaj po rozpocz\u0119ciu swapu","Clear Transaction History":"Wyczy\u015B\u0107 histori\u0119 transakcji","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Kontynuacja spowoduje usuni\u0119cie wszystkich udanych i nieudanych transakcji z wid\u017Cetu. Czy chcesz kontynuowa\u0107?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Uwaga: To nie usuwa Twojej historii transakcji z \u0142a\u0144cucha; usuwa j\u0105 tylko tutaj.","Yes, Clear the history":"Tak, wyczy\u015B\u0107 histori\u0119","language":"j\u0119zyk","Deselect all":"Odznacz wszystkie","Select all":"Zaznacz wszystkie","Search {sourceType}":["Szukaj ",["sourceType"]],"Search Chain":"Wyszukaj \u0142a\u0144cuch","Source":"\u0179r\xf3d\u0142o","Destination":"Miejsce przeznaczenia","Swap {type}":["Zamie\u0144 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Obecnie jeste\u015B w trybie kampanii z ograniczeniami dotycz\u0105cymi \u017Ar\xf3de\u0142 p\u0142ynno\u015Bci. Czy chcesz wy\u0142\u0105czy\u0107 ten tryb i wykorzysta\u0107 wszystkie dost\u0119pne \u017Ar\xf3d\u0142a p\u0142ynno\u015Bci?","The request ID is necessary to display the swap details.":"Identyfikator \u017C\u0105dania jest niezb\u0119dny do wy\u015Bwietlania szczeg\xf3\u0142\xf3w swapu.","Connect Wallets":"Po\u0142\u0105cz portfele","Choose a wallet to connect.":"Wybierz portfel do po\u0142\u0105czenia.","This week":"W tym tygodniu","This month":"W tym miesi\u0105cu","This year":"W tym roku","Required: >= {min} {symbol}":["Wymagane: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Wymagane: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Wymagane: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Wymagane: < ",["max"]," ",["symbol"]]," for network fee":" za op\u0142at\u0119 sieciow\u0105"," for swap":" dla swapu"," for input and network fee":" dla op\u0142at wej\u015Bciowych i op\u0142at sieciowych","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Potrzebuje \u2192 ",["requiredAmount"]," ",["symbol"],["reason"],", ale masz ",["currentAmount"]," ",["symbol"]," w swoim portfelu ",["blockchain"],"."],"Waiting for connecting wallet":"Oczekiwanie na po\u0142\u0105czenie portfela","Waiting for other running tasks to be finished":"Oczekiwanie na zako\u0144czenie innych uruchomionych zada\u0144","Waiting for changing wallet network":"Oczekiwanie na zmian\u0119 sieci portfela","Sunday":"Niedziela","Monday":"Poniedzia\u0142ek","Tuesday":"Wtorek","Wednesday":"\u015Aroda","Thursday":"Czwartek","Friday":"Pi\u0105tek","Saturday":"Sobota","Powered By":"Wspierane przez","Aggregated Transaction":"Zbiorcza transakcja","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Zamie\u0144 na ",["fromChain"]," przez ",["swapper"]],"Bridge to {toChain} via {swapper}":["Most do ",["toChain"]," przez ",["swapper"]],"Completed":"Zako\u0144czone","In progress":"W toku","Waiting for bridge transaction":"Oczekiwanie na transakcj\u0119 mostu","Connected":"Po\u0142\u0105czono","Disconnect":"Roz\u0142\u0105cz","Install":"Zainstaluj","Connecting ...":"\u0141\u0105czenie...","Connecting":"\u0141\u0105czenie","Disconnected":"Roz\u0142\u0105czony","you need to pass a correct state to Wallet.":"musisz przekaza\u0107 poprawny stan Wallet.","There are no notifications.":"Brak powiadomie\u0144.","Clear all":"Wyczy\u015B\u0107 wszystko","Balance":"Saldo","Max":"Maks."}');


/*eslint-disable*/ const $91180c0cd3b0e5b3$export$defe85febe8b728c = JSON.parse('{"No results found":"Nenhum resultado encontrado","Try using different keywords":"Tente usar palavras-chave diferentes","Select Chain":"Selecionar Cadeia","All":"TODOS","More +{count}":["Mais +",["count"]],"Activate this tab":"Ativar esta aba","Another tab is open and handles transactions.":"Outra aba \xe9 aberta e lida com transa\xe7\xf5es.","Activate current tab":"Ativar a aba atual","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"No momento, algumas transa\xe7\xf5es est\xe3o sendo executadas e sendo tratadas por outra aba do navegador. Se voc\xea ativar essa aba, todas as transa\xe7\xf5es que j\xe1 est\xe3o na etapa de sinal de transa\xe7\xe3o ir\xe3o expirar.","Confirm":"Confirmar","Your {blockchainName} wallets":["Suas carteiras ",["blockchainName"]],"Insufficient account balance":"Saldo de conta insuficiente","Proceed anyway":"Continuar mesmo assim","You need to connect a {blockchainName} wallet.":["Voc\xea precisa conectar uma carteira ",["blockchainName"],"."],"Add {chain} chain":["Adiciona cadeia ",["chain"]],"Show more wallets":"Mostrar mais carteiras","Send to a different address":"Enviar para outro endere\xe7o","Enter {blockchainName} address":["Digite o endere\xe7o ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["O endere\xe7o ",["destination"]," n\xe3o corresponde ao padr\xe3o do endere\xe7o da blockchain."],"via":"atrav\xe9s","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Este token n\xe3o aparece na lista de tokens ativos. Certifique-se de que este \xe9 o token que voc\xea deseja negociar.","Import":"Importa\xe7\xe3o","Status":"SItua\xe7\xe3o","Reset":"Reset","Cancel":"cancelar","Refresh":"atualizar","Notifications":"notifica\xe7\xf5es","Settings":"Confirgura\xe7\xf5es","History":"Hist\xf3rico","Connect Wallet":"Conectar Carteira","Today":"hoje","Swaps steps":"Etapas de troca","Retry":"Repetir","Slippage Error":"Erro Slippage","Slippage Warning":"Aviso Slippage","Bridge Limit Error":"Erro no limite da ponte","Yours: {amount} {symbol}":["Sua: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["M\xednimo de slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Sua: ",["userSlippage"]],"See All Routes":"Ver todas as rotas","View more info":"Ver mais informa\xe7\xf5es","Gas & Fee Explanation":"Explica\xe7\xe3o de G\xe1s e Taxa","Details":"detalhes","Total Payable Fee":"Taxa total a pagar","Hide non-payable fees":"Ocultar taxas n\xe3o-pag\xe1veis","Show non-payable fees":"Mostrar tarifas n\xe3o pag\xe1veis","Description":"Descri\xe7\xe3o:","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"As seguintes tarifas s\xe3o consideradas no resultado da transa\xe7\xe3o e\\n                voc\xea n\xe3o precisar\xe1 pagar g\xe1s extra por elas.","Swap input":"Swap input","Estimated output":"Sa\xedda estimada","Via:":"Via:","Chains:":"Correntas:","Sort by":"Classificar por","Smart Routing":"Roteamento inteligente","Lowest Fee":"Taxa mais baixa","Fastest Transfer":"Mais R\xe1pido","Maximum Return":"Retorno M\xe1ximo","Maximum Output":"Produ\xe7\xe3o M\xe1xima","Swapping":"Swapping","Gas cost":"Custo de g\xe1s","Receiving":"Recebimento","Price impact":"Impacto nos pre\xe7os","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Voc\xea precisa aumentar o slippage para pelo menos ",["minRequiredSlippage"]," para esta rota."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Recomendamos que voc\xea aumente o slippage para pelo menos ",["minRequiredSlippage"]," para esta rota."],"Caution, your slippage is high.":"Cuidado, seu slippage est\xe1 alto.","Change":"Troca","Change settings":"Alterar configura\xe7\xf5es","High slippage":"Alto slide","Low slippage":"Slippage Baixo"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Cuidado, sua p\xe1gina de slippage est\xe1 alta =",["userSlippage"],"). Sua opera\xe7\xe3o pode ser iniciada primeiro."],"Confirm anyway":"Confirmar mesmo assim","Something went wrong":"Algo deu errado","Something went wrong. Please refresh the app.":"Ocorreu um erro. Por favor, atualize o aplicativo.","Slippage tolerance per swap":"Toler\xe2ncia do slippage por swap","Custom":"Personalizado","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Sua transa\xe7\xe3o ser\xe1 revertida se o pre\xe7o mudar desfavoravelmente, mais do que esta percentagem.","Warning":"ATEN\xc7\xc3O","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Essa configura\xe7\xe3o \xe9 aplicada a cada etapa (por exemplo, 1Inch, Thorchain, etc.), significando apenas que a etapa espec\xedfica ser\xe1 revertida, n\xe3o a rota inteira.","Swap Details":"Trocar detalhes","Request ID":"Solicitar ID","Not found":"N\xe3o encontrado","Swap with request ID = {requestId} not found.":["Trocar com o ID de requisi\xe7\xe3o = ",["requestId"]," n\xe3o encontrado."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Voc\xea recebeu ",["amount"]," ",["token"]," em carteira ",["conciseAddress"]," na cadeia ",["chain"],"."],"Transaction was not sent.":"Transa\xe7\xe3o n\xe3o foi enviada.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," em ",["blockchain"]," permanece em sua carteira."],"Delete":"excluir","Try again":"Tente novamente","Copied To Clipboard":"Copiado Para a \xc1rea de Transfer\xeancia","Copy Request ID":"Copiar ID da Requisi\xe7\xe3o","View on Rango Explorer":"Ver no Rango Explorer","Finished at":"Terminado em","Created at":"Criado em","View transaction":"Ver transa\xe7\xe3o","Connect":"Conectar","Swap Successful":"Troca bem sucedida","Transaction Failed":"Transa\xe7\xe3o Falhou","Done":"Conclu\xeddo","Diagnosis":"Diagn\xf3stico","See Details":"Ver Detalhes","Cancel Swap":"Cancelar Swap","Are you sure you want to cancel this swap?":"Tem certeza que deseja cancelar este swap?","Yes, Cancel it":"Sim, Cancele","No, Continue":"N\xe3o, continuar","Delete Transaction":"Excluir Transa\xe7\xe3o","Are you sure you want to delete this swap?":"Tem certeza que deseja excluir esta troca?","Yes, Delete it":"Sim, exclua-o","No, Cancel":"N\xe3o, cancele","Change Network":"Alterar rede","Network Changed":"Rede alterada","Select Token":"Selecione o Token","Wallet Connected":"Carteira conectada","Your wallet is connected, you can use it to swap.":"Sua carteira est\xe1 conectada, voc\xea pode us\xe1-la para trocar.","Failed to Connect":"Falha na conex\xe3o","Your wallet is not connected. Please try again.":"Sua carteira n\xe3o est\xe1 conectada. Por favor, tente novamente.","Connecting to your wallet":"Conectando-se \xe0 sua carteira","Click connect in your wallet popup.":"Clique em conectar no pop-up da sua carteira.","Select Derivation Path":"Selecionar Caminho de Deriva\xe7\xe3o","In order to connect to {type}, you must first select a Derivation Path":["Para conectar a ",["type"],", voc\xea deve primeiro selecionar um caminho de Deriva\xe7\xe3o"],"Choose Derivation Path Template":"Escolher Modelo de Caminho de Deriva\xe7\xe3o","Enter Path":"Insira o caminho","Enter Index":"Inserir \xedndice","Add {blockchainDisplayName} Chain":["Adicionar Corrente ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Voc\xea gostaria de adicionar a cadeia experimental ",["blockchainDisplayName"]," \xe0 sua carteira?"],"Please approve the experimental chain pop-up in your wallet.":"Por favor, aprove o pop-up experimental na sua carteira.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Cadeia Adicionada"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["A cadeia ",["blockchainDisplayName"]," foi adicionada com sucesso \xe0 sua carteira."],"Request Rejected":"Pedido rejeitado","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Voc\xea rejeitou adicionar ",["blockchainDisplayName"]," corrente \xe0 sua carteira."],"Select chain types":"Selecione tipos de correntes","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Esta carteira suporta v\xe1rias cadeias. Selecione a que cadeia voc\xea gostaria de se conectar.","Failed Network, Please retry your swap.":"Falha na Rede, tente novamente sua altern\xe2ncia.","Please reset your liquidity sources.":"Por favor, redefina suas fontes de liquidez.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Voc\xea limitou as fontes de liquidez e isso pode resultar em que o Rango n\xe3o encontre nenhuma rota. Por favor, considere redefinir suas fontes de liquidez.","No Routes Found.":"Nenhuma rota encontrada.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Motivos porque Rango n\xe3o conseguiu encontrar uma rota: baixa liquidez no token, quantidade muito baixa de entrada ou nenhuma rota dispon\xedvel para a combina\xe7\xe3o selecionada de entrada/sa\xedda do token.","Bridge Limit Error: Please increase your amount.":"Erro no limite da ponte: Por favor, aumente o seu valor.","Bridge Limit Error: Please decrease your amount.":"Erro no limite da ponte: Por favor, reduza seu montante.","High Price Impact":"Impacto de pre\xe7o alto","Price impact is too high!":"O impacto nos pre\xe7os \xe9 muito alto!","The price impact is significantly higher than the allowed amount.":"O impacto nos pre\xe7os \xe9 significativamente mais alto do que a quantidade permitida.","Confirm high price impact":"Confirmar alto impacto nos pre\xe7os","Route updated and price impact is too high, try again later!":"A rota atualizada e o impacto nos pre\xe7os \xe9 muito alto, tente novamente mais tarde!","USD Price Unknown":"Pre\xe7o em USD desconhecido","USD Price Unknown, Cannot calculate Price Impact.":"Pre\xe7o em USD desconhecido, n\xe3o \xe9 poss\xedvel calcular o impacto de pre\xe7os.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Pre\xe7o em USD desconhecido, n\xe3o \xe9 poss\xedvel calcular o impacto do pre\xe7o. O impacto do pre\xe7o pode ser maior do que o normal. Tem certeza que deseja continuar o Swap?","Confirm USD Price Unknown":"Confirmar pre\xe7o de USD desconhecido","Swap":"Trocar","Swap anyway":"Trocar mesmo assim","The route goes through Ethereum. Continue?":"A rota passa pelo Ethereum. Continuar?","Route has been updated.":"Rota foi atualizada.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Valor de sa\xedda alterado para ",["newOutputAmount"]," ( Altera\xe7\xe3o de",["percentageChange"],"%)."],"Route swappers has been updated.":"Os trocadores de rota foram atualizados.","Route internal coins has been updated.":"Moedas internas do itiner\xe1rio foram atualizadas.","Routes":"Rotas","From":"De","To":"Para","Light":"Fino","Dark":"Escuro","Auto":"Autom\xe1tico","Loading failed":"Falha no carregamento","Bridges":"Pontes","Exchanges":"Trocas","Custom Tokens":"Tokens Personalizados","Language":"IDIOMA","Infinite approval":"Aprova\xe7\xe3o infinita","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Habilitar o modo \'Aprova\xe7\xe3o infinita\' concede acesso irrestrito aos contratos inteligentes subjacentes, permitindo-lhes usar o valor do token aprovado, sem limita\xe7\xf5es.","Theme":"Tema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"O endere\xe7o inserido \xe9 duplicado, por favor insira um novo endere\xe7o.","Token Already Exists":"Token j\xe1 existe","There\'s no need to add this token again because it already exists and is supported by us.":"N\xe3o h\xe1 necessidade de adicionar este token novamente porque ele j\xe1 existe e \xe9 suportado por n\xf3s.","Token Not Found":"Token n\xe3o encontrado","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Desculpe, nenhum token foi encontrado na cadeia ",["blockchain"]," com o endere\xe7o fornecido. Por favor, certifique-se de ter inserido o endere\xe7o correto do token."],"Network Error":"Erro de rede","Add Custom Token":"Adicionar token personalizado","Select chain":"Selecione a cadeia","Enter Address":"Inserir Endere\xe7o","Enter token address":"Inserir endere\xe7o do token","Failed Network, Please retry.":"Rede falhada, por favor, tente novamente.","Add another custom token":"Adicionar outro token personalizado","Confirm Swap":"Confirmar troca","Start Swap":"Trocar de in\xedcio","You get":"Voc\xea recebe","Search Token":"Token de pesquisa","No custom tokens":"Sem tokens personalizados","press the button to add your custom token":"pressione o bot\xe3o para adicionar seu token personalizado","Delete Custom Token":"Excluir token personalizado","Are you sure you want to Delete this Token?":"Tem certeza que deseja excluir este Token?","Complete":"Complete","Running":"Executando","Failed":"Falhou","Clear":"Limpar","Search Transaction":"Pesquisar transa\xe7\xe3o","No transactions":"Nenhuma transa\xe7\xe3o","Your transaction history is stored locally and will appear here after you start a swap":"Seu hist\xf3rico de transa\xe7\xf5es \xe9 armazenado localmente e aparecer\xe1 aqui depois que voc\xea come\xe7ar uma troca","Clear Transaction History":"Limpar hist\xf3rico de transa\xe7\xf5es","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"O processo ir\xe1 remover todas as transa\xe7\xf5es com sucesso e falha do widget. Deseja continuar?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Nota: Isso n\xe3o apaga seu hist\xf3rico de transa\xe7\xf5es na cadeia; s\xf3 os remove aqui.","Yes, Clear the history":"Sim, limpar o hist\xf3rico","language":"Idioma","Deselect all":"Desmarcar todos","Select all":"Selecionar todos","Search {sourceType}":["Pesquisar em ",["sourceType"]],"Search Chain":"Buscar Cadeia","Source":"fonte","Destination":"Destino","Swap {type}":["Trocar ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Atualmente, voc\xea est\xe1 no modo campanha com restri\xe7\xf5es sobre fontes de liquidez. Gostaria de mudar este modo e usar todas as fontes de liquidez dispon\xedveis?","The request ID is necessary to display the swap details.":"O ID da requisi\xe7\xe3o \xe9 necess\xe1rio para exibir os detalhes do swap.","Connect Wallets":"Conectar Carteiras","Choose a wallet to connect.":"Escolha uma carteira para se conectar.","This week":"Esta semana","This month":"Este M\xeas","This year":"Esse ano","Required: >= {min} {symbol}":["Obrigat\xf3rio: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Obrigat\xf3rio: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Obrigat\xf3rio: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Obrigat\xf3rio: < ",["max"]," ",["symbol"]]," for network fee":" para taxa de rede"," for swap":" para troca"," for input and network fee":" por taxa de entrada e de rede","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Precisa de ",["requiredAmount"]," ",["symbol"],["reason"],", mas voc\xea tem ",["currentAmount"]," ",["symbol"]," na sua carteira ",["blockchain"],"."],"Waiting for connecting wallet":"Aguardando conex\xe3o da carteira","Waiting for other running tasks to be finished":"Aguardando o t\xe9rmino de outras tarefas em execu\xe7\xe3o","Waiting for changing wallet network":"Aguardando mudan\xe7a da rede de carteira","Sunday":"domingo","Monday":"Segunda-Feira","Tuesday":"Ter\xe7a-feira","Wednesday":"quarta-feira","Thursday":"quinta-feira","Friday":"Sexta-feira","Saturday":"s\xe1bado","Powered By":"Desenvolvido por","Aggregated Transaction":"Transa\xe7\xe3o Agregada","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Trocar em ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Ponte para ",["toChain"]," via ",["swapper"]],"Completed":"Conclu\xeddo","In progress":"Em Execu\xe7\xe3o","Waiting for bridge transaction":"Aguardando a transa\xe7\xe3o da bridge","Connected":"Conectado","Disconnect":"Desconectar","Install":"Instale","Connecting ...":"Conectando ...","Connecting":"Conectando","Disconnected":"Desconectado","you need to pass a correct state to Wallet.":"voc\xea precisa passar um estado correto para o Wallet.","There are no notifications.":"N\xe3o h\xe1 notifica\xe7\xf5es.","Clear all":"Limpar tudo","Balance":"Saldo","Max":"M\xe1ximo"}');


/*eslint-disable*/ const $c8a5ea4be110b179$export$defe85febe8b728c = JSON.parse('{"No results found":"\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","Try using different keywords":"\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u043D\u044B\u0435 \u043A\u043B\u044E\u0447\u0435\u0432\u044B\u0435 \u0441\u043B\u043E\u0432\u0430","Select Chain":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0435\u043F\u044C","All":"\u0412\u0441\u0435","More +{count}":["\u0411\u043E\u043B\u044C\u0448\u0435 +",["count"]],"Activate this tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Another tab is open and handles transactions.":"\u0415\u0449\u0435 \u043E\u0434\u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u0430 \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438.","Activate current tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u044E\u0442\u0441\u044F \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0434\u0440\u0443\u0433\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u043E\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u0415\u0441\u043B\u0438 \u0432\u044B \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0435\u0442\u0435 \u044D\u0442\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0432\u0441\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0443\u0436\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u0448\u0430\u0433\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439, \u0438\u0441\u0442\u0435\u043A\u0430\u044E\u0442.","Confirm":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C","Your {blockchainName} wallets":["\u0412\u0430\u0448\u0438 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438 ",["blockchainName"]],"Insufficient account balance":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u0441\u0447\u0435\u0442\u0435","Proceed anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","You need to connect a {blockchainName} wallet.":["\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A ",["blockchainName"],"."],"Add {chain} chain":["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0446\u0435\u043F\u043E\u0447\u043A\u0443 ",["chain"]],"Show more wallets":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u043E\u0432","Send to a different address":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u0434\u0440\u0435\u0441","Enter {blockchainName} address":["\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":[["destination"]," \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0430 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D\u0430."],"via":"\u0447\u0435\u0440\u0435\u0437","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u042D\u0442\u043E\u0442 \u0442\u043E\u043A\u0435\u043D \u043D\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u0432 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0441\u043F\u0438\u0441\u043A\u0430\u0445 \u0442\u043E\u043A\u0435\u043D\u043E\u0432. \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u044D\u0442\u043E \u0442\u043E\u043A\u0435\u043D, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0442\u043E\u0440\u0433\u043E\u0432\u0430\u0442\u044C.","Import":"\u0418\u043C\u043F\u043E\u0440\u0442","Status":"\u0421\u0442\u0430\u0442\u0443\u0441","Reset":"Reset","Cancel":"\u041E\u0442\u043C\u0435\u043D\u0430","Refresh":"\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C","Notifications":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F","Settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","History":"\u0418\u0441\u0442\u043E\u0440\u0438\u044F","Connect Wallet":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A","Today":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","Swaps steps":"\u041C\u0435\u043D\u044F\u0435\u0442 \u0448\u0430\u0433\u0438","Retry":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C","Slippage Error":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F","Slippage Warning":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F","Bridge Limit Error":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043C\u043E\u0441\u0442\u0430","Yours: {amount} {symbol}":["\u0412\u0430\u0448\u0438: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u043E\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0412\u0430\u0448\u0438: ",["userSlippage"]],"See All Routes":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u044B","View more info":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","Gas & Fee Explanation":"\u041E\u0431\u044A\u044F\u0441\u043D\u0435\u043D\u0438\u0435 \u0433\u0430\u0437\u0430 \u0438 \u043F\u043B\u0430\u0442\u044B","Details":"\u0414\u0435\u0442\u0430\u043B\u0438","Total Payable Fee":"\u041E\u0431\u0449\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430","Hide non-payable fees":"\u0421\u043A\u0440\u044B\u0442\u044C \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438","Show non-payable fees":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0441\u0431\u043E\u0440\u044B","Description":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0438 \u0432\u044B\u0432\u043E\u0434\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439, \u0438\\n                \u0432\u0430\u043C \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0437\u0430 \u043D\u0438\u0445 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u0430\u0437.","Swap input":"Swap input","Estimated output":"\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u044B\u0445\u043E\u0434","Via:":"\u0412\u0438\u0430:","Chains:":"\u0426\u0435\u043F\u043E\u0447\u043A\u0438:","Sort by":"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E","Smart Routing":"\u0423\u043C\u043D\u0430\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0438\u044F","Lowest Fee":"\u0421\u0430\u043C\u0430\u044F \u043D\u0438\u0437\u043A\u0430\u044F \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F","Fastest Transfer":"\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434","Maximum Return":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u043E\u0437\u0432\u0440\u0430\u0442","Maximum Output":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u044B\u0432\u043E\u0434","Swapping":"Swapping","Gas cost":"\u0417\u0430\u0442\u0440\u0430\u0442\u044B \u0433\u0430\u0437\u0430","Receiving":"\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435","Price impact":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u0446\u0435\u043D\u044B","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 \u0434\u043E ",["minRequiredSlippage"]," \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0432\u0430\u043C \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u043F\u043E \u043A\u0440\u0430\u0439\u043D\u0435\u0439 \u043C\u0435\u0440\u0435 \u0434\u043E ",["minRequiredSlippage"]," \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430."],"Caution, your slippage is high.":"\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0432\u0430\u0448\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E.","Change":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C","Change settings":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","High slippage":"\u0412\u044B\u0441\u043E\u043A\u043E\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435","Low slippage":"\u041D\u0438\u0437\u043A\u043E\u0435 \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435, \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u0435 (=",["userSlippage"],"). \u0412\u0430\u0448\u0430 \u0441\u0434\u0435\u043B\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u043D\u0435\u0433\u043E \u0437\u0430\u043F\u0443\u0441\u043A\u0430."],"Confirm anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C","Something went wrong":"\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A","Something went wrong. Please refresh the app.":"\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435.","Slippage tolerance per swap":"\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0441\u043A\u0430\u043B\u044C\u0437\u044B\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0441\u043C\u0435\u043D\u0443","Custom":"\u0421\u0432\u043E\u0439","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0412\u0430\u0448\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430, \u0435\u0441\u043B\u0438 \u0446\u0435\u043D\u0430 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0441\u044F \u0431\u043E\u043B\u0435\u0435 \u0447\u0435\u043C \u043D\u0430 \u044D\u0442\u043E\u0442 \u043F\u0440\u043E\u0446\u0435\u043D\u0442.","Warning":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u042D\u0442\u043E\u0442 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u043A \u043A\u0430\u0436\u0434\u043E\u043C\u0443 \u0448\u0430\u0433\u0443 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, 1Inch, Thorchain \u0438 \u0442.\u0434.). \u042D\u0442\u043E \u043E\u0437\u043D\u0430\u0447\u0430\u0435\u0442, \u0447\u0442\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0439 \u0448\u0430\u0433 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u0440\u0430\u0449\u0435\u043D, \u0430 \u043D\u0435 \u0432\u0435\u0441\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442.","Swap Details":"\u0414\u0435\u0442\u0430\u043B\u0438 \u043E\u0431\u043C\u0435\u043D\u0430","Request ID":"ID \u0437\u0430\u043F\u0440\u043E\u0441\u0430","Not found":"\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","Swap with request ID = {requestId} not found.":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ID \u0437\u0430\u043F\u0440\u043E\u0441\u0430 = ",["requestId"]," \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 ",["amount"]," ",["token"]," \u043D\u0430 ",["conciseAddress"]," \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435 \u043D\u0430 \u0446\u0435\u043F\u043E\u0447\u043A\u0435 ",["chain"],"."],"Transaction was not sent.":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u043D\u0430 ",["blockchain"]," \u043E\u0441\u0442\u0430\u0435\u0442\u0441\u044F \u0432 \u0432\u0430\u0448\u0435\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435."],"Delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","Try again":"\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437","Copied To Clipboard":"\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430","Copy Request ID":"\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C ID \u0437\u0430\u043F\u0440\u043E\u0441\u0430","View on Rango Explorer":"\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 \u043F\u0440\u043E\u0432\u043E\u0434\u043D\u0438\u043A\u0435 Rango","Finished at":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0432","Created at":"\u0421\u043E\u0437\u0434\u0430\u043D\u043E \u0432","View transaction":"\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","Connect":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Swap Successful":"\u041F\u043E\u043C\u0435\u043D\u044F\u043D\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E","Transaction Failed":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u0430\u0441\u044C","Done":"\u0413\u043E\u0442\u043E\u0432\u043E","Diagnosis":"\u0414\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430","See Details":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","Cancel Swap":"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0437\u0430\u043C\u0435\u043D\u0443","Are you sure you want to cancel this swap?":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u043E\u0431\u043C\u0435\u043D?","Yes, Cancel it":"\u0414\u0430, \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C","No, Continue":"\u041D\u0435\u0442, \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","Delete Transaction":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E","Are you sure you want to delete this swap?":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043C\u0435\u043D\u0443?","Yes, Delete it":"\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C","No, Cancel":"\u041D\u0435\u0442, \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C","Change Network":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0435\u0442\u044C","Network Changed":"\u0421\u0435\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430","Select Token":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u043E\u043A\u0435\u043D","Wallet Connected":"\u041A\u043E\u0448\u0435\u043B\u0435\u043A \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D","Your wallet is connected, you can use it to swap.":"\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0435\u0433\u043E \u0434\u043B\u044F \u0441\u043C\u0435\u043D\u044B.","Failed to Connect":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Your wallet is not connected. Please try again.":"\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437.","Connecting to your wallet":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443","Click connect in your wallet popup.":"\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u043E \u0432\u0441\u043F\u043B\u044B\u0432\u0430\u044E\u0449\u0435\u043C \u043E\u043A\u043D\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.","Select Derivation Path":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0443\u0442\u044C \u0434\u0435\u0440\u0438\u0432\u0430\u0446\u0438\u0438","In order to connect to {type}, you must first select a Derivation Path":["\u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043A ",["type"],", \u0432\u044B \u0434\u043E\u043B\u0436\u043D\u044B \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0443\u0442\u044C \u043A \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0443."],"Choose Derivation Path Template":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D \u043F\u0443\u0442\u0438 \u0434\u0435\u0440\u0438\u0432\u0430\u0446\u0438\u0438","Enter Path":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0443\u0442\u044C","Enter Index":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043D\u0434\u0435\u043A\u0441","Add {blockchainDisplayName} Chain":["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0446\u0435\u043F\u043E\u0447\u043A\u0443 ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u044D\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0443\u044E \u0446\u0435\u043F\u043E\u0447\u043A\u0443 ",["blockchainDisplayName"]," \u0432 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A?"],"Please approve the experimental chain pop-up in your wallet.":"\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043E\u043A\u043D\u043E \u044D\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0439 \u0446\u0435\u043F\u043E\u0447\u043A\u0438 \u0432 \u0432\u0430\u0448\u0435\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0446\u0435\u043F\u043E\u0447\u043A\u0430 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u0426\u0435\u043F\u043E\u0447\u043A\u0430 ",["blockchainDisplayName"]," \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A."],"Request Rejected":"\u0417\u0430\u043F\u0440\u043E\u0441 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0412\u044B \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0446\u0435\u043F\u043E\u0447\u043A\u0438 ",["blockchainDisplayName"]," \u0432 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A."],"Select chain types":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F\u044B \u0446\u0435\u043F\u043E\u0447\u043A\u0438","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u042D\u0442\u043E\u0442 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0446\u0435\u043F\u043E\u043A. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u043A \u043A\u0430\u043A\u043E\u0439 \u0446\u0435\u043F\u043E\u0447\u043A\u0435 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F.","Failed Network, Please retry your swap.":"\u041D\u0435\u0443\u0434\u0430\u0447\u043D\u0430\u044F \u0441\u0435\u0442\u044C, \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u0437\u0430\u043C\u0435\u043D\u0443.","Please reset your liquidity sources.":"\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0412\u044B \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u044B \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u043C\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438, \u0438 \u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043A Rango \u043D\u0435 \u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043E \u0441\u0431\u0440\u043E\u0441\u0435 \u0432\u0430\u0448\u0438\u0445 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","No Routes Found.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u041F\u0440\u0438\u0447\u0438\u043D\u044B \u043F\u043E\u0447\u0435\u043C\u0443 Rango \u043D\u0435 \u0441\u043C\u043E\u0433 \u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442: \u043D\u0438\u0437\u043A\u0430\u044F \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u044C \u043D\u0430 \u0442\u043E\u043A\u0435\u043D\u0435, \u043E\u0447\u0435\u043D\u044C \u043D\u0438\u0437\u043A\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0432\u0432\u043E\u0434\u0430 \u0438\u043B\u0438 \u043D\u0435\u0442 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u0432 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043A\u043E\u043C\u0431\u0438\u043D\u0430\u0446\u0438\u0438 \u0442\u043E\u043A\u0435\u043D\u0430 \u0432\u0432\u043E\u0434\u0430/\u0432\u044B\u0432\u043E\u0434\u0430.","Bridge Limit Error: Please increase your amount.":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043B\u0438\u043C\u0438\u0442\u0430 \u043C\u043E\u0441\u0442\u0430: \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u0432\u0435\u043B\u0438\u0447\u044C\u0442\u0435 \u0441\u0443\u043C\u043C\u0443.","Bridge Limit Error: Please decrease your amount.":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043B\u0438\u043C\u0438\u0442\u0430 \u043C\u043E\u0441\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443.","High Price Impact":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u0446\u0435\u043D\u044B","Price impact is too high!":"\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443!","The price impact is significantly higher than the allowed amount.":"\u0412\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u044B \u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u044B\u0448\u0435, \u0447\u0435\u043C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430.","Confirm high price impact":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u0446\u0435\u043D\u044B","Route updated and price impact is too high, try again later!":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0451\u043D \u0438 \u0446\u0435\u043D\u0430 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0441\u043E\u043A\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435!","USD Price Unknown":"\u0426\u0435\u043D\u0430 USD \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430","USD Price Unknown, Cannot calculate Price Impact.":"USD \u0426\u0435\u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430, \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \u0426\u0435\u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430, \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443. \u0412\u043E\u0437\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0430 \u0446\u0435\u043D\u0443 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0432\u044B\u0448\u0435, \u0447\u0435\u043C \u043E\u0431\u044B\u0447\u043D\u043E. \u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?","Confirm USD Price Unknown":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0443\u044E \u0446\u0435\u043D\u0443 \u0432 USD","Swap":"\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C","Swap anyway":"\u0412\u0441\u0435 \u0440\u0430\u0432\u043D\u043E \u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C","The route goes through Ethereum. Continue?":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0447\u0435\u0440\u0435\u0437 Ethereum. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?","Route has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0421\u0443\u043C\u043C\u0430 \u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043D\u0430 ",["newOutputAmount"]," (",["percentageChange"],"% \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E)."],"Route swappers has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043E\u0431\u043C\u0435\u043D\u0430 \u0431\u044B\u043B \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.","Route internal coins has been updated.":"\u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u043C\u043E\u043D\u0435\u0442\u044B \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B.","Routes":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B","From":"\u041E\u0442","To":"\u041A\u043E\u043C\u0443","Light":"\u0421\u0432\u0435\u0442\u043B\u0430\u044F","Dark":"\u0422\u0451\u043C\u043D\u0430\u044F","Auto":"\u0410\u0432\u0442\u043E","Loading failed":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C","Bridges":"\u041C\u043E\u0441\u0442\u044B","Exchanges":"\u041E\u0431\u043C\u0435\u043D\u044B","Custom Tokens":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0442\u043E\u043A\u0435\u043D\u044B","Language":"\u042F\u0437\u044B\u043A","Infinite approval":"\u0411\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \\"\u0411\u0435\u0441\u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435\\" \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u043C \u0441\u043C\u0430\u0440\u0442-\u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430\u043C, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044F \u0438\u043C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443 \u0442\u043E\u043A\u0435\u043D\u0430 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439.","Theme":"\u0422\u0435\u043C\u0430","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0439 \u0432\u0430\u043C\u0438 \u0430\u0434\u0440\u0435\u0441 \u0434\u0443\u0431\u043B\u0438\u0440\u0443\u0435\u0442\u0441\u044F, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441.","Token Already Exists":"\u0422\u043E\u043A\u0435\u043D \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442","There\'s no need to add this token again because it already exists and is supported by us.":"\u041D\u0435 \u043D\u0443\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u043A\u0435\u043D \u0441\u043D\u043E\u0432\u0430, \u043F\u043E\u0442\u043E\u043C\u0443 \u0447\u0442\u043E \u043E\u043D \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043C\u0438.","Token Not Found":"\u0422\u043E\u043A\u0435\u043D \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u043E \u0446\u0435\u043F\u043E\u0447\u043A\u0435 ",["blockchain"]," \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0442\u043E\u043A\u0435\u043D\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0432\u044B \u0432\u0432\u0435\u043B\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0442\u043E\u043A\u0435\u043D\u0430."],"Network Error":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438","Add Custom Token":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Select chain":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0435\u043F\u043E\u0447\u043A\u0443","Enter Address":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441","Enter token address":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u0442\u043E\u043A\u0435\u043D\u0430","Failed Network, Please retry.":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438, \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","Add another custom token":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Confirm Swap":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0441\u043C\u0435\u043D\u044B","Start Swap":"\u041D\u0430\u0447\u0430\u0442\u044C \u043E\u0431\u043C\u0435\u043D","You get":"\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435","Search Token":"\u041F\u043E\u0438\u0441\u043A \u0442\u043E\u043A\u0435\u043D\u0430","No custom tokens":"\u041D\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u043E\u0432","press the button to add your custom token":"\u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Delete Custom Token":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Are you sure you want to Delete this Token?":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u043A\u0435\u043D?","Complete":"Complete","Running":"\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F","Failed":"\u041D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0439","Clear":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C","Search Transaction":"\u041F\u043E\u0438\u0441\u043A \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","No transactions":"\u041D\u0435\u0442 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","Your transaction history is stored locally and will appear here after you start a swap":"\u0412\u0430\u0448\u0430 \u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0438 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u043E\u0431\u043C\u0435\u043D\u0430","Clear Transaction History":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432\u0441\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0435 \u0438 \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u0438\u0437 \u0432\u0438\u0434\u0436\u0435\u0442\u0430. \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u042D\u0442\u043E \u043D\u0435 \u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0432 \u0446\u0435\u043F\u043E\u0447\u043A\u0435; \u043E\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0443\u0434\u0430\u043B\u044F\u0435\u0442 \u0438\u0445 \u0437\u0434\u0435\u0441\u044C.","Yes, Clear the history":"\u0414\u0430, \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0440\u0438\u044E","language":"\u044F\u0437\u044B\u043A","Deselect all":"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440","Select all":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435","Search {sourceType}":["\u0418\u0441\u043A\u0430\u0442\u044C ",["sourceType"]],"Search Chain":"\u041F\u043E\u0438\u0441\u043A \u0446\u0435\u043F\u043E\u0447\u043A\u0438","Source":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A","Destination":"\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435","Swap {type}":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0432\u044B \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0435\u0441\u044C \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0438 \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438. \u0412\u044B\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0435\u0436\u0438\u043C \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438?","The request ID is necessary to display the swap details.":"\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043E swap.","Connect Wallets":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0438","Choose a wallet to connect.":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F.","This week":"\u042D\u0442\u0430 \u043D\u0435\u0434\u0435\u043B\u044F","This month":"\u042D\u0442\u043E\u0442 \u043C\u0435\u0441\u044F\u0446","This year":"\u0412 \u044D\u0442\u043E\u043C \u0433\u043E\u0434\u0443","Required: >= {min} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439: < ",["max"]," ",["symbol"]]," for network fee":" \u0437\u0430 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E \u0441\u0435\u0442\u0438"," for swap":" \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u0430\u0447\u043A\u0438"," for input and network fee":" \u0437\u0430 \u0432\u0432\u043E\u0434 \u0438 \u0441\u0435\u0442\u0435\u0432\u043E\u0439 \u0441\u0431\u043E\u0440","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u041D\u0443\u0436\u043D\u043E <unk> ",["requiredAmount"]," ",["symbol"],["reason"],", \u043D\u043E \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C ",["currentAmount"]," ",["symbol"]," \u0432 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435 ",["blockchain"],"."],"Waiting for connecting wallet":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430","Waiting for other running tasks to be finished":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447","Waiting for changing wallet network":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0435\u0442\u0438 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430","Sunday":"\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435","Monday":"\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A","Tuesday":"\u0412\u0442\u043E\u0440\u043D\u0438\u043A","Wednesday":"\u0421\u0440\u0435\u0434\u0430","Thursday":"\u0427\u0435\u0442\u0432\u0435\u0440\u0433","Friday":"\u041F\u044F\u0442\u043D\u0438\u0446\u0430","Saturday":"\u0421\u0443\u0431\u0431\u043E\u0442\u0430","Powered By":"\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430","Aggregated Transaction":"\u0410\u0433\u0440\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u041F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u043D\u0430 ",["fromChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u041C\u043E\u0441\u0442 \u043A ",["toChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Completed":"\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","In progress":"\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435","Waiting for bridge transaction":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u043F\u043E \u043C\u043E\u0441\u0442\u0443","Connected":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","Disconnect":"\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F","Install":"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C","Connecting ...":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...","Connecting":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435","Disconnected":"\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E","you need to pass a correct state to Wallet.":"\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u041A\u043E\u0448\u0435\u043B\u044C\u043A\u0443 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435.","There are no notifications.":"\u041D\u0435\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439.","Clear all":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435","Balance":"\u0411\u0430\u043B\u0430\u043D\u0441","Max":"\u041C\u0430\u043A\u0441"}');


/*eslint-disable*/ const $add9ce5f91c74d3d$export$defe85febe8b728c = JSON.parse('{"No results found":"Nena\u0161li sa \u017Eiadne v\xfdsledky","Try using different keywords":"Sk\xfaste pou\u017Ei\u0165 in\xe9 k\u013E\xfa\u010Dov\xe9 slov\xe1","Select Chain":"Vyberte polo\u017Eku Re\u0165az","All":"V\u0161etky","More +{count}":["Viac +",["count"]],"Activate this tab":"Aktivujte t\xfato kartu","Another tab is open and handles transactions.":"\u010Eal\u0161ia karta je otvoren\xe1 a spracov\xe1va transakcie.","Activate current tab":"Aktivova\u0165 aktu\xe1lnu kartu","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"V s\xfa\u010Dasnosti s\xfa niektor\xe9 transakcie spusten\xe9 a spracov\xe1van\xe9 inou kartou prehliada\u010Da. Ak aktivujete t\xfato kartu, platnos\u0165 v\u0161etk\xfdch transakci\xed, ktor\xe9 sa u\u017E nach\xe1dzaj\xfa v kroku podpisu transakcie, vypr\u0161\xed.","Confirm":"Potvr\u010Fte","Your {blockchainName} wallets":["Va\u0161e ",["blockchainName"]," pe\u0148a\u017Eenky"],"Insufficient account balance":"Nedostato\u010Dn\xfd zostatok na \xfa\u010Dte","Proceed anyway":"Aj tak pokra\u010Dujte","You need to connect a {blockchainName} wallet.":["Mus\xedte pripoji\u0165 ",["blockchainName"]," pe\u0148a\u017Eenku."],"Add {chain} chain":["Pridajte re\u0165azec ",["chain"]],"Show more wallets":"Zobrazi\u0165 viac pe\u0148a\u017Eeniek","Send to a different address":"Odosla\u0165 na in\xfa adresu","Enter {blockchainName} address":["Zadajte ",["blockchainName"]," adresu"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adresa ",["destination"]," sa nezhoduje so vzorom adresy blockchain."],"via":"cez","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Tento token sa nezobrazuje v akt\xedvnych zoznamoch tokenov. Uistite sa, \u017Ee ide o token, s ktor\xfdm chcete obchodova\u0165.","Import":"Importova\u0165","Status":"Stav","Reset":"Resetova\u0165","Cancel":"Zru\u0161i\u0165","Refresh":"Obnovi\u0165","Notifications":"Upozornenia","Settings":"Nastavenia","History":"Hist\xf3ria","Connect Wallet":"Pripoji\u0165 Pe\u0148a\u017Eenku","Today":"Dnes","Swaps steps":"Vymie\u0148a kroky","Retry":"Sk\xfaste to znova","Slippage Error":"Chyba sklzu","Slippage Warning":"Upozornenie na sklz","Bridge Limit Error":"Chyba limitu mosta","Yours: {amount} {symbol}":["V\xe1\u0161: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minim\xe1lny po\u017Eadovan\xfd sklz: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["V\xe1\u0161: ",["userSlippage"]],"See All Routes":"Pozrite si v\u0161etky trasy","View more info":"Zobrazi\u0165 viac inform\xe1ci\xed","Gas & Fee Explanation":"Vysvetlenie plynu a poplatkov","Details":"Podrobnosti","Total Payable Fee":"Celkov\xfd splatn\xfd poplatok","Hide non-payable fees":"Skry\u0165 neplatite\u013En\xe9 poplatky","Show non-payable fees":"Uk\xe1\u017Ete nezaplatite\u013En\xe9 poplatky","Description":"Popis","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Nasleduj\xface poplatky s\xfa zoh\u013Eadnen\xe9 vo v\xfdstupe transakcie a\\n                za ne nebudete musie\u0165 plati\u0165 extra plyn.","Swap input":"Vyme\u0148te vstup","Estimated output":"Odhadovan\xfd v\xfdstup","Via:":"cez:","Chains:":"re\u0165aze:","Sort by":"Zoradi\u0165 pod\u013Ea","Smart Routing":"Inteligentn\xe9 smerovanie","Lowest Fee":"Najni\u017E\u0161\xed poplatok","Fastest Transfer":"Najr\xfdchlej\u0161\xed prevod","Maximum Return":"Maxim\xe1lna n\xe1vratnos\u0165","Maximum Output":"Maxim\xe1lny v\xfdkon","Swapping":"V\xfdmena","Gas cost":"N\xe1klady na plyn","Receiving":"Prij\xedmanie","Price impact":"Vplyv na cenu","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Pre t\xfato trasu mus\xedte zv\xfd\u0161i\u0165 sklz aspo\u0148 na ",["minRequiredSlippage"]," ."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Na tejto trase v\xe1m odpor\xfa\u010Dame zv\xfd\u0161i\u0165 sklz aspo\u0148 na ",["minRequiredSlippage"]," ."],"Caution, your slippage is high.":"Pozor, v\xe1\u0161 sklz je vysok\xfd.","Change":"Zmeni\u0165","Change settings":"Zme\u0148te nastavenia","High slippage":"Vysok\xfd sklz","Low slippage":"N\xedzky sklz"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Pozor, v\xe1\u0161 sklz je vysok\xfd (=",["userSlippage"],"). V\xe1\u0161 obchod m\xf4\u017Ee by\u0165 front run."],"Confirm anyway":"Napriek tomu potvr\u010Fte","Something went wrong":"Nie\u010Do sa pokazilo","Something went wrong. Please refresh the app.":"Nie\u010Do sa pokazilo. Obnovte aplik\xe1ciu.","Slippage tolerance per swap":"Tolerancia sklzu na v\xfdmenu","Custom":"Vlastn\xe9","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Va\u0161a transakcia bude vr\xe1ten\xe1, ak sa cena nepriaznivo zmen\xed o viac ako toto percento.","Warning":"POZOR","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Toto nastavenie sa aplikuje na ka\u017Ed\xfd krok (napr. 1Inch, Thorchain at\u010F.), \u010Do znamen\xe1, \u017Ee sa vr\xe1ti iba tento konkr\xe9tny krok, nie cel\xe1 trasa.","Swap Details":"Podrobnosti o v\xfdmene","Request ID":"ID \u017Eiadosti","Not found":"Nen\xe1jden\xe9","Swap with request ID = {requestId} not found.":["Z\xe1mena s ID po\u017Eiadavky = ",["requestId"]," sa nena\u0161la."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Dostali ste ",["amount"]," ",["token"]," do ",["conciseAddress"]," pe\u0148a\u017Eenky v re\u0165azci ",["chain"]," ."],"Transaction was not sent.":"Transakcia nebola odoslan\xe1.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," na ",["blockchain"]," zost\xe1va vo va\u0161ej pe\u0148a\u017Eenke."],"Delete":"Odstr\xe1ni\u0165","Try again":"Sk\xfaste to znova","Copied To Clipboard":"Skop\xedrovan\xe9 do schr\xe1nky","Copy Request ID":"Skop\xedrova\u0165 ID \u017Eiadosti","View on Rango Explorer":"Zobrazi\u0165 na Rango Explorer","Finished at":"Dokon\u010Den\xe9 o","Created at":"Vytvoren\xe9 o","View transaction":"Zobrazi\u0165 transakciu","Connect":"Pripojte sa","Swap Successful":"V\xfdmena bola \xfaspe\u0161n\xe1","Transaction Failed":"Transakcia zlyhala","Done":"Hotovo","Diagnosis":"Diagn\xf3za","See Details":"Pozri Podrobnosti","Cancel Swap":"Zru\u0161i\u0165 v\xfdmenu","Are you sure you want to cancel this swap?":"Naozaj chcete zru\u0161i\u0165 t\xfato v\xfdmenu?","Yes, Cancel it":"\xc1no, zru\u0161i\u0165","No, Continue":"Nie, pokra\u010Dova\u0165","Delete Transaction":"Odstr\xe1ni\u0165 transakciu","Are you sure you want to delete this swap?":"Naozaj chcete odstr\xe1ni\u0165 t\xfato v\xfdmenu?","Yes, Delete it":"\xc1no, vymaza\u0165","No, Cancel":"Nie, zru\u0161i\u0165","Change Network":"Zmeni\u0165 sie\u0165","Network Changed":"Sie\u0165 zmenen\xe1","Select Token":"Vyberte polo\u017Eku Token","Wallet Connected":"Pe\u0148a\u017Eenka je pripojen\xe1","Your wallet is connected, you can use it to swap.":"Va\u0161a pe\u0148a\u017Eenka je pripojen\xe1, m\xf4\u017Eete ju pou\u017Ei\u0165 na v\xfdmenu.","Failed to Connect":"Nepodarilo sa pripoji\u0165","Your wallet is not connected. Please try again.":"Va\u0161a pe\u0148a\u017Eenka nie je pripojen\xe1. Sk\xfaste to znova.","Connecting to your wallet":"Pripojenie k va\u0161ej pe\u0148a\u017Eenke","Click connect in your wallet popup.":"Vo vyskakovacom okne pe\u0148a\u017Eenky kliknite na Pripoji\u0165.","Select Derivation Path":"Vyberte cestu odvodenia","In order to connect to {type}, you must first select a Derivation Path":["Ak sa chcete pripoji\u0165 k ",["type"],", mus\xedte najprv vybra\u0165 cestu odvodenia"],"Choose Derivation Path Template":"Vyberte mo\u017Enos\u0165 \u0160abl\xf3na odvodenej cesty","Enter Path":"Zadajte cestu","Enter Index":"Zadajte index","Add {blockchainDisplayName} Chain":["Pridajte re\u0165azec ",["blockchainDisplayName"]],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Chceli by ste do svojej pe\u0148a\u017Eenky prida\u0165 experiment\xe1lny re\u0165azec ",["blockchainDisplayName"]," ?"],"Please approve the experimental chain pop-up in your wallet.":"Schv\xe1\u013Ete kontextov\xe9 okno experiment\xe1lneho re\u0165azca vo va\u0161ej pe\u0148a\u017Eenke.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Pridan\xfd re\u0165azec"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Re\u0165azec ",["blockchainDisplayName"]," bol \xfaspe\u0161ne pridan\xfd do va\u0161ej pe\u0148a\u017Eenky."],"Request Rejected":"\u017Diados\u0165 zamietnut\xe1","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Odmietli ste prida\u0165 re\u0165azec ",["blockchainDisplayName"]," do va\u0161ej pe\u0148a\u017Eenky."],"Select chain types":"Vyberte typy re\u0165az\xed","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"T\xe1to pe\u0148a\u017Eenka podporuje viacero re\u0165az\xed. Vyberte re\u0165azec, ku ktor\xe9mu sa chcete pripoji\u0165.","Failed Network, Please retry your swap.":"Sie\u0165 zlyhala, sk\xfaste v\xfdmenu zopakova\u0165.","Please reset your liquidity sources.":"Obnovte zdroje likvidity.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Obmedzili ste zdroje likvidity a to m\xf4\u017Ee vies\u0165 k tomu, \u017Ee Rango nen\xe1jde \u017Eiadne cesty. Zv\xe1\u017Ete resetovanie zdrojov likvidity.","No Routes Found.":"Nena\u0161li sa \u017Eiadne trasy.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"D\xf4vody, pre\u010Do Rango nemohol n\xe1js\u0165 cestu: n\xedzka likvidita tokenu, ve\u013Emi n\xedzka vstupn\xe1 suma alebo \u017Eiadne dostupn\xe9 cesty pre zvolen\xfa kombin\xe1ciu vstupn\xfdch/v\xfdstupn\xfdch tokenov.","Bridge Limit Error: Please increase your amount.":"Chyba limitu mosta: Zv\xfd\u0161te svoju sumu.","Bridge Limit Error: Please decrease your amount.":"Chyba limitu mosta: Zn\xed\u017Ete sumu.","High Price Impact":"Vysok\xfd vplyv na cenu","Price impact is too high!":"Vplyv na cenu je pr\xedli\u0161 vysok\xfd!","The price impact is significantly higher than the allowed amount.":"Cenov\xfd vplyv je v\xfdrazne vy\u0161\u0161\xed ako povolen\xe1 suma.","Confirm high price impact":"Potvr\u010Fte vysok\xfd cenov\xfd vplyv","Route updated and price impact is too high, try again later!":"Trasa bola aktualizovan\xe1 a vplyv na cenu je pr\xedli\u0161 vysok\xfd, sk\xfaste to znova nesk\xf4r!","USD Price Unknown":"Cena v USD nezn\xe1ma","USD Price Unknown, Cannot calculate Price Impact.":"Cena v USD nie je zn\xe1ma, vplyv na cenu sa ned\xe1 vypo\u010D\xedta\u0165.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Cena v USD nie je zn\xe1ma, nie je mo\u017En\xe9 vypo\u010D\xedta\u0165 vplyv na cenu. Cenov\xfd vplyv m\xf4\u017Ee by\u0165 vy\u0161\u0161\xed ako zvy\u010Dajne. Naozaj chcete pokra\u010Dova\u0165 vo v\xfdmene?","Confirm USD Price Unknown":"Potvrdenie ceny v USD nie je zn\xe1me","Swap":"Vyme\u0148te","Swap anyway":"Aj tak vymeni\u0165","The route goes through Ethereum. Continue?":"Trasa vedie cez Ethereum. Pokra\u010Dova\u0165?","Route has been updated.":"Trasa bola aktualizovan\xe1.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["V\xfdstupn\xe9 mno\u017Estvo zmenen\xe9 na ",["newOutputAmount"]," (",["percentageChange"],"% zmena)."],"Route swappers has been updated.":"V\xfdmenn\xedky tr\xe1s boli aktualizovan\xe9.","Route internal coins has been updated.":"Trasa intern\xfdch minc\xed bola aktualizovan\xe1.","Routes":"Trasy","From":"Od","To":"Komu","Light":"Svetlo","Dark":"Tmav\xfd","Auto":"Auto","Loading failed":"Na\u010D\xedtanie zlyhalo","Bridges":"Mosty","Exchanges":"V\xfdmeny","Custom Tokens":"Vlastn\xe9 tokeny","Language":"Jazyk","Infinite approval":"Nekone\u010Dn\xfd s\xfahlas","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Povolenie re\u017Eimu \u201ENekone\u010Dn\xe9 schv\xe1lenie\u201C poskytuje neobmedzen\xfd pr\xedstup k z\xe1kladn\xfdm inteligentn\xfdm zmluv\xe1m, \u010Do im umo\u017E\u0148uje vyu\u017E\xedva\u0165 schv\xe1len\xfa sumu tokenu bez obmedzen\xed.","Theme":"T\xe9ma","Duplicate Token":"Duplicitn\xfd token","The address you entered is duplicate, please enter a new address.":"Zadan\xe1 adresa je duplicitn\xe1, zadajte nov\xfa adresu.","Token Already Exists":"Token u\u017E existuje","There\'s no need to add this token again because it already exists and is supported by us.":"Tento token nie je potrebn\xe9 znova prid\xe1va\u0165, preto\u017Ee u\u017E existuje a je nami podporovan\xfd.","Token Not Found":"Token sa nena\u0161iel","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u013Dutujeme, v re\u0165azci ",["blockchain"]," so zadanou adresou sa nena\u0161iel \u017Eiadny token. uistite sa, \u017Ee ste zadali spr\xe1vnu adresu tokenu."],"Network Error":"Chyba siete","Add Custom Token":"Prida\u0165 vlastn\xfd token","Select chain":"Vyberte re\u0165az","Enter Address":"Zadajte adresu","Enter token address":"Zadajte adresu tokenu","Failed Network, Please retry.":"Sie\u0165 zlyhala, sk\xfaste to znova.","Add another custom token":"Pridajte \u010Fal\u0161\xed vlastn\xfd token","Confirm Swap":"Potvr\u010Fte V\xfdmenu","Start Swap":"Spustite v\xfdmenu","You get":"dostane\u0161","Search Token":"Vyh\u013Ead\xe1vac\xed token","No custom tokens":"\u017Diadne vlastn\xe9 tokeny","press the button to add your custom token":"stla\u010Dte tla\u010Didlo a pridajte svoj vlastn\xfd token","Delete Custom Token":"Odstr\xe1ni\u0165 vlastn\xfd token","Are you sure you want to Delete this Token?":"Naozaj chcete odstr\xe1ni\u0165 tento token?","Complete":"Dokon\u010Di\u0165","Running":"Beh","Failed":"Nepodarilo sa","Clear":"Jasn\xe9","Search Transaction":"Vyh\u013Eada\u0165 transakciu","No transactions":"\u017Diadne transakcie","Your transaction history is stored locally and will appear here after you start a swap":"Va\u0161a hist\xf3ria transakci\xed je ulo\u017Een\xe1 lok\xe1lne a zobraz\xed sa tu po spusten\xed swapu","Clear Transaction History":"Vymaza\u0165 hist\xf3riu transakci\xed","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Pokra\u010Dovan\xedm sa z miniaplik\xe1cie odstr\xe1nia v\u0161etky \xfaspe\u0161n\xe9 a ne\xfaspe\u0161n\xe9 transakcie. Chcete pokra\u010Dova\u0165?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Pozn\xe1mka: T\xfdmto sa nevyma\u017Ee va\u0161a hist\xf3ria transakci\xed v re\u0165azci; odstr\xe1ni ich len tu.","Yes, Clear the history":"\xc1no, vymaza\u0165 hist\xf3riu","language":"jazyk","Deselect all":"Zru\u0161te v\xfdber v\u0161etk\xfdch","Select all":"Vybra\u0165 v\u0161etko","Search {sourceType}":["H\u013Eada\u0165 ",["sourceType"]],"Search Chain":"Vyh\u013Ead\xe1vac\xed re\u0165azec","Source":"Zdroj","Destination":"Cie\u013E","Swap {type}":["Vyme\u0148te ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Moment\xe1lne ste v re\u017Eime kampane s obmedzeniami na zdroje likvidity. Chceli by ste z tohto re\u017Eimu vypn\xfa\u0165 a vyu\u017Ei\u0165 v\u0161etky dostupn\xe9 zdroje likvidity?","The request ID is necessary to display the swap details.":"ID po\u017Eiadavky je potrebn\xe9 na zobrazenie podrobnost\xed o v\xfdmene.","Connect Wallets":"Pripojte Pe\u0148a\u017Eenky","Choose a wallet to connect.":"Vyberte si pe\u0148a\u017Eenku, ktor\xfa chcete pripoji\u0165.","This week":"Tento t\xfd\u017Ede\u0148","This month":"Tento mesiac","This year":"Tento rok","Required: >= {min} {symbol}":["Povinn\xe9: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Povinn\xe9: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Povinn\xe9: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Povinn\xe9: < ",["max"]," ",["symbol"]]," for network fee":" za sie\u0165ov\xfd poplatok"," for swap":" na v\xfdmenu"," for input and network fee":" za vstupn\xfd a sie\u0165ov\xfd poplatok","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Potrebujete \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", ale vo svojej ",["blockchain"]," pe\u0148a\u017Eenke m\xe1te ",["currentAmount"]," ",["symbol"]," ."],"Waiting for connecting wallet":"\u010Cak\xe1 sa na pripojenie pe\u0148a\u017Eenky","Waiting for other running tasks to be finished":"\u010Cak\xe1 sa na dokon\u010Denie ostatn\xfdch spusten\xfdch \xfaloh","Waiting for changing wallet network":"\u010Cak\xe1 sa na zmenu siete pe\u0148a\u017Eenky","Sunday":"nede\u013Eu","Monday":"pondelok","Tuesday":"utorok","Wednesday":"streda","Thursday":"\u0161tvrtok","Friday":"piatok","Saturday":"sobota","Powered By":"Be\u017E\xed na","Aggregated Transaction":"Agregovan\xe1 transakcia","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Vyme\u0148te na ",["fromChain"]," cez ",["swapper"]],"Bridge to {toChain} via {swapper}":["Most na ",["toChain"]," cez ",["swapper"]],"Completed":"Dokon\u010Den\xe9","In progress":"Prebieha","Waiting for bridge transaction":"\u010Cak\xe1 sa na preklenovaciu transakciu","Connected":"Pripojen\xe9","Disconnect":"Odpoji\u0165","Install":"In\u0161talova\u0165","Connecting ...":"Prip\xe1ja sa...","Connecting":"Prip\xe1ja sa","Disconnected":"Odpojen\xe9","you need to pass a correct state to Wallet.":"mus\xedte do Pe\u0148a\u017Eenky odovzda\u0165 spr\xe1vny stav.","There are no notifications.":"Neexistuj\xfa \u017Eiadne upozornenia.","Clear all":"Vymaza\u0165 v\u0161etko","Balance":"Zostatok","Max":"Max"}');


/*eslint-disable*/ const $aeb35b9b0d36f840$export$defe85febe8b728c = JSON.parse('{"No results found":"\u041D\u0435\u043C\u0430 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u0442\u0430\u0442\u0430","Try using different keywords":"\u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0435 \u0440\u0430\u0437\u043B\u0438\u0447\u0438\u0442\u0435 \u043A\u0459\u0443\u0447\u043D\u0435 \u0440\u0435\u0447\u0438","Select Chain":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u041B\u0430\u043D\u0430\u0446","All":"\u0421\u0432\u0435","More +{count}":["\u0408\u043E\u0448 +",["count"]],"Activate this tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u0458\u0442\u0435 \u043E\u0432\u0443 \u043A\u0430\u0440\u0442\u0438\u0446\u0443","Another tab is open and handles transactions.":"\u0414\u0440\u0443\u0433\u0430 \u043A\u0430\u0440\u0442\u0438\u0446\u0430 \u0458\u0435 \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0430 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430\u043C\u0430.","Activate current tab":"\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u0458\u0442\u0435 \u0442\u0440\u0435\u043D\u0443\u0442\u043D\u0443 \u043A\u0430\u0440\u0442\u0438\u0446\u0443","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0422\u0440\u0435\u043D\u0443\u0442\u043D\u043E \u0441\u0443 \u043D\u0435\u043A\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0435 \u043F\u043E\u043A\u0440\u0435\u043D\u0443\u0442\u0435 \u0438 \u045A\u0438\u043C\u0430 \u0443\u043F\u0440\u0430\u0432\u0459\u0430 \u0434\u0440\u0443\u0433\u0430 \u043A\u0430\u0440\u0442\u0438\u0446\u0430 \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0430. \u0410\u043A\u043E \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u0442\u0435 \u043E\u0432\u0443 \u043A\u0430\u0440\u0442\u0438\u0446\u0443, \u0441\u0432\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0435 \u043A\u043E\u0458\u0435 \u0441\u0443 \u0432\u0435\u045B \u0443 \u043A\u043E\u0440\u0430\u043A\u0443 \u043F\u043E\u0442\u043F\u0438\u0441\u0438\u0432\u0430\u045A\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0435 \u045B\u0435 \u0438\u0441\u0442\u0435\u045B\u0438.","Confirm":"\u041F\u043E\u0442\u0432\u0440\u0434\u0438","Your {blockchainName} wallets":["\u0412\u0430\u0448\u0438 ",["blockchainName"]," \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u0446\u0438"],"Insufficient account balance":"\u041D\u0435\u0434\u043E\u0432\u043E\u0459\u043D\u043E \u0441\u0442\u0430\u045A\u0435 \u043D\u0430 \u0440\u0430\u0447\u0443\u043D\u0443","Proceed anyway":"\u0418\u043F\u0430\u043A \u043D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0435","You need to connect a {blockchainName} wallet.":["\u041C\u043E\u0440\u0430\u0442\u0435 \u0434\u0430 \u043F\u043E\u0432\u0435\u0436\u0435\u0442\u0435 ",["blockchainName"]," \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A."],"Add {chain} chain":["\u0414\u043E\u0434\u0430\u0458\u0442\u0435 ",["chain"]," \u043B\u0430\u043D\u0430\u0446"],"Show more wallets":"\u041F\u0440\u0438\u043A\u0430\u0436\u0438 \u0458\u043E\u0448 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430","Send to a different address":"\u041F\u043E\u0448\u0430\u0459\u0438\u0442\u0435 \u043D\u0430 \u0434\u0440\u0443\u0433\u0443 \u0430\u0434\u0440\u0435\u0441\u0443","Enter {blockchainName} address":["\u0423\u043D\u0435\u0441\u0438\u0442\u0435 ",["blockchainName"]," \u0430\u0434\u0440\u0435\u0441\u0443"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0410\u0434\u0440\u0435\u0441\u0430 ",["destination"]," \u043D\u0435 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430 \u043E\u0431\u0440\u0430\u0441\u0446\u0443 \u0430\u0434\u0440\u0435\u0441\u0435 \u0431\u043B\u043E\u043A \u043B\u0430\u043D\u0446\u0430."],"via":"\u043F\u0440\u0435\u043A\u043E","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u041E\u0432\u0430\u0458 \u0442\u043E\u043A\u0435\u043D \u0441\u0435 \u043D\u0435 \u043F\u043E\u0458\u0430\u0432\u0459\u0443\u0458\u0435 \u043D\u0430 \u043B\u0438\u0441\u0442\u0438 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0430. \u0423\u0432\u0435\u0440\u0438\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0458\u0435 \u043E\u0432\u043E \u0436\u0435\u0442\u043E\u043D \u043A\u043E\u0458\u0438\u043C \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0442\u0440\u0433\u0443\u0458\u0435\u0442\u0435.","Import":"\u0423\u0432\u043E\u0437","Status":"\u0421\u0442\u0430\u0442\u0443\u0441","Reset":"\u0420\u0435\u0441\u0435\u0442\u0443\u0458","Cancel":"\u041E\u0442\u043A\u0430\u0436\u0438","Refresh":"\u041E\u0441\u0432\u0435\u0436\u0438","Notifications":"\u041E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u045A\u0430","Settings":"\u041F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430","History":"\u0418\u0441\u0442\u043E\u0440\u0438\u0458\u0430","Connect Wallet":"\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A","Today":"\u0434\u0430\u043D\u0430\u0441","Swaps steps":"\u0417\u0430\u043C\u0435\u045A\u0443\u0458\u0435 \u043A\u043E\u0440\u0430\u043A\u0435","Retry":"\u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E","Slippage Error":"\u0421\u043B\u0438\u043F\u043F\u0430\u0433\u0435 \u0415\u0440\u0440\u043E\u0440","Slippage Warning":"\u0423\u043F\u043E\u0437\u043E\u0440\u0435\u045A\u0435 \u043E \u043F\u0440\u043E\u043A\u043B\u0438\u0437\u0430\u0432\u0430\u045A\u0443","Bridge Limit Error":"\u0413\u0440\u0435\u0448\u043A\u0430 \u0433\u0440\u0430\u043D\u0438\u0446\u0435 \u043C\u043E\u0441\u0442\u0430","Yours: {amount} {symbol}":["\u0412\u0430\u0448: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u043D\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E \u043A\u043B\u0438\u0437\u0430\u045A\u0435: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0412\u0430\u0448: ",["userSlippage"]],"See All Routes":"\u041F\u043E\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u0441\u0432\u0435 \u0440\u0443\u0442\u0435","View more info":"\u041F\u043E\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u0432\u0438\u0448\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0458\u0430","Gas & Fee Explanation":"\u041E\u0431\u0458\u0430\u0448\u045A\u0435\u045A\u0435 \u0437\u0430 \u0433\u0430\u0441 \u0438 \u043D\u0430\u043A\u043D\u0430\u0434\u0443","Details":"\u0414\u0435\u0442\u0430\u0459\u0438","Total Payable Fee":"\u0423\u043A\u0443\u043F\u043D\u0430 \u043D\u0430\u043A\u043D\u0430\u0434\u0430 \u0437\u0430 \u043F\u043B\u0430\u045B\u0430\u045A\u0435","Hide non-payable fees":"\u0421\u0430\u043A\u0440\u0438\u0458\u0442\u0435 \u043D\u0435\u043F\u043B\u0430\u0442\u0438\u0432\u0435 \u043D\u0430\u043A\u043D\u0430\u0434\u0435","Show non-payable fees":"\u041F\u0440\u0438\u043A\u0430\u0436\u0438\u0442\u0435 \u043D\u0435\u043F\u043B\u0430\u0442\u0438\u0432\u0435 \u043D\u0430\u043A\u043D\u0430\u0434\u0435","Description":"\u041E\u043F\u0438\u0441","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0421\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0430\u043A\u043D\u0430\u0434\u0435 \u0441\u0435 \u0443\u0437\u0438\u043C\u0430\u0458\u0443 \u0443 \u043E\u0431\u0437\u0438\u0440 \u0443 \u0438\u0437\u043B\u0430\u0437\u0443 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0435 \u0438\\n                \u043D\u0435\u045B\u0435\u0442\u0435 \u043C\u043E\u0440\u0430\u0442\u0438 \u0434\u0430 \u043F\u043B\u0430\u045B\u0430\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u043D\u0438 \u0433\u0430\u0441 \u0437\u0430 \u045A\u0438\u0445.","Swap input":"\u0417\u0430\u043C\u0435\u043D\u0438 \u0443\u043B\u0430\u0437","Estimated output":"\u041F\u0440\u043E\u0446\u0435\u045A\u0435\u043D\u0438 \u0438\u0437\u043B\u0430\u0437","Via:":"\u043F\u0440\u0435\u043A\u043E:","Chains:":"\u041B\u0430\u043D\u0446\u0438:","Sort by":"\u0421\u043E\u0440\u0442\u0438\u0440\u0430\u0458 \u043F\u043E","Smart Routing":"\u0421\u043C\u0430\u0440\u0442 \u0420\u043E\u0443\u0442\u0438\u043D\u0433","Lowest Fee":"\u041D\u0430\u0458\u043D\u0438\u0436\u0430 \u043D\u0430\u043A\u043D\u0430\u0434\u0430","Fastest Transfer":"\u041D\u0430\u0458\u0431\u0440\u0436\u0438 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440","Maximum Return":"\u041C\u0430\u043A\u0438\u043C\u0443\u043C \u0420\u0435\u0442\u0443\u0440\u043D","Maximum Output":"\u041C\u0430\u043A\u0438\u043C\u0443\u043C \u041E\u0443\u0442\u043F\u0443\u0442","Swapping":"\u0417\u0430\u043C\u0435\u043D\u0430","Gas cost":"\u0422\u0440\u043E\u0448\u0430\u043A \u0433\u0430\u0441\u0430","Receiving":"\u041F\u0440\u0438\u043C\u0430\u045A\u0435","Price impact":"\u0423\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u041C\u043E\u0440\u0430\u0442\u0435 \u043F\u043E\u0432\u0435\u045B\u0430\u0442\u0438 \u043A\u043B\u0438\u0437\u0430\u045A\u0435 \u043D\u0430 \u043D\u0430\u0458\u043C\u0430\u045A\u0435 ",["minRequiredSlippage"]," \u0437\u0430 \u043E\u0432\u0443 \u0440\u0443\u0442\u0443."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u041F\u0440\u0435\u043F\u043E\u0440\u0443\u0447\u0443\u0458\u0435\u043C\u043E \u0432\u0430\u043C \u0434\u0430 \u043F\u043E\u0432\u0435\u045B\u0430\u0442\u0435 \u043A\u043B\u0438\u0437\u0430\u045A\u0435 \u043D\u0430 \u043D\u0430\u0458\u043C\u0430\u045A\u0435 ",["minRequiredSlippage"]," \u0437\u0430 \u043E\u0432\u0443 \u0440\u0443\u0442\u0443."],"Caution, your slippage is high.":"\u041E\u043F\u0440\u0435\u0437, \u0432\u0430\u0448\u0435 \u043A\u043B\u0438\u0437\u0430\u045A\u0435 \u0458\u0435 \u0432\u0435\u043B\u0438\u043A\u043E.","Change":"\u041F\u0440\u043E\u043C\u0435\u043D\u0430","Change settings":"\u041F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0430","High slippage":"\u0412\u0438\u0441\u043E\u043A\u043E \u043A\u043B\u0438\u0437\u0430\u045A\u0435","Low slippage":"\u041D\u0438\u0441\u043A\u043E \u043A\u043B\u0438\u0437\u0430\u045A\u0435"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u041F\u0430\u0436\u045A\u0430, \u0432\u0430\u0448\u0435 \u043F\u0440\u043E\u043A\u043B\u0438\u0437\u0430\u0432\u0430\u045A\u0435 \u0458\u0435 \u0432\u0435\u043B\u0438\u043A\u043E (=",["userSlippage"],"). \u0412\u0430\u0448\u0430 \u0442\u0440\u0433\u043E\u0432\u0438\u043D\u0430 \u043C\u043E\u0436\u0435 \u0431\u0438\u0442\u0438 \u043F\u043E\u0447\u0435\u0442\u043D\u0430."],"Confirm anyway":"\u0421\u0432\u0435\u0458\u0435\u0434\u043D\u043E \u043F\u043E\u0442\u0432\u0440\u0434\u0438","Something went wrong":"\u041D\u0435\u0448\u0442\u043E \u0458\u0435 \u043F\u043E\u0448\u043B\u043E \u043F\u043E \u0437\u043B\u0443","Something went wrong. Please refresh the app.":"\u041D\u0435\u0448\u0442\u043E \u0458\u0435 \u043F\u043E\u0448\u043B\u043E \u043F\u043E \u0437\u043B\u0443. \u041E\u0441\u0432\u0435\u0436\u0438\u0442\u0435 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0443.","Slippage tolerance per swap":"\u0422\u043E\u043B\u0435\u0440\u0430\u043D\u0446\u0438\u0458\u0430 \u043A\u043B\u0438\u0437\u0430\u045A\u0430 \u043F\u043E \u0437\u0430\u043C\u0435\u043D\u0438","Custom":"\u0426\u0443\u0441\u0442\u043E\u043C","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0412\u0430\u0448\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u045B\u0435 \u0431\u0438\u0442\u0438 \u043F\u043E\u043D\u0438\u0448\u0442\u0435\u043D\u0430 \u0430\u043A\u043E \u0441\u0435 \u0446\u0435\u043D\u0430 \u043D\u0435\u043F\u043E\u0432\u043E\u0459\u043D\u043E \u043F\u0440\u043E\u043C\u0435\u043D\u0438 \u0437\u0430 \u0432\u0438\u0448\u0435 \u043E\u0434 \u043E\u0432\u043E\u0433 \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u0430.","Warning":"\u0423\u043F\u043E\u0437\u043E\u0440\u0435\u045A\u0435","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u041E\u0432\u043E \u043F\u043E\u0434\u0435\u0448\u0430\u0432\u0430\u045A\u0435 \u0441\u0435 \u043F\u0440\u0438\u043C\u0435\u045A\u0443\u0458\u0435 \u043D\u0430 \u0441\u0432\u0430\u043A\u0438 \u043A\u043E\u0440\u0430\u043A (\u043D\u043F\u0440. 1 \u0438\u043D\u0447, \u0422\u0445\u043E\u0440\u0446\u0445\u0430\u0438\u043D, \u0438\u0442\u0434.), \u0448\u0442\u043E \u0437\u043D\u0430\u0447\u0438 \u0434\u0430 \u045B\u0435 \u0441\u0430\u043C\u043E \u0442\u0430\u0458 \u043E\u0434\u0440\u0435\u0452\u0435\u043D\u0438 \u043A\u043E\u0440\u0430\u043A \u0431\u0438\u0442\u0438 \u0432\u0440\u0430\u045B\u0435\u043D, \u0430 \u043D\u0435 \u0446\u0435\u043B\u0430 \u0440\u0443\u0442\u0430.","Swap Details":"\u0421\u0432\u0430\u043F \u0414\u0435\u0442\u0430\u0438\u043B\u0441","Request ID":"\u0418\u0414 \u0437\u0430\u0445\u0442\u0435\u0432\u0430","Not found":"\u041D\u0438\u0458\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u043E","Swap with request ID = {requestId} not found.":["\u0417\u0430\u043C\u0435\u043D\u0430 \u0441\u0430 \u0418\u0414-\u043E\u043C \u0437\u0430\u0445\u0442\u0435\u0432\u0430 = ",["requestId"]," \u043D\u0438\u0458\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u043E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0414\u043E\u0431\u0438\u043B\u0438 \u0441\u0442\u0435 ",["amount"]," ",["token"]," \u0443 ",["conciseAddress"]," \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443 \u043D\u0430 ",["chain"]," \u043B\u0430\u043D\u0446\u0443."],"Transaction was not sent.":"\u0422\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u043D\u0438\u0458\u0435 \u043F\u043E\u0441\u043B\u0430\u0442\u0430.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u043D\u0430 ",["blockchain"]," \u043E\u0441\u0442\u0430\u0458\u0435 \u0443 \u0432\u0430\u0448\u0435\u043C \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443."],"Delete":"\u0418\u0437\u0431\u0440\u0438\u0448\u0438","Try again":"\u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E","Copied To Clipboard":"\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A","Copy Request ID":"\u041A\u043E\u043F\u0438\u0440\u0430\u0458 \u0418\u0414 \u0437\u0430\u0445\u0442\u0435\u0432\u0430","View on Rango Explorer":"\u041F\u043E\u0433\u043B\u0435\u0434 \u043D\u0430 \u0420\u0430\u043D\u0433\u043E \u0415\u043A\u043F\u043B\u043E\u0440\u0435\u0440","Finished at":"\u0417\u0430\u0432\u0440\u0448\u0435\u043D\u043E \u0443","Created at":"\u0426\u0440\u0435\u0430\u0442\u0435\u0434 \u0430\u0442","View transaction":"\u041F\u043E\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0443","Connect":"\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0441\u0435","Swap Successful":"\u0417\u0430\u043C\u0435\u043D\u0430 \u0443\u0441\u043F\u0435\u043B\u0430","Transaction Failed":"\u0422\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u0430","Done":"\u0413\u043E\u0442\u043E\u0432\u043E","Diagnosis":"\u0414\u0438\u0458\u0430\u0433\u043D\u043E\u0437\u0430","See Details":"\u041F\u043E\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u0414\u0435\u0442\u0430\u0459\u0438","Cancel Swap":"\u041E\u0442\u043A\u0430\u0436\u0438 \u0437\u0430\u043C\u0435\u043D\u0443","Are you sure you want to cancel this swap?":"\u0414\u0430 \u043B\u0438 \u0441\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0434\u0430 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u043E\u0442\u043A\u0430\u0436\u0435\u0442\u0435 \u043E\u0432\u0443 \u0437\u0430\u043C\u0435\u043D\u0443?","Yes, Cancel it":"\u0414\u0430, \u043E\u0442\u043A\u0430\u0436\u0438","No, Continue":"\u041D\u0435, \u043D\u0430\u0441\u0442\u0430\u0432\u0438","Delete Transaction":"\u0418\u0437\u0431\u0440\u0438\u0448\u0438 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0443","Are you sure you want to delete this swap?":"\u0414\u0430 \u043B\u0438 \u0441\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0434\u0430 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0438\u0437\u0431\u0440\u0438\u0448\u0435\u0442\u0435 \u043E\u0432\u0443 \u0437\u0430\u043C\u0435\u043D\u0443?","Yes, Delete it":"\u0414\u0430, \u0418\u0437\u0431\u0440\u0438\u0448\u0438","No, Cancel":"\u041D\u0435, \u043E\u0442\u043A\u0430\u0436\u0438","Change Network":"\u041F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0440\u0435\u0436\u0443","Network Changed":"\u041C\u0440\u0435\u0436\u0430 \u0458\u0435 \u043F\u0440\u043E\u043C\u0435\u045A\u0435\u043D\u0430","Select Token":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0422\u043E\u043A\u0435\u043D","Wallet Connected":"\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043F\u043E\u0432\u0435\u0437\u0430\u043D","Your wallet is connected, you can use it to swap.":"\u0412\u0430\u0448 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0458\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043D, \u043C\u043E\u0436\u0435\u0442\u0435 \u0433\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0438 \u0437\u0430 \u0437\u0430\u043C\u0435\u043D\u0443.","Failed to Connect":"\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E","Your wallet is not connected. Please try again.":"\u0412\u0430\u0448 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043D\u0438\u0458\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043D. \u041F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E.","Connecting to your wallet":"\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u0441\u0430 \u0432\u0430\u0448\u0438\u043C \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u043C","Click connect in your wallet popup.":"\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u041F\u043E\u0432\u0435\u0436\u0438 \u0441\u0435 \u0443 \u0438\u0441\u043A\u0430\u0447\u0443\u045B\u0435\u043C \u043F\u0440\u043E\u0437\u043E\u0440\u0443 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430.","Select Derivation Path":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u041F\u0443\u0442\u0430\u045A\u0430 \u0434\u0435\u0440\u0438\u0432\u0430\u0446\u0438\u0458\u0435","In order to connect to {type}, you must first select a Derivation Path":["\u0414\u0430 \u0431\u0438\u0441\u0442\u0435 \u0441\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043B\u0438 \u043D\u0430 ",["type"],", \u043F\u0440\u0432\u043E \u043C\u043E\u0440\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0430\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0443\u0442\u0430\u045A\u0443 \u0438\u0437\u0432\u043E\u0452\u0435\u045A\u0430"],"Choose Derivation Path Template":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D \u043F\u0443\u0442\u0430\u045A\u0435 \u0438\u0437\u0432\u043E\u0452\u0435\u045A\u0430","Enter Path":"\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u043F\u0443\u0442\u0430\u045A\u0443","Enter Index":"\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u0438\u043D\u0434\u0435\u043A\u0441","Add {blockchainDisplayName} Chain":["\u0414\u043E\u0434\u0430\u0458\u0442\u0435 ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0430\u0446"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0414\u0430 \u043B\u0438 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0434\u043E\u0434\u0430\u0442\u0435 ",["blockchainDisplayName"]," \u0435\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u043D\u0438 \u043B\u0430\u043D\u0430\u0446 \u0443 \u0441\u0432\u043E\u0458 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A?"],"Please approve the experimental chain pop-up in your wallet.":"\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u0435 \u0438\u0441\u043A\u0430\u0447\u0443\u045B\u0438 \u043F\u0440\u043E\u0437\u043E\u0440 \u0435\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u043D\u043E\u0433 \u043B\u0430\u043D\u0446\u0430 \u0443 \u0441\u0432\u043E\u043C \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0414\u043E\u0434\u0430\u043D \u043B\u0430\u043D\u0430\u0446"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u041B\u0430\u043D\u0430\u0446 ",["blockchainDisplayName"]," \u0458\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0434\u0430\u0442 \u0443 \u0432\u0430\u0448 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A."],"Request Rejected":"\u0417\u0430\u0445\u0442\u0435\u0432 \u043E\u0434\u0431\u0438\u0458\u0435\u043D","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u041E\u0434\u0431\u0438\u043B\u0438 \u0441\u0442\u0435 \u0434\u043E\u0434\u0430\u0432\u0430\u045A\u0435 ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0446\u0430 \u0443 \u0432\u0430\u0448 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A."],"Select chain types":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F\u043E\u0432\u0435 \u043B\u0430\u043D\u0430\u0446\u0430","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u041E\u0432\u0430\u0458 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430 \u0432\u0438\u0448\u0435 \u043B\u0430\u043D\u0430\u0446\u0430. \u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u0458\u0438 \u043B\u0430\u043D\u0430\u0446 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0441\u0435 \u043F\u043E\u0432\u0435\u0436\u0435\u0442\u0435.","Failed Network, Please retry your swap.":"\u041D\u0435\u0443\u0441\u043F\u0435\u043B\u0430 \u043C\u0440\u0435\u0436\u0430, \u043F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E \u0434\u0430 \u0438\u0437\u0432\u0440\u0448\u0438\u0442\u0435 \u0437\u0430\u043C\u0435\u043D\u0443.","Please reset your liquidity sources.":"\u0420\u0435\u0441\u0435\u0442\u0443\u0458\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u0438\u0437\u0432\u043E\u0440\u0435 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u043B\u0438 \u0441\u0442\u0435 \u0438\u0437\u0432\u043E\u0440\u0435 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438 \u0438 \u0442\u043E \u043C\u043E\u0436\u0435 \u0434\u043E\u0432\u0435\u0441\u0442\u0438 \u0434\u043E \u0442\u043E\u0433\u0430 \u0434\u0430 \u0420\u0430\u043D\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435 \u043D\u0438\u043A\u0430\u043A\u0432\u0435 \u0440\u0443\u0442\u0435. \u0420\u0430\u0437\u043C\u0438\u0441\u043B\u0438\u0442\u0435 \u043E \u0440\u0435\u0441\u0435\u0442\u043E\u0432\u0430\u045A\u0443 \u0438\u0437\u0432\u043E\u0440\u0430 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438.","No Routes Found.":"\u0420\u0443\u0442\u0435 \u043D\u0438\u0441\u0443 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u0435.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u0420\u0430\u0437\u043B\u043E\u0437\u0438 \u0437\u0431\u043E\u0433 \u043A\u043E\u0458\u0438\u0445 \u0420\u0430\u043D\u0433\u043E \u043D\u0438\u0458\u0435 \u043C\u043E\u0433\u0430\u043E \u0434\u0430 \u043F\u0440\u043E\u043D\u0430\u0452\u0435 \u0440\u0443\u0442\u0443: \u043D\u0438\u0441\u043A\u0430 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442 \u043D\u0430 \u0442\u043E\u043A\u0435\u043D\u0443, \u0432\u0435\u043E\u043C\u0430 \u043C\u0430\u043B\u0438 \u0438\u0437\u043D\u043E\u0441 \u0443\u043D\u043E\u0441\u0430 \u0438\u043B\u0438 \u043D\u0435\u043C\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u0440\u0443\u0442\u0430 \u0437\u0430 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u0443 \u043A\u043E\u043C\u0431\u0438\u043D\u0430\u0446\u0438\u0458\u0443 \u0443\u043B\u0430\u0437\u043D\u043E/\u0438\u0437\u043B\u0430\u0437\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0430.","Bridge Limit Error: Please increase your amount.":"\u0413\u0440\u0435\u0448\u043A\u0430 \u0443 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0443 \u043F\u0440\u0435\u043C\u043E\u0448\u045B\u0430\u0432\u0430\u045A\u0430: \u041F\u043E\u0432\u0435\u045B\u0430\u0458\u0442\u0435 \u0438\u0437\u043D\u043E\u0441.","Bridge Limit Error: Please decrease your amount.":"\u0413\u0440\u0435\u0448\u043A\u0430 \u0443 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0443 \u043F\u0440\u0435\u043C\u043E\u0448\u045B\u0430\u0432\u0430\u045A\u0430: \u0421\u043C\u0430\u045A\u0438\u0442\u0435 \u0438\u0437\u043D\u043E\u0441.","High Price Impact":"\u0412\u0438\u0441\u043E\u043A \u0443\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443","Price impact is too high!":"\u0423\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443 \u0458\u0435 \u043F\u0440\u0435\u0432\u0435\u043B\u0438\u043A!","The price impact is significantly higher than the allowed amount.":"\u0423\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443 \u0458\u0435 \u0437\u043D\u0430\u0442\u043D\u043E \u0432\u0435\u045B\u0438 \u043E\u0434 \u0434\u043E\u0437\u0432\u043E\u0459\u0435\u043D\u043E\u0433 \u0438\u0437\u043D\u043E\u0441\u0430.","Confirm high price impact":"\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0443\u0442\u0438\u0446\u0430\u0458 \u0432\u0438\u0441\u043E\u043A\u0435 \u0446\u0435\u043D\u0435","Route updated and price impact is too high, try again later!":"\u0420\u0443\u0442\u0430 \u0458\u0435 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043D\u0430 \u0438 \u0443\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443 \u0458\u0435 \u043F\u0440\u0435\u0432\u0435\u043B\u0438\u043A, \u043F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E \u043A\u0430\u0441\u043D\u0438\u0458\u0435!","USD Price Unknown":"\u0423\u0421\u0414 \u0426\u0435\u043D\u0430 \u043D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u0430","USD Price Unknown, Cannot calculate Price Impact.":"\u0426\u0435\u043D\u0430 \u0443 \u0423\u0421\u0414 \u043D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u0430, \u043D\u0435 \u043C\u043E\u0436\u0435 \u0441\u0435 \u0438\u0437\u0440\u0430\u0447\u0443\u043D\u0430\u0442\u0438 \u0443\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u0426\u0435\u043D\u0430 \u0443 \u0423\u0421\u0414 \u043D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u0430, \u043D\u0435 \u043C\u043E\u0436\u0435 \u0441\u0435 \u0438\u0437\u0440\u0430\u0447\u0443\u043D\u0430\u0442\u0438 \u0443\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443. \u0423\u0442\u0438\u0446\u0430\u0458 \u043D\u0430 \u0446\u0435\u043D\u0443 \u043C\u043E\u0436\u0435 \u0431\u0438\u0442\u0438 \u0432\u0435\u045B\u0438 \u043D\u0435\u0433\u043E \u0438\u043D\u0430\u0447\u0435. \u0414\u0430 \u043B\u0438 \u0441\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0434\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0459\u0430\u0442\u0435 \u0417\u0430\u043C\u0435\u043D\u0443?","Confirm USD Price Unknown":"\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0446\u0435\u043D\u0443 \u0443 \u0423\u0421\u0414 \u043D\u0435\u043F\u043E\u0437\u043D\u0430\u0442\u043E","Swap":"\u0421\u0432\u0430\u043F","Swap anyway":"\u0417\u0430\u043C\u0435\u043D\u0438 \u0443 \u0441\u0432\u0430\u043A\u043E\u043C \u0441\u043B\u0443\u0447\u0430\u0458\u0443","The route goes through Ethereum. Continue?":"\u0420\u0443\u0442\u0430 \u0438\u0434\u0435 \u043F\u0440\u0435\u043A\u043E \u0415\u0442\u0445\u0435\u0440\u0435\u0443\u043C\u0430. \u041D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0438?","Route has been updated.":"\u0420\u0443\u0442\u0430 \u0458\u0435 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043D\u0430.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0418\u0437\u043B\u0430\u0437\u043D\u0438 \u0438\u0437\u043D\u043E\u0441 \u0458\u0435 \u043F\u0440\u043E\u043C\u0435\u045A\u0435\u043D \u0443 ",["newOutputAmount"]," (",["percentageChange"],"% \u043F\u0440\u043E\u043C\u0435\u043D\u0430)."],"Route swappers has been updated.":"\u041F\u0440\u043E\u043C\u0435\u043D\u0430 \u0440\u0443\u0442\u0430 \u0458\u0435 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043D\u0430.","Route internal coins has been updated.":"\u0418\u043D\u0442\u0435\u0440\u043D\u0438 \u043D\u043E\u0432\u0447\u0438\u045B\u0438 \u0440\u0443\u0442\u0435 \u0441\u0443 \u0430\u0436\u0443\u0440\u0438\u0440\u0430\u043D\u0438.","Routes":"\u0420\u0443\u0442\u0435","From":"\u041E\u0434","To":"\u0422\u043E","Light":"\u0421\u0432\u0435\u0442\u043B\u043E\u0441\u0442","Dark":"\u0414\u0430\u0440\u043A","Auto":"\u0410\u0443\u0442\u043E","Loading failed":"\u0423\u0447\u0438\u0442\u0430\u0432\u0430\u045A\u0435 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E","Bridges":"\u041C\u043E\u0441\u0442\u043E\u0432\u0438","Exchanges":"\u0420\u0430\u0437\u043C\u0435\u043D\u0435","Custom Tokens":"\u041F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0442\u043E\u043A\u0435\u043D\u0438","Language":"\u0408\u0435\u0437\u0438\u043A","Infinite approval":"\u0411\u0435\u0441\u043A\u043E\u043D\u0430\u0447\u043D\u043E \u043E\u0434\u043E\u0431\u0440\u0435\u045A\u0435","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u041E\u043C\u043E\u0433\u0443\u045B\u0430\u0432\u0430\u045A\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u201E\u0411\u0435\u0441\u043A\u043E\u043D\u0430\u0447\u043D\u043E \u043E\u0434\u043E\u0431\u0440\u0435\u045A\u0435\u201C \u0434\u0430\u0458\u0435 \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D \u043F\u0440\u0438\u0441\u0442\u0443\u043F \u043E\u0441\u043D\u043E\u0432\u043D\u0438\u043C \u043F\u0430\u043C\u0435\u0442\u043D\u0438\u043C \u0443\u0433\u043E\u0432\u043E\u0440\u0438\u043C\u0430, \u043E\u043C\u043E\u0433\u0443\u045B\u0430\u0432\u0430\u0458\u0443\u045B\u0438 \u0438\u043C \u0434\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438 \u0438\u0437\u043D\u043E\u0441 \u0442\u043E\u043A\u0435\u043D\u0430 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0430.","Theme":"\u0422\u0435\u043C\u0430","Duplicate Token":"\u0414\u0443\u043F\u043B\u0438\u043A\u0430\u0442 \u0442\u043E\u043A\u0435\u043D\u0430","The address you entered is duplicate, please enter a new address.":"\u0410\u0434\u0440\u0435\u0441\u0430 \u043A\u043E\u0458\u0443 \u0441\u0442\u0435 \u0443\u043D\u0435\u043B\u0438 \u0458\u0435 \u0434\u0443\u043F\u043B\u0438\u043A\u0430\u0442, \u0443\u043D\u0435\u0441\u0438\u0442\u0435 \u043D\u043E\u0432\u0443 \u0430\u0434\u0440\u0435\u0441\u0443.","Token Already Exists":"\u0422\u043E\u043A\u0435\u043D \u0432\u0435\u045B \u043F\u043E\u0441\u0442\u043E\u0458\u0438","There\'s no need to add this token again because it already exists and is supported by us.":"\u041D\u0435\u043C\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0434\u0430 \u043F\u043E\u043D\u043E\u0432\u043E \u0434\u043E\u0434\u0430\u0458\u0435\u0442\u0435 \u043E\u0432\u0430\u0458 \u0442\u043E\u043A\u0435\u043D \u0458\u0435\u0440 \u0432\u0435\u045B \u043F\u043E\u0441\u0442\u043E\u0458\u0438 \u0438 \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430\u043C\u043E \u0433\u0430.","Token Not Found":"\u0422\u043E\u043A\u0435\u043D \u043D\u0438\u0458\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u0416\u0430\u043E \u043D\u0430\u043C \u0458\u0435, \u0442\u043E\u043A\u0435\u043D \u043D\u0438\u0458\u0435 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D \u0443 ",["blockchain"]," \u043B\u0430\u043D\u0446\u0443 \u0441\u0430 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u043E\u043C \u0430\u0434\u0440\u0435\u0441\u043E\u043C. \u0443\u0432\u0435\u0440\u0438\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0441\u0442\u0435 \u0443\u043D\u0435\u043B\u0438 \u0438\u0441\u043F\u0440\u0430\u0432\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0442\u043E\u043A\u0435\u043D\u0430."],"Network Error":"\u041C\u0440\u0435\u0436\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430","Add Custom Token":"\u0414\u043E\u0434\u0430\u0458\u0442\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0442\u043E\u043A\u0435\u043D","Select chain":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043B\u0430\u043D\u0430\u0446","Enter Address":"\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441\u0443","Enter token address":"\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441\u0443 \u0442\u043E\u043A\u0435\u043D\u0430","Failed Network, Please retry.":"\u041C\u0440\u0435\u0436\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u0430, \u043F\u043E\u043A\u0443\u0448\u0430\u0458\u0442\u0435 \u043F\u043E\u043D\u043E\u0432\u043E.","Add another custom token":"\u0414\u043E\u0434\u0430\u0458\u0442\u0435 \u0458\u043E\u0448 \u0458\u0435\u0434\u0430\u043D \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0442\u043E\u043A\u0435\u043D","Confirm Swap":"\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043C\u0435\u043D\u0443","Start Swap":"\u0421\u0442\u0430\u0440\u0442 \u0421\u0432\u0430\u043F","You get":"\u0414\u043E\u0431\u0438\u0458\u0435\u0448","Search Token":"\u0421\u0435\u0430\u0440\u0446\u0445 \u0422\u043E\u043A\u0435\u043D","No custom tokens":"\u041D\u0435\u043C\u0430 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0430","press the button to add your custom token":"\u043F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0434\u0443\u0433\u043C\u0435 \u0434\u0430 \u0434\u043E\u0434\u0430\u0442\u0435 \u0441\u0432\u043E\u0458 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0442\u043E\u043A\u0435\u043D","Delete Custom Token":"\u0418\u0437\u0431\u0440\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u0430\u0433\u043E\u0452\u0435\u043D\u0438 \u0442\u043E\u043A\u0435\u043D","Are you sure you want to Delete this Token?":"\u0414\u0430 \u043B\u0438 \u0441\u0442\u0435 \u0441\u0438\u0433\u0443\u0440\u043D\u0438 \u0434\u0430 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0438\u0437\u0431\u0440\u0438\u0448\u0435\u0442\u0435 \u043E\u0432\u0430\u0458 \u0442\u043E\u043A\u0435\u043D?","Complete":"\u0417\u0430\u0432\u0440\u0448\u0435\u043D\u043E","Running":"\u0422\u0440\u0447\u0430\u045A\u0435","Failed":"\u041D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E","Clear":"\u0408\u0430\u0441\u043D\u043E","Search Transaction":"\u0422\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u043F\u0440\u0435\u0442\u0440\u0430\u0433\u0435","No transactions":"\u041D\u0435\u043C\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430","Your transaction history is stored locally and will appear here after you start a swap":"\u0412\u0430\u0448\u0430 \u0438\u0441\u0442\u043E\u0440\u0438\u0458\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u0441\u0435 \u0447\u0443\u0432\u0430 \u043B\u043E\u043A\u0430\u043B\u043D\u043E \u0438 \u043F\u043E\u0458\u0430\u0432\u0438\u045B\u0435 \u0441\u0435 \u043E\u0432\u0434\u0435 \u043D\u0430\u043A\u043E\u043D \u0448\u0442\u043E \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0437\u0430\u043C\u0435\u043D\u0443","Clear Transaction History":"\u041E\u0431\u0440\u0438\u0448\u0438 \u0438\u0441\u0442\u043E\u0440\u0438\u0458\u0443 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u041D\u0430\u0441\u0442\u0430\u0432\u0459\u0430\u045A\u0435 \u045B\u0435 \u0443\u043A\u043B\u043E\u043D\u0438\u0442\u0438 \u0441\u0432\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u0435 \u0438 \u043D\u0435\u0443\u0441\u043F\u0435\u043B\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0435 \u0438\u0437 \u0432\u0438\u045F\u0435\u0442\u0430. \u0414\u0430 \u043B\u0438 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0435?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u041D\u0430\u043F\u043E\u043C\u0435\u043D\u0430: \u041E\u0432\u043E \u043D\u0435 \u0431\u0440\u0438\u0448\u0435 \u0432\u0430\u0448\u0443 \u0438\u0441\u0442\u043E\u0440\u0438\u0458\u0443 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430 \u0443 \u043B\u0430\u043D\u0446\u0443; \u0441\u0430\u043C\u043E \u0438\u0445 \u043E\u0432\u0434\u0435 \u0443\u043A\u043B\u0430\u045A\u0430.","Yes, Clear the history":"\u0414\u0430, \u043E\u0431\u0440\u0438\u0448\u0438\u0442\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u0458\u0443","language":"\u0458\u0435\u0437\u0438\u043A","Deselect all":"\u041E\u043F\u043E\u0437\u043E\u0432\u0438 \u0441\u0432\u0435","Select all":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u0435","Search {sourceType}":["\u041F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0442\u0435 ",["sourceType"]],"Search Chain":"\u0421\u0435\u0430\u0440\u0446\u0445 \u0426\u0445\u0430\u0438\u043D","Source":"\u0418\u0437\u0432\u043E\u0440","Destination":"\u041E\u0434\u0440\u0435\u0434\u0438\u0448\u0442\u0435","Swap {type}":["\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u0438 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0422\u0440\u0435\u043D\u0443\u0442\u043D\u043E \u0441\u0442\u0435 \u0443 \u0440\u0435\u0436\u0438\u043C\u0443 \u043A\u0430\u043C\u043F\u0430\u045A\u0435 \u0441\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u045A\u0438\u043C\u0430 \u0438\u0437\u0432\u043E\u0440\u0430 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438. \u0414\u0430 \u043B\u0438 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u0438\u0437\u0430\u0452\u0435\u0442\u0435 \u0438\u0437 \u043E\u0432\u043E\u0433 \u0440\u0435\u0436\u0438\u043C\u0430 \u0438 \u0438\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0435 \u0441\u0432\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0438\u0437\u0432\u043E\u0440\u0435 \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438?","The request ID is necessary to display the swap details.":"\u0418\u0414 \u0437\u0430\u0445\u0442\u0435\u0432\u0430 \u0458\u0435 \u043D\u0435\u043E\u043F\u0445\u043E\u0434\u0430\u043D \u0437\u0430 \u043F\u0440\u0438\u043A\u0430\u0437 \u0434\u0435\u0442\u0430\u0459\u0430 \u0440\u0430\u0437\u043C\u0435\u043D\u0435.","Connect Wallets":"\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0435","Choose a wallet to connect.":"\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0437\u0430 \u043F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435.","This week":"\u041E\u0432\u0435 \u043D\u0435\u0434\u0435\u0459\u0435","This month":"\u041E\u0432\u043E\u0433 \u043C\u0435\u0441\u0435\u0446\u0430","This year":"\u041E\u0432\u0435 \u0433\u043E\u0434\u0438\u043D\u0435","Required: >= {min} {symbol}":["\u041E\u0431\u0430\u0432\u0435\u0437\u043D\u043E: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u041E\u0431\u0430\u0432\u0435\u0437\u043D\u043E: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u041E\u0431\u0430\u0432\u0435\u0437\u043D\u043E: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u041E\u0431\u0430\u0432\u0435\u0437\u043D\u043E: < ",["max"]," ",["symbol"]]," for network fee":" \u0437\u0430 \u043C\u0440\u0435\u0436\u043D\u0443 \u043D\u0430\u043A\u043D\u0430\u0434\u0443"," for swap":" \u0437\u0430 \u0437\u0430\u043C\u0435\u043D\u0443"," for input and network fee":" \u0437\u0430 \u0443\u043B\u0430\u0437\u043D\u0443 \u0438 \u043C\u0440\u0435\u0436\u043D\u0443 \u043D\u0430\u043A\u043D\u0430\u0434\u0443","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u041F\u043E\u0442\u0440\u0435\u0431\u043D\u043E \u0458\u0435 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", \u0430\u043B\u0438 \u0438\u043C\u0430\u0442\u0435 ",["currentAmount"]," ",["symbol"]," \u0443 \u0441\u0432\u043E\u043C ",["blockchain"]," \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443."],"Waiting for connecting wallet":"\u0427\u0435\u043A\u0430 \u0441\u0435 \u043F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430","Waiting for other running tasks to be finished":"\u0427\u0435\u043A\u0430 \u0441\u0435 \u0434\u0430 \u0441\u0435 \u0437\u0430\u0432\u0440\u0448\u0435 \u0434\u0440\u0443\u0433\u0438 \u0437\u0430\u0434\u0430\u0446\u0438","Waiting for changing wallet network":"\u0427\u0435\u043A\u0430 \u0441\u0435 \u043F\u0440\u043E\u043C\u0435\u043D\u0430 \u043C\u0440\u0435\u0436\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430","Sunday":"\u043D\u0435\u0434\u0435\u0459\u0430","Monday":"\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A","Tuesday":"\u0443\u0442\u043E\u0440\u0430\u043A","Wednesday":"\u0441\u0440\u0435\u0434\u0430","Thursday":"\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A","Friday":"\u043F\u0435\u0442\u0430\u043A","Saturday":"\u0421\u0443\u0431\u043E\u0442\u0430","Powered By":"\u041F\u043E\u0432\u0435\u0440\u0435\u0434 \u0411\u0438","Aggregated Transaction":"\u0417\u0431\u0438\u0440\u043D\u0430 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u0435 \u043D\u0430 ",["fromChain"]," \u043F\u0440\u0435\u043A\u043E ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u041C\u043E\u0441\u0442 \u0434\u043E ",["toChain"]," \u043F\u0440\u0435\u043A\u043E ",["swapper"]],"Completed":"\u0417\u0430\u0432\u0440\u0448\u0435\u043D\u043E","In progress":"\u0423 \u0442\u043E\u043A\u0443","Waiting for bridge transaction":"\u0427\u0435\u043A\u0430 \u0441\u0435 \u0431\u0440\u0438\u0434\u0433\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0458\u0430","Connected":"\u041F\u043E\u0432\u0435\u0437\u0430\u043D\u043E","Disconnect":"\u041F\u0440\u0435\u043A\u0438\u043D\u0438 \u0432\u0435\u0437\u0443","Install":"\u0418\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0458","Connecting ...":"\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435...","Connecting":"\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435","Disconnected":"\u0414\u0438\u0441\u0446\u043E\u043D\u043D\u0435\u0446\u0442\u0435\u0434","you need to pass a correct state to Wallet.":"\u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E \u0458\u0435 \u0434\u0430 \u043F\u0440\u043E\u0441\u043B\u0435\u0434\u0438\u0442\u0435 \u0438\u0441\u043F\u0440\u0430\u0432\u043D\u043E \u0441\u0442\u0430\u045A\u0435 \u0443 \u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.","There are no notifications.":"\u041D\u0435\u043C\u0430 \u043E\u0431\u0430\u0432\u0435\u0448\u0442\u0435\u045A\u0430.","Clear all":"\u041E\u0431\u0440\u0438\u0448\u0438 \u0441\u0432\u0435","Balance":"\u0411\u0430\u043B\u0430\u043D\u0441","Max":"\u041C\u0430\u043A\u0441"}');


/*eslint-disable*/ const $8464a7fe75e16c47$export$defe85febe8b728c = JSON.parse('{"No results found":"Inga resultat hittades","Try using different keywords":"Prova att anv\xe4nda olika s\xf6kord","Select Chain":"V\xe4lj kedja","All":"Alla","More +{count}":["Mer +",["count"]],"Activate this tab":"Aktivera denna flik","Another tab is open and handles transactions.":"En annan flik \xe4r \xf6ppen och hanterar transaktioner.","Activate current tab":"Aktivera aktuell flik","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"F\xf6r n\xe4rvarande k\xf6rs och hanteras vissa transaktioner av andra webbl\xe4sarfliken. Om du aktiverar den h\xe4r fliken, kommer alla transaktioner som redan finns i transaktionssigneringssteget att upph\xf6ra.","Confirm":"Bekr\xe4fta","Your {blockchainName} wallets":["Dina ",["blockchainName"]," pl\xe5nb\xf6cker"],"Insufficient account balance":"Otillr\xe4ckligt saldo","Proceed anyway":"Forts\xe4tt \xe4nd\xe5","You need to connect a {blockchainName} wallet.":["Du m\xe5ste ansluta en ",["blockchainName"]," pl\xe5nbok."],"Add {chain} chain":["L\xe4gg till ",["chain"]," kedja"],"Show more wallets":"Visa fler pl\xe5nb\xf6cker","Send to a different address":"Skicka till en annan adress","Enter {blockchainName} address":["Ange ",["blockchainName"]," adress"],"Address {destination} doesn\'t match the blockchain address pattern.":["Adress ",["destination"]," matchar inte blockkedjans adressm\xf6nster."],"via":"via","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Denna token visas inte p\xe5 den aktiva token listan. Se till att detta \xe4r den token som du vill handla.","Import":"Importera","Status":"Status","Reset":"Reset","Cancel":"Avbryt","Refresh":"Uppdatera","Notifications":"Aviseringar","Settings":"Inst\xe4llningar","History":"Historik","Connect Wallet":"Anslut pl\xe5nbok","Today":"Idag","Swaps steps":"V\xe4xlar steg","Retry":"F\xf6rs\xf6k igen","Slippage Error":"Slippage Fel","Slippage Warning":"Slippage Varning","Bridge Limit Error":"Bridgegr\xe4ns fel","Yours: {amount} {symbol}":["Yours: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minsta obligatoriska halkning: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Er: ",["userSlippage"]],"See All Routes":"Se alla rutter","View more info":"Visa mer information","Gas & Fee Explanation":"F\xf6rklaring av gas & avgift","Details":"Detaljer","Total Payable Fee":"Total betalningskostnad","Hide non-payable fees":"D\xf6lj icke-betalbara avgifter","Show non-payable fees":"Visa icke-betalbara avgifter","Description":"Beskrivning","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"F\xf6ljande avgifter beaktas i transaktionen utg\xe5ng och\\n                beh\xf6ver du inte betala extra gas f\xf6r dem.","Swap input":"Swap input","Estimated output":"Uppskattad utdata","Via:":"Via:","Chains:":"Kedjor:","Sort by":"Sortera efter","Smart Routing":"Smart routing","Lowest Fee":"L\xe4gsta avgift","Fastest Transfer":"Snabbaste \xf6verf\xf6ringen","Maximum Return":"Maximal retur","Maximum Output":"Maximal utdata","Swapping":"Swapping","Gas cost":"Gas kostnad","Receiving":"Tar emot","Price impact":"Pris inverkan","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Du m\xe5ste \xf6ka halkningen till minst ",["minRequiredSlippage"]," f\xf6r denna rutt."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Vi rekommenderar att du \xf6kar halkningen till minst ",["minRequiredSlippage"]," f\xf6r denna rutt."],"Caution, your slippage is high.":"Varning, din glidning \xe4r h\xf6g.","Change":"\xc4ndra","Change settings":"\xc4ndra inst\xe4llningar","High slippage":"H\xf6g glidning","Low slippage":"L\xe5g glidning"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Varning, din glidning \xe4r h\xf6g (=",["userSlippage"],"). Din handel kan k\xf6ras framifr\xe5n."],"Confirm anyway":"Bekr\xe4fta \xe4nd\xe5","Something went wrong":"N\xe5got gick fel","Something went wrong. Please refresh the app.":"N\xe5got gick fel. V\xe4nligen uppdatera appen.","Slippage tolerance per swap":"Slippage tolerans per swap","Custom":"Anpassad","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Din transaktion kommer att \xe5terst\xe4llas om priset \xe4ndras ogynnsamt med mer \xe4n denna procentsats.","Warning":"Varning","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Denna inst\xe4llning till\xe4mpas p\xe5 varje steg (t.ex. 1Inch, Thorchain, etc.), vilket inneb\xe4r endast att specifika steg kommer att \xe5terst\xe4llas, inte hela v\xe4gen.","Swap Details":"V\xe4xla detaljer","Request ID":"Beg\xe4r ID","Not found":"Hittades inte","Swap with request ID = {requestId} not found.":["Byt mot f\xf6rfr\xe5gnings-ID = ",["requestId"]," hittades inte."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Du har f\xe5tt ",["amount"]," ",["token"]," i ",["conciseAddress"]," pl\xe5nboken p\xe5 ",["chain"]," kedjan."],"Transaction was not sent.":"Transaktionen skickades inte.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," p\xe5 ",["blockchain"]," finns kvar i din pl\xe5nbok."],"Delete":"Radera","Try again":"F\xf6rs\xf6k igen","Copied To Clipboard":"Kopierad till urklipp","Copy Request ID":"Kopiera beg\xe4ran ID","View on Rango Explorer":"Visa p\xe5 Rango Explorer","Finished at":"Klart den","Created at":"Skapad den","View transaction":"Visa transaktion","Connect":"Anslut","Swap Successful":"Byte lyckades","Transaction Failed":"Transaktionen misslyckades","Done":"Klar","Diagnosis":"Diagnos","See Details":"Se detaljer","Cancel Swap":"Avbryt Swap","Are you sure you want to cancel this swap?":"\xc4r du s\xe4ker p\xe5 att du vill avbryta denna swap?","Yes, Cancel it":"Ja, Avbryt det","No, Continue":"Nej, forts\xe4tt","Delete Transaction":"Ta bort transaktion","Are you sure you want to delete this swap?":"\xc4r du s\xe4ker p\xe5 att du vill ta bort denna swap?","Yes, Delete it":"Ja, ta bort den","No, Cancel":"Nej, Avbryt","Change Network":"\xc4ndra n\xe4tverk","Network Changed":"N\xe4tverk \xe4ndrat","Select Token":"V\xe4lj token","Wallet Connected":"Pl\xe5nbok ansluten","Your wallet is connected, you can use it to swap.":"Din pl\xe5nbok \xe4r ansluten, du kan anv\xe4nda den f\xf6r att byta.","Failed to Connect":"Anslutningen misslyckades","Your wallet is not connected. Please try again.":"Din pl\xe5nbok \xe4r inte ansluten. F\xf6rs\xf6k igen.","Connecting to your wallet":"Ansluter till din pl\xe5nbok","Click connect in your wallet popup.":"Klicka p\xe5 anslut i din pl\xe5nbok popup.","Select Derivation Path":"V\xe4lj Derivations s\xf6kv\xe4g","In order to connect to {type}, you must first select a Derivation Path":["F\xf6r att ansluta till ",["type"],"m\xe5ste du f\xf6rst v\xe4lja en Derivation s\xf6kv\xe4g"],"Choose Derivation Path Template":"V\xe4lj mall f\xf6r Derivations s\xf6kv\xe4g","Enter Path":"Ange s\xf6kv\xe4g","Enter Index":"Ange index","Add {blockchainDisplayName} Chain":["L\xe4gg till ",["blockchainDisplayName"]," Chain"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Vill du l\xe4gga till den experimentella kedjan ",["blockchainDisplayName"]," i din pl\xe5nbok?"],"Please approve the experimental chain pop-up in your wallet.":"V\xe4nligen godk\xe4nn den experimentella kedjans pop-up i din pl\xe5nbok.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," kedja tillagd"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Kedjan ",["blockchainDisplayName"]," har lagts till i din pl\xe5nbok."],"Request Rejected":"Beg\xe4ran avvisad","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Du har avb\xf6jt att l\xe4gga till ",["blockchainDisplayName"]," kedjan i din pl\xe5nbok."],"Select chain types":"V\xe4lj kedjetyper","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Denna pl\xe5nbok st\xf6der flera kedjor. V\xe4lj vilken kedja du vill ansluta till.","Failed Network, Please retry your swap.":"Det gick inte att n\xe4tverka, f\xf6rs\xf6k igen din swap.","Please reset your liquidity sources.":"V\xe4nligen \xe5terst\xe4ll dina likviditetsk\xe4llor.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Du har begr\xe4nsat likviditetsk\xe4llorna och detta kan leda till att Rango inte hittar n\xe5gra rutter. V\xe4nligen \xf6verv\xe4ga att \xe5terst\xe4lla dina likviditetsk\xe4llor.","No Routes Found.":"Inga rutter hittade.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Anledningar till varf\xf6r Rango inte kunde hitta en v\xe4g: l\xe5g likviditet p\xe5 token, mycket l\xe5g inmatningsbelopp eller inga rutter tillg\xe4ngliga f\xf6r den valda ing\xe5ng/utmatningskombinationen.","Bridge Limit Error: Please increase your amount.":"Bridgegr\xe4ns fel: \xf6ka ditt belopp.","Bridge Limit Error: Please decrease your amount.":"Brobegr\xe4nsningsfel: V\xe4nligen minska ditt belopp.","High Price Impact":"H\xf6ga priseffekter","Price impact is too high!":"Priseffekten \xe4r f\xf6r h\xf6g!","The price impact is significantly higher than the allowed amount.":"Priseffekten \xe4r betydligt h\xf6gre \xe4n det till\xe5tna beloppet.","Confirm high price impact":"Bekr\xe4fta h\xf6g prisp\xe5verkan","Route updated and price impact is too high, try again later!":"Rutten uppdaterad och priseffekten \xe4r f\xf6r h\xf6g, f\xf6rs\xf6k igen senare!","USD Price Unknown":"USD Pris Ok\xe4nd","USD Price Unknown, Cannot calculate Price Impact.":"USD Pris Ok\xe4nd, Kan inte ber\xe4kna prisp\xe5verkan.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Pris Ok\xe4nd, Kan inte ber\xe4kna prisp\xe5verkan. Prisp\xe5verkan kan vara h\xf6gre \xe4n vanligt. \xc4r du s\xe4ker p\xe5 att forts\xe4tta Swap?","Confirm USD Price Unknown":"Bekr\xe4fta USD pris ok\xe4nt","Swap":"Byt","Swap anyway":"Byt \xe4nd\xe5","The route goes through Ethereum. Continue?":"Rutten g\xe5r genom Ethereum. Forts\xe4tt?","Route has been updated.":"Rutten har uppdaterats.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Utdatabeloppet har \xe4ndrats till ",["newOutputAmount"]," (",["percentageChange"],"% \xe4ndring)."],"Route swappers has been updated.":"Utbytare av rutter har uppdaterats.","Route internal coins has been updated.":"Rutten interna mynt har uppdaterats.","Routes":"Rutter","From":"Fr\xe5n","To":"Till","Light":"Ljus","Dark":"M\xf6rk","Auto":"Automatiskt","Loading failed":"Laddningen misslyckades","Bridges":"Broar","Exchanges":"Byten","Custom Tokens":"Anpassade Tokens","Language":"Spr\xe5k","Infinite approval":"O\xe4ndligt godk\xe4nnande","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Aktivering av O\xe4ndligt godk\xe4nnande ger obegr\xe4nsad \xe5tkomst till underliggande smarta kontrakt, vilket ger dem m\xf6jlighet att anv\xe4nda det godk\xe4nda tokenbeloppet utan begr\xe4nsningar.","Theme":"Tema","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"Adressen du angav \xe4r dubblett, ange en ny adress.","Token Already Exists":"Token finns redan","There\'s no need to add this token again because it already exists and is supported by us.":"Det finns ingen anledning att l\xe4gga till denna token igen eftersom den redan finns och st\xf6ds av oss.","Token Not Found":"Token hittades inte","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Tyv\xe4rr, ingen token hittades p\xe5 ",["blockchain"]," kedjan med den angivna adressen. Kontrollera att du har angett r\xe4tt token adress."],"Network Error":"N\xe4tverksfel","Add Custom Token":"L\xe4gg till anpassad token","Select chain":"V\xe4lj kedja","Enter Address":"Ange adress","Enter token address":"Ange token adress","Failed Network, Please retry.":"Det gick inte att n\xe4tverka, f\xf6rs\xf6k igen.","Add another custom token":"L\xe4gg till en annan anpassad token","Confirm Swap":"Bekr\xe4fta byte","Start Swap":"Starta byte","You get":"Du f\xe5r","Search Token":"S\xf6k Token","No custom tokens":"Inga anpassade tokens","press the button to add your custom token":"Tryck p\xe5 knappen f\xf6r att l\xe4gga till din anpassade token","Delete Custom Token":"Ta bort anpassad token","Are you sure you want to Delete this Token?":"\xc4r du s\xe4ker p\xe5 att du vill ta bort detta token?","Complete":"Complete","Running":"K\xf6rs","Failed":"Misslyckades","Clear":"Rensa","Search Transaction":"S\xf6k transaktion","No transactions":"Inga transaktioner","Your transaction history is stored locally and will appear here after you start a swap":"Din transaktionshistorik lagras lokalt och kommer att visas h\xe4r n\xe4r du startar ett byte","Clear Transaction History":"Rensa transaktionshistorik","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Forts\xe4ttning kommer att ta bort alla lyckade och misslyckade transaktioner fr\xe5n widget. Vill du forts\xe4tta?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Obs: Detta raderar inte din transaktionshistorik i kedjan; det tar bara bort dem h\xe4r.","Yes, Clear the history":"Ja, Rensa historiken","language":"spr\xe5k","Deselect all":"Avmarkera alla","Select all":"Markera alla","Search {sourceType}":["S\xf6k ",["sourceType"]],"Search Chain":"S\xf6k Kedja","Source":"K\xe4lla","Destination":"M\xe5l","Swap {type}":["Byt ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"F\xf6r n\xe4rvarande \xe4r du i kampanjl\xe4ge med restriktioner f\xf6r likviditetsk\xe4llor. Vill du byta ut det h\xe4r l\xe4get och utnyttja alla tillg\xe4ngliga likviditetsk\xe4llor?","The request ID is necessary to display the swap details.":"Beg\xe4ran ID \xe4r n\xf6dv\xe4ndigt f\xf6r att visa swap detaljer.","Connect Wallets":"Anslut pl\xe5nb\xf6cker","Choose a wallet to connect.":"V\xe4lj en pl\xe5nbok att ansluta.","This week":"Denna vecka","This month":"Denna m\xe5nad","This year":"I \xe5r","Required: >= {min} {symbol}":["Kr\xe4vs: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Kr\xe4vs: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Kr\xe4vs: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Kr\xe4vs: < ",["max"]," ",["symbol"]]," for network fee":" f\xf6r n\xe4tverksavgift"," for swap":" f\xf6r byte"," for input and network fee":" f\xf6r in- och n\xe4tverksavgift","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Beh\xf6vs \u2191 ",["requiredAmount"]," ",["symbol"],["reason"],", men du har ",["currentAmount"]," ",["symbol"]," i din ",["blockchain"]," pl\xe5nbok."],"Waiting for connecting wallet":"V\xe4ntar p\xe5 att ansluta pl\xe5nbok","Waiting for other running tasks to be finished":"V\xe4ntar p\xe5 att andra p\xe5g\xe5ende uppgifter ska vara klara","Waiting for changing wallet network":"V\xe4ntar p\xe5 att byta pl\xe5nboksn\xe4tverk","Sunday":"S\xf6ndag","Monday":"M\xe5ndag","Tuesday":"Tisdag","Wednesday":"Onsdag","Thursday":"Torsdag","Friday":"Fredag","Saturday":"L\xf6rdag","Powered By":"Drivs av","Aggregated Transaction":"Aggregerad transaktion","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Byt p\xe5 ",["fromChain"]," via ",["swapper"]],"Bridge to {toChain} via {swapper}":["Bron till ",["toChain"]," via ",["swapper"]],"Completed":"Slutf\xf6rd","In progress":"p\xe5g\xe5r","Waiting for bridge transaction":"V\xe4ntar p\xe5 bryggtransaktion","Connected":"Ansluten","Disconnect":"Koppla fr\xe5n","Install":"Installera","Connecting ...":"Ansluter ...","Connecting":"Ansluter","Disconnected":"Fr\xe5nkopplad","you need to pass a correct state to Wallet.":"du m\xe5ste skicka ett korrekt tillst\xe5nd till pl\xe5nboken.","There are no notifications.":"Det finns inga meddelanden.","Clear all":"Rensa alla","Balance":"Saldo","Max":"Max"}');


/*eslint-disable*/ const $4e0261e7f0cf8f66$export$defe85febe8b728c = JSON.parse('{"No results found":"Hakuna matokeo yaliyopatikana","Try using different keywords":"Jaribu kutumia maneno muhimu tofauti","Select Chain":"Chagua Chain","All":"Wote","More +{count}":["Zaidi +",["count"]],"Activate this tab":"Amilisha kichupo hiki","Another tab is open and handles transactions.":"Kichupo kingine kimefunguliwa na kinashughulikia shughuli.","Activate current tab":"Washa kichupo cha sasa","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Hivi sasa, baadhi ya miamala inaendelea na inashughulikiwa na kichupo kingine cha kivinjari. Ukiwezesha kichupo hiki, miamala yote ambayo tayari iko katika hatua ya ishara ya muamala itaisha.","Confirm":"Thibitisha","Your {blockchainName} wallets":["Pochi zako ",["blockchainName"]],"Insufficient account balance":"Salio la akaunti halitoshi","Proceed anyway":"Endelea hata hivyo","You need to connect a {blockchainName} wallet.":["Unahitaji kuunganisha mkoba ",["blockchainName"]," ."],"Add {chain} chain":["Ongeza ",["chain"]," mnyororo"],"Show more wallets":"Onyesha pochi zaidi","Send to a different address":"Tuma kwa anwani tofauti","Enter {blockchainName} address":["Ingiza ",["blockchainName"]," anwani"],"Address {destination} doesn\'t match the blockchain address pattern.":["Anwani ",["destination"]," hailingani na muundo wa anwani ya blockchain."],"via":"kupitia","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Tokeni hii haionekani kwenye orodha ya tokeni inayotumika. Hakikisha kuwa hii ndiyo ishara unayotaka kufanya biashara.","Import":"Ingiza","Status":"Hali","Reset":"Weka upya","Cancel":"Ghairi","Refresh":"Onyesha upya","Notifications":"Arifa","Settings":"Mipangilio","History":"Historia","Connect Wallet":"Unganisha Wallet","Today":"Leo","Swaps steps":"Hubadilisha hatua","Retry":"Jaribu tena","Slippage Error":"Hitilafu ya Kuteleza","Slippage Warning":"Onyo la Kuteleza","Bridge Limit Error":"Hitilafu ya Kikomo cha Daraja","Yours: {amount} {symbol}":["Wako: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Kima cha chini cha utelezi kinachohitajika: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Wako: ",["userSlippage"]],"See All Routes":"Angalia Njia Zote","View more info":"Tazama maelezo zaidi","Gas & Fee Explanation":"Maelezo ya Gesi na Ada","Details":"Maelezo","Total Payable Fee":"Ada ya Jumla Inayolipwa","Hide non-payable fees":"Ficha ada zisizolipiwa","Show non-payable fees":"Onyesha ada zisizolipiwa","Description":"Maelezo","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"Ada zifuatazo zinazingatiwa katika matokeo ya muamala na\\n                hutahitaji kuzilipia gesi ya ziada.","Swap input":"Badilisha pembejeo","Estimated output":"Kadirio la matokeo","Via:":"Kupitia:","Chains:":"Minyororo:","Sort by":"Panga kwa","Smart Routing":"Smart Routing","Lowest Fee":"Ada ya chini kabisa","Fastest Transfer":"Uhamisho wa haraka zaidi","Maximum Return":"Upeo wa Kurudi","Maximum Output":"Upeo wa Pato","Swapping":"Kubadilishana","Gas cost":"Gharama ya gesi","Receiving":"Kupokea","Price impact":"Athari ya bei","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Unahitaji kuongeza utelezi hadi angalau ",["minRequiredSlippage"]," kwa njia hii."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Tunapendekeza uongeze utelezi hadi angalau ",["minRequiredSlippage"]," kwa njia hii."],"Caution, your slippage is high.":"Tahadhari, utelezi wako uko juu.","Change":"Badilika","Change settings":"Badilisha mipangilio","High slippage":"Utelezi wa hali ya juu","Low slippage":"Utelezi mdogo"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Tahadhari, utelezi wako uko juu (=",["userSlippage"],"). Biashara yako inaweza kuwa ya mbele."],"Confirm anyway":"Thibitisha hata hivyo","Something went wrong":"Hitilafu fulani imetokea","Something went wrong. Please refresh the app.":"Hitilafu fulani imetokea. Tafadhali onyesha upya programu.","Slippage tolerance per swap":"Uvumilivu wa kuteleza kwa ubadilishaji","Custom":"Desturi","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Muamala wako utarejeshwa ikiwa bei itabadilika isivyofaa kwa zaidi ya asilimia hii.","Warning":"Onyo","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Mpangilio huu unatumika kwa kila hatua (km 1Inch, Thorchain, n.k.), ikimaanisha tu hatua hiyo mahususi itarejeshwa, si njia nzima.","Swap Details":"Badilisha Maelezo","Request ID":"Ombi la kitambulisho","Not found":"Haijapatikana","Swap with request ID = {requestId} not found.":["Badili na ID ya ombi = ",["requestId"]," haijapatikana."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["Umepokea ",["amount"]," ",["token"]," in ",["conciseAddress"]," wallet kwenye ",["chain"]," mnyororo."],"Transaction was not sent.":"Muamala haukutumwa.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," on ",["blockchain"]," inabaki kwenye pochi yako."],"Delete":"Futa","Try again":"Jaribu tena","Copied To Clipboard":"Imenakiliwa kwenye Ubao wa kunakili","Copy Request ID":"Nakili Kitambulisho cha Ombi","View on Rango Explorer":"Tazama kwenye Rango Explorer","Finished at":"Imekamilika saa","Created at":"Imeundwa saa","View transaction":"Tazama muamala","Connect":"Unganisha","Swap Successful":"Kubadilishana Kumefaulu","Transaction Failed":"Muamala Umeshindwa","Done":"Imekamilika","Diagnosis":"Utambuzi","See Details":"Tazama Maelezo","Cancel Swap":"Ghairi Ubadilishanaji","Are you sure you want to cancel this swap?":"Je, una uhakika unataka kughairi ubadilishaji huu?","Yes, Cancel it":"Ndiyo, Ghairi","No, Continue":"Hapana, Endelea","Delete Transaction":"Futa Muamala","Are you sure you want to delete this swap?":"Je, una uhakika unataka kufuta ubadilishaji huu?","Yes, Delete it":"Ndiyo, Futa","No, Cancel":"Hapana, Ghairi","Change Network":"Badilisha Mtandao","Network Changed":"Mtandao Umebadilishwa","Select Token":"Chagua Tokeni","Wallet Connected":"Wallet Imeunganishwa","Your wallet is connected, you can use it to swap.":"Pochi yako imeunganishwa, unaweza kuitumia kubadilishana.","Failed to Connect":"Imeshindwa Kuunganisha","Your wallet is not connected. Please try again.":"Mkoba wako haujaunganishwa. Tafadhali jaribu tena.","Connecting to your wallet":"Inaunganisha kwenye pochi yako","Click connect in your wallet popup.":"Bofya unganisha kwenye dirisha ibukizi la mkoba wako.","Select Derivation Path":"Chagua Njia ya Utoaji","In order to connect to {type}, you must first select a Derivation Path":["Ili kuunganisha kwa ",["type"],", lazima kwanza uchague Njia ya Utokaji"],"Choose Derivation Path Template":"Chagua Kiolezo cha Njia ya Utoaji","Enter Path":"Ingiza Njia","Enter Index":"Ingiza Index","Add {blockchainDisplayName} Chain":["Ongeza ",["blockchainDisplayName"]," Mnyororo"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["Je, ungependa kuongeza msururu wa majaribio wa ",["blockchainDisplayName"]," kwenye pochi yako?"],"Please approve the experimental chain pop-up in your wallet.":"Tafadhali idhinisha msururu wa ibukizi wa majaribio kwenye pochi yako.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Mnyororo Umeongezwa"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Msururu wa ",["blockchainDisplayName"]," umeongezwa kwa mkoba wako."],"Request Rejected":"Ombi Limekataliwa","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["Umekataa kuongeza ",["blockchainDisplayName"]," mnyororo kwenye pochi yako."],"Select chain types":"Chagua aina za mnyororo","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Mkoba huu unasaidia minyororo mingi. Chagua ni msururu gani ungependa kuunganisha.","Failed Network, Please retry your swap.":"Mtandao Umeshindwa, Tafadhali jaribu tena kubadilishana kwako.","Please reset your liquidity sources.":"Tafadhali weka upya vyanzo vyako vya ukwasi.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Umedhibiti vyanzo vya ukwasi na hii inaweza kusababisha Rango isipate njia. Tafadhali zingatia kuweka upya vyanzo vyako vya ukwasi.","No Routes Found.":"Hakuna Njia Zilizopatikana.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Sababu kwa nini Rango haikuweza kupata njia: ukwasi mdogo kwenye tokeni, kiasi kidogo sana cha ingizo au hakuna njia zinazopatikana kwa mseto uliochaguliwa wa tokeni.","Bridge Limit Error: Please increase your amount.":"Hitilafu ya Kikomo cha Daraja: Tafadhali ongeza kiasi chako.","Bridge Limit Error: Please decrease your amount.":"Hitilafu ya Kikomo cha Daraja: Tafadhali punguza kiasi chako.","High Price Impact":"Athari ya Bei ya Juu","Price impact is too high!":"Athari ya bei ni kubwa mno!","The price impact is significantly higher than the allowed amount.":"Athari ya bei ni kubwa zaidi kuliko kiasi kinachoruhusiwa.","Confirm high price impact":"Thibitisha athari ya bei ya juu","Route updated and price impact is too high, try again later!":"Njia imesasishwa na athari ya bei ni kubwa mno, jaribu tena baadaye!","USD Price Unknown":"Bei ya USD Haijulikani","USD Price Unknown, Cannot calculate Price Impact.":"Bei ya USD Haijulikani, Haiwezi kukokotoa Athari ya Bei.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Bei ya USD Haijulikani, Haiwezi kukokotoa Athari ya Bei. Athari ya bei inaweza kuwa kubwa kuliko kawaida. Je, una uhakika kuendelea Kubadilishana?","Confirm USD Price Unknown":"Thibitisha Bei ya USD Haijulikani","Swap":"Badili","Swap anyway":"Badili hata hivyo","The route goes through Ethereum. Continue?":"Njia inapitia Ethereum. Ungependa kuendelea?","Route has been updated.":"Njia imesasishwa.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["Kiasi cha pato kimebadilishwa hadi ",["newOutputAmount"]," (",["percentageChange"],"% badilisha)."],"Route swappers has been updated.":"Vibadilishaji njia vimesasishwa.","Route internal coins has been updated.":"Sarafu za ndani za njia zimesasishwa.","Routes":"Njia","From":"Kutoka","To":"Kwa","Light":"Mwanga","Dark":"Giza","Auto":"Otomatiki","Loading failed":"Imeshindwa kupakia","Bridges":"Madaraja","Exchanges":"Mabadilishano","Custom Tokens":"Ishara Maalum","Language":"Lugha","Infinite approval":"Idhini isiyo na kikomo","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"Kuwasha hali ya \'Uidhinishaji usio na kikomo\' hutoa ufikiaji usio na kikomo kwa mikataba ya msingi mahiri, na kuwaruhusu kutumia kiasi cha tokeni kilichoidhinishwa bila vikwazo.","Theme":"Mandhari","Duplicate Token":"Tokeni Nakala","The address you entered is duplicate, please enter a new address.":"Anwani uliyoweka ni nakala, tafadhali weka anwani mpya.","Token Already Exists":"Ishara Tayari Ipo","There\'s no need to add this token again because it already exists and is supported by us.":"Hakuna haja ya kuongeza tokeni hii tena kwa sababu tayari ipo na tunaitumia.","Token Not Found":"Ishara Haijapatikana","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Samahani, hakuna tokeni iliyopatikana kwenye mnyororo wa ",["blockchain"]," na anwani iliyotolewa. tafadhali hakikisha kuwa umeingiza anwani sahihi ya tokeni."],"Network Error":"Hitilafu ya Mtandao","Add Custom Token":"Ongeza Tokeni Maalum","Select chain":"Chagua mnyororo","Enter Address":"Weka Anwani","Enter token address":"Weka anwani ya ishara","Failed Network, Please retry.":"Mtandao Umeshindwa, Tafadhali jaribu tena.","Add another custom token":"Ongeza tokeni nyingine maalum","Confirm Swap":"Thibitisha Kubadilishana","Start Swap":"Anza Kubadilishana","You get":"Unapata","Search Token":"Tafuta Tokeni","No custom tokens":"Hakuna tokeni maalum","press the button to add your custom token":"bonyeza kitufe ili kuongeza tokeni yako maalum","Delete Custom Token":"Futa Tokeni Maalum","Are you sure you want to Delete this Token?":"Je, una uhakika unataka Kufuta Tokeni hii?","Complete":"Kamilisha","Running":"Kukimbia","Failed":"Imeshindwa","Clear":"Wazi","Search Transaction":"Tafuta Muamala","No transactions":"Hakuna shughuli","Your transaction history is stored locally and will appear here after you start a swap":"Historia yako ya muamala imehifadhiwa ndani na itaonekana hapa baada ya kuanza kubadilishana","Clear Transaction History":"Futa Historia ya Muamala","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Kuendelea kutaondoa miamala yote iliyofaulu na iliyofeli kwenye wijeti. Je, ungependa kuendelea?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Kumbuka: Hii haifuti historia yako ya muamala kwenye msururu; inawaondoa hapa tu.","Yes, Clear the history":"Ndiyo, Futa historia","language":"lugha","Deselect all":"Acha kuchagua zote","Select all":"Chagua zote","Search {sourceType}":["Tafuta ",["sourceType"]],"Search Chain":"Msururu wa Utafutaji","Source":"Chanzo","Destination":"Marudio","Swap {type}":["Badilisha ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Kwa sasa, uko katika hali ya kampeni na vikwazo kwenye vyanzo vya ukwasi. Je, ungependa kuondoka kwenye hali hii na kutumia vyanzo vyote vya ukwasi vinavyopatikana?","The request ID is necessary to display the swap details.":"Kitambulisho cha ombi ni muhimu ili kuonyesha maelezo ya kubadilishana.","Connect Wallets":"Unganisha Pochi","Choose a wallet to connect.":"Chagua mkoba ili kuunganisha.","This week":"Wiki hii","This month":"Mwezi huu","This year":"Mwaka huu","Required: >= {min} {symbol}":["Inahitajika: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Inahitajika: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Inahitajika: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Inahitajika: < ",["max"]," ",["symbol"]]," for network fee":" kwa ada ya mtandao"," for swap":" kwa kubadilishana"," for input and network fee":" kwa pembejeo na ada ya mtandao","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["Inahitaji \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", lakini unayo ",["currentAmount"]," ",["symbol"]," kwenye mkoba wako wa ",["blockchain"]," ."],"Waiting for connecting wallet":"Inasubiri kuunganisha pochi","Waiting for other running tasks to be finished":"Inasubiri kazi zingine zinazoendeshwa zikamilike","Waiting for changing wallet network":"Inasubiri kubadilisha mtandao wa pochi","Sunday":"Jumapili","Monday":"Jumatatu","Tuesday":"Jumanne","Wednesday":"Jumatano","Thursday":"Alhamisi","Friday":"Ijumaa","Saturday":"Jumamosi","Powered By":"Inaendeshwa Na","Aggregated Transaction":"Muamala Uliojumlishwa","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["Badili kwa ",["fromChain"]," kupitia ",["swapper"]],"Bridge to {toChain} via {swapper}":["Daraja hadi ",["toChain"]," kupitia ",["swapper"]],"Completed":"Imekamilika","In progress":"Inaendelea","Waiting for bridge transaction":"Inasubiri muamala wa daraja","Connected":"Imeunganishwa","Disconnect":"Tenganisha","Install":"Sakinisha","Connecting ...":"Inaunganisha...","Connecting":"Inaunganisha","Disconnected":"Imetenganishwa","you need to pass a correct state to Wallet.":"unahitaji kupitisha hali sahihi kwa Wallet.","There are no notifications.":"Hakuna arifa.","Clear all":"Futa zote","Balance":"Mizani","Max":"Max"}');


/*eslint-disable*/ const $566c5a96df87467f$export$defe85febe8b728c = JSON.parse('{"No results found":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C","Try using different keywords":"\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E04\u0E33\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E2D\u0E37\u0E48\u0E19 \u0E46","Select Chain":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E0B\u0E48","All":"\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","More +{count}":["\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21 +",["count"]],"Activate this tab":"\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E19\u0E35\u0E49","Another tab is open and handles transactions.":"\u0E21\u0E35\u0E41\u0E17\u0E47\u0E1A\u0E2D\u0E37\u0E48\u0E19\u0E40\u0E1B\u0E34\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","Activate current tab":"\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E21\u0E35\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E25\u0E30\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E42\u0E14\u0E22\u0E41\u0E17\u0E47\u0E1A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E17\u0E47\u0E1A\u0E19\u0E35\u0E49 \u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E19\u0E32\u0E21\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E08\u0E30\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38","Confirm":"\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19","Your {blockchainName} wallets":["\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C ",["blockchainName"]," \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"],"Insufficient account balance":"\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19\u0E43\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D","Proceed anyway":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B","You need to connect a {blockchainName} wallet.":["\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19 ",["blockchainName"]],"Add {chain} chain":["\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E48 ",["chain"]],"Show more wallets":"\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","Send to a different address":"\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E37\u0E48\u0E19","Enter {blockchainName} address":["\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 ",["destination"]," \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E40\u0E0A\u0E19"],"via":"\u0E17\u0E32\u0E07","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Import":"\u0E01\u0E32\u0E23\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32","Status":"\u0E2A\u0E16\u0E32\u0E19\u0E30","Reset":"\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15","Cancel":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","Refresh":"\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A","Notifications":"\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19","Settings":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","History":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E28\u0E32\u0E2A\u0E15\u0E23\u0E4C","Connect Wallet":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C","Today":"\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49","Swaps steps":"\u0E2A\u0E25\u0E31\u0E1A\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19","Retry":"\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","Slippage Error":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E01\u0E32\u0E23\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25","Slippage Warning":"\u0E04\u0E33\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25","Bridge Limit Error":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E01\u0E32\u0E23\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2A\u0E30\u0E1E\u0E32\u0E19","Yours: {amount} {symbol}":["\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u0E04\u0E48\u0E32\u0E2A\u0E25\u0E34\u0E1B\u0E40\u0E1B\u0E08\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13: ",["userSlippage"]],"See All Routes":"\u0E14\u0E39\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","View more info":"\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","Gas & Fee Explanation":"\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E4A\u0E32\u0E0B\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21","Details":"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14","Total Payable Fee":"\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E23\u0E27\u0E21\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E0A\u0E33\u0E23\u0E30","Hide non-payable fees":"\u0E0B\u0E48\u0E2D\u0E19\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E0A\u0E33\u0E23\u0E30","Show non-payable fees":"\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E0A\u0E33\u0E23\u0E30","Description":"\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E14\u0E31\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E08\u0E30\u0E16\u0E39\u0E01\u0E19\u0E33\u0E21\u0E32\u0E1E\u0E34\u0E08\u0E32\u0E23\u0E13\u0E32\u0E43\u0E19\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E02\u0E2D\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21 \u0E41\u0E25\u0E30\\n                \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E48\u0E32\u0E22\u0E04\u0E48\u0E32\u0E01\u0E4A\u0E32\u0E0B\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49","Swap input":"\u0E2A\u0E25\u0E31\u0E1A\u0E2D\u0E34\u0E19\u0E1E\u0E38\u0E15","Estimated output":"\u0E1C\u0E25\u0E1C\u0E25\u0E34\u0E15\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13","Via:":"\u0E17\u0E32\u0E07:","Chains:":"\u0E42\u0E0B\u0E48:","Sort by":"\u0E08\u0E31\u0E14\u0E40\u0E23\u0E35\u0E22\u0E07\u0E15\u0E32\u0E21","Smart Routing":"\u0E01\u0E32\u0E23\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E2D\u0E31\u0E08\u0E09\u0E23\u0E34\u0E22\u0E30","Lowest Fee":"\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E15\u0E48\u0E33\u0E2A\u0E38\u0E14","Fastest Transfer":"\u0E42\u0E2D\u0E19\u0E16\u0E48\u0E32\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14","Maximum Return":"\u0E1C\u0E25\u0E15\u0E2D\u0E1A\u0E41\u0E17\u0E19\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14","Maximum Output":"\u0E40\u0E2D\u0E32\u0E17\u0E4C\u0E1E\u0E38\u0E15\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14","Swapping":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Gas cost":"\u0E04\u0E48\u0E32\u0E41\u0E01\u0E4A\u0E2A","Receiving":"\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A","Price impact":"\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 ",["minRequiredSlippage"]," \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E19\u0E35\u0E49"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 ",["minRequiredSlippage"]," \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E19\u0E35\u0E49"],"Caution, your slippage is high.":"\u0E23\u0E30\u0E27\u0E31\u0E07 \u0E01\u0E32\u0E23\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E2A\u0E39\u0E07","Change":"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Change settings":"\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32","High slippage":"\u0E04\u0E27\u0E32\u0E21\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25\u0E2A\u0E39\u0E07","Low slippage":"\u0E04\u0E27\u0E32\u0E21\u0E25\u0E37\u0E48\u0E19\u0E44\u0E16\u0E25\u0E15\u0E48\u0E33"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0E23\u0E30\u0E27\u0E31\u0E07 \u0E2A\u0E25\u0E34\u0E1B\u0E40\u0E1E\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E39\u0E07 (=",["userSlippage"],") \u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E40\u0E01\u0E34\u0E14\u0E01\u0E32\u0E23\u0E1F\u0E23\u0E2D\u0E19\u0E17\u0E4C\u0E23\u0E31\u0E19"],"Confirm anyway":"\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E15\u0E48\u0E2D\u0E44\u0E1B","Something went wrong":"\u0E21\u0E35\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19","Something went wrong. Please refresh the app.":"\u0E21\u0E35\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E41\u0E2D\u0E1B","Slippage tolerance per swap":"\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E25\u0E34\u0E1B\u0E15\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A","Custom":"\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E01\u0E25\u0E31\u0E1A\u0E04\u0E37\u0E19\u0E2B\u0E32\u0E01\u0E23\u0E32\u0E04\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E43\u0E19\u0E17\u0E32\u0E07\u0E25\u0E1A\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E19\u0E35\u0E49","Warning":"\u0E04\u0E33\u0E40\u0E15\u0E37\u0E2D\u0E19","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E19\u0E35\u0E49\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E25\u0E30\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19 (\u0E40\u0E0A\u0E48\u0E19 1 \u0E19\u0E34\u0E49\u0E27, Thorchain \u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19) \u0E0B\u0E36\u0E48\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E27\u0E48\u0E32\u0E08\u0E30\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","Swap Details":"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A","Request ID":"\u0E02\u0E2D\u0E23\u0E2B\u0E31\u0E2A ID","Not found":"\u0E44\u0E21\u0E48\u0E1E\u0E1A","Swap with request ID = {requestId} not found.":["\u0E2A\u0E25\u0E31\u0E1A\u0E01\u0E31\u0E1A ID \u0E04\u0E33\u0E02\u0E2D = ",["requestId"]," \u0E44\u0E21\u0E48\u0E1E\u0E1A."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A ",["amount"]," ",["token"]," \u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19 ",["conciseAddress"]," \u0E1A\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22 ",["chain"]],"Transaction was not sent.":"\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u0E1A\u0E19 ",["blockchain"]," \u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"],"Delete":"\u0E25\u0E1A","Try again":"\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","Copied To Clipboard":"\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14","Copy Request ID":"\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E04\u0E33\u0E02\u0E2D ID","View on Rango Explorer":"\u0E14\u0E39\u0E1A\u0E19 Rango Explorer","Finished at":"\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\u0E41\u0E25\u0E49\u0E27\u0E17\u0E35\u0E48","Created at":"\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D","View transaction":"\u0E14\u0E39\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","Connect":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","Swap Successful":"\u0E2A\u0E25\u0E31\u0E1A\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","Transaction Failed":"\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","Done":"\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27","Diagnosis":"\u0E01\u0E32\u0E23\u0E27\u0E34\u0E19\u0E34\u0E08\u0E09\u0E31\u0E22","See Details":"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14","Cancel Swap":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Are you sure you want to cancel this swap?":"\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?","Yes, Cancel it":"\u0E43\u0E0A\u0E48 \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E21\u0E31\u0E19","No, Continue":"\u0E44\u0E21\u0E48 \u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","Delete Transaction":"\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","Are you sure you want to delete this swap?":"\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?","Yes, Delete it":"\u0E43\u0E0A\u0E48 \u0E25\u0E1A\u0E21\u0E31\u0E19\u0E0B\u0E30","No, Cancel":"\u0E44\u0E21\u0E48 \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","Change Network":"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22","Network Changed":"\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07","Select Token":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","Wallet Connected":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C","Your wallet is connected, you can use it to swap.":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E21\u0E31\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E14\u0E49","Failed to Connect":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49","Your wallet is not connected. Please try again.":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","Connecting to your wallet":"\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","Click connect in your wallet popup.":"\u0E04\u0E25\u0E34\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E19\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1B\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","Select Derivation Path":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E32\u0E19","In order to connect to {type}, you must first select a Derivation Path":["\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A ",["type"],"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E21\u0E32\u0E01\u0E48\u0E2D\u0E19"],"Choose Derivation Path Template":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E17\u0E21\u0E40\u0E1E\u0E25\u0E15\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E32\u0E19","Enter Path":"\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07","Enter Index":"\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E14\u0E31\u0E0A\u0E19\u0E35","Add {blockchainDisplayName} Chain":["\u0E40\u0E1E\u0E34\u0E48\u0E21 ",["blockchainDisplayName"]," \u0E40\u0E0A\u0E19"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E48\u0E17\u0E14\u0E25\u0E2D\u0E07 ",["blockchainDisplayName"]," \u0E25\u0E07\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48"],"Please approve the experimental chain pop-up in your wallet.":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E43\u0E2B\u0E49\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1B\u0E42\u0E0B\u0E48\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E48\u0E41\u0E25\u0E49\u0E27"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E48 ",["blockchainDisplayName"]," \u0E25\u0E07\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27"],"Request Rejected":"\u0E04\u0E33\u0E02\u0E2D\u0E16\u0E39\u0E01\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0E04\u0E38\u0E13\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E0B\u0E48 ",["blockchainDisplayName"]," \u0E25\u0E07\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"],"Select chain types":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E42\u0E0B\u0E48","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E19\u0E35\u0E49\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E2B\u0E25\u0E32\u0E22\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22 \u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","Failed Network, Please retry your swap.":"\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2A\u0E25\u0E31\u0E1A\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","Please reset your liquidity sources.":"\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E08\u0E33\u0E01\u0E31\u0E14\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E44\u0E27\u0E49 \u0E0B\u0E36\u0E48\u0E07\u0E2D\u0E32\u0E08\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E43\u0E2B\u0E49 Rango \u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E43\u0E14 \u0E46 \u0E42\u0E1B\u0E23\u0E14\u0E1E\u0E34\u0E08\u0E32\u0E23\u0E13\u0E32\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","No Routes Found.":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u0E2A\u0E32\u0E40\u0E2B\u0E15\u0E38\u0E17\u0E35\u0E48 Rango \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49: \u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E15\u0E48\u0E33, \u0E1B\u0E23\u0E34\u0E21\u0E32\u0E13\u0E2D\u0E34\u0E19\u0E1E\u0E38\u0E15\u0E15\u0E48\u0E33\u0E21\u0E32\u0E01 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E0A\u0E38\u0E14\u0E04\u0E48\u0E32\u0E1C\u0E2A\u0E21\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E2D\u0E34\u0E19\u0E1E\u0E38\u0E15/\u0E40\u0E2D\u0E32\u0E15\u0E4C\u0E1E\u0E38\u0E15\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01","Bridge Limit Error: Please increase your amount.":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E01\u0E32\u0E23\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2A\u0E30\u0E1E\u0E32\u0E19: \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","Bridge Limit Error: Please decrease your amount.":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E01\u0E32\u0E23\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2A\u0E30\u0E1E\u0E32\u0E19: \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E14\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","High Price Impact":"\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E39\u0E07","Price impact is too high!":"\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E39\u0E07\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B!","The price impact is significantly higher than the allowed amount.":"\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E08\u0E30\u0E2A\u0E39\u0E07\u0E01\u0E27\u0E48\u0E32\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E32\u0E01","Confirm high price impact":"\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E39\u0E07","Route updated and price impact is too high, try again later!":"\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27\u0E41\u0E25\u0E30\u0E21\u0E35\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E39\u0E07\u0E40\u0E01\u0E34\u0E19\u0E44\u0E1B \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07!","USD Price Unknown":"\u0E23\u0E32\u0E04\u0E32 USD \u0E44\u0E21\u0E48\u0E17\u0E23\u0E32\u0E1A","USD Price Unknown, Cannot calculate Price Impact.":"\u0E23\u0E32\u0E04\u0E32 USD \u0E44\u0E21\u0E48\u0E17\u0E23\u0E32\u0E1A \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E33\u0E19\u0E27\u0E13\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E44\u0E14\u0E49","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u0E23\u0E32\u0E04\u0E32 USD \u0E44\u0E21\u0E48\u0E17\u0E23\u0E32\u0E1A \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E33\u0E19\u0E27\u0E13\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E44\u0E14\u0E49 \u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E23\u0E32\u0E04\u0E32\u0E2D\u0E32\u0E08\u0E2A\u0E39\u0E07\u0E01\u0E27\u0E48\u0E32\u0E1B\u0E01\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23 Swap \u0E15\u0E48\u0E2D","Confirm USD Price Unknown":"\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E23\u0E32\u0E04\u0E32 USD \u0E44\u0E21\u0E48\u0E17\u0E23\u0E32\u0E1A","Swap":"\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Swap anyway":"\u0E2A\u0E25\u0E31\u0E1A\u0E01\u0E31\u0E19","The route goes through Ethereum. Continue?":"\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E08\u0E30\u0E1C\u0E48\u0E32\u0E19 Ethereum \u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?","Route has been updated.":"\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0E1B\u0E23\u0E34\u0E21\u0E32\u0E13\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E16\u0E39\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E1B\u0E47\u0E19 ",["newOutputAmount"]," (",["percentageChange"],"% \u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07)"],"Route swappers has been updated.":"\u0E15\u0E31\u0E27\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27","Route internal coins has been updated.":"\u0E40\u0E2B\u0E23\u0E35\u0E22\u0E0D\u0E20\u0E32\u0E22\u0E43\u0E19\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27","Routes":"\u0E40\u0E2A\u0E49\u0E19\u0E17\u0E32\u0E07","From":"\u0E08\u0E32\u0E01","To":"\u0E16\u0E36\u0E07","Light":"\u0E41\u0E2A\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07","Dark":"\u0E21\u0E37\u0E14","Auto":"\u0E2D\u0E2D\u0E42\u0E15\u0E49","Loading failed":"\u0E01\u0E32\u0E23\u0E42\u0E2B\u0E25\u0E14\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","Bridges":"\u0E2A\u0E30\u0E1E\u0E32\u0E19","Exchanges":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","Custom Tokens":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07","Language":"\u0E20\u0E32\u0E29\u0E32","Infinite approval":"\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E17\u0E35\u0E48\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E42\u0E2B\u0E21\u0E14 \'\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\' \u0E08\u0E30\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E2D\u0E31\u0E08\u0E09\u0E23\u0E34\u0E22\u0E30\u0E1E\u0E37\u0E49\u0E19\u0E10\u0E32\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14 \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E08\u0E33\u0E19\u0E27\u0E19\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14","Theme":"\u0E18\u0E35\u0E21","Duplicate Token":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E0B\u0E49\u0E33","The address you entered is duplicate, please enter a new address.":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E1B\u0E49\u0E2D\u0E19\u0E0B\u0E49\u0E33 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E1B\u0E49\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E2B\u0E21\u0E48","Token Already Exists":"\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27","There\'s no need to add this token again because it already exists and is supported by us.":"\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07 \u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E41\u0E25\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E08\u0E32\u0E01\u0E40\u0E23\u0E32\u0E41\u0E25\u0E49\u0E27","Token Not Found":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E1A\u0E19\u0E40\u0E0A\u0E19 ",["blockchain"]," \u0E17\u0E35\u0E48\u0E21\u0E35\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E44\u0E27\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E49\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07"],"Network Error":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E2D\u0E07\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22","Add Custom Token":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07","Select chain":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E0B\u0E48","Enter Address":"\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","Enter token address":"\u0E1B\u0E49\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","Failed Network, Please retry.":"\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","Add another custom token":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07\u0E2D\u0E37\u0E48\u0E19","Confirm Swap":"\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A","Start Swap":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","You get":"\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A","Search Token":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19","No custom tokens":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07","press the button to add your custom token":"\u0E01\u0E14\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13","Delete Custom Token":"\u0E25\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07","Are you sure you want to Delete this Token?":"\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E42\u0E17\u0E40\u0E04\u0E47\u0E19\u0E19\u0E35\u0E49?","Complete":"\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","Running":"\u0E27\u0E34\u0E48\u0E07","Failed":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","Clear":"\u0E0A\u0E31\u0E14\u0E40\u0E08\u0E19","Search Transaction":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","No transactions":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","Your transaction history is stored locally and will appear here after you start a swap":"\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E25\u0E31\u0E1A","Clear Transaction History":"\u0E25\u0E49\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E08\u0E30\u0E25\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E30\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E27\u0E34\u0E14\u0E40\u0E08\u0E47\u0E15 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E25\u0E1A\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1A\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22 \u0E41\u0E15\u0E48\u0E08\u0E30\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","Yes, Clear the history":"\u0E43\u0E0A\u0E48 \u0E25\u0E49\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E27\u0E31\u0E15\u0E34","language":"\u0E20\u0E32\u0E29\u0E32","Deselect all":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","Select all":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","Search {sourceType}":["\u0E04\u0E49\u0E19\u0E2B\u0E32 ",["sourceType"]],"Search Chain":"\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E41\u0E1A\u0E1A\u0E42\u0E0B\u0E48","Source":"\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E17\u0E35\u0E48\u0E21\u0E32","Destination":"\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07","Swap {type}":["\u0E2A\u0E25\u0E31\u0E1A ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E2B\u0E21\u0E14\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E0B\u0E36\u0E48\u0E07\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E42\u0E2B\u0E21\u0E14\u0E19\u0E35\u0E49\u0E41\u0E25\u0E30\u0E43\u0E0A\u0E49\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E2A\u0E20\u0E32\u0E1E\u0E04\u0E25\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","The request ID is necessary to display the swap details.":"\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35 ID \u0E04\u0E33\u0E02\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A","Connect Wallets":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C","Choose a wallet to connect.":"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","This week":"\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C\u0E19\u0E35\u0E49","This month":"\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E19\u0E35\u0E49","This year":"\u0E1B\u0E35\u0E19\u0E35\u0E49","Required: >= {min} {symbol}":["\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19: < ",["max"]," ",["symbol"]]," for network fee":" \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22"," for swap":" \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19"," for input and network fee":" \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E2D\u0E34\u0E19\u0E1E\u0E38\u0E17\u0E41\u0E25\u0E30\u0E04\u0E48\u0E32\u0E40\u0E19\u0E47\u0E15\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E04","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\u0E41\u0E15\u0E48\u0E04\u0E38\u0E13\u0E21\u0E35 ",["currentAmount"]," ",["symbol"]," \u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19 ",["blockchain"]," \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"],"Waiting for connecting wallet":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C","Waiting for other running tasks to be finished":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E43\u0E2B\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19","Waiting for changing wallet network":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19","Sunday":"\u0E27\u0E31\u0E19\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C","Monday":"\u0E27\u0E31\u0E19\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C","Tuesday":"\u0E27\u0E31\u0E19\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23","Wednesday":"\u0E27\u0E31\u0E19\u0E1E\u0E38\u0E18","Thursday":"\u0E27\u0E31\u0E19\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35","Friday":"\u0E27\u0E31\u0E19\u0E28\u0E38\u0E01\u0E23\u0E4C","Saturday":"\u0E27\u0E31\u0E19\u0E40\u0E2A\u0E32\u0E23\u0E4C","Powered By":"\u0E02\u0E31\u0E1A\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E42\u0E14\u0E22","Aggregated Transaction":"\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E23\u0E27\u0E21","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0E2A\u0E25\u0E31\u0E1A ",["fromChain"]," \u0E40\u0E1B\u0E47\u0E19 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07 ",["toChain"]," \u0E1C\u0E48\u0E32\u0E19 ",["swapper"]],"Completed":"\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C","In progress":"\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","Waiting for bridge transaction":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E2A\u0E30\u0E1E\u0E32\u0E19","Connected":"\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","Disconnect":"\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","Install":"\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07","Connecting ...":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D ...","Connecting":"\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","Disconnected":"\u0E16\u0E39\u0E01\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D","you need to pass a correct state to Wallet.":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E48\u0E07\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Wallet","There are no notifications.":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E43\u0E14\u0E46.","Clear all":"\u0E25\u0E49\u0E32\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","Balance":"\u0E2A\u0E21\u0E14\u0E38\u0E25","Max":"\u0E41\u0E21\u0E47\u0E01\u0E0B\u0E4C"}');


/*eslint-disable*/ const $b0d4c95b302c5a6e$export$defe85febe8b728c = JSON.parse('{"No results found":"Hi\xe7bir sonu\xe7 bulunamad\u0131","Try using different keywords":"Farkl\u0131 anahtar kelimeler kullanmay\u0131 deneyin","Select Chain":"Zincir Se\xe7","All":"T\xfcm","More +{count}":["Daha Fazla +",["count"]],"Activate this tab":"Bu sekmeyi etkinle\u015Ftir","Another tab is open and handles transactions.":"Ba\u015Fka bir sekme daha a\xe7\u0131k ve i\u015Flemleri y\xf6netiyor.","Activate current tab":"Mevcut sekmeyi etkinle\u015Ftir","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u015Eu anda baz\u0131 i\u015Flemler \xe7al\u0131\u015F\u0131yor ve ba\u015Fka bir taray\u0131c\u0131 sekmesi taraf\u0131ndan i\u015Fleniyor. Bu sekmeyi etkinle\u015Ftirirseniz, i\u015Flem imzalama ad\u0131m\u0131nda olan t\xfcm i\u015Flemler sona erecektir.","Confirm":"Onaylamak","Your {blockchainName} wallets":[["blockchainName"]," c\xfczdanlar\u0131n\u0131z"],"Insufficient account balance":"Yetersiz hesap bakiyesi","Proceed anyway":"Yine de devam et","You need to connect a {blockchainName} wallet.":[["blockchainName"]," c\xfczdan\u0131n\u0131 ba\u011Flaman\u0131z gerekiyor."],"Add {chain} chain":[["chain"]," zincirini ekle"],"Show more wallets":"Daha fazla c\xfczdan g\xf6ster","Send to a different address":"Farkl\u0131 bir adrese g\xf6nder","Enter {blockchainName} address":[["blockchainName"]," adresini girin"],"Address {destination} doesn\'t match the blockchain address pattern.":[["destination"]," adresi blockchain adres \xf6r\xfcnt\xfcs\xfcyle uyu\u015Fmuyor."],"via":"arac\u0131l\u0131\u011F\u0131yla","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"Bu token aktif token listesinde g\xf6r\xfcnm\xfcyor. Bunun i\u015Flem yapmak istedi\u011Finiz token oldu\u011Fundan emin olun.","Import":"\u0130\xe7e aktarmak","Status":"Durum","Reset":"S\u0131f\u0131rla","Cancel":"\u0130ptal etmek","Refresh":"Yenile","Notifications":"Bildirimler","Settings":"Ayarlar","History":"Tarih","Connect Wallet":"C\xfczdan\u0131 Ba\u011Fla","Today":"Bug\xfcn","Swaps steps":"De\u011Fi\u015Fim ad\u0131mlar\u0131","Retry":"Tekrar dene","Slippage Error":"Kayma Hatas\u0131","Slippage Warning":"Kayma Uyar\u0131s\u0131","Bridge Limit Error":"K\xf6pr\xfc S\u0131n\u0131r Hatas\u0131","Yours: {amount} {symbol}":["Sizin: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["Minimum gerekli kayma: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["Sizin: ",["userSlippage"]],"See All Routes":"T\xfcm Rotalar\u0131 G\xf6r","View more info":"Daha fazla bilgi g\xf6r\xfcnt\xfcle","Gas & Fee Explanation":"Gaz ve \xdccret A\xe7\u0131klamas\u0131","Details":"Detaylar","Total Payable Fee":"Toplam \xd6denecek \xdccret","Hide non-payable fees":"\xd6denmeyen \xfccretleri gizle","Show non-payable fees":"\xd6denmeyen \xfccretleri g\xf6ster","Description":"Tan\u0131m","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"A\u015Fa\u011F\u0131daki \xfccretler i\u015Flem \xe7\u0131kt\u0131s\u0131na dahil edilir ve\\n                bunlar i\xe7in ekstra gas \xf6demenize gerek kalmaz.","Swap input":"Giri\u015Fi de\u011Fi\u015Ftir","Estimated output":"Tahmini \xe7\u0131kt\u0131","Via:":"Arac\u0131l\u0131\u011F\u0131yla:","Chains:":"Zincirler:","Sort by":"G\xf6re s\u0131rala","Smart Routing":"Ak\u0131ll\u0131 Y\xf6nlendirme","Lowest Fee":"En D\xfc\u015F\xfck \xdccret","Fastest Transfer":"En H\u0131zl\u0131 Transfer","Maximum Return":"Maksimum Getiri","Maximum Output":"Maksimum \xc7\u0131kt\u0131","Swapping":"Takaslama","Gas cost":"Gaz maliyeti","Receiving":"Alma","Price impact":"Fiyat etkisi","You need to increase slippage to at least {minRequiredSlippage} for this route.":["Bu rota i\xe7in kaymay\u0131 en az ",["minRequiredSlippage"]," \'a \xe7\u0131karman\u0131z gerekiyor."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Bu rota i\xe7in kaymay\u0131 en az ",["minRequiredSlippage"]," seviyesine \xe7\u0131karman\u0131z\u0131 \xf6neririz."],"Caution, your slippage is high.":"Dikkat, kayman\u0131z y\xfcksek.","Change":"De\u011Fi\u015Ftirmek","Change settings":"Ayarlar\u0131 de\u011Fi\u015Ftir","High slippage":"Y\xfcksek kayma","Low slippage":"D\xfc\u015F\xfck kayma"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Dikkat, kayman\u0131z y\xfcksek (=",["userSlippage"],"). \u0130\u015Fleminiz \xf6nden ko\u015Fu olabilir."],"Confirm anyway":"Yine de onayla","Something went wrong":"Bir \u015Feyler ters gitti","Something went wrong. Please refresh the app.":"Bir \u015Feyler ters gitti. L\xfctfen uygulamay\u0131 yenileyin.","Slippage tolerance per swap":"Swap ba\u015F\u0131na kayma tolerans\u0131","Custom":"Gelenek","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Fiyatta bu orandan fazla olumsuz de\u011Fi\u015Fim olmas\u0131 durumunda i\u015Fleminiz geri al\u0131nacakt\u0131r.","Warning":"Uyar\u0131","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"Bu ayar her bir ad\u0131ma uygulan\u0131r (\xf6rne\u011Fin 1Inch, Thorchain, vb.), yani yaln\u0131zca o belirli ad\u0131m geri al\u0131n\u0131r, t\xfcm rota geri al\u0131nmaz.","Swap Details":"Takas Detaylar\u0131","Request ID":"\u0130stek Kimli\u011Fi","Not found":"Bulunamad\u0131","Swap with request ID = {requestId} not found.":["\u0130stek ID\'si = ",["requestId"]," olan takas bulunamad\u0131."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":[["chain"]," zincirindeki ",["conciseAddress"]," c\xfczdan\u0131nda ",["amount"]," ",["token"]," ald\u0131n\u0131z."],"Transaction was not sent.":"\u0130\u015Flem g\xf6nderilemedi.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," on ",["blockchain"]," c\xfczdan\u0131n\u0131zda kal\u0131r."],"Delete":"Silmek","Try again":"Tekrar deneyin","Copied To Clipboard":"Panoya Kopyaland\u0131","Copy Request ID":"Kopyalama \u0130stek Kimli\u011Fi","View on Rango Explorer":"Rango Explorer\'da g\xf6r\xfcnt\xfcle","Finished at":"Bitirildi","Created at":"Olu\u015Fturuldu","View transaction":"\u0130\u015Flemi g\xf6r\xfcnt\xfcle","Connect":"Ba\u011Flamak","Swap Successful":"Takas Ba\u015Far\u0131l\u0131","Transaction Failed":"\u0130\u015Flem Ba\u015Far\u0131s\u0131z","Done":"Tamamlamak","Diagnosis":"Tan\u0131","See Details":"Ayr\u0131nt\u0131lar\u0131 G\xf6r","Cancel Swap":"Takas \u0130ptali","Are you sure you want to cancel this swap?":"Bu takas\u0131 iptal etmek istedi\u011Finizden emin misiniz?","Yes, Cancel it":"Evet, \u0130ptal Et","No, Continue":"Hay\u0131r, Devam Et","Delete Transaction":"\u0130\u015Flemi Sil","Are you sure you want to delete this swap?":"Bu takas\u0131 silmek istedi\u011Finizden emin misiniz?","Yes, Delete it":"Evet, Sil","No, Cancel":"Hay\u0131r, \u0130ptal","Change Network":"A\u011F De\u011Fi\u015Ftir","Network Changed":"A\u011F De\u011Fi\u015Fti","Select Token":"Jeton Se\xe7","Wallet Connected":"C\xfczdan Ba\u011Fland\u0131","Your wallet is connected, you can use it to swap.":"C\xfczdan\u0131n\u0131z ba\u011Fland\u0131, takas yapmak i\xe7in kullanabilirsiniz.","Failed to Connect":"Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu","Your wallet is not connected. Please try again.":"C\xfczdan\u0131n\u0131z ba\u011Fl\u0131 de\u011Fil. L\xfctfen tekrar deneyin.","Connecting to your wallet":"C\xfczdan\u0131n\u0131za ba\u011Flan\u0131l\u0131yor","Click connect in your wallet popup.":"C\xfczdan\u0131n\u0131zdaki a\xe7\u0131l\u0131r pencerede ba\u011Flan\'a t\u0131klay\u0131n.","Select Derivation Path":"T\xfcretme Yolunu Se\xe7in","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\'a ba\u011Flanmak i\xe7in \xf6ncelikle bir T\xfcretme Yolu se\xe7melisiniz"],"Choose Derivation Path Template":"T\xfcretme Yolu \u015Eablonunu Se\xe7in","Enter Path":"Yola Girin","Enter Index":"Dizin\'e Girin","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," Zinciri Ekle"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":[["blockchainDisplayName"]," deneysel zincirini c\xfczdan\u0131n\u0131za eklemek ister misiniz?"],"Please approve the experimental chain pop-up in your wallet.":"L\xfctfen c\xfczdan\u0131n\u0131zdaki deneysel zincir a\xe7\u0131l\u0131r penceresini onaylay\u0131n.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," Zincir Eklendi"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," zinciri c\xfczdan\u0131n\u0131za ba\u015Far\u0131yla eklendi."],"Request Rejected":"\u0130stek Reddedildi","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["C\xfczdan\u0131n\u0131za ",["blockchainDisplayName"]," zincirinin eklenmesini reddettiniz."],"Select chain types":"Zincir tiplerini se\xe7in","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"Bu c\xfczdan birden fazla zinciri destekler. Hangi zincire ba\u011Flanmak istedi\u011Finizi se\xe7in.","Failed Network, Please retry your swap.":"A\u011F ba\u015Far\u0131s\u0131z oldu. L\xfctfen takas\u0131n\u0131z\u0131 tekrar deneyin.","Please reset your liquidity sources.":"L\xfctfen likidite kaynaklar\u0131n\u0131z\u0131 s\u0131f\u0131rlay\u0131n.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"Likidite kaynaklar\u0131n\u0131 s\u0131n\u0131rlad\u0131n\u0131z ve bu Rango\'nun rota bulamamas\u0131na neden olabilir. L\xfctfen likidite kaynaklar\u0131n\u0131z\u0131 s\u0131f\u0131rlamay\u0131 d\xfc\u015F\xfcn\xfcn.","No Routes Found.":"Rota Bulunamad\u0131.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango\'nun bir rota bulamamas\u0131n\u0131n nedenleri: token\'da d\xfc\u015F\xfck likidite, \xe7ok d\xfc\u015F\xfck girdi miktar\u0131 veya se\xe7ilen girdi/\xe7\u0131kt\u0131 token kombinasyonu i\xe7in kullan\u0131labilir rota olmamas\u0131.","Bridge Limit Error: Please increase your amount.":"K\xf6pr\xfc Limit Hatas\u0131: L\xfctfen tutar\u0131n\u0131z\u0131 art\u0131r\u0131n.","Bridge Limit Error: Please decrease your amount.":"K\xf6pr\xfc Limit Hatas\u0131: L\xfctfen tutar\u0131n\u0131z\u0131 azalt\u0131n.","High Price Impact":"Y\xfcksek Fiyat Etkisi","Price impact is too high!":"Fiyat etkisi \xe7ok y\xfcksek!","The price impact is significantly higher than the allowed amount.":"Fiyat etkisi izin verilen miktar\u0131n \xf6nemli \xf6l\xe7\xfcde \xfczerindedir.","Confirm high price impact":"Y\xfcksek fiyat etkisini do\u011Frulay\u0131n","Route updated and price impact is too high, try again later!":"Rota g\xfcncellendi ve fiyat etkisi \xe7ok y\xfcksek, daha sonra tekrar deneyin!","USD Price Unknown":"USD Fiyat\u0131 Bilinmiyor","USD Price Unknown, Cannot calculate Price Impact.":"USD Fiyat\u0131 Bilinmiyor, Fiyat Etkisi Hesaplanam\u0131yor.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD Fiyat\u0131 Bilinmiyor, Fiyat Etkisi Hesaplanam\u0131yor. Fiyat etkisi normalden daha y\xfcksek olabilir. Swap\'a devam etmek istedi\u011Finizden emin misiniz?","Confirm USD Price Unknown":"USD Fiyat\u0131n\u0131 Onaylay\u0131n Bilinmiyor","Swap":"Takas","Swap anyway":"Her neyse takas et","The route goes through Ethereum. Continue?":"Rota Ethereum\'dan ge\xe7iyor. Devam etmek istiyor musunuz?","Route has been updated.":"Rota g\xfcncellendi.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\xc7\u0131kt\u0131 miktar\u0131 ",["newOutputAmount"]," (",["percentageChange"],"% de\u011Fi\u015Fim) olarak de\u011Fi\u015Ftirildi."],"Route swappers has been updated.":"Rota de\u011Fi\u015Ftiriciler g\xfcncellendi.","Route internal coins has been updated.":"Rota i\xe7i coinler g\xfcncellendi.","Routes":"Rotalar","From":"\u0130tibaren","To":"\u0130le","Light":"I\u015F\u0131k","Dark":"Karanl\u0131k","Auto":"Otomatik","Loading failed":"Y\xfckleme ba\u015Far\u0131s\u0131z oldu","Bridges":"K\xf6pr\xfcler","Exchanges":"Borsalar","Custom Tokens":"\xd6zel Jetonlar","Language":"Dil","Infinite approval":"Sonsuz onay","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\'Sonsuz onay\' modunun etkinle\u015Ftirilmesi, temeldeki ak\u0131ll\u0131 s\xf6zle\u015Fmelere s\u0131n\u0131rs\u0131z eri\u015Fim sa\u011Flar ve onaylanan token miktar\u0131n\u0131 s\u0131n\u0131rlama olmaks\u0131z\u0131n kullanmalar\u0131na olanak tan\u0131r.","Theme":"Tema","Duplicate Token":"\xc7ift Jeton","The address you entered is duplicate, please enter a new address.":"Girdi\u011Finiz adres ayn\u0131 de\u011Fil, l\xfctfen yeni bir adres girin.","Token Already Exists":"Jeton Zaten Mevcut","There\'s no need to add this token again because it already exists and is supported by us.":"Bu token\'\u0131 tekrar eklemenize gerek yok \xe7\xfcnk\xfc zaten mevcut ve taraf\u0131m\u0131zca destekleniyor.","Token Not Found":"Jeton Bulunamad\u0131","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\xdczg\xfcn\xfcz, ",["blockchain"]," zincirinde belirtilen adresle bir token bulunamad\u0131. L\xfctfen do\u011Fru token adresini girdi\u011Finizden emin olun."],"Network Error":"A\u011F Hatas\u0131","Add Custom Token":"\xd6zel Token Ekle","Select chain":"Zinciri se\xe7in","Enter Address":"Adresi Girin","Enter token address":"Jeton adresini girin","Failed Network, Please retry.":"A\u011F ba\u015Far\u0131s\u0131z, l\xfctfen tekrar deneyin.","Add another custom token":"Ba\u015Fka bir \xf6zel belirte\xe7 ekle","Confirm Swap":"Takas\u0131 Onayla","Start Swap":"Takas Ba\u015Flat","You get":"Sen al\u0131rs\u0131n","Search Token":"Arama Simgesi","No custom tokens":"\xd6zel token yok","press the button to add your custom token":"\xf6zel tokeninizi eklemek i\xe7in d\xfc\u011Fmeye bas\u0131n","Delete Custom Token":"\xd6zel Token\'\u0131 Sil","Are you sure you want to Delete this Token?":"Bu Token\'\u0131 Silmek istedi\u011Finizden emin misiniz?","Complete":"Tamamlamak","Running":"Ko\u015Fma","Failed":"Ar\u0131zal\u0131","Clear":"Temizlemek","Search Transaction":"Arama \u0130\u015Flemi","No transactions":"Hi\xe7bir i\u015Flem yok","Your transaction history is stored locally and will appear here after you start a swap":"\u0130\u015Flem ge\xe7mi\u015Finiz yerel olarak saklan\u0131r ve bir takas ba\u015Flatt\u0131ktan sonra burada g\xf6r\xfcn\xfcr","Clear Transaction History":"\u0130\u015Flem Ge\xe7mi\u015Fini Temizle","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Devam etmek, widget\'tan t\xfcm ba\u015Far\u0131l\u0131 ve ba\u015Far\u0131s\u0131z i\u015Flemleri kald\u0131racakt\u0131r. Devam etmek istiyor musunuz?","Note: This does not erase your transaction history on the chain; it only removes them here.":"Not: Bu, zincirdeki i\u015Flem ge\xe7mi\u015Finizi silmez; yaln\u0131zca buradan kald\u0131r\u0131r.","Yes, Clear the history":"Evet, ge\xe7mi\u015Fi temizle","language":"dil","Deselect all":"T\xfcm\xfcn\xfc se\xe7imi kald\u0131r","Select all":"T\xfcm\xfcn\xfc se\xe7","Search {sourceType}":["Ara ",["sourceType"]],"Search Chain":"Arama Zinciri","Source":"Kaynak","Destination":"Var\u0131\u015F noktas\u0131","Swap {type}":["Takas ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u015Eu anda, likidite kaynaklar\u0131nda k\u0131s\u0131tlamalar olan kampanya modundas\u0131n\u0131z. Bu moddan \xe7\u0131k\u0131p t\xfcm mevcut likidite kaynaklar\u0131n\u0131 kullanmak ister misiniz?","The request ID is necessary to display the swap details.":"Takas detaylar\u0131n\u0131n g\xf6r\xfcnt\xfclenebilmesi i\xe7in istek ID\'si gereklidir.","Connect Wallets":"C\xfczdanlar\u0131 Ba\u011Flay\u0131n","Choose a wallet to connect.":"Ba\u011Flanmak i\xe7in bir c\xfczdan se\xe7in.","This week":"Bu hafta","This month":"Bu ay","This year":"Bu y\u0131l","Required: >= {min} {symbol}":["Gerekli: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["Gerekli: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["Gerekli: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["Gerekli: < ",["max"]," ",["symbol"]]," for network fee":" a\u011F \xfccreti i\xe7in"," for swap":" takas i\xe7in"," for input and network fee":" giri\u015F ve a\u011F \xfccreti i\xe7in","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"gerekiyor, ancak c\xfczdan\u0131n\u0131zda ",["blockchain"]," ",["currentAmount"]," ",["symbol"]," var."],"Waiting for connecting wallet":"C\xfczdan\u0131n ba\u011Flanmas\u0131n\u0131 bekliyorum","Waiting for other running tasks to be finished":"Di\u011Fer \xe7al\u0131\u015Fan g\xf6revlerin bitmesini bekliyorum","Waiting for changing wallet network":"C\xfczdan a\u011F\u0131n\u0131n de\u011Fi\u015Ftirilmesi bekleniyor","Sunday":"Pazar","Monday":"Pazartesi","Tuesday":"Sal\u0131","Wednesday":"\xc7ar\u015Famba","Thursday":"Per\u015Fembe","Friday":"Cuma","Saturday":"Cumartesi","Powered By":"Taraf\u0131ndan desteklenmektedir","Aggregated Transaction":"Toplu \u0130\u015Flem","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["fromChain"]," \xfczerinden ",["swapper"],"ile takas yap\u0131n"],"Bridge to {toChain} via {swapper}":[["swapper"],"\xfczerinden ",["toChain"]," \'a k\xf6pr\xfc"],"Completed":"Tamamlanm\u0131\u015F","In progress":"Devam etmekte","Waiting for bridge transaction":"K\xf6pr\xfc i\u015Flemi bekleniyor","Connected":"Ba\u011Fl\u0131","Disconnect":"Ba\u011Flant\u0131y\u0131 kes","Install":"D\xfczenlemek","Connecting ...":"Ba\u011Flan\u0131yor...","Connecting":"Ba\u011Flanma","Disconnected":"Ba\u011Flant\u0131s\u0131 kesildi","you need to pass a correct state to Wallet.":"C\xfczdan\'a do\u011Fru bir durum ge\xe7irmeniz gerekiyor.","There are no notifications.":"Bildirim yok.","Clear all":"Hepsini temizle","Balance":"Denge","Max":"Maksimum"}');


/*eslint-disable*/ const $6f9b04b275969705$export$defe85febe8b728c = JSON.parse('{"No results found":"\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","Try using different keywords":"\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0456\u043D\u0448\u0456 \u043A\u043B\u044E\u0447\u043E\u0432\u0456 \u0441\u043B\u043E\u0432\u0430","Select Chain":"\u041E\u0431\u0440\u0430\u0442\u0438 \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A","All":"\u0412\u0441\u0456","More +{count}":["\u0411\u0456\u043B\u044C\u0448\u0435 +",["count"]],"Activate this tab":"\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Another tab is open and handles transactions.":"\u0406\u043D\u0448\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0430 - \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0456 \u043E\u0431\u0440\u043E\u0431\u043A\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439.","Activate current tab":"\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0443 \u0432\u043A\u043B\u0430\u0434\u043A\u0443","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0412 \u0434\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0434\u0435\u044F\u043A\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0432\u0438\u043A\u043E\u043D\u0443\u044E\u0442\u044C\u0441\u044F \u0456 \u043E\u0431\u0440\u043E\u0431\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0456\u043D\u0448\u043E\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u043E\u044E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u042F\u043A\u0449\u043E \u0432\u0438 \u0430\u043A\u0442\u0438\u0432\u0443\u0454\u0442\u0435 \u0446\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443, \u0432\u0441\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457, \u0449\u043E \u0432\u0436\u0435 \u0437\u043D\u0430\u0445\u043E\u0434\u044F\u0442\u044C\u0441\u044F \u0432 \u0435\u0442\u0430\u043F\u0456 \u043F\u0456\u0434\u043F\u0438\u0441\u0443 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439, \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F.","Confirm":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438","Your {blockchainName} wallets":["\u0412\u0430\u0448\u0456 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["blockchainName"]],"Insufficient account balance":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0433\u0440\u043E\u0448\u0435\u0439 \u043D\u0430 \u0431\u0430\u043B\u0430\u043D\u0441\u0456","Proceed anyway":"\u0412\u0441\u0435 \u043E\u0434\u043D\u043E","You need to connect a {blockchainName} wallet.":["\u0412\u0438 \u043F\u043E\u0432\u0438\u043D\u043D\u0456 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 ",["blockchainName"]," \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C."],"Add {chain} chain":["\u0414\u043E\u0434\u0430\u0442\u0438 \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A ",["chain"]],"Show more wallets":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0433\u0430\u043C\u0430\u043D\u0446\u0456\u0432","Send to a different address":"\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0442\u0438 \u043D\u0430 \u0456\u043D\u0448\u0443 \u0430\u0434\u0440\u0435\u0441\u0443","Enter {blockchainName} address":["\u0412\u0432\u0435\u0434\u0456\u0442\u044C ",["blockchainName"]," \u0430\u0434\u0440\u0435\u0441\u0443"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0410\u0434\u0440\u0435\u0441\u0430 ",["destination"]," \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0438 \u0431\u043B\u043E\u043A\u0447\u0435\u0439\u043D."],"via":"\u0447\u0435\u0440\u0435\u0437","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u0426\u0435\u0439 \u0442\u043E\u043A\u0435\u043D \u043D\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0443 \u0441\u043F\u0438\u0441\u043A\u0443 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0456\u0432. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0446\u0435 \u043C\u0430\u0440\u043A\u0435\u0440 \u044F\u043A\u0438\u0439 \u0432\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u0442\u043E\u0440\u0433\u0443\u0432\u0430\u0442\u0438.","Import":"\u0406\u043C\u043F\u043E\u0440\u0442","Status":"\u0421\u0442\u0430\u0442\u0443\u0441","Reset":"Reset","Cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","Refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438","Notifications":"\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F","Settings":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","History":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F","Connect Wallet":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C Wallet","Today":"\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456","Swaps steps":"\u041A\u0440\u043E\u043A\u0438 \u0437\u043C\u0456\u043D\u0438","Retry":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443","Slippage Error":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F","Slippage Warning":"\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E Slippage","Bridge Limit Error":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0441\u0442\u0443","Yours: {amount} {symbol}":["\u0412\u0430\u0448: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0430 \u043F\u043E\u0432\u0437\u0443\u043D\u043A\u0430: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0412\u0430\u0448: ",["userSlippage"]],"See All Routes":"\u041F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438","View more info":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435","Gas & Fee Explanation":"\u0413\u0430\u0437 \u0456 \u043A\u043E\u043C\u0456\u0441\u0456\u044F","Details":"\u041F\u043E\u0434\u0440\u043E\u0431\u0438\u0446\u0456","Total Payable Fee":"\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430 \u0432\u0438\u043F\u043B\u0430\u0442","Hide non-payable fees":"\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u043D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0456","Show non-payable fees":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043B\u0430\u0442\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0456","Description":"\u041E\u043F\u0438\u0441","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0456 \u043A\u043E\u043C\u0456\u0441\u0456\u0457 \u0432\u0440\u0430\u0445\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0443 \u0432\u0438\u0445\u0456\u0434\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457, \u0456\\n                \u0432\u0430\u043C \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0431\u0443\u0434\u0435 \u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0437\u0430 \u043D\u0438\u0445 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0433\u0430\u0437.","Swap input":"Swap input","Estimated output":"\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u043E\u0432\u0438\u0439 \u0432\u0438\u0445\u0456\u0434","Via:":"\u0427\u0435\u0440\u0435\u0437:","Chains:":"\u041B\u0430\u043D\u0446\u044E\u0433\u0438:","Sort by":"\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430","Smart Routing":"\u0420\u043E\u0437\u0443\u043C\u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\u0437\u0430\u0446\u0456\u044F","Lowest Fee":"\u041D\u0430\u0439\u043D\u0438\u0436\u0447\u0430 \u043A\u043E\u043C\u0456\u0441\u0456\u044F","Fastest Transfer":"\u041D\u0430\u0439\u0448\u0432\u0438\u0434\u0448\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0430","Maximum Return":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F","Maximum Output":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0445\u0456\u0434","Swapping":"Swapping","Gas cost":"\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0433\u0430\u0437\u0443","Receiving":"\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F","Price impact":"\u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0412\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0441\u043B\u0430\u0439\u0434 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 ",["minRequiredSlippage"]," \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u041C\u0438 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454\u043C\u043E \u0432\u0430\u043C \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0441\u043B\u0430\u0439\u0434 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 ",["minRequiredSlippage"]," \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443."],"Caution, your slippage is high.":"\u041E\u0431\u0435\u0440\u0435\u0436\u043D\u043E, \u0442\u0432\u043E\u044F \u0441\u0445\u043E\u0432\u0430\u043D\u043A\u0430 \u0432\u0438\u0441\u043E\u043A\u0430.","Change":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438","Change settings":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438","High slippage":"\u0412\u0438\u0441\u043E\u043A\u0430 \u0441\u043B\u0438\u0437\u044C\u043A\u0430","Low slippage":"\u041D\u0438\u0437\u044C\u043A\u0430 \u0437\u0430\u043B\u0438\u0432\u043A\u0430"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u041E\u0431\u0435\u0440\u0435\u0436\u043D\u043E, \u0432\u0430\u0448 \u0441\u043B\u0430\u0439\u0434 \u0432\u0438\u0441\u043E\u043A\u0438\u0439 (=",["userSlippage"],"). \u0412\u0430\u0448\u0430 \u0442\u043E\u0440\u0433\u0456\u0432\u043B\u044F \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0430."],"Confirm anyway":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0441\u0435 \u043E\u0434\u043D\u043E","Something went wrong":"\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430","Something went wrong. Please refresh the app.":"\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u043D\u043E\u0432\u0456\u0442\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0443.","Slippage tolerance per swap":"\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0456\u0441\u0442\u044C \u0441\u043F\u0443\u0441\u043A\u0443 \u043D\u0430 \u0441\u0432\u043E\u043F","Custom":"\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0430","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0412\u0430\u0448\u0443 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E, \u044F\u043A\u0449\u043E \u0446\u044F \u0446\u0456\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u044C\u0441\u044F \u0431\u0456\u043B\u044C\u0448 \u043D\u0456\u0436 \u043D\u0430 \u0446\u0435\u0439 \u0432\u0456\u0434\u0441\u043E\u0442\u043E\u043A.","Warning":"\u0417\u0430\u0441\u0442\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u0426\u0435\u0439 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u043A\u0440\u043E\u043A\u0443 (\u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434. 1Inch, \u0422\u043E\u0440\u0447\u0435\u0439\u043D \u0456 \u0442.\u043F.), \u0449\u043E \u043E\u0437\u043D\u0430\u0447\u0430\u0454, \u0449\u043E \u0442\u0456\u043B\u044C\u043A\u0438 \u043F\u0435\u0432\u043D\u0438\u0439 \u043A\u0440\u043E\u043A \u0431\u0443\u0434\u0435 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0430 \u043D\u0435 \u0432\u0435\u0441\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442.","Swap Details":"\u0414\u0435\u0442\u0430\u043B\u0456 \u0441\u0432\u043E\u043F\u0438","Request ID":"\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u043F\u0438\u0442\u0443","Not found":"\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","Swap with request ID = {requestId} not found.":["\u0421\u0432\u043E\u043F \u0437 RequestID = ",["requestId"]," \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u043B\u0438 ",["amount"]," ",["token"]," \u0432 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["conciseAddress"]," \u043D\u0430 ",["chain"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0443."],"Transaction was not sent.":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u043D\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u043D\u0430 ",["blockchain"]," \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C\u0441\u044F \u0432 \u0432\u0430\u0448\u043E\u043C\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456."],"Delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","Try again":"\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437","Copied To Clipboard":"\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","Copy Request ID":"\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 ID \u0437\u0430\u043F\u0438\u0442\u0443","View on Rango Explorer":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Rango Explorer","Finished at":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u043E","Created at":"\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u0432","View transaction":"\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u044E","Connect":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F","Swap Successful":"\u0417\u043C\u0456\u043D\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u0430","Transaction Failed":"\u041D\u0435\u0432\u0434\u0430\u043B\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F","Done":"\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E","Diagnosis":"\u0414\u0456\u0430\u0433\u043D\u043E\u0437","See Details":"\u0414\u0438\u0432. \u0434\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435","Cancel Swap":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u043C\u0456\u043D\u0438","Are you sure you want to cancel this swap?":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0446\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F?","Yes, Cancel it":"\u0422\u0430\u043A, \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","No, Continue":"\u041D\u0456, \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438","Delete Transaction":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E","Are you sure you want to delete this swap?":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F?","Yes, Delete it":"\u0422\u0430\u043A, \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0439\u043E\u0433\u043E","No, Cancel":"\u041D\u0456, \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","Change Network":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043C\u0435\u0440\u0435\u0436\u0443","Network Changed":"\u041C\u0435\u0440\u0435\u0436\u0430 \u0437\u043C\u0456\u043D\u0435\u043D\u0430","Select Token":"\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u043E\u043A\u0435\u043D","Wallet Connected":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C","Your wallet is connected, you can use it to swap.":"\u0412\u0430\u0448 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u0434\u043B\u044F \u043E\u0431\u043C\u0456\u043D\u0443.","Failed to Connect":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\'\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F","Your wallet is not connected. Please try again.":"\u0412\u0430\u0448 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.","Connecting to your wallet":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Click connect in your wallet popup.":"\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0432 \u0441\u043F\u043B\u0438\u0432\u0430\u044E\u0447\u043E\u043C\u0443 \u0432\u0456\u043A\u043D\u0456 \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F.","Select Derivation Path":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u043B\u044F\u0445 \u0434\u043E \u0432\u0438\u0434\u0430\u0447\u0456","In order to connect to {type}, you must first select a Derivation Path":["\u0414\u043B\u044F \u0442\u043E\u0433\u043E, \u0449\u043E\u0431 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E ",["type"],", \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0441\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0448\u043B\u044F\u0445 \u0432\u0456\u0434\u0434\u0456\u043B\u0435\u043D\u043D\u044F"],"Choose Derivation Path Template":"\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u043F\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0443","Enter Path":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0448\u043B\u044F\u0445","Enter Index":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0456\u043D\u0434\u0435\u043A\u0441","Add {blockchainDisplayName} Chain":["\u0414\u043E\u0434\u0430\u0442\u0438 ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u0425\u043E\u0447\u0435\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u0438 \u0435\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043B\u0430\u043D\u0446\u044E\u0433 ",["blockchainDisplayName"]," \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F?"],"Please approve the experimental chain pop-up in your wallet.":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0435\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u0433\u0430\u043C\u0430\u043D\u0446\u0456.","{blockchainDisplayName} Chain Added":["\u0414\u043E\u0434\u0430\u043D\u043E \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A ",["blockchainDisplayName"]],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["\u041B\u0430\u043D\u0446\u044E\u0436\u043E\u043A ",["blockchainDisplayName"]," \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F."],"Request Rejected":"\u0417\u0430\u043F\u0438\u0442 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0412\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u043B\u0438 \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F ",["blockchainDisplayName"]," \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0430 \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0433\u0430\u043C\u0430\u043D\u0446\u044F."],"Select chain types":"\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F\u0438 \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0456\u0432","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u0426\u0435\u0439 \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 \u043A\u0456\u043B\u044C\u043A\u0430 \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0456\u0432. \u041E\u0431\u0435\u0440\u0456\u0442\u044C, \u0434\u043E \u044F\u043A\u043E\u0433\u043E \u043B\u0430\u043D\u0446\u044E\u0433\u0430 \u0432\u0438 \u0445\u043E\u0442\u0456\u043B\u0438 \u0431 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F.","Failed Network, Please retry your swap.":"\u041D\u0435\u0432\u0434\u0430\u043B\u0430 \u043C\u0435\u0440\u0435\u0436\u0430, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0441\u0432\u043E\u043F.","Please reset your liquidity sources.":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043A\u0438\u043D\u044C\u0442\u0435 \u0432\u0430\u0448\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0412\u0438 \u043E\u0431\u043C\u0435\u0436\u0438\u043B\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456, \u0456 \u0446\u0435 \u043C\u043E\u0436\u0435 \u043F\u0440\u0438\u0437\u0432\u0435\u0441\u0442\u0438 \u0434\u043E \u0442\u043E\u0433\u043E, \u0449\u043E \u0420\u0430\u043D\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043F\u0440\u043E \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456.","No Routes Found.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u041F\u0440\u0438\u0447\u0438\u043D\u0430, \u0447\u043E\u043C\u0443 \u0420\u0430\u043D\u0433\u043E \u043D\u0435 \u0437\u043C\u0456\u0433 \u0437\u043D\u0430\u0439\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442: \u043D\u0438\u0437\u044C\u043A\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C, \u0434\u0443\u0436\u0435 \u043C\u0430\u043B\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0432\u0445\u0456\u0434\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0430\u0431\u043E \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u0457 \u0442\u043E\u043A\u0435\u043D\u0443 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F/\u0432\u0438\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u0442\u0435\u043A\u0441\u0442\u0443.","Bridge Limit Error: Please increase your amount.":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0441\u0442\u0443. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0431\u0456\u043B\u044C\u0448\u0456\u0442\u044C \u0441\u0443\u043C\u0443.","Bridge Limit Error: Please decrease your amount.":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0441\u0442\u0443: \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u043C\u0435\u043D\u0448\u0442\u0435 \u0441\u0443\u043C\u0443.","High Price Impact":"\u0412\u0438\u0441\u043E\u043A\u0438\u0439 \u0432\u043F\u043B\u0438\u0432 \u043D\u0430 \u0446\u0456\u043D\u0443","Price impact is too high!":"\u0422\u0430\u0440\u0438\u0444\u043D\u0438\u0439 \u0432\u043F\u043B\u0438\u0432 \u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0438\u0439!","The price impact is significantly higher than the allowed amount.":"\u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D \u0437\u043D\u0430\u0447\u043D\u043E \u0432\u0438\u0449\u0438\u0439, \u043D\u0456\u0436 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0430 \u0441\u0443\u043C\u0430.","Confirm high price impact":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0438\u0441\u043E\u043A\u0438\u0439 \u0446\u0456\u043D\u043E\u0432\u0438\u0439 \u0432\u043F\u043B\u0438\u0432","Route updated and price impact is too high, try again later!":"\u0417\u043C\u0456\u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443 \u0456 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0438\u0439, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435!","USD Price Unknown":"USD \u0446\u0456\u043D\u0430 \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0430","USD Price Unknown, Cannot calculate Price Impact.":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u0446\u0456\u043D\u0430 USD \u043D\u0435 \u043C\u043E\u0436\u0435 \u043E\u0431\u0447\u0438\u0441\u043B\u0438\u0442\u0438 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u0426\u0456\u043D\u0430 \u0421\u0428\u0410 \u043D\u0435 \u0432\u0456\u0434\u043E\u043C\u0430, \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0432\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438. \u0412\u043F\u043B\u0438\u0432 \u0446\u0456\u043D\u0438 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0438\u0449\u0438\u043C, \u043D\u0456\u0436 \u0437\u0430\u0437\u0432\u0438\u0447\u0430\u0439. \u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043F\u043B\u0430\u0432\u0430\u043D\u043D\u044F?","Confirm USD Price Unknown":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0443 \u0446\u0456\u043D\u0443 USD","Swap":"\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438","Swap anyway":"\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u043C\u0456\u0441\u0446\u044F\u043C\u0438 \u0432\u0441\u0435 \u043E\u0434\u043D\u043E","The route goes through Ethereum. Continue?":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442\u044C \u0447\u0435\u0440\u0435\u0437 Ethereum. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?","Route has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442 \u0431\u0443\u043B\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0421\u0443\u043C\u0430 \u0432\u0438\u0432\u043E\u0434\u0443 \u0437\u043C\u0456\u043D\u0435\u043D\u0430 \u043D\u0430 ",["newOutputAmount"]," (",["percentageChange"],"% \u0437\u043C\u0456\u043D\u0438)."],"Route swappers has been updated.":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u043D\u0456 \u0437\u0430\u043C\u0456\u043D\u0438 \u0431\u0443\u043B\u0438 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456.","Route internal coins has been updated.":"\u0420\u0435\u0439\u0441 \u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0445 \u043C\u043E\u043D\u0435\u0442 \u0431\u0443\u0432 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439.","Routes":"\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438","From":"\u0412\u0456\u0434","To":"\u041D\u0430","Light":"\u0421\u0432\u0456\u0442\u043B\u0430","Dark":"\u0422\u0435\u043C\u043D\u0430","Auto":"\u0410\u0432\u0442\u043E","Loading failed":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F","Bridges":"\u0411\u0440\u0456\u0434\u0436\u0435\u0441","Exchanges":"\u041E\u0431\u043C\u0456\u043D \u0432\u0430\u043B\u044E\u0442","Custom Tokens":"\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0456 \u0442\u043E\u043A\u0435\u043D\u0438","Language":"\u041C\u043E\u0432\u0430:","Infinite approval":"\u041D\u0435\u0441\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043D\u044F \u0440\u0435\u0436\u0438\u043C\u0443 \xab\u041D\u0435\u0441\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F\xbb \u043D\u0430\u0434\u0430\u0454 \u043D\u0435\u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043E\u0441\u043D\u043E\u0432\u043D\u0438\u0445 \u0440\u043E\u0437\u0443\u043C\u043D\u0438\u0445 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0456\u0432, \u043D\u0430\u0434\u0430\u044E\u0447\u0438 \u0457\u043C \u0437\u043C\u043E\u0433\u0443 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0456 \u043A\u0456\u043B\u044C\u043A\u043E\u0441\u0442\u0456 \u0442\u043E\u043A\u0435\u043D\u0456\u0432 \u0431\u0435\u0437 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u044C.","Theme":"\u0422\u0435\u043C\u0430","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"\u0423\u0432\u0435\u0434\u0435\u043D\u0430 \u0432\u0430\u043C\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u0434\u0443\u0431\u043B\u044E\u0454\u0442\u044C\u0441\u044F, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u0432\u0443 \u0430\u0434\u0440\u0435\u0441\u0443.","Token Already Exists":"\u0422\u043E\u043A\u0435\u043D \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454","There\'s no need to add this token again because it already exists and is supported by us.":"\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0442\u0440\u0435\u0431\u0438 \u0437\u043D\u043E\u0432\u0443 \u0434\u043E\u0434\u0430\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0442\u043E\u043A\u0435\u043D, \u0442\u043E\u043C\u0443 \u0449\u043E \u0432\u0456\u043D \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454 \u0456 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430\u043C\u0438.","Token Not Found":"\u041C\u0430\u0440\u043A\u0435\u0440 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u041D\u0430 \u0436\u0430\u043B\u044C, \u0432 \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0443 ",["blockchain"]," \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u043E\u043A\u0435\u043D\u0430. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0438 \u0432\u0432\u0435\u043B\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0442\u043E\u043A\u0435\u043D\u0443."],"Network Error":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456","Add Custom Token":"\u0414\u043E\u0434\u0430\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Select chain":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A","Enter Address":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0430\u0434\u0440\u0435\u0441\u0443","Enter token address":"\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0430\u0434\u0440\u0435\u0441\u0443 \u043C\u0430\u0440\u043A\u0435\u0440\u0430","Failed Network, Please retry.":"\u041D\u0435\u0432\u0434\u0430\u043B\u0430 \u043C\u0435\u0440\u0435\u0436\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.","Add another custom token":"\u0414\u043E\u0434\u0430\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Confirm Swap":"\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0441\u0432\u043E\u043F","Start Swap":"\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u043E\u043C\u0456\u043D\u044F\u0442\u0438","You get":"\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u0435","Search Token":"\u041F\u043E\u0448\u0443\u043A \u043C\u0430\u0440\u043A\u0435\u0440","No custom tokens":"\u041D\u0435\u043C\u0430\u0454 \u0432\u043B\u0430\u0441\u043D\u0438\u0445 \u0442\u043E\u043A\u0435\u043D\u0456\u0432","press the button to add your custom token":"\u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443, \u0449\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u0441\u0432\u0456\u0439 \u0432\u043B\u0430\u0441\u043D\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Delete Custom Token":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439 \u0442\u043E\u043A\u0435\u043D","Are you sure you want to Delete this Token?":"\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0442\u043E\u043A\u0435\u043D?","Complete":"Complete","Running":"\u0411\u0456\u0433","Failed":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F","Clear":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438","Search Transaction":"\u041F\u043E\u0448\u0443\u043A \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457","No transactions":"\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456","Your transaction history is stored locally and will appear here after you start a swap":"\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0430\u0448\u0438\u0445 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0456 \u0437\'\u044F\u0432\u0438\u0442\u044C\u0441\u044F \u0442\u0443\u0442 \u043F\u0456\u0441\u043B\u044F \u0442\u043E\u0433\u043E, \u044F\u043A \u0432\u0438 \u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0437\u0430\u043C\u0456\u043D\u0443","Clear Transaction History":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u044E\u0447\u0438, \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0432\u0441\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u0456 \u0442\u0430 \u043D\u0435\u0432\u0434\u0430\u043B\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457 \u0437 \u0432\u0456\u0434\u0436\u0435\u0442\u0430. \u0411\u0430\u0436\u0430\u0454\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430: \u0412 \u043B\u0430\u043D\u0446\u044E\u0436\u043A\u0443 \u0456\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0430\u0448\u0438\u0445 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439 \u043D\u0435 \u0432\u0438\u0434\u0430\u043B\u044F\u0454\u0442\u044C\u0441\u044F; \u0432\u0456\u043D \u0442\u0456\u043B\u044C\u043A\u0438 \u0432\u0438\u0434\u0430\u043B\u044F\u0454 \u0457\u0445 \u0442\u0443\u0442.","Yes, Clear the history":"\u0422\u0430\u043A, \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E","language":"\u043C\u043E\u0432\u0430","Deselect all":"\u0417\u043D\u044F\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0456\u043B\u0435\u043D\u043D\u044F","Select all":"\u0412\u0438\u0434\u0456\u043B\u0438\u0442\u0438 \u0432\u0441\u0435","Search {sourceType}":["\u0428\u0443\u043A\u0430\u0442\u0438 ",["sourceType"]],"Search Chain":"\u0428\u0443\u043A\u0430\u0442\u0438 \u043B\u0430\u043D\u0446\u044E\u0436\u043E\u043A","Source":"\u0414\u0436\u0435\u0440\u0435\u043B\u043E","Destination":"\u041F\u0443\u043D\u043A\u0442 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","Swap {type}":["\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0412 \u0434\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0432\u0438 \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u0457 \u0437 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456. \u0412\u0438 \u0445\u043E\u0442\u0456\u043B\u0438 \u0431 \u0432\u0438\u0439\u0442\u0438 \u0437 \u0446\u044C\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0443 \u0456 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0432\u0441\u0456 \u043D\u0430\u044F\u0432\u043D\u0456 \u0434\u0436\u0435\u0440\u0435\u043B\u0430 \u043B\u0456\u043A\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456?","The request ID is necessary to display the swap details.":"\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0442\u0443 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0439 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0441\u0432\u043E\u043F.","Connect Wallets":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0433\u0430\u043C\u0430\u043D\u0446\u0456\u0432","Choose a wallet to connect.":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0433\u0430\u043C\u0430\u043D\u0435\u0446\u044C \u0434\u043B\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.","This week":"\u0426\u044C\u043E\u0433\u043E \u0442\u0438\u0436\u043D\u044F","This month":"\u0426\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F","This year":"\u0426\u044C\u043E\u0433\u043E \u0440\u043E\u043A\u0443","Required: >= {min} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u041E\u0431\u043E\u0432\'\u044F\u0437\u043A\u043E\u0432\u043E: < ",["max"]," ",["symbol"]]," for network fee":" \u0437\u0430 \u0437\u0431\u0456\u0440 \u043C\u0435\u0440\u0435\u0436\u0456"," for swap":" \u0434\u043B\u044F \u0441\u0432\u043E\u043F\u0430"," for input and network fee":" \u0437\u0430 \u0432\u0445\u0456\u0434\u043D\u0438\u0439 \u0442\u0430 \u043C\u0435\u0440\u0435\u0436\u0435\u0432\u0438\u0439 \u0437\u0431\u0456\u0440","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0439 TrueCon ",["requiredAmount"]," ",["symbol"],["reason"],", \u0430\u043B\u0435 \u0432\u0438 \u043C\u0430\u0454\u0442\u0435 ",["currentAmount"]," ",["symbol"]," \u0432 \u0433\u0430\u043C\u0430\u043D\u0446\u0456 ",["blockchain"],"."],"Waiting for connecting wallet":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Waiting for other running tasks to be finished":"\u041E\u0447\u0456\u043A\u0443\u0454\u043C\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0456\u043D\u0448\u0438\u0445 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0438\u0445 \u0437\u0430\u0434\u0430\u0447","Waiting for changing wallet network":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u043C\u0456\u043D\u0438 \u043C\u0435\u0440\u0435\u0436\u0456 \u0433\u0430\u043C\u0430\u043D\u0446\u044F","Sunday":"\u041D\u0435\u0434\u0456\u043B\u044F","Monday":"\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A","Tuesday":"\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A","Wednesday":"\u0421\u0435\u0440\u0435\u0434\u0430","Thursday":"\u0427\u0435\u0442\u0432\u0435\u0440","Friday":"\u041F\'\u044F\u0442\u043D\u0438\u0446\u044F","Saturday":"\u0421\u0443\u0431\u043E\u0442\u0430","Powered By":"\u041D\u0430\u0434\u0430\u043D\u043E","Aggregated Transaction":"\u0421\u0443\u043A\u0443\u043F\u043D\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u041F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u043D\u0430 ",["fromChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Bridge to {toChain} via {swapper}":["\u041C\u0456\u0441\u0442 \u0434\u043E ",["toChain"]," \u0447\u0435\u0440\u0435\u0437 ",["swapper"]],"Completed":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456","In progress":"\u041E\u0431\u0440\u043E\u0431\u043A\u0430","Waiting for bridge transaction":"\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0437 \u043C\u043E\u0441\u0442\u043E\u043C","Connected":"\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","Disconnect":"\u0412\u0456\u0434\'\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044C","Install":"\u0406\u043D\u0441\u0442\u0430\u043B\u044E\u0432\u0430\u0442\u0438","Connecting ...":"\u041F\u0456\u0434\'\u0454\u0434\u043D\u0430\u043D\u043D\u044F...","Connecting":"\u0417\u2019\u0454\u0434\u043D\u0430\u043D\u043D\u044F","Disconnected":"\u0412\u0456\u0434\u2019\u0454\u0434\u043D\u0430\u043D\u043E","you need to pass a correct state to Wallet.":"\u0432\u0438 \u043C\u0430\u0454\u0442\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0441\u0442\u0430\u043D \u0434\u043E Wallet.","There are no notifications.":"\u041D\u0435\u043C\u0430\u0454 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C.","Clear all":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0441\u0435","Balance":"\u0411\u0430\u043B\u0430\u043D\u0441","Max":"\u041C\u0430\u043A\u0441"}');


/*eslint-disable*/ const $ed70f3cad66431c9$export$defe85febe8b728c = JSON.parse('{"No results found":"\u06A9\u0648\u0626\u06CC \u0646\u062A\u06CC\u062C\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627","Try using different keywords":"\u0645\u062E\u062A\u0644\u0641 \u0645\u0637\u0644\u0648\u0628\u06C1 \u0627\u0644\u0641\u0627\u0638 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Select Chain":"\u0686\u06CC\u0646 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","All":"\u062A\u0645\u0627\u0645","More +{count}":["\u0645\u0632\u06CC\u062F +",["count"]],"Activate this tab":"\u0627\u0633 \u0679\u06CC\u0628 \u06A9\u0648 \u0686\u0627\u0644\u0648 \u06A9\u0631\u06CC\u06BA\u06D4","Another tab is open and handles transactions.":"\u0627\u06CC\u06A9 \u0627\u0648\u0631 \u0679\u06CC\u0628 \u06A9\u06BE\u0644\u0627 \u06C1\u06D2 \u0627\u0648\u0631 \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u0648 \u06C1\u06CC\u0646\u0688\u0644 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u06D4","Activate current tab":"\u0645\u0648\u062C\u0648\u062F\u06C1 \u0679\u06CC\u0628 \u06A9\u0648 \u0686\u0627\u0644\u0648 \u06A9\u0631\u06CC\u06BA\u06D4","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u0641\u06CC \u0627\u0644\u062D\u0627\u0644\u060C \u06A9\u0686\u06BE \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0686\u0644 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA \u0627\u0648\u0631 \u062F\u0648\u0633\u0631\u06D2 \u0628\u0631\u0627\u0624\u0632\u0631 \u0679\u06CC\u0628 \u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 \u06C1\u06CC\u0646\u0688\u0644 \u06A9\u06CC\u06D2 \u062C\u0627 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4 \u0627\u06AF\u0631 \u0622\u067E \u0627\u0633 \u0679\u06CC\u0628 \u06A9\u0648 \u0686\u0627\u0644\u0648 \u06A9\u0631\u062A\u06D2 \u06C1\u06CC\u06BA\u060C \u062A\u0648 \u0648\u06C1 \u062A\u0645\u0627\u0645 \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u062C\u0648 \u067E\u06C1\u0644\u06D2 \u0633\u06D2 \u06C1\u06CC \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u06D2 \u0646\u0634\u0627\u0646 \u06A9\u06D2 \u0645\u0631\u062D\u0644\u06D2 \u0645\u06CC\u06BA \u06C1\u06CC\u06BA \u062E\u062A\u0645 \u06C1\u0648 \u062C\u0627\u0626\u06CC\u06BA \u06AF\u06D2\u06D4","Confirm":"\u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u06CC\u06BA\u06D4","Your {blockchainName} wallets":["\u0622\u067E \u06A9\u06D2 ",["blockchainName"]," \u0628\u0679\u0648\u06D2"],"Insufficient account balance":"\u0646\u0627\u06A9\u0627\u0641\u06CC \u0627\u06A9\u0627\u0624\u0646\u0679 \u0628\u06CC\u0644\u0646\u0633","Proceed anyway":"\u0628\u06C1\u0631\u062D\u0627\u0644 \u0622\u06AF\u06D2 \u0628\u0691\u06BE\u06CC\u06BA\u06D4","You need to connect a {blockchainName} wallet.":["\u0622\u067E \u06A9\u0648 \u0627\u06CC\u06A9 ",["blockchainName"]," \u0648\u0627\u0644\u06CC\u0679 \u062C\u0648\u0691\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u06D4"],"Add {chain} chain":[["chain"]," \u0686\u06CC\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA\u06D4"],"Show more wallets":"\u0645\u0632\u06CC\u062F \u0628\u0679\u0648\u06D2 \u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA\u06D4","Send to a different address":"\u06A9\u0633\u06CC \u062F\u0648\u0633\u0631\u06D2 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u067E\u0631 \u0628\u06BE\u06CC\u062C\u06CC\u06BA\u06D4","Enter {blockchainName} address":[["blockchainName"]," \u067E\u062A\u06C1 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA\u06D4"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u067E\u062A\u06C1 ",["destination"]," \u0628\u0644\u0627\u06A9\u0686\u06CC\u0646 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u067E\u06CC\u0679\u0631\u0646 \u0633\u06D2 \u0645\u0645\u0627\u062B\u0644 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4"],"via":"\u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u06CC\u06C1 \u0679\u0648\u06A9\u0646 \u0627\u06CC\u06A9\u0679\u0648 \u0679\u0648\u06A9\u0646 \u0644\u0633\u0679 \u067E\u0631 \u0638\u0627\u06C1\u0631 \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u062A\u0627 \u06C1\u06D2\u06D4 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u06CC\u06C1 \u0648\u06C1 \u0679\u0648\u06A9\u0646 \u06C1\u06D2 \u062C\u0633 \u06A9\u06CC \u0622\u067E \u062A\u062C\u0627\u0631\u062A \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","Import":"\u062F\u0631\u0622\u0645\u062F \u06A9\u0631\u06CC\u06BA\u06D4","Status":"\u062D\u06CC\u062B\u06CC\u062A","Reset":"\u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u0631\u062A\u06CC\u0628 \u062F\u06CC\u06BA\u06D4","Cancel":"\u0645\u0646\u0633\u0648\u062E \u06A9\u0631\u06CC\u06BA\u06D4","Refresh":"\u062A\u0627\u0632\u06C1 \u062F\u0645 \u06A9\u0631\u06CC\u06BA\u06D4","Notifications":"\u0627\u0637\u0644\u0627\u0639\u0627\u062A","Settings":"\u062A\u0631\u062A\u06CC\u0628\u0627\u062A","History":"\u062A\u0627\u0631\u06CC\u062E","Connect Wallet":"\u0648\u0627\u0644\u06CC\u0679 \u06A9\u0648 \u062C\u0648\u0691\u06CC\u06BA\u06D4","Today":"\u0622\u062C","Swaps steps":"\u0642\u062F\u0645\u0648\u06BA \u06A9\u06CC \u062A\u0628\u062F\u06CC\u0644\u06CC","Retry":"\u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Slippage Error":"\u067E\u06BE\u0633\u0644\u0646 \u06A9\u06CC \u062E\u0631\u0627\u0628\u06CC\u06D4","Slippage Warning":"\u067E\u06BE\u0633\u0644\u0646 \u06A9\u06CC \u0648\u0627\u0631\u0646\u0646\u06AF","Bridge Limit Error":"\u067E\u0644 \u06A9\u06CC \u062D\u062F \u06A9\u06CC \u062E\u0631\u0627\u0628\u06CC\u06D4","Yours: {amount} {symbol}":["\u0622\u067E \u06A9\u0627: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u06A9\u0645 \u0627\u0632 \u06A9\u0645 \u0645\u0637\u0644\u0648\u0628\u06C1 slippage: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u0622\u067E \u06A9\u0627: ",["userSlippage"]],"See All Routes":"\u062A\u0645\u0627\u0645 \u0631\u0627\u0633\u062A\u06D2 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA","View more info":"\u0645\u0632\u06CC\u062F \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062F\u06CC\u06A9\u06BE\u06CC\u06BA","Gas & Fee Explanation":"\u06AF\u06CC\u0633 \u0627\u0648\u0631 \u0641\u06CC\u0633 \u06A9\u06CC \u0648\u0636\u0627\u062D\u062A","Details":"\u062A\u0641\u0635\u06CC\u0644\u0627\u062A","Total Payable Fee":"\u06A9\u0644 \u0642\u0627\u0628\u0644 \u0627\u062F\u0627\u0626\u06CC\u06AF\u06CC \u0641\u06CC\u0633","Hide non-payable fees":"\u063A\u06CC\u0631 \u0642\u0627\u0628\u0644 \u0627\u062F\u0627\u0626\u06CC\u06AF\u06CC \u0641\u06CC\u0633 \u0686\u06BE\u067E\u0627\u0626\u06CC\u06BA\u06D4","Show non-payable fees":"\u063A\u06CC\u0631 \u0642\u0627\u0628\u0644 \u0627\u062F\u0627\u0626\u06CC\u06AF\u06CC \u0641\u06CC\u0633 \u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA\u06D4","Description":"\u062A\u0641\u0635\u06CC\u0644","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u06D2 \u0622\u0624\u0679 \u067E\u0679 \u0645\u06CC\u06BA \u062F\u0631\u062C \u0630\u06CC\u0644 \u0641\u06CC\u0633\u0648\u06BA \u067E\u0631 \u063A\u0648\u0631 \u06A9\u06CC\u0627 \u062C\u0627\u062A\u0627 \u06C1\u06D2 \u0627\u0648\u0631\\n                \u0622\u067E \u06A9\u0648 \u0627\u0646 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0636\u0627\u0641\u06CC \u06AF\u06CC\u0633 \u0627\u062F\u0627 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u0648\u06AF\u06CC\u06D4","Swap input":"\u0627\u0646 \u067E\u0679 \u06A9\u0648 \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Estimated output":"\u062A\u062E\u0645\u06CC\u0646\u06CC \u067E\u06CC\u062F\u0627\u0648\u0627\u0631","Via:":"\u0628\u0630\u0631\u06CC\u0639\u06C1:","Chains:":"\u0632\u0646\u062C\u06CC\u0631\u06CC\u06BA:","Sort by":"\u062A\u0631\u062A\u06CC\u0628 \u062F\u06CC\u06BA","Smart Routing":"\u0627\u0633\u0645\u0627\u0631\u0679 \u0631\u0648\u0679\u0646\u06AF","Lowest Fee":"\u0633\u0628 \u0633\u06D2 \u06A9\u0645 \u0641\u06CC\u0633","Fastest Transfer":"\u062A\u06CC\u0632 \u062A\u0631\u06CC\u0646 \u0679\u0631\u0627\u0646\u0633\u0641\u0631","Maximum Return":"\u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0648\u0627\u067E\u0633\u06CC","Maximum Output":"\u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0622\u0624\u0679 \u067E\u0679","Swapping":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0631\u0646\u0627","Gas cost":"\u06AF\u06CC\u0633 \u06A9\u06CC \u0642\u06CC\u0645\u062A","Receiving":"\u0648\u0635\u0648\u0644 \u06A9\u0631\u0646\u0627","Price impact":"\u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u0627\u0633 \u0631\u0627\u0633\u062A\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0622\u067E \u06A9\u0648 \u067E\u06BE\u0633\u0644\u0646 \u06A9\u0648 \u06A9\u0645 \u0627\u0632 \u06A9\u0645 ",["minRequiredSlippage"]," \u062A\u06A9 \u0628\u0691\u06BE\u0627\u0646\u0627 \u06C1\u0648\u06AF\u0627\u06D4"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u06C1\u0645 \u0622\u067E \u06A9\u0648 \u0645\u0634\u0648\u0631\u06C1 \u062F\u06CC\u062A\u06D2 \u06C1\u06CC\u06BA \u06A9\u06C1 \u0627\u0633 \u0631\u0627\u0633\u062A\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u067E\u06BE\u0633\u0644\u0646 \u06A9\u0648 \u06A9\u0645 \u0627\u0632 \u06A9\u0645 ",["minRequiredSlippage"]," \u062A\u06A9 \u0628\u0691\u06BE\u0627 \u062F\u06CC\u06BA\u06D4"],"Caution, your slippage is high.":"\u062E\u0628\u0631\u062F\u0627\u0631\u060C \u0622\u067E \u06A9\u06CC \u067E\u06BE\u0633\u0644\u0646 \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u06D2\u06D4","Change":"\u062A\u0628\u062F\u06CC\u0644\u06CC","Change settings":"\u062A\u0631\u062A\u06CC\u0628\u0627\u062A \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","High slippage":"\u0627\u0648\u0646\u0686\u06CC \u067E\u06BE\u0633\u0644\u0646","Low slippage":"\u06A9\u0645 \u067E\u06BE\u0633\u0644\u0646\u0627"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u0627\u062D\u062A\u06CC\u0627\u0637\u060C \u0622\u067E \u06A9\u0627 \u067E\u06BE\u0633\u0644\u0646\u0627 \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u06D2 (=",["userSlippage"],")\u06D4 \u0622\u067E \u06A9\u06CC \u062A\u062C\u0627\u0631\u062A \u0622\u06AF\u06D2 \u0686\u0644 \u0633\u06A9\u062A\u06CC \u06C1\u06D2\u06D4"],"Confirm anyway":"\u0628\u06C1\u0631\u062D\u0627\u0644 \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u06CC\u06BA\u06D4","Something went wrong":"\u06A9\u0686\u06BE \u063A\u0644\u0637 \u06C1\u0648 \u06AF\u06CC\u0627\u06D4","Something went wrong. Please refresh the app.":"\u06A9\u0686\u06BE \u063A\u0644\u0637 \u06C1\u0648 \u06AF\u06CC\u0627\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u06CC\u067E \u06A9\u0648 \u0631\u06CC\u0641\u0631\u06CC\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Slippage tolerance per swap":"slippage \u0631\u0648\u0627\u062F\u0627\u0631\u06CC \u0641\u06CC \u0633\u0648\u06CC\u067E","Custom":"\u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u0627\u06AF\u0631 \u0642\u06CC\u0645\u062A \u0627\u0633 \u0641\u06CC\u0635\u062F \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u0646\u0627\u0645\u0648\u0627\u0641\u0642 \u0637\u0648\u0631 \u067E\u0631 \u062A\u0628\u062F\u06CC\u0644 \u06C1\u0648\u062A\u06CC \u06C1\u06D2 \u062A\u0648 \u0622\u067E \u06A9\u0627 \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0648\u0627\u067E\u0633 \u06A9\u0631 \u062F\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u06D4","Warning":"\u0648\u0627\u0631\u0646\u0646\u06AF","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u06CC\u06C1 \u062A\u0631\u062A\u06CC\u0628 \u06C1\u0631 \u0642\u062F\u0645 (\u0645\u062B\u0644\u0627\u064B 1 \u0627\u0646\u0686\u060C \u062A\u06BE\u0648\u0631\u0686\u06CC\u0646\u060C \u0648\u063A\u06CC\u0631\u06C1) \u067E\u0631 \u0644\u0627\u06AF\u0648 \u06C1\u0648\u062A\u06CC \u06C1\u06D2\u060C \u06CC\u0639\u0646\u06CC \u0635\u0631\u0641 \u0648\u06C1\u06CC \u0645\u062E\u0635\u0648\u0635 \u0645\u0631\u062D\u0644\u06C1 \u0648\u0627\u067E\u0633 \u06A9\u06CC\u0627 \u062C\u0627\u0626\u06D2 \u06AF\u0627\u060C \u067E\u0648\u0631\u06D2 \u0631\u0627\u0633\u062A\u06D2 \u067E\u0631 \u0646\u06C1\u06CC\u06BA\u06D4","Swap Details":"\u062A\u0641\u0635\u06CC\u0644\u0627\u062A \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Request ID":"ID \u06A9\u06CC \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u0631\u06CC\u06BA\u06D4","Not found":"\u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627","Swap with request ID = {requestId} not found.":["\u062F\u0631\u062E\u0648\u0627\u0633\u062A ID = ",["requestId"]," \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u062A\u0628\u0627\u062F\u0644\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627\u06D4"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u0622\u067E \u06A9\u0648 ",["chain"]," \u0686\u06CC\u0646 \u067E\u0631 ",["conciseAddress"]," \u0648\u0627\u0644\u06CC\u0679 \u0645\u06CC\u06BA ",["amount"]," ",["token"]," \u0645\u0648\u0635\u0648\u0644 \u06C1\u0648\u0627 \u06C1\u06D2\u06D4"],"Transaction was not sent.":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0646\u06C1\u06CC\u06BA \u0628\u06BE\u06CC\u062C\u0627 \u06AF\u06CC\u0627 \u062A\u06BE\u0627\u06D4","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u067E\u0631 ",["blockchain"]," \u0622\u067E \u06A9\u06D2 \u0628\u0679\u0648\u06D2 \u0645\u06CC\u06BA \u0631\u06C1\u062A\u0627 \u06C1\u06D2\u06D4"],"Delete":"\u062D\u0630\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","Try again":"\u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Copied To Clipboard":"\u06A9\u0644\u067E \u0628\u0648\u0631\u0688 \u067E\u0631 \u06A9\u0627\u067E\u06CC \u06A9\u06CC\u0627 \u06AF\u06CC\u0627\u06D4","Copy Request ID":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u06A9\u0627\u067E\u06CC \u06A9\u0631\u06CC\u06BA\u06D4","View on Rango Explorer":"\u0631\u0646\u06AF\u0648 \u0627\u06CC\u06A9\u0633\u067E\u0644\u0648\u0631\u0631 \u067E\u0631 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA","Finished at":"\u067E\u0631 \u062E\u062A\u0645 \u06C1\u0648\u0627\u06D4","Created at":"\u067E\u0631 \u062A\u062E\u0644\u06CC\u0642 \u06A9\u06CC\u0627 \u06AF\u06CC\u0627\u06D4","View transaction":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u062F\u06CC\u06A9\u06BE\u06CC\u06BA","Connect":"\u062C\u0691\u06CC\u06BA","Swap Successful":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0627\u0645\u06CC\u0627\u0628","Transaction Failed":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0646\u0627\u06A9\u0627\u0645 \u06C1\u0648 \u06AF\u06CC\u0627\u06D4","Done":"\u06C1\u0648 \u06AF\u06CC\u0627","Diagnosis":"\u062A\u0634\u062E\u06CC\u0635","See Details":"\u062A\u0641\u0635\u06CC\u0644\u0627\u062A \u062F\u06CC\u06A9\u06BE\u06CC\u06BA","Cancel Swap":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u0645\u0646\u0633\u0648\u062E \u06A9\u0631\u06CC\u06BA\u06D4","Are you sure you want to cancel this swap?":"\u06A9\u06CC\u0627 \u0622\u067E \u0648\u0627\u0642\u0639\u06CC \u0627\u0633 \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0648 \u0645\u0646\u0633\u0648\u062E \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u061F","Yes, Cancel it":"\u06C1\u0627\u06BA\u060C \u0627\u0633\u06D2 \u0645\u0646\u0633\u0648\u062E \u06A9\u0631 \u062F\u06CC\u06BA\u06D4","No, Continue":"\u0646\u06C1\u06CC\u06BA\u060C \u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u06CC\u06BA","Delete Transaction":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u0648 \u062D\u0630\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","Are you sure you want to delete this swap?":"\u06A9\u06CC\u0627 \u0622\u067E \u0648\u0627\u0642\u0639\u06CC \u0627\u0633 \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0648 \u062D\u0630\u0641 \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u061F","Yes, Delete it":"\u06C1\u0627\u06BA\u060C \u0627\u0633\u06D2 \u062D\u0630\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","No, Cancel":"\u0646\u06C1\u06CC\u06BA\u060C \u0645\u0646\u0633\u0648\u062E \u06A9\u0631\u06CC\u06BA\u06D4","Change Network":"\u0646\u06CC\u0679 \u0648\u0631\u06A9 \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Network Changed":"\u0646\u06CC\u0679 \u0648\u0631\u06A9 \u0628\u062F\u0644 \u06AF\u06CC\u0627\u06D4","Select Token":"\u0679\u0648\u06A9\u0646 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","Wallet Connected":"\u0648\u0627\u0644\u06CC\u0679 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u06D2\u06D4","Your wallet is connected, you can use it to swap.":"\u0622\u067E \u06A9\u0627 \u0628\u0679\u0648\u06C1 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u06D2\u060C \u0622\u067E \u0627\u0633\u06D2 \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","Failed to Connect":"\u0645\u0631\u0628\u0648\u0637 \u06C1\u0648\u0646\u06D2 \u0645\u06CC\u06BA \u0646\u0627\u06A9\u0627\u0645","Your wallet is not connected. Please try again.":"\u0622\u067E \u06A9\u0627 \u0628\u0679\u0648\u06C1 \u0645\u0646\u0633\u0644\u06A9 \u0646\u06C1\u06CC\u06BA \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Connecting to your wallet":"\u0622\u067E \u06A9\u06D2 \u0628\u0679\u0648\u06D2 \u0633\u06D2 \u0645\u0646\u0633\u0644\u06A9 \u06C1\u0648 \u0631\u06C1\u0627 \u06C1\u06D2\u06D4","Click connect in your wallet popup.":"\u0627\u067E\u0646\u06D2 \u0648\u0627\u0644\u0679 \u067E\u0627\u067E \u0627\u067E \u0645\u06CC\u06BA \u06A9\u0646\u06CC\u06A9\u0679 \u067E\u0631 \u06A9\u0644\u06A9 \u06A9\u0631\u06CC\u06BA\u06D4","Select Derivation Path":"\u0627\u062E\u0630 \u06A9\u0631\u0646\u06D2 \u06A9\u0627 \u0631\u0627\u0633\u062A\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","In order to connect to {type}, you must first select a Derivation Path":[["type"],"\u0633\u06D2 \u062C\u0691\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2\u060C \u0622\u067E \u06A9\u0648 \u067E\u06C1\u0644\u06D2 \u0627\u062E\u0630 \u06A9\u0631\u0646\u06D2 \u06A9\u0627 \u0631\u0627\u0633\u062A\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u0646\u0627 \u06C1\u0648\u06AF\u0627\u06D4"],"Choose Derivation Path Template":"\u0627\u062E\u0630 \u067E\u0627\u062A\u06BE \u0679\u06CC\u0645\u067E\u0644\u06CC\u0679 \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","Enter Path":"\u0631\u0627\u0633\u062A\u06C1 \u062F\u0627\u062E\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Enter Index":"\u0627\u0646\u0688\u06CC\u06A9\u0633 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA\u06D4","Add {blockchainDisplayName} Chain":[["blockchainDisplayName"]," \u0686\u06CC\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA\u06D4"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u06A9\u06CC\u0627 \u0622\u067E \u0627\u067E\u0646\u06D2 \u0628\u0679\u0648\u06D2 \u0645\u06CC\u06BA ",["blockchainDisplayName"]," \u062A\u062C\u0631\u0628\u0627\u062A\u06CC \u0633\u0644\u0633\u0644\u06C1 \u0634\u0627\u0645\u0644 \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06BA \u06AF\u06D2\u061F"],"Please approve the experimental chain pop-up in your wallet.":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0628\u0679\u0648\u06D2 \u0645\u06CC\u06BA \u062A\u062C\u0631\u0628\u0627\u062A\u06CC \u0686\u06CC\u0646 \u06A9\u06D2 \u067E\u0627\u067E \u0627\u067E \u06A9\u0648 \u0645\u0646\u0638\u0648\u0631 \u06A9\u0631\u06CC\u06BA\u06D4","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0633\u0644\u0633\u0644\u06C1 \u0634\u0627\u0645\u0644 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627\u06D4"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u0633\u0644\u0633\u0644\u06C1 \u06A9\u0627\u0645\u06CC\u0627\u0628\u06CC \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0622\u067E \u06A9\u06D2 \u0628\u0679\u0648\u06D2 \u0645\u06CC\u06BA \u0634\u0627\u0645\u0644 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4"],"Request Rejected":"\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0645\u0633\u062A\u0631\u062F \u06A9\u0631 \u062F\u06CC \u06AF\u0626\u06CC\u06D4","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u0622\u067E \u0646\u06D2 \u0627\u067E\u0646\u06D2 \u0628\u0679\u0648\u06D2 \u0645\u06CC\u06BA ",["blockchainDisplayName"]," \u0686\u06CC\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u0648 \u0645\u0633\u062A\u0631\u062F \u06A9\u0631 \u062F\u06CC\u0627 \u06C1\u06D2\u06D4"],"Select chain types":"\u0632\u0646\u062C\u06CC\u0631 \u06A9\u06CC \u0627\u0642\u0633\u0627\u0645 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u06CC\u06C1 \u067E\u0631\u0633 \u0645\u062A\u0639\u062F\u062F \u0632\u0646\u062C\u06CC\u0631\u0648\u06BA \u06A9\u0648 \u0633\u067E\u0648\u0631\u0679 \u06A9\u0631\u062A\u0627 \u06C1\u06D2\u06D4 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u06A9\u0633 \u0633\u0644\u0633\u0644\u06C1 \u0633\u06D2 \u062C\u0691\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","Failed Network, Please retry your swap.":"\u0646\u0627\u06A9\u0627\u0645 \u0646\u06CC\u0679 \u0648\u0631\u06A9\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u06CC \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Please reset your liquidity sources.":"\u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC \u0630\u0631\u0627\u0626\u0639 \u06A9\u0648 \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u0631\u062A\u06CC\u0628 \u062F\u06CC\u06BA\u06D4","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u0622\u067E \u0646\u06D2 \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC \u0630\u0631\u0627\u0626\u0639 \u06A9\u0648 \u0645\u062D\u062F\u0648\u062F \u06A9\u0631 \u062F\u06CC\u0627 \u06C1\u06D2 \u0627\u0648\u0631 \u0627\u0633 \u06A9\u06D2 \u0646\u062A\u06CC\u062C\u06D2 \u0645\u06CC\u06BA \u0631\u0646\u06AF\u0648 \u06A9\u0648 \u06A9\u0648\u0626\u06CC \u0631\u0627\u0633\u062A\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC \u0630\u0631\u0627\u0626\u0639 \u06A9\u0648 \u062F\u0648\u0628\u0627\u0631\u06C1 \u062A\u0631\u062A\u06CC\u0628 \u062F\u06CC\u0646\u06D2 \u067E\u0631 \u063A\u0648\u0631 \u06A9\u0631\u06CC\u06BA\u06D4","No Routes Found.":"\u06A9\u0648\u0626\u06CC \u0631\u0627\u0633\u062A\u06C1 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627\u06D4","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango \u06A9\u0648 \u0631\u0648\u0679 \u0646\u06C1 \u0645\u0644\u0646\u06D2 \u06A9\u06CC \u0648\u062C\u0648\u06C1\u0627\u062A: \u0679\u0648\u06A9\u0646 \u067E\u0631 \u06A9\u0645 \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC\u060C \u0628\u06C1\u062A \u06A9\u0645 \u0627\u0646 \u067E\u0679 \u0631\u0642\u0645 \u06CC\u0627 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u062F\u06C1 \u0627\u0646 \u067E\u0679/\u0622\u0624\u0679 \u067E\u0679 \u0679\u0648\u06A9\u0646 \u0627\u0645\u062A\u0632\u0627\u062C \u06A9\u06D2 \u0644\u06CC\u06D2 \u06A9\u0648\u0626\u06CC \u0631\u0648\u0679\u0633 \u062F\u0633\u062A\u06CC\u0627\u0628 \u0646\u06C1\u06CC\u06BA\u06D4","Bridge Limit Error: Please increase your amount.":"\u0628\u0631\u062C \u06A9\u06CC \u062D\u062F \u06A9\u06CC \u062E\u0631\u0627\u0628\u06CC: \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06CC \u0631\u0642\u0645 \u0628\u0691\u06BE\u0627\u0626\u06CC\u06BA\u06D4","Bridge Limit Error: Please decrease your amount.":"\u0628\u0631\u062C \u06A9\u06CC \u062D\u062F \u06A9\u06CC \u062E\u0631\u0627\u0628\u06CC: \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06CC \u0631\u0642\u0645 \u06A9\u0645 \u06A9\u0631\u06CC\u06BA\u06D4","High Price Impact":"\u0627\u0639\u0644\u06CC \u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631","Price impact is too high!":"\u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631 \u0628\u06C1\u062A \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u06D2!","The price impact is significantly higher than the allowed amount.":"\u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631 \u0642\u0627\u0628\u0644 \u0627\u062C\u0627\u0632\u062A \u0631\u0642\u0645 \u0633\u06D2 \u06A9\u0627\u0641\u06CC \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u06D2\u06D4","Confirm high price impact":"\u0627\u0639\u0644\u06CC \u0642\u06CC\u0645\u062A \u06A9\u06D2 \u0627\u062B\u0631 \u06A9\u06CC \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u06CC\u06BA\u06D4","Route updated and price impact is too high, try again later!":"\u0631\u0627\u0633\u062A\u06C1 \u0627\u067E \u0688\u06CC\u0679 \u06C1\u0648\u0627 \u0627\u0648\u0631 \u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631 \u0628\u06C1\u062A \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u06D2\u060C \u0628\u0639\u062F \u0645\u06CC\u06BA \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA!","USD Price Unknown":"USD \u0642\u06CC\u0645\u062A \u0646\u0627\u0645\u0639\u0644\u0648\u0645 \u06C1\u06D2\u06D4","USD Price Unknown, Cannot calculate Price Impact.":"USD \u0642\u06CC\u0645\u062A \u0646\u0627\u0645\u0639\u0644\u0648\u0645 \u06C1\u06D2\u060C \u0642\u06CC\u0645\u062A \u06A9\u06D2 \u0627\u062B\u0631\u0627\u062A \u06A9\u0627 \u062D\u0633\u0627\u0628 \u0646\u06C1\u06CC\u06BA \u0644\u06AF\u0627\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627\u06D4","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"USD \u0642\u06CC\u0645\u062A \u0646\u0627\u0645\u0639\u0644\u0648\u0645 \u06C1\u06D2\u060C \u0642\u06CC\u0645\u062A \u06A9\u06D2 \u0627\u062B\u0631\u0627\u062A \u06A9\u0627 \u062D\u0633\u0627\u0628 \u0646\u06C1\u06CC\u06BA \u0644\u06AF\u0627\u06CC\u0627 \u062C\u0627 \u0633\u06A9\u062A\u0627\u06D4 \u0642\u06CC\u0645\u062A \u06A9\u0627 \u0627\u062B\u0631 \u0645\u0639\u0645\u0648\u0644 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1 \u06C1\u0648 \u0633\u06A9\u062A\u0627 \u06C1\u06D2\u06D4 \u06A9\u06CC\u0627 \u0622\u067E \u06A9\u0648 \u062A\u0628\u0627\u062F\u0644\u06C1 \u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u06D2 \u06A9\u0627 \u06CC\u0642\u06CC\u0646 \u06C1\u06D2\u061F","Confirm USD Price Unknown":"\u0646\u0627\u0645\u0639\u0644\u0648\u0645 USD \u0642\u06CC\u0645\u062A \u06A9\u06CC \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u06CC\u06BA\u06D4","Swap":"\u062A\u0628\u0627\u062F\u0644\u06C1","Swap anyway":"\u0628\u06C1\u0631\u062D\u0627\u0644 \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0631\u06CC\u06BA\u06D4","The route goes through Ethereum. Continue?":"\u0631\u0627\u0633\u062A\u06C1 Ethereum \u0633\u06D2 \u06AF\u0632\u0631\u062A\u0627 \u06C1\u06D2\u06D4 \u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u06CC\u06BA\u061F","Route has been updated.":"\u0631\u0648\u0679 \u06A9\u0648 \u0627\u067E \u0688\u06CC\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u0622\u0624\u0679 \u067E\u0679 \u06A9\u06CC \u0631\u0642\u0645 \u06A9\u0648 ",["newOutputAmount"]," \u0645\u06CC\u06BA \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 (",["percentageChange"],"% \u062A\u0628\u062F\u06CC\u0644\u06CC)\u06D4"],"Route swappers has been updated.":"\u0631\u0648\u0679 \u0633\u0648\u06CC\u067E\u0631\u0632 \u06A9\u0648 \u0627\u067E \u0688\u06CC\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4","Route internal coins has been updated.":"\u0631\u0627\u0633\u062A\u06D2 \u06A9\u06D2 \u0627\u0646\u062F\u0631\u0648\u0646\u06CC \u0633\u06A9\u06A9\u0648\u06BA \u06A9\u0648 \u0627\u067E \u0688\u06CC\u0679 \u06A9\u0631 \u062F\u06CC\u0627 \u06AF\u06CC\u0627 \u06C1\u06D2\u06D4","Routes":"\u0631\u0627\u0633\u062A\u06D2","From":"\u0633\u06D2","To":"\u06A9\u0648","Light":"\u0631\u0648\u0634\u0646\u06CC","Dark":"\u0627\u0646\u062F\u06BE\u06CC\u0631\u0627","Auto":"\u0622\u0679\u0648","Loading failed":"\u0644\u0648\u0688\u0646\u06AF \u0646\u0627\u06A9\u0627\u0645 \u06C1\u0648 \u06AF\u0626\u06CC\u06D4","Bridges":"\u067E\u0644","Exchanges":"\u062A\u0628\u0627\u062F\u0644\u06C1","Custom Tokens":"\u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646\u0632","Language":"\u0632\u0628\u0627\u0646","Infinite approval":"\u0644\u0627\u0645\u062D\u062F\u0648\u062F \u0645\u0646\u0638\u0648\u0631\u06CC","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\'\u0644\u0627\u0645\u062D\u062F\u0648\u062F \u0645\u0646\u0638\u0648\u0631\u06CC\' \u0645\u0648\u0688 \u06A9\u0648 \u0641\u0639\u0627\u0644 \u06A9\u0631\u0646\u06D2 \u0633\u06D2 \u0628\u0646\u06CC\u0627\u062F\u06CC \u0633\u0645\u0627\u0631\u0679 \u0645\u0639\u0627\u06C1\u062F\u0648\u06BA \u062A\u06A9 \u063A\u06CC\u0631 \u0645\u062D\u062F\u0648\u062F \u0631\u0633\u0627\u0626\u06CC \u062D\u0627\u0635\u0644 \u06C1\u0648\u062A\u06CC \u06C1\u06D2\u060C \u062C\u0633 \u0633\u06D2 \u0648\u06C1 \u0645\u0646\u0638\u0648\u0631 \u0634\u062F\u06C1 \u0679\u0648\u06A9\u0646 \u0631\u0642\u0645 \u06A9\u0648 \u0628\u063A\u06CC\u0631 \u06A9\u0633\u06CC \u067E\u0627\u0628\u0646\u062F\u06CC \u06A9\u06D2 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631 \u0633\u06A9\u062A\u06D2 \u06C1\u06CC\u06BA\u06D4","Theme":"\u062A\u06BE\u06CC\u0645","Duplicate Token":"\u0688\u067E\u0644\u06CC\u06A9\u06CC\u0679 \u0679\u0648\u06A9\u0646","The address you entered is duplicate, please enter a new address.":"\u0622\u067E \u0646\u06D2 \u062C\u0648 \u067E\u062A\u06C1 \u062F\u0631\u062C \u06A9\u06CC\u0627 \u06C1\u06D2 \u0648\u06C1 \u0688\u067E\u0644\u06CC\u06A9\u06CC\u0679 \u06C1\u06D2\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u06CC\u06A9 \u0646\u06CC\u0627 \u067E\u062A\u06C1 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA\u06D4","Token Already Exists":"\u0679\u0648\u06A9\u0646 \u067E\u06C1\u0644\u06D2 \u0633\u06D2 \u0645\u0648\u062C\u0648\u062F \u06C1\u06D2\u06D4","There\'s no need to add this token again because it already exists and is supported by us.":"\u0627\u0633 \u0679\u0648\u06A9\u0646 \u06A9\u0648 \u062F\u0648\u0628\u0627\u0631\u06C1 \u0634\u0627\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06D2 \u06A9\u06CC\u0648\u0646\u06A9\u06C1 \u06CC\u06C1 \u067E\u06C1\u0644\u06D2 \u0633\u06D2 \u0645\u0648\u062C\u0648\u062F \u06C1\u06D2 \u0627\u0648\u0631 \u06C1\u0645\u0627\u0631\u06D2 \u0630\u0631\u06CC\u0639\u06C1 \u062A\u0639\u0627\u0648\u0646 \u06CC\u0627\u0641\u062A\u06C1 \u06C1\u06D2\u06D4","Token Not Found":"\u0679\u0648\u06A9\u0646 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u0645\u0639\u0630\u0631\u062A\u060C \u0641\u0631\u0627\u06C1\u0645 \u06A9\u0631\u062F\u06C1 \u067E\u062A\u06D2 \u06A9\u06D2 \u0633\u0627\u062A\u06BE ",["blockchain"]," \u0686\u06CC\u0646 \u067E\u0631 \u06A9\u0648\u0626\u06CC \u0679\u0648\u06A9\u0646 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u06CC\u0642\u06CC\u0646\u06CC \u0628\u0646\u0627\u0626\u06CC\u06BA \u06A9\u06C1 \u0622\u067E \u0646\u06D2 \u0635\u062D\u06CC\u062D \u0679\u0648\u06A9\u0646 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u062F\u0631\u062C \u06A9\u06CC\u0627 \u06C1\u06D2\u06D4"],"Network Error":"\u0646\u06CC\u0679 \u0648\u0631\u06A9 \u06A9\u06CC \u062E\u0631\u0627\u0628\u06CC\u06D4","Add Custom Token":"\u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Select chain":"\u0633\u0644\u0633\u0644\u06C1 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","Enter Address":"\u0627\u06CC\u0688\u0631\u06CC\u0633 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA\u06D4","Enter token address":"\u0679\u0648\u06A9\u0646 \u0627\u06CC\u0688\u0631\u06CC\u0633 \u062F\u0631\u062C \u06A9\u0631\u06CC\u06BA\u06D4","Failed Network, Please retry.":"\u0646\u0627\u06A9\u0627\u0645 \u0646\u06CC\u0679 \u0648\u0631\u06A9\u060C \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u062F\u0648\u0628\u0627\u0631\u06C1 \u06A9\u0648\u0634\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","Add another custom token":"\u0627\u06CC\u06A9 \u0627\u0648\u0631 \u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Confirm Swap":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u06CC \u062A\u0635\u062F\u06CC\u0642 \u06A9\u0631\u06CC\u06BA\u06D4","Start Swap":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA\u06D4","You get":"\u0622\u067E \u062D\u0627\u0635\u0644 \u06A9\u0631\u06CC\u06BA","Search Token":"\u0679\u0648\u06A9\u0646 \u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","No custom tokens":"\u06A9\u0648\u0626\u06CC \u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646 \u0646\u06C1\u06CC\u06BA\u06D4","press the button to add your custom token":"\u0627\u067E\u0646\u0627 \u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0628\u0679\u0646 \u062F\u0628\u0627\u0626\u06CC\u06BA\u06D4","Delete Custom Token":"\u062D\u0633\u0628 \u0636\u0631\u0648\u0631\u062A \u0679\u0648\u06A9\u0646 \u062D\u0630\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","Are you sure you want to Delete this Token?":"\u06A9\u06CC\u0627 \u0622\u067E \u0648\u0627\u0642\u0639\u06CC \u0627\u0633 \u0679\u0648\u06A9\u0646 \u06A9\u0648 \u062D\u0630\u0641 \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u061F","Complete":"\u0645\u06A9\u0645\u0644","Running":"\u0686\u0644 \u0631\u06C1\u0627 \u06C1\u06D2\u06D4","Failed":"\u0646\u0627\u06A9\u0627\u0645","Clear":"\u0635\u0627\u0641","Search Transaction":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA\u06D4","No transactions":"\u06A9\u0648\u0626\u06CC \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u0646\u06C1\u06CC\u06BA\u06D4","Your transaction history is stored locally and will appear here after you start a swap":"\u0622\u067E \u06A9\u06CC \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u06CC \u0633\u0631\u06AF\u0632\u0634\u062A \u0645\u0642\u0627\u0645\u06CC \u0637\u0648\u0631 \u067E\u0631 \u0630\u062E\u06CC\u0631\u06C1 \u06A9\u06CC \u062C\u0627\u062A\u06CC \u06C1\u06D2 \u0627\u0648\u0631 \u0622\u067E \u06A9\u06D2 \u062A\u0628\u0627\u062F\u0644\u06C1 \u0634\u0631\u0648\u0639 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0628\u0639\u062F \u06CC\u06C1\u0627\u06BA \u0638\u0627\u06C1\u0631 \u06C1\u0648\u06AF\u06CC\u06D4","Clear Transaction History":"\u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u06CC \u062A\u0627\u0631\u06CC\u062E \u0635\u0627\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u0622\u06AF\u06D2 \u0628\u0691\u06BE\u0646\u06D2 \u0633\u06D2 \u0648\u06CC\u062C\u06CC\u0679 \u0633\u06D2 \u062A\u0645\u0627\u0645 \u06A9\u0627\u0645\u06CC\u0627\u0628 \u0627\u0648\u0631 \u0646\u0627\u06A9\u0627\u0645 \u0679\u0631\u0627\u0646\u0632\u06CC\u06A9\u0634\u0646\u0632 \u06C1\u0679 \u062C\u0627\u0626\u06CC\u06BA \u06AF\u06CC\u06D4 \u06A9\u06CC\u0627 \u0622\u067E \u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u0646\u0627 \u0686\u0627\u06C1\u062A\u06D2 \u06C1\u06CC\u06BA\u061F","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u0646\u0648\u0679: \u06CC\u06C1 \u0633\u0644\u0633\u0644\u06C1 \u067E\u0631 \u0622\u067E \u06A9\u06CC \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u06CC \u062A\u0627\u0631\u06CC\u062E \u06A9\u0648 \u0646\u06C1\u06CC\u06BA \u0645\u0679\u0627\u062A\u0627 \u06C1\u06D2\u06D4 \u06CC\u06C1 \u0635\u0631\u0641 \u0627\u0646\u06C1\u06CC\u06BA \u06CC\u06C1\u0627\u06BA \u06C1\u0679\u0627\u062A\u0627 \u06C1\u06D2\u06D4","Yes, Clear the history":"\u06C1\u0627\u06BA\u060C \u062A\u0627\u0631\u06CC\u062E \u06A9\u0648 \u0635\u0627\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","language":"\u0632\u0628\u0627\u0646","Deselect all":"\u0633\u0628\u06BE\u06CC \u06A9\u0648 \u063A\u06CC\u0631 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","Select all":"\u0633\u0628\u06BE\u06CC \u06A9\u0648 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","Search {sourceType}":[["sourceType"],"\u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA\u06D4"],"Search Chain":"\u0633\u0631\u0686 \u0686\u06CC\u0646","Source":"\u0645\u0627\u062E\u0630","Destination":"\u0645\u0646\u0632\u0644","Swap {type}":["\u062A\u0628\u0627\u062F\u0644\u06C1 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u0641\u06CC \u0627\u0644\u062D\u0627\u0644\u060C \u0622\u067E \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC \u0630\u0631\u0627\u0626\u0639 \u067E\u0631 \u067E\u0627\u0628\u0646\u062F\u06CC\u0648\u06BA \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0645\u06C1\u0645 \u06A9\u06D2 \u0645\u0648\u0688 \u0645\u06CC\u06BA \u06C1\u06CC\u06BA\u06D4 \u06A9\u06CC\u0627 \u0622\u067E \u0627\u0633 \u0645\u0648\u0688 \u0633\u06D2 \u0628\u0627\u06C1\u0631 \u0646\u06A9\u0644 \u06A9\u0631 \u062A\u0645\u0627\u0645 \u062F\u0633\u062A\u06CC\u0627\u0628 \u0644\u06CC\u06A9\u0648\u06CC\u0688\u06CC\u0679\u06CC \u0630\u0631\u0627\u0626\u0639 \u06A9\u0648 \u0627\u0633\u062A\u0639\u0645\u0627\u0644 \u06A9\u0631\u0646\u0627 \u0686\u0627\u06C1\u06CC\u06BA \u06AF\u06D2\u061F","The request ID is necessary to display the swap details.":"\u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u06CC \u062A\u0641\u0635\u06CC\u0644\u0627\u062A \u0638\u0627\u06C1\u0631 \u06A9\u0631\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u06A9\u06CC \u0634\u0646\u0627\u062E\u062A \u0636\u0631\u0648\u0631\u06CC \u06C1\u06D2\u06D4","Connect Wallets":"\u0628\u0679\u0648\u06D2 \u06A9\u0648 \u062C\u0648\u0691\u06CC\u06BA\u06D4","Choose a wallet to connect.":"\u062C\u0691\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u06CC\u06A9 \u067E\u0631\u0633 \u06A9\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0631\u06CC\u06BA\u06D4","This week":"\u0627\u0633 \u06C1\u0641\u062A\u06D2","This month":"\u0627\u0633 \u0645\u06C1\u06CC\u0646\u06D2","This year":"\u0627\u0633 \u0633\u0627\u0644","Required: >= {min} {symbol}":["\u0645\u0637\u0644\u0648\u0628\u06C1: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u0645\u0637\u0644\u0648\u0628\u06C1: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u0645\u0637\u0644\u0648\u0628\u06C1: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u0645\u0637\u0644\u0648\u0628\u06C1: < ",["max"]," ",["symbol"]]," for network fee":" \u0646\u06CC\u0679 \u0648\u0631\u06A9 \u0641\u06CC\u0633 \u06A9\u06D2 \u0644\u06CC\u06D2"," for swap":" \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u06D2 \u0644\u06CC\u06D2"," for input and network fee":" \u0627\u0646 \u067E\u0679 \u0627\u0648\u0631 \u0646\u06CC\u0679 \u0648\u0631\u06A9 \u0641\u06CC\u0633 \u06A9\u06D2 \u0644\u06CC\u06D2","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u0636\u0631\u0648\u0631\u062A \u06C1\u06D2 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\u060C \u0644\u06CC\u06A9\u0646 \u0622\u067E \u06A9\u06D2 ",["blockchain"]," \u0648\u0627\u0644\u06CC\u0679 \u0645\u06CC\u06BA ",["currentAmount"]," ",["symbol"]," \u06C1\u06D2\u06D4"],"Waiting for connecting wallet":"\u0628\u0679\u0648\u06D2 \u06A9\u0648 \u062C\u0648\u0691\u0646\u06D2 \u06A9\u0627 \u0627\u0646\u062A\u0638\u0627\u0631 \u06A9\u0631 \u0631\u06C1\u0627 \u06C1\u06D2\u06D4","Waiting for other running tasks to be finished":"\u062F\u0648\u0633\u0631\u06D2 \u0686\u0644\u0646\u06D2 \u0648\u0627\u0644\u06D2 \u06A9\u0627\u0645\u0648\u06BA \u06A9\u06D2 \u0645\u06A9\u0645\u0644 \u06C1\u0648\u0646\u06D2 \u06A9\u0627 \u0627\u0646\u062A\u0638\u0627\u0631 \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4","Waiting for changing wallet network":"\u0628\u0679\u0648\u06D2 \u06A9\u06D2 \u0646\u06CC\u0679 \u0648\u0631\u06A9 \u06A9\u0648 \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u0627 \u0627\u0646\u062A\u0638\u0627\u0631 \u06A9\u0631 \u0631\u06C1\u06D2 \u06C1\u06CC\u06BA\u06D4","Sunday":"\u0627\u062A\u0648\u0627\u0631","Monday":"\u067E\u06CC\u0631","Tuesday":"\u0645\u0646\u06AF\u0644","Wednesday":"\u0628\u062F\u06BE","Thursday":"\u062C\u0645\u0639\u0631\u0627\u062A","Friday":"\u062C\u0645\u0639\u06C1","Saturday":"\u06C1\u0641\u062A\u06C1","Powered By":"\u06A9\u06CC \u0637\u0631\u0641 \u0633\u06D2 \u0637\u0627\u0642\u062A","Aggregated Transaction":"\u0645\u062C\u0645\u0648\u0639\u06CC \u0644\u06CC\u0646 \u062F\u06CC\u0646","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":[["swapper"],"\u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 ",["fromChain"]," \u067E\u0631 \u062A\u0628\u0627\u062F\u0644\u06C1 \u06A9\u0631\u06CC\u06BA\u06D4"],"Bridge to {toChain} via {swapper}":[["swapper"],"\u06A9\u06D2 \u0630\u0631\u06CC\u0639\u06D2 ",["toChain"]," \u067E\u0631 \u067E\u0644"],"Completed":"\u0645\u06A9\u0645\u0644","In progress":"\u062C\u0627\u0631\u06CC \u06C1\u06D2\u06D4","Waiting for bridge transaction":"\u067E\u0644 \u06A9\u06D2 \u0644\u06CC\u0646 \u062F\u06CC\u0646 \u06A9\u0627 \u0627\u0646\u062A\u0638\u0627\u0631 \u06C1\u06D2\u06D4","Connected":"\u062C\u0691\u0627 \u06C1\u0648\u0627","Disconnect":"\u0645\u0646\u0642\u0637\u0639 \u06A9\u0631\u0646\u0627","Install":"\u0627\u0646\u0633\u0679\u0627\u0644 \u06A9\u0631\u06CC\u06BA\u06D4","Connecting ...":"\u0645\u0646\u0633\u0644\u06A9 \u06C1\u0648 \u0631\u06C1\u0627 \u06C1\u06D2...","Connecting":"\u062C\u0691 \u0631\u06C1\u0627 \u06C1\u06D2\u06D4","Disconnected":"\u0645\u0646\u0642\u0637\u0639","you need to pass a correct state to Wallet.":"\u0622\u067E \u06A9\u0648 Wallet \u0645\u06CC\u06BA \u0627\u06CC\u06A9 \u062F\u0631\u0633\u062A \u062D\u0627\u0644\u062A \u0645\u0646\u062A\u0642\u0644 \u06A9\u0631\u0646\u06D2 \u06A9\u06CC \u0636\u0631\u0648\u0631\u062A \u06C1\u06D2\u06D4","There are no notifications.":"\u06A9\u0648\u0626\u06CC \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0646\u06C1\u06CC\u06BA \u06C1\u06CC\u06BA\u06D4","Clear all":"\u0633\u0628 \u0635\u0627\u0641 \u06A9\u0631\u06CC\u06BA\u06D4","Balance":"\u062A\u0648\u0627\u0632\u0646","Max":"\u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1"}');


/*eslint-disable*/ const $007398226015d860$export$defe85febe8b728c = JSON.parse('{"No results found":"Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 n\xe0o","Try using different keywords":"H\xe3y th\u1EED s\u1EED d\u1EE5ng c\xe1c t\u1EEB kh\xf3a kh\xe1c nhau","Select Chain":"Ch\u1ECDn chu\u1ED7i","All":"T\u1EA5t c\u1EA3","More +{count}":["Th\xeam +",["count"]],"Activate this tab":"K\xedch ho\u1EA1t tab n\xe0y","Another tab is open and handles transactions.":"M\u1ED9t tab kh\xe1c \u0111ang m\u1EDF v\xe0 x\u1EED l\xfd c\xe1c giao d\u1ECBch.","Activate current tab":"K\xedch ho\u1EA1t tab hi\u1EC7n t\u1EA1i","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"Hi\u1EC7n t\u1EA1i, m\u1ED9t s\u1ED1 giao d\u1ECBch \u0111ang ch\u1EA1y v\xe0 \u0111\u01B0\u1EE3c x\u1EED l\xfd b\u1EDFi tab tr\xecnh duy\u1EC7t kh\xe1c. N\u1EBFu b\u1EA1n k\xedch ho\u1EA1t tab n\xe0y, t\u1EA5t c\u1EA3 c\xe1c giao d\u1ECBch \u0111\xe3 \u1EDF b\u01B0\u1EDBc k\xfd giao d\u1ECBch s\u1EBD h\u1EBFt h\u1EA1n.","Confirm":"X\xe1c nh\u1EADn","Your {blockchainName} wallets":["V\xed ",["blockchainName"]," c\u1EE7a b\u1EA1n"],"Insufficient account balance":"S\u1ED1 d\u01B0 t\xe0i kho\u1EA3n kh\xf4ng \u0111\u1EE7","Proceed anyway":"Ti\u1EBFn h\xe0nh d\xf9 sao \u0111i n\u1EEFa","You need to connect a {blockchainName} wallet.":["B\u1EA1n c\u1EA7n k\u1EBFt n\u1ED1i v\xed ",["blockchainName"]," ."],"Add {chain} chain":["Th\xeam chu\u1ED7i ",["chain"]],"Show more wallets":"Hi\u1EC3n th\u1ECB th\xeam v\xed","Send to a different address":"G\u1EEDi \u0111\u1EBFn m\u1ED9t \u0111\u1ECBa ch\u1EC9 kh\xe1c","Enter {blockchainName} address":["Nh\u1EADp \u0111\u1ECBa ch\u1EC9 ",["blockchainName"]],"Address {destination} doesn\'t match the blockchain address pattern.":["\u0110\u1ECBa ch\u1EC9 ",["destination"]," kh\xf4ng kh\u1EDBp v\u1EDBi m\u1EABu \u0111\u1ECBa ch\u1EC9 blockchain."],"via":"th\xf4ng qua","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"M\xe3 th\xf4ng b\xe1o n\xe0y kh\xf4ng xu\u1EA5t hi\u1EC7n trong danh s\xe1ch m\xe3 th\xf4ng b\xe1o \u0111ang ho\u1EA1t \u0111\u1ED9ng. H\xe3y \u0111\u1EA3m b\u1EA3o \u0111\xe2y l\xe0 m\xe3 th\xf4ng b\xe1o m\xe0 b\u1EA1n mu\u1ED1n giao d\u1ECBch.","Import":"Nh\u1EADp kh\u1EA9u","Status":"Tr\u1EA1ng th\xe1i","Reset":"C\xe0i l\u1EA1i","Cancel":"H\u1EE7y b\u1ECF","Refresh":"L\xe0m cho kh\u1ECFe l\u1EA1i","Notifications":"Th\xf4ng b\xe1o","Settings":"C\xe0i \u0111\u1EB7t","History":"L\u1ECBch s\u1EED","Connect Wallet":"K\u1EBFt n\u1ED1i v\xed","Today":"H\xf4m nay","Swaps steps":"C\xe1c b\u01B0\u1EDBc ho\xe1n \u0111\u1ED5i","Retry":"Th\u1EED l\u1EA1i","Slippage Error":"L\u1ED7i tr\u01B0\u1EE3t","Slippage Warning":"C\u1EA3nh b\xe1o tr\u01B0\u1EE3t","Bridge Limit Error":"L\u1ED7i gi\u1EDBi h\u1EA1n c\u1EA7u","Yours: {amount} {symbol}":["C\u1EE7a b\u1EA1n: ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u0110\u1ED9 tr\u01B0\u1EE3t t\u1ED1i thi\u1EC3u c\u1EA7n thi\u1EBFt: ",["minRequiredSlippage"]],"Yours: {userSlippage}":["C\u1EE7a b\u1EA1n: ",["userSlippage"]],"See All Routes":"Xem t\u1EA5t c\u1EA3 c\xe1c tuy\u1EBFn \u0111\u01B0\u1EDDng","View more info":"Xem th\xeam th\xf4ng tin","Gas & Fee Explanation":"Gi\u1EA3i th\xedch v\u1EC1 Gas & Ph\xed","Details":"Chi ti\u1EBFt","Total Payable Fee":"T\u1ED5ng ph\xed ph\u1EA3i tr\u1EA3","Hide non-payable fees":"\u1EA8n c\xe1c kho\u1EA3n ph\xed kh\xf4ng ph\u1EA3i tr\u1EA3","Show non-payable fees":"Hi\u1EC3n th\u1ECB c\xe1c kho\u1EA3n ph\xed kh\xf4ng ph\u1EA3i tr\u1EA3","Description":"S\u1EF1 mi\xeau t\u1EA3","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"C\xe1c lo\u1EA1i ph\xed sau \u0111\xe2y \u0111\u01B0\u1EE3c t\xednh v\xe0o k\u1EBFt qu\u1EA3 giao d\u1ECBch v\xe0\\n                b\u1EA1n s\u1EBD kh\xf4ng c\u1EA7n ph\u1EA3i tr\u1EA3 th\xeam ph\xed gas cho ch\xfang.","Swap input":"Ho\xe1n \u0111\u1ED5i \u0111\u1EA7u v\xe0o","Estimated output":"S\u1EA3n l\u01B0\u1EE3ng \u01B0\u1EDBc t\xednh","Via:":"Th\xf4ng qua:","Chains:":"Chu\u1ED7i:","Sort by":"S\u1EAFp x\u1EBFp theo","Smart Routing":"L\u1ED9 tr\xecnh th\xf4ng minh","Lowest Fee":"Ph\xed th\u1EA5p nh\u1EA5t","Fastest Transfer":"Chuy\u1EC3n kho\u1EA3n nhanh nh\u1EA5t","Maximum Return":"L\u1EE3i nhu\u1EADn t\u1ED1i \u0111a","Maximum Output":"\u0110\u1EA7u ra t\u1ED1i \u0111a","Swapping":"Trao \u0111\u1ED5i","Gas cost":"Chi ph\xed gas","Receiving":"Nh\u1EADn \u0111\u01B0\u1EE3c","Price impact":"T\xe1c \u0111\u1ED9ng gi\xe1","You need to increase slippage to at least {minRequiredSlippage} for this route.":["B\u1EA1n c\u1EA7n t\u0103ng \u0111\u1ED9 tr\u01B0\u1EE3t l\xean \xedt nh\u1EA5t ",["minRequiredSlippage"]," cho tuy\u1EBFn \u0111\u01B0\u1EDDng n\xe0y."],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["Ch\xfang t\xf4i khuy\xean b\u1EA1n n\xean t\u0103ng \u0111\u1ED9 tr\u01B0\u1EE3t l\xean \xedt nh\u1EA5t l\xe0 ",["minRequiredSlippage"]," cho tuy\u1EBFn \u0111\u01B0\u1EDDng n\xe0y."],"Caution, your slippage is high.":"C\u1EA9n th\u1EADn, \u0111\u1ED9 tr\u01B0\u1EE3t c\u1EE7a b\u1EA1n kh\xe1 cao.","Change":"Thay \u0111\u1ED5i","Change settings":"Thay \u0111\u1ED5i c\xe0i \u0111\u1EB7t","High slippage":"\u0110\u1ED9 tr\u01B0\u1EE3t cao","Low slippage":"\u0110\u1ED9 tr\u01B0\u1EE3t th\u1EA5p"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" Th\u1EADn tr\u1ECDng, \u0111\u1ED9 tr\u01B0\u1EE3t gi\xe1 c\u1EE7a b\u1EA1n cao (=",["userSlippage"],"). Giao d\u1ECBch c\u1EE7a b\u1EA1n c\xf3 th\u1EC3 b\u1ECB ch\u1EA1y tr\u01B0\u1EDBc."],"Confirm anyway":"X\xe1c nh\u1EADn d\xf9 sao","Something went wrong":"C\xf3 g\xec \u0111\xf3 kh\xf4ng \u1ED5n","Something went wrong. Please refresh the app.":"C\xf3 l\u1ED7i x\u1EA3y ra. Vui l\xf2ng l\xe0m m\u1EDBi \u1EE9ng d\u1EE5ng.","Slippage tolerance per swap":"\u0110\u1ED9 tr\u01B0\u1EE3t cho m\u1ED7i l\u1EA7n ho\xe1n \u0111\u1ED5i","Custom":"Phong t\u1EE5c","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"Giao d\u1ECBch c\u1EE7a b\u1EA1n s\u1EBD b\u1ECB h\u1EE7y n\u1EBFu gi\xe1 thay \u0111\u1ED5i b\u1EA5t l\u1EE3i h\u01A1n m\u1EE9c ph\u1EA7n tr\u0103m n\xe0y.","Warning":"C\u1EA3nh b\xe1o","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"C\xe0i \u0111\u1EB7t n\xe0y \u0111\u01B0\u1EE3c \xe1p d\u1EE5ng cho t\u1EEBng b\u01B0\u1EDBc (v\xed d\u1EE5: 1Inch, Thorchain, v.v.), ngh\u0129a l\xe0 ch\u1EC9 b\u01B0\u1EDBc c\u1EE5 th\u1EC3 \u0111\xf3 s\u1EBD \u0111\u01B0\u1EE3c ho\xe0n nguy\xean ch\u1EE9 kh\xf4ng ph\u1EA3i to\xe0n b\u1ED9 l\u1ED9 tr\xecnh.","Swap Details":"Chi ti\u1EBFt trao \u0111\u1ED5i","Request ID":"Y\xeau c\u1EA7u ID","Not found":"Kh\xf4ng t\xecm th\u1EA5y","Swap with request ID = {requestId} not found.":["Kh\xf4ng t\xecm th\u1EA5y ho\xe1n \u0111\u1ED5i v\u1EDBi ID y\xeau c\u1EA7u = ",["requestId"]," ."],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["B\u1EA1n \u0111\xe3 nh\u1EADn \u0111\u01B0\u1EE3c ",["amount"]," ",["token"]," trong v\xed ",["conciseAddress"]," tr\xean chu\u1ED7i ",["chain"]," ."],"Transaction was not sent.":"Giao d\u1ECBch kh\xf4ng \u0111\u01B0\u1EE3c g\u1EEDi.","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," tr\xean ",["blockchain"]," v\u1EABn c\xf2n trong v\xed c\u1EE7a b\u1EA1n."],"Delete":"X\xf3a b\u1ECF","Try again":"Th\u1EED l\u1EA1i","Copied To Clipboard":"\u0110\xe3 sao ch\xe9p v\xe0o b\u1EA3ng t\u1EA1m","Copy Request ID":"Sao ch\xe9p ID y\xeau c\u1EA7u","View on Rango Explorer":"Xem tr\xean Rango Explorer","Finished at":"Ho\xe0n th\xe0nh t\u1EA1i","Created at":"\u0110\u01B0\u1EE3c t\u1EA1o ra t\u1EA1i","View transaction":"Xem giao d\u1ECBch","Connect":"K\u1EBFt n\u1ED1i","Swap Successful":"Ho\xe1n \u0111\u1ED5i th\xe0nh c\xf4ng","Transaction Failed":"Giao d\u1ECBch kh\xf4ng th\xe0nh c\xf4ng","Done":"Xong","Diagnosis":"Ch\u1EA9n \u0111o\xe1n","See Details":"Xem chi ti\u1EBFt","Cancel Swap":"H\u1EE7y b\u1ECF ho\xe1n \u0111\u1ED5i","Are you sure you want to cancel this swap?":"B\u1EA1n c\xf3 ch\u1EAFc ch\u1EAFn mu\u1ED1n h\u1EE7y giao d\u1ECBch ho\xe1n \u0111\u1ED5i n\xe0y kh\xf4ng?","Yes, Cancel it":"C\xf3, H\u1EE7y n\xf3","No, Continue":"Kh\xf4ng, Ti\u1EBFp t\u1EE5c","Delete Transaction":"X\xf3a giao d\u1ECBch","Are you sure you want to delete this swap?":"B\u1EA1n c\xf3 ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xf3a ho\xe1n \u0111\u1ED5i n\xe0y kh\xf4ng?","Yes, Delete it":"C\xf3, x\xf3a n\xf3 \u0111i","No, Cancel":"Kh\xf4ng, H\u1EE7y b\u1ECF","Change Network":"Thay \u0111\u1ED5i m\u1EA1ng","Network Changed":"M\u1EA1ng \u0111\xe3 thay \u0111\u1ED5i","Select Token":"Ch\u1ECDn M\xe3 th\xf4ng b\xe1o","Wallet Connected":"V\xed \u0111\xe3 k\u1EBFt n\u1ED1i","Your wallet is connected, you can use it to swap.":"V\xed c\u1EE7a b\u1EA1n \u0111\xe3 \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i, b\u1EA1n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng n\xf3 \u0111\u1EC3 ho\xe1n \u0111\u1ED5i.","Failed to Connect":"Kh\xf4ng th\u1EC3 k\u1EBFt n\u1ED1i","Your wallet is not connected. Please try again.":"V\xed c\u1EE7a b\u1EA1n ch\u01B0a \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i. Vui l\xf2ng th\u1EED l\u1EA1i.","Connecting to your wallet":"K\u1EBFt n\u1ED1i v\u1EDBi v\xed c\u1EE7a b\u1EA1n","Click connect in your wallet popup.":"Nh\u1EA5p v\xe0o k\u1EBFt n\u1ED1i trong c\u1EEDa s\u1ED5 b\u1EADt l\xean c\u1EE7a v\xed.","Select Derivation Path":"Ch\u1ECDn \u0110\u01B0\u1EDDng d\u1EABn d\u1EABn xu\u1EA5t","In order to connect to {type}, you must first select a Derivation Path":["\u0110\u1EC3 k\u1EBFt n\u1ED1i v\u1EDBi ",["type"],", tr\u01B0\u1EDBc ti\xean b\u1EA1n ph\u1EA3i ch\u1ECDn \u0110\u01B0\u1EDDng d\u1EABn ph\xe1i sinh"],"Choose Derivation Path Template":"Ch\u1ECDn m\u1EABu \u0111\u01B0\u1EDDng d\u1EABn d\u1EABn xu\u1EA5t","Enter Path":"Nh\u1EADp \u0110\u01B0\u1EDDng d\u1EABn","Enter Index":"Nh\u1EADp ch\u1EC9 m\u1EE5c","Add {blockchainDisplayName} Chain":["Th\xeam ",["blockchainDisplayName"]," Chu\u1ED7i"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["B\u1EA1n c\xf3 mu\u1ED1n th\xeam chu\u1ED7i th\u1EED nghi\u1EC7m ",["blockchainDisplayName"]," v\xe0o v\xed c\u1EE7a m\xecnh kh\xf4ng?"],"Please approve the experimental chain pop-up in your wallet.":"Vui l\xf2ng ch\u1EA5p thu\u1EADn c\u1EEDa s\u1ED5 b\u1EADt l\xean chu\u1ED7i th\u1EED nghi\u1EC7m trong v\xed c\u1EE7a b\u1EA1n.","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u0110\xe3 th\xeam chu\u1ED7i"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":["Chu\u1ED7i ",["blockchainDisplayName"]," \u0111\xe3 \u0111\u01B0\u1EE3c th\xeam th\xe0nh c\xf4ng v\xe0o v\xed c\u1EE7a b\u1EA1n."],"Request Rejected":"Y\xeau c\u1EA7u b\u1ECB t\u1EEB ch\u1ED1i","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["B\u1EA1n \u0111\xe3 t\u1EEB ch\u1ED1i th\xeam chu\u1ED7i ",["blockchainDisplayName"]," v\xe0o v\xed c\u1EE7a m\xecnh."],"Select chain types":"Ch\u1ECDn lo\u1EA1i chu\u1ED7i","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"V\xed n\xe0y h\u1ED7 tr\u1EE3 nhi\u1EC1u chu\u1ED7i. Ch\u1ECDn chu\u1ED7i b\u1EA1n mu\u1ED1n k\u1EBFt n\u1ED1i.","Failed Network, Please retry your swap.":"M\u1EA1ng b\u1ECB l\u1ED7i, vui l\xf2ng th\u1EED l\u1EA1i vi\u1EC7c ho\xe1n \u0111\u1ED5i.","Please reset your liquidity sources.":"Vui l\xf2ng thi\u1EBFt l\u1EADp l\u1EA1i ngu\u1ED3n thanh kho\u1EA3n c\u1EE7a b\u1EA1n.","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"B\u1EA1n \u0111\xe3 gi\u1EDBi h\u1EA1n c\xe1c ngu\u1ED3n thanh kho\u1EA3n v\xe0 \u0111i\u1EC1u n\xe0y c\xf3 th\u1EC3 khi\u1EBFn Rango kh\xf4ng t\xecm th\u1EA5y \u0111\u01B0\u1EDDng \u0111i. Vui l\xf2ng c\xe2n nh\u1EAFc thi\u1EBFt l\u1EADp l\u1EA1i c\xe1c ngu\u1ED3n thanh kho\u1EA3n c\u1EE7a b\u1EA1n.","No Routes Found.":"Kh\xf4ng t\xecm th\u1EA5y tuy\u1EBFn \u0111\u01B0\u1EDDng n\xe0o.","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"L\xfd do Rango kh\xf4ng t\xecm \u0111\u01B0\u1EE3c tuy\u1EBFn \u0111\u01B0\u1EDDng: t\xednh thanh kho\u1EA3n c\u1EE7a token th\u1EA5p, l\u01B0\u1EE3ng \u0111\u1EA7u v\xe0o r\u1EA5t th\u1EA5p ho\u1EB7c kh\xf4ng c\xf3 tuy\u1EBFn \u0111\u01B0\u1EDDng n\xe0o kh\u1EA3 d\u1EE5ng cho t\u1ED5 h\u1EE3p token \u0111\u1EA7u v\xe0o/\u0111\u1EA7u ra \u0111\xe3 ch\u1ECDn.","Bridge Limit Error: Please increase your amount.":"L\u1ED7i gi\u1EDBi h\u1EA1n c\u1EA7u: Vui l\xf2ng t\u0103ng s\u1ED1 ti\u1EC1n c\u1EE7a b\u1EA1n.","Bridge Limit Error: Please decrease your amount.":"L\u1ED7i gi\u1EDBi h\u1EA1n c\u1EA7u: Vui l\xf2ng gi\u1EA3m s\u1ED1 ti\u1EC1n c\u1EE7a b\u1EA1n.","High Price Impact":"T\xe1c \u0111\u1ED9ng gi\xe1 cao","Price impact is too high!":"T\xe1c \u0111\u1ED9ng \u0111\u1EBFn gi\xe1 qu\xe1 cao!","The price impact is significantly higher than the allowed amount.":"T\xe1c \u0111\u1ED9ng \u0111\u1EBFn gi\xe1 c\u1EA3 cao h\u01A1n \u0111\xe1ng k\u1EC3 so v\u1EDBi m\u1EE9c cho ph\xe9p.","Confirm high price impact":"X\xe1c nh\u1EADn t\xe1c \u0111\u1ED9ng gi\xe1 cao","Route updated and price impact is too high, try again later!":"Tuy\u1EBFn \u0111\u01B0\u1EDDng \u0111\xe3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt v\xe0 gi\xe1 c\u1EA3 b\u1ECB \u1EA3nh h\u01B0\u1EDFng qu\xe1 cao, h\xe3y th\u1EED l\u1EA1i sau!","USD Price Unknown":"Gi\xe1 USD Kh\xf4ng r\xf5","USD Price Unknown, Cannot calculate Price Impact.":"Gi\xe1 USD kh\xf4ng x\xe1c \u0111\u1ECBnh, kh\xf4ng th\u1EC3 t\xednh \u0111\u01B0\u1EE3c t\xe1c \u0111\u1ED9ng gi\xe1.","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"Gi\xe1 USD kh\xf4ng x\xe1c \u0111\u1ECBnh, Kh\xf4ng th\u1EC3 t\xednh t\xe1c \u0111\u1ED9ng gi\xe1. T\xe1c \u0111\u1ED9ng gi\xe1 c\xf3 th\u1EC3 cao h\u01A1n b\xecnh th\u01B0\u1EDDng. B\u1EA1n c\xf3 ch\u1EAFc ch\u1EAFn mu\u1ED1n ti\u1EBFp t\u1EE5c ho\xe1n \u0111\u1ED5i kh\xf4ng?","Confirm USD Price Unknown":"X\xe1c nh\u1EADn gi\xe1 USD Kh\xf4ng r\xf5","Swap":"Tr\xe1o \u0111\u1ED5i","Swap anyway":"D\xf9 sao th\xec c\u0169ng \u0111\u1ED5i","The route goes through Ethereum. Continue?":"Tuy\u1EBFn \u0111\u01B0\u1EDDng \u0111i qua Ethereum. Ti\u1EBFp t\u1EE5c?","Route has been updated.":"Tuy\u1EBFn \u0111\u01B0\u1EDDng \u0111\xe3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["L\u01B0\u1EE3ng \u0111\u1EA7u ra \u0111\xe3 thay \u0111\u1ED5i th\xe0nh ",["newOutputAmount"]," (",["percentageChange"],"% thay \u0111\u1ED5i)."],"Route swappers has been updated.":"C\xf4ng c\u1EE5 ho\xe1n \u0111\u1ED5i tuy\u1EBFn \u0111\u01B0\u1EDDng \u0111\xe3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.","Route internal coins has been updated.":"Tuy\u1EBFn ti\u1EC1n n\u1ED9i b\u1ED9 \u0111\xe3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.","Routes":"Tuy\u1EBFn \u0111\u01B0\u1EDDng","From":"T\u1EEB","To":"\u0110\u1EBEN","Light":"\xc1nh s\xe1ng","Dark":"T\u1ED1i t\u0103m","Auto":"T\u01B0\u0323 \u0111\xf4\u0323ng","Loading failed":"T\u1EA3i kh\xf4ng th\xe0nh c\xf4ng","Bridges":"C\u1EA7u","Exchanges":"Trao \u0111\u1ED5i","Custom Tokens":"M\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh","Language":"Ng\xf4n ng\u1EEF","Infinite approval":"S\u1EF1 ch\u1EA5p thu\u1EADn v\xf4 h\u1EA1n","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"B\u1EADt ch\u1EBF \u0111\u1ED9 \'Ph\xea duy\u1EC7t v\xf4 h\u1EA1n\' s\u1EBD c\u1EA5p quy\u1EC1n truy c\u1EADp kh\xf4ng gi\u1EDBi h\u1EA1n v\xe0o c\xe1c h\u1EE3p \u0111\u1ED3ng th\xf4ng minh c\u01A1 b\u1EA3n, cho ph\xe9p ch\xfang s\u1EED d\u1EE5ng s\u1ED1 l\u01B0\u1EE3ng m\xe3 th\xf4ng b\xe1o \u0111\xe3 \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t m\xe0 kh\xf4ng c\xf3 gi\u1EDBi h\u1EA1n.","Theme":"Ch\u1EE7 \u0111\u1EC1","Duplicate Token":"M\xe3 th\xf4ng b\xe1o tr\xf9ng l\u1EB7p","The address you entered is duplicate, please enter a new address.":"\u0110\u1ECBa ch\u1EC9 b\u1EA1n nh\u1EADp b\u1ECB tr\xf9ng l\u1EB7p, vui l\xf2ng nh\u1EADp \u0111\u1ECBa ch\u1EC9 m\u1EDBi.","Token Already Exists":"M\xe3 th\xf4ng b\xe1o \u0111\xe3 t\u1ED3n t\u1EA1i","There\'s no need to add this token again because it already exists and is supported by us.":"Kh\xf4ng c\u1EA7n ph\u1EA3i th\xeam m\xe3 th\xf4ng b\xe1o n\xe0y n\u1EEFa v\xec n\xf3 \u0111\xe3 t\u1ED3n t\u1EA1i v\xe0 \u0111\u01B0\u1EE3c ch\xfang t\xf4i h\u1ED7 tr\u1EE3.","Token Not Found":"Kh\xf4ng t\xecm th\u1EA5y m\xe3 th\xf4ng b\xe1o","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["Xin l\u1ED7i, kh\xf4ng t\xecm th\u1EA5y m\xe3 th\xf4ng b\xe1o n\xe0o tr\xean chu\u1ED7i ",["blockchain"]," c\xf3 \u0111\u1ECBa ch\u1EC9 \u0111\u01B0\u1EE3c cung c\u1EA5p. Vui l\xf2ng \u0111\u1EA3m b\u1EA3o r\u1EB1ng b\u1EA1n \u0111\xe3 nh\u1EADp \u0111\xfang \u0111\u1ECBa ch\u1EC9 m\xe3 th\xf4ng b\xe1o."],"Network Error":"L\u1ED7i m\u1EA1ng","Add Custom Token":"Th\xeam M\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh","Select chain":"Ch\u1ECDn chu\u1ED7i","Enter Address":"Nh\u1EADp \u0110\u1ECBa Ch\u1EC9","Enter token address":"Nh\u1EADp \u0111\u1ECBa ch\u1EC9 m\xe3 th\xf4ng b\xe1o","Failed Network, Please retry.":"M\u1EA1ng b\u1ECB l\u1ED7i, vui l\xf2ng th\u1EED l\u1EA1i.","Add another custom token":"Th\xeam m\u1ED9t m\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh kh\xe1c","Confirm Swap":"X\xe1c nh\u1EADn ho\xe1n \u0111\u1ED5i","Start Swap":"B\u1EAFt \u0111\u1EA7u ho\xe1n \u0111\u1ED5i","You get":"B\u1EA1n nh\u1EADn \u0111\u01B0\u1EE3c","Search Token":"T\xecm ki\u1EBFm M\xe3 th\xf4ng b\xe1o","No custom tokens":"Kh\xf4ng c\xf3 m\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh","press the button to add your custom token":"nh\u1EA5n n\xfat \u0111\u1EC3 th\xeam m\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh c\u1EE7a b\u1EA1n","Delete Custom Token":"X\xf3a M\xe3 th\xf4ng b\xe1o t\xf9y ch\u1EC9nh","Are you sure you want to Delete this Token?":"B\u1EA1n c\xf3 ch\u1EAFc ch\u1EAFn mu\u1ED1n x\xf3a m\xe3 th\xf4ng b\xe1o n\xe0y kh\xf4ng?","Complete":"Ho\xe0n th\xe0nh","Running":"\u0110ang ch\u1EA1y","Failed":"Th\u1EA5t b\u1EA1i","Clear":"Th\xf4ng tho\xe1ng","Search Transaction":"T\xecm ki\u1EBFm giao d\u1ECBch","No transactions":"Kh\xf4ng c\xf3 giao d\u1ECBch","Your transaction history is stored locally and will appear here after you start a swap":"L\u1ECBch s\u1EED giao d\u1ECBch c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF c\u1EE5c b\u1ED9 v\xe0 s\u1EBD xu\u1EA5t hi\u1EC7n \u1EDF \u0111\xe2y sau khi b\u1EA1n b\u1EAFt \u0111\u1EA7u ho\xe1n \u0111\u1ED5i","Clear Transaction History":"X\xf3a L\u1ECBch s\u1EED giao d\u1ECBch","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"Ti\u1EBFn h\xe0nh s\u1EBD x\xf3a t\u1EA5t c\u1EA3 c\xe1c giao d\u1ECBch th\xe0nh c\xf4ng v\xe0 th\u1EA5t b\u1EA1i kh\u1ECFi ti\u1EC7n \xedch. B\u1EA1n c\xf3 mu\u1ED1n ti\u1EBFp t\u1EE5c kh\xf4ng?","Note: This does not erase your transaction history on the chain; it only removes them here.":"L\u01B0u \xfd: Thao t\xe1c n\xe0y kh\xf4ng x\xf3a l\u1ECBch s\u1EED giao d\u1ECBch c\u1EE7a b\u1EA1n tr\xean chu\u1ED7i; n\xf3 ch\u1EC9 x\xf3a ch\xfang t\u1EA1i \u0111\xe2y.","Yes, Clear the history":"C\xf3, X\xf3a l\u1ECBch s\u1EED","language":"ng\xf4n ng\u1EEF","Deselect all":"B\u1ECF ch\u1ECDn t\u1EA5t c\u1EA3","Select all":"Ch\u1ECDn t\u1EA5t c\u1EA3","Search {sourceType}":["T\xecm ki\u1EBFm ",["sourceType"]],"Search Chain":"Chu\u1ED7i t\xecm ki\u1EBFm","Source":"Ngu\u1ED3n","Destination":"\u0110i\u1EC3m \u0111\u1EBFn","Swap {type}":["Ho\xe1n \u0111\u1ED5i ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"Hi\u1EC7n t\u1EA1i, b\u1EA1n \u0111ang \u1EDF ch\u1EBF \u0111\u1ED9 chi\u1EBFn d\u1ECBch v\u1EDBi c\xe1c h\u1EA1n ch\u1EBF v\u1EC1 ngu\u1ED3n thanh kho\u1EA3n. B\u1EA1n c\xf3 mu\u1ED1n tho\xe1t kh\u1ECFi ch\u1EBF \u0111\u1ED9 n\xe0y v\xe0 s\u1EED d\u1EE5ng t\u1EA5t c\u1EA3 c\xe1c ngu\u1ED3n thanh kho\u1EA3n kh\u1EA3 d\u1EE5ng kh\xf4ng?","The request ID is necessary to display the swap details.":"ID y\xeau c\u1EA7u l\xe0 c\u1EA7n thi\u1EBFt \u0111\u1EC3 hi\u1EC3n th\u1ECB th\xf4ng tin chi ti\u1EBFt v\u1EC1 giao d\u1ECBch ho\xe1n \u0111\u1ED5i.","Connect Wallets":"K\u1EBFt n\u1ED1i v\xed","Choose a wallet to connect.":"Ch\u1ECDn v\xed \u0111\u1EC3 k\u1EBFt n\u1ED1i.","This week":"Tu\u1EA7n n\xe0y","This month":"Th\xe1ng n\xe0y","This year":"N\u0103m nay","Required: >= {min} {symbol}":["B\u1EAFt bu\u1ED9c: >= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["B\u1EAFt bu\u1ED9c: > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["B\u1EAFt bu\u1ED9c: <= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["B\u1EAFt bu\u1ED9c: < ",["max"]," ",["symbol"]]," for network fee":" cho ph\xed m\u1EA1ng"," for swap":" \u0111\u1EC3 trao \u0111\u1ED5i"," for input and network fee":" cho ph\xed \u0111\u1EA7u v\xe0o v\xe0 ph\xed m\u1EA1ng","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["C\u1EA7n \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],", nh\u01B0ng b\u1EA1n c\xf3 ",["currentAmount"]," ",["symbol"]," trong v\xed ",["blockchain"]," c\u1EE7a m\xecnh."],"Waiting for connecting wallet":"\u0110ang ch\u1EDD k\u1EBFt n\u1ED1i v\xed","Waiting for other running tasks to be finished":"\u0110ang ch\u1EDD c\xe1c t\xe1c v\u1EE5 \u0111ang ch\u1EA1y kh\xe1c ho\xe0n t\u1EA5t","Waiting for changing wallet network":"\u0110ang ch\u1EDD thay \u0111\u1ED5i m\u1EA1ng v\xed","Sunday":"Ch\u1EE7 nh\u1EADt","Monday":"Th\u1EE9 hai","Tuesday":"Th\u1EE9 ba","Wednesday":"Th\u1EE9 T\u01B0","Thursday":"Th\u1EE9 n\u0103m","Friday":"Th\u1EE9 s\xe1u","Saturday":"Th\u1EE9 b\u1EA3y","Powered By":"\u0110\u01B0\u1EE3c cung c\u1EA5p b\u1EDFi","Aggregated Transaction":"Giao d\u1ECBch t\u1ED5ng h\u1EE3p","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u0110\u1ED5i tr\xean ",["fromChain"]," qua ",["swapper"]],"Bridge to {toChain} via {swapper}":["C\u1EA7u n\u1ED1i \u0111\u1EBFn ",["toChain"]," qua ",["swapper"]],"Completed":"Ho\xe0n th\xe0nh","In progress":"\u0110ang ti\u1EBFn h\xe0nh","Waiting for bridge transaction":"\u0110ang ch\u1EDD giao d\u1ECBch c\u1EA7u n\u1ED1i","Connected":"\u0110\xe3 k\u1EBFt n\u1ED1i","Disconnect":"Ng\u1EAFt k\u1EBFt n\u1ED1i","Install":"C\xe0i \u0111\u1EB7t","Connecting ...":"\u0110ang k\u1EBFt n\u1ED1i ...","Connecting":"K\u1EBFt n\u1ED1i","Disconnected":"\u0110\xe3 ng\u1EAFt k\u1EBFt n\u1ED1i","you need to pass a correct state to Wallet.":"b\u1EA1n c\u1EA7n ph\u1EA3i chuy\u1EC3n tr\u1EA1ng th\xe1i ch\xednh x\xe1c cho Wallet.","There are no notifications.":"Kh\xf4ng c\xf3 th\xf4ng b\xe1o n\xe0o.","Clear all":"X\xf3a t\u1EA5t c\u1EA3","Balance":"S\u1EF1 c\xe2n b\u1EB1ng","Max":"T\u1ED1i \u0111a"}');


/*eslint-disable*/ const $89ff72a3712b1e04$export$defe85febe8b728c = JSON.parse('{"No results found":"\u672A\u627E\u5230\u7ED3\u679C","Try using different keywords":"\u5C1D\u8BD5\u4F7F\u7528\u4E0D\u540C\u7684\u5173\u952E\u5B57","Select Chain":"\u9009\u62E9\u94FE\u6761","All":"\u6240\u6709\u7684","More +{count}":["\u66F4\u591A +",["count"]],"Activate this tab":"\u6FC0\u6D3B\u6B64\u6807\u7B7E","Another tab is open and handles transactions.":"\u53E6\u4E00\u4E2A\u6807\u7B7E\u662F\u6253\u5F00\u548C\u5904\u7406\u4EA4\u6613\u3002","Activate current tab":"\u6FC0\u6D3B\u5F53\u524D\u6807\u7B7E","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u76EE\u524D\uFF0C\u6709\u4E9B\u4EA4\u6613\u6B63\u5728\u8FD0\u884C\uFF0C\u6B63\u5728\u7531\u5176\u4ED6\u6D4F\u89C8\u5668\u9009\u9879\u5361\u5904\u7406\u3002 \u5982\u679C\u60A8\u6FC0\u6D3B\u6B64\u6807\u7B7E\uFF0C\u6240\u6709\u5DF2\u7ECF\u5728\u4EA4\u6613\u7B7E\u540D\u6B65\u9AA4\u4E2D\u7684\u4EA4\u6613\u90FD\u5C06\u8FC7\u671F\u3002","Confirm":"\u786E\u8BA4","Your {blockchainName} wallets":["\u60A8\u7684 ",["blockchainName"]," \u94B1\u5305"],"Insufficient account balance":"\u8D26\u6237\u4F59\u989D\u4E0D\u8DB3","Proceed anyway":"\u4ECD\u7136\u7EE7\u7EED","You need to connect a {blockchainName} wallet.":["\u60A8\u9700\u8981\u8FDE\u63A5\u4E00\u4E2A ",["blockchainName"]," \u94B1\u5305\u3002"],"Add {chain} chain":["\u6DFB\u52A0 ",["chain"]," \u94FE"],"Show more wallets":"\u663E\u793A\u66F4\u591A\u94B1\u5305","Send to a different address":"\u53D1\u9001\u5230\u53E6\u4E00\u4E2A\u5730\u5740","Enter {blockchainName} address":["\u8F93\u5165 ",["blockchainName"]," \u5730\u5740"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u5730\u5740 ",["destination"]," \u4E0E\u533A\u5757\u94FE\u5730\u5740\u6A21\u5F0F\u4E0D\u5339\u914D\u3002"],"via":"\u901A\u8FC7","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u6B64\u4EE4\u724C\u4E0D\u4F1A\u51FA\u73B0\u5728\u6D3B\u52A8\u4EE4\u724C\u5217\u8868\u4E2D\u3002\u8BF7\u786E\u4FDD\u8FD9\u662F\u60A8\u60F3\u8981\u4EA4\u6613\u7684\u4EE4\u724C\u3002","Import":"\u5BFC\u5165","Status":"\u72B6\u6001","Reset":"Reset","Cancel":"\u53D6\u6D88","Refresh":"\u5237\u65B0","Notifications":"\u901A\u77E5","Settings":"\u8BBE\u7F6E","History":"\u5386\u53F2\u8BB0\u5F55","Connect Wallet":"\u8FDE\u63A5\u94B1\u5305","Today":"\u4ECA\u65E5\uFF1A","Swaps steps":"\u4E92\u6362\u6B65\u9AA4","Retry":"\u91CD\u8BD5","Slippage Error":"\u7FFB\u8F6C\u9519\u8BEF","Slippage Warning":"\u7FFB\u8F6C\u8B66\u544A","Bridge Limit Error":"\u6865\u63A5\u9650\u5236\u9519\u8BEF","Yours: {amount} {symbol}":["\u4F60\u7684\uFF1A ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u6700\u4F4E\u8981\u6C42\u6ED1\u70B9\uFF1A ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u4F60\u7684\uFF1A ",["userSlippage"]],"See All Routes":"\u67E5\u770B\u6240\u6709\u8DEF\u7531","View more info":"\u67E5\u770B\u66F4\u591A\u4FE1\u606F","Gas & Fee Explanation":"\u6C14\u4F53\u548C\u8D39\u7528\u89E3\u91CA","Details":"\u8BE6\u7EC6\u4FE1\u606F","Total Payable Fee":"\u5E94\u652F\u4ED8\u8D39\u7528\u603B\u989D","Hide non-payable fees":"\u9690\u85CF\u975E\u652F\u4ED8\u8D39\u7528","Show non-payable fees":"\u663E\u793A\u975E\u5E94\u652F\u4ED8\u8D39\u7528","Description":"\u63CF\u8FF0","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"\u5728\u4EA4\u6613\u8F93\u51FA\u4E2D\u8003\u8651\u5230\u4EE5\u4E0B\u8D39\u7528\u548C\\n                \u60A8\u5C06\u4E0D\u9700\u8981\u652F\u4ED8\u989D\u5916\u7684\u6C14\u4F53\u3002","Swap input":"Swap input","Estimated output":"\u4F30\u8BA1\u8F93\u51FA","Via:":"Via\uFF1A","Chains:":"\u94FE\uFF1A","Sort by":"\u6392\u5E8F\u65B9\u5F0F","Smart Routing":"\u667A\u80FD\u8DEF\u7531","Lowest Fee":"\u6700\u4F4E\u8D39\u7528","Fastest Transfer":"\u6700\u5FEB\u7684\u4F20\u8F93","Maximum Return":"\u6700\u5927\u8FD4\u56DE","Maximum Output":"\u6700\u5927\u8F93\u51FA","Swapping":"Swapping","Gas cost":"\u7164\u6C14\u6210\u672C","Receiving":"\u63A5\u6536\u4E2D","Price impact":"\u4EF7\u683C\u5F71\u54CD","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u60A8\u9700\u8981\u5C06\u6B64\u8DEF\u7EBF\u7684\u6ED1\u79FB\u91CF\u81F3\u5C11\u589E\u52A0\u5230 ",["minRequiredSlippage"]," \u3002"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06\u6B64\u8DEF\u7EBF\u7684\u6ED1\u79FB\u91CF\u81F3\u5C11\u589E\u52A0\u5230 ",["minRequiredSlippage"]," \u3002"],"Caution, your slippage is high.":"\u6CE8\u610F\u529B\uFF0C\u60A8\u7684\u5E7B\u706F\u7247\u5F88\u9AD8\u3002","Change":"\u66F4\u6539","Change settings":"\u66F4\u6539\u8BBE\u7F6E","High slippage":"\u9AD8\u6ED1\u5757","Low slippage":"\u4F4E\u6ED1\u5757"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u5C0F\u5FC3\uFF0C\u60A8\u7684\u6ED1\u70B9\u5F88\u9AD8 (=",["userSlippage"],")\u3002\u60A8\u7684\u4EA4\u6613\u53EF\u80FD\u88AB\u62A2\u5148\u6267\u884C\u3002"],"Confirm anyway":"\u4ECD\u7136\u786E\u8BA4","Something went wrong":"\u51FA\u4E86\u9519\u3002","Something went wrong. Please refresh the app.":"\u51FA\u9519\u4E86\u3002\u8BF7\u5237\u65B0\u5E94\u7528\u7A0B\u5E8F\u3002","Slippage tolerance per swap":"\u6BCF\u6B21\u4EA4\u6362\u65F6\u7FFB\u9875\u8303\u56F4","Custom":"\u81EA\u5B9A\u4E49","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u5982\u679C\u4EF7\u683C\u53D8\u5316\u5927\u4E8E\u6B64\u767E\u5206\u6BD4\uFF0C\u60A8\u7684\u4EA4\u6613\u5C06\u4F1A\u6062\u590D\u3002","Warning":"\u8B66\u544A","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u6B64\u8BBE\u7F6E\u9002\u7528\u4E8E\u6BCF\u4E00\u6B65(\u4F8B\u59821Inch\u3001Thorchain\u7B49)\uFF0C\u53EA\u8868\u793A\u7279\u5B9A\u6B65\u9AA4\u5C06\u88AB\u8FD8\u539F\uFF0C\u800C\u4E0D\u662F\u6574\u4E2A\u8DEF\u5F84\u3002","Swap Details":"\u4EA4\u6362\u8BE6\u60C5","Request ID":"\u8BF7\u6C42ID","Not found":"\u627E\u4E0D\u5230","Swap with request ID = {requestId} not found.":["\u672A\u627E\u5230\u8BF7\u6C42 ID = ",["requestId"]," \u7684\u4EA4\u6362\u3002"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u60A8\u5DF2\u5728 ",["chain"]," \u94FE\u4E0A\u7684 ",["conciseAddress"]," \u94B1\u5305\u4E2D\u6536\u5230 ",["amount"]," ",["token"]," \u3002"],"Transaction was not sent.":"\u4EA4\u6613\u672A\u53D1\u9001\u3002","{amount} {symbol} on {blockchain} remains in your wallet.":[["amount"]," ",["symbol"]," \u548C ",["blockchain"]," \u4ECD\u7559\u5728\u60A8\u7684\u94B1\u5305\u4E2D\u3002"],"Delete":"\u5220\u9664","Try again":"\u518D\u8BD5\u4E00\u6B21","Copied To Clipboard":"\u590D\u5236\u5230\u526A\u8D34\u677F","Copy Request ID":"\u590D\u5236\u8BF7\u6C42ID","View on Rango Explorer":"\u5728Rango\u6D4F\u89C8\u5668\u4E0A\u67E5\u770B","Finished at":"\u5B8C\u6210\u4E8E","Created at":"\u521B\u5EFA\u4E8E","View transaction":"\u67E5\u770B\u4EA4\u6613","Connect":"\u8FDE\u63A5","Swap Successful":"\u4EA4\u6362\u6210\u529F","Transaction Failed":"\u4EA4\u6613\u5931\u8D25","Done":"\u5B8C\u6210","Diagnosis":"\u8BCA\u65AD\u4FE1\u606F","See Details":"\u67E5\u770B\u8BE6\u7EC6\u4FE1\u606F","Cancel Swap":"\u53D6\u6D88\u5207\u6362","Are you sure you want to cancel this swap?":"\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u6B64\u4EA4\u6362\u5417\uFF1F","Yes, Cancel it":"\u662F\uFF0C\u53D6\u6D88\u5B83","No, Continue":"\u5426\uFF0C\u7EE7\u7EED","Delete Transaction":"\u5220\u9664\u4EA4\u6613","Are you sure you want to delete this swap?":"\u60A8\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u4EA4\u6362\u5417\uFF1F","Yes, Delete it":"\u662F\uFF0C\u5220\u9664\u5B83","No, Cancel":"\u5426\uFF0C\u53D6\u6D88","Change Network":"\u66F4\u6539\u7F51\u7EDC","Network Changed":"\u7F51\u7EDC\u5DF2\u66F4\u6539","Select Token":"\u9009\u62E9\u4EE4\u724C","Wallet Connected":"\u94B1\u5305\u5DF2\u8FDE\u63A5","Your wallet is connected, you can use it to swap.":"\u60A8\u7684\u94B1\u5305\u5DF2\u8FDE\u63A5\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u5B83\u4EA4\u6362\u3002","Failed to Connect":"\u8FDE\u63A5\u5931\u8D25","Your wallet is not connected. Please try again.":"\u60A8\u7684\u94B1\u5305\u672A\u8FDE\u63A5\u3002\u8BF7\u91CD\u8BD5\u3002","Connecting to your wallet":"\u6B63\u5728\u8FDE\u63A5\u4F60\u7684\u94B1\u5305","Click connect in your wallet popup.":"\u70B9\u51FB\u5728\u4F60\u7684\u94B1\u5305\u5F39\u51FA\u7A97\u53E3\u4E2D\u8FDE\u63A5\u3002","Select Derivation Path":"\u9009\u62E9\u6D3E\u751F\u8DEF\u5F84","In order to connect to {type}, you must first select a Derivation Path":["\u4E3A\u4E86\u8FDE\u63A5\u5230 ",["type"],"\uFF0C\u4F60\u5FC5\u987B\u9996\u5148\u9009\u62E9\u4E00\u4E2A\u6D3E\u751F\u8DEF\u5F84"],"Choose Derivation Path Template":"\u9009\u62E9\u6D3E\u751F\u8DEF\u5F84\u6A21\u677F","Enter Path":"\u8F93\u5165\u8DEF\u5F84","Enter Index":"\u8F93\u5165\u7D22\u5F15","Add {blockchainDisplayName} Chain":["\u6DFB\u52A0 ",["blockchainDisplayName"]," \u94FE"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u60A8\u60F3\u5C06 ",["blockchainDisplayName"]," \u5B9E\u9A8C\u94FE\u6DFB\u52A0\u5230\u60A8\u7684\u94B1\u5305\u5417\uFF1F"],"Please approve the experimental chain pop-up in your wallet.":"\u8BF7\u6279\u51C6\u60A8\u94B1\u5305\u4E2D\u7684\u5B9E\u9A8C\u6027\u94FE\u5F39\u51FA\u7A97\u53E3\u3002","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u5DF2\u6DFB\u52A0\u94FE"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u94FE\u5DF2\u6210\u529F\u6DFB\u52A0\u5230\u60A8\u7684\u94B1\u5305\u3002"],"Request Rejected":"\u8BF7\u6C42\u88AB\u62D2\u7EDD","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u60A8\u62D2\u7EDD\u5C06 ",["blockchainDisplayName"]," \u94FE\u6DFB\u52A0\u5230\u60A8\u7684\u94B1\u5305\u3002"],"Select chain types":"\u9009\u62E9\u94FE\u7C7B\u578B","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u8FD9\u4E2A\u94B1\u5305\u652F\u6301\u591A\u4E2A\u94FE\u3002\u9009\u62E9\u4F60\u60F3\u8981\u8FDE\u63A5\u7684\u94FE\u3002","Failed Network, Please retry your swap.":"\u7F51\u7EDC\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u60A8\u7684\u4EA4\u6362\u3002","Please reset your liquidity sources.":"\u8BF7\u91CD\u7F6E\u60A8\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u60A8\u9650\u5236\u4E86\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\uFF0C\u8FD9\u53EF\u80FD\u5BFC\u81F4Rango\u627E\u4E0D\u5230\u8DEF\u5F84\u3002\u8BF7\u8003\u8651\u91CD\u7F6E\u60A8\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002","No Routes Found.":"\u672A\u627E\u5230\u8DEF\u7531\u3002","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"\u4E3A\u4EC0\u4E48Rango\u627E\u4E0D\u5230\u8DEF\u7531\uFF1A\u4EE3\u5E01\u6D41\u52A8\u6027\u4F4E\uFF0C\u8F93\u5165\u91CF\u5F88\u4F4E\uFF0C\u6216\u8005\u6CA1\u6709\u9009\u62E9\u7684\u8F93\u5165/\u8F93\u51FA\u4EE3\u5E01\u7EC4\u5408\u53EF\u7528\u7684\u8DEF\u7531\u3002","Bridge Limit Error: Please increase your amount.":"\u6865\u63A5\u9650\u5236\u9519\u8BEF\uFF1A\u8BF7\u589E\u52A0\u60A8\u7684\u91D1\u989D\u3002","Bridge Limit Error: Please decrease your amount.":"\u6865\u63A5\u9650\u5236\u9519\u8BEF\uFF1A\u8BF7\u51CF\u5C11\u60A8\u7684\u91D1\u989D\u3002","High Price Impact":"\u9AD8\u4EF7\u683C\u5F71\u54CD","Price impact is too high!":"\u4EF7\u683C\u5F71\u54CD\u8FC7\u9AD8\uFF01","The price impact is significantly higher than the allowed amount.":"\u4EF7\u683C\u5F71\u54CD\u5927\u5927\u9AD8\u4E8E\u5141\u8BB8\u7684\u6570\u989D\u3002","Confirm high price impact":"\u786E\u8BA4\u9AD8\u4EF7\u683C\u5F71\u54CD","Route updated and price impact is too high, try again later!":"\u8DEF\u7531\u66F4\u65B0\u4E14\u4EF7\u683C\u5F71\u54CD\u592A\u5927\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5","USD Price Unknown":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5","USD Price Unknown, Cannot calculate Price Impact.":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5\uFF0C\u4E0D\u80FD\u8BA1\u7B97\u4EF7\u683C\u5F71\u54CD\u3002","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u7F8E\u5143\u4EF7\u683C\u672A\u77E5\uFF0C\u4E0D\u80FD\u8BA1\u7B97\u4EF7\u683C\u5F71\u54CD\u3002\u4EF7\u683C\u5F71\u54CD\u53EF\u80FD\u9AD8\u4E8E\u901A\u5E38\u3002\u60A8\u786E\u5B9A\u8981\u7EE7\u7EED\u6389\u671F\u5417\uFF1F","Confirm USD Price Unknown":"\u786E\u8BA4\u7F8E\u5143\u4EF7\u683C\u672A\u77E5","Swap":"\u5207\u6362","Swap anyway":"\u4ECD\u7136\u5207\u6362","The route goes through Ethereum. Continue?":"\u822A\u7EBF\u7A7F\u8FC7\u592A\u592A\u7A7A\u4E86\u3002\u7EE7\u7EED\u5417\uFF1F","Route has been updated.":"\u8DEF\u7531\u5DF2\u66F4\u65B0\u3002","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u8F93\u51FA\u91CF\u53D8\u4E3A ",["newOutputAmount"]," (",["percentageChange"],"% \u53D8\u5316)\u3002"],"Route swappers has been updated.":"\u8DEF\u7531\u4EA4\u6362\u5668\u5DF2\u66F4\u65B0\u3002","Route internal coins has been updated.":"\u5185\u90E8\u786C\u5E01\u5DF2\u66F4\u65B0\u3002","Routes":"\u8DEF\u7531","From":"\u6765\u81EA","To":"\u6536\u4EF6\u4EBA","Light":"\u4EAE\u8272\u7684","Dark":"\u6DF1\u8272","Auto":"\u81EA\u52A8\u64CD\u4F5C","Loading failed":"\u52A0\u8F7D\u5931\u8D25","Bridges":"\u6865\u63A5","Exchanges":"\u4EA4\u6613","Custom Tokens":"\u81EA\u5B9A\u4E49\u4EE4\u724C","Language":"\u8BED\u8A00","Infinite approval":"\u65E0\u9650\u6279\u51C6","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u542F\u7528\u201C\u65E0\u9650\u6279\u51C6\u201D\u6A21\u5F0F\u5141\u8BB8\u65E0\u9650\u5236\u8BBF\u95EE\u57FA\u672C\u667A\u80FD\u5408\u540C\uFF0C\u5141\u8BB8\u4ED6\u4EEC\u4E0D\u53D7\u9650\u5236\u5730\u4F7F\u7528\u5DF2\u6279\u51C6\u7684\u4EE3\u5E01\u91D1\u989D\u3002","Theme":"\u4E3B\u9898","Duplicate Token":"Duplicate Token","The address you entered is duplicate, please enter a new address.":"\u60A8\u8F93\u5165\u7684\u5730\u5740\u662F\u91CD\u590D\u7684\uFF0C\u8BF7\u8F93\u5165\u4E00\u4E2A\u65B0\u5730\u5740\u3002","Token Already Exists":"\u4EE4\u724C\u5DF2\u5B58\u5728","There\'s no need to add this token again because it already exists and is supported by us.":"\u65E0\u9700\u518D\u6B21\u6DFB\u52A0\u6B64\u4EE4\u724C\uFF0C\u56E0\u4E3A\u5B83\u5DF2\u7ECF\u5B58\u5728\u5E76\u5F97\u5230\u6211\u4EEC\u7684\u652F\u6301\u3002","Token Not Found":"\u672A\u627E\u5230\u4EE4\u724C","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u62B1\u6B49\uFF0C\u5728 ",["blockchain"]," \u94FE\u4E0A\u672A\u627E\u5230\u5177\u6709\u6240\u63D0\u4F9B\u5730\u5740\u7684\u4EE3\u5E01\u3002\u8BF7\u786E\u4FDD\u60A8\u8F93\u5165\u4E86\u6B63\u786E\u7684\u4EE3\u5E01\u5730\u5740\u3002"],"Network Error":"\u7F51\u7EDC\u9519\u8BEF","Add Custom Token":"\u6DFB\u52A0\u81EA\u5B9A\u4E49\u4EE4\u724C","Select chain":"\u9009\u62E9\u94FE\u63A5","Enter Address":"\u8F93\u5165\u5730\u5740","Enter token address":"\u8F93\u5165\u4EE4\u724C\u5730\u5740","Failed Network, Please retry.":"\u7F51\u7EDC\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5\u3002","Add another custom token":"\u6DFB\u52A0\u53E6\u4E00\u4E2A\u81EA\u5B9A\u4E49\u4EE4\u724C","Confirm Swap":"\u786E\u8BA4\u5207\u6362","Start Swap":"\u542F\u52A8\u4EA4\u6362\u673A","You get":"\u4F60\u5F97\u5230\u4E86","Search Token":"\u641C\u7D22\u4EE4\u724C","No custom tokens":"\u6CA1\u6709\u81EA\u5B9A\u4E49\u4EE4\u724C","press the button to add your custom token":"\u70B9\u51FB\u6309\u94AE\u6DFB\u52A0\u60A8\u7684\u81EA\u5B9A\u4E49\u4EE4\u724C","Delete Custom Token":"\u5220\u9664\u81EA\u5B9A\u4E49\u4EE4\u724C","Are you sure you want to Delete this Token?":"\u60A8\u786E\u5B9A\u8981\u5220\u9664\u6B64\u4EE4\u724C\u5417\uFF1F","Complete":"Complete","Running":"\u6B63\u5728\u8FD0\u884C","Failed":"\u5931\u8D25","Clear":"\u6E05\u7A7A","Search Transaction":"\u641C\u7D22\u4EA4\u6613","No transactions":"\u65E0\u4EA4\u6613","Your transaction history is stored locally and will appear here after you start a swap":"\u60A8\u7684\u4EA4\u6613\u5386\u53F2\u5DF2\u5B58\u50A8\u5728\u672C\u5730\uFF0C\u5E76\u5C06\u5728\u60A8\u5F00\u59CB\u4EA4\u6362\u540E\u663E\u793A\u5728\u8FD9\u91CC","Clear Transaction History":"\u6E05\u9664\u4EA4\u6613\u8BB0\u5F55","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u7EE7\u7EED\u64CD\u4F5C\u5C06\u4ECE\u5C0F\u90E8\u4EF6\u5220\u9664\u6240\u6709\u6210\u529F\u548C\u5931\u8D25\u7684\u4EA4\u6613\u3002\u60A8\u60F3\u8981\u7EE7\u7EED\u5417\uFF1F","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u6CE8\u610F\uFF1A\u8FD9\u4E0D\u4F1A\u64E6\u9664\u60A8\u5728\u94FE\u4E0A\u7684\u4EA4\u6613\u5386\u53F2\u8BB0\u5F55\uFF1B\u5B83\u53EA\u4F1A\u5C06\u5B83\u4EEC\u79FB\u5230\u6B64\u5904\u3002","Yes, Clear the history":"\u662F\u7684\uFF0C\u6E05\u9664\u5386\u53F2\u8BB0\u5F55","language":"\u8BED\u8A00","Deselect all":"\u53D6\u6D88\u5168\u9009","Select all":"\u9009\u62E9\u6240\u6709","Search {sourceType}":["\u641C\u7D22 ",["sourceType"]],"Search Chain":"\u641C\u7D22\u94FE\u63A5","Source":"\u6765\u6E90","Destination":"\u76EE\u6807","Swap {type}":["\u4EA4\u6362 ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u76EE\u524D\uFF0C\u60A8\u6B63\u5904\u4E8E\u6D3B\u52A8\u6A21\u5F0F\uFF0C\u5E76\u4E14\u9650\u5236\u4E86\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u3002 \u60A8\u60F3\u8981\u5207\u6362\u6B64\u6A21\u5F0F\u5E76\u4F7F\u7528\u6240\u6709\u53EF\u7528\u7684\u6D41\u52A8\u8D44\u91D1\u6765\u6E90\u5417\uFF1F","The request ID is necessary to display the swap details.":"\u8BF7\u6C42ID\u662F\u663E\u793A\u4EA4\u6362\u8BE6\u7EC6\u4FE1\u606F\u6240\u5FC5\u9700\u7684\u3002","Connect Wallets":"\u8FDE\u63A5\u94B1\u5305","Choose a wallet to connect.":"\u9009\u62E9\u8981\u8FDE\u63A5\u7684\u94B1\u5305\u3002","This week":"\u672C\u5468","This month":"\u672C\u6708","This year":"\u4ECA\u5E74\uFF1A","Required: >= {min} {symbol}":["\u5FC5\u9700\uFF1A>= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u5FC5\u9700\uFF1A> ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u5FC5\u9700\uFF1A<= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u5FC5\u586B\uFF1A< ",["max"]," ",["symbol"]]," for network fee":" \u7F51\u7EDC\u8D39\u7528"," for swap":" \u6362\u884C"," for input and network fee":" \u8F93\u5165\u548C\u7F51\u7EDC\u8D39\u7528","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u9700\u8981 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\uFF0C\u4F46\u662F\u4F60\u7684 ",["blockchain"]," \u94B1\u5305\u91CC\u6709 ",["currentAmount"]," ",["symbol"],"\u3002"],"Waiting for connecting wallet":"\u6B63\u5728\u7B49\u5F85\u8FDE\u63A5\u94B1\u5305","Waiting for other running tasks to be finished":"\u7B49\u5F85\u5176\u4ED6\u6B63\u5728\u8FD0\u884C\u7684\u4EFB\u52A1\u5B8C\u6210","Waiting for changing wallet network":"\u6B63\u5728\u7B49\u5F85\u66F4\u6539\u94B1\u5305\u7F51\u7EDC","Sunday":"\u5468\u65E5","Monday":"\u5468\u4E00","Tuesday":"\u661F\u671F\u4E8C","Wednesday":"\u661F\u671F\u4E09","Thursday":"\u661F\u671F\u56DB","Friday":"\u661F\u671F\u4E94","Saturday":"\u5468\u516D","Powered By":"\u652F\u6301\u8005","Aggregated Transaction":"\u5408\u8BA1\u4EA4\u6613","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u901A\u8FC7 ",["swapper"],"\u5728 ",["fromChain"]," \u4E0A\u4EA4\u6362"],"Bridge to {toChain} via {swapper}":["\u901A\u8FC7 ",["swapper"],"\u6865\u63A5\u5230 ",["toChain"]],"Completed":"\u5DF2\u5B8C\u6210","In progress":"\u8FDB\u884C\u4E2D","Waiting for bridge transaction":"\u7B49\u5F85\u6865\u63A5\u4EA4\u6613","Connected":"\u5DF2\u8FDE\u63A5","Disconnect":"\u65AD\u5F00\u8FDE\u63A5","Install":"\u5B89\u88C5","Connecting ...":"\u6B63\u5728\u8FDE\u63A5...","Connecting":"\u6B63\u5728\u8FDE\u63A5","Disconnected":"\u65AD\u5F00\u8FDE\u63A5","you need to pass a correct state to Wallet.":"\u60A8\u9700\u8981\u5C06\u4E00\u4E2A\u6B63\u786E\u7684\u72B6\u6001\u4F20\u9012\u7ED9\u94B1\u5305\u3002","There are no notifications.":"\u6CA1\u6709\u901A\u77E5\u3002","Clear all":"\u5168\u90E8\u6E05\u9664","Balance":"\u4F59\u989D","Max":"\u6700\u5927\u503C"}');


/*eslint-disable*/ const $85c97d47197a9804$export$defe85febe8b728c = JSON.parse('{"No results found":"\u6C92\u6709\u627E\u5230\u7D50\u679C","Try using different keywords":"\u5617\u8A66\u4F7F\u7528\u4E0D\u540C\u7684\u95DC\u9375\u5B57","Select Chain":"\u9078\u64C7\u93C8\u689D","All":"\u5168\u90E8","More +{count}":["\u66F4\u591A +",["count"]],"Activate this tab":"\u555F\u52D5\u6B64\u9078\u9805\u5361","Another tab is open and handles transactions.":"\u53E6\u4E00\u500B\u9078\u9805\u5361\u5DF2\u958B\u555F\u4E26\u8655\u7406\u4EA4\u6613\u3002","Activate current tab":"\u555F\u52D5\u76EE\u524D\u9078\u9805\u5361","Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.":"\u76EE\u524D\uFF0C\u67D0\u4E9B\u4E8B\u52D9\u6B63\u5728\u904B\u884C\u4E26\u7531\u5176\u4ED6\u700F\u89BD\u5668\u9078\u9805\u5361\u8655\u7406\u3002\u5982\u679C\u60A8\u555F\u52D5\u6B64\u9078\u9805\u5361\uFF0C\u5247\u5DF2\u5728\u4EA4\u6613\u7C3D\u7F72\u6B65\u9A5F\u4E2D\u7684\u6240\u6709\u4EA4\u6613\u90FD\u5C07\u904E\u671F\u3002","Confirm":"\u78BA\u8A8D","Your {blockchainName} wallets":["\u4F60\u7684 ",["blockchainName"]," \u9322\u5305"],"Insufficient account balance":"\u5E33\u6236\u9918\u984D\u4E0D\u8DB3","Proceed anyway":"\u7121\u8AD6\u5982\u4F55\u90FD\u8981\u7E7C\u7E8C","You need to connect a {blockchainName} wallet.":["You need to connect a ",["blockchainName"]," wallet."],"Add {chain} chain":["\u52A0\u5165 ",["chain"]," \u93C8"],"Show more wallets":"\u986F\u793A\u66F4\u591A\u9322\u5305","Send to a different address":"\u767C\u9001\u5230\u4E0D\u540C\u7684\u5730\u5740","Enter {blockchainName} address":["\u8F38\u5165 ",["blockchainName"]," \u5730\u5740"],"Address {destination} doesn\'t match the blockchain address pattern.":["\u4F4D\u5740 ",["destination"]," \u8207\u5340\u584A\u93C8\u4F4D\u5740\u6A21\u5F0F\u4E0D\u7B26\u3002"],"via":"\u900F\u904E","This token doesn\'t appear on the active token list(s). Make sure this is the token that you want to trade.":"\u6B64\u4EE4\u724C\u4E0D\u6703\u51FA\u73FE\u5728\u6D3B\u52D5\u4EE4\u724C\u6E05\u55AE\u4E2D\u3002\u78BA\u4FDD\u9019\u662F\u60A8\u8981\u4EA4\u6613\u7684\u4EE3\u5E63\u3002","Import":"\u9032\u53E3","Status":"\u5730\u4F4D","Reset":"\u91CD\u7F6E","Cancel":"\u53D6\u6D88","Refresh":"\u91CD\u65B0\u6574\u7406","Notifications":"\u901A\u77E5","Settings":"\u8A2D\u5B9A","History":"\u6B77\u53F2","Connect Wallet":"\u9023\u63A5\u9322\u5305","Today":"\u4ECA\u5929","Swaps steps":"\u4EA4\u63DB\u6B65\u9A5F","Retry":"\u91CD\u8A66","Slippage Error":"\u6ED1\u9EDE\u932F\u8AA4","Slippage Warning":"\u6ED1\u9EDE\u8B66\u544A","Bridge Limit Error":"\u6A4B\u9650\u4F4D\u8AA4\u5DEE","Yours: {amount} {symbol}":["\u4F60\u7684\uFF1A ",["amount"]," ",["symbol"]],"Minimum required slippage: {minRequiredSlippage}":["\u6240\u9700\u6700\u5C0F\u6ED1\u9EDE\uFF1A ",["minRequiredSlippage"]],"Yours: {userSlippage}":["\u4F60\u7684\uFF1A ",["userSlippage"]],"See All Routes":"\u67E5\u770B\u6240\u6709\u8DEF\u7DDA","View more info":"\u67E5\u770B\u66F4\u591A\u4FE1\u606F","Gas & Fee Explanation":"Gas & \u8CBB\u7528\u8AAA\u660E","Details":"\u7D30\u7BC0","Total Payable Fee":"\u61C9\u4ED8\u8CBB\u7528\u7E3D\u984D","Hide non-payable fees":"\u96B1\u85CF\u4E0D\u53EF\u652F\u4ED8\u7684\u8CBB\u7528","Show non-payable fees":"\u986F\u793A\u975E\u61C9\u4ED8\u8CBB\u7528","Description":"\u63CF\u8FF0","The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.":"The following fees are considered in the transaction output and\\n                you won\u2019t need to pay extra gas for them.","Swap input":"\u4EA4\u63DB\u8F38\u5165","Estimated output":"\u9810\u8A08\u7522\u91CF","Via:":"\u901A\u904E\uFF1A","Chains:":"\u93C8\u689D\uFF1A","Sort by":"\u6392\u5E8F\u65B9\u5F0F","Smart Routing":"\u667A\u6167\u8DEF\u7531","Lowest Fee":"\u6700\u4F4E\u8CBB\u7528","Fastest Transfer":"\u6700\u5FEB\u7684\u50B3\u8F38","Maximum Return":"\u6700\u5927\u56DE\u5831","Maximum Output":"\u6700\u5927\u8F38\u51FA","Swapping":"\u4EA4\u63DB","Gas cost":"\u5929\u7136\u6C23\u6210\u672C","Receiving":"\u63A5\u6536","Price impact":"\u50F9\u683C\u5F71\u97FF","You need to increase slippage to at least {minRequiredSlippage} for this route.":["\u60A8\u9700\u8981\u5C07\u8A72\u8DEF\u7DDA\u7684\u6ED1\u9EDE\u589E\u52A0\u5230\u81F3\u5C11 ",["minRequiredSlippage"]," \u3002"],"We recommend you to increase slippage to at least {minRequiredSlippage} for this route.":["\u6211\u5011\u5EFA\u8B70\u60A8\u5C07\u6B64\u8DEF\u7DDA\u7684\u6ED1\u9EDE\u589E\u52A0\u5230\u81F3\u5C11 ",["minRequiredSlippage"]," \u3002"],"Caution, your slippage is high.":"\u5C0F\u5FC3\uFF0C\u4F60\u7684\u6ED1\u9EDE\u5F88\u9AD8\u3002","Change":"\u6539\u8B8A","Change settings":"\u66F4\u6539\u8A2D\u5B9A","High slippage":"\u9AD8\u6ED1\u9EDE","Low slippage":"\u4F4E\u6ED1\u9EDE"," Caution, your slippage is high (={userSlippage}). Your trade may be front run.":[" \u8ACB\u6CE8\u610F\uFF0C\u60A8\u7684\u6ED1\u9EDE\u5F88\u9AD8 (=",["userSlippage"],")\u3002\u60A8\u7684\u4EA4\u6613\u53EF\u80FD\u6703\u6436\u5148\u4EA4\u6613\u3002"],"Confirm anyway":"\u7121\u8AD6\u5982\u4F55\u78BA\u8A8D","Something went wrong":"\u51FA\u4E86\u9EDE\u554F\u984C","Something went wrong. Please refresh the app.":"\u51FA\u4E86\u9EDE\u554F\u984C\u3002\u8ACB\u5237\u65B0\u61C9\u7528\u7A0B\u5F0F\u3002","Slippage tolerance per swap":"\u6BCF\u6B21\u4E92\u63DB\u7684\u6ED1\u9EDE\u5BB9\u5DEE","Custom":"\u98A8\u4FD7","Your transaction will be reverted if the price changes unfavorably by more than this percentage.":"\u5982\u679C\u50F9\u683C\u4E0D\u5229\u8B8A\u5316\u8D85\u904E\u6B64\u767E\u5206\u6BD4\uFF0C\u60A8\u7684\u4EA4\u6613\u5C07\u88AB\u6062\u5FA9\u3002","Warning":"\u8B66\u544A","This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.":"\u6B64\u8A2D\u5B9A\u61C9\u7528\u65BC\u6BCF\u500B\u6B65\u9A5F\uFF08\u4F8B\u5982 1Inch\u3001Thorchain \u7B49\uFF09\uFF0C\u9019\u610F\u5473\u8457\u50C5\u6062\u5FA9\u8A72\u7279\u5B9A\u6B65\u9A5F\uFF0C\u800C\u4E0D\u662F\u6574\u500B\u8DEF\u7DDA\u3002","Swap Details":"\u4E92\u63DB\u8A73\u60C5","Request ID":"\u8ACB\u6C42ID","Not found":"\u672A\u627E\u5230","Swap with request ID = {requestId} not found.":["\u8207\u8ACB\u6C42 ID \u9032\u884C\u4EA4\u63DB = ",["requestId"]," \u672A\u627E\u5230\u3002"],"You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.":["\u60A8\u5DF2\u5728 ",["chain"]," \u93C8\u4E0A\u7684 ",["conciseAddress"]," \u9322\u5305\u4E2D\u6536\u5230 ",["amount"]," ",["token"]," \u3002"],"Transaction was not sent.":"\u4EA4\u6613\u672A\u767C\u9001\u3002","{amount} {symbol} on {blockchain} remains in your wallet.":[["blockchain"]," \u4E0A\u7684 ",["amount"]," ",["symbol"]," \u4ECD\u4FDD\u7559\u5728\u60A8\u7684\u9322\u5305\u4E2D\u3002"],"Delete":"\u522A\u9664","Try again":"\u518D\u8A66\u4E00\u6B21","Copied To Clipboard":"\u8907\u88FD\u5230\u526A\u8CBC\u7C3F","Copy Request ID":"\u8907\u88FD\u8ACB\u6C42 ID","View on Rango Explorer":"\u5728 Rango Explorer \u4E0A\u67E5\u770B","Finished at":"\u5B8C\u6210\u65BC","Created at":"\u5275\u5EFA\u65BC","View transaction":"\u67E5\u770B\u4EA4\u6613","Connect":"\u9023\u63A5","Swap Successful":"\u514C\u63DB\u6210\u529F","Transaction Failed":"\u4EA4\u6613\u5931\u6557","Done":"\u5B8C\u7562","Diagnosis":"\u8A3A\u65B7","See Details":"\u770B\u8A73\u60C5","Cancel Swap":"\u53D6\u6D88\u6389\u671F","Are you sure you want to cancel this swap?":"\u60A8\u78BA\u5B9A\u8981\u53D6\u6D88\u6B64\u4EA4\u63DB\u55CE\uFF1F","Yes, Cancel it":"\u662F\u7684\uFF0C\u53D6\u6D88\u5B83","No, Continue":"\u4E0D\uFF0C\u7E7C\u7E8C","Delete Transaction":"\u522A\u9664\u4EA4\u6613","Are you sure you want to delete this swap?":"\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u4EA4\u63DB\u55CE\uFF1F","Yes, Delete it":"\u662F\u7684\uFF0C\u522A\u9664\u5B83","No, Cancel":"\u4E0D\uFF0C\u53D6\u6D88","Change Network":"\u6539\u8B8A\u7DB2\u8DEF","Network Changed":"\u7DB2\u8DEF\u5DF2\u66F4\u6539","Select Token":"\u9078\u64C7\u4EE3\u5E63","Wallet Connected":"\u9322\u5305\u5DF2\u9023\u63A5","Your wallet is connected, you can use it to swap.":"\u60A8\u7684\u9322\u5305\u5DF2\u9023\u63A5\uFF0C\u60A8\u53EF\u4EE5\u7528\u5B83\u4F86\u514C\u63DB\u3002","Failed to Connect":"\u9023\u7DDA\u5931\u6557","Your wallet is not connected. Please try again.":"\u60A8\u7684\u9322\u5305\u672A\u9023\u63A5\u3002\u8ACB\u518D\u8A66\u4E00\u6B21\u3002","Connecting to your wallet":"\u9023\u63A5\u5230\u60A8\u7684\u9322\u5305","Click connect in your wallet popup.":"\u9EDE\u64CA\u9322\u5305\u5F48\u51FA\u8996\u7A97\u4E2D\u7684\u201C\u9023\u63A5\u201D\u3002","Select Derivation Path":"\u9078\u64C7\u63A8\u5C0E\u8DEF\u5F91","In order to connect to {type}, you must first select a Derivation Path":["\u70BA\u4E86\u9023\u63A5\u5230 ",["type"],"\uFF0C\u60A8\u5FC5\u9808\u5148\u9078\u64C7\u6D3E\u751F\u8DEF\u5F91"],"Choose Derivation Path Template":"\u9078\u64C7\u6D3E\u751F\u8DEF\u5F91\u6A21\u677F","Enter Path":"\u8F38\u5165\u8DEF\u5F91","Enter Index":"\u8F38\u5165\u7D22\u5F15","Add {blockchainDisplayName} Chain":["\u52A0\u5165 ",["blockchainDisplayName"]," \u93C8"],"Would you like to add the {blockchainDisplayName} experimental chain to your wallet?":["\u60A8\u60F3\u5C07 ",["blockchainDisplayName"]," \u5BE6\u9A57\u93C8\u52A0\u5165\u60A8\u7684\u9322\u5305\u55CE\uFF1F"],"Please approve the experimental chain pop-up in your wallet.":"\u8ACB\u6279\u51C6\u60A8\u9322\u5305\u4E2D\u5F48\u51FA\u7684\u5BE6\u9A57\u93C8\u3002","{blockchainDisplayName} Chain Added":[["blockchainDisplayName"]," \u5DF2\u52A0\u5165\u93C8"],"The {blockchainDisplayName} chain has been successfully added to your wallet.":[["blockchainDisplayName"]," \u93C8\u5DF2\u6210\u529F\u6DFB\u52A0\u5230\u60A8\u7684\u9322\u5305\u4E2D\u3002"],"Request Rejected":"\u8ACB\u6C42\u88AB\u62D2\u7D55","You\'ve rejected adding {blockchainDisplayName} chain to your wallet.":["\u60A8\u5DF2\u62D2\u7D55\u5C07 ",["blockchainDisplayName"]," \u93C8\u6DFB\u52A0\u5230\u60A8\u7684\u9322\u5305\u4E2D\u3002"],"Select chain types":"\u9078\u64C7\u93C8\u689D\u985E\u578B","This wallet supports multiple chains. Select which chain you\'d like to connect to.":"\u8A72\u9322\u5305\u652F\u63F4\u591A\u93C8\u3002\u9078\u64C7\u60A8\u60F3\u8981\u9023\u63A5\u7684\u93C8\u3002","Failed Network, Please retry your swap.":"\u7DB2\u8DEF\u6545\u969C\uFF0C\u8ACB\u91CD\u8A66\u4EA4\u63DB\u3002","Please reset your liquidity sources.":"\u8ACB\u91CD\u7F6E\u60A8\u7684\u6D41\u52D5\u6027\u4F86\u6E90\u3002","You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.":"\u60A8\u9650\u5236\u4E86\u6D41\u52D5\u6027\u4F86\u6E90\uFF0C\u9019\u53EF\u80FD\u6703\u5C0E\u81F4 Rango \u627E\u4E0D\u5230\u8DEF\u7DDA\u3002\u8ACB\u8003\u616E\u91CD\u7F6E\u60A8\u7684\u6D41\u52D5\u6027\u4F86\u6E90\u3002","No Routes Found.":"\u672A\u627E\u5230\u8DEF\u7DDA\u3002","Reasons why Rango couldn\'t find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.":"Rango \u627E\u4E0D\u5230\u8DEF\u7DDA\u7684\u539F\u56E0\uFF1A\u4EE3\u5E63\u6D41\u52D5\u6027\u4F4E\u3001\u8F38\u5165\u91CF\u6975\u4F4E\u6216\u6240\u9078\u8F38\u5165/\u8F38\u51FA\u4EE3\u5E63\u7D44\u5408\u6C92\u6709\u53EF\u7528\u8DEF\u7DDA\u3002","Bridge Limit Error: Please increase your amount.":"\u6A4B\u63A5\u9650\u5236\u932F\u8AA4\uFF1A\u8ACB\u589E\u52A0\u60A8\u7684\u91D1\u984D\u3002","Bridge Limit Error: Please decrease your amount.":"\u6A4B\u9650\u5236\u932F\u8AA4\uFF1A\u8ACB\u6E1B\u5C11\u60A8\u7684\u91D1\u984D\u3002","High Price Impact":"\u9AD8\u50F9\u5F71\u97FF","Price impact is too high!":"\u50F9\u683C\u5F71\u97FF\u592A\u5927\u4E86\uFF01","The price impact is significantly higher than the allowed amount.":"\u50F9\u683C\u5F71\u97FF\u660E\u986F\u9AD8\u65BC\u5141\u8A31\u7684\u91D1\u984D\u3002","Confirm high price impact":"\u78BA\u8A8D\u9AD8\u50F9\u5F71\u97FF","Route updated and price impact is too high, try again later!":"\u8DEF\u7DDA\u5DF2\u66F4\u65B0\uFF0C\u50F9\u683C\u5F71\u97FF\u592A\u5927\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\uFF01","USD Price Unknown":"\u7F8E\u5143\u50F9\u683C\u672A\u77E5","USD Price Unknown, Cannot calculate Price Impact.":"\u7F8E\u5143\u50F9\u683C\u672A\u77E5\uFF0C\u7121\u6CD5\u8A08\u7B97\u50F9\u683C\u5F71\u97FF\u3002","USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?":"\u7F8E\u5143\u50F9\u683C\u672A\u77E5\uFF0C\u7121\u6CD5\u8A08\u7B97\u50F9\u683C\u5F71\u97FF\u3002\u50F9\u683C\u5F71\u97FF\u53EF\u80FD\u6BD4\u5E73\u5E38\u66F4\u5927\u3002\u60A8\u78BA\u5B9A\u8981\u7E7C\u7E8C\u4EA4\u63DB\u55CE\uFF1F","Confirm USD Price Unknown":"\u78BA\u8A8D\u7F8E\u5143\u50F9\u683C\u672A\u77E5","Swap":"\u4EA4\u63DB","Swap anyway":"\u7121\u8AD6\u5982\u4F55\u4EA4\u63DB","The route goes through Ethereum. Continue?":"\u8DEF\u7DDA\u7D93\u904E\u4EE5\u592A\u574A\u3002\u7E7C\u7E8C\uFF1F","Route has been updated.":"\u8DEF\u7DDA\u5DF2\u66F4\u65B0\u3002","Output amount changed to {newOutputAmount} ({percentageChange}% change).":["\u8F38\u51FA\u91CF\u6539\u70BA ",["newOutputAmount"]," \uFF08",["percentageChange"],"% \u8B8A\u5316\uFF09\u3002"],"Route swappers has been updated.":"\u8DEF\u7531\u4EA4\u63DB\u5668\u5DF2\u66F4\u65B0\u3002","Route internal coins has been updated.":"\u8DEF\u7DDA\u5167\u90E8\u786C\u5E63\u5DF2\u66F4\u65B0\u3002","Routes":"\u8DEF\u7DDA","From":"\u5F9E","To":"\u5230","Light":"\u5149","Dark":"\u9ED1\u6697\u7684","Auto":"\u6C7D\u8ECA","Loading failed":"\u8F09\u5165\u5931\u6557","Bridges":"\u6A4B\u6A11","Exchanges":"\u4EA4\u6D41","Custom Tokens":"\u81EA\u8A02\u4EE4\u724C","Language":"\u8A9E\u8A00","Infinite approval":"\u7121\u9650\u8A8D\u53EF","Enabling the \'Infinite approval\' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.":"\u555F\u7528\u300C\u7121\u9650\u6279\u51C6\u300D\u6A21\u5F0F\u53EF\u4EE5\u4E0D\u53D7\u9650\u5236\u5730\u5B58\u53D6\u5E95\u5C64\u667A\u6167\u5408\u7D04\uFF0C\u5F9E\u800C\u5141\u8A31\u4ED6\u5011\u4E0D\u53D7\u9650\u5236\u5730\u4F7F\u7528\u6279\u51C6\u7684\u4EE3\u5E63\u6578\u91CF\u3002","Theme":"\u4E3B\u984C","Duplicate Token":"\u91CD\u8907\u4EE4\u724C","The address you entered is duplicate, please enter a new address.":"\u60A8\u8F38\u5165\u7684\u5730\u5740\u91CD\u8907\uFF0C\u8ACB\u8F38\u5165\u65B0\u5730\u5740\u3002","Token Already Exists":"\u4EE4\u724C\u5DF2\u5B58\u5728","There\'s no need to add this token again because it already exists and is supported by us.":"\u7121\u9700\u518D\u6B21\u6DFB\u52A0\u6B64\u4EE4\u724C\uFF0C\u56E0\u70BA\u5B83\u5DF2\u7D93\u5B58\u5728\u4E26\u4E14\u53D7\u5230\u6211\u5011\u7684\u652F\u6301\u3002","Token Not Found":"\u672A\u627E\u5230\u4EE4\u724C","Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.":["\u62B1\u6B49\uFF0C\u5728 ",["blockchain"]," \u93C8\u4E0A\u627E\u4E0D\u5230\u5177\u6709\u6240\u63D0\u4F9B\u5730\u5740\u7684\u4EE3\u5E63\u3002\u8ACB\u78BA\u4FDD\u60A8\u8F38\u5165\u4E86\u6B63\u78BA\u7684\u4EE3\u5E63\u5730\u5740\u3002"],"Network Error":"\u7DB2\u8DEF\u932F\u8AA4","Add Custom Token":"\u65B0\u589E\u81EA\u8A02\u4EE4\u724C","Select chain":"\u9078\u64C7\u93C8\u689D","Enter Address":"\u8F38\u5165\u5730\u5740","Enter token address":"\u8F38\u5165\u4EE3\u5E63\u5730\u5740","Failed Network, Please retry.":"\u7DB2\u8DEF\u6545\u969C\uFF0C\u8ACB\u91CD\u8A66\u3002","Add another custom token":"\u65B0\u589E\u53E6\u4E00\u500B\u81EA\u8A02\u4EE4\u724C","Confirm Swap":"\u78BA\u8A8D\u514C\u63DB","Start Swap":"\u958B\u59CB\u4EA4\u63DB","You get":"\u4F60\u5F97\u5230","Search Token":"\u641C\u5C0B\u4EE4\u724C","No custom tokens":"\u6C92\u6709\u81EA\u8A02\u4EE4\u724C","press the button to add your custom token":"\u6309\u4E0B\u6309\u9215\u65B0\u589E\u60A8\u7684\u81EA\u8A02\u4EE4\u724C","Delete Custom Token":"\u522A\u9664\u81EA\u8A02\u4EE4\u724C","Are you sure you want to Delete this Token?":"\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u4EE4\u724C\u55CE\uFF1F","Complete":"\u5B8C\u5168\u7684","Running":"\u8DD1\u6B65","Failed":"\u5931\u6557\u7684","Clear":"\u6E05\u9664","Search Transaction":"\u641C\u5C0B\u4EA4\u6613","No transactions":"\u6C92\u6709\u4EA4\u6613","Your transaction history is stored locally and will appear here after you start a swap":"\u60A8\u7684\u4EA4\u6613\u6B77\u53F2\u8A18\u9304\u5132\u5B58\u5728\u672C\u5730\uFF0C\u4E26\u5728\u60A8\u958B\u59CB\u514C\u63DB\u5F8C\u986F\u793A\u5728\u6B64\u8655","Clear Transaction History":"\u6E05\u9664\u4EA4\u6613\u6B77\u53F2\u8A18\u9304","Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?":"\u7E7C\u7E8C\u5C07\u5F9E\u5C0F\u90E8\u4EF6\u4E2D\u522A\u9664\u6240\u6709\u6210\u529F\u548C\u5931\u6557\u7684\u4EA4\u6613\u3002\u60A8\u60F3\u7E7C\u7E8C\u55CE\uFF1F","Note: This does not erase your transaction history on the chain; it only removes them here.":"\u6CE8\u610F\uFF1A\u9019\u4E0D\u6703\u522A\u9664\u60A8\u5728\u93C8\u4E0A\u7684\u4EA4\u6613\u6B77\u53F2\u8A18\u9304\uFF1B\u5B83\u53EA\u5728\u9019\u88E1\u522A\u9664\u5B83\u5011\u3002","Yes, Clear the history":"\u662F\u7684\uFF0C\u6E05\u9664\u6B77\u53F2\u8A18\u9304","language":"\u8A9E\u8A00","Deselect all":"\u53D6\u6D88\u5168\u9078","Select all":"\u9078\u64C7\u5168\u90E8","Search {sourceType}":["\u641C\u5C0B ",["sourceType"]],"Search Chain":"\u641C\u5C0B\u93C8","Source":"\u4F86\u6E90","Destination":"\u76EE\u7684\u5730","Swap {type}":["\u4EA4\u63DB ",["type"]],"Currently, you\'re in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?":"\u76EE\u524D\uFF0C\u60A8\u8655\u65BC\u6D3B\u52D5\u6A21\u5F0F\uFF0C\u6D41\u52D5\u6027\u4F86\u6E90\u53D7\u5230\u9650\u5236\u3002\u60A8\u60F3\u9000\u51FA\u9019\u7A2E\u6A21\u5F0F\u4E26\u5229\u7528\u6240\u6709\u53EF\u7528\u7684\u6D41\u52D5\u6027\u4F86\u6E90\u55CE\uFF1F","The request ID is necessary to display the swap details.":"\u8ACB\u6C42 ID \u662F\u986F\u793A\u4EA4\u63DB\u8A73\u7D30\u8CC7\u8A0A\u6240\u5FC5\u9700\u7684\u3002","Connect Wallets":"\u9023\u63A5\u9322\u5305","Choose a wallet to connect.":"\u9078\u64C7\u8981\u9023\u63A5\u7684\u9322\u5305\u3002","This week":"\u672C\u661F\u671F","This month":"\u672C\u6708","This year":"\u4ECA\u5E74","Required: >= {min} {symbol}":["\u5FC5\u586B\uFF1A>= ",["min"]," ",["symbol"]],"Required: > {min} {symbol}":["\u5FC5\u586B\uFF1A > ",["min"]," ",["symbol"]],"Required: <= {max} {symbol}":["\u5FC5\u586B\uFF1A<= ",["max"]," ",["symbol"]],"Required: < {max} {symbol}":["\u5FC5\u586B\uFF1A< ",["max"]," ",["symbol"]]," for network fee":" \u6536\u53D6\u7DB2\u8DEF\u8CBB"," for swap":" \u7528\u65BC\u4EA4\u63DB"," for input and network fee":" \u8F38\u5165\u8CBB\u548C\u7DB2\u8DEF\u8CBB","Needs \u2248 {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.":["\u9700\u8981 \u2248 ",["requiredAmount"]," ",["symbol"],["reason"],"\uFF0C\u4F46\u4F60\u7684 ",["blockchain"]," \u9322\u5305\u88E1\u6709 ",["currentAmount"]," ",["symbol"],"\u3002"],"Waiting for connecting wallet":"\u7B49\u5F85\u9023\u63A5\u9322\u5305","Waiting for other running tasks to be finished":"\u7B49\u5F85\u5176\u4ED6\u6B63\u5728\u904B\u884C\u7684\u4EFB\u52D9\u5B8C\u6210","Waiting for changing wallet network":"\u7B49\u5F85\u66F4\u6539\u9322\u5305\u7DB2\u7D61","Sunday":"\u661F\u671F\u65E5","Monday":"\u9031\u4E00","Tuesday":"\u9031\u4E8C","Wednesday":"\u9031\u4E09","Thursday":"\u9031\u56DB","Friday":"\u661F\u671F\u4E94","Saturday":"\u9031\u516D","Powered By":"\u4F9B\u96FB","Aggregated Transaction":"\u805A\u5408\u4EA4\u6613","{blockchainCategory}":[["blockchainCategory"]],"Swap on {fromChain} via {swapper}":["\u900F\u904E ",["swapper"],"\u4EA4\u63DB ",["fromChain"]],"Bridge to {toChain} via {swapper}":["\u7D93 ",["swapper"],"\u6A4B\u63A5\u5728 ",["toChain"]],"Completed":"\u5B8C\u5168\u7684","In progress":"\u9032\u884C\u4E2D","Waiting for bridge transaction":"\u7B49\u5F85\u6A4B\u63A5\u4EA4\u6613","Connected":"\u5DF2\u9023\u63A5","Disconnect":"\u65B7\u958B","Install":"\u5B89\u88DD","Connecting ...":"\u6B63\u5728\u9023\u63A5...","Connecting":"\u9023\u63A5\u4E2D","Disconnected":"\u5DF2\u65B7\u958B\u9023\u63A5","you need to pass a correct state to Wallet.":"\u60A8\u9700\u8981\u5C07\u6B63\u78BA\u7684\u72C0\u614B\u50B3\u905E\u7D66\u9322\u5305\u3002","There are no notifications.":"\u6C92\u6709\u4EFB\u4F55\u901A\u77E5\u3002","Clear all":"\u5168\u90E8\u6E05\u9664","Balance":"\u5E73\u8861","Max":"\u6700\u5927\u9650\u5EA6"}');


const $db7bfa0e98ad1e64$var$messages = {
    af: (0, $9eb8ba525c3d6ebc$export$defe85febe8b728c),
    ar: (0, $70d3a57bbc5cc5ee$export$defe85febe8b728c),
    bn: (0, $d9456b7cb7e535ea$export$defe85febe8b728c),
    ca: (0, $4897c42ac4abf87c$export$defe85febe8b728c),
    da: (0, $cbcb323baab5f3ac$export$defe85febe8b728c),
    de: (0, $f4a2abe442b680eb$export$defe85febe8b728c),
    el: (0, $3e9330b072e528d1$export$defe85febe8b728c),
    en: (0, $b41d5a2e355d559e$export$defe85febe8b728c),
    es: (0, $120ac1159ebd9e5b$export$defe85febe8b728c),
    fi: (0, $902cca6be1bf7145$export$defe85febe8b728c),
    fil: (0, $92308cb0459afc04$export$defe85febe8b728c),
    fr: (0, $1ffe798a265e8e17$export$defe85febe8b728c),
    hi: (0, $08b4924e0a1d36ad$export$defe85febe8b728c),
    hu: (0, $c9a017bc79de91a8$export$defe85febe8b728c),
    id: (0, $6d2a809d3b820113$export$defe85febe8b728c),
    it: (0, $85993aef506dc223$export$defe85febe8b728c),
    ja: (0, $d478e065bd8fe83e$export$defe85febe8b728c),
    ko: (0, $f9c8288eb64e0cad$export$defe85febe8b728c),
    lt: (0, $635408662cd9c3d7$export$defe85febe8b728c),
    ms: (0, $833a28f7a46ae305$export$defe85febe8b728c),
    nl: (0, $8558407c79bcbcba$export$defe85febe8b728c),
    pl: (0, $11d62329a6924e92$export$defe85febe8b728c),
    pt: (0, $91180c0cd3b0e5b3$export$defe85febe8b728c),
    ru: (0, $c8a5ea4be110b179$export$defe85febe8b728c),
    sk: (0, $add9ce5f91c74d3d$export$defe85febe8b728c),
    sr: (0, $aeb35b9b0d36f840$export$defe85febe8b728c),
    sv: (0, $8464a7fe75e16c47$export$defe85febe8b728c),
    sw: (0, $4e0261e7f0cf8f66$export$defe85febe8b728c),
    th: (0, $566c5a96df87467f$export$defe85febe8b728c),
    tr: (0, $b0d4c95b302c5a6e$export$defe85febe8b728c),
    uk: (0, $6f9b04b275969705$export$defe85febe8b728c),
    ur: (0, $ed70f3cad66431c9$export$defe85febe8b728c),
    vi: (0, $007398226015d860$export$defe85febe8b728c),
    "zh-CN": (0, $89ff72a3712b1e04$export$defe85febe8b728c),
    "zh-TW": (0, $85c97d47197a9804$export$defe85febe8b728c)
};
(0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).load($db7bfa0e98ad1e64$var$messages);
function $db7bfa0e98ad1e64$export$97f06dd36973b4cd(props) {
    const [count, forceUpdate] = (0, $exYeM.useReducer)((x)=>x + 1, 0);
    (0, $exYeM.useEffect)(()=>{
        (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).on("change", ()=>{
            forceUpdate();
        });
    }, [
        (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168)
    ]);
    (0, $exYeM.useEffect)(()=>{
        (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).activate(props.language);
    }, [
        props.language
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bc776e50cb44f318$export$a54013f0d02a8f82), {
        i18n: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168),
        children: props.children
    }, count);
}





parcelRequire("exYeM");

parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $5f9225ad5bc3d601$var$e = "colors", $5f9225ad5bc3d601$var$t = "sizes", $5f9225ad5bc3d601$var$r = "space", $5f9225ad5bc3d601$export$22deaee80f3d7c38 = {
    gap: $5f9225ad5bc3d601$var$r,
    gridGap: $5f9225ad5bc3d601$var$r,
    columnGap: $5f9225ad5bc3d601$var$r,
    gridColumnGap: $5f9225ad5bc3d601$var$r,
    rowGap: $5f9225ad5bc3d601$var$r,
    gridRowGap: $5f9225ad5bc3d601$var$r,
    inset: $5f9225ad5bc3d601$var$r,
    insetBlock: $5f9225ad5bc3d601$var$r,
    insetBlockEnd: $5f9225ad5bc3d601$var$r,
    insetBlockStart: $5f9225ad5bc3d601$var$r,
    insetInline: $5f9225ad5bc3d601$var$r,
    insetInlineEnd: $5f9225ad5bc3d601$var$r,
    insetInlineStart: $5f9225ad5bc3d601$var$r,
    margin: $5f9225ad5bc3d601$var$r,
    marginTop: $5f9225ad5bc3d601$var$r,
    marginRight: $5f9225ad5bc3d601$var$r,
    marginBottom: $5f9225ad5bc3d601$var$r,
    marginLeft: $5f9225ad5bc3d601$var$r,
    marginBlock: $5f9225ad5bc3d601$var$r,
    marginBlockEnd: $5f9225ad5bc3d601$var$r,
    marginBlockStart: $5f9225ad5bc3d601$var$r,
    marginInline: $5f9225ad5bc3d601$var$r,
    marginInlineEnd: $5f9225ad5bc3d601$var$r,
    marginInlineStart: $5f9225ad5bc3d601$var$r,
    padding: $5f9225ad5bc3d601$var$r,
    paddingTop: $5f9225ad5bc3d601$var$r,
    paddingRight: $5f9225ad5bc3d601$var$r,
    paddingBottom: $5f9225ad5bc3d601$var$r,
    paddingLeft: $5f9225ad5bc3d601$var$r,
    paddingBlock: $5f9225ad5bc3d601$var$r,
    paddingBlockEnd: $5f9225ad5bc3d601$var$r,
    paddingBlockStart: $5f9225ad5bc3d601$var$r,
    paddingInline: $5f9225ad5bc3d601$var$r,
    paddingInlineEnd: $5f9225ad5bc3d601$var$r,
    paddingInlineStart: $5f9225ad5bc3d601$var$r,
    top: $5f9225ad5bc3d601$var$r,
    right: $5f9225ad5bc3d601$var$r,
    bottom: $5f9225ad5bc3d601$var$r,
    left: $5f9225ad5bc3d601$var$r,
    scrollMargin: $5f9225ad5bc3d601$var$r,
    scrollMarginTop: $5f9225ad5bc3d601$var$r,
    scrollMarginRight: $5f9225ad5bc3d601$var$r,
    scrollMarginBottom: $5f9225ad5bc3d601$var$r,
    scrollMarginLeft: $5f9225ad5bc3d601$var$r,
    scrollMarginX: $5f9225ad5bc3d601$var$r,
    scrollMarginY: $5f9225ad5bc3d601$var$r,
    scrollMarginBlock: $5f9225ad5bc3d601$var$r,
    scrollMarginBlockEnd: $5f9225ad5bc3d601$var$r,
    scrollMarginBlockStart: $5f9225ad5bc3d601$var$r,
    scrollMarginInline: $5f9225ad5bc3d601$var$r,
    scrollMarginInlineEnd: $5f9225ad5bc3d601$var$r,
    scrollMarginInlineStart: $5f9225ad5bc3d601$var$r,
    scrollPadding: $5f9225ad5bc3d601$var$r,
    scrollPaddingTop: $5f9225ad5bc3d601$var$r,
    scrollPaddingRight: $5f9225ad5bc3d601$var$r,
    scrollPaddingBottom: $5f9225ad5bc3d601$var$r,
    scrollPaddingLeft: $5f9225ad5bc3d601$var$r,
    scrollPaddingX: $5f9225ad5bc3d601$var$r,
    scrollPaddingY: $5f9225ad5bc3d601$var$r,
    scrollPaddingBlock: $5f9225ad5bc3d601$var$r,
    scrollPaddingBlockEnd: $5f9225ad5bc3d601$var$r,
    scrollPaddingBlockStart: $5f9225ad5bc3d601$var$r,
    scrollPaddingInline: $5f9225ad5bc3d601$var$r,
    scrollPaddingInlineEnd: $5f9225ad5bc3d601$var$r,
    scrollPaddingInlineStart: $5f9225ad5bc3d601$var$r,
    fontSize: "fontSizes",
    background: $5f9225ad5bc3d601$var$e,
    backgroundColor: $5f9225ad5bc3d601$var$e,
    backgroundImage: $5f9225ad5bc3d601$var$e,
    borderImage: $5f9225ad5bc3d601$var$e,
    border: $5f9225ad5bc3d601$var$e,
    borderBlock: $5f9225ad5bc3d601$var$e,
    borderBlockEnd: $5f9225ad5bc3d601$var$e,
    borderBlockStart: $5f9225ad5bc3d601$var$e,
    borderBottom: $5f9225ad5bc3d601$var$e,
    borderBottomColor: $5f9225ad5bc3d601$var$e,
    borderColor: $5f9225ad5bc3d601$var$e,
    borderInline: $5f9225ad5bc3d601$var$e,
    borderInlineEnd: $5f9225ad5bc3d601$var$e,
    borderInlineStart: $5f9225ad5bc3d601$var$e,
    borderLeft: $5f9225ad5bc3d601$var$e,
    borderLeftColor: $5f9225ad5bc3d601$var$e,
    borderRight: $5f9225ad5bc3d601$var$e,
    borderRightColor: $5f9225ad5bc3d601$var$e,
    borderTop: $5f9225ad5bc3d601$var$e,
    borderTopColor: $5f9225ad5bc3d601$var$e,
    caretColor: $5f9225ad5bc3d601$var$e,
    color: $5f9225ad5bc3d601$var$e,
    columnRuleColor: $5f9225ad5bc3d601$var$e,
    fill: $5f9225ad5bc3d601$var$e,
    outline: $5f9225ad5bc3d601$var$e,
    outlineColor: $5f9225ad5bc3d601$var$e,
    stroke: $5f9225ad5bc3d601$var$e,
    textDecorationColor: $5f9225ad5bc3d601$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $5f9225ad5bc3d601$var$t,
    minBlockSize: $5f9225ad5bc3d601$var$t,
    maxBlockSize: $5f9225ad5bc3d601$var$t,
    inlineSize: $5f9225ad5bc3d601$var$t,
    minInlineSize: $5f9225ad5bc3d601$var$t,
    maxInlineSize: $5f9225ad5bc3d601$var$t,
    width: $5f9225ad5bc3d601$var$t,
    minWidth: $5f9225ad5bc3d601$var$t,
    maxWidth: $5f9225ad5bc3d601$var$t,
    height: $5f9225ad5bc3d601$var$t,
    minHeight: $5f9225ad5bc3d601$var$t,
    maxHeight: $5f9225ad5bc3d601$var$t,
    flexBasis: $5f9225ad5bc3d601$var$t,
    gridTemplateColumns: $5f9225ad5bc3d601$var$t,
    gridTemplateRows: $5f9225ad5bc3d601$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $5f9225ad5bc3d601$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $5f9225ad5bc3d601$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $5f9225ad5bc3d601$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $5f9225ad5bc3d601$var$l = Symbol.for("sxs.internal"), $5f9225ad5bc3d601$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $5f9225ad5bc3d601$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $5f9225ad5bc3d601$var$c } = Object.prototype, $5f9225ad5bc3d601$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $5f9225ad5bc3d601$var$g = /\s+(?![^()]*\))/, $5f9225ad5bc3d601$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($5f9225ad5bc3d601$var$g) : [
            t
        ]), $5f9225ad5bc3d601$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $5f9225ad5bc3d601$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $5f9225ad5bc3d601$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $5f9225ad5bc3d601$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $5f9225ad5bc3d601$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $5f9225ad5bc3d601$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $5f9225ad5bc3d601$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $5f9225ad5bc3d601$var$h = /([\d.]+)([^]*)/, $5f9225ad5bc3d601$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $5f9225ad5bc3d601$var$m = (e, t)=>e in $5f9225ad5bc3d601$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$5f9225ad5bc3d601$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$5f9225ad5bc3d601$var$d(e)}:${r}fit-content`) + i) : String(t), $5f9225ad5bc3d601$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $5f9225ad5bc3d601$var$S = (e)=>e ? e + "-" : "", $5f9225ad5bc3d601$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $5f9225ad5bc3d601$var$S(t) + (l.includes("$") ? "" : $5f9225ad5bc3d601$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $5f9225ad5bc3d601$var$y = /\s*,\s*(?![^()]*\))/, $5f9225ad5bc3d601$var$B = Object.prototype.toString, $5f9225ad5bc3d601$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $5f9225ad5bc3d601$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $5f9225ad5bc3d601$var$u) {
                        const t = $5f9225ad5bc3d601$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $5f9225ad5bc3d601$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($5f9225ad5bc3d601$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($5f9225ad5bc3d601$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $5f9225ad5bc3d601$var$f(t, c.split($5f9225ad5bc3d601$var$y));
                        void 0 !== o && i($5f9225ad5bc3d601$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$5f9225ad5bc3d601$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $5f9225ad5bc3d601$var$I ? String(g) + "px" : String(g) : $5f9225ad5bc3d601$var$k($5f9225ad5bc3d601$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$5f9225ad5bc3d601$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($5f9225ad5bc3d601$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $5f9225ad5bc3d601$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $5f9225ad5bc3d601$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $5f9225ad5bc3d601$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $5f9225ad5bc3d601$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $5f9225ad5bc3d601$var$R(t % 52) + r;
        return $5f9225ad5bc3d601$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $5f9225ad5bc3d601$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $5f9225ad5bc3d601$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $5f9225ad5bc3d601$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($5f9225ad5bc3d601$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $5f9225ad5bc3d601$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $5f9225ad5bc3d601$var$W.length - 1; e >= 0; --e){
            const t = $5f9225ad5bc3d601$var$W[e];
            if (!l[t]) {
                const r = $5f9225ad5bc3d601$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $5f9225ad5bc3d601$var$v(l[t]);
        }
    };
    return n(), t;
}, $5f9225ad5bc3d601$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $5f9225ad5bc3d601$var$T = Symbol(), $5f9225ad5bc3d601$var$w = $5f9225ad5bc3d601$var$o(), $5f9225ad5bc3d601$var$M = (e, t)=>$5f9225ad5bc3d601$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$5f9225ad5bc3d601$var$l]) {
                    null == n.type && (n.type = t[$5f9225ad5bc3d601$var$l].type);
                    for (const e of t[$5f9225ad5bc3d601$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($5f9225ad5bc3d601$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $5f9225ad5bc3d601$var$P(e, n, t);
        }), $5f9225ad5bc3d601$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$5f9225ad5bc3d601$var$S(i.prefix)}c-${$5f9225ad5bc3d601$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $5f9225ad5bc3d601$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$5f9225ad5bc3d601$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$5f9225ad5bc3d601$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $5f9225ad5bc3d601$var$P = (e, t, r)=>{
    const [n, i, o, a] = $5f9225ad5bc3d601$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$5f9225ad5bc3d601$var$T].length; r++){
                const [n, i] = t[$5f9225ad5bc3d601$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$5f9225ad5bc3d601$var$T] = [], null;
        }
        return t[$5f9225ad5bc3d601$var$T] = [], t.rules = {}, $5f9225ad5bc3d601$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$5f9225ad5bc3d601$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $5f9225ad5bc3d601$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $5f9225ad5bc3d601$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $5f9225ad5bc3d601$var$O(o, u, e.media), s = $5f9225ad5bc3d601$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$5f9225ad5bc3d601$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $5f9225ad5bc3d601$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$5f9225ad5bc3d601$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $5f9225ad5bc3d601$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$5f9225ad5bc3d601$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $5f9225ad5bc3d601$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $5f9225ad5bc3d601$var$s(p, {
        className: n,
        selector: g,
        [$5f9225ad5bc3d601$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $5f9225ad5bc3d601$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $5f9225ad5bc3d601$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $5f9225ad5bc3d601$var$A = {}, $5f9225ad5bc3d601$var$N = $5f9225ad5bc3d601$var$o(), $5f9225ad5bc3d601$var$D = (e, t)=>$5f9225ad5bc3d601$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $5f9225ad5bc3d601$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $5f9225ad5bc3d601$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $5f9225ad5bc3d601$var$s(n, {
                toString: n
            });
        }), $5f9225ad5bc3d601$var$H = $5f9225ad5bc3d601$var$o(), $5f9225ad5bc3d601$var$V = (e, t)=>$5f9225ad5bc3d601$var$H(e, ()=>(r)=>{
            const n = `${$5f9225ad5bc3d601$var$S(e.prefix)}k-${$5f9225ad5bc3d601$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $5f9225ad5bc3d601$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $5f9225ad5bc3d601$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $5f9225ad5bc3d601$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $5f9225ad5bc3d601$var$S(this.prefix) + $5f9225ad5bc3d601$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $5f9225ad5bc3d601$var$F = $5f9225ad5bc3d601$var$o(), $5f9225ad5bc3d601$var$J = (e, t)=>$5f9225ad5bc3d601$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$5f9225ad5bc3d601$var$S(e.prefix)}t-${$5f9225ad5bc3d601$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$5f9225ad5bc3d601$var$S(e.prefix)}${t}-${r}`, s = $5f9225ad5bc3d601$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $5f9225ad5bc3d601$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $5f9225ad5bc3d601$var$U = $5f9225ad5bc3d601$var$o();
var $5f9225ad5bc3d601$var$X, $5f9225ad5bc3d601$var$Y = $5f9225ad5bc3d601$var$o(), $5f9225ad5bc3d601$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $5f9225ad5bc3d601$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$5f9225ad5bc3d601$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $5f9225ad5bc3d601$var$E(o), c = {
                css: $5f9225ad5bc3d601$var$M(s, a),
                globalCss: $5f9225ad5bc3d601$var$D(s, a),
                keyframes: $5f9225ad5bc3d601$var$V(s, a),
                createTheme: $5f9225ad5bc3d601$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$5f9225ad5bc3d601$var$Y(e, ()=>{
            const r = $5f9225ad5bc3d601$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$5f9225ad5bc3d601$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$5f9225ad5bc3d601$var$l] = t[$5f9225ad5bc3d601$var$l], i;
            };
        }))(t), t;
}, $5f9225ad5bc3d601$var$K = ()=>$5f9225ad5bc3d601$var$X || ($5f9225ad5bc3d601$var$X = $5f9225ad5bc3d601$export$3c6706659c99b84e()), $5f9225ad5bc3d601$export$25d302a5b900a763 = (...e)=>$5f9225ad5bc3d601$var$K().createTheme(...e), $5f9225ad5bc3d601$export$db53682eef82cc11 = (...e)=>$5f9225ad5bc3d601$var$K().globalCss(...e), $5f9225ad5bc3d601$export$d25ddfdf17c3ad3e = (...e)=>$5f9225ad5bc3d601$var$K().keyframes(...e), $5f9225ad5bc3d601$export$dbf350e5966cf602 = (...e)=>$5f9225ad5bc3d601$var$K().css(...e), $5f9225ad5bc3d601$export$3817b7a54a07cec7 = (...e)=>$5f9225ad5bc3d601$var$K().styled(...e);
 //# sourceMappingUrl=index.map


const $3dd421da623820a3$export$bca14c5b3b88a9c9 = {
    colors: {
        primary: "#1C3CF1",
        primary500: "#1C3CF1",
        primary550: "#0B27C4",
        secondary: "#469BF5",
        secondary100: "#E9F3FF",
        secondary150: "#D6EAFF",
        secondary200: "#C8E2FF",
        secondary250: "#B5D9FF",
        secondary500: "#469BF5",
        secondary550: "#2284ED",
        neutral: "#E6E6E6",
        neutral100: "#F9F9F9",
        neutral200: "#F6F6F6",
        neutral300: "#F2F2F2",
        neutral400: "#EEEEEE",
        neutral500: "#E6E6E6",
        neutral600: "#A2A2A2",
        neutral700: "#727272",
        neutral800: "#1B1B1B",
        neutral900: "#121212",
        error100: "#FDF3F3",
        error300: "#FFD7D7",
        error500: "#FF3B3B",
        error600: "#432F2F",
        error700: "#191212",
        warning100: "#FFF1D4",
        warning300: "#FFD8B4",
        warning500: "#F17606",
        warning600: "#38271F",
        warning700: "#1A1412",
        info: "#5BABFF",
        info100: "#E9F3FF",
        info300: "#C8E2FF",
        info500: "#5BABFF",
        info600: "#2E2E41",
        info700: "#121521",
        success100: "#CEFAE6",
        success300: "#BDECD7",
        success500: "#06C270",
        success600: "#1F2825",
        success700: "#0F1412",
        background: "#FDFDFD",
        foreground: "#010101"
    },
    space: {
        0: "0rem",
        5: "0.313rem",
        10: "0.625rem",
        15: "0.938rem",
        20: "1.25rem",
        25: "1.563rem",
        30: "1.875rem",
        40: "2.5rem",
        46: "2.875rem",
        50: "3.125rem",
        60: "3.75rem",
        70: "4.375rem",
        80: "5rem",
        90: "5.625rem",
        100: "6.25rem",
        //These should be removed
        2: "2px",
        4: "4px",
        6: "6px",
        8: "8px",
        12: "12px",
        16: "16px",
        24: "24px",
        28: "28px",
        32: "32px",
        36: "36px"
    },
    radii: {
        xs: "5px",
        sm: "10px",
        xm: "15px",
        md: "25px",
        xl: "35px",
        lg: "40px",
        primary: "20px",
        secondary: `$md`
    },
    fontSizes: {
        10: "0.625rem",
        12: "0.75rem",
        14: "0.875rem",
        16: "1rem",
        18: "1.125rem",
        20: "1.25rem",
        22: "1.375rem",
        24: "1.5rem",
        28: "1.75rem",
        32: "2rem",
        36: "2.25rem",
        40: "2.5rem",
        48: "3rem"
    },
    fonts: {
        primary: "Roboto",
        widget: "$primary"
    },
    fontWeights: {
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700
    },
    lineHeights: {
        12: "0.75rem",
        16: "1rem",
        20: "1.25rem",
        24: "1.5rem",
        26: "1.625rem",
        28: "1.75rem",
        30: "1.875rem",
        36: "2.25rem",
        40: "2.5rem",
        44: "2.75rem",
        52: "3.25rem",
        64: "4rem"
    },
    letterSpacings: {},
    sizes: {
        4: "4px",
        6: "6px",
        8: "8px",
        10: "10px",
        12: "12px",
        16: "16px",
        18: "18px",
        20: "20px",
        24: "24px",
        26: "26px",
        28: "28px",
        30: "30px",
        32: "32px",
        36: "36px",
        40: "40px",
        45: "45px",
        48: "48px"
    },
    borderWidths: {},
    borderStyles: {},
    shadows: {
        /** Shadow for swap box */ mainContainer: "15px 15px 15px 0px rgba(0, 0, 0, 0.05)"
    },
    zIndices: {},
    transitions: {}
};
const $3dd421da623820a3$var$media = {
    xs: "(min-width: 375px)",
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)"
};
const $3dd421da623820a3$var$utils = {
    bc: (value)=>({
            backgroundColor: value
        })
};
const $3dd421da623820a3$export$abadeef2f905fad3 = {
    secondary: "#2284ED",
    secondary250: "#469BF5",
    secondary500: "#2284ED",
    secondary550: "#2B3462",
    neutral: "#222222",
    neutral900: "#E9E9E9",
    neutral800: "#E6E6E6",
    neutral700: "#B8B8B8",
    neutral600: "#A2A2A2",
    neutral500: "#222222",
    neutral400: "#1B1B1B",
    neutral300: "#121212",
    neutral200: "#111111",
    neutral100: "#101010",
    error500: "#FF5050",
    warning500: "#FF8A20",
    background: "#010101",
    foreground: "#FDFDFD"
};
const { styled: $3dd421da623820a3$export$3817b7a54a07cec7, css: $3dd421da623820a3$export$dbf350e5966cf602, createTheme: $3dd421da623820a3$export$25d302a5b900a763, keyframes: $3dd421da623820a3$export$d25ddfdf17c3ad3e, globalCss: $3dd421da623820a3$export$db53682eef82cc11, config: $3dd421da623820a3$export$e506a1d27d1eaa20 } = (0, $5f9225ad5bc3d601$export$3c6706659c99b84e)({
    media: $3dd421da623820a3$var$media,
    theme: $3dd421da623820a3$export$bca14c5b3b88a9c9,
    utils: $3dd421da623820a3$var$utils
});
const $3dd421da623820a3$export$f30cb9bc4f736419 = $3dd421da623820a3$export$25d302a5b900a763("light-theme-ui", {});
const $3dd421da623820a3$export$3e936a8db52a10a0 = $3dd421da623820a3$export$25d302a5b900a763("dark-theme-ui", {
    colors: $3dd421da623820a3$export$abadeef2f905fad3
});
const $3dd421da623820a3$export$3933df6a0a9e657 = {
    secondary800: "#242D5B",
    secondary850: "#131C49",
    neutral: "#161C38",
    neutral100: "#101327",
    neutral200: "#0D122C",
    neutral300: "#0F142E",
    neutral400: "#111733",
    neutral500: "#161C38",
    neutral800: "#B8B8B8",
    neutral900: "#E9E9E9",
    background: "#070917",
    foreground: "#FDFDFD"
};


const $16ee07b7a73a9abe$export$e4972e67c67fb2af = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    flexShrink: 0,
    variants: {
        size: {
            2: {},
            4: {},
            8: {},
            10: {},
            12: {},
            16: {},
            18: {},
            20: {},
            24: {},
            30: {},
            32: {},
            36: {},
            40: {}
        },
        direction: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            size: 2,
            direction: "horizontal",
            css: {
                width: 2
            }
        },
        {
            size: 2,
            direction: "vertical",
            css: {
                height: 2
            }
        },
        {
            size: 4,
            direction: "horizontal",
            css: {
                width: "$4"
            }
        },
        {
            size: 4,
            direction: "vertical",
            css: {
                height: "$4"
            }
        },
        {
            size: 8,
            direction: "horizontal",
            css: {
                width: "$8"
            }
        },
        {
            size: 8,
            direction: "vertical",
            css: {
                height: "$8"
            }
        },
        {
            size: 10,
            direction: "horizontal",
            css: {
                width: "$10"
            }
        },
        {
            size: 10,
            direction: "vertical",
            css: {
                height: "$10"
            }
        },
        {
            size: 12,
            direction: "horizontal",
            css: {
                width: "$12"
            }
        },
        {
            size: 12,
            direction: "vertical",
            css: {
                height: "$12"
            }
        },
        {
            size: 16,
            direction: "horizontal",
            css: {
                width: "$16"
            }
        },
        {
            size: 16,
            direction: "vertical",
            css: {
                height: "$16"
            }
        },
        {
            size: 18,
            direction: "horizontal",
            css: {
                width: "$18"
            }
        },
        {
            size: 18,
            direction: "vertical",
            css: {
                height: "$18"
            }
        },
        {
            size: 20,
            direction: "horizontal",
            css: {
                width: "$20"
            }
        },
        {
            size: 20,
            direction: "vertical",
            css: {
                height: "$20"
            }
        },
        {
            size: 24,
            direction: "horizontal",
            css: {
                width: "$24"
            }
        },
        {
            size: 24,
            direction: "vertical",
            css: {
                height: "$24"
            }
        },
        {
            size: 30,
            direction: "horizontal",
            css: {
                width: "$30"
            }
        },
        {
            size: 30,
            direction: "vertical",
            css: {
                height: "$30"
            }
        },
        {
            size: 32,
            direction: "horizontal",
            css: {
                width: "$32"
            }
        },
        {
            size: 36,
            direction: "vertical",
            css: {
                height: "$36"
            }
        },
        {
            size: 36,
            direction: "horizontal",
            css: {
                width: "$36"
            }
        },
        {
            size: 32,
            direction: "vertical",
            css: {
                height: "$32"
            }
        },
        {
            size: 40,
            direction: "vertical",
            css: {
                height: "$40"
            }
        }
    ]
});


const $2b81c0e59eaa4d2d$var$DEFAULT_SIZE = 12;
function $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb({ size: size = $2b81c0e59eaa4d2d$var$DEFAULT_SIZE, direction: direction = "vertical", ...props }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $16ee07b7a73a9abe$export$e4972e67c67fb2af), {
        size: size,
        direction: direction,
        ...props
    });
}





parcelRequire("exYeM");

const $4db86d9e473e1211$export$d30a6df1a12190b6 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("span", {
    display: "inline-block",
    variants: {
        variant: {
            display: {},
            headline: {},
            title: {},
            label: {},
            body: {}
        },
        size: {
            large: {},
            medium: {},
            xmedium: {},
            small: {},
            xsmall: {}
        },
        align: {
            center: {
                textAlign: "center"
            },
            left: {
                textAlign: "left"
            },
            right: {
                textAlign: "right"
            }
        },
        noWrap: {
            true: {
                whiteSpace: "nowrap"
            }
        }
    },
    compoundVariants: [
        {
            size: "large",
            variant: "display",
            css: {
                fontSize: "$48",
                fontWeight: "$semiBold",
                lineHeight: "$64"
            }
        },
        {
            size: "medium",
            variant: "display",
            css: {
                fontSize: "$40",
                fontWeight: "$semiBold",
                lineHeight: "$52"
            }
        },
        {
            size: "small",
            variant: "display",
            css: {
                fontSize: "$36",
                fontWeight: "$semiBold",
                lineHeight: "$44"
            }
        },
        {
            size: "large",
            variant: "headline",
            css: {
                fontSize: "$32",
                fontWeight: "$semiBold",
                lineHeight: "$40"
            }
        },
        {
            size: "medium",
            variant: "headline",
            css: {
                fontSize: "$38",
                fontWeight: "$semiBold",
                lineHeight: "$36"
            }
        },
        {
            size: "small",
            variant: "headline",
            css: {
                fontSize: "$22",
                fontWeight: "$semiBold",
                lineHeight: "$30"
            }
        },
        {
            size: "xsmall",
            variant: "headline",
            css: {
                fontSize: "$20",
                fontWeight: "$semiBold",
                lineHeight: "$28"
            }
        },
        {
            size: "large",
            variant: "title",
            css: {
                fontSize: "$22",
                fontWeight: "$medium",
                lineHeight: "$28"
            }
        },
        {
            size: "medium",
            variant: "title",
            css: {
                fontSize: "$18",
                fontWeight: "$medium",
                lineHeight: "$26"
            }
        },
        {
            size: "xmedium",
            variant: "title",
            css: {
                fontSize: "$16",
                fontWeight: "$medium",
                lineHeight: "$24"
            }
        },
        {
            size: "small",
            variant: "title",
            css: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "$20"
            }
        },
        {
            size: "large",
            variant: "label",
            css: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "$20"
            }
        },
        {
            size: "medium",
            variant: "label",
            css: {
                fontSize: "$12",
                fontWeight: "$medium",
                lineHeight: "$16"
            }
        },
        {
            size: "small",
            variant: "label",
            css: {
                fontSize: "$10",
                fontWeight: "$medium",
                lineHeight: "$16"
            }
        },
        {
            size: "large",
            variant: "body",
            css: {
                fontSize: "$16",
                fontWeight: "$regular",
                lineHeight: "$24"
            }
        },
        {
            size: "medium",
            variant: "body",
            css: {
                fontSize: "$14",
                fontWeight: "$regular",
                lineHeight: "$20"
            }
        },
        {
            size: "small",
            variant: "body",
            css: {
                fontSize: "$12",
                fontWeight: "$regular",
                lineHeight: "$16"
            }
        },
        {
            size: "xsmall",
            variant: "body",
            css: {
                fontSize: "$10",
                fontWeight: "$regular",
                lineHeight: "$12"
            }
        }
    ]
});


function $6234172cd87b86f8$export$1c6175f3aa4394b7({ children: children, className: className, color: color, ...props }) {
    const customCss = color ? {
        color: color.startsWith("$") ? color : `$${color}`
    } : {
        color: "$foreground"
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4db86d9e473e1211$export$d30a6df1a12190b6), {
        className: `_typography _text ${className || ""}`,
        css: customCss,
        ...props,
        children: children
    });
}




const $2b3ee42d9713f32c$export$175d6b097d8679ab = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    userSelect: "none"
});




const $490a1bdb09a41c3f$export$5551a2d24ff40153 = (type, variant)=>{
    if (variant === "regular") return undefined;
    switch(type){
        case "success":
        case "warning":
        case "error":
        case "info":
            return `${type}500`;
        default:
            return undefined;
    }
};
const $490a1bdb09a41c3f$export$f4a49e78999238bb = (variant)=>{
    switch(variant){
        case "alarm":
            return "small";
        case "regular":
            return "xsmall";
        default:
            return "xsmall";
    }
};



parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

parcelRequire("exYeM");

const $f3e108fa0c4cc675$export$8b8329c13d18f742 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("svg", {
    variants: {
        color: {
            primary: {
                color: "$primary500"
            },
            secondary: {
                color: "$secondary500"
            },
            error: {
                color: "$error500"
            },
            warning: {
                color: "$warning500"
            },
            success: {
                color: "$success500"
            },
            black: {
                color: "$foreground"
            },
            white: {
                color: "$background"
            },
            info: {
                color: "$info500"
            },
            gray: {
                color: "$neutral700"
            }
        }
    }
});


function $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed(props) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const { size: size = "1em", color: color, children: children } = props;
    const originalSvgProps = children?.props;
    const commonProps = {
        ...originalSvgProps,
        width: size,
        height: size,
        color: color,
        className: "_icon"
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $f3e108fa0c4cc675$export$8b8329c13d18f742), {
        ...commonProps,
        children: children?.props.children
    });
}




function $2c1b2854d2e60533$var$SvgAdd(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M18.8611 13.6389H4.63889C4.15296 13.6389 3.75 13.2359 3.75 12.75C3.75 12.2641 4.15296 11.8611 4.63889 11.8611H18.8611C19.347 11.8611 19.75 12.2641 19.75 12.75C19.75 13.2359 19.347 13.6389 18.8611 13.6389Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M11.75 20.75C11.2641 20.75 10.8611 20.347 10.8611 19.8611V5.63889C10.8611 5.15296 11.2641 4.75 11.75 4.75C12.2359 4.75 12.6389 5.15296 12.6389 5.63889V19.8611C12.6389 20.347 12.2359 20.75 11.75 20.75Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $2c1b2854d2e60533$export$2e2bcd8739ae039 = $2c1b2854d2e60533$var$SvgAdd;




var $exYeM = parcelRequire("exYeM");

function $be4896a1eca75035$var$SvgAffiliate(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.45318 2.60045C3.57763 2.60561 3.70937 2.61423 3.84631 2.62555C4.17141 2.65241 4.5031 2.69234 4.81038 2.72934C4.83446 2.73224 4.85839 2.73512 4.88215 2.73798C5.19198 2.77521 5.50531 2.81244 5.71946 2.81549C6.0508 2.82019 6.32322 2.55541 6.32793 2.22407C6.33264 1.89274 6.06785 1.62032 5.73651 1.61561C5.60081 1.61368 5.3621 1.58702 5.02531 1.54655C5.00076 1.5436 4.97583 1.5406 4.95056 1.53755C4.6469 1.50097 4.29373 1.45842 3.94513 1.42962C3.57094 1.3987 3.17504 1.38108 2.82889 1.4088C2.65549 1.42269 2.47599 1.44926 2.30897 1.49983C2.14712 1.54884 1.9535 1.63327 1.79549 1.79127M3.45318 2.60045L5.48846 4.63574C5.72278 4.87005 5.72278 5.24995 5.48846 5.48426C5.25415 5.71858 4.87425 5.71858 4.63994 5.48426L2.60464 3.44897C2.6098 3.57342 2.61842 3.70517 2.62974 3.84211C2.6566 4.16722 2.69654 4.49891 2.73354 4.80619C2.73644 4.83027 2.73932 4.85419 2.74217 4.87795C2.77941 5.18779 2.81664 5.50112 2.81969 5.71527C2.82439 6.04661 2.55961 6.31903 2.22827 6.32374C1.89693 6.32844 1.62452 6.06366 1.61981 5.73232C1.61788 5.59663 1.59122 5.35791 1.55075 5.02112C1.54779 4.99657 1.54479 4.97164 1.54175 4.94637C1.50516 4.64271 1.46262 4.28953 1.43381 3.94093C1.40289 3.56674 1.38526 3.17084 1.41299 2.82468C1.42688 2.65128 1.45345 2.47178 1.50403 2.30476C1.55304 2.14291 1.63748 1.94928 1.79549 1.79128M21.6816 1.49983C21.8435 1.54884 22.0371 1.63327 22.1951 1.79128C22.3531 1.94928 22.4375 2.14291 22.4866 2.30476C22.5371 2.47178 22.5637 2.65128 22.5776 2.82468C22.6053 3.17084 22.5877 3.56674 22.5568 3.94093C22.528 4.28956 22.4854 4.64277 22.4488 4.94645C22.4458 4.97169 22.4428 4.99659 22.4398 5.02112C22.3994 5.35791 22.3727 5.59663 22.3708 5.73232C22.3661 6.06366 22.0936 6.32844 21.7623 6.32374C21.431 6.31903 21.1662 6.04661 21.1709 5.71527C21.1739 5.50112 21.2112 5.18779 21.2484 4.87795C21.2513 4.85418 21.2541 4.83023 21.257 4.80614C21.294 4.49887 21.334 4.1672 21.3608 3.84211C21.3722 3.70517 21.3808 3.57342 21.3859 3.44897L19.3506 5.48426C19.1163 5.71858 18.7364 5.71858 18.5021 5.48426C18.2678 5.24995 18.2678 4.87005 18.5021 4.63574L20.5374 2.60045C20.413 2.60561 20.2812 2.61423 20.1443 2.62555C19.8192 2.65241 19.4875 2.69235 19.1802 2.72934C19.1561 2.73224 19.1322 2.73512 19.1084 2.73798C18.7986 2.77521 18.4853 2.81244 18.2711 2.81549C17.9398 2.82019 17.6674 2.55541 17.6627 2.22407C17.6579 1.89274 17.9227 1.62032 18.2541 1.61561C18.3898 1.61368 18.6285 1.58702 18.9653 1.54655C18.9898 1.5436 19.0148 1.5406 19.04 1.53755C19.3437 1.50097 19.6969 1.45842 20.0455 1.42962C20.4196 1.3987 20.8155 1.38108 21.1617 1.4088C21.3351 1.42269 21.5146 1.44926 21.6816 1.49983ZM12 5.6C8.46537 5.6 5.59999 8.46538 5.59999 12C5.59999 15.5346 8.46537 18.4 12 18.4C15.5346 18.4 18.4 15.5346 18.4 12C18.4 8.46538 15.5346 5.6 12 5.6ZM4.39999 12C4.39999 7.80264 7.80263 4.4 12 4.4C16.1974 4.4 19.6 7.80264 19.6 12C19.6 16.1974 16.1974 19.6 12 19.6C7.80263 19.6 4.39999 16.1974 4.39999 12ZM11.914 7.85703C12.2454 7.85703 12.514 8.12566 12.514 8.45703V8.74862C12.7685 8.79155 12.9983 8.86333 13.2082 8.96269C13.5718 9.13478 13.8401 9.37297 14.0577 9.61866C14.2774 9.86671 14.2545 10.2459 14.0064 10.4656C13.7584 10.6854 13.3792 10.6624 13.1595 10.4143C13.0136 10.2497 12.87 10.1302 12.6948 10.0473C12.5196 9.96434 12.2773 9.90127 11.914 9.90127C11.4745 9.90127 11.1257 10.0294 10.9013 10.1966C10.6762 10.3644 10.6 10.547 10.6 10.6887C10.6 10.8984 10.6593 10.9952 10.778 11.0741C10.9459 11.1858 11.3023 11.2999 12 11.2999C12.8926 11.2999 13.5695 11.5021 14.0216 11.9271C14.4822 12.3602 14.6 12.9206 14.6 13.3875C14.6 13.975 14.31 14.4863 13.8122 14.8284C13.4625 15.0687 13.0219 15.2201 12.514 15.2849V15.5088C12.514 15.8402 12.2454 16.1088 11.914 16.1088C11.5826 16.1088 11.314 15.8402 11.314 15.5088V15.2883C11.0965 15.2607 10.8972 15.214 10.7078 15.1413C10.3529 15.0052 10.0837 14.7967 9.8224 14.5603C9.5767 14.3379 9.55776 13.9585 9.7801 13.7128C10.0024 13.4671 10.3819 13.4482 10.6276 13.6705C10.8459 13.8681 10.9857 13.9626 11.1377 14.021C11.294 14.0809 11.5136 14.1214 11.914 14.1214C12.5245 14.1214 12.9142 13.9895 13.1325 13.8394C13.3341 13.7009 13.4 13.5453 13.4 13.3875C13.4 13.1093 13.3319 12.9258 13.1996 12.8014C13.0587 12.6689 12.7356 12.4999 12 12.4999C11.2196 12.4999 10.576 12.381 10.1134 12.0734C9.60164 11.733 9.39999 11.2242 9.39999 10.6887C9.39999 10.0851 9.7285 9.57404 10.1842 9.23441C10.499 8.99982 10.886 8.83524 11.314 8.75567V8.45703C11.314 8.12566 11.5826 7.85703 11.914 7.85703ZM2.22827 17.6422C2.55961 17.6469 2.82439 17.9193 2.81969 18.2506C2.81664 18.4648 2.77941 18.7781 2.74217 19.0879C2.73932 19.1117 2.73644 19.1356 2.73354 19.1597C2.69654 19.467 2.6566 19.7987 2.62974 20.1238C2.61842 20.2607 2.6098 20.3925 2.60464 20.5169L4.63994 18.4816C4.87425 18.2473 5.25415 18.2473 5.48846 18.4816C5.72278 18.716 5.72278 19.0959 5.48846 19.3302L3.45318 21.3654C3.57763 21.3603 3.70937 21.3517 3.84631 21.3404C4.17139 21.3135 4.50305 21.2736 4.81032 21.2366C4.83442 21.2337 4.85837 21.2308 4.88215 21.2279C5.19198 21.1907 5.50531 21.1535 5.71946 21.1504C6.0508 21.1457 6.32322 21.4105 6.32793 21.7418C6.33264 22.0732 6.06785 22.3456 5.73651 22.3503C5.60081 22.3522 5.3621 22.3789 5.02531 22.4194C5.00073 22.4223 4.97578 22.4253 4.95049 22.4284C4.64685 22.4649 4.2937 22.5075 3.94513 22.5363C3.57094 22.5672 3.17504 22.5848 2.82889 22.5571C2.65549 22.5432 2.47599 22.5166 2.30897 22.4661C2.14712 22.4171 1.9535 22.3326 1.79549 22.1746C1.63748 22.0166 1.55304 21.823 1.50403 21.6611C1.45345 21.4941 1.42688 21.3146 1.41299 21.1412C1.38526 20.7951 1.40289 20.3992 1.43381 20.025C1.46262 19.6764 1.50517 19.3232 1.54175 19.0195C1.54479 18.9943 1.5478 18.9693 1.55075 18.9448C1.59122 18.608 1.61788 18.3693 1.61981 18.2336C1.62452 17.9022 1.89693 17.6375 2.22827 17.6422ZM21.7623 17.6422C22.0936 17.6375 22.3661 17.9022 22.3708 18.2336C22.3727 18.3693 22.3994 18.608 22.4398 18.9448C22.4428 18.9693 22.4458 18.9942 22.4488 19.0194C22.4854 19.3231 22.528 19.6763 22.5568 20.025C22.5877 20.3992 22.6053 20.7951 22.5776 21.1412C22.5637 21.3146 22.5371 21.4941 22.4866 21.6611C22.4375 21.823 22.3531 22.0166 22.1951 22.1746C22.0371 22.3326 21.8435 22.4171 21.6816 22.4661C21.5146 22.5166 21.3351 22.5432 21.1617 22.5571C20.8155 22.5848 20.4196 22.5672 20.0455 22.5363C19.6969 22.5075 19.3437 22.4649 19.0401 22.4284C19.0148 22.4253 18.9899 22.4223 18.9653 22.4194C18.6285 22.3789 18.3898 22.3522 18.2541 22.3503C17.9227 22.3456 17.6579 22.0732 17.6627 21.7418C17.6674 21.4105 17.9398 21.1457 18.2711 21.1504C18.4853 21.1535 18.7986 21.1907 19.1084 21.2279C19.1322 21.2308 19.1562 21.2337 19.1803 21.2366C19.4875 21.2736 19.8192 21.3135 20.1443 21.3404C20.2812 21.3517 20.413 21.3603 20.5374 21.3655L18.5021 19.3302C18.2678 19.0959 18.2678 18.716 18.5021 18.4816C18.7364 18.2473 19.1163 18.2473 19.3506 18.4816L21.3859 20.5169C21.3808 20.3925 21.3722 20.2607 21.3608 20.1238C21.334 19.7987 21.294 19.467 21.257 19.1598C21.2541 19.1357 21.2513 19.1117 21.2484 19.0879C21.2112 18.7781 21.1739 18.4648 21.1709 18.2506C21.1662 17.9193 21.431 17.6469 21.7623 17.6422Z",
            fill: "currentColor"
        })
    }));
}
var $be4896a1eca75035$export$2e2bcd8739ae039 = $be4896a1eca75035$var$SvgAffiliate;




var $exYeM = parcelRequire("exYeM");

function $1d952e059ee297ad$var$SvgAutoTheme(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M8.67039 5.54766C8.67994 5.54187 8.68937 5.53695 8.69935 5.53245L8.71277 5.52846C8.74207 5.52051 8.77226 5.51778 8.80218 5.52045C8.8367 5.52346 8.87064 5.53342 8.90134 5.54974C8.93205 5.56607 8.95903 5.58852 8.98102 5.61568C9.00257 5.64277 9.01894 5.67402 9.02829 5.70756L9.66563 7.65375L9.60439 7.67032C9.54198 7.68708 9.47797 7.70395 9.41702 7.72391C9.33427 7.75101 9.2558 7.78366 9.17544 7.81428L8.53809 5.86809C8.51629 5.80775 8.51786 5.74138 8.54227 5.68226C8.56661 5.62296 8.61265 5.57495 8.67039 5.54766Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M4.31652 9.28115C4.34365 9.24036 4.38217 9.20811 4.4269 9.18856C4.46226 9.17289 4.50065 9.16523 4.53906 9.16635C4.57746 9.16747 4.61539 9.17714 4.64978 9.19471L6.48083 10.1223C6.42748 10.2155 6.37764 10.3093 6.3311 10.4045C6.30215 10.4635 6.27424 10.5231 6.247 10.5836L4.41595 9.65597C4.372 9.63416 4.33549 9.60011 4.30989 9.55818C4.28467 9.51613 4.27171 9.46782 4.27283 9.41878C4.27395 9.36974 4.28895 9.32188 4.31652 9.28115Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M6.83869 14.1002C6.07832 11.7784 7.34267 9.27443 9.66435 8.51412C9.9063 8.43488 10.1502 8.37772 10.3939 8.34146C10.0982 9.29702 10.0106 10.3458 10.181 11.417C10.5306 13.6147 11.8965 15.3978 13.6791 16.2836C13.3073 16.5594 12.8853 16.781 12.4214 16.9329C10.0993 17.6934 7.59912 16.4223 6.83869 14.1002Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M3.8378 14.911C3.86254 14.8466 3.91143 14.7948 3.97426 14.7669L3.99187 14.7607L3.99975 14.7585C4.00807 14.7552 4.01693 14.7523 4.02561 14.7501L5.97678 14.1111C5.99167 14.1653 6.00637 14.2214 6.02212 14.277C6.03057 14.3066 6.03933 14.3358 6.04876 14.3646C6.06177 14.4043 6.07607 14.443 6.09068 14.4814L6.13737 14.6015L4.1862 15.2404C4.12305 15.2687 4.05169 15.2706 3.98759 15.246C3.92313 15.2215 3.87145 15.1724 3.84351 15.1095C3.8152 15.0468 3.81343 14.9752 3.8378 14.911Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M7.51423 19.1168L8.44186 17.2858C8.59168 17.3711 8.74049 17.4508 8.89807 17.5211L7.97561 19.3504C7.9445 19.4115 7.89054 19.4578 7.82552 19.4791C7.76014 19.5005 7.68924 19.4951 7.62801 19.4643C7.56708 19.4331 7.52078 19.3791 7.49943 19.3139C7.4889 19.2818 7.48472 19.2478 7.48711 19.2139C7.48993 19.18 7.49914 19.1469 7.51423 19.1168Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M13.0798 19.7377L12.4423 17.7913C12.5256 17.7683 12.6078 17.7484 12.691 17.7212C12.7722 17.6945 12.8537 17.6609 12.9329 17.6307L13.5703 19.577C13.5813 19.6094 13.586 19.6437 13.5837 19.6778L13.5815 19.7C13.5775 19.7262 13.5695 19.752 13.5573 19.776C13.5421 19.8068 13.5211 19.8341 13.495 19.8565C13.4806 19.8688 13.4653 19.8795 13.4489 19.8884C13.4354 19.8957 13.4214 19.9017 13.4066 19.9065C13.3741 19.9172 13.3399 19.9212 13.3055 19.9186C13.2714 19.9158 13.238 19.9063 13.2079 19.8904C13.1966 19.8847 13.1858 19.878 13.1757 19.8707C13.1581 19.8583 13.1422 19.8434 13.1282 19.8269C13.1065 19.8007 13.09 19.7703 13.0798 19.7377Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2386 8.51423C14.5854 7.29762 15.4329 6.31226 16.5434 5.77669C16.777 5.66404 16.7626 5.29952 16.5044 5.27455C13.9779 5.03012 11.5363 6.63125 10.831 9.17829C10.0531 11.9895 11.6984 14.9386 14.5238 15.7463C16.3896 16.2796 18.3976 15.7372 19.7517 14.4016C19.9363 14.2195 19.7197 13.9339 19.4689 13.9996C16.3574 14.8152 13.1572 12.308 14.2386 8.51423Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $1d952e059ee297ad$export$2e2bcd8739ae039 = $1d952e059ee297ad$var$SvgAutoTheme;




var $exYeM = parcelRequire("exYeM");

function $d195d943de5e5fdd$var$SvgAutorenew(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z",
            fill: "currentColor"
        })
    }));
}
var $d195d943de5e5fdd$export$2e2bcd8739ae039 = $d195d943de5e5fdd$var$SvgAutorenew;




var $exYeM = parcelRequire("exYeM");

function $e26563fe7865c93f$var$SvgBorderRadius(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Border-Radius",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.48926 7.74652C3.48926 5.15304 5.592 3 8.24997 3C8.53793 3 8.77138 3.22074 8.77138 3.49304C8.77138 3.76533 8.53793 3.98607 8.24997 3.98607C6.22533 3.98607 4.53208 5.64173 4.53208 7.74652C4.53208 8.01881 4.29864 8.23955 4.01067 8.23955C3.7227 8.23955 3.48926 8.01881 3.48926 7.74652ZM16.2071 3.49304C16.2071 3.22074 16.4406 3 16.7286 3C19.3865 3 21.4893 5.15304 21.4893 7.74652C21.4893 8.01882 21.2558 8.23956 20.9678 8.23956C20.6799 8.23956 20.4464 8.01882 20.4464 7.74652C20.4464 5.64173 18.7532 3.98607 16.7286 3.98607C16.4406 3.98607 16.2071 3.76533 16.2071 3.49304ZM5.60885 7.74638C5.60885 6.32747 6.76259 5.1266 8.24991 5.1266L16.7285 5.1266C18.2158 5.1266 19.3696 6.32747 19.3696 7.74638L19.3696 16.2533C19.3696 17.6722 18.2158 18.8731 16.7285 18.8731L8.2499 18.8731C6.76259 18.8731 5.60885 17.6722 5.60885 16.2533L5.60885 7.74638ZM8.24991 6.11267C7.39592 6.11267 6.65167 6.81615 6.65167 7.74638L6.65167 16.2533C6.65167 17.1836 7.39592 17.887 8.2499 17.887L16.7285 17.887C17.5825 17.887 18.3267 17.1836 18.3267 16.2533L18.3267 7.74638C18.3267 6.81616 17.5825 6.11267 16.7285 6.11267L8.24991 6.11267ZM4.01067 15.7604C4.29864 15.7604 4.53208 15.9812 4.53208 16.2535C4.53208 18.3583 6.22533 20.0139 8.24996 20.0139C8.53793 20.0139 8.77138 20.2347 8.77138 20.507C8.77138 20.7793 8.53793 21 8.24996 21C5.592 21 3.48926 18.847 3.48926 16.2535C3.48926 15.9812 3.7227 15.7604 4.01067 15.7604ZM20.9678 15.7604C21.2558 15.7604 21.4893 15.9812 21.4893 16.2535C21.4893 18.847 19.3865 21 16.7285 21C16.4406 21 16.2071 20.7793 16.2071 20.507C16.2071 20.2347 16.4406 20.0139 16.7285 20.0139C18.7532 20.0139 20.4464 18.3583 20.4464 16.2535C20.4464 15.9812 20.6799 15.7604 20.9678 15.7604Z",
                fill: "#727272"
            })
        })
    }));
}
var $e26563fe7865c93f$export$2e2bcd8739ae039 = $e26563fe7865c93f$var$SvgBorderRadius;




var $exYeM = parcelRequire("exYeM");

function $efb90bfb9b7fd357$var$SvgBridges(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M18.21 9.21C15.93 10.78 13.45 13.3 13 17H15V19H9V17H11C10.5 12.5 6.63 9 2 9V7C6.39 7 10.22 9.55 12 13.3C13.13 10.87 14.99 9.05 16.78 7.78L14 5H21V12L18.21 9.21Z",
            fill: "currentColor"
        })
    }));
}
var $efb90bfb9b7fd357$export$2e2bcd8739ae039 = $efb90bfb9b7fd357$var$SvgBridges;




var $exYeM = parcelRequire("exYeM");

function $cc8325b970676242$var$SvgBugReport(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_20032_457548)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1.3999 5.9999C1.3999 3.45939 3.45939 1.3999 5.9999 1.3999H14.9999C17.5404 1.3999 19.5999 3.45939 19.5999 5.9999V10.9999C19.5999 11.3313 19.3313 11.5999 18.9999 11.5999C18.6685 11.5999 18.3999 11.3313 18.3999 10.9999V5.9999C18.3999 4.12213 16.8777 2.5999 14.9999 2.5999H5.9999C4.12213 2.5999 2.5999 4.12213 2.5999 5.9999V17.9999C2.5999 19.8777 4.12213 21.3999 5.9999 21.3999H9.9999C10.3313 21.3999 10.5999 21.6685 10.5999 21.9999C10.5999 22.3313 10.3313 22.5999 9.9999 22.5999H5.9999C3.45939 22.5999 1.3999 20.5404 1.3999 17.9999V5.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.8999 6.9999C4.8999 6.66853 5.16853 6.3999 5.4999 6.3999H15.4999C15.8313 6.3999 16.0999 6.66853 16.0999 6.9999C16.0999 7.33127 15.8313 7.5999 15.4999 7.5999H5.4999C5.16853 7.5999 4.8999 7.33127 4.8999 6.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.8999 10.9999C4.8999 10.6685 5.16853 10.3999 5.4999 10.3999H11.4999C11.8313 10.3999 12.0999 10.6685 12.0999 10.9999C12.0999 11.3313 11.8313 11.5999 11.4999 11.5999H5.4999C5.16853 11.5999 4.8999 11.3313 4.8999 10.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.4999 22.7999C18.8747 22.7999 20.7999 20.8747 20.7999 18.4999C20.7999 16.1251 18.8747 14.1999 16.4999 14.1999C14.1251 14.1999 12.1999 16.1251 12.1999 18.4999C12.1999 20.8747 14.1251 22.7999 16.4999 22.7999ZM16.4999 23.9999C19.5375 23.9999 21.9999 21.5375 21.9999 18.4999C21.9999 15.4623 19.5375 12.9999 16.4999 12.9999C13.4623 12.9999 10.9999 15.4623 10.9999 18.4999C10.9999 21.5375 13.4623 23.9999 16.4999 23.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.4999 15.7999C16.8313 15.7999 17.0999 16.0685 17.0999 16.3999V18.4999C17.0999 18.8313 16.8313 19.0999 16.4999 19.0999C16.1685 19.0999 15.8999 18.8313 15.8999 18.4999V16.3999C15.8999 16.0685 16.1685 15.7999 16.4999 15.7999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.4999 19.7999C16.8313 19.7999 17.0999 20.0685 17.0999 20.3999V20.4499C17.0999 20.7813 16.8313 21.0499 16.4999 21.0499C16.1685 21.0499 15.8999 20.7813 15.8999 20.4499V20.3999C15.8999 20.0685 16.1685 19.7999 16.4999 19.7999Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_20032_457548",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $cc8325b970676242$export$2e2bcd8739ae039 = $cc8325b970676242$var$SvgBugReport;




var $exYeM = parcelRequire("exYeM");

function $0dd1b14f128f5811$var$SvgCalendar(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.50034 3.8499C3.99644 3.8499 3.51318 4.05007 3.15687 4.40638C2.80056 4.76269 2.60039 5.24595 2.60039 5.74985V20.7495C2.60039 21.2534 2.80056 21.7367 3.15687 22.093C3.51318 22.4493 3.99644 22.6495 4.50034 22.6495H19.5C20.0039 22.6495 20.4872 22.4493 20.8435 22.093C21.1998 21.7367 21.4 21.2534 21.4 20.7495V5.74985C21.4 5.24595 21.1998 4.76269 20.8435 4.40638C20.4872 4.05007 20.0039 3.8499 19.5 3.8499H4.50034ZM2.30834 3.55786C2.8897 2.9765 3.67818 2.6499 4.50034 2.6499H19.5C20.3222 2.6499 21.1107 2.9765 21.692 3.55786C22.2734 4.13921 22.6 4.92769 22.6 5.74985V20.7495C22.6 21.5717 22.2734 22.3602 21.692 22.9415C21.1107 23.5229 20.3222 23.8495 19.5 23.8495H4.50034C3.67818 23.8495 2.8897 23.5229 2.30834 22.9415C1.72699 22.3602 1.40039 21.5717 1.40039 20.7495V5.74985C1.40039 4.92769 1.72699 4.13921 2.30834 3.55786Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.9999 0.149902C17.3313 0.149902 17.5999 0.418532 17.5999 0.749902V5.74979C17.5999 6.08116 17.3313 6.34979 16.9999 6.34979C16.6685 6.34979 16.3999 6.08116 16.3999 5.74979V0.749902C16.3999 0.418532 16.6685 0.149902 16.9999 0.149902Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.00039 0.149902C7.33176 0.149902 7.60039 0.418532 7.60039 0.749902V5.74979C7.60039 6.08116 7.33176 6.34979 7.00039 6.34979C6.66902 6.34979 6.40039 6.08116 6.40039 5.74979V0.749902C6.40039 0.418532 6.66902 0.149902 7.00039 0.149902Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.40039 10.7494C1.40039 10.418 1.66902 10.1494 2.00039 10.1494H22C22.3313 10.1494 22.6 10.418 22.6 10.7494C22.6 11.0808 22.3313 11.3494 22 11.3494H2.00039C1.66902 11.3494 1.40039 11.0808 1.40039 10.7494Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $0dd1b14f128f5811$export$2e2bcd8739ae039 = $0dd1b14f128f5811$var$SvgCalendar;




var $exYeM = parcelRequire("exYeM");

function $649ad8aca28bbcee$var$SvgChevronDown(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.4595 6.04028C23.2057 5.78644 22.7941 5.78644 22.5403 6.04028L11.9999 16.5807L1.45952 6.04028C1.20568 5.78644 0.794123 5.78644 0.540283 6.04028C0.286442 6.29412 0.286442 6.70568 0.540283 6.95952L11.5403 17.9595C11.7941 18.2134 12.2057 18.2134 12.4595 17.9595L23.4595 6.95952C23.7134 6.70568 23.7134 6.29412 23.4595 6.04028Z",
            fill: "currentColor"
        })
    }));
}
var $649ad8aca28bbcee$export$2e2bcd8739ae039 = $649ad8aca28bbcee$var$SvgChevronDown;




var $exYeM = parcelRequire("exYeM");

function $2e0408aac5dd3ed5$var$SvgChevronLeft(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.9597 0.540478C18.2136 0.794319 18.2136 1.20588 17.9597 1.45972L7.41934 12.0001L17.9597 22.5405C18.2136 22.7943 18.2136 23.2059 17.9597 23.4597C17.7059 23.7136 17.2943 23.7136 17.0405 23.4597L6.04048 12.4597C5.78664 12.2059 5.78664 11.7943 6.04048 11.5405L17.0405 0.540478C17.2943 0.286637 17.7059 0.286637 17.9597 0.540478Z",
            fill: "currentColor"
        })
    }));
}
var $2e0408aac5dd3ed5$export$2e2bcd8739ae039 = $2e0408aac5dd3ed5$var$SvgChevronLeft;




var $exYeM = parcelRequire("exYeM");

function $9b9c1ebda254eeb8$var$SvgChevronRight(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.04028 0.540478C5.78644 0.794319 5.78644 1.20588 6.04028 1.45972L16.5807 12.0001L6.04028 22.5405C5.78644 22.7943 5.78644 23.2059 6.04028 23.4597C6.29412 23.7136 6.70568 23.7136 6.95952 23.4597L17.9595 12.4597C18.2134 12.2059 18.2134 11.7943 17.9595 11.5405L6.95952 0.540478C6.70568 0.286637 6.29412 0.286637 6.04028 0.540478Z",
            fill: "currentColor"
        })
    }));
}
var $9b9c1ebda254eeb8$export$2e2bcd8739ae039 = $9b9c1ebda254eeb8$var$SvgChevronRight;




var $exYeM = parcelRequire("exYeM");

function $37519868f1c889a9$var$SvgChevronUp(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.17976 17.6273C1.41944 17.867 1.80803 17.867 2.04771 17.6273L12 7.67504L21.9523 17.6273C22.192 17.867 22.5806 17.867 22.8202 17.6273C23.0599 17.3877 23.0599 16.9991 22.8202 16.7594L12.434 6.37312C12.1943 6.13344 11.8057 6.13344 11.566 6.37312L1.17976 16.7594C0.940081 16.9991 0.940081 17.3877 1.17976 17.6273Z",
            fill: "currentColor"
        })
    }));
}
var $37519868f1c889a9$export$2e2bcd8739ae039 = $37519868f1c889a9$var$SvgChevronUp;




var $exYeM = parcelRequire("exYeM");

function $8192be46f8fafa5a$var$SvgClose(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40175)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.4597 0.540356C23.7135 0.794197 23.7135 1.20575 23.4597 1.45959L12.9193 12L23.4597 22.5404C23.7135 22.7942 23.7135 23.2058 23.4597 23.4596C23.2059 23.7134 22.7943 23.7134 22.5405 23.4596L12.0001 12.9192L1.45972 23.4596C1.20588 23.7134 0.794319 23.7134 0.540478 23.4596C0.286637 23.2057 0.286637 22.7942 0.540478 22.5403L11.0808 12L0.54048 1.45961C0.286639 1.20577 0.286639 0.794217 0.54048 0.540376C0.794321 0.286535 1.20588 0.286535 1.45972 0.540376L12.0001 11.0807L22.5405 0.540356C22.7943 0.286515 23.2059 0.286515 23.4597 0.540356Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_3736_40175",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $8192be46f8fafa5a$export$2e2bcd8739ae039 = $8192be46f8fafa5a$var$SvgClose;




var $exYeM = parcelRequire("exYeM");

function $2728cf0100aeae4d$var$SvgComplete(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519937 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693604 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693604 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519937 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9964 15.1815 22.731 18.2317 20.4813 20.4813C18.2317 22.731 15.1815 23.9964 12 24ZM5.24958 10.7467C5.02396 10.7461 4.80338 10.8134 4.61649 10.9398C4.42961 11.0663 4.28505 11.2459 4.20158 11.4556C4.11812 11.6652 4.09962 11.8951 4.14847 12.1153C4.19732 12.3356 4.31128 12.5361 4.47553 12.6908L9.38309 17.3238C9.59865 17.5247 9.88439 17.6329 10.1789 17.6253C10.4734 17.6178 10.7532 17.495 10.9582 17.2833L19.556 8.28277C19.7619 8.06674 19.8735 7.77777 19.8663 7.47942C19.8591 7.18108 19.7338 6.89781 19.5177 6.69192C19.3017 6.48603 19.0127 6.3744 18.7144 6.38157C18.416 6.38875 18.1328 6.51414 17.9269 6.73017L10.1144 14.9139L6.02363 11.0527C5.81479 10.856 5.5387 10.7466 5.25183 10.7467H5.24958Z",
            fill: "currentColor"
        })
    }));
}
var $2728cf0100aeae4d$export$2e2bcd8739ae039 = $2728cf0100aeae4d$var$SvgComplete;




var $exYeM = parcelRequire("exYeM");

function $b4453245b5271f9c$var$SvgCopy(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M20.4327 5.58132H16.0737V1.95344C16.071 1.43619 15.8811 0.941128 15.5451 0.575383C15.2091 0.209663 14.7541 0.00277478 14.2789 0H4.02234C3.54722 0.00280315 3.09223 0.209677 2.75619 0.575383C2.42017 0.941104 2.23026 1.43614 2.22754 1.95344V16.465C2.23029 16.9823 2.42019 17.4776 2.75619 17.8433C3.09221 18.209 3.54722 18.4157 4.02234 18.4187H8.38133V22.0466C8.38408 22.5638 8.57398 23.0589 8.90999 23.4246C9.246 23.7903 9.70101 23.9972 10.1761 24H20.4327C20.9079 23.9972 21.3628 23.7903 21.6989 23.4246C22.0349 23.0589 22.2248 22.5639 22.2275 22.0466V7.53495C22.2248 7.0177 22.0349 6.52245 21.6989 6.1567C21.3629 5.79098 20.9079 5.58429 20.4327 5.58132ZM4.02278 16.7441C3.88129 16.7441 3.76625 16.6192 3.76625 16.465V1.95344C3.76625 1.79927 3.88112 1.67443 4.0226 1.67443H14.2792C14.3472 1.67443 14.4125 1.70377 14.4605 1.7561C14.5086 1.80842 14.5356 1.87944 14.5356 1.95344V5.58132H10.1766C9.70145 5.58431 9.24647 5.791 8.91043 6.1567C8.57441 6.52242 8.3845 7.01765 8.38177 7.53495V16.7443L4.02278 16.7441ZM20.689 22.0467C20.689 22.1208 20.662 22.1918 20.614 22.2441C20.5659 22.2964 20.5006 22.3258 20.4327 22.3258H10.176C10.0346 22.3258 9.91969 22.2009 9.91969 22.0467V7.53515C9.91969 7.38097 10.0346 7.25595 10.176 7.25595H20.4327C20.5006 7.25595 20.5659 7.28548 20.614 7.3378C20.6621 7.39013 20.689 7.46114 20.689 7.53515V22.0467Z",
            fill: "currentColor"
        })
    }));
}
var $b4453245b5271f9c$export$2e2bcd8739ae039 = $b4453245b5271f9c$var$SvgCopy;




var $exYeM = parcelRequire("exYeM");

function $d95c28b579ea6a16$var$SvgCosmosCategory(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 14.5,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M14.5001 3C13.9355 3 13.4778 5.04669 13.4778 7.57143C13.4778 10.0962 13.9355 12.1429 14.5001 12.1429C15.0646 12.1429 15.5224 10.0962 15.5224 7.57143C15.5224 5.04669 15.0646 3 14.5001 3ZM14.5707 11.8849C14.5061 11.9709 14.4415 11.9064 14.4415 11.9064C14.1816 11.6053 14.0516 11.0459 14.0516 11.0459C13.5968 9.58303 13.7051 6.44219 13.7051 6.44219C13.9188 3.9487 14.3075 3.35966 14.4398 3.22888C14.4533 3.21554 14.4711 3.20738 14.4901 3.20585C14.509 3.20432 14.5279 3.20951 14.5433 3.22052C14.7353 3.35648 14.8963 3.92507 14.8963 3.92507C15.3717 5.68909 15.3287 7.34556 15.3287 7.34556C15.3717 8.7869 15.0904 10.4003 15.0904 10.4003C14.8739 11.6265 14.5707 11.8849 14.5707 11.8849Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M18.4671 5.29619C18.186 4.80656 16.1823 5.42826 13.9903 6.68463C11.7983 7.941 10.2521 9.35649 10.5329 9.84592C10.8138 10.3353 12.8177 9.71385 15.0097 8.45748C17.2017 7.20111 18.7479 5.78562 18.4671 5.29619ZM10.7923 9.77875C10.6846 9.7652 10.709 9.6768 10.709 9.6768C10.841 9.30162 11.261 8.91052 11.261 8.91052C12.3046 7.78823 15.0842 6.31912 15.0842 6.31912C17.3542 5.26349 18.0593 5.30803 18.2381 5.35725C18.2565 5.36237 18.2724 5.37383 18.2832 5.38958C18.2939 5.40533 18.2987 5.42437 18.2967 5.44332C18.2752 5.67751 17.8609 6.0999 17.8609 6.0999C16.5675 7.39043 15.1086 8.17758 15.1086 8.17758C13.8792 8.93243 12.3391 9.49111 12.3391 9.49111C11.1672 9.91321 10.7923 9.77875 10.7923 9.77875H10.7923Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M18.4571 9.86134C18.7404 9.373 17.1981 7.95102 15.0138 6.6852C12.8295 5.41938 10.826 4.78999 10.543 5.27916C10.26 5.76833 11.8021 7.18947 13.9876 8.45529C16.1732 9.72111 18.1741 10.3506 18.4571 9.86134ZM10.7307 5.46785C10.6889 5.3687 10.7772 5.34482 10.7772 5.34482C11.1682 5.27101 11.7175 5.43921 11.7175 5.43921C13.2118 5.77933 15.8763 7.44763 15.8763 7.44763C17.9278 8.88253 18.2424 9.51456 18.2896 9.69397C18.2944 9.71237 18.2925 9.73188 18.2843 9.74904C18.2761 9.7662 18.2621 9.77992 18.2448 9.78777C18.0309 9.88567 17.4579 9.73981 17.4579 9.73981C15.692 9.26652 14.2797 8.39938 14.2797 8.39938C13.0108 7.71528 11.756 6.66266 11.756 6.66266C10.8026 5.86025 10.731 5.46894 10.731 5.46894L10.7307 5.46785Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M14.4893 8.09906C14.7865 8.09906 15.0274 7.85827 15.0274 7.56125C15.0274 7.26422 14.7865 7.02344 14.4893 7.02344C14.1922 7.02344 13.9513 7.26422 13.9513 7.56125C13.9513 7.85827 14.1922 8.09906 14.4893 8.09906Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M16.6954 5.81725C16.8677 5.81725 17.0075 5.67278 17.0075 5.49456C17.0075 5.31635 16.8677 5.17188 16.6954 5.17188C16.523 5.17188 16.3833 5.31635 16.3833 5.49456C16.3833 5.67278 16.523 5.81725 16.6954 5.81725Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M11.5731 6.9149C11.7454 6.9149 11.8851 6.77043 11.8851 6.59222C11.8851 6.414 11.7454 6.26953 11.5731 6.26953C11.4007 6.26953 11.261 6.414 11.261 6.59222C11.261 6.77043 11.4007 6.9149 11.5731 6.9149Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M13.8544 10.8719C14.0268 10.8719 14.1665 10.7275 14.1665 10.5492C14.1665 10.371 14.0268 10.2266 13.8544 10.2266C13.6821 10.2266 13.5424 10.371 13.5424 10.5492C13.5424 10.7275 13.6821 10.8719 13.8544 10.8719Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 7.5,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_95038)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M12.0037 16.8405C11.903 16.4592 11.5793 16.0779 10.9965 15.6535C10.5289 15.3153 10.0325 15.1211 9.63681 15.1211C9.55767 15.1211 9.48573 15.1283 9.41379 15.1427C9.23393 15.1786 9.07566 15.3081 8.97494 15.5024C8.85264 15.7326 8.82386 16.042 8.90299 16.229C8.93177 16.2866 8.96774 16.3585 9.01091 16.4233C8.62961 16.6535 8.41379 16.7182 8.38501 16.7254C9.37782 17.0563 10.2052 17.747 10.7231 18.6463L10.7303 18.5599C10.7519 18.3225 10.8239 18.0492 10.9246 17.7686C11.0253 17.7974 11.126 17.8117 11.2267 17.8117C11.4929 17.8117 11.7231 17.7038 11.867 17.5096C12.0109 17.3153 12.0685 17.0563 12.0037 16.8405Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M10.9675 17.5614C11.6222 17.7413 11.8884 17.2377 11.802 16.8996C11.7085 16.5614 11.4064 16.2161 10.874 15.8276C10.3416 15.4391 9.80204 15.2809 9.45671 15.3528C9.11139 15.4247 9.01067 15.9499 9.097 16.1514C9.13297 16.2305 9.21211 16.3456 9.32002 16.4751C9.18333 16.5686 9.05384 16.6406 8.94592 16.7053C9.60779 17.0003 10.1833 17.4607 10.615 18.0363C10.6653 17.842 10.7373 17.6693 10.802 17.5183C10.8524 17.5255 10.91 17.5398 10.9675 17.5614Z",
                        fill: "url(#paint0_radial_9706_95038)"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M11.4713 16.5684C10.9246 15.9929 10.4641 15.8418 9.91018 15.7195C9.47853 15.6188 9.59364 15.3742 10.1188 15.4245C9.86702 15.3382 9.62961 15.3166 9.45695 15.3526C9.11162 15.4245 9.0109 15.9497 9.09723 16.1511C9.1332 16.2303 9.21234 16.3454 9.32026 16.4749C9.12601 16.6044 8.96054 16.6979 8.82385 16.7699C8.8886 16.7986 8.96774 16.8346 9.06126 16.885C9.30587 17.0145 9.57205 17.2303 9.57205 17.2303C9.16918 16.885 9.25551 16.7267 9.80946 16.3382C9.98213 16.2159 10.2987 16.2303 10.5936 16.3814C10.8886 16.5324 11.2339 16.9137 11.2339 16.9137L10.903 17.5468C10.9246 17.554 10.9462 17.5612 10.9677 17.5684C11.1764 17.626 11.3418 17.6116 11.4713 17.5612C11.6224 17.4677 12.0181 17.1511 11.4713 16.5684Z",
                        fill: "#C0DAF6"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.90274 16.0629C10.0466 16.1204 10.2337 16.2212 10.4639 16.3722C10.7373 16.5521 10.9747 16.7535 11.1258 16.9118C10.874 17.2428 10.7085 17.696 10.6078 18.0125C10.6581 18.0845 10.7157 18.1564 10.766 18.2284C10.8164 18.0485 10.9027 17.7823 11.0178 17.5161C11.0466 17.5233 11.0826 17.5233 11.1186 17.5233C11.2049 17.5233 11.3056 17.5089 11.3848 17.4442C11.4423 17.401 11.5071 17.3219 11.4999 17.178C11.4999 17.0413 11.3919 16.8687 11.1689 16.66C11.0107 16.5089 10.7948 16.3435 10.579 16.1924C9.96029 15.7823 9.52864 15.6672 9.3344 15.8615C9.2049 15.991 9.21929 16.1492 9.26245 16.2643C9.03224 16.4154 8.83799 16.5233 8.7085 16.5953C8.79483 16.624 8.87396 16.66 8.96029 16.696C9.19051 16.5737 9.52145 16.3651 9.90274 16.0629ZM11.2625 17.0917C11.284 17.1276 11.2912 17.1636 11.2912 17.1852C11.2912 17.2499 11.2696 17.2715 11.2553 17.2859C11.2265 17.3075 11.1689 17.3219 11.1186 17.3219C11.1617 17.2356 11.2121 17.1636 11.2625 17.0917ZM9.48547 16.0197C9.50706 15.9981 9.56461 15.9838 9.65814 15.9981C9.58619 16.0557 9.51425 16.1061 9.44231 16.1564C9.43511 16.1061 9.44231 16.0557 9.48547 16.0197Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M7.2192 16.332C4.86668 16.332 2.96021 18.2385 2.96021 20.591C2.96021 22.9435 4.86668 24.85 7.2192 24.85C9.57172 24.85 11.4782 22.9435 11.4782 20.591C11.4782 18.2385 9.56452 16.332 7.2192 16.332ZM7.2192 24.6126C4.99618 24.6126 3.19762 22.814 3.19762 20.591C3.19762 18.368 4.99618 16.5694 7.2192 16.5694C9.44222 16.5694 11.2408 18.368 11.2408 20.591C11.2408 22.814 9.43502 24.6126 7.2192 24.6126Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M7.21921 24.6135C9.44029 24.6135 11.2408 22.813 11.2408 20.5919C11.2408 18.3708 9.44029 16.5703 7.21921 16.5703C4.99814 16.5703 3.19763 18.3708 3.19763 20.5919C3.19763 22.813 4.99814 24.6135 7.21921 24.6135Z",
                        fill: "#6CAFF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M11.0398 20.5547C11.0398 22.6626 9.32759 24.3748 7.21967 24.3748C5.11176 24.3748 3.39233 22.6626 3.39233 20.5547H11.0398Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M10.7375 20.5547C10.7375 22.6122 9.11165 24.2957 7.06848 24.3748H7.21956C9.32747 24.3748 11.0397 22.6626 11.0397 20.5547H10.7375Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M11.0326 20.5885C11.0326 20.1497 10.27 19.8979 9.25564 19.8116C8.52183 19.754 7.78082 19.826 6.9319 20.0849C6.19809 20.3008 5.53622 20.2648 5.0542 20.2072C3.98226 20.0849 3.39233 20.0706 3.39233 20.5885C3.39233 21.3367 4.91751 22.272 7.20528 21.9483C8.36356 21.7828 8.96068 21.4447 9.64413 21.2144C10.3851 20.9698 11.0326 20.977 11.0326 20.5885Z",
                        fill: "#7EB8F5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.52875 19.2577C9.67976 19.2577 9.80213 19.1353 9.80213 18.9843C9.80213 18.8333 9.67976 18.7109 9.52875 18.7109C9.37774 18.7109 9.25537 18.8333 9.25537 18.9843C9.25537 19.1353 9.37774 19.2577 9.52875 19.2577Z",
                        fill: "#55A6FA",
                        fillOpacity: 0.53
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M8.47097 18.7754C8.82859 18.7754 9.11845 18.4856 9.11845 18.128C9.11845 17.7703 8.82859 17.4805 8.47097 17.4805C8.11334 17.4805 7.82349 17.7703 7.82349 18.128C7.82349 18.4856 8.11334 18.7754 8.47097 18.7754Z",
                        fill: "#55A6FA",
                        fillOpacity: 0.53
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.16923 22.2728C9.20894 22.2728 9.24118 22.2406 9.24118 22.2008C9.24118 22.1611 9.20894 22.1289 9.16923 22.1289C9.12952 22.1289 9.09729 22.1611 9.09729 22.2008C9.09729 22.2406 9.12952 22.2728 9.16923 22.2728Z",
                        fill: "white",
                        fillOpacity: 0.3
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 21.5,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2726 16.668L24.1966 23.4457L25.4961 21.178L22.8716 16.668H20.2726Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2726 21.3047L21.623 23.445H24.324L22.9735 21.3047H20.2726Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.1005 18.8086L17.75 21.1273L19.1005 23.446L21.8269 18.8086H19.1005Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("radialGradient", {
                        id: "paint0_radial_9706_95038",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.6708 16.4463) scale(3.21543 3.21542)",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#C2DBF5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BCD8F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip0_9706_95038",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 10,
                            height: 10,
                            fill: "white",
                            transform: "translate(2.5 15)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $d95c28b579ea6a16$export$2e2bcd8739ae039 = $d95c28b579ea6a16$var$SvgCosmosCategory;




var $exYeM = parcelRequire("exYeM");

function $1b852c4a9413eaa0$var$SvgCreditCard(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M23.9529 17.8164V6.88069C23.9529 5.29233 22.6605 4 21.0722 4H2.88069C1.29233 4 0 5.29244 0 6.88069V17.8164C0 19.4047 1.29244 20.6971 2.88069 20.6971H21.0722C22.6606 20.6971 23.9529 19.4046 23.9529 17.8164ZM2.88042 5.40869H21.072C21.8836 5.40869 22.5441 6.06918 22.5441 6.8808V8.5537H1.40826V6.8808C1.40826 6.06918 2.06881 5.40869 2.88042 5.40869ZM1.40831 17.8164V9.96239H22.5441V17.8164C22.5441 18.628 21.8836 19.2885 21.072 19.2885H2.88047C2.06886 19.2885 1.40831 18.628 1.40831 17.8164Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M20.2882 15.6025H17.66C17.2711 15.6025 16.9551 15.9175 16.9551 16.3074C16.9551 16.6963 17.27 17.0123 17.66 17.0123H20.2882C20.6771 17.0123 20.9931 16.6974 20.9931 16.3074C20.992 15.9175 20.6771 15.6025 20.2882 15.6025Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $1b852c4a9413eaa0$export$2e2bcd8739ae039 = $1b852c4a9413eaa0$var$SvgCreditCard;




var $exYeM = parcelRequire("exYeM");

function $0a7569fdef68b632$var$SvgCustomColors(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.3172 1.14659C18.8459 -0.382197 21.3246 -0.382197 22.8534 1.14659C24.3822 2.67538 24.3822 5.15404 22.8534 6.68283L21.9458 7.59042C21.4696 8.06664 21.4696 8.83873 21.9458 9.31494C22.9734 10.3425 22.9734 12.0084 21.9458 13.036C20.9183 14.0635 19.2523 14.0635 18.2248 13.036L10.964 5.77524C9.93643 4.7477 9.93643 3.08172 10.964 2.05419C11.9915 1.02665 13.6575 1.02665 14.685 2.05419C15.1612 2.5304 15.9333 2.5304 16.4096 2.05419L17.3172 1.14659ZM21.8551 2.14486C20.8777 1.16739 19.2929 1.16739 18.3154 2.14486L17.4078 3.05245C16.3803 4.07999 14.7143 4.07999 13.6868 3.05245C13.2105 2.57624 12.4384 2.57624 11.9622 3.05245C11.486 3.52866 11.486 4.30076 11.9622 4.77697L19.223 12.0377C19.6992 12.5139 20.4713 12.5139 20.9475 12.0377C21.4238 11.5615 21.4238 10.7894 20.9475 10.3132C19.92 9.28567 19.92 7.6197 20.9475 6.59216L21.8551 5.68456C22.8326 4.7071 22.8326 3.12232 21.8551 2.14486ZM11.4177 9.85952C11.1922 9.63393 10.8264 9.63393 10.6008 9.85951L3.49641 16.9639C2.33926 18.121 1.62441 19.6473 1.47625 21.277L1.41434 21.9581C1.38168 22.3173 1.68265 22.6183 2.04192 22.5857L2.72301 22.5237C4.35276 22.3756 5.87898 21.6607 7.03613 20.5036L14.1405 13.3992C14.3661 13.1736 14.3661 12.8079 14.1405 12.5823L11.4177 9.85952ZM9.60255 8.86125C10.3795 8.08433 11.6391 8.08434 12.416 8.86125L15.1388 11.584C15.9157 12.3609 15.9157 13.6206 15.1388 14.3975L8.0344 21.5019C6.64371 22.8925 4.80947 23.7517 2.85082 23.9297L2.16973 23.9916C0.932446 24.1041 -0.104108 23.0676 0.00837295 21.8303L0.0702906 21.1492C0.24835 19.1905 1.10746 17.3563 2.49815 15.9656L9.60255 8.86125Z",
            fill: "currentColor"
        })
    }));
}
var $0a7569fdef68b632$export$2e2bcd8739ae039 = $0a7569fdef68b632$var$SvgCustomColors;




var $exYeM = parcelRequire("exYeM");

function $455f94f5acae486c$var$SvgCustomTokensZeroState(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 200 173",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "#F3F8FC",
                d: "M44.167 61.576C5.142 56.15 5.23 102.127 11.919 116.708c12.94 28.225 62.797 48.735 69.176 24.965 9.46-35.247 62.915-2.897 85.22-4.754 22.304-1.858 24.25-31.86 6.499-46.34-17.752-14.48-5.966-32.553-8.561-48.994-2.595-16.44-24.489-29.104-48.396-14.093-22.582 14.178-17.514 41.617-71.69 34.084Z"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                stroke: "#002D5E",
                strokeLinecap: "round",
                strokeWidth: 0.877,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M36.509 80.67c-2.554-2.055-5.828-1.903-10.124-.734M41.066 73.016c-2.62-3.294-3.184-5.288-3.688-9.6M37.608 75.705c-3.2-2.95-7.364-5.582-11.294-7.717"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                stroke: "#002D5E",
                strokeDasharray: "3.51 2.63",
                strokeWidth: 0.877,
                d: "M141.301 100.922c.348-3.058.581-6.172 1.492-9.117.782-2.524 2.02-4.717 3.768-6.66 1.456-1.62 3.195-3.075 5.223-3.867 1.97-.77 4.154-1.006 6.255-1.001 2.518.006 5.171.328 7.493 1.421 1.803.849 3.288 2.637 4.303 4.351 1.759 2.97 1.247 6.634-.92 9.22-.764.91-1.753 1.771-2.862 2.203-1.564.609-3.035.013-4.129-1.244-2.476-2.843-1.619-7.39-.322-10.552 1.524-3.715 4.277-6.931 7.534-9.149 2.361-1.607 5.028-2.739 7.68-3.736 2.619-.984 5.281-1.656 7.97-2.393"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 186.116,
                cy: 70.399,
                r: 2.746,
                fill: "#002D5E"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                stroke: "#fff",
                strokeWidth: 0.407,
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 99.809,
                        height: 28.4,
                        x: 46.977,
                        y: 112.419,
                        fill: "#D6E8F9",
                        fillOpacity: 0.5,
                        rx: 4.404
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 70.596,
                        height: 4.056,
                        x: 70.917,
                        y: 120.126,
                        fill: "#F5FAFF",
                        rx: 2.028
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 70.596,
                        height: 4.056,
                        x: 70.917,
                        y: 129.868,
                        fill: "#F5FAFF",
                        rx: 2.028
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#F5FAFF",
                        d: "M67.263 126.82a7.911 7.911 0 1 1-15.822 0 7.911 7.911 0 0 1 15.822 0Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                stroke: "#fff",
                strokeWidth: 0.407,
                filter: "url(#b)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 99.809,
                        height: 28.4,
                        x: 46.978,
                        y: 44.592,
                        fill: "#D6E8F9",
                        fillOpacity: 0.5,
                        rx: 4.404
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 70.596,
                        height: 4.056,
                        x: 70.917,
                        y: 52.3,
                        fill: "#F5FAFF",
                        rx: 2.028
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 70.596,
                        height: 4.056,
                        x: 70.917,
                        y: 62.041,
                        fill: "#F5FAFF",
                        rx: 2.028
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#F5FAFF",
                        d: "M67.263 59a7.911 7.911 0 1 1-15.822 0 7.911 7.911 0 0 1 15.822 0Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                filter: "url(#c)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                    width: 108.517,
                    height: 31.193,
                    x: 38.475,
                    y: 76.075,
                    fill: "#fff",
                    rx: 4.99
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                width: 75.27,
                height: 4.731,
                x: 66.133,
                y: 84.572,
                fill: "#E6F2FF",
                rx: 2.366
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                width: 75.27,
                height: 4.731,
                x: 66.133,
                y: 94.894,
                fill: "#E6F2FF",
                rx: 2.366
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                filter: "url(#d)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 52.386,
                    cy: 91.607,
                    r: 9.749,
                    stroke: "#002D5E",
                    strokeDasharray: "1.78 1.34",
                    strokeWidth: 0.446
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                filter: "url(#e)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 54.492,
                        cy: 91.848,
                        r: 9.99,
                        fill: "#E5F2FF"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 54.492,
                        cy: 91.848,
                        r: 9.896,
                        stroke: "#fff",
                        strokeWidth: 0.188
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                stroke: "#002D5E",
                strokeLinecap: "round",
                strokeWidth: 0.754,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "m53.224 90.58 2.534 2.534M53.224 93.114l2.534-2.534"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 54.491,
                cy: 91.847,
                r: 4.15,
                stroke: "#002D5E",
                strokeWidth: 0.754
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "a",
                        width: 100.984,
                        height: 29.575,
                        x: 46.39,
                        y: 111.831,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                result: "effect1_foregroundBlur_19281_419764",
                                stdDeviation: 0.192
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "b",
                        width: 100.984,
                        height: 29.575,
                        x: 46.39,
                        y: 44.005,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                result: "effect1_foregroundBlur_19281_419764",
                                stdDeviation: 0.192
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "c",
                        width: 116.833,
                        height: 39.509,
                        x: 33.07,
                        y: 74.827,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feOffset", {
                                dx: -1.247,
                                dy: 2.911
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 2.079
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.507031 0 0 0 0 0.626875 0 0 0 0 0.7375 0 0 0 0.49 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_19281_419764"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_19281_419764",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "d",
                        width: 21.73,
                        height: 21.73,
                        x: 41.521,
                        y: 80.742,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 0.446
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_19281_419764"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_19281_419764",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "e",
                        width: 22.994,
                        height: 24.285,
                        x: 42.995,
                        y: 81.104,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 0.377
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_19281_419764"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feOffset", {
                                dy: 2.044
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 0.754
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.814115 0 0 0 0 0.882372 0 0 0 0 0.9625 0 0 0 0.33 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in2: "effect1_backgroundBlur_19281_419764",
                                result: "effect2_dropShadow_19281_419764"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_19281_419764",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var $455f94f5acae486c$export$2e2bcd8739ae039 = $455f94f5acae486c$var$SvgCustomTokensZeroState;




var $exYeM = parcelRequire("exYeM");

function $5d38c93c2f96b486$var$SvgCustomTokensZeroStateDark(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 200 173",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                id: "Custom Tokens",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        id: "Vector 10",
                        d: "M44.167 61.5761C5.14181 56.15 5.22992 102.127 11.9196 116.708C24.8586 144.933 74.7156 165.443 81.0951 141.673C90.5545 106.426 144.01 138.776 166.315 136.919C188.62 135.061 190.565 105.059 172.814 90.5792C155.062 76.099 166.849 58.0255 164.253 41.585C161.658 25.1445 139.764 12.4813 115.857 27.4918C93.2754 41.6699 98.3432 69.1088 44.167 61.5761Z",
                        fill: "#111112"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        id: "Group 1000007805",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                id: "Vector 5",
                                d: "M33.3549 82.5155C30.8013 80.4597 27.5271 80.6121 23.2312 81.7805",
                                stroke: "#D1D1D1",
                                strokeWidth: 0.876984,
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                id: "Vector 6",
                                d: "M37.9128 74.8615C35.292 71.5671 34.7292 69.5732 34.2246 65.261",
                                stroke: "#D1D1D1",
                                strokeWidth: 0.876984,
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                id: "Vector 7",
                                d: "M34.4533 77.5497C31.2532 74.6003 27.0895 71.9673 23.1592 69.833",
                                stroke: "#D1D1D1",
                                strokeWidth: 0.876984,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        id: "Group 1000007806",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                id: "Vector 2",
                                d: "M138.142 102.767C138.49 99.7086 138.723 96.5943 139.635 93.6495C140.416 91.126 141.655 88.9323 143.402 86.9893C144.858 85.3701 146.598 83.9147 148.625 83.1229C150.596 82.3531 152.779 82.1166 154.881 82.1214C157.399 82.1272 160.052 82.4497 162.373 83.5426C164.176 84.3912 165.662 86.1799 166.677 87.8937C168.435 90.8633 167.923 94.5274 165.757 97.113C164.993 98.0243 164.003 98.885 162.895 99.3162C161.33 99.9252 159.86 99.3294 158.765 98.0726C156.289 95.2291 157.146 90.6821 158.443 87.5208C159.967 83.8057 162.721 80.5889 165.978 78.3715C168.338 76.7645 171.005 75.6328 173.657 74.6358C176.276 73.6511 178.939 72.9793 181.628 72.2427",
                                stroke: "#D1D1D1",
                                strokeWidth: 0.876984,
                                strokeDasharray: "3.51 2.63"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                id: "Ellipse 1940",
                                cx: 182.957,
                                cy: 72.2431,
                                r: 2.74629,
                                fill: "#D1D1D1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        id: "Group 1000007807",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                id: "Group 1000007810",
                                filter: "url(#filter0_f_19281_419835)",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Group 1000007748",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                                id: "Rectangle 6610",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                        x: 43.6162,
                                                        y: 113.849,
                                                        width: 100.216,
                                                        height: 28.8071,
                                                        rx: 4.60784,
                                                        fill: "#444444",
                                                        fillOpacity: 0.5
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                        x: 43.8197,
                                                        y: 114.053,
                                                        width: 99.8093,
                                                        height: 28.4001,
                                                        rx: 4.40431,
                                                        stroke: "#787878",
                                                        strokeOpacity: 0.25,
                                                        strokeWidth: 0.407059
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                id: "Rectangle 6611",
                                                x: 67.5557,
                                                y: 121.557,
                                                width: 71.0035,
                                                height: 4.46308,
                                                rx: 2.23154,
                                                fill: "#343434"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                id: "Rectangle 6612",
                                                x: 67.5557,
                                                y: 131.298,
                                                width: 71.0035,
                                                height: 4.46308,
                                                rx: 2.23154,
                                                fill: "#343434"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Ellipse 1952",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ellipse", {
                                                cx: 56.1948,
                                                cy: 128.461,
                                                rx: 8.11468,
                                                ry: 8.11468,
                                                fill: "#3F3F3F"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                d: "M64.2094 128.461C64.2094 132.887 60.6211 136.475 56.1948 136.475C51.7684 136.475 48.1801 132.887 48.1801 128.461C48.1801 124.034 51.7684 120.446 56.1948 120.446C60.6211 120.446 64.2094 124.034 64.2094 128.461Z",
                                                stroke: "#787878",
                                                strokeOpacity: 0.25,
                                                strokeWidth: 0.2
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                id: "Group 1000007822",
                                filter: "url(#filter1_f_19281_419835)",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Group 1000007748_2",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                                id: "Rectangle 6610_2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                        x: 43.6162,
                                                        y: 46.2336,
                                                        width: 100.216,
                                                        height: 28.8071,
                                                        rx: 4.60784,
                                                        fill: "#444444",
                                                        fillOpacity: 0.5
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                        x: 43.8197,
                                                        y: 46.4372,
                                                        width: 99.8093,
                                                        height: 28.4001,
                                                        rx: 4.40431,
                                                        stroke: "#787878",
                                                        strokeOpacity: 0.25,
                                                        strokeWidth: 0.407059
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                id: "Rectangle 6611_2",
                                                x: 67.5557,
                                                y: 53.9412,
                                                width: 71.0035,
                                                height: 4.46308,
                                                rx: 2.23154,
                                                fill: "#343434"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                id: "Rectangle 6612_2",
                                                x: 67.5557,
                                                y: 63.6826,
                                                width: 71.0035,
                                                height: 4.46308,
                                                rx: 2.23154,
                                                fill: "#343434"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Ellipse 1952_2",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ellipse", {
                                                cx: 56.1948,
                                                cy: 60.8449,
                                                rx: 8.11468,
                                                ry: 8.11468,
                                                fill: "#3F3F3F"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                d: "M64.2094 60.8449C64.2094 65.2713 60.6211 68.8596 56.1948 68.8596C51.7684 68.8596 48.1801 65.2713 48.1801 60.8449C48.1801 56.4185 51.7684 52.8302 56.1948 52.8302C60.6211 52.8302 64.2094 56.4185 64.2094 60.8449Z",
                                                stroke: "#787878",
                                                strokeOpacity: 0.25,
                                                strokeWidth: 0.2
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                id: "Group 1000007811",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Rectangle 6610_3",
                                        filter: "url(#filter2_d_19281_419835)",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                x: 35.3213,
                                                y: 78.5015,
                                                width: 106.238,
                                                height: 30.538,
                                                rx: 4.88471,
                                                fill: "#414141"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                                x: 35.5248,
                                                y: 78.705,
                                                width: 105.831,
                                                height: 30.131,
                                                rx: 4.68118,
                                                stroke: "#313134",
                                                strokeWidth: 0.407059
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                        id: "Group 1000007823",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                                id: "Group 1000007726",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                                        id: "Ellipse 1938",
                                                        filter: "url(#filter3_bd_19281_419835)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                                                cx: 52.4858,
                                                                cy: 93.5847,
                                                                r: 9.88228,
                                                                fill: "#363636"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                                                cx: 52.4858,
                                                                cy: 93.5847,
                                                                r: 9.78911,
                                                                stroke: "#787878",
                                                                strokeWidth: 0.186346
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                                                        id: "Group 1000007725",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                id: "Line 351",
                                                                d: "M51.2324 92.3315L53.7389 94.838",
                                                                stroke: "white",
                                                                strokeWidth: 0.745383,
                                                                strokeLinecap: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                id: "Line 352",
                                                                d: "M51.2324 94.8362L53.7389 92.3297",
                                                                stroke: "white",
                                                                strokeWidth: 0.745383,
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                                        id: "Ellipse 1939",
                                                        cx: 52.4894,
                                                        cy: 93.5833,
                                                        r: 4.10556,
                                                        fill: "#B6B6B6",
                                                        fillOpacity: 0.38,
                                                        stroke: "#B8B8B8",
                                                        strokeWidth: 0.745383
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                                                id: "Group 1000007808",
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                                                    id: "Group 1000007740",
                                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                                                        id: "Ellipse 1941",
                                                        filter: "url(#filter4_b_19281_419835)",
                                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                                            cx: 51.3139,
                                                            cy: 94.4919,
                                                            r: 9.74949,
                                                            stroke: "#A5A5A5",
                                                            strokeWidth: 0.446247,
                                                            strokeDasharray: "1.78 1.34"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                        id: "Rectangle 6611_3",
                                        x: 66.5283,
                                        y: 86.8232,
                                        width: 69.6961,
                                        height: 4.16096,
                                        rx: 2.08048,
                                        fill: "#5A5A5A"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                        id: "Rectangle 6612_3",
                                        x: 66.5283,
                                        y: 97.2258,
                                        width: 69.6961,
                                        height: 4.16096,
                                        rx: 2.08048,
                                        fill: "#5A5A5A"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "filter0_f_19281_419835",
                        x: 43.2322,
                        y: 113.465,
                        width: 100.985,
                        height: 29.5751,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 0.191993,
                                result: "effect1_foregroundBlur_19281_419835"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "filter1_f_19281_419835",
                        x: 43.2322,
                        y: 45.8497,
                        width: 100.985,
                        height: 29.5751,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 0.191993,
                                result: "effect1_foregroundBlur_19281_419835"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "filter2_d_19281_419835",
                        x: 22.044,
                        y: 70.5351,
                        width: 132.793,
                        height: 57.0927,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feOffset", {
                                dy: 5.31093
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 6.63866
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0352941 0 0 0 0 0.0352941 0 0 0 0 0.0352941 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_19281_419835"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_19281_419835",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "filter3_bd_19281_419835",
                        x: 38.8766,
                        y: 81.4662,
                        width: 27.2185,
                        height: 27.2185,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 0.372692
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_19281_419835"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feOffset", {
                                dy: 1.49077
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 1.86346
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0352941 0 0 0 0 0.0352941 0 0 0 0 0.0352941 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_backgroundBlur_19281_419835",
                                result: "effect2_dropShadow_19281_419835"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_19281_419835",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("filter", {
                        id: "filter4_b_19281_419835",
                        x: 40.4493,
                        y: 83.6268,
                        width: 21.7293,
                        height: 21.7303,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 0.446247
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_19281_419835"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_19281_419835",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var $5d38c93c2f96b486$export$2e2bcd8739ae039 = $5d38c93c2f96b486$var$SvgCustomTokensZeroStateDark;




var $exYeM = parcelRequire("exYeM");

function $0a3c0adda0f506a9$var$SvgCustomerSupport(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.49131 8.93104C2.71953 9.28416 1.38428 10.8479 1.38428 12.7235C1.38428 14.8592 3.11564 16.5906 5.25138 16.5906C5.78253 16.5906 6.24657 16.4827 6.63097 16.2429C7.01948 16.0007 7.27541 15.6557 7.44145 15.2719C7.75496 14.5475 7.77693 13.6023 7.77693 12.7235C7.77693 11.8447 7.75496 10.8995 7.44145 10.175C7.27541 9.79129 7.01948 9.44629 6.63097 9.204C6.3719 9.04244 6.07667 8.94075 5.74909 8.89161C6.48712 6.61874 8.95994 4.86602 12 4.86602C15.0401 4.86602 17.5129 6.61873 18.251 8.8916C17.9233 8.94073 17.6281 9.04242 17.369 9.204C16.9805 9.44629 16.7245 9.79129 16.5585 10.175C16.245 10.8995 16.223 11.8447 16.223 12.7235C16.223 13.6023 16.245 14.5475 16.5585 15.2719C16.7245 15.6557 16.9805 16.0007 17.369 16.2429C17.5371 16.3478 17.7204 16.4274 17.9179 16.4838V16.8817C17.9179 18.2196 16.5072 19.518 14.4726 19.518H12.4499C12.1186 19.518 11.8499 19.7866 11.8499 20.118C11.8499 20.4493 12.1186 20.718 12.4499 20.718H14.4726C16.9062 20.718 19.1179 19.1184 19.1179 16.8817V16.5732C21.0804 16.3872 22.6157 14.7346 22.6157 12.7235C22.6157 10.8479 21.2805 9.28423 19.5087 8.93106C19.507 8.92282 19.5052 8.91459 19.5031 8.90635C18.7376 5.85484 15.6181 3.66602 12 3.66602C8.38194 3.66602 5.26244 5.85484 4.49696 8.90635C4.4949 8.91458 4.49302 8.92281 4.49131 8.93104ZM5.25138 10.0564C3.77838 10.0564 2.58428 11.2505 2.58428 12.7235C2.58428 14.1965 3.77838 15.3906 5.25138 15.3906C5.62242 15.3906 5.85017 15.3156 5.99597 15.2247C6.13766 15.1364 6.25034 15.0029 6.34014 14.7954C6.53832 14.3374 6.57693 13.649 6.57693 12.7235C6.57693 11.7979 6.53832 11.1095 6.34014 10.6516C6.25034 10.444 6.13766 10.3106 5.99597 10.2222C5.85017 10.1313 5.62242 10.0564 5.25138 10.0564ZM17.6598 10.6516C17.4616 11.1095 17.423 11.7979 17.423 12.7235C17.423 13.649 17.4616 14.3374 17.6598 14.7954C17.7496 15.0029 17.8623 15.1364 18.004 15.2247C18.1498 15.3156 18.3775 15.3906 18.7486 15.3906C20.2216 15.3906 21.4157 14.1965 21.4157 12.7235C21.4157 11.2505 20.2216 10.0564 18.7486 10.0564C18.3775 10.0564 18.1498 10.1313 18.004 10.2222C17.8623 10.3106 17.7496 10.444 17.6598 10.6516Z",
            fill: "currentColor"
        })
    }));
}
var $0a3c0adda0f506a9$export$2e2bcd8739ae039 = $0a3c0adda0f506a9$var$SvgCustomerSupport;




var $exYeM = parcelRequire("exYeM");

function $79da6f5c8cc6e6a6$var$SvgDarkMode(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.37258 9.78494C9.37258 7.99775 10.1423 6.33088 11.4437 5.17318C11.7175 4.92967 11.5567 4.44003 11.1963 4.50607C7.66917 5.15238 4.97201 8.27321 5.00022 12.0067C5.03199 16.1273 8.40939 19.4968 12.5607 19.5C15.3021 19.502 17.82 17.9874 19.1426 15.6485C19.3229 15.3297 18.918 15.0255 18.6027 15.2119C14.6912 17.5249 9.37258 15.3579 9.37258 9.78494Z",
            fill: "currentColor"
        })
    }));
}
var $79da6f5c8cc6e6a6$export$2e2bcd8739ae039 = $79da6f5c8cc6e6a6$var$SvgDarkMode;




var $exYeM = parcelRequire("exYeM");

function $5a11d8a29a0f97e3$var$SvgDelete(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40135)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.42673 4.10987C6.81047 1.73825 8.80256 0 11.1368 0H13.773C16.1072 0 18.0993 1.73825 18.483 4.10987C18.4847 4.1205 18.4862 4.13118 18.4874 4.14188L18.5405 4.60777C19.409 4.71723 20.1677 4.84185 20.8164 4.96697C20.8225 4.96804 20.8285 4.96921 20.8345 4.97045C21.7656 5.15059 22.4685 5.33139 22.9433 5.46895C23.1816 5.53796 23.3623 5.59608 23.4856 5.63775C23.5473 5.65859 23.5946 5.67531 23.6275 5.68723L23.6661 5.70141L23.6773 5.70564L23.6809 5.70701L23.6821 5.7075L23.6827 5.7077C23.6829 5.70779 23.6831 5.70787 23.4549 6.33476L23.6831 5.70787C24.0192 5.8377 24.1895 6.22362 24.0635 6.56985C23.9375 6.91583 23.5633 7.09125 23.2274 6.96194C23.2272 6.96189 23.2271 6.96185 23.227 6.9618L23.2266 6.96166L23.2222 6.95999L23.1963 6.95049C23.1719 6.94166 23.1333 6.92796 23.0803 6.91006C22.9745 6.87428 22.8115 6.82175 22.5914 6.75799C22.278 6.6672 21.8487 6.55361 21.3036 6.43317L20.5397 18.1139L20.5395 18.1166C20.3096 21.4316 17.6317 24 14.4051 24H10.5046C7.27806 24 4.6001 21.4316 4.37022 18.1166L4.37004 18.1139L3.60614 6.43317C3.06101 6.55361 2.63175 6.6672 2.31835 6.75799C2.09824 6.82175 1.93526 6.87428 1.82939 6.91006C1.77645 6.92796 1.7378 6.94166 1.71341 6.95049L1.68755 6.95999L1.68309 6.96166L1.68274 6.9618C1.34671 7.09138 0.972254 6.91596 0.84625 6.56985C0.720202 6.22362 0.890505 5.8377 1.22663 5.70787L1.45486 6.33476C1.22663 5.70787 1.22684 5.70779 1.22707 5.7077L1.22758 5.7075L1.22887 5.70701L1.23245 5.70564L1.24366 5.70141L1.28225 5.68723C1.31516 5.67531 1.36244 5.65859 1.42409 5.63775C1.54739 5.59608 1.72815 5.53796 1.96638 5.46895C2.44118 5.33139 3.14416 5.15059 4.07525 4.97045C4.08123 4.9692 4.08724 4.96804 4.09327 4.96697C4.74202 4.84186 5.50068 4.71723 6.36923 4.60777L6.42232 4.14188C6.42354 4.13118 6.42501 4.1205 6.42673 4.10987ZM7.01295 5.87877C7.02196 5.87794 7.03092 5.87693 7.03984 5.87573C8.53259 5.70737 10.3376 5.58798 12.4549 5.58798C14.5722 5.58798 16.3771 5.70737 17.8699 5.87573C17.8788 5.87693 17.8878 5.87794 17.8968 5.87877C18.6928 5.96908 19.3996 6.07327 20.0172 6.18058L19.2428 18.0212C19.2428 18.0217 19.2427 18.0222 19.2427 18.0227C19.0607 20.6363 16.9491 22.6609 14.4051 22.6609H10.5046C7.96052 22.6609 5.84891 20.6361 5.66701 18.0225C5.66698 18.022 5.66695 18.0216 5.66692 18.0212L4.89257 6.18058C5.51014 6.07327 6.21693 5.96908 7.01295 5.87877ZM17.215 4.46238C15.8455 4.33369 14.2588 4.24893 12.4549 4.24893C10.6509 4.24893 9.0642 4.33369 7.69472 4.46238L7.71155 4.31473C7.99687 2.5966 9.44306 1.33906 11.1368 1.33906H13.773C15.4667 1.33906 16.9129 2.59661 17.1982 4.31474L17.215 4.46238ZM12.4549 9.91416C12.8138 9.91416 13.1049 10.2139 13.1049 10.5837V17.6652C13.1049 18.035 12.8138 18.3348 12.4549 18.3348C12.0959 18.3348 11.8049 18.035 11.8049 17.6652L11.8049 10.5837C11.8049 10.2139 12.0959 9.91416 12.4549 9.91416ZM9.01736 11.3305C9.37635 11.3305 9.66736 11.6302 9.66736 12V16.2489C9.66736 16.6187 9.37635 16.9185 9.01736 16.9185C8.65838 16.9185 8.36736 16.6187 8.36736 16.2489V12C8.36736 11.6302 8.65838 11.3305 9.01736 11.3305ZM15.8924 11.3305C16.2513 11.3305 16.5424 11.6302 16.5424 12V16.2489C16.5424 16.6187 16.2513 16.9185 15.8924 16.9185C15.5334 16.9185 15.2424 16.6187 15.2424 16.2489V12C15.2424 11.6302 15.5334 11.3305 15.8924 11.3305Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_3736_40135",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.45459)"
                    })
                })
            })
        ]
    }));
}
var $5a11d8a29a0f97e3$export$2e2bcd8739ae039 = $5a11d8a29a0f97e3$var$SvgDelete;




var $exYeM = parcelRequire("exYeM");

function $4dc7445fdaabbc45$var$SvgDesktop(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 228 165",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M37.772 108.328C37.772 90.9014 51.9386 76.78 69.4209 76.78H74.9067V68.0667C74.9067 52.2627 87.7472 39.4032 103.662 39.4032C119.517 39.4032 132.417 52.2026 132.417 68.0667C132.417 80.9263 142.907 91.3822 155.807 91.3822H181.127C183.9 91.3822 186.552 91.923 189.024 92.8844V108.328H37.772Z",
                fill: "url(#paint0_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M82.3193 143.601H140.372C142.724 143.601 144.231 141.017 143.025 138.974L134.646 124.913C130.124 117.341 127.713 108.628 127.713 99.7948H95.0994C95.0994 108.628 92.6881 117.281 88.1668 124.913L79.7874 138.974C78.5817 141.017 80.0285 143.601 82.4398 143.601H82.3193Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M140.373 144.202H82.3198C80.9936 144.202 79.7879 143.541 79.1248 142.339C78.4617 141.197 78.4617 139.815 79.1248 138.674L87.5042 124.612C91.9652 117.101 94.3766 108.568 94.3766 99.8547V99.2538H128.196V99.8547C128.196 108.568 130.547 117.161 135.068 124.612L143.447 138.674C144.111 139.815 144.171 141.197 143.447 142.339C142.784 143.481 141.579 144.202 140.252 144.202H140.373ZM95.6425 100.456C95.5219 109.169 93.1106 117.762 88.6496 125.273L80.2702 139.335C79.7879 140.116 79.7879 141.017 80.2702 141.798C80.6922 142.58 81.5361 143.06 82.3801 143.06H140.433C141.338 143.06 142.121 142.58 142.543 141.798C142.965 141.017 142.965 140.116 142.543 139.335L134.164 125.273C129.703 117.762 127.231 109.229 127.171 100.456H95.7631H95.6425Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M33.6713 117.341L189.083 117.341C194.043 117.341 198.065 113.333 198.065 108.388V9.77779C198.065 4.83286 194.043 0.824196 189.083 0.824196L33.6713 0.824196C28.7106 0.824196 24.6891 4.83286 24.6891 9.77779V108.388C24.6891 113.333 28.7106 117.341 33.6713 117.341Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M189.022 117.942H33.611C28.306 117.942 24.0259 113.676 24.0259 108.388V9.77803C24.0259 4.48999 28.306 0.223511 33.611 0.223511H189.022C194.327 0.223511 198.607 4.48999 198.607 9.77803V108.388C198.607 113.676 194.327 117.942 189.022 117.942ZM33.611 1.42534C28.9691 1.42534 25.2316 5.151 25.2316 9.77803V108.388C25.2316 113.015 28.9691 116.741 33.611 116.741H189.022C193.664 116.741 197.402 113.015 197.402 108.388V9.77803C197.402 5.151 193.664 1.42534 189.022 1.42534H33.611Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M189.022 108.328V9.83826L33.7312 9.83826V108.328L189.022 108.328Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M189.626 108.929H33.0688V9.23718H189.626V108.929ZM34.3348 107.727H188.42V10.439H34.2745V107.727H34.3348Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M37.772 108.328C37.772 90.9014 51.9386 76.78 69.4209 76.78H74.9067V68.0667C74.9067 52.2627 87.7472 39.4032 103.662 39.4032C119.517 39.4032 132.417 52.2026 132.417 68.0667C132.417 80.9263 142.907 91.3822 155.807 91.3822H181.127C183.9 91.3822 186.552 91.923 189.024 92.8844V108.328H37.772Z",
                fill: "url(#paint1_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                opacity: 0.8,
                d: "M179.98 91.3822V104.122C176.484 103.761 173.229 102.559 170.456 100.696V91.3822H179.98Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M186.972 143.601H218.138C222.001 143.601 225.131 140.481 225.131 136.631V62.2979C225.131 58.4482 222.001 55.3273 218.138 55.3273H186.972C183.11 55.3273 179.979 58.4482 179.979 62.2979V136.631C179.979 140.481 183.11 143.601 186.972 143.601Z",
                fill: "#D6EAFF"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M218.14 144.202H186.973C182.753 144.202 179.377 140.777 179.377 136.631V62.2979C179.377 58.0915 182.814 54.7264 186.973 54.7264H218.14C222.36 54.7264 225.736 58.1516 225.736 62.2979V136.631C225.736 140.837 222.299 144.202 218.14 144.202ZM186.973 55.9283C183.416 55.9283 180.583 58.8126 180.583 62.2979V136.631C180.583 140.176 183.477 143.001 186.973 143.001H218.14C221.697 143.001 224.53 140.116 224.53 136.631V62.2979C224.53 58.7526 221.636 55.9283 218.14 55.9283H186.973Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M220.913 62.2377V136.571C220.913 138.073 219.647 139.335 218.14 139.335H186.973C185.466 139.335 184.2 138.073 184.2 136.571V62.2377C184.2 60.7354 185.466 59.4735 186.973 59.4735H218.14C219.647 59.4735 220.913 60.7354 220.913 62.2377Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M218.139 139.996H186.972C185.103 139.996 183.596 138.493 183.596 136.631V62.2976C183.596 60.4348 185.103 58.9325 186.972 58.9325H218.139C220.008 58.9325 221.515 60.4348 221.515 62.2976V136.631C221.515 138.493 220.008 139.996 218.139 139.996ZM186.972 60.1343C185.766 60.1343 184.802 61.0958 184.802 62.2976V136.631C184.802 137.832 185.766 138.794 186.972 138.794H218.139C219.344 138.794 220.309 137.832 220.309 136.631V62.2976C220.309 61.0958 219.344 60.1343 218.139 60.1343H186.972Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                opacity: 0.8,
                d: "M167.261 91.3822V98.1124C165.332 96.1895 163.705 93.9661 162.62 91.3822H167.261Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M202.586 67.045C201.259 67.045 200.174 65.9633 200.174 64.6413C200.174 63.3193 201.259 62.2377 202.586 62.2377C203.912 62.2377 204.997 63.3193 204.997 64.6413C204.997 65.9633 203.912 67.045 202.586 67.045ZM202.586 63.4395C201.923 63.4395 201.38 63.9803 201.38 64.6413C201.38 65.3023 201.923 65.8431 202.586 65.8431C203.249 65.8431 203.791 65.3023 203.791 64.6413C203.791 63.9803 203.249 63.4395 202.586 63.4395Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M111.317 6.8935C110.292 6.8935 109.448 6.05223 109.448 5.03068C109.448 4.00912 110.292 3.16785 111.317 3.16785C112.341 3.16785 113.185 4.00912 113.185 5.03068C113.185 6.05223 112.341 6.8935 111.317 6.8935ZM111.317 4.36967C110.955 4.36967 110.653 4.67013 110.653 5.03068C110.653 5.39122 110.955 5.69168 111.317 5.69168C111.678 5.69168 111.98 5.39122 111.98 5.03068C111.98 4.67013 111.678 4.36967 111.317 4.36967Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M46.2358 75.712H39.9061C39.5444 75.712 39.3032 75.4716 39.3032 75.111C39.3032 74.7505 39.5444 74.5101 39.9061 74.5101H46.2358C46.5975 74.5101 46.8387 74.7505 46.8387 75.111C46.8387 75.4716 46.5975 75.712 46.2358 75.712Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M54.6733 75.712H48.3436C47.9819 75.712 47.7407 75.4716 47.7407 75.111C47.7407 74.7505 47.9819 74.5101 48.3436 74.5101H54.6733C55.035 74.5101 55.2762 74.7505 55.2762 75.111C55.2762 75.4716 55.035 75.712 54.6733 75.712Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M227.183 79.1236C226.822 79.1236 226.581 78.8832 226.581 78.5227V72.2131C226.581 71.8525 226.822 71.6122 227.183 71.6122C227.545 71.6122 227.786 71.8525 227.786 72.2131V78.5227C227.786 78.8832 227.545 79.1236 227.183 79.1236Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M202.588 112.715H205.422C210.907 112.715 216.152 113.856 220.914 115.959V136.571C220.914 138.073 219.648 139.335 218.141 139.335H186.975C185.468 139.335 184.202 138.073 184.202 136.571V91.5624C194.57 93.0647 202.588 101.958 202.588 112.715Z",
                fill: "url(#paint2_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                opacity: 0.8,
                d: "M197.042 98.4728C193.606 101.658 189.145 103.761 184.202 104.182V91.6224C189.265 92.3435 193.787 94.8674 197.042 98.4728Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M140.373 140.597H128.316C127.955 140.597 127.713 140.356 127.713 139.996C127.713 139.635 127.955 139.395 128.316 139.395H140.373C140.735 139.395 140.976 139.635 140.976 139.996C140.976 140.356 140.735 140.597 140.373 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M124.641 140.597H120.722C120.361 140.597 120.12 140.356 120.12 139.996C120.12 139.635 120.361 139.395 120.722 139.395H124.641C125.003 139.395 125.244 139.635 125.244 139.996C125.244 140.356 125.003 140.597 124.641 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M117.826 140.597H116.5C116.138 140.597 115.897 140.356 115.897 139.996C115.897 139.635 116.138 139.395 116.5 139.395H117.826C118.188 139.395 118.429 139.635 118.429 139.996C118.429 140.356 118.188 140.597 117.826 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                opacity: 0.8,
                d: "M49.8892 83.5102C53.0842 80.9864 56.7615 79.1235 60.7402 77.9818V87.957C56.8218 87.1157 53.1445 85.6134 49.8892 83.5102Z",
                fill: "#3F5AF3"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M113.365 140.597H97.6912C97.3295 140.597 97.0884 140.356 97.0884 139.996C97.0884 139.635 97.3295 139.395 97.6912 139.395H113.365C113.727 139.395 113.968 139.635 113.968 139.996C113.968 140.356 113.727 140.597 113.365 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M93.7137 140.597H82.3201C81.9584 140.597 81.7173 140.356 81.7173 139.996C81.7173 139.635 81.9584 139.395 82.3201 139.395H93.7137C94.0754 139.395 94.3166 139.635 94.3166 139.996C94.3166 140.356 94.0754 140.597 93.7137 140.597Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M162.063 50.1633C169.509 48.1187 173.883 40.4436 171.832 33.0205C169.781 25.5975 162.081 21.2374 154.635 23.2821C147.188 25.3267 142.814 33.0018 144.865 40.4249C146.916 47.8479 154.616 52.208 162.063 50.1633Z",
                fill: "url(#paint3_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M187.816 135.91C187.455 135.91 187.213 135.669 187.213 135.309V119.384C187.213 119.024 187.455 118.784 187.816 118.784C188.178 118.784 188.419 119.024 188.419 119.384V135.309C188.419 135.669 188.178 135.91 187.816 135.91Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M187.816 116.26C187.455 116.26 187.213 116.02 187.213 115.659V111.753C187.213 111.393 187.455 111.152 187.816 111.152C188.178 111.152 188.419 111.393 188.419 111.753V115.659C188.419 116.02 188.178 116.26 187.816 116.26Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                opacity: 0.8,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M187.816 109.469C187.455 109.469 187.213 109.229 187.213 108.868V107.967C187.213 107.606 187.455 107.366 187.816 107.366C188.178 107.366 188.419 107.606 188.419 107.967V108.868C188.419 109.229 188.178 109.469 187.816 109.469Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M210.847 96.0089C210.847 95.2878 210.244 94.7469 209.581 94.7469C208.918 94.7469 208.315 95.3479 208.315 96.0089C208.315 96.6699 208.918 97.2708 209.581 97.2708C210.244 97.2708 210.847 96.6699 210.847 96.0089Z",
                fill: "url(#paint4_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M200.48 75.9466C201.124 73.2337 199.439 70.5145 196.717 69.8731C193.996 69.2318 191.268 70.9112 190.624 73.6242C189.981 76.3372 191.666 79.0564 194.387 79.6977C197.109 80.339 199.837 78.6596 200.48 75.9466Z",
                fill: "url(#paint5_linear_7539_98594)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M218.139 139.996H186.972C185.103 139.996 183.596 138.493 183.596 136.631V62.2976C183.596 60.4348 185.103 58.9325 186.972 58.9325H218.139C220.008 58.9325 221.515 60.4348 221.515 62.2976V136.631C221.515 138.493 220.008 139.996 218.139 139.996ZM186.972 60.1343C185.766 60.1343 184.802 61.0958 184.802 62.2976V136.631C184.802 137.832 185.766 138.794 186.972 138.794H218.139C219.344 138.794 220.309 137.832 220.309 136.631V62.2976C220.309 61.0958 219.344 60.1343 218.139 60.1343H186.972Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M101.309 38.862H48.9829C46.5715 38.862 44.5822 36.879 44.5822 34.4753C44.5822 32.0717 43.1354 31.2905 41.3871 31.2905H23.7843C21.373 31.2905 19.3836 29.3075 19.3836 26.9038C19.3836 24.5002 17.9368 23.719 16.1886 23.719H4.61409C2.20274 23.719 0.213379 21.736 0.213379 19.3323C0.213379 16.9287 2.20274 14.9457 4.61409 14.9457H25.8942C28.3056 14.9457 30.2949 16.9287 30.2949 19.3323C30.2949 21.736 31.7417 22.5172 33.49 22.5172H76.1105C78.5219 22.5172 80.5112 24.5002 80.5112 26.9038C80.5112 29.3075 81.9581 30.0887 83.7063 30.0887H101.309C103.72 30.0887 105.71 32.0717 105.71 34.4753C105.71 36.879 103.72 38.862 101.309 38.862ZM4.5538 16.0874C2.80558 16.0874 1.35877 17.5296 1.35877 19.2722C1.35877 21.0149 2.80558 22.4571 4.5538 22.4571H16.1283C18.5396 22.4571 20.529 24.4401 20.529 26.8437C20.529 29.2474 21.9758 30.0286 23.724 30.0286H41.3269C43.7382 30.0286 45.7276 32.0116 45.7276 34.4153C45.7276 36.8189 47.1744 37.6001 48.9226 37.6001H101.249C102.997 37.6001 104.444 36.1579 104.444 34.4153C104.444 32.6726 102.997 31.2304 101.249 31.2304H83.646C81.2346 31.2304 79.2453 29.2474 79.2453 26.8437C79.2453 24.4401 77.7985 23.6589 76.0503 23.6589H33.4297C31.0183 23.6589 29.029 21.6759 29.029 19.2722C29.029 16.8686 27.5822 16.0874 25.8339 16.0874H4.5538Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M12.9149 45.4861C10.5035 45.4861 8.51416 43.5031 8.51416 41.0994C8.51416 38.6958 10.5035 36.7128 12.9149 36.7128C15.3262 36.7128 17.3156 38.6958 17.3156 41.0994C17.3156 43.5031 17.0744 41.7003 16.7127 41.7003C16.351 41.7003 16.1099 41.46 16.1099 41.0994C16.1099 39.3568 14.6631 37.9146 12.9149 37.9146C11.1666 37.9146 9.71984 39.3568 9.71984 41.0994C9.71984 42.8421 11.1666 44.2843 12.9149 44.2843C14.6631 44.2843 13.5177 44.5246 13.5177 44.8852C13.5177 45.2457 13.2766 45.4861 12.9149 45.4861Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M2.18466 45.4861C1.82296 45.4861 1.58182 45.2457 1.58182 44.8852C1.58182 44.5246 1.82296 44.2843 2.18466 44.2843C3.93289 44.2843 5.37969 42.8421 5.37969 41.0994C5.37969 39.3568 3.93289 37.9146 2.18466 37.9146C0.436432 37.9146 1.58182 37.6742 1.58182 37.3137C1.58182 36.9531 1.82296 36.7128 2.18466 36.7128C4.59601 36.7128 6.58537 38.6958 6.58537 41.0994C6.58537 43.5031 4.59601 45.4861 2.18466 45.4861Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M208.313 38.8621C205.902 38.8621 203.913 36.8791 203.913 34.4754C203.913 32.0718 205.902 30.0887 208.313 30.0887C210.725 30.0887 208.916 30.3291 208.916 30.6897C208.916 31.0502 208.675 31.2906 208.313 31.2906C206.565 31.2906 205.118 32.7328 205.118 34.4754C205.118 36.2181 206.565 37.6602 208.313 37.6602C210.062 37.6602 211.508 36.2181 211.508 34.4754C211.508 32.7328 211.749 33.8745 212.111 33.8745C212.473 33.8745 212.714 34.1149 212.714 34.4754C212.714 36.8791 210.725 38.8621 208.313 38.8621Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M219.95 38.8621C217.539 38.8621 215.549 36.8791 215.549 34.4754C215.549 32.0718 217.539 30.0887 219.95 30.0887C222.361 30.0887 220.553 30.3291 220.553 30.6897C220.553 31.0502 220.312 31.2906 219.95 31.2906C218.202 31.2906 216.755 32.7328 216.755 34.4754C216.755 36.2181 218.202 37.6602 219.95 37.6602C221.698 37.6602 220.553 37.9006 220.553 38.2612C220.553 38.6217 220.312 38.8621 219.95 38.8621Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M113.173 163.601L112.923 163.601L112.923 163.852L113.174 163.851L113.173 163.601ZM113.35 146.526C113.252 146.428 113.094 146.428 112.996 146.526L111.405 148.117C111.307 148.214 111.307 148.373 111.405 148.47C111.503 148.568 111.661 148.568 111.759 148.47L113.173 147.056L114.587 148.47C114.685 148.568 114.843 148.568 114.941 148.47C115.038 148.373 115.038 148.214 114.941 148.117L113.35 146.526ZM207.17 163.299L207.171 163.549L207.419 163.548L207.42 163.301L207.17 163.299ZM207.031 144.201L207.025 145.156L207.525 145.159L207.53 144.204L207.031 144.201ZM207.014 147.066L207.003 148.975L207.503 148.978L207.514 147.069L207.014 147.066ZM206.992 150.885L206.981 152.795L207.481 152.798L207.492 150.888L206.992 150.885ZM206.97 154.704L206.959 156.614L207.459 156.617L207.47 154.707L206.97 154.704ZM206.948 158.524L206.937 160.433L207.437 160.436L207.448 158.527L206.948 158.524ZM206.926 162.343L206.92 163.298L207.42 163.301L207.426 162.346L206.926 162.343ZM207.169 163.049L206.148 163.053L206.149 163.553L207.171 163.549L207.169 163.049ZM204.104 163.059L202.061 163.066L202.062 163.566L204.106 163.559L204.104 163.059ZM200.017 163.072L197.974 163.079L197.976 163.579L200.019 163.572L200.017 163.072ZM195.931 163.085L193.887 163.092L193.889 163.592L195.932 163.585L195.931 163.085ZM191.844 163.099L189.8 163.105L189.802 163.605L191.845 163.599L191.844 163.099ZM187.757 163.112L185.713 163.118L185.715 163.618L187.758 163.612L187.757 163.112ZM183.67 163.125L181.627 163.131L181.628 163.631L183.672 163.625L183.67 163.125ZM179.583 163.138L177.54 163.145L177.541 163.645L179.585 163.638L179.583 163.138ZM175.496 163.151L173.453 163.158L173.455 163.658L175.498 163.651L175.496 163.151ZM171.41 163.164L169.366 163.171L169.368 163.671L171.411 163.664L171.41 163.164ZM167.323 163.177L165.279 163.184L165.281 163.684L167.324 163.677L167.323 163.177ZM163.236 163.191L161.192 163.197L161.194 163.697L163.237 163.691L163.236 163.191ZM159.149 163.204L157.106 163.21L157.107 163.71L159.151 163.704L159.149 163.204ZM155.062 163.217L153.019 163.223L153.02 163.723L155.064 163.717L155.062 163.217ZM150.975 163.23L148.932 163.236L148.933 163.736L150.977 163.73L150.975 163.23ZM146.888 163.243L144.845 163.25L144.847 163.75L146.89 163.743L146.888 163.243ZM142.802 163.256L140.758 163.263L140.76 163.763L142.803 163.756L142.802 163.256ZM138.715 163.269L136.671 163.276L136.673 163.776L138.716 163.769L138.715 163.269ZM134.628 163.282L132.585 163.289L132.586 163.789L134.63 163.782L134.628 163.282ZM130.541 163.296L128.498 163.302L128.499 163.802L130.543 163.796L130.541 163.296ZM126.454 163.309L124.411 163.315L124.412 163.815L126.456 163.809L126.454 163.309ZM122.367 163.322L120.324 163.328L120.326 163.828L122.369 163.822L122.367 163.322ZM118.281 163.335L116.237 163.342L116.239 163.842L118.282 163.835L118.281 163.335ZM114.194 163.348L113.172 163.351L113.174 163.851L114.195 163.848L114.194 163.348ZM113.423 163.601L113.423 162.545L112.923 162.545L112.923 163.601L113.423 163.601ZM113.423 160.433L113.423 158.321L112.923 158.321L112.923 160.433L113.423 160.433ZM113.423 156.208L113.423 154.096L112.923 154.096L112.923 156.208L113.423 156.208ZM113.423 151.983L113.423 149.871L112.923 149.871L112.923 151.983L113.423 151.983ZM113.423 147.759L113.423 146.703L112.923 146.703L112.923 147.759L113.423 147.759ZM113.173 163.601L112.673 163.601L112.673 164.103L113.174 164.101L113.173 163.601ZM113.526 146.349C113.331 146.154 113.015 146.154 112.819 146.349L109.637 149.531C109.442 149.726 109.442 150.043 109.637 150.238C109.833 150.433 110.149 150.433 110.344 150.238L113.173 147.41L116.001 150.238C116.197 150.433 116.513 150.433 116.708 150.238C116.904 150.043 116.904 149.726 116.708 149.531L113.526 146.349ZM207.17 163.299L207.172 163.799L207.667 163.798L207.67 163.302L207.17 163.299ZM206.781 144.2L206.775 145.155L207.775 145.16L207.78 144.205L206.781 144.2ZM206.764 147.064L206.753 148.974L207.753 148.98L207.764 147.07L206.764 147.064ZM206.742 150.884L206.731 152.793L207.731 152.799L207.742 150.889L206.742 150.884ZM206.72 154.703L206.709 156.613L207.709 156.618L207.72 154.709L206.72 154.703ZM206.698 158.522L206.687 160.432L207.687 160.438L207.698 158.528L206.698 158.522ZM206.676 162.342L206.67 163.296L207.67 163.302L207.676 162.347L206.676 162.342ZM207.169 162.799L206.147 162.803L206.15 163.803L207.172 163.799L207.169 162.799ZM204.103 162.809L202.06 162.816L202.063 163.816L204.107 163.809L204.103 162.809ZM200.017 162.822L197.973 162.829L197.976 163.829L200.02 163.822L200.017 162.822ZM195.93 162.835L193.886 162.842L193.89 163.842L195.933 163.835L195.93 162.835ZM191.843 162.849L189.799 162.855L189.803 163.855L191.846 163.849L191.843 162.849ZM187.756 162.862L185.713 162.868L185.716 163.868L187.759 163.862L187.756 162.862ZM183.669 162.875L181.626 162.881L181.629 163.881L183.672 163.875L183.669 162.875ZM179.582 162.888L177.539 162.895L177.542 163.895L179.586 163.888L179.582 162.888ZM175.496 162.901L173.452 162.908L173.455 163.908L175.499 163.901L175.496 162.901ZM171.409 162.914L169.365 162.921L169.368 163.921L171.412 163.914L171.409 162.914ZM167.322 162.927L165.278 162.934L165.282 163.934L167.325 163.927L167.322 162.927ZM163.235 162.941L161.192 162.947L161.195 163.947L163.238 163.94L163.235 162.941ZM159.148 162.954L157.105 162.96L157.108 163.96L159.151 163.954L159.148 162.954ZM155.061 162.967L153.018 162.973L153.021 163.973L155.065 163.967L155.061 162.967ZM150.974 162.98L148.931 162.986L148.934 163.986L150.978 163.98L150.974 162.98ZM146.888 162.993L144.844 163L144.847 164L146.891 163.993L146.888 162.993ZM142.801 163.006L140.757 163.013L140.761 164.013L142.804 164.006L142.801 163.006ZM138.714 163.019L136.671 163.026L136.674 164.026L138.717 164.019L138.714 163.019ZM134.627 163.032L132.584 163.039L132.587 164.039L134.63 164.032L134.627 163.032ZM130.54 163.046L128.497 163.052L128.5 164.052L130.544 164.046L130.54 163.046ZM126.453 163.059L124.41 163.065L124.413 164.065L126.457 164.059L126.453 163.059ZM122.367 163.072L120.323 163.078L120.326 164.078L122.37 164.072L122.367 163.072ZM118.28 163.085L116.236 163.092L116.24 164.092L118.283 164.085L118.28 163.085ZM114.193 163.098L113.171 163.101L113.174 164.101L114.196 164.098L114.193 163.098ZM113.673 163.601L113.673 162.545L112.673 162.545L112.673 163.601L113.673 163.601ZM113.673 160.433L113.673 158.321L112.673 158.321L112.673 160.433L113.673 160.433ZM113.673 156.208L113.673 154.096L112.673 154.096L112.673 156.208L113.673 156.208ZM113.673 151.983L113.673 149.871L112.673 149.871L112.673 151.983L113.673 151.983ZM113.673 147.759L113.673 146.703L112.673 146.703L112.673 147.759L113.673 147.759Z",
                fill: "#0B27C4"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_7539_98594",
                        x1: 8.23296,
                        y1: 35.6175,
                        x2: 371.22,
                        y2: 246.222,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_7539_98594",
                        x1: -4.30604,
                        y1: -56.4424,
                        x2: 250.429,
                        y2: 285.597,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_7539_98594",
                        x1: 40.3648,
                        y1: -89.733,
                        x2: 295.1,
                        y2: 252.366,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint3_linear_7539_98594",
                        x1: 42.7137,
                        y1: -120.169,
                        x2: 360.531,
                        y2: 314.058,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint4_linear_7539_98594",
                        x1: 47.7199,
                        y1: -123.745,
                        x2: 365.538,
                        y2: 310.421,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint5_linear_7539_98594",
                        x1: 48.4927,
                        y1: -124.657,
                        x2: 366.371,
                        y2: 309.511,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#2644F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.2,
                                stopColor: "#1334F0"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.4,
                                stopColor: "#3D59F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#526AF4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.8,
                                stopColor: "#5E75F5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#0E2CD7"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var $4dc7445fdaabbc45$export$2e2bcd8739ae039 = $4dc7445fdaabbc45$var$SvgDesktop;




var $exYeM = parcelRequire("exYeM");

function $747d84e06f248c6d$var$SvgDisconnect(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_18445_28182)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M8.13506 3.78534L8.13511 4.78364C8.13513 5.00352 8.01379 5.20546 7.81963 5.30868C4.92721 6.84636 3.08106 9.85427 3.08106 13.1893C3.08106 18.1151 7.07415 22.1082 11.9999 22.1082C16.9256 22.1082 20.9187 18.1151 20.9187 13.1893C20.9187 9.85438 19.0727 6.84656 16.1804 5.30883C15.9863 5.20561 15.8649 5.00367 15.865 4.78379L15.865 3.78548C15.865 3.3487 16.3202 3.06102 16.7148 3.24845C20.5215 5.05701 22.9998 8.89953 22.9998 13.1893C22.9998 19.2644 18.075 24.1892 11.9999 24.1892C5.92482 24.1892 1 19.2644 1 13.1893C1 8.8994 3.47838 5.05679 7.28533 3.2483C7.67985 3.06089 8.13503 3.34857 8.13506 3.78534ZM12.4458 -0.189453C12.7742 -0.189453 13.0404 0.0767532 13.0404 0.405135V11.405C13.0404 11.7334 12.7742 11.9996 12.4458 11.9996H11.5539C11.2256 11.9996 10.9594 11.7334 10.9594 11.405V0.405135C10.9594 0.0767532 11.2256 -0.189453 11.5539 -0.189453H12.4458Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_18445_28182",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $747d84e06f248c6d$export$2e2bcd8739ae039 = $747d84e06f248c6d$var$SvgDisconnect;




var $exYeM = parcelRequire("exYeM");

function $9ad0aa148d3f1f1b$var$SvgDocument(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M13.4552 8.11728H13.2618V3.37085C13.2618 3.32158 13.2418 3.27449 13.2065 3.24031C13.2038 3.23758 11.8927 1.96816 11.8902 1.9658C11.8549 1.9338 11.8102 1.91852 11.7636 1.91452H11.3889L11.0773 0.150203C11.0598 0.0512962 10.9651 -0.0145205 10.8668 0.00275184L3.4613 1.30817C3.36258 1.32563 3.29658 1.41981 3.31385 1.51871L3.43476 2.20852L1.1199 3.05104C1.02736 3.08268 0.975905 3.19304 1.01118 3.28413L2.29151 6.80168C1.84407 6.75477 1.42789 7.08567 1.43153 7.54748V15.2542C1.43153 15.6655 1.76607 16 2.17733 16H13.4554C13.8667 16 14.2012 15.6655 14.2012 15.2542V8.86326C14.2012 8.452 13.8667 8.11746 13.4554 8.11746L13.4552 8.11728ZM6.41086 8.11728C6.1496 8.1391 5.91997 7.86602 5.74179 7.71329V2.27815H11.5816V3.41194C11.5816 3.5123 11.6631 3.59376 11.7635 3.59376H12.8982V8.11728H6.41086ZM12.6404 3.23013H11.9453V2.53505L12.6404 3.23013ZM10.7508 0.392379L11.0197 1.91452H5.56016C5.4598 1.91452 5.37834 1.99598 5.37834 2.09634V7.38748C5.17908 7.21912 4.88817 6.89331 4.622 6.84095C4.54964 6.42678 3.74857 1.88761 3.70329 1.63489L10.7508 0.392379ZM1.41517 3.33049L3.50057 2.5716L4.24601 6.8015H2.67841L1.41517 3.33049ZM13.8374 15.254C13.8374 15.4647 13.666 15.6362 13.4552 15.6362H2.17715C1.96643 15.6362 1.79498 15.4647 1.79498 15.254V7.5473C1.79498 7.33657 1.96643 7.16512 2.17715 7.16512C2.38442 7.17058 4.11256 7.16112 4.36728 7.16512C4.50782 7.16512 4.64291 7.21676 4.74763 7.31057L5.78815 8.24255C5.9596 8.39618 6.18087 8.48091 6.41105 8.48091C6.41177 8.47836 13.0792 8.48182 13.0802 8.48164C13.0831 8.47964 13.452 8.48164 13.4554 8.48091C13.6661 8.48091 13.8376 8.65236 13.8376 8.86308L13.8374 15.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.81629 10.5452H3.30512C3.20476 10.5452 3.12331 10.6267 3.12331 10.727V13.1862C3.12331 13.2866 3.20476 13.3681 3.30512 13.3681H7.81629C7.91665 13.3681 7.9981 13.2866 7.9981 13.1862V10.727C7.9981 10.6267 7.91665 10.5452 7.81629 10.5452ZM7.63447 13.0044H3.48694V10.9089H7.63447V13.0044Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.81629 13.7564H3.30512C3.06767 13.7601 3.06495 14.1159 3.30512 14.12H7.81629C8.05373 14.1164 8.05646 13.7606 7.81629 13.7564Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.71577 5.27262H11.9909C12.2282 5.26917 12.2313 4.91318 11.9909 4.909H6.71577C6.4785 4.91245 6.47541 5.26844 6.71577 5.27262Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M11.9909 5.81807H6.71577C6.4785 5.82152 6.47541 6.17751 6.71577 6.18169H11.9909C12.2282 6.17824 12.2313 5.82225 11.9909 5.81807Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.9 6.72713H6.71577C6.47814 6.73077 6.47577 7.08658 6.71577 7.09076H10.9C11.1377 7.08713 11.14 6.73132 10.9 6.72713Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.71577 4.18174H8.71826C8.95662 4.17792 8.95771 3.8223 8.71826 3.81811H6.71577C6.47741 3.82193 6.47632 4.17756 6.71577 4.18174Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $9ad0aa148d3f1f1b$export$2e2bcd8739ae039 = $9ad0aa148d3f1f1b$var$SvgDocument;




var $exYeM = parcelRequire("exYeM");

function $8c6c4140a27ba029$var$SvgDocumentation(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.40527 8.9999C2.40527 4.80254 5.80791 1.3999 10.0053 1.3999H16.0243C18.5648 1.3999 20.6243 3.45939 20.6243 5.9999V12.9438C20.6243 13.2751 20.3557 13.5438 20.0243 13.5438C19.693 13.5438 19.4243 13.2751 19.4243 12.9438V5.9999C19.4243 4.12213 17.9021 2.5999 16.0243 2.5999H10.0053C6.47065 2.5999 3.60527 5.46528 3.60527 8.9999V17.7241C3.60527 19.6018 5.1275 21.1241 7.00527 21.1241H9.1222C9.45357 21.1241 9.7222 21.3927 9.7222 21.7241C9.7222 22.0555 9.45357 22.3241 9.1222 22.3241H7.00527C4.46476 22.3241 2.40527 20.2646 2.40527 17.7241V8.9999Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.18786 4.9999C9.18786 3.01168 10.7996 1.3999 12.7879 1.3999H15.4055C15.7369 1.3999 16.0055 1.66853 16.0055 1.9999C16.0055 2.33127 15.7369 2.5999 15.4055 2.5999H12.7879C11.4624 2.5999 10.3879 3.67442 10.3879 4.9999V6.59719C10.3879 8.04283 9.20863 9.21087 7.76306 9.19707L6.0228 9.18047C4.68843 9.16774 3.5999 10.2459 3.5999 11.5804V12.5047C3.5999 12.8361 3.33127 13.1047 2.9999 13.1047C2.66853 13.1047 2.3999 12.8361 2.3999 12.5047V11.5804C2.3999 9.5787 4.03269 7.96142 6.03425 7.98052L7.77451 7.99713C8.55289 8.00455 9.18786 7.37561 9.18786 6.59719V4.9999Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5306 15.6324C17.7465 15.381 18.1253 15.3523 18.3767 15.5682L21.0361 17.8523C21.7761 18.488 21.78 19.6322 21.0442 20.2728L18.3797 22.5927C18.1298 22.8103 17.7508 22.7841 17.5332 22.5342C17.3156 22.2843 17.3418 21.9053 17.5917 21.6877L20.2562 19.3678C20.4402 19.2076 20.4392 18.9216 20.2542 18.7626L17.5948 16.4785C17.3434 16.2626 17.3147 15.8838 17.5306 15.6324Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7373 15.6324C14.9532 15.8838 14.9245 16.2626 14.6731 16.4785L12.0137 18.7626C11.8287 18.9216 11.8277 19.2076 12.0117 19.3678L14.6761 21.6877C14.9261 21.9053 14.9523 22.2843 14.7347 22.5342C14.5171 22.7841 14.1381 22.8103 13.8882 22.5927L11.2237 20.2728C10.4879 19.6322 10.4918 18.488 11.2318 17.8523L13.8912 15.5682C14.1426 15.3523 14.5214 15.381 14.7373 15.6324Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $8c6c4140a27ba029$export$2e2bcd8739ae039 = $8c6c4140a27ba029$var$SvgDocumentation;




var $exYeM = parcelRequire("exYeM");

function $5815e032006c952c$var$SvgDone(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.7846 4.31584C24.1751 4.70637 24.1751 5.33953 23.7846 5.73006L10.0607 19.4539C9.1495 20.3651 7.67211 20.3651 6.76089 19.4539L1.03703 13.7301C0.64651 13.3395 0.64651 12.7064 1.03703 12.3158C1.42756 11.9253 2.06072 11.9253 2.45125 12.3158L8.17511 18.0397C8.30528 18.1699 8.51634 18.1699 8.64651 18.0397L22.3704 4.31584C22.7609 3.92532 23.3941 3.92532 23.7846 4.31584Z",
            fill: "currentColor"
        })
    }));
}
var $5815e032006c952c$export$2e2bcd8739ae039 = $5815e032006c952c$var$SvgDone;




var $exYeM = parcelRequire("exYeM");

function $af042e3144c17b49$var$SvgEvmCategory(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 14.25,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_64247)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.2491 3L14.182 3.22789V9.84004L14.2491 9.90697L17.3183 8.09273L14.2491 3Z",
                        fill: "#85BBF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.2491 3L11.1798 8.09273L14.2491 9.90697V6.69762V3Z",
                        fill: "#E2EBF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.2491 10.4891L14.2113 10.5352V12.8905L14.2491 13.0009L17.3202 8.67578L14.2491 10.4891Z",
                        fill: "#85BBF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.2491 13.0009V10.4891L11.1798 8.67578L14.2491 13.0009Z",
                        fill: "#E2EBF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.2491 9.90858L17.3184 8.09433L14.2491 6.69922V9.90858Z",
                        fill: "#69ADF5"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M11.1798 8.09433L14.2491 9.90858V6.69922L11.1798 8.09433Z",
                        fill: "#85BBF5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 7.25,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip1_9706_64247)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.3298 22.9628H5.50681C5.78393 22.9628 5.92249 22.9628 6.04615 22.9285C6.18173 22.8882 6.30539 22.8168 6.4082 22.7184C6.50261 22.6285 6.57073 22.5092 6.70512 22.2741L6.7052 22.2739L6.70915 22.267L8.2357 19.5685C8.37128 19.3316 8.43833 19.2124 8.46813 19.0873C8.5009 18.9517 8.5009 18.8087 8.46813 18.6731C8.43855 18.5489 8.37082 18.4305 8.23726 18.1972L8.23422 18.1918L7.63676 17.1489C7.51311 16.9314 7.45053 16.8226 7.37157 16.7824C7.28664 16.7392 7.18532 16.7392 7.1004 16.7824C7.02144 16.8226 6.95887 16.9314 6.8352 17.1489L3.92902 22.2715C3.80685 22.486 3.74576 22.5933 3.75023 22.6812C3.75619 22.7766 3.80535 22.863 3.88581 22.9151C3.9603 22.9628 4.08247 22.9628 4.3298 22.9628ZM10.1657 22.9628H8.47915C8.23034 22.9628 8.10519 22.9628 8.03218 22.9151C7.95173 22.863 7.90257 22.7751 7.89661 22.6797C7.89216 22.5925 7.95374 22.4862 8.07694 22.2736L8.07697 22.2735L8.07986 22.2685L8.92165 20.8233C9.04531 20.6103 9.10788 20.5045 9.18536 20.4643C9.27024 20.4211 9.37014 20.4211 9.45501 20.4643C9.53194 20.5034 9.59184 20.6047 9.71043 20.8053L9.71061 20.8056L9.72022 20.8218L10.565 22.267L10.5772 22.288L10.5772 22.2881C10.6943 22.4901 10.7541 22.5932 10.7498 22.6783C10.7453 22.7736 10.6946 22.8615 10.6142 22.9137C10.5397 22.9628 10.4145 22.9628 10.1657 22.9628H10.1657Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 21.25,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M22.18 23.3046V24.4253L21.2029 25L20.2547 24.4253V23.3046L21.2029 23.8793L22.18 23.3046ZM16.9501 19.4253L17.8983 20V21.9253L19.5363 22.9023V24.023L16.9501 22.5V19.4253ZM25.4558 19.4253V22.5L22.8409 24.023V22.9023L24.4788 21.9253V20L25.4558 19.4253ZM22.8409 17.9023L23.8179 18.477V19.5977L22.18 20.5747V22.5287L21.2317 23.1034L20.2834 22.5287V20.5747L18.588 19.5977V18.477L19.565 17.9023L21.2029 18.8793L22.8409 17.9023ZM18.588 20.4023L19.5363 20.977V22.0977L18.588 21.523V20.4023ZM23.8179 20.4023V21.523L22.8696 22.0977V20.977L23.8179 20.4023ZM17.8983 16.9253L18.8754 17.5L17.8983 18.0747V19.1954L16.9501 18.6207V17.5L17.8983 16.9253ZM24.5075 16.9253L25.4846 17.5V18.6207L24.5075 19.1954V18.0747L23.5593 17.5L24.5075 16.9253ZM21.2029 16.9253L22.18 17.5L21.2029 18.0747L20.2547 17.5L21.2029 16.9253ZM21.2029 15L23.8179 16.523L22.8696 17.0977L21.2317 16.1207L19.565 17.0977L18.6167 16.523L21.2029 15Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip0_9706_64247",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 10,
                            height: 10,
                            fill: "white",
                            transform: "translate(9.25 3)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip1_9706_64247",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 8,
                            height: 8,
                            fill: "white",
                            transform: "translate(3.25 16)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $af042e3144c17b49$export$2e2bcd8739ae039 = $af042e3144c17b49$var$SvgEvmCategory;




var $exYeM = parcelRequire("exYeM");

function $a4b9d4c09097b8a0$var$SvgError(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM10.8 18V15.6H13.2V18H10.8ZM10.8 6V13.2H13.2V6H10.8Z",
            fill: "currentColor"
        })
    }));
}
var $a4b9d4c09097b8a0$export$2e2bcd8739ae039 = $a4b9d4c09097b8a0$var$SvgError;




var $exYeM = parcelRequire("exYeM");

function $8f81708c6e49638f$var$SvgExchange(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector",
                d: "M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z",
                fill: "currentColor"
            })
        })
    }));
}
var $8f81708c6e49638f$export$2e2bcd8739ae039 = $8f81708c6e49638f$var$SvgExchange;




var $exYeM = parcelRequire("exYeM");

function $94723a09b1001eeb$var$SvgExit(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
            fill: "currentColor"
        })
    }));
}
var $94723a09b1001eeb$export$2e2bcd8739ae039 = $94723a09b1001eeb$var$SvgExit;




var $exYeM = parcelRequire("exYeM");

function $5cccb19b756bc986$var$SvgExplorer(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M8.8548 12.9707C12.067 12.9707 14.6803 10.3574 14.6803 7.1452C14.6803 3.93297 12.067 1.31969 8.8548 1.31969C5.64257 1.31969 3.02929 3.93297 3.02929 7.1452C3.02929 8.37412 3.4121 9.51535 4.06437 10.4562L3.21525 11.3053L3.20468 11.2948C3.11783 11.2081 2.97714 11.2081 2.89045 11.2948L0.374595 13.8106C0.13297 14.0522 0 14.3745 0 14.7181C0 15.0617 0.13297 15.3839 0.374595 15.6254C0.616221 15.867 0.938332 16 1.28207 16C1.62582 16 1.94793 15.867 2.18955 15.6254L4.70541 13.1095C4.74716 13.0678 4.77047 13.0113 4.77047 12.9524C4.77047 12.8936 4.747 12.8369 4.70541 12.7953L4.69485 12.7848L5.54397 11.9356C6.48482 12.5879 7.62588 12.9709 8.85497 12.9709L8.8548 12.9707ZM8.8548 1.76404C11.8219 1.76404 14.236 4.17795 14.236 7.1452C14.236 10.1125 11.822 12.5264 8.8548 12.5264C5.88755 12.5264 3.47364 10.1123 3.47364 7.1452C3.47364 4.17812 5.88772 1.76404 8.8548 1.76404ZM1.87516 15.3112C1.71754 15.4688 1.50693 15.5556 1.28207 15.5556C1.05722 15.5556 0.846612 15.4688 0.688994 15.3112C0.531375 15.1536 0.444517 14.943 0.444517 14.7181C0.444517 14.4932 0.531375 14.2826 0.688994 14.125L3.04774 11.7663L4.23407 12.9526L1.87532 15.3113L1.87516 15.3112ZM4.38045 12.4704L3.52948 11.6196L4.334 10.815C4.5877 11.1269 4.87292 11.4121 5.18481 11.666L4.38028 12.4705L4.38045 12.4704ZM8.8548 11.6999C11.3663 11.6999 13.4095 9.6567 13.4095 7.1452C13.4095 4.6337 11.3663 2.59053 8.8548 2.59053C6.3433 2.59053 4.30013 4.6337 4.30013 7.1452C4.30013 9.6567 6.3433 11.6999 8.8548 11.6999ZM8.8548 3.03488C11.1212 3.03488 12.965 4.87868 12.965 7.14503C12.965 9.41138 11.1212 11.2554 8.8548 11.2554C6.58845 11.2554 4.74465 9.41155 4.74465 7.14503C4.74465 4.87851 6.58845 3.03488 8.8548 3.03488ZM6.51584 8.35165L6.24655 8.75324C6.18736 8.84144 6.19893 8.95899 6.27405 9.03411L6.96589 9.72595C7.04101 9.8009 7.15856 9.81247 7.24676 9.75328L7.64835 9.48399L8.05396 9.65234L8.14753 10.1265C8.16799 10.2307 8.25937 10.3058 8.36551 10.3058H9.34409C9.45023 10.3058 9.54161 10.2307 9.56207 10.1265L9.65563 9.65234L10.0613 9.48399L10.4628 9.75328C10.551 9.81247 10.6688 9.8009 10.7437 9.72595L11.4355 9.03411C11.5107 8.95899 11.5221 8.84128 11.463 8.75324L11.1938 8.35165L11.3621 7.94587L11.8363 7.85247C11.9404 7.83185 12.0156 7.74063 12.0156 7.63449V6.65591C12.0156 6.54977 11.9404 6.45839 11.8363 6.43793L11.3621 6.34453L11.1938 5.93892L11.463 5.53733C11.5222 5.44913 11.5107 5.33158 11.4355 5.25646L10.7437 4.56462C10.6686 4.4895 10.5509 4.4781 10.4628 4.53729L10.0613 4.80658L9.65563 4.63823L9.56207 4.16403C9.54161 4.05991 9.45023 3.98479 9.34409 3.98479H8.36551C8.25937 3.98479 8.16799 4.05991 8.14753 4.16403L8.05396 4.63823L7.64835 4.80658L7.24676 4.53729C7.15856 4.4781 7.04085 4.48967 6.96589 4.56462L6.27405 5.25646C6.19893 5.33158 6.18753 5.44913 6.24655 5.53733L6.51584 5.93892L6.34749 6.34453L5.8733 6.43793C5.76917 6.45855 5.69405 6.54977 5.69405 6.65591V7.63449C5.69405 7.74063 5.76917 7.83201 5.8733 7.85247L6.34749 7.94587L6.51584 8.35165ZM6.13857 6.83852L6.55022 6.75736C6.62316 6.74294 6.68403 6.69314 6.71253 6.62439L6.9721 5.99878C7.0006 5.93003 6.99289 5.85172 6.95147 5.78985L6.71756 5.44108L7.15118 5.00746L7.49995 5.24137C7.56183 5.28279 7.64013 5.2905 7.70888 5.26216L8.33449 5.0026C8.40307 4.97409 8.45304 4.91322 8.46729 4.84028L8.54845 4.42863H9.16165L9.24281 4.84028C9.25723 4.91322 9.30703 4.97409 9.37561 5.0026L10.0012 5.26216C10.07 5.29067 10.1484 5.28296 10.2101 5.24137L10.5589 5.00746L10.9925 5.44108L10.7586 5.78985C10.7172 5.85156 10.7095 5.93003 10.738 5.99878L10.9976 6.62439C11.0261 6.69297 11.0869 6.74294 11.1599 6.75719L11.5715 6.83835V7.45155L11.1599 7.53271C11.0869 7.54713 11.0261 7.59693 10.9976 7.66568L10.738 8.29129C10.7095 8.36004 10.7172 8.43834 10.7588 8.50022L10.9927 8.84899L10.5591 9.28261L10.2103 9.04869C10.1486 9.00728 10.0701 8.99957 10.0014 9.0279L9.37578 9.28747C9.3072 9.31598 9.25723 9.37684 9.24298 9.44978L9.16182 9.86144H8.54862L8.46746 9.44978C8.45304 9.37684 8.40324 9.31598 8.33466 9.28747L7.70905 9.0279C7.6403 8.9994 7.56199 9.00711 7.50012 9.04869L7.15135 9.28261L6.71773 8.84899L6.95164 8.50022C6.99306 8.43851 7.00077 8.36004 6.97227 8.29129L6.7127 7.66568C6.68419 7.5971 6.62333 7.54713 6.55038 7.53271L6.13873 7.45155V6.83835L6.13857 6.83852ZM8.8548 8.88839C9.8161 8.88839 10.5982 8.10634 10.5982 7.14503C10.5982 6.18373 9.8161 5.40167 8.8548 5.40167C7.8935 5.40167 7.11144 6.18373 7.11144 7.14503C7.11144 8.10634 7.8935 8.88839 8.8548 8.88839ZM8.8548 5.84619C9.57096 5.84619 10.1536 6.42888 10.1536 7.14503C10.1536 7.86119 9.57096 8.44388 8.8548 8.44388C8.13864 8.44388 7.55596 7.86119 7.55596 7.14503C7.55596 6.42888 8.13864 5.84619 8.8548 5.84619ZM15.8353 10.564C15.816 10.5692 15.7967 10.5716 15.7776 10.5716C15.6795 10.5716 15.5896 10.5062 15.5631 10.4067L15.4971 10.1602C15.1235 10.9799 14.5946 11.7351 13.9486 12.3656C13.1831 13.1126 12.2471 13.6912 11.2417 14.0393C11.2177 14.0477 11.1931 14.0516 11.1689 14.0516C11.0769 14.0516 10.9907 13.9939 10.959 13.902C10.9189 13.786 10.9803 13.6594 11.0963 13.6193C12.8617 13.0083 14.2829 11.7186 15.0641 10.0402L14.9068 10.1443C14.8046 10.2122 14.6666 10.1841 14.5988 10.0818C14.5311 9.97948 14.5591 9.84148 14.6614 9.77374L15.4164 9.27372C15.4761 9.23432 15.5509 9.22576 15.6178 9.25125C15.6847 9.27657 15.7352 9.33241 15.7538 9.40149L15.9924 10.2917C16.0241 10.4102 15.9538 10.5323 15.8353 10.564ZM10.9837 0.583581C10.9442 0.523888 10.9359 0.449103 10.961 0.382199C10.9863 0.315295 11.0423 0.264823 11.1113 0.246211L12.0015 0.00760352C12.12 -0.0240878 12.2419 0.0461697 12.2736 0.164719C12.3053 0.283268 12.235 0.405171 12.1165 0.436862L11.8707 0.50276C12.6997 0.880709 13.4635 1.41862 14.0981 2.07492C14.8337 2.83551 15.4047 3.76345 15.7491 4.75829C15.7892 4.87432 15.7278 5.00092 15.6118 5.041C15.5876 5.04938 15.5631 5.05324 15.539 5.05324C15.4469 5.05324 15.3607 4.99555 15.3291 4.90367C14.7192 3.14169 13.4281 1.71827 11.7505 0.936378L11.8542 1.09299C11.922 1.19527 11.894 1.33327 11.7917 1.40102C11.754 1.426 11.7114 1.43807 11.6691 1.43807C11.597 1.43807 11.5264 1.40303 11.4837 1.33847L10.9837 0.583581ZM1.7172 3.99837C1.68534 3.87982 1.75577 3.75792 1.87432 3.72622C1.99287 3.69453 2.11477 3.76479 2.14646 3.88334L2.21253 4.12966C2.58796 3.30635 3.12017 2.54777 3.77027 1.91562C4.53388 1.17314 5.46667 0.597331 6.46805 0.250738C6.58392 0.210663 6.71052 0.272034 6.75076 0.388067C6.79084 0.504101 6.72947 0.630699 6.61343 0.670775C4.84945 1.28129 3.42736 2.57159 2.64598 4.24972L2.80292 4.14576C2.90521 4.07785 3.04321 4.10602 3.11095 4.2083C3.17869 4.31059 3.15069 4.44859 3.04841 4.51633L2.29335 5.01635C2.25646 5.04083 2.2137 5.05324 2.17061 5.05324C2.14411 5.05324 2.11745 5.04854 2.09196 5.03882C2.02506 5.0135 1.97459 4.95766 1.95598 4.88858L1.7172 3.99837Z",
            fill: "currentColor"
        })
    }));
}
var $5cccb19b756bc986$export$2e2bcd8739ae039 = $5cccb19b756bc986$var$SvgExplorer;




var $exYeM = parcelRequire("exYeM");

function $7de21d312ca8c004$var$SvgExternalLink(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.4046 1.85421C21.1566 1.83395 20.8342 1.83345 20.3523 1.83345H14.6314C14.2724 1.83345 13.9814 1.54243 13.9814 1.18345C13.9814 0.824463 14.2724 0.533448 14.6314 0.533448L20.3786 0.533448C20.8274 0.533438 21.2032 0.53343 21.5104 0.558531C21.8312 0.58474 22.134 0.641521 22.4209 0.787689C22.8598 1.01133 23.2167 1.36818 23.4403 1.80709C23.5865 2.09396 23.6433 2.3968 23.6695 2.71758C23.6946 3.02482 23.6946 3.40062 23.6945 3.8495V9.59659C23.6945 9.95558 23.4035 10.2466 23.0445 10.2466C22.6856 10.2466 22.3945 9.95558 22.3945 9.59659V3.87565C22.3945 3.39375 22.394 3.07141 22.3738 2.82344C22.3541 2.58305 22.3192 2.47034 22.282 2.39727C22.183 2.20297 22.025 2.045 21.8307 1.946C21.7577 1.90877 21.6449 1.87385 21.4046 1.85421ZM21.8215 2.40646C22.0754 2.6603 22.0754 3.07186 21.8215 3.3257L12.6873 12.46C12.4334 12.7138 12.0219 12.7138 11.768 12.46C11.5142 12.2061 11.5142 11.7946 11.768 11.5407L20.9023 2.40646C21.1561 2.15262 21.5677 2.15262 21.8215 2.40646ZM7.93747 4.13908H10.4248C10.7838 4.13908 11.0748 4.4301 11.0748 4.78908C11.0748 5.14807 10.7838 5.43908 10.4248 5.43908H7.96644C6.80836 5.43908 5.97889 5.43959 5.32826 5.49275C4.68523 5.54528 4.27433 5.646 3.94301 5.81482C3.29435 6.14532 2.76698 6.67269 2.43648 7.32135C2.26766 7.65267 2.16694 8.06357 2.11441 8.7066C2.06125 9.35723 2.06074 10.1867 2.06074 11.3448V16.2616C2.06074 17.4196 2.06125 18.2491 2.11441 18.8997C2.16694 19.5428 2.26766 19.9537 2.43648 20.285C2.76698 20.9336 3.29435 21.461 3.94301 21.7915C4.27433 21.9603 4.68523 22.061 5.32827 22.1136C5.97889 22.1667 6.80836 22.1673 7.96644 22.1673H12.8832C14.0413 22.1673 14.8708 22.1667 15.5214 22.1136C16.1644 22.061 16.5753 21.9603 16.9066 21.7915C17.5553 21.461 18.0827 20.9336 18.4132 20.285C18.582 19.9537 18.6827 19.5428 18.7352 18.8997C18.7884 18.2491 18.7889 17.4196 18.7889 16.2616V13.8032C18.7889 13.4442 19.0799 13.1532 19.4389 13.1532C19.7979 13.1532 20.0889 13.4442 20.0889 13.8032V16.2905C20.0889 17.4133 20.0889 18.2958 20.0309 19.0056C19.9718 19.729 19.8492 20.33 19.5715 20.8752C19.1163 21.7684 18.3901 22.4947 17.4968 22.9498C16.9517 23.2276 16.3507 23.3502 15.6273 23.4093C14.9175 23.4673 14.035 23.4673 12.9121 23.4673H7.93758C6.8147 23.4673 5.93218 23.4673 5.2224 23.4093C4.49897 23.3502 3.89795 23.2276 3.35282 22.9498C2.45956 22.4947 1.73331 21.7684 1.27817 20.8752C1.00041 20.33 0.87783 19.729 0.818724 19.0056C0.760735 18.2958 0.760738 17.4133 0.760742 16.2905V11.3158C0.760738 10.193 0.760735 9.31049 0.818724 8.60074C0.87783 7.87731 1.00041 7.27629 1.27817 6.73116C1.73331 5.83789 2.45956 5.11165 3.35282 4.65651C3.89795 4.37875 4.49897 4.25617 5.2224 4.19706C5.93215 4.13907 6.81465 4.13908 7.93747 4.13908Z",
            fill: "currentColor"
        })
    }));
}
var $7de21d312ca8c004$export$2e2bcd8739ae039 = $7de21d312ca8c004$var$SvgExternalLink;




var $exYeM = parcelRequire("exYeM");

function $a207a73058054a83$var$SvgFeatureList(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.6363 6.08445L18.6344 6.08561L18.6258 6.09088L18.5898 6.11321C18.5579 6.13313 18.5108 6.16281 18.4522 6.20071C18.3348 6.27667 18.1724 6.38479 17.993 6.51285C17.6229 6.77711 17.2237 7.09625 16.9831 7.37734C16.8067 7.58348 16.6044 7.89898 16.4364 8.18539C16.355 8.32422 16.2861 8.44854 16.2377 8.53796C16.2135 8.58257 16.1946 8.61826 16.1819 8.64242L16.1676 8.66965L16.1643 8.67613L16.1636 8.67748C16.0675 8.86453 15.8805 8.98776 15.6707 9.00211C15.4609 9.01646 15.2589 8.91992 15.1383 8.74765L14.1827 7.3829C13.9927 7.11145 14.0586 6.73733 14.3301 6.54727C14.6015 6.3572 14.9757 6.42318 15.1657 6.69463L15.5791 7.28506C15.7263 7.05078 15.8982 6.79948 16.0714 6.59707C16.4121 6.19905 16.912 5.81018 17.2957 5.53622C17.4933 5.39515 17.6715 5.27661 17.8004 5.19318C17.865 5.15138 17.9176 5.11818 17.9545 5.09516L17.9977 5.06838L18.0097 5.06105L18.0132 5.05895L18.0142 5.05831C18.0142 5.05831 18.0148 5.05793 18.3256 5.57119L18.0142 5.05831C18.2977 4.88669 18.6672 4.97698 18.8389 5.26044C19.0104 5.54386 18.9197 5.91279 18.6363 6.08445Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.3999 18.9872C1.3999 21.5277 3.45939 23.5872 5.9999 23.5872L14.9999 23.5872C17.5404 23.5872 19.5999 21.5277 19.5999 18.9872L19.5999 13.9872C19.5999 13.6558 19.3313 13.3872 18.9999 13.3872C18.6685 13.3872 18.3999 13.6558 18.3999 13.9872L18.3999 18.9872C18.3999 20.865 16.8777 22.3872 14.9999 22.3872H5.9999C4.12214 22.3872 2.5999 20.865 2.5999 18.9872L2.5999 6.98721C2.5999 5.10944 4.12213 3.58721 5.9999 3.58721L9.9999 3.58721C10.3313 3.58721 10.5999 3.31858 10.5999 2.98721C10.5999 2.65583 10.3313 2.38721 9.9999 2.38721L5.9999 2.38721C3.45939 2.38721 1.3999 4.4467 1.3999 6.98721L1.3999 18.9872Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.8999 17.9872C4.8999 18.3186 5.16853 18.5872 5.4999 18.5872L15.4999 18.5872C15.8313 18.5872 16.0999 18.3186 16.0999 17.9872C16.0999 17.6558 15.8313 17.3872 15.4999 17.3872L5.4999 17.3872C5.16853 17.3872 4.8999 17.6558 4.8999 17.9872Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.2349 13.3872L5.4999 13.3872C5.16853 13.3872 4.8999 13.6558 4.8999 13.9872C4.8999 14.3186 5.16853 14.5872 5.4999 14.5872L10.2349 14.5872C10.5662 14.5872 10.8349 14.3186 10.8349 13.9872C10.8349 13.6558 10.5662 13.3872 10.2349 13.3872Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.4999 2.5999C14.0769 2.5999 12.1126 4.56417 12.1126 6.98721C12.1126 9.41025 14.0769 11.3745 16.4999 11.3745C18.9229 11.3745 20.8872 9.41025 20.8872 6.98721C20.8872 4.56417 18.9229 2.5999 16.4999 2.5999ZM10.9126 6.98721C10.9126 3.90142 13.4141 1.3999 16.4999 1.3999C19.5857 1.3999 22.0872 3.90142 22.0872 6.98721C22.0872 10.073 19.5857 12.5745 16.4999 12.5745C13.4141 12.5745 10.9126 10.073 10.9126 6.98721Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $a207a73058054a83$export$2e2bcd8739ae039 = $a207a73058054a83$var$SvgFeatureList;




var $exYeM = parcelRequire("exYeM");

function $5745037053c23ac5$var$SvgFilter(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.82568 3.82878C2.82568 2.03228 4.28203 0.575928 6.07853 0.575928H17.9208C19.7173 0.575928 21.1737 2.03228 21.1737 3.82878V5.80513C21.1737 6.68795 20.8149 7.53209 20.181 8.1445L15.7568 13.4631L15.7228 13.4949C15.3694 13.8261 15.1689 14.2887 15.1689 14.773V18.8493C15.1689 19.6996 14.836 20.5161 14.2414 21.124L12.2631 23.1462C11.0086 24.4287 8.83041 23.5405 8.83041 21.7465V14.773C8.83041 14.2887 8.6299 13.8261 8.27652 13.4949L8.24251 13.4631L3.81837 8.1445C3.18447 7.53209 2.82568 6.68795 2.82568 5.80513V3.82878ZM6.07853 2.07724C5.11119 2.07724 4.327 2.86143 4.327 3.82878V5.80513C4.327 6.28941 4.52751 6.75208 4.88089 7.08322L4.9149 7.11509L9.33904 12.4336C9.97294 13.046 10.3317 13.8902 10.3317 14.773V21.7465C10.3317 22.195 10.8763 22.417 11.1899 22.0964L13.1682 20.0741C13.4883 19.7468 13.6676 19.3072 13.6676 18.8493V14.773C13.6676 13.8902 14.0264 13.046 14.6603 12.4336L19.0844 7.11509L19.1185 7.08322C19.4718 6.75208 19.6723 6.28941 19.6723 5.80513V3.82878C19.6723 2.86143 18.8882 2.07724 17.9208 2.07724H6.07853Z",
            fill: "currentColor"
        })
    }));
}
var $5745037053c23ac5$export$2e2bcd8739ae039 = $5745037053c23ac5$var$SvgFilter;




var $exYeM = parcelRequire("exYeM");

function $42d3930c911eaba9$var$SvgFirst(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector",
                d: "M10.3981 12.2525L19.7762 22.3353C19.9172 22.4895 19.9959 22.6973 19.995 22.9135C19.9942 23.1297 19.9139 23.3368 19.7717 23.4897C19.6294 23.6426 19.4368 23.7289 19.2357 23.7297C19.0346 23.7306 18.8413 23.6459 18.6979 23.4943L8.852 12.9088C8.68428 12.7285 8.61109 12.4856 8.63218 12.2503C8.62181 12.1305 8.63616 12.0098 8.6742 11.8966C8.71224 11.7834 8.77304 11.6807 8.85226 11.5957L18.6984 1.01023C18.8414 0.856505 19.0353 0.770142 19.2376 0.770142C19.4398 0.770142 19.6337 0.856505 19.7767 1.01023C19.9197 1.16396 20 1.37246 20 1.58986C20 1.80726 19.9197 2.01576 19.7767 2.16949L10.3981 12.2525Z",
                fill: "#727272"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector_2",
                d: "M1.76846 12.2525L11.1473 22.3353C11.2883 22.4895 11.367 22.6973 11.3661 22.9135C11.3653 23.1297 11.285 23.3368 11.1428 23.4897C11.0006 23.6426 10.8079 23.7289 10.6068 23.7297C10.4057 23.7306 10.2124 23.6459 10.069 23.4943L0.223115 12.9088C0.0553913 12.7285 -0.0177975 12.4856 0.0032959 12.2503C-0.00705814 12.1305 0.00729561 12.0098 0.0453348 11.8966C0.083375 11.7835 0.144164 11.6807 0.223369 11.5957L10.069 1.01023C10.212 0.856505 10.4059 0.770142 10.6082 0.770142C10.8104 0.770142 11.0043 0.856505 11.1473 1.01023C11.2903 1.16396 11.3706 1.37246 11.3706 1.58986C11.3706 1.80726 11.2903 2.01576 11.1473 2.16949L1.76846 12.2525Z",
                fill: "#727272"
            })
        ]
    }));
}
var $42d3930c911eaba9$export$2e2bcd8739ae039 = $42d3930c911eaba9$var$SvgFirst;




var $exYeM = parcelRequire("exYeM");

function $0e47179121021ed7$var$SvgFont(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                id: "Font",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M20.2235 8.41095C19.7886 8.41095 19.4469 8.07056 19.4469 7.63735V5.73429C19.4469 5.37843 19.2295 5.09994 19.0276 5.09994H4.97239C4.77049 5.09994 4.55306 5.36296 4.55306 5.73429V7.63735C4.55306 8.07056 4.21139 8.41095 3.77653 8.41095C3.34167 8.41095 3 8.07056 3 7.63735V5.73429C3 4.52747 3.88525 3.55273 4.97239 3.55273H19.0276C20.1148 3.55273 21 4.52747 21 5.73429V7.63735C21 8.05509 20.6428 8.41095 20.2235 8.41095Z",
                        fill: "#727272"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M11.9921 20.2625C11.5573 20.2625 11.2156 19.9221 11.2156 19.4889V4.32634C11.2156 3.89312 11.5573 3.55273 11.9921 3.55273C12.427 3.55273 12.7687 3.89312 12.7687 4.32634V19.4889C12.7687 19.9067 12.427 20.2625 11.9921 20.2625Z",
                        fill: "#727272"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.6953 20.4481H9.2906C8.85575 20.4481 8.51407 20.1077 8.51407 19.6745C8.51407 19.2413 8.85575 18.9009 9.2906 18.9009H14.6953C15.1301 18.9009 15.4718 19.2413 15.4718 19.6745C15.4718 20.1077 15.1301 20.4481 14.6953 20.4481Z",
                        fill: "#727272"
                    })
                ]
            })
        })
    }));
}
var $0e47179121021ed7$export$2e2bcd8739ae039 = $0e47179121021ed7$var$SvgFont;




var $exYeM = parcelRequire("exYeM");

function $06af9c266b4fd351$var$SvgGas(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.8071 0C24.1477 0 24.4237 0.276065 24.4237 0.616609V17.6986C24.4237 17.7076 24.4235 17.7165 24.4232 17.7255C24.3829 18.6498 23.8666 19.4876 23.0583 19.9387C22.2503 20.3897 21.2662 20.3897 20.4582 19.9387C19.6499 19.4876 19.1337 18.6498 19.0934 17.7255C19.093 17.7165 19.0928 17.7076 19.0928 17.6986V11.5193C19.0928 11.1389 18.9418 10.7742 18.6727 10.5052L18.6726 10.5051C18.4039 10.2362 18.0391 10.0851 17.6586 10.0851C17.3181 10.0851 17.042 9.80903 17.042 9.46848C17.042 9.12794 17.3181 8.85187 17.6586 8.85187C18.3659 8.85187 19.0445 9.13273 19.5447 9.63314M19.5448 9.63324C20.0451 10.1335 20.326 10.8119 20.326 11.5193V17.684C20.3517 18.1764 20.6283 18.6214 21.0592 18.8618L21.0593 18.8619C21.4937 19.1044 22.0229 19.1044 22.4573 18.8619L22.4573 18.8618C22.8882 18.6214 23.1649 18.1763 23.1905 17.684V0.616609C23.1905 0.276065 23.4666 0 23.8071 0",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.53542 0.57105L5.53714 0.571045L14.4217 0.571047C15.3082 0.57351 16.1576 0.926858 16.7844 1.55365C17.4112 2.18044 17.7645 3.02981 17.767 3.91636L17.767 3.91808L17.767 20.3758H18.8651C19.2057 20.3758 19.4817 20.6518 19.4817 20.9924V23.3831C19.4817 23.7236 19.2057 23.9997 18.8651 23.9997H1.09952C0.758975 23.9997 0.48291 23.7236 0.48291 23.3831V20.9924C0.48291 20.6518 0.758975 20.3758 1.09952 20.3758H2.18995V3.91637C2.19242 3.02981 2.54577 2.18043 3.17256 1.55365C3.79938 0.926839 4.64891 0.573525 5.53542 0.57105ZM5.53805 1.80427C4.97773 1.80604 4.44078 2.02946 4.04457 2.42567C3.64832 2.82191 3.42493 3.35873 3.42317 3.91902V20.9924C3.42317 21.3329 3.14711 21.609 2.80656 21.609H1.71613V22.7665H18.2485V21.609H17.1504C16.8098 21.609 16.5338 21.3329 16.5338 20.9924V3.91862C16.5319 3.35847 16.3085 2.82182 15.9124 2.42566C15.5161 2.02942 14.9793 1.80603 14.419 1.80427H5.53805Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.22655 4.30646C6.18948 4.30646 6.15949 4.33645 6.15949 4.37352V8.75265C6.15985 8.75356 6.16028 8.75458 6.16078 8.75571C6.16671 8.76915 6.17792 8.78734 6.19405 8.80464C6.21007 8.82182 6.22439 8.83114 6.2323 8.83503C6.23277 8.83526 6.23319 8.83546 6.23357 8.83564H13.7229C13.7599 8.83564 13.7899 8.80564 13.7899 8.76858V4.38944C13.7896 4.38853 13.7891 4.38752 13.7886 4.38639C13.7827 4.37294 13.7715 4.35476 13.7554 4.33746C13.7393 4.32028 13.725 4.31096 13.7171 4.30707C13.7166 4.30684 13.7162 4.30664 13.7158 4.30646H6.22655ZM4.92627 4.37352C4.92627 3.65538 5.50838 3.07324 6.22655 3.07324H13.7229C14.1221 3.07324 14.4468 3.27076 14.6572 3.49636C14.862 3.71596 15.0231 4.03077 15.0231 4.37352V8.76858C15.0231 9.48672 14.441 10.0689 13.7229 10.0689H6.22655C5.8273 10.0689 5.50257 9.87134 5.29217 9.64573C5.08738 9.42614 4.92627 9.11132 4.92627 8.76858V4.37352Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7244 3.19696C23.9967 3.40155 24.0515 3.7881 23.8469 4.06033L22.489 5.86725C22.3169 6.09312 22.2662 6.38829 22.3529 6.65787C22.4396 6.92722 22.6522 7.13715 22.922 7.22041L23.9853 7.53627C24.3118 7.63324 24.4978 7.97649 24.4008 8.30293C24.3038 8.62938 23.9606 8.8154 23.6341 8.71843L22.5634 8.40035C21.9063 8.1994 21.3894 7.68949 21.179 7.03563C20.9687 6.38201 21.0916 5.66758 21.5067 5.12163L22.8611 3.31944C23.0657 3.0472 23.4522 2.99237 23.7244 3.19696Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $06af9c266b4fd351$export$2e2bcd8739ae039 = $06af9c266b4fd351$var$SvgGas;




var $exYeM = parcelRequire("exYeM");

function $96295415f6a9ee85$var$SvgHeight(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Height",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Height_2",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.3807 23.7933C12.1204 24.0689 11.6983 24.0689 11.4379 23.7933L7.19526 19.301C6.93491 19.0254 6.93491 18.5784 7.19526 18.3028C7.45561 18.0271 7.87772 18.0271 8.13807 18.3028L11.2426 21.59V2.41003L8.13807 5.69723C7.87772 5.97289 7.45561 5.97289 7.19526 5.69723C6.93491 5.42156 6.93491 4.97462 7.19526 4.69896L11.4379 0.206747C11.6983 -0.0689157 12.1204 -0.0689157 12.3807 0.206747L16.6234 4.69896C16.8837 4.97462 16.8837 5.42156 16.6234 5.69723C16.363 5.97289 15.9409 5.97289 15.6805 5.69723L12.576 2.41003V21.59L15.6805 18.3028C15.9409 18.0271 16.363 18.0271 16.6234 18.3028C16.8837 18.5784 16.8837 19.0254 16.6234 19.301L12.3807 23.7933Z",
                fill: "currentColor"
            })
        })
    }));
}
var $96295415f6a9ee85$export$2e2bcd8739ae039 = $96295415f6a9ee85$var$SvgHeight;




var $exYeM = parcelRequire("exYeM");

function $bfd5cb152b935f2d$var$SvgInProgress(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 8 7",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_14768_268730)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4.0687 0.915086C2.84154 0.915086 1.84673 1.9099 1.84673 3.13706C1.84673 4.36422 2.84154 5.35904 4.0687 5.35904C5.29586 5.35904 6.29068 4.36422 6.29068 3.13706C6.29068 1.9099 5.29586 0.915086 4.0687 0.915086ZM1.0625 3.13706C1.0625 1.47678 2.40842 0.130859 4.0687 0.130859C5.72898 0.130859 7.0749 1.47678 7.0749 3.13706C7.0749 4.79734 5.72898 6.14326 4.0687 6.14326C2.40842 6.14326 1.0625 4.79734 1.0625 3.13706Z",
                        fill: "#C8E2FF"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.07471 3.09881C7.08137 3.62208 6.95131 4.13803 6.69741 4.59563C6.4435 5.05322 6.07454 5.43661 5.62701 5.70787C5.17949 5.97913 4.6689 6.12887 4.14576 6.14228C3.62261 6.15568 3.10503 6.03229 2.6442 5.78431C2.18337 5.53632 1.79526 5.17233 1.51825 4.72834C1.40362 4.54461 1.45963 4.30274 1.64336 4.18811C1.82709 4.07348 2.06896 4.1295 2.1836 4.31323C2.38834 4.64139 2.67521 4.91043 3.01582 5.09372C3.35644 5.27701 3.739 5.36822 4.12567 5.35831C4.51234 5.3484 4.88973 5.23772 5.22051 5.03722C5.55129 4.83673 5.824 4.55335 6.01167 4.21513C6.19934 3.87691 6.29547 3.49556 6.29054 3.10879C6.28562 2.72202 6.17982 2.34323 5.98361 2.0099C5.78739 1.67656 5.50756 1.40022 5.17178 1.2082C4.83601 1.01619 4.45593 0.915151 4.06913 0.915086C3.85257 0.915049 3.67704 0.739464 3.67708 0.522906C3.67712 0.306348 3.8527 0.130823 4.06926 0.130859C4.59258 0.130948 5.10681 0.267645 5.56109 0.52743C6.01537 0.787216 6.39397 1.16109 6.65944 1.61207C6.92491 2.06306 7.06805 2.57553 7.07471 3.09881Z",
                        fill: "#5BABFF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_14768_268730",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 6.27381,
                        height: 6.27381,
                        fill: "white",
                        transform: "translate(0.931763)"
                    })
                })
            })
        ]
    }));
}
var $bfd5cb152b935f2d$export$2e2bcd8739ae039 = $bfd5cb152b935f2d$var$SvgInProgress;




var $exYeM = parcelRequire("exYeM");

function $d33873eddac739a4$var$SvgInfoError(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519935 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693604 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693604 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519935 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9964 15.1815 22.731 18.2317 20.4813 20.4813C18.2317 22.731 15.1815 23.9964 12 24ZM9.91412 8.40428V9.70711L11.5837 9.99513V17.9201L9.91412 18.2081V19.4997H15.2762V18.2081L13.6066 17.9201V8.40428H9.91412ZM11.5837 3.50122V5.56235H13.6089V3.50122H11.5837Z",
            fill: "currentColor"
        })
    }));
}
var $d33873eddac739a4$export$2e2bcd8739ae039 = $d33873eddac739a4$var$SvgInfoError;




var $exYeM = parcelRequire("exYeM");

function $be5f47e94ea1c2a7$var$SvgInfo(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M12.2133 10.1543C11.969 10.1582 11.736 10.2584 11.5656 10.4334C11.3952 10.6082 11.3015 10.8434 11.3048 11.0872V17.5287C11.3013 17.775 11.3971 18.0125 11.5705 18.1879C11.744 18.3633 11.9807 18.4619 12.2278 18.4619C12.475 18.4619 12.7117 18.3633 12.8852 18.1879C13.0587 18.0124 13.1543 17.775 13.1507 17.5287V11.0872C13.1543 10.8385 13.0566 10.599 12.8798 10.4232C12.7033 10.2475 12.4628 10.1504 12.2133 10.1543Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.1508 7.38487C13.1508 7.89462 12.7375 8.30795 12.2278 8.30795C11.718 8.30795 11.3047 7.89462 11.3047 7.38487C11.3047 6.87511 11.718 6.46179 12.2278 6.46179C12.7375 6.46179 13.1508 6.87511 13.1508 7.38487Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M12.2275 0.00012207C5.6104 0.00012207 0.227539 5.38298 0.227539 12.0001C0.227539 18.6173 5.6104 24.0001 12.2275 24.0001C18.8447 24.0001 24.2275 18.6173 24.2275 12.0001C24.2275 5.38298 18.8447 0.00012207 12.2275 0.00012207ZM12.2275 1.71441C17.9185 1.71441 22.5133 6.30928 22.5133 12.0001C22.5133 17.691 17.9184 22.2858 12.2275 22.2858C6.5367 22.2858 1.94182 17.691 1.94182 12.0001C1.94182 6.30928 6.5367 1.71441 12.2275 1.71441Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $be5f47e94ea1c2a7$export$2e2bcd8739ae039 = $be5f47e94ea1c2a7$var$SvgInfo;




var $exYeM = parcelRequire("exYeM");

function $480d64c61a1b53d5$var$SvgLanguage(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                id: "Language",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M14.3359 18.2133C14.2438 18.2133 14.1433 18.1883 14.0596 18.1464C13.7498 17.9874 13.6242 17.6109 13.7749 17.3012L15.5666 13.728C15.6754 13.5188 15.8931 13.3849 16.1275 13.3849C16.3619 13.3849 16.5796 13.5188 16.6885 13.7364L18.4801 17.3096C18.6392 17.6192 18.5136 17.9958 18.1954 18.1547C17.8857 18.3137 17.5089 18.1883 17.3499 17.8703L16.1275 15.4184L14.9052 17.8703C14.788 18.0878 14.5619 18.2133 14.3359 18.2133Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M17.5928 17.5773H14.6458C14.3025 17.5773 14.0179 17.2928 14.0179 16.9497C14.0179 16.6066 14.3025 16.3221 14.6458 16.3221H17.5928C17.936 16.3221 18.2207 16.6066 18.2207 16.9497C18.2207 17.2928 17.9444 17.5773 17.5928 17.5773Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M16.119 21C13.4316 21 11.2381 18.8159 11.2381 16.1213C11.2381 13.4268 13.4232 11.2427 16.119 11.2427C18.8065 11.2427 21 13.4268 21 16.1213C21 18.8159 18.8149 21 16.119 21ZM16.119 12.5063C14.1181 12.5063 12.4939 14.1297 12.4939 16.1297C12.4939 18.1297 14.1181 19.7532 16.119 19.7532C18.1116 19.7532 19.7442 18.1297 19.7442 16.1297C19.7442 14.1297 18.12 12.5063 16.119 12.5063Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M6.02235 12.5899C5.09304 12.5899 4.35629 12.3305 3.83722 11.8284C3.28465 11.2928 3 10.4811 3 9.43513V6.15482C3 4.12135 4.12187 3 6.15631 3H9.43819C10.4847 3 11.2884 3.27615 11.8326 3.83682C12.3601 4.38075 12.6196 5.16739 12.5945 6.17157V9.43513C12.6196 10.456 12.3601 11.2594 11.8159 11.8033C11.2717 12.3473 10.468 12.5983 9.42981 12.5816H6.16467C6.10607 12.5899 6.06421 12.5899 6.02235 12.5899ZM6.15631 4.2636C4.80839 4.2636 4.25582 4.81592 4.25582 6.16319V9.4435C4.25582 10.1381 4.40652 10.6401 4.70791 10.933C5.00094 11.2175 5.46979 11.3431 6.13119 11.3347H9.42981C10.1331 11.3515 10.6187 11.2092 10.9117 10.9163C11.2047 10.6234 11.3387 10.1297 11.3219 9.45188V6.15482C11.3387 5.48536 11.2047 5.00835 10.9201 4.71547C10.627 4.41421 10.1247 4.2636 9.42981 4.2636H6.15631Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.48837 7.48523H6.08928C5.74602 7.48523 5.46136 7.20071 5.46136 6.85761C5.46136 6.51452 5.74602 6.23 6.08928 6.23H9.48837C9.83163 6.23 10.1163 6.51452 10.1163 6.85761C10.1163 7.20071 9.84 7.48523 9.48837 7.48523Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M7.79723 7.48528C7.45397 7.48528 7.16932 7.20076 7.16932 6.85766V6.28863C7.16932 5.94554 7.45397 5.66102 7.79723 5.66102C8.14049 5.66102 8.42514 5.94554 8.42514 6.28863V6.85766C8.42514 7.20076 8.14049 7.48528 7.79723 7.48528Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M6.08928 10.1296C5.74602 10.1296 5.46136 9.84513 5.46136 9.50204C5.46136 9.15894 5.74602 8.87442 6.08928 8.87442C7.15254 8.87442 8.01487 7.97067 8.01487 6.84934C8.01487 6.50624 8.29953 6.22173 8.64278 6.22173C8.98604 6.22173 9.2707 6.50624 9.2707 6.84934C9.2707 8.65686 7.84743 10.1296 6.08928 10.1296Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.49674 10.1296C8.71813 10.1296 7.97301 9.73635 7.44556 9.04179C7.23626 8.76564 7.29487 8.3723 7.57115 8.16309C7.84743 7.95389 8.24091 8.01249 8.45022 8.28864C8.73487 8.67357 9.11162 8.8828 9.49674 8.8828C9.83999 8.8828 10.1246 9.16731 10.1246 9.51041C10.1246 9.8535 9.83999 10.1296 9.49674 10.1296Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.48842 20.9999C5.91351 20.9999 3 18.0878 3 14.5146C3 14.1715 3.28465 13.887 3.62791 13.887C3.97117 13.887 4.25582 14.1715 4.25582 14.5146C4.25582 16.9916 5.98049 19.0669 8.29957 19.6109L8.07352 19.2343C7.89771 18.933 7.98981 18.5481 8.29121 18.3723C8.58423 18.1966 8.97772 18.2887 9.15354 18.5899L10.0326 20.0543C10.1498 20.2468 10.1498 20.4895 10.041 20.682C9.92377 20.8744 9.71447 20.9999 9.48842 20.9999Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M20.3722 10.1213C20.0289 10.1213 19.7443 9.83681 19.7443 9.49371C19.7443 7.01673 18.0196 4.9414 15.7005 4.39747L15.9266 4.77405C16.1024 5.0753 16.0103 5.46026 15.7089 5.63599C15.4158 5.81173 15.0224 5.71967 14.8465 5.41841L13.9675 3.95398C13.8503 3.76152 13.8503 3.51884 13.9591 3.32637C14.0679 3.12553 14.2772 3.00838 14.5033 3.00838C18.0782 3.00838 20.9917 5.9205 20.9917 9.49371C21.0001 9.83681 20.7154 10.1213 20.3722 10.1213Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $480d64c61a1b53d5$export$2e2bcd8739ae039 = $480d64c61a1b53d5$var$SvgLanguage;




var $exYeM = parcelRequire("exYeM");

function $f0b6133eaa6ba60e$var$SvgLast(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector",
                d: "M9.6014 11.7457L0.223335 21.8285C0.082301 21.9826 0.00363768 22.1904 0.00448023 22.4067C0.00532279 22.6229 0.0856029 22.83 0.227834 22.9829C0.370064 23.1358 0.562722 23.222 0.763842 23.2229C0.964961 23.2237 1.15825 23.1391 1.3016 22.9874L11.1475 12.402C11.3152 12.2216 11.3884 11.9787 11.3673 11.7435C11.3777 11.6237 11.3634 11.5029 11.3253 11.3898C11.2873 11.2766 11.2265 11.1739 11.1473 11.0889L1.30109 0.503396C1.1581 0.349669 0.964172 0.263306 0.761958 0.263306C0.559745 0.263306 0.365814 0.349669 0.222827 0.503396C0.0798406 0.657122 -0.000488281 0.865621 -0.000488281 1.08302C-0.000488281 1.30043 0.0798406 1.50892 0.222827 1.66265L9.6014 11.7457Z",
                fill: "#727272"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector_2",
                d: "M18.231 11.7457L8.85222 21.8285C8.71119 21.9826 8.63252 22.1904 8.63337 22.4067C8.63421 22.6229 8.71449 22.83 8.85672 22.9829C8.99895 23.1358 9.19161 23.222 9.39273 23.2229C9.59385 23.2237 9.78713 23.1391 9.93048 22.9874L19.7764 12.402C19.9441 12.2216 20.0173 11.9787 19.9962 11.7435C20.0066 11.6237 19.9922 11.5029 19.9542 11.3898C19.9161 11.2766 19.8553 11.1739 19.7761 11.0889L9.93048 0.503396C9.7875 0.349669 9.59357 0.263306 9.39135 0.263306C9.18914 0.263306 8.99521 0.349669 8.85222 0.503396C8.70924 0.657122 8.62891 0.865621 8.62891 1.08302C8.62891 1.30043 8.70924 1.50892 8.85222 1.66265L18.231 11.7457Z",
                fill: "#727272"
            })
        ]
    }));
}
var $f0b6133eaa6ba60e$export$2e2bcd8739ae039 = $f0b6133eaa6ba60e$var$SvgLast;




var $exYeM = parcelRequire("exYeM");

function $b1cf2a46a66f1313$var$SvgLegacy(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.3809 3.27038C12.5018 2.87966 11.4983 2.87966 10.6192 3.27038L5.62133 5.49164C4.38429 6.04144 3.59276 7.26008 3.66901 8.5691C3.84589 11.6059 4.37566 13.7238 5.39356 15.4596C6.41247 17.1971 7.95519 18.6115 10.2722 20.1802C11.3143 20.8857 12.6881 20.8868 13.7277 20.1813C16.0495 18.6057 17.5804 17.1778 18.5897 15.4379C19.5988 13.6984 20.1205 11.5881 20.313 8.58695C20.3977 7.26813 19.6043 6.03634 18.3589 5.48283L13.3809 3.27038ZM10.1318 2.17381C11.3212 1.64519 12.6789 1.64519 13.8683 2.17381L18.8463 4.38626C20.5123 5.12671 21.63 6.80315 21.5106 8.66379C21.3119 11.7605 20.7663 14.0773 19.6277 16.04C18.4894 18.0023 16.7924 19.5518 14.4016 21.1742C12.9539 22.1566 11.0466 22.1536 9.59945 21.1739C7.21834 19.5618 5.50797 18.0269 4.35842 16.0666C3.20786 14.1046 2.65378 11.7763 2.47104 8.63888C2.3633 6.78931 3.47976 5.13027 5.13396 4.39506L10.1318 2.17381Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.3951 8.54853C15.6445 8.76674 15.6698 9.14579 15.4516 9.39518L12.5817 12.6751C12.0178 13.3194 11.0466 13.4057 10.378 12.8709L8.6252 11.4686C8.36645 11.2616 8.32449 10.884 8.5315 10.6253C8.73851 10.3665 9.11608 10.3245 9.37484 10.5316L11.1277 11.9338C11.2948 12.0675 11.5376 12.046 11.6786 11.8849L14.5485 8.60497C14.7667 8.35559 15.1457 8.33032 15.3951 8.54853Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $b1cf2a46a66f1313$export$2e2bcd8739ae039 = $b1cf2a46a66f1313$var$SvgLegacy;




var $exYeM = parcelRequire("exYeM");

function $8533928d7a391c2c$var$SvgLightMode(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12.0363 4.5C12.0248 4.50117 12.0134 4.50307 12.0022 4.50569C11.9349 4.51415 11.8731 4.54737 11.829 4.59888C11.7848 4.65039 11.7614 4.71649 11.7634 4.7843V6.95074C11.8546 6.9463 11.944 6.93937 12.0363 6.93937C12.1268 6.93937 12.2198 6.94649 12.3093 6.95074V4.7843C12.3108 4.74752 12.3049 4.7108 12.2918 4.67636C12.2788 4.64193 12.2589 4.61048 12.2334 4.58392C12.2079 4.55736 12.1773 4.53623 12.1435 4.5218C12.1096 4.50738 12.0731 4.49997 12.0363 4.5ZM6.53762 6.76889C6.48594 6.77394 6.43678 6.79361 6.3959 6.82561C6.35502 6.85761 6.32411 6.90061 6.3068 6.94956C6.28949 6.9985 6.2865 7.05137 6.29817 7.10195C6.30985 7.15254 6.3357 7.19876 6.37271 7.23517L7.90802 8.77047C8.03137 8.63463 8.15858 8.50694 8.29468 8.38381L6.75938 6.8485C6.73071 6.81951 6.6959 6.79731 6.65753 6.78353C6.61915 6.76976 6.57818 6.76476 6.53762 6.76889ZM17.4724 6.76889C17.4099 6.77565 17.3517 6.80377 17.3075 6.8485L15.7722 8.38381C15.9075 8.50601 16.0419 8.63001 16.1646 8.76479L17.6942 7.23518C17.7348 7.1954 17.762 7.14391 17.7719 7.08793C17.7819 7.03194 17.7741 6.97424 17.7497 6.92289C17.7253 6.87154 17.6854 6.8291 17.6357 6.80149C17.586 6.77388 17.5289 6.76248 17.4724 6.76889ZM12.0249 7.81517C9.44027 7.81517 7.34498 9.91611 7.34498 12.5007C7.34498 15.0853 9.44009 17.1862 12.0249 17.1862C14.6094 17.1862 16.7104 15.0855 16.7104 12.5007C16.7104 9.91611 14.6094 7.81517 12.0249 7.81517ZM4.24599 12.2278C4.1736 12.2353 4.10717 12.2713 4.06132 12.3278C4.01546 12.3843 3.99394 12.4567 4.00148 12.5291C4.00902 12.6015 4.04501 12.6679 4.10152 12.7138C4.15804 12.7597 4.23046 12.7812 4.30285 12.7736H6.47511C6.47085 12.6845 6.46374 12.5966 6.46374 12.5064C6.46374 12.4142 6.47066 12.3188 6.47511 12.2278H4.30285C4.29338 12.2273 4.28389 12.2273 4.27442 12.2278C4.26495 12.2273 4.25546 12.2273 4.24599 12.2278ZM17.6031 12.2278C17.6075 12.3188 17.6088 12.4142 17.6088 12.5064C17.6088 12.5966 17.6073 12.6845 17.6031 12.7736H19.7695C19.8057 12.7742 19.8417 12.7676 19.8753 12.7541C19.909 12.7407 19.9396 12.7207 19.9654 12.6953C19.9912 12.6699 20.0117 12.6396 20.0257 12.6062C20.0397 12.5728 20.047 12.5369 20.047 12.5007C20.047 12.4645 20.0397 12.4286 20.0257 12.3952C20.0117 12.3618 19.9912 12.3315 19.9654 12.3061C19.9396 12.2807 19.909 12.2607 19.8753 12.2472C19.8417 12.2338 19.8057 12.2272 19.7695 12.2278H17.6031ZM7.90797 16.2309L6.37267 17.7662C6.34728 17.7916 6.32714 17.8217 6.3134 17.8549C6.29966 17.8881 6.29259 17.9236 6.29259 17.9596C6.29259 18.0321 6.32139 18.1016 6.37267 18.1529C6.42394 18.2042 6.49349 18.233 6.566 18.233C6.63852 18.233 6.70806 18.2042 6.75934 18.1529L8.28894 16.6176C8.15392 16.4951 8.03041 16.3659 7.90797 16.2309ZM16.1645 16.2422C16.0427 16.3759 15.912 16.5018 15.7778 16.6232L17.3074 18.1528C17.3587 18.2041 17.4282 18.2329 17.5008 18.2329C17.5733 18.2329 17.6428 18.2041 17.6941 18.1528C17.7454 18.1015 17.7742 18.032 17.7742 17.9595C17.7742 17.8869 17.7454 17.8174 17.6941 17.7661L16.1645 16.2422ZM11.7632 18.0561V20.2226C11.7626 20.2588 11.7692 20.2948 11.7827 20.3284C11.7961 20.362 11.8161 20.3926 11.8415 20.4185C11.8669 20.4443 11.8972 20.4648 11.9306 20.4788C11.9641 20.4928 11.9999 20.5 12.0361 20.5C12.0724 20.5 12.1082 20.4928 12.1416 20.4788C12.175 20.4648 12.2053 20.4443 12.2307 20.4185C12.2561 20.3926 12.2761 20.362 12.2896 20.3284C12.303 20.2948 12.3097 20.2588 12.3091 20.2226V18.0561C12.2197 18.0605 12.1266 18.0674 12.0361 18.0674C11.9439 18.0674 11.8544 18.0605 11.7632 18.0561Z",
            fill: "currentColor"
        })
    }));
}
var $8533928d7a391c2c$export$2e2bcd8739ae039 = $8533928d7a391c2c$var$SvgLightMode;




var $exYeM = parcelRequire("exYeM");

function $dc0aa3760240d972$var$SvgLink(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.477539 12.0001C0.477539 9.15583 2.78327 6.8501 5.62754 6.8501H7.82754C8.24175 6.8501 8.57754 7.18588 8.57754 7.6001C8.57754 8.01431 8.24175 8.3501 7.82754 8.3501H5.62754C3.6117 8.3501 1.97754 9.98426 1.97754 12.0001C1.97754 14.0159 3.6117 15.6501 5.62754 15.6501H7.82754C8.24175 15.6501 8.57754 15.9859 8.57754 16.4001C8.57754 16.8143 8.24175 17.1501 7.82754 17.1501H5.62754C2.78327 17.1501 0.477539 14.8444 0.477539 12.0001ZM15.8775 7.6001C15.8775 7.18588 16.2133 6.8501 16.6275 6.8501H18.8275C21.6718 6.8501 23.9775 9.15583 23.9775 12.0001C23.9775 14.8444 21.6718 17.1501 18.8275 17.1501H16.6275C16.2133 17.1501 15.8775 16.8143 15.8775 16.4001C15.8775 15.9859 16.2133 15.6501 16.6275 15.6501H18.8275C20.8434 15.6501 22.4775 14.0159 22.4775 12.0001C22.4775 9.98426 20.8434 8.3501 18.8275 8.3501H16.6275C16.2133 8.3501 15.8775 8.01431 15.8775 7.6001ZM7.07754 12.0001C7.07754 11.5859 7.41333 11.2501 7.82754 11.2501H16.6275C17.0418 11.2501 17.3775 11.5859 17.3775 12.0001C17.3775 12.4143 17.0418 12.7501 16.6275 12.7501H7.82754C7.41333 12.7501 7.07754 12.4143 7.07754 12.0001Z",
            fill: "currentColor"
        })
    }));
}
var $dc0aa3760240d972$export$2e2bcd8739ae039 = $dc0aa3760240d972$var$SvgLink;




var $exYeM = parcelRequire("exYeM");

function $567d89352d8c7d60$var$SvgLoading(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M24.432 11.1616C24.5297 11.9542 24.3082 12.7531 23.8169 13.3826C23.3254 14.012 22.6039 14.4206 21.8113 14.5181C21.0187 14.6157 20.2196 14.3945 19.5903 13.903C18.9607 13.4115 18.5523 12.69 18.4547 11.8974C18.3572 11.1047 18.5784 10.3059 19.0699 9.67634C19.5615 9.047 20.2827 8.63838 21.0753 8.54093C21.8682 8.44325 22.667 8.66448 23.2964 9.15599C23.9259 9.64753 24.3343 10.369 24.432 11.1616Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M19.9341 3.46405C20.4122 3.93997 20.6819 4.5865 20.6834 5.26117C20.6849 5.93583 20.4185 6.58367 19.9425 7.06182C19.4664 7.53997 18.8201 7.80962 18.1452 7.81117C17.4706 7.81273 16.8229 7.54622 16.3446 7.07027C15.8664 6.59435 15.5968 5.94782 15.5952 5.27315C15.5937 4.59832 15.8602 3.95065 16.3361 3.4725C16.812 2.99412 17.4586 2.72469 18.1332 2.72315C18.8081 2.72137 19.4557 2.98788 19.9341 3.46405H19.9341Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M13.2107 0.786521C13.7696 0.902717 14.2596 1.23635 14.5727 1.71383C14.8856 2.19109 14.9962 2.77341 14.88 3.33253C14.7638 3.89142 14.4301 4.38138 13.9527 4.69448C13.4752 5.00738 12.8931 5.118 12.334 5.0018C11.7751 4.8856 11.2851 4.55197 10.972 4.0745C10.6591 3.59701 10.5485 3.01491 10.6647 2.45579C10.7809 1.89691 11.1145 1.40694 11.592 1.09384C12.0693 0.780943 12.6516 0.670326 13.2107 0.786521Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M7.17135 1.74731C7.633 1.52184 8.16556 1.48928 8.65131 1.65655C9.13727 1.82359 9.53694 2.17707 9.76217 2.63895C9.98742 3.10059 10.0202 3.63293 9.85294 4.11891C9.68567 4.60487 9.33241 5.00431 8.87054 5.22977C8.40889 5.45502 7.87632 5.4878 7.39057 5.32053C6.90462 5.15327 6.50495 4.80001 6.27971 4.33814C6.05447 3.87626 6.02168 3.34392 6.18895 2.85794C6.35621 2.37221 6.70948 1.97254 7.17135 1.74731Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M2.63401 5.40181C2.85056 4.99971 3.21807 4.7002 3.65569 4.56905C4.09326 4.43792 4.56495 4.48609 4.96706 4.70264C5.36916 4.91942 5.66867 5.28693 5.79982 5.72449C5.93073 6.16206 5.88278 6.63375 5.666 7.03586C5.44945 7.43774 5.08194 7.73725 4.64432 7.86839C4.20676 7.99953 3.73506 7.95135 3.33295 7.7348C2.93085 7.51803 2.63134 7.15052 2.5002 6.71295C2.36906 6.27561 2.41723 5.80392 2.63401 5.40181Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M0.56274 10.2383C0.521481 9.8407 0.639906 9.44326 0.891915 9.13308C1.14393 8.82263 1.5088 8.62526 1.90623 8.58422C2.30387 8.54297 2.70153 8.66139 3.01172 8.9134C3.32191 9.16541 3.51931 9.53029 3.56057 9.92771C3.60161 10.3254 3.48318 10.7228 3.23117 11.033C2.97938 11.3432 2.61428 11.5408 2.21686 11.5818C1.81944 11.6231 1.42178 11.5047 1.1116 11.2527C0.801376 11.0006 0.604001 10.6358 0.56274 10.2383Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M0.838025 15.3494C0.582888 15.08 0.445065 14.7203 0.455102 14.3492C0.465138 13.9783 0.622145 13.6264 0.891549 13.3712C1.16095 13.1161 1.52071 12.9783 1.89182 12.9883C2.2627 12.9983 2.61439 13.1553 2.86976 13.4248C3.1249 13.6942 3.26272 14.0539 3.25269 14.4248C3.24265 14.7959 3.08564 15.1476 2.81624 15.403C2.54683 15.6581 2.18707 15.7959 1.8162 15.7859C1.44509 15.7759 1.0934 15.6188 0.838025 15.3494Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M3.04198 19.3038C2.70389 19.2485 2.40169 19.0611 2.20186 18.7828C2.00181 18.5047 1.92063 18.1586 1.97594 17.8205C2.03126 17.4825 2.21859 17.1802 2.4967 16.9802C2.7748 16.7803 3.12118 16.6989 3.45923 16.7542C3.7971 16.8096 4.09952 16.9971 4.29935 17.2752C4.4994 17.5533 4.58058 17.8995 4.52527 18.2375C4.46995 18.5756 4.28262 18.8778 4.00451 19.0779C3.72619 19.2777 3.38003 19.3591 3.04198 19.3038Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M6.31283 21.765C6.03451 21.9107 5.70999 21.9399 5.41025 21.8462C5.11051 21.7523 4.86029 21.5433 4.71463 21.2652C4.569 20.9869 4.53978 20.6624 4.63367 20.3626C4.72734 20.0629 4.93631 19.8127 5.21442 19.667C5.49275 19.5214 5.81744 19.4922 6.11701 19.5861C6.41674 19.6797 6.66697 19.8887 6.81263 20.167C6.95826 20.4451 6.98747 20.7699 6.89358 21.0696C6.79992 21.3691 6.59095 21.6194 6.31283 21.765Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M9.33649 22.6063C9.20825 22.8289 8.99683 22.9915 8.74883 23.0582C8.50061 23.1251 8.23633 23.0905 8.01353 22.9623C7.79096 22.8341 7.62838 22.6226 7.56169 22.3744C7.49478 22.1264 7.52935 21.8619 7.65759 21.6393C7.78583 21.4168 7.99725 21.2542 8.24548 21.1873C8.49348 21.1206 8.75798 21.1552 8.98055 21.2834C9.20334 21.4116 9.36593 21.623 9.43261 21.871C9.4993 22.1193 9.46473 22.3838 9.33649 22.6063Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M11.5464 22.9354C11.461 23.084 11.3201 23.1924 11.1546 23.2367C10.9891 23.2813 10.8129 23.2581 10.6644 23.1727C10.3553 22.9948 10.2491 22.5998 10.4271 22.2907C10.5127 22.1424 10.6537 22.034 10.819 21.9894C10.9844 21.945 11.1606 21.968 11.3091 22.0534C11.4575 22.139 11.5658 22.28 11.6104 22.4453C11.655 22.6107 11.6319 22.7871 11.5464 22.9354Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M13.7535 22.6851C13.6964 22.7839 13.6025 22.8562 13.4921 22.8859C13.3819 22.9158 13.2644 22.9004 13.1654 22.8433C12.9593 22.7246 12.8886 22.4615 13.0073 22.2554C13.1259 22.0493 13.3891 21.9784 13.5951 22.097C13.6942 22.1541 13.7664 22.248 13.7961 22.3584C13.8257 22.4686 13.8103 22.5861 13.7535 22.6851Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $567d89352d8c7d60$export$2e2bcd8739ae039 = $567d89352d8c7d60$var$SvgLoading;




var $exYeM = parcelRequire("exYeM");

function $9dcdd567e104bf5c$var$SvgLogoWithText(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 124 45",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_4784_46479)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M61.5225 16.129H59.7776V21.4426H56.1006V5.27441H62.5335C65.5899 5.27441 68.0452 7.74673 68.0452 10.8155C68.0452 12.8012 66.8507 14.6025 65.0824 15.5051L68.5058 21.4426H64.5555L61.5225 16.129ZM59.7776 12.8954H62.5335C63.5445 12.8954 64.372 11.9967 64.372 10.8155C64.372 9.63432 63.5445 8.73565 62.5335 8.73565H59.7776V12.8915V12.8954Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M81.3251 9.8931V21.4423H77.8784V20.3553C77.1211 21.2343 75.993 21.7641 74.4551 21.7641C71.4455 21.7641 68.9629 19.1074 68.9629 15.6658C68.9629 12.2241 71.4455 9.56738 74.4551 9.56738C75.993 9.56738 77.1211 10.0972 77.8784 10.9762V9.88918H81.3251V9.8931ZM77.8784 15.6658C77.8784 13.9351 76.7308 12.8481 75.146 12.8481C73.5612 12.8481 72.4135 13.9351 72.4135 15.6658C72.4135 17.3964 73.5612 18.4834 75.146 18.4834C76.7308 18.4834 77.8784 17.3964 77.8784 15.6658Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M94.8778 14.3472V21.4384H91.4311V14.8573C91.4311 13.425 90.5372 12.7539 89.4325 12.7539C88.1678 12.7539 87.2973 13.4917 87.2973 15.132V21.4384H83.8506V9.89308H87.2973V10.9801C87.918 10.1246 89.0656 9.57129 90.584 9.57129C92.9027 9.57129 94.8818 11.2352 94.8818 14.3511L94.8778 14.3472Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M109.027 9.89355V20.8659C109.027 24.747 106.018 26.3874 102.961 26.3874C100.572 26.3874 98.5738 25.4848 97.516 23.5933L100.455 21.8862C100.892 22.6946 101.56 23.3421 103.075 23.3421C104.683 23.3421 105.67 22.5102 105.67 20.8698V19.8063C104.913 20.7521 103.808 21.3094 102.317 21.3094C99.054 21.3094 96.665 18.6291 96.665 15.4425C96.665 12.256 99.054 9.57568 102.317 9.57568C103.812 9.57568 104.913 10.129 105.67 11.0787V9.9014H109.023L109.027 9.89355ZM105.674 15.4347C105.674 13.8414 104.527 12.7544 102.895 12.7544C101.263 12.7544 100.116 13.8414 100.116 15.4347C100.116 17.0279 101.263 18.115 102.895 18.115C104.527 18.115 105.674 17.0279 105.674 15.4347Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M110.979 15.6658C110.979 12.2241 113.688 9.56738 117.069 9.56738C120.449 9.56738 123.158 12.2241 123.158 15.6658C123.158 19.1074 120.445 21.7641 117.069 21.7641C113.692 21.7641 110.979 19.1074 110.979 15.6658ZM119.708 15.6658C119.708 14.0254 118.56 12.9423 117.065 12.9423C115.57 12.9423 114.422 14.0293 114.422 15.6658C114.422 17.3022 115.57 18.3892 117.065 18.3892C118.56 18.3892 119.708 17.3022 119.708 15.6658Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M56.7563 36.4374H61.7527V37.1556H56.0029V27.1133H61.6825V27.8314H56.7602V31.7322H61.3272V32.4503H56.7602V36.4374H56.7563Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M69.6027 37.1556H68.7322L66.3199 34.0279L63.9076 37.1556H63.0371L65.8905 33.4667L63.2089 29.9819H64.0793L66.3199 32.8938L68.5761 29.9819H69.431L66.761 33.4549L69.6027 37.1556Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M74.2122 37.3128C73.1387 37.3128 72.2448 36.9557 71.5305 36.2375C70.8162 35.5194 70.4609 34.6325 70.4609 33.569C70.4609 32.5055 70.8162 31.6186 71.5305 30.9005C72.2448 30.1823 73.1387 29.8252 74.2122 29.8252C74.907 29.8252 75.5354 29.99 76.0975 30.3197C76.6596 30.6493 77.0695 31.0967 77.3232 31.6618L76.7377 32.0071C76.5269 31.548 76.199 31.183 75.7462 30.9162C75.2934 30.6493 74.7821 30.5159 74.2122 30.5159C73.3573 30.5159 72.6391 30.8102 72.0575 31.3988C71.4758 31.9875 71.187 32.7135 71.187 33.5729C71.187 34.4323 71.4758 35.1583 72.0575 35.747C72.6391 36.3356 73.3573 36.6299 74.2122 36.6299C74.7821 36.6299 75.2934 36.4965 75.7462 36.2297C76.199 35.9628 76.5425 35.5978 76.7806 35.1387L77.3818 35.4958C77.0968 36.0491 76.6713 36.4926 76.1053 36.8222C75.5393 37.1519 74.907 37.3167 74.2161 37.3167L74.2122 37.3128Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M82.5582 29.825C83.4053 29.825 84.0766 30.084 84.5763 30.6059C85.0759 31.1279 85.3258 31.8225 85.3258 32.6937V37.1556H84.5997V32.6937C84.5997 32.0226 84.4163 31.4928 84.0493 31.1004C83.6824 30.708 83.1671 30.5117 82.4997 30.5117C81.7658 30.5117 81.1686 30.7551 80.7002 31.2417C80.2357 31.7283 80.0014 32.4386 80.0014 33.3647V37.1517H79.2871V27.1094H80.0014V31.3398C80.5167 30.3273 81.3677 29.8171 82.5543 29.8171L82.5582 29.825Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M93.96 29.9821H94.6899V37.1558H93.96V35.535C93.6555 36.0884 93.2379 36.524 92.7031 36.8418C92.1683 37.1558 91.5672 37.3167 90.8919 37.3167C89.8731 37.3167 89.0026 36.9556 88.2805 36.2336C87.5583 35.5115 87.1953 34.6246 87.1953 33.5729C87.1953 32.5212 87.5583 31.6343 88.2805 30.9122C89.0026 30.1901 89.8731 29.8291 90.8919 29.8291C91.5672 29.8291 92.1722 29.9861 92.7031 30.3039C93.234 30.6179 93.6555 31.0535 93.96 31.6107V29.99V29.9821ZM88.7996 35.7352C89.3852 36.3277 90.0995 36.626 90.9465 36.626C91.7936 36.626 92.5079 36.3277 93.0856 35.7352C93.6672 35.1426 93.9561 34.4205 93.9561 33.569C93.9561 32.7174 93.6672 31.9953 93.0856 31.4027C92.504 30.8102 91.7897 30.5119 90.9465 30.5119C90.1034 30.5119 89.3852 30.8102 88.7996 31.4027C88.2141 31.9953 87.9214 32.7174 87.9214 33.569C87.9214 34.4205 88.2141 35.1426 88.7996 35.7352Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M100.499 29.8252C101.346 29.8252 102.017 30.0842 102.517 30.6062C103.016 31.1281 103.266 31.8227 103.266 32.6939V37.1558H102.54V32.6939C102.54 32.0228 102.357 31.4931 101.99 31.1006C101.623 30.7082 101.108 30.512 100.44 30.512C99.7062 30.512 99.109 30.7553 98.6406 31.2419C98.1761 31.7285 97.9419 32.4388 97.9419 33.365V37.1519H97.2275V29.9783H97.9419V31.34C98.4571 30.3275 99.3081 29.8174 100.495 29.8174L100.499 29.8252Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M111.955 29.9822H112.669V36.8105C112.669 37.8543 112.33 38.6745 111.655 39.2788C110.979 39.8832 110.132 40.1814 109.113 40.1814C108.294 40.1814 107.595 40.0284 107.017 39.7223C106.436 39.4162 106.014 38.9963 105.749 38.4587L106.377 38.1016C106.834 39.0277 107.747 39.4947 109.117 39.4947C110.003 39.4947 110.698 39.2514 111.202 38.7687C111.705 38.286 111.959 37.6346 111.959 36.8105V35.4919C111.662 36.057 111.249 36.5004 110.71 36.8262C110.171 37.1519 109.566 37.3128 108.891 37.3128C107.864 37.3128 106.99 36.9517 106.272 36.2297C105.553 35.5076 105.194 34.6207 105.194 33.569C105.194 32.5173 105.553 31.6304 106.272 30.9083C106.99 30.1862 107.864 29.8252 108.891 29.8252C109.566 29.8252 110.171 29.9861 110.71 30.3118C111.249 30.6375 111.662 31.081 111.959 31.6461V29.9822H111.955ZM106.783 35.7352C107.369 36.3278 108.083 36.626 108.93 36.626C109.777 36.626 110.491 36.3278 111.077 35.7352C111.662 35.1426 111.955 34.4206 111.955 33.569C111.955 32.7174 111.662 31.9953 111.077 31.4028C110.491 30.8102 109.777 30.5119 108.93 30.5119C108.083 30.5119 107.369 30.8102 106.783 31.4028C106.198 31.9953 105.905 32.7174 105.905 33.569C105.905 34.4206 106.198 35.1426 106.783 35.7352Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M118.419 29.8252C119.465 29.8252 120.316 30.198 120.968 30.9436C121.62 31.6892 121.944 32.5761 121.944 33.5965C121.944 33.6357 121.944 33.6906 121.936 33.7691C121.932 33.8476 121.928 33.9025 121.928 33.9418H115.464C115.55 34.7463 115.87 35.3938 116.428 35.8843C116.987 36.3788 117.674 36.6221 118.489 36.6221C119.059 36.6221 119.559 36.5044 119.988 36.265C120.418 36.0256 120.738 35.7117 120.96 35.3192L121.589 35.692C121.296 36.1904 120.874 36.5828 120.332 36.8772C119.789 37.1715 119.173 37.3167 118.478 37.3167C117.385 37.3167 116.483 36.9635 115.78 36.2611C115.078 35.5586 114.723 34.6599 114.723 33.5729C114.723 32.4859 115.066 31.6108 115.757 30.8965C116.448 30.1862 117.334 29.8291 118.419 29.8291V29.8252ZM118.419 30.5119C117.611 30.5119 116.936 30.767 116.393 31.2733C115.851 31.7795 115.542 32.4349 115.464 33.2393H121.202C121.124 32.3878 120.824 31.7206 120.297 31.2379C119.77 30.7553 119.141 30.5119 118.419 30.5119Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M22.3785 44.9961C34.7378 44.9961 44.757 34.9234 44.757 22.498C44.757 10.0727 34.7378 0 22.3785 0C10.0192 0 0 10.0727 0 22.498C0 34.9234 10.0192 44.9961 22.3785 44.9961Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M19.3255 15.3717C19.3255 15.3717 20.2663 15.8936 21.6871 16.6863L40.2442 8.94759C39.5728 8.05677 38.8389 7.21697 38.0465 6.43604C37.9177 6.5106 37.8084 6.55376 37.8084 6.55376L18.4512 14.7359C18.6698 14.9596 18.9547 15.1755 19.3255 15.3678V15.3717Z",
                        fill: "url(#paint0_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M42.2159 12.0829L38.7964 13.4133C36.0601 14.4218 25.2905 18.6875 25.2905 18.6875C27.0509 19.6647 28.9519 20.7164 30.6265 21.6347C34.9086 23.9853 32.1996 29.1458 31.6336 30.1269C31.6258 30.1387 31.618 30.1544 31.6102 30.1661C31.5633 30.2446 31.536 30.2917 31.536 30.2917C31.536 30.2917 31.9381 26.4341 29.233 25.0096C26.5084 23.5851 20.2589 20.2416 17.6319 18.8327C16.3945 18.1695 15.4967 16.9648 15.3289 15.5677C15.204 14.5199 15.4655 13.3152 16.7146 12.2635C17.4445 11.5845 18.2252 11.2196 18.2252 11.2196L32.1879 5.45871C32.1879 5.45871 32.2777 5.42339 32.4065 5.35668L35.3106 4.14407C31.657 1.5344 27.1993 0 22.3785 0C10.0202 0 0 10.0737 0 22.498C0 26.4969 1.04222 30.2525 2.86514 33.5057L8.26752 31.1394L19.0215 26.6029C17.1674 25.5825 15.4538 24.6289 14.6419 24.1933C14.2359 23.9736 13.7284 23.6322 13.3225 23.4163C11.1444 22.2587 9.7157 18.9897 13.0219 15.1125C13.0219 15.1125 12.6784 18.7935 14.7238 20.0414C16.6756 21.2344 24.2444 25.1312 26.4888 26.3399C27.0666 26.65 27.5974 27.0463 28.019 27.5486C28.8934 28.5886 29.2252 29.8757 28.8582 31.2335C28.8426 31.3003 28.8192 31.367 28.7997 31.4298C28.788 31.4729 28.7724 31.5161 28.7567 31.5553C28.7333 31.622 28.7099 31.6848 28.6865 31.7476C28.6787 31.7672 28.6709 31.7869 28.6631 31.8065C27.8941 33.6784 25.8409 34.2396 25.8409 34.2396L25.591 34.322L12.5223 39.714L9.64153 40.9854C13.2561 43.5048 17.6436 44.9882 22.3785 44.9882C34.7368 44.9882 44.757 34.9145 44.757 22.4902C44.757 18.7307 43.8358 15.1871 42.212 12.0712L42.2159 12.0829Z",
                        fill: "url(#paint1_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M22.6365 28.5845L8.29916 34.7064L4.66895 36.2487C5.33644 37.1159 6.06248 37.9322 6.84707 38.6896L7.34671 38.4384L26.1262 30.5663L22.6326 28.5806L22.6365 28.5845Z",
                        fill: "url(#paint2_linear_4784_46479)"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M19.0181 26.603L22.6366 28.5848L20.8254 29.3579L17.0391 27.4389L19.0181 26.603Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M25.8408 34.2513C25.8408 34.2513 28.8464 32.1126 26.1257 30.5703L24.4199 31.2845C24.4199 31.2845 27.2694 32.0537 25.8408 34.2513Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M19.0181 26.603L22.6366 28.5848L20.8254 29.3579L17.0391 27.4389L19.0181 26.603Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.1,
                        d: "M25.8408 34.2513C25.8408 34.2513 28.8464 32.1126 26.1257 30.5703L24.4199 31.2845C24.4199 31.2845 27.2694 32.0537 25.8408 34.2513Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.3,
                        d: "M20.3095 13.9196L18.3968 14.7281C18.3968 14.7281 15.6293 12.295 19.0097 10.9019C19.0097 10.9019 17.9128 12.7737 20.3056 13.9196H20.3095Z",
                        fill: "#4D4D4D"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        opacity: 0.3,
                        d: "M25.2904 18.7109L21.6602 16.6938L23.405 15.9639L26.9728 18.0281L25.2904 18.7109Z",
                        fill: "#4D4D4D"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_4784_46479",
                        x1: 18.4512,
                        y1: 11.5651,
                        x2: 40.2442,
                        y2: 11.5651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.09,
                                stopColor: "#3A81F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.21,
                                stopColor: "#2F68F2"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.34,
                                stopColor: "#2654F2"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.49,
                                stopColor: "#2046F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.67,
                                stopColor: "#1D3EF1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_4784_46479",
                        x1: 0,
                        y1: 22.498,
                        x2: 44.7609,
                        y2: 22.498,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#2756F2"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_4784_46479",
                        x1: 4.67285,
                        y1: 33.639,
                        x2: 26.1301,
                        y2: 33.639,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.08,
                                stopColor: "#469BF5"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.24,
                                stopColor: "#4191F4"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.51,
                                stopColor: "#3678F3"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 0.85,
                                stopColor: "#2550F1"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#1C3CF1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip0_4784_46479",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 123.158,
                            height: 45,
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    }));
}
var $9dcdd567e104bf5c$export$2e2bcd8739ae039 = $9dcdd567e104bf5c$var$SvgLogoWithText;




var $exYeM = parcelRequire("exYeM");

function $af6eed1353e28a77$var$SvgLogout(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_19665_403207)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.268555 6.51603C0.268555 3.41999 2.77839 0.910156 5.87443 0.910156H11.1186C14.2147 0.910156 16.7245 3.41999 16.7245 6.51604V6.8207C16.7245 7.22453 16.3971 7.5519 15.9933 7.5519C15.5895 7.5519 15.2621 7.22453 15.2621 6.8207V6.51604C15.2621 4.22766 13.407 2.37256 11.1186 2.37256H5.87443C3.58606 2.37256 1.73096 4.22766 1.73096 6.51603V17.4841C1.73096 19.7724 3.58606 21.6275 5.87443 21.6275H11.1186C13.407 21.6275 15.2621 19.7724 15.2621 17.4841V17.1794C15.2621 16.7756 15.5895 16.4482 15.9933 16.4482C16.3971 16.4482 16.7245 16.7756 16.7245 17.1794V17.4841C16.7245 20.5801 14.2147 23.0899 11.1186 23.0899H5.87443C2.77839 23.0899 0.268555 20.5801 0.268555 17.4841V6.51603ZM19.533 8.3803C19.7831 8.06325 20.2429 8.00898 20.56 8.2591C21.2114 8.77302 21.9659 9.38204 22.5599 9.97564C22.8565 10.2721 23.1335 10.5846 23.3408 10.8972C23.5373 11.1936 23.7309 11.5778 23.731 12C23.731 12.4221 23.5373 12.8064 23.3408 13.1028C23.1335 13.4153 22.8565 13.7279 22.5599 14.0244C21.9659 14.618 21.2114 15.227 20.56 15.7409C20.2429 15.991 19.7831 15.9367 19.533 15.6197C19.2829 15.3026 19.3372 14.8429 19.6542 14.5927C20.3082 14.0768 21.0001 13.5157 21.5261 12.99C21.6159 12.9003 21.6984 12.8139 21.7735 12.7312H10.672C10.2682 12.7312 9.94084 12.4038 9.94084 12C9.94084 11.5962 10.2682 11.2688 10.672 11.2688H21.7734C21.6984 11.1861 21.6158 11.0997 21.5261 11.01C21 10.4843 20.3082 9.92316 19.6542 9.40725C19.3372 9.15713 19.2829 8.69735 19.533 8.3803Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_19665_403207",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $af6eed1353e28a77$export$2e2bcd8739ae039 = $af6eed1353e28a77$var$SvgLogout;




var $exYeM = parcelRequire("exYeM");

function $b4b4db0dbded274d$var$SvgMenu(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 7H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 12H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M3 17H21",
                stroke: "currentColor",
                strokeWidth: 1.5,
                strokeLinecap: "round"
            })
        ]
    }));
}
var $b4b4db0dbded274d$export$2e2bcd8739ae039 = $b4b4db0dbded274d$var$SvgMenu;




var $exYeM = parcelRequire("exYeM");

function $3591b0c23ff6c1f5$var$SvgMore(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.80078 12.5C7.80078 11.6716 7.12921 11 6.30078 11C5.47235 11 4.80078 11.6716 4.80078 12.5C4.80078 13.3284 5.47235 14 6.30078 14C7.12921 14 7.80078 13.3284 7.80078 12.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M13.8008 12.5C13.8008 11.6716 13.1292 11 12.3008 11C11.4724 11 10.8008 11.6716 10.8008 12.5C10.8008 13.3284 11.4724 14 12.3008 14C13.1292 14 13.8008 13.3284 13.8008 12.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M19.8008 12.5C19.8008 11.6716 19.1292 11 18.3008 11C17.4724 11 16.8008 11.6716 16.8008 12.5C16.8008 13.3284 17.4724 14 18.3008 14C19.1292 14 19.8008 13.3284 19.8008 12.5Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $3591b0c23ff6c1f5$export$2e2bcd8739ae039 = $3591b0c23ff6c1f5$var$SvgMore;




var $exYeM = parcelRequire("exYeM");

function $3a3b92139b7892d7$var$SvgNoRoute(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.0304 2.4375V3.12441C16.0304 2.4375 16.0301 2.4375 16.0304 2.4375L16.0319 2.4375L16.0337 2.43751L16.0383 2.43753L16.0514 2.43769C16.0618 2.43785 16.0757 2.43815 16.0928 2.43869C16.1269 2.43978 16.174 2.44185 16.2323 2.44582C16.3486 2.45373 16.5106 2.46924 16.7041 2.49975C17.0884 2.56031 17.612 2.6823 18.1526 2.93156C19.2617 3.44284 20.4302 4.49412 20.5947 6.51644L20.5969 6.54424V12.2916H19.2231V6.60106C19.0998 5.19398 18.3333 4.52763 17.5775 4.17918C17.1833 3.99747 16.7896 3.90398 16.4902 3.85681C16.342 3.83344 16.2206 3.82201 16.139 3.81646C16.1049 3.81414 16.0779 3.81286 16.0591 3.81215C14.4249 3.99225 13.6604 4.74826 13.2775 5.40608C13.0756 5.7529 12.9692 6.09267 12.9139 6.34615C12.8864 6.47201 12.8721 6.57383 12.8648 6.64072C12.8612 6.67407 12.8593 6.69844 12.8584 6.71244L12.858 6.71956V16.88L12.8557 16.9078C12.6915 18.9309 11.5302 19.9824 10.4243 20.4932C9.88568 20.7421 9.36417 20.8632 8.98144 20.9231C8.78867 20.9532 8.62727 20.9684 8.51139 20.9761C8.45335 20.9799 8.40642 20.9819 8.37236 20.9829C8.35532 20.9834 8.34147 20.9837 8.33102 20.9838L8.31792 20.9839L8.31333 20.9839H8.31153C6.00027 20.9881 4.73082 20.0094 4.08107 18.9328C3.76952 18.4165 3.61648 17.9054 3.54043 17.527C3.50215 17.3366 3.4826 17.1759 3.47258 17.0595C3.46756 17.0012 3.46489 16.9536 3.46348 16.9186C3.46278 16.901 3.46239 16.8866 3.46217 16.8755L3.46196 16.8613L3.46192 16.8561L3.46192 16.854C3.46192 16.8535 3.46191 16.8522 4.14882 16.8522H3.46191V12.2916H4.83572V16.8488L4.83619 16.8634C4.83681 16.8789 4.83821 16.9055 4.84132 16.9416C4.84756 17.0141 4.86053 17.1231 4.8873 17.2563C4.94134 17.5252 5.04848 17.8769 5.2573 18.2229C5.64805 18.8704 6.46017 19.614 8.3103 19.6101L8.31297 19.6101L8.3316 19.6097C8.3501 19.6091 8.38034 19.6079 8.42071 19.6053C8.50165 19.5999 8.62205 19.5888 8.76918 19.5658C9.06627 19.5193 9.45701 19.4268 9.84817 19.2461C10.5972 18.9001 11.3607 18.2353 11.4842 16.8233V6.68664L12.1711 6.70407C11.4844 6.68664 11.4842 6.68706 11.4842 6.68664L11.4844 6.68491L11.4845 6.68287L11.4847 6.6779L11.4852 6.66444C11.4857 6.65392 11.4864 6.64034 11.4874 6.62387C11.4896 6.59096 11.4931 6.54642 11.4991 6.4918C11.511 6.38273 11.5325 6.23231 11.5717 6.05306C11.6496 5.6963 11.7995 5.21429 12.0902 4.71496C12.6891 3.68608 13.8445 2.65953 15.9599 2.44113L15.9951 2.4375H16.0304ZM12.8576 6.72561C12.8576 6.7264 12.8576 6.72625 12.8576 6.72561V6.72561Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "mask0_3736_40141",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 3,
                y: 2,
                width: 20,
                height: 19,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.11822 18.3546L21.1163 2.88989L22.7441 4.78442L4.74609 20.2491L3.11822 18.3546Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                mask: "url(#mask0_3736_40141)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.0251 2.43726V3.12416C16.0251 2.43726 16.0247 2.43726 16.0251 2.43726L16.0265 2.43726L16.0283 2.43726L16.0329 2.43729L16.046 2.43744C16.0564 2.4376 16.0703 2.4379 16.0874 2.43845C16.1216 2.43953 16.1686 2.44161 16.2269 2.44557C16.3432 2.45349 16.5052 2.469 16.6988 2.4995C17.083 2.56006 17.6066 2.68206 18.1473 2.93132C19.2563 3.4426 20.4248 4.49387 20.5893 6.5162L20.5916 6.54399V12.2913H19.2177V6.60081C19.0944 5.19374 18.328 4.52739 17.5721 4.17894C17.178 3.99723 16.7842 3.90374 16.4849 3.85656C16.3366 3.83319 16.2153 3.82177 16.1336 3.81622C16.0995 3.81389 16.0725 3.81261 16.0537 3.81191C14.4195 3.992 13.655 4.74801 13.2721 5.40584C13.0703 5.75266 12.9638 6.09243 12.9085 6.3459C12.881 6.47177 12.8667 6.57358 12.8594 6.64047C12.8558 6.67382 12.8539 6.69819 12.853 6.71219L12.8526 6.71932V16.8798L12.8504 16.9075C12.6861 18.9307 11.5248 19.9821 10.4189 20.493C9.88031 20.7418 9.3588 20.863 8.97606 20.9228C8.7833 20.953 8.6219 20.9682 8.50602 20.9758C8.44798 20.9797 8.40105 20.9816 8.36699 20.9827C8.34995 20.9832 8.3361 20.9834 8.32565 20.9836L8.31255 20.9837L8.30796 20.9837H8.30616C5.9949 20.9878 4.72545 20.0092 4.0757 18.9325C3.76415 18.4163 3.61111 17.9052 3.53506 17.5268C3.49678 17.3363 3.47723 17.1757 3.46721 17.0593C3.46218 17.0009 3.45952 16.9534 3.45811 16.9183C3.45741 16.9008 3.45702 16.8863 3.4568 16.8752L3.45659 16.861L3.45655 16.8558L3.45655 16.8537C3.45654 16.8533 3.45654 16.8519 4.14345 16.8519H3.45654V12.2913H4.83035V16.8486L4.83082 16.8631C4.83144 16.8787 4.83284 16.9053 4.83595 16.9414C4.84219 17.0138 4.85516 17.1229 4.88193 17.2561C4.93597 17.5249 5.04311 17.8767 5.25193 18.2227C5.64268 18.8702 6.4548 19.6137 8.30493 19.6099L8.3076 19.6099L8.32623 19.6094C8.34473 19.6089 8.37497 19.6077 8.41534 19.605C8.49628 19.5997 8.61667 19.5885 8.76381 19.5655C9.0609 19.5191 9.45164 19.4265 9.8428 19.2458C10.5918 18.8998 11.3553 18.2351 11.4788 16.8231V6.68639L12.1657 6.70383C11.479 6.6864 11.4788 6.68681 11.4788 6.68639L11.4791 6.68466L11.4791 6.68263L11.4793 6.67766L11.4798 6.6642C11.4803 6.65368 11.481 6.64009 11.4821 6.62363C11.4842 6.59071 11.4877 6.54618 11.4937 6.49155C11.5056 6.38249 11.5272 6.23207 11.5663 6.05282C11.6442 5.69606 11.7942 5.21405 12.0848 4.71472C12.6837 3.68583 13.8391 2.65928 15.9545 2.44089L15.9897 2.43726H16.0251ZM12.8523 6.72537C12.8522 6.72615 12.8522 6.726 12.8523 6.72537V6.72537Z",
                    fill: "#FDFDFD"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.8206 3.10254C23.0453 3.36412 23.0155 3.75838 22.7539 3.98314L2.76815 21.1558C2.50657 21.3805 2.11231 21.3507 1.88755 21.0891C1.66279 20.8275 1.69264 20.4333 1.95422 20.2085L21.94 3.03587C22.2016 2.81111 22.5958 2.84096 22.8206 3.10254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.908 12.7864C19.0532 12.7864 18.3601 13.4794 18.3601 14.3343C18.3601 15.1892 19.0532 15.8822 19.908 15.8822C20.7629 15.8822 21.4559 15.1892 21.4559 14.3343C21.4559 13.4794 20.7629 12.7864 19.908 12.7864ZM16.9863 14.3343C16.9863 12.7207 18.2944 11.4126 19.908 11.4126C21.5216 11.4126 22.8297 12.7207 22.8297 14.3343C22.8297 15.9479 21.5216 17.256 19.908 17.256C18.2944 17.256 16.9863 15.9479 16.9863 14.3343Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.14924 8.31766C3.29436 8.31766 2.60135 9.01067 2.60135 9.86555C2.60135 10.7204 3.29436 11.4134 4.14924 11.4134C5.00412 11.4134 5.69713 10.7204 5.69713 9.86555C5.69713 9.01067 5.00412 8.31766 4.14924 8.31766ZM1.22754 9.86555C1.22754 8.25194 2.53563 6.94385 4.14924 6.94385C5.76285 6.94385 7.07094 8.25194 7.07094 9.86555C7.07094 11.4792 5.76285 12.7873 4.14924 12.7873C2.53563 12.7873 1.22754 11.4792 1.22754 9.86555Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $3a3b92139b7892d7$export$2e2bcd8739ae039 = $3a3b92139b7892d7$var$SvgNoRoute;




var $exYeM = parcelRequire("exYeM");

function $68b8157e90e31e9e$var$SvgNext(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.3231 7.40376L23.4597 11.5403C23.7136 11.7942 23.7136 12.2057 23.4597 12.4596L19.3231 16.5961C19.0693 16.85 18.6577 16.85 18.4039 16.5961C18.1501 16.3423 18.1501 15.9307 18.4039 15.6769L21.4309 12.65H1.0001C0.641113 12.65 0.350098 12.3589 0.350098 12C0.350098 11.641 0.641113 11.35 1.0001 11.35H21.4309L18.4039 8.323C18.1501 8.06916 18.1501 7.6576 18.4039 7.40376C18.6577 7.14992 19.0693 7.14992 19.3231 7.40376Z",
            fill: "currentColor"
        })
    }));
}
var $68b8157e90e31e9e$export$2e2bcd8739ae039 = $68b8157e90e31e9e$var$SvgNext;




var $exYeM = parcelRequire("exYeM");

function $7c795f0e1104a290$var$SvgNoNotification(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Frame 1000007661",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                id: "Group 1000007530",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        id: "Subtract",
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.08063 7.73123C5.08063 4.14247 7.99067 1.2332 11.5804 1.2332C14.1703 1.2332 16.4065 2.7476 17.4511 4.93898L18.3676 4.02277C17.0543 1.62551 14.5072 0 11.5804 0C7.30941 0 3.8471 3.46139 3.8471 7.73123C3.8471 9.21129 3.06751 10.9332 2.1141 12.2068C1.41485 13.1409 1.00049 14.3016 1.00049 15.5573C1.00049 17.1616 1.67567 18.6083 2.75746 19.6287L3.63017 18.7563C2.7714 17.9594 2.23402 16.8211 2.23402 15.5573C2.23402 14.577 2.55661 13.6739 3.1017 12.9457C4.14201 11.5559 5.08063 9.57778 5.08063 7.73123ZM6.16446 19.8996L5.10978 20.954C5.58391 21.0845 6.08322 21.1542 6.59882 21.1542H8.17177C8.46269 22.7722 9.87812 24 11.5804 24C13.2827 24 14.6981 22.7722 14.989 21.1542H16.562C19.6538 21.1542 22.1603 18.6484 22.1603 15.5573C22.1603 14.3016 21.7459 13.1409 21.0467 12.2068C20.0933 10.9332 19.3137 9.21129 19.3137 7.73123C19.3137 7.41895 19.2952 7.111 19.2592 6.8084L18.0858 7.98147C18.1649 9.75478 19.0656 11.6185 20.0591 12.9457C20.6042 13.6739 20.9268 14.577 20.9268 15.5573C20.9268 17.9673 18.9726 19.9209 16.562 19.9209H6.59882C6.45223 19.9209 6.30733 19.9137 6.16446 19.8996ZM11.5804 22.7668C10.5628 22.7668 9.70449 22.0854 9.43694 21.1542H13.7238C13.4563 22.0854 12.5979 22.7668 11.5804 22.7668Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        id: "Rectangle 6608",
                        d: "M19.9662 3.42426C20.2006 3.18995 20.5806 3.18995 20.815 3.42426C21.0494 3.65858 21.0494 4.03848 20.815 4.27279L2.27315 22.8096C2.03877 23.0439 1.65877 23.0439 1.42439 22.8096C1.19001 22.5753 1.19001 22.1954 1.42439 21.9611L19.9662 3.42426Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $7c795f0e1104a290$export$2e2bcd8739ae039 = $7c795f0e1104a290$var$SvgNoNotification;




var $exYeM = parcelRequire("exYeM");

function $57438ef1fa5a2b4d$var$SvgNotificationNumber(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_3736_40162)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M24 12.571C24 19.1985 18.6274 24.571 12 24.571C5.37258 24.571 0 19.1985 0 12.571C0 5.94363 5.37258 0.571045 12 0.571045C18.6274 0.571045 24 5.94363 24 12.571Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12 23.571C18.0751 23.571 23 18.6462 23 12.571C23 6.49591 18.0751 1.57104 12 1.57104C5.92487 1.57104 1 6.49591 1 12.571C1 18.6462 5.92487 23.571 12 23.571ZM12 24.571C18.6274 24.571 24 19.1985 24 12.571C24 5.94363 18.6274 0.571045 12 0.571045C5.37258 0.571045 0 5.94363 0 12.571C0 19.1985 5.37258 24.571 12 24.571Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M10.9863 12.4939H12.1113C12.5488 12.4939 12.9108 12.4184 13.1973 12.2673C13.4889 12.1163 13.7051 11.908 13.8457 11.6423C13.9863 11.3767 14.0566 11.072 14.0566 10.7283C14.0566 10.3689 13.9915 10.0616 13.8613 9.8064C13.7363 9.54598 13.5436 9.34546 13.2832 9.20483C13.028 9.06421 12.7025 8.9939 12.3066 8.9939C11.9733 8.9939 11.6712 9.0616 11.4004 9.19702C11.1348 9.32723 10.9238 9.51473 10.7676 9.75952C10.6113 9.9991 10.5332 10.2856 10.5332 10.6189H8.64258C8.64258 10.0147 8.80143 9.47827 9.11914 9.00952C9.43685 8.54077 9.86914 8.17358 10.416 7.90796C10.9681 7.63713 11.5879 7.50171 12.2754 7.50171C13.0098 7.50171 13.6504 7.6241 14.1973 7.8689C14.7493 8.10848 15.179 8.46785 15.4863 8.94702C15.7936 9.42619 15.9473 10.0199 15.9473 10.7283C15.9473 11.0512 15.8717 11.3793 15.7207 11.7126C15.5697 12.046 15.3457 12.3507 15.0488 12.6267C14.752 12.8975 14.3822 13.1189 13.9395 13.2908C13.4967 13.4574 12.9837 13.5408 12.4004 13.5408H10.9863V12.4939ZM10.9863 13.9626V12.9314H12.4004C13.0671 12.9314 13.6348 13.0095 14.1035 13.1658C14.5775 13.322 14.9629 13.5382 15.2598 13.8142C15.5566 14.085 15.7728 14.3949 15.9082 14.7439C16.0488 15.0929 16.1191 15.4626 16.1191 15.8533C16.1191 16.3845 16.0228 16.8585 15.8301 17.2751C15.6426 17.6866 15.3743 18.0356 15.0254 18.322C14.6764 18.6085 14.2676 18.8246 13.7988 18.9705C13.3353 19.1163 12.8301 19.1892 12.2832 19.1892C11.7936 19.1892 11.3249 19.1215 10.877 18.9861C10.429 18.8507 10.028 18.6501 9.67383 18.3845C9.31966 18.1137 9.03841 17.7778 8.83008 17.3767C8.62695 16.9705 8.52539 16.5017 8.52539 15.9705H10.4082C10.4082 16.309 10.4863 16.6085 10.6426 16.8689C10.804 17.1241 11.028 17.3246 11.3145 17.4705C11.6061 17.6163 11.9395 17.6892 12.3145 17.6892C12.7103 17.6892 13.0514 17.6189 13.3379 17.4783C13.6243 17.3376 13.8431 17.1293 13.9941 16.8533C14.1504 16.5772 14.2285 16.2439 14.2285 15.8533C14.2285 15.4106 14.1426 15.0512 13.9707 14.7751C13.7988 14.4991 13.554 14.296 13.2363 14.1658C12.9186 14.0304 12.5436 13.9626 12.1113 13.9626H10.9863Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_3736_40162",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0 0.571045)"
                    })
                })
            })
        ]
    }));
}
var $57438ef1fa5a2b4d$export$2e2bcd8739ae039 = $57438ef1fa5a2b4d$var$SvgNotificationNumber;




var $exYeM = parcelRequire("exYeM");

function $ff8602060d83f868$var$SvgNotifications(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.4545 1.2332C8.86576 1.2332 5.95649 4.14247 5.95649 7.73123C5.95649 9.57778 5.01813 11.5559 3.97809 12.9457C3.43315 13.6739 3.11064 14.577 3.11064 15.5573C3.11064 17.9673 5.06431 19.9209 7.47428 19.9209H17.4348C19.8447 19.9209 21.7984 17.9673 21.7984 15.5573C21.7984 14.577 21.4759 13.6739 20.931 12.9457C19.8909 11.556 18.9525 9.57778 18.9525 7.73123C18.9525 4.14247 16.0433 1.2332 12.4545 1.2332ZM15.8622 21.1542H17.4348C20.5258 21.1542 23.0316 18.6484 23.0316 15.5573C23.0316 14.3016 22.6173 13.1409 21.9183 12.2068C20.9651 10.9332 20.1858 9.21129 20.1858 7.73123C20.1858 3.46139 16.7244 0 12.4545 0C8.18468 0 4.72329 3.46139 4.72329 7.73123C4.72329 9.21129 3.94391 10.9332 2.99076 12.2068C2.2917 13.1409 1.87744 14.3016 1.87744 15.5573C1.87744 18.6484 4.38323 21.1542 7.47428 21.1542H9.04681C9.33766 22.7722 10.7527 24 12.4545 24C14.1563 24 15.5714 22.7722 15.8622 21.1542ZM14.5974 21.1542H10.3116C10.5791 22.0854 11.4372 22.7668 12.4545 22.7668C13.4718 22.7668 14.3299 22.0854 14.5974 21.1542Z",
            fill: "currentColor"
        })
    }));
}
var $ff8602060d83f868$export$2e2bcd8739ae039 = $ff8602060d83f868$var$SvgNotifications;




var $exYeM = parcelRequire("exYeM");

function $e1a9317fa9c0dcf9$var$SvgNumber(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Number",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector",
                d: "M12.379 2.00335C12.315 2.01277 12.2532 2.03276 12.1962 2.06255L0.767986 7.73863C0.581526 7.83102 0.464088 8.01691 0.464088 8.21997C0.464088 8.42303 0.581526 8.60912 0.767986 8.70151L12.1962 14.3776C12.3549 14.4556 12.5427 14.4556 12.7013 14.3776L24.1296 8.70151C24.316 8.60912 24.4335 8.42303 24.4335 8.21997C24.4335 8.01692 24.316 7.83102 24.1296 7.73863L12.7013 2.06255C12.6024 2.01202 12.4902 1.99128 12.379 2.00335ZM12.4486 3.15213L22.6574 8.22006L12.4486 13.288L2.23983 8.22006L12.4486 3.15213ZM0.994475 11.7251C0.73627 11.7331 0.517924 11.9118 0.466014 12.1571C0.4141 12.4024 0.542817 12.6499 0.776911 12.7557L12.2051 18.1615C12.3591 18.2341 12.5388 18.2341 12.6928 18.1615L24.121 12.7557C24.2598 12.6965 24.3679 12.585 24.4202 12.447C24.4727 12.309 24.4648 12.1561 24.3983 12.024C24.3318 11.8916 24.2128 11.7913 24.0683 11.746C23.9241 11.7008 23.7668 11.7148 23.6332 11.7843L12.4488 17.0719L1.26451 11.7843C1.1809 11.7428 1.08819 11.7225 0.994475 11.7251ZM0.994475 15.5091C0.73627 15.517 0.517924 15.6957 0.466014 15.941C0.414104 16.1863 0.542817 16.4341 0.776911 16.5396L12.2051 21.9454C12.3591 22.0182 12.5388 22.0182 12.6928 21.9454L24.121 16.5396C24.2598 16.4806 24.3679 16.3692 24.4202 16.231C24.4727 16.093 24.4648 15.9403 24.3983 15.8079C24.3318 15.6756 24.2128 15.5753 24.0683 15.5302C23.9241 15.4849 23.7668 15.4987 23.6332 15.5683L12.4488 20.8558L1.26451 15.5683C1.1809 15.527 1.08819 15.5065 0.994475 15.5091Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.15
            })
        })
    }));
}
var $e1a9317fa9c0dcf9$export$2e2bcd8739ae039 = $e1a9317fa9c0dcf9$var$SvgNumber;




var $exYeM = parcelRequire("exYeM");

function $67c94a0ce4a56966$var$SvgOtherCategory(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 28 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 14,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M17.464 9.86197L16.3084 11.0827C16.2833 11.1092 16.2529 11.1303 16.2191 11.1448C16.1853 11.1592 16.1489 11.1667 16.1121 11.1667H10.6342C10.608 11.1667 10.5824 11.1591 10.5606 11.145C10.5387 11.1309 10.5215 11.1108 10.5111 11.0872C10.5007 11.0636 10.4975 11.0375 10.5019 11.0121C10.5064 10.9867 10.5182 10.9632 10.5361 10.9444L11.6925 9.72366C11.7176 9.69722 11.7478 9.67612 11.7815 9.66167C11.8152 9.64722 11.8515 9.63974 11.8882 9.63968H17.3658C17.392 9.63968 17.4175 9.6472 17.4394 9.66132C17.4613 9.67544 17.4784 9.69554 17.4889 9.71915C17.4993 9.74276 17.5025 9.76885 17.4981 9.79423C17.4936 9.8196 17.4818 9.84315 17.464 9.86197ZM16.3084 7.40382C16.2833 7.3773 16.2529 7.35616 16.2191 7.34171C16.1853 7.32727 16.1489 7.31982 16.1121 7.31984H10.6342C10.608 7.31984 10.5824 7.32736 10.5606 7.34148C10.5387 7.3556 10.5215 7.3757 10.5111 7.39931C10.5007 7.42292 10.4975 7.44902 10.5019 7.47439C10.5064 7.49976 10.5182 7.52331 10.5361 7.54214L11.6925 8.76284C11.7176 8.78929 11.7478 8.81038 11.7815 8.82483C11.8152 8.83927 11.8515 8.84676 11.8882 8.84682H17.3658C17.392 8.84682 17.4175 8.8393 17.4394 8.82518C17.4613 8.81106 17.4784 8.79096 17.4889 8.76735C17.4993 8.74374 17.5025 8.71764 17.4981 8.69227C17.4936 8.6669 17.4818 8.64335 17.464 8.62453L16.3084 7.40382ZM10.6342 6.52698H16.1121C16.1489 6.527 16.1853 6.51956 16.2191 6.50511C16.2529 6.49066 16.2833 6.46952 16.3084 6.443L17.464 5.22229C17.4818 5.20347 17.4936 5.17992 17.4981 5.15455C17.5025 5.12918 17.4993 5.10308 17.4889 5.07947C17.4784 5.05586 17.4613 5.03576 17.4394 5.02164C17.4175 5.00752 17.392 5 17.3658 5H11.8882C11.8515 5.00006 11.8152 5.00755 11.7815 5.02199C11.7478 5.03644 11.7176 5.05754 11.6925 5.08398L10.5364 6.30469C10.5186 6.32349 10.5067 6.34702 10.5023 6.37236C10.4978 6.3977 10.501 6.42378 10.5114 6.44738C10.5217 6.47098 10.5389 6.49108 10.5607 6.50522C10.5825 6.51936 10.608 6.52692 10.6342 6.52698Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 7,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                clipPath: "url(#clip0_9706_69204)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.76322 18.3239L3.94253 17.7704C3.97931 17.6573 4.06758 17.5699 4.18069 17.5359L4.73701 17.3649C4.81425 17.341 4.81425 17.2324 4.73793 17.2076L4.18345 17.0283C4.07126 16.9915 3.98299 16.9033 3.94896 16.7901L3.77793 16.2338C3.75402 16.1566 3.64551 16.1566 3.62069 16.2329L3.44138 16.7865C3.40459 16.8987 3.31632 16.9869 3.20322 17.021L2.64689 17.192C2.56965 17.2159 2.56873 17.3244 2.64597 17.3492L3.20046 17.5285C3.31264 17.5653 3.40092 17.6545 3.43494 17.7676L3.60597 18.3239C3.62988 18.4012 3.73839 18.4021 3.76322 18.3249V18.3239Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.5632 18.0042C12.3342 17.7477 11.9756 17.6033 11.6271 17.5435C11.2758 17.4865 10.908 17.492 10.5613 17.5536C9.86063 17.6723 9.22339 17.9628 8.66799 18.3205C8.37925 18.4962 8.13374 18.6994 7.8781 18.9072C7.75489 19.012 7.64362 19.1233 7.52684 19.2336L7.20776 19.5509C6.86109 19.9132 6.51994 20.2424 6.18983 20.5155C5.85787 20.7877 5.54799 20.9936 5.2427 21.138C4.93741 21.2833 4.61098 21.3679 4.18523 21.3817C3.76316 21.3964 3.26385 21.3201 2.7296 21.195C2.19259 21.07 1.62891 20.8916 0.999023 20.738C1.21879 21.3477 1.54983 21.8865 1.97466 22.3794C2.405 22.8631 2.94201 23.3044 3.63167 23.595C4.31121 23.892 5.16546 23.9978 5.96454 23.8378C6.76546 23.6833 7.46799 23.3127 8.03626 22.8842C8.60546 22.4511 9.06707 21.9582 9.45511 21.4451C9.5627 21.3035 9.61879 21.2244 9.69695 21.1132L9.91121 20.795C10.0602 20.5982 10.1963 20.3748 10.3434 20.1798C10.633 19.7716 10.9181 19.3642 11.2491 18.989C11.4156 18.7987 11.5921 18.6166 11.7999 18.4419C11.9038 18.3564 12.0151 18.2727 12.1393 18.1973C12.2652 18.1164 12.3976 18.0529 12.5613 18.0033L12.5632 18.0042Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.5632 18.0028C12.3168 17.3803 11.8579 16.8571 11.2428 16.4708C10.6313 16.0883 9.78161 15.8934 8.94023 16.0598C8.5246 16.1398 8.12184 16.2952 7.76782 16.5012C7.41563 16.7062 7.10023 16.9536 6.82805 17.2194C6.69195 17.3527 6.56782 17.4915 6.44552 17.6304L6.12736 18.0368L5.6354 18.6906C5.00828 19.532 4.33333 20.5177 3.22437 20.8092C2.13655 21.0961 1.66483 20.8423 1 20.7375C1.12138 21.0511 1.27218 21.3554 1.4754 21.623C1.67586 21.8961 1.91218 22.1527 2.20552 22.3725C2.35356 22.4782 2.5108 22.5821 2.6846 22.6713C2.85747 22.7568 3.04506 22.8322 3.2446 22.8883C3.64184 22.9968 4.08874 23.0354 4.52092 22.9766C4.95402 22.9187 5.36782 22.7817 5.7292 22.5996C6.09333 22.4194 6.41057 22.1996 6.69379 21.9679C7.25747 21.4998 7.69517 20.983 8.06483 20.4607C8.25058 20.1996 8.41977 19.9338 8.57609 19.6672L8.76 19.3499C8.81609 19.2571 8.8731 19.1642 8.93103 19.0768C9.16368 18.7283 9.39172 18.4488 9.66851 18.2382C9.94161 18.023 10.3214 17.8639 10.8299 17.8272C11.3356 17.7895 11.9195 17.8584 12.5614 18.0028H12.5632Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.82568 23.1713C9.82568 23.6283 10.1963 23.9989 10.6533 23.9989C11.1103 23.9989 11.4809 23.6283 11.4809 23.1713C11.4809 22.7143 11.1103 22.3438 10.6533 22.3438C10.1963 22.3438 9.82568 22.7143 9.82568 23.1713Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 21,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip1_9706_69204)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M24.5312 18.5094C24.1796 18.1848 23.6933 17.6891 23.2972 17.3376L23.2738 17.3212C23.2348 17.2899 23.1908 17.2653 23.1437 17.2485C22.1886 17.0704 17.7437 16.2396 17.657 16.2501C17.6327 16.2535 17.6095 16.2623 17.5891 16.2759L17.5668 16.2935C17.5394 16.3213 17.5186 16.3549 17.5059 16.3919L17.5 16.4071V16.4903V16.5032C18.0004 17.8966 19.9761 22.461 20.3652 23.532C20.3886 23.6047 20.4332 23.743 20.5164 23.75H20.5351C20.5796 23.75 20.7695 23.4992 20.7695 23.4992C20.7695 23.4992 24.1632 19.3837 24.5065 18.9454C24.551 18.8914 24.5902 18.8333 24.6237 18.7719C24.6323 18.7239 24.6283 18.6745 24.612 18.6285C24.5958 18.5825 24.5679 18.5415 24.5312 18.5094ZM21.6402 18.9887L23.0886 17.7876L23.9382 18.5704L21.6402 18.9887ZM21.0777 18.9102L18.584 16.8665L22.6187 17.6106L21.0777 18.9102ZM21.3027 19.4458L23.855 19.0344L20.9371 22.55L21.3027 19.4458ZM18.2453 17.0704L20.8691 19.2969L20.4894 22.5524L18.2453 17.0704Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip0_9706_69204",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 11.5632,
                            height: 8,
                            fill: "white",
                            transform: "translate(1 16)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip1_9706_69204",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 8,
                            height: 8,
                            fill: "white",
                            transform: "translate(17 16)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $67c94a0ce4a56966$export$2e2bcd8739ae039 = $67c94a0ce4a56966$var$SvgOtherCategory;




var $exYeM = parcelRequire("exYeM");

function $dc10cd7dea101db2$var$SvgPaste(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_16926_238235)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M13.5 7H9.5C8.673 7 8 7.673 8 8.5V13H2.5C2.36739 13 2.24021 12.9473 2.14645 12.8536C2.05268 12.7598 2 12.6326 2 12.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H4V2.5C4 2.63261 4.05268 2.75979 4.14645 2.85355C4.24021 2.94732 4.36739 3 4.5 3H8.5C8.63261 3 8.75979 2.94732 8.85355 2.85355C8.94732 2.75979 9 2.63261 9 2.5V2H10.5C10.6326 2 10.7598 2.05268 10.8536 2.14645C10.9473 2.24021 11 2.36739 11 2.5V5.5C11 5.63261 11.0527 5.75979 11.1464 5.85355C11.2402 5.94732 11.3674 6 11.5 6C11.6326 6 11.7598 5.94732 11.8536 5.85355C11.9473 5.75979 12 5.63261 12 5.5V2.5C12 1.673 11.327 1 10.5 1H9V0.5C9 0.367392 8.94732 0.240215 8.85355 0.146447C8.75979 0.0526784 8.63261 0 8.5 0L4.5 0C4.36739 0 4.24021 0.0526784 4.14645 0.146447C4.05268 0.240215 4 0.367392 4 0.5V1H2.5C1.673 1 1 1.673 1 2.5V12.5C1 13.327 1.673 14 2.5 14H8V14.5C8 15.327 8.673 16 9.5 16H13.5C14.327 16 15 15.327 15 14.5V8.5C15 7.673 14.327 7 13.5 7ZM5 1H8V2H5V1ZM14 14.5C14 14.6326 13.9473 14.7598 13.8536 14.8536C13.7598 14.9473 13.6326 15 13.5 15H9.5C9.36739 15 9.24021 14.9473 9.14645 14.8536C9.05268 14.7598 9 14.6326 9 14.5V8.5C9 8.36739 9.05268 8.24021 9.14645 8.14645C9.24021 8.05268 9.36739 8 9.5 8H13.5C13.6326 8 13.7598 8.05268 13.8536 8.14645C13.9473 8.24021 14 8.36739 14 8.5V14.5ZM13 13.5C13 13.6326 12.9473 13.7598 12.8536 13.8536C12.7598 13.9473 12.6326 14 12.5 14H10.5C10.3674 14 10.2402 13.9473 10.1464 13.8536C10.0527 13.7598 10 13.6326 10 13.5C10 13.3674 10.0527 13.2402 10.1464 13.1464C10.2402 13.0527 10.3674 13 10.5 13H12.5C12.6326 13 12.7598 13.0527 12.8536 13.1464C12.9473 13.2402 13 13.3674 13 13.5ZM13 11.5C13 11.6326 12.9473 11.7598 12.8536 11.8536C12.7598 11.9473 12.6326 12 12.5 12H10.5C10.3674 12 10.2402 11.9473 10.1464 11.8536C10.0527 11.7598 10 11.6326 10 11.5C10 11.3674 10.0527 11.2402 10.1464 11.1464C10.2402 11.0527 10.3674 11 10.5 11H12.5C12.6326 11 12.7598 11.0527 12.8536 11.1464C12.9473 11.2402 13 11.3674 13 11.5ZM13 9.5C13 9.63261 12.9473 9.75979 12.8536 9.85355C12.7598 9.94732 12.6326 10 12.5 10H10.5C10.3674 10 10.2402 9.94732 10.1464 9.85355C10.0527 9.75979 10 9.63261 10 9.5C10 9.36739 10.0527 9.24021 10.1464 9.14645C10.2402 9.05268 10.3674 9 10.5 9H12.5C12.6326 9 12.7598 9.05268 12.8536 9.14645C12.9473 9.24021 13 9.36739 13 9.5Z",
                    fill: "#727272"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_16926_238235",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 16,
                        height: 16,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $dc10cd7dea101db2$export$2e2bcd8739ae039 = $dc10cd7dea101db2$var$SvgPaste;




var $exYeM = parcelRequire("exYeM");

function $c58775af0b3abd7f$var$SvgPin(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40152)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M6.49636 23.6636C6.70432 23.7702 6.95035 23.7839 7.17959 23.7013C7.40926 23.6186 7.60362 23.4466 7.72026 23.2228L10.7963 17.3204L16.2882 20.1373C16.4962 20.244 16.742 20.2574 16.9716 20.1747C17.2013 20.092 17.3957 19.92 17.5121 19.6965L18.3911 18.0099C18.8976 17.038 19.0763 15.9358 18.8968 14.8896C18.7174 13.8431 18.1908 12.9174 17.406 12.2686L20.0866 7.12496L21.6556 7.92969C22.089 8.152 22.6371 7.95458 22.8797 7.48905C23.1225 7.02321 22.9678 6.46571 22.5344 6.2434L11.5507 0.609804C11.1173 0.387496 10.5693 0.584614 10.3265 1.05044C10.0839 1.51599 10.2385 2.07378 10.6719 2.29609L12.2408 3.10082L9.51628 8.32884C8.48642 8.12375 7.39804 8.28256 6.41978 8.78044C5.44136 9.27851 4.62745 10.0877 4.10411 11.0827L3.3899 12.4531C3.27342 12.6766 3.24433 12.9334 3.30908 13.1671C3.37383 13.4009 3.52702 13.592 3.73499 13.6987L9.22697 16.5155L6.15098 22.4179C6.03434 22.6417 6.00525 22.8985 6.07 23.1322C6.13464 23.3655 6.28839 23.5569 6.49636 23.6636ZM18.5178 6.32006L15.8812 11.3793L11.1737 8.96478L13.8103 3.90555L18.5178 6.32006ZM5.67369 11.8877C6.06765 11.1337 6.72388 10.5539 7.49828 10.275C8.27267 9.99607 9.10196 10.0409 9.80432 10.4L15.7867 13.4684C16.4108 13.7885 16.8706 14.362 17.0648 15.0628C17.259 15.7635 17.1715 16.5342 16.8219 17.205L16.3825 18.0481L5.39882 12.4145L5.67369 11.8877Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_3736_40152",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.227539)"
                    })
                })
            })
        ]
    }));
}
var $c58775af0b3abd7f$export$2e2bcd8739ae039 = $c58775af0b3abd7f$var$SvgPin;




var $exYeM = parcelRequire("exYeM");

function $9edb259e66945005$var$SvgProfile(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0636 2.6C10.1507 2.6 8.60005 4.1507 8.60005 6.06359C8.60005 7.97648 10.1507 9.52717 12.0636 9.52717C13.9765 9.52717 15.5272 7.97648 15.5272 6.06359C15.5272 4.1507 13.9765 2.6 12.0636 2.6ZM7.40005 6.06359C7.40005 3.48796 9.48801 1.4 12.0636 1.4C14.6393 1.4 16.7272 3.48796 16.7272 6.06359C16.7272 8.63922 14.6393 10.7272 12.0636 10.7272C9.48801 10.7272 7.40005 8.63922 7.40005 6.06359ZM6.85651 14.7727C9.97465 12.9424 13.9255 12.9424 17.0436 14.7727C17.1482 14.8341 17.2767 14.9056 17.4217 14.9862C18.0519 15.3368 18.9933 15.8605 19.6389 16.4834C20.042 16.8724 20.4204 17.3807 20.4891 18.0006C20.5621 18.6589 20.2716 19.2787 19.6813 19.8331C18.6512 20.8005 17.4252 21.5661 15.8448 21.5661H8.05532C6.47498 21.5661 5.24887 20.8005 4.21882 19.8331C3.62849 19.2787 3.33796 18.6589 3.41096 18.0006C3.4797 17.3807 3.85806 16.8724 4.26126 16.4834C4.90678 15.8605 5.84812 15.3369 6.47838 14.9863C6.62334 14.9056 6.75185 14.8341 6.85651 14.7727ZM16.4361 15.8076C13.6931 14.1975 10.2071 14.1975 7.46396 15.8076C7.31802 15.8932 7.15724 15.9831 6.9882 16.0777C6.35806 16.43 5.61319 16.8465 5.09449 17.347C4.77177 17.6583 4.62705 17.9218 4.60365 18.1328C4.58451 18.3054 4.63279 18.5757 5.04031 18.9584L4.62957 19.3957L5.04032 18.9584C5.96005 19.8222 6.90548 20.3661 8.05532 20.3661H15.8448C16.9946 20.3661 17.94 19.8222 18.8598 18.9584C19.2673 18.5757 19.3156 18.3054 19.2965 18.1328C19.2731 17.9218 19.1283 17.6583 18.8056 17.3469C18.2869 16.8464 17.542 16.43 16.9118 16.0776C16.7428 15.9831 16.5821 15.8932 16.4362 15.8076L16.4361 15.8076Z",
            fill: "currentColor"
        })
    }));
}
var $9edb259e66945005$export$2e2bcd8739ae039 = $9edb259e66945005$var$SvgProfile;




var $exYeM = parcelRequire("exYeM");

function $abc70174b8494ed5$var$SvgRangoExplorer(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.2815 8.25591L19.6283 7.73436C20.2352 8.89455 20.5936 10.2051 20.6294 11.5964C20.634 11.7859 20.6325 11.9742 20.6249 12.1613C19.5312 10.5143 17.6595 9.42856 15.5343 9.42856C15.4286 9.42856 15.3235 9.43125 15.219 9.43656C16.4138 8.96941 17.7426 8.45317 18.2815 8.25591ZM13.3962 9.81336L12.2685 9.23878L11.5409 9.5425L12.6547 10.1488C12.8929 10.0212 13.1405 9.90896 13.3962 9.81336ZM11.3239 11.1122C10.7771 10.8212 10.2844 10.5585 9.94529 10.3774C9.45802 10.1171 9.1042 9.64569 9.03773 9.09755C8.98763 8.68747 9.09091 8.21551 9.58329 7.80236C9.84865 7.55744 10.1319 7.4158 10.1738 7.39586L10.1841 7.39126L15.6785 5.13683C15.6785 5.13683 15.7132 5.12302 15.7639 5.09694L16.9076 4.62192C15.4688 3.60183 13.7125 3 11.8151 3C6.93834 3 2.91085 7.10492 3.00084 11.9814C3.02845 13.4873 3.43544 14.8996 4.12723 16.1298L6.25525 15.2023L9.68954 13.7611C9.75651 13.5402 9.83567 13.3245 9.92623 13.1149C9.91673 13.1097 9.90725 13.1045 9.89779 13.0993C9.41097 12.8318 8.99628 12.604 8.76572 12.481C8.68653 12.4387 8.59757 12.3845 8.50852 12.3301L8.50848 12.3301L8.50848 12.3301C8.41757 12.2746 8.32657 12.2191 8.24573 12.1762C7.38777 11.7227 6.82535 10.4423 8.12762 8.92267C8.12762 8.92267 7.99264 10.3646 8.79896 10.8545C9.12623 11.0535 9.85537 11.445 10.653 11.8655C10.8557 11.5962 11.0803 11.3442 11.3239 11.1122ZM9.43422 15.255C9.43003 15.3478 9.42792 15.4411 9.42792 15.5349C9.42792 15.8823 9.45692 16.2228 9.51263 16.5543L5.8932 18.0636L5.69686 18.1617C5.38803 17.8642 5.10119 17.5441 4.83839 17.2045L6.26798 16.6002L9.43422 15.255ZM9.85338 17.7788C10.3154 18.9477 11.1278 19.9398 12.1611 20.6259C12.0627 20.6297 11.9639 20.632 11.8647 20.6325C9.98159 20.6427 8.23602 20.0614 6.79927 19.0648L7.93435 18.5663L9.85338 17.7788ZM10.612 9.02247C10.612 9.02247 10.9816 9.22751 11.5425 9.53788L18.852 6.50573C18.5882 6.15649 18.2988 5.82822 17.9869 5.52245C17.9353 5.55159 17.8923 5.56796 17.8923 5.56796L10.9441 8.48962C10.8683 8.46801 9.83602 8.15546 10.3829 7.31633C10.3829 7.31633 9.18744 8.16225 10.2683 8.77377L10.2679 8.77396C10.3537 8.86242 10.4662 8.94628 10.612 9.02247Z",
                fill: "url(#paint0_linear_16912_208495)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M20.2351 15.5998C20.2351 18.1601 18.1596 20.2355 15.5994 20.2355C13.0392 20.2355 10.9637 18.1601 10.9637 15.5998C10.9637 13.0396 13.0392 10.9641 15.5994 10.9641C18.1596 10.9641 20.2351 13.0396 20.2351 15.5998ZM20.6394 20.7498C20.6096 20.7498 20.5817 20.7377 20.5642 20.7202L19.6076 19.7636C19.5686 19.7246 19.5637 19.6554 19.6091 19.6065C19.6486 19.5688 19.7169 19.5647 19.7652 19.61L20.7198 20.5646C20.7579 20.6028 20.7634 20.6698 20.7212 20.7184C20.6955 20.74 20.6657 20.7498 20.6394 20.7498Z",
                stroke: "#727272",
                strokeWidth: 0.5,
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("linearGradient", {
                    id: "paint0_linear_16912_208495",
                    x1: 2.99864,
                    y1: 11.8168,
                    x2: 20.6305,
                    y2: 11.8168,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                            offset: 0.0754,
                            stopColor: "#469BF5"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                            offset: 0.7046,
                            stopColor: "#2857F2"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#1C3CF1"
                        })
                    ]
                })
            })
        ]
    }));
}
var $abc70174b8494ed5$export$2e2bcd8739ae039 = $abc70174b8494ed5$var$SvgRangoExplorer;




var $exYeM = parcelRequire("exYeM");

function $7dc26a4a8677d48b$var$SvgRank(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.5543 8.80555C16.7998 9.05054 16.8002 9.44816 16.5552 9.69366L11.0688 15.1914C10.9509 15.3095 10.7909 15.3759 10.624 15.3758C10.4571 15.3757 10.2971 15.3092 10.1793 15.1909L7.4418 12.4421C7.19707 12.1963 7.19789 11.7987 7.44364 11.554C7.6894 11.3092 8.08702 11.31 8.33175 11.5558L10.6248 13.8583L15.6662 8.80646C15.9112 8.56096 16.3088 8.56055 16.5543 8.80555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.034 1.62891C12.4707 1.1563 11.533 1.16075 10.9866 1.62794L9.19324 3.16028C8.94868 3.37167 8.62911 3.53755 8.32526 3.65046C8.02072 3.76362 7.67165 3.84597 7.35257 3.84597H5.38746C4.53024 3.84597 3.82317 4.55304 3.82317 5.41027V7.36401C3.82317 7.68352 3.7406 8.02973 3.62935 8.33029C3.51777 8.63171 3.35598 8.94486 3.1551 9.18592L3.1514 9.19036L1.61992 10.994C1.15868 11.544 1.15776 12.4746 1.619 13.0245L3.15512 14.8338C3.356 15.0748 3.51777 15.388 3.62935 15.6894C3.7406 15.99 3.82317 16.3362 3.82317 16.6557V18.5981C3.82317 19.4553 4.53024 20.1624 5.38746 20.1624H7.35257C7.67649 20.1624 8.02553 20.2443 8.33057 20.3583C8.63529 20.4721 8.95127 20.6385 9.1944 20.849L10.9856 22.3908C11.5485 22.8631 12.4855 22.8589 13.032 22.3925L14.8244 20.8496C15.0691 20.6378 15.3899 20.4709 15.6942 20.3579C15.9988 20.2447 16.3479 20.1624 16.6669 20.1624H18.598C19.4552 20.1624 20.1623 19.4553 20.1623 18.5981V16.667C20.1623 16.3431 20.2442 15.9941 20.3582 15.689C20.472 15.3843 20.6385 15.0683 20.849 14.8252L22.3907 13.034C22.863 12.4711 22.8588 11.5341 22.3924 10.9876L20.8496 9.19518C20.6377 8.95047 20.4709 8.62968 20.3578 8.32535C20.2446 8.02081 20.1623 7.67174 20.1623 7.35265V5.42163C20.1623 4.5644 19.4552 3.85733 18.598 3.85733H16.6669C16.343 3.85733 15.994 3.7754 15.6889 3.66143C15.3843 3.5476 15.0684 3.38121 14.8253 3.17077L13.034 1.62891ZM10.1706 0.6732C11.191 -0.199189 12.8185 -0.195314 13.8457 0.670466L13.8507 0.674665L15.647 2.2209C15.7445 2.30545 15.9167 2.40574 16.1285 2.48488C16.3403 2.56402 16.5365 2.60135 16.6669 2.60135H18.598C20.1488 2.60135 21.4182 3.87074 21.4182 5.42163V7.35265C21.4182 7.47657 21.4552 7.67273 21.5351 7.88787C21.615 8.10292 21.7155 8.27663 21.7987 8.3726L21.8001 8.3742L23.3462 10.1705C24.2188 11.1909 24.215 12.8185 23.3491 13.8458L23.3449 13.8508L21.8001 15.6455L21.7987 15.6471C21.7141 15.7446 21.6139 15.9168 21.5347 16.1286C21.4556 16.3404 21.4182 16.5366 21.4182 16.667V18.5981C21.4182 20.1489 20.1488 21.4183 18.598 21.4183H16.6669C16.543 21.4183 16.3469 21.4553 16.1317 21.5352C15.9167 21.6151 15.743 21.7156 15.647 21.7988L15.6454 21.8002L13.8507 23.345L13.8491 23.3463C12.8287 24.2189 11.2011 24.215 10.1738 23.3492L10.1688 23.345L8.37412 21.8002L8.37251 21.7988C8.27496 21.7142 8.10282 21.6139 7.89099 21.5348C7.67919 21.4557 7.48301 21.4183 7.35257 21.4183H5.38746C3.83658 21.4183 2.56719 20.1489 2.56719 18.5981V16.6557C2.56719 16.5322 2.53048 16.3388 2.45147 16.1254C2.37327 15.9141 2.27454 15.7397 2.19176 15.6397L0.658475 13.8338C-0.196709 12.8164 -0.196703 11.2033 0.658481 10.1859L0.66048 10.1835L2.19176 8.38001C2.27455 8.27999 2.37327 8.10555 2.45147 7.89428C2.53048 7.68085 2.56719 7.48751 2.56719 7.36401V5.41027C2.56719 3.85938 3.83658 2.58999 5.38746 2.58999H7.35257C7.47648 2.58999 7.67265 2.55307 7.88778 2.47313C8.10283 2.39322 8.27654 2.29272 8.37251 2.20954L8.37585 2.20665L10.1706 0.6732Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $7dc26a4a8677d48b$export$2e2bcd8739ae039 = $7dc26a4a8677d48b$var$SvgRank;




var $exYeM = parcelRequire("exYeM");

function $ccf9750f04b1d14c$var$SvgRefresh(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M6.29926 18.2997C2.82191 15.1563 2.5569 9.7767 5.6942 6.30604C8.8315 2.83538 14.2165 2.55094 17.6939 5.69429C18.4094 6.34109 19.0142 7.07007 19.4955 7.88186C19.6905 8.2039 19.5837 8.61775 19.2617 8.8127C18.9396 9.00765 18.5258 8.90088 18.3308 8.57884C17.9196 7.89116 17.4024 7.2535 16.7871 6.69737C13.8648 4.05575 9.34494 4.28377 6.70333 7.20608C4.06171 10.1284 4.28973 14.6483 7.21204 17.2899C10.1343 19.9315 14.6542 19.7035 17.2959 16.7812C18.251 15.7246 18.8622 14.4301 19.0662 13.0348C19.1179 12.6684 19.4622 12.4086 19.8353 12.4663C20.2017 12.518 20.4616 12.8623 20.4038 13.2354C20.1624 14.9006 19.436 16.4435 18.2996 17.7007C15.1556 21.1653 9.77661 21.443 6.29926 18.2997Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $ccf9750f04b1d14c$export$2e2bcd8739ae039 = $ccf9750f04b1d14c$var$SvgRefresh;




var $exYeM = parcelRequire("exYeM");

function $2d6c172158725aa9$var$SvgReport(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M13.5783 0H4.98897C4.9378 0 4.8884 0.0211734 4.85135 0.0564623L2.05646 2.85311C2.01941 2.89016 2 2.93957 2 2.99074V13.5192V15.1548C2 15.6206 2.37936 16 2.84517 16H13.5783C14.0441 16 14.4235 15.6206 14.4235 15.1548V0.84517C14.4235 0.379356 14.0441 0 13.5783 0ZM4.79488 0.665196V2.5408C4.79488 2.68196 4.68019 2.79488 4.5408 2.79488H2.6652L4.79488 0.665196ZM14.0335 15.1548C14.0335 15.4054 13.8288 15.6101 13.5783 15.6101H2.84341C2.59285 15.6101 2.38818 15.4054 2.38818 15.1548V13.5192V3.18483H4.53904C4.89369 3.18483 5.18306 2.89546 5.18306 2.5408V0.389943H13.5765C13.8271 0.389943 14.0318 0.594618 14.0318 0.84517V15.1548H14.0335ZM12.9025 9.00044C12.9025 9.10807 12.8143 9.19629 12.7067 9.19629H3.71504C3.60741 9.19629 3.51919 9.10807 3.51919 9.00044C3.51919 8.89281 3.60741 8.80459 3.71504 8.80459H12.7084C12.8143 8.80459 12.9025 8.89281 12.9025 9.00044ZM12.9025 10.3944C12.9025 10.502 12.8143 10.5902 12.7067 10.5902H3.71504C3.60741 10.5902 3.51919 10.502 3.51919 10.3944C3.51919 10.2867 3.60741 10.1985 3.71504 10.1985H12.7084C12.8143 10.1985 12.9025 10.2867 12.9025 10.3944ZM12.9025 11.7865C12.9025 11.8941 12.8143 11.9824 12.7067 11.9824H3.71504C3.60741 11.9824 3.51919 11.8941 3.51919 11.7865C3.51919 11.6789 3.60741 11.5906 3.71504 11.5906H12.7084C12.8143 11.5924 12.9025 11.6789 12.9025 11.7865ZM9.83591 13.1804C9.83591 13.288 9.74768 13.3763 9.64005 13.3763H3.71504C3.60741 13.3763 3.51919 13.288 3.51919 13.1804C3.51919 13.0728 3.60741 12.9846 3.71504 12.9846H9.64182C9.74945 12.9846 9.83591 13.0728 9.83591 13.1804ZM4.3079 7.28011H12.112C12.2197 7.28011 12.3079 7.19188 12.3079 7.08425C12.3079 6.97662 12.2197 6.8884 12.112 6.8884H11.7539V3.03485C11.7539 2.809 11.5704 2.6255 11.3445 2.6255H10.1006C9.87473 2.6255 9.69122 2.809 9.69122 3.03485V3.63652H8.42612C8.20027 3.63652 8.01676 3.82003 8.01676 4.04588V4.64755H6.75166C6.52581 4.64755 6.3423 4.83105 6.3423 5.0569V5.65858H5.0772C4.85135 5.65858 4.66784 5.84208 4.66784 6.06793V6.88487H4.30966C4.20203 6.88487 4.11381 6.97309 4.11381 7.08072C4.11381 7.18836 4.20026 7.28011 4.3079 7.28011ZM10.1006 3.01544H11.3445C11.3551 3.01544 11.3639 3.02426 11.3639 3.03485V6.89016H10.0812V3.03485C10.0812 3.02426 10.09 3.01544 10.1006 3.01544ZM8.42612 4.02647H9.69122V6.8884H8.40671V4.04764C8.40671 4.03705 8.41553 4.02647 8.42612 4.02647ZM6.75166 5.03926H8.01676V6.8884H6.73225V5.06043C6.73048 5.04985 6.74107 5.03926 6.75166 5.03926ZM5.05602 6.07323C5.05602 6.06264 5.06484 6.05382 5.07543 6.05382H6.34054V6.89193H5.05602V6.07323Z",
            fill: "currentColor"
        })
    }));
}
var $2d6c172158725aa9$export$2e2bcd8739ae039 = $2d6c172158725aa9$var$SvgReport;




var $exYeM = parcelRequire("exYeM");

function $c701d82687c1affb$var$SvgRequest(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 17 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.8844 12.8493H15.3478V4.32162C15.3478 3.66683 14.8162 3.13529 14.1615 3.13529H13.4681C13.3654 3.13529 13.2833 3.21746 13.2833 3.32017C13.2833 3.42289 13.3654 3.50505 13.4681 3.50505H14.1615C14.6134 3.50505 14.978 3.87225 14.978 4.32162V12.8493H1.09132V4.32162C1.09132 3.86968 1.45595 3.50505 1.90531 3.50505H2.82202C2.92473 3.50505 3.0069 3.42289 3.0069 3.32017C3.0069 3.21746 2.92473 3.13529 2.82202 3.13529H1.90531C1.25309 3.13529 0.721554 3.66683 0.721554 4.32162V12.8493H0.184882C0.0821698 12.8493 0 12.9315 0 13.0342V14.9806C0 15.5429 0.45707 16 1.01685 16H15.0473C15.6097 16 16.0668 15.5429 16.0668 14.9806V13.0342C16.0668 12.934 15.9846 12.8493 15.8844 12.8493ZM6.73536 13.2191H9.33398V13.7147C9.33398 13.8328 9.2364 13.9303 9.11828 13.9303H6.95105C6.83293 13.9303 6.73536 13.8328 6.73536 13.7147V13.2191ZM15.6996 14.9806C15.6996 15.3401 15.4068 15.6302 15.0499 15.6302H1.01942C0.659926 15.6302 0.369764 15.3375 0.369764 14.9806V13.2191H6.36559V13.7147C6.36559 14.0356 6.62751 14.3001 6.94848 14.3001H9.11571C9.43669 14.3001 9.6986 14.0382 9.6986 13.7147V13.2191H15.6944V14.9806H15.6996Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M4.10079 11.2419H11.966C12.3409 11.2419 12.6464 10.9363 12.6464 10.5614V0.680469C12.6464 0.305569 12.3409 0 11.966 0H6.08313C5.94447 0 5.81095 0.0308137 5.69026 0.0847376H5.68769C5.59011 0.125822 5.50281 0.184882 5.42321 0.259348L3.69764 1.97978C3.61547 2.06195 3.55128 2.15696 3.51019 2.25197C3.51019 2.25453 3.51019 2.25453 3.50762 2.2571C3.50762 2.25967 3.50762 2.26224 3.50506 2.26224C3.44856 2.38549 3.42032 2.51645 3.42032 2.65254V10.5614C3.42032 10.9389 3.72589 11.2419 4.10079 11.2419ZM11.966 0.367196C12.138 0.367196 12.2767 0.508426 12.2767 0.677901V10.5614C12.2767 10.7334 12.138 10.8721 11.966 10.8721H4.10079C3.92874 10.8721 3.79008 10.7334 3.79008 10.5614V2.65254C3.79008 2.60632 3.79779 2.5601 3.80806 2.51388H5.41037C5.70567 2.51388 5.94447 2.27508 5.94447 1.97978V0.385171C5.99069 0.3749 6.03434 0.367196 6.08313 0.367196H11.966ZM5.57728 0.629113V1.98235C5.57728 2.07479 5.50281 2.14925 5.41037 2.14925H4.05457L5.57728 0.629113Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.27716 3.18408H10.8105C10.9953 3.18408 11.1443 3.03515 11.1443 2.85026V1.65623C11.1443 1.47135 10.9953 1.32242 10.8105 1.32242H7.27716C7.09228 1.32242 6.94335 1.47135 6.94335 1.65623V2.85026C6.94335 3.03258 7.09485 3.18408 7.27716 3.18408ZM7.31311 1.69218H10.7771V2.81688H7.31311V1.69218Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 3.94158C5.07142 3.94158 4.98925 4.02375 4.98925 4.12646C4.98925 4.22918 5.07142 4.31135 5.17413 4.31135H11.0647C11.1674 4.31135 11.2496 4.22918 11.2496 4.12646C11.2496 4.02375 11.1674 3.94158 11.0647 3.94158H5.17413Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 5.4797H11.0647C11.1674 5.4797 11.2496 5.39753 11.2496 5.29482C11.2496 5.1921 11.1674 5.10993 11.0647 5.10993H5.17413C5.07142 5.10993 4.98925 5.1921 4.98925 5.29482C4.98925 5.39753 5.07399 5.4797 5.17413 5.4797Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M5.17413 6.65062H11.0647C11.1674 6.65062 11.2496 6.56845 11.2496 6.46574C11.2496 6.36302 11.1674 6.28085 11.0647 6.28085H5.17413C5.07142 6.28085 4.98925 6.36302 4.98925 6.46574C4.99182 6.56845 5.07399 6.65062 5.17413 6.65062Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.07543 7.25662C5.264 7.25662 4.60151 7.91655 4.60151 8.72797C4.60151 9.5394 5.26144 10.1993 6.07543 10.1993C6.88686 10.1993 7.54678 9.5394 7.54678 8.72797C7.54678 7.91655 6.88686 7.25662 6.07543 7.25662ZM6.07543 9.82956C5.46686 9.82956 4.97127 9.33397 4.97127 8.72797C4.97127 8.1194 5.46686 7.62638 6.07543 7.62638C6.684 7.62638 7.17702 8.12197 7.17702 8.72797C7.17702 9.33397 6.684 9.82956 6.07543 9.82956Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M9.99647 7.25662C9.18504 7.25662 8.52255 7.91655 8.52255 8.72797C8.52255 9.5394 9.18248 10.1993 9.99647 10.1993C10.8079 10.1993 11.4678 9.5394 11.4678 8.72797C11.4653 7.91655 10.8053 7.25662 9.99647 7.25662ZM9.99647 9.82956C9.3879 9.82956 8.89231 9.33397 8.89231 8.72797C8.89231 8.1194 9.3879 7.62638 9.99647 7.62638C10.605 7.62638 11.0981 8.12197 11.0981 8.72797C11.0981 9.33397 10.6025 9.82956 9.99647 9.82956Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.28599 8.41984L5.97785 8.61756L5.92393 8.51998C5.87514 8.43267 5.76216 8.39929 5.67228 8.44808C5.58241 8.49687 5.5516 8.60985 5.60039 8.69973L5.74932 8.96678C5.775 9.01043 5.81608 9.04381 5.86487 9.05665C5.88028 9.05922 5.89568 9.06179 5.90852 9.06179C5.94447 9.06179 5.97785 9.05152 6.00867 9.03354L6.48114 8.73054C6.56588 8.67662 6.59156 8.56107 6.53763 8.47633C6.48628 8.38902 6.37329 8.36591 6.28599 8.41984Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.415 8.30685C10.3431 8.23495 10.2276 8.23495 10.1557 8.30685L9.99647 8.46606L9.83727 8.30685C9.76537 8.23495 9.64982 8.23495 9.57792 8.30685C9.50602 8.37875 9.50602 8.4943 9.57792 8.5662L9.73712 8.72541L9.57792 8.88461C9.50602 8.95651 9.50602 9.07206 9.57792 9.14396C9.61387 9.17991 9.66009 9.19788 9.70888 9.19788C9.7551 9.19788 9.80388 9.17991 9.83983 9.14396L9.99904 8.98475L10.1582 9.14396C10.1942 9.17991 10.2404 9.19788 10.2892 9.19788C10.3354 9.19788 10.3842 9.17991 10.4202 9.14396C10.4921 9.07206 10.4921 8.95651 10.4202 8.88461L10.261 8.72541L10.4202 8.5662C10.4869 8.4943 10.4869 8.37875 10.415 8.30685Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $c701d82687c1affb$export$2e2bcd8739ae039 = $c701d82687c1affb$var$SvgRequest;




var $exYeM = parcelRequire("exYeM");

function $f7c293598ac51755$var$SvgReverse(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.50787 23.5806C9.21497 23.8735 8.7401 23.8735 8.44721 23.5806L1.92428 17.0576C1.63139 16.7647 1.63139 16.2899 1.92429 15.997C2.21718 15.7041 2.69206 15.7041 2.98495 15.997L9.50787 22.52C9.80076 22.8129 9.80076 23.2877 9.50787 23.5806Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.97754 23.8003C8.56333 23.8003 8.22754 23.4645 8.22754 23.0503L8.22754 0.949467C8.22754 0.535254 8.56333 0.199467 8.97754 0.199467C9.39175 0.199467 9.72754 0.535254 9.72754 0.949467L9.72754 23.0503C9.72754 23.4645 9.39175 23.8003 8.97754 23.8003Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.9849 8.00567C22.692 8.29857 22.2171 8.29856 21.9243 8.00567L15.4013 1.48268C15.1084 1.18979 15.1084 0.714912 15.4013 0.422021C15.6942 0.129129 16.1691 0.129131 16.462 0.422026L22.9849 6.94501C23.2778 7.23791 23.2778 7.71278 22.9849 8.00567Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9297 23.8003C15.5155 23.8003 15.1797 23.4645 15.1797 23.0503L15.1797 0.949467C15.1797 0.535254 15.5155 0.199467 15.9297 0.199467C16.3439 0.199467 16.6797 0.535254 16.6797 0.949467L16.6797 23.0503C16.6797 23.4645 16.3439 23.8003 15.9297 23.8003Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $f7c293598ac51755$export$2e2bcd8739ae039 = $f7c293598ac51755$var$SvgReverse;




var $exYeM = parcelRequire("exYeM");

function $0156f9680cfc260b$var$SvgRoute(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3027 2.55688V3.25637C16.3027 2.55688 16.3023 2.55688 16.3027 2.55688L16.3042 2.55689L16.306 2.55689L16.3107 2.55692L16.324 2.55708C16.3346 2.55724 16.3488 2.55754 16.3662 2.5581C16.401 2.5592 16.4489 2.56132 16.5082 2.56536C16.6266 2.57341 16.7916 2.58921 16.9887 2.62027C17.38 2.68194 17.9132 2.80617 18.4638 3.06C19.5932 3.58064 20.783 4.65118 20.9505 6.71055L20.9528 6.73886V12.5915H19.5539V6.79672C19.4282 5.36387 18.6478 4.68531 17.8781 4.33047C17.4767 4.14544 17.0757 4.05024 16.7709 4.00219C16.6199 3.9784 16.4964 3.96676 16.4132 3.96111C16.3785 3.95874 16.351 3.95744 16.3318 3.95672C14.6677 4.14012 13.8892 4.90998 13.4993 5.57985C13.2937 5.93303 13.1854 6.27902 13.129 6.53714C13.101 6.66531 13.0865 6.76899 13.079 6.8371C13.0753 6.87107 13.0734 6.89588 13.0725 6.91014L13.0721 6.91739V17.264L13.0698 17.2923C12.9025 19.3524 11.72 20.4232 10.5939 20.9434C10.0454 21.1968 9.51429 21.3202 9.12455 21.3811C8.92825 21.4118 8.76389 21.4273 8.64589 21.4351C8.58678 21.439 8.539 21.441 8.50431 21.442C8.48696 21.4426 8.47285 21.4428 8.46222 21.443L8.44888 21.4431L8.4442 21.4431L8.44237 21.4431C6.08877 21.4473 4.79606 20.4508 4.1344 19.3543C3.81715 18.8286 3.6613 18.3082 3.58386 17.9228C3.54488 17.7289 3.52497 17.5653 3.51477 17.4468C3.50965 17.3874 3.50694 17.3389 3.50551 17.3032C3.50479 17.2854 3.50439 17.2707 3.50417 17.2593L3.50395 17.2449L3.50392 17.2396L3.50391 17.2375C3.50391 17.237 3.50391 17.2357 4.2034 17.2357H3.50391V12.5915H4.90289V17.2322L4.90336 17.2471C4.90399 17.2629 4.90542 17.29 4.90859 17.3267C4.91494 17.4005 4.92815 17.5115 4.95541 17.6472C5.01043 17.921 5.11954 18.2791 5.33218 18.6315C5.73009 19.2909 6.55709 20.048 8.44111 20.0441L8.44383 20.0441L8.46281 20.0437C8.48164 20.0431 8.51244 20.0419 8.55355 20.0392C8.63597 20.0337 8.75857 20.0224 8.90841 19.9989C9.21093 19.9516 9.60883 19.8574 10.0072 19.6734C10.7699 19.3211 11.5474 18.6441 11.6731 17.2063V6.88387L12.3726 6.90162C11.6734 6.88387 11.6731 6.8843 11.6731 6.88387L11.6734 6.88211L11.6735 6.88003L11.6736 6.87497L11.6742 6.86126C11.6746 6.85055 11.6754 6.83672 11.6765 6.81995C11.6786 6.78643 11.6822 6.74108 11.6883 6.68546C11.7004 6.57439 11.7224 6.42122 11.7622 6.23869C11.8416 5.87539 11.9943 5.38455 12.2903 4.87607C12.9001 3.82834 14.0767 2.78298 16.2308 2.56058L16.2667 2.55688H16.3027ZM13.0718 6.92355C13.0717 6.92435 13.0717 6.9242 13.0718 6.92355V6.92355Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2521 13.0936C19.3815 13.0936 18.6758 13.7993 18.6758 14.6698C18.6758 15.5403 19.3815 16.2461 20.2521 16.2461C21.1226 16.2461 21.8283 15.5403 21.8283 14.6698C21.8283 13.7993 21.1226 13.0936 20.2521 13.0936ZM17.2769 14.6698C17.2769 13.0266 18.6089 11.6946 20.2521 11.6946C21.8953 11.6946 23.2273 13.0266 23.2273 14.6698C23.2273 16.313 21.8953 17.645 20.2521 17.645C18.6089 17.645 17.2769 16.313 17.2769 14.6698Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.20277 8.54253C3.33223 8.54253 2.62652 9.24824 2.62652 10.1188C2.62652 10.9893 3.33223 11.695 4.20277 11.695C5.07331 11.695 5.77902 10.9893 5.77902 10.1188C5.77902 9.24824 5.07331 8.54253 4.20277 8.54253ZM1.22754 10.1188C1.22754 8.47561 2.55959 7.14355 4.20277 7.14355C5.84594 7.14355 7.178 8.47561 7.178 10.1188C7.178 11.762 5.84594 13.094 4.20277 13.094C2.55959 13.094 1.22754 11.762 1.22754 10.1188Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $0156f9680cfc260b$export$2e2bcd8739ae039 = $0156f9680cfc260b$var$SvgRoute;




var $exYeM = parcelRequire("exYeM");

function $7c601a476a2817cb$var$SvgScanner(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.58325 2.02067C9.59093 2.35195 9.3286 2.62673 8.99732 2.63441C6.16945 2.69997 4.77428 2.9858 3.84461 3.92835C3.03337 4.75082 2.70799 5.94273 2.5992 8.16812C2.58302 8.4991 2.3016 8.75429 1.97062 8.73811C1.63964 8.72193 1.38445 8.44051 1.40063 8.10953C1.51093 5.85326 1.84092 4.25093 2.99026 3.08567C4.30071 1.75708 6.18417 1.4993 8.96951 1.43473C9.30079 1.42706 9.57557 1.68939 9.58325 2.02067ZM14.4166 2.02067C14.4243 1.68939 14.699 1.42706 15.0303 1.43473C17.8157 1.4993 19.6991 1.75708 21.0096 3.08567C22.1589 4.25092 22.4889 5.85326 22.5992 8.10954C22.6154 8.44052 22.3602 8.72194 22.0292 8.73811C21.6982 8.75428 21.4168 8.49909 21.4006 8.16811C21.2919 5.94273 20.9665 4.75082 20.1553 3.92835C19.2255 2.98579 17.8304 2.69997 15.0025 2.63441C14.6712 2.62673 14.4089 2.35195 14.4166 2.02067ZM1.97062 15.6786C2.3016 15.6624 2.58302 15.9176 2.5992 16.2486C2.70798 18.474 3.03337 19.6658 3.84461 20.4883C4.77428 21.4309 6.16945 21.7168 8.99731 21.7823C9.32859 21.7899 9.59093 22.0647 9.58325 22.396C9.57558 22.7273 9.3008 22.9896 8.96952 22.9819C6.18416 22.9174 4.30071 22.6596 2.99026 21.331C1.84093 20.1657 1.51093 18.5635 1.40063 16.3071C1.38445 15.9762 1.63965 15.6947 1.97062 15.6786ZM22.0292 15.6786C22.3602 15.6947 22.6154 15.9762 22.5992 16.3071C22.4889 18.5635 22.1589 20.1657 21.0096 21.331C19.6991 22.6596 17.8157 22.9174 15.0303 22.9819C14.699 22.9896 14.4242 22.7273 14.4166 22.396C14.4089 22.0647 14.6712 21.7899 15.0025 21.7823C17.8304 21.7168 19.2255 21.4309 20.1552 20.4883C20.9665 19.6658 21.2919 18.474 21.4006 16.2486C21.4168 15.9176 21.6982 15.6624 22.0292 15.6786Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.39992 11.6997C6.39992 8.84957 8.67353 6.52145 11.4999 6.52145C14.3263 6.52145 16.5999 8.84957 16.5999 11.6997C16.5999 12.9113 16.189 14.0286 15.4994 14.9127L17.4278 16.8746C17.6601 17.111 17.6568 17.4908 17.4205 17.7231C17.1842 17.9554 16.8043 17.9521 16.572 17.7158L14.6567 15.7672C13.7896 16.4622 12.6941 16.8779 11.4999 16.8779C8.67353 16.8779 6.39992 14.5497 6.39992 11.6997ZM11.4999 7.72145C9.35568 7.72145 7.59992 9.49274 7.59992 11.6997C7.59992 13.9066 9.35568 15.6779 11.4999 15.6779C13.6441 15.6779 15.3999 13.9066 15.3999 11.6997C15.3999 9.49274 13.6441 7.72145 11.4999 7.72145Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $7c601a476a2817cb$export$2e2bcd8739ae039 = $7c601a476a2817cb$var$SvgScanner;




var $exYeM = parcelRequire("exYeM");

function $face5bd47680c654$var$SvgScore(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.1297 4.15703C13.935 4.15703 13.5652 4.31417 13.2086 5.04165L13.2065 5.04589L11.708 8.04284C11.5535 8.35839 11.2936 8.6315 11.023 8.83277C10.7517 9.03459 10.414 9.20563 10.0653 9.26254L7.35557 9.70885C6.59307 9.84027 6.32773 10.1442 6.26382 10.3438C6.20022 10.5425 6.23891 10.9424 6.78676 11.4903L8.90971 13.6133C9.1703 13.8817 9.34982 14.2405 9.44958 14.5896C9.5489 14.9373 9.58745 15.3398 9.4993 15.7108L9.49876 15.713L8.89345 18.3254C8.66637 19.3044 8.89026 19.678 9.02355 19.7749C9.1589 19.8734 9.58682 19.9701 10.4497 19.4606L12.9892 17.9517C13.3345 17.7437 13.7543 17.6591 14.1377 17.6591C14.521 17.6591 14.9408 17.7437 15.2861 17.9518L17.8274 19.4616C18.6899 19.9761 19.1166 19.8777 19.2508 19.7796C19.3853 19.6814 19.6089 19.3042 19.3819 18.3256L18.7759 15.7102L18.7757 15.7092C18.6885 15.3355 18.7258 14.9314 18.8257 14.5817C18.9256 14.2322 19.1063 13.8725 19.3719 13.6069L21.4868 11.4921L21.4876 11.4913C22.0361 10.9377 22.0753 10.535 22.0115 10.3359C21.9481 10.1379 21.6846 9.83555 20.9213 9.70911L18.1973 9.26046C17.8585 9.19741 17.5259 9.03063 17.2542 8.83019C16.9846 8.63125 16.7229 8.36056 16.5673 8.04284L15.0695 5.04728C14.7024 4.31804 14.3271 4.15703 14.1297 4.15703ZM14.1297 2.95703C14.9959 2.95703 15.6897 3.61019 16.1414 4.50783L16.1422 4.50923L17.6446 7.5142C17.6913 7.60998 17.801 7.74239 17.9666 7.86456C18.1288 7.98418 18.2937 8.05649 18.4119 8.07962L21.1169 8.52515C22.0873 8.6859 22.8933 9.15476 23.1544 9.96992C23.415 10.7838 23.0341 11.6359 22.3389 12.337L22.3371 12.3388L20.2205 14.4555C20.1351 14.5409 20.0393 14.7024 19.9796 14.9113C19.9201 15.1197 19.9149 15.3108 19.9443 15.4367L19.9446 15.438L20.5509 18.0544C20.8024 19.1392 20.7123 20.1981 19.9587 20.7486C19.205 21.2992 18.1694 21.0627 17.2133 20.4926L14.6675 18.98C14.5558 18.9125 14.365 18.8591 14.1377 18.8591C13.9103 18.8591 13.7195 18.9125 13.6078 18.98L13.6039 18.9824L11.0604 20.4935C10.1048 21.058 9.07033 21.2929 8.31757 20.7453C7.56277 20.1961 7.4729 19.139 7.72442 18.0546L8.3307 15.438L8.33167 15.4339C8.35982 15.3162 8.35577 15.1294 8.29575 14.9193C8.23652 14.712 8.14079 14.5454 8.05111 14.4517L5.93823 12.3388C5.24162 11.6422 4.86018 10.7924 5.12098 9.9779C5.38142 9.16455 6.18463 8.69242 7.15436 8.52584L7.15843 8.52514L9.87069 8.07843L9.8718 8.07825C9.98026 8.06059 10.1422 7.99241 10.3068 7.86995C10.4714 7.74746 10.583 7.61219 10.6307 7.51422L10.6334 7.50866L12.1322 4.51126C12.5733 3.6125 13.2615 2.95703 14.1297 2.95703Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.76416 4.5541C0.76416 4.22273 1.03279 3.9541 1.36416 3.9541H7.74598C8.07735 3.9541 8.34598 4.22273 8.34598 4.5541C8.34598 4.88547 8.07735 5.1541 7.74598 5.1541H1.36416C1.03279 5.1541 0.76416 4.88547 0.76416 4.5541Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.76416 19.4447C0.76416 19.1134 1.03279 18.8447 1.36416 18.8447H4.55507C4.88644 18.8447 5.15507 19.1134 5.15507 19.4447C5.15507 19.7761 4.88644 20.0447 4.55507 20.0447H1.36416C1.03279 20.0447 0.76416 19.7761 0.76416 19.4447Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.76416 11.9994C0.76416 11.668 1.03279 11.3994 1.36416 11.3994H2.4278C2.75917 11.3994 3.0278 11.668 3.0278 11.9994C3.0278 12.3308 2.75917 12.5994 2.4278 12.5994H1.36416C1.03279 12.5994 0.76416 12.3308 0.76416 11.9994Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $face5bd47680c654$export$2e2bcd8739ae039 = $face5bd47680c654$var$SvgScore;




var $exYeM = parcelRequire("exYeM");

function $daa353aade8d8ccc$var$SvgSearch(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.058 4.04189C14.3131 0.296976 8.2414 0.296976 4.49648 4.04189C0.751566 7.78681 0.751566 13.8585 4.49648 17.6034C8.2414 21.3483 14.3131 21.3483 18.058 17.6034C21.8029 13.8585 21.8029 7.78681 18.058 4.04189ZM18.93 3.16988C14.7035 -1.05663 7.85098 -1.05663 3.62447 3.16988C-0.602038 7.39639 -0.602038 14.2489 3.62447 18.4754C7.85098 22.7019 14.7035 22.7019 18.93 18.4754C23.1565 14.2489 23.1565 7.39639 18.93 3.16988Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.0517 17.5971C18.2925 17.3563 18.6829 17.3563 18.9237 17.5971L24.2739 22.9473C24.5147 23.1881 24.5147 23.5785 24.2739 23.8193C24.0331 24.0601 23.6427 24.0601 23.4019 23.8193L18.0517 18.4691C17.8109 18.2283 17.8109 17.8379 18.0517 17.5971Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $daa353aade8d8ccc$export$2e2bcd8739ae039 = $daa353aade8d8ccc$var$SvgSearch;




var $exYeM = parcelRequire("exYeM");

function $85884e39b7c36b15$var$SvgShare(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_19665_403199)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.3333 2.34435C17.7132 2.34435 16.3999 3.65765 16.3999 5.27769C16.3999 6.89772 17.7132 8.21102 19.3333 8.21102C20.9534 8.21102 22.2666 6.89772 22.2666 5.27769C22.2666 3.65765 20.9534 2.34435 19.3333 2.34435ZM14.9333 5.27769C14.9333 2.84765 16.9032 0.877686 19.3333 0.877686C21.7634 0.877686 23.7333 2.84765 23.7333 5.27769C23.7333 7.70773 21.7634 9.67769 19.3333 9.67769C17.8132 9.67769 16.4732 8.90689 15.6827 7.73484L8.91673 10.8571C9.01448 11.2215 9.0666 11.6046 9.0666 11.9999C9.0666 12.3952 9.01449 12.7782 8.91675 13.1427L15.6828 16.2649C16.4732 15.0929 17.8132 14.3221 19.3333 14.3221C21.7634 14.3221 23.7333 16.292 23.7333 18.7221C23.7333 21.1522 21.7634 23.1221 19.3333 23.1221C16.9032 23.1221 14.9333 21.1522 14.9333 18.7221C14.9333 18.3346 14.9834 17.9588 15.0774 17.6009L8.30465 14.4755C7.51261 15.6372 6.17867 16.3999 4.6666 16.3999C2.23656 16.3999 0.266602 14.43 0.266602 11.9999C0.266602 9.56979 2.23656 7.59991 4.6666 7.59991C6.17863 7.59991 7.51254 8.36258 8.30459 9.52424L15.0774 6.39888C14.9834 6.04093 14.9333 5.66515 14.9333 5.27769ZM4.6666 9.06658C3.04656 9.06658 1.73327 10.3798 1.73327 11.9999C1.73327 13.62 3.04656 14.9332 4.6666 14.9332C6.28664 14.9332 7.59993 13.62 7.59993 11.9999C7.59993 10.3798 6.28664 9.06658 4.6666 9.06658ZM19.3333 15.7888C17.7132 15.7888 16.3999 17.102 16.3999 18.7221C16.3999 20.3422 17.7132 21.6555 19.3333 21.6555C20.9534 21.6555 22.2666 20.3422 22.2666 18.7221C22.2666 17.102 20.9534 15.7888 19.3333 15.7888Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_19665_403199",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $85884e39b7c36b15$export$2e2bcd8739ae039 = $85884e39b7c36b15$var$SvgShare;




var $exYeM = parcelRequire("exYeM");

function $62b65843d6c09f2b$var$SvgSlippage(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12.1875 15.9375C12.2868 15.9371 12.3819 15.8973 12.4519 15.8269L19.2019 9.07687C19.2633 9.00514 19.2954 8.91286 19.2918 8.81848C19.2881 8.7241 19.249 8.63457 19.1822 8.56779C19.1154 8.501 19.0259 8.46188 18.9315 8.45823C18.8371 8.45459 18.7449 8.48669 18.6731 8.54813L11.9231 15.2981C11.871 15.3506 11.8355 15.4172 11.8212 15.4898C11.8069 15.5623 11.8143 15.6375 11.8425 15.7058C11.8708 15.7741 11.9186 15.8326 11.98 15.8738C12.0414 15.915 12.1136 15.9372 12.1875 15.9375ZM15 9.75C15 9.37916 14.89 9.01665 14.684 8.70831C14.478 8.39996 14.1851 8.15964 13.8425 8.01773C13.4999 7.87581 13.1229 7.83868 12.7592 7.91103C12.3955 7.98337 12.0614 8.16195 11.7992 8.42417C11.537 8.6864 11.3584 9.02049 11.286 9.38421C11.2137 9.74792 11.2508 10.1249 11.3927 10.4675C11.5346 10.8101 11.775 11.103 12.0833 11.309C12.3916 11.515 12.7542 11.625 13.125 11.625C13.6223 11.625 14.0992 11.4275 14.4508 11.0758C14.8025 10.7242 15 10.2473 15 9.75ZM12 9.75C12 9.5275 12.066 9.30999 12.1896 9.12498C12.3132 8.93998 12.4889 8.79578 12.6945 8.71064C12.9 8.62549 13.1262 8.60321 13.3445 8.64662C13.5627 8.69002 13.7632 8.79717 13.9205 8.9545C14.0778 9.11184 14.185 9.31229 14.2284 9.53052C14.2718 9.74875 14.2495 9.97495 14.1644 10.1805C14.0792 10.3861 13.935 10.5618 13.75 10.6854C13.565 10.809 13.3475 10.875 13.125 10.875C12.8266 10.875 12.5405 10.7565 12.3295 10.5455C12.1185 10.3345 12 10.0484 12 9.75ZM18 16.125C18.3708 16.125 18.7334 16.015 19.0417 15.809C19.35 15.603 19.5904 15.3101 19.7323 14.9675C19.8742 14.6249 19.9113 14.2479 19.839 13.8842C19.7666 13.5205 19.588 13.1864 19.3258 12.9242C19.0636 12.662 18.7295 12.4834 18.3658 12.411C18.0021 12.3387 17.6251 12.3758 17.2825 12.5177C16.9399 12.6596 16.647 12.9 16.441 13.2083C16.235 13.5166 16.125 13.8792 16.125 14.25C16.125 14.7473 16.3225 15.2242 16.6742 15.5758C17.0258 15.9275 17.5027 16.125 18 16.125ZM18 13.125C18.2225 13.125 18.44 13.191 18.625 13.3146C18.81 13.4382 18.9542 13.6139 19.0394 13.8195C19.1245 14.025 19.1468 14.2512 19.1034 14.4695C19.06 14.6877 18.9528 14.8882 18.7955 15.0455C18.6382 15.2028 18.4377 15.31 18.2195 15.3534C18.0012 15.3968 17.775 15.3745 17.5695 15.2894C17.3639 15.2042 17.1882 15.06 17.0646 14.875C16.941 14.69 16.875 14.4725 16.875 14.25C16.875 13.9516 16.9935 13.6655 17.2045 13.4545C17.4155 13.2435 17.7016 13.125 18 13.125ZM3.375 3.75H5.625C5.72446 3.75 5.81984 3.71049 5.89016 3.64016C5.96049 3.56984 6 3.47446 6 3.375C6 3.27554 5.96049 3.18016 5.89016 3.10984C5.81984 3.03951 5.72446 3 5.625 3H3.375C3.27554 3 3.18016 3.03951 3.10984 3.10984C3.03951 3.18016 3 3.27554 3 3.375C3 3.47446 3.03951 3.56984 3.10984 3.64016C3.18016 3.71049 3.27554 3.75 3.375 3.75ZM18.375 3.75H20.625C20.7245 3.75 20.8198 3.71049 20.8902 3.64016C20.9605 3.56984 21 3.47446 21 3.375C21 3.27554 20.9605 3.18016 20.8902 3.10984C20.8198 3.03951 20.7245 3 20.625 3H18.375C18.2755 3 18.1802 3.03951 18.1098 3.10984C18.0395 3.18016 18 3.27554 18 3.375C18 3.47446 18.0395 3.56984 18.1098 3.64016C18.1802 3.71049 18.2755 3.75 18.375 3.75ZM10.875 3.75H13.125C13.2245 3.75 13.3198 3.71049 13.3902 3.64016C13.4605 3.56984 13.5 3.47446 13.5 3.375C13.5 3.27554 13.4605 3.18016 13.3902 3.10984C13.3198 3.03951 13.2245 3 13.125 3H10.875C10.7755 3 10.6802 3.03951 10.6098 3.10984C10.5395 3.18016 10.5 3.27554 10.5 3.375C10.5 3.47446 10.5395 3.56984 10.6098 3.64016C10.6802 3.71049 10.7755 3.75 10.875 3.75ZM7.125 3.75H9.375C9.47446 3.75 9.56984 3.71049 9.64017 3.64016C9.71049 3.56984 9.75 3.47446 9.75 3.375C9.75 3.27554 9.71049 3.18016 9.64017 3.10984C9.56984 3.03951 9.47446 3 9.375 3H7.125C7.02554 3 6.93016 3.03951 6.85983 3.10984C6.78951 3.18016 6.75 3.27554 6.75 3.375C6.75 3.47446 6.78951 3.56984 6.85983 3.64016C6.93016 3.71049 7.02554 3.75 7.125 3.75ZM14.625 3.75H16.875C16.9745 3.75 17.0698 3.71049 17.1402 3.64016C17.2105 3.56984 17.25 3.47446 17.25 3.375C17.25 3.27554 17.2105 3.18016 17.1402 3.10984C17.0698 3.03951 16.9745 3 16.875 3H14.625C14.5255 3 14.4302 3.03951 14.3598 3.10984C14.2895 3.18016 14.25 3.27554 14.25 3.375C14.25 3.47446 14.2895 3.56984 14.3598 3.64016C14.4302 3.71049 14.5255 3.75 14.625 3.75ZM5.625 20.25H3.375C3.27554 20.25 3.18016 20.2895 3.10984 20.3598C3.03951 20.4302 3 20.5255 3 20.625C3 20.7245 3.03951 20.8198 3.10984 20.8902C3.18016 20.9605 3.27554 21 3.375 21H5.625C5.72446 21 5.81984 20.9605 5.89016 20.8902C5.96049 20.8198 6 20.7245 6 20.625C6 20.5255 5.96049 20.4302 5.89016 20.3598C5.81984 20.2895 5.72446 20.25 5.625 20.25ZM20.625 20.25H18.375C18.2755 20.25 18.1802 20.2895 18.1098 20.3598C18.0395 20.4302 18 20.5255 18 20.625C18 20.7245 18.0395 20.8198 18.1098 20.8902C18.1802 20.9605 18.2755 21 18.375 21H20.625C20.7245 21 20.8198 20.9605 20.8902 20.8902C20.9605 20.8198 21 20.7245 21 20.625C21 20.5255 20.9605 20.4302 20.8902 20.3598C20.8198 20.2895 20.7245 20.25 20.625 20.25ZM13.125 20.25H10.875C10.7755 20.25 10.6802 20.2895 10.6098 20.3598C10.5395 20.4302 10.5 20.5255 10.5 20.625C10.5 20.7245 10.5395 20.8198 10.6098 20.8902C10.6802 20.9605 10.7755 21 10.875 21H13.125C13.2245 21 13.3198 20.9605 13.3902 20.8902C13.4605 20.8198 13.5 20.7245 13.5 20.625C13.5 20.5255 13.4605 20.4302 13.3902 20.3598C13.3198 20.2895 13.2245 20.25 13.125 20.25ZM9.375 20.25H7.125C7.02554 20.25 6.93016 20.2895 6.85983 20.3598C6.78951 20.4302 6.75 20.5255 6.75 20.625C6.75 20.7245 6.78951 20.8198 6.85983 20.8902C6.93016 20.9605 7.02554 21 7.125 21H9.375C9.47446 21 9.56984 20.9605 9.64017 20.8902C9.71049 20.8198 9.75 20.7245 9.75 20.625C9.75 20.5255 9.71049 20.4302 9.64017 20.3598C9.56984 20.2895 9.47446 20.25 9.375 20.25ZM16.875 20.25H14.625C14.5255 20.25 14.4302 20.2895 14.3598 20.3598C14.2895 20.4302 14.25 20.5255 14.25 20.625C14.25 20.7245 14.2895 20.8198 14.3598 20.8902C14.4302 20.9605 14.5255 21 14.625 21H16.875C16.9745 21 17.0698 20.9605 17.1402 20.8902C17.2105 20.8198 17.25 20.7245 17.25 20.625C17.25 20.5255 17.2105 20.4302 17.1402 20.3598C17.0698 20.2895 16.9745 20.25 16.875 20.25ZM10.3894 16.2356C10.3191 16.1658 10.2241 16.1266 10.125 16.1266C10.0259 16.1266 9.93089 16.1658 9.86063 16.2356L8.25 17.8444V6.15563L9.86063 7.76437C9.93236 7.82581 10.0246 7.85791 10.119 7.85427C10.2134 7.85062 10.3029 7.8115 10.3697 7.74471C10.4365 7.67793 10.4756 7.5884 10.4793 7.49402C10.4829 7.39964 10.4508 7.30736 10.3894 7.23563L8.13937 4.98563C8.06911 4.91578 7.97407 4.87658 7.875 4.87658C7.77593 4.87658 7.68089 4.91578 7.61063 4.98563L5.36063 7.23563C5.29919 7.30736 5.26709 7.39964 5.27073 7.49402C5.27438 7.5884 5.3135 7.67793 5.38029 7.74471C5.44707 7.8115 5.5366 7.85062 5.63098 7.85427C5.72536 7.85791 5.81764 7.82581 5.88937 7.76437L7.5 6.15563V17.8444L5.88937 16.2356C5.81764 16.1742 5.72536 16.1421 5.63098 16.1457C5.5366 16.1494 5.44707 16.1885 5.38029 16.2553C5.3135 16.3221 5.27438 16.4116 5.27073 16.506C5.26709 16.6004 5.29919 16.6926 5.36063 16.7644L7.61063 19.0144C7.68089 19.0842 7.77593 19.1234 7.875 19.1234C7.97407 19.1234 8.06911 19.0842 8.13937 19.0144L10.3894 16.7644C10.4592 16.6941 10.4984 16.5991 10.4984 16.5C10.4984 16.4009 10.4592 16.3059 10.3894 16.2356Z",
            fill: "currentColor"
        })
    }));
}
var $62b65843d6c09f2b$export$2e2bcd8739ae039 = $62b65843d6c09f2b$var$SvgSlippage;




var $exYeM = parcelRequire("exYeM");

function $057474aa665d083c$var$SvgStats(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_19665_403204)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.999935 0.266602C1.40494 0.266602 1.73327 0.594926 1.73327 0.999935V14.4444C1.73327 16.4817 1.73483 17.9358 1.88335 19.0405C2.02903 20.1241 2.3039 20.7609 2.77141 21.2285C2.7714 21.2285 2.77142 21.2285 2.77141 21.2285M2.77141 21.2285C3.23891 21.696 3.87575 21.9708 4.95932 22.1165C6.064 22.265 7.5182 22.2666 9.55549 22.2666H22.9999C23.4049 22.2666 23.7333 22.5949 23.7333 22.9999C23.7333 23.4049 23.4049 23.7333 22.9999 23.7333H9.49996C7.5305 23.7333 5.97763 23.7333 4.76389 23.5701C3.51768 23.4026 2.51976 23.051 1.73433 22.2656C0.948917 21.4801 0.597309 20.4822 0.429758 19.2359C0.266576 18.0222 0.266587 16.4694 0.266602 14.4999L0.266602 0.999935C0.266602 0.594926 0.594927 0.266602 0.999935 0.266602M8.32449 4.17795C6.98416 4.17795 6.06248 4.98901 5.29529 6.26659C5.08679 6.61381 4.63629 6.72625 4.28907 6.51775C3.94186 6.30925 3.82941 5.85875 4.03791 5.51153C4.91701 4.0476 6.22867 2.71128 8.32449 2.71128C9.36395 2.71128 10.2395 2.97626 10.97 3.46553C11.6929 3.94969 12.231 4.62463 12.6496 5.3813C13.4335 6.79833 13.8659 8.64001 14.2715 10.3675C14.2905 10.4486 14.3095 10.5294 14.3284 10.6099C14.7661 12.4697 15.193 14.183 15.951 15.4412C16.3214 16.0559 16.7549 16.5322 17.2811 16.8571C17.8026 17.1791 18.4563 17.378 19.3111 17.378C20.663 17.378 21.5795 16.5614 22.3773 15.2794C22.5913 14.9355 23.0435 14.8302 23.3874 15.0442C23.7313 15.2582 23.8365 15.7104 23.6226 16.0543C22.7232 17.4995 21.4198 18.8446 19.3111 18.8446C18.2146 18.8446 17.2883 18.5852 16.5107 18.1051C15.7378 17.6279 15.1528 16.9583 14.6948 16.1981C13.796 14.7062 13.326 12.7529 12.9008 10.946C12.8897 10.8992 12.8788 10.8525 12.8678 10.8059C12.4406 8.9898 12.0493 7.32607 11.3662 6.09127C11.0241 5.47294 10.6285 5.00204 10.1538 4.68412C9.68679 4.37131 9.10098 4.17795 8.32449 4.17795Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_19665_403204",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $057474aa665d083c$export$2e2bcd8739ae039 = $057474aa665d083c$var$SvgStats;




var $exYeM = parcelRequire("exYeM");

function $08343c3aba8ea46f$var$SvgSupport(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.77732 12.5006C7.82378 12.5797 7.90809 12.6296 8.001 12.6296C8.09392 12.6296 8.17823 12.5797 8.22468 12.5006L8.9353 11.2686C10.7368 10.8402 12.0324 9.20905 12.0324 7.34562C12.0324 5.12259 10.224 3.3125 7.99928 3.3125C5.77453 3.3125 3.96788 5.12259 3.96788 7.34562C3.96788 9.20905 5.2635 10.8419 7.06499 11.2686L7.77732 12.5006ZM4.48407 7.34562C4.48407 5.40649 6.06187 3.82868 8.001 3.82868C9.94014 3.82868 11.5179 5.40649 11.5179 7.34562C11.5179 9.00601 10.3393 10.4531 8.71678 10.7886C8.64451 10.8041 8.58257 10.8488 8.54472 10.9125L8.001 11.8554L7.45729 10.9125C7.42116 10.8488 7.35749 10.8041 7.28523 10.7886C5.66269 10.4548 4.48407 9.00601 4.48407 7.34562Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M9.81797 8.87615C9.81797 8.73334 9.70268 8.61806 9.55987 8.61806H6.44212C6.29931 8.61806 6.18403 8.73334 6.18403 8.87615C6.18403 9.01896 6.29931 9.13424 6.44212 9.13424H9.55815C9.70096 9.13424 9.81797 9.01896 9.81797 8.87615Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M6.44212 5.91896H9.55815C9.70096 5.91896 9.81625 5.80368 9.81625 5.66087C9.81625 5.51806 9.70096 5.40278 9.55815 5.40278H6.44212C6.29931 5.40278 6.18403 5.51806 6.18403 5.66087C6.18403 5.80368 6.30103 5.91896 6.44212 5.91896Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M10.1706 7.26504C10.1706 7.12223 10.0553 7.00694 9.91246 7.00694H6.08926C5.94644 7.00694 5.83116 7.12223 5.83116 7.26504C5.83116 7.40785 5.94644 7.52313 6.08926 7.52313H9.91074C10.0553 7.52313 10.1706 7.40785 10.1706 7.26504Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.1001 5.72137H15.0278C14.7956 5.72137 14.5856 5.81256 14.4256 5.95709C13.6772 3.10947 11.0808 1 8.00086 1C4.92096 1 2.32455 3.10947 1.5778 5.95709C1.41779 5.81256 1.20787 5.72137 0.975589 5.72137H0.901602C0.404344 5.72137 0 6.12571 0 6.62297V8.65674C0 9.15399 0.404344 9.55834 0.901602 9.55834H0.973868C1.47113 9.55834 1.87547 9.15399 1.87547 8.65674V7.63985C1.87547 4.26229 4.62329 1.51618 7.99914 1.51618C11.375 1.51618 14.1228 4.26401 14.1228 7.63985C14.1228 10.3946 12.3041 12.7862 9.67502 13.5312C9.52704 13.3093 9.27411 13.1647 8.98849 13.1647H7.88041C7.42445 13.1647 7.05452 13.5347 7.05452 13.9906V14.0543C7.05452 14.5103 7.42445 14.8802 7.88041 14.8802H8.99021C9.44617 14.8802 9.81611 14.5103 9.81611 14.0543V14.0285C12.1148 13.3781 13.8423 11.568 14.4256 9.32433C14.5856 9.46886 14.7956 9.55834 15.0261 9.55834H15.0984C15.5956 9.55834 16 9.15399 16 8.65674V6.62469C16.0017 6.12743 15.5974 5.72137 15.1001 5.72137ZM1.36101 8.65674C1.36101 8.87009 1.18722 9.04215 0.975589 9.04215H0.901602C0.688246 9.04215 0.516184 8.86837 0.516184 8.65674V6.62469C0.516184 6.41133 0.689966 6.23927 0.901602 6.23927H0.973868C1.18722 6.23927 1.35929 6.41305 1.35929 6.62469V8.65674H1.36101ZM9.30164 14.0543C9.30164 14.2246 9.16227 14.364 8.99193 14.364H7.88041C7.71007 14.364 7.5707 14.2246 7.5707 14.0543V13.9906C7.5707 13.8203 7.71007 13.6809 7.88041 13.6809H8.99021C9.11582 13.6809 9.22594 13.7566 9.27411 13.8668C9.27583 13.8788 9.27583 13.8891 9.27927 13.9012C9.28272 13.9149 9.29132 13.927 9.29648 13.939C9.29992 13.9562 9.30164 13.9734 9.30164 13.9906V14.0543ZM15.4855 8.65674C15.4855 8.87009 15.3117 9.04215 15.1001 9.04215H15.0278C14.8145 9.04215 14.6424 8.86837 14.6424 8.65674V6.62469C14.6424 6.41133 14.8162 6.23927 15.0278 6.23927H15.1001C15.3135 6.23927 15.4855 6.41305 15.4855 6.62469V8.65674Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $08343c3aba8ea46f$export$2e2bcd8739ae039 = $08343c3aba8ea46f$var$SvgSupport;




var $exYeM = parcelRequire("exYeM");

function $e7d9fdd45b4d82b6$var$SvgSwap(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_13896_357843)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                    clipPath: "url(#clip1_13896_357843)",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.46967 18.9837C0.176778 18.6908 0.176776 18.2159 0.469666 17.923L5.0163 13.3763C5.30919 13.0834 5.78406 13.0834 6.07696 13.3763C6.36985 13.6692 6.36986 14.1441 6.07697 14.437L2.06066 18.4534L6.07696 22.4697C6.36985 22.7626 6.36985 23.2374 6.07696 23.5303C5.78407 23.8232 5.30919 23.8232 5.0163 23.5303L0.46967 18.9837Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.25 18.4539C0.25 18.0396 0.585786 17.7039 1 17.7039H23C23.4142 17.7039 23.75 18.0396 23.75 18.4539C23.75 18.8681 23.4142 19.2039 23 19.2039H1C0.585786 19.2039 0.25 18.8681 0.25 18.4539Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M17.9228 10.6483C17.6299 10.3554 17.6299 9.88049 17.9228 9.58759L21.9391 5.57122L17.9228 1.55491C17.6299 1.26202 17.6299 0.787147 17.9228 0.494253C18.2157 0.201361 18.6906 0.201361 18.9835 0.494253L23.5301 5.04088C23.823 5.33378 23.823 5.80865 23.5301 6.10154L18.9835 10.6482C18.6906 10.9411 18.2157 10.9411 17.9228 10.6483Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.25 5.57129C0.25 5.15708 0.585786 4.82129 1 4.82129L23 4.82129C23.4142 4.82129 23.75 5.15708 23.75 5.57129C23.75 5.9855 23.4142 6.32129 23 6.32129L1 6.32129C0.585786 6.32129 0.25 5.9855 0.25 5.57129Z",
                            fill: "currentColor"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip0_13896_357843",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 24,
                            height: 24,
                            fill: "white",
                            transform: "matrix(0 -1 1 0 0 24)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                        id: "clip1_13896_357843",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                            width: 24,
                            height: 24,
                            fill: "white",
                            transform: "matrix(0 -1 1 0 0 24)"
                        })
                    })
                ]
            })
        ]
    }));
}
var $e7d9fdd45b4d82b6$export$2e2bcd8739ae039 = $e7d9fdd45b4d82b6$var$SvgSwap;




var $exYeM = parcelRequire("exYeM");

function $556a7d2e42a609b4$var$SvgTarget(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Custom token",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Icon (Stroke)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0004 0.174805C12.456 0.174805 12.8254 0.544173 12.8254 0.999811V2.40968C17.483 2.80507 21.1952 6.51725 21.5906 11.1749H23.0005C23.4561 11.1749 23.8255 11.5443 23.8255 11.9999C23.8255 12.4555 23.4561 12.8249 23.0005 12.8249H21.5906C21.1952 17.4825 17.483 21.1947 12.8254 21.5901V23C12.8254 23.4556 12.456 23.825 12.0004 23.825C11.5447 23.825 11.1754 23.4556 11.1754 23V21.5901C6.51773 21.1947 2.80556 17.4825 2.41017 12.8249H1.0003C0.544661 12.8249 0.175293 12.4555 0.175293 11.9999C0.175293 11.5443 0.544661 11.1749 1.0003 11.1749H2.41017C2.80556 6.51725 6.51773 2.80507 11.1754 2.40968V0.999811C11.1754 0.544173 11.5447 0.174805 12.0004 0.174805ZM11.1754 4.06699C7.42972 4.45195 4.45243 7.42923 4.06748 11.1749H5.40033C5.85597 11.1749 6.22534 11.5443 6.22534 11.9999C6.22534 12.4555 5.85597 12.8249 5.40033 12.8249H4.06748C4.45243 16.5706 7.42972 19.5478 11.1754 19.9328V18.5999C11.1754 18.1443 11.5447 17.7749 12.0004 17.7749C12.456 17.7749 12.8254 18.1443 12.8254 18.5999V19.9328C16.571 19.5478 19.5483 16.5706 19.9333 12.8249H18.6004C18.1448 12.8249 17.7754 12.4555 17.7754 11.9999C17.7754 11.5443 18.1448 11.1749 18.6004 11.1749H19.9333C19.5483 7.42923 16.571 4.45195 12.8254 4.06699V5.39984C12.8254 5.85548 12.456 6.22485 12.0004 6.22485C11.5447 6.22485 11.1754 5.85548 11.1754 5.39984V4.06699ZM12.0004 8.97487C12.456 8.97487 12.8254 9.34424 12.8254 9.79988V11.1749H14.2004C14.656 11.1749 15.0254 11.5443 15.0254 11.9999C15.0254 12.4555 14.656 12.8249 14.2004 12.8249H12.8254V14.1999C12.8254 14.6555 12.456 15.0249 12.0004 15.0249C11.5447 15.0249 11.1754 14.6555 11.1754 14.1999V12.8249H9.80037C9.34473 12.8249 8.97536 12.4555 8.97536 11.9999C8.97536 11.5443 9.34473 11.1749 9.80037 11.1749H11.1754V9.79988C11.1754 9.34424 11.5447 8.97487 12.0004 8.97487Z",
                fill: "currentColor"
            })
        })
    }));
}
var $556a7d2e42a609b4$export$2e2bcd8739ae039 = $556a7d2e42a609b4$var$SvgTarget;




var $exYeM = parcelRequire("exYeM");

function $7aa76ffc74c20c04$var$SvgTime(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.4551 22.6998C18.3645 22.6998 23.1551 17.9092 23.1551 11.9998C23.1551 6.09031 18.3645 1.29976 12.4551 1.29976C6.54563 1.29976 1.75508 6.09031 1.75508 11.9998C1.75508 17.9092 6.54563 22.6998 12.4551 22.6998ZM12.4551 23.9998C19.0825 23.9998 24.4551 18.6272 24.4551 11.9998C24.4551 5.37234 19.0825 -0.000244141 12.4551 -0.000244141C5.82766 -0.000244141 0.455078 5.37234 0.455078 11.9998C0.455078 18.6272 5.82766 23.9998 12.4551 23.9998Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1564 6.64951C12.1564 6.29053 11.8654 5.99951 11.5064 5.99951C11.1475 5.99951 10.8564 6.29053 10.8564 6.64951V13.5539C10.8564 13.7039 10.9073 13.8421 10.9927 13.9522C11.0305 14.019 11.0778 14.0798 11.1342 14.1315L15.3897 18.0282C15.6545 18.2706 16.0194 18.2179 16.2049 17.9106C16.3903 17.6032 16.326 17.1574 16.0612 16.915L12.1564 13.3395V6.64951Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1564 13.3395L16.0612 16.915C16.077 16.9294 16.092 16.9446 16.1063 16.9603C16.1506 17.0092 16.188 17.0642 16.2182 17.1233C16.3425 17.3663 16.3451 17.678 16.2049 17.9106C16.0194 18.2179 15.6545 18.2706 15.3897 18.0282L11.1342 14.1315C11.0778 14.0798 11.0305 14.019 10.9927 13.9522C10.9073 13.8421 10.8564 13.7039 10.8564 13.5539V6.64951C10.8564 6.29053 11.1475 5.99951 11.5064 5.99951C11.8654 5.99951 12.1564 6.29053 12.1564 6.64951V13.3395Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $7aa76ffc74c20c04$export$2e2bcd8739ae039 = $7aa76ffc74c20c04$var$SvgTime;




var $exYeM = parcelRequire("exYeM");

function $28575451c94002a6$var$SvgTransaction(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.72071 5.68769C1.71769 2.54635 4.26488 -0.00214142 7.40636 1.35055e-06C10.77 0.00229565 14.1336 0.0022956 17.4972 1.35055e-06C20.6387 -0.00214148 23.1856 2.5459 23.1849 5.68684C23.1845 7.86988 23.1856 9.9259 23.1869 12.0692C23.188 14.0266 23.1892 16.0568 23.1892 18.323C23.1892 18.4865 23.1242 18.6433 23.0086 18.7589L17.9483 23.8194C17.8327 23.935 17.6758 24 17.5123 24C15.9522 24 14.295 23.9993 12.6072 23.9986C10.8818 23.9979 9.1243 23.9971 7.40581 23.9971C4.26467 23.9971 1.71769 21.4485 1.72071 18.3071C1.7249 13.9398 1.7249 10.055 1.72071 5.68769ZM7.40552 1.2332C4.94605 1.23152 2.95155 3.22689 2.95391 5.68651C2.9581 10.0546 2.9581 13.9402 2.95391 18.3083C2.95155 20.7679 4.94602 22.7639 7.40583 22.7639C9.13703 22.7639 10.8892 22.7647 12.6094 22.7654C14.0722 22.766 15.5119 22.7666 16.8957 22.7668V19.5881C16.8957 18.5488 17.7382 17.7064 18.7774 17.7064H21.956C21.9558 15.6878 21.9547 13.8496 21.9537 12.0711C21.9524 9.92644 21.9513 7.8687 21.9517 5.68659C21.9522 3.22658 19.9575 1.23152 17.498 1.2332C14.1339 1.2355 10.7697 1.2355 7.40552 1.2332ZM21.084 18.9396H18.7774C18.4192 18.9396 18.1289 19.2299 18.1289 19.5881V21.8948L21.084 18.9396ZM6.7748 5.67184C6.7748 5.3313 7.05087 5.05524 7.3914 5.05524H17.5122C17.8527 5.05524 18.1288 5.3313 18.1288 5.67184C18.1288 6.01238 17.8527 6.28844 17.5122 6.28844H7.3914C7.05087 6.28844 6.7748 6.01238 6.7748 5.67184ZM6.7748 9.46718C6.7748 9.12664 7.05087 8.85058 7.3914 8.85058H17.5122C17.8527 8.85058 18.1288 9.12664 18.1288 9.46718C18.1288 9.80772 17.8527 10.0838 17.5122 10.0838H7.3914C7.05087 10.0838 6.7748 9.80772 6.7748 9.46718ZM6.7748 13.2625C6.7748 12.922 7.05087 12.6459 7.3914 12.6459H12.4518C12.7924 12.6459 13.0684 12.922 13.0684 13.2625C13.0684 13.603 12.7924 13.8791 12.4518 13.8791H7.3914C7.05087 13.8791 6.7748 13.603 6.7748 13.2625Z",
            fill: "currentColor"
        })
    }));
}
var $28575451c94002a6$export$2e2bcd8739ae039 = $28575451c94002a6$var$SvgTransaction;




var $exYeM = parcelRequire("exYeM");

function $de6be12df3b0d2d1$var$SvgTune(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 25",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.3143 10.9429C11.7029 10.9429 12.8286 9.81717 12.8286 8.42857C12.8286 7.03997 11.7029 5.91429 10.3143 5.91429C8.92568 5.91429 7.8 7.03997 7.8 8.42857C7.8 9.81717 8.92568 10.9429 10.3143 10.9429ZM10.3143 11.8571C12.2078 11.8571 13.7429 10.3221 13.7429 8.42857C13.7429 6.53502 12.2078 5 10.3143 5C8.42074 5 6.88571 6.53502 6.88571 8.42857C6.88571 10.3221 8.42074 11.8571 10.3143 11.8571Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7429 20.0857C15.1315 20.0857 16.2571 18.96 16.2571 17.5714C16.2571 16.1828 15.1315 15.0571 13.7429 15.0571C12.3543 15.0571 11.2286 16.1828 11.2286 17.5714C11.2286 18.96 12.3543 20.0857 13.7429 20.0857ZM13.7429 21C15.6364 21 17.1714 19.465 17.1714 17.5714C17.1714 15.6779 15.6364 14.1429 13.7429 14.1429C11.8493 14.1429 10.3143 15.6779 10.3143 17.5714C10.3143 19.465 11.8493 21 13.7429 21Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 8.42857C3 8.1761 3.20467 7.97143 3.45714 7.97143H6.88571C7.13819 7.97143 7.34286 8.1761 7.34286 8.42857C7.34286 8.68104 7.13819 8.88571 6.88571 8.88571H3.45714C3.20467 8.88571 3 8.68104 3 8.42857Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7143 17.5714C16.7143 17.319 16.919 17.1143 17.1714 17.1143H20.6C20.8525 17.1143 21.0571 17.319 21.0571 17.5714C21.0571 17.8239 20.8525 18.0286 20.6 18.0286H17.1714C16.919 18.0286 16.7143 17.8239 16.7143 17.5714Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.4286 8.42857C14.4286 8.1761 14.6332 7.97143 14.8857 7.97143H20.6C20.8525 7.97143 21.0571 8.1761 21.0571 8.42857C21.0571 8.68104 20.8525 8.88571 20.6 8.88571H14.8857C14.6332 8.88571 14.4286 8.68104 14.4286 8.42857Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 17.5714C3 17.319 3.20467 17.1143 3.45714 17.1143H9.17143C9.4239 17.1143 9.62857 17.319 9.62857 17.5714C9.62857 17.8239 9.4239 18.0286 9.17143 18.0286H3.45714C3.20467 18.0286 3 17.8239 3 17.5714Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $de6be12df3b0d2d1$export$2e2bcd8739ae039 = $de6be12df3b0d2d1$var$SvgTune;




var $exYeM = parcelRequire("exYeM");

function $1b41d781fbb19493$var$SvgUtxoCategory(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 29 28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 14.75,
                cy: 8,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M17.6511 7.26507C17.7689 6.47699 17.1689 6.05337 16.3485 5.77078L16.6147 4.70326L15.9648 4.54134L15.7057 5.58075C15.5349 5.53814 15.3595 5.49799 15.1851 5.45819L15.4461 4.41192L14.7966 4.25L14.5303 5.31717C14.389 5.28498 14.2501 5.25317 14.1154 5.21965L14.1162 5.21629L13.22 4.99251L13.0472 5.68657C13.0472 5.68657 13.5293 5.79709 13.5191 5.80389C13.7823 5.86957 13.8299 6.04376 13.822 6.18183L13.5188 7.39799C13.5369 7.40259 13.5604 7.40925 13.5863 7.41967C13.5647 7.41428 13.5416 7.40841 13.5177 7.40268L13.0927 9.10633C13.0605 9.18628 12.9789 9.30626 12.7949 9.2607C12.8014 9.27014 12.3226 9.14283 12.3226 9.14283L12 9.88668L12.8456 10.0975C13.003 10.1369 13.1571 10.1782 13.309 10.217L13.04 11.2968L13.6891 11.4587L13.9554 10.3904C14.1327 10.4386 14.3048 10.483 14.4733 10.5248L14.2079 11.5881L14.8577 11.75L15.1266 10.6723C16.2347 10.882 17.0679 10.7974 17.4186 9.79515C17.7012 8.98821 17.4046 8.52276 16.8216 8.21923C17.2462 8.12131 17.5658 7.84196 17.6511 7.26507ZM16.1664 9.34702C15.9655 10.154 14.6069 9.71775 14.1664 9.60837L14.5232 8.17787C14.9637 8.28784 16.3762 8.50545 16.1664 9.34702ZM16.3673 7.25338C16.1841 7.98738 15.0533 7.61447 14.6865 7.52303L15.01 6.22566C15.3768 6.3171 16.5581 6.48776 16.3673 7.25338Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 7.75,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.2203 22.2684L7.77769 20.3888L8.64617 20.1426L8.82765 19.5204L7.97212 19.7796L8.8795 16.6945V16.6453C8.87883 16.6255 8.87427 16.6061 8.86609 16.5881C8.85791 16.5701 8.84626 16.5539 8.83182 16.5404C8.81737 16.527 8.80041 16.5165 8.7819 16.5095C8.76339 16.5026 8.7437 16.4994 8.72395 16.5001H7.57029C7.52661 16.4987 7.48374 16.5121 7.4485 16.5379C7.41327 16.5637 7.38769 16.6006 7.37585 16.6427L6.29996 20.2981L5.44444 20.5574L5.25 21.1536L6.10552 20.8944L5.34074 23.4998H9.90353C9.94731 23.5016 9.9904 23.4885 10.0257 23.4626C10.0611 23.4367 10.0865 23.3995 10.098 23.3572L10.3572 22.4628V22.4136C10.3566 22.3938 10.352 22.3744 10.3438 22.3564C10.3356 22.3384 10.324 22.3222 10.3095 22.3087C10.2951 22.2953 10.2781 22.2848 10.2596 22.2778C10.2411 22.2709 10.2214 22.2677 10.2017 22.2684H7.2203Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: 21.75,
                cy: 20,
                r: 7,
                fill: "#469BF5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_9706_95224)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M24.0422 18.076C23.8054 17.3151 23.0809 17.1948 22.2192 17.2974L21.9943 16.2204L21.3388 16.3574L21.5578 17.406C21.3854 17.4419 21.21 17.4821 21.0357 17.5222L20.8154 16.4666L20.1602 16.6034L20.3848 17.6801C20.2435 17.7126 20.1047 17.7444 19.9688 17.7729L19.968 17.7695L19.0638 17.958L19.2102 18.6581C19.2102 18.6581 19.6923 18.5478 19.6861 18.5583C19.9516 18.503 20.0703 18.6391 20.1233 18.7669L20.3795 19.9938C20.3978 19.99 20.4219 19.9858 20.4497 19.9839C20.4279 19.9885 20.4046 19.9932 20.3805 19.9985L20.7392 21.7173C20.7451 21.8033 20.7238 21.9468 20.5383 21.9859C20.5483 21.9915 20.0618 22.0853 20.0618 22.0853L20.095 22.8954L20.9481 22.7172C21.1069 22.6843 21.2637 22.6543 21.4172 22.6232L21.645 23.7124L22.2998 23.5758L22.0747 22.498C22.2553 22.4642 22.4296 22.4293 22.5995 22.3937L22.8232 23.4665L23.4788 23.3295L23.2519 22.2422C24.3408 21.9488 25.0542 21.5101 24.9339 20.4551C24.8372 19.6056 24.3675 19.3156 23.7106 19.296C24.0503 19.0231 24.2164 18.6325 24.0422 18.076ZM23.6114 20.5965C23.7817 21.4105 22.3686 21.6089 21.9244 21.7021L21.6232 20.2589C22.0676 20.1662 23.4341 19.7475 23.6114 20.5965ZM22.8813 18.624C23.0357 19.3646 21.8553 19.5209 21.4852 19.5982L21.212 18.2894C21.5821 18.2121 22.7199 17.8517 22.8813 18.624Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_9706_95224",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 8,
                        height: 8,
                        fill: "white",
                        transform: "translate(16.408 18.1406) rotate(-25.7942)"
                    })
                })
            })
        ]
    }));
}
var $1b41d781fbb19493$export$2e2bcd8739ae039 = $1b41d781fbb19493$var$SvgUtxoCategory;




var $exYeM = parcelRequire("exYeM");

function $6bb2faf91f857227$var$SvgWallet(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                clipPath: "url(#clip0_3736_40081)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.8584 0.862959L15.3058 1.41525C16.9489 1.78602 18.2271 2.07447 19.2188 2.40426C20.2261 2.73925 21.004 3.13692 21.6096 3.76475C21.7414 3.9014 21.8498 4.01602 21.9385 4.11203C21.9394 4.11303 21.9403 4.11403 21.9413 4.11504C22.5067 4.5409 22.9972 5.05945 23.3914 5.64946C23.95 6.48545 24.2066 7.45716 24.3315 8.68458C24.4546 9.89445 24.4546 11.419 24.4546 13.3875V13.4584C24.4546 15.4268 24.4546 16.9514 24.3315 18.1613C24.2066 19.3887 23.95 20.3604 23.3914 21.1964C22.9312 21.8852 22.3398 22.4766 21.651 22.9369C20.815 23.4954 19.8433 23.7521 18.6159 23.8769C17.406 24 15.8814 24 13.9129 24H10.9962C9.02776 24 7.50318 24 6.29331 23.8769C5.06589 23.7521 4.09417 23.4954 3.25818 22.9369C2.56938 22.4766 1.97797 21.8852 1.51773 21.1964C0.959139 20.3604 0.702521 19.3887 0.577659 18.1613C0.504912 17.4462 0.475165 16.6211 0.463001 15.6594C0.457469 15.6262 0.45459 15.5921 0.45459 15.5573V13.5198C0.45459 13.4993 0.45459 13.4789 0.45459 13.4584V13.3875C0.45459 13.367 0.45459 13.3465 0.45459 13.3261V11.2885C0.45459 11.2538 0.457469 11.2197 0.463001 11.1865C0.475164 10.2248 0.504912 9.3997 0.577659 8.68458C0.702521 7.45716 0.959139 6.48545 1.51773 5.64946C1.85461 5.14527 2.26177 4.69328 2.72596 4.3067C3.11565 3.02447 3.55365 2.07925 4.32097 1.37775C4.84839 0.895558 5.46731 0.520025 6.14202 0.271815C6.96557 -0.0311507 7.84132 -0.0555731 8.89761 0.0751007C9.93706 0.203692 11.2152 0.492136 12.8584 0.862959ZM4.39684 3.35079C4.95892 3.15746 5.58334 3.04115 6.29331 2.96893C7.50318 2.84585 9.02777 2.84586 10.9962 2.84586H13.9129C14.7013 2.84586 15.4185 2.84586 16.0727 2.85376C15.7378 2.77698 15.3811 2.69646 15.0007 2.61061L12.6204 2.07346C10.9367 1.6935 9.7179 1.41918 8.7462 1.29897C7.7843 1.17997 7.13094 1.22202 6.56779 1.42918C6.04187 1.62266 5.56127 1.91472 5.15307 2.28791C4.85984 2.55599 4.61826 2.89086 4.39684 3.35079ZM1.68779 13.4229C1.68779 12.8782 1.68785 12.3738 1.69023 11.9051H4.6285C5.46675 11.9051 6.14629 12.5847 6.14629 13.4229C6.14629 14.2612 5.46675 14.9407 4.6285 14.9407H1.69023C1.68785 14.4721 1.68779 13.9676 1.68779 13.4229ZM1.70507 16.1739H4.6285C6.14783 16.1739 7.37949 14.9423 7.37949 13.4229C7.37949 11.9036 6.14783 10.6719 4.6285 10.6719H1.70507C1.72046 9.96264 1.74955 9.34986 1.80453 8.80939C1.91947 7.67947 2.14247 6.93418 2.5431 6.33459C2.91337 5.78044 3.38916 5.30464 3.94331 4.93437C4.5429 4.53374 5.2882 4.31074 6.41812 4.1958C7.55834 4.07981 9.02038 4.07906 11.0317 4.07906H13.8775C15.8888 4.07906 17.3508 4.07981 18.491 4.1958C19.621 4.31074 20.3663 4.53374 20.9658 4.93437C21.52 5.30464 21.9958 5.78044 22.3661 6.33459C22.7667 6.93418 22.9897 7.67947 23.1046 8.80939C23.2206 9.94961 23.2214 11.4117 23.2214 13.4229C23.2214 15.4342 23.2206 16.8963 23.1046 18.0365C22.9897 19.1664 22.7667 19.9117 22.3661 20.5113C21.9958 21.0654 21.52 21.5412 20.9658 21.9115C20.3663 22.3121 19.621 22.5351 18.491 22.6501C17.3508 22.7661 15.8888 22.7668 13.8775 22.7668H11.0317C9.02038 22.7668 7.55834 22.7661 6.41812 22.6501C5.2882 22.5351 4.5429 22.3121 3.94331 21.9115C3.38916 21.5412 2.91337 21.0654 2.5431 20.5113C2.14247 19.9117 1.91947 19.1664 1.80453 18.0365C1.74955 17.496 1.72046 16.8832 1.70507 16.1739ZM17.5297 19.1146C17.5297 18.7741 17.8058 18.498 18.1463 18.498H19.5693C19.9098 18.498 20.1859 18.7741 20.1859 19.1146C20.1859 19.4552 19.9098 19.7312 19.5693 19.7312H18.1463C17.8058 19.7312 17.5297 19.4552 17.5297 19.1146Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_3736_40081",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.45459)"
                    })
                })
            })
        ]
    }));
}
var $6bb2faf91f857227$export$2e2bcd8739ae039 = $6bb2faf91f857227$var$SvgWallet;




var $exYeM = parcelRequire("exYeM");

function $19f0b898bfde68ac$var$SvgWarning(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M22.7245 22.4863H1.73091C1.38524 22.4863 1.05369 22.3491 0.809081 22.1049C0.56447 21.8606 0.426788 21.5293 0.42627 21.1836C0.426608 20.9568 0.485203 20.7339 0.59644 20.5362L11.0923 2.15775C11.1771 2.00885 11.2905 1.87815 11.4259 1.77315C11.5614 1.66815 11.7162 1.5909 11.8816 1.54584C12.0469 1.50078 12.2195 1.48878 12.3895 1.51055C12.5595 1.53231 12.7235 1.5874 12.8722 1.67267C13.075 1.78726 13.2427 1.95497 13.3573 2.15775L23.8531 20.544C23.9681 20.7424 24.0287 20.9677 24.0288 21.197C24.0288 21.4263 23.9683 21.6516 23.8534 21.85C23.7385 22.0485 23.5733 22.2131 23.3743 22.3272C23.1754 22.4414 22.9499 22.501 22.7206 22.5L22.7245 22.4863ZM11.0394 17.7724V20.1196H13.4121V17.7724H11.0394ZM10.9201 8.14893L11.5754 16.5166H12.8644L13.5314 8.16067L10.9201 8.14893Z",
            fill: "currentColor"
        })
    }));
}
var $19f0b898bfde68ac$export$2e2bcd8739ae039 = $19f0b898bfde68ac$var$SvgWarning;




var $exYeM = parcelRequire("exYeM");

function $8f541ba59839e730$var$SvgWidget(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Icons",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Widget",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 7.76471C3 5.13323 5.13323 3 7.76471 3L16.2353 3C18.8668 3 21 5.13323 21 7.76471V16.2353C21 18.8668 18.8668 21 16.2353 21H7.76471C5.13323 21 3 18.8668 3 16.2353L3 7.76471ZM19.9412 11.4706V7.76471C19.9412 5.718 18.282 4.05882 16.2353 4.05882L10.4118 4.05882V11.4706L19.9412 11.4706ZM19.9412 12.5294V16.2353C19.9412 18.282 18.282 19.9412 16.2353 19.9412H7.76471C5.718 19.9412 4.05882 18.282 4.05882 16.2353L4.05882 12.5294L9.88235 12.5294H19.9412ZM9.35294 11.4706V4.05882L7.76471 4.05882C5.718 4.05882 4.05882 5.718 4.05882 7.76471L4.05882 11.4706L9.35294 11.4706Z",
                fill: "#727272"
            })
        })
    }));
}
var $8f541ba59839e730$export$2e2bcd8739ae039 = $8f541ba59839e730$var$SvgWidget;




var $exYeM = parcelRequire("exYeM");

function $c7fd4b2932f47a81$var$SvgWidth(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
                id: "Width",
                clipPath: "url(#clip0_5933_20072)",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    id: "Width_2",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.206748 12.0355C-0.0689161 11.8403 -0.0689161 11.5237 0.206748 11.3284L4.69896 8.14645C4.97462 7.95118 5.42156 7.95118 5.69722 8.14645C5.97289 8.34171 5.97289 8.65829 5.69722 8.85355L2.41003 11.182H21.59L18.3028 8.85355C18.0271 8.65829 18.0271 8.34171 18.3028 8.14645C18.5784 7.95118 19.0254 7.95118 19.301 8.14645L23.7933 11.3284C24.0689 11.5237 24.0689 11.8403 23.7933 12.0355L19.301 15.2175C19.0254 15.4128 18.5784 15.4128 18.3028 15.2175C18.0271 15.0223 18.0271 14.7057 18.3028 14.5104L21.59 12.182H2.41003L5.69722 14.5104C5.97289 14.7057 5.97289 15.0223 5.69722 15.2175C5.42156 15.4128 4.97462 15.4128 4.69896 15.2175L0.206748 12.0355Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("clipPath", {
                    id: "clip0_5933_20072",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white"
                    })
                })
            })
        ]
    }));
}
var $c7fd4b2932f47a81$export$2e2bcd8739ae039 = $c7fd4b2932f47a81$var$SvgWidth;




var $exYeM = parcelRequire("exYeM");

function $ae85982a21261850$var$SvgBullhorn(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Frame 1000009392",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                id: "Vector",
                d: "M11.2837 4.18222L12.8874 12.333M6.09508 13.6694L12.8219 12.3459C13.0879 12.2935 13.3626 12.3075 13.6219 12.3865L17.3842 13.5325C18.0508 13.7356 18.6933 13.1551 18.5588 12.4714L16.48 1.90558C16.3454 1.22189 15.5309 0.928099 14.9909 1.36852L11.9432 3.85445C11.7332 4.02578 11.4842 4.14277 11.2182 4.1951L4.4914 5.51863C2.24063 5.96147 0.775013 8.14508 1.21786 10.3958C1.6607 12.6466 3.84431 14.1122 6.09508 13.6694ZM5.64226 13.7585L8.02441 17.9576C8.32196 18.4822 8.92177 18.7574 9.51347 18.641C10.4518 18.4564 10.9334 17.4068 10.4616 16.575L8.54031 13.1883L5.64226 13.7585Z",
                stroke: "currentColor",
                fill: "#00000000",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    }));
}
var $ae85982a21261850$export$2e2bcd8739ae039 = $ae85982a21261850$var$SvgBullhorn;




var $exYeM = parcelRequire("exYeM");

function $5394915e3c9232d6$var$SvgChains(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M18.7249 10.2885V6.69047C18.7249 6.5286 18.6347 6.38026 18.4908 6.30582L12.199 3.0485C12.0742 2.98383 11.9256 2.98383 11.8008 3.0485L5.50897 6.30582C5.36514 6.38026 5.2749 6.5286 5.2749 6.69047V10.2885C5.2749 10.4504 5.36514 10.5988 5.50897 10.6733L8.07348 12.0002L5.50897 13.3267C5.36514 13.4012 5.2749 13.5496 5.2749 13.7115L5.27528 17.3102C5.27528 17.4721 5.36552 17.6205 5.50934 17.6948L11.8008 20.9515C11.8632 20.9838 11.9315 21 11.9999 21C12.0683 21 12.1366 20.9838 12.199 20.9515L18.4905 17.6948C18.6343 17.6205 18.7245 17.4721 18.7245 17.3102L18.7249 13.7115C18.7249 13.5496 18.6347 13.4012 18.4908 13.3267L15.9263 12.0002L18.4908 10.6733C18.6347 10.5988 18.7249 10.4504 18.7249 10.2885ZM11.9999 3.92092L17.3489 6.69011L11.9999 9.46104L6.65085 6.69011L11.9999 3.92092ZM17.8582 17.0466L11.9999 20.0791L6.14158 17.0466L6.14127 14.4237L11.8006 17.3553C11.8632 17.3876 11.9315 17.4038 11.9999 17.4038C12.0683 17.4038 12.1366 17.3876 12.1992 17.3553L17.8585 14.4237L17.8582 17.0466ZM17.3495 13.7117L11.9999 16.4828L6.65034 13.7117L9.01624 12.488L11.8008 13.9287C11.8632 13.9609 11.9317 13.9771 11.9999 13.9771C12.0681 13.9771 12.1366 13.9609 12.199 13.9287L14.9836 12.488L17.3495 13.7117ZM17.8586 10.0249L11.9999 13.0563L6.14121 10.0249V7.40188L11.8006 10.3336C11.8632 10.3659 11.9315 10.3821 11.9999 10.3821C12.0683 10.3821 12.1366 10.3659 12.1992 10.3336L17.8586 7.40188V10.0249Z",
            fill: "#727272"
        })
    }));
}
var $5394915e3c9232d6$export$2e2bcd8739ae039 = $5394915e3c9232d6$var$SvgChains;




var $exYeM = parcelRequire("exYeM");

function $0456abd8e455d9cd$var$SvgChart(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.32065 2.32065C3.74249 0.898821 5.88475 0.339844 8.69984 0.339844H15.2998C18.1149 0.339844 20.2572 0.898821 21.679 2.32065C23.1009 3.74249 23.6598 5.88475 23.6598 8.69984V15.2998C23.6598 18.1149 23.1009 20.2572 21.679 21.679C20.2572 23.1009 18.1149 23.6598 15.2998 23.6598H8.69984C5.88475 23.6598 3.74249 23.1009 2.32065 21.679C0.898821 20.2572 0.339844 18.1149 0.339844 15.2998V8.69984C0.339844 5.88475 0.898821 3.74249 2.32065 2.32065ZM3.25403 3.25403C2.20087 4.3072 1.65984 6.01494 1.65984 8.69984V15.2998C1.65984 17.9847 2.20087 19.6925 3.25403 20.7457C4.3072 21.7988 6.01494 22.3398 8.69984 22.3398H15.2998C17.9847 22.3398 19.6925 21.7988 20.7457 20.7457C21.7988 19.6925 22.3398 17.9847 22.3398 15.2998V8.69984C22.3398 6.01494 21.7988 4.3072 20.7457 3.25403C19.6925 2.20087 17.9847 1.65984 15.2998 1.65984H8.69984C6.01494 1.65984 4.3072 2.20087 3.25403 3.25403ZM11.9998 8.03984C12.3644 8.03984 12.6598 8.33534 12.6598 8.69984V16.0478C12.6598 16.4124 12.3644 16.7078 11.9998 16.7078C11.6353 16.7078 11.3398 16.4124 11.3398 16.0478V8.69984C11.3398 8.33534 11.6353 8.03984 11.9998 8.03984ZM6.49984 9.95384C6.86435 9.95384 7.15984 10.2493 7.15984 10.6138V14.1338C7.15984 14.4984 6.86435 14.7938 6.49984 14.7938C6.13534 14.7938 5.83984 14.4984 5.83984 14.1338V10.6138C5.83984 10.2493 6.13534 9.95384 6.49984 9.95384ZM17.4998 9.95384C17.8644 9.95384 18.1598 10.2493 18.1598 10.6138V14.1338C18.1598 14.4984 17.8644 14.7938 17.4998 14.7938C17.1353 14.7938 16.8398 14.4984 16.8398 14.1338V10.6138C16.8398 10.2493 17.1353 9.95384 17.4998 9.95384Z",
            fill: "currentColor"
        })
    }));
}
var $0456abd8e455d9cd$export$2e2bcd8739ae039 = $0456abd8e455d9cd$var$SvgChart;




var $exYeM = parcelRequire("exYeM");

function $97af6e06fe4ac8e7$var$SvgColors(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.49068 9.35508C5.80086 9.27081 6.12485 9.43296 6.24334 9.73176C6.95508 11.5267 8.48265 12.9097 10.3699 13.4254L10.3738 13.4264C10.8831 13.569 11.428 13.6418 11.9996 13.6418C12.5713 13.6418 13.1162 13.569 13.6255 13.4264C13.9367 13.3393 14.2635 13.5012 14.3828 13.8015C14.7188 14.6478 14.9048 15.5795 14.9048 16.5471C14.9048 18.7443 13.949 20.7327 12.421 22.0881C11.1043 23.2795 9.36406 24 7.45241 24C3.34076 24 0 20.659 0 16.5471C0 13.1174 2.33477 10.2125 5.49068 9.35508ZM5.30898 10.7382C2.95349 11.6086 1.26312 13.8904 1.26312 16.5471C1.26312 19.9614 4.03839 22.7368 7.45241 22.7368C9.04089 22.7368 10.4827 22.1394 11.5757 21.1495L11.5807 21.1449C12.8479 20.0219 13.6417 18.3733 13.6417 16.5471C13.6417 15.9326 13.5516 15.3369 13.3856 14.7783C12.9358 14.8631 12.4723 14.9049 11.9996 14.9049C11.3215 14.9049 10.6621 14.8187 10.0351 14.6433C7.95605 14.0747 6.24187 12.6339 5.30898 10.7382Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.9991 1.26318C8.58512 1.26318 5.80986 4.0386 5.80986 7.45288C5.80986 8.25876 5.96545 9.03186 6.24334 9.73176C6.95508 11.5267 8.48265 12.9097 10.3699 13.4254L10.3738 13.4264C10.8831 13.569 11.428 13.6418 11.9996 13.6418C12.5713 13.6418 13.1162 13.569 13.6255 13.4264L13.6288 13.4261C15.5161 12.9105 17.0437 11.5275 17.7555 9.73257C18.0333 9.03266 18.1884 8.25876 18.1884 7.45288C18.1884 4.0386 15.4132 1.26318 11.9991 1.26318ZM4.54674 7.45288C4.54674 3.34099 7.8875 0 11.9991 0C16.1108 0 19.4516 3.34099 19.4516 7.45288C19.4516 8.42052 19.2655 9.3522 18.9295 10.1985C18.0727 12.3591 16.2361 14.0226 13.9637 14.6441C13.3367 14.8195 12.6778 14.9049 11.9996 14.9049C11.3215 14.9049 10.6621 14.8187 10.0351 14.6433C7.76264 14.0218 5.92563 12.3591 5.06877 10.1985M4.54674 7.45288C4.54674 8.42043 4.73285 9.35227 5.06877 10.1985L4.54674 7.45288Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.7567 9.73176C17.8751 9.43296 18.1991 9.27081 18.5093 9.35508C21.6652 10.2125 24 13.1174 24 16.5471C24 20.659 20.6592 24 16.5476 24C14.6347 24 12.8934 23.2786 11.5764 22.0857C11.4433 21.9652 11.3678 21.7937 11.3688 21.6142C11.3698 21.4347 11.4464 21.264 11.5807 21.1449C12.8479 20.0219 13.6417 18.3733 13.6417 16.5471C13.6417 15.7412 13.4874 14.9676 13.2095 14.2677C13.1432 14.1007 13.1512 13.9133 13.2315 13.7525C13.3117 13.5917 13.4567 13.4727 13.6301 13.4254C15.5173 12.9097 17.0449 11.5267 17.7567 9.73176ZM18.691 10.7382C17.8554 12.4363 16.3929 13.7693 14.6027 14.4375C14.7994 15.106 14.9048 15.8163 14.9048 16.5471C14.9048 18.4806 14.1654 20.2523 12.9466 21.5733C13.9594 22.3074 15.2008 22.7368 16.5476 22.7368C19.9616 22.7368 22.7369 19.9614 22.7369 16.5471C22.7369 13.8904 21.0465 11.6086 18.691 10.7382Z",
                fill: "currentColor"
            })
        ]
    }));
}
var $97af6e06fe4ac8e7$export$2e2bcd8739ae039 = $97af6e06fe4ac8e7$var$SvgColors;




var $exYeM = parcelRequire("exYeM");

function $d390336006c1e40d$var$SvgDiscord(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.899 2.27191C15.0314 2.01005 15.312 1.8574 15.6037 1.88852C17.4166 2.08189 19.3694 2.48267 21.2253 3.77553C21.3465 3.85999 21.4382 3.98039 21.4874 4.11973C22.6789 7.49582 23.3304 10.4412 23.5822 12.8075C23.831 15.1462 23.6985 17.0009 23.2414 18.1433C23.2341 18.1615 23.2261 18.1794 23.2173 18.1969C22.7981 19.0347 22.1662 19.9871 21.3855 20.7411C20.6151 21.485 19.6146 22.1155 18.4694 22.1155C18.1899 22.1155 17.9568 21.9886 17.8202 21.9015C17.6623 21.8009 17.5077 21.6704 17.3642 21.5322C17.0752 21.2538 16.7706 20.8856 16.4945 20.4912C16.2176 20.0956 15.955 19.6532 15.7588 19.2196C15.6653 19.0127 15.5791 18.7913 15.516 18.5666C13.1328 18.9857 10.8676 18.9857 8.48444 18.5666C8.4213 18.7913 8.33515 19.0127 8.24158 19.2196C8.04541 19.6532 7.78287 20.0956 7.50593 20.4912C7.22987 20.8856 6.92526 21.2538 6.63621 21.5322C6.49268 21.6704 6.33812 21.8009 6.18025 21.9015C6.04365 21.9886 5.81054 22.1155 5.53101 22.1155C4.38587 22.1155 3.3853 21.485 2.61497 20.7411C1.83422 19.9871 1.2023 19.0347 0.783111 18.1969C0.774337 18.1794 0.766298 18.1615 0.759014 18.1433C0.30194 17.0009 0.169411 15.1462 0.418271 12.8075C0.670063 10.4412 1.32158 7.49582 2.51307 4.11973C2.56225 3.98039 2.65392 3.85999 2.77517 3.77553C4.63103 2.48267 6.58386 2.08189 8.3967 1.88852C8.68814 1.85743 8.96846 2.00972 9.101 2.27113L10.0165 4.07672C11.3338 3.89737 12.6694 3.89734 13.9868 4.07663L14.899 2.27191ZM7.09691 18.2788C6.71076 18.1869 6.32052 18.0845 5.92524 17.9716C5.55047 17.8645 5.33346 17.4739 5.44054 17.0991C5.54762 16.7244 5.93823 16.5074 6.313 16.6144C10.303 17.7544 13.6974 17.7544 17.6874 16.6144C18.0622 16.5074 18.4528 16.7244 18.5599 17.0991C18.667 17.4739 18.45 17.8645 18.0752 17.9716C17.6799 18.0845 17.2897 18.1869 16.9035 18.2788C16.9379 18.3842 16.9844 18.5042 17.0448 18.6378C17.1979 18.9761 17.4132 19.3423 17.6508 19.6818C17.8894 20.0226 18.1361 20.316 18.3433 20.5155C18.4381 20.6068 18.5125 20.6667 18.5638 20.7014C19.1559 20.6679 19.7871 20.3224 20.405 19.7257C21.0374 19.115 21.5762 18.3156 21.9413 17.5926C22.2618 16.7669 22.4174 15.2007 22.1786 12.9569C21.9455 10.7663 21.3448 8.00484 20.233 4.80813C18.8635 3.90803 17.4168 3.54109 15.9362 3.34881L15.0154 5.1705C14.8755 5.44734 14.5712 5.60035 14.2655 5.54759C12.7676 5.289 11.2364 5.289 9.73842 5.54759C9.43307 5.6003 9.12905 5.44766 8.98892 5.17128L8.06485 3.34872C6.58406 3.54098 5.13715 3.9079 3.76746 4.80813C2.65563 8.00484 2.05491 10.7663 1.82181 12.9569C1.58305 15.2007 1.73862 16.7669 2.05908 17.5926C2.42427 18.3156 2.96299 19.115 3.59544 19.7257C4.21334 20.3224 4.84451 20.6679 5.43667 20.7014C5.4879 20.6667 5.56232 20.6068 5.65716 20.5155C5.86433 20.316 6.11107 20.0226 6.34961 19.6818C6.58726 19.3423 6.80256 18.9761 6.95558 18.6378C7.01604 18.5042 7.0625 18.3842 7.09691 18.2788ZM5.38821 20.73C5.38826 20.7298 5.39117 20.7283 5.39677 20.726C5.39096 20.7291 5.38815 20.7303 5.38821 20.73ZM18.6122 20.73C18.6122 20.7302 18.6094 20.7291 18.6037 20.726C18.6093 20.7283 18.6122 20.7298 18.6122 20.73ZM7.14082 10.6693C7.49375 10.3163 7.97243 10.1181 8.47156 10.1181C8.97068 10.1181 9.44936 10.3163 9.8023 10.6693C10.1552 11.0222 10.3535 11.5009 10.3535 12C10.3535 12.4991 10.1552 12.9778 9.8023 13.3308C9.44936 13.6837 8.97068 13.882 8.47156 13.882C7.97243 13.882 7.49375 13.6837 7.14082 13.3308C6.78788 12.9778 6.58961 12.4991 6.58961 12C6.58961 11.5009 6.78788 11.0222 7.14082 10.6693ZM8.47156 11.5295C8.34678 11.5295 8.22711 11.5791 8.13887 11.6673C8.05064 11.7556 8.00107 11.8752 8.00107 12C8.00107 12.1248 8.05064 12.2445 8.13887 12.3327C8.22711 12.4209 8.34678 12.4705 8.47156 12.4705C8.59634 12.4705 8.71601 12.4209 8.80424 12.3327C8.89248 12.2445 8.94204 12.1248 8.94204 12C8.94204 11.8752 8.89248 11.7556 8.80424 11.6673C8.71601 11.5791 8.59634 11.5295 8.47156 11.5295ZM14.1981 10.6693C14.5511 10.3163 15.0297 10.1181 15.5289 10.1181C16.028 10.1181 16.5067 10.3163 16.8596 10.6693C17.2125 11.0222 17.4108 11.5009 17.4108 12C17.4108 12.4991 17.2125 12.9778 16.8596 13.3308C16.5067 13.6837 16.028 13.882 15.5289 13.882C15.0297 13.882 14.5511 13.6837 14.1981 13.3308C13.8452 12.9778 13.6469 12.4991 13.6469 12C13.6469 11.5009 13.8452 11.0222 14.1981 10.6693ZM15.5289 11.5295C15.4041 11.5295 15.2844 11.5791 15.1962 11.6673C15.108 11.7556 15.0584 11.8752 15.0584 12C15.0584 12.1248 15.108 12.2445 15.1962 12.3327C15.2844 12.4209 15.4041 12.4705 15.5289 12.4705C15.6537 12.4705 15.7733 12.4209 15.8616 12.3327C15.9498 12.2445 15.9994 12.1248 15.9994 12C15.9994 11.8752 15.9498 11.7556 15.8616 11.6673C15.7733 11.5791 15.6537 11.5295 15.5289 11.5295Z",
            fill: "currentColor"
        })
    }));
}
var $d390336006c1e40d$export$2e2bcd8739ae039 = $d390336006c1e40d$var$SvgDiscord;




var $exYeM = parcelRequire("exYeM");

function $38a65c022741f4d2$var$SvgInfinity(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.20889 5.83725C4.57975 5.83725 3.97637 6.08718 3.53149 6.53205C3.08662 6.97692 2.83669 7.5803 2.83669 8.20945C2.83669 8.8386 3.08662 9.44198 3.53149 9.88685C3.97637 10.3317 4.57975 10.5817 5.20889 10.5817C5.54212 10.5817 5.79218 10.5219 5.99423 10.4231C6.19629 10.3249 6.37323 10.1764 6.54458 9.96767C6.84599 9.59928 7.09326 9.09805 7.41923 8.43774C7.48453 8.30546 7.55319 8.16703 7.62575 8.02247L7.81553 7.63733C8.13982 6.97814 8.439 6.3703 8.80739 5.92097C9.03623 5.64133 9.30415 5.40579 9.63905 5.2428C9.97395 5.07982 10.3535 5 10.7905 5C11.2991 5 11.8004 5.12085 12.253 5.35258C12.7057 5.58431 13.0968 5.9203 13.3942 6.33285C13.6915 6.7454 13.8866 7.22271 13.9633 7.72544C14.04 8.22817 13.9961 8.74192 13.8353 9.22437C13.6745 9.70682 13.4013 10.1441 13.0383 10.5003C12.6753 10.8565 12.2329 11.1213 11.7475 11.2729C11.2621 11.4245 10.7476 11.4587 10.2464 11.3724C9.74523 11.2862 9.27171 11.0821 8.86488 10.777C8.77606 10.7104 8.71734 10.6112 8.70164 10.5013C8.68593 10.3914 8.71454 10.2798 8.78115 10.1909C8.84777 10.1021 8.94694 10.0434 9.05685 10.0277C9.16676 10.012 9.27841 10.0406 9.36723 10.1072C9.66793 10.3327 10.0179 10.4836 10.3884 10.5473C10.7588 10.611 11.1391 10.5858 11.4979 10.4738C11.8566 10.3617 12.1837 10.1659 12.452 9.90269C12.7203 9.63944 12.9222 9.3162 13.041 8.95961C13.1599 8.60302 13.1923 8.22328 13.1356 7.8517C13.0789 7.48012 12.9348 7.12733 12.715 6.8224C12.4952 6.51747 12.2061 6.26913 11.8715 6.09785C11.5369 5.92657 11.1664 5.83725 10.7905 5.83725C10.4573 5.83725 10.2073 5.89697 10.0052 5.99577C9.80315 6.094 9.62621 6.24248 9.45486 6.45123C9.15345 6.81962 8.90618 7.32085 8.58021 7.98116C8.51491 8.11345 8.44625 8.25187 8.37369 8.39644L8.18392 8.78157C7.85962 9.44076 7.56044 10.0486 7.19206 10.4985C6.96321 10.7776 6.69529 11.0131 6.36039 11.1761C6.02549 11.3391 5.64594 11.4189 5.20889 11.4189C4.70037 11.4188 4.19915 11.2979 3.74653 11.0661C3.29391 10.8343 2.90285 10.4983 2.60556 10.0857C2.30828 9.67314 2.11329 9.19583 2.03665 8.69312C1.96002 8.19041 2.00394 7.67668 2.16479 7.19427C2.32564 6.71186 2.59882 6.27457 2.96181 5.91845C3.32481 5.56232 3.76723 5.29755 4.25263 5.14595C4.73803 4.99434 5.2525 4.96025 5.75366 5.04648C6.25481 5.1327 6.72831 5.33678 7.13512 5.64189C7.1791 5.67491 7.21615 5.71627 7.24414 5.76361C7.27214 5.81095 7.29053 5.86334 7.29828 5.91778C7.30603 5.97223 7.30298 6.02767 7.2893 6.08094C7.27562 6.13421 7.25159 6.18426 7.21857 6.22824C7.18555 6.27222 7.14419 6.30927 7.09685 6.33726C7.04951 6.36526 6.99712 6.38366 6.94267 6.3914C6.88823 6.39915 6.83279 6.3961 6.77952 6.38242C6.72625 6.36875 6.6762 6.34471 6.63222 6.31169C6.22202 6.00293 5.72231 5.83636 5.20889 5.83725Z",
            fill: "currentColor"
        })
    }));
}
var $38a65c022741f4d2$export$2e2bcd8739ae039 = $38a65c022741f4d2$var$SvgInfinity;




var $exYeM = parcelRequire("exYeM");

function $f35c0bf2103f6461$var$SvgKey(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 12 13",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
            id: "key",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    id: "Vector",
                    d: "M3.26028 12.4995C3.20753 12.4995 3.1495 12.4942 3.10203 12.489L1.95736 12.3307C1.40876 12.2569 0.912912 11.7663 0.828513 11.2072L0.670263 10.052C0.617513 9.68278 0.775763 9.20278 1.03951 8.93377L3.35523 6.61815C2.98071 5.12011 3.41325 3.53768 4.51573 2.44581C6.22482 0.742057 9.00473 0.736782 10.7191 2.44581C11.5473 3.27394 12.0009 4.37637 12.0009 5.54737C12.0009 6.71837 11.5473 7.82079 10.7191 8.64893C9.61136 9.74608 8.03414 10.1786 6.54659 9.79883L4.2256 12.1144C4.00405 12.3465 3.60843 12.4995 3.26028 12.4995ZM7.61214 1.95525C6.68902 1.95525 5.77117 2.30339 5.0696 3.00493C4.1201 3.94911 3.77723 5.3311 4.17285 6.61815C4.21505 6.76056 4.17813 6.90826 4.07263 7.01375L1.59338 9.49289C1.50371 9.58256 1.42986 9.81465 1.44569 9.93597L1.60393 11.0911C1.63558 11.2916 1.85186 11.5184 2.05231 11.5448L3.20225 11.703C3.32885 11.7241 3.56095 11.6503 3.65063 11.5606L6.14042 9.07619C6.24592 8.97069 6.39889 8.93904 6.53604 8.98124C7.80731 9.38212 9.19463 9.03926 10.1441 8.0898C10.8193 7.41463 11.1939 6.50737 11.1939 5.54737C11.1939 4.58209 10.8193 3.6801 10.1441 3.00493C9.45838 2.30866 8.53526 1.95525 7.61214 1.95525Z",
                    fill: "#727272"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    id: "Vector_2",
                    d: "M4.84974 11.3351C4.74951 11.3351 4.64929 11.2982 4.57016 11.2191L3.35692 10.0059C3.20394 9.85291 3.20394 9.59973 3.35692 9.44676C3.50989 9.29379 3.76309 9.29379 3.91607 9.44676L5.12931 10.66C5.28229 10.8129 5.28229 11.0661 5.12931 11.2191C5.05019 11.2982 4.94996 11.3351 4.84974 11.3351Z",
                    fill: "#727272"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    id: "Vector_3",
                    d: "M7.64781 6.69786C6.99371 6.69786 6.46094 6.16511 6.46094 5.51104C6.46094 4.85697 6.99371 4.32422 7.64781 4.32422C8.30191 4.32422 8.83468 4.85697 8.83468 5.51104C8.83468 6.16511 8.30191 6.69786 7.64781 6.69786ZM7.64781 5.11543C7.43153 5.11543 7.25218 5.29478 7.25218 5.51104C7.25218 5.72731 7.43153 5.90665 7.64781 5.90665C7.86408 5.90665 8.04343 5.72731 8.04343 5.51104C8.04343 5.29478 7.86408 5.11543 7.64781 5.11543Z",
                    fill: "#727272"
                })
            ]
        })
    }));
}
var $f35c0bf2103f6461$export$2e2bcd8739ae039 = $f35c0bf2103f6461$var$SvgKey;




var $exYeM = parcelRequire("exYeM");

function $263cbcf8dd6e17c9$var$SvgMedium(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.7826 9.2168C8.98375 9.2168 7.25857 9.93139 5.98658 11.2034C4.71459 12.4754 4 14.2005 4 15.9994C4 17.7983 4.71459 19.5234 5.98658 20.7954C7.25857 22.0674 8.98375 22.782 10.7826 22.782C12.5815 22.782 14.3067 22.0674 15.5786 20.7954C16.8506 19.5234 17.5652 17.7983 17.5652 15.9994C17.5652 14.2005 16.8506 12.4754 15.5786 11.2034C14.3067 9.93139 12.5815 9.2168 10.7826 9.2168ZM21.4783 9.73854C19.6052 9.73854 18.087 12.5418 18.087 15.9994C18.087 16.6479 18.1402 17.273 18.2393 17.861C18.3713 18.6451 18.5847 19.3631 18.8612 19.9818C18.9995 20.2912 19.1534 20.5756 19.3209 20.8307C19.6558 21.341 20.045 21.7349 20.4697 21.9791C20.7885 22.1617 21.1271 22.2603 21.4783 22.2603C21.8294 22.2603 22.168 22.1617 22.4868 21.9791C22.9115 21.7349 23.3007 21.341 23.6357 20.8307C23.8031 20.5756 23.957 20.2912 24.0953 19.9818C24.3718 19.3636 24.5852 18.6451 24.7172 17.861C24.8163 17.273 24.8696 16.6479 24.8696 15.9994C24.8696 12.5418 23.3513 9.73854 21.4783 9.73854ZM26.6957 10.2603C26.5605 10.2603 26.4301 10.3505 26.308 10.5185C26.2261 10.6302 26.1478 10.7763 26.0743 10.9531C26.0372 11.0413 26.0012 11.1373 25.9668 11.2406C25.8974 11.4467 25.8327 11.682 25.7737 11.9413C25.6558 12.4604 25.5603 13.0792 25.4941 13.7658C25.4612 14.1091 25.4357 14.4697 25.4179 14.8432C25.4002 15.2163 25.3913 15.6034 25.3913 15.9994C25.3913 16.3954 25.4002 16.7825 25.4179 17.1561C25.4351 17.5297 25.4607 17.8902 25.4941 18.2335C25.5603 18.9201 25.6558 19.5384 25.7737 20.058C25.8327 20.3178 25.8974 20.5526 25.9668 20.7587C26.0012 20.862 26.0372 20.958 26.0743 21.0462C26.1483 21.2231 26.2266 21.3691 26.308 21.4808C26.4301 21.6483 26.5605 21.7385 26.6957 21.7385C27.4162 21.7385 28 19.169 28 15.9994C28 12.8298 27.4162 10.2603 26.6957 10.2603Z",
            fill: "currentColor"
        })
    }));
}
var $263cbcf8dd6e17c9$export$2e2bcd8739ae039 = $263cbcf8dd6e17c9$var$SvgMedium;




var $exYeM = parcelRequire("exYeM");

function $59dc5f42ec7031c1$var$SvgSettings(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.50467 2.93423C8.50467 1.50705 9.66162 0.350098 11.0888 0.350098H13.8205C15.2477 0.350098 16.4047 1.50706 16.4047 2.93424C16.4047 3.92275 17.4748 4.5406 18.3309 4.04632C19.5669 3.33272 21.1474 3.75618 21.861 4.99218L23.2268 7.35787C23.9404 8.59386 23.5169 10.1743 22.2809 10.8879C21.4248 11.3822 21.4248 12.6179 22.2809 13.1121C23.5169 13.8257 23.9404 15.4062 23.2268 16.6422L21.861 19.0079C21.1474 20.2439 19.5669 20.6673 18.3309 19.9537C17.4748 19.4595 16.4047 20.0773 16.4047 21.0659C16.4047 22.4931 15.2477 23.6501 13.8205 23.6501H11.0889C9.66164 23.6501 8.50467 22.4931 8.50467 21.0659C8.50467 20.0773 7.43452 19.4595 6.57844 19.9537C5.34246 20.6673 3.76202 20.2439 3.04842 19.0079L1.68258 16.6422C0.968984 15.4062 1.39246 13.8257 2.62845 13.1121C3.48456 12.6179 3.48456 11.3822 2.62845 10.8879C1.39247 10.1743 0.968985 8.59386 1.68258 7.35787L3.04842 4.99216C3.76202 3.75618 5.34248 3.33271 6.57845 4.0463C7.43455 4.54057 8.50467 3.92274 8.50467 2.93423ZM11.0888 1.6501C10.3796 1.6501 9.80467 2.22502 9.80467 2.93423C9.80467 4.92351 7.65119 6.16676 5.92845 5.17214C5.31425 4.81752 4.52886 5.02797 4.17426 5.64216L2.80842 8.00787C2.4538 8.62208 2.66425 9.40746 3.27845 9.76207C5.00123 10.7567 5.00123 13.2433 3.27845 14.238C2.66424 14.5926 2.4538 15.378 2.80841 15.9922L4.17426 18.3579C4.52886 18.9721 5.31424 19.1825 5.92844 18.8279C7.65123 17.8333 9.80467 19.0766 9.80467 21.0659C9.80467 21.7751 10.3796 22.3501 11.0889 22.3501H13.8205C14.5297 22.3501 15.1047 21.7751 15.1047 21.0659C15.1047 19.0766 17.2581 17.8332 18.9809 18.8279C19.5951 19.1825 20.3805 18.9721 20.7351 18.3579L22.101 15.9922C22.4556 15.378 22.2451 14.5926 21.6309 14.238C19.9082 13.2433 19.9082 10.7567 21.6309 9.76207C22.2451 9.40746 22.4556 8.62208 22.101 8.00787L20.7351 5.64218C20.3805 5.02798 19.5951 4.81753 18.9809 5.17215C17.2582 6.16678 15.1047 4.92353 15.1047 2.93424C15.1047 2.22503 14.5297 1.6501 13.8205 1.6501H11.0888ZM12.4547 8.2501C10.3836 8.2501 8.70467 9.92903 8.70467 12.0001C8.70467 14.0712 10.3836 15.7501 12.4547 15.7501C14.5257 15.7501 16.2047 14.0712 16.2047 12.0001C16.2047 9.92903 14.5257 8.2501 12.4547 8.2501ZM7.40467 12.0001C7.40467 9.21106 9.66563 6.9501 12.4547 6.9501C15.2437 6.9501 17.5047 9.21106 17.5047 12.0001C17.5047 14.7891 15.2437 17.0501 12.4547 17.0501C9.66563 17.0501 7.40467 14.7891 7.40467 12.0001Z",
            fill: "currentColor"
        })
    }));
}
var $59dc5f42ec7031c1$export$2e2bcd8739ae039 = $59dc5f42ec7031c1$var$SvgSettings;




var $exYeM = parcelRequire("exYeM");

function $9b5df8bfcf13dff0$var$SvgStyle(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("g", {
            id: "Style",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.12348 3.15363C4.43468 1.84244 6.40414 1.33337 8.96989 1.33337H10.9699C11.3381 1.33337 11.6366 1.63185 11.6366 2.00004C11.6366 2.36823 11.3381 2.6667 10.9699 2.6667H8.96989C6.53564 2.6667 5.0051 3.15763 4.06629 4.09644C3.12749 5.03525 2.63656 6.56579 2.63656 9.00004V15C2.63656 17.4343 3.12749 18.9648 4.06629 19.9036C5.0051 20.8424 6.53564 21.3334 8.96989 21.3334H14.9699C17.4041 21.3334 18.9347 20.8424 19.8735 19.9036C20.8123 18.9648 21.3032 17.4343 21.3032 15V13C21.3032 12.6318 21.6017 12.3334 21.9699 12.3334C22.3381 12.3334 22.6366 12.6318 22.6366 13V15C22.6366 17.5658 22.1275 19.5352 20.8163 20.8464C19.5051 22.1576 17.5356 22.6667 14.9699 22.6667H8.96989C6.40414 22.6667 4.43468 22.1576 3.12348 20.8464C1.81229 19.5352 1.30322 17.5658 1.30322 15V9.00004C1.30322 6.43428 1.81229 4.46483 3.12348 3.15363Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.6533 2.70122C19.1946 3.28847 17.4352 4.33801 15.7767 5.56928C14.1164 6.80192 12.599 8.18569 11.6112 9.41666C11.611 9.41693 11.6108 9.41719 11.6106 9.41746L10.5735 10.7179C11.1923 10.8971 11.7777 11.2353 12.2798 11.7366C12.7724 12.2208 13.1029 12.7819 13.2804 13.3834L14.5634 12.3603C14.5631 12.3605 14.5636 12.3601 14.5634 12.3603C15.794 11.3727 17.1734 9.85753 18.4009 8.19869C19.6287 6.53961 20.6747 4.77756 21.2617 3.31231L21.2625 3.3104C21.342 3.11383 21.2901 2.93258 21.1592 2.80166C21.0422 2.68463 20.858 2.62459 20.6533 2.70122ZM12.0795 14.126C12.0087 13.6037 11.7766 13.111 11.3436 12.686L11.3392 12.6817C10.8986 12.2411 10.3815 11.9985 9.85474 11.9241C9.70039 11.9146 9.58818 11.909 9.48218 11.9156C9.25816 11.9296 9.04212 11.83 8.90739 11.6504C8.77266 11.4709 8.73731 11.2356 8.81333 11.0244C8.92575 10.7122 9.09202 10.4104 9.3202 10.151L10.5694 8.5846L10.5706 8.58306C11.6528 7.23423 13.2651 5.77332 14.9819 4.49873C16.6987 3.22417 18.5618 2.1049 20.162 1.46169L20.1721 1.4576C20.9057 1.17667 21.6398 1.39669 22.102 1.85885C22.5709 2.32773 22.799 3.06605 22.4991 3.80916C21.856 5.4137 20.7423 7.27624 19.4727 8.99182C18.203 10.7076 16.7469 12.3178 15.3978 13.4002L15.3963 13.4015L13.8162 14.6615L13.8006 14.6736C13.5646 14.8505 13.3122 15.0042 13.0135 15.1211C12.8083 15.2014 12.5767 15.1751 12.3948 15.0509C12.2128 14.9267 12.1039 14.7206 12.1039 14.5003C12.1039 14.3817 12.0961 14.2604 12.0795 14.126Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.8644 11.9144C9.71005 11.9048 9.59784 11.8992 9.49184 11.9059C9.48226 11.9065 9.47267 11.9069 9.46307 11.9071C8.20229 11.9313 7.05337 12.8306 6.9031 14.2118C6.90307 14.2121 6.90312 14.2116 6.9031 14.2118L6.69317 16.1812L6.69292 16.1835C6.61951 16.8502 7.18196 17.4002 7.82596 17.328L7.82959 17.3276L9.79274 17.1183C10.4333 17.0359 10.9538 16.7633 11.337 16.3809C11.8429 15.866 12.1136 15.1948 12.1136 14.4905C12.1136 14.381 12.1057 14.2498 12.0891 14.1163C12.0188 13.5976 11.7885 13.1116 11.3489 12.6719C10.9082 12.2313 10.3912 11.9887 9.8644 11.9144ZM9.95752 10.5842C9.96234 10.5845 9.96712 10.5848 9.97184 10.5851C9.98719 10.5861 10.0025 10.5876 10.0177 10.5896C10.8435 10.6989 11.6383 11.0757 12.2917 11.7291C12.9311 12.3686 13.3008 13.1215 13.411 13.9418L13.4118 13.9478C13.435 14.1332 13.4469 14.3209 13.4469 14.4905C13.4469 15.5453 13.0383 16.5533 12.2854 17.3182L12.2817 17.3219C11.6862 17.9174 10.8895 18.3235 9.95398 18.4419L9.94094 18.4435L7.97251 18.6532C6.4778 18.8196 5.20177 17.5508 5.36746 16.0388C5.36741 16.0392 5.3675 16.0384 5.36746 16.0388L5.57735 14.0698C5.80677 11.9567 7.56956 10.6164 9.42348 10.5743C9.62029 10.5631 9.81008 10.575 9.95752 10.5842Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.3638 8.19047C11.3638 7.82228 11.6622 7.5238 12.0304 7.5238C14.4998 7.5238 16.4871 9.52342 16.4871 11.9805C16.4871 12.3487 16.1886 12.6471 15.8204 12.6471C15.4522 12.6471 15.1538 12.3487 15.1538 11.9805C15.1538 10.2575 13.7611 8.85713 12.0304 8.85713C11.6622 8.85713 11.3638 8.55866 11.3638 8.19047Z",
                        fill: "currentColor"
                    })
                ]
            })
        })
    }));
}
var $9b5df8bfcf13dff0$export$2e2bcd8739ae039 = $9b5df8bfcf13dff0$var$SvgStyle;




var $exYeM = parcelRequire("exYeM");

function $3e8679eefce5a28f$var$SvgTelegram(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M27.5468 4.97762C27.1374 4.61721 26.4944 4.56565 25.8295 4.84275H25.8285C25.1292 5.13402 6.03537 13.6363 5.25808 13.9837C5.11671 14.0347 3.88199 14.5129 4.00918 15.5783C4.12271 16.5388 5.11507 16.9366 5.23625 16.9825L10.0905 18.708C10.4125 19.8209 11.5998 23.927 11.8623 24.8042C12.0261 25.351 12.293 26.0696 12.7608 26.2175C13.1713 26.3818 13.5796 26.2316 13.8438 26.0163L16.8116 23.1586L21.6025 27.0375L21.7166 27.1083C22.0419 27.2579 22.3536 27.3327 22.6511 27.3327C22.8809 27.3327 23.1014 27.2879 23.3121 27.1984C24.0299 26.8924 24.317 26.1823 24.347 26.1019L27.9256 6.79152C28.144 5.76019 27.8405 5.23545 27.5468 4.97762ZM14.3716 19.3982L12.734 23.9315L11.0965 18.2649L23.6511 8.63149L14.3716 19.3982Z",
            fill: "currentColor"
        })
    }));
}
var $3e8679eefce5a28f$export$2e2bcd8739ae039 = $3e8679eefce5a28f$var$SvgTelegram;




var $exYeM = parcelRequire("exYeM");

function $8dbffd66de0568cc$var$SvgX(props) {
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M18.0955 14.3165L26.2864 5H24.3456L17.2303 13.0877L11.5514 5H5L13.5895 17.2311L5 27H6.94072L14.4501 18.4571L20.4486 27H27L18.0955 14.3165ZM15.4365 17.3385L14.5649 16.1198L7.64059 6.43161H10.6219L16.2117 14.2532L17.0797 15.4719L24.3447 25.6381H21.3634L15.4365 17.3385Z",
            fill: "currentColor"
        })
    }));
}
var $8dbffd66de0568cc$export$2e2bcd8739ae039 = $8dbffd66de0568cc$var$SvgX;





parcelRequire("exYeM");


const $daa5f192cc119d53$var$spin = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $daa5f192cc119d53$export$a5e06607a5ac6158 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    animation: `${$daa5f192cc119d53$var$spin} 1.5s linear infinite`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


function $76e484f048f6cf30$export$7f7cbe89f1eacd2(props) {
    const { size: size, color: color, css: css = {} } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $daa5f192cc119d53$export$a5e06607a5ac6158), {
        css: css,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $567d89352d8c7d60$export$2e2bcd8739ae039), {
            size: size,
            color: color
        })
    });
}




function $cf3c882ce06dec1a$var$AlertIcon(props) {
    switch(props.type){
        case "success":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2728cf0100aeae4d$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "warning":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "error":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a4b9d4c09097b8a0$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
        case "loading":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $76e484f048f6cf30$export$7f7cbe89f1eacd2), {
                color: "info",
                size: 12
            });
        default:
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d33873eddac739a4$export$2e2bcd8739ae039), {
                color: props.type,
                size: 12
            });
    }
}
var $cf3c882ce06dec1a$export$2e2bcd8739ae039 = $cf3c882ce06dec1a$var$AlertIcon;



const $64eb97d70691045d$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    borderRadius: "$xs",
    ".title_typography": {
        width: "100%"
    },
    ".title_typography:first-letter": {
        textTransform: "uppercase"
    },
    ".footer": {
        paddingTop: "$5",
        paddingLeft: "$24"
    },
    ".description": {
        color: "$neutral700",
        fontSize: "$10",
        lineHeight: "$12"
    },
    variants: {
        type: {
            success: {},
            warning: {},
            error: {},
            info: {},
            loading: {}
        },
        variant: {
            regular: {
                padding: "$5",
                alignItems: "flex-start",
                backgroundColor: "$neutral400"
            },
            alarm: {
                padding: "$5 $10",
                ".title_typography": {
                    fontWeight: "$medium"
                }
            }
        }
    },
    compoundVariants: [
        {
            type: "warning",
            variant: "alarm",
            css: {
                $$color: "$colors$warning100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "error",
            variant: "alarm",
            css: {
                $$color: "$colors$error100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "info",
            variant: "alarm",
            css: {
                $$color: "$colors$info100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info700"
                },
                backgroundColor: "$$color"
            }
        },
        {
            type: "success",
            variant: "alarm",
            css: {
                $$color: "$colors$success100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success700"
                },
                backgroundColor: "$$color"
            }
        }
    ]
});
const $64eb97d70691045d$export$861edd1ccea2f746 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    variants: {
        variant: {
            regular: {
                justifyContent: "space-between"
            },
            alarm: {
                justifyContent: "flex-start"
            }
        }
    }
});
const $64eb97d70691045d$export$35e09ba17cc51c69 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    flex: "1 0 0"
});
const $64eb97d70691045d$export$9ae29657c885eef1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$lg",
    width: "$20",
    height: "$20",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
    flexShrink: 0,
    variants: {
        type: {
            success: {
                $$color: "$colors$success300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success600"
                },
                backgroundColor: "$$color"
            },
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            },
            info: {
                $$color: "$colors$info300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            },
            loading: {
                $$color: "$colors$info300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            }
        },
        align: {
            center: {
                alignSelf: "center"
            }
        }
    }
});


function $23aba6742c98cdf0$export$caec2af78bcc877f(props) {
    const { type: type, title: title, footer: footer, action: action, containerStyles: containerStyles, variant: variant = "regular", titleAlign: titleAlign } = props;
    const isFooterString = typeof footer === "string";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $64eb97d70691045d$export$42a852a2b6b56249), {
        className: "_alert",
        css: containerStyles,
        type: type,
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $64eb97d70691045d$export$861edd1ccea2f746), {
                variant: variant,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $64eb97d70691045d$export$35e09ba17cc51c69), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $64eb97d70691045d$export$9ae29657c885eef1), {
                                type: type,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $cf3c882ce06dec1a$export$2e2bcd8739ae039), {
                                    type: type
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 4
                            }),
                            title && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                color: (0, $490a1bdb09a41c3f$export$5551a2d24ff40153)(type, variant),
                                align: titleAlign,
                                variant: "body",
                                className: "title_typography",
                                size: (0, $490a1bdb09a41c3f$export$f4a49e78999238bb)(variant),
                                children: title
                            })
                        ]
                    }),
                    action ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: "20"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                children: action
                            })
                        ]
                    }) : null
                ]
            }),
            footer ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: `footer ${isFooterString ? "description" : ""}`,
                children: footer
            }) : null
        ]
    });
}
$23aba6742c98cdf0$export$caec2af78bcc877f.toString = ()=>"._alert";





parcelRequire("exYeM");


parcelRequire("exYeM");

const $fb5d3986dd3d8e79$export$94026ee33dbabc26 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ".image": {
        width: "100%",
        height: "100%",
        objectFit: "contain"
    },
    ".circular": {
        borderRadius: "$lg"
    }
});
function $fb5d3986dd3d8e79$export$3e431a229df88919(props) {
    const { size: size, useAsPlaceholder: useAsPlaceholder, backgroundColor: backgroundColor = "$secondary100", type: type, ...otherProps } = props;
    const borderRadius = type === "circular" ? "$lg" : "$xs";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($fb5d3986dd3d8e79$export$94026ee33dbabc26, {
        css: {
            width: size + "px",
            height: size + "px",
            ...useAsPlaceholder && {
                backgroundColor: backgroundColor,
                borderRadius: borderRadius
            }
        },
        children: !useAsPlaceholder && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
            className: `image ${type === "circular" ? "circular" : ""}`,
            ...otherProps
        })
    });
}




const $0351968147de240a$export$5a7f9a6004988d01 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    padding: "$10",
    borderRadius: "$sm",
    width: "100%",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    border: 0,
    fontFamily: "inherit",
    [`& ${0, $fb5d3986dd3d8e79$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    },
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        outline: 0,
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color"
    },
    variants: {
        selected: {
            true: {
                outline: "1px solid $secondary500"
            },
            false: {
                outline: 0
            }
        }
    }
});


function $b21157a9f19b41cb$export$70f20e53a91f662d(props) {
    const { children: children, selected: selected, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0351968147de240a$export$5a7f9a6004988d01), {
        selected: selected,
        onClick: onClick,
        children: children
    });
}






parcelRequire("exYeM");


parcelRequire("exYeM");

function $68f050ed138229b3$export$e6ff31bff12b7ff4(props) {
    const { size: size = "1em", color: color } = props;
    const commonProps = {
        width: size,
        height: size,
        color: color,
        className: "_icon"
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $f3e108fa0c4cc675$export$8b8329c13d18f742), {
        ...commonProps,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        className: "c-lekKBq",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "m7.641 6.333.89.492 6.982-2.896a8.471 8.471 0 0 0-.825-.939c-.05.028-.09.044-.09.044L7.315 6.097c.083.084.19.164.33.236H7.64ZM3.134 14.967l7.067-2.947-1.315-.743-5.393 2.291-1.366.578c.251.325.526.63.82.914l.187-.095v.002Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "m16.253 5.1-1.287.498c-1.03.377-5.082 1.975-5.082 1.975.662.365 1.378.759 2.008 1.102 1.612.88.592 2.812.379 3.18l-.01.014a5.873 5.873 0 0 0-.027.046s.151-1.443-.866-1.977a648.55 648.55 0 0 1-4.365-2.313c-.466-.248-.804-.7-.868-1.223-.048-.392.051-.843.521-1.238.274-.254.569-.39.569-.39l5.253-2.156s.033-.013.081-.038l1.093-.454A8.421 8.421 0 0 0 1.447 13.12l2.032-.886 4.046-1.697c-.698-.383-1.342-.739-1.648-.903-.152-.081-.344-.21-.496-.292-.82-.433-1.357-1.656-.113-3.107 0 0-.13 1.377.641 1.845.734.446 3.582 1.905 4.428 2.358.216.116.416.264.576.453.329.39.454.87.316 1.38-.006.025-.015.049-.023.073l-.016.048a1.018 1.018 0 0 1-.037.095c-.29.7-1.062.91-1.062.91L10 13.43l-4.917 2.018-1.084.476A8.42 8.42 0 0 0 16.253 5.099v.002Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                fill: "currentColor",
                d: "m7.53 10.53 1.36.74-.68.29-1.426-.717.745-.314ZM10.09 13.392s1.13-.8.108-1.378l-.643.268s1.072.287.535 1.11ZM9.889 7.567l-1.361-.74.695-.29 1.437.731-.771.3ZM7.41 4.705s-1.131.801-.108 1.378l.642-.268s-1.072-.287-.535-1.11Z",
                opacity: 0.4,
                style: {
                    mixBlendMode: "multiply"
                }
            })
        ]
    });
}






const $b60dcfb494f4cdac$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "100%",
    justifyContent: "end",
    alignItems: "center"
});
const $b60dcfb494f4cdac$export$ec39d0bf2d6d1efb = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("a", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none"
});


function $739811eb95ae3c7e$export$11833b2d9103c949() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b60dcfb494f4cdac$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "xsmall",
                color: "$neutral700",
                children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Powered By")
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                direction: "horizontal",
                size: 8
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b60dcfb494f4cdac$export$ec39d0bf2d6d1efb), {
                href: "https://rango.exchange",
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $68f050ed138229b3$export$e6ff31bff12b7ff4), {
                        size: 16,
                        color: "gray"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        variant: "body",
                        size: "xsmall",
                        color: "neutral700",
                        children: "RANGO"
                    })
                ]
            })
        ]
    });
}






var $exYeM = parcelRequire("exYeM");


const $e3ff27881b63b531$export$b0bb876e969289cd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "$16",
    fontWeight: "$400",
    border: "0",
    borderRadius: "$secondary",
    cursor: "pointer",
    transition: "all 0.35s",
    fontFamily: "inherit",
    variants: {
        size: {
            xxsmall: {
                fontSize: "$10",
                lineHeight: "12px",
                padding: "$4"
            },
            xsmall: {
                fontSize: "$12",
                lineHeight: "12px",
                padding: "$0 $4"
            },
            small: {
                fontSize: "$14",
                fontWeight: "$medium",
                lineHeight: "20px",
                padding: "$4 $4"
            },
            medium: {
                fontSize: "$16",
                lineHeight: "24px",
                fontWeight: "$medium",
                padding: "$8 $8"
            },
            large: {
                fontSize: "$18",
                lineHeight: "26px",
                padding: "$12 $24",
                fontWeight: "$medium"
            }
        },
        variant: {
            contained: {
                backgroundColor: "$background",
                color: "$foreground",
                border: 0,
                "&:hover": {
                    backgroundColor: "$neutral300"
                },
                "&:focus-visible": {
                    backgroundColor: "$neutral500",
                    outline: 0
                },
                "&:disabled": {
                    backgroundColor: "$neutral600",
                    $$color: "$colors$background",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground",
                        backgroundColor: "$neutral700"
                    },
                    color: "$$color",
                    pointerEvents: "none"
                }
            },
            outlined: {
                backgroundColor: "$background",
                border: 1,
                borderStyle: "solid",
                color: "$foreground",
                borderColor: "$neutral200",
                "&:hover": {
                    borderColor: "$neutral300"
                },
                "&:focus-visible": {
                    borderColor: "$neutral500",
                    outline: 0
                },
                "&:disabled": {
                    borderColor: "$neutral600",
                    color: "$neutral600",
                    pointerEvents: "none"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                color: "$neutral700",
                "&:disabled": {
                    color: "$neutral600",
                    pointerEvents: "none"
                },
                "&:focus-visible": {
                    backgroundColor: "$neutral500",
                    outline: 0
                },
                "&:hover": {
                    color: "$secondary500"
                }
            },
            default: {}
        },
        fullWidth: {
            true: {
                width: "100%"
            }
        },
        type: {
            primary: {},
            error: {},
            warning: {},
            success: {},
            secondary: {}
        }
    },
    compoundVariants: [
        {
            type: "primary",
            variant: "contained",
            css: {
                background: "$primary500",
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$primary550",
                    $$color: "$colors$background",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:disabled": {
                    $$color: "$colors$background",
                    background: "$neutral600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground",
                        backgroundColor: "$neutral700"
                    },
                    color: "$$color",
                    pointerEvents: "none"
                },
                "&:visited": {
                    background: "$primary500"
                },
                "&:active": {
                    backgroundColor: "$primary500",
                    backgroundSize: "100%",
                    transition: "background 0s"
                },
                "&:focus-visible": {
                    background: "$primary550",
                    outline: 0
                }
            }
        },
        {
            type: "primary",
            variant: "outlined",
            css: {
                color: "$primary500",
                borderColor: "$primary500",
                "&:hover": {
                    color: "$primary550",
                    borderColor: "$primary550"
                },
                "&:focus-visible": {
                    color: "$primary550",
                    borderColor: "$primary550",
                    outline: 0
                }
            }
        },
        {
            type: "primary",
            variant: "ghost",
            css: {
                color: "$primary500",
                "&:hover": {
                    color: "$primary550"
                },
                "&:focus-visible": {
                    color: "$primary550",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "contained",
            css: {
                background: "$secondary500",
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$secondary550",
                    $$color: "$colors$background",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$secondary500"
                },
                "&:focus": {
                    background: "$secondary550",
                    outline: 0
                },
                "&:focus-visible": {
                    background: "$secondary550",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "outlined",
            css: {
                color: "$secondary500",
                borderColor: "$secondary500",
                "&:hover": {
                    color: "$secondary550",
                    borderColor: "$secondary550"
                },
                "&:visited": {
                    color: "$secondary500",
                    borderColor: "$secondary500"
                },
                "&:focus": {
                    color: "$secondary550",
                    borderColor: "$secondary500",
                    outline: 0
                },
                "&:focus-visible": {
                    color: "$secondary550",
                    borderColor: "$secondary500",
                    outline: 0
                }
            }
        },
        {
            type: "secondary",
            variant: "ghost",
            css: {
                color: "$secondary500",
                "&:hover": {
                    color: "$secondary550"
                },
                "&:visited": {
                    color: "$secondary500"
                },
                "&:focus": {
                    color: "$secondary550",
                    outline: 0
                },
                "&:focus-visible": {
                    color: "$secondary550",
                    outline: 0
                }
            }
        },
        {
            type: "error",
            variant: "contained",
            css: {
                background: "$error500",
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$error500"
                },
                "&:visited": {
                    background: "$error500"
                },
                "&:focus": {
                    background: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "error",
            variant: "outlined",
            css: {
                color: "$error500",
                borderColor: "$error500",
                "&:hover": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:visited": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:focus": {
                    color: "$error500",
                    borderColor: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    color: "$$outline",
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "error",
            variant: "ghost",
            css: {
                color: "$error500",
                "&:hover": {
                    color: "$error500"
                },
                "&:visited": {
                    color: "$error500"
                },
                "&:focus": {
                    color: "$error500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$error600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$error300"
                    },
                    color: "$$outline",
                    outline: 0
                }
            }
        },
        {
            type: "warning",
            variant: "contained",
            css: {
                background: "$warning500",
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$warning500",
                    $$color: "$colors$background",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$warning500"
                },
                "&:focus": {
                    background: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "warning",
            variant: "outlined",
            css: {
                color: "$warning500",
                borderColor: "$warning500",
                "&:hover": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:visited": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:focus": {
                    color: "$warning500",
                    borderColor: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    outlineColor: "$$outline",
                    color: "$$outline"
                }
            }
        },
        {
            type: "warning",
            variant: "ghost",
            css: {
                color: "$warning500",
                "&:hover": {
                    color: "$warning500"
                },
                "&:visited": {
                    color: "$warning500"
                },
                "&:focus": {
                    color: "$warning500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$warning600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$warning300"
                    },
                    color: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "contained",
            css: {
                background: "$success500",
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color",
                "&:hover": {
                    background: "$success500",
                    $$color: "$colors$background",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$foreground"
                    },
                    color: "$$color"
                },
                "&:visited": {
                    background: "$success500"
                },
                "&:focus": {
                    background: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outlineColor: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "outlined",
            css: {
                color: "$success500",
                borderColor: "$success500",
                "&:hover": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:visited": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:focus": {
                    color: "$success500",
                    borderColor: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outlineColor: "$$outline",
                    color: "$$outline"
                }
            }
        },
        {
            type: "success",
            variant: "ghost",
            css: {
                color: "$success500",
                "&:hover": {
                    color: "$success500"
                },
                "&:visited": {
                    color: "$success500"
                },
                "&:focus": {
                    color: "$success500"
                },
                "&:focus-visible": {
                    $$outline: "$colors$success600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$outline: "$colors$success300"
                    },
                    outline: 0,
                    color: "$$outline"
                }
            }
        }
    ],
    defaultVariants: {
        size: "medium",
        variant: "contained"
    }
});
const $e3ff27881b63b531$export$7c6e2c02157bb7d2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("span", {
    flexGrow: 1,
    display: "inline-block",
    variants: {
        pl: {
            true: {
                paddingLeft: "$8"
            }
        },
        pr: {
            true: {
                paddingRight: "$8"
            }
        }
    }
});
const $e3ff27881b63b531$var$ripple = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    to: {
        transform: "scale(2)",
        opacity: 0.1
    }
});
const $e3ff27881b63b531$export$79da28b0dcaab934 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    inset: "0",
    overflow: "hidden",
    borderRadius: "$sm",
    "& span": {
        transform: "scale(0)",
        borderRadius: "100%",
        position: "absolute",
        opacity: "0.75",
        backgroundColor: "$neutral500",
        animation: `${$e3ff27881b63b531$var$ripple} 0.8s linear`
    }
});




var $exYeM = parcelRequire("exYeM");

const $8dd748e1707a018a$var$DURATION = 850;
const $8dd748e1707a018a$var$useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction)=>{
    (0, $exYeM.useEffect)(()=>{
        let bounce = null;
        if (rippleCount > 0) {
            if (bounce) clearTimeout(bounce);
            bounce = setTimeout(()=>{
                cleanUpFunction();
                if (bounce) clearTimeout(bounce);
            }, duration);
        }
        return ()=>{
            if (bounce) clearTimeout(bounce);
        };
    }, [
        rippleCount,
        duration,
        cleanUpFunction
    ]);
};
const $8dd748e1707a018a$var$Ripple = ({ duration: duration = $8dd748e1707a018a$var$DURATION })=>{
    const [rippleArray, setRippleArray] = (0, $exYeM.useState)([]);
    $8dd748e1707a018a$var$useDebouncedRippleCleanUp(rippleArray.length, duration, ()=>{
        setRippleArray([]);
    });
    const addRipple = (event)=>{
        const rippleContainer = event.currentTarget.getBoundingClientRect();
        const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
        const x = event.pageX - rippleContainer.x - size / 2;
        const y = event.pageY - rippleContainer.y - size / 2;
        const newRipple = {
            x: x,
            y: y,
            size: size
        };
        setRippleArray([
            ...rippleArray,
            newRipple
        ]);
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3ff27881b63b531$export$79da28b0dcaab934), {
        onMouseDown: addRipple,
        children: rippleArray.length > 0 && rippleArray.map((ripple, index)=>{
            const key = "span" + index;
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    top: ripple.y,
                    left: ripple.x,
                    width: ripple.size,
                    height: ripple.size
                }
            }, key);
        })
    });
};
var $8dd748e1707a018a$export$2e2bcd8739ae039 = $8dd748e1707a018a$var$Ripple;


function $78c4dd382a7fe326$var$ButtonComponent(props, ref) {
    const { children: children, loading: loading, disabled: disabled, prefix: prefix, suffix: suffix, onClick: onClick, disableRipple: disableRipple, ...otherProps } = props;
    const shouldShowRipple = !disabled && !loading && !disableRipple;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e3ff27881b63b531$export$b0bb876e969289cd), {
        disabled: !loading && disabled,
        onClick: loading || disabled ? undefined : onClick,
        ...otherProps,
        ref: ref,
        children: [
            loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $76e484f048f6cf30$export$7f7cbe89f1eacd2), {
                css: {
                    width: "$24",
                    height: "$24"
                }
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    prefix,
                    children && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3ff27881b63b531$export$7c6e2c02157bb7d2), {
                        pl: !!prefix,
                        pr: !!suffix,
                        className: "_text",
                        children: children
                    }),
                    suffix
                ]
            }),
            shouldShowRipple && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8dd748e1707a018a$export$2e2bcd8739ae039), {})
        ]
    });
}
const $78c4dd382a7fe326$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($78c4dd382a7fe326$var$ButtonComponent);
$78c4dd382a7fe326$export$353f5b6fc5456de1.displayName = "Button";






var $exYeM = parcelRequire("exYeM");

// border-radius: 100% + overflow: hidden
function $4c39613e9fff7ff6$var$IconButtonComponent(props, ref) {
    const { style: style, ...otherProps } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        className: "_icon-button",
        ref: ref,
        ...otherProps,
        style: {
            borderRadius: "100%",
            lineHeight: 0,
            ...style
        },
        children: props.children
    });
}
const $4c39613e9fff7ff6$export$c25acd513dcc8062 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($4c39613e9fff7ff6$var$IconButtonComponent);
$4c39613e9fff7ff6$export$c25acd513dcc8062.displayName = "IconButton";
$4c39613e9fff7ff6$export$c25acd513dcc8062.toString = ()=>"._icon-button";





function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(this, arguments);
}



var $exYeM = parcelRequire("exYeM");
function $a20bcd1655f7f422$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $exYeM = parcelRequire("exYeM");
function $e1a745ecb8941240$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $exYeM.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $exYeM.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $exYeM.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $exYeM.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $exYeM.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $e1a745ecb8941240$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $exYeM.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $cec6513cd2787f04$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $exYeM.useRef)(callback);
    (0, $exYeM.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $exYeM.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $ceaa710ce91b202b$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $exYeM.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $ceaa710ce91b202b$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $exYeM.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $exYeM.useRef)(value);
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    (0, $exYeM.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $exYeM = parcelRequire("exYeM");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $96a334e7374a91f2$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $exYeM.useLayoutEffect) : ()=>{};



var $exYeM = parcelRequire("exYeM");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a0301a3b12ffad9c$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $a0301a3b12ffad9c$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $exYeM.useCallback)($a0301a3b12ffad9c$export$43e446d32b3d21af(...refs), refs);
}




var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $exYeM.Children).toArray(children);
    const slottable = childrenArray.find($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $exYeM.Children).count(newElement) > 1) return (0, $exYeM.Children).only(null);
                return /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $exYeM.isValidElement)(newElement) ? /*#__PURE__*/ (0, $exYeM.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$8d4dfd758f40b63f$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $exYeM.isValidElement)(children)) return /*#__PURE__*/ (0, $exYeM.cloneElement)(children, {
        ...$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $exYeM.Children).count(children) > 1 ? (0, $exYeM.Children).only(null) : null;
});
$8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $exYeM.isValidElement)(child) && child.type === $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45;
}
function $8d4dfd758f40b63f$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $8d4dfd758f40b63f$export$be92b6f5f03c0fe9 = $8d4dfd758f40b63f$export$8c6ed5c666ac1360;


const $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$250ffa63cdc0d034 = $9b1158d53fe98b0a$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : node;
        (0, $exYeM.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $exYeM.createElement)(Comp, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $9b1158d53fe98b0a$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $97dc602bd7e23afa$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $9b1158d53fe98b0a$export$be92b6f5f03c0fe9 = $9b1158d53fe98b0a$export$250ffa63cdc0d034;



var $exYeM = parcelRequire("exYeM");



function $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $exYeM.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $4a876f8b5705075b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $exYeM.Children).only(children);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $exYeM.cloneElement)(child, {
        ref: ref
    }) : null;
};
$4a876f8b5705075b$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $exYeM.useState)();
    const stylesRef = (0, $exYeM.useRef)({});
    const prevPresentRef = (0, $exYeM.useRef)(present);
    const prevAnimationNameRef = (0, $exYeM.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $4a876f8b5705075b$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $exYeM.useEffect)(()=>{
        const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $97dc602bd7e23afa$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $exYeM.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $4a876f8b5705075b$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}



var $exYeM = parcelRequire("exYeM");

const $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId = $exYeM["useId".toString()] || (()=>undefined);
let $6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count = 0;
function $6e53b15deb1e14e9$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($6e53b15deb1e14e9$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


/* -------------------------------------------------------------------------------------------------
 * Collapsible
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$75d51ac32d862af6$var$$409067139f391064$var$createCollapsibleContext, $75d51ac32d862af6$export$952b32dcbe73087a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const [$75d51ac32d862af6$var$$409067139f391064$var$CollapsibleProvider, $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext] = $75d51ac32d862af6$var$$409067139f391064$var$createCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME);
const $75d51ac32d862af6$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, open: openProp, defaultOpen: defaultOpen, disabled: disabled, onOpenChange: onOpenChange, ...collapsibleProps } = props;
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($75d51ac32d862af6$var$$409067139f391064$var$CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled: disabled,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ])
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(open),
        "data-disabled": disabled ? "" : undefined
    }, collapsibleProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$6eb0f7ddcda6131f, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$COLLAPSIBLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleTrigger
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $75d51ac32d862af6$export$c135dce7b15bbbdc = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, ...triggerProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        disabled: context.disabled
    }, triggerProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$c135dce7b15bbbdc, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CollapsibleContent
 * -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $75d51ac32d862af6$export$aadde00976f34151 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, ({ present: present })=>/*#__PURE__*/ (0, $exYeM.createElement)($75d51ac32d862af6$var$$409067139f391064$var$CollapsibleContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
            ref: forwardedRef,
            present: present
        })));
});
/*#__PURE__*/ Object.assign($75d51ac32d862af6$export$aadde00976f34151, {
    displayName: $75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $75d51ac32d862af6$var$$409067139f391064$var$CollapsibleContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCollapsible: __scopeCollapsible, present: present, children: children, ...contentProps } = props;
    const context = $75d51ac32d862af6$var$$409067139f391064$var$useCollapsibleContext($75d51ac32d862af6$var$$409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = (0, $exYeM.useState)(present);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const heightRef = (0, $exYeM.useRef)(0);
    const height = heightRef.current;
    const widthRef = (0, $exYeM.useRef)(0);
    const width = widthRef.current; // when opening we want it to immediately open to retrieve dimensions
    // when closing we delay `present` to retrieve dimensions before closing
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = (0, $exYeM.useRef)(isOpen);
    const originalStylesRef = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            }; // block any animations/transitions so the element renders at its full dimensions
            node.style.transitionDuration = "0s";
            node.style.animationName = "none"; // get width and height from full dimensions
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width; // kick off any animations/transitions that were originally set up if it isn't the initial mount
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    /**
     * depends on `context.open` because it will change to `false`
     * when a close is triggered but `present` will be `false` on
     * animation end (so when close finishes). This allows us to
     * retrieve the dimensions *before* closing.
     */ }, [
        context.open,
        present
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $75d51ac32d862af6$var$$409067139f391064$var$getState(context.open),
        "data-disabled": context.disabled ? "" : undefined,
        id: context.contentId,
        hidden: !isOpen
    }, contentProps, {
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : undefined,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : undefined,
            ...props.style
        }
    }), isOpen && children);
});
/* -----------------------------------------------------------------------------------------------*/ function $75d51ac32d862af6$var$$409067139f391064$var$getState(open) {
    return open ? "open" : "closed";
}
const $75d51ac32d862af6$export$be92b6f5f03c0fe9 = $75d51ac32d862af6$export$6eb0f7ddcda6131f;
const $75d51ac32d862af6$export$41fb9f06171c75f4 = $75d51ac32d862af6$export$c135dce7b15bbbdc;
const $75d51ac32d862af6$export$7c6e2c02157bb7d2 = $75d51ac32d862af6$export$aadde00976f34151;


parcelRequire("exYeM");


const $19113fa36cc5fa5e$var$slideDown = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const $19113fa36cc5fa5e$var$slideUp = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const $19113fa36cc5fa5e$export$aadde00976f34151 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$7c6e2c02157bb7d2, {
    overflow: "hidden",
    variants: {
        open: {
            true: {
                animation: `${$19113fa36cc5fa5e$var$slideDown} 300ms ease-out`
            },
            false: {
                animation: `${$19113fa36cc5fa5e$var$slideUp} 300ms ease-out`
            }
        }
    }
});




const $4c607626a309c0ac$export$41fb9f06171c75f4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$41fb9f06171c75f4, {
    border: "none",
    background: "transparent",
    width: "100%"
});


function $33ed32d1e250df39$export$9bd9b68c3a48b0fa(props) {
    const { open: open, onOpenChange: onOpenChange, trigger: trigger, children: children, ...otherProps } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($75d51ac32d862af6$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: onOpenChange,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4c607626a309c0ac$export$41fb9f06171c75f4), {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $19113fa36cc5fa5e$export$aadde00976f34151), {
                open: open,
                children: children
            })
        ]
    });
}





parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");
function $e863f772c7a65c44$export$5cae361ad82dce8b(value) {
    const ref = (0, $exYeM.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $exYeM.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}



var $exYeM = parcelRequire("exYeM");

function $e3071ccbaf099f7e$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $exYeM.useState)(undefined);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}




/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME = "Checkbox";
const [$809f883df8253f8c$var$$e698a72e93240346$var$createCheckboxContext, $809f883df8253f8c$export$b566c4ff5488ea01] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME);
const [$809f883df8253f8c$var$$e698a72e93240346$var$CheckboxProvider, $809f883df8253f8c$var$$e698a72e93240346$var$useCheckboxContext] = $809f883df8253f8c$var$$e698a72e93240346$var$createCheckboxContext($809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME);
const $809f883df8253f8c$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...checkboxProps } = props;
    const [button, setButton] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $exYeM.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0, $exYeM.useRef)(checked);
    (0, $exYeM.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($809f883df8253f8c$var$$e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        role: "checkbox",
        "aria-checked": $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $809f883df8253f8c$var$$e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $exYeM.createElement)($809f883df8253f8c$var$$e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($809f883df8253f8c$export$48513f6b9f8ce62d, {
    displayName: $809f883df8253f8c$var$$e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME = "CheckboxIndicator";
const $809f883df8253f8c$export$59aad738f51d1c05 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $809f883df8253f8c$var$$e698a72e93240346$var$useCheckboxContext($809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $809f883df8253f8c$var$$e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: "none",
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($809f883df8253f8c$export$59aad738f51d1c05, {
    displayName: $809f883df8253f8c$var$$e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $809f883df8253f8c$var$$e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const prevChecked = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("input", (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $809f883df8253f8c$var$$e698a72e93240346$var$getState(checked) {
    return $809f883df8253f8c$var$$e698a72e93240346$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const $809f883df8253f8c$export$be92b6f5f03c0fe9 = $809f883df8253f8c$export$48513f6b9f8ce62d;
const $809f883df8253f8c$export$adb584737d712b70 = $809f883df8253f8c$export$59aad738f51d1c05;



const $d50f25cb35ce22fb$export$be6fcc6a7e078caa = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});
const $d50f25cb35ce22fb$export$ab09149c4c8e7904 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($809f883df8253f8c$export$be92b6f5f03c0fe9, {
    borderRadius: "$xs",
    position: "relative",
    width: "1rem",
    height: "1rem",
    padding: 0,
    $$borderColor: "$colors$neutral600",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$borderColor: "$colors$neutral700"
    },
    border: "1px solid $$borderColor",
    backgroundColor: "transparent",
    cursor: "pointer",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary250"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    },
    "&[data-disabled]": {
        backgroundColor: "$neutral600",
        borderColor: "$neutral700"
    }
});
const $d50f25cb35ce22fb$export$59aad738f51d1c05 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($809f883df8253f8c$export$59aad738f51d1c05, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $d50f25cb35ce22fb$export$b04be29aa201d4f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("label", {
    color: "$foreground",
    fontSize: "$m",
    cursor: "pointer"
});


function $c3cfb7c988c3f338$export$48513f6b9f8ce62d(props) {
    const { id: id, label: label, ...otherProps } = props;
    const hasLabel = id && label;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $d50f25cb35ce22fb$export$be6fcc6a7e078caa), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d50f25cb35ce22fb$export$ab09149c4c8e7904), {
                id: id,
                ...otherProps,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d50f25cb35ce22fb$export$59aad738f51d1c05), {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5815e032006c952c$export$2e2bcd8739ae039), {
                        color: "white",
                        size: 12
                    })
                })
            }),
            hasLabel ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d50f25cb35ce22fb$export$b04be29aa201d4f5), {
                        className: "_text",
                        htmlFor: id,
                        children: label
                    })
                ]
            }) : null
        ]
    });
}





parcelRequire("exYeM");


const $6211e7c98f00bb51$export$14a9f83786186af1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "$xs",
    padding: "$5 $15",
    cursor: "pointer",
    transition: "all 0.35s",
    border: "1px solid transparent",
    fontFamily: "inherit",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    variants: {
        selected: {
            true: {
                border: "1px solid $secondary500"
            }
        }
    }
});


function $b8fd588522d703e5$export$5a7f9a6004988d01(props) {
    const { label: label, selected: selected, prefix: prefix, suffix: suffix, ...otherProps } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $6211e7c98f00bb51$export$14a9f83786186af1), {
        selected: selected,
        ...otherProps,
        children: [
            prefix || null,
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                color: !selected ? "neutral700" : undefined,
                variant: "body",
                size: "medium",
                children: label
            }),
            suffix || null
        ]
    });
}









var $exYeM = parcelRequire("exYeM");


parcelRequire("exYeM");


parcelRequire("exYeM");

const $921baa0e4bb19672$var$waveSquares = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "0%": {
        backgroundPosition: "-468px 0"
    },
    "100%": {
        backgroundPosition: "468px 0"
    }
});
const $921baa0e4bb19672$export$66b8cea0c448285 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    $$background: "linear-gradient(90deg, $colors$secondary200 20%, rgba(200, 226, 255, 0.20) 70%, $colors$secondary200 100%)",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$background: "linear-gradient(90deg, $colors$secondary550 0%,rgba(43, 52, 98, 0.20) 70%, $colors$secondary550 100%)"
    },
    background: "$$background",
    backgroundSize: "800px 100px",
    animation: `${$921baa0e4bb19672$var$waveSquares} 2s infinite ease-out`,
    variants: {
        variant: {
            text: {
                borderRadius: "$sm"
            },
            circular: {
                borderRadius: "$lg"
            },
            rectangular: {},
            rounded: {
                borderRadius: "$sm"
            }
        },
        size: {
            small: {},
            medium: {},
            large: {}
        }
    },
    compoundVariants: [
        {
            size: "small",
            variant: "text",
            css: {
                height: "$8"
            }
        },
        {
            size: "medium",
            variant: "text",
            css: {
                height: "$12"
            }
        },
        {
            size: "large",
            variant: "text",
            css: {
                height: "$16"
            }
        }
    ]
});


function $adacf710924c9926$export$8f31e4c4a37b8e9c(props) {
    const { width: width = "100%" } = props;
    const customCss = props.variant !== "text" ? {
        width: width,
        height: props.height
    } : {
        width: width
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $921baa0e4bb19672$export$66b8cea0c448285), {
        css: customCss,
        ...props
    });
}




const $96d8e068a4eda6f1$export$452e43e577d2dd6c = {
    small: {
        token: 17,
        chain: 10
    },
    xmedium: {
        token: 22,
        chain: 10
    },
    medium: {
        token: 27,
        chain: 10
    },
    large: {
        token: 30,
        chain: 15
    }
};




const $7c48552eddaeb4ce$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "flex",
    [`& ${0, $fb5d3986dd3d8e79$export$3e431a229df88919}`]: {
        borderRadius: "100%"
    }
});
const $7c48552eddaeb4ce$export$d4931c993da6ddd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    borderRadius: "100%",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    variants: {
        size: {
            small: {
                right: "-3px",
                bottom: "-3px"
            },
            xmedium: {
                right: "-3px",
                bottom: "-3px"
            },
            medium: {
                right: "0",
                bottom: "0"
            },
            large: {
                right: "-5px",
                bottom: "-5px"
            }
        },
        hasBorder: {
            true: {
                $$borderColor: "$colors$secondary250",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$borderColor: "$colors$secondary550"
                },
                border: "1px solid $$borderColor"
            },
            false: {}
        }
    }
});
const $7c48552eddaeb4ce$export$89316b32bccd1f58 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "100%",
    width: "$30",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        hasBorder: {
            true: {
                $$borderColor: "$colors$secondary550",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$borderColor: "$colors$secondary500"
                },
                border: "1px solid $$borderColor"
            },
            false: {}
        }
    }
});


const $a0e1b354b0ac8fb0$export$89626202435b26ac = (props)=>{
    const { tokenImage: tokenImage, chainImage: chainImage, chianImageId: chianImageId, size: size, useAsPlaceholder: useAsPlaceholder, loading: loading } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7c48552eddaeb4ce$export$42a852a2b6b56249), {
        css: loading ? {} : {
            width: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].token,
            height: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].token
        },
        children: [
            loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                height: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].token,
                width: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].token
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7c48552eddaeb4ce$export$89316b32bccd1f58), {
                hasBorder: !tokenImage,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                    size: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].token,
                    src: tokenImage,
                    type: "circular",
                    ...(useAsPlaceholder || !tokenImage) && {
                        useAsPlaceholder: true,
                        backgroundColor: "transparent"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7c48552eddaeb4ce$export$d4931c993da6ddd), {
                size: size,
                hasBorder: !chainImage,
                children: loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                    variant: "circular",
                    height: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].chain,
                    width: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].chain
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                    id: chianImageId,
                    size: (0, $96d8e068a4eda6f1$export$452e43e577d2dd6c)[size].chain,
                    src: chainImage,
                    type: "circular",
                    ...(useAsPlaceholder || !chainImage) && {
                        useAsPlaceholder: true,
                        backgroundColor: "transparent"
                    }
                })
            })
        ]
    });
};







parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

/**
 * Listens for when the escape key is down
 */ function $34fe34d34d8734af$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $exYeM.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $0516f19b588c56c0$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $exYeM.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $exYeM.useState)({});
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $34fe34d34d8734af$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $exYeM.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $0516f19b588c56c0$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $exYeM.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $exYeM.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$177fb62ff3ec1f22, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $0516f19b588c56c0$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = (0, $exYeM.useContext)($0516f19b588c56c0$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($0516f19b588c56c0$export$4d5eb2109db14228, {
    displayName: $0516f19b588c56c0$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $exYeM.useRef)(false);
    const handleClickRef = (0, $exYeM.useRef)(()=>{});
    (0, $exYeM.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $0516f19b588c56c0$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($0516f19b588c56c0$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $0516f19b588c56c0$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $0516f19b588c56c0$export$be92b6f5f03c0fe9 = $0516f19b588c56c0$export$177fb62ff3ec1f22;
const $0516f19b588c56c0$export$aecb2ddcb55c95be = $0516f19b588c56c0$export$4d5eb2109db14228;





var $exYeM = parcelRequire("exYeM");
const $8311b4bc2ec83684$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $8311b4bc2ec83684$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $8311b4bc2ec83684$export$803cd8101b6c182b = /*#__PURE__*/ $8311b4bc2ec83684$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $8311b4bc2ec83684$export$27b07d8a310ed8b5[0], side + "-" + $8311b4bc2ec83684$export$27b07d8a310ed8b5[1]), []);
const $8311b4bc2ec83684$export$96ec731ed4dcb222 = Math.min;
const $8311b4bc2ec83684$export$8960430cfd85939f = Math.max;
const $8311b4bc2ec83684$export$2077e0241d6afd3c = Math.round;
const $8311b4bc2ec83684$export$a3fe094919f356fd = Math.floor;
const $8311b4bc2ec83684$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $8311b4bc2ec83684$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $8311b4bc2ec83684$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $8311b4bc2ec83684$export$7d15b64cf5a3a4c4(start, value, end) {
    return $8311b4bc2ec83684$export$8960430cfd85939f(start, $8311b4bc2ec83684$export$96ec731ed4dcb222(value, end));
}
function $8311b4bc2ec83684$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $8311b4bc2ec83684$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $8311b4bc2ec83684$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $8311b4bc2ec83684$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $8311b4bc2ec83684$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $8311b4bc2ec83684$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($8311b4bc2ec83684$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $8311b4bc2ec83684$export$2b57e0052a6d6d4c(placement) {
    return $8311b4bc2ec83684$export$8a000a963141ac32($8311b4bc2ec83684$export$f28e8f882010718a(placement));
}
function $8311b4bc2ec83684$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $8311b4bc2ec83684$export$f0989780f32bfcda(placement);
    const alignmentAxis = $8311b4bc2ec83684$export$2b57e0052a6d6d4c(placement);
    const length = $8311b4bc2ec83684$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $8311b4bc2ec83684$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $8311b4bc2ec83684$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $8311b4bc2ec83684$export$496432a3699e50b1(placement) {
    const oppositePlacement = $8311b4bc2ec83684$export$9c5e28bad23365fa(placement);
    return [
        $8311b4bc2ec83684$export$2b182c584985588b(placement),
        oppositePlacement,
        $8311b4bc2ec83684$export$2b182c584985588b(oppositePlacement)
    ];
}
function $8311b4bc2ec83684$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$8311b4bc2ec83684$var$oppositeAlignmentMap[alignment]);
}
function $8311b4bc2ec83684$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $8311b4bc2ec83684$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $8311b4bc2ec83684$export$f0989780f32bfcda(placement);
    let list = $8311b4bc2ec83684$var$getSideList($8311b4bc2ec83684$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($8311b4bc2ec83684$export$2b182c584985588b));
    }
    return list;
}
function $8311b4bc2ec83684$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$8311b4bc2ec83684$var$oppositeSideMap[side]);
}
function $8311b4bc2ec83684$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $8311b4bc2ec83684$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $8311b4bc2ec83684$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $8311b4bc2ec83684$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $0b2a0321bb512d25$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $8311b4bc2ec83684$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $8311b4bc2ec83684$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $8311b4bc2ec83684$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $0b2a0321bb512d25$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $0b2a0321bb512d25$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $0b2a0321bb512d25$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $0b2a0321bb512d25$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $8311b4bc2ec83684$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $0b2a0321bb512d25$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $8311b4bc2ec83684$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $8311b4bc2ec83684$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $8311b4bc2ec83684$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $8311b4bc2ec83684$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $0b2a0321bb512d25$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $8311b4bc2ec83684$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $0b2a0321bb512d25$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $8311b4bc2ec83684$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $8311b4bc2ec83684$export$803cd8101b6c182b) ? $0b2a0321bb512d25$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $8311b4bc2ec83684$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $0b2a0321bb512d25$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $8311b4bc2ec83684$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $8311b4bc2ec83684$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $8311b4bc2ec83684$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $8311b4bc2ec83684$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $0b2a0321bb512d25$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $0b2a0321bb512d25$var$isAnySideFullyClipped(overflow) {
    return (0, $8311b4bc2ec83684$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $0b2a0321bb512d25$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $0b2a0321bb512d25$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $0b2a0321bb512d25$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $0b2a0321bb512d25$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $0b2a0321bb512d25$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $0b2a0321bb512d25$var$getBoundingRect(rects) {
    const minX = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $0b2a0321bb512d25$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)($0b2a0321bb512d25$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $0b2a0321bb512d25$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $0b2a0321bb512d25$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)($0b2a0321bb512d25$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $8311b4bc2ec83684$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $8311b4bc2ec83684$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $0b2a0321bb512d25$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $8311b4bc2ec83684$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $0b2a0321bb512d25$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $0b2a0321bb512d25$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $0b2a0321bb512d25$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $8311b4bc2ec83684$export$f28e8f882010718a)((0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $8311b4bc2ec83684$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $8311b4bc2ec83684$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $8311b4bc2ec83684$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $0b2a0321bb512d25$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $8311b4bc2ec83684$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $8311b4bc2ec83684$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $0b2a0321bb512d25$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $8311b4bc2ec83684$export$fef61f332f2c0afc)(options, state);
            const overflow = await $0b2a0321bb512d25$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $8311b4bc2ec83684$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $8311b4bc2ec83684$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $8311b4bc2ec83684$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $8311b4bc2ec83684$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $933c1818790aa1e9$export$651544f548703224(node) {
    if ($933c1818790aa1e9$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $933c1818790aa1e9$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $933c1818790aa1e9$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($933c1818790aa1e9$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $933c1818790aa1e9$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $933c1818790aa1e9$export$38b2d434cce3ea22(value).Node;
}
function $933c1818790aa1e9$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $933c1818790aa1e9$export$38b2d434cce3ea22(value).Element;
}
function $933c1818790aa1e9$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $933c1818790aa1e9$export$38b2d434cce3ea22(value).HTMLElement;
}
function $933c1818790aa1e9$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $933c1818790aa1e9$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $933c1818790aa1e9$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $933c1818790aa1e9$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $933c1818790aa1e9$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($933c1818790aa1e9$export$651544f548703224(element));
}
function $933c1818790aa1e9$export$d6c4e8150c35fed1(element) {
    const webkit = $933c1818790aa1e9$export$78551043582a6a98();
    const css = $933c1818790aa1e9$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $933c1818790aa1e9$export$940d8225183e1404(element) {
    let currentNode = $933c1818790aa1e9$export$4e12058fc4d51d56(element);
    while($933c1818790aa1e9$export$1b3bfaa9684536aa(currentNode) && !$933c1818790aa1e9$export$d1162fb0b6d4cd51(currentNode)){
        if ($933c1818790aa1e9$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $933c1818790aa1e9$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $933c1818790aa1e9$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $933c1818790aa1e9$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($933c1818790aa1e9$export$651544f548703224(node));
}
function $933c1818790aa1e9$export$3735103072e4a80(element) {
    return $933c1818790aa1e9$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $933c1818790aa1e9$export$dc8fc79fa2800137(element) {
    if ($933c1818790aa1e9$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $933c1818790aa1e9$export$4e12058fc4d51d56(node) {
    if ($933c1818790aa1e9$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $933c1818790aa1e9$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $933c1818790aa1e9$export$e495491855dc5418(node);
    return $933c1818790aa1e9$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $933c1818790aa1e9$export$7cd01a57c8ca906c(node) {
    const parentNode = $933c1818790aa1e9$export$4e12058fc4d51d56(node);
    if ($933c1818790aa1e9$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($933c1818790aa1e9$export$1b3bfaa9684536aa(parentNode) && $933c1818790aa1e9$export$989e911fa9af580a(parentNode)) return parentNode;
    return $933c1818790aa1e9$export$7cd01a57c8ca906c(parentNode);
}
function $933c1818790aa1e9$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $933c1818790aa1e9$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $933c1818790aa1e9$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $933c1818790aa1e9$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $933c1818790aa1e9$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $933c1818790aa1e9$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $a0b0ef9ecd9b02ae$var$getCssDimensions(element) {
    const css = (0, $933c1818790aa1e9$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $8311b4bc2ec83684$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $8311b4bc2ec83684$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $a0b0ef9ecd9b02ae$var$unwrapElement(element) {
    return !(0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $a0b0ef9ecd9b02ae$var$getScale(element) {
    const domElement = $a0b0ef9ecd9b02ae$var$unwrapElement(element);
    if (!(0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(domElement)) return (0, $8311b4bc2ec83684$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $a0b0ef9ecd9b02ae$var$getCssDimensions(domElement);
    let x = ($ ? (0, $8311b4bc2ec83684$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $8311b4bc2ec83684$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $a0b0ef9ecd9b02ae$var$noOffsets = /*#__PURE__*/ (0, $8311b4bc2ec83684$export$a397704b5e280835)(0);
function $a0b0ef9ecd9b02ae$var$getVisualOffsets(element) {
    const win = (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(element);
    if (!(0, $933c1818790aa1e9$export$78551043582a6a98)() || !win.visualViewport) return $a0b0ef9ecd9b02ae$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $a0b0ef9ecd9b02ae$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $a0b0ef9ecd9b02ae$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $a0b0ef9ecd9b02ae$var$unwrapElement(element);
    let scale = (0, $8311b4bc2ec83684$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(offsetParent)) scale = $a0b0ef9ecd9b02ae$var$getScale(offsetParent);
        } else scale = $a0b0ef9ecd9b02ae$var$getScale(element);
    }
    const visualOffsets = $a0b0ef9ecd9b02ae$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $a0b0ef9ecd9b02ae$var$getVisualOffsets(domElement) : (0, $8311b4bc2ec83684$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $a0b0ef9ecd9b02ae$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $933c1818790aa1e9$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $a0b0ef9ecd9b02ae$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $933c1818790aa1e9$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $8311b4bc2ec83684$export$a397704b5e280835)(1);
    const offsets = (0, $8311b4bc2ec83684$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $933c1818790aa1e9$export$651544f548703224)(offsetParent) !== "body" || (0, $933c1818790aa1e9$export$989e911fa9af580a)(documentElement)) scroll = (0, $933c1818790aa1e9$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $a0b0ef9ecd9b02ae$var$getBoundingClientRect(offsetParent);
            scale = $a0b0ef9ecd9b02ae$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $a0b0ef9ecd9b02ae$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $a0b0ef9ecd9b02ae$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $a0b0ef9ecd9b02ae$var$getBoundingClientRect((0, $933c1818790aa1e9$export$e495491855dc5418)(element)).left + (0, $933c1818790aa1e9$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $a0b0ef9ecd9b02ae$var$getDocumentRect(element) {
    const html = (0, $933c1818790aa1e9$export$e495491855dc5418)(element);
    const scroll = (0, $933c1818790aa1e9$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $a0b0ef9ecd9b02ae$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $933c1818790aa1e9$export$3735103072e4a80)(body).direction === "rtl") x += (0, $8311b4bc2ec83684$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $a0b0ef9ecd9b02ae$var$getViewportRect(element, strategy) {
    const win = (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(element);
    const html = (0, $933c1818790aa1e9$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $933c1818790aa1e9$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $a0b0ef9ecd9b02ae$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $a0b0ef9ecd9b02ae$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(element) ? $a0b0ef9ecd9b02ae$var$getScale(element) : (0, $8311b4bc2ec83684$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $a0b0ef9ecd9b02ae$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $a0b0ef9ecd9b02ae$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $a0b0ef9ecd9b02ae$var$getDocumentRect((0, $933c1818790aa1e9$export$e495491855dc5418)(element));
    else if ((0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $a0b0ef9ecd9b02ae$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $a0b0ef9ecd9b02ae$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $8311b4bc2ec83684$export$ee05aea0aeecbad4)(rect);
}
function $a0b0ef9ecd9b02ae$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $933c1818790aa1e9$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(parentNode) || (0, $933c1818790aa1e9$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $933c1818790aa1e9$export$3735103072e4a80)(parentNode).position === "fixed" || $a0b0ef9ecd9b02ae$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $a0b0ef9ecd9b02ae$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $933c1818790aa1e9$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(el) && (0, $933c1818790aa1e9$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $933c1818790aa1e9$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $933c1818790aa1e9$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $933c1818790aa1e9$export$45a5e7f76e0caa8d)(currentNode) && !(0, $933c1818790aa1e9$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $933c1818790aa1e9$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $933c1818790aa1e9$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $933c1818790aa1e9$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $a0b0ef9ecd9b02ae$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $933c1818790aa1e9$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $a0b0ef9ecd9b02ae$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $a0b0ef9ecd9b02ae$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $a0b0ef9ecd9b02ae$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8311b4bc2ec83684$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $a0b0ef9ecd9b02ae$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $a0b0ef9ecd9b02ae$var$getDimensions(element) {
    return $a0b0ef9ecd9b02ae$var$getCssDimensions(element);
}
function $a0b0ef9ecd9b02ae$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $933c1818790aa1e9$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $a0b0ef9ecd9b02ae$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $8311b4bc2ec83684$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $933c1818790aa1e9$export$651544f548703224)(offsetParent) !== "body" || (0, $933c1818790aa1e9$export$989e911fa9af580a)(documentElement)) scroll = (0, $933c1818790aa1e9$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $a0b0ef9ecd9b02ae$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $a0b0ef9ecd9b02ae$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $a0b0ef9ecd9b02ae$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(element) || (0, $933c1818790aa1e9$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $a0b0ef9ecd9b02ae$var$getOffsetParent(element, polyfill) {
    const window = (0, $933c1818790aa1e9$export$38b2d434cce3ea22)(element);
    if (!(0, $933c1818790aa1e9$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $a0b0ef9ecd9b02ae$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $933c1818790aa1e9$export$71535ffaa902797f)(offsetParent) && (0, $933c1818790aa1e9$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $a0b0ef9ecd9b02ae$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $933c1818790aa1e9$export$651544f548703224)(offsetParent) === "html" || (0, $933c1818790aa1e9$export$651544f548703224)(offsetParent) === "body" && (0, $933c1818790aa1e9$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $933c1818790aa1e9$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $933c1818790aa1e9$export$940d8225183e1404)(element) || window;
}
const $a0b0ef9ecd9b02ae$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $a0b0ef9ecd9b02ae$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $a0b0ef9ecd9b02ae$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $a0b0ef9ecd9b02ae$var$isRTL(element) {
    return (0, $933c1818790aa1e9$export$3735103072e4a80)(element).direction === "rtl";
}
const $a0b0ef9ecd9b02ae$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $a0b0ef9ecd9b02ae$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $933c1818790aa1e9$export$e495491855dc5418,
    getClippingRect: $a0b0ef9ecd9b02ae$var$getClippingRect,
    getOffsetParent: $a0b0ef9ecd9b02ae$var$getOffsetParent,
    getElementRects: $a0b0ef9ecd9b02ae$var$getElementRects,
    getClientRects: $a0b0ef9ecd9b02ae$var$getClientRects,
    getDimensions: $a0b0ef9ecd9b02ae$var$getDimensions,
    getScale: $a0b0ef9ecd9b02ae$var$getScale,
    isElement: $933c1818790aa1e9$export$45a5e7f76e0caa8d,
    isRTL: $a0b0ef9ecd9b02ae$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $a0b0ef9ecd9b02ae$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $933c1818790aa1e9$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $8311b4bc2ec83684$export$a3fe094919f356fd)(top);
        const insetRight = (0, $8311b4bc2ec83684$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $8311b4bc2ec83684$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $8311b4bc2ec83684$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $8311b4bc2ec83684$export$8960430cfd85939f)(0, (0, $8311b4bc2ec83684$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $a0b0ef9ecd9b02ae$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $a0b0ef9ecd9b02ae$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $933c1818790aa1e9$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $933c1818790aa1e9$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $a0b0ef9ecd9b02ae$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $a0b0ef9ecd9b02ae$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $a0b0ef9ecd9b02ae$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $a0b0ef9ecd9b02ae$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $a0b0ef9ecd9b02ae$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $0b2a0321bb512d25$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $exYeM = parcelRequire("exYeM");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $15fa45bf44f4de37$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $0b2a0321bb512d25$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $0b2a0321bb512d25$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $15fa45bf44f4de37$var$index = typeof document !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $15fa45bf44f4de37$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$15fa45bf44f4de37$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$15fa45bf44f4de37$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $15fa45bf44f4de37$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $15fa45bf44f4de37$var$roundByDPR(element, value) {
    const dpr = $15fa45bf44f4de37$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $15fa45bf44f4de37$var$useLatestRef(value) {
    const ref = $exYeM.useRef(value);
    $15fa45bf44f4de37$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $15fa45bf44f4de37$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $exYeM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $exYeM.useState(middleware);
    if (!$15fa45bf44f4de37$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $exYeM.useState(null);
    const [_floating, _setFloating] = $exYeM.useState(null);
    const setReference = $exYeM.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $exYeM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $exYeM.useRef(null);
    const floatingRef = $exYeM.useRef(null);
    const dataRef = $exYeM.useRef(data);
    const whileElementsMountedRef = $15fa45bf44f4de37$var$useLatestRef(whileElementsMounted);
    const platformRef = $15fa45bf44f4de37$var$useLatestRef(platform);
    const update = $exYeM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $a0b0ef9ecd9b02ae$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$15fa45bf44f4de37$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $97dc602bd7e23afa$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $15fa45bf44f4de37$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $exYeM.useRef(false);
    $15fa45bf44f4de37$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $15fa45bf44f4de37$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $exYeM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $exYeM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $exYeM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $15fa45bf44f4de37$var$roundByDPR(elements.floating, data.x);
        const y = $15fa45bf44f4de37$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$15fa45bf44f4de37$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $exYeM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $51f35d4f6c07a0fd$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).svg, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $exYeM.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($51f35d4f6c07a0fd$export$21b07c8f274aebd5, {
    displayName: $51f35d4f6c07a0fd$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9 = $51f35d4f6c07a0fd$export$21b07c8f274aebd5;








const $7b6292e260c70ed7$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $7b6292e260c70ed7$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext, $7b6292e260c70ed7$export$722aac194ae923] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $7b6292e260c70ed7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $exYeM.useState)(null);
    return /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$badac9ada3a0bdf9, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $7b6292e260c70ed7$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $exYeM.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$ecd4e1ccab6ed6d, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$createPopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $7b6292e260c70ed7$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$usePopperContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $exYeM.useState)(null);
    const arrowSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $15fa45bf44f4de37$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $a0b0ef9ecd9b02ae$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $0b2a0321bb512d25$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $0b2a0321bb512d25$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $0b2a0321bb512d25$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $0b2a0321bb512d25$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $0b2a0321bb512d25$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $15fa45bf44f4de37$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $0b2a0321bb512d25$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPlaced);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $exYeM.useState)();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $exYeM.createElement)($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$bc4ae5855d3c4fc, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $7b6292e260c70ed7$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$useContentContext($7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $exYeM.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($7b6292e260c70ed7$export$79d62cd4e10a3fd0, {
    displayName: $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $7b6292e260c70ed7$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $7b6292e260c70ed7$export$be92b6f5f03c0fe9 = $7b6292e260c70ed7$export$badac9ada3a0bdf9;
const $7b6292e260c70ed7$export$b688253958b8dfe7 = $7b6292e260c70ed7$export$ecd4e1ccab6ed6d;
const $7b6292e260c70ed7$export$7c6e2c02157bb7d2 = $7b6292e260c70ed7$export$bc4ae5855d3c4fc;
const $7b6292e260c70ed7$export$21b07c8f274aebd5 = $7b6292e260c70ed7$export$79d62cd4e10a3fd0;




var $exYeM = parcelRequire("exYeM");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $965ca2171585ad7a$export$602eac185826482c = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).createPortal(/*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($965ca2171585ad7a$export$602eac185826482c, {
    displayName: $965ca2171585ad7a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $965ca2171585ad7a$export$be92b6f5f03c0fe9 = $965ca2171585ad7a$export$602eac185826482c;








var $exYeM = parcelRequire("exYeM");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $4ed20962d3818fe0$export$439d29a4e110a164 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($4ed20962d3818fe0$export$439d29a4e110a164, {
    displayName: $4ed20962d3818fe0$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4ed20962d3818fe0$export$be92b6f5f03c0fe9 = $4ed20962d3818fe0$export$439d29a4e110a164;


const [$9d584503d9945f04$var$$a093c7e1ec25a057$var$createTooltipContext, $9d584503d9945f04$export$1c540a2224f0d865] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $9d584503d9945f04$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $9d584503d9945f04$var$$a093c7e1ec25a057$var$createTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $9d584503d9945f04$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $9d584503d9945f04$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $exYeM.useState)(true);
    const isPointerInTransitRef = (0, $exYeM.useRef)(false);
    const skipDelayTimerRef = (0, $exYeM.useRef)(0);
    (0, $exYeM.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $exYeM.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $exYeM.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $exYeM.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$f78649fb9ca566b8, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContextProvider, $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext] = $9d584503d9945f04$var$$a093c7e1ec25a057$var$createTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $9d584503d9945f04$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipProviderContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $exYeM.useState)(null);
    const contentId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const openTimerRef = (0, $exYeM.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $exYeM.useRef)(false);
    const [open1 = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $exYeM.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open1
    ]);
    const handleOpen = (0, $exYeM.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $exYeM.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $exYeM.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $exYeM.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $exYeM.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$28c660c63b792dea, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $9d584503d9945f04$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipProviderContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $exYeM.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $exYeM.useRef)(false);
    const handlePointerUp = (0, $exYeM.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $exYeM.useEffect)(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (event.pointerType === "touch") return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener("pointerup", handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$8c610744efcf8a1d, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$9d584503d9945f04$var$$a093c7e1ec25a057$var$PortalProvider, $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePortalContext] = $9d584503d9945f04$var$$a093c7e1ec25a057$var$createTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $9d584503d9945f04$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$7b36b8f925ab7497, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $9d584503d9945f04$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePortalContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipProviderContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $exYeM.useState)(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = (0, $exYeM.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $exYeM.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $9d584503d9945f04$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $9d584503d9945f04$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $9d584503d9945f04$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $9d584503d9945f04$var$$a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$9d584503d9945f04$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
const [$9d584503d9945f04$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $9d584503d9945f04$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $9d584503d9945f04$var$$a093c7e1ec25a057$var$createTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $9d584503d9945f04$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useTooltipContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context; // Close this tooltip if another one opens
    (0, $exYeM.useEffect)(()=>{
        document.addEventListener($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($9d584503d9945f04$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $exYeM.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
            "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
            "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45), null, children), /*#__PURE__*/ (0, $exYeM.createElement)($9d584503d9945f04$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$be92b6f5f03c0fe9), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$e9003e2be37ec060, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $9d584503d9945f04$var$$a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $9d584503d9945f04$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $9d584503d9945f04$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $9d584503d9945f04$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($9d584503d9945f04$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($9d584503d9945f04$export$c27ee0ad710f7559, {
    displayName: $9d584503d9945f04$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $9d584503d9945f04$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $9d584503d9945f04$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $9d584503d9945f04$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $9d584503d9945f04$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $9d584503d9945f04$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $9d584503d9945f04$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $9d584503d9945f04$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $9d584503d9945f04$export$2881499e37b75b9a = $9d584503d9945f04$export$f78649fb9ca566b8;
const $9d584503d9945f04$export$be92b6f5f03c0fe9 = $9d584503d9945f04$export$28c660c63b792dea;
const $9d584503d9945f04$export$41fb9f06171c75f4 = $9d584503d9945f04$export$8c610744efcf8a1d;
const $9d584503d9945f04$export$602eac185826482c = $9d584503d9945f04$export$7b36b8f925ab7497;
const $9d584503d9945f04$export$7c6e2c02157bb7d2 = $9d584503d9945f04$export$e9003e2be37ec060;
const $9d584503d9945f04$export$21b07c8f274aebd5 = $9d584503d9945f04$export$c27ee0ad710f7559;


parcelRequire("exYeM");



const $a0c7f499bddc1d8f$export$e9003e2be37ec060 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($9d584503d9945f04$export$7c6e2c02157bb7d2, {
    zIndex: "999999"
});
const $a0c7f499bddc1d8f$export$b6f66dee6916bf4e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    borderRadius: "$md",
    padding: "$5 $10",
    boxShadow: "5px 5px 10px 0px rgba(0, 0, 0, 0.10)",
    backgroundColor: "$neutral200",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral500"
    }
});
const $a0c7f499bddc1d8f$export$f9885a8ac96d941c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


function $273666b35d34bd80$export$28c660c63b792dea(props) {
    const { children: children, content: content, color: color, sideOffset: sideOffset, container: container, open: open, side: side = "top", styles: styles, align: align, alignOffset: alignOffset, collisionPadding: collisionPadding } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($9d584503d9945f04$export$2881499e37b75b9a, {
        delayDuration: 0,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($9d584503d9945f04$export$be92b6f5f03c0fe9, {
            open: open,
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($9d584503d9945f04$export$41fb9f06171c75f4, {
                    asChild: true,
                    style: styles?.root,
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0c7f499bddc1d8f$export$f9885a8ac96d941c), {
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($9d584503d9945f04$export$602eac185826482c, {
                    container: container,
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0c7f499bddc1d8f$export$e9003e2be37ec060), {
                        alignOffset: alignOffset,
                        align: align,
                        side: side,
                        sideOffset: sideOffset,
                        collisionPadding: collisionPadding,
                        collisionBoundary: container,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0c7f499bddc1d8f$export$b6f66dee6916bf4e), {
                            css: styles?.content,
                            variant: "label",
                            size: "medium",
                            color: color,
                            children: content
                        })
                    })
                })
            ]
        })
    });
}



parcelRequire("exYeM");

function $bf240020059341c1$export$2e47cedab3b3b640(props) {
    const MAX_DECIMALS = 12;
    const formattedNumber = Number(props.content).toFixed(props.maxDecimals || MAX_DECIMALS).replace(/(?:\.0*|(\.\d+?)0*)$/, "$1");
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $273666b35d34bd80$export$28c660c63b792dea), {
        ...props,
        content: formattedNumber
    });
}






const $c62a208cc950240e$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xs",
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $c62a208cc950240e$export$1ff3c3f08ae963c0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $foreground"
});
const $c62a208cc950240e$export$2c99b98b77550cb4 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "$16",
    height: "$16",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $c62a208cc950240e$var$blinker = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "50%": {
        opacity: 0.2
    }
});
const $c62a208cc950240e$export$25fefe78d771888d = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center",
    cursor: "default",
    "&.feeSection": {
        cursor: "pointer",
        "&:hover": {
            svg: {
                color: "$secondary"
            },
            "._typography": {
                color: "$secondary"
            }
        }
    },
    "&.warning": {
        animation: `${$c62a208cc950240e$var$blinker} 2s linear infinite`,
        svg: {
            color: "$warning500"
        },
        "._typography": {
            color: "$warning500"
        }
    }
});


function $d1d7703f2e2f8b84$export$9f6f00ee434c7351(props) {
    const { fee: fee, time: time, steps: steps, onClickFee: onClickFee, tooltipGas: tooltipGas, feeWarning: feeWarning, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $c62a208cc950240e$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $273666b35d34bd80$export$28c660c63b792dea), {
                container: tooltipContainer,
                content: tooltipGas,
                open: !onClickFee && !tooltipGas ? false : undefined,
                side: "bottom",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: `${(0, $c62a208cc950240e$export$25fefe78d771888d)()} ${onClickFee ? "feeSection" : ""} ${feeWarning ? "warning" : ""}`,
                    onClick: onClickFee,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: (0, $c62a208cc950240e$export$2c99b98b77550cb4)(),
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $06af9c266b4fd351$export$2e2bcd8739ae039), {
                                size: 12,
                                color: "gray"
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            align: "center",
                            variant: "body",
                            size: "small",
                            children: [
                                "$",
                                fee
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c62a208cc950240e$export$1ff3c3f08ae963c0), {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $c62a208cc950240e$export$25fefe78d771888d)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: (0, $c62a208cc950240e$export$2c99b98b77550cb4)(),
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7aa76ffc74c20c04$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "gray"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        align: "center",
                        variant: "body",
                        size: "small",
                        children: time
                    })
                ]
            }),
            !!steps && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c62a208cc950240e$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: (0, $c62a208cc950240e$export$25fefe78d771888d)(),
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: (0, $c62a208cc950240e$export$2c99b98b77550cb4)(),
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e1a9317fa9c0dcf9$export$2e2bcd8739ae039), {
                                    size: 16,
                                    color: "gray"
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                direction: "horizontal",
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                align: "center",
                                variant: "body",
                                size: "small",
                                children: steps
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





parcelRequire("exYeM");


const $5f0bf9abd576da50$export$e7b977ac5c55d779 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({});
const $5f0bf9abd576da50$export$af3b7d3c8d59acc5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$neutral400",
    borderRadius: "$xs",
    padding: "$2 $5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        type: {
            RECOMMENDED: {
                [`& .${$5f0bf9abd576da50$export$e7b977ac5c55d779}`]: {
                    color: "$secondary500",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        color: "$secondary250"
                    }
                }
            },
            FASTEST: {
                [`& .${$5f0bf9abd576da50$export$e7b977ac5c55d779}`]: {
                    color: "$success500"
                }
            },
            HIGH_IMPACT: {
                [`& .${$5f0bf9abd576da50$export$e7b977ac5c55d779}`]: {
                    color: "$error500"
                }
            },
            LOWEST_FEE: {
                [`& .${$5f0bf9abd576da50$export$e7b977ac5c55d779}`]: {
                    color: "#FF4DAD"
                }
            },
            CENTRALIZED: {
                [`& .${$5f0bf9abd576da50$export$e7b977ac5c55d779}`]: {
                    color: "$warning500"
                }
            }
        }
    }
});


const $e2b30e6c1e3602cc$export$349442539731427c = (props)=>{
    const { value: value, label: label } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5f0bf9abd576da50$export$af3b7d3c8d59acc5), {
        type: value,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "small",
            className: (0, $5f0bf9abd576da50$export$e7b977ac5c55d779)(),
            children: label
        })
    });
};






const $b344959151d6baeb$export$6734e3695501c0ee = 3;
const $b344959151d6baeb$export$947a80214a9ca07b = 10;
const $b344959151d6baeb$var$MAX_AMOUNT_LENGTH_DISPLAY = 4;
const $b344959151d6baeb$var$MAX_NAME_LENGTH_DISPLAY = 6;
function $b344959151d6baeb$export$37f14c58fa1a3fcb(amount) {
    if (!amount || amount.length <= $b344959151d6baeb$var$MAX_AMOUNT_LENGTH_DISPLAY) return amount;
    return amount.slice(0, $b344959151d6baeb$var$MAX_AMOUNT_LENGTH_DISPLAY) + "...";
}
function $b344959151d6baeb$export$e139cb72a374c7ad(name) {
    if (!name || name.length <= $b344959151d6baeb$var$MAX_NAME_LENGTH_DISPLAY) return name;
    return name.slice(0, $b344959151d6baeb$var$MAX_NAME_LENGTH_DISPLAY) + "...";
}
function $b344959151d6baeb$export$254a955910945df1(tag, t) {
    const data = {
        CENTRALIZED: t("Centralized"),
        FASTEST: t("Fastest"),
        HIGH_IMPACT: t("High Impact"),
        LOWEST_FEE: t("Lowest Fee"),
        RECOMMENDED: t("Recommended")
    };
    return data[tag];
}



parcelRequire("exYeM");




parcelRequire("exYeM");


const $a1ea7d3509815a6c$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
});
const $a1ea7d3509815a6c$export$f9eb9b061a8738e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& ._typography": {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    },
    variants: {
        hasWarning: {
            true: {
                "& ._typography": {
                    color: "$warning500"
                }
            }
        },
        hasError: {
            true: {
                "& ._typography": {
                    color: "$error500"
                }
            }
        }
    }
});


function $8c357132bc764382$export$7933e639b40d0e01(props) {
    const { size: size = "medium", outputUsdValue: outputUsdValue, outputColor: outputColor, realOutputUsdValue: realOutputUsdValue, percentageChange: percentageChange, warningLevel: warningLevel, error: error, tooltipProps: tooltipProps, ...rest } = props;
    const hasWarning = !outputUsdValue || warningLevel === "low";
    const hasError = warningLevel === "high";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $a1ea7d3509815a6c$export$42a852a2b6b56249), {
        ...rest,
        children: [
            outputUsdValue && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                content: realOutputUsdValue,
                container: tooltipProps?.container,
                open: !realOutputUsdValue || realOutputUsdValue === "0" ? false : undefined,
                side: tooltipProps?.side,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a1ea7d3509815a6c$export$f9eb9b061a8738e), {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: size,
                        variant: "body",
                        color: outputColor,
                        children: outputUsdValue === "0" ? "0.00" : `~$${outputUsdValue}`
                    })
                })
            }),
            (outputUsdValue && percentageChange || !outputUsdValue) && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $a1ea7d3509815a6c$export$f9eb9b061a8738e), {
                hasError: hasError,
                hasWarning: hasWarning,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: size,
                        variant: "body",
                        children: [
                            outputUsdValue && percentageChange && `(${percentageChange.includes("-") ? percentageChange : `-${percentageChange}`}${percentageChange ? "%" : "-"})`,
                            !outputUsdValue && error
                        ]
                    })
                ]
            })
        ]
    });
}




const $5210cc354d2b51e6$export$b5b6a7470c1d9e07 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({});
const $5210cc354d2b51e6$export$11b902a59791d036 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $5210cc354d2b51e6$export$253df7dc30f737bc = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    border: "1px solid",
    padding: "$20 $15",
    backgroundColor: "$neutral200",
    borderRadius: "$xm",
    cursor: "pointer",
    gap: "$20",
    display: "flex",
    flexDirection: "column",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral500"
    },
    "&:hover": {
        backgroundColor: "$neutral300",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral400"
        }
    },
    variants: {
        selected: {
            true: {
                $$color: "$colors$secondary500",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary250"
                },
                borderColor: "$$color"
            },
            false: {
                borderColor: "transparent"
            }
        },
        hovered: {
            true: {
                "&:hover": {
                    backgroundColor: "$neutral200",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral500"
                    }
                }
            }
        }
    }
});
const $5210cc354d2b51e6$export$82c5ac23db8ef240 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    variants: {
        loading: {
            true: {
                padding: "$2"
            }
        }
    }
});
const $5210cc354d2b51e6$export$331084b24da1eef5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    gap: "$5"
});
const $5210cc354d2b51e6$export$fb587a27d5a722e7 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    height: "85px"
});
const $5210cc354d2b51e6$export$3ced97e5087256a2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$10 $5 $5 0",
    height: "100px",
    display: "flex",
    width: "100%",
    variants: {
        isHovered: {
            true: {
                backgroundColor: "$neutral400",
                boxShadow: "4px 4px 10px 0 #0000001A",
                borderRadius: "$xs",
                zIndex: 10
            }
        }
    }
});
const $5210cc354d2b51e6$export$cabfe84f37bb5841 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    height: "100%"
});
const $5210cc354d2b51e6$export$b08bf0dceef77d4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    minWidth: "42px",
    position: "relative",
    variants: {
        isInternalSwap: {
            true: {
                flexDirection: "column",
                gap: "$5",
                "& .token-info": {
                    position: "static",
                    flexDirection: "column-reverse"
                }
            }
        }
    }
});
const $5210cc354d2b51e6$export$aab1ace5c1c1541d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    height: "50%",
    borderBottom: "1px dashed",
    borderColor: "$secondary200",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    gap: "2px",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        borderColor: "$secondary550"
    }
});
const $5210cc354d2b51e6$export$47d8a00fffa4e400 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    position: "absolute",
    flexDirection: "column",
    bottom: 0,
    left: 0,
    right: 0,
    [`& .${$5210cc354d2b51e6$export$b5b6a7470c1d9e07}`]: {
        color: "$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    }
});
const $5210cc354d2b51e6$export$9f147dc32a27e4be = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    flexDirection: "column",
    "& ._typography": {
        color: "$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    }
});
const $5210cc354d2b51e6$export$c4564903776fef93 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    flexDirection: "column",
    width: "fit-content"
});
const $5210cc354d2b51e6$export$ea11e202301c755c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    position: "relative"
});
const $5210cc354d2b51e6$export$ab38450d76302a54 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    borderRadius: "$lg",
    position: "relative",
    width: "$24",
    height: "$24",
    border: "1px solid transparent",
    variants: {
        state: {
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $5210cc354d2b51e6$export$9ae29657c885eef1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    borderRadius: "$lg",
    position: "absolute",
    width: "$10",
    height: "$10",
    bottom: -3,
    right: -3,
    variants: {
        type: {
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            }
        }
    }
});
const $5210cc354d2b51e6$export$64fe411fc3cd7b17 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    flexDirection: "column",
    paddingLeft: "$8"
});
const $5210cc354d2b51e6$export$ceb1bc6d1dff5ae8 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "calc(50% + 1px)",
    borderRight: "1px dashed",
    height: "$10",
    borderColor: "$secondary200",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        borderColor: "$secondary550"
    }
});
const $5210cc354d2b51e6$export$67fdf4d37dbe2e64 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $8c357132bc764382$export$7933e639b40d0e01), {
    justifyContent: "center",
    gap: "$4"
});
const $5210cc354d2b51e6$export$663c37645b18b3d = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    position: "relative",
    "&::after": {
        content: "",
        position: "absolute",
        bottom: "-6px",
        right: "-3px",
        transform: "translate(-50%, -50%) rotate(45deg)",
        width: "$6",
        height: "$6",
        borderTop: "2px solid",
        borderRight: "2px solid",
        borderColor: "$secondary200",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            borderColor: "$secondary550"
        }
    }
});
const $5210cc354d2b51e6$export$1ff3c3f08ae963c0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $neutral700"
});
const $5210cc354d2b51e6$export$fe825d25d9426347 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    padding: "$10 $2 0",
    height: "85px",
    gap: "$10",
    flexDirection: "column"
});
const $5210cc354d2b51e6$export$e47245de49fa77f7 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    paddingTop: "$25"
});
const $5210cc354d2b51e6$export$44ec04c6081e3a25 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "$10"
});
const $5210cc354d2b51e6$export$fd7ac08b5fcaeea = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    variants: {
        hasFooter: {
            true: {
                paddingBottom: "$5",
                borderBottom: "1px solid",
                borderColor: "$neutral500",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    borderColor: "$neutral800"
                }
            }
        }
    }
});
const $5210cc354d2b51e6$export$a191041dd4ce0669 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($5210cc354d2b51e6$export$11b902a59791d036, {
    width: "100%",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "$10"
});
const $5210cc354d2b51e6$export$f04a61298a47a40f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingBottom: "$20"
});


function $e82f39539289477f$export$171a4533b2ae49b5() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$11b902a59791d036), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                        width: 57.5,
                        variant: "text",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                        width: 57.5,
                        variant: "text",
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$1ff3c3f08ae963c0), {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                        width: 25.5,
                        variant: "text",
                        size: "large"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$11b902a59791d036), {
                css: {
                    gap: "$5"
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                    width: 153,
                    variant: "text",
                    size: "large"
                })
            })
        ]
    });
}
function $e82f39539289477f$export$53e20f7fa219f29d() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$fe825d25d9426347), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                useAsPlaceholder: true,
                size: "large",
                chainImage: "",
                tokenImage: "",
                loading: true
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "rounded",
                width: 122,
                height: 29
            })
        ]
    });
}
function $e82f39539289477f$export$c3b8634856a026cb() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$e47245de49fa77f7), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
            variant: "rounded",
            width: 42,
            height: 49
        })
    });
}
function $e82f39539289477f$export$75e9455d3ac36b12() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$11b902a59791d036), {
        css: {
            flexDirection: "column",
            gap: "$2"
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 30,
                height: 30
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$ceb1bc6d1dff5ae8), {
                css: {
                    width: "unset"
                }
            })
        ]
    });
}




parcelRequire("exYeM");




function $6a8718a31a43396f$export$2cc5788f206d44e2(props) {
    const { style: style = {}, chainImage: chainImage, tokenImage: tokenImage, tooltipProps: tooltipProps, amount: amount, name: name, isInternalSwap: isInternalSwap, size: size = "xmedium" } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$b08bf0dceef77d4), {
        style: style,
        isInternalSwap: isInternalSwap,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                size: size,
                chainImage: chainImage,
                tokenImage: tokenImage
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$47d8a00fffa4e400), {
                className: "token-info",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                        content: tooltipProps?.content,
                        container: tooltipProps?.container,
                        side: "bottom",
                        open: tooltipProps?.open,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            size: "xsmall",
                            variant: "body",
                            className: isInternalSwap ? (0, $5210cc354d2b51e6$export$b5b6a7470c1d9e07)() : "",
                            children: amount
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        className: (0, $5210cc354d2b51e6$export$b5b6a7470c1d9e07)(),
                        children: name
                    })
                ]
            })
        ]
    });
}




parcelRequire("exYeM");







function $40b33b978b5f0336$export$e9003e2be37ec060(props) {
    const { internalSwaps: internalSwaps, time: time, fee: fee, alerts: alerts } = props;
    const hasInternalSwaps = !!internalSwaps.length;
    const hasFooter = hasInternalSwaps || !!alerts;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$44ec04c6081e3a25), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$fd7ac08b5fcaeea), {
                hasFooter: hasFooter,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d1d7703f2e2f8b84$export$9f6f00ee434c7351), {
                    fee: fee,
                    time: time
                })
            }),
            hasFooter && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$a191041dd4ce0669), {
                children: [
                    hasInternalSwaps && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "xsmall",
                                variant: "body",
                                children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Aggregated Transaction")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$11b902a59791d036), {
                                style: {
                                    padding: "2px"
                                },
                                children: internalSwaps.map((internalSwap, index, arr)=>{
                                    const key = `internal-item-${index}`;
                                    const isLastItem = index === arr.length - 1;
                                    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$11b902a59791d036), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6a8718a31a43396f$export$2cc5788f206d44e2), {
                                                isInternalSwap: true,
                                                size: "small",
                                                chainImage: internalSwap.from.chain.image,
                                                tokenImage: internalSwap.from.token?.image || "",
                                                name: internalSwap.from.token?.displayName,
                                                amount: internalSwap.from.price?.value
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$f04a61298a47a40f), {
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
                                                    color: "black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$9f147dc32a27e4be), {
                                                style: {
                                                    paddingBottom: "10px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$ab38450d76302a54), {
                                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                                                            size: 16,
                                                            type: "circular",
                                                            src: internalSwap.swapper.image
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                        size: 2
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                        size: "xsmall",
                                                        variant: "body",
                                                        align: "center",
                                                        children: internalSwap.swapper.displayName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$f04a61298a47a40f), {
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
                                                    color: "black"
                                                })
                                            }),
                                            isLastItem && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6a8718a31a43396f$export$2cc5788f206d44e2), {
                                                    isInternalSwap: true,
                                                    size: "small",
                                                    chainImage: internalSwap.to.chain.image,
                                                    tokenImage: internalSwap.to.token?.image || "",
                                                    name: internalSwap.to.token?.displayName,
                                                    amount: internalSwap.to.price?.value
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    }),
                    alerts
                ]
            })
        ]
    });
}


function $5da5afbb006dfcd7$export$68c79565df9aee60(props) {
    const { loading: loading, percentageChange: percentageChange, warningLevel: warningLevel, tooltipContainer: tooltipContainer, onClick: onClick, feeWarning: feeWarning, selected: selected = false } = props;
    const [hoveredItemIndex, setHoveredItemIndex] = (0, $exYeM.useState)(null);
    const steps = loading ? Array((0, $b344959151d6baeb$export$6734e3695501c0ee)).fill(undefined) : props.steps;
    const numberOfSteps = steps.length;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$253df7dc30f737bc), {
        selected: selected,
        onClick: onClick,
        hovered: hoveredItemIndex !== null,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$82c5ac23db8ef240), {
                loading: loading,
                children: loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e82f39539289477f$export$171a4533b2ae49b5), {}) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d1d7703f2e2f8b84$export$9f6f00ee434c7351), {
                            fee: props.fee,
                            time: props.time,
                            steps: numberOfSteps,
                            feeWarning: feeWarning
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$331084b24da1eef5), {
                            children: props.tags.map((tag)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e2b30e6c1e3602cc$export$349442539731427c), {
                                    label: (0, $b344959151d6baeb$export$254a955910945df1)(tag.value, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t),
                                    value: tag.value
                                }, tag.label))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$fb587a27d5a722e7), {
                children: [
                    steps.map((step, index)=>{
                        const key = `item-${index}`;
                        const isStepHovered = hoveredItemIndex === index;
                        const isLastItem = index === numberOfSteps - 1;
                        const isFirstItem = index === 0;
                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$3ced97e5087256a2), {
                            isHovered: isStepHovered,
                            style: {
                                marginLeft: !isFirstItem && !loading ? "-47px" : "0px"
                            },
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $273666b35d34bd80$export$28c660c63b792dea), {
                                container: tooltipContainer,
                                side: "bottom",
                                align: isLastItem && !isFirstItem ? "end" : "start",
                                sideOffset: (0, $b344959151d6baeb$export$947a80214a9ca07b),
                                open: !loading && isStepHovered,
                                styles: {
                                    root: {
                                        width: "100%"
                                    },
                                    content: {
                                        borderRadius: "5px",
                                        padding: "10px",
                                        backgroundColor: "$neutral400 !important"
                                    }
                                },
                                content: !loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $40b33b978b5f0336$export$e9003e2be37ec060), {
                                    internalSwaps: step.internalSwaps || [],
                                    time: step.time || "",
                                    fee: step.fee || "",
                                    alerts: step.alerts
                                }) : null,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$cabfe84f37bb5841), {
                                    children: [
                                        loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e82f39539289477f$export$c3b8634856a026cb), {}) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6a8718a31a43396f$export$2cc5788f206d44e2), {
                                            style: {
                                                opacity: hoveredItemIndex === index - 1 ? 0 : 1
                                            },
                                            chainImage: step.from.chain.image,
                                            tokenImage: step.from.token.image,
                                            amount: isStepHovered ? (0, $b344959151d6baeb$export$37f14c58fa1a3fcb)(step.from.price.value) : step.from.price.value,
                                            name: isStepHovered ? (0, $b344959151d6baeb$export$e139cb72a374c7ad)(step.from.token.displayName) : step.from.token.displayName,
                                            tooltipProps: {
                                                content: step.from.price.realValue,
                                                open: !step.from.price.realValue ? false : undefined,
                                                container: tooltipContainer
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$aab1ace5c1c1541d), {
                                            className: isLastItem ? (0, $5210cc354d2b51e6$export$663c37645b18b3d)() : "",
                                            children: loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e82f39539289477f$export$75e9455d3ac36b12), {}) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$9f147dc32a27e4be), {
                                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$c4564903776fef93), {
                                                            onMouseEnter: ()=>setHoveredItemIndex(index),
                                                            onMouseLeave: ()=>setHoveredItemIndex(null),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$ea11e202301c755c), {
                                                                    children: [
                                                                        !step.internalSwaps ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$ab38450d76302a54), {
                                                                            state: step.state,
                                                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                                                                                size: 22,
                                                                                type: "circular",
                                                                                src: step.swapper.image
                                                                            })
                                                                        }) : step.internalSwaps.map((internalswap, iIndex)=>{
                                                                            const key = `${iIndex}-swapper-image`;
                                                                            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$ab38450d76302a54), {
                                                                                state: step.state,
                                                                                style: {
                                                                                    marginLeft: iIndex !== 0 ? "-10px" : "0px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                                                                                    size: 22,
                                                                                    type: "circular",
                                                                                    src: internalswap.swapper.image
                                                                                })
                                                                            }, key);
                                                                        }),
                                                                        step.state && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$9ae29657c885eef1), {
                                                                            type: step.state,
                                                                            children: step.state === "error" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a4b9d4c09097b8a0$export$2e2bcd8739ae039), {
                                                                                size: 8,
                                                                                color: "error"
                                                                            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), {
                                                                                size: 8,
                                                                                color: "warning"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                                    size: 2
                                                                }),
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                                    size: "xsmall",
                                                                    variant: "body",
                                                                    align: "center",
                                                                    children: step.swapper.displayName
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$ceb1bc6d1dff5ae8), {})
                                                ]
                                            })
                                        }),
                                        !loading && !isLastItem && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6a8718a31a43396f$export$2cc5788f206d44e2), {
                                            style: {
                                                opacity: isStepHovered ? 1 : 0
                                            },
                                            chainImage: step.to.chain.image,
                                            tokenImage: step.to.token.image,
                                            amount: (0, $b344959151d6baeb$export$37f14c58fa1a3fcb)(step.to.price.value),
                                            name: (0, $b344959151d6baeb$export$e139cb72a374c7ad)(step.to.token.displayName)
                                        }),
                                        !loading && isLastItem && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $5210cc354d2b51e6$export$64fe411fc3cd7b17), {
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                                                    chainImage: step.to.chain.image,
                                                    tokenImage: step.to.token.image,
                                                    size: "medium"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                    size: 4
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                                        content: props.outputPrice.realValue,
                                                        container: tooltipContainer,
                                                        open: !props.outputPrice.realValue ? false : undefined,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                                size: "xmedium",
                                                                variant: "title",
                                                                children: props.outputPrice.value
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                                size: 4,
                                                                direction: "horizontal"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                                size: "xmedium",
                                                                variant: "title",
                                                                children: step.to.token.displayName
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5210cc354d2b51e6$export$67fdf4d37dbe2e64), {
                                                    size: "small",
                                                    warningLevel: warningLevel,
                                                    outputUsdValue: props.outputPrice.usdValue,
                                                    realOutputUsdValue: props.outputPrice.realUsdValue,
                                                    percentageChange: percentageChange,
                                                    tooltipProps: {
                                                        container: tooltipContainer
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, key);
                    }),
                    loading && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e82f39539289477f$export$53e20f7fa219f29d), {})
                ]
            })
        ]
    });
}





parcelRequire("exYeM");



const $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26 = 20;


const $47ecf8363847a2fc$export$2734916e8cdc97ea = (0, $5f9225ad5bc3d601$export$db53682eef82cc11)({
    ".rng-scrolled": {
        ".rng-curve-left::before, rng-curve-right::before": {
            borderRadius: "0 !important"
        }
    }
});
const $47ecf8363847a2fc$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    padding: "$20 $20 $15 $20",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    position: "relative",
    variants: {
        titlePosition: {
            left: {
                justifyContent: "start"
            },
            center: {
                justifyContent: "center"
            },
            right: {
                justifyContent: "end"
            }
        }
    },
    ".rng-curve-left,.rng-curve-right": {
        width: (0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26) * 2,
        height: (0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26) * 2,
        position: "absolute",
        bottom: 0,
        overflow: "hidden",
        transform: "translateY(100%)",
        "&:before": {
            width: (0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26) * 2,
            height: (0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26) * 2,
            display: "block",
            content: "",
            position: "absolute",
            bottom: 0,
            borderRadius: "50%",
            transition: "border-radius 0.5s"
        }
    },
    ".rng-curve-left": {
        left: 0,
        "&:before": {
            left: 0,
            boxShadow: `-${(0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26)}px -${(0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26)}px 0 0 $$color`
        }
    },
    ".rng-curve-right": {
        right: 0,
        "&:before": {
            right: 0,
            boxShadow: `${(0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26)}px -${(0, $e9f0f2dd5a7d33bd$export$3c5592d0d0c22a26)}px 0 0 $$color`
        }
    }
});
const $47ecf8363847a2fc$export$e77cfe0b08ec163 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    left: "$20",
    display: "flex",
    alignItems: "center",
    gap: "$5"
});
const $47ecf8363847a2fc$export$6fe455b424bdaa07 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    right: "$20",
    display: "flex",
    alignItems: "center",
    gap: "$5"
});


function $9616dbef4dcfe531$export$8b251419efc915eb({ prefix: prefix, suffix: suffix, title: title }) {
    (0, $47ecf8363847a2fc$export$2734916e8cdc97ea)();
    const getTitlePosition = ()=>{
        if (!prefix) return "left";
        if (!suffix) return "right";
        return "center";
    };
    const renderTitle = ()=>{
        if (!title) return null;
        else if (typeof title === "string") return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "headline",
            size: "small",
            children: title
        });
        return title;
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $47ecf8363847a2fc$export$42a852a2b6b56249), {
        titlePosition: getTitlePosition(),
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $47ecf8363847a2fc$export$e77cfe0b08ec163), {
                children: prefix
            }),
            renderTitle(),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $47ecf8363847a2fc$export$6fe455b424bdaa07), {
                children: suffix
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "rng-curve-left"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "rng-curve-right"
            })
        ]
    });
}







var $exYeM = parcelRequire("exYeM");






// https://github.com/reactjs/react-transition-group/blob/master/src/CSSTransition.js#L48-L55
function $fb7c7d3e48ee4678$export$7d26bbb1236dafd6(node) {
    return node.scrollTop;
}




const $3955bea98e972974$export$e14f8c8d1fddbcd6 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    zIndex: 10,
    borderRadius: "$primary",
    overflow: "hidden",
    transition: "background .35s",
    variants: {
        active: {
            true: {
                backgroundColor: "color-mix(in srgb, $neutral500 70%, transparent)"
            }
        }
    }
});
const $3955bea98e972974$export$c9554889b3e706cd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$background",
    width: "100%",
    borderRadius: "$primary",
    display: "flex",
    flexDirection: "column",
    zIndex: 9999999,
    position: "absolute",
    transition: "transform .45s ease-in-out, top .45s ease-in-out, left .45s ease-in-out",
    variants: {
        anchor: {
            right: {
                left: "100%"
            },
            center: {
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)"
            },
            bottom: {
                top: "100%"
            }
        },
        active: {
            true: {}
        }
    },
    compoundVariants: [
        {
            active: true,
            anchor: "right",
            css: {
                transform: "translateX(-100%)"
            }
        },
        {
            active: true,
            anchor: "center",
            css: {
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            }
        },
        {
            active: true,
            anchor: "bottom",
            css: {
                transform: "translateY(-100%)"
            }
        }
    ]
});
const $3955bea98e972974$export$f51f4c4ede09e011 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    [`& ${0, $4c39613e9fff7ff6$export$c25acd513dcc8062}`]: {
        padding: "$5"
    }
});
const $3955bea98e972974$export$f50a68e3694789ee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $0 $20",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    variants: {
        noTitle: {
            true: {
                justifyContent: "flex-end"
            }
        }
    }
});
const $3955bea98e972974$export$7c6e2c02157bb7d2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: "$0 $20 $10 $20",
    backgroundColor: "$background",
    position: "relative",
    overflowY: "auto",
    overflowX: "hidden"
});
const $3955bea98e972974$export$a06f1c675e846f6f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "0 $20 $10",
    "& .footer__logo": {
        "&.logo__show": {
            opacity: 1
        },
        "&.logo__hidden": {
            visibility: "hidden"
        }
    }
});


function $8f7c1be9e0a4b3b4$export$2b77a92f1a5ad772(props) {
    const { title: title, open: open, onClose: onClose, onExit: onExit, styles: styles, anchor: anchor = "bottom", container: container = document.body, prefix: prefix, header: header, dismissible: dismissible = true, children: children, suffix: suffix, footer: footer, hasWatermark: hasWatermark = true, hasCloseIcon: hasCloseIcon = true } = props;
    const [status, setStatus] = (0, $exYeM.useState)("unmounted");
    const active = status === "activated";
    const isMount = status == "mounted" || status === "activated" || status === "deactivated";
    const modalContainerRef = (0, $exYeM.useRef)(null);
    const exitCallbackRef = (0, $exYeM.useRef)();
    const handleBackDropClick = (event)=>{
        event.stopPropagation();
        if (event.target === event.currentTarget && dismissible) onClose();
    };
    (0, $exYeM.useEffect)(()=>{
        exitCallbackRef.current = onExit;
    }, [
        onExit
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (exitCallbackRef.current) modalContainerRef.current?.addEventListener("transitionend", exitCallbackRef.current);
        if (!open) {
            if (status === "activated") {
                setStatus("deactivated");
                modalContainerRef.current?.addEventListener("transitionend", ()=>{
                    setStatus("unmounted");
                    container.style.removeProperty("overflow");
                });
            } else setStatus("unmounted");
        } else {
            setStatus("mounted");
            container.style.overflow = "hidden";
        }
        return ()=>{
            if (exitCallbackRef.current) modalContainerRef.current?.removeEventListener("transitionend", exitCallbackRef.current);
        };
    }, [
        open
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            //container might be null
            container?.style.removeProperty("overflow");
        };
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (!!container && isMount) {
            if (modalContainerRef.current) (0, $fb7c7d3e48ee4678$export$7d26bbb1236dafd6)(modalContainerRef.current);
            setStatus("activated");
        }
    }, [
        isMount,
        container
    ]);
    if (status === "unmounted" || !container) return null;
    return /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $3955bea98e972974$export$e14f8c8d1fddbcd6), {
        active: active,
        onClick: handleBackDropClick,
        css: styles?.root,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $3955bea98e972974$export$c9554889b3e706cd), {
            active: active,
            css: styles?.container,
            anchor: anchor,
            ref: (ref)=>modalContainerRef.current = ref,
            children: [
                header ?? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $3955bea98e972974$export$f50a68e3694789ee), {
                    noTitle: !title && dismissible && !prefix,
                    children: [
                        prefix,
                        title && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            variant: "title",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $3955bea98e972974$export$f51f4c4ede09e011), {
                            children: [
                                suffix,
                                dismissible && hasCloseIcon && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
                                    onClick: onClose,
                                    variant: "ghost",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8192be46f8fafa5a$export$2e2bcd8739ae039), {
                                        color: "gray",
                                        size: 14
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $3955bea98e972974$export$7c6e2c02157bb7d2), {
                    css: styles?.content,
                    children: children
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $3955bea98e972974$export$a06f1c675e846f6f), {
                    css: styles?.footer,
                    children: [
                        footer && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "footer__content",
                            children: footer
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: `footer__logo ${hasWatermark ? "logo__show" : "logo__hidden"}`,
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                    size: 12
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $739811eb95ae3c7e$export$11833b2d9103c949), {})
                            ]
                        })
                    ]
                })
            ]
        })
    }), container);
}






parcelRequire("exYeM");



const $27c2a7a361b8afde$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
});
const $27c2a7a361b8afde$export$393edc798c47379d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    textAlign: "center"
});
const $27c2a7a361b8afde$export$9ae29657c885eef1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "50%",
    width: "$45",
    height: "$45",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        type: {
            success: {
                $$color: "$colors$success300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$success600"
                },
                backgroundColor: "$$color"
            },
            warning: {
                $$color: "$colors$warning300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$warning600"
                },
                backgroundColor: "$$color"
            },
            error: {
                $$color: "$colors$error300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$error600"
                },
                backgroundColor: "$$color"
            },
            info: {
                $$color: "$colors$info300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            },
            loading: {
                $$color: "$colors$info300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$info600"
                },
                backgroundColor: "$$color"
            }
        }
    }
});



parcelRequire("exYeM");


function $d3d10e091944bee7$var$StatusIcon(props) {
    switch(props.type){
        case "success":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2728cf0100aeae4d$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "warning":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "error":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a4b9d4c09097b8a0$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
        case "loading":
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $76e484f048f6cf30$export$7f7cbe89f1eacd2), {
                color: "info",
                size: 30
            });
        default:
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d33873eddac739a4$export$2e2bcd8739ae039), {
                color: props.type,
                size: 30
            });
    }
}
var $d3d10e091944bee7$export$2e2bcd8739ae039 = $d3d10e091944bee7$var$StatusIcon;


function $067048c05c356dc5$export$52499e2c5ea4b095(props) {
    const { type: type, title: title, description: description, children: children, icon: icon } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $27c2a7a361b8afde$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $27c2a7a361b8afde$export$9ae29657c885eef1), {
                type: type,
                children: icon || /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d3d10e091944bee7$export$2e2bcd8739ae039), {
                    type: type
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                color: type === "loading" ? "info500" : `${type}500`,
                variant: "title",
                size: "medium",
                children: title
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 16
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $27c2a7a361b8afde$export$393edc798c47379d), {
                children: typeof description === "string" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                    color: "neutral700",
                    variant: "body",
                    size: "medium",
                    children: description
                }) : description
            }),
            children
        ]
    });
}





var $exYeM = parcelRequire("exYeM");





const $abe336573c1b9fad$export$41fb9f06171c75f4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$41fb9f06171c75f4, {
    padding: "$15",
    paddingBottom: "$5",
    borderRadius: "$xm",
    cursor: "pointer",
    $$backgroundColor: "$colors$neutral200",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$backgroundColor: "$colors$neutral500"
    },
    backgroundColor: "$$backgroundColor",
    textAlign: "center",
    border: 0,
    width: "100%",
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    }
});



function $892c2bc6f75a574a$export$523be34b5e7d2d0f(props) {
    const { description: description, status: status, title: title, children: children } = props;
    const [open, setOpen] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($75d51ac32d862af6$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $abe336573c1b9fad$export$41fb9f06171c75f4), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
                    title: title,
                    description: description,
                    type: status
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $19113fa36cc5fa5e$export$aadde00976f34151), {
                    open: open,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                            size: 12
                        }),
                        children
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                    size: 12
                }),
                open ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $37519868f1c889a9$export$2e2bcd8739ae039), {
                    color: "black",
                    size: 16
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
                    color: "black",
                    size: 16
                })
            ]
        })
    });
}







parcelRequire("exYeM");

parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");






var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $ac7c84a01af4e06e$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}









var $exYeM = parcelRequire("exYeM");
const $9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $9cee77c98b858c29$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $9cee77c98b858c29$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $exYeM.useContext)($9cee77c98b858c29$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $9cee77c98b858c29$export$2881499e37b75b9a = $9cee77c98b858c29$export$c760c09fdd558351;


const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $71edc3b1c9a6f9c6$export$c7109489551a4f4] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $71edc3b1c9a6f9c6$export$8699f7c8af148338 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$8699f7c8af148338, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $exYeM.useState)(false);
    const handleEntryFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $exYeM.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $exYeM.useState)(0);
    (0, $exYeM.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $exYeM.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $exYeM.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $exYeM.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $71edc3b1c9a6f9c6$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $exYeM.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($71edc3b1c9a6f9c6$export$ab9df7c53fe8454, {
    displayName: $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $71edc3b1c9a6f9c6$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9 = $71edc3b1c9a6f9c6$export$8699f7c8af148338;
const $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2 = $71edc3b1c9a6f9c6$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/ const $29fa98f89f333569$var$$ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$29fa98f89f333569$var$$ce77a8961b41be9e$var$createRadioContext, $29fa98f89f333569$var$$ce77a8961b41be9e$export$67d2296460f1b002] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($29fa98f89f333569$var$$ce77a8961b41be9e$var$RADIO_NAME);
const [$29fa98f89f333569$var$$ce77a8961b41be9e$var$RadioProvider, $29fa98f89f333569$var$$ce77a8961b41be9e$var$useRadioContext] = $29fa98f89f333569$var$$ce77a8961b41be9e$var$createRadioContext($29fa98f89f333569$var$$ce77a8961b41be9e$var$RADIO_NAME);
const $29fa98f89f333569$var$$ce77a8961b41be9e$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, ...radioProps } = props;
    const [button, setButton] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $exYeM.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /*#__PURE__*/ (0, $exYeM.createElement)($29fa98f89f333569$var$$ce77a8961b41be9e$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        role: "radio",
        "aria-checked": checked,
        "data-state": $29fa98f89f333569$var$$ce77a8961b41be9e$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, radioProps, {
        ref: composedRefs,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            // radios cannot be unchecked so we only communicate a checked state
            if (!checked) onCheck === null || onCheck === void 0 || onCheck();
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect radio updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $exYeM.createElement)($29fa98f89f333569$var$$ce77a8961b41be9e$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($29fa98f89f333569$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, {
    displayName: $29fa98f89f333569$var$$ce77a8961b41be9e$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/ const $29fa98f89f333569$var$$ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $29fa98f89f333569$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $29fa98f89f333569$var$$ce77a8961b41be9e$var$useRadioContext($29fa98f89f333569$var$$ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $29fa98f89f333569$var$$ce77a8961b41be9e$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($29fa98f89f333569$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, {
    displayName: $29fa98f89f333569$var$$ce77a8961b41be9e$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $29fa98f89f333569$var$$ce77a8961b41be9e$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const prevChecked = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("input", (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $29fa98f89f333569$var$$ce77a8961b41be9e$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $29fa98f89f333569$var$$f99a8c78507165f7$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $29fa98f89f333569$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$29fa98f89f333569$var$$f99a8c78507165f7$var$createRadioGroupContext, $29fa98f89f333569$export$c547093f11b76da2] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($29fa98f89f333569$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME, [
    (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4),
    $29fa98f89f333569$var$$ce77a8961b41be9e$export$67d2296460f1b002
]);
const $29fa98f89f333569$var$$f99a8c78507165f7$var$useRovingFocusGroupScope = (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)();
const $29fa98f89f333569$var$$f99a8c78507165f7$var$useRadioScope = $29fa98f89f333569$var$$ce77a8961b41be9e$export$67d2296460f1b002();
const [$29fa98f89f333569$var$$f99a8c78507165f7$var$RadioGroupProvider, $29fa98f89f333569$var$$f99a8c78507165f7$var$useRadioGroupContext] = $29fa98f89f333569$var$$f99a8c78507165f7$var$createRadioGroupContext($29fa98f89f333569$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $29fa98f89f333569$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $29fa98f89f333569$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($29fa98f89f333569$var$$f99a8c78507165f7$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? "" : undefined,
        dir: direction
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($29fa98f89f333569$export$a98f0dcb43a68a25, {
    displayName: $29fa98f89f333569$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $29fa98f89f333569$var$$f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $29fa98f89f333569$export$9f866c100ef519e4 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $29fa98f89f333569$var$$f99a8c78507165f7$var$useRadioGroupContext($29fa98f89f333569$var$$f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $29fa98f89f333569$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $29fa98f89f333569$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($29fa98f89f333569$var$$f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !isDisabled,
        active: checked
    }), /*#__PURE__*/ (0, $exYeM.createElement)($29fa98f89f333569$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        disabled: isDisabled,
        required: context.required,
        checked: checked
    }, radioScope, itemProps, {
        name: context.name,
        ref: composedRefs,
        onCheck: ()=>context.onValueChange(itemProps.value),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)((event)=>{
            // According to WAI ARIA, radio groups don't activate items on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
            var _ref$current;
            /**
       * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
       * and we need to "check" it in that case. We click it to "check" it (instead
       * of updating `context.value`) so that the radio change event fires.
       */ if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
        })
    })));
});
/*#__PURE__*/ Object.assign($29fa98f89f333569$export$9f866c100ef519e4, {
    displayName: $29fa98f89f333569$var$$f99a8c78507165f7$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/ const $29fa98f89f333569$var$$f99a8c78507165f7$var$INDICATOR_NAME = "RadioGroupIndicator";
const $29fa98f89f333569$export$5fb54c671a65c88 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $29fa98f89f333569$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    return /*#__PURE__*/ (0, $exYeM.createElement)($29fa98f89f333569$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, radioScope, indicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($29fa98f89f333569$export$5fb54c671a65c88, {
    displayName: $29fa98f89f333569$var$$f99a8c78507165f7$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $29fa98f89f333569$export$be92b6f5f03c0fe9 = $29fa98f89f333569$export$a98f0dcb43a68a25;
const $29fa98f89f333569$export$6d08773d2e66f8f2 = $29fa98f89f333569$export$9f866c100ef519e4;
const $29fa98f89f333569$export$adb584737d712b70 = $29fa98f89f333569$export$5fb54c671a65c88;



const $398d4319d405c119$export$7c16ae7705e422c4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($29fa98f89f333569$export$6d08773d2e66f8f2, {
    padding: "0",
    width: "16px",
    height: "16px",
    borderRadius: "100%",
    cursor: "pointer",
    backgroundColor: "transparent",
    $$borderColor: "$colors$neutral600",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$borderColor: "$colors$neutral700"
    },
    border: "1px solid $$borderColor",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary250"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    }
});
const $398d4319d405c119$export$bd1caedcf570dd41 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($29fa98f89f333569$export$adb584737d712b70, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    position: "relative",
    "&::after": {
        content: "",
        display: "block",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "$background"
    }
});


function $183ba84fee413071$export$d7b12c4107be0d61(props) {
    const { value: value } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $398d4319d405c119$export$7c16ae7705e422c4), {
        value: value,
        id: value,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $398d4319d405c119$export$bd1caedcf570dd41), {})
    });
}







const $366ceca5f7810d8c$export$4d716843016d54fd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($29fa98f89f333569$export$be92b6f5f03c0fe9, {
    variants: {
        direction: {
            horizontal: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap"
            },
            vertical: {
                display: "grid",
                gridGap: "$24"
            }
        }
    }
});
const $366ceca5f7810d8c$export$ed8671f612970784 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    marginRight: "$8"
});
const $366ceca5f7810d8c$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $366ceca5f7810d8c$export$b04be29aa201d4f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("label", {
    paddingLeft: "$8",
    cursor: "pointer",
    color: "$foreground",
    "& > span": {
        display: "block"
    }
});


function $3b05561cfcf811a5$export$a98f0dcb43a68a25(props) {
    const { value: value, onChange: onChange, direction: direction = "vertical", style: style, options: options } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $366ceca5f7810d8c$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $366ceca5f7810d8c$export$4d716843016d54fd), {
            onValueChange: onChange,
            value: value,
            direction: direction,
            style: style,
            children: options.map((option)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $366ceca5f7810d8c$export$ed8671f612970784), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $183ba84fee413071$export$d7b12c4107be0d61), {
                            value: option.value
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $366ceca5f7810d8c$export$b04be29aa201d4f5), {
                            className: "_text",
                            htmlFor: option.value,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "small",
                                children: option.label
                            })
                        })
                    ]
                }, option.value))
        })
    });
}





/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $exYeM = parcelRequire("exYeM");


const $573e90b4fdf2d1d5$export$df04d8751c537a8b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ellipse", {
    cx: "12.5px",
    cy: "12.5px",
    rx: "7.7px",
    ry: "7.7px",
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: 100,
    transform: `rotate(20deg)`,
    transformOrigin: "center",
    variants: {
        type: {
            "in-progress": {
                stroke: "$info500",
                strokeWidth: 2
            },
            basic: {
                strokeWidth: 1.8
            }
        }
    }
});
const $573e90b4fdf2d1d5$export$6d577df87755bf76 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("path", {
    fill: "$info500"
});


const $de4e1a978c16da60$var$DEFAULT_STROKE_DASHOFFSET = 59;
const $de4e1a978c16da60$var$MAX_PERCENTAGE = 100;
const $de4e1a978c16da60$var$MAX_PROGRESS = 41;
const $de4e1a978c16da60$var$MIN_PROGRESS = 0;
const $de4e1a978c16da60$var$NORMALIZE_FACTOR = 10;
const $de4e1a978c16da60$var$OPACITY_THRESHOLD = 82;
const $de4e1a978c16da60$var$DIVISION_FACTOR = 2;
const $de4e1a978c16da60$var$Ellipse = (props)=>{
    const type = props.progress ? "in-progress" : "basic";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $573e90b4fdf2d1d5$export$df04d8751c537a8b), {
        type: type,
        stroke: "currentColor",
        strokeDashoffset: props.progress || $de4e1a978c16da60$var$DEFAULT_STROKE_DASHOFFSET
    });
};
function $de4e1a978c16da60$export$8d944f010ac3c33e(props) {
    const normalizeValue = (value)=>{
        return (value - $de4e1a978c16da60$var$OPACITY_THRESHOLD) / $de4e1a978c16da60$var$NORMALIZE_FACTOR;
    };
    const normalizedProgress = Math.min(props.progress / $de4e1a978c16da60$var$DIVISION_FACTOR, $de4e1a978c16da60$var$MAX_PROGRESS);
    const opacity = normalizedProgress !== $de4e1a978c16da60$var$MAX_PROGRESS ? $de4e1a978c16da60$var$MIN_PROGRESS : normalizeValue(props.progress);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $1a0d6b8c1d4f8be6$export$dbcb8210e8a983ed), props, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($de4e1a978c16da60$var$Ellipse, {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($de4e1a978c16da60$var$Ellipse, {
                progress: $de4e1a978c16da60$var$MAX_PERCENTAGE - normalizedProgress
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $573e90b4fdf2d1d5$export$6d577df87755bf76), {
                d: "M19.2696 9.6089C19.1207 9.49207 19.0218 9.31141 19.01 9.10738L18.807 5.14476C18.788 4.77467 19.0763 4.45089 19.4464 4.43183C19.8165 4.41278 20.1402 4.70108 20.1593 5.07117L20.3622 9.0338C20.3813 9.40389 20.093 9.72767 19.7229 9.74672C19.5584 9.76661 19.3973 9.70903 19.2696 9.6089Z",
                fillOpacity: opacity
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $573e90b4fdf2d1d5$export$6d577df87755bf76), {
                d: "M15.5108 9.47903C15.3476 9.35108 15.2457 9.14511 15.2505 8.9198C15.2639 8.55221 15.575 8.25778 15.9482 8.26404L19.707 8.3939C20.0802 8.40016 20.3691 8.71837 20.3628 9.09152C20.3565 9.46466 20.0383 9.75353 19.6652 9.74728L15.9007 9.62451C15.7529 9.62312 15.6243 9.56804 15.5108 9.47903Z",
                fillOpacity: opacity
            })
        ]
    }));
}




/* eslint-disable @typescript-eslint/no-magic-numbers */ 

parcelRequire("exYeM");


parcelRequire("14sfz");
var $liigz = parcelRequire("liigz");

var $361160a0016c9549$export$55324dbe813607bf;
(function(BlockchainCategories) {
    BlockchainCategories["ALL"] = "ALL";
    BlockchainCategories["EVM"] = "EVM";
    BlockchainCategories["COSMOS"] = "COSMOS";
    BlockchainCategories["UTXO"] = "UTXO";
    BlockchainCategories["OTHER"] = "OTHER";
})($361160a0016c9549$export$55324dbe813607bf || ($361160a0016c9549$export$55324dbe813607bf = {}));


const $72ff915f8d8218ca$export$7dde0cb4a4d74932 = {
    [(0, $361160a0016c9549$export$55324dbe813607bf).EVM]: (0, $af042e3144c17b49$export$2e2bcd8739ae039),
    [(0, $361160a0016c9549$export$55324dbe813607bf).COSMOS]: (0, $d95c28b579ea6a16$export$2e2bcd8739ae039),
    [(0, $361160a0016c9549$export$55324dbe813607bf).UTXO]: (0, $1b41d781fbb19493$export$2e2bcd8739ae039),
    [(0, $361160a0016c9549$export$55324dbe813607bf).OTHER]: (0, $67c94a0ce4a56966$export$2e2bcd8739ae039)
};
const $72ff915f8d8218ca$export$d88ce295a6b08a0d = {
    [(0, $361160a0016c9549$export$55324dbe813607bf).ALL]: "All",
    [(0, $361160a0016c9549$export$55324dbe813607bf).EVM]: "EVM",
    [(0, $361160a0016c9549$export$55324dbe813607bf).COSMOS]: "Cosmos",
    [(0, $361160a0016c9549$export$55324dbe813607bf).UTXO]: "UTXO",
    [(0, $361160a0016c9549$export$55324dbe813607bf).OTHER]: "Other"
};
const $72ff915f8d8218ca$var$filterByType = (blockchain, type)=>{
    switch(type){
        case (0, $361160a0016c9549$export$55324dbe813607bf).ALL:
            return true;
        case (0, $361160a0016c9549$export$55324dbe813607bf).UTXO:
            return blockchain.type === (0, $liigz.TransactionType).TRANSFER;
        case (0, $361160a0016c9549$export$55324dbe813607bf).OTHER:
            return blockchain.type !== (0, $liigz.TransactionType).TRANSFER && blockchain.type !== (0, $liigz.TransactionType).COSMOS && blockchain.type !== (0, $liigz.TransactionType).EVM;
        default:
            return blockchain.type === type;
    }
};
const $72ff915f8d8218ca$export$fb786c03f215e9c = (list, blockchainType)=>list.some((blockchain)=>$72ff915f8d8218ca$var$filterByType(blockchain, blockchainType));
const $72ff915f8d8218ca$export$f6cff66fe61062ef = (list)=>{
    const categoriesToCheck = Object.values((0, $361160a0016c9549$export$55324dbe813607bf)).filter((category)=>category !== (0, $361160a0016c9549$export$55324dbe813607bf).ALL);
    const categoriesCount = categoriesToCheck.reduce((count, category)=>{
        const isCategoryPresent = list.some((blockchain)=>$72ff915f8d8218ca$var$filterByType(blockchain, category));
        return count + (isCategoryPresent ? 1 : 0);
    }, 0);
    return categoriesCount;
};



const $2817ae733199c6cc$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$10",
    gridTemplateColumns: "auto 1fr 1fr 1fr 1fr"
});
const $2817ae733199c6cc$export$74385c853d1d6d43 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "$10"
});
const $2817ae733199c6cc$export$6d5a3de5dde3e68f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("img", {
    position: "absolute",
    top: -2,
    width: 15,
    height: 15
});



function $d15d2da2f4d97305$export$e15317e9262e7409(props) {
    const { setCategory: setCategory, category: category, isLoading: isLoading, blockchains: blockchains } = props;
    const categories = Object.keys((0, $361160a0016c9549$export$55324dbe813607bf));
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $2817ae733199c6cc$export$42a852a2b6b56249), {
        children: [
            isLoading && Array.from(Array(5), (_, index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                    variant: "rounded",
                    height: 70,
                    width: index === 0 ? 45 : 65
                }, index)),
            !isLoading && categories.map((blockchainCategory)=>{
                const Logo = blockchainCategory !== (0, $361160a0016c9549$export$55324dbe813607bf).ALL ? (0, $72ff915f8d8218ca$export$7dde0cb4a4d74932)[blockchainCategory] : null;
                const hasBlockchain = (0, $72ff915f8d8218ca$export$fb786c03f215e9c)(blockchains, blockchainCategory);
                return hasBlockchain && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b21157a9f19b41cb$export$70f20e53a91f662d), {
                    selected: category === blockchainCategory,
                    onClick: ()=>setCategory(blockchainCategory),
                    children: [
                        Logo && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(Logo, {
                                    size: 28
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                    size: 12
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            size: "xsmall",
                            variant: "body",
                            color: blockchainCategory === (0, $361160a0016c9549$export$55324dbe813607bf).ALL ? "secondary500" : undefined,
                            children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                                id: "{blockchainCategory}",
                                values: {
                                    blockchainCategory: (0, $72ff915f8d8218ca$export$d88ce295a6b08a0d)[blockchainCategory]
                                }
                            })
                        })
                    ]
                }, blockchainCategory);
            })
        ]
    });
}








parcelRequire("exYeM");



function $3c4bce1cc9530e8f$export$b70265791d2079d4(status) {
    switch(status){
        case "failed":
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Failed");
        case "success":
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Completed");
        default:
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("In progress");
    }
}
function $3c4bce1cc9530e8f$export$ebcd02f2edaf9026(time, onlyShowTime) {
    if (!time) return "";
    const date = new Date(Number(time));
    const HOURS_IN_HALF_DAY = 12; // Constant for 12 hours
    const MINUTES_IN_SINGLE_DIGIT = 10; // Constant for 10 minutes
    if (!onlyShowTime) {
        const options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        return date.toLocaleDateString(undefined, options);
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= HOURS_IN_HALF_DAY ? "pm" : "am";
    const formattedHours = hours % HOURS_IN_HALF_DAY === 0 ? HOURS_IN_HALF_DAY : hours % HOURS_IN_HALF_DAY;
    const formattedMinutes = minutes < MINUTES_IN_SINGLE_DIGIT ? `0${minutes}` : minutes;
    const formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;
    return formattedTime;
}



const $88c13259c365b9fb$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 10
});
const $88c13259c365b9fb$export$8b251419efc915eb = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
});
const $88c13259c365b9fb$export$861edd1ccea2f746 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    border: "none",
    width: "100%",
    borderRadius: "$xm",
    gap: 10,
    padding: 15,
    cursor: "pointer",
    fontFamily: "inherit",
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: "none"
    }
});
const $88c13259c365b9fb$export$6341f9a885713487 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$2",
    alignItems: "flex-start"
});
const $88c13259c365b9fb$export$2a5ccff8d92ce188 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    border: "none",
    width: "100%",
    borderRadius: "$xm",
    gap: 10,
    padding: 15
});
const $88c13259c365b9fb$export$5e3f251c730829 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 25
});


const $31bcb68f72f240ef$export$7022f9518c58e9fc = {
    failed: "error500",
    running: "info500",
    success: "success500"
};




parcelRequire("exYeM");







const $9291edd46c5abd90$export$8767a2c368a76e9a = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    gap: 10
});
const $9291edd46c5abd90$export$ec7dcaac71d9599d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    alignSelf: "stretch"
});
const $9291edd46c5abd90$export$c84671f46d6a1ca = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "flex-start",
    variants: {
        direction: {
            column: {
                flexDirection: "column",
                flex: "1 0 0"
            },
            row: {
                padding: 0
            }
        }
    }
});
const $9291edd46c5abd90$export$37ff71e1bfe909b1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch"
});
const $9291edd46c5abd90$export$47d8a00fffa4e400 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start"
});
const $9291edd46c5abd90$export$f04a61298a47a40f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$4",
    width: "$32",
    height: "$32",
    justifyContent: "center",
    alignItems: "center"
});
const $9291edd46c5abd90$export$dd9c1622bf55ea3a = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $9291edd46c5abd90$export$56037a7cca3845e9 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "$24",
    height: "$24",
    justifyContent: "center",
    alignItems: "center"
});
const $9291edd46c5abd90$export$5e3f251c730829 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: 0,
    alignItems: "center",
    gap: 25
});


function $28e6f3c2d9632833$export$db41f99696d026eb(props) {
    if ("isLoading" in props) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$8767a2c368a76e9a), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$ec7dcaac71d9599d), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                            tokenImage: "",
                            chainImage: "",
                            size: "medium",
                            loading: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        style: {
                            transform: "translateX(-5px)"
                        },
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                            tokenImage: "",
                            chainImage: "",
                            size: "medium",
                            loading: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$dd9c1622bf55ea3a), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 76
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 60
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9291edd46c5abd90$export$56037a7cca3845e9), {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $68b8157e90e31e9e$export$2e2bcd8739ae039), {
                            size: 12,
                            color: "gray"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 76
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium",
                                width: 60
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const { data: { from: { token: fromToken, amount: fromAmount, blockchain: fromBlockchain, realAmount: fromRealAmount }, to: { token: toToken, amount: toAmount, blockchain: toBlockchain, realAmount: toRealAmount } }, status: status, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$8767a2c368a76e9a), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$ec7dcaac71d9599d), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                            tokenImage: fromToken.image,
                            chainImage: fromBlockchain.image,
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        style: {
                            transform: "translateX(-10px)"
                        },
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                            tokenImage: toToken.image,
                            chainImage: toBlockchain.image,
                            size: "large"
                        })
                    })
                ]
            }),
            status === "running" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$c84671f46d6a1ca), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$37ff71e1bfe909b1), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: fromToken.displayName
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9291edd46c5abd90$export$f04a61298a47a40f), {
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $68b8157e90e31e9e$export$2e2bcd8739ae039), {
                                    size: 24,
                                    color: "black"
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: toToken.displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "small",
                        variant: "body",
                        color: "neutral700",
                        children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Waiting for bridge transaction")
                    })
                ]
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$c84671f46d6a1ca), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: fromToken.displayName
                            }),
                            !!fromAmount && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                content: fromRealAmount,
                                container: tooltipContainer,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                    size: "small",
                                    variant: "body",
                                    color: "neutral700",
                                    children: fromAmount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9291edd46c5abd90$export$f04a61298a47a40f), {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $68b8157e90e31e9e$export$2e2bcd8739ae039), {
                            size: 24,
                            color: "black"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9291edd46c5abd90$export$47d8a00fffa4e400), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "medium",
                                variant: "title",
                                children: toToken.displayName
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                content: toRealAmount,
                                container: tooltipContainer,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                    size: "small",
                                    variant: "body",
                                    color: "neutral700",
                                    children: toAmount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $04d011cefd91ddc7$export$d3c936bb842e13d8(props) {
    if ("isLoading" in props) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $88c13259c365b9fb$export$2a5ccff8d92ce188), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $88c13259c365b9fb$export$5e3f251c730829), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $88c13259c365b9fb$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                            variant: "text",
                            size: "medium",
                            width: 76
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                            variant: "text",
                            size: "medium",
                            width: 76
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $28e6f3c2d9632833$export$db41f99696d026eb), {
                    isLoading: true
                })
            ]
        })
    });
    const { onClick: onClick, requestId: requestId, creationTime: creationTime, onlyShowTime: onlyShowTime, status: status, swapTokenData: swapTokenData, tooltipContainer: tooltipContainer } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $88c13259c365b9fb$export$861edd1ccea2f746), {
        onClick: onClick.bind(null, requestId),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $88c13259c365b9fb$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $88c13259c365b9fb$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $88c13259c365b9fb$export$6341f9a885713487), {
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "label",
                                size: "medium",
                                color: "neutral600",
                                children: (0, $3c4bce1cc9530e8f$export$ebcd02f2edaf9026)(creationTime, onlyShowTime)
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            variant: "label",
                            size: "medium",
                            color: (0, $31bcb68f72f240ef$export$7022f9518c58e9fc)[status],
                            children: (0, $3c4bce1cc9530e8f$export$b70265791d2079d4)(status)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $28e6f3c2d9632833$export$db41f99696d026eb), {
                    data: swapTokenData,
                    status: status,
                    tooltipContainer: tooltipContainer
                })
            ]
        })
    });
}





parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");







/* -------------------------------------------------------------------------------------------------
 * Switch
 * -----------------------------------------------------------------------------------------------*/ const $966477614ef4c22c$var$$6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$966477614ef4c22c$var$$6be4966fd9bbc698$var$createSwitchContext, $966477614ef4c22c$export$cf7f5f17f69cbd43] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($966477614ef4c22c$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const [$966477614ef4c22c$var$$6be4966fd9bbc698$var$SwitchProvider, $966477614ef4c22c$var$$6be4966fd9bbc698$var$useSwitchContext] = $966477614ef4c22c$var$$6be4966fd9bbc698$var$createSwitchContext($966477614ef4c22c$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const $966477614ef4c22c$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $exYeM.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)($966477614ef4c22c$var$$6be4966fd9bbc698$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $966477614ef4c22c$var$$6be4966fd9bbc698$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, switchProps, {
        ref: composedRefs,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if switch is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect switch updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $exYeM.createElement)($966477614ef4c22c$var$$6be4966fd9bbc698$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($966477614ef4c22c$export$b5d5cf8927ab7262, {
    displayName: $966477614ef4c22c$var$$6be4966fd9bbc698$var$SWITCH_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SwitchThumb
 * -----------------------------------------------------------------------------------------------*/ const $966477614ef4c22c$var$$6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $966477614ef4c22c$export$4d07bf653ea69106 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $966477614ef4c22c$var$$6be4966fd9bbc698$var$useSwitchContext($966477614ef4c22c$var$$6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $966477614ef4c22c$var$$6be4966fd9bbc698$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, thumbProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($966477614ef4c22c$export$4d07bf653ea69106, {
    displayName: $966477614ef4c22c$var$$6be4966fd9bbc698$var$THUMB_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $966477614ef4c22c$var$$6be4966fd9bbc698$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const prevChecked = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)("input", (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $966477614ef4c22c$var$$6be4966fd9bbc698$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $966477614ef4c22c$export$be92b6f5f03c0fe9 = $966477614ef4c22c$export$b5d5cf8927ab7262;
const $966477614ef4c22c$export$6521433ed15a34db = $966477614ef4c22c$export$4d07bf653ea69106;



const $690b2d953e3270b6$export$a4d1d31a0695f0ce = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($966477614ef4c22c$export$be92b6f5f03c0fe9, {
    boxSizing: "border-box",
    boxShadow: "none",
    width: "24px",
    height: "16px",
    $$color: "$colors$neutral600",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral700"
    },
    backgroundColor: "$$color",
    border: "none",
    borderRadius: "99999px",
    padding: "0",
    cursor: "pointer",
    transition: "all 0.35s",
    overflow: "hidden",
    '&[data-state="checked"]': {
        $$color: "$colors$secondary500",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$secondary250"
        },
        backgroundColor: "$$color",
        borderColor: "$$color"
    },
    "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
});
const $690b2d953e3270b6$export$6970ba0f9c29d2bc = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($966477614ef4c22c$export$6521433ed15a34db, {
    boxSizing: "border-box",
    position: "relative",
    left: "$2",
    display: "block",
    width: "12px",
    height: "12px",
    backgroundColor: "$background",
    borderColor: "$secondary100",
    transition: " transform 300ms",
    borderRadius: "999999px",
    willChange: "transform",
    "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-moz-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-webkit-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px",
        "-o-box-shadow": "rgba(0, 0, 0, 0.6) 0px 3px 8px"
    },
    '&[data-state="checked"]': {
        transform: "translateX(8px)"
    }
});


function $443aba4fa02f39df$export$b5d5cf8927ab7262(props) {
    const { checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $690b2d953e3270b6$export$a4d1d31a0695f0ce), {
        checked: checked,
        onCheckedChange: onChange,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $690b2d953e3270b6$export$6970ba0f9c29d2bc), {})
    });
}






var $exYeM = parcelRequire("exYeM");



const $e1cf1cc8e2de84dc$export$b821cb5d358838ed = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xs",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    variants: {
        fullWidth: {
            true: {
                width: "100%"
            },
            false: {
                width: "fit-content"
            }
        },
        size: {
            small: {
                padding: "$5 $15"
            },
            large: {
                padding: "$10",
                borderRadius: "$xl"
            }
        },
        variant: {
            contained: {
                $$color: "$colors$neutral100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral300"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    $$color: "$colors$secondary100",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral100"
                    },
                    backgroundColor: "$$color"
                }
            },
            outlined: {
                backgroundColor: "transparent",
                border: "1px solid $neutral100",
                "&:hover": {
                    $$color: "$colors$secondary100",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral400"
                    },
                    borderColor: "$$color"
                }
            },
            ghost: {
                background: "transparent"
            }
        },
        disabled: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            variant: "contained",
            disabled: true,
            css: {
                "&:hover": {
                    backgroundColor: "$neutral100"
                }
            }
        },
        {
            variant: "outlined",
            disabled: true,
            css: {
                "&:hover": {
                    borderColor: "$neutral100"
                }
            }
        }
    ]
});
const $e1cf1cc8e2de84dc$export$f5b8910cec6cf069 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("input", {
    flexGrow: 1,
    color: "$foreground",
    fontSize: "$14",
    lineHeight: "$20",
    fontWeight: 400,
    border: "none",
    outline: "none",
    fontFamily: "inherit",
    maxWidth: "100%",
    variants: {
        suffix: {
            true: {
                marginRight: "$10"
            }
        }
    },
    backgroundColor: "transparent",
    "-webkit-appearance": "none",
    margin: 0,
    "&:disabled": {
        cursor: "not-allowed"
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
    },
    '&[type="number"]': {
        "-moz-appearance": "textfield"
    },
    "&::placeholder, &::-webkit-input-placeholder": {
        color: "$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    },
    "&:focus-visible": {
        outline: "none"
    }
});
const $e1cf1cc8e2de84dc$export$b04be29aa201d4f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("label", {
    display: "inline-block"
});


function $d3217f51ad5e64fb$var$TextFieldComponent(props, ref) {
    const { label: label, prefix: prefix, suffix: suffix, size: size = "small", style: style, variant: variant, fullWidth: fullWidth, labelProps: labelProps, ...inputAttributes } = props;
    const handleKeyDown = (event)=>{
        if (inputAttributes?.type === "number") {
            const disallowedKeys = [
                "-",
                "+"
            ];
            if (disallowedKeys.includes(event.key)) event.preventDefault();
        }
    };
    const handlePaste = (event)=>{
        if (inputAttributes?.type === "number") {
            const data = event.clipboardData.getData("text");
            const numericPattern = /^\d+(\.\d+)?$/;
            if (!numericPattern.test(data)) event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            label && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e1cf1cc8e2de84dc$export$b04be29aa201d4f5), {
                        className: "_text",
                        ...inputAttributes.id && {
                            htmlFor: inputAttributes.id
                        },
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            variant: "label",
                            size: "large",
                            ...labelProps,
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "vertical",
                        size: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e1cf1cc8e2de84dc$export$b821cb5d358838ed), {
                disabled: inputAttributes.disabled,
                fullWidth: fullWidth,
                variant: variant,
                size: size,
                css: style,
                className: "_text-field",
                children: [
                    prefix || null,
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e1cf1cc8e2de84dc$export$f5b8910cec6cf069), {
                        ...inputAttributes,
                        onKeyDown: handleKeyDown,
                        onPaste: handlePaste,
                        spellCheck: false,
                        suffix: !!suffix,
                        ref: ref
                    }),
                    suffix || null
                ]
            })
        ]
    });
}
const $d3217f51ad5e64fb$export$2c73285ae9390cec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($d3217f51ad5e64fb$var$TextFieldComponent);
$d3217f51ad5e64fb$export$2c73285ae9390cec.displayName = "TextField";
$d3217f51ad5e64fb$export$2c73285ae9390cec.toString = ()=>"._text-field";






var $exYeM = parcelRequire("exYeM");






function $5d11ef01998ef222$export$82884410b91fbb16() {
    let id = 1;
    return ()=>{
        id++;
        return id;
    };
}
const $5d11ef01998ef222$export$414eb01e809a2d1b = 500; // the delay before the toast is unmounted
const $5d11ef01998ef222$export$4962a3413ea39118 = 300; // the duration of the toast transition
const $5d11ef01998ef222$export$c7d67db1581e240f = 200; // the duration of the toast transition hover
const $5d11ef01998ef222$export$52fbc2f98abc42d8 = 200; // the delay before the toast is invisible to shift remained toast smoothly




var $exYeM = parcelRequire("exYeM");






const $afc6ef6d36fff888$export$24994fa5911a63e = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    transition: `transform ${(0, $5d11ef01998ef222$export$c7d67db1581e240f)}ms ease-in-out`,
    "&:hover": {
        transform: "scale(0.99)"
    }
});
const $afc6ef6d36fff888$export$d1361d980a1c7d33 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    transition: `transform ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms cubic-bezier(0, 0, 0.75, 1.25)`,
    cursor: "pointer",
    variants: {
        isActive: {
            true: {}
        },
        isVisible: {
            true: {}
        },
        position: {
            "right-top": {},
            "right-bottom": {},
            "left-top": {},
            "left-bottom": {},
            "center-top": {},
            "center-bottom": {}
        }
    },
    compoundVariants: [
        {
            position: "right-top",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-top",
            isActive: false,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateX(100%)"
            }
        },
        {
            position: "right-top",
            isActive: false,
            isVisible: false,
            css: {
                maxHeight: "0px",
                transform: "translateX(100%)",
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "right-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "right-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "left-top",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-top",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-top",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "left-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateX(0)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "200px"
            }
        },
        {
            position: "left-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateX(-100%)",
                maxHeight: "0px",
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "center-top",
            isActive: true,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateY(0)",
                opacity: 1
            }
        },
        {
            position: "center-top",
            isActive: false,
            isVisible: true,
            css: {
                maxHeight: "200px",
                transform: "translateY(-1000%)",
                opacity: 0
            }
        },
        {
            position: "center-top",
            isActive: false,
            isVisible: false,
            css: {
                maxHeight: "0px",
                opacity: 0,
                transform: "translateY(-1000%)",
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        },
        {
            position: "center-bottom",
            isActive: true,
            isVisible: true,
            css: {
                transform: "translateY(0)",
                maxHeight: "200px",
                opacity: 1
            }
        },
        {
            position: "center-bottom",
            isActive: false,
            isVisible: true,
            css: {
                transform: "translateY(1000%)",
                maxHeight: "200px",
                opacity: 0
            }
        },
        {
            position: "center-bottom",
            isActive: false,
            isVisible: false,
            css: {
                transform: "translateY(1000%)",
                maxHeight: "0px",
                opacity: 0,
                transition: `max-height ${(0, $5d11ef01998ef222$export$4962a3413ea39118)}ms ease-in-out`
            }
        }
    ]
});
const $afc6ef6d36fff888$export$f2815235e76a62b9 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    overflow: "hidden",
    position: "absolute",
    zIndex: 9999,
    display: "flex",
    gap: "$4",
    flexDirection: "column",
    variants: {
        position: {
            "right-top": {
                right: 12,
                top: 2
            },
            "right-bottom": {
                right: 12,
                bottom: 2,
                flexDirection: "column-reverse"
            },
            "left-top": {
                left: 12,
                top: 2
            },
            "left-bottom": {
                left: 12,
                bottom: 2,
                flexDirection: "column-reverse"
            },
            "center-top": {
                left: "50%",
                transform: "translateX(-50%)",
                top: 2
            },
            "center-bottom": {
                left: "50%",
                transform: "translateX(-50%)",
                bottom: 2,
                flexDirection: "column-reverse"
            }
        }
    }
});
const $afc6ef6d36fff888$export$321fad4722ba1db7 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    borderRadius: "$sm",
    width: "292px",
    minHeight: "52px",
    variants: {
        variant: {
            custom: {
                backgroundColor: "$background",
                borderRight: "1px solid",
                "&:hover": {
                    backgroundColor: "$secondary100",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral300"
                    }
                }
            },
            standard: {
                "& ._alert": {
                    padding: "$10",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center"
                }
            }
        },
        type: {
            error: {},
            success: {},
            warning: {},
            info: {},
            loading: {}
        }
    },
    compoundVariants: [
        {
            variant: "custom",
            type: "error",
            css: {
                borderRightColor: "$error500"
            }
        },
        {
            variant: "custom",
            type: "success",
            css: {
                borderRightColor: "$success500"
            }
        },
        {
            variant: "custom",
            type: "warning",
            css: {
                borderRightColor: "$warning500"
            }
        },
        {
            variant: "custom",
            type: "info",
            css: {
                borderRightColor: "$info500"
            }
        },
        {
            variant: "custom",
            type: "loading",
            css: {
                borderRightColor: "$info500"
            }
        }
    ]
});
const $afc6ef6d36fff888$export$4375e32cdedbcc1e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$10",
    alignItems: "center"
});
const $afc6ef6d36fff888$export$55a634df6fa02b47 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    variants: {
        hasColor: {
            false: {
                [`.${0, $3dd421da623820a3$export$f30cb9bc4f736419} &`]: {
                    color: "$neutral700"
                },
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    color: "$neutral900"
                }
            }
        }
    }
});


const $13621c91ac91153e$var$ToastContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $13621c91ac91153e$var$renderToastContainer = (toasts, position)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: toasts.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $afc6ef6d36fff888$export$f2815235e76a62b9), {
            style: toasts[0].containerStyle,
            position: position,
            children: toasts.map((toast)=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $5ffc66810348b35e$export$8d8dc7d5f743331b), {
                    ...toast,
                    key: toast.id
                }))
        })
    });
const $13621c91ac91153e$export$f5d03d415824e0e = (props)=>{
    const generateId = (0, $exYeM.useMemo)(()=>(0, $5d11ef01998ef222$export$82884410b91fbb16)(), []);
    const { children: children, container: container } = props;
    const [leftTopToasts, setLeftTopToasts] = (0, $exYeM.useState)([]);
    const [leftBottomToasts, setLeftBottomToasts] = (0, $exYeM.useState)([]);
    const [rightTopToasts, setRightTopToasts] = (0, $exYeM.useState)([]);
    const [rightBottomToasts, setRightBottomToasts] = (0, $exYeM.useState)([]);
    const [centerTopToasts, setCenterTopToasts] = (0, $exYeM.useState)([]);
    const [centerBottomToasts, setCenterBottomToasts] = (0, $exYeM.useState)([]);
    const getToastSetter = (position)=>{
        switch(position){
            case "right-top":
                return setRightTopToasts;
            case "right-bottom":
                return setRightBottomToasts;
            case "left-top":
                return setLeftTopToasts;
            case "left-bottom":
                return setLeftBottomToasts;
            case "center-top":
                return setCenterTopToasts;
            default:
                return setCenterBottomToasts;
        }
    };
    const handleAddToast = (content)=>{
        const addToasts = ()=>getToastSetter(content.position);
        addToasts()((toasts)=>{
            const isToastExistById = toasts.find((toast)=>toast.id === content.id);
            if (isToastExistById) {
                console.warn("Trying to send a toast with an existing ID. Please update the toast ID or use it after the toast is hidden");
                return toasts;
            }
            return [
                ...toasts,
                {
                    ...content,
                    id: content.id || generateId()
                }
            ];
        });
    };
    const handleRemoveToast = (id, position)=>{
        const removeFromToasts = ()=>getToastSetter(position);
        removeFromToasts()((toasts)=>toasts.filter((t)=>t.id !== id));
    };
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const toastApis = {
        addToast: (content)=>handleAddToast(content),
        removeToast: (id, position)=>handleRemoveToast(id, position)
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($13621c91ac91153e$var$ToastContext.Provider, {
        value: toastApis,
        children: [
            children,
            container && /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    $13621c91ac91153e$var$renderToastContainer(rightTopToasts, "right-top"),
                    $13621c91ac91153e$var$renderToastContainer(leftTopToasts, "left-top"),
                    $13621c91ac91153e$var$renderToastContainer(centerTopToasts, "center-top"),
                    $13621c91ac91153e$var$renderToastContainer(rightBottomToasts, "right-bottom"),
                    $13621c91ac91153e$var$renderToastContainer(leftBottomToasts, "left-bottom"),
                    $13621c91ac91153e$var$renderToastContainer(centerBottomToasts, "center-bottom")
                ]
            }), container)
        ]
    });
};
function $13621c91ac91153e$export$a407b657d3044108() {
    const context = (0, $exYeM.useContext)($13621c91ac91153e$var$ToastContext);
    if (!context) throw new Error("useToast can only be used within the ToastProvider component");
    return context;
}



const $5ffc66810348b35e$export$8d8dc7d5f743331b = (props)=>{
    const { id: id, autoHideDuration: autoHideDuration, onClose: onClose, type: type, title: title, position: position, hasCloseIcon: hasCloseIcon = true, hideOnTap: hideOnTap = true, variant: variant = "standard" } = props;
    const [isActive, setIsActive] = (0, $exYeM.useState)(false);
    const [isVisible, setIsVisible] = (0, $exYeM.useState)(false);
    const { removeToast: removeToast } = (0, $13621c91ac91153e$export$a407b657d3044108)();
    (0, $exYeM.useEffect)(()=>{
        let cleanup;
        if (autoHideDuration) {
            const timer = setTimeout(()=>{
                handleClose();
            }, autoHideDuration);
            cleanup = ()=>clearTimeout(timer);
        }
        return cleanup;
    }, [
        id
    ]);
    const handleClose = ()=>{
        setIsActive(false);
        setTimeout(()=>{
            setIsVisible(false);
        }, (0, $5d11ef01998ef222$export$52fbc2f98abc42d8));
        setTimeout(()=>{
            removeToast(id, position);
            onClose?.();
        }, (0, $5d11ef01998ef222$export$414eb01e809a2d1b));
    };
    (0, $exYeM.useEffect)(()=>{
        setIsVisible(true);
        setTimeout(()=>{
            setIsActive(true);
        }, 0);
    }, []);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $afc6ef6d36fff888$export$d1361d980a1c7d33), {
        isActive: isActive,
        position: position,
        isVisible: isVisible,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            className: (0, $afc6ef6d36fff888$export$24994fa5911a63e)(),
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $afc6ef6d36fff888$export$321fad4722ba1db7), {
                onClick: hideOnTap ? handleClose : undefined,
                variant: variant,
                type: type,
                children: variant === "custom" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $afc6ef6d36fff888$export$4375e32cdedbcc1e), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $64eb97d70691045d$export$9ae29657c885eef1), {
                            type: type,
                            align: "center",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $cf3c882ce06dec1a$export$2e2bcd8739ae039), {
                                type: type
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                            direction: "horizontal",
                            size: 10
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $afc6ef6d36fff888$export$55a634df6fa02b47), {
                            variant: "body",
                            size: "small",
                            align: "left",
                            children: props.title
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
                    title: title,
                    type: type,
                    variant: "alarm",
                    titleAlign: "left",
                    action: hasCloseIcon ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
                        variant: "ghost",
                        size: "xsmall",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8192be46f8fafa5a$export$2e2bcd8739ae039), {
                            size: 12
                        })
                    }) : undefined
                })
            })
        })
    });
};








parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");

var $exYeM = parcelRequire("exYeM");






var $b573446a19694996$export$ba984d729fe7282e;
(function(WalletState) {
    WalletState["NOT_INSTALLED"] = "not_installed";
    WalletState["DISCONNECTED"] = "disconnected";
    WalletState["CONNECTING"] = "connecting";
    WalletState["CONNECTED"] = "connected";
})($b573446a19694996$export$ba984d729fe7282e || ($b573446a19694996$export$ba984d729fe7282e = {}));


function $10c703de8203ab2d$export$75a2bd39da73db46(state) {
    switch(state){
        case (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED:
            return {
                color: "success500",
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connected"),
                tooltipText: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Disconnect")
            };
        case (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED:
            return {
                color: "info500",
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Install"),
                tooltipText: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Install")
            };
        case (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING:
            return {
                color: "neutral600",
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connecting ..."),
                tooltipText: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connecting")
            };
        case (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED:
            return {
                color: "neutral600",
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Disconnected"),
                tooltipText: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect")
            };
        default:
            throw new Error((0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("you need to pass a correct state to Wallet."));
    }
}




const $50171c19a4232bdc$export$3c76d375d5e2c498 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});
const $50171c19a4232bdc$export$f99233281efd08a0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    textTransform: "capitalize"
});
const $50171c19a4232bdc$export$5f1af8db9871e1d6 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    marginTop: "$10"
});
const $50171c19a4232bdc$export$eab4424f030fcb21 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    borderRadius: "$xm",
    padding: "$10",
    border: "0",
    display: "flex",
    flexDirection: "column",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    alignItems: "center",
    cursor: "pointer",
    width: 100,
    position: "relative",
    fontFamily: "inherit",
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    "&:disabled": {
        filter: "grayscale(1)",
        pointerEvents: "none"
    },
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                $$outline: "$colors$secondary500",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$outline: "$colors$secondary250"
                },
                outlineColor: "$$outline",
                outlineStyle: "solid"
            }
        }
    }
});
const $50171c19a4232bdc$export$4ec83e90d030b2f3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xm",
    padding: "$10 0",
    border: "0",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$neutral100",
    alignItems: "center",
    justifyContent: "center",
    width: 100
});



function $b7ad2cfc9fe1d9ac$var$Wallet(props) {
    const { title: title, type: type, image: image, onClick: onClick, isLoading: isLoading, disabled: disabled = false } = props;
    const info = (0, $10c703de8203ab2d$export$75a2bd39da73db46)(props.state);
    if (isLoading) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $50171c19a4232bdc$export$4ec83e90d030b2f3), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 12
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 85,
                size: "medium"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 64,
                size: "medium"
            })
        ]
    });
    const WrapperComponent = disabled ? (0, $exYeM.Fragment) : (0, $273666b35d34bd80$export$28c660c63b792dea);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(WrapperComponent, {
        container: props.container,
        content: info.tooltipText,
        side: "top",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $50171c19a4232bdc$export$eab4424f030fcb21), {
            disabled: props.state == (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING || disabled,
            onClick: ()=>{
                if (props.state === (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED) window.open((0, $7aYgM.detectInstallLink)(props.link), "_blank");
                else onClick(type);
            },
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $50171c19a4232bdc$export$3c76d375d5e2c498), {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                        src: image,
                        size: 35
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $50171c19a4232bdc$export$5f1af8db9871e1d6), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $50171c19a4232bdc$export$f99233281efd08a0), {
                            variant: "label",
                            size: "medium",
                            noWrap: false,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            variant: "body",
                            size: "xsmall",
                            noWrap: false,
                            color: info.color,
                            children: info.description
                        })
                    ]
                })
            ]
        })
    });
}
var $b7ad2cfc9fe1d9ac$export$2e2bcd8739ae039 = $b7ad2cfc9fe1d9ac$var$Wallet;



parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
parcelRequire("exYeM");





function $42a8fe687f7787a4$export$d2242c7b771012ce(props) {
    const { title: title, type: type, image: image, onClick: onClick, selected: selected, description: description, state: state, disabled: disabled = false } = props;
    const info = (0, $10c703de8203ab2d$export$75a2bd39da73db46)(props.state);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $50171c19a4232bdc$export$eab4424f030fcb21), {
        selected: selected,
        disabled: props.state == (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING || disabled,
        onClick: ()=>{
            if (props.state === (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED) window.open((0, $7aYgM.detectInstallLink)(props.link), "_blank");
            else onClick(type);
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $50171c19a4232bdc$export$3c76d375d5e2c498), {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                    src: image,
                    size: 35
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $50171c19a4232bdc$export$5f1af8db9871e1d6), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $50171c19a4232bdc$export$f99233281efd08a0), {
                        variant: "label",
                        size: "medium",
                        noWrap: false,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        variant: "body",
                        size: "xsmall",
                        noWrap: false,
                        color: state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED ? "neutral700" : info.color,
                        children: description || info.description
                    })
                ]
            })
        ]
    });
}












var $exYeM = parcelRequire("exYeM");

const $da8c96b0530df421$var$PUBLISH = 0;
const $da8c96b0530df421$var$SUBSCRIBE = 1;
const $da8c96b0530df421$var$RESET = 2;
const $da8c96b0530df421$var$VALUE = 4;
function $da8c96b0530df421$var$compose(a, b) {
    return (arg)=>a(b(arg));
}
function $da8c96b0530df421$var$thrush(arg, proc) {
    return proc(arg);
}
function $da8c96b0530df421$var$curry2to1(proc, arg1) {
    return (arg2)=>proc(arg1, arg2);
}
function $da8c96b0530df421$var$curry1to0(proc, arg) {
    return ()=>proc(arg);
}
function $da8c96b0530df421$var$tap(arg, proc) {
    proc(arg);
    return arg;
}
function $da8c96b0530df421$var$tup(...args) {
    return args;
}
function $da8c96b0530df421$var$call(proc) {
    proc();
}
function $da8c96b0530df421$var$always(value) {
    return ()=>value;
}
function $da8c96b0530df421$var$joinProc(...procs) {
    return ()=>{
        procs.map($da8c96b0530df421$var$call);
    };
}
function $da8c96b0530df421$var$isDefined(arg) {
    return arg !== void 0;
}
function $da8c96b0530df421$var$noop() {}
function $da8c96b0530df421$var$subscribe(emitter, subscription) {
    return emitter($da8c96b0530df421$var$SUBSCRIBE, subscription);
}
function $da8c96b0530df421$var$publish(publisher, value) {
    publisher($da8c96b0530df421$var$PUBLISH, value);
}
function $da8c96b0530df421$var$reset(emitter) {
    emitter($da8c96b0530df421$var$RESET);
}
function $da8c96b0530df421$var$getValue(depot) {
    return depot($da8c96b0530df421$var$VALUE);
}
function $da8c96b0530df421$var$connect(emitter, publisher) {
    return $da8c96b0530df421$var$subscribe(emitter, $da8c96b0530df421$var$curry2to1(publisher, $da8c96b0530df421$var$PUBLISH));
}
function $da8c96b0530df421$var$handleNext(emitter, subscription) {
    const unsub = emitter($da8c96b0530df421$var$SUBSCRIBE, (value)=>{
        unsub();
        subscription(value);
    });
    return unsub;
}
function $da8c96b0530df421$var$stream() {
    const subscriptions = [];
    return (action, arg)=>{
        switch(action){
            case $da8c96b0530df421$var$RESET:
                subscriptions.splice(0, subscriptions.length);
                return;
            case $da8c96b0530df421$var$SUBSCRIBE:
                subscriptions.push(arg);
                return ()=>{
                    const indexOf = subscriptions.indexOf(arg);
                    if (indexOf > -1) subscriptions.splice(indexOf, 1);
                };
            case $da8c96b0530df421$var$PUBLISH:
                subscriptions.slice().forEach((subscription)=>{
                    subscription(arg);
                });
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $da8c96b0530df421$var$statefulStream(initial) {
    let value = initial;
    const innerSubject = $da8c96b0530df421$var$stream();
    return (action, arg)=>{
        switch(action){
            case $da8c96b0530df421$var$SUBSCRIBE:
                const subscription = arg;
                subscription(value);
                break;
            case $da8c96b0530df421$var$PUBLISH:
                value = arg;
                break;
            case $da8c96b0530df421$var$VALUE:
                return value;
        }
        return innerSubject(action, arg);
    };
}
function $da8c96b0530df421$var$eventHandler(emitter) {
    let unsub;
    let currentSubscription;
    const cleanup = ()=>unsub && unsub();
    return function(action, subscription) {
        switch(action){
            case $da8c96b0530df421$var$SUBSCRIBE:
                if (subscription) {
                    if (currentSubscription === subscription) return;
                    cleanup();
                    currentSubscription = subscription;
                    unsub = $da8c96b0530df421$var$subscribe(emitter, subscription);
                    return unsub;
                } else {
                    cleanup();
                    return $da8c96b0530df421$var$noop;
                }
            case $da8c96b0530df421$var$RESET:
                cleanup();
                currentSubscription = null;
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $da8c96b0530df421$var$streamFromEmitter(emitter) {
    return $da8c96b0530df421$var$tap($da8c96b0530df421$var$stream(), (stream2)=>$da8c96b0530df421$var$connect(emitter, stream2));
}
function $da8c96b0530df421$var$statefulStreamFromEmitter(emitter, initial) {
    return $da8c96b0530df421$var$tap($da8c96b0530df421$var$statefulStream(initial), (stream2)=>$da8c96b0530df421$var$connect(emitter, stream2));
}
function $da8c96b0530df421$var$combineOperators(...operators) {
    return (subscriber)=>{
        return operators.reduceRight($da8c96b0530df421$var$thrush, subscriber);
    };
}
function $da8c96b0530df421$var$pipe(source, ...operators) {
    const project = $da8c96b0530df421$var$combineOperators(...operators);
    return (action, subscription)=>{
        switch(action){
            case $da8c96b0530df421$var$SUBSCRIBE:
                return $da8c96b0530df421$var$subscribe(source, project(subscription));
            case $da8c96b0530df421$var$RESET:
                $da8c96b0530df421$var$reset(source);
                return;
        }
    };
}
function $da8c96b0530df421$var$defaultComparator(previous, next) {
    return previous === next;
}
function $da8c96b0530df421$var$distinctUntilChanged(comparator = $da8c96b0530df421$var$defaultComparator) {
    let current;
    return (done)=>(next)=>{
            if (!comparator(current, next)) {
                current = next;
                done(next);
            }
        };
}
function $da8c96b0530df421$var$filter(predicate) {
    return (done)=>(value)=>{
            predicate(value) && done(value);
        };
}
function $da8c96b0530df421$var$map(project) {
    return (done)=>$da8c96b0530df421$var$compose(done, project);
}
function $da8c96b0530df421$var$mapTo(value) {
    return (done)=>()=>done(value);
}
function $da8c96b0530df421$var$scan(scanner, initial) {
    return (done)=>(value)=>done(initial = scanner(initial, value));
}
function $da8c96b0530df421$var$skip(times) {
    return (done)=>(value)=>{
            times > 0 ? times-- : done(value);
        };
}
function $da8c96b0530df421$var$throttleTime(interval) {
    let currentValue = null;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) return;
            timeout = setTimeout(()=>{
                timeout = void 0;
                done(currentValue);
            }, interval);
        };
}
function $da8c96b0530df421$var$debounceTime(interval) {
    let currentValue;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                done(currentValue);
            }, interval);
        };
}
function $da8c96b0530df421$var$withLatestFrom(...sources) {
    const values = new Array(sources.length);
    let called = 0;
    let pendingCall = null;
    const allCalled = Math.pow(2, sources.length) - 1;
    sources.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $da8c96b0530df421$var$subscribe(source, (value)=>{
            const prevCalled = called;
            called = called | bit;
            values[index] = value;
            if (prevCalled !== allCalled && called === allCalled && pendingCall) {
                pendingCall();
                pendingCall = null;
            }
        });
    });
    return (done)=>(value)=>{
            const call2 = ()=>done([
                    value
                ].concat(values));
            if (called === allCalled) call2();
            else pendingCall = call2;
        };
}
function $da8c96b0530df421$var$merge(...sources) {
    return function(action, subscription) {
        switch(action){
            case $da8c96b0530df421$var$SUBSCRIBE:
                return $da8c96b0530df421$var$joinProc(...sources.map((source)=>$da8c96b0530df421$var$subscribe(source, subscription)));
            case $da8c96b0530df421$var$RESET:
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $da8c96b0530df421$var$duc(source, comparator = $da8c96b0530df421$var$defaultComparator) {
    return $da8c96b0530df421$var$pipe(source, $da8c96b0530df421$var$distinctUntilChanged(comparator));
}
function $da8c96b0530df421$var$combineLatest(...emitters) {
    const innerSubject = $da8c96b0530df421$var$stream();
    const values = new Array(emitters.length);
    let called = 0;
    const allCalled = Math.pow(2, emitters.length) - 1;
    emitters.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $da8c96b0530df421$var$subscribe(source, (value)=>{
            values[index] = value;
            called = called | bit;
            if (called === allCalled) $da8c96b0530df421$var$publish(innerSubject, values);
        });
    });
    return function(action, subscription) {
        switch(action){
            case $da8c96b0530df421$var$SUBSCRIBE:
                if (called === allCalled) subscription(values);
                return $da8c96b0530df421$var$subscribe(innerSubject, subscription);
            case $da8c96b0530df421$var$RESET:
                return $da8c96b0530df421$var$reset(innerSubject);
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $da8c96b0530df421$var$system(constructor, dependencies = [], { singleton: singleton } = {
    singleton: true
}) {
    return {
        id: $da8c96b0530df421$var$id(),
        constructor: constructor,
        dependencies: dependencies,
        singleton: singleton
    };
}
const $da8c96b0530df421$var$id = ()=>Symbol();
function $da8c96b0530df421$var$init(systemSpec) {
    const singletons = /* @__PURE__ */ new Map();
    const _init = ({ id: id2, constructor: constructor, dependencies: dependencies, singleton: singleton })=>{
        if (singleton && singletons.has(id2)) return singletons.get(id2);
        const system2 = constructor(dependencies.map((e)=>_init(e)));
        if (singleton) singletons.set(id2, system2);
        return system2;
    };
    return _init(systemSpec);
}
function $da8c96b0530df421$var$omit(keys, obj) {
    const result = {};
    const index = {};
    let idx = 0;
    const len = keys.length;
    while(idx < len){
        index[keys[idx]] = 1;
        idx += 1;
    }
    for(const prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
}
const $da8c96b0530df421$var$useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect;
function $da8c96b0530df421$var$systemToComponent(systemSpec, map2, Root) {
    const requiredPropNames = Object.keys(map2.required || {});
    const optionalPropNames = Object.keys(map2.optional || {});
    const methodNames = Object.keys(map2.methods || {});
    const eventNames = Object.keys(map2.events || {});
    const Context = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({});
    function applyPropsToSystem(system2, props) {
        if (system2["propsReady"]) $da8c96b0530df421$var$publish(system2["propsReady"], false);
        for (const requiredPropName of requiredPropNames){
            const stream2 = system2[map2.required[requiredPropName]];
            $da8c96b0530df421$var$publish(stream2, props[requiredPropName]);
        }
        for (const optionalPropName of optionalPropNames)if (optionalPropName in props) {
            const stream2 = system2[map2.optional[optionalPropName]];
            $da8c96b0530df421$var$publish(stream2, props[optionalPropName]);
        }
        if (system2["propsReady"]) $da8c96b0530df421$var$publish(system2["propsReady"], true);
    }
    function buildMethods(system2) {
        return methodNames.reduce((acc, methodName)=>{
            acc[methodName] = (value)=>{
                const stream2 = system2[map2.methods[methodName]];
                $da8c96b0530df421$var$publish(stream2, value);
            };
            return acc;
        }, {});
    }
    function buildEventHandlers(system2) {
        return eventNames.reduce((handlers, eventName)=>{
            handlers[eventName] = $da8c96b0530df421$var$eventHandler(system2[map2.events[eventName]]);
            return handlers;
        }, {});
    }
    const Component = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((propsWithChildren, ref)=>{
        const { children: children, ...props } = propsWithChildren;
        const [system2] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(()=>{
            return $da8c96b0530df421$var$tap($da8c96b0530df421$var$init(systemSpec), (system22)=>applyPropsToSystem(system22, props));
        });
        const [handlers] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($da8c96b0530df421$var$curry1to0(buildEventHandlers, system2));
        $da8c96b0530df421$var$useIsomorphicLayoutEffect$2(()=>{
            for (const eventName of eventNames)if (eventName in props) $da8c96b0530df421$var$subscribe(handlers[eventName], props[eventName]);
            return ()=>{
                Object.values(handlers).map($da8c96b0530df421$var$reset);
            };
        }, [
            props,
            handlers,
            system2
        ]);
        $da8c96b0530df421$var$useIsomorphicLayoutEffect$2(()=>{
            applyPropsToSystem(system2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useImperativeHandle(ref, $da8c96b0530df421$var$always(buildMethods(system2)));
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Context.Provider, {
            value: system2
        }, Root ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Root, $da8c96b0530df421$var$omit([
            ...requiredPropNames,
            ...optionalPropNames,
            ...eventNames
        ], props), children) : children);
    });
    const usePublisher2 = (key)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback($da8c96b0530df421$var$curry2to1($da8c96b0530df421$var$publish, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext(Context)[key]), [
            key
        ]);
    };
    const useEmitterValue2 = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext(Context);
        const source = system2[key];
        const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($da8c96b0530df421$var$curry1to0($da8c96b0530df421$var$getValue, source));
        $da8c96b0530df421$var$useIsomorphicLayoutEffect$2(()=>$da8c96b0530df421$var$subscribe(source, (next)=>{
                if (next !== value) setValue($da8c96b0530df421$var$always(next));
            }), [
            source,
            value
        ]);
        return value;
    };
    const useEmitter2 = (key, callback)=>{
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext(Context);
        const source = context[key];
        $da8c96b0530df421$var$useIsomorphicLayoutEffect$2(()=>$da8c96b0530df421$var$subscribe(source, callback), [
            callback,
            source
        ]);
    };
    return {
        Component: Component,
        usePublisher: usePublisher2,
        useEmitterValue: useEmitterValue2,
        useEmitter: useEmitter2
    };
}
const $da8c96b0530df421$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect;
const $da8c96b0530df421$var$useIsomorphicLayoutEffect$1 = $da8c96b0530df421$var$useIsomorphicLayoutEffect;
var $da8c96b0530df421$export$243e62d78d3b544d = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
    return LogLevel2;
})($da8c96b0530df421$export$243e62d78d3b544d || {});
const $da8c96b0530df421$var$CONSOLE_METHOD_MAP = {
    [0]: "debug",
    [1]: "log",
    [2]: "warn",
    [3]: "error"
};
const $da8c96b0530df421$var$getGlobalThis = ()=>typeof globalThis === "undefined" ? window : globalThis;
const $da8c96b0530df421$var$loggerSystem = $da8c96b0530df421$var$system(()=>{
    const logLevel = $da8c96b0530df421$var$statefulStream(3);
    const log = $da8c96b0530df421$var$statefulStream((label, message, level = 1)=>{
        var _a;
        const currentLevel = (_a = $da8c96b0530df421$var$getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : $da8c96b0530df421$var$getValue(logLevel);
        if (level >= currentLevel) console[$da8c96b0530df421$var$CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
    });
    return {
        log: log,
        logLevel: logLevel
    };
}, [], {
    singleton: true
});
function $da8c96b0530df421$var$useSizeWithElRef(callback, enabled = true) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    let callbackRef = (_el)=>{};
    if (typeof ResizeObserver !== "undefined") {
        const observer = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
            return new ResizeObserver((entries)=>{
                const element = entries[0].target;
                if (element.offsetParent !== null) callback(element);
            });
        }, [
            callback
        ]);
        callbackRef = (elRef)=>{
            if (elRef && enabled) {
                observer.observe(elRef);
                ref.current = elRef;
            } else {
                if (ref.current) observer.unobserve(ref.current);
                ref.current = null;
            }
        };
    }
    return {
        ref: ref,
        callbackRef: callbackRef
    };
}
function $da8c96b0530df421$var$useSize(callback, enabled = true) {
    return $da8c96b0530df421$var$useSizeWithElRef(callback, enabled).callbackRef;
}
function $da8c96b0530df421$var$useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
    const memoedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((el)=>{
        const ranges = $da8c96b0530df421$var$getChangedChildSizes(el.children, itemSize, "offsetHeight", log);
        let scrollableElement = el.parentElement;
        while(!scrollableElement.dataset["virtuosoScroller"])scrollableElement = scrollableElement.parentElement;
        const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
        const scrollTop = customScrollParent ? customScrollParent.scrollTop : windowScrolling ? window.pageYOffset || document.documentElement.scrollTop : scrollableElement.scrollTop;
        const scrollHeight = customScrollParent ? customScrollParent.scrollHeight : windowScrolling ? document.documentElement.scrollHeight : scrollableElement.scrollHeight;
        const viewportHeight = customScrollParent ? customScrollParent.offsetHeight : windowScrolling ? window.innerHeight : scrollableElement.offsetHeight;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        });
        gap == null || gap($da8c96b0530df421$var$resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
        if (ranges !== null) callback(ranges);
    }, [
        callback,
        itemSize,
        log,
        gap,
        customScrollParent,
        scrollContainerStateCallback
    ]);
    return $da8c96b0530df421$var$useSizeWithElRef(memoedCallback, enabled);
}
function $da8c96b0530df421$var$getChangedChildSizes(children, itemSize, field, log) {
    const length = children.length;
    if (length === 0) return null;
    const results = [];
    for(let i = 0; i < length; i++){
        const child = children.item(i);
        if (!child || child.dataset.index === void 0) continue;
        const index = parseInt(child.dataset.index);
        const knownSize = parseFloat(child.dataset.knownSize);
        const size = itemSize(child, field);
        if (size === 0) log("Zero-sized element, this should not happen", {
            child: child
        }, $da8c96b0530df421$export$243e62d78d3b544d.ERROR);
        if (size === knownSize) continue;
        const lastResult = results[results.length - 1];
        if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) results.push({
            startIndex: index,
            endIndex: index,
            size: size
        });
        else results[results.length - 1].endIndex++;
    }
    return results;
}
function $da8c96b0530df421$var$resolveGapValue$1(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $da8c96b0530df421$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
function $da8c96b0530df421$var$correctItemSize(el, dimension) {
    return Math.round(el.getBoundingClientRect()[dimension]);
}
function $da8c96b0530df421$var$approximatelyEqual(num1, num2) {
    return Math.abs(num1 - num2) < 1.01;
}
function $da8c96b0530df421$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = $da8c96b0530df421$var$noop, customScrollParent) {
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const scrollTopTarget = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const handler = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((ev)=>{
        const el = ev.target;
        const windowScroll = el === window || el === document;
        const scrollTop = windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
        const scrollHeight = windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
        const viewportHeight = windowScroll ? window.innerHeight : el.offsetHeight;
        const call2 = ()=>{
            scrollContainerStateCallback({
                scrollTop: Math.max(scrollTop, 0),
                scrollHeight: scrollHeight,
                viewportHeight: viewportHeight
            });
        };
        if (ev.suppressFlushSync) call2();
        else (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).flushSync(call2);
        if (scrollTopTarget.current !== null) {
            if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            }
        }
    }, [
        scrollContainerStateCallback,
        smoothScrollTargetReached
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
        scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
        handler({
            target: localRef,
            suppressFlushSync: true
        });
        localRef.addEventListener("scroll", handler, {
            passive: true
        });
        return ()=>{
            scrollerRefCallback(null);
            localRef.removeEventListener("scroll", handler);
        };
    }, [
        scrollerRef,
        handler,
        scrollerElement,
        scrollerRefCallback,
        customScrollParent
    ]);
    function scrollToCallback(location) {
        const scrollerElement2 = scrollerRef.current;
        if (!scrollerElement2 || "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0) return;
        const isSmooth = location.behavior === "smooth";
        let offsetHeight;
        let scrollHeight;
        let scrollTop;
        if (scrollerElement2 === window) {
            scrollHeight = Math.max($da8c96b0530df421$var$correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight);
            offsetHeight = window.innerHeight;
            scrollTop = document.documentElement.scrollTop;
        } else {
            scrollHeight = scrollerElement2.scrollHeight;
            offsetHeight = $da8c96b0530df421$var$correctItemSize(scrollerElement2, "height");
            scrollTop = scrollerElement2.scrollTop;
        }
        const maxScrollTop = scrollHeight - offsetHeight;
        location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
        if ($da8c96b0530df421$var$approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
            scrollContainerStateCallback({
                scrollTop: scrollTop,
                scrollHeight: scrollHeight,
                viewportHeight: offsetHeight
            });
            if (isSmooth) smoothScrollTargetReached(true);
            return;
        }
        if (isSmooth) {
            scrollTopTarget.current = location.top;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                timeoutRef.current = null;
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
            }, 1e3);
        } else scrollTopTarget.current = null;
        scrollerElement2.scrollTo(location);
    }
    function scrollByCallback(location) {
        scrollerRef.current.scrollBy(location);
    }
    return {
        scrollerRef: scrollerRef,
        scrollByCallback: scrollByCallback,
        scrollToCallback: scrollToCallback
    };
}
const $da8c96b0530df421$var$domIOSystem = $da8c96b0530df421$var$system(()=>{
    const scrollContainerState = $da8c96b0530df421$var$stream();
    const scrollTop = $da8c96b0530df421$var$stream();
    const deviation = $da8c96b0530df421$var$statefulStream(0);
    const smoothScrollTargetReached = $da8c96b0530df421$var$stream();
    const statefulScrollTop = $da8c96b0530df421$var$statefulStream(0);
    const viewportHeight = $da8c96b0530df421$var$stream();
    const scrollHeight = $da8c96b0530df421$var$stream();
    const headerHeight = $da8c96b0530df421$var$statefulStream(0);
    const fixedHeaderHeight = $da8c96b0530df421$var$statefulStream(0);
    const fixedFooterHeight = $da8c96b0530df421$var$statefulStream(0);
    const footerHeight = $da8c96b0530df421$var$statefulStream(0);
    const scrollTo = $da8c96b0530df421$var$stream();
    const scrollBy = $da8c96b0530df421$var$stream();
    const scrollingInProgress = $da8c96b0530df421$var$statefulStream(false);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollContainerState, $da8c96b0530df421$var$map(({ scrollTop: scrollTop2 })=>scrollTop2)), scrollTop);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollContainerState, $da8c96b0530df421$var$map(({ scrollHeight: scrollHeight2 })=>scrollHeight2)), scrollHeight);
    $da8c96b0530df421$var$connect(scrollTop, statefulScrollTop);
    return {
        scrollContainerState: // input
        scrollContainerState,
        scrollTop: scrollTop,
        viewportHeight: viewportHeight,
        headerHeight: headerHeight,
        fixedHeaderHeight: fixedHeaderHeight,
        fixedFooterHeight: fixedFooterHeight,
        footerHeight: footerHeight,
        scrollHeight: scrollHeight,
        smoothScrollTargetReached: smoothScrollTargetReached,
        scrollTo: // signals
        scrollTo,
        scrollBy: scrollBy,
        statefulScrollTop: // state
        statefulScrollTop,
        deviation: deviation,
        scrollingInProgress: scrollingInProgress
    };
}, [], {
    singleton: true
});
const $da8c96b0530df421$var$NIL_NODE = {
    lvl: 0
};
function $da8c96b0530df421$var$newAANode(k, v, lvl, l = $da8c96b0530df421$var$NIL_NODE, r = $da8c96b0530df421$var$NIL_NODE) {
    return {
        k: k,
        v: v,
        lvl: lvl,
        l: l,
        r: r
    };
}
function $da8c96b0530df421$var$empty(node) {
    return node === $da8c96b0530df421$var$NIL_NODE;
}
function $da8c96b0530df421$var$newTree() {
    return $da8c96b0530df421$var$NIL_NODE;
}
function $da8c96b0530df421$var$remove(node, key) {
    if ($da8c96b0530df421$var$empty(node)) return $da8c96b0530df421$var$NIL_NODE;
    const { k: k, l: l, r: r } = node;
    if (key === k) {
        if ($da8c96b0530df421$var$empty(l)) return r;
        else if ($da8c96b0530df421$var$empty(r)) return l;
        else {
            const [lastKey, lastValue] = $da8c96b0530df421$var$last(l);
            return $da8c96b0530df421$var$adjust($da8c96b0530df421$var$clone(node, {
                k: lastKey,
                v: lastValue,
                l: $da8c96b0530df421$var$deleteLast(l)
            }));
        }
    } else if (key < k) return $da8c96b0530df421$var$adjust($da8c96b0530df421$var$clone(node, {
        l: $da8c96b0530df421$var$remove(l, key)
    }));
    else return $da8c96b0530df421$var$adjust($da8c96b0530df421$var$clone(node, {
        r: $da8c96b0530df421$var$remove(r, key)
    }));
}
function $da8c96b0530df421$var$find(node, key) {
    if ($da8c96b0530df421$var$empty(node)) return;
    if (key === node.k) return node.v;
    else if (key < node.k) return $da8c96b0530df421$var$find(node.l, key);
    else return $da8c96b0530df421$var$find(node.r, key);
}
function $da8c96b0530df421$var$findMaxKeyValue(node, value, field = "k") {
    if ($da8c96b0530df421$var$empty(node)) return [
        -Infinity,
        void 0
    ];
    if (Number(node[field]) === value) return [
        node.k,
        node.v
    ];
    if (Number(node[field]) < value) {
        const r = $da8c96b0530df421$var$findMaxKeyValue(node.r, value, field);
        if (r[0] === -Infinity) return [
            node.k,
            node.v
        ];
        else return r;
    }
    return $da8c96b0530df421$var$findMaxKeyValue(node.l, value, field);
}
function $da8c96b0530df421$var$insert(node, k, v) {
    if ($da8c96b0530df421$var$empty(node)) return $da8c96b0530df421$var$newAANode(k, v, 1);
    if (k === node.k) return $da8c96b0530df421$var$clone(node, {
        k: k,
        v: v
    });
    else if (k < node.k) return $da8c96b0530df421$var$rebalance($da8c96b0530df421$var$clone(node, {
        l: $da8c96b0530df421$var$insert(node.l, k, v)
    }));
    else return $da8c96b0530df421$var$rebalance($da8c96b0530df421$var$clone(node, {
        r: $da8c96b0530df421$var$insert(node.r, k, v)
    }));
}
function $da8c96b0530df421$var$walkWithin(node, start, end) {
    if ($da8c96b0530df421$var$empty(node)) return [];
    const { k: k, v: v, l: l, r: r } = node;
    let result = [];
    if (k > start) result = result.concat($da8c96b0530df421$var$walkWithin(l, start, end));
    if (k >= start && k <= end) result.push({
        k: k,
        v: v
    });
    if (k <= end) result = result.concat($da8c96b0530df421$var$walkWithin(r, start, end));
    return result;
}
function $da8c96b0530df421$var$walk(node) {
    if ($da8c96b0530df421$var$empty(node)) return [];
    return [
        ...$da8c96b0530df421$var$walk(node.l),
        {
            k: node.k,
            v: node.v
        },
        ...$da8c96b0530df421$var$walk(node.r)
    ];
}
function $da8c96b0530df421$var$last(node) {
    return $da8c96b0530df421$var$empty(node.r) ? [
        node.k,
        node.v
    ] : $da8c96b0530df421$var$last(node.r);
}
function $da8c96b0530df421$var$deleteLast(node) {
    return $da8c96b0530df421$var$empty(node.r) ? node.l : $da8c96b0530df421$var$adjust($da8c96b0530df421$var$clone(node, {
        r: $da8c96b0530df421$var$deleteLast(node.r)
    }));
}
function $da8c96b0530df421$var$clone(node, args) {
    return $da8c96b0530df421$var$newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function $da8c96b0530df421$var$isSingle(node) {
    return $da8c96b0530df421$var$empty(node) || node.lvl > node.r.lvl;
}
function $da8c96b0530df421$var$rebalance(node) {
    return $da8c96b0530df421$var$split($da8c96b0530df421$var$skew(node));
}
function $da8c96b0530df421$var$adjust(node) {
    const { l: l, r: r, lvl: lvl } = node;
    if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) return node;
    else if (lvl > r.lvl + 1) {
        if ($da8c96b0530df421$var$isSingle(l)) return $da8c96b0530df421$var$skew($da8c96b0530df421$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$da8c96b0530df421$var$empty(l) && !$da8c96b0530df421$var$empty(l.r)) return $da8c96b0530df421$var$clone(l.r, {
                l: $da8c96b0530df421$var$clone(l, {
                    r: l.r.l
                }),
                r: $da8c96b0530df421$var$clone(node, {
                    l: l.r.r,
                    lvl: lvl - 1
                }),
                lvl: lvl
            });
            else throw new Error("Unexpected empty nodes");
        }
    } else {
        if ($da8c96b0530df421$var$isSingle(node)) return $da8c96b0530df421$var$split($da8c96b0530df421$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$da8c96b0530df421$var$empty(r) && !$da8c96b0530df421$var$empty(r.l)) {
                const rl = r.l;
                const rlvl = $da8c96b0530df421$var$isSingle(rl) ? r.lvl - 1 : r.lvl;
                return $da8c96b0530df421$var$clone(rl, {
                    l: $da8c96b0530df421$var$clone(node, {
                        r: rl.l,
                        lvl: lvl - 1
                    }),
                    r: $da8c96b0530df421$var$split($da8c96b0530df421$var$clone(r, {
                        l: rl.r,
                        lvl: rlvl
                    })),
                    lvl: rl.lvl + 1
                });
            } else throw new Error("Unexpected empty nodes");
        }
    }
}
function $da8c96b0530df421$var$rangesWithin(node, startIndex, endIndex) {
    if ($da8c96b0530df421$var$empty(node)) return [];
    const adjustedStart = $da8c96b0530df421$var$findMaxKeyValue(node, startIndex)[0];
    return $da8c96b0530df421$var$toRanges($da8c96b0530df421$var$walkWithin(node, adjustedStart, endIndex));
}
function $da8c96b0530df421$var$arrayToRanges(items, parser) {
    const length = items.length;
    if (length === 0) return [];
    let { index: start, value: value } = parser(items[0]);
    const result = [];
    for(let i = 1; i < length; i++){
        const { index: nextIndex, value: nextValue } = parser(items[i]);
        result.push({
            start: start,
            end: nextIndex - 1,
            value: value
        });
        start = nextIndex;
        value = nextValue;
    }
    result.push({
        start: start,
        end: Infinity,
        value: value
    });
    return result;
}
function $da8c96b0530df421$var$toRanges(nodes) {
    return $da8c96b0530df421$var$arrayToRanges(nodes, ({ k: index, v: value })=>({
            index: index,
            value: value
        }));
}
function $da8c96b0530df421$var$split(node) {
    const { r: r, lvl: lvl } = node;
    return !$da8c96b0530df421$var$empty(r) && !$da8c96b0530df421$var$empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? $da8c96b0530df421$var$clone(r, {
        l: $da8c96b0530df421$var$clone(node, {
            r: r.l
        }),
        lvl: lvl + 1
    }) : node;
}
function $da8c96b0530df421$var$skew(node) {
    const { l: l } = node;
    return !$da8c96b0530df421$var$empty(l) && l.lvl === node.lvl ? $da8c96b0530df421$var$clone(l, {
        r: $da8c96b0530df421$var$clone(node, {
            l: l.r
        })
    }) : node;
}
function $da8c96b0530df421$var$findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
    let end = items.length - 1;
    while(start <= end){
        const index = Math.floor((start + end) / 2);
        const item = items[index];
        const match = comparator(item, value);
        if (match === 0) return index;
        if (match === -1) {
            if (end - start < 2) return index - 1;
            end = index - 1;
        } else {
            if (end === start) return index;
            start = index + 1;
        }
    }
    throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function $da8c96b0530df421$var$findClosestSmallerOrEqual(items, value, comparator) {
    return items[$da8c96b0530df421$var$findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function $da8c96b0530df421$var$findRange(items, startValue, endValue, comparator) {
    const startIndex = $da8c96b0530df421$var$findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
    const endIndex = $da8c96b0530df421$var$findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
    return items.slice(startIndex, endIndex + 1);
}
const $da8c96b0530df421$var$recalcSystem = $da8c96b0530df421$var$system(()=>{
    const recalcInProgress = $da8c96b0530df421$var$statefulStream(false);
    return {
        recalcInProgress: recalcInProgress
    };
}, [], {
    singleton: true
});
function $da8c96b0530df421$var$rangeIncludes(refRange) {
    const { size: size, startIndex: startIndex, endIndex: endIndex } = refRange;
    return (range)=>{
        return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
    };
}
function $da8c96b0530df421$var$affectedGroupCount(offset, groupIndices) {
    let recognizedOffsetItems = 0;
    let groupIndex = 0;
    while(recognizedOffsetItems < offset){
        recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
        groupIndex++;
    }
    const offsetIsExact = recognizedOffsetItems === offset;
    return groupIndex - (offsetIsExact ? 0 : 1);
}
function $da8c96b0530df421$var$insertRanges(sizeTree, ranges) {
    let syncStart = $da8c96b0530df421$var$empty(sizeTree) ? 0 : Infinity;
    for (const range of ranges){
        const { size: size, startIndex: startIndex, endIndex: endIndex } = range;
        syncStart = Math.min(syncStart, startIndex);
        if ($da8c96b0530df421$var$empty(sizeTree)) {
            sizeTree = $da8c96b0530df421$var$insert(sizeTree, 0, size);
            continue;
        }
        const overlappingRanges = $da8c96b0530df421$var$rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
        if (overlappingRanges.some($da8c96b0530df421$var$rangeIncludes(range))) continue;
        let firstPassDone = false;
        let shouldInsert = false;
        for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges){
            if (!firstPassDone) {
                shouldInsert = rangeValue !== size;
                firstPassDone = true;
            } else if (endIndex >= rangeStart || size === rangeValue) sizeTree = $da8c96b0530df421$var$remove(sizeTree, rangeStart);
            if (rangeEnd > endIndex && endIndex >= rangeStart) {
                if (rangeValue !== size) sizeTree = $da8c96b0530df421$var$insert(sizeTree, endIndex + 1, rangeValue);
            }
        }
        if (shouldInsert) sizeTree = $da8c96b0530df421$var$insert(sizeTree, startIndex, size);
    }
    return [
        sizeTree,
        syncStart
    ];
}
function $da8c96b0530df421$var$initialSizeState() {
    return {
        offsetTree: [],
        sizeTree: $da8c96b0530df421$var$newTree(),
        groupOffsetTree: $da8c96b0530df421$var$newTree(),
        lastIndex: 0,
        lastOffset: 0,
        lastSize: 0,
        groupIndices: []
    };
}
function $da8c96b0530df421$var$indexComparator({ index: itemIndex }, index) {
    return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function $da8c96b0530df421$var$offsetComparator({ offset: itemOffset }, offset) {
    return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function $da8c96b0530df421$var$offsetPointParser(point) {
    return {
        index: point.index,
        value: point
    };
}
function $da8c96b0530df421$var$rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
    if (minStartIndex > 0) startOffset = Math.max(startOffset, $da8c96b0530df421$var$findClosestSmallerOrEqual(tree, minStartIndex, $da8c96b0530df421$var$indexComparator).offset);
    return $da8c96b0530df421$var$arrayToRanges($da8c96b0530df421$var$findRange(tree, startOffset, endOffset, $da8c96b0530df421$var$offsetComparator), $da8c96b0530df421$var$offsetPointParser);
}
function $da8c96b0530df421$var$createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
    let offsetTree = prevOffsetTree;
    let prevIndex = 0;
    let prevSize = 0;
    let prevOffset = 0;
    let startIndex = 0;
    if (syncStart !== 0) {
        startIndex = $da8c96b0530df421$var$findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, $da8c96b0530df421$var$indexComparator);
        const offsetInfo = offsetTree[startIndex];
        prevOffset = offsetInfo.offset;
        const kv = $da8c96b0530df421$var$findMaxKeyValue(sizeTree, syncStart - 1);
        prevIndex = kv[0];
        prevSize = kv[1];
        if (offsetTree.length && offsetTree[startIndex].size === $da8c96b0530df421$var$findMaxKeyValue(sizeTree, syncStart)[1]) startIndex -= 1;
        offsetTree = offsetTree.slice(0, startIndex + 1);
    } else offsetTree = [];
    for (const { start: startIndex2, value: value } of $da8c96b0530df421$var$rangesWithin(sizeTree, syncStart, Infinity)){
        const indexOffset = startIndex2 - prevIndex;
        const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
        offsetTree.push({
            offset: aOffset,
            size: value,
            index: startIndex2
        });
        prevIndex = startIndex2;
        prevOffset = aOffset;
        prevSize = value;
    }
    return {
        offsetTree: offsetTree,
        lastIndex: prevIndex,
        lastOffset: prevOffset,
        lastSize: prevSize
    };
}
function $da8c96b0530df421$var$sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
    if (ranges.length > 0) log("received item sizes", ranges, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
    const sizeTree = state.sizeTree;
    let newSizeTree = sizeTree;
    let syncStart = 0;
    if (groupIndices.length > 0 && $da8c96b0530df421$var$empty(sizeTree) && ranges.length === 2) {
        const groupSize = ranges[0].size;
        const itemSize = ranges[1].size;
        newSizeTree = groupIndices.reduce((tree, groupIndex)=>{
            return $da8c96b0530df421$var$insert($da8c96b0530df421$var$insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
        }, newSizeTree);
    } else [newSizeTree, syncStart] = $da8c96b0530df421$var$insertRanges(newSizeTree, ranges);
    if (newSizeTree === sizeTree) return state;
    const { offsetTree: newOffsetTree, lastIndex: lastIndex, lastSize: lastSize, lastOffset: lastOffset } = $da8c96b0530df421$var$createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
    return {
        sizeTree: newSizeTree,
        offsetTree: newOffsetTree,
        lastIndex: lastIndex,
        lastOffset: lastOffset,
        lastSize: lastSize,
        groupOffsetTree: groupIndices.reduce((tree, index)=>{
            return $da8c96b0530df421$var$insert(tree, index, $da8c96b0530df421$var$offsetOf(index, newOffsetTree, gap));
        }, $da8c96b0530df421$var$newTree()),
        groupIndices: groupIndices
    };
}
function $da8c96b0530df421$var$offsetOf(index, tree, gap) {
    if (tree.length === 0) return 0;
    const { offset: offset, index: startIndex, size: size } = $da8c96b0530df421$var$findClosestSmallerOrEqual(tree, index, $da8c96b0530df421$var$indexComparator);
    const itemCount = index - startIndex;
    const top = size * itemCount + (itemCount - 1) * gap + offset;
    return top > 0 ? top + gap : top;
}
function $da8c96b0530df421$var$isGroupLocation(location) {
    return typeof location.groupIndex !== "undefined";
}
function $da8c96b0530df421$var$originalIndexFromLocation(location, sizes, lastIndex) {
    if ($da8c96b0530df421$var$isGroupLocation(location)) return sizes.groupIndices[location.groupIndex] + 1;
    else {
        const numericIndex = location.index === "LAST" ? lastIndex : location.index;
        let result = $da8c96b0530df421$var$originalIndexFromItemIndex(numericIndex, sizes);
        result = Math.max(0, result, Math.min(lastIndex, result));
        return result;
    }
}
function $da8c96b0530df421$var$originalIndexFromItemIndex(itemIndex, sizes) {
    if (!$da8c96b0530df421$var$hasGroups(sizes)) return itemIndex;
    let groupOffset = 0;
    while(sizes.groupIndices[groupOffset] <= itemIndex + groupOffset)groupOffset++;
    return itemIndex + groupOffset;
}
function $da8c96b0530df421$var$hasGroups(sizes) {
    return !$da8c96b0530df421$var$empty(sizes.groupOffsetTree);
}
function $da8c96b0530df421$var$sizeTreeToRanges(sizeTree) {
    return $da8c96b0530df421$var$walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray)=>{
        const nextSize = sizeArray[index + 1];
        const endIndex = nextSize ? nextSize.k - 1 : Infinity;
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            size: size
        };
    });
}
const $da8c96b0530df421$var$SIZE_MAP = {
    offsetHeight: "height",
    offsetWidth: "width"
};
const $da8c96b0530df421$var$sizeSystem = $da8c96b0530df421$var$system(([{ log: log }, { recalcInProgress: recalcInProgress }])=>{
    const sizeRanges = $da8c96b0530df421$var$stream();
    const totalCount = $da8c96b0530df421$var$stream();
    const statefulTotalCount = $da8c96b0530df421$var$statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = $da8c96b0530df421$var$stream();
    const shiftWith = $da8c96b0530df421$var$stream();
    const firstItemIndex = $da8c96b0530df421$var$statefulStream(0);
    const groupIndices = $da8c96b0530df421$var$statefulStream([]);
    const fixedItemSize = $da8c96b0530df421$var$statefulStream(void 0);
    const defaultItemSize = $da8c96b0530df421$var$statefulStream(void 0);
    const itemSize = $da8c96b0530df421$var$statefulStream((el, field)=>$da8c96b0530df421$var$correctItemSize(el, $da8c96b0530df421$var$SIZE_MAP[field]));
    const data = $da8c96b0530df421$var$statefulStream(void 0);
    const gap = $da8c96b0530df421$var$statefulStream(0);
    const initial = $da8c96b0530df421$var$initialSizeState();
    const sizes = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(sizeRanges, $da8c96b0530df421$var$withLatestFrom(groupIndices, log, gap), $da8c96b0530df421$var$scan($da8c96b0530df421$var$sizeStateReducer, initial), $da8c96b0530df421$var$distinctUntilChanged()), initial);
    const prevGroupIndices = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(groupIndices, $da8c96b0530df421$var$distinctUntilChanged(), $da8c96b0530df421$var$scan((prev, curr)=>({
            prev: prev.current,
            current: curr
        }), {
        prev: [],
        current: []
    }), $da8c96b0530df421$var$map(({ prev: prev })=>prev)), []);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(groupIndices, $da8c96b0530df421$var$filter((indexes)=>indexes.length > 0), $da8c96b0530df421$var$withLatestFrom(sizes, gap), $da8c96b0530df421$var$map(([groupIndices2, sizes2, gap2])=>{
        const groupOffsetTree = groupIndices2.reduce((tree, index, idx)=>{
            return $da8c96b0530df421$var$insert(tree, index, $da8c96b0530df421$var$offsetOf(index, sizes2.offsetTree, gap2) || idx);
        }, $da8c96b0530df421$var$newTree());
        return {
            ...sizes2,
            groupIndices: groupIndices2,
            groupOffsetTree: groupOffsetTree
        };
    })), sizes);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(totalCount, $da8c96b0530df421$var$withLatestFrom(sizes), $da8c96b0530df421$var$filter(([totalCount2, { lastIndex: lastIndex }])=>{
        return totalCount2 < lastIndex;
    }), $da8c96b0530df421$var$map(([totalCount2, { lastIndex: lastIndex, lastSize: lastSize }])=>{
        return [
            {
                startIndex: totalCount2,
                endIndex: lastIndex,
                size: lastSize
            }
        ];
    })), sizeRanges);
    $da8c96b0530df421$var$connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(fixedItemSize, $da8c96b0530df421$var$map((size)=>size === void 0)), true);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(defaultItemSize, $da8c96b0530df421$var$filter((value)=>{
        return value !== void 0 && $da8c96b0530df421$var$empty($da8c96b0530df421$var$getValue(sizes).sizeTree);
    }), $da8c96b0530df421$var$map((size)=>[
            {
                startIndex: 0,
                endIndex: 0,
                size: size
            }
        ])), sizeRanges);
    const listRefresh = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(sizeRanges, $da8c96b0530df421$var$withLatestFrom(sizes), $da8c96b0530df421$var$scan(({ sizes: oldSizes }, [_, newSizes])=>{
        return {
            changed: newSizes !== oldSizes,
            sizes: newSizes
        };
    }, {
        changed: false,
        sizes: initial
    }), $da8c96b0530df421$var$map((value)=>value.changed)));
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(firstItemIndex, $da8c96b0530df421$var$scan((prev, next)=>{
        return {
            diff: prev.prev - next,
            prev: next
        };
    }, {
        diff: 0,
        prev: 0
    }), $da8c96b0530df421$var$map((val)=>val.diff)), (offset)=>{
        const { groupIndices: groupIndices2 } = $da8c96b0530df421$var$getValue(sizes);
        if (offset > 0) {
            $da8c96b0530df421$var$publish(recalcInProgress, true);
            $da8c96b0530df421$var$publish(unshiftWith, offset + $da8c96b0530df421$var$affectedGroupCount(offset, groupIndices2));
        } else if (offset < 0) {
            const prevGroupIndicesValue = $da8c96b0530df421$var$getValue(prevGroupIndices);
            if (prevGroupIndicesValue.length > 0) offset -= $da8c96b0530df421$var$affectedGroupCount(-offset, prevGroupIndicesValue);
            $da8c96b0530df421$var$publish(shiftWith, offset);
        }
    });
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(firstItemIndex, $da8c96b0530df421$var$withLatestFrom(log)), ([index, log2])=>{
        if (index < 0) log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
            firstItemIndex: firstItemIndex
        }, $da8c96b0530df421$export$243e62d78d3b544d.ERROR);
    });
    const beforeUnshiftWith = $da8c96b0530df421$var$streamFromEmitter(unshiftWith);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(unshiftWith, $da8c96b0530df421$var$withLatestFrom(sizes), $da8c96b0530df421$var$map(([unshiftWith2, sizes2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        const initialRanges = [];
        const defaultSize = sizes2.lastSize;
        if (groupedMode) {
            const firstGroupSize = $da8c96b0530df421$var$find(sizes2.sizeTree, 0);
            let prependedGroupItemsCount = 0;
            let groupIndex = 0;
            while(prependedGroupItemsCount < unshiftWith2){
                const theGroupIndex = sizes2.groupIndices[groupIndex];
                const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
                initialRanges.push({
                    startIndex: theGroupIndex,
                    endIndex: theGroupIndex,
                    size: firstGroupSize
                });
                initialRanges.push({
                    startIndex: theGroupIndex + 1,
                    endIndex: theGroupIndex + 1 + groupItemCount - 1,
                    size: defaultSize
                });
                groupIndex++;
                prependedGroupItemsCount += groupItemCount + 1;
            }
            const sizeTreeKV = $da8c96b0530df421$var$walk(sizes2.sizeTree);
            const firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
            if (firstGroupIsExpanded) sizeTreeKV.shift();
            return sizeTreeKV.reduce((acc, { k: index, v: size })=>{
                let ranges = acc.ranges;
                if (acc.prevSize !== 0) ranges = [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ];
                return {
                    ranges: ranges,
                    prevIndex: index + unshiftWith2,
                    prevSize: size
                };
            }, {
                ranges: initialRanges,
                prevIndex: unshiftWith2,
                prevSize: 0
            }).ranges;
        }
        return $da8c96b0530df421$var$walk(sizes2.sizeTree).reduce((acc, { k: index, v: size })=>{
            return {
                ranges: [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ],
                prevIndex: index + unshiftWith2,
                prevSize: size
            };
        }, {
            ranges: [],
            prevIndex: 0,
            prevSize: defaultSize
        }).ranges;
    })), sizeRanges);
    const shiftWithOffset = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(shiftWith, $da8c96b0530df421$var$withLatestFrom(sizes, gap), $da8c96b0530df421$var$map(([shiftWith2, { offsetTree: offsetTree }, gap2])=>{
        const newFirstItemIndex = -shiftWith2;
        return $da8c96b0530df421$var$offsetOf(newFirstItemIndex, offsetTree, gap2);
    })));
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(shiftWith, $da8c96b0530df421$var$withLatestFrom(sizes, gap), $da8c96b0530df421$var$map(([shiftWith2, sizes2, gap2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        if (groupedMode) {
            if ($da8c96b0530df421$var$empty(sizes2.sizeTree)) return sizes2;
            let newSizeTree = $da8c96b0530df421$var$newTree();
            const prevGroupIndicesValue = $da8c96b0530df421$var$getValue(prevGroupIndices);
            let removedItemsCount = 0;
            let groupIndex = 0;
            let groupOffset = 0;
            while(removedItemsCount < -shiftWith2){
                groupOffset = prevGroupIndicesValue[groupIndex];
                const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
                groupIndex++;
                removedItemsCount += groupItemCount + 1;
            }
            newSizeTree = $da8c96b0530df421$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $da8c96b0530df421$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, newSizeTree);
            const aGroupIsShrunk = removedItemsCount !== -shiftWith2;
            if (aGroupIsShrunk) {
                const firstGroupSize = $da8c96b0530df421$var$find(sizes2.sizeTree, groupOffset);
                newSizeTree = $da8c96b0530df421$var$insert(newSizeTree, 0, firstGroupSize);
                const nextItemSize = $da8c96b0530df421$var$findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
                newSizeTree = $da8c96b0530df421$var$insert(newSizeTree, 1, nextItemSize);
            }
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$da8c96b0530df421$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        } else {
            const newSizeTree = $da8c96b0530df421$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $da8c96b0530df421$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, $da8c96b0530df421$var$newTree());
            return {
                ...sizes2,
                sizeTree: newSizeTree,
                ...$da8c96b0530df421$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2)
            };
        }
    })), sizes);
    return {
        data: // input
        data,
        totalCount: totalCount,
        sizeRanges: sizeRanges,
        groupIndices: groupIndices,
        defaultItemSize: defaultItemSize,
        fixedItemSize: fixedItemSize,
        unshiftWith: unshiftWith,
        shiftWith: shiftWith,
        shiftWithOffset: shiftWithOffset,
        beforeUnshiftWith: beforeUnshiftWith,
        firstItemIndex: firstItemIndex,
        gap: gap,
        sizes: // output
        sizes,
        listRefresh: listRefresh,
        statefulTotalCount: statefulTotalCount,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$loggerSystem, $da8c96b0530df421$var$recalcSystem), {
    singleton: true
});
const $da8c96b0530df421$var$SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function $da8c96b0530df421$var$normalizeIndexLocation(location) {
    const result = typeof location === "number" ? {
        index: location
    } : location;
    if (!result.align) result.align = "start";
    if (!result.behavior || !$da8c96b0530df421$var$SUPPORTS_SCROLL_TO_OPTIONS) result.behavior = "auto";
    if (!result.offset) result.offset = 0;
    return result;
}
const $da8c96b0530df421$var$scrollToIndexSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, totalCount: totalCount, listRefresh: listRefresh, gap: gap }, { scrollingInProgress: scrollingInProgress, viewportHeight: viewportHeight, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, headerHeight: headerHeight, footerHeight: footerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { log: log }])=>{
    const scrollToIndex = $da8c96b0530df421$var$stream();
    const topListHeight = $da8c96b0530df421$var$statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
        if (unsubscribeNextListRefresh) {
            unsubscribeNextListRefresh();
            unsubscribeNextListRefresh = null;
        }
        if (unsubscribeListRefresh) {
            unsubscribeListRefresh();
            unsubscribeListRefresh = null;
        }
        if (cleartTimeoutRef) {
            clearTimeout(cleartTimeoutRef);
            cleartTimeoutRef = null;
        }
        $da8c96b0530df421$var$publish(scrollingInProgress, false);
    }
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollToIndex, $da8c96b0530df421$var$withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), $da8c96b0530df421$var$withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), $da8c96b0530df421$var$map(([[location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2], gap2, fixedHeaderHeight2, fixedFooterHeight2])=>{
        const normalLocation = $da8c96b0530df421$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        const lastIndex = totalCount2 - 1;
        const index = $da8c96b0530df421$var$originalIndexFromLocation(normalLocation, sizes2, lastIndex);
        let top = $da8c96b0530df421$var$offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
        if (align === "end") {
            top += fixedHeaderHeight2 + $da8c96b0530df421$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
            if (index === lastIndex) top += footerHeight2;
        } else if (align === "center") top += (fixedHeaderHeight2 + $da8c96b0530df421$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
        else top -= topListHeight2;
        if (offset) top += offset;
        const retry = (listChanged)=>{
            cleanup();
            if (listChanged) {
                log2("retrying to scroll to", {
                    location: location
                }, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
                $da8c96b0530df421$var$publish(scrollToIndex, location);
            } else log2("list did not change, scroll successful", {}, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
        };
        cleanup();
        if (behavior === "smooth") {
            let listChanged = false;
            unsubscribeListRefresh = $da8c96b0530df421$var$subscribe(listRefresh, (changed)=>{
                listChanged = listChanged || changed;
            });
            unsubscribeNextListRefresh = $da8c96b0530df421$var$handleNext(smoothScrollTargetReached, ()=>{
                retry(listChanged);
            });
        } else unsubscribeNextListRefresh = $da8c96b0530df421$var$handleNext($da8c96b0530df421$var$pipe(listRefresh, $da8c96b0530df421$var$watchChangesFor(150)), retry);
        cleartTimeoutRef = setTimeout(()=>{
            cleanup();
        }, 1200);
        $da8c96b0530df421$var$publish(scrollingInProgress, true);
        log2("scrolling from index to", {
            index: index,
            top: top,
            behavior: behavior
        }, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    return {
        scrollToIndex: scrollToIndex,
        topListHeight: topListHeight
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$loggerSystem), {
    singleton: true
});
function $da8c96b0530df421$var$watchChangesFor(limit) {
    return (done)=>{
        const timeoutRef = setTimeout(()=>{
            done(false);
        }, limit);
        return (value)=>{
            if (value) {
                done(true);
                clearTimeout(timeoutRef);
            }
        };
    };
}
const $da8c96b0530df421$var$UP = "up";
const $da8c96b0530df421$var$DOWN = "down";
const $da8c96b0530df421$var$NONE$1 = "none";
const $da8c96b0530df421$var$INITIAL_BOTTOM_STATE = {
    atBottom: false,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0
    }
};
const $da8c96b0530df421$var$DEFAULT_AT_TOP_THRESHOLD = 0;
const $da8c96b0530df421$var$stateFlagsSystem = $da8c96b0530df421$var$system(([{ scrollContainerState: scrollContainerState, scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, footerHeight: footerHeight, scrollBy: scrollBy }])=>{
    const isAtBottom = $da8c96b0530df421$var$statefulStream(false);
    const isAtTop = $da8c96b0530df421$var$statefulStream(true);
    const atBottomStateChange = $da8c96b0530df421$var$stream();
    const atTopStateChange = $da8c96b0530df421$var$stream();
    const atBottomThreshold = $da8c96b0530df421$var$statefulStream(4);
    const atTopThreshold = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$DEFAULT_AT_TOP_THRESHOLD);
    const isScrolling = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$merge($da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(scrollTop), $da8c96b0530df421$var$skip(1), $da8c96b0530df421$var$mapTo(true)), $da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(scrollTop), $da8c96b0530df421$var$skip(1), $da8c96b0530df421$var$mapTo(false), $da8c96b0530df421$var$debounceTime(100))), $da8c96b0530df421$var$distinctUntilChanged()), false);
    const isScrollingBy = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$merge($da8c96b0530df421$var$pipe(scrollBy, $da8c96b0530df421$var$mapTo(true)), $da8c96b0530df421$var$pipe(scrollBy, $da8c96b0530df421$var$mapTo(false), $da8c96b0530df421$var$debounceTime(200))), $da8c96b0530df421$var$distinctUntilChanged()), false);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(scrollTop), $da8c96b0530df421$var$duc(atTopThreshold)), $da8c96b0530df421$var$map(([top, atTopThreshold2])=>top <= atTopThreshold2), $da8c96b0530df421$var$distinctUntilChanged()), isAtTop);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(isAtTop, $da8c96b0530df421$var$throttleTime(50)), atTopStateChange);
    const atBottomState = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(scrollContainerState, $da8c96b0530df421$var$duc(viewportHeight), $da8c96b0530df421$var$duc(headerHeight), $da8c96b0530df421$var$duc(footerHeight), $da8c96b0530df421$var$duc(atBottomThreshold)), $da8c96b0530df421$var$scan((current, [{ scrollTop: scrollTop2, scrollHeight: scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2])=>{
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
            viewportHeight: viewportHeight2,
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight
        };
        if (isAtBottom2) {
            let atBottomBecause;
            let scrollTopDelta;
            if (scrollTop2 > current.state.scrollTop) {
                atBottomBecause = "SCROLLED_DOWN";
                scrollTopDelta = current.state.scrollTop - scrollTop2;
            } else {
                atBottomBecause = "SIZE_DECREASED";
                scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
            }
            return {
                atBottom: true,
                state: state,
                atBottomBecause: atBottomBecause,
                scrollTopDelta: scrollTopDelta
            };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) notAtBottomBecause = "SIZE_INCREASED";
        else if (viewportHeight2 < current.state.viewportHeight) notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        else if (scrollTop2 < current.state.scrollTop) notAtBottomBecause = "SCROLLING_UPWARDS";
        else notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        return {
            atBottom: false,
            notAtBottomBecause: notAtBottomBecause,
            state: state
        };
    }, $da8c96b0530df421$var$INITIAL_BOTTOM_STATE), $da8c96b0530df421$var$distinctUntilChanged((prev, next)=>{
        return prev && prev.atBottom === next.atBottom;
    })));
    const lastJumpDueToItemResize = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(scrollContainerState, $da8c96b0530df421$var$scan((current, { scrollTop: scrollTop2, scrollHeight: scrollHeight, viewportHeight: viewportHeight2 })=>{
        if (!$da8c96b0530df421$var$approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
            };
            else return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
            };
        } else return {
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight,
            jump: 0,
            changed: false
        };
    }, {
        scrollHeight: 0,
        jump: 0,
        scrollTop: 0,
        changed: false
    }), $da8c96b0530df421$var$filter((value)=>value.changed), $da8c96b0530df421$var$map((value)=>value.jump)), 0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(atBottomState, $da8c96b0530df421$var$map((state)=>state.atBottom)), isAtBottom);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(isAtBottom, $da8c96b0530df421$var$throttleTime(50)), atBottomStateChange);
    const scrollDirection = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$DOWN);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollContainerState, $da8c96b0530df421$var$map(({ scrollTop: scrollTop2 })=>scrollTop2), $da8c96b0530df421$var$distinctUntilChanged(), $da8c96b0530df421$var$scan((acc, scrollTop2)=>{
        if ($da8c96b0530df421$var$getValue(isScrollingBy)) return {
            direction: acc.direction,
            prevScrollTop: scrollTop2
        };
        return {
            direction: scrollTop2 < acc.prevScrollTop ? $da8c96b0530df421$var$UP : $da8c96b0530df421$var$DOWN,
            prevScrollTop: scrollTop2
        };
    }, {
        direction: $da8c96b0530df421$var$DOWN,
        prevScrollTop: 0
    }), $da8c96b0530df421$var$map((value)=>value.direction)), scrollDirection);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollContainerState, $da8c96b0530df421$var$throttleTime(50), $da8c96b0530df421$var$mapTo($da8c96b0530df421$var$NONE$1)), scrollDirection);
    const scrollVelocity = $da8c96b0530df421$var$statefulStream(0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(isScrolling, $da8c96b0530df421$var$filter((value)=>!value), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $da8c96b0530df421$var$mapTo(0)), scrollVelocity);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollTop, $da8c96b0530df421$var$throttleTime(100), $da8c96b0530df421$var$withLatestFrom(isScrolling), $da8c96b0530df421$var$filter(([_, isScrolling2])=>!!isScrolling2), $da8c96b0530df421$var$scan(([_, prev], [next])=>[
            prev,
            next
        ], [
        0,
        0
    ]), $da8c96b0530df421$var$map(([prev, next])=>next - prev)), scrollVelocity);
    return {
        isScrolling: isScrolling,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        atBottomState: atBottomState,
        atTopStateChange: atTopStateChange,
        atBottomStateChange: atBottomStateChange,
        scrollDirection: scrollDirection,
        atBottomThreshold: atBottomThreshold,
        atTopThreshold: atTopThreshold,
        scrollVelocity: scrollVelocity,
        lastJumpDueToItemResize: lastJumpDueToItemResize
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem));
const $da8c96b0530df421$var$propsReadySystem = $da8c96b0530df421$var$system(([{ log: log }])=>{
    const propsReady = $da8c96b0530df421$var$statefulStream(false);
    const didMount = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(propsReady, $da8c96b0530df421$var$filter((ready)=>ready), $da8c96b0530df421$var$distinctUntilChanged()));
    $da8c96b0530df421$var$subscribe(propsReady, (value)=>{
        value && $da8c96b0530df421$var$getValue(log)("props updated", {}, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
    });
    return {
        propsReady: propsReady,
        didMount: didMount
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$loggerSystem), {
    singleton: true
});
function $da8c96b0530df421$var$skipFrames(frameCount, callback) {
    if (frameCount == 0) callback();
    else requestAnimationFrame(()=>$da8c96b0530df421$var$skipFrames(frameCount - 1, callback));
}
function $da8c96b0530df421$var$getInitialTopMostItemIndexNumber(location, totalCount) {
    const lastIndex = totalCount - 1;
    const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
    return index;
}
const $da8c96b0530df421$var$initialTopMostItemIndexSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, listRefresh: listRefresh, defaultItemSize: defaultItemSize }, { scrollTop: scrollTop }, { scrollToIndex: scrollToIndex }, { didMount: didMount }])=>{
    const scrolledToInitialItem = $da8c96b0530df421$var$statefulStream(true);
    const initialTopMostItemIndex = $da8c96b0530df421$var$statefulStream(0);
    const scrollScheduled = $da8c96b0530df421$var$statefulStream(false);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(initialTopMostItemIndex), $da8c96b0530df421$var$filter(([_, location])=>!!location), $da8c96b0530df421$var$mapTo(false)), scrolledToInitialItem);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(listRefresh, didMount), $da8c96b0530df421$var$withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, scrollScheduled), $da8c96b0530df421$var$filter(([[, didMount2], scrolledToInitialItem2, { sizeTree: sizeTree }, defaultItemSize2, scrollScheduled2])=>{
        return didMount2 && (!$da8c96b0530df421$var$empty(sizeTree) || $da8c96b0530df421$var$isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled2;
    }), $da8c96b0530df421$var$withLatestFrom(initialTopMostItemIndex)), ([, initialTopMostItemIndex2])=>{
        $da8c96b0530df421$var$publish(scrollScheduled, true);
        $da8c96b0530df421$var$skipFrames(3, ()=>{
            $da8c96b0530df421$var$handleNext(scrollTop, ()=>$da8c96b0530df421$var$publish(scrolledToInitialItem, true));
            $da8c96b0530df421$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$scrollToIndexSystem, $da8c96b0530df421$var$propsReadySystem), {
    singleton: true
});
function $da8c96b0530df421$var$normalizeFollowOutput(follow) {
    if (!follow) return false;
    return follow === "smooth" ? "smooth" : "auto";
}
const $da8c96b0530df421$var$behaviorFromFollowOutput = (follow, isAtBottom)=>{
    if (typeof follow === "function") return $da8c96b0530df421$var$normalizeFollowOutput(follow(isAtBottom));
    return isAtBottom && $da8c96b0530df421$var$normalizeFollowOutput(follow);
};
const $da8c96b0530df421$var$followOutputSystem = $da8c96b0530df421$var$system(([{ totalCount: totalCount, listRefresh: listRefresh }, { isAtBottom: isAtBottom, atBottomState: atBottomState }, { scrollToIndex: scrollToIndex }, { scrolledToInitialItem: scrolledToInitialItem }, { propsReady: propsReady, didMount: didMount }, { log: log }, { scrollingInProgress: scrollingInProgress }])=>{
    const followOutput = $da8c96b0530df421$var$statefulStream(false);
    const autoscrollToBottom = $da8c96b0530df421$var$stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
        $da8c96b0530df421$var$publish(scrollToIndex, {
            index: "LAST",
            align: "end",
            behavior: followOutputBehavior
        });
    }
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(totalCount), $da8c96b0530df421$var$skip(1)), didMount), $da8c96b0530df421$var$withLatestFrom($da8c96b0530df421$var$duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), $da8c96b0530df421$var$map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2])=>{
        let shouldFollow = didMount2 && scrolledToInitialItem2;
        let followOutputBehavior = "auto";
        if (shouldFollow) {
            followOutputBehavior = $da8c96b0530df421$var$behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
        }
        return {
            totalCount: totalCount2,
            shouldFollow: shouldFollow,
            followOutputBehavior: followOutputBehavior
        };
    }), $da8c96b0530df421$var$filter(({ shouldFollow: shouldFollow })=>shouldFollow)), ({ totalCount: totalCount2, followOutputBehavior: followOutputBehavior })=>{
        if (pendingScrollHandle) {
            pendingScrollHandle();
            pendingScrollHandle = null;
        }
        pendingScrollHandle = $da8c96b0530df421$var$handleNext(listRefresh, ()=>{
            $da8c96b0530df421$var$getValue(log)("following output to ", {
                totalCount: totalCount2
            }, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
            scrollToBottom(followOutputBehavior);
            pendingScrollHandle = null;
        });
    });
    function trapNextSizeIncrease(followOutput2) {
        const cancel = $da8c96b0530df421$var$handleNext(atBottomState, (state)=>{
            if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
                $da8c96b0530df421$var$getValue(log)("scrolling to bottom due to increased size", {}, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
                scrollToBottom("auto");
            }
        });
        setTimeout(cancel, 100);
    }
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(followOutput), totalCount, propsReady), $da8c96b0530df421$var$filter(([follow, , ready])=>follow && ready), $da8c96b0530df421$var$scan(({ value: value }, [, next])=>{
        return {
            refreshed: value === next,
            value: next
        };
    }, {
        refreshed: false,
        value: 0
    }), $da8c96b0530df421$var$filter(({ refreshed: refreshed })=>refreshed), $da8c96b0530df421$var$withLatestFrom(followOutput, totalCount)), ([, followOutput2])=>{
        trapNextSizeIncrease(followOutput2 !== false);
    });
    $da8c96b0530df421$var$subscribe(autoscrollToBottom, ()=>{
        trapNextSizeIncrease($da8c96b0530df421$var$getValue(followOutput) !== false);
    });
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(followOutput), atBottomState), ([followOutput2, state])=>{
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") scrollToBottom("auto");
    });
    return {
        followOutput: followOutput,
        autoscrollToBottom: autoscrollToBottom
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$stateFlagsSystem, $da8c96b0530df421$var$scrollToIndexSystem, $da8c96b0530df421$var$initialTopMostItemIndexSystem, $da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$loggerSystem, $da8c96b0530df421$var$domIOSystem));
function $da8c96b0530df421$var$groupCountsToIndicesAndCount(counts) {
    return counts.reduce((acc, groupCount)=>{
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: []
    });
}
const $da8c96b0530df421$var$groupedListSystem = $da8c96b0530df421$var$system(([{ totalCount: totalCount, groupIndices: groupIndices, sizes: sizes }, { scrollTop: scrollTop, headerHeight: headerHeight }])=>{
    const groupCounts = $da8c96b0530df421$var$stream();
    const topItemsIndexes = $da8c96b0530df421$var$stream();
    const groupIndicesAndCount = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(groupCounts, $da8c96b0530df421$var$map($da8c96b0530df421$var$groupCountsToIndicesAndCount)));
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(groupIndicesAndCount, $da8c96b0530df421$var$map((value)=>value.totalCount)), totalCount);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(groupIndicesAndCount, $da8c96b0530df421$var$map((value)=>value.groupIndices)), groupIndices);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(scrollTop, sizes, headerHeight), $da8c96b0530df421$var$filter(([_, sizes2])=>$da8c96b0530df421$var$hasGroups(sizes2)), $da8c96b0530df421$var$map(([scrollTop2, state, headerHeight2])=>$da8c96b0530df421$var$findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]), $da8c96b0530df421$var$distinctUntilChanged(), $da8c96b0530df421$var$map((index)=>[
            index
        ])), topItemsIndexes);
    return {
        groupCounts: groupCounts,
        topItemsIndexes: topItemsIndexes
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$domIOSystem));
function $da8c96b0530df421$var$tupleComparator(prev, current) {
    return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function $da8c96b0530df421$var$rangeComparator(prev, next) {
    return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const $da8c96b0530df421$var$TOP = "top";
const $da8c96b0530df421$var$BOTTOM = "bottom";
const $da8c96b0530df421$var$NONE = "none";
function $da8c96b0530df421$var$getOverscan(overscan, end, direction) {
    if (typeof overscan === "number") return direction === $da8c96b0530df421$var$UP && end === $da8c96b0530df421$var$TOP || direction === $da8c96b0530df421$var$DOWN && end === $da8c96b0530df421$var$BOTTOM ? overscan : 0;
    else {
        if (direction === $da8c96b0530df421$var$UP) return end === $da8c96b0530df421$var$TOP ? overscan.main : overscan.reverse;
        else return end === $da8c96b0530df421$var$BOTTOM ? overscan.main : overscan.reverse;
    }
}
function $da8c96b0530df421$var$getViewportIncrease(value, end) {
    return typeof value === "number" ? value : value[end] || 0;
}
const $da8c96b0530df421$var$sizeRangeSystem = $da8c96b0530df421$var$system(([{ scrollTop: scrollTop, viewportHeight: viewportHeight, deviation: deviation, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight }])=>{
    const listBoundary = $da8c96b0530df421$var$stream();
    const topListHeight = $da8c96b0530df421$var$statefulStream(0);
    const increaseViewportBy = $da8c96b0530df421$var$statefulStream(0);
    const overscan = $da8c96b0530df421$var$statefulStream(0);
    const visibleRange = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(scrollTop), $da8c96b0530df421$var$duc(viewportHeight), $da8c96b0530df421$var$duc(headerHeight), $da8c96b0530df421$var$duc(listBoundary, $da8c96b0530df421$var$tupleComparator), $da8c96b0530df421$var$duc(overscan), $da8c96b0530df421$var$duc(topListHeight), $da8c96b0530df421$var$duc(fixedHeaderHeight), $da8c96b0530df421$var$duc(deviation), $da8c96b0530df421$var$duc(increaseViewportBy)), $da8c96b0530df421$var$map(([scrollTop2, viewportHeight2, headerHeight2, [listTop, listBottom], overscan2, topListHeight2, fixedHeaderHeight2, deviation2, increaseViewportBy2])=>{
        const top = scrollTop2 - deviation2;
        const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
        const headerVisible = Math.max(headerHeight2 - top, 0);
        let direction = $da8c96b0530df421$var$NONE;
        const topViewportAddition = $da8c96b0530df421$var$getViewportIncrease(increaseViewportBy2, $da8c96b0530df421$var$TOP);
        const bottomViewportAddition = $da8c96b0530df421$var$getViewportIncrease(increaseViewportBy2, $da8c96b0530df421$var$BOTTOM);
        listTop -= deviation2;
        listTop += headerHeight2 + fixedHeaderHeight2;
        listBottom += headerHeight2 + fixedHeaderHeight2;
        listBottom -= deviation2;
        if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) direction = $da8c96b0530df421$var$UP;
        if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) direction = $da8c96b0530df421$var$DOWN;
        if (direction !== $da8c96b0530df421$var$NONE) return [
            Math.max(top - headerHeight2 - $da8c96b0530df421$var$getOverscan(overscan2, $da8c96b0530df421$var$TOP, direction) - topViewportAddition, 0),
            top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + $da8c96b0530df421$var$getOverscan(overscan2, $da8c96b0530df421$var$BOTTOM, direction) + bottomViewportAddition
        ];
        return null;
    }), $da8c96b0530df421$var$filter((value)=>value != null), $da8c96b0530df421$var$distinctUntilChanged($da8c96b0530df421$var$tupleComparator)), [
        0,
        0
    ]);
    return {
        listBoundary: // input
        listBoundary,
        overscan: overscan,
        topListHeight: topListHeight,
        increaseViewportBy: increaseViewportBy,
        visibleRange: // output
        visibleRange
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem), {
    singleton: true
});
function $da8c96b0530df421$var$probeItemSet(index, sizes, data) {
    if ($da8c96b0530df421$var$hasGroups(sizes)) {
        const itemIndex = $da8c96b0530df421$var$originalIndexFromItemIndex(index, sizes);
        const groupIndex = $da8c96b0530df421$var$findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
        return [
            {
                index: groupIndex,
                size: 0,
                offset: 0
            },
            {
                index: itemIndex,
                size: 0,
                offset: 0,
                data: data && data[0]
            }
        ];
    }
    return [
        {
            index: index,
            size: 0,
            offset: 0,
            data: data && data[0]
        }
    ];
}
const $da8c96b0530df421$var$EMPTY_LIST_STATE = {
    items: [],
    topItems: [],
    offsetTop: 0,
    offsetBottom: 0,
    top: 0,
    bottom: 0,
    topListHeight: 0,
    totalCount: 0,
    firstItemIndex: 0
};
function $da8c96b0530df421$var$transposeItems(items, sizes, firstItemIndex) {
    if (items.length === 0) return [];
    if (!$da8c96b0530df421$var$hasGroups(sizes)) return items.map((item)=>({
            ...item,
            index: item.index + firstItemIndex,
            originalIndex: item.index
        }));
    const startIndex = items[0].index;
    const endIndex = items[items.length - 1].index;
    const transposedItems = [];
    const groupRanges = $da8c96b0530df421$var$rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
    let currentRange = void 0;
    let currentGroupIndex = 0;
    for (const item of items){
        if (!currentRange || currentRange.end < item.index) {
            currentRange = groupRanges.shift();
            currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
        }
        let transposedItem;
        if (item.index === currentRange.start) transposedItem = {
            type: "group",
            index: currentGroupIndex
        };
        else transposedItem = {
            index: item.index - (currentGroupIndex + 1) + firstItemIndex,
            groupIndex: currentGroupIndex
        };
        transposedItems.push({
            ...transposedItem,
            size: item.size,
            offset: item.offset,
            originalIndex: item.index,
            data: item.data
        });
    }
    return transposedItems;
}
function $da8c96b0530df421$var$buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
    const { lastSize: lastSize, lastOffset: lastOffset, lastIndex: lastIndex } = sizes;
    let offsetTop = 0;
    let bottom = 0;
    if (items.length > 0) {
        offsetTop = items[0].offset;
        const lastItem = items[items.length - 1];
        bottom = lastItem.offset + lastItem.size;
    }
    const itemCount = totalCount - lastIndex;
    const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
    const top = offsetTop;
    const offsetBottom = total - bottom;
    return {
        items: $da8c96b0530df421$var$transposeItems(items, sizes, firstItemIndex),
        topItems: $da8c96b0530df421$var$transposeItems(topItems, sizes, firstItemIndex),
        topListHeight: topItems.reduce((height, item)=>item.size + height, 0),
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        top: top,
        bottom: bottom,
        totalCount: totalCount,
        firstItemIndex: firstItemIndex
    };
}
function $da8c96b0530df421$var$buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
    let includedGroupsCount = 0;
    if (sizes.groupIndices.length > 0) for (const index of sizes.groupIndices){
        if (index - includedGroupsCount >= itemCount) break;
        includedGroupsCount++;
    }
    const adjustedCount = itemCount + includedGroupsCount;
    const initialTopMostItemIndexNumber = $da8c96b0530df421$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
    const items = Array.from({
        length: adjustedCount
    }).map((_, index)=>({
            index: index + initialTopMostItemIndexNumber,
            size: 0,
            offset: 0,
            data: data[index + initialTopMostItemIndexNumber]
        }));
    return $da8c96b0530df421$var$buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
const $da8c96b0530df421$var$listStateSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, totalCount: totalCount, data: data, firstItemIndex: firstItemIndex, gap: gap }, groupedListSystem2, { visibleRange: visibleRange, listBoundary: listBoundary, topListHeight: rangeTopListHeight }, { scrolledToInitialItem: scrolledToInitialItem, initialTopMostItemIndex: initialTopMostItemIndex }, { topListHeight: topListHeight }, stateFlags, { didMount: didMount }, { recalcInProgress: recalcInProgress }])=>{
    const topItemsIndexes = $da8c96b0530df421$var$statefulStream([]);
    const initialItemCount = $da8c96b0530df421$var$statefulStream(0);
    const itemsRendered = $da8c96b0530df421$var$stream();
    $da8c96b0530df421$var$connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(didMount, recalcInProgress, $da8c96b0530df421$var$duc(visibleRange, $da8c96b0530df421$var$tupleComparator), $da8c96b0530df421$var$duc(totalCount), $da8c96b0530df421$var$duc(sizes), $da8c96b0530df421$var$duc(initialTopMostItemIndex), scrolledToInitialItem, $da8c96b0530df421$var$duc(topItemsIndexes), $da8c96b0530df421$var$duc(firstItemIndex), $da8c96b0530df421$var$duc(gap), data), $da8c96b0530df421$var$filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2])=>{
        const dataChangeInProgress = data2 && data2.length !== totalCount2;
        return mount && !recalcInProgress2 && !dataChangeInProgress;
    }), $da8c96b0530df421$var$map(([, , [startOffset, endOffset], totalCount2, sizes2, initialTopMostItemIndex2, scrolledToInitialItem2, topItemsIndexes2, firstItemIndex2, gap2, data2])=>{
        const sizesValue = sizes2;
        const { sizeTree: sizeTree, offsetTree: offsetTree } = sizesValue;
        const initialItemCountValue = $da8c96b0530df421$var$getValue(initialItemCount);
        if (totalCount2 === 0) return {
            ...$da8c96b0530df421$var$EMPTY_LIST_STATE,
            totalCount: totalCount2
        };
        if (startOffset === 0 && endOffset === 0) {
            if (initialItemCountValue === 0) return {
                ...$da8c96b0530df421$var$EMPTY_LIST_STATE,
                totalCount: totalCount2
            };
            else return $da8c96b0530df421$var$buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
        }
        if ($da8c96b0530df421$var$empty(sizeTree)) {
            if (initialItemCountValue > 0) return null;
            const state = $da8c96b0530df421$var$buildListState($da8c96b0530df421$var$probeItemSet($da8c96b0530df421$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
            return state;
        }
        const topItems = [];
        if (topItemsIndexes2.length > 0) {
            const startIndex = topItemsIndexes2[0];
            const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
            let offset = 0;
            for (const range of $da8c96b0530df421$var$rangesWithin(sizeTree, startIndex, endIndex)){
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for(let i = rangeStartIndex; i <= rangeEndIndex; i++){
                    topItems.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size;
                }
            }
        }
        if (!scrolledToInitialItem2) return $da8c96b0530df421$var$buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
        const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
        const offsetPointRanges = $da8c96b0530df421$var$rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
        if (offsetPointRanges.length === 0) return null;
        const maxIndex = totalCount2 - 1;
        const items = $da8c96b0530df421$var$tap([], (result)=>{
            for (const range of offsetPointRanges){
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                    rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                    const itemCount = rangeStartIndex - range.start;
                    offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                    offset += (minStartIndex - rangeStartIndex) * size;
                    rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for(let i = rangeStartIndex; i <= endIndex; i++){
                    if (offset >= endOffset) break;
                    result.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size + gap2;
                }
            }
        });
        return $da8c96b0530df421$var$buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
    }), //@ts-expect-error filter needs to be fixed
    $da8c96b0530df421$var$filter((value)=>value !== null), $da8c96b0530df421$var$distinctUntilChanged()), $da8c96b0530df421$var$EMPTY_LIST_STATE);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(data, $da8c96b0530df421$var$filter($da8c96b0530df421$var$isDefined), $da8c96b0530df421$var$map((data2)=>data2 == null ? void 0 : data2.length)), totalCount);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$map((value)=>value.topListHeight)), topListHeight);
    $da8c96b0530df421$var$connect(topListHeight, rangeTopListHeight);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$map((state)=>[
            state.top,
            state.bottom
        ])), listBoundary);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$map((state)=>state.items)), itemsRendered);
    const endReached = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$filter(({ items: items })=>items.length > 0), $da8c96b0530df421$var$withLatestFrom(totalCount, data), $da8c96b0530df421$var$filter(([{ items: items }, totalCount2])=>items[items.length - 1].originalIndex === totalCount2 - 1), $da8c96b0530df421$var$map(([, totalCount2, data2])=>[
            totalCount2 - 1,
            data2
        ]), $da8c96b0530df421$var$distinctUntilChanged($da8c96b0530df421$var$tupleComparator), $da8c96b0530df421$var$map(([count])=>count)));
    const startReached = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$throttleTime(200), $da8c96b0530df421$var$filter(({ items: items, topItems: topItems })=>{
        return items.length > 0 && items[0].originalIndex === topItems.length;
    }), $da8c96b0530df421$var$map(({ items: items })=>items[0].index), $da8c96b0530df421$var$distinctUntilChanged()));
    const rangeChanged = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$filter(({ items: items })=>items.length > 0), $da8c96b0530df421$var$map(({ items: items })=>{
        let startIndex = 0;
        let endIndex = items.length - 1;
        while(items[startIndex].type === "group" && startIndex < endIndex)startIndex++;
        while(items[endIndex].type === "group" && endIndex > startIndex)endIndex--;
        return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
        };
    }), $da8c96b0530df421$var$distinctUntilChanged($da8c96b0530df421$var$rangeComparator)));
    return {
        listState: listState,
        topItemsIndexes: topItemsIndexes,
        endReached: endReached,
        startReached: startReached,
        rangeChanged: rangeChanged,
        itemsRendered: itemsRendered,
        initialItemCount: initialItemCount,
        ...stateFlags
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$groupedListSystem, $da8c96b0530df421$var$sizeRangeSystem, $da8c96b0530df421$var$initialTopMostItemIndexSystem, $da8c96b0530df421$var$scrollToIndexSystem, $da8c96b0530df421$var$stateFlagsSystem, $da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$recalcSystem), {
    singleton: true
});
const $da8c96b0530df421$var$initialItemCountSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, firstItemIndex: firstItemIndex, data: data, gap: gap }, { initialTopMostItemIndex: initialTopMostItemIndex }, { initialItemCount: initialItemCount, listState: listState }, { didMount: didMount }])=>{
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(initialItemCount), $da8c96b0530df421$var$filter(([, count])=>count !== 0), $da8c96b0530df421$var$withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), $da8c96b0530df421$var$map(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []])=>{
        return $da8c96b0530df421$var$buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
    })), listState);
    return {};
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$initialTopMostItemIndexSystem, $da8c96b0530df421$var$listStateSystem, $da8c96b0530df421$var$propsReadySystem), {
    singleton: true
});
const $da8c96b0530df421$var$scrollSeekSystem = $da8c96b0530df421$var$system(([{ scrollVelocity: scrollVelocity }])=>{
    const isSeeking = $da8c96b0530df421$var$statefulStream(false);
    const rangeChanged = $da8c96b0530df421$var$stream();
    const scrollSeekConfiguration = $da8c96b0530df421$var$statefulStream(false);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollVelocity, $da8c96b0530df421$var$withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), $da8c96b0530df421$var$filter(([_, config])=>!!config), $da8c96b0530df421$var$map(([speed, config, isSeeking2, range])=>{
        const { exit: exit, enter: enter } = config;
        if (isSeeking2) {
            if (exit(speed, range)) return false;
        } else {
            if (enter(speed, range)) return true;
        }
        return isSeeking2;
    }), $da8c96b0530df421$var$distinctUntilChanged()), isSeeking);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(isSeeking, scrollVelocity, rangeChanged), $da8c96b0530df421$var$withLatestFrom(scrollSeekConfiguration)), ([[isSeeking2, velocity, range], config])=>isSeeking2 && config && config.change && config.change(velocity, range));
    return {
        isSeeking: isSeeking,
        scrollSeekConfiguration: scrollSeekConfiguration,
        scrollVelocity: scrollVelocity,
        scrollSeekRangeChanged: rangeChanged
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$stateFlagsSystem), {
    singleton: true
});
const $da8c96b0530df421$var$topItemCountSystem = $da8c96b0530df421$var$system(([{ topItemsIndexes: topItemsIndexes }])=>{
    const topItemCount = $da8c96b0530df421$var$statefulStream(0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(topItemCount, $da8c96b0530df421$var$filter((length)=>length > 0), $da8c96b0530df421$var$map((length)=>Array.from({
            length: length
        }).map((_, index)=>index))), topItemsIndexes);
    return {
        topItemCount: topItemCount
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$listStateSystem));
const $da8c96b0530df421$var$totalListHeightSystem = $da8c96b0530df421$var$system(([{ footerHeight: footerHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { listState: listState }])=>{
    const totalListHeightChanged = $da8c96b0530df421$var$stream();
    const totalListHeight = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), $da8c96b0530df421$var$map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2])=>{
        return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
    })), 0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$duc(totalListHeight), totalListHeightChanged);
    return {
        totalListHeight: totalListHeight,
        totalListHeightChanged: totalListHeightChanged
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$listStateSystem), {
    singleton: true
});
function $da8c96b0530df421$var$simpleMemoize(func) {
    let called = false;
    let result;
    return ()=>{
        if (!called) {
            called = true;
            result = func();
        }
        return result;
    };
}
const $da8c96b0530df421$var$isMobileSafari = $da8c96b0530df421$var$simpleMemoize(()=>{
    return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const $da8c96b0530df421$var$upwardScrollFixSystem = $da8c96b0530df421$var$system(([{ scrollBy: scrollBy, scrollTop: scrollTop, deviation: deviation, scrollingInProgress: scrollingInProgress }, { isScrolling: isScrolling, isAtBottom: isAtBottom, scrollDirection: scrollDirection, lastJumpDueToItemResize: lastJumpDueToItemResize }, { listState: listState }, { beforeUnshiftWith: beforeUnshiftWith, shiftWithOffset: shiftWithOffset, sizes: sizes, gap: gap }, { log: log }, { recalcInProgress: recalcInProgress }])=>{
    const deviationOffset = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$withLatestFrom(lastJumpDueToItemResize), $da8c96b0530df421$var$scan(([, prevItems, prevTotalCount, prevTotalHeight], [{ items: items, totalCount: totalCount, bottom: bottom, offsetBottom: offsetBottom }, lastJumpDueToItemResize2])=>{
        const totalHeight = bottom + offsetBottom;
        let newDev = 0;
        if (prevTotalCount === totalCount) {
            if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                    newDev = totalHeight - prevTotalHeight;
                    if (newDev !== 0) newDev += lastJumpDueToItemResize2;
                }
            }
        }
        return [
            newDev,
            items,
            totalCount,
            totalHeight
        ];
    }, [
        0,
        [],
        0,
        0
    ]), $da8c96b0530df421$var$filter(([amount])=>amount !== 0), $da8c96b0530df421$var$withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), $da8c96b0530df421$var$filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2])=>{
        return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === $da8c96b0530df421$var$UP;
    }), $da8c96b0530df421$var$map(([[amount], , , , , log2])=>{
        log2("Upward scrolling compensation", {
            amount: amount
        }, $da8c96b0530df421$export$243e62d78d3b544d.DEBUG);
        return amount;
    })));
    function scrollByWith(offset) {
        if (offset > 0) {
            $da8c96b0530df421$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
            $da8c96b0530df421$var$publish(deviation, 0);
        } else {
            $da8c96b0530df421$var$publish(deviation, 0);
            $da8c96b0530df421$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
        }
    }
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(deviationOffset, $da8c96b0530df421$var$withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2])=>{
        if (isScrolling2 && $da8c96b0530df421$var$isMobileSafari()) $da8c96b0530df421$var$publish(deviation, deviationAmount - offset);
        else scrollByWith(-offset);
    });
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), $da8c96b0530df421$var$filter(([is, deviation2, recalc])=>!is && !recalc && deviation2 !== 0), $da8c96b0530df421$var$map(([_, deviation2])=>deviation2), $da8c96b0530df421$var$throttleTime(1)), scrollByWith);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(shiftWithOffset, $da8c96b0530df421$var$map((offset)=>{
        return {
            top: -offset
        };
    })), scrollBy);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(beforeUnshiftWith, $da8c96b0530df421$var$withLatestFrom(sizes, gap), $da8c96b0530df421$var$map(([offset, { lastSize: defaultItemSize, groupIndices: groupIndices, sizeTree: sizeTree }, gap2])=>{
        function getItemOffset(itemCount) {
            return itemCount * (defaultItemSize + gap2);
        }
        if (groupIndices.length === 0) return getItemOffset(offset);
        else {
            let amount = 0;
            const defaultGroupSize = $da8c96b0530df421$var$find(sizeTree, 0);
            let recognizedOffsetItems = 0;
            let groupIndex = 0;
            while(recognizedOffsetItems < offset){
                recognizedOffsetItems++;
                amount += defaultGroupSize;
                let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
                if (recognizedOffsetItems + groupItemCount > offset) {
                    amount -= defaultGroupSize;
                    groupItemCount = offset - recognizedOffsetItems + 1;
                }
                recognizedOffsetItems += groupItemCount;
                amount += getItemOffset(groupItemCount);
                groupIndex++;
            }
            return amount;
        }
    })), (offset)=>{
        $da8c96b0530df421$var$publish(deviation, offset);
        requestAnimationFrame(()=>{
            $da8c96b0530df421$var$publish(scrollBy, {
                top: offset
            });
            requestAnimationFrame(()=>{
                $da8c96b0530df421$var$publish(deviation, 0);
                $da8c96b0530df421$var$publish(recalcInProgress, false);
            });
        });
    });
    return {
        deviation: deviation
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$stateFlagsSystem, $da8c96b0530df421$var$listStateSystem, $da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$loggerSystem, $da8c96b0530df421$var$recalcSystem));
const $da8c96b0530df421$var$initialScrollTopSystem = $da8c96b0530df421$var$system(([{ didMount: didMount }, { scrollTo: scrollTo }, { listState: listState }])=>{
    const initialScrollTop = $da8c96b0530df421$var$statefulStream(0);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(initialScrollTop), $da8c96b0530df421$var$filter(([, offset])=>offset !== 0), $da8c96b0530df421$var$map(([, offset])=>({
            top: offset
        }))), (location)=>{
        $da8c96b0530df421$var$handleNext($da8c96b0530df421$var$pipe(listState, $da8c96b0530df421$var$skip(1), $da8c96b0530df421$var$filter((state)=>state.items.length > 1)), ()=>{
            requestAnimationFrame(()=>{
                $da8c96b0530df421$var$publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$listStateSystem), {
    singleton: true
});
const $da8c96b0530df421$var$alignToBottomSystem = $da8c96b0530df421$var$system(([{ viewportHeight: viewportHeight }, { totalListHeight: totalListHeight }])=>{
    const alignToBottom = $da8c96b0530df421$var$statefulStream(false);
    const paddingTopAddition = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(alignToBottom, viewportHeight, totalListHeight), $da8c96b0530df421$var$filter(([enabled])=>enabled), $da8c96b0530df421$var$map(([, viewportHeight2, totalListHeight2])=>{
        return Math.max(0, viewportHeight2 - totalListHeight2);
    }), $da8c96b0530df421$var$throttleTime(0), $da8c96b0530df421$var$distinctUntilChanged()), 0);
    return {
        alignToBottom: alignToBottom,
        paddingTopAddition: paddingTopAddition
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$totalListHeightSystem), {
    singleton: true
});
const $da8c96b0530df421$var$windowScrollerSystem = $da8c96b0530df421$var$system(([{ scrollTo: scrollTo, scrollContainerState: scrollContainerState }])=>{
    const windowScrollContainerState = $da8c96b0530df421$var$stream();
    const windowViewportRect = $da8c96b0530df421$var$stream();
    const windowScrollTo = $da8c96b0530df421$var$stream();
    const useWindowScroll = $da8c96b0530df421$var$statefulStream(false);
    const customScrollParent = $da8c96b0530df421$var$statefulStream(void 0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(windowScrollContainerState, windowViewportRect), $da8c96b0530df421$var$map(([{ viewportHeight: viewportHeight, scrollTop: windowScrollTop, scrollHeight: scrollHeight }, { offsetTop: offsetTop }])=>{
        return {
            scrollTop: Math.max(0, windowScrollTop - offsetTop),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        };
    })), scrollContainerState);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollTo, $da8c96b0530df421$var$withLatestFrom(windowViewportRect), $da8c96b0530df421$var$map(([scrollTo2, { offsetTop: offsetTop }])=>{
        return {
            ...scrollTo2,
            top: scrollTo2.top + offsetTop
        };
    })), windowScrollTo);
    return {
        useWindowScroll: // config
        useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: // input
        windowScrollContainerState,
        windowViewportRect: windowViewportRect,
        windowScrollTo: // signals
        windowScrollTo
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$domIOSystem));
const $da8c96b0530df421$var$defaultCalculateViewLocation = ({ itemTop: itemTop2, itemBottom: itemBottom, viewportTop: viewportTop, viewportBottom: viewportBottom, locationParams: { behavior: behavior, align: align, ...rest } })=>{
    if (itemTop2 < viewportTop) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "start"
    };
    if (itemBottom > viewportBottom) return {
        ...rest,
        behavior: behavior,
        align: align != null ? align : "end"
    };
    return null;
};
const $da8c96b0530df421$var$scrollIntoViewSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, totalCount: totalCount, gap: gap }, { scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight, scrollingInProgress: scrollingInProgress }, { scrollToIndex: scrollToIndex }])=>{
    const scrollIntoView = $da8c96b0530df421$var$stream();
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollIntoView, $da8c96b0530df421$var$withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), $da8c96b0530df421$var$withLatestFrom(gap), $da8c96b0530df421$var$map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2])=>{
        const { done: done, behavior: behavior, align: align, calculateViewLocation: calculateViewLocation = $da8c96b0530df421$var$defaultCalculateViewLocation, ...rest } = viewLocation;
        const actualIndex = $da8c96b0530df421$var$originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
        const itemTop2 = $da8c96b0530df421$var$offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
        const itemBottom = itemTop2 + $da8c96b0530df421$var$findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
        const viewportTop = scrollTop2 + fixedHeaderHeight2;
        const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
        const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom: itemBottom,
            viewportTop: viewportTop,
            viewportBottom: viewportBottom,
            locationParams: {
                behavior: behavior,
                align: align,
                ...rest
            }
        });
        if (location) done && $da8c96b0530df421$var$handleNext($da8c96b0530df421$var$pipe(scrollingInProgress, $da8c96b0530df421$var$filter((value)=>value === false), // skips the initial publish of false, and the cleanup call.
        // but if scrollingInProgress is true, we skip the initial publish.
        $da8c96b0530df421$var$skip($da8c96b0530df421$var$getValue(scrollingInProgress) ? 1 : 2)), done);
        else done && done();
        return location;
    }), $da8c96b0530df421$var$filter((value)=>value !== null)), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$scrollToIndexSystem, $da8c96b0530df421$var$listStateSystem, $da8c96b0530df421$var$loggerSystem), {
    singleton: true
});
const $da8c96b0530df421$var$stateLoadSystem = $da8c96b0530df421$var$system(([{ sizes: sizes, sizeRanges: sizeRanges }, { scrollTop: scrollTop }, { initialTopMostItemIndex: initialTopMostItemIndex }, { didMount: didMount }, { useWindowScroll: useWindowScroll, windowScrollContainerState: windowScrollContainerState, windowViewportRect: windowViewportRect }])=>{
    const getState = $da8c96b0530df421$var$stream();
    const restoreStateFrom = $da8c96b0530df421$var$statefulStream(void 0);
    const statefulWindowScrollContainerState = $da8c96b0530df421$var$statefulStream(null);
    const statefulWindowViewportRect = $da8c96b0530df421$var$statefulStream(null);
    $da8c96b0530df421$var$connect(windowScrollContainerState, statefulWindowScrollContainerState);
    $da8c96b0530df421$var$connect(windowViewportRect, statefulWindowViewportRect);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(getState, $da8c96b0530df421$var$withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect)), ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2])=>{
        const ranges = $da8c96b0530df421$var$sizeTreeToRanges(sizes2.sizeTree);
        if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
        callback({
            ranges: ranges,
            scrollTop: scrollTop2
        });
    });
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(restoreStateFrom, $da8c96b0530df421$var$filter($da8c96b0530df421$var$isDefined), $da8c96b0530df421$var$map($da8c96b0530df421$var$locationFromSnapshot)), initialTopMostItemIndex);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(restoreStateFrom), $da8c96b0530df421$var$filter(([, state])=>state !== void 0), $da8c96b0530df421$var$distinctUntilChanged(), $da8c96b0530df421$var$map(([, snapshot])=>{
        return snapshot.ranges;
    })), sizeRanges);
    return {
        getState: getState,
        restoreStateFrom: restoreStateFrom
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$initialTopMostItemIndexSystem, $da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$windowScrollerSystem));
function $da8c96b0530df421$var$locationFromSnapshot(snapshot) {
    return {
        offset: snapshot.scrollTop,
        index: 0,
        align: "start"
    };
}
const $da8c96b0530df421$var$featureGroup1System = $da8c96b0530df421$var$system(([sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger])=>{
    return {
        ...sizeRange,
        ...initialItemCount,
        ...propsReady,
        ...scrollSeek,
        ...totalListHeight,
        ...initialScrollTopSystem2,
        ...alignToBottom,
        ...windowScroller,
        ...scrollIntoView,
        ...logger
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeRangeSystem, $da8c96b0530df421$var$initialItemCountSystem, $da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$scrollSeekSystem, $da8c96b0530df421$var$totalListHeightSystem, $da8c96b0530df421$var$initialScrollTopSystem, $da8c96b0530df421$var$alignToBottomSystem, $da8c96b0530df421$var$windowScrollerSystem, $da8c96b0530df421$var$scrollIntoViewSystem, $da8c96b0530df421$var$loggerSystem));
const $da8c96b0530df421$var$listSystem = $da8c96b0530df421$var$system(([{ totalCount: totalCount, sizeRanges: sizeRanges, fixedItemSize: fixedItemSize, defaultItemSize: defaultItemSize, trackItemSizes: trackItemSizes, itemSize: itemSize, data: data, firstItemIndex: firstItemIndex, groupIndices: groupIndices, statefulTotalCount: statefulTotalCount, gap: gap, sizes: sizes }, { initialTopMostItemIndex: initialTopMostItemIndex, scrolledToInitialItem: scrolledToInitialItem }, domIO, stateLoad, followOutput, { listState: listState, topItemsIndexes: topItemsIndexes, ...flags }, { scrollToIndex: scrollToIndex }, _, { topItemCount: topItemCount }, { groupCounts: groupCounts }, featureGroup1])=>{
    $da8c96b0530df421$var$connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(featureGroup1.windowViewportRect, $da8c96b0530df421$var$map((value)=>value.visibleHeight)), domIO.viewportHeight);
    return {
        totalCount: // input
        totalCount,
        data: data,
        firstItemIndex: firstItemIndex,
        sizeRanges: sizeRanges,
        initialTopMostItemIndex: initialTopMostItemIndex,
        scrolledToInitialItem: scrolledToInitialItem,
        topItemsIndexes: topItemsIndexes,
        topItemCount: topItemCount,
        groupCounts: groupCounts,
        fixedItemHeight: fixedItemSize,
        defaultItemHeight: defaultItemSize,
        gap: gap,
        ...followOutput,
        statefulTotalCount: // output
        statefulTotalCount,
        listState: listState,
        scrollToIndex: scrollToIndex,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize,
        groupIndices: groupIndices,
        // exported from stateFlagsSystem
        ...flags,
        // the bag of IO from featureGroup1System
        ...featureGroup1,
        ...domIO,
        sizes: sizes,
        ...stateLoad
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeSystem, $da8c96b0530df421$var$initialTopMostItemIndexSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$stateLoadSystem, $da8c96b0530df421$var$followOutputSystem, $da8c96b0530df421$var$listStateSystem, $da8c96b0530df421$var$scrollToIndexSystem, $da8c96b0530df421$var$upwardScrollFixSystem, $da8c96b0530df421$var$topItemCountSystem, $da8c96b0530df421$var$groupedListSystem, $da8c96b0530df421$var$featureGroup1System));
const $da8c96b0530df421$var$WEBKIT_STICKY = "-webkit-sticky";
const $da8c96b0530df421$var$STICKY = "sticky";
const $da8c96b0530df421$var$positionStickyCssValue = $da8c96b0530df421$var$simpleMemoize(()=>{
    if (typeof document === "undefined") return $da8c96b0530df421$var$STICKY;
    const node = document.createElement("div");
    node.style.position = $da8c96b0530df421$var$WEBKIT_STICKY;
    return node.style.position === $da8c96b0530df421$var$WEBKIT_STICKY ? $da8c96b0530df421$var$WEBKIT_STICKY : $da8c96b0530df421$var$STICKY;
});
function $da8c96b0530df421$var$useWindowViewportRectRef(callback, customScrollParent) {
    const viewportInfo = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const calculateInfo = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((element)=>{
        if (element === null || !element.offsetParent) return;
        const rect = element.getBoundingClientRect();
        const visibleWidth = rect.width;
        let visibleHeight, offsetTop;
        if (customScrollParent) {
            const customScrollParentRect = customScrollParent.getBoundingClientRect();
            const deltaTop = rect.top - customScrollParentRect.top;
            visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
            offsetTop = deltaTop + customScrollParent.scrollTop;
        } else {
            visibleHeight = window.innerHeight - Math.max(0, rect.top);
            offsetTop = rect.top + window.pageYOffset;
        }
        viewportInfo.current = {
            offsetTop: offsetTop,
            visibleHeight: visibleHeight,
            visibleWidth: visibleWidth
        };
        callback(viewportInfo.current);
    }, [
        callback,
        customScrollParent
    ]);
    const { callbackRef: callbackRef, ref: ref } = $da8c96b0530df421$var$useSizeWithElRef(calculateInfo);
    const scrollAndResizeEventHandler = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
        calculateInfo(ref.current);
    }, [
        calculateInfo,
        ref
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (customScrollParent) {
            customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
            const observer = new ResizeObserver(scrollAndResizeEventHandler);
            observer.observe(customScrollParent);
            return ()=>{
                customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
                observer.unobserve(customScrollParent);
            };
        } else {
            window.addEventListener("scroll", scrollAndResizeEventHandler);
            window.addEventListener("resize", scrollAndResizeEventHandler);
            return ()=>{
                window.removeEventListener("scroll", scrollAndResizeEventHandler);
                window.removeEventListener("resize", scrollAndResizeEventHandler);
            };
        }
    }, [
        scrollAndResizeEventHandler,
        customScrollParent
    ]);
    return callbackRef;
}
const $da8c96b0530df421$export$99e9d54e386aea7b = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0);
const $da8c96b0530df421$export$81e3217b4b7a890f = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0);
function $da8c96b0530df421$var$identity(value) {
    return value;
}
const $da8c96b0530df421$var$listComponentPropsSystem = /* @__PURE__ */ $da8c96b0530df421$var$system(()=>{
    const itemContent = $da8c96b0530df421$var$statefulStream((index)=>`Item ${index}`);
    const context = $da8c96b0530df421$var$statefulStream(null);
    const groupContent = $da8c96b0530df421$var$statefulStream((index)=>`Group ${index}`);
    const components = $da8c96b0530df421$var$statefulStream({});
    const computeItemKey = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$identity);
    const headerFooterTag = $da8c96b0530df421$var$statefulStream("div");
    const scrollerRef = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(components, $da8c96b0530df421$var$map((components2)=>components2[propName]), $da8c96b0530df421$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        groupContent: groupContent,
        components: components,
        computeItemKey: computeItemKey,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        TopItemListComponent: distinctProp("TopItemList"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        GroupComponent: distinctProp("Group", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
    };
});
const $da8c96b0530df421$var$combinedSystem$2 = /* @__PURE__ */ $da8c96b0530df421$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$listSystem, $da8c96b0530df421$var$listComponentPropsSystem));
const $da8c96b0530df421$var$DefaultScrollSeekPlaceholder$1 = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        style: {
            height: height
        }
    });
const $da8c96b0530df421$var$GROUP_STYLE = {
    position: $da8c96b0530df421$var$positionStickyCssValue(),
    zIndex: 1,
    overflowAnchor: "none"
};
const $da8c96b0530df421$var$ITEM_STYLE$1 = {
    overflowAnchor: "none"
};
const $da8c96b0530df421$var$Items$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoItems({ showTopList: showTopList = false }) {
    const listState = $da8c96b0530df421$var$useEmitterValue$2("listState");
    const sizeRanges = $da8c96b0530df421$var$usePublisher$2("sizeRanges");
    const useWindowScroll = $da8c96b0530df421$var$useEmitterValue$2("useWindowScroll");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue$2("customScrollParent");
    const windowScrollContainerStateCallback = $da8c96b0530df421$var$usePublisher$2("windowScrollContainerState");
    const _scrollContainerStateCallback = $da8c96b0530df421$var$usePublisher$2("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $da8c96b0530df421$var$useEmitterValue$2("itemContent");
    const context = $da8c96b0530df421$var$useEmitterValue$2("context");
    const groupContent = $da8c96b0530df421$var$useEmitterValue$2("groupContent");
    const trackItemSizes = $da8c96b0530df421$var$useEmitterValue$2("trackItemSizes");
    const itemSize = $da8c96b0530df421$var$useEmitterValue$2("itemSize");
    const log = $da8c96b0530df421$var$useEmitterValue$2("log");
    const listGap = $da8c96b0530df421$var$usePublisher$2("gap");
    const { callbackRef: callbackRef } = $da8c96b0530df421$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? $da8c96b0530df421$var$noop : scrollContainerStateCallback, log, listGap, customScrollParent);
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    $da8c96b0530df421$var$useEmitter$2("deviation", (value)=>{
        if (deviation !== value) setDeviation(value);
    });
    const EmptyPlaceholder = $da8c96b0530df421$var$useEmitterValue$2("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $da8c96b0530df421$var$useEmitterValue$2("ScrollSeekPlaceholder") || $da8c96b0530df421$var$DefaultScrollSeekPlaceholder$1;
    const ListComponent = $da8c96b0530df421$var$useEmitterValue$2("ListComponent");
    const ItemComponent = $da8c96b0530df421$var$useEmitterValue$2("ItemComponent");
    const GroupComponent = $da8c96b0530df421$var$useEmitterValue$2("GroupComponent");
    const computeItemKey = $da8c96b0530df421$var$useEmitterValue$2("computeItemKey");
    const isSeeking = $da8c96b0530df421$var$useEmitterValue$2("isSeeking");
    const hasGroups2 = $da8c96b0530df421$var$useEmitterValue$2("groupIndices").length > 0;
    const paddingTopAddition = $da8c96b0530df421$var$useEmitterValue$2("paddingTopAddition");
    const scrolledToInitialItem = $da8c96b0530df421$var$useEmitterValue$2("scrolledToInitialItem");
    const containerStyle = showTopList ? {} : {
        boxSizing: "border-box",
        paddingTop: listState.offsetTop + paddingTopAddition,
        paddingBottom: listState.offsetBottom,
        marginTop: deviation,
        ...scrolledToInitialItem ? {} : {
            visibility: "hidden"
        }
    };
    if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(EmptyPlaceholder, $da8c96b0530df421$var$contextPropIfNotDomElement(EmptyPlaceholder, context));
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ListComponent, {
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(ListComponent, context),
        ref: callbackRef,
        style: containerStyle,
        "data-test-id": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list"
    }, (showTopList ? listState.topItems : listState.items).map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
        if (isSeeking) return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ScrollSeekPlaceholder, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item",
            ...item.type === "group" ? {} : {
                groupIndex: item.groupIndex
            }
        });
        if (item.type === "group") return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(GroupComponent, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(GroupComponent, context),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: $da8c96b0530df421$var$GROUP_STYLE
        }, groupContent(item.index, context));
        else return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ItemComponent, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ItemComponent, context),
            ...$da8c96b0530df421$var$itemPropIfNotDomElement(ItemComponent, item.data),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            "data-item-group-index": item.groupIndex,
            style: $da8c96b0530df421$var$ITEM_STYLE$1
        }, hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
    }));
});
const $da8c96b0530df421$var$scrollerStyle = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
};
const $da8c96b0530df421$var$viewportStyle = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0
};
const $da8c96b0530df421$var$topItemListStyle = {
    width: "100%",
    position: $da8c96b0530df421$var$positionStickyCssValue(),
    top: 0,
    zIndex: 1
};
function $da8c96b0530df421$var$contextPropIfNotDomElement(element, context) {
    if (typeof element === "string") return void 0;
    return {
        context: context
    };
}
function $da8c96b0530df421$var$itemPropIfNotDomElement(element, item) {
    return {
        item: typeof element === "string" ? void 0 : item
    };
}
const $da8c96b0530df421$var$Header$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoHeader() {
    const Header2 = $da8c96b0530df421$var$useEmitterValue$2("HeaderComponent");
    const headerHeight = $da8c96b0530df421$var$usePublisher$2("headerHeight");
    const headerFooterTag = $da8c96b0530df421$var$useEmitterValue$2("headerFooterTag");
    const ref = $da8c96b0530df421$var$useSize((el)=>headerHeight($da8c96b0530df421$var$correctItemSize(el, "height")));
    const context = $da8c96b0530df421$var$useEmitterValue$2("context");
    return Header2 ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Header2, $da8c96b0530df421$var$contextPropIfNotDomElement(Header2, context))) : null;
});
const $da8c96b0530df421$var$Footer$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoFooter() {
    const Footer2 = $da8c96b0530df421$var$useEmitterValue$2("FooterComponent");
    const footerHeight = $da8c96b0530df421$var$usePublisher$2("footerHeight");
    const headerFooterTag = $da8c96b0530df421$var$useEmitterValue$2("headerFooterTag");
    const ref = $da8c96b0530df421$var$useSize((el)=>footerHeight($da8c96b0530df421$var$correctItemSize(el, "height")));
    const context = $da8c96b0530df421$var$useEmitterValue$2("context");
    return Footer2 ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Footer2, $da8c96b0530df421$var$contextPropIfNotDomElement(Footer2, context))) : null;
});
function $da8c96b0530df421$var$buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("scrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const scrollerRefCallback = useEmitterValue2("scrollerRef");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $da8c96b0530df421$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback);
        useEmitter2("scrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ScrollerComponent, {
            ref: scrollerRef,
            style: {
                ...$da8c96b0530df421$var$scrollerStyle,
                ...style
            },
            "data-test-id": "virtuoso-scroller",
            "data-virtuoso-scroller": true,
            tabIndex: 0,
            ...props,
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ScrollerComponent, context)
        }, children);
    });
    return Scroller2;
}
function $da8c96b0530df421$var$buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoWindowScroller({ style: style, children: children, ...props }) {
        const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const totalListHeight = useEmitterValue2("totalListHeight");
        const deviation = useEmitterValue2("deviation");
        const customScrollParent = useEmitterValue2("customScrollParent");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $da8c96b0530df421$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, $da8c96b0530df421$var$noop, customScrollParent);
        $da8c96b0530df421$var$useIsomorphicLayoutEffect$1(()=>{
            scrollerRef.current = customScrollParent ? customScrollParent : window;
            return ()=>{
                scrollerRef.current = null;
            };
        }, [
            scrollerRef,
            customScrollParent
        ]);
        useEmitter2("windowScrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ScrollerComponent, {
            style: {
                position: "relative",
                ...style,
                ...totalListHeight !== 0 ? {
                    height: totalListHeight + deviation
                } : {}
            },
            "data-virtuoso-scroller": true,
            ...props,
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ScrollerComponent, context)
        }, children);
    });
    return Scroller2;
}
const $da8c96b0530df421$var$Viewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$99e9d54e386aea7b);
    const viewportHeight = $da8c96b0530df421$var$usePublisher$2("viewportHeight");
    const fixedItemHeight = $da8c96b0530df421$var$usePublisher$2("fixedItemHeight");
    const viewportRef = $da8c96b0530df421$var$useSize($da8c96b0530df421$var$compose(viewportHeight, (el)=>$da8c96b0530df421$var$correctItemSize(el, "height")));
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        style: $da8c96b0530df421$var$viewportStyle,
        ref: viewportRef,
        "data-viewport-type": "element"
    }, children);
};
const $da8c96b0530df421$var$WindowViewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$99e9d54e386aea7b);
    const windowViewportRect = $da8c96b0530df421$var$usePublisher$2("windowViewportRect");
    const fixedItemHeight = $da8c96b0530df421$var$usePublisher$2("fixedItemHeight");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue$2("customScrollParent");
    const viewportRef = $da8c96b0530df421$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: viewportRef,
        style: $da8c96b0530df421$var$viewportStyle,
        "data-viewport-type": "window"
    }, children);
};
const $da8c96b0530df421$var$TopItemListContainer = ({ children: children })=>{
    const TopItemList = $da8c96b0530df421$var$useEmitterValue$2("TopItemListComponent");
    const headerHeight = $da8c96b0530df421$var$useEmitterValue$2("headerHeight");
    const style = {
        ...$da8c96b0530df421$var$topItemListStyle,
        marginTop: `${headerHeight}px`
    };
    const context = $da8c96b0530df421$var$useEmitterValue$2("context");
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TopItemList || "div", {
        style: style,
        context: context
    }, children);
};
const $da8c96b0530df421$var$ListRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoRoot(props) {
    const useWindowScroll = $da8c96b0530df421$var$useEmitterValue$2("useWindowScroll");
    const showTopList = $da8c96b0530df421$var$useEmitterValue$2("topItemsIndexes").length > 0;
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue$2("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowScroller$2 : $da8c96b0530df421$var$Scroller$2;
    const TheViewport = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowViewport$2 : $da8c96b0530df421$var$Viewport$2;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheScroller, {
        ...props
    }, showTopList && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$TopItemListContainer, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Items$1, {
        showTopList: true
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheViewport, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Header$1, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Items$1, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Footer$1, null)));
});
const { Component: $da8c96b0530df421$var$List, usePublisher: $da8c96b0530df421$var$usePublisher$2, useEmitterValue: $da8c96b0530df421$var$useEmitterValue$2, useEmitter: $da8c96b0530df421$var$useEmitter$2 } = /* @__PURE__ */ $da8c96b0530df421$var$systemToComponent($da8c96b0530df421$var$combinedSystem$2, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        itemContent: "itemContent",
        groupContent: "groupContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        groupCounts: "groupCounts",
        topItemCount: "topItemCount",
        firstItemIndex: "firstItemIndex",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        autoscrollToBottom: "autoscrollToBottom",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $da8c96b0530df421$var$ListRoot);
const $da8c96b0530df421$var$Scroller$2 = /* @__PURE__ */ $da8c96b0530df421$var$buildScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher$2,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue$2,
    useEmitter: $da8c96b0530df421$var$useEmitter$2
});
const $da8c96b0530df421$var$WindowScroller$2 = /* @__PURE__ */ $da8c96b0530df421$var$buildWindowScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher$2,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue$2,
    useEmitter: $da8c96b0530df421$var$useEmitter$2
});
const $da8c96b0530df421$export$ea50ab61e1198ee3 = $da8c96b0530df421$var$List;
const $da8c96b0530df421$export$41737384f976dee3 = $da8c96b0530df421$var$List;
const $da8c96b0530df421$var$INITIAL_GRID_STATE = {
    items: [],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const $da8c96b0530df421$var$PROBE_GRID_STATE = {
    items: [
        {
            index: 0
        }
    ],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const { round: $da8c96b0530df421$var$round, ceil: $da8c96b0530df421$var$ceil, floor: $da8c96b0530df421$var$floor, min: $da8c96b0530df421$var$min, max: $da8c96b0530df421$var$max } = Math;
function $da8c96b0530df421$var$buildProbeGridState(items) {
    return {
        ...$da8c96b0530df421$var$PROBE_GRID_STATE,
        items: items
    };
}
function $da8c96b0530df421$var$buildItems(startIndex, endIndex, data) {
    return Array.from({
        length: endIndex - startIndex + 1
    }).map((_, i)=>{
        const dataItem = data === null ? null : data[i + startIndex];
        return {
            index: i + startIndex,
            data: dataItem
        };
    });
}
function $da8c96b0530df421$var$gapComparator(prev, next) {
    return prev && prev.column === next.column && prev.row === next.row;
}
function $da8c96b0530df421$var$dimensionComparator(prev, next) {
    return prev && prev.width === next.width && prev.height === next.height;
}
const $da8c96b0530df421$var$gridSystem = /* @__PURE__ */ $da8c96b0530df421$var$system(([{ overscan: overscan, visibleRange: visibleRange, listBoundary: listBoundary }, { scrollTop: scrollTop, viewportHeight: viewportHeight, scrollBy: scrollBy, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, scrollContainerState: scrollContainerState, footerHeight: footerHeight, headerHeight: headerHeight }, stateFlags, scrollSeek, { propsReady: propsReady, didMount: didMount }, { windowViewportRect: windowViewportRect, useWindowScroll: useWindowScroll, customScrollParent: customScrollParent, windowScrollContainerState: windowScrollContainerState, windowScrollTo: windowScrollTo }, log])=>{
    const totalCount = $da8c96b0530df421$var$statefulStream(0);
    const initialItemCount = $da8c96b0530df421$var$statefulStream(0);
    const gridState = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$INITIAL_GRID_STATE);
    const viewportDimensions = $da8c96b0530df421$var$statefulStream({
        height: 0,
        width: 0
    });
    const itemDimensions = $da8c96b0530df421$var$statefulStream({
        height: 0,
        width: 0
    });
    const scrollToIndex = $da8c96b0530df421$var$stream();
    const scrollHeight = $da8c96b0530df421$var$stream();
    const deviation = $da8c96b0530df421$var$statefulStream(0);
    const data = $da8c96b0530df421$var$statefulStream(null);
    const gap = $da8c96b0530df421$var$statefulStream({
        row: 0,
        column: 0
    });
    const stateChanged = $da8c96b0530df421$var$stream();
    const restoreStateFrom = $da8c96b0530df421$var$stream();
    const stateRestoreInProgress = $da8c96b0530df421$var$statefulStream(false);
    const initialTopMostItemIndex = $da8c96b0530df421$var$statefulStream(0);
    const scrolledToInitialItem = $da8c96b0530df421$var$statefulStream(true);
    const scrollScheduled = $da8c96b0530df421$var$statefulStream(false);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(initialTopMostItemIndex), $da8c96b0530df421$var$filter(([_, location])=>!!location)), ()=>{
        $da8c96b0530df421$var$publish(scrolledToInitialItem, false);
        $da8c96b0530df421$var$publish(initialItemCount, 0);
    });
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), $da8c96b0530df421$var$filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2])=>{
        return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
    })), ([, , , , initialTopMostItemIndex2])=>{
        $da8c96b0530df421$var$publish(scrollScheduled, true);
        $da8c96b0530df421$var$skipFrames(1, ()=>{
            $da8c96b0530df421$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
        $da8c96b0530df421$var$handleNext($da8c96b0530df421$var$pipe(scrollTop), ()=>{
            $da8c96b0530df421$var$publish(listBoundary, [
                0,
                0
            ]);
            $da8c96b0530df421$var$publish(scrolledToInitialItem, true);
        });
    });
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(restoreStateFrom, $da8c96b0530df421$var$filter((value)=>value !== void 0 && value !== null && value.scrollTop > 0), $da8c96b0530df421$var$mapTo(0)), initialItemCount);
    $da8c96b0530df421$var$subscribe($da8c96b0530df421$var$pipe(didMount, $da8c96b0530df421$var$withLatestFrom(restoreStateFrom), $da8c96b0530df421$var$filter(([, snapshot])=>snapshot !== void 0 && snapshot !== null)), ([, snapshot])=>{
        if (!snapshot) return;
        $da8c96b0530df421$var$publish(viewportDimensions, snapshot.viewport), $da8c96b0530df421$var$publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
        $da8c96b0530df421$var$publish(gap, snapshot.gap);
        if (snapshot.scrollTop > 0) {
            $da8c96b0530df421$var$publish(stateRestoreInProgress, true);
            $da8c96b0530df421$var$handleNext($da8c96b0530df421$var$pipe(scrollTop, $da8c96b0530df421$var$skip(1)), (_value)=>{
                $da8c96b0530df421$var$publish(stateRestoreInProgress, false);
            });
            $da8c96b0530df421$var$publish(scrollTo, {
                top: snapshot.scrollTop
            });
        }
    });
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(viewportDimensions, $da8c96b0530df421$var$map(({ height: height })=>height)), viewportHeight);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(viewportDimensions, $da8c96b0530df421$var$dimensionComparator), $da8c96b0530df421$var$duc(itemDimensions, $da8c96b0530df421$var$dimensionComparator), $da8c96b0530df421$var$duc(gap, (prev, next)=>prev && prev.column === next.column && prev.row === next.row), $da8c96b0530df421$var$duc(scrollTop)), $da8c96b0530df421$var$map(([viewport, item, gap2, scrollTop2])=>({
            viewport: viewport,
            item: item,
            gap: gap2,
            scrollTop: scrollTop2
        }))), stateChanged);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest($da8c96b0530df421$var$duc(totalCount), visibleRange, $da8c96b0530df421$var$duc(gap, $da8c96b0530df421$var$gapComparator), $da8c96b0530df421$var$duc(itemDimensions, $da8c96b0530df421$var$dimensionComparator), $da8c96b0530df421$var$duc(viewportDimensions, $da8c96b0530df421$var$dimensionComparator), $da8c96b0530df421$var$duc(data), $da8c96b0530df421$var$duc(initialItemCount), $da8c96b0530df421$var$duc(stateRestoreInProgress), $da8c96b0530df421$var$duc(scrolledToInitialItem), $da8c96b0530df421$var$duc(initialTopMostItemIndex)), $da8c96b0530df421$var$filter(([, , , , , , , stateRestoreInProgress2])=>{
        return !stateRestoreInProgress2;
    }), $da8c96b0530df421$var$map(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2, initialItemCount2, , scrolledToInitialItem2, initialTopMostItemIndex2])=>{
        const { row: rowGap, column: columnGap } = gap2;
        const { height: itemHeight, width: itemWidth } = item;
        const { width: viewportWidth } = viewport;
        if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) return $da8c96b0530df421$var$INITIAL_GRID_STATE;
        if (itemWidth === 0) {
            const startIndex2 = $da8c96b0530df421$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
            const endIndex2 = startIndex2 === 0 ? Math.max(initialItemCount2 - 1, 0) : startIndex2;
            return $da8c96b0530df421$var$buildProbeGridState($da8c96b0530df421$var$buildItems(startIndex2, endIndex2, data2));
        }
        const perRow = $da8c96b0530df421$var$itemsPerRow(viewportWidth, itemWidth, columnGap);
        let startIndex;
        let endIndex;
        if (!scrolledToInitialItem2) {
            startIndex = 0;
            endIndex = -1;
        } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
            startIndex = 0;
            endIndex = initialItemCount2 - 1;
        } else {
            startIndex = perRow * $da8c96b0530df421$var$floor((startOffset + rowGap) / (itemHeight + rowGap));
            endIndex = perRow * $da8c96b0530df421$var$ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
            endIndex = $da8c96b0530df421$var$min(totalCount2 - 1, $da8c96b0530df421$var$max(endIndex, perRow - 1));
            startIndex = $da8c96b0530df421$var$min(endIndex, $da8c96b0530df421$var$max(0, startIndex));
        }
        const items = $da8c96b0530df421$var$buildItems(startIndex, endIndex, data2);
        const { top: top, bottom: bottom } = $da8c96b0530df421$var$gridLayout(viewport, gap2, item, items);
        const rowCount = $da8c96b0530df421$var$ceil(totalCount2 / perRow);
        const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
        const offsetBottom = totalHeight - bottom;
        return {
            items: items,
            offsetTop: top,
            offsetBottom: offsetBottom,
            top: top,
            bottom: bottom,
            itemHeight: itemHeight,
            itemWidth: itemWidth
        };
    })), gridState);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(data, $da8c96b0530df421$var$filter((data2)=>data2 !== null), $da8c96b0530df421$var$map((data2)=>data2.length)), totalCount);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe($da8c96b0530df421$var$combineLatest(viewportDimensions, itemDimensions, gridState, gap), $da8c96b0530df421$var$filter(([viewportDimensions2, itemDimensions2, { items: items }])=>{
        return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
    }), $da8c96b0530df421$var$map(([viewportDimensions2, itemDimensions2, { items: items }, gap2])=>{
        const { top: top, bottom: bottom } = $da8c96b0530df421$var$gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
        return [
            top,
            bottom
        ];
    }), $da8c96b0530df421$var$distinctUntilChanged($da8c96b0530df421$var$tupleComparator)), listBoundary);
    const hasScrolled = $da8c96b0530df421$var$statefulStream(false);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollTop, $da8c96b0530df421$var$withLatestFrom(hasScrolled), $da8c96b0530df421$var$map(([scrollTop2, hasScrolled2])=>{
        return hasScrolled2 || scrollTop2 !== 0;
    })), hasScrolled);
    const endReached = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(gridState), $da8c96b0530df421$var$filter(({ items: items })=>items.length > 0), $da8c96b0530df421$var$withLatestFrom(totalCount, hasScrolled), $da8c96b0530df421$var$filter(([{ items: items }, totalCount2, hasScrolled2])=>hasScrolled2 && items[items.length - 1].index === totalCount2 - 1), $da8c96b0530df421$var$map(([, totalCount2])=>totalCount2 - 1), $da8c96b0530df421$var$distinctUntilChanged()));
    const startReached = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(gridState), $da8c96b0530df421$var$filter(({ items: items })=>{
        return items.length > 0 && items[0].index === 0;
    }), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $da8c96b0530df421$var$mapTo(0), $da8c96b0530df421$var$distinctUntilChanged()));
    const rangeChanged = $da8c96b0530df421$var$streamFromEmitter($da8c96b0530df421$var$pipe($da8c96b0530df421$var$duc(gridState), $da8c96b0530df421$var$withLatestFrom(stateRestoreInProgress), $da8c96b0530df421$var$filter(([{ items: items }, stateRestoreInProgress2])=>items.length > 0 && !stateRestoreInProgress2), $da8c96b0530df421$var$map(([{ items: items }])=>{
        return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
        };
    }), $da8c96b0530df421$var$distinctUntilChanged($da8c96b0530df421$var$rangeComparator), $da8c96b0530df421$var$throttleTime(0)));
    $da8c96b0530df421$var$connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(scrollToIndex, $da8c96b0530df421$var$withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), $da8c96b0530df421$var$map(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2])=>{
        const normalLocation = $da8c96b0530df421$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        let index = normalLocation.index;
        if (index === "LAST") index = totalCount2 - 1;
        index = $da8c96b0530df421$var$max(0, index, $da8c96b0530df421$var$min(totalCount2 - 1, index));
        let top = $da8c96b0530df421$var$itemTop(viewportDimensions2, gap2, itemDimensions2, index);
        if (align === "end") top = $da8c96b0530df421$var$round(top - viewportDimensions2.height + itemDimensions2.height);
        else if (align === "center") top = $da8c96b0530df421$var$round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
        if (offset) top += offset;
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    const totalListHeight = $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(gridState, $da8c96b0530df421$var$map((gridState2)=>{
        return gridState2.offsetBottom + gridState2.bottom;
    })), 0);
    $da8c96b0530df421$var$connect($da8c96b0530df421$var$pipe(windowViewportRect, $da8c96b0530df421$var$map((viewportInfo)=>({
            width: viewportInfo.visibleWidth,
            height: viewportInfo.visibleHeight
        }))), viewportDimensions);
    return {
        data: // input
        data,
        totalCount: totalCount,
        viewportDimensions: viewportDimensions,
        itemDimensions: itemDimensions,
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        overscan: overscan,
        scrollBy: scrollBy,
        scrollTo: scrollTo,
        scrollToIndex: scrollToIndex,
        smoothScrollTargetReached: smoothScrollTargetReached,
        windowViewportRect: windowViewportRect,
        windowScrollTo: windowScrollTo,
        useWindowScroll: useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: windowScrollContainerState,
        deviation: deviation,
        scrollContainerState: scrollContainerState,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        initialItemCount: initialItemCount,
        gap: gap,
        restoreStateFrom: restoreStateFrom,
        ...scrollSeek,
        initialTopMostItemIndex: initialTopMostItemIndex,
        gridState: // output
        gridState,
        totalListHeight: totalListHeight,
        ...stateFlags,
        startReached: startReached,
        endReached: endReached,
        rangeChanged: rangeChanged,
        stateChanged: stateChanged,
        propsReady: propsReady,
        stateRestoreInProgress: stateRestoreInProgress,
        ...log
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$sizeRangeSystem, $da8c96b0530df421$var$domIOSystem, $da8c96b0530df421$var$stateFlagsSystem, $da8c96b0530df421$var$scrollSeekSystem, $da8c96b0530df421$var$propsReadySystem, $da8c96b0530df421$var$windowScrollerSystem, $da8c96b0530df421$var$loggerSystem));
function $da8c96b0530df421$var$gridLayout(viewport, gap, item, items) {
    const { height: itemHeight } = item;
    if (itemHeight === void 0 || items.length === 0) return {
        top: 0,
        bottom: 0
    };
    const top = $da8c96b0530df421$var$itemTop(viewport, gap, item, items[0].index);
    const bottom = $da8c96b0530df421$var$itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
    return {
        top: top,
        bottom: bottom
    };
}
function $da8c96b0530df421$var$itemTop(viewport, gap, item, index) {
    const perRow = $da8c96b0530df421$var$itemsPerRow(viewport.width, item.width, gap.column);
    const rowCount = $da8c96b0530df421$var$floor(index / perRow);
    const top = rowCount * item.height + $da8c96b0530df421$var$max(0, rowCount - 1) * gap.row;
    return top > 0 ? top + gap.row : top;
}
function $da8c96b0530df421$var$itemsPerRow(viewportWidth, itemWidth, gap) {
    return $da8c96b0530df421$var$max(1, $da8c96b0530df421$var$floor((viewportWidth + gap) / ($da8c96b0530df421$var$floor(itemWidth) + gap)));
}
const $da8c96b0530df421$var$gridComponentPropsSystem = /* @__PURE__ */ $da8c96b0530df421$var$system(()=>{
    const itemContent = $da8c96b0530df421$var$statefulStream((index)=>`Item ${index}`);
    const components = $da8c96b0530df421$var$statefulStream({});
    const context = $da8c96b0530df421$var$statefulStream(null);
    const itemClassName = $da8c96b0530df421$var$statefulStream("virtuoso-grid-item");
    const listClassName = $da8c96b0530df421$var$statefulStream("virtuoso-grid-list");
    const computeItemKey = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$identity);
    const headerFooterTag = $da8c96b0530df421$var$statefulStream("div");
    const scrollerRef = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(components, $da8c96b0530df421$var$map((components2)=>components2[propName]), $da8c96b0530df421$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        components: components,
        computeItemKey: computeItemKey,
        itemClassName: itemClassName,
        listClassName: listClassName,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
    };
});
const $da8c96b0530df421$var$combinedSystem$1 = /* @__PURE__ */ $da8c96b0530df421$var$system(([gridSystem2, gridComponentPropsSystem2])=>{
    return {
        ...gridSystem2,
        ...gridComponentPropsSystem2
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$gridSystem, $da8c96b0530df421$var$gridComponentPropsSystem));
const $da8c96b0530df421$var$GridItems = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function GridItems2() {
    const gridState = $da8c96b0530df421$var$useEmitterValue$1("gridState");
    const listClassName = $da8c96b0530df421$var$useEmitterValue$1("listClassName");
    const itemClassName = $da8c96b0530df421$var$useEmitterValue$1("itemClassName");
    const itemContent = $da8c96b0530df421$var$useEmitterValue$1("itemContent");
    const computeItemKey = $da8c96b0530df421$var$useEmitterValue$1("computeItemKey");
    const isSeeking = $da8c96b0530df421$var$useEmitterValue$1("isSeeking");
    const scrollHeightCallback = $da8c96b0530df421$var$usePublisher$1("scrollHeight");
    const ItemComponent = $da8c96b0530df421$var$useEmitterValue$1("ItemComponent");
    const ListComponent = $da8c96b0530df421$var$useEmitterValue$1("ListComponent");
    const ScrollSeekPlaceholder = $da8c96b0530df421$var$useEmitterValue$1("ScrollSeekPlaceholder");
    const context = $da8c96b0530df421$var$useEmitterValue$1("context");
    const itemDimensions = $da8c96b0530df421$var$usePublisher$1("itemDimensions");
    const gridGap = $da8c96b0530df421$var$usePublisher$1("gap");
    const log = $da8c96b0530df421$var$useEmitterValue$1("log");
    const stateRestoreInProgress = $da8c96b0530df421$var$useEmitterValue$1("stateRestoreInProgress");
    const listRef = $da8c96b0530df421$var$useSize((el)=>{
        const scrollHeight = el.parentElement.parentElement.scrollHeight;
        scrollHeightCallback(scrollHeight);
        const firstItem = el.firstChild;
        if (firstItem) {
            const { width: width, height: height } = firstItem.getBoundingClientRect();
            itemDimensions({
                width: width,
                height: height
            });
        }
        gridGap({
            row: $da8c96b0530df421$var$resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
            column: $da8c96b0530df421$var$resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
        });
    });
    if (stateRestoreInProgress) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ListComponent, {
        ref: listRef,
        className: listClassName,
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(ListComponent, context),
        style: {
            paddingTop: gridState.offsetTop,
            paddingBottom: gridState.offsetBottom
        },
        "data-test-id": "virtuoso-item-list"
    }, gridState.items.map((item)=>{
        const key = computeItemKey(item.index, item.data, context);
        return isSeeking ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ScrollSeekPlaceholder, {
            key: key,
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            index: item.index,
            height: gridState.itemHeight,
            width: gridState.itemWidth
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ItemComponent, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ItemComponent, context),
            className: itemClassName,
            "data-index": item.index,
            key: key
        }, itemContent(item.index, item.data, context));
    }));
});
const $da8c96b0530df421$var$Header = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoHeader2() {
    const Header2 = $da8c96b0530df421$var$useEmitterValue$1("HeaderComponent");
    const headerHeight = $da8c96b0530df421$var$usePublisher$1("headerHeight");
    const headerFooterTag = $da8c96b0530df421$var$useEmitterValue$1("headerFooterTag");
    const ref = $da8c96b0530df421$var$useSize((el)=>headerHeight($da8c96b0530df421$var$correctItemSize(el, "height")));
    const context = $da8c96b0530df421$var$useEmitterValue$1("context");
    return Header2 ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Header2, $da8c96b0530df421$var$contextPropIfNotDomElement(Header2, context))) : null;
});
const $da8c96b0530df421$var$Footer = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoGridFooter() {
    const Footer2 = $da8c96b0530df421$var$useEmitterValue$1("FooterComponent");
    const footerHeight = $da8c96b0530df421$var$usePublisher$1("footerHeight");
    const headerFooterTag = $da8c96b0530df421$var$useEmitterValue$1("headerFooterTag");
    const ref = $da8c96b0530df421$var$useSize((el)=>footerHeight($da8c96b0530df421$var$correctItemSize(el, "height")));
    const context = $da8c96b0530df421$var$useEmitterValue$1("context");
    return Footer2 ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(headerFooterTag, {
        ref: ref
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Footer2, $da8c96b0530df421$var$contextPropIfNotDomElement(Footer2, context))) : null;
});
const $da8c96b0530df421$var$Viewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$81e3217b4b7a890f);
    const itemDimensions = $da8c96b0530df421$var$usePublisher$1("itemDimensions");
    const viewportDimensions = $da8c96b0530df421$var$usePublisher$1("viewportDimensions");
    const viewportRef = $da8c96b0530df421$var$useSize((el)=>{
        viewportDimensions(el.getBoundingClientRect());
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            viewportDimensions({
                height: ctx.viewportHeight,
                width: ctx.viewportWidth
            });
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
        }
    }, [
        ctx,
        viewportDimensions,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        style: $da8c96b0530df421$var$viewportStyle,
        ref: viewportRef
    }, children);
};
const $da8c96b0530df421$var$WindowViewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$81e3217b4b7a890f);
    const windowViewportRect = $da8c96b0530df421$var$usePublisher$1("windowViewportRect");
    const itemDimensions = $da8c96b0530df421$var$usePublisher$1("itemDimensions");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue$1("customScrollParent");
    const viewportRef = $da8c96b0530df421$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: ctx.viewportWidth
            });
        }
    }, [
        ctx,
        windowViewportRect,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: viewportRef,
        style: $da8c96b0530df421$var$viewportStyle
    }, children);
};
const $da8c96b0530df421$var$GridRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function GridRoot2({ ...props }) {
    const useWindowScroll = $da8c96b0530df421$var$useEmitterValue$1("useWindowScroll");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue$1("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowScroller$1 : $da8c96b0530df421$var$Scroller$1;
    const TheViewport = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowViewport$1 : $da8c96b0530df421$var$Viewport$1;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheScroller, {
        ...props
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheViewport, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Header, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$GridItems, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Footer, null)));
});
const { Component: $da8c96b0530df421$var$Grid, usePublisher: $da8c96b0530df421$var$usePublisher$1, useEmitterValue: $da8c96b0530df421$var$useEmitterValue$1, useEmitter: $da8c96b0530df421$var$useEmitter$1 } = /* @__PURE__ */ $da8c96b0530df421$var$systemToComponent($da8c96b0530df421$var$combinedSystem$1, {
    optional: {
        context: "context",
        totalCount: "totalCount",
        overscan: "overscan",
        itemContent: "itemContent",
        components: "components",
        computeItemKey: "computeItemKey",
        data: "data",
        initialItemCount: "initialItemCount",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        listClassName: "listClassName",
        itemClassName: "itemClassName",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        restoreStateFrom: "restoreStateFrom",
        initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        scrollToIndex: "scrollToIndex"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        stateChanged: "stateChanged"
    }
}, $da8c96b0530df421$var$GridRoot);
const $da8c96b0530df421$var$Scroller$1 = /* @__PURE__ */ $da8c96b0530df421$var$buildScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher$1,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue$1,
    useEmitter: $da8c96b0530df421$var$useEmitter$1
});
const $da8c96b0530df421$var$WindowScroller$1 = /* @__PURE__ */ $da8c96b0530df421$var$buildWindowScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher$1,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue$1,
    useEmitter: $da8c96b0530df421$var$useEmitter$1
});
function $da8c96b0530df421$var$resolveGapValue(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $da8c96b0530df421$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
const $da8c96b0530df421$export$eef3fd285144b65e = $da8c96b0530df421$var$Grid;
const $da8c96b0530df421$var$tableComponentPropsSystem = /* @__PURE__ */ $da8c96b0530df421$var$system(()=>{
    const itemContent = $da8c96b0530df421$var$statefulStream((index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("td", null, "Item $", index));
    const context = $da8c96b0530df421$var$statefulStream(null);
    const fixedHeaderContent = $da8c96b0530df421$var$statefulStream(null);
    const fixedFooterContent = $da8c96b0530df421$var$statefulStream(null);
    const components = $da8c96b0530df421$var$statefulStream({});
    const computeItemKey = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$identity);
    const scrollerRef = $da8c96b0530df421$var$statefulStream($da8c96b0530df421$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $da8c96b0530df421$var$statefulStreamFromEmitter($da8c96b0530df421$var$pipe(components, $da8c96b0530df421$var$map((components2)=>components2[propName]), $da8c96b0530df421$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        fixedHeaderContent: fixedHeaderContent,
        fixedFooterContent: fixedFooterContent,
        components: components,
        computeItemKey: computeItemKey,
        scrollerRef: scrollerRef,
        TableComponent: distinctProp("Table", "table"),
        TableHeadComponent: distinctProp("TableHead", "thead"),
        TableFooterComponent: distinctProp("TableFoot", "tfoot"),
        TableBodyComponent: distinctProp("TableBody", "tbody"),
        TableRowComponent: distinctProp("TableRow", "tr"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
        FillerRow: distinctProp("FillerRow")
    };
});
const $da8c96b0530df421$var$combinedSystem = /* @__PURE__ */ $da8c96b0530df421$var$system(([listSystem2, propsSystem])=>{
    return {
        ...listSystem2,
        ...propsSystem
    };
}, $da8c96b0530df421$var$tup($da8c96b0530df421$var$listSystem, $da8c96b0530df421$var$tableComponentPropsSystem));
const $da8c96b0530df421$var$DefaultScrollSeekPlaceholder = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("td", {
        style: {
            height: height
        }
    }));
const $da8c96b0530df421$var$DefaultFillerRow = ({ height: height })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("td", {
        style: {
            height: height,
            padding: 0,
            border: 0
        }
    }));
const $da8c96b0530df421$var$ITEM_STYLE = {
    overflowAnchor: "none"
};
const $da8c96b0530df421$var$Items = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function VirtuosoItems2() {
    const listState = $da8c96b0530df421$var$useEmitterValue("listState");
    const sizeRanges = $da8c96b0530df421$var$usePublisher("sizeRanges");
    const useWindowScroll = $da8c96b0530df421$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue("customScrollParent");
    const windowScrollContainerStateCallback = $da8c96b0530df421$var$usePublisher("windowScrollContainerState");
    const _scrollContainerStateCallback = $da8c96b0530df421$var$usePublisher("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $da8c96b0530df421$var$useEmitterValue("itemContent");
    const trackItemSizes = $da8c96b0530df421$var$useEmitterValue("trackItemSizes");
    const itemSize = $da8c96b0530df421$var$useEmitterValue("itemSize");
    const log = $da8c96b0530df421$var$useEmitterValue("log");
    const { callbackRef: callbackRef, ref: ref } = $da8c96b0530df421$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, scrollContainerStateCallback, log, void 0, customScrollParent);
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    $da8c96b0530df421$var$useEmitter("deviation", (value)=>{
        if (deviation !== value) {
            ref.current.style.marginTop = `${value}px`;
            setDeviation(value);
        }
    });
    const EmptyPlaceholder = $da8c96b0530df421$var$useEmitterValue("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $da8c96b0530df421$var$useEmitterValue("ScrollSeekPlaceholder") || $da8c96b0530df421$var$DefaultScrollSeekPlaceholder;
    const FillerRow = $da8c96b0530df421$var$useEmitterValue("FillerRow") || $da8c96b0530df421$var$DefaultFillerRow;
    const TableBodyComponent = $da8c96b0530df421$var$useEmitterValue("TableBodyComponent");
    const TableRowComponent = $da8c96b0530df421$var$useEmitterValue("TableRowComponent");
    const computeItemKey = $da8c96b0530df421$var$useEmitterValue("computeItemKey");
    const isSeeking = $da8c96b0530df421$var$useEmitterValue("isSeeking");
    const paddingTopAddition = $da8c96b0530df421$var$useEmitterValue("paddingTopAddition");
    const firstItemIndex = $da8c96b0530df421$var$useEmitterValue("firstItemIndex");
    const statefulTotalCount = $da8c96b0530df421$var$useEmitterValue("statefulTotalCount");
    const context = $da8c96b0530df421$var$useEmitterValue("context");
    if (statefulTotalCount === 0 && EmptyPlaceholder) return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(EmptyPlaceholder, $da8c96b0530df421$var$contextPropIfNotDomElement(EmptyPlaceholder, context));
    const paddingTop = listState.offsetTop + paddingTopAddition + deviation;
    const paddingBottom = listState.offsetBottom;
    const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(FillerRow, {
        height: paddingTop,
        key: "padding-top",
        context: context
    }) : null;
    const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(FillerRow, {
        height: paddingBottom,
        key: "padding-bottom",
        context: context
    }) : null;
    const items = listState.items.map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + firstItemIndex, item.data, context);
        if (isSeeking) return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ScrollSeekPlaceholder, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context),
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TableRowComponent, {
            ...$da8c96b0530df421$var$contextPropIfNotDomElement(TableRowComponent, context),
            ...$da8c96b0530df421$var$itemPropIfNotDomElement(TableRowComponent, item.data),
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: $da8c96b0530df421$var$ITEM_STYLE
        }, itemContent(item.index, item.data, context));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TableBodyComponent, {
        ref: callbackRef,
        "data-test-id": "virtuoso-item-list",
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(TableBodyComponent, context)
    }, [
        paddingTopEl,
        ...items,
        paddingBottomEl
    ]);
});
const $da8c96b0530df421$var$Viewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$99e9d54e386aea7b);
    const viewportHeight = $da8c96b0530df421$var$usePublisher("viewportHeight");
    const fixedItemHeight = $da8c96b0530df421$var$usePublisher("fixedItemHeight");
    const viewportRef = $da8c96b0530df421$var$useSize($da8c96b0530df421$var$compose(viewportHeight, (el)=>$da8c96b0530df421$var$correctItemSize(el, "height")));
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        style: $da8c96b0530df421$var$viewportStyle,
        ref: viewportRef,
        "data-viewport-type": "element"
    }, children);
};
const $da8c96b0530df421$var$WindowViewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($da8c96b0530df421$export$99e9d54e386aea7b);
    const windowViewportRect = $da8c96b0530df421$var$usePublisher("windowViewportRect");
    const fixedItemHeight = $da8c96b0530df421$var$usePublisher("fixedItemHeight");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue("customScrollParent");
    const viewportRef = $da8c96b0530df421$var$useWindowViewportRectRef(windowViewportRect, customScrollParent);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: viewportRef,
        style: $da8c96b0530df421$var$viewportStyle,
        "data-viewport-type": "window"
    }, children);
};
const $da8c96b0530df421$var$TableRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(function TableVirtuosoRoot(props) {
    const useWindowScroll = $da8c96b0530df421$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $da8c96b0530df421$var$useEmitterValue("customScrollParent");
    const fixedHeaderHeight = $da8c96b0530df421$var$usePublisher("fixedHeaderHeight");
    const fixedFooterHeight = $da8c96b0530df421$var$usePublisher("fixedFooterHeight");
    const fixedHeaderContent = $da8c96b0530df421$var$useEmitterValue("fixedHeaderContent");
    const fixedFooterContent = $da8c96b0530df421$var$useEmitterValue("fixedFooterContent");
    const context = $da8c96b0530df421$var$useEmitterValue("context");
    const theadRef = $da8c96b0530df421$var$useSize($da8c96b0530df421$var$compose(fixedHeaderHeight, (el)=>$da8c96b0530df421$var$correctItemSize(el, "height")));
    const tfootRef = $da8c96b0530df421$var$useSize($da8c96b0530df421$var$compose(fixedFooterHeight, (el)=>$da8c96b0530df421$var$correctItemSize(el, "height")));
    const TheScroller = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowScroller : $da8c96b0530df421$var$Scroller;
    const TheViewport = customScrollParent || useWindowScroll ? $da8c96b0530df421$var$WindowViewport : $da8c96b0530df421$var$Viewport;
    const TheTable = $da8c96b0530df421$var$useEmitterValue("TableComponent");
    const TheTHead = $da8c96b0530df421$var$useEmitterValue("TableHeadComponent");
    const TheTFoot = $da8c96b0530df421$var$useEmitterValue("TableFooterComponent");
    const theHead = fixedHeaderContent ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheTHead, {
        key: "TableHead",
        style: {
            zIndex: 2,
            position: "sticky",
            top: 0
        },
        ref: theadRef,
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(TheTHead, context)
    }, fixedHeaderContent()) : null;
    const theFoot = fixedFooterContent ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheTFoot, {
        key: "TableFoot",
        style: {
            zIndex: 1,
            position: "sticky",
            bottom: 0
        },
        ref: tfootRef,
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(TheTFoot, context)
    }, fixedFooterContent()) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheScroller, {
        ...props
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheViewport, null, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(TheTable, {
        style: {
            borderSpacing: 0,
            overflowAnchor: "none"
        },
        ...$da8c96b0530df421$var$contextPropIfNotDomElement(TheTable, context)
    }, [
        theHead,
        /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($da8c96b0530df421$var$Items, {
            key: "TableBody"
        }),
        theFoot
    ])));
});
const { Component: $da8c96b0530df421$var$Table, usePublisher: $da8c96b0530df421$var$usePublisher, useEmitterValue: $da8c96b0530df421$var$useEmitterValue, useEmitter: $da8c96b0530df421$var$useEmitter } = /* @__PURE__ */ $da8c96b0530df421$var$systemToComponent($da8c96b0530df421$var$combinedSystem, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        fixedHeaderContent: "fixedHeaderContent",
        fixedFooterContent: "fixedFooterContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $da8c96b0530df421$var$TableRoot);
const $da8c96b0530df421$var$Scroller = /* @__PURE__ */ $da8c96b0530df421$var$buildScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue,
    useEmitter: $da8c96b0530df421$var$useEmitter
});
const $da8c96b0530df421$var$WindowScroller = /* @__PURE__ */ $da8c96b0530df421$var$buildWindowScroller({
    usePublisher: $da8c96b0530df421$var$usePublisher,
    useEmitterValue: $da8c96b0530df421$var$useEmitterValue,
    useEmitter: $da8c96b0530df421$var$useEmitter
});
const $da8c96b0530df421$export$3631598018434e6e = $da8c96b0530df421$var$Table;







parcelRequire("exYeM");


parcelRequire("exYeM");


const $e359d60337112ab3$export$335b4682f37c7f57 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("li", {
    width: "100%",
    overflow: "hidden",
    borderRadius: "$xs",
    display: "flex",
    alignItems: "center",
    padding: "$10 $5",
    border: 0,
    backgroundColor: "transparent",
    ".item-start-container": {
        paddingRight: "$10",
        flexShrink: 0,
        "& svg": {
            display: "block"
        }
    },
    ".item-text-container": {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: "auto",
        textAlign: "left",
        "._description": {
            $$color: "$colors$neutral600",
            [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$neutral700"
            },
            color: "$$color"
        },
        ".item-text-title": {
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            color: "$foreground"
        }
    },
    ".item-end-container": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: "$10",
        overflow: "hidden",
        flexShrink: 0
    },
    variants: {
        hasDivider: {
            true: {
                borderBottom: "1px solid",
                borderColor: "$neutral300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    borderColor: "$neutral400"
                },
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        }
    }
});


function $41f02fa281174231$export$a7b06bfba60a8a78(props) {
    const { start: start, title: title, description: description, end: end, onClick: onClick, hasDivider: hasDivider, ...restProps } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $e359d60337112ab3$export$335b4682f37c7f57), {
        hasDivider: hasDivider,
        onClick: onClick,
        ...restProps,
        children: [
            start && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "item-start-container",
                children: start
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "item-text-container",
                children: [
                    title && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "item-text-title",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        variant: "body",
                        className: "_description",
                        size: "small",
                        children: description
                    })
                ]
            }),
            end && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "item-end-container",
                children: end
            })
        ]
    });
}


const $5ab2a84ac234fc75$export$b4e74466fe415444 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $41f02fa281174231$export$a7b06bfba60a8a78), {
    transition: "all 0.35s",
    "&:hover": {
        borderRadius: "$xs",
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color",
        cursor: "pointer"
    },
    "&:active": {
        transform: "scale(0.99)"
    },
    "&:focus-visible": {
        borderRadius: "$xs",
        outline: 0,
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color"
    },
    variants: {
        selected: {
            true: {
                outline: "1px solid $secondary500"
            },
            false: {
                outline: 0
            }
        }
    }
});


function $59d17099a29b7c86$export$b3f67a2d87d5d23e(props) {
    const { onClick: onClick, id: id, selected: selected, ...restProps } = props;
    const onClickWithKey = ()=>{
        if (onClick) onClick(id);
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5ab2a84ac234fc75$export$b4e74466fe415444), {
        onClick: onClickWithKey,
        id: id,
        "aria-label": "button",
        selected: selected,
        onKeyUp: (e)=>{
            e.key === "Enter" && onClickWithKey();
        },
        tabIndex: 0,
        ...restProps
    });
}






var $exYeM = parcelRequire("exYeM");




const $4cadd89d905e9fb9$export$b13c898b9fb465a3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    padding: 0,
    margin: 0,
    listStyle: "none"
});


function $3eba68bfb6488b0a$export$54c2e3dc7acea9f5(props) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4cadd89d905e9fb9$export$b13c898b9fb465a3), {
        as: props.as,
        children: props.items.map((item)=>{
            const { id: id, type: type, ...itemProps } = item;
            const container = type || props.type;
            if (!!container) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(container, {
                ...itemProps,
                key: id,
                id: id
            });
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $41f02fa281174231$export$a7b06bfba60a8a78), {
                id: id,
                ...itemProps
            }, id);
        })
    });
}






parcelRequire("exYeM");




const $9dd4d31515198e7b$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    "& .not-found-description": {
        color: "$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$neutral900"
        }
    }
});


function $11870f864492f7ce$export$271f9f08425019c7(props) {
    const { icon: icon, titleColor: titleColor, hasIcon: hasIcon = true } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $9dd4d31515198e7b$export$42a852a2b6b56249), {
        children: [
            hasIcon && (icon || /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $daa353aade8d8ccc$export$2e2bcd8739ae039), {
                color: "secondary",
                size: 26
            })),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "medium",
                color: titleColor,
                children: props.title
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 10
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                className: "not-found-description",
                variant: "body",
                size: "medium",
                children: props.description
            })
        ]
    });
}






parcelRequire("exYeM");







const $95a07cff78e17d81$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    variants: {
        direction: {
            vertical: {
                flexDirection: "column",
                alignItems: "start"
            },
            horizontal: {
                flexDirection: "row",
                width: "100%",
                alignItems: "end"
            }
        },
        centerAlign: {
            true: {
                alignItems: "center",
                justifyContent: "center"
            }
        }
    }
});
const $95a07cff78e17d81$export$2b7c32f103496492 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $95a07cff78e17d81$export$769c5f3d6f42e497 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$5"
});
const $95a07cff78e17d81$export$65d6c44ef9d63a3f = {
    width: "fit-content"
};


function $66a5c1820d80e5ba$export$b642c5d9b327de62(props) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $95a07cff78e17d81$export$42a852a2b6b56249), {
        direction: props.direction,
        centerAlign: props.centerAlign,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $95a07cff78e17d81$export$2b7c32f103496492)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                        chainImage: props.chain.image,
                        tokenImage: props.token.image,
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        children: [
                            props.label && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "xsmall",
                                variant: "body",
                                color: "$neutral700",
                                children: props.label
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                    styles: {
                                        root: (0, $95a07cff78e17d81$export$65d6c44ef9d63a3f)
                                    },
                                    content: props.price.realValue,
                                    open: !props.price.realValue ? false : undefined,
                                    container: props.tooltipContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "title",
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: props.price.value
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                            direction: "horizontal",
                                            size: 8
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "title",
                                            style: {
                                                fontWeight: 400
                                            },
                                            children: props.token.displayName
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            props.price.usdValue && props.price.usdValue !== "0" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $95a07cff78e17d81$export$769c5f3d6f42e497)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                        content: props.price.realUsdValue,
                        container: props.tooltipContainer,
                        children: props.type === "input" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a1ea7d3509815a6c$export$f9eb9b061a8738e), {
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                size: "small",
                                variant: "body",
                                children: `~$${props.price.usdValue}`
                            })
                        })
                    }),
                    props.type === "output" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8c357132bc764382$export$7933e639b40d0e01), {
                        size: "small",
                        tooltipProps: {
                            container: props.tooltipContainer,
                            side: "top"
                        },
                        outputUsdValue: props.price.usdValue,
                        percentageChange: props.percentageChange,
                        warningLevel: props.warningLevel,
                        realOutputUsdValue: props.price.realUsdValue
                    })
                ]
            })
        ]
    });
}







var $exYeM = parcelRequire("exYeM");








const $251a288f5453b532$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    position: "relative",
    padding: "0 0.5rem",
    boxSizing: "border-box",
    border: "1px solid transparent",
    variants: {
        type: {
            "quote-details": {
                border: "none"
            },
            "swap-progress": {
                backgroundColor: "$neutral100",
                $$color: "$colors$neutral100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral300"
                },
                borderRadius: "$xm",
                padding: "$10 $15",
                marginBottom: "15px"
            }
        },
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $251a288f5453b532$export$ab38450d76302a54 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "100%",
    width: "24px",
    height: "24px",
    overflow: "hidden",
    border: "1.5px solid transparent",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $251a288f5453b532$export$7a76bf180c86084f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    variants: {
        pb: {
            true: {
                paddingBottom: "35px"
            }
        }
    }
});
const $251a288f5453b532$export$f02c3a67649c805e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed $foreground",
    minHeight: "64px",
    margin: "0 11.5px",
    alignSelf: "stretch",
    variants: {
        invisible: {
            true: {
                visibility: "hidden",
                minHeight: "unset"
            }
        }
    }
});
const $251a288f5453b532$export$d27001317eb485a2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px solid transparent",
    margin: "0 $12",
    display: "block",
    height: "8px",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $251a288f5453b532$export$1beef6af864ce77e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed transparent",
    margin: "0 $10",
    alignSelf: "stretch",
    display: "block",
    height: "15px",
    position: "absolute",
    top: "-16px",
    left: "16px",
    variants: {
        state: {
            default: {
                borderColor: "transparent"
            },
            "in-progress": {
                borderColor: "$info500"
            },
            completed: {
                borderColor: "$success500"
            },
            warning: {
                borderColor: "$warning500"
            },
            error: {
                borderColor: "$error500"
            }
        }
    }
});
const $251a288f5453b532$export$39222f6264c0699 = (0, $5f9225ad5bc3d601$export$dbf350e5966cf602)({
    width: "100%",
    overflow: "hidden"
});
const $251a288f5453b532$export$2ddbc5c5557e05cf = (0, $5f9225ad5bc3d601$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
});
const $251a288f5453b532$export$b05485dbd58a70b1 = (0, $5f9225ad5bc3d601$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center"
});
const $251a288f5453b532$export$9414bbab41d375fd = (0, $5f9225ad5bc3d601$export$dbf350e5966cf602)({
    display: "flex",
    flex: "1",
    width: "100%",
    alignItems: "start",
    variants: {
        tx: {
            true: {
                paddingLeft: "36px"
            }
        }
    }
});
const $251a288f5453b532$export$d4ceff6660e0c910 = (0, $5f9225ad5bc3d601$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$5",
    paddingBottom: "$10",
    alignItems: "center"
});


const $6c6be03ec54b75f1$var$StepDetailsComponent = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, parentRef)=>{
    const { step: step, hasSeparator: hasSeparator, type: type, state: state, isFocused: isFocused, tabIndex: tabIndex, tooltipContainer: tooltipContainer } = props;
    const { from: from, to: to, swapper: swapper } = step;
    const containerRef = (0, $exYeM.useRef)(null);
    const isCompleted = state === "completed" || state === "error";
    const swappers = step.internalSwaps?.length ? step.internalSwaps : [
        {
            from: from,
            to: to,
            swapper: swapper
        }
    ];
    (0, $exYeM.useEffect)(()=>{
        const parentElement = parentRef?.current;
        const childElement = containerRef.current;
        if (isFocused && childElement && parentElement) parentElement.scrollTop = childElement.offsetTop - parentElement.offsetTop;
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $251a288f5453b532$export$42a852a2b6b56249), {
        type: type,
        state: state,
        ref: containerRef,
        tabIndex: tabIndex,
        children: [
            type === "quote-details" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $251a288f5453b532$export$b05485dbd58a70b1)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$ab38450d76302a54), {
                        state: state,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                            size: 22,
                            src: step.swapper.image
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "medium",
                        variant: "label",
                        children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                            id: "Swap on {fromChain} via {swapper}",
                            values: {
                                fromChain: step.from.chain.displayName,
                                swapper: step.swapper.displayName
                            }
                        })
                    })
                ]
            }),
            type === "swap-progress" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $251a288f5453b532$export$2ddbc5c5557e05cf)(),
                children: [
                    hasSeparator && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$1beef6af864ce77e), {
                        state: state
                    }),
                    swappers.map((swapperItem, index)=>{
                        const key = `${swapperItem.swapper.displayName}-${index}`;
                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $exYeM.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    id: swapperItem.swapper.displayName,
                                    className: (0, $251a288f5453b532$export$b05485dbd58a70b1)(),
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$ab38450d76302a54), {
                                            state: state,
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                                                size: 22,
                                                src: swapperItem.swapper.image
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                            direction: "horizontal",
                                            size: 8
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                            size: "medium",
                                            variant: "label",
                                            children: swapperItem?.swapper.type === "DEX" ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                                                id: "Swap on {fromChain} via {swapper}",
                                                values: {
                                                    fromChain: swapperItem.from.chain.displayName,
                                                    swapper: swapperItem.swapper.displayName
                                                }
                                            }) : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                                                id: "Bridge to {toChain} via {swapper}",
                                                values: {
                                                    toChain: swapperItem.to.chain.displayName,
                                                    swapper: swapperItem.swapper.displayName
                                                }
                                            })
                                        })
                                    ]
                                }),
                                index !== swappers.length - 1 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$d27001317eb485a2), {
                                    state: state
                                })
                            ]
                        }, key);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $251a288f5453b532$export$9414bbab41d375fd)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$f02c3a67649c805e), {
                        invisible: !hasSeparator || type === "swap-progress"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: (0, $251a288f5453b532$export$39222f6264c0699)(),
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: (0, $251a288f5453b532$export$d4ceff6660e0c910)(),
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                                        chainImage: step.from.chain.image,
                                        tokenImage: step.from.token.image,
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                        content: step.from.price.realValue,
                                        container: tooltipContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                direction: "horizontal",
                                                size: 4
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                size: "small",
                                                color: "$neutral700",
                                                variant: "body",
                                                children: `${step.from.price.value} ${step.from.token.displayName}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $68b8157e90e31e9e$export$2e2bcd8739ae039), {
                                        color: "gray"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                        size: 4,
                                        direction: "horizontal"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                                        chainImage: step.to.chain.image,
                                        tokenImage: step.to.token.image,
                                        size: "small"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                        content: step.to.price.realValue,
                                        container: tooltipContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                                direction: "horizontal",
                                                size: 4
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                size: "small",
                                                color: "$neutral700",
                                                variant: "body",
                                                children: `${isCompleted ? "" : "~"}${step.to.price.value} ${step.to.token.displayName}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $251a288f5453b532$export$7a76bf180c86084f), {
                                pb: hasSeparator && type === "quote-details",
                                children: step.alerts
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$6c6be03ec54b75f1$var$StepDetailsComponent.displayName = "StepDetailsComponent";
const $6c6be03ec54b75f1$export$bb03d422d1792782 = /*#__PURE__*/ (0, $exYeM.memo)($6c6be03ec54b75f1$var$StepDetailsComponent);







var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");
/** Number of components which have requested interest to have focus guards */ let $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count = 0;
function $c12fde423b091e9b$export$ac5b58043b79449b(props) {
    $c12fde423b091e9b$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $c12fde423b091e9b$export$b7ece24a22aeda8c() {
    (0, $exYeM.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $c12fde423b091e9b$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $c12fde423b091e9b$export$be92b6f5f03c0fe9 = $c12fde423b091e9b$export$ac5b58043b79449b;




var $exYeM = parcelRequire("exYeM");



const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $0d95d7873b2aecf3$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $exYeM.useState)(null);
    const onMountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $exYeM.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $exYeM.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (container1) {
            $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $exYeM.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($0d95d7873b2aecf3$export$20e40289641fbbb6, {
    displayName: $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$focusScopesStack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d95d7873b2aecf3$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $0d95d7873b2aecf3$export$be92b6f5f03c0fe9 = $0d95d7873b2aecf3$export$20e40289641fbbb6;









var $ed7fbe99f365bc63$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $ed7fbe99f365bc63$var$counterMap = new WeakMap();
var $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
var $ed7fbe99f365bc63$var$markerMap = {};
var $ed7fbe99f365bc63$var$lockCount = 0;
var $ed7fbe99f365bc63$var$unwrapHost = function(node) {
    return node && (node.host || $ed7fbe99f365bc63$var$unwrapHost(node.parentNode));
};
var $ed7fbe99f365bc63$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ed7fbe99f365bc63$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $ed7fbe99f365bc63$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $ed7fbe99f365bc63$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$ed7fbe99f365bc63$var$markerMap[markerName]) $ed7fbe99f365bc63$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ed7fbe99f365bc63$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($ed7fbe99f365bc63$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ed7fbe99f365bc63$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ed7fbe99f365bc63$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $ed7fbe99f365bc63$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ed7fbe99f365bc63$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ed7fbe99f365bc63$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ed7fbe99f365bc63$var$lockCount--;
        if (!$ed7fbe99f365bc63$var$lockCount) {
            // clear
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
            $ed7fbe99f365bc63$var$markerMap = {};
        }
    };
};
var $ed7fbe99f365bc63$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $ed7fbe99f365bc63$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $ed7fbe99f365bc63$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $ed7fbe99f365bc63$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($ed7fbe99f365bc63$export$cc95fea82d705fca() ? $ed7fbe99f365bc63$export$59151cc8db999a24 : $ed7fbe99f365bc63$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $1aMHK = parcelRequire("1aMHK");

var $exYeM = parcelRequire("exYeM");

var $1aMHK = parcelRequire("1aMHK");

var $exYeM = parcelRequire("exYeM");
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $d00d56265ba92762$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $1aMHK = parcelRequire("1aMHK");
function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $1aMHK.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $1aMHK.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $1aMHK.__assign)((0, $1aMHK.__assign)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $4fc5d5f926eb9841$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $1aMHK.__assign)((0, $1aMHK.__assign)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $1aMHK.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};



var $1aMHK = parcelRequire("1aMHK");

var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $1aMHK.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $1aMHK.__assign)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}



var $1aMHK = parcelRequire("1aMHK");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c01c422d43bc8e57$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $00191a54979f785d$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $071c3d40780405a9$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b8129a946e86d087$var$Style = (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $a424de23c132f073$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $a424de23c132f073$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $8c733fa2685d08ec$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;


var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState(function() {
        return (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $1aMHK.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $895262f629112328$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $4fc5d5f926eb9841$export$e27363444bedfeac), (0, $e11a1edcdcbdc39d$export$a09dbff87b5da2d));


var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $6c2939159ce57a12$export$22940b497e769dee), (0, $1aMHK.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $5f000f9080e28e0a$export$2e2bcd8739ae039)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $6c2939159ce57a12$export$22940b497e769dee).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;


/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext, $0f2238d5081ee7b6$export$c8393c9e73286932] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $0f2238d5081ee7b6$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $exYeM.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $exYeM.useState)(false);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $exYeM.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $exYeM.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$5b6b19405a83ff9d, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $0f2238d5081ee7b6$export$96e5381f42521a79 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $exYeM.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$96e5381f42521a79, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $0f2238d5081ee7b6$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$7dacb05d26466c3, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext] = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$createPopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $0f2238d5081ee7b6$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$dd679ffb4362d2d4, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $0f2238d5081ee7b6$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const portalContext = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePortalContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d7e1f420b25549ff, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $exYeM.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $exYeM.useRef)(false);
    const hasPointerDownOutsideRef = (0, $exYeM.useRef)(false);
    return /*#__PURE__*/ (0, $exYeM.createElement)($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-state": $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
            "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
            "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $0f2238d5081ee7b6$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopoverContext($0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$d6ac43ebaa40d53e, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $0f2238d5081ee7b6$export$3152841115e061b2 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($0f2238d5081ee7b6$export$3152841115e061b2, {
    displayName: $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $0f2238d5081ee7b6$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $0f2238d5081ee7b6$export$be92b6f5f03c0fe9 = $0f2238d5081ee7b6$export$5b6b19405a83ff9d;
const $0f2238d5081ee7b6$export$b688253958b8dfe7 = $0f2238d5081ee7b6$export$96e5381f42521a79;
const $0f2238d5081ee7b6$export$41fb9f06171c75f4 = $0f2238d5081ee7b6$export$7dacb05d26466c3;
const $0f2238d5081ee7b6$export$602eac185826482c = $0f2238d5081ee7b6$export$dd679ffb4362d2d4;
const $0f2238d5081ee7b6$export$7c6e2c02157bb7d2 = $0f2238d5081ee7b6$export$d7e1f420b25549ff;
const $0f2238d5081ee7b6$export$f39c2d165cd861fe = $0f2238d5081ee7b6$export$d6ac43ebaa40d53e;
const $0f2238d5081ee7b6$export$21b07c8f274aebd5 = $0f2238d5081ee7b6$export$3152841115e061b2;



var $exYeM = parcelRequire("exYeM");


const $530717a6f0884ed8$export$52e5b7d17d1ec2bb = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($0f2238d5081ee7b6$export$7c6e2c02157bb7d2, {
    borderRadius: "$sm",
    filter: "drop-shadow(0px 5px 20px rgba(130, 130, 130, 0.20))",
    backgroundColor: "$neutral100",
    zIndex: 10,
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral300"
    }
});
const $530717a6f0884ed8$export$3152841115e061b2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($0f2238d5081ee7b6$export$21b07c8f274aebd5, {
    fill: "$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        fill: "$neutral300"
    },
    width: "$16",
    height: "$8"
});


const $75e13ed4f8122291$var$DEFAULT_SIDE_OFFSET = 0;
const $75e13ed4f8122291$var$DEFAULT_ALIGN_OFFSET = 0;
const $75e13ed4f8122291$export$a4de8bad7306184e = (props, forwardedRef)=>{
    const { container: container, children: children, styles: styles, hasArrow: hasArrow = true, ...rest } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0f2238d5081ee7b6$export$602eac185826482c, {
        container: container,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $530717a6f0884ed8$export$52e5b7d17d1ec2bb), {
            ...rest,
            ref: forwardedRef,
            children: [
                children,
                hasArrow && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $530717a6f0884ed8$export$3152841115e061b2), {
                    css: styles?.arrowStyles
                })
            ]
        })
    });
};
const $75e13ed4f8122291$var$PopoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($75e13ed4f8122291$export$a4de8bad7306184e);
$75e13ed4f8122291$var$PopoverContent.displayName = "PopoverContent";
function $75e13ed4f8122291$export$5b6b19405a83ff9d(props) {
    const { children: children, content: content, side: side = "bottom", sideOffset: sideOffset = $75e13ed4f8122291$var$DEFAULT_SIDE_OFFSET, alignOffset: alignOffset = $75e13ed4f8122291$var$DEFAULT_ALIGN_OFFSET, align: align = "center", collisionBoundary: collisionBoundary = [], collisionPadding: collisionPadding = 0, container: container = document.body, onOpenChange: onOpenChange, open: open, ...rest } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($0f2238d5081ee7b6$export$be92b6f5f03c0fe9, {
        onOpenChange: onOpenChange,
        open: open,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0f2238d5081ee7b6$export$41fb9f06171c75f4, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($75e13ed4f8122291$var$PopoverContent, {
                align: align,
                alignOffset: alignOffset,
                collisionBoundary: collisionBoundary,
                collisionPadding: collisionPadding,
                side: side,
                sideOffset: sideOffset,
                container: container,
                ...rest,
                children: content
            })
        ]
    });
}





parcelRequire("exYeM");
const $8416342f94648864$export$e4c0458e30711294 = "1em";


function $05456647600d0eb6$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#496e2d",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 200.3,
                        cy: 256,
                        r: 111.3,
                        fill: "#d80027"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $22cc52d199a804cd$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M0 0v57l32 29-32 28v57l32 29-32 28v57l32 28-32 28v57l32 29-32 28v57h512v-57l-32-28 32-29v-57l-32-28 32-28v-57l-32-28 32-29v-57l-32-28 32-29V0H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 57h512v57H0Zm0 114h512v57H0Zm0 114h512v56H0Zm0 113h512v57H0Z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $c06811018ea8cb27$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m140.1 155.8 22.1 68h71.5l-57.8 42.1 22.1 68-57.9-42-57.9 42 22.2-68-57.9-42.1H118zm163.4 240.7-16.9-20.8-25 9.7 14.5-22.5-16.9-20.9 25.9 6.9 14.6-22.5 1.4 26.8 26 6.9-25.1 9.6zm33.6-61 8-25.6-21.9-15.5 26.8-.4 7.9-25.6 8.7 25.4 26.8-.3-21.5 16 8.6 25.4-21.9-15.5zm45.3-147.6L370.6 212l19.2 18.7-26.5-3.8-11.8 24-4.6-26.4-26.6-3.8 23.8-12.5-4.6-26.5 19.2 18.7zm-78.2-73-2 26.7 24.9 10.1-26.1 6.4-1.9 26.8-14.1-22.8-26.1 6.4 17.3-20.5-14.2-22.7 24.9 10.1z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $da66016d4d2c7a53$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M400.7 222.6h-33.4a111.3 111.3 0 0 1-222.6 0h-33.4c0 66.2 44.5 122 105.2 139.2a37 37 0 0 0 3.9 40.5l36.3-29.2 36.4 29.2a37 37 0 0 0 3.7-40.8 144.8 144.8 0 0 0 103.9-138.9z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M167 211.5s0 55.6 55.6 55.6l11.1 11.2H256s11.1-33.4 33.4-33.4c0 0 0-22.3 22.3-22.3H345s-11-44.5 44.6-77.9l-22.3-11.1s-78 55.6-133.6 44.5v22.2h-22.2l-11.2-11-33.3 22.2z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $26cc6cd6f1b31021$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h133.6l32.7 20.3 34-20.3H512v222.6L491.4 256l20.6 33.4V512H200.3l-31.7-20.4-35 20.4H0V289.4l29.4-33L0 222.7z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $5bae59a0ca5c4d98$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 0 8 22-8 23v23l32 54-32 54v32l32 48-32 48v32l32 54-32 54v68l22-8 23 8h23l54-32 54 32h32l48-32 48 32h32l54-32 54 32h68l-8-22 8-23v-23l-32-54 32-54v-32l-32-48 32-48v-32l-32-54 32-54V0l-22 8-23-8h-23l-54 32-54-32h-32l-48 32-48-32h-32l-54 32L68 0H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0v45l131 131h45L0 0zm208 0v208H0v96h208v208h96V304h208v-96H304V0h-96zm259 0L336 131v45L512 0h-45zM176 336 0 512h45l131-131v-45zm160 0 176 176v-45L381 336h-45z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $ef7375a9ef81e88a$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $2ce5bbc0587d6a90$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h167v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M345 0h167v512H345z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $1bd966efb4350c20$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 345 256.7-25.5L512 345v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m0 167 255-23 257 23v178H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#333",
                        d: "M0 0h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $ec7dd0983fbff973$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h99l29 32 28-32h356v57l-32 28 32 29v57l-32 28 32 29v57l-32 28 32 28v57l-32 29 32 28v57H0v-57l32-28-32-29v-56l32-29-32-28V171l32-29-32-28Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M99 0v114H0v57h99v114H0v57h512v-57H156V171h100v-57H156V0Zm157 57v57h256V57Zm0 114v57h256v-57ZM0 398v57h512v-57z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $a2434d283c3a3f57$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 160 256-32 256 32v192l-256 32L0 352z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M0 0h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 352h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 72,
                        fill: "#0052b4"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 48,
                        fill: "#eee"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: 256,
                        cy: 256,
                        r: 24,
                        fill: "#0052b4"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $75b81446f360bb41$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $948afb5c9a3043f0$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 160 256-32 256 32v192l-256 32L0 352z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M0 0h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 352h512v160H0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "256",
                        cy: "256",
                        r: "72",
                        fill: "#0052b4"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "256",
                        cy: "256",
                        r: "48",
                        fill: "#eee"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "256",
                        cy: "256",
                        r: "24",
                        fill: "#0052b4"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $e5ba4cf233dccafe$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 256 249.6-41.3L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $ca126a9eab937d30$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 0h167v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M345 0h167v512H345z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $557e788bd80de79a$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "256",
                        cy: "256",
                        r: "111.3",
                        fill: "#d80027"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $b9ef553cc43a0f0d$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v512H0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#333",
                        d: "m350 335 24-24 16 16-24 23zm-39 39 24-24 15 16-23 24zm87 8 23-24 16 16-24 24zm-40 39 24-23 16 15-24 24Zm16-63 24-23 15 15-23 24zm-39 40 23-24 16 16-24 23zm63-221-63-63 15-15 64 63zm-63-15-24-24 16-16 23 24zm39 39-24-24 16-15 24 23zm8-87-24-23 16-16 24 24Zm39 40-23-24 15-16 24 24ZM91 358l63 63-16 16-63-63zm63 16 23 24-15 15-24-23zm-40-39 24 23-16 16-23-24zm24-24 63 63-16 16-63-63zm16-220-63 63-16-16 63-63zm23 23-63 63-15-16 63-63zm24 24-63 63-16-16 63-63z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M319 319 193 193a89 89 0 1 1 126 126z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M319 319a89 89 0 1 1-126-126z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "224.5",
                        cy: "224.5",
                        r: "44.5",
                        fill: "#d80027"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "287.5",
                        cy: "287.5",
                        r: "44.5",
                        fill: "#0052b4"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $8cbba6f1bedca365$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $14ca30fc33cb4aac$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#338af3",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $1164608ad810c3d4$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 345h512v167H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $e945a4e0ece49372$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h133.6l50.2 252.5L133.6 512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#496e2d",
                        d: "M133.6 0H512v512H133.6z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M365.5 298.3A72.3 72.3 0 1 1 313.7 168a89 89 0 1 0 74.6 103.2 72 72 0 0 1-22.8 27.2zM364 167l18.2 19.6 24.3-11.3-13 23.5 18.2 19.6-26.3-5.1-13 23.4-3.3-26.7-26.1-5 24.4-11.3z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $cf1275a7afd947ed$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h512v256l-265 45.2z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M210 256h302v256H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0v512l256-256z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M175.3 256 144 241.3l16.7-30.3-34 6.5-4.3-34.3-23.6 25.2L75 183.2l-4.3 34.3-34-6.5 16.7 30.3L22.3 256l31.2 14.7L37 301l34-6.5 4.2 34.3 23.7-25.2 23.6 25.2 4.3-34.3 34 6.5-16.7-30.3zm-107-155.8 10.4 14.5 17-5.4-10.6 14.4 10.4 14.5-17-5.6L68 147l.2-17.9-17-5.6 17-5.4zm0 264.8 10.4 14.6 17-5.4-10.6 14.3 10.4 14.6-17-5.7L68 411.8l.2-17.9-17-5.6 17-5.4zm148.4-132.4L206.3 247l-17-5.4 10.5 14.4-10.4 14.6 17-5.7 10.6 14.4-.1-17.9 17-5.6-17.1-5.4z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $b3504a4ebf02bc9e$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m0 256 256.4-44.3L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $076e4b020cd6fd26$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M0 512h167l37.9-260.3L167 0H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M512 0H167v512h345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                        cx: "167",
                        cy: "256",
                        r: "89",
                        fill: "#ffda44"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $a98b5d26da9e9cb4$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M512 170v172l-256 32L0 342V170l256-32z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M512 0v170H0V0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M512 342v170H0V342Z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $32fd776629403fce$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#496e2d",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#eee",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M144.7 306c0 18.5 15 33.5 33.4 33.5h100.2a27.8 27.8 0 0 0 27.8 27.8h33.4a27.8 27.8 0 0 0 27.8-27.8V306zm225.4-161.3v78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9H370zm-239.3 78c0 12.2-10 22.2-22.3 22.2v33.4c30.7 0 55.7-25 55.7-55.7v-77.9h-33.4z"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M320 144.7h33.4v78H320zm-50 44.5a5.6 5.6 0 0 1-11.2 0v-44.5h-33.4v44.5a5.6 5.6 0 0 1-11.1 0v-44.5h-33.4v44.5a39 39 0 0 0 39 39 38.7 38.7 0 0 0 22.2-7 38.7 38.7 0 0 0 22.2 7c1.7 0 3.4-.1 5-.3a22.3 22.3 0 0 1-21.6 17v33.4c30.6 0 55.6-25 55.6-55.7v-77.9H270z"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M180.9 244.9h50v33.4h-50z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $9ee7ea20f5856de1$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 345h512v167H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M66.2 144.7v127.7c0 72.6 94.9 95 94.9 95s94.9-22.4 94.9-95V144.7z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M105.4 167h111.4v-44.6l-22.3 11.2-33.4-33.4-33.4 33.4-22.3-11.2zm128.3 123.2-72.3-72.4L89 290.2l23.7 23.6 48.7-48.7 48.7 48.7z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M233.7 222.6H200a22.1 22.1 0 0 0 3-11.1 22.3 22.3 0 0 0-42-10.5 22.3 22.3 0 0 0-41.9 10.5 22.1 22.1 0 0 0 3 11.1H89a23 23 0 0 0 23 22.3h-.7c0 12.3 10 22.2 22.3 22.2 0 11 7.8 20 18.1 21.9l-17.5 39.6a72.1 72.1 0 0 0 27.2 5.3 72.1 72.1 0 0 0 27.2-5.3L171.1 289c10.3-2 18.1-11 18.1-21.9 12.3 0 22.3-10 22.3-22.2h-.8a23 23 0 0 0 23-22.3z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $6fd6ccbc1b739a4c$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "m0 160 256-32 256 32v192l-256 32L0 352z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 0h512v160H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 352h512v160H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M64 63v217c0 104 144 137 144 137s144-33 144-137V63z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M96 95v185a83 78 0 0 0 9 34h206a83 77 0 0 0 9-34V95z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M288 224h-64v-32h32v-32h-32v-32h-32v32h-32v32h32v32h-64v32h64v32h32v-32h64z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M152 359a247 231 0 0 0 56 24c12-3 34-11 56-24a123 115 0 0 0 47-45 60 56 0 0 0-34-10l-14 2a60 56 0 0 0-110 0 60 56 0 0 0-14-2c-12 0-24 4-34 10a123 115 0 0 0 47 45z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $163cfd0418700f12$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 0 192 256L0 512h47l465-189v-34l-32-33 32-33v-34L47 0Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#333",
                        d: "M0 142v228l140-114z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M192 256 0 95v47l114 114L0 370v47z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#6da544",
                        d: "M512 223H223L0 0v94l161 162L0 418v94l223-223h289z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M512 0H47l189 189h276z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M512 512H47l189-189h276z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $587b6b5217b9553a$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 128 256-32 256 32v256l-256 32L0 384Z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v128H0zm0 384h512v128H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#eee",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M144 304h-16v-80h16zm128 0h16v-80h-16z"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ellipse", {
                                cx: "208",
                                cy: "296",
                                rx: "48",
                                ry: "32"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#d80027",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                width: "16",
                                height: "24",
                                x: "128",
                                y: "192",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                width: "16",
                                height: "24",
                                x: "272",
                                y: "192",
                                rx: "8"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M208 272v24a24 24 0 0 0 24 24 24 24 0 0 0 24-24v-24h-24z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "120",
                        y: "208",
                        fill: "#ff9811",
                        ry: "8"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "264",
                        y: "208",
                        fill: "#ff9811",
                        ry: "8"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "120",
                        y: "304",
                        fill: "#ff9811",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: "32",
                        height: "16",
                        x: "264",
                        y: "304",
                        fill: "#ff9811",
                        rx: "8"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M160 272v24c0 8 4 14 9 19l5-6 5 10a21 21 0 0 0 10 0l5-10 5 6c6-5 9-11 9-19v-24h-9l-5 8-5-8h-10l-5 8-5-8z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M122 252h172m-172 24h28m116 0h28"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M122 248a4 4 0 0 0-4 4 4 4 0 0 0 4 4h172a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm0 24a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4zm144 0a4 4 0 0 0-4 4 4 4 0 0 0 4 4h28a4 4 0 0 0 4-4 4 4 0 0 0-4-4z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M196 168c-7 0-13 5-15 11l-5-1c-9 0-16 7-16 16s7 16 16 16c7 0 13-4 15-11a16 16 0 0 0 17-4 16 16 0 0 0 17 4 16 16 0 1 0 10-20 16 16 0 0 0-27-5c-3-4-7-6-12-6zm0 8c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm24 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8zm-44 10 4 1 4 8c0 4-4 7-8 7s-8-3-8-8c0-4 4-8 8-8zm64 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-7l4-8z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "none",
                        d: "M220 284v12c0 7 5 12 12 12s12-5 12-12v-12z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M200 160h16v32h-16z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M208 224h48v48h-48z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24zm-88 16h48v48h-48z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                        width: "20",
                        height: "32",
                        x: "222",
                        y: "232",
                        fill: "#d80027",
                        rx: "10",
                        ry: "10"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ff9811",
                        d: "M168 232v8h8v16h-8v8h32v-8h-8v-16h8v-8zm8-16h64v8h-64z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#ffda44",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                cx: "186",
                                cy: "202",
                                r: "6"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                cx: "208",
                                cy: "202",
                                r: "6"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                cx: "230",
                                cy: "202",
                                r: "6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M169 272v43a24 24 0 0 0 10 4v-47h-10zm20 0v47a24 24 0 0 0 10-4v-43h-10z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#338af3",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                                cx: "208",
                                cy: "272",
                                r: "16"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                width: "32",
                                height: "16",
                                x: "264",
                                y: "320",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
                                width: "32",
                                height: "16",
                                x: "120",
                                y: "320",
                                ry: "8"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $d2a96b461bc63761$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: "256",
                    cy: "256",
                    r: "256",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m0 144.7 253.4-28.2L512 144.7V178l-36 76.4 36 79.6v33.3L254.7 400 0 367.3V334l39-78-39-78z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#333",
                        d: "M0 0h512v144.7H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M0 178h512v156H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#496e2d",
                        d: "M0 367.3h512V512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "m335.9 118.3-30.3-14-49.4 111.9-49.4-111.9-30.3 14L237.8 256l-61.3 137.7 30.3 14 49.4-111.9 49.4 111.9 30.3-14L274.6 256z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M256.2 111.3s-7 5.8-16.7 16l-16 127.6 16 129.8c9.7 10.2 16.7 16 16.7 16s7-5.8 16.7-16l15-130.7-15-126.7c-9.7-10.2-16.7-16-16.7-16z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#333",
                        d: "m311.9 179.2-10 75.5 10 78.1A158.6 158.6 0 0 0 334 256c0-28.2-9.7-54.5-22.2-76.8zm-111.4 0 8.9 74.3-9 79.3a158.6 158.6 0 0 1-22.1-76.8c0-28.2 9.7-54.5 22.2-76.8z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#a2001d",
                        d: "M200.5 179.2v153.6a269 269 0 0 0 39 51.9V127.3c-11.4 12-26.6 30-39 52zm111.4 0a269 269 0 0 0-39-51.9v257.4c11.4-12 26.5-30 39-52V179.3z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $b3f183aaf0af65db$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $21fd827fd7e4c82c$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v89l-79.2 163.7L512 423v89H0v-89l82.7-169.6L0 89z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#eee",
                        d: "M0 89h512v78l-42.6 91.2L512 345v78H0v-78l40-92.5L0 167z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#0052b4",
                        d: "M0 167h512v178H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $79649b9f82a49880$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                        fill: "#eee",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "m245.5 209.2 21 29 34-11.1-21 29 21 28.9-34-11.1-21 29V267l-34-11.1 34-11z"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                d: "M188.2 328.3a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $39bd2056492681b8$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m0 256 258-39.4L512 256v256H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#338af3",
                        d: "M0 0h512v256H0z"
                    })
                ]
            })
        ]
    });
}



parcelRequire("exYeM");

function $b42ee6fe0e513c3c$export$2e2bcd8739ae039(props) {
    const { size: size = (0, $8416342f94648864$export$e4c0458e30711294) } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("mask", {
                id: "a",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                    cx: 256,
                    cy: 256,
                    r: 256,
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#d80027",
                        d: "M0 0h512v512H0z"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        fill: "#ffda44",
                        d: "m256 133.6 27.6 85H373L300.7 271l27.6 85-72.3-52.5-72.3 52.6 27.6-85-72.3-52.6h89.4z"
                    })
                ]
            })
        ]
    });
}







var $exYeM = parcelRequire("exYeM");

function $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}






















const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME = "Select";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext, $e552a3fd37fc9fd9$export$286727a75dc039bd] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME, [
    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createCollectionScope,
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME);
const $e552a3fd37fc9fd9$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0, $exYeM.useState)(null);
    const [valueNode, setValueNode] = (0, $exYeM.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0, $exYeM.useState)(false);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0, $exYeM.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0, $exYeM.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0, $exYeM.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option));
        }, []),
        onNativeOptionRemove: (0, $exYeM.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value),
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0, $exYeM.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ef9b1a59e592288f, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
const $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$b688253958b8dfe7), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? "open" : "closed",
        disabled: isDisabled,
        "data-disabled": isDisabled ? "" : undefined,
        "data-placeholder": $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? "" : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== "";
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === " ") return;
            if ($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
const $e552a3fd37fc9fd9$export$e288731fd71264f0 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: "none"
        }
    }), $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$e288731fd71264f0, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ICON_NAME = "SelectIcon";
const $e552a3fd37fc9fd9$export$99b400cabb58c515 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || "\u25BC");
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$99b400cabb58c515, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$PORTAL_NAME = "SelectPortal";
const $e552a3fd37fc9fd9$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $965ca2171585ad7a$export$602eac185826482c), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$b2af6c9944296213, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
const $e552a3fd37fc9fd9$export$c973a4b3cb86a03d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0, $exYeM.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(/*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $exYeM.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$c973a4b3cb86a03d, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME);
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME = "SelectContentImpl";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, ...contentProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const [viewport, setViewport] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = (0, $exYeM.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0, $exYeM.useState)(null);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0, $exYeM.useState)(false);
    const firstValidItemFoundRef = (0, $exYeM.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $exYeM.useEffect)(()=>{
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    const focusFirst = (0, $exYeM.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: "nearest"
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0, $exYeM.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0, $exYeM.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    (0, $exYeM.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0, $exYeM.useEffect)(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = (0, $exYeM.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0, $exYeM.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = (0, $exYeM.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition : $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $exYeM.createElement)(SelectPosition, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? "open" : "closed",
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true),
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === "Tab") event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled);
                let candidateNodes = items.map((item)=>item.ref.current);
                if ([
                    "ArrowUp",
                    "End"
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    "ArrowUp",
                    "ArrowDown"
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes));
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0, $exYeM.useState)(null);
    const [content, setContent] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0, $exYeM.useRef)(false);
    const shouldRepositionRef = (0, $exYeM.useRef)(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = (0, $exYeM.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(left, [
                    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(right, [
                    $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px"; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0, $exYeM.useState)();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0, $exYeM.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0, $exYeM.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: "border-box",
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: "100%",
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME = "SelectPopperPosition";
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$7c6e2c02157bb7d2), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectViewportProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_NAME, {});
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
const $e552a3fd37fc9fd9$export$9ed6e7b40248d36d = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...viewportProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0, $exYeM.useRef)(0);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...viewportProps.style
        },
        onScroll: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + "px";
                        if (contentWrapper.style.bottom === "0px") {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = "flex-end";
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$9ed6e7b40248d36d, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectGroupContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME);
const $e552a3fd37fc9fd9$export$ee25a334c55de1f4 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ee25a334c55de1f4, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel";
const $e552a3fd37fc9fd9$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectGroupContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$f67338d29bd972f8, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
const [$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemContextProvider, $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext] = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$createSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME);
const $e552a3fd37fc9fd9$export$13ef48a934230896 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0, $exYeM.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0, $exYeM.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
            });
        }, [])
    }, /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? "" : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? "checked" : "unchecked",
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
        onPointerUp: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
            if (isTypingAhead && event.key === " ") return;
            if ($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === " ") event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$13ef48a934230896, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
const $e552a3fd37fc9fd9$export$3572fb0fb821ff49 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0, $exYeM.useState)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0, $exYeM.useMemo)(()=>/*#__PURE__*/ (0, $exYeM.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $exYeM.Fragment), null, /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0, $97dc602bd7e23afa$exports.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$3572fb0fb821ff49, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
const $e552a3fd37fc9fd9$export$6b9198de19accfe6 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectItemContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$6b9198de19accfe6, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
const $e552a3fd37fc9fd9$export$d8117927658af6d7 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$d8117927658af6d7, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
const $e552a3fd37fc9fd9$export$ff951e476c12189 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectViewportContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0, $exYeM.useState)(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0, $exYeM.createElement)($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$ff951e476c12189, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = (0, $exYeM.useRef)(null);
    const getItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0, $exYeM.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0, $exYeM.useEffect)(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SEPARATOR_NAME = "SelectSeparator";
const $e552a3fd37fc9fd9$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $exYeM.createElement)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$eba4b1df07cb1d3, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME = "SelectArrow";
const $e552a3fd37fc9fd9$export$314f4cb8f8099628 = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useSelectContentContext($e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /*#__PURE__*/ (0, $exYeM.createElement)((0, $7b6292e260c70ed7$export$21b07c8f274aebd5), (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($e552a3fd37fc9fd9$export$314f4cb8f8099628, {
    displayName: $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === "" || value === undefined;
}
const $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0, $exYeM.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = (0, $exYeM.useRef)(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $exYeM.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0, $exYeM.createElement)((0, $4ed20962d3818fe0$export$439d29a4e110a164), {
        asChild: true
    }, /*#__PURE__*/ (0, $exYeM.createElement)("select", (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = (0, $exYeM.useRef)("");
    const timerRef = (0, $exYeM.useRef)(0);
    const handleTypeaheadSearch = (0, $exYeM.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0, $exYeM.useCallback)(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $e552a3fd37fc9fd9$var$$cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $e552a3fd37fc9fd9$export$be92b6f5f03c0fe9 = $e552a3fd37fc9fd9$export$ef9b1a59e592288f;
const $e552a3fd37fc9fd9$export$41fb9f06171c75f4 = $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1;
const $e552a3fd37fc9fd9$export$4c8d1a57a761ef94 = $e552a3fd37fc9fd9$export$e288731fd71264f0;
const $e552a3fd37fc9fd9$export$f04a61298a47a40f = $e552a3fd37fc9fd9$export$99b400cabb58c515;
const $e552a3fd37fc9fd9$export$602eac185826482c = $e552a3fd37fc9fd9$export$b2af6c9944296213;
const $e552a3fd37fc9fd9$export$7c6e2c02157bb7d2 = $e552a3fd37fc9fd9$export$c973a4b3cb86a03d;
const $e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7 = $e552a3fd37fc9fd9$export$9ed6e7b40248d36d;
const $e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4 = $e552a3fd37fc9fd9$export$ee25a334c55de1f4;
const $e552a3fd37fc9fd9$export$b04be29aa201d4f5 = $e552a3fd37fc9fd9$export$f67338d29bd972f8;
const $e552a3fd37fc9fd9$export$6d08773d2e66f8f2 = $e552a3fd37fc9fd9$export$13ef48a934230896;
const $e552a3fd37fc9fd9$export$d6e5bf9c43ea9319 = $e552a3fd37fc9fd9$export$3572fb0fb821ff49;
const $e552a3fd37fc9fd9$export$c3468e2714d175fa = $e552a3fd37fc9fd9$export$6b9198de19accfe6;
const $e552a3fd37fc9fd9$export$2f60d3ec9ad468f2 = $e552a3fd37fc9fd9$export$d8117927658af6d7;
const $e552a3fd37fc9fd9$export$bf1aedc3039c8d63 = $e552a3fd37fc9fd9$export$ff951e476c12189;
const $e552a3fd37fc9fd9$export$1ff3c3f08ae963c0 = $e552a3fd37fc9fd9$export$eba4b1df07cb1d3;
const $e552a3fd37fc9fd9$export$21b07c8f274aebd5 = $e552a3fd37fc9fd9$export$314f4cb8f8099628;



var $exYeM = parcelRequire("exYeM");




const $b60e7595ac213fde$export$feda024f54e6d09b = 300;
const $b60e7595ac213fde$export$3ac1e88a1c0b9f1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($e552a3fd37fc9fd9$export$41fb9f06171c75f4, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    outline: 0,
    whiteSpace: "nowrap",
    width: "100%",
    "& svg": {
        transition: `all ${$b60e7595ac213fde$export$feda024f54e6d09b}ms ease`
    },
    "& ._typography": {
        whiteSpace: "nowrap"
    },
    variants: {
        open: {
            true: {
                "& svg": {
                    transform: "rotate(180deg)"
                }
            },
            false: {
                "& svg": {
                    transform: "rotate(0)"
                }
            }
        },
        variant: {
            filled: {
                border: 0,
                borderRadius: "$sm",
                padding: "$5 $10",
                backgroundColor: "$neutral300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    backgroundColor: "$neutral400"
                },
                "&:hover": {
                    backgroundColor: "$secondary100",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral"
                    }
                }
            },
            outlined: {
                backgroundColor: "transparent",
                padding: "$10",
                border: "1px solid $neutral300",
                borderRadius: "$xm",
                "&:hover": {
                    borderColor: "$secondary200",
                    "& svg": {
                        color: "$secondary500"
                    }
                }
            }
        }
    }
});
const $b60e7595ac213fde$export$c973a4b3cb86a03d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($e552a3fd37fc9fd9$export$7c6e2c02157bb7d2, {
    width: "var(--radix-select-trigger-width)",
    maxHeight: "var(--radix-select-content-available-height)",
    overflowY: "auto",
    borderRadius: "$sm",
    boxShadow: "-5px 5px 10px 0px rgba(86, 86, 86, 0.10)",
    backgroundColor: "$background"
});
const $b60e7595ac213fde$export$13ef48a934230896 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($e552a3fd37fc9fd9$export$6d08773d2e66f8f2, {
    padding: "$10",
    listStyleType: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    "&:focus": {
        outline: "none"
    },
    "&:hover": {
        backgroundColor: "$secondary100",
        "& ._text": {
            color: "$secondary500"
        },
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral",
            color: "$secondary500"
        }
    }
});


function $36de8fcf5878cc9c$export$c006741a65b06687(props) {
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const selectRef = (0, $exYeM.useRef)(null);
    const { options: options, value: value, container: container, handleItemClick: handleItemClick, variant: variant, styles: styles } = props;
    const handleToggle = ()=>{
        setOpen((prev)=>!prev);
    };
    const handleClickOutside = (e)=>{
        if (selectRef.current && !selectRef.current.contains(e.target)) setOpen(false);
    };
    (0, $exYeM.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    const selectedLabel = options.find((option)=>option.value === value)?.label;
    const wrapPortal = (children)=>{
        if (container) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$602eac185826482c, {
            container: container,
            children: children
        });
        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: children
        });
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        ref: selectRef,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$be92b6f5f03c0fe9, {
            value: value,
            open: open,
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b60e7595ac213fde$export$3ac1e88a1c0b9f1), {
                    variant: variant,
                    onKeyDown: (event)=>event.key === "Enter" && handleToggle(),
                    onClick: handleToggle,
                    open: open,
                    "aria-label": selectedLabel,
                    css: styles?.trigger,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$4c8d1a57a761ef94, {
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "small",
                                children: selectedLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$f04a61298a47a40f, {
                            className: "SelectIcon",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
                                size: 12,
                                color: "black"
                            })
                        })
                    ]
                }),
                wrapPortal(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b60e7595ac213fde$export$c973a4b3cb86a03d), {
                    position: "popper",
                    sideOffset: 5,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$2f60d3ec9ad468f2, {
                            className: "SelectScrollButton",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $37519868f1c889a9$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7, {
                            className: "SelectViewport",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4, {
                                children: options.map((option)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b60e7595ac213fde$export$13ef48a934230896), {
                                        onClick: ()=>{
                                            handleItemClick && handleItemClick(option);
                                            handleToggle();
                                        },
                                        value: option.value,
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$d6e5bf9c43ea9319, {
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                                    variant: "body",
                                                    size: "small",
                                                    className: "_text",
                                                    children: option.label
                                                })
                                            }),
                                            option.value === value && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5815e032006c952c$export$2e2bcd8739ae039), {
                                                size: 14,
                                                color: "secondary"
                                            })
                                        ]
                                    }, option.value))
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$bf1aedc3039c8d63, {
                            className: "SelectScrollButton",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {})
                        })
                    ]
                }))
            ]
        })
    });
}







var $exYeM = parcelRequire("exYeM");






const $07e817a817109a89$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    variants: {
        hasPadding: {
            true: {
                padding: "0 $32"
            }
        }
    }
});
const $07e817a817109a89$export$21b07c8f274aebd5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
    position: "absolute",
    height: "100%",
    zIndex: 20,
    borderRadius: "$xs !important",
    variants: {
        hidden: {
            true: {
                visibility: "hidden"
            }
        }
    }
});
const $07e817a817109a89$export$acad20503ad73ac1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($07e817a817109a89$export$21b07c8f274aebd5, {
    right: 0
});
const $07e817a817109a89$export$e4c291d45fea4cd0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($07e817a817109a89$export$21b07c8f274aebd5, {
    left: 0
});
const $07e817a817109a89$export$b2539bed5023c21c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    justifyContent: "space-between",
    height: "100%",
    variants: {
        type: {
            secondary: {
                border: "3px solid $neutral100",
                backgroundColor: "$neutral100"
            },
            primary: {
                $$color: "$colors$neutral200",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                borderColor: "$$color",
                borderWidth: "5px",
                borderStyle: "solid",
                backgroundColor: "$$color"
            },
            bordered: {}
        },
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            },
            none: {
                borderRadius: "unset"
            }
        },
        scrollable: {
            true: {
                overflowX: "auto",
                scrollBehavior: "smooth",
                scrollbarWidth: "none",
                "&::webkit-scrollbar": {
                    display: "none"
                }
            }
        }
    }
});
const $07e817a817109a89$export$3e41faf802a29e71 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    color: "$neutral700",
    flex: 1,
    backgroundColor: "transparent",
    height: "100%",
    zIndex: 10,
    "& ._text": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    variants: {
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            },
            none: {
                borderRadius: "unset"
            }
        },
        type: {
            primary: {
                padding: "$5 $10",
                height: "100%"
            },
            secondary: {},
            bordered: {
                padding: "$10 $20"
            }
        },
        isActive: {
            true: {
                transition: "color 0.8s linear"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            type: "secondary",
            isActive: true,
            css: {
                $$color: "$colors$background",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$foreground"
                },
                color: "$$color"
            }
        },
        {
            type: "secondary",
            isActive: false,
            css: {
                "&:hover": {
                    backgroundColor: "$secondary100",
                    color: "$secondary500",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "transparent",
                        color: "$neutral700"
                    }
                }
            }
        },
        {
            type: "primary",
            isActive: true,
            css: {
                color: "$secondary",
                "& svg": {
                    color: "$secondary"
                }
            }
        },
        {
            type: "primary",
            isActive: false,
            css: {
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        },
        {
            type: "bordered",
            isActive: true,
            css: {
                color: "$secondary500"
            }
        },
        {
            type: "bordered",
            isActive: false,
            css: {
                color: "$neutral600",
                fontWeight: "$regular",
                "&:hover": {
                    color: "$secondary550"
                }
            }
        }
    ]
});
const $07e817a817109a89$export$cb226174c18dced4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$4",
    boxSizing: "border-box",
    position: "absolute",
    inset: 0,
    transition: "transform 0.2s cubic-bezier(0, 0, 0.86, 1.2)",
    "&.no-transition": {
        transition: "none"
    },
    variants: {
        type: {
            secondary: {
                backgroundColor: "$secondary500"
            },
            primary: {
                backgroundColor: "$background"
            },
            bordered: {
                borderRadius: "0 !important",
                borderBottom: "$secondary500 solid 2px"
            }
        },
        borderRadius: {
            small: {
                borderRadius: "$xs"
            },
            medium: {
                borderRadius: "$sm"
            },
            full: {
                borderRadius: "$xm"
            },
            none: {
                borderRadius: "unset"
            }
        }
    }
});


const $838c21fc3959a414$var$INITIAL_RENDER_DELAY = 100;
function $838c21fc3959a414$export$fb3aab15d866de8f(props) {
    const { items: tabItems, onChange: onChange, container: container = document.body, value: value, type: type, className: className, scrollable: scrollable, scrollButtons: scrollButtons = true } = props;
    const [tabWidth, setTabWidth] = (0, $exYeM.useState)(0);
    const tabRef = (0, $exYeM.useRef)(null);
    const containerRef = (0, $exYeM.useRef)(null);
    const leftArrowRef = (0, $exYeM.useRef)(null);
    const currentIndex = tabItems.findIndex((item)=>item.id === value);
    // State variable to track the initial render
    const [initialRender, setInitialRender] = (0, $exYeM.useState)(true);
    const [transformPosition, setTransformPosition] = (0, $exYeM.useState)(0);
    const [leftArrowDisabled, setLeftArrowDisabled] = (0, $exYeM.useState)(true);
    const [rightArrowDisabled, setRightArrowDisabled] = (0, $exYeM.useState)(false);
    const [showArrows, setShowArrows] = (0, $exYeM.useState)(false);
    let borderRadius = "medium";
    if (type === "bordered") borderRadius = "none";
    else if (type && props.borderRadius) borderRadius = props.borderRadius;
    const handleScroll = (to)=>{
        if (!containerRef.current) return;
        const SCROLL_MULTIPLIER = 1.5;
        const scrollWidth = containerRef.current.scrollWidth / tabItems.length * SCROLL_MULTIPLIER;
        if (to === "right") containerRef.current.scrollLeft -= scrollWidth;
        else containerRef.current.scrollLeft += scrollWidth;
    };
    const updateIndicator = ()=>{
        if (tabRef.current && containerRef.current) {
            const tabRect = tabRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();
            setTabWidth(tabRect.width);
            setTransformPosition(tabRef.current.offsetLeft);
            const itemPartiallyVisibleOnLeft = tabRect.left < containerRect.left;
            const itemPartiallyVisibleOnRight = tabRect.right > containerRect.right;
            if (itemPartiallyVisibleOnLeft) containerRef.current.scrollLeft = tabRef.current.offsetLeft;
            else if (itemPartiallyVisibleOnRight) {
                const containerComputedStyles = window.getComputedStyle(containerRef.current);
                containerRef.current.scrollLeft = containerRef.current.scrollLeft + tabRect.right - containerRect.right + parseFloat(containerComputedStyles.borderRightWidth);
            }
        }
    };
    (0, $exYeM.useEffect)(()=>{
        // Set initialRender to false after a short delay
        const timeout = setTimeout(()=>{
            setInitialRender(false);
            clearTimeout(timeout);
        }, $838c21fc3959a414$var$INITIAL_RENDER_DELAY);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        updateIndicator();
        const updateArrowsVisibility = ()=>{
            if (scrollable && containerRef.current) {
                const startOfTheScroll = containerRef.current.scrollLeft === 0;
                const endOfTheScroll = containerRef.current.scrollLeft + containerRef.current.clientWidth === containerRef.current.scrollWidth;
                if (startOfTheScroll) setLeftArrowDisabled(true);
                else setLeftArrowDisabled(false);
                if (endOfTheScroll) setRightArrowDisabled(true);
                else setRightArrowDisabled(false);
            }
        };
        const resizeHandler = (event)=>{
            updateIndicator();
            if (!containerRef.current || !scrollable || !scrollButtons) return;
            updateArrowsVisibility();
            const TOTAL_WIDTH_OF_ARROWS = 64;
            const element = event[0].target;
            const tabsContainerOverflown = element.scrollWidth - TOTAL_WIDTH_OF_ARROWS > element.clientWidth;
            if (showArrows && !tabsContainerOverflown) setShowArrows(false);
            else if (element.scrollWidth > element.clientWidth) setShowArrows(true);
        };
        containerRef.current?.addEventListener("scroll", updateArrowsVisibility);
        const resizeObserver = new ResizeObserver(resizeHandler);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>{
            if (containerRef.current) {
                resizeObserver.unobserve(containerRef.current);
                containerRef.current.removeEventListener("scroll", updateArrowsVisibility);
            }
        };
    }, [
        containerRef.current,
        showArrows,
        currentIndex
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $07e817a817109a89$export$42a852a2b6b56249), {
        hasPadding: scrollButtons && showArrows,
        children: [
            scrollable && showArrows && scrollButtons && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $07e817a817109a89$export$e4c291d45fea4cd0), {
                        ref: leftArrowRef,
                        hidden: leftArrowDisabled,
                        onClick: ()=>handleScroll("right"),
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2e0408aac5dd3ed5$export$2e2bcd8739ae039), {
                            size: 16,
                            color: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $07e817a817109a89$export$acad20503ad73ac1), {
                        hidden: rightArrowDisabled,
                        onClick: ()=>handleScroll("left"),
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
                            size: 16,
                            color: "secondary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $07e817a817109a89$export$b2539bed5023c21c), {
                ref: containerRef,
                className: `_tabs ${className || ""}`,
                type: type,
                borderRadius: borderRadius,
                scrollable: scrollable,
                children: [
                    tabItems.map((item, index)=>{
                        const isActive = item.id === value;
                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $273666b35d34bd80$export$28c660c63b792dea), {
                            styles: {
                                root: {
                                    width: "100%"
                                }
                            },
                            container: container,
                            side: "bottom",
                            sideOffset: 2,
                            content: item.tooltip,
                            open: !item.tooltip ? false : undefined,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $07e817a817109a89$export$3e41faf802a29e71), {
                                className: "_tab",
                                ref: index === currentIndex ? tabRef : null,
                                type: type,
                                fullWidth: scrollable ? false : true,
                                disableRipple: true,
                                borderRadius: borderRadius,
                                onClick: ()=>onChange(item),
                                size: "small",
                                isActive: isActive,
                                "data-active": isActive,
                                variant: "default",
                                children: [
                                    item.icon,
                                    !!item.icon && !!item.title && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                        direction: "horizontal",
                                        size: "2"
                                    }),
                                    item.title
                                ]
                            })
                        }, item.id);
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $07e817a817109a89$export$cb226174c18dced4), {
                        type: type,
                        borderRadius: borderRadius,
                        className: `_backdrop-tab ${initialRender ? "no-transition" : ""}`,
                        css: {
                            width: tabWidth,
                            transform: `translateX(${transformPosition}px)`
                        }
                    })
                ]
            })
        ]
    });
}








var $exYeM = parcelRequire("exYeM");



const $5e65830771d95ee2$export$6da19a24bf249f17 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$8",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    overflow: "auto"
});


function $0f60015809265b9c$export$716151ac6ec086e5(props) {
    const { open: open, list: list, onSelect: onSelect, onClose: onClose } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8f7c1be9e0a4b3b4$export$2b77a92f1a5ad772), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect Wallets"),
        open: open,
        onClose: onClose,
        styles: {
            container: {
                width: "75%",
                maxWidth: "30rem",
                height: "60%"
            }
        },
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5e65830771d95ee2$export$6da19a24bf249f17), {
            children: list.map((info)=>/*#__PURE__*/ (0, $exYeM.createElement)((0, $b7ad2cfc9fe1d9ac$export$2e2bcd8739ae039), {
                    ...info,
                    key: info.title,
                    onClick: onSelect
                }))
        })
    });
}





parcelRequire("exYeM");


const $858269b0b7dfb3e7$var$List = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    padding: "$0 $0 $40 $0",
    margin: 0
});
const $858269b0b7dfb3e7$var$ListItem = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("li", {
    paddingBottom: "$10"
});
const $858269b0b7dfb3e7$var$Message = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    display: "block"
});
function $858269b0b7dfb3e7$export$137c1412116f174({ messages: messages }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($858269b0b7dfb3e7$var$List, {
            children: messages.map((warning, index)=>{
                const key = index + warning;
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($858269b0b7dfb3e7$var$ListItem, {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($858269b0b7dfb3e7$var$Message, {
                        variant: "body",
                        size: "medium",
                        color: "$neutral700",
                        children: warning
                    })
                }, key);
            })
        })
    });
}






parcelRequire("exYeM");

const $6a79bb2ad502ec07$export$98524ae54d1a2dd3 = {
    SWAP_FROM_INPUT_CONTAINER_ID: "rango-swap-from-input-container",
    SWAP_TO_INPUT_CONTAINER_ID: "rango-swap-to-input-container",
    SWAP_FROM_CHAIN_IMAGE_ID: "rango-swap-from-chain-image",
    SWAP_TO_CHAIN_IMAGE_ID: "rango-swap-to-chain-image"
};




const $22eb5db140eeebcb$export$6a54c24d15b0f6ba = (0, $3dd421da623820a3$export$dbf350e5966cf602)();
const $22eb5db140eeebcb$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderRadius: "$xm",
    padding: "$15",
    variants: {
        sharpBottomStyle: {
            true: {
                borderBottomLeftRadius: "$0",
                borderBottomRightRadius: "$0"
            }
        }
    },
    [`& .${$22eb5db140eeebcb$export$6a54c24d15b0f6ba}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $22eb5db140eeebcb$export$35d22d5200306724 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
    width: "100%",
    padding: "0",
    fontSize: "$18",
    lineHeight: "$26",
    fontWeight: "$medium",
    textAlign: "right",
    "&:disabled": {
        cursor: "unset"
    }
});
const $22eb5db140eeebcb$export$c04ed6f11664dd90 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    $$color: "$colors$secondary200",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$secondary800"
    },
    backgroundColor: "$$color",
    "& ._typography": {
        color: "$colors$secondary500",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$colors$secondary250"
        }
    }
});
const $22eb5db140eeebcb$export$f9eb9b061a8738e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    width: "100%",
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    variants: {
        hasWarning: {
            true: {
                "& ._typography": {
                    color: "$warning500"
                }
            },
            false: {
                "& ._typography": {
                    $$color: "$colors$neutral600",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: "$colors$neutral700"
                    },
                    color: "$$color"
                }
            }
        }
    }
});
const $22eb5db140eeebcb$export$e1b615d0557d2f42 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $22eb5db140eeebcb$export$7554676c98048ec9 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $22eb5db140eeebcb$export$e87981cb53057926 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $22eb5db140eeebcb$export$5985f0c5f3c7246 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "45%",
    maxWidth: "170px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "end",
    flexGrow: 1
});
const $22eb5db140eeebcb$export$dfd5bd29dece2cc0 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    paddingBottom: "$5"
});
const $22eb5db140eeebcb$export$e446747fdf024f49 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    width: "100%",
    textAlign: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});




parcelRequire("exYeM");




const $dc8d055e0a389910$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    maxWidth: "180px",
    minWidth: "130px",
    flexGrow: 1,
    backgroundColor: "transparent",
    borderRadius: "$xs",
    color: "$neutral700",
    "&:disabled": {
        color: "$neutral600"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color !important",
        outline: 0
    },
    "&:disabled:hover": {
        backgroundColor: "transparent"
    },
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color !important",
        [`& ${0, $7c48552eddaeb4ce$export$d4931c993da6ddd}`]: {
            $$color: "$colors$secondary100",
            [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$neutral100"
            },
            backgroundColor: "$$color !important"
        }
    }
});
const $dc8d055e0a389910$export$855375d104d0e96 = (0, $3dd421da623820a3$export$dbf350e5966cf602)();
const $dc8d055e0a389910$export$b08bf0dceef77d4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    maxWidth: "170px",
    padding: "$2 $5",
    display: "flex",
    borderRadius: "$xs",
    justifyContent: "start",
    boxSizing: "border-box",
    alignItems: "center",
    [`& .${$dc8d055e0a389910$export$855375d104d0e96}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $dc8d055e0a389910$export$8f074db8fdb69212 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    paddingLeft: "$10",
    flexGrow: 1,
    textAlign: "left"
});
const $dc8d055e0a389910$export$eedc0036349bcb7b = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "100%",
    padding: "$5 $0"
});


function $2865d507fce59def$export$2cc5788f206d44e2(props) {
    const { error: error, chainImage: chainImage, tokenImage: tokenImage, tokenSymbol: tokenSymbol, chain: chain, chianImageId: chianImageId, onClick: onClick, loading: loading } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $dc8d055e0a389910$export$42a852a2b6b56249), {
        variant: "default",
        disabled: error || loading,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $dc8d055e0a389910$export$b08bf0dceef77d4), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                    chianImageId: chianImageId,
                    size: "large",
                    useAsPlaceholder: error,
                    chainImage: chainImage,
                    tokenImage: tokenImage,
                    loading: loading
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: (0, $dc8d055e0a389910$export$8f074db8fdb69212)(),
                    children: loading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: (0, $dc8d055e0a389910$export$eedc0036349bcb7b)(),
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "medium"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "title",
                                size: "medium",
                                children: error || !loading && !tokenSymbol ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Token") : tokenSymbol
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "body",
                                size: "medium",
                                className: (0, $dc8d055e0a389910$export$855375d104d0e96)(),
                                children: error || !loading && !chain ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Chain") : chain
                            })
                        ]
                    })
                })
            ]
        })
    });
}


function $b59329c443aff15a$export$c8e430728cac0e9a(props) {
    const showBalance = "balance" in props && !props.loading && !props.loadingBalance && props.token.displayName && props.anyWalletConnected;
    const showBalanceSkeleton = "balance" in props && (props.loading || props.loadingBalance);
    const price = props.price;
    const isUsdValueZeroOrFalsy = !props.price.usdValue || props.price.usdValue === "0";
    const displayUsdValue = props.price.error || (isUsdValueZeroOrFalsy ? "0.00" : `~$${props.price.usdValue}`);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $22eb5db140eeebcb$export$42a852a2b6b56249), {
        id: props.mode === "To" ? (0, $6a79bb2ad502ec07$export$98524ae54d1a2dd3).SWAP_TO_INPUT_CONTAINER_ID : (0, $6a79bb2ad502ec07$export$98524ae54d1a2dd3).SWAP_FROM_INPUT_CONTAINER_ID,
        sharpBottomStyle: props.sharpBottomStyle,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: (0, $22eb5db140eeebcb$export$dfd5bd29dece2cc0)(),
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: (0, $22eb5db140eeebcb$export$7554676c98048ec9)(),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                            variant: "body",
                            size: "small",
                            className: (0, $22eb5db140eeebcb$export$6a54c24d15b0f6ba)(),
                            children: props.label
                        }),
                        showBalance && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: (0, $22eb5db140eeebcb$export$e87981cb53057926)(),
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                    className: (0, $22eb5db140eeebcb$export$6a54c24d15b0f6ba)(),
                                    variant: "body",
                                    size: "xsmall",
                                    children: [
                                        (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Balance"),
                                        ": ",
                                        props.balance
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                    direction: "horizontal",
                                    size: 4
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $22eb5db140eeebcb$export$c04ed6f11664dd90), {
                                    variant: "default",
                                    size: "xsmall",
                                    onClick: props.onSelectMaxBalance,
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                        variant: "body",
                                        size: "xsmall",
                                        children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Max")
                                    })
                                })
                            ]
                        }),
                        showBalanceSkeleton && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: (0, $22eb5db140eeebcb$export$e87981cb53057926)(),
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                variant: "text",
                                size: "large",
                                width: 105
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: (0, $22eb5db140eeebcb$export$e1b615d0557d2f42)(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2865d507fce59def$export$2cc5788f206d44e2), {
                        chain: props.chain.displayName,
                        chianImageId: props.mode === "To" ? (0, $6a79bb2ad502ec07$export$98524ae54d1a2dd3).SWAP_TO_CHAIN_IMAGE_ID : (0, $6a79bb2ad502ec07$export$98524ae54d1a2dd3).SWAP_FROM_CHAIN_IMAGE_ID,
                        tokenSymbol: props.token.displayName,
                        error: props.error,
                        chainImage: props.chain.image,
                        tokenImage: props.token.image,
                        onClick: props.onClickToken,
                        loading: props.loading
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: (0, $22eb5db140eeebcb$export$5985f0c5f3c7246)(),
                        children: props.loading || props.mode === "To" && props.fetchingQuote ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                    variant: "text",
                                    size: "large"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                    size: 8
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                                    variant: "text",
                                    size: "medium"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                    align: "end",
                                    content: price.realValue,
                                    container: props.tooltipContainer,
                                    open: !price.realValue || price.realValue === "0" ? false : undefined,
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $22eb5db140eeebcb$export$35d22d5200306724), {
                                        disabled: props.disabled || props.mode === "To",
                                        style: {
                                            padding: 0
                                        },
                                        value: price.value,
                                        type: "onInputChange" in props ? "number" : "text",
                                        step: "any",
                                        size: "large",
                                        placeholder: "0",
                                        variant: "ghost",
                                        min: 0,
                                        ..."onInputChange" in props && {
                                            onChange: (event)=>props.onInputChange(event.target.value)
                                        }
                                    })
                                }),
                                "percentageChange" in props ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8c357132bc764382$export$7933e639b40d0e01), {
                                    size: "medium",
                                    tooltipProps: {
                                        container: props.tooltipContainer,
                                        side: "bottom"
                                    },
                                    outputUsdValue: price.usdValue,
                                    realOutputUsdValue: price.realUsdValue,
                                    error: price.error,
                                    percentageChange: props.percentageChange,
                                    warningLevel: props.warningLevel
                                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                                    content: price.realUsdValue,
                                    container: props.tooltipContainer,
                                    open: isUsdValueZeroOrFalsy ? false : undefined,
                                    side: "bottom",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $22eb5db140eeebcb$export$f9eb9b061a8738e), {
                                        hasWarning: !!price.error,
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $22eb5db140eeebcb$export$e446747fdf024f49), {
                                            variant: "body",
                                            size: "medium",
                                            children: displayUsdValue
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}







var $exYeM = parcelRequire("exYeM");




parcelRequire("exYeM");




const $81f51e45908c8fa9$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$sm",
    padding: "0 $10 $10 $10",
    width: "350px",
    maxWidth: "90vw",
    minHeight: "150px",
    maxHeight: "207px",
    overflowY: "auto",
    background: "inherit",
    variants: {
        equalPadding: {
            true: {
                padding: "$10"
            }
        }
    }
});
const $81f51e45908c8fa9$export$8b251419efc915eb = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$10 $10 0 $10",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "inherit",
    position: "sticky",
    top: "0",
    zIndex: 999
});
const $81f51e45908c8fa9$export$506070318f3da67b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    padding: "$5 !important"
});
const $81f51e45908c8fa9$export$54c2e3dc7acea9f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    padding: 0,
    margin: 0,
    listStyle: "none",
    ".to-chain-token": {
        transform: "translateX(-3px)"
    }
});
const $81f51e45908c8fa9$export$a7b06bfba60a8a78 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
    variants: {
        actionRequired: {
            true: {
                backgroundColor: "$error300",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    backgroundColor: "$error600"
                }
            }
        }
    }
});
const $81f51e45908c8fa9$export$ec7dcaac71d9599d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "0 0 0 $5",
    alignItems: "center",
    alignSelf: "stretch"
});
const $81f51e45908c8fa9$export$32fe640941018446 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "$10",
    width: "100%",
    height: "150px"
});
const $81f51e45908c8fa9$export$8f314e512d92575f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("span", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: "$8"
});


function $e67a4ac8d558afef$export$8a9c8161c98a13f3() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $81f51e45908c8fa9$export$32fe640941018446), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7c795f0e1104a290$export$2e2bcd8739ae039), {
                color: "secondary",
                size: 26
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 12
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "body",
                size: "medium",
                color: "neutral700",
                children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("There are no notifications.")
            })
        ]
    });
}



function $064ff9767570353c$export$36ba2f559d49a8f6(props) {
    const { list: list, getBlockchainImage: getBlockchainImage, getTokenImage: getTokenImage, onClickItem: onClickItem, onClearAll: onClearAll, containerStyles: containerStyles } = props;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $81f51e45908c8fa9$export$42a852a2b6b56249), {
        equalPadding: list.length === 0,
        css: containerStyles,
        children: [
            list.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $81f51e45908c8fa9$export$8b251419efc915eb), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                variant: "label",
                                size: "medium",
                                children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Notifications")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $81f51e45908c8fa9$export$506070318f3da67b), {
                                variant: "ghost",
                                size: "xsmall",
                                onClick: onClearAll,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                    variant: "body",
                                    size: "xsmall",
                                    color: "neutral700",
                                    children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Clear all")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "vertical",
                        size: 4
                    })
                ]
            }),
            list.length ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $81f51e45908c8fa9$export$54c2e3dc7acea9f5), {
                children: list.map((notificationItem, index)=>{
                    const { route: route, requestId: requestId, event: event } = notificationItem;
                    const fromTokenImage = getTokenImage(route.from);
                    const fromBlockchainImage = getBlockchainImage(route.from.blockchain);
                    const toTokenImage = getTokenImage(route.to);
                    const toBlockchainImage = getBlockchainImage(route.to.blockchain);
                    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $81f51e45908c8fa9$export$a7b06bfba60a8a78), {
                                onClick: ()=>onClickItem(requestId),
                                actionRequired: event.messageSeverity === "warning",
                                title: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                                    variant: "body",
                                    size: "small",
                                    color: event.messageSeverity === "warning" ? "$foreground" : "$neutral700",
                                    children: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(event.message)
                                }),
                                id: requestId,
                                start: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $81f51e45908c8fa9$export$ec7dcaac71d9599d), {
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                                            tokenImage: fromTokenImage,
                                            chainImage: fromBlockchainImage,
                                            size: "small"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
                                            tokenImage: toTokenImage,
                                            chainImage: toBlockchainImage,
                                            size: "small"
                                        })
                                    ]
                                }),
                                end: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $81f51e45908c8fa9$export$8f314e512d92575f), {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
                                        size: 12,
                                        color: "gray"
                                    })
                                })
                            })
                        ]
                    }, requestId);
                })
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e67a4ac8d558afef$export$8a9c8161c98a13f3), {})
        ]
    });
}









var $5261de32bd9e6742$exports = {};
"use strict";
var $5b2b91ff0bfceb9a$exports = {};
$5b2b91ff0bfceb9a$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $5261de32bd9e6742$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $5261de32bd9e6742$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $5261de32bd9e6742$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $5261de32bd9e6742$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $5b2b91ff0bfceb9a$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $5261de32bd9e6742$var$clipboardToIE11Formatting[options.format] || $5261de32bd9e6742$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $5261de32bd9e6742$var$format("message" in options ? options.message : $5261de32bd9e6742$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$5261de32bd9e6742$exports = $5261de32bd9e6742$var$copy;



var $exYeM = parcelRequire("exYeM");
function $32beb9a5973b277f$export$b2199c37e85de4a7(resetInterval) {
    const [isCopied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback((text)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($5261de32bd9e6742$exports)))(text.toString());
        setCopied(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        let timeout;
        if (isCopied && resetInterval) timeout = setTimeout(()=>setCopied(false), resetInterval);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        isCopied,
        resetInterval
    ]);
    return [
        isCopied,
        handleCopy
    ];
}









var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");
function $2f8e5b6a3ded171b$export$7df706298a2a76be(state) {
    return !!state.derivationPath;
}
function $2f8e5b6a3ded171b$export$f5d08094a802a70c(state) {
    return !!state.namespace;
}


const $2ec9712b76e0a645$export$f6196a6c6bb539b4 = {
    status: "init",
    namespace: null,
    derivationPath: null
};
function $2ec9712b76e0a645$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case "needsNamespace":
            return {
                ...state,
                status: "namespace",
                namespace: action.payload,
                derivationPath: null
            };
        case "needsDerivationPath":
            return {
                ...state,
                status: "derivationPath",
                derivationPath: action.payload
            };
        case "reset":
            return $2ec9712b76e0a645$export$f6196a6c6bb539b4;
        case "resetDerivation":
            if (state.namespace) return {
                ...state,
                derivationPath: null,
                status: "namespace"
            };
            return $2ec9712b76e0a645$export$f6196a6c6bb539b4;
        default:
            throw new Error(`Action hasn't been defined.`);
    }
}


var $610ef28624c7c1dc$export$7103a54af3e45080;
(function(ResultStatus) {
    ResultStatus["Connected"] = "connected";
    ResultStatus["Namespace"] = "namespace";
    ResultStatus["DerivationPath"] = "derivation-path";
    ResultStatus["Disconnected"] = "disconnected";
    ResultStatus["DisconnectedUnhandled"] = "disconnected-unhandled";
    ResultStatus["Noop"] = "noop";
})($610ef28624c7c1dc$export$7103a54af3e45080 || ($610ef28624c7c1dc$export$7103a54af3e45080 = {}));


function $cd10f5b2a6cbb0dc$export$bccd57329105f7af() {
    const { state: state, disconnect: disconnect, connect: connect } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const [connectState, dispatch] = (0, $exYeM.useReducer)((0, $2ec9712b76e0a645$export$1650419e431d3ba3), (0, $2ec9712b76e0a645$export$f6196a6c6bb539b4));
    const runConnect = async (type, namespaces, _options)=>{
        /*
     * When running this function, it means all optional steps (like namespace and derivation path) has passed, or wallet doesn't need them at all.
     * By resetting state, we will make sure when user tries to connect other wallets, it doesn't have unexpected states.
     */ dispatch({
            type: "reset"
        });
        try {
            await connect(type, undefined, namespaces);
            return {
                status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).Connected
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            const message = e?.message ? `Error: ${e.message}` : "An unknown error happened during connecting wallet.";
            throw new Error(message, {
                cause: e
            });
        }
    };
    const handleConnect = async (wallet, options)=>{
        const isDisconnected = wallet.state === (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED;
        if (isDisconnected) {
            if (!wallet.namespaces) return await runConnect(wallet.type, undefined, options);
            const needsNamespace = wallet.namespaces.length > 1;
            const needsDerivationPath = wallet.needsDerivationPath;
            if (needsNamespace) {
                dispatch({
                    type: "needsNamespace",
                    payload: {
                        providerType: wallet.type,
                        providerImage: wallet.image,
                        availableNamespaces: wallet.namespaces,
                        singleNamespace: wallet.singleNamespace
                    }
                });
                return {
                    status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).Namespace
                };
            } else if (needsDerivationPath) {
                dispatch({
                    type: "needsDerivationPath",
                    payload: {
                        providerType: wallet.type,
                        providerImage: wallet.image,
                        namespace: wallet.namespaces[0]
                    }
                });
                return {
                    status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).DerivationPath
                };
            }
            return await runConnect(wallet.type, wallet.namespaces.map((namespace)=>({
                    namespace: namespace
                })), options);
        }
        if (options?.disconnectIfConnected) {
            await handleDisconnect(wallet.type);
            return {
                status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).Disconnected
            };
        }
        return {
            status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).DisconnectedUnhandled
        };
    };
    const handleNamespace = async (wallet, selectedNamespaces)=>{
        const isSingleNamespace = wallet.singleNamespace;
        const needsDerivationPath = wallet.needsDerivationPath;
        const firstSelectedNamespace = selectedNamespaces[0];
        if (!firstSelectedNamespace) throw new Error("To confirm a namespace, you should select at least one namespace.");
        /*
     * Currently we support derivation path only for single namespace wallets.
     *
     * Basically Single namespace is a list with radio buttons to let the user select one value within the list.
     */ if (isSingleNamespace && needsDerivationPath) {
            dispatch({
                type: "needsDerivationPath",
                payload: {
                    providerType: wallet.type,
                    providerImage: wallet.image,
                    namespace: firstSelectedNamespace
                }
            });
            return {
                status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).DerivationPath
            };
        }
        /**
     * If execution reaches here, means we don't have any more optional step (like namespace and derivation)
     * So we should start connecting wallet.
     */ if (!(0, $2f8e5b6a3ded171b$export$f5d08094a802a70c)(connectState)) // Unreachable code.
        throw new Error("Something went wrong on handling namespace. Please retry.");
        const type = connectState.namespace.providerType;
        const namespaces = selectedNamespaces.map((namespace)=>({
                namespace: namespace
            }));
        return await runConnect(type, namespaces);
    };
    const handleDerivationPath = async (derivationPath)=>{
        if (!derivationPath) throw new Error("Derivation path is empty. Please make sure you've filled the field correctly.");
        if (!(0, $2f8e5b6a3ded171b$export$7df706298a2a76be)(connectState)) throw new Error("It seems you are filling derivation path without setting namespace before doing that. Please retry to connect.");
        const type = connectState.derivationPath.providerType;
        const selectedNamespace = connectState.derivationPath.namespace;
        const namespaces = [
            {
                namespace: selectedNamespace,
                derivationPath: derivationPath
            }
        ];
        return await runConnect(type, namespaces);
    };
    const handleDisconnect = async (type)=>{
        const wallet = state(type);
        if (wallet.connected || wallet.connecting) {
            await disconnect(type);
            return {
                status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).Disconnected
            };
        }
        return {
            status: (0, $610ef28624c7c1dc$export$7103a54af3e45080).Noop
        };
    };
    return {
        handleConnect: handleConnect,
        handleDisconnect: handleDisconnect,
        handleNamespace: handleNamespace,
        handleDerivationPath: handleDerivationPath,
        getState: ()=>connectState,
        resetState: (section)=>{
            if (section === "derivation") dispatch({
                type: "resetDerivation"
            });
            else dispatch({
                type: "reset"
            });
        }
    };
}







parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
var $yEwlv = parcelRequire("yEwlv");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c84578bb05928dc5$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $c84578bb05928dc5$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($c84578bb05928dc5$import_meta.env ? $c84578bb05928dc5$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
const $c84578bb05928dc5$export$f51a9068ac82ea43 = (createState)=>createState ? $c84578bb05928dc5$var$createStoreImpl(createState) : $c84578bb05928dc5$var$createStoreImpl;
var $c84578bb05928dc5$export$2e2bcd8739ae039 = (createState)=>{
    if (($c84578bb05928dc5$import_meta.env ? $c84578bb05928dc5$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $c84578bb05928dc5$export$f51a9068ac82ea43(createState);
};



var $exYeM = parcelRequire("exYeM");
var $e0448e6874efea69$exports = {};
"use strict";

$e0448e6874efea69$exports = (parcelRequire("eXtb5"));


var $deedc9bfbd0dc16c$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $deedc9bfbd0dc16c$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
const { useSyncExternalStoreWithSelector: $deedc9bfbd0dc16c$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($e0448e6874efea69$exports)));
let $deedc9bfbd0dc16c$var$didWarnAboutEqualityFn = false;
function $deedc9bfbd0dc16c$export$6ccbb43953eebf8(api, selector = api.getState, equalityFn) {
    if (($deedc9bfbd0dc16c$import_meta.env ? $deedc9bfbd0dc16c$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$deedc9bfbd0dc16c$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $deedc9bfbd0dc16c$var$didWarnAboutEqualityFn = true;
    }
    const slice = $deedc9bfbd0dc16c$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $deedc9bfbd0dc16c$var$useDebugValue(slice);
    return slice;
}
const $deedc9bfbd0dc16c$var$createImpl = (createState)=>{
    if (($deedc9bfbd0dc16c$import_meta.env ? $deedc9bfbd0dc16c$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $c84578bb05928dc5$export$f51a9068ac82ea43)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$deedc9bfbd0dc16c$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $deedc9bfbd0dc16c$export$185802fd694ee1f5 = (createState)=>createState ? $deedc9bfbd0dc16c$var$createImpl(createState) : $deedc9bfbd0dc16c$var$createImpl;
var $deedc9bfbd0dc16c$export$2e2bcd8739ae039 = (createState)=>{
    if (($deedc9bfbd0dc16c$import_meta.env ? $deedc9bfbd0dc16c$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $deedc9bfbd0dc16c$export$185802fd694ee1f5(createState);
};


var $3ed31f3dd58f2a20$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $3ed31f3dd58f2a20$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $3ed31f3dd58f2a20$export$4feba8a1bc8e9afd = $3ed31f3dd58f2a20$var$reduxImpl;
const $3ed31f3dd58f2a20$var$trackedConnections = /* @__PURE__ */ new Map();
const $3ed31f3dd58f2a20$var$getTrackedConnectionState = (name)=>{
    const api = $3ed31f3dd58f2a20$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $3ed31f3dd58f2a20$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $3ed31f3dd58f2a20$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $3ed31f3dd58f2a20$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $3ed31f3dd58f2a20$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($3ed31f3dd58f2a20$import_meta.env ? $3ed31f3dd58f2a20$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($3ed31f3dd58f2a20$import_meta.env ? $3ed31f3dd58f2a20$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $3ed31f3dd58f2a20$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$3ed31f3dd58f2a20$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($3ed31f3dd58f2a20$import_meta.env ? $3ed31f3dd58f2a20$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $3ed31f3dd58f2a20$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($3ed31f3dd58f2a20$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($3ed31f3dd58f2a20$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $3ed31f3dd58f2a20$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($3ed31f3dd58f2a20$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $3ed31f3dd58f2a20$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $3ed31f3dd58f2a20$export$6922d3b3a607469e = $3ed31f3dd58f2a20$var$devtoolsImpl;
const $3ed31f3dd58f2a20$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $3ed31f3dd58f2a20$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $3ed31f3dd58f2a20$export$5c593627aef9f076 = $3ed31f3dd58f2a20$var$subscribeWithSelectorImpl;
const $3ed31f3dd58f2a20$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $3ed31f3dd58f2a20$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $3ed31f3dd58f2a20$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $3ed31f3dd58f2a20$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $3ed31f3dd58f2a20$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $3ed31f3dd58f2a20$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $3ed31f3dd58f2a20$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $3ed31f3dd58f2a20$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $3ed31f3dd58f2a20$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $3ed31f3dd58f2a20$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $3ed31f3dd58f2a20$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $3ed31f3dd58f2a20$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($3ed31f3dd58f2a20$import_meta.env ? $3ed31f3dd58f2a20$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $3ed31f3dd58f2a20$var$oldImpl(config, baseOptions);
    }
    return $3ed31f3dd58f2a20$var$newImpl(config, baseOptions);
};
const $3ed31f3dd58f2a20$export$9a6132153fba2e0 = $3ed31f3dd58f2a20$var$persistImpl;


class $8ff437adffe9ce26$var$CacheService {
    #cache;
    get(key) {
        return this.#cache.get(key);
    }
    set(key, value) {
        this.#cache.set(key, value);
    }
    remove(key) {
        this.#cache.delete(key);
    }
    clear() {
        this.#cache.clear();
    }
    constructor(){
        this.#cache = new Map();
    }
}
const $8ff437adffe9ce26$export$eb7bed8a914fcd26 = new $8ff437adffe9ce26$var$CacheService();


function $76ee130e8dc1847d$export$96fcfd2cb226eb33(blockchainName, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.displayName;
}
function $76ee130e8dc1847d$export$88c49d2c18237b4a(blockchainName, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.shortName;
}
function $76ee130e8dc1847d$export$3f940559f33e83a0(blockchainName, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.logo;
}
function $76ee130e8dc1847d$export$1fea59066bd06abd(swapperId, swappers) {
    return swappers.find((swapper)=>swapper.id === swapperId)?.title;
}
function $76ee130e8dc1847d$export$b20204be864cdab1(name, blockchains) {
    return blockchains.find((blockchain)=>blockchain.name === name) ?? null;
}
function $76ee130e8dc1847d$export$3fb5fac5f0bb937f(token, blockchain) {
    if (!blockchain || !token) return false;
    for (const feeAsset of blockchain.feeAssets){
        if (token?.blockchain === feeAsset?.blockchain && token?.symbol === feeAsset?.symbol && token?.address === feeAsset?.address) return true;
    }
    return false;
}
function $76ee130e8dc1847d$export$a7b26387fecb5183(asset) {
    return `${asset.blockchain.toLowerCase()}-${asset.symbol.toLowerCase()}-${(asset.address ?? "").toLowerCase()}`;
}
function $76ee130e8dc1847d$export$e331c843472783ec(chain, address) {
    const regex = chain.addressPatterns;
    const valid = regex.filter((r)=>new RegExp(r).test(address)).length > 0;
    return valid;
}


function $661f04ba9c1c4c68$export$3c912d2df882aeb8(params) {
    const { config: config, meta: meta } = params;
    const result = {};
    const configTokens = config.tokens;
    // Helper function to add tokens to result
    const addTokens = (tokens)=>{
        tokens.forEach((item)=>{
            if (typeof item !== "string") item = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(item);
            const tokenFromMeta = meta.tokensMapByTokenHash.get(item);
            if (tokenFromMeta) result[item] = tokenFromMeta;
        });
    };
    /**
   * We support two types of configurations for passing tokens in the widget config.
   * We check the type of configuration and calculate the result based on that.
   */ if (Array.isArray(configTokens)) {
        /**
     * If "config.tokens" is an array,
     * we iterate through it and include any token that exists in the meta data in the result.
     */ if (configTokens.length > 0) {
            addTokens(configTokens);
            return Object.values(result);
        }
        return Array.from(meta.tokensMapByTokenHash.values());
    }
    /**
   * From this point onward,
   * the function handles the other type of widget configuration.
   */ if (!configTokens) return Array.from(meta.tokensMapByTokenHash.values());
    let configBlockchains;
    if (config.blockchains?.length) configBlockchains = config.blockchains;
    else {
        /**
     * If config.blockchains does not exist,
     * we include all tokens from every blockchain in the meta data that are not specified in the tokens from the config.
     */ configBlockchains = Object.keys(configTokens);
        const configBlockchainsSet = new Set(configBlockchains);
        Object.keys(meta.tokensMapByBlockchainName).forEach((blockchain)=>{
            if (!configBlockchainsSet.has(blockchain)) addTokens(meta.tokensMapByBlockchainName[blockchain]);
        });
    }
    //We iterate over each blockchain and retrieve the related tokens for each one from the configuration.
    configBlockchains.forEach((blockchain)=>{
        const targetTokensForBlockchain = configTokens[blockchain];
        /**
     * If no tokens exist for a blockchain,
     * we include all tokens for that blockchain from the meta response.
     */ if (!targetTokensForBlockchain && meta.tokensMapByBlockchainName?.[blockchain]) {
            addTokens(meta.tokensMapByBlockchainName[blockchain]);
            return;
        }
        if (targetTokensForBlockchain) {
            if (targetTokensForBlockchain.isExcluded) {
                /**
         * If tokens are excluded,
         * we first include all tokens from the meta for that blockchain,
         * then remove the excluded tokens from the result.
         */ addTokens(meta.tokensMapByBlockchainName[blockchain]);
                targetTokensForBlockchain.tokens.forEach((token)=>{
                    const tokenHash = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(token);
                    delete result[tokenHash];
                });
            } else //We retrieve the corresponding token from the meta and include it in the result.
            addTokens(targetTokensForBlockchain.tokens);
        }
    });
    return Object.values(result);
}
function $661f04ba9c1c4c68$export$31ae555fa3cd9613(params) {
    const { config: config } = params;
    const configFromBlockchains = config.from?.blockchains || [];
    const configToBlockchains = config.to?.blockchains || [];
    /*
   * Empty array means all blockchains. So if any of to or from has an empty array,
   * it means all blockchains is available to use and there is no limitation from config.
   */ if (!configFromBlockchains.length || !configToBlockchains.length) return [];
    const blockchains = [
        ...configFromBlockchains,
        ...configToBlockchains
    ];
    const supportedBlockchains = new Set(blockchains);
    return Array.from(supportedBlockchains);
}




const $b05f972a7e8c18b1$export$c2f8e0cc249a8d8f = {
    apiKey: "",
    title: undefined,
    multiWallets: true,
    excludeLiquiditySources: true,
    customDestination: true,
    variant: "default",
    trezorManifest: {
        appUrl: "https://widget.rango.exchange/",
        email: "hi+trezorwidget@rango.exchange"
    }
};
const $b05f972a7e8c18b1$var$DEFAULT_IFRAME_CONFIGS = {
    clientUrl: undefined
};
const $b05f972a7e8c18b1$var$DEFAULT_CAMPAIGN_MODE = {
    liquiditySources: undefined
};
const $b05f972a7e8c18b1$export$50436c4ddffbe408 = (initialData, set, get)=>{
    return {
        config: {
            ...$b05f972a7e8c18b1$export$c2f8e0cc249a8d8f,
            ...initialData
        },
        iframe: $b05f972a7e8c18b1$var$DEFAULT_IFRAME_CONFIGS,
        campaignMode: $b05f972a7e8c18b1$var$DEFAULT_CAMPAIGN_MODE,
        getLiquiditySources: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? campaignMode.liquiditySources : config.liquiditySources ?? [];
        },
        getDisabledLiquiditySources: ()=>{
            const { disabledLiquiditySources: disabledLiquiditySources, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? [] : disabledLiquiditySources;
        },
        excludeLiquiditySources: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            return campaignMode.liquiditySources?.length ? false : !!config.excludeLiquiditySources;
        },
        isInCampaignMode: ()=>{
            const { campaignMode: campaignMode } = get();
            return !!campaignMode.liquiditySources?.length;
        },
        // Actions
        updateConfig: (nextConfig)=>{
            const currentConfig = get().config;
            const { _tokensMapByTokenHash: tokensMapByTokenHash, _tokensMapByBlockchainName: tokensMapByBlockchainName } = get();
            const supportedSourceTokens = (0, $661f04ba9c1c4c68$export$3c912d2df882aeb8)({
                type: "source",
                config: {
                    blockchains: nextConfig.from?.blockchains,
                    tokens: nextConfig.from?.tokens
                },
                meta: {
                    tokensMapByBlockchainName: tokensMapByBlockchainName,
                    tokensMapByTokenHash: tokensMapByTokenHash
                }
            });
            const supportedDestinationTokens = (0, $661f04ba9c1c4c68$export$3c912d2df882aeb8)({
                type: "destination",
                config: {
                    blockchains: nextConfig.to?.blockchains,
                    tokens: nextConfig.to?.tokens
                },
                meta: {
                    tokensMapByBlockchainName: tokensMapByBlockchainName,
                    tokensMapByTokenHash: tokensMapByTokenHash
                }
            });
            (0, $8ff437adffe9ce26$export$eb7bed8a914fcd26).set("supportedSourceTokens", supportedSourceTokens);
            (0, $8ff437adffe9ce26$export$eb7bed8a914fcd26).set("supportedDestinationTokens", supportedDestinationTokens);
            set({
                config: {
                    ...currentConfig,
                    ...nextConfig
                }
            });
        },
        updateCampaignMode: (name, value)=>{
            const currentCampaignMode = get().campaignMode;
            set({
                campaignMode: {
                    ...currentCampaignMode,
                    [name]: value
                }
            });
        },
        updateIframe: (name, value)=>{
            const currentIframeConfig = get().iframe;
            set({
                iframe: {
                    ...currentIframeConfig,
                    [name]: value
                }
            });
        }
    };
};


// We keep all the received data from server in this slice
parcelRequire("14sfz");
var $liigz = parcelRequire("liigz");
const $1d6046c6e2456fc7$export$610275bb3c85e71b = [
    (0, $liigz.TransactionType).EVM,
    (0, $liigz.TransactionType).SOLANA
];





const $81cb43aa4aa5ed51$export$807e570e9765ba53 = "c6381a79-2817-4602-83bf-6a641a409e32";
const $81cb43aa4aa5ed51$export$6554e0e4e82f1b3a = "https://api.rango.exchange";
const $81cb43aa4aa5ed51$export$be3862c5a1fc6346 = "https://explorer.rango.exchange";
const $81cb43aa4aa5ed51$export$e701ab3081df299 = {
    SWAP_BOX_ID: "rango-swap-box",
    EXPANDED_BOX_ID: "rango-expanded-box",
    ...(0, $6a79bb2ad502ec07$export$98524ae54d1a2dd3)
};




var $8aS14 = parcelRequire("8aS14");
parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
var $jN5Ze = parcelRequire("jN5Ze");
var $B8faE = parcelRequire("B8faE");
var $yEwlv = parcelRequire("yEwlv");
var $8aS14 = parcelRequire("8aS14");

var $76r4H = parcelRequire("76r4H");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $76r4H = parcelRequire("76r4H");
const $fdd69898c00c1ed2$export$2a1795c9359f92b9 = new (0, $76r4H.default)(0);


const $189a5d7f52888885$export$758a3860814b1a7f = -3;
const $189a5d7f52888885$export$de21a634bd33d85f = -10;
const $189a5d7f52888885$export$ef691c67d4b820e1 = 6;
const $189a5d7f52888885$export$67f38c76b6d12b6f = 6;
const $189a5d7f52888885$export$40c7c9ebb925aa59 = 4;
const $189a5d7f52888885$export$b95c92fdaeee061 = 4;
const $189a5d7f52888885$export$2c13d6fe7cdf779a = 2;
const $189a5d7f52888885$export$d6d8c6e2c799e13f = 2;
const $189a5d7f52888885$export$14448384d530389b = 2;
const $189a5d7f52888885$export$9ec1967a1af30315 = 2;
const $189a5d7f52888885$export$d562bc219e0ce311 = 8;
const $189a5d7f52888885$export$971432a7539c584e = 8;


parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");
const $ed01ca0149c753c3$export$255aaf0ca58ac083 = [
    (0, $yEwlv.WalletTypes).LEAP
];





const $0113bd1bc94a323f$export$2653e0d5dd45b294 = "Roboto";
const $0113bd1bc94a323f$export$4537c0415897d658 = [
    {
        name: "Roboto",
        value: "Roboto",
        url: ""
    },
    {
        name: "Times New Roman",
        value: "Times New Roman",
        url: "https://fonts.cdnfonts.com/css/times-new-roman"
    },
    {
        name: "Arial",
        value: "Arial",
        url: ""
    },
    {
        name: "Open Sans",
        value: "Open Sans",
        url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap"
    },
    {
        name: "Noto Sans",
        value: "Noto Sans",
        url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
    },
    {
        name: "Montserrat",
        value: "Montserrat",
        url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap"
    },
    {
        name: "Poppins",
        value: "Poppins",
        url: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
    },
    {
        name: "Roboto Condensed",
        value: "Roboto Condensed",
        url: "https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap"
    },
    {
        name: "Roboto Mono",
        value: "Roboto Mono",
        url: "https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap"
    },
    {
        name: "Oswald",
        value: "Oswald",
        url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap"
    },
    {
        name: "Raleway",
        value: "Raleway",
        url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap"
    },
    {
        name: "Sedan",
        value: "Sedan",
        url: "https://fonts.googleapis.com/css2?family=Sedan:ital@0;1&display=swap"
    },
    {
        name: "Inter",
        value: "Inter",
        url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
    },
    {
        name: "Rubik",
        value: "Rubik",
        url: "https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap"
    },
    {
        name: "Lora",
        value: "Lora",
        url: "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400..700;1,400..700&display=swap"
    },
    {
        name: "Barlow Condensed",
        value: "Barlow Condensed",
        url: "https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
    }
];


const $0e20811c075a8b88$export$d80c3e6bc74dd784 = 1;
const $0e20811c075a8b88$export$52001b3a8252841f = 2;
const $0e20811c075a8b88$export$6871e15ec823b824 = 3;
const $0e20811c075a8b88$export$903cf51fd956ce7c = 3;
const $0e20811c075a8b88$export$9aa0933711079985 = 3;
const $0e20811c075a8b88$export$42b12693c1953a5f = 4;


function $7c74207847ca6a20$export$bbb516152e3c2c05(array) {
    return Array.from(new Set(array));
}
function $7c74207847ca6a20$export$b141efd0b0fb9174(array1, array2) {
    return array1.length === array2.length && array1.every((v, i)=>v === array2[i]);
}
function $7c74207847ca6a20$export$61fc7d43ac8f84b0(fn, time) {
    let timeoutId;
    return wrapper;
    function wrapper(...args) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            fn(...args);
        }, time);
    }
}
function $7c74207847ca6a20$export$949cdd5cc1255afe(text, searchText) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}
function $7c74207847ca6a20$export$d37420fd4f3f3972(text, searchText) {
    return text.toLowerCase() === searchText.toLowerCase();
}
function $7c74207847ca6a20$export$befa03c7b4e7be8a(text, searchText) {
    return text.toLowerCase().startsWith(searchText.toLowerCase());
}
const $7c74207847ca6a20$export$49f5bf502122d4f7 = ()=>document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID);
const $7c74207847ca6a20$export$536dc91e674be53 = ()=>document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).EXPANDED_BOX_ID);
function $7c74207847ca6a20$var$compareExactMatchText(searchFor, textA, textB) {
    const exactMatchA = !!textA && $7c74207847ca6a20$export$d37420fd4f3f3972(textA, searchFor);
    const exactMatchB = !!textB && $7c74207847ca6a20$export$d37420fd4f3f3972(textB, searchFor);
    if (exactMatchA !== exactMatchB) return exactMatchA ? -1 : 1;
    return 0;
}
function $7c74207847ca6a20$var$compareContainsText(searchFor, textA, textB) {
    const textContainsA = !!textA && $7c74207847ca6a20$export$949cdd5cc1255afe(textA, searchFor);
    const textContainsB = !!textB && $7c74207847ca6a20$export$949cdd5cc1255afe(textB, searchFor);
    if (textContainsA !== textContainsB) return textContainsA ? -1 : 1;
    // If both texts contains the searched term, The shorter one has priority
    if (textContainsA && textContainsB && textA?.length !== textB?.length) return textA?.length - textB?.length;
    return 0;
}
function $7c74207847ca6a20$var$compareStartWithText(searchFor, textA, textB) {
    const textStartWithA = !!textA && $7c74207847ca6a20$export$befa03c7b4e7be8a(textA, searchFor);
    const textStartWithB = !!textB && $7c74207847ca6a20$export$befa03c7b4e7be8a(textB, searchFor);
    if (textStartWithA !== textStartWithB) return textStartWithA ? -1 : 1;
    // If both texts start with the searched term, The shorter one has priority
    if (textStartWithA && textStartWithB && textA?.length !== textB?.length) return textA?.length - textB?.length;
    return 0;
}
function $7c74207847ca6a20$export$38315dd14f917da8(tokenA, tokenB, searchFor) {
    if (!searchFor) return 0;
    // 1: Check the order to exact match the symbol
    const symbolExactMatchCompare = $7c74207847ca6a20$var$compareExactMatchText(searchFor, tokenA.symbol, tokenB.symbol);
    if (symbolExactMatchCompare) return symbolExactMatchCompare;
    // 2: Check the order to exact match the token name
    if (searchFor.length >= (0, $0e20811c075a8b88$export$903cf51fd956ce7c)) {
        const tokenNameExactMatchCompare = $7c74207847ca6a20$var$compareExactMatchText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameExactMatchCompare) return tokenNameExactMatchCompare;
    }
    // 3: Check symbol start with searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$52001b3a8252841f)) {
        const symbolStartWithCompare = $7c74207847ca6a20$var$compareStartWithText(searchFor, tokenA.symbol, tokenB.symbol);
        if (symbolStartWithCompare) return symbolStartWithCompare;
    }
    // 4: Check symbol Contains searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$6871e15ec823b824)) {
        const symbolContainsCompare = $7c74207847ca6a20$var$compareContainsText(searchFor, tokenA.symbol, tokenB.symbol);
        if (symbolContainsCompare) return symbolContainsCompare;
    }
    // 5: Check token name start with searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$9aa0933711079985)) {
        const tokenNameStartWithCompare = $7c74207847ca6a20$var$compareStartWithText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameStartWithCompare) return tokenNameStartWithCompare;
    }
    // 6: Check token name Contains searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$9aa0933711079985)) {
        const tokenNameContainsCompare = $7c74207847ca6a20$var$compareContainsText(searchFor, tokenA.name, tokenB.name);
        if (tokenNameContainsCompare !== 0) return tokenNameContainsCompare;
    }
    // 7: Check address start with searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$42b12693c1953a5f)) {
        const addressStartWithCompare = $7c74207847ca6a20$var$compareStartWithText(searchFor, tokenA.address, tokenB.address);
        if (addressStartWithCompare) return addressStartWithCompare;
    }
    // 8: Check address Contains searchFor
    if (searchFor.length >= (0, $0e20811c075a8b88$export$42b12693c1953a5f)) {
        const addressContainCompare = $7c74207847ca6a20$var$compareContainsText(searchFor, tokenA.address, tokenB.address);
        if (addressContainCompare !== 0) return addressContainCompare;
    }
    return 0;
}
const $7c74207847ca6a20$export$3f79ee9344f436da = (blockchainType, category)=>{
    switch(category){
        case (0, $361160a0016c9549$export$55324dbe813607bf).ALL:
            return true;
        case (0, $361160a0016c9549$export$55324dbe813607bf).UTXO:
            return blockchainType === (0, $e0809f1f0dfba620$export$d513b00599f845d4).TRANSFER;
        case (0, $361160a0016c9549$export$55324dbe813607bf).OTHER:
            return blockchainType !== (0, $e0809f1f0dfba620$export$d513b00599f845d4).TRANSFER && blockchainType !== (0, $e0809f1f0dfba620$export$d513b00599f845d4).COSMOS && blockchainType !== (0, $e0809f1f0dfba620$export$d513b00599f845d4).EVM;
        default:
            return blockchainType === category;
    }
};
const $7c74207847ca6a20$export$7a6d663e4a815381 = (fontName)=>{
    const font = (0, $0113bd1bc94a323f$export$4537c0415897d658).find((font)=>font.value === fontName);
    return font?.url;
};
function $7c74207847ca6a20$export$23e4659a2fa50df7(wallets, multiWallets) {
    const atLeastOneWalletIsConnected = !!wallets.find((w)=>w.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED);
    return multiWallets === false && atLeastOneWalletIsConnected;
}



/* eslint-disable @typescript-eslint/no-magic-numbers */ 
var $76r4H = parcelRequire("76r4H");
const $63fc48ac3256c035$export$448e1c9b3b4c9054 = (s)=>{
    const seconds = Math.floor(s % 60 / 15) * 15;
    const minutes = parseInt((s / 60).toString());
    if (minutes >= 60) return `${Math.floor(minutes / 5) * 5}:00`;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};
const $63fc48ac3256c035$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null || number === undefined) return "";
    if (number === "") return "";
    const n = new (0, $76r4H.BigNumber)(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, $76r4H.BigNumber)(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++){
        if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    }
    if (n.isEqualTo(0)) return "0";
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};
const $63fc48ac3256c035$export$c44b02fb03dbac82 = (buffer)=>{
    // buffer is an ArrayBuffer
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return [
        ...buffer
    ].map((x)=>x.toString(16).padStart(2, "0")).join("");
};
const $63fc48ac3256c035$export$b325637b88286521 = (data)=>data?.reduce((a, b)=>a + (b.estimatedTimeInSeconds ?? 0), 0) || 0;
const $63fc48ac3256c035$export$46f9cdbce9dbecaf = (data)=>(data?.result?.swaps?.flatMap((s)=>s.fee.map((f)=>({
                swapperId: s.swapperId,
                fee: f
            }))) || []).reduce((partialSum, a)=>partialSum + parseFloat(a.fee.amount), 0).toFixed(3);
const $63fc48ac3256c035$export$949cdd5cc1255afe = (text, searchText)=>text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
const $63fc48ac3256c035$export$5374bb854d0e41c8 = (text)=>!!text && parseFloat(text) > 0;


function $b27897cbc1e94793$export$6907ce8795f5a4df(state) {
    switch(true){
        case state.connected:
            return (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED;
        case state.connecting:
            return (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING;
        case !state.installed:
            return (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED;
        default:
            return (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED;
    }
}
function $b27897cbc1e94793$export$5a0148b6bada75e0(getState, getWalletInfo, list, chain) {
    return list.filter((wallet)=>!(0, $ed01ca0149c753c3$export$255aaf0ca58ac083).includes(wallet)).filter((wallet)=>{
        const { supportedChains: supportedChains, isContractWallet: isContractWallet } = getWalletInfo(wallet);
        const { installed: installed, network: network } = getState(wallet);
        const filterContractWallets = isContractWallet && (!installed || !!chain && network !== chain);
        if (filterContractWallets) return false;
        if (chain) return !!supportedChains.find((supportedChain)=>supportedChain.name === chain);
        return true;
    }).map((type)=>{
        const { name: name, img: image, installLink: installLink, showOnMobile: showOnMobile, namespaces: namespaces, singleNamespace: singleNamespace, supportedChains: supportedChains, needsDerivationPath: needsDerivationPath } = getWalletInfo(type);
        const blockchainTypes = (0, $7c74207847ca6a20$export$bbb516152e3c2c05)(supportedChains.map((item)=>item.type));
        const state = $b27897cbc1e94793$export$6907ce8795f5a4df(getState(type));
        return {
            title: name,
            image: image,
            link: (0, $7aYgM.detectInstallLink)(installLink),
            state: state,
            type: type,
            showOnMobile: showOnMobile,
            namespaces: namespaces,
            singleNamespace: singleNamespace,
            blockchainTypes: blockchainTypes,
            needsDerivationPath: needsDerivationPath
        };
    });
}
function $b27897cbc1e94793$export$ac0949be5bbc1b7e(supportedBlockchains) {
    if (!supportedBlockchains) return null;
    let walletAndSupportedChainsNames = [];
    walletAndSupportedChainsNames = supportedBlockchains.map((blockchainMeta)=>blockchainMeta.name);
    return walletAndSupportedChainsNames;
}
function $b27897cbc1e94793$export$468dee0f603364f(wallet, accounts, evmBasedChains, supportedChainNames, isContractWallet) {
    const result = [];
    function addAccount(network, address) {
        const accountForChainAlreadyExists = !!result.find((account)=>account.chain === network);
        if (!accountForChainAlreadyExists) {
            const newAccount = {
                address: address,
                chain: network,
                walletType: wallet
            };
            result.push(newAccount);
        }
    }
    const supportedBlockchains = supportedChainNames || [];
    accounts.forEach((account)=>{
        const { address: address, network: network } = (0, $8aS14.legacyReadAccountAddress)(account);
        const hasLimitation = supportedBlockchains.length > 0;
        const isSupported = supportedBlockchains.includes(network);
        const isUnknown = network === (0, $8aS14.LegacyNetworks).Unknown;
        const notSupportedNetworkByWallet = hasLimitation && !isSupported && !isUnknown;
        /*
     * Here we check given `network` is not supported by wallet
     * And also the network is known.
     */ if (notSupportedNetworkByWallet) return;
        /*
     * In some cases we can handle unknown network by checking its address
     * pattern and act on it.
     * Example: showing our evm compatible network when the unknown network is evm.
     * Otherwise, we stop executing this function.
     */ const isUnknownAndEvmBased = network === (0, $8aS14.LegacyNetworks).Unknown && (0, $B8faE.isAddress)(address);
        if (isUnknown && !isUnknownAndEvmBased) return;
        const isEvmBasedChain = evmBasedChains.includes(network);
        // If it's an evm network, we will add the address to all the evm chains.
        if (isEvmBasedChain || isUnknownAndEvmBased) {
            if (isContractWallet) /*
         * for contract wallets like Safe wallet, we should add only account for the
         * current connected blockchain not all of the supported blockchains
         */ addAccount(network, address.toLowerCase());
            else {
                /*
         * all evm chains are not supported in wallets, so we are adding
         * only to those that are supported by wallet.
         */ const evmChainsSupportedByWallet = supportedBlockchains.filter((chain)=>evmBasedChains.includes(chain));
                evmChainsSupportedByWallet.forEach((network)=>{
                    /*
           * EVM addresses are not case sensitive.
           * Some wallets like Binance-chain return some letters in uppercase which produces bugs in our wallet state.
           */ addAccount(network, address.toLowerCase());
                });
            }
        } else addAccount(network, address);
    });
    return result;
}
function $b27897cbc1e94793$export$eb1ab48c3aa3d9f2(params) {
    const { filter: filter, quote: quote } = params;
    const wallets = new Set();
    quote?.swaps.forEach((swap, swapIndex)=>{
        const currentStepFromBlockchain = swap.from.blockchain;
        const currentStepToBlockchain = swap.to.blockchain;
        wallets.add(currentStepFromBlockchain);
        // Check if internalSwaps array exists
        if (swap.internalSwaps) {
            const { internalSwaps: internalSwaps } = swap;
            internalSwaps.forEach((internalSwap, internalSwapIndex)=>{
                const internalStepFromBlockchain = internalSwap.from.blockchain;
                const internalStepToBlockchain = internalSwap.to.blockchain;
                const isLastStep = swapIndex === quote.swaps.length - 1;
                const isLastInternalStep = internalSwapIndex === internalSwaps.length - 1;
                if (!isLastStep && !isLastInternalStep || isLastStep && currentStepToBlockchain !== internalStepFromBlockchain || filter === "all") wallets.add(internalStepFromBlockchain);
                if (filter === "all") wallets.add(internalStepToBlockchain);
            });
        }
        if (filter === "all") wallets.add(currentStepToBlockchain);
    });
    return Array.from(wallets);
}
function $b27897cbc1e94793$export$f9a87ee1a616fb86(account, connectedWallet) {
    return account.address === connectedWallet.address && account.chain === connectedWallet.chain && account.walletType === connectedWallet.walletType;
}
function $b27897cbc1e94793$export$2f738d191cb8cc64(retrievedBalance, findToken) {
    const { blockChain: chain, balances: balances = [] } = retrievedBalance;
    return balances?.map((tokenBalance)=>({
            chain: chain,
            symbol: tokenBalance.asset.symbol,
            ticker: tokenBalance.asset.symbol,
            address: tokenBalance.asset.address || null,
            rawAmount: tokenBalance.amount.amount,
            decimal: tokenBalance.amount.decimals,
            amount: new (0, $76r4H.default)(tokenBalance.amount.amount).shiftedBy(-tokenBalance.amount.decimals).toFixed(),
            logo: "",
            usdPrice: findToken(tokenBalance.asset)?.usdPrice || null
        })) || [];
}
function $b27897cbc1e94793$export$c537abfa9eefe515(connectedWallet) {
    return {
        ...connectedWallet,
        loading: false,
        error: true
    };
}
const $b27897cbc1e94793$export$bb973fd3adad4d0d = (connectedWallet)=>{
    const uniqueAccountAddresses = new Set();
    const uniqueBalance = connectedWallet?.reduce((acc, current)=>{
        return acc.findIndex((i)=>i.address === current.address && i.chain === current.chain) === -1 ? [
            ...acc,
            current
        ] : acc;
    }, []);
    const modifiedWalletBlockchains = uniqueBalance?.map((chain)=>{
        const modifiedWalletBlockchain = {
            name: chain.chain,
            accounts: []
        };
        if (!uniqueAccountAddresses.has(chain.address)) uniqueAccountAddresses.add(chain.address);
        uniqueAccountAddresses.forEach((accountAddress)=>{
            if (chain.address === accountAddress) modifiedWalletBlockchain.accounts.push(chain);
        });
        return modifiedWalletBlockchain;
    });
    const total = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(modifiedWalletBlockchains?.flatMap((b)=>b.accounts)?.flatMap((a)=>a?.balances)?.map((b)=>new (0, $76r4H.default)(b?.amount || (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)).multipliedBy(b?.usdPrice || 0))?.reduce((a, b)=>a.plus(b), (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)) || (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)).toString();
    return $b27897cbc1e94793$var$numberWithThousandSeparator(total);
};
function $b27897cbc1e94793$var$numberWithThousandSeparator(number) {
    const parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}
const $b27897cbc1e94793$export$61051f1588e51c47 = (blockchains, wallet)=>{
    const cosmosExperimentalChainInfo = (0, $jN5Ze.getCosmosExperimentalChainInfo)(Object.entries(blockchains).map(([, blockchainMeta])=>blockchainMeta).filter((0, $21GQj.isCosmosBlockchain)));
    return cosmosExperimentalChainInfo && cosmosExperimentalChainInfo[wallet]?.experimental;
};
const $b27897cbc1e94793$export$cf971e7e19573484 = (selectableWallets)=>{
    const connectedWalletTypes = new Set(selectableWallets.map((wallet)=>{
        return wallet.walletType;
    }));
    return (0, $yEwlv.KEPLR_COMPATIBLE_WALLETS).filter((compatibleWallet)=>connectedWalletTypes.has(compatibleWallet));
};
function $b27897cbc1e94793$export$cc3bc0b518c1c6b8(balance) {
    const formattedBalance = balance ? {
        ...balance,
        amount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(balance.amount, (0, $189a5d7f52888885$export$d562bc219e0ce311), (0, $189a5d7f52888885$export$971432a7539c584e)),
        usdValue: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(balance.usdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061))
    } : null;
    return formattedBalance;
}
function $b27897cbc1e94793$export$2d6073c6441ad1f9(token1Balance, token2Balance) {
    if (token1Balance?.usdValue || token2Balance?.usdValue) return parseFloat(token2Balance?.usdValue || "0") - parseFloat(token1Balance?.usdValue || "0");
    if (token1Balance?.amount || token2Balance?.amount) return parseFloat(token2Balance?.amount || "0") - parseFloat(token1Balance?.amount || "0");
    return 0;
}
function $b27897cbc1e94793$export$74c4c3613ff7e484(tokenA, tokenB) {
    return tokenA?.blockchain === tokenB?.blockchain && tokenA?.symbol.toLowerCase() === tokenB?.symbol.toLowerCase() && tokenA?.address?.toLowerCase() === tokenB?.address?.toLowerCase();
}
function $b27897cbc1e94793$export$b93ff9484ececcd0(wallets) {
    return wallets.sort((a, b)=>Number(b.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED) - Number(a.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED) || Number(b.state === (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED || b.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING) - Number(a.state === (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED || a.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING));
}
function $b27897cbc1e94793$export$ebc397f3c3118f9b(address, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
maxChars = 8, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
ellipsisLength = 3) {
    if (address.length < 2 * maxChars + ellipsisLength) return address;
    const start = address.slice(0, maxChars);
    const end = address.slice(-maxChars);
    return `${start}${".".repeat(ellipsisLength)}${end}`;
}
function $b27897cbc1e94793$export$88411125f012957a({ chain: chain, connectedWallets: connectedWallets, walletType: walletType }) {
    return connectedWallets.find((connectedWallet)=>connectedWallet.walletType === walletType && connectedWallet.chain === chain)?.address;
}
function $b27897cbc1e94793$export$172df6faccd9b546(connectedWallets) {
    return connectedWallets.flatMap((wallet)=>wallet.balances).reduce((balances, balance)=>{
        const currentBalance = {
            amount: balance?.amount ?? "",
            decimals: balance?.decimal ?? 0,
            usdValue: balance?.usdPrice ? new (0, $76r4H.default)(balance?.usdPrice ?? (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)).multipliedBy(balance?.amount).toString() : ""
        };
        const tokenHash = balance ? (0, $76ee130e8dc1847d$export$a7b26387fecb5183)({
            symbol: balance.symbol,
            blockchain: balance.chain,
            address: balance.address
        }) : null;
        const prevBalance = tokenHash ? balances[tokenHash] : null;
        const shouldUpdateBalance = tokenHash && (!prevBalance || prevBalance && prevBalance.amount < currentBalance.amount);
        if (shouldUpdateBalance) balances[tokenHash] = currentBalance;
        return balances;
    }, {});
}
const $b27897cbc1e94793$export$e521f0a0dd245bdc = (connectedWallets, blockchain)=>!!connectedWallets.find((wallet)=>wallet.chain === blockchain && wallet.loading);
function $b27897cbc1e94793$export$985326e893e48db7(walletsInfo) {
    return walletsInfo.map((w)=>w.state).join("-");
}
function $b27897cbc1e94793$export$81d36a7d7cd51dc8(wallets, blockchains) {
    const uniqueBlockchainTypes = new Set();
    wallets.forEach((wallet)=>{
        wallet.blockchainTypes.forEach((type)=>{
            uniqueBlockchainTypes.add(type);
        });
    });
    const filteredBlockchains = blockchains.filter((blockchain)=>uniqueBlockchainTypes.has(blockchain.type));
    return filteredBlockchains;
}
function $b27897cbc1e94793$export$11a6962816b1514(wallets, category) {
    if (category === (0, $361160a0016c9549$export$55324dbe813607bf).ALL) return wallets;
    return wallets.filter((wallet)=>{
        for (const type of wallet.blockchainTypes){
            if ((0, $7c74207847ca6a20$export$3f79ee9344f436da)(type, category)) return true;
        }
        return false;
    });
}


let $6fd02b85a3828f9f$var$configs = {
    API_KEY: (0, $81cb43aa4aa5ed51$export$807e570e9765ba53)
};
function $6fd02b85a3828f9f$export$44487a86467333c3(name) {
    return $6fd02b85a3828f9f$var$configs[name] || "";
}
function $6fd02b85a3828f9f$export$940a7873bb071df8(name, value) {
    $6fd02b85a3828f9f$var$configs[name] = value;
    return value;
}
function $6fd02b85a3828f9f$export$b9b9cdb96b829919(nextConfigs) {
    let clonedConfigs;
    if (typeof structuredClone === "function") clonedConfigs = structuredClone(nextConfigs);
    else clonedConfigs = JSON.parse(JSON.stringify(nextConfigs));
    $6fd02b85a3828f9f$var$configs = clonedConfigs;
    return $6fd02b85a3828f9f$var$configs;
}
const $6fd02b85a3828f9f$export$6caebe9814b9ee2b = 20;
const $6fd02b85a3828f9f$export$b59ee264a2367cd4 = 25;
const $6fd02b85a3828f9f$export$3d3091a962922574 = `theme-widget`;
const $6fd02b85a3828f9f$export$9b55254af1da3b63 = (token, tokensConfig)=>{
    let result = false;
    if (tokensConfig && token) {
        if (Array.isArray(tokensConfig)) result = !tokensConfig.some((asset)=>(0, $b27897cbc1e94793$export$74c4c3613ff7e484)(asset, token));
        else if (!Array.isArray(tokensConfig) && tokensConfig[token.blockchain]) {
            result = tokensConfig[token.blockchain].tokens.some((asset)=>(0, $b27897cbc1e94793$export$74c4c3613ff7e484)(asset, token));
            const isExcluded = tokensConfig[token.blockchain].isExcluded;
            return !isExcluded && !result || isExcluded && result;
        }
    }
    return result;
};
const $6fd02b85a3828f9f$export$2e445b1a4b8d9774 = (blockchain, blockchainsConfig)=>{
    return blockchain && blockchainsConfig && !blockchainsConfig.includes(blockchain.name);
};
const $6fd02b85a3828f9f$export$f56e4a09b07f5a47 = (isLargeScreen, isExtraLargeScreen, variant)=>{
    return variant === "expanded" && (isLargeScreen || isExtraLargeScreen) || variant === "full-expanded" && isExtraLargeScreen;
};


let $8a4b1db626d4e3d9$var$rango = undefined;
const $8a4b1db626d4e3d9$export$c1b2b945bea31d71 = ()=>{
    if ($8a4b1db626d4e3d9$var$rango) return $8a4b1db626d4e3d9$var$rango;
    $8a4b1db626d4e3d9$var$rango = new (0, $e0809f1f0dfba620$export$2eb9c0bd2d5b9cf8)((0, $6fd02b85a3828f9f$export$44487a86467333c3)("API_KEY"), (0, $6fd02b85a3828f9f$export$44487a86467333c3)("BASE_URL"));
    return $8a4b1db626d4e3d9$var$rango;
};





function $b64e40f2483e228d$export$299798afcc913c30(swappers, disabledLiquiditySources) {
    const supportedSwappers = swappers.map((swapper)=>swapper.swapperGroup);
    const uniqueSupportedSwappersGroups = [];
    const uniqueGroup = (0, $7c74207847ca6a20$export$bbb516152e3c2c05)(swappers.map((s)=>s.swapperGroup));
    uniqueGroup.map((uniqueGroupItem)=>{
        const swapperItem = swappers.find((swapper)=>swapper.swapperGroup === uniqueGroupItem);
        if (swapperItem) {
            let isSupportedSwapper = true;
            if (supportedSwappers) isSupportedSwapper = supportedSwappers.some((supportedItem)=>supportedItem === swapperItem.swapperGroup);
            if (isSupportedSwapper) swapperItem.types.map((swapperTypeItem)=>{
                uniqueSupportedSwappersGroups.push({
                    id: swapperItem.swapperGroup,
                    groupTitle: swapperItem.swapperGroup,
                    logo: swapperItem.logo,
                    type: swapperTypeItem,
                    selected: !disabledLiquiditySources.includes(swapperItem.swapperGroup)
                });
            });
        }
    });
    return uniqueSupportedSwappersGroups;
}
function $b64e40f2483e228d$export$80e328dbb43ecc6(a, b) {
    if (a.swapperGroup < b.swapperGroup) return -1;
    if (a.swapperGroup > b.swapperGroup) return 1;
    return 0;
}
function $b64e40f2483e228d$export$82f8135ce57445c2(feature, features) {
    return features?.[feature] === "hidden";
}
function $b64e40f2483e228d$export$87e0f7dd6dec932f(feature, features) {
    return features?.[feature] === "enabled";
}
const $b64e40f2483e228d$export$2ebaa701aac0d48b = (supportedTokens, customTokens, features)=>{
    const isCustomTokensHidden = $b64e40f2483e228d$export$82f8135ce57445c2("customTokens", features);
    return isCustomTokensHidden ? supportedTokens : supportedTokens.concat(customTokens);
};




const $c4f949a3df067699$export$263112ed24cf907e = (set, get)=>({
        // State
        _blockchainsMapByName: new Map(),
        _tokensMapByTokenHash: new Map(),
        _tokensMapByBlockchainName: {},
        _popularTokens: [],
        _swappers: [],
        fetchStatus: "loading",
        // Selectors
        blockchains: (options)=>{
            const blockchainsMapByName = get()._blockchainsMapByName;
            const blockchainsFromState = Array.from(blockchainsMapByName?.values() || []);
            if (!options || !options?.type) return blockchainsFromState;
            const config = get().config;
            if (options.type === "custom-token") {
                const supportedBlockchainsFromConfig = (0, $661f04ba9c1c4c68$export$31ae555fa3cd9613)({
                    config: config
                });
                let supportedBlockchains = blockchainsFromState;
                /*
       * Supported blockchains can be configured and be limited.
       * In this case, we only keep those active blockchains which exist in config.
       */ if (supportedBlockchainsFromConfig.length > 0) supportedBlockchains = supportedBlockchains.filter((blockchain)=>supportedBlockchainsFromConfig.includes(blockchain.name));
                return supportedBlockchains.filter((blockchain)=>(0, $1d6046c6e2456fc7$export$610275bb3c85e71b).includes(blockchain.type));
            }
            const supportedBlockchainsFromConfig = (options.type === "source" ? config.from?.blockchains : config.to?.blockchains) ?? [];
            const list = blockchainsFromState.filter((blockchain)=>{
                if (supportedBlockchainsFromConfig.length > 0 && !supportedBlockchainsFromConfig.includes(blockchain.name)) return false;
                return true;
            });
            return list;
        },
        tokens: (options)=>{
            const { _tokensMapByTokenHash: _tokensMapByTokenHash, _tokensMapByBlockchainName: _tokensMapByBlockchainName, config: config, _customTokens: _customTokens } = get();
            const tokensFromState = Array.from(_tokensMapByTokenHash.values());
            const blockchainsMapByName = get()._blockchainsMapByName;
            if (!options || !options.type) return tokensFromState;
            const configType = options.type === "source" ? "from" : "to";
            const cacheKey = options.type === "source" ? "supportedSourceTokens" : "supportedDestinationTokens";
            let supportedTokens = (0, $8ff437adffe9ce26$export$eb7bed8a914fcd26).get(cacheKey);
            if (!supportedTokens?.length) {
                supportedTokens = (0, $661f04ba9c1c4c68$export$3c912d2df882aeb8)({
                    type: options.type,
                    config: {
                        blockchains: config[configType]?.blockchains,
                        tokens: config[configType]?.tokens
                    },
                    meta: {
                        tokensMapByTokenHash: _tokensMapByTokenHash,
                        tokensMapByBlockchainName: _tokensMapByBlockchainName
                    }
                });
                (0, $8ff437adffe9ce26$export$eb7bed8a914fcd26).set(cacheKey, supportedTokens);
            }
            supportedTokens = (0, $b64e40f2483e228d$export$2ebaa701aac0d48b)(supportedTokens, _customTokens, config.features);
            const blockchains = get().blockchains({
                type: options.type
            });
            const list = supportedTokens.filter((token)=>{
                // If a specific blockchain has passed, we only keep that blockchain's tokens.
                if (!!options.blockchain && token.blockchain !== options.blockchain) return false;
                // Check only available blockchains
                if (!blockchains.some((blockchain)=>{
                    return blockchain.name === token.blockchain;
                })) return false;
                // Search functionality
                if (options.searchFor) {
                    if ((0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.symbol, options.searchFor) || (0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.address || "", options.searchFor) || (0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.name || "", options.searchFor)) return true;
                    return false;
                }
                return true;
            }).sort((tokenA, tokenB)=>{
                //1. sort by pinned tokens
                const isToken1Pinned = get().isTokenPinned(tokenA, options.type);
                const isToken2Pinned = get().isTokenPinned(tokenB, options.type);
                if (isToken1Pinned !== isToken2Pinned) return isToken1Pinned ? -1 : 1;
                //2. sort by balance
                if (options.getBalanceFor) {
                    const token1Balance = options.getBalanceFor(tokenA);
                    const token2Balance = options.getBalanceFor(tokenB);
                    const balanceCompare = (0, $b27897cbc1e94793$export$2d6073c6441ad1f9)(token1Balance, token2Balance);
                    if (balanceCompare !== 0) return balanceCompare;
                }
                const blockChainA = blockchainsMapByName.get(tokenA.blockchain);
                const blockChainB = blockchainsMapByName.get(tokenB.blockchain);
                //3. sort by native token
                const isNativeTokenA = (0, $76ee130e8dc1847d$export$3fb5fac5f0bb937f)(tokenA, blockChainA);
                const isNativeTokenB = (0, $76ee130e8dc1847d$export$3fb5fac5f0bb937f)(tokenB, blockChainB);
                if (isNativeTokenA !== isNativeTokenB) return isNativeTokenA ? -1 : 1;
                //4. sort by token popularity
                if (tokenA.isPopular !== tokenB.isPopular) return tokenA.isPopular ? -1 : 1;
                //5. sort by search phrase
                if (options.searchFor) {
                    const symbolSearchForCompare = (0, $7c74207847ca6a20$export$38315dd14f917da8)(tokenA, tokenB, options.searchFor);
                    if (symbolSearchForCompare) return symbolSearchForCompare;
                }
                //6. sort by token isSecondary
                if (tokenA.isSecondaryCoin !== tokenB.isSecondaryCoin) return tokenA.isSecondaryCoin ? 1 : -1;
                //7. sort by blockchain order
                if (!!blockChainA && !!blockChainB) return blockChainA.sort - blockChainB.sort;
                return 0;
            });
            return list;
        },
        findToken: (asset)=>{
            const tokensMapByHashToken = get()._tokensMapByTokenHash;
            const customTokens = get().customTokens();
            const tokenHash = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(asset);
            let token = tokensMapByHashToken.get(tokenHash);
            if (!token) token = customTokens.find((customToken)=>(0, $76ee130e8dc1847d$export$a7b26387fecb5183)(customToken) === tokenHash);
            return token;
        },
        isTokenPinned: (token, type)=>{
            const pinnedTokens = type === "source" ? get().config.from?.pinnedTokens : get().config.to?.pinnedTokens;
            const pinned = !!pinnedTokens?.some((pinnedToken)=>(0, $b27897cbc1e94793$export$74c4c3613ff7e484)(pinnedToken, token));
            return pinned;
        },
        swappers: ()=>{
            const { config: config, campaignMode: campaignMode } = get();
            const campaignModeLiquiditySource = campaignMode.liquiditySources?.length ? campaignMode.liquiditySources : null;
            const liquiditySources = campaignModeLiquiditySource ?? config.liquiditySources;
            const excludeLiquiditySources = campaignModeLiquiditySource ? false : config.excludeLiquiditySources;
            /*
     * If the excludeLiquiditySources flag is set to true, we return all swappers that are not included in the config.
     * Otherwise, we return all swappers that are included in the config.
     */ const swappers = get()._swappers.filter((swapper)=>{
                const swapperGroupIncludedInLiquiditySources = liquiditySources?.includes(swapper.swapperGroup);
                const shouldExcludeLiquiditySources = excludeLiquiditySources || !liquiditySources || liquiditySources.length === 0;
                return shouldExcludeLiquiditySources ? !swapperGroupIncludedInLiquiditySources : swapperGroupIncludedInLiquiditySources;
            });
            const sortedSwappers = swappers.sort((0, $b64e40f2483e228d$export$80e328dbb43ecc6));
            return sortedSwappers;
        },
        // Actions
        fetch: async ()=>{
            try {
                const { enableCentralizedSwappers: enableCentralizedSwappers } = get().config;
                const response = await (0, $8a4b1db626d4e3d9$export$c1b2b945bea31d71)().getAllMetadata({
                    enableCentralizedSwappers: enableCentralizedSwappers
                });
                set({
                    fetchStatus: "success"
                });
                const blockchainsMapByName = new Map();
                const tokensMapByTokenHash = new Map();
                const tokensMapByBlockchainName = {};
                const tokens = [];
                const popularTokens = response.popularTokens;
                const swappers = response.swappers;
                const blockchainsWithAtLeastOneToken = new Set();
                response.tokens.forEach((token)=>{
                    blockchainsWithAtLeastOneToken.add(token.blockchain);
                    tokens.push(token);
                });
                const sortedBlockchain = response.blockchains.sort((a, b)=>a.sort - b.sort);
                sortedBlockchain.forEach((blockchain)=>{
                    if (blockchain.enabled && blockchainsWithAtLeastOneToken.has(blockchain.name)) blockchainsMapByName.set(blockchain.name, blockchain);
                });
                tokens.forEach((token)=>{
                    const tokenHash = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(token);
                    if (!tokensMapByBlockchainName[token.blockchain]) tokensMapByBlockchainName[token.blockchain] = [];
                    tokensMapByTokenHash.set(tokenHash, token);
                    tokensMapByBlockchainName[token.blockchain].push(tokenHash);
                });
                set({
                    _blockchainsMapByName: blockchainsMapByName,
                    _tokensMapByTokenHash: tokensMapByTokenHash,
                    _tokensMapByBlockchainName: tokensMapByBlockchainName,
                    _popularTokens: popularTokens,
                    _swappers: swappers
                });
            } catch (error) {
                set({
                    fetchStatus: "failed"
                });
                throw error;
            }
        }
    });


const $25cb0a171c1d3c61$export$6b07023c78ed4e3a = 10;



const $e63cb382fec4f20b$export$2092376fd002e13 = [
    {
        title: "Afrikaans",
        label: "Afrikaans",
        local: "af",
        SVGFlag: (0, $163cfd0418700f12$export$2e2bcd8739ae039)
    },
    {
        title: "Arabic",
        label: "\u0639\u0631\u0628\u064A",
        local: "ar",
        SVGFlag: (0, $32fd776629403fce$export$2e2bcd8739ae039)
    },
    {
        title: "Bengali",
        label: "\u09AC\u09BE\u0982\u09B2\u09BE",
        local: "bn",
        SVGFlag: (0, $05456647600d0eb6$export$2e2bcd8739ae039)
    },
    {
        title: "Catalan",
        label: "Catal\xe0",
        local: "ca",
        SVGFlag: (0, $22cc52d199a804cd$export$2e2bcd8739ae039)
    },
    {
        title: "Chinese (Simplified)",
        label: "\u7B80\u4F53\u4E2D\u6587",
        local: "zh-CN",
        SVGFlag: (0, $c06811018ea8cb27$export$2e2bcd8739ae039)
    },
    {
        title: "Chinese (Traditional)",
        label: "\u4E2D\u6587\uFF08\u7E41\u9AD4)",
        local: "zh-TW",
        SVGFlag: (0, $c06811018ea8cb27$export$2e2bcd8739ae039)
    },
    {
        title: "Danish",
        label: "Dansk",
        local: "da",
        SVGFlag: (0, $26cc6cd6f1b31021$export$2e2bcd8739ae039)
    },
    {
        title: "Dutch",
        label: "Nederlands",
        local: "nl",
        SVGFlag: (0, $1164608ad810c3d4$export$2e2bcd8739ae039)
    },
    {
        title: "English",
        label: "English",
        local: "en",
        SVGFlag: (0, $5bae59a0ca5c4d98$export$2e2bcd8739ae039)
    },
    {
        title: "Filipino",
        label: "Filipino",
        local: "fil",
        SVGFlag: (0, $cf1275a7afd947ed$export$2e2bcd8739ae039)
    },
    {
        title: "Finnish",
        label: "Suomalainen",
        local: "fi",
        SVGFlag: (0, $ef7375a9ef81e88a$export$2e2bcd8739ae039)
    },
    {
        title: "French",
        label: "Fran\xe7ais",
        local: "fr",
        SVGFlag: (0, $2ce5bbc0587d6a90$export$2e2bcd8739ae039)
    },
    {
        title: "German",
        label: "Deutsch",
        local: "de",
        SVGFlag: (0, $1bd966efb4350c20$export$2e2bcd8739ae039)
    },
    {
        title: "Greek",
        label: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        local: "el",
        SVGFlag: (0, $ec7dd0983fbff973$export$2e2bcd8739ae039)
    },
    {
        title: "Hindi",
        label: "\u0939\u093F\u0902\u0926\u0940",
        local: "hi",
        SVGFlag: (0, $948afb5c9a3043f0$export$2e2bcd8739ae039)
    },
    {
        title: "Hungarian",
        label: "Magyar",
        local: "hu",
        SVGFlag: (0, $75b81446f360bb41$export$2e2bcd8739ae039)
    },
    {
        title: "Indonesian",
        label: "Indonesia",
        local: "id",
        SVGFlag: (0, $e5ba4cf233dccafe$export$2e2bcd8739ae039)
    },
    {
        title: "Italian",
        label: "Italiana",
        local: "it",
        SVGFlag: (0, $ca126a9eab937d30$export$2e2bcd8739ae039)
    },
    {
        title: "Japanese",
        label: "\u65E5\u672C\u8A9E",
        local: "ja",
        SVGFlag: (0, $557e788bd80de79a$export$2e2bcd8739ae039)
    },
    {
        title: "Korean",
        label: "\uD55C\uAD6D\uC778",
        local: "ko",
        SVGFlag: (0, $b9ef553cc43a0f0d$export$2e2bcd8739ae039)
    },
    {
        title: "Lithuanian",
        label: "Lietuvi\u0173",
        local: "lt",
        SVGFlag: (0, $8cbba6f1bedca365$export$2e2bcd8739ae039)
    },
    {
        title: "Malay",
        label: "Melayu",
        local: "ms",
        SVGFlag: (0, $14ca30fc33cb4aac$export$2e2bcd8739ae039)
    },
    {
        title: "Polish",
        label: "Polski",
        local: "pl",
        SVGFlag: (0, $b3504a4ebf02bc9e$export$2e2bcd8739ae039)
    },
    {
        title: "Portuguese",
        label: "Portugu\xeas",
        local: "pt",
        SVGFlag: (0, $076e4b020cd6fd26$export$2e2bcd8739ae039)
    },
    {
        title: "Russian",
        label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        local: "ru",
        SVGFlag: (0, $a98b5d26da9e9cb4$export$2e2bcd8739ae039)
    },
    {
        title: "Serbian",
        label: "C\u0440\u043F\u0441\u043A\u0438",
        local: "sr",
        SVGFlag: (0, $9ee7ea20f5856de1$export$2e2bcd8739ae039)
    },
    {
        title: "Slovak",
        label: "Slovensk\xfd",
        local: "sk",
        SVGFlag: (0, $6fd6ccbc1b739a4c$export$2e2bcd8739ae039)
    },
    {
        title: "Spanish",
        label: "Espa\xf1ol",
        local: "es",
        SVGFlag: (0, $587b6b5217b9553a$export$2e2bcd8739ae039)
    },
    {
        title: "Swahili",
        label: "Kiswahili",
        local: "sw",
        SVGFlag: (0, $d2a96b461bc63761$export$2e2bcd8739ae039)
    },
    {
        title: "Swedish",
        label: "Svenska",
        local: "sv",
        SVGFlag: (0, $b3f183aaf0af65db$export$2e2bcd8739ae039)
    },
    {
        title: "Thai",
        label: "\u0E41\u0E1A\u0E1A\u0E44\u0E17\u0E22",
        local: "th",
        SVGFlag: (0, $21fd827fd7e4c82c$export$2e2bcd8739ae039)
    },
    {
        title: "Turkish",
        label: "T\xfcrk\xe7e",
        local: "tr",
        SVGFlag: (0, $79649b9f82a49880$export$2e2bcd8739ae039)
    },
    {
        title: "Ukrainian",
        label: "Y\u043A\u0440\u0430\u0457\u043D\u0456",
        local: "uk",
        SVGFlag: (0, $39bd2056492681b8$export$2e2bcd8739ae039)
    },
    {
        title: "Urdu",
        label: "\u0627\u0631\u062F\u0648",
        local: "ur",
        SVGFlag: (0, $e945a4e0ece49372$export$2e2bcd8739ae039)
    },
    {
        title: "Vietnamese",
        label: "Ti\u1EBFng Vi\u1EC7t",
        local: "vi",
        SVGFlag: (0, $b42ee6fe0e513c3c$export$2e2bcd8739ae039)
    }
];
const $e63cb382fec4f20b$export$910b680d1eea6990 = "en";


const $6eceba59c0c82e59$var$LOW = 0.5;
const $6eceba59c0c82e59$var$MEDIUM = 1;
const $6eceba59c0c82e59$var$HIGH = 3;
const $6eceba59c0c82e59$export$5ec0897e5fd6c2eb = [
    $6eceba59c0c82e59$var$LOW,
    $6eceba59c0c82e59$var$MEDIUM,
    $6eceba59c0c82e59$var$HIGH
];
const $6eceba59c0c82e59$export$d86fe0476a9ccd6e = 1;
const $6eceba59c0c82e59$export$c16183a27a68b1cf = 5;
const $6eceba59c0c82e59$export$7f2b1a3579bfd3f3 = 100;
const $6eceba59c0c82e59$export$c9f588d8d1b5cc3a = 0;





const $30d92bf82af18719$export$c4a303e4d9c7dae4 = (set, get)=>({
        disabledLiquiditySources: [],
        theme: "auto",
        language: null,
        preferredBlockchains: [],
        slippage: (0, $6eceba59c0c82e59$export$d86fe0476a9ccd6e),
        customSlippage: null,
        infiniteApprove: false,
        affiliateRef: null,
        affiliatePercent: null,
        affiliateWallets: null,
        _customTokens: [],
        addPreferredBlockchain: (blockchain)=>{
            const currentPreferredBlockchains = get().preferredBlockchains;
            const noNeedToDoAnything = currentPreferredBlockchains.find((preferredBlockchain, index)=>{
                const isSameBlockchain = preferredBlockchain === blockchain;
                const isInVisibleList = index <= (0, $25cb0a171c1d3c61$export$6b07023c78ed4e3a) - 1;
                return isSameBlockchain && isInVisibleList;
            });
            if (noNeedToDoAnything) return;
            const nextPreferredBlockchains = currentPreferredBlockchains.filter((preferredBlockchain)=>{
                const isSameBlockchain = preferredBlockchain === blockchain;
                return !isSameBlockchain;
            });
            set(()=>({
                    preferredBlockchains: [
                        blockchain,
                        ...nextPreferredBlockchains
                    ]
                }));
        },
        setSlippage: (slippage)=>set(()=>({
                    slippage: slippage
                })),
        setCustomSlippage: (customSlippage)=>set(()=>({
                    customSlippage: customSlippage
                })),
        setAffiliateRef: (affiliateRef)=>set(()=>({
                    affiliateRef: affiliateRef
                })),
        setAffiliatePercent: (affiliatePercent)=>set(()=>({
                    affiliatePercent: affiliatePercent
                })),
        setAffiliateWallets: (affiliateWallets)=>set(()=>({
                    affiliateWallets: affiliateWallets
                })),
        toggleAllLiquiditySources: (swappers, shouldReset)=>set((state)=>{
                if (shouldReset) return {
                    disabledLiquiditySources: []
                };
                const swappersGroup = (0, $7c74207847ca6a20$export$bbb516152e3c2c05)(swappers.map((swapper)=>swapper.swapperGroup));
                if (swappersGroup.length === state.disabledLiquiditySources.length) return {
                    disabledLiquiditySources: []
                };
                return {
                    disabledLiquiditySources: swappersGroup
                };
            }),
        toggleInfiniteApprove: ()=>set((state)=>({
                    infiniteApprove: !state.infiniteApprove
                })),
        toggleLiquiditySource: (name)=>set((state)=>{
                if (state.disabledLiquiditySources.includes(name)) return {
                    disabledLiquiditySources: state.disabledLiquiditySources.filter((liquiditySource)=>liquiditySource != name)
                };
                return {
                    disabledLiquiditySources: state.disabledLiquiditySources.concat(name)
                };
            }),
        setTheme: (theme)=>set(()=>({
                    theme: theme
                })),
        setLanguage: (language)=>set(()=>({
                    language: language
                })),
        updateSettings: (nextConfig)=>{
            const { features: features, theme: theme } = nextConfig;
            const isThemeHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("theme", features);
            const isLanguageHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("language", features);
            const isLiquidityHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("liquiditySource", features);
            const singleTheme = theme?.singleTheme;
            const autoUpdateSettings = nextConfig?.__UNSTABLE_OR_INTERNAL__?.autoUpdateSettings;
            set({
                ...isThemeHidden && {
                    theme: nextConfig.theme?.mode || "auto"
                },
                ...singleTheme && {
                    theme: nextConfig.theme?.mode || "light"
                },
                ...isLanguageHidden && {
                    language: nextConfig.language || (0, $e63cb382fec4f20b$export$910b680d1eea6990)
                },
                ...isLiquidityHidden && {
                    disabledLiquiditySources: nextConfig.liquiditySources || []
                },
                ...autoUpdateSettings && {
                    // For the time being, we have added the language; if more are needed later, we can add other parameters.
                    language: nextConfig.language || (0, $e63cb382fec4f20b$export$910b680d1eea6990)
                }
            });
        },
        setCustomToken: (token)=>set((state)=>({
                    _customTokens: [
                        token,
                        ...state._customTokens
                    ]
                })),
        deleteCustomToken: (token)=>set((state)=>({
                    _customTokens: state._customTokens.filter((customToken)=>customToken.address !== token.address)
                })),
        customTokens: ()=>{
            const config = get().config;
            const customTokens = get()._customTokens;
            const supportedBlockchainsFromConfig = (0, $661f04ba9c1c4c68$export$31ae555fa3cd9613)({
                config: config
            });
            return !supportedBlockchainsFromConfig.length ? customTokens : customTokens.filter((token)=>supportedBlockchainsFromConfig.includes(token.blockchain));
        }
    });


function $7b9fe388f42e8582$export$38e7b01cdeec369(initialData) {
    return (0, $deedc9bfbd0dc16c$export$185802fd694ee1f5)()((0, $3ed31f3dd58f2a20$export$9a6132153fba2e0)((...a)=>({
            ...(0, $c4f949a3df067699$export$263112ed24cf907e)(...a),
            ...(0, $30d92bf82af18719$export$c4a303e4d9c7dae4)(...a),
            ...(0, $b05f972a7e8c18b1$export$50436c4ddffbe408)(initialData, ...a)
        }), {
        name: "user-settings",
        skipHydration: true,
        partialize: (state)=>{
            return {
                _customTokens: state._customTokens,
                theme: state.theme,
                language: state.language,
                affiliatePercent: state.affiliatePercent,
                affiliateRef: state.affiliateRef,
                affiliateWallets: state.affiliateWallets,
                slippage: state.slippage,
                customSlippage: state.customSlippage,
                infiniteApprove: state.infiniteApprove,
                preferredBlockchains: state.preferredBlockchains,
                disabledLiquiditySources: state.disabledLiquiditySources
            };
        }
    }));
}


const $9997ae2e4c8ece9b$export$793d33a55ac6e857 = /*#__PURE__*/ (0, $exYeM.createContext)(null);
function $9997ae2e4c8ece9b$export$35cd30506bcba883() {
    const store = (0, $exYeM.useContext)($9997ae2e4c8ece9b$export$793d33a55ac6e857);
    (0, $exYeM.useEffect)(()=>{
        if (store && !store.persist.hasHydrated()) store.persist.rehydrate();
    }, []);
    if (!store) throw new Error("Missing AppStoreContext.Provider in the tree");
    return store();
}
function $9997ae2e4c8ece9b$export$5c53a35a4a26c364(props) {
    const appStoreRef = (0, $exYeM.useRef)();
    if (!appStoreRef.current) appStoreRef.current = (0, $7b9fe388f42e8582$export$38e7b01cdeec369)(props.config);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9997ae2e4c8ece9b$export$793d33a55ac6e857.Provider, {
        value: appStoreRef.current
    }, props.children);
}




function $5d35e8f81637cc41$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i ? i.push(e) : n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
        },
        emit: function(t, e) {
            var i = n.get(t);
            i && i.slice().map(function(n) {
                n(e);
            }), (i = n.get("*")) && i.slice().map(function(n) {
                n(t, e);
            });
        }
    };
}


const $23eba71feb69205e$export$10dc3edfc20c8ff = (0, $5d35e8f81637cc41$export$2e2bcd8739ae039)();
const $23eba71feb69205e$export$34dfa91224288fed = {
    on: $23eba71feb69205e$export$10dc3edfc20c8ff.on,
    off: $23eba71feb69205e$export$10dc3edfc20c8ff.off
};







/* eslint-disable @typescript-eslint/prefer-enum-initializers */ var $bad1ce08d7bdae0b$export$d1b98d026d7c244c;
(function(QuoteErrorType) {
    QuoteErrorType[QuoteErrorType["NO_RESULT"] = 0] = "NO_RESULT";
    QuoteErrorType[QuoteErrorType["REQUEST_FAILED"] = 1] = "REQUEST_FAILED";
    QuoteErrorType[QuoteErrorType["REQUEST_CANCELED"] = 2] = "REQUEST_CANCELED";
    QuoteErrorType[QuoteErrorType["BRIDGE_LIMIT"] = 3] = "BRIDGE_LIMIT";
    QuoteErrorType[QuoteErrorType["INSUFFICIENT_SLIPPAGE"] = 4] = "INSUFFICIENT_SLIPPAGE";
})($bad1ce08d7bdae0b$export$d1b98d026d7c244c || ($bad1ce08d7bdae0b$export$d1b98d026d7c244c = {}));
var $bad1ce08d7bdae0b$export$e1e7a505a413c460;
(function(QuoteWarningType) {
    QuoteWarningType[QuoteWarningType["HIGH_VALUE_LOSS"] = 0] = "HIGH_VALUE_LOSS";
    QuoteWarningType[QuoteWarningType["UNKNOWN_PRICE"] = 1] = "UNKNOWN_PRICE";
    QuoteWarningType[QuoteWarningType["INSUFFICIENT_SLIPPAGE"] = 2] = "INSUFFICIENT_SLIPPAGE";
    QuoteWarningType[QuoteWarningType["HIGH_SLIPPAGE"] = 3] = "HIGH_SLIPPAGE";
})($bad1ce08d7bdae0b$export$e1e7a505a413c460 || ($bad1ce08d7bdae0b$export$e1e7a505a413c460 = {}));
var $bad1ce08d7bdae0b$export$f8344cf73408b4e3;
(function(QuoteUpdateType) {
    QuoteUpdateType[QuoteUpdateType["QUOTE_UPDATED"] = 0] = "QUOTE_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_SWAPPERS_UPDATED"] = 1] = "QUOTE_SWAPPERS_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_COINS_UPDATED"] = 2] = "QUOTE_COINS_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_AND_OUTPUT_AMOUNT_UPDATED"] = 3] = "QUOTE_AND_OUTPUT_AMOUNT_UPDATED";
    QuoteUpdateType[QuoteUpdateType["QUOTE_UPDATED_WITH_HIGH_VALUE_LOSS"] = 4] = "QUOTE_UPDATED_WITH_HIGH_VALUE_LOSS";
})($bad1ce08d7bdae0b$export$f8344cf73408b4e3 || ($bad1ce08d7bdae0b$export$f8344cf73408b4e3 = {}));





var $97c1ea0b5855c6ca$export$88d3f00995e6f561;
(function(QuoteEventTypes) {
    QuoteEventTypes["QUOTE_INPUT_UPDATE"] = "quoteInputUpdate";
    QuoteEventTypes["QUOTE_OUTPUT_UPDATE"] = "quoteOutputUpdate";
})($97c1ea0b5855c6ca$export$88d3f00995e6f561 || ($97c1ea0b5855c6ca$export$88d3f00995e6f561 = {}));
var $97c1ea0b5855c6ca$export$63e1155cabad967f;
(function(WalletEventTypes) {
    WalletEventTypes["CONNECT"] = "connect";
    WalletEventTypes["DISCONNECT"] = "disconnect";
})($97c1ea0b5855c6ca$export$63e1155cabad967f || ($97c1ea0b5855c6ca$export$63e1155cabad967f = {}));
var $97c1ea0b5855c6ca$export$7a2e2250d475f540;
(function(UiEventTypes) {
    UiEventTypes["CLICK_CONNECT_WALLET"] = "clickConnectWallet";
})($97c1ea0b5855c6ca$export$7a2e2250d475f540 || ($97c1ea0b5855c6ca$export$7a2e2250d475f540 = {}));
var $97c1ea0b5855c6ca$export$54f5f69c1651567f;
(function(WidgetEvents) {
    WidgetEvents[WidgetEvents["RouteEvent"] = (0, $ab26e0b6754d430c$export$54f5f69c1651567f).RouteEvent] = "RouteEvent";
    WidgetEvents[WidgetEvents["StepEvent"] = (0, $ab26e0b6754d430c$export$54f5f69c1651567f).StepEvent] = "StepEvent";
    WidgetEvents["QuoteEvent"] = "quoteEvent";
    WidgetEvents["WalletEvent"] = "walletEvent";
    WidgetEvents["UiEvent"] = "uiEvent";
})($97c1ea0b5855c6ca$export$54f5f69c1651567f || ($97c1ea0b5855c6ca$export$54f5f69c1651567f = {}));






const $e0ddf8b9111cc8ab$var$createSelectors = (_store)=>{
    const store = _store;
    store.use = {};
    for (const k of Object.keys(store.getState()))store.use[k] = ()=>store((s)=>s[k]);
    return store;
};
var $e0ddf8b9111cc8ab$export$2e2bcd8739ae039 = $e0ddf8b9111cc8ab$var$createSelectors;


const $41385c7b1441a578$export$63a06538da9383a6 = (0, $e0ddf8b9111cc8ab$export$2e2bcd8739ae039)((0, $deedc9bfbd0dc16c$export$185802fd694ee1f5)()((0, $3ed31f3dd58f2a20$export$5c593627aef9f076)((set, get)=>{
    return {
        connectedWallets: [],
        balances: {},
        loading: false,
        connectWallet: (accounts, findToken)=>{
            (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).WalletEvent, {
                type: (0, $97c1ea0b5855c6ca$export$63e1155cabad967f).CONNECT,
                payload: {
                    walletType: accounts[0].walletType,
                    accounts: accounts
                }
            });
            const getWalletsDetails = get().getWalletsDetails;
            set((state)=>({
                    loading: true,
                    connectedWallets: state.connectedWallets.filter((wallet)=>wallet.walletType !== accounts[0].walletType).concat(accounts.map((account)=>{
                        const shouldMarkWalletAsSelected = !state.connectedWallets.some((connectedWallet)=>connectedWallet.chain === account.chain && connectedWallet.selected && /**
                         * Sometimes, the connect function can be called multiple times for a particular wallet type when using the auto-connect feature.
                         * This check is there to make sure the chosen wallet doesn't end up unselected.
                         */ connectedWallet.walletType !== account.walletType);
                        return {
                            balances: [],
                            address: account.address,
                            chain: account.chain,
                            explorerUrl: null,
                            walletType: account.walletType,
                            selected: shouldMarkWalletAsSelected,
                            loading: true,
                            error: false
                        };
                    }))
                }));
            getWalletsDetails(accounts, findToken);
        },
        disconnectWallet: (walletType)=>{
            set((state)=>{
                if (state.connectedWallets.find((wallet)=>wallet.walletType === walletType)) (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).WalletEvent, {
                    type: (0, $97c1ea0b5855c6ca$export$63e1155cabad967f).DISCONNECT,
                    payload: {
                        walletType: walletType
                    }
                });
                const selectedWallets = state.connectedWallets.filter((connectedWallet)=>connectedWallet.selected && connectedWallet.walletType !== walletType).map((selectedWallet)=>selectedWallet.chain);
                const connectedWallets = state.connectedWallets.filter((connectedWallet)=>connectedWallet.walletType !== walletType).map((connectedWallet)=>{
                    const anyWalletSelectedForBlockchain = selectedWallets.includes(connectedWallet.chain);
                    if (anyWalletSelectedForBlockchain) return connectedWallet;
                    selectedWallets.push(connectedWallet.chain);
                    return {
                        ...connectedWallet,
                        selected: true
                    };
                });
                const balances = (0, $b27897cbc1e94793$export$172df6faccd9b546)(connectedWallets);
                return {
                    balances: balances,
                    connectedWallets: connectedWallets
                };
            });
        },
        selectWallets: (wallets)=>set((state)=>({
                    connectedWallets: state.connectedWallets.map((connectedWallet)=>{
                        const walletSelected = !!wallets.find((wallet)=>wallet.chain === connectedWallet.chain && wallet.walletType !== connectedWallet.walletType && connectedWallet.selected);
                        const walletNotSelected = !!wallets.find((wallet)=>wallet.chain === connectedWallet.chain && wallet.walletType === connectedWallet.walletType && !connectedWallet.selected);
                        if (walletSelected) return {
                            ...connectedWallet,
                            selected: false
                        };
                        else if (walletNotSelected) return {
                            ...connectedWallet,
                            selected: true
                        };
                        return connectedWallet;
                    })
                })),
        clearConnectedWallet: ()=>set(()=>({
                    connectedWallets: [],
                    selectedWallets: []
                })),
        getWalletsDetails: async (accounts, findToken, shouldRetry = true)=>{
            const getWalletsDetails = get().getWalletsDetails;
            set((state)=>({
                    loading: true,
                    connectedWallets: state.connectedWallets.map((wallet)=>{
                        return accounts.find((account)=>(0, $b27897cbc1e94793$export$f9a87ee1a616fb86)(account, wallet)) ? {
                            ...wallet,
                            loading: true
                        } : wallet;
                    })
                }));
            try {
                const data = accounts.map(({ address: address, chain: chain })=>({
                        address: address,
                        blockchain: chain
                    }));
                const response = await (0, $8a4b1db626d4e3d9$export$c1b2b945bea31d71)().getWalletsDetails(data);
                const retrievedBalance = response.wallets;
                if (retrievedBalance) set((state)=>{
                    const connectedWallets = state.connectedWallets.map((connectedWallet)=>{
                        const matchedAccount = accounts.find((account)=>(0, $b27897cbc1e94793$export$f9a87ee1a616fb86)(account, connectedWallet));
                        const retrievedBalanceAccount = retrievedBalance.find((balance)=>balance.address === connectedWallet.address && balance.blockChain === connectedWallet.chain);
                        if (retrievedBalanceAccount?.failed && matchedAccount && shouldRetry) getWalletsDetails([
                            matchedAccount
                        ], findToken, false);
                        return matchedAccount && retrievedBalanceAccount ? {
                            ...connectedWallet,
                            explorerUrl: retrievedBalanceAccount.explorerUrl,
                            balances: (0, $b27897cbc1e94793$export$2f738d191cb8cc64)(retrievedBalanceAccount, findToken),
                            loading: false,
                            error: false
                        } : connectedWallet;
                    });
                    const balances = (0, $b27897cbc1e94793$export$172df6faccd9b546)(connectedWallets);
                    return {
                        loading: false,
                        balances: balances,
                        connectedWallets: connectedWallets
                    };
                });
                else throw new Error("Wallet not found");
            } catch (error) {
                set((state)=>{
                    const connectedWallets = state.connectedWallets.map((balance)=>{
                        return accounts.find((account)=>(0, $b27897cbc1e94793$export$f9a87ee1a616fb86)(account, balance)) ? (0, $b27897cbc1e94793$export$c537abfa9eefe515)(balance) : balance;
                    });
                    const balances = (0, $b27897cbc1e94793$export$172df6faccd9b546)(connectedWallets);
                    return {
                        loading: false,
                        balances: balances,
                        connectedWallets: connectedWallets
                    };
                });
            }
        },
        getBalanceFor: (token)=>{
            const { balances: balances } = get();
            const tokenHash = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(token);
            const balance = balances[tokenHash];
            return balance ?? null;
        }
    };
})));


var $0b75c909d77fc239$exports = {};

$parcel$export($0b75c909d77fc239$exports, "config", function () { return $0b75c909d77fc239$export$e506a1d27d1eaa20; });
$parcel$export($0b75c909d77fc239$exports, "getInstance", function () { return $0b75c909d77fc239$export$8bedcca5bbd73999; });
$parcel$export($0b75c909d77fc239$exports, "connect", function () { return $0b75c909d77fc239$export$64605811ab45167f; });
$parcel$export($0b75c909d77fc239$exports, "subscribe", function () { return $0b75c909d77fc239$export$ec068583843480e7; });
$parcel$export($0b75c909d77fc239$exports, "canSwitchNetworkTo", function () { return $0b75c909d77fc239$export$3b3cf9ab9019de20; });
$parcel$export($0b75c909d77fc239$exports, "getSigners", function () { return $0b75c909d77fc239$export$6352a17a50193ded; });
$parcel$export($0b75c909d77fc239$exports, "canEagerConnect", function () { return $0b75c909d77fc239$export$be9f3c5ed1d25e42; });
$parcel$export($0b75c909d77fc239$exports, "getWalletInfo", function () { return $0b75c909d77fc239$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $f968a2b26200fbb0$export$539912d80e7af9ec() {
    const { starknet_argentX: starknet_argentX } = window;
    if (!!starknet_argentX) return starknet_argentX;
    return null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $ff06bdce7a4c2a8d$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultStarknetSigner: DefaultStarknetSigner } = await (parcelRequire("6xcFR"));
    signers.registerSigner((0, $liigz.TransactionType).STARKNET, new DefaultStarknetSigner(provider));
    return signers;
}


/*
 * https://www.starknetjs.com/docs/API/signer
 * https://github.com/apibara/starknet-react
 * https://github.com/0xs34n/starknet.js
 * https://github.com/argentlabs/argent-x#-usage-with-your-dapp
 */ const $0b75c909d77fc239$var$WALLET = (0, $yEwlv.WalletTypes).ARGENTX;
const $0b75c909d77fc239$var$MAINNET_CHAIN_ID = "SN_MAIN";
const $0b75c909d77fc239$export$e506a1d27d1eaa20 = {
    type: $0b75c909d77fc239$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).STARKNET
};
const $0b75c909d77fc239$export$8bedcca5bbd73999 = (0, $f968a2b26200fbb0$export$539912d80e7af9ec);
const $0b75c909d77fc239$export$64605811ab45167f = async ({ instance: instance })=>{
    let r = undefined;
    r = await instance?.enable();
    if (!r || !instance.isConnected || r?.length === 0) throw new Error("Error connecting ArgentX");
    if (instance?.chainId !== $0b75c909d77fc239$var$MAINNET_CHAIN_ID) throw new Error(`Please switch to Mainnet, current network is ${instance?.chainId}`);
    return {
        accounts: r ? r : [],
        chainId: (0, $8aS14.LegacyNetworks).STARKNET
    };
};
const $0b75c909d77fc239$export$ec068583843480e7 = ({ instance: instance, state: state, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (accounts)=>{
        if (state.connected) {
            if (instance) updateAccounts(accounts, (0, $8aS14.LegacyNetworks).STARKNET);
        }
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
    };
};
const $0b75c909d77fc239$export$3b3cf9ab9019de20 = ()=>false;
const $0b75c909d77fc239$export$6352a17a50193ded = (0, $ff06bdce7a4c2a8d$export$2e2bcd8739ae039);
const $0b75c909d77fc239$export$be9f3c5ed1d25e42 = ({ instance: instance })=>instance.isPreauthorized();
const $0b75c909d77fc239$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const starknet = (0, $21GQj.starknetBlockchain)(allBlockChains);
    return {
        name: "ArgentX",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/argentx/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/argent-x/dlcobpjiigpikoobohmabehhmhfoodbb",
            BRAVE: "https://chrome.google.com/webstore/detail/argent-x/dlcobpjiigpikoobohmabehhmhfoodbb",
            FIREFOX: "https://addons.mozilla.org/en-GB/firefox/addon/argent-x",
            DEFAULT: "https://www.argent.xyz"
        },
        color: "#96e7ed",
        supportedChains: starknet
    };
};


var $bca53e3b1b1a5dd8$exports = {};

$parcel$export($bca53e3b1b1a5dd8$exports, "config", function () { return $bca53e3b1b1a5dd8$export$e506a1d27d1eaa20; });
$parcel$export($bca53e3b1b1a5dd8$exports, "getInstance", function () { return $bca53e3b1b1a5dd8$export$8bedcca5bbd73999; });
$parcel$export($bca53e3b1b1a5dd8$exports, "connect", function () { return $bca53e3b1b1a5dd8$export$64605811ab45167f; });
$parcel$export($bca53e3b1b1a5dd8$exports, "subscribe", function () { return $bca53e3b1b1a5dd8$export$ec068583843480e7; });
$parcel$export($bca53e3b1b1a5dd8$exports, "switchNetwork", function () { return $bca53e3b1b1a5dd8$export$f3473d805e486329; });
$parcel$export($bca53e3b1b1a5dd8$exports, "canSwitchNetworkTo", function () { return $bca53e3b1b1a5dd8$export$3b3cf9ab9019de20; });
$parcel$export($bca53e3b1b1a5dd8$exports, "canEagerConnect", function () { return $bca53e3b1b1a5dd8$export$be9f3c5ed1d25e42; });
$parcel$export($bca53e3b1b1a5dd8$exports, "getSigners", function () { return $bca53e3b1b1a5dd8$export$6352a17a50193ded; });
$parcel$export($bca53e3b1b1a5dd8$exports, "getWalletInfo", function () { return $bca53e3b1b1a5dd8$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $3da0ff82b4eca190$export$426b240890f4892d() {
    const instances = new Map();
    const { bitkeep: bitkeep } = window;
    if (!bitkeep) return null;
    if (bitkeep.ethereum) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, bitkeep.ethereum);
    if (bitkeep.tronLink) instances.set((0, $8aS14.LegacyNetworks).TRON, bitkeep.tronLink);
    if (instances.size === 0) return null;
    return instances;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $5e884146fa144164$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const tronProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).TRON);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { DefaultTronSigner: DefaultTronSigner } = await (parcelRequire("fqCpP"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).TRON, new DefaultTronSigner(tronProvider));
    return signers;
}


const $bca53e3b1b1a5dd8$var$WALLET = (0, $yEwlv.WalletTypes).BITGET;
const $bca53e3b1b1a5dd8$export$e506a1d27d1eaa20 = {
    type: $bca53e3b1b1a5dd8$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $bca53e3b1b1a5dd8$export$8bedcca5bbd73999 = (0, $3da0ff82b4eca190$export$426b240890f4892d);
const $bca53e3b1b1a5dd8$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const tronInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).TRON);
    const results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push(evmResult);
    }
    if (tronInstance) {
        const res = await tronInstance.request({
            method: "tron_requestAccounts"
        });
        if (!res) throw new Error("Please unlock your Bitget extension first.");
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (!!res?.code && !!res.message && res.code !== 200) throw new Error(res.message);
        const address = tronInstance.tronWeb.defaultAddress.base58;
        results.push({
            accounts: address ? [
                address
            ] : [],
            chainId: (0, $8aS14.LegacyNetworks).TRON
        });
    }
    return results;
};
const $bca53e3b1b1a5dd8$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const ethInstance = instance.get((0, $8aS14.LegacyNetworks).ETHEREUM);
    const evmBlockchainMeta = meta.filter((0, $21GQj.isEvmBlockchain));
    const cleanup = (0, $bHRZL.subscribeToEvm)({
        instance: ethInstance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: evmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    window.addEventListener("message", (e)=>{
        if (e.data.isTronLink && e.data.message && e.data.message.action == "accountsChanged") {
            const account = e?.data?.message?.data?.address;
            if (account) updateAccounts([
                account
            ]);
            else disconnect();
        }
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $bca53e3b1b1a5dd8$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $bca53e3b1b1a5dd8$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $bca53e3b1b1a5dd8$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $bca53e3b1b1a5dd8$export$6352a17a50193ded = (0, $5e884146fa144164$export$2e2bcd8739ae039);
const $bca53e3b1b1a5dd8$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const tron = (0, $21GQj.tronBlockchain)(allBlockChains);
    return {
        name: "Bitget Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/bitget/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak",
            BRAVE: "https://chrome.google.com/webstore/detail/bitkeep-crypto-nft-wallet/jiidiaalihmmhddjgbnbgdfflelocpak",
            DEFAULT: "https://web3.bitget.com/en/wallet-download?type=1"
        },
        color: "#ffffff",
        supportedChains: [
            ...evms,
            ...tron
        ]
    };
};


var $d5760f03f86ca6d0$exports = {};

$parcel$export($d5760f03f86ca6d0$exports, "config", function () { return $d5760f03f86ca6d0$export$e506a1d27d1eaa20; });
$parcel$export($d5760f03f86ca6d0$exports, "getInstance", function () { return $d5760f03f86ca6d0$export$8bedcca5bbd73999; });
$parcel$export($d5760f03f86ca6d0$exports, "connect", function () { return $d5760f03f86ca6d0$export$64605811ab45167f; });
$parcel$export($d5760f03f86ca6d0$exports, "subscribe", function () { return $d5760f03f86ca6d0$export$ec068583843480e7; });
$parcel$export($d5760f03f86ca6d0$exports, "canSwitchNetworkTo", function () { return $d5760f03f86ca6d0$export$3b3cf9ab9019de20; });
$parcel$export($d5760f03f86ca6d0$exports, "getSigners", function () { return $d5760f03f86ca6d0$export$6352a17a50193ded; });
$parcel$export($d5760f03f86ca6d0$exports, "canEagerConnect", function () { return $d5760f03f86ca6d0$export$be9f3c5ed1d25e42; });
$parcel$export($d5760f03f86ca6d0$exports, "getWalletInfo", function () { return $d5760f03f86ca6d0$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $e18644ea0b87003b$export$80c24364a68cc000() {
    const { starknet_braavos: starknet_braavos } = window;
    if (!!starknet_braavos) return starknet_braavos;
    return null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $76f5edf5aee9802f$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultStarknetSigner: DefaultStarknetSigner } = await (parcelRequire("6xcFR"));
    signers.registerSigner((0, $liigz.TransactionType).STARKNET, new DefaultStarknetSigner(provider));
    return signers;
}


const $d5760f03f86ca6d0$var$WALLET = (0, $yEwlv.WalletTypes).BRAAVOS;
const $d5760f03f86ca6d0$export$e506a1d27d1eaa20 = {
    type: $d5760f03f86ca6d0$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).STARKNET
};
const $d5760f03f86ca6d0$export$8bedcca5bbd73999 = (0, $e18644ea0b87003b$export$80c24364a68cc000);
const $d5760f03f86ca6d0$export$64605811ab45167f = async ({ instance: instance })=>{
    const accounts = await instance?.enable();
    if (!accounts?.length || !instance.isConnected) throw new Error("Connection Error");
    return {
        accounts: accounts || [],
        chainId: (0, $8aS14.LegacyNetworks).STARKNET
    };
};
const $d5760f03f86ca6d0$export$ec068583843480e7 = ({ instance: instance, state: state, updateAccounts: updateAccounts })=>{
    const handleAccountsChanged = (accounts)=>{
        if (state.connected) {
            if (instance) updateAccounts([
                accounts
            ], (0, $8aS14.LegacyNetworks).STARKNET);
        }
    };
    instance?.on?.("accountsChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountsChanged", handleAccountsChanged);
    };
};
const $d5760f03f86ca6d0$export$3b3cf9ab9019de20 = ()=>false;
const $d5760f03f86ca6d0$export$6352a17a50193ded = (0, $76f5edf5aee9802f$export$2e2bcd8739ae039);
const $d5760f03f86ca6d0$export$be9f3c5ed1d25e42 = ({ instance: instance })=>instance.isPreauthorized();
const $d5760f03f86ca6d0$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const starknet = (0, $21GQj.starknetBlockchain)(allBlockChains);
    return {
        name: "Braavos",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/braavos/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            BRAVE: "https://chrome.google.com/webstore/detail/braavos-smart-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet/",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc",
            DEFAULT: "https://braavos.app/"
        },
        color: "#96e7ed",
        supportedChains: starknet
    };
};


var $efe06be440deeb8d$exports = {};

$parcel$export($efe06be440deeb8d$exports, "config", function () { return $efe06be440deeb8d$export$e506a1d27d1eaa20; });
$parcel$export($efe06be440deeb8d$exports, "getInstance", function () { return $efe06be440deeb8d$export$8bedcca5bbd73999; });
$parcel$export($efe06be440deeb8d$exports, "connect", function () { return $efe06be440deeb8d$export$64605811ab45167f; });
$parcel$export($efe06be440deeb8d$exports, "subscribe", function () { return $efe06be440deeb8d$export$ec068583843480e7; });
$parcel$export($efe06be440deeb8d$exports, "switchNetwork", function () { return $efe06be440deeb8d$export$f3473d805e486329; });
$parcel$export($efe06be440deeb8d$exports, "canSwitchNetworkTo", function () { return $efe06be440deeb8d$export$3b3cf9ab9019de20; });
$parcel$export($efe06be440deeb8d$exports, "getSigners", function () { return $efe06be440deeb8d$export$6352a17a50193ded; });
$parcel$export($efe06be440deeb8d$exports, "canEagerConnect", function () { return $efe06be440deeb8d$export$be9f3c5ed1d25e42; });
$parcel$export($efe06be440deeb8d$exports, "getWalletInfo", function () { return $efe06be440deeb8d$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $7aYgM = parcelRequire("7aYgM");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $35357d892fc016d7$export$55900a4725b84e07() {
    const { ethereum: ethereum, braveSolana: braveSolana } = window;
    const instances = new Map();
    if (ethereum?.isBraveWallet) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, ethereum);
    if (braveSolana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, braveSolana);
    if (instances.size === 0) return null;
    return instances;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $5c7d61ee05e1517a$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("4DYZp"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $efe06be440deeb8d$var$WALLET = (0, $yEwlv.WalletTypes).BRAVE;
const $efe06be440deeb8d$export$e506a1d27d1eaa20 = {
    type: $efe06be440deeb8d$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $efe06be440deeb8d$export$8bedcca5bbd73999 = (0, $35357d892fc016d7$export$55900a4725b84e07);
const $efe06be440deeb8d$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const sol_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    const emptyWalletErrorCode = -32603;
    const emptyWalletCustomErrorMessage = "Please create or import a wallet";
    let numberOfEmptyWallets = 0;
    if (evm_instance) try {
        const evmAccounts = await (0, $bHRZL.getEvmAccounts)(evm_instance);
        results.push(evmAccounts);
    } catch (error) {
        // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
        const err = error;
        if (err.code === emptyWalletErrorCode) numberOfEmptyWallets += 1;
        else throw error;
    }
    if (sol_instance) try {
        const solanaAccounts = await (0, $7aYgM.getSolanaAccounts)({
            instance: sol_instance,
            meta: meta
        });
        results.push(solanaAccounts);
    } catch (error) {
        // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
        const err = error;
        if (err.code === emptyWalletErrorCode) numberOfEmptyWallets += 1;
        else throw error;
    }
    if (numberOfEmptyWallets === instance.size) throw new Error(emptyWalletCustomErrorMessage);
    return results;
};
const $efe06be440deeb8d$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, meta: meta, state: state, updateChainId: updateChainId })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const sol_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $8aS14.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleEvmChainChanged = (chainId)=>{
        updateChainId(chainId);
    };
    const handleSolanaAccountsChanged = async ()=>{
        if (state.network != (0, $8aS14.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $21GQj.isSolanaBlockchain))[0].chainId);
        const response = await sol_instance.connect();
        const account = response.publicKey.toString();
        updateAccounts([
            account
        ]);
    };
    evm_instance?.on?.("accountsChanged", handleEvmAccountsChanged);
    evm_instance?.on?.("chainChanged", handleEvmChainChanged);
    sol_instance?.on?.("accountChanged", handleSolanaAccountsChanged);
    return ()=>{
        evm_instance?.off?.("accountsChanged", handleEvmAccountsChanged);
        evm_instance?.off?.("chainChanged", handleEvmChainChanged);
        sol_instance?.off?.("accountChanged", handleSolanaAccountsChanged);
    };
};
const $efe06be440deeb8d$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $efe06be440deeb8d$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $efe06be440deeb8d$export$6352a17a50193ded = (0, $5c7d61ee05e1517a$export$2e2bcd8739ae039);
const $efe06be440deeb8d$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $efe06be440deeb8d$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Brave",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/brave/icon.svg",
        installLink: {
            DEFAULT: "https://brave.com/wallet/"
        },
        color: "#ef342f",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $ff7388b706660096$exports = {};

$parcel$export($ff7388b706660096$exports, "config", function () { return $ff7388b706660096$export$e506a1d27d1eaa20; });
$parcel$export($ff7388b706660096$exports, "getInstance", function () { return $ff7388b706660096$export$8bedcca5bbd73999; });
$parcel$export($ff7388b706660096$exports, "connect", function () { return $ff7388b706660096$export$64605811ab45167f; });
$parcel$export($ff7388b706660096$exports, "subscribe", function () { return $ff7388b706660096$export$ec068583843480e7; });
$parcel$export($ff7388b706660096$exports, "switchNetwork", function () { return $ff7388b706660096$export$f3473d805e486329; });
$parcel$export($ff7388b706660096$exports, "canSwitchNetworkTo", function () { return $ff7388b706660096$export$3b3cf9ab9019de20; });
$parcel$export($ff7388b706660096$exports, "getSigners", function () { return $ff7388b706660096$export$6352a17a50193ded; });
$parcel$export($ff7388b706660096$exports, "canEagerConnect", function () { return $ff7388b706660096$export$be9f3c5ed1d25e42; });
$parcel$export($ff7388b706660096$exports, "getWalletInfo", function () { return $ff7388b706660096$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $91427b230cbeecd1$export$a716877156479c99() {
    const { clover: clover, clover_solana: clover_solana } = window;
    if (!clover) return null;
    const instances = new Map();
    if (clover) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, clover);
    if (clover_solana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, clover_solana);
    return instances;
}
async function $91427b230cbeecd1$export$78e7a9381dd8e059(instances) {
    const solanaInstance = instances.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaAccounts = await solanaInstance.getAccount();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $912dbf18bf391edd$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("614yl"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $ff7388b706660096$var$WALLET = (0, $yEwlv.WalletTypes).CLOVER;
const $ff7388b706660096$export$e506a1d27d1eaa20 = {
    type: $ff7388b706660096$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $ff7388b706660096$export$8bedcca5bbd73999 = (0, $91427b230cbeecd1$export$a716877156479c99);
const $ff7388b706660096$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push({
            chainId: evmResult?.chainId,
            accounts: evmResult?.accounts.length > 0 ? [
                evmResult.accounts[0]
            ] : []
        });
    }
    const nonEvmResults = await (0, $91427b230cbeecd1$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $ff7388b706660096$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, state: state, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).SOLANA);
    ethInstance?.on?.("accountsChanged", async (addresses)=>{
        if (state.connected) {
            if (ethInstance) {
                const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
                updateAccounts(addresses, eth_chainId);
            }
            if (solanaInstance) {
                const solanaAccount = await solanaInstance.getAccount();
                updateAccounts([
                    solanaAccount
                ], (0, $8aS14.LegacyNetworks).SOLANA);
            }
        }
    });
};
const $ff7388b706660096$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $bHRZL.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $ff7388b706660096$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $ff7388b706660096$export$6352a17a50193ded = (0, $912dbf18bf391edd$export$2e2bcd8739ae039);
const $ff7388b706660096$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $ff7388b706660096$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Clover",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/clover/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/clover-wallet/nhnkbkgjikgcigadomkphalanndcapjk",
            BRAVE: "https://chrome.google.com/webstore/detail/clover-wallet/nhnkbkgjikgcigadomkphalanndcapjk",
            DEFAULT: "https://wallet.clover.finance"
        },
        color: "#96e7ed",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $e2f989be5c77ee12$exports = {};

$parcel$export($e2f989be5c77ee12$exports, "config", function () { return $e2f989be5c77ee12$export$e506a1d27d1eaa20; });
$parcel$export($e2f989be5c77ee12$exports, "getInstance", function () { return $e2f989be5c77ee12$export$8bedcca5bbd73999; });
$parcel$export($e2f989be5c77ee12$exports, "connect", function () { return $e2f989be5c77ee12$export$64605811ab45167f; });
$parcel$export($e2f989be5c77ee12$exports, "subscribe", function () { return $e2f989be5c77ee12$export$ec068583843480e7; });
$parcel$export($e2f989be5c77ee12$exports, "switchNetwork", function () { return $e2f989be5c77ee12$export$f3473d805e486329; });
$parcel$export($e2f989be5c77ee12$exports, "canSwitchNetworkTo", function () { return $e2f989be5c77ee12$export$3b3cf9ab9019de20; });
$parcel$export($e2f989be5c77ee12$exports, "getSigners", function () { return $e2f989be5c77ee12$export$6352a17a50193ded; });
$parcel$export($e2f989be5c77ee12$exports, "getWalletInfo", function () { return $e2f989be5c77ee12$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $2081a47386a9630f$export$98327fbacb25d5d5() {
    const { coin98: coin98, ethereum: ethereum } = window;
    if (!coin98) return null;
    const instances = new Map();
    // When disabled overring metamask
    if (coin98.provider) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, coin98.provider);
    if (ethereum && ethereum.isCoin98) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, ethereum);
    if (coin98.sol) instances.set((0, $8aS14.LegacyNetworks).SOLANA, coin98.sol);
    return instances;
}
async function $2081a47386a9630f$export$a009f0f0c363aa6c(instance) {
    await instance.enable();
    const accounts = await instance.request({
        method: "sol_accounts"
    });
    return {
        accounts: accounts
    };
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $b2fb5c14ce2dcaac$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("anyT5"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $e2f989be5c77ee12$var$WALLET = (0, $yEwlv.WalletTypes).COIN98;
const $e2f989be5c77ee12$export$e506a1d27d1eaa20 = {
    type: $e2f989be5c77ee12$var$WALLET,
    // TODO: Get from evm networks
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $e2f989be5c77ee12$export$8bedcca5bbd73999 = (0, $2081a47386a9630f$export$98327fbacb25d5d5);
const $e2f989be5c77ee12$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const sol_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const evm = await (0, $bHRZL.getEvmAccounts)(evm_instance);
    const { accounts: solanaAccounts } = await (0, $2081a47386a9630f$export$a009f0f0c363aa6c)(sol_instance);
    return [
        evm,
        {
            accounts: solanaAccounts,
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        }
    ];
};
const $e2f989be5c77ee12$export$ec068583843480e7 = ({ instance: instance, meta: meta, updateChainId: updateChainId, connect: connect })=>{
    const eth = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const handleChainChanged = (chainId)=>{
        const network = (0, $8aS14.legacyGetBlockChainNameFromId)(chainId, meta) || (0, $8aS14.LegacyNetworks).Unknown;
        const targetInstance = (0, $bHRZL.chooseInstance)(instance, meta, network);
        targetInstance.request({
            method: "eth_requestAccounts"
        }).then(()=>undefined).catch((err)=>{
            console.log({
                err: err
            });
        });
        /*
     *TODO:
     *We are calling `connect` here because signer can't detect
     *currect network, I guess the bug is in our signer and it
     *gets the wrong network by calling a wrong method or something.
     *Anyways, this works for now, maybe we can reconsider it in future
     *Whenever we refactored the signer code as well.
     */ /*
     *  we need to update `network` first, if not, it will goes through
     * the switching network and will open unneccessary pop ups.
     */ updateChainId(chainId);
        connect(network);
    };
    eth?.on?.("chainChanged", handleChainChanged);
    return ()=>{
        eth?.off?.("chainChanged", handleChainChanged);
    };
};
const $e2f989be5c77ee12$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $bHRZL.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $e2f989be5c77ee12$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $e2f989be5c77ee12$export$6352a17a50193ded = (0, $b2fb5c14ce2dcaac$export$2e2bcd8739ae039);
const $e2f989be5c77ee12$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Coin98",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coin98/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
            BRAVE: "https://chrome.google.com/webstore/detail/coin98-wallet/aeachknmefphepccionboohckonoeemg",
            DEFAULT: "https://coin98.com/wallet"
        },
        color: "#1d1c25",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $1f0372b1cf0a204d$exports = {};

$parcel$export($1f0372b1cf0a204d$exports, "config", function () { return $1f0372b1cf0a204d$export$e506a1d27d1eaa20; });
$parcel$export($1f0372b1cf0a204d$exports, "getInstance", function () { return $1f0372b1cf0a204d$export$8bedcca5bbd73999; });
$parcel$export($1f0372b1cf0a204d$exports, "connect", function () { return $1f0372b1cf0a204d$export$64605811ab45167f; });
$parcel$export($1f0372b1cf0a204d$exports, "subscribe", function () { return $1f0372b1cf0a204d$export$ec068583843480e7; });
$parcel$export($1f0372b1cf0a204d$exports, "switchNetwork", function () { return $1f0372b1cf0a204d$export$f3473d805e486329; });
$parcel$export($1f0372b1cf0a204d$exports, "canSwitchNetworkTo", function () { return $1f0372b1cf0a204d$export$3b3cf9ab9019de20; });
$parcel$export($1f0372b1cf0a204d$exports, "getSigners", function () { return $1f0372b1cf0a204d$export$6352a17a50193ded; });
$parcel$export($1f0372b1cf0a204d$exports, "canEagerConnect", function () { return $1f0372b1cf0a204d$export$be9f3c5ed1d25e42; });
$parcel$export($1f0372b1cf0a204d$exports, "getWalletInfo", function () { return $1f0372b1cf0a204d$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $d52052175bc32e91$export$15e9669680853bb4() {
    const { coinbaseWalletExtension: coinbaseWalletExtension, coinbaseSolana: coinbaseSolana } = window;
    const instances = new Map();
    if (coinbaseWalletExtension) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, coinbaseWalletExtension);
    if (!!coinbaseSolana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, coinbaseSolana);
    if (instances.size === 0) return null;
    return instances;
}
async function $d52052175bc32e91$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        await solanaInstance.connect();
        const account = solanaInstance.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $f7b88a18a13aebd2$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("lcEHA"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $1f0372b1cf0a204d$var$WALLET = (0, $yEwlv.WalletTypes).COINBASE;
const $1f0372b1cf0a204d$export$e506a1d27d1eaa20 = {
    type: $1f0372b1cf0a204d$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $1f0372b1cf0a204d$export$8bedcca5bbd73999 = (0, $d52052175bc32e91$export$15e9669680853bb4);
const $1f0372b1cf0a204d$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (evm_instance) {
        const evm = await (0, $bHRZL.getEvmAccounts)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $d52052175bc32e91$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $1f0372b1cf0a204d$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $8aS14.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleSolanaAccountChanged = async (publicKey)=>{
        if (state.network != (0, $8aS14.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $21GQj.isSolanaBlockchain))[0].chainId);
        const network = (0, $8aS14.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    solanaInstance?.on?.("accountChanged", handleSolanaAccountChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
        solanaInstance?.off?.("accountChanged", handleSolanaAccountChanged);
    };
};
const $1f0372b1cf0a204d$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $1f0372b1cf0a204d$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $1f0372b1cf0a204d$export$6352a17a50193ded = (0, $f7b88a18a13aebd2$export$2e2bcd8739ae039);
const $1f0372b1cf0a204d$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $1f0372b1cf0a204d$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Coinbase",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/coinbase/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
            BRAVE: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
            DEFAULT: "https://www.coinbase.com/wallet"
        },
        color: "#2a62f5",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $ec2ba5c07821d2af$exports = {};

$parcel$export($ec2ba5c07821d2af$exports, "config", function () { return $ec2ba5c07821d2af$export$e506a1d27d1eaa20; });
$parcel$export($ec2ba5c07821d2af$exports, "getInstance", function () { return $ec2ba5c07821d2af$export$8bedcca5bbd73999; });
$parcel$export($ec2ba5c07821d2af$exports, "connect", function () { return $ec2ba5c07821d2af$export$64605811ab45167f; });
$parcel$export($ec2ba5c07821d2af$exports, "switchNetwork", function () { return $ec2ba5c07821d2af$export$f3473d805e486329; });
$parcel$export($ec2ba5c07821d2af$exports, "canSwitchNetworkTo", function () { return $ec2ba5c07821d2af$export$3b3cf9ab9019de20; });
$parcel$export($ec2ba5c07821d2af$exports, "subscribe", function () { return $ec2ba5c07821d2af$export$ec068583843480e7; });
$parcel$export($ec2ba5c07821d2af$exports, "suggest", function () { return $ec2ba5c07821d2af$export$b0b3f4ef5d856594; });
$parcel$export($ec2ba5c07821d2af$exports, "getSigners", function () { return $ec2ba5c07821d2af$export$6352a17a50193ded; });
$parcel$export($ec2ba5c07821d2af$exports, "canEagerConnect", function () { return $ec2ba5c07821d2af$export$be9f3c5ed1d25e42; });
$parcel$export($ec2ba5c07821d2af$exports, "getWalletInfo", function () { return $ec2ba5c07821d2af$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $jN5Ze = parcelRequire("jN5Ze");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $60c6b7dffe9c0253$export$f10fc90c2179d193() {
    const { cosmostation: cosmostation } = window;
    const instances = new Map();
    if (!cosmostation || !cosmostation.providers) return null;
    const evmInstance = cosmostation.providers.metamask;
    if (evmInstance) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, evmInstance);
    const cosmosInstance = cosmostation.providers.keplr;
    if (cosmosInstance) instances.set((0, $8aS14.LegacyNetworks).COSMOS, cosmosInstance);
    if (instances.size === 0) return null;
    return instances;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $d53f7552b3d78b4b$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const cosmosProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).COSMOS);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (parcelRequire("fRq6b"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}


const $ec2ba5c07821d2af$var$WALLET = (0, $yEwlv.WalletTypes).COSMOSTATION;
const $ec2ba5c07821d2af$export$e506a1d27d1eaa20 = {
    type: $ec2ba5c07821d2af$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).COSMOS
};
const $ec2ba5c07821d2af$export$8bedcca5bbd73999 = (0, $60c6b7dffe9c0253$export$f10fc90c2179d193);
const $ec2ba5c07821d2af$export$64605811ab45167f = async ({ instance: instance, meta: meta, network: network })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const cosmosInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).COSMOS);
    const results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push(evmResult);
    }
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((0, $21GQj.isCosmosBlockchain));
        const requestedNetwork = network || (0, $8aS14.LegacyNetworks).COSMOS;
        const comsmosResult = await (0, $jN5Ze.getCosmosAccounts)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: requestedNetwork
        });
        if (Array.isArray(comsmosResult)) results.push(...comsmosResult);
        else results.push(comsmosResult);
    }
    return results;
};
const $ec2ba5c07821d2af$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $ec2ba5c07821d2af$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $ec2ba5c07821d2af$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const ethInstance = instance.get((0, $8aS14.LegacyNetworks).ETHEREUM);
    const EvmBlockchainMeta = meta.filter((0, $21GQj.isEvmBlockchain));
    const cleanupEvm = (0, $bHRZL.subscribeToEvm)({
        instance: ethInstance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: EvmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    const handleCosmosAccountChanged = ()=>{
        disconnect();
        connect();
    };
    window.cosmostation.cosmos.on?.("accountChanged", handleCosmosAccountChanged);
    return ()=>{
        if (cleanupEvm) cleanupEvm();
        window.cosmostation.cosmos.off("accountChanged", handleCosmosAccountChanged);
    };
};
const $ec2ba5c07821d2af$export$b0b3f4ef5d856594 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const cosmosInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).COSMOS);
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((0, $21GQj.isCosmosBlockchain));
        await (0, $jN5Ze.suggestCosmosChain)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: network
        });
    }
};
const $ec2ba5c07821d2af$export$6352a17a50193ded = (0, $d53f7552b3d78b4b$export$2e2bcd8739ae039);
const $ec2ba5c07821d2af$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $ec2ba5c07821d2af$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const cosmos = (0, $21GQj.cosmosBlockchains)(allBlockChains);
    return {
        name: "Cosmostation",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/cosmostation/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf",
            BRAVE: "https://chrome.google.com/webstore/detail/cosmostation/fpkhgmpbidmiogeglndfbkegfdlnajnf",
            DEFAULT: "https://cosmostation.io/"
        },
        color: "black",
        supportedChains: [
            ...evms,
            ...cosmos
        ]
    };
};


var $7e8974fedb2f4ea9$exports = {};

$parcel$export($7e8974fedb2f4ea9$exports, "config", function () { return $7e8974fedb2f4ea9$export$e506a1d27d1eaa20; });
$parcel$export($7e8974fedb2f4ea9$exports, "getInstance", function () { return $7e8974fedb2f4ea9$export$8bedcca5bbd73999; });
$parcel$export($7e8974fedb2f4ea9$exports, "connect", function () { return $7e8974fedb2f4ea9$export$64605811ab45167f; });
$parcel$export($7e8974fedb2f4ea9$exports, "subscribe", function () { return $7e8974fedb2f4ea9$export$ec068583843480e7; });
$parcel$export($7e8974fedb2f4ea9$exports, "switchNetwork", function () { return $7e8974fedb2f4ea9$export$f3473d805e486329; });
$parcel$export($7e8974fedb2f4ea9$exports, "canSwitchNetworkTo", function () { return $7e8974fedb2f4ea9$export$3b3cf9ab9019de20; });
$parcel$export($7e8974fedb2f4ea9$exports, "getSigners", function () { return $7e8974fedb2f4ea9$export$6352a17a50193ded; });
$parcel$export($7e8974fedb2f4ea9$exports, "canEagerConnect", function () { return $7e8974fedb2f4ea9$export$be9f3c5ed1d25e42; });
$parcel$export($7e8974fedb2f4ea9$exports, "getWalletInfo", function () { return $7e8974fedb2f4ea9$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $668d68f3766f5db2$export$9526fb4b4acd9f98() {
    const { ethereum: ethereum } = window;
    return ethereum ?? null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $ddd286bd4369e4ae$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $7e8974fedb2f4ea9$var$WALLET = (0, $yEwlv.WalletTypes).DEFAULT;
const $7e8974fedb2f4ea9$export$e506a1d27d1eaa20 = {
    type: $7e8974fedb2f4ea9$var$WALLET
};
const $7e8974fedb2f4ea9$export$8bedcca5bbd73999 = (0, $668d68f3766f5db2$export$9526fb4b4acd9f98);
const $7e8974fedb2f4ea9$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $7e8974fedb2f4ea9$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $7e8974fedb2f4ea9$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $7e8974fedb2f4ea9$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $7e8974fedb2f4ea9$export$6352a17a50193ded = (0, $ddd286bd4369e4ae$export$2e2bcd8739ae039);
const $7e8974fedb2f4ea9$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $7e8974fedb2f4ea9$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Default",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/default/icon.svg",
        installLink: {
            DEFAULT: "https://metamask.io/download/"
        },
        color: "#dac7ae",
        supportedChains: evms
    };
};


var $cf16142e144057c5$exports = {};

$parcel$export($cf16142e144057c5$exports, "getInstance", function () { return $cf16142e144057c5$export$8bedcca5bbd73999; });
$parcel$export($cf16142e144057c5$exports, "config", function () { return $cf16142e144057c5$export$e506a1d27d1eaa20; });
$parcel$export($cf16142e144057c5$exports, "connect", function () { return $cf16142e144057c5$export$64605811ab45167f; });
$parcel$export($cf16142e144057c5$exports, "subscribe", function () { return $cf16142e144057c5$export$ec068583843480e7; });
$parcel$export($cf16142e144057c5$exports, "switchNetwork", function () { return $cf16142e144057c5$export$f3473d805e486329; });
$parcel$export($cf16142e144057c5$exports, "canSwitchNetworkTo", function () { return $cf16142e144057c5$export$3b3cf9ab9019de20; });
$parcel$export($cf16142e144057c5$exports, "getSigners", function () { return $cf16142e144057c5$export$6352a17a50193ded; });
$parcel$export($cf16142e144057c5$exports, "canEagerConnect", function () { return $cf16142e144057c5$export$be9f3c5ed1d25e42; });
$parcel$export($cf16142e144057c5$exports, "getWalletInfo", function () { return $cf16142e144057c5$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $f7ac59f6d51fefc4$export$a44e33b8de461ecd() {
    const { enkrypt: enkrypt } = window;
    const ethereum = enkrypt?.providers?.ethereum;
    if (!ethereum) return null;
    return ethereum;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $8fdc5cbd9fb3452c$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $cf16142e144057c5$export$8bedcca5bbd73999 = (0, $f7ac59f6d51fefc4$export$a44e33b8de461ecd);
const $cf16142e144057c5$var$WALLET = (0, $yEwlv.WalletTypes).ENKRYPT;
const $cf16142e144057c5$export$e506a1d27d1eaa20 = {
    type: $cf16142e144057c5$var$WALLET
};
const $cf16142e144057c5$export$64605811ab45167f = async ({ instance: instance })=>{
    const result = await (0, $bHRZL.getEvmAccounts)(instance);
    const { chainId: chainId } = result;
    let { accounts: accounts } = result;
    if (accounts.length > 1) accounts = [
        instance.selectedAddress
    ];
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $cf16142e144057c5$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $cf16142e144057c5$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $cf16142e144057c5$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $cf16142e144057c5$export$6352a17a50193ded = (0, $8fdc5cbd9fb3452c$export$2e2bcd8739ae039);
const $cf16142e144057c5$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $cf16142e144057c5$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Enkrypt",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/enkrypt/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/enkrypt/",
            BRAVE: "https://chrome.google.com/webstore/detail/enkrypt/kkpllkodjeloidieedojogacfhpaihoh",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/enkrypt-ethereum-polkad/gfenajajnjjmmdojhdjmnngomkhlnfjl",
            DEFAULT: "https://www.enkrypt.com/"
        },
        color: "#fff",
        supportedChains: evms
    };
};


var $18d70c9a3b02d0e0$exports = {};

$parcel$export($18d70c9a3b02d0e0$exports, "config", function () { return $18d70c9a3b02d0e0$export$e506a1d27d1eaa20; });
$parcel$export($18d70c9a3b02d0e0$exports, "getInstance", function () { return $18d70c9a3b02d0e0$export$8bedcca5bbd73999; });
$parcel$export($18d70c9a3b02d0e0$exports, "connect", function () { return $18d70c9a3b02d0e0$export$64605811ab45167f; });
$parcel$export($18d70c9a3b02d0e0$exports, "subscribe", function () { return $18d70c9a3b02d0e0$export$ec068583843480e7; });
$parcel$export($18d70c9a3b02d0e0$exports, "switchNetwork", function () { return $18d70c9a3b02d0e0$export$f3473d805e486329; });
$parcel$export($18d70c9a3b02d0e0$exports, "canSwitchNetworkTo", function () { return $18d70c9a3b02d0e0$export$3b3cf9ab9019de20; });
$parcel$export($18d70c9a3b02d0e0$exports, "getSigners", function () { return $18d70c9a3b02d0e0$export$6352a17a50193ded; });
$parcel$export($18d70c9a3b02d0e0$exports, "canEagerConnect", function () { return $18d70c9a3b02d0e0$export$be9f3c5ed1d25e42; });
$parcel$export($18d70c9a3b02d0e0$exports, "getWalletInfo", function () { return $18d70c9a3b02d0e0$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $0c854e6def446826$export$4615eefcbfd0c799() {
    const { exodus: exodus } = window;
    if (!exodus) return null;
    const instances = new Map();
    if (exodus.ethereum) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, exodus.ethereum);
    if (exodus.solana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, exodus.solana);
    return instances;
}
async function $0c854e6def446826$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const account = solanaResponse.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}
const $0c854e6def446826$export$1ac55c078823cdb2 = [
    (0, $8aS14.LegacyNetworks).SOLANA,
    (0, $8aS14.LegacyNetworks).ETHEREUM,
    (0, $8aS14.LegacyNetworks).BSC,
    (0, $8aS14.LegacyNetworks).POLYGON,
    (0, $8aS14.LegacyNetworks).AVAX_CCHAIN
];


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $6149162125c09e42$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("fs5wa"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $18d70c9a3b02d0e0$var$WALLET = (0, $yEwlv.WalletTypes).EXODUS;
const $18d70c9a3b02d0e0$export$e506a1d27d1eaa20 = {
    type: $18d70c9a3b02d0e0$var$WALLET,
    // TODO: Get from evm networks
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $18d70c9a3b02d0e0$export$8bedcca5bbd73999 = (0, $0c854e6def446826$export$4615eefcbfd0c799);
const $18d70c9a3b02d0e0$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (evm_instance) {
        const evm = await (0, $bHRZL.getEvmAccounts)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $0c854e6def446826$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $18d70c9a3b02d0e0$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    ethInstance?.on?.("accountsChanged", (addresses)=>{
        const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $8aS14.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    });
    solanaInstance?.on?.("accountChanged", async (publicKey)=>{
        if (state.network != (0, $8aS14.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $21GQj.isSolanaBlockchain))[0].chainId);
        const network = (0, $8aS14.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    });
};
const $18d70c9a3b02d0e0$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $bHRZL.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $18d70c9a3b02d0e0$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $18d70c9a3b02d0e0$export$6352a17a50193ded = (0, $6149162125c09e42$export$2e2bcd8739ae039);
const $18d70c9a3b02d0e0$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $18d70c9a3b02d0e0$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: "Exodus",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/exodus/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno",
            BRAVE: "https://chrome.google.com/webstore/detail/exodus-web3-wallet/aholpfdialjgjfhomihkjbmgjidlcdno",
            DEFAULT: "https://www.exodus.com/"
        },
        color: "#8f70fa",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $0c854e6def446826$export$1ac55c078823cdb2).includes(blockchainMeta.name))
    });


var $c6811752435011fa$exports = {};

$parcel$export($c6811752435011fa$exports, "config", function () { return $c6811752435011fa$export$e506a1d27d1eaa20; });
$parcel$export($c6811752435011fa$exports, "getInstance", function () { return $c6811752435011fa$export$8bedcca5bbd73999; });
$parcel$export($c6811752435011fa$exports, "connect", function () { return $c6811752435011fa$export$64605811ab45167f; });
$parcel$export($c6811752435011fa$exports, "subscribe", function () { return $c6811752435011fa$export$ec068583843480e7; });
$parcel$export($c6811752435011fa$exports, "switchNetwork", function () { return $c6811752435011fa$export$f3473d805e486329; });
$parcel$export($c6811752435011fa$exports, "canSwitchNetworkTo", function () { return $c6811752435011fa$export$3b3cf9ab9019de20; });
$parcel$export($c6811752435011fa$exports, "getSigners", function () { return $c6811752435011fa$export$6352a17a50193ded; });
$parcel$export($c6811752435011fa$exports, "canEagerConnect", function () { return $c6811752435011fa$export$be9f3c5ed1d25e42; });
$parcel$export($c6811752435011fa$exports, "getWalletInfo", function () { return $c6811752435011fa$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $ba49b4ad0f69ebb6$export$83bfb1870d005a15() {
    const { frontier: frontier } = window;
    if (!frontier) return null;
    const instances = new Map();
    if (frontier?.ethereum) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, frontier?.ethereum);
    if (frontier?.solana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, frontier?.solana);
    return instances;
}
async function $ba49b4ad0f69ebb6$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        await solanaInstance.connect();
        const account = solanaInstance.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $22091e94ae1472a1$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await Promise.resolve((parcelRequire("jMEJx")));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    return signers;
}


const $c6811752435011fa$var$WALLET = (0, $yEwlv.WalletTypes).FRONTIER;
const $c6811752435011fa$export$e506a1d27d1eaa20 = {
    type: $c6811752435011fa$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $c6811752435011fa$export$8bedcca5bbd73999 = (0, $ba49b4ad0f69ebb6$export$83bfb1870d005a15);
const $c6811752435011fa$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push({
            chainId: evmResult?.chainId,
            accounts: evmResult?.accounts.length > 0 ? [
                evmResult.accounts[0]
            ] : []
        });
    }
    const solanaResults = await (0, $ba49b4ad0f69ebb6$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $c6811752435011fa$export$ec068583843480e7 = (options)=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solanaInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const { connect: connect, updateAccounts: updateAccounts, state: state, updateChainId: updateChainId, meta: meta } = options;
    const handleEvmAccountsChanged = (addresses)=>{
        const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
        if (state.connected) {
            if (state.network != (0, $8aS14.LegacyNetworks).ETHEREUM && eth_chainId) updateChainId(eth_chainId);
            updateAccounts(addresses);
        }
    };
    const handleSolanaAccountsChanged = async (publicKey)=>{
        if (state.network != (0, $8aS14.LegacyNetworks).SOLANA) updateChainId(meta.filter((0, $21GQj.isSolanaBlockchain))[0].chainId);
        const network = (0, $8aS14.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    solanaInstance?.on?.("accountChanged", handleSolanaAccountsChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
        solanaInstance?.off?.("accountChanged", handleSolanaAccountsChanged);
    };
};
const $c6811752435011fa$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $bHRZL.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $c6811752435011fa$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $c6811752435011fa$export$6352a17a50193ded = (0, $22091e94ae1472a1$export$2e2bcd8739ae039);
const $c6811752435011fa$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $c6811752435011fa$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Frontier",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/frontier/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
            BRAVE: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
            DEFAULT: "https://www.frontier.xyz"
        },
        color: "#4d40c6",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $97ef826e62a1917c$exports = {};

$parcel$export($97ef826e62a1917c$exports, "config", function () { return $97ef826e62a1917c$export$e506a1d27d1eaa20; });
$parcel$export($97ef826e62a1917c$exports, "getInstance", function () { return $97ef826e62a1917c$export$8bedcca5bbd73999; });
$parcel$export($97ef826e62a1917c$exports, "connect", function () { return $97ef826e62a1917c$export$64605811ab45167f; });
$parcel$export($97ef826e62a1917c$exports, "subscribe", function () { return $97ef826e62a1917c$export$ec068583843480e7; });
$parcel$export($97ef826e62a1917c$exports, "switchNetwork", function () { return $97ef826e62a1917c$export$f3473d805e486329; });
$parcel$export($97ef826e62a1917c$exports, "canSwitchNetworkTo", function () { return $97ef826e62a1917c$export$3b3cf9ab9019de20; });
$parcel$export($97ef826e62a1917c$exports, "getSigners", function () { return $97ef826e62a1917c$export$6352a17a50193ded; });
$parcel$export($97ef826e62a1917c$exports, "getWalletInfo", function () { return $97ef826e62a1917c$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $922a5144b098da97$export$3b7573e5a32832d4() {
    const { kucoin: kucoin } = window;
    if (kucoin && kucoin.isKuCoinWallet) return kucoin;
    return null;
}
const $922a5144b098da97$export$667e61432fbd2423 = [
    (0, $8aS14.LegacyNetworks).ETHEREUM,
    (0, $8aS14.LegacyNetworks).POLYGON,
    (0, $8aS14.LegacyNetworks).BSC
];


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $a33e7b40c64ee882$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}


const $97ef826e62a1917c$var$WALLET = (0, $yEwlv.WalletTypes).HALO;
const $97ef826e62a1917c$export$e506a1d27d1eaa20 = {
    type: $97ef826e62a1917c$var$WALLET
};
const $97ef826e62a1917c$export$8bedcca5bbd73999 = (0, $922a5144b098da97$export$3b7573e5a32832d4);
const $97ef826e62a1917c$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $97ef826e62a1917c$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $97ef826e62a1917c$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $97ef826e62a1917c$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $97ef826e62a1917c$export$6352a17a50193ded = (0, $a33e7b40c64ee882$export$2e2bcd8739ae039);
const $97ef826e62a1917c$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    return {
        name: "Halo",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/halo/icon.svg",
        color: "#b2dbff",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/halo-wallet/nbdpmlhambbdkhkmbfpljckjcmgibalo",
            BRAVE: "https://chrome.google.com/webstore/detail/halo-wallet/nbdpmlhambbdkhkmbfpljckjcmgibalo",
            DEFAULT: "https://halo.social/"
        },
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $922a5144b098da97$export$667e61432fbd2423).includes(blockchainMeta.name))
    };
};


var $dd12b1eb60b48a5f$exports = {};

$parcel$export($dd12b1eb60b48a5f$exports, "config", function () { return $dd12b1eb60b48a5f$export$e506a1d27d1eaa20; });
$parcel$export($dd12b1eb60b48a5f$exports, "getInstance", function () { return $dd12b1eb60b48a5f$export$8bedcca5bbd73999; });
$parcel$export($dd12b1eb60b48a5f$exports, "connect", function () { return $dd12b1eb60b48a5f$export$64605811ab45167f; });
$parcel$export($dd12b1eb60b48a5f$exports, "subscribe", function () { return $dd12b1eb60b48a5f$export$ec068583843480e7; });
$parcel$export($dd12b1eb60b48a5f$exports, "suggest", function () { return $dd12b1eb60b48a5f$export$b0b3f4ef5d856594; });
$parcel$export($dd12b1eb60b48a5f$exports, "getSigners", function () { return $dd12b1eb60b48a5f$export$6352a17a50193ded; });
$parcel$export($dd12b1eb60b48a5f$exports, "getWalletInfo", function () { return $dd12b1eb60b48a5f$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $jN5Ze = parcelRequire("jN5Ze");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $4fc18cc982243f9f$export$6ebea13480cb087e() {
    return window.keplr || null;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $383eaa869791bbfd$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).COSMOS);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (parcelRequire("fRq6b"));
    signers.registerSigner((0, $liigz.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}


const $dd12b1eb60b48a5f$var$WALLET = (0, $yEwlv.WalletTypes).KEPLR;
const $dd12b1eb60b48a5f$export$e506a1d27d1eaa20 = {
    type: $dd12b1eb60b48a5f$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).COSMOS
};
const $dd12b1eb60b48a5f$export$8bedcca5bbd73999 = (0, $4fc18cc982243f9f$export$6ebea13480cb087e);
const $dd12b1eb60b48a5f$export$64605811ab45167f = async ({ instance: instance, network: network, meta: meta })=>{
    return await (0, $jN5Ze.getCosmosAccounts)({
        instance: instance,
        meta: meta,
        network: network
    });
};
const $dd12b1eb60b48a5f$export$ec068583843480e7 = ({ connect: connect, disconnect: disconnect })=>{
    const handleAccountsChanged = ()=>{
        disconnect();
        connect();
    };
    window.addEventListener("keplr_keystorechange", handleAccountsChanged);
    return ()=>{
        window.removeEventListener("keplr_keystorechange", handleAccountsChanged);
    };
};
const $dd12b1eb60b48a5f$export$b0b3f4ef5d856594 = (0, $jN5Ze.suggestCosmosChain);
const $dd12b1eb60b48a5f$export$6352a17a50193ded = (0, $383eaa869791bbfd$export$2e2bcd8739ae039);
const $dd12b1eb60b48a5f$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const cosmos = (0, $21GQj.cosmosBlockchains)(allBlockChains);
    return {
        name: "Keplr",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/keplr/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            BRAVE: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/keplr",
            DEFAULT: "https://www.keplr.app"
        },
        color: "#3898e5",
        supportedChains: cosmos.filter((blockchainMeta)=>!!blockchainMeta.info)
    };
};


var $9c8858e43ac876c2$exports = {};

$parcel$export($9c8858e43ac876c2$exports, "config", function () { return $9c8858e43ac876c2$export$e506a1d27d1eaa20; });
$parcel$export($9c8858e43ac876c2$exports, "getInstance", function () { return $9c8858e43ac876c2$export$8bedcca5bbd73999; });
$parcel$export($9c8858e43ac876c2$exports, "connect", function () { return $9c8858e43ac876c2$export$64605811ab45167f; });
$parcel$export($9c8858e43ac876c2$exports, "subscribe", function () { return $9c8858e43ac876c2$export$ec068583843480e7; });
$parcel$export($9c8858e43ac876c2$exports, "suggest", function () { return $9c8858e43ac876c2$export$b0b3f4ef5d856594; });
$parcel$export($9c8858e43ac876c2$exports, "getSigners", function () { return $9c8858e43ac876c2$export$6352a17a50193ded; });
$parcel$export($9c8858e43ac876c2$exports, "getWalletInfo", function () { return $9c8858e43ac876c2$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $jN5Ze = parcelRequire("jN5Ze");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $bd458827162df792$export$b091593a1da89c86() {
    const { leap: leap } = window;
    if (!!leap) return leap;
    return null;
}
async function $bd458827162df792$export$6588b8d892e2b6de(instance) {
    return instance.getSupportedChains();
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $0afb81ed36588585$export$2e2bcd8739ae039(provider) {
    const cosmosProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).COSMOS);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultCosmosSigner: DefaultCosmosSigner } = await (parcelRequire("fRq6b"));
    signers.registerSigner((0, $liigz.TransactionType).COSMOS, new DefaultCosmosSigner(cosmosProvider));
    return signers;
}


const $9c8858e43ac876c2$var$WALLET = (0, $yEwlv.WalletTypes).LEAP_COSMOS;
const $9c8858e43ac876c2$export$e506a1d27d1eaa20 = {
    type: $9c8858e43ac876c2$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).COSMOS
};
// TODO: check supported valid chain name : Some chain have different names
const $9c8858e43ac876c2$var$supportedChainWithDifferentName = [
    (0, $8aS14.LegacyNetworks).COSMOS.toLowerCase(),
    (0, $8aS14.LegacyNetworks).KI.toLowerCase(),
    (0, $8aS14.LegacyNetworks).SECRET.toLowerCase(),
    (0, $8aS14.LegacyNetworks).TERRA.toLowerCase()
];
const $9c8858e43ac876c2$export$8bedcca5bbd73999 = (0, $bd458827162df792$export$b091593a1da89c86);
const $9c8858e43ac876c2$export$64605811ab45167f = async ({ instance: instance, network: network, meta: meta })=>{
    const supportedChains = await (0, $bd458827162df792$export$6588b8d892e2b6de)(instance);
    const leapBlockchainMeta = meta.filter((chain)=>{
        const isChainSupported = supportedChains.includes(chain.name.toLowerCase());
        const isNetworkMatch = chain.name === network;
        const isDifferentNameSupported = $9c8858e43ac876c2$var$supportedChainWithDifferentName.includes(chain.name.toLocaleLowerCase());
        return chain.enabled && (isChainSupported || isNetworkMatch || isDifferentNameSupported);
    });
    const results = await (0, $jN5Ze.getCosmosAccounts)({
        instance: instance,
        meta: leapBlockchainMeta,
        network: network || (0, $8aS14.LegacyNetworks).COSMOS
    });
    return results;
};
const $9c8858e43ac876c2$export$ec068583843480e7 = ({ connect: connect, disconnect: disconnect })=>{
    const handleAccountsChanged = ()=>{
        disconnect();
        connect();
    };
    window.addEventListener("leap_keystorechange", handleAccountsChanged);
    return ()=>{
        window.removeEventListener("leap_keystorechange", handleAccountsChanged);
    };
};
const $9c8858e43ac876c2$export$b0b3f4ef5d856594 = async (options)=>{
    const { instance: instance, meta: meta, network: network } = options;
    const supportedChains = await (0, $bd458827162df792$export$6588b8d892e2b6de)(instance);
    const leapBlockchainMeta = meta.filter((chain)=>{
        const isChainSupported = supportedChains.includes(chain.name.toLowerCase());
        const isNetworkMatch = chain.name === network;
        const isDifferentNameSupported = $9c8858e43ac876c2$var$supportedChainWithDifferentName.includes(chain.name.toLocaleLowerCase());
        return chain.enabled && (isChainSupported || isNetworkMatch || isDifferentNameSupported);
    });
    await (0, $jN5Ze.suggestCosmosChain)({
        instance: instance,
        meta: leapBlockchainMeta,
        network: network
    });
};
const $9c8858e43ac876c2$export$6352a17a50193ded = (0, $0afb81ed36588585$export$2e2bcd8739ae039);
const $9c8858e43ac876c2$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const cosmos = (0, $21GQj.cosmosBlockchains)(allBlockChains);
    return {
        name: "Leap Cosmos",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/leap-cosmos/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg",
            BRAVE: "https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg",
            DEFAULT: "https://www.leapwallet.io/cosmos"
        },
        color: "black",
        supportedChains: cosmos.filter((blockchainMeta)=>!!blockchainMeta.info)
    };
};


var $b06d3627b37a3467$exports = {};

$parcel$export($b06d3627b37a3467$exports, "config", function () { return $b06d3627b37a3467$export$e506a1d27d1eaa20; });
$parcel$export($b06d3627b37a3467$exports, "getInstance", function () { return $b06d3627b37a3467$export$8bedcca5bbd73999; });
$parcel$export($b06d3627b37a3467$exports, "connect", function () { return $b06d3627b37a3467$export$64605811ab45167f; });
$parcel$export($b06d3627b37a3467$exports, "disconnect", function () { return $b06d3627b37a3467$export$37dfea93db2e14ed; });
$parcel$export($b06d3627b37a3467$exports, "getSigners", function () { return $b06d3627b37a3467$export$6352a17a50193ded; });
$parcel$export($b06d3627b37a3467$exports, "getWalletInfo", function () { return $b06d3627b37a3467$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");

var $9IKPT = parcelRequire("9IKPT");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $805f062cbed859fb$export$2e2bcd8739ae039() {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { EthereumSigner: EthereumSigner } = await (parcelRequire("cfbE8"));
    const { SolanaSigner: SolanaSigner } = await (parcelRequire("9taAx"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new EthereumSigner());
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new SolanaSigner());
    return signers;
}



var $53JAW = parcelRequire("53JAW");
const $b06d3627b37a3467$export$e506a1d27d1eaa20 = {
    type: (0, $yEwlv.WalletTypes).LEDGER
};
const $b06d3627b37a3467$export$8bedcca5bbd73999 = (0, $9IKPT.getLedgerInstance);
const $b06d3627b37a3467$export$64605811ab45167f = async ({ namespaces: namespaces })=>{
    const results = [];
    const solanaNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === (0, $8aS14.LegacyNamespace).Solana);
    const evmNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === (0, $8aS14.LegacyNamespace).Evm);
    if (solanaNamespace) {
        if (solanaNamespace.derivationPath) {
            (0, $53JAW.setDerivationPath)(solanaNamespace.derivationPath);
            const accounts = await (0, $9IKPT.getSolanaAccounts)();
            results.push(accounts);
        } else throw new Error("Derivation Path can not be empty.");
    } else if (evmNamespace) {
        if (evmNamespace.derivationPath) {
            (0, $53JAW.setDerivationPath)(evmNamespace.derivationPath);
            const accounts = await (0, $9IKPT.getEthereumAccounts)();
            results.push(accounts);
        } else throw new Error("Derivation Path can not be empty.");
    } else throw new Error(`It appears that you have selected a namespace that is not yet supported by our system. Your namespaces: ${namespaces?.map((namespaceItem)=>namespaceItem.namespace)}`);
    return results;
};
const $b06d3627b37a3467$export$37dfea93db2e14ed = async ()=>{
    (0, $9IKPT.transportDisconnect)();
};
const $b06d3627b37a3467$export$6352a17a50193ded = (0, $805f062cbed859fb$export$2e2bcd8739ae039);
const $b06d3627b37a3467$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedChains = [];
    const ethereumBlockchain = allBlockChains.find((chain)=>chain.name === (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (ethereumBlockchain) supportedChains.push(ethereumBlockchain);
    const solanaBlockchain = allBlockChains.find((chain)=>chain.name === (0, $8aS14.LegacyNetworks).SOLANA);
    if (solanaBlockchain) supportedChains.push(solanaBlockchain);
    return {
        name: "Ledger",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/ledger/icon.svg",
        installLink: {
            DEFAULT: "https://support.ledger.com/hc/en-us/articles/4404389606417-Download-and-install-Ledger-Live?docs=true"
        },
        color: "black",
        supportedChains: supportedChains,
        namespaces: [
            (0, $8aS14.LegacyNamespace).Evm,
            (0, $8aS14.LegacyNamespace).Solana
        ],
        singleNamespace: true,
        showOnMobile: false,
        needsDerivationPath: true
    };
};


var $7a4eb50ac5cae5a3$exports = {};

$parcel$export($7a4eb50ac5cae5a3$exports, "config", function () { return $7a4eb50ac5cae5a3$export$e506a1d27d1eaa20; });
$parcel$export($7a4eb50ac5cae5a3$exports, "getInstance", function () { return $7a4eb50ac5cae5a3$export$8bedcca5bbd73999; });
$parcel$export($7a4eb50ac5cae5a3$exports, "connect", function () { return $7a4eb50ac5cae5a3$export$64605811ab45167f; });
$parcel$export($7a4eb50ac5cae5a3$exports, "subscribe", function () { return $7a4eb50ac5cae5a3$export$ec068583843480e7; });
$parcel$export($7a4eb50ac5cae5a3$exports, "canSwitchNetworkTo", function () { return $7a4eb50ac5cae5a3$export$3b3cf9ab9019de20; });
$parcel$export($7a4eb50ac5cae5a3$exports, "getSigners", function () { return $7a4eb50ac5cae5a3$export$6352a17a50193ded; });
$parcel$export($7a4eb50ac5cae5a3$exports, "canEagerConnect", function () { return $7a4eb50ac5cae5a3$export$be9f3c5ed1d25e42; });
$parcel$export($7a4eb50ac5cae5a3$exports, "getWalletInfo", function () { return $7a4eb50ac5cae5a3$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $6b19d568d6a73750$export$a696bbed8f4d981d() {
    const instances = new Map();
    const { solana: solana, ethereum: ethereum, offlineSigner: offlineSigner } = window;
    if (!!solana && solana.isMathWallet) instances.set((0, $8aS14.LegacyNetworks).SOLANA, solana);
    if (ethereum && ethereum.isMathWallet) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, ethereum);
    if (offlineSigner && offlineSigner.getAccounts) instances.set((0, $8aS14.LegacyNetworks).COSMOS, offlineSigner);
    if (instances.size === 0) return null;
    return instances;
}
async function $6b19d568d6a73750$export$78e7a9381dd8e059(instances) {
    // Getting Solana accounts
    const solanaInstance = instances.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        // Asking for account from wallet.
        const solanaResponse = await solanaInstance.connect();
        const solanaAccounts = solanaResponse.publicKey.toString();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    // Getting Cosmos accounts
    const cosmosInstance = instances.get((0, $8aS14.LegacyNetworks).COSMOS);
    if (cosmosInstance) {
        const [firstAccount] = await cosmosInstance.getAccounts();
        if (firstAccount) results.push({
            accounts: [
                firstAccount.address
            ],
            chainId: (0, $8aS14.LegacyNetworks).COSMOS
        });
    }
    return results;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");



async function $4f3f1965c96516ba$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const cosmosProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).COSMOS);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await Promise.resolve((parcelRequire("jMEJx")));
    const { MathWalletCosmosSigner: MathWalletCosmosSigner } = await (parcelRequire("3CkBL"));
    if (!!ethProvider) signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    if (!!solProvider) signers.registerSigner((0, $liigz.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    if (!!cosmosProvider) signers.registerSigner((0, $liigz.TransactionType).COSMOS, new MathWalletCosmosSigner(cosmosProvider));
    return signers;
}


const $7a4eb50ac5cae5a3$var$WALLET = (0, $yEwlv.WalletTypes).MATH;
const $7a4eb50ac5cae5a3$export$e506a1d27d1eaa20 = {
    type: $7a4eb50ac5cae5a3$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $7a4eb50ac5cae5a3$export$8bedcca5bbd73999 = (0, $6b19d568d6a73750$export$a696bbed8f4d981d);
const $7a4eb50ac5cae5a3$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push(evmResult);
    }
    const nonEvmResults = await (0, $6b19d568d6a73750$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $7a4eb50ac5cae5a3$export$ec068583843480e7 = (options)=>{
    let cleanup;
    const ethInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (ethInstance) cleanup = (0, $bHRZL.subscribeToEvm)({
        ...options,
        instance: ethInstance
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $7a4eb50ac5cae5a3$export$3b3cf9ab9019de20 = ()=>false;
const $7a4eb50ac5cae5a3$export$6352a17a50193ded = (0, $4f3f1965c96516ba$export$2e2bcd8739ae039);
const $7a4eb50ac5cae5a3$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $7a4eb50ac5cae5a3$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    const cosmos = allBlockChains.filter((blockchainMeta)=>blockchainMeta.name === (0, $8aS14.LegacyNetworks).COSMOS);
    return {
        name: "Math Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/math/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc",
            BRAVE: "https://chrome.google.com/webstore/detail/math-wallet/afbcbjpbpfadlkmhmclhkeeodmamcflc",
            DEFAULT: "https://mathwallet.org/en-us/"
        },
        color: "#2b2f25",
        supportedChains: [
            ...evms,
            ...solana,
            ...cosmos
        ]
    };
};


var $8aa8f19907af02ea$exports = {};

$parcel$export($8aa8f19907af02ea$exports, "config", function () { return $8aa8f19907af02ea$export$e506a1d27d1eaa20; });
$parcel$export($8aa8f19907af02ea$exports, "getInstance", function () { return $8aa8f19907af02ea$export$8bedcca5bbd73999; });
$parcel$export($8aa8f19907af02ea$exports, "connect", function () { return $8aa8f19907af02ea$export$64605811ab45167f; });
$parcel$export($8aa8f19907af02ea$exports, "subscribe", function () { return $8aa8f19907af02ea$export$ec068583843480e7; });
$parcel$export($8aa8f19907af02ea$exports, "switchNetwork", function () { return $8aa8f19907af02ea$export$f3473d805e486329; });
$parcel$export($8aa8f19907af02ea$exports, "canSwitchNetworkTo", function () { return $8aa8f19907af02ea$export$3b3cf9ab9019de20; });
$parcel$export($8aa8f19907af02ea$exports, "getSigners", function () { return $8aa8f19907af02ea$export$6352a17a50193ded; });
$parcel$export($8aa8f19907af02ea$exports, "canEagerConnect", function () { return $8aa8f19907af02ea$export$be9f3c5ed1d25e42; });
$parcel$export($8aa8f19907af02ea$exports, "getWalletInfo", function () { return $8aa8f19907af02ea$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $9483631a31fb5a25$var$isMetamaskProvider(ethereum) {
    const isMetamask = !!ethereum?.isMetaMask;
    if (!isMetamask) return false;
    /*
   * Brave tries to make itself look like MetaMask
   * Could also try RPC `web3_clientVersion` if following is unreliable
   */ if (ethereum.isBraveWallet && !ethereum._events && !ethereum._state) return false;
    if (ethereum.isApexWallet) return false;
    if (ethereum.isAvalanche) return false;
    if (ethereum.isBitKeep) return false;
    if (ethereum.isBlockWallet) return false;
    if (ethereum.isCoin98) return false;
    if (ethereum.isFordefi) return false;
    if (ethereum.__XDEFI) return false;
    if (ethereum.isMathWallet) return false;
    if (ethereum.isOkxWallet || ethereum.isOKExWallet) return false;
    if (ethereum.isOneInchIOSWallet || ethereum.isOneInchAndroidWallet) return false;
    if (ethereum.isOpera) return false;
    if (ethereum.isPortal) return false;
    if (ethereum.isRabby) return false;
    if (ethereum.isDefiant) return false;
    if (ethereum.isTokenPocket) return false;
    if (ethereum.isTokenary) return false;
    if (ethereum.isZeal) return false;
    if (ethereum.isZerion) return false;
    return true;
}
function $9483631a31fb5a25$export$35acf79c20989cf0() {
    const { ethereum: ethereum } = window;
    if (Array.isArray(ethereum?.providers)) {
        /*
     * When alternative EVM wallets are enabled and take precedence over MetaMask,
     * they append MetaMask or other EVM wallets to the ethereum.providers array.
     * example: 'Core' wallet
     */ let providers = ethereum.providers;
        //Exceptions exist, such as when only 'MetaMask' and 'Coinbase' are enabled.
        if (providers.length > 0 && Array.isArray(ethereum.providers[0]?.providers) && providers[0]?.providers.length > 0) providers = providers[0]?.providers;
        const metamaskProvider = providers.find($9483631a31fb5a25$var$isMetamaskProvider);
        if (metamaskProvider) return metamaskProvider;
    }
    return ethereum?.isMetaMask ? ethereum : null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $c29b917a48af7a26$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $8aa8f19907af02ea$var$WALLET = (0, $yEwlv.WalletTypes).META_MASK;
const $8aa8f19907af02ea$export$e506a1d27d1eaa20 = {
    type: $8aa8f19907af02ea$var$WALLET
};
const $8aa8f19907af02ea$export$8bedcca5bbd73999 = (0, $9483631a31fb5a25$export$35acf79c20989cf0);
const $8aa8f19907af02ea$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $8aa8f19907af02ea$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $8aa8f19907af02ea$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $8aa8f19907af02ea$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $8aa8f19907af02ea$export$6352a17a50193ded = (0, $c29b917a48af7a26$export$2e2bcd8739ae039);
const $8aa8f19907af02ea$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $8aa8f19907af02ea$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "MetaMask",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/metamask/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            BRAVE: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US",
            DEFAULT: "https://metamask.io/download/"
        },
        color: "#dac7ae",
        supportedChains: evms
    };
};


var $9ef6de0b5bd1a5ea$exports = {};

$parcel$export($9ef6de0b5bd1a5ea$exports, "config", function () { return $9ef6de0b5bd1a5ea$export$e506a1d27d1eaa20; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "getInstance", function () { return $9ef6de0b5bd1a5ea$export$8bedcca5bbd73999; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "connect", function () { return $9ef6de0b5bd1a5ea$export$64605811ab45167f; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "subscribe", function () { return $9ef6de0b5bd1a5ea$export$ec068583843480e7; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "switchNetwork", function () { return $9ef6de0b5bd1a5ea$export$f3473d805e486329; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "canSwitchNetworkTo", function () { return $9ef6de0b5bd1a5ea$export$3b3cf9ab9019de20; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "getSigners", function () { return $9ef6de0b5bd1a5ea$export$6352a17a50193ded; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "canEagerConnect", function () { return $9ef6de0b5bd1a5ea$export$be9f3c5ed1d25e42; });
$parcel$export($9ef6de0b5bd1a5ea$exports, "getWalletInfo", function () { return $9ef6de0b5bd1a5ea$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $f513f5871785506e$export$693e5e2f39793ae1() {
    const { okxwallet: okxwallet } = window;
    if (!okxwallet) return null;
    const instances = new Map();
    if (okxwallet) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, okxwallet);
    if (okxwallet.solana) instances.set((0, $8aS14.LegacyNetworks).SOLANA, okxwallet.solana);
    return instances;
}
async function $f513f5871785506e$export$a009f0f0c363aa6c(instance) {
    const solanaInstance = await instance.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const account = solanaResponse.publicKey.toString();
        results.push({
            accounts: account ? [
                account
            ] : [],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}
const $f513f5871785506e$export$ac6b831b3b0dc450 = [
    (0, $8aS14.LegacyNetworks).ETHEREUM,
    (0, $8aS14.LegacyNetworks).BSC,
    (0, $8aS14.LegacyNetworks).SOLANA,
    (0, $8aS14.LegacyNetworks).POLYGON,
    (0, $8aS14.LegacyNetworks).FANTOM,
    (0, $8aS14.LegacyNetworks).ARBITRUM,
    (0, $8aS14.LegacyNetworks).OPTIMISM,
    (0, $8aS14.LegacyNetworks).CRONOS,
    (0, $8aS14.LegacyNetworks).BOBA,
    (0, $8aS14.LegacyNetworks).GNOSIS,
    (0, $8aS14.LegacyNetworks).MOONBEAM,
    (0, $8aS14.LegacyNetworks).MOONRIVER,
    (0, $8aS14.LegacyNetworks).HARMONY,
    (0, $8aS14.LegacyNetworks).AVAX_CCHAIN
];


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $a8989951111fd4e0$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("2HZPr"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    return signers;
}


const $9ef6de0b5bd1a5ea$var$WALLET = (0, $yEwlv.WalletTypes).OKX;
const $9ef6de0b5bd1a5ea$export$e506a1d27d1eaa20 = {
    type: $9ef6de0b5bd1a5ea$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $9ef6de0b5bd1a5ea$export$8bedcca5bbd73999 = (0, $f513f5871785506e$export$693e5e2f39793ae1);
const $9ef6de0b5bd1a5ea$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    let results = [];
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) {
        const evm = await (0, $bHRZL.getEvmAccounts)(evm_instance);
        results.push(evm);
    }
    const solanaResults = await (0, $f513f5871785506e$export$a009f0f0c363aa6c)(instance);
    results = [
        ...results,
        ...solanaResults
    ];
    return results;
};
const $9ef6de0b5bd1a5ea$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const handleEvmAccountsChanged = async (addresses)=>{
        const eth_chainId = meta.filter((0, $21GQj.isEvmBlockchain)).find((blockchain)=>blockchain.name === (0, $8aS14.LegacyNetworks).ETHEREUM)?.chainId;
        updateAccounts(addresses, eth_chainId);
        const [{ accounts: accounts, chainId: chainId }] = await (0, $f513f5871785506e$export$a009f0f0c363aa6c)(instance);
        updateAccounts(accounts, chainId);
    };
    ethInstance?.on?.("accountsChanged", handleEvmAccountsChanged);
    return ()=>{
        ethInstance?.off?.("accountsChanged", handleEvmAccountsChanged);
    };
};
const $9ef6de0b5bd1a5ea$export$f3473d805e486329 = async (options)=>{
    const instance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, options.network);
    return (0, $bHRZL.switchNetworkForEvm)({
        ...options,
        instance: instance
    });
};
const $9ef6de0b5bd1a5ea$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $9ef6de0b5bd1a5ea$export$6352a17a50193ded = (0, $a8989951111fd4e0$export$2e2bcd8739ae039);
const $9ef6de0b5bd1a5ea$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $9ef6de0b5bd1a5ea$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>({
        name: "OKX",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/okx/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
            BRAVE: "https://chrome.google.com/webstore/detail/okx-wallet/mcohilncbfahbmgdjkbpemcciiolgcge",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/okexwallet",
            DEFAULT: "https://www.okx.com/web3"
        },
        color: "white",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $f513f5871785506e$export$ac6b831b3b0dc450).includes(blockchainMeta.name))
    });


var $eee36c7c5a4830f4$exports = {};

$parcel$export($eee36c7c5a4830f4$exports, "config", function () { return $eee36c7c5a4830f4$export$e506a1d27d1eaa20; });
$parcel$export($eee36c7c5a4830f4$exports, "getInstance", function () { return $eee36c7c5a4830f4$export$8bedcca5bbd73999; });
$parcel$export($eee36c7c5a4830f4$exports, "connect", function () { return $eee36c7c5a4830f4$export$64605811ab45167f; });
$parcel$export($eee36c7c5a4830f4$exports, "subscribe", function () { return $eee36c7c5a4830f4$export$ec068583843480e7; });
$parcel$export($eee36c7c5a4830f4$exports, "canSwitchNetworkTo", function () { return $eee36c7c5a4830f4$export$3b3cf9ab9019de20; });
$parcel$export($eee36c7c5a4830f4$exports, "getSigners", function () { return $eee36c7c5a4830f4$export$6352a17a50193ded; });
$parcel$export($eee36c7c5a4830f4$exports, "canEagerConnect", function () { return $eee36c7c5a4830f4$export$be9f3c5ed1d25e42; });
$parcel$export($eee36c7c5a4830f4$exports, "getWalletInfo", function () { return $eee36c7c5a4830f4$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $0513ed3a3e35a355$export$40b6ddfff396bf5b() {
    if ("phantom" in window) {
        const instance = window.phantom?.solana;
        if (instance?.isPhantom) return instance;
    }
    return null;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $70c26a2f1f675d36$export$2e2bcd8739ae039(provider) {
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await Promise.resolve((parcelRequire("jMEJx")));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    return signers;
}


const $eee36c7c5a4830f4$var$WALLET = (0, $yEwlv.WalletTypes).PHANTOM;
const $eee36c7c5a4830f4$export$e506a1d27d1eaa20 = {
    type: $eee36c7c5a4830f4$var$WALLET
};
const $eee36c7c5a4830f4$export$8bedcca5bbd73999 = (0, $0513ed3a3e35a355$export$40b6ddfff396bf5b);
const $eee36c7c5a4830f4$export$64605811ab45167f = (0, $7aYgM.getSolanaAccounts);
const $eee36c7c5a4830f4$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, connect: connect })=>{
    const handleAccountsChanged = async (publicKey)=>{
        const network = (0, $8aS14.LegacyNetworks).SOLANA;
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else connect(network);
    };
    instance?.on?.("accountChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountChanged", handleAccountsChanged);
    };
};
const $eee36c7c5a4830f4$export$3b3cf9ab9019de20 = ()=>false;
const $eee36c7c5a4830f4$export$6352a17a50193ded = (0, $70c26a2f1f675d36$export$2e2bcd8739ae039);
const $eee36c7c5a4830f4$export$be9f3c5ed1d25e42 = async ({ instance: instance })=>{
    try {
        const result = await instance.connect({
            onlyIfTrusted: true
        });
        return !!result;
    } catch (error) {
        return false;
    }
};
const $eee36c7c5a4830f4$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Phantom",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/phantom/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
            DEFAULT: "https://phantom.app/"
        },
        color: "#4d40c6",
        supportedChains: solana
    };
};


var $1209ff33b8a5cdc3$exports = {};

$parcel$export($1209ff33b8a5cdc3$exports, "config", function () { return $1209ff33b8a5cdc3$export$e506a1d27d1eaa20; });
$parcel$export($1209ff33b8a5cdc3$exports, "getInstance", function () { return $1209ff33b8a5cdc3$export$8bedcca5bbd73999; });
$parcel$export($1209ff33b8a5cdc3$exports, "connect", function () { return $1209ff33b8a5cdc3$export$64605811ab45167f; });
$parcel$export($1209ff33b8a5cdc3$exports, "subscribe", function () { return $1209ff33b8a5cdc3$export$ec068583843480e7; });
$parcel$export($1209ff33b8a5cdc3$exports, "switchNetwork", function () { return $1209ff33b8a5cdc3$export$f3473d805e486329; });
$parcel$export($1209ff33b8a5cdc3$exports, "canSwitchNetworkTo", function () { return $1209ff33b8a5cdc3$export$3b3cf9ab9019de20; });
$parcel$export($1209ff33b8a5cdc3$exports, "getSigners", function () { return $1209ff33b8a5cdc3$export$6352a17a50193ded; });
$parcel$export($1209ff33b8a5cdc3$exports, "canEagerConnect", function () { return $1209ff33b8a5cdc3$export$be9f3c5ed1d25e42; });
$parcel$export($1209ff33b8a5cdc3$exports, "getWalletInfo", function () { return $1209ff33b8a5cdc3$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $277f96fc13c359a5$export$6e053ecfae416447() {
    const { ethereum: ethereum } = window;
    return ethereum?.isRabby ? ethereum : null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $2b1dbad63a0f6dea$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $1209ff33b8a5cdc3$export$e506a1d27d1eaa20 = {
    type: (0, $yEwlv.WalletTypes).Rabby
};
const $1209ff33b8a5cdc3$export$8bedcca5bbd73999 = (0, $277f96fc13c359a5$export$6e053ecfae416447);
const $1209ff33b8a5cdc3$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $1209ff33b8a5cdc3$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $1209ff33b8a5cdc3$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $1209ff33b8a5cdc3$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $1209ff33b8a5cdc3$export$6352a17a50193ded = (0, $2b1dbad63a0f6dea$export$2e2bcd8739ae039);
const $1209ff33b8a5cdc3$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $1209ff33b8a5cdc3$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Rabby",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/rabby/icon.svg",
        installLink: {
            CHROME: "https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch",
            DEFAULT: "https://rabby.io/"
        },
        color: "#fff",
        supportedChains: evms
    };
};


var $7707aab27997e975$exports = {};

$parcel$export($7707aab27997e975$exports, "config", function () { return $7707aab27997e975$export$e506a1d27d1eaa20; });
$parcel$export($7707aab27997e975$exports, "getInstance", function () { return $7707aab27997e975$export$8bedcca5bbd73999; });
$parcel$export($7707aab27997e975$exports, "connect", function () { return $7707aab27997e975$export$64605811ab45167f; });
$parcel$export($7707aab27997e975$exports, "subscribe", function () { return $7707aab27997e975$export$ec068583843480e7; });
$parcel$export($7707aab27997e975$exports, "switchNetwork", function () { return $7707aab27997e975$export$f3473d805e486329; });
$parcel$export($7707aab27997e975$exports, "canSwitchNetworkTo", function () { return $7707aab27997e975$export$3b3cf9ab9019de20; });
$parcel$export($7707aab27997e975$exports, "getSigners", function () { return $7707aab27997e975$export$6352a17a50193ded; });
$parcel$export($7707aab27997e975$exports, "canEagerConnect", function () { return $7707aab27997e975$export$be9f3c5ed1d25e42; });
$parcel$export($7707aab27997e975$exports, "getWalletInfo", function () { return $7707aab27997e975$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $aSKsu = parcelRequire("aSKsu");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $4c895d9de7a8081c$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { CustomEvmSigner: CustomEvmSigner } = await (parcelRequire("7qW2M"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new CustomEvmSigner(provider));
    return signers;
}


const $7707aab27997e975$var$WALLET = (0, $yEwlv.WalletTypes).SAFE;
const $7707aab27997e975$export$e506a1d27d1eaa20 = {
    type: $7707aab27997e975$var$WALLET,
    isAsyncInstance: true
};
const $7707aab27997e975$export$8bedcca5bbd73999 = async ()=>{
    return await (0, $aSKsu.getSafeInstance)();
};
const $7707aab27997e975$export$64605811ab45167f = async ({ instance: instance })=>{
    const accounts = await instance.request({
        method: "eth_accounts"
    });
    const { chainId: chainId } = instance;
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $7707aab27997e975$export$ec068583843480e7 = ({ instance: instance, state: state, updateChainId: updateChainId, updateAccounts: updateAccounts, meta: meta, connect: connect, disconnect: disconnect })=>{
    const evmBlockchainMeta = meta.filter((0, $21GQj.isEvmBlockchain));
    const cleanup = (0, $bHRZL.subscribeToEvm)({
        instance: instance,
        state: state,
        updateChainId: updateChainId,
        updateAccounts: updateAccounts,
        meta: evmBlockchainMeta,
        connect: connect,
        disconnect: disconnect
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $7707aab27997e975$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $7707aab27997e975$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $7707aab27997e975$export$6352a17a50193ded = (0, $4c895d9de7a8081c$export$2e2bcd8739ae039);
const $7707aab27997e975$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $7707aab27997e975$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Safe",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safe/icon.svg",
        installLink: {
            DEFAULT: "https://app.safe.global/"
        },
        color: "#ffffff",
        supportedChains: evms,
        isContractWallet: true
    };
};


var $e70dc9983ed0cd8f$exports = {};

$parcel$export($e70dc9983ed0cd8f$exports, "config", function () { return $e70dc9983ed0cd8f$export$e506a1d27d1eaa20; });
$parcel$export($e70dc9983ed0cd8f$exports, "getInstance", function () { return $e70dc9983ed0cd8f$export$8bedcca5bbd73999; });
$parcel$export($e70dc9983ed0cd8f$exports, "connect", function () { return $e70dc9983ed0cd8f$export$64605811ab45167f; });
$parcel$export($e70dc9983ed0cd8f$exports, "subscribe", function () { return $e70dc9983ed0cd8f$export$ec068583843480e7; });
$parcel$export($e70dc9983ed0cd8f$exports, "switchNetwork", function () { return $e70dc9983ed0cd8f$export$f3473d805e486329; });
$parcel$export($e70dc9983ed0cd8f$exports, "canSwitchNetworkTo", function () { return $e70dc9983ed0cd8f$export$3b3cf9ab9019de20; });
$parcel$export($e70dc9983ed0cd8f$exports, "getSigners", function () { return $e70dc9983ed0cd8f$export$6352a17a50193ded; });
$parcel$export($e70dc9983ed0cd8f$exports, "getWalletInfo", function () { return $e70dc9983ed0cd8f$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $b2f7529bf5438f0e$export$ff14f0e3b306c092() {
    const instances = new Map();
    const { isSafePal: isSafePal, safepal: safepal, safepalProvider: safepalProvider } = window;
    if (!isSafePal) return null;
    if (!!safepal && safepal.isSafePalWallet) instances.set((0, $8aS14.LegacyNetworks).SOLANA, safepal);
    if (safepalProvider && safepalProvider) instances.set((0, $8aS14.LegacyNetworks).ETHEREUM, safepalProvider);
    if (instances.size === 0) return null;
    return instances;
}
async function $b2f7529bf5438f0e$export$78e7a9381dd8e059(instances) {
    const solanaInstance = instances.get((0, $8aS14.LegacyNetworks).SOLANA);
    const results = [];
    if (solanaInstance) {
        const solanaResponse = await solanaInstance.connect();
        const solanaAccounts = solanaResponse.publicKey.toString();
        results.push({
            accounts: [
                solanaAccounts
            ],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        });
    }
    return results;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");


async function $010e6311ab5c7ec1$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { DefaultSolanaSigner: DefaultSolanaSigner } = await Promise.resolve((parcelRequire("jMEJx")));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new DefaultSolanaSigner(solProvider));
    return signers;
}


const $e70dc9983ed0cd8f$var$WALLET = (0, $yEwlv.WalletTypes).SAFEPAL;
const $e70dc9983ed0cd8f$export$e506a1d27d1eaa20 = {
    type: $e70dc9983ed0cd8f$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).ETHEREUM
};
const $e70dc9983ed0cd8f$export$8bedcca5bbd73999 = (0, $b2f7529bf5438f0e$export$ff14f0e3b306c092);
const $e70dc9983ed0cd8f$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    let results = [];
    if (ethInstance) {
        const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
        results.push(evmResult);
    }
    const nonEvmResults = await (0, $b2f7529bf5438f0e$export$78e7a9381dd8e059)(instance);
    results = [
        ...results,
        ...nonEvmResults
    ];
    return results;
};
const $e70dc9983ed0cd8f$export$ec068583843480e7 = (options)=>{
    let cleanup;
    const ethInstance = (0, $bHRZL.chooseInstance)(options.instance, options.meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (ethInstance) cleanup = (0, $bHRZL.subscribeToEvm)({
        ...options,
        instance: ethInstance
    });
    return ()=>{
        if (cleanup) cleanup();
    };
};
const $e70dc9983ed0cd8f$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $e70dc9983ed0cd8f$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $e70dc9983ed0cd8f$export$6352a17a50193ded = (0, $010e6311ab5c7ec1$export$2e2bcd8739ae039);
const $e70dc9983ed0cd8f$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "SafePal",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/safepal/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa",
            BRAVE: "https://chrome.google.com/webstore/detail/safepal-extension-wallet/lgmpcpglpngdoalbgeoldeajfclnhafa",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/safepal-extension-wallet",
            DEFAULT: "https://www.safepal.com/download"
        },
        color: "#4A21EF",
        supportedChains: [
            ...evms,
            ...solana
        ]
    };
};


var $3eb7d8777ccd4c4b$exports = {};

$parcel$export($3eb7d8777ccd4c4b$exports, "config", function () { return $3eb7d8777ccd4c4b$export$e506a1d27d1eaa20; });
$parcel$export($3eb7d8777ccd4c4b$exports, "getInstance", function () { return $3eb7d8777ccd4c4b$export$8bedcca5bbd73999; });
$parcel$export($3eb7d8777ccd4c4b$exports, "connect", function () { return $3eb7d8777ccd4c4b$export$64605811ab45167f; });
$parcel$export($3eb7d8777ccd4c4b$exports, "subscribe", function () { return $3eb7d8777ccd4c4b$export$ec068583843480e7; });
$parcel$export($3eb7d8777ccd4c4b$exports, "canSwitchNetworkTo", function () { return $3eb7d8777ccd4c4b$export$3b3cf9ab9019de20; });
$parcel$export($3eb7d8777ccd4c4b$exports, "getSigners", function () { return $3eb7d8777ccd4c4b$export$6352a17a50193ded; });
$parcel$export($3eb7d8777ccd4c4b$exports, "getWalletInfo", function () { return $3eb7d8777ccd4c4b$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");

var $4Ya7C = parcelRequire("4Ya7C");
var $d71e659823218cf6$exports = {};
"use strict";
var $d71e659823218cf6$var$has = Object.prototype.hasOwnProperty, $d71e659823218cf6$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d71e659823218cf6$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d71e659823218cf6$var$Events().__proto__) $d71e659823218cf6$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d71e659823218cf6$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $d71e659823218cf6$var$EE(fn, context || emitter, once), evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d71e659823218cf6$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d71e659823218cf6$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d71e659823218cf6$var$EventEmitter() {
    this._events = new $d71e659823218cf6$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d71e659823218cf6$var$has.call(events, name)) names.push($d71e659823218cf6$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d71e659823218cf6$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d71e659823218cf6$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
        if (this._events[evt]) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        this._events = new $d71e659823218cf6$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d71e659823218cf6$var$EventEmitter.prototype.off = $d71e659823218cf6$var$EventEmitter.prototype.removeListener;
$d71e659823218cf6$var$EventEmitter.prototype.addListener = $d71e659823218cf6$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d71e659823218cf6$var$EventEmitter.prefixed = $d71e659823218cf6$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d71e659823218cf6$var$EventEmitter.EventEmitter = $d71e659823218cf6$var$EventEmitter;
$d71e659823218cf6$exports = $d71e659823218cf6$var$EventEmitter;


var $d2ed3f8017184c07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($d71e659823218cf6$exports)));



var $3df38da2ab51f822$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3df38da2ab51f822$var$WalletAdapter = /** @class */ function(_super) {
    $3df38da2ab51f822$var$__extends(WalletAdapter, _super);
    function WalletAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WalletAdapter;
}((0, $d2ed3f8017184c07$export$2e2bcd8739ae039));
var $3df38da2ab51f822$export$2e2bcd8739ae039 = $3df38da2ab51f822$var$WalletAdapter;




var $4Ya7C = parcelRequire("4Ya7C");

var $4evmt = parcelRequire("4evmt");
var $5af9c06a54cbe9b3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5af9c06a54cbe9b3$var$__assign = undefined && undefined.__assign || function() {
    $5af9c06a54cbe9b3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5af9c06a54cbe9b3$var$__assign.apply(this, arguments);
};
var $5af9c06a54cbe9b3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5af9c06a54cbe9b3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5af9c06a54cbe9b3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5af9c06a54cbe9b3$var$Wallet = /** @class */ function(_super) {
    $5af9c06a54cbe9b3$var$__extends(Wallet, _super);
    function Wallet(provider, network) {
        var _this = _super.call(this) || this;
        _this._handleMessage = function(e) {
            if (_this._injectedProvider && e.source === window || e.origin === _this._providerUrl.origin && e.source === _this._popup) {
                if (e.data.method === "connected") {
                    var newPublicKey = new (0, $4Ya7C.PublicKey)(e.data.params.publicKey);
                    if (!_this._publicKey || !_this._publicKey.equals(newPublicKey)) {
                        if (_this._publicKey && !_this._publicKey.equals(newPublicKey)) _this._handleDisconnect();
                        _this._publicKey = newPublicKey;
                        _this._autoApprove = !!e.data.params.autoApprove;
                        _this.emit("connect", _this._publicKey);
                    }
                } else if (e.data.method === "disconnected") _this._handleDisconnect();
                else if (e.data.result || e.data.error) {
                    if (_this._responsePromises.has(e.data.id)) {
                        var _a = $5af9c06a54cbe9b3$var$__read(_this._responsePromises.get(e.data.id), 2), resolve = _a[0], reject = _a[1];
                        if (e.data.result) resolve(e.data.result);
                        else reject(new Error(e.data.error));
                    }
                }
            }
        };
        _this._handleConnect = function() {
            if (!_this._handlerAdded) {
                _this._handlerAdded = true;
                window.addEventListener("message", _this._handleMessage);
                window.addEventListener("beforeunload", _this.disconnect);
            }
            if (_this._injectedProvider) return new Promise(function(resolve) {
                _this._sendRequest("connect", {});
                resolve();
            });
            else {
                window.name = "parent";
                _this._popup = window.open(_this._providerUrl.toString(), "_blank", "location,resizable,width=460,height=675");
                return new Promise(function(resolve) {
                    _this.once("connect", resolve);
                });
            }
        };
        _this._handleDisconnect = function() {
            if (_this._handlerAdded) {
                _this._handlerAdded = false;
                window.removeEventListener("message", _this._handleMessage);
                window.removeEventListener("beforeunload", _this.disconnect);
            }
            if (_this._publicKey) {
                _this._publicKey = null;
                _this.emit("disconnect");
            }
            _this._responsePromises.forEach(function(_a, id) {
                var _b = $5af9c06a54cbe9b3$var$__read(_a, 2), resolve = _b[0], reject = _b[1];
                _this._responsePromises.delete(id);
                reject("Wallet disconnected");
            });
        };
        _this._sendRequest = function(method, params) {
            return $5af9c06a54cbe9b3$var$__awaiter(_this, void 0, void 0, function() {
                var requestId;
                var _this = this;
                return $5af9c06a54cbe9b3$var$__generator(this, function(_a) {
                    if (method !== "connect" && !this.connected) throw new Error("Wallet not connected");
                    requestId = this._nextRequestId;
                    ++this._nextRequestId;
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            _this._responsePromises.set(requestId, [
                                resolve,
                                reject
                            ]);
                            if (_this._injectedProvider) _this._injectedProvider.postMessage({
                                jsonrpc: "2.0",
                                id: requestId,
                                method: method,
                                params: $5af9c06a54cbe9b3$var$__assign({
                                    network: _this._network
                                }, params)
                            });
                            else {
                                _this._popup.postMessage({
                                    jsonrpc: "2.0",
                                    id: requestId,
                                    method: method,
                                    params: params
                                }, _this._providerUrl.origin);
                                if (!_this.autoApprove) _this._popup.focus();
                            }
                        })
                    ];
                });
            });
        };
        _this.connect = function() {
            if (_this._popup) _this._popup.close();
            return _this._handleConnect();
        };
        _this.disconnect = function() {
            return $5af9c06a54cbe9b3$var$__awaiter(_this, void 0, void 0, function() {
                return $5af9c06a54cbe9b3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!this._injectedProvider) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this._sendRequest("disconnect", {})
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (this._popup) this._popup.close();
                            this._handleDisconnect();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.sign = function(data, display) {
            return $5af9c06a54cbe9b3$var$__awaiter(_this, void 0, void 0, function() {
                var response, signature, publicKey;
                return $5af9c06a54cbe9b3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(data instanceof Uint8Array)) throw new Error("Data must be an instance of Uint8Array");
                            return [
                                4 /*yield*/ ,
                                this._sendRequest("sign", {
                                    data: data,
                                    display: display
                                })
                            ];
                        case 1:
                            response = _a.sent();
                            signature = (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(response.signature);
                            publicKey = new (0, $4Ya7C.PublicKey)(response.publicKey);
                            return [
                                2 /*return*/ ,
                                {
                                    signature: signature,
                                    publicKey: publicKey
                                }
                            ];
                    }
                });
            });
        };
        if ($5af9c06a54cbe9b3$var$isInjectedProvider(provider)) _this._injectedProvider = provider;
        else if ($5af9c06a54cbe9b3$var$isString(provider)) {
            _this._providerUrl = new URL(provider);
            _this._providerUrl.hash = new URLSearchParams({
                origin: window.location.origin,
                network: network
            }).toString();
        } else throw new Error("provider parameter must be an injected provider or a URL string.");
        _this._network = network;
        _this._publicKey = null;
        _this._autoApprove = false;
        _this._popup = null;
        _this._handlerAdded = false;
        _this._nextRequestId = 1;
        _this._responsePromises = new Map();
        return _this;
    }
    Object.defineProperty(Wallet.prototype, "publicKey", {
        get: function() {
            return this._publicKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Wallet.prototype, "connected", {
        get: function() {
            return this._publicKey !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Wallet.prototype, "autoApprove", {
        get: function() {
            return this._autoApprove;
        },
        enumerable: false,
        configurable: true
    });
    return Wallet;
}((0, $d2ed3f8017184c07$export$2e2bcd8739ae039));
var $5af9c06a54cbe9b3$export$2e2bcd8739ae039 = $5af9c06a54cbe9b3$var$Wallet;
function $5af9c06a54cbe9b3$var$isString(a) {
    return typeof a === "string";
}
function $5af9c06a54cbe9b3$var$isInjectedProvider(a) {
    return $5af9c06a54cbe9b3$var$isObject(a) && $5af9c06a54cbe9b3$var$isFunction(a.postMessage);
}
function $5af9c06a54cbe9b3$var$isObject(a) {
    return typeof a === "object" && a !== null;
}
function $5af9c06a54cbe9b3$var$isFunction(a) {
    return typeof a === "function";
}



var $4evmt = parcelRequire("4evmt");
var $3e4ca14c9a7cad76$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3e4ca14c9a7cad76$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3e4ca14c9a7cad76$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3e4ca14c9a7cad76$var$WebAdapter = /** @class */ function(_super) {
    $3e4ca14c9a7cad76$var$__extends(WebAdapter, _super);
    // @ts-ignore
    function WebAdapter(iframe, network, provider) {
        var _this = _super.call(this) || this;
        _this._instance = null;
        // @ts-ignore
        _this.handleMessage = function(data) {
        // nothing to do here
        };
        _this._sendRequest = function(method, params) {
            return $3e4ca14c9a7cad76$var$__awaiter(_this, void 0, void 0, function() {
                var _a, _b;
                return $3e4ca14c9a7cad76$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            if (!((_a = this._instance) === null || _a === void 0 ? void 0 : _a.sendRequest)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this._instance.sendRequest(method, params)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _c.sent()
                            ];
                        case 2:
                            if (!((_b = this._instance) === null || _b === void 0 ? void 0 : _b._sendRequest)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                this._instance._sendRequest(method, params)
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _c.sent()
                            ];
                        case 4:
                            throw new Error("Unsupported version of `@project-serum/sol-wallet-adapter`");
                    }
                });
            });
        };
        _this._handleConnect = function() {
            _this.emit("connect");
        };
        _this._handleDisconnect = function() {
            window.clearInterval(_this._pollTimer);
            _this.emit("disconnect");
        };
        _this._network = network;
        _this._provider = provider;
        return _this;
    }
    Object.defineProperty(WebAdapter.prototype, "publicKey", {
        get: function() {
            return this._instance.publicKey || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAdapter.prototype, "connected", {
        get: function() {
            return this._instance.connected || false;
        },
        enumerable: false,
        configurable: true
    });
    WebAdapter.prototype.connect = function() {
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this._instance = new (0, $5af9c06a54cbe9b3$export$2e2bcd8739ae039)(this._provider, this._network);
                        this._instance.on("connect", this._handleConnect);
                        this._instance.on("disconnect", this._handleDisconnect);
                        this._pollTimer = window.setInterval(function() {
                            var _a, _b;
                            // @ts-ignore
                            if (((_b = (_a = _this._instance) === null || _a === void 0 ? void 0 : _a._popup) === null || _b === void 0 ? void 0 : _b.closed) !== false) _this._handleDisconnect();
                        }, 200);
                        return [
                            4 /*yield*/ ,
                            this._instance.connect()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAdapter.prototype.disconnect = function() {
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        this._instance.removeAllListeners("connect");
                        this._instance.removeAllListeners("disconnect");
                        return [
                            4 /*yield*/ ,
                            this._instance.disconnect()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAdapter.prototype.signTransaction = function(transaction) {
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            var signedTransaction;
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        return [
                            4 /*yield*/ ,
                            this._sendRequest("signTransactionV2", {
                                transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction)
                            })
                        ];
                    case 1:
                        signedTransaction = _a.sent().transaction;
                        return [
                            2 /*return*/ ,
                            (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction)
                        ];
                }
            });
        });
    };
    WebAdapter.prototype.signAllTransactions = function(transactions) {
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            var signedTransactions;
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        return [
                            4 /*yield*/ ,
                            this._sendRequest("signAllTransactionsV2", {
                                transactions: transactions.map(function(transaction) {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction);
                                })
                            })
                        ];
                    case 1:
                        signedTransactions = _a.sent().transactions;
                        return [
                            2 /*return*/ ,
                            signedTransactions.map(function(transaction) {
                                return (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(transaction);
                            })
                        ];
                }
            });
        });
    };
    WebAdapter.prototype.signAndSendTransaction = function(transaction, options) {
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        return [
                            4 /*yield*/ ,
                            this._sendRequest("signAndSendTransaction", {
                                transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction),
                                options: options
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            response.signature
                        ];
                }
            });
        });
    };
    WebAdapter.prototype.signMessage = function(data, display) {
        if (display === void 0) display = "hex";
        return $3e4ca14c9a7cad76$var$__awaiter(this, void 0, void 0, function() {
            var signature;
            return $3e4ca14c9a7cad76$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        return [
                            4 /*yield*/ ,
                            this._instance.sign(data, display)
                        ];
                    case 1:
                        signature = _a.sent().signature;
                        return [
                            2 /*return*/ ,
                            Uint8Array.from(signature)
                        ];
                }
            });
        });
    };
    return WebAdapter;
}((0, $3df38da2ab51f822$export$2e2bcd8739ae039));
var $3e4ca14c9a7cad76$export$2e2bcd8739ae039 = $3e4ca14c9a7cad76$var$WebAdapter;



var $4Ya7C = parcelRequire("4Ya7C");



var $4evmt = parcelRequire("4evmt");
var $8f670d5fbe4fff65$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8f670d5fbe4fff65$var$__assign = undefined && undefined.__assign || function() {
    $8f670d5fbe4fff65$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f670d5fbe4fff65$var$__assign.apply(this, arguments);
};
var $8f670d5fbe4fff65$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8f670d5fbe4fff65$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8f670d5fbe4fff65$var$IframeAdapter = /** @class */ function(_super) {
    $8f670d5fbe4fff65$var$__extends(IframeAdapter, _super);
    function IframeAdapter(iframe, publicKey) {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this._publicKey = null;
        _this._messageHandlers = {};
        _this.handleMessage = function(data) {
            if (_this._messageHandlers[data.id]) {
                var _a = _this._messageHandlers[data.id], resolve = _a.resolve, reject = _a.reject;
                delete _this._messageHandlers[data.id];
                if (data.error) reject(data.error);
                else resolve(data.result);
            }
        };
        _this._sendMessage = function(data) {
            if (!_this.connected) throw new Error("Wallet not connected");
            return new Promise(function(resolve, reject) {
                var _a, _b;
                var messageId = (0, $d0666643e2ee88b4$export$2e2bcd8739ae039)();
                _this._messageHandlers[messageId] = {
                    resolve: resolve,
                    reject: reject
                };
                (_b = (_a = _this._iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
                    channel: "solflareWalletAdapterToIframe",
                    data: $8f670d5fbe4fff65$var$__assign({
                        id: messageId
                    }, data)
                }, "*");
            });
        };
        _this._iframe = iframe;
        _this._publicKey = new (0, $4Ya7C.PublicKey)((_a = publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString) === null || _a === void 0 ? void 0 : _a.call(publicKey));
        return _this;
    }
    Object.defineProperty(IframeAdapter.prototype, "publicKey", {
        get: function() {
            return this._publicKey || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IframeAdapter.prototype, "connected", {
        get: function() {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    IframeAdapter.prototype.connect = function() {
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            return $8f670d5fbe4fff65$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    IframeAdapter.prototype.disconnect = function() {
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            return $8f670d5fbe4fff65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._sendMessage({
                                method: "disconnect"
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IframeAdapter.prototype.signTransaction = function(transaction) {
        var _a;
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            var signedTransaction, e_1;
            return $8f670d5fbe4fff65$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._sendMessage({
                                method: "signTransaction",
                                params: {
                                    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction)
                                }
                            })
                        ];
                    case 2:
                        signedTransaction = _b.sent();
                        return [
                            2 /*return*/ ,
                            (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction)
                        ];
                    case 3:
                        e_1 = _b.sent();
                        throw new Error(((_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.toString) === null || _a === void 0 ? void 0 : _a.call(e_1)) || "Failed to sign transaction");
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IframeAdapter.prototype.signAllTransactions = function(transactions) {
        var _a;
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            var signedTransactions, e_2;
            return $8f670d5fbe4fff65$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._sendMessage({
                                method: "signAllTransactions",
                                params: {
                                    transactions: transactions.map(function(transaction) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction);
                                    })
                                }
                            })
                        ];
                    case 2:
                        signedTransactions = _b.sent();
                        return [
                            2 /*return*/ ,
                            signedTransactions.map(function(transaction) {
                                return (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(transaction);
                            })
                        ];
                    case 3:
                        e_2 = _b.sent();
                        throw new Error(((_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.toString) === null || _a === void 0 ? void 0 : _a.call(e_2)) || "Failed to sign transactions");
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IframeAdapter.prototype.signAndSendTransaction = function(transaction, options) {
        var _a;
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            var result, e_3;
            return $8f670d5fbe4fff65$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._sendMessage({
                                method: "signAndSendTransaction",
                                params: {
                                    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction),
                                    options: options
                                }
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        e_3 = _b.sent();
                        throw new Error(((_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.toString) === null || _a === void 0 ? void 0 : _a.call(e_3)) || "Failed to sign and send transaction");
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IframeAdapter.prototype.signMessage = function(data, display) {
        var _a;
        if (display === void 0) display = "hex";
        return $8f670d5fbe4fff65$var$__awaiter(this, void 0, void 0, function() {
            var result, e_4;
            return $8f670d5fbe4fff65$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._sendMessage({
                                method: "signMessage",
                                params: {
                                    data: data,
                                    display: display
                                }
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            Uint8Array.from((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(result))
                        ];
                    case 3:
                        e_4 = _b.sent();
                        throw new Error(((_a = e_4 === null || e_4 === void 0 ? void 0 : e_4.toString) === null || _a === void 0 ? void 0 : _a.call(e_4)) || "Failed to sign message");
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return IframeAdapter;
}((0, $3df38da2ab51f822$export$2e2bcd8739ae039));
var $8f670d5fbe4fff65$export$2e2bcd8739ae039 = $8f670d5fbe4fff65$var$IframeAdapter;


function $cf23608b6667af63$export$a5e20ff98a035c0f(transaction) {
    return transaction.version === undefined;
}


var $ecf1f6e66ab822b4$export$a4ad2735b021c132 = "1.4.2";


var $0e78d8aad3851e26$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0e78d8aad3851e26$var$__assign = undefined && undefined.__assign || function() {
    $0e78d8aad3851e26$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e78d8aad3851e26$var$__assign.apply(this, arguments);
};
var $0e78d8aad3851e26$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0e78d8aad3851e26$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0e78d8aad3851e26$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $0e78d8aad3851e26$var$Solflare = /** @class */ function(_super) {
    $0e78d8aad3851e26$var$__extends(Solflare, _super);
    function Solflare(config) {
        var _this = _super.call(this) || this;
        _this._network = "mainnet-beta";
        _this._provider = null;
        _this._iframeParams = {};
        _this._adapterInstance = null;
        _this._element = null;
        _this._iframe = null;
        _this._connectHandler = null;
        _this._flutterHandlerInterval = null;
        _this._handleEvent = function(event) {
            var _a, _b, _c, _d;
            switch(event.type){
                case "connect_native_web":
                    _this._collapseIframe();
                    _this._adapterInstance = new (0, $3e4ca14c9a7cad76$export$2e2bcd8739ae039)(_this._iframe, _this._network, ((_a = event.data) === null || _a === void 0 ? void 0 : _a.provider) || _this._provider || "https://solflare.com/provider");
                    _this._adapterInstance.on("connect", _this._webConnected);
                    _this._adapterInstance.on("disconnect", _this._webDisconnected);
                    _this._adapterInstance.connect();
                    _this._setPreferredAdapter("native_web");
                    return;
                case "connect":
                    _this._collapseIframe();
                    _this._adapterInstance = new (0, $8f670d5fbe4fff65$export$2e2bcd8739ae039)(_this._iframe, ((_b = event.data) === null || _b === void 0 ? void 0 : _b.publicKey) || "");
                    _this._adapterInstance.connect();
                    _this._setPreferredAdapter((_c = event.data) === null || _c === void 0 ? void 0 : _c.adapter);
                    if (_this._connectHandler) {
                        _this._connectHandler.resolve();
                        _this._connectHandler = null;
                    }
                    _this.emit("connect", _this.publicKey);
                    return;
                case "disconnect":
                    if (_this._connectHandler) {
                        _this._connectHandler.reject();
                        _this._connectHandler = null;
                    }
                    _this._disconnected();
                    _this.emit("disconnect");
                    return;
                case "accountChanged":
                    if ((_d = event.data) === null || _d === void 0 ? void 0 : _d.publicKey) {
                        _this._adapterInstance = new (0, $8f670d5fbe4fff65$export$2e2bcd8739ae039)(_this._iframe, event.data.publicKey);
                        _this._adapterInstance.connect();
                        _this.emit("accountChanged", _this.publicKey);
                    } else _this.emit("accountChanged", undefined);
                    return;
                // legacy event, use resize message type instead
                case "collapse":
                    _this._collapseIframe();
                    return;
                default:
                    return;
            }
        };
        _this._handleResize = function(data) {
            if (data.resizeMode === "full") {
                if (data.params.mode === "fullscreen") _this._expandIframe();
                else if (data.params.mode === "hide") _this._collapseIframe();
            } else if (data.resizeMode === "coordinates") {
                if (_this._iframe) {
                    _this._iframe.style.top = isFinite(data.params.top) ? "".concat(data.params.top, "px") : "";
                    _this._iframe.style.bottom = isFinite(data.params.bottom) ? "".concat(data.params.bottom, "px") : "";
                    _this._iframe.style.left = isFinite(data.params.left) ? "".concat(data.params.left, "px") : "";
                    _this._iframe.style.right = isFinite(data.params.right) ? "".concat(data.params.right, "px") : "";
                    _this._iframe.style.width = isFinite(data.params.width) ? "".concat(data.params.width, "px") : data.params.width;
                    _this._iframe.style.height = isFinite(data.params.height) ? "".concat(data.params.height, "px") : data.params.height;
                }
            }
        };
        _this._handleMessage = function(event) {
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.channel) !== "solflareIframeToWalletAdapter") return;
            var data = event.data.data || {};
            if (data.type === "event") _this._handleEvent(data.event);
            else if (data.type === "resize") _this._handleResize(data);
            else if (data.type === "response") {
                if (_this._adapterInstance) _this._adapterInstance.handleMessage(data);
            }
        };
        _this._removeElement = function() {
            if (_this._flutterHandlerInterval !== null) {
                clearInterval(_this._flutterHandlerInterval);
                _this._flutterHandlerInterval = null;
            }
            if (_this._element) {
                _this._element.remove();
                _this._element = null;
            }
        };
        _this._removeDanglingElements = function() {
            var e_1, _a;
            var elements = document.getElementsByClassName("solflare-wallet-adapter-iframe");
            try {
                for(var elements_1 = $0e78d8aad3851e26$var$__values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()){
                    var element = elements_1_1.value;
                    if (element.parentElement) element.remove();
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        };
        _this._injectElement = function() {
            _this._removeElement();
            _this._removeDanglingElements();
            var params = $0e78d8aad3851e26$var$__assign($0e78d8aad3851e26$var$__assign({}, _this._iframeParams), {
                cluster: _this._network || "mainnet-beta",
                origin: window.location.origin || "",
                title: document.title || "",
                version: 1,
                sdkVersion: (0, $ecf1f6e66ab822b4$export$a4ad2735b021c132) || "unknown"
            });
            var preferredAdapter = _this._getPreferredAdapter();
            if (preferredAdapter) params.adapter = preferredAdapter;
            if (_this._provider) params.provider = _this._provider;
            var queryString = Object.keys(params).map(function(key) {
                return "".concat(key, "=").concat(encodeURIComponent(params[key]));
            }).join("&");
            var iframeUrl = "".concat(Solflare.IFRAME_URL, "?").concat(queryString);
            _this._element = document.createElement("div");
            _this._element.className = "solflare-wallet-adapter-iframe";
            _this._element.innerHTML = "\n      <iframe src='".concat(iframeUrl, "' referrerPolicy='strict-origin-when-cross-origin' style='position: fixed; top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%; border: none; border-radius: 0; z-index: 99999; color-scheme: auto;' allowtransparency='true'></iframe>\n    ");
            document.body.appendChild(_this._element);
            _this._iframe = _this._element.querySelector("iframe");
            // @ts-ignore
            window.fromFlutter = _this._handleMobileMessage;
            _this._flutterHandlerInterval = setInterval(function() {
                // @ts-ignore
                window.fromFlutter = _this._handleMobileMessage;
            }, 100);
            window.addEventListener("message", _this._handleMessage, false);
        };
        _this._collapseIframe = function() {
            if (_this._iframe) {
                _this._iframe.style.top = "";
                _this._iframe.style.right = "";
                _this._iframe.style.height = "2px";
                _this._iframe.style.width = "2px";
            }
        };
        _this._expandIframe = function() {
            if (_this._iframe) {
                _this._iframe.style.top = "0px";
                _this._iframe.style.bottom = "0px";
                _this._iframe.style.left = "0px";
                _this._iframe.style.right = "0px";
                _this._iframe.style.width = "100%";
                _this._iframe.style.height = "100%";
            }
        };
        _this._getPreferredAdapter = function() {
            if (localStorage) return localStorage.getItem("solflarePreferredWalletAdapter") || null;
            return null;
        };
        _this._setPreferredAdapter = function(adapter) {
            if (localStorage && adapter) localStorage.setItem("solflarePreferredWalletAdapter", adapter);
        };
        _this._clearPreferredAdapter = function() {
            if (localStorage) localStorage.removeItem("solflarePreferredWalletAdapter");
        };
        _this._webConnected = function() {
            if (_this._connectHandler) {
                _this._connectHandler.resolve();
                _this._connectHandler = null;
            }
            _this.emit("connect", _this.publicKey);
        };
        _this._webDisconnected = function() {
            if (_this._connectHandler) {
                _this._connectHandler.reject();
                _this._connectHandler = null;
            }
            _this._disconnected();
            _this.emit("disconnect");
        };
        _this._disconnected = function() {
            window.removeEventListener("message", _this._handleMessage, false);
            _this._removeElement();
            _this._clearPreferredAdapter();
            _this._adapterInstance = null;
        };
        _this._handleMobileMessage = function(data) {
            var _a, _b;
            (_b = (_a = _this._iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
                channel: "solflareMobileToIframe",
                data: data
            }, "*");
        };
        if (config === null || config === void 0 ? void 0 : config.network) _this._network = config === null || config === void 0 ? void 0 : config.network;
        if (config === null || config === void 0 ? void 0 : config.provider) _this._provider = config === null || config === void 0 ? void 0 : config.provider;
        if (config === null || config === void 0 ? void 0 : config.params) _this._iframeParams = $0e78d8aad3851e26$var$__assign({}, config === null || config === void 0 ? void 0 : config.params);
        return _this;
    }
    Object.defineProperty(Solflare.prototype, "publicKey", {
        get: function() {
            var _a;
            return ((_a = this._adapterInstance) === null || _a === void 0 ? void 0 : _a.publicKey) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Solflare.prototype, "isConnected", {
        get: function() {
            var _a;
            return !!((_a = this._adapterInstance) === null || _a === void 0 ? void 0 : _a.connected);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Solflare.prototype, "connected", {
        get: function() {
            return this.isConnected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Solflare.prototype, "autoApprove", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Solflare.prototype.connect = function() {
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.connected) return [
                            2 /*return*/ 
                        ];
                        this._injectElement();
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                _this._connectHandler = {
                                    resolve: resolve,
                                    reject: reject
                                };
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Solflare.prototype.disconnect = function() {
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._adapterInstance) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            this._adapterInstance.disconnect()
                        ];
                    case 1:
                        _a.sent();
                        this._disconnected();
                        this.emit("disconnect");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Solflare.prototype.signTransaction = function(transaction) {
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            var serializedTransaction, signedTransaction;
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        serializedTransaction = (0, $cf23608b6667af63$export$a5e20ff98a035c0f)(transaction) ? Uint8Array.from(transaction.serialize({
                            verifySignatures: false,
                            requireAllSignatures: false
                        })) : transaction.serialize();
                        return [
                            4 /*yield*/ ,
                            this._adapterInstance.signTransaction(serializedTransaction)
                        ];
                    case 1:
                        signedTransaction = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $cf23608b6667af63$export$a5e20ff98a035c0f)(transaction) ? (0, $4Ya7C.Transaction).from(signedTransaction) : (0, $4Ya7C.VersionedTransaction).deserialize(signedTransaction)
                        ];
                }
            });
        });
    };
    Solflare.prototype.signAllTransactions = function(transactions) {
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            var serializedTransactions, signedTransactions;
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        serializedTransactions = transactions.map(function(transaction) {
                            return (0, $cf23608b6667af63$export$a5e20ff98a035c0f)(transaction) ? Uint8Array.from(transaction.serialize({
                                verifySignatures: false,
                                requireAllSignatures: false
                            })) : transaction.serialize();
                        });
                        return [
                            4 /*yield*/ ,
                            this._adapterInstance.signAllTransactions(serializedTransactions)
                        ];
                    case 1:
                        signedTransactions = _a.sent();
                        if (signedTransactions.length !== transactions.length) throw new Error("Failed to sign all transactions");
                        return [
                            2 /*return*/ ,
                            signedTransactions.map(function(signedTransaction, index) {
                                return (0, $cf23608b6667af63$export$a5e20ff98a035c0f)(transactions[index]) ? (0, $4Ya7C.Transaction).from(signedTransaction) : (0, $4Ya7C.VersionedTransaction).deserialize(signedTransaction);
                            })
                        ];
                }
            });
        });
    };
    Solflare.prototype.signAndSendTransaction = function(transaction, options) {
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            var serializedTransaction;
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        serializedTransaction = (0, $cf23608b6667af63$export$a5e20ff98a035c0f)(transaction) ? transaction.serialize({
                            verifySignatures: false,
                            requireAllSignatures: false
                        }) : transaction.serialize();
                        return [
                            4 /*yield*/ ,
                            this._adapterInstance.signAndSendTransaction(serializedTransaction, options)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    Solflare.prototype.signMessage = function(data, display) {
        if (display === void 0) display = "utf8";
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.connected) throw new Error("Wallet not connected");
                        return [
                            4 /*yield*/ ,
                            this._adapterInstance.signMessage(data, display)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    Solflare.prototype.sign = function(data, display) {
        if (display === void 0) display = "utf8";
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            return $0e78d8aad3851e26$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.signMessage(data, display)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    Solflare.prototype.detectWallet = function(timeout) {
        var _a;
        if (timeout === void 0) timeout = 10;
        return $0e78d8aad3851e26$var$__awaiter(this, void 0, void 0, function() {
            return $0e78d8aad3851e26$var$__generator(this, function(_b) {
                if (window.SolflareApp || ((_a = window.solflare) === null || _a === void 0 ? void 0 : _a.isSolflare)) return [
                    2 /*return*/ ,
                    true
                ];
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        var pollInterval, pollTimeout;
                        pollInterval = setInterval(function() {
                            var _a;
                            if (window.SolflareApp || ((_a = window.solflare) === null || _a === void 0 ? void 0 : _a.isSolflare)) {
                                clearInterval(pollInterval);
                                clearTimeout(pollTimeout);
                                resolve(true);
                            }
                        }, 500);
                        pollTimeout = setTimeout(function() {
                            clearInterval(pollInterval);
                            resolve(false);
                        }, timeout * 1000);
                    })
                ];
            });
        });
    };
    Solflare.IFRAME_URL = "https://connect.solflare.com/";
    return Solflare;
}((0, $d2ed3f8017184c07$export$2e2bcd8739ae039));
var $0e78d8aad3851e26$export$2e2bcd8739ae039 = $0e78d8aad3851e26$var$Solflare;


parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $5d18a8f9905599a6$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("fk6Pk"));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(provider));
    return signers;
}


const $3eb7d8777ccd4c4b$var$WALLET = (0, $yEwlv.WalletTypes).SOLFLARE;
const $3eb7d8777ccd4c4b$export$e506a1d27d1eaa20 = {
    type: $3eb7d8777ccd4c4b$var$WALLET
};
/*
 * Solflare is a transpiling ESM to CJS as well. It causes interop issues which is normally will be fixed using following code
 */ let $3eb7d8777ccd4c4b$var$SDK = (0, $0e78d8aad3851e26$export$2e2bcd8739ae039);
if (typeof (0, $0e78d8aad3851e26$export$2e2bcd8739ae039) !== "function" && // @ts-expect-error This import error is not visible to TypeScript
typeof (0, $0e78d8aad3851e26$export$2e2bcd8739ae039).default === "function") $3eb7d8777ccd4c4b$var$SDK = (0, $0e78d8aad3851e26$export$2e2bcd8739ae039).default;
const $3eb7d8777ccd4c4b$var$walletInstance = new $3eb7d8777ccd4c4b$var$SDK();
const $3eb7d8777ccd4c4b$export$8bedcca5bbd73999 = ()=>window.solflare ? $3eb7d8777ccd4c4b$var$walletInstance : null;
const $3eb7d8777ccd4c4b$export$64605811ab45167f = async ({ instance: instance })=>{
    try {
        await instance.connect();
        if (instance.publicKey) {
            const account = instance.publicKey?.toString();
            return {
                accounts: [
                    account
                ],
                chainId: (0, $8aS14.LegacyNetworks).SOLANA
            };
        }
        throw new Error();
    } catch (error) {
        throw new Error("An error occurred while connecting to Solflare.");
    }
};
const $3eb7d8777ccd4c4b$export$ec068583843480e7 = ({ instance: instance, updateAccounts: updateAccounts, disconnect: disconnect })=>{
    const handleAccountsChanged = async (publicKey)=>{
        if (publicKey) {
            const account = publicKey.toString();
            updateAccounts([
                account
            ]);
        } else disconnect();
    };
    instance?.on?.("accountChanged", handleAccountsChanged);
    return ()=>{
        instance?.off?.("accountChanged", handleAccountsChanged);
    };
};
const $3eb7d8777ccd4c4b$export$3b3cf9ab9019de20 = ()=>false;
const $3eb7d8777ccd4c4b$export$6352a17a50193ded = (0, $5d18a8f9905599a6$export$2e2bcd8739ae039);
const $3eb7d8777ccd4c4b$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Solflare",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/solflare/icon.svg",
        installLink: {
            CHROME: "https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic",
            BRAVE: "https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/solflare-wallet/",
            EDGE: "https://chromewebstore.google.com/detail/solflare-wallet/bhhhlbepdkbapadjdnnojkbgioiodbic",
            DEFAULT: "https://solflare.com"
        },
        color: "#4d40c6",
        supportedChains: solana
    };
};


var $26682f018f34e7d8$exports = {};

$parcel$export($26682f018f34e7d8$exports, "config", function () { return $26682f018f34e7d8$export$e506a1d27d1eaa20; });
$parcel$export($26682f018f34e7d8$exports, "getInstance", function () { return $26682f018f34e7d8$export$8bedcca5bbd73999; });
$parcel$export($26682f018f34e7d8$exports, "connect", function () { return $26682f018f34e7d8$export$64605811ab45167f; });
$parcel$export($26682f018f34e7d8$exports, "disconnect", function () { return $26682f018f34e7d8$export$37dfea93db2e14ed; });
$parcel$export($26682f018f34e7d8$exports, "subscribe", function () { return $26682f018f34e7d8$export$ec068583843480e7; });
$parcel$export($26682f018f34e7d8$exports, "getSigners", function () { return $26682f018f34e7d8$export$6352a17a50193ded; });
$parcel$export($26682f018f34e7d8$exports, "getWalletInfo", function () { return $26682f018f34e7d8$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");


var $4Ya7C = parcelRequire("4Ya7C");


var $4evmt = parcelRequire("4evmt");


var $3aNd6 = parcelRequire("3aNd6");
var $c6952c3feeea340f$require$Buffer = $3aNd6.Buffer;
function $c6952c3feeea340f$export$a5e20ff98a035c0f(transaction) {
    return transaction.version === undefined;
}
function $c6952c3feeea340f$export$7cb44e9a321cd996(transaction) {
    return $c6952c3feeea340f$export$a5e20ff98a035c0f(transaction) ? transaction.serialize({
        verifySignatures: false,
        requireAllSignatures: false
    }) : transaction.serialize();
}
function $c6952c3feeea340f$export$bbb3fbc09a038d6c(transaction) {
    return $c6952c3feeea340f$export$a5e20ff98a035c0f(transaction) ? transaction.serializeMessage() : transaction.message.serialize();
}
function $c6952c3feeea340f$export$2c46e451e46a8931(transaction, publicKey, signature) {
    if ($c6952c3feeea340f$export$a5e20ff98a035c0f(transaction)) transaction.addSignature(publicKey, $c6952c3feeea340f$require$Buffer.from(signature));
    else {
        const signerPubkeys = transaction.message.staticAccountKeys.slice(0, transaction.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        if (signerIndex >= 0) transaction.signatures[signerIndex] = signature;
    }
}


var $6483e3220639bcdc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $6483e3220639bcdc$export$f7e4886acf8e11ad(provider) {
    return $6483e3220639bcdc$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield provider.request({
                method: "wallet_getSnaps"
            });
            return true;
        } catch (error) {
            return false;
        }
    });
}
function $6483e3220639bcdc$export$49aa21b0f89f5ec() {
    return $6483e3220639bcdc$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const provider = window.ethereum;
            if (!provider) return null;
            if (provider.providers && Array.isArray(provider.providers)) {
                const providers = provider.providers;
                for (const provider of providers){
                    if (yield $6483e3220639bcdc$export$f7e4886acf8e11ad(provider)) return provider;
                }
            }
            if (provider.detected && Array.isArray(provider.detected)) {
                const providers = provider.detected;
                for (const provider of providers){
                    if (yield $6483e3220639bcdc$export$f7e4886acf8e11ad(provider)) return provider;
                }
            }
            if (yield $6483e3220639bcdc$export$f7e4886acf8e11ad(provider)) return provider;
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
}


// This is copied with modification from @wallet-standard/wallet
/** Name of the feature. */ const $4a8d59fb28435229$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

/** Name of the feature. */ const $5896d6fe86244add$export$22c7939a38084172 = "solana:signMessage";

/** Name of the feature. */ const $a4fb3f96564c823d$export$54187c3796d0ecb = "solana:signTransaction";


// This is copied from @solana/wallet-standard-chains
/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $e0bb7272662fecc7$export$bba9a228295b3963 = "solana:mainnet";
const $e0bb7272662fecc7$export$654cc095bd2e650 = "solana:devnet";
const $e0bb7272662fecc7$export$76575b7bf4de1f40 = "solana:testnet";
const $e0bb7272662fecc7$export$483699a75281444c = "solana:localnet";
const $e0bb7272662fecc7$export$d77e7f94b1f6bf7d = [
    $e0bb7272662fecc7$export$bba9a228295b3963,
    $e0bb7272662fecc7$export$654cc095bd2e650,
    $e0bb7272662fecc7$export$76575b7bf4de1f40,
    $e0bb7272662fecc7$export$483699a75281444c
];
function $e0bb7272662fecc7$export$d8f86f4d3d9fc2b5(chain) {
    return $e0bb7272662fecc7$export$d77e7f94b1f6bf7d.includes(chain);
}


var $2cae340d606eab41$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2cae340d606eab41$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_address, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_publicKey, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_chains, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_features, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_label, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_icon;
const $2cae340d606eab41$var$chains = (0, $e0bb7272662fecc7$export$d77e7f94b1f6bf7d);
const $2cae340d606eab41$var$features = [
    (0, $4a8d59fb28435229$export$dd64f32469f35f81),
    (0, $a4fb3f96564c823d$export$54187c3796d0ecb),
    (0, $5896d6fe86244add$export$22c7939a38084172)
];
class $2cae340d606eab41$export$b2698b812af69908 {
    get address() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_address, "f");
    }
    get publicKey() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_publicKey, "f").slice();
    }
    get chains() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_chains, "f").slice();
    }
    get features() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_features, "f").slice();
    }
    get label() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_label, "f");
    }
    get icon() {
        return $2cae340d606eab41$var$__classPrivateFieldGet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_icon, "f");
    }
    constructor({ address: address, publicKey: publicKey, label: label, icon: icon }){
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_address.set(this, void 0);
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_publicKey.set(this, void 0);
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_chains.set(this, void 0);
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_features.set(this, void 0);
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_label.set(this, void 0);
        $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_icon.set(this, void 0);
        if (new.target === $2cae340d606eab41$export$b2698b812af69908) Object.freeze(this);
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_address, address, "f");
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_publicKey, publicKey, "f");
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_chains, $2cae340d606eab41$var$chains, "f");
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_features, $2cae340d606eab41$var$features, "f");
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_label, label, "f");
        $2cae340d606eab41$var$__classPrivateFieldSet(this, $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_icon, icon, "f");
    }
}
$2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_address = new WeakMap(), $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_publicKey = new WeakMap(), $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_chains = new WeakMap(), $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_features = new WeakMap(), $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_label = new WeakMap(), $2cae340d606eab41$var$_StandardSolflareMetaMaskWalletAccount_icon = new WeakMap();





var $d2de2bd8704cab16$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $d2de2bd8704cab16$var$SolflareMetaMask extends (0, $d2ed3f8017184c07$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._network = "mainnet-beta";
        this._iframeParams = {};
        this._element = null;
        this._iframe = null;
        this._publicKey = null;
        this._account = null;
        this._isConnected = false;
        this._connectHandler = null;
        this._messageHandlers = {};
        this._handleEvent = (event)=>{
            var _a, _b;
            switch(event.type){
                case "connect":
                    this._collapseIframe();
                    if ((_a = event.data) === null || _a === void 0 ? void 0 : _a.publicKey) {
                        this._publicKey = event.data.publicKey;
                        this._isConnected = true;
                        if (this._connectHandler) {
                            this._connectHandler.resolve();
                            this._connectHandler = null;
                        }
                        this._connected();
                    } else {
                        if (this._connectHandler) {
                            this._connectHandler.reject();
                            this._connectHandler = null;
                        }
                        this._disconnected();
                    }
                    return;
                case "disconnect":
                    if (this._connectHandler) {
                        this._connectHandler.reject();
                        this._connectHandler = null;
                    }
                    this._disconnected();
                    return;
                case "accountChanged":
                    if ((_b = event.data) === null || _b === void 0 ? void 0 : _b.publicKey) {
                        this._publicKey = event.data.publicKey;
                        this.emit("accountChanged", this.publicKey);
                        this._standardConnected();
                    } else {
                        this.emit("accountChanged", undefined);
                        this._standardDisconnected();
                    }
                    return;
                default:
                    return;
            }
        };
        this._handleResize = (data)=>{
            if (data.resizeMode === "full") {
                if (data.params.mode === "fullscreen") this._expandIframe();
                else if (data.params.mode === "hide") this._collapseIframe();
            } else if (data.resizeMode === "coordinates") this._resizeIframe(data.params);
        };
        this._handleMessage = (event)=>{
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.channel) !== "solflareIframeToWalletAdapter") return;
            const data = event.data.data || {};
            if (data.type === "event") this._handleEvent(data.event);
            else if (data.type === "resize") this._handleResize(data);
            else if (data.type === "response") {
                if (this._messageHandlers[data.id]) {
                    const { resolve: resolve, reject: reject } = this._messageHandlers[data.id];
                    delete this._messageHandlers[data.id];
                    if (data.error) reject(data.error);
                    else resolve(data.result);
                }
            }
        };
        this._removeElement = ()=>{
            if (this._element) {
                this._element.remove();
                this._element = null;
            }
        };
        this._removeDanglingElements = ()=>{
            const elements = document.getElementsByClassName("solflare-metamask-wallet-adapter-iframe");
            for (const element of elements)if (element.parentElement) element.remove();
        };
        this._injectElement = ()=>{
            this._removeElement();
            this._removeDanglingElements();
            const params = Object.assign(Object.assign({}, this._iframeParams), {
                mm: true,
                v: 1,
                cluster: this._network || "mainnet-beta",
                origin: window.location.origin || "",
                title: document.title || ""
            });
            const queryString = Object.keys(params).map((key)=>`${key}=${encodeURIComponent(params[key])}`).join("&");
            const iframeUrl = `${$d2de2bd8704cab16$var$SolflareMetaMask.IFRAME_URL}?${queryString}`;
            this._element = document.createElement("div");
            this._element.className = "solflare-metamask-wallet-adapter-iframe";
            this._element.innerHTML = `
      <iframe src='${iframeUrl}' style='position: fixed; top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%; border: none; border-radius: 0; z-index: 99999; color-scheme: auto;' allowtransparency='true'></iframe>
    `;
            document.body.appendChild(this._element);
            this._iframe = this._element.querySelector("iframe");
            window.addEventListener("message", this._handleMessage, false);
        };
        this._collapseIframe = ()=>{
            if (this._iframe) {
                this._iframe.style.top = "";
                this._iframe.style.right = "";
                this._iframe.style.height = "2px";
                this._iframe.style.width = "2px";
            }
        };
        this._expandIframe = ()=>{
            if (this._iframe) {
                this._iframe.style.top = "0px";
                this._iframe.style.bottom = "0px";
                this._iframe.style.left = "0px";
                this._iframe.style.right = "0px";
                this._iframe.style.width = "100%";
                this._iframe.style.height = "100%";
            }
        };
        this._resizeIframe = (params)=>{
            if (!this._iframe) return;
            this._iframe.style.top = isFinite(params.top) ? `${params.top}px` : "";
            this._iframe.style.bottom = isFinite(params.bottom) ? `${params.bottom}px` : "";
            this._iframe.style.left = isFinite(params.left) ? `${params.left}px` : "";
            this._iframe.style.right = isFinite(params.right) ? `${params.right}px` : "";
            this._iframe.style.width = isFinite(params.width) ? `${params.width}px` : params.width;
            this._iframe.style.height = isFinite(params.height) ? `${params.height}px` : params.height;
        };
        this._sendIframeMessage = (data)=>{
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            return new Promise((resolve, reject)=>{
                var _a, _b;
                const messageId = (0, $d0666643e2ee88b4$export$2e2bcd8739ae039)();
                this._messageHandlers[messageId] = {
                    resolve: resolve,
                    reject: reject
                };
                (_b = (_a = this._iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
                    channel: "solflareWalletAdapterToIframe",
                    data: Object.assign({
                        id: messageId
                    }, data)
                }, "*");
            });
        };
        this._connected = ()=>{
            this._isConnected = true;
            this.emit("connect", this.publicKey);
            this._standardConnected();
        };
        this._disconnected = ()=>{
            this._publicKey = null;
            this._isConnected = false;
            window.removeEventListener("message", this._handleMessage, false);
            this._removeElement();
            this.emit("disconnect");
            this._standardDisconnected();
        };
        this._standardConnected = ()=>{
            if (!this.publicKey) return;
            const address = this.publicKey.toString();
            if (!this._account || this._account.address !== address) {
                this._account = new (0, $2cae340d606eab41$export$b2698b812af69908)({
                    address: address,
                    publicKey: this.publicKey.toBytes()
                });
                this.emit("standard_change", {
                    accounts: this.standardAccounts
                });
            }
        };
        this._standardDisconnected = ()=>{
            if (this._account) {
                this._account = null;
                this.emit("standard_change", {
                    accounts: this.standardAccounts
                });
            }
        };
        if (config === null || config === void 0 ? void 0 : config.network) this._network = config === null || config === void 0 ? void 0 : config.network;
        if (window.SolflareMetaMaskParams) this._iframeParams = Object.assign(Object.assign({}, this._iframeParams), window.SolflareMetaMaskParams);
        if (config === null || config === void 0 ? void 0 : config.params) this._iframeParams = Object.assign(Object.assign({}, this._iframeParams), config === null || config === void 0 ? void 0 : config.params);
    }
    get publicKey() {
        return this._publicKey ? new (0, $4Ya7C.PublicKey)(this._publicKey) : null;
    }
    get standardAccount() {
        return this._account;
    }
    get standardAccounts() {
        return this._account ? [
            this._account
        ] : [];
    }
    get isConnected() {
        return this._isConnected;
    }
    get connected() {
        return this.isConnected;
    }
    get autoApprove() {
        return false;
    }
    connect() {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connected) return;
            this._injectElement();
            yield new Promise((resolve, reject)=>{
                this._connectHandler = {
                    resolve: resolve,
                    reject: reject
                };
            });
        });
    }
    disconnect() {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            yield this._sendIframeMessage({
                method: "disconnect"
            });
            this._disconnected();
        });
    }
    signTransaction(transaction) {
        var _a;
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransaction = (0, $c6952c3feeea340f$export$7cb44e9a321cd996)(transaction);
                const response = yield this._sendIframeMessage({
                    method: "signTransactionV2",
                    params: {
                        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(serializedTransaction)
                    }
                });
                const { transaction: signedTransaction } = response;
                return (0, $c6952c3feeea340f$export$a5e20ff98a035c0f)(transaction) ? (0, $4Ya7C.Transaction).from((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction)) : (0, $4Ya7C.VersionedTransaction).deserialize((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction));
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign transaction");
            }
        });
    }
    signAllTransactions(transactions) {
        var _a;
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransactions = transactions.map((transaction)=>(0, $c6952c3feeea340f$export$7cb44e9a321cd996)(transaction));
                const { transactions: signedTransactions } = yield this._sendIframeMessage({
                    method: "signAllTransactionsV2",
                    params: {
                        transactions: serializedTransactions.map((transaction)=>(0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(transaction))
                    }
                });
                return signedTransactions.map((signedTransaction, index)=>{
                    return (0, $c6952c3feeea340f$export$a5e20ff98a035c0f)(transactions[index]) ? (0, $4Ya7C.Transaction).from((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction)) : (0, $4Ya7C.VersionedTransaction).deserialize((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signedTransaction));
                });
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign transactions");
            }
        });
    }
    signAndSendTransaction(transaction, options) {
        var _a;
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const serializedTransaction = (0, $c6952c3feeea340f$export$7cb44e9a321cd996)(transaction);
                const { signature: signature } = yield this._sendIframeMessage({
                    method: "signAndSendTransaction",
                    params: {
                        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(serializedTransaction),
                        options: options
                    }
                });
                return signature;
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign and send transaction");
            }
        });
    }
    signMessage(data, display = "utf8") {
        var _a;
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected || !this.publicKey) throw new Error("Wallet not connected");
            try {
                const { signature: signature } = yield this._sendIframeMessage({
                    method: "signMessage",
                    params: {
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).encode(data),
                        display: display
                    }
                });
                return Uint8Array.from((0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signature));
            } catch (e) {
                throw new Error(((_a = e === null || e === void 0 ? void 0 : e.toString) === null || _a === void 0 ? void 0 : _a.call(e)) || "Failed to sign message");
            }
        });
    }
    sign(data, display = "utf8") {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.signMessage(data, display);
        });
    }
    static isSupported() {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            const provider = yield (0, $6483e3220639bcdc$export$49aa21b0f89f5ec)();
            return !!provider;
        });
    }
    standardSignAndSendTransaction(...inputs) {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { transaction: transaction, account: account, chain: chain, options: options } = inputs[0];
                const { minContextSlot: minContextSlot, preflightCommitment: preflightCommitment, skipPreflight: skipPreflight, maxRetries: maxRetries } = options || {};
                if (account !== this._account) throw new Error("invalid account");
                if (!(0, $e0bb7272662fecc7$export$d8f86f4d3d9fc2b5)(chain)) throw new Error("invalid chain");
                const signature = yield this.signAndSendTransaction((0, $4Ya7C.VersionedTransaction).deserialize(transaction), {
                    preflightCommitment: preflightCommitment,
                    minContextSlot: minContextSlot,
                    maxRetries: maxRetries,
                    skipPreflight: skipPreflight
                });
                outputs.push({
                    signature: (0, (/*@__PURE__*/$parcel$interopDefault($4evmt))).decode(signature)
                });
            } else if (inputs.length > 1) for (const input of inputs)outputs.push(...yield this.standardSignAndSendTransaction(input));
            return outputs;
        });
    }
    standardSignTransaction(...inputs) {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { transaction: transaction, account: account, chain: chain } = inputs[0];
                if (account !== this._account) throw new Error("invalid account");
                if (chain && !(0, $e0bb7272662fecc7$export$d8f86f4d3d9fc2b5)(chain)) throw new Error("invalid chain");
                const signedTransaction = yield this.signTransaction((0, $4Ya7C.VersionedTransaction).deserialize(transaction));
                outputs.push({
                    signedTransaction: signedTransaction.serialize()
                });
            } else if (inputs.length > 1) {
                let chain;
                for (const input of inputs){
                    if (input.account !== this._account) throw new Error("invalid account");
                    if (input.chain) {
                        if (!(0, $e0bb7272662fecc7$export$d8f86f4d3d9fc2b5)(input.chain)) throw new Error("invalid chain");
                        if (chain) {
                            if (input.chain !== chain) throw new Error("conflicting chain");
                        } else chain = input.chain;
                    }
                }
                const transactions = inputs.map(({ transaction: transaction })=>(0, $4Ya7C.VersionedTransaction).deserialize(transaction));
                const signedTransactions = yield this.signAllTransactions(transactions);
                outputs.push(...signedTransactions.map((signedTransaction)=>({
                        signedTransaction: signedTransaction.serialize()
                    })));
            }
            return outputs;
        });
    }
    standardSignMessage(...inputs) {
        return $d2de2bd8704cab16$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.connected) throw new Error("not connected");
            const outputs = [];
            if (inputs.length === 1) {
                const { message: message, account: account } = inputs[0];
                if (account !== this._account) throw new Error("invalid account");
                const signature = yield this.signMessage(message);
                outputs.push({
                    signedMessage: message,
                    signature: signature
                });
            } else if (inputs.length > 1) for (const input of inputs)outputs.push(...yield this.standardSignMessage(input));
            return outputs;
        });
    }
}
$d2de2bd8704cab16$var$SolflareMetaMask.IFRAME_URL = "https://widget.solflare.com/";
var $d2de2bd8704cab16$export$2e2bcd8739ae039 = $d2de2bd8704cab16$var$SolflareMetaMask;


function $14da55b14656dc43$export$c82b810292d43863() {
    const metamaskInstance = (0, $8aa8f19907af02ea$export$8bedcca5bbd73999)();
    if (metamaskInstance) {
        const solflareMetaMask = new (0, $d2de2bd8704cab16$export$2e2bcd8739ae039)();
        return solflareMetaMask;
    }
    return null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $0b024a5ee788adf9$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { SolflareSnapSolanaSigner: SolflareSnapSolanaSigner } = await (parcelRequire("i2utu"));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new SolflareSnapSolanaSigner(provider));
    return signers;
}


const $26682f018f34e7d8$export$e506a1d27d1eaa20 = {
    type: (0, $yEwlv.WalletTypes).SOLFLARE_SNAP
};
const $26682f018f34e7d8$export$8bedcca5bbd73999 = (0, $14da55b14656dc43$export$c82b810292d43863);
const $26682f018f34e7d8$export$64605811ab45167f = async ({ instance: instance })=>{
    try {
        await instance.connect();
        if (!!instance.standardAccounts?.length) return {
            accounts: [
                instance.standardAccounts?.map((account)=>account.address)
            ],
            chainId: (0, $8aS14.LegacyNetworks).SOLANA
        };
        return [];
    } catch (error) {
        throw new Error("Could not connect to Snap");
    }
};
const $26682f018f34e7d8$export$37dfea93db2e14ed = async ({ instance: instance })=>{
    if (instance?.isConnected) instance?.disconnect();
};
const $26682f018f34e7d8$export$ec068583843480e7 = ({ instance: instance, disconnect: disconnect })=>{
    instance?.on("disconnect", async ()=>disconnect());
};
const $26682f018f34e7d8$export$6352a17a50193ded = (0, $0b024a5ee788adf9$export$2e2bcd8739ae039);
const $26682f018f34e7d8$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const solana = (0, $21GQj.solanaBlockchain)(allBlockChains);
    return {
        name: "Solana Snap",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/solflare-snap/icon.svg",
        installLink: {
            DEFAULT: "https://solflare.com/metamask"
        },
        color: "#dac7ae",
        supportedChains: solana
    };
};


var $4c7ba30550f08373$exports = {};

$parcel$export($4c7ba30550f08373$exports, "config", function () { return $4c7ba30550f08373$export$e506a1d27d1eaa20; });
$parcel$export($4c7ba30550f08373$exports, "getInstance", function () { return $4c7ba30550f08373$export$8bedcca5bbd73999; });
$parcel$export($4c7ba30550f08373$exports, "connect", function () { return $4c7ba30550f08373$export$64605811ab45167f; });
$parcel$export($4c7ba30550f08373$exports, "subscribe", function () { return $4c7ba30550f08373$export$ec068583843480e7; });
$parcel$export($4c7ba30550f08373$exports, "switchNetwork", function () { return $4c7ba30550f08373$export$f3473d805e486329; });
$parcel$export($4c7ba30550f08373$exports, "canSwitchNetworkTo", function () { return $4c7ba30550f08373$export$3b3cf9ab9019de20; });
$parcel$export($4c7ba30550f08373$exports, "getSigners", function () { return $4c7ba30550f08373$export$6352a17a50193ded; });
$parcel$export($4c7ba30550f08373$exports, "canEagerConnect", function () { return $4c7ba30550f08373$export$be9f3c5ed1d25e42; });
$parcel$export($4c7ba30550f08373$exports, "getWalletInfo", function () { return $4c7ba30550f08373$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
function $5929b51a4c6b235b$export$a6e3712902d7179d() {
    const { tally: tally } = window;
    if (!tally) return null;
    return tally;
}
const $5929b51a4c6b235b$export$7dea4b4511e736f7 = [
    (0, $8aS14.LegacyNetworks).ETHEREUM,
    (0, $8aS14.LegacyNetworks).POLYGON,
    (0, $8aS14.LegacyNetworks).OPTIMISM,
    (0, $8aS14.LegacyNetworks).ARBITRUM,
    (0, $8aS14.LegacyNetworks).AVAX_CCHAIN,
    (0, $8aS14.LegacyNetworks).BSC
];


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $8782f6f960d0310d$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(provider));
    return signers;
}


const $4c7ba30550f08373$var$WALLET = (0, $yEwlv.WalletTypes).TAHO;
const $4c7ba30550f08373$export$e506a1d27d1eaa20 = {
    type: $4c7ba30550f08373$var$WALLET
};
const $4c7ba30550f08373$export$8bedcca5bbd73999 = (0, $5929b51a4c6b235b$export$a6e3712902d7179d);
const $4c7ba30550f08373$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $4c7ba30550f08373$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $4c7ba30550f08373$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $4c7ba30550f08373$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $4c7ba30550f08373$export$6352a17a50193ded = (0, $8782f6f960d0310d$export$2e2bcd8739ae039);
const $4c7ba30550f08373$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $4c7ba30550f08373$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    return {
        name: "Taho",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/taho/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd",
            BRAVE: "https://chrome.google.com/webstore/detail/taho/eajafomhmkipbjmfmhebemolkcicgfmd",
            DEFAULT: "https://taho.xyz"
        },
        color: "#ffffff",
        supportedChains: allBlockChains.filter((blockchainMeta)=>(0, $5929b51a4c6b235b$export$7dea4b4511e736f7).includes(blockchainMeta.name))
    };
};


var $1615b2cf8584bb6e$exports = {};

$parcel$export($1615b2cf8584bb6e$exports, "config", function () { return $1615b2cf8584bb6e$export$e506a1d27d1eaa20; });
$parcel$export($1615b2cf8584bb6e$exports, "getInstance", function () { return $1615b2cf8584bb6e$export$8bedcca5bbd73999; });
$parcel$export($1615b2cf8584bb6e$exports, "connect", function () { return $1615b2cf8584bb6e$export$64605811ab45167f; });
$parcel$export($1615b2cf8584bb6e$exports, "subscribe", function () { return $1615b2cf8584bb6e$export$ec068583843480e7; });
$parcel$export($1615b2cf8584bb6e$exports, "switchNetwork", function () { return $1615b2cf8584bb6e$export$f3473d805e486329; });
$parcel$export($1615b2cf8584bb6e$exports, "canSwitchNetworkTo", function () { return $1615b2cf8584bb6e$export$3b3cf9ab9019de20; });
$parcel$export($1615b2cf8584bb6e$exports, "getSigners", function () { return $1615b2cf8584bb6e$export$6352a17a50193ded; });
$parcel$export($1615b2cf8584bb6e$exports, "canEagerConnect", function () { return $1615b2cf8584bb6e$export$be9f3c5ed1d25e42; });
$parcel$export($1615b2cf8584bb6e$exports, "getWalletInfo", function () { return $1615b2cf8584bb6e$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $0630b1491dd15ceb$export$fd8555b3d22160de() {
    const { ethereum: ethereum } = window;
    if (ethereum && ethereum.isTokenPocket) return ethereum;
    return null;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $7285124b05d54600$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}


const $1615b2cf8584bb6e$var$WALLET = (0, $yEwlv.WalletTypes).TOKEN_POCKET;
const $1615b2cf8584bb6e$export$e506a1d27d1eaa20 = {
    type: $1615b2cf8584bb6e$var$WALLET
};
const $1615b2cf8584bb6e$export$8bedcca5bbd73999 = (0, $0630b1491dd15ceb$export$fd8555b3d22160de);
const $1615b2cf8584bb6e$export$64605811ab45167f = async ({ instance: instance })=>{
    /*
   * Note: We need to get `chainId` here, because for the first time
   * after opening the browser, wallet is locked, and don't give us accounts and chainId
   * on `check` phase, so `network` will be null. For this case we need to get chainId
   * whenever we are requesting accounts.
   */ const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $1615b2cf8584bb6e$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $1615b2cf8584bb6e$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $1615b2cf8584bb6e$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $1615b2cf8584bb6e$export$6352a17a50193ded = (0, $7285124b05d54600$export$2e2bcd8739ae039);
const $1615b2cf8584bb6e$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $1615b2cf8584bb6e$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Token Pocket",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tokenpocket/icon.svg",
        color: "#b2dbff",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii",
            BRAVE: "https://chrome.google.com/webstore/detail/tokenpocket/mfgccjchihfkkindfppnaooecgfneiii",
            DEFAULT: "https://www.tokenpocket.pro/en/download/app"
        },
        supportedChains: evms
    };
};


var $670e3547ef6a3ec6$exports = {};

$parcel$export($670e3547ef6a3ec6$exports, "config", function () { return $670e3547ef6a3ec6$export$e506a1d27d1eaa20; });
$parcel$export($670e3547ef6a3ec6$exports, "getInstance", function () { return $670e3547ef6a3ec6$export$8bedcca5bbd73999; });
$parcel$export($670e3547ef6a3ec6$exports, "connect", function () { return $670e3547ef6a3ec6$export$64605811ab45167f; });
$parcel$export($670e3547ef6a3ec6$exports, "subscribe", function () { return $670e3547ef6a3ec6$export$ec068583843480e7; });
$parcel$export($670e3547ef6a3ec6$exports, "switchNetwork", function () { return $670e3547ef6a3ec6$export$f3473d805e486329; });
$parcel$export($670e3547ef6a3ec6$exports, "canSwitchNetworkTo", function () { return $670e3547ef6a3ec6$export$3b3cf9ab9019de20; });
$parcel$export($670e3547ef6a3ec6$exports, "getSigners", function () { return $670e3547ef6a3ec6$export$6352a17a50193ded; });
$parcel$export($670e3547ef6a3ec6$exports, "canEagerConnect", function () { return $670e3547ef6a3ec6$export$be9f3c5ed1d25e42; });
$parcel$export($670e3547ef6a3ec6$exports, "getWalletInfo", function () { return $670e3547ef6a3ec6$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $4b05e368c3d0fee9$export$80e00309bbc24489() {
    const { tomo_evm: tomo_evm } = window;
    if (tomo_evm) return tomo_evm;
    return null;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $15276c027b378bd7$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}


const $670e3547ef6a3ec6$var$WALLET = (0, $yEwlv.WalletTypes).TOMO;
const $670e3547ef6a3ec6$export$e506a1d27d1eaa20 = {
    type: $670e3547ef6a3ec6$var$WALLET
};
const $670e3547ef6a3ec6$export$8bedcca5bbd73999 = (0, $4b05e368c3d0fee9$export$80e00309bbc24489);
const $670e3547ef6a3ec6$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $670e3547ef6a3ec6$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $670e3547ef6a3ec6$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $670e3547ef6a3ec6$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $670e3547ef6a3ec6$export$6352a17a50193ded = (0, $15276c027b378bd7$export$2e2bcd8739ae039);
const $670e3547ef6a3ec6$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $670e3547ef6a3ec6$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Tomo",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tomo/icon.svg",
        color: "#b2dbff",
        installLink: {
            CHROME: "https://chromewebstore.google.com/detail/tomo-wallet/pfccjkejcgoppjnllalolplgogenfojk?hl=en",
            BRAVE: "https://chromewebstore.google.com/detail/tomo-wallet/pfccjkejcgoppjnllalolplgogenfojk?hl=en",
            DEFAULT: "https://tomo.inc/"
        },
        supportedChains: evms
    };
};


var $ef997ea342edd1ae$exports = {};

$parcel$export($ef997ea342edd1ae$exports, "config", function () { return $ef997ea342edd1ae$export$e506a1d27d1eaa20; });
$parcel$export($ef997ea342edd1ae$exports, "init", function () { return $ef997ea342edd1ae$export$2cd8252107eb640b; });
$parcel$export($ef997ea342edd1ae$exports, "getInstance", function () { return $ef997ea342edd1ae$export$8bedcca5bbd73999; });
$parcel$export($ef997ea342edd1ae$exports, "connect", function () { return $ef997ea342edd1ae$export$64605811ab45167f; });
$parcel$export($ef997ea342edd1ae$exports, "getSigners", function () { return $ef997ea342edd1ae$export$6352a17a50193ded; });
$parcel$export($ef997ea342edd1ae$exports, "getWalletInfo", function () { return $ef997ea342edd1ae$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");

var $6peVL = parcelRequire("6peVL");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $20e43649dd851bf0$export$2e2bcd8739ae039() {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { EthereumSigner: EthereumSigner } = await (parcelRequire("iB1e7"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new EthereumSigner());
    return signers;
}



var $3HnEP = parcelRequire("3HnEP");
let $ef997ea342edd1ae$var$trezorManifest = {
    appUrl: "",
    email: ""
};
const $ef997ea342edd1ae$export$e506a1d27d1eaa20 = {
    type: (0, $yEwlv.WalletTypes).TREZOR
};
const $ef997ea342edd1ae$export$2cd8252107eb640b = (environments)=>{
    $ef997ea342edd1ae$var$trezorManifest = environments.manifest;
};
const $ef997ea342edd1ae$export$8bedcca5bbd73999 = (0, $6peVL.getTrezorInstance);
let $ef997ea342edd1ae$var$isTrezorInitialized = false;
const $ef997ea342edd1ae$export$64605811ab45167f = async ({ namespaces: namespaces })=>{
    const results = [];
    const TrezorConnect = await (0, $6peVL.getTrezorModule)();
    const evmNamespace = namespaces?.find((namespaceItem)=>namespaceItem.namespace === (0, $8aS14.LegacyNamespace).Evm);
    if (evmNamespace) {
        if (evmNamespace.derivationPath) {
            (0, $3HnEP.setDerivationPath)((0, $6peVL.getTrezorNormalizedDerivationPath)(evmNamespace.derivationPath));
            if (!$ef997ea342edd1ae$var$isTrezorInitialized) {
                await TrezorConnect.init({
                    lazyLoad: true,
                    manifest: $ef997ea342edd1ae$var$trezorManifest
                });
                $ef997ea342edd1ae$var$isTrezorInitialized = true;
            }
            const accounts = await (0, $6peVL.getEthereumAccounts)();
            results.push(accounts);
        } else throw new Error("Derivation Path can not be empty.");
    } else throw new Error(`It appears that you have selected a namespace that is not yet supported by our system. Your namespaces: ${namespaces?.map((namespaceItem)=>namespaceItem.namespace)}`);
    return results;
};
const $ef997ea342edd1ae$export$6352a17a50193ded = (0, $20e43649dd851bf0$export$2e2bcd8739ae039);
const $ef997ea342edd1ae$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedChains = [];
    const ethereumBlockchain = allBlockChains.find((chain)=>chain.name === (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (ethereumBlockchain) supportedChains.push(ethereumBlockchain);
    return {
        name: "Trezor",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trezor/icon.svg",
        installLink: {
            DEFAULT: "https://trezor.io/learn/a/download-verify-trezor-suite"
        },
        color: "black",
        supportedChains: supportedChains,
        namespaces: [
            (0, $8aS14.LegacyNamespace).Evm
        ],
        singleNamespace: true,
        showOnMobile: false,
        needsDerivationPath: true
    };
};


var $ff5727fa66478b70$exports = {};

$parcel$export($ff5727fa66478b70$exports, "config", function () { return $ff5727fa66478b70$export$e506a1d27d1eaa20; });
$parcel$export($ff5727fa66478b70$exports, "getInstance", function () { return $ff5727fa66478b70$export$8bedcca5bbd73999; });
$parcel$export($ff5727fa66478b70$exports, "connect", function () { return $ff5727fa66478b70$export$64605811ab45167f; });
$parcel$export($ff5727fa66478b70$exports, "subscribe", function () { return $ff5727fa66478b70$export$ec068583843480e7; });
$parcel$export($ff5727fa66478b70$exports, "canSwitchNetworkTo", function () { return $ff5727fa66478b70$export$3b3cf9ab9019de20; });
$parcel$export($ff5727fa66478b70$exports, "getSigners", function () { return $ff5727fa66478b70$export$6352a17a50193ded; });
$parcel$export($ff5727fa66478b70$exports, "getWalletInfo", function () { return $ff5727fa66478b70$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $821a73cdf74f55ee$export$4b1f753594498963() {
    const { tronLink: tronLink } = window;
    if (!!tronLink) return tronLink;
    return null;
}


parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $4ebc5f1bd2a50cfd$export$2e2bcd8739ae039(provider) {
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultTronSigner: DefaultTronSigner } = await (parcelRequire("fqCpP"));
    signers.registerSigner((0, $liigz.TransactionType).TRON, new DefaultTronSigner(provider));
    return signers;
}


/*
 * https://docs.tronlink.org/dapp/start-developing
 * https://developers.tron.network/docs/tronlink-events
 */ const $ff5727fa66478b70$var$WALLET = (0, $yEwlv.WalletTypes).TRON_LINK;
const $ff5727fa66478b70$export$e506a1d27d1eaa20 = {
    type: $ff5727fa66478b70$var$WALLET,
    defaultNetwork: (0, $8aS14.LegacyNetworks).TRON
};
const $ff5727fa66478b70$export$8bedcca5bbd73999 = (0, $821a73cdf74f55ee$export$4b1f753594498963);
const $ff5727fa66478b70$export$64605811ab45167f = async ({ instance: instance })=>{
    let r = undefined;
    const SUCCESS_CODE = 200;
    if (!!instance && !instance.ready) {
        r = await instance.request({
            method: "tron_requestAccounts"
        });
        if (!r) throw new Error("Please unlock your TronLink extension first.");
        if (r?.code !== SUCCESS_CODE && !!r.message) throw new Error(r.message);
    }
    const address = instance.tronWeb.defaultAddress.base58;
    // TODO check connected network
    return {
        accounts: address ? [
            address
        ] : [],
        chainId: (0, $8aS14.LegacyNetworks).TRON
    };
};
const $ff5727fa66478b70$export$ec068583843480e7 = ({ updateAccounts: updateAccounts, disconnect: disconnect })=>{
    window.addEventListener("message", (e)=>{
        if (e.data.isTronLink && e.data.message && e.data.message.action == "accountsChanged") {
            const account = e?.data?.message?.data?.address;
            if (account) updateAccounts([
                account
            ]);
            else disconnect();
        }
    });
};
const $ff5727fa66478b70$export$3b3cf9ab9019de20 = ()=>false;
const $ff5727fa66478b70$export$6352a17a50193ded = (0, $4ebc5f1bd2a50cfd$export$2e2bcd8739ae039);
const $ff5727fa66478b70$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const tron = (0, $21GQj.tronBlockchain)(allBlockChains);
    return {
        name: "TronLink",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tronlink/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            BRAVE: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            DEFAULT: "https://www.tronlink.org"
        },
        color: "#96e7ed",
        supportedChains: tron
    };
};


var $4023609387b7799f$exports = {};

$parcel$export($4023609387b7799f$exports, "config", function () { return $4023609387b7799f$export$e506a1d27d1eaa20; });
$parcel$export($4023609387b7799f$exports, "getInstance", function () { return $4023609387b7799f$export$8bedcca5bbd73999; });
$parcel$export($4023609387b7799f$exports, "connect", function () { return $4023609387b7799f$export$64605811ab45167f; });
$parcel$export($4023609387b7799f$exports, "subscribe", function () { return $4023609387b7799f$export$ec068583843480e7; });
$parcel$export($4023609387b7799f$exports, "switchNetwork", function () { return $4023609387b7799f$export$f3473d805e486329; });
$parcel$export($4023609387b7799f$exports, "canSwitchNetworkTo", function () { return $4023609387b7799f$export$3b3cf9ab9019de20; });
$parcel$export($4023609387b7799f$exports, "getSigners", function () { return $4023609387b7799f$export$6352a17a50193ded; });
$parcel$export($4023609387b7799f$exports, "canEagerConnect", function () { return $4023609387b7799f$export$be9f3c5ed1d25e42; });
$parcel$export($4023609387b7799f$exports, "getWalletInfo", function () { return $4023609387b7799f$export$e5b9d96c6aeb3ff7; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");
function $eaf0ca5fb05f201a$export$9c52be32606cd1e4() {
    const { trustwallet: trustwallet } = window;
    if (!!trustwallet && (trustwallet?.isTrust || trustwallet?.isTrustWallet)) return trustwallet;
    return null;
}


parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");

async function $4ce7683f8ff4c565$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    return signers;
}


const $4023609387b7799f$var$WALLET = (0, $yEwlv.WalletTypes).TRUST_WALLET;
const $4023609387b7799f$export$e506a1d27d1eaa20 = {
    type: $4023609387b7799f$var$WALLET
};
const $4023609387b7799f$export$8bedcca5bbd73999 = (0, $eaf0ca5fb05f201a$export$9c52be32606cd1e4);
const $4023609387b7799f$export$64605811ab45167f = async ({ instance: instance })=>{
    const { accounts: accounts, chainId: chainId } = await (0, $bHRZL.getEvmAccounts)(instance);
    return {
        accounts: accounts,
        chainId: chainId
    };
};
const $4023609387b7799f$export$ec068583843480e7 = (0, $bHRZL.subscribeToEvm);
const $4023609387b7799f$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $4023609387b7799f$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $4023609387b7799f$export$6352a17a50193ded = (0, $4ce7683f8ff4c565$export$2e2bcd8739ae039);
const $4023609387b7799f$export$be9f3c5ed1d25e42 = (0, $bHRZL.canEagerlyConnectToEvm);
const $4023609387b7799f$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "Trust Wallet",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/trustwallet/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph",
            BRAVE: "https://chrome.google.com/webstore/detail/trust-wallet/egjidjbpglichdcondbcbdnbeeppgdph",
            DEFAULT: "https://trustwallet.com/browser-extension"
        },
        color: "#ffffff",
        supportedChains: evms
    };
};


var $6ef47812c6c4098a$exports = {};

$parcel$export($6ef47812c6c4098a$exports, "init", function () { return $6ef47812c6c4098a$export$2cd8252107eb640b; });
$parcel$export($6ef47812c6c4098a$exports, "config", function () { return $6ef47812c6c4098a$export$e506a1d27d1eaa20; });
$parcel$export($6ef47812c6c4098a$exports, "getInstance", function () { return $6ef47812c6c4098a$export$8bedcca5bbd73999; });
$parcel$export($6ef47812c6c4098a$exports, "connect", function () { return $6ef47812c6c4098a$export$64605811ab45167f; });
$parcel$export($6ef47812c6c4098a$exports, "subscribe", function () { return $6ef47812c6c4098a$export$ec068583843480e7; });
$parcel$export($6ef47812c6c4098a$exports, "switchNetwork", function () { return $6ef47812c6c4098a$export$f3473d805e486329; });
$parcel$export($6ef47812c6c4098a$exports, "canSwitchNetworkTo", function () { return $6ef47812c6c4098a$export$3b3cf9ab9019de20; });
$parcel$export($6ef47812c6c4098a$exports, "disconnect", function () { return $6ef47812c6c4098a$export$37dfea93db2e14ed; });
$parcel$export($6ef47812c6c4098a$exports, "getSigners", function () { return $6ef47812c6c4098a$export$6352a17a50193ded; });
$parcel$export($6ef47812c6c4098a$exports, "getWalletInfo", function () { return $6ef47812c6c4098a$export$e5b9d96c6aeb3ff7; });

parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $yEwlv = parcelRequire("yEwlv");

var $dG33B = parcelRequire("dG33B");
const $b5fcaa4b15516e76$var$suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const $b5fcaa4b15516e76$var$suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const $b5fcaa4b15516e76$var$JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function $b5fcaa4b15516e76$var$jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        $b5fcaa4b15516e76$var$warnKeyDropped(key);
        return;
    }
    return value;
}
function $b5fcaa4b15516e76$var$warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function $b5fcaa4b15516e76$export$2e2bcd8739ae039(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.at(-1) === '"' && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!$b5fcaa4b15516e76$var$JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if ($b5fcaa4b15516e76$var$suspectProtoRx.test(value) || $b5fcaa4b15516e76$var$suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, $b5fcaa4b15516e76$var$jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function $b5fcaa4b15516e76$export$4b2a7c187ff4b28c(value, options = {}) {
    return $b5fcaa4b15516e76$export$2e2bcd8739ae039(value, {
        ...options,
        strict: true
    });
}



var $3aNd6 = parcelRequire("3aNd6");
var $c324036465c1d4a9$require$Buffer = $3aNd6.Buffer;
function $c324036465c1d4a9$var$wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function $c324036465c1d4a9$export$8b22cf2602fb60ce(function_, ...arguments_) {
    try {
        return $c324036465c1d4a9$var$wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function $c324036465c1d4a9$var$isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function $c324036465c1d4a9$var$isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function $c324036465c1d4a9$export$2408f22a0fab9ae5(value) {
    if ($c324036465c1d4a9$var$isPrimitive(value)) return String(value);
    if ($c324036465c1d4a9$var$isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return $c324036465c1d4a9$export$2408f22a0fab9ae5(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function $c324036465c1d4a9$var$checkBufferSupport() {}
const $c324036465c1d4a9$var$BASE64_PREFIX = "base64:";
function $c324036465c1d4a9$export$db3b6bfb95261072(value) {
    if (typeof value === "string") return value;
    $c324036465c1d4a9$var$checkBufferSupport();
    const base64 = $c324036465c1d4a9$require$Buffer.from(value).toString("base64");
    return $c324036465c1d4a9$var$BASE64_PREFIX + base64;
}
function $c324036465c1d4a9$export$4368d992c4eafac0(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith($c324036465c1d4a9$var$BASE64_PREFIX)) return value;
    $c324036465c1d4a9$var$checkBufferSupport();
    return $c324036465c1d4a9$require$Buffer.from(value.slice($c324036465c1d4a9$var$BASE64_PREFIX.length), "base64");
}
const $c324036465c1d4a9$var$storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function $c324036465c1d4a9$export$ffb5f4729a158638(storage, base) {
    base = $c324036465c1d4a9$export$7ccc53e8f1e7dfc5(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of $c324036465c1d4a9$var$storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function $c324036465c1d4a9$export$407448d2b89b1813(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function $c324036465c1d4a9$export$35e795649ee09318(...keys) {
    return $c324036465c1d4a9$export$407448d2b89b1813(keys.join(":"));
}
function $c324036465c1d4a9$export$7ccc53e8f1e7dfc5(base) {
    base = $c324036465c1d4a9$export$407448d2b89b1813(base);
    return base ? base + ":" : "";
}


function $dc73baafa18b1fbb$export$b5cf55d52d4cddb(factory) {
    return factory;
}
const $dc73baafa18b1fbb$var$DRIVER_NAME = "memory";
const $dc73baafa18b1fbb$var$memory = $dc73baafa18b1fbb$export$b5cf55d52d4cddb(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: $dc73baafa18b1fbb$var$DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function $dc73baafa18b1fbb$export$d184a47a971dd4b9(options = {}) {
    const context = {
        mounts: {
            "": options.driver || $dc73baafa18b1fbb$var$memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base: base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint: mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await $dc73baafa18b1fbb$var$watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key: key,
                value: value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $b5fcaa4b15516e76$export$2e2bcd8739ae039)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, $c324036465c1d4a9$export$35e795649ee09318)(batch.base, item.key),
                            value: (0, $b5fcaa4b15516e76$export$2e2bcd8739ae039)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, $b5fcaa4b15516e76$export$2e2bcd8739ae039)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.getItemRaw) return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.getItemRaw, relativeKey, opts);
            return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.getItem, relativeKey, opts).then((value)=>(0, $c324036465c1d4a9$export$4368d992c4eafac0)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $c324036465c1d4a9$export$2408f22a0fab9ae5)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, $c324036465c1d4a9$export$2408f22a0fab9ae5)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(batch.driver.setItem, item.relativeKey, (0, $c324036465c1d4a9$export$2408f22a0fab9ae5)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (driver.setItemRaw) await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.setItem, relativeKey, (0, $c324036465c1d4a9$export$db3b6bfb95261072)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key);
            const { relativeKey: relativeKey, driver: driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, $b5fcaa4b15516e76$export$2e2bcd8739ae039)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, $c324036465c1d4a9$export$407448d2b89b1813)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>$dc73baafa18b1fbb$var$dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve($dc73baafa18b1fbb$var$watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await $dc73baafa18b1fbb$var$dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, $c324036465c1d4a9$export$407448d2b89b1813)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, $c324036465c1d4a9$export$407448d2b89b1813)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function $dc73baafa18b1fbb$export$b8801ea43165ed7d(storage, base) {
    base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function $dc73baafa18b1fbb$export$11e5d4541284dd1e(driver, snapshot2, base = "") {
    base = (0, $c324036465c1d4a9$export$7ccc53e8f1e7dfc5)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function $dc73baafa18b1fbb$var$watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function $dc73baafa18b1fbb$var$dispose(driver) {
    if (typeof driver.dispose === "function") await (0, $c324036465c1d4a9$export$8b22cf2602fb60ce)(driver.dispose);
}
const $dc73baafa18b1fbb$export$108bed33247a8bd7 = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};


function $1e450fbc83dd2601$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $1e450fbc83dd2601$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $1e450fbc83dd2601$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $1e450fbc83dd2601$var$defaultGetStoreFunc;
function $1e450fbc83dd2601$var$defaultGetStore() {
    if (!$1e450fbc83dd2601$var$defaultGetStoreFunc) $1e450fbc83dd2601$var$defaultGetStoreFunc = $1e450fbc83dd2601$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $1e450fbc83dd2601$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$3988ae62b71be9a3(key, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readonly", (store)=>$1e450fbc83dd2601$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$adaa4cf7ef1b65be(key, value, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.put(value, key);
        return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$daa0a5170277c7a8(entries, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$5df405cccea42673(keys, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readonly", (store)=>Promise.all(keys.map((key)=>$1e450fbc83dd2601$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$722fbec263ad908a(key, updater, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($1e450fbc83dd2601$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$1d2f21e549771e67(key, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.delete(key);
        return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$c8aa84257229cac8(keys, customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$42ffd38884aecdac(customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readwrite", (store)=>{
        store.clear();
        return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
    });
}
function $1e450fbc83dd2601$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $1e450fbc83dd2601$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$ed97f33186d4b816(customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $1e450fbc83dd2601$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $1e450fbc83dd2601$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$68c286be0e7e55b7(customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $1e450fbc83dd2601$export$b327150396135fe7(store.getAll());
        const items = [];
        return $1e450fbc83dd2601$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $1e450fbc83dd2601$export$3e9f948b41964866(customStore = $1e450fbc83dd2601$var$defaultGetStore()) {
    return customStore("readonly", (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $1e450fbc83dd2601$export$b327150396135fe7(store.getAllKeys()),
            $1e450fbc83dd2601$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore("readonly", (store)=>$1e450fbc83dd2601$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}


const $88b153d3a15ebfc6$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $88b153d3a15ebfc6$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $88b153d3a15ebfc6$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $88b153d3a15ebfc6$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $88b153d3a15ebfc6$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $88b153d3a15ebfc6$var$JSONStringify(value) || "";
}


function $b76ca8702ff105ae$var$C(i) {
    return i;
}
const $b76ca8702ff105ae$var$x = "idb-keyval";
var $b76ca8702ff105ae$var$z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, $1e450fbc83dd2601$export$f51a9068ac82ea43)(i.dbName, i.storeName)), {
        name: $b76ca8702ff105ae$var$x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, $1e450fbc83dd2601$export$3988ae62b71be9a3)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, $1e450fbc83dd2601$export$3988ae62b71be9a3)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, $1e450fbc83dd2601$export$adaa4cf7ef1b65be)(e(s), a, n);
        },
        removeItem (s) {
            return (0, $1e450fbc83dd2601$export$1d2f21e549771e67)(e(s), n);
        },
        getKeys () {
            return (0, $1e450fbc83dd2601$export$ed97f33186d4b816)(n);
        },
        clear () {
            return (0, $1e450fbc83dd2601$export$42ffd38884aecdac)(n);
        }
    };
};
const $b76ca8702ff105ae$var$D = "WALLET_CONNECT_V2_INDEXED_DB", $b76ca8702ff105ae$var$E = "keyvaluestorage";
class $b76ca8702ff105ae$var$_ {
    constructor(){
        this.indexedDb = (0, $dc73baafa18b1fbb$export$d184a47a971dd4b9)({
            driver: $b76ca8702ff105ae$var$z({
                dbName: $b76ca8702ff105ae$var$D,
                storeName: $b76ca8702ff105ae$var$E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, $88b153d3a15ebfc6$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var $b76ca8702ff105ae$var$l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $b76ca8702ff105ae$var$c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof $b76ca8702ff105ae$var$l < "u" && $b76ca8702ff105ae$var$l.localStorage ? $b76ca8702ff105ae$var$c.exports = $b76ca8702ff105ae$var$l.localStorage : typeof window < "u" && window.localStorage ? $b76ca8702ff105ae$var$c.exports = window.localStorage : $b76ca8702ff105ae$var$c.exports = new t;
})();
function $b76ca8702ff105ae$var$k(i) {
    var t;
    return [
        i[0],
        (0, $88b153d3a15ebfc6$export$84137bb44359aed5)((t = i[1]) != null ? t : "")
    ];
}
class $b76ca8702ff105ae$var$K {
    constructor(){
        this.localStorage = $b76ca8702ff105ae$var$c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map($b76ca8702ff105ae$var$k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, $88b153d3a15ebfc6$export$84137bb44359aed5)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, $88b153d3a15ebfc6$export$abc3f407e87918a4)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const $b76ca8702ff105ae$var$N = "wc_storage_version", $b76ca8702ff105ae$var$y = 1, $b76ca8702ff105ae$var$O = async (i, t, e)=>{
    const n = $b76ca8702ff105ae$var$N, s = await t.getItem(n);
    if (s && s >= $b76ca8702ff105ae$var$y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, $b76ca8702ff105ae$var$y), e(t), $b76ca8702ff105ae$var$j(i, m);
}, $b76ca8702ff105ae$var$j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class $b76ca8702ff105ae$export$8536778e426ddf92 {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new $b76ca8702ff105ae$var$K;
        this.storage = t;
        try {
            const e = new $b76ca8702ff105ae$var$_;
            $b76ca8702ff105ae$var$O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}


var $75808f0aedbf25ac$exports = {};
"use strict";
Object.defineProperty($75808f0aedbf25ac$exports, "__esModule", {
    value: true
});

var $1WATb = parcelRequire("1WATb");

$1WATb.__exportStar((parcelRequire("6sf4n")), $75808f0aedbf25ac$exports);

$1WATb.__exportStar((parcelRequire("a8KUy")), $75808f0aedbf25ac$exports);

$1WATb.__exportStar((parcelRequire("lJxs2")), $75808f0aedbf25ac$exports);


var $4c75a16aead80288$exports = {};
"use strict";
Object.defineProperty($4c75a16aead80288$exports, "__esModule", {
    value: true
});
$4c75a16aead80288$exports.pino = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e3f8dcf0dabcb526$var$extendStatics = function(d, b) {
    $e3f8dcf0dabcb526$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e3f8dcf0dabcb526$var$extendStatics(d, b);
};
function $e3f8dcf0dabcb526$export$a8ba968b8961cb8a(d, b) {
    $e3f8dcf0dabcb526$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e3f8dcf0dabcb526$export$18ce0697a983be9b = function() {
    $e3f8dcf0dabcb526$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e3f8dcf0dabcb526$export$18ce0697a983be9b.apply(this, arguments);
};
function $e3f8dcf0dabcb526$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e3f8dcf0dabcb526$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e3f8dcf0dabcb526$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e3f8dcf0dabcb526$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e3f8dcf0dabcb526$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e3f8dcf0dabcb526$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e3f8dcf0dabcb526$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e3f8dcf0dabcb526$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e3f8dcf0dabcb526$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e3f8dcf0dabcb526$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e3f8dcf0dabcb526$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e3f8dcf0dabcb526$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e3f8dcf0dabcb526$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e3f8dcf0dabcb526$export$10c90e4f7922046c(v) {
    return this instanceof $e3f8dcf0dabcb526$export$10c90e4f7922046c ? (this.v = v, this) : new $e3f8dcf0dabcb526$export$10c90e4f7922046c(v);
}
function $e3f8dcf0dabcb526$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e3f8dcf0dabcb526$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e3f8dcf0dabcb526$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e3f8dcf0dabcb526$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e3f8dcf0dabcb526$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e3f8dcf0dabcb526$export$19a8beecd37a4c45 === "function" ? $e3f8dcf0dabcb526$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e3f8dcf0dabcb526$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e3f8dcf0dabcb526$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e3f8dcf0dabcb526$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e3f8dcf0dabcb526$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e3f8dcf0dabcb526$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



const $4c75a16aead80288$var$pino_1 = $e3f8dcf0dabcb526$export$da59b14a69baef04((parcelRequire("2gtzz")));
Object.defineProperty($4c75a16aead80288$exports, "pino", {
    enumerable: true,
    get: function() {
        return $4c75a16aead80288$var$pino_1.default;
    }
});

$e3f8dcf0dabcb526$export$f33643c0debef087((parcelRequire("dlIIs")), $4c75a16aead80288$exports);

$e3f8dcf0dabcb526$export$f33643c0debef087((parcelRequire("dQeds")), $4c75a16aead80288$exports);


parcelRequire("d55yj");
var $1lOcn = parcelRequire("1lOcn");

var $dG33B = parcelRequire("dG33B");
class $8d964f47298418e8$export$ed533416df113881 extends (0, $1lOcn.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $8d964f47298418e8$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$45b2c2643615b67 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $8d964f47298418e8$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $8d964f47298418e8$export$3b0872bbd7e675a2 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$9a0f755fd4f79434 extends (0, $1lOcn.IEvents) {
    constructor(s){
        super();
    }
}
class $8d964f47298418e8$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $8d964f47298418e8$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $8d964f47298418e8$export$300eed987e764b57 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$41aaa3c39f6f2861 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $8d964f47298418e8$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $8d964f47298418e8$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(){
        super();
    }
}
class $8d964f47298418e8$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $8d964f47298418e8$export$623dd0f793f15643 extends (0, $dG33B.EventEmitter) {
    constructor(){
        super();
    }
}
class $8d964f47298418e8$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}



var $67e1c27d88bb1cf4$exports = {};
$parcel$export($67e1c27d88bb1cf4$exports, "generateKeyPair", function () { return $bf3d2d04ac30a374$export$a949d36eab55b41f; });
$parcel$export($67e1c27d88bb1cf4$exports, "signJWT", function () { return $bf3d2d04ac30a374$export$a8dda30659d36d45; });
$parcel$export($67e1c27d88bb1cf4$exports, "encodeIss", function () { return $b19a768c56f4badd$export$1b29ef9371459e10; });
var $212512bcb5557ed8$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($212512bcb5557ed8$exports, "__esModule", {
    value: true
});
$212512bcb5557ed8$exports.convertSecretKeyToX25519 = $212512bcb5557ed8$exports.convertPublicKeyToX25519 = $212512bcb5557ed8$exports.verify = $212512bcb5557ed8$exports.sign = $212512bcb5557ed8$exports.extractPublicKeyFromSecretKey = $212512bcb5557ed8$exports.generateKeyPair = $212512bcb5557ed8$exports.generateKeyPairFromSeed = $212512bcb5557ed8$exports.SEED_LENGTH = $212512bcb5557ed8$exports.SECRET_KEY_LENGTH = $212512bcb5557ed8$exports.PUBLIC_KEY_LENGTH = $212512bcb5557ed8$exports.SIGNATURE_LENGTH = void 0;
var $e8d7d54636de94dc$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($e8d7d54636de94dc$exports, "__esModule", {
    value: true
});
$e8d7d54636de94dc$exports.randomStringForEntropy = $e8d7d54636de94dc$exports.randomString = $e8d7d54636de94dc$exports.randomUint32 = $e8d7d54636de94dc$exports.randomBytes = $e8d7d54636de94dc$exports.defaultRandomSource = void 0;
var $2bf78e455641c467$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($2bf78e455641c467$exports, "__esModule", {
    value: true
});
$2bf78e455641c467$exports.SystemRandomSource = void 0;
var $c5d87d211c278313$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c5d87d211c278313$exports, "__esModule", {
    value: true
});
$c5d87d211c278313$exports.BrowserRandomSource = void 0;
const $c5d87d211c278313$var$QUOTA = 65536;
class $c5d87d211c278313$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $c5d87d211c278313$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $c5d87d211c278313$var$QUOTA)));
        return out;
    }
}
$c5d87d211c278313$exports.BrowserRandomSource = $c5d87d211c278313$var$BrowserRandomSource;


var $30490eec905e7169$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($30490eec905e7169$exports, "__esModule", {
    value: true
});
$30490eec905e7169$exports.NodeRandomSource = void 0;
var $f23ef81b68a41b51$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($f23ef81b68a41b51$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $f23ef81b68a41b51$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$f23ef81b68a41b51$exports.wipe = $f23ef81b68a41b51$var$wipe;



class $30490eec905e7169$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("1wVs5"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $f23ef81b68a41b51$exports.wipe)(buffer);
        return out;
    }
}
$30490eec905e7169$exports.NodeRandomSource = $30490eec905e7169$var$NodeRandomSource;


class $2bf78e455641c467$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $c5d87d211c278313$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $30490eec905e7169$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$2bf78e455641c467$exports.SystemRandomSource = $2bf78e455641c467$var$SystemRandomSource;


var $844dc299b00b17a1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($844dc299b00b17a1$exports, "__esModule", {
    value: true
});
var $99ada1f32205824c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($99ada1f32205824c$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $99ada1f32205824c$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$99ada1f32205824c$exports.mul = Math.imul || $99ada1f32205824c$var$imulShim;
/** 32-bit integer addition.  */ function $99ada1f32205824c$var$add(a, b) {
    return a + b | 0;
}
$99ada1f32205824c$exports.add = $99ada1f32205824c$var$add;
/**  32-bit integer subtraction.  */ function $99ada1f32205824c$var$sub(a, b) {
    return a - b | 0;
}
$99ada1f32205824c$exports.sub = $99ada1f32205824c$var$sub;
/** 32-bit integer left rotation */ function $99ada1f32205824c$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$99ada1f32205824c$exports.rotl = $99ada1f32205824c$var$rotl;
/** 32-bit integer left rotation */ function $99ada1f32205824c$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$99ada1f32205824c$exports.rotr = $99ada1f32205824c$var$rotr;
function $99ada1f32205824c$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $99ada1f32205824c$exports.isInteger = Number.isInteger || $99ada1f32205824c$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $99ada1f32205824c$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $99ada1f32205824c$exports.isSafeInteger = function(n) {
    return $99ada1f32205824c$exports.isInteger(n) && n >= -$99ada1f32205824c$exports.MAX_SAFE_INTEGER && n <= $99ada1f32205824c$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$844dc299b00b17a1$exports.readInt16BE = $844dc299b00b17a1$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$844dc299b00b17a1$exports.readUint16BE = $844dc299b00b17a1$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$844dc299b00b17a1$exports.readInt16LE = $844dc299b00b17a1$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$844dc299b00b17a1$exports.readUint16LE = $844dc299b00b17a1$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$844dc299b00b17a1$exports.writeUint16BE = $844dc299b00b17a1$var$writeUint16BE;
$844dc299b00b17a1$exports.writeInt16BE = $844dc299b00b17a1$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$844dc299b00b17a1$exports.writeUint16LE = $844dc299b00b17a1$var$writeUint16LE;
$844dc299b00b17a1$exports.writeInt16LE = $844dc299b00b17a1$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$844dc299b00b17a1$exports.readInt32BE = $844dc299b00b17a1$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$844dc299b00b17a1$exports.readUint32BE = $844dc299b00b17a1$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$844dc299b00b17a1$exports.readInt32LE = $844dc299b00b17a1$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $844dc299b00b17a1$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$844dc299b00b17a1$exports.readUint32LE = $844dc299b00b17a1$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$844dc299b00b17a1$exports.writeUint32BE = $844dc299b00b17a1$var$writeUint32BE;
$844dc299b00b17a1$exports.writeInt32BE = $844dc299b00b17a1$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$844dc299b00b17a1$exports.writeUint32LE = $844dc299b00b17a1$var$writeUint32LE;
$844dc299b00b17a1$exports.writeInt32LE = $844dc299b00b17a1$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $844dc299b00b17a1$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $844dc299b00b17a1$var$readInt32BE(array, offset);
    var lo = $844dc299b00b17a1$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$844dc299b00b17a1$exports.readInt64BE = $844dc299b00b17a1$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $844dc299b00b17a1$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $844dc299b00b17a1$var$readUint32BE(array, offset);
    var lo = $844dc299b00b17a1$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$844dc299b00b17a1$exports.readUint64BE = $844dc299b00b17a1$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $844dc299b00b17a1$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $844dc299b00b17a1$var$readInt32LE(array, offset);
    var hi = $844dc299b00b17a1$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$844dc299b00b17a1$exports.readInt64LE = $844dc299b00b17a1$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $844dc299b00b17a1$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $844dc299b00b17a1$var$readUint32LE(array, offset);
    var hi = $844dc299b00b17a1$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$844dc299b00b17a1$exports.readUint64LE = $844dc299b00b17a1$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $844dc299b00b17a1$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $844dc299b00b17a1$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$844dc299b00b17a1$exports.writeUint64BE = $844dc299b00b17a1$var$writeUint64BE;
$844dc299b00b17a1$exports.writeInt64BE = $844dc299b00b17a1$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $844dc299b00b17a1$var$writeUint32LE(value >>> 0, out, offset);
    $844dc299b00b17a1$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$844dc299b00b17a1$exports.writeUint64LE = $844dc299b00b17a1$var$writeUint64LE;
$844dc299b00b17a1$exports.writeInt64LE = $844dc299b00b17a1$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $844dc299b00b17a1$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$844dc299b00b17a1$exports.readUintBE = $844dc299b00b17a1$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $844dc299b00b17a1$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$844dc299b00b17a1$exports.readUintLE = $844dc299b00b17a1$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$99ada1f32205824c$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$844dc299b00b17a1$exports.writeUintBE = $844dc299b00b17a1$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$99ada1f32205824c$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$844dc299b00b17a1$exports.writeUintLE = $844dc299b00b17a1$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $844dc299b00b17a1$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$844dc299b00b17a1$exports.readFloat32BE = $844dc299b00b17a1$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $844dc299b00b17a1$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$844dc299b00b17a1$exports.readFloat32LE = $844dc299b00b17a1$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $844dc299b00b17a1$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$844dc299b00b17a1$exports.readFloat64BE = $844dc299b00b17a1$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $844dc299b00b17a1$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$844dc299b00b17a1$exports.readFloat64LE = $844dc299b00b17a1$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$844dc299b00b17a1$exports.writeFloat32BE = $844dc299b00b17a1$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$844dc299b00b17a1$exports.writeFloat32LE = $844dc299b00b17a1$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$844dc299b00b17a1$exports.writeFloat64BE = $844dc299b00b17a1$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $844dc299b00b17a1$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$844dc299b00b17a1$exports.writeFloat64LE = $844dc299b00b17a1$var$writeFloat64LE;



$e8d7d54636de94dc$exports.defaultRandomSource = new $2bf78e455641c467$exports.SystemRandomSource();
function $e8d7d54636de94dc$var$randomBytes(length, prng = $e8d7d54636de94dc$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$e8d7d54636de94dc$exports.randomBytes = $e8d7d54636de94dc$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $e8d7d54636de94dc$var$randomUint32(prng = $e8d7d54636de94dc$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $e8d7d54636de94dc$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $844dc299b00b17a1$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $f23ef81b68a41b51$exports.wipe)(buf);
    return result;
}
$e8d7d54636de94dc$exports.randomUint32 = $e8d7d54636de94dc$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $e8d7d54636de94dc$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $e8d7d54636de94dc$var$randomString(length, charset = $e8d7d54636de94dc$var$ALPHANUMERIC, prng = $e8d7d54636de94dc$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $e8d7d54636de94dc$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $f23ef81b68a41b51$exports.wipe)(buf);
    }
    return out;
}
$e8d7d54636de94dc$exports.randomString = $e8d7d54636de94dc$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $e8d7d54636de94dc$var$randomStringForEntropy(bits, charset = $e8d7d54636de94dc$var$ALPHANUMERIC, prng = $e8d7d54636de94dc$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $e8d7d54636de94dc$var$randomString(length, charset, prng);
}
$e8d7d54636de94dc$exports.randomStringForEntropy = $e8d7d54636de94dc$var$randomStringForEntropy;


var $ab0aacbd32eec5a1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ab0aacbd32eec5a1$exports, "__esModule", {
    value: true
});


$ab0aacbd32eec5a1$exports.DIGEST_LENGTH = 64;
$ab0aacbd32eec5a1$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $ab0aacbd32eec5a1$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $ab0aacbd32eec5a1$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $ab0aacbd32eec5a1$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $f23ef81b68a41b51$exports.wipe(this._buffer);
        $f23ef81b68a41b51$exports.wipe(this._tempHi);
        $f23ef81b68a41b51$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $ab0aacbd32eec5a1$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $ab0aacbd32eec5a1$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $ab0aacbd32eec5a1$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $844dc299b00b17a1$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $844dc299b00b17a1$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $ab0aacbd32eec5a1$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $844dc299b00b17a1$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $844dc299b00b17a1$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $f23ef81b68a41b51$exports.wipe(savedState.stateHi);
        $f23ef81b68a41b51$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $f23ef81b68a41b51$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$ab0aacbd32eec5a1$exports.SHA512 = $ab0aacbd32eec5a1$var$SHA512;
// Constants
var $ab0aacbd32eec5a1$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $ab0aacbd32eec5a1$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $844dc299b00b17a1$exports.readUint32BE(m, j);
            wl[i] = $844dc299b00b17a1$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $ab0aacbd32eec5a1$var$K[i * 2];
            l = $ab0aacbd32eec5a1$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $ab0aacbd32eec5a1$var$hash(data) {
    var h = new $ab0aacbd32eec5a1$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$ab0aacbd32eec5a1$exports.hash = $ab0aacbd32eec5a1$var$hash;



$212512bcb5557ed8$exports.SIGNATURE_LENGTH = 64;
$212512bcb5557ed8$exports.PUBLIC_KEY_LENGTH = 32;
$212512bcb5557ed8$exports.SECRET_KEY_LENGTH = 64;
$212512bcb5557ed8$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $212512bcb5557ed8$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $212512bcb5557ed8$var$_9 = new Uint8Array(32);
$212512bcb5557ed8$var$_9[0] = 9;
const $212512bcb5557ed8$var$gf0 = $212512bcb5557ed8$var$gf();
const $212512bcb5557ed8$var$gf1 = $212512bcb5557ed8$var$gf([
    1
]);
const $212512bcb5557ed8$var$D = $212512bcb5557ed8$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $212512bcb5557ed8$var$D2 = $212512bcb5557ed8$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $212512bcb5557ed8$var$X = $212512bcb5557ed8$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $212512bcb5557ed8$var$Y = $212512bcb5557ed8$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $212512bcb5557ed8$var$I = $212512bcb5557ed8$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $212512bcb5557ed8$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $212512bcb5557ed8$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $212512bcb5557ed8$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $212512bcb5557ed8$var$pack25519(o, n) {
    const m = $212512bcb5557ed8$var$gf();
    const t = $212512bcb5557ed8$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $212512bcb5557ed8$var$car25519(t);
    $212512bcb5557ed8$var$car25519(t);
    $212512bcb5557ed8$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $212512bcb5557ed8$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $212512bcb5557ed8$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $212512bcb5557ed8$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $212512bcb5557ed8$var$pack25519(c, a);
    $212512bcb5557ed8$var$pack25519(d, b);
    return $212512bcb5557ed8$var$verify32(c, d);
}
function $212512bcb5557ed8$var$par25519(a) {
    const d = new Uint8Array(32);
    $212512bcb5557ed8$var$pack25519(d, a);
    return d[0] & 1;
}
function $212512bcb5557ed8$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $212512bcb5557ed8$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $212512bcb5557ed8$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $212512bcb5557ed8$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $212512bcb5557ed8$var$square(o, a) {
    $212512bcb5557ed8$var$mul(o, a, a);
}
function $212512bcb5557ed8$var$inv25519(o, i) {
    const c = $212512bcb5557ed8$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $212512bcb5557ed8$var$square(c, c);
        if (a !== 2 && a !== 4) $212512bcb5557ed8$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $212512bcb5557ed8$var$pow2523(o, i) {
    const c = $212512bcb5557ed8$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $212512bcb5557ed8$var$square(c, c);
        if (a !== 1) $212512bcb5557ed8$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $212512bcb5557ed8$var$edadd(p, q) {
    const a = $212512bcb5557ed8$var$gf(), b = $212512bcb5557ed8$var$gf(), c = $212512bcb5557ed8$var$gf(), d = $212512bcb5557ed8$var$gf(), e = $212512bcb5557ed8$var$gf(), f = $212512bcb5557ed8$var$gf(), g = $212512bcb5557ed8$var$gf(), h = $212512bcb5557ed8$var$gf(), t = $212512bcb5557ed8$var$gf();
    $212512bcb5557ed8$var$sub(a, p[1], p[0]);
    $212512bcb5557ed8$var$sub(t, q[1], q[0]);
    $212512bcb5557ed8$var$mul(a, a, t);
    $212512bcb5557ed8$var$add(b, p[0], p[1]);
    $212512bcb5557ed8$var$add(t, q[0], q[1]);
    $212512bcb5557ed8$var$mul(b, b, t);
    $212512bcb5557ed8$var$mul(c, p[3], q[3]);
    $212512bcb5557ed8$var$mul(c, c, $212512bcb5557ed8$var$D2);
    $212512bcb5557ed8$var$mul(d, p[2], q[2]);
    $212512bcb5557ed8$var$add(d, d, d);
    $212512bcb5557ed8$var$sub(e, b, a);
    $212512bcb5557ed8$var$sub(f, d, c);
    $212512bcb5557ed8$var$add(g, d, c);
    $212512bcb5557ed8$var$add(h, b, a);
    $212512bcb5557ed8$var$mul(p[0], e, f);
    $212512bcb5557ed8$var$mul(p[1], h, g);
    $212512bcb5557ed8$var$mul(p[2], g, f);
    $212512bcb5557ed8$var$mul(p[3], e, h);
}
function $212512bcb5557ed8$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$212512bcb5557ed8$var$sel25519(p[i], q[i], b);
}
function $212512bcb5557ed8$var$pack(r, p) {
    const tx = $212512bcb5557ed8$var$gf(), ty = $212512bcb5557ed8$var$gf(), zi = $212512bcb5557ed8$var$gf();
    $212512bcb5557ed8$var$inv25519(zi, p[2]);
    $212512bcb5557ed8$var$mul(tx, p[0], zi);
    $212512bcb5557ed8$var$mul(ty, p[1], zi);
    $212512bcb5557ed8$var$pack25519(r, ty);
    r[31] ^= $212512bcb5557ed8$var$par25519(tx) << 7;
}
function $212512bcb5557ed8$var$scalarmult(p, q, s) {
    $212512bcb5557ed8$var$set25519(p[0], $212512bcb5557ed8$var$gf0);
    $212512bcb5557ed8$var$set25519(p[1], $212512bcb5557ed8$var$gf1);
    $212512bcb5557ed8$var$set25519(p[2], $212512bcb5557ed8$var$gf1);
    $212512bcb5557ed8$var$set25519(p[3], $212512bcb5557ed8$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $212512bcb5557ed8$var$cswap(p, q, b);
        $212512bcb5557ed8$var$edadd(q, p);
        $212512bcb5557ed8$var$edadd(p, p);
        $212512bcb5557ed8$var$cswap(p, q, b);
    }
}
function $212512bcb5557ed8$var$scalarbase(p, s) {
    const q = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    $212512bcb5557ed8$var$set25519(q[0], $212512bcb5557ed8$var$X);
    $212512bcb5557ed8$var$set25519(q[1], $212512bcb5557ed8$var$Y);
    $212512bcb5557ed8$var$set25519(q[2], $212512bcb5557ed8$var$gf1);
    $212512bcb5557ed8$var$mul(q[3], $212512bcb5557ed8$var$X, $212512bcb5557ed8$var$Y);
    $212512bcb5557ed8$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $212512bcb5557ed8$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $212512bcb5557ed8$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$212512bcb5557ed8$exports.SEED_LENGTH} bytes`);
    const d = (0, $ab0aacbd32eec5a1$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    $212512bcb5557ed8$var$scalarbase(p, d);
    $212512bcb5557ed8$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$212512bcb5557ed8$exports.generateKeyPairFromSeed = $212512bcb5557ed8$var$generateKeyPairFromSeed;
function $212512bcb5557ed8$var$generateKeyPair(prng) {
    const seed = (0, $e8d7d54636de94dc$exports.randomBytes)(32, prng);
    const result = $212512bcb5557ed8$var$generateKeyPairFromSeed(seed);
    (0, $f23ef81b68a41b51$exports.wipe)(seed);
    return result;
}
$212512bcb5557ed8$exports.generateKeyPair = $212512bcb5557ed8$var$generateKeyPair;
function $212512bcb5557ed8$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $212512bcb5557ed8$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$212512bcb5557ed8$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$212512bcb5557ed8$exports.extractPublicKeyFromSecretKey = $212512bcb5557ed8$var$extractPublicKeyFromSecretKey;
const $212512bcb5557ed8$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $212512bcb5557ed8$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $212512bcb5557ed8$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $212512bcb5557ed8$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $212512bcb5557ed8$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $212512bcb5557ed8$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $212512bcb5557ed8$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $212512bcb5557ed8$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    const d = (0, $ab0aacbd32eec5a1$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $ab0aacbd32eec5a1$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $212512bcb5557ed8$var$reduce(r);
    $212512bcb5557ed8$var$scalarbase(p, r);
    $212512bcb5557ed8$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $212512bcb5557ed8$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $212512bcb5557ed8$var$modL(signature.subarray(32), x);
    return signature;
}
$212512bcb5557ed8$exports.sign = $212512bcb5557ed8$var$sign;
function $212512bcb5557ed8$var$unpackneg(r, p) {
    const t = $212512bcb5557ed8$var$gf(), chk = $212512bcb5557ed8$var$gf(), num = $212512bcb5557ed8$var$gf(), den = $212512bcb5557ed8$var$gf(), den2 = $212512bcb5557ed8$var$gf(), den4 = $212512bcb5557ed8$var$gf(), den6 = $212512bcb5557ed8$var$gf();
    $212512bcb5557ed8$var$set25519(r[2], $212512bcb5557ed8$var$gf1);
    $212512bcb5557ed8$var$unpack25519(r[1], p);
    $212512bcb5557ed8$var$square(num, r[1]);
    $212512bcb5557ed8$var$mul(den, num, $212512bcb5557ed8$var$D);
    $212512bcb5557ed8$var$sub(num, num, r[2]);
    $212512bcb5557ed8$var$add(den, r[2], den);
    $212512bcb5557ed8$var$square(den2, den);
    $212512bcb5557ed8$var$square(den4, den2);
    $212512bcb5557ed8$var$mul(den6, den4, den2);
    $212512bcb5557ed8$var$mul(t, den6, num);
    $212512bcb5557ed8$var$mul(t, t, den);
    $212512bcb5557ed8$var$pow2523(t, t);
    $212512bcb5557ed8$var$mul(t, t, num);
    $212512bcb5557ed8$var$mul(t, t, den);
    $212512bcb5557ed8$var$mul(t, t, den);
    $212512bcb5557ed8$var$mul(r[0], t, den);
    $212512bcb5557ed8$var$square(chk, r[0]);
    $212512bcb5557ed8$var$mul(chk, chk, den);
    if ($212512bcb5557ed8$var$neq25519(chk, num)) $212512bcb5557ed8$var$mul(r[0], r[0], $212512bcb5557ed8$var$I);
    $212512bcb5557ed8$var$square(chk, r[0]);
    $212512bcb5557ed8$var$mul(chk, chk, den);
    if ($212512bcb5557ed8$var$neq25519(chk, num)) return -1;
    if ($212512bcb5557ed8$var$par25519(r[0]) === p[31] >> 7) $212512bcb5557ed8$var$sub(r[0], $212512bcb5557ed8$var$gf0, r[0]);
    $212512bcb5557ed8$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $212512bcb5557ed8$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    const q = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    if (signature.length !== $212512bcb5557ed8$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$212512bcb5557ed8$exports.SIGNATURE_LENGTH} bytes`);
    if ($212512bcb5557ed8$var$unpackneg(q, publicKey)) return false;
    const hs = new $ab0aacbd32eec5a1$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $212512bcb5557ed8$var$reduce(h);
    $212512bcb5557ed8$var$scalarmult(p, q, h);
    $212512bcb5557ed8$var$scalarbase(q, signature.subarray(32));
    $212512bcb5557ed8$var$edadd(p, q);
    $212512bcb5557ed8$var$pack(t, p);
    if ($212512bcb5557ed8$var$verify32(signature, t)) return false;
    return true;
}
$212512bcb5557ed8$exports.verify = $212512bcb5557ed8$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $212512bcb5557ed8$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf(),
        $212512bcb5557ed8$var$gf()
    ];
    if ($212512bcb5557ed8$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $212512bcb5557ed8$var$gf();
    let b = $212512bcb5557ed8$var$gf();
    let y = q[1];
    $212512bcb5557ed8$var$add(a, $212512bcb5557ed8$var$gf1, y);
    $212512bcb5557ed8$var$sub(b, $212512bcb5557ed8$var$gf1, y);
    $212512bcb5557ed8$var$inv25519(b, b);
    $212512bcb5557ed8$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $212512bcb5557ed8$var$pack25519(z, a);
    return z;
}
$212512bcb5557ed8$exports.convertPublicKeyToX25519 = $212512bcb5557ed8$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $212512bcb5557ed8$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $ab0aacbd32eec5a1$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $f23ef81b68a41b51$exports.wipe)(d);
    return o;
}
$212512bcb5557ed8$exports.convertSecretKeyToX25519 = $212512bcb5557ed8$var$convertSecretKeyToX25519;




var $j5HK8 = parcelRequire("j5HK8");
const $3f42b1a526bf7802$export$51745f7832485c34 = "EdDSA";
const $3f42b1a526bf7802$export$f51b45e220f2ba98 = "JWT";
const $3f42b1a526bf7802$export$a3e35a0f952eb3ef = ".";
const $3f42b1a526bf7802$export$d2e6fe38c55f8e23 = "base64url";
const $3f42b1a526bf7802$export$c09c2801e10a2b95 = "utf8";
const $3f42b1a526bf7802$export$1e9219c0b91a4257 = "utf8";
const $3f42b1a526bf7802$export$d4057275de9d060b = ":";
const $3f42b1a526bf7802$export$acf13c61a1a0ccf3 = "did";
const $3f42b1a526bf7802$export$b908fe81ccf30934 = "key";
const $3f42b1a526bf7802$export$7bd18b7a7a4d0471 = "base58btc";
const $3f42b1a526bf7802$export$6d6d3d2e39be8d68 = "z";
const $3f42b1a526bf7802$export$9902a33a5776d1fc = "K36";
const $3f42b1a526bf7802$export$ca477e91394a742a = 32;
const $3f42b1a526bf7802$export$f09ad228919f26fb = 32;


function $de3c5df3ff477878$export$db814d038928c649(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}


function $23d98f49e421cf9a$export$2de70f21292aac9e(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return (0, $de3c5df3ff477878$export$db814d038928c649)(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $23d98f49e421cf9a$export$19833a56117fe205(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return (0, $de3c5df3ff477878$export$db814d038928c649)(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}



function $2a39c00b82d2af1d$export$ee1b3e54f0441b22(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = (0, $23d98f49e421cf9a$export$19833a56117fe205)(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return (0, $de3c5df3ff477878$export$db814d038928c649)(output);
}


var $5cf7ecb3583ae8b2$exports = {};

$parcel$export($5cf7ecb3583ae8b2$exports, "identity", function () { return $5cf7ecb3583ae8b2$export$f0954fd7d5368655; });
function $ddaf5026152c1d4d$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $ddaf5026152c1d4d$var$src = $ddaf5026152c1d4d$var$base;
var $ddaf5026152c1d4d$var$_brrp__multiformats_scope_baseX = $ddaf5026152c1d4d$var$src;
var $ddaf5026152c1d4d$export$2e2bcd8739ae039 = $ddaf5026152c1d4d$var$_brrp__multiformats_scope_baseX;


const $00f8b9fcbe55dbeb$export$6e22c362a0406a2c = new Uint8Array(0);
const $00f8b9fcbe55dbeb$export$7ea66e3774a60b67 = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $00f8b9fcbe55dbeb$export$1a8ceedbd5845648 = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $00f8b9fcbe55dbeb$export$6e22c362a0406a2c;
};
const $00f8b9fcbe55dbeb$export$e9bab7fafb253603 = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $00f8b9fcbe55dbeb$export$8c14e57e778d3873 = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $00f8b9fcbe55dbeb$export$37488ff1135b1696 = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $00f8b9fcbe55dbeb$export$3004f64547af360e = (str)=>new TextEncoder().encode(str);
const $00f8b9fcbe55dbeb$export$f84e8e69fd4488a5 = (b)=>new TextDecoder().decode(b);


class $57cbbb20b90ddb01$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $57cbbb20b90ddb01$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $57cbbb20b90ddb01$export$252bb8b3bbdf6749(this, decoder);
    }
}
class $57cbbb20b90ddb01$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $57cbbb20b90ddb01$export$252bb8b3bbdf6749(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $57cbbb20b90ddb01$export$252bb8b3bbdf6749 = (left, right)=>new $57cbbb20b90ddb01$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $57cbbb20b90ddb01$export$a111e9ced3f1d2d0 {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $57cbbb20b90ddb01$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $57cbbb20b90ddb01$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $57cbbb20b90ddb01$export$6788812c4e6611e6 = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $57cbbb20b90ddb01$export$a111e9ced3f1d2d0(name, prefix, encode, decode);
const $57cbbb20b90ddb01$export$180c73aedea7f385 = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = (0, $ddaf5026152c1d4d$export$2e2bcd8739ae039)(alphabet, name);
    return $57cbbb20b90ddb01$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>(0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873)(decode(text))
    });
};
const $57cbbb20b90ddb01$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $57cbbb20b90ddb01$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $57cbbb20b90ddb01$export$fa9dde04c7d2f31a = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $57cbbb20b90ddb01$export$6788812c4e6611e6({
        prefix: prefix,
        name: name,
        encode (input) {
            return $57cbbb20b90ddb01$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $57cbbb20b90ddb01$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};



const $5cf7ecb3583ae8b2$export$f0954fd7d5368655 = (0, $57cbbb20b90ddb01$export$6788812c4e6611e6)({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>(0, $00f8b9fcbe55dbeb$export$f84e8e69fd4488a5)(buf),
    decode: (str)=>(0, $00f8b9fcbe55dbeb$export$3004f64547af360e)(str)
});


var $a74a12a273d3ff75$exports = {};

$parcel$export($a74a12a273d3ff75$exports, "base2", function () { return $a74a12a273d3ff75$export$ed5f7917e37e31aa; });

const $a74a12a273d3ff75$export$ed5f7917e37e31aa = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});


var $3c9c55dd7a52c8a4$exports = {};

$parcel$export($3c9c55dd7a52c8a4$exports, "base8", function () { return $3c9c55dd7a52c8a4$export$43b580ac9deb5b96; });

const $3c9c55dd7a52c8a4$export$43b580ac9deb5b96 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});


var $0e2fab5b4e019eca$exports = {};

$parcel$export($0e2fab5b4e019eca$exports, "base10", function () { return $0e2fab5b4e019eca$export$63d6a7de0ff813cc; });

const $0e2fab5b4e019eca$export$63d6a7de0ff813cc = (0, $57cbbb20b90ddb01$export$180c73aedea7f385)({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});


var $1f1c29b41550a0c7$exports = {};

$parcel$export($1f1c29b41550a0c7$exports, "base16", function () { return $1f1c29b41550a0c7$export$586f61c71cb02fe4; });
$parcel$export($1f1c29b41550a0c7$exports, "base16upper", function () { return $1f1c29b41550a0c7$export$2d835b8dd4032b62; });

const $1f1c29b41550a0c7$export$586f61c71cb02fe4 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $1f1c29b41550a0c7$export$2d835b8dd4032b62 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});


var $137e79e01e206153$exports = {};

$parcel$export($137e79e01e206153$exports, "base32", function () { return $137e79e01e206153$export$4a4d5965e2738b2a; });
$parcel$export($137e79e01e206153$exports, "base32upper", function () { return $137e79e01e206153$export$fbaa3bbbd754def4; });
$parcel$export($137e79e01e206153$exports, "base32pad", function () { return $137e79e01e206153$export$e194fa100d329365; });
$parcel$export($137e79e01e206153$exports, "base32padupper", function () { return $137e79e01e206153$export$3a9fc48d294dce32; });
$parcel$export($137e79e01e206153$exports, "base32hex", function () { return $137e79e01e206153$export$c57d6760d519c8ac; });
$parcel$export($137e79e01e206153$exports, "base32hexupper", function () { return $137e79e01e206153$export$8cf4640df3165d29; });
$parcel$export($137e79e01e206153$exports, "base32hexpad", function () { return $137e79e01e206153$export$8c6a05c08ec7d456; });
$parcel$export($137e79e01e206153$exports, "base32hexpadupper", function () { return $137e79e01e206153$export$29f73c6a744e639f; });
$parcel$export($137e79e01e206153$exports, "base32z", function () { return $137e79e01e206153$export$fdad9af4bdc05e3; });

const $137e79e01e206153$export$4a4d5965e2738b2a = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $137e79e01e206153$export$fbaa3bbbd754def4 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $137e79e01e206153$export$e194fa100d329365 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $137e79e01e206153$export$3a9fc48d294dce32 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $137e79e01e206153$export$c57d6760d519c8ac = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $137e79e01e206153$export$8cf4640df3165d29 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $137e79e01e206153$export$8c6a05c08ec7d456 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $137e79e01e206153$export$29f73c6a744e639f = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $137e79e01e206153$export$fdad9af4bdc05e3 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});


var $d1db2665698935ce$exports = {};

$parcel$export($d1db2665698935ce$exports, "base36", function () { return $d1db2665698935ce$export$95b61e7c39ae893a; });
$parcel$export($d1db2665698935ce$exports, "base36upper", function () { return $d1db2665698935ce$export$bab7c9bdb963afd; });

const $d1db2665698935ce$export$95b61e7c39ae893a = (0, $57cbbb20b90ddb01$export$180c73aedea7f385)({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $d1db2665698935ce$export$bab7c9bdb963afd = (0, $57cbbb20b90ddb01$export$180c73aedea7f385)({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});


var $d5eb4c3479635bf7$exports = {};

$parcel$export($d5eb4c3479635bf7$exports, "base58btc", function () { return $d5eb4c3479635bf7$export$65c61748a9b98a2c; });
$parcel$export($d5eb4c3479635bf7$exports, "base58flickr", function () { return $d5eb4c3479635bf7$export$c6a7baed2941aad2; });

const $d5eb4c3479635bf7$export$65c61748a9b98a2c = (0, $57cbbb20b90ddb01$export$180c73aedea7f385)({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $d5eb4c3479635bf7$export$c6a7baed2941aad2 = (0, $57cbbb20b90ddb01$export$180c73aedea7f385)({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});


var $b1594e117e20924f$exports = {};

$parcel$export($b1594e117e20924f$exports, "base64", function () { return $b1594e117e20924f$export$b3b2de96497acc47; });
$parcel$export($b1594e117e20924f$exports, "base64pad", function () { return $b1594e117e20924f$export$a9c086fc40b4563c; });
$parcel$export($b1594e117e20924f$exports, "base64url", function () { return $b1594e117e20924f$export$7d21597c7bc64465; });
$parcel$export($b1594e117e20924f$exports, "base64urlpad", function () { return $b1594e117e20924f$export$e87ddc9183aa53c9; });

const $b1594e117e20924f$export$b3b2de96497acc47 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $b1594e117e20924f$export$a9c086fc40b4563c = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $b1594e117e20924f$export$7d21597c7bc64465 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $b1594e117e20924f$export$e87ddc9183aa53c9 = (0, $57cbbb20b90ddb01$export$fa9dde04c7d2f31a)({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});


var $7527e3b488edc187$exports = {};

$parcel$export($7527e3b488edc187$exports, "base256emoji", function () { return $7527e3b488edc187$export$6a5d4ab6075d2779; });

const $7527e3b488edc187$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $7527e3b488edc187$var$alphabetBytesToChars = $7527e3b488edc187$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $7527e3b488edc187$var$alphabetCharsToBytes = $7527e3b488edc187$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $7527e3b488edc187$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $7527e3b488edc187$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $7527e3b488edc187$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $7527e3b488edc187$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $7527e3b488edc187$export$6a5d4ab6075d2779 = (0, $57cbbb20b90ddb01$export$6788812c4e6611e6)({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $7527e3b488edc187$var$encode,
    decode: $7527e3b488edc187$var$decode
});


var $b97b089ad911043f$exports = {};

$parcel$export($b97b089ad911043f$exports, "sha256", function () { return $b97b089ad911043f$export$bced8d2aada2d1c9; });
$parcel$export($b97b089ad911043f$exports, "sha512", function () { return $b97b089ad911043f$export$a888d2532e6dc7bb; });

var $e28509dd740beea2$var$encode_1 = $e28509dd740beea2$var$encode;
var $e28509dd740beea2$var$MSB = 128, $e28509dd740beea2$var$REST = 127, $e28509dd740beea2$var$MSBALL = ~$e28509dd740beea2$var$REST, $e28509dd740beea2$var$INT = Math.pow(2, 31);
function $e28509dd740beea2$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $e28509dd740beea2$var$INT){
        out[offset++] = num & 255 | $e28509dd740beea2$var$MSB;
        num /= 128;
    }
    while(num & $e28509dd740beea2$var$MSBALL){
        out[offset++] = num & 255 | $e28509dd740beea2$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $e28509dd740beea2$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $e28509dd740beea2$var$decode = $e28509dd740beea2$var$read;
var $e28509dd740beea2$var$MSB$1 = 128, $e28509dd740beea2$var$REST$1 = 127;
function $e28509dd740beea2$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $e28509dd740beea2$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $e28509dd740beea2$var$REST$1) << shift : (b & $e28509dd740beea2$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $e28509dd740beea2$var$MSB$1);
    $e28509dd740beea2$var$read.bytes = counter - offset;
    return res;
}
var $e28509dd740beea2$var$N1 = Math.pow(2, 7);
var $e28509dd740beea2$var$N2 = Math.pow(2, 14);
var $e28509dd740beea2$var$N3 = Math.pow(2, 21);
var $e28509dd740beea2$var$N4 = Math.pow(2, 28);
var $e28509dd740beea2$var$N5 = Math.pow(2, 35);
var $e28509dd740beea2$var$N6 = Math.pow(2, 42);
var $e28509dd740beea2$var$N7 = Math.pow(2, 49);
var $e28509dd740beea2$var$N8 = Math.pow(2, 56);
var $e28509dd740beea2$var$N9 = Math.pow(2, 63);
var $e28509dd740beea2$var$length = function(value) {
    return value < $e28509dd740beea2$var$N1 ? 1 : value < $e28509dd740beea2$var$N2 ? 2 : value < $e28509dd740beea2$var$N3 ? 3 : value < $e28509dd740beea2$var$N4 ? 4 : value < $e28509dd740beea2$var$N5 ? 5 : value < $e28509dd740beea2$var$N6 ? 6 : value < $e28509dd740beea2$var$N7 ? 7 : value < $e28509dd740beea2$var$N8 ? 8 : value < $e28509dd740beea2$var$N9 ? 9 : 10;
};
var $e28509dd740beea2$var$varint = {
    encode: $e28509dd740beea2$var$encode_1,
    decode: $e28509dd740beea2$var$decode,
    encodingLength: $e28509dd740beea2$var$length
};
var $e28509dd740beea2$var$_brrp_varint = $e28509dd740beea2$var$varint;
var $e28509dd740beea2$export$2e2bcd8739ae039 = $e28509dd740beea2$var$_brrp_varint;


const $163909489c2148df$export$2f872c0f2117be69 = (data, offset = 0)=>{
    const code = (0, $e28509dd740beea2$export$2e2bcd8739ae039).decode(data, offset);
    return [
        code,
        (0, $e28509dd740beea2$export$2e2bcd8739ae039).decode.bytes
    ];
};
const $163909489c2148df$export$8512cbe4228de3b3 = (int, target, offset = 0)=>{
    (0, $e28509dd740beea2$export$2e2bcd8739ae039).encode(int, target, offset);
    return target;
};
const $163909489c2148df$export$cbee51f25f0626d7 = (int)=>{
    return (0, $e28509dd740beea2$export$2e2bcd8739ae039).encodingLength(int);
};


const $cc772570c173a6a4$export$185802fd694ee1f5 = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $163909489c2148df$export$cbee51f25f0626d7(code);
    const digestOffset = sizeOffset + $163909489c2148df$export$cbee51f25f0626d7(size);
    const bytes = new Uint8Array(digestOffset + size);
    $163909489c2148df$export$8512cbe4228de3b3(code, bytes, 0);
    $163909489c2148df$export$8512cbe4228de3b3(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $cc772570c173a6a4$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $cc772570c173a6a4$export$2f872c0f2117be69 = (multihash)=>{
    const bytes = (0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873)(multihash);
    const [code, sizeOffset] = $163909489c2148df$export$2f872c0f2117be69(bytes);
    const [size, digestOffset] = $163909489c2148df$export$2f872c0f2117be69(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $cc772570c173a6a4$export$d67a82ff561eff43(code, size, digest, bytes);
};
const $cc772570c173a6a4$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, $00f8b9fcbe55dbeb$export$e9bab7fafb253603)(a.bytes, b.bytes);
};
class $cc772570c173a6a4$export$d67a82ff561eff43 {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}


const $1ff1235691f82e96$export$6788812c4e6611e6 = ({ name: name, code: code, encode: encode })=>new $1ff1235691f82e96$export$df06eed23808f4d0(name, code, encode);
class $1ff1235691f82e96$export$df06eed23808f4d0 {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $cc772570c173a6a4$export$185802fd694ee1f5(this.code, result) : result.then((digest)=>$cc772570c173a6a4$export$185802fd694ee1f5(this.code, digest));
        } else throw Error("Unknown type, must be binary type");
    }
}


const $b97b089ad911043f$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $b97b089ad911043f$export$bced8d2aada2d1c9 = (0, $1ff1235691f82e96$export$6788812c4e6611e6)({
    name: "sha2-256",
    code: 18,
    encode: $b97b089ad911043f$var$sha("SHA-256")
});
const $b97b089ad911043f$export$a888d2532e6dc7bb = (0, $1ff1235691f82e96$export$6788812c4e6611e6)({
    name: "sha2-512",
    code: 19,
    encode: $b97b089ad911043f$var$sha("SHA-512")
});


var $6c7a2a97f390404b$exports = {};

$parcel$export($6c7a2a97f390404b$exports, "identity", function () { return $6c7a2a97f390404b$export$f0954fd7d5368655; });


const $6c7a2a97f390404b$var$code = 0;
const $6c7a2a97f390404b$var$name = "identity";
const $6c7a2a97f390404b$var$encode = (0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873);
const $6c7a2a97f390404b$var$digest = (input)=>$cc772570c173a6a4$export$185802fd694ee1f5($6c7a2a97f390404b$var$code, $6c7a2a97f390404b$var$encode(input));
const $6c7a2a97f390404b$export$f0954fd7d5368655 = {
    code: $6c7a2a97f390404b$var$code,
    name: $6c7a2a97f390404b$var$name,
    encode: $6c7a2a97f390404b$var$encode,
    digest: $6c7a2a97f390404b$var$digest
};


var $f8661faef556892f$exports = {};

$parcel$export($f8661faef556892f$exports, "name", function () { return $f8661faef556892f$export$a8ff84c12d48cfa6; });
$parcel$export($f8661faef556892f$exports, "code", function () { return $f8661faef556892f$export$6565f9f03506010b; });
$parcel$export($f8661faef556892f$exports, "encode", function () { return $f8661faef556892f$export$c564cdbbe6da493; });
$parcel$export($f8661faef556892f$exports, "decode", function () { return $f8661faef556892f$export$2f872c0f2117be69; });

const $f8661faef556892f$export$a8ff84c12d48cfa6 = "raw";
const $f8661faef556892f$export$6565f9f03506010b = 85;
const $f8661faef556892f$export$c564cdbbe6da493 = (node)=>(0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873)(node);
const $f8661faef556892f$export$2f872c0f2117be69 = (data)=>(0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873)(data);


var $33a3ebdf3474d0ed$exports = {};

$parcel$export($33a3ebdf3474d0ed$exports, "name", function () { return $33a3ebdf3474d0ed$export$a8ff84c12d48cfa6; });
$parcel$export($33a3ebdf3474d0ed$exports, "code", function () { return $33a3ebdf3474d0ed$export$6565f9f03506010b; });
$parcel$export($33a3ebdf3474d0ed$exports, "encode", function () { return $33a3ebdf3474d0ed$export$c564cdbbe6da493; });
$parcel$export($33a3ebdf3474d0ed$exports, "decode", function () { return $33a3ebdf3474d0ed$export$2f872c0f2117be69; });
const $33a3ebdf3474d0ed$var$textEncoder = new TextEncoder();
const $33a3ebdf3474d0ed$var$textDecoder = new TextDecoder();
const $33a3ebdf3474d0ed$export$a8ff84c12d48cfa6 = "json";
const $33a3ebdf3474d0ed$export$6565f9f03506010b = 512;
const $33a3ebdf3474d0ed$export$c564cdbbe6da493 = (node)=>$33a3ebdf3474d0ed$var$textEncoder.encode(JSON.stringify(node));
const $33a3ebdf3474d0ed$export$2f872c0f2117be69 = (data)=>JSON.parse($33a3ebdf3474d0ed$var$textDecoder.decode(data));







class $f700129b44a0f701$export$12d863fcef3f6aa {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $f700129b44a0f701$var$hidden,
            byteLength: $f700129b44a0f701$var$hidden,
            code: $f700129b44a0f701$var$readonly,
            version: $f700129b44a0f701$var$readonly,
            multihash: $f700129b44a0f701$var$readonly,
            bytes: $f700129b44a0f701$var$readonly,
            _baseCache: $f700129b44a0f701$var$hidden,
            asCID: $f700129b44a0f701$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $f700129b44a0f701$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $f700129b44a0f701$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $f700129b44a0f701$export$12d863fcef3f6aa.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest } = this.multihash;
                    const multihash = $cc772570c173a6a4$export$185802fd694ee1f5(code, digest);
                    return $f700129b44a0f701$export$12d863fcef3f6aa.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $cc772570c173a6a4$export$e9bab7fafb253603(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $f700129b44a0f701$var$toStringV0(bytes, _baseCache, base || (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).encoder);
            default:
                return $f700129b44a0f701$var$toStringV1(bytes, _baseCache, base || (0, $137e79e01e206153$export$4a4d5965e2738b2a).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $f700129b44a0f701$var$deprecate(/^0\.0/, $f700129b44a0f701$var$IS_CID_DEPRECATION);
        return !!(value && (value[$f700129b44a0f701$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $f700129b44a0f701$export$12d863fcef3f6aa) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $f700129b44a0f701$export$12d863fcef3f6aa(version, code, multihash, bytes || $f700129b44a0f701$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$f700129b44a0f701$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest = $cc772570c173a6a4$export$2f872c0f2117be69(multihash);
            return $f700129b44a0f701$export$12d863fcef3f6aa.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $f700129b44a0f701$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$f700129b44a0f701$var$DAG_PB_CODE}) block encoding`);
                else return new $f700129b44a0f701$export$12d863fcef3f6aa(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $f700129b44a0f701$var$encodeCID(version, code, digest.bytes);
                    return new $f700129b44a0f701$export$12d863fcef3f6aa(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $f700129b44a0f701$export$12d863fcef3f6aa.create(0, $f700129b44a0f701$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $f700129b44a0f701$export$12d863fcef3f6aa.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $f700129b44a0f701$export$12d863fcef3f6aa.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = $f700129b44a0f701$export$12d863fcef3f6aa.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, $00f8b9fcbe55dbeb$export$8c14e57e778d3873)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new $cc772570c173a6a4$export$d67a82ff561eff43(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $f700129b44a0f701$export$12d863fcef3f6aa.createV0(digest) : $f700129b44a0f701$export$12d863fcef3f6aa.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $163909489c2148df$export$2f872c0f2117be69(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $f700129b44a0f701$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $f700129b44a0f701$var$parseCIDtoBytes(source, base);
        const cid = $f700129b44a0f701$export$12d863fcef3f6aa.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $f700129b44a0f701$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c);
                return [
                    (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).prefix,
                    decoder.decode(`${(0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).prefix}${source}`)
                ];
            }
        case (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).prefix:
            {
                const decoder = base || (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c);
                return [
                    (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, $137e79e01e206153$export$4a4d5965e2738b2a).prefix:
            {
                const decoder = base || (0, $137e79e01e206153$export$4a4d5965e2738b2a);
                return [
                    (0, $137e79e01e206153$export$4a4d5965e2738b2a).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $f700129b44a0f701$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== (0, $d5eb4c3479635bf7$export$65c61748a9b98a2c).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $f700129b44a0f701$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $f700129b44a0f701$var$DAG_PB_CODE = 112;
const $f700129b44a0f701$var$SHA_256_CODE = 18;
const $f700129b44a0f701$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $163909489c2148df$export$cbee51f25f0626d7(version);
    const hashOffset = codeOffset + $163909489c2148df$export$cbee51f25f0626d7(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $163909489c2148df$export$8512cbe4228de3b3(version, bytes, 0);
    $163909489c2148df$export$8512cbe4228de3b3(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $f700129b44a0f701$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $f700129b44a0f701$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $f700129b44a0f701$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $f700129b44a0f701$var$version = "0.0.0-dev";
const $f700129b44a0f701$var$deprecate = (range, message)=>{
    if (range.test($f700129b44a0f701$var$version)) console.warn(message);
    else throw new Error(message);
};
const $f700129b44a0f701$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;








const $3ee393557f7928d6$export$196f613671eb7dd9 = {
    ...$5cf7ecb3583ae8b2$exports,
    ...$a74a12a273d3ff75$exports,
    ...$3c9c55dd7a52c8a4$exports,
    ...$0e2fab5b4e019eca$exports,
    ...$1f1c29b41550a0c7$exports,
    ...$137e79e01e206153$exports,
    ...$d1db2665698935ce$exports,
    ...$d5eb4c3479635bf7$exports,
    ...$b1594e117e20924f$exports,
    ...$7527e3b488edc187$exports
};
const $3ee393557f7928d6$export$cff071c6f82b8944 = {
    ...$b97b089ad911043f$exports,
    ...$6c7a2a97f390404b$exports
};
const $3ee393557f7928d6$export$b2c6ab3b27d60531 = {
    raw: $f8661faef556892f$exports,
    json: $33a3ebdf3474d0ed$exports
};



function $694430fd6f5f6e2a$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $694430fd6f5f6e2a$var$string = $694430fd6f5f6e2a$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $694430fd6f5f6e2a$var$ascii = $694430fd6f5f6e2a$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = (0, $23d98f49e421cf9a$export$19833a56117fe205)(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $694430fd6f5f6e2a$var$BASES = {
    utf8: $694430fd6f5f6e2a$var$string,
    "utf-8": $694430fd6f5f6e2a$var$string,
    hex: (0, $3ee393557f7928d6$export$196f613671eb7dd9).base16,
    latin1: $694430fd6f5f6e2a$var$ascii,
    ascii: $694430fd6f5f6e2a$var$ascii,
    binary: $694430fd6f5f6e2a$var$ascii,
    ...(0, $3ee393557f7928d6$export$196f613671eb7dd9)
};
var $694430fd6f5f6e2a$export$2e2bcd8739ae039 = $694430fd6f5f6e2a$var$BASES;


function $e6600a05507ca982$export$f84e8e69fd4488a5(array, encoding = "utf8") {
    const base = (0, $694430fd6f5f6e2a$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}




function $9e7f19515ec15414$export$3004f64547af360e(string, encoding = "utf8") {
    const base = (0, $694430fd6f5f6e2a$export$2e2bcd8739ae039)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return (0, $de3c5df3ff477878$export$db814d038928c649)(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}




function $b19a768c56f4badd$export$2030d1af6cd0ef93(str) {
    return (0, $88b153d3a15ebfc6$export$84137bb44359aed5)((0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $9e7f19515ec15414$export$3004f64547af360e)(str, (0, $3f42b1a526bf7802$export$d2e6fe38c55f8e23)), (0, $3f42b1a526bf7802$export$c09c2801e10a2b95)));
}
function $b19a768c56f4badd$export$84046f8082657cdf(val) {
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $9e7f19515ec15414$export$3004f64547af360e)((0, $88b153d3a15ebfc6$export$abc3f407e87918a4)(val), (0, $3f42b1a526bf7802$export$c09c2801e10a2b95)), (0, $3f42b1a526bf7802$export$d2e6fe38c55f8e23));
}
function $b19a768c56f4badd$export$1b29ef9371459e10(publicKey) {
    const header = (0, $9e7f19515ec15414$export$3004f64547af360e)((0, $3f42b1a526bf7802$export$9902a33a5776d1fc), (0, $3f42b1a526bf7802$export$7bd18b7a7a4d0471));
    const multicodec = (0, $3f42b1a526bf7802$export$6d6d3d2e39be8d68) + (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
        header,
        publicKey
    ]), (0, $3f42b1a526bf7802$export$7bd18b7a7a4d0471));
    return [
        (0, $3f42b1a526bf7802$export$acf13c61a1a0ccf3),
        (0, $3f42b1a526bf7802$export$b908fe81ccf30934),
        multicodec
    ].join((0, $3f42b1a526bf7802$export$d4057275de9d060b));
}
function $b19a768c56f4badd$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $3f42b1a526bf7802$export$d4057275de9d060b));
    if (prefix !== (0, $3f42b1a526bf7802$export$acf13c61a1a0ccf3) || method !== (0, $3f42b1a526bf7802$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $3f42b1a526bf7802$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $9e7f19515ec15414$export$3004f64547af360e)(multicodec.slice(1), (0, $3f42b1a526bf7802$export$7bd18b7a7a4d0471));
    const type = (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(bytes.slice(0, 2), (0, $3f42b1a526bf7802$export$7bd18b7a7a4d0471));
    if (type !== (0, $3f42b1a526bf7802$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $3f42b1a526bf7802$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $b19a768c56f4badd$export$d9746ef301b2089b(bytes) {
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(bytes, (0, $3f42b1a526bf7802$export$d2e6fe38c55f8e23));
}
function $b19a768c56f4badd$export$c37aeb372ac07c0e(encoded) {
    return (0, $9e7f19515ec15414$export$3004f64547af360e)(encoded, (0, $3f42b1a526bf7802$export$d2e6fe38c55f8e23));
}
function $b19a768c56f4badd$export$cfdd1f2478131e3d(params) {
    return (0, $9e7f19515ec15414$export$3004f64547af360e)([
        $b19a768c56f4badd$export$84046f8082657cdf(params.header),
        $b19a768c56f4badd$export$84046f8082657cdf(params.payload)
    ].join((0, $3f42b1a526bf7802$export$a3e35a0f952eb3ef)), (0, $3f42b1a526bf7802$export$1e9219c0b91a4257));
}
function $b19a768c56f4badd$export$13923bea59211b58(data) {
    const params = (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(data, (0, $3f42b1a526bf7802$export$1e9219c0b91a4257)).split((0, $3f42b1a526bf7802$export$a3e35a0f952eb3ef));
    const header = $b19a768c56f4badd$export$2030d1af6cd0ef93(params[0]);
    const payload = $b19a768c56f4badd$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $b19a768c56f4badd$export$1b70f4551c751d68(params) {
    return [
        $b19a768c56f4badd$export$84046f8082657cdf(params.header),
        $b19a768c56f4badd$export$84046f8082657cdf(params.payload),
        $b19a768c56f4badd$export$d9746ef301b2089b(params.signature)
    ].join((0, $3f42b1a526bf7802$export$a3e35a0f952eb3ef));
}
function $b19a768c56f4badd$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $3f42b1a526bf7802$export$a3e35a0f952eb3ef));
    const header = $b19a768c56f4badd$export$2030d1af6cd0ef93(params[0]);
    const payload = $b19a768c56f4badd$export$2030d1af6cd0ef93(params[1]);
    const signature = $b19a768c56f4badd$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $9e7f19515ec15414$export$3004f64547af360e)(params.slice(0, 2).join((0, $3f42b1a526bf7802$export$a3e35a0f952eb3ef)), (0, $3f42b1a526bf7802$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $bf3d2d04ac30a374$export$a949d36eab55b41f(seed = (0, $e8d7d54636de94dc$exports.randomBytes)((0, $3f42b1a526bf7802$export$f09ad228919f26fb))) {
    return $212512bcb5557ed8$exports.generateKeyPairFromSeed(seed);
}
async function $bf3d2d04ac30a374$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $j5HK8.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $3f42b1a526bf7802$export$51745f7832485c34),
        typ: (0, $3f42b1a526bf7802$export$f51b45e220f2ba98)
    };
    const iss = (0, $b19a768c56f4badd$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $b19a768c56f4badd$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $212512bcb5557ed8$exports.sign(keyPair.secretKey, data);
    return (0, $b19a768c56f4badd$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $bf3d2d04ac30a374$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $b19a768c56f4badd$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $3f42b1a526bf7802$export$51745f7832485c34) || header.typ !== (0, $3f42b1a526bf7802$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $b19a768c56f4badd$export$86ac046d72244356)(payload.iss);
    return $212512bcb5557ed8$exports.verify(publicKey, data, signature);
}



var $fca28e908229dd3c$exports = {};



$parcel$exportWildcard($67e1c27d88bb1cf4$exports, $fca28e908229dd3c$exports);


var $4dc6ea184d480b85$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($4dc6ea184d480b85$exports, "__esModule", {
    value: true
});
var $40a734e4de8415e9$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($40a734e4de8415e9$exports, "__esModule", {
    value: true
});


// Number of ChaCha rounds (ChaCha20).
var $40a734e4de8415e9$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $40a734e4de8415e9$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $40a734e4de8415e9$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $844dc299b00b17a1$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $844dc299b00b17a1$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $844dc299b00b17a1$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $844dc299b00b17a1$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $844dc299b00b17a1$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $844dc299b00b17a1$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $844dc299b00b17a1$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $844dc299b00b17a1$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $844dc299b00b17a1$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $844dc299b00b17a1$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $844dc299b00b17a1$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $844dc299b00b17a1$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $844dc299b00b17a1$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $844dc299b00b17a1$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $844dc299b00b17a1$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $844dc299b00b17a1$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $40a734e4de8415e9$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $40a734e4de8415e9$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $40a734e4de8415e9$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $f23ef81b68a41b51$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $f23ef81b68a41b51$exports.wipe(nc);
    return dst;
}
$40a734e4de8415e9$exports.streamXOR = $40a734e4de8415e9$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $40a734e4de8415e9$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $f23ef81b68a41b51$exports.wipe(dst);
    return $40a734e4de8415e9$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$40a734e4de8415e9$exports.stream = $40a734e4de8415e9$var$stream;
function $40a734e4de8415e9$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $5ff14e795ff4b95c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($5ff14e795ff4b95c$exports, "__esModule", {
    value: true
});
var $64bb2c13f8767f73$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($64bb2c13f8767f73$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $64bb2c13f8767f73$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$64bb2c13f8767f73$exports.select = $64bb2c13f8767f73$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $64bb2c13f8767f73$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$64bb2c13f8767f73$exports.lessOrEqual = $64bb2c13f8767f73$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $64bb2c13f8767f73$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$64bb2c13f8767f73$exports.compare = $64bb2c13f8767f73$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $64bb2c13f8767f73$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $64bb2c13f8767f73$var$compare(a, b) !== 0;
}
$64bb2c13f8767f73$exports.equal = $64bb2c13f8767f73$var$equal;



$5ff14e795ff4b95c$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $5ff14e795ff4b95c$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $5ff14e795ff4b95c$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $f23ef81b68a41b51$exports.wipe(this._buffer);
        $f23ef81b68a41b51$exports.wipe(this._r);
        $f23ef81b68a41b51$exports.wipe(this._h);
        $f23ef81b68a41b51$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$5ff14e795ff4b95c$exports.Poly1305 = $5ff14e795ff4b95c$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $5ff14e795ff4b95c$var$oneTimeAuth(key, data) {
    var h = new $5ff14e795ff4b95c$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$5ff14e795ff4b95c$exports.oneTimeAuth = $5ff14e795ff4b95c$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $5ff14e795ff4b95c$var$equal(a, b) {
    if (a.length !== $5ff14e795ff4b95c$exports.DIGEST_LENGTH || b.length !== $5ff14e795ff4b95c$exports.DIGEST_LENGTH) return false;
    return $64bb2c13f8767f73$exports.equal(a, b);
}
$5ff14e795ff4b95c$exports.equal = $5ff14e795ff4b95c$var$equal;





$4dc6ea184d480b85$exports.KEY_LENGTH = 32;
$4dc6ea184d480b85$exports.NONCE_LENGTH = 12;
$4dc6ea184d480b85$exports.TAG_LENGTH = 16;
var $4dc6ea184d480b85$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $4dc6ea184d480b85$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $4dc6ea184d480b85$exports.NONCE_LENGTH;
        this.tagLength = $4dc6ea184d480b85$exports.TAG_LENGTH;
        if (key.length !== $4dc6ea184d480b85$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $40a734e4de8415e9$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $40a734e4de8415e9$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $f23ef81b68a41b51$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $40a734e4de8415e9$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$64bb2c13f8767f73$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $40a734e4de8415e9$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $f23ef81b68a41b51$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $f23ef81b68a41b51$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $5ff14e795ff4b95c$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($4dc6ea184d480b85$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($4dc6ea184d480b85$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $844dc299b00b17a1$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $844dc299b00b17a1$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $f23ef81b68a41b51$exports.wipe(tag);
        $f23ef81b68a41b51$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$4dc6ea184d480b85$exports.ChaCha20Poly1305 = $4dc6ea184d480b85$var$ChaCha20Poly1305;


var $4488f47cea993102$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($4488f47cea993102$exports, "__esModule", {
    value: true
});
var $0638c31d611e0c70$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($0638c31d611e0c70$exports, "__esModule", {
    value: true
});
var $3bf2d46302e485d0$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($3bf2d46302e485d0$exports, "__esModule", {
    value: true
});
function $3bf2d46302e485d0$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$3bf2d46302e485d0$exports.isSerializableHash = $3bf2d46302e485d0$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $0638c31d611e0c70$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($3bf2d46302e485d0$exports.isSerializableHash(this._inner) && $3bf2d46302e485d0$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $f23ef81b68a41b51$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$3bf2d46302e485d0$exports.isSerializableHash(this._inner) || !$3bf2d46302e485d0$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($3bf2d46302e485d0$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($3bf2d46302e485d0$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$3bf2d46302e485d0$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$3bf2d46302e485d0$exports.isSerializableHash(this._inner) || !$3bf2d46302e485d0$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$3bf2d46302e485d0$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$0638c31d611e0c70$exports.HMAC = $0638c31d611e0c70$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $0638c31d611e0c70$var$hmac(hash, key, data) {
    var h = new $0638c31d611e0c70$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$0638c31d611e0c70$exports.hmac = $0638c31d611e0c70$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $0638c31d611e0c70$exports.equal = $64bb2c13f8767f73$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $4488f47cea993102$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $0638c31d611e0c70$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $0638c31d611e0c70$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $f23ef81b68a41b51$exports.wipe(this._buffer);
        $f23ef81b68a41b51$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$4488f47cea993102$exports.HKDF = $4488f47cea993102$var$HKDF; // TODO(dchest): maybe implement deriveKey?



var $90699891a8c8f5b5$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($90699891a8c8f5b5$exports, "__esModule", {
    value: true
});


$90699891a8c8f5b5$exports.DIGEST_LENGTH = 32;
$90699891a8c8f5b5$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $90699891a8c8f5b5$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $90699891a8c8f5b5$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $90699891a8c8f5b5$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $f23ef81b68a41b51$exports.wipe(this._buffer);
        $f23ef81b68a41b51$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $90699891a8c8f5b5$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $90699891a8c8f5b5$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $844dc299b00b17a1$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $844dc299b00b17a1$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $90699891a8c8f5b5$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$844dc299b00b17a1$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $f23ef81b68a41b51$exports.wipe(savedState.state);
        if (savedState.buffer) $f23ef81b68a41b51$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$90699891a8c8f5b5$exports.SHA256 = $90699891a8c8f5b5$var$SHA256;
// Constants
var $90699891a8c8f5b5$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $90699891a8c8f5b5$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $844dc299b00b17a1$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($90699891a8c8f5b5$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $90699891a8c8f5b5$var$hash(data) {
    var h = new $90699891a8c8f5b5$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$90699891a8c8f5b5$exports.hash = $90699891a8c8f5b5$var$hash;


var $c8893c01b49eb09f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c8893c01b49eb09f$exports, "__esModule", {
    value: true
});
$c8893c01b49eb09f$exports.sharedKey = $c8893c01b49eb09f$exports.generateKeyPair = $c8893c01b49eb09f$exports.generateKeyPairFromSeed = $c8893c01b49eb09f$exports.scalarMultBase = $c8893c01b49eb09f$exports.scalarMult = $c8893c01b49eb09f$exports.SHARED_KEY_LENGTH = $c8893c01b49eb09f$exports.SECRET_KEY_LENGTH = $c8893c01b49eb09f$exports.PUBLIC_KEY_LENGTH = void 0;


$c8893c01b49eb09f$exports.PUBLIC_KEY_LENGTH = 32;
$c8893c01b49eb09f$exports.SECRET_KEY_LENGTH = 32;
$c8893c01b49eb09f$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $c8893c01b49eb09f$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $c8893c01b49eb09f$var$_9 = new Uint8Array(32);
$c8893c01b49eb09f$var$_9[0] = 9;
const $c8893c01b49eb09f$var$_121665 = $c8893c01b49eb09f$var$gf([
    0xdb41,
    1
]);
function $c8893c01b49eb09f$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $c8893c01b49eb09f$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $c8893c01b49eb09f$var$pack25519(o, n) {
    const m = $c8893c01b49eb09f$var$gf();
    const t = $c8893c01b49eb09f$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $c8893c01b49eb09f$var$car25519(t);
    $c8893c01b49eb09f$var$car25519(t);
    $c8893c01b49eb09f$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $c8893c01b49eb09f$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $c8893c01b49eb09f$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $c8893c01b49eb09f$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $c8893c01b49eb09f$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $c8893c01b49eb09f$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $c8893c01b49eb09f$var$square(o, a) {
    $c8893c01b49eb09f$var$mul(o, a, a);
}
function $c8893c01b49eb09f$var$inv25519(o, inp) {
    const c = $c8893c01b49eb09f$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $c8893c01b49eb09f$var$square(c, c);
        if (i !== 2 && i !== 4) $c8893c01b49eb09f$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $c8893c01b49eb09f$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $c8893c01b49eb09f$var$gf(), b = $c8893c01b49eb09f$var$gf(), c = $c8893c01b49eb09f$var$gf(), d = $c8893c01b49eb09f$var$gf(), e = $c8893c01b49eb09f$var$gf(), f = $c8893c01b49eb09f$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $c8893c01b49eb09f$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $c8893c01b49eb09f$var$sel25519(a, b, r);
        $c8893c01b49eb09f$var$sel25519(c, d, r);
        $c8893c01b49eb09f$var$add(e, a, c);
        $c8893c01b49eb09f$var$sub(a, a, c);
        $c8893c01b49eb09f$var$add(c, b, d);
        $c8893c01b49eb09f$var$sub(b, b, d);
        $c8893c01b49eb09f$var$square(d, e);
        $c8893c01b49eb09f$var$square(f, a);
        $c8893c01b49eb09f$var$mul(a, c, a);
        $c8893c01b49eb09f$var$mul(c, b, e);
        $c8893c01b49eb09f$var$add(e, a, c);
        $c8893c01b49eb09f$var$sub(a, a, c);
        $c8893c01b49eb09f$var$square(b, a);
        $c8893c01b49eb09f$var$sub(c, d, f);
        $c8893c01b49eb09f$var$mul(a, c, $c8893c01b49eb09f$var$_121665);
        $c8893c01b49eb09f$var$add(a, a, d);
        $c8893c01b49eb09f$var$mul(c, c, a);
        $c8893c01b49eb09f$var$mul(a, d, f);
        $c8893c01b49eb09f$var$mul(d, b, x);
        $c8893c01b49eb09f$var$square(b, e);
        $c8893c01b49eb09f$var$sel25519(a, b, r);
        $c8893c01b49eb09f$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $c8893c01b49eb09f$var$inv25519(x32, x32);
    $c8893c01b49eb09f$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $c8893c01b49eb09f$var$pack25519(q, x16);
    return q;
}
$c8893c01b49eb09f$exports.scalarMult = $c8893c01b49eb09f$var$scalarMult;
function $c8893c01b49eb09f$var$scalarMultBase(n) {
    return $c8893c01b49eb09f$var$scalarMult(n, $c8893c01b49eb09f$var$_9);
}
$c8893c01b49eb09f$exports.scalarMultBase = $c8893c01b49eb09f$var$scalarMultBase;
function $c8893c01b49eb09f$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $c8893c01b49eb09f$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$c8893c01b49eb09f$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $c8893c01b49eb09f$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$c8893c01b49eb09f$exports.generateKeyPairFromSeed = $c8893c01b49eb09f$var$generateKeyPairFromSeed;
function $c8893c01b49eb09f$var$generateKeyPair(prng) {
    const seed = (0, $e8d7d54636de94dc$exports.randomBytes)(32, prng);
    const result = $c8893c01b49eb09f$var$generateKeyPairFromSeed(seed);
    (0, $f23ef81b68a41b51$exports.wipe)(seed);
    return result;
}
$c8893c01b49eb09f$exports.generateKeyPair = $c8893c01b49eb09f$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $c8893c01b49eb09f$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $c8893c01b49eb09f$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $c8893c01b49eb09f$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $c8893c01b49eb09f$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$c8893c01b49eb09f$exports.sharedKey = $c8893c01b49eb09f$var$sharedKey;


function $09d1fb1d94ade4a5$export$398604a469f7de9a(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}



function $06febb88698d0550$export$e9bab7fafb253603(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}






function $0cff5133269c23ec$export$6444ef5cd411280c(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = (0, $23d98f49e421cf9a$export$19833a56117fe205)(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return (0, $de3c5df3ff477878$export$db814d038928c649)(result);
}





var $6qd2L = parcelRequire("6qd2L");
var $fc258a372ec38109$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $fc258a372ec38109$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $fc258a372ec38109$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $6qd2L.platform;
    }
    return NodeInfo;
}();
var $fc258a372ec38109$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $fc258a372ec38109$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $fc258a372ec38109$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $fc258a372ec38109$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $fc258a372ec38109$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $fc258a372ec38109$var$REQUIRED_VERSION_PARTS = 3;
var $fc258a372ec38109$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $fc258a372ec38109$var$SEARCHBOX_UA_REGEX
    ]
];
var $fc258a372ec38109$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $fc258a372ec38109$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $fc258a372ec38109$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $fc258a372ec38109$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $fc258a372ec38109$export$1184956100eddc3c(navigator.userAgent);
    return $fc258a372ec38109$export$bf2c6630ab904918();
}
function $fc258a372ec38109$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $fc258a372ec38109$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $fc258a372ec38109$export$89ca9f8ca1a50fd5(ua) {
    var data = $fc258a372ec38109$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $fc258a372ec38109$export$1184956100eddc3c(ua) {
    var matchedRule = $fc258a372ec38109$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $fc258a372ec38109$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $fc258a372ec38109$var$REQUIRED_VERSION_PARTS) versionParts = $fc258a372ec38109$var$__spreadArray($fc258a372ec38109$var$__spreadArray([], versionParts, true), $fc258a372ec38109$var$createVersionParts($fc258a372ec38109$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $fc258a372ec38109$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $fc258a372ec38109$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $fc258a372ec38109$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $fc258a372ec38109$export$8fa985da04a86f0(name, version, os);
}
function $fc258a372ec38109$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $fc258a372ec38109$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $fc258a372ec38109$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $fc258a372ec38109$export$bf2c6630ab904918() {
    var isNode = typeof $6qd2L !== "undefined" && $6qd2L.version;
    return isNode ? new $fc258a372ec38109$export$62457c674e0167c0($6qd2L.version.slice(1)) : null;
}
function $fc258a372ec38109$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $j5HK8 = parcelRequire("j5HK8");
var $42fc9f31ad639091$exports = {};
"use strict";
Object.defineProperty($42fc9f31ad639091$exports, "__esModule", {
    value: true
});
$42fc9f31ad639091$exports.getLocalStorage = $42fc9f31ad639091$exports.getLocalStorageOrThrow = $42fc9f31ad639091$exports.getCrypto = $42fc9f31ad639091$exports.getCryptoOrThrow = $42fc9f31ad639091$exports.getLocation = $42fc9f31ad639091$exports.getLocationOrThrow = $42fc9f31ad639091$exports.getNavigator = $42fc9f31ad639091$exports.getNavigatorOrThrow = $42fc9f31ad639091$exports.getDocument = $42fc9f31ad639091$exports.getDocumentOrThrow = $42fc9f31ad639091$exports.getFromWindowOrThrow = $42fc9f31ad639091$exports.getFromWindow = void 0;
function $42fc9f31ad639091$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$42fc9f31ad639091$exports.getFromWindow = $42fc9f31ad639091$var$getFromWindow;
function $42fc9f31ad639091$var$getFromWindowOrThrow(name) {
    const res = $42fc9f31ad639091$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$42fc9f31ad639091$exports.getFromWindowOrThrow = $42fc9f31ad639091$var$getFromWindowOrThrow;
function $42fc9f31ad639091$var$getDocumentOrThrow() {
    return $42fc9f31ad639091$var$getFromWindowOrThrow("document");
}
$42fc9f31ad639091$exports.getDocumentOrThrow = $42fc9f31ad639091$var$getDocumentOrThrow;
function $42fc9f31ad639091$var$getDocument() {
    return $42fc9f31ad639091$var$getFromWindow("document");
}
$42fc9f31ad639091$exports.getDocument = $42fc9f31ad639091$var$getDocument;
function $42fc9f31ad639091$var$getNavigatorOrThrow() {
    return $42fc9f31ad639091$var$getFromWindowOrThrow("navigator");
}
$42fc9f31ad639091$exports.getNavigatorOrThrow = $42fc9f31ad639091$var$getNavigatorOrThrow;
function $42fc9f31ad639091$var$getNavigator() {
    return $42fc9f31ad639091$var$getFromWindow("navigator");
}
$42fc9f31ad639091$exports.getNavigator = $42fc9f31ad639091$var$getNavigator;
function $42fc9f31ad639091$var$getLocationOrThrow() {
    return $42fc9f31ad639091$var$getFromWindowOrThrow("location");
}
$42fc9f31ad639091$exports.getLocationOrThrow = $42fc9f31ad639091$var$getLocationOrThrow;
function $42fc9f31ad639091$var$getLocation() {
    return $42fc9f31ad639091$var$getFromWindow("location");
}
$42fc9f31ad639091$exports.getLocation = $42fc9f31ad639091$var$getLocation;
function $42fc9f31ad639091$var$getCryptoOrThrow() {
    return $42fc9f31ad639091$var$getFromWindowOrThrow("crypto");
}
$42fc9f31ad639091$exports.getCryptoOrThrow = $42fc9f31ad639091$var$getCryptoOrThrow;
function $42fc9f31ad639091$var$getCrypto() {
    return $42fc9f31ad639091$var$getFromWindow("crypto");
}
$42fc9f31ad639091$exports.getCrypto = $42fc9f31ad639091$var$getCrypto;
function $42fc9f31ad639091$var$getLocalStorageOrThrow() {
    return $42fc9f31ad639091$var$getFromWindowOrThrow("localStorage");
}
$42fc9f31ad639091$exports.getLocalStorageOrThrow = $42fc9f31ad639091$var$getLocalStorageOrThrow;
function $42fc9f31ad639091$var$getLocalStorage() {
    return $42fc9f31ad639091$var$getFromWindow("localStorage");
}
$42fc9f31ad639091$exports.getLocalStorage = $42fc9f31ad639091$var$getLocalStorage;


var $b27946e0f1afb509$exports = {};
"use strict";
Object.defineProperty($b27946e0f1afb509$exports, "__esModule", {
    value: true
});
$b27946e0f1afb509$exports.getWindowMetadata = void 0;

function $b27946e0f1afb509$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $42fc9f31ad639091$exports.getDocumentOrThrow();
        loc = $42fc9f31ad639091$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$b27946e0f1afb509$exports.getWindowMetadata = $b27946e0f1afb509$var$getWindowMetadata;


var $4466bfd994589455$export$f9380c9a627682d3;
var $4466bfd994589455$export$98e6a39c04603d36;
var $4466bfd994589455$export$fac44ee5b035f737;
var $4466bfd994589455$export$7a5253c0f62e0150;
var $4466bfd994589455$export$a8c1621ea79325d3;
var $4466bfd994589455$export$357523c63a2253b9;
var $4466bfd994589455$export$44c361b8ec72ef7f;
"use strict";
var $fb68c056088f0e6a$exports = {};
"use strict";
$fb68c056088f0e6a$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $e3f49fb9a7fe1f8f$exports = {};
"use strict";
var $e3f49fb9a7fe1f8f$var$token = "%[a-f0-9]{2}";
var $e3f49fb9a7fe1f8f$var$singleMatcher = new RegExp("(" + $e3f49fb9a7fe1f8f$var$token + ")|([^%]+?)", "gi");
var $e3f49fb9a7fe1f8f$var$multiMatcher = new RegExp("(" + $e3f49fb9a7fe1f8f$var$token + ")+", "gi");
function $e3f49fb9a7fe1f8f$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $e3f49fb9a7fe1f8f$var$decodeComponents(left), $e3f49fb9a7fe1f8f$var$decodeComponents(right));
}
function $e3f49fb9a7fe1f8f$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $e3f49fb9a7fe1f8f$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $e3f49fb9a7fe1f8f$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$e3f49fb9a7fe1f8f$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(encodedURI);
    }
};


var $e78c9bd53c92ef94$exports = {};
"use strict";
$e78c9bd53c92ef94$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $e85104af5636d4bb$exports = {};
"use strict";
$e85104af5636d4bb$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $4466bfd994589455$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $4466bfd994589455$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $4466bfd994589455$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            "[",
                            $4466bfd994589455$var$encode(index, options),
                            "]=",
                            $4466bfd994589455$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            "[]=",
                            $4466bfd994589455$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            ":list=",
                            $4466bfd994589455$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $4466bfd994589455$var$encode(key, options),
                                keyValueSep,
                                $4466bfd994589455$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $4466bfd994589455$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $4466bfd994589455$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $4466bfd994589455$var$encode(key, options),
                            "=",
                            $4466bfd994589455$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $4466bfd994589455$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $4466bfd994589455$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $4466bfd994589455$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$4466bfd994589455$var$decode(item, options)) : value === null ? value : $4466bfd994589455$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $4466bfd994589455$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$4466bfd994589455$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $4466bfd994589455$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $4466bfd994589455$var$encode(value, options) {
    if (options.encode) return options.strict ? $fb68c056088f0e6a$exports(value) : encodeURIComponent(value);
    return value;
}
function $4466bfd994589455$var$decode(value, options) {
    if (options.decode) return $e3f49fb9a7fe1f8f$exports(value);
    return value;
}
function $4466bfd994589455$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $4466bfd994589455$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $4466bfd994589455$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $4466bfd994589455$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $4466bfd994589455$var$extract(input) {
    input = $4466bfd994589455$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $4466bfd994589455$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $4466bfd994589455$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $4466bfd994589455$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $4466bfd994589455$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $e78c9bd53c92ef94$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $4466bfd994589455$var$decode(value, options);
        formatter($4466bfd994589455$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $4466bfd994589455$var$parseValue(value[k], options);
        else ret[key] = $4466bfd994589455$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $4466bfd994589455$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$4466bfd994589455$export$f9380c9a627682d3 = $4466bfd994589455$var$extract;
$4466bfd994589455$export$98e6a39c04603d36 = $4466bfd994589455$var$parse;
$4466bfd994589455$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $4466bfd994589455$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $4466bfd994589455$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $4466bfd994589455$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $4466bfd994589455$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $4466bfd994589455$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $4466bfd994589455$var$encode(key, options) + "=" + $4466bfd994589455$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$4466bfd994589455$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $e78c9bd53c92ef94$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $4466bfd994589455$var$parse($4466bfd994589455$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $4466bfd994589455$var$decode(hash, options)
    } : {});
};
$4466bfd994589455$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$4466bfd994589455$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $4466bfd994589455$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $4466bfd994589455$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $4466bfd994589455$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $4466bfd994589455$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $4466bfd994589455$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$4466bfd994589455$var$encodeFragmentIdentifier] ? $4466bfd994589455$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$4466bfd994589455$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$4466bfd994589455$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $4466bfd994589455$export$7a5253c0f62e0150(input, options);
    return $4466bfd994589455$export$a8c1621ea79325d3({
        url: url,
        query: $e85104af5636d4bb$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$4466bfd994589455$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $4466bfd994589455$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $168bd39a0fd66e15$exports = {};
$parcel$export($168bd39a0fd66e15$exports, "RELAY_JSONRPC", function () { return $d06ba0a3f54ef0e1$export$af490b3b9a6de00f; });
var $4d8ef06abea122c2$exports = {};


function $2d158ad184ebd9e2$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $2d158ad184ebd9e2$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $2d158ad184ebd9e2$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $2d158ad184ebd9e2$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $2d158ad184ebd9e2$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $2d158ad184ebd9e2$export$e4b3f942a6d00ef9(params, required.length) : $2d158ad184ebd9e2$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $2d158ad184ebd9e2$export$c538c02216fcdc03(params, required);
}
function $2d158ad184ebd9e2$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $e4e1bb208e9df84f$export$c75580565fa025bd(request) {
    return $e4e1bb208e9df84f$export$f576347163de0984(request.method) && $e4e1bb208e9df84f$export$dae2311546d43680(request.params);
}
function $e4e1bb208e9df84f$export$f576347163de0984(method) {
    return (0, $2d158ad184ebd9e2$export$18337b4ba58d5c33)(method, "subscribe");
}
function $e4e1bb208e9df84f$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $2d158ad184ebd9e2$export$19e8e281e27dafad)(params, required, optional);
}
function $e4e1bb208e9df84f$export$8fa7cf76b41caee0(request) {
    return $e4e1bb208e9df84f$export$71d4d33ac7f7a269(request.method) && $e4e1bb208e9df84f$export$71e8d1aa48c3e86f(request.params);
}
function $e4e1bb208e9df84f$export$71d4d33ac7f7a269(method) {
    return (0, $2d158ad184ebd9e2$export$18337b4ba58d5c33)(method, "publish");
}
function $e4e1bb208e9df84f$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $2d158ad184ebd9e2$export$19e8e281e27dafad)(params, required, optional);
}
function $e4e1bb208e9df84f$export$83e292763180b41b(request) {
    return $e4e1bb208e9df84f$export$568d956f39536025(request.method) && $e4e1bb208e9df84f$export$cbc597c53c3b4f80(request.params);
}
function $e4e1bb208e9df84f$export$568d956f39536025(method) {
    return (0, $2d158ad184ebd9e2$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $e4e1bb208e9df84f$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $2d158ad184ebd9e2$export$19e8e281e27dafad)(params, required, optional);
}
function $e4e1bb208e9df84f$export$43cf4100d6287b8e(request) {
    return $e4e1bb208e9df84f$export$3cb4ad320e3a46a4(request.method) && $e4e1bb208e9df84f$export$6366ff9a39f2da4c(request.params);
}
function $e4e1bb208e9df84f$export$3cb4ad320e3a46a4(method) {
    return (0, $2d158ad184ebd9e2$export$18337b4ba58d5c33)(method, "subscription");
}
function $e4e1bb208e9df84f$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $2d158ad184ebd9e2$export$19e8e281e27dafad)(params, required, optional);
}


function $b8727f36177bbff9$export$abdf96c288cb375(request) {
    if (!(0, $e4e1bb208e9df84f$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $e4e1bb208e9df84f$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $b8727f36177bbff9$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $e4e1bb208e9df84f$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $e4e1bb208e9df84f$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "topic");
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "message");
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $b8727f36177bbff9$export$78baa72f78156594(request) {
    if (!(0, $e4e1bb208e9df84f$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $e4e1bb208e9df84f$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "id");
    return params;
}
function $b8727f36177bbff9$export$4d5822edd41f3b48(request) {
    if (!(0, $e4e1bb208e9df84f$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $e4e1bb208e9df84f$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "id");
    (0, $2d158ad184ebd9e2$export$804de46662e4ac95)(params, "data");
    return params;
}


const $d06ba0a3f54ef0e1$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($168bd39a0fd66e15$exports, $4d8ef06abea122c2$exports);



var $6qd2L = parcelRequire("6qd2L");
const $93242f9a41d458a0$var$K = ":";
function $93242f9a41d458a0$export$4764229d78de4437(e) {
    const [n, t] = e.split($93242f9a41d458a0$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $93242f9a41d458a0$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($93242f9a41d458a0$var$K);
}
function $93242f9a41d458a0$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($93242f9a41d458a0$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $93242f9a41d458a0$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($93242f9a41d458a0$var$K);
}
function $93242f9a41d458a0$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $93242f9a41d458a0$export$2806d446053abd1d(e) {
    const { address: n } = $93242f9a41d458a0$export$276ab0158c66e3d(e);
    return n;
}
function $93242f9a41d458a0$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $93242f9a41d458a0$export$276ab0158c66e3d(e);
    return $93242f9a41d458a0$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $93242f9a41d458a0$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $93242f9a41d458a0$export$4764229d78de4437(n);
    return $93242f9a41d458a0$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $93242f9a41d458a0$export$aa4a6b630dfcfa83(e) {
    return $93242f9a41d458a0$export$d579bc26e95946b5(e, $93242f9a41d458a0$export$2806d446053abd1d);
}
function $93242f9a41d458a0$export$d5ee58c6b13696e9(e) {
    return $93242f9a41d458a0$export$d579bc26e95946b5(e, $93242f9a41d458a0$export$93512919ec2ab555);
}
function $93242f9a41d458a0$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $93242f9a41d458a0$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$93242f9a41d458a0$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $93242f9a41d458a0$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$93242f9a41d458a0$export$376384387cd15b27(r, o));
    }), t;
}
function $93242f9a41d458a0$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $93242f9a41d458a0$export$a524ae552db7912 = (e)=>e?.split(":"), $93242f9a41d458a0$export$85f23c05c80b194 = (e)=>{
    const n = e && $93242f9a41d458a0$export$a524ae552db7912(e);
    if (n) return n[3];
}, $93242f9a41d458a0$export$a8b149927aef7051 = (e)=>{
    const n = e && $93242f9a41d458a0$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $93242f9a41d458a0$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $93242f9a41d458a0$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $93242f9a41d458a0$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $93242f9a41d458a0$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$93242f9a41d458a0$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $93242f9a41d458a0$export$f7403969428298bd = "base10", $93242f9a41d458a0$export$49eb910ab2518105 = "base16", $93242f9a41d458a0$export$9bff723d552e6bcf = "base64pad", $93242f9a41d458a0$export$9560dad2a83e4f04 = "utf8", $93242f9a41d458a0$export$3425bd336a9673d8 = 0, $93242f9a41d458a0$export$406e97c329f0f3d4 = 1, $93242f9a41d458a0$var$Dn = 0, $93242f9a41d458a0$var$Te = 1, $93242f9a41d458a0$var$Z = 12, $93242f9a41d458a0$var$X = 32;
function $93242f9a41d458a0$export$a949d36eab55b41f() {
    const e = $c8893c01b49eb09f$exports.generateKeyPair();
    return {
        privateKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.secretKey, $93242f9a41d458a0$export$49eb910ab2518105),
        publicKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.publicKey, $93242f9a41d458a0$export$49eb910ab2518105)
    };
}
function $93242f9a41d458a0$export$d15a28e4f1821243() {
    const e = (0, $e8d7d54636de94dc$exports.randomBytes)($93242f9a41d458a0$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $93242f9a41d458a0$export$49eb910ab2518105);
}
function $93242f9a41d458a0$export$f8378f68e053f5c6(e, n) {
    const t = $c8893c01b49eb09f$exports.sharedKey((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $93242f9a41d458a0$export$49eb910ab2518105), (0, $9e7f19515ec15414$export$3004f64547af360e)(n, $93242f9a41d458a0$export$49eb910ab2518105), !0), r = new (0, $4488f47cea993102$exports.HKDF)((0, $90699891a8c8f5b5$exports.SHA256), t).expand($93242f9a41d458a0$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(r, $93242f9a41d458a0$export$49eb910ab2518105);
}
function $93242f9a41d458a0$export$1e87d19d4aab5805(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $93242f9a41d458a0$export$49eb910ab2518105));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $93242f9a41d458a0$export$49eb910ab2518105);
}
function $93242f9a41d458a0$export$d4c241cec96564c1(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $93242f9a41d458a0$export$9560dad2a83e4f04));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $93242f9a41d458a0$export$49eb910ab2518105);
}
function $93242f9a41d458a0$export$e9d2f9ba70428fb6(e) {
    return (0, $9e7f19515ec15414$export$3004f64547af360e)(`${e}`, $93242f9a41d458a0$export$f7403969428298bd);
}
function $93242f9a41d458a0$export$7547a514ee29b9d4(e) {
    return Number((0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $93242f9a41d458a0$export$f7403969428298bd));
}
function $93242f9a41d458a0$export$5b0f6292f11d1d18(e) {
    const n = $93242f9a41d458a0$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $93242f9a41d458a0$export$3425bd336a9673d8);
    if ($93242f9a41d458a0$export$7547a514ee29b9d4(n) === $93242f9a41d458a0$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.senderPublicKey, $93242f9a41d458a0$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.iv, $93242f9a41d458a0$export$49eb910ab2518105) : (0, $e8d7d54636de94dc$exports.randomBytes)($93242f9a41d458a0$var$Z), o = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $93242f9a41d458a0$export$49eb910ab2518105)).seal(r, (0, $9e7f19515ec15414$export$3004f64547af360e)(e.message, $93242f9a41d458a0$export$9560dad2a83e4f04));
    return $93242f9a41d458a0$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $93242f9a41d458a0$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $93242f9a41d458a0$export$49eb910ab2518105)), { sealed: t, iv: r } = $93242f9a41d458a0$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(o, $93242f9a41d458a0$export$9560dad2a83e4f04);
}
function $93242f9a41d458a0$export$dfdc1655ccc5b9cb(e) {
    if ($93242f9a41d458a0$export$7547a514ee29b9d4(e.type) === $93242f9a41d458a0$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $93242f9a41d458a0$export$9bff723d552e6bcf);
    }
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $93242f9a41d458a0$export$9bff723d552e6bcf);
}
function $93242f9a41d458a0$export$efcd34ab6248d3cd(e) {
    const n = (0, $9e7f19515ec15414$export$3004f64547af360e)(e, $93242f9a41d458a0$export$9bff723d552e6bcf), t = n.slice($93242f9a41d458a0$var$Dn, $93242f9a41d458a0$var$Te), r = $93242f9a41d458a0$var$Te;
    if ($93242f9a41d458a0$export$7547a514ee29b9d4(t) === $93242f9a41d458a0$export$406e97c329f0f3d4) {
        const d = r + $93242f9a41d458a0$var$X, l = d + $93242f9a41d458a0$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $93242f9a41d458a0$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $93242f9a41d458a0$export$177f3e316562333d(e, n) {
    const t = $93242f9a41d458a0$export$efcd34ab6248d3cd(e);
    return $93242f9a41d458a0$export$7949f60f2444aef2({
        type: $93242f9a41d458a0$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(t.senderPublicKey, $93242f9a41d458a0$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $93242f9a41d458a0$export$7949f60f2444aef2(e) {
    const n = e?.type || $93242f9a41d458a0$export$3425bd336a9673d8;
    if (n === $93242f9a41d458a0$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $93242f9a41d458a0$export$8c165704db2d5c15(e) {
    return e.type === $93242f9a41d458a0$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $93242f9a41d458a0$var$Bn = Object.defineProperty, $93242f9a41d458a0$var$Ue = Object.getOwnPropertySymbols, $93242f9a41d458a0$var$Gn = Object.prototype.hasOwnProperty, $93242f9a41d458a0$var$Wn = Object.prototype.propertyIsEnumerable, $93242f9a41d458a0$var$_e = (e, n, t)=>n in e ? $93242f9a41d458a0$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $93242f9a41d458a0$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$93242f9a41d458a0$var$Gn.call(n, t) && $93242f9a41d458a0$var$_e(e, t, n[t]);
    if ($93242f9a41d458a0$var$Ue) for (var t of $93242f9a41d458a0$var$Ue(n))$93242f9a41d458a0$var$Wn.call(n, t) && $93242f9a41d458a0$var$_e(e, t, n[t]);
    return e;
};
const $93242f9a41d458a0$export$f12873d77424d47b = "ReactNative", $93242f9a41d458a0$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $93242f9a41d458a0$export$657dee6d5648750a = " ", $93242f9a41d458a0$export$96c3628b3b9d2079 = ":", $93242f9a41d458a0$export$98238152dfccf046 = "/", $93242f9a41d458a0$export$7f882bb969de14a3 = 2, $93242f9a41d458a0$export$77baccb4c6bd5852 = 1e3, $93242f9a41d458a0$export$e08b61c98317d88c = "js";
function $93242f9a41d458a0$export$8ee0fc9ee280b4ee() {
    return typeof $6qd2L < "u" && typeof $6qd2L.versions < "u" && typeof $6qd2L.versions.node < "u";
}
function $93242f9a41d458a0$export$f7a1e23e542d38e3() {
    return !(0, $42fc9f31ad639091$exports.getDocument)() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && navigator.product === $93242f9a41d458a0$export$f12873d77424d47b;
}
function $93242f9a41d458a0$export$4e09c449d6c407f7() {
    return !$93242f9a41d458a0$export$8ee0fc9ee280b4ee() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && !!(0, $42fc9f31ad639091$exports.getDocument)();
}
function $93242f9a41d458a0$export$57570b1603cf6adb() {
    return $93242f9a41d458a0$export$f7a1e23e542d38e3() ? $93242f9a41d458a0$export$86b1301a63b15dd9.reactNative : $93242f9a41d458a0$export$8ee0fc9ee280b4ee() ? $93242f9a41d458a0$export$86b1301a63b15dd9.node : $93242f9a41d458a0$export$4e09c449d6c407f7() ? $93242f9a41d458a0$export$86b1301a63b15dd9.browser : $93242f9a41d458a0$export$86b1301a63b15dd9.unknown;
}
function $93242f9a41d458a0$export$40a40f90174d197c() {
    var e;
    try {
        return $93242f9a41d458a0$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $93242f9a41d458a0$export$c4147c69f6845da(e, n) {
    let t = $4466bfd994589455$export$98e6a39c04603d36(e);
    return t = $93242f9a41d458a0$var$$e($93242f9a41d458a0$var$$e({}, t), n), e = $4466bfd994589455$export$fac44ee5b035f737(t), e;
}
function $93242f9a41d458a0$export$ba31e015127122bb() {
    return (0, $b27946e0f1afb509$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $93242f9a41d458a0$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $93242f9a41d458a0$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $93242f9a41d458a0$export$20d4a3cb5829b8b6() {
    if ($93242f9a41d458a0$export$57570b1603cf6adb() === $93242f9a41d458a0$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $fc258a372ec38109$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $93242f9a41d458a0$export$4389b0987726d52d() {
    var e;
    const n = $93242f9a41d458a0$export$57570b1603cf6adb();
    return n === $93242f9a41d458a0$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $93242f9a41d458a0$export$b55a4c6e272b719f(e, n, t) {
    const r = $93242f9a41d458a0$export$20d4a3cb5829b8b6(), o = $93242f9a41d458a0$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $93242f9a41d458a0$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $93242f9a41d458a0$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $93242f9a41d458a0$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $93242f9a41d458a0$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $93242f9a41d458a0$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $93242f9a41d458a0$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $93242f9a41d458a0$export$1e21530e896c0b0b(e, n = $93242f9a41d458a0$export$7f882bb969de14a3) {
    return $93242f9a41d458a0$export$7f00885504704576(e.split($93242f9a41d458a0$export$98238152dfccf046), n);
}
function $93242f9a41d458a0$export$80bffd46c37a96f6(e) {
    return $93242f9a41d458a0$export$1e21530e896c0b0b(e).join($93242f9a41d458a0$export$657dee6d5648750a);
}
function $93242f9a41d458a0$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $93242f9a41d458a0$export$7f00885504704576(e, n = $93242f9a41d458a0$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $93242f9a41d458a0$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $93242f9a41d458a0$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $93242f9a41d458a0$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $93242f9a41d458a0$export$85c927578394b28b = (e)=>e;
function $93242f9a41d458a0$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $93242f9a41d458a0$export$9a00dee1beb8f576(e) {
    return e.split($93242f9a41d458a0$export$657dee6d5648750a).map((n)=>$93242f9a41d458a0$export$e9f8fcacef3bca4b(n)).join($93242f9a41d458a0$export$657dee6d5648750a);
}
function $93242f9a41d458a0$export$cbf9e3cc9ffc85cb(e = (0, $j5HK8.FIVE_MINUTES), n) {
    const t = (0, $j5HK8.toMiliseconds)(e || (0, $j5HK8.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $93242f9a41d458a0$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $93242f9a41d458a0$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $93242f9a41d458a0$export$43ab92477f8713b9(e) {
    return $93242f9a41d458a0$export$187ab6574b2ae23f("topic", e);
}
function $93242f9a41d458a0$export$bd13103c2e5cc0c3(e) {
    return $93242f9a41d458a0$export$187ab6574b2ae23f("id", e);
}
function $93242f9a41d458a0$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $93242f9a41d458a0$export$b136d03015bfc12(e, n) {
    return (0, $j5HK8.fromMiliseconds)((n || Date.now()) + (0, $j5HK8.toMiliseconds)(e));
}
function $93242f9a41d458a0$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $j5HK8.toMiliseconds)(e);
}
function $93242f9a41d458a0$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $93242f9a41d458a0$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $93242f9a41d458a0$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $93242f9a41d458a0$export$57570b1603cf6adb();
        i === $93242f9a41d458a0$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $93242f9a41d458a0$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $93242f9a41d458a0$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($93242f9a41d458a0$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $93242f9a41d458a0$export$822d0bd1635d5360 = "irn";
function $93242f9a41d458a0$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $93242f9a41d458a0$export$822d0bd1635d5360
    };
}
function $93242f9a41d458a0$export$604e3deb95e1b734(e) {
    const n = (0, $d06ba0a3f54ef0e1$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $93242f9a41d458a0$var$bt = Object.defineProperty, $93242f9a41d458a0$var$Nt = Object.defineProperties, $93242f9a41d458a0$var$Ot = Object.getOwnPropertyDescriptors, $93242f9a41d458a0$var$qe = Object.getOwnPropertySymbols, $93242f9a41d458a0$var$St = Object.prototype.hasOwnProperty, $93242f9a41d458a0$var$wt = Object.prototype.propertyIsEnumerable, $93242f9a41d458a0$var$Be = (e, n, t)=>n in e ? $93242f9a41d458a0$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $93242f9a41d458a0$var$It = (e, n)=>{
    for(var t in n || (n = {}))$93242f9a41d458a0$var$St.call(n, t) && $93242f9a41d458a0$var$Be(e, t, n[t]);
    if ($93242f9a41d458a0$var$qe) for (var t of $93242f9a41d458a0$var$qe(n))$93242f9a41d458a0$var$wt.call(n, t) && $93242f9a41d458a0$var$Be(e, t, n[t]);
    return e;
}, $93242f9a41d458a0$var$Tt = (e, n)=>$93242f9a41d458a0$var$Nt(e, $93242f9a41d458a0$var$Ot(n));
function $93242f9a41d458a0$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $93242f9a41d458a0$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $4466bfd994589455$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $93242f9a41d458a0$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $93242f9a41d458a0$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $93242f9a41d458a0$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $93242f9a41d458a0$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $93242f9a41d458a0$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $4466bfd994589455$export$fac44ee5b035f737($93242f9a41d458a0$var$Tt($93242f9a41d458a0$var$It({
        symKey: e.symKey
    }, $93242f9a41d458a0$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $93242f9a41d458a0$var$At = Object.defineProperty, $93242f9a41d458a0$var$Ut = Object.defineProperties, $93242f9a41d458a0$var$_t = Object.getOwnPropertyDescriptors, $93242f9a41d458a0$var$Ye = Object.getOwnPropertySymbols, $93242f9a41d458a0$var$$t = Object.prototype.hasOwnProperty, $93242f9a41d458a0$var$Ct = Object.prototype.propertyIsEnumerable, $93242f9a41d458a0$var$Je = (e, n, t)=>n in e ? $93242f9a41d458a0$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $93242f9a41d458a0$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$93242f9a41d458a0$var$$t.call(n, t) && $93242f9a41d458a0$var$Je(e, t, n[t]);
    if ($93242f9a41d458a0$var$Ye) for (var t of $93242f9a41d458a0$var$Ye(n))$93242f9a41d458a0$var$Ct.call(n, t) && $93242f9a41d458a0$var$Je(e, t, n[t]);
    return e;
}, $93242f9a41d458a0$var$Dt = (e, n)=>$93242f9a41d458a0$var$Ut(e, $93242f9a41d458a0$var$_t(n));
function $93242f9a41d458a0$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $93242f9a41d458a0$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$93242f9a41d458a0$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $93242f9a41d458a0$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $93242f9a41d458a0$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $93242f9a41d458a0$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $93242f9a41d458a0$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $93242f9a41d458a0$export$a8daa26a7c60ef90(e, n) {
    const t = $93242f9a41d458a0$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $93242f9a41d458a0$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $93242f9a41d458a0$export$2994550cda701c96(n), s = $93242f9a41d458a0$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $93242f9a41d458a0$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $93242f9a41d458a0$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $93242f9a41d458a0$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $93242f9a41d458a0$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $93242f9a41d458a0$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $93242f9a41d458a0$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $93242f9a41d458a0$export$dd404c96fbbb1ff8(e) {
    return $93242f9a41d458a0$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $93242f9a41d458a0$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$93242f9a41d458a0$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $93242f9a41d458a0$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $93242f9a41d458a0$export$dd404c96fbbb1ff8(s);
        o[u] = $93242f9a41d458a0$var$Dt($93242f9a41d458a0$var$jt({}, o[u]), {
            chains: $93242f9a41d458a0$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $93242f9a41d458a0$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $93242f9a41d458a0$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $93242f9a41d458a0$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $93242f9a41d458a0$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $93242f9a41d458a0$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $93242f9a41d458a0$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $93242f9a41d458a0$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $93242f9a41d458a0$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $93242f9a41d458a0$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $93242f9a41d458a0$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $93242f9a41d458a0$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $93242f9a41d458a0$export$ee898ca48ab56c74(e, n) {
    return n && $93242f9a41d458a0$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $93242f9a41d458a0$export$d6781b696a0576d1(e, n) {
    return n && $93242f9a41d458a0$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $93242f9a41d458a0$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $93242f9a41d458a0$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $93242f9a41d458a0$export$d46695d9c3664fe9(d), a = t[i];
        (!$93242f9a41d458a0$export$1468a49de573f7f9($93242f9a41d458a0$export$376384387cd15b27(i, a), u) || !$93242f9a41d458a0$export$1468a49de573f7f9(a.methods, l) || !$93242f9a41d458a0$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $93242f9a41d458a0$export$e544b39f0a22e47a(e) {
    return $93242f9a41d458a0$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $93242f9a41d458a0$export$49e4a5b6862e3c71(e) {
    if ($93242f9a41d458a0$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $93242f9a41d458a0$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $93242f9a41d458a0$export$bef94a5618bf18bf(e) {
    if ($93242f9a41d458a0$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $93242f9a41d458a0$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $93242f9a41d458a0$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $93242f9a41d458a0$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $93242f9a41d458a0$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $93242f9a41d458a0$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $93242f9a41d458a0$export$c12fced8176774f3(e) {
    let n = !0;
    return $93242f9a41d458a0$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$93242f9a41d458a0$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $93242f9a41d458a0$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $93242f9a41d458a0$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $93242f9a41d458a0$export$e544b39f0a22e47a(o) || (r = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $93242f9a41d458a0$export$e544b39f0a22e47a(e) || (r = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $93242f9a41d458a0$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $93242f9a41d458a0$export$df46c123d7e298ce(o, $93242f9a41d458a0$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $93242f9a41d458a0$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $93242f9a41d458a0$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $93242f9a41d458a0$export$49e4a5b6862e3c71(r) || (t = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $93242f9a41d458a0$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $93242f9a41d458a0$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $93242f9a41d458a0$export$b32541d63753af56(e, n) {
    let t = null;
    return $93242f9a41d458a0$export$c12fced8176774f3(e?.methods) ? $93242f9a41d458a0$export$c12fced8176774f3(e?.events) || (t = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $93242f9a41d458a0$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $93242f9a41d458a0$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $93242f9a41d458a0$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $93242f9a41d458a0$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $93242f9a41d458a0$export$16a0268bc22b47b0(e)) {
        const o = $93242f9a41d458a0$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $93242f9a41d458a0$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $93242f9a41d458a0$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $93242f9a41d458a0$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $93242f9a41d458a0$export$16a0268bc22b47b0(e)) {
        const r = $93242f9a41d458a0$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $93242f9a41d458a0$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $93242f9a41d458a0$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $93242f9a41d458a0$export$1b3fc298be8c9a7b(e) {
    return $93242f9a41d458a0$export$ee898ca48ab56c74(e.protocol, !0);
}
function $93242f9a41d458a0$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $93242f9a41d458a0$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $93242f9a41d458a0$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $93242f9a41d458a0$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $93242f9a41d458a0$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $93242f9a41d458a0$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$93242f9a41d458a0$export$d6781b696a0576d1(e.code, !1) || !e.message || !$93242f9a41d458a0$export$ee898ca48ab56c74(e.message, !1));
}
function $93242f9a41d458a0$export$1a2af3c017fb6d42(e) {
    return !($93242f9a41d458a0$export$fce6876652108ab(e) || !$93242f9a41d458a0$export$ee898ca48ab56c74(e.method, !1));
}
function $93242f9a41d458a0$export$1ae38cf0a848f651(e) {
    return !($93242f9a41d458a0$export$fce6876652108ab(e) || $93242f9a41d458a0$export$fce6876652108ab(e.result) && $93242f9a41d458a0$export$fce6876652108ab(e.error) || !$93242f9a41d458a0$export$d6781b696a0576d1(e.id, !1) || !$93242f9a41d458a0$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $93242f9a41d458a0$export$cbe4cdc5960cfa11(e) {
    return !($93242f9a41d458a0$export$fce6876652108ab(e) || !$93242f9a41d458a0$export$ee898ca48ab56c74(e.name, !1));
}
function $93242f9a41d458a0$export$144fc36610eb6522(e, n) {
    return !(!$93242f9a41d458a0$export$e544b39f0a22e47a(n) || !$93242f9a41d458a0$export$fb6db6038e742b14(e).includes(n));
}
function $93242f9a41d458a0$export$8db4804e3a6de711(e, n, t) {
    return $93242f9a41d458a0$export$ee898ca48ab56c74(t, !1) ? $93242f9a41d458a0$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $93242f9a41d458a0$export$df2c67ef8baad16b(e, n, t) {
    return $93242f9a41d458a0$export$ee898ca48ab56c74(t, !1) ? $93242f9a41d458a0$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $93242f9a41d458a0$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $93242f9a41d458a0$var$er(e), s = $93242f9a41d458a0$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $93242f9a41d458a0$var$pn(Object.keys(e)), c = $93242f9a41d458a0$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $93242f9a41d458a0$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $93242f9a41d458a0$export$1468a49de573f7f9(i, d) || (r = $93242f9a41d458a0$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $93242f9a41d458a0$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $93242f9a41d458a0$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($93242f9a41d458a0$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $93242f9a41d458a0$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $93242f9a41d458a0$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $93242f9a41d458a0$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $93242f9a41d458a0$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $93242f9a41d458a0$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $93242f9a41d458a0$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $93242f9a41d458a0$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $93242f9a41d458a0$export$59fba2af1ac782b(e, n) {
    return $93242f9a41d458a0$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $93242f9a41d458a0$export$53c2fd0173ad2b80() {
    const e = $93242f9a41d458a0$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $93242f9a41d458a0$export$86b1301a63b15dd9.browser:
                n($93242f9a41d458a0$export$2f147c609a999e49());
                break;
            case $93242f9a41d458a0$export$86b1301a63b15dd9.reactNative:
                n($93242f9a41d458a0$export$1444c95b1570bd12());
                break;
            case $93242f9a41d458a0$export$86b1301a63b15dd9.node:
                n($93242f9a41d458a0$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $93242f9a41d458a0$export$2f147c609a999e49() {
    return $93242f9a41d458a0$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $93242f9a41d458a0$export$1444c95b1570bd12() {
    if ($93242f9a41d458a0$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $93242f9a41d458a0$export$aec5b2d627eec500() {
    return !0;
}
function $93242f9a41d458a0$export$600a1ee4bc680996(e) {
    switch($93242f9a41d458a0$export$57570b1603cf6adb()){
        case $93242f9a41d458a0$export$86b1301a63b15dd9.browser:
            $93242f9a41d458a0$export$d32b24f18d96c5f2(e);
            break;
        case $93242f9a41d458a0$export$86b1301a63b15dd9.reactNative:
            $93242f9a41d458a0$export$904edb1c18ec91c7(e);
            break;
        case $93242f9a41d458a0$export$86b1301a63b15dd9.node:
            break;
    }
}
function $93242f9a41d458a0$export$d32b24f18d96c5f2(e) {
    !$93242f9a41d458a0$export$f7a1e23e542d38e3() && $93242f9a41d458a0$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $93242f9a41d458a0$export$904edb1c18ec91c7(e) {
    $93242f9a41d458a0$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $93242f9a41d458a0$var$ae = {};
class $93242f9a41d458a0$export$b72d712fed4d036d {
    static get(n) {
        return $93242f9a41d458a0$var$ae[n];
    }
    static set(n, t) {
        $93242f9a41d458a0$var$ae[n] = t;
    }
    static delete(n) {
        delete $93242f9a41d458a0$var$ae[n];
    }
}




var $j5HK8 = parcelRequire("j5HK8");

var $dG33B = parcelRequire("dG33B");
var $c08876b1eee09a15$exports = {};
$parcel$export($c08876b1eee09a15$exports, "parseConnectionError", function () { return $58fc83052225418b$export$f555d7d8f922e407; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcError", function () { return $c386f08588b215d9$exports.formatJsonRpcError; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcRequest", function () { return $c386f08588b215d9$exports.formatJsonRpcRequest; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcResult", function () { return $c386f08588b215d9$exports.formatJsonRpcResult; });
$parcel$export($c08876b1eee09a15$exports, "getBigIntRpcId", function () { return $c386f08588b215d9$exports.getBigIntRpcId; });
$parcel$export($c08876b1eee09a15$exports, "IJsonRpcProvider", function () { return $c386f08588b215d9$exports.IJsonRpcProvider; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcError", function () { return $c386f08588b215d9$exports.isJsonRpcError; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcRequest", function () { return $c386f08588b215d9$exports.isJsonRpcRequest; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcResponse", function () { return $c386f08588b215d9$exports.isJsonRpcResponse; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcResult", function () { return $c386f08588b215d9$exports.isJsonRpcResult; });
$parcel$export($c08876b1eee09a15$exports, "isLocalhostUrl", function () { return $c386f08588b215d9$exports.isLocalhostUrl; });
$parcel$export($c08876b1eee09a15$exports, "isReactNative", function () { return $c386f08588b215d9$exports.isReactNative; });
$parcel$export($c08876b1eee09a15$exports, "isWsUrl", function () { return $c386f08588b215d9$exports.isWsUrl; });
$parcel$export($c08876b1eee09a15$exports, "parseConnectionError", function () { return $c386f08588b215d9$exports.parseConnectionError; });
$parcel$export($c08876b1eee09a15$exports, "payloadId", function () { return $c386f08588b215d9$exports.payloadId; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcError", function () { return $bcdc9d9062e38dd6$export$9f7302ae26c3f77; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcRequest", function () { return $bcdc9d9062e38dd6$export$11d081ebb32d4398; });
$parcel$export($c08876b1eee09a15$exports, "formatJsonRpcResult", function () { return $bcdc9d9062e38dd6$export$478fdea01c2a3198; });
$parcel$export($c08876b1eee09a15$exports, "getBigIntRpcId", function () { return $bcdc9d9062e38dd6$export$799a3db5df197877; });
$parcel$export($c08876b1eee09a15$exports, "payloadId", function () { return $bcdc9d9062e38dd6$export$2f5364a5d4b80251; });
$parcel$export($c08876b1eee09a15$exports, "IJsonRpcProvider", function () { return $c23ac9387260c33f$export$46957420a688a16d; });
$parcel$export($c08876b1eee09a15$exports, "isLocalhostUrl", function () { return $4490259ce29ad5df$export$8eb4a0a481601f29; });
$parcel$export($c08876b1eee09a15$exports, "isWsUrl", function () { return $4490259ce29ad5df$export$4e4463e75eccf20c; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcError", function () { return $21d319f26b46bae4$export$5662a1047b4d1d15; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcRequest", function () { return $21d319f26b46bae4$export$f6e4034abe07d2a5; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcResponse", function () { return $21d319f26b46bae4$export$308ba927de2bcbe8; });
$parcel$export($c08876b1eee09a15$exports, "isJsonRpcResult", function () { return $21d319f26b46bae4$export$cb3d3b20e3223d77; });
const $631a0df959a9966f$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $631a0df959a9966f$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $631a0df959a9966f$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $631a0df959a9966f$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $631a0df959a9966f$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $631a0df959a9966f$export$125ebd30471ac25c = "SERVER_ERROR";
const $631a0df959a9966f$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $631a0df959a9966f$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $631a0df959a9966f$export$cca5387ab287e1ae = {
    [$631a0df959a9966f$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$631a0df959a9966f$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$631a0df959a9966f$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$631a0df959a9966f$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$631a0df959a9966f$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$631a0df959a9966f$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $631a0df959a9966f$export$d166979eca925bce = $631a0df959a9966f$export$125ebd30471ac25c;



function $58fc83052225418b$export$e463129eb4bc487f(code) {
    return code <= (0, $631a0df959a9966f$export$fff5b44b15c75f69)[0] && code >= (0, $631a0df959a9966f$export$fff5b44b15c75f69)[1];
}
function $58fc83052225418b$export$2ae0ec6393ab16c3(code) {
    return (0, $631a0df959a9966f$export$af84821b5448ca78).includes(code);
}
function $58fc83052225418b$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $58fc83052225418b$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $631a0df959a9966f$export$cca5387ab287e1ae)).includes(type)) return (0, $631a0df959a9966f$export$cca5387ab287e1ae)[0, $631a0df959a9966f$export$d166979eca925bce];
    return (0, $631a0df959a9966f$export$cca5387ab287e1ae)[type];
}
function $58fc83052225418b$export$60a3bac005957e12(code) {
    const match = Object.values((0, $631a0df959a9966f$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $631a0df959a9966f$export$cca5387ab287e1ae)[0, $631a0df959a9966f$export$d166979eca925bce];
    return match;
}
function $58fc83052225418b$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$58fc83052225418b$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($58fc83052225418b$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $58fc83052225418b$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $631a0df959a9966f$export$cca5387ab287e1ae)[0, $631a0df959a9966f$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $58fc83052225418b$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $c386f08588b215d9$exports = {};
"use strict";
Object.defineProperty($c386f08588b215d9$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $af9c818a6409426d$var$extendStatics = function(d, b) {
    $af9c818a6409426d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $af9c818a6409426d$var$extendStatics(d, b);
};
function $af9c818a6409426d$export$a8ba968b8961cb8a(d, b) {
    $af9c818a6409426d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $af9c818a6409426d$export$18ce0697a983be9b = function() {
    $af9c818a6409426d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af9c818a6409426d$export$18ce0697a983be9b.apply(this, arguments);
};
function $af9c818a6409426d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $af9c818a6409426d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $af9c818a6409426d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $af9c818a6409426d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $af9c818a6409426d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $af9c818a6409426d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $af9c818a6409426d$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $af9c818a6409426d$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $af9c818a6409426d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $af9c818a6409426d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $af9c818a6409426d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($af9c818a6409426d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $af9c818a6409426d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $af9c818a6409426d$export$10c90e4f7922046c(v) {
    return this instanceof $af9c818a6409426d$export$10c90e4f7922046c ? (this.v = v, this) : new $af9c818a6409426d$export$10c90e4f7922046c(v);
}
function $af9c818a6409426d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $af9c818a6409426d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $af9c818a6409426d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $af9c818a6409426d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $af9c818a6409426d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $af9c818a6409426d$export$19a8beecd37a4c45 === "function" ? $af9c818a6409426d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $af9c818a6409426d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $af9c818a6409426d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $af9c818a6409426d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $af9c818a6409426d$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $af9c818a6409426d$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$af9c818a6409426d$export$f33643c0debef087((parcelRequire("k6hbu")), $c386f08588b215d9$exports);

$af9c818a6409426d$export$f33643c0debef087((parcelRequire("dRcwz")), $c386f08588b215d9$exports);


const $d2e1ca3ea24ec944$export$d1694901a048d7c8 = (0, $c386f08588b215d9$exports.isNode);




function $bcdc9d9062e38dd6$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $bcdc9d9062e38dd6$export$799a3db5df197877(entropy = 6) {
    return BigInt($bcdc9d9062e38dd6$export$2f5364a5d4b80251(entropy));
}
function $bcdc9d9062e38dd6$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $bcdc9d9062e38dd6$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $bcdc9d9062e38dd6$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $bcdc9d9062e38dd6$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $bcdc9d9062e38dd6$export$5201d50a34753d71(error, data)
    };
}
function $bcdc9d9062e38dd6$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $58fc83052225418b$export$e1599abf47b5b568)((0, $631a0df959a9966f$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $58fc83052225418b$export$e1599abf47b5b568)((0, $631a0df959a9966f$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $58fc83052225418b$export$2ae0ec6393ab16c3)(error.code)) error = (0, $58fc83052225418b$export$60a3bac005957e12)(error.code);
    return error;
}


function $86a6fc14932af7dd$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $86a6fc14932af7dd$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $86a6fc14932af7dd$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $86a6fc14932af7dd$export$8e8b9bea55b56df2(route) {
    if ($86a6fc14932af7dd$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $86a6fc14932af7dd$export$2d48faaafcc8fbdc(route) {
    return !$86a6fc14932af7dd$export$c7e2040809cad2c4(route) && $86a6fc14932af7dd$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $86a6fc14932af7dd$export$be298a4710fab756(route) {
    return !$86a6fc14932af7dd$export$c7e2040809cad2c4(route) && $86a6fc14932af7dd$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $df5af7426eb9c0a7$export$ab429ec7e240e546 {
}



class $c23ac9387260c33f$export$77d426dd89724fbe extends (0, $df5af7426eb9c0a7$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $c23ac9387260c33f$export$cb916a2eed49af33 extends (0, $df5af7426eb9c0a7$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $c23ac9387260c33f$export$46957420a688a16d extends $c23ac9387260c33f$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $4490259ce29ad5df$var$HTTP_REGEX = "^https?:";
const $4490259ce29ad5df$var$WS_REGEX = "^wss?:";
function $4490259ce29ad5df$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $4490259ce29ad5df$var$matchRegexProtocol(url, regex) {
    const protocol = $4490259ce29ad5df$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $4490259ce29ad5df$export$206c3129b8bb1b4f(url) {
    return $4490259ce29ad5df$var$matchRegexProtocol(url, $4490259ce29ad5df$var$HTTP_REGEX);
}
function $4490259ce29ad5df$export$4e4463e75eccf20c(url) {
    return $4490259ce29ad5df$var$matchRegexProtocol(url, $4490259ce29ad5df$var$WS_REGEX);
}
function $4490259ce29ad5df$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $21d319f26b46bae4$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $21d319f26b46bae4$export$f6e4034abe07d2a5(payload) {
    return $21d319f26b46bae4$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $21d319f26b46bae4$export$308ba927de2bcbe8(payload) {
    return $21d319f26b46bae4$export$bf3617e9fafa893f(payload) && ($21d319f26b46bae4$export$cb3d3b20e3223d77(payload) || $21d319f26b46bae4$export$5662a1047b4d1d15(payload));
}
function $21d319f26b46bae4$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $21d319f26b46bae4$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $21d319f26b46bae4$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $ae80616f2408768a$export$da28308012bf6748 extends (0, $c23ac9387260c33f$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $dG33B.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $bcdc9d9062e38dd6$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $21d319f26b46bae4$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $21d319f26b46bae4$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $ae80616f2408768a$export$2e2bcd8739ae039 = $ae80616f2408768a$export$da28308012bf6748;


var $7ca3cf65fb45a3ec$export$2e2bcd8739ae039 = (0, $ae80616f2408768a$export$2e2bcd8739ae039);




var $dG33B = parcelRequire("dG33B");



const $3ac19b0a42a82fe7$var$w = ()=>typeof WebSocket < "u" ? WebSocket : typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" ? $parcel$global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : (parcelRequire("gO9pH")), $3ac19b0a42a82fe7$var$b = ()=>typeof WebSocket < "u" || typeof $parcel$global < "u" && typeof $parcel$global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", $3ac19b0a42a82fe7$var$a = (c)=>c.split("?")[0], $3ac19b0a42a82fe7$var$h = 10, $3ac19b0a42a82fe7$var$S = $3ac19b0a42a82fe7$var$w();
class $3ac19b0a42a82fe7$export$ea0df116fa892998 {
    constructor(e){
        if (this.url = e, this.events = new (0, $dG33B.EventEmitter), this.registering = !1, !(0, $4490259ce29ad5df$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        this.url = e;
    }
    get connected() {
        return typeof this.socket < "u";
    }
    get connecting() {
        return this.registering;
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async open(e = this.url) {
        await this.register(e);
    }
    async close() {
        return new Promise((e, t)=>{
            if (typeof this.socket > "u") {
                t(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (n)=>{
                this.onClose(n), e();
            }, this.socket.close();
        });
    }
    async send(e) {
        typeof this.socket > "u" && (this.socket = await this.register());
        try {
            this.socket.send((0, $88b153d3a15ebfc6$export$abc3f407e87918a4)(e));
        } catch (t) {
            this.onError(e.id, t);
        }
    }
    register(e = this.url) {
        if (!(0, $4490259ce29ad5df$export$4e4463e75eccf20c)(e)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
        if (this.registering) {
            const t = this.events.getMaxListeners();
            return (this.events.listenerCount("register_error") >= t || this.events.listenerCount("open") >= t) && this.events.setMaxListeners(t + 1), new Promise((n, o)=>{
                this.events.once("register_error", (s)=>{
                    this.resetMaxListeners(), o(s);
                }), this.events.once("open", ()=>{
                    if (this.resetMaxListeners(), typeof this.socket > "u") return o(new Error("WebSocket connection is missing or invalid"));
                    n(this.socket);
                });
            });
        }
        return this.url = e, this.registering = !0, new Promise((t, n)=>{
            const o = new URLSearchParams(e).get("origin"), s = (0, $c386f08588b215d9$exports.isReactNative)() ? {
                headers: {
                    origin: o
                }
            } : {
                rejectUnauthorized: !(0, $4490259ce29ad5df$export$8eb4a0a481601f29)(e)
            }, i = new $3ac19b0a42a82fe7$var$S(e, [], s);
            $3ac19b0a42a82fe7$var$b() ? i.onerror = (r)=>{
                const l = r;
                n(this.emitError(l.error));
            } : i.on("error", (r)=>{
                n(this.emitError(r));
            }), i.onopen = ()=>{
                this.onOpen(i), t(i);
            };
        });
    }
    onOpen(e) {
        e.onmessage = (t)=>this.onPayload(t), e.onclose = (t)=>this.onClose(t), this.socket = e, this.registering = !1, this.events.emit("open");
    }
    onClose(e) {
        this.socket = void 0, this.registering = !1, this.events.emit("close", e);
    }
    onPayload(e) {
        if (typeof e.data > "u") return;
        const t = typeof e.data == "string" ? (0, $88b153d3a15ebfc6$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", t);
    }
    onError(e, t) {
        const n = this.parseError(t), o = n.message || n.toString(), s = (0, $bcdc9d9062e38dd6$export$9f7302ae26c3f77)(e, o);
        this.events.emit("payload", s);
    }
    parseError(e, t = this.url) {
        return (0, $58fc83052225418b$export$f555d7d8f922e407)(e, $3ac19b0a42a82fe7$var$a(t), "WS");
    }
    resetMaxListeners() {
        this.events.getMaxListeners() > $3ac19b0a42a82fe7$var$h && this.events.setMaxListeners($3ac19b0a42a82fe7$var$h);
    }
    emitError(e) {
        const t = this.parseError(new Error(e?.message || `WebSocket connection failed for host: ${$3ac19b0a42a82fe7$var$a(this.url)}`));
        return this.events.emit("register_error", t), t;
    }
}



var $1ABol = parcelRequire("1ABol");
var $46caeba641ae9a9e$exports = {};


$46caeba641ae9a9e$exports = self.fetch || (self.fetch = (parcelRequire("bAcE3")).default || (parcelRequire("bAcE3")));


function $7cf2ddfb76fcdbf7$var$Hi(n, e) {
    if (n.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < n.length; s++){
        var r = n.charAt(s), o = r.charCodeAt(0);
        if (t[o] !== 255) throw new TypeError(r + " is ambiguous");
        t[o] = s;
    }
    var a = n.length, h = n.charAt(0), l = Math.log(a) / Math.log(256), d = Math.log(256) / Math.log(a);
    function p(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var m = 0, z = 0, I = 0, _ = u.length; I !== _ && u[I] === 0;)I++, m++;
        for(var T = (_ - I) * d + 1 >>> 0, f = new Uint8Array(T); I !== _;){
            for(var S = u[I], A = 0, C = T - 1; (S !== 0 || A < z) && C !== -1; C--, A++)S += 256 * f[C] >>> 0, f[C] = S % a >>> 0, S = S / a >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            z = A, I++;
        }
        for(var x = T - z; x !== T && f[x] === 0;)x++;
        for(var j = h.repeat(m); x < T; ++x)j += n.charAt(f[x]);
        return j;
    }
    function y(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var m = 0;
        if (u[m] !== " ") {
            for(var z = 0, I = 0; u[m] === h;)z++, m++;
            for(var _ = (u.length - m) * l + 1 >>> 0, T = new Uint8Array(_); u[m];){
                var f = t[u.charCodeAt(m)];
                if (f === 255) return;
                for(var S = 0, A = _ - 1; (f !== 0 || S < I) && A !== -1; A--, S++)f += a * T[A] >>> 0, T[A] = f % 256 >>> 0, f = f / 256 >>> 0;
                if (f !== 0) throw new Error("Non-zero carry");
                I = S, m++;
            }
            if (u[m] !== " ") {
                for(var C = _ - I; C !== _ && T[C] === 0;)C++;
                for(var x = new Uint8Array(z + (_ - C)), j = z; C !== _;)x[j++] = T[C++];
                return x;
            }
        }
    }
    function M(u) {
        var m = y(u);
        if (m) return m;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: p,
        decodeUnsafe: y,
        decode: M
    };
}
var $7cf2ddfb76fcdbf7$var$Ji = $7cf2ddfb76fcdbf7$var$Hi, $7cf2ddfb76fcdbf7$var$Xi = $7cf2ddfb76fcdbf7$var$Ji;
const $7cf2ddfb76fcdbf7$var$Ne = (n)=>{
    if (n instanceof Uint8Array && n.constructor.name === "Uint8Array") return n;
    if (n instanceof ArrayBuffer) return new Uint8Array(n);
    if (ArrayBuffer.isView(n)) return new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $7cf2ddfb76fcdbf7$var$Wi = (n)=>new TextEncoder().encode(n), $7cf2ddfb76fcdbf7$var$Qi = (n)=>new TextDecoder().decode(n);
class $7cf2ddfb76fcdbf7$var$Zi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $7cf2ddfb76fcdbf7$var$es {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $7cf2ddfb76fcdbf7$var$Ue(this, e);
    }
}
class $7cf2ddfb76fcdbf7$var$ts {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $7cf2ddfb76fcdbf7$var$Ue(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $7cf2ddfb76fcdbf7$var$Ue = (n, e)=>new $7cf2ddfb76fcdbf7$var$ts({
        ...n.decoders || {
            [n.prefix]: n
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $7cf2ddfb76fcdbf7$var$is {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $7cf2ddfb76fcdbf7$var$Zi(e, t, i), this.decoder = new $7cf2ddfb76fcdbf7$var$es(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $7cf2ddfb76fcdbf7$var$W = ({ name: n, prefix: e, encode: t, decode: i })=>new $7cf2ddfb76fcdbf7$var$is(n, e, t, i), $7cf2ddfb76fcdbf7$var$B = ({ prefix: n, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $7cf2ddfb76fcdbf7$var$Xi(t, e);
    return $7cf2ddfb76fcdbf7$var$W({
        prefix: n,
        name: e,
        encode: i,
        decode: (r)=>$7cf2ddfb76fcdbf7$var$Ne(s(r))
    });
}, $7cf2ddfb76fcdbf7$var$ss = (n, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let r = n.length;
    for(; n[r - 1] === "=";)--r;
    const o = new Uint8Array(r * t / 8 | 0);
    let a = 0, h = 0, l = 0;
    for(let d = 0; d < r; ++d){
        const p = s[n[d]];
        if (p === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | p, a += t, a >= 8 && (a -= 8, o[l++] = 255 & h >> a);
    }
    if (a >= t || 255 & h << 8 - a) throw new SyntaxError("Unexpected end of data");
    return o;
}, $7cf2ddfb76fcdbf7$var$rs = (n, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let r = "", o = 0, a = 0;
    for(let h = 0; h < n.length; ++h)for(a = a << 8 | n[h], o += 8; o > t;)o -= t, r += e[s & a >> o];
    if (o && (r += e[s & a << t - o]), i) for(; r.length * t & 7;)r += "=";
    return r;
}, $7cf2ddfb76fcdbf7$var$g = ({ name: n, prefix: e, bitsPerChar: t, alphabet: i })=>$7cf2ddfb76fcdbf7$var$W({
        prefix: e,
        name: n,
        encode (s) {
            return $7cf2ddfb76fcdbf7$var$rs(s, i, t);
        },
        decode (s) {
            return $7cf2ddfb76fcdbf7$var$ss(s, i, t, n);
        }
    }), $7cf2ddfb76fcdbf7$var$ns = $7cf2ddfb76fcdbf7$var$W({
    prefix: "\0",
    name: "identity",
    encode: (n)=>$7cf2ddfb76fcdbf7$var$Qi(n),
    decode: (n)=>$7cf2ddfb76fcdbf7$var$Wi(n)
});
var $7cf2ddfb76fcdbf7$var$os = Object.freeze({
    __proto__: null,
    identity: $7cf2ddfb76fcdbf7$var$ns
});
const $7cf2ddfb76fcdbf7$var$as = $7cf2ddfb76fcdbf7$var$g({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $7cf2ddfb76fcdbf7$var$hs = Object.freeze({
    __proto__: null,
    base2: $7cf2ddfb76fcdbf7$var$as
});
const $7cf2ddfb76fcdbf7$var$cs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $7cf2ddfb76fcdbf7$var$us = Object.freeze({
    __proto__: null,
    base8: $7cf2ddfb76fcdbf7$var$cs
});
const $7cf2ddfb76fcdbf7$var$ls = $7cf2ddfb76fcdbf7$var$B({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $7cf2ddfb76fcdbf7$var$ds = Object.freeze({
    __proto__: null,
    base10: $7cf2ddfb76fcdbf7$var$ls
});
const $7cf2ddfb76fcdbf7$var$gs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $7cf2ddfb76fcdbf7$var$ps = $7cf2ddfb76fcdbf7$var$g({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $7cf2ddfb76fcdbf7$var$Ds = Object.freeze({
    __proto__: null,
    base16: $7cf2ddfb76fcdbf7$var$gs,
    base16upper: $7cf2ddfb76fcdbf7$var$ps
});
const $7cf2ddfb76fcdbf7$var$ys = $7cf2ddfb76fcdbf7$var$g({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$ms = $7cf2ddfb76fcdbf7$var$g({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$bs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$fs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$Es = $7cf2ddfb76fcdbf7$var$g({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$ws = $7cf2ddfb76fcdbf7$var$g({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$vs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$Is = $7cf2ddfb76fcdbf7$var$g({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $7cf2ddfb76fcdbf7$var$Cs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $7cf2ddfb76fcdbf7$var$Rs = Object.freeze({
    __proto__: null,
    base32: $7cf2ddfb76fcdbf7$var$ys,
    base32upper: $7cf2ddfb76fcdbf7$var$ms,
    base32pad: $7cf2ddfb76fcdbf7$var$bs,
    base32padupper: $7cf2ddfb76fcdbf7$var$fs,
    base32hex: $7cf2ddfb76fcdbf7$var$Es,
    base32hexupper: $7cf2ddfb76fcdbf7$var$ws,
    base32hexpad: $7cf2ddfb76fcdbf7$var$vs,
    base32hexpadupper: $7cf2ddfb76fcdbf7$var$Is,
    base32z: $7cf2ddfb76fcdbf7$var$Cs
});
const $7cf2ddfb76fcdbf7$var$_s = $7cf2ddfb76fcdbf7$var$B({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $7cf2ddfb76fcdbf7$var$Ts = $7cf2ddfb76fcdbf7$var$B({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $7cf2ddfb76fcdbf7$var$Ss = Object.freeze({
    __proto__: null,
    base36: $7cf2ddfb76fcdbf7$var$_s,
    base36upper: $7cf2ddfb76fcdbf7$var$Ts
});
const $7cf2ddfb76fcdbf7$var$Ps = $7cf2ddfb76fcdbf7$var$B({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $7cf2ddfb76fcdbf7$var$xs = $7cf2ddfb76fcdbf7$var$B({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $7cf2ddfb76fcdbf7$var$Os = Object.freeze({
    __proto__: null,
    base58btc: $7cf2ddfb76fcdbf7$var$Ps,
    base58flickr: $7cf2ddfb76fcdbf7$var$xs
});
const $7cf2ddfb76fcdbf7$var$As = $7cf2ddfb76fcdbf7$var$g({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $7cf2ddfb76fcdbf7$var$zs = $7cf2ddfb76fcdbf7$var$g({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $7cf2ddfb76fcdbf7$var$Ns = $7cf2ddfb76fcdbf7$var$g({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $7cf2ddfb76fcdbf7$var$Us = $7cf2ddfb76fcdbf7$var$g({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $7cf2ddfb76fcdbf7$var$Ls = Object.freeze({
    __proto__: null,
    base64: $7cf2ddfb76fcdbf7$var$As,
    base64pad: $7cf2ddfb76fcdbf7$var$zs,
    base64url: $7cf2ddfb76fcdbf7$var$Ns,
    base64urlpad: $7cf2ddfb76fcdbf7$var$Us
});
const $7cf2ddfb76fcdbf7$var$Le = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $7cf2ddfb76fcdbf7$var$$s = $7cf2ddfb76fcdbf7$var$Le.reduce((n, e, t)=>(n[t] = e, n), []), $7cf2ddfb76fcdbf7$var$Fs = $7cf2ddfb76fcdbf7$var$Le.reduce((n, e, t)=>(n[e.codePointAt(0)] = t, n), []);
function $7cf2ddfb76fcdbf7$var$Ms(n) {
    return n.reduce((e, t)=>(e += $7cf2ddfb76fcdbf7$var$$s[t], e), "");
}
function $7cf2ddfb76fcdbf7$var$ks(n) {
    const e = [];
    for (const t of n){
        const i = $7cf2ddfb76fcdbf7$var$Fs[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $7cf2ddfb76fcdbf7$var$Ks = $7cf2ddfb76fcdbf7$var$W({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $7cf2ddfb76fcdbf7$var$Ms,
    decode: $7cf2ddfb76fcdbf7$var$ks
});
var $7cf2ddfb76fcdbf7$var$Bs = Object.freeze({
    __proto__: null,
    base256emoji: $7cf2ddfb76fcdbf7$var$Ks
}), $7cf2ddfb76fcdbf7$var$Vs = $7cf2ddfb76fcdbf7$var$Fe, $7cf2ddfb76fcdbf7$var$$e = 128, $7cf2ddfb76fcdbf7$var$qs = 127, $7cf2ddfb76fcdbf7$var$js = ~$7cf2ddfb76fcdbf7$var$qs, $7cf2ddfb76fcdbf7$var$Gs = Math.pow(2, 31);
function $7cf2ddfb76fcdbf7$var$Fe(n, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; n >= $7cf2ddfb76fcdbf7$var$Gs;)e[t++] = n & 255 | $7cf2ddfb76fcdbf7$var$$e, n /= 128;
    for(; n & $7cf2ddfb76fcdbf7$var$js;)e[t++] = n & 255 | $7cf2ddfb76fcdbf7$var$$e, n >>>= 7;
    return e[t] = n | 0, $7cf2ddfb76fcdbf7$var$Fe.bytes = t - i + 1, e;
}
var $7cf2ddfb76fcdbf7$var$Ys = $7cf2ddfb76fcdbf7$var$he, $7cf2ddfb76fcdbf7$var$Hs = 128, $7cf2ddfb76fcdbf7$var$Me = 127;
function $7cf2ddfb76fcdbf7$var$he(n, i) {
    var t = 0, i = i || 0, s = 0, r = i, o, a = n.length;
    do {
        if (r >= a) throw $7cf2ddfb76fcdbf7$var$he.bytes = 0, new RangeError("Could not decode varint");
        o = n[r++], t += s < 28 ? (o & $7cf2ddfb76fcdbf7$var$Me) << s : (o & $7cf2ddfb76fcdbf7$var$Me) * Math.pow(2, s), s += 7;
    }while (o >= $7cf2ddfb76fcdbf7$var$Hs);
    return $7cf2ddfb76fcdbf7$var$he.bytes = r - i, t;
}
var $7cf2ddfb76fcdbf7$var$Js = Math.pow(2, 7), $7cf2ddfb76fcdbf7$var$Xs = Math.pow(2, 14), $7cf2ddfb76fcdbf7$var$Ws = Math.pow(2, 21), $7cf2ddfb76fcdbf7$var$Qs = Math.pow(2, 28), $7cf2ddfb76fcdbf7$var$Zs = Math.pow(2, 35), $7cf2ddfb76fcdbf7$var$er = Math.pow(2, 42), $7cf2ddfb76fcdbf7$var$tr = Math.pow(2, 49), $7cf2ddfb76fcdbf7$var$ir = Math.pow(2, 56), $7cf2ddfb76fcdbf7$var$sr = Math.pow(2, 63), $7cf2ddfb76fcdbf7$var$rr = function(n) {
    return n < $7cf2ddfb76fcdbf7$var$Js ? 1 : n < $7cf2ddfb76fcdbf7$var$Xs ? 2 : n < $7cf2ddfb76fcdbf7$var$Ws ? 3 : n < $7cf2ddfb76fcdbf7$var$Qs ? 4 : n < $7cf2ddfb76fcdbf7$var$Zs ? 5 : n < $7cf2ddfb76fcdbf7$var$er ? 6 : n < $7cf2ddfb76fcdbf7$var$tr ? 7 : n < $7cf2ddfb76fcdbf7$var$ir ? 8 : n < $7cf2ddfb76fcdbf7$var$sr ? 9 : 10;
}, $7cf2ddfb76fcdbf7$var$nr = {
    encode: $7cf2ddfb76fcdbf7$var$Vs,
    decode: $7cf2ddfb76fcdbf7$var$Ys,
    encodingLength: $7cf2ddfb76fcdbf7$var$rr
}, $7cf2ddfb76fcdbf7$var$ke = $7cf2ddfb76fcdbf7$var$nr;
const $7cf2ddfb76fcdbf7$var$Ke = (n, e, t = 0)=>($7cf2ddfb76fcdbf7$var$ke.encode(n, e, t), e), $7cf2ddfb76fcdbf7$var$Be = (n)=>$7cf2ddfb76fcdbf7$var$ke.encodingLength(n), $7cf2ddfb76fcdbf7$var$ce = (n, e)=>{
    const t = e.byteLength, i = $7cf2ddfb76fcdbf7$var$Be(n), s = i + $7cf2ddfb76fcdbf7$var$Be(t), r = new Uint8Array(s + t);
    return $7cf2ddfb76fcdbf7$var$Ke(n, r, 0), $7cf2ddfb76fcdbf7$var$Ke(t, r, i), r.set(e, s), new $7cf2ddfb76fcdbf7$var$or(n, t, e, r);
};
class $7cf2ddfb76fcdbf7$var$or {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $7cf2ddfb76fcdbf7$var$Ve = ({ name: n, code: e, encode: t })=>new $7cf2ddfb76fcdbf7$var$ar(n, e, t);
class $7cf2ddfb76fcdbf7$var$ar {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $7cf2ddfb76fcdbf7$var$ce(this.code, t) : t.then((i)=>$7cf2ddfb76fcdbf7$var$ce(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $7cf2ddfb76fcdbf7$var$qe = (n)=>async (e)=>new Uint8Array(await crypto.subtle.digest(n, e)), $7cf2ddfb76fcdbf7$var$hr = $7cf2ddfb76fcdbf7$var$Ve({
    name: "sha2-256",
    code: 18,
    encode: $7cf2ddfb76fcdbf7$var$qe("SHA-256")
}), $7cf2ddfb76fcdbf7$var$cr = $7cf2ddfb76fcdbf7$var$Ve({
    name: "sha2-512",
    code: 19,
    encode: $7cf2ddfb76fcdbf7$var$qe("SHA-512")
});
var $7cf2ddfb76fcdbf7$var$ur = Object.freeze({
    __proto__: null,
    sha256: $7cf2ddfb76fcdbf7$var$hr,
    sha512: $7cf2ddfb76fcdbf7$var$cr
});
const $7cf2ddfb76fcdbf7$var$je = 0, $7cf2ddfb76fcdbf7$var$lr = "identity", $7cf2ddfb76fcdbf7$var$Ge = $7cf2ddfb76fcdbf7$var$Ne, $7cf2ddfb76fcdbf7$var$dr = (n)=>$7cf2ddfb76fcdbf7$var$ce($7cf2ddfb76fcdbf7$var$je, $7cf2ddfb76fcdbf7$var$Ge(n)), $7cf2ddfb76fcdbf7$var$gr = {
    code: $7cf2ddfb76fcdbf7$var$je,
    name: $7cf2ddfb76fcdbf7$var$lr,
    encode: $7cf2ddfb76fcdbf7$var$Ge,
    digest: $7cf2ddfb76fcdbf7$var$dr
};
var $7cf2ddfb76fcdbf7$var$pr = Object.freeze({
    __proto__: null,
    identity: $7cf2ddfb76fcdbf7$var$gr
});
new TextEncoder, new TextDecoder;
const $7cf2ddfb76fcdbf7$var$Ye = {
    ...$7cf2ddfb76fcdbf7$var$os,
    ...$7cf2ddfb76fcdbf7$var$hs,
    ...$7cf2ddfb76fcdbf7$var$us,
    ...$7cf2ddfb76fcdbf7$var$ds,
    ...$7cf2ddfb76fcdbf7$var$Ds,
    ...$7cf2ddfb76fcdbf7$var$Rs,
    ...$7cf2ddfb76fcdbf7$var$Ss,
    ...$7cf2ddfb76fcdbf7$var$Os,
    ...$7cf2ddfb76fcdbf7$var$Ls,
    ...$7cf2ddfb76fcdbf7$var$Bs
};
({
    ...$7cf2ddfb76fcdbf7$var$ur,
    ...$7cf2ddfb76fcdbf7$var$pr
});
function $7cf2ddfb76fcdbf7$var$He(n) {
    return globalThis.Buffer != null ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : n;
}
function $7cf2ddfb76fcdbf7$var$Dr(n = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $7cf2ddfb76fcdbf7$var$He(globalThis.Buffer.allocUnsafe(n)) : new Uint8Array(n);
}
function $7cf2ddfb76fcdbf7$var$Je(n, e, t, i) {
    return {
        name: n,
        prefix: e,
        encoder: {
            name: n,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $7cf2ddfb76fcdbf7$var$Xe = $7cf2ddfb76fcdbf7$var$Je("utf8", "u", (n)=>"u" + new TextDecoder("utf8").decode(n), (n)=>new TextEncoder().encode(n.substring(1))), $7cf2ddfb76fcdbf7$var$ue = $7cf2ddfb76fcdbf7$var$Je("ascii", "a", (n)=>{
    let e = "a";
    for(let t = 0; t < n.length; t++)e += String.fromCharCode(n[t]);
    return e;
}, (n)=>{
    n = n.substring(1);
    const e = $7cf2ddfb76fcdbf7$var$Dr(n.length);
    for(let t = 0; t < n.length; t++)e[t] = n.charCodeAt(t);
    return e;
}), $7cf2ddfb76fcdbf7$var$yr = {
    utf8: $7cf2ddfb76fcdbf7$var$Xe,
    "utf-8": $7cf2ddfb76fcdbf7$var$Xe,
    hex: $7cf2ddfb76fcdbf7$var$Ye.base16,
    latin1: $7cf2ddfb76fcdbf7$var$ue,
    ascii: $7cf2ddfb76fcdbf7$var$ue,
    binary: $7cf2ddfb76fcdbf7$var$ue,
    ...$7cf2ddfb76fcdbf7$var$Ye
};
function $7cf2ddfb76fcdbf7$var$mr(n, e = "utf8") {
    const t = $7cf2ddfb76fcdbf7$var$yr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $7cf2ddfb76fcdbf7$var$He(globalThis.Buffer.from(n, "utf-8")) : t.decoder.decode(`${t.prefix}${n}`);
}
const $7cf2ddfb76fcdbf7$export$51b1c900ac262bdf = "wc", $7cf2ddfb76fcdbf7$export$f30bd3c8747cdfbe = 2, $7cf2ddfb76fcdbf7$export$d47601f9de5ee22b = "core", $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545 = `${$7cf2ddfb76fcdbf7$export$51b1c900ac262bdf}@2:${$7cf2ddfb76fcdbf7$export$d47601f9de5ee22b}:`, $7cf2ddfb76fcdbf7$export$db0fdb6d486555c2 = {
    name: $7cf2ddfb76fcdbf7$export$d47601f9de5ee22b,
    logger: "error"
}, $7cf2ddfb76fcdbf7$export$ba920abfe854b85d = {
    database: ":memory:"
}, $7cf2ddfb76fcdbf7$export$92a79f21481c803d = "crypto", $7cf2ddfb76fcdbf7$export$3613aa6e652146e4 = "client_ed25519_seed", $7cf2ddfb76fcdbf7$export$c4bc5e31a4d0ec78 = (0, $j5HK8.ONE_DAY), $7cf2ddfb76fcdbf7$export$9d7218f72e8dc49b = "keychain", $7cf2ddfb76fcdbf7$export$34f82f4ba0c3d769 = "0.3", $7cf2ddfb76fcdbf7$export$9662bbc7d10cf481 = "messages", $7cf2ddfb76fcdbf7$export$19dfd1896412c038 = "0.3", $7cf2ddfb76fcdbf7$export$8ddbe6611b67d926 = (0, $j5HK8.SIX_HOURS), $7cf2ddfb76fcdbf7$export$9d92662178f2abd1 = "publisher", $7cf2ddfb76fcdbf7$export$822d0bd1635d5360 = "irn", $7cf2ddfb76fcdbf7$export$5176ffa6778d6637 = "error", $7cf2ddfb76fcdbf7$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $7cf2ddfb76fcdbf7$export$27fee22bec112637 = "wss://relay.walletconnect.org", $7cf2ddfb76fcdbf7$export$602d6e27611c3fcb = "relayer", $7cf2ddfb76fcdbf7$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $7cf2ddfb76fcdbf7$export$119b4645f6b233c8 = "_subscription", $7cf2ddfb76fcdbf7$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $7cf2ddfb76fcdbf7$export$11ccd39be2c57d6 = (0, $j5HK8.ONE_SECOND), $7cf2ddfb76fcdbf7$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $7cf2ddfb76fcdbf7$export$5f30917a6f8c9025 = "2.11.2", $7cf2ddfb76fcdbf7$export$fb3eab7adf12329d = 1e4, $7cf2ddfb76fcdbf7$export$629a342182ba24b = "0.3", $7cf2ddfb76fcdbf7$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $7cf2ddfb76fcdbf7$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $7cf2ddfb76fcdbf7$export$9d35d0a6a3599be = (0, $j5HK8.THIRTY_DAYS), $7cf2ddfb76fcdbf7$export$9c3a96bb670cddb8 = "subscription", $7cf2ddfb76fcdbf7$export$fb57e03bef4c4cea = "0.3", $7cf2ddfb76fcdbf7$export$9a2ddbfe54f8af77 = (0, $j5HK8.FIVE_SECONDS) * 1e3, $7cf2ddfb76fcdbf7$export$390360ea476c6145 = "pairing", $7cf2ddfb76fcdbf7$export$5593ec74b27d1b18 = "0.3", $7cf2ddfb76fcdbf7$export$ee4b1978d0aedfad = (0, $j5HK8.THIRTY_DAYS), $7cf2ddfb76fcdbf7$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $j5HK8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $j5HK8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75 = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, $7cf2ddfb76fcdbf7$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $7cf2ddfb76fcdbf7$export$160142c73cb99dc3 = "history", $7cf2ddfb76fcdbf7$export$8eba9ce85616c607 = "0.3", $7cf2ddfb76fcdbf7$export$4ddf883392bbc828 = "expirer", $7cf2ddfb76fcdbf7$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $7cf2ddfb76fcdbf7$export$717295846191925d = "0.3", $7cf2ddfb76fcdbf7$export$3cfe73d6765db74 = (0, $j5HK8.ONE_DAY), $7cf2ddfb76fcdbf7$export$3b58f2450f2297e3 = "verify-api", $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com", $7cf2ddfb76fcdbf7$export$4fe83ee8f9aec7b6 = "https://verify.walletconnect.org", $7cf2ddfb76fcdbf7$export$be24df03c4baa778 = [
    $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa,
    $7cf2ddfb76fcdbf7$export$4fe83ee8f9aec7b6
], $7cf2ddfb76fcdbf7$export$40c022d2cffe0adc = "echo", $7cf2ddfb76fcdbf7$export$3c48c4faab79aab1 = "https://echo.walletconnect.com";
class $7cf2ddfb76fcdbf7$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $7cf2ddfb76fcdbf7$export$9d7218f72e8dc49b, this.version = $7cf2ddfb76fcdbf7$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: r } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(r);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $93242f9a41d458a0$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $93242f9a41d458a0$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $7cf2ddfb76fcdbf7$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), r = $bf3d2d04ac30a374$export$a949d36eab55b41f(s);
            return $b19a768c56f4badd$export$1b29ef9371459e10(r.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $93242f9a41d458a0$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const r = await this.getClientSeed(), o = $bf3d2d04ac30a374$export$a949d36eab55b41f(r), a = (0, $93242f9a41d458a0$export$d15a28e4f1821243)(), h = $7cf2ddfb76fcdbf7$export$c4bc5e31a4d0ec78;
            return await $bf3d2d04ac30a374$export$a8dda30659d36d45(a, s, h, o);
        }, this.generateSharedKey = (s, r, o)=>{
            this.isInitialized();
            const a = this.getPrivateKey(s), h = (0, $93242f9a41d458a0$export$f8378f68e053f5c6)(a, r);
            return this.setSymKey(h, o);
        }, this.setSymKey = async (s, r)=>{
            this.isInitialized();
            const o = r || (0, $93242f9a41d458a0$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(o, s), o;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $93242f9a41d458a0$export$7949f60f2444aef2)(o), h = (0, $88b153d3a15ebfc6$export$abc3f407e87918a4)(r);
            if ((0, $93242f9a41d458a0$export$8c165704db2d5c15)(a)) {
                const y = a.senderPublicKey, M = a.receiverPublicKey;
                s = await this.generateSharedKey(y, M);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: p } = a;
            return (0, $93242f9a41d458a0$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: p
            });
        }, this.decode = async (s, r, o)=>{
            this.isInitialized();
            const a = (0, $93242f9a41d458a0$export$177f3e316562333d)(r, o);
            if ((0, $93242f9a41d458a0$export$8c165704db2d5c15)(a)) {
                const h = a.receiverPublicKey, l = a.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $93242f9a41d458a0$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: r
                });
                return (0, $88b153d3a15ebfc6$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const r = (0, $93242f9a41d458a0$export$efcd34ab6248d3cd)(s);
            return (0, $93242f9a41d458a0$export$7547a514ee29b9d4)(r.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const r = (0, $93242f9a41d458a0$export$efcd34ab6248d3cd)(s);
            return r.senderPublicKey ? (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(r.senderPublicKey, (0, $93242f9a41d458a0$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.keychain = i || new $7cf2ddfb76fcdbf7$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($7cf2ddfb76fcdbf7$export$3613aa6e652146e4);
        } catch  {
            e = (0, $93242f9a41d458a0$export$d15a28e4f1821243)(), await this.keychain.set($7cf2ddfb76fcdbf7$export$3613aa6e652146e4, e);
        }
        return $7cf2ddfb76fcdbf7$var$mr(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$export$4a2542d0790ac2fd extends (0, $8d964f47298418e8$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $7cf2ddfb76fcdbf7$export$9662bbc7d10cf481, this.version = $7cf2ddfb76fcdbf7$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const r = (0, $93242f9a41d458a0$export$d4c241cec96564c1)(s);
            let o = this.messages.get(i);
            return typeof o > "u" && (o = {}), typeof o[r] < "u" || (o[r] = s, this.messages.set(i, o), await this.persist()), r;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const r = this.get(i), o = (0, $93242f9a41d458a0$export$d4c241cec96564c1)(s);
            return typeof r[o] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $93242f9a41d458a0$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $93242f9a41d458a0$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$var$vr extends (0, $8d964f47298418e8$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $dG33B.EventEmitter), this.name = $7cf2ddfb76fcdbf7$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $j5HK8.toMiliseconds)((0, $j5HK8.TEN_SECONDS) * 2), this.needsTransportRestart = !1, this.publish = async (i, s, r)=>{
            var o;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: r
                }
            });
            try {
                const a = r?.ttl || $7cf2ddfb76fcdbf7$export$8ddbe6611b67d926, h = (0, $93242f9a41d458a0$export$cf77af25151525db)(r), l = r?.prompt || !1, d = r?.tag || 0, p = r?.id || (0, $bcdc9d9062e38dd6$export$799a3db5df197877)().toString(), y = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: a,
                        relay: h,
                        prompt: l,
                        tag: d,
                        id: p
                    }
                }, M = setTimeout(()=>this.queue.set(p, y), this.publishTimeout);
                try {
                    await await (0, $93242f9a41d458a0$export$3da2293b007ed708)(this.rpcPublish(i, s, a, h, l, d, p), this.publishTimeout, `Failed to publish payload, please try again. id:${p} tag:${d}`), this.removeRequestFromQueue(p), this.relayer.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.publish, y);
                } catch (u) {
                    if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (o = r?.internal) != null && o.throwOnFailedPublish) throw this.removeRequestFromQueue(p), u;
                    return;
                } finally{
                    clearTimeout(M);
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: r
                    }
                });
            } catch (a) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(a), a;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, r, o, a) {
        var h, l, d, p;
        const y = {
            method: (0, $93242f9a41d458a0$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: r,
                tag: o
            },
            id: a
        };
        return (0, $93242f9a41d458a0$export$fce6876652108ab)((h = y.params) == null ? void 0 : h.prompt) && ((l = y.params) == null || delete l.prompt), (0, $93242f9a41d458a0$export$fce6876652108ab)((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $75808f0aedbf25ac$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($7cf2ddfb76fcdbf7$export$d56245796e2837d.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class $7cf2ddfb76fcdbf7$var$Ir {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((r)=>r !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $7cf2ddfb76fcdbf7$var$Cr = Object.defineProperty, $7cf2ddfb76fcdbf7$var$Rr = Object.defineProperties, $7cf2ddfb76fcdbf7$var$_r = Object.getOwnPropertyDescriptors, $7cf2ddfb76fcdbf7$var$At = Object.getOwnPropertySymbols, $7cf2ddfb76fcdbf7$var$Tr = Object.prototype.hasOwnProperty, $7cf2ddfb76fcdbf7$var$Sr = Object.prototype.propertyIsEnumerable, $7cf2ddfb76fcdbf7$var$zt = (n, e, t)=>e in n ? $7cf2ddfb76fcdbf7$var$Cr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $7cf2ddfb76fcdbf7$var$q = (n, e)=>{
    for(var t in e || (e = {}))$7cf2ddfb76fcdbf7$var$Tr.call(e, t) && $7cf2ddfb76fcdbf7$var$zt(n, t, e[t]);
    if ($7cf2ddfb76fcdbf7$var$At) for (var t of $7cf2ddfb76fcdbf7$var$At(e))$7cf2ddfb76fcdbf7$var$Sr.call(e, t) && $7cf2ddfb76fcdbf7$var$zt(n, t, e[t]);
    return n;
}, $7cf2ddfb76fcdbf7$var$De = (n, e)=>$7cf2ddfb76fcdbf7$var$Rr(n, $7cf2ddfb76fcdbf7$var$_r(e));
class $7cf2ddfb76fcdbf7$export$60959659b2c22881 extends (0, $8d964f47298418e8$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $7cf2ddfb76fcdbf7$var$Ir, this.events = new (0, $dG33B.EventEmitter), this.name = $7cf2ddfb76fcdbf7$export$9c3a96bb670cddb8, this.version = $7cf2ddfb76fcdbf7$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const r = (0, $93242f9a41d458a0$export$cf77af25151525db)(s), o = {
                    topic: i,
                    relay: r
                };
                this.pending.set(i, o);
                const a = await this.rpcSubscribe(i, r);
                return this.onSubscribe(a, o), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), a;
            } catch (r) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(r), r;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>{
            if (this.topics.includes(i)) return !0;
            const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
            return await new Promise((r, o)=>{
                const a = new (0, $j5HK8.Watch);
                a.start(s);
                const h = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), a.stop(s), r(!0)), a.elapsed(s) >= $7cf2ddfb76fcdbf7$export$9a2ddbfe54f8af77 && (clearInterval(h), a.stop(s), o(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1);
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $93242f9a41d458a0$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const r = (0, $93242f9a41d458a0$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, r), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $93242f9a41d458a0$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $93242f9a41d458a0$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.connection_stalled);
        }
        return (0, $93242f9a41d458a0$export$d4c241cec96564c1)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $93242f9a41d458a0$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $93242f9a41d458a0$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $93242f9a41d458a0$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $7cf2ddfb76fcdbf7$var$De($7cf2ddfb76fcdbf7$var$q({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $7cf2ddfb76fcdbf7$var$q({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $7cf2ddfb76fcdbf7$var$q({}, t)), this.topicMap.set(t.topic, e), this.events.emit($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.deleted, $7cf2ddfb76fcdbf7$var$De($7cf2ddfb76fcdbf7$var$q({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $93242f9a41d458a0$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$7cf2ddfb76fcdbf7$var$De($7cf2ddfb76fcdbf7$var$q({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $75808f0aedbf25ac$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($7cf2ddfb76fcdbf7$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($7cf2ddfb76fcdbf7$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $7cf2ddfb76fcdbf7$var$Pr = Object.defineProperty, $7cf2ddfb76fcdbf7$var$Ut = Object.getOwnPropertySymbols, $7cf2ddfb76fcdbf7$var$xr = Object.prototype.hasOwnProperty, $7cf2ddfb76fcdbf7$var$Or = Object.prototype.propertyIsEnumerable, $7cf2ddfb76fcdbf7$var$Lt = (n, e, t)=>e in n ? $7cf2ddfb76fcdbf7$var$Pr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $7cf2ddfb76fcdbf7$var$Ar = (n, e)=>{
    for(var t in e || (e = {}))$7cf2ddfb76fcdbf7$var$xr.call(e, t) && $7cf2ddfb76fcdbf7$var$Lt(n, t, e[t]);
    if ($7cf2ddfb76fcdbf7$var$Ut) for (var t of $7cf2ddfb76fcdbf7$var$Ut(e))$7cf2ddfb76fcdbf7$var$Or.call(e, t) && $7cf2ddfb76fcdbf7$var$Lt(n, t, e[t]);
    return n;
};
class $7cf2ddfb76fcdbf7$export$70e73aa29a3d4407 extends (0, $8d964f47298418e8$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $dG33B.EventEmitter), this.name = $7cf2ddfb76fcdbf7$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = new Map, this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            const i = t.id;
            try {
                await this.toEstablishConnection();
                const s = this.provider.request(t);
                return this.requestsInFlight.set(i, {
                    promise: s,
                    request: t
                }), await s;
            } catch (s) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(s), s;
            } finally{
                this.requestsInFlight.delete(i);
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t);
        }, this.onConnectHandler = ()=>{
            this.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.on($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.on($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.on($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $4c75a16aead80288$exports.generateChildLogger)(e.logger, this.name) : (0, $4c75a16aead80288$exports.pino)((0, $4c75a16aead80288$exports.getDefaultLoggerOptions)({
            level: e.logger || $7cf2ddfb76fcdbf7$export$5176ffa6778d6637
        })), this.messages = new $7cf2ddfb76fcdbf7$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $7cf2ddfb76fcdbf7$export$60959659b2c22881(this, this.logger), this.publisher = new $7cf2ddfb76fcdbf7$var$vr(this, this.logger), this.relayUrl = e?.relayUrl || $7cf2ddfb76fcdbf7$export$a68061e6c48f332a, this.projectId = e.projectId, this.bundleId = (0, $93242f9a41d458a0$export$40a40f90174d197c)(), this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$7cf2ddfb76fcdbf7$export$27fee22bec112637}...`), await this.restartTransport($7cf2ddfb76fcdbf7$export$27fee22bec112637);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $7cf2ddfb76fcdbf7$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        if (s) return s;
        let r;
        const o = (a)=>{
            a.topic === e && (this.subscriber.off($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.created, o), r());
        };
        return await Promise.all([
            new Promise((a)=>{
                r = a, this.subscriber.on($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.created, o);
            }),
            new Promise(async (a)=>{
                s = await this.subscriber.subscribe(e, t), a();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.requestsInFlight.size > 0 && (this.logger.debug("Waiting for all in-flight requests to finish before closing transport..."), this.requestsInFlight.forEach(async (e)=>{
            await e.promise;
        })), this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await (0, $93242f9a41d458a0$export$3da2293b007ed708)(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
            e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        if (!this.initialized) return t();
                        this.subscriber.once($7cf2ddfb76fcdbf7$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    new Promise(async (t, i)=>{
                        try {
                            await (0, $93242f9a41d458a0$export$3da2293b007ed708)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
                        } catch (s) {
                            i(s);
                            return;
                        }
                        t();
                    })
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.provider.events.emit($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.disconnect);
            } finally{
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
            }
        }
    }
    async restartTransport(e) {
        await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, $93242f9a41d458a0$export$53c2fd0173ad2b80)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $ae80616f2408768a$export$da28308012bf6748)(new (0, $3ac19b0a42a82fe7$export$ea0df116fa892998)((0, $93242f9a41d458a0$export$d875b3963ef774f5)({
            sdkVersion: $7cf2ddfb76fcdbf7$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0,
            bundleId: this.bundleId
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $21d319f26b46bae4$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($7cf2ddfb76fcdbf7$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: r } = t.data, o = {
                topic: i,
                message: s,
                publishedAt: r
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($7cf2ddfb76fcdbf7$var$Ar({
                type: "event",
                event: t.id
            }, o)), this.events.emit(t.id, o), await this.acknowledgePayload(e), await this.onMessageEvent(o);
        } else (0, $21d319f26b46bae4$export$308ba927de2bcbe8)(e) && this.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $bcdc9d9062e38dd6$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.payload, this.onPayloadHandler), this.provider.off($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.connect, this.onConnectHandler), this.provider.off($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.disconnect, this.onDisconnectHandler), this.provider.off($7cf2ddfb76fcdbf7$export$58062acf2f31ddf8.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        this.events.on($7cf2ddfb76fcdbf7$export$d56245796e2837d.connection_stalled, ()=>{
            this.restartTransport().catch((t)=>this.logger.error(t));
        });
        let e = await (0, $93242f9a41d458a0$export$53c2fd0173ad2b80)();
        (0, $93242f9a41d458a0$export$600a1ee4bc680996)(async (t)=>{
            this.initialized && e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((i)=>this.logger.error(i))));
        });
    }
    onProviderDisconnect() {
        this.events.emit($7cf2ddfb76fcdbf7$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async ()=>{
            await this.restartTransport().catch((e)=>this.logger.error(e));
        }, (0, $j5HK8.toMiliseconds)($7cf2ddfb76fcdbf7$export$11ccd39be2c57d6)));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectionAttemptInProgress) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $7cf2ddfb76fcdbf7$var$zr = Object.defineProperty, $7cf2ddfb76fcdbf7$var$Ft = Object.getOwnPropertySymbols, $7cf2ddfb76fcdbf7$var$Nr = Object.prototype.hasOwnProperty, $7cf2ddfb76fcdbf7$var$Ur = Object.prototype.propertyIsEnumerable, $7cf2ddfb76fcdbf7$var$Mt = (n, e, t)=>e in n ? $7cf2ddfb76fcdbf7$var$zr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $7cf2ddfb76fcdbf7$var$kt = (n, e)=>{
    for(var t in e || (e = {}))$7cf2ddfb76fcdbf7$var$Nr.call(e, t) && $7cf2ddfb76fcdbf7$var$Mt(n, t, e[t]);
    if ($7cf2ddfb76fcdbf7$var$Ft) for (var t of $7cf2ddfb76fcdbf7$var$Ft(e))$7cf2ddfb76fcdbf7$var$Ur.call(e, t) && $7cf2ddfb76fcdbf7$var$Mt(n, t, e[t]);
    return n;
};
class $7cf2ddfb76fcdbf7$export$390f32400eaf98c9 extends (0, $8d964f47298418e8$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, r){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $7cf2ddfb76fcdbf7$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((o)=>{
                this.getKey && o !== null && !(0, $93242f9a41d458a0$export$fce6876652108ab)(o) ? this.map.set(this.getKey(o), o) : (0, $93242f9a41d458a0$export$f657f7976bb2769d)(o) ? this.map.set(o.id, o) : (0, $93242f9a41d458a0$export$c96d5113768aaf5e)(o) && this.map.set(o.topic, o);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (o, a)=>{
            this.isInitialized(), this.map.has(o) ? await this.update(o, a) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: o,
                value: a
            }), this.map.set(o, a), await this.persist());
        }, this.get = (o)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: o
            }), this.getData(o)), this.getAll = (o)=>(this.isInitialized(), o ? this.values.filter((a)=>Object.keys(o).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ABol)))(a[h], o[h]))) : this.values), this.update = async (o, a)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: o,
                update: a
            });
            const h = $7cf2ddfb76fcdbf7$var$kt($7cf2ddfb76fcdbf7$var$kt({}, this.getData(o)), a);
            this.map.set(o, h), await this.persist();
        }, this.delete = async (o, a)=>{
            this.isInitialized(), this.map.has(o) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: o,
                reason: a
            }), this.map.delete(o), await this.persist());
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = r;
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $7cf2ddfb76fcdbf7$export$390360ea476c6145, this.version = $7cf2ddfb76fcdbf7$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))), this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $93242f9a41d458a0$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $93242f9a41d458a0$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), r = (0, $93242f9a41d458a0$export$b136d03015bfc12)((0, $j5HK8.FIVE_MINUTES)), o = {
                protocol: $7cf2ddfb76fcdbf7$export$822d0bd1635d5360
            }, a = {
                topic: s,
                expiry: r,
                relay: o,
                active: !1
            }, h = (0, $93242f9a41d458a0$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: o,
                expiryTimestamp: r
            });
            return await this.pairings.set(s, a), await this.core.relayer.subscribe(s), this.core.expirer.set(s, r), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: r, relay: o, expiryTimestamp: a } = (0, $93242f9a41d458a0$export$59f58847421cfb28)(i.uri);
            let h;
            if (this.pairings.keys.includes(s) && (h = this.pairings.get(s), h.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            const l = a || (0, $93242f9a41d458a0$export$b136d03015bfc12)((0, $j5HK8.FIVE_MINUTES)), d = {
                topic: s,
                relay: o,
                expiry: l,
                active: !1
            };
            return await this.pairings.set(s, d), this.core.expirer.set(s, l), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit($7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75.create, d), this.core.crypto.keychain.has(s) || (await this.core.crypto.setSymKey(r, s), await this.core.relayer.subscribe(s, {
                relay: o
            })), d;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $93242f9a41d458a0$export$b136d03015bfc12)((0, $j5HK8.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const r = await this.sendRequest(s, "wc_pairingPing", {}), { done: o, resolve: a, reject: h } = (0, $93242f9a41d458a0$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $93242f9a41d458a0$export$e3eb27ce66c0f6d9)("pairing_ping", r), ({ error: l })=>{
                    l ? h(l) : a();
                }), await o();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $93242f9a41d458a0$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, r)=>{
            const o = (0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)(s, r), a = await this.core.crypto.encode(i, o), h = $7cf2ddfb76fcdbf7$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, o), this.core.relayer.publish(i, a, h), o.id;
        }, this.sendResult = async (i, s, r)=>{
            const o = (0, $bcdc9d9062e38dd6$export$478fdea01c2a3198)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $7cf2ddfb76fcdbf7$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.sendError = async (i, s, r)=>{
            const o = (0, $bcdc9d9062e38dd6$export$9f7302ae26c3f77)(i, r), a = await this.core.crypto.encode(s, o), h = await this.core.history.get(s, i), l = $7cf2ddfb76fcdbf7$export$d94d6986a8185883[h.request.method] ? $7cf2ddfb76fcdbf7$export$d94d6986a8185883[h.request.method].res : $7cf2ddfb76fcdbf7$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, a, l), await this.core.history.resolve(o);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $93242f9a41d458a0$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $93242f9a41d458a0$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: r } = i;
            switch(r.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, r);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, r);
                default:
                    return this.onUnknownRpcMethodRequest(s, r);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: r } = i, o = (await this.core.history.get(s, r.id)).request.method;
            switch(o){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, r);
                default:
                    return this.onUnknownRpcMethodResponse(o);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(r, i, !0), this.events.emit($7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75.ping, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: r } = s;
            setTimeout(()=>{
                (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $93242f9a41d458a0$export$e3eb27ce66c0f6d9)("pairing_ping", r), {}) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && this.events.emit((0, $93242f9a41d458a0$export$e3eb27ce66c0f6d9)("pairing_ping", r), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: r } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit($7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75.delete, {
                    id: r,
                    topic: i
                });
            } catch (o) {
                await this.sendError(r, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: r, method: o } = s;
            try {
                if (this.registeredMethods.includes(o)) return;
                const a = (0, $93242f9a41d458a0$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", o);
                await this.sendError(r, i, a), this.logger.error(a);
            } catch (a) {
                await this.sendError(r, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $93242f9a41d458a0$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            var s;
            if (!(0, $93242f9a41d458a0$export$b3f5fcca1d210454)(i)) {
                const { message: o } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(o);
            }
            if (!(0, $93242f9a41d458a0$export$bef94a5618bf18bf)(i.uri)) {
                const { message: o } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(o);
            }
            const r = (0, $93242f9a41d458a0$export$59f58847421cfb28)(i.uri);
            if (!((s = r?.relay) != null && s.protocol)) {
                const { message: o } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#relay-protocol");
                throw new Error(o);
            }
            if (!(r != null && r.symKey)) {
                const { message: o } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "pair() uri#symKey");
                throw new Error(o);
            }
            if (r != null && r.expiryTimestamp && (0, $j5HK8.toMiliseconds)(r?.expiryTimestamp) < Date.now()) {
                const { message: o } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
                throw new Error(o);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $93242f9a41d458a0$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $93242f9a41d458a0$export$b3f5fcca1d210454)(i)) {
                const { message: r } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(r);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $93242f9a41d458a0$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $93242f9a41d458a0$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.pairings = new $7cf2ddfb76fcdbf7$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($7cf2ddfb76fcdbf7$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $21d319f26b46bae4$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $21d319f26b46bae4$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (r) {
                this.logger.error(r);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $93242f9a41d458a0$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit($7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75.expire, {
                topic: t
            }));
        });
    }
}
class $7cf2ddfb76fcdbf7$export$eeb4f10f25d479cb extends (0, $8d964f47298418e8$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $dG33B.EventEmitter), this.name = $7cf2ddfb76fcdbf7$export$160142c73cb99dc3, this.version = $7cf2ddfb76fcdbf7$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, r)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: r
            }), this.records.has(s.id)) return;
            const o = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: r,
                expiry: (0, $93242f9a41d458a0$export$b136d03015bfc12)((0, $j5HK8.THIRTY_DAYS))
            };
            this.records.set(o.id, o), this.events.emit($7cf2ddfb76fcdbf7$export$a682338b5ffca937.created, o);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($7cf2ddfb76fcdbf7$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((r)=>{
                if (r.topic === i) {
                    if (typeof s < "u" && r.id !== s) return;
                    this.records.delete(r.id), this.events.emit($7cf2ddfb76fcdbf7$export$a682338b5ffca937.deleted, r);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($7cf2ddfb76fcdbf7$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($7cf2ddfb76fcdbf7$export$a682338b5ffca937.created, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($7cf2ddfb76fcdbf7$export$a682338b5ffca937.updated, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($7cf2ddfb76fcdbf7$export$a682338b5ffca937.deleted, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $75808f0aedbf25ac$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $j5HK8.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$export$e76805ce609031cb extends (0, $8d964f47298418e8$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $dG33B.EventEmitter), this.name = $7cf2ddfb76fcdbf7$export$4ddf883392bbc828, this.version = $7cf2ddfb76fcdbf7$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $7cf2ddfb76fcdbf7$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const r = this.formatTarget(i), o = {
                target: r,
                expiry: s
            };
            this.expirations.set(r, o), this.checkExpiry(r, o), this.events.emit($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.created, {
                target: r,
                expiration: o
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), r = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: r
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $93242f9a41d458a0$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $93242f9a41d458a0$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $j5HK8.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $75808f0aedbf25ac$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.created, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.expired, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($7cf2ddfb76fcdbf7$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $7cf2ddfb76fcdbf7$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $93242f9a41d458a0$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $7cf2ddfb76fcdbf7$export$91a8e56769aeb334 extends (0, $8d964f47298418e8$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $7cf2ddfb76fcdbf7$export$3b58f2450f2297e3, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async (i)=>{
            if (this.verifyDisabled || (0, $93242f9a41d458a0$export$f7a1e23e542d38e3)() || !(0, $93242f9a41d458a0$export$4e09c449d6c407f7)()) return;
            const s = this.getVerifyUrl(i?.verifyUrl);
            this.verifyUrl !== s && this.removeIframe(), this.verifyUrl = s;
            try {
                await this.createIframe();
            } catch (r) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = $7cf2ddfb76fcdbf7$export$4fe83ee8f9aec7b6;
                try {
                    await this.createIframe();
                } catch (r) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(r), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = this.getVerifyUrl(i?.verifyUrl);
            let r;
            try {
                r = await this.fetchAttestation(i.attestationId, s);
            } catch (o) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(o), r = await this.fetchAttestation(i.attestationId, $7cf2ddfb76fcdbf7$export$4fe83ee8f9aec7b6);
            }
            return r;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const r = this.startAbortTimer((0, $j5HK8.ONE_SECOND) * 2), o = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(r), o.status === 200 ? await o.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (r)=>{
                r.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((r)=>{
                    if (document.getElementById($7cf2ddfb76fcdbf7$export$3b58f2450f2297e3)) return r();
                    window.addEventListener("message", s);
                    const o = document.createElement("iframe");
                    o.id = $7cf2ddfb76fcdbf7$export$3b58f2450f2297e3, o.src = `${this.verifyUrl}/${this.projectId}`, o.style.display = "none", document.body.append(o), this.iframe = o, i = r;
                }),
                new Promise((r, o)=>setTimeout(()=>{
                        window.removeEventListener("message", s), o("verify iframe load timeout");
                    }, (0, $j5HK8.toMiliseconds)((0, $j5HK8.FIVE_SECONDS))))
            ]);
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.getVerifyUrl = (i)=>{
            let s = i || $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa;
            return $7cf2ddfb76fcdbf7$export$be24df03c4baa778.includes(s) || (this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${$7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa}`), s = $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa), s;
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.verifyUrl = $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $93242f9a41d458a0$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, $j5HK8.toMiliseconds)(e));
    }
}
class $7cf2ddfb76fcdbf7$export$c393c48c5b0cf59a extends (0, $8d964f47298418e8$export$7db533fb638f979d) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.context = $7cf2ddfb76fcdbf7$export$40c022d2cffe0adc, this.registerDeviceToken = async (i)=>{
            const { clientId: s, token: r, notificationType: o, enableEncrypted: a = !1 } = i, h = `${$7cf2ddfb76fcdbf7$export$3c48c4faab79aab1}/${this.projectId}/clients`;
            await (0, (/*@__PURE__*/$parcel$interopDefault($46caeba641ae9a9e$exports)))(h, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    client_id: s,
                    type: o,
                    token: r,
                    always_raw: a
                })
            });
        }, this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.context);
    }
}
var $7cf2ddfb76fcdbf7$var$Lr = Object.defineProperty, $7cf2ddfb76fcdbf7$var$Yt = Object.getOwnPropertySymbols, $7cf2ddfb76fcdbf7$var$$r = Object.prototype.hasOwnProperty, $7cf2ddfb76fcdbf7$var$Fr = Object.prototype.propertyIsEnumerable, $7cf2ddfb76fcdbf7$var$Ht = (n, e, t)=>e in n ? $7cf2ddfb76fcdbf7$var$Lr(n, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : n[e] = t, $7cf2ddfb76fcdbf7$var$Jt = (n, e)=>{
    for(var t in e || (e = {}))$7cf2ddfb76fcdbf7$var$$r.call(e, t) && $7cf2ddfb76fcdbf7$var$Ht(n, t, e[t]);
    if ($7cf2ddfb76fcdbf7$var$Yt) for (var t of $7cf2ddfb76fcdbf7$var$Yt(e))$7cf2ddfb76fcdbf7$var$Fr.call(e, t) && $7cf2ddfb76fcdbf7$var$Ht(n, t, e[t]);
    return n;
};
class $7cf2ddfb76fcdbf7$export$2e2bcd8739ae039 extends (0, $8d964f47298418e8$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $7cf2ddfb76fcdbf7$export$51b1c900ac262bdf, this.version = $7cf2ddfb76fcdbf7$export$f30bd3c8747cdfbe, this.name = $7cf2ddfb76fcdbf7$export$d47601f9de5ee22b, this.events = new (0, $dG33B.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $7cf2ddfb76fcdbf7$export$a68061e6c48f332a, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $4c75a16aead80288$exports.pino)((0, $4c75a16aead80288$exports.getDefaultLoggerOptions)({
            level: e?.logger || $7cf2ddfb76fcdbf7$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $75808f0aedbf25ac$exports.HeartBeat), this.crypto = new $7cf2ddfb76fcdbf7$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $7cf2ddfb76fcdbf7$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $7cf2ddfb76fcdbf7$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, $b76ca8702ff105ae$export$8536778e426ddf92)($7cf2ddfb76fcdbf7$var$Jt($7cf2ddfb76fcdbf7$var$Jt({}, $7cf2ddfb76fcdbf7$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $7cf2ddfb76fcdbf7$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $7cf2ddfb76fcdbf7$export$3370ee24730992a3(this, this.logger), this.verify = new $7cf2ddfb76fcdbf7$export$91a8e56769aeb334(this.projectId || "", this.logger), this.echoClient = new $7cf2ddfb76fcdbf7$export$c393c48c5b0cf59a(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $7cf2ddfb76fcdbf7$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($7cf2ddfb76fcdbf7$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $7cf2ddfb76fcdbf7$export$4143ab5b91744744 = $7cf2ddfb76fcdbf7$export$2e2bcd8739ae039;



parcelRequire("d55yj");
var $1lOcn = parcelRequire("1lOcn");

var $dG33B = parcelRequire("dG33B");
class $bd34dd86acf0ba1d$export$ed533416df113881 extends (0, $1lOcn.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bd34dd86acf0ba1d$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$45b2c2643615b67 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bd34dd86acf0ba1d$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bd34dd86acf0ba1d$export$3b0872bbd7e675a2 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$9a0f755fd4f79434 extends (0, $1lOcn.IEvents) {
    constructor(s){
        super();
    }
}
class $bd34dd86acf0ba1d$export$a7f17ba6c54777e7 {
    constructor(s, t, o, M){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $bd34dd86acf0ba1d$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bd34dd86acf0ba1d$export$300eed987e764b57 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$41aaa3c39f6f2861 extends (0, $1lOcn.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bd34dd86acf0ba1d$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$7db533fb638f979d {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bd34dd86acf0ba1d$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))) {
    constructor(){
        super();
    }
}
class $bd34dd86acf0ba1d$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bd34dd86acf0ba1d$export$623dd0f793f15643 extends (0, $dG33B.EventEmitter) {
    constructor(){
        super();
    }
}
class $bd34dd86acf0ba1d$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}









var $6qd2L = parcelRequire("6qd2L");
var $f6b07f49ea861d2a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f6b07f49ea861d2a$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $f6b07f49ea861d2a$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $6qd2L.platform;
    }
    return NodeInfo;
}();
var $f6b07f49ea861d2a$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $f6b07f49ea861d2a$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $f6b07f49ea861d2a$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $f6b07f49ea861d2a$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $f6b07f49ea861d2a$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $f6b07f49ea861d2a$var$REQUIRED_VERSION_PARTS = 3;
var $f6b07f49ea861d2a$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $f6b07f49ea861d2a$var$SEARCHBOX_UA_REGEX
    ]
];
var $f6b07f49ea861d2a$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $f6b07f49ea861d2a$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $f6b07f49ea861d2a$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $f6b07f49ea861d2a$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $f6b07f49ea861d2a$export$1184956100eddc3c(navigator.userAgent);
    return $f6b07f49ea861d2a$export$bf2c6630ab904918();
}
function $f6b07f49ea861d2a$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $f6b07f49ea861d2a$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $f6b07f49ea861d2a$export$89ca9f8ca1a50fd5(ua) {
    var data = $f6b07f49ea861d2a$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $f6b07f49ea861d2a$export$1184956100eddc3c(ua) {
    var matchedRule = $f6b07f49ea861d2a$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $f6b07f49ea861d2a$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $f6b07f49ea861d2a$var$REQUIRED_VERSION_PARTS) versionParts = $f6b07f49ea861d2a$var$__spreadArray($f6b07f49ea861d2a$var$__spreadArray([], versionParts, true), $f6b07f49ea861d2a$var$createVersionParts($f6b07f49ea861d2a$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $f6b07f49ea861d2a$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $f6b07f49ea861d2a$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $f6b07f49ea861d2a$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $f6b07f49ea861d2a$export$8fa985da04a86f0(name, version, os);
}
function $f6b07f49ea861d2a$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $f6b07f49ea861d2a$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $f6b07f49ea861d2a$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $f6b07f49ea861d2a$export$bf2c6630ab904918() {
    var isNode = typeof $6qd2L !== "undefined" && $6qd2L.version;
    return isNode ? new $f6b07f49ea861d2a$export$62457c674e0167c0($6qd2L.version.slice(1)) : null;
}
function $f6b07f49ea861d2a$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $j5HK8 = parcelRequire("j5HK8");

var $6d3b08c41039b216$exports = {};
"use strict";
Object.defineProperty($6d3b08c41039b216$exports, "__esModule", {
    value: true
});
$6d3b08c41039b216$exports.getWindowMetadata = void 0;

function $6d3b08c41039b216$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $42fc9f31ad639091$exports.getDocumentOrThrow();
        loc = $42fc9f31ad639091$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$6d3b08c41039b216$exports.getWindowMetadata = $6d3b08c41039b216$var$getWindowMetadata;


var $beb036acab5e15f8$export$f9380c9a627682d3;
var $beb036acab5e15f8$export$98e6a39c04603d36;
var $beb036acab5e15f8$export$fac44ee5b035f737;
var $beb036acab5e15f8$export$7a5253c0f62e0150;
var $beb036acab5e15f8$export$a8c1621ea79325d3;
var $beb036acab5e15f8$export$357523c63a2253b9;
var $beb036acab5e15f8$export$44c361b8ec72ef7f;
"use strict";




const $beb036acab5e15f8$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $beb036acab5e15f8$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $beb036acab5e15f8$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            "[",
                            $beb036acab5e15f8$var$encode(index, options),
                            "]=",
                            $beb036acab5e15f8$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            "[]=",
                            $beb036acab5e15f8$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            ":list=",
                            $beb036acab5e15f8$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $beb036acab5e15f8$var$encode(key, options),
                                keyValueSep,
                                $beb036acab5e15f8$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $beb036acab5e15f8$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $beb036acab5e15f8$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $beb036acab5e15f8$var$encode(key, options),
                            "=",
                            $beb036acab5e15f8$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $beb036acab5e15f8$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $beb036acab5e15f8$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $beb036acab5e15f8$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$beb036acab5e15f8$var$decode(item, options)) : value === null ? value : $beb036acab5e15f8$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $beb036acab5e15f8$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$beb036acab5e15f8$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $beb036acab5e15f8$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $beb036acab5e15f8$var$encode(value, options) {
    if (options.encode) return options.strict ? $fb68c056088f0e6a$exports(value) : encodeURIComponent(value);
    return value;
}
function $beb036acab5e15f8$var$decode(value, options) {
    if (options.decode) return $e3f49fb9a7fe1f8f$exports(value);
    return value;
}
function $beb036acab5e15f8$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $beb036acab5e15f8$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $beb036acab5e15f8$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $beb036acab5e15f8$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $beb036acab5e15f8$var$extract(input) {
    input = $beb036acab5e15f8$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $beb036acab5e15f8$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $beb036acab5e15f8$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $beb036acab5e15f8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $beb036acab5e15f8$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $e78c9bd53c92ef94$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $beb036acab5e15f8$var$decode(value, options);
        formatter($beb036acab5e15f8$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $beb036acab5e15f8$var$parseValue(value[k], options);
        else ret[key] = $beb036acab5e15f8$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $beb036acab5e15f8$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$beb036acab5e15f8$export$f9380c9a627682d3 = $beb036acab5e15f8$var$extract;
$beb036acab5e15f8$export$98e6a39c04603d36 = $beb036acab5e15f8$var$parse;
$beb036acab5e15f8$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $beb036acab5e15f8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $beb036acab5e15f8$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $beb036acab5e15f8$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $beb036acab5e15f8$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $beb036acab5e15f8$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $beb036acab5e15f8$var$encode(key, options) + "=" + $beb036acab5e15f8$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$beb036acab5e15f8$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $e78c9bd53c92ef94$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $beb036acab5e15f8$var$parse($beb036acab5e15f8$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $beb036acab5e15f8$var$decode(hash, options)
    } : {});
};
$beb036acab5e15f8$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$beb036acab5e15f8$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $beb036acab5e15f8$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $beb036acab5e15f8$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $beb036acab5e15f8$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $beb036acab5e15f8$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $beb036acab5e15f8$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$beb036acab5e15f8$var$encodeFragmentIdentifier] ? $beb036acab5e15f8$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$beb036acab5e15f8$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$beb036acab5e15f8$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $beb036acab5e15f8$export$7a5253c0f62e0150(input, options);
    return $beb036acab5e15f8$export$a8c1621ea79325d3({
        url: url,
        query: $e85104af5636d4bb$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$beb036acab5e15f8$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $beb036acab5e15f8$export$357523c63a2253b9(input, exclusionFilter, options);
};




var $6qd2L = parcelRequire("6qd2L");
const $3d822aa3e3449a80$var$K = ":";
function $3d822aa3e3449a80$export$4764229d78de4437(e) {
    const [n, t] = e.split($3d822aa3e3449a80$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $3d822aa3e3449a80$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($3d822aa3e3449a80$var$K);
}
function $3d822aa3e3449a80$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($3d822aa3e3449a80$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $3d822aa3e3449a80$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($3d822aa3e3449a80$var$K);
}
function $3d822aa3e3449a80$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $3d822aa3e3449a80$export$2806d446053abd1d(e) {
    const { address: n } = $3d822aa3e3449a80$export$276ab0158c66e3d(e);
    return n;
}
function $3d822aa3e3449a80$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $3d822aa3e3449a80$export$276ab0158c66e3d(e);
    return $3d822aa3e3449a80$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $3d822aa3e3449a80$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $3d822aa3e3449a80$export$4764229d78de4437(n);
    return $3d822aa3e3449a80$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $3d822aa3e3449a80$export$aa4a6b630dfcfa83(e) {
    return $3d822aa3e3449a80$export$d579bc26e95946b5(e, $3d822aa3e3449a80$export$2806d446053abd1d);
}
function $3d822aa3e3449a80$export$d5ee58c6b13696e9(e) {
    return $3d822aa3e3449a80$export$d579bc26e95946b5(e, $3d822aa3e3449a80$export$93512919ec2ab555);
}
function $3d822aa3e3449a80$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $3d822aa3e3449a80$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$3d822aa3e3449a80$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $3d822aa3e3449a80$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$3d822aa3e3449a80$export$376384387cd15b27(r, o));
    }), t;
}
function $3d822aa3e3449a80$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $3d822aa3e3449a80$export$a524ae552db7912 = (e)=>e?.split(":"), $3d822aa3e3449a80$export$85f23c05c80b194 = (e)=>{
    const n = e && $3d822aa3e3449a80$export$a524ae552db7912(e);
    if (n) return n[3];
}, $3d822aa3e3449a80$export$a8b149927aef7051 = (e)=>{
    const n = e && $3d822aa3e3449a80$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $3d822aa3e3449a80$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $3d822aa3e3449a80$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $3d822aa3e3449a80$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $3d822aa3e3449a80$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$3d822aa3e3449a80$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $3d822aa3e3449a80$export$f7403969428298bd = "base10", $3d822aa3e3449a80$export$49eb910ab2518105 = "base16", $3d822aa3e3449a80$export$9bff723d552e6bcf = "base64pad", $3d822aa3e3449a80$export$9560dad2a83e4f04 = "utf8", $3d822aa3e3449a80$export$3425bd336a9673d8 = 0, $3d822aa3e3449a80$export$406e97c329f0f3d4 = 1, $3d822aa3e3449a80$var$Dn = 0, $3d822aa3e3449a80$var$Te = 1, $3d822aa3e3449a80$var$Z = 12, $3d822aa3e3449a80$var$X = 32;
function $3d822aa3e3449a80$export$a949d36eab55b41f() {
    const e = $c8893c01b49eb09f$exports.generateKeyPair();
    return {
        privateKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.secretKey, $3d822aa3e3449a80$export$49eb910ab2518105),
        publicKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.publicKey, $3d822aa3e3449a80$export$49eb910ab2518105)
    };
}
function $3d822aa3e3449a80$export$d15a28e4f1821243() {
    const e = (0, $e8d7d54636de94dc$exports.randomBytes)($3d822aa3e3449a80$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $3d822aa3e3449a80$export$49eb910ab2518105);
}
function $3d822aa3e3449a80$export$f8378f68e053f5c6(e, n) {
    const t = $c8893c01b49eb09f$exports.sharedKey((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $3d822aa3e3449a80$export$49eb910ab2518105), (0, $9e7f19515ec15414$export$3004f64547af360e)(n, $3d822aa3e3449a80$export$49eb910ab2518105), !0), r = new (0, $4488f47cea993102$exports.HKDF)((0, $90699891a8c8f5b5$exports.SHA256), t).expand($3d822aa3e3449a80$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(r, $3d822aa3e3449a80$export$49eb910ab2518105);
}
function $3d822aa3e3449a80$export$1e87d19d4aab5805(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $3d822aa3e3449a80$export$49eb910ab2518105));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $3d822aa3e3449a80$export$49eb910ab2518105);
}
function $3d822aa3e3449a80$export$d4c241cec96564c1(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $3d822aa3e3449a80$export$9560dad2a83e4f04));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $3d822aa3e3449a80$export$49eb910ab2518105);
}
function $3d822aa3e3449a80$export$e9d2f9ba70428fb6(e) {
    return (0, $9e7f19515ec15414$export$3004f64547af360e)(`${e}`, $3d822aa3e3449a80$export$f7403969428298bd);
}
function $3d822aa3e3449a80$export$7547a514ee29b9d4(e) {
    return Number((0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $3d822aa3e3449a80$export$f7403969428298bd));
}
function $3d822aa3e3449a80$export$5b0f6292f11d1d18(e) {
    const n = $3d822aa3e3449a80$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $3d822aa3e3449a80$export$3425bd336a9673d8);
    if ($3d822aa3e3449a80$export$7547a514ee29b9d4(n) === $3d822aa3e3449a80$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.senderPublicKey, $3d822aa3e3449a80$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.iv, $3d822aa3e3449a80$export$49eb910ab2518105) : (0, $e8d7d54636de94dc$exports.randomBytes)($3d822aa3e3449a80$var$Z), o = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $3d822aa3e3449a80$export$49eb910ab2518105)).seal(r, (0, $9e7f19515ec15414$export$3004f64547af360e)(e.message, $3d822aa3e3449a80$export$9560dad2a83e4f04));
    return $3d822aa3e3449a80$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $3d822aa3e3449a80$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $3d822aa3e3449a80$export$49eb910ab2518105)), { sealed: t, iv: r } = $3d822aa3e3449a80$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(o, $3d822aa3e3449a80$export$9560dad2a83e4f04);
}
function $3d822aa3e3449a80$export$dfdc1655ccc5b9cb(e) {
    if ($3d822aa3e3449a80$export$7547a514ee29b9d4(e.type) === $3d822aa3e3449a80$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $3d822aa3e3449a80$export$9bff723d552e6bcf);
    }
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $3d822aa3e3449a80$export$9bff723d552e6bcf);
}
function $3d822aa3e3449a80$export$efcd34ab6248d3cd(e) {
    const n = (0, $9e7f19515ec15414$export$3004f64547af360e)(e, $3d822aa3e3449a80$export$9bff723d552e6bcf), t = n.slice($3d822aa3e3449a80$var$Dn, $3d822aa3e3449a80$var$Te), r = $3d822aa3e3449a80$var$Te;
    if ($3d822aa3e3449a80$export$7547a514ee29b9d4(t) === $3d822aa3e3449a80$export$406e97c329f0f3d4) {
        const d = r + $3d822aa3e3449a80$var$X, l = d + $3d822aa3e3449a80$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $3d822aa3e3449a80$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $3d822aa3e3449a80$export$177f3e316562333d(e, n) {
    const t = $3d822aa3e3449a80$export$efcd34ab6248d3cd(e);
    return $3d822aa3e3449a80$export$7949f60f2444aef2({
        type: $3d822aa3e3449a80$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(t.senderPublicKey, $3d822aa3e3449a80$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $3d822aa3e3449a80$export$7949f60f2444aef2(e) {
    const n = e?.type || $3d822aa3e3449a80$export$3425bd336a9673d8;
    if (n === $3d822aa3e3449a80$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $3d822aa3e3449a80$export$8c165704db2d5c15(e) {
    return e.type === $3d822aa3e3449a80$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $3d822aa3e3449a80$var$Bn = Object.defineProperty, $3d822aa3e3449a80$var$Ue = Object.getOwnPropertySymbols, $3d822aa3e3449a80$var$Gn = Object.prototype.hasOwnProperty, $3d822aa3e3449a80$var$Wn = Object.prototype.propertyIsEnumerable, $3d822aa3e3449a80$var$_e = (e, n, t)=>n in e ? $3d822aa3e3449a80$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3d822aa3e3449a80$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$3d822aa3e3449a80$var$Gn.call(n, t) && $3d822aa3e3449a80$var$_e(e, t, n[t]);
    if ($3d822aa3e3449a80$var$Ue) for (var t of $3d822aa3e3449a80$var$Ue(n))$3d822aa3e3449a80$var$Wn.call(n, t) && $3d822aa3e3449a80$var$_e(e, t, n[t]);
    return e;
};
const $3d822aa3e3449a80$export$f12873d77424d47b = "ReactNative", $3d822aa3e3449a80$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $3d822aa3e3449a80$export$657dee6d5648750a = " ", $3d822aa3e3449a80$export$96c3628b3b9d2079 = ":", $3d822aa3e3449a80$export$98238152dfccf046 = "/", $3d822aa3e3449a80$export$7f882bb969de14a3 = 2, $3d822aa3e3449a80$export$77baccb4c6bd5852 = 1e3, $3d822aa3e3449a80$export$e08b61c98317d88c = "js";
function $3d822aa3e3449a80$export$8ee0fc9ee280b4ee() {
    return typeof $6qd2L < "u" && typeof $6qd2L.versions < "u" && typeof $6qd2L.versions.node < "u";
}
function $3d822aa3e3449a80$export$f7a1e23e542d38e3() {
    return !(0, $42fc9f31ad639091$exports.getDocument)() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && navigator.product === $3d822aa3e3449a80$export$f12873d77424d47b;
}
function $3d822aa3e3449a80$export$4e09c449d6c407f7() {
    return !$3d822aa3e3449a80$export$8ee0fc9ee280b4ee() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && !!(0, $42fc9f31ad639091$exports.getDocument)();
}
function $3d822aa3e3449a80$export$57570b1603cf6adb() {
    return $3d822aa3e3449a80$export$f7a1e23e542d38e3() ? $3d822aa3e3449a80$export$86b1301a63b15dd9.reactNative : $3d822aa3e3449a80$export$8ee0fc9ee280b4ee() ? $3d822aa3e3449a80$export$86b1301a63b15dd9.node : $3d822aa3e3449a80$export$4e09c449d6c407f7() ? $3d822aa3e3449a80$export$86b1301a63b15dd9.browser : $3d822aa3e3449a80$export$86b1301a63b15dd9.unknown;
}
function $3d822aa3e3449a80$export$40a40f90174d197c() {
    var e;
    try {
        return $3d822aa3e3449a80$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $3d822aa3e3449a80$export$c4147c69f6845da(e, n) {
    let t = $beb036acab5e15f8$export$98e6a39c04603d36(e);
    return t = $3d822aa3e3449a80$var$$e($3d822aa3e3449a80$var$$e({}, t), n), e = $beb036acab5e15f8$export$fac44ee5b035f737(t), e;
}
function $3d822aa3e3449a80$export$ba31e015127122bb() {
    return (0, $6d3b08c41039b216$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $3d822aa3e3449a80$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $3d822aa3e3449a80$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $3d822aa3e3449a80$export$20d4a3cb5829b8b6() {
    if ($3d822aa3e3449a80$export$57570b1603cf6adb() === $3d822aa3e3449a80$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $f6b07f49ea861d2a$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $3d822aa3e3449a80$export$4389b0987726d52d() {
    var e;
    const n = $3d822aa3e3449a80$export$57570b1603cf6adb();
    return n === $3d822aa3e3449a80$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $3d822aa3e3449a80$export$b55a4c6e272b719f(e, n, t) {
    const r = $3d822aa3e3449a80$export$20d4a3cb5829b8b6(), o = $3d822aa3e3449a80$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $3d822aa3e3449a80$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $3d822aa3e3449a80$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $3d822aa3e3449a80$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $3d822aa3e3449a80$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $3d822aa3e3449a80$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $3d822aa3e3449a80$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $3d822aa3e3449a80$export$1e21530e896c0b0b(e, n = $3d822aa3e3449a80$export$7f882bb969de14a3) {
    return $3d822aa3e3449a80$export$7f00885504704576(e.split($3d822aa3e3449a80$export$98238152dfccf046), n);
}
function $3d822aa3e3449a80$export$80bffd46c37a96f6(e) {
    return $3d822aa3e3449a80$export$1e21530e896c0b0b(e).join($3d822aa3e3449a80$export$657dee6d5648750a);
}
function $3d822aa3e3449a80$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $3d822aa3e3449a80$export$7f00885504704576(e, n = $3d822aa3e3449a80$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $3d822aa3e3449a80$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $3d822aa3e3449a80$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $3d822aa3e3449a80$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $3d822aa3e3449a80$export$85c927578394b28b = (e)=>e;
function $3d822aa3e3449a80$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $3d822aa3e3449a80$export$9a00dee1beb8f576(e) {
    return e.split($3d822aa3e3449a80$export$657dee6d5648750a).map((n)=>$3d822aa3e3449a80$export$e9f8fcacef3bca4b(n)).join($3d822aa3e3449a80$export$657dee6d5648750a);
}
function $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb(e = (0, $j5HK8.FIVE_MINUTES), n) {
    const t = (0, $j5HK8.toMiliseconds)(e || (0, $j5HK8.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $3d822aa3e3449a80$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $3d822aa3e3449a80$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $3d822aa3e3449a80$export$43ab92477f8713b9(e) {
    return $3d822aa3e3449a80$export$187ab6574b2ae23f("topic", e);
}
function $3d822aa3e3449a80$export$bd13103c2e5cc0c3(e) {
    return $3d822aa3e3449a80$export$187ab6574b2ae23f("id", e);
}
function $3d822aa3e3449a80$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $3d822aa3e3449a80$export$b136d03015bfc12(e, n) {
    return (0, $j5HK8.fromMiliseconds)((n || Date.now()) + (0, $j5HK8.toMiliseconds)(e));
}
function $3d822aa3e3449a80$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $j5HK8.toMiliseconds)(e);
}
function $3d822aa3e3449a80$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $3d822aa3e3449a80$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $3d822aa3e3449a80$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $3d822aa3e3449a80$export$57570b1603cf6adb();
        i === $3d822aa3e3449a80$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $3d822aa3e3449a80$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $3d822aa3e3449a80$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($3d822aa3e3449a80$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $3d822aa3e3449a80$export$822d0bd1635d5360 = "irn";
function $3d822aa3e3449a80$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $3d822aa3e3449a80$export$822d0bd1635d5360
    };
}
function $3d822aa3e3449a80$export$604e3deb95e1b734(e) {
    const n = (0, $d06ba0a3f54ef0e1$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $3d822aa3e3449a80$var$bt = Object.defineProperty, $3d822aa3e3449a80$var$Nt = Object.defineProperties, $3d822aa3e3449a80$var$Ot = Object.getOwnPropertyDescriptors, $3d822aa3e3449a80$var$qe = Object.getOwnPropertySymbols, $3d822aa3e3449a80$var$St = Object.prototype.hasOwnProperty, $3d822aa3e3449a80$var$wt = Object.prototype.propertyIsEnumerable, $3d822aa3e3449a80$var$Be = (e, n, t)=>n in e ? $3d822aa3e3449a80$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3d822aa3e3449a80$var$It = (e, n)=>{
    for(var t in n || (n = {}))$3d822aa3e3449a80$var$St.call(n, t) && $3d822aa3e3449a80$var$Be(e, t, n[t]);
    if ($3d822aa3e3449a80$var$qe) for (var t of $3d822aa3e3449a80$var$qe(n))$3d822aa3e3449a80$var$wt.call(n, t) && $3d822aa3e3449a80$var$Be(e, t, n[t]);
    return e;
}, $3d822aa3e3449a80$var$Tt = (e, n)=>$3d822aa3e3449a80$var$Nt(e, $3d822aa3e3449a80$var$Ot(n));
function $3d822aa3e3449a80$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $3d822aa3e3449a80$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $beb036acab5e15f8$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $3d822aa3e3449a80$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $3d822aa3e3449a80$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $3d822aa3e3449a80$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $3d822aa3e3449a80$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $3d822aa3e3449a80$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $beb036acab5e15f8$export$fac44ee5b035f737($3d822aa3e3449a80$var$Tt($3d822aa3e3449a80$var$It({
        symKey: e.symKey
    }, $3d822aa3e3449a80$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $3d822aa3e3449a80$var$At = Object.defineProperty, $3d822aa3e3449a80$var$Ut = Object.defineProperties, $3d822aa3e3449a80$var$_t = Object.getOwnPropertyDescriptors, $3d822aa3e3449a80$var$Ye = Object.getOwnPropertySymbols, $3d822aa3e3449a80$var$$t = Object.prototype.hasOwnProperty, $3d822aa3e3449a80$var$Ct = Object.prototype.propertyIsEnumerable, $3d822aa3e3449a80$var$Je = (e, n, t)=>n in e ? $3d822aa3e3449a80$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3d822aa3e3449a80$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$3d822aa3e3449a80$var$$t.call(n, t) && $3d822aa3e3449a80$var$Je(e, t, n[t]);
    if ($3d822aa3e3449a80$var$Ye) for (var t of $3d822aa3e3449a80$var$Ye(n))$3d822aa3e3449a80$var$Ct.call(n, t) && $3d822aa3e3449a80$var$Je(e, t, n[t]);
    return e;
}, $3d822aa3e3449a80$var$Dt = (e, n)=>$3d822aa3e3449a80$var$Ut(e, $3d822aa3e3449a80$var$_t(n));
function $3d822aa3e3449a80$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $3d822aa3e3449a80$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$3d822aa3e3449a80$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $3d822aa3e3449a80$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $3d822aa3e3449a80$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $3d822aa3e3449a80$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $3d822aa3e3449a80$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $3d822aa3e3449a80$export$a8daa26a7c60ef90(e, n) {
    const t = $3d822aa3e3449a80$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $3d822aa3e3449a80$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $3d822aa3e3449a80$export$2994550cda701c96(n), s = $3d822aa3e3449a80$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $3d822aa3e3449a80$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $3d822aa3e3449a80$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $3d822aa3e3449a80$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $3d822aa3e3449a80$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $3d822aa3e3449a80$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $3d822aa3e3449a80$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $3d822aa3e3449a80$export$dd404c96fbbb1ff8(e) {
    return $3d822aa3e3449a80$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $3d822aa3e3449a80$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$3d822aa3e3449a80$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $3d822aa3e3449a80$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $3d822aa3e3449a80$export$dd404c96fbbb1ff8(s);
        o[u] = $3d822aa3e3449a80$var$Dt($3d822aa3e3449a80$var$jt({}, o[u]), {
            chains: $3d822aa3e3449a80$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $3d822aa3e3449a80$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $3d822aa3e3449a80$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $3d822aa3e3449a80$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $3d822aa3e3449a80$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $3d822aa3e3449a80$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $3d822aa3e3449a80$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $3d822aa3e3449a80$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $3d822aa3e3449a80$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $3d822aa3e3449a80$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $3d822aa3e3449a80$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $3d822aa3e3449a80$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $3d822aa3e3449a80$export$ee898ca48ab56c74(e, n) {
    return n && $3d822aa3e3449a80$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $3d822aa3e3449a80$export$d6781b696a0576d1(e, n) {
    return n && $3d822aa3e3449a80$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $3d822aa3e3449a80$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $3d822aa3e3449a80$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $3d822aa3e3449a80$export$d46695d9c3664fe9(d), a = t[i];
        (!$3d822aa3e3449a80$export$1468a49de573f7f9($3d822aa3e3449a80$export$376384387cd15b27(i, a), u) || !$3d822aa3e3449a80$export$1468a49de573f7f9(a.methods, l) || !$3d822aa3e3449a80$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $3d822aa3e3449a80$export$e544b39f0a22e47a(e) {
    return $3d822aa3e3449a80$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $3d822aa3e3449a80$export$49e4a5b6862e3c71(e) {
    if ($3d822aa3e3449a80$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $3d822aa3e3449a80$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $3d822aa3e3449a80$export$bef94a5618bf18bf(e) {
    if ($3d822aa3e3449a80$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $3d822aa3e3449a80$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $3d822aa3e3449a80$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $3d822aa3e3449a80$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $3d822aa3e3449a80$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $3d822aa3e3449a80$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $3d822aa3e3449a80$export$c12fced8176774f3(e) {
    let n = !0;
    return $3d822aa3e3449a80$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$3d822aa3e3449a80$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $3d822aa3e3449a80$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $3d822aa3e3449a80$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $3d822aa3e3449a80$export$e544b39f0a22e47a(o) || (r = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $3d822aa3e3449a80$export$e544b39f0a22e47a(e) || (r = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $3d822aa3e3449a80$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $3d822aa3e3449a80$export$df46c123d7e298ce(o, $3d822aa3e3449a80$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $3d822aa3e3449a80$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $3d822aa3e3449a80$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $3d822aa3e3449a80$export$49e4a5b6862e3c71(r) || (t = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $3d822aa3e3449a80$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $3d822aa3e3449a80$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $3d822aa3e3449a80$export$b32541d63753af56(e, n) {
    let t = null;
    return $3d822aa3e3449a80$export$c12fced8176774f3(e?.methods) ? $3d822aa3e3449a80$export$c12fced8176774f3(e?.events) || (t = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $3d822aa3e3449a80$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $3d822aa3e3449a80$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $3d822aa3e3449a80$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $3d822aa3e3449a80$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $3d822aa3e3449a80$export$16a0268bc22b47b0(e)) {
        const o = $3d822aa3e3449a80$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $3d822aa3e3449a80$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $3d822aa3e3449a80$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $3d822aa3e3449a80$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $3d822aa3e3449a80$export$16a0268bc22b47b0(e)) {
        const r = $3d822aa3e3449a80$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $3d822aa3e3449a80$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $3d822aa3e3449a80$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $3d822aa3e3449a80$export$1b3fc298be8c9a7b(e) {
    return $3d822aa3e3449a80$export$ee898ca48ab56c74(e.protocol, !0);
}
function $3d822aa3e3449a80$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $3d822aa3e3449a80$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $3d822aa3e3449a80$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $3d822aa3e3449a80$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $3d822aa3e3449a80$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $3d822aa3e3449a80$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$3d822aa3e3449a80$export$d6781b696a0576d1(e.code, !1) || !e.message || !$3d822aa3e3449a80$export$ee898ca48ab56c74(e.message, !1));
}
function $3d822aa3e3449a80$export$1a2af3c017fb6d42(e) {
    return !($3d822aa3e3449a80$export$fce6876652108ab(e) || !$3d822aa3e3449a80$export$ee898ca48ab56c74(e.method, !1));
}
function $3d822aa3e3449a80$export$1ae38cf0a848f651(e) {
    return !($3d822aa3e3449a80$export$fce6876652108ab(e) || $3d822aa3e3449a80$export$fce6876652108ab(e.result) && $3d822aa3e3449a80$export$fce6876652108ab(e.error) || !$3d822aa3e3449a80$export$d6781b696a0576d1(e.id, !1) || !$3d822aa3e3449a80$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $3d822aa3e3449a80$export$cbe4cdc5960cfa11(e) {
    return !($3d822aa3e3449a80$export$fce6876652108ab(e) || !$3d822aa3e3449a80$export$ee898ca48ab56c74(e.name, !1));
}
function $3d822aa3e3449a80$export$144fc36610eb6522(e, n) {
    return !(!$3d822aa3e3449a80$export$e544b39f0a22e47a(n) || !$3d822aa3e3449a80$export$fb6db6038e742b14(e).includes(n));
}
function $3d822aa3e3449a80$export$8db4804e3a6de711(e, n, t) {
    return $3d822aa3e3449a80$export$ee898ca48ab56c74(t, !1) ? $3d822aa3e3449a80$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $3d822aa3e3449a80$export$df2c67ef8baad16b(e, n, t) {
    return $3d822aa3e3449a80$export$ee898ca48ab56c74(t, !1) ? $3d822aa3e3449a80$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $3d822aa3e3449a80$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $3d822aa3e3449a80$var$er(e), s = $3d822aa3e3449a80$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $3d822aa3e3449a80$var$pn(Object.keys(e)), c = $3d822aa3e3449a80$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $3d822aa3e3449a80$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $3d822aa3e3449a80$export$1468a49de573f7f9(i, d) || (r = $3d822aa3e3449a80$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $3d822aa3e3449a80$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $3d822aa3e3449a80$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($3d822aa3e3449a80$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $3d822aa3e3449a80$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $3d822aa3e3449a80$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $3d822aa3e3449a80$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $3d822aa3e3449a80$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $3d822aa3e3449a80$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $3d822aa3e3449a80$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $3d822aa3e3449a80$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $3d822aa3e3449a80$export$59fba2af1ac782b(e, n) {
    return $3d822aa3e3449a80$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $3d822aa3e3449a80$export$53c2fd0173ad2b80() {
    const e = $3d822aa3e3449a80$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $3d822aa3e3449a80$export$86b1301a63b15dd9.browser:
                n($3d822aa3e3449a80$export$2f147c609a999e49());
                break;
            case $3d822aa3e3449a80$export$86b1301a63b15dd9.reactNative:
                n($3d822aa3e3449a80$export$1444c95b1570bd12());
                break;
            case $3d822aa3e3449a80$export$86b1301a63b15dd9.node:
                n($3d822aa3e3449a80$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $3d822aa3e3449a80$export$2f147c609a999e49() {
    return $3d822aa3e3449a80$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $3d822aa3e3449a80$export$1444c95b1570bd12() {
    if ($3d822aa3e3449a80$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $3d822aa3e3449a80$export$aec5b2d627eec500() {
    return !0;
}
function $3d822aa3e3449a80$export$600a1ee4bc680996(e) {
    switch($3d822aa3e3449a80$export$57570b1603cf6adb()){
        case $3d822aa3e3449a80$export$86b1301a63b15dd9.browser:
            $3d822aa3e3449a80$export$d32b24f18d96c5f2(e);
            break;
        case $3d822aa3e3449a80$export$86b1301a63b15dd9.reactNative:
            $3d822aa3e3449a80$export$904edb1c18ec91c7(e);
            break;
        case $3d822aa3e3449a80$export$86b1301a63b15dd9.node:
            break;
    }
}
function $3d822aa3e3449a80$export$d32b24f18d96c5f2(e) {
    !$3d822aa3e3449a80$export$f7a1e23e542d38e3() && $3d822aa3e3449a80$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $3d822aa3e3449a80$export$904edb1c18ec91c7(e) {
    $3d822aa3e3449a80$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $3d822aa3e3449a80$var$ae = {};
class $3d822aa3e3449a80$export$b72d712fed4d036d {
    static get(n) {
        return $3d822aa3e3449a80$var$ae[n];
    }
    static set(n, t) {
        $3d822aa3e3449a80$var$ae[n] = t;
    }
    static delete(n) {
        delete $3d822aa3e3449a80$var$ae[n];
    }
}



var $dG33B = parcelRequire("dG33B");

var $j5HK8 = parcelRequire("j5HK8");

const $9008fe5fa430f55b$export$4fa962fc67384e02 = "wc", $9008fe5fa430f55b$export$61085c48796ff049 = 2, $9008fe5fa430f55b$export$94715592c220319a = "client", $9008fe5fa430f55b$export$7fa6f9ee1e2cab96 = `${$9008fe5fa430f55b$export$4fa962fc67384e02}@${$9008fe5fa430f55b$export$61085c48796ff049}:${$9008fe5fa430f55b$export$94715592c220319a}:`, $9008fe5fa430f55b$export$8dffb3242f2c5f72 = {
    name: $9008fe5fa430f55b$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $9008fe5fa430f55b$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_request_expire: "session_request_expire"
}, $9008fe5fa430f55b$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $9008fe5fa430f55b$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $9008fe5fa430f55b$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $9008fe5fa430f55b$export$160142c73cb99dc3 = "history", $9008fe5fa430f55b$export$8eba9ce85616c607 = "0.3", $9008fe5fa430f55b$export$ae6c7a4f7ed730a1 = "proposal", $9008fe5fa430f55b$export$6db28e89b135a53c = (0, $j5HK8.THIRTY_DAYS), $9008fe5fa430f55b$export$1e6a4dc5172f4830 = "Proposal expired", $9008fe5fa430f55b$export$a069e98a8dfeec1e = "session", $9008fe5fa430f55b$export$84b1b9dbcdea0475 = (0, $j5HK8.SEVEN_DAYS), $9008fe5fa430f55b$export$2db42d5151ad6eb8 = "engine", $9008fe5fa430f55b$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $j5HK8.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $j5HK8.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $j5HK8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $j5HK8.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $9008fe5fa430f55b$export$409f0c0a13a1b7c6 = {
    min: (0, $j5HK8.FIVE_MINUTES),
    max: (0, $j5HK8.SEVEN_DAYS)
}, $9008fe5fa430f55b$export$8602b201748df21a = {
    idle: "IDLE",
    active: "ACTIVE"
}, $9008fe5fa430f55b$export$40b296af21bd38a4 = "request", $9008fe5fa430f55b$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $9008fe5fa430f55b$var$as = Object.defineProperty, $9008fe5fa430f55b$var$cs = Object.defineProperties, $9008fe5fa430f55b$var$ls = Object.getOwnPropertyDescriptors, $9008fe5fa430f55b$var$de = Object.getOwnPropertySymbols, $9008fe5fa430f55b$var$ps = Object.prototype.hasOwnProperty, $9008fe5fa430f55b$var$hs = Object.prototype.propertyIsEnumerable, $9008fe5fa430f55b$var$ue = (w, r, e)=>r in w ? $9008fe5fa430f55b$var$as(w, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : w[r] = e, $9008fe5fa430f55b$var$g = (w, r)=>{
    for(var e in r || (r = {}))$9008fe5fa430f55b$var$ps.call(r, e) && $9008fe5fa430f55b$var$ue(w, e, r[e]);
    if ($9008fe5fa430f55b$var$de) for (var e of $9008fe5fa430f55b$var$de(r))$9008fe5fa430f55b$var$hs.call(r, e) && $9008fe5fa430f55b$var$ue(w, e, r[e]);
    return w;
}, $9008fe5fa430f55b$var$D = (w, r)=>$9008fe5fa430f55b$var$cs(w, $9008fe5fa430f55b$var$ls(r));
class $9008fe5fa430f55b$var$ds extends (0, $bd34dd86acf0ba1d$export$87df43c730effa30) {
    constructor(r){
        super(r), this.name = $9008fe5fa430f55b$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($dG33B))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $3d822aa3e3449a80$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $9008fe5fa430f55b$export$8602b201748df21a.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: $9008fe5fa430f55b$export$8602b201748df21a.idle,
            queue: []
        }, this.requestQueueDelay = (0, $j5HK8.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys($9008fe5fa430f55b$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, $j5HK8.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            await this.isInitialized();
            const s = $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let c = t, p, d = !1;
            if (c && (d = this.client.core.pairing.pairings.get(c).active), !c || !d) {
                const { topic: T, uri: _ } = await this.client.core.pairing.create();
                c = T, p = _;
            }
            const h = await this.client.core.crypto.generateKeyPair(), N = $9008fe5fa430f55b$export$4edb1ca37014192d.wc_sessionPropose.req.ttl || (0, $j5HK8.FIVE_MINUTES), m = (0, $3d822aa3e3449a80$export$b136d03015bfc12)(N), f = $9008fe5fa430f55b$var$g({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $7cf2ddfb76fcdbf7$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiryTimestamp: m
            }, o && {
                sessionProperties: o
            }), { reject: k, resolve: O, done: we } = (0, $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb)(N, $9008fe5fa430f55b$export$1e6a4dc5172f4830);
            if (this.events.once((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: T, session: _ })=>{
                if (T) k(T);
                else if (_) {
                    _.self.publicKey = h;
                    const B = $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, _), {
                        requiredNamespaces: f.requiredNamespaces,
                        optionalNamespaces: f.optionalNamespaces
                    });
                    await this.client.session.set(_.topic, B), await this.setExpiry(_.topic, _.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: _.peer.metadata
                    }), O(B);
                }
            }), !c) {
                const { message: T } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(T);
            }
            const W = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: f,
                throwOnFailedPublish: !0
            });
            return await this.setProposal(W, $9008fe5fa430f55b$var$g({
                id: W
            }, f)), {
                uri: p,
                approval: we
            };
        }, this.pair = async (e)=>(await this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            await this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: c, requiredNamespaces: p, optionalNamespaces: d } = o;
            a = a || "";
            const h = await this.client.core.crypto.generateKeyPair(), N = c.publicKey, m = await this.client.core.crypto.generateSharedKey(h, N);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.sendResult({
                id: s,
                topic: a,
                result: {
                    relay: {
                        protocol: t ?? "irn"
                    },
                    responderPublicKey: h
                }
            }), await this.client.proposal.delete(s, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const f = $9008fe5fa430f55b$var$g({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(m);
            const k = $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, f), {
                topic: m,
                requiredNamespaces: p,
                optionalNamespaces: d,
                pairingTopic: a,
                acknowledged: !1,
                self: f.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            await this.client.session.set(m, k);
            try {
                await this.sendRequest({
                    topic: m,
                    method: "wc_sessionSettle",
                    params: f,
                    throwOnFailedPublish: !0
                });
            } catch (O) {
                throw this.client.logger.error(O), this.client.session.delete(m, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(m), O;
            }
            return await this.setExpiry(m, (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$84b1b9dbcdea0475)), {
                topic: m,
                acknowledged: ()=>new Promise((O)=>setTimeout(()=>O(this.client.session.get(m)), 500))
            };
        }, this.reject = async (e)=>{
            await this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            await this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest({
                topic: s,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                }
            }), { done: n, resolve: o, reject: a } = (0, $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_update", i), ({ error: c })=>{
                c ? a(c) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            await this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest({
                topic: s,
                method: "wc_sessionExtend",
                params: {}
            }), { done: i, resolve: n, reject: o } = (0, $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            await this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n = $9008fe5fa430f55b$export$4edb1ca37014192d.wc_sessionRequest.req.ttl } = e, o = (0, $bcdc9d9062e38dd6$export$2f5364a5d4b80251)(), { done: a, resolve: c, reject: p } = (0, $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb)(n, "Request expired. Please try again.");
            return this.events.once((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: d, result: h })=>{
                d ? p(d) : c(h);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, t), {
                                expiryTimestamp: (0, $3d822aa3e3449a80$export$b136d03015bfc12)(n)
                            }),
                            chainId: s
                        },
                        expiry: n,
                        throwOnFailedPublish: !0
                    }).catch((h)=>p(h)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: s,
                        id: o
                    }), d();
                }),
                new Promise(async (d)=>{
                    const h = await (0, $3d822aa3e3449a80$export$e55bfdac47149a32)(this.client.core.storage, $9008fe5fa430f55b$export$a26ccd6441b7d638);
                    (0, $3d822aa3e3449a80$export$694a208c8abca99a)({
                        id: o,
                        topic: i,
                        wcDeepLink: h
                    }), d();
                }),
                a()
            ]).then((d)=>d[2]);
        }, this.respond = async (e)=>{
            await this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(t) ? await this.sendResult({
                id: i,
                topic: s,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            await this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest({
                    topic: s,
                    method: "wc_sessionPing",
                    params: {}
                }), { done: i, resolve: n, reject: o } = (0, $3d822aa3e3449a80$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            await this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest({
                topic: s,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                }
            });
        }, this.disconnect = async (e)=>{
            await this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) await this.sendRequest({
                topic: s,
                method: "wc_sessionDelete",
                params: (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession({
                topic: s,
                emitEvent: !1
            });
            else if (this.client.core.pairing.pairings.keys.includes(s)) await this.client.core.pairing.disconnect({
                topic: s
            });
            else {
                const { message: t } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISMATCHED_TOPIC", `Session or pairing topic not found: ${s}`);
                throw new Error(t);
            }
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $3d822aa3e3449a80$export$6fc4971bf8f326a)(s, e))), this.getPendingSessionRequests = ()=>this.client.pendingRequest.getAll(), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e)=>{
            const { topic: s, expirerHasDeleted: t = !1, emitEvent: i = !0, id: n = 0 } = e, { self: o } = this.client.session.get(s);
            await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(o.publicKey) && await this.client.core.crypto.deleteKeyPair(o.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), t || this.client.core.expirer.del(s), this.client.core.storage.removeItem($9008fe5fa430f55b$export$a26ccd6441b7d638).catch((a)=>this.client.logger.warn(a)), this.getPendingSessionRequests().forEach((a)=>{
                a.topic === s && this.deletePendingSessionRequest(a.id, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED"));
            }), i && this.client.events.emit("session_delete", {
                id: n,
                topic: s
            });
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), t && (this.sessionRequestQueue.state = $9008fe5fa430f55b$export$8602b201748df21a.idle, this.client.events.emit("session_request_expire", {
                id: e
            }));
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$4edb1ca37014192d.wc_sessionPropose.req.ttl));
        }, this.setPendingSessionRequest = async (e)=>{
            const { id: s, topic: t, params: i, verifyContext: n } = e, o = i.request.expiryTimestamp || (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$4edb1ca37014192d.wc_sessionRequest.req.ttl);
            await this.client.pendingRequest.set(s, {
                id: s,
                topic: t,
                params: i,
                verifyContext: n
            }), o && this.client.core.expirer.set(s, o);
        }, this.sendRequest = async (e)=>{
            const { topic: s, method: t, params: i, expiry: n, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = e, p = (0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)(t, i, a);
            if ((0, $3d822aa3e3449a80$export$4e09c449d6c407f7)() && $9008fe5fa430f55b$export$63c37d8ae5931ad5.includes(t)) {
                const N = (0, $3d822aa3e3449a80$export$d4c241cec96564c1)(JSON.stringify(p));
                this.client.core.verify.register({
                    attestationId: N
                });
            }
            const d = await this.client.core.crypto.encode(s, p), h = $9008fe5fa430f55b$export$4edb1ca37014192d[t].req;
            return n && (h.ttl = n), o && (h.id = o), this.client.core.history.set(s, p), c ? (h.internal = $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, d, h)) : this.client.core.relayer.publish(s, d, h).catch((N)=>this.client.logger.error(N)), p.id;
        }, this.sendResult = async (e)=>{
            const { id: s, topic: t, result: i, throwOnFailedPublish: n } = e, o = (0, $bcdc9d9062e38dd6$export$478fdea01c2a3198)(s, i), a = await this.client.core.crypto.encode(t, o), c = await this.client.core.history.get(t, s), p = $9008fe5fa430f55b$export$4edb1ca37014192d[c.request.method].res;
            n ? (p.internal = $9008fe5fa430f55b$var$D($9008fe5fa430f55b$var$g({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, p)) : this.client.core.relayer.publish(t, a, p).catch((d)=>this.client.logger.error(d)), await this.client.core.history.resolve(o);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $bcdc9d9062e38dd6$export$9f7302ae26c3f77)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $9008fe5fa430f55b$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                let i = !1;
                (0, $3d822aa3e3449a80$export$57947cfd429801a2)(t.expiry) && (i = !0), this.client.core.crypto.keychain.has(t.topic) || (i = !0), i && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $3d822aa3e3449a80$export$57947cfd429801a2)(t.expiryTimestamp) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession({
                        topic: t
                    })),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === $9008fe5fa430f55b$export$8602b201748df21a.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = $9008fe5fa430f55b$export$8602b201748df21a.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    this.processRequest(e), await new Promise((s)=>setTimeout(s, 300));
                } catch (s) {
                    this.client.logger.warn(s);
                }
            }
            this.requestQueue.state = $9008fe5fa430f55b$export$8602b201748df21a.idle;
        }, this.processRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($9008fe5fa430f55b$var$g({}, s.params));
                const n = t.expiryTimestamp || (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$4edb1ca37014192d.wc_sessionPropose.req.ttl), o = $9008fe5fa430f55b$var$g({
                    id: i,
                    pairingTopic: e,
                    expiryTimestamp: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $3d822aa3e3449a80$export$d4c241cec96564c1)(JSON.stringify(s)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const p = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && (await this.client.proposal.delete(t, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: c, sessionProperties: p, pairingTopic: d } = s.params, h = $9008fe5fa430f55b$var$g({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: d,
                    requiredNamespaces: {},
                    optionalNamespaces: {},
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, p && {
                    sessionProperties: p
                });
                await this.sendResult({
                    id: s.id,
                    topic: e,
                    result: !0
                }), this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: h
                }), this.cleanupDuplicatePairings(h);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && (await this.client.session.delete(e, (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                const n = `${e}_session_update`, o = (0, $3d822aa3e3449a80$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`);
                    return;
                }
                this.isValidUpdate($9008fe5fa430f55b$var$g({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult({
                    id: i,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                }), (0, $3d822aa3e3449a80$export$b72d712fed4d036d).set(n, i);
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.isRequestOutOfSync = (e, s)=>parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3)), this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $3d822aa3e3449a80$export$b136d03015bfc12)($9008fe5fa430f55b$export$84b1b9dbcdea0475)), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $7cf2ddfb76fcdbf7$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession({
                                topic: e,
                                id: t
                            }));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: e,
                        result: !0
                    }),
                    this.cleanupPendingSentRequestsForTopic({
                        topic: e,
                        error: (0, $3d822aa3e3449a80$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
                    })
                ]);
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($9008fe5fa430f55b$var$g({
                    topic: e
                }, i));
                const n = (0, $3d822aa3e3449a80$export$d4c241cec96564c1)(JSON.stringify((0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)("wc_sessionRequest", i, t))), o = this.client.session.get(e), a = await this.getVerifyContext(n, o.peer.metadata), c = {
                    id: t,
                    topic: e,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $21d319f26b46bae4$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: s.result
            }) : (0, $21d319f26b46bae4$export$5662a1047b4d1d15)(s) && this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                const n = `${e}_session_event_${i.event.name}`, o = (0, $3d822aa3e3449a80$export$b72d712fed4d036d).get(n);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit($9008fe5fa430f55b$var$g({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                }), (0, $3d822aa3e3449a80$export$b72d712fed4d036d).set(n, t);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = $9008fe5fa430f55b$export$8602b201748df21a.idle, this.processSessionRequestQueue();
            }, (0, $j5HK8.toMiliseconds)(this.requestQueueDelay));
        }, this.cleanupPendingSentRequestsForTopic = ({ topic: e, error: s })=>{
            const t = this.client.core.history.pending;
            t.length > 0 && t.filter((i)=>i.topic === e && i.request.method === "wc_sessionRequest").forEach((i)=>{
                this.events.emit((0, $3d822aa3e3449a80$export$e3eb27ce66c0f6d9)("session_request", i.request.id), {
                    error: s
                });
            });
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === $9008fe5fa430f55b$export$8602b201748df21a.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = $9008fe5fa430f55b$export$8602b201748df21a.active, this.client.events.emit("session_request", e);
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.onPairingCreated = (e)=>{
            if (e.active) return;
            const s = this.client.proposal.getAll().find((t)=>t.pairingTopic === e.topic);
            s && this.onSessionProposeRequest(e.topic, (0, $bcdc9d9062e38dd6$export$11d081ebb32d4398)("wc_sessionPropose", {
                requiredNamespaces: s.requiredNamespaces,
                optionalNamespaces: s.optionalNamespaces,
                relays: s.relays,
                proposer: s.proposer,
                sessionProperties: s.sessionProperties
            }, s.id));
        }, this.isValidConnect = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $3d822aa3e3449a80$export$fce6876652108ab)(s) || await this.isValidPairingTopic(s), !(0, $3d822aa3e3449a80$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $3d822aa3e3449a80$export$fce6876652108ab)(t) && (0, $3d822aa3e3449a80$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $3d822aa3e3449a80$export$fce6876652108ab)(i) && (0, $3d822aa3e3449a80$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $3d822aa3e3449a80$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $3d822aa3e3449a80$export$9e2b2cae22c6a8b3)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) throw new Error((0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $3d822aa3e3449a80$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, $3d822aa3e3449a80$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, $3d822aa3e3449a80$export$ee898ca48ab56c74)(i, !0)) {
                const { message: p } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(p);
            }
            (0, $3d822aa3e3449a80$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $3d822aa3e3449a80$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: c } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $3d822aa3e3449a80$export$1b3fc298be8c9a7b)(s)) {
                const { message: c } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, $3d822aa3e3449a80$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $3d822aa3e3449a80$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $3d822aa3e3449a80$export$57947cfd429801a2)(n)) {
                const { message: c } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $3d822aa3e3449a80$export$93f7b81dc815a714)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $3d822aa3e3449a80$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $3d822aa3e3449a80$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $3d822aa3e3449a80$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $3d822aa3e3449a80$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $3d822aa3e3449a80$export$59fba2af1ac782b)(n, $9008fe5fa430f55b$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$9008fe5fa430f55b$export$409f0c0a13a1b7c6.min} and ${$9008fe5fa430f55b$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            var s;
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: n } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(n);
            }
            const { topic: t, response: i } = e;
            try {
                await this.isValidSessionTopic(t);
            } catch (n) {
                throw (s = e?.response) != null && s.id && this.cleanupAfterResponse(e), n;
            }
            if (!(0, $3d822aa3e3449a80$export$1ae38cf0a848f651)(i)) {
                const { message: n } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(i)}`);
                throw new Error(n);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: o } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $3d822aa3e3449a80$export$144fc36610eb6522)(n, i)) {
                const { message: o } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $3d822aa3e3449a80$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $3d822aa3e3449a80$export$df2c67ef8baad16b)(n, i, t.name)) {
                const { message: o } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $3d822aa3e3449a80$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || (0, $7cf2ddfb76fcdbf7$export$7e3b1a28ddecdbaa),
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $3d822aa3e3449a80$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $7cf2ddfb76fcdbf7$export$d56245796e2837d).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $21d319f26b46bae4$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $21d319f26b46bae4$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $7cf2ddfb76fcdbf7$export$9013719d9206b0c1).expired, async (r)=>{
            const { topic: e, id: s } = (0, $3d822aa3e3449a80$export$93adeb0f16e8e51d)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession({
                topic: e,
                expirerHasDeleted: !0
            }), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, $7cf2ddfb76fcdbf7$export$ca3c0b962acf7b75).create, (r)=>this.onPairingCreated(r));
    }
    isValidPairingTopic(r) {
        if (!(0, $3d822aa3e3449a80$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $3d822aa3e3449a80$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $3d822aa3e3449a80$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $3d822aa3e3449a80$export$57947cfd429801a2)(this.client.session.get(r).expiry)) {
            await this.deleteSession({
                topic: r
            });
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.crypto.keychain.has(r)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic does not exist in keychain: ${r}`);
            throw await this.deleteSession({
                topic: r
            }), new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $3d822aa3e3449a80$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $3d822aa3e3449a80$export$53551be28ad5e34d)(r)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $3d822aa3e3449a80$export$57947cfd429801a2)(this.client.proposal.get(r).expiryTimestamp)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $3d822aa3e3449a80$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $9008fe5fa430f55b$var$us extends (0, $7cf2ddfb76fcdbf7$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $9008fe5fa430f55b$export$ae6c7a4f7ed730a1, $9008fe5fa430f55b$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $9008fe5fa430f55b$var$ge extends (0, $7cf2ddfb76fcdbf7$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $9008fe5fa430f55b$export$a069e98a8dfeec1e, $9008fe5fa430f55b$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $9008fe5fa430f55b$var$gs extends (0, $7cf2ddfb76fcdbf7$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $9008fe5fa430f55b$export$40b296af21bd38a4, $9008fe5fa430f55b$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $9008fe5fa430f55b$export$2e2bcd8739ae039 extends (0, $bd34dd86acf0ba1d$export$2ebcf6eeacedad44) {
    constructor(r){
        super(r), this.protocol = $9008fe5fa430f55b$export$4fa962fc67384e02, this.version = $9008fe5fa430f55b$export$61085c48796ff049, this.name = $9008fe5fa430f55b$export$8dffb3242f2c5f72.name, this.events = new (0, $dG33B.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $9008fe5fa430f55b$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $3d822aa3e3449a80$export$ba31e015127122bb)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $4c75a16aead80288$exports.pino)((0, $4c75a16aead80288$exports.getDefaultLoggerOptions)({
            level: r?.logger || $9008fe5fa430f55b$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $7cf2ddfb76fcdbf7$export$4143ab5b91744744)(r), this.logger = (0, $4c75a16aead80288$exports.generateChildLogger)(e, this.name), this.session = new $9008fe5fa430f55b$var$ge(this.core, this.logger), this.proposal = new $9008fe5fa430f55b$var$us(this.core, this.logger), this.pendingRequest = new $9008fe5fa430f55b$var$gs(this.core, this.logger), this.engine = new $9008fe5fa430f55b$var$ds(this);
    }
    static async init(r) {
        const e = new $9008fe5fa430f55b$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $4c75a16aead80288$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $9008fe5fa430f55b$export$90b8cff65c105172 = $9008fe5fa430f55b$var$ge, $9008fe5fa430f55b$export$bdf4ba258ec679dc = $9008fe5fa430f55b$export$2e2bcd8739ae039;



var $67phy = parcelRequire("67phy");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $ckJhP = parcelRequire("ckJhP");
parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
var $B8faE = parcelRequire("B8faE");
var $8aS14 = parcelRequire("8aS14");

var $d276p = parcelRequire("d276p");

class $65cde6c0197eb9cb$export$642f71372fab1590 {
    constructor(e){
        this.openModal = (0, $d276p.ModalCtrl).open, this.closeModal = (0, $d276p.ModalCtrl).close, this.subscribeModal = (0, $d276p.ModalCtrl).subscribe, this.setTheme = (0, $d276p.ThemeCtrl).setThemeConfig, (0, $d276p.ThemeCtrl).setThemeConfig(e), (0, $d276p.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await (parcelRequire("l2m1H"));
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, $d276p.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}



var $67phy = parcelRequire("67phy");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $ckJhP = parcelRequire("ckJhP");
parcelRequire("fzv2W");
var $8aS14 = parcelRequire("8aS14");
var $7aYgM = parcelRequire("7aYgM");







var $6qd2L = parcelRequire("6qd2L");
var $13742155a98448ab$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $13742155a98448ab$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $13742155a98448ab$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $6qd2L.platform;
    }
    return NodeInfo;
}();
var $13742155a98448ab$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $13742155a98448ab$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $13742155a98448ab$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $13742155a98448ab$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $13742155a98448ab$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $13742155a98448ab$var$REQUIRED_VERSION_PARTS = 3;
var $13742155a98448ab$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $13742155a98448ab$var$SEARCHBOX_UA_REGEX
    ]
];
var $13742155a98448ab$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $13742155a98448ab$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $13742155a98448ab$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $13742155a98448ab$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $13742155a98448ab$export$1184956100eddc3c(navigator.userAgent);
    return $13742155a98448ab$export$bf2c6630ab904918();
}
function $13742155a98448ab$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $13742155a98448ab$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $13742155a98448ab$export$89ca9f8ca1a50fd5(ua) {
    var data = $13742155a98448ab$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $13742155a98448ab$export$1184956100eddc3c(ua) {
    var matchedRule = $13742155a98448ab$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $13742155a98448ab$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $13742155a98448ab$var$REQUIRED_VERSION_PARTS) versionParts = $13742155a98448ab$var$__spreadArray($13742155a98448ab$var$__spreadArray([], versionParts, true), $13742155a98448ab$var$createVersionParts($13742155a98448ab$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $13742155a98448ab$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $13742155a98448ab$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $13742155a98448ab$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $13742155a98448ab$export$8fa985da04a86f0(name, version, os);
}
function $13742155a98448ab$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $13742155a98448ab$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $13742155a98448ab$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $13742155a98448ab$export$bf2c6630ab904918() {
    var isNode = typeof $6qd2L !== "undefined" && $6qd2L.version;
    return isNode ? new $13742155a98448ab$export$62457c674e0167c0($6qd2L.version.slice(1)) : null;
}
function $13742155a98448ab$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $j5HK8 = parcelRequire("j5HK8");

var $fa46d972e4c25083$exports = {};
"use strict";
Object.defineProperty($fa46d972e4c25083$exports, "__esModule", {
    value: true
});
$fa46d972e4c25083$exports.getWindowMetadata = void 0;

function $fa46d972e4c25083$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $42fc9f31ad639091$exports.getDocumentOrThrow();
        loc = $42fc9f31ad639091$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$fa46d972e4c25083$exports.getWindowMetadata = $fa46d972e4c25083$var$getWindowMetadata;


var $c33d0fbca0b8ee70$export$f9380c9a627682d3;
var $c33d0fbca0b8ee70$export$98e6a39c04603d36;
var $c33d0fbca0b8ee70$export$fac44ee5b035f737;
var $c33d0fbca0b8ee70$export$7a5253c0f62e0150;
var $c33d0fbca0b8ee70$export$a8c1621ea79325d3;
var $c33d0fbca0b8ee70$export$357523c63a2253b9;
var $c33d0fbca0b8ee70$export$44c361b8ec72ef7f;
"use strict";




const $c33d0fbca0b8ee70$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $c33d0fbca0b8ee70$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $c33d0fbca0b8ee70$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            "[",
                            $c33d0fbca0b8ee70$var$encode(index, options),
                            "]=",
                            $c33d0fbca0b8ee70$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            "[]=",
                            $c33d0fbca0b8ee70$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            ":list=",
                            $c33d0fbca0b8ee70$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $c33d0fbca0b8ee70$var$encode(key, options),
                                keyValueSep,
                                $c33d0fbca0b8ee70$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $c33d0fbca0b8ee70$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $c33d0fbca0b8ee70$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $c33d0fbca0b8ee70$var$encode(key, options),
                            "=",
                            $c33d0fbca0b8ee70$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $c33d0fbca0b8ee70$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $c33d0fbca0b8ee70$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $c33d0fbca0b8ee70$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$c33d0fbca0b8ee70$var$decode(item, options)) : value === null ? value : $c33d0fbca0b8ee70$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $c33d0fbca0b8ee70$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$c33d0fbca0b8ee70$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $c33d0fbca0b8ee70$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $c33d0fbca0b8ee70$var$encode(value, options) {
    if (options.encode) return options.strict ? $fb68c056088f0e6a$exports(value) : encodeURIComponent(value);
    return value;
}
function $c33d0fbca0b8ee70$var$decode(value, options) {
    if (options.decode) return $e3f49fb9a7fe1f8f$exports(value);
    return value;
}
function $c33d0fbca0b8ee70$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $c33d0fbca0b8ee70$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $c33d0fbca0b8ee70$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $c33d0fbca0b8ee70$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $c33d0fbca0b8ee70$var$extract(input) {
    input = $c33d0fbca0b8ee70$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $c33d0fbca0b8ee70$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $c33d0fbca0b8ee70$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $c33d0fbca0b8ee70$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $c33d0fbca0b8ee70$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $e78c9bd53c92ef94$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $c33d0fbca0b8ee70$var$decode(value, options);
        formatter($c33d0fbca0b8ee70$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $c33d0fbca0b8ee70$var$parseValue(value[k], options);
        else ret[key] = $c33d0fbca0b8ee70$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $c33d0fbca0b8ee70$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$c33d0fbca0b8ee70$export$f9380c9a627682d3 = $c33d0fbca0b8ee70$var$extract;
$c33d0fbca0b8ee70$export$98e6a39c04603d36 = $c33d0fbca0b8ee70$var$parse;
$c33d0fbca0b8ee70$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $c33d0fbca0b8ee70$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $c33d0fbca0b8ee70$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $c33d0fbca0b8ee70$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $c33d0fbca0b8ee70$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $c33d0fbca0b8ee70$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $c33d0fbca0b8ee70$var$encode(key, options) + "=" + $c33d0fbca0b8ee70$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$c33d0fbca0b8ee70$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $e78c9bd53c92ef94$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $c33d0fbca0b8ee70$var$parse($c33d0fbca0b8ee70$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $c33d0fbca0b8ee70$var$decode(hash, options)
    } : {});
};
$c33d0fbca0b8ee70$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$c33d0fbca0b8ee70$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $c33d0fbca0b8ee70$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $c33d0fbca0b8ee70$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $c33d0fbca0b8ee70$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $c33d0fbca0b8ee70$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $c33d0fbca0b8ee70$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$c33d0fbca0b8ee70$var$encodeFragmentIdentifier] ? $c33d0fbca0b8ee70$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$c33d0fbca0b8ee70$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$c33d0fbca0b8ee70$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $c33d0fbca0b8ee70$export$7a5253c0f62e0150(input, options);
    return $c33d0fbca0b8ee70$export$a8c1621ea79325d3({
        url: url,
        query: $e85104af5636d4bb$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$c33d0fbca0b8ee70$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $c33d0fbca0b8ee70$export$357523c63a2253b9(input, exclusionFilter, options);
};




var $6qd2L = parcelRequire("6qd2L");
const $fb950f674fec8a45$var$K = ":";
function $fb950f674fec8a45$export$4764229d78de4437(e) {
    const [n, t] = e.split($fb950f674fec8a45$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $fb950f674fec8a45$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($fb950f674fec8a45$var$K);
}
function $fb950f674fec8a45$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($fb950f674fec8a45$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $fb950f674fec8a45$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($fb950f674fec8a45$var$K);
}
function $fb950f674fec8a45$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $fb950f674fec8a45$export$2806d446053abd1d(e) {
    const { address: n } = $fb950f674fec8a45$export$276ab0158c66e3d(e);
    return n;
}
function $fb950f674fec8a45$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $fb950f674fec8a45$export$276ab0158c66e3d(e);
    return $fb950f674fec8a45$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $fb950f674fec8a45$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $fb950f674fec8a45$export$4764229d78de4437(n);
    return $fb950f674fec8a45$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $fb950f674fec8a45$export$aa4a6b630dfcfa83(e) {
    return $fb950f674fec8a45$export$d579bc26e95946b5(e, $fb950f674fec8a45$export$2806d446053abd1d);
}
function $fb950f674fec8a45$export$d5ee58c6b13696e9(e) {
    return $fb950f674fec8a45$export$d579bc26e95946b5(e, $fb950f674fec8a45$export$93512919ec2ab555);
}
function $fb950f674fec8a45$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $fb950f674fec8a45$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$fb950f674fec8a45$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $fb950f674fec8a45$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$fb950f674fec8a45$export$376384387cd15b27(r, o));
    }), t;
}
function $fb950f674fec8a45$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $fb950f674fec8a45$export$a524ae552db7912 = (e)=>e?.split(":"), $fb950f674fec8a45$export$85f23c05c80b194 = (e)=>{
    const n = e && $fb950f674fec8a45$export$a524ae552db7912(e);
    if (n) return n[3];
}, $fb950f674fec8a45$export$a8b149927aef7051 = (e)=>{
    const n = e && $fb950f674fec8a45$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $fb950f674fec8a45$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $fb950f674fec8a45$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $fb950f674fec8a45$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $fb950f674fec8a45$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$fb950f674fec8a45$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $fb950f674fec8a45$export$f7403969428298bd = "base10", $fb950f674fec8a45$export$49eb910ab2518105 = "base16", $fb950f674fec8a45$export$9bff723d552e6bcf = "base64pad", $fb950f674fec8a45$export$9560dad2a83e4f04 = "utf8", $fb950f674fec8a45$export$3425bd336a9673d8 = 0, $fb950f674fec8a45$export$406e97c329f0f3d4 = 1, $fb950f674fec8a45$var$Dn = 0, $fb950f674fec8a45$var$Te = 1, $fb950f674fec8a45$var$Z = 12, $fb950f674fec8a45$var$X = 32;
function $fb950f674fec8a45$export$a949d36eab55b41f() {
    const e = $c8893c01b49eb09f$exports.generateKeyPair();
    return {
        privateKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.secretKey, $fb950f674fec8a45$export$49eb910ab2518105),
        publicKey: (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e.publicKey, $fb950f674fec8a45$export$49eb910ab2518105)
    };
}
function $fb950f674fec8a45$export$d15a28e4f1821243() {
    const e = (0, $e8d7d54636de94dc$exports.randomBytes)($fb950f674fec8a45$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $fb950f674fec8a45$export$49eb910ab2518105);
}
function $fb950f674fec8a45$export$f8378f68e053f5c6(e, n) {
    const t = $c8893c01b49eb09f$exports.sharedKey((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $fb950f674fec8a45$export$49eb910ab2518105), (0, $9e7f19515ec15414$export$3004f64547af360e)(n, $fb950f674fec8a45$export$49eb910ab2518105), !0), r = new (0, $4488f47cea993102$exports.HKDF)((0, $90699891a8c8f5b5$exports.SHA256), t).expand($fb950f674fec8a45$var$X);
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(r, $fb950f674fec8a45$export$49eb910ab2518105);
}
function $fb950f674fec8a45$export$1e87d19d4aab5805(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $fb950f674fec8a45$export$49eb910ab2518105));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $fb950f674fec8a45$export$49eb910ab2518105);
}
function $fb950f674fec8a45$export$d4c241cec96564c1(e) {
    const n = (0, $90699891a8c8f5b5$exports.hash)((0, $9e7f19515ec15414$export$3004f64547af360e)(e, $fb950f674fec8a45$export$9560dad2a83e4f04));
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(n, $fb950f674fec8a45$export$49eb910ab2518105);
}
function $fb950f674fec8a45$export$e9d2f9ba70428fb6(e) {
    return (0, $9e7f19515ec15414$export$3004f64547af360e)(`${e}`, $fb950f674fec8a45$export$f7403969428298bd);
}
function $fb950f674fec8a45$export$7547a514ee29b9d4(e) {
    return Number((0, $e6600a05507ca982$export$f84e8e69fd4488a5)(e, $fb950f674fec8a45$export$f7403969428298bd));
}
function $fb950f674fec8a45$export$5b0f6292f11d1d18(e) {
    const n = $fb950f674fec8a45$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $fb950f674fec8a45$export$3425bd336a9673d8);
    if ($fb950f674fec8a45$export$7547a514ee29b9d4(n) === $fb950f674fec8a45$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.senderPublicKey, $fb950f674fec8a45$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $9e7f19515ec15414$export$3004f64547af360e)(e.iv, $fb950f674fec8a45$export$49eb910ab2518105) : (0, $e8d7d54636de94dc$exports.randomBytes)($fb950f674fec8a45$var$Z), o = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $fb950f674fec8a45$export$49eb910ab2518105)).seal(r, (0, $9e7f19515ec15414$export$3004f64547af360e)(e.message, $fb950f674fec8a45$export$9560dad2a83e4f04));
    return $fb950f674fec8a45$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $fb950f674fec8a45$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $4dc6ea184d480b85$exports.ChaCha20Poly1305)((0, $9e7f19515ec15414$export$3004f64547af360e)(e.symKey, $fb950f674fec8a45$export$49eb910ab2518105)), { sealed: t, iv: r } = $fb950f674fec8a45$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(o, $fb950f674fec8a45$export$9560dad2a83e4f04);
}
function $fb950f674fec8a45$export$dfdc1655ccc5b9cb(e) {
    if ($fb950f674fec8a45$export$7547a514ee29b9d4(e.type) === $fb950f674fec8a45$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $fb950f674fec8a45$export$9bff723d552e6bcf);
    }
    return (0, $e6600a05507ca982$export$f84e8e69fd4488a5)((0, $2a39c00b82d2af1d$export$ee1b3e54f0441b22)([
        e.type,
        e.iv,
        e.sealed
    ]), $fb950f674fec8a45$export$9bff723d552e6bcf);
}
function $fb950f674fec8a45$export$efcd34ab6248d3cd(e) {
    const n = (0, $9e7f19515ec15414$export$3004f64547af360e)(e, $fb950f674fec8a45$export$9bff723d552e6bcf), t = n.slice($fb950f674fec8a45$var$Dn, $fb950f674fec8a45$var$Te), r = $fb950f674fec8a45$var$Te;
    if ($fb950f674fec8a45$export$7547a514ee29b9d4(t) === $fb950f674fec8a45$export$406e97c329f0f3d4) {
        const d = r + $fb950f674fec8a45$var$X, l = d + $fb950f674fec8a45$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $fb950f674fec8a45$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $fb950f674fec8a45$export$177f3e316562333d(e, n) {
    const t = $fb950f674fec8a45$export$efcd34ab6248d3cd(e);
    return $fb950f674fec8a45$export$7949f60f2444aef2({
        type: $fb950f674fec8a45$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $e6600a05507ca982$export$f84e8e69fd4488a5)(t.senderPublicKey, $fb950f674fec8a45$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $fb950f674fec8a45$export$7949f60f2444aef2(e) {
    const n = e?.type || $fb950f674fec8a45$export$3425bd336a9673d8;
    if (n === $fb950f674fec8a45$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $fb950f674fec8a45$export$8c165704db2d5c15(e) {
    return e.type === $fb950f674fec8a45$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $fb950f674fec8a45$var$Bn = Object.defineProperty, $fb950f674fec8a45$var$Ue = Object.getOwnPropertySymbols, $fb950f674fec8a45$var$Gn = Object.prototype.hasOwnProperty, $fb950f674fec8a45$var$Wn = Object.prototype.propertyIsEnumerable, $fb950f674fec8a45$var$_e = (e, n, t)=>n in e ? $fb950f674fec8a45$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb950f674fec8a45$var$$e = (e, n)=>{
    for(var t in n || (n = {}))$fb950f674fec8a45$var$Gn.call(n, t) && $fb950f674fec8a45$var$_e(e, t, n[t]);
    if ($fb950f674fec8a45$var$Ue) for (var t of $fb950f674fec8a45$var$Ue(n))$fb950f674fec8a45$var$Wn.call(n, t) && $fb950f674fec8a45$var$_e(e, t, n[t]);
    return e;
};
const $fb950f674fec8a45$export$f12873d77424d47b = "ReactNative", $fb950f674fec8a45$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $fb950f674fec8a45$export$657dee6d5648750a = " ", $fb950f674fec8a45$export$96c3628b3b9d2079 = ":", $fb950f674fec8a45$export$98238152dfccf046 = "/", $fb950f674fec8a45$export$7f882bb969de14a3 = 2, $fb950f674fec8a45$export$77baccb4c6bd5852 = 1e3, $fb950f674fec8a45$export$e08b61c98317d88c = "js";
function $fb950f674fec8a45$export$8ee0fc9ee280b4ee() {
    return typeof $6qd2L < "u" && typeof $6qd2L.versions < "u" && typeof $6qd2L.versions.node < "u";
}
function $fb950f674fec8a45$export$f7a1e23e542d38e3() {
    return !(0, $42fc9f31ad639091$exports.getDocument)() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && navigator.product === $fb950f674fec8a45$export$f12873d77424d47b;
}
function $fb950f674fec8a45$export$4e09c449d6c407f7() {
    return !$fb950f674fec8a45$export$8ee0fc9ee280b4ee() && !!(0, $42fc9f31ad639091$exports.getNavigator)() && !!(0, $42fc9f31ad639091$exports.getDocument)();
}
function $fb950f674fec8a45$export$57570b1603cf6adb() {
    return $fb950f674fec8a45$export$f7a1e23e542d38e3() ? $fb950f674fec8a45$export$86b1301a63b15dd9.reactNative : $fb950f674fec8a45$export$8ee0fc9ee280b4ee() ? $fb950f674fec8a45$export$86b1301a63b15dd9.node : $fb950f674fec8a45$export$4e09c449d6c407f7() ? $fb950f674fec8a45$export$86b1301a63b15dd9.browser : $fb950f674fec8a45$export$86b1301a63b15dd9.unknown;
}
function $fb950f674fec8a45$export$40a40f90174d197c() {
    var e;
    try {
        return $fb950f674fec8a45$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $fb950f674fec8a45$export$c4147c69f6845da(e, n) {
    let t = $c33d0fbca0b8ee70$export$98e6a39c04603d36(e);
    return t = $fb950f674fec8a45$var$$e($fb950f674fec8a45$var$$e({}, t), n), e = $c33d0fbca0b8ee70$export$fac44ee5b035f737(t), e;
}
function $fb950f674fec8a45$export$ba31e015127122bb() {
    return (0, $fa46d972e4c25083$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $fb950f674fec8a45$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $fb950f674fec8a45$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $fb950f674fec8a45$export$20d4a3cb5829b8b6() {
    if ($fb950f674fec8a45$export$57570b1603cf6adb() === $fb950f674fec8a45$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $13742155a98448ab$export$17b446b869dad473)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $fb950f674fec8a45$export$4389b0987726d52d() {
    var e;
    const n = $fb950f674fec8a45$export$57570b1603cf6adb();
    return n === $fb950f674fec8a45$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $42fc9f31ad639091$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $fb950f674fec8a45$export$b55a4c6e272b719f(e, n, t) {
    const r = $fb950f674fec8a45$export$20d4a3cb5829b8b6(), o = $fb950f674fec8a45$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $fb950f674fec8a45$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $fb950f674fec8a45$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $fb950f674fec8a45$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $fb950f674fec8a45$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $fb950f674fec8a45$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $fb950f674fec8a45$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $fb950f674fec8a45$export$1e21530e896c0b0b(e, n = $fb950f674fec8a45$export$7f882bb969de14a3) {
    return $fb950f674fec8a45$export$7f00885504704576(e.split($fb950f674fec8a45$export$98238152dfccf046), n);
}
function $fb950f674fec8a45$export$80bffd46c37a96f6(e) {
    return $fb950f674fec8a45$export$1e21530e896c0b0b(e).join($fb950f674fec8a45$export$657dee6d5648750a);
}
function $fb950f674fec8a45$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $fb950f674fec8a45$export$7f00885504704576(e, n = $fb950f674fec8a45$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $fb950f674fec8a45$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $fb950f674fec8a45$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $fb950f674fec8a45$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $fb950f674fec8a45$export$85c927578394b28b = (e)=>e;
function $fb950f674fec8a45$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $fb950f674fec8a45$export$9a00dee1beb8f576(e) {
    return e.split($fb950f674fec8a45$export$657dee6d5648750a).map((n)=>$fb950f674fec8a45$export$e9f8fcacef3bca4b(n)).join($fb950f674fec8a45$export$657dee6d5648750a);
}
function $fb950f674fec8a45$export$cbf9e3cc9ffc85cb(e = (0, $j5HK8.FIVE_MINUTES), n) {
    const t = (0, $j5HK8.toMiliseconds)(e || (0, $j5HK8.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $fb950f674fec8a45$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $fb950f674fec8a45$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $fb950f674fec8a45$export$43ab92477f8713b9(e) {
    return $fb950f674fec8a45$export$187ab6574b2ae23f("topic", e);
}
function $fb950f674fec8a45$export$bd13103c2e5cc0c3(e) {
    return $fb950f674fec8a45$export$187ab6574b2ae23f("id", e);
}
function $fb950f674fec8a45$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $fb950f674fec8a45$export$b136d03015bfc12(e, n) {
    return (0, $j5HK8.fromMiliseconds)((n || Date.now()) + (0, $j5HK8.toMiliseconds)(e));
}
function $fb950f674fec8a45$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $j5HK8.toMiliseconds)(e);
}
function $fb950f674fec8a45$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $fb950f674fec8a45$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $fb950f674fec8a45$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $fb950f674fec8a45$export$57570b1603cf6adb();
        i === $fb950f674fec8a45$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $fb950f674fec8a45$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $fb950f674fec8a45$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($fb950f674fec8a45$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $fb950f674fec8a45$export$822d0bd1635d5360 = "irn";
function $fb950f674fec8a45$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $fb950f674fec8a45$export$822d0bd1635d5360
    };
}
function $fb950f674fec8a45$export$604e3deb95e1b734(e) {
    const n = (0, $d06ba0a3f54ef0e1$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $fb950f674fec8a45$var$bt = Object.defineProperty, $fb950f674fec8a45$var$Nt = Object.defineProperties, $fb950f674fec8a45$var$Ot = Object.getOwnPropertyDescriptors, $fb950f674fec8a45$var$qe = Object.getOwnPropertySymbols, $fb950f674fec8a45$var$St = Object.prototype.hasOwnProperty, $fb950f674fec8a45$var$wt = Object.prototype.propertyIsEnumerable, $fb950f674fec8a45$var$Be = (e, n, t)=>n in e ? $fb950f674fec8a45$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb950f674fec8a45$var$It = (e, n)=>{
    for(var t in n || (n = {}))$fb950f674fec8a45$var$St.call(n, t) && $fb950f674fec8a45$var$Be(e, t, n[t]);
    if ($fb950f674fec8a45$var$qe) for (var t of $fb950f674fec8a45$var$qe(n))$fb950f674fec8a45$var$wt.call(n, t) && $fb950f674fec8a45$var$Be(e, t, n[t]);
    return e;
}, $fb950f674fec8a45$var$Tt = (e, n)=>$fb950f674fec8a45$var$Nt(e, $fb950f674fec8a45$var$Ot(n));
function $fb950f674fec8a45$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $fb950f674fec8a45$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $c33d0fbca0b8ee70$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $fb950f674fec8a45$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $fb950f674fec8a45$export$3d24f408c2ac468a(i),
        expiryTimestamp: i.expiryTimestamp ? parseInt(i.expiryTimestamp, 10) : void 0
    };
}
function $fb950f674fec8a45$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $fb950f674fec8a45$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $fb950f674fec8a45$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $c33d0fbca0b8ee70$export$fac44ee5b035f737($fb950f674fec8a45$var$Tt($fb950f674fec8a45$var$It({
        symKey: e.symKey
    }, $fb950f674fec8a45$export$65c55c7ccd19bb8f(e.relay)), {
        expiryTimestamp: e.expiryTimestamp
    }));
}
var $fb950f674fec8a45$var$At = Object.defineProperty, $fb950f674fec8a45$var$Ut = Object.defineProperties, $fb950f674fec8a45$var$_t = Object.getOwnPropertyDescriptors, $fb950f674fec8a45$var$Ye = Object.getOwnPropertySymbols, $fb950f674fec8a45$var$$t = Object.prototype.hasOwnProperty, $fb950f674fec8a45$var$Ct = Object.prototype.propertyIsEnumerable, $fb950f674fec8a45$var$Je = (e, n, t)=>n in e ? $fb950f674fec8a45$var$At(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $fb950f674fec8a45$var$jt = (e, n)=>{
    for(var t in n || (n = {}))$fb950f674fec8a45$var$$t.call(n, t) && $fb950f674fec8a45$var$Je(e, t, n[t]);
    if ($fb950f674fec8a45$var$Ye) for (var t of $fb950f674fec8a45$var$Ye(n))$fb950f674fec8a45$var$Ct.call(n, t) && $fb950f674fec8a45$var$Je(e, t, n[t]);
    return e;
}, $fb950f674fec8a45$var$Dt = (e, n)=>$fb950f674fec8a45$var$Ut(e, $fb950f674fec8a45$var$_t(n));
function $fb950f674fec8a45$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $fb950f674fec8a45$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$fb950f674fec8a45$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $fb950f674fec8a45$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $fb950f674fec8a45$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $fb950f674fec8a45$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $fb950f674fec8a45$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $fb950f674fec8a45$export$a8daa26a7c60ef90(e, n) {
    const t = $fb950f674fec8a45$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $fb950f674fec8a45$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $fb950f674fec8a45$export$2994550cda701c96(n), s = $fb950f674fec8a45$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $fb950f674fec8a45$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), En = r[c].methods.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.methods) == null ? void 0 : C.includes(T);
        }), bn = r[c].events.filter((T)=>{
            var P, C;
            return (C = (P = s[c]) == null ? void 0 : P.events) == null ? void 0 : C.includes(T);
        }), Nn = h?.map((T)=>r[c].accounts.filter((P)=>P.includes(`${T}:`))).flat();
        l[c] = {
            chains: $fb950f674fec8a45$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, h),
            methods: $fb950f674fec8a45$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $fb950f674fec8a45$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $fb950f674fec8a45$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $fb950f674fec8a45$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $fb950f674fec8a45$export$dd404c96fbbb1ff8(e) {
    return $fb950f674fec8a45$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $fb950f674fec8a45$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$fb950f674fec8a45$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $fb950f674fec8a45$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $fb950f674fec8a45$export$dd404c96fbbb1ff8(s);
        o[u] = $fb950f674fec8a45$var$Dt($fb950f674fec8a45$var$jt({}, o[u]), {
            chains: $fb950f674fec8a45$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $fb950f674fec8a45$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $fb950f674fec8a45$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $fb950f674fec8a45$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $fb950f674fec8a45$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $fb950f674fec8a45$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $fb950f674fec8a45$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $fb950f674fec8a45$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $fb950f674fec8a45$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $fb950f674fec8a45$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $fb950f674fec8a45$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $fb950f674fec8a45$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $fb950f674fec8a45$export$ee898ca48ab56c74(e, n) {
    return n && $fb950f674fec8a45$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $fb950f674fec8a45$export$d6781b696a0576d1(e, n) {
    return n && $fb950f674fec8a45$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $fb950f674fec8a45$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $fb950f674fec8a45$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $fb950f674fec8a45$export$d46695d9c3664fe9(d), a = t[i];
        (!$fb950f674fec8a45$export$1468a49de573f7f9($fb950f674fec8a45$export$376384387cd15b27(i, a), u) || !$fb950f674fec8a45$export$1468a49de573f7f9(a.methods, l) || !$fb950f674fec8a45$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $fb950f674fec8a45$export$e544b39f0a22e47a(e) {
    return $fb950f674fec8a45$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $fb950f674fec8a45$export$49e4a5b6862e3c71(e) {
    if ($fb950f674fec8a45$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $fb950f674fec8a45$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $fb950f674fec8a45$export$bef94a5618bf18bf(e) {
    if ($fb950f674fec8a45$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $fb950f674fec8a45$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $fb950f674fec8a45$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $fb950f674fec8a45$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $fb950f674fec8a45$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $fb950f674fec8a45$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $fb950f674fec8a45$export$c12fced8176774f3(e) {
    let n = !0;
    return $fb950f674fec8a45$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$fb950f674fec8a45$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $fb950f674fec8a45$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $fb950f674fec8a45$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $fb950f674fec8a45$export$e544b39f0a22e47a(o) || (r = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $fb950f674fec8a45$export$e544b39f0a22e47a(e) || (r = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $fb950f674fec8a45$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $fb950f674fec8a45$export$df46c123d7e298ce(o, $fb950f674fec8a45$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $fb950f674fec8a45$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $fb950f674fec8a45$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $fb950f674fec8a45$export$49e4a5b6862e3c71(r) || (t = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $fb950f674fec8a45$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $fb950f674fec8a45$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $fb950f674fec8a45$export$b32541d63753af56(e, n) {
    let t = null;
    return $fb950f674fec8a45$export$c12fced8176774f3(e?.methods) ? $fb950f674fec8a45$export$c12fced8176774f3(e?.events) || (t = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $fb950f674fec8a45$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $fb950f674fec8a45$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $fb950f674fec8a45$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $fb950f674fec8a45$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $fb950f674fec8a45$export$16a0268bc22b47b0(e)) {
        const o = $fb950f674fec8a45$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $fb950f674fec8a45$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $fb950f674fec8a45$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $fb950f674fec8a45$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $fb950f674fec8a45$export$16a0268bc22b47b0(e)) {
        const r = $fb950f674fec8a45$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $fb950f674fec8a45$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $fb950f674fec8a45$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $fb950f674fec8a45$export$1b3fc298be8c9a7b(e) {
    return $fb950f674fec8a45$export$ee898ca48ab56c74(e.protocol, !0);
}
function $fb950f674fec8a45$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $fb950f674fec8a45$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $fb950f674fec8a45$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $fb950f674fec8a45$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $fb950f674fec8a45$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $fb950f674fec8a45$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$fb950f674fec8a45$export$d6781b696a0576d1(e.code, !1) || !e.message || !$fb950f674fec8a45$export$ee898ca48ab56c74(e.message, !1));
}
function $fb950f674fec8a45$export$1a2af3c017fb6d42(e) {
    return !($fb950f674fec8a45$export$fce6876652108ab(e) || !$fb950f674fec8a45$export$ee898ca48ab56c74(e.method, !1));
}
function $fb950f674fec8a45$export$1ae38cf0a848f651(e) {
    return !($fb950f674fec8a45$export$fce6876652108ab(e) || $fb950f674fec8a45$export$fce6876652108ab(e.result) && $fb950f674fec8a45$export$fce6876652108ab(e.error) || !$fb950f674fec8a45$export$d6781b696a0576d1(e.id, !1) || !$fb950f674fec8a45$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $fb950f674fec8a45$export$cbe4cdc5960cfa11(e) {
    return !($fb950f674fec8a45$export$fce6876652108ab(e) || !$fb950f674fec8a45$export$ee898ca48ab56c74(e.name, !1));
}
function $fb950f674fec8a45$export$144fc36610eb6522(e, n) {
    return !(!$fb950f674fec8a45$export$e544b39f0a22e47a(n) || !$fb950f674fec8a45$export$fb6db6038e742b14(e).includes(n));
}
function $fb950f674fec8a45$export$8db4804e3a6de711(e, n, t) {
    return $fb950f674fec8a45$export$ee898ca48ab56c74(t, !1) ? $fb950f674fec8a45$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $fb950f674fec8a45$export$df2c67ef8baad16b(e, n, t) {
    return $fb950f674fec8a45$export$ee898ca48ab56c74(t, !1) ? $fb950f674fec8a45$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $fb950f674fec8a45$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $fb950f674fec8a45$var$er(e), s = $fb950f674fec8a45$var$nr(n), i = Object.keys(o), d = Object.keys(s), l = $fb950f674fec8a45$var$pn(Object.keys(e)), c = $fb950f674fec8a45$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $fb950f674fec8a45$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $fb950f674fec8a45$export$1468a49de573f7f9(i, d) || (r = $fb950f674fec8a45$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $fb950f674fec8a45$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $fb950f674fec8a45$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($fb950f674fec8a45$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $fb950f674fec8a45$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $fb950f674fec8a45$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $fb950f674fec8a45$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $fb950f674fec8a45$var$er(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $fb950f674fec8a45$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $fb950f674fec8a45$var$nr(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $fb950f674fec8a45$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $fb950f674fec8a45$export$59fba2af1ac782b(e, n) {
    return $fb950f674fec8a45$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $fb950f674fec8a45$export$53c2fd0173ad2b80() {
    const e = $fb950f674fec8a45$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $fb950f674fec8a45$export$86b1301a63b15dd9.browser:
                n($fb950f674fec8a45$export$2f147c609a999e49());
                break;
            case $fb950f674fec8a45$export$86b1301a63b15dd9.reactNative:
                n($fb950f674fec8a45$export$1444c95b1570bd12());
                break;
            case $fb950f674fec8a45$export$86b1301a63b15dd9.node:
                n($fb950f674fec8a45$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $fb950f674fec8a45$export$2f147c609a999e49() {
    return $fb950f674fec8a45$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $fb950f674fec8a45$export$1444c95b1570bd12() {
    if ($fb950f674fec8a45$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $fb950f674fec8a45$export$aec5b2d627eec500() {
    return !0;
}
function $fb950f674fec8a45$export$600a1ee4bc680996(e) {
    switch($fb950f674fec8a45$export$57570b1603cf6adb()){
        case $fb950f674fec8a45$export$86b1301a63b15dd9.browser:
            $fb950f674fec8a45$export$d32b24f18d96c5f2(e);
            break;
        case $fb950f674fec8a45$export$86b1301a63b15dd9.reactNative:
            $fb950f674fec8a45$export$904edb1c18ec91c7(e);
            break;
        case $fb950f674fec8a45$export$86b1301a63b15dd9.node:
            break;
    }
}
function $fb950f674fec8a45$export$d32b24f18d96c5f2(e) {
    !$fb950f674fec8a45$export$f7a1e23e542d38e3() && $fb950f674fec8a45$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $fb950f674fec8a45$export$904edb1c18ec91c7(e) {
    $fb950f674fec8a45$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $fb950f674fec8a45$var$ae = {};
class $fb950f674fec8a45$export$b72d712fed4d036d {
    static get(n) {
        return $fb950f674fec8a45$var$ae[n];
    }
    static set(n, t) {
        $fb950f674fec8a45$var$ae[n] = t;
    }
    static delete(n) {
        delete $fb950f674fec8a45$var$ae[n];
    }
}



var $67phy = parcelRequire("67phy");

var $ckJhP = parcelRequire("ckJhP");

function $f5eb82b75b47d727$export$e3cecf4b77dd45d7(client) {
    return client.session.values[client.session.values.length - 1];
}
async function $f5eb82b75b47d727$export$97f2d6af95e164f5(client, pairingTopic) {
    await (0, $7aYgM.timeout)(client.ping({
        topic: pairingTopic
    }), (0, $ckJhP.PING_TIMEOUT));
    // We assume last session is the correct session, beacuse we are doing clean up and keeps only one pairing/session.
    const session = $f5eb82b75b47d727$export$e3cecf4b77dd45d7(client);
    return session;
}
async function $f5eb82b75b47d727$export$f7c62c73429afa28(client, options, configs) {
    const { requiredNamespaces: requiredNamespaces, optionalNamespaces: optionalNamespaces, pairingTopic: pairingTopic } = options;
    try {
        const { uri: uri, approval: approval } = await client.connect({
            requiredNamespaces: requiredNamespaces,
            optionalNamespaces: optionalNamespaces,
            pairingTopic: pairingTopic
        });
        // Open QRCode modal if a URI was returned (i.e. we're not connecting an existing pairing).
        let onCloseModal;
        if (uri) {
            /*
       * There are some wallets have been listed in WC itself (https://docs.walletconnect.com/cloud/explorer-submission),
       * Using `DISABLE_MODAL_AND_OPEN_LINK` option, we can directly open a specific desktop wallet.
       */ const redirectLink = configs.envs.DISABLE_MODAL_AND_OPEN_LINK;
            if (redirectLink) {
                const url = `${redirectLink}/wc?uri=${encodeURIComponent(uri)}`;
                window.open(url, "_blank", "noreferrer noopener");
            } else {
                // Create a flat array of all requested chains across namespaces.
                const allNamespaces = {
                    ...requiredNamespaces || {},
                    ...optionalNamespaces || {}
                };
                const standaloneChains = Object.values(allNamespaces).map((namespace)=>namespace.chains).flat();
                const modal = (0, $a73b202427b9e72e$export$f4be253ad5d01050)();
                modal.openModal({
                    uri: uri,
                    chains: standaloneChains
                });
                onCloseModal = new Promise((_, reject)=>{
                    modal.subscribeModal((state)=>{
                        // the modal was closed so reject the promise
                        if (!state.open) reject(new Error("Modal has been closed."));
                    });
                });
            }
        }
        const session = approval();
        if (onCloseModal) {
            const result = await Promise.race([
                session,
                onCloseModal
            ]);
            // We know onClose only reject a modal and never returns a value.
            return result;
        }
        return await session;
    } finally{
        (0, $a73b202427b9e72e$export$f4be253ad5d01050)().closeModal();
    }
}
function $f5eb82b75b47d727$export$4774a1f21338acb(client) {
    const pairings = client.pairing.getAll({
        active: true
    });
    const lastPairing = pairings.length > 0 ? pairings[pairings.length - 1] : undefined;
    return lastPairing;
}
async function $f5eb82b75b47d727$export$7215d6c263aa9e76(client, params) {
    const { meta: meta } = params;
    // We try to get all of our supported chains as optional.
    const optionalNamespaces = (0, $a73b202427b9e72e$export$246abed5cb9ad8b7)(meta);
    // Check if the user has a session, if yes, restore the session and use it.
    let session;
    const pairing = $f5eb82b75b47d727$export$4774a1f21338acb(client);
    if (pairing) try {
        session = await $f5eb82b75b47d727$export$97f2d6af95e164f5(client, pairing.topic);
    } catch (e) {
        await $f5eb82b75b47d727$export$bb9762dbf655cc61(client);
    }
    // In case of connecting for the first time or session couldn't be restored, we will create a new session.
    if (!session) session = await $f5eb82b75b47d727$export$f7c62c73429afa28(client, {
        requiredNamespaces: {},
        optionalNamespaces: optionalNamespaces
    }, {
        envs: params.envs
    });
    return session;
}
async function $f5eb82b75b47d727$export$82837ae09132684e(client, topic) {
    const sessions = client.session.getAll();
    const pairings = client.pairing.getAll();
    sessions.forEach((session)=>{
        if (session.topic === topic || session.pairingTopic === topic) {
            const requestForDeleteTopic = session.pairingTopic === topic ? session.pairingTopic : session.topic;
            client.core.expirer.set(requestForDeleteTopic, 0);
        }
    });
    pairings.forEach((pairing)=>{
        if (pairing.topic === topic) client.core.expirer.set(topic, 0);
    });
}
async function $f5eb82b75b47d727$export$bb9762dbf655cc61(client) {
    const allPromises = [];
    const sessions = client.session.getAll();
    for (const session of sessions)allPromises.push(client.disconnect({
        topic: session.topic,
        reason: (0, $fb950f674fec8a45$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
    }));
    const pairings = client.pairing.getAll();
    for (const pairing of pairings)allPromises.push(client.disconnect({
        topic: pairing.topic,
        reason: (0, $fb950f674fec8a45$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
    }));
    // reset the current chain id
    $f5eb82b75b47d727$export$d6555d45666e2426(client, undefined);
    return await Promise.all(allPromises);
}
function $f5eb82b75b47d727$export$797dcf9bf9d15555(session) {
    const accounts = Object.values(session.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $67phy.AccountId)(account);
        /*
       * Note: Solana has a specific ID, we need to convert it back to network name.
       * It will return the chain id itslef if it's not that specific ID.
       */ const chain = (0, $a73b202427b9e72e$export$6a4876fc98b55b42)(chainId.reference);
        return {
            address: address,
            chainId: chain
        };
    });
    return accounts;
}
function $f5eb82b75b47d727$export$728ff8346bb6c973(event) {
    const accounts = Object.values(event.params.namespaces).map((namespace)=>namespace.accounts).flat().map((account)=>{
        const { address: address, chainId: chainId } = new (0, $67phy.AccountId)(account);
        return {
            accounts: [
                address
            ],
            chainId: chainId.namespace === "solana" ? (0, $8aS14.LegacyNetworks).SOLANA : chainId.reference
        };
    });
    return accounts;
}
async function $f5eb82b75b47d727$export$1420fad475829053(instance, requestedNetwork, currentNetwork, meta) {
    const session = instance.session;
    const namespaces = session.namespaces;
    let needUpdateNamepspace = false;
    const accounts = namespaces.eip155.accounts;
    const currentAccountAddress = (0, $a73b202427b9e72e$export$1b7c4178e86d86b0)(instance);
    const requestedAccount = (0, $a73b202427b9e72e$export$7b89a811b933f464)(requestedNetwork, currentAccountAddress, meta);
    if (!accounts.includes(requestedAccount)) {
        accounts.push(requestedAccount);
        needUpdateNamepspace = true;
    }
    const currentAccount = (0, $a73b202427b9e72e$export$7b89a811b933f464)(currentNetwork, currentAccountAddress, meta);
    if (!accounts.includes(currentAccount)) {
        accounts.push(currentAccount);
        needUpdateNamepspace = true;
    }
    if (needUpdateNamepspace) {
        const updatedNamespaces = {
            ...namespaces,
            eip155: {
                ...namespaces.eip155,
                accounts: accounts
            }
        };
        await instance.client.session.update({
            topic: session.topic,
            namespaces: updatedNamespaces
        }).catch((err)=>{
            console.log(err);
        });
    }
}
function $f5eb82b75b47d727$export$84f4ff2dba79932a(instance) {
    const WALLETS_WITH_WRONG_NAMESPACE_METHODS = [
        "trust",
        "1inch"
    ];
    const peerName = instance?.session?.peer?.metadata?.name;
    return WALLETS_WITH_WRONG_NAMESPACE_METHODS.some((name)=>peerName?.toLowerCase()?.includes(name));
}
async function $f5eb82b75b47d727$export$d6555d45666e2426(client, chainId) {
    return client.core.storage.setItem((0, $ckJhP.CHAIN_ID_STORAGE), {
        defaultChainId: chainId ? parseInt(chainId) : ""
    });
}
async function $f5eb82b75b47d727$export$6223f21353aa8cdc(client) {
    try {
        const chainId = (await client.core.storage.getItem((0, $ckJhP.CHAIN_ID_STORAGE)))?.defaultChainId;
        return !!chainId ? String(chainId) : undefined;
    } catch  {
        return undefined;
    }
}


let $a73b202427b9e72e$var$web3Modal;
function $a73b202427b9e72e$export$cd9972eecd25d22(projectId) {
    if (!$a73b202427b9e72e$var$web3Modal) $a73b202427b9e72e$var$web3Modal = new (0, $65cde6c0197eb9cb$export$642f71372fab1590)({
        projectId: projectId,
        themeMode: "light",
        themeVariables: {
            "--wcm-z-index": "999999999"
        }
    });
}
function $a73b202427b9e72e$export$f4be253ad5d01050() {
    return $a73b202427b9e72e$var$web3Modal;
}
function $a73b202427b9e72e$export$246abed5cb9ad8b7(meta) {
    const evm = (0, $21GQj.evmBlockchains)(meta);
    const evmChains = evm.map((chain)=>{
        return new (0, $67phy.ChainId)({
            namespace: (0, $ckJhP.NAMESPACES).ETHEREUM,
            reference: String(parseInt(chain.chainId))
        }).toString();
    });
    const namespaces = {
        [(0, $ckJhP.NAMESPACES).ETHEREUM]: {
            methods: (0, $ckJhP.DEFAULT_ETHEREUM_METHODS),
            events: (0, $ckJhP.DEFAULT_ETHEREUM_EVENTS),
            chains: evmChains
        }
    };
    return namespaces;
}
function $a73b202427b9e72e$export$6a4876fc98b55b42(chainId) {
    return chainId === (0, $ckJhP.DEFAULT_SOLANA_CHAIN_ID) ? (0, $8aS14.LegacyNetworks).SOLANA : chainId;
}
async function $a73b202427b9e72e$export$218515c613c9d06f(params, provider, meta, getState) {
    if (params.method === "eth_chainId") {
        const currentSession = (0, $f5eb82b75b47d727$export$e3cecf4b77dd45d7)(provider);
        const standaloneChains = Object.values(currentSession.namespaces).map((namespace)=>namespace.chains).flat();
        const network = getState().network;
        if (standaloneChains.length > 0) {
            const chainId = network ? $a73b202427b9e72e$export$a98607e13f3cedcc(network, meta) : undefined;
            if (chainId) return chainId;
            const firstIndex = 0;
            const firstChain = standaloneChains[firstIndex];
            const firstChainId = new (0, $67phy.ChainId)(firstChain);
            return firstChainId.reference;
        }
        throw new Error(`Couldn't find any chain on namespace`);
    }
    throw new Error("Dissallowed method:", params);
}
function $a73b202427b9e72e$export$a98607e13f3cedcc(network, meta) {
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === network);
    const chainIdInHex = targetBlockchain?.chainId;
    if (!chainIdInHex) return undefined;
    const chainId = String(parseInt(chainIdInHex));
    return chainId;
}
async function $a73b202427b9e72e$export$d112ba85ab1851ef(meta, requestedNetwork, currentNetwork, instance) {
    const evmBlockchains = meta.filter((0, $21GQj.isEvmBlockchain));
    const evmNetworksChainInfo = (0, $7aYgM.convertEvmBlockchainMetaToEvmChainInfo)(evmBlockchains);
    const targetChain = evmNetworksChainInfo[requestedNetwork];
    const targetBlockchain = meta.find((blockchain)=>blockchain.name === requestedNetwork);
    const chainIdInHex = targetBlockchain?.chainId;
    const currentChainId = $a73b202427b9e72e$export$a98607e13f3cedcc(currentNetwork, meta);
    const currentChainEip = (0, $67phy.ChainId).format({
        namespace: (0, $ckJhP.NAMESPACES).ETHEREUM,
        reference: String(currentChainId)
    });
    const session = instance.session;
    try {
        await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $ckJhP.EthereumRPCMethods).SWITCH_CHAIN,
                params: [
                    {
                        chainId: chainIdInHex
                    }
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
    } catch (err) {
        const addChainError = 4902;
        if (err?.code === addChainError || err?.message?.includes(String(addChainError))) await instance.client.request({
            topic: session.topic,
            request: {
                method: (0, $ckJhP.EthereumRPCMethods).ADD_CHAIN,
                params: [
                    targetChain
                ]
            },
            // It's required to pass current chain, otherwise it won't work
            chainId: currentChainEip
        });
        else throw err;
    }
}
function $a73b202427b9e72e$export$1b7c4178e86d86b0(instance) {
    return instance.session.namespaces.eip155.accounts?.map((account)=>{
        return new (0, $67phy.AccountId)(account).address;
    })?.filter((address)=>(0, $B8faE.isAddress)(address))?.[0];
}
function $a73b202427b9e72e$export$7b89a811b933f464(network, address, meta) {
    const currentChainId = $a73b202427b9e72e$export$a98607e13f3cedcc(network, meta);
    return (0, $67phy.AccountId).format({
        chainId: {
            namespace: (0, $ckJhP.NAMESPACES).ETHEREUM,
            reference: String(currentChainId)
        },
        address: address
    });
}
function $a73b202427b9e72e$export$a39e82169bfefc19(accounts, currentChainId) {
    let firstEvmAddress = false;
    return accounts.filter(({ address: address, chainId: chainId })=>{
        const isEvm = (0, $B8faE.isAddress)(address);
        if (isEvm) {
            if (currentChainId && chainId !== currentChainId) return false;
            if (!currentChainId) {
                if (firstEvmAddress) return false;
                firstEvmAddress = true;
            }
        }
        return true;
    }).map(({ address: address, chainId: chainId })=>({
            accounts: [
                address
            ],
            chainId: chainId
        }));
}



parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");



async function $2631234018c38e4a$export$2e2bcd8739ae039(instance) {
    if (!instance.session) throw new Error("Session is required for wallet connect signers.");
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const EVMSigner = (await (parcelRequire("3tGm7"))).default;
    const COSMOSSigner = (await (parcelRequire("1agdN"))).default;
    const SOLANASigner = (await (parcelRequire("5Ocfb"))).default;
    signers.registerSigner((0, $liigz.TransactionType).EVM, new EVMSigner(instance.client, instance.session));
    signers.registerSigner((0, $liigz.TransactionType).COSMOS, new COSMOSSigner(instance.client, instance.session));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new SOLANASigner(instance.client, instance.session));
    return signers;
}


const $6ef47812c6c4098a$var$WALLET = (0, $yEwlv.WalletTypes).WALLET_CONNECT_2;
let $6ef47812c6c4098a$var$envs = {
    WC_PROJECT_ID: "",
    DISABLE_MODAL_AND_OPEN_LINK: undefined
};
const $6ef47812c6c4098a$export$2cd8252107eb640b = (environments)=>{
    $6ef47812c6c4098a$var$envs = environments;
    (0, $a73b202427b9e72e$export$cd9972eecd25d22)($6ef47812c6c4098a$var$envs.WC_PROJECT_ID);
};
const $6ef47812c6c4098a$export$e506a1d27d1eaa20 = {
    type: $6ef47812c6c4098a$var$WALLET,
    checkInstallation: false,
    isAsyncInstance: true,
    defaultNetwork: (0, $ckJhP.DEFAULT_NETWORK),
    isAsyncSwitchNetwork: true
};
const $6ef47812c6c4098a$export$8bedcca5bbd73999 = async (options)=>{
    const { currentProvider: currentProvider, getState: getState, meta: meta } = options;
    /*
   * Create a new pair, if exists use the pair,
   * Or use the already created one.
   */ let provider;
    if (!currentProvider) {
        if (!$6ef47812c6c4098a$var$envs.WC_PROJECT_ID) throw new Error("You need to set `WC_PROJECT_ID` in Wallet Connect provider.");
        provider = await (0, $9008fe5fa430f55b$export$2e2bcd8739ae039).init({
            relayUrl: (0, $ckJhP.RELAY_URL),
            projectId: $6ef47812c6c4098a$var$envs.WC_PROJECT_ID,
            metadata: (0, $ckJhP.DEFAULT_APP_METADATA)
        });
    } else provider = currentProvider;
    return {
        client: provider,
        session: null,
        request: async (params)=>(0, $a73b202427b9e72e$export$218515c613c9d06f)(params, provider, meta, getState)
    };
};
const $6ef47812c6c4098a$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const { client: client } = instance;
    // Try to restore the session first, if couldn't, create a new session by showing a modal.
    const session = await (0, $f5eb82b75b47d727$export$7215d6c263aa9e76)(client, {
        meta: meta,
        envs: $6ef47812c6c4098a$var$envs
    });
    // Override the value (session).
    instance.session = session;
    const currentChainId = await (0, $f5eb82b75b47d727$export$6223f21353aa8cdc)(client);
    const accounts = (0, $f5eb82b75b47d727$export$797dcf9bf9d15555)(session);
    return (0, $a73b202427b9e72e$export$a39e82169bfefc19)(accounts, currentChainId);
};
const $6ef47812c6c4098a$export$ec068583843480e7 = ({ instance: instance, updateChainId: updateChainId, updateAccounts: updateAccounts, disconnect: disconnect })=>{
    const { client: client } = instance;
    /**
   * Session events refrence:
   * https://docs.walletconnect.com/2.0/specs/clients/sign/session-events
   */ // Listen to updating the session by adding a new chain, method, or event
    client.on("session_update", (args)=>{
        const allAccounts = (0, $f5eb82b75b47d727$export$728ff8346bb6c973)(args);
        allAccounts.forEach((accountsWithChain)=>{
            updateAccounts(accountsWithChain.accounts, accountsWithChain.chainId);
        });
    });
    // Listen to events triggred by wallet. (e.g. accountsChanged and chainChanged)
    client.on("session_event", (args)=>{
        if (args.params.event.name === (0, $ckJhP.EthereumEvents).ACCOUNTS_CHANGED) {
            const accounts = args.params.event.data.map((account)=>{
                return new (0, $67phy.AccountId)(account).address;
            });
            const chainId = (0, $67phy.ChainId).parse(args.params.chainId).reference;
            updateAccounts(accounts);
            updateChainId(chainId);
        } else if (args.params.event.name === (0, $ckJhP.EthereumEvents).CHAIN_CHANGED) {
            const chainId = args.params.event.data;
            updateChainId(chainId);
            (0, $f5eb82b75b47d727$export$d6555d45666e2426)(instance.client, chainId);
        } else console.log("[WC2] session_event not supported", args.params.event);
    });
    client.on("session_delete", async (event)=>{
        console.log("[WC2] your wallet has requested to delete session.", event);
        (0, $f5eb82b75b47d727$export$82837ae09132684e)(client, event.topic);
        disconnect();
    });
};
const $6ef47812c6c4098a$export$f3473d805e486329 = async ({ network: network, instance: instance, meta: meta, getState: getState, updateChainId: updateChainId })=>{
    const evm = (0, $21GQj.evmBlockchains)(meta);
    const chainId = evm.find((chain)=>chain.name === network)?.chainId;
    if (!chainId) {
        const error = new Error(`There is no match for ${chainId}`);
        (0, $2d0ef42914e3f734$export$a3bc9b8ed74fc)(error);
        throw error;
    }
    const chaindIdStr = new (0, $67phy.ChainId)({
        namespace: (0, $ckJhP.NAMESPACES).ETHEREUM,
        reference: String(parseInt(chainId))
    }).toString();
    const session = instance.session;
    const evmNamespace = session.namespaces[(0, $ckJhP.NAMESPACES).ETHEREUM];
    const authorizedChains = evmNamespace?.chains || [];
    const authorizedMethods = evmNamespace?.methods || [];
    if (authorizedMethods.includes((0, $ckJhP.EthereumRPCMethods).SWITCH_CHAIN) && !(0, $f5eb82b75b47d727$export$84f4ff2dba79932a)(instance)) {
        const currentNetwork = getState?.().network || (0, $8aS14.LegacyNetworks).ETHEREUM;
        await (0, $f5eb82b75b47d727$export$1420fad475829053)(instance, network, currentNetwork, meta);
        await (0, $a73b202427b9e72e$export$d112ba85ab1851ef)(meta, network, currentNetwork, instance);
    } else if (authorizedChains.includes(chaindIdStr)) {
        updateChainId(chainId);
        return;
    } else {
        const error = new Error(`Chain ${chainId} is not configured.`);
        (0, $2d0ef42914e3f734$export$a3bc9b8ed74fc)(error);
        throw error;
    }
};
const $6ef47812c6c4098a$export$3b3cf9ab9019de20 = ()=>true;
const $6ef47812c6c4098a$export$37dfea93db2e14ed = async ({ instance: instance })=>{
    const { client: client } = instance;
    if (client) (0, $f5eb82b75b47d727$export$bb9762dbf655cc61)(client).catch((error)=>(0, $2d0ef42914e3f734$export$1c9f709888824e05)(error));
};
const $6ef47812c6c4098a$export$6352a17a50193ded = (0, $2631234018c38e4a$export$2e2bcd8739ae039);
const $6ef47812c6c4098a$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const evms = (0, $21GQj.evmBlockchains)(allBlockChains);
    return {
        name: "WalletConnect",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/walletconnect/icon.svg",
        installLink: "",
        color: "#b2dbff",
        supportedChains: evms,
        showOnMobile: true,
        mobileWallet: true
    };
};


var $5130c160e6867e70$exports = {};

$parcel$export($5130c160e6867e70$exports, "config", function () { return $5130c160e6867e70$export$e506a1d27d1eaa20; });
$parcel$export($5130c160e6867e70$exports, "getInstance", function () { return $5130c160e6867e70$export$8bedcca5bbd73999; });
$parcel$export($5130c160e6867e70$exports, "connect", function () { return $5130c160e6867e70$export$64605811ab45167f; });
$parcel$export($5130c160e6867e70$exports, "subscribe", function () { return $5130c160e6867e70$export$ec068583843480e7; });
$parcel$export($5130c160e6867e70$exports, "switchNetwork", function () { return $5130c160e6867e70$export$f3473d805e486329; });
$parcel$export($5130c160e6867e70$exports, "canSwitchNetworkTo", function () { return $5130c160e6867e70$export$3b3cf9ab9019de20; });
$parcel$export($5130c160e6867e70$exports, "getSigners", function () { return $5130c160e6867e70$export$6352a17a50193ded; });
$parcel$export($5130c160e6867e70$exports, "canEagerConnect", function () { return $5130c160e6867e70$export$be9f3c5ed1d25e42; });
$parcel$export($5130c160e6867e70$exports, "getWalletInfo", function () { return $5130c160e6867e70$export$e5b9d96c6aeb3ff7; });
$parcel$export($5130c160e6867e70$exports, "SUPPORTED_ETH_CHAINS", function () { return (parcelRequire("7TfHp")).SUPPORTED_ETH_CHAINS; });
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
var $jN5Ze = parcelRequire("jN5Ze");
var $7aYgM = parcelRequire("7aYgM");
var $yEwlv = parcelRequire("yEwlv");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $7TfHp = parcelRequire("7TfHp");

var $bUtcz = parcelRequire("bUtcz");
parcelRequire("fzv2W");
var $bHRZL = parcelRequire("bHRZL");
var $8aS14 = parcelRequire("8aS14");
parcelRequire("14sfz");
var $5QE4B = parcelRequire("5QE4B");
var $liigz = parcelRequire("liigz");




async function $7548f91f3e0e2a01$export$2e2bcd8739ae039(provider) {
    const ethProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solProvider = (0, $bHRZL.getNetworkInstance)(provider, (0, $8aS14.LegacyNetworks).SOLANA);
    const signers = new (0, $5QE4B.DefaultSignerFactory)();
    const { DefaultEvmSigner: DefaultEvmSigner } = await (parcelRequire("bWPjV"));
    const { CustomSolanaSigner: CustomSolanaSigner } = await (parcelRequire("c9no2"));
    const { CustomCosmosSigner: CustomCosmosSigner } = await (parcelRequire("9j7Xd"));
    const { CustomTransferSigner: CustomTransferSigner } = await (parcelRequire("7IVgN"));
    signers.registerSigner((0, $liigz.TransactionType).EVM, new DefaultEvmSigner(ethProvider));
    signers.registerSigner((0, $liigz.TransactionType).SOLANA, new CustomSolanaSigner(solProvider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $liigz.TransactionType).COSMOS, new CustomCosmosSigner(provider));
    // passed provider for transfer as it comprises several signers
    signers.registerSigner((0, $liigz.TransactionType).TRANSFER, new CustomTransferSigner(provider));
    return signers;
}


const $5130c160e6867e70$var$DEFAULT_NETWORK = (0, $8aS14.LegacyNetworks).ETHEREUM;
const $5130c160e6867e70$var$WALLET = (0, $yEwlv.WalletTypes).XDEFI;
const $5130c160e6867e70$export$e506a1d27d1eaa20 = {
    type: $5130c160e6867e70$var$WALLET,
    defaultNetwork: $5130c160e6867e70$var$DEFAULT_NETWORK
};
const $5130c160e6867e70$export$8bedcca5bbd73999 = (0, $bUtcz.xdefi);
const $5130c160e6867e70$export$64605811ab45167f = async ({ instance: instance, meta: meta })=>{
    const ethInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    const solInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).SOLANA);
    const cosmosInstance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).COSMOS);
    const evmResult = await (0, $bHRZL.getEvmAccounts)(ethInstance);
    const nonEvmResults = await (0, $bUtcz.getNonEvmAccounts)(instance);
    const solanaAccounts = await (0, $7aYgM.getSolanaAccounts)({
        instance: solInstance,
        meta: meta
    });
    const cosmosAccounts = [];
    if (cosmosInstance) {
        const cosmosBlockchainMeta = meta.filter((blockchainMeta)=>(0, $21GQj.isCosmosBlockchain)(blockchainMeta) && (0, $7TfHp.SUPPORTED_COSMOS_CHAINS).includes(blockchainMeta.name));
        const requestedNetwork = (0, $8aS14.LegacyNetworks).COSMOS;
        const cosmosResult = await (0, $jN5Ze.getCosmosAccounts)({
            instance: cosmosInstance,
            meta: cosmosBlockchainMeta,
            network: requestedNetwork
        });
        if (Array.isArray(cosmosResult)) cosmosAccounts.push(...cosmosResult);
        else cosmosAccounts.push(cosmosResult);
    }
    return [
        evmResult,
        ...nonEvmResults,
        solanaAccounts,
        ...cosmosAccounts
    ];
};
const $5130c160e6867e70$export$ec068583843480e7 = ({ instance: instance, meta: meta, updateChainId: updateChainId, connect: connect })=>{
    const handleChainChanged = (chainId)=>{
        const network = (0, $8aS14.legacyGetBlockChainNameFromId)(chainId, meta) || (0, $8aS14.LegacyNetworks).Unknown;
        /*
     *TODO:
     *We are calling `connect` here because signer can't detect
     *currect network, I guess the bug is in our signer and it
     *gets the wrong network by calling a wrong method or something.
     *Anyways, this works for now, maybe we can reconsider it in future
     *Whenever we refactored the signer code as well.
     */ /*
     *  we need to update `network` first, if not, it will goes through
     * the switching network and will open unneccessary pop ups.
     */ updateChainId(chainId);
        connect(network);
    };
    const eth = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    eth?.on?.("chainChanged", handleChainChanged);
    return ()=>{
        eth?.off?.("chainChanged", handleChainChanged);
    };
};
const $5130c160e6867e70$export$f3473d805e486329 = (0, $bHRZL.switchNetworkForEvm);
const $5130c160e6867e70$export$3b3cf9ab9019de20 = (0, $bHRZL.canSwitchNetworkToEvm);
const $5130c160e6867e70$export$6352a17a50193ded = (0, $7548f91f3e0e2a01$export$2e2bcd8739ae039);
const $5130c160e6867e70$export$be9f3c5ed1d25e42 = async ({ instance: instance, meta: meta })=>{
    const evm_instance = (0, $bHRZL.chooseInstance)(instance, meta, (0, $8aS14.LegacyNetworks).ETHEREUM);
    if (evm_instance) return (0, $bHRZL.canEagerlyConnectToEvm)({
        instance: evm_instance,
        meta: meta
    });
    return Promise.resolve(false);
};
const $5130c160e6867e70$export$e5b9d96c6aeb3ff7 = (allBlockChains)=>{
    const supportedCosmosChains = (0, $21GQj.cosmosBlockchains)(allBlockChains).filter((blockchainMeta)=>!!blockchainMeta.info && (0, $7TfHp.SUPPORTED_COSMOS_CHAINS).includes(blockchainMeta.name));
    const supportedChains = [
        ...allBlockChains.filter((blockchainMeta)=>[
                ...(0, $7TfHp.SUPPORTED_ETH_CHAINS),
                ...(0, $yEwlv.XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS),
                (0, $8aS14.LegacyNetworks).SOLANA
            ].includes(blockchainMeta.name)),
        ...supportedCosmosChains
    ];
    return {
        name: "XDefi",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/xdefi/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            BRAVE: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            DEFAULT: "https://xdefi.io/"
        },
        color: "#0646c7",
        supportedChains: supportedChains
    };
};


parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");
const $48570d6d4cf637ac$export$8b867028656ffdd3 = (providers, wallet)=>{
    return providers.length && !providers.find((provider)=>typeof provider === "string" ? provider === wallet.type : provider.getWalletInfo([]).name === wallet.name);
};


const $027163972054409b$export$e6f06807598c9e91 = (options)=>{
    const providers = options?.selectedProviders || [];
    if (!(0, $48570d6d4cf637ac$export$8b867028656ffdd3)(providers, {
        type: (0, $yEwlv.WalletTypes).WALLET_CONNECT_2,
        name: "WalletConnect"
    })) {
        if (!!options?.walletconnect2?.WC_PROJECT_ID) $6ef47812c6c4098a$exports.init(options.walletconnect2);
        else throw new Error('WalletConnect has been included in your providers. Passing a Project ID is required. Make sure you are passing "WC_PROJECT_ID".');
    }
    if (!(0, $48570d6d4cf637ac$export$8b867028656ffdd3)(providers, {
        type: (0, $yEwlv.WalletTypes).TREZOR,
        name: "Trezor"
    })) {
        if (!!options?.trezor?.manifest) $ef997ea342edd1ae$exports.init(options.trezor);
    }
    return [
        $7707aab27997e975$exports,
        $7e8974fedb2f4ea9$exports,
        $8aa8f19907af02ea$exports,
        $26682f018f34e7d8$exports,
        $6ef47812c6c4098a$exports,
        $dd12b1eb60b48a5f$exports,
        $eee36c7c5a4830f4$exports,
        $0b75c909d77fc239$exports,
        $ff5727fa66478b70$exports,
        $4023609387b7799f$exports,
        $bca53e3b1b1a5dd8$exports,
        $cf16142e144057c5$exports,
        $5130c160e6867e70$exports,
        $ff7388b706660096$exports,
        $e70dc9983ed0cd8f$exports,
        $efe06be440deeb8d$exports,
        $e2f989be5c77ee12$exports,
        $1f0372b1cf0a204d$exports,
        $ec2ba5c07821d2af$exports,
        $18d70c9a3b02d0e0$exports,
        $7a4eb50ac5cae5a3$exports,
        $9ef6de0b5bd1a5ea$exports,
        $1615b2cf8584bb6e$exports,
        $670e3547ef6a3ec6$exports,
        $97ef826e62a1917c$exports,
        $9c8858e43ac876c2$exports,
        $c6811752435011fa$exports,
        $4c7ba30550f08373$exports,
        $d5760f03f86ca6d0$exports,
        $b06d3627b37a3467$exports,
        $1209ff33b8a5cdc3$exports,
        $ef997ea342edd1ae$exports,
        $3eb7d8777ccd4c4b$exports
    ];
};


function $cac1229bf34c3204$export$eb12fafc925d4180(providers, options) {
    const all = (0, $027163972054409b$export$e6f06807598c9e91)({
        walletconnect2: {
            WC_PROJECT_ID: options?.walletConnectProjectId || "",
            DISABLE_MODAL_AND_OPEN_LINK: options?.walletConnectListedDesktopWalletLink
        },
        selectedProviders: providers,
        trezor: options?.trezorManifest ? {
            manifest: options.trezorManifest
        } : undefined
    });
    if (providers) {
        const selectedProviders = [];
        providers.forEach((requestedProvider)=>{
            /*
       * There are two types of provider we get, the first one is only passing the wallet name
       * then we will match the wallet name with our providers (@rango-dev/provider-*).
       * The second way is passing a custom provider which implemented ProviderInterface.
       */ if (typeof requestedProvider === "string") {
                const result = all.find((provider)=>{
                    return provider.config.type === requestedProvider;
                });
                if (result) selectedProviders.push(result);
                else console.warn(`Couldn't find ${requestedProvider} provider. Please make sure you are passing the correct name.`);
            } else // It's a custom provider so we directly push it to the list.
            selectedProviders.push(requestedProvider);
        });
        return selectedProviders;
    }
    return all;
}
function $cac1229bf34c3204$export$ea79493de4f3d5d9(config, options) {
    const providers = $cac1229bf34c3204$export$eb12fafc925d4180(config, options);
    const names = providers.map((provider)=>{
        return provider.config.type;
    });
    return names;
}




const $054d9182f00d4104$var$ALL_SUPPORTED_WALLETS = Object.values((0, $yEwlv.WalletTypes));
function $054d9182f00d4104$export$8c7712426fcad4df(params) {
    const { chain: chain } = params || {};
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { state: state, getWalletInfo: getWalletInfo } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const { connectedWallets: connectedWallets } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { handleDisconnect: handleDisconnect } = (0, $cd10f5b2a6cbb0dc$export$bccd57329105f7af)();
    /** It can be what has been set by widget config or as a fallback we use all the supported wallets by our library */ const listAvailableWalletTypes = (0, $cac1229bf34c3204$export$ea79493de4f3d5d9)(config?.wallets, {
        trezorManifest: config?.trezorManifest,
        walletConnectProjectId: config?.walletConnectProjectId,
        walletConnectListedDesktopWalletLink: config.__UNSTABLE_OR_INTERNAL__?.walletConnectListedDesktopWalletLink
    }) || $054d9182f00d4104$var$ALL_SUPPORTED_WALLETS;
    let wallets = (0, $b27897cbc1e94793$export$5a0148b6bada75e0)(state, getWalletInfo, listAvailableWalletTypes, chain);
    wallets = (0, $7aYgM.detectMobileScreens)() ? wallets.filter((wallet)=>wallet.showOnMobile !== false && state(wallet.type).installed) : wallets;
    const sortedWallets = (0, $b27897cbc1e94793$export$b93ff9484ececcd0)(wallets);
    const isExperimentalChainNotAdded = (walletType)=>!connectedWallets.find((connectedWallet)=>connectedWallet.walletType === walletType && connectedWallet.chain === chain);
    const terminateConnectingWallets = (0, $exYeM.useCallback)(()=>{
        const connectingWallets = wallets?.filter((wallet)=>wallet.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTING) || [];
        for (const wallet of connectingWallets)handleDisconnect(wallet.type);
    }, [
        (0, $b27897cbc1e94793$export$985326e893e48db7)(wallets)
    ]);
    (0, $exYeM.useEffect)(()=>{
        return ()=>{
            terminateConnectingWallets();
        };
    }, []);
    /*
   * Atm, we only support default injected wallet for the EVM
   * so we show default wallet when there is no other evm wallet installed
   * but we have ethereum injected
   */ const shouldShowDefaultInjectedWallet = (wallets)=>{
        // don't show default injected wallet when it's not installed
        const defaultWallet = wallets.find((wallet)=>wallet.type === (0, $yEwlv.WalletTypes).DEFAULT);
        if (!defaultWallet || defaultWallet.state === (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED) return false;
        /*
     * if we have another evm wallet installed (except wallet connect),
     * there is no need to show default injected wallet anymore
     */ const isEvmWalletInstalledExceptDefault = wallets.filter((wallet)=>wallet.state != (0, $b573446a19694996$export$ba984d729fe7282e).NOT_INSTALLED && ![
                (0, $yEwlv.WalletTypes).DEFAULT,
                (0, $yEwlv.WalletTypes).WALLET_CONNECT_2,
                (0, $yEwlv.WalletTypes).LEDGER
            ].includes(wallet.type) && getWalletInfo(wallet.type).supportedChains.filter((blockchain)=>blockchain.type == "EVM").length > 0);
        return isEvmWalletInstalledExceptDefault.length == 0;
    };
    const shouldExcludeWallet = (walletType, chain, blockchains)=>{
        return (0, $b27897cbc1e94793$export$61051f1588e51c47)(blockchains, chain) && isExperimentalChainNotAdded(walletType) && !(0, $yEwlv.KEPLR_COMPATIBLE_WALLETS).includes(walletType) || walletType == (0, $yEwlv.WalletTypes).DEFAULT && !shouldShowDefaultInjectedWallet(wallets);
    };
    return {
        list: sortedWallets.filter((wallet)=>!shouldExcludeWallet(wallet.type, chain ?? "", blockchains)),
        terminateConnectingWallets: terminateConnectingWallets
    };
}





var $exYeM = parcelRequire("exYeM");

const $375ef45cd13c05a1$export$3cf918ebc7e29d7a = 300;
const $375ef45cd13c05a1$export$138fd049d3297d2d = 100000;
const $375ef45cd13c05a1$export$ab9998995666ebe3 = "rango-widget";


class $831564c732c11912$export$59220c853884db6b {
    constructor(events){
        this.state = "not-initiated";
        this.events = {};
        this.init = ()=>{
            this.initEvents();
            this.tryClaim();
        };
        /**
   * This is applicable when a user in an inactive tab seeks to activate that tab.
   */ this.forceClaim = ()=>{
            if (!this.isClaimed()) {
                const message = {
                    name: "force-claim",
                    candidateId: this.tabId
                };
                this.channel.postMessage(message);
                setTimeout(()=>{
                    if (!this.isClaimed()) this.claim();
                }, (0, $375ef45cd13c05a1$export$3cf918ebc7e29d7a));
            }
        };
        this.isClaimed = ()=>{
            return this.state === "claimed";
        };
        /**
   * remove event listeners
   */ this.destroy = ()=>{
            this.channel.removeEventListener("message", this.handleMessageEvent);
            document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            document.removeEventListener("resume", this.handleResume);
        };
        this.handleMessageEvent = (event)=>{
            const name = event.data.name;
            switch(name){
                case "ping":
                    this.claimedByCurrentTab(event.data.pingAt);
                    break;
                case "pong":
                    this.alreadyClaimedByAnotherTab();
                    break;
                case "force-claim":
                    this.forceRelease(event.data.candidateId);
                    break;
                case "force-release":
                    if (this.tabId === event.data.candidateId) this.claim();
                    break;
                default:
                    throw new Error(`${name} is not supported.`);
            }
        };
        this.handleVisibilityChange = async ()=>{
            if (document.visibilityState === "visible") await this.tryClaim();
        };
        this.handleResume = async ()=>{
            if (this.isClaimed()) {
                await this.tryClaim();
                if (!this.isClaimed()) this.events.onRelease?.();
            }
        };
        this.channel = new BroadcastChannel((0, $375ef45cd13c05a1$export$ab9998995666ebe3));
        this.tabId = Math.trunc(Math.random() * (0, $375ef45cd13c05a1$export$138fd049d3297d2d));
        this.events = events;
    }
    /**
   * Reacting to messages and window events to claim.
   */ initEvents() {
        this.channel.addEventListener("message", this.handleMessageEvent);
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        /**
     * The "resume" event is currently supported only in certain browsers.
     * It is triggered when a previously frozen tab is unfrozen and resumes execution.
     * To avoid having multiple active tabs,
     * if the current tab is active after the "resume" event,
     * we send a signal to other tabs to verify if any of them currently claim to be active.
     * If this is the case, we deactivate the current tab.
     * https://developer.chrome.com/docs/web-platform/page-lifecycle-api
     */ document.addEventListener("resume", this.handleResume);
    }
    /**
   * Runs after a `ping` message and checks if current tab is claimed the tabs,
   *    if yes, it responds with `pong`, If not, it doesn't do anything.
   *
   * Note 1: If we receive a `ping` message,
   *    it means a tab is trying to claim tabs directly, usually it's the active tab.
   *
   * Note 2: If multiple tabs are opening at once, all of them are broadcasting `ping`
   *    and eventually all of them will `claim` the queue after the TIMEOUT.
   *    For avoiding this, we will accepts the oldest broadcasted ping. (`isPingSentBefore`)
   */ claimedByCurrentTab(pingAt) {
        const isPingSentBefore = this.lastTryClaim && this.lastTryClaim < pingAt;
        if (this.isClaimed() || isPingSentBefore) {
            const message = {
                name: "pong"
            };
            this.channel.postMessage(message);
            return;
        }
    }
    /**
   * Runs after receiving `pong` message, which means one of tabs already claimed the tabs.
   */ alreadyClaimedByAnotherTab() {
        this.resetLastCheck();
    }
    /**
   * Try to send a `ping` message to know if the tabs `claimed` or not.
   * On constructing instance, or whenever page is active we will try.
   */ async tryClaim() {
        /**
     * Try to ask from possible other running tabs.
     */ this.setLastCheck();
        return new Promise((resolve)=>{
            setTimeout(()=>{
                this.check();
                resolve();
            }, (0, $375ef45cd13c05a1$export$3cf918ebc7e29d7a));
        });
    }
    /**
   * If `lastCheck` is exist, it means there is no other tabs which `claimed` the tabs.
   * And we mark the current tab as `claimed`
   */ check() {
        if (this.state === "not-initiated") this.events.onInit?.();
        /**
     *it means we didn't get any response from other tabs, this tab can claim.
     */ if (this.lastTryClaim) {
            this.claim();
            this.resetLastCheck();
        } else this.state = "not-claimed";
    }
    claim() {
        this.state = "claimed";
        this.events.onClaim?.();
    }
    /**
   * Setting current time as `lastCheck` and broadcast a `ping` message event.
   */ setLastCheck() {
        this.lastTryClaim = Date.now();
        const message = {
            name: "ping",
            pingAt: this.lastTryClaim
        };
        this.channel.postMessage(message);
    }
    resetLastCheck() {
        this.lastTryClaim = undefined;
    }
    /**
   * Upon receipt of a "force-claim" message,
   * the presently active tab is expected to deactivate itself and initiate any attached callback associated with this event.
   */ forceRelease(nextActiveTab) {
        if (this.isClaimed()) {
            this.state = "not-claimed";
            this.events.onRelease?.();
            const message = {
                name: "force-release",
                candidateId: nextActiveTab
            };
            this.channel.postMessage(message);
        }
    }
}





const $0763b7f547a573fc$export$d4874efc85adb7db = (0, $e0ddf8b9111cc8ab$export$2e2bcd8739ae039)((0, $deedc9bfbd0dc16c$export$185802fd694ee1f5)()((set, get)=>({
        isActiveTab: false,
        tabManagerInitiated: false,
        showActivateTabModal: false,
        watermark: "NONE",
        fetchingApiConfig: false,
        activateCurrentTab: (setCurrentTabAsActive, hasRunningSwaps)=>{
            const { showActivateTabModal: showActivateTabModal } = get();
            if (!showActivateTabModal && hasRunningSwaps) set({
                showActivateTabModal: true
            });
            else if (showActivateTabModal || !hasRunningSwaps) setCurrentTabAsActive();
        },
        setShowActivateTabModal: (flag)=>{
            set({
                showActivateTabModal: flag
            });
        },
        setWatermark: (watermark)=>{
            set({
                watermark: watermark
            });
        }
    })));
const $0763b7f547a573fc$export$4a3066c505397ad1 = new (0, $831564c732c11912$export$59220c853884db6b)({
    onInit: ()=>$0763b7f547a573fc$export$d4874efc85adb7db.setState({
            tabManagerInitiated: true
        }),
    onClaim: ()=>$0763b7f547a573fc$export$d4874efc85adb7db.setState({
            isActiveTab: true,
            showActivateTabModal: false
        }),
    onRelease: ()=>$0763b7f547a573fc$export$d4874efc85adb7db.setState({
            isActiveTab: false
        })
});


function $95851a689b855275$export$c5f1eb137838e890(props) {
    const { watermark: watermark } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const hasWatermark = watermark === "FULL";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8f7c1be9e0a4b3b4$export$2b77a92f1a5ad772), {
        hasWatermark: hasWatermark,
        ...props
    }, props.children);
}






parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");

var $exYeM = parcelRequire("exYeM");


const $7313e18cfe57bf45$export$c7c73467b57835d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
    width: "$24",
    position: "relative",
    padding: "0",
    overflow: "unset",
    "&:hover": {
        backgroundColor: "$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral"
        }
    }
});
const $7313e18cfe57bf45$export$2789403f16b80e3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    background: "$secondary500",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$secondary250"
    },
    width: "$6",
    height: "$6",
    borderRadius: "$lg",
    right: "$4",
    border: "1px solid $surface100"
});
const $7313e18cfe57bf45$export$9baf379cdbf61443 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "$40",
    button: {
        padding: 0
    }
});
const $7313e18cfe57bf45$export$9d7cce4585963231 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    width: "14px",
    height: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "7px",
    top: "$0",
    right: "$0",
    variants: {
        isSever: {
            true: {
                backgroundColor: "$error500"
            },
            false: {
                backgroundColor: "$secondary500"
            }
        }
    }
});
const $7313e18cfe57bf45$export$91fe1a97e725639f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$2",
    variants: {
        isRefetched: {
            true: {
                transform: `rotate(360deg)`,
                transition: "transform 1s ease-in-out"
            }
        }
    }
});
const $7313e18cfe57bf45$export$4d2ac46462ee75ca = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    right: "$4",
    top: "$4",
    backgroundColor: "$background",
    borderRadius: "100%"
});
const $7313e18cfe57bf45$export$a3abe124fc948fcd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
});
const $7313e18cfe57bf45$export$3c76d375d5e2c498 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "100%",
    border: "1.5px transparent solid",
    "&:not(:first-child)": {
        marginLeft: "-$6"
    },
    img: {
        borderRadius: "100%"
    }
});



const $19d7b9c8ded56747$export$8f314e512d92575f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    backgroundColor: "$success300",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $19d7b9c8ded56747$export$d43ffeaaec0b2a58 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative"
});
const $19d7b9c8ded56747$var$spin = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $19d7b9c8ded56747$export$7f7cbe89f1eacd2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    border: "2px solid rgba(0, 0, 0, 0.1)",
    borderTop: "2px solid $info500",
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    animation: `${$19d7b9c8ded56747$var$spin} 1s linear infinite`,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
});
const $19d7b9c8ded56747$export$3c76d375d5e2c498 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});


function $ba87d225a6118ed6$export$ec91e38d2d4f6d28(blockchains, blockchainName) {
    return blockchains.find((blockchain)=>blockchain.name === blockchainName)?.logo;
}



const $9222c177cb8f05c7$export$b30ed44380481a45 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    padding: 0,
    paddingTop: "$4",
    paddingBottom: "$4"
});


function $8956f494711d6565$export$2f21297dc8e7cb72(props) {
    const { singleNamespace: singleNamespace, availableNamespaces: availableNamespaces, providerImage: providerImage } = props.value;
    const [selectedNamespaces, setSelectedNamespaces] = (0, $exYeM.useState)([]);
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const namespacesInfo = (0, $exYeM.useMemo)(()=>availableNamespaces?.map((namespace)=>({
                name: namespace,
                logo: (0, $ba87d225a6118ed6$export$ec91e38d2d4f6d28)(blockchains, (0, $yEwlv.namespaces)[namespace].mainBlockchain),
                title: (0, $yEwlv.namespaces)[namespace].title
            })), [
        availableNamespaces
    ]);
    const onSelect = (namespace)=>{
        if (singleNamespace) setSelectedNamespaces([
            namespace
        ]);
        else setSelectedNamespaces((selectedNamespaces)=>selectedNamespaces.includes(namespace) ? selectedNamespaces.filter((item)=>item !== namespace) : selectedNamespaces.concat(namespace));
    };
    const wrapRadioRoot = (children)=>{
        if (singleNamespace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $366ceca5f7810d8c$export$4d716843016d54fd), {
            value: selectedNamespaces?.[0]
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, children);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "info",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select chain types"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(`This wallet supports multiple chains. Select which chain you'd like to connect to.`),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: providerImage,
            size: 45
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$7f7cbe89f1eacd2), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9222c177cb8f05c7$export$b30ed44380481a45), null, wrapRadioRoot(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, namespacesInfo?.map((namespaceInfoItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
            key: namespaceInfoItem.name,
            id: namespaceInfoItem.name,
            title: namespaceInfoItem.title,
            hasDivider: true,
            style: {
                height: 60
            },
            onClick: ()=>onSelect(namespaceInfoItem.name),
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                src: namespaceInfoItem.logo,
                size: 22
            }),
            end: singleNamespace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $183ba84fee413071$export$d7b12c4107be0d61), {
                value: namespaceInfoItem.name
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c3cfb7c988c3f338$export$48513f6b9f8ce62d), {
                checked: selectedNamespaces.includes(namespaceInfoItem.name)
            })
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-name-space-confirm-btn",
        type: "primary",
        disabled: !selectedNamespaces.length,
        onClick: ()=>props.onConfirm(selectedNamespaces)
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm")));
}





var $exYeM = parcelRequire("exYeM");

parcelRequire("fzv2W");
var $yEwlv = parcelRequire("yEwlv");
const $d099ab48c549bbf8$export$972a27e5cb797ee1 = {
    id: "custom",
    label: "Custom",
    generateDerivationPath: (index)=>index
};
function $d099ab48c549bbf8$export$c66514fcb4b038d1(selectedNamespace) {
    const selectedNamespaceDerivationPaths = selectedNamespace ? (0, $yEwlv.namespaces)[selectedNamespace].derivationPaths : null;
    const derivationPaths = !!selectedNamespaceDerivationPaths ? [
        ...selectedNamespaceDerivationPaths,
        $d099ab48c549bbf8$export$972a27e5cb797ee1
    ] : [];
    return derivationPaths;
}



const $7b0c1f4017484b26$export$6ba5151b7290021c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingTop: "$30",
    paddingBottom: "$30",
    zIndex: 10
});
const $7b0c1f4017484b26$export$76d3231fec538b73 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    paddingLeft: "$10"
});
const $7b0c1f4017484b26$export$74041f85faebc215 = {
    height: "$40",
    backgroundColor: "$neutral200",
    borderRadius: "$sm"
};


const $c48bafa81adeae40$var$DEFAULT_DERIVATION_PATH_INDEX = "0";
function $c48bafa81adeae40$export$cfd6f0f481db5fd9(props) {
    const { onConfirm: onConfirm } = props;
    const { namespace: selectedNamespace, providerImage: image, providerType: type } = props.value;
    const [selectedDerivationPathId, setSelectedDerivationPathId] = (0, $exYeM.useState)(null);
    const [derivationPathIndex, setDerivationPathIndex] = (0, $exYeM.useState)($c48bafa81adeae40$var$DEFAULT_DERIVATION_PATH_INDEX);
    const isCustomOptionSelected = selectedDerivationPathId === (0, $d099ab48c549bbf8$export$972a27e5cb797ee1).id;
    const derivationPaths = (0, $d099ab48c549bbf8$export$c66514fcb4b038d1)(selectedNamespace);
    const handleDerivationPathItemClick = ({ value: value })=>{
        const selectedDerivationPath = derivationPaths?.find((derivationPath)=>derivationPath.id === value);
        if (selectedDerivationPath) {
            /*
       * Custom mode accepts string, but other modes only accepts number,
       * Here we are checking if user is on custom mode and trying to switch to another mode
       * if it's an string we will keep it, if not we will reset the value to default
       */ if (selectedDerivationPathId === (0, $d099ab48c549bbf8$export$972a27e5cb797ee1).id && Number.isNaN(Number(derivationPathIndex))) setDerivationPathIndex($c48bafa81adeae40$var$DEFAULT_DERIVATION_PATH_INDEX);
            setSelectedDerivationPathId(selectedDerivationPath.id);
        }
    };
    const handleConfirm = ()=>{
        const selectedDerivationPath = derivationPaths.find((derivationPath)=>derivationPath.id === selectedDerivationPathId);
        if (selectedDerivationPath) onConfirm(selectedDerivationPath.generateDerivationPath(derivationPathIndex));
        else // Unreachable code
        throw new Error("selectedDerivationPath can not be undefined");
    };
    (0, $exYeM.useEffect)(()=>{
        setSelectedDerivationPathId((0, $d099ab48c549bbf8$export$c66514fcb4b038d1)(selectedNamespace)[0]?.id || null);
    }, [
        selectedNamespace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "info",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Derivation Path"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "In order to connect to {type}, you must first select a Derivation Path",
            values: {
                type: type
            }
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: image,
            size: 45
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$7f7cbe89f1eacd2), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7b0c1f4017484b26$export$6ba5151b7290021c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7b0c1f4017484b26$export$76d3231fec538b73), {
        variant: "body",
        size: "xsmall",
        color: "$neutral600"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Choose Derivation Path Template")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $36de8fcf5878cc9c$export$c006741a65b06687), {
        value: selectedDerivationPathId || "",
        options: derivationPaths.map((derivationPath)=>({
                value: derivationPath.id,
                label: derivationPath.label
            })),
        variant: "filled",
        handleItemClick: handleDerivationPathItemClick,
        styles: {
            trigger: (0, $7b0c1f4017484b26$export$74041f85faebc215)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7b0c1f4017484b26$export$76d3231fec538b73), {
        variant: "body",
        size: "xsmall",
        color: "$neutral600"
    }, isCustomOptionSelected ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enter Path") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enter Index")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
        type: isCustomOptionSelected ? "text" : "number",
        variant: "contained",
        value: derivationPathIndex,
        onChange: (event)=>setDerivationPathIndex(event.target.value),
        style: (0, $7b0c1f4017484b26$export$74041f85faebc215)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-derivation-path-confirm-btn",
        type: "primary",
        onClick: handleConfirm,
        disabled: !derivationPaths || !selectedDerivationPathId || !derivationPathIndex
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm")));
}






var $exYeM = parcelRequire("exYeM");


function $260d4d37f107f7a4$export$b76f919f795d900a(props) {
    // See `wallet` notes on its type definition
    const { wallet: wallet, error: error } = props;
    const { type: type, image: image } = wallet;
    const { state: state } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const walletState = (0, $b27897cbc1e94793$export$6907ce8795f5a4df)(state(type));
    if (walletState === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "success",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Wallet Connected"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Your wallet is connected, you can use it to swap.")
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Failed to Connect"),
        description: error || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Your wallet is not connected. Please try again.")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "loading",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connecting to your wallet"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Click connect in your wallet popup."),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: image,
            size: 45
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19d7b9c8ded56747$export$7f7cbe89f1eacd2), null))
    });
}





var $exYeM = parcelRequire("exYeM");
function $621c234ddbd689a1$export$81938e7db5b62af2(props) {
    const { displayName: displayName, onConfirm: onConfirm } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Add {blockchainDisplayName} Chain",
            values: {
                blockchainDisplayName: displayName
            }
        }),
        type: "warning",
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Would you like to add the {blockchainDisplayName} experimental chain to your wallet?",
            values: {
                blockchainDisplayName: displayName
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-experimental-chain-confirm-btn",
        onClick: onConfirm,
        variant: "outlined",
        type: "primary",
        fullWidth: true,
        size: "large"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm")));
}




function $b491b3e9dee0a145$export$34d914d73342461(getState, wallet) {
    return getState().status === "init" && !!wallet;
}
function $b491b3e9dee0a145$export$ccc8fed7d7fe1e65(getState) {
    return getState().status === "namespace";
}
function $b491b3e9dee0a145$export$3daaaec1aac44f61(getState) {
    return getState().status === "derivationPath";
}


const $a533ccd38320000a$var$KEEP_SUCCESS_MODAL_FOR = 3000;
const $a533ccd38320000a$var$DELAY_SHOWING_MODAL_FOR = 300;
function $a533ccd38320000a$export$7710cdf1210cd2fb(props) {
    const successModalTimerId = (0, $exYeM.useRef)();
    const [isConnecting, setIsConnecting] = (0, $exYeM.useState)(false);
    const [error, setError] = (0, $exYeM.useState)();
    const catchErrorOnHandle = (error)=>{
        setError(error.message);
    };
    const { terminateConnectingWallets: terminateConnectingWallets } = (0, $054d9182f00d4104$export$8c7712426fcad4df)();
    const { handleConnect: handleConnect, handleDerivationPath: handleDerivationPath, handleNamespace: handleNamespace, getState: getState, resetState: resetState } = (0, $cd10f5b2a6cbb0dc$export$bccd57329105f7af)();
    const handleConfirmNamespaces = (selectedNamespaces)=>{
        handleNamespace(props.wallet, selectedNamespaces).catch(catchErrorOnHandle);
    };
    const handleDerivationPathConfirm = (derivationPath)=>{
        if (!derivationPath) throw new Error("Derivation path is empty. Please make sure you've filled the field correctly.");
        handleDerivationPath(derivationPath).catch(catchErrorOnHandle);
    };
    const handleClosingModal = ()=>{
        setIsConnecting(false);
    };
    const resetModalState = ()=>{
        setError(undefined);
        resetState();
        setIsConnecting(false);
        if (successModalTimerId.current) clearTimeout(successModalTimerId.current);
    };
    (0, $exYeM.useEffect)(()=>{
        if (props.wallet) {
            resetModalState();
            let isConnected = false;
            /*
       * If connecting to wallet is happening quickly, we shouldn't show a modal.
       * by default we are assuming we can connect quickly, but if it passes an certain amount of time
       * We set his flag as false which means we a modal has been opened (showing a connection status or Namespace/Derivation path modal)
       */ let isImmediatelyConnected = true;
            const beforeConnecting = ()=>{
                setTimeout(()=>{
                    isImmediatelyConnected = false;
                    if (!isConnected) setIsConnecting(true);
                }, $a533ccd38320000a$var$DELAY_SHOWING_MODAL_FOR);
            };
            const afterConnected = (result)=>{
                const resultIsConnected = result.status === (0, $610ef28624c7c1dc$export$7103a54af3e45080).Connected;
                const resultIsDisconnected = [
                    (0, $610ef28624c7c1dc$export$7103a54af3e45080).Disconnected,
                    (0, $610ef28624c7c1dc$export$7103a54af3e45080).DisconnectedUnhandled
                ].includes(result.status);
                const resultIsNeedMoreStepsToConnect = [
                    (0, $610ef28624c7c1dc$export$7103a54af3e45080).Namespace,
                    (0, $610ef28624c7c1dc$export$7103a54af3e45080).DerivationPath
                ].includes(result.status);
                if (!resultIsNeedMoreStepsToConnect) isConnected = true;
                if (resultIsConnected && !isImmediatelyConnected) successModalTimerId.current = setTimeout(handleClosingModal, $a533ccd38320000a$var$KEEP_SUCCESS_MODAL_FOR);
                else if (resultIsDisconnected) handleClosingModal();
                if (props.onConnect) props.onConnect(result);
            };
            beforeConnecting();
            handleConnect(props.wallet, {
                disconnectIfConnected: true
            }).then(afterConnected).catch(catchErrorOnHandle);
        }
    }, [
        props.wallet
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: isConnecting,
        onClose: handleClosingModal,
        onExit: ()=>{
            resetModalState();
            terminateConnectingWallets();
            if (props.onClose) props.onClose();
        },
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, (0, $b491b3e9dee0a145$export$34d914d73342461)(getState, props.wallet) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $260d4d37f107f7a4$export$b76f919f795d900a), {
        wallet: {
            type: props.wallet.type,
            image: props.wallet.image
        },
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "vertical",
        size: 32
    })), (0, $b491b3e9dee0a145$export$ccc8fed7d7fe1e65)(getState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8956f494711d6565$export$2f21297dc8e7cb72), {
        onConfirm: handleConfirmNamespaces,
        value: getState().namespace
    }), (0, $b491b3e9dee0a145$export$3daaaec1aac44f61)(getState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c48bafa81adeae40$export$cfd6f0f481db5fd9), {
        onConfirm: handleDerivationPathConfirm,
        value: getState().derivationPath
    }));
}











var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");


function $22ea59c12d8f7f87$export$ea638d66bbfffa37(providers) {
    return providers.map((provider)=>{
        if (typeof provider === "string") return provider;
        return provider.config.type;
    }).join("-");
}


function $79be19cec507ff6f$export$86b7849cd1e05a88(providers, options) {
    const clearConnectedWallet = (0, $41385c7b1441a578$export$63a06538da9383a6).use.clearConnectedWallet();
    let generateProviders = (0, $cac1229bf34c3204$export$eb12fafc925d4180)(providers, options);
    (0, $exYeM.useEffect)(()=>{
        clearConnectedWallet();
        generateProviders = (0, $cac1229bf34c3204$export$eb12fafc925d4180)(providers, options);
    }, [
        (0, $22ea59c12d8f7f87$export$ea638d66bbfffa37)(providers ?? []),
        options?.walletConnectProjectId,
        options?.walletConnectListedDesktopWalletLink
    ]);
    return {
        providers: generateProviders
    };
}








const $0b656bef82852b92$export$a0936c9989b92d74 = /*#__PURE__*/ (0, $exYeM.createContext)({
    onConnectWallet: ()=>{
        return;
    },
    onDisconnectWallet: ()=>{
        return;
    }
});
function $0b656bef82852b92$var$Main(props) {
    const { updateConfig: updateConfig, updateSettings: updateSettings, fetch: fetchMeta, fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const config = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().config;
    const walletOptions = {
        walletConnectProjectId: config?.walletConnectProjectId,
        trezorManifest: config?.trezorManifest,
        walletConnectListedDesktopWalletLink: props.config.__UNSTABLE_OR_INTERNAL__?.walletConnectListedDesktopWalletLink
    };
    const { providers: providers } = (0, $79be19cec507ff6f$export$86b7849cd1e05a88)(config.wallets, walletOptions);
    const { connectWallet: connectWallet, disconnectWallet: disconnectWallet } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const onConnectWalletHandler = (0, $exYeM.useRef)();
    const onDisconnectWalletHandler = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        fetchMeta().catch(console.log);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (props.config) {
            updateConfig(props.config);
            updateSettings(props.config);
            window["__rango"] = {
                config: config,
                dappConfig: props.config
            };
        }
    }, [
        props.config,
        fetchStatus
    ]);
    const evmBasedChainNames = blockchains.filter((0, $e0809f1f0dfba620$export$9d749b8b357dfab2)).map((chain)=>chain.name);
    const onUpdateState = (type, event, value, state, meta)=>{
        if (event === (0, $b5172e8f52f8965a$export$ada873a34909da65).ACCOUNTS) {
            if (value) {
                const supportedChainNames = (0, $b27897cbc1e94793$export$ac0949be5bbc1b7e)(meta.supportedBlockchains);
                const data = (0, $b27897cbc1e94793$export$468dee0f603364f)(type, value, evmBasedChainNames, supportedChainNames, meta.isContractWallet);
                if (data.length) connectWallet(data, findToken);
            } else {
                disconnectWallet(type);
                if (!!onDisconnectWalletHandler.current) onDisconnectWalletHandler.current(type);
                else console.warn(`onDisconnectWallet handler hasn't been set. Are you sure?`);
            }
        }
        if (event === (0, $b5172e8f52f8965a$export$ada873a34909da65).ACCOUNTS && state.connected) {
            const key = `${type}-${state.network}-${value}`;
            if (state.connected) {
                if (!!onConnectWalletHandler.current) onConnectWalletHandler.current(key);
                else console.warn(`onConnectWallet handler hasn't been set. Are you sure?`);
            }
        }
        if (event === (0, $b5172e8f52f8965a$export$ada873a34909da65).NETWORK && state.network) {
            const key = `${type}-${state.network}`;
            if (!!onConnectWalletHandler.current) onConnectWalletHandler.current(key);
            else console.warn(`onConnectWallet handler hasn't been set. Are you sure?`);
        }
        // propagate updates for Dapps using external wallets
        if (props.onUpdateState) props.onUpdateState(type, event, value, state, meta);
    };
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    const handlers = (0, $exYeM.useMemo)(()=>({
            onConnectWallet: (handler)=>{
                onConnectWalletHandler.current = handler;
            },
            onDisconnectWallet: (handler)=>{
                onDisconnectWalletHandler.current = handler;
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($0b656bef82852b92$export$a0936c9989b92d74.Provider, {
        value: handlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e812922bcaff6f9f$export$2e2bcd8739ae039), {
        allBlockChains: blockchains,
        providers: providers,
        onUpdateState: onUpdateState,
        autoConnect: !!isActiveTab
    }, props.children));
}
function $0b656bef82852b92$export$d1263745710d963c(props) {
    const { config: config, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9997ae2e4c8ece9b$export$5c53a35a4a26c364), {
        config: config
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($0b656bef82852b92$var$Main, {
        ...otherProps,
        config: config
    }));
}





var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

function $f45aff2ed35363b2$export$8707b35fd1c03f46({ children: children }) {
    const isRouterInContext = (0, $b0e6fcd50b7ef685$export$9c954a9d03d32f4a)();
    const Router = isRouterInContext ? (0, $exYeM.Fragment) : (0, $b0e6fcd50b7ef685$export$ae46f04cfaffe093);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Router, null, children);
}





var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

const $415b6399c61cd80f$export$492bdc31a14c4d1 = {
    home: "/",
    fromSwap: "from-swap",
    toSwap: "to-swap",
    blockchains: "blockchains",
    settings: "settings",
    customTokens: "custom-tokens",
    addCustomTokens: "add-custom-tokens",
    liquiditySources: "liquidity-sources",
    bridges: "bridges",
    exchanges: "exchanges",
    languages: "languages",
    swaps: "swaps",
    wallets: "wallets",
    confirmSwap: "confirm-swap",
    swapDetails: ":requestId",
    routes: "routes"
};



var $exYeM = parcelRequire("exYeM");


var $76r4H = parcelRequire("76r4H");






/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $76r4H = parcelRequire("76r4H");
function $0cffb0cab258d6b7$export$ddd0c2fa7802cfaa(fee, t) {
    const data = {
        "Network Fee": t("Network Fee"),
        "Swapper Fee": t("Protocol Fee"),
        "Affiliate Fee": t("Affiliate Fee"),
        "Outbound network fee": t("Outbound Fee"),
        "Rango Fee": t("Rango Fee")
    };
    return data[fee];
}
const $0cffb0cab258d6b7$export$a69883272d33ff0b = [
    "RECOMMENDED",
    "CENTRALIZED",
    "LOWEST_FEE",
    "FASTEST",
    "HIGH_IMPACT"
];
const $0cffb0cab258d6b7$export$637a7e4c3f8581d5 = 30;







/* eslint-disable @typescript-eslint/no-magic-numbers */ 


var $76r4H = parcelRequire("76r4H");
parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");


const $f273788a9b293b5f$export$d8bd0967cb58683 = ()=>{
    return {
        genericServerError: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Failed Network, Please retry your swap."),
        liquiditySourcesError: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Please reset your liquidity sources."),
            description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("You have limited the liquidity sources and this might result in Rango finding no routes. Please consider resetting your liquidity sources.")
        },
        noResultError: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No Routes Found."),
            description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Reasons why Rango couldn't find a route: low liquidity on token, very low input amount or no routes available for the selected input/output token combination.")
        },
        bridgeLimitErrors: {
            increaseAmount: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Bridge Limit Error: Please increase your amount."),
            decreaseAmount: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Bridge Limit Error: Please decrease your amount.")
        },
        highValueLossError: {
            impactTitle: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("High Price Impact"),
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Price impact is too high!"),
            description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("The price impact is significantly higher than the allowed amount."),
            confirmMessage: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm high price impact")
        },
        quoteUpdatedWithHighValueLoss: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Route updated and price impact is too high, try again later!")
        },
        unknownPriceError: {
            impactTitle: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("USD Price Unknown"),
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("USD Price Unknown, Cannot calculate Price Impact."),
            description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("USD Price Unknown, Cannot calculate Price Impact. The price impact may be higher than usual. Are you sure to continue the Swap?"),
            confirmMessage: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm USD Price Unknown")
        }
    };
};
function $f273788a9b293b5f$export$90611c8061ee618c(error) {
    switch(error.type){
        case (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT:
            return error.diagnosisMessage ?? $f273788a9b293b5f$export$d8bd0967cb58683().noResultError.title;
        case (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED:
            return $f273788a9b293b5f$export$d8bd0967cb58683().genericServerError;
        default:
            return "";
    }
}



const $0d4055cff0224c82$export$4d19bb19f409c9fe = ()=>{
    return {
        connectWallet: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect Wallet"),
        swap: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap"),
        swapAnyway: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap anyway"),
        ethWarning: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("The route goes through Ethereum. Continue?")
    };
};








function $8e9d7744e1038276$export$fa3d37198a547385(inputUsdValue, outputUsdValue) {
    if (!inputUsdValue || !outputUsdValue || inputUsdValue.lte((0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)) || outputUsdValue.lte((0, $fdd69898c00c1ed2$export$2a1795c9359f92b9))) return 0;
    return outputUsdValue.div(inputUsdValue).minus(1).multipliedBy(100).toNumber();
}
function $8e9d7744e1038276$export$cadf2b27a67febc2(inputUsdValue, priceImpact) {
    return (parseInt(priceImpact.toFixed(2) || "0") <= -10 && inputUsdValue?.gte(new (0, $76r4H.default)(400)) || parseInt(priceImpact.toFixed(2) || "0") <= -5 && inputUsdValue?.gte(new (0, $76r4H.default)(1000))) ?? false;
}
function $8e9d7744e1038276$export$78e0ca21c1421c3a(swaps) {
    return (swaps || []).filter((swap)=>{
        const minimum = !!swap.fromAmountMinValue ? new (0, $76r4H.default)(swap.fromAmountMinValue) : null;
        const maximum = !!swap.fromAmountMaxValue ? new (0, $76r4H.default)(swap.fromAmountMaxValue) : null;
        const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
        if (isExclusive) return minimum?.gte(swap.fromAmount) || maximum?.lte(swap.fromAmount);
        return minimum?.gt(swap.fromAmount) || maximum?.lt(swap.fromAmount);
    }).length > 0;
}
function $8e9d7744e1038276$export$5b3c7e829f29cdf0(swaps) {
    const swap = (swaps || []).filter((swap)=>{
        const minimum = !!swap.fromAmountMinValue ? new (0, $76r4H.default)(swap.fromAmountMinValue) : null;
        const maximum = !!swap.fromAmountMaxValue ? new (0, $76r4H.default)(swap.fromAmountMaxValue) : null;
        const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
        if (isExclusive) return minimum?.gte(swap.fromAmount) || maximum?.lte(swap.fromAmount);
        return minimum?.gt(swap.fromAmount) || maximum?.lt(swap.fromAmount);
    })[0];
    const minimum = !!swap.fromAmountMinValue ? new (0, $76r4H.default)(swap.fromAmountMinValue) : null;
    const maximum = !!swap.fromAmountMaxValue ? new (0, $76r4H.default)(swap.fromAmountMaxValue) : null;
    const isExclusive = swap.fromAmountRestrictionType === "EXCLUSIVE";
    let fromAmountRangeError = "";
    let recommendation = "";
    if (!isExclusive && !!minimum && minimum.gt(swap.fromAmount)) {
        fromAmountRangeError = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Required: >= {min} {symbol}",
            values: {
                min: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(minimum, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().bridgeLimitErrors.increaseAmount;
    } else if (isExclusive && !!minimum && minimum.gte(swap.fromAmount)) {
        fromAmountRangeError = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Required: > {min} {symbol}",
            values: {
                min: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(minimum, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().bridgeLimitErrors.increaseAmount;
    }
    if (!isExclusive && !!maximum && maximum.lt(swap.fromAmount)) {
        fromAmountRangeError = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Required: <= {max} {symbol}",
            values: {
                max: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(maximum, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().bridgeLimitErrors.decreaseAmount;
    } else if (isExclusive && !!maximum && maximum.lte(swap.fromAmount)) {
        fromAmountRangeError = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Required: < {max} {symbol}",
            values: {
                max: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(maximum, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                symbol: swap.from.symbol
            }
        });
        recommendation = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().bridgeLimitErrors.decreaseAmount;
    }
    return {
        swap: swap,
        fromAmountRangeError: fromAmountRangeError,
        recommendation: recommendation
    };
}
function $8e9d7744e1038276$export$cd3d5e5ada9115df(params) {
    const { fetchMetaStatus: fetchMetaStatus, anyWalletConnected: anyWalletConnected, fetchingQuote: fetchingQuote, inputAmount: inputAmount, quote: quote, warning: warning, error: error, needsToWarnEthOnPath: needsToWarnEthOnPath } = params;
    if (fetchMetaStatus !== "success") return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().connectWallet,
        action: "connect-wallet",
        disabled: true
    };
    if (!anyWalletConnected) return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().connectWallet,
        action: "connect-wallet",
        disabled: false
    };
    if (fetchingQuote || !quote || error || !inputAmount || inputAmount === "0") return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().swap,
        action: "confirm-swap",
        disabled: true
    };
    else if (warning) return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().swapAnyway,
        action: "confirm-warning",
        disabled: false
    };
    else if (needsToWarnEthOnPath) return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().ethWarning,
        action: "confirm-warning",
        disabled: false
    };
    return {
        title: (0, $0d4055cff0224c82$export$4d19bb19f409c9fe)().swap,
        action: "confirm-swap",
        disabled: false
    };
}
function $8e9d7744e1038276$export$281de2a4ae686054(quote, inputAmount, usdValue) {
    const inputAmountNumber = parseFloat(inputAmount || "0");
    return !(quote && (!usdValue || usdValue.lte((0, $fdd69898c00c1ed2$export$2a1795c9359f92b9))) && inputAmount && inputAmount !== "0" && inputAmountNumber !== 0);
}
function $8e9d7744e1038276$export$acbec34e083696b5(step, findToken) {
    let totalFeeInUsd = (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9);
    for(let i = 0; i < step.fee.length; i++){
        const fee = step.fee[i];
        if (fee.expenseType === "DECREASE_FROM_OUTPUT") continue;
        const unitPrice = findToken(fee.asset)?.usdPrice || null;
        totalFeeInUsd = totalFeeInUsd.plus(new (0, $76r4H.default)(fee.amount).multipliedBy(unitPrice || 0));
    }
    return totalFeeInUsd;
}
function $8e9d7744e1038276$export$684cb4cc81f91db3(swaps, findToken) {
    return swaps.reduce((totalFee, step)=>totalFee.plus($8e9d7744e1038276$export$acbec34e083696b5(step, findToken)), (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9));
}
function $8e9d7744e1038276$export$3d75576154c088e3(fee) {
    let totalFeeInUsd = (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9);
    totalFeeInUsd = totalFeeInUsd.plus(new (0, $76r4H.default)(fee.amount).multipliedBy(fee.price || 0));
    return totalFeeInUsd;
}
function $8e9d7744e1038276$export$b40dda5a0de0bf83(fees) {
    return fees.reduce((totalFee, fee)=>totalFee.plus($8e9d7744e1038276$export$3d75576154c088e3(fee)), (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9));
}
function $8e9d7744e1038276$export$583f50d85ee7d7be(swaps) {
    return swaps.reduce((result, swap)=>{
        for (const fee of swap.fee){
            const name = fee.name;
            const feeGroup = fee.expenseType !== "DECREASE_FROM_OUTPUT" ? result.payable : result.nonePayable;
            feeGroup[name] = [
                ...feeGroup[name] || [],
                fee
            ];
        }
        return result;
    }, {
        payable: {},
        nonePayable: {}
    });
}
function $8e9d7744e1038276$export$2d59ece324530d9e(totalFeeInUsd) {
    if (!totalFeeInUsd) return false;
    return !totalFeeInUsd.lt(new (0, $76r4H.default)(30));
}
function $8e9d7744e1038276$export$254459455117bf3(slippages) {
    return (slippages?.filter((s)=>!!s?.error)?.length || 0) > 0;
}
function $8e9d7744e1038276$export$a39b04dc395724b3(swaps) {
    const recommendedSlippages = new Map();
    swaps.forEach((swap, index)=>{
        if (swap.recommendedSlippage?.error) recommendedSlippages.set(index, swap.recommendedSlippage.slippage);
    });
    if (recommendedSlippages.size > 0) return recommendedSlippages;
    return null;
}
function $8e9d7744e1038276$export$b4e336809a24b023(quote, userSlippage) {
    const recommendedSlippages = new Map();
    quote?.swaps.forEach((swap, index)=>{
        if (swap.recommendedSlippage?.slippage && parseFloat(swap.recommendedSlippage.slippage) > userSlippage) recommendedSlippages.set(index, swap.recommendedSlippage.slippage);
    });
    if (recommendedSlippages.size > 0) return recommendedSlippages;
    return null;
}
function $8e9d7744e1038276$export$20a61b45ab42ee9c(swaps) {
    const slippages = swaps.map((slippage)=>slippage.recommendedSlippage);
    return slippages?.map((s)=>s?.slippage || "0")?.filter((s)=>parseFloat(s) > 0)?.sort((a, b)=>parseFloat(b) - parseFloat(a))?.find(()=>true) || null;
}
function $8e9d7744e1038276$export$eb9588acfa74eb26(userSlippage, minRequiredSlippage) {
    if (!minRequiredSlippage) return true;
    return parseFloat(userSlippage) >= parseFloat(minRequiredSlippage);
}
function $8e9d7744e1038276$export$3ae6dccbe779fd27(quote, selectedWallets) {
    const fee = quote.validationStatus;
    if (fee === null || fee.length === 0) return true;
    for (const wallet of selectedWallets){
        const requiredAssets = (0, $aae90cdd39be0d29$export$4ce5d18da71de2d4)(wallet, fee);
        if (!requiredAssets) continue;
        const enoughBalanceInWallet = requiredAssets.map((asset)=>asset.ok).reduce((previous, current)=>previous && current);
        if (!enoughBalanceInWallet) return false;
    }
    return true;
}
function $8e9d7744e1038276$export$98211b8b0335ec81(quote, selectedWallets, userSlippage, minRequiredSlippage) {
    return $8e9d7744e1038276$export$3ae6dccbe779fd27(quote, selectedWallets) && $8e9d7744e1038276$export$eb9588acfa74eb26(userSlippage, minRequiredSlippage);
}
function $8e9d7744e1038276$export$49491b4f1f3674fa(params) {
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, wallets: wallets, selectedWallets: selectedWallets, disabledLiquiditySources: disabledLiquiditySources, liquiditySources: liquiditySources, excludeLiquiditySources: excludeLiquiditySources, slippage: slippage, affiliateRef: affiliateRef, affiliatePercent: affiliatePercent, affiliateWallets: affiliateWallets, destination: destination, enableCentralizedSwappers: enableCentralizedSwappers } = params;
    const selectedWalletsMap = selectedWallets?.reduce((selectedWalletsMap, selectedWallet)=>(selectedWalletsMap[selectedWallet.chain] = selectedWallet.address, selectedWalletsMap), {});
    const connectedWallets = [];
    wallets?.forEach((wallet)=>{
        connectedWallets.push({
            blockchain: wallet.chain,
            addresses: [
                wallet.address
            ]
        });
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const requestBody = {
        amount: inputAmount.toString(),
        affiliateRef: affiliateRef ?? undefined,
        affiliatePercent: affiliatePercent ?? undefined,
        affiliateWallets: affiliateWallets ?? undefined,
        from: {
            address: fromToken.address,
            blockchain: fromToken.blockchain,
            symbol: fromToken.symbol
        },
        to: {
            address: toToken.address,
            blockchain: toToken.blockchain,
            symbol: toToken.symbol
        },
        connectedWallets: connectedWallets,
        selectedWallets: selectedWalletsMap ?? {},
        slippage: slippage.toString(),
        ...destination && {
            destination: destination
        },
        ...excludeLiquiditySources && {
            swapperGroups: disabledLiquiditySources.concat(liquiditySources ?? []),
            swappersGroupsExclude: true
        },
        ...!excludeLiquiditySources && {
            swapperGroups: liquiditySources?.filter((liquiditySource)=>!disabledLiquiditySources.includes(liquiditySource)),
            swappersGroupsExclude: false
        },
        enableCentralizedSwappers: enableCentralizedSwappers
    };
    return requestBody;
}
function $8e9d7744e1038276$export$16b1f1b35a7efc82(selectedWallets) {
    const wallets = selectedWallets.reduce((selectedWalletsMap, selectedWallet)=>(selectedWalletsMap[selectedWallet.chain] = {
            address: selectedWallet.address,
            walletType: selectedWallet.walletType
        }, selectedWalletsMap), {});
    return wallets;
}
function $8e9d7744e1038276$export$c255fe40da530e79(quote) {
    return quote?.outputAmount || null;
}
function $8e9d7744e1038276$export$f10d6a896d4ffbcf(input, output) {
    return new (0, $76r4H.default)(output).div(new (0, $76r4H.default)(input)).minus(1).multipliedBy(100).toNumber();
}
function $8e9d7744e1038276$export$a3d345d6bfa24457(oldQuote, newQuote) {
    const oldOutputAmount = $8e9d7744e1038276$export$c255fe40da530e79(oldQuote);
    const newOutputAmount = $8e9d7744e1038276$export$c255fe40da530e79(newQuote);
    if (!oldOutputAmount || !newOutputAmount) return false;
    const percentageChange = (0, $aae90cdd39be0d29$export$3cad4d44dd01c178)(oldOutputAmount, newOutputAmount);
    if (!percentageChange) return true;
    return percentageChange <= -1;
}
function $8e9d7744e1038276$export$f86a37bf67251d79(quote, selectedWallets, blockchains) {
    const fee = quote.validationStatus;
    const requiredWallets = (0, $b27897cbc1e94793$export$eb1ab48c3aa3d9f2)({
        filter: "required",
        quote: quote
    });
    const walletsSortedByRequiredWallets = selectedWallets.sort((selectedWallet1, selectedWallet2)=>requiredWallets.indexOf(selectedWallet1.chain) - requiredWallets.indexOf(selectedWallet2.chain));
    return walletsSortedByRequiredWallets.flatMap((wallet)=>(0, $aae90cdd39be0d29$export$4ce5d18da71de2d4)(wallet, fee) || []).filter((asset)=>!asset.ok).map((asset)=>{
        const symbol = asset.asset.symbol;
        const currentAmount = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(new (0, $76r4H.default)(asset.currentAmount.amount).shiftedBy(-asset.currentAmount.decimals), (0, $189a5d7f52888885$export$d562bc219e0ce311), (0, $189a5d7f52888885$export$971432a7539c584e));
        const requiredAmount = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(new (0, $76r4H.default)(asset.requiredAmount.amount).shiftedBy(-asset.requiredAmount.decimals), (0, $189a5d7f52888885$export$d562bc219e0ce311), (0, $189a5d7f52888885$export$971432a7539c584e));
        let reason = "";
        if (asset.reason === "FEE") reason = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(" for network fee");
        if (asset.reason === "INPUT_ASSET") reason = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(" for swap");
        if (asset.reason === "FEE_AND_INPUT_ASSET") reason = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(" for input and network fee");
        const warningMessage = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: `Needs \u{2248} {requiredAmount} {symbol}{reason}, but you have {currentAmount} {symbol} in your {blockchain} wallet.`,
            values: {
                requiredAmount: requiredAmount,
                symbol: symbol,
                reason: reason,
                currentAmount: currentAmount,
                blockchain: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(asset.asset.blockchain, blockchains)
            }
        });
        return warningMessage;
    });
}
function $8e9d7744e1038276$export$6f59f9bb345c1d58(outputAmount, tokenPrice) {
    const amount = !!outputAmount ? new (0, $76r4H.default)(outputAmount) : (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9);
    return amount.multipliedBy(tokenPrice || 0);
}
function $8e9d7744e1038276$export$69e0fdd2c54a443b(pendingSwapStep) {
    return !!pendingSwapStep && pendingSwapStep.networkStatus !== null && pendingSwapStep.networkStatus !== (0, $aQzGx.PendingSwapNetworkStatus).NetworkChanged;
}
function $8e9d7744e1038276$export$49d192cd6c2bb4ab(pendingSwap, currentStep) {
    const textForRemove = "bellow button or";
    let message = pendingSwap.extraMessage;
    let detailedMessage = pendingSwap.extraMessageDetail;
    if (pendingSwap.networkStatusExtraMessageDetail?.includes(textForRemove)) pendingSwap.networkStatusExtraMessageDetail = pendingSwap.networkStatusExtraMessageDetail.replace(textForRemove, "");
    const networkWarningState = $8e9d7744e1038276$export$69e0fdd2c54a443b(currentStep);
    if (networkWarningState) {
        message = pendingSwap.networkStatusExtraMessage || "";
        detailedMessage = pendingSwap.networkStatusExtraMessageDetail || "";
        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
        switch(currentStep?.networkStatus){
            case (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet:
                message = message || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Waiting for connecting wallet");
                break;
            case (0, $aQzGx.PendingSwapNetworkStatus).WaitingForQueue:
                message = message || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Waiting for other running tasks to be finished");
                break;
            case (0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange:
                message = message || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Waiting for changing wallet network");
                break;
            default:
                message = message || "";
                break;
        }
    }
    detailedMessage = detailedMessage || "";
    message = message || "";
    const isRpc = message?.indexOf("code") !== -1 && message?.indexOf("reason") !== -1;
    return {
        shortMessage: message,
        detailedMessage: {
            content: detailedMessage,
            long: isRpc
        }
    };
}
function $8e9d7744e1038276$export$855612345450ce78(pendingSwap) {
    let resultToken = null;
    if (pendingSwap.status === "failed") {
        const lastSuccessStep = pendingSwap.steps.slice().reverse().filter((step)=>step.status === "success")[0];
        if (lastSuccessStep) resultToken = {
            blockchain: lastSuccessStep.toBlockchain,
            symbol: lastSuccessStep.toSymbol,
            outputAmount: lastSuccessStep.outputAmount,
            address: lastSuccessStep.toSymbolAddress
        };
    }
    return resultToken;
}
function $8e9d7744e1038276$export$971830c6ceef0cca(pendingSwap) {
    return pendingSwap.status === "failed";
}
function $8e9d7744e1038276$export$f485b865770f4e4c(fetching, isCustomDestinationOpen, customDestination, quote, selectedWallets, lastStepToBlockchain) {
    if (!quote || fetching) return true;
    const allWallets = (0, $b27897cbc1e94793$export$eb1ab48c3aa3d9f2)({
        filter: "all",
        quote: quote
    });
    const requiredWallets = (0, $b27897cbc1e94793$export$eb1ab48c3aa3d9f2)({
        filter: "required",
        quote: quote
    });
    const everyWalletSelected = allWallets.every((blockchain)=>selectedWallets.some((selectedWallet)=>selectedWallet.chain === blockchain));
    const everyRequiredWalletSelected = requiredWallets.every((wallet)=>selectedWallets.some((selectedWallet)=>selectedWallet.chain === wallet));
    const customDestinationIsValid = customDestination && lastStepToBlockchain ? (0, $76ee130e8dc1847d$export$e331c843472783ec)(lastStepToBlockchain, customDestination) : false;
    return !isCustomDestinationOpen && !everyWalletSelected || isCustomDestinationOpen && !customDestination || isCustomDestinationOpen && !!customDestination && (!customDestinationIsValid || !everyRequiredWalletSelected);
}
function $8e9d7744e1038276$export$2cdd2187dfb51b81(tokenA, tokenB) {
    return tokenA.blockchain === tokenB.blockchain && tokenA.symbol === tokenB.symbol && tokenA.address === tokenB.address;
}
function $8e9d7744e1038276$export$179ab3265105ab59(event) {
    return event.type === (0, $ab26e0b6754d430c$export$543d0a6c7f452841).FAILED || event.type === (0, $ab26e0b6754d430c$export$543d0a6c7f452841).SUCCEEDED;
}


function $aae90cdd39be0d29$export$63bd4576f33d0cb4(quote) {
    const swaps = quote?.swaps || [];
    return swaps[swaps.length - 1].to.usdPrice;
}
function $aae90cdd39be0d29$export$1d28ea9d3bcb49f(quote) {
    const swaps = quote?.swaps || [];
    return swaps[0].from.usdPrice;
}
function $aae90cdd39be0d29$export$b28275e1828e6c69(quoteA, quoteB) {
    const quoteASwaps = quoteA?.swaps || [];
    const quoteBSwaps = quoteB?.swaps || [];
    return quoteASwaps.length !== quoteBSwaps.length;
}
function $aae90cdd39be0d29$export$f355d013c74cf359(quoteA, quoteB) {
    const quoteASwappers = quoteA?.swaps.map((swap)=>swap.swapperId) || [];
    const quoteBSwappers = quoteB?.swaps.map((swap)=>swap.swapperId) || [];
    return !(0, $7c74207847ca6a20$export$b141efd0b0fb9174)(quoteASwappers, quoteBSwappers);
}
function $aae90cdd39be0d29$export$d28ab8000b10b9a3(quoteA, quoteB) {
    const quoteAInternalCoins = quoteA?.swaps.map((swap)=>swap.to.symbol) || [];
    const quoteBInternalCoins = quoteB?.swaps.map((swap)=>swap.to.symbol) || [];
    return !(0, $7c74207847ca6a20$export$b141efd0b0fb9174)(quoteAInternalCoins, quoteBInternalCoins);
}
function $aae90cdd39be0d29$export$9bf882d220c3db75(quoteA, quoteB) {
    return $aae90cdd39be0d29$export$b28275e1828e6c69(quoteA, quoteB) || $aae90cdd39be0d29$export$f355d013c74cf359(quoteA, quoteB) || $aae90cdd39be0d29$export$d28ab8000b10b9a3(quoteA, quoteB);
}
function $aae90cdd39be0d29$export$d053da0969166248(fromUsdValue, outToInRatio) {
    return parseInt(outToInRatio?.toFixed(2) || "0") <= -10 && (fromUsdValue === null || fromUsdValue.gte(new (0, $76r4H.default)(200))) || parseInt(outToInRatio?.toFixed(2) || "0") <= -5 && (fromUsdValue === null || fromUsdValue.gte(new (0, $76r4H.default)(1000)));
}
function $aae90cdd39be0d29$export$4ce5d18da71de2d4(selectedWallet, fee) {
    if (fee === null) return null;
    const relatedFeeStatus = fee?.find((item)=>item.blockchain === selectedWallet.chain)?.wallets.find((wallet)=>wallet.address?.toLowerCase() === selectedWallet.address.toLowerCase());
    if (!relatedFeeStatus) return null;
    return relatedFeeStatus.requiredAssets;
}
function $aae90cdd39be0d29$export$161668da75c421a0(priceImpact) {
    let warningLevel = undefined;
    if (priceImpact <= (0, $189a5d7f52888885$export$758a3860814b1a7f) && priceImpact > (0, $189a5d7f52888885$export$de21a634bd33d85f)) warningLevel = "low";
    else if (priceImpact <= (0, $189a5d7f52888885$export$de21a634bd33d85f)) warningLevel = "high";
    return warningLevel;
}
function $aae90cdd39be0d29$export$e9eb27c9915a9d93(listA, listB) {
    const set = new Set();
    listA.forEach((token)=>set.add((0, $76ee130e8dc1847d$export$a7b26387fecb5183)(token)));
    return listB.filter((token)=>set.has((0, $76ee130e8dc1847d$export$a7b26387fecb5183)(token)));
}
function $aae90cdd39be0d29$export$ba2af798efa32d0b(pendingSwap, blockchains, findToken) {
    const firstStep = pendingSwap.steps[0];
    const lastStep = pendingSwap.steps[pendingSwap.steps.length - 1];
    const lastSuccessfulStep = (0, $45075b780ed6e88c$export$ce182e0a92d996da)(pendingSwap.steps);
    const toToken = {
        blockchain: lastStep.toBlockchain,
        symbol: lastStep.toSymbol,
        address: lastStep.toSymbolAddress
    };
    const fromBlockchainMeta = (0, $76ee130e8dc1847d$export$b20204be864cdab1)(lastSuccessfulStep ? lastSuccessfulStep.toBlockchain : firstStep.fromBlockchain, blockchains);
    const toBlockchainMeta = (0, $76ee130e8dc1847d$export$b20204be864cdab1)(lastStep.toBlockchain, blockchains);
    const fromTokenMeta = findToken(lastSuccessfulStep ? {
        blockchain: fromBlockchainMeta?.name ?? "",
        symbol: lastSuccessfulStep.toSymbol,
        address: lastSuccessfulStep.toSymbolAddress
    } : {
        blockchain: fromBlockchainMeta?.name ?? "",
        symbol: firstStep.fromSymbol,
        address: firstStep.fromSymbolAddress
    });
    const toTokenMeta = findToken(toToken);
    const inputAmount = lastSuccessfulStep ? lastSuccessfulStep.outputAmount ?? "" : pendingSwap.inputAmount;
    return {
        fromBlockchain: fromBlockchainMeta,
        fromToken: fromTokenMeta,
        toBlockchain: toBlockchainMeta,
        toToken: toTokenMeta,
        inputAmount: inputAmount
    };
}
function $aae90cdd39be0d29$export$a0c8f8d7b1849c8c(quote, params) {
    const { fromToken: fromToken, toToken: toToken, findToken: findToken, userSlippage: userSlippage } = params;
    const inputUsdValue = (0, $8e9d7744e1038276$export$6f59f9bb345c1d58)(quote.requestAmount, $aae90cdd39be0d29$export$1d28ea9d3bcb49f(quote) || fromToken?.usdPrice);
    const outputUsdValue = (0, $8e9d7744e1038276$export$6f59f9bb345c1d58)(quote.outputAmount, $aae90cdd39be0d29$export$63bd4576f33d0cb4(quote) || toToken?.usdPrice);
    if (!!quote && inputUsdValue && outputUsdValue) {
        const priceImpact = $aae90cdd39be0d29$export$3cad4d44dd01c178(inputUsdValue.toString(), outputUsdValue.toString());
        const highValueLoss = !!priceImpact && (0, $8e9d7744e1038276$export$cadf2b27a67febc2)(inputUsdValue, priceImpact);
        if (highValueLoss) {
            const totalFee = (0, $8e9d7744e1038276$export$684cb4cc81f91db3)(quote?.swaps, findToken);
            const warningLevel = $aae90cdd39be0d29$export$161668da75c421a0(priceImpact);
            return {
                type: (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_VALUE_LOSS,
                inputUsdValue: inputUsdValue,
                outputUsdValue: outputUsdValue,
                priceImpact: priceImpact,
                totalFee: totalFee,
                warningLevel: warningLevel
            };
        }
    } else if (quote && (!inputUsdValue || !outputUsdValue)) return {
        type: (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).UNKNOWN_PRICE
    };
    const minRequiredSlippage = (0, $8e9d7744e1038276$export$20a61b45ab42ee9c)(quote.swaps);
    const highSlippage = userSlippage > (0, $6eceba59c0c82e59$export$c16183a27a68b1cf);
    if (!(0, $8e9d7744e1038276$export$eb9588acfa74eb26)(params.userSlippage.toString(), minRequiredSlippage)) return {
        type: (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE,
        recommendedSlippages: (0, $8e9d7744e1038276$export$b4e336809a24b023)(quote, userSlippage),
        minRequiredSlippage: minRequiredSlippage
    };
    else if (highSlippage && parseFloat(minRequiredSlippage ?? "0") < userSlippage) return {
        type: (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_SLIPPAGE,
        slippage: userSlippage.toString()
    };
    return null;
}
function $aae90cdd39be0d29$export$3cad4d44dd01c178(inputUsdValue, outputUsdValue) {
    const outputUsdValueIsInvalid = typeof outputUsdValue === "string" ? parseFloat(outputUsdValue) <= 0 : !outputUsdValue?.gt(0);
    const percentageChange = !inputUsdValue || !outputUsdValue || outputUsdValueIsInvalid ? null : (0, $8e9d7744e1038276$export$f10d6a896d4ffbcf)(inputUsdValue.toString(), outputUsdValue.toString());
    return percentageChange && percentageChange < 0 ? percentageChange : null;
}
const $aae90cdd39be0d29$export$d676cb553c1d42b2 = (steps)=>{
    const set = new Set();
    const result = [];
    steps.forEach((step)=>{
        if (!set.has(step.from.chain.displayName)) {
            set.add(step.from.chain.displayName);
            result.push(step.from.chain);
        }
        if (!set.has(step.to.chain.displayName)) {
            set.add(step.to.chain.displayName);
            result.push(step.to.chain);
        }
    });
    return result;
};
const $aae90cdd39be0d29$export$3e03f427decd49d3 = (strategy, quotes)=>{
    return quotes.sort((quote1, quote2)=>{
        const getScore = (route)=>route.scores?.find((score)=>score.preferenceType === strategy)?.score ?? 0;
        const quote1Score = getScore(quote1);
        const quote2Score = getScore(quote2);
        if (quote1Score !== quote2Score) return quote2Score - quote1Score;
        const lowerQuoteId1 = quote1.requestId.toLowerCase();
        const lowerQuoteId2 = quote2.requestId.toLowerCase();
        return lowerQuoteId1.localeCompare(lowerQuoteId2);
    });
};
const $aae90cdd39be0d29$export$ddaf73e67dd8a5fe = (currentQuote, quotes, requestAmount)=>{
    if (!quotes.length) return null;
    if (!currentQuote) // Handle the case where currentQuote is null
    return {
        requestAmount: requestAmount,
        validationStatus: null,
        ...quotes[0]
    };
    // Create a set of swapperIds from the currentQuote swaps
    const currentQuoteSwapperIds = new Set(currentQuote.swaps.map((swap)=>swap.swapperId));
    // Find a quote that matches the currentQuote's swapperIds
    const matchedQuote = quotes.find((quote)=>{
        // Create a set of swapperIds from the quote swaps
        const quoteSwapperIds = new Set(quote.swaps.map((swap)=>swap.swapperId));
        // Check if all swapperIds from the currentQuote are present in the quoteSwapperIds
        return Array.from(currentQuoteSwapperIds).every((swapperId)=>quoteSwapperIds.has(swapperId));
    });
    // Return the matchedQuote if found, otherwise return the first quote from the quotes array
    return {
        requestAmount: requestAmount,
        validationStatus: null,
        ...matchedQuote || quotes[0]
    };
};
const $aae90cdd39be0d29$export$3f24c42f0d58efd8 = (tags)=>{
    const customSort = (a, b)=>{
        const indexA = (0, $0cffb0cab258d6b7$export$a69883272d33ff0b).indexOf(a.value);
        const indexB = (0, $0cffb0cab258d6b7$export$a69883272d33ff0b).indexOf(b.value);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        else if (indexB !== -1) return 1;
        return 0;
    };
    return tags.sort(customSort);
};




const $3b5b1daaa6398d06$export$45999e57825f8e7a = (token, amount)=>token?.usdPrice ? new (0, $76r4H.default)(amount || (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9)).multipliedBy(token?.usdPrice || 0) : null;
const $3b5b1daaa6398d06$export$347bbd3ce043dc56 = (0, $e0ddf8b9111cc8ab$export$2e2bcd8739ae039)((0, $deedc9bfbd0dc16c$export$185802fd694ee1f5)()((0, $3ed31f3dd58f2a20$export$5c593627aef9f076)((set)=>({
        fromBlockchain: null,
        fromToken: null,
        inputAmount: "",
        outputAmount: null,
        inputUsdValue: new (0, $76r4H.default)(0),
        outputUsdValue: new (0, $76r4H.default)(0),
        toBlockchain: null,
        toToken: null,
        refetchQuote: true,
        sortStrategy: "SMART",
        selectedQuote: null,
        quotes: null,
        error: null,
        warning: null,
        quoteWalletsConfirmed: false,
        selectedWallets: [],
        customDestination: null,
        quoteWarningsConfirmed: false,
        updateQuotePartialState: (key, value)=>set((state)=>({
                    ...state,
                    [key]: value
                })),
        setSelectedQuote: (quote)=>set((state)=>{
                let outputAmount = null;
                let outputUsdValue = (0, $fdd69898c00c1ed2$export$2a1795c9359f92b9);
                let inputUsdValue = state.inputUsdValue;
                if (!(0, $63fc48ac3256c035$export$5374bb854d0e41c8)(state.inputAmount)) return {};
                if (!!quote) {
                    outputAmount = !!quote?.outputAmount ? new (0, $76r4H.default)(quote?.outputAmount) : null;
                    inputUsdValue = (0, $8e9d7744e1038276$export$6f59f9bb345c1d58)(state.inputAmount, (0, $aae90cdd39be0d29$export$1d28ea9d3bcb49f)(quote) || state.fromToken?.usdPrice);
                    outputUsdValue = (0, $8e9d7744e1038276$export$6f59f9bb345c1d58)(quote.outputAmount, (0, $aae90cdd39be0d29$export$63bd4576f33d0cb4)(quote) || state.toToken?.usdPrice);
                }
                return {
                    selectedQuote: quote,
                    ...!!quote && {
                        outputAmount: outputAmount,
                        outputUsdValue: outputUsdValue,
                        inputUsdValue: inputUsdValue
                    }
                };
            }),
        resetAlerts: ()=>set(()=>({
                    error: null,
                    warning: null
                })),
        resetQuote: ()=>set(()=>({
                    selectedQuote: null,
                    outputAmount: null,
                    outputUsdValue: new (0, $76r4H.default)(0),
                    quotes: null,
                    refetchQuote: true,
                    error: null,
                    warning: null
                })),
        setFromBlockchain: (chain)=>{
            set((state)=>{
                if (state.fromBlockchain?.name === chain?.name) return {};
                return {
                    fromBlockchain: chain,
                    inputUsdValue: new (0, $76r4H.default)(0),
                    ...state.fromToken && {
                        selectedQuote: null,
                        fromToken: null,
                        outputAmount: null,
                        outputUsdValue: new (0, $76r4H.default)(0)
                    }
                };
            });
        },
        setFromToken: (params)=>{
            return set((state)=>({
                    fromToken: params.token,
                    ...params.token && {
                        fromBlockchain: params.meta.blockchains.find((blockchain)=>blockchain.name === params.token.blockchain) ?? null
                    },
                    ...!!state.inputAmount && {
                        inputUsdValue: $3b5b1daaa6398d06$export$45999e57825f8e7a(params.token, state.inputAmount)
                    }
                }));
        },
        setToBlockchain: (chain)=>{
            set((state)=>{
                if (state.toBlockchain?.name === chain?.name) return {};
                return {
                    toBlockchain: chain,
                    ...state.toToken && {
                        selectedQuote: null,
                        toToken: null,
                        outputAmount: null,
                        outputUsdValue: new (0, $76r4H.default)(0)
                    }
                };
            });
        },
        setToToken: (params)=>{
            return set(()=>({
                    toToken: params.token,
                    ...params.token && {
                        toBlockchain: params.meta.blockchains.find((blockchain)=>blockchain.name === params.token.blockchain) ?? null
                    }
                }));
        },
        setInputAmount: (amount)=>{
            set((state)=>({
                    inputAmount: amount,
                    ...!amount && {
                        outputAmount: null,
                        outputUsdValue: new (0, $76r4H.default)(0),
                        selectedQuote: null
                    },
                    ...!!state.fromToken && {
                        inputUsdValue: $3b5b1daaa6398d06$export$45999e57825f8e7a(state.fromToken, amount)
                    }
                }));
        },
        retry: (retryQuote)=>{
            const { fromBlockchain: fromBlockchain, fromToken: fromToken, toBlockchain: toBlockchain, toToken: toToken, inputAmount: inputAmount } = retryQuote;
            set({
                fromBlockchain: fromBlockchain,
                fromToken: fromToken,
                inputAmount: inputAmount,
                outputAmount: null,
                inputUsdValue: $3b5b1daaa6398d06$export$45999e57825f8e7a(fromToken ?? null, inputAmount),
                outputUsdValue: new (0, $76r4H.default)(0),
                toBlockchain: toBlockchain,
                toToken: toToken,
                selectedQuote: null
            });
        },
        switchFromAndTo: ()=>set((state)=>({
                    fromBlockchain: state.toBlockchain,
                    fromToken: state.toToken,
                    toBlockchain: state.fromBlockchain,
                    toToken: state.fromToken,
                    inputAmount: state.outputAmount?.toString() || "",
                    inputUsdValue: state.toToken ? $3b5b1daaa6398d06$export$45999e57825f8e7a(state.toToken, state.outputAmount?.toString() || "") : new (0, $76r4H.default)(0)
                })),
        resetFromBlockchain: ()=>set(()=>({
                    fromToken: null,
                    fromBlockchain: null,
                    outputUsdValue: new (0, $76r4H.default)(0),
                    inputUsdValue: new (0, $76r4H.default)(0),
                    inputAmount: "",
                    outputAmount: null,
                    selectedQuote: null
                })),
        resetToBlockchain: ()=>set(()=>({
                    toToken: null,
                    toBlockchain: null,
                    outputAmount: null,
                    outputUsdValue: new (0, $76r4H.default)(0),
                    selectedQuote: null
                })),
        setQuoteWalletConfirmed: (flag)=>set({
                quoteWalletsConfirmed: flag
            }),
        setSelectedWallets: (wallets)=>set({
                selectedWallets: wallets
            }),
        setCustomDestination: (address)=>set({
                customDestination: address
            }),
        resetQuoteWallets: ()=>set({
                quoteWalletsConfirmed: false,
                selectedWallets: [],
                customDestination: null
            }),
        setQuoteWarningsConfirmed: (flag)=>set({
                quoteWarningsConfirmed: flag
            })
    }))));
const $3b5b1daaa6398d06$export$a83d0c15f7a234c9 = $3b5b1daaa6398d06$export$347bbd3ce043dc56.subscribe((selectedState, previousSelectedState)=>{
    if (selectedState.fromBlockchain !== previousSelectedState.fromBlockchain || selectedState.fromToken !== previousSelectedState.fromToken || selectedState.toBlockchain !== previousSelectedState.toBlockchain || selectedState.toToken !== previousSelectedState.toToken || selectedState.inputAmount !== previousSelectedState.inputAmount) // useEffect hook can not be used in Zustand subscribe
    (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).QuoteEvent, {
        type: (0, $97c1ea0b5855c6ca$export$88d3f00995e6f561).QUOTE_INPUT_UPDATE,
        payload: {
            fromBlockchain: selectedState.fromBlockchain?.name,
            toBlockchain: selectedState.toBlockchain?.name,
            fromToken: selectedState.fromToken ? {
                symbol: selectedState.fromToken.symbol,
                name: selectedState.fromToken.name,
                address: selectedState.fromToken.address
            } : undefined,
            toToken: selectedState.toToken ? {
                symbol: selectedState.toToken.symbol,
                name: selectedState.toToken.name,
                address: selectedState.toToken.address
            } : undefined,
            requestAmount: selectedState.inputAmount
        }
    });
    if (selectedState.selectedQuote?.requestId !== previousSelectedState.selectedQuote?.requestId) (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).QuoteEvent, {
        type: (0, $97c1ea0b5855c6ca$export$88d3f00995e6f561).QUOTE_OUTPUT_UPDATE,
        payload: selectedState.selectedQuote ? {
            requestAmount: selectedState.selectedQuote.requestAmount,
            swaps: selectedState.selectedQuote.swaps,
            outputAmount: selectedState.selectedQuote.outputAmount,
            resultType: selectedState.selectedQuote.resultType,
            tags: selectedState.selectedQuote.tags
        } : null
    });
});



function $9c328eee9f952c1b$export$149433a791a52f40() {
    const { setInputAmount: setInputAmount, setToToken: setToToken, setToBlockchain: setToBlockchain, setFromBlockchain: setFromBlockchain, resetQuote: resetQuote, setFromToken: setFromToken, fromToken: fromToken, toToken: toToken, fromBlockchain: fromBlockchain, toBlockchain: toBlockchain } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const config = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().config;
    const fetchMetaStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { setAffiliateRef: setAffiliateRef, setAffiliatePercent: setAffiliatePercent, setAffiliateWallets: setAffiliateWallets } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const fromTokensConfig = config?.from?.tokens;
    const fromBlockchainsConfig = config?.from?.blockchains;
    const toTokensConfig = config?.to?.tokens;
    const toBlockchainsConfig = config?.to?.blockchains;
    const prevConfigFromToken = (0, $exYeM.useRef)(undefined);
    const prevConfigToToken = (0, $exYeM.useRef)(undefined);
    const prevConfigFromBlockchain = (0, $exYeM.useRef)(undefined);
    const prevConfigToBlockchain = (0, $exYeM.useRef)(undefined);
    (0, $exYeM.useEffect)(()=>{
        if (typeof config.amount !== "undefined") setInputAmount(config.amount.toString());
    }, [
        config?.amount
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (fetchMetaStatus === "success") {
            resetQuote();
            const chain = blockchains.find((chain)=>chain.name === config?.from?.blockchain);
            const fromToken = config?.from?.token;
            const token = fromToken && findToken(fromToken);
            if (chain || !chain && prevConfigFromBlockchain.current) setFromBlockchain(chain ?? null);
            if (token) setFromToken({
                token: token,
                meta: {
                    blockchains: blockchains,
                    tokens: tokens
                }
            });
            else if (!token && prevConfigFromToken.current) setFromToken({
                token: null
            });
            prevConfigFromBlockchain.current = config?.from?.blockchain;
            prevConfigFromToken.current = config?.from?.token;
        }
    }, [
        config?.from?.token?.symbol,
        config?.from?.token?.address,
        config?.from?.token?.blockchain,
        config?.from?.blockchain,
        fetchMetaStatus
    ]);
    (0, $exYeM.useEffect)(()=>{
        if ((0, $6fd02b85a3828f9f$export$9b55254af1da3b63)(fromToken, fromTokensConfig)) setFromToken({
            token: null
        });
        if ((0, $6fd02b85a3828f9f$export$2e445b1a4b8d9774)(fromBlockchain, fromBlockchainsConfig)) setFromBlockchain(null);
    }, [
        fromTokensConfig,
        fromBlockchainsConfig
    ]);
    (0, $exYeM.useEffect)(()=>{
        if ((0, $6fd02b85a3828f9f$export$9b55254af1da3b63)(toToken, toTokensConfig)) setFromToken({
            token: null
        });
        if ((0, $6fd02b85a3828f9f$export$2e445b1a4b8d9774)(toBlockchain, toBlockchainsConfig)) setToBlockchain(null);
    }, [
        toTokensConfig,
        toBlockchainsConfig
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (fetchMetaStatus === "success") {
            resetQuote();
            const chain = blockchains.find((chain)=>chain.name === config?.to?.blockchain);
            const toToken = config?.to?.token;
            const token = toToken && findToken(toToken);
            if (chain || !chain && prevConfigToBlockchain.current) setToBlockchain(chain ?? null);
            if (token) setToToken({
                token: token,
                meta: {
                    blockchains: blockchains,
                    tokens: tokens
                }
            });
            else if (!token && prevConfigToToken.current) setToToken({
                token: null
            });
            prevConfigToBlockchain.current = config?.to?.blockchain;
            prevConfigToToken.current = config?.to?.token;
        }
    }, [
        config?.to?.token?.symbol,
        config?.to?.token?.address,
        config?.to?.token?.blockchain,
        config?.to?.blockchain,
        fetchMetaStatus
    ]);
    (0, $exYeM.useEffect)(()=>{
        setAffiliateRef(config?.affiliate?.ref ?? null);
        setAffiliatePercent(config?.affiliate?.percent ?? null);
        setAffiliateWallets(config?.affiliate?.wallets ?? null);
    }, [
        config?.affiliate?.ref,
        config?.affiliate?.percent,
        config?.affiliate?.wallets
    ]);
}



var $exYeM = parcelRequire("exYeM");

var $ac85cc6f6f867f4c$export$1e1d235314148489;
(function(SearchParams) {
    SearchParams["FROM_BLOCKCHAIN"] = "fromBlockchain";
    SearchParams["FROM_TOKEN"] = "fromToken";
    SearchParams["TO_BLOCKCHAIN"] = "toBlockchain";
    SearchParams["TO_TOKEN"] = "toToken";
    SearchParams["FROM_AMOUNT"] = "fromAmount";
    SearchParams["AUTO_CONNECT"] = "autoConnect";
    // This is for custom tokens
    SearchParams["BLOCKCHAIN"] = "blockchain";
    /*
   * dApps can transmit liquidity sources as a search parameter,
   * and these take precedence over widget configurations
   */ SearchParams["LIQUIDITY_SOURCES"] = "liquiditySources";
    // iframe environments
    SearchParams["CLIENT_URL"] = "clientUrl";
})($ac85cc6f6f867f4c$export$1e1d235314148489 || ($ac85cc6f6f867f4c$export$1e1d235314148489 = {}));




function $79764411ffa78859$export$ba71973bb3551e40(searchParam, chain) {
    const symbolAndAddress = searchParam.split("--");
    return {
        blockchain: chain.name,
        address: symbolAndAddress?.[1] || null,
        symbol: symbolAndAddress[0]
    };
}
function $79764411ffa78859$export$a382f88a24e0c2b5(token) {
    if (token) return `${token.symbol}${token.address ? `--${token.address}` : ""}`;
    return undefined;
}


function $ca6e928adc2062c3$export$bdeb80d0daf5f225() {
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const [searchParams, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const { fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, setFromBlockchain: setFromBlockchain, setToBlockchain: setToBlockchain, setFromToken: setFromToken, setToToken: setToToken, setInputAmount: setInputAmount } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const fetchMetaStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens();
    const isInRouterContext = (0, $b0e6fcd50b7ef685$export$9c954a9d03d32f4a)();
    const { updateIframe: updateIframe, updateCampaignMode: updateCampaignMode } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const campaignMode = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().isInCampaignMode();
    const liquiditySourcesParamsRef = (0, $exYeM.useRef)();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const getUrlSearchParams = ()=>{
        const utmQueryParams = {};
        for (const [key, value] of searchParams.entries())if (key.startsWith("utm_")) utmQueryParams[key] = value;
        const fromAmount = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_AMOUNT);
        const fromBlockchain = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_BLOCKCHAIN);
        const fromToken = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_TOKEN);
        const toBlockchain = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).TO_BLOCKCHAIN);
        const toToken = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).TO_TOKEN);
        const autoConnect = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).AUTO_CONNECT);
        const clientUrl = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).CLIENT_URL);
        const liquiditySources = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).LIQUIDITY_SOURCES);
        const blockchain = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).BLOCKCHAIN);
        return {
            fromAmount: fromAmount,
            fromBlockchain: fromBlockchain,
            fromToken: fromToken,
            toBlockchain: toBlockchain,
            toToken: toToken,
            autoConnect: autoConnect,
            clientUrl: clientUrl,
            liquiditySources: liquiditySources,
            utmQueryParams: utmQueryParams,
            blockchain: blockchain
        };
    };
    const updateUrlSearchParams = (searchParams)=>{
        for(const property in searchParams)if (!searchParams[property]) delete searchParams[property];
        setSearchParams(searchParams, {
            replace: true
        });
    };
    (0, $exYeM.useEffect)(()=>{
        const { autoConnect: autoConnect, clientUrl: clientUrl, utmQueryParams: utmQueryParams, blockchain: blockchain } = getUrlSearchParams();
        if (isInRouterContext && fetchMetaStatus === "success") updateUrlSearchParams({
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_BLOCKCHAIN]: fromBlockchain?.name,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_TOKEN]: (0, $79764411ffa78859$export$a382f88a24e0c2b5)(fromToken),
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).TO_BLOCKCHAIN]: toBlockchain?.name,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).TO_TOKEN]: (0, $79764411ffa78859$export$a382f88a24e0c2b5)(toToken),
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).FROM_AMOUNT]: inputAmount,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).AUTO_CONNECT]: autoConnect ?? undefined,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).CLIENT_URL]: clientUrl ?? undefined,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).BLOCKCHAIN]: blockchain ?? undefined,
            [(0, $ac85cc6f6f867f4c$export$1e1d235314148489).LIQUIDITY_SOURCES]: campaignMode ? liquiditySourcesParamsRef.current : undefined,
            ...utmQueryParams
        });
    }, [
        location.pathname,
        inputAmount,
        fromBlockchain,
        fromToken,
        toBlockchain,
        toToken,
        campaignMode
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!isInRouterContext) return;
        const searchParams = getUrlSearchParams();
        if (!liquiditySourcesParamsRef.current && searchParams.liquiditySources) liquiditySourcesParamsRef.current = searchParams.liquiditySources;
        if (searchParams.fromAmount) setInputAmount(searchParams.fromAmount);
        if (fetchMetaStatus === "success") {
            const fromBlockchain = blockchains.find((blockchain)=>blockchain.name === searchParams.fromBlockchain);
            const fromToken = searchParams.fromToken && fromBlockchain ? findToken((0, $79764411ffa78859$export$ba71973bb3551e40)(searchParams.fromToken, fromBlockchain)) : undefined;
            const toBlockchain = blockchains.find((blockchain)=>blockchain.name === searchParams.toBlockchain);
            const toToken = searchParams.toToken && toBlockchain ? findToken((0, $79764411ffa78859$export$ba71973bb3551e40)(searchParams.toToken, toBlockchain)) : undefined;
            if (!!fromBlockchain) {
                setFromBlockchain(fromBlockchain);
                if (!!fromToken) setFromToken({
                    token: fromToken,
                    meta: {
                        blockchains: blockchains,
                        tokens: tokens
                    }
                });
            }
            if (!!toBlockchain) {
                setToBlockchain(toBlockchain);
                if (!!toToken) setToToken({
                    token: toToken,
                    meta: {
                        blockchains: blockchains,
                        tokens: tokens
                    }
                });
            }
        }
    }, [
        fetchMetaStatus
    ]);
    (0, $exYeM.useEffect)(()=>{
        const { clientUrl: clientUrl, liquiditySources: liquiditySources } = getUrlSearchParams();
        // We run this only once, because if the app is embedded into an iframe, the data in url for iframe will not change.
        updateIframe("clientUrl", clientUrl || undefined);
        updateCampaignMode("liquiditySources", liquiditySources?.split(",") ?? undefined);
    }, []);
}







var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");

const $8a721ef691ddc432$export$b821cb5d358838ed = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "$40",
    padding: "$4 $10",
    borderRadius: "$sm",
    cursor: "pointer",
    alignItems: "center",
    backgroundColor: "$neutral300",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral400"
    },
    "&:hover": {
        backgroundColor: "$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral500"
        }
    },
    variants: {
        disabled: {
            true: {
                cursor: "default",
                "&:hover": {
                    borderColor: "$neutral300",
                    "& svg": {
                        color: "$neutral700"
                    }
                }
            }
        }
    }
});
const $8a721ef691ddc432$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    ".title_typography": {
        textTransform: "capitalize"
    }
});
const $8a721ef691ddc432$export$124d4c7bf7db9715 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex"
});


function $8d2ad8cc9562553b$export$508837fc497186f1(props) {
    const { onClick: onClick, value: value, title: title, hasLogo: hasLogo, placeholder: placeholder, disabled: disabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8a721ef691ddc432$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "large",
        variant: "label"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8a721ef691ddc432$export$b821cb5d358838ed), {
        onClick: disabled ? undefined : onClick,
        disabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8a721ef691ddc432$export$124d4c7bf7db9715), null, hasLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
        src: value?.logo,
        size: 16,
        useAsPlaceholder: !value?.logo,
        type: "circular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        className: "title_typography",
        size: "medium",
        variant: "label"
    }, value?.name || placeholder)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
        size: 12,
        color: "black"
    })));
}








var $exYeM = parcelRequire("exYeM");


function $c08bbfbaa8d5e09b$export$b6ff7fadce59d74(address, blockchain) {
    // We don't have Cosmos explorer url in API.
    if (blockchain.type === "COSMOS") return "";
    const explorerLinkPattern = blockchain.info?.addressUrl;
    if (!explorerLinkPattern || !address) return "";
    return explorerLinkPattern.replace("{wallet}", address);
}



const $903c68d15ffa5dd6$export$9048d548939551ee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("a", {
    textDecoration: "none",
    color: "$colors$neutral700",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        color: "$colors$neutral900"
    },
    "& svg": {
        marginLeft: "$4",
        color: "$colors$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$colors$neutral900"
        }
    },
    variants: {
        hasHover: {
            true: {
                "&:hover": {
                    color: "$colors$secondary550",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        color: "$colors$secondary500"
                    },
                    "& svg": {
                        color: "$colors$secondary550",
                        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                            color: "$colors$secondary500"
                        }
                    }
                }
            },
            false: {}
        }
    }
});
const $903c68d15ffa5dd6$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    "& ._blockchain-name, & ._coin-source": {
        color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$colors$neutral800"
        }
    },
    "& ._coin-source-name, & ._custom-token-description": {
        color: "$colors$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            color: "$colors$neutral900"
        }
    }
});


function $ebfbc8baf7dbe530$export$7b29f3327b1aa922(props) {
    const { open: open, onClose: onClose, token: token, onSubmitClick: onSubmitClick, blockchain: blockchain } = props;
    const explorerLink = (0, $c08bbfbaa8d5e09b$export$b6ff7fadce59d74)(token.address, blockchain);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: open,
        dismissible: true,
        onClose: onClose,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $903c68d15ffa5dd6$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
        src: token.image,
        size: 45,
        type: "circular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium"
    }, token.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "small",
        className: "_blockchain-name"
    }, blockchain.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium"
    }, !!explorerLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $903c68d15ffa5dd6$export$9048d548939551ee), {
        hasHover: true,
        href: explorerLink,
        target: "_blank",
        rel: "nofollow noreferrer"
    }, token.address, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7de21d312ca8c004$export$2e2bcd8739ae039), {
        size: 12,
        color: "gray"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $903c68d15ffa5dd6$export$9048d548939551ee), null, token.address)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), token.coinSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        className: "_coin-source",
        variant: "body",
        size: "xsmall"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("via"), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        className: "_coin-source-name",
        variant: "body",
        size: "xsmall"
    }, token.coinSource)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "32"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "medium",
        variant: "body",
        className: "_custom-token-description"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(`This token doesn't appear on the active token list(s). Make sure this is the token that you want to trade.`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 40
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-custom-token-modal-import-btn",
        variant: "contained",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: onSubmitClick
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Import")));
}







var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

function $b54140b98e48aa4e$export$be86b17dfe5c2dc1() {
    return window.self !== window.top;
}


function $c644546fde36009c$export$f7a742ca3c17ffb() {
    const heightObserver = (0, $exYeM.useRef)(null);
    const { iframe: iframe } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const isMessagePassingAvailable = (0, $b54140b98e48aa4e$export$be86b17dfe5c2dc1)() && iframe.clientUrl;
    const send = (message)=>{
        if (isMessagePassingAvailable) window.top?.postMessage(message, iframe.clientUrl);
    };
    const connectHeightObserver = (element)=>{
        heightObserver.current = new ResizeObserver((entries)=>{
            for (const entry of entries)send({
                type: "widget_height",
                data: {
                    height: entry.contentRect.height
                }
            });
        });
        heightObserver.current.observe(element);
    };
    const disconnectHeightObserver = ()=>{
        if (heightObserver.current) {
            heightObserver.current.disconnect();
            heightObserver.current = null;
        }
    };
    return {
        send: send,
        connectHeightObserver: connectHeightObserver,
        disconnectHeightObserver: disconnectHeightObserver
    };
}






function $44b8318ef6fb2100$export$7ce1f551d78f9130() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return ()=>navigate(-1);
}


/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $exYeM = parcelRequire("exYeM");



/* eslint-disable @typescript-eslint/no-magic-numbers */ 

var $exYeM = parcelRequire("exYeM");
/* eslint-disable @typescript-eslint/no-magic-numbers */ // Types
const $ae3c5b1d0dc01863$var$HEX_BASE = 16;
const $ae3c5b1d0dc01863$var$MAX_COLOR_VALUE = 255;
const $ae3c5b1d0dc01863$var$PERCENT = 0.11;
// Utility Functions
function $ae3c5b1d0dc01863$var$expandShortHexColor(hexColor) {
    // Remove '#' if it exists
    if (hexColor.startsWith("#")) hexColor = hexColor.slice(1);
    // Check if the hexColor has a length of 3
    if (hexColor.length === 3) {
        // Convert the string to an array of characters
        const characters = hexColor.split("");
        // Duplicate each character and combine them into a single string
        const expandedHex = characters.reduce(function(acc, char) {
            return acc + char + char;
        }, "");
        // Return the resulting 6-character hex color
        return `#${expandedHex}`;
    }
    // Return the original hexColor if it's not 3 characters
    return `#${hexColor}`;
}
/*
 * We letting users to override some specific colors (e.g. `primary550`, `secondary100`).
 * So we are generating a range of colors if `primary` (or other keys) has passed but if user is passing a specific color,
 * we will override the user color to generated range.
 */ function $ae3c5b1d0dc01863$var$isOverridingColor(colorKey) {
    return /[0-9]+$/.test(colorKey);
}
// pad a hexadecimal string with zeros if it needs it
function $ae3c5b1d0dc01863$var$pad(number, length) {
    return number.padStart(length, "0");
}
// Convert an integer to a 2-character hex string
function $ae3c5b1d0dc01863$var$intToHex(value) {
    const clampedValue = Math.min(Math.max(Math.round(value), 0), $ae3c5b1d0dc01863$var$MAX_COLOR_VALUE);
    return $ae3c5b1d0dc01863$var$pad(clampedValue.toString($ae3c5b1d0dc01863$var$HEX_BASE), 2);
}
// convert one of our rgb color objects to a full hex color string
function $ae3c5b1d0dc01863$var$rgbToHex(rgb) {
    return `#${$ae3c5b1d0dc01863$var$intToHex(rgb.red)}${$ae3c5b1d0dc01863$var$intToHex(rgb.green)}${$ae3c5b1d0dc01863$var$intToHex(rgb.blue)}`;
}
// Convert a hex color string to an RGB object
function $ae3c5b1d0dc01863$var$hexToRGB(hex) {
    const red = parseInt(hex.slice(1, 3), $ae3c5b1d0dc01863$var$HEX_BASE);
    const green = parseInt(hex.slice(3, 5), $ae3c5b1d0dc01863$var$HEX_BASE);
    const blue = parseInt(hex.slice(5, 7), $ae3c5b1d0dc01863$var$HEX_BASE);
    return {
        red: red,
        green: green,
        blue: blue
    };
}
// Generate a shade of a given RGB color
function $ae3c5b1d0dc01863$var$generateShade(rgb, step) {
    const factor = 1 - $ae3c5b1d0dc01863$var$PERCENT * step;
    return {
        red: rgb.red * factor,
        green: rgb.green * factor,
        blue: rgb.blue * factor
    };
}
// Generate a tint of a given RGB color
function $ae3c5b1d0dc01863$var$generateTint(rgb, step) {
    const factor = $ae3c5b1d0dc01863$var$PERCENT * step;
    return {
        red: rgb.red + ($ae3c5b1d0dc01863$var$MAX_COLOR_VALUE - rgb.red) * factor,
        green: rgb.green + ($ae3c5b1d0dc01863$var$MAX_COLOR_VALUE - rgb.green) * factor,
        blue: rgb.blue + ($ae3c5b1d0dc01863$var$MAX_COLOR_VALUE - rgb.blue) * factor
    };
}
function $ae3c5b1d0dc01863$export$b02d3aa4baf6e348(hex) {
    return $ae3c5b1d0dc01863$var$calculateColors(hex, $ae3c5b1d0dc01863$var$generateShade);
}
function $ae3c5b1d0dc01863$export$187a2f2a625b3ef0(hex) {
    return $ae3c5b1d0dc01863$var$calculateColors(hex, $ae3c5b1d0dc01863$var$generateTint);
}
// General function to calculate shades or tints
function $ae3c5b1d0dc01863$var$calculateColors(hex, generateColor) {
    const rgb = $ae3c5b1d0dc01863$var$hexToRGB(hex);
    const colors = [];
    for(let i = 1; i < 9; i++)colors.push($ae3c5b1d0dc01863$var$rgbToHex(generateColor(rgb, i)));
    return colors;
}
function $ae3c5b1d0dc01863$export$c496300248fb0045(hex, colorKey, isReversed) {
    const BASE_INDEX = 100;
    const STEP = 50;
    const tints = $ae3c5b1d0dc01863$export$187a2f2a625b3ef0(hex).reverse().concat(hex);
    const shades = $ae3c5b1d0dc01863$export$b02d3aa4baf6e348(hex);
    const combinedColors = tints.concat(shades);
    const colorMap = {};
    const length = combinedColors.length;
    for(let i = 0; i < length; i++){
        const index = BASE_INDEX + (isReversed ? length - 1 - i : i) * STEP;
        colorMap[`${colorKey}${index}`] = combinedColors[i];
    }
    return colorMap;
}
function $ae3c5b1d0dc01863$export$5e317e8064e5f14a(baseColors, expandColors, options) {
    const output = {
        ...baseColors
    };
    for(const colorKey in expandColors){
        const expandColor = expandColors[colorKey];
        const isNeutralReversed = colorKey === "neutral" && !!options?.reverseNeutralRange;
        /*
     *Most of the colors are range but there are some colors that should be a single value e.g.
     *{
     *  // single value
     *   background: "#fff",
     *   // range
     *   primary: '#1C3CF1',
     *    primary500: '#1C3CF1',
     *    primary550: '#0B27C4',
     *}
     */ const isSingleColor = [
            "background",
            "foreground"
        ].includes(colorKey);
        if (!isSingleColor && !$ae3c5b1d0dc01863$var$isOverridingColor(colorKey)) {
            const expandedHexColor = $ae3c5b1d0dc01863$var$expandShortHexColor(expandColor);
            Object.assign(output, $ae3c5b1d0dc01863$export$c496300248fb0045(expandedHexColor, colorKey, isNeutralReversed));
        }
    }
    return {
        ...output,
        ...expandColors
    };
}


/* eslint-disable @typescript-eslint/no-magic-numbers */ // Original Code: https://github.com/stitchesjs/stitches/blob/canary/packages/core/src/convert/toHash.js
const $81d7ee5a80b4e0df$var$toAlphabeticChar = (code)=>String.fromCharCode(code + (code > 25 ? 39 : 97));
const $81d7ee5a80b4e0df$var$toAlphabeticName = (code)=>{
    let name = "";
    let x;
    for(x = Math.abs(code); x > 52; x = x / 52 | 0)name = $81d7ee5a80b4e0df$var$toAlphabeticChar(x % 52) + name;
    return $81d7ee5a80b4e0df$var$toAlphabeticChar(x % 52) + name;
};
const $81d7ee5a80b4e0df$var$toPhash = (h, x)=>{
    let i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
};
const $81d7ee5a80b4e0df$export$da43f679ba2e9167 = (value)=>$81d7ee5a80b4e0df$var$toAlphabeticName($81d7ee5a80b4e0df$var$toPhash(5381, JSON.stringify(value)) >>> 0);



function $3d6bbfe922540776$export$13fbd353224898bd(colors) {
    const baseColors = (0, $3dd421da623820a3$export$bca14c5b3b88a9c9).colors;
    const baseDarkColors = {
        ...baseColors,
        ...(0, $3dd421da623820a3$export$abadeef2f905fad3)
    };
    let lightTheme = undefined;
    let darkTheme = undefined;
    if (colors?.light) {
        const lightColors = (0, $ae3c5b1d0dc01863$export$5e317e8064e5f14a)(baseColors, colors.light);
        const tokens = {
            colors: lightColors
        };
        const id = `${(0, $6fd02b85a3828f9f$export$3d3091a962922574)}-light-${(0, $81d7ee5a80b4e0df$export$da43f679ba2e9167)(tokens)}`;
        lightTheme = {
            id: id,
            tokens: tokens
        };
    }
    if (colors?.dark) {
        const darkColors = (0, $ae3c5b1d0dc01863$export$5e317e8064e5f14a)(baseDarkColors, colors.dark, {
            reverseNeutralRange: true
        });
        const tokens = {
            colors: darkColors
        };
        const id = `${(0, $6fd02b85a3828f9f$export$3d3091a962922574)}-dark-${(0, $81d7ee5a80b4e0df$export$da43f679ba2e9167)(tokens)}`;
        darkTheme = {
            id: id,
            tokens: tokens
        };
    }
    return {
        light: lightTheme,
        dark: darkTheme
    };
}
function $3d6bbfe922540776$export$ae074417fbc9c359(list, divider) {
    if (list.length <= 1) return list.map(({ element: element, key: key })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(element, {
            key: key
        }));
    const output = [];
    list.forEach((item, index)=>{
        const { element: element, key: key } = item;
        output.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(element, {
            key: key
        }));
        if (index < list.length - 1) {
            const key = `divider-${index}`;
            output.push((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement(divider, {
                key: key
            }));
        }
    });
    return output;
}


function $80bd201e0bc05e20$var$doesWindowPreferDarkColorScheme() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function $80bd201e0bc05e20$export$93d4e7f90805808f(props) {
    const { colors: colors, fontFamily: fontFamily = (0, $0113bd1bc94a323f$export$2653e0d5dd45b294), borderRadius: borderRadius = (0, $6fd02b85a3828f9f$export$6caebe9814b9ee2b), secondaryBorderRadius: secondaryBorderRadius = (0, $6fd02b85a3828f9f$export$b59ee264a2367cd4) } = props;
    const [OSTheme, setOSTheme] = (0, $exYeM.useState)($80bd201e0bc05e20$var$doesWindowPreferDarkColorScheme() ? "dark" : "light");
    const { theme: theme } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { dark: dark, light: light } = (0, $3d6bbfe922540776$export$13fbd353224898bd)(colors);
    const baseTheme = (0, $3dd421da623820a3$export$25d302a5b900a763)({
        shadows: props.shadows || {},
        radii: {
            primary: `${borderRadius}px`,
            secondary: `${secondaryBorderRadius}px`
        },
        fonts: {
            widget: fontFamily
        }
    });
    const lightThemeClasses = [
        baseTheme.className,
        (0, $3dd421da623820a3$export$f30cb9bc4f736419).className
    ];
    const darkThemeClasses = [
        baseTheme.className,
        (0, $3dd421da623820a3$export$3e936a8db52a10a0).className
    ];
    /*
   * If theme has been customized, we will push the customized theme to override the default themes.
   * To be overridden, it should be last thing that has been pushed.
   */ if (light) {
        const customizedLightTheme = (0, $3dd421da623820a3$export$25d302a5b900a763)(light.id, light.tokens);
        lightThemeClasses.push(customizedLightTheme.className);
    }
    if (dark) {
        const customizedDarkTheme = (0, $3dd421da623820a3$export$25d302a5b900a763)(dark.id, dark.tokens);
        darkThemeClasses.push(customizedDarkTheme.className);
    }
    (0, $exYeM.useEffect)(()=>{
        const switchThemeListener = (event)=>{
            if (event.matches) setOSTheme("dark");
            else setOSTheme("light");
        };
        if ($80bd201e0bc05e20$var$doesWindowPreferDarkColorScheme()) setOSTheme("dark");
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", switchThemeListener);
        return ()=>{
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", switchThemeListener);
        };
    }, []);
    const getActiveTheme = ()=>{
        const lightClassNames = lightThemeClasses.join(" ");
        const darkClassNames = darkThemeClasses.join(" ");
        if (theme === "auto") return OSTheme === "dark" ? darkClassNames : lightClassNames;
        return theme === "dark" ? darkClassNames : lightClassNames;
    };
    return {
        activeTheme: getActiveTheme,
        mode: theme === "auto" ? OSTheme : theme
    };
}






const $cd356c8939bca632$export$e57dfc82f316498a = (manager)=>{
    const result = [];
    manager?.getAll().forEach((q, id)=>{
        const storage = q.list.getStorage();
        if (storage?.swapDetails) result.push({
            id: id,
            swap: storage?.swapDetails
        });
    });
    return result.sort((a, b)=>Number(b.swap.creationTime) - Number(a.swap.creationTime));
};






var $exYeM = parcelRequire("exYeM");
function $2e24a6e0fb7be7ce$export$14f54fee89b888e(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-active-tab-btn",
            onClick: props.onActivateTab,
            variant: "contained",
            size: "xxsmall",
            type: "warning"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Activate this tab")),
        type: "warning",
        variant: "alarm",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Another tab is open and handles transactions.")
    });
}







var $exYeM = parcelRequire("exYeM");


function $204e4e539b405a25$export$ba77044533392a5a(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: open,
        dismissible: true,
        onClose: onClose,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Activate current tab"),
        type: "warning",
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Currently, some transactions are running and being handled by other browser tab. If you activate this tab, all transactions that are already in the transaction sign step will expire.")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-modal-confirm-activate-tab-btn",
        variant: "contained",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: onConfirm
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm"))));
}






var $exYeM = parcelRequire("exYeM");

function $832f321a14fcd9c1$export$e0d897ee21382f67(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-back-icon-btn",
        variant: "ghost",
        size: "small",
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2e0408aac5dd3ed5$export$2e2bcd8739ae039), {
        color: "black",
        size: 16
    }));
}





var $exYeM = parcelRequire("exYeM");

function $f4c7b76472291cf1$export$488fee190faedb43(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$9baf379cdbf61443), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-header-cancel-btn",
        variant: "ghost",
        onClick: props.onClick,
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "error500"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Cancel"))));
}





var $exYeM = parcelRequire("exYeM");


function $a53ba131288deca8$export$eab4424f030fcb21(props) {
    const { list: list } = (0, $054d9182f00d4104$export$8c7712426fcad4df)();
    const connectedWallets = list.filter((wallet)=>wallet.state === "connected");
    const content = !connectedWallets.length ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect Wallet") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $7313e18cfe57bf45$export$a3abe124fc948fcd)()
    }, connectedWallets.map((wallet)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$3c76d375d5e2c498), {
            key: wallet.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: wallet.image,
            size: 14
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: props.container,
        side: "bottom",
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-wallet-icon-btn",
        variant: "ghost",
        size: "small",
        onClick: props.onClick
    }, props.isConnected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$2789403f16b80e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6bb2faf91f857227$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    })));
}





var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");






const $fee1a2b736a8a94e$export$aa94277a9804d2bd = (0, $e0ddf8b9111cc8ab$export$2e2bcd8739ae039)((0, $deedc9bfbd0dc16c$export$185802fd694ee1f5)()((0, $3ed31f3dd58f2a20$export$9a6132153fba2e0)((0, $3ed31f3dd58f2a20$export$5c593627aef9f076)((set, get)=>({
        isSynced: false,
        notifications: [],
        setNotification: (event, route)=>{
            const fromStep = route.steps[0];
            const toStep = route.steps[route.steps.length - 1];
            const notification = {
                event: event,
                creationTime: Date.now(),
                requestId: route.requestId,
                route: {
                    creationTime: parseInt(route.creationTime),
                    from: {
                        blockchain: fromStep.fromBlockchain,
                        address: fromStep.fromSymbolAddress,
                        symbol: fromStep.fromSymbol
                    },
                    to: {
                        blockchain: toStep.toBlockchain,
                        address: toStep.toSymbolAddress,
                        symbol: toStep.toSymbol
                    }
                }
            };
            const excludedList = get().notifications.filter((notificationItem)=>notificationItem.requestId !== route.requestId);
            set(()=>({
                    notifications: [
                        ...excludedList,
                        notification
                    ]
                }));
        },
        removeNotification: (requestId)=>{
            set((state)=>({
                    notifications: state.notifications.filter((notification)=>notification.requestId !== requestId)
                }));
        },
        getNotifications: ()=>{
            const { isSynced: isSynced, notifications: notifications } = get();
            return isSynced ? notifications.sort((a, b)=>{
                if (a.route.creationTime && !b.route.creationTime) return -1;
                if (!a.route.creationTime && b.route.creationTime) return 1;
                if (!a.route.creationTime && !b.route.creationTime) return b.creationTime - a.creationTime;
                return b.route.creationTime - a.route.creationTime;
            }) : [];
        },
        syncNotifications: (swaps)=>{
            const { isSynced: isSynced, notifications: notifications } = get();
            if (!isSynced) {
                const nextNotifications = [];
                notifications.forEach((notification)=>{
                    const swapExist = swaps.some((swap)=>swap.swap.requestId === notification.requestId);
                    if (swapExist) nextNotifications.push(notification);
                });
                set({
                    isSynced: true,
                    notifications: nextNotifications
                });
            }
        },
        clearNotifications: ()=>set({
                notifications: []
            })
    })), {
    name: "notification",
    skipHydration: true,
    partialize: ({ isSynced: isSynced, ...otherProps })=>otherProps,
    version: 1,
    migrate: (persistedState, version)=>{
        if (version === 0) {
            /**
             * Eliminate the persistence of read notifications,
             * and remove the "read" flag from other notifications to align with the current modifications in the notification store structure.
             */ const oldNotifications = persistedState.notifications;
            persistedState.notifications = oldNotifications.filter((notification)=>!notification.read).map(({ read: read, ...otherProps })=>otherProps);
        }
        return persistedState;
    }
})));



function $7fdd82cc91158a0d$export$503892287317b6c8() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { getNotifications: getNotifications, clearNotifications: clearNotifications } = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd)();
    const notifications = getNotifications();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const onClickItem = (requestId)=>{
        navigate(`${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).swaps}/${requestId}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $064ff9767570353c$export$36ba2f559d49a8f6), {
        list: notifications,
        getBlockchainImage: (blockchain)=>(0, $76ee130e8dc1847d$export$3f940559f33e83a0)(blockchain, blockchains) ?? "",
        getTokenImage: (token)=>findToken(token)?.image ?? "",
        onClickItem: onClickItem,
        onClearAll: clearNotifications
    });
}








var $exYeM = parcelRequire("exYeM");


const $4d0f20a3292e5368$var$InProgressTransactionBadge = ()=>{
    const { manager: manager } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const list = (0, $cd356c8939bca632$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    if (!list.find((swap)=>swap.status === "running")) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$4d2ac46462ee75ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bfd5cb152b935f2d$export$2e2bcd8739ae039), {
        color: "info",
        size: 6
    }));
};
var $4d0f20a3292e5368$export$2e2bcd8739ae039 = $4d0f20a3292e5368$var$InProgressTransactionBadge;





var $exYeM = parcelRequire("exYeM");


function $1c862d83702e137b$export$63c2f4b9e5b3caeb() {
    const { getNotifications: getNotifications } = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd)();
    const notificationsList = getNotifications();
    const notificationsCount = notificationsList.length;
    const hasSeverNotification = !!notificationsList.find((notificationItem)=>notificationItem.event.messageSeverity === (0, $ab26e0b6754d430c$export$ac89cc7182ae1ed0).WARNING);
    return notificationsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$9d7cce4585963231), {
        isSever: hasSeverNotification
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "$background"
    }, notificationsCount)) : null;
}




var $exYeM = parcelRequire("exYeM");

const $bd1c6af42d9c466b$var$REFRESH_INTERVAL = 1000;
const $bd1c6af42d9c466b$var$MAX_ELAPSED_TIME = 60;
const $bd1c6af42d9c466b$var$MAX_PERCENTAGE = 100;
function $bd1c6af42d9c466b$export$b6a16082cbe3a673({ onClick: onClick }) {
    const [elapsedTime, setElapsedTime] = (0, $exYeM.useState)(0);
    const [isRefetched, setIsRefetched] = (0, $exYeM.useState)(false);
    const handleVisibilityChange = (interval)=>{
        if (document.hidden && interval) // Tab is inactive, clear the interval
        clearTimeout(interval);
    };
    (0, $exYeM.useEffect)(()=>{
        let interval;
        if (onClick) interval = window.setInterval(()=>{
            setElapsedTime((prevTime)=>prevTime + 1);
            if (elapsedTime === $bd1c6af42d9c466b$var$MAX_ELAPSED_TIME) handleRefreshClick();
        }, $bd1c6af42d9c466b$var$REFRESH_INTERVAL);
        else clearTimeout(interval);
        document.addEventListener("visibilitychange", ()=>handleVisibilityChange(interval));
        return ()=>{
            document.removeEventListener("visibilitychange", ()=>handleVisibilityChange(interval));
            if (interval) clearInterval(interval);
        };
    }, [
        elapsedTime,
        onClick
    ]);
    const clearTimeout = (interval)=>{
        if (interval) clearInterval(interval);
        setElapsedTime(0);
    };
    const handleRefreshClick = ()=>{
        onClick?.();
        setElapsedTime(0);
        setIsRefetched(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-refresh-icon-btn",
        variant: "ghost",
        size: "small",
        style: {
            paddingTop: 0,
            paddingBottom: 0
        },
        onClick: handleRefreshClick,
        disabled: !onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$91fe1a97e725639f), {
        onTransitionEnd: ()=>setIsRefetched(false),
        isRefetched: isRefetched
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $de4e1a978c16da60$export$8d944f010ac3c33e), {
        size: 22,
        color: !onClick ? "gray" : "black",
        progress: elapsedTime / $bd1c6af42d9c466b$var$MAX_ELAPSED_TIME * $bd1c6af42d9c466b$var$MAX_PERCENTAGE
    })));
}


function $c7cd3627666a89e5$export$ed80cdffa8822341(props) {
    const { onClickRefresh: onClickRefresh, onClickHistory: onClickHistory, onClickSettings: onClickSettings, hidden: hidden = [], container: container } = props;
    const { config: { features: features } } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const isNotificationsHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("notification", features) || hidden.includes("notifications");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, !hidden.includes("refresh") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: container || (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Refresh")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bd1c6af42d9c466b$export$b6a16082cbe3a673), {
        onClick: onClickRefresh
    })), !isNotificationsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75e13ed4f8122291$export$5b6b19405a83ff9d), {
        align: "end",
        alignOffset: -88,
        sideOffset: 15,
        collisionPadding: {
            right: 20,
            left: 20
        },
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7fdd82cc91158a0d$export$503892287317b6c8), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Notifications")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-notification-icon-btn",
        size: "small",
        variant: "ghost"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff8602060d83f868$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1c862d83702e137b$export$63c2f4b9e5b3caeb), null))))), !hidden.includes("settings") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Settings")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-setting-icon-btn",
        size: "small",
        variant: "ghost",
        onClick: onClickSettings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59dc5f42ec7031c1$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }))), !hidden.includes("history") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        side: "top",
        content: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("History")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$c7c73467b57835d), {
        id: "widget-header-history-icon-btn",
        size: "small",
        variant: "ghost",
        onClick: onClickHistory
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $28575451c94002a6$export$2e2bcd8739ae039), {
        size: 18,
        color: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4d0f20a3292e5368$export$2e2bcd8739ae039), null))));
}







var $exYeM = parcelRequire("exYeM");



const $bc94ed44d786b668$export$b6a16082cbe3a673 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
});


function $2b4e54ce44fd9c8c$export$2263fae7e9cb987a(props) {
    const { open: open, onClose: onClose } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: open,
        dismissible: true,
        onClose: onClose,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Something went wrong"),
        type: "error",
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Something went wrong. Please refresh the app.")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bc94ed44d786b668$export$b6a16082cbe3a673), {
        variant: "outlined",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: ()=>location.reload()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ccf9750f04b1d14c$export$2e2bcd8739ae039), {
        size: 20,
        color: "primary"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Refresh"))));
}





function $b3c5e90feaeb4a1c$export$cc297bb97c600d29(e) {
    const contentElement = e.target;
    if (contentElement) {
        const fromTop = contentElement.scrollTop;
        const container = (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
        if (fromTop > 1) container.classList.add("rng-scrolled");
        else container.classList.remove("rng-scrolled");
    }
}



const $b0ed1a181150593d$var$WIDGET_HEIGHT = "700px";
const $b0ed1a181150593d$export$faad8b178f68f912 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    borderRadius: "$primary",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: "$mainContainer"
});
const $b0ed1a181150593d$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    width: "100vw",
    minWidth: "300px",
    maxWidth: "390px",
    backgroundColor: "$background",
    variants: {
        height: {
            auto: {
                height: "auto",
                maxHeight: $b0ed1a181150593d$var$WIDGET_HEIGHT
            },
            fixed: {
                height: $b0ed1a181150593d$var$WIDGET_HEIGHT
            }
        }
    }
});
const $b0ed1a181150593d$export$7c6e2c02157bb7d2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    overflow: "hidden",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflowY: "auto"
});
const $b0ed1a181150593d$export$a06f1c675e846f6f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "0 $20 $10",
    "& .footer__alert": {
        paddingTop: "$10"
    },
    "& .footer__logo": {
        opacity: 0,
        transition: "opacity 1s ease-in-out",
        "&.logo__show": {
            opacity: 1
        },
        "&.logo__hidden": {
            visibility: "hidden"
        }
    }
});


function $ff687e4433269b3c$export$c84671f46d6a1ca(props) {
    const { connectHeightObserver: connectHeightObserver, disconnectHeightObserver: disconnectHeightObserver } = (0, $c644546fde36009c$export$f7a742ca3c17ffb)();
    const { children: children, header: header, footer: footer, height: height = "fixed" } = props;
    const { fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [openRefreshModal, setOpenRefreshModal] = (0, $exYeM.useState)(false);
    const connectedWallets = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const { config: { features: features, theme: theme } } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { watermark: watermark } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const hasWatermark = watermark === "FULL";
    const { activeTheme: activeTheme } = (0, $80bd201e0bc05e20$export$93d4e7f90805808f)(theme || {});
    const isConnectWalletHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("connectWalletButton", features);
    const { isActiveTab: isActiveTab, tabManagerInitiated: tabManagerInitiated, showActivateTabModal: showActivateTabModal, setShowActivateTabModal: setShowActivateTabModal, activateCurrentTab: activateCurrentTab } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const { manager: manager } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const pendingSwaps = (0, $cd356c8939bca632$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    const hasRunningSwap = pendingSwaps.some((swap)=>swap.status === "running");
    const onActivateTab = ()=>activateCurrentTab((0, $0763b7f547a573fc$export$4a3066c505397ad1).forceClaim, hasRunningSwap);
    const onConnectWallet = ()=>{
        header.onWallet?.();
    };
    const showBackButton = typeof header.hasBackButton === "undefined" || header.hasBackButton;
    const scrollViewRef = (0, $exYeM.useRef)(null);
    const containerRef = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        const isIframe = (0, $b54140b98e48aa4e$export$be86b17dfe5c2dc1)();
        // This feature only will be available in an iframe context.
        if (isIframe && containerRef.current) connectHeightObserver(containerRef.current);
        return ()=>{
            disconnectHeightObserver();
        };
    }, []);
    (0, $exYeM.useEffect)(()=>{
        scrollViewRef.current?.addEventListener("scroll", (0, $b3c5e90feaeb4a1c$export$cc297bb97c600d29));
        return ()=>{
            scrollViewRef.current?.removeEventListener("scroll", (0, $b3c5e90feaeb4a1c$export$cc297bb97c600d29));
        };
    }, []);
    (0, $exYeM.useEffect)(()=>{
        setOpenRefreshModal(fetchStatus === "failed");
    }, [
        fetchStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b0ed1a181150593d$export$42a852a2b6b56249), {
        height: height,
        id: (0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID,
        className: `${activeTheme()} ${(0, $b0ed1a181150593d$export$faad8b178f68f912)()}`,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9616dbef4dcfe531$export$8b251419efc915eb), {
        prefix: showBackButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $832f321a14fcd9c1$export$e0d897ee21382f67), {
            onClick: ()=>{
                navigateBack();
                // As an example, used in routes page to add a custom logic when navigating back to the home page.
                header.onBack && header.onBack();
            }
        }) : null,
        title: header.title,
        suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, header.suffix, header.onWallet && !isConnectWalletHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a53ba131288deca8$export$eab4424f030fcb21), {
            container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
            onClick: onConnectWallet,
            isConnected: !!connectedWallets?.length
        }), header.onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f4c7b76472291cf1$export$488fee190faedb43), {
            onClick: header.onCancel
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b0ed1a181150593d$export$7c6e2c02157bb7d2), {
        ref: scrollViewRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $204e4e539b405a25$export$ba77044533392a5a), {
        open: showActivateTabModal,
        onClose: ()=>setShowActivateTabModal(false),
        onConfirm: onActivateTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b0ed1a181150593d$export$a06f1c675e846f6f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "footer__content"
    }, tabManagerInitiated && !isActiveTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "footer__alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2e24a6e0fb7be7ce$export$14f54fee89b888e), {
        onActivateTab: onActivateTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    })), footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: `footer__logo ${hasWatermark ? "logo__show" : "logo__hidden"}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $739811eb95ae3c7e$export$11833b2d9103c949), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b4e54ce44fd9c8c$export$2263fae7e9cb987a), {
        open: openRefreshModal,
        onClose: ()=>setOpenRefreshModal(false)
    }));
}



const $fd737d69d3de4ef4$export$6e84eb1dcf528852 = "$20 $20 $10 $20";
const $fd737d69d3de4ef4$export$83c3fa3ac4f31acf = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: $fd737d69d3de4ef4$export$6e84eb1dcf528852,
    overflowY: "auto",
    flexGrow: 1
});



const $6c5bde2e3b92044e$export$5f86df0ee0a255b5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    padding: "20px 20px 10px",
    flexGrow: 1,
    variants: {
        view: {
            true: {
                flexGrow: 1,
                overflow: "hidden"
            }
        },
        compact: {
            true: {
                padding: 0
            }
        }
    }
});








var $exYeM = parcelRequire("exYeM");


function $cf33983d2245a621$export$d2a2906ea5ab9ada() {
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const [error, setError] = (0, $exYeM.useState)(undefined);
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const customTokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().customTokens();
    function produceErrorMessage(type, blockchain) {
        switch(type){
            case "duplicated":
                return {
                    title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Duplicate Token"),
                    message: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("The address you entered is duplicate, please enter a new address.")
                };
            case "token-exist":
                return {
                    title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Token Already Exists"),
                    message: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(`There's no need to add this token again because it already exists and is supported by us.`)
                };
            case "not-found":
                return {
                    title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Token Not Found"),
                    message: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                        id: "Sorry, no token was found on {blockchain} chain with the provided address. please make sure you have entered the right token address.",
                        values: {
                            blockchain: blockchain
                        }
                    })
                };
        }
    }
    const fetchCustomToken = async ({ blockchain: blockchain, tokenAddress: tokenAddress })=>{
        setLoading(true);
        try {
            // Check for duplicate token in customTokens
            const isDuplicate = customTokens.some((token)=>token.address?.toLowerCase() === tokenAddress.toLowerCase());
            if (isDuplicate) {
                const errorMessage = produceErrorMessage("duplicated");
                setError(errorMessage);
                return undefined;
            }
            const response = await (0, $8a4b1db626d4e3d9$export$c1b2b945bea31d71)().getCustomToken({
                blockchain: blockchain,
                address: tokenAddress
            });
            if (!response || !response.token || response.error) {
                const errorMessage = produceErrorMessage("not-found", blockchain);
                setError(errorMessage);
                return undefined;
            }
            // Check if token is already in the system
            const token = response.token;
            const isTokenFound = findToken({
                blockchain: token.blockchain,
                address: token.address,
                symbol: token.symbol
            });
            if (isTokenFound) {
                const errorMessage = produceErrorMessage("token-exist");
                setError(errorMessage);
                return undefined;
            }
            return token;
        } catch (error) {
            setError(undefined);
            throw new Error(error.message);
        } finally{
            setLoading(false);
        }
    };
    return {
        fetchCustomToken: fetchCustomToken,
        loading: loading,
        error: error
    };
}






const $057238ebd3ed3dbf$var$Content = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    flex: 1,
    "& ._text-field": {
        padding: "$4 $10",
        backgroundColor: "$neutral300",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral400"
        },
        borderRadius: "$sm",
        height: "$40"
    }
});
const $057238ebd3ed3dbf$var$CUSTOM_TOKEN_REFRESH_DELAY = 1000;
function $057238ebd3ed3dbf$export$2ad972b9afb35534() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const { setCustomToken: setCustomToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const blockchainName = searchParams.get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).BLOCKCHAIN) || "";
    const blockchain = (0, $76ee130e8dc1847d$export$b20204be864cdab1)(blockchainName, blockchains);
    const [address, setAddress] = (0, $exYeM.useState)("");
    const [isOpenErrorModal, setIsOpenErrorModal] = (0, $exYeM.useState)(false);
    const [token, setToken] = (0, $exYeM.useState)();
    const { fetchCustomToken: fetchCustomToken, loading: loading, error: error } = (0, $cf33983d2245a621$export$d2a2906ea5ab9ada)();
    const [networkError, setNetworkError] = (0, $exYeM.useState)("");
    const isValidAddress = !!blockchain && (0, $76ee130e8dc1847d$export$e331c843472783ec)(blockchain, address);
    const isImportDisabled = !blockchain || !address || !isValidAddress;
    const getCustomToken = async ()=>{
        if (blockchain) try {
            const res = await fetchCustomToken({
                blockchain: blockchainName,
                tokenAddress: address
            });
            setNetworkError("");
            if (!!res) setToken(res);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.message === "Failed to fetch") {
                setNetworkError((0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Network Error"));
                setIsOpenErrorModal(true);
            }
        }
    };
    const closeErrorModal = ()=>{
        if (!!error) setAddress("");
        setIsOpenErrorModal(false);
    };
    const handleErrorModalButtonClick = async ()=>{
        if (!!networkError) setTimeout(async ()=>{
            await getCustomToken();
        }, $057238ebd3ed3dbf$var$CUSTOM_TOKEN_REFRESH_DELAY);
        closeErrorModal();
    };
    (0, $exYeM.useEffect)(()=>{
        if (!!error) setIsOpenErrorModal(true);
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Add Custom Token")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($057238ebd3ed3dbf$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d2ad8cc9562553b$export$508837fc497186f1), {
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).blockchains, {
                replace: true
            }),
        hasLogo: !!blockchain?.logo,
        value: !!blockchain ? {
            name: blockchain.displayName,
            logo: blockchain.logo
        } : undefined,
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select chain"),
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select chain")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "large",
        variant: "label"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enter Address")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
        fullWidth: true,
        disabled: !blockchain,
        variant: "contained",
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enter token address"),
        size: "large",
        value: address,
        suffix: !!address && isValidAddress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5815e032006c952c$export$2e2bcd8739ae039), {
            color: "success",
            size: 12
        }),
        onChange: (e)=>setAddress(e.target.value)
    }), !isValidAddress && !!address && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "error",
        variant: "alarm",
        title: "Invalid Address"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-add-custom-token-import-btn",
        disabled: isImportDisabled,
        type: "primary",
        variant: "contained",
        loading: loading,
        size: "large",
        onClick: getCustomToken
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Import"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: isOpenErrorModal,
        dismissible: true,
        onClose: closeErrorModal,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: error?.title || networkError,
        type: "error",
        description: error?.message || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Failed Network, Please retry.")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 40
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: `widget-add-custom-token-${networkError ? "retry" : "add-another"}-btn`,
        variant: "contained",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: handleErrorModalButtonClick
    }, networkError ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Retry") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Add another custom token")))), blockchain && token && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ebfbc8baf7dbe530$export$7b29f3327b1aa922), {
        blockchain: blockchain,
        token: token,
        onSubmitClick: ()=>{
            if (token) {
                setCustomToken(token);
                setToken(undefined);
                navigateBack();
            }
        },
        onClose: ()=>setToken(undefined),
        open: !!blockchain && !!token
    })));
}


/* eslint-disable @typescript-eslint/no-magic-numbers */ 



var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");





function $4e1ec8cfadcc6066$export$bd041dac165cd8f3(warning) {
    switch(warning.type){
        case (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_UPDATED:
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Route has been updated.");
        case (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_AND_OUTPUT_AMOUNT_UPDATED:
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Output amount changed to {newOutputAmount} ({percentageChange}% change).", {
                newOutputAmount: warning.newOutputAmount,
                percentageChange: warning.percentageChange
            });
        case (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_SWAPPERS_UPDATED:
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Route swappers has been updated.");
        case (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_COINS_UPDATED:
            return (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Route internal coins has been updated.");
        default:
            return "";
    }
}












var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");


const $3eb85c698767267e$export$7eefde46b9d5b934 = 300;
const $3eb85c698767267e$var$slideDown = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const $3eb85c698767267e$var$slideUp = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const $3eb85c698767267e$export$2ad57374564f8390 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$be92b6f5f03c0fe9, {
    borderRadius: "$sm",
    overflow: "hidden",
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                outlineColor: "$secondary500",
                outlineStyle: "solid"
            }
        }
    }
});
const $3eb85c698767267e$export$41fb9f06171c75f4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$41fb9f06171c75f4, {
    padding: "$0",
    border: "none",
    outline: "none",
    width: "100%",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    cursor: "pointer"
});
const $3eb85c698767267e$export$aadde00976f34151 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$7c6e2c02157bb7d2, {
    overflow: "hidden",
    variants: {
        open: {
            true: {
                animation: `${$3eb85c698767267e$var$slideDown} ${$3eb85c698767267e$export$7eefde46b9d5b934}ms ease-out`
            },
            false: {
                animation: `${$3eb85c698767267e$var$slideUp} ${$3eb85c698767267e$export$7eefde46b9d5b934}ms ease-out`
            }
        }
    }
});
const $3eb85c698767267e$export$f5cb197ef241297f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    transition: `all ${$3eb85c698767267e$export$7eefde46b9d5b934}ms ease`,
    display: "flex",
    alignItems: "center",
    variants: {
        orientation: {
            down: {
                transform: "rotate(0)"
            },
            up: {
                transform: "rotate(180deg)"
            }
        }
    }
});


function $89c4abf263bb57c4$export$810d59a3bedb5238(props) {
    const { open: open, hasSelected: hasSelected, onOpenChange: onOpenChange, children: children, onClickTrigger: onClickTrigger, trigger: trigger, triggerAnchor: triggerAnchor } = props;
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$2ad57374564f8390), {
        ref: ref,
        className: "collapsible_root",
        selected: hasSelected && open,
        open: open,
        onOpenChange: onOpenChange
    }, triggerAnchor === "top" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$41fb9f06171c75f4), {
        className: "collapsible_trigger",
        onClick: onClickTrigger
    }, trigger), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$aadde00976f34151), {
        className: "collapsible_content",
        open: open
    }, children), triggerAnchor === "bottom" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$41fb9f06171c75f4), {
        className: "collapsible_trigger",
        onClick: onClickTrigger
    }, trigger));
}




const $8229114b82774ea9$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$10 $0",
    "& .button__content": {
        display: "flex",
        alignItems: "center"
    },
    "& .alarms": {
        paddingTop: "$5"
    },
    "& .collapsible_content": {
        backgroundColor: "$neutral100"
    },
    "& .collapsible_root": {
        backgroundColor: "$neutral100"
    }
});
const $8229114b82774ea9$export$111e140b0af40b4e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
    backgroundColor: "$neutral100",
    padding: "$15"
});
const $8229114b82774ea9$export$803b1587b4adf5ec = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderRadius: "$sm",
    display: "flex",
    padding: "$15",
    justifyContent: "space-between",
    alignItems: "center",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderBottomRightRadius: "0",
    borderBottomLeftRadius: "0",
    "&:focus-visible": {
        $$background: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$background: "$colors$info700"
        },
        backgroundColor: "$$background",
        outline: 0
    }
});


function $7289237d8dfd0950$export$5dcdfad7d0e5961d(props) {
    const { blockchain: blockchain, handleOpenChange: handleOpenChange, open: open } = props;
    const { customDestination: customDestination, setCustomDestination: setCustomDestination } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const blockchainName = (0, $76ee130e8dc1847d$export$96fcfd2cb226eb33)(blockchain.name, blockchains);
    const inputRef = (0, $exYeM.useRef)(null);
    const configDestination = config?.defaultCustomDestinations?.[blockchain.name];
    const isFirefox = navigator?.userAgent.includes("Firefox");
    const isAddressChecked = open && !!customDestination && blockchain;
    const isAddressInvalid = isAddressChecked && !(0, $76ee130e8dc1847d$export$e331c843472783ec)(blockchain, customDestination);
    const handleClear = ()=>{
        setCustomDestination("");
    };
    const handlePaste = async (event)=>{
        event.preventDefault();
        if (navigator.clipboard !== undefined) {
            const pastedText = await navigator.clipboard.readText();
            setCustomDestination(pastedText);
            inputRef?.current?.focus();
        }
    };
    const renderSuffix = ()=>{
        if (customDestination) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            id: "widget-custom-destination-close-icon-btn",
            onClick: handleClear,
            variant: "ghost"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8192be46f8fafa5a$export$2e2bcd8739ae039), {
            size: 12,
            color: "gray"
        }));
        else if (!isFirefox) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            id: "widget-custom-destination-paste-icon-btn",
            onClick: handlePaste,
            variant: "ghost"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc10cd7dea101db2$export$2e2bcd8739ae039), {
            size: 16
        }));
        return null;
    };
    (0, $exYeM.useEffect)(()=>{
        const shouldUseConfigDestination = !!configDestination && customDestination === null;
        if (shouldUseConfigDestination) {
            setCustomDestination(configDestination);
            handleOpenChange(true);
        }
    }, [
        configDestination
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8229114b82774ea9$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $89c4abf263bb57c4$export$810d59a3bedb5238), {
        onOpenChange: handleOpenChange,
        hasSelected: true,
        open: open,
        triggerAnchor: "top",
        trigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8229114b82774ea9$export$803b1587b4adf5ec), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            className: "button__content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6bb2faf91f857227$export$2e2bcd8739ae039), {
            size: 18,
            color: "info"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 4,
            direction: "horizontal"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "label",
            size: "medium",
            color: open ? "$neutral600" : undefined
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Send to a different address"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$f5cb197ef241297f), {
            orientation: open ? "up" : "down"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
            size: 10,
            color: "secondary"
        }))),
        onClickTrigger: ()=>handleOpenChange(!open)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8229114b82774ea9$export$111e140b0af40b4e), {
        ref: inputRef,
        style: {
            padding: 0,
            paddingRight: customDestination ? "8px" : "5px"
        },
        autoFocus: !customDestination,
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enter {blockchainName} address", {
            blockchainName: blockchainName
        }),
        value: customDestination || "",
        suffix: renderSuffix(),
        onChange: (e)=>{
            const customDestination = e.target.value;
            setCustomDestination(customDestination);
        }
    })), isAddressInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            values: {
                destination: customDestination
            },
            id: "Address {destination} doesn't match the blockchain address pattern."
        })
    })));
}



const $c77eb20a43ee72e4$export$f99233281efd08a0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $c77eb20a43ee72e4$export$122a2a667e12876b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5",
    height: "100%"
});
const $c77eb20a43ee72e4$export$eab4424f030fcb21 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("button", {
    borderRadius: "$xm",
    padding: "$10",
    border: "0",
    display: "flex",
    justifyContent: "center",
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    alignItems: "center",
    cursor: "pointer",
    width: 110,
    position: "relative",
    "&:hover": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral100"
        },
        backgroundColor: "$$color"
    },
    "&:focus-visible": {
        $$color: "$colors$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$info700"
        },
        backgroundColor: "$$color",
        outline: 0
    },
    variants: {
        selected: {
            true: {
                outlineWidth: 1,
                outlineColor: "$secondary",
                outlineStyle: "solid"
            }
        }
    }
});
const $c77eb20a43ee72e4$export$f25b3164f5886a30 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($c77eb20a43ee72e4$export$eab4424f030fcb21, {
    alignSelf: "stretch",
    minHeight: "93px"
});
const $c77eb20a43ee72e4$export$316083882e71f2d3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $15 $20",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$neutral200",
    position: "relative",
    width: "100%"
});
const $c77eb20a43ee72e4$export$48f498d418060b34 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
    position: "absolute",
    left: "$20"
});
const $c77eb20a43ee72e4$export$cd7f52d9cefc7c7e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingTop: "$20"
});
const $c77eb20a43ee72e4$export$5b16c1e739cf7357 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5",
    height: "100%"
});
const $c77eb20a43ee72e4$export$2271e07b17a755d3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $c77eb20a43ee72e4$export$5cde6cad58293e28 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    overflow: "visible",
    width: "100%"
});






var $exYeM = parcelRequire("exYeM");














var $exYeM = parcelRequire("exYeM");

const $c782828c97902d00$export$d43ffeaaec0b2a58 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative"
});
const $c782828c97902d00$var$SpinAnimation = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $c782828c97902d00$export$7f7cbe89f1eacd2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    border: "2px solid rgba(0, 0, 0, 0.1)",
    borderTop: "2px solid $info500",
    borderRadius: "$lg",
    width: "$45",
    height: "$45",
    animation: `${$c782828c97902d00$var$SpinAnimation} 1s linear infinite`,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
});
const $c782828c97902d00$export$3c76d375d5e2c498 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    "& img": {
        borderRadius: "50%"
    }
});



function $92f2ad5119104648$export$66f78e44fb2f2387(status, blockchainDisplayName) {
    switch(status){
        case "in-progress":
            return {
                type: "loading",
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                    id: "Add {blockchainDisplayName} Chain",
                    values: {
                        blockchainDisplayName: blockchainDisplayName
                    }
                }),
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                    id: "Please approve the experimental chain pop-up in your wallet.",
                    values: {
                        blockchainDisplayName: blockchainDisplayName
                    }
                })
            };
        case "completed":
            return {
                type: "success",
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                    id: "{blockchainDisplayName} Chain Added",
                    values: {
                        blockchainDisplayName: blockchainDisplayName
                    }
                }),
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                    id: "The {blockchainDisplayName} chain has been successfully added to your wallet.",
                    values: {
                        blockchainDisplayName: blockchainDisplayName
                    }
                })
            };
        case "rejected":
            return {
                type: "error",
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Request Rejected"),
                description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                    id: "You've rejected adding {blockchainDisplayName} chain to your wallet.",
                    values: {
                        blockchainDisplayName: blockchainDisplayName
                    }
                })
            };
        default:
            throw new Error(`Showing information about an experimentation chain status needs to be defined first. status: ${status}`);
    }
}


function $fd539d9e895df9ae$export$c4df5a643b2e3365(props) {
    const { status: status, displayName: displayName, image: image } = props;
    const data = (0, $92f2ad5119104648$export$66f78e44fb2f2387)(status, displayName);
    const hasImage = status == "in-progress";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: data.type,
        title: data.title,
        description: data.description,
        icon: hasImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c782828c97902d00$export$d43ffeaaec0b2a58), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c782828c97902d00$export$3c76d375d5e2c498), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: image,
            size: 45
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c782828c97902d00$export$7f7cbe89f1eacd2), null)) : undefined
    });
}



const $bef4b4ec6f094a96$var$ACCOUNT_ADDRESS_MAX_CHARACTERS = 7;
const $bef4b4ec6f094a96$var$TIME_TO_CLOSE_MODAL = 3000;
function $bef4b4ec6f094a96$export$c14550826a96138d(props) {
    const { chain: chain, isSelected: isSelected, selectWallet: selectWallet, limit: limit, onShowMore: onShowMore } = props;
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    const connectedWallets = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const { blockchains: blockchains } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [selectedWalletToConnect, setSelectedWalletToConnect] = (0, $exYeM.useState)();
    const [experimentalChainWallet, setExperimentalChainWallet] = (0, $exYeM.useState)(null);
    const [showExperimentalChainModal, setShowExperimentalChainModal] = (0, $exYeM.useState)(false);
    const [addingExperimentalChainStatus, setAddingExperimentalChainStatus] = (0, $exYeM.useState)(null);
    const { suggestAndConnect: suggestAndConnect } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const { handleDisconnect: handleDisconnect } = (0, $cd10f5b2a6cbb0dc$export$bccd57329105f7af)();
    const { list: list } = (0, $054d9182f00d4104$export$8c7712426fcad4df)({
        chain: chain
    });
    const [sortedList, setSortedList] = (0, $exYeM.useState)(list);
    const numberOfSupportedWallets = list.length;
    const shouldShowMoreWallets = limit && numberOfSupportedWallets - limit > 0;
    const addExperimentalChain = async (wallet)=>{
        setShowExperimentalChainModal(false);
        setAddingExperimentalChainStatus("in-progress");
        try {
            await suggestAndConnect(wallet.walletType, wallet.chain);
            setAddingExperimentalChainStatus("completed");
        } catch (e) {
            setAddingExperimentalChainStatus("rejected");
        }
    };
    (0, $exYeM.useEffect)(()=>{
        setSortedList((sortedList)=>{
            const selectedWalletIndex = list.findIndex((wallet)=>isSelected(wallet.type, chain));
            if (shouldShowMoreWallets && selectedWalletIndex > 1) return [
                list[selectedWalletIndex]
            ].concat(list.filter((_, index)=>index !== selectedWalletIndex));
            return sortedList.map((sortedItem)=>list.find((listItem)=>listItem.type === sortedItem.type) ?? sortedItem);
        });
    }, [
        JSON.stringify(list)
    ]);
    const modalContainer = document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID);
    (0, $exYeM.useEffect)(()=>{
        let timeout = null;
        if (addingExperimentalChainStatus === "completed" || addingExperimentalChainStatus === "rejected") timeout = setTimeout(()=>setAddingExperimentalChainStatus(null), $bef4b4ec6f094a96$var$TIME_TO_CLOSE_MODAL);
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        addingExperimentalChainStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, sortedList.slice(0, limit).map((wallet)=>{
        const address = (0, $b27897cbc1e94793$export$88411125f012957a)({
            connectedWallets: connectedWallets,
            walletType: wallet.type,
            chain: chain
        });
        const conciseAddress = address ? (0, $b27897cbc1e94793$export$ebc397f3c3118f9b)(address, $bef4b4ec6f094a96$var$ACCOUNT_ADDRESS_MAX_CHARACTERS) : "";
        const experimentalChain = (0, $b27897cbc1e94793$export$61051f1588e51c47)(blockchains(), chain);
        const experimentalChainNotAdded = !connectedWallets.find((connectedWallet)=>connectedWallet.walletType === wallet.type && connectedWallet.chain === chain);
        const couldAddExperimentalChain = experimentalChain && experimentalChainNotAdded && wallet.state === (0, $b573446a19694996$export$ba984d729fe7282e).CONNECTED;
        const connectedWalletDescription = couldAddExperimentalChain ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Add {chain} chain",
            values: {
                chain: chain
            }
        }) : conciseAddress;
        const onSelectableWalletClick = async ()=>{
            const isDisconnected = wallet.state === (0, $b573446a19694996$export$ba984d729fe7282e).DISCONNECTED;
            if (isDisconnected) setSelectedWalletToConnect(wallet);
            else if (!!wallet.namespaces && !conciseAddress) {
                // wallet is connected on a different namespace
                await handleDisconnect(wallet.type);
                setSelectedWalletToConnect(wallet);
            } else if (couldAddExperimentalChain) {
                setExperimentalChainWallet({
                    walletType: wallet.type,
                    chain: chain,
                    address: address ?? ""
                });
                setShowExperimentalChainModal(true);
            } else selectWallet({
                walletType: wallet.type,
                chain: chain,
                address: address ?? ""
            });
        };
        const blockchainDisplayName = experimentalChainWallet?.chain ? (0, $76ee130e8dc1847d$export$96fcfd2cb226eb33)(experimentalChainWallet.chain, blockchains()) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: `${wallet.title}_${blockchainDisplayName}`
        }, !!experimentalChainWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
            open: !!experimentalChainWallet && showExperimentalChainModal,
            container: modalContainer,
            onClose: ()=>{
                setExperimentalChainWallet(null);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $621c234ddbd689a1$export$81938e7db5b62af2), {
            displayName: blockchainDisplayName,
            onConfirm: ()=>{
                addExperimentalChain(experimentalChainWallet);
            }
        })), addingExperimentalChainStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
            open: !!addingExperimentalChainStatus,
            onClose: setAddingExperimentalChainStatus.bind(null, null),
            container: modalContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fd539d9e895df9ae$export$c4df5a643b2e3365), {
            status: addingExperimentalChainStatus,
            displayName: blockchainDisplayName,
            image: wallet.image
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "vertical",
            size: 32
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $42a8fe687f7787a4$export$d2242c7b771012ce), {
            key: wallet.type,
            description: connectedWalletDescription,
            onClick: onSelectableWalletClick,
            selected: isSelected(wallet.type, chain),
            disabled: !isActiveTab,
            ...wallet
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a533ccd38320000a$export$7710cdf1210cd2fb), {
        wallet: selectedWalletToConnect,
        onClose: ()=>{
            setSelectedWalletToConnect(undefined);
        },
        onConnect: (result)=>{
            if (props.onConnect && result.status === (0, $610ef28624c7c1dc$export$7103a54af3e45080).Connected) {
                if (selectedWalletToConnect?.type) props.onConnect(selectedWalletToConnect.type);
                else (0, $2d0ef42914e3f734$export$c106dd0671a0fc2d)(new Error("The selected wallet hasn't been detected after the connection process finished. It usually shouldn't happen."));
            }
        }
    }), shouldShowMoreWallets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$f25b3164f5886a30), {
        selected: false,
        onClick: onShowMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Show more wallets"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "$primary"
    }, "\xa0+", numberOfSupportedWallets - (limit ?? 0)))));
}


const $34b0e7cab88d17f2$var$NUMBER_OF_WALLETS_TO_DISPLAY = 2;
function $34b0e7cab88d17f2$export$d70033d2e2cb025(props) {
    //TODO: move component's logics to a custom hook
    const { open: open, onClose: onClose, onCancel: onCancel, onCheckBalance: onCheckBalance, loading: loading } = props;
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { selectedQuote: selectedQuote, setSelectedWallets: selectQuoteWallets, quoteWalletsConfirmed: quoteWalletsConfirmed, setQuoteWalletConfirmed: setQuoteWalletConfirmed, customDestination: customDestination, setCustomDestination: setCustomDestination } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { connectedWallets: connectedWallets, selectWallets: selectWallets } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [showMoreWalletFor, setShowMoreWalletFor] = (0, $exYeM.useState)("");
    const [balanceWarnings, setBalanceWarnings] = (0, $exYeM.useState)([]);
    const [error, setError] = (0, $exYeM.useState)("");
    const [quoteWarning, setQuoteWarning] = (0, $exYeM.useState)(null);
    const [isCustomDestinationOpen, setCustomDestinationOpen] = (0, $exYeM.useState)(!!customDestination);
    const quoteWallets = (0, $exYeM.useMemo)(()=>(0, $b27897cbc1e94793$export$eb1ab48c3aa3d9f2)({
            filter: "all",
            quote: selectedQuote
        }), [
        selectedQuote
    ]);
    const requiredWallets = (0, $b27897cbc1e94793$export$eb1ab48c3aa3d9f2)({
        filter: "required",
        quote: selectedQuote
    });
    const lastStepToBlockchain = blockchains.find((blockchain)=>blockchain.name === selectedQuote?.swaps[selectedQuote?.swaps.length - 1].to.blockchain);
    const isWalletRequiredFor = (blockchain)=>requiredWallets.includes(blockchain);
    const getInitialSelectableWallets = (0, $exYeM.useCallback)(()=>connectedWallets.filter((connectedWallet)=>{
            return connectedWallet.selected && quoteWallets.includes(connectedWallet.chain);
        }), [
        connectedWallets,
        quoteWallets
    ]);
    const [selectableWallets, setSelectableWallets] = (0, $exYeM.useState)(getInitialSelectableWallets());
    const [nextSelectedWallets, setNextSelectedWallets] = (0, $exYeM.useState)([]);
    const addNextSelectedWallets = (blockchain, walletType)=>setNextSelectedWallets((prevState)=>prevState.concat({
                blockchain: blockchain,
                walletType: walletType
            }));
    const isInsufficientBalanceModalOpen = balanceWarnings.length > 0;
    const isSelected = (walletType, chain)=>!!selectableWallets.find((selectableWallet)=>selectableWallet.walletType === walletType && selectableWallet.chain === chain && selectableWallet.selected && (isWalletRequiredFor(chain) || !isWalletRequiredFor(chain) && !customDestination));
    const updateSelectableWallets = (wallets, chainName, shouldSelect)=>{
        let isAnyWalletSelected = false;
        return wallets.map((wallet)=>{
            if (wallet.chain === chainName) {
                let selected = wallet.selected;
                if (!isAnyWalletSelected && shouldSelect) {
                    isAnyWalletSelected = true;
                    selected = true;
                } else if (!shouldSelect) selected = false;
                return {
                    ...wallet,
                    selected: selected
                };
            }
            return wallet;
        });
    };
    const handleCustomDestinationCollapsibleOpenChange = (open)=>{
        setCustomDestinationOpen(open);
        if (!open) {
            setCustomDestination("");
            setSelectableWallets((selectableWallets)=>{
                return updateSelectableWallets(selectableWallets, lastStepToBlockchain?.name || "", true);
            });
        } else if (!isWalletRequiredFor(lastStepToBlockchain?.name ?? "")) setSelectableWallets((selectableWallets)=>{
            return updateSelectableWallets(selectableWallets, lastStepToBlockchain?.name || "", false);
        });
    };
    const onChange = (wallet)=>{
        if (showMoreWalletFor) setShowMoreWalletFor("");
        const selected = isSelected(wallet.walletType, wallet.chain);
        if (selected) return;
        const connectedWallet = connectedWallets.find((connectedWallet)=>connectedWallet.walletType === wallet.walletType && connectedWallet.chain === wallet.chain);
        if (!connectedWallet) return;
        onCancel();
        if (wallet.chain === lastStepToBlockchain?.name && isCustomDestinationOpen && !isWalletRequiredFor(lastStepToBlockchain.name)) {
            setCustomDestinationOpen(false);
            setCustomDestination(null);
        }
        setSelectableWallets((selectableWallets)=>selectableWallets.filter((selectableWallet)=>selectableWallet.chain !== wallet.chain).concat({
                ...connectedWallet,
                selected: true
            }));
    };
    const onConfirmBalance = ()=>{
        const lastSelectedWallets = selectableWallets.filter((wallet)=>wallet.selected);
        selectWallets(lastSelectedWallets);
        selectQuoteWallets(lastSelectedWallets);
        setQuoteWalletConfirmed(true);
        onClose();
    };
    const onConfirmWallets = async ()=>{
        setBalanceWarnings([]);
        setError("");
        setQuoteWarning(null);
        const result = await onCheckBalance?.({
            selectedWallets: selectableWallets.filter((wallet)=>wallet.selected),
            customDestination: customDestination
        });
        const warnings = result.warnings;
        if (warnings?.balance?.messages) setBalanceWarnings(warnings.balance.messages);
        if (warnings?.quoteUpdate) setQuoteWarning(warnings.quoteUpdate);
        if (result.error) setError((0, $f273788a9b293b5f$export$90611c8061ee618c)(result.error));
        if (!result.error && (!warnings?.balance?.messages.length || false)) onConfirmBalance();
        else setBalanceWarnings(warnings?.balance?.messages ?? []);
    };
    (0, $exYeM.useEffect)(()=>{
        setSelectableWallets((selectableWallets)=>{
            let nextState = [];
            //if wallet disconnected we should unselect the wallet from the list
            selectableWallets.forEach((selectableWallet)=>{
                const walletDisconnected = !connectedWallets.some((connectedWallet)=>connectedWallet.chain === selectableWallet.chain && connectedWallet.walletType === selectableWallet.walletType && connectedWallet.address === selectableWallet.address);
                if (!walletDisconnected) nextState.push(selectableWallet);
            });
            /**
       * We confirm if a newly connected wallet for a blockchain is marked as selected in the store,
       * but there are no selected wallets for that blockchain in our list.
       * If this condition is met, we include the wallet in our list as selected.
       */ nextState = nextState.concat(connectedWallets.filter((connectedWallet)=>{
                const anyWalletSelected = !!nextState.find((selectableWallet)=>selectableWallet.chain === connectedWallet.chain);
                return !anyWalletSelected && connectedWallet.selected && quoteWallets.includes(connectedWallet.chain);
            }));
            return nextState;
        });
    }, [
        connectedWallets,
        quoteWallets
    ]);
    (0, $exYeM.useEffect)(()=>{
        const nextState = [];
        if (nextSelectedWallets.length > 0) {
            nextSelectedWallets.forEach((selectedWallet)=>{
                const wallet = connectedWallets.find((wallet)=>wallet.chain === selectedWallet.blockchain && wallet.walletType === selectedWallet.walletType);
                if (wallet) onChange(wallet);
                else nextState.push(selectedWallet);
            });
            setNextSelectedWallets(nextState);
        }
    }, [
        connectedWallets,
        nextSelectedWallets
    ]);
    const modalContainer = document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: open,
        onClose: ()=>{
            if (!quoteWalletsConfirmed) {
                const home = "../";
                navigate(home, {
                    replace: true
                });
            }
            onClose();
        },
        dismissible: !showMoreWalletFor,
        container: modalContainer,
        ...!showMoreWalletFor && {
            styles: {
                container: {
                    height: "100%"
                }
            },
            footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$2271e07b17a755d3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
                id: "widget-confirm-wallet-modal-confirm-btn",
                loading: loading,
                disabled: (0, $8e9d7744e1038276$export$f485b865770f4e4c)(loading, isCustomDestinationOpen, customDestination, selectedQuote, selectableWallets, lastStepToBlockchain),
                onClick: onConfirmWallets,
                variant: "contained",
                type: "primary",
                fullWidth: true,
                size: "large"
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm")))
        },
        ...showMoreWalletFor && {
            styles: {
                container: {
                    height: "100%",
                    padding: "$0"
                }
            },
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$316083882e71f2d3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$48f498d418060b34), {
                id: "widget-confirm-wallet-modal-navigate-back-icon-btn",
                variant: "ghost",
                onClick: setShowMoreWalletFor.bind(null, "")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2e0408aac5dd3ed5$export$2e2bcd8739ae039), {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "headline",
                size: "small"
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                id: "Your {blockchainName} wallets",
                values: {
                    blockchainName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(showMoreWalletFor, blockchains)
                }
            })))
        },
        anchor: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: isInsufficientBalanceModalOpen,
        onClose: setBalanceWarnings.bind(null, []),
        container: modalContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Insufficient account balance"),
        type: "error",
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $858269b0b7dfb3e7$export$137c1412116f174), {
            messages: balanceWarnings ?? []
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-confirm-wallet-modal-proceed-anyway-btn",
        variant: "outlined",
        size: "large",
        type: "primary",
        fullWidth: true,
        onClick: onConfirmBalance
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Proceed anyway")))), showMoreWalletFor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$cd7f52d9cefc7c7e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $c77eb20a43ee72e4$export$5b16c1e739cf7357)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bef4b4ec6f094a96$export$c14550826a96138d), {
        chain: showMoreWalletFor,
        isSelected: isSelected,
        selectWallet: onChange,
        onShowMore: ()=>setShowMoreWalletFor(showMoreWalletFor),
        onConnect: (walletType)=>{
            addNextSelectedWallets(showMoreWalletFor, walletType);
        }
    }))), !showMoreWalletFor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(error)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    })), quoteWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "warning",
        title: (0, $4e1ec8cfadcc6066$export$bd041dac165cd8f3)(quoteWarning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$5cde6cad58293e28), null, quoteWallets.map((requiredWallet, index)=>{
        const blockchain = blockchains.find((blockchain)=>blockchain.name === requiredWallet);
        const key = `wallet-${index}`;
        const isLastWallet = index === quoteWallets.length - 1;
        const showCustomDestination = isLastWallet && lastStepToBlockchain && config?.customDestination !== false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$f99233281efd08a0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Your {blockchainName} wallets",
            values: {
                blockchainName: blockchain?.shortName
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "label",
            color: "$neutral700",
            size: "medium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "You need to connect a {blockchainName} wallet.",
            values: {
                blockchainName: blockchain?.shortName
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 24
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c77eb20a43ee72e4$export$122a2a667e12876b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bef4b4ec6f094a96$export$c14550826a96138d), {
            chain: requiredWallet,
            isSelected: isSelected,
            selectWallet: onChange,
            limit: $34b0e7cab88d17f2$var$NUMBER_OF_WALLETS_TO_DISPLAY,
            onShowMore: ()=>setShowMoreWalletFor(blockchain?.name ?? ""),
            onConnect: (walletType)=>{
                addNextSelectedWallets(requiredWallet, walletType);
            }
        })), !isLastWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 32
        }), showCustomDestination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7289237d8dfd0950$export$5dcdfad7d0e5961d), {
            blockchain: lastStepToBlockchain,
            open: isCustomDestinationOpen,
            handleOpenChange: handleCustomDestinationCollapsibleOpenChange
        }));
    }))));
}







var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");





const $68193e5cb9044435$var$SMALL_NO_ROUTE__ICON_SIZE = 24;
const $68193e5cb9044435$var$LARGE_NO_ROUTE_ICON_SIZE = 60;
function $68193e5cb9044435$export$75a2bd39da73db46(error, disabledLiquiditySources, toggleAllLiquiditySources, refetchQuote) {
    if (error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED) return {
        alert: {
            type: "warning",
            text: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().genericServerError,
            action: {
                onClick: refetchQuote,
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Retry")
            }
        },
        description: ""
    };
    else if (disabledLiquiditySources.length) return {
        alert: {
            type: "warning",
            text: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().liquiditySourcesError.title,
            action: {
                onClick: ()=>toggleAllLiquiditySources(true),
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Reset")
            }
        },
        description: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().liquiditySourcesError.description
    };
    else if (error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT && error.diagnosisMessage) return {
        alert: {
            type: "error",
            text: error.diagnosisMessage,
            action: null
        },
        description: ""
    };
    return {
        alert: null,
        description: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().noResultError.description
    };
}
var $68193e5cb9044435$export$cd2b5008028e0990;
(function(NoRouteIconSize) {
    NoRouteIconSize[NoRouteIconSize["small"] = $68193e5cb9044435$var$SMALL_NO_ROUTE__ICON_SIZE] = "small";
    NoRouteIconSize[NoRouteIconSize["large"] = $68193e5cb9044435$var$LARGE_NO_ROUTE_ICON_SIZE] = "large";
})($68193e5cb9044435$export$cd2b5008028e0990 || ($68193e5cb9044435$export$cd2b5008028e0990 = {}));
var $68193e5cb9044435$export$b28b3d91533b86c4;
(function(NoRouteTitleSize) {
    NoRouteTitleSize["small"] = "small";
    NoRouteTitleSize["large"] = "medium";
})($68193e5cb9044435$export$b28b3d91533b86c4 || ($68193e5cb9044435$export$b28b3d91533b86c4 = {}));



const $d75fe61dee27fd85$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $d75fe61dee27fd85$export$cfba08fc0e40e2ab = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    variants: {
        size: {
            small: {},
            large: {
                maxWidth: "316px"
            }
        }
    }
});
const $d75fe61dee27fd85$export$a06f1c675e846f6f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    variants: {
        size: {
            small: {
                width: "100%"
            },
            large: {}
        }
    }
});
const $d75fe61dee27fd85$export$705c4f636de3e144 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$6 $0"
});


function $5c40172fd35373c2$export$f1fa434e5dfb6ce5(props) {
    const { fetch: fetch, error: error, size: size = "small" } = props;
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const toggleAllLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().toggleAllLiquiditySources;
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const info = (0, $68193e5cb9044435$export$75a2bd39da73db46)(error, disabledLiquiditySources, ()=>toggleAllLiquiditySources(swappers, true), fetch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d75fe61dee27fd85$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3a3b92139b7892d7$export$2e2bcd8739ae039), {
        size: (0, $68193e5cb9044435$export$cd2b5008028e0990)[size],
        color: "gray"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: (0, $68193e5cb9044435$export$b28b3d91533b86c4)[size]
    }, (0, $f273788a9b293b5f$export$d8bd0967cb58683)().noResultError.title), size === "large" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), !!info.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d75fe61dee27fd85$export$cfba08fc0e40e2ab), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "small",
        align: "center",
        color: "neutral700"
    }, info.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: size === "large" ? "24" : "4"
    }), !!info.alert && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d75fe61dee27fd85$export$a06f1c675e846f6f), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: info.alert.type,
        title: info.alert.text,
        titleAlign: "left",
        action: info.alert.action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            size: "xsmall",
            id: "widget-no-result-alert-btn",
            type: info.alert.type,
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d75fe61dee27fd85$export$705c4f636de3e144), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ccf9750f04b1d14c$export$2e2bcd8739ae039), {
                size: 8
            })),
            onClick: info.alert.action.onClick
        }, info.alert.action.title),
        variant: "alarm"
    })));
}







var $exYeM = parcelRequire("exYeM");







var $exYeM = parcelRequire("exYeM");

const $e4dcb454b65690b2$export$7a76bf180c86084f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%"
});
const $e4dcb454b65690b2$export$f51f4c4ede09e011 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "$5",
    width: "100%"
});
const $e4dcb454b65690b2$export$6d08773d2e66f8f2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    padding: "$5 0",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    "._title": {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $e4dcb454b65690b2$export$e19cd5f9376f8cee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$2",
    alignSelf: "flex-start",
    cursor: "pointer"
});


function $e5ea687236aace88$export$f2c17e09e76cc630(props) {
    const { title: title, value: value, valueColor: valueColor } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e4dcb454b65690b2$export$6d08773d2e66f8f2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "medium",
        variant: "label",
        className: "_title"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "large",
        variant: "label",
        color: valueColor || "foreground"
    }, `${valueColor ? "%" : "$"}${value}`));
}



function $94f8d1db6c30245e$export$f112e0dd94238fef(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm, warning: warning, confirmationDisabled: confirmationDisabled } = props;
    const type = warning.warningLevel === "high" ? "error" : "warning";
    const highValueLossData = [
        {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swapping"),
            value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(warning.inputUsdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061))
        },
        {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Gas cost"),
            value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(warning.totalFee, (0, $189a5d7f52888885$export$2c13d6fe7cdf779a), (0, $189a5d7f52888885$export$d6d8c6e2c799e13f))
        },
        {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Receiving"),
            value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(warning.outputUsdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061))
        },
        {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Price impact"),
            value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(warning.priceImpact, (0, $189a5d7f52888885$export$14448384d530389b), (0, $189a5d7f52888885$export$9ec1967a1af30315)),
            valueColor: `${type}500`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-high-value-loss-warning-modal-confirm-btn",
            type: "primary",
            size: "large",
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), null),
            fullWidth: true,
            disabled: confirmationDisabled,
            onClick: onConfirm
        }, (0, $f273788a9b293b5f$export$d8bd0967cb58683)().highValueLossError.confirmMessage),
        open: open,
        onClose: onClose,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: type,
        title: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().highValueLossError.impactTitle,
        description: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().highValueLossError.description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e4dcb454b65690b2$export$f51f4c4ede09e011), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "title"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e4dcb454b65690b2$export$f51f4c4ede09e011), null, highValueLossData.map((item, index)=>{
        const key = index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e5ea687236aace88$export$f2c17e09e76cc630), {
            key: key,
            ...item
        });
    }))));
}






function $5b190f913ff71d26$export$5b62dcf6d1ce2a0d(warning, error) {
    const alertInfo = {
        alertType: "warning",
        title: "",
        action: null
    };
    if (error) {
        alertInfo.alertType = "error";
        if (error.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).BRIDGE_LIMIT) alertInfo.title = error.recommendation;
        if (error.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE) {
            alertInfo.title = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                id: "You need to increase slippage to at least {minRequiredSlippage} for this route.",
                values: {
                    minRequiredSlippage: error.minRequiredSlippage
                }
            });
            alertInfo.action = "change-settings";
        }
        return alertInfo;
    }
    if (warning) {
        if (warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_VALUE_LOSS) {
            const warningLevel = (0, $aae90cdd39be0d29$export$161668da75c421a0)(warning.priceImpact);
            if (warningLevel === "high") alertInfo.alertType = "error";
            alertInfo.action = "show-info";
            alertInfo.title = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().highValueLossError.title;
        }
        if (warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).UNKNOWN_PRICE) alertInfo.title = (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.title;
        if (warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE) {
            alertInfo.title = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                id: "We recommend you to increase slippage to at least {minRequiredSlippage} for this route.",
                values: {
                    minRequiredSlippage: warning.minRequiredSlippage
                }
            });
            alertInfo.action = "change-settings";
        }
        if (warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_SLIPPAGE) {
            alertInfo.title = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Caution, your slippage is high.");
            alertInfo.action = "change-settings";
        }
        return alertInfo;
    }
    return null;
}






var $exYeM = parcelRequire("exYeM");






function $ecd71aa3088ca4e1$export$273eefa7d9277cda(props) {
    const { customSlippage: customSlippage, slippage: slippage } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { open: open, onClose: onClose, onConfirm: onConfirm, warning: warning, confirmationDisabled: confirmationDisabled } = props;
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const userSlippage = customSlippage ?? slippage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        anchor: "bottom",
        open: open,
        prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            size: "small",
            id: "widget-slippage-warning-modal-change-settings-btn",
            variant: "ghost",
            onClick: ()=>navigate("../" + (0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "label",
            size: "medium",
            color: "$neutral900"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Change settings"))),
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "warning",
        title: warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_SLIPPAGE ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("High slippage") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Low slippage"),
        description: warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_SLIPPAGE ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: " Caution, your slippage is high (={userSlippage}). Your trade may be front run.",
            values: {
                userSlippage: userSlippage
            }
        }) : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "We recommend you to increase slippage to at least {minRequiredSlippage} for this route.",
            values: {
                minRequiredSlippage: warning.minRequiredSlippage
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-slippage-warning-modal-confirm-anyway-btn",
        size: "large",
        type: "primary",
        variant: "contained",
        fullWidth: true,
        disabled: confirmationDisabled,
        onClick: onConfirm
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm anyway"))));
}




var $exYeM = parcelRequire("exYeM");



function $94cbcd81b91a33ba$export$3ee0de577ee845b6(props) {
    const { open: open, onClose: onClose, onConfirm: onConfirm, confirmationDisabled: confirmationDisabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-unknown-price-warning-modal-confirm-btn",
            type: "primary",
            size: "large",
            prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), null),
            fullWidth: true,
            disabled: confirmationDisabled,
            onClick: onConfirm
        }, (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.confirmMessage),
        open: open,
        onClose: onClose,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "warning",
        title: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.impactTitle,
        description: (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.description
    }));
}


function $6dff230125954816$export$39d3931d398915e7(props) {
    const { warning: warning, error: error, couldChangeSettings: couldChangeSettings, showWarningModal: showWarningModal, confirmationDisabled: confirmationDisabled, refetchQuote: refetchQuote, onOpenWarningModal: onOpenWarningModal, onCloseWarningModal: onCloseWarningModal, onConfirmWarningModal: onConfirmWarningModal, onChangeSettings: onChangeSettings } = props;
    const warningModalHandlers = {
        confirmationDisabled: confirmationDisabled,
        open: showWarningModal,
        onClose: onCloseWarningModal,
        onConfirm: onConfirmWarningModal
    };
    const showNoResultMessage = error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT || error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED;
    const alertInfo = (0, $5b190f913ff71d26$export$5b62dcf6d1ce2a0d)(warning, error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).BRIDGE_LIMIT || error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE ? error : null);
    if (alertInfo && !couldChangeSettings) alertInfo.action = null;
    const showAlerts = !!alertInfo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, showNoResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5c40172fd35373c2$export$f1fa434e5dfb6ce5), {
        error: error,
        fetch: refetchQuote
    }), showAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e4dcb454b65690b2$export$7a76bf180c86084f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        title: alertInfo.title,
        type: alertInfo.alertType,
        variant: "alarm",
        ...alertInfo.action === "show-info" && {
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e4dcb454b65690b2$export$e19cd5f9376f8cee), {
                onClick: onOpenWarningModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $be5f47e94ea1c2a7$export$2e2bcd8739ae039), {
                size: 12,
                color: "gray"
            }))
        },
        ...alertInfo.action === "change-settings" && {
            action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
                id: "widget-quote-warning-error-change-settings-btn",
                size: "xxsmall",
                type: alertInfo.alertType,
                onClick: onChangeSettings
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Change"))
        }
    })), warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_VALUE_LOSS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $94f8d1db6c30245e$export$f112e0dd94238fef), {
        ...warningModalHandlers,
        warning: warning
    }), (warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).HIGH_SLIPPAGE || warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ecd71aa3088ca4e1$export$273eefa7d9277cda), {
        ...warningModalHandlers,
        warning: warning
    }), warning.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).UNKNOWN_PRICE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $94cbcd81b91a33ba$export$3ee0de577ee845b6), {
        ...warningModalHandlers,
        warning: warning
    })));
}







var $76r4H = parcelRequire("76r4H");

var $exYeM = parcelRequire("exYeM");



var $76r4H = parcelRequire("76r4H");

var $exYeM = parcelRequire("exYeM");



const $f27f4df4f85c90d2$export$e56e199144073d66 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    "& .position-top__skeleton": {
        paddingTop: "$10"
    }
});
const $f27f4df4f85c90d2$export$ef1fb697b7d6778e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingBottom: "$15",
    variants: {
        dense: {
            true: {
                paddingBottom: 0
            }
        }
    }
});
const $f27f4df4f85c90d2$export$80f958b90643d96a = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex"
});












const $0f59627e0b20bec0$export$feda024f54e6d09b = 300;
const $0f59627e0b20bec0$export$e56e199144073d66 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$be92b6f5f03c0fe9, {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    borderRadius: "$xm",
    variants: {
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral400",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral400",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$secondary200",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary800"
                },
                backgroundColor: "$$color"
            }
        }
    ]
});
const $0f59627e0b20bec0$export$cdf9ff574e7737b9 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    padding: "$10 $15"
});
const $0f59627e0b20bec0$export$746202595cb65037 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
    backgroundColor: "transparent",
    border: "1px solid $secondary550",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        border: "1px solid $secondary"
    },
    transition: "background-color 0.3s ease",
    "&:hover": {
        backgroundColor: "$secondary550",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$secondary"
        },
        ".allRoutesLabel": {
            $$color: "$colors$background",
            [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                $$color: "$colors$foreground"
            },
            color: "$$color",
            transition: "color 0.3s ease"
        }
    }
});
const $0f59627e0b20bec0$export$bd55427d3650a1b0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$xm",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",
    color: "$foreground",
    boxSizing: "border-box",
    position: "relative",
    variants: {
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral200",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                backgroundColor: "$$color"
            }
        },
        basic: {
            true: {
                borderTopRightRadius: "0",
                borderTopLeftRadius: "0"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral200",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral500"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    "& .quote_container": {
                        "& button": {
                            backgroundColor: "$neutral500",
                            [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                                backgroundColor: "$neutral200"
                            }
                        },
                        backgroundColor: "$neutral500",
                        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                            backgroundColor: "$neutral200"
                        }
                    },
                    backgroundColor: "$neutral300",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral400"
                    }
                },
                cursor: "pointer"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: true,
            selected: true,
            css: {
                outline: "1px solid $secondary"
            }
        },
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$secondary100",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary550"
                },
                backgroundColor: "$$color",
                "&:hover": {
                    backgroundColor: "$$color"
                }
            }
        },
        {
            listItem: true,
            selected: false,
            css: {
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "$neutral300",
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        backgroundColor: "$neutral400"
                    }
                }
            }
        }
    ]
});
const $0f59627e0b20bec0$export$536f082bec611ce3 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "100%",
    padding: "$15 $15 $10 $15"
});
const $0f59627e0b20bec0$export$3a26e2864aaf9ab7 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "$10",
    position: "relative"
});
const $0f59627e0b20bec0$export$a3abe124fc948fcd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    ".blockchainImage": {
        marginLeft: "-$8"
    }
});
const $0f59627e0b20bec0$export$9f236c2276094cda = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center",
    ".usd-value": {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $0f59627e0b20bec0$export$41fb9f06171c75f4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)($75d51ac32d862af6$export$41fb9f06171c75f4, {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    height: "$36",
    padding: "$10 $15",
    boxSizing: "border-box",
    cursor: "pointer",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    variants: {
        error: {
            true: {
                [`& ${0, $fb5d3986dd3d8e79$export$3e431a229df88919}`]: {
                    border: "1px $warning500 solid",
                    borderRadius: "100%"
                }
            },
            false: {
                [`& ${0, $fb5d3986dd3d8e79$export$3e431a229df88919}`]: {
                    border: "1px transparent solid",
                    borderRadius: "100%"
                }
            }
        },
        selected: {
            true: {},
            false: {
                $$color: "$colors$neutral400",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            }
        },
        listItem: {
            true: {
                $$color: "$colors$neutral400",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$neutral200"
                },
                backgroundColor: "$$color"
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            listItem: false,
            selected: true,
            css: {
                $$color: "$colors$secondary200",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    $$color: "$colors$secondary800"
                },
                backgroundColor: "$$color"
            }
        }
    ],
    ".blockchains_section": {
        display: "none"
    },
    "@xs": {
        ".blockchains_section": {
            display: "block"
        }
    }
});
const $0f59627e0b20bec0$export$94026ee33dbabc26 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "18px",
    height: "18px",
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1.5px transparent solid",
    img: {
        borderRadius: "100%"
    },
    variants: {
        state: {
            error: {
                borderColor: "$error500"
            },
            warning: {
                borderColor: "$warning500"
            }
        }
    }
});
const $0f59627e0b20bec0$export$7c6e2c02157bb7d2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $3eb85c698767267e$export$aadde00976f34151), {
    width: "100%",
    background: "inherit"
});
const $0f59627e0b20bec0$export$8f314e512d92575f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "$2",
    transition: `all ${$0f59627e0b20bec0$export$feda024f54e6d09b}ms ease`,
    variants: {
        orientation: {
            down: {
                transform: "rotate(0)"
            },
            up: {
                transform: "rotate(180deg)"
            }
        }
    }
});
const $0f59627e0b20bec0$export$1ff3c3f08ae963c0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "$12",
    marginLeft: "$10",
    marginRight: "$10",
    borderLeft: "1px solid $foreground"
});
const $0f59627e0b20bec0$export$a035dcf9055239cd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    margin: "0 $15",
    borderTop: "1px solid",
    $$color: "$colors$neutral300",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral400"
    },
    borderColor: "$$color"
});
const $0f59627e0b20bec0$export$bbfc12447ec5dbe8 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "$16",
    height: "$16",
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
});
const $0f59627e0b20bec0$export$762370ecb7bb9034 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    overflow: "hidden",
    textOverflow: "ellipsis",
    letterSpacing: 0.4
});
const $0f59627e0b20bec0$export$9377ac6cfc6a88da = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexWrap: "wrap"
});
const $0f59627e0b20bec0$export$93a4b59f35673217 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "18px",
    height: "18px",
    borderRadius: "100%",
    backgroundColor: "$background",
    cursor: "default",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1.5px transparent solid",
    variants: {
        state: {
            error: {
                borderColor: "$error500"
            },
            warning: {
                borderColor: "$warning500"
            }
        }
    }
});
const $0f59627e0b20bec0$export$af3b7d3c8d59acc5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $0f59627e0b20bec0$export$17d680238e50603e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "$neutral",
    margin: "$5 0",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        borderTopColor: "$neutral800"
    }
});





var $exYeM = parcelRequire("exYeM");









const $9c1cc360123f228e$export$d8514b71775652ea = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$5 0",
    "&.total_payable_fee": {
        padding: "$12 0"
    }
});
const $9c1cc360123f228e$export$17d680238e50603e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    borderTop: "1px solid $neutral300",
    margin: "$10 0"
});
const $9c1cc360123f228e$export$c9554889b3e706cd = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$20 0",
    display: "flex",
    flexDirection: "column",
    "& .collapsible_trigger": {
        display: "flex",
        alignItems: "center"
    }
});
const $9c1cc360123f228e$export$f50a68e3694789ee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$20 $20 $10",
    textAlign: "center",
    position: "relative",
    "._icon-button": {
        position: "absolute",
        zIndex: 10,
        top: "$16",
        right: "$16"
    }
});
const $9c1cc360123f228e$export$e614dc9140f7ae71 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "$5",
    "&:hover": {
        "& ._typography, & svg": {
            color: "$secondary"
        }
    }
});


const $73fa99e8a8978543$var$NonPayableFee = (props)=>{
    return !props.fee.isZero() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$d8514b71775652ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "neutral600"
    }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, "$", (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(props.fee, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)))) : null;
};
function $73fa99e8a8978543$export$6cd8467b6b9d3fde(props) {
    const [open, setOpen] = (0, $exYeM.useState)(false);
    const [openCollapse, setOpenCollapse] = (0, $exYeM.useState)(false);
    const { steps: steps, quote: quote, fee: fee, time: time, feeWarning: feeWarning, showModalFee: showModalFee } = props;
    const swaps = quote?.swaps ?? [];
    const container = (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
    const feesGroup = (0, $8e9d7744e1038276$export$583f50d85ee7d7be)(swaps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d1d7703f2e2f8b84$export$9f6f00ee434c7351), {
        onClickFee: showModalFee ? (e)=>{
            e.stopPropagation();
            setOpen(!open);
        } : undefined,
        fee: fee,
        feeWarning: feeWarning,
        time: time,
        steps: steps,
        tooltipGas: showModalFee ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("View more info") : undefined,
        tooltipContainer: container
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        container: container,
        open: open,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$f50a68e3694789ee), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "medium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Gas & Fee Explanation")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            id: "widget-quote-cost-details-modal-close-icon-btn",
            onClick: ()=>setOpen(false),
            variant: "ghost"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8192be46f8fafa5a$export$2e2bcd8739ae039), {
            color: "gray",
            size: 14
        }))),
        onClose: ()=>{
            setOpen(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$c9554889b3e706cd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Details")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), Object.entries(feesGroup.payable).flatMap(([payableFeesKey, feeArray])=>feeArray.map((fee, index)=>{
            const key = `payable-fee-${index}`;
            const usdValue = (0, $8e9d7744e1038276$export$3d75576154c088e3)(fee);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$d8514b71775652ea), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                color: "neutral600"
            }, (0, $0cffb0cab258d6b7$export$ddd0c2fa7802cfaa)(payableFeesKey, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bf240020059341c1$export$2e47cedab3b3b640), {
                content: fee.amount,
                container: container
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium"
            }, (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(fee.amount, (0, $189a5d7f52888885$export$2c13d6fe7cdf779a), (0, $189a5d7f52888885$export$d6d8c6e2c799e13f)), " ", fee.asset.symbol, " ($", (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(usdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)), ")")));
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$d8514b71775652ea), {
        className: "total_payable_fee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Total Payable Fee")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium"
    }, "$", (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(fee, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$17d680238e50603e), null), Object.keys(feesGroup.nonePayable).length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $89c4abf263bb57c4$export$810d59a3bedb5238), {
        triggerAnchor: "bottom",
        onClickTrigger: ()=>setOpenCollapse((prev)=>!prev),
        trigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            className: (0, $9c1cc360123f228e$export$e614dc9140f7ae71)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "small",
            variant: "body",
            color: "neutral700"
        }, openCollapse ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Hide non-payable fees") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Show non-payable fees")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 4,
            direction: "horizontal"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eb85c698767267e$export$f5cb197ef241297f), {
            orientation: openCollapse ? "up" : "down"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
            size: 12,
            color: "gray"
        }))),
        open: openCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "title"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Description")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "body",
        color: "neutral700"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(`The following fees are considered in the transaction output and
                you won\u{2019}t need to pay extra gas for them.`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), Object.entries(feesGroup.nonePayable).map(([nonPayableFeesKey, fees], index)=>{
        const totalFeeInUsd = (0, $8e9d7744e1038276$export$b40dda5a0de0bf83)(fees);
        const label = (0, $0cffb0cab258d6b7$export$ddd0c2fa7802cfaa)(nonPayableFeesKey, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t);
        const key = `non-payable-fee-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($73fa99e8a8978543$var$NonPayableFee, {
            key: key,
            fee: totalFeeInUsd,
            label: label
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c1cc360123f228e$export$17d680238e50603e), null)))));
}





var $exYeM = parcelRequire("exYeM");


const $1e3c17599e9baf56$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $1e3c17599e9baf56$export$39b9f83b35c7456d = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    height: "14px",
    marginLeft: "14px",
    position: "absolute",
    borderLeft: "1px solid $foreground",
    top: "42%"
});


function $43e9a31a1f3ab960$export$e3e8fd41e398c095(props) {
    const { from: from, to: to, percentageChange: percentageChange, warningLevel: warningLevel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1e3c17599e9baf56$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $66a5c1820d80e5ba$export$b642c5d9b327de62), {
        direction: "horizontal",
        label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap input"),
        type: "input",
        tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        price: {
            value: from.price.value,
            usdValue: from.price.usdValue,
            realValue: from.price.realValue,
            realUsdValue: from.price.realUsdValue
        },
        token: {
            displayName: from.token.displayName,
            image: from.token.image
        },
        chain: {
            image: from.chain.image
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $1e3c17599e9baf56$export$39b9f83b35c7456d)()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $66a5c1820d80e5ba$export$b642c5d9b327de62), {
        direction: "horizontal",
        tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Estimated output"),
        type: "output",
        price: {
            value: to.price.value,
            usdValue: to.price.usdValue,
            realValue: to.price.realValue,
            realUsdValue: to.price.realUsdValue
        },
        token: {
            displayName: to.token.displayName,
            image: to.token.image
        },
        chain: {
            image: to.chain.image
        },
        percentageChange: percentageChange,
        warningLevel: warningLevel
    }));
}





var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/*
 * mobile: screen <= 480
 * tablet: screen > 480 and screen <= 768
 * notebook: screen > 768 & screen <= 1024
 * large: screen > 1024 & screen <= 1200
 * extra large: screen > 1200
 */ const $556a63bab2f130c0$var$MIN_TABLET_WIDTH = 480;
const $556a63bab2f130c0$var$MIN_NOTEBOOK_WIDTH = 768;
const $556a63bab2f130c0$var$MIN_LARGE_SCREEN_WIDTH = 1024;
const $556a63bab2f130c0$var$MIN_EXTRA_LARGE_SCREEN_WIDTH = 1200;
const $556a63bab2f130c0$var$useScreenDetect = ()=>{
    const [isMobile, setIsMobile] = (0, $exYeM.useState)(false);
    const [isTablet, setIsTablet] = (0, $exYeM.useState)(false);
    const [isNotebook, setIsNotebook] = (0, $exYeM.useState)(false);
    const [isLargeScreen, setIsLargeScreen] = (0, $exYeM.useState)(false);
    const [isExtraLargeScreen, setIsExtraLargeScreen] = (0, $exYeM.useState)(false);
    const handleResize = ()=>{
        setIsMobile(window.innerWidth <= $556a63bab2f130c0$var$MIN_TABLET_WIDTH);
        setIsTablet(window.innerWidth > $556a63bab2f130c0$var$MIN_TABLET_WIDTH && window.innerWidth <= $556a63bab2f130c0$var$MIN_NOTEBOOK_WIDTH);
        setIsNotebook(window.innerWidth > $556a63bab2f130c0$var$MIN_NOTEBOOK_WIDTH && window.innerWidth <= $556a63bab2f130c0$var$MIN_LARGE_SCREEN_WIDTH);
        setIsLargeScreen(window.innerWidth > $556a63bab2f130c0$var$MIN_LARGE_SCREEN_WIDTH && window.innerWidth <= $556a63bab2f130c0$var$MIN_EXTRA_LARGE_SCREEN_WIDTH);
        setIsExtraLargeScreen(window.innerWidth > $556a63bab2f130c0$var$MIN_EXTRA_LARGE_SCREEN_WIDTH);
    };
    (0, $exYeM.useLayoutEffect)(()=>{
        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return {
        isMobile: isMobile,
        isTablet: isTablet,
        isNotebook: isNotebook,
        isLargeScreen: isLargeScreen,
        isExtraLargeScreen: isExtraLargeScreen
    };
};
var $556a63bab2f130c0$export$2e2bcd8739ae039 = $556a63bab2f130c0$var$useScreenDetect;





const $6475edaa189dafbf$var$MAX_STEPS = 4;
const $6475edaa189dafbf$var$MAX_BLOCKCHAINS = 6;
const $6475edaa189dafbf$var$ImageComponent = (props)=>{
    const { content: content, src: src, className: className, open: open, state: state, container: container } = props;
    const tooltipContainer = container || (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: tooltipContainer,
        side: "bottom",
        sideOffset: 4,
        open: open,
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$94026ee33dbabc26), {
        className: className,
        state: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
        src: src,
        size: 16
    })));
};
function $6475edaa189dafbf$export$6ec9a7d85fda7775(props) {
    const { quoteRef: quoteRef, selected: selected, setExpanded: setExpanded, steps: steps, expanded: expanded, type: type, container: container } = props;
    const tooltipContainer = container || (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
    const numberOfSteps = steps.length;
    const blockchains = (0, $aae90cdd39be0d29$export$d676cb553c1d42b2)(steps);
    const { isTablet: isTablet, isMobile: isMobile } = (0, $556a63bab2f130c0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$41fb9f06171c75f4), {
        listItem: type === "list-item",
        ref: (ref)=>quoteRef.current = ref,
        selected: selected,
        onClick: (e)=>{
            e.stopPropagation();
            setExpanded((prevState)=>!prevState);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Via:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), steps.map((step, index)=>{
        const key = `item-${index}`;
        const arrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$8f314e512d92575f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
            size: 12,
            color: "black"
        }));
        return isMobile || isTablet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6475edaa189dafbf$var$ImageComponent, {
            content: step.swapper.displayName,
            src: step.swapper.image,
            state: step.state,
            container: container
        }), index !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, arrow)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: key
        }, numberOfSteps <= $6475edaa189dafbf$var$MAX_STEPS || numberOfSteps > $6475edaa189dafbf$var$MAX_STEPS && index < $6475edaa189dafbf$var$MAX_STEPS - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6475edaa189dafbf$var$ImageComponent, {
            content: step.swapper.displayName,
            src: step.swapper.image,
            state: step.state,
            container: container
        }), index !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, arrow)) : index === $6475edaa189dafbf$var$MAX_STEPS - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            align: "end",
            sideOffset: 4,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
                className: (0, $0f59627e0b20bec0$export$a3abe124fc948fcd)()
            }, arrow, steps.map((step, i)=>{
                const key = `image-${i}`;
                return i >= index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
                    key: key
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6475edaa189dafbf$var$ImageComponent, {
                    content: step.swapper.displayName,
                    src: step.swapper.image,
                    state: step.state,
                    open: false
                }), i !== numberOfSteps - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, arrow));
            }))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$93a4b59f35673217), {
            state: steps.find((step, i)=>i >= index && (step.state === "error" || step.state === "warning"))?.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, "+", numberOfSteps - index))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "blockchains_section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Chains:")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), blockchains.map((blockchain, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: blockchain.displayName
        }, blockchains.length <= $6475edaa189dafbf$var$MAX_BLOCKCHAINS || blockchains.length > $6475edaa189dafbf$var$MAX_BLOCKCHAINS && index < $6475edaa189dafbf$var$MAX_BLOCKCHAINS - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            content: blockchain.displayName,
            sideOffset: 4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6475edaa189dafbf$var$ImageComponent, {
            content: "",
            src: blockchain.image,
            open: false,
            className: index !== 0 ? "blockchainImage" : ""
        })) : index === $6475edaa189dafbf$var$MAX_BLOCKCHAINS - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
            container: tooltipContainer,
            side: "bottom",
            align: "end",
            sideOffset: 4,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
                className: (0, $0f59627e0b20bec0$export$a3abe124fc948fcd)()
            }, blockchains.map((chain, i)=>i >= index && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6475edaa189dafbf$var$ImageComponent, {
                    key: chain.displayName,
                    content: "",
                    src: chain.image,
                    open: false,
                    className: i > index ? "blockchainImage" : "",
                    container: container
                })))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$93a4b59f35673217), {
            className: "blockchainImage"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, "+", blockchains.length - index))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 32
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$8f314e512d92575f), {
        orientation: expanded ? "up" : "down"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
        size: 12,
        color: "black"
    }))));
}


function $bac80fa0ebc36661$export$82b8d343c504672(props) {
    const { quote: quote, input: input, output: output, error: error, warning: warning, type: type, selected: selected = false, tagHidden: tagHidden = true, showModalFee: showModalFee = true, onClickAllRoutes: onClickAllRoutes, fullExpandedMode: fullExpandedMode = false, container: propContainer } = props;
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const { customSlippage: customSlippage, slippage: slippage } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const userSlippage = customSlippage || slippage;
    const [expanded, setExpanded] = (0, $exYeM.useState)(props.expanded);
    const quoteRef = (0, $exYeM.useRef)(null);
    const roundedInput = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(input.value, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f));
    const roundedOutput = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(output.value, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f));
    const roundedOutputUsdValue = output.usdValue ? (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(output.usdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)) : "";
    const priceImpact = (0, $aae90cdd39be0d29$export$3cad4d44dd01c178)(input.usdValue, output.usdValue ?? null);
    const percentageChange = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(priceImpact, (0, $189a5d7f52888885$export$14448384d530389b), (0, $189a5d7f52888885$export$9ec1967a1af30315));
    const priceImpactWarningLevel = (0, $aae90cdd39be0d29$export$161668da75c421a0)(priceImpact ?? 0);
    const getQuoteSteps = (swaps, internalSwap)=>{
        return swaps.map((swap, index)=>{
            let stepState = undefined;
            const hasBridgeLimitError = error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).BRIDGE_LIMIT && error.swap.swapperId === swap.swapperId;
            const hasSlippageError = error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE && error.recommendedSlippages?.has(index);
            const hasSlippageWarning = warning?.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE && warning.recommendedSlippages?.has(index);
            const stepHasError = hasBridgeLimitError || hasSlippageError;
            const stepHasWarning = hasSlippageWarning;
            if (stepHasError) stepState = "error";
            else if (stepHasWarning) stepState = "warning";
            let alertTitle = stepHasError ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Slippage Error") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Slippage Warning");
            if (hasBridgeLimitError) alertTitle = (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Bridge Limit Error");
            return {
                swapper: {
                    displayName: (0, $76ee130e8dc1847d$export$1fea59066bd06abd)(swap.swapperId, swappers) ?? "",
                    image: swap.swapperLogo
                },
                from: {
                    token: {
                        displayName: swap.from.symbol,
                        image: swap.from.logo
                    },
                    chain: {
                        displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(swap.from.blockchain, blockchains) ?? "",
                        image: swap.from.blockchainLogo
                    },
                    price: {
                        value: index === 0 && !internalSwap ? (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(input.value, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)) : (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(swap.fromAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                        usdValue: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((swap.from.usdPrice ?? 0) * parseFloat(swap.fromAmount), (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)),
                        realValue: index === 0 ? input.value : swap.fromAmount,
                        realUsdValue: new (0, $76r4H.default)(swap.from.usdPrice ?? 0).multipliedBy(swap.fromAmount).toString()
                    }
                },
                to: {
                    token: {
                        displayName: swap.to.symbol,
                        image: swap.to.logo
                    },
                    chain: {
                        displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(swap.to.blockchain, blockchains) || "",
                        image: swap.to.blockchainLogo
                    },
                    price: {
                        value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(swap.toAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                        usdValue: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((swap.to.usdPrice ?? 0) * parseFloat(swap.toAmount), (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)),
                        realValue: swap.toAmount,
                        realUsdValue: new (0, $76r4H.default)(swap.to.usdPrice ?? 0).multipliedBy(swap.toAmount).toString()
                    }
                },
                state: stepState,
                alerts: stepHasError || stepHasWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f27f4df4f85c90d2$export$ef1fb697b7d6778e), {
                    dense: fullExpandedMode
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
                    variant: "alarm",
                    type: stepHasError ? "error" : "warning",
                    title: alertTitle,
                    footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f27f4df4f85c90d2$export$80f958b90643d96a), null, hasBridgeLimitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, error.fromAmountRangeError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "vertical",
                        size: 2
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                        id: "Yours: {amount} {symbol}",
                        values: {
                            amount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(swap.fromAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                            symbol: swap?.from.symbol
                        }
                    }))), (hasSlippageError || hasSlippageWarning) && !hasBridgeLimitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                        id: "Minimum required slippage: {minRequiredSlippage}",
                        values: {
                            ...error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE && {
                                minRequiredSlippage: error.recommendedSlippages?.get(index)
                            },
                            ...warning?.type === (0, $bad1ce08d7bdae0b$export$e1e7a505a413c460).INSUFFICIENT_SLIPPAGE && {
                                minRequiredSlippage: warning.recommendedSlippages?.get(index)
                            }
                        }
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "vertical",
                        size: 2
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        size: "xsmall",
                        variant: "body",
                        color: "neutral900"
                    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
                        id: "Yours: {userSlippage}",
                        values: {
                            userSlippage: userSlippage
                        }
                    }))))
                })) : undefined,
                time: (0, $63fc48ac3256c035$export$448e1c9b3b4c9054)(swap.estimatedTimeInSeconds),
                fee: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((0, $8e9d7744e1038276$export$acbec34e083696b5)(swap, findToken), (0, $189a5d7f52888885$export$2c13d6fe7cdf779a), (0, $189a5d7f52888885$export$d6d8c6e2c799e13f)),
                internalSwaps: swap.internalSwaps ? getQuoteSteps(swap.internalSwaps) : undefined
            };
        });
    };
    const steps = getQuoteSteps(quote?.swaps ?? []);
    const numberOfSteps = steps.length;
    const container = propContainer || (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
    const sortedQuoteTags = (0, $aae90cdd39be0d29$export$3f24c42f0d58efd8)(props.quote.tags || []);
    const showAllRoutesButton = !!onClickAllRoutes;
    const totalTime = (0, $63fc48ac3256c035$export$448e1c9b3b4c9054)((0, $63fc48ac3256c035$export$b325637b88286521)(quote?.swaps));
    const totalFee = (0, $8e9d7744e1038276$export$684cb4cc81f91db3)(quote?.swaps ?? [], findToken);
    const fee = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(totalFee, (0, $189a5d7f52888885$export$2c13d6fe7cdf779a), (0, $189a5d7f52888885$export$d6d8c6e2c799e13f));
    const feeWarning = totalFee.gte(new (0, $76r4H.default)((0, $0cffb0cab258d6b7$export$637a7e4c3f8581d5)));
    return fullExpandedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5da5afbb006dfcd7$export$68c79565df9aee60), {
        selected: selected,
        fee: fee,
        time: totalTime,
        tooltipContainer: (0, $7c74207847ca6a20$export$536dc91e674be53)(),
        steps: steps,
        tags: sortedQuoteTags,
        feeWarning: feeWarning,
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel,
        outputPrice: {
            value: roundedOutput,
            usdValue: roundedOutputUsdValue,
            realValue: output.value,
            realUsdValue: output.usdValue
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$bd55427d3650a1b0), {
        selected: selected,
        listItem: type === "list-item",
        basic: type === "basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$536f082bec611ce3)()
    }, !tagHidden && sortedQuoteTags.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$af3b7d3c8d59acc5), null, sortedQuoteTags.map((tag, index)=>{
        const key = `${tag.value}_${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $e2b30e6c1e3602cc$export$349442539731427c), {
            label: tag.label,
            value: tag.value
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 4,
            direction: "horizontal"
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$17d680238e50603e), null), !showAllRoutesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        id: "portal-root",
        className: (0, $0f59627e0b20bec0$export$3a26e2864aaf9ab7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $73fa99e8a8978543$export$6cd8467b6b9d3fde), {
        quote: quote,
        time: totalTime,
        fee: fee,
        feeWarning: feeWarning,
        showModalFee: showModalFee,
        steps: numberOfSteps
    }), showAllRoutesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$746202595cb65037), {
        onClick: (e)=>{
            e.stopPropagation();
            onClickAllRoutes();
        },
        size: "xxsmall",
        type: "secondary",
        variant: "default",
        css: {
            paddingLeft: "$10",
            paddingRight: "$10",
            paddingTop: "$5",
            paddingBottom: "$5"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        color: "secondary",
        variant: "body",
        size: "xsmall",
        className: "allRoutesLabel"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("See All Routes")))), type === "basic" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$9f236c2276094cda)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$bbfc12447ec5dbe8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $be5f47e94ea1c2a7$export$2e2bcd8739ae039), {
        size: 12,
        color: "gray"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$9377ac6cfc6a88da), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$762370ecb7bb9034), {
        size: "small",
        variant: "body"
    }, `${roundedInput} ${steps[0].from.token.displayName} = `), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bf240020059341c1$export$2e47cedab3b3b640), {
        content: output.value,
        container: container,
        open: !output.value ? false : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$762370ecb7bb9034), {
        size: "small",
        variant: "body"
    }, "\xa0", `${roundedOutput} ${steps[steps.length - 1].to.token.displayName}`))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bf240020059341c1$export$2e47cedab3b3b640), {
        content: output.usdValue,
        container: container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 2,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        color: "$neutral600",
        size: "xsmall",
        variant: "body"
    }, `($${roundedOutputUsdValue})`))), type === "list-item" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $66a5c1820d80e5ba$export$b642c5d9b327de62), {
        tooltipContainer: container,
        type: "output",
        direction: "vertical",
        price: {
            value: roundedOutput,
            usdValue: roundedOutputUsdValue,
            realValue: output.value,
            realUsdValue: output.usdValue
        },
        token: {
            displayName: steps[numberOfSteps - 1].to.token.displayName,
            image: steps[numberOfSteps - 1].to.token.image
        },
        chain: {
            image: steps[numberOfSteps - 1].to.chain.image
        },
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel
    }), type === "swap-preview" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $43e9a31a1f3ab960$export$e3e8fd41e398c095), {
        from: steps[0].from,
        to: steps[numberOfSteps - 1].to,
        percentageChange: percentageChange,
        warningLevel: priceImpactWarningLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$e56e199144073d66), {
        selected: selected,
        listItem: type === "list-item",
        open: expanded,
        className: "quote_container",
        onOpenChange: setExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6475edaa189dafbf$export$6ec9a7d85fda7775), {
        type: type,
        quoteRef: quoteRef,
        selected: selected,
        setExpanded: setExpanded,
        container: container,
        expanded: expanded,
        steps: steps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$7c6e2c02157bb7d2), {
        open: expanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$a035dcf9055239cd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0f59627e0b20bec0$export$cdf9ff574e7737b9)()
    }, steps.map((step, index)=>{
        const key = `item-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c6be03ec54b75f1$export$bb03d422d1792782), {
            type: "quote-details",
            key: key,
            tooltipContainer: container,
            step: step,
            hasSeparator: index !== steps.length - 1,
            state: step.state
        });
    })))));
}







var $exYeM = parcelRequire("exYeM");

const $dc191cb7eff57ca2$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    $$color: "$colors$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral300"
    },
    backgroundColor: "$$color",
    borderBottomLeftRadius: "$xm",
    borderBottomRightRadius: "$xm",
    padding: "$15",
    variants: {
        rounded: {
            true: {
                borderRadius: "$xm"
            }
        },
        expanded: {
            true: {
                paddingBottom: "3px"
            },
            false: {
                paddingBottom: "$12"
            }
        }
    }
});
const $dc191cb7eff57ca2$export$c3f32f9b7c2f46bb = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingTop: "$2"
});
const $dc191cb7eff57ca2$export$fb587a27d5a722e7 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$8"
});
const $dc191cb7eff57ca2$export$1beef6af864ce77e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderLeft: "1px dashed $foreground",
    minHeight: " 0",
    margin: "0px 11.5px",
    alignSelf: "stretch",
    variants: {
        hideSeparator: {
            true: {
                minHeight: "unset",
                height: "0"
            }
        }
    }
});




var $exYeM = parcelRequire("exYeM");


const $025b5b97cdc10623$export$d77e6273750b9257 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex"
});
const $025b5b97cdc10623$export$718bd1248265bbef = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$10 $0 $20"
});
const $025b5b97cdc10623$export$670ff8da74c69da1 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "14px $0 $20 $0",
    display: "flex",
    flexDirection: "column"
});
const $025b5b97cdc10623$export$77e628a79a4c5f21 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $025b5b97cdc10623$export$e3e8fd41e398c095 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end"
});
const $025b5b97cdc10623$export$c3c1788b44d063d6 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "$24",
    marginLeft: "13px",
    borderLeft: "1px solid $neutral700"
});
const $025b5b97cdc10623$export$b642c5d9b327de62 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "65%",
    display: "flex",
    justifyContent: "start"
});
const $025b5b97cdc10623$export$9c61e4a585a15846 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    flexGrow: 1,
    maxWidth: "148px"
});
const $025b5b97cdc10623$export$970b12555e5b429c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$15 $0 $15 $0"
});
const $025b5b97cdc10623$export$be24b091af3609e7 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});


function $ceaf65f2f049df7a$export$a675a97e32cdba21(props) {
    const { type: type, tagHidden: tagHidden = true } = props;
    const quotePreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$e3e8fd41e398c095), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$b642c5d9b327de62), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
        loading: true,
        size: "medium",
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 8,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$9c61e4a585a15846), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 10,
        width: 60,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 15,
        variant: "rounded"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 12,
        width: 64,
        variant: "rounded"
    }));
    const showAllRoutesSkeleton = type === "basic" && !tagHidden;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, !tagHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$d77e6273750b9257), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 65,
        height: 20,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0f59627e0b20bec0$export$17d680238e50603e), null), !showAllRoutesSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $025b5b97cdc10623$export$be24b091af3609e7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$d77e6273750b9257), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), showAllRoutesSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 85,
        height: 24,
        variant: "rounded"
    })), type === "basic" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$718bd1248265bbef), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 148,
        variant: "rounded"
    })), type === "list-item" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$670ff8da74c69da1), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$77e628a79a4c5f21), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
        loading: true,
        size: "medium",
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 150,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 10,
        width: 184,
        variant: "rounded"
    })), type === "swap-preview" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$970b12555e5b429c), null, quotePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $025b5b97cdc10623$export$c3c1788b44d063d6), null), quotePreview), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    })));
}




var $exYeM = parcelRequire("exYeM");


const $75b70dc7a3f8eb8e$export$2aebd25fada42a64 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "start"
});
const $75b70dc7a3f8eb8e$export$60f29b3ba9352a67 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    flexGrow: 1,
    paddingTop: "$5",
    paddingBottom: "$10",
    display: "flex",
    alignItems: "center",
    variants: {
        extraSpace: {
            true: {
                paddingBottom: "$40"
            }
        }
    }
});
const $75b70dc7a3f8eb8e$export$caf3cad5ecf7ecdf = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    flexGrow: 1
});
const $75b70dc7a3f8eb8e$export$47a8e0cde9116a8f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    margin: "$0 $2",
    padding: "$4",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $75b70dc7a3f8eb8e$export$2adea9ff51460424 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});


function $7078bbec44c00800$export$93cb3e391e45e2dc(props) {
    const { separator: separator = true } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$2adea9ff51460424), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 22,
        width: 22,
        variant: "circular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 15,
        width: 148,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$2aebd25fada42a64), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc191cb7eff57ca2$export$1beef6af864ce77e), {
        hideSeparator: !separator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$60f29b3ba9352a67), {
        extraSpace: separator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$caf3cad5ecf7ecdf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
        size: "small",
        loading: true,
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 12,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$47a8e0cde9116a8f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $68b8157e90e31e9e$export$2e2bcd8739ae039), {
        color: "gray",
        size: 16
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75b70dc7a3f8eb8e$export$caf3cad5ecf7ecdf), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a0e1b354b0ac8fb0$export$89626202435b26ac), {
        size: "small",
        loading: true,
        chainImage: "",
        tokenImage: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 12,
        variant: "rounded"
    })))));
}


function $c289027c32d9400a$export$45d002177aaaee04(props) {
    const { type: type, expanded: expanded, tagHidden: tagHidden = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc191cb7eff57ca2$export$42a852a2b6b56249), {
        expanded: expanded,
        rounded: type !== "basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ceaf65f2f049df7a$export$a675a97e32cdba21), {
        type: type,
        tagHidden: tagHidden
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc191cb7eff57ca2$export$c3f32f9b7c2f46bb), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 15,
        variant: "rounded"
    })), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc191cb7eff57ca2$export$fb587a27d5a722e7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 24
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), {
        separator: false
    })));
}











function $ac503755ed522b68$export$44189e4b18fc4b2c(props) {
    const { quote: quote, type: type, loading: loading, error: error, warning: warning, expanded: expanded = false, tagHidden: tagHidden, onClick: onClick, showModalFee: showModalFee, selected: selected, onClickAllRoutes: onClickAllRoutes, fullExpandedMode: fullExpandedMode = false, container: container } = props;
    const { inputAmount: inputAmount, inputUsdValue: inputUsdValue, toToken: toToken } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const outputAmount = !!quote?.outputAmount ? new (0, $76r4H.default)(quote?.outputAmount) : null;
    const outputUsdValue = !!quote?.outputAmount ? (0, $8e9d7744e1038276$export$6f59f9bb345c1d58)(quote?.outputAmount, (0, $aae90cdd39be0d29$export$63bd4576f33d0cb4)(quote) || toToken?.usdPrice) : null;
    const noResult = error && (error.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT || error.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED);
    const showQuote = !noResult && quote && !loading;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f27f4df4f85c90d2$export$e56e199144073d66), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c289027c32d9400a$export$45d002177aaaee04), {
        tagHidden: tagHidden,
        type: type,
        expanded: expanded
    }));
    return showQuote ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f27f4df4f85c90d2$export$e56e199144073d66), {
        onClick: ()=>onClick?.(quote)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bac80fa0ebc36661$export$82b8d343c504672), {
        quote: quote,
        error: error,
        container: container,
        showModalFee: showModalFee,
        warning: warning,
        tagHidden: tagHidden,
        selected: selected,
        type: type,
        expanded: expanded,
        onClickAllRoutes: onClickAllRoutes,
        fullExpandedMode: fullExpandedMode,
        input: {
            value: inputAmount,
            usdValue: inputUsdValue?.toString() ?? ""
        },
        output: {
            value: outputAmount?.toString() ?? "",
            usdValue: outputUsdValue?.toString() ?? ""
        }
    })) : null;
}






var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");
const $4b55915d4f70e238$var$RETRY_DELAY = 2000;
function $4b55915d4f70e238$export$d852f5f778460fa4({ request: request }) {
    const [loading, setLoading] = (0, $exYeM.useState)(false);
    const abortController = (0, $exYeM.useRef)(null);
    const cancelFetch = ()=>abortController.current?.abort();
    const retryFetch = async (requestBody)=>{
        await new Promise((resolve)=>setTimeout(resolve, $4b55915d4f70e238$var$RETRY_DELAY));
        return await fetch(requestBody, false);
    };
    const fetch = async (requestBody, retryOnFail = false)=>{
        cancelFetch();
        abortController.current = new AbortController();
        setLoading(true);
        try {
            const res = await request(requestBody, {
                signal: abortController.current.signal
            });
            abortController.current = null;
            return res;
        // eslint-disable-next-line no-useless-catch
        } catch (error) {
            if (retryOnFail) return await retryFetch(requestBody);
            throw error;
        } finally{
            setLoading(false);
        }
    };
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}


function $04cfddbb0c5ae481$export$1e5bf4cdba320952() {
    const { fetch: fetch, loading: loading, cancelFetch: cancelFetch } = (0, $4b55915d4f70e238$export$d852f5f778460fa4)({
        request: async (requestBody, options)=>await (0, $8a4b1db626d4e3d9$export$c1b2b945bea31d71)().confirmRoute(requestBody, options)
    });
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}







function $f6bd121b28fc649c$export$2b02bead412ce535(response) {
    if (!response.swaps) throw new Error((0, $f273788a9b293b5f$export$d8bd0967cb58683)().noResultError.title, {
        cause: {
            type: (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT,
            diagnosisMessage: response.diagnosisMessages?.[0]
        }
    });
    const quoteError = $f6bd121b28fc649c$export$978cd6d704db6274(response.swaps);
    if (quoteError) throw new Error(quoteError.message, {
        cause: quoteError.options
    });
}
function $f6bd121b28fc649c$export$978cd6d704db6274(swaps) {
    const limitError = (0, $8e9d7744e1038276$export$78e0ca21c1421c3a)(swaps);
    if (limitError) {
        const { swap: swap, recommendation: recommendation, fromAmountRangeError: fromAmountRangeError } = (0, $8e9d7744e1038276$export$5b3c7e829f29cdf0)(swaps);
        return {
            message: "bridge limit error",
            options: {
                type: (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).BRIDGE_LIMIT,
                swap: swap,
                recommendation: recommendation,
                fromAmountRangeError: fromAmountRangeError
            }
        };
    }
    const recommendedSlippages = (0, $8e9d7744e1038276$export$a39b04dc395724b3)(swaps);
    if (recommendedSlippages) {
        const minRequiredSlippage = (0, $8e9d7744e1038276$export$20a61b45ab42ee9c)(swaps);
        return {
            message: "",
            options: {
                type: (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).INSUFFICIENT_SLIPPAGE,
                recommendedSlippages: recommendedSlippages,
                minRequiredSlippage: minRequiredSlippage
            }
        };
    }
    return null;
}
function $f6bd121b28fc649c$export$d3ef6183a73480ba(previousQuote, currentQuote, params) {
    let quoteChanged = false;
    if (previousQuote) quoteChanged = (0, $aae90cdd39be0d29$export$9bf882d220c3db75)(previousQuote, currentQuote);
    const output = {
        quote: null,
        quoteUpdate: null,
        balance: null
    };
    const quoteWarning = (0, $aae90cdd39be0d29$export$a0c8f8d7b1849c8c)(currentQuote, {
        fromToken: params.fromToken,
        toToken: params.toToken,
        findToken: params.findToken,
        userSlippage: params.userSlippage
    });
    if (quoteWarning) output.quote = quoteWarning;
    if (previousQuote && quoteChanged) {
        if ((0, $8e9d7744e1038276$export$a3d345d6bfa24457)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_AND_OUTPUT_AMOUNT_UPDATED,
            newOutputAmount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((0, $8e9d7744e1038276$export$c255fe40da530e79)(currentQuote)),
            percentageChange: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((0, $aae90cdd39be0d29$export$3cad4d44dd01c178)((0, $8e9d7744e1038276$export$c255fe40da530e79)(previousQuote) ?? "", (0, $8e9d7744e1038276$export$c255fe40da530e79)(currentQuote) ?? ""), null, 2)
        };
        else if ((0, $aae90cdd39be0d29$export$b28275e1828e6c69)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_UPDATED
        };
        else if ((0, $aae90cdd39be0d29$export$f355d013c74cf359)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_SWAPPERS_UPDATED
        };
        else if ((0, $aae90cdd39be0d29$export$d28ab8000b10b9a3)(previousQuote, currentQuote)) output.quoteUpdate = {
            type: (0, $bad1ce08d7bdae0b$export$f8344cf73408b4e3).QUOTE_COINS_UPDATED
        };
    }
    const balanceWarnings = (0, $8e9d7744e1038276$export$f86a37bf67251d79)(currentQuote, params.selectedWallets, params.meta.blockchains);
    const enoughBalance = balanceWarnings.length === 0;
    if (!enoughBalance) output.balance = {
        messages: balanceWarnings
    };
    return output;
}
function $f6bd121b28fc649c$export$5346efba7535e42d(error) {
    if (error?.code === "ERR_CANCELED") return {
        swap: null,
        error: {
            type: (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_CANCELED
        },
        warnings: null
    };
    if (error.cause) return {
        swap: null,
        error: error.cause,
        warnings: null
    };
    return {
        swap: null,
        error: {
            type: (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED
        },
        warnings: null
    };
}


function $b1afcc5c25bc96ff$export$94a73d00729f2002() {
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, setSelectedQuote: setSelectedQuote, selectedQuote: initialQuote, customDestination: customDestinationFromStore, setQuoteWarningsConfirmed: setQuoteWarningsConfirmed, resetAlerts: resetAlerts } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const userSlippage = customSlippage || slippage;
    const { fetch: fetchQuote, cancelFetch: cancelFetch, loading: loading } = (0, $04cfddbb0c5ae481$export$1e5bf4cdba320952)();
    (0, $exYeM.useEffect)(()=>cancelFetch, []);
    const fetch = async (params)=>{
        const selectedWallets = params.selectedWallets;
        const customDestination = params?.customDestination ?? customDestinationFromStore;
        if (!fromToken || !toToken || !inputAmount) return {
            quote: null,
            swap: null,
            error: null,
            warnings: null
        };
        const wallets = selectedWallets.reduce((acc, item)=>{
            acc[item.chain] = item.address;
            return acc;
        }, {});
        const requestBody = {
            requestId: initialQuote?.requestId || "",
            selectedWallets: wallets,
            destination: customDestination || undefined
        };
        try {
            return await fetchQuote(requestBody, true).then((response)=>{
                const { result: result } = response;
                if (!result) throw new Error("Error fetching updated route");
                (0, $f6bd121b28fc649c$export$2b02bead412ce535)({
                    diagnosisMessages: result.diagnosisMessages,
                    requestId: result.requestId,
                    swaps: result.result?.swaps
                });
                const currentQuote = {
                    outputAmount: result.result?.outputAmount,
                    requestId: result.requestId,
                    resultType: result.result?.resultType,
                    swaps: result.result?.swaps || [],
                    validationStatus: result.validationStatus,
                    requestAmount: result.requestAmount
                };
                setSelectedQuote(currentQuote);
                const swapSettings = {
                    slippage: userSlippage.toString(),
                    disabledSwappersGroups: disabledLiquiditySources
                };
                const confirmSwapWarnings = (0, $f6bd121b28fc649c$export$d3ef6183a73480ba)(initialQuote ?? undefined, currentQuote, {
                    fromToken: fromToken,
                    toToken: toToken,
                    meta: {
                        blockchains: blockchains
                    },
                    findToken: findToken,
                    selectedWallets: selectedWallets,
                    userSlippage: userSlippage
                });
                if (confirmSwapWarnings.quoteUpdate) setQuoteWarningsConfirmed(false);
                resetAlerts();
                const proceedAnyway = !!confirmSwapWarnings.balance;
                const swap = (0, $f3ce3db9d10c7efd$export$dc09743a86365433)(inputAmount.toString(), result, (0, $8e9d7744e1038276$export$16b1f1b35a7efc82)(selectedWallets), swapSettings, proceedAnyway ? false : true, {
                    blockchains: blockchains,
                    tokens: tokens
                });
                return {
                    quote: currentQuote,
                    swap: swap,
                    error: null,
                    warnings: confirmSwapWarnings
                };
            });
        } catch (error) {
            const confirmSwapResult = (0, $f6bd121b28fc649c$export$5346efba7535e42d)(error);
            return confirmSwapResult;
        }
    };
    return {
        loading: loading,
        fetch: fetch,
        cancelFetch: cancelFetch
    };
}








const $d13cf072cbbbeffc$var$Buttons = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [`& ${0, $4c39613e9fff7ff6$export$c25acd513dcc8062}`]: {
        width: "$48",
        height: "$48"
    }
});
const $d13cf072cbbbeffc$var$confirmBtnStyles = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    flexGrow: 1,
    paddingRight: "$10"
});
const $d13cf072cbbbeffc$var$iconStyles = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "$24",
    height: "$24",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $d13cf072cbbbeffc$var$descriptionStyles = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
function $d13cf072cbbbeffc$export$8d36e40575ab7683() {
    //TODO: move component's logics to a custom hook
    const { selectedQuote: selectedQuote, setInputAmount: setInputAmount, selectedWallets: selectedWallets, quoteWalletsConfirmed: quoteWalletsConfirmed, customDestination: customDestination, quoteWarningsConfirmed: quoteWarningsConfirmed } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [dbErrorMessage, setDbErrorMessage] = (0, $exYeM.useState)("");
    const showWalletsOnInit = !quoteWalletsConfirmed;
    const [showWallets, setShowWallets] = (0, $exYeM.useState)(false);
    const [isConfirming, setIsConfirming] = (0, $exYeM.useState)(false);
    const { isActiveTab: isActiveTab } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const prevDisabledLiquiditySources = (0, $exYeM.useRef)(disabledLiquiditySources);
    const { manager: manager } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const { fetch: confirmSwap, loading: fetchingConfirmationQuote, cancelFetch: cancelFetch } = (0, $b1afcc5c25bc96ff$export$94a73d00729f2002)();
    const [confirmSwapResult, setConfirmSwapResult] = (0, $exYeM.useState)({
        swap: null,
        error: null,
        warnings: null
    });
    const [showQuoteWarningModal, setShowQuoteWarningModal] = (0, $exYeM.useState)(false);
    const onConfirmSwap = async ({ selectedWallets: selectedWallets, customDestination: customDestination })=>{
        const result = await confirmSwap?.({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        });
        setConfirmSwapResult(result);
        return result;
    };
    const addNewSwap = async ()=>{
        if (confirmSwapResult.swap && quoteWalletsConfirmed) try {
            await manager?.create("swap", {
                swapDetails: confirmSwapResult.swap
            }, {
                id: confirmSwapResult.swap.requestId
            });
            const swap_url = `../${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).swaps}/${confirmSwapResult.swap.requestId}`;
            navigate(swap_url, {
                replace: true
            });
            setTimeout(()=>{
                setInputAmount("");
            }, 0);
        } catch (e) {
            setDbErrorMessage("Error: " + e?.message);
        }
    };
    const onConfirm = async ()=>{
        setIsConfirming(true);
        await addNewSwap();
        setIsConfirming(false);
    };
    const onStartConfirmSwap = async ()=>{
        if (confirmSwapResult?.warnings?.quote && !quoteWarningsConfirmed) setShowQuoteWarningModal(true);
        else await onConfirm();
    };
    const onRefresh = async ()=>{
        setConfirmSwapResult({
            error: null,
            swap: null,
            warnings: null
        });
        confirmSwap({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        }).then((res)=>{
            setConfirmSwapResult(res);
        }).catch((error)=>console.error(error));
    };
    (0, $exYeM.useEffect)(()=>{
        const disabledLiquiditySourceReset = !!prevDisabledLiquiditySources.current.length && !disabledLiquiditySources.length;
        if (disabledLiquiditySourceReset) onRefresh();
        prevDisabledLiquiditySources.current = disabledLiquiditySources;
    }, [
        disabledLiquiditySources.length
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (showWalletsOnInit) cancelFetch();
    }, [
        showWalletsOnInit
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (showWalletsOnInit) setShowWallets(showWalletsOnInit);
    }, [
        showWalletsOnInit
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!showWalletsOnInit) confirmSwap({
            selectedWallets: selectedWallets,
            customDestination: customDestination
        }).then((result)=>setConfirmSwapResult(result)).catch((error)=>console.error(error));
    }, []);
    (0, $exYeM.useLayoutEffect)(()=>{
        if (!selectedQuote?.requestId) navigate(`../${location.search}`);
    }, [
        selectedQuote?.requestId
    ]);
    const quoteWarning = confirmSwapResult.warnings?.quote ?? null;
    const quoteError = confirmSwapResult.error;
    const alerts = [];
    if (dbErrorMessage) alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "error",
        variant: "alarm",
        title: dbErrorMessage
    }));
    if (confirmSwapResult.warnings?.quoteUpdate) alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        variant: "alarm",
        type: "warning",
        title: confirmSwapResult.warnings.quoteUpdate && (0, $4e1ec8cfadcc6066$export$bd041dac165cd8f3)(confirmSwapResult.warnings.quoteUpdate)
    }));
    if (quoteWarning || quoteError) {
        const settings_url = `../${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings}`;
        alerts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6dff230125954816$export$39d3931d398915e7), {
            warning: quoteWarning,
            error: quoteError,
            couldChangeSettings: false,
            refetchQuote: onRefresh,
            showWarningModal: showQuoteWarningModal,
            confirmationDisabled: !isActiveTab,
            onOpenWarningModal: ()=>setShowQuoteWarningModal(true),
            onCloseWarningModal: ()=>setShowQuoteWarningModal(false),
            onConfirmWarningModal: async ()=>{
                setShowQuoteWarningModal(false);
                await addNewSwap();
            },
            onChangeSettings: ()=>navigate(settings_url)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Confirm Swap"),
            onWallet: ()=>{
                const wallets_url = `../${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).wallets}`;
                navigate(wallets_url);
            }
        },
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($d13cf072cbbbeffc$var$Buttons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            className: $d13cf072cbbbeffc$var$confirmBtnStyles()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-confirm-swap-start-btn",
            variant: "contained",
            type: "primary",
            size: "large",
            fullWidth: true,
            loading: fetchingConfirmationQuote || isConfirming,
            disabled: !!confirmSwapResult.error || !isActiveTab,
            onClick: onStartConfirmSwap
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Start Swap"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            id: "widget-confirm-swap-wallet-icon-btn",
            variant: "contained",
            type: "primary",
            size: "large",
            loading: fetchingConfirmationQuote || isConfirming,
            disabled: !isActiveTab,
            onClick: setShowWallets.bind(null, true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6bb2faf91f857227$export$2e2bcd8739ae039), {
            size: 24
        })))
    }, showWallets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $34b0e7cab88d17f2$export$d70033d2e2cb025), {
        open: showWallets,
        onClose: ()=>setShowWallets(false),
        onCancel: cancelFetch,
        loading: fetchingConfirmationQuote,
        onCheckBalance: onConfirmSwap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: $d13cf072cbbbeffc$var$descriptionStyles()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("You get")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: $d13cf072cbbbeffc$var$iconStyles()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bd1c6af42d9c466b$export$b6a16082cbe3a673), {
        onClick: !fetchingConfirmationQuote && !showWallets && !showQuoteWarningModal ? onRefresh : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "12"
    }), (0, $3d6bbfe922540776$export$ae074417fbc9c359)(alerts.map((alert, index)=>({
            element: alert,
            key: `alert-${index}`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    })), alerts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ac503755ed522b68$export$44189e4b18fc4b2c), {
        quote: selectedQuote,
        type: "swap-preview",
        expanded: true,
        tagHidden: true,
        error: confirmSwapResult.error,
        loading: fetchingConfirmationQuote,
        warning: confirmSwapResult.warnings?.quote ?? null
    })));
}





var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

const $1e6cacb80f72d375$export$be58b4326e23250f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "$24",
    height: "$24",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});


function $a986a2912425d5f2$export$55d7609a8f1eccd2(props) {
    const { variant: variant, fullWidth: fullWidth, color: color, size: size, onChange: onChange, value: value, style: style, setValue: setValue, ...inputAttributes } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
        prefix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1e6cacb80f72d375$export$be58b4326e23250f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $daa353aade8d8ccc$export$2e2bcd8739ae039), {
            color: "black"
        })),
        suffix: !!value.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            variant: "ghost",
            onClick: ()=>setValue?.(""),
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8192be46f8fafa5a$export$2e2bcd8739ae039), {
            color: "gray",
            size: 10
        })),
        fullWidth: fullWidth,
        color: color,
        variant: variant,
        style: {
            padding: 10,
            borderRadius: 25,
            alignItems: "center",
            ...style
        },
        size: size,
        value: value,
        onChange: onChange,
        ...inputAttributes
    });
}




/* eslint-disable @typescript-eslint/no-magic-numbers */ 


var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");



function $f977519689efdcf4$export$446ffacd5b62b780(selectedBlockchain) {
    const { connectedWallets: connectedWallets } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const { getWalletInfo: getWalletInfo } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const prevFetchingBalanceWallets = (0, $exYeM.useRef)([]);
    // The "balanceKey" will be updated and incremented after each change in the balance for a blockchain.
    const [balanceKey, setBalanceKey] = (0, $exYeM.useState)(0);
    (0, $exYeM.useEffect)(()=>{
        const handleWalletEvent = (event)=>{
            if (event.type === (0, $97c1ea0b5855c6ca$export$63e1155cabad967f).DISCONNECT) {
                const walletInfo = getWalletInfo(event.payload.walletType);
                const blockchainSupported = walletInfo.supportedChains.some((chain)=>chain.name === selectedBlockchain);
                if (blockchainSupported) setBalanceKey((prev)=>prev + 1);
            }
        };
        (0, $23eba71feb69205e$export$34dfa91224288fed).on((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).WalletEvent, handleWalletEvent);
        if (!selectedBlockchain) return setBalanceKey((prev)=>prev + 1);
        const supportedWallets = connectedWallets.filter((wallet)=>wallet.chain === selectedBlockchain);
        supportedWallets.forEach((wallet)=>{
            const { walletType: walletType } = wallet;
            const walletIsAlreadyFetching = prevFetchingBalanceWallets.current.includes(walletType);
            /**
       * Watching for changes in "wallet.balances.length" is not accurate.
       * Additionally, checking the equality of previous and current balances for a specific blockchain is resource-intensive, so we avoid these methods.
       */ if (wallet.loading && !walletIsAlreadyFetching) prevFetchingBalanceWallets.current = prevFetchingBalanceWallets.current.concat(walletType);
            else if (!wallet.loading && walletIsAlreadyFetching) {
                prevFetchingBalanceWallets.current = prevFetchingBalanceWallets.current.filter((prevWallet)=>prevWallet !== walletType);
                setBalanceKey((prev)=>prev + 1);
            }
        });
        return ()=>(0, $23eba71feb69205e$export$34dfa91224288fed).off((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).WalletEvent, handleWalletEvent);
    }, [
        connectedWallets,
        selectedBlockchain,
        getWalletInfo
    ]);
    return {
        balanceKey: balanceKey
    };
}










var $exYeM = parcelRequire("exYeM");

const $628afd39532a8fe5$export$1c72867c30aa33bd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    position: "absolute",
    transform: "none",
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 100,
    overflow: "hidden"
});
const $628afd39532a8fe5$export$139026c318cb751f = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    position: "relative",
    height: 12,
    width: "30%",
    maxWidth: "150px"
});
const $628afd39532a8fe5$export$a7b9e4dd713f430b = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    position: "absolute",
    transform: "none",
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    bottom: "-8px"
});
const $628afd39532a8fe5$export$b12cee98d1e517c4 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    transform: "translateY(12px)",
    visibility: "hidden",
    display: "flex",
    "& a": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "$12",
        lineHeight: "$16",
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color",
        textDecoration: "none"
    }
});
const $628afd39532a8fe5$export$46849f385975e6c3 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({});
const $628afd39532a8fe5$export$769c5f3d6f42e497 = (0, $3dd421da623820a3$export$dbf350e5966cf602)();
const $628afd39532a8fe5$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
    justifyContent: "center"
});
const $628afd39532a8fe5$export$f99233281efd08a0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center",
    "._typography": {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 100,
        overflow: "hidden"
    }
});
const $628afd39532a8fe5$export$54c2e3dc7acea9f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    flexGrow: 1,
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& li": {
        alignItems: "none",
        "&:hover": {
            [`& .${$628afd39532a8fe5$export$139026c318cb751f}`]: {
                [`& .${$628afd39532a8fe5$export$b12cee98d1e517c4}`]: {
                    position: "absolute",
                    transform: "none",
                    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
                    visibility: "visible"
                },
                [`& .${$628afd39532a8fe5$export$46849f385975e6c3}`]: {
                    bottom: "-15px"
                },
                [`& .${$628afd39532a8fe5$export$1c72867c30aa33bd}`]: {
                    position: "absolute",
                    transform: "translateY(-12px)",
                    visibility: "hidden"
                },
                [`& .${$628afd39532a8fe5$export$a7b9e4dd713f430b}`]: {
                    position: "absolute",
                    transform: "translateY(-12px)",
                    bottom: "-10px"
                }
            }
        }
    }
});
const $628afd39532a8fe5$export$3288d34c523a1192 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$5",
    paddingRight: "$5",
    borderRadius: "$md",
    display: "flex",
    alignItems: "center"
});
const $628afd39532a8fe5$export$90be223f2c3d0504 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {});
const $628afd39532a8fe5$export$41164ea466f6b019 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    textAlign: "right",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [`& .${$628afd39532a8fe5$export$769c5f3d6f42e497}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $628afd39532a8fe5$export$290d774e6bd35c9a = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "end",
    flexDirection: "column"
});
const $628afd39532a8fe5$export$393edc798c47379d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "center"
});
const $628afd39532a8fe5$export$cb5dc3b938560113 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    [`& ${0, $fb5d3986dd3d8e79$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    }
});
const $628afd39532a8fe5$export$656559010049c8e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    backgroundColor: "$neutral100",
    padding: "$4",
    borderRadius: "50%",
    bottom: -6,
    right: -6
});
const $628afd39532a8fe5$export$89bb33df9ba78ef4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
const $628afd39532a8fe5$export$9048d548939551ee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("a", {
    "& svg:hover": {
        color: "$colors$info"
    }
});


function $365c63b561e85aa2$export$db8f6c71ff4138c0(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$54c2e3dc7acea9f5), null, Array.from(Array(props.size), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $41f02fa281174231$export$a7b06bfba60a8a78), {
            key: e,
            hasDivider: true,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$290d774e6bd35c9a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 70
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "medium",
                width: 50
            })),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "medium",
                width: 90
            }))
        })));
}



const $4bd664e70bf2c5c1$var$PAGE_SIZE = 20;
const $4bd664e70bf2c5c1$var$renderDesc = (props)=>{
    const { address: address, name: name, url: url, token: token, customCssForTag: customCssForTag, customCssForTagTitle: customCssForTagTitle } = props;
    const length = address.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $628afd39532a8fe5$export$139026c318cb751f)()
    }, name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $628afd39532a8fe5$export$1c72867c30aa33bd)()
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$f99233281efd08a0), {
        className: (0, $628afd39532a8fe5$export$a7b9e4dd713f430b)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium"
    }, token.symbol), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$3288d34c523a1192), {
        css: customCssForTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$90be223f2c3d0504), {
        variant: "body",
        size: "xsmall",
        css: customCssForTagTitle
    }, token.blockchain))), !!address && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: `${(0, $628afd39532a8fe5$export$b12cee98d1e517c4)()} ${!name && (0, $628afd39532a8fe5$export$46849f385975e6c3)()}`
    }, length > 10 ? `${address.slice(0, 5)}...${address.slice(length - 6, length)}` : address, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$9048d548939551ee), {
        href: url,
        target: "_blank",
        rel: "nofollow noreferrer",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7de21d312ca8c004$export$2e2bcd8739ae039), {
        size: 12
    }))));
};
function $4bd664e70bf2c5c1$export$24d4785067273813(props) {
    const { list: list, searchedFor: searchedFor = "", onChange: onChange, selectedBlockchain: selectedBlockchain, showTitle: showTitle = true, action: action } = props;
    const [tokens, setTokens] = (0, $exYeM.useState)(list);
    const fetchStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const [hasNextPage, setHasNextPage] = (0, $exYeM.useState)(true);
    const { getBalanceFor: getBalanceFor, loading: loadingWallet } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const { isTokenPinned: isTokenPinned } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    /**
   * We can create the key by hashing the list of tokens,
   * but if the list is large, the memory usage and cost of comparisons may be high.
   */ const { balanceKey: balanceKey } = (0, $f977519689efdcf4$export$446ffacd5b62b780)(selectedBlockchain);
    const loadNextPage = ()=>{
        setTokens(list.slice(0, tokens.length + $4bd664e70bf2c5c1$var$PAGE_SIZE));
    };
    (0, $exYeM.useEffect)(()=>{
        setHasNextPage(list.length > tokens.length);
    }, [
        tokens.length
    ]);
    (0, $exYeM.useEffect)(()=>{
        setTokens(list.slice(0, $4bd664e70bf2c5c1$var$PAGE_SIZE));
    }, [
        list.length,
        selectedBlockchain,
        balanceKey
    ]);
    const endRenderer = (token)=>{
        const tokenBalance = (0, $b27897cbc1e94793$export$cc3bc0b518c1c6b8)(getBalanceFor(token));
        if (action) return action(token);
        if (loadingWallet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$290d774e6bd35c9a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
            variant: "text",
            size: "large",
            width: 70
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
            variant: "text",
            size: "medium",
            width: 50
        }));
        return tokenBalance && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$41164ea466f6b019), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$89bb33df9ba78ef4), {
            variant: "title",
            size: "small"
        }, tokenBalance.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null), tokenBalance.usdValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            className: (0, $628afd39532a8fe5$export$769c5f3d6f42e497)(),
            size: "xsmall"
        }, `$${tokenBalance.usdValue}`));
    };
    const renderList = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $da8c96b0530df421$export$ea50ab61e1198ee3), {
            endReached: hasNextPage ? loadNextPage : undefined,
            itemContent: (index)=>{
                const token = tokens[index];
                const address = token.address || "";
                const blockchain = blockchains.find((blockchain)=>blockchain.name === token.blockchain);
                const colors = (0, $ae3c5b1d0dc01863$export$c496300248fb0045)(blockchain.color, "main");
                const customCssForTag = {
                    $$color: colors.main150,
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: colors.main750
                    },
                    backgroundColor: "$$color"
                };
                const customCssForTagTitle = {
                    $$color: colors.main750,
                    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                        $$color: colors.main150
                    },
                    color: "$$color"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
                    style: {
                        paddingRight: 5
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
                    style: {
                        width: "100%",
                        overflow: "hidden",
                        height: "60px"
                    },
                    "tab-index": index,
                    key: `${token.symbol}${token.address}`,
                    id: `${token.symbol}${token.address}`,
                    className: `widget-token-list-item-btn`,
                    hasDivider: true,
                    onClick: ()=>onChange && onChange(tokens[index]),
                    start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$cb5dc3b938560113), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                        src: token.image,
                        size: 30
                    }), props.type !== "custom-token" && isTokenPinned(token, props.type) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$656559010049c8e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c58775af0b3abd7f$export$2e2bcd8739ae039), {
                        size: 12,
                        color: "gray"
                    }))),
                    title: blockchain?.type === "COSMOS" || !!token.name || !token.name && !address ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$f99233281efd08a0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                        variant: "title",
                        size: "xmedium"
                    }, token.symbol), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                        direction: "horizontal",
                        size: 4
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$3288d34c523a1192), {
                        css: customCssForTag
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$90be223f2c3d0504), {
                        variant: "body",
                        size: "xsmall",
                        css: customCssForTagTitle
                    }, token.blockchain))) : undefined,
                    description: !!blockchain?.info && !!address && blockchain.type !== "COSMOS" ? $4bd664e70bf2c5c1$var$renderDesc({
                        address: address,
                        token: tokens[index],
                        customCssForTag: customCssForTag,
                        customCssForTagTitle: customCssForTagTitle,
                        name: token.name,
                        url: blockchain.info.addressUrl.split("{wallet}").join(address)
                    }) : token.name || undefined,
                    end: endRenderer(token)
                }));
            },
            totalCount: tokens.length,
            key: `${selectedBlockchain}-${searchedFor}-${balanceKey}`
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, showTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Token")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    }), fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $365c63b561e85aa2$export$db8f6c71ff4138c0), {
        size: $4bd664e70bf2c5c1$var$PAGE_SIZE
    }), fetchStatus === "success" && (tokens.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $628afd39532a8fe5$export$54c2e3dc7acea9f5), {
        as: "ul"
    }, renderList()) : !!searchedFor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No results found"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Try using different keywords")
    }))));
}










const $1d1d210a037de13d$var$Content = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    flex: 1
});
const $1d1d210a037de13d$var$NotFoundContent = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "0.75"
});
const $1d1d210a037de13d$var$DeleteIconButton = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
    "&:hover": {
        "& svg": {
            color: "$secondary550"
        }
    }
});
function $1d1d210a037de13d$export$af93f07aa3c8215b() {
    const [searchedFor, setSearchedFor] = (0, $exYeM.useState)("");
    const { deleteCustomToken: deleteCustomToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const customTokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().customTokens();
    const { fromToken: fromToken, toToken: toToken, setFromToken: setFromToken, setToToken: setToToken } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { mode: mode } = (0, $80bd201e0bc05e20$export$93d4e7f90805808f)({});
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $exYeM.useState)(false);
    const [selectedToken, setSelectedToken] = (0, $exYeM.useState)();
    const handleSearch = (event)=>{
        const value = event.target.value;
        setSearchedFor(value);
    };
    const isDarkTheme = mode === "dark";
    const customTokensResults = customTokens.filter((token)=>(0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.symbol, searchedFor) || (0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.address || "", searchedFor) || (0, $7c74207847ca6a20$export$949cdd5cc1255afe)(token.name || "", searchedFor));
    const handleDeleteCustomToken = ()=>{
        if (selectedToken) {
            const toTokenHash = toToken ? (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(toToken) : null;
            const fromTokenHash = fromToken ? (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(fromToken) : null;
            const selectedTokenHash = (0, $76ee130e8dc1847d$export$a7b26387fecb5183)(selectedToken);
            if (toTokenHash === selectedTokenHash) setToToken({
                token: null
            });
            else if (fromTokenHash === selectedTokenHash) setFromToken({
                token: null
            });
            deleteCustomToken(selectedToken);
        }
        setIsDeleteModalOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Custom Tokens")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1d1d210a037de13d$var$Content, null, !!customTokens.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a986a2912425d5f2$export$55d7609a8f1eccd2), {
        value: searchedFor,
        setValue: setSearchedFor,
        fullWidth: true,
        color: "light",
        variant: "contained",
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Search Token"),
        onChange: handleSearch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4bd664e70bf2c5c1$export$24d4785067273813), {
        list: customTokensResults,
        type: "custom-token",
        searchedFor: searchedFor,
        showTitle: false,
        action: (token)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1d1d210a037de13d$var$DeleteIconButton, {
                id: "widget-custom-token-delete-icon-btn",
                variant: "ghost",
                onClick: ()=>{
                    setIsDeleteModalOpen(true);
                    setSelectedToken(token);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5a11d8a29a0f97e3$export$2e2bcd8739ae039), {
                size: 12,
                color: "gray"
            }))
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1d1d210a037de13d$var$NotFoundContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
        icon: isDarkTheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5d38c93c2f96b486$export$2e2bcd8739ae039), {
            size: 200
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $455f94f5acae486c$export$2e2bcd8739ae039), {
            size: 200
        }),
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No custom tokens"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("press the button to add your custom token")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-custom-token-add-btn",
        type: "primary",
        variant: "contained",
        size: "large",
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).addCustomTokens)
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Add Custom Token"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: isDeleteModalOpen,
        dismissible: true,
        onClose: ()=>setIsDeleteModalOpen(false),
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Delete Custom Token"),
        type: "error",
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Are you sure you want to Delete this Token?")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 40
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        fullWidth: true,
        id: "widget-custom-token-delete-modal-yes-btn",
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: handleDeleteCustomToken
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Yes, Delete it")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-custom-token-delete-modal-no-btn",
        fullWidth: true,
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: ()=>setIsDeleteModalOpen(false)
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No, Continue"))))));
}





parcelRequire("14sfz");
var $liigz = parcelRequire("liigz");

var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");


const $78c1de5f55d53463$export$8f314e512d92575f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    "&::before": {
        position: "absolute",
        right: "1px",
        top: "-1px",
        width: "$8",
        height: "$8",
        borderRadius: "100%",
        backgroundColor: "$neutral300",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral400"
        },
        padding: "$2"
    },
    variants: {
        isSelect: {
            true: {
                "&::before": {
                    content: ""
                }
            }
        }
    }
});
const $78c1de5f55d53463$export$fb46dd9777cc6db0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
    width: "$36",
    height: "$36",
    position: "relative",
    padding: "0",
    overflow: "unset",
    backgroundColor: "$neutral300",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral400"
    },
    "&:hover": {
        backgroundColor: "$secondary100",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            backgroundColor: "$neutral"
        },
        [`& ${$78c1de5f55d53463$export$8f314e512d92575f}::before`]: {
            backgroundColor: "$secondary100",
            [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                backgroundColor: "$neutral"
            }
        }
    },
    variants: {
        isSelect: {
            true: {
                border: "1px solid $secondary"
            }
        }
    }
});
const $78c1de5f55d53463$export$37acb3580601e69a = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    width: "$6",
    height: "$6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "3px",
    top: "$0",
    right: "1px",
    backgroundColor: "$secondary500"
});
const $78c1de5f55d53463$export$2f96f6f204f87534 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    padding: "$15",
    borderRadius: "$sm",
    width: "248px",
    backgroundColor: "$background",
    zIndex: 10
});
const $78c1de5f55d53463$export$de560c8a43b4abd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $78c1de5f55d53463$export$c2080d75be022537 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    margin: 0,
    listStyle: "none",
    height: "100%",
    padding: 0,
    ".item-start-container": {
        paddingRight: "0 !important"
    }
});





var $exYeM = parcelRequire("exYeM");

function $757bc6fed7df868b$export$a7463510a6f2fe2c(props) {
    const { filterBy: value, onClickItem: onClickItem } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c1de5f55d53463$export$2f96f6f204f87534), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $78c1de5f55d53463$export$de560c8a43b4abd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "small",
        variant: "body"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Status")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-filter-selector-reset-btn",
        variant: "ghost",
        size: "xxsmall",
        onClick: ()=>onClickItem("")
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Reset"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $366ceca5f7810d8c$export$4d716843016d54fd), {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c1de5f55d53463$export$c2080d75be022537), null, props.list.map((item, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
            key: item.id,
            style: {
                height: "40px",
                width: "100%"
            },
            selected: false,
            hasDivider: props.list.length - 1 != index,
            id: item.id,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                direction: "horizontal",
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                size: "medium",
                variant: "body"
            }, item.title)),
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $183ba84fee413071$export$d7b12c4107be0d61), {
                value: item.id
            }),
            onClick: onClickItem
        });
    }))));
}


function $90b994a492a0ac28$export$f973f3c28d5d9390(props) {
    const { onClickItem: onClickItem, onOpenChange: onOpenChange, filterBy: filterBy, list: list, open: open } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $75e13ed4f8122291$export$5b6b19405a83ff9d), {
        open: open,
        align: "end",
        onOpenChange: onOpenChange,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $757bc6fed7df868b$export$a7463510a6f2fe2c), {
            list: list,
            filterBy: filterBy,
            onClickItem: (id)=>{
                onClickItem(id);
                onOpenChange(false);
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c1de5f55d53463$export$fb46dd9777cc6db0), {
        id: "widget-filter-selector-filter-icon-btn",
        variant: "default",
        isSelect: !!filterBy,
        onClick: ()=>onOpenChange(!props.open)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c1de5f55d53463$export$8f314e512d92575f), {
        isSelect: !!filterBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5745037053c23ac5$export$2e2bcd8739ae039), {
        size: 16,
        color: "black"
    }), !!filterBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c1de5f55d53463$export$37acb3580601e69a), null)))));
}








var $exYeM = parcelRequire("exYeM");



/*
 * The calculateGroupsSoFar Slices the total groups into the groups which contain the items so far.
 * For example, if you have [10, 10, 10, 10] groups in total,
 * slicing them to 23 will result in [10, 10, 3] :
 * https://virtuoso.dev/grouped-with-load-on-demand/
 */ function $d526e5a61b9f48bd$export$e98224da95d25a15(totalGroups, count) {
    const groups = [];
    let index = 0;
    do {
        const group = totalGroups[index];
        groups.push(Math.min(group, count));
        count -= group;
        index++;
    }while (count > 0 && index <= totalGroups.length);
    return groups;
}



const $0e48728109bc676f$export$b0b6d10c5fae514b = (0, $3dd421da623820a3$export$dbf350e5966cf602)();
const $0e48728109bc676f$export$78f92eb1616b0e96 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "$5"
});
const $0e48728109bc676f$export$eb2fcfdbd7ba97d4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "$background",
    padding: "$10 $5 0 $5",
    [`& .${$0e48728109bc676f$export$b0b6d10c5fae514b}`]: {
        $$color: "$colors$neutral600",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
            $$color: "$colors$neutral700"
        },
        color: "$$color"
    }
});
const $0e48728109bc676f$export$680ea196effce5f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "flex-start",
    padding: "$2"
});
const $0e48728109bc676f$export$725566228e41c071 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    gap: "$10",
    display: "flex",
    flexDirection: "column"
});
const $0e48728109bc676f$export$32fe640941018446 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});


const $c800982aa7ea41af$var$ITEMS_PER_PAGE = 10;
function $c800982aa7ea41af$export$9c406bd011f017d8(props) {
    const { list: list, onSwapClick: onSwapClick, groupBy: groupBy, isLoading: isLoading } = props;
    const [currentGroupCounts, setCurrentGroupCounts] = (0, $exYeM.useState)([]);
    const loadedItems = (0, $exYeM.useRef)(0);
    const { swaps: swaps, groupCounts: groupCounts, groups: groups } = groupBy(list);
    const calculateGroups = (0, $exYeM.useCallback)((0, $d526e5a61b9f48bd$export$e98224da95d25a15), []);
    const loadMore = (0, $exYeM.useCallback)(()=>{
        const remainedItems = list.length - loadedItems.current;
        if (remainedItems) {
            loadedItems.current += Math.min(remainedItems, $c800982aa7ea41af$var$ITEMS_PER_PAGE);
            setCurrentGroupCounts(calculateGroups(groupCounts, loadedItems.current));
        }
    }, [
        list.length
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!isLoading) loadMore();
    }, [
        isLoading,
        loadMore
    ]);
    if (isLoading) {
        // The number of items presented in each group.
        const swaps = [
            1,
            2
        ];
        const loadingGroups = [
            swaps,
            swaps
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, loadingGroups.map((group, index)=>{
            const key = index;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$eb2fcfdbd7ba97d4), {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$680ea196effce5f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                width: 60,
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
                size: 4
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$725566228e41c071), null, group.map((_, index)=>{
                const key = index;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $04d011cefd91ddc7$export$d3c936bb842e13d8), {
                    isLoading: true,
                    key: key
                });
            })));
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $da8c96b0530df421$export$41737384f976dee3), {
        endReached: ()=>{
            if (loadedItems.current < list.length) loadMore();
        },
        groupCounts: currentGroupCounts,
        groupContent: (index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$eb2fcfdbd7ba97d4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$680ea196effce5f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                className: (0, $0e48728109bc676f$export$b0b6d10c5fae514b)()
            }, groups[index])));
        },
        itemContent: (index, groupIndex)=>{
            const swap = swaps[index];
            if (!swap) return null;
            const firstStep = swap.steps[0];
            const lastStep = swap.steps[swap.steps.length - 1];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$78f92eb1616b0e96), {
                key: swap.requestId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $04d011cefd91ddc7$export$d3c936bb842e13d8), {
                requestId: swap.requestId,
                creationTime: swap.creationTime,
                status: swap.status,
                onClick: onSwapClick,
                tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
                onlyShowTime: groups[groupIndex] === (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Today"),
                swapTokenData: {
                    from: {
                        token: {
                            image: firstStep.fromLogo,
                            displayName: firstStep.fromSymbol
                        },
                        blockchain: {
                            image: firstStep.fromBlockchainLogo || ""
                        },
                        amount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(swap.inputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                        realAmount: swap.inputAmount
                    },
                    to: {
                        token: {
                            image: lastStep.toLogo,
                            displayName: lastStep.toSymbol
                        },
                        blockchain: {
                            image: lastStep.toBlockchainLogo || ""
                        },
                        amount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable || "", (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                        realAmount: lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable || ""
                    }
                }
            }));
        }
    });
}









var $623348c8dd681cea$exports = {};
!function(t, e) {
    $623348c8dd681cea$exports = e();
}($623348c8dd681cea$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $a0dfcd2a15d273ef$export$12b2414fa2111e69 = (swaps)=>{
    const output = new Map([
        [
            "today",
            {
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Today"),
                swaps: []
            }
        ],
        [
            "week",
            {
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("This week"),
                swaps: []
            }
        ],
        [
            "month",
            {
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("This month"),
                swaps: []
            }
        ],
        [
            "year",
            {
                title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("This year"),
                swaps: []
            }
        ]
    ]);
    function addYearsToOutput(key, swap) {
        if (!output.has(key)) output.set(key, {
            title: key,
            swaps: []
        });
        output.get(key)?.swaps.push(swap);
    }
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($623348c8dd681cea$exports)))();
    swaps.forEach((swap)=>{
        const time = Number(swap.creationTime);
        const swapDate = (0, (/*@__PURE__*/$parcel$interopDefault($623348c8dd681cea$exports)))(time);
        if (now.isSame(swapDate, "day")) output.get("today")?.swaps.push(swap);
        else if (now.isSame(swapDate, "week")) output.get("week")?.swaps.push(swap);
        else if (now.isSame(swapDate, "month")) output.get("month")?.swaps.push(swap);
        else if (now.isSame(swapDate, "year")) output.get("year")?.swaps.push(swap);
        else {
            const year = new Date(time).getFullYear().toString();
            addYearsToOutput(year, swap);
        }
    });
    const groupedSwaps = Array.from(output.values()).filter((item)=>item.swaps.length > 0);
    const items = groupedSwaps.flatMap((group)=>group.swaps);
    const groupCounts = groupedSwaps.map((group)=>group.swaps.length);
    const groups = groupedSwaps.map((group)=>group.title);
    return {
        swaps: items,
        groupCounts: groupCounts,
        groups: groups
    };
};




const $9b953284eda32bc9$var$HistoryGroupedListContainer = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    overflowY: "visible",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 15,
    height: "100%"
});
const $9b953284eda32bc9$var$SearchAndFilterBar = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $9b953284eda32bc9$var$Description = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    "._typography": {
        color: "$neutral700",
        [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0}&`]: {
            color: "$neutral900"
        }
    }
});
const $9b953284eda32bc9$var$transactionStatusFilters = [
    {
        id: (0, $liigz.TransactionStatus).SUCCESS,
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Complete")
    },
    {
        id: (0, $liigz.TransactionStatus).RUNNING,
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Running")
    },
    {
        id: (0, $liigz.TransactionStatus).FAILED,
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Failed")
    }
];
const $9b953284eda32bc9$var$isStepContainsText = (steps, value)=>{
    if (!steps?.length) return false;
    return steps.filter((step)=>(0, $63fc48ac3256c035$export$949cdd5cc1255afe)(step.fromBlockchain, value) || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(step.toBlockchain, value) || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(step.toSymbol, value) || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(step.fromSymbol, value)).length;
};
function $9b953284eda32bc9$export$6eebdb755ddb29f3() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { manager: manager, state: state } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const list = (0, $cd356c8939bca632$export$e57dfc82f316498a)(manager).map(({ swap: swap })=>swap);
    const [searchedFor, setSearchedFor] = (0, $exYeM.useState)("");
    const [openFilterSelector, setOpenFilterSelector] = (0, $exYeM.useState)(false);
    const loading = !state.loadedFromPersistor;
    const [filterBy, setFilterBy] = (0, $exYeM.useState)("");
    const [openClearModal, setOpenClearModal] = (0, $exYeM.useState)(false);
    const handleSearch = (event)=>{
        const value = event.target.value;
        setSearchedFor(value);
    };
    const filteredList = (0, $exYeM.useMemo)(()=>{
        if (!searchedFor && !filterBy) return list;
        return list.filter((swap)=>{
            const { inputAmount: inputAmount, status: status, steps: steps, requestId: requestId } = swap;
            const matchesSearch = !searchedFor || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(inputAmount, searchedFor) || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(status, searchedFor) || $9b953284eda32bc9$var$isStepContainsText(steps, searchedFor) || (0, $63fc48ac3256c035$export$949cdd5cc1255afe)(requestId, searchedFor);
            const matchesFilter = !filterBy || filterBy === status;
            return matchesSearch && matchesFilter;
        });
    }, [
        list,
        searchedFor,
        filterBy
    ]);
    const isEmpty = !filteredList?.length && !loading;
    const onCloseModal = ()=>setOpenClearModal(false);
    const onClear = async ()=>{
        try {
            await manager?.clearQueue();
            setOpenClearModal(false);
        } catch (e) {
            console.log(e);
        }
    };
    const isClearButtonDisabled = (0, $exYeM.useMemo)(()=>{
        return !list.some((swap)=>swap.status === (0, $liigz.TransactionStatus).SUCCESS || swap.status === (0, $liigz.TransactionStatus).FAILED);
    }, [
        list
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("History"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$9baf379cdbf61443), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
                id: "widget-history-clear-btn",
                disabled: isClearButtonDisabled,
                variant: "ghost",
                size: "xsmall",
                onClick: ()=>setOpenClearModal(true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                size: "medium",
                variant: "label",
                color: "error"
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Clear"))))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9b953284eda32bc9$var$SearchAndFilterBar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a986a2912425d5f2$export$55d7609a8f1eccd2), {
        setValue: setSearchedFor,
        fullWidth: true,
        variant: "contained",
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Search Transaction"),
        autoFocus: true,
        onChange: handleSearch,
        style: {
            height: 36
        },
        value: searchedFor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10,
        direction: "horizontal"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $90b994a492a0ac28$export$f973f3c28d5d9390), {
        filterBy: filterBy,
        open: openFilterSelector,
        onOpenChange: (open)=>setOpenFilterSelector(open),
        onClickItem: (id)=>setFilterBy(id),
        list: $9b953284eda32bc9$var$transactionStatusFilters
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9b953284eda32bc9$var$HistoryGroupedListContainer, null, isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0e48728109bc676f$export$32fe640941018446), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
        title: searchedFor ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No results found") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No transactions"),
        titleColor: !searchedFor ? "$info" : undefined,
        hasIcon: !!searchedFor,
        description: searchedFor ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Try using different keywords") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Your transaction history is stored locally and will appear here after you start a swap")
    })), !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c800982aa7ea41af$export$9c406bd011f017d8), {
        list: filteredList,
        onSwapClick: navigate,
        groupBy: (0, $a0dfcd2a15d273ef$export$12b2414fa2111e69),
        isLoading: loading
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: openClearModal,
        onClose: onCloseModal,
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "warning",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Clear Transaction History"),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($9b953284eda32bc9$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "medium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Proceeding will remove all successful and failed transactions from the widget. Do you want to continue?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: "24"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "small"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Note: This does not erase your transaction history on the chain; it only removes them here.")))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 30
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-history-clear-modal-yes-btn",
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: onClear
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Yes, Clear the history")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-history-clear-modal-no-btn",
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "primary"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No, Cancel")))));
}





var $76r4H = parcelRequire("76r4H");

var $exYeM = parcelRequire("exYeM");








var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");










const $ebde2b74044dfe92$export$79fedeb51c055a8b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%"
});
const $ebde2b74044dfe92$export$dd00e0d829eaceaa = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $ebde2b74044dfe92$export$446eebadefe1123b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "146px"
});





var $exYeM = parcelRequire("exYeM");


function $5d3f83785d6ab0f5$export$fafa44f7dbf2a1f4(props) {
    const { updateQuotePartialState: updateQuotePartialState, sortStrategy: sortStrategy } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const ROUTE_STRATEGY = [
        {
            value: "SMART",
            label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Smart Routing")
        },
        {
            value: "FEE",
            label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Lowest Fee")
        },
        {
            value: "SPEED",
            label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Fastest Transfer")
        },
        {
            value: "NET_OUTPUT",
            label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Maximum Return")
        },
        {
            value: "PRICE",
            label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Maximum Output")
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ebde2b74044dfe92$export$446eebadefe1123b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $36de8fcf5878cc9c$export$c006741a65b06687), {
        container: props.container,
        options: ROUTE_STRATEGY,
        value: sortStrategy,
        handleItemClick: (item)=>{
            updateQuotePartialState("sortStrategy", item.value);
        },
        variant: "filled"
    }));
}


const $95128160bacc58a0$var$ITEM_SKELETON_COUNT = 3;
function $95128160bacc58a0$export$d459179d2c3ffa58(props) {
    const { loading: loading, onClickOnQuote: onClickOnQuote, fetch: fetch, showModalFee: showModalFee, hasSort: hasSort = true, fullExpandedMode: fullExpandedMode = false, container: propContainer } = props;
    const { selectedQuote: selectedQuote, quotes: quotes, updateQuotePartialState: updateQuotePartialState, fromToken: fromToken, toToken: toToken, sortStrategy: sortStrategy, error: error } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const container = propContainer || (0, $7c74207847ca6a20$export$49f5bf502122d4f7)();
    const hasQuotes = !!quotes && quotes.results.length;
    const userSlippage = customSlippage ?? slippage;
    const getQuoteWarning = (quote)=>{
        if (!fromToken || !toToken || !quotes) return null;
        const mergedQuote = {
            requestAmount: quotes.requestAmount,
            validationStatus: null,
            ...quote
        };
        return (0, $aae90cdd39be0d29$export$a0c8f8d7b1849c8c)(mergedQuote, {
            fromToken: fromToken,
            toToken: toToken,
            userSlippage: userSlippage,
            findToken: findToken
        });
    };
    const showNoResultMessage = error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT || error?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED;
    const sortQuotes = quotes?.results ? (0, $aae90cdd39be0d29$export$3e03f427decd49d3)(sortStrategy, quotes?.results) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, hasSort && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ebde2b74044dfe92$export$dd00e0d829eaceaa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        size: "xmedium",
        variant: "title"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Sort by")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5d3f83785d6ab0f5$export$fafa44f7dbf2a1f4), {
        container: container
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "10"
    })), loading && Array.from({
        length: $95128160bacc58a0$var$ITEM_SKELETON_COUNT
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: index
        }, fullExpandedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5da5afbb006dfcd7$export$68c79565df9aee60), {
            loading: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c289027c32d9400a$export$45d002177aaaee04), {
            tagHidden: false,
            type: "list-item",
            expanded: false
        }), index !== $95128160bacc58a0$var$ITEM_SKELETON_COUNT - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 16
        }))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, hasQuotes ? sortQuotes.map((quote, index)=>{
        const quoteWarning = getQuoteWarning(quote);
        const quoteError = (0, $f6bd121b28fc649c$export$978cd6d704db6274)(quote.swaps);
        const lastIndex = sortQuotes.length - 1 === index;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: quote.requestId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ac503755ed522b68$export$44189e4b18fc4b2c), {
            showModalFee: showModalFee,
            container: container,
            selected: selectedQuote?.requestId === quote.requestId,
            tagHidden: false,
            quote: {
                ...quote,
                requestAmount: quotes.requestAmount,
                validationStatus: null
            },
            loading: loading,
            error: quoteError?.options || null,
            warning: quoteWarning,
            fullExpandedMode: fullExpandedMode,
            onClick: (quote)=>{
                if (!quoteError) updateQuotePartialState("warning", quoteWarning);
                updateQuotePartialState("error", quoteError?.options || null);
                onClickOnQuote(quote);
            },
            type: "list-item"
        }), !lastIndex && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            size: 16
        }));
    }) : showNoResultMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ebde2b74044dfe92$export$79fedeb51c055a8b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5c40172fd35373c2$export$f1fa434e5dfb6ce5), {
        size: fullExpandedMode ? "large" : "small",
        error: error,
        fetch: fetch
    }))));
}









const $616dbc5850e96f66$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    transition: "width 0.2s, opacity 0.2s, margin-left 0.2s",
    height: "700px",
    width: "390px",
    opacity: 1,
    marginLeft: "$16",
    backgroundColor: "$neutral100",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        backgroundColor: "$neutral300"
    },
    variants: {
        expandMode: {
            default: {
                width: "390px"
            },
            full: {
                width: "719px"
            }
        }
    },
    "&.is-hidden": {
        width: 0,
        height: 0,
        opacity: 0,
        marginLeft: 0
    }
});
const $616dbc5850e96f66$export$7c6e2c02157bb7d2 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative",
    overflow: "hidden",
    padding: "$20",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    borderRadius: "$primary",
    backgroundColor: "$background"
});


const $87d0d48d9e35b2ad$export$5424beebcc828498 = 100;
function $87d0d48d9e35b2ad$export$72c877fd5d43103c(props) {
    const { fetch: fetch, loading: loading, onClickOnQuote: onClickOnQuote, onClickRefresh: onClickRefresh, isVisible: isVisible } = props;
    const [isDelayedVisible, setIsDelayedVisible] = (0, $exYeM.useState)(false);
    const containerClass = isDelayedVisible ? "" : "is-hidden";
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const fullExpandedMode = config?.variant === "full-expanded";
    const container = (0, $7c74207847ca6a20$export$536dc91e674be53)();
    (0, $exYeM.useEffect)(()=>{
        let timeout = null;
        if (isVisible) timeout = setTimeout(()=>{
            setIsDelayedVisible(true);
        }, $87d0d48d9e35b2ad$export$5424beebcc828498);
        else {
            setIsDelayedVisible(false);
            if (timeout) clearTimeout(timeout);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $616dbc5850e96f66$export$42a852a2b6b56249), {
        expandMode: config?.variant === "full-expanded" ? "full" : "default",
        className: `${containerClass} ${(0, $b0ed1a181150593d$export$faad8b178f68f912)()}`,
        id: (0, $81cb43aa4aa5ed51$export$e701ab3081df299).EXPANDED_BOX_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9616dbef4dcfe531$export$8b251419efc915eb), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Routes"),
        suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5d3f83785d6ab0f5$export$fafa44f7dbf2a1f4), {
            container: container
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c7cd3627666a89e5$export$ed80cdffa8822341), {
            container: container,
            onClickRefresh: onClickRefresh,
            hidden: [
                "history",
                "notifications",
                "settings"
            ]
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $616dbc5850e96f66$export$7c6e2c02157bb7d2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95128160bacc58a0$export$d459179d2c3ffa58), {
        showModalFee: false,
        fetch: fetch,
        hasSort: false,
        loading: loading,
        container: (0, $7c74207847ca6a20$export$536dc91e674be53)(),
        onClickOnQuote: onClickOnQuote,
        fullExpandedMode: fullExpandedMode
    })));
}







var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


const $fce2d760ca3c5692$export$a1abbc082aa371ff = 450;
const $fce2d760ca3c5692$var$rotateAnimation = (0, $3dd421da623820a3$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotateX(0deg) rotateY(0deg) rotateZ(0deg)"
    },
    "33%": {
        transform: "rotateX(0deg) rotateZ(78deg) rotateY(66deg)"
    },
    "66%": {
        transform: "rotateX(0deg) rotateZ(163deg) rotateY(66deg)"
    },
    "100%": {
        transform: "rotateX(0deg) rotateZ(180deg) rotateY(0deg)"
    }
});
const $fce2d760ca3c5692$export$aa84ad242e2b0f4e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "absolute",
    bottom: "-12px",
    left: "50%",
    transform: "translate(-50%, 10%)",
    cursor: "pointer"
});
const $fce2d760ca3c5692$export$2d5d2ba3c7c8c40b = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    borderRadius: "$md",
    border: "3px solid $background",
    background: "$neutral100",
    width: "$24",
    height: "$24",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "$foreground",
    "&.rotate": {
        "& svg": {
            animation: `${$fce2d760ca3c5692$var$rotateAnimation} ${$fce2d760ca3c5692$export$a1abbc082aa371ff}ms ease-in-out forwards`
        }
    },
    "&:hover": {
        color: "$secondary500",
        transform: "translateY(1px) scale(1.04)",
        boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)"
    }
});


function $8aa109ce026b6c53$export$a130a75aa6e260f1() {
    const switchFromAndTo = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.switchFromAndTo();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fce2d760ca3c5692$export$aa84ad242e2b0f4e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fce2d760ca3c5692$export$2d5d2ba3c7c8c40b), {
        onClick: (event)=>{
            const button = event.currentTarget;
            button.classList.add("rotate");
            setTimeout(()=>{
                button.classList.remove("rotate");
            }, (0, $fce2d760ca3c5692$export$a1abbc082aa371ff));
            switchFromAndTo();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f7c293598ac51755$export$2e2bcd8739ae039), {
        size: 12
    })));
}














const $768d1f96612b6032$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$5",
    alignSelf: "stretch"
});
const $768d1f96612b6032$export$67d0bc60d30f05c5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    position: "relative"
});


function $840d345dc5222d0b$export$42ce93d1a224e3f9(props) {
    const { fetchingQuote: fetchingQuote, fetchMetaStatus: fetchMetaStatus, onClickToken: onClickToken, isExpandable: isExpandable } = props;
    const { fromToken: fromToken, fromBlockchain: fromBlockchain, toToken: toToken, toBlockchain: toBlockchain, setInputAmount: setInputAmount, inputAmount: inputAmount, inputUsdValue: inputUsdValue, outputAmount: outputAmount, outputUsdValue: outputUsdValue, selectedQuote: selectedQuote } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { connectedWallets: connectedWallets, getBalanceFor: getBalanceFor } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const fromTokenBalance = fromToken ? getBalanceFor(fromToken) : null;
    const fromTokenFormattedBalance = (0, $b27897cbc1e94793$export$cc3bc0b518c1c6b8)(fromTokenBalance)?.amount ?? "0";
    const tokenBalanceReal = !!fromBlockchain && !!fromToken ? (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(fromTokenBalance?.amount, fromTokenBalance?.decimals) : "0";
    const fetchingBalance = !!fromBlockchain && (0, $b27897cbc1e94793$export$e521f0a0dd245bdc)(connectedWallets, fromBlockchain.name);
    const priceImpactInputCanNotBeComputed = !(0, $8e9d7744e1038276$export$281de2a4ae686054)(selectedQuote, inputAmount, inputUsdValue);
    const priceImpactOutputCanNotBeComputed = !(0, $8e9d7744e1038276$export$281de2a4ae686054)(selectedQuote, inputAmount, outputUsdValue);
    const percentageChange = !inputUsdValue || !outputUsdValue || !outputUsdValue.gt(0) ? null : (0, $aae90cdd39be0d29$export$3cad4d44dd01c178)(inputUsdValue.toString(), outputUsdValue.toString());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $768d1f96612b6032$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $768d1f96612b6032$export$67d0bc60d30f05c5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b59329c443aff15a$export$c8e430728cac0e9a), {
        label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("From"),
        mode: "From",
        onInputChange: setInputAmount,
        balance: fromTokenFormattedBalance,
        chain: {
            displayName: fromBlockchain?.displayName || "",
            image: fromBlockchain?.logo || ""
        },
        token: {
            displayName: fromToken?.symbol || "",
            image: fromToken?.image || ""
        },
        onClickToken: ()=>onClickToken("from"),
        price: {
            value: inputAmount,
            usdValue: priceImpactInputCanNotBeComputed ? undefined : (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(inputUsdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)),
            realUsdValue: priceImpactInputCanNotBeComputed ? undefined : inputUsdValue?.toString(),
            error: priceImpactInputCanNotBeComputed ? (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.impactTitle : undefined
        },
        disabled: fetchMetaStatus === "failed",
        loading: fetchMetaStatus === "loading",
        loadingBalance: fetchingBalance,
        tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        onSelectMaxBalance: ()=>{
            setInputAmount(tokenBalanceReal.split(",").join(""));
        },
        anyWalletConnected: connectedWallets.length > 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8aa109ce026b6c53$export$a130a75aa6e260f1), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b59329c443aff15a$export$c8e430728cac0e9a), {
        sharpBottomStyle: !isExpandable && (!!selectedQuote || fetchingQuote),
        label: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("To"),
        mode: "To",
        fetchingQuote: fetchingQuote,
        chain: {
            displayName: toBlockchain?.displayName || "",
            image: toBlockchain?.logo || ""
        },
        token: {
            displayName: toToken?.symbol || "",
            image: toToken?.image || ""
        },
        percentageChange: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)((0, $aae90cdd39be0d29$export$3cad4d44dd01c178)(inputUsdValue, outputUsdValue), (0, $189a5d7f52888885$export$14448384d530389b), (0, $189a5d7f52888885$export$9ec1967a1af30315)),
        warningLevel: (0, $aae90cdd39be0d29$export$161668da75c421a0)(percentageChange ?? 0),
        price: {
            value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(outputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
            usdValue: priceImpactOutputCanNotBeComputed ? undefined : (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(outputUsdValue, (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061)),
            realValue: outputAmount?.toString(),
            realUsdValue: priceImpactOutputCanNotBeComputed ? undefined : outputUsdValue?.toString(),
            error: priceImpactOutputCanNotBeComputed ? (0, $f273788a9b293b5f$export$d8bd0967cb58683)().unknownPriceError.impactTitle : undefined
        },
        onClickToken: ()=>onClickToken("to"),
        disabled: fetchMetaStatus === "failed",
        loading: fetchMetaStatus === "loading",
        tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
    }));
}







var $exYeM = parcelRequire("exYeM");













function $61bd9f4d72025ee8$export$6b54849c3b8ca12f() {
    const { fetch: fetch, loading: loading, cancelFetch: cancelFetch } = (0, $4b55915d4f70e238$export$d852f5f778460fa4)({
        request: async (requestBody, options)=>await (0, $8a4b1db626d4e3d9$export$c1b2b945bea31d71)().getAllRoutes(requestBody, options)
    });
    return {
        fetch: fetch,
        loading: loading,
        cancelFetch: cancelFetch
    };
}


const $9b33b70178d0da96$var$DEBOUNCE_DELAY = 600;
const $9b33b70178d0da96$var$FIRST_INDEX = 0;
function $9b33b70178d0da96$export$747fb43bd07dd5c6({ refetchQuote: refetchQuote }) {
    const { fetch: fetchQuote, cancelFetch: cancelFetch } = (0, $61bd9f4d72025ee8$export$6b54849c3b8ca12f)();
    const { excludeLiquiditySources: configExcludeLiquiditySources, features: features, enableCentralizedSwappers: enableCentralizedSwappers } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().config;
    const connectedWallets = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, inputUsdValue: inputUsdValue, selectedQuote: selectedQuote, sortStrategy: sortStrategy, resetQuote: resetQuote, error: error, warning: warning, setSelectedQuote: setSelectedQuote, updateQuotePartialState: updateQuotePartialState } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { slippage: slippage, customSlippage: customSlippage, affiliatePercent: affiliatePercent, affiliateRef: affiliateRef, affiliateWallets: affiliateWallets, fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const liquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getLiquiditySources();
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const excludeLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().excludeLiquiditySources();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [loading, setLoading] = (0, $exYeM.useState)(true);
    const prevInputAmount = (0, $exYeM.useRef)(inputAmount);
    const userSlippage = customSlippage ?? slippage;
    const tokensValueInvalid = !fromToken || !toToken;
    const shouldSkipRequest = tokensValueInvalid || (0, $b27897cbc1e94793$export$74c4c3613ff7e484)(fromToken, toToken) || !(0, $63fc48ac3256c035$export$5374bb854d0e41c8)(inputAmount);
    const resetState = (loading)=>{
        setLoading(loading);
    };
    const fetch = (params)=>{
        const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, liquiditySources: liquiditySources, excludeLiquiditySources: excludeLiquiditySources, disabledLiquiditySources: disabledLiquiditySources, slippage: slippage, affiliateRef: affiliateRef, affiliatePercent: affiliatePercent, affiliateWallets: affiliateWallets } = params;
        if (!loading) resetState(true);
        if (!shouldSkipRequest && fromToken && toToken) {
            resetQuote();
            const requestBody = (0, $8e9d7744e1038276$export$49491b4f1f3674fa)({
                fromToken: fromToken,
                toToken: toToken,
                inputAmount: inputAmount,
                liquiditySources: liquiditySources,
                excludeLiquiditySources: excludeLiquiditySources,
                disabledLiquiditySources: disabledLiquiditySources,
                wallets: connectedWallets,
                slippage: slippage,
                affiliateRef: affiliateRef,
                affiliatePercent: affiliatePercent,
                affiliateWallets: affiliateWallets,
                enableCentralizedSwappers: enableCentralizedSwappers
            });
            if ((0, $b64e40f2483e228d$export$87e0f7dd6dec932f)("experimentalRoute", features)) requestBody.experimental = true;
            fetchQuote(requestBody).then((res)=>{
                const sortQuotes = (0, $aae90cdd39be0d29$export$3e03f427decd49d3)(sortStrategy, res.results);
                const quote = (0, $aae90cdd39be0d29$export$ddaf73e67dd8a5fe)(selectedQuote, sortQuotes, res.requestAmount);
                setLoading(false);
                updateQuotePartialState("quotes", res);
                setSelectedQuote(quote);
                (0, $f6bd121b28fc649c$export$2b02bead412ce535)({
                    diagnosisMessages: res.diagnosisMessages,
                    requestId: quote?.requestId || "",
                    swaps: quote?.swaps
                });
                const outputUsdValue = (0, $aae90cdd39be0d29$export$63bd4576f33d0cb4)(quote) || toToken?.usdPrice;
                const inputUsdValue = (0, $aae90cdd39be0d29$export$1d28ea9d3bcb49f)(quote) || fromToken?.usdPrice;
                const quoteWarning = quote && (0, $aae90cdd39be0d29$export$a0c8f8d7b1849c8c)(quote, {
                    fromToken: {
                        ...fromToken,
                        usdPrice: inputUsdValue
                    },
                    toToken: {
                        ...toToken,
                        usdPrice: outputUsdValue
                    },
                    userSlippage: userSlippage,
                    findToken: findToken
                });
                updateQuotePartialState("warning", quoteWarning);
            }).catch((error)=>{
                const { error: quoteError } = (0, $f6bd121b28fc649c$export$5346efba7535e42d)(error);
                if (quoteError?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).NO_RESULT || quoteError?.type === (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_FAILED) resetQuote();
                if (quoteError?.type !== (0, $bad1ce08d7bdae0b$export$d1b98d026d7c244c).REQUEST_CANCELED) {
                    updateQuotePartialState("error", quoteError);
                    setLoading(false);
                }
            });
        }
    };
    const debouncedFetch = (0, $exYeM.useCallback)((0, $7c74207847ca6a20$export$61fc7d43ac8f84b0)((params)=>{
        fetch(params);
    }, $9b33b70178d0da96$var$DEBOUNCE_DELAY), [
        shouldSkipRequest
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!refetchQuote) {
            setLoading(false);
            return;
        }
        if (fetchStatus !== "success") return;
        if (shouldSkipRequest) {
            setLoading(false);
            if (selectedQuote || error || warning) resetQuote();
            return;
        }
        if (!(0, $63fc48ac3256c035$export$5374bb854d0e41c8)(inputAmount) || inputUsdValue?.eq(0)) {
            resetState(false);
            cancelFetch();
            return;
        }
        resetQuote();
        resetState(true);
        let fetchQuotes = fetch;
        if (prevInputAmount.current && prevInputAmount.current != inputAmount) fetchQuotes = debouncedFetch;
        prevInputAmount.current = inputAmount;
        fetchQuotes({
            inputAmount: inputAmount,
            fromToken: fromToken,
            toToken: toToken,
            liquiditySources: liquiditySources,
            excludeLiquiditySources: excludeLiquiditySources,
            disabledLiquiditySources: disabledLiquiditySources,
            slippage: userSlippage,
            affiliateRef: affiliateRef,
            affiliatePercent: affiliatePercent,
            affiliateWallets: affiliateWallets
        });
        return cancelFetch;
    }, [
        fetchStatus,
        inputAmount,
        fromToken?.symbol,
        fromToken?.address,
        fromToken?.blockchain,
        toToken?.symbol,
        toToken?.address,
        toToken?.blockchain,
        shouldSkipRequest,
        liquiditySources?.length,
        configExcludeLiquiditySources,
        disabledLiquiditySources.length,
        userSlippage,
        affiliateRef,
        affiliatePercent,
        JSON.stringify(affiliateWallets)
    ]);
    return {
        fetch: ()=>fetch({
                inputAmount: inputAmount,
                fromToken: fromToken,
                toToken: toToken,
                liquiditySources: liquiditySources,
                excludeLiquiditySources: excludeLiquiditySources,
                disabledLiquiditySources: disabledLiquiditySources,
                slippage: userSlippage,
                affiliateRef: affiliateRef,
                affiliatePercent: affiliatePercent,
                affiliateWallets: affiliateWallets
            }),
        loading: loading
    };
}










function $054abf421a70fcbf$export$4b85f2c954ea8ad7(event, action) {
    let defaultPrevented = false;
    const extendedPayload = {
        preventDefault () {
            defaultPrevented = true;
        },
        ...event.payload === undefined && {
            payload: event.payload
        }
    };
    (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit((0, $97c1ea0b5855c6ca$export$54f5f69c1651567f).UiEvent, {
        type: event.type,
        payload: extendedPayload
    });
    if (!defaultPrevented) action();
}



const $46253dfedd5d183d$var$MainContainer = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    alignItems: "flex-start",
    maxHeight: 700,
    "& .footer__alert": {
        paddingTop: "0 !important"
    }
});
const $46253dfedd5d183d$export$5d17bb5eb80d9179 = 300;
function $46253dfedd5d183d$export$b94310965bed44e6() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { fromToken: fromToken, toToken: toToken, inputAmount: inputAmount, selectedQuote: selectedQuote, refetchQuote: refetchQuote, error: quoteError, warning: quoteWarning, quotes: quotes, setSelectedQuote: setSelectedQuote, resetQuoteWallets: resetQuoteWallets, setQuoteWarningsConfirmed: setQuoteWarningsConfirmed, updateQuotePartialState: updateQuotePartialState } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const [isVisibleExpanded, setIsVisibleExpanded] = (0, $exYeM.useState)(false);
    const { isLargeScreen: isLargeScreen, isExtraLargeScreen: isExtraLargeScreen } = (0, $556a63bab2f130c0$export$2e2bcd8739ae039)();
    const { fetch: fetchQuote, loading: loading } = (0, $9b33b70178d0da96$export$747fb43bd07dd5c6)({
        refetchQuote: refetchQuote
    });
    const { config: config, fetchStatus: fetchMetaStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { connectedWallets: connectedWallets } = (0, $41385c7b1441a578$export$63a06538da9383a6)();
    const { isActiveTab: isActiveTab } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const [showQuoteWarningModal, setShowQuoteWarningModal] = (0, $exYeM.useState)(false);
    const needsToWarnEthOnPath = false;
    const swapButtonState = (0, $8e9d7744e1038276$export$cd3d5e5ada9115df)({
        fetchMetaStatus: fetchMetaStatus,
        fetchingQuote: loading,
        inputAmount: inputAmount,
        quote: selectedQuote,
        anyWalletConnected: connectedWallets.length > 0,
        error: quoteError,
        warning: quoteWarning,
        needsToWarnEthOnPath: needsToWarnEthOnPath
    });
    const isExpandable = (0, $6fd02b85a3828f9f$export$f56e4a09b07f5a47)(isLargeScreen, isExtraLargeScreen, config?.variant);
    const hasInputs = !!inputAmount && !!fromToken && !!toToken && new (0, $76r4H.default)(inputAmount).gt(0) && !(0, $8e9d7744e1038276$export$2cdd2187dfb51b81)(fromToken, toToken);
    const fetchingQuote = hasInputs && fetchMetaStatus === "success" && loading;
    const hasValidQuotes = !isExpandable || isExpandable && quotes?.results.length;
    const hasWarningOrError = quoteWarning || quoteError;
    const showMessages = hasValidQuotes && hasWarningOrError;
    (0, $exYeM.useEffect)(()=>{
        resetQuoteWallets();
        updateQuotePartialState("refetchQuote", true);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        setIsVisibleExpanded(hasInputs);
    }, [
        hasInputs
    ]);
    const onClickRefresh = (!!selectedQuote || quoteError) && !showQuoteWarningModal ? fetchQuote : undefined;
    const onHandleNavigation = (route)=>{
        if (isExpandable && isVisibleExpanded) {
            setIsVisibleExpanded(false);
            setTimeout(()=>{
                navigate(route);
            }, $46253dfedd5d183d$export$5d17bb5eb80d9179);
        } else navigate(route);
    };
    const onClickOnQuote = (quote)=>{
        if (selectedQuote?.requestId !== quote.requestId) {
            setShowQuoteWarningModal(false);
            setSelectedQuote(quote);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($46253dfedd5d183d$var$MainContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        height: "auto",
        footer: // eslint-disable-next-line jsx-id-attribute-enforcement/missing-ids
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: `widget-swap-${swapButtonState.action}-btn`,
            type: "primary",
            size: "large",
            disabled: swapButtonState.disabled || !isActiveTab,
            prefix: swapButtonState.action === "confirm-warning" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $19f0b898bfde68ac$export$2e2bcd8739ae039), null),
            fullWidth: true,
            onClick: ()=>{
                if (swapButtonState.action === "connect-wallet") (0, $054abf421a70fcbf$export$4b85f2c954ea8ad7)({
                    type: (0, $97c1ea0b5855c6ca$export$7a2e2250d475f540).CLICK_CONNECT_WALLET
                }, ()=>onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).wallets));
                else if (swapButtonState.action === "confirm-warning") setShowQuoteWarningModal(true);
                else onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).confirmSwap);
            }
        }, swapButtonState.title),
        header: {
            onWallet: ()=>{
                onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).wallets);
            },
            hasBackButton: false,
            title: config.title || (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c7cd3627666a89e5$export$ed80cdffa8822341), {
                hidden: isExpandable ? [
                    "refresh"
                ] : undefined,
                onClickRefresh: onClickRefresh,
                onClickHistory: ()=>onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).swaps),
                onClickSettings: ()=>{
                    onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings);
                }
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $840d345dc5222d0b$export$42ce93d1a224e3f9), {
        fetchingQuote: fetchingQuote,
        fetchMetaStatus: fetchMetaStatus,
        isExpandable: isExpandable,
        onClickToken: (mode)=>{
            onHandleNavigation(mode === "from" ? (0, $415b6399c61cd80f$export$492bdc31a14c4d1).fromSwap : (0, $415b6399c61cd80f$export$492bdc31a14c4d1).toSwap);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "2"
    }), !isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ac503755ed522b68$export$44189e4b18fc4b2c), {
        quote: selectedQuote,
        loading: fetchingQuote,
        error: quoteError,
        tagHidden: false,
        warning: quoteWarning,
        type: "basic",
        onClickAllRoutes: !!quotes && quotes.results.length > 1 ? ()=>{
            updateQuotePartialState("refetchQuote", false);
            onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).routes);
        } : undefined
    }) : null, showMessages ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6dff230125954816$export$39d3931d398915e7), {
        warning: quoteWarning,
        error: quoteError,
        couldChangeSettings: true,
        refetchQuote: fetchQuote,
        showWarningModal: showQuoteWarningModal,
        confirmationDisabled: !isActiveTab,
        onOpenWarningModal: ()=>setShowQuoteWarningModal(true),
        onCloseWarningModal: ()=>setShowQuoteWarningModal(false),
        onConfirmWarningModal: ()=>{
            setShowQuoteWarningModal(false);
            setQuoteWarningsConfirmed(true);
            onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).confirmSwap);
        },
        onChangeSettings: ()=>onHandleNavigation((0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings)
    })) : null)), isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $87d0d48d9e35b2ad$export$72c877fd5d43103c), {
        loading: fetchingQuote,
        onClickOnQuote: onClickOnQuote,
        fetch: fetchQuote,
        onClickRefresh: onClickRefresh,
        isVisible: isVisibleExpanded
    }) : null);
}





var $exYeM = parcelRequire("exYeM");



function $da3430e16b59e33f$export$c1fd9f444a3dc711() {
    const { setLanguage: setLanguage, language: language, config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const languages = (0, $e63cb382fec4f20b$export$2092376fd002e13);
    const defaultLanguage = config?.language || (0, $e63cb382fec4f20b$export$910b680d1eea6990);
    return {
        activeLanguage: language || defaultLanguage,
        languages: languages,
        defaultLanguage: defaultLanguage,
        changeLanguage: (language)=>setLanguage(language || (0, $e63cb382fec4f20b$export$910b680d1eea6990)),
        resetLanguage: ()=>setLanguage(null)
    };
}



function $1ab13a5fa27a1367$export$28f282c008ccfd46() {
    const { activeLanguage: activeLanguage, changeLanguage: changeLanguage, languages: languages } = (0, $da3430e16b59e33f$export$c1fd9f444a3dc711)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const languageList = languages.map((languageItem)=>{
        const { local: local, label: label, SVGFlag: SVGFlag } = languageItem;
        return {
            id: `widget-setting-languages-${local}-item-btn`,
            value: local,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "xmedium"
            }, label),
            onClick: ()=>{
                changeLanguage(languageItem.local);
                navigateBack();
            },
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $183ba84fee413071$export$d7b12c4107be0d61), {
                value: local
            }),
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(SVGFlag, null)
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Language")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "warning",
        variant: "alarm",
        title: "Warning: We are using machine translation, so the translations may be inaccurate."
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $366ceca5f7810d8c$export$4d716843016d54fd), {
        value: activeLanguage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eba68bfb6488b0a$export$54c2e3dc7acea9f5), {
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("language"),
            id: "_",
            onClick: ()=>console.log()
        }),
        items: languageList
    }))));
}





var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");

const $651a720a6a0571ad$export$f4be31ec5852033d = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("ul", {
    padding: "$15 $5 0",
    margin: 0,
    listStyle: "none",
    height: "100%",
    overflowY: "auto",
    variants: {
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
});
const $651a720a6a0571ad$export$8477f97543bab9a5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: 80,
    display: "flex",
    justifyContent: "flex-end"
});
const $651a720a6a0571ad$export$32fe640941018446 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});





const $12a00bff1d6d06df$export$61eb8c55090b85cc = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $41f02fa281174231$export$a7b06bfba60a8a78), {
    height: 61
});


const $ac3a5b03d879a268$var$ITEM_SKELETON_COUNT = 30;
function $ac3a5b03d879a268$export$f7d81c4b74405eec() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $651a720a6a0571ad$export$f4be31ec5852033d), null, Array.from(Array($ac3a5b03d879a268$var$ITEM_SKELETON_COUNT), (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $12a00bff1d6d06df$export$61eb8c55090b85cc), {
            hasDivider: true,
            key: index,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            }),
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c3cfb7c988c3f338$export$48513f6b9f8ce62d), {
                checked: false
            })
        })));
}









function $dfa8e208271e2384$export$ab9f3efe9ea3da6a({ sourceType: sourceType }) {
    const fetchStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const [searchedFor, setSearchedFor] = (0, $exYeM.useState)("");
    const toggleLiquiditySource = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().toggleLiquiditySource;
    const campaignMode = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().isInCampaignMode();
    const supportedUniqueSwappersGroups = (0, $b64e40f2483e228d$export$299798afcc913c30)(swappers, disabledLiquiditySources);
    const types = {
        Exchanges: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Exchanges"),
        Bridges: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Bridges")
    };
    const validTypes = [];
    if (sourceType === "Exchanges") validTypes.push("DEX");
    if (sourceType === "Bridges") validTypes.push("BRIDGE", "AGGREGATOR", "OFF_CHAIN");
    const liquiditySources = supportedUniqueSwappersGroups.filter((uniqueItem)=>validTypes.includes(uniqueItem.type));
    const hasSelectAll = liquiditySources.length === liquiditySources.filter((sourceItem)=>sourceItem.selected).length;
    const toggleAllSources = ()=>{
        liquiditySources.forEach((sourceItem)=>{
            if (hasSelectAll) toggleLiquiditySource(sourceItem.groupTitle);
            else if (!sourceItem.selected) toggleLiquiditySource(sourceItem.groupTitle);
        });
    };
    const list = liquiditySources.map((sourceItem)=>{
        const { selected: selected, groupTitle: groupTitle, logo: logo, id: id, ...restSourceItem } = sourceItem;
        return {
            id: `widget-setting-liquidity-source-${id.toLowerCase().replace(/\s+/g, "-")}-item-btn`,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                src: logo,
                size: 22,
                type: "circular"
            }),
            onClick: ()=>{
                if (!campaignMode) toggleLiquiditySource(groupTitle);
            },
            end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c3cfb7c988c3f338$export$48513f6b9f8ce62d), {
                checked: selected,
                disabled: campaignMode
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "title",
                size: "xmedium"
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(groupTitle)),
            selected: selected,
            groupTitle: groupTitle,
            logo: logo,
            ...restSourceItem
        };
    });
    const handleSearch = (event)=>{
        const value = event.target.value;
        setSearchedFor(value);
    };
    let filteredList = list;
    if (searchedFor) filteredList = list.filter((sourceItem)=>(0, $63fc48ac3256c035$export$949cdd5cc1255afe)(sourceItem.groupTitle, searchedFor));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(sourceType),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $651a720a6a0571ad$export$8477f97543bab9a5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
                id: `widget-liquidity-source-${hasSelectAll ? "deselect-all" : "select-all"}-btn`,
                variant: "ghost",
                size: "xsmall",
                onClick: toggleAllSources
            }, hasSelectAll ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Deselect all") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select all")))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), {
        view: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a986a2912425d5f2$export$55d7609a8f1eccd2), {
        value: searchedFor,
        setValue: setSearchedFor,
        fullWidth: true,
        color: "light",
        variant: "contained",
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Search {sourceType}", {
            sourceType: types[sourceType]
        }),
        onChange: handleSearch
    }), fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ac3a5b03d879a268$export$f7d81c4b74405eec), null), !filteredList.length && !!searchedFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $651a720a6a0571ad$export$32fe640941018446), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No results found"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Try using different keywords")
    })) : fetchStatus === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $651a720a6a0571ad$export$f4be31ec5852033d), {
        disabled: campaignMode
    }, filteredList.map((sourceItem)=>{
        const { groupTitle: groupTitle, ...otherProps } = sourceItem;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, {
            key: sourceItem.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
            style: {
                height: "61px"
            },
            ...otherProps,
            selected: false,
            hasDivider: true
        }));
    }))));
}




var $exYeM = parcelRequire("exYeM");








function $de8101526b9c107b$export$ebde1f165243f87e() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const { selectedQuote: selectedQuote, refetchQuote: refetchQuote, setSelectedQuote: setSelectedQuote, updateQuotePartialState: updateQuotePartialState, error: quoteError } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const { fetch: fetchQuote, loading: fetchingQuote } = (0, $9b33b70178d0da96$export$747fb43bd07dd5c6)({
        refetchQuote: refetchQuote
    });
    const onClickOnQuote = (quote)=>{
        setSelectedQuote(quote);
        updateQuotePartialState("refetchQuote", false);
        navigateBack();
    };
    const settings_url = `../${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings}`;
    const wallets_url = `../${(0, $415b6399c61cd80f$export$492bdc31a14c4d1).wallets}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            onWallet: ()=>{
                navigate(wallets_url);
                updateQuotePartialState("refetchQuote", true);
            },
            onBack: ()=>{
                updateQuotePartialState("refetchQuote", false);
            },
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Routes"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c7cd3627666a89e5$export$ed80cdffa8822341), {
                onClickRefresh: !!selectedQuote || quoteError ? fetchQuote : undefined,
                hidden: [
                    "notifications",
                    "history"
                ],
                onClickSettings: ()=>{
                    navigate(settings_url);
                    updateQuotePartialState("refetchQuote", true);
                }
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95128160bacc58a0$export$d459179d2c3ffa58), {
        fetch: fetchQuote,
        loading: fetchingQuote,
        onClickOnQuote: onClickOnQuote
    })));
}





var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");


const $60e331ddff38e042$export$c1c7992bdd9075bb = (list, searchedFor, blockchainCategory)=>list.filter((blockchain)=>(0, $7c74207847ca6a20$export$3f79ee9344f436da)(blockchain.type, blockchainCategory)).filter((blockchain)=>(0, $7c74207847ca6a20$export$949cdd5cc1255afe)(blockchain.name, searchedFor) || (0, $7c74207847ca6a20$export$949cdd5cc1255afe)(blockchain.displayName, searchedFor));




const $3dfbd910ad12840c$export$78348a28ea56e725 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: "100%",
    justifyContent: "center"
});
const $3dfbd910ad12840c$export$54c2e3dc7acea9f5 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $fd737d69d3de4ef4$export$83c3fa3ac4f31acf), {
    padding: 0,
    margin: 0,
    listStyle: "none",
    [`& ${0, $fb5d3986dd3d8e79$export$94026ee33dbabc26}`]: {
        borderRadius: "$xm",
        overflow: "hidden"
    }
});




var $exYeM = parcelRequire("exYeM");

const $fa2bb8ff54dab282$var$ITEM_SKELETON_COUNT = 20;
function $fa2bb8ff54dab282$export$ebbe851050dc69fa() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3dfbd910ad12840c$export$54c2e3dc7acea9f5), null, Array.from(Array($fa2bb8ff54dab282$var$ITEM_SKELETON_COUNT), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $41f02fa281174231$export$a7b06bfba60a8a78), {
            key: e,
            hasDivider: true,
            start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "circular",
                width: 35,
                height: 35
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                variant: "text",
                size: "large",
                width: 90
            })
        })));
}


function $feeacc5d9746439c$export$9ba583f5b6f67c9b(props) {
    const { list: list, searchedFor: searchedFor, onChange: onChange, blockchainCategory: blockchainCategory, showTitle: showTitle = true } = props;
    const [blockchains, setBlockchains] = (0, $exYeM.useState)(list);
    const { fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    (0, $exYeM.useEffect)(()=>{
        setBlockchains([
            ...(0, $60e331ddff38e042$export$c1c7992bdd9075bb)(list, searchedFor, blockchainCategory)
        ]);
    }, [
        list,
        searchedFor,
        blockchainCategory
    ]);
    const renderList = ()=>{
        if (!blockchains.length && !!searchedFor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No results found"),
            description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Try using different keywords")
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3dfbd910ad12840c$export$54c2e3dc7acea9f5), {
            as: "ul",
            key: `${blockchainCategory}-${searchedFor}`
        }, blockchains.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
                key: `${item.name}-${item.chainId}`,
                className: `widget-blockchain-list-item-btn`,
                hasDivider: true,
                onClick: ()=>onChange(item),
                start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
                    src: item.logo,
                    size: 30
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                    variant: "title",
                    size: "medium"
                }, item.displayName),
                id: item.name
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, showTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Chain")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 4
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3dfbd910ad12840c$export$78348a28ea56e725), null, fetchStatus === "loading" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fa2bb8ff54dab282$export$ebbe851050dc69fa), null), fetchStatus === "success" && renderList()));
}









function $c4f81ebb9198a5bd$export$6a77e94e9d78943a(props) {
    const { type: type } = props;
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const [searchedFor, setSearchedFor] = (0, $exYeM.useState)("");
    const [blockchainCategory, setBlockchainCategory] = (0, $exYeM.useState)("ALL");
    const setToBlockchain = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.setToBlockchain();
    const setFromBlockchain = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.setFromBlockchain();
    const { fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains({
        type: type
    });
    const activeCategoriesCount = (0, $72ff915f8d8218ca$export$f6cff66fe61062ef)(blockchains);
    const showCategory = !props.hideCategory && activeCategoriesCount !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t(`Select Chain`)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), {
        view: true
    }, showCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d15d2da2f4d97305$export$e15317e9262e7409), {
        setCategory: setBlockchainCategory,
        category: blockchainCategory,
        blockchains: blockchains,
        isLoading: fetchStatus === "loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a986a2912425d5f2$export$55d7609a8f1eccd2), {
        value: searchedFor,
        autoFocus: true,
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Search Chain"),
        color: "light",
        variant: "contained",
        size: "large",
        setValue: ()=>setSearchedFor(""),
        onChange: (event)=>setSearchedFor(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $feeacc5d9746439c$export$9ba583f5b6f67c9b), {
        list: blockchains,
        showTitle: type !== "custom-token",
        searchedFor: searchedFor,
        blockchainCategory: blockchainCategory,
        onChange: (blockchain)=>{
            if (type === "custom-token") navigate(`..?blockchain=${blockchain.name}`, {
                replace: true
            });
            else {
                if (type === "source") setFromBlockchain(blockchain);
                else setToBlockchain(blockchain);
                navigateBack();
            }
        }
    })));
}





var $exYeM = parcelRequire("exYeM");

/* eslint-disable @typescript-eslint/no-magic-numbers */ 


var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

const $e17494a61de93feb$export$889e8e3e982ff536 = [
    "ETH",
    "COSMOS",
    "OSMOSIS"
];


function $b77cc5047ad3960f$export$18298bb220d85216(blockchains, preferredBlockchains, options) {
    /*
   * TODO:
   * We copying the `blockchains` which can causes performance penalties but we should because we are mutating the original object.
   * A better way to solve the problem maybe is using new JS features like Use toSpliced() but
   * we can not use it right now because we need to upgrade our toolings first.
   */ const list = JSON.parse(JSON.stringify(blockchains));
    let more = [];
    list.sort($b77cc5047ad3960f$export$88cbd77c92ad5cdd);
    // Checking `limit` has set and it should be more than of the list items.
    if (!!options?.limit && blockchains.length > options.limit) {
        const start = options.limit;
        let preferredBlockchainsWithoutMainList = preferredBlockchains;
        if (preferredBlockchains.length <= options.limit) {
            /**
       *
       * if we want to show 10 items (aka `options.limit`)
       * and have these items as our preferred list: [x,y,z]
       * and these as our main list: [A, B, C, D, E, F, G, H, I, J]
       * the final list will be like this: [...preferred, ...mainList].
       *
       * Since we have a limit (e.g. 10) on our list (preferred + mainList),
       * we only should check those items from main list that will be in final list.
       *
       * finalListWithoutLimit = [x,y,z, A, B, C, D, E, F, G, H, I, J]
       * finalListWithLimit = [x,y,z, A, B, C, D, E, F, G]
       *
       * As you can see, [H, I, J] will not be in our list.
       *
       * The following code only check preffred blockchain
       * shouldn't be in first 7 of 10 items in main list. (Since, the last 3 items will not be in the final list and we should check those.)
       */ const howManyItemsShouldBeCheckedFromMainList = options.limit - preferredBlockchains.length;
            for(let i = 0; i <= howManyItemsShouldBeCheckedFromMainList; i++){
                const blockchain = list[i];
                preferredBlockchainsWithoutMainList = preferredBlockchainsWithoutMainList.filter((preferredBlockchain)=>{
                    return blockchain.name !== preferredBlockchain;
                });
            }
        }
        list.sort($b77cc5047ad3960f$export$d978304d0aef050d(preferredBlockchainsWithoutMainList));
        /*
     * Splice will modify the original list and returns the deleted items
     * We use the deleted items as `more`
     */ more = list.splice(start);
    }
    return {
        list: list,
        more: more
    };
}
function $b77cc5047ad3960f$export$88cbd77c92ad5cdd(a, b) {
    const mostUsed = (0, $e17494a61de93feb$export$889e8e3e982ff536);
    const aIndexInMostUsed = mostUsed.findIndex((token)=>token === a.name);
    const bIndexInMostUsed = mostUsed.findIndex((token)=>token === b.name);
    const aIsMostUsed = aIndexInMostUsed > -1;
    const bIsMostUsed = bIndexInMostUsed > -1;
    if (aIsMostUsed && bIsMostUsed) return aIndexInMostUsed > bIndexInMostUsed ? 1 : -1;
    if (aIsMostUsed) return -1;
    if (bIsMostUsed) return 1;
    return 0;
}
function $b77cc5047ad3960f$export$d978304d0aef050d(preferredBlockchains) {
    return function sortByPreferred(a, b) {
        const aIndexInPreferred = preferredBlockchains.findIndex((blockchain)=>blockchain === a.name);
        const bIndexInPreferred = preferredBlockchains.findIndex((blockchain)=>blockchain === b.name);
        const aIsPreferred = aIndexInPreferred > -1;
        const bIsPreferred = bIndexInPreferred > -1;
        if (aIsPreferred && bIsPreferred) return aIndexInPreferred > bIndexInPreferred ? 1 : -1;
        if (preferredBlockchains.includes(a.name)) return -1;
        if (preferredBlockchains.includes(b.name)) return 1;
        return 0;
    };
}
function $b77cc5047ad3960f$export$927467835c0f6712(blockchain, prepareOutput) {
    return !!prepareOutput.list.find((item)=>item.name === blockchain);
}


function $4e1c27481a725ffd$export$35f383448a339da9(blockchains, options) {
    const { preferredBlockchains: preferredBlockchains, addPreferredBlockchain: addPreferredBlockchain } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    (0, $exYeM.useEffect)(()=>{
        if (options?.selected) {
            const output = (0, $b77cc5047ad3960f$export$18298bb220d85216)(blockchains, preferredBlockchains, options);
            /**
       * We only add a new blockchain to preferred when it's not in the main list
       * In this way we can guarantee we will be able to regenerate the same list always.
       * And also it helps us to avoid jumping for the last item of the main list (e.g. tenth item of our list).
       */ if (!(0, $b77cc5047ad3960f$export$927467835c0f6712)(options.selected, output)) addPreferredBlockchain(options?.selected);
        }
    }, [
        options?.selected
    ]);
    const output = (0, $b77cc5047ad3960f$export$18298bb220d85216)(blockchains, preferredBlockchains, options);
    return {
        list: output.list,
        more: output.more,
        history: []
    };
}








const $3f12b5f5fbb74e43$export$3f078f46c085d23c = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "grid",
    gap: "$10",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))"
});


const $ad983ea4dc895992$var$NUMBER_OF_LOADING = 12;
function $ad983ea4dc895992$export$4aeb8def13a8b944(props) {
    const { blockchains: blockchains, type: type, blockchain: blockchain, onChange: onChange, onMoreClick: onMoreClick } = props;
    const blockchainsList = (0, $4e1c27481a725ffd$export$35f383448a339da9)(blockchains, {
        limit: (0, $25cb0a171c1d3c61$export$6b07023c78ed4e3a),
        selected: blockchain?.name
    });
    const { fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const resetToBlockchain = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.resetToBlockchain();
    const resetFromBlockchain = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.resetFromBlockchain();
    const hasMoreItemsInList = blockchainsList.more.length > 0;
    /**
   * When only one item is left on list, we will not show the `More` button and will show the item itself instead.
   */ const onlyOneItemInList = blockchainsList.more.length === 1;
    const showMoreButton = !onlyOneItemInList && hasMoreItemsInList;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Select Chain")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3f12b5f5fbb74e43$export$3f078f46c085d23c), null, fetchStatus === "loading" && Array.from(Array($ad983ea4dc895992$var$NUMBER_OF_LOADING), (e)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
            key: e,
            variant: "rounded",
            height: 50
        })), fetchStatus === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b21157a9f19b41cb$export$70f20e53a91f662d), {
        selected: !blockchain,
        onClick: ()=>{
            if (type === "from") resetFromBlockchain();
            else resetToBlockchain();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "secondary500"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("All"))), blockchainsList.list.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
            key: item.name,
            content: item.shortName,
            side: "bottom",
            sideOffset: 2,
            container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b21157a9f19b41cb$export$70f20e53a91f662d), {
            key: item.name,
            selected: !!blockchain && blockchain.name === item.name,
            onClick: ()=>onChange(item)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
            src: item.logo,
            size: 30
        })))), onlyOneItemInList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b21157a9f19b41cb$export$70f20e53a91f662d), {
        key: blockchainsList.more[0].name,
        selected: !!blockchain && blockchain.name === blockchainsList.more[0].name,
        onClick: ()=>onChange(blockchainsList.more[0])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fb5d3986dd3d8e79$export$3e431a229df88919), {
        src: blockchainsList.more[0].logo,
        size: 30
    })) : null, showMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b21157a9f19b41cb$export$70f20e53a91f662d), {
        onClick: onMoreClick,
        key: "more-blockchains"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "xsmall",
        color: "secondary500"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168)._("More +{count}", {
        count: blockchainsList.more.length
    }))) : null)));
}












function $0683a7464e2e4cbc$export$1d77075907ff19f4(props) {
    const { type: type } = props;
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const { fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, setFromToken: setFromToken, setToToken: setToToken, setFromBlockchain: setFromBlockchain, setToBlockchain: setToBlockchain } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const getBalanceFor = (0, $41385c7b1441a578$export$63a06538da9383a6).use.getBalanceFor();
    const [searchedFor, setSearchedFor] = (0, $exYeM.useState)("");
    const selectedBlockchain = type === "source" ? fromBlockchain : toBlockchain;
    const selectedBlockchainName = selectedBlockchain?.name ?? "";
    // Tokens & Blockchains list
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains({
        type: type
    });
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens({
        type: type,
        blockchain: selectedBlockchainName,
        searchFor: searchedFor,
        getBalanceFor: getBalanceFor
    });
    const updateBlockchain = (blockchain)=>{
        if (type === "source") setFromBlockchain(blockchain);
        else setToBlockchain(blockchain);
    };
    const updateToken = (token)=>{
        if (type === "source") setFromToken({
            token: token,
            meta: {
                blockchains: blockchains,
                tokens: tokens
            }
        });
        else setToToken({
            token: token,
            meta: {
                blockchains: blockchains,
                tokens: tokens
            }
        });
    };
    const types = {
        source: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Source"),
        destination: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Destination")
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap {type}", {
                type: types[type]
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ad983ea4dc895992$export$4aeb8def13a8b944), {
        blockchains: blockchains,
        type: type == "source" ? "from" : "to",
        blockchain: type === "source" ? fromBlockchain : toBlockchain,
        onMoreClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).blockchains),
        onChange: (blockchain)=>{
            updateBlockchain(blockchain);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 24
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a986a2912425d5f2$export$55d7609a8f1eccd2), {
        value: searchedFor,
        autoFocus: true,
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Search Token"),
        color: "light",
        variant: "contained",
        size: "large",
        setValue: ()=>setSearchedFor(""),
        onChange: (event)=>setSearchedFor(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4bd664e70bf2c5c1$export$24d4785067273813), {
        list: tokens,
        selectedBlockchain: selectedBlockchainName,
        searchedFor: searchedFor,
        type: type,
        onChange: (token)=>{
            updateToken(token);
            const tokenBlockchain = blockchains.find((chain)=>token.blockchain === chain.name);
            if (tokenBlockchain) updateBlockchain(tokenBlockchain);
            navigateBack();
        }
    })));
}





var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");




const $9c34483fdc184f26$export$89c285f228afdc27 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingTop: "$5",
    padding: "$10 $5"
});
const $9c34483fdc184f26$export$24cf50e28641c154 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexWrap: "wrap",
    gap: "$10",
    [`& ${0, $d3217f51ad5e64fb$export$2c73285ae9390cec}`]: {
        flex: "1 1 0",
        maxWidth: "127px",
        minWidth: "85px"
    }
});
const $9c34483fdc184f26$export$e93312b7773dfcac = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    paddingBottom: "$10"
});
const $9c34483fdc184f26$export$5b19a5dd031ecfa = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    maxWidth: "280px",
    padding: "$10"
});
const $9c34483fdc184f26$export$3dc245849826fdb3 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $b8fd588522d703e5$export$5a7f9a6004988d01), {
    width: "61px",
    flexShrink: 0
});





var $exYeM = parcelRequire("exYeM");

function $204e57c347cdec36$export$6923348ff7f94201() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$5b19a5dd031ecfa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "medium",
        color: "neutral700"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Your transaction will be reverted if the price changes unfavorably by more than this percentage."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("b", null, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Warning")), ":\xa0", (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("This setting is applied to each step (e.g. 1Inch, Thorchain, etc.), meaning only that specific step will be reverted, not the entire route.")));
}


function $d35c4366b78e5e46$export$938e26165a502512() {
    const { slippage: slippage, setSlippage: setSlippage, customSlippage: customSlippage, setCustomSlippage: setCustomSlippage } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$89c285f228afdc27), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$e93312b7773dfcac), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $62b65843d6c09f2b$export$2e2bcd8739ae039), {
        size: 16,
        color: "gray"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Slippage tolerance per swap")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        side: "top",
        sideOffset: 4,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $204e57c347cdec36$export$6923348ff7f94201), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $be5f47e94ea1c2a7$export$2e2bcd8739ae039), {
        color: "gray"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$24cf50e28641c154), null, (0, $6eceba59c0c82e59$export$5ec0897e5fd6c2eb).map((slippageItem, index)=>{
        const key = `slippage-${index}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$3dc245849826fdb3), {
            key: key,
            onClick: ()=>{
                if (customSlippage) setCustomSlippage(null);
                setSlippage(slippageItem);
            },
            selected: !customSlippage && slippageItem === slippage,
            label: `${slippageItem.toString()}%`
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d3217f51ad5e64fb$export$2c73285ae9390cec), {
        type: "number",
        min: "0.01",
        max: "30",
        step: "0.01",
        fullWidth: true,
        variant: "contained",
        value: customSlippage === null ? "" : customSlippage,
        color: "dark",
        onChange: (event)=>{
            const value = event.target.value;
            const parsedValue = parseFloat(value);
            if (parsedValue >= (0, $6eceba59c0c82e59$export$c9f588d8d1b5cc3a) && parsedValue <= (0, $6eceba59c0c82e59$export$7f2b1a3579bfd3f3)) setCustomSlippage(parsedValue);
            else setCustomSlippage(null);
        },
        suffix: customSlippage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "small"
        }, "%"),
        placeholder: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Custom")
    })));
}








var $exYeM = parcelRequire("exYeM");



var $af12d4e4dfc49242$export$2db90bef9bd225d6;
(function(ThemeModeEnum) {
    ThemeModeEnum["DARK"] = "dark";
    ThemeModeEnum["LIGHT"] = "light";
    ThemeModeEnum["AUTO"] = "auto";
})($af12d4e4dfc49242$export$2db90bef9bd225d6 || ($af12d4e4dfc49242$export$2db90bef9bd225d6 = {}));






const $3f009ae8b9641f5e$var$ThemeSection = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "202px",
    height: "$40"
});
const $3f009ae8b9641f5e$var$themesList = [
    {
        id: (0, $af12d4e4dfc49242$export$2db90bef9bd225d6).LIGHT,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8533928d7a391c2c$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Light"))
    },
    {
        id: (0, $af12d4e4dfc49242$export$2db90bef9bd225d6).DARK,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $79da6f5c8cc6e6a6$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Dark"))
    },
    {
        id: (0, $af12d4e4dfc49242$export$2db90bef9bd225d6).AUTO,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1d952e059ee297ad$export$2e2bcd8739ae039), {
            color: "black",
            size: 24
        }),
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            size: "xsmall",
            variant: "body"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Auto"))
    }
];
const $3f009ae8b9641f5e$var$getThemeIcon = (theme)=>{
    const iconProps = {
        color: "gray",
        size: 16
    };
    switch(theme){
        case "auto":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1d952e059ee297ad$export$2e2bcd8739ae039), iconProps);
        case "dark":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $79da6f5c8cc6e6a6$export$2e2bcd8739ae039), iconProps);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8533928d7a391c2c$export$2e2bcd8739ae039), iconProps);
    }
};
function $3f009ae8b9641f5e$export$84de30aaa5b56e89() {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const { theme: themeConfig } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().config;
    const { setTheme: setTheme, theme: theme } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { activeLanguage: activeLanguage, languages: languages } = (0, $da3430e16b59e33f$export$c1fd9f444a3dc711)();
    const currentLanguage = languages.find((language)=>language.local === activeLanguage)?.label;
    const fetchStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const disabledLiquiditySources = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().getDisabledLiquiditySources();
    const { config: { features: features } } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const customTokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().customTokens();
    const isThemeHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("theme", features);
    const isLiquidityHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("liquiditySource", features);
    const isLanguageHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("language", features);
    const isCustomTokensHidden = (0, $b64e40f2483e228d$export$82f8135ce57445c2)("customTokens", features);
    const infiniteApprove = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().infiniteApprove;
    const toggleInfiniteApprove = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().toggleInfiniteApprove;
    const supportedUniqueSwappersGroups = (0, $b64e40f2483e228d$export$299798afcc913c30)(swappers, disabledLiquiditySources);
    const bridgeSources = supportedUniqueSwappersGroups.filter((uniqueItem)=>[
            "BRIDGE",
            "AGGREGATOR",
            "OFF_CHAIN"
        ].includes(uniqueItem.type));
    const totalBridgeSources = bridgeSources.length;
    const totalSelectedBridgeSources = bridgeSources.filter((uniqueItem)=>uniqueItem.selected).length;
    const exchangeSources = supportedUniqueSwappersGroups.filter((uniqueItem)=>uniqueItem.type === "DEX");
    const totalExchangeSources = exchangeSources.length;
    const totalSelectedExchangeSources = exchangeSources.filter((uniqueItem)=>uniqueItem.selected).length;
    const handleSwapperEndItem = (totalSelected, total)=>{
        switch(fetchStatus){
            case "loading":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
                    variant: "text",
                    size: "medium",
                    width: 50
                });
            case "failed":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                    variant: "body",
                    size: "medium",
                    color: "$error500"
                }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Loading failed"));
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                    variant: "body",
                    size: "medium"
                }, `${totalSelected} / ${total}`);
        }
    };
    const bridgeItem = {
        id: "widget-setting-bridge-item-btn",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Bridges")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, handleSwapperEndItem(totalSelectedBridgeSources, totalBridgeSources), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
            color: "black"
        })),
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).bridges),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $efb90bfb9b7fd357$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        })
    };
    const exchangeItem = {
        id: "widget-setting-exchange-item-btn",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Exchanges")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, handleSwapperEndItem(totalSelectedExchangeSources, totalExchangeSources), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
            color: "black"
        })),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8f81708c6e49638f$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).exchanges)
    };
    const customTokensItem = {
        id: "widget-setting-custom-tokens-item-btn",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Custom Tokens")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "medium"
        }, `${customTokens.length}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
            color: "black"
        })),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $556a7d2e42a609b4$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).customTokens)
    };
    const languageItem = {
        id: "widget-setting-language-item-btn",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Language")),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $480d64c61a1b53d5$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "body",
            size: "medium"
        }, currentLanguage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 8
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b9c1ebda254eeb8$export$2e2bcd8739ae039), {
            color: "black"
        })),
        onClick: ()=>navigate((0, $415b6399c61cd80f$export$492bdc31a14c4d1).languages)
    };
    const infiniteApprovalItem = {
        id: "widget-setting-infinite-approval-item-btn",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Infinite approval")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
            direction: "horizontal",
            size: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
            side: "top",
            sideOffset: 4,
            container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9c34483fdc184f26$export$5b19a5dd031ecfa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                variant: "label",
                size: "medium",
                color: "neutral700"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("b", null, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Warning")), ":\xa0", (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Enabling the 'Infinite approval' mode grants unrestricted access to underlying smart contracts, allowing them to utilize the approved token amount without limitations.")))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $be5f47e94ea1c2a7$export$2e2bcd8739ae039), {
            color: "gray"
        }))),
        start: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $38a65c022741f4d2$export$2e2bcd8739ae039), {
            color: "gray",
            size: 16
        }),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $443aba4fa02f39df$export$b5d5cf8927ab7262), {
            checked: infiniteApprove
        }),
        onClick: toggleInfiniteApprove
    };
    const themeItem = {
        id: "widget-setting-theme-item-btn",
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $41f02fa281174231$export$a7b06bfba60a8a78), null),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
            variant: "title",
            size: "xmedium"
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Theme")),
        end: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($3f009ae8b9641f5e$var$ThemeSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $838c21fc3959a414$export$fb3aab15d866de8f), {
            container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
            items: $3f009ae8b9641f5e$var$themesList,
            value: theme,
            onChange: (item)=>setTheme(item.id),
            type: "primary",
            borderRadius: "small"
        })),
        start: $3f009ae8b9641f5e$var$getThemeIcon(theme)
    };
    const settingItems = isLiquidityHidden ? [] : [
        bridgeItem,
        exchangeItem
    ];
    if (!isCustomTokensHidden) settingItems.push(customTokensItem);
    if (!isLanguageHidden) settingItems.push(languageItem);
    settingItems.push(infiniteApprovalItem);
    if (!themeConfig?.singleTheme && !isThemeHidden) settingItems.push(themeItem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3eba68bfb6488b0a$export$54c2e3dc7acea9f5), {
        type: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $59d17099a29b7c86$export$b3f67a2d87d5d23e), {
            hasDivider: true,
            id: "_",
            onClick: ()=>console.log()
        }),
        items: settingItems
    });
}



const $43da3e715fe1b938$var$ResetAction = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    paddingLeft: "$8"
});
function $43da3e715fe1b938$export$8f6dcfe950367406() {
    const { isInCampaignMode: isInCampaignMode, updateCampaignMode: updateCampaignMode } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const campaignMode = isInCampaignMode();
    const [, setSearchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const isRouterInContext = (0, $b0e6fcd50b7ef685$export$9c954a9d03d32f4a)();
    const onClick = ()=>{
        if (isRouterInContext && campaignMode) {
            setSearchParams((prev)=>{
                prev.delete((0, $ac85cc6f6f867f4c$export$1e1d235314148489).LIQUIDITY_SOURCES);
                return prev;
            }, {
                replace: true
            });
            updateCampaignMode("liquiditySources", undefined);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Settings")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), null, campaignMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "info",
        variant: "alarm",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Currently, you're in campaign mode with restrictions on liquidity sources. Would you like to switch out of this mode and make use of all available liquidity sources?"),
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($43da3e715fe1b938$var$ResetAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-setting-exit-campaign-mode-btn",
            type: "secondary",
            size: "small",
            onClick: onClick
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Reset")))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d35c4366b78e5e46$export$938e26165a502512), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $3f009ae8b9641f5e$export$84de30aaa5b56e89), null)));
}







var $exYeM = parcelRequire("exYeM");






var $76r4H = parcelRequire("76r4H");
parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");

var $exYeM = parcelRequire("exYeM");












const $b1fe47b696740fbd$var$daysOfWeek = [
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Sunday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Monday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Tuesday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Wednesday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Thursday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Friday"),
    (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Saturday")
];
function $b1fe47b696740fbd$export$79c01495e306fbf5(millisecond) {
    const date = new Date(millisecond);
    const day = date.getDate();
    const month = date.toLocaleString("default", {
        month: "long"
    });
    const year = date.getFullYear();
    const isToday = date.getDay() === new Date().getDay();
    const formattedDate = isToday ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Today") : `${$b1fe47b696740fbd$var$daysOfWeek[date.getDay()]} ${day} ${month} ${year}`;
    return `${formattedDate}, ${new Date(millisecond).toLocaleTimeString()}`;
}
function $b1fe47b696740fbd$export$1bb100e9526c4aa5(pendingSwap) {
    const time = pendingSwap.finishTime ? $b1fe47b696740fbd$export$79c01495e306fbf5(parseInt(pendingSwap.finishTime)) : $b1fe47b696740fbd$export$79c01495e306fbf5(parseInt(pendingSwap.creationTime));
    return time;
}






parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");

var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");
const $febb7722f9040266$export$345aec9bf820993c = ({ onCancel: onCancel, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Cancel Swap"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Are you sure you want to cancel this swap?")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        variant: "contained",
        id: "widget-swap-details-modal-cancel-swap-yes-btn",
        type: "primary",
        size: "large",
        onClick: onCancel
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Yes, Cancel it")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-swap-details-modal-cancel-swap-no-btn",
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No, Continue")));
};





var $exYeM = parcelRequire("exYeM");
const $8ead22e4c9c66a47$export$bceefbc2c0681c56 = ({ onDelete: onDelete, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Delete Transaction"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Are you sure you want to delete this swap?")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-swap-details-modal-delete-swap-yes-btn",
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: onDelete
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Yes, Delete it")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-swap-details-modal-delete-swap-no-btn",
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "primary"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("No, Cancel"))));
};



parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");
const $b4d3e7ac0e33f6c7$export$dee0912d3648abce = {
    [(0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange]: {
        type: "loading",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Change Network")
    },
    [(0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet]: {
        type: "warning",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect Wallet")
    },
    [(0, $aQzGx.PendingSwapNetworkStatus).NetworkChanged]: {
        type: "success",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Network Changed")
    }
};






var $exYeM = parcelRequire("exYeM");





const $cc3b91741e9b0d0c$export$d054c659ec406a12 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center"
});
const $cc3b91741e9b0d0c$export$fbdc105b5fcad188 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    maxWidth: 280,
    "& ._typography": {
        wordWrap: "break-word",
        display: "block"
    }
});


const $1418a62e7aaac705$export$f4ca91e11faab022 = (props)=>{
    const { type: type, title: title, currentStepWallet: currentStepWallet, message: message, showWalletButton: showWalletButton, walletButtonDisabled: walletButtonDisabled } = props;
    const [selectedWalletToConnect, setSelectedWalletToConnect] = (0, $exYeM.useState)();
    const { getWalletInfo: getWalletInfo, state: state } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const walletType = currentStepWallet?.walletType;
    const walletState = walletType ? (0, $b27897cbc1e94793$export$6907ce8795f5a4df)(state(walletType)) : null;
    const walletInfo = walletType ? getWalletInfo(walletType) : null;
    const shouldShowWallet = showWalletButton && !!walletType && !!walletState && !!walletInfo;
    const { list: list } = (0, $054d9182f00d4104$export$8c7712426fcad4df)();
    const handleWalletItemClick = ()=>{
        if (!!walletType) {
            const wallet = list.find((wallet)=>wallet.type === walletType);
            if (wallet) setSelectedWalletToConnect(wallet);
            else (0, $2d0ef42914e3f734$export$c106dd0671a0fc2d)(new Error(`It seems requested wallet to be connected is not available in the list. requested wallet: ${wallet}`));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: type,
        title: title,
        description: message
    }), shouldShowWallet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $cc3b91741e9b0d0c$export$d054c659ec406a12), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b7ad2cfc9fe1d9ac$export$2e2bcd8739ae039), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        title: walletInfo.name,
        image: walletInfo.img,
        type: walletType,
        state: walletState,
        link: walletInfo.installLink,
        disabled: walletButtonDisabled,
        // TODO we need to show an error modal when user reject the connection
        onClick: handleWalletItemClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a533ccd38320000a$export$7710cdf1210cd2fb), {
        wallet: selectedWalletToConnect,
        onClose: ()=>{
            setSelectedWalletToConnect(undefined);
        }
    }));
};


function $8642584b36506129$export$cf55976545e981b5(props) {
    const { state: state, onClose: onClose, onDelete: onDelete, onCancel: onCancel, currentStepWallet: currentStepWallet, message: message, walletButtonDisabled: walletButtonDisabled } = props;
    const showWalletStateContent = state === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange || state === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet || state === (0, $aQzGx.PendingSwapNetworkStatus).NetworkChanged;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: !!state,
        onClose: onClose,
        container: document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID) || document.body
    }, showWalletStateContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1418a62e7aaac705$export$f4ca91e11faab022), {
        type: (0, $b4d3e7ac0e33f6c7$export$dee0912d3648abce)[state].type,
        title: (0, $b4d3e7ac0e33f6c7$export$dee0912d3648abce)[state].title,
        currentStepWallet: currentStepWallet,
        message: message,
        walletButtonDisabled: walletButtonDisabled,
        showWalletButton: state !== (0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange
    }), state === "delete" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8ead22e4c9c66a47$export$bceefbc2c0681c56), {
        onClose: onClose,
        onDelete: onDelete
    }), state === "cancel" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $febb7722f9040266$export$345aec9bf820993c), {
        onClose: onClose,
        onCancel: onCancel
    }));
}





var $exYeM = parcelRequire("exYeM");




function $a9660b2807aedbcf$export$3a6293ed33167cb8(props) {
    const { open: open, onClose: onClose, status: status, priceValue: priceValue, usdValue: usdValue, realUsdValue: realUsdValue, realValue: realValue, token: token, chain: chain, percentageChange: percentageChange, description: description, diagnosisUrl: diagnosisUrl } = props;
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $95851a689b855275$export$c5f1eb137838e890), {
        open: open,
        onClose: onClose,
        container: document.getElementById((0, $81cb43aa4aa5ed51$export$e701ab3081df299).SWAP_BOX_ID) || document.body
    }, status === "success" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "success",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap Successful")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $66a5c1820d80e5ba$export$b642c5d9b327de62), {
        direction: "vertical",
        tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        type: "output",
        centerAlign: true,
        price: {
            value: priceValue,
            usdValue: usdValue,
            realUsdValue: realUsdValue,
            realValue: realValue
        },
        token: token,
        chain: chain,
        percentageChange: percentageChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium",
        color: "neutral700",
        align: "center"
    }, description)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $067048c05c356dc5$export$52499e2c5ea4b095), {
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Transaction Failed"),
        description: description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 32
    }), status === "success" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-swap-details-modal-done-btn",
        variant: "contained",
        type: "primary",
        size: "large",
        onClick: ()=>{
            const home = "../../";
            navigate(home);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "neutral100"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Done"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    }), diagnosisUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        variant: "contained",
        id: "widget-swap-detail-modal-diagnosis-btn",
        type: "primary",
        size: "large",
        onClick: ()=>window.open(diagnosisUrl, "_blank")
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Diagnosis")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 12
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
        id: "widget-swap-details-modal-see-details-btn",
        variant: "outlined",
        type: "primary",
        size: "large",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "medium",
        color: "primary"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("See Details"))));
}





var $exYeM = parcelRequire("exYeM");







var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");


const $d21f2e3a004e3ac0$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden"
});
const $d21f2e3a004e3ac0$export$de1f3500221e9400 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    "& ._icon-button": {
        "&:hover": {
            "& svg": {
                color: "$secondary550",
                [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
                    color: "$secondary500"
                }
            }
        }
    }
});
const $d21f2e3a004e3ac0$export$f0bfe728a2277c47 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $fd737d69d3de4ef4$export$83c3fa3ac4f31acf), {
    padding: "$0 $20 $20 $20"
});
const $d21f2e3a004e3ac0$export$7a76bf180c86084f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$10"
});
const $d21f2e3a004e3ac0$export$5127577766e232fc = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    height: "450px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $d21f2e3a004e3ac0$export$8f67d857ad88efa0 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    paddingTop: "33%",
    flex: 1
});
const $d21f2e3a004e3ac0$export$a3abe124fc948fcd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$10 $20",
    borderBottom: "1px solid",
    $$color: "$colors$neutral300",
    [`.${0, $3dd421da623820a3$export$3e936a8db52a10a0} &`]: {
        $$color: "$colors$neutral400"
    },
    borderColor: "$$color",
    color: "$neutral500"
});
const $d21f2e3a004e3ac0$export$4866c913ca4197c1 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    padding: "$5 0"
});
const $d21f2e3a004e3ac0$export$754fee9f6f8b3515 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "$24"
});
const $d21f2e3a004e3ac0$export$3f5791985792ee7e = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    width: "100%",
    padding: "$15 $20 $20",
    flexDirection: "column",
    alignItems: "start"
});
const $d21f2e3a004e3ac0$export$4899c272a91daec2 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "100%",
    padding: "0 $20 $10"
});
const $d21f2e3a004e3ac0$export$9048d548939551ee = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("a", {
    fontSize: "$16",
    fontWeight: "$400",
    color: "$neutral700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $d21f2e3a004e3ac0$export$6586c12bbf6d0c20 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$5"
});
const $d21f2e3a004e3ac0$export$9490da692ad51d2e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
    wordBreak: "break-word"
});



const $357524ebf0187f16$export$7a76bf180c86084f = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "$10"
});
const $357524ebf0187f16$export$c8e5c1392561c508 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    transition: "transform 0.3s ease-in-out",
    variants: {
        rotated: {
            true: {
                transform: "rotate(180deg)"
            }
        }
    }
});
const $357524ebf0187f16$export$9f4c9972b81a5196 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    transition: "max-height 0.3s ease-in-out",
    maxHeight: "0px",
    overflow: "hidden",
    variants: {
        open: {
            true: {
                maxHeight: "200px"
            }
        }
    }
});


function $bff33e742226e21c$export$431e7dc2182c6e11(props) {
    const { message: message } = props;
    const [showContentError, setShowContentError] = (0, $exYeM.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "error",
        title: message.shortMessage,
        containerStyles: {
            "& .footer": {
                paddingTop: "$0"
            }
        },
        action: message.detailedMessage.content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
            onClick: ()=>setShowContentError((prev)=>!prev),
            variant: "ghost",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $357524ebf0187f16$export$c8e5c1392561c508), {
            rotated: showContentError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $649ad8aca28bbcee$export$2e2bcd8739ae039), {
            size: 12,
            color: "gray"
        }))),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $357524ebf0187f16$export$9f4c9972b81a5196), {
            open: showContentError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$9490da692ad51d2e), {
            variant: "body",
            size: "xsmall",
            color: "neutral700"
        }, message.detailedMessage.content))
    });
}





parcelRequire("14sfz");
var $aQzGx = parcelRequire("aQzGx");

var $exYeM = parcelRequire("exYeM");
function $deb7b097f366981f$export$ee91ffc7d60a66d(props) {
    const { switchNetwork: switchNetwork, setNetworkModal: setNetworkModal, message: message, showNetworkModal: showNetworkModal } = props;
    if (!!switchNetwork) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage,
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-swap-details-warning-alert-change-network-btn",
            size: "xxsmall",
            type: "warning",
            onClick: ()=>{
                setNetworkModal((0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange);
                switchNetwork().catch((e)=>{
                    console.log(e);
                });
            }
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Change"))
    });
    if (showNetworkModal === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage,
        action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            id: "widget-swap-details-warning-alert-connect-wallet-btn",
            size: "xxsmall",
            type: "warning",
            onClick: ()=>{
                setNetworkModal((0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet);
            }
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect"))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "warning",
        title: message.shortMessage
    });
}


function $bf861b1b763f6a9e$export$34b5e0f1a85de840(props) {
    const { switchNetwork: switchNetwork, showNetworkModal: showNetworkModal, setNetworkModal: setNetworkModal, message: message, step: step, hasAlreadyProceededToSign: hasAlreadyProceededToSign } = props;
    const hasWarning = (0, $8e9d7744e1038276$export$69e0fdd2c54a443b)(step);
    const waitingForApproval = step.status === "waitingForApproval" && !hasWarning;
    const inProgress = step.status === "running" && !hasWarning;
    const waitingProgress = inProgress && !hasAlreadyProceededToSign || waitingForApproval && !step.explorerUrl?.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $357524ebf0187f16$export$7a76bf180c86084f), null, step.explorerUrl?.map((explorerUrl, index, urls)=>{
        const key = index + explorerUrl.url;
        const lastUrl = index === urls.length - 1;
        const loading = (lastUrl && inProgress || waitingForApproval) && !waitingProgress;
        const error = lastUrl && step.status === "failed";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $exYeM.Fragment), {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
            type: lastUrl ? loading && "loading" || error && "error" || "success" : "success",
            title: !explorerUrl.description ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("View transaction") : `${explorerUrl.description} Tx`,
            action: explorerUrl.url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
                id: "widget-swap-details-tx-link-icon-btn",
                variant: "ghost",
                size: "xsmall",
                onClick: ()=>window.open(explorerUrl.url, "_blank")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dc0aa3760240d972$export$2e2bcd8739ae039), {
                size: 12
            }))
        }));
    }), waitingProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        type: "loading",
        title: message.shortMessage
    }), step.status !== "failed" && hasWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $deb7b097f366981f$export$ee91ffc7d60a66d), {
        switchNetwork: switchNetwork,
        showNetworkModal: showNetworkModal,
        setNetworkModal: setNetworkModal,
        message: message
    }), step.status === "failed" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bff33e742226e21c$export$431e7dc2182c6e11), {
        message: message
    }));
}




const $0e12715a8888ef07$export$29e461c3d10d7405 = 2000;
const $0e12715a8888ef07$export$8fa5d88ee8e453e2 = 60;
const $0e12715a8888ef07$export$1012b332cad0397b = ({ swap: swap, blockchains: blockchains, swappers: swappers, ...args })=>{
    const hasAlreadyProceededToSign = swap.hasAlreadyProceededToSign !== false;
    return swap.steps.map((step, index)=>{
        const amountToConvert = index === 0 ? swap.inputAmount : swap.steps[index - 1].outputAmount || swap.steps[index - 1].expectedOutputAmountHumanReadable;
        return {
            from: {
                token: {
                    displayName: step.fromSymbol,
                    image: step.fromLogo ?? ""
                },
                chain: {
                    displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(step.fromBlockchain, blockchains) ?? "",
                    image: step.fromBlockchainLogo ?? ""
                },
                price: {
                    value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(amountToConvert, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                    realValue: amountToConvert ?? ""
                }
            },
            to: {
                token: {
                    displayName: step.toSymbol,
                    image: step.toLogo
                },
                chain: {
                    displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(step.toBlockchain, blockchains) ?? "",
                    image: step.toBlockchainLogo ?? ""
                },
                price: {
                    value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(step.outputAmount || step.expectedOutputAmountHumanReadable, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                    realValue: step.outputAmount || step.expectedOutputAmountHumanReadable || ""
                }
            },
            swapper: {
                displayName: (0, $76ee130e8dc1847d$export$1fea59066bd06abd)(step.swapperId, swappers) ?? "",
                image: step.swapperLogo ?? "",
                type: step.swapperType
            },
            internalSwaps: step.internalSwaps ? step.internalSwaps.map((internalSwap)=>{
                return {
                    from: {
                        chain: {
                            displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(internalSwap.fromBlockchain, blockchains) ?? "",
                            image: internalSwap.fromBlockchainLogo ?? ""
                        }
                    },
                    to: {
                        chain: {
                            displayName: (0, $76ee130e8dc1847d$export$88c49d2c18237b4a)(internalSwap.toBlockchain, blockchains) ?? "",
                            image: internalSwap.toBlockchainLogo ?? ""
                        }
                    },
                    swapper: {
                        displayName: (0, $76ee130e8dc1847d$export$1fea59066bd06abd)(internalSwap.swapperId, swappers) ?? "",
                        image: internalSwap.swapperLogo ?? "",
                        type: internalSwap.swapperType
                    }
                };
            }) : [],
            alerts: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $bf861b1b763f6a9e$export$34b5e0f1a85de840), {
                step: step,
                hasAlreadyProceededToSign: hasAlreadyProceededToSign,
                ...args
            })
        };
    });
};
function $0e12715a8888ef07$export$b0d5540f068e7e9e(step) {
    if ((0, $8e9d7744e1038276$export$69e0fdd2c54a443b)(step) && step.status !== "failed" && step.status !== "success") return "warning";
    switch(step.status){
        case "created":
            return "default";
        case "approved":
        case "waitingForApproval":
        case "running":
            return "in-progress";
        case "failed":
            return "error";
        case "success":
            return "completed";
    }
}



function $970b1e37ca0118a1$export$c2a945e084c93396(props) {
    const { swap: swap, requestId: requestId, onDelete: onDelete, onCancel: onCancelProps } = props;
    const { canSwitchNetworkTo: canSwitchNetworkTo, connect: connect, getWalletInfo: getWalletInfo } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const retry = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.retry();
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [isCopied, handleCopy] = (0, $32beb9a5973b277f$export$b2199c37e85de4a7)((0, $0e12715a8888ef07$export$29e461c3d10d7405));
    const listRef = (0, $exYeM.useRef)(null);
    const [modalState, setModalState] = (0, $exYeM.useState)(null);
    const [showCompletedModal, setShowCompletedModal] = (0, $exYeM.useState)(null);
    const onCancel = ()=>{
        onCancelProps();
        setModalState(null);
    };
    const getNotifications = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).use.getNotifications();
    const removeNotification = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).use.removeNotification();
    const notifications = getNotifications();
    const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
    const currentStepNetworkStatus = currentStep?.networkStatus;
    (0, $exYeM.useEffect)(()=>{
        const existNotification = notifications.find((n)=>n.requestId === swap.requestId);
        if (existNotification) {
            if (swap.status === "success" || swap.status === "failed") {
                setShowCompletedModal(swap.status);
                removeNotification(swap.requestId);
            } else if (showCompletedModal) setShowCompletedModal(null);
        }
    }, [
        swap.status,
        swap.requestId
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (showSwitchNetwork) setModalState((0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange);
        else if (currentStepNetworkStatus === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForConnectingWallet || currentStepNetworkStatus === (0, $aQzGx.PendingSwapNetworkStatus).NetworkChanged) setModalState(currentStepNetworkStatus);
        else setModalState(null);
    }, [
        currentStepNetworkStatus
    ]);
    const lastConvertedTokenInFailedSwap = (0, $8e9d7744e1038276$export$855612345450ce78)(swap);
    const currentStepBlockchain = currentStep ? (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, currentStep) : null;
    const currentStepWallet = currentStep ? (0, $f3ce3db9d10c7efd$export$5be79e3cb2436f0b)(swap, currentStep) : null;
    const swapDate = (0, $b1fe47b696740fbd$export$1bb100e9526c4aa5)(swap);
    const shouldRetry = (0, $8e9d7744e1038276$export$971830c6ceef0cca)(swap);
    const isMobileWallet = (walletType)=>!!getWalletInfo(walletType)?.mobileWallet;
    const showSwitchNetwork = currentStepNetworkStatus === (0, $aQzGx.PendingSwapNetworkStatus).WaitingForNetworkChange && !!currentStepBlockchain && !!currentStepWallet?.walletType && (isMobileWallet(currentStepWallet.walletType) || canSwitchNetworkTo(currentStepWallet.walletType, currentStepBlockchain));
    const switchNetwork = showSwitchNetwork ? connect.bind(null, currentStepWallet.walletType, currentStepBlockchain) : undefined;
    const stepMessage = (0, $8e9d7744e1038276$export$49d192cd6c2bb4ab)(swap, currentStep);
    const steps = (0, $0e12715a8888ef07$export$1012b332cad0397b)({
        swap: swap,
        switchNetwork: switchNetwork,
        showNetworkModal: currentStepNetworkStatus,
        setNetworkModal: setModalState,
        message: stepMessage,
        blockchains: blockchains,
        swappers: swappers
    });
    const numberOfSteps = steps.length;
    const [firstStep, lastStep] = [
        swap.steps[0],
        swap.steps[numberOfSteps - 1]
    ];
    const outputAmount = lastStep.outputAmount || lastStep.expectedOutputAmountHumanReadable;
    const totalFee = swap.steps.reduce((totalFee, steps)=>totalFee + parseFloat(steps.feeInUsd || ""), 0);
    const diagnosisUrl = swap.steps.find((step)=>step.diagnosisUrl)?.diagnosisUrl;
    const outputUsdValue = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(parseFloat(outputAmount || "0") * (lastStep.toUsdPrice || 0), (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061));
    const inputUsdValue = (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(parseFloat(swap.inputAmount) * (firstStep.fromUsdPrice || 0), (0, $189a5d7f52888885$export$40c7c9ebb925aa59), (0, $189a5d7f52888885$export$b95c92fdaeee061));
    const realOutputUsdValue = outputAmount ? new (0, $76r4H.default)(outputAmount).multipliedBy(lastStep.toUsdPrice || 0).toString() : "";
    const realInputUsdValue = new (0, $76r4H.default)(swap.inputAmount).multipliedBy(firstStep.fromUsdPrice || 0).toString();
    const percentageChange = (0, $aae90cdd39be0d29$export$3cad4d44dd01c178)(inputUsdValue, outputUsdValue);
    const stepDetailMessage = stepMessage.detailedMessage.content || stepMessage.shortMessage;
    const completeModalDesc = swap.status === "success" ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
        id: "You have received {amount} {token} in {conciseAddress} wallet on {chain} chain.",
        values: {
            amount: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(outputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
            token: steps[numberOfSteps - 1].to.token.displayName,
            conciseAddress: (0, $b27897cbc1e94793$export$ebc397f3c3118f9b)(swap.wallets[steps[numberOfSteps - 1].to.chain.displayName]?.address || ""),
            chain: steps[numberOfSteps - 1].to.chain.displayName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$6586c12bbf6d0c20), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "body",
        size: "medium",
        color: "neutral700",
        align: "center"
    }, !stepDetailMessage ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Transaction was not sent.") : "", lastConvertedTokenInFailedSwap ? `${(0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
        id: "{amount} {symbol} on {blockchain} remains in your wallet.",
        values: {
            amount: lastConvertedTokenInFailedSwap.outputAmount,
            symbol: lastConvertedTokenInFailedSwap.symbol,
            blockchain: lastConvertedTokenInFailedSwap.blockchain
        }
    })}` : ""), stepDetailMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$9490da692ad51d2e), {
        align: "center",
        variant: "body",
        size: "medium",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("b", null, "Reason:"), " ", stepDetailMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap Details"),
            onCancel: swap.status === "running" ? ()=>setModalState("cancel") : undefined,
            suffix: swap.status !== "running" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$9baf379cdbf61443), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
                id: "widget-swap-details-delete-btn",
                variant: "ghost",
                type: "error",
                size: "xsmall",
                onClick: ()=>setModalState("delete")
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
                size: "medium",
                variant: "label",
                color: "error"
            }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Delete"))))
        },
        footer: shouldRetry && !showCompletedModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $78c4dd382a7fe326$export$353f5b6fc5456de1), {
            fullWidth: true,
            id: "widget-swap-details-try-again-btn",
            variant: "contained",
            type: "primary",
            size: "large",
            onClick: ()=>{
                const swapInput = (0, $aae90cdd39be0d29$export$ba2af798efa32d0b)(swap, blockchains, findToken);
                retry(swapInput);
                setTimeout(()=>{
                    const home = "../../";
                    navigate(home);
                }, 0);
            }
        }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Try again"))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), {
        compact: true,
        view: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$de1f3500221e9400), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, `${(0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Request ID")}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$754fee9f6f8b3515)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, requestId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        content: isCopied ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Copied To Clipboard") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Copy Request ID"),
        open: isCopied || undefined,
        side: "bottom",
        alignOffset: -16,
        align: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4c39613e9fff7ff6$export$c25acd513dcc8062), {
        id: "widget-swap-details-done-copy-icon-btn",
        variant: "ghost",
        onClick: handleCopy.bind(null, requestId || "")
    }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5815e032006c952c$export$2e2bcd8739ae039), {
        size: 16,
        color: "secondary"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b4453245b5271f9c$export$2e2bcd8739ae039), {
        size: 16,
        color: "gray"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$9048d548939551ee), {
        target: "_blank",
        href: `${(0, $81cb43aa4aa5ed51$export$be3862c5a1fc6346)}/swap/${requestId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $273666b35d34bd80$export$28c660c63b792dea), {
        container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
        content: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("View on Rango Explorer"),
        side: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $abc70174b8494ed5$export$2e2bcd8739ae039), {
        size: 20
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, swap.finishTime ? (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Finished at") : (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Created at")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, swapDate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$3f5791985792ee7e)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d1d7703f2e2f8b84$export$9f6f00ee434c7351), {
        fee: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(String(totalFee), (0, $189a5d7f52888885$export$2c13d6fe7cdf779a), (0, $189a5d7f52888885$export$d6d8c6e2c799e13f)),
        time: (0, $63fc48ac3256c035$export$448e1c9b3b4c9054)((0, $63fc48ac3256c035$export$b325637b88286521)(swap.steps)),
        steps: numberOfSteps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $43e9a31a1f3ab960$export$e3e8fd41e398c095), {
        from: {
            price: {
                value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(swap.inputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                usdValue: inputUsdValue,
                realUsdValue: realInputUsdValue,
                realValue: swap.inputAmount
            },
            token: {
                displayName: steps[0].from.token.displayName,
                image: steps[0].from.token.image
            },
            chain: {
                image: steps[0].from.chain.image,
                displayName: steps[0].from.chain.displayName
            }
        },
        to: {
            price: {
                value: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(outputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
                usdValue: outputUsdValue,
                realUsdValue: realOutputUsdValue,
                realValue: outputAmount || ""
            },
            token: {
                displayName: steps[numberOfSteps - 1].to.token.displayName,
                image: steps[numberOfSteps - 1].to.token.image
            },
            chain: {
                image: steps[numberOfSteps - 1].to.chain.image,
                displayName: steps[numberOfSteps - 1].to.chain.displayName
            }
        },
        percentageChange: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(percentageChange, (0, $189a5d7f52888885$export$14448384d530389b), (0, $189a5d7f52888885$export$9ec1967a1af30315)),
        warningLevel: (0, $aae90cdd39be0d29$export$161668da75c421a0)(percentageChange ?? 0)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$4899c272a91daec2)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swaps steps"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$f0bfe728a2277c47), {
        ref: listRef
    }, steps.map((step, index)=>{
        const key = index;
        const state = (0, $0e12715a8888ef07$export$b0d5540f068e7e9e)(swap.steps[index]);
        const isFocused = state === "error" || state === "in-progress" || state === "warning" || state === "completed" && index === steps.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6c6be03ec54b75f1$export$bb03d422d1792782), {
            key: key,
            step: step,
            type: "swap-progress",
            ref: listRef,
            state: state,
            hasSeparator: index !== 0,
            tabIndex: key,
            isFocused: isFocused,
            tooltipContainer: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)()
        });
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8642584b36506129$export$cf55976545e981b5), {
        state: modalState,
        onClose: ()=>setModalState(null),
        onCancel: onCancel,
        onDelete: onDelete,
        message: stepMessage.detailedMessage.content,
        currentStepWallet: currentStepWallet,
        walletButtonDisabled: !isActiveTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a9660b2807aedbcf$export$3a6293ed33167cb8), {
        open: !!showCompletedModal,
        diagnosisUrl: diagnosisUrl,
        onClose: ()=>setShowCompletedModal(null),
        status: swap.status === "success" ? "success" : "failed",
        priceValue: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(outputAmount, (0, $189a5d7f52888885$export$ef691c67d4b820e1), (0, $189a5d7f52888885$export$67f38c76b6d12b6f)),
        usdValue: outputUsdValue,
        realUsdValue: realOutputUsdValue,
        realValue: outputAmount || "",
        percentageChange: (0, $63fc48ac3256c035$export$f67be9d9b0e25d7b)(percentageChange, (0, $189a5d7f52888885$export$14448384d530389b), (0, $189a5d7f52888885$export$9ec1967a1af30315)),
        token: {
            displayName: steps[numberOfSteps - 1].to.token.displayName,
            image: steps[numberOfSteps - 1].to.token.image
        },
        chain: {
            image: steps[numberOfSteps - 1].to.chain.image
        },
        description: completeModalDesc
    }));
}







var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");


const $693abe1f94372ba2$export$42a852a2b6b56249 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "100%",
    height: "100%",
    padding: "$10 $20"
});
const $693abe1f94372ba2$export$5f3565be0afe38e4 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    backgroundColor: "$neutral100",
    borderRadius: "$xm",
    padding: "$10 $15"
});
const $693abe1f94372ba2$export$1beef6af864ce77e = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    width: "0px",
    height: "$20",
    borderLeft: "1px dashed $neutral700",
    marginLeft: "25px"
});
const $693abe1f94372ba2$export$b70e978db50b0b3e = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $693abe1f94372ba2$export$2b7c32f103496492 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $693abe1f94372ba2$export$6e57971e38a2fb84 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    paddingTop: "$15",
    display: "flex"
});
const $693abe1f94372ba2$export$1674906ec94119ca = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    padding: "$15 $0"
});
const $693abe1f94372ba2$export$9f52b23ac1c5e029 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    width: "0px",
    height: "$16",
    borderLeft: "1px solid $neutral400",
    marginLeft: "13px"
});
const $693abe1f94372ba2$export$6b90e26a29a8fff9 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    paddingBottom: "$10"
});
const $693abe1f94372ba2$export$8465164c5cd8d19e = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center"
});
const $693abe1f94372ba2$export$bb028af75b9cf876 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    paddingTop: "$5",
    display: "flex",
    alignItems: "center"
});
const $693abe1f94372ba2$export$9414bbab41d375fd = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    alignItems: "center"
});
const $693abe1f94372ba2$export$3c9e1afeb803adf1 = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    padding: "$4 $6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $693abe1f94372ba2$export$bacdaee3974cc26e = (0, $3dd421da623820a3$export$dbf350e5966cf602)({
    display: "flex",
    paddingTop: "$10",
    paddingBottom: "$5"
});


function $5ea7883a729c3432$export$72a01500d5589ed8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ceaf65f2f049df7a$export$a675a97e32cdba21), {
        type: "swap-preview"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: "swaps-steps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "small"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swaps steps"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), {
        separator: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $693abe1f94372ba2$export$bacdaee3974cc26e)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        height: 22,
        variant: "rectangular"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), {
        separator: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), {
        separator: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$1beef6af864ce77e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $693abe1f94372ba2$export$5f3565be0afe38e4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7078bbec44c00800$export$93cb3e391e45e2dc), {
        separator: false
    }))));
}





function $753bdd41d956cb56$export$76f4376499a6b585(props) {
    const { requestId: requestId, showSkeleton: showSkeleton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Swap Details"),
            suffix: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $7313e18cfe57bf45$export$9baf379cdbf61443), null)
        }
    }, showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$42a852a2b6b56249), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$de1f3500221e9400), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "large",
        color: "neutral700"
    }, `${(0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Request ID")}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$754fee9f6f8b3515)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 16,
        height: 16,
        variant: "rectangular"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        direction: "horizontal",
        size: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 16,
        height: 16,
        variant: "rectangular"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $d21f2e3a004e3ac0$export$a3abe124fc948fcd)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        className: (0, $d21f2e3a004e3ac0$export$4866c913ca4197c1)(),
        variant: "label",
        size: "large",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "label",
        size: "small",
        color: "neutral700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $adacf710924c9926$export$8f31e4c4a37b8e9c), {
        width: 60,
        height: 10,
        variant: "rounded"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5ea7883a729c3432$export$72a01500d5589ed8), null)), !showSkeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d21f2e3a004e3ac0$export$5127577766e232fc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11870f864492f7ce$export$271f9f08425019c7), {
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Not found"),
        description: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t({
            id: "Swap with request ID = {requestId} not found.",
            values: {
                requestId: requestId
            }
        })
    })));
}





function $4295bb0c1992ead0$export$232b752ed416656f() {
    const { manager: manager, state: state } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const loading = !state.loadedFromPersistor;
    const pendingSwaps = (0, $cd356c8939bca632$export$e57dfc82f316498a)(manager);
    const { requestId: requestId } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const navigateBack = (0, $44b8318ef6fb2100$export$7ce1f551d78f9130)();
    const { fetchStatus: fetchMetaStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    if (!requestId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $23aba6742c98cdf0$export$caec2af78bcc877f), {
        containerStyles: {
            margin: "20px"
        },
        type: "error",
        title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("The request ID is necessary to display the swap details.")
    });
    const showSkeleton = loading || fetchMetaStatus === "loading";
    const selectedSwap = requestId ? pendingSwaps.find(({ swap: swap })=>swap.requestId === requestId) : undefined;
    const onCancel = ()=>{
        if (selectedSwap?.id) {
            const swap = manager?.get(selectedSwap.id);
            if (swap) (0, $45075b780ed6e88c$export$c778f9ff5514f6d7)(swap);
        }
    };
    const onDelete = async ()=>{
        if (selectedSwap?.id) try {
            manager?.deleteQueue(selectedSwap.id);
            navigateBack();
        } catch (e) {
            console.log(e);
        }
    };
    const swap = selectedSwap?.swap;
    if (!swap || showSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $753bdd41d956cb56$export$76f4376499a6b585), {
        requestId: requestId,
        showSkeleton: showSkeleton
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $970b1e37ca0118a1$export$c2a945e084c93396), {
        swap: swap,
        requestId: requestId,
        onCancel: onCancel,
        onDelete: onDelete
    });
}





var $exYeM = parcelRequire("exYeM");







const $11da4dc66b076be0$var$ListContainer = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "$10",
    flexWrap: "wrap",
    paddingTop: "$5"
});
const $11da4dc66b076be0$var$Container = (0, $3dd421da623820a3$export$3817b7a54a07cec7)((0, $6c5bde2e3b92044e$export$5f86df0ee0a255b5), {
    textAlign: "center"
});
function $11da4dc66b076be0$export$ab40521368a1ca64() {
    const { fetchStatus: fetchMetaStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [blockchainCategory, setBlockchainCategory] = (0, $exYeM.useState)("ALL");
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const [selectedWalletToConnect, setSelectedWalletToConnect] = (0, $exYeM.useState)();
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    const { list: list } = (0, $054d9182f00d4104$export$8c7712426fcad4df)();
    const filteredBlockchains = (0, $b27897cbc1e94793$export$81d36a7d7cd51dc8)(list, blockchains);
    const activeCategoriesCount = (0, $72ff915f8d8218ca$export$f6cff66fe61062ef)(filteredBlockchains);
    const showCategory = activeCategoriesCount !== 1;
    const filteredWallets = (0, $b27897cbc1e94793$export$11a6962816b1514)(list, blockchainCategory);
    const handleWalletItemClick = (wallet)=>{
        if ((0, $7c74207847ca6a20$export$23e4659a2fa50df7)(list, config.multiWallets)) return;
        setSelectedWalletToConnect(wallet);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $ff687e4433269b3c$export$c84671f46d6a1ca), {
        header: {
            title: (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Connect Wallets")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($11da4dc66b076be0$var$Container, null, showCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d15d2da2f4d97305$export$e15317e9262e7409), {
        setCategory: setBlockchainCategory,
        category: blockchainCategory,
        blockchains: filteredBlockchains,
        isLoading: fetchMetaStatus === "loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2b81c0e59eaa4d2d$export$2e0a83ec2e27ecbb), {
        size: 24
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $6234172cd87b86f8$export$1c6175f3aa4394b7), {
        variant: "title",
        size: "xmedium",
        align: "center"
    }, (0, $e58de2ce5f95dde9$export$a7357cdd1f0b0168).t("Choose a wallet to connect.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($11da4dc66b076be0$var$ListContainer, null, filteredWallets.map((wallet, index)=>{
        const key = `wallet-${index}-${wallet.type}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b7ad2cfc9fe1d9ac$export$2e2bcd8739ae039), {
            key: key,
            ...wallet,
            container: (0, $7c74207847ca6a20$export$49f5bf502122d4f7)(),
            onClick: ()=>handleWalletItemClick(wallet),
            isLoading: fetchMetaStatus === "loading",
            disabled: !isActiveTab
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $a533ccd38320000a$export$7710cdf1210cd2fb), {
        wallet: selectedWalletToConnect,
        onClose: ()=>{
            setSelectedWalletToConnect(undefined);
        }
    }))));
}


function $d1ae4738cd31e3f4$export$37d3279522fbf5e2() {
    /**
   * The configuration of the widget should initially be applied to the widget state.
   * If search parameters exist in the URL,
   * they should be applied later and take precedence over the widget configuration.
   * To achieve this, it is crucial to execute these hooks in the correct sequence.
   */ (0, $9c328eee9f952c1b$export$149433a791a52f40)();
    (0, $ca6e928adc2062c3$export$bdeb80d0daf5f225)();
    return (0, $b0e6fcd50b7ef685$export$5d3fca4a98652595)([
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).home,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $46253dfedd5d183d$export$b94310965bed44e6), null)
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).routes,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $de8101526b9c107b$export$ebde1f165243f87e), null)
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).fromSwap,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0683a7464e2e4cbc$export$1d77075907ff19f4), {
                        type: "source"
                    })
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).blockchains,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c4f81ebb9198a5bd$export$6a77e94e9d78943a), {
                        type: "source"
                    })
                }
            ]
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).toSwap,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0683a7464e2e4cbc$export$1d77075907ff19f4), {
                        type: "destination"
                    })
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).blockchains,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c4f81ebb9198a5bd$export$6a77e94e9d78943a), {
                        type: "destination"
                    })
                }
            ]
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).settings,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $43da3e715fe1b938$export$8f6dcfe950367406), null)
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).languages,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1ab13a5fa27a1367$export$28f282c008ccfd46), null)
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).exchanges,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dfa8e208271e2384$export$ab9f3efe9ea3da6a), {
                        sourceType: "Exchanges"
                    })
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).bridges,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $dfa8e208271e2384$export$ab9f3efe9ea3da6a), {
                        sourceType: "Bridges"
                    })
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).customTokens,
                    children: [
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $1d1d210a037de13d$export$af93f07aa3c8215b), null)
                        },
                        {
                            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).addCustomTokens,
                            children: [
                                {
                                    index: true,
                                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $057238ebd3ed3dbf$export$2ad972b9afb35534), null)
                                },
                                {
                                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).blockchains,
                                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $c4f81ebb9198a5bd$export$6a77e94e9d78943a), {
                                        hideCategory: true,
                                        type: "custom-token"
                                    })
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).swaps,
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9b953284eda32bc9$export$6eebdb755ddb29f3), null)
                },
                {
                    path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).swapDetails,
                    element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $4295bb0c1992ead0$export$232b752ed416656f), null)
                }
            ]
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).wallets,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $11da4dc66b076be0$export$ab40521368a1ca64), null)
        },
        {
            path: (0, $415b6399c61cd80f$export$492bdc31a14c4d1).confirmSwap,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d13cf072cbbbeffc$export$8d36e40575ab7683), null)
        }
    ]);
}



parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");


var $exYeM = parcelRequire("exYeM");



const $c6cc06c549aad967$export$5ed6c50ee68bdd59 = ()=>(0, $3dd421da623820a3$export$db53682eef82cc11)({
        "@import": "url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap')"
    })();








function $844adfaabf1ed37e$export$c0f7c2d82ae0a45b() {
    const { setWatermark: setWatermark } = (0, $0763b7f547a573fc$export$d4874efc85adb7db)();
    const fetchApiConfig = async ()=>{
        const response = await fetch(`${(0, $6fd02b85a3828f9f$export$44487a86467333c3)("BASE_URL")}/meta/dapp/config?apiKey=${(0, $6fd02b85a3828f9f$export$44487a86467333c3)("API_KEY")}`);
        if (!response.ok) throw new Error(`Request failed with status: ${response.status} `);
        const data = await response.json();
        setWatermark(data.config.watermark);
    };
    return {
        fetchApiConfig: fetchApiConfig
    };
}




var $exYeM = parcelRequire("exYeM");


function $974c6319c8ca6f1a$export$9c123b7d6b87b1d7() {
    const { connect: connect, state: state } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const initiated = (0, $exYeM.useRef)({});
    const { fetchStatus: fetchStatus } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const walletType = new URLSearchParams(location.search).get((0, $ac85cc6f6f867f4c$export$1e1d235314148489).AUTO_CONNECT) || "";
    const walletState = state(walletType);
    (0, $exYeM.useEffect)(()=>{
        const shouldTryConnect = fetchStatus === "success" && walletType && walletState.installed && !walletState.connecting && !walletState.connected;
        if (shouldTryConnect && !initiated.current[walletType]) {
            initiated.current[walletType] = true;
            connect(walletType);
        }
    }, [
        walletState,
        fetchStatus
    ]);
}




var $exYeM = parcelRequire("exYeM");




function $af4241633bacda7a$export$df40a8e5d5ece720() {
    const connectedWallets = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const getWalletsDetails = (0, $41385c7b1441a578$export$63a06538da9383a6).use.getWalletsDetails();
    const setNotification = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).use.setNotification();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    (0, $exYeM.useEffect)(()=>{
        const handleStepEvent = (widgetEvent)=>{
            const { event: event, step: step, route: route } = widgetEvent;
            const shouldRefetchBalance = event.type === (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).TX_EXECUTION && event.status === (0, $ab26e0b6754d430c$export$4a1a2e5c997cdbb1).TX_SENT && !(0, $45075b780ed6e88c$export$5265eafbefe28577)(step) || event.type === (0, $ab26e0b6754d430c$export$19ce097d7421ac9a).SUCCEEDED;
            if (shouldRefetchBalance) {
                const fromAccount = connectedWallets.find((account)=>account.chain === step?.fromBlockchain);
                const toAccount = step?.fromBlockchain !== step?.toBlockchain && connectedWallets.find((wallet)=>wallet.chain === step?.toBlockchain);
                fromAccount && getWalletsDetails([
                    fromAccount
                ], findToken);
                toAccount && getWalletsDetails([
                    toAccount
                ], findToken);
            }
            setNotification(event, route);
        };
        (0, $23eba71feb69205e$export$10dc3edfc20c8ff).on((0, $ab26e0b6754d430c$export$54f5f69c1651567f).StepEvent, handleStepEvent);
        return ()=>(0, $23eba71feb69205e$export$10dc3edfc20c8ff).off((0, $ab26e0b6754d430c$export$54f5f69c1651567f).StepEvent, handleStepEvent);
    }, [
        (0, $23eba71feb69205e$export$10dc3edfc20c8ff),
        connectedWallets
    ]);
    (0, $exYeM.useEffect)(()=>{
        const handleRouteEvent = (widgetEvent)=>{
            const { event: event, route: route } = widgetEvent;
            if (event.type === (0, $ab26e0b6754d430c$export$543d0a6c7f452841).FAILED || event.type === (0, $ab26e0b6754d430c$export$543d0a6c7f452841).SUCCEEDED) setNotification(event, route);
        };
        (0, $23eba71feb69205e$export$10dc3edfc20c8ff).on((0, $ab26e0b6754d430c$export$54f5f69c1651567f).RouteEvent, handleRouteEvent);
        return ()=>(0, $23eba71feb69205e$export$10dc3edfc20c8ff).off((0, $ab26e0b6754d430c$export$54f5f69c1651567f).RouteEvent, handleRouteEvent);
    }, [
        (0, $23eba71feb69205e$export$10dc3edfc20c8ff)
    ]);
}






var $exYeM = parcelRequire("exYeM");


function $5aa69aad9cc7895e$export$2ae07520b63cb24d() {
    const { isSynced: isSynced, syncNotifications: syncNotifications } = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd)();
    const { manager: manager, state: state } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    (0, $exYeM.useEffect)(()=>{
        const shouldSyncNotifications = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).persist.hasHydrated() && state.loadedFromPersistor && !isSynced;
        if (shouldSyncNotifications) syncNotifications((0, $cd356c8939bca632$export$e57dfc82f316498a)(manager));
    }, [
        (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).persist.hasHydrated(),
        state.loadedFromPersistor,
        isSynced
    ]);
}




function $6fac7e9e28805945$export$9ba1f1f28043c5bf() {
    (0, $974c6319c8ca6f1a$export$9c123b7d6b87b1d7)();
    (0, $c6cc06c549aad967$export$5ed6c50ee68bdd59)();
    (0, $af4241633bacda7a$export$df40a8e5d5ece720)();
    (0, $5aa69aad9cc7895e$export$2ae07520b63cb24d)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const { canSwitchNetworkTo: canSwitchNetworkTo } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const [lastConnectedWalletWithNetwork, setLastConnectedWalletWithNetwork] = (0, $exYeM.useState)("");
    const [disconnectedWallet, setDisconnectedWallet] = (0, $exYeM.useState)();
    const widgetContext = (0, $exYeM.useContext)((0, $0b656bef82852b92$export$a0936c9989b92d74));
    const evmChains = blockchains.filter((0, $e0809f1f0dfba620$export$9d749b8b357dfab2));
    const { fetchApiConfig: fetchApiConfig } = (0, $844adfaabf1ed37e$export$c0f7c2d82ae0a45b)();
    // Unsubscribe QuoteStore listeners
    (0, $exYeM.useEffect)(()=>()=>(0, $3b5b1daaa6398d06$export$a83d0c15f7a234c9)(), []);
    // At the moment, we only detect the disconnection of EVM wallets.
    (0, $64034aac48a9a7d7$export$1fbfa58ad4d80d3a)({
        lastConnectedWallet: lastConnectedWalletWithNetwork,
        clearDisconnectedWallet: ()=>{
            setDisconnectedWallet(undefined);
        },
        disconnectedWallet: disconnectedWallet,
        evmChains: evmChains,
        canSwitchNetworkTo: canSwitchNetworkTo
    });
    (0, $exYeM.useEffect)(()=>{
        (0, $0763b7f547a573fc$export$4a3066c505397ad1).init();
        if (!(0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).persist.hasHydrated()) (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd).persist.rehydrate();
        /**
     * Add handlers to the widget context for connecting and disconnecting wallets.
     * We pass these handlers to the wallet provider to keep track of the last connected and last disconnected wallets.
     * The 'queue-manager' uses these details to spot any changes in the connection status of the required wallet during the swap process.
     *
     * with this approch anyone who use the widget context can override these handlers and causes some bugs happens.
     * it the future we should add a safer soloution like considering array of handlers .
     * https://github.com/rango-exchange/rango-client/pull/630/files#r1518846728
     */ widgetContext.onConnectWallet(setLastConnectedWalletWithNetwork);
        widgetContext.onDisconnectWallet((walletType)=>{
            setDisconnectedWallet(walletType);
            if (walletType === (0, $7aYgM.splitWalletNetwork)(lastConnectedWalletWithNetwork)?.[0]) setLastConnectedWalletWithNetwork("");
        });
        fetchApiConfig().catch(console.log);
        return (0, $0763b7f547a573fc$export$4a3066c505397ad1).destroy;
    }, []);
}








const $9e4f086662eda484$export$d653589df987fd93 = (0, $3dd421da623820a3$export$3817b7a54a07cec7)("div", {
    fontFamily: "$widget",
    boxSizing: "border-box",
    textAlign: "left",
    "& *, *::before, *::after": {
        boxSizing: "inherit"
    },
    "& *:focus-visible": {
        outlineColor: "$info500",
        transition: "none"
    },
    "& ul, ol, li": {
        listStyleType: "none"
    }
});


function $9f9c9f37f38395f3$export$861edd1ccea2f746() {
    (0, $6fac7e9e28805945$export$9ba1f1f28043c5bf)();
    const { config: config } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const { activeTheme: activeTheme } = (0, $80bd201e0bc05e20$export$93d4e7f90805808f)(config?.theme || {});
    const { activeLanguage: activeLanguage } = (0, $da3430e16b59e33f$export$c1fd9f444a3dc711)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $db7bfa0e98ad1e64$export$97f06dd36973b4cd), {
        language: activeLanguage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9e4f086662eda484$export$d653589df987fd93), {
        id: "swap-container",
        className: activeTheme()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $d1ae4738cd31e3f4$export$37d3279522fbf5e2), null)));
}




parcelRequire("jMEJx");
var $4HuAm = parcelRequire("4HuAm");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

/*
 *TODO:
 * Loading fonts from JS has a downside and it is the bundle needs to be downloaded and executed first which means after sometime font will be added to <head /> and it causes a layoutshift each time.
 * We've added Roboto into <head /> since it's the default font. the downside here is it will load roboto anyway even dApp has set fontFamily other than Roboto which causes an unneccerary downloand (Roboto).
 * We decided to go with the second one and it can be solved in future by split these types of configs into a separate js file and let it to be loaded with a more priority than the main bundle. it should be also cached which imrpove user experience after first load.
 */ const $b9b350af5c8e104e$var$useFontLoader = ()=>{
    const [fontLink, setFontLink] = (0, $exYeM.useState)(null);
    const loadFont = (fontUrl)=>{
        const link = document.createElement("link");
        link.href = fontUrl;
        link.rel = "stylesheet";
        document.head.appendChild(link);
        return link;
    };
    const unloadFont = ()=>{
        if (fontLink) {
            document.head.removeChild(fontLink);
            setFontLink(null);
        }
    };
    const handleLoadCustomFont = (fontName)=>{
        unloadFont(); // Remove previous font
        const fontUrl = (0, $7c74207847ca6a20$export$7a6d663e4a815381)(fontName);
        if (fontUrl) {
            const newFontLink = loadFont(fontUrl);
            setFontLink(newFontLink);
        }
    };
    return {
        handleLoadCustomFont: handleLoadCustomFont
    };
};
var $b9b350af5c8e104e$export$2e2bcd8739ae039 = $b9b350af5c8e104e$var$useFontLoader;





parcelRequire("fzv2W");
var $7aYgM = parcelRequire("7aYgM");
parcelRequire("14sfz");
var $21GQj = parcelRequire("21GQj");

var $exYeM = parcelRequire("exYeM");






function $2247f8d416db6c12$var$QueueManager(props) {
    const { providers: providers, getSigners: getSigners, state: state, connect: connect, canSwitchNetworkTo: canSwitchNetworkTo, getWalletInfo: getWalletInfo } = (0, $3fc2765fe288a6f8$export$934951b5ed2ebf82)();
    const swapQueueDef = (0, $exYeM.useMemo)(()=>{
        return (0, $438d15dd568686cf$export$e5055f26eedfa461)({
            API_KEY: props.apiKey || (0, $6fd02b85a3828f9f$export$44487a86467333c3)("API_KEY"),
            BASE_URL: (0, $6fd02b85a3828f9f$export$44487a86467333c3)("BASE_URL"),
            emitter: {
                emit: (0, $23eba71feb69205e$export$10dc3edfc20c8ff).emit
            }
        });
    }, [
        props.apiKey
    ]);
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const connectedWallets = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const wallets = {
        blockchains: connectedWallets.map((wallet)=>({
                accounts: [
                    wallet
                ],
                name: wallet.chain
            }))
    };
    const switchNetwork = async (wallet, network)=>{
        if (!canSwitchNetworkTo(wallet, network)) return undefined;
        return connect(wallet, network);
    };
    const isMobileWallet = (walletType)=>!!getWalletInfo(walletType).mobileWallet;
    // TODO: this code copy & pasted from rango, should be refactored.
    const allBlockchains = blockchains.filter((blockchain)=>blockchain.enabled).reduce((blockchainsObj, blockchain)=>(blockchainsObj[blockchain.name] = blockchain, blockchainsObj), {});
    const evmBasedChains = blockchains.filter((0, $21GQj.isEvmBlockchain));
    const getSupportedChainNames = (type)=>{
        const { supportedChains: supportedChains } = getWalletInfo(type);
        return (0, $b27897cbc1e94793$export$ac0949be5bbc1b7e)(supportedChains);
    };
    const allProviders = providers();
    const context = {
        meta: {
            blockchains: allBlockchains,
            evmBasedChains: evmBasedChains,
            evmNetworkChainInfo: (0, $7aYgM.convertEvmBlockchainMetaToEvmChainInfo)(evmBasedChains),
            getSupportedChainNames: getSupportedChainNames
        },
        getSigners: getSigners,
        wallets: wallets,
        providers: allProviders,
        switchNetwork: switchNetwork,
        canSwitchNetworkTo: canSwitchNetworkTo,
        connect: connect,
        state: state,
        isMobileWallet: isMobileWallet
    };
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5008c46af694b4d0$export$2e2bcd8739ae039), {
        queuesDefs: [
            swapQueueDef
        ],
        context: context,
        onPersistedDataLoaded: (manager)=>{
            (0, $45075b780ed6e88c$export$d9db0ccdbfe08fc3)(manager);
        },
        isPaused: !isActiveTab
    }, props.children);
}
var $2247f8d416db6c12$export$2e2bcd8739ae039 = $2247f8d416db6c12$var$QueueManager;






var $exYeM = parcelRequire("exYeM");



function $f3f0aae87db51e93$export$199926506fad9bd() {
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens();
    const { setFromBlockchain: setFromBlockchain, setFromToken: setFromToken, setToBlockchain: setToBlockchain, setToToken: setToToken, setInputAmount: setInputAmount } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    const updateQuoteInputs = (params)=>{
        const { fromBlockchain: fromBlockchain, fromToken: fromToken, toBlockchain: toBlockchain, toToken: toToken, requestAmount: requestAmount } = params;
        const meta = {
            blockchains: blockchains,
            tokens: tokens
        };
        if (fromBlockchain !== undefined) {
            const blockchainMeta = blockchains.find((blockchain)=>blockchain.name === fromBlockchain) ?? null;
            setFromBlockchain(blockchainMeta);
        }
        if (fromToken !== undefined) {
            const token = fromToken ? findToken(fromToken) ?? null : null;
            setFromToken({
                meta: meta,
                token: token
            });
        }
        if (toBlockchain !== undefined) {
            const blockchainMeta = blockchains.find((blockchain)=>blockchain.name === toBlockchain) ?? null;
            setToBlockchain(blockchainMeta);
        }
        if (toToken !== undefined) {
            const token = toToken ? findToken(toToken) ?? null : null;
            setToToken({
                meta: meta,
                token: token
            });
        }
        if (requestAmount !== undefined) setInputAmount(requestAmount);
    };
    return updateQuoteInputs;
}











class $d519bfbe4ca55e92$export$aab940d56fb8e4f8 {
    constructor(manager, actions){
        this.manager = manager;
        this.actions = actions;
    }
    getAllSwaps() {
        return (0, $cd356c8939bca632$export$e57dfc82f316498a)(this.manager);
    }
    getCurrentStep(swap) {
        return this.getCurrentStepInfo(swap).step;
    }
    getCurrentStepWallet(swap) {
        return this.getCurrentStepInfo(swap).wallet;
    }
    getCurrentStepNetwork(swap) {
        return this.getCurrentStepInfo(swap).network;
    }
    retry(swap, meta) {
        const retryQuote = (0, $aae90cdd39be0d29$export$ba2af798efa32d0b)(swap, meta.blockchains, this.actions.findToken);
        return this.actions.retrySwap(retryQuote);
    }
    cancel(id) {
        const queue = this.manager?.get(id);
        if (queue) (0, $45075b780ed6e88c$export$c778f9ff5514f6d7)(queue);
    }
    getCurrentStepInfo(swap) {
        const currentStep = (0, $45075b780ed6e88c$export$613fded3c60df0c1)(swap);
        return {
            step: currentStep,
            wallet: currentStep ? (0, $f3ce3db9d10c7efd$export$5be79e3cb2436f0b)(swap, currentStep) : null,
            network: currentStep ? (0, $f3ce3db9d10c7efd$export$e07f0a7a416c5e36)(swap, currentStep) : null
        };
    }
}


const $fa1eca21c64db5d1$export$fa3801a90295b284 = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
function $fa1eca21c64db5d1$export$3d5fdc7711772f70(props) {
    const { manager: manager } = (0, $5008c46af694b4d0$export$ddf53f26a9d1c984)();
    const isActiveTab = (0, $0763b7f547a573fc$export$d4874efc85adb7db).use.isActiveTab();
    const retrySwap = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56).use.retry();
    const { findToken: findToken } = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)();
    const history = new (0, $d519bfbe4ca55e92$export$aab940d56fb8e4f8)(manager, {
        retrySwap: retrySwap,
        findToken: findToken
    });
    const details = (0, $41385c7b1441a578$export$63a06538da9383a6).use.connectedWallets();
    const isLoading = (0, $41385c7b1441a578$export$63a06538da9383a6).use.loading();
    const totalBalance = (0, $b27897cbc1e94793$export$bb973fd3adad4d0d)(details);
    const refetch = (0, $41385c7b1441a578$export$63a06538da9383a6).use.getWalletsDetails();
    const blockchains = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().blockchains();
    const tokens = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().tokens();
    const swappers = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().swappers();
    const loadingStatus = (0, $9997ae2e4c8ece9b$export$35cd30506bcba883)().fetchStatus;
    const resetLanguage = (0, $da3430e16b59e33f$export$c1fd9f444a3dc711)().resetLanguage;
    const notifications = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd)().getNotifications();
    const clearNotifications = (0, $fee1a2b736a8a94e$export$aa94277a9804d2bd)().clearNotifications;
    const updateQuoteInputs = (0, $f3f0aae87db51e93$export$199926506fad9bd)();
    const { fromBlockchain: fromBlockchain, toBlockchain: toBlockchain, fromToken: fromToken, toToken: toToken, inputAmount: inputAmount } = (0, $3b5b1daaa6398d06$export$347bbd3ce043dc56)();
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const value = {
        isActiveTab: isActiveTab,
        setCurrentTabAsActive: (0, $0763b7f547a573fc$export$4a3066c505397ad1).forceClaim,
        history: history,
        wallets: {
            isLoading: isLoading,
            details: details,
            totalBalance: totalBalance,
            refetch: (accounts)=>refetch(accounts, findToken)
        },
        meta: {
            blockchains: blockchains,
            tokens: tokens,
            swappers: swappers,
            loadingStatus: loadingStatus,
            findToken: findToken
        },
        resetLanguage: resetLanguage,
        notifications: {
            list: notifications,
            clearAll: clearNotifications
        },
        quote: {
            quoteInputs: {
                fromBlockchain: fromBlockchain?.name ?? null,
                fromToken: fromToken ? {
                    symbol: fromToken.symbol,
                    blockchain: fromToken.blockchain,
                    address: fromToken.address
                } : null,
                toBlockchain: toBlockchain?.name ?? null,
                toToken: toToken ? {
                    symbol: toToken.symbol,
                    blockchain: toToken.blockchain,
                    address: toToken.address
                } : null,
                requestAmount: inputAmount
            },
            updateQuoteInputs: updateQuoteInputs
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($fa1eca21c64db5d1$export$fa3801a90295b284.Provider, {
        value: value
    }, props.children);
}
function $fa1eca21c64db5d1$export$bed784987806c3d2() {
    const context = (0, $exYeM.useContext)($fa1eca21c64db5d1$export$fa3801a90295b284);
    if (!context) throw new Error("useWidget can only be used within the WidgetProvider component");
    return context;
}




function $5524fbbd0d4cae87$export$42e76418f6ea3109(props) {
    const { onUpdateState: onUpdateState, config: config } = props;
    const fontFamily = props.config?.theme?.fontFamily;
    const { handleLoadCustomFont: handleLoadCustomFont } = (0, $b9b350af5c8e104e$export$2e2bcd8739ae039)();
    (0, $exYeM.useEffect)(()=>{
        if (fontFamily) handleLoadCustomFont(fontFamily);
    }, [
        fontFamily
    ]);
    (0, $exYeM.useMemo)(()=>{
        (0, $6fd02b85a3828f9f$export$b9b9cdb96b829919)({
            API_KEY: config?.apiKey || (0, $81cb43aa4aa5ed51$export$807e570e9765ba53),
            BASE_URL: config?.apiUrl || (0, $81cb43aa4aa5ed51$export$6554e0e4e82f1b3a)
        });
    }, [
        config.apiKey,
        config.apiUrl
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (props.config?.signers?.customSolanaRPC) (0, $4HuAm.setSolanaSignerConfig)("customRPC", props.config.signers.customSolanaRPC);
    }, [
        props.config?.signers?.customSolanaRPC
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $0b656bef82852b92$export$d1263745710d963c), {
        config: config,
        onUpdateState: onUpdateState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $2247f8d416db6c12$export$2e2bcd8739ae039), {
        apiKey: config.apiKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $fa1eca21c64db5d1$export$3d5fdc7711772f70), null, props.children)));
}




function $e3f18d1088aa160d$export$a829527ff4e4114a(props) {
    const isExternalWalletsEnabled = props.config?.externalWallets;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $f45aff2ed35363b2$export$8707b35fd1c03f46), null, isExternalWalletsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9f9c9f37f38395f3$export$861edd1ccea2f746), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $5524fbbd0d4cae87$export$42e76418f6ea3109), {
        config: props.config ?? (0, $b05f972a7e8c18b1$export$c2f8e0cc249a8d8f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9f9c9f37f38395f3$export$861edd1ccea2f746), null)));
}









function $25afac15fad3333e$export$f31d65a8503b5870() {
    // To be exported for Dapps
    const { on: on, off: off } = (0, $23eba71feb69205e$export$10dc3edfc20c8ff);
    return {
        on: on,
        off: off
    };
}







const $ab43bec793d3e7e7$export$838c666f440d9c36 = {
    DerivationPath: $c48bafa81adeae40$export$cfd6f0f481db5fd9,
    Namespaces: $8956f494711d6565$export$2f21297dc8e7cb72,
    isOnDerivationPath: $b491b3e9dee0a145$export$3daaaec1aac44f61,
    isOnNamespace: $b491b3e9dee0a145$export$ccc8fed7d7fe1e65
};



var $exYeM = parcelRequire("exYeM");

const $51d3a252685c5e41$export$5a31b40893a5df6f = "e24844c5deb5193c1c14840a7af6a40b";
const $51d3a252685c5e41$export$7bd4d5ccbedcb39c = {
    appUrl: "https://widget.rango.exchange/",
    email: "hi+trezorwidget@rango.exchange"
};


function $e03d48e41e8f146e$export$86fbec116b87613f() {
    const [searchParams] = (0, $2cc1d3688dd37f6f$export$f1a78c17382fe22a)();
    const configRef = (0, $exYeM.useRef)();
    const configParam = searchParams.get("config");
    let config = undefined;
    if (!configRef.current) {
        if (!!configParam) try {
            config = JSON.parse(configParam, (_, value)=>{
                if (typeof value === "string" && value[0] === "$") return value.replace("$", "#");
                return value;
            });
        } catch (error) {
            console.error("Widget config param is invalid!");
        }
        else /*
       *TODO:
       *The assumption here is this object won't be created on iframe so we are on dev mode.
       *We should consider a more proper way.
       */ config = {
            apiKey: "",
            walletConnectProjectId: (0, $51d3a252685c5e41$export$5a31b40893a5df6f),
            trezorManifest: (0, $51d3a252685c5e41$export$7bd4d5ccbedcb39c)
        };
        if (!!config) configRef.current = config;
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
            path: "/*",
            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e3f18d1088aa160d$export$a829527ff4e4114a), {
                config: configRef.current
            })
        })
    });
}


const $012c7a461ac2e20c$var$container = document.getElementById("app");
const $012c7a461ac2e20c$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($012c7a461ac2e20c$var$container);
$012c7a461ac2e20c$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e03d48e41e8f146e$export$86fbec116b87613f), {})
}));

})();
//# sourceMappingURL=index.06465224.js.map
